(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["omjs"] = factory();
	else
		root["omjs"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var omjs                = __webpack_require__(1);
	var consts              = __webpack_require__(18);
	var viewFabric          = __webpack_require__(19);
	var View                = __webpack_require__(20);
	var Layer               = __webpack_require__(41);
	var UTFGridLayer        = __webpack_require__(244);
	var LayerCollection     = __webpack_require__(40);
	var TileLayer           = __webpack_require__(42);
	var VectorLayer         = __webpack_require__(44);
	var ImageLayer          = __webpack_require__(47);
	var MVTLayer            = __webpack_require__(50);
	var OmsVectorLayer      = __webpack_require__(45);
	var OmsCategoryLayer    = __webpack_require__(52);
	var OmsChartsLayer      = __webpack_require__(53);
	var OmsVectorFeatureLayer      = __webpack_require__(46);
	var Choropleth          = __webpack_require__(245);
	var Widget              = __webpack_require__(31);
	var Button              = __webpack_require__(199);
	var ButtonGroup         = __webpack_require__(200);
	var ZoomControl         = __webpack_require__(202);
	var DistanceButton      = __webpack_require__(205);
	var RadiusButton   	    = __webpack_require__(246);
	var PointButton   	    = __webpack_require__(247);
	var AreaButton          = __webpack_require__(222);
	var SidePanel           = __webpack_require__(248);
	var ModalMessage        = __webpack_require__(30);
	var LayersTree          = __webpack_require__(249);
	var Window              = __webpack_require__(207);
	var Panel               = __webpack_require__(209);
	var Legend              = __webpack_require__(210);
	var LegendGroup         = __webpack_require__(223);
	var BubbleLegend        = __webpack_require__(211);
	var ThematicLegend      = __webpack_require__(215);
	var CategoryLegend      = __webpack_require__(213);
	var ol                  = __webpack_require__(22);
	var MarkerLayer         = __webpack_require__(236);
	var SearchBar           = __webpack_require__(224);
	var SearchBarExt        = __webpack_require__(251);
	var DropDown		    = __webpack_require__(201);
	var LabelButton		    = __webpack_require__(206);
	var MeasureToolChanger  = __webpack_require__(227);
	var PublicMapDraw       = __webpack_require__(230);
	
	omjs.ol       = ol;
	omjs.initView = viewFabric;
	
	omjs.View                  		= View;
	omjs.View.Layer            		= Layer;
	omjs.View.LayerCollection  		= LayerCollection;
	omjs.View.TileLayer        		= TileLayer;
	omjs.View.VectorLayer      		= VectorLayer;
	omjs.View.ImageLayer      		= ImageLayer;
	omjs.View.MVTLayer      		= MVTLayer;
	omjs.View.OmsVectorLayer   		= OmsVectorLayer;
	omjs.View.OmsCategoryLayer 		= OmsCategoryLayer;
	omjs.View.OmsChartsLayer   		= OmsChartsLayer;
	omjs.View.MarkerLayer      		= MarkerLayer;
	omjs.View.Choropleth       		= Choropleth;
	omjs.View.UTFGridLayer     		= UTFGridLayer;
	omjs.View.OmsVectorFeatureLayer = OmsVectorFeatureLayer;
	omjs.View.PublicMapDraw         = PublicMapDraw;
			
	omjs.Widget                		= Widget;
	omjs.Widget.Button         		= Button;
	omjs.Widget.ButtonGroup    		= ButtonGroup;
	omjs.Widget.DistanceButton 		= DistanceButton;
	omjs.Widget.RadiusButton 		= RadiusButton;
	omjs.Widget.PointButton 		= PointButton;
	omjs.Widget.AreaButton     		= AreaButton;
	omjs.Widget.SidePanel      		= SidePanel;
	omjs.Widget.LayersTree     		= LayersTree;
	omjs.Widget.Window         		= Window;
	omjs.Widget.Panel          		= Panel;
	omjs.Widget.Legend         		= Legend;
	omjs.Widget.LegendGroup    		= LegendGroup;
	omjs.Widget.BubbleLegend   		= BubbleLegend;
	omjs.Widget.ThematicLegend 		= ThematicLegend;
	omjs.Widget.CategoryLegend 		= CategoryLegend;
	omjs.Widget.ModalMessage   		= ModalMessage;
	omjs.Widget.ZoomControl    		= ZoomControl;
	omjs.Widget.SearchBar      		= SearchBar;
	omjs.Widget.SearchBarExt   		= SearchBarExt;
	omjs.Widget.DropDown	   		= DropDown;
	omjs.Widget.LabelButton	   		= LabelButton;
	omjs.Widget.MeasureToolChanger 	= MeasureToolChanger;
	
	omjs.baseMapType = {
	    'MAP'     : 1,
	    'URL'     : 2,
	    'EXTERNAL': 3
	};
	
	omjs.C = consts;
	
	
	module.exports = omjs;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var omjs          = __webpack_require__(2),
	    projectFabric = __webpack_require__(10),
	    Project       = __webpack_require__(11),
	    Container     = __webpack_require__(13),
	    ContainersCollection     = __webpack_require__(12),
	    Layer         = __webpack_require__(14),
	    Visualization = __webpack_require__(15),
	    LayerObject   = __webpack_require__(17);
	
	
	omjs.initProject = projectFabric;
	
	/**
	 * @property {omjs.Project} Project
	 */
	omjs.Project = Project;
	
	omjs.Project.ContainersCollection   = ContainersCollection;
	
	/**
	 * {{#crossLink "omjs.Project.Container"}} Описание класса omjs.Project.Container{{/crossLink}}
	 *
	 * @property {omjs.Project.Container} Project.Container
	 */
	omjs.Project.Container = Container;
	
	/**
	 * {{#crossLink "omjs.Project.Layer"}} Описание класса omjs.Project.Layer{{/crossLink}}
	 *
	 * @property {omjs.Project.Layer} Project.Layer
	 */
	omjs.Project.Layer = Layer;
	omjs.Project.Visualization = Visualization;
	omjs.Project.LayerObject   = LayerObject;
	
	module.exports = omjs;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(3),
	    Class = __webpack_require__(4),
	    Events = __webpack_require__(6),
	    Utils = __webpack_require__(5),
	    Model         = __webpack_require__(7),
	    Collection    = __webpack_require__(8);
	
	
	/**
	 * @class omjs
	 * @static
	 */
	var omjs = {
	    /**
	     * Версия API
	     *
	     * @private
	     */
	    version: "2.6"
	};
	
	
	/**
	 *
	 */
	omjs.$ = $;
	
	omjs.Class = Class;
	omjs.Events = Events;
	omjs.Utils = Utils;
	omjs.Access = __webpack_require__(9);
	
	/**
	 * {{#crossLink "omjs.Model"}} Описание класса omjs.Model {{/crossLink}}
	 *
	 * @property {omjs.Model} Model
	 */
	omjs.Model = Model;
	
	/**
	 * {{#crossLink "omjs.Collection"}} Описание класса omjs.Collection{{/crossLink}}
	 *
	 * @property {omjs.Collection} Collection
	 */
	omjs.Collection = Collection;
	
	module.exports = omjs;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.1.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-04-28T16:01Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//
	
	var arr = [];
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		version = "2.1.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
		},
	
		isPlainObject: function( obj ) {
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			if ( obj.constructor &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
	
			// If the function hasn't returned already, we're confident that
			// |obj| is a plain object, created by {} or constructed with new Object
			return true;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf("use strict") === 1 ) {
					script = document.createElement("script");
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.0-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-12-16
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
		nodeType = context.nodeType;
	
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		if ( !seed && documentIsHTML ) {
	
			// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType !== 1 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
		parent = doc.defaultView;
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Support tests
		---------------------------------------------------------------------- */
		documentIsHTML = !isXML( doc );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\f]' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				truncate = until !== undefined;
	
			while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
				if ( elem.nodeType === 1 ) {
					if ( truncate && jQuery( elem ).is( until ) ) {
						break;
					}
					matched.push( elem );
				}
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var matched = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					matched.push( n );
				}
			}
	
			return matched;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter(function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.unique( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// Flag to know if list is currently firing
			firing,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// We once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[0], key ) : emptyGet;
	};
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( owner ) {
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	function Data() {
		// Support: Android<4,
		// Old WebKit does not have Object.preventExtensions/freeze method,
		// return new empty object instead with no [[set]] accessor
		Object.defineProperty( this.cache = {}, 0, {
			get: function() {
				return {};
			}
		});
	
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	Data.accepts = jQuery.acceptData;
	
	Data.prototype = {
		key: function( owner ) {
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return the key for a frozen object.
			if ( !Data.accepts( owner ) ) {
				return 0;
			}
	
			var descriptor = {},
				// Check if the owner object already has a cache key
				unlock = owner[ this.expando ];
	
			// If not, create one
			if ( !unlock ) {
				unlock = Data.uid++;
	
				// Secure it in a non-enumerable, non-writable property
				try {
					descriptor[ this.expando ] = { value: unlock };
					Object.defineProperties( owner, descriptor );
	
				// Support: Android<4
				// Fallback to a less secure definition
				} catch ( e ) {
					descriptor[ this.expando ] = unlock;
					jQuery.extend( owner, descriptor );
				}
			}
	
			// Ensure the cache object
			if ( !this.cache[ unlock ] ) {
				this.cache[ unlock ] = {};
			}
	
			return unlock;
		},
		set: function( owner, data, value ) {
			var prop,
				// There may be an unlock assigned to this node,
				// if there is no entry for this "owner", create one inline
				// and set the unlock as though an owner entry had always existed
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
				// Fresh assignments by object are shallow copied
				if ( jQuery.isEmptyObject( cache ) ) {
					jQuery.extend( this.cache[ unlock ], data );
				// Otherwise, copy the properties one-by-one to the cache object
				} else {
					for ( prop in data ) {
						cache[ prop ] = data[ prop ];
					}
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			// Either a valid cache is found, or will be created.
			// New caches will be created and the unlock returned,
			// allowing direct access to the newly created
			// empty data object. A valid owner object must be provided.
			var cache = this.cache[ this.key( owner ) ];
	
			return key === undefined ?
				cache : cache[ key ];
		},
		access: function( owner, key, value ) {
			var stored;
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					((key && typeof key === "string") && value === undefined) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase(key) );
			}
	
			// [*]When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				unlock = this.key( owner ),
				cache = this.cache[ unlock ];
	
			if ( key === undefined ) {
				this.cache[ unlock ] = {};
	
			} else {
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
		},
		hasData: function( owner ) {
			return !jQuery.isEmptyObject(
				this.cache[ owner[ this.expando ] ] || {}
			);
		},
		discard: function( owner ) {
			if ( owner[ this.expando ] ) {
				delete this.cache[ owner[ this.expando ] ];
			}
		}
	};
	var data_priv = new Data();
	
	var data_user = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				data_user.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend({
		hasData: function( elem ) {
			return data_user.hasData( elem ) || data_priv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return data_user.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			data_user.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to data_priv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return data_priv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			data_priv.remove( elem, name );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = data_user.get( elem );
	
					if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						data_priv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					data_user.set( this, key );
				});
			}
	
			return access( this, function( value ) {
				var data,
					camelKey = jQuery.camelCase( key );
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
					// Attempt to get data from the cache
					// with the key as-is
					data = data_user.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to get data from the cache
					// with the key camelized
					data = data_user.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each(function() {
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = data_user.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					data_user.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf("-") !== -1 && data !== undefined ) {
						data_user.set( this, key, value );
					}
				});
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each(function() {
				data_user.remove( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = data_priv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = data_priv.access( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return data_priv.get( elem, key ) || data_priv.access( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					data_priv.remove( elem, [ type + "queue", key ] );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = data_priv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	})();
	var strundefined = typeof undefined;
	
	
	
	support.focusinBubbles = "onfocusin" in window;
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = data_priv.hasData( elem ) && data_priv.get( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
				data_priv.remove( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.disabled !== true || event.type !== "click" ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && e.preventDefault ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && e.stopPropagation ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// Support: Firefox, Chrome, Safari
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = data_priv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						data_priv.remove( doc, fix );
	
					} else {
						data_priv.access( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
	
			// Support: IE9
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
			thead: [ 1, "<table>", "</table>" ],
			col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			_default: [ 0, "", "" ]
		};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute("type");
		}
	
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			data_priv.set(
				elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( data_priv.hasData( src ) ) {
			pdataOld = data_priv.access( src );
			pdataCur = data_priv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( data_user.hasData( src ) ) {
			udataOld = data_user.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			data_user.set( dest, udataCur );
		}
	}
	
	function getAll( context, tag ) {
		var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
				context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var elem, tmp, tag, wrap, contains, j,
				fragment = context.createDocumentFragment(),
				nodes = [],
				i = 0,
				l = elems.length;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
						tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];
	
						// Descend through wrappers to the right content
						j = wrap[ 0 ];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Support: QtWebKit, PhantomJS
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( nodes, tmp.childNodes );
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( fragment.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			return fragment;
		},
	
		cleanData: function( elems ) {
			var data, elem, type, key,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
				if ( jQuery.acceptData( elem ) ) {
					key = elem[ data_priv.expando ];
	
					if ( key && (data = data_priv.cache[ key ]) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
						if ( data_priv.cache[ key ] ) {
							// Discard any remaining `private` data
							delete data_priv.cache[ key ];
						}
					}
				}
				// Discard any remaining `user` data
				delete data_user.cache[ elem[ data_user.expando ] ];
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each(function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					});
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var fragment, first, scripts, hasScripts, node, doc,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[ 0 ],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[ 0 ] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								// Support: QtWebKit
								// jQuery.merge because push.apply(_, arraylike) throws
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[ i ], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
								}
							}
						}
					}
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optimization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			if ( elem.ownerDocument.defaultView.opener ) {
				return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
			}
	
			return window.getComputedStyle( elem, null );
		};
	
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
		}
	
		if ( computed ) {
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// Support: iOS < 6
			// A tribute to the "awesome hack by Dean Edwards"
			// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
			// Support: IE
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		var pixelPositionVal, boxSizingReliableVal,
			docElem = document.documentElement,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
			"position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computePixelPositionAndBoxSizingReliable() {
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
			div.innerHTML = "";
			docElem.appendChild( container );
	
			var divStyle = window.getComputedStyle( div, null );
			pixelPositionVal = divStyle.top !== "1%";
			boxSizingReliableVal = divStyle.width === "4px";
	
			docElem.removeChild( container );
		}
	
		// Support: node.js jsdom
		// Don't assume that getComputedStyle is a property of the global object
		if ( window.getComputedStyle ) {
			jQuery.extend( support, {
				pixelPosition: function() {
	
					// This test is executed only once but we still do memoizing
					// since we can use the boxSizingReliable pre-computing.
					// No need to check if the test was already performed, though.
					computePixelPositionAndBoxSizingReliable();
					return pixelPositionVal;
				},
				boxSizingReliable: function() {
					if ( boxSizingReliableVal == null ) {
						computePixelPositionAndBoxSizingReliable();
					}
					return boxSizingReliableVal;
				},
				reliableMarginRight: function() {
	
					// Support: Android 2.3
					// Check if div with explicit width and no margin-right incorrectly
					// gets computed margin-right based on width of container. (#3333)
					// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
					// This support function is only executed once so no memoizing is needed.
					var ret,
						marginDiv = div.appendChild( document.createElement( "div" ) );
	
					// Reset CSS: box-sizing; display; margin; border; padding
					marginDiv.style.cssText = div.style.cssText =
						// Support: Firefox<29, Android 2.3
						// Vendor-prefix box-sizing
						"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
						"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
					marginDiv.style.marginRight = marginDiv.style.width = "0";
					div.style.width = "1px";
					docElem.appendChild( container );
	
					ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );
	
					docElem.removeChild( container );
					div.removeChild( marginDiv );
	
					return ret;
				}
			});
		}
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
		// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = data_priv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend({
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
					style[ name ] = value;
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*.
						// Use string for doubling so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur(),
					// break the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = data_priv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// Ensure the complete handler is called before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = data_priv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
	
				data_priv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || data_priv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = data_priv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = data_priv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	});
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each(function() {
				delete this[ jQuery.propFix[ name ] || name ];
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
						elem.tabIndex :
						-1;
				}
			}
		}
	});
	
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				proceed = arguments.length === 0 || typeof value === "string" && value,
				i = 0,
				len = this.length;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// Toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						data_priv.set( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// Handle most common string cases
						ret.replace(rreturn, "") :
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE6-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = window.location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType[0] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
				// URL without anti-cache param
				cacheURL,
				// Response headers
				responseHeadersString,
				responseHeaders,
				// timeout handle
				timeoutTimer,
				// Cross-domain detection vars
				parts,
				// To know if global events are to be dispatched
				fireGlobals,
				// Loop variable
				i,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function( i ) {
					jQuery( this ).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	};
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new XMLHttpRequest();
		} catch( e ) {}
	};
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSuccessStatus = {
			// file protocol always yields status code 0, assume 200
			0: 200,
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE9
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]();
			}
		});
	}
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport(function( options ) {
		var callback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;
	
					xhr.open( options.type, options.url, options.async, options.username, options.password );
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								delete xhrCallbacks[ id ];
								callback = xhr.onload = xhr.onerror = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
									complete(
										// file: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
										// Support: IE9
										// Accessing binary-data responseText throws an exception
										// (#11426)
										typeof xhr.responseText === "string" ? {
											text: xhr.responseText
										} : undefined,
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					xhr.onerror = callback("error");
	
					// Create the abort callback
					callback = xhrCallbacks[ id ] = callback("abort");
	
					try {
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery("<script>").prop({
						async: true,
						charset: s.scriptCharset,
						src: s.url
					}).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf("auto") > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// Support: BlackBerry 5, iOS 3 (original iPhone)
			// If we don't have gBCR, just use 0,0 rather than error
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : window.pageXOffset,
						top ? val : window.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Support: Safari<7+, Chrome<37+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils = __webpack_require__(5);
	
	var Class = function(){};
	
	
	Class.extend = function(props){
	
	    // extended class with the new prototype
	    var parent;
	    var proto;
	    var i;
	    var NewClass = function(){
	
	        var i;
	        var that = this;
	        if('___hooks' in proto){
	            for(i in proto.___hooks){
	                if(!(i in proto)) continue;
	                proto.___hooks[i].original = proto[i];
	                proto[i] = (function(i){
	                    return function(){
	                        var ii;
	                        var args_obj = {
	                            "args":arguments,
	                            "result":undefined
	                        };
	                        var rtrn;
	                        for(ii in proto.___hooks[i].before){
	                            args_obj['result'] = proto.___hooks[i].before[ii].call(that, args_obj);
	                        }
	
	                        args_obj['result'] = proto.___hooks[i].original.apply(that, arguments);
	                        rtrn = args_obj['result'];
	
	                        for(ii in proto.___hooks[i].after){
	                            args_obj['result'] = proto.___hooks[i].after[ii].call(that, args_obj);
	                            if(proto.___hooks[i].after[ii].override){
	                                rtrn = args_obj['result'];
	                            }
	                        }
	
	                        return rtrn;
	                    }
	                })(i);
	            }
	        }
	
	        this.setOptions = function(options){
	            Utils.setOptions(this, options);
	        };
	
	        // call the constructor
	        if(this.initialize){
	            this.initialize.apply(this, arguments);
	        }
	    };
	
	    // instantiate class without calling constructor
	    var F = function(){};
	    F.prototype = this.prototype;
	
	    proto = new F();
	    proto.constructor = NewClass;
	
	    NewClass.prototype = proto;
	
	    //inherit parent's statics
	    for(i in this){
	        if(this.hasOwnProperty(i) && i !== 'prototype'){
	            NewClass[i] = this[i];
	        }
	    }
	
	    // mix static properties into the class
	    if(props.statics){
	        Utils.extend(NewClass, props.statics);
	        delete props.statics;
	    }
	
	    // mix includes into the prototype
	    if(props.includes){
	        Utils.extend.apply(null, [proto].concat(props.includes));
	        delete props.includes;
	    }
	
	
	    // merge options
	    if(props.options && proto.options){
	        props.options = Utils.extend({}, proto.options, props.options);
	    }
	
	    // mix given properties into the prototype
	    Utils.extend(proto, props);
	
	    parent = this;
	
	    NewClass.__super__ = parent.prototype;
	
	
	    return NewClass;
	};
	
	// method for adding properties to prototype
	Class.include = function(props){
	    Utils.extend(this.prototype, props);
	};
	
	Class._hook = function(before_after, methodName, func, override){
	    var that = this;
	    before_after || (before_after = 'before');
	    override     || (override = false);
	    if(!(methodName in that.prototype))throw Error('No method found');
	
	    if(!('___hooks' in that.prototype)){
	        that.prototype['___hooks'] = {};
	    }
	
	    if(!(methodName in that.prototype['___hooks'])){
	        that.prototype['___hooks'][methodName] = {
	            'before': [],
	            'after': []
	        };
	    }
	
	    func.override = override;
	
	    that.prototype['___hooks'][methodName][before_after].push(func);
	
	    return that;
	};
	
	// merge new default options to the Class
	Class.mergeOptions = function(options){
	    Utils.extend(this.prototype.options, options);
	};
	
	module.exports = Class;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(3);
	
	/**
	 * Статический класс с различными утилитами
	 * @namespace
	 */
	var Utils = {
	
	    /**
	     * Расширяет объект `dest` свойствами объекта `src` и возвращает `dest`.
	     *
	     * @param {Object} dest Объект, который нужно расширить
	     * @param {Object} [object1] Объект, который содержит дополнительные параметры для расширения dest
	     * @param {Object} [objectN] Дополнительные объекты, которые содержат дополнительные параметры для расширения dest
	     * @returns {Object} dest
	     */
	    extend: $.extend,
	
	    /**
	     * Возвращает функцию, которая вызывает функцию `fn` с контекстом `obj`.
	     * @param fn {Function} Функция, к которой нужно привязать контекст
	     * @param obj {Object} Объект - контекст. Будет доступен внутри функции как `this`
	     * @returns {Function}
	     * @example
	     *
	     * // Допустим у нас есть функция
	     * var myFunc = function(){return this.hello};
	     *
	     * // И простой объект
	     * var myContextObject = {hello:'hello world'};
	     *
	     * // Мы можем создать функцию с привязанным контекстом при этом не удаляя старую функцию myFunc
	     * var myFuncWithContextObject = Utils.bind(myFunc, myContextObject);
	     *
	     * // returns 'hello world'
	     * myFuncWithContextObject()
	     */
	    bind: function(fn, obj){ // (Function, Object) -> Function
	        var args = arguments.length > 2 ? Array.prototype.slice.call(arguments, 2) : null;
	        return function(){
	            return fn.apply(obj, args || arguments);
	        };
	    },
	
	    /**
	     * Stamp
	     */
	    stamp: (function(){
	        var lastId = 0,
	            _key   = '_omjs_obj_id';
	        return function(obj, key){
	            key || (key = _key);
	            obj[key] = obj[key] || ++lastId;
	            return obj[key];
	        };
	    }()),
	
	    trim: function(str){
	        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	    },
	
	    splitWords: function(str){
	        return Utils.trim(str).split(/\s+/);
	    },
	
	    setOptions: function(obj, options){
	        obj.options = Utils.extend(true, {}, obj.options, options);
	        return obj.options;
	    },
	
	    template: function(str, data){
	        return str.replace(/\{ *([\w_]+) *\}/g, function(str, key){
	            var value = data[key];
	            if(value === undefined){
	                throw new Error('No value provided for variable ' + str);
	            }else if(typeof value === 'function'){
	                value = value(data);
	            }
	            return value;
	        });
	    },
	
	    invokeEach: function(obj, method, context){
	        var i, args;
	
	        if(typeof obj === 'object'){
	            args = Array.prototype.slice.call(arguments, 3);
	
	            for(i in obj){
	                method.apply(context, [i, obj[i]].concat(args));
	            }
	            return true;
	        }
	
	        return false;
	    },
	
	    getUrlWithEndSlash: function(url){
	        return url + (url.charAt(url.length - 1) == '/' ? '' : '/');
	    },
	
	    flattenTreeObject: function(objects, child_attr, id_attr, parent_value){
	
	        // Если не передали значение родителя - пустая строка. Рут типа.
	        parent_value || (parent_value = "");
	
	        objects.forEach(function(obj){
	            // Устанавливаем значение родителя
	            obj['parent'] = parent_value;
	
	            if(child_attr in obj){ // Объект притворяется, что у него есть потомки
	
	                if(obj[child_attr].length){ // Они действительно есть
	                    // Уходим в рекурсию по потомкам объекта
	                    // и конкатенируем результат с основным массивом объектов
	                    objects = objects.concat(Utils.flattenTreeObject(obj[child_attr],
	                        child_attr,
	                        id_attr,
	                        obj[id_attr]));
	                }
	
	                // Удаляем ссылку на потомков из объекта
	                delete obj[child_attr]
	            }
	        });
	
	        // Возвращаем массив объектов
	        return objects
	    },
	
	    generateColors: function(min_color, max_color, total_colors){
	        var R, G, B, i, aRGBStart, aRGBFinish, finishPercent, startPercent,
	            /* n - количество промежуточных цветов, включая конечный
	             (т.е. между начальным и конечным цветами будет n-1 цвет) */
	            n      = total_colors - 1,
	            colors = [];
	
	        aRGBStart = min_color.replace("#", "").match(/.{2}/g);
	        aRGBFinish = max_color.replace("#", "").match(/.{2}/g);
	
	        for(i = 0; i <= n; i++){
	
	            /*процент содержания конечного цвета в текущем промежуточном цвете;
	             изменяется от 0 (не включая 0) до 1 (1 = 100%)*/
	
	            finishPercent = i / n;
	            /*процент содержания начального цвета в текущем промежуточном цвете;
	             изменяется от 1 до 0 (1 = 100%) */
	            startPercent = 1 - finishPercent;
	
	            //вычисляем значения красного, зеленого, синего промежуточного цвета
	            R = Math.floor(('0x' + aRGBStart[0]) * startPercent + ('0x' + aRGBFinish[0]) * finishPercent);
	            G = Math.floor(('0x' + aRGBStart[1]) * startPercent + ('0x' + aRGBFinish[1]) * finishPercent);
	            B = Math.floor(('0x' + aRGBStart[2]) * startPercent + ('0x' + aRGBFinish[2]) * finishPercent);
	
	            colors.push("#" + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1));
	        }
	
	        return colors;
	    },
	
	    getDevicePixelRatio: function () {
	        var ratio = 1;
	        // To account for zoom, change to use deviceXDPI instead of systemXDPI
	        if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
	            // Only allow for values > 1
	            ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
	        }
	        else if (window.devicePixelRatio !== undefined) {
	            ratio = window.devicePixelRatio;
	        }
	        return ratio;
	    },
	
	    getZoomFromResolution: function (resolution) {
	        var tileSize    = 256,
	            worldLength = 20037508.319893047 * 2;
	
	        return Math.log((worldLength) / (tileSize * resolution)) / Math.LN2;
	    },
	
	    /**
	     * Доработанная функция анимации из https://learn.javascript.ru/js-animation
	     * @param options.duration - время анимации в мс
	     * @param options.timing - функция анимации (по умолчанию линейная)
	     * @param options.infinite - анимация будет длиться бесконечно
	     * @param cb - функция, которая будет выполнена в конце анимации. опционально
	     * @returns {Function} функция, которая остановит анимацию
	     */
	    animate: function (options, cb) {
	        var start = Date.now();
	        var stop  = false;
	        options.timing || (options.timing = function (timeFraction) {
	            return timeFraction;
	        });
	        window.requestAnimationFrame(function animate(time) {
	            var progress, timeFraction;
	            if (stop) {
	                if (cb) {
	                    cb();
	                }
	                return false;
	            }
	            // timeFraction от 0 до 1
	            timeFraction = (time - start) / options.duration;
	            if (timeFraction > 1) timeFraction = 1;
	            if (timeFraction < 0) timeFraction = 0;
	
	            // текущее состояние анимации
	            progress = options.timing(timeFraction);
	
	            options.draw(progress);
	
	            if (timeFraction < 1) {
	                window.requestAnimationFrame(function () {
	                    animate(Date.now())
	                });
	            } else {
	                if (options.infinite) {
	                    start = Date.now();
	                    window.requestAnimationFrame(function () {
	                        animate(Date.now())
	                    });
	                } else {
	                    if (cb) {
	                        cb();
	                    }
	                    return false;
	                }
	            }
	        });
	
	        return function () {
	            stop = true;
	        }
	    },
	
	    webglEnabled: function(){
	        var gl;
	        var canvas = document.createElement('canvas');
	        try {
	            gl = canvas.getContext("webgl");
	        } catch (x) {
	            gl = null;
	        }
	
	        if (gl == null) {
	            try {
	                gl = canvas.getContext("experimental-webgl");
	            } catch (x) {
	                gl = null;
	            }
	        }
	
	        return gl != null;
	    },
	
	    isTouch: function(){
	        var isTouch;
	        try {
	            document.createEvent("TouchEvent");
	            isTouch = true;
	        } catch (e) {
	            isTouch = false;
	        }
	        return isTouch;
	    },
	
	    emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
	    escapeHTML: function(html){
	        var escape = document.createElement('div');
	        escape.textContent = html;
	        return escape.innerHTML;
	    },
	
	    unescapeHTML: function(html){
	        var escape = document.createElement('div');
	        escape.innerHTML = html;
	        return escape.textContent;
	    },
	
	    doubleUnescapeHTML: function(html){
	        return Utils.unescapeHTML(Utils.unescapeHTML(html));
	    },
	    /**
	     *
	     * @param number - Кол-во объектов кластера
	     * @param scale - Коэффициент масштаба отрисовки (pixelRatio)
	     * @param cluserSizeOptions - Параметры отрисовки кол-ва объектов
	     * @returns canvas
	     */
	    createObjectsCountCnv: function(number, scale, cluserSizeOptions) {
	        // фигуры иконки кол-ва объектов будут вписаны и отцентрированы в общие размеры
	        var width   = cluserSizeOptions.width * scale;
	        var height  = cluserSizeOptions.height * scale;
	        var canvas = document.createElement('canvas');
	            canvas.width = width;
	            canvas.height = height;
	        // var canvas  = $('<canvas width="'+width+'" height="'+height+'"></canvas>')[0];
	        var ctx     = canvas.getContext('2d');
	
	        cluserSizeOptions.figures.forEach(function (fig) {
	            var offsetX,
	                offsetY;
	            switch (fig.type) {
	                case 'rect':
	                    var rectRadius  = fig.radius * scale,
	                        rectWidth   = fig.width * scale,
	                        rectHeight  = fig.height * scale,
	                        lineWidth   = typeof fig.lineWidth === 'number' ? fig.lineWidth : 1,
	                        offset = 0;
	                    offsetX = (width - rectWidth) / 2;
	                    offsetY = (height - rectHeight) / 2;
	                    ctx.strokeStyle = fig.strokeStyle;
	                    ctx.fillStyle   = fig.fillStyle;
	                    // если есть обводка, то нужен отступ при рисовании,
	                    // чтобы обводка за canvas не вылезала (и шла внутрь)
	                    if (lineWidth) {
	                        ctx.lineWidth   = fig.lineWidth * scale;
	                        offset += (ctx.lineWidth / 2);
	                    }
	                    Utils.roundRect(ctx, offset + offsetX, offset + offsetY,
	                        width - ((offset + offsetX) * 2), height - ((offset + offsetY) * 2),
	                        rectRadius, true, Boolean(lineWidth));
	                    break;
	                case 'circle':
	                    var circleRadius = fig.radius * scale;
	                    offsetX = (width - circleRadius * 2) / 2;
	                    offsetY = (height - circleRadius * 2) / 2;
	                    ctx.fillStyle   = fig.fillStyle;
	                    ctx.beginPath();
	                    ctx.arc(circleRadius + offsetX, circleRadius + offsetY, circleRadius, 0, 2 * Math.PI);
	                    ctx.fill();
	                    // для circle нет нужны поддерживать stroke, эмулиуется circle, бОльшим по размеру
	                    break;
	            }
	        });
	        ctx.font        = cluserSizeOptions.fontSize * (scale / 2) + "px " + cluserSizeOptions.fontFamily;
	        ctx.textAlign   = cluserSizeOptions.textAlign;
	        ctx.textBaseline= cluserSizeOptions.textBaseline;
	        ctx.fillStyle   = cluserSizeOptions.textColor;
	        ctx.fillText(number, width / 2, (height / 2) + 1); 
	        return canvas;
	    },
	
	    // https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
	    roundRect: function (ctx, x, y, width, height, radius, fill, stroke) {
	        if (typeof stroke == 'undefined') {
	            stroke = true;
	        }
	        if (typeof radius === 'undefined' || isNaN(radius)) {
	            radius = 5;
	        }
	        if (typeof radius === 'number') {
	            radius = {tl: radius, tr: radius, br: radius, bl: radius};
	        } else {
	            var defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
	            for (var side in defaultRadius) {
	                radius[side] = radius[side] || defaultRadius[side];
	            }
	        }
	        ctx.beginPath();
	        ctx.moveTo(x + radius.tl, y);
	        ctx.lineTo(x + width - radius.tr, y);
	        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
	        ctx.lineTo(x + width, y + height - radius.br);
	        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
	        ctx.lineTo(x + radius.bl, y + height);
	        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
	        ctx.lineTo(x, y + radius.tl);
	        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
	        ctx.closePath();
	        if (fill) {
	            ctx.fill();
	        }
	        if (stroke) {
	            ctx.stroke();
	        }
	    },
	
	    cloneFeature: function(feature) {
	        return feature.clone();
	    },
	
	    cloneVectorLayer: function(
	        original_layer,
	        source_options,
	        for_each_feature
	    ) {
	
	        var original_style = original_layer.getStyle();
	
	        var cloned_style = null;
	
	        if (_.isArray(original_style)) {
	            cloned_style = original_style.map(function(style){
	                return style.clone();
	            });
	        } else if (typeof original_style == 'function') {
	            // потенциальное место для ошибок
	            cloned_style = original_style.bind(original_style);
	        } else {
	            cloned_style = original_style.clone();
	        }
	
	        var original_source = original_layer.getSource();
	        var cloned_features = original_source
	                                .getFeatures()
	                                .map(Utils.cloneFeature);
	
	        if (
	            for_each_feature 
	            && _.isFunction(for_each_feature)
	        ) {
	            for (var i = 0; i < cloned_features.length; i++) {
	                var _feature = cloned_features[i];
	                for_each_feature(_feature);
	            }
	        }
	
	        var new_source = new ol.source.Vector(
	            _.extend({ features: cloned_features }, source_options)
	        );
	
	        var layer = new ol.layer.Vector({
	            source: new_source,
	            style : cloned_style
	        });
	
	        return layer;
	    }
	};
	
	module.exports = Utils;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils = __webpack_require__(5);
	
	var eventsKey = '_orbisapp_events';
	
	var falseFn = function(){
	    return false;
	};
	
	var Events = {
	
	    addEventListener: function(types, fn, context){ // (String, Function[, Object]) or (Object[, Object])
	
	        // types can be a map of types/handlers
	        var events, contextId, i, len, event, type, indexKey, indexLenKey, typeIndex;
	
	        if(Utils.invokeEach(types, this.addEventListener, this, fn, context)){ return this; }
	
	        events = this[eventsKey] = this[eventsKey] || {};
	        contextId = context && context !== this && Utils.stamp(context);
	
	        // types can be a string of space-separated words
	        types = Utils.splitWords(types);
	
	        for(i = 0, len = types.length; i < len; i++){
	            event = {
	                action : fn,
	                context: context || this
	            };
	            type = types[i];
	
	            if(contextId){
	                // store listeners of a particular context in a separate hash (if it has an id)
	                // gives a major performance boost when removing thousands of map layers
	
	                indexKey = type + '_idx';
	                indexLenKey = indexKey + '_len';
	
	                typeIndex = events[indexKey] = events[indexKey] || {};
	
	                if(!typeIndex[contextId]){
	                    typeIndex[contextId] = [];
	
	                    // keep track of the number of keys in the index to quickly check if it's empty
	                    events[indexLenKey] = (events[indexLenKey] || 0) + 1;
	                }
	
	                typeIndex[contextId].push(event);
	
	            }else{
	                events[type] = events[type] || [];
	                events[type].push(event);
	            }
	        }
	
	        return this;
	    },
	
	    hasEventListeners: function(type){ // (String) -> Boolean
	        var events = this[eventsKey];
	        return !!events && ((type in events && events[type].length > 0) ||
	                            (type + '_idx' in events && events[type + '_idx_len'] > 0));
	    },
	
	    removeEventListener: function(types, fn, context){ // ([String, Function, Object]) or (Object[, Object])
	
	        var events, contextId, i, len, type, listeners, j, indexKey, indexLenKey, typeIndex, removed;
	        if(!this[eventsKey]){
	            return this;
	        }
	
	        if(!types){
	            return this.clearAllEventListeners();
	        }
	
	        if(Utils.invokeEach(types, this.removeEventListener, this, fn, context)){ return this; }
	
	        events = this[eventsKey];
	        contextId = context && context !== this && Utils.stamp(context);
	
	        types = Utils.splitWords(types);
	
	        for(i = 0, len = types.length; i < len; i++){
	            type = types[i];
	            indexKey = type + '_idx';
	            indexLenKey = indexKey + '_len';
	
	            typeIndex = events[indexKey];
	
	            if(!fn){
	                // clear all listeners for a type if function isn't specified
	                delete events[type];
	                delete events[indexKey];
	                delete events[indexLenKey];
	
	            }else{
	                listeners = contextId && typeIndex ? typeIndex[contextId] : events[type];
	
	                if(listeners){
	                    for(j = listeners.length - 1; j >= 0; j--){
	                        if((listeners[j].action === fn) && (!context || (listeners[j].context === context))){
	                            removed = listeners.splice(j, 1);
	                            // set the old action to a no-op, because it is possible
	                            // that the listener is being iterated over as part of a dispatch
	                            removed[0].action = falseFn;
	                        }
	                    }
	
	                    if(context && typeIndex && (listeners.length === 0)){
	                        delete typeIndex[contextId];
	                        events[indexLenKey]--;
	                    }
	                }
	            }
	        }
	
	        return this;
	    },
	
	    clearAllEventListeners: function(){
	        delete this[eventsKey];
	        return this;
	    },
	
	    fireEvent: function(type, data){ // (String[, Object])
	        var events, listeners, i, len, typeIndex, contextId;
	        var event;
	        if(!this.hasEventListeners(type)){
	            return this;
	        }
	
	        event = Utils.extend({},
	            data,
	            {
	                type  : type,
	                target: this
	            });
	
	        events = this[eventsKey];
	
	        if(events[type]){
	            // make sure adding/removing listeners inside other listeners won't cause infinite loop
	            listeners = events[type].slice();
	
	            for(i = 0, len = listeners.length; i < len; i++){
	                listeners[i].action.call(listeners[i].context, event);
	            }
	        }
	
	        // fire event for the context-indexed listeners as well
	        typeIndex = events[type + '_idx'];
	
	        for(contextId in typeIndex){
	            listeners = typeIndex[contextId].slice();
	
	            if(listeners){
	                for(i = 0, len = listeners.length; i < len; i++){
	                    listeners[i].action.call(listeners[i].context, event);
	                }
	            }
	        }
	
	        return this;
	    },
	
	    addOneTimeEventListener: function(types, fn, context){
	
	        var handler;
	        if(Utils.invokeEach(types, this.addOneTimeEventListener, this, fn, context)){ return this; }
	
	        handler = Utils.bind(function(){
	            this
	                .removeEventListener(types, fn, context)
	                .removeEventListener(types, handler, context);
	        }, this);
	
	        return this
	            .addEventListener(types, fn, context)
	            .addEventListener(types, handler, context);
	    }
	};
	
	Events.on = Events.addEventListener;
	
	Events.off = Events.removeEventListener;
	
	Events.once = Events.addOneTimeEventListener;
	
	Events.fire = Events.fireEvent;
	
	module.exports = Events;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var Class   = __webpack_require__(4),
	    utils   = __webpack_require__(5);
	
	var Model = Class.extend({
	
	    /**
	     * Уникальный идентификатор модели который генерируется при ее создании
	     *
	     * @property {Number} guid
	     */
	    guid: undefined,
	
	    initialize: function(attributes, options){
	        var that = this,
	            attrs;
	
	        that._attributes = {};
	
	        attrs = attributes || {};
	
	        options = options || {};
	        that.setOptions(options);
	
	        that.set(attrs);
	        utils.stamp(that, 'guid');
	    },
	
	    get: function(attrName){
	        return this._attributes[attrName];
	    },
	
	    set: function(attr, value) {
	        var that = this,
	            attrs,
	            i;
	
	        if (typeof attr === "string") {
	            attrs = {};
	            attrs[attr] = value;
	        } else {
	            attrs = attr;
	        }
	
	        for( i in attrs) {
	            that._attributes[i] = attrs[i];
	        }
	    }
	});
	
	module.exports = Model;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var Class   = __webpack_require__(4),
	    $       = __webpack_require__(3);
	
	
	var Collection = Class.extend({
	
	    /**
	     * Базовый класс коллекции объектов (моделей) предоставляющий основные методы
	     * для управления набором данных(добавление, удаление, фильтрация, ...)
	     *
	     * @class Collection
	     * @namespace omjs
	     * @extends Class
	     * @constructor
	     * @param {Object[]|Model[]} [objects] - массив объектов или моделей
	     * @param {Object} [options] - объект с опциями коллекции в формате ключ - значение
	
	     * @example
	     *     var collection = new omjs.Collection([model1, model2, model3, ...], {
	     *         option1: option1_value,
	     *         ...
	     *     });
	     */
	    initialize: function(objects, options){
	        var that = this,
	            objs;
	
	        objs = objects || [];
	
	        that.reset(objs);
	
	        options = options || {};
	        that.setOptions(options);
	    },
	
	    /**
	     * Возвращает длину коллекции
	     *
	     * @method getLength
	     * @returns {Number}
	     */
	    getLength: function() {
	        return this.getArray().length;
	    },
	
	    /**
	     * Возвращает элементы коллекции в виде массива
	     *
	     * @method getArray
	     * @returns {Object[]|omjs.Model[]}
	     */
	    getArray: function(){
	        return this._items;
	    },
	
	    /**
	     * Возвращает ондекс элемента в коллекции, указанного в параметре object.
	     * Если елемент отсутствует в коллекции метод вернет -1
	     *
	     * @method indexOf
	     * @param {Object|omjs.Model} object - объект, индекс которого будет определен
	     * @returns {Number}
	     */
	    indexOf: function(object){
	        return this._items.indexOf(object);
	    },
	
	    /**
	     * Определяет есть ли такой елемент (массив елементов) в коллекции
	     *
	     * @method has
	     * @param {Object|Object[]} objects - объект или массив объектов
	     * @returns {Boolean}
	     */
	    has: function(objects) {
	        var that = this,
	            result = true,
	            i;
	
	        if (!$.isArray(objects)) {
	            result = that._items.indexOf(objects) !== -1;
	        } else {
	            for(i in objects) {
	                result &= that._items.indexOf(objects[i]) !== -1;
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Возвращает елемент коллекции с указанным индексом
	     *
	     * @method at
	     * @param {number} index - индекс элемента
	     * @returns {Object|omjs.Model}
	     */
	    at: function(index){
	        return this._items[index];
	    },
	
	    /**
	     * Добавляет элемент или массив элементов в коллекцию
	     *
	     * @method add
	     * @chainable
	     * @param {Object[]|omjs.Model[]} objects - элемент или массив элементов
	     * @returns {this}
	     *
	     */
	    add: function(objects){
	        var that = this,
	            _objects,
	            i;
	
	        _objects = $.isArray(objects) ? objects : [objects];
	
	        for (i in _objects) {
	            if (_objects[i]) {
	                that._items.push(_objects[i]);
	            }
	        }
	        return that;
	    },
	
	    /**
	     * Удаляет элементы из коллекции
	     *
	     * @method remove
	     * @param {Object[]|omjs.Model[]} objects - элемент или массив элементов для удаления
	     */
	    remove: function(objects){
	        var that = this,
	            _objects,
	            removed,
	            result = [],
	            i;
	
	        _objects = $.isArray(objects) ? objects : [objects];
	
	        for (i in _objects) {
	            if (that.has(_objects[i])) {
	                removed = that._items.splice(that.indexOf(_objects[i]), 1);
	                result.push(removed);
	            }
	        }
	
	        return that;
	    },
	
	    /**
	     * Метод создает массив из атрибутов моделей коллекции
	     *
	     * @param {String} attrName - Имя атрибута, значения которого будут использованы для создания массива
	     * @returns {Array}
	     *
	     * @example
	     *      var collection = new omjs.Collection([
	     *          {a:1, b:2},
	     *          {a:3, b:2},
	     *          {a:5, b:2}
	     *      ]);
	     *
	     *      collection.pluck("a");
	     *      // результат [1,3,5];
	     */
	    pluck: function(attrName){
	        var that = this,
	            result = [],
	            i;
	
	        if (that.getLength()) {
	            for(i in that._items) {
	                result.push(that._items[i].get(attrName));
	            }
	        }
	
	        return result;
	    },
	
	    /**
	     * Метод позволяет отфильтровать этементы коллекции и получить их в виде новой коллекции
	     *
	     * @method filter
	     * @param {Function} predicate - функция для фильтрации
	     * @return {omjs.Collection}
	     *
	     * @example
	     *      var collection = new omjs.Collection([
	     *          {a:1, b:2},
	     *          {a:3, b:1},
	     *          {a:5, b:2}
	     *          {a:3, b:1},
	     *          {a:5, b:2}
	     *      ]);
	     *
	     *      var result = collection.filter(function(obj, i){
	     *          return obj.get("b") == 2;
	     *      };
	     *      // результат новая коллекция с элементами 0, 2, 4;
	     */
	    filter: function(predicate){
	        var that = this,
	            result = [],
	            callback;
	
	        callback = $.isFunction(predicate)
	            ? predicate
	            : function() {return true;};
	
	        that._items.forEach(function(obj, i){
	            if (callback(obj, i)) {
	                result.push(obj);
	            }
	        });
	
	        return new that.constructor(result);
	    },
	
	    each: function(iteratee) {
	        var that = this;
	        that._items.forEach(iteratee);
	        return that;
	    },
	
	    /**
	     * Очищает коллекцию и записывает в нее элементы objects
	     *
	     * @method reset
	     * @chainable
	     * @param {Object[]|omjs.Model[]} objects - массив объектов или моделей
	     */
	    reset: function(objects){
	        var that = this;
	
	        that._items = [];
	        if(objects){
	            that.add(objects);
	        }
	
	        return that;
	    }
	});
	
	module.exports = Collection;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var Access = {
	
	    // Константы доступов
	    NO_ACCESS        : 0,
	    FULL_ACCESS      : 0xFFFF,
	    // Маски доступов
	    BIT_READ        : 1 << 0, //       1
	    BIT_EDIT        : 1 << 1, //      10
	    BIT_CHILD_READ  : 1 << 2, //     100
	    BIT_CHILD_EDIT  : 1 << 3, //    1000
	    BIT_CHILD_APPEND: 1 << 4, //   10000
	    BIT_STRUCT_READ : 1 << 5, //  100000
	    BIT_STRUCT_EDIT : 1 << 6,  // 1000000
	
	    setAccess: function(access, mask, value){
	        "use strict";
	
	        if (value) {
	            access |= mask;
	        } else {
	            access &= ~mask;
	        }
	
	        return access;
	    },
	
	    hasAccess: function (access, mask, value) {
	        "use strict";
	        var val;
	
	        if(value == undefined){
	            value = true;
	        }
	
	        val = Boolean(value);
	
	        return ((access & mask) == mask) == val;
	    },
	
	    hasAnyAccess: function(access, mask){
	        "use strict";
	
	        return Boolean((access & mask) > 0);
	    },
	
	    // mixin: {
	    //     accessAttribute: 'access',
	
	    //     getAccessValue: function () {
	    //         "use strict";
	    //         return this.get(this.accessAttribute);
	    //     },
	
	    //     setAccessValue: function (access) {
	    //         "use strict";
	    //         return this.set(this.accessAttribute, access);
	    //     },
	
	    //     setAccess: function (mask, value) {
	    //         "use strict";
	    //         var that   = this;
	    //         var access = that.getAccessValue();
	    //         that.setAccessValue(Access.setAccess(access, mask, value));
	    //         return that;
	    //     },
	
	    //     hasAccess: function (mask, value) {
	    //         "use strict";
	    //         var that   = this;
	    //         var access = that.getAccessValue();
	    //         return Access.hasAccess(access, mask, value)
	    //     },
	
	    //     hasAnyAccess: function(mask){
	    //         "use strict";
	    //         var that = this;
	    //         var access = that.getAccessValue();
	    //         return Access.hasAnyAccess(access, mask)
	    //     },
	    // }
	};
	
	module.exports = Access;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(3),
	    Project = __webpack_require__(11);
	
	/**
	 * Фабрика , создающая новый экземпляр проекта с заданной конфигурацией
	 *
	 * @function initProject
	 * @for omjs
	 * @param {String|Object} config - url конфигурации проекта или объект с конфигурацией
	 * @static
	 * @return {omjs.Project}
	 */
	
	module.exports = function(config){
	    var result = $.Deferred(),
	        project;
	
	    if($.type(config) === 'string') {
	        $.getJSON(config).done(function(confObject){
	            project = new Project(confObject);
	            result.resolve(project);
	        });
	    } else {
	        project = new Project(config);
	        result.resolve(project);
	    }
	
	    return result;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var Class      = __webpack_require__(4);
	var Events     = __webpack_require__(6);
	var $          = __webpack_require__(3);
	var utils      = __webpack_require__(5);
	var Collection = __webpack_require__(8);
	var ContainersCollection;
	var Layer;
	var Visualization;
	var LayerObject;
	var Container;
	
	var createContainer = function (container_obj, project) {
	    var cont;
	
	    if (container_obj.style_mode && container_obj.style_mode == 3){
	        cont = new Visualization(container_obj, project);
	    }
	    else {
	        switch (container_obj['type']) {
	            case 'layer':
	            case 'virtual':
	            case 'material':
	                cont = new Layer(container_obj, project);
	                break;
	            default:
	                cont = new Container(container_obj, project);
	        }
	    }
	
	    return cont;
	};
	
	/**
	 * @class
	 */
	var Project = Class.extend({
	
	    includes: Events,
	
	    options: {
	        apiUrl : '',
	        mapCode: ''
	    },
	
	    /**
	     * Класс проекта oms реализующий работу с данными опубликованной карты
	     *
	     * @class Project
	     * @namespace omjs
	     * @extends Class
	     * @constructor
	     *
	     * @example
	     *     var container = new omjs.Project.Container({
	     *         project: projectInstance,
	     *         ...
	     *     });
	     */
	    initialize: function (options) {
	        var that = this;
	        if (!$.isPlainObject(options)) {
	            throw new Error('No options specified');
	        }
	
	        that.setOptions(options);
	
	        that.token = that.options.token || false;
	        that.lng = that.options.lng || false;
	        that.objects_editable = that.options.objects_editable || false;
	
	        // Validate apiUrl option
	        that.options['apiUrl'] = ('' + that.options['apiUrl']).trim();
	
	        if (!that.options['apiUrl']) {
	            throw new Error('No apiUrl option specified');
	        }
	
	        // Добавляем слеш к урле в конце, если её небыло
	        that.options['apiUrl'] = utils.getUrlWithEndSlash(that.options['apiUrl']);
	
	        // TODO: Убрать когда сервак будет отдавать правильную URL
	        if (~that.options['apiUrl'].indexOf('%version')) {
	            that.options['apiUrl'] = that.options['apiUrl'].replace('/%version/', '/'+omjs.version+'/');
	        } else {
	            that.options['apiUrl'] = that.options['apiUrl'].replace('/2.0/', '/'+omjs.version+'/');
	        }
	
	        that._originalTilesUrl = false;
	        if(that.options['tilesUrl']){
	            that._originalTilesUrl = that.options['tilesUrl'];
	            that._addParamsToTilesUrl();
	        }
	
	        // Validate mapCode option
	        that.options['mapCode'] = ('' + that.options['mapCode']).trim();
	
	        if (!that.options['mapCode']) {
	            throw new Error('No mapCode option specified');
	        }
	
	        that.apiUrlLocation = that._getApiLocation();
	
	        ContainersCollection = __webpack_require__(12);
	        Layer                = __webpack_require__(14);
	        Visualization        = __webpack_require__(15);
	        Container            = __webpack_require__(13);
	        LayerObject          = __webpack_require__(17);
	
	        that._cache = {
	            // containers       : new ContainersCollection(),
	            // publishContainers: new ContainersCollection()
	        };
	        that.contsDeferred = {};
	    },
	    /**
	     * Дополнительные параметры в URL тайлов
	     * @returns {Project}
	     * @private
	     */
	    _addParamsToTilesUrl: function(){
	        var that = this;
	        if(!that.options['tilesUrl']){
	            return that;
	        }
	        that.options['tilesUrl'] = that._originalTilesUrl;
	        if(that.token){
	            that.options['tilesUrl'] += '&token='+that.token;
	        }
	        if(that.lng){
	            that.options['tilesUrl'] += '&lng='+that.lng;
	        }
	        return that;
	    },
	
	    /**
	     *
	     * @returns {*}
	     * @private
	     */
	    _getUrlWithMapCode: function () {
	        var that = this;
	        return utils.getUrlWithEndSlash(that.options['apiUrl'] + that.options['mapCode']);
	    },
	
	    _getApiLocation: function(){
	        var that = this;
	        var l = document.createElement("a");
	        l.href = that.options.apiUrl;
	        if (!l.origin) {
	            l.origin = l.protocol + '//' + l.hostname;
	        }
	        return l;
	    },
	
	    /**
	     * Авторизация пользователя на проекте
	     *
	     * @method login
	     * @param {String} user - Имя пользователя
	     * @param {String} password - Пароль пользователя
	     * @return {jQuery.jqXHR}
	     */
	    login: function (user, password) {
	        var that = this;
	        var url  = that.options['apiUrl'];
	
	        if (!($.type(user) == 'string' && user.length)) {
	            throw new Error('User required');
	        }
	
	        if (!($.type(password) == 'string' && password.length)) {
	            throw new Error('Password required');
	        }
	
	        return $.ajax(url + 'login/', {
	            "crossDomain": true,
	            "type"       : "post",
	            "data"       : {
	                user: user,
	                pass: password
	            }
	        }).done(function (resp) {
	            that.token = resp.token;
	            that._addParamsToTilesUrl();
	        });
	    },
	
	    /**
	     * Завершение авторизованной сессии полльзователя
	     *
	     * @method logout
	     * @return {jQuery.Promise}
	     */
	    logout: function () {
	        var that = this;
	        var url  = that.options['apiUrl'];
	
	        return $.when()
	            .then(function () {
	                return !that.token || $.ajax(url + 'logout/', {
	                    "crossDomain": true,
	                    "type"       : "post",
	                    "data"       : {
	                        "token": that.token
	                    }
	                });
	            })
	            .done(function () {
	                that.token = false;
	                that._addParamsToTilesUrl();
	            });
	    },
	
	    loginToken: function(token){
	        var that = this;
	
	        // чтоб нам авторизоваться этим токеном
	        // нужно сделать запрос на сервер с этим токеном
	        // подойдет запрос на проверку авторизации
	        // если сервер нам скажет, что такой пользователь есть,
	        // то мы поменяем урлу до тайлов и установим that.token
	
	        that.isAuthorized(token).then(function(is_authorized){
	            if (is_authorized) {
	                that.token = token;
	                that._addParamsToTilesUrl();
	            }
	        });
	
	    },
	
	    isAuthorized: function(token, set_token_if_authorized){
	        var that = this;
	        var url  = that.options['apiUrl'];
	
	        token = (token === undefined || token === false) ? that.token : token;
	
	        // token = token || that.token;
	        
	        // if (!token) {
	        //     return $.Deferred().resolve(false);
	        // }
	
	        return $.ajax({
	            type: "GET",
	            url: url + 'authorized/',
	            data: {
	                token: token
	            }
	        }).then(function(response){
	            // если сервер вернул true
	            if (response) {
	                if (set_token_if_authorized) {
	                    that.token = token;
	                    that._addParamsToTilesUrl();
	                }
	            }
	            return response;
	        });
	    },
	
	    isPublicUser: function(){
	        var that = this;
	        return that.isAuthorized().then(function(response){
	            return !response;
	        });
	    },
	
	    /**
	     * Загружает список контейнеров
	     */
	    loadContainers: function (options) {
	        var that = this;
	        var url  = that._getUrlWithMapCode();
	        var raw  = false;
	        var deferred;
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "type"      : "full",
	            "returnCss" : 0
	        }, options);
	
	        if (that.token) {
	            options['token'] = that.token;
	        }
	        if (that.lng) {
	            options['lng'] = that.lng;
	        }
	        if (options.type == "publish" && that.objects_editable) {
	            options['with_access'] = 1;
	        }
	
	        deferred = $.when()
	            .then(function() {
	                raw = Boolean(options['raw']);
	
	                if (!raw) {
	                    options['returnCss']  = 0;
	                } else {
	                    delete options['raw'];
	                }
	
	                return $.ajax(url + 'layers/', {
	                    "crossDomain": true,
	                    "data"       : options
	                });
	            })
	            .then(function(response) {
	                var collection;
	
	                if (raw) {
	                    return response;
	                }
	
	                collection = new ContainersCollection();
	
	                response.forEach(function (container_obj) {
	                    collection.add(createContainer(container_obj, {project: that}));
	                });
	
	                return collection;
	            });
	
	        return deferred;
	    },
	
	    getContainers: function (options) {
	        var that = this;
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "type"      : "full"
	        }, options);
	
	        options['returnCss']  = 0;
	        delete options['raw'];
	
	        return $.when()
	            .then(function () {
	                if (!that.contsDeferred[options['type']]) {
	                    that.contsDeferred[options['type']] = that.loadContainers(options);
	                }
	
	                return that.contsDeferred[options['type']];
	            })
	            .then(function(containers){
	                var containersAttr;
	                // Определяем, кеш чего нам нужен. Публичных контейнеров или полное дерево.
	                containersAttr = (options['type'] == 'full') ? 'containers' : 'publishContainers';
	
	                // Если кеш еще пуст - заполняем его
	                if (!that._cache[containersAttr]) {
	                    that._cache[containersAttr] = containers;
	                }
	
	                return containers;
	            });
	    },
	
	    /**
	     * Загружает список слоев (без папок и карт !!!) используя метод loadContainers
	     */
	    loadLayers: function (options) {
	        var that = this;
	        options || (options = {});
	
	        options = $.extend(true, {
	            "type"      : "full",
	            "returnCss" : 0
	        }, options);
	
	        // Нельзя грузить контейнеры в "сыром" виде для получения слоёв.
	        if ('raw' in options) {
	            delete options['raw'];
	        }
	
	        return that.loadContainers(options)
	            .then(function (collection) {
	                return collection.filter(function (container) {
	                    return Boolean(~$.inArray(container.get('type'), ['layer', 'virtual', 'material', 'raster']));
	                });
	            });
	    },
	
	    getLayers: function (options) {
	        var that = this;
	
	        return that.getContainers(options)
	            .then(function (collection) {
	                return collection.filter(function (container) {
	                    var cont_type = (container.get)?container.get('type'):container['type'];
	                    return Boolean(~$.inArray(cont_type, ['layer', 'virtual', 'material', 'raster']));
	                });
	            });
	    },
	
	    /**
	     * Загрузка слоя опубликованной карты по его коду
	     *
	     * @param {String} layer_code - код слоя
	     * @param {Object} [options] - опции
	     * @param {Boolean} [options.raw=false] - `true` - не обрабатывать ответ с сервера
	     * @return {jQuery.jqXHR}
	     */
	    loadLayer: function (layer_code, options) {
	        var that = this,
	            url  = that._getUrlWithMapCode(),
	            raw  = false;
	
	        if (typeof layer_code != 'string') {
	            throw new Error('layer_code is not a String or undefined');
	        }
	
	        options || (options = {});
	        options = $.extend(true, {}, options);
	
	        if ('raw' in options) {
	            raw = Boolean(options['raw']);
	            delete options['raw'];
	        }
	
	        if (that.token) {
	            options['token'] = that.token
	        }
	        if (that.lng) {
	            options['lng'] = that.lng
	        }
	
	        return $.ajax(url + 'layers/' + layer_code + '/', {
	                "crossDomain": true,
	                "data"       : options
	            })
	            .then(function (response) {
	                if (raw) return this;
	
	                return createContainer(response, {project: that})
	            });
	    },
	
	    /**
	     * Загрузка полной информации по объекту
	     *
	     * @method loadObjects
	     * @param {String} layerCode - код слоя
	     * @param {Object} [options] - опции
	     * @param {Boolean} [options.raw=false] - `true` - не обрабатывать ответ с сервера
	     * @param {String[]} [options.fields] - массив кодов полей, значения которых также попадут в результат
	     * @param {any} [options.*] - все параметры которые поддерживает сервер
	     * @returns {jQuery.jqXHR}
	     *
	     * @example
	     *      var layers;
	     *      omjs.initProject(config)
	     *      .then(function(project){
	     *          return project.loadLayers();
	     *      })
	     *      .then(function(layers){
	     *          layersColection = layers;
	     *          return layers.loadObjects();
	     *      })
	     *      .then(function(objects){
	     *          // Работаем с объектами
	     *      });
	     */
	    loadObjects: function (layerCode, options) {
	        var that = this,
	            url  = that._getUrlWithMapCode(),
	            raw  = false;
	
	        if ($.type(layerCode) !== 'string') {
	            // TODO: Нужно нормальное описание ошибки.
	            throw new Error('layerCode is not a string')
	        }
	
	        options || (options = {});
	        options = $.extend(true, {}, options);
	
	        if ('raw' in options) {
	            raw = Boolean(options['raw']);
	            delete options['raw'];
	        }
	
	        if (that.token) {
	            options['token'] = that.token
	        }
	        if (that.lng) {
	            options['lng'] = that.lng
	        }
	
	        if ('fields' in options) {
	
	            // Если передали не массив - грохаем опцию.
	            // Тут может быть только массив строк
	            if (typeof options['fields'] == 'string') {
	                options['fields'] = [options['fields']];
	            }
	            if (!$.isArray(options['fields'])) {
	                throw new Error('option -fields-  mast be Array');
	            }
	            // Переводим в нужный серверу формат
	            options['fields'] = options['fields'].join(',');
	        }
	
	        // TODO: Нужно дописать обработчик fail-а.
	        return $.ajax(url + 'layers/' + layerCode + '/objects/', {
	            crossDomain: true,
	            data       : options
	        }).then(function (response) {
	
	            var objects;
	            if (raw) return response;
	
	            objects = response.map(function (obj) {
	                var objId     = obj['id'];
	                var objFields = obj['fields'];
	                delete obj['id'];
	                delete obj['fields'];
	                obj['layerCode'] = layerCode;
	                return new LayerObject(objId, objFields, obj);
	            });
	
	            return new Collection(objects);
	        });
	    },
	
	    /**
	     * Загрузка полной информации по объекту
	     *
	     * @method loadObject
	     * @param {String} layerCode - код слоя
	     * @param {Number} objectId - id запрашиваемого объекта
	     * @param {Object} [options] - опции
	     * @param {Boolean} [options.raw=false] - `true` - не обрабатывать ответ с сервера
	     * @param {*} [options.*] - все параметры которые поддерживает сервер
	     * @returns {jQuery.jqXHR}
	     */
	    loadObject: function (layerCode, objectId, options) {
	        var that   = this,
	            url    = that._getUrlWithMapCode(),
	            raw    = false,
	            objUrl = "";
	
	        if ($.type(layerCode) !== 'string') {
	            // TODO: Нужно нормальное описание ошибки.
	            throw new Error('`layerCode` is not String')
	        }
	
	        if ($.type(objectId) !== 'number') {
	            // TODO: Нужно нормальное описание ошибки.
	            throw new Error('`objectId` is not Number')
	        }
	
	        options || (options = {});
	        options = $.extend(true, {}, options);
	
	        if ('raw' in options) {
	            raw = Boolean(options['raw']);
	            delete options['raw'];
	        }
	
	        if (that.token) {
	            options['token'] = that.token
	        }
	        if (that.lng) {
	            options['lng'] = that.lng
	        }
	
	        // TODO: Нужно дописать обработчик fail-а.
	        objUrl = utils.getUrlWithEndSlash(url + 'layers/' + layerCode + '/objects/' + objectId);
	        return $.ajax(objUrl, {
	            crossDomain: true,
	            data       : options
	        }).then(function (obj) {
	            var objId  = obj['id'];
	            var fields = obj['fields'];
	
	            if (raw) {
	                return obj;
	            }
	
	            delete obj['id'];
	            delete obj['fields'];
	
	            obj['layerCode'] = layerCode;
	
	            return new LayerObject(objId, fields, obj);
	        });
	    },
	
	    loadStructure: function (layerCode, options) {
	        var that         = this,
	            url          = that._getUrlWithMapCode(),
	            raw          = false,
	            structureUrl = "";
	
	        if ($.type(layerCode) !== 'string') {
	            // TODO: Нужно нормальное описание ошибки.
	            throw new Error('`layerCode` is not String')
	        }
	
	
	        options || (options = {});
	        options = $.extend(true, {}, options);
	
	        if ('raw' in options) {
	            raw = Boolean(options['raw']);
	            delete options['raw'];
	        }
	
	        if (that.token) {
	            options['token'] = that.token;
	        }
	        if (that.lng) {
	            options['lng'] = that.lng;
	        }
	
	        if (that.objects_editable) {
	            options['with_access'] = 1;
	        }
	
	        // TODO: Нужно дописать обработчик fail-а.
	        structureUrl = utils.getUrlWithEndSlash(url + 'layers/' + layerCode + '/structure/');
	        return $.ajax(structureUrl, {
	            crossDomain: true,
	            data       : options
	        }).then(function (structure) {
	            return structure;
	        });
	    },
	
	    loadLegend: function (layerCode) {
	        var that    = this,
	            url     = that._getUrlWithMapCode(),
	            legendUrl,
	            options = {};
	
	        if ($.type(layerCode) !== 'string') {
	            // TODO: Нужно нормальное описание ошибки.
	            throw new Error('`layerCode` is not String')
	        }
	
	        if (that.token) {
	            options['token'] = that.token
	        }
	        if (that.lng) {
	            options['lng'] = that.lng
	        }
	
	        legendUrl = utils.getUrlWithEndSlash(url + 'layers/' + layerCode + '/legend/');
	
	        return $.ajax(legendUrl, {
	            crossDomain: true,
	            data       : options
	        }).then(function (legend) {
	            return legend;
	        });
	    },
	
	    loadMap: function(options){
	        var that = this,
	            url  = that._getUrlWithMapCode(),
	            raw  = false;
	
	        options || (options = {});
	        options = $.extend(true, {}, options);
	
	        if ('raw' in options) {
	            raw = Boolean(options['raw']);
	            delete options['raw'];
	        }
	
	        if (that.token) {
	            options['token'] = that.token
	        }
	        if (that.lng) {
	            options['lng'] = that.lng
	        }
	
	        return $.ajax(url, {
	                "crossDomain": true,
	                "data"       : options
	            })
	            .then(function (response) {
	                if (raw) return this;
	
	                return createContainer(response, {project: that})
	            });
	    },
	
	    deleteObject: function(layer_code, object_id) {
	        var that = this;
	
	        var options = {};
	
	        if (that.token) {
	            options['token'] = that.token;
	        } else {
	            throw new Error('Для выполнения этого действия нужен токен');
	        }
	
	        var delete_url = (
	            that._getUrlWithMapCode() + 'layers/' + layer_code 
	            + '/objects/' + object_id + '/' + '?token=' + that.token
	        );
	
	        return $.ajax({
	            method: "DELETE",
	            url: delete_url,
	            data: options
	        });
	    },
	
	    updateObject: function(layer_code, object_id, opt_update_data, opt_update_geom) {
	        var that = this;
	        var options = {};
	
	        if (that.token) {
	            options['token'] = that.token;
	        } else {
	            throw new Error('Для выполнения этого действия нужен токен');
	        }
	
	        var update_url = (
	            that._getUrlWithMapCode() + 'layers/' + layer_code 
	            + '/objects/' + object_id + '/' + '?token=' + that.token
	        );
	
	        var data = {};
	        if (opt_update_data) {
	            data['fields'] = opt_update_data;
	        }
	
	        // Геометрия может прийти null. В таком случае ее надо слать на сервер
	        // Т.к. это почти наверняка означает что геометрию очистили и ее больше нет
	        if (opt_update_geom !== undefined) {
	            data['geom'] = opt_update_geom;
	        }
	
	        return $.ajax({
	            method: "PUT",
	            url: update_url,
	            contentType : 'application/json',
	            data: JSON.stringify(data)
	        });
	    },
	
	    createObject: function(layer_code, object_attributes, opt_geom) {
	        var that = this;
	
	        var options = {};
	        opt_geom = opt_geom || false;
	
	        if (that.token) {
	            options['token'] = that.token;
	        } else {
	            throw new Error('Для выполнения этого действия нужен токен');
	        }
	
	        var create_url = (
	            that._getUrlWithMapCode() + 'layers/' + layer_code + '/objects/?token=' + that.token
	        );
	
	        var post_data = {
	            fields: object_attributes,
	        };
	        if (opt_geom) {
	            post_data['geom'] = opt_geom;
	        }
	
	        return $.ajax({
	            method: "POST",
	            url: create_url,
	            contentType : 'application/json',
	            data: JSON.stringify(post_data),
	        }).then(function(object_json) {
	            var layer_object = new LayerObject(
	                object_json.id,
	                object_json.fields,
	                {
	                    bbox: object_json.bbox,
	                    geom: object_json.geom
	                }
	            );
	
	            return $.Deferred().resolve(layer_object);
	        });
	    },
	
	    deleteFileFromObject: function(
	        layer_code, 
	        object_id, 
	        field_code, 
	        file_id
	    ) {
	        var that = this;
	
	        var options = {
	            field: field_code
	        };
	
	        if (that.token) {
	            options['token'] = that.token;
	        } else {
	            throw new Error('Для выполнения этого действия нужен токен');
	        }
	
	        var delete_url = (
	            that._getUrlWithMapCode() + 
	            'layers/' + layer_code 
	            + '/objects/'+ object_id 
	            + '/files/'+ file_id +'/'
	        );
	
	        return $.ajax({
	            method: "DELETE",
	            url: delete_url,
	            data: options
	        });
	    },
	
	    uploadFileToObject: function(
	        layer_code,
	        object_id,
	        field_code, 
	        file_object, 
	        opt_additional_data
	    ) {
	        var that = this;
	        opt_additional_data = opt_additional_data || {};
	
	        var form_data = new FormData();
	
	        if (that.token) {
	            form_data.append('token', that.token);
	        } else {
	            throw new Error('Для выполнения этого действия нужен токен');
	        }
	
	        form_data.append('file', file_object);
	        form_data.append('field', field_code);
	
	        var url = that._getUrlWithMapCode() 
	            + "/layers/"+ layer_code 
	            + "/objects/"+ object_id +"/files/"
	 
	        $.each(opt_additional_data, function(key, value) {
	            form_data.append(key, value);
	        });
	
	        return $.ajax({
	            type: 'POST',
	            url: url,
	            data: form_data,
	            processData: false,
	            cache: false,
	            contentType: false
	        });
	    }
	});
	
	module.exports = Project;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var Collection = __webpack_require__(8),
	    Container  = __webpack_require__(13),
	    $          = __webpack_require__(3),
	    Layer      = __webpack_require__(14);
	
	var ContainersCollection = Collection.extend({
	
	    /**
	     *
	     */
	    loadObjects: function(options){
	        var that      = this,
	            layers    = that.filter(function(cont){
	                return (cont instanceof Layer)
	            }),
	            deferreds = [],
	            objects = new Collection();
	
	        if(options && 'raw' in options){
	            delete options['raw']
	        }
	
	        layers.each(function(layer){
	            deferreds.push(layer.loadObjects(options));
	        });
	
	        return $.when.apply(window, deferreds).then(function(){
	            layers.each(function(layer){
	                objects.add(layer.objects.getArray())
	            });
	
	            return objects;
	        })
	    },
	
	    /**
	     *
	     */
	    add: function(objects){
	        var that = this,
	            _objects,
	            i;
	
	        _objects = $.isArray(objects) ? objects : [objects];
	
	        for (i in _objects) {
	            if (_objects[i] && _objects[i] instanceof Container) {
	                that._items.push(_objects[i]);
	            }
	        }
	        return that;
	    }
	});
	
	module.exports = ContainersCollection;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var Model = __webpack_require__(7);
	var Project = __webpack_require__(11);
	var Events = __webpack_require__(6);
	
	var Container = Model.extend({
	
	    includes: Events,
	
	    options: {
	        project: undefined
	    },
	
	    initialize: function(){
	        var that = this;
	        Container.__super__.initialize.apply(that, arguments);
	
	        // TODO: Возможно это стоит перенести в класс слоя.
	        // Контейнер нельзя инициализировать без проекта.
	        if(!(that.options['project'] instanceof Project)){
	            throw new Error('Project is required to initialize container');
	        }
	
	        that.project = that.options['project'];
	    },
	
	    set: function(attr, value, silent) {
	        var that = this;
	        var attrsHash = JSON.stringify(that._attributes);
	
	        if (_.isObject(attr)) {
	            silent = value;
	        }
	
	        Container.__super__.set.call(that, attr, value);
	
	        if (that.project && !silent) {
	            that.project.fire('containerSet', {
	                container: that
	            });
	
	            if (attrsHash !== JSON.stringify(that._attributes)) {
	                that.project.fire('containerChanged', {
	                    container: that
	                });
	            }
	        }
	    }
	});
	
	module.exports = Container;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var Container = __webpack_require__(13);
	var Collection = __webpack_require__(8);
	
	var Layer = Container.extend({
	
	    initialize: function(){
	        var that = this;
	        that.objects = new Collection();
	        Layer.__super__.initialize.apply(that, arguments);
	    },
	
	    loadObjects: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        if('raw' in options){
	            delete options['raw']
	        }
	        return that.project.loadObjects(that.get('code'), options).then(function(objects){
	            that.objects.reset(objects.getArray());
	            return that.objects;
	        })
	    },
	
	    loadObject: function(objectId, options){
	        var that = this;
	        options || (options = {});
	        if('raw' in options){
	            delete options['raw']
	        }
	        return that.project.loadObject(that.get('code'), objectId, options)
	    }
	});
	
	module.exports = Layer;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var Layer = __webpack_require__(14),
	    $     = __webpack_require__(3),
	    _     = __webpack_require__(16);
	
	var legendTypes = {
	    1:'thematic',
	    2:'category',
	    3:'bubble',
	    4:'PieChart',
	    5:'BarChart',
	    6:'LineChart',
	    7:'heat'
	};
	
	var Visualization = Layer.extend({
	
	    initialize: function () {
	        var that     = this;
	        that._legend = false;
	        Visualization.__super__.initialize.apply(that, arguments);
	    },
	
	    /**
	     * Загружает информацию легенды визуализации
	     *
	     * @method getLegend
	     * @return {jQuery.Promise}
	     */
	    getLegend: function () {
	        var that = this;
	
	        return $.when()
	            .then(function () {
	                if (!that._legend) {
	                    return that.project.loadLegend(that.get('code'))
	                        .then(function (legend) {
	                            if(_.isEmpty(legend)){
	                                return $.Deferred().reject();
	                            }
	                            legend['type'] = legendTypes[legend['type']];
	                            that._legend = legend;
	                            return that._legend;
	                        })
	                }
	
	                return that._legend;
	            });
	    }
	});
	
	module.exports = Visualization;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var Model = __webpack_require__(7),
	    $     = __webpack_require__(3);
	
	var LayerObject = Model.extend({
	
	    options: {},
	
	    initialize: function(id, fields, options){
	        var that = this,
	            bbox;
	
	        options || (options = {});
	
	        if(id === undefined){
	            throw new Error('Id is required')
	        }
	
	        that.id = parseInt(id);
	
	        that._bbox = null;
	
	        that._geometry = null;
	
	        if($.isPlainObject(options['bbox'])){
	            bbox = options['bbox'];
	            if('sw' in bbox && 'ne' in bbox){
	                that.setBBox(bbox['sw'], bbox['ne']);
	            }
	            delete options['bbox'];
	        }
	
	        if($.isPlainObject(options['geom'])){
	            that.setGeometry(options['geom']);
	            delete options['geom'];
	        }
	
	        LayerObject.__super__.initialize.call(that, fields, options);
	    },
	
	    fget: function(attribute){
	        var that = this;
	        if("#"+attribute in that._attributes){
	            return that.get("#"+attribute);
	        }
	        return that.get(attribute)
	    },
	
	    getId: function(){
	        return this.id
	    },
	
	    getGeometry: function(){
	        return this._geometry;
	    },
	
	    setGeometry: function(geometry){
	        this._geometry = geometry;
	        return this;
	    },
	
	    getBBox: function(){
	        return this._bbox;
	    },
	
	    setBBox: function(sw, ne){
	        var that = this;
	        if($.isArray(sw) && $.isArray(ne)){
	            that._bbox = {
	                sw: sw,
	                ne: ne
	            };
	        }
	        return that;
	    }
	});
	
	module.exports = LayerObject;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	var C = {};
	
	C.TILE_LAYER = "tile";
	C.VECTOR_LAYER = "vector";
	C.OMS_VECTOR_LAYER = "oms_vector";
	C.OMS_CATEGORY_LAYER = "oms_vector_category";
	C.OMS_CHARTS_LAYER = "oms_chart_layer";
	C.OMS_VECTOR_FEATURE_LAYER = "oms_vector_feature";
	C.OMS_MVT_LAYER = "oms_mvt";
	
	C.TILE_LAYER_IDS = {};
	C.TILE_LAYER_IDS[C.TILE_LAYER] = 0;
	
	C.VECTOR_LAYER_IDS = {};
	C.VECTOR_LAYER_IDS[C.VECTOR_LAYER] = 1;
	C.VECTOR_LAYER_IDS[C.OMS_VECTOR_LAYER] = 2;
	C.VECTOR_LAYER_IDS[C.OMS_CATEGORY_LAYER] = 3;
	C.VECTOR_LAYER_IDS[C.OMS_CHARTS_LAYER] = 4;
	
	C.BASES_TYPES = [
	    'OMS',
	    'PUBLIC_SERVICE',
	    'XYZ',
	    'WMS'
	];
	
	C.CONT_TYPES = {
	    'map': 1,
	    'folder': 2,
	    'layers': 3,
	    'virtual': 4,
	    'raster': 5,
	    'material': 7
	};
	
	module.exports = C;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(3),
	    Project = __webpack_require__(11),
	    View    = __webpack_require__(20); 
	
	/**
	 *
	 * @param element
	 * @param config
	 * @param options
	 * @return {View}
	 */
	module.exports = function(element, config, options){
	    var configReady = $.Deferred(),
	        doc_ready = $.Deferred(),
	        project,
	        view;
	
	    $(doc_ready.resolve);
	
	    if($.type(config) === 'string') {
	        if (!~config.indexOf("config.json")) {
	            config += "config.json";
	        }
	
	        config += "?ver=v_" + omjs.version.replace('.', '_');
	        if(options && options.token){
	            config += '&token=' + options.token
	        }
	        configReady = $.getJSON(config);
	    } else if($.isPlainObject(config)) {
	        configReady.resolve([config]);
	    } else {
	        throw new TypeError('Config should be `string` or plain object')
	    }
	
	    options || (options = {});
	
	    return $.when(configReady, doc_ready).then(function(confResponse){
	        var cfg,
	            projectConf = {},
	            confObject;
	
	        confObject = confResponse[0];
	        if (!$.isPlainObject(confObject)) {
	            return $.Deferred().reject("Config is not a plain object");
	        }
	
	        cfg = $.extend(true, {}, confObject, options);
	
	        // Create config for project instance
	        projectConf['apiUrl'] = cfg['apiUrl'];
	        projectConf['mapCode'] = cfg['mapCode'];
	        projectConf['tilesUrl'] = cfg['tilesUrl'];
	        projectConf['styleUrl'] = cfg['styleUrl'];
	
	        projectConf['token'] = cfg['token'];
	        projectConf['lng'] = cfg['lng'];
	        projectConf['objects_editable'] = cfg['objects_editable'];
	        if(cfg['token']){
	            delete cfg['token'];
	        }
	
	
	        // Remove project options from config
	        delete cfg['apiUrl'];
	        delete cfg['mapCode'];
	
	        // Create project
	        project = new Project(projectConf);
	
	        // У просмотрщиков есть зависимость от опции tilesUrl именно у view.
	        cfg['tilesUrl'] = project.options['tilesUrl'];
	        cfg['styleUrl'] = project.options['styleUrl'];
	        // Create view
	        view = new View(element, project, cfg);
	
	        return view;
	    });
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var C                   = __webpack_require__(18),
	    Class               = __webpack_require__(4),
	    $                   = __webpack_require__(3),
	    Utils               = __webpack_require__(5),
	    BaseLayer           = __webpack_require__(21),
	    LayerCollection     = __webpack_require__(40),
	    Layer               = __webpack_require__(41),
	    TileLayer           = __webpack_require__(42),
	    VectorLayer         = __webpack_require__(44),
	    OmsVectorLayer      = __webpack_require__(45),
	    OmsVectorFeatureLayer   = __webpack_require__(46),
	    OmsMVTLayer         = __webpack_require__(49),
	    OmsCategoryLayer    = __webpack_require__(52),
	    OmsChartsLayer      = __webpack_require__(53),
	    WidgetManager       = __webpack_require__(198),
	    Measurement         = __webpack_require__(228),
	    PublicMapDraw       = __webpack_require__(230),
	    GenericGeometryEditor = __webpack_require__(235),
	    ol                  = __webpack_require__(22),
	    MarkerLayer         = __webpack_require__(236),
	    TileCounter         = __webpack_require__(237),
	    Lang                = __webpack_require__(238);
	
	var _ = __webpack_require__(16);
	window._ = _;
	window.ol = ol;
	
	var layerTypes = [
	    "tile",
	    "vector",
	    "oms_vector",
	    "oms_vector_category",
	    "oms_chart_layer",
	    "oms_vector_feature",
	    "oms_mvt"
	];
	
	var View = Class.extend({
	
	    includes: [
	        __webpack_require__(6),
	        __webpack_require__(242)
	    ],
	
	    /**
	     *
	     */
	    options: {
	        show               : true,
	        publication: {
	            map_position: {
	                zoom               : 2,
	                min_zoom            : 1,
	                max_zoom            : 30,
	                // center             : [37.6155600, 55.7522200]
	                center             : [4187344.9851, 7509246.96669]
	            }
	        },
	        misc_data: {
	            objects_counter_style: {}
	        }
	        // centerProj         : 'EPSG:4326'
	    },
	
	    /**
	     *
	     */
	    _project: undefined,
	
	    /**
	     *
	     */
	    _map: undefined,
	
	
	    /**
	     *
	     * @param element
	     * @param project
	     * @param options
	     */
	    initialize: function(element, project, options){
	        var that = this,
	            baseLayerCfg;
	
	        if(!project || !element){
	            throw new Error("Bad arguments set for view initialization");
	        }
	
	        that._element = $(element);
	        that._element.css('opacity', '0');
	
	        // TODO нигде не используется, проверить и удалить гада
	        that._visiblePLayers = [];
	        that._utfIgnoreClick = false;
	        that._utfIgnoreClickTimer = 0;
	
	        that._project = project;
	        that._pLayerList = false;
	        that._elements = {};
	
	        that.isTouch      = Utils.isTouch();
	        that.webglEnabled = Utils.webglEnabled();
	
	        that._layers = new LayerCollection(that);
	        that._layersForInteractions = {};
	        that._markerLayers = new LayerCollection(that);
	
	        that._widgetManager = new WidgetManager(that, [], {});
	
	        that._http_prefix = (window.location.protocol != "https:") ? 'http:' : 'https:';
	
	        that.Lang = new Lang({
	            lng: that._project.lng,
	            translations: options.translations || {}
	        });
	
	        that.setOptions(options);
	
	        that._setupPublicationConfig();
	
	        baseLayerCfg = $.extend({}, that.options.publication, {
	            urlTemplate : that.getProject().options['tilesUrl'],
	            mapboxStyleUrlTemplate: that.getProject().options['styleUrl'].replace('{map_code}', that.getProject().options['mapCode'])
	        });
	
	        that._createHtmlStruct($(element));
	
	        that.getParams = that._parseLocationQuery();
	
	        var pinchZoom = new ol.interaction.PinchZoom({
	            constrainResolution: true
	        });
	
	
	        var publication = that.options.publication,
	            mapPosition = publication.map_position;
	        // Пользовательское начальное смещение карты
	        if (publication.map_position_manual){
	            mapPosition = $.extend(true, {}, mapPosition, publication.map_position_manual);
	        }
	
	        that._map = new ol.Map({
	            target      : that._elements.mapContainer,
	            layers      : [],
	            view        : new ol.View({
	                center: mapPosition.center,
	                zoom: mapPosition.zoom,
	                maxZoom: mapPosition.max_zoom,
	                minZoom: mapPosition.min_zoom,
	                zoomFactor: 2
	            }),
	            controls: [new ol.control.Attribution({
	                collapsible: false
	            })],
	
	            interactions: (
	                window.location.search.indexOf("nozoom") != -1)
	                    ? ol.interaction.defaults({mouseWheelZoom:false})
	                    : ol.interaction.defaults({altShiftDragRotate:false, pinchRotate:false, pinchZoom: false})
	                        .extend([
	                            new ol.interaction.OMJSMouseWheelZoom({duration: 190}),
	                            pinchZoom
	                        ])
	        });
	
	        if (!that.isTouch) {
	            ol.events.listen(
	                that.getMap().getTargetElement(),
	                'contextmenu',
	                function(event){
	                    event = new ol.MapBrowserEvent(
	                        'contextmenu',
	                        that.getMap(),
	                        event,
	                        false,
	                        that.getMap().frameState_
	                    );
	                    that.fire('finish_drawing', event);
	                    event.preventDefault();
	                }
	            );
	        }
	
	
	        // interactions: ol.interaction.defaults({pinchZoom: false}).extend([
	        //     new ol.interaction.PinchZoom({
	        //         constrainResolution: true // force zooming to a integer zoom
	        //     })
	        // ]),
	
	        if(!that.options.show){
	            that.hide();
	        }
	
	        that._baseLayer = new BaseLayer(that, baseLayerCfg, that._elements['container']);
	
	        that._measurement = new Measurement(that._map, that, {});
	
	        that._publicMapDraw = new PublicMapDraw(that._map);
	
	        that._genericGeometryEditor = new GenericGeometryEditor(that._map)
	
	        that._setMapInteractions();
	
	        that.getMap().addLayer(that._baseLayer.olLayer);
	        that.getMap().addLayer(that._layers._olLayersGroup);
	        that.getMap().addLayer(that._markerLayers._olLayersGroup);
	        that._markerLayers.add(new MarkerLayer({
	            'group': 'default'
	        }));
	
	        // Инициализируем счётчик тайлов для OMS Extention
	        if($('html').attr("omsExt") == 'true'){
	            new TileCounter(that);
	        }
	    },
	
	    _setPadding: function(mapPosition) {
	        var that = this;
	
	        if (mapPosition.padding) {
	            setTimeout(function () {
	                var center = mapPosition.center;
	
	                that.getMap().getView().fit(
	                    center.concat(center),
	                    {
	                        maxZoom: mapPosition.zoom,
	                        size: that.getMap().getSize(),
	                        padding: mapPosition.padding
	                    }
	                );
	
	                that._element.css('opacity', '1');
	            }, 0);
	        }
	        else {
	            that._element.css('opacity', '1');
	        }
	    },
	
	    _setupPublicationConfig: function () {
	        var that = this,
	            i;
	        if(!that.webglEnabled){
	            for(i in that.options.publication['base_maps']){
	                if(that.options.publication['base_maps'][i]['vector']){
	                    that.options.publication['base_maps'][i]['vector'] = false;
	                    // Ставим метку о том, что эта подложка должна была быть векторной.
	                    that.options.publication['base_maps'][i]['should_be_vector'] = true;
	                }
	            }
	        }
	
	        return that;
	    },
	
	    _setMapInteractions: function(){
	        var that = this;
	
	        var selected = {
	            layer  : false,
	            feature: false
	        };
	
	        that._map.on(['click', 'dblclick', 'pointermove', 'singleclick'], function(evt){
	            var hasFeatureAtPixel;
	
	            try{
	                hasFeatureAtPixel = that._map.hasFeatureAtPixel(evt.pixel, function(candidate){
	                    var omjsLayer = candidate.get('omjsLayer');
	                    return omjsLayer && omjsLayer.hasEventListeners(evt.type);
	                    // return true;
	                });
	            }catch(e){
	                hasFeatureAtPixel = false;
	            }
	
	            if (hasFeatureAtPixel) {
	                var layerAndFeature = that._map.forEachFeatureAtPixel(
	                    evt.pixel,
	                    function(feature, layer){
	                        if (layer) {
	                            var omjsLayer = layer.get('omjsLayer');
	                            if (omjsLayer && (
	                                omjsLayer instanceof omjs.View.VectorLayer ||
	                                omjsLayer instanceof omjs.View.ImageLayer ||
	                                omjsLayer instanceof omjs.View.MVTLayer
	                                )) {
	                                return {
	                                    layer: omjsLayer,
	                                    feature: feature
	                                };
	                            }
	                        }
	                    }
	                );
	
	                if (layerAndFeature) {
	                    if (evt.type == 'click' || evt.type == 'singleclick' || evt.type == 'dblclick') {
	                        //на touch устройствах click проходит по всему пирогу и надо предотвратить срабатывание
	                        // click по utfgrid, если клик был по векторному объекту
	                        that._utfIgnoreClick = true;
	                        clearTimeout(that._utfIgnoreClickTimer);
	                        that._utfIgnoreClickTimer = setTimeout(function(){
	                            that._utfIgnoreClick = false;
	                        }, 100);
	                    }
	
	                    layerAndFeature['layer'].fire(evt.type, {
	                        feature: layerAndFeature['feature'],
	                        olEvent: evt
	                    });
	
	                    if(evt.type == 'pointermove' && omjs.ol.events.condition.mouseOnly(evt)){
	                        if(selected['feature'] != layerAndFeature['feature']){
	                            if(selected['feature']){
	                                selected['layer'].fire('pointerleave', {
	                                    feature: selected['feature'],
	                                    olEvent: evt
	                                });
	                            }
	                            selected = layerAndFeature;
	                            selected['layer'].fire('pointerenter', {
	                                feature: selected['feature'],
	                                olEvent: evt
	                            });
	                        }
	                    }
	                }
	            }else{
	                if(evt.type == 'pointermove' && selected['feature']){
	                    selected['layer'].fire('pointerleave', {
	                        feature: selected['feature'],
	                        olEvent: evt
	                    });
	
	                    selected['feature'] = selected['layer'] = false;
	                }
	            }
	        })
	    },
	
	    /**
	     *
	     * @private
	     */
	    _createHtmlStruct: function(container){
	        var that = this,
	            classes;
	
	        if(container.length !== 1){
	            throw new Error('Bad element for view initialization');
	        }
	
	        that._elements['container'] = container[0];
	        that._elements['mapContainer'] = document.createElement('div');
	        that._elements['mapContainer'].className = 'omjs-map-container';
	        that._elements['container'].appendChild(that._elements['mapContainer']);
	
	        classes = Utils.splitWords(that._elements['container'].className);
	        if(!~classes.indexOf('omjs-container')){
	            classes.push('omjs-container');
	            that._elements['container'].className = classes.join(" ");
	        }
	    },
	
	    /**
	     *
	     */
	    getContainer: function(){
	        return $(this._elements['container']);
	    },
	
	    /**
	     *
	     */
	    getMap: function(){
	        return this._map;
	    },
	
	    /**
	     *
	     */
	    getProject: function(){
	        return this._project;
	    },
	
	    /**
	     *
	     */
	    getLayers: function(){
	        return this._layers;
	    },
	
	    /**
	     *
	     */
	    getWidgetManager: function(){
	        return this._widgetManager;
	    },
	
	    /**
	     *
	     */
	    show: function(){
	        var that = this;
	
	        $(that._elements.container).removeClass('hidden');
	        return that;
	    },
	
	    /**
	     *
	     */
	    hide: function(){
	        var that = this;
	
	        $(that._elements.container).addClass('hidden');
	        return that;
	    },
	
	    /**
	     *
	     * @param layerCode
	     * @param options
	     */
	    addLayer: function(layerCode, options){
	        var that      = this,
	            loading   = $.Deferred(),
	            pLayers,
	            layerType = "tile",
	            newLayer  = {},
	            mapCode = that._project.options.mapCode;
	
	        options = options || {};
	
	        if('layerType' in options && ~layerTypes.indexOf(options['layerType'])){
	            layerType = options['layerType'];
	        }
	        // Если это уже слой view просто добавляем его и валим отсюда
	        // TODO возможно нужна более жесткая проверка - что мы пытаемся добавить
	        if (layerCode instanceof Layer) {
	            that.getLayers().add(layerCode);
	            loading.resolve(newLayer);
	            return loading;
	        } else if (layerCode instanceof ol.layer.Base) {
	            newLayer = new Layer({});
	            newLayer.setMapLayer(layerCode);
	            that.getLayers().add(newLayer);
	            loading.resolve(newLayer);
	            return loading;
	        } else {
	            if(layerType == C.TILE_LAYER){
	                options.urlTemplate = that.getProject().options['tilesUrl'];
	                options.mapCode = mapCode;
	                newLayer = new TileLayer(options);
	            } else if (layerType == C.VECTOR_LAYER) {
	                options.returnGeom = '1';
	                options.geomSR = '3857';
	                newLayer = new VectorLayer(options);
	            } else if (layerType == C.OMS_VECTOR_LAYER) {
	                options.returnGeom = '1';
	                options.geomCentroid = '1';
	                options.geomSR = '3857';
	                newLayer = new OmsVectorLayer(options);
	            } else if (layerType == C.OMS_CATEGORY_LAYER) {
	                options.returnGeom = '1';
	                options.geomCentroid = '1';
	                options.geomSR = '3857';
	                newLayer = new OmsCategoryLayer(options);
	            } else if (layerType == C.OMS_CHARTS_LAYER) {
	                options.returnGeom = '1';
	                options.geomCentroid = '1';
	                options.geomSR = '3857';
	                newLayer = new OmsChartsLayer(options);
	            } else if(layerType == C.OMS_VECTOR_FEATURE_LAYER) {
	                options.returnGeom = '1';
	                options.geomSR = '3857';
	                options.urlTemplate = that.getProject().options['apiUrl'];
	                options.mapCode = mapCode;
	                newLayer = new OmsVectorFeatureLayer(options);
	            } else if(layerType == C.OMS_MVT_LAYER){
	                options.urlTemplate = that.getProject().options['tilesUrl'];
	                options.mapCode = mapCode;
	                newLayer = new OmsMVTLayer(options);
	            }
	            that.getLayers().add(newLayer);
	
	        }
	        // TODO тут какое то ... 0_o. Нужно решить правильно ли это!!!
	        // Загружаем список слоёв
	
	        /* Denis:
	         Для чего мы тут грузим список слоёв?
	         Ведь достаточно загрузить только один слой не?
	         Если это для гибридного тайлового слоя - нужно лучше подумать, как сделать лучше.
	         */
	
	        // if (!that._pLayerList) {
	        //     loading = that.getProject().loadLayers();
	        // } else {
	        //     loading.resolve(that._pLayerList);
	        // }
	
	        // Настраиваем слой после загрузки списка слоёв.
	        return that.getProject().getLayers().then(function(layerList){
	            var codes = Utils.splitWords(layerCode);
	            var defe = $.Deferred();
	            if(!that._pLayerList){
	                that._pLayerList = layerList;
	            }
	
	            pLayers = that._pLayerList.filter(function(l){
	                return Boolean(~codes.indexOf(l.get('code')));
	            });
	            // Если слой векторный то нужно еще загрузить объекты
	
	            if(layerType in C.VECTOR_LAYER_IDS){
	                if (pLayers.at(0)) {
	                    if (pLayers.at(0).get('render_type') == 1) {
	                        that._mergeNecessaryFields(pLayers.at(0), options.fields).done(function(fields){
	                            options.fields = fields;
	                            if (layerType == 'oms_chart_layer' && !pLayers.at(0).get('selected')) {
	                                newLayer.loadOptions = options;
	                                defe.resolve(pLayers);
	                            }
	                            pLayers.at(0).loadObjects(options).then(function () {
	                                defe.resolve(pLayers);
	                            });
	                        });
	                    }
	                }
	            }else {
	                defe.resolve(pLayers);
	            }
	            return defe;
	        }).then(function(pLayer){
	            return newLayer._setup({projectLayers: pLayer});
	        }).fail(function(){
	            that.removeLayer(newLayer);
	        });
	    },
	
	
	    _mergeNecessaryFields: function(projectLayer, fields) {
	        var res= [];
	        var that = this;
	        that.newArray = [];
	        var def = $.Deferred();
	        projectLayer.project.loadStructure(projectLayer.get('code')).then(function(arr) {
	            if (projectLayer.get('vectorSettings') && projectLayer.get('vectorSettings').showPopup) {
	                res.push(projectLayer.get('vectorSettings')['popupColumnCode']);
	            }
	            $.each(arr, function (id, elem) {
	                if(projectLayer.get("visualSettings")) {
	                    if(projectLayer.get("visualSettings").classesSettings.columns) {
	                        $.each(projectLayer.get("visualSettings").classesSettings.columns, function (sort, column) {
	                            if (elem.id == column.id) {
	                                that.newArray[sort] = elem.code;
	                                res.push(elem.code);
	                                if (projectLayer.get('style_mode') == 3) {
	                                    res.push(projectLayer.get('visualSettings')['columnCode']);
	
	                                    if (~[4, 5, 6].indexOf(projectLayer.get("visualSettings").type)) {
	                                        if (projectLayer.get("visualSettings").classesSettings.sizeType == 3) {
	                                            res.push(elem.sizeColumnCode);
	                                        }
	                                    }
	
	                                    //для загрузки колонки с текстом
	                                    if (projectLayer.get("visualSettings").showText) {
	                                        res.push(elem.code);
	                                    }
	                                }
	                            }
	                        });
	                    }
	                    if (projectLayer.get("visualSettings").showText) {
	                        res.push(elem.code);
	                    }
	                    if(projectLayer.get("visualSettings").classesSettings.classes) {
	                        var column = projectLayer.get("visualSettings").column;
	                        if (column == elem.id) {
	                            res.push(elem.code);
	                        }
	                    }
	                }
	            });
	            if (projectLayer.get("render_type") != 1) {
	                return res;
	            }
	
	            if (projectLayer.get('vectorSettings').showPopup) {
	                res.push(projectLayer.get('vectorSettings')['popupColumnCode']);
	            }
	
	            if (fields) {
	                if (typeof fields == 'string') {
	                    fields = [fields];
	                }
	            } else {
	                fields = [];
	            }
	
	            fields = fields.concat(res);
	            fields = _.uniq(fields);
	            def.resolve(fields);
	            return fields;
	        });
	        return def;
	    },
	
	    /**
	     *
	     */
	    removeLayer: function(layer){
	        var that = this;
	
	        that.getLayers().remove(layer);
	        return that;
	    },
	
	    /**
	     *
	     */
	    getBaseLayer: function(){
	        return this._baseLayer;
	    },
	
	    /**
	     *
	     */
	    _getBaseInfoById: function(id){
	        var that = this,
	            i;
	
	        for (i in that.options.publication.base_maps) {
	            if (that.options.publication.base_maps[i].id == id) {
	                return that.options.publication.base_maps[i];
	            }
	        }
	        return false;
	    },
	
	    /**
	     *
	     */
	    switchBaseLayer: function(baseId){
	        var that = this,
	            baseMaps = that.options.publication['base_maps'],
	            baseMap;
	
	        // *************************************************************
	        // Встречаем новую логику переключения подл...?, нет, чего то...
	        // *************************************************************
	
	        baseMap = that._getBaseInfoById(baseId);
	        if (!baseMap) {
	            return;
	        }
	
	        if (baseMaps && baseMaps.length > 0) {
	            // Переключаем слой с подложками но не с тайловыми подложками OMS
	            that._baseLayer.switchTo(baseId);
	
	            if (baseMap.type == 'OMS' && !baseMap.vector) {
	                // Всетаки не прокатило
	                that._showOmsBases(baseMap);
	                that._baseLayer.fire('layerChanged', {'layerName': baseMap.id});
	            } else {
	                that._hideOmsBases();
	            }
	        }
	    },
	
	    /**
	     * Метод тушит любую подложку OMS в любом режиме отображения
	     * @private
	     */
	    _hideOmsBases: function(){
	        var that = this,
	            i,
	            mapLayer,
	            commonLayer,
	            codesForHide = [];
	
	        that._layers.each(function(l){
	            if (l.options.baseId != undefined) {
	                l.hide();
	            }
	            if (l.options.commonLayer) {
	                commonLayer = l;
	            }
	        });
	
	        if (commonLayer) {
	            for ( i in that._mapLayersInfo) {
	                mapLayer = that._mapLayersInfo[i];
	                if (mapLayer.baseId) {
	                    codesForHide = codesForHide.concat(mapLayer.activeLayers);
	                }
	            }
	            if (codesForHide.length > 0) {
	                commonLayer.deactivateLayers(codesForHide);
	                if(!commonLayer.getActiveLayerCodes().length){
	                    commonLayer.hide();
	                }
	            }
	        }
	    },
	
	    _showOmsBases: function(baseMap){
	        var that = this,
	            commonLayer,
	            mapLayer,
	            i;
	
	        that._hideOmsBases();
	
	        that._layers.each(function(l){
	            if (l.options.baseId == baseMap['container_id']) {
	                l.show();
	            }
	            if (l.options.commonLayer) {
	                commonLayer = l;
	            }
	        });
	
	        if (commonLayer) {
	            for ( i in that._mapLayersInfo) {
	                mapLayer = that._mapLayersInfo[i];
	                if (mapLayer.baseId) {
	                    if (mapLayer.baseId == baseMap['container_id']) {
	                        commonLayer.activateLayers(mapLayer.activeLayers);
	                        if(!commonLayer.isVisible()){
	                            commonLayer.show();
	                        }
	                    }
	                }
	            }
	        }
	    },
	
	    _prepareOmsBases: function(containers){
	        var that = this,
	            omsBases = {},
	            container,
	            childs,
	            baseMapContsMap = {},
	            vectorChilds;
	            /*first = false;*/
	
	        that.options.publication.base_maps.forEach(function(bm, i) {
	            // Если это базовая карта OMS то нужно подготовить ее объект
	            if (bm.type == 'OMS') {
	                container        = containers.filter(function (c) {
	                    return c.get('map_layer_id') == bm['container_id'];
	                }).at(0);
	                if(container && bm['container_id']) {
	                    container.baseId = bm['container_id'];
	
	                    childs = that._getContDescendants(bm['container_id'], containers.getArray());
	
	                    vectorChilds = childs.filter(function (ch) {
	                        return ch.get('render_type') == 1;
	                    });
	                    vectorChilds.forEach(function (vc) {
	                        vc.baseId = bm['container_id'];
	                        vc.options.baseId = bm['container_id'];
	                    });
	
	                    omsBases[bm['container_id']] = {
	                        index: i,
	                        vectorContainers: vectorChilds,
	                        selected: bm['selected'],
	                        isVector: bm['vector']
	                    };
	
	                    // Добавляем ссылку на объект базовой карты всем контейнерам, которые участвуют в базовых картах.
	                    // Нельзя использовать baseId т.к. этот атрибут уже используется с завязкой на то, что он может быть только у векторных слоёв.
	                    // TODO: Не верно определять режим отображения слоя по наличию атрибута baseId. От этой завязки нужно избавляться.
	
	                    container.baseMapRef = omsBases[bm['container_id']];
	                    container.baseMapRefId = bm['container_id'];
	                    container.options.baseMapRef = omsBases[bm['container_id']];
	                    container.options.baseMapRefId = bm['container_id'];
	                    childs.forEach(function (c) {
	                        c.baseMapRef = omsBases[bm['container_id']];
	                        c.baseMapRefId = bm['container_id'];
	                        c.options.baseMapRef = omsBases[bm['container_id']];
	                        c.options.baseMapRefId = bm['container_id'];
	                    });
	
	                    baseMapContsMap[bm.id] = childs.slice();
	                    baseMapContsMap[bm.id].unshift(container);
	                    baseMapContsMap[bm.id] = baseMapContsMap[bm.id]
	                        .filter(function (c) {
	                            return c.get('selected') && c.get('render_type') == 0 && !~['folder', 'raster'].indexOf(c.get('type'));
	                        })
	                        .map(function (c) {
	                            return c.get('map_layer_id');
	                        });
	                }
	            }
	        });
	
	        that.getBaseLayer()._setBaseMapContainers(baseMapContsMap);
	
	        return omsBases;
	    },
	
	
	    _findVectorLayers: function (containers, parent_id) {
	        var that = this,
	            vLayers = [],
	            descLayers;
	
	        descLayers = parent_id
	            ? containers.filter(function (layer) {
	                return layer.get('parent_id') == parent_id;
	            })
	            : containers;
	
	
	        descLayers.each(function (layer) {
	            if (layer.get('type') == 'folder') {
	                var vvlayers = that._findVectorLayers(containers, layer.get('map_layer_id'));
	                vLayers = vLayers.concat(vvlayers);
	            } else {
	                if (layer.get('render_type') == 1) vLayers.push(layer);
	            }
	        });
	        return vLayers;
	    },
	
	    //формируем loader для векторного слоя
	    _createVectorLayerLoader: function (vl, publish_containers, beforeVectorAdd, omsBases) {
	        var that = this,
	            baseLayerInfo,
	            layerType,
	            visibility;
	        // Выясняем тип векторного слоя
	        layerType = C.OMS_VECTOR_LAYER;
	        if (vl.get('style_mode') == 3) {
	            if (vl.get('visualSettings').type == 2) {
	                layerType = C.OMS_CATEGORY_LAYER;
	            } else if (~[4, 5, 6].indexOf(vl.get('visualSettings').type)) {
	                layerType = C.OMS_CHARTS_LAYER;
	            }
	        }
	
	        baseLayerInfo = ('baseId' in vl && vl.baseId != undefined)
	            ? omsBases[vl.baseId]
	            : false;
	
	        visibility = (baseLayerInfo)
	            ? baseLayerInfo.selected
	            : vl.get('selected');
	
	        var isBaseLayer = baseLayerInfo && baseLayerInfo.selected;
	        var isSelected = vl.get('selected');
	        var inPublishLayers = ~publish_containers.pluck('code').indexOf(vl.get('code'));
	        var layerPubConfig = that.options.publication.layers_config.filter(function (conf) {
	            return conf.containerId == vl.get('id');
	        })[0];
	        var fieldsToLoad = [];
	        if (layerPubConfig) {
	            if (layerPubConfig.objectNameAutoChoose) {
	                fieldsToLoad.push('name');
	                fieldsToLoad.push('label');
	            } else {
	                fieldsToLoad.push(layerPubConfig.objectNameColumnCode);
	            }
	        }
	
	        var loadingOptions;
	        if (isBaseLayer || isSelected || inPublishLayers) {
	            loadingOptions = {
	                layerType: layerType,
	                visible: visibility,
	                baseId: vl.baseId,
	                f: 'fjson',
	                fields: fieldsToLoad
	            };
	            if (beforeVectorAdd && typeof beforeVectorAdd === 'function') {
	                loadingOptions = beforeVectorAdd.call(null, vl, loadingOptions)
	            }
	            return that.addLayer(vl.get('code'), loadingOptions);
	        }
	        return null;
	    },
	
	    //формируем mapInfo для растрового слоя
	    _createTileLayerInfo: function (tl, omsBases) {
	        var that = this,
	            activeChilds,
	            mapLayerInfo,
	            contId = tl.get('map_layer_id');
	
	        if (tl.get('map_layer_id') in omsBases) {
	            activeChilds = [tl.get('code')];
	        } else {
	            activeChilds = tl.get('selected') ? [tl.get('code')] : [];
	        }
	        mapLayerInfo = {
	            codes: [tl.get('code')],
	            activeLayers: activeChilds,
	            baseId: contId in omsBases ? contId : undefined,
	            selected: contId in omsBases && omsBases[contId].selected
	        };
	        return mapLayerInfo;
	    },
	
	    //формируем mapInfo для папки
	    _createFolderTileInfo: function (containers, options) {
	        var that = this,
	            mapLayerInfo,
	            contId,
	            childs,
	            activeChilds;
	
	        contId = options.contId;
	        childs = that._getContDescendants(contId, containers.getArray());
	
	        // на случай вызова из однослойного  режима
	        childs = childs.filter(function (ch) {
	            return ch.get('render_type') != 1;
	        });
	
	        activeChilds = childs
	            .filter(function (ch) {
	                return ch.get('selected');
	            })
	            .map(function (ch) {
	                return ch.get('code');
	            });
	        childs = childs.map(function (ch) {
	            return ch.get('code');
	        });
	        if (childs.length) {
	            mapLayerInfo = {
	                codes: childs,
	                activeLayers: activeChilds,
	                baseId: contId in options.omsBases ? contId : undefined,
	                selected: contId in options.omsBases && options.omsBases[contId].selected,
	                layerType: options.view_format_type,
	                tilesQuality: options.tiles_quality
	            };
	        }
	        return mapLayerInfo;
	    },
	
	    //формируем mapInfo для коллекции
	    _createCollectionInfo: function (descLayers, containers, options) {
	        var that = this,
	            mapLayersInfo = [],
	            contId,
	            lcodes = [],
	            acodes = [],
	            folderMapInfo,
	            mapLayer;
	
	        descLayers.each(function (tl) {
	            contId = tl.get('map_layer_id');
	            if (tl.get('type') == 'folder') {
	                folderMapInfo = that._createFolderTileInfo(containers, {
	                    omsBases: options.omsBases,
	                    contId: tl.get('map_layer_id'),
	                    view_format_type: options.view_format_types[tl.get('view_format_type')],
	                    tiles_quality: tl.get('tiles_quality')
	                });
	                if (folderMapInfo) mapLayersInfo.push(folderMapInfo);
	            } else {
	                mapLayersInfo.push(that._createTileLayerInfo(tl, options.omsBases));
	            }
	        });
	
	        for (var i in mapLayersInfo) {
	            mapLayer = mapLayersInfo[i];
	            if (mapLayer.baseId != undefined) {
	                lcodes = lcodes.concat(mapLayer.codes);
	                if (mapLayer.selected) {
	                    acodes = acodes.concat(mapLayer.activeLayers);
	                }
	            } else {
	                lcodes = lcodes.concat(mapLayer.codes);
	                acodes = acodes.concat(mapLayer.activeLayers);
	            }
	        }
	        return {
	            codes: {
	                lcodes: lcodes,
	                acodes: acodes
	            },
	            mapLayersInfo: mapLayersInfo
	        }
	    },
	
	    //формируем лоадеры для слоев по порядку
	    _createLoadersAuto: function (options, containers, parent_id) {
	        var that = this,
	            loaders = [],
	            mapLayersInfo = [],
	            mapLayer,
	            data,
	            descLayers,
	            vLoader,
	            formats = [],
	            value,
	            equal = true,
	            default_params = [0, 1];
	
	        descLayers = containers.filter(function (layer) {
	            return (parent_id > 0)
	                ? layer.get('parent_id') == parent_id
	                : layer.get('parent_id') == 0;
	        });
	
	        var vLayers = that._findVectorLayers(containers, parent_id);
	
	        // в корне при отсутствии векторных слоев проверяем форматы растровых слоев
	        if (parent_id === 0 && vLayers.length == 0) {
	            descLayers.each(function (l) {
	                if (l.get('type') == 'folder') {
	                    value = l.get('view_format_type') + '';
	                    if (l.get('view_format_type') == 0) {
	                        value += '.' + l.get('tiles_quality');
	                    }
	                    formats.push(value);
	                } else {
	                    formats.push('0.1')
	                }
	                default_params = [
	                    l.get('view_format_type') || 0,
	                    l.get('tiles_quality') || 1
	                ]
	            });
	            equal = formats.every(function (value, i, arr) {
	                return value == arr[0];
	            });
	        }
	
	        // если слои в одном формате все приводим к одному слою
	        if (vLayers.length == 0 && equal) {
	
	            if (parent_id > 0) {// если мы во вложенной папке
	                var fLayer = containers._items.filter(function (l) {
	                    return l.get('map_layer_id') == parent_id;
	                })[0];
	                mapLayer = that._createFolderTileInfo(containers, {
	                    omsBases: options.omsBases,
	                    contId: fLayer.get('map_layer_id'),
	                    view_format_type: options.view_format_types[options.view_format_type],
	                    tiles_quality: options.tiles_quality
	                });
	                if (mapLayer) {
	                    mapLayersInfo.push(mapLayer);
	                    loaders.push(that.addLayer(mapLayer.codes.join(' '), {
	                        visible: mapLayer.baseId != undefined ? mapLayer.selected : mapLayer.activeLayers.length > 0,
	                        activeLayers: mapLayer.activeLayers,
	                        projectLayerCodes: mapLayer.codes,
	                        baseId: mapLayer.baseId,
	                        layerType: mapLayer.layerType,
	                        tilesQuality: mapLayer.tilesQuality
	                    }));
	                }
	            } else {// и если мы в корне
	
	                data = that._createCollectionInfo(descLayers, containers, {
	                    omsBases: options.omsBases,
	                    view_format_types: options.view_format_types
	                });
	                loaders.push(that.addLayer(data.codes.lcodes.join(' '), {
	                    activeLayers: data.codes.acodes,
	                    commonLayer: true,
	                    layerType: options.view_format_types[default_params[0]],
	                    tilesQuality: default_params[1]
	                }));
	                mapLayersInfo = data.mapLayersInfo;
	            }
	
	            return {
	                loaders: loaders,
	                mapLayersInfo: mapLayersInfo
	            }
	        }
	
	        // если слои в разном формате раскладываем на слои
	        descLayers.each(function (layer) {
	            if (layer.get('type') == 'folder') { //папка
	                if (parent_id > 0) {
	                    options = $.extend(options, {
	                        view_format_type: options.view_format_type,
	                        tiles_quality: options.tiles_quality
	                    });
	                } else {
	                    options = $.extend(options, {
	                        view_format_type: layer.get('view_format_type'),
	                        tiles_quality: layer.get('tiles_quality')
	                    });
	                }
	                data = that._createLoadersAuto(options, containers, layer.get('map_layer_id'));
	                loaders = loaders.concat(data.loaders);
	                mapLayersInfo = mapLayersInfo.concat(data.mapLayersInfo);
	
	            } else // слой
	            {
	                if (layer.get('render_type') == 1) {//  векторный
	                    vLoader = that._createVectorLayerLoader(layer, options.publish_containers, options.beforeVectorAdd, options.omsBases);
	                    if (vLoader) loaders.push(vLoader);
	                } else { // растровый
	                    mapLayer = that._createTileLayerInfo(layer, options.omsBases);
	                    loaders.push(that.addLayer(mapLayer.codes.join(' '), {
	                        visible: mapLayer.baseId != undefined ? mapLayer.selected : mapLayer.activeLayers.length > 0,
	                        activeLayers: mapLayer.activeLayers,
	                        projectLayerCodes: mapLayer.codes,
	                        baseId: mapLayer.baseId,
	                        layerType: mapLayer.layerType,
	                        tilesQuality: mapLayer.tilesQuality
	                    }));
	                    mapLayersInfo.push(mapLayer);
	                }
	            }
	        });
	
	        return {
	            loaders: loaders,
	            mapLayersInfo: mapLayersInfo
	        };
	    },
	
	    //Новая функция формирования слоев
	    showOMSPublication: function (beforeVectorAdd) {
	        var that = this,
	            omsBases,
	            mapLayersInfo = [],
	            view_format_types = [
	                C.TILE_LAYER,
	                C.OMS_VECTOR_FEATURE_LAYER,
	                C.OMS_MVT_LAYER
	            ];
	
	        // Нужно проставить центр и зум из настроек публикации
	        var publication = that.options.publication,
	            mapPosition = publication.map_position;
	        // Пользовательское начальное смещение карты
	        if (publication.map_position_manual) {
	            mapPosition = $.extend(true, {}, mapPosition, publication.map_position_manual);
	        }
	
	        that._map.getView().setZoom(mapPosition.zoom);
	        that._map.getView().setCenter(mapPosition.center);
	
	        that._setPadding(mapPosition);
	
	        // Прогружаем все контейнеры
	        return that.getProject().loadMap()
	            .then(function (mapContainer) {
	                that._mapContainer = mapContainer;
	                return $.when(that.getProject().getContainers(), that.getProject().getContainers({type: 'publish'}));
	            })
	            .then(function (full_containers, publish_containers) {
	                // Приготовим
	                var master = $.Deferred(),
	                    loaders = [],
	                    containers;
	
	                omsBases = that._prepareOmsBases(full_containers);
	
	                // Поскольку векторные базовые карты отображаются без помощи OL, в этой функции они нам не нужны.
	                // Выбираем контейнеры, которые не участвуют в векторных базовых картах.
	                containers = full_containers.filter(function (c) {
	                    // Контейнер участвует в базовых картах
	                    // Или участвует в не векторной базовой карте
	                    return !('baseMapRef' in c) || !c.baseMapRef.isVector;
	                });
	
	                var data;
	                var options = {
	                    omsBases: omsBases,
	                    publish_containers: publish_containers,
	                    beforeVectorAdd: beforeVectorAdd,
	                    view_format_types: view_format_types
	                };
	
	                containers._items.reverse();
	
	                data = that._createLoadersAuto(options, containers, 0);
	                loaders = data.loaders;
	                mapLayersInfo = data.mapLayersInfo;
	                that._mapLayersInfo = mapLayersInfo;
	
	
	                // TODO: Пахнет жестким костылем
	                if (that._baseLayer.cdr_layer != undefined) {
	                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_layer);
	                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_highlight_layer);
	                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_zouit_highlight_layer);
	                }
	
	
	                $.when.apply($, loaders).then(function () {
	                    master.resolve(true);
	                });
	
	                return master;
	            });
	    },
	
	    //Старая функция формирования слоев
	    __showOMSPublication: function(beforeVectorAdd){
	        var that = this,
	            omsBases,
	            layers,
	            mapLayersInfo = [],
	            childs,
	            activeChilds,
	            mapLayer,
	            i,
	            vectorLayers,
	            layerType,
	            visibility,
	            contId;
	        //that.__showOMSPublication(beforeVectorAdd);
	        // Нужно проставить центр и зум из настроек публикации
	        var publication = that.options.publication,
	            mapPosition = publication.map_position;
	        // Пользовательское начальное смещение карты
	        if (publication.map_position_manual){
	            mapPosition = $.extend(true, {}, mapPosition, publication.map_position_manual);
	        }
	
	        that._map.getView().setZoom(mapPosition.zoom);
	        that._map.getView().setCenter(mapPosition.center);
	
	        that._setPadding(mapPosition);
	
	        // Прогружаем все контейнеры
	        return that.getProject().loadMap()
	            .then(function(mapContainer){
	                that._mapContainer = mapContainer;
	                return $.when(that.getProject().getContainers(), that.getProject().getContainers({type:'publish'}));
	            })
	            .then(function(full_containers, publish_containers){
	                // Приготовим
	                var master = $.Deferred(),
	                    baseLayerInfo,
	                    loaders = [],
	                    containers;
	
	                omsBases = that._prepareOmsBases(full_containers);
	
	                // Поскольку векторные базовые карты отображаются без помощи OL, в этой функции они нам не нужны.
	                // Выбираем контейнеры, которые не участвуют в векторных базовых картах.
	                containers = full_containers.filter(function(c){
	                    // Контейнер участвует в базовых картах
	                    // Или участвует в не векторной базовой карте
	                    return !('baseMapRef' in c) || !c.baseMapRef.isVector;
	                });
	
	                // Все контейнеры в корне, которые рендерятся тайлами.
	                // Для послойного отображения
	                layers = containers.filter(function(c) {
	                    return c.get('parent_id') == 0 && c.get('render_type') !== 1;
	                });
	                layers._items.reverse();
	
	                // Боримся с тайловыми слоями
	                layers.each(function(tl) {
	                    contId = tl.get('map_layer_id');
	
	                    if (tl.get('type') == 'folder') {
	                        childs = that._getContDescendants(tl.get('map_layer_id'), containers.getArray());
	
	                        childs = childs.filter(function(ch){
	                            return ch.get('render_type') != 1;
	                        });
	
	                        activeChilds = childs
	                            .filter(function(ch){
	                                return ch.get('selected');
	                            })
	                            .map(function(ch){
	                                return ch.get('code');
	                            });
	
	                        childs = childs.map(function(ch){
	                            return ch.get('code');
	                        });
	
	                        if (childs.length) {
	                            mapLayersInfo.push({
	                                codes: childs,
	                                activeLayers: activeChilds,
	                                baseId: contId in omsBases ? contId : undefined,
	                                selected: contId in omsBases && omsBases[contId].selected,
	                                layerType: tl.get('view_format_type') == 1
	                                    ? C.OMS_VECTOR_FEATURE_LAYER
	                                    : (
	                                        tl.get('view_format_type') == 2
	                                            ? C.OMS_MVT_LAYER
	                                            : C.TILE_LAYER
	                                ),
	                                tilesQuality: tl.get('tiles_quality')
	                            });
	                        }
	                    } else {
	                        if (tl.get('map_layer_id') in omsBases) {
	                            activeChilds = [tl.get('code')];
	                        } else {
	                            activeChilds = tl.get('selected') ? [tl.get('code')] : [];
	                        }
	                        mapLayersInfo.push({
	                            codes: [tl.get('code')],
	                            activeLayers: activeChilds,
	                            baseId: contId in omsBases ? contId : undefined,
	                            selected: contId in omsBases && omsBases[contId].selected
	                        });
	                    }
	                });
	
	                /** Создаем слои карты */
	                // Послойное отображение
	                if (that._mapContainer.get('group_layers') == 0) {
	                    for (i in mapLayersInfo) {
	                        mapLayer = mapLayersInfo[i];
	                        loaders.push(that.addLayer(mapLayer.codes.join(' '), {
	                            visible: mapLayer.baseId != undefined ? mapLayer.selected : mapLayer.activeLayers.length > 0,
	                            activeLayers: mapLayer.activeLayers,
	                            projectLayerCodes: mapLayer.codes,
	                            baseId: mapLayer.baseId,
	                            layerType: mapLayer.layerType,
	                            tilesQuality: mapLayer.tilesQuality
	                        }));
	                    }
	                } else { // Отображение единым слоем
	                    var lcodes = [];
	                    var acodes = [];
	                    for (i in mapLayersInfo) {
	                        mapLayer = mapLayersInfo[i];
	                        if (mapLayer.baseId != undefined) {
	                            lcodes = lcodes.concat(mapLayer.codes);
	                            if (mapLayer.selected) {
	                                acodes = acodes.concat(mapLayer.activeLayers);
	                            }
	                        } else {
	                            lcodes = lcodes.concat(mapLayer.codes);
	                            acodes = acodes.concat(mapLayer.activeLayers);
	                        }
	                    }
	                    loaders.push(that.addLayer(lcodes.join(' '), {
	                        activeLayers: acodes,
	                        commonLayer: true
	                    }));
	                }
	                that._mapLayersInfo = mapLayersInfo;
	
	                // TODO: Пахнет жестким костылем
	                if (that._baseLayer.cdr_layer != undefined) {
	                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_layer);
	                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_highlight_layer);
	                    that._layers._olLayersGroup.getLayers().push(that._baseLayer.cdr_zouit_highlight_layer);
	                }
	
	                // Нужно отобразить векторные слои в обратном порядке
	                vectorLayers = containers.filter(function(c){
	                    return c.get('render_type') == 1;
	                });
	
	                vectorLayers._items.reverse();
	                vectorLayers.each(function(vl){
	                    // Выясняем тип векторного слоя
	                    layerType = C.OMS_VECTOR_LAYER;
	                    if (vl.get('style_mode') == 3) {
	                        if (vl.get('visualSettings').type == 2){
	                            layerType = C.OMS_CATEGORY_LAYER;
	                        } else if (~[4,5,6].indexOf(vl.get('visualSettings').type)) {
	                            layerType = C.OMS_CHARTS_LAYER;
	                        }
	                    }
	
	                    baseLayerInfo = ('baseId' in vl && vl.baseId != undefined)
	                        ? omsBases[vl.baseId]
	                        : false;
	
	                    visibility = (baseLayerInfo)
	                        ? baseLayerInfo.selected
	                        : vl.get('selected');
	
	                    var isBaseLayer = baseLayerInfo && baseLayerInfo.selected;
	                    var isSelected = vl.get('selected');
	                    var inPublishLayers = ~publish_containers.pluck('code').indexOf(vl.get('code'));
	                    var layerPubConfig = that.options.publication.layers_config.filter(function(conf){
	                        return conf.containerId == vl.get('id');
	                    })[0];
	                    var fieldsToLoad = [];
	                    if(layerPubConfig){
	                        if(layerPubConfig.objectNameAutoChoose){
	                            fieldsToLoad.push('name');
	                            fieldsToLoad.push('label');
	                        }else{
	                            fieldsToLoad.push(layerPubConfig.objectNameColumnCode);
	                        }
	                    }
	
	                    var loadingOptions;
	                    if (isBaseLayer || isSelected || inPublishLayers) {
	                        loadingOptions = {
	                            layerType: layerType,
	                            visible: visibility,
	                            baseId: vl.baseId,
	                            f: 'fjson',
	                            fields: fieldsToLoad
	                        };
	                        if (beforeVectorAdd && typeof beforeVectorAdd === 'function') {
	                            loadingOptions = beforeVectorAdd.call(null, vl, loadingOptions)
	                        }
	                        loaders.push(that.addLayer(vl.get('code'), loadingOptions));
	                    }
	                    //var vLoader = that.createVectorLayerLoader(vl, publish_containers, beforeVectorAdd);
	                    //if (vLoader) loaders.push(vLoader);
	
	                });
	                $.when.apply($, loaders).then(function(){
	                    master.resolve(true);
	                });
	
	                return master;
	            });
	    },
	
	    getActiveProjectLayers: function(){
	        var that = this,
	            ids,
	            activeLayers = [];
	
	        that._layers.getArray().forEach(function(layer){
	            if (!(layer instanceof Layer) || !layer._prjLayers || !layer._prjLayers.getLength()){
	                return;
	            }
	
	            if (layer.isVisible()) {
	                if (layer instanceof TileLayer) {
	                    ids = layer.getSource().getActiveLayers();
	                    if (ids.length) {
	                        activeLayers = activeLayers.concat(layer._prjLayers.getArray().filter(function(player){
	                            return ~ids.indexOf(player.get('map_layer_id')) != 0;
	                        }));
	                    }
	                } else {
	                    activeLayers = activeLayers.concat(layer._prjLayers.getArray());
	                }
	            }
	        });
	
	        return activeLayers;
	    },
	
	    _getContDescendants: function (parent_id, conts) {
	        var that        = this;
	        var descendands = [];
	        for (var i in conts) {
	            if (conts[i].get('parent_id') == parent_id) {
	                if (conts[i].get('type') == 'folder') {
	                    descendands = descendands.concat(that._getContDescendants(conts[i].get('map_layer_id'), conts));
	                } else {
	                    descendands.push(conts[i]);
	                }
	            }
	        }
	
	        return descendands;
	    },
	
	    /**
	     *
	     */
	    getMeasurement: function(){
	        return this._measurement;
	    },
	
	    /**
	     *
	     */
	    getPublicMapDraw: function() {
	        return this._publicMapDraw;
	    },
	
	    getGeometryEditor: function() {
	        return this._genericGeometryEditor;
	    },
	
	    /**
	     *
	     */
	    addMarker: function(coordinates, options){
	        var that = this,
	            _layers,
	            markerLayer;
	
	        options || (options = {});
	        if (options.group == undefined) {
	            options.group = 'default';
	        }
	
	        _layers = that._markerLayers.filter(function(layer){
	            return layer.get('group') == options.group;
	        });
	
	        if (_layers.getLength() == 0) {
	            markerLayer = new MarkerLayer({
	                'group': options.group
	            });
	            that._markerLayers.add(markerLayer);
	        } else {
	            markerLayer = _layers.at(0);
	        }
	
	        return markerLayer.addMarker.call(markerLayer, coordinates, options);
	    },
	
	    /**
	     *
	     */
	    getMarkerGroup: function(name){
	        var that = this;
	
	        if (name === undefined) {
	            name = 'default';
	        }
	        return that._markerLayers.filter(function(l){
	            return l.get('group') == name;
	        }).at(0);
	    },
	
	    _parseLocationQuery: function(){
	        var searchParamsArray, keyvalarr;
	        var searchParamsObject = {};
	        var searchQuery = window.location.search;
	        searchQuery = searchQuery.substr(1, searchQuery.length-1);
	        searchParamsArray = searchQuery.split("&");
	        for (var i = 0; i < searchParamsArray.length; i++) {
	            if (/\w*=\w*/.test(searchParamsArray[i])) {
	                keyvalarr = searchParamsArray[i].split("=");
	                searchParamsObject[keyvalarr[0]] = keyvalarr[1];
	            }
	        }
	        return searchParamsObject;
	    },
	
	    syncWithProject: function(without) {
	        var that = this;
	
	        that._layers.each(function(layer) {
	            if (typeof layer.syncWithProject === 'function') {
	                layer.syncWithProject(without);
	            }
	        });
	    }
	});
	
	module.exports = View;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var Class           = __webpack_require__(4),
	    Utils           = __webpack_require__(5),
	    $               = __webpack_require__(3),
	    Events          = __webpack_require__(6),
	    ol              = __webpack_require__(22),
	    ModalMessage    = __webpack_require__(30),
	    PKK5Source      = __webpack_require__(32),
	    PKK5Source      = __webpack_require__(34),
	    mapboxgl;
	
	var utils = __webpack_require__(5);
	
	var changeContext = function(object, context) {
	    $.each(object, function(name, value) {
	        object[name] = value.bind(context);
	    });
	};
	
	var sourceAliases = {
	    'yandexMap'    : 'yandex#map',
	    'yandexSat'    : 'yandex#satellite',
	    'yandexHybrid' : 'yandex#hybrid',
	    'yandexPublic' : 'yandex#publicMap',
	    'googleRoadmap': 'ROADMAP',
	    'googleSat'    : 'SATELLITE',
	    'googleHybrid' : 'HYBRID',
	    'googleTerrain': 'TERRAIN'
	};
	
	// TODO: Нужно унаследоваться от LayerCollection
	var BaseLayer = Class.extend({
	
	    includes: Events,
	
	    /**
	     *
	     */
	    initialize: function (view, options, container) {
	        var that       = this,
	            initSource = -1,
	            i,
	            baseMap;
	
	        that.view                   = view;
	        that.sources                = {};
	        that.currentSource          = undefined;
	        // Объект с контейнерами OMS, которые участвуют в базовых картах, индексированы по id базовой карты.
	        that._baseMapContaiers      = {};
	        that._baseMapContaiersReady = $.Deferred();
	        that._map                   = view.getMap();
	        that._yaMap                 = false;
	        that._googMap               = false;
	        that._container             = container;
	        that._lastRes               = that._map.getView().getResolution();
	        that._lastZoom              = that._map.getView().getZoom();
	        that._googBaseTimeout       = 0;
	        that._yandexBaseTimeout     = 0;
	        that._mapboxglBaseTimeout   = 0;
	        that.yaContainer            = false;
	        that.googContainer          = false;
	        that.mapboxGlContainer      = false;
	        that._currentMBGLStylesUrl  = '';
	        that._pixelRatio            = Math.round(utils.getDevicePixelRatio());
	
	        $.each(BaseMapSyncHandlers, function(name, value) {
	            changeContext(BaseMapSyncHandlers[name], that);
	        });
	
	        if(that.view.webglEnabled){
	            try{
	                mapboxgl = __webpack_require__(35);
	            }catch(e){
	                that.view.webglEnabled = false;
	            }
	        }
	
	        that._webglFailMessage = false;
	
	        that._webglFailMessage      = new ModalMessage({
	            message: 'Не удалось отобразить базовую карту в векторном режиме ' +
	                     'из-за отсутствия поддержки технологии WebGL',
	            classes: ModalMessage.CLASSES.HIDDEN_CLASS
	        });
	
	        // that._webglFailMessage.hide();
	
	        that.setOptions(options);
	
	        that.olLayer = new ol.layer.Tile({});
	
	        that._createSources();
	
	        if (that.options['base_maps'] && that.options['base_maps'].length > 0) {
	            for (i in that.options['base_maps']) {
	                baseMap = that.options['base_maps'][i];
	                if (baseMap.selected && (baseMap.type != 'OMS' || baseMap.vector || baseMap.should_be_vector) && baseMap.value != 'cadastre') {
	                    that.switchTo(baseMap.id);
	                    initSource = baseMap.id;
	                    break;
	                }
	            }
	        }
	    },
	
	    setup: function () {
	        var that = this;
	        return that;
	    },
	
	    _setBaseMapContainers: function (baseMapContsMap) {
	        var that               = this;
	        that._baseMapContaiers = baseMapContsMap;
	        that._baseMapContaiersReady.resolve(that._baseMapContaiers);
	        return that;
	    },
	
	    _getBaseMapContainers: function () {
	        return this._baseMapContaiersReady;
	    },
	
	    /**
	     *
	     */
	    _createSources: function () {
	        var that = this,
	            url;
	
	        that.options['base_maps'].forEach(function (base, i) {
	            if (base.type == 'OMS') {
	                if (!base.vector) return;
	                that.sources[base.id] = base.container_id + '';
	                if (that.mapboxGlContainer) return;
	                that.mapboxGlContainer           = document.createElement('div');
	                that.mapboxGlContainer.className = 'omjs-map-container omjs-mapboxgl-base';
	                that._container.appendChild(that.mapboxGlContainer);
	            } else {
	                if (base.type == 'PUBLIC_SERVICE') {
	                    if (base.value == 'OSM') {
	                        that.sources[base.id] = new ol.source.OSM({
	                            crossOrigin : "anonymous",
	                            attributions: [
	                                '&nbsp;', // место под иконку
	                                '&copy; ' +
	                                    '<a href="http://www.openstreetmap.org/copyright" target="_blank">'
	                                    + that.view.Lang.translate('Участники OpenStreetMap')
	                                    + '</a>'
	                            ]
	                        });
	                    }
	                    if (base.value == 'ORBISMapBaseMap') {
	                        var xyzUrl = "https://maps.orbismap.ru/base.png?x={x}&y={-y}&z={z}";
	                        var tilePixelRatio = 1;
	                        if (that._pixelRatio > 1) {
	                            xyzUrl += '&retina=' + that._pixelRatio;
	                            tilePixelRatio = that._pixelRatio;
	                        }
	                        that.sources[base.id] = new ol.source.XYZ({
	                            crossOrigin: "anonymous",
	                            url        : xyzUrl,
	                            tilePixelRatio: tilePixelRatio
	                        });
	                    }
	                    if (~base.value.indexOf('yandex') || ~base.value.indexOf('google')) {
	                        that.sources[base.id] = base.value;
	                        if (~base.value.indexOf('yandex') && !that.yaContainer) {
	                            that.yaContainer           = document.createElement('div');
	                            that.yaContainer.className = 'omjs-map-container omjs-yandex-base';
	                            that._container.appendChild(that.yaContainer);
	                        }
	                        if (~base.value.indexOf('google') && !that.googContainer) {
	                            that.googContainer           = document.createElement('div');
	                            that.googContainer.className = 'omjs-map-container omjs-google-base';
	                            that._container.appendChild(that.googContainer);
	                        }
	                    }
	
	                    if (base.value == 'cadastre') {
	                        that.cdr_layer = new ol.layer.Tile({
	                            source: new ol.source.PKK5ArcGISSource({
	                                url        : 'https://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/Cadastre/MapServer',
	                                crossOrigin: 'anonymous'
	                            }),
	                            visible: false
	                        });
	
	                        that.cdr_highlight_layer = new ol.layer.Tile({
	                            source: new ol.source.PKK5ArcGISHighlightSource({
	                                url        : 'https://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/CadastreSelected/MapServer',
	                                crossOrigin: 'anonymous'
	                            }),
	                            opacity: 0.7,
	                            visible: false
	                        });
	
	                        that.cdr_zouit_highlight_layer = new ol.layer.Tile({
	                            source: new ol.source.PKK5ArcGISHighlightSource({
	                                url        : 'https://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/ZONESSelected/MapServer',
	                                crossOrigin: 'anonymous'
	                            }),
	                            opacity: 0.7,
	                            visible: false
	                        });
	                    }
	                } else if (base.type === 'XYZ') {
	                    var rPixelRatio = /\{pixelratio([&?][^=]*)?=([^}]+)\}/;
	                    var res = base.value.match(rPixelRatio);
	                    var replacer = '';
	                    var xValues;
	                    var xVar = '';
	                    var xVal;
	                    var xyzUrl = base.value;
	                    var tilePixelRatio = 1;
	                    if (res) {
	                        if (res.length === 3) {
	                            if (res[1]) {
	                                xVar += res[1] + '=';
	                            }
	                            xValues = res[2].split(',');
	                        } else {
	                            xValues = res[1].split(',');
	                        }
	
	                        if (that._pixelRatio === 1) {
	                            xVal = xValues[that._pixelRatio-1];
	                        } else {
	                            for ( var n = that._pixelRatio -1; n > 0; n--) {
	                                xVal = xValues[n];
	                                if (xVal && xVal.trim() !== '') {
	                                    tilePixelRatio = n + 1;
	                                    break;
	                                }
	                            }
	                        }
	
	                        if (xVal && xVal.trim() !== "") {
	                            replacer = xVar + xVal;
	                        }
	                        xyzUrl = xyzUrl.replace(res[0], replacer);
	                    }
	
	                    that.sources[base.id] = new ol.source.XYZ({
	                        crossOrigin: "anonymous",
	                        url        : xyzUrl,
	                        tilePixelRatio: tilePixelRatio
	                    });
	                } else if (base.type == 'WMS') {
	                    var wmsJson = JSON.parse(base.value);
	                    url         = wmsJson['url'];
	                    delete wmsJson['url'];
	
	                    that.sources[base.id] = new ol.source.TileWMS({
	                        crossOrigin: "anonymous",
	                        url        : url,
	                        params     : wmsJson
	                    });
	                } else if (base.type == 'ARCGIS') {
	                    var arcGisJson = JSON.parse(base.value);
	                    url            = arcGisJson['url'];
	                    delete arcGisJson['url'];
	
	                    that.sources[base.id] = new ol.source.TileArcGISRest({
	                        crossOrigin: "anonymous",
	                        url        : url,
	                        params     : arcGisJson
	                    });
	                }
	            }
	        });
	
	        return that;
	    },
	
	    /**
	     *
	     */
	    switchTo: function (sourceId) {
	        var that    = this,
	            changed = false,
	            source,
	            i;
	
	        for (i in that.options.base_maps) {
	            if (that.options.base_maps[i]['id'] == sourceId && that.options.base_maps[i]['should_be_vector']) {
	                that.view.getWidgetManager().addWidget(that._webglFailMessage);
	                that._webglFailMessage.once('hide', function(){
	                    that.view.getWidgetManager().removeWidget(that._webglFailMessage);
	                });
	                that._webglFailMessage.show();
	            }
	        }
	
	
	        if (that.currentSource == sourceId) {
	            return;
	        }
	
	        source = that.sources[sourceId];
	
	        if (!source) {
	            $(that._container).find('.omjs-map-container').removeClass('no-background');
	            that.hide();
	            that.currentSource = undefined;
	            return that;
	        } else {
	            that.show();
	        }
	
	        if (typeof source !== 'string') {
	            $(that._container).find('.omjs-map-container').removeClass('no-background');
	            that.olLayer.setSource(source);
	            changed = true;
	
	            that.olLayer.setVisible(true);
	
	            $(that._container).find('.ol-scale-line').css('bottom', 8);
	
	            that.hideGoogMap();
	            that.hideYaMap();
	            that.hideMapboxGlMap();
	
	            that._map
	                .getInteractions()
	                .forEach(function (interaction) {
	                    if (
	                        (interaction instanceof omjs.ol.interaction.PinchRotate) ||
	                        (interaction instanceof omjs.ol.interaction.DragRotate)
	                    ) {
	                        interaction.setActive(true)
	                    }
	                });
	        } else {
	            that._map
	                .getInteractions()
	                .forEach(function (interaction) {
	                    if (
	                        (interaction instanceof omjs.ol.interaction.PinchRotate) ||
	                        (interaction instanceof omjs.ol.interaction.DragRotate)
	                    ) {
	                        interaction.setActive(false)
	                    }
	                });
	            that._map.getView().setRotation(0);
	
	            that.olLayer.setVisible(false);
	            $(that._container).find('.omjs-map-container').addClass('no-background');
	            $(that._container).find('.ol-scale-line').css('bottom', 21);
	
	            if (~source.indexOf('yandex')) {
	                that.hideGoogMap();
	                that.initYaMap()
	                    .done(function () {
	                        that.showYaMap(source)
	                    });
	                changed = true;
	            } else if (~source.indexOf('google')) {
	                that.hideYaMap();
	                that.initGoogMap()
	                    .done(function () {
	                        that.showGoogMap(source)
	                    });
	                changed = true;
	            } else {
	                that.hideGoogMap();
	                that.hideYaMap();
	                that._getBaseMapContainers()
	                    .done(function () {
	                        that.initMapboxGlMap(sourceId);
	                        that.showMapboxGlMap(sourceId);
	                    });
	
	                changed = true;
	            }
	        }
	
	        if (changed) {
	            that.currentSource = sourceId;
	            that.fire('layerChanged', {'layerName': that.currentSource});
	        }
	
	        return that;
	    },
	
	    /**
	     *
	     */
	    show: function () {
	        var that = this,
	            source;
	
	        source = that.sources[that.currentSource];
	
	        if (typeof source !== 'string') {
	            that.olLayer.setVisible(true);
	            $(that._container).find('.ol-scale-line').css('bottom', 8);
	        } else {
	            $(that._container).find('.ol-scale-line').css('bottom', 21);
	            if (~source.indexOf('yandex')) {
	                that.showYaMap(source)
	            } else if (~source.indexOf('google')) {
	                that.showGoogMap(source)
	            } else {
	                that._getBaseMapContainers()
	                    .done(function () {
	                        that.showMapboxGlMap(source)
	                    })
	            }
	        }
	
	        return that;
	    },
	
	    /**
	     *
	     */
	    hide: function () {
	        var that = this,
	            source;
	
	        source = that.sources[that.currentSource];
	
	        if (typeof source !== 'string') {
	            that.olLayer.setVisible(false);
	            $(that._container).find('.ol-scale-line').css('bottom', 21);
	        } else {
	            $(that._container).find('.ol-scale-line').css('bottom', 8);
	            that.hideYaMap();
	            that.hideGoogMap();
	            that.hideMapboxGlMap();
	        }
	
	        return that;
	    },
	
	    initYaMap: function () {
	        var that = this;
	        var def  = $.Deferred();
	        var ymapsApi;
	
	        // Яндекс карты ещё не инициализированы
	        if (window.ymaps === undefined) {
	            // Создаём и добавляем скрипт, который подгрузит на яндекс карты
	            ymapsApi = document.createElement('script');
	            $('head').append(ymapsApi);
	            // Как только скрипт загрузится, API яндекс карт будет доступен
	            ymapsApi.onload = function () {
	                ymapsApi.onload = void(0);
	                // API доступен, но нужно дождаться загрузки внутренних ресурсов яндекса
	                window.ymaps.ready(function () {
	                    // Дождались всего, можно инициализировать саму карту
	                    def.resolve()
	                })
	            };
	
	            ymapsApi.onerror = function () {
	                ymapsApi.onerror = void(0);
	                def.reject()
	            };
	
	            ymapsApi.setAttribute('type', 'text/javascript');
	            // Начинаем загрузку скрипта
	            ymapsApi.src = '//api-maps.yandex.ru/2.1/?lang=ru_RU';
	        } else {
	            def.resolve()
	        }
	
	        return def
	            .then(function () {
	                // Если яндекс карта уже была инициализирована - ничего не делаем.
	                if (that._yaMap) return true;
	
	                that.yaContainer.style.display = "block";
	                // Как только API яндекс карт полностью инициализируется, мы можем инициализировать яндекс карту
	                var view                       = that._map.getView();
	                var center                     = view.getCenter();
	                center                         = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	
	                that._yaMap = new ymaps.Map(that.yaContainer, {
	                    center  : [center[1], center[0]],
	                    zoom    : view.getZoom(),
	                    controls: []
	                }, {
	                    suppressMapOpenBlock: true,
	                    avoidFractionalZoom: false
	                });
	                return true;
	            });
	    },
	
	    showYaMap: function (layerName) {
	        var that      = this;
	        var view      = that._map.getView();
	        var center    = view.getCenter();
	        var layerType = layerName in sourceAliases ? sourceAliases[layerName] : 'yandex#map';
	        center        = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	
	        that.yaContainer.style.display = "block";
	
	        that._map.un('precompose', BaseMapSyncHandlers.yandex.syncCenter);
	        that._map.getView().un('change:resolution', BaseMapSyncHandlers.yandex.syncZoom);
	        that._map.un('change:size', BaseMapSyncHandlers.yandex.syncSize);
	
	        that._yaMap.container.fitToViewport();
	        that._yaMap.setType(layerType);
	        that._yaMap.setCenter([center[1], center[0]], view.getZoom());
	
	        $(that.yaContainer)
	            .find('ymaps[class$="copyrights-pane"]')
	            .appendTo(that._map.getTargetElement());
	
	        $(that._container).find('ymaps[class$="copyrights-pane"]').show();
	
	        that._lastRes = that._map.getView().getResolution();
	
	        that._map.on('precompose', BaseMapSyncHandlers.yandex.syncCenter);
	        that._map.getView().on('change:resolution', BaseMapSyncHandlers.yandex.syncZoom);
	        that._map.on('change:size', BaseMapSyncHandlers.yandex.syncSize);
	
	        return that;
	    },
	
	    hideYaMap: function () {
	        var that = this;
	        that._map.un('precompose', BaseMapSyncHandlers.yandex.syncCenter);
	        that._map.getView().un('change:resolution', BaseMapSyncHandlers.yandex.syncZoom);
	        that._map.un('change:size', BaseMapSyncHandlers.yandex.syncSize);
	        if (that.yaContainer) {
	            that.yaContainer.style.display = "none";
	            $(that._container).find('ymaps[class$="copyrights-pane"]').hide();
	        }
	
	        return that;
	    },
	
	    initGoogMap: function () {
	        var that = this,
	            layerType,
	            googleApi,
	            def  = $.Deferred();
	
	        if (window.google === undefined) {
	            googleApi = document.createElement('script');
	            $('head').append(googleApi);
	            googleApi.onload = function () {
	                googleApi.onload = void(0);
	                google.load("maps", "3", {
	                    callback: function () {
	                        def.resolve()
	                    },
	                    other_params : 'key=' + that.view.options.google_maps_api_key
	                });
	
	            };
	
	            googleApi.onerror = function () {
	                googleApi.onload = void(0);
	                def.reject()
	            };
	
	            googleApi.src = 'https://www.google.com/jsapi';
	        } else {
	            def.resolve();
	        }
	
	        return def
	            .then(function () {
	                if (that._googMap) return true;
	                var view     = that._map.getView();
	                var center   = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
	                var goCenter = new google.maps.LatLng(center[1], center[0]);
	
	                var mapOptions = {
	                    zoom                  : view.getZoom(),
	                    center                : goCenter,
	                    animatedZoom          : false,
	                    disableDefaultUI      : true,
	                    keyboardShortcuts     : false,
	                    draggable             : false,
	                    disableDoubleClickZoom: true,
	                    scrollwheel           : false,
	                    streetViewControl     : false,
	                    mapTypeId             : google.maps.MapTypeId[layerType]
	                };
	
	                that.googContainer.style.display = "block";
	
	                that._googMap = new google.maps.Map(that.googContainer, mapOptions);
	
	                setTimeout(function () {
	                    $(that.googContainer).find('.gm-style > div:eq(1)').addClass('googlecopy').appendTo(that._map.getTargetElement());
	                    $(that.googContainer).find('.gm-style > .gm-style-cc').addClass('googlecopy').appendTo(that._map.getTargetElement());
	                    $(that.googContainer).find('.gm-style > .gmnoprint').addClass('googlecopy').appendTo(that._map.getTargetElement());
	                    $(that._container).find('.ol-scale-line').css('bottom', 21);
	                }, 1000);
	
	                view.on('change:resolution', BaseMapSyncHandlers.google.restrictZoom);
	
	                return true;
	            });
	    },
	
	    showGoogMap: function (layerName) {
	        var that      = this;
	        var view      = that._map.getView();
	        var center    = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
	        var goCenter  = new google.maps.LatLng(center[1], center[0]);
	        var layerType = layerName in sourceAliases ? sourceAliases[layerName] : 'ROADMAP';
	
	        if (view.getZoom() > 19) {
	            return that.hideGoogMap();
	        }
	
	        that.googContainer.style.display = "block";
	
	        that._map.un('precompose', BaseMapSyncHandlers.google.syncCenter);
	        view.un('change:resolution', BaseMapSyncHandlers.google.syncZoom);
	        that._map.un('change:size', BaseMapSyncHandlers.google.syncSize);
	
	        google.maps.event.trigger(that._googMap, 'resize');
	
	        that._googMap.setOptions({
	            zoom  : view.getZoom(),
	            center: goCenter
	        });
	        that._googMap.setMapTypeId(google.maps.MapTypeId[layerType]);
	
	        $(that._container).find('.googlecopy').show();
	
	        that._map.on('precompose', BaseMapSyncHandlers.google.syncCenter);
	        view.on('change:resolution', BaseMapSyncHandlers.google.syncZoom);
	
	        // При каждм ресайзе OL карты нужно обновлять состояние Google Карт. Иначе получаем рассинхрон.
	        that._map.on('change:size', BaseMapSyncHandlers.google.syncSize);
	
	        return that;
	    },
	
	    hideGoogMap: function () {
	        var that = this;
	        var view = that._map.getView();
	        that._map.un('precompose', BaseMapSyncHandlers.google.syncCenter);
	        view.un('change:resolution', BaseMapSyncHandlers.google.syncZoom);
	        that._map.un('change:size', BaseMapSyncHandlers.google.syncSize);
	        if (that.googContainer) {
	            that.googContainer.style.display = "none";
	            $(that._container).find('.googlecopy').hide();
	        }
	
	        return that;
	    },
	
	    initMapboxGlMap: function (baseMapId) {
	        var that     = this;
	        var cont_ids = that._baseMapContaiers[baseMapId];
	        var view     = that._map.getView();
	        var center   = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
	        if (that._glMap || !cont_ids || !cont_ids.length) return that;
	        that._currentMBGLStylesUrl = that.options['mapboxStyleUrlTemplate'].replace('{layers}', cont_ids.join(','));
	
	        // mapboxgl.accessToken = 'pk.eyJ1IjoiY3J1ZWxzaWxlbmNlIiwiYSI6Imx5MHJ3S00ifQ.sRd76jrMWJxIc_UPG5tPkA';
	        mapboxgl.accessToken           = 'dumb';
	        that._glMap                    = new mapboxgl.Map({
	            container            : that.mapboxGlContainer,
	            preserveDrawingBuffer: true,
	            style                : that._currentMBGLStylesUrl,
	            interactive          : false,
	            attributionControl   : false,
	            zoom                 : view.getZoom() - 1,
	            center               : center,
	            trackResize          : false,
	            maxBounds            : null
	        });
	        // Убираем ограничение на pan
	        that._glMap.transform.latRange = null;
	    },
	
	    showMapboxGlMap: function (baseMapId) {
	        var that     = this;
	        var cont_ids = that._baseMapContaiers[baseMapId];
	        var view     = that._map.getView();
	        var center   = view.getCenter();
	        var stylesUrl;
	        if (!cont_ids || !cont_ids.length) return that;
	        center = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	
	        that.mapboxGlContainer.style.display = "block";
	
	        stylesUrl = that.options['mapboxStyleUrlTemplate'].replace('{layers}', cont_ids.join(','));
	
	        if (that._currentMBGLStylesUrl != stylesUrl) {
	            that._currentMBGLStylesUrl = stylesUrl;
	            that._glMap.setStyle(that._currentMBGLStylesUrl);
	        }
	
	        that._glMap.resize();
	
	        that._map.un('precompose', BaseMapSyncHandlers.mapboxgl.syncPosition);
	        that._map.un('change:size', BaseMapSyncHandlers.mapboxgl.syncSize);
	        that._map.getView().un('change:resolution', BaseMapSyncHandlers.mapboxgl.restrictZoom);
	
	
	        if (isNaN(center[0])) {
	            center = [0, 0]
	        }
	        that._glMap.transform.zoom   = view.getZoom() - 1;
	        that._glMap.transform.center = mapboxgl.LngLat.convert(center);
	
	        that._glMap._render();
	
	        that._map.on('precompose', BaseMapSyncHandlers.mapboxgl.syncPosition);
	        that._map.on('change:size', BaseMapSyncHandlers.mapboxgl.syncSize);
	        that._map.getView().on('change:resolution', BaseMapSyncHandlers.mapboxgl.restrictZoom);
	
	        BaseMapSyncHandlers.mapboxgl.restrictZoom.call(that);
	
	        return that;
	    },
	
	    hideMapboxGlMap: function () {
	        var that = this;
	        that._map.un('precompose', BaseMapSyncHandlers.mapboxgl.syncPosition);
	        that._map.un('change:size', BaseMapSyncHandlers.mapboxgl.syncSize);
	        that._map.getView().un('change:resolution', BaseMapSyncHandlers.mapboxgl.restrictZoom);
	        if (that.mapboxGlContainer) {
	            that.mapboxGlContainer.style.display = "none";
	        }
	
	        return that;
	    },
	
	    highlightCadastreFeature: function(feature_id) {
	        var that = this;
	        if (that.cdr_layer && that.cdr_layer.getVisible()) {
	
	            var zouid_regex = /^\d+\.\d+\.\d+/;
	
	            if (feature_id !== null) {
	
	                if (zouid_regex.exec(feature_id)) {
	                    // Если просят подсветить ЗОУИД, то включаем слой для подсветки ЗОУИД,
	                    // отключаем слой для подсветки обычных объектов
	                    if (that.cdr_highlight_layer.getVisible()) {
	                        that.cdr_highlight_layer.setVisible(false);
	                    }
	                    if (!that.cdr_zouit_highlight_layer.getVisible()) {
	                        that.cdr_zouit_highlight_layer.setVisible(true);
	                    }
	
	                    // Выставляем фичу слою для подсветки ЗОУИДов
	                    that.cdr_zouit_highlight_layer
	                        .getSource()
	                        .setSelectedFeature(feature_id);
	
	                    // Сбрасываем подсветку для обычных фич
	                    that.cdr_highlight_layer
	                        .getSource()
	                        .setSelectedFeature(null);
	
	                } else {
	                    // Если просят подсветить обычную фичу, то включаем слой для
	                    // подсветки фич и отключаем слой для подсветки ЗОУИДов
	                    if (!that.cdr_highlight_layer.getVisible()) {
	                        that.cdr_highlight_layer.setVisible(true);
	                    }
	                    if (that.cdr_zouit_highlight_layer.getVisible()) {
	                        that.cdr_zouit_highlight_layer.setVisible(false);
	                    }
	
	                    // Выставляем фичу слою для подсветки обычных фич
	                    that.cdr_highlight_layer
	                        .getSource()
	                        .setSelectedFeature(feature_id);
	
	                    // Сбарсываем подсветку для ЗОУИДов
	                    that.cdr_zouit_highlight_layer
	                        .getSource()
	                        .setSelectedFeature(null);
	
	                }
	            } else {
	                that.cdr_highlight_layer.setVisible(false);
	                that.cdr_zouit_highlight_layer.setVisible(false);
	                that.cdr_highlight_layer.getSource().emptyCache();
	            }
	        }
	    }
	
	});
	
	
	
	
	
	var BaseMapSyncHandlers = {
	    "yandex"  : {
	        "syncCenter": function (e) {
	            var that     = this;
	            var center   = ol.proj.transform(e.frameState.viewState.center, 'EPSG:3857', 'EPSG:4326');
	
	            that._yaMap.setCenter([center[1], center[0]], that._map.getView().getZoom(),{
	                checkZoomRange: false
	            });
	        },
	
	        "syncZoom": function (e) {
	
	        },
	
	        "syncSize": function () {
	            var that   = this;
	            var center = that._map.getView().getCenter();
	            center     = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	
	            that._yaMap.container.fitToViewport();
	            that._yaMap.setCenter([center[1], center[0]], that._map.getView().getZoom());
	        }
	    },
	    "google"  : {
	        "syncCenter": function (e) {
	            var that     = this;
	            var startRes = that._lastRes;
	            var endRes   = that._map.getView().getResolution();
	
	            if (startRes == endRes) {
	                var center = ol.proj.transform(e.frameState.viewState.center, 'EPSG:3857', 'EPSG:4326');
	                that._googMap.setCenter(new google.maps.LatLng(center[1], center[0]));
	            }
	
	            clearTimeout(that._googBaseTimeout);
	            that._googBaseTimeout = setTimeout(function () {
	                that._lastRes = that._map.getView().getResolution();
	            }, 50)
	        },
	
	        "syncZoom": function () {
	            var that   = this;
	            var center = that._map.getView().getCenter();
	            center     = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	            that._googMap.setOptions({
	                zoom  : that._map.getView().getZoom(),
	                center: new google.maps.LatLng(center[1], center[0])
	            });
	        },
	
	        "syncSize": function () {
	            var that   = this;
	            var center = that._map.getView().getCenter();
	            center     = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326');
	
	            google.maps.event.trigger(that._googMap, 'resize');
	
	            that._googMap.setOptions({
	                zoom  : that._map.getView().getZoom(),
	                center: new google.maps.LatLng(center[1], center[0])
	            });
	        },
	
	        "restrictZoom": function () {
	            var that          = this;
	            var currentSource = that.sources[that.currentSource];
	            if (typeof currentSource != 'string' || !~currentSource.indexOf('goog')) return;
	
	            var googleIsShown    = that.googContainer.style.display == "block";
	            var googleIsHidden   = !googleIsShown;
	            var needToHideGoogle = that._map.getView().getZoom() > 19;
	            var needToShowGoogle = !needToHideGoogle;
	
	            if (googleIsShown && needToHideGoogle) { // Если гуглокарта отображена и мы перешли за 19 зум
	                // Скрываем гуглокарту
	                that.hideGoogMap();
	            } else if (googleIsHidden && needToShowGoogle) { // Если гуглокарта не отображена и зум у нас меньше 20
	                // Отображаем гуглокарту
	                that.showGoogMap(currentSource);
	            }
	        }
	    },
	    "mapboxgl": {
	        "syncPosition": function (e) {
	            var zoom;
	            var center;
	            var that        = this;
	            var newZoom;
	            var updateStyle = false;
	            that._glMap.stop();
	            center = ol.proj.transform(e.frameState.viewState.center, 'EPSG:3857', 'EPSG:4326');
	            zoom   = Utils.getZoomFromResolution(e.frameState.viewState.resolution);
	
	            if (isNaN(center[0])) {
	                center = [0, 0]
	            }
	
	            that._glMap._omsLastZoom = that._glMap.transform.zoom;
	            newZoom                  = zoom - 1;
	            if (Math.round(that._glMap._omsLastZoom) != newZoom) {
	                updateStyle = true;
	            }
	
	            that._glMap.transform.zoom   = zoom - 1;
	            that._glMap.transform.center = mapboxgl.LngLat.convert(center);
	
	            that._glMap._render();
	            clearTimeout(that._mapboxglBaseTimeout);
	            that._mapboxglBaseTimeout = setTimeout(function () {
	                // that._glMap._update()
	                that._glMap._update(updateStyle);
	                that._glMap.animationLoop.set(300);
	                that._glMap._rerender();
	            }, 50);
	
	        },
	        "syncSize"    : function () {
	            var that   = this;
	            var view   = that._map.getView();
	            var center = ol.proj.transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
	            that._glMap.resize();
	
	            that._glMap.transform.zoom   = view.getZoom() - 1;
	            that._glMap.transform.center = mapboxgl.LngLat.convert(center);
	
	            that._glMap._render();
	        },
	
	        "restrictZoom": function () {
	            var that = this;
	            if (that._map.getView().getZoom() > 21) {
	                that._map.getView().setZoom(21);
	            }
	        }
	    }
	};
	
	
	module.exports = BaseLayer;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	__webpack_require__(24);
	__webpack_require__(25);
	__webpack_require__(26);
	__webpack_require__(27);
	__webpack_require__(28);
	__webpack_require__(29);
	
	module.exports = ol;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/**
	 * @module ol/util
	 */
	
	/**
	 * @return {?} Any return.
	 */
	function abstract() {
	  return /** @type {?} */ ((function() {
	    throw new Error('Unimplemented abstract method.');
	  })());
	}
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * Usage:
	 *
	 *     function ParentClass(a, b) { }
	 *     ParentClass.prototype.foo = function(a) { }
	 *
	 *     function ChildClass(a, b, c) {
	 *       // Call parent constructor
	 *       ParentClass.call(this, a, b);
	 *     }
	 *     inherits(ChildClass, ParentClass);
	 *
	 *     var child = new ChildClass('a', 'b', 'see');
	 *     child.foo(); // This works.
	 *
	 * @param {!Function} childCtor Child constructor.
	 * @param {!Function} parentCtor Parent constructor.
	 * @function module:ol.inherits
	 * @deprecated
	 * @api
	 */
	function inherits(childCtor, parentCtor) {
	  childCtor.prototype = Object.create(parentCtor.prototype);
	  childCtor.prototype.constructor = childCtor;
	}
	
	/**
	 * Counter for getUid.
	 * @type {number}
	 * @private
	 */
	var uidCounter_ = 0;
	
	/**
	 * Gets a unique ID for an object. This mutates the object so that further calls
	 * with the same object as a parameter returns the same value. Unique IDs are generated
	 * as a strictly increasing sequence. Adapted from goog.getUid.
	 *
	 * @param {Object} obj The object to get the unique ID for.
	 * @return {string} The unique ID for the object.
	 * @function module:ol.getUid
	 * @api
	 */
	function getUid(obj) {
	  return obj.ol_uid || (obj.ol_uid = String(++uidCounter_));
	}
	
	/**
	 * OpenLayers version.
	 * @type {string}
	 */
	var VERSION = '5.3.0';
	
	/**
	 * @module ol/AssertionError
	 */
	
	/**
	 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
	 * extended with a `code` property.
	 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
	 */
	var AssertionError = /*@__PURE__*/(function (Error) {
	  function AssertionError(code) {
	    var path = 'v' + VERSION.split('-')[0];
	    var message = 'Assertion failed. See https://openlayers.org/en/' + path +
	    '/doc/errors/#' + code + ' for details.';
	
	    Error.call(this, message);
	
	    /**
	     * Error code. The meaning of the code can be found on
	     * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
	     * the version found in the OpenLayers script's header comment if a version
	     * other than the latest is used).
	     * @type {number}
	     * @api
	     */
	    this.code = code;
	
	    /**
	     * @type {string}
	     */
	    this.name = 'AssertionError';
	
	    // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40
	    this.message = message;
	  }
	
	  if ( Error ) { AssertionError.__proto__ = Error; }
	  AssertionError.prototype = Object.create( Error && Error.prototype );
	  AssertionError.prototype.constructor = AssertionError;
	
	  return AssertionError;
	}(Error));
	
	/**
	 * @module ol/CollectionEventType
	 */
	
	/**
	 * @enum {string}
	 */
	var CollectionEventType = {
	  /**
	   * Triggered when an item is added to the collection.
	   * @event module:ol/Collection.CollectionEvent#add
	   * @api
	   */
	  ADD: 'add',
	  /**
	   * Triggered when an item is removed from the collection.
	   * @event module:ol/Collection.CollectionEvent#remove
	   * @api
	   */
	  REMOVE: 'remove'
	};
	
	/**
	 * @module ol/ObjectEventType
	 */
	
	/**
	 * @enum {string}
	 */
	var ObjectEventType = {
	  /**
	   * Triggered when a property is changed.
	   * @event module:ol/Object.ObjectEvent#propertychange
	   * @api
	   */
	  PROPERTYCHANGE: 'propertychange'
	};
	
	/**
	 * @module ol/obj
	 */
	
	
	/**
	 * Polyfill for Object.assign().  Assigns enumerable and own properties from
	 * one or more source objects to a target object.
	 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
	 *
	 * @param {!Object} target The target object.
	 * @param {...Object} var_sources The source object(s).
	 * @api
	 * @return {!Object} The modified target object.
	 */
	var assign = (typeof Object.assign === 'function') ? Object.assign : function(target, var_sources) {
	  var arguments$1 = arguments;
	
	  if (target === undefined || target === null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  for (var i = 1, ii = arguments.length; i < ii; ++i) {
	    var source = arguments$1[i];
	    if (source !== undefined && source !== null) {
	      for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	          output[key] = source[key];
	        }
	      }
	    }
	  }
	  return output;
	};
	
	
	/**
	 * Removes all properties from an object.
	 * @param {Object} object The object to clear.
	 */
	function clear(object) {
	  for (var property in object) {
	    delete object[property];
	  }
	}
	
	
	/**
	 * Get an array of property values from an object.
	 * @param {Object<K,V>} object The object from which to get the values.
	 * @return {!Array<V>} The property values.
	 * @template K,V
	 */
	function getValues(object) {
	  var values = [];
	  for (var property in object) {
	    values.push(object[property]);
	  }
	  return values;
	}
	
	
	/**
	 * Determine if an object has any properties.
	 * @param {Object} object The object to check.
	 * @return {boolean} The object is empty.
	 * @api
	 */
	function isEmpty(object) {
	  var property;
	  for (property in object) {
	    return false;
	  }
	  return !property;
	}
	
	/**
	 * @module ol/events/EventType
	 */
	
	/**
	 * @enum {string}
	 * @const
	 */
	var EventType = {
	  /**
	   * Generic change event. Triggered when the revision counter is increased.
	   * @event module:ol/events/Event~Event#change
	   * @api
	   */
	  CHANGE: 'change',
	
	  CLEAR: 'clear',
	  CONTEXTMENU: 'contextmenu',
	  CLICK: 'click',
	  DBLCLICK: 'dblclick',
	  DRAGENTER: 'dragenter',
	  DRAGOVER: 'dragover',
	  DROP: 'drop',
	  ERROR: 'error',
	  KEYDOWN: 'keydown',
	  KEYPRESS: 'keypress',
	  LOAD: 'load',
	  MOUSEDOWN: 'mousedown',
	  MOUSEMOVE: 'mousemove',
	  MOUSEOUT: 'mouseout',
	  MOUSEUP: 'mouseup',
	  MOUSEWHEEL: 'mousewheel',
	  MSPOINTERDOWN: 'MSPointerDown',
	  RESIZE: 'resize',
	  TOUCHSTART: 'touchstart',
	  TOUCHMOVE: 'touchmove',
	  TOUCHEND: 'touchend',
	  WHEEL: 'wheel'
	};
	
	/**
	 * @module ol/events
	 */
	
	
	/**
	 * Key to use with {@link module:ol/Observable~Observable#unByKey}.
	 * @typedef {Object} EventsKey
	 * @property {Object} [bindTo]
	 * @property {ListenerFunction} [boundListener]
	 * @property {boolean} callOnce
	 * @property {number} [deleteIndex]
	 * @property {ListenerFunction} listener
	 * @property {import("./events/Target.js").EventTargetLike} target
	 * @property {string} type
	 * @api
	 */
	
	
	/**
	 * Listener function. This function is called with an event object as argument.
	 * When the function returns `false`, event propagation will stop.
	 *
	 * @typedef {function((Event|import("./events/Event.js").default)): (void|boolean)} ListenerFunction
	 * @api
	 */
	
	
	/**
	 * @param {EventsKey} listenerObj Listener object.
	 * @return {ListenerFunction} Bound listener.
	 */
	function bindListener(listenerObj) {
	  var boundListener = function(evt) {
	    var listener = listenerObj.listener;
	    var bindTo = listenerObj.bindTo || listenerObj.target;
	    if (listenerObj.callOnce) {
	      unlistenByKey(listenerObj);
	    }
	    return listener.call(bindTo, evt);
	  };
	  listenerObj.boundListener = boundListener;
	  return boundListener;
	}
	
	
	/**
	 * Finds the matching {@link module:ol/events~EventsKey} in the given listener
	 * array.
	 *
	 * @param {!Array<!EventsKey>} listeners Array of listeners.
	 * @param {!Function} listener The listener function.
	 * @param {Object=} opt_this The `this` value inside the listener.
	 * @param {boolean=} opt_setDeleteIndex Set the deleteIndex on the matching
	 *     listener, for {@link module:ol/events~unlistenByKey}.
	 * @return {EventsKey|undefined} The matching listener object.
	 */
	function findListener(listeners, listener, opt_this, opt_setDeleteIndex) {
	  var listenerObj;
	  for (var i = 0, ii = listeners.length; i < ii; ++i) {
	    listenerObj = listeners[i];
	    if (listenerObj.listener === listener &&
	        listenerObj.bindTo === opt_this) {
	      if (opt_setDeleteIndex) {
	        listenerObj.deleteIndex = i;
	      }
	      return listenerObj;
	    }
	  }
	  return undefined;
	}
	
	
	/**
	 * @param {import("./events/Target.js").EventTargetLike} target Target.
	 * @param {string} type Type.
	 * @return {Array<EventsKey>|undefined} Listeners.
	 */
	function getListeners(target, type) {
	  var listenerMap = getListenerMap(target);
	  return listenerMap ? listenerMap[type] : undefined;
	}
	
	
	/**
	 * Get the lookup of listeners.
	 * @param {Object} target Target.
	 * @param {boolean=} opt_create If a map should be created if it doesn't exist.
	 * @return {!Object<string, Array<EventsKey>>} Map of
	 *     listeners by event type.
	 */
	function getListenerMap(target, opt_create) {
	  var listenerMap = target.ol_lm;
	  if (!listenerMap && opt_create) {
	    listenerMap = target.ol_lm = {};
	  }
	  return listenerMap;
	}
	
	
	/**
	 * Remove the listener map from a target.
	 * @param {Object} target Target.
	 */
	function removeListenerMap(target) {
	  delete target.ol_lm;
	}
	
	
	/**
	 * Clean up all listener objects of the given type.  All properties on the
	 * listener objects will be removed, and if no listeners remain in the listener
	 * map, it will be removed from the target.
	 * @param {import("./events/Target.js").EventTargetLike} target Target.
	 * @param {string} type Type.
	 */
	function removeListeners(target, type) {
	  var listeners = getListeners(target, type);
	  if (listeners) {
	    for (var i = 0, ii = listeners.length; i < ii; ++i) {
	      /** @type {import("./events/Target.js").default} */ (target).
	        removeEventListener(type, listeners[i].boundListener);
	      clear(listeners[i]);
	    }
	    listeners.length = 0;
	    var listenerMap = getListenerMap(target);
	    if (listenerMap) {
	      delete listenerMap[type];
	      if (Object.keys(listenerMap).length === 0) {
	        removeListenerMap(target);
	      }
	    }
	  }
	}
	
	
	/**
	 * Registers an event listener on an event target. Inspired by
	 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
	 *
	 * This function efficiently binds a `listener` to a `this` object, and returns
	 * a key for use with {@link module:ol/events~unlistenByKey}.
	 *
	 * @param {import("./events/Target.js").EventTargetLike} target Event target.
	 * @param {string} type Event type.
	 * @param {ListenerFunction} listener Listener.
	 * @param {Object=} opt_this Object referenced by the `this` keyword in the
	 *     listener. Default is the `target`.
	 * @param {boolean=} opt_once If true, add the listener as one-off listener.
	 * @return {EventsKey} Unique key for the listener.
	 * @api
	 */
	function listen(target, type, listener, opt_this, opt_once) {
	  var listenerMap = getListenerMap(target, true);
	  var listeners = listenerMap[type];
	  if (!listeners) {
	    listeners = listenerMap[type] = [];
	  }
	  var listenerObj = findListener(listeners, listener, opt_this, false);
	  if (listenerObj) {
	    if (!opt_once) {
	      // Turn one-off listener into a permanent one.
	      listenerObj.callOnce = false;
	    }
	  } else {
	    listenerObj = /** @type {EventsKey} */ ({
	      bindTo: opt_this,
	      callOnce: !!opt_once,
	      listener: listener,
	      target: target,
	      type: type
	    });
	    /** @type {import("./events/Target.js").default} */ (target).
	      addEventListener(type, bindListener(listenerObj));
	    listeners.push(listenerObj);
	  }
	
	  return listenerObj;
	}
	
	
	/**
	 * Registers a one-off event listener on an event target. Inspired by
	 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
	 *
	 * This function efficiently binds a `listener` as self-unregistering listener
	 * to a `this` object, and returns a key for use with
	 * {@link module:ol/events~unlistenByKey} in case the listener needs to be
	 * unregistered before it is called.
	 *
	 * When {@link module:ol/events~listen} is called with the same arguments after this
	 * function, the self-unregistering listener will be turned into a permanent
	 * listener.
	 *
	 * @param {import("./events/Target.js").EventTargetLike} target Event target.
	 * @param {string} type Event type.
	 * @param {ListenerFunction} listener Listener.
	 * @param {Object=} opt_this Object referenced by the `this` keyword in the
	 *     listener. Default is the `target`.
	 * @return {EventsKey} Key for unlistenByKey.
	 */
	function listenOnce(target, type, listener, opt_this) {
	  return listen(target, type, listener, opt_this, true);
	}
	
	
	/**
	 * Unregisters an event listener on an event target. Inspired by
	 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
	 *
	 * To return a listener, this function needs to be called with the exact same
	 * arguments that were used for a previous {@link module:ol/events~listen} call.
	 *
	 * @param {import("./events/Target.js").EventTargetLike} target Event target.
	 * @param {string} type Event type.
	 * @param {ListenerFunction} listener Listener.
	 * @param {Object=} opt_this Object referenced by the `this` keyword in the
	 *     listener. Default is the `target`.
	 * @api
	 */
	function unlisten(target, type, listener, opt_this) {
	  var listeners = getListeners(target, type);
	  if (listeners) {
	    var listenerObj = findListener(listeners, listener, opt_this, true);
	    if (listenerObj) {
	      unlistenByKey(listenerObj);
	    }
	  }
	}
	
	
	/**
	 * Unregisters event listeners on an event target. Inspired by
	 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
	 *
	 * The argument passed to this function is the key returned from
	 * {@link module:ol/events~listen} or {@link module:ol/events~listenOnce}.
	 *
	 * @param {EventsKey} key The key.
	 */
	function unlistenByKey(key) {
	  if (key && key.target) {
	    /** @type {import("./events/Target.js").default} */ (key.target).
	      removeEventListener(key.type, key.boundListener);
	    var listeners = getListeners(key.target, key.type);
	    if (listeners) {
	      var i = 'deleteIndex' in key ? key.deleteIndex : listeners.indexOf(key);
	      if (i !== -1) {
	        listeners.splice(i, 1);
	      }
	      if (listeners.length === 0) {
	        removeListeners(key.target, key.type);
	      }
	    }
	    clear(key);
	  }
	}
	
	
	/**
	 * Unregisters all event listeners on an event target. Inspired by
	 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
	 *
	 * @param {import("./events/Target.js").EventTargetLike} target Target.
	 */
	function unlistenAll(target) {
	  var listenerMap = getListenerMap(target);
	  if (listenerMap) {
	    for (var type in listenerMap) {
	      removeListeners(target, type);
	    }
	  }
	}
	
	/**
	 * @api
	 */
	var EventType$1 = EventType;
	
	/**
	 * @module ol/Disposable
	 */
	
	/**
	 * @classdesc
	 * Objects that need to clean up after themselves.
	 */
	var Disposable = function Disposable() {
	  /**
	   * The object has already been disposed.
	   * @type {boolean}
	   * @private
	   */
	  this.disposed_ = false;
	};
	
	/**
	 * Clean up.
	 */
	Disposable.prototype.dispose = function dispose () {
	  if (!this.disposed_) {
	    this.disposed_ = true;
	    this.disposeInternal();
	  }
	};
	
	/**
	 * Extension point for disposable objects.
	 * @protected
	 */
	Disposable.prototype.disposeInternal = function disposeInternal () {};
	
	/**
	 * @module ol/functions
	 */
	
	/**
	 * Always returns true.
	 * @returns {boolean} true.
	 */
	function TRUE() {
	  return true;
	}
	
	/**
	 * Always returns false.
	 * @returns {boolean} false.
	 */
	function FALSE() {
	  return false;
	}
	
	/**
	 * A reusable function, used e.g. as a default for callbacks.
	 *
	 * @return {void} Nothing.
	 */
	function VOID() {}
	
	/**
	 * @module ol/events/Event
	 */
	
	/**
	 * @classdesc
	 * Stripped down implementation of the W3C DOM Level 2 Event interface.
	 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
	 *
	 * This implementation only provides `type` and `target` properties, and
	 * `stopPropagation` and `preventDefault` methods. It is meant as base class
	 * for higher level events defined in the library, and works with
	 * {@link module:ol/events/Target~Target}.
	 */
	var Event = function Event(type) {
	
	  /**
	   * @type {boolean}
	   */
	  this.propagationStopped;
	
	  /**
	   * The event type.
	   * @type {string}
	   * @api
	   */
	  this.type = type;
	
	  /**
	   * The event target.
	   * @type {Object}
	   * @api
	   */
	  this.target = null;
	};
	
	/**
	 * Stop event propagation.
	 * @api
	 */
	Event.prototype.preventDefault = function preventDefault () {
	  this.propagationStopped = true;
	};
	
	/**
	 * Stop event propagation.
	 * @api
	 */
	Event.prototype.stopPropagation = function stopPropagation () {
	  this.propagationStopped = true;
	};
	
	
	/**
	 * @param {Event|import("./Event.js").default} evt Event
	 */
	function stopPropagation(evt) {
	  evt.stopPropagation();
	}
	
	/**
	 * @module ol/events/Target
	 */
	
	
	/**
	 * @typedef {EventTarget|Target} EventTargetLike
	 */
	
	
	/**
	 * @classdesc
	 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
	 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
	 *
	 * There are two important simplifications compared to the specification:
	 *
	 * 1. The handling of `useCapture` in `addEventListener` and
	 *    `removeEventListener`. There is no real capture model.
	 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
	 *    There is no event target hierarchy. When a listener calls
	 *    `stopPropagation` or `preventDefault` on an event object, it means that no
	 *    more listeners after this one will be called. Same as when the listener
	 *    returns false.
	 */
	var Target = /*@__PURE__*/(function (Disposable$$1) {
	  function Target() {
	
	    Disposable$$1.call(this);
	
	    /**
	     * @private
	     * @type {!Object<string, number>}
	     */
	    this.pendingRemovals_ = {};
	
	    /**
	     * @private
	     * @type {!Object<string, number>}
	     */
	    this.dispatching_ = {};
	
	    /**
	     * @private
	     * @type {!Object<string, Array<import("../events.js").ListenerFunction>>}
	     */
	    this.listeners_ = {};
	
	  }
	
	  if ( Disposable$$1 ) { Target.__proto__ = Disposable$$1; }
	  Target.prototype = Object.create( Disposable$$1 && Disposable$$1.prototype );
	  Target.prototype.constructor = Target;
	
	  /**
	   * @param {string} type Type.
	   * @param {import("../events.js").ListenerFunction} listener Listener.
	   */
	  Target.prototype.addEventListener = function addEventListener (type, listener) {
	    var listeners = this.listeners_[type];
	    if (!listeners) {
	      listeners = this.listeners_[type] = [];
	    }
	    if (listeners.indexOf(listener) === -1) {
	      listeners.push(listener);
	    }
	  };
	
	  /**
	   * Dispatches an event and calls all listeners listening for events
	   * of this type. The event parameter can either be a string or an
	   * Object with a `type` property.
	   *
	   * @param {{type: string,
	   *     target: (EventTargetLike|undefined),
	   *     propagationStopped: (boolean|undefined)}|
	   *     import("./Event.js").default|string} event Event object.
	   * @return {boolean|undefined} `false` if anyone called preventDefault on the
	   *     event object or if any of the listeners returned false.
	   * @api
	   */
	  Target.prototype.dispatchEvent = function dispatchEvent (event) {
	    var evt = typeof event === 'string' ? new Event(event) : event;
	    var type = evt.type;
	    evt.target = this;
	    var listeners = this.listeners_[type];
	    var propagate;
	    if (listeners) {
	      if (!(type in this.dispatching_)) {
	        this.dispatching_[type] = 0;
	        this.pendingRemovals_[type] = 0;
	      }
	      ++this.dispatching_[type];
	      for (var i = 0, ii = listeners.length; i < ii; ++i) {
	        if (listeners[i].call(this, evt) === false || evt.propagationStopped) {
	          propagate = false;
	          break;
	        }
	      }
	      --this.dispatching_[type];
	      if (this.dispatching_[type] === 0) {
	        var pendingRemovals = this.pendingRemovals_[type];
	        delete this.pendingRemovals_[type];
	        while (pendingRemovals--) {
	          this.removeEventListener(type, VOID);
	        }
	        delete this.dispatching_[type];
	      }
	      return propagate;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Target.prototype.disposeInternal = function disposeInternal () {
	    unlistenAll(this);
	  };
	
	  /**
	   * Get the listeners for a specified event type. Listeners are returned in the
	   * order that they will be called in.
	   *
	   * @param {string} type Type.
	   * @return {Array<import("../events.js").ListenerFunction>} Listeners.
	   */
	  Target.prototype.getListeners = function getListeners$$1 (type) {
	    return this.listeners_[type];
	  };
	
	  /**
	   * @param {string=} opt_type Type. If not provided,
	   *     `true` will be returned if this event target has any listeners.
	   * @return {boolean} Has listeners.
	   */
	  Target.prototype.hasListener = function hasListener (opt_type) {
	    return opt_type ?
	      opt_type in this.listeners_ :
	      Object.keys(this.listeners_).length > 0;
	  };
	
	  /**
	   * @param {string} type Type.
	   * @param {import("../events.js").ListenerFunction} listener Listener.
	   */
	  Target.prototype.removeEventListener = function removeEventListener (type, listener) {
	    var listeners = this.listeners_[type];
	    if (listeners) {
	      var index = listeners.indexOf(listener);
	      if (type in this.pendingRemovals_) {
	        // make listener a no-op, and remove later in #dispatchEvent()
	        listeners[index] = VOID;
	        ++this.pendingRemovals_[type];
	      } else {
	        listeners.splice(index, 1);
	        if (listeners.length === 0) {
	          delete this.listeners_[type];
	        }
	      }
	    }
	  };
	
	  return Target;
	}(Disposable));
	
	/**
	 * @module ol/Observable
	 */
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * An event target providing convenient methods for listener registration
	 * and unregistration. A generic `change` event is always available through
	 * {@link module:ol/Observable~Observable#changed}.
	 *
	 * @fires import("./events/Event.js").Event
	 * @api
	 */
	var Observable = /*@__PURE__*/(function (EventTarget) {
	  function Observable() {
	
	    EventTarget.call(this);
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.revision_ = 0;
	
	  }
	
	  if ( EventTarget ) { Observable.__proto__ = EventTarget; }
	  Observable.prototype = Object.create( EventTarget && EventTarget.prototype );
	  Observable.prototype.constructor = Observable;
	
	  /**
	   * Increases the revision counter and dispatches a 'change' event.
	   * @api
	   */
	  Observable.prototype.changed = function changed () {
	    ++this.revision_;
	    this.dispatchEvent(EventType.CHANGE);
	  };
	
	  /**
	   * Get the version number for this object.  Each time the object is modified,
	   * its version number will be incremented.
	   * @return {number} Revision.
	   * @api
	   */
	  Observable.prototype.getRevision = function getRevision () {
	    return this.revision_;
	  };
	
	  /**
	   * Listen for a certain type of event.
	   * @param {string|Array<string>} type The event type or array of event types.
	   * @param {function(?): ?} listener The listener function.
	   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
	   *     called with an array of event types as the first argument, the return
	   *     will be an array of keys.
	   * @api
	   */
	  Observable.prototype.on = function on (type, listener) {
	    if (Array.isArray(type)) {
	      var len = type.length;
	      var keys = new Array(len);
	      for (var i = 0; i < len; ++i) {
	        keys[i] = listen(this, type[i], listener);
	      }
	      return keys;
	    } else {
	      return listen(this, /** @type {string} */ (type), listener);
	    }
	  };
	
	  /**
	   * Listen once for a certain type of event.
	   * @param {string|Array<string>} type The event type or array of event types.
	   * @param {function(?): ?} listener The listener function.
	   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
	   *     called with an array of event types as the first argument, the return
	   *     will be an array of keys.
	   * @api
	   */
	  Observable.prototype.once = function once (type, listener) {
	    if (Array.isArray(type)) {
	      var len = type.length;
	      var keys = new Array(len);
	      for (var i = 0; i < len; ++i) {
	        keys[i] = listenOnce(this, type[i], listener);
	      }
	      return keys;
	    } else {
	      return listenOnce(this, /** @type {string} */ (type), listener);
	    }
	  };
	
	  /**
	   * Unlisten for a certain type of event.
	   * @param {string|Array<string>} type The event type or array of event types.
	   * @param {function(?): ?} listener The listener function.
	   * @api
	   */
	  Observable.prototype.un = function un (type, listener) {
	    if (Array.isArray(type)) {
	      for (var i = 0, ii = type.length; i < ii; ++i) {
	        unlisten(this, type[i], listener);
	      }
	      return;
	    } else {
	      unlisten(this, /** @type {string} */ (type), listener);
	    }
	  };
	
	  return Observable;
	}(Target));
	
	
	/**
	 * Removes an event listener using the key returned by `on()` or `once()`.
	 * @param {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} key The key returned by `on()`
	 *     or `once()` (or an array of keys).
	 * @api
	 */
	function unByKey(key) {
	  if (Array.isArray(key)) {
	    for (var i = 0, ii = key.length; i < ii; ++i) {
	      unlistenByKey(key[i]);
	    }
	  } else {
	    unlistenByKey(/** @type {import("./events.js").EventsKey} */ (key));
	  }
	}
	
	/**
	 * @module ol/Object
	 */
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/Object~BaseObject} instances are instances of this type.
	 */
	var ObjectEvent = /*@__PURE__*/(function (Event$$1) {
	  function ObjectEvent(type, key, oldValue) {
	    Event$$1.call(this, type);
	
	    /**
	     * The name of the property whose value is changing.
	     * @type {string}
	     * @api
	     */
	    this.key = key;
	
	    /**
	     * The old value. To get the new value use `e.target.get(e.key)` where
	     * `e` is the event object.
	     * @type {*}
	     * @api
	     */
	    this.oldValue = oldValue;
	
	  }
	
	  if ( Event$$1 ) { ObjectEvent.__proto__ = Event$$1; }
	  ObjectEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  ObjectEvent.prototype.constructor = ObjectEvent;
	
	  return ObjectEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Most non-trivial classes inherit from this.
	 *
	 * This extends {@link module:ol/Observable} with observable
	 * properties, where each property is observable as well as the object as a
	 * whole.
	 *
	 * Classes that inherit from this have pre-defined properties, to which you can
	 * add your owns. The pre-defined properties are listed in this documentation as
	 * 'Observable Properties', and have their own accessors; for example,
	 * {@link module:ol/Map~Map} has a `target` property, accessed with
	 * `getTarget()` and changed with `setTarget()`. Not all properties are however
	 * settable. There are also general-purpose accessors `get()` and `set()`. For
	 * example, `get('target')` is equivalent to `getTarget()`.
	 *
	 * The `set` accessors trigger a change event, and you can monitor this by
	 * registering a listener. For example, {@link module:ol/View~View} has a
	 * `center` property, so `view.on('change:center', function(evt) {...});` would
	 * call the function whenever the value of the center property changes. Within
	 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
	 * would return the new center.
	 *
	 * You can add your own observable properties with
	 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
	 * You can listen for changes on that property value with
	 * `object.on('change:prop', listener)`. You can get a list of all
	 * properties with {@link module:ol/Object~BaseObject#getProperties}.
	 *
	 * Note that the observable properties are separate from standard JS properties.
	 * You can, for example, give your map object a title with
	 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
	 * first will be a `hasOwnProperty`; the second will appear in
	 * `getProperties()`. Only the second is observable.
	 *
	 * Properties can be deleted by using the unset method. E.g.
	 * object.unset('foo').
	 *
	 * @fires ObjectEvent
	 * @api
	 */
	var BaseObject = /*@__PURE__*/(function (Observable$$1) {
	  function BaseObject(opt_values) {
	    Observable$$1.call(this);
	
	    // Call {@link module:ol/util~getUid} to ensure that the order of objects' ids is
	    // the same as the order in which they were created.  This also helps to
	    // ensure that object properties are always added in the same order, which
	    // helps many JavaScript engines generate faster code.
	    getUid(this);
	
	    /**
	     * @private
	     * @type {!Object<string, *>}
	     */
	    this.values_ = {};
	
	    if (opt_values !== undefined) {
	      this.setProperties(opt_values);
	    }
	  }
	
	  if ( Observable$$1 ) { BaseObject.__proto__ = Observable$$1; }
	  BaseObject.prototype = Object.create( Observable$$1 && Observable$$1.prototype );
	  BaseObject.prototype.constructor = BaseObject;
	
	  /**
	   * Gets a value.
	   * @param {string} key Key name.
	   * @return {*} Value.
	   * @api
	   */
	  BaseObject.prototype.get = function get (key) {
	    var value;
	    if (this.values_.hasOwnProperty(key)) {
	      value = this.values_[key];
	    }
	    return value;
	  };
	
	  /**
	   * Get a list of object property names.
	   * @return {Array<string>} List of property names.
	   * @api
	   */
	  BaseObject.prototype.getKeys = function getKeys () {
	    return Object.keys(this.values_);
	  };
	
	  /**
	   * Get an object of all property names and values.
	   * @return {Object<string, *>} Object.
	   * @api
	   */
	  BaseObject.prototype.getProperties = function getProperties () {
	    return assign({}, this.values_);
	  };
	
	  /**
	   * @param {string} key Key name.
	   * @param {*} oldValue Old value.
	   */
	  BaseObject.prototype.notify = function notify (key, oldValue) {
	    var eventType;
	    eventType = getChangeEventType(key);
	    this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
	    eventType = ObjectEventType.PROPERTYCHANGE;
	    this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
	  };
	
	  /**
	   * Sets a value.
	   * @param {string} key Key name.
	   * @param {*} value Value.
	   * @param {boolean=} opt_silent Update without triggering an event.
	   * @api
	   */
	  BaseObject.prototype.set = function set (key, value, opt_silent) {
	    if (opt_silent) {
	      this.values_[key] = value;
	    } else {
	      var oldValue = this.values_[key];
	      this.values_[key] = value;
	      if (oldValue !== value) {
	        this.notify(key, oldValue);
	      }
	    }
	  };
	
	  /**
	   * Sets a collection of key-value pairs.  Note that this changes any existing
	   * properties and adds new ones (it does not remove any existing properties).
	   * @param {Object<string, *>} values Values.
	   * @param {boolean=} opt_silent Update without triggering an event.
	   * @api
	   */
	  BaseObject.prototype.setProperties = function setProperties (values, opt_silent) {
	    for (var key in values) {
	      this.set(key, values[key], opt_silent);
	    }
	  };
	
	  /**
	   * Unsets a property.
	   * @param {string} key Key name.
	   * @param {boolean=} opt_silent Unset without triggering an event.
	   * @api
	   */
	  BaseObject.prototype.unset = function unset (key, opt_silent) {
	    if (key in this.values_) {
	      var oldValue = this.values_[key];
	      delete this.values_[key];
	      if (!opt_silent) {
	        this.notify(key, oldValue);
	      }
	    }
	  };
	
	  return BaseObject;
	}(Observable));
	
	
	/**
	 * @type {Object<string, string>}
	 */
	var changeEventTypeCache = {};
	
	
	/**
	 * @param {string} key Key name.
	 * @return {string} Change name.
	 */
	function getChangeEventType(key) {
	  return changeEventTypeCache.hasOwnProperty(key) ?
	    changeEventTypeCache[key] :
	    (changeEventTypeCache[key] = 'change:' + key);
	}
	
	/**
	 * @module ol/Collection
	 */
	
	
	/**
	 * @enum {string}
	 * @private
	 */
	var Property = {
	  LENGTH: 'length'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/Collection~Collection} instances are instances of this
	 * type.
	 */
	var CollectionEvent = /*@__PURE__*/(function (Event$$1) {
	  function CollectionEvent(type, opt_element) {
	    Event$$1.call(this, type);
	
	    /**
	     * The element that is added to or removed from the collection.
	     * @type {*}
	     * @api
	     */
	    this.element = opt_element;
	
	  }
	
	  if ( Event$$1 ) { CollectionEvent.__proto__ = Event$$1; }
	  CollectionEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  CollectionEvent.prototype.constructor = CollectionEvent;
	
	  return CollectionEvent;
	}(Event));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {boolean} [unique=false] Disallow the same item from being added to
	 * the collection twice.
	 */
	
	/**
	 * @classdesc
	 * An expanded version of standard JS Array, adding convenience methods for
	 * manipulation. Add and remove changes to the Collection trigger a Collection
	 * event. Note that this does not cover changes to the objects _within_ the
	 * Collection; they trigger events on the appropriate object, not on the
	 * Collection as a whole.
	 *
	 * @fires CollectionEvent
	 *
	 * @template T
	 * @api
	 */
	var Collection = /*@__PURE__*/(function (BaseObject$$1) {
	  function Collection(opt_array, opt_options) {
	
	    BaseObject$$1.call(this);
	
	    var options = opt_options || {};
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.unique_ = !!options.unique;
	
	    /**
	     * @private
	     * @type {!Array<T>}
	     */
	    this.array_ = opt_array ? opt_array : [];
	
	    if (this.unique_) {
	      for (var i = 0, ii = this.array_.length; i < ii; ++i) {
	        this.assertUnique_(this.array_[i], i);
	      }
	    }
	
	    this.updateLength_();
	
	  }
	
	  if ( BaseObject$$1 ) { Collection.__proto__ = BaseObject$$1; }
	  Collection.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Collection.prototype.constructor = Collection;
	
	  /**
	   * Remove all elements from the collection.
	   * @api
	   */
	  Collection.prototype.clear = function clear () {
	    while (this.getLength() > 0) {
	      this.pop();
	    }
	  };
	
	  /**
	   * Add elements to the collection.  This pushes each item in the provided array
	   * to the end of the collection.
	   * @param {!Array<T>} arr Array.
	   * @return {Collection<T>} This collection.
	   * @api
	   */
	  Collection.prototype.extend = function extend (arr) {
	    for (var i = 0, ii = arr.length; i < ii; ++i) {
	      this.push(arr[i]);
	    }
	    return this;
	  };
	
	  /**
	   * Iterate over each element, calling the provided callback.
	   * @param {function(T, number, Array<T>): *} f The function to call
	   *     for every element. This function takes 3 arguments (the element, the
	   *     index and the array). The return value is ignored.
	   * @api
	   */
	  Collection.prototype.forEach = function forEach (f) {
	    var array = this.array_;
	    for (var i = 0, ii = array.length; i < ii; ++i) {
	      f(array[i], i, array);
	    }
	  };
	
	  /**
	   * Get a reference to the underlying Array object. Warning: if the array
	   * is mutated, no events will be dispatched by the collection, and the
	   * collection's "length" property won't be in sync with the actual length
	   * of the array.
	   * @return {!Array<T>} Array.
	   * @api
	   */
	  Collection.prototype.getArray = function getArray () {
	    return this.array_;
	  };
	
	  /**
	   * Get the element at the provided index.
	   * @param {number} index Index.
	   * @return {T} Element.
	   * @api
	   */
	  Collection.prototype.item = function item (index) {
	    return this.array_[index];
	  };
	
	  /**
	   * Get the length of this collection.
	   * @return {number} The length of the array.
	   * @observable
	   * @api
	   */
	  Collection.prototype.getLength = function getLength () {
	    return this.get(Property.LENGTH);
	  };
	
	  /**
	   * Insert an element at the provided index.
	   * @param {number} index Index.
	   * @param {T} elem Element.
	   * @api
	   */
	  Collection.prototype.insertAt = function insertAt (index, elem) {
	    if (this.unique_) {
	      this.assertUnique_(elem);
	    }
	    this.array_.splice(index, 0, elem);
	    this.updateLength_();
	    this.dispatchEvent(
	      new CollectionEvent(CollectionEventType.ADD, elem));
	  };
	
	  /**
	   * Remove the last element of the collection and return it.
	   * Return `undefined` if the collection is empty.
	   * @return {T|undefined} Element.
	   * @api
	   */
	  Collection.prototype.pop = function pop () {
	    return this.removeAt(this.getLength() - 1);
	  };
	
	  /**
	   * Insert the provided element at the end of the collection.
	   * @param {T} elem Element.
	   * @return {number} New length of the collection.
	   * @api
	   */
	  Collection.prototype.push = function push (elem) {
	    if (this.unique_) {
	      this.assertUnique_(elem);
	    }
	    var n = this.getLength();
	    this.insertAt(n, elem);
	    return this.getLength();
	  };
	
	  /**
	   * Remove the first occurrence of an element from the collection.
	   * @param {T} elem Element.
	   * @return {T|undefined} The removed element or undefined if none found.
	   * @api
	   */
	  Collection.prototype.remove = function remove (elem) {
	    var arr = this.array_;
	    for (var i = 0, ii = arr.length; i < ii; ++i) {
	      if (arr[i] === elem) {
	        return this.removeAt(i);
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * Remove the element at the provided index and return it.
	   * Return `undefined` if the collection does not contain this index.
	   * @param {number} index Index.
	   * @return {T|undefined} Value.
	   * @api
	   */
	  Collection.prototype.removeAt = function removeAt (index) {
	    var prev = this.array_[index];
	    this.array_.splice(index, 1);
	    this.updateLength_();
	    this.dispatchEvent(new CollectionEvent(CollectionEventType.REMOVE, prev));
	    return prev;
	  };
	
	  /**
	   * Set the element at the provided index.
	   * @param {number} index Index.
	   * @param {T} elem Element.
	   * @api
	   */
	  Collection.prototype.setAt = function setAt (index, elem) {
	    var n = this.getLength();
	    if (index < n) {
	      if (this.unique_) {
	        this.assertUnique_(elem, index);
	      }
	      var prev = this.array_[index];
	      this.array_[index] = elem;
	      this.dispatchEvent(
	        new CollectionEvent(CollectionEventType.REMOVE, prev));
	      this.dispatchEvent(
	        new CollectionEvent(CollectionEventType.ADD, elem));
	    } else {
	      for (var j = n; j < index; ++j) {
	        this.insertAt(j, undefined);
	      }
	      this.insertAt(index, elem);
	    }
	  };
	
	  /**
	   * @private
	   */
	  Collection.prototype.updateLength_ = function updateLength_ () {
	    this.set(Property.LENGTH, this.array_.length);
	  };
	
	  /**
	   * @private
	   * @param {T} elem Element.
	   * @param {number=} opt_except Optional index to ignore.
	   */
	  Collection.prototype.assertUnique_ = function assertUnique_ (elem, opt_except) {
	    for (var i = 0, ii = this.array_.length; i < ii; ++i) {
	      if (this.array_[i] === elem && i !== opt_except) {
	        throw new AssertionError(58);
	      }
	    }
	  };
	
	  return Collection;
	}(BaseObject));
	
	/**
	 * @module ol/asserts
	 */
	
	/**
	 * @param {*} assertion Assertion we expected to be truthy.
	 * @param {number} errorCode Error code.
	 */
	function assert(assertion, errorCode) {
	  if (!assertion) {
	    throw new AssertionError(errorCode);
	  }
	}
	
	/**
	 * @module ol/Feature
	 */
	
	/**
	 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
	 */
	
	/**
	 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
	 */
	
	/**
	 * @classdesc
	 * A vector object for geographic features with a geometry and other
	 * attribute properties, similar to the features in vector file formats like
	 * GeoJSON.
	 *
	 * Features can be styled individually with `setStyle`; otherwise they use the
	 * style of their vector layer.
	 *
	 * Note that attribute properties are set as {@link module:ol/Object} properties on
	 * the feature object, so they are observable, and have get/set accessors.
	 *
	 * Typically, a feature has a single geometry property. You can set the
	 * geometry using the `setGeometry` method and get it with `getGeometry`.
	 * It is possible to store more than one geometry on a feature using attribute
	 * properties. By default, the geometry used for rendering is identified by
	 * the property name `geometry`. If you want to use another geometry property
	 * for rendering, use the `setGeometryName` method to change the attribute
	 * property associated with the geometry for the feature.  For example:
	 *
	 * ```js
	 *
	 * import Feature from 'ol/Feature';
	 * import Polygon from 'ol/geom/Polygon';
	 * import Point from 'ol/geom/Point';
	 *
	 * var feature = new Feature({
	 *   geometry: new Polygon(polyCoords),
	 *   labelPoint: new Point(labelCoords),
	 *   name: 'My Polygon'
	 * });
	 *
	 * // get the polygon geometry
	 * var poly = feature.getGeometry();
	 *
	 * // Render the feature as a point using the coordinates from labelPoint
	 * feature.setGeometryName('labelPoint');
	 *
	 * // get the point geometry
	 * var point = feature.getGeometry();
	 * ```
	 *
	 * @api
	 */
	var Feature = /*@__PURE__*/(function (BaseObject$$1) {
	  function Feature(opt_geometryOrProperties) {
	
	    BaseObject$$1.call(this);
	
	    /**
	     * @private
	     * @type {number|string|undefined}
	     */
	    this.id_ = undefined;
	
	    /**
	     * @type {string}
	     * @private
	     */
	    this.geometryName_ = 'geometry';
	
	    /**
	     * User provided style.
	     * @private
	     * @type {import("./style/Style.js").StyleLike}
	     */
	    this.style_ = null;
	
	    /**
	     * @private
	     * @type {import("./style/Style.js").StyleFunction|undefined}
	     */
	    this.styleFunction_ = undefined;
	
	    /**
	     * @private
	     * @type {?import("./events.js").EventsKey}
	     */
	    this.geometryChangeKey_ = null;
	
	    listen(
	      this, getChangeEventType(this.geometryName_),
	      this.handleGeometryChanged_, this);
	
	    if (opt_geometryOrProperties) {
	      if (typeof /** @type {?} */ (opt_geometryOrProperties).getSimplifiedGeometry === 'function') {
	        var geometry = /** @type {import("./geom/Geometry.js").default} */ (opt_geometryOrProperties);
	        this.setGeometry(geometry);
	      } else {
	        /** @type {Object<string, *>} */
	        var properties = opt_geometryOrProperties;
	        this.setProperties(properties);
	      }
	    }
	  }
	
	  if ( BaseObject$$1 ) { Feature.__proto__ = BaseObject$$1; }
	  Feature.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Feature.prototype.constructor = Feature;
	
	  /**
	   * Clone this feature. If the original feature has a geometry it
	   * is also cloned. The feature id is not set in the clone.
	   * @return {Feature} The clone.
	   * @api
	   */
	  Feature.prototype.clone = function clone () {
	    var clone = new Feature(this.getProperties());
	    clone.setGeometryName(this.getGeometryName());
	    var geometry = this.getGeometry();
	    if (geometry) {
	      clone.setGeometry(geometry.clone());
	    }
	    var style = this.getStyle();
	    if (style) {
	      clone.setStyle(style);
	    }
	    return clone;
	  };
	
	  /**
	   * Get the feature's default geometry.  A feature may have any number of named
	   * geometries.  The "default" geometry (the one that is rendered by default) is
	   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
	   * @return {import("./geom/Geometry.js").default|undefined} The default geometry for the feature.
	   * @api
	   * @observable
	   */
	  Feature.prototype.getGeometry = function getGeometry () {
	    return (
	      /** @type {import("./geom/Geometry.js").default|undefined} */ (this.get(this.geometryName_))
	    );
	  };
	
	  /**
	   * Get the feature identifier.  This is a stable identifier for the feature and
	   * is either set when reading data from a remote source or set explicitly by
	   * calling {@link module:ol/Feature~Feature#setId}.
	   * @return {number|string|undefined} Id.
	   * @api
	   */
	  Feature.prototype.getId = function getId () {
	    return this.id_;
	  };
	
	  /**
	   * Get the name of the feature's default geometry.  By default, the default
	   * geometry is named `geometry`.
	   * @return {string} Get the property name associated with the default geometry
	   *     for this feature.
	   * @api
	   */
	  Feature.prototype.getGeometryName = function getGeometryName () {
	    return this.geometryName_;
	  };
	
	  /**
	   * Get the feature's style. Will return what was provided to the
	   * {@link module:ol/Feature~Feature#setStyle} method.
	   * @return {import("./style/Style.js").StyleLike} The feature style.
	   * @api
	   */
	  Feature.prototype.getStyle = function getStyle () {
	    return this.style_;
	  };
	
	  /**
	   * Get the feature's style function.
	   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
	   * representing the current style of this feature.
	   * @api
	   */
	  Feature.prototype.getStyleFunction = function getStyleFunction () {
	    return this.styleFunction_;
	  };
	
	  /**
	   * @private
	   */
	  Feature.prototype.handleGeometryChange_ = function handleGeometryChange_ () {
	    this.changed();
	  };
	
	  /**
	   * @private
	   */
	  Feature.prototype.handleGeometryChanged_ = function handleGeometryChanged_ () {
	    if (this.geometryChangeKey_) {
	      unlistenByKey(this.geometryChangeKey_);
	      this.geometryChangeKey_ = null;
	    }
	    var geometry = this.getGeometry();
	    if (geometry) {
	      this.geometryChangeKey_ = listen(geometry,
	        EventType.CHANGE, this.handleGeometryChange_, this);
	    }
	    this.changed();
	  };
	
	  /**
	   * Set the default geometry for the feature.  This will update the property
	   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
	   * @param {import("./geom/Geometry.js").default|undefined} geometry The new geometry.
	   * @api
	   * @observable
	   */
	  Feature.prototype.setGeometry = function setGeometry (geometry) {
	    this.set(this.geometryName_, geometry);
	  };
	
	  /**
	   * Set the style for the feature.  This can be a single style object, an array
	   * of styles, or a function that takes a resolution and returns an array of
	   * styles. If it is `null` the feature has no style (a `null` style).
	   * @param {import("./style/Style.js").StyleLike} style Style for this feature.
	   * @api
	   * @fires module:ol/events/Event~Event#event:change
	   */
	  Feature.prototype.setStyle = function setStyle (style) {
	    this.style_ = style;
	    this.styleFunction_ = !style ? undefined : createStyleFunction(style);
	    this.changed();
	  };
	
	  /**
	   * Set the feature id.  The feature id is considered stable and may be used when
	   * requesting features or comparing identifiers returned from a remote source.
	   * The feature id can be used with the
	   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
	   * @param {number|string|undefined} id The feature id.
	   * @api
	   * @fires module:ol/events/Event~Event#event:change
	   */
	  Feature.prototype.setId = function setId (id) {
	    this.id_ = id;
	    this.changed();
	  };
	
	  /**
	   * Set the property name to be used when getting the feature's default geometry.
	   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
	   * this name will be returned.
	   * @param {string} name The property name of the default geometry.
	   * @api
	   */
	  Feature.prototype.setGeometryName = function setGeometryName (name) {
	    unlisten(
	      this, getChangeEventType(this.geometryName_),
	      this.handleGeometryChanged_, this);
	    this.geometryName_ = name;
	    listen(
	      this, getChangeEventType(this.geometryName_),
	      this.handleGeometryChanged_, this);
	    this.handleGeometryChanged_();
	  };
	
	  return Feature;
	}(BaseObject));
	
	
	/**
	 * Convert the provided object into a feature style function.  Functions passed
	 * through unchanged.  Arrays of Style or single style objects wrapped
	 * in a new feature style function.
	 * @param {!import("./style/Style.js").StyleFunction|!Array<import("./style/Style.js").default>|!import("./style/Style.js").default} obj
	 *     A feature style function, a single style, or an array of styles.
	 * @return {import("./style/Style.js").StyleFunction} A style function.
	 */
	function createStyleFunction(obj) {
	  if (typeof obj === 'function') {
	    return obj;
	  } else {
	    /**
	     * @type {Array<import("./style/Style.js").default>}
	     */
	    var styles;
	    if (Array.isArray(obj)) {
	      styles = obj;
	    } else {
	      assert(typeof /** @type {?} */ (obj).getZIndex === 'function',
	        41); // Expected an `import("./style/Style.js").Style` or an array of `import("./style/Style.js").Style`
	      var style = /** @type {import("./style/Style.js").default} */ (obj);
	      styles = [style];
	    }
	    return function() {
	      return styles;
	    };
	  }
	}
	
	/**
	 * @module ol/array
	 */
	
	
	/**
	 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
	 * https://github.com/darkskyapp/binary-search
	 *
	 * @param {Array<*>} haystack Items to search through.
	 * @param {*} needle The item to look for.
	 * @param {Function=} opt_comparator Comparator function.
	 * @return {number} The index of the item if found, -1 if not.
	 */
	function binarySearch(haystack, needle, opt_comparator) {
	  var mid, cmp;
	  var comparator = opt_comparator || numberSafeCompareFunction;
	  var low = 0;
	  var high = haystack.length;
	  var found = false;
	
	  while (low < high) {
	    /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
	     * to double (which gives the wrong results). */
	    mid = low + (high - low >> 1);
	    cmp = +comparator(haystack[mid], needle);
	
	    if (cmp < 0.0) { /* Too low. */
	      low = mid + 1;
	
	    } else { /* Key found or too high */
	      high = mid;
	      found = !cmp;
	    }
	  }
	
	  /* Key not found. */
	  return found ? low : ~low;
	}
	
	
	/**
	 * Compare function for array sort that is safe for numbers.
	 * @param {*} a The first object to be compared.
	 * @param {*} b The second object to be compared.
	 * @return {number} A negative number, zero, or a positive number as the first
	 *     argument is less than, equal to, or greater than the second.
	 * @api
	 */
	function numberSafeCompareFunction(a, b) {
	  return a > b ? 1 : a < b ? -1 : 0;
	}
	
	
	/**
	 * Whether the array contains the given object.
	 * @param {Array<*>} arr The array to test for the presence of the element.
	 * @param {*} obj The object for which to test.
	 * @return {boolean} The object is in the array.
	 */
	function includes(arr, obj) {
	  return arr.indexOf(obj) >= 0;
	}
	
	
	/**
	 * @param {Array<number>} arr Array.
	 * @param {number} target Target.
	 * @param {number} direction 0 means return the nearest, > 0
	 *    means return the largest nearest, < 0 means return the
	 *    smallest nearest.
	 * @return {number} Index.
	 */
	function linearFindNearest(arr, target, direction) {
	  var n = arr.length;
	  if (arr[0] <= target) {
	    return 0;
	  } else if (target <= arr[n - 1]) {
	    return n - 1;
	  } else {
	    var i;
	    if (direction > 0) {
	      for (i = 1; i < n; ++i) {
	        if (arr[i] < target) {
	          return i - 1;
	        }
	      }
	    } else if (direction < 0) {
	      for (i = 1; i < n; ++i) {
	        if (arr[i] <= target) {
	          return i;
	        }
	      }
	    } else {
	      for (i = 1; i < n; ++i) {
	        if (arr[i] == target) {
	          return i;
	        } else if (arr[i] < target) {
	          if (arr[i - 1] - target < target - arr[i]) {
	            return i - 1;
	          } else {
	            return i;
	          }
	        }
	      }
	    }
	    return n - 1;
	  }
	}
	
	
	/**
	 * @param {Array<*>} arr Array.
	 * @param {number} begin Begin index.
	 * @param {number} end End index.
	 */
	function reverseSubArray(arr, begin, end) {
	  while (begin < end) {
	    var tmp = arr[begin];
	    arr[begin] = arr[end];
	    arr[end] = tmp;
	    ++begin;
	    --end;
	  }
	}
	
	
	/**
	 * @param {Array<VALUE>} arr The array to modify.
	 * @param {!Array<VALUE>|VALUE} data The elements or arrays of elements to add to arr.
	 * @template VALUE
	 */
	function extend(arr, data) {
	  var extension = Array.isArray(data) ? data : [data];
	  var length = extension.length;
	  for (var i = 0; i < length; i++) {
	    arr[arr.length] = extension[i];
	  }
	}
	
	
	/**
	 * @param {Array<VALUE>} arr The array to modify.
	 * @param {VALUE} obj The element to remove.
	 * @template VALUE
	 * @return {boolean} If the element was removed.
	 */
	function remove(arr, obj) {
	  var i = arr.indexOf(obj);
	  var found = i > -1;
	  if (found) {
	    arr.splice(i, 1);
	  }
	  return found;
	}
	
	
	/**
	 * @param {Array<VALUE>} arr The array to search in.
	 * @param {function(VALUE, number, ?) : boolean} func The function to compare.
	 * @template VALUE
	 * @return {VALUE|null} The element found or null.
	 */
	function find(arr, func) {
	  var length = arr.length >>> 0;
	  var value;
	
	  for (var i = 0; i < length; i++) {
	    value = arr[i];
	    if (func(value, i, arr)) {
	      return value;
	    }
	  }
	  return null;
	}
	
	
	/**
	 * @param {Array|Uint8ClampedArray} arr1 The first array to compare.
	 * @param {Array|Uint8ClampedArray} arr2 The second array to compare.
	 * @return {boolean} Whether the two arrays are equal.
	 * @api
	 */
	function equals(arr1, arr2) {
	  var len1 = arr1.length;
	  if (len1 !== arr2.length) {
	    return false;
	  }
	  for (var i = 0; i < len1; i++) {
	    if (arr1[i] !== arr2[i]) {
	      return false;
	    }
	  }
	  return true;
	}
	
	
	/**
	 * Sort the passed array such that the relative order of equal elements is preverved.
	 * See https://en.wikipedia.org/wiki/Sorting_algorithm#Stability for details.
	 * @param {Array<*>} arr The array to sort (modifies original).
	 * @param {!function(*, *): number} compareFnc Comparison function.
	 * @api
	 */
	function stableSort(arr, compareFnc) {
	  var length = arr.length;
	  var tmp = Array(arr.length);
	  var i;
	  for (i = 0; i < length; i++) {
	    tmp[i] = {index: i, value: arr[i]};
	  }
	  tmp.sort(function(a, b) {
	    return compareFnc(a.value, b.value) || a.index - b.index;
	  });
	  for (i = 0; i < arr.length; i++) {
	    arr[i] = tmp[i].value;
	  }
	}
	
	
	/**
	 * @param {Array<*>} arr The array to search in.
	 * @param {Function} func Comparison function.
	 * @return {number} Return index.
	 */
	function findIndex(arr, func) {
	  var index;
	  var found = !arr.every(function(el, idx) {
	    index = idx;
	    return !func(el, idx, arr);
	  });
	  return found ? index : -1;
	}
	
	
	/**
	 * @param {Array<*>} arr The array to test.
	 * @param {Function=} opt_func Comparison function.
	 * @param {boolean=} opt_strict Strictly sorted (default false).
	 * @return {boolean} Return index.
	 */
	function isSorted(arr, opt_func, opt_strict) {
	  var compare = opt_func || numberSafeCompareFunction;
	  return arr.every(function(currentVal, index) {
	    if (index === 0) {
	      return true;
	    }
	    var res = compare(arr[index - 1], currentVal);
	    return !(res > 0 || opt_strict && res === 0);
	  });
	}
	
	/**
	 * @module ol/extent/Corner
	 */
	
	/**
	 * Extent corner.
	 * @enum {string}
	 */
	var Corner = {
	  BOTTOM_LEFT: 'bottom-left',
	  BOTTOM_RIGHT: 'bottom-right',
	  TOP_LEFT: 'top-left',
	  TOP_RIGHT: 'top-right'
	};
	
	/**
	 * @module ol/extent/Relationship
	 */
	
	/**
	 * Relationship to an extent.
	 * @enum {number}
	 */
	var Relationship = {
	  UNKNOWN: 0,
	  INTERSECTING: 1,
	  ABOVE: 2,
	  RIGHT: 4,
	  BELOW: 8,
	  LEFT: 16
	};
	
	/**
	 * @module ol/extent
	 */
	
	
	/**
	 * An array of numbers representing an extent: `[minx, miny, maxx, maxy]`.
	 * @typedef {Array<number>} Extent
	 * @api
	 */
	
	/**
	 * Build an extent that includes all given coordinates.
	 *
	 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
	 * @return {Extent} Bounding extent.
	 * @api
	 */
	function boundingExtent(coordinates) {
	  var extent = createEmpty();
	  for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	    extendCoordinate(extent, coordinates[i]);
	  }
	  return extent;
	}
	
	
	/**
	 * @param {Array<number>} xs Xs.
	 * @param {Array<number>} ys Ys.
	 * @param {Extent=} opt_extent Destination extent.
	 * @private
	 * @return {Extent} Extent.
	 */
	function _boundingExtentXYs(xs, ys, opt_extent) {
	  var minX = Math.min.apply(null, xs);
	  var minY = Math.min.apply(null, ys);
	  var maxX = Math.max.apply(null, xs);
	  var maxY = Math.max.apply(null, ys);
	  return createOrUpdate(minX, minY, maxX, maxY, opt_extent);
	}
	
	
	/**
	 * Return extent increased by the provided value.
	 * @param {Extent} extent Extent.
	 * @param {number} value The amount by which the extent should be buffered.
	 * @param {Extent=} opt_extent Extent.
	 * @return {Extent} Extent.
	 * @api
	 */
	function buffer(extent, value, opt_extent) {
	  if (opt_extent) {
	    opt_extent[0] = extent[0] - value;
	    opt_extent[1] = extent[1] - value;
	    opt_extent[2] = extent[2] + value;
	    opt_extent[3] = extent[3] + value;
	    return opt_extent;
	  } else {
	    return [
	      extent[0] - value,
	      extent[1] - value,
	      extent[2] + value,
	      extent[3] + value
	    ];
	  }
	}
	
	
	/**
	 * Creates a clone of an extent.
	 *
	 * @param {Extent} extent Extent to clone.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} The clone.
	 */
	function clone(extent, opt_extent) {
	  if (opt_extent) {
	    opt_extent[0] = extent[0];
	    opt_extent[1] = extent[1];
	    opt_extent[2] = extent[2];
	    opt_extent[3] = extent[3];
	    return opt_extent;
	  } else {
	    return extent.slice();
	  }
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @api
	 * @return {number} Closest squared distance.
	 */
	function closestSquaredDistanceXY(extent, x, y) {
	  var dx, dy;
	  if (x < extent[0]) {
	    dx = extent[0] - x;
	  } else if (extent[2] < x) {
	    dx = x - extent[2];
	  } else {
	    dx = 0;
	  }
	  if (y < extent[1]) {
	    dy = extent[1] - y;
	  } else if (extent[3] < y) {
	    dy = y - extent[3];
	  } else {
	    dy = 0;
	  }
	  return dx * dx + dy * dy;
	}
	
	
	/**
	 * Check if the passed coordinate is contained or on the edge of the extent.
	 *
	 * @param {Extent} extent Extent.
	 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
	 * @return {boolean} The coordinate is contained in the extent.
	 * @api
	 */
	function containsCoordinate(extent, coordinate) {
	  return containsXY(extent, coordinate[0], coordinate[1]);
	}
	
	
	/**
	 * Check if one extent contains another.
	 *
	 * An extent is deemed contained if it lies completely within the other extent,
	 * including if they share one or more edges.
	 *
	 * @param {Extent} extent1 Extent 1.
	 * @param {Extent} extent2 Extent 2.
	 * @return {boolean} The second extent is contained by or on the edge of the
	 *     first.
	 * @api
	 */
	function containsExtent(extent1, extent2) {
	  return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] &&
	      extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
	}
	
	
	/**
	 * Check if the passed coordinate is contained or on the edge of the extent.
	 *
	 * @param {Extent} extent Extent.
	 * @param {number} x X coordinate.
	 * @param {number} y Y coordinate.
	 * @return {boolean} The x, y values are contained in the extent.
	 * @api
	 */
	function containsXY(extent, x, y) {
	  return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
	}
	
	
	/**
	 * Get the relationship between a coordinate and extent.
	 * @param {Extent} extent The extent.
	 * @param {import("./coordinate.js").Coordinate} coordinate The coordinate.
	 * @api
	 * @return {Relationship} The relationship (bitwise compare with
	 *     import("./extent/Relationship.js").Relationship).
	 */
	function coordinateRelationship(extent, coordinate) {
	  var minX = extent[0];
	  var minY = extent[1];
	  var maxX = extent[2];
	  var maxY = extent[3];
	  var x = coordinate[0];
	  var y = coordinate[1];
	  var relationship = Relationship.UNKNOWN;
	  if (x < minX) {
	    relationship = relationship | Relationship.LEFT;
	  } else if (x > maxX) {
	    relationship = relationship | Relationship.RIGHT;
	  }
	  if (y < minY) {
	    relationship = relationship | Relationship.BELOW;
	  } else if (y > maxY) {
	    relationship = relationship | Relationship.ABOVE;
	  }
	  if (relationship === Relationship.UNKNOWN) {
	    relationship = Relationship.INTERSECTING;
	  }
	  return relationship;
	}
	
	
	/**
	 * Create an empty extent.
	 * @return {Extent} Empty extent.
	 * @api
	 */
	function createEmpty() {
	  return [Infinity, Infinity, -Infinity, -Infinity];
	}
	
	
	/**
	 * Create a new extent or update the provided extent.
	 * @param {number} minX Minimum X.
	 * @param {number} minY Minimum Y.
	 * @param {number} maxX Maximum X.
	 * @param {number} maxY Maximum Y.
	 * @param {Extent=} opt_extent Destination extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function createOrUpdate(minX, minY, maxX, maxY, opt_extent) {
	  if (opt_extent) {
	    opt_extent[0] = minX;
	    opt_extent[1] = minY;
	    opt_extent[2] = maxX;
	    opt_extent[3] = maxY;
	    return opt_extent;
	  } else {
	    return [minX, minY, maxX, maxY];
	  }
	}
	
	
	/**
	 * Create a new empty extent or make the provided one empty.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function createOrUpdateEmpty(opt_extent) {
	  return createOrUpdate(
	    Infinity, Infinity, -Infinity, -Infinity, opt_extent);
	}
	
	
	/**
	 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function createOrUpdateFromCoordinate(coordinate, opt_extent) {
	  var x = coordinate[0];
	  var y = coordinate[1];
	  return createOrUpdate(x, y, x, y, opt_extent);
	}
	
	
	/**
	 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function createOrUpdateFromCoordinates(coordinates, opt_extent) {
	  var extent = createOrUpdateEmpty(opt_extent);
	  return extendCoordinates(extent, coordinates);
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function createOrUpdateFromFlatCoordinates(flatCoordinates, offset, end, stride, opt_extent) {
	  var extent = createOrUpdateEmpty(opt_extent);
	  return extendFlatCoordinates(extent, flatCoordinates, offset, end, stride);
	}
	
	/**
	 * @param {Array<Array<import("./coordinate.js").Coordinate>>} rings Rings.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function createOrUpdateFromRings(rings, opt_extent) {
	  var extent = createOrUpdateEmpty(opt_extent);
	  return extendRings(extent, rings);
	}
	
	
	/**
	 * Determine if two extents are equivalent.
	 * @param {Extent} extent1 Extent 1.
	 * @param {Extent} extent2 Extent 2.
	 * @return {boolean} The two extents are equivalent.
	 * @api
	 */
	function equals$1(extent1, extent2) {
	  return extent1[0] == extent2[0] && extent1[2] == extent2[2] &&
	      extent1[1] == extent2[1] && extent1[3] == extent2[3];
	}
	
	
	/**
	 * Modify an extent to include another extent.
	 * @param {Extent} extent1 The extent to be modified.
	 * @param {Extent} extent2 The extent that will be included in the first.
	 * @return {Extent} A reference to the first (extended) extent.
	 * @api
	 */
	function extend$1(extent1, extent2) {
	  if (extent2[0] < extent1[0]) {
	    extent1[0] = extent2[0];
	  }
	  if (extent2[2] > extent1[2]) {
	    extent1[2] = extent2[2];
	  }
	  if (extent2[1] < extent1[1]) {
	    extent1[1] = extent2[1];
	  }
	  if (extent2[3] > extent1[3]) {
	    extent1[3] = extent2[3];
	  }
	  return extent1;
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
	 * @api
	 */
	function extendCoordinate(extent, coordinate) {
	  if (coordinate[0] < extent[0]) {
	    extent[0] = coordinate[0];
	  }
	  if (coordinate[0] > extent[2]) {
	    extent[2] = coordinate[0];
	  }
	  if (coordinate[1] < extent[1]) {
	    extent[1] = coordinate[1];
	  }
	  if (coordinate[1] > extent[3]) {
	    extent[3] = coordinate[1];
	  }
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
	 * @api
	 * @return {Extent} Extent.
	 */
	function extendCoordinates(extent, coordinates) {
	  for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	    extendCoordinate(extent, coordinates[i]);
	  }
	  return extent;
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @api
	 * @return {Extent} Extent.
	 */
	function extendFlatCoordinates(extent, flatCoordinates, offset, end, stride) {
	  for (; offset < end; offset += stride) {
	    extendXY(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
	  }
	  return extent;
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {Array<Array<import("./coordinate.js").Coordinate>>} rings Rings.
	 * @api
	 * @return {Extent} Extent.
	 */
	function extendRings(extent, rings) {
	  for (var i = 0, ii = rings.length; i < ii; ++i) {
	    extendCoordinates(extent, rings[i]);
	  }
	  return extent;
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @api
	 */
	function extendXY(extent, x, y) {
	  extent[0] = Math.min(extent[0], x);
	  extent[1] = Math.min(extent[1], y);
	  extent[2] = Math.max(extent[2], x);
	  extent[3] = Math.max(extent[3], y);
	}
	
	
	/**
	 * This function calls `callback` for each corner of the extent. If the
	 * callback returns a truthy value the function returns that value
	 * immediately. Otherwise the function returns `false`.
	 * @param {Extent} extent Extent.
	 * @param {function(this:T, import("./coordinate.js").Coordinate): S} callback Callback.
	 * @param {T=} opt_this Value to use as `this` when executing `callback`.
	 * @api
	 * @return {S|boolean} Value.
	 * @template S, T
	 */
	function forEachCorner(extent, callback, opt_this) {
	  var val;
	  val = callback.call(opt_this, getBottomLeft(extent));
	  if (val) {
	    return val;
	  }
	  val = callback.call(opt_this, getBottomRight(extent));
	  if (val) {
	    return val;
	  }
	  val = callback.call(opt_this, getTopRight(extent));
	  if (val) {
	    return val;
	  }
	  val = callback.call(opt_this, getTopLeft(extent));
	  if (val) {
	    return val;
	  }
	  return false;
	}
	
	
	/**
	 * Get the size of an extent.
	 * @param {Extent} extent Extent.
	 * @return {number} Area.
	 * @api
	 */
	function getArea(extent) {
	  var area = 0;
	  if (!isEmpty$1(extent)) {
	    area = getWidth(extent) * getHeight(extent);
	  }
	  return area;
	}
	
	
	/**
	 * Get the bottom left coordinate of an extent.
	 * @param {Extent} extent Extent.
	 * @return {import("./coordinate.js").Coordinate} Bottom left coordinate.
	 * @api
	 */
	function getBottomLeft(extent) {
	  return [extent[0], extent[1]];
	}
	
	
	/**
	 * Get the bottom right coordinate of an extent.
	 * @param {Extent} extent Extent.
	 * @return {import("./coordinate.js").Coordinate} Bottom right coordinate.
	 * @api
	 */
	function getBottomRight(extent) {
	  return [extent[2], extent[1]];
	}
	
	
	/**
	 * Get the center coordinate of an extent.
	 * @param {Extent} extent Extent.
	 * @return {import("./coordinate.js").Coordinate} Center.
	 * @api
	 */
	function getCenter(extent) {
	  return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
	}
	
	
	/**
	 * Get a corner coordinate of an extent.
	 * @param {Extent} extent Extent.
	 * @param {Corner} corner Corner.
	 * @api
	 * @return {import("./coordinate.js").Coordinate} Corner coordinate.
	 */
	function getCorner(extent, corner) {
	  var coordinate;
	  if (corner === Corner.BOTTOM_LEFT) {
	    coordinate = getBottomLeft(extent);
	  } else if (corner === Corner.BOTTOM_RIGHT) {
	    coordinate = getBottomRight(extent);
	  } else if (corner === Corner.TOP_LEFT) {
	    coordinate = getTopLeft(extent);
	  } else if (corner === Corner.TOP_RIGHT) {
	    coordinate = getTopRight(extent);
	  } else {
	    assert(false, 13); // Invalid corner
	  }
	  return coordinate;
	}
	
	
	/**
	 * @param {Extent} extent1 Extent 1.
	 * @param {Extent} extent2 Extent 2.
	 * @api
	 * @return {number} Enlarged area.
	 */
	function getEnlargedArea(extent1, extent2) {
	  var minX = Math.min(extent1[0], extent2[0]);
	  var minY = Math.min(extent1[1], extent2[1]);
	  var maxX = Math.max(extent1[2], extent2[2]);
	  var maxY = Math.max(extent1[3], extent2[3]);
	  return (maxX - minX) * (maxY - minY);
	}
	
	
	/**
	 * @param {import("./coordinate.js").Coordinate} center Center.
	 * @param {number} resolution Resolution.
	 * @param {number} rotation Rotation.
	 * @param {import("./size.js").Size} size Size.
	 * @param {Extent=} opt_extent Destination extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function getForViewAndSize(center, resolution, rotation, size, opt_extent) {
	  var dx = resolution * size[0] / 2;
	  var dy = resolution * size[1] / 2;
	  var cosRotation = Math.cos(rotation);
	  var sinRotation = Math.sin(rotation);
	  var xCos = dx * cosRotation;
	  var xSin = dx * sinRotation;
	  var yCos = dy * cosRotation;
	  var ySin = dy * sinRotation;
	  var x = center[0];
	  var y = center[1];
	  var x0 = x - xCos + ySin;
	  var x1 = x - xCos - ySin;
	  var x2 = x + xCos - ySin;
	  var x3 = x + xCos + ySin;
	  var y0 = y - xSin - yCos;
	  var y1 = y - xSin + yCos;
	  var y2 = y + xSin + yCos;
	  var y3 = y + xSin - yCos;
	  return createOrUpdate(
	    Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3),
	    Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3),
	    opt_extent);
	}
	
	
	/**
	 * Get the height of an extent.
	 * @param {Extent} extent Extent.
	 * @return {number} Height.
	 * @api
	 */
	function getHeight(extent) {
	  return extent[3] - extent[1];
	}
	
	
	/**
	 * @param {Extent} extent1 Extent 1.
	 * @param {Extent} extent2 Extent 2.
	 * @api
	 * @return {number} Intersection area.
	 */
	function getIntersectionArea(extent1, extent2) {
	  var intersection = getIntersection(extent1, extent2);
	  return getArea(intersection);
	}
	
	
	/**
	 * Get the intersection of two extents.
	 * @param {Extent} extent1 Extent 1.
	 * @param {Extent} extent2 Extent 2.
	 * @param {Extent=} opt_extent Optional extent to populate with intersection.
	 * @return {Extent} Intersecting extent.
	 * @api
	 */
	function getIntersection(extent1, extent2, opt_extent) {
	  var intersection = opt_extent ? opt_extent : createEmpty();
	  if (intersects(extent1, extent2)) {
	    if (extent1[0] > extent2[0]) {
	      intersection[0] = extent1[0];
	    } else {
	      intersection[0] = extent2[0];
	    }
	    if (extent1[1] > extent2[1]) {
	      intersection[1] = extent1[1];
	    } else {
	      intersection[1] = extent2[1];
	    }
	    if (extent1[2] < extent2[2]) {
	      intersection[2] = extent1[2];
	    } else {
	      intersection[2] = extent2[2];
	    }
	    if (extent1[3] < extent2[3]) {
	      intersection[3] = extent1[3];
	    } else {
	      intersection[3] = extent2[3];
	    }
	  } else {
	    createOrUpdateEmpty(intersection);
	  }
	  return intersection;
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @api
	 * @return {number} Margin.
	 */
	function getMargin(extent) {
	  return getWidth(extent) + getHeight(extent);
	}
	
	
	/**
	 * Get the size (width, height) of an extent.
	 * @param {Extent} extent The extent.
	 * @return {import("./size.js").Size} The extent size.
	 * @api
	 */
	function getSize(extent) {
	  return [extent[2] - extent[0], extent[3] - extent[1]];
	}
	
	
	/**
	 * Get the top left coordinate of an extent.
	 * @param {Extent} extent Extent.
	 * @return {import("./coordinate.js").Coordinate} Top left coordinate.
	 * @api
	 */
	function getTopLeft(extent) {
	  return [extent[0], extent[3]];
	}
	
	
	/**
	 * Get the top right coordinate of an extent.
	 * @param {Extent} extent Extent.
	 * @return {import("./coordinate.js").Coordinate} Top right coordinate.
	 * @api
	 */
	function getTopRight(extent) {
	  return [extent[2], extent[3]];
	}
	
	
	/**
	 * Get the width of an extent.
	 * @param {Extent} extent Extent.
	 * @return {number} Width.
	 * @api
	 */
	function getWidth(extent) {
	  return extent[2] - extent[0];
	}
	
	
	/**
	 * Determine if one extent intersects another.
	 * @param {Extent} extent1 Extent 1.
	 * @param {Extent} extent2 Extent.
	 * @return {boolean} The two extents intersect.
	 * @api
	 */
	function intersects(extent1, extent2) {
	  return extent1[0] <= extent2[2] &&
	      extent1[2] >= extent2[0] &&
	      extent1[1] <= extent2[3] &&
	      extent1[3] >= extent2[1];
	}
	
	
	/**
	 * Determine if an extent is empty.
	 * @param {Extent} extent Extent.
	 * @return {boolean} Is empty.
	 * @api
	 */
	function isEmpty$1(extent) {
	  return extent[2] < extent[0] || extent[3] < extent[1];
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {Extent=} opt_extent Extent.
	 * @api
	 * @return {Extent} Extent.
	 */
	function returnOrUpdate(extent, opt_extent) {
	  if (opt_extent) {
	    opt_extent[0] = extent[0];
	    opt_extent[1] = extent[1];
	    opt_extent[2] = extent[2];
	    opt_extent[3] = extent[3];
	    return opt_extent;
	  } else {
	    return extent;
	  }
	}
	
	
	/**
	 * @param {Extent} extent Extent.
	 * @param {number} value Value.
	 * @api
	 */
	function scaleFromCenter(extent, value) {
	  var deltaX = ((extent[2] - extent[0]) / 2) * (value - 1);
	  var deltaY = ((extent[3] - extent[1]) / 2) * (value - 1);
	  extent[0] -= deltaX;
	  extent[2] += deltaX;
	  extent[1] -= deltaY;
	  extent[3] += deltaY;
	}
	
	
	/**
	 * Determine if the segment between two coordinates intersects (crosses,
	 * touches, or is contained by) the provided extent.
	 * @param {Extent} extent The extent.
	 * @param {import("./coordinate.js").Coordinate} start Segment start coordinate.
	 * @param {import("./coordinate.js").Coordinate} end Segment end coordinate.
	 * @api
	 * @return {boolean} The segment intersects the extent.
	 */
	function intersectsSegment(extent, start, end) {
	  var intersects = false;
	  var startRel = coordinateRelationship(extent, start);
	  var endRel = coordinateRelationship(extent, end);
	  if (startRel === Relationship.INTERSECTING ||
	      endRel === Relationship.INTERSECTING) {
	    intersects = true;
	  } else {
	    var minX = extent[0];
	    var minY = extent[1];
	    var maxX = extent[2];
	    var maxY = extent[3];
	    var startX = start[0];
	    var startY = start[1];
	    var endX = end[0];
	    var endY = end[1];
	    var slope = (endY - startY) / (endX - startX);
	    var x, y;
	    if (!!(endRel & Relationship.ABOVE) &&
	        !(startRel & Relationship.ABOVE)) {
	      // potentially intersects top
	      x = endX - ((endY - maxY) / slope);
	      intersects = x >= minX && x <= maxX;
	    }
	    if (!intersects && !!(endRel & Relationship.RIGHT) &&
	        !(startRel & Relationship.RIGHT)) {
	      // potentially intersects right
	      y = endY - ((endX - maxX) * slope);
	      intersects = y >= minY && y <= maxY;
	    }
	    if (!intersects && !!(endRel & Relationship.BELOW) &&
	        !(startRel & Relationship.BELOW)) {
	      // potentially intersects bottom
	      x = endX - ((endY - minY) / slope);
	      intersects = x >= minX && x <= maxX;
	    }
	    if (!intersects && !!(endRel & Relationship.LEFT) &&
	        !(startRel & Relationship.LEFT)) {
	      // potentially intersects left
	      y = endY - ((endX - minX) * slope);
	      intersects = y >= minY && y <= maxY;
	    }
	
	  }
	  return intersects;
	}
	
	
	/**
	 * Apply a transform function to the extent.
	 * @param {Extent} extent Extent.
	 * @param {import("./proj.js").TransformFunction} transformFn Transform function.
	 * Called with `[minX, minY, maxX, maxY]` extent coordinates.
	 * @param {Extent=} opt_extent Destination extent.
	 * @return {Extent} Extent.
	 * @api
	 */
	function applyTransform(extent, transformFn, opt_extent) {
	  var coordinates = [
	    extent[0], extent[1],
	    extent[0], extent[3],
	    extent[2], extent[1],
	    extent[2], extent[3]
	  ];
	  transformFn(coordinates, coordinates, 2);
	  var xs = [coordinates[0], coordinates[2], coordinates[4], coordinates[6]];
	  var ys = [coordinates[1], coordinates[3], coordinates[5], coordinates[7]];
	  return _boundingExtentXYs(xs, ys, opt_extent);
	}
	
	/**
	 * @module ol/geom/GeometryLayout
	 */
	
	/**
	 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
	 * or measure ('M') coordinate is available. Supported values are `'XY'`,
	 * `'XYZ'`, `'XYM'`, `'XYZM'`.
	 * @enum {string}
	 */
	var GeometryLayout = {
	  XY: 'XY',
	  XYZ: 'XYZ',
	  XYM: 'XYM',
	  XYZM: 'XYZM'
	};
	
	/**
	 * @module ol/geom/GeometryType
	 */
	
	/**
	 * The geometry type. One of `'Point'`, `'LineString'`, `'LinearRing'`,
	 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
	 * `'GeometryCollection'`, `'Circle'`.
	 * @enum {string}
	 */
	var GeometryType = {
	  POINT: 'Point',
	  LINE_STRING: 'LineString',
	  LINEAR_RING: 'LinearRing',
	  POLYGON: 'Polygon',
	  MULTI_POINT: 'MultiPoint',
	  MULTI_LINE_STRING: 'MultiLineString',
	  MULTI_POLYGON: 'MultiPolygon',
	  GEOMETRY_COLLECTION: 'GeometryCollection',
	  CIRCLE: 'Circle'
	};
	
	/**
	 * @module ol/geom/flat/transform
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {import("../../transform.js").Transform} transform Transform.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Transformed coordinates.
	 * @api
	 */
	function transform2D(flatCoordinates, offset, end, stride, transform, opt_dest) {
	  var dest = opt_dest ? opt_dest : [];
	  var i = 0;
	  for (var j = offset; j < end; j += stride) {
	    var x = flatCoordinates[j];
	    var y = flatCoordinates[j + 1];
	    dest[i++] = transform[0] * x + transform[2] * y + transform[4];
	    dest[i++] = transform[1] * x + transform[3] * y + transform[5];
	  }
	  if (opt_dest && dest.length != i) {
	    dest.length = i;
	  }
	  return dest;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} angle Angle.
	 * @param {Array<number>} anchor Rotation anchor point.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Transformed coordinates.
	 */
	function rotate(flatCoordinates, offset, end, stride, angle, anchor, opt_dest) {
	  var dest = opt_dest ? opt_dest : [];
	  var cos = Math.cos(angle);
	  var sin = Math.sin(angle);
	  var anchorX = anchor[0];
	  var anchorY = anchor[1];
	  var i = 0;
	  for (var j = offset; j < end; j += stride) {
	    var deltaX = flatCoordinates[j] - anchorX;
	    var deltaY = flatCoordinates[j + 1] - anchorY;
	    dest[i++] = anchorX + deltaX * cos - deltaY * sin;
	    dest[i++] = anchorY + deltaX * sin + deltaY * cos;
	    for (var k = j + 2; k < j + stride; ++k) {
	      dest[i++] = flatCoordinates[k];
	    }
	  }
	  if (opt_dest && dest.length != i) {
	    dest.length = i;
	  }
	  return dest;
	}
	
	
	/**
	 * Scale the coordinates.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} sx Scale factor in the x-direction.
	 * @param {number} sy Scale factor in the y-direction.
	 * @param {Array<number>} anchor Scale anchor point.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Transformed coordinates.
	 */
	function scale(flatCoordinates, offset, end, stride, sx, sy, anchor, opt_dest) {
	  var dest = opt_dest ? opt_dest : [];
	  var anchorX = anchor[0];
	  var anchorY = anchor[1];
	  var i = 0;
	  for (var j = offset; j < end; j += stride) {
	    var deltaX = flatCoordinates[j] - anchorX;
	    var deltaY = flatCoordinates[j + 1] - anchorY;
	    dest[i++] = anchorX + sx * deltaX;
	    dest[i++] = anchorY + sy * deltaY;
	    for (var k = j + 2; k < j + stride; ++k) {
	      dest[i++] = flatCoordinates[k];
	    }
	  }
	  if (opt_dest && dest.length != i) {
	    dest.length = i;
	  }
	  return dest;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} deltaX Delta X.
	 * @param {number} deltaY Delta Y.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Transformed coordinates.
	 */
	function translate(flatCoordinates, offset, end, stride, deltaX, deltaY, opt_dest) {
	  var dest = opt_dest ? opt_dest : [];
	  var i = 0;
	  for (var j = offset; j < end; j += stride) {
	    dest[i++] = flatCoordinates[j] + deltaX;
	    dest[i++] = flatCoordinates[j + 1] + deltaY;
	    for (var k = j + 2; k < j + stride; ++k) {
	      dest[i++] = flatCoordinates[k];
	    }
	  }
	  if (opt_dest && dest.length != i) {
	    dest.length = i;
	  }
	  return dest;
	}
	
	/**
	 * @module ol/math
	 */
	
	/**
	 * Takes a number and clamps it to within the provided bounds.
	 * @param {number} value The input number.
	 * @param {number} min The minimum value to return.
	 * @param {number} max The maximum value to return.
	 * @return {number} The input number if it is within bounds, or the nearest
	 *     number within the bounds.
	 * @api
	 */
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}
	
	
	/**
	 * Return the hyperbolic cosine of a given number. The method will use the
	 * native `Math.cosh` function if it is available, otherwise the hyperbolic
	 * cosine will be calculated via the reference implementation of the Mozilla
	 * developer network.
	 *
	 * @param {number} x X.
	 * @return {number} Hyperbolic cosine of x.
	 * @api
	 */
	var cosh = (function() {
	  // Wrapped in a iife, to save the overhead of checking for the native
	  // implementation on every invocation.
	  var cosh;
	  if ('cosh' in Math) {
	    // The environment supports the native Math.cosh function, use it…
	    cosh = Math.cosh;
	  } else {
	    // … else, use the reference implementation of MDN:
	    cosh = function(x) {
	      var y = /** @type {Math} */ (Math).exp(x);
	      return (y + 1 / y) / 2;
	    };
	  }
	  return cosh;
	}());
	
	
	/**
	 * @param {number} x X.
	 * @return {number} The smallest power of two greater than or equal to x.
	 * @api
	 */
	function roundUpToPowerOfTwo(x) {
	  assert(0 < x, 29); // `x` must be greater than `0`
	  return Math.pow(2, Math.ceil(Math.log(x) / Math.LN2));
	}
	
	
	/**
	 * Returns the square of the closest distance between the point (x, y) and the
	 * line segment (x1, y1) to (x2, y2).
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {number} x1 X1.
	 * @param {number} y1 Y1.
	 * @param {number} x2 X2.
	 * @param {number} y2 Y2.
	 * @return {number} Squared distance.
	 * @api
	 */
	function squaredSegmentDistance(x, y, x1, y1, x2, y2) {
	  var dx = x2 - x1;
	  var dy = y2 - y1;
	  if (dx !== 0 || dy !== 0) {
	    var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
	    if (t > 1) {
	      x1 = x2;
	      y1 = y2;
	    } else if (t > 0) {
	      x1 += dx * t;
	      y1 += dy * t;
	    }
	  }
	  return squaredDistance(x, y, x1, y1);
	}
	
	
	/**
	 * Returns the square of the distance between the points (x1, y1) and (x2, y2).
	 * @param {number} x1 X1.
	 * @param {number} y1 Y1.
	 * @param {number} x2 X2.
	 * @param {number} y2 Y2.
	 * @return {number} Squared distance.
	 * @api
	 */
	function squaredDistance(x1, y1, x2, y2) {
	  var dx = x2 - x1;
	  var dy = y2 - y1;
	  return dx * dx + dy * dy;
	}
	
	
	/**
	 * Solves system of linear equations using Gaussian elimination method.
	 *
	 * @param {Array<Array<number>>} mat Augmented matrix (n x n + 1 column)
	 *                                     in row-major order.
	 * @return {Array<number>} The resulting vector.
	 * @api
	 */
	function solveLinearSystem(mat) {
	  var n = mat.length;
	
	  for (var i = 0; i < n; i++) {
	    // Find max in the i-th column (ignoring i - 1 first rows)
	    var maxRow = i;
	    var maxEl = Math.abs(mat[i][i]);
	    for (var r = i + 1; r < n; r++) {
	      var absValue = Math.abs(mat[r][i]);
	      if (absValue > maxEl) {
	        maxEl = absValue;
	        maxRow = r;
	      }
	    }
	
	    if (maxEl === 0) {
	      return null; // matrix is singular
	    }
	
	    // Swap max row with i-th (current) row
	    var tmp = mat[maxRow];
	    mat[maxRow] = mat[i];
	    mat[i] = tmp;
	
	    // Subtract the i-th row to make all the remaining rows 0 in the i-th column
	    for (var j = i + 1; j < n; j++) {
	      var coef = -mat[j][i] / mat[i][i];
	      for (var k = i; k < n + 1; k++) {
	        if (i == k) {
	          mat[j][k] = 0;
	        } else {
	          mat[j][k] += coef * mat[i][k];
	        }
	      }
	    }
	  }
	
	  // Solve Ax=b for upper triangular matrix A (mat)
	  var x = new Array(n);
	  for (var l = n - 1; l >= 0; l--) {
	    x[l] = mat[l][n] / mat[l][l];
	    for (var m = l - 1; m >= 0; m--) {
	      mat[m][n] -= mat[m][l] * x[l];
	    }
	  }
	  return x;
	}
	
	
	/**
	 * Converts radians to to degrees.
	 *
	 * @param {number} angleInRadians Angle in radians.
	 * @return {number} Angle in degrees.
	 * @api
	 */
	function toDegrees(angleInRadians) {
	  return angleInRadians * 180 / Math.PI;
	}
	
	
	/**
	 * Converts degrees to radians.
	 *
	 * @param {number} angleInDegrees Angle in degrees.
	 * @return {number} Angle in radians.
	 * @api
	 */
	function toRadians(angleInDegrees) {
	  return angleInDegrees * Math.PI / 180;
	}
	
	/**
	 * Returns the modulo of a / b, depending on the sign of b.
	 *
	 * @param {number} a Dividend.
	 * @param {number} b Divisor.
	 * @return {number} Modulo.
	 * @api
	 */
	function modulo(a, b) {
	  var r = a % b;
	  return r * b < 0 ? r + b : r;
	}
	
	/**
	 * Calculates the linearly interpolated value of x between a and b.
	 *
	 * @param {number} a Number
	 * @param {number} b Number
	 * @param {number} x Value to be interpolated.
	 * @return {number} Interpolated value.
	 * @api
	 */
	function lerp(a, b, x) {
	  return a + x * (b - a);
	}
	
	/**
	 * @license
	 * Latitude/longitude spherical geodesy formulae taken from
	 * http://www.movable-type.co.uk/scripts/latlong.html
	 * Licensed under CC-BY-3.0.
	 */
	
	
	/**
	 * Object literal with options for the {@link getLength} or {@link getArea}
	 * functions.
	 * @typedef {Object} SphereMetricOptions
	 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857']
	 * Projection of the  geometry.  By default, the geometry is assumed to be in
	 * Web Mercator.
	 * @property {number} [radius=6371008.8] Sphere radius.  By default, the radius of the
	 * earth is used (Clarke 1866 Authalic Sphere).
	 */
	
	
	/**
	 * The mean Earth radius (1/3 * (2a + b)) for the WGS84 ellipsoid.
	 * https://en.wikipedia.org/wiki/Earth_radius#Mean_radius
	 * @type {number}
	 */
	var DEFAULT_RADIUS = 6371008.8;
	
	
	/**
	 * Get the great circle distance (in meters) between two geographic coordinates.
	 * @param {Array} c1 Starting coordinate.
	 * @param {Array} c2 Ending coordinate.
	 * @param {number=} opt_radius The sphere radius to use.  Defaults to the Earth's
	 *     mean radius using the WGS84 ellipsoid.
	 * @return {number} The great circle distance between the points (in meters).
	 * @api
	 */
	function getDistance(c1, c2, opt_radius) {
	  var radius = opt_radius || DEFAULT_RADIUS;
	  var lat1 = toRadians(c1[1]);
	  var lat2 = toRadians(c2[1]);
	  var deltaLatBy2 = (lat2 - lat1) / 2;
	  var deltaLonBy2 = toRadians(c2[0] - c1[0]) / 2;
	  var a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) +
	      Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) *
	      Math.cos(lat1) * Math.cos(lat2);
	  return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	}
	
	
	/**
	 * Get the cumulative great circle length of linestring coordinates (geographic).
	 * @param {Array} coordinates Linestring coordinates.
	 * @param {number} radius The sphere radius to use.
	 * @return {number} The length (in meters).
	 */
	function getLengthInternal(coordinates, radius) {
	  var length = 0;
	  for (var i = 0, ii = coordinates.length; i < ii - 1; ++i) {
	    length += getDistance(coordinates[i], coordinates[i + 1], radius);
	  }
	  return length;
	}
	
	
	/**
	 * Get the spherical length of a geometry.  This length is the sum of the
	 * great circle distances between coordinates.  For polygons, the length is
	 * the sum of all rings.  For points, the length is zero.  For multi-part
	 * geometries, the length is the sum of the length of each part.
	 * @param {import("./geom/Geometry.js").default} geometry A geometry.
	 * @param {SphereMetricOptions=} opt_options Options for the
	 * length calculation.  By default, geometries are assumed to be in 'EPSG:3857'.
	 * You can change this by providing a `projection` option.
	 * @return {number} The spherical length (in meters).
	 * @api
	 */
	function getLength(geometry, opt_options) {
	  var options = opt_options || {};
	  var radius = options.radius || DEFAULT_RADIUS;
	  var projection = options.projection || 'EPSG:3857';
	  var type = geometry.getType();
	  if (type !== GeometryType.GEOMETRY_COLLECTION) {
	    geometry = geometry.clone().transform(projection, 'EPSG:4326');
	  }
	  var length = 0;
	  var coordinates, coords, i, ii, j, jj;
	  switch (type) {
	    case GeometryType.POINT:
	    case GeometryType.MULTI_POINT: {
	      break;
	    }
	    case GeometryType.LINE_STRING:
	    case GeometryType.LINEAR_RING: {
	      coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
	      length = getLengthInternal(coordinates, radius);
	      break;
	    }
	    case GeometryType.MULTI_LINE_STRING:
	    case GeometryType.POLYGON: {
	      coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
	      for (i = 0, ii = coordinates.length; i < ii; ++i) {
	        length += getLengthInternal(coordinates[i], radius);
	      }
	      break;
	    }
	    case GeometryType.MULTI_POLYGON: {
	      coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
	      for (i = 0, ii = coordinates.length; i < ii; ++i) {
	        coords = coordinates[i];
	        for (j = 0, jj = coords.length; j < jj; ++j) {
	          length += getLengthInternal(coords[j], radius);
	        }
	      }
	      break;
	    }
	    case GeometryType.GEOMETRY_COLLECTION: {
	      var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ (geometry).getGeometries();
	      for (i = 0, ii = geometries.length; i < ii; ++i) {
	        length += getLength(geometries[i], opt_options);
	      }
	      break;
	    }
	    default: {
	      throw new Error('Unsupported geometry type: ' + type);
	    }
	  }
	  return length;
	}
	
	
	/**
	 * Returns the spherical area for a list of coordinates.
	 *
	 * [Reference](https://trs-new.jpl.nasa.gov/handle/2014/40409)
	 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
	 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
	 * Laboratory, Pasadena, CA, June 2007
	 *
	 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
	 * ring. If the ring is oriented clockwise, the area will be positive,
	 * otherwise it will be negative.
	 * @param {number} radius The sphere radius.
	 * @return {number} Area (in square meters).
	 */
	function getAreaInternal(coordinates, radius) {
	  var area = 0;
	  var len = coordinates.length;
	  var x1 = coordinates[len - 1][0];
	  var y1 = coordinates[len - 1][1];
	  for (var i = 0; i < len; i++) {
	    var x2 = coordinates[i][0];
	    var y2 = coordinates[i][1];
	    area += toRadians(x2 - x1) *
	        (2 + Math.sin(toRadians(y1)) +
	        Math.sin(toRadians(y2)));
	    x1 = x2;
	    y1 = y2;
	  }
	  return area * radius * radius / 2.0;
	}
	
	
	/**
	 * Get the spherical area of a geometry.  This is the area (in meters) assuming
	 * that polygon edges are segments of great circles on a sphere.
	 * @param {import("./geom/Geometry.js").default} geometry A geometry.
	 * @param {SphereMetricOptions=} opt_options Options for the area
	 *     calculation.  By default, geometries are assumed to be in 'EPSG:3857'.
	 *     You can change this by providing a `projection` option.
	 * @return {number} The spherical area (in square meters).
	 * @api
	 */
	function getArea$1(geometry, opt_options) {
	  var options = opt_options || {};
	  var radius = options.radius || DEFAULT_RADIUS;
	  var projection = options.projection || 'EPSG:3857';
	  var type = geometry.getType();
	  if (type !== GeometryType.GEOMETRY_COLLECTION) {
	    geometry = geometry.clone().transform(projection, 'EPSG:4326');
	  }
	  var area = 0;
	  var coordinates, coords, i, ii, j, jj;
	  switch (type) {
	    case GeometryType.POINT:
	    case GeometryType.MULTI_POINT:
	    case GeometryType.LINE_STRING:
	    case GeometryType.MULTI_LINE_STRING:
	    case GeometryType.LINEAR_RING: {
	      break;
	    }
	    case GeometryType.POLYGON: {
	      coordinates = /** @type {import("./geom/Polygon.js").default} */ (geometry).getCoordinates();
	      area = Math.abs(getAreaInternal(coordinates[0], radius));
	      for (i = 1, ii = coordinates.length; i < ii; ++i) {
	        area -= Math.abs(getAreaInternal(coordinates[i], radius));
	      }
	      break;
	    }
	    case GeometryType.MULTI_POLYGON: {
	      coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
	      for (i = 0, ii = coordinates.length; i < ii; ++i) {
	        coords = coordinates[i];
	        area += Math.abs(getAreaInternal(coords[0], radius));
	        for (j = 1, jj = coords.length; j < jj; ++j) {
	          area -= Math.abs(getAreaInternal(coords[j], radius));
	        }
	      }
	      break;
	    }
	    case GeometryType.GEOMETRY_COLLECTION: {
	      var geometries = /** @type {import("./geom/GeometryCollection.js").default} */ (geometry).getGeometries();
	      for (i = 0, ii = geometries.length; i < ii; ++i) {
	        area += getArea$1(geometries[i], opt_options);
	      }
	      break;
	    }
	    default: {
	      throw new Error('Unsupported geometry type: ' + type);
	    }
	  }
	  return area;
	}
	
	
	/**
	 * Returns the coordinate at the given distance and bearing from `c1`.
	 *
	 * @param {import("./coordinate.js").Coordinate} c1 The origin point (`[lon, lat]` in degrees).
	 * @param {number} distance The great-circle distance between the origin
	 *     point and the target point.
	 * @param {number} bearing The bearing (in radians).
	 * @param {number=} opt_radius The sphere radius to use.  Defaults to the Earth's
	 *     mean radius using the WGS84 ellipsoid.
	 * @return {import("./coordinate.js").Coordinate} The target point.
	 */
	function offset(c1, distance, bearing, opt_radius) {
	  var radius = opt_radius || DEFAULT_RADIUS;
	  var lat1 = toRadians(c1[1]);
	  var lon1 = toRadians(c1[0]);
	  var dByR = distance / radius;
	  var lat = Math.asin(
	    Math.sin(lat1) * Math.cos(dByR) +
	      Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
	  var lon = lon1 + Math.atan2(
	    Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1),
	    Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
	  return [toDegrees(lon), toDegrees(lat)];
	}
	
	/**
	 * @module ol/proj/Units
	 */
	
	/**
	 * Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or
	 * `'us-ft'`.
	 * @enum {string}
	 */
	var Units = {
	  DEGREES: 'degrees',
	  FEET: 'ft',
	  METERS: 'm',
	  PIXELS: 'pixels',
	  TILE_PIXELS: 'tile-pixels',
	  USFEET: 'us-ft'
	};
	
	
	/**
	 * Meters per unit lookup table.
	 * @const
	 * @type {Object<Units, number>}
	 * @api
	 */
	var METERS_PER_UNIT = {};
	// use the radius of the Normal sphere
	METERS_PER_UNIT[Units.DEGREES] = 2 * Math.PI * 6370997 / 360;
	METERS_PER_UNIT[Units.FEET] = 0.3048;
	METERS_PER_UNIT[Units.METERS] = 1;
	METERS_PER_UNIT[Units.USFEET] = 1200 / 3937;
	
	/**
	 * @module ol/proj/Projection
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
	 * @property {import("./Units.js").default|string} [units] Units. Required unless a
	 * proj4 projection is defined for `code`.
	 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
	 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
	 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
	 * @property {number} [metersPerUnit] The meters per unit for the SRS.
	 * If not provided, the `units` are used to get the meters per unit from the {@link module:ol/proj/Units~METERS_PER_UNIT}
	 * lookup table.
	 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
	 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
	 * Function to determine resolution at a point. The function is called with a
	 * `{number}` view resolution and an `{import("../coordinate.js").Coordinate}` as arguments, and returns
	 * the `{number}` resolution at the passed coordinate. If this is `undefined`,
	 * the default {@link module:ol/proj#getPointResolution} function will be used.
	 */
	
	
	/**
	 * @classdesc
	 * Projection definition class. One of these is created for each projection
	 * supported in the application and stored in the {@link module:ol/proj} namespace.
	 * You can use these in applications, but this is not required, as API params
	 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
	 * code will suffice.
	 *
	 * You can use {@link module:ol/proj~get} to retrieve the object for a particular
	 * projection.
	 *
	 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
	 * with the following aliases:
	 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
	 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
	 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
	 *     urn:x-ogc:def:crs:EPSG:4326
	 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
	 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
	 *     http://www.opengis.net/gml/srs/epsg.xml#3857
	 *
	 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
	 * be added using `proj4.defs()`. After all required projection definitions are
	 * added, call the {@link module:ol/proj/proj4~register} function.
	 *
	 * @api
	 */
	var Projection = function Projection(options) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this.code_ = options.code;
	
	  /**
	   * Units of projected coordinates. When set to `TILE_PIXELS`, a
	   * `this.extent_` and `this.worldExtent_` must be configured properly for each
	   * tile.
	   * @private
	   * @type {import("./Units.js").default}
	   */
	  this.units_ = /** @type {import("./Units.js").default} */ (options.units);
	
	  /**
	   * Validity extent of the projection in projected coordinates. For projections
	   * with `TILE_PIXELS` units, this is the extent of the tile in
	   * tile pixel space.
	   * @private
	   * @type {import("../extent.js").Extent}
	   */
	  this.extent_ = options.extent !== undefined ? options.extent : null;
	
	  /**
	   * Extent of the world in EPSG:4326. For projections with
	   * `TILE_PIXELS` units, this is the extent of the tile in
	   * projected coordinate space.
	   * @private
	   * @type {import("../extent.js").Extent}
	   */
	  this.worldExtent_ = options.worldExtent !== undefined ?
	    options.worldExtent : null;
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this.axisOrientation_ = options.axisOrientation !== undefined ?
	    options.axisOrientation : 'enu';
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  this.global_ = options.global !== undefined ? options.global : false;
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  this.canWrapX_ = !!(this.global_ && this.extent_);
	
	  /**
	   * @private
	   * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
	   */
	  this.getPointResolutionFunc_ = options.getPointResolution;
	
	  /**
	   * @private
	   * @type {import("../tilegrid/TileGrid.js").default}
	   */
	  this.defaultTileGrid_ = null;
	
	  /**
	   * @private
	   * @type {number|undefined}
	   */
	  this.metersPerUnit_ = options.metersPerUnit;
	};
	
	/**
	 * @return {boolean} The projection is suitable for wrapping the x-axis
	 */
	Projection.prototype.canWrapX = function canWrapX () {
	  return this.canWrapX_;
	};
	
	/**
	 * Get the code for this projection, e.g. 'EPSG:4326'.
	 * @return {string} Code.
	 * @api
	 */
	Projection.prototype.getCode = function getCode () {
	  return this.code_;
	};
	
	/**
	 * Get the validity extent for this projection.
	 * @return {import("../extent.js").Extent} Extent.
	 * @api
	 */
	Projection.prototype.getExtent = function getExtent () {
	  return this.extent_;
	};
	
	/**
	 * Get the units of this projection.
	 * @return {import("./Units.js").default} Units.
	 * @api
	 */
	Projection.prototype.getUnits = function getUnits () {
	  return this.units_;
	};
	
	/**
	 * Get the amount of meters per unit of this projection.If the projection is
	 * not configured with `metersPerUnit` or a units identifier, the return is
	 * `undefined`.
	 * @return {number|undefined} Meters.
	 * @api
	 */
	Projection.prototype.getMetersPerUnit = function getMetersPerUnit () {
	  return this.metersPerUnit_ || METERS_PER_UNIT[this.units_];
	};
	
	/**
	 * Get the world extent for this projection.
	 * @return {import("../extent.js").Extent} Extent.
	 * @api
	 */
	Projection.prototype.getWorldExtent = function getWorldExtent () {
	  return this.worldExtent_;
	};
	
	/**
	 * Get the axis orientation of this projection.
	 * Example values are:
	 * enu - the default easting, northing, elevation.
	 * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
	 *   or south orientated transverse mercator.
	 * wnu - westing, northing, up - some planetary coordinate systems have
	 *   "west positive" coordinate systems
	 * @return {string} Axis orientation.
	 * @api
	 */
	Projection.prototype.getAxisOrientation = function getAxisOrientation () {
	  return this.axisOrientation_;
	};
	
	/**
	 * Is this projection a global projection which spans the whole world?
	 * @return {boolean} Whether the projection is global.
	 * @api
	 */
	Projection.prototype.isGlobal = function isGlobal () {
	  return this.global_;
	};
	
	/**
	 * Set if the projection is a global projection which spans the whole world
	 * @param {boolean} global Whether the projection is global.
	 * @api
	 */
	Projection.prototype.setGlobal = function setGlobal (global) {
	  this.global_ = global;
	  this.canWrapX_ = !!(global && this.extent_);
	};
	
	/**
	 * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
	 */
	Projection.prototype.getDefaultTileGrid = function getDefaultTileGrid () {
	  return this.defaultTileGrid_;
	};
	
	/**
	 * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
	 */
	Projection.prototype.setDefaultTileGrid = function setDefaultTileGrid (tileGrid) {
	  this.defaultTileGrid_ = tileGrid;
	};
	
	/**
	 * Set the validity extent for this projection.
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @api
	 */
	Projection.prototype.setExtent = function setExtent (extent) {
	  this.extent_ = extent;
	  this.canWrapX_ = !!(this.global_ && extent);
	};
	
	/**
	 * Set the world extent for this projection.
	 * @param {import("../extent.js").Extent} worldExtent World extent
	 *   [minlon, minlat, maxlon, maxlat].
	 * @api
	 */
	Projection.prototype.setWorldExtent = function setWorldExtent (worldExtent) {
	  this.worldExtent_ = worldExtent;
	};
	
	/**
	 * Set the getPointResolution function (see {@link module:ol/proj~getPointResolution}
	 * for this projection.
	 * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
	 * @api
	 */
	Projection.prototype.setGetPointResolution = function setGetPointResolution (func) {
	  this.getPointResolutionFunc_ = func;
	};
	
	/**
	 * Get the custom point resolution function for this projection (if set).
	 * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
	 * resolution function (if set).
	 */
	Projection.prototype.getPointResolutionFunc = function getPointResolutionFunc () {
	  return this.getPointResolutionFunc_;
	};
	
	/**
	 * @module ol/proj/epsg3857
	 */
	
	
	/**
	 * Radius of WGS84 sphere
	 *
	 * @const
	 * @type {number}
	 */
	var RADIUS = 6378137;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var HALF_SIZE = Math.PI * RADIUS;
	
	
	/**
	 * @const
	 * @type {import("../extent.js").Extent}
	 */
	var EXTENT = [
	  -HALF_SIZE, -HALF_SIZE,
	  HALF_SIZE, HALF_SIZE
	];
	
	
	/**
	 * @const
	 * @type {import("../extent.js").Extent}
	 */
	var WORLD_EXTENT = [-180, -85, 180, 85];
	
	
	/**
	 * @classdesc
	 * Projection object for web/spherical Mercator (EPSG:3857).
	 */
	var EPSG3857Projection = /*@__PURE__*/(function (Projection$$1) {
	  function EPSG3857Projection(code) {
	    Projection$$1.call(this, {
	      code: code,
	      units: Units.METERS,
	      extent: EXTENT,
	      global: true,
	      worldExtent: WORLD_EXTENT,
	      getPointResolution: function(resolution, point) {
	        return resolution / cosh(point[1] / RADIUS);
	      }
	    });
	
	  }
	
	  if ( Projection$$1 ) { EPSG3857Projection.__proto__ = Projection$$1; }
	  EPSG3857Projection.prototype = Object.create( Projection$$1 && Projection$$1.prototype );
	  EPSG3857Projection.prototype.constructor = EPSG3857Projection;
	
	  return EPSG3857Projection;
	}(Projection));
	
	
	/**
	 * Projections equal to EPSG:3857.
	 *
	 * @const
	 * @type {Array<import("./Projection.js").default>}
	 */
	var PROJECTIONS = [
	  new EPSG3857Projection('EPSG:3857'),
	  new EPSG3857Projection('EPSG:102100'),
	  new EPSG3857Projection('EPSG:102113'),
	  new EPSG3857Projection('EPSG:900913'),
	  new EPSG3857Projection('urn:ogc:def:crs:EPSG:6.18:3:3857'),
	  new EPSG3857Projection('urn:ogc:def:crs:EPSG::3857'),
	  new EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
	];
	
	
	/**
	 * Transformation from EPSG:4326 to EPSG:3857.
	 *
	 * @param {Array<number>} input Input array of coordinate values.
	 * @param {Array<number>=} opt_output Output array of coordinate values.
	 * @param {number=} opt_dimension Dimension (default is `2`).
	 * @return {Array<number>} Output array of coordinate values.
	 */
	function fromEPSG4326(input, opt_output, opt_dimension) {
	  var length = input.length;
	  var dimension = opt_dimension > 1 ? opt_dimension : 2;
	  var output = opt_output;
	  if (output === undefined) {
	    if (dimension > 2) {
	      // preserve values beyond second dimension
	      output = input.slice();
	    } else {
	      output = new Array(length);
	    }
	  }
	  var halfSize = HALF_SIZE;
	  for (var i = 0; i < length; i += dimension) {
	    output[i] = halfSize * input[i] / 180;
	    var y = RADIUS *
	        Math.log(Math.tan(Math.PI * (input[i + 1] + 90) / 360));
	    if (y > halfSize) {
	      y = halfSize;
	    } else if (y < -halfSize) {
	      y = -halfSize;
	    }
	    output[i + 1] = y;
	  }
	  return output;
	}
	
	
	/**
	 * Transformation from EPSG:3857 to EPSG:4326.
	 *
	 * @param {Array<number>} input Input array of coordinate values.
	 * @param {Array<number>=} opt_output Output array of coordinate values.
	 * @param {number=} opt_dimension Dimension (default is `2`).
	 * @return {Array<number>} Output array of coordinate values.
	 */
	function toEPSG4326(input, opt_output, opt_dimension) {
	  var length = input.length;
	  var dimension = opt_dimension > 1 ? opt_dimension : 2;
	  var output = opt_output;
	  if (output === undefined) {
	    if (dimension > 2) {
	      // preserve values beyond second dimension
	      output = input.slice();
	    } else {
	      output = new Array(length);
	    }
	  }
	  for (var i = 0; i < length; i += dimension) {
	    output[i] = 180 * input[i] / HALF_SIZE;
	    output[i + 1] = 360 * Math.atan(
	      Math.exp(input[i + 1] / RADIUS)) / Math.PI - 90;
	  }
	  return output;
	}
	
	/**
	 * @module ol/proj/epsg4326
	 */
	
	
	/**
	 * Semi-major radius of the WGS84 ellipsoid.
	 *
	 * @const
	 * @type {number}
	 */
	var RADIUS$1 = 6378137;
	
	
	/**
	 * Extent of the EPSG:4326 projection which is the whole world.
	 *
	 * @const
	 * @type {import("../extent.js").Extent}
	 */
	var EXTENT$1 = [-180, -90, 180, 90];
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var METERS_PER_UNIT$1 = Math.PI * RADIUS$1 / 180;
	
	
	/**
	 * @classdesc
	 * Projection object for WGS84 geographic coordinates (EPSG:4326).
	 *
	 * Note that OpenLayers does not strictly comply with the EPSG definition.
	 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
	 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
	 */
	var EPSG4326Projection = /*@__PURE__*/(function (Projection$$1) {
	  function EPSG4326Projection(code, opt_axisOrientation) {
	    Projection$$1.call(this, {
	      code: code,
	      units: Units.DEGREES,
	      extent: EXTENT$1,
	      axisOrientation: opt_axisOrientation,
	      global: true,
	      metersPerUnit: METERS_PER_UNIT$1,
	      worldExtent: EXTENT$1
	    });
	
	  }
	
	  if ( Projection$$1 ) { EPSG4326Projection.__proto__ = Projection$$1; }
	  EPSG4326Projection.prototype = Object.create( Projection$$1 && Projection$$1.prototype );
	  EPSG4326Projection.prototype.constructor = EPSG4326Projection;
	
	  return EPSG4326Projection;
	}(Projection));
	
	
	/**
	 * Projections equal to EPSG:4326.
	 *
	 * @const
	 * @type {Array<import("./Projection.js").default>}
	 */
	var PROJECTIONS$1 = [
	  new EPSG4326Projection('CRS:84'),
	  new EPSG4326Projection('EPSG:4326', 'neu'),
	  new EPSG4326Projection('urn:ogc:def:crs:EPSG::4326', 'neu'),
	  new EPSG4326Projection('urn:ogc:def:crs:EPSG:6.6:4326', 'neu'),
	  new EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
	  new EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
	  new EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
	  new EPSG4326Projection('urn:x-ogc:def:crs:EPSG:4326', 'neu')
	];
	
	/**
	 * @module ol/proj/projections
	 */
	
	
	/**
	 * @type {Object<string, import("./Projection.js").default>}
	 */
	var cache = {};
	
	
	/**
	 * Get a cached projection by code.
	 * @param {string} code The code for the projection.
	 * @return {import("./Projection.js").default} The projection (if cached).
	 */
	function get(code) {
	  return cache[code] || null;
	}
	
	
	/**
	 * Add a projection to the cache.
	 * @param {string} code The projection code.
	 * @param {import("./Projection.js").default} projection The projection to cache.
	 */
	function add(code, projection) {
	  cache[code] = projection;
	}
	
	/**
	 * @module ol/proj/transforms
	 */
	
	
	/**
	 * @private
	 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
	 */
	var transforms = {};
	
	
	/**
	 * Registers a conversion function to convert coordinates from the source
	 * projection to the destination projection.
	 *
	 * @param {import("./Projection.js").default} source Source.
	 * @param {import("./Projection.js").default} destination Destination.
	 * @param {import("../proj.js").TransformFunction} transformFn Transform.
	 */
	function add$1(source, destination, transformFn) {
	  var sourceCode = source.getCode();
	  var destinationCode = destination.getCode();
	  if (!(sourceCode in transforms)) {
	    transforms[sourceCode] = {};
	  }
	  transforms[sourceCode][destinationCode] = transformFn;
	}
	
	
	/**
	 * Get a transform given a source code and a destination code.
	 * @param {string} sourceCode The code for the source projection.
	 * @param {string} destinationCode The code for the destination projection.
	 * @return {import("../proj.js").TransformFunction|undefined} The transform function (if found).
	 */
	function get$1(sourceCode, destinationCode) {
	  var transform;
	  if (sourceCode in transforms && destinationCode in transforms[sourceCode]) {
	    transform = transforms[sourceCode][destinationCode];
	  }
	  return transform;
	}
	
	/**
	 * @module ol/proj
	 */
	
	/**
	 * @param {Array<number>} input Input coordinate array.
	 * @param {Array<number>=} opt_output Output array of coordinate values.
	 * @param {number=} opt_dimension Dimension.
	 * @return {Array<number>} Output coordinate array (new array, same coordinate
	 *     values).
	 */
	function cloneTransform(input, opt_output, opt_dimension) {
	  var output;
	  if (opt_output !== undefined) {
	    for (var i = 0, ii = input.length; i < ii; ++i) {
	      opt_output[i] = input[i];
	    }
	    output = opt_output;
	  } else {
	    output = input.slice();
	  }
	  return output;
	}
	
	
	/**
	 * @param {Array<number>} input Input coordinate array.
	 * @param {Array<number>=} opt_output Output array of coordinate values.
	 * @param {number=} opt_dimension Dimension.
	 * @return {Array<number>} Input coordinate array (same array as input).
	 */
	function identityTransform(input, opt_output, opt_dimension) {
	  if (opt_output !== undefined && input !== opt_output) {
	    for (var i = 0, ii = input.length; i < ii; ++i) {
	      opt_output[i] = input[i];
	    }
	    input = opt_output;
	  }
	  return input;
	}
	
	
	/**
	 * Add a Projection object to the list of supported projections that can be
	 * looked up by their code.
	 *
	 * @param {Projection} projection Projection instance.
	 * @api
	 */
	function addProjection(projection) {
	  add(projection.getCode(), projection);
	  add$1(projection, projection, cloneTransform);
	}
	
	
	/**
	 * @param {Array<Projection>} projections Projections.
	 */
	function addProjections(projections) {
	  projections.forEach(addProjection);
	}
	
	
	/**
	 * Fetches a Projection object for the code specified.
	 *
	 * @param {ProjectionLike} projectionLike Either a code string which is
	 *     a combination of authority and identifier such as "EPSG:4326", or an
	 *     existing projection object, or undefined.
	 * @return {Projection} Projection object, or null if not in list.
	 * @api
	 */
	function get$2(projectionLike) {
	  return typeof projectionLike === 'string' ?
	    get(/** @type {string} */ (projectionLike)) :
	    (/** @type {Projection} */ (projectionLike) || null);
	}
	
	
	/**
	 * Get the resolution of the point in degrees or distance units.
	 * For projections with degrees as the unit this will simply return the
	 * provided resolution. For other projections the point resolution is
	 * by default estimated by transforming the 'point' pixel to EPSG:4326,
	 * measuring its width and height on the normal sphere,
	 * and taking the average of the width and height.
	 * A custom function can be provided for a specific projection, either
	 * by setting the `getPointResolution` option in the
	 * {@link module:ol/proj/Projection~Projection} constructor or by using
	 * {@link module:ol/proj/Projection~Projection#setGetPointResolution} to change an existing
	 * projection object.
	 * @param {ProjectionLike} projection The projection.
	 * @param {number} resolution Nominal resolution in projection units.
	 * @param {import("./coordinate.js").Coordinate} point Point to find adjusted resolution at.
	 * @param {Units=} opt_units Units to get the point resolution in.
	 * Default is the projection's units.
	 * @return {number} Point resolution.
	 * @api
	 */
	function getPointResolution(projection, resolution, point, opt_units) {
	  projection = get$2(projection);
	  var pointResolution;
	  var getter = projection.getPointResolutionFunc();
	  if (getter) {
	    pointResolution = getter(resolution, point);
	  } else {
	    var units = projection.getUnits();
	    if (units == Units.DEGREES && !opt_units || opt_units == Units.DEGREES) {
	      pointResolution = resolution;
	    } else {
	      // Estimate point resolution by transforming the center pixel to EPSG:4326,
	      // measuring its width and height on the normal sphere, and taking the
	      // average of the width and height.
	      var toEPSG4326$$1 = getTransformFromProjections(projection, get$2('EPSG:4326'));
	      var vertices = [
	        point[0] - resolution / 2, point[1],
	        point[0] + resolution / 2, point[1],
	        point[0], point[1] - resolution / 2,
	        point[0], point[1] + resolution / 2
	      ];
	      vertices = toEPSG4326$$1(vertices, vertices, 2);
	      var width = getDistance(vertices.slice(0, 2), vertices.slice(2, 4));
	      var height = getDistance(vertices.slice(4, 6), vertices.slice(6, 8));
	      pointResolution = (width + height) / 2;
	      var metersPerUnit = opt_units ?
	        METERS_PER_UNIT[opt_units] :
	        projection.getMetersPerUnit();
	      if (metersPerUnit !== undefined) {
	        pointResolution /= metersPerUnit;
	      }
	    }
	  }
	  return pointResolution;
	}
	
	
	/**
	 * Registers transformation functions that don't alter coordinates. Those allow
	 * to transform between projections with equal meaning.
	 *
	 * @param {Array<Projection>} projections Projections.
	 * @api
	 */
	function addEquivalentProjections(projections) {
	  addProjections(projections);
	  projections.forEach(function(source) {
	    projections.forEach(function(destination) {
	      if (source !== destination) {
	        add$1(source, destination, cloneTransform);
	      }
	    });
	  });
	}
	
	
	/**
	 * Registers transformation functions to convert coordinates in any projection
	 * in projection1 to any projection in projection2.
	 *
	 * @param {Array<Projection>} projections1 Projections with equal
	 *     meaning.
	 * @param {Array<Projection>} projections2 Projections with equal
	 *     meaning.
	 * @param {TransformFunction} forwardTransform Transformation from any
	 *   projection in projection1 to any projection in projection2.
	 * @param {TransformFunction} inverseTransform Transform from any projection
	 *   in projection2 to any projection in projection1..
	 */
	function addEquivalentTransforms(projections1, projections2, forwardTransform, inverseTransform) {
	  projections1.forEach(function(projection1) {
	    projections2.forEach(function(projection2) {
	      add$1(projection1, projection2, forwardTransform);
	      add$1(projection2, projection1, inverseTransform);
	    });
	  });
	}
	
	
	/**
	 * @param {Projection|string|undefined} projection Projection.
	 * @param {string} defaultCode Default code.
	 * @return {Projection} Projection.
	 */
	function createProjection(projection, defaultCode) {
	  if (!projection) {
	    return get$2(defaultCode);
	  } else if (typeof projection === 'string') {
	    return get$2(projection);
	  } else {
	    return (
	      /** @type {Projection} */ (projection)
	    );
	  }
	}
	
	
	/**
	 * Creates a {@link module:ol/proj~TransformFunction} from a simple 2D coordinate transform
	 * function.
	 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} coordTransform Coordinate
	 *     transform.
	 * @return {TransformFunction} Transform function.
	 */
	function createTransformFromCoordinateTransform(coordTransform) {
	  return (
	    /**
	     * @param {Array<number>} input Input.
	     * @param {Array<number>=} opt_output Output.
	     * @param {number=} opt_dimension Dimension.
	     * @return {Array<number>} Output.
	     */
	    function(input, opt_output, opt_dimension) {
	      var length = input.length;
	      var dimension = opt_dimension !== undefined ? opt_dimension : 2;
	      var output = opt_output !== undefined ? opt_output : new Array(length);
	      for (var i = 0; i < length; i += dimension) {
	        var point = coordTransform([input[i], input[i + 1]]);
	        output[i] = point[0];
	        output[i + 1] = point[1];
	        for (var j = dimension - 1; j >= 2; --j) {
	          output[i + j] = input[i + j];
	        }
	      }
	      return output;
	    });
	}
	
	
	/**
	 * Registers coordinate transform functions to convert coordinates between the
	 * source projection and the destination projection.
	 * The forward and inverse functions convert coordinate pairs; this function
	 * converts these into the functions used internally which also handle
	 * extents and coordinate arrays.
	 *
	 * @param {ProjectionLike} source Source projection.
	 * @param {ProjectionLike} destination Destination projection.
	 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} forward The forward transform
	 *     function (that is, from the source projection to the destination
	 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
	 *     the transformed {@link module:ol/coordinate~Coordinate}.
	 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} inverse The inverse transform
	 *     function (that is, from the destination projection to the source
	 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
	 *     the transformed {@link module:ol/coordinate~Coordinate}.
	 * @api
	 */
	function addCoordinateTransforms(source, destination, forward, inverse) {
	  var sourceProj = get$2(source);
	  var destProj = get$2(destination);
	  add$1(sourceProj, destProj, createTransformFromCoordinateTransform(forward));
	  add$1(destProj, sourceProj, createTransformFromCoordinateTransform(inverse));
	}
	
	
	/**
	 * Transforms a coordinate from longitude/latitude to a different projection.
	 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate as longitude and latitude, i.e.
	 *     an array with longitude as 1st and latitude as 2nd element.
	 * @param {ProjectionLike=} opt_projection Target projection. The
	 *     default is Web Mercator, i.e. 'EPSG:3857'.
	 * @return {import("./coordinate.js").Coordinate} Coordinate projected to the target projection.
	 * @api
	 */
	function fromLonLat(coordinate, opt_projection) {
	  return transform(coordinate, 'EPSG:4326',
	    opt_projection !== undefined ? opt_projection : 'EPSG:3857');
	}
	
	
	/**
	 * Transforms a coordinate to longitude/latitude.
	 * @param {import("./coordinate.js").Coordinate} coordinate Projected coordinate.
	 * @param {ProjectionLike=} opt_projection Projection of the coordinate.
	 *     The default is Web Mercator, i.e. 'EPSG:3857'.
	 * @return {import("./coordinate.js").Coordinate} Coordinate as longitude and latitude, i.e. an array
	 *     with longitude as 1st and latitude as 2nd element.
	 * @api
	 */
	function toLonLat(coordinate, opt_projection) {
	  var lonLat = transform(coordinate,
	    opt_projection !== undefined ? opt_projection : 'EPSG:3857', 'EPSG:4326');
	  var lon = lonLat[0];
	  if (lon < -180 || lon > 180) {
	    lonLat[0] = modulo(lon + 180, 360) - 180;
	  }
	  return lonLat;
	}
	
	
	/**
	 * Checks if two projections are the same, that is every coordinate in one
	 * projection does represent the same geographic point as the same coordinate in
	 * the other projection.
	 *
	 * @param {Projection} projection1 Projection 1.
	 * @param {Projection} projection2 Projection 2.
	 * @return {boolean} Equivalent.
	 * @api
	 */
	function equivalent(projection1, projection2) {
	  if (projection1 === projection2) {
	    return true;
	  }
	  var equalUnits = projection1.getUnits() === projection2.getUnits();
	  if (projection1.getCode() === projection2.getCode()) {
	    return equalUnits;
	  } else {
	    var transformFunc = getTransformFromProjections(projection1, projection2);
	    return transformFunc === cloneTransform && equalUnits;
	  }
	}
	
	
	/**
	 * Searches in the list of transform functions for the function for converting
	 * coordinates from the source projection to the destination projection.
	 *
	 * @param {Projection} sourceProjection Source Projection object.
	 * @param {Projection} destinationProjection Destination Projection
	 *     object.
	 * @return {TransformFunction} Transform function.
	 */
	function getTransformFromProjections(sourceProjection, destinationProjection) {
	  var sourceCode = sourceProjection.getCode();
	  var destinationCode = destinationProjection.getCode();
	  var transformFunc = get$1(sourceCode, destinationCode);
	  if (!transformFunc) {
	    transformFunc = identityTransform;
	  }
	  return transformFunc;
	}
	
	
	/**
	 * Given the projection-like objects, searches for a transformation
	 * function to convert a coordinates array from the source projection to the
	 * destination projection.
	 *
	 * @param {ProjectionLike} source Source.
	 * @param {ProjectionLike} destination Destination.
	 * @return {TransformFunction} Transform function.
	 * @api
	 */
	function getTransform(source, destination) {
	  var sourceProjection = get$2(source);
	  var destinationProjection = get$2(destination);
	  return getTransformFromProjections(sourceProjection, destinationProjection);
	}
	
	
	/**
	 * Transforms a coordinate from source projection to destination projection.
	 * This returns a new coordinate (and does not modify the original).
	 *
	 * See {@link module:ol/proj~transformExtent} for extent transformation.
	 * See the transform method of {@link module:ol/geom/Geometry~Geometry} and its
	 * subclasses for geometry transforms.
	 *
	 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
	 * @param {ProjectionLike} source Source projection-like.
	 * @param {ProjectionLike} destination Destination projection-like.
	 * @return {import("./coordinate.js").Coordinate} Coordinate.
	 * @api
	 */
	function transform(coordinate, source, destination) {
	  var transformFunc = getTransform(source, destination);
	  return transformFunc(coordinate, undefined, coordinate.length);
	}
	
	
	/**
	 * Transforms an extent from source projection to destination projection.  This
	 * returns a new extent (and does not modify the original).
	 *
	 * @param {import("./extent.js").Extent} extent The extent to transform.
	 * @param {ProjectionLike} source Source projection-like.
	 * @param {ProjectionLike} destination Destination projection-like.
	 * @return {import("./extent.js").Extent} The transformed extent.
	 * @api
	 */
	function transformExtent(extent, source, destination) {
	  var transformFunc = getTransform(source, destination);
	  return applyTransform(extent, transformFunc);
	}
	
	/**
	 * Add transforms to and from EPSG:4326 and EPSG:3857.  This function is called
	 * by when this module is executed and should only need to be called again after
	 * `clearAllProjections()` is called (e.g. in tests).
	 */
	function addCommon() {
	  // Add transformations that don't alter coordinates to convert within set of
	  // projections with equal meaning.
	  addEquivalentProjections(PROJECTIONS);
	  addEquivalentProjections(PROJECTIONS$1);
	  // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
	  // coordinates and back.
	  addEquivalentTransforms(PROJECTIONS$1, PROJECTIONS, fromEPSG4326, toEPSG4326);
	}
	
	addCommon();
	
	/**
	 * @module ol/transform
	 */
	
	
	/**
	 * An array representing an affine 2d transformation for use with
	 * {@link module:ol/transform} functions. The array has 6 elements.
	 * @typedef {!Array<number>} Transform
	 */
	
	
	/**
	 * Collection of affine 2d transformation functions. The functions work on an
	 * array of 6 elements. The element order is compatible with the [SVGMatrix
	 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
	 * a subset (elements a to f) of a 3×3 matrix:
	 * ```
	 * [ a c e ]
	 * [ b d f ]
	 * [ 0 0 1 ]
	 * ```
	 */
	
	
	/**
	 * @private
	 * @type {Transform}
	 */
	var tmp_ = new Array(6);
	
	
	/**
	 * Create an identity transform.
	 * @return {!Transform} Identity transform.
	 */
	function create() {
	  return [1, 0, 0, 1, 0, 0];
	}
	
	
	/**
	 * Resets the given transform to an identity transform.
	 * @param {!Transform} transform Transform.
	 * @return {!Transform} Transform.
	 */
	function reset(transform) {
	  return set(transform, 1, 0, 0, 1, 0, 0);
	}
	
	
	/**
	 * Multiply the underlying matrices of two transforms and return the result in
	 * the first transform.
	 * @param {!Transform} transform1 Transform parameters of matrix 1.
	 * @param {!Transform} transform2 Transform parameters of matrix 2.
	 * @return {!Transform} transform1 multiplied with transform2.
	 */
	function multiply(transform1, transform2) {
	  var a1 = transform1[0];
	  var b1 = transform1[1];
	  var c1 = transform1[2];
	  var d1 = transform1[3];
	  var e1 = transform1[4];
	  var f1 = transform1[5];
	  var a2 = transform2[0];
	  var b2 = transform2[1];
	  var c2 = transform2[2];
	  var d2 = transform2[3];
	  var e2 = transform2[4];
	  var f2 = transform2[5];
	
	  transform1[0] = a1 * a2 + c1 * b2;
	  transform1[1] = b1 * a2 + d1 * b2;
	  transform1[2] = a1 * c2 + c1 * d2;
	  transform1[3] = b1 * c2 + d1 * d2;
	  transform1[4] = a1 * e2 + c1 * f2 + e1;
	  transform1[5] = b1 * e2 + d1 * f2 + f1;
	
	  return transform1;
	}
	
	/**
	 * Set the transform components a-f on a given transform.
	 * @param {!Transform} transform Transform.
	 * @param {number} a The a component of the transform.
	 * @param {number} b The b component of the transform.
	 * @param {number} c The c component of the transform.
	 * @param {number} d The d component of the transform.
	 * @param {number} e The e component of the transform.
	 * @param {number} f The f component of the transform.
	 * @return {!Transform} Matrix with transform applied.
	 */
	function set(transform, a, b, c, d, e, f) {
	  transform[0] = a;
	  transform[1] = b;
	  transform[2] = c;
	  transform[3] = d;
	  transform[4] = e;
	  transform[5] = f;
	  return transform;
	}
	
	
	/**
	 * Set transform on one matrix from another matrix.
	 * @param {!Transform} transform1 Matrix to set transform to.
	 * @param {!Transform} transform2 Matrix to set transform from.
	 * @return {!Transform} transform1 with transform from transform2 applied.
	 * @api
	 */
	function setFromArray(transform1, transform2) {
	  transform1[0] = transform2[0];
	  transform1[1] = transform2[1];
	  transform1[2] = transform2[2];
	  transform1[3] = transform2[3];
	  transform1[4] = transform2[4];
	  transform1[5] = transform2[5];
	  return transform1;
	}
	
	
	/**
	 * Transforms the given coordinate with the given transform returning the
	 * resulting, transformed coordinate. The coordinate will be modified in-place.
	 *
	 * @param {Transform} transform The transformation.
	 * @param {import("./coordinate.js").Coordinate|import("./pixel.js").Pixel} coordinate The coordinate to transform.
	 * @return {import("./coordinate.js").Coordinate|import("./pixel.js").Pixel} return coordinate so that operations can be
	 *     chained together.
	 */
	function apply(transform, coordinate) {
	  var x = coordinate[0];
	  var y = coordinate[1];
	  coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
	  coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
	  return coordinate;
	}
	
	
	/**
	 * Applies rotation to the given transform.
	 * @param {!Transform} transform Transform.
	 * @param {number} angle Angle in radians.
	 * @return {!Transform} The rotated transform.
	 */
	function rotate$1(transform, angle) {
	  var cos = Math.cos(angle);
	  var sin = Math.sin(angle);
	  return multiply(transform, set(tmp_, cos, sin, -sin, cos, 0, 0));
	}
	
	
	/**
	 * Applies scale to a given transform.
	 * @param {!Transform} transform Transform.
	 * @param {number} x Scale factor x.
	 * @param {number} y Scale factor y.
	 * @return {!Transform} The scaled transform.
	 */
	function scale$1(transform, x, y) {
	  return multiply(transform, set(tmp_, x, 0, 0, y, 0, 0));
	}
	
	
	/**
	 * Applies translation to the given transform.
	 * @param {!Transform} transform Transform.
	 * @param {number} dx Translation x.
	 * @param {number} dy Translation y.
	 * @return {!Transform} The translated transform.
	 */
	function translate$1(transform, dx, dy) {
	  return multiply(transform, set(tmp_, 1, 0, 0, 1, dx, dy));
	}
	
	
	/**
	 * Creates a composite transform given an initial translation, scale, rotation, and
	 * final translation (in that order only, not commutative).
	 * @param {!Transform} transform The transform (will be modified in place).
	 * @param {number} dx1 Initial translation x.
	 * @param {number} dy1 Initial translation y.
	 * @param {number} sx Scale factor x.
	 * @param {number} sy Scale factor y.
	 * @param {number} angle Rotation (in counter-clockwise radians).
	 * @param {number} dx2 Final translation x.
	 * @param {number} dy2 Final translation y.
	 * @return {!Transform} The composite transform.
	 * @api
	 */
	function compose(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
	  var sin = Math.sin(angle);
	  var cos = Math.cos(angle);
	  transform[0] = sx * cos;
	  transform[1] = sy * sin;
	  transform[2] = -sx * sin;
	  transform[3] = sy * cos;
	  transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
	  transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
	  return transform;
	}
	
	
	/**
	 * Invert the given transform.
	 * @param {!Transform} transform Transform.
	 * @return {!Transform} Inverse of the transform.
	 * @api
	 */
	function invert(transform) {
	  var det = determinant(transform);
	  assert(det !== 0, 32); // Transformation matrix cannot be inverted
	
	  var a = transform[0];
	  var b = transform[1];
	  var c = transform[2];
	  var d = transform[3];
	  var e = transform[4];
	  var f = transform[5];
	
	  transform[0] = d / det;
	  transform[1] = -b / det;
	  transform[2] = -c / det;
	  transform[3] = a / det;
	  transform[4] = (c * f - d * e) / det;
	  transform[5] = -(a * f - b * e) / det;
	
	  return transform;
	}
	
	
	/**
	 * Returns the determinant of the given matrix.
	 * @param {!Transform} mat Matrix.
	 * @return {number} Determinant.
	 */
	function determinant(mat) {
	  return mat[0] * mat[3] - mat[1] * mat[2];
	}
	
	/**
	 * @module ol/geom/Geometry
	 */
	
	
	/**
	 * @type {import("../transform.js").Transform}
	 */
	var tmpTransform = create();
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for vector geometries.
	 *
	 * To get notified of changes to the geometry, register a listener for the
	 * generic `change` event on your geometry instance.
	 *
	 * @abstract
	 * @api
	 */
	var Geometry = /*@__PURE__*/(function (BaseObject$$1) {
	  function Geometry() {
	
	    BaseObject$$1.call(this);
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.extent_ = createEmpty();
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.extentRevision_ = -1;
	
	    /**
	     * @protected
	     * @type {Object<string, Geometry>}
	     */
	    this.simplifiedGeometryCache = {};
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.simplifiedGeometryMaxMinSquaredTolerance = 0;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.simplifiedGeometryRevision = 0;
	
	  }
	
	  if ( BaseObject$$1 ) { Geometry.__proto__ = BaseObject$$1; }
	  Geometry.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Geometry.prototype.constructor = Geometry;
	
	  /**
	   * Make a complete copy of the geometry.
	   * @abstract
	   * @return {!Geometry} Clone.
	   */
	  Geometry.prototype.clone = function clone$$1 () {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @param {number} x X.
	   * @param {number} y Y.
	   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
	   * @param {number} minSquaredDistance Minimum squared distance.
	   * @return {number} Minimum squared distance.
	   */
	  Geometry.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    return abstract();
	  };
	
	  /**
	   * @param {number} x X.
	   * @param {number} y Y.
	   * @return {boolean} Contains (x, y).
	   */
	  Geometry.prototype.containsXY = function containsXY$$1 (x, y) {
	    return false;
	  };
	
	  /**
	   * Return the closest point of the geometry to the passed point as
	   * {@link module:ol/coordinate~Coordinate coordinate}.
	   * @param {import("../coordinate.js").Coordinate} point Point.
	   * @param {import("../coordinate.js").Coordinate=} opt_closestPoint Closest point.
	   * @return {import("../coordinate.js").Coordinate} Closest point.
	   * @api
	   */
	  Geometry.prototype.getClosestPoint = function getClosestPoint (point, opt_closestPoint) {
	    var closestPoint = opt_closestPoint ? opt_closestPoint : [NaN, NaN];
	    this.closestPointXY(point[0], point[1], closestPoint, Infinity);
	    return closestPoint;
	  };
	
	  /**
	   * Returns true if this geometry includes the specified coordinate. If the
	   * coordinate is on the boundary of the geometry, returns false.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @return {boolean} Contains coordinate.
	   * @api
	   */
	  Geometry.prototype.intersectsCoordinate = function intersectsCoordinate (coordinate) {
	    return this.containsXY(coordinate[0], coordinate[1]);
	  };
	
	  /**
	   * @abstract
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @protected
	   * @return {import("../extent.js").Extent} extent Extent.
	   */
	  Geometry.prototype.computeExtent = function computeExtent (extent) {
	    return abstract();
	  };
	
	  /**
	   * Get the extent of the geometry.
	   * @param {import("../extent.js").Extent=} opt_extent Extent.
	   * @return {import("../extent.js").Extent} extent Extent.
	   * @api
	   */
	  Geometry.prototype.getExtent = function getExtent (opt_extent) {
	    if (this.extentRevision_ != this.getRevision()) {
	      this.extent_ = this.computeExtent(this.extent_);
	      this.extentRevision_ = this.getRevision();
	    }
	    return returnOrUpdate(this.extent_, opt_extent);
	  };
	
	  /**
	   * Rotate the geometry around a given coordinate. This modifies the geometry
	   * coordinates in place.
	   * @abstract
	   * @param {number} angle Rotation angle in radians.
	   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
	   * @api
	   */
	  Geometry.prototype.rotate = function rotate$$1 (angle, anchor) {
	    abstract();
	  };
	
	  /**
	   * Scale the geometry (with an optional origin).  This modifies the geometry
	   * coordinates in place.
	   * @abstract
	   * @param {number} sx The scaling factor in the x-direction.
	   * @param {number=} opt_sy The scaling factor in the y-direction (defaults to
	   *     sx).
	   * @param {import("../coordinate.js").Coordinate=} opt_anchor The scale origin (defaults to the center
	   *     of the geometry extent).
	   * @api
	   */
	  Geometry.prototype.scale = function scale$$1 (sx, opt_sy, opt_anchor) {
	    abstract();
	  };
	
	  /**
	   * Create a simplified version of this geometry.  For linestrings, this uses
	   * the the {@link
	   * https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
	   * Douglas Peucker} algorithm.  For polygons, a quantization-based
	   * simplification is used to preserve topology.
	   * @param {number} tolerance The tolerance distance for simplification.
	   * @return {Geometry} A new, simplified version of the original geometry.
	   * @api
	   */
	  Geometry.prototype.simplify = function simplify (tolerance) {
	    return this.getSimplifiedGeometry(tolerance * tolerance);
	  };
	
	  /**
	   * Create a simplified version of this geometry using the Douglas Peucker
	   * algorithm.
	   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
	   * @abstract
	   * @param {number} squaredTolerance Squared tolerance.
	   * @return {Geometry} Simplified geometry.
	   */
	  Geometry.prototype.getSimplifiedGeometry = function getSimplifiedGeometry (squaredTolerance) {
	    return abstract();
	  };
	
	  /**
	   * Get the type of this geometry.
	   * @abstract
	   * @api
	   * @return {import("./GeometryType.js").default} Geometry type.
	   */
	  Geometry.prototype.getType = function getType () {
	    return abstract();
	  };
	
	  /**
	   * Apply a transform function to each coordinate of the geometry.
	   * The geometry is modified in place.
	   * If you do not want the geometry modified in place, first `clone()` it and
	   * then use this function on the clone.
	   * @abstract
	   * @param {import("../proj.js").TransformFunction} transformFn Transform.
	   */
	  Geometry.prototype.applyTransform = function applyTransform$$1 (transformFn) {
	    abstract();
	  };
	
	  /**
	   * Test if the geometry and the passed extent intersect.
	   * @abstract
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @return {boolean} `true` if the geometry and the extent intersect.
	   */
	  Geometry.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return abstract();
	  };
	
	  /**
	   * Translate the geometry.  This modifies the geometry coordinates in place.  If
	   * instead you want a new geometry, first `clone()` this geometry.
	   * @abstract
	   * @param {number} deltaX Delta X.
	   * @param {number} deltaY Delta Y.
	   * @api
	   */
	  Geometry.prototype.translate = function translate$$1 (deltaX, deltaY) {
	    abstract();
	  };
	
	  /**
	   * Transform each coordinate of the geometry from one coordinate reference
	   * system to another. The geometry is modified in place.
	   * For example, a line will be transformed to a line and a circle to a circle.
	   * If you do not want the geometry modified in place, first `clone()` it and
	   * then use this function on the clone.
	   *
	   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
	   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
	   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
	   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
	   * @return {Geometry} This geometry.  Note that original geometry is
	   *     modified in place.
	   * @api
	   */
	  Geometry.prototype.transform = function transform$$1 (source, destination) {
	    /** @type {import("../proj/Projection.js").default} */
	    var sourceProj = get$2(source);
	    var transformFn = sourceProj.getUnits() == Units.TILE_PIXELS ?
	      function(inCoordinates, outCoordinates, stride) {
	        var pixelExtent = sourceProj.getExtent();
	        var projectedExtent = sourceProj.getWorldExtent();
	        var scale$$1 = getHeight(projectedExtent) / getHeight(pixelExtent);
	        compose(tmpTransform,
	          projectedExtent[0], projectedExtent[3],
	          scale$$1, -scale$$1, 0,
	          0, 0);
	        transform2D(inCoordinates, 0, inCoordinates.length, stride,
	          tmpTransform, outCoordinates);
	        return getTransform(sourceProj, destination)(inCoordinates, outCoordinates, stride);
	      } :
	      getTransform(sourceProj, destination);
	    this.applyTransform(transformFn);
	    return this;
	  };
	
	  return Geometry;
	}(BaseObject));
	
	/**
	 * @module ol/geom/SimpleGeometry
	 */
	
	/**
	 * @classdesc
	 * Abstract base class; only used for creating subclasses; do not instantiate
	 * in apps, as cannot be rendered.
	 *
	 * @abstract
	 * @api
	 */
	var SimpleGeometry = /*@__PURE__*/(function (Geometry$$1) {
	  function SimpleGeometry() {
	
	    Geometry$$1.call(this);
	
	    /**
	     * @protected
	     * @type {GeometryLayout}
	     */
	    this.layout = GeometryLayout.XY;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.stride = 2;
	
	    /**
	     * @protected
	     * @type {Array<number>}
	     */
	    this.flatCoordinates = null;
	
	  }
	
	  if ( Geometry$$1 ) { SimpleGeometry.__proto__ = Geometry$$1; }
	  SimpleGeometry.prototype = Object.create( Geometry$$1 && Geometry$$1.prototype );
	  SimpleGeometry.prototype.constructor = SimpleGeometry;
	
	  /**
	   * @inheritDoc
	   */
	  SimpleGeometry.prototype.computeExtent = function computeExtent (extent) {
	    return createOrUpdateFromFlatCoordinates(this.flatCoordinates,
	      0, this.flatCoordinates.length, this.stride, extent);
	  };
	
	  /**
	   * @abstract
	   * @return {Array} Coordinates.
	   */
	  SimpleGeometry.prototype.getCoordinates = function getCoordinates () {
	    return abstract();
	  };
	
	  /**
	   * Return the first coordinate of the geometry.
	   * @return {import("../coordinate.js").Coordinate} First coordinate.
	   * @api
	   */
	  SimpleGeometry.prototype.getFirstCoordinate = function getFirstCoordinate () {
	    return this.flatCoordinates.slice(0, this.stride);
	  };
	
	  /**
	   * @return {Array<number>} Flat coordinates.
	   */
	  SimpleGeometry.prototype.getFlatCoordinates = function getFlatCoordinates () {
	    return this.flatCoordinates;
	  };
	
	  /**
	   * Return the last coordinate of the geometry.
	   * @return {import("../coordinate.js").Coordinate} Last point.
	   * @api
	   */
	  SimpleGeometry.prototype.getLastCoordinate = function getLastCoordinate () {
	    return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
	  };
	
	  /**
	   * Return the {@link module:ol/geom/GeometryLayout layout} of the geometry.
	   * @return {GeometryLayout} Layout.
	   * @api
	   */
	  SimpleGeometry.prototype.getLayout = function getLayout () {
	    return this.layout;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  SimpleGeometry.prototype.getSimplifiedGeometry = function getSimplifiedGeometry (squaredTolerance) {
	    if (this.simplifiedGeometryRevision != this.getRevision()) {
	      clear(this.simplifiedGeometryCache);
	      this.simplifiedGeometryMaxMinSquaredTolerance = 0;
	      this.simplifiedGeometryRevision = this.getRevision();
	    }
	    // If squaredTolerance is negative or if we know that simplification will not
	    // have any effect then just return this.
	    if (squaredTolerance < 0 ||
	        (this.simplifiedGeometryMaxMinSquaredTolerance !== 0 &&
	         squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance)) {
	      return this;
	    }
	    var key = squaredTolerance.toString();
	    if (this.simplifiedGeometryCache.hasOwnProperty(key)) {
	      return this.simplifiedGeometryCache[key];
	    } else {
	      var simplifiedGeometry =
	          this.getSimplifiedGeometryInternal(squaredTolerance);
	      var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
	      if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) {
	        this.simplifiedGeometryCache[key] = simplifiedGeometry;
	        return simplifiedGeometry;
	      } else {
	        // Simplification did not actually remove any coordinates.  We now know
	        // that any calls to getSimplifiedGeometry with a squaredTolerance less
	        // than or equal to the current squaredTolerance will also not have any
	        // effect.  This allows us to short circuit simplification (saving CPU
	        // cycles) and prevents the cache of simplified geometries from filling
	        // up with useless identical copies of this geometry (saving memory).
	        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
	        return this;
	      }
	    }
	  };
	
	  /**
	   * @param {number} squaredTolerance Squared tolerance.
	   * @return {SimpleGeometry} Simplified geometry.
	   * @protected
	   */
	  SimpleGeometry.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal (squaredTolerance) {
	    return this;
	  };
	
	  /**
	   * @return {number} Stride.
	   */
	  SimpleGeometry.prototype.getStride = function getStride () {
	    return this.stride;
	  };
	
	  /**
	   * @param {GeometryLayout} layout Layout.
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   */
	  SimpleGeometry.prototype.setFlatCoordinates = function setFlatCoordinates (layout, flatCoordinates) {
	    this.stride = getStrideForLayout(layout);
	    this.layout = layout;
	    this.flatCoordinates = flatCoordinates;
	  };
	
	  /**
	   * @abstract
	   * @param {!Array} coordinates Coordinates.
	   * @param {GeometryLayout=} opt_layout Layout.
	   */
	  SimpleGeometry.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    abstract();
	  };
	
	  /**
	   * @param {GeometryLayout|undefined} layout Layout.
	   * @param {Array} coordinates Coordinates.
	   * @param {number} nesting Nesting.
	   * @protected
	   */
	  SimpleGeometry.prototype.setLayout = function setLayout (layout, coordinates, nesting) {
	    /** @type {number} */
	    var stride;
	    if (layout) {
	      stride = getStrideForLayout(layout);
	    } else {
	      for (var i = 0; i < nesting; ++i) {
	        if (coordinates.length === 0) {
	          this.layout = GeometryLayout.XY;
	          this.stride = 2;
	          return;
	        } else {
	          coordinates = /** @type {Array} */ (coordinates[0]);
	        }
	      }
	      stride = coordinates.length;
	      layout = getLayoutForStride(stride);
	    }
	    this.layout = layout;
	    this.stride = stride;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  SimpleGeometry.prototype.applyTransform = function applyTransform$$1 (transformFn) {
	    if (this.flatCoordinates) {
	      transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
	      this.changed();
	    }
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  SimpleGeometry.prototype.rotate = function rotate$1 (angle, anchor) {
	    var flatCoordinates = this.getFlatCoordinates();
	    if (flatCoordinates) {
	      var stride = this.getStride();
	      rotate(
	        flatCoordinates, 0, flatCoordinates.length,
	        stride, angle, anchor, flatCoordinates);
	      this.changed();
	    }
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  SimpleGeometry.prototype.scale = function scale$1 (sx, opt_sy, opt_anchor) {
	    var sy = opt_sy;
	    if (sy === undefined) {
	      sy = sx;
	    }
	    var anchor = opt_anchor;
	    if (!anchor) {
	      anchor = getCenter(this.getExtent());
	    }
	    var flatCoordinates = this.getFlatCoordinates();
	    if (flatCoordinates) {
	      var stride = this.getStride();
	      scale(
	        flatCoordinates, 0, flatCoordinates.length,
	        stride, sx, sy, anchor, flatCoordinates);
	      this.changed();
	    }
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  SimpleGeometry.prototype.translate = function translate$1 (deltaX, deltaY) {
	    var flatCoordinates = this.getFlatCoordinates();
	    if (flatCoordinates) {
	      var stride = this.getStride();
	      translate(
	        flatCoordinates, 0, flatCoordinates.length, stride,
	        deltaX, deltaY, flatCoordinates);
	      this.changed();
	    }
	  };
	
	  return SimpleGeometry;
	}(Geometry));
	
	
	/**
	 * @param {number} stride Stride.
	 * @return {GeometryLayout} layout Layout.
	 */
	function getLayoutForStride(stride) {
	  var layout;
	  if (stride == 2) {
	    layout = GeometryLayout.XY;
	  } else if (stride == 3) {
	    layout = GeometryLayout.XYZ;
	  } else if (stride == 4) {
	    layout = GeometryLayout.XYZM;
	  }
	  return (
	    /** @type {GeometryLayout} */ (layout)
	  );
	}
	
	
	/**
	 * @param {GeometryLayout} layout Layout.
	 * @return {number} Stride.
	 */
	function getStrideForLayout(layout) {
	  var stride;
	  if (layout == GeometryLayout.XY) {
	    stride = 2;
	  } else if (layout == GeometryLayout.XYZ || layout == GeometryLayout.XYM) {
	    stride = 3;
	  } else if (layout == GeometryLayout.XYZM) {
	    stride = 4;
	  }
	  return /** @type {number} */ (stride);
	}
	
	
	/**
	 * @param {SimpleGeometry} simpleGeometry Simple geometry.
	 * @param {import("../transform.js").Transform} transform Transform.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Transformed flat coordinates.
	 */
	function transformGeom2D(simpleGeometry, transform, opt_dest) {
	  var flatCoordinates = simpleGeometry.getFlatCoordinates();
	  if (!flatCoordinates) {
	    return null;
	  } else {
	    var stride = simpleGeometry.getStride();
	    return transform2D(
	      flatCoordinates, 0, flatCoordinates.length, stride,
	      transform, opt_dest);
	  }
	}
	
	/**
	 * @module ol/geom/flat/area
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @return {number} Area.
	 */
	function linearRing(flatCoordinates, offset, end, stride) {
	  var twiceArea = 0;
	  var x1 = flatCoordinates[end - stride];
	  var y1 = flatCoordinates[end - stride + 1];
	  for (; offset < end; offset += stride) {
	    var x2 = flatCoordinates[offset];
	    var y2 = flatCoordinates[offset + 1];
	    twiceArea += y1 * x2 - x1 * y2;
	    x1 = x2;
	    y1 = y2;
	  }
	  return twiceArea / 2;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @return {number} Area.
	 */
	function linearRings(flatCoordinates, offset, ends, stride) {
	  var area = 0;
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    area += linearRing(flatCoordinates, offset, end, stride);
	    offset = end;
	  }
	  return area;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @return {number} Area.
	 */
	function linearRingss(flatCoordinates, offset, endss, stride) {
	  var area = 0;
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    area += linearRings(flatCoordinates, offset, ends, stride);
	    offset = ends[ends.length - 1];
	  }
	  return area;
	}
	
	/**
	 * @module ol/geom/flat/closest
	 */
	
	
	/**
	 * Returns the point on the 2D line segment flatCoordinates[offset1] to
	 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
	 * dimensions are linearly interpolated.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset1 Offset 1.
	 * @param {number} offset2 Offset 2.
	 * @param {number} stride Stride.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {Array<number>} closestPoint Closest point.
	 */
	function assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
	  var x1 = flatCoordinates[offset1];
	  var y1 = flatCoordinates[offset1 + 1];
	  var dx = flatCoordinates[offset2] - x1;
	  var dy = flatCoordinates[offset2 + 1] - y1;
	  var offset;
	  if (dx === 0 && dy === 0) {
	    offset = offset1;
	  } else {
	    var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
	    if (t > 1) {
	      offset = offset2;
	    } else if (t > 0) {
	      for (var i = 0; i < stride; ++i) {
	        closestPoint[i] = lerp(flatCoordinates[offset1 + i],
	          flatCoordinates[offset2 + i], t);
	      }
	      closestPoint.length = stride;
	      return;
	    } else {
	      offset = offset1;
	    }
	  }
	  for (var i$1 = 0; i$1 < stride; ++i$1) {
	    closestPoint[i$1] = flatCoordinates[offset + i$1];
	  }
	  closestPoint.length = stride;
	}
	
	
	/**
	 * Return the squared of the largest distance between any pair of consecutive
	 * coordinates.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} max Max squared delta.
	 * @return {number} Max squared delta.
	 */
	function maxSquaredDelta(flatCoordinates, offset, end, stride, max) {
	  var x1 = flatCoordinates[offset];
	  var y1 = flatCoordinates[offset + 1];
	  for (offset += stride; offset < end; offset += stride) {
	    var x2 = flatCoordinates[offset];
	    var y2 = flatCoordinates[offset + 1];
	    var squaredDelta = squaredDistance(x1, y1, x2, y2);
	    if (squaredDelta > max) {
	      max = squaredDelta;
	    }
	    x1 = x2;
	    y1 = y2;
	  }
	  return max;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {number} max Max squared delta.
	 * @return {number} Max squared delta.
	 */
	function arrayMaxSquaredDelta(flatCoordinates, offset, ends, stride, max) {
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    max = maxSquaredDelta(
	      flatCoordinates, offset, end, stride, max);
	    offset = end;
	  }
	  return max;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {number} max Max squared delta.
	 * @return {number} Max squared delta.
	 */
	function multiArrayMaxSquaredDelta(flatCoordinates, offset, endss, stride, max) {
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    max = arrayMaxSquaredDelta(
	      flatCoordinates, offset, ends, stride, max);
	    offset = ends[ends.length - 1];
	  }
	  return max;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} maxDelta Max delta.
	 * @param {boolean} isRing Is ring.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {Array<number>} closestPoint Closest point.
	 * @param {number} minSquaredDistance Minimum squared distance.
	 * @param {Array<number>=} opt_tmpPoint Temporary point object.
	 * @return {number} Minimum squared distance.
	 */
	function assignClosestPoint(flatCoordinates, offset, end,
	  stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance,
	  opt_tmpPoint) {
	  if (offset == end) {
	    return minSquaredDistance;
	  }
	  var i, squaredDistance$$1;
	  if (maxDelta === 0) {
	    // All points are identical, so just test the first point.
	    squaredDistance$$1 = squaredDistance(
	      x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
	    if (squaredDistance$$1 < minSquaredDistance) {
	      for (i = 0; i < stride; ++i) {
	        closestPoint[i] = flatCoordinates[offset + i];
	      }
	      closestPoint.length = stride;
	      return squaredDistance$$1;
	    } else {
	      return minSquaredDistance;
	    }
	  }
	  var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [NaN, NaN];
	  var index = offset + stride;
	  while (index < end) {
	    assignClosest(
	      flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
	    squaredDistance$$1 = squaredDistance(x, y, tmpPoint[0], tmpPoint[1]);
	    if (squaredDistance$$1 < minSquaredDistance) {
	      minSquaredDistance = squaredDistance$$1;
	      for (i = 0; i < stride; ++i) {
	        closestPoint[i] = tmpPoint[i];
	      }
	      closestPoint.length = stride;
	      index += stride;
	    } else {
	      // Skip ahead multiple points, because we know that all the skipped
	      // points cannot be any closer than the closest point we have found so
	      // far.  We know this because we know how close the current point is, how
	      // close the closest point we have found so far is, and the maximum
	      // distance between consecutive points.  For example, if we're currently
	      // at distance 10, the best we've found so far is 3, and that the maximum
	      // distance between consecutive points is 2, then we'll need to skip at
	      // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
	      // finding a closer point.  We use Math.max(..., 1) to ensure that we
	      // always advance at least one point, to avoid an infinite loop.
	      index += stride * Math.max(
	        ((Math.sqrt(squaredDistance$$1) -
	            Math.sqrt(minSquaredDistance)) / maxDelta) | 0, 1);
	    }
	  }
	  if (isRing) {
	    // Check the closing segment.
	    assignClosest(
	      flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
	    squaredDistance$$1 = squaredDistance(x, y, tmpPoint[0], tmpPoint[1]);
	    if (squaredDistance$$1 < minSquaredDistance) {
	      minSquaredDistance = squaredDistance$$1;
	      for (i = 0; i < stride; ++i) {
	        closestPoint[i] = tmpPoint[i];
	      }
	      closestPoint.length = stride;
	    }
	  }
	  return minSquaredDistance;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {number} maxDelta Max delta.
	 * @param {boolean} isRing Is ring.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {Array<number>} closestPoint Closest point.
	 * @param {number} minSquaredDistance Minimum squared distance.
	 * @param {Array<number>=} opt_tmpPoint Temporary point object.
	 * @return {number} Minimum squared distance.
	 */
	function assignClosestArrayPoint(flatCoordinates, offset, ends,
	  stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance,
	  opt_tmpPoint) {
	  var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [NaN, NaN];
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    minSquaredDistance = assignClosestPoint(
	      flatCoordinates, offset, end, stride,
	      maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
	    offset = end;
	  }
	  return minSquaredDistance;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {number} maxDelta Max delta.
	 * @param {boolean} isRing Is ring.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {Array<number>} closestPoint Closest point.
	 * @param {number} minSquaredDistance Minimum squared distance.
	 * @param {Array<number>=} opt_tmpPoint Temporary point object.
	 * @return {number} Minimum squared distance.
	 */
	function assignClosestMultiArrayPoint(flatCoordinates, offset,
	  endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance,
	  opt_tmpPoint) {
	  var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [NaN, NaN];
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    minSquaredDistance = assignClosestArrayPoint(
	      flatCoordinates, offset, ends, stride,
	      maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
	    offset = ends[ends.length - 1];
	  }
	  return minSquaredDistance;
	}
	
	/**
	 * @module ol/geom/flat/deflate
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
	 * @param {number} stride Stride.
	 * @return {number} offset Offset.
	 */
	function deflateCoordinate(flatCoordinates, offset, coordinate, stride) {
	  for (var i = 0, ii = coordinate.length; i < ii; ++i) {
	    flatCoordinates[offset++] = coordinate[i];
	  }
	  return offset;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<import("../../coordinate.js").Coordinate>} coordinates Coordinates.
	 * @param {number} stride Stride.
	 * @return {number} offset Offset.
	 */
	function deflateCoordinates(flatCoordinates, offset, coordinates, stride) {
	  for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	    var coordinate = coordinates[i];
	    for (var j = 0; j < stride; ++j) {
	      flatCoordinates[offset++] = coordinate[j];
	    }
	  }
	  return offset;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} coordinatess Coordinatess.
	 * @param {number} stride Stride.
	 * @param {Array<number>=} opt_ends Ends.
	 * @return {Array<number>} Ends.
	 */
	function deflateCoordinatesArray(flatCoordinates, offset, coordinatess, stride, opt_ends) {
	  var ends = opt_ends ? opt_ends : [];
	  var i = 0;
	  for (var j = 0, jj = coordinatess.length; j < jj; ++j) {
	    var end = deflateCoordinates(
	      flatCoordinates, offset, coordinatess[j], stride);
	    ends[i++] = end;
	    offset = end;
	  }
	  ends.length = i;
	  return ends;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} coordinatesss Coordinatesss.
	 * @param {number} stride Stride.
	 * @param {Array<Array<number>>=} opt_endss Endss.
	 * @return {Array<Array<number>>} Endss.
	 */
	function deflateMultiCoordinatesArray(flatCoordinates, offset, coordinatesss, stride, opt_endss) {
	  var endss = opt_endss ? opt_endss : [];
	  var i = 0;
	  for (var j = 0, jj = coordinatesss.length; j < jj; ++j) {
	    var ends = deflateCoordinatesArray(
	      flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
	    endss[i++] = ends;
	    offset = ends[ends.length - 1];
	  }
	  endss.length = i;
	  return endss;
	}
	
	/**
	 * @module ol/geom/flat/inflate
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {Array<import("../../coordinate.js").Coordinate>=} opt_coordinates Coordinates.
	 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
	 */
	function inflateCoordinates(flatCoordinates, offset, end, stride, opt_coordinates) {
	  var coordinates = opt_coordinates !== undefined ? opt_coordinates : [];
	  var i = 0;
	  for (var j = offset; j < end; j += stride) {
	    coordinates[i++] = flatCoordinates.slice(j, j + stride);
	  }
	  coordinates.length = i;
	  return coordinates;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {Array<Array<import("../../coordinate.js").Coordinate>>=} opt_coordinatess Coordinatess.
	 * @return {Array<Array<import("../../coordinate.js").Coordinate>>} Coordinatess.
	 */
	function inflateCoordinatesArray(flatCoordinates, offset, ends, stride, opt_coordinatess) {
	  var coordinatess = opt_coordinatess !== undefined ? opt_coordinatess : [];
	  var i = 0;
	  for (var j = 0, jj = ends.length; j < jj; ++j) {
	    var end = ends[j];
	    coordinatess[i++] = inflateCoordinates(
	      flatCoordinates, offset, end, stride, coordinatess[i]);
	    offset = end;
	  }
	  coordinatess.length = i;
	  return coordinatess;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>=} opt_coordinatesss
	 *     Coordinatesss.
	 * @return {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} Coordinatesss.
	 */
	function inflateMultiCoordinatesArray(flatCoordinates, offset, endss, stride, opt_coordinatesss) {
	  var coordinatesss = opt_coordinatesss !== undefined ? opt_coordinatesss : [];
	  var i = 0;
	  for (var j = 0, jj = endss.length; j < jj; ++j) {
	    var ends = endss[j];
	    coordinatesss[i++] = inflateCoordinatesArray(
	      flatCoordinates, offset, ends, stride, coordinatesss[i]);
	    offset = ends[ends.length - 1];
	  }
	  coordinatesss.length = i;
	  return coordinatesss;
	}
	
	/**
	 * @module ol/geom/flat/simplify
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
	 *     coordinates.
	 * @param {number} simplifiedOffset Simplified offset.
	 * @return {number} Simplified offset.
	 */
	function douglasPeucker(flatCoordinates, offset, end,
	  stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
	  var n = (end - offset) / stride;
	  if (n < 3) {
	    for (; offset < end; offset += stride) {
	      simplifiedFlatCoordinates[simplifiedOffset++] =
	          flatCoordinates[offset];
	      simplifiedFlatCoordinates[simplifiedOffset++] =
	          flatCoordinates[offset + 1];
	    }
	    return simplifiedOffset;
	  }
	  /** @type {Array<number>} */
	  var markers = new Array(n);
	  markers[0] = 1;
	  markers[n - 1] = 1;
	  /** @type {Array<number>} */
	  var stack = [offset, end - stride];
	  var index = 0;
	  while (stack.length > 0) {
	    var last = stack.pop();
	    var first = stack.pop();
	    var maxSquaredDistance = 0;
	    var x1 = flatCoordinates[first];
	    var y1 = flatCoordinates[first + 1];
	    var x2 = flatCoordinates[last];
	    var y2 = flatCoordinates[last + 1];
	    for (var i = first + stride; i < last; i += stride) {
	      var x = flatCoordinates[i];
	      var y = flatCoordinates[i + 1];
	      var squaredDistance$$1 = squaredSegmentDistance(
	        x, y, x1, y1, x2, y2);
	      if (squaredDistance$$1 > maxSquaredDistance) {
	        index = i;
	        maxSquaredDistance = squaredDistance$$1;
	      }
	    }
	    if (maxSquaredDistance > squaredTolerance) {
	      markers[(index - offset) / stride] = 1;
	      if (first + stride < index) {
	        stack.push(first, index);
	      }
	      if (index + stride < last) {
	        stack.push(index, last);
	      }
	    }
	  }
	  for (var i$1 = 0; i$1 < n; ++i$1) {
	    if (markers[i$1]) {
	      simplifiedFlatCoordinates[simplifiedOffset++] =
	          flatCoordinates[offset + i$1 * stride];
	      simplifiedFlatCoordinates[simplifiedOffset++] =
	          flatCoordinates[offset + i$1 * stride + 1];
	    }
	  }
	  return simplifiedOffset;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
	 *     coordinates.
	 * @param {number} simplifiedOffset Simplified offset.
	 * @param {Array<number>} simplifiedEnds Simplified ends.
	 * @return {number} Simplified offset.
	 */
	function douglasPeuckerArray(flatCoordinates, offset,
	  ends, stride, squaredTolerance, simplifiedFlatCoordinates,
	  simplifiedOffset, simplifiedEnds) {
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    simplifiedOffset = douglasPeucker(
	      flatCoordinates, offset, end, stride, squaredTolerance,
	      simplifiedFlatCoordinates, simplifiedOffset);
	    simplifiedEnds.push(simplifiedOffset);
	    offset = end;
	  }
	  return simplifiedOffset;
	}
	
	
	/**
	 * @param {number} value Value.
	 * @param {number} tolerance Tolerance.
	 * @return {number} Rounded value.
	 */
	function snap(value, tolerance) {
	  return tolerance * Math.round(value / tolerance);
	}
	
	
	/**
	 * Simplifies a line string using an algorithm designed by Tim Schaub.
	 * Coordinates are snapped to the nearest value in a virtual grid and
	 * consecutive duplicate coordinates are discarded.  This effectively preserves
	 * topology as the simplification of any subsection of a line string is
	 * independent of the rest of the line string.  This means that, for examples,
	 * the common edge between two polygons will be simplified to the same line
	 * string independently in both polygons.  This implementation uses a single
	 * pass over the coordinates and eliminates intermediate collinear points.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} tolerance Tolerance.
	 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
	 *     coordinates.
	 * @param {number} simplifiedOffset Simplified offset.
	 * @return {number} Simplified offset.
	 */
	function quantize(flatCoordinates, offset, end, stride,
	  tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
	  // do nothing if the line is empty
	  if (offset == end) {
	    return simplifiedOffset;
	  }
	  // snap the first coordinate (P1)
	  var x1 = snap(flatCoordinates[offset], tolerance);
	  var y1 = snap(flatCoordinates[offset + 1], tolerance);
	  offset += stride;
	  // add the first coordinate to the output
	  simplifiedFlatCoordinates[simplifiedOffset++] = x1;
	  simplifiedFlatCoordinates[simplifiedOffset++] = y1;
	  // find the next coordinate that does not snap to the same value as the first
	  // coordinate (P2)
	  var x2, y2;
	  do {
	    x2 = snap(flatCoordinates[offset], tolerance);
	    y2 = snap(flatCoordinates[offset + 1], tolerance);
	    offset += stride;
	    if (offset == end) {
	      // all coordinates snap to the same value, the line collapses to a point
	      // push the last snapped value anyway to ensure that the output contains
	      // at least two points
	      // FIXME should we really return at least two points anyway?
	      simplifiedFlatCoordinates[simplifiedOffset++] = x2;
	      simplifiedFlatCoordinates[simplifiedOffset++] = y2;
	      return simplifiedOffset;
	    }
	  } while (x2 == x1 && y2 == y1);
	  while (offset < end) {
	    // snap the next coordinate (P3)
	    var x3 = snap(flatCoordinates[offset], tolerance);
	    var y3 = snap(flatCoordinates[offset + 1], tolerance);
	    offset += stride;
	    // skip P3 if it is equal to P2
	    if (x3 == x2 && y3 == y2) {
	      continue;
	    }
	    // calculate the delta between P1 and P2
	    var dx1 = x2 - x1;
	    var dy1 = y2 - y1;
	    // calculate the delta between P3 and P1
	    var dx2 = x3 - x1;
	    var dy2 = y3 - y1;
	    // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
	    // P1 in the same direction then P2 is on the straight line between P1 and
	    // P3
	    if ((dx1 * dy2 == dy1 * dx2) &&
	        ((dx1 < 0 && dx2 < dx1) || dx1 == dx2 || (dx1 > 0 && dx2 > dx1)) &&
	        ((dy1 < 0 && dy2 < dy1) || dy1 == dy2 || (dy1 > 0 && dy2 > dy1))) {
	      // discard P2 and set P2 = P3
	      x2 = x3;
	      y2 = y3;
	      continue;
	    }
	    // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
	    // between P3 and P1 or on the opposite half of the line to P2.  add P2,
	    // and continue with P1 = P2 and P2 = P3
	    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
	    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
	    x1 = x2;
	    y1 = y2;
	    x2 = x3;
	    y2 = y3;
	  }
	  // add the last point (P2)
	  simplifiedFlatCoordinates[simplifiedOffset++] = x2;
	  simplifiedFlatCoordinates[simplifiedOffset++] = y2;
	  return simplifiedOffset;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {number} tolerance Tolerance.
	 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
	 *     coordinates.
	 * @param {number} simplifiedOffset Simplified offset.
	 * @param {Array<number>} simplifiedEnds Simplified ends.
	 * @return {number} Simplified offset.
	 */
	function quantizeArray(
	  flatCoordinates, offset, ends, stride,
	  tolerance,
	  simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    simplifiedOffset = quantize(
	      flatCoordinates, offset, end, stride,
	      tolerance,
	      simplifiedFlatCoordinates, simplifiedOffset);
	    simplifiedEnds.push(simplifiedOffset);
	    offset = end;
	  }
	  return simplifiedOffset;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {number} tolerance Tolerance.
	 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
	 *     coordinates.
	 * @param {number} simplifiedOffset Simplified offset.
	 * @param {Array<Array<number>>} simplifiedEndss Simplified endss.
	 * @return {number} Simplified offset.
	 */
	function quantizeMultiArray(
	  flatCoordinates, offset, endss, stride,
	  tolerance,
	  simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    var simplifiedEnds = [];
	    simplifiedOffset = quantizeArray(
	      flatCoordinates, offset, ends, stride,
	      tolerance,
	      simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
	    simplifiedEndss.push(simplifiedEnds);
	    offset = ends[ends.length - 1];
	  }
	  return simplifiedOffset;
	}
	
	/**
	 * @module ol/geom/LinearRing
	 */
	
	/**
	 * @classdesc
	 * Linear ring geometry. Only used as part of polygon; cannot be rendered
	 * on its own.
	 *
	 * @api
	 */
	var LinearRing = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function LinearRing(coordinates, opt_layout) {
	
	    SimpleGeometry$$1.call(this);
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDelta_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDeltaRevision_ = -1;
	
	    if (opt_layout !== undefined && !Array.isArray(coordinates[0])) {
	      this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ (coordinates));
	    } else {
	      this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ (coordinates), opt_layout);
	    }
	
	  }
	
	  if ( SimpleGeometry$$1 ) { LinearRing.__proto__ = SimpleGeometry$$1; }
	  LinearRing.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  LinearRing.prototype.constructor = LinearRing;
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!LinearRing} Clone.
	   * @override
	   * @api
	   */
	  LinearRing.prototype.clone = function clone$$1 () {
	    return new LinearRing(this.flatCoordinates.slice(), this.layout);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LinearRing.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    if (this.maxDeltaRevision_ != this.getRevision()) {
	      this.maxDelta_ = Math.sqrt(maxSquaredDelta(
	        this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
	      this.maxDeltaRevision_ = this.getRevision();
	    }
	    return assignClosestPoint(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride,
	      this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
	  };
	
	  /**
	   * Return the area of the linear ring on projected plane.
	   * @return {number} Area (on projected plane).
	   * @api
	   */
	  LinearRing.prototype.getArea = function getArea$$1 () {
	    return linearRing(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
	  };
	
	  /**
	   * Return the coordinates of the linear ring.
	   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
	   * @override
	   * @api
	   */
	  LinearRing.prototype.getCoordinates = function getCoordinates () {
	    return inflateCoordinates(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LinearRing.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal (squaredTolerance) {
	    var simplifiedFlatCoordinates = [];
	    simplifiedFlatCoordinates.length = douglasPeucker(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride,
	      squaredTolerance, simplifiedFlatCoordinates, 0);
	    return new LinearRing(simplifiedFlatCoordinates, GeometryLayout.XY);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  LinearRing.prototype.getType = function getType () {
	    return GeometryType.LINEAR_RING;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LinearRing.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return false;
	  };
	
	  /**
	   * Set the coordinates of the linear ring.
	   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
	   * @param {GeometryLayout=} opt_layout Layout.
	   * @override
	   * @api
	   */
	  LinearRing.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 1);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    this.flatCoordinates.length = deflateCoordinates(
	      this.flatCoordinates, 0, coordinates, this.stride);
	    this.changed();
	  };
	
	  return LinearRing;
	}(SimpleGeometry));
	
	/**
	 * @module ol/geom/Point
	 */
	
	/**
	 * @classdesc
	 * Point geometry.
	 *
	 * @api
	 */
	var Point = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function Point(coordinates, opt_layout) {
	    SimpleGeometry$$1.call(this);
	    this.setCoordinates(coordinates, opt_layout);
	  }
	
	  if ( SimpleGeometry$$1 ) { Point.__proto__ = SimpleGeometry$$1; }
	  Point.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  Point.prototype.constructor = Point;
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!Point} Clone.
	   * @override
	   * @api
	   */
	  Point.prototype.clone = function clone$$1 () {
	    var point = new Point(this.flatCoordinates.slice(), this.layout);
	    return point;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Point.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    var flatCoordinates = this.flatCoordinates;
	    var squaredDistance$$1 = squaredDistance(x, y, flatCoordinates[0], flatCoordinates[1]);
	    if (squaredDistance$$1 < minSquaredDistance) {
	      var stride = this.stride;
	      for (var i = 0; i < stride; ++i) {
	        closestPoint[i] = flatCoordinates[i];
	      }
	      closestPoint.length = stride;
	      return squaredDistance$$1;
	    } else {
	      return minSquaredDistance;
	    }
	  };
	
	  /**
	   * Return the coordinate of the point.
	   * @return {import("../coordinate.js").Coordinate} Coordinates.
	   * @override
	   * @api
	   */
	  Point.prototype.getCoordinates = function getCoordinates () {
	    return !this.flatCoordinates ? [] : this.flatCoordinates.slice();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Point.prototype.computeExtent = function computeExtent (extent) {
	    return createOrUpdateFromCoordinate(this.flatCoordinates, extent);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Point.prototype.getType = function getType () {
	    return GeometryType.POINT;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Point.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return containsXY(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Point.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 0);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    this.flatCoordinates.length = deflateCoordinate(
	      this.flatCoordinates, 0, coordinates, this.stride);
	    this.changed();
	  };
	
	  return Point;
	}(SimpleGeometry));
	
	/**
	 * @module ol/geom/flat/contains
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {import("../../extent.js").Extent} extent Extent.
	 * @return {boolean} Contains extent.
	 */
	function linearRingContainsExtent(flatCoordinates, offset, end, stride, extent) {
	  var outside = forEachCorner(extent,
	    /**
	     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
	     * @return {boolean} Contains (x, y).
	     */
	    function(coordinate) {
	      return !linearRingContainsXY(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
	    });
	  return !outside;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @return {boolean} Contains (x, y).
	 */
	function linearRingContainsXY(flatCoordinates, offset, end, stride, x, y) {
	  // http://geomalgorithms.com/a03-_inclusion.html
	  // Copyright 2000 softSurfer, 2012 Dan Sunday
	  // This code may be freely used and modified for any purpose
	  // providing that this copyright notice is included with it.
	  // SoftSurfer makes no warranty for this code, and cannot be held
	  // liable for any real or imagined damage resulting from its use.
	  // Users of this code must verify correctness for their application.
	  var wn = 0;
	  var x1 = flatCoordinates[end - stride];
	  var y1 = flatCoordinates[end - stride + 1];
	  for (; offset < end; offset += stride) {
	    var x2 = flatCoordinates[offset];
	    var y2 = flatCoordinates[offset + 1];
	    if (y1 <= y) {
	      if (y2 > y && ((x2 - x1) * (y - y1)) - ((x - x1) * (y2 - y1)) > 0) {
	        wn++;
	      }
	    } else if (y2 <= y && ((x2 - x1) * (y - y1)) - ((x - x1) * (y2 - y1)) < 0) {
	      wn--;
	    }
	    x1 = x2;
	    y1 = y2;
	  }
	  return wn !== 0;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @return {boolean} Contains (x, y).
	 */
	function linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y) {
	  if (ends.length === 0) {
	    return false;
	  }
	  if (!linearRingContainsXY(flatCoordinates, offset, ends[0], stride, x, y)) {
	    return false;
	  }
	  for (var i = 1, ii = ends.length; i < ii; ++i) {
	    if (linearRingContainsXY(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @return {boolean} Contains (x, y).
	 */
	function linearRingssContainsXY(flatCoordinates, offset, endss, stride, x, y) {
	  if (endss.length === 0) {
	    return false;
	  }
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    if (linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y)) {
	      return true;
	    }
	    offset = ends[ends.length - 1];
	  }
	  return false;
	}
	
	/**
	 * @module ol/geom/flat/interiorpoint
	 */
	
	
	/**
	 * Calculates a point that is likely to lie in the interior of the linear rings.
	 * Inspired by JTS's com.vividsolutions.jts.geom.Geometry#getInteriorPoint.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {Array<number>} flatCenters Flat centers.
	 * @param {number} flatCentersOffset Flat center offset.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Destination point as XYM coordinate, where M is the
	 * length of the horizontal intersection that the point belongs to.
	 */
	function getInteriorPointOfArray(flatCoordinates, offset,
	  ends, stride, flatCenters, flatCentersOffset, opt_dest) {
	  var i, ii, x, x1, x2, y1, y2;
	  var y = flatCenters[flatCentersOffset + 1];
	  /** @type {Array<number>} */
	  var intersections = [];
	  // Calculate intersections with the horizontal line
	  for (var r = 0, rr = ends.length; r < rr; ++r) {
	    var end = ends[r];
	    x1 = flatCoordinates[end - stride];
	    y1 = flatCoordinates[end - stride + 1];
	    for (i = offset; i < end; i += stride) {
	      x2 = flatCoordinates[i];
	      y2 = flatCoordinates[i + 1];
	      if ((y <= y1 && y2 <= y) || (y1 <= y && y <= y2)) {
	        x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
	        intersections.push(x);
	      }
	      x1 = x2;
	      y1 = y2;
	    }
	  }
	  // Find the longest segment of the horizontal line that has its center point
	  // inside the linear ring.
	  var pointX = NaN;
	  var maxSegmentLength = -Infinity;
	  intersections.sort(numberSafeCompareFunction);
	  x1 = intersections[0];
	  for (i = 1, ii = intersections.length; i < ii; ++i) {
	    x2 = intersections[i];
	    var segmentLength = Math.abs(x2 - x1);
	    if (segmentLength > maxSegmentLength) {
	      x = (x1 + x2) / 2;
	      if (linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y)) {
	        pointX = x;
	        maxSegmentLength = segmentLength;
	      }
	    }
	    x1 = x2;
	  }
	  if (isNaN(pointX)) {
	    // There is no horizontal line that has its center point inside the linear
	    // ring.  Use the center of the the linear ring's extent.
	    pointX = flatCenters[flatCentersOffset];
	  }
	  if (opt_dest) {
	    opt_dest.push(pointX, y, maxSegmentLength);
	    return opt_dest;
	  } else {
	    return [pointX, y, maxSegmentLength];
	  }
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {Array<number>} flatCenters Flat centers.
	 * @return {Array<number>} Interior points as XYM coordinates, where M is the
	 * length of the horizontal intersection that the point belongs to.
	 */
	function getInteriorPointsOfMultiArray(flatCoordinates, offset, endss, stride, flatCenters) {
	  var interiorPoints = [];
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    interiorPoints = getInteriorPointOfArray(flatCoordinates,
	      offset, ends, stride, flatCenters, 2 * i, interiorPoints);
	    offset = ends[ends.length - 1];
	  }
	  return interiorPoints;
	}
	
	/**
	 * @module ol/geom/flat/segments
	 */
	
	
	/**
	 * This function calls `callback` for each segment of the flat coordinates
	 * array. If the callback returns a truthy value the function returns that
	 * value immediately. Otherwise the function returns `false`.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {function(this: S, import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
	 *     called for each segment.
	 * @param {S=} opt_this The object to be used as the value of 'this'
	 *     within callback.
	 * @api
	 * @return {T|boolean} Value.
	 * @template T,S
	 */
	function forEach(flatCoordinates, offset, end, stride, callback, opt_this) {
	  var point1 = [flatCoordinates[offset], flatCoordinates[offset + 1]];
	  var point2 = [];
	  var ret;
	  for (; (offset + stride) < end; offset += stride) {
	    point2[0] = flatCoordinates[offset + stride];
	    point2[1] = flatCoordinates[offset + stride + 1];
	    ret = callback.call(opt_this, point1, point2);
	    if (ret) {
	      return ret;
	    }
	    point1[0] = point2[0];
	    point1[1] = point2[1];
	  }
	  return false;
	}
	
	/**
	 * @module ol/geom/flat/intersectsextent
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {import("../../extent.js").Extent} extent Extent.
	 * @return {boolean} True if the geometry and the extent intersect.
	 */
	function intersectsLineString(flatCoordinates, offset, end, stride, extent) {
	  var coordinatesExtent = extendFlatCoordinates(
	    createEmpty(), flatCoordinates, offset, end, stride);
	  if (!intersects(extent, coordinatesExtent)) {
	    return false;
	  }
	  if (containsExtent(extent, coordinatesExtent)) {
	    return true;
	  }
	  if (coordinatesExtent[0] >= extent[0] &&
	      coordinatesExtent[2] <= extent[2]) {
	    return true;
	  }
	  if (coordinatesExtent[1] >= extent[1] &&
	      coordinatesExtent[3] <= extent[3]) {
	    return true;
	  }
	  return forEach(flatCoordinates, offset, end, stride,
	    /**
	     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
	     * @param {import("../../coordinate.js").Coordinate} point2 End point.
	     * @return {boolean} `true` if the segment and the extent intersect,
	     *     `false` otherwise.
	     */
	    function(point1, point2) {
	      return intersectsSegment(extent, point1, point2);
	    });
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {import("../../extent.js").Extent} extent Extent.
	 * @return {boolean} True if the geometry and the extent intersect.
	 */
	function intersectsLineStringArray(flatCoordinates, offset, ends, stride, extent) {
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    if (intersectsLineString(
	      flatCoordinates, offset, ends[i], stride, extent)) {
	      return true;
	    }
	    offset = ends[i];
	  }
	  return false;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {import("../../extent.js").Extent} extent Extent.
	 * @return {boolean} True if the geometry and the extent intersect.
	 */
	function intersectsLinearRing(flatCoordinates, offset, end, stride, extent) {
	  if (intersectsLineString(
	    flatCoordinates, offset, end, stride, extent)) {
	    return true;
	  }
	  if (linearRingContainsXY(flatCoordinates, offset, end, stride, extent[0], extent[1])) {
	    return true;
	  }
	  if (linearRingContainsXY(flatCoordinates, offset, end, stride, extent[0], extent[3])) {
	    return true;
	  }
	  if (linearRingContainsXY(flatCoordinates, offset, end, stride, extent[2], extent[1])) {
	    return true;
	  }
	  if (linearRingContainsXY(flatCoordinates, offset, end, stride, extent[2], extent[3])) {
	    return true;
	  }
	  return false;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {import("../../extent.js").Extent} extent Extent.
	 * @return {boolean} True if the geometry and the extent intersect.
	 */
	function intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent) {
	  if (!intersectsLinearRing(
	    flatCoordinates, offset, ends[0], stride, extent)) {
	    return false;
	  }
	  if (ends.length === 1) {
	    return true;
	  }
	  for (var i = 1, ii = ends.length; i < ii; ++i) {
	    if (linearRingContainsExtent(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
	      if (!intersectsLineString(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @param {import("../../extent.js").Extent} extent Extent.
	 * @return {boolean} True if the geometry and the extent intersect.
	 */
	function intersectsLinearRingMultiArray(flatCoordinates, offset, endss, stride, extent) {
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    if (intersectsLinearRingArray(
	      flatCoordinates, offset, ends, stride, extent)) {
	      return true;
	    }
	    offset = ends[ends.length - 1];
	  }
	  return false;
	}
	
	/**
	 * @module ol/geom/flat/reverse
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 */
	function coordinates(flatCoordinates, offset, end, stride) {
	  while (offset < end - stride) {
	    for (var i = 0; i < stride; ++i) {
	      var tmp = flatCoordinates[offset + i];
	      flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
	      flatCoordinates[end - stride + i] = tmp;
	    }
	    offset += stride;
	    end -= stride;
	  }
	}
	
	/**
	 * @module ol/geom/flat/orient
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @return {boolean} Is clockwise.
	 */
	function linearRingIsClockwise(flatCoordinates, offset, end, stride) {
	  // http://tinyurl.com/clockwise-method
	  // https://github.com/OSGeo/gdal/blob/trunk/gdal/ogr/ogrlinearring.cpp
	  var edge = 0;
	  var x1 = flatCoordinates[end - stride];
	  var y1 = flatCoordinates[end - stride + 1];
	  for (; offset < end; offset += stride) {
	    var x2 = flatCoordinates[offset];
	    var y2 = flatCoordinates[offset + 1];
	    edge += (x2 - x1) * (y2 + y1);
	    x1 = x2;
	    y1 = y2;
	  }
	  return edge > 0;
	}
	
	
	/**
	 * Determines if linear rings are oriented.  By default, left-hand orientation
	 * is tested (first ring must be clockwise, remaining rings counter-clockwise).
	 * To test for right-hand orientation, use the `opt_right` argument.
	 *
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Array of end indexes.
	 * @param {number} stride Stride.
	 * @param {boolean=} opt_right Test for right-hand orientation
	 *     (counter-clockwise exterior ring and clockwise interior rings).
	 * @return {boolean} Rings are correctly oriented.
	 */
	function linearRingIsOriented(flatCoordinates, offset, ends, stride, opt_right) {
	  var right = opt_right !== undefined ? opt_right : false;
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    var isClockwise = linearRingIsClockwise(
	      flatCoordinates, offset, end, stride);
	    if (i === 0) {
	      if ((right && isClockwise) || (!right && !isClockwise)) {
	        return false;
	      }
	    } else {
	      if ((right && !isClockwise) || (!right && isClockwise)) {
	        return false;
	      }
	    }
	    offset = end;
	  }
	  return true;
	}
	
	
	/**
	 * Determines if linear rings are oriented.  By default, left-hand orientation
	 * is tested (first ring must be clockwise, remaining rings counter-clockwise).
	 * To test for right-hand orientation, use the `opt_right` argument.
	 *
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Array of array of end indexes.
	 * @param {number} stride Stride.
	 * @param {boolean=} opt_right Test for right-hand orientation
	 *     (counter-clockwise exterior ring and clockwise interior rings).
	 * @return {boolean} Rings are correctly oriented.
	 */
	function linearRingsAreOriented(flatCoordinates, offset, endss, stride, opt_right) {
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    if (!linearRingIsOriented(
	      flatCoordinates, offset, endss[i], stride, opt_right)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	
	/**
	 * Orient coordinates in a flat array of linear rings.  By default, rings
	 * are oriented following the left-hand rule (clockwise for exterior and
	 * counter-clockwise for interior rings).  To orient according to the
	 * right-hand rule, use the `opt_right` argument.
	 *
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {boolean=} opt_right Follow the right-hand rule for orientation.
	 * @return {number} End.
	 */
	function orientLinearRings(flatCoordinates, offset, ends, stride, opt_right) {
	  var right = opt_right !== undefined ? opt_right : false;
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    var isClockwise = linearRingIsClockwise(
	      flatCoordinates, offset, end, stride);
	    var reverse = i === 0 ?
	      (right && isClockwise) || (!right && !isClockwise) :
	      (right && !isClockwise) || (!right && isClockwise);
	    if (reverse) {
	      coordinates(flatCoordinates, offset, end, stride);
	    }
	    offset = end;
	  }
	  return offset;
	}
	
	
	/**
	 * Orient coordinates in a flat array of linear rings.  By default, rings
	 * are oriented following the left-hand rule (clockwise for exterior and
	 * counter-clockwise for interior rings).  To orient according to the
	 * right-hand rule, use the `opt_right` argument.
	 *
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Array of array of end indexes.
	 * @param {number} stride Stride.
	 * @param {boolean=} opt_right Follow the right-hand rule for orientation.
	 * @return {number} End.
	 */
	function orientLinearRingsArray(flatCoordinates, offset, endss, stride, opt_right) {
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    offset = orientLinearRings(
	      flatCoordinates, offset, endss[i], stride, opt_right);
	  }
	  return offset;
	}
	
	/**
	 * @module ol/geom/Polygon
	 */
	
	/**
	 * @classdesc
	 * Polygon geometry.
	 *
	 * @api
	 */
	var Polygon = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function Polygon(coordinates, opt_layout, opt_ends) {
	
	    SimpleGeometry$$1.call(this);
	
	    /**
	     * @type {Array<number>}
	     * @private
	     */
	    this.ends_ = [];
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.flatInteriorPointRevision_ = -1;
	
	    /**
	     * @private
	     * @type {import("../coordinate.js").Coordinate}
	     */
	    this.flatInteriorPoint_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDelta_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDeltaRevision_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.orientedRevision_ = -1;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.orientedFlatCoordinates_ = null;
	
	    if (opt_layout !== undefined && opt_ends) {
	      this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ (coordinates));
	      this.ends_ = opt_ends;
	    } else {
	      this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ (coordinates), opt_layout);
	    }
	
	  }
	
	  if ( SimpleGeometry$$1 ) { Polygon.__proto__ = SimpleGeometry$$1; }
	  Polygon.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  Polygon.prototype.constructor = Polygon;
	
	  /**
	   * Append the passed linear ring to this polygon.
	   * @param {LinearRing} linearRing Linear ring.
	   * @api
	   */
	  Polygon.prototype.appendLinearRing = function appendLinearRing (linearRing$$1) {
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = linearRing$$1.getFlatCoordinates().slice();
	    } else {
	      extend(this.flatCoordinates, linearRing$$1.getFlatCoordinates());
	    }
	    this.ends_.push(this.flatCoordinates.length);
	    this.changed();
	  };
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!Polygon} Clone.
	   * @override
	   * @api
	   */
	  Polygon.prototype.clone = function clone$$1 () {
	    return new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polygon.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    if (this.maxDeltaRevision_ != this.getRevision()) {
	      this.maxDelta_ = Math.sqrt(arrayMaxSquaredDelta(
	        this.flatCoordinates, 0, this.ends_, this.stride, 0));
	      this.maxDeltaRevision_ = this.getRevision();
	    }
	    return assignClosestArrayPoint(
	      this.flatCoordinates, 0, this.ends_, this.stride,
	      this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polygon.prototype.containsXY = function containsXY$$1 (x, y) {
	    return linearRingsContainsXY(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
	  };
	
	  /**
	   * Return the area of the polygon on projected plane.
	   * @return {number} Area (on projected plane).
	   * @api
	   */
	  Polygon.prototype.getArea = function getArea$$1 () {
	    return linearRings(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
	  };
	
	  /**
	   * Get the coordinate array for this geometry.  This array has the structure
	   * of a GeoJSON coordinate array for polygons.
	   *
	   * @param {boolean=} opt_right Orient coordinates according to the right-hand
	   *     rule (counter-clockwise for exterior and clockwise for interior rings).
	   *     If `false`, coordinates will be oriented according to the left-hand rule
	   *     (clockwise for exterior and counter-clockwise for interior rings).
	   *     By default, coordinate orientation will depend on how the geometry was
	   *     constructed.
	   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
	   * @override
	   * @api
	   */
	  Polygon.prototype.getCoordinates = function getCoordinates (opt_right) {
	    var flatCoordinates;
	    if (opt_right !== undefined) {
	      flatCoordinates = this.getOrientedFlatCoordinates().slice();
	      orientLinearRings(
	        flatCoordinates, 0, this.ends_, this.stride, opt_right);
	    } else {
	      flatCoordinates = this.flatCoordinates;
	    }
	
	    return inflateCoordinatesArray(
	      flatCoordinates, 0, this.ends_, this.stride);
	  };
	
	  /**
	   * @return {Array<number>} Ends.
	   */
	  Polygon.prototype.getEnds = function getEnds () {
	    return this.ends_;
	  };
	
	  /**
	   * @return {Array<number>} Interior point.
	   */
	  Polygon.prototype.getFlatInteriorPoint = function getFlatInteriorPoint () {
	    if (this.flatInteriorPointRevision_ != this.getRevision()) {
	      var flatCenter = getCenter(this.getExtent());
	      this.flatInteriorPoint_ = getInteriorPointOfArray(
	        this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride,
	        flatCenter, 0);
	      this.flatInteriorPointRevision_ = this.getRevision();
	    }
	    return this.flatInteriorPoint_;
	  };
	
	  /**
	   * Return an interior point of the polygon.
	   * @return {Point} Interior point as XYM coordinate, where M is the
	   * length of the horizontal intersection that the point belongs to.
	   * @api
	   */
	  Polygon.prototype.getInteriorPoint = function getInteriorPoint () {
	    return new Point(this.getFlatInteriorPoint(), GeometryLayout.XYM);
	  };
	
	  /**
	   * Return the number of rings of the polygon,  this includes the exterior
	   * ring and any interior rings.
	   *
	   * @return {number} Number of rings.
	   * @api
	   */
	  Polygon.prototype.getLinearRingCount = function getLinearRingCount () {
	    return this.ends_.length;
	  };
	
	  /**
	   * Return the Nth linear ring of the polygon geometry. Return `null` if the
	   * given index is out of range.
	   * The exterior linear ring is available at index `0` and the interior rings
	   * at index `1` and beyond.
	   *
	   * @param {number} index Index.
	   * @return {LinearRing} Linear ring.
	   * @api
	   */
	  Polygon.prototype.getLinearRing = function getLinearRing (index) {
	    if (index < 0 || this.ends_.length <= index) {
	      return null;
	    }
	    return new LinearRing(this.flatCoordinates.slice(
	      index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
	  };
	
	  /**
	   * Return the linear rings of the polygon.
	   * @return {Array<LinearRing>} Linear rings.
	   * @api
	   */
	  Polygon.prototype.getLinearRings = function getLinearRings () {
	    var layout = this.layout;
	    var flatCoordinates = this.flatCoordinates;
	    var ends = this.ends_;
	    var linearRings$$1 = [];
	    var offset$$1 = 0;
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      var end = ends[i];
	      var linearRing$$1 = new LinearRing(flatCoordinates.slice(offset$$1, end), layout);
	      linearRings$$1.push(linearRing$$1);
	      offset$$1 = end;
	    }
	    return linearRings$$1;
	  };
	
	  /**
	   * @return {Array<number>} Oriented flat coordinates.
	   */
	  Polygon.prototype.getOrientedFlatCoordinates = function getOrientedFlatCoordinates () {
	    if (this.orientedRevision_ != this.getRevision()) {
	      var flatCoordinates = this.flatCoordinates;
	      if (linearRingIsOriented(
	        flatCoordinates, 0, this.ends_, this.stride)) {
	        this.orientedFlatCoordinates_ = flatCoordinates;
	      } else {
	        this.orientedFlatCoordinates_ = flatCoordinates.slice();
	        this.orientedFlatCoordinates_.length =
	            orientLinearRings(
	              this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
	      }
	      this.orientedRevision_ = this.getRevision();
	    }
	    return this.orientedFlatCoordinates_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polygon.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal (squaredTolerance) {
	    var simplifiedFlatCoordinates = [];
	    var simplifiedEnds = [];
	    simplifiedFlatCoordinates.length = quantizeArray(
	      this.flatCoordinates, 0, this.ends_, this.stride,
	      Math.sqrt(squaredTolerance),
	      simplifiedFlatCoordinates, 0, simplifiedEnds);
	    return new Polygon(simplifiedFlatCoordinates, GeometryLayout.XY, simplifiedEnds);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Polygon.prototype.getType = function getType () {
	    return GeometryType.POLYGON;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Polygon.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return intersectsLinearRingArray(
	      this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
	  };
	
	  /**
	   * Set the coordinates of the polygon.
	   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
	   * @param {GeometryLayout=} opt_layout Layout.
	   * @override
	   * @api
	   */
	  Polygon.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 2);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    var ends = deflateCoordinatesArray(
	      this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
	    this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
	    this.changed();
	  };
	
	  return Polygon;
	}(SimpleGeometry));
	
	
	/**
	 * Create an approximation of a circle on the surface of a sphere.
	 * @param {import("../coordinate.js").Coordinate} center Center (`[lon, lat]` in degrees).
	 * @param {number} radius The great-circle distance from the center to
	 *     the polygon vertices.
	 * @param {number=} opt_n Optional number of vertices for the resulting
	 *     polygon. Default is `32`.
	 * @param {number=} opt_sphereRadius Optional radius for the sphere (defaults to
	 *     the Earth's mean radius using the WGS84 ellipsoid).
	 * @return {Polygon} The "circular" polygon.
	 * @api
	 */
	function circular(center, radius, opt_n, opt_sphereRadius) {
	  var n = opt_n ? opt_n : 32;
	  /** @type {Array<number>} */
	  var flatCoordinates = [];
	  for (var i = 0; i < n; ++i) {
	    extend(flatCoordinates, offset(center, radius, 2 * Math.PI * i / n, opt_sphereRadius));
	  }
	  flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
	  return new Polygon(flatCoordinates, GeometryLayout.XY, [flatCoordinates.length]);
	}
	
	
	/**
	 * Create a polygon from an extent. The layout used is `XY`.
	 * @param {import("../extent.js").Extent} extent The extent.
	 * @return {Polygon} The polygon.
	 * @api
	 */
	function fromExtent(extent) {
	  var minX = extent[0];
	  var minY = extent[1];
	  var maxX = extent[2];
	  var maxY = extent[3];
	  var flatCoordinates =
	      [minX, minY, minX, maxY, maxX, maxY, maxX, minY, minX, minY];
	  return new Polygon(flatCoordinates, GeometryLayout.XY, [flatCoordinates.length]);
	}
	
	
	/**
	 * Create a regular polygon from a circle.
	 * @param {import("./Circle.js").default} circle Circle geometry.
	 * @param {number=} opt_sides Number of sides of the polygon. Default is 32.
	 * @param {number=} opt_angle Start angle for the first vertex of the polygon in
	 *     radians. Default is 0.
	 * @return {Polygon} Polygon geometry.
	 * @api
	 */
	function fromCircle(circle, opt_sides, opt_angle) {
	  var sides = opt_sides ? opt_sides : 32;
	  var stride = circle.getStride();
	  var layout = circle.getLayout();
	  var center = circle.getCenter();
	  var arrayLength = stride * (sides + 1);
	  var flatCoordinates = new Array(arrayLength);
	  for (var i = 0; i < arrayLength; i += stride) {
	    flatCoordinates[i] = 0;
	    flatCoordinates[i + 1] = 0;
	    for (var j = 2; j < stride; j++) {
	      flatCoordinates[i + j] = center[j];
	    }
	  }
	  var ends = [flatCoordinates.length];
	  var polygon = new Polygon(flatCoordinates, layout, ends);
	  makeRegular(polygon, center, circle.getRadius(), opt_angle);
	  return polygon;
	}
	
	
	/**
	 * Modify the coordinates of a polygon to make it a regular polygon.
	 * @param {Polygon} polygon Polygon geometry.
	 * @param {import("../coordinate.js").Coordinate} center Center of the regular polygon.
	 * @param {number} radius Radius of the regular polygon.
	 * @param {number=} opt_angle Start angle for the first vertex of the polygon in
	 *     radians. Default is 0.
	 */
	function makeRegular(polygon, center, radius, opt_angle) {
	  var flatCoordinates = polygon.getFlatCoordinates();
	  var stride = polygon.getStride();
	  var sides = flatCoordinates.length / stride - 1;
	  var startAngle = opt_angle ? opt_angle : 0;
	  for (var i = 0; i <= sides; ++i) {
	    var offset$$1 = i * stride;
	    var angle = startAngle + (modulo(i, sides) * 2 * Math.PI / sides);
	    flatCoordinates[offset$$1] = center[0] + (radius * Math.cos(angle));
	    flatCoordinates[offset$$1 + 1] = center[1] + (radius * Math.sin(angle));
	  }
	  polygon.changed();
	}
	
	/**
	 * @module ol/webgl
	 */
	
	
	/**
	 * Constants taken from goog.webgl
	 */
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var ONE = 1;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var SRC_ALPHA = 0x0302;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var COLOR_ATTACHMENT0 = 0x8CE0;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var COLOR_BUFFER_BIT = 0x00004000;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TRIANGLES = 0x0004;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TRIANGLE_STRIP = 0x0005;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var ONE_MINUS_SRC_ALPHA = 0x0303;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var ARRAY_BUFFER = 0x8892;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var ELEMENT_ARRAY_BUFFER = 0x8893;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var STREAM_DRAW = 0x88E0;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var STATIC_DRAW = 0x88E4;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DYNAMIC_DRAW = 0x88E8;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var CULL_FACE = 0x0B44;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var BLEND = 0x0BE2;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var STENCIL_TEST = 0x0B90;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DEPTH_TEST = 0x0B71;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var SCISSOR_TEST = 0x0C11;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var UNSIGNED_BYTE = 0x1401;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var UNSIGNED_SHORT = 0x1403;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var UNSIGNED_INT = 0x1405;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var FLOAT = 0x1406;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var RGBA = 0x1908;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var FRAGMENT_SHADER = 0x8B30;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var VERTEX_SHADER = 0x8B31;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var LINEAR = 0x2601;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TEXTURE_MAG_FILTER = 0x2800;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TEXTURE_MIN_FILTER = 0x2801;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TEXTURE_WRAP_S = 0x2802;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TEXTURE_WRAP_T = 0x2803;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TEXTURE_2D = 0x0DE1;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var TEXTURE0 = 0x84C0;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var CLAMP_TO_EDGE = 0x812F;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var FRAMEBUFFER = 0x8D40;
	
	
	/** end of goog.webgl constants
	 */
	
	
	/**
	 * @const
	 * @type {Array<string>}
	 */
	var CONTEXT_IDS = [
	  'experimental-webgl',
	  'webgl',
	  'webkit-3d',
	  'moz-webgl'
	];
	
	
	/**
	 * @param {HTMLCanvasElement} canvas Canvas.
	 * @param {Object=} opt_attributes Attributes.
	 * @return {WebGLRenderingContext} WebGL rendering context.
	 */
	function getContext(canvas, opt_attributes) {
	  var ii = CONTEXT_IDS.length;
	  for (var i = 0; i < ii; ++i) {
	    try {
	      var context = canvas.getContext(CONTEXT_IDS[i], opt_attributes);
	      if (context) {
	        return /** @type {!WebGLRenderingContext} */ (context);
	      }
	    } catch (e) {
	      // pass
	    }
	  }
	  return null;
	}
	
	
	/**
	 * The maximum supported WebGL texture size in pixels. If WebGL is not
	 * supported, the value is set to `undefined`.
	 * @type {number|undefined}
	 */
	var MAX_TEXTURE_SIZE; // value is set below
	
	
	/**
	 * List of supported WebGL extensions.
	 * @type {Array<string>}
	 */
	var EXTENSIONS; // value is set below
	
	//TODO Remove side effects
	if (typeof window !== 'undefined' && 'WebGLRenderingContext' in window) {
	  try {
	    var canvas = /** @type {HTMLCanvasElement} */ (document.createElement('canvas'));
	    var gl = getContext(canvas, {failIfMajorPerformanceCaveat: true});
	    if (gl) {
	      MAX_TEXTURE_SIZE = /** @type {number} */ (gl.getParameter(gl.MAX_TEXTURE_SIZE));
	      EXTENSIONS = gl.getSupportedExtensions();
	    }
	  } catch (e) {
	    // pass
	  }
	}
	
	/**
	 * @module ol/has
	 */
	
	var ua = typeof navigator !== 'undefined' ?
	  navigator.userAgent.toLowerCase() : '';
	
	/**
	 * User agent string says we are dealing with Firefox as browser.
	 * @type {boolean}
	 * @api
	 */
	var FIREFOX = ua.indexOf('firefox') !== -1;
	
	/**
	 * User agent string says we are dealing with Safari as browser.
	 * @type {boolean}
	 * @api
	 */
	var SAFARI = ua.indexOf('safari') !== -1 && ua.indexOf('chrom') == -1;
	
	/**
	 * User agent string says we are dealing with a WebKit engine.
	 * @type {boolean}
	 * @api
	 */
	var WEBKIT = ua.indexOf('webkit') !== -1 && ua.indexOf('edge') == -1;
	
	/**
	 * User agent string says we are dealing with a Mac as platform.
	 * @type {boolean}
	 * @api
	 */
	var MAC = ua.indexOf('macintosh') !== -1;
	
	
	/**
	 * The ratio between physical pixels and device-independent pixels
	 * (dips) on the device (`window.devicePixelRatio`).
	 * @const
	 * @type {number}
	 * @api
	 */
	var DEVICE_PIXEL_RATIO = window.devicePixelRatio || 1;
	
	
	/**
	 * True if the browser's Canvas implementation implements {get,set}LineDash.
	 * @type {boolean}
	 */
	var CANVAS_LINE_DASH = function() {
	  var has = false;
	  try {
	    has = !!document.createElement('canvas').getContext('2d').setLineDash;
	  } catch (e) {
	    // pass
	  }
	  return has;
	}();
	
	
	/**
	 * Is HTML5 geolocation supported in the current browser?
	 * @const
	 * @type {boolean}
	 * @api
	 */
	var GEOLOCATION = 'geolocation' in navigator;
	
	
	/**
	 * True if browser supports touch events.
	 * @const
	 * @type {boolean}
	 * @api
	 */
	var TOUCH = 'ontouchstart' in window;
	
	
	/**
	 * True if browser supports pointer events.
	 * @const
	 * @type {boolean}
	 */
	var POINTER = 'PointerEvent' in window;
	
	
	/**
	 * True if browser supports ms pointer events (IE 10).
	 * @const
	 * @type {boolean}
	 */
	var MSPOINTER = !!(navigator.msPointerEnabled);
	
	/**
	 * @module ol/Geolocation
	 */
	
	
	/**
	 * @enum {string}
	 */
	var Property$1 = {
	  ACCURACY: 'accuracy',
	  ACCURACY_GEOMETRY: 'accuracyGeometry',
	  ALTITUDE: 'altitude',
	  ALTITUDE_ACCURACY: 'altitudeAccuracy',
	  HEADING: 'heading',
	  POSITION: 'position',
	  PROJECTION: 'projection',
	  SPEED: 'speed',
	  TRACKING: 'tracking',
	  TRACKING_OPTIONS: 'trackingOptions'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted on Geolocation error.
	 */
	var GeolocationError = /*@__PURE__*/(function (Event$$1) {
	  function GeolocationError(error) {
	    Event$$1.call(this, EventType.ERROR);
	
	    /**
	     * @type {number}
	     */
	    this.code = error.code;
	
	    /**
	     * @type {string}
	     */
	    this.message = error.message;
	  }
	
	  if ( Event$$1 ) { GeolocationError.__proto__ = Event$$1; }
	  GeolocationError.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  GeolocationError.prototype.constructor = GeolocationError;
	
	  return GeolocationError;
	}(Event));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {boolean} [tracking=false] Start Tracking right after
	 * instantiation.
	 * @property {PositionOptions} [trackingOptions] Tracking options.
	 * See http://www.w3.org/TR/geolocation-API/#position_options_interface.
	 * @property {import("./proj.js").ProjectionLike} [projection] The projection the position
	 * is reported in.
	 */
	
	
	/**
	 * @classdesc
	 * Helper class for providing HTML5 Geolocation capabilities.
	 * The [Geolocation API](http://www.w3.org/TR/geolocation-API/)
	 * is used to locate a user's position.
	 *
	 * To get notified of position changes, register a listener for the generic
	 * `change` event on your instance of {@link module:ol/Geolocation~Geolocation}.
	 *
	 * Example:
	 *
	 *     var geolocation = new Geolocation({
	 *       // take the projection to use from the map's view
	 *       projection: view.getProjection()
	 *     });
	 *     // listen to changes in position
	 *     geolocation.on('change', function(evt) {
	 *       window.console.log(geolocation.getPosition());
	 *     });
	 *
	 * @fires error
	 * @api
	 */
	var Geolocation = /*@__PURE__*/(function (BaseObject$$1) {
	  function Geolocation(opt_options) {
	
	    BaseObject$$1.call(this);
	
	    var options = opt_options || {};
	
	    /**
	     * The unprojected (EPSG:4326) device position.
	     * @private
	     * @type {import("./coordinate.js").Coordinate}
	     */
	    this.position_ = null;
	
	    /**
	     * @private
	     * @type {import("./proj.js").TransformFunction}
	     */
	    this.transform_ = identityTransform;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.watchId_ = undefined;
	
	    listen(
	      this, getChangeEventType(Property$1.PROJECTION),
	      this.handleProjectionChanged_, this);
	    listen(
	      this, getChangeEventType(Property$1.TRACKING),
	      this.handleTrackingChanged_, this);
	
	    if (options.projection !== undefined) {
	      this.setProjection(options.projection);
	    }
	    if (options.trackingOptions !== undefined) {
	      this.setTrackingOptions(options.trackingOptions);
	    }
	
	    this.setTracking(options.tracking !== undefined ? options.tracking : false);
	
	  }
	
	  if ( BaseObject$$1 ) { Geolocation.__proto__ = BaseObject$$1; }
	  Geolocation.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Geolocation.prototype.constructor = Geolocation;
	
	  /**
	   * @inheritDoc
	   */
	  Geolocation.prototype.disposeInternal = function disposeInternal () {
	    this.setTracking(false);
	    BaseObject$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @private
	   */
	  Geolocation.prototype.handleProjectionChanged_ = function handleProjectionChanged_ () {
	    var projection = this.getProjection();
	    if (projection) {
	      this.transform_ = getTransformFromProjections(
	        get$2('EPSG:4326'), projection);
	      if (this.position_) {
	        this.set(Property$1.POSITION, this.transform_(this.position_));
	      }
	    }
	  };
	
	  /**
	   * @private
	   */
	  Geolocation.prototype.handleTrackingChanged_ = function handleTrackingChanged_ () {
	    if (GEOLOCATION) {
	      var tracking = this.getTracking();
	      if (tracking && this.watchId_ === undefined) {
	        this.watchId_ = navigator.geolocation.watchPosition(
	          this.positionChange_.bind(this),
	          this.positionError_.bind(this),
	          this.getTrackingOptions());
	      } else if (!tracking && this.watchId_ !== undefined) {
	        navigator.geolocation.clearWatch(this.watchId_);
	        this.watchId_ = undefined;
	      }
	    }
	  };
	
	  /**
	   * @private
	   * @param {Position} position position event.
	   */
	  Geolocation.prototype.positionChange_ = function positionChange_ (position) {
	    var coords = position.coords;
	    this.set(Property$1.ACCURACY, coords.accuracy);
	    this.set(Property$1.ALTITUDE,
	      coords.altitude === null ? undefined : coords.altitude);
	    this.set(Property$1.ALTITUDE_ACCURACY,
	      coords.altitudeAccuracy === null ?
	        undefined : coords.altitudeAccuracy);
	    this.set(Property$1.HEADING, coords.heading === null ?
	      undefined : toRadians(coords.heading));
	    if (!this.position_) {
	      this.position_ = [coords.longitude, coords.latitude];
	    } else {
	      this.position_[0] = coords.longitude;
	      this.position_[1] = coords.latitude;
	    }
	    var projectedPosition = this.transform_(this.position_);
	    this.set(Property$1.POSITION, projectedPosition);
	    this.set(Property$1.SPEED,
	      coords.speed === null ? undefined : coords.speed);
	    var geometry = circular(this.position_, coords.accuracy);
	    geometry.applyTransform(this.transform_);
	    this.set(Property$1.ACCURACY_GEOMETRY, geometry);
	    this.changed();
	  };
	
	  /**
	   * Triggered when the Geolocation returns an error.
	   * @event error
	   * @api
	   */
	
	  /**
	   * @private
	   * @param {PositionError} error error object.
	   */
	  Geolocation.prototype.positionError_ = function positionError_ (error) {
	    this.setTracking(false);
	    this.dispatchEvent(new GeolocationError(error));
	  };
	
	  /**
	   * Get the accuracy of the position in meters.
	   * @return {number|undefined} The accuracy of the position measurement in
	   *     meters.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getAccuracy = function getAccuracy () {
	    return /** @type {number|undefined} */ (this.get(Property$1.ACCURACY));
	  };
	
	  /**
	   * Get a geometry of the position accuracy.
	   * @return {?import("./geom/Polygon.js").default} A geometry of the position accuracy.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getAccuracyGeometry = function getAccuracyGeometry () {
	    return (
	      /** @type {?import("./geom/Polygon.js").default} */ (this.get(Property$1.ACCURACY_GEOMETRY) || null)
	    );
	  };
	
	  /**
	   * Get the altitude associated with the position.
	   * @return {number|undefined} The altitude of the position in meters above mean
	   *     sea level.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getAltitude = function getAltitude () {
	    return /** @type {number|undefined} */ (this.get(Property$1.ALTITUDE));
	  };
	
	  /**
	   * Get the altitude accuracy of the position.
	   * @return {number|undefined} The accuracy of the altitude measurement in
	   *     meters.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getAltitudeAccuracy = function getAltitudeAccuracy () {
	    return /** @type {number|undefined} */ (this.get(Property$1.ALTITUDE_ACCURACY));
	  };
	
	  /**
	   * Get the heading as radians clockwise from North.
	   * Note: depending on the browser, the heading is only defined if the `enableHighAccuracy`
	   * is set to `true` in the tracking options.
	   * @return {number|undefined} The heading of the device in radians from north.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getHeading = function getHeading () {
	    return /** @type {number|undefined} */ (this.get(Property$1.HEADING));
	  };
	
	  /**
	   * Get the position of the device.
	   * @return {import("./coordinate.js").Coordinate|undefined} The current position of the device reported
	   *     in the current projection.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getPosition = function getPosition () {
	    return (
	      /** @type {import("./coordinate.js").Coordinate|undefined} */ (this.get(Property$1.POSITION))
	    );
	  };
	
	  /**
	   * Get the projection associated with the position.
	   * @return {import("./proj/Projection.js").default|undefined} The projection the position is
	   *     reported in.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getProjection = function getProjection () {
	    return (
	      /** @type {import("./proj/Projection.js").default|undefined} */ (this.get(Property$1.PROJECTION))
	    );
	  };
	
	  /**
	   * Get the speed in meters per second.
	   * @return {number|undefined} The instantaneous speed of the device in meters
	   *     per second.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getSpeed = function getSpeed () {
	    return /** @type {number|undefined} */ (this.get(Property$1.SPEED));
	  };
	
	  /**
	   * Determine if the device location is being tracked.
	   * @return {boolean} The device location is being tracked.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getTracking = function getTracking () {
	    return /** @type {boolean} */ (this.get(Property$1.TRACKING));
	  };
	
	  /**
	   * Get the tracking options.
	   * See http://www.w3.org/TR/geolocation-API/#position-options.
	   * @return {PositionOptions|undefined} PositionOptions as defined by
	   *     the [HTML5 Geolocation spec
	   *     ](http://www.w3.org/TR/geolocation-API/#position_options_interface).
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.getTrackingOptions = function getTrackingOptions () {
	    return /** @type {PositionOptions|undefined} */ (this.get(Property$1.TRACKING_OPTIONS));
	  };
	
	  /**
	   * Set the projection to use for transforming the coordinates.
	   * @param {import("./proj.js").ProjectionLike} projection The projection the position is
	   *     reported in.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.setProjection = function setProjection (projection) {
	    this.set(Property$1.PROJECTION, get$2(projection));
	  };
	
	  /**
	   * Enable or disable tracking.
	   * @param {boolean} tracking Enable tracking.
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.setTracking = function setTracking (tracking) {
	    this.set(Property$1.TRACKING, tracking);
	  };
	
	  /**
	   * Set the tracking options.
	   * See http://www.w3.org/TR/geolocation-API/#position-options.
	   * @param {PositionOptions} options PositionOptions as defined by the
	   *     [HTML5 Geolocation spec
	   *     ](http://www.w3.org/TR/geolocation-API/#position_options_interface).
	   * @observable
	   * @api
	   */
	  Geolocation.prototype.setTrackingOptions = function setTrackingOptions (options) {
	    this.set(Property$1.TRACKING_OPTIONS, options);
	  };
	
	  return Geolocation;
	}(BaseObject));
	
	/**
	 * @module ol/string
	 */
	
	/**
	 * @param {number} number Number to be formatted
	 * @param {number} width The desired width
	 * @param {number=} opt_precision Precision of the output string (i.e. number of decimal places)
	 * @returns {string} Formatted string
	 */
	function padNumber(number, width, opt_precision) {
	  var numberString = opt_precision !== undefined ? number.toFixed(opt_precision) : '' + number;
	  var decimal = numberString.indexOf('.');
	  decimal = decimal === -1 ? numberString.length : decimal;
	  return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
	}
	
	
	/**
	 * Adapted from https://github.com/omichelsen/compare-versions/blob/master/index.js
	 * @param {string|number} v1 First version
	 * @param {string|number} v2 Second version
	 * @returns {number} Value
	 */
	function compareVersions(v1, v2) {
	  var s1 = ('' + v1).split('.');
	  var s2 = ('' + v2).split('.');
	
	  for (var i = 0; i < Math.max(s1.length, s2.length); i++) {
	    var n1 = parseInt(s1[i] || '0', 10);
	    var n2 = parseInt(s2[i] || '0', 10);
	
	    if (n1 > n2) {
	      return 1;
	    }
	    if (n2 > n1) {
	      return -1;
	    }
	  }
	
	  return 0;
	}
	
	/**
	 * @module ol/coordinate
	 */
	
	
	/**
	 * An array of numbers representing an xy coordinate. Example: `[16, 48]`.
	 * @typedef {Array<number>} Coordinate
	 * @api
	 */
	
	
	/**
	 * A function that takes a {@link module:ol/coordinate~Coordinate} and
	 * transforms it into a `{string}`.
	 *
	 * @typedef {function((Coordinate|undefined)): string} CoordinateFormat
	 * @api
	 */
	
	
	/**
	 * Add `delta` to `coordinate`. `coordinate` is modified in place and returned
	 * by the function.
	 *
	 * Example:
	 *
	 *     import {add} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     add(coord, [-2, 4]);
	 *     // coord is now [5.85, 51.983333]
	 *
	 * @param {Coordinate} coordinate Coordinate.
	 * @param {Coordinate} delta Delta.
	 * @return {Coordinate} The input coordinate adjusted by
	 * the given delta.
	 * @api
	 */
	function add$2(coordinate, delta) {
	  coordinate[0] += delta[0];
	  coordinate[1] += delta[1];
	  return coordinate;
	}
	
	
	/**
	 * Calculates the point closest to the passed coordinate on the passed circle.
	 *
	 * @param {Coordinate} coordinate The coordinate.
	 * @param {import("./geom/Circle.js").default} circle The circle.
	 * @api
	 * @return {Coordinate} Closest point on the circumference.
	 */
	function closestOnCircle(coordinate, circle) {
	  var r = circle.getRadius();
	  var center = circle.getCenter();
	  var x0 = center[0];
	  var y0 = center[1];
	  var x1 = coordinate[0];
	  var y1 = coordinate[1];
	
	  var dx = x1 - x0;
	  var dy = y1 - y0;
	  if (dx === 0 && dy === 0) {
	    dx = 1;
	  }
	  var d = Math.sqrt(dx * dx + dy * dy);
	
	  var x = x0 + r * dx / d;
	  var y = y0 + r * dy / d;
	
	  return [x, y];
	}
	
	
	/**
	 * Calculates the point closest to the passed coordinate on the passed segment.
	 * This is the foot of the perpendicular of the coordinate to the segment when
	 * the foot is on the segment, or the closest segment coordinate when the foot
	 * is outside the segment.
	 *
	 * @param {Coordinate} coordinate The coordinate.
	 * @param {Array<Coordinate>} segment The two coordinates
	 * of the segment.
	 * @api
	 * @return {Coordinate} The foot of the perpendicular of
	 * the coordinate to the segment.
	 */
	function closestOnSegment(coordinate, segment) {
	  var x0 = coordinate[0];
	  var y0 = coordinate[1];
	  var start = segment[0];
	  var end = segment[1];
	  var x1 = start[0];
	  var y1 = start[1];
	  var x2 = end[0];
	  var y2 = end[1];
	  var dx = x2 - x1;
	  var dy = y2 - y1;
	  var along = (dx === 0 && dy === 0) ? 0 :
	    ((dx * (x0 - x1)) + (dy * (y0 - y1))) / ((dx * dx + dy * dy) || 0);
	  var x, y;
	  if (along <= 0) {
	    x = x1;
	    y = y1;
	  } else if (along >= 1) {
	    x = x2;
	    y = y2;
	  } else {
	    x = x1 + along * dx;
	    y = y1 + along * dy;
	  }
	  return [x, y];
	}
	
	
	/**
	 * Returns a {@link module:ol/coordinate~CoordinateFormat} function that can be
	 * used to format
	 * a {Coordinate} to a string.
	 *
	 * Example without specifying the fractional digits:
	 *
	 *     import {createStringXY} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var stringifyFunc = createStringXY();
	 *     var out = stringifyFunc(coord);
	 *     // out is now '8, 48'
	 *
	 * Example with explicitly specifying 2 fractional digits:
	 *
	 *     import {createStringXY} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var stringifyFunc = createStringXY(2);
	 *     var out = stringifyFunc(coord);
	 *     // out is now '7.85, 47.98'
	 *
	 * @param {number=} opt_fractionDigits The number of digits to include
	 *    after the decimal point. Default is `0`.
	 * @return {CoordinateFormat} Coordinate format.
	 * @api
	 */
	function createStringXY(opt_fractionDigits) {
	  return (
	    /**
	     * @param {Coordinate} coordinate Coordinate.
	     * @return {string} String XY.
	     */
	    function(coordinate) {
	      return toStringXY(coordinate, opt_fractionDigits);
	    }
	  );
	}
	
	
	/**
	 * @param {string} hemispheres Hemispheres.
	 * @param {number} degrees Degrees.
	 * @param {number=} opt_fractionDigits The number of digits to include
	 *    after the decimal point. Default is `0`.
	 * @api
	 * @return {string} String.
	 */
	function degreesToStringHDMS(hemispheres, degrees, opt_fractionDigits) {
	  var normalizedDegrees = modulo(degrees + 180, 360) - 180;
	  var x = Math.abs(3600 * normalizedDegrees);
	  var dflPrecision = opt_fractionDigits || 0;
	  var precision = Math.pow(10, dflPrecision);
	
	  var deg = Math.floor(x / 3600);
	  var min = Math.floor((x - deg * 3600) / 60);
	  var sec = x - (deg * 3600) - (min * 60);
	  sec = Math.ceil(sec * precision) / precision;
	
	  if (sec >= 60) {
	    sec = 0;
	    min += 1;
	  }
	
	  if (min >= 60) {
	    min = 0;
	    deg += 1;
	  }
	
	  return deg + '\u00b0 ' + padNumber(min, 2) + '\u2032 ' +
	    padNumber(sec, 2, dflPrecision) + '\u2033' +
	    (normalizedDegrees == 0 ? '' : ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0));
	}
	
	
	/**
	 * Transforms the given {@link module:ol/coordinate~Coordinate} to a string
	 * using the given string template. The strings `{x}` and `{y}` in the template
	 * will be replaced with the first and second coordinate values respectively.
	 *
	 * Example without specifying the fractional digits:
	 *
	 *     import {format} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var template = 'Coordinate is ({x}|{y}).';
	 *     var out = format(coord, template);
	 *     // out is now 'Coordinate is (8|48).'
	 *
	 * Example explicitly specifying the fractional digits:
	 *
	 *     import {format} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var template = 'Coordinate is ({x}|{y}).';
	 *     var out = format(coord, template, 2);
	 *     // out is now 'Coordinate is (7.85|47.98).'
	 *
	 * @param {Coordinate} coordinate Coordinate.
	 * @param {string} template A template string with `{x}` and `{y}` placeholders
	 *     that will be replaced by first and second coordinate values.
	 * @param {number=} opt_fractionDigits The number of digits to include
	 *    after the decimal point. Default is `0`.
	 * @return {string} Formatted coordinate.
	 * @api
	 */
	function format(coordinate, template, opt_fractionDigits) {
	  if (coordinate) {
	    return template
	      .replace('{x}', coordinate[0].toFixed(opt_fractionDigits))
	      .replace('{y}', coordinate[1].toFixed(opt_fractionDigits));
	  } else {
	    return '';
	  }
	}
	
	
	/**
	 * @param {Coordinate} coordinate1 First coordinate.
	 * @param {Coordinate} coordinate2 Second coordinate.
	 * @api
	 * @return {boolean} The two coordinates are equal.
	 */
	function equals$2(coordinate1, coordinate2) {
	  var equals = true;
	  for (var i = coordinate1.length - 1; i >= 0; --i) {
	    if (coordinate1[i] != coordinate2[i]) {
	      equals = false;
	      break;
	    }
	  }
	  return equals;
	}
	
	
	/**
	 * Rotate `coordinate` by `angle`. `coordinate` is modified in place and
	 * returned by the function.
	 *
	 * Example:
	 *
	 *     import {rotate} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var rotateRadians = Math.PI / 2; // 90 degrees
	 *     rotate(coord, rotateRadians);
	 *     // coord is now [-47.983333, 7.85]
	 *
	 * @param {Coordinate} coordinate Coordinate.
	 * @param {number} angle Angle in radian.
	 * @return {Coordinate} Coordinate.
	 * @api
	 */
	function rotate$2(coordinate, angle) {
	  var cosAngle = Math.cos(angle);
	  var sinAngle = Math.sin(angle);
	  var x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
	  var y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
	  coordinate[0] = x;
	  coordinate[1] = y;
	  return coordinate;
	}
	
	
	/**
	 * Scale `coordinate` by `scale`. `coordinate` is modified in place and returned
	 * by the function.
	 *
	 * Example:
	 *
	 *     import {scale as scaleCoordinate} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var scale = 1.2;
	 *     scaleCoordinate(coord, scale);
	 *     // coord is now [9.42, 57.5799996]
	 *
	 * @param {Coordinate} coordinate Coordinate.
	 * @param {number} scale Scale factor.
	 * @api
	 * @return {Coordinate} Coordinate.
	 */
	function scale$2(coordinate, scale) {
	  coordinate[0] *= scale;
	  coordinate[1] *= scale;
	  return coordinate;
	}
	
	
	/**
	 * @param {Coordinate} coord1 First coordinate.
	 * @param {Coordinate} coord2 Second coordinate.
	 * @return {number} Squared distance between coord1 and coord2.
	 * @api
	 */
	function squaredDistance$1(coord1, coord2) {
	  var dx = coord1[0] - coord2[0];
	  var dy = coord1[1] - coord2[1];
	  return dx * dx + dy * dy;
	}
	
	
	/**
	 * @param {Coordinate} coord1 First coordinate.
	 * @param {Coordinate} coord2 Second coordinate.
	 * @api
	 * @return {number} Distance between coord1 and coord2.
	 */
	function distance(coord1, coord2) {
	  return Math.sqrt(squaredDistance$1(coord1, coord2));
	}
	
	
	/**
	 * Calculate the squared distance from a coordinate to a line segment.
	 *
	 * @param {Coordinate} coordinate Coordinate of the point.
	 * @param {Array<Coordinate>} segment Line segment (2
	 * coordinates).
	 * @api
	 * @return {number} Squared distance from the point to the line segment.
	 */
	function squaredDistanceToSegment(coordinate, segment) {
	  return squaredDistance$1(coordinate,
	    closestOnSegment(coordinate, segment));
	}
	
	
	/**
	 * Format a geographic coordinate with the hemisphere, degrees, minutes, and
	 * seconds.
	 *
	 * Example without specifying fractional digits:
	 *
	 *     import {toStringHDMS} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var out = toStringHDMS(coord);
	 *     // out is now '47° 58′ 60″ N 7° 50′ 60″ E'
	 *
	 * Example explicitly specifying 1 fractional digit:
	 *
	 *     import {toStringHDMS} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var out = toStringHDMS(coord, 1);
	 *     // out is now '47° 58′ 60.0″ N 7° 50′ 60.0″ E'
	 *
	 * @param {Coordinate} coordinate Coordinate.
	 * @param {number=} opt_fractionDigits The number of digits to include
	 *    after the decimal point. Default is `0`.
	 * @return {string} Hemisphere, degrees, minutes and seconds.
	 * @api
	 */
	function toStringHDMS(coordinate, opt_fractionDigits) {
	  if (coordinate) {
	    return degreesToStringHDMS('NS', coordinate[1], opt_fractionDigits) + ' ' +
	        degreesToStringHDMS('EW', coordinate[0], opt_fractionDigits);
	  } else {
	    return '';
	  }
	}
	
	
	/**
	 * Format a coordinate as a comma delimited string.
	 *
	 * Example without specifying fractional digits:
	 *
	 *     import {toStringXY} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var out = toStringXY(coord);
	 *     // out is now '8, 48'
	 *
	 * Example explicitly specifying 1 fractional digit:
	 *
	 *     import {toStringXY} from 'ol/coordinate';
	 *
	 *     var coord = [7.85, 47.983333];
	 *     var out = toStringXY(coord, 1);
	 *     // out is now '7.8, 48.0'
	 *
	 * @param {Coordinate} coordinate Coordinate.
	 * @param {number=} opt_fractionDigits The number of digits to include
	 *    after the decimal point. Default is `0`.
	 * @return {string} XY.
	 * @api
	 */
	function toStringXY(coordinate, opt_fractionDigits) {
	  return format(coordinate, '{x}, {y}', opt_fractionDigits);
	}
	
	/**
	 * @module ol/geom/flat/interpolate
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} fraction Fraction.
	 * @param {Array<number>=} opt_dest Destination.
	 * @return {Array<number>} Destination.
	 */
	function interpolatePoint(flatCoordinates, offset, end, stride, fraction, opt_dest) {
	  var pointX = NaN;
	  var pointY = NaN;
	  var n = (end - offset) / stride;
	  if (n === 1) {
	    pointX = flatCoordinates[offset];
	    pointY = flatCoordinates[offset + 1];
	  } else if (n == 2) {
	    pointX = (1 - fraction) * flatCoordinates[offset] +
	        fraction * flatCoordinates[offset + stride];
	    pointY = (1 - fraction) * flatCoordinates[offset + 1] +
	        fraction * flatCoordinates[offset + stride + 1];
	  } else if (n !== 0) {
	    var x1 = flatCoordinates[offset];
	    var y1 = flatCoordinates[offset + 1];
	    var length = 0;
	    var cumulativeLengths = [0];
	    for (var i = offset + stride; i < end; i += stride) {
	      var x2 = flatCoordinates[i];
	      var y2 = flatCoordinates[i + 1];
	      length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	      cumulativeLengths.push(length);
	      x1 = x2;
	      y1 = y2;
	    }
	    var target = fraction * length;
	    var index = binarySearch(cumulativeLengths, target);
	    if (index < 0) {
	      var t = (target - cumulativeLengths[-index - 2]) /
	          (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
	      var o = offset + (-index - 2) * stride;
	      pointX = lerp(
	        flatCoordinates[o], flatCoordinates[o + stride], t);
	      pointY = lerp(
	        flatCoordinates[o + 1], flatCoordinates[o + stride + 1], t);
	    } else {
	      pointX = flatCoordinates[offset + index * stride];
	      pointY = flatCoordinates[offset + index * stride + 1];
	    }
	  }
	  if (opt_dest) {
	    opt_dest[0] = pointX;
	    opt_dest[1] = pointY;
	    return opt_dest;
	  } else {
	    return [pointX, pointY];
	  }
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {number} m M.
	 * @param {boolean} extrapolate Extrapolate.
	 * @return {import("../../coordinate.js").Coordinate} Coordinate.
	 */
	function lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, extrapolate) {
	  if (end == offset) {
	    return null;
	  }
	  var coordinate;
	  if (m < flatCoordinates[offset + stride - 1]) {
	    if (extrapolate) {
	      coordinate = flatCoordinates.slice(offset, offset + stride);
	      coordinate[stride - 1] = m;
	      return coordinate;
	    } else {
	      return null;
	    }
	  } else if (flatCoordinates[end - 1] < m) {
	    if (extrapolate) {
	      coordinate = flatCoordinates.slice(end - stride, end);
	      coordinate[stride - 1] = m;
	      return coordinate;
	    } else {
	      return null;
	    }
	  }
	  // FIXME use O(1) search
	  if (m == flatCoordinates[offset + stride - 1]) {
	    return flatCoordinates.slice(offset, offset + stride);
	  }
	  var lo = offset / stride;
	  var hi = end / stride;
	  while (lo < hi) {
	    var mid = (lo + hi) >> 1;
	    if (m < flatCoordinates[(mid + 1) * stride - 1]) {
	      hi = mid;
	    } else {
	      lo = mid + 1;
	    }
	  }
	  var m0 = flatCoordinates[lo * stride - 1];
	  if (m == m0) {
	    return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
	  }
	  var m1 = flatCoordinates[(lo + 1) * stride - 1];
	  var t = (m - m0) / (m1 - m0);
	  coordinate = [];
	  for (var i = 0; i < stride - 1; ++i) {
	    coordinate.push(lerp(flatCoordinates[(lo - 1) * stride + i],
	      flatCoordinates[lo * stride + i], t));
	  }
	  coordinate.push(m);
	  return coordinate;
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<number>} ends Ends.
	 * @param {number} stride Stride.
	 * @param {number} m M.
	 * @param {boolean} extrapolate Extrapolate.
	 * @param {boolean} interpolate Interpolate.
	 * @return {import("../../coordinate.js").Coordinate} Coordinate.
	 */
	function lineStringsCoordinateAtM(
	  flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
	  if (interpolate) {
	    return lineStringCoordinateAtM(
	      flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
	  }
	  var coordinate;
	  if (m < flatCoordinates[stride - 1]) {
	    if (extrapolate) {
	      coordinate = flatCoordinates.slice(0, stride);
	      coordinate[stride - 1] = m;
	      return coordinate;
	    } else {
	      return null;
	    }
	  }
	  if (flatCoordinates[flatCoordinates.length - 1] < m) {
	    if (extrapolate) {
	      coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
	      coordinate[stride - 1] = m;
	      return coordinate;
	    } else {
	      return null;
	    }
	  }
	  for (var i = 0, ii = ends.length; i < ii; ++i) {
	    var end = ends[i];
	    if (offset == end) {
	      continue;
	    }
	    if (m < flatCoordinates[offset + stride - 1]) {
	      return null;
	    } else if (m <= flatCoordinates[end - 1]) {
	      return lineStringCoordinateAtM(
	        flatCoordinates, offset, end, stride, m, false);
	    }
	    offset = end;
	  }
	  return null;
	}
	
	/**
	 * @module ol/geom/flat/length
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @return {number} Length.
	 * @api
	 */
	function lineStringLength(flatCoordinates, offset, end, stride) {
	  var x1 = flatCoordinates[offset];
	  var y1 = flatCoordinates[offset + 1];
	  var length = 0;
	  for (var i = offset + stride; i < end; i += stride) {
	    var x2 = flatCoordinates[i];
	    var y2 = flatCoordinates[i + 1];
	    length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	    x1 = x2;
	    y1 = y2;
	  }
	  return length;
	}
	
	/**
	 * @module ol/geom/LineString
	 */
	
	/**
	 * @classdesc
	 * Linestring geometry.
	 *
	 * @api
	 */
	var LineString = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function LineString(coordinates, opt_layout) {
	
	    SimpleGeometry$$1.call(this);
	
	    /**
	     * @private
	     * @type {import("../coordinate.js").Coordinate}
	     */
	    this.flatMidpoint_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.flatMidpointRevision_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDelta_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDeltaRevision_ = -1;
	
	    if (opt_layout !== undefined && !Array.isArray(coordinates[0])) {
	      this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ (coordinates));
	    } else {
	      this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ (coordinates), opt_layout);
	    }
	
	  }
	
	  if ( SimpleGeometry$$1 ) { LineString.__proto__ = SimpleGeometry$$1; }
	  LineString.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  LineString.prototype.constructor = LineString;
	
	  /**
	   * Append the passed coordinate to the coordinates of the linestring.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @api
	   */
	  LineString.prototype.appendCoordinate = function appendCoordinate (coordinate) {
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = coordinate.slice();
	    } else {
	      extend(this.flatCoordinates, coordinate);
	    }
	    this.changed();
	  };
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!LineString} Clone.
	   * @override
	   * @api
	   */
	  LineString.prototype.clone = function clone$$1 () {
	    return new LineString(this.flatCoordinates.slice(), this.layout);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LineString.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    if (this.maxDeltaRevision_ != this.getRevision()) {
	      this.maxDelta_ = Math.sqrt(maxSquaredDelta(
	        this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
	      this.maxDeltaRevision_ = this.getRevision();
	    }
	    return assignClosestPoint(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride,
	      this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
	  };
	
	  /**
	   * Iterate over each segment, calling the provided callback.
	   * If the callback returns a truthy value the function returns that
	   * value immediately. Otherwise the function returns `false`.
	   *
	   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
	   *     called for each segment.
	   * @return {T|boolean} Value.
	   * @template T,S
	   * @api
	   */
	  LineString.prototype.forEachSegment = function forEachSegment$1 (callback) {
	    return forEach(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
	  };
	
	  /**
	   * Returns the coordinate at `m` using linear interpolation, or `null` if no
	   * such coordinate exists.
	   *
	   * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
	   * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
	   * M will return the first coordinate and Ms greater than the last M will
	   * return the last coordinate.
	   *
	   * @param {number} m M.
	   * @param {boolean=} opt_extrapolate Extrapolate. Default is `false`.
	   * @return {import("../coordinate.js").Coordinate} Coordinate.
	   * @api
	   */
	  LineString.prototype.getCoordinateAtM = function getCoordinateAtM (m, opt_extrapolate) {
	    if (this.layout != GeometryLayout.XYM &&
	        this.layout != GeometryLayout.XYZM) {
	      return null;
	    }
	    var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
	    return lineStringCoordinateAtM(this.flatCoordinates, 0,
	      this.flatCoordinates.length, this.stride, m, extrapolate);
	  };
	
	  /**
	   * Return the coordinates of the linestring.
	   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
	   * @override
	   * @api
	   */
	  LineString.prototype.getCoordinates = function getCoordinates () {
	    return inflateCoordinates(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
	  };
	
	  /**
	   * Return the coordinate at the provided fraction along the linestring.
	   * The `fraction` is a number between 0 and 1, where 0 is the start of the
	   * linestring and 1 is the end.
	   * @param {number} fraction Fraction.
	   * @param {import("../coordinate.js").Coordinate=} opt_dest Optional coordinate whose values will
	   *     be modified. If not provided, a new coordinate will be returned.
	   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
	   * @api
	   */
	  LineString.prototype.getCoordinateAt = function getCoordinateAt (fraction, opt_dest) {
	    return interpolatePoint(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride,
	      fraction, opt_dest);
	  };
	
	  /**
	   * Return the length of the linestring on projected plane.
	   * @return {number} Length (on projected plane).
	   * @api
	   */
	  LineString.prototype.getLength = function getLength () {
	    return lineStringLength(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
	  };
	
	  /**
	   * @return {Array<number>} Flat midpoint.
	   */
	  LineString.prototype.getFlatMidpoint = function getFlatMidpoint () {
	    if (this.flatMidpointRevision_ != this.getRevision()) {
	      this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_);
	      this.flatMidpointRevision_ = this.getRevision();
	    }
	    return this.flatMidpoint_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LineString.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal (squaredTolerance) {
	    var simplifiedFlatCoordinates = [];
	    simplifiedFlatCoordinates.length = douglasPeucker(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride,
	      squaredTolerance, simplifiedFlatCoordinates, 0);
	    return new LineString(simplifiedFlatCoordinates, GeometryLayout.XY);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  LineString.prototype.getType = function getType () {
	    return GeometryType.LINE_STRING;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  LineString.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return intersectsLineString(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride,
	      extent);
	  };
	
	  /**
	   * Set the coordinates of the linestring.
	   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
	   * @param {GeometryLayout=} opt_layout Layout.
	   * @override
	   * @api
	   */
	  LineString.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 1);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    this.flatCoordinates.length = deflateCoordinates(
	      this.flatCoordinates, 0, coordinates, this.stride);
	    this.changed();
	  };
	
	  return LineString;
	}(SimpleGeometry));
	
	/**
	 * @module ol/geom/flat/geodesic
	 */
	
	
	/**
	 * @param {function(number): import("../../coordinate.js").Coordinate} interpolate Interpolate function.
	 * @param {import("../../proj.js").TransformFunction} transform Transform from longitude/latitude to
	 *     projected coordinates.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @return {Array<number>} Flat coordinates.
	 */
	function line(interpolate, transform$$1, squaredTolerance) {
	  // FIXME reduce garbage generation
	  // FIXME optimize stack operations
	
	  /** @type {Array<number>} */
	  var flatCoordinates = [];
	
	  var geoA = interpolate(0);
	  var geoB = interpolate(1);
	
	  var a = transform$$1(geoA);
	  var b = transform$$1(geoB);
	
	  /** @type {Array<import("../../coordinate.js").Coordinate>} */
	  var geoStack = [geoB, geoA];
	  /** @type {Array<import("../../coordinate.js").Coordinate>} */
	  var stack = [b, a];
	  /** @type {Array<number>} */
	  var fractionStack = [1, 0];
	
	  /** @type {!Object<string, boolean>} */
	  var fractions = {};
	
	  var maxIterations = 1e5;
	  var geoM, m, fracA, fracB, fracM, key;
	
	  while (--maxIterations > 0 && fractionStack.length > 0) {
	    // Pop the a coordinate off the stack
	    fracA = fractionStack.pop();
	    geoA = geoStack.pop();
	    a = stack.pop();
	    // Add the a coordinate if it has not been added yet
	    key = fracA.toString();
	    if (!(key in fractions)) {
	      flatCoordinates.push(a[0], a[1]);
	      fractions[key] = true;
	    }
	    // Pop the b coordinate off the stack
	    fracB = fractionStack.pop();
	    geoB = geoStack.pop();
	    b = stack.pop();
	    // Find the m point between the a and b coordinates
	    fracM = (fracA + fracB) / 2;
	    geoM = interpolate(fracM);
	    m = transform$$1(geoM);
	    if (squaredSegmentDistance(m[0], m[1], a[0], a[1],
	      b[0], b[1]) < squaredTolerance) {
	      // If the m point is sufficiently close to the straight line, then we
	      // discard it.  Just use the b coordinate and move on to the next line
	      // segment.
	      flatCoordinates.push(b[0], b[1]);
	      key = fracB.toString();
	      fractions[key] = true;
	    } else {
	      // Otherwise, we need to subdivide the current line segment.  Split it
	      // into two and push the two line segments onto the stack.
	      fractionStack.push(fracB, fracM, fracM, fracA);
	      stack.push(b, m, m, a);
	      geoStack.push(geoB, geoM, geoM, geoA);
	    }
	  }
	
	  return flatCoordinates;
	}
	
	
	/**
	 * Generate a meridian (line at constant longitude).
	 * @param {number} lon Longitude.
	 * @param {number} lat1 Latitude 1.
	 * @param {number} lat2 Latitude 2.
	 * @param {import("../../proj/Projection.js").default} projection Projection.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @return {Array<number>} Flat coordinates.
	 */
	function meridian(lon, lat1, lat2, projection, squaredTolerance) {
	  var epsg4326Projection = get$2('EPSG:4326');
	  return line(
	    /**
	     * @param {number} frac Fraction.
	     * @return {import("../../coordinate.js").Coordinate} Coordinate.
	     */
	    function(frac) {
	      return [lon, lat1 + ((lat2 - lat1) * frac)];
	    },
	    getTransform(epsg4326Projection, projection), squaredTolerance);
	}
	
	
	/**
	 * Generate a parallel (line at constant latitude).
	 * @param {number} lat Latitude.
	 * @param {number} lon1 Longitude 1.
	 * @param {number} lon2 Longitude 2.
	 * @param {import("../../proj/Projection.js").default} projection Projection.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @return {Array<number>} Flat coordinates.
	 */
	function parallel(lat, lon1, lon2, projection, squaredTolerance) {
	  var epsg4326Projection = get$2('EPSG:4326');
	  return line(
	    /**
	     * @param {number} frac Fraction.
	     * @return {import("../../coordinate.js").Coordinate} Coordinate.
	     */
	    function(frac) {
	      return [lon1 + ((lon2 - lon1) * frac), lat];
	    },
	    getTransform(epsg4326Projection, projection), squaredTolerance);
	}
	
	/**
	 * @module ol/render/EventType
	 */
	
	/**
	 * @enum {string}
	 */
	var RenderEventType = {
	  /**
	   * @event module:ol/render/Event~RenderEvent#postcompose
	   * @api
	   */
	  POSTCOMPOSE: 'postcompose',
	  /**
	   * @event module:ol/render/Event~RenderEvent#precompose
	   * @api
	   */
	  PRECOMPOSE: 'precompose',
	  /**
	   * @event module:ol/render/Event~RenderEvent#render
	   * @api
	   */
	  RENDER: 'render',
	  /**
	   * Triggered when rendering is complete, i.e. all sources and tiles have
	   * finished loading for the current viewport, and all tiles are faded in.
	   * @event module:ol/render/Event~RenderEvent#rendercomplete
	   * @api
	   */
	  RENDERCOMPLETE: 'rendercomplete'
	};
	
	/**
	 * @module ol/color
	 */
	
	
	/**
	 * A color represented as a short array [red, green, blue, alpha].
	 * red, green, and blue should be integers in the range 0..255 inclusive.
	 * alpha should be a float in the range 0..1 inclusive. If no alpha value is
	 * given then `1` will be used.
	 * @typedef {Array<number>} Color
	 * @api
	 */
	
	
	/**
	 * This RegExp matches # followed by 3, 4, 6, or 8 hex digits.
	 * @const
	 * @type {RegExp}
	 * @private
	 */
	var HEX_COLOR_RE_ = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i;
	
	
	/**
	 * Regular expression for matching potential named color style strings.
	 * @const
	 * @type {RegExp}
	 * @private
	 */
	var NAMED_COLOR_RE_ = /^([a-z]*)$/i;
	
	
	/**
	 * Return the color as an rgba string.
	 * @param {Color|string} color Color.
	 * @return {string} Rgba string.
	 * @api
	 */
	function asString(color) {
	  if (typeof color === 'string') {
	    return color;
	  } else {
	    return toString(color);
	  }
	}
	
	/**
	 * Return named color as an rgba string.
	 * @param {string} color Named color.
	 * @return {string} Rgb string.
	 */
	function fromNamed(color) {
	  var el = document.createElement('div');
	  el.style.color = color;
	  if (el.style.color !== '') {
	    document.body.appendChild(el);
	    var rgb = getComputedStyle(el).color;
	    document.body.removeChild(el);
	    return rgb;
	  } else {
	    return '';
	  }
	}
	
	
	/**
	 * @param {string} s String.
	 * @return {Color} Color.
	 */
	var fromString = (
	  function() {
	
	    // We maintain a small cache of parsed strings.  To provide cheap LRU-like
	    // semantics, whenever the cache grows too large we simply delete an
	    // arbitrary 25% of the entries.
	
	    /**
	     * @const
	     * @type {number}
	     */
	    var MAX_CACHE_SIZE = 1024;
	
	    /**
	     * @type {Object<string, Color>}
	     */
	    var cache = {};
	
	    /**
	     * @type {number}
	     */
	    var cacheSize = 0;
	
	    return (
	      /**
	       * @param {string} s String.
	       * @return {Color} Color.
	       */
	      function(s) {
	        var color;
	        if (cache.hasOwnProperty(s)) {
	          color = cache[s];
	        } else {
	          if (cacheSize >= MAX_CACHE_SIZE) {
	            var i = 0;
	            for (var key in cache) {
	              if ((i++ & 3) === 0) {
	                delete cache[key];
	                --cacheSize;
	              }
	            }
	          }
	          color = fromStringInternal_(s);
	          cache[s] = color;
	          ++cacheSize;
	        }
	        return color;
	      }
	    );
	
	  })();
	
	/**
	 * Return the color as an array. This function maintains a cache of calculated
	 * arrays which means the result should not be modified.
	 * @param {Color|string} color Color.
	 * @return {Color} Color.
	 * @api
	 */
	function asArray(color) {
	  if (Array.isArray(color)) {
	    return color;
	  } else {
	    return fromString(color);
	  }
	}
	
	/**
	 * @param {string} s String.
	 * @private
	 * @return {Color} Color.
	 */
	function fromStringInternal_(s) {
	  var r, g, b, a, color;
	
	  if (NAMED_COLOR_RE_.exec(s)) {
	    s = fromNamed(s);
	  }
	
	  if (HEX_COLOR_RE_.exec(s)) { // hex
	    var n = s.length - 1; // number of hex digits
	    var d; // number of digits per channel
	    if (n <= 4) {
	      d = 1;
	    } else {
	      d = 2;
	    }
	    var hasAlpha = n === 4 || n === 8;
	    r = parseInt(s.substr(1 + 0 * d, d), 16);
	    g = parseInt(s.substr(1 + 1 * d, d), 16);
	    b = parseInt(s.substr(1 + 2 * d, d), 16);
	    if (hasAlpha) {
	      a = parseInt(s.substr(1 + 3 * d, d), 16);
	    } else {
	      a = 255;
	    }
	    if (d == 1) {
	      r = (r << 4) + r;
	      g = (g << 4) + g;
	      b = (b << 4) + b;
	      if (hasAlpha) {
	        a = (a << 4) + a;
	      }
	    }
	    color = [r, g, b, a / 255];
	  } else if (s.indexOf('rgba(') == 0) { // rgba()
	    color = s.slice(5, -1).split(',').map(Number);
	    normalize(color);
	  } else if (s.indexOf('rgb(') == 0) { // rgb()
	    color = s.slice(4, -1).split(',').map(Number);
	    color.push(1);
	    normalize(color);
	  } else {
	    assert(false, 14); // Invalid color
	  }
	  return color;
	}
	
	
	/**
	 * TODO this function is only used in the test, we probably shouldn't export it
	 * @param {Color} color Color.
	 * @return {Color} Clamped color.
	 */
	function normalize(color) {
	  color[0] = clamp((color[0] + 0.5) | 0, 0, 255);
	  color[1] = clamp((color[1] + 0.5) | 0, 0, 255);
	  color[2] = clamp((color[2] + 0.5) | 0, 0, 255);
	  color[3] = clamp(color[3], 0, 1);
	  return color;
	}
	
	
	/**
	 * @param {Color} color Color.
	 * @return {string} String.
	 */
	function toString(color) {
	  var r = color[0];
	  if (r != (r | 0)) {
	    r = (r + 0.5) | 0;
	  }
	  var g = color[1];
	  if (g != (g | 0)) {
	    g = (g + 0.5) | 0;
	  }
	  var b = color[2];
	  if (b != (b | 0)) {
	    b = (b + 0.5) | 0;
	  }
	  var a = color[3] === undefined ? 1 : color[3];
	  return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
	}
	
	/**
	 * @module ol/style/Fill
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
	 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
	 * Default null; if null, the Canvas/renderer default black will be used.
	 */
	
	
	/**
	 * @classdesc
	 * Set fill style for vector features.
	 * @api
	 */
	var Fill = function Fill(opt_options) {
	
	  var options = opt_options || {};
	
	  /**
	   * @private
	   * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
	   */
	  this.color_ = options.color !== undefined ? options.color : null;
	
	  /**
	   * @private
	   * @type {string|undefined}
	   */
	  this.checksum_ = undefined;
	};
	
	/**
	 * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
	 * @return {Fill} The cloned style.
	 * @api
	 */
	Fill.prototype.clone = function clone () {
	  var color = this.getColor();
	  return new Fill({
	    color: Array.isArray(color) ? color.slice() : color || undefined
	  });
	};
	
	/**
	 * Get the fill color.
	 * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
	 * @api
	 */
	Fill.prototype.getColor = function getColor () {
	  return this.color_;
	};
	
	/**
	 * Set the color.
	 *
	 * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
	 * @api
	 */
	Fill.prototype.setColor = function setColor (color) {
	  this.color_ = color;
	  this.checksum_ = undefined;
	};
	
	/**
	 * @return {string} The checksum.
	 */
	Fill.prototype.getChecksum = function getChecksum () {
	  if (this.checksum_ === undefined) {
	    var color = this.color_;
	    if (color) {
	      if (Array.isArray(color) || typeof color == 'string') {
	        this.checksum_ = 'f' + asString(/** @type {import("../color.js").Color|string} */ (color));
	      } else {
	        this.checksum_ = getUid(this.color_);
	      }
	    } else {
	      this.checksum_ = 'f-';
	    }
	  }
	
	  return this.checksum_;
	};
	
	/**
	 * @module ol/style/Stroke
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
	 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
	 * Default null; if null, the Canvas/renderer default black will be used.
	 * @property {string} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
	 * @property {string} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
	 * @property {Array<number>} [lineDash] Line dash pattern. Default is `undefined` (no dash).
	 * Please note that Internet Explorer 10 and lower do not support the `setLineDash` method on
	 * the `CanvasRenderingContext2D` and therefore this option will have no visual effect in these browsers.
	 * @property {number} [lineDashOffset=0] Line dash offset.
	 * @property {number} [miterLimit=10] Miter limit.
	 * @property {number} [width] Width.
	 */
	
	
	/**
	 * @classdesc
	 * Set stroke style for vector features.
	 * Note that the defaults given are the Canvas defaults, which will be used if
	 * option is not defined. The `get` functions return whatever was entered in
	 * the options; they will not return the default.
	 * @api
	 */
	var Stroke = function Stroke(opt_options) {
	
	  var options = opt_options || {};
	
	  /**
	   * @private
	   * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
	   */
	  this.color_ = options.color !== undefined ? options.color : null;
	
	  /**
	   * @private
	   * @type {string|undefined}
	   */
	  this.lineCap_ = options.lineCap;
	
	  /**
	   * @private
	   * @type {Array<number>}
	   */
	  this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
	
	  /**
	   * @private
	   * @type {number|undefined}
	   */
	  this.lineDashOffset_ = options.lineDashOffset;
	
	  /**
	   * @private
	   * @type {string|undefined}
	   */
	  this.lineJoin_ = options.lineJoin;
	
	  /**
	   * @private
	   * @type {number|undefined}
	   */
	  this.miterLimit_ = options.miterLimit;
	
	  /**
	   * @private
	   * @type {number|undefined}
	   */
	  this.width_ = options.width;
	
	  /**
	   * @private
	   * @type {string|undefined}
	   */
	  this.checksum_ = undefined;
	};
	
	/**
	 * Clones the style.
	 * @return {Stroke} The cloned style.
	 * @api
	 */
	Stroke.prototype.clone = function clone () {
	  var color = this.getColor();
	  return new Stroke({
	    color: Array.isArray(color) ? color.slice() : color || undefined,
	    lineCap: this.getLineCap(),
	    lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
	    lineDashOffset: this.getLineDashOffset(),
	    lineJoin: this.getLineJoin(),
	    miterLimit: this.getMiterLimit(),
	    width: this.getWidth()
	  });
	};
	
	/**
	 * Get the stroke color.
	 * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
	 * @api
	 */
	Stroke.prototype.getColor = function getColor () {
	  return this.color_;
	};
	
	/**
	 * Get the line cap type for the stroke.
	 * @return {string|undefined} Line cap.
	 * @api
	 */
	Stroke.prototype.getLineCap = function getLineCap () {
	  return this.lineCap_;
	};
	
	/**
	 * Get the line dash style for the stroke.
	 * @return {Array<number>} Line dash.
	 * @api
	 */
	Stroke.prototype.getLineDash = function getLineDash () {
	  return this.lineDash_;
	};
	
	/**
	 * Get the line dash offset for the stroke.
	 * @return {number|undefined} Line dash offset.
	 * @api
	 */
	Stroke.prototype.getLineDashOffset = function getLineDashOffset () {
	  return this.lineDashOffset_;
	};
	
	/**
	 * Get the line join type for the stroke.
	 * @return {string|undefined} Line join.
	 * @api
	 */
	Stroke.prototype.getLineJoin = function getLineJoin () {
	  return this.lineJoin_;
	};
	
	/**
	 * Get the miter limit for the stroke.
	 * @return {number|undefined} Miter limit.
	 * @api
	 */
	Stroke.prototype.getMiterLimit = function getMiterLimit () {
	  return this.miterLimit_;
	};
	
	/**
	 * Get the stroke width.
	 * @return {number|undefined} Width.
	 * @api
	 */
	Stroke.prototype.getWidth = function getWidth () {
	  return this.width_;
	};
	
	/**
	 * Set the color.
	 *
	 * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
	 * @api
	 */
	Stroke.prototype.setColor = function setColor (color) {
	  this.color_ = color;
	  this.checksum_ = undefined;
	};
	
	/**
	 * Set the line cap.
	 *
	 * @param {string|undefined} lineCap Line cap.
	 * @api
	 */
	Stroke.prototype.setLineCap = function setLineCap (lineCap) {
	  this.lineCap_ = lineCap;
	  this.checksum_ = undefined;
	};
	
	/**
	 * Set the line dash.
	 *
	 * Please note that Internet Explorer 10 and lower [do not support][mdn] the
	 * `setLineDash` method on the `CanvasRenderingContext2D` and therefore this
	 * property will have no visual effect in these browsers.
	 *
	 * [mdn]: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility
	 *
	 * @param {Array<number>} lineDash Line dash.
	 * @api
	 */
	Stroke.prototype.setLineDash = function setLineDash (lineDash) {
	  this.lineDash_ = lineDash;
	  this.checksum_ = undefined;
	};
	
	/**
	 * Set the line dash offset.
	 *
	 * @param {number|undefined} lineDashOffset Line dash offset.
	 * @api
	 */
	Stroke.prototype.setLineDashOffset = function setLineDashOffset (lineDashOffset) {
	  this.lineDashOffset_ = lineDashOffset;
	  this.checksum_ = undefined;
	};
	
	/**
	 * Set the line join.
	 *
	 * @param {string|undefined} lineJoin Line join.
	 * @api
	 */
	Stroke.prototype.setLineJoin = function setLineJoin (lineJoin) {
	  this.lineJoin_ = lineJoin;
	  this.checksum_ = undefined;
	};
	
	/**
	 * Set the miter limit.
	 *
	 * @param {number|undefined} miterLimit Miter limit.
	 * @api
	 */
	Stroke.prototype.setMiterLimit = function setMiterLimit (miterLimit) {
	  this.miterLimit_ = miterLimit;
	  this.checksum_ = undefined;
	};
	
	/**
	 * Set the width.
	 *
	 * @param {number|undefined} width Width.
	 * @api
	 */
	Stroke.prototype.setWidth = function setWidth (width) {
	  this.width_ = width;
	  this.checksum_ = undefined;
	};
	
	/**
	 * @return {string} The checksum.
	 */
	Stroke.prototype.getChecksum = function getChecksum () {
	  if (this.checksum_ === undefined) {
	    this.checksum_ = 's';
	    if (this.color_) {
	      if (typeof this.color_ === 'string') {
	        this.checksum_ += this.color_;
	      } else {
	        this.checksum_ += getUid(this.color_);
	      }
	    } else {
	      this.checksum_ += '-';
	    }
	    this.checksum_ += ',' +
	        (this.lineCap_ !== undefined ?
	          this.lineCap_.toString() : '-') + ',' +
	        (this.lineDash_ ?
	          this.lineDash_.toString() : '-') + ',' +
	        (this.lineDashOffset_ !== undefined ?
	          this.lineDashOffset_ : '-') + ',' +
	        (this.lineJoin_ !== undefined ?
	          this.lineJoin_ : '-') + ',' +
	        (this.miterLimit_ !== undefined ?
	          this.miterLimit_.toString() : '-') + ',' +
	        (this.width_ !== undefined ?
	          this.width_.toString() : '-');
	  }
	
	  return this.checksum_;
	};
	
	/**
	 * @module ol/style/TextPlacement
	 */
	
	/**
	 * Text placement. One of `'point'`, `'line'`. Default is `'point'`. Note that
	 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
	 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
	 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
	 * @enum {string}
	 */
	var TextPlacement = {
	  POINT: 'point',
	  LINE: 'line'
	};
	
	/**
	 * @module ol/style/Text
	 */
	
	
	/**
	 * The default fill color to use if no fill was set at construction time; a
	 * blackish `#333`.
	 *
	 * @const {string}
	 * @api
	 */
	var DEFAULT_FILL_COLOR = '#333';
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [font] Font style as CSS 'font' value, see:
	 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is '10px sans-serif'
	 * @property {number} [maxAngle] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
	 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
	 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
	 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
	 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
	 * the width of the polygon at the label position or the length of the path that it follows.
	 * @property {import("./TextPlacement.js").default|string} [placement] Text placement.
	 * @property {number} [scale] Scale.
	 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
	 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
	 * @property {string} [text] Text content.
	 * @property {string} [textAlign] Text alignment. Possible values: 'left', 'right', 'center', 'end' or 'start'.
	 * Default is 'center' for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
	 * placement where `maxAngle` is not exceeded.
	 * @property {string} [textBaseline='middle'] Text base line. Possible values: 'bottom', 'top', 'middle', 'alphabetic',
	 * 'hanging', 'ideographic'.
	 * @property {import("./Fill.js").default} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333).
	 * @property {import("./Stroke.js").default} [stroke] Stroke style.
	 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
	 * `'point'`. Default is no fill.
	 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
	 * is `'point'`. Default is no stroke.
	 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
	 * values in the array is `[top, right, bottom, left]`.
	 */
	
	
	/**
	 * @classdesc
	 * Set text style for vector features.
	 * @api
	 */
	var Text = function Text(opt_options) {
	
	  var options = opt_options || {};
	
	  /**
	  * @private
	  * @type {string|undefined}
	  */
	  this.font_ = options.font;
	
	  /**
	  * @private
	  * @type {number|undefined}
	  */
	  this.rotation_ = options.rotation;
	
	  /**
	  * @private
	  * @type {boolean|undefined}
	  */
	  this.rotateWithView_ = options.rotateWithView;
	
	  /**
	  * @private
	  * @type {number|undefined}
	  */
	  this.scale_ = options.scale;
	
	  /**
	  * @private
	  * @type {string|undefined}
	  */
	  this.text_ = options.text;
	
	  /**
	  * @private
	  * @type {string|undefined}
	  */
	  this.textAlign_ = options.textAlign;
	
	  /**
	  * @private
	  * @type {string|undefined}
	  */
	  this.textBaseline_ = options.textBaseline;
	
	  /**
	  * @private
	  * @type {import("./Fill.js").default}
	  */
	  this.fill_ = options.fill !== undefined ? options.fill :
	    new Fill({color: DEFAULT_FILL_COLOR});
	
	  /**
	  * @private
	  * @type {number}
	  */
	  this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
	
	  /**
	  * @private
	  * @type {import("./TextPlacement.js").default|string}
	  */
	  this.placement_ = options.placement !== undefined ? options.placement : TextPlacement.POINT;
	
	  /**
	  * @private
	  * @type {boolean}
	  */
	  this.overflow_ = !!options.overflow;
	
	  /**
	  * @private
	  * @type {import("./Stroke.js").default}
	  */
	  this.stroke_ = options.stroke !== undefined ? options.stroke : null;
	
	  /**
	  * @private
	  * @type {number}
	  */
	  this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
	
	  /**
	  * @private
	  * @type {number}
	  */
	  this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
	
	  /**
	  * @private
	  * @type {import("./Fill.js").default}
	  */
	  this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
	
	  /**
	  * @private
	  * @type {import("./Stroke.js").default}
	  */
	  this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
	
	  /**
	  * @private
	  * @type {Array<number>}
	  */
	  this.padding_ = options.padding === undefined ? null : options.padding;
	};
	
	/**
	* Clones the style.
	* @return {Text} The cloned style.
	* @api
	*/
	Text.prototype.clone = function clone () {
	  return new Text({
	    font: this.getFont(),
	    placement: this.getPlacement(),
	    maxAngle: this.getMaxAngle(),
	    overflow: this.getOverflow(),
	    rotation: this.getRotation(),
	    rotateWithView: this.getRotateWithView(),
	    scale: this.getScale(),
	    text: this.getText(),
	    textAlign: this.getTextAlign(),
	    textBaseline: this.getTextBaseline(),
	    fill: this.getFill() ? this.getFill().clone() : undefined,
	    stroke: this.getStroke() ? this.getStroke().clone() : undefined,
	    offsetX: this.getOffsetX(),
	    offsetY: this.getOffsetY(),
	    backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
	    backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined
	  });
	};
	
	/**
	* Get the `overflow` configuration.
	* @return {boolean} Let text overflow the length of the path they follow.
	* @api
	*/
	Text.prototype.getOverflow = function getOverflow () {
	  return this.overflow_;
	};
	
	/**
	* Get the font name.
	* @return {string|undefined} Font.
	* @api
	*/
	Text.prototype.getFont = function getFont () {
	  return this.font_;
	};
	
	/**
	* Get the maximum angle between adjacent characters.
	* @return {number} Angle in radians.
	* @api
	*/
	Text.prototype.getMaxAngle = function getMaxAngle () {
	  return this.maxAngle_;
	};
	
	/**
	* Get the label placement.
	* @return {import("./TextPlacement.js").default|string} Text placement.
	* @api
	*/
	Text.prototype.getPlacement = function getPlacement () {
	  return this.placement_;
	};
	
	/**
	* Get the x-offset for the text.
	* @return {number} Horizontal text offset.
	* @api
	*/
	Text.prototype.getOffsetX = function getOffsetX () {
	  return this.offsetX_;
	};
	
	/**
	* Get the y-offset for the text.
	* @return {number} Vertical text offset.
	* @api
	*/
	Text.prototype.getOffsetY = function getOffsetY () {
	  return this.offsetY_;
	};
	
	/**
	* Get the fill style for the text.
	* @return {import("./Fill.js").default} Fill style.
	* @api
	*/
	Text.prototype.getFill = function getFill () {
	  return this.fill_;
	};
	
	/**
	* Determine whether the text rotates with the map.
	* @return {boolean|undefined} Rotate with map.
	* @api
	*/
	Text.prototype.getRotateWithView = function getRotateWithView () {
	  return this.rotateWithView_;
	};
	
	/**
	* Get the text rotation.
	* @return {number|undefined} Rotation.
	* @api
	*/
	Text.prototype.getRotation = function getRotation () {
	  return this.rotation_;
	};
	
	/**
	* Get the text scale.
	* @return {number|undefined} Scale.
	* @api
	*/
	Text.prototype.getScale = function getScale () {
	  return this.scale_;
	};
	
	/**
	* Get the stroke style for the text.
	* @return {import("./Stroke.js").default} Stroke style.
	* @api
	*/
	Text.prototype.getStroke = function getStroke () {
	  return this.stroke_;
	};
	
	/**
	* Get the text to be rendered.
	* @return {string|undefined} Text.
	* @api
	*/
	Text.prototype.getText = function getText () {
	  return this.text_;
	};
	
	/**
	* Get the text alignment.
	* @return {string|undefined} Text align.
	* @api
	*/
	Text.prototype.getTextAlign = function getTextAlign () {
	  return this.textAlign_;
	};
	
	/**
	* Get the text baseline.
	* @return {string|undefined} Text baseline.
	* @api
	*/
	Text.prototype.getTextBaseline = function getTextBaseline () {
	  return this.textBaseline_;
	};
	
	/**
	* Get the background fill style for the text.
	* @return {import("./Fill.js").default} Fill style.
	* @api
	*/
	Text.prototype.getBackgroundFill = function getBackgroundFill () {
	  return this.backgroundFill_;
	};
	
	/**
	* Get the background stroke style for the text.
	* @return {import("./Stroke.js").default} Stroke style.
	* @api
	*/
	Text.prototype.getBackgroundStroke = function getBackgroundStroke () {
	  return this.backgroundStroke_;
	};
	
	/**
	* Get the padding for the text.
	* @return {Array<number>} Padding.
	* @api
	*/
	Text.prototype.getPadding = function getPadding () {
	  return this.padding_;
	};
	
	/**
	* Set the `overflow` property.
	*
	* @param {boolean} overflow Let text overflow the path that it follows.
	* @api
	*/
	Text.prototype.setOverflow = function setOverflow (overflow) {
	  this.overflow_ = overflow;
	};
	
	/**
	* Set the font.
	*
	* @param {string|undefined} font Font.
	* @api
	*/
	Text.prototype.setFont = function setFont (font) {
	  this.font_ = font;
	};
	
	/**
	* Set the maximum angle between adjacent characters.
	*
	* @param {number} maxAngle Angle in radians.
	* @api
	*/
	Text.prototype.setMaxAngle = function setMaxAngle (maxAngle) {
	  this.maxAngle_ = maxAngle;
	};
	
	/**
	* Set the x offset.
	*
	* @param {number} offsetX Horizontal text offset.
	* @api
	*/
	Text.prototype.setOffsetX = function setOffsetX (offsetX) {
	  this.offsetX_ = offsetX;
	};
	
	/**
	* Set the y offset.
	*
	* @param {number} offsetY Vertical text offset.
	* @api
	*/
	Text.prototype.setOffsetY = function setOffsetY (offsetY) {
	  this.offsetY_ = offsetY;
	};
	
	/**
	* Set the text placement.
	*
	* @param {import("./TextPlacement.js").default|string} placement Placement.
	* @api
	*/
	Text.prototype.setPlacement = function setPlacement (placement) {
	  this.placement_ = placement;
	};
	
	/**
	* Set the fill.
	*
	* @param {import("./Fill.js").default} fill Fill style.
	* @api
	*/
	Text.prototype.setFill = function setFill (fill) {
	  this.fill_ = fill;
	};
	
	/**
	* Set the rotation.
	*
	* @param {number|undefined} rotation Rotation.
	* @api
	*/
	Text.prototype.setRotation = function setRotation (rotation) {
	  this.rotation_ = rotation;
	};
	
	/**
	* Set the scale.
	*
	* @param {number|undefined} scale Scale.
	* @api
	*/
	Text.prototype.setScale = function setScale (scale) {
	  this.scale_ = scale;
	};
	
	/**
	* Set the stroke.
	*
	* @param {import("./Stroke.js").default} stroke Stroke style.
	* @api
	*/
	Text.prototype.setStroke = function setStroke (stroke) {
	  this.stroke_ = stroke;
	};
	
	/**
	* Set the text.
	*
	* @param {string|undefined} text Text.
	* @api
	*/
	Text.prototype.setText = function setText (text) {
	  this.text_ = text;
	};
	
	/**
	* Set the text alignment.
	*
	* @param {string|undefined} textAlign Text align.
	* @api
	*/
	Text.prototype.setTextAlign = function setTextAlign (textAlign) {
	  this.textAlign_ = textAlign;
	};
	
	/**
	* Set the text baseline.
	*
	* @param {string|undefined} textBaseline Text baseline.
	* @api
	*/
	Text.prototype.setTextBaseline = function setTextBaseline (textBaseline) {
	  this.textBaseline_ = textBaseline;
	};
	
	/**
	* Set the background fill.
	*
	* @param {import("./Fill.js").default} fill Fill style.
	* @api
	*/
	Text.prototype.setBackgroundFill = function setBackgroundFill (fill) {
	  this.backgroundFill_ = fill;
	};
	
	/**
	* Set the background stroke.
	*
	* @param {import("./Stroke.js").default} stroke Stroke style.
	* @api
	*/
	Text.prototype.setBackgroundStroke = function setBackgroundStroke (stroke) {
	  this.backgroundStroke_ = stroke;
	};
	
	/**
	* Set the padding (`[top, right, bottom, left]`).
	*
	* @param {!Array<number>} padding Padding.
	* @api
	*/
	Text.prototype.setPadding = function setPadding (padding) {
	  this.padding_ = padding;
	};
	
	/**
	 * @module ol/Graticule
	 */
	
	
	/**
	 * @type {Stroke}
	 * @private
	 * @const
	 */
	var DEFAULT_STROKE_STYLE = new Stroke({
	  color: 'rgba(0,0,0,0.2)'
	});
	
	/**
	 * @type {Array<number>}
	 * @private
	 */
	var INTERVALS = [
	  90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001
	];
	
	/**
	 * @typedef {Object} GraticuleLabelDataType
	 * @property {Point} geom
	 * @property {string} text
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./PluggableMap.js").default} [map] Reference to an
	 * {@link module:ol/Map~Map} object.
	 * @property {number} [maxLines=100] The maximum number of meridians and
	 * parallels from the center of the map. The default value of 100 means that at
	 * most 200 meridians and 200 parallels will be displayed. The default value is
	 * appropriate for conformal projections like Spherical Mercator. If you
	 * increase the value, more lines will be drawn and the drawing performance will
	 * decrease.
	 * @property {Stroke} [strokeStyle='rgba(0,0,0,0.2)'] The
	 * stroke style to use for drawing the graticule. If not provided, a not fully
	 * opaque black will be used.
	 * @property {number} [targetSize=100] The target size of the graticule cells,
	 * in pixels.
	 * @property {boolean} [showLabels=false] Render a label with the respective
	 * latitude/longitude for each graticule line.
	 * @property {function(number):string} [lonLabelFormatter] Label formatter for
	 * longitudes. This function is called with the longitude as argument, and
	 * should return a formatted string representing the longitude. By default,
	 * labels are formatted as degrees, minutes, seconds and hemisphere.
	 * @property {function(number):string} [latLabelFormatter] Label formatter for
	 * latitudes. This function is called with the latitude as argument, and
	 * should return a formatted string representing the latitude. By default,
	 * labels are formatted as degrees, minutes, seconds and hemisphere.
	 * @property {number} [lonLabelPosition=0] Longitude label position in fractions
	 * (0..1) of view extent. 0 means at the bottom of the viewport, 1 means at the
	 * top.
	 * @property {number} [latLabelPosition=1] Latitude label position in fractions
	 * (0..1) of view extent. 0 means at the left of the viewport, 1 means at the
	 * right.
	 * @property {Text} [lonLabelStyle] Longitude label text
	 * style. If not provided, the following style will be used:
	 * ```js
	 * new Text({
	 *   font: '12px Calibri,sans-serif',
	 *   textBaseline: 'bottom',
	 *   fill: new Fill({
	 *     color: 'rgba(0,0,0,1)'
	 *   }),
	 *   stroke: new Stroke({
	 *     color: 'rgba(255,255,255,1)',
	 *     width: 3
	 *   })
	 * });
	 * ```
	 * Note that the default's `textBaseline` configuration will not work well for
	 * `lonLabelPosition` configurations that position labels close to the top of
	 * the viewport.
	 * @property {Text} [latLabelStyle] Latitude label text style.
	 * If not provided, the following style will be used:
	 * ```js
	 * new Text({
	 *   font: '12px Calibri,sans-serif',
	 *   textAlign: 'end',
	 *   fill: new Fill({
	 *     color: 'rgba(0,0,0,1)'
	 *   }),
	 *   stroke: Stroke({
	 *     color: 'rgba(255,255,255,1)',
	 *     width: 3
	 *   })
	 * });
	 * ```
	 * Note that the default's `textAlign` configuration will not work well for
	 * `latLabelPosition` configurations that position labels close to the left of
	 * the viewport.
	 * @property {Array<number>} [intervals=[90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001]]
	 * Intervals (in degrees) for the graticule. Example to limit graticules to 30 and 10 degrees intervals:
	 * ```js
	 * [30, 10]
	 * ```
	 */
	
	
	/**
	 * Render a grid for a coordinate system on a map.
	 * @api
	 */
	var Graticule = function Graticule(opt_options) {
	  var options = opt_options || {};
	
	  /**
	   * @type {import("./PluggableMap.js").default}
	   * @private
	   */
	  this.map_ = null;
	
	  /**
	   * @type {?import("./events.js").EventsKey}
	   * @private
	   */
	  this.postcomposeListenerKey_ = null;
	
	  /**
	   * @type {import("./proj/Projection.js").default}
	   */
	  this.projection_ = null;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.maxLat_ = Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.maxLon_ = Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.minLat_ = -Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.minLon_ = -Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.maxLatP_ = Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.maxLonP_ = Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.minLatP_ = -Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.minLonP_ = -Infinity;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.targetSize_ = options.targetSize !== undefined ? options.targetSize : 100;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.maxLines_ = options.maxLines !== undefined ? options.maxLines : 100;
	
	  /**
	   * @type {Array<LineString>}
	   * @private
	   */
	  this.meridians_ = [];
	
	  /**
	   * @type {Array<LineString>}
	   * @private
	   */
	  this.parallels_ = [];
	
	  /**
	   * @type {Stroke}
	   * @private
	   */
	  this.strokeStyle_ = options.strokeStyle !== undefined ? options.strokeStyle : DEFAULT_STROKE_STYLE;
	
	  /**
	   * @type {import("./proj.js").TransformFunction|undefined}
	   * @private
	   */
	  this.fromLonLatTransform_ = undefined;
	
	  /**
	   * @type {import("./proj.js").TransformFunction|undefined}
	   * @private
	   */
	  this.toLonLatTransform_ = undefined;
	
	  /**
	   * @type {import("./coordinate.js").Coordinate}
	   * @private
	   */
	  this.projectionCenterLonLat_ = null;
	
	  /**
	   * @type {Array<GraticuleLabelDataType>}
	   * @private
	   */
	  this.meridiansLabels_ = null;
	
	  /**
	   * @type {Array<GraticuleLabelDataType>}
	   * @private
	   */
	  this.parallelsLabels_ = null;
	
	  if (options.showLabels == true) {
	
	    /**
	     * @type {null|function(number):string}
	     * @private
	     */
	    this.lonLabelFormatter_ = options.lonLabelFormatter == undefined ?
	      degreesToStringHDMS.bind(this, 'EW') : options.lonLabelFormatter;
	
	    /**
	     * @type {function(number):string}
	     * @private
	     */
	    this.latLabelFormatter_ = options.latLabelFormatter == undefined ?
	      degreesToStringHDMS.bind(this, 'NS') : options.latLabelFormatter;
	
	    /**
	     * Longitude label position in fractions (0..1) of view extent. 0 means
	     * bottom, 1 means top.
	     * @type {number}
	     * @private
	     */
	    this.lonLabelPosition_ = options.lonLabelPosition == undefined ? 0 :
	      options.lonLabelPosition;
	
	    /**
	     * Latitude Label position in fractions (0..1) of view extent. 0 means left, 1
	     * means right.
	     * @type {number}
	     * @private
	     */
	    this.latLabelPosition_ = options.latLabelPosition == undefined ? 1 :
	      options.latLabelPosition;
	
	    /**
	     * @type {Text}
	     * @private
	     */
	    this.lonLabelStyle_ = options.lonLabelStyle !== undefined ? options.lonLabelStyle :
	      new Text({
	        font: '12px Calibri,sans-serif',
	        textBaseline: 'bottom',
	        fill: new Fill({
	          color: 'rgba(0,0,0,1)'
	        }),
	        stroke: new Stroke({
	          color: 'rgba(255,255,255,1)',
	          width: 3
	        })
	      });
	
	    /**
	     * @type {Text}
	     * @private
	     */
	    this.latLabelStyle_ = options.latLabelStyle !== undefined ? options.latLabelStyle :
	      new Text({
	        font: '12px Calibri,sans-serif',
	        textAlign: 'end',
	        fill: new Fill({
	          color: 'rgba(0,0,0,1)'
	        }),
	        stroke: new Stroke({
	          color: 'rgba(255,255,255,1)',
	          width: 3
	        })
	      });
	
	    this.meridiansLabels_ = [];
	    this.parallelsLabels_ = [];
	  }
	
	  /**
	   * @type {Array<number>}
	   * @private
	   */
	  this.intervals_ = options.intervals !== undefined ? options.intervals : INTERVALS;
	
	  this.setMap(options.map !== undefined ? options.map : null);
	};
	
	/**
	 * @param {number} lon Longitude.
	 * @param {number} minLat Minimal latitude.
	 * @param {number} maxLat Maximal latitude.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number} index Index.
	 * @return {number} Index.
	 * @private
	 */
	Graticule.prototype.addMeridian_ = function addMeridian_ (lon, minLat, maxLat, squaredTolerance, extent, index) {
	  var lineString = this.getMeridian_(lon, minLat, maxLat, squaredTolerance, index);
	  if (intersects(lineString.getExtent(), extent)) {
	    if (this.meridiansLabels_) {
	      var textPoint = this.getMeridianPoint_(lineString, extent, index);
	      this.meridiansLabels_[index] = {
	        geom: textPoint,
	        text: this.lonLabelFormatter_(lon)
	      };
	    }
	    this.meridians_[index++] = lineString;
	  }
	  return index;
	};
	
	/**
	 * @param {LineString} lineString Meridian
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number} index Index.
	 * @return {Point} Meridian point.
	 * @private
	 */
	Graticule.prototype.getMeridianPoint_ = function getMeridianPoint_ (lineString, extent, index) {
	  var flatCoordinates = lineString.getFlatCoordinates();
	  var clampedBottom = Math.max(extent[1], flatCoordinates[1]);
	  var clampedTop = Math.min(extent[3], flatCoordinates[flatCoordinates.length - 1]);
	  var lat = clamp(
	    extent[1] + Math.abs(extent[1] - extent[3]) * this.lonLabelPosition_,
	    clampedBottom, clampedTop);
	  var coordinate = [flatCoordinates[0], lat];
	  var point;
	  if (index in this.meridiansLabels_) {
	    point = this.meridiansLabels_[index].geom;
	    point.setCoordinates(coordinate);
	  } else {
	    point = new Point(coordinate);
	  }
	  return point;
	};
	
	/**
	 * @param {number} lat Latitude.
	 * @param {number} minLon Minimal longitude.
	 * @param {number} maxLon Maximal longitude.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number} index Index.
	 * @return {number} Index.
	 * @private
	 */
	Graticule.prototype.addParallel_ = function addParallel_ (lat, minLon, maxLon, squaredTolerance, extent, index) {
	  var lineString = this.getParallel_(lat, minLon, maxLon, squaredTolerance, index);
	  if (intersects(lineString.getExtent(), extent)) {
	    if (this.parallelsLabels_) {
	      var textPoint = this.getParallelPoint_(lineString, extent, index);
	      this.parallelsLabels_[index] = {
	        geom: textPoint,
	        text: this.latLabelFormatter_(lat)
	      };
	    }
	    this.parallels_[index++] = lineString;
	  }
	  return index;
	};
	
	/**
	 * @param {LineString} lineString Parallels.
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number} index Index.
	 * @return {Point} Parallel point.
	 * @private
	 */
	Graticule.prototype.getParallelPoint_ = function getParallelPoint_ (lineString, extent, index) {
	  var flatCoordinates = lineString.getFlatCoordinates();
	  var clampedLeft = Math.max(extent[0], flatCoordinates[0]);
	  var clampedRight = Math.min(extent[2], flatCoordinates[flatCoordinates.length - 2]);
	  var lon = clamp(
	    extent[0] + Math.abs(extent[0] - extent[2]) * this.latLabelPosition_,
	    clampedLeft, clampedRight);
	  var coordinate = [lon, flatCoordinates[1]];
	  var point;
	  if (index in this.parallelsLabels_) {
	    point = this.parallelsLabels_[index].geom;
	    point.setCoordinates(coordinate);
	  } else {
	    point = new Point(coordinate);
	  }
	  return point;
	};
	
	/**
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {import("./coordinate.js").Coordinate} center Center.
	 * @param {number} resolution Resolution.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @private
	 */
	Graticule.prototype.createGraticule_ = function createGraticule_ (extent, center, resolution, squaredTolerance) {
	
	  var interval = this.getInterval_(resolution);
	  if (interval == -1) {
	    this.meridians_.length = this.parallels_.length = 0;
	    if (this.meridiansLabels_) {
	      this.meridiansLabels_.length = 0;
	    }
	    if (this.parallelsLabels_) {
	      this.parallelsLabels_.length = 0;
	    }
	    return;
	  }
	
	  var centerLonLat = this.toLonLatTransform_(center);
	  var centerLon = centerLonLat[0];
	  var centerLat = centerLonLat[1];
	  var maxLines = this.maxLines_;
	  var cnt, idx, lat, lon;
	
	  var validExtent = [
	    Math.max(extent[0], this.minLonP_),
	    Math.max(extent[1], this.minLatP_),
	    Math.min(extent[2], this.maxLonP_),
	    Math.min(extent[3], this.maxLatP_)
	  ];
	
	  validExtent = transformExtent(validExtent, this.projection_, 'EPSG:4326');
	  var maxLat = validExtent[3];
	  var maxLon = validExtent[2];
	  var minLat = validExtent[1];
	  var minLon = validExtent[0];
	
	  // Create meridians
	
	  centerLon = Math.floor(centerLon / interval) * interval;
	  lon = clamp(centerLon, this.minLon_, this.maxLon_);
	
	  idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, 0);
	
	  cnt = 0;
	  while (lon != this.minLon_ && cnt++ < maxLines) {
	    lon = Math.max(lon - interval, this.minLon_);
	    idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
	  }
	
	  lon = clamp(centerLon, this.minLon_, this.maxLon_);
	
	  cnt = 0;
	  while (lon != this.maxLon_ && cnt++ < maxLines) {
	    lon = Math.min(lon + interval, this.maxLon_);
	    idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
	  }
	
	  this.meridians_.length = idx;
	  if (this.meridiansLabels_) {
	    this.meridiansLabels_.length = idx;
	  }
	
	  // Create parallels
	
	  centerLat = Math.floor(centerLat / interval) * interval;
	  lat = clamp(centerLat, this.minLat_, this.maxLat_);
	
	  idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, 0);
	
	  cnt = 0;
	  while (lat != this.minLat_ && cnt++ < maxLines) {
	    lat = Math.max(lat - interval, this.minLat_);
	    idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
	  }
	
	  lat = clamp(centerLat, this.minLat_, this.maxLat_);
	
	  cnt = 0;
	  while (lat != this.maxLat_ && cnt++ < maxLines) {
	    lat = Math.min(lat + interval, this.maxLat_);
	    idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
	  }
	
	  this.parallels_.length = idx;
	  if (this.parallelsLabels_) {
	    this.parallelsLabels_.length = idx;
	  }
	
	};
	
	/**
	 * @param {number} resolution Resolution.
	 * @return {number} The interval in degrees.
	 * @private
	 */
	Graticule.prototype.getInterval_ = function getInterval_ (resolution) {
	  var centerLon = this.projectionCenterLonLat_[0];
	  var centerLat = this.projectionCenterLonLat_[1];
	  var interval = -1;
	  var target = Math.pow(this.targetSize_ * resolution, 2);
	  /** @type {Array<number>} **/
	  var p1 = [];
	  /** @type {Array<number>} **/
	  var p2 = [];
	  for (var i = 0, ii = this.intervals_.length; i < ii; ++i) {
	    var delta = this.intervals_[i] / 2;
	    p1[0] = centerLon - delta;
	    p1[1] = centerLat - delta;
	    p2[0] = centerLon + delta;
	    p2[1] = centerLat + delta;
	    this.fromLonLatTransform_(p1, p1);
	    this.fromLonLatTransform_(p2, p2);
	    var dist = Math.pow(p2[0] - p1[0], 2) + Math.pow(p2[1] - p1[1], 2);
	    if (dist <= target) {
	      break;
	    }
	    interval = this.intervals_[i];
	  }
	  return interval;
	};
	
	/**
	 * Get the map associated with this graticule.
	 * @return {import("./PluggableMap.js").default} The map.
	 * @api
	 */
	Graticule.prototype.getMap = function getMap () {
	  return this.map_;
	};
	
	/**
	 * @param {number} lon Longitude.
	 * @param {number} minLat Minimal latitude.
	 * @param {number} maxLat Maximal latitude.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @return {LineString} The meridian line string.
	 * @param {number} index Index.
	 * @private
	 */
	Graticule.prototype.getMeridian_ = function getMeridian_ (lon, minLat, maxLat, squaredTolerance, index) {
	  var flatCoordinates = meridian(lon, minLat, maxLat, this.projection_, squaredTolerance);
	  var lineString = this.meridians_[index];
	  if (!lineString) {
	    lineString = this.meridians_[index] = new LineString(flatCoordinates, GeometryLayout.XY);
	  } else {
	    lineString.setFlatCoordinates(GeometryLayout.XY, flatCoordinates);
	    lineString.changed();
	  }
	  return lineString;
	};
	
	/**
	 * Get the list of meridians.Meridians are lines of equal longitude.
	 * @return {Array<LineString>} The meridians.
	 * @api
	 */
	Graticule.prototype.getMeridians = function getMeridians () {
	  return this.meridians_;
	};
	
	/**
	 * @param {number} lat Latitude.
	 * @param {number} minLon Minimal longitude.
	 * @param {number} maxLon Maximal longitude.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @return {LineString} The parallel line string.
	 * @param {number} index Index.
	 * @private
	 */
	Graticule.prototype.getParallel_ = function getParallel_ (lat, minLon, maxLon, squaredTolerance, index) {
	  var flatCoordinates = parallel(lat, minLon, maxLon, this.projection_, squaredTolerance);
	  var lineString = this.parallels_[index];
	  if (!lineString) {
	    lineString = new LineString(flatCoordinates, GeometryLayout.XY);
	  } else {
	    lineString.setFlatCoordinates(GeometryLayout.XY, flatCoordinates);
	    lineString.changed();
	  }
	  return lineString;
	};
	
	/**
	 * Get the list of parallels.Parallels are lines of equal latitude.
	 * @return {Array<LineString>} The parallels.
	 * @api
	 */
	Graticule.prototype.getParallels = function getParallels () {
	  return this.parallels_;
	};
	
	/**
	 * @param {import("./render/Event.js").default} e Event.
	 * @private
	 */
	Graticule.prototype.handlePostCompose_ = function handlePostCompose_ (e) {
	  var vectorContext = e.vectorContext;
	  var frameState = e.frameState;
	  var extent = frameState.extent;
	  var viewState = frameState.viewState;
	  var center = viewState.center;
	  var projection = viewState.projection;
	  var resolution = viewState.resolution;
	  var pixelRatio = frameState.pixelRatio;
	  var squaredTolerance =
	      resolution * resolution / (4 * pixelRatio * pixelRatio);
	
	  var updateProjectionInfo = !this.projection_ ||
	      !equivalent(this.projection_, projection);
	
	  if (updateProjectionInfo) {
	    this.updateProjectionInfo_(projection);
	  }
	
	  this.createGraticule_(extent, center, resolution, squaredTolerance);
	
	  // Draw the lines
	  vectorContext.setFillStrokeStyle(null, this.strokeStyle_);
	  var i, l, line;
	  for (i = 0, l = this.meridians_.length; i < l; ++i) {
	    line = this.meridians_[i];
	    vectorContext.drawGeometry(line);
	  }
	  for (i = 0, l = this.parallels_.length; i < l; ++i) {
	    line = this.parallels_[i];
	    vectorContext.drawGeometry(line);
	  }
	  var labelData;
	  if (this.meridiansLabels_) {
	    for (i = 0, l = this.meridiansLabels_.length; i < l; ++i) {
	      labelData = this.meridiansLabels_[i];
	      this.lonLabelStyle_.setText(labelData.text);
	      vectorContext.setTextStyle(this.lonLabelStyle_);
	      vectorContext.drawGeometry(labelData.geom);
	    }
	  }
	  if (this.parallelsLabels_) {
	    for (i = 0, l = this.parallelsLabels_.length; i < l; ++i) {
	      labelData = this.parallelsLabels_[i];
	      this.latLabelStyle_.setText(labelData.text);
	      vectorContext.setTextStyle(this.latLabelStyle_);
	      vectorContext.drawGeometry(labelData.geom);
	    }
	  }
	};
	
	/**
	 * @param {import("./proj/Projection.js").default} projection Projection.
	 * @private
	 */
	Graticule.prototype.updateProjectionInfo_ = function updateProjectionInfo_ (projection) {
	  var epsg4326Projection = get$2('EPSG:4326');
	
	  var worldExtent = projection.getWorldExtent();
	  var worldExtentP = transformExtent(worldExtent, epsg4326Projection, projection);
	
	  this.maxLat_ = worldExtent[3];
	  this.maxLon_ = worldExtent[2];
	  this.minLat_ = worldExtent[1];
	  this.minLon_ = worldExtent[0];
	
	  this.maxLatP_ = worldExtentP[3];
	  this.maxLonP_ = worldExtentP[2];
	  this.minLatP_ = worldExtentP[1];
	  this.minLonP_ = worldExtentP[0];
	
	  this.fromLonLatTransform_ = getTransform(epsg4326Projection, projection);
	
	  this.toLonLatTransform_ = getTransform(projection, epsg4326Projection);
	
	  this.projectionCenterLonLat_ = this.toLonLatTransform_(getCenter(projection.getExtent()));
	
	  this.projection_ = projection;
	};
	
	/**
	 * Set the map for this graticule.The graticule will be rendered on the
	 * provided map.
	 * @param {import("./PluggableMap.js").default} map Map.
	 * @api
	 */
	Graticule.prototype.setMap = function setMap (map) {
	  if (this.map_) {
	    unlistenByKey(this.postcomposeListenerKey_);
	    this.postcomposeListenerKey_ = null;
	    this.map_.render();
	  }
	  if (map) {
	    this.postcomposeListenerKey_ = listen(map, RenderEventType.POSTCOMPOSE, this.handlePostCompose_, this);
	    map.render();
	  }
	  this.map_ = map;
	};
	
	/**
	 * @module ol/Kinetic
	 */
	
	/**
	 * @classdesc
	 * Implementation of inertial deceleration for map movement.
	 *
	 * @api
	 */
	var Kinetic = function Kinetic(decay, minVelocity, delay) {
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.decay_ = decay;
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.minVelocity_ = minVelocity;
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.delay_ = delay;
	
	  /**
	   * @private
	   * @type {Array<number>}
	   */
	  this.points_ = [];
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.angle_ = 0;
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.initialVelocity_ = 0;
	};
	
	/**
	 * FIXME empty description for jsdoc
	 */
	Kinetic.prototype.begin = function begin () {
	  this.points_.length = 0;
	  this.angle_ = 0;
	  this.initialVelocity_ = 0;
	};
	
	/**
	 * @param {number} x X.
	 * @param {number} y Y.
	 */
	Kinetic.prototype.update = function update (x, y) {
	  this.points_.push(x, y, Date.now());
	};
	
	/**
	 * @return {boolean} Whether we should do kinetic animation.
	 */
	Kinetic.prototype.end = function end () {
	  if (this.points_.length < 6) {
	    // at least 2 points are required (i.e. there must be at least 6 elements
	    // in the array)
	    return false;
	  }
	  var delay = Date.now() - this.delay_;
	  var lastIndex = this.points_.length - 3;
	  if (this.points_[lastIndex + 2] < delay) {
	    // the last tracked point is too old, which means that the user stopped
	    // panning before releasing the map
	    return false;
	  }
	
	  // get the first point which still falls into the delay time
	  var firstIndex = lastIndex - 3;
	  while (firstIndex > 0 && this.points_[firstIndex + 2] > delay) {
	    firstIndex -= 3;
	  }
	
	  var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
	  // we don't want a duration of 0 (divide by zero)
	  // we also make sure the user panned for a duration of at least one frame
	  // (1/60s) to compute sane displacement values
	  if (duration < 1000 / 60) {
	    return false;
	  }
	
	  var dx = this.points_[lastIndex] - this.points_[firstIndex];
	  var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
	  this.angle_ = Math.atan2(dy, dx);
	  this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
	  return this.initialVelocity_ > this.minVelocity_;
	};
	
	/**
	 * @return {number} Total distance travelled (pixels).
	 */
	Kinetic.prototype.getDistance = function getDistance () {
	  return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
	};
	
	/**
	 * @return {number} Angle of the kinetic panning animation (radians).
	 */
	Kinetic.prototype.getAngle = function getAngle () {
	  return this.angle_;
	};
	
	/**
	 * @module ol/MapEvent
	 */
	
	/**
	 * @classdesc
	 * Events emitted as map events are instances of this type.
	 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map event.
	 */
	var MapEvent = /*@__PURE__*/(function (Event$$1) {
	  function MapEvent(type, map, opt_frameState) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The map where the event occurred.
	     * @type {import("./PluggableMap.js").default}
	     * @api
	     */
	    this.map = map;
	
	    /**
	     * The frame state at the time of the event.
	     * @type {?import("./PluggableMap.js").FrameState}
	     * @api
	     */
	    this.frameState = opt_frameState !== undefined ? opt_frameState : null;
	
	  }
	
	  if ( Event$$1 ) { MapEvent.__proto__ = Event$$1; }
	  MapEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  MapEvent.prototype.constructor = MapEvent;
	
	  return MapEvent;
	}(Event));
	
	/**
	 * @module ol/MapBrowserEvent
	 */
	
	/**
	 * @classdesc
	 * Events emitted as map browser events are instances of this type.
	 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map browser event.
	 * @api
	 */
	var MapBrowserEvent = /*@__PURE__*/(function (MapEvent$$1) {
	  function MapBrowserEvent(type, map, browserEvent, opt_dragging, opt_frameState) {
	
	    MapEvent$$1.call(this, type, map, opt_frameState);
	
	    /**
	     * The original browser event.
	     * @const
	     * @type {Event}
	     * @api
	     */
	    this.originalEvent = browserEvent;
	
	    /**
	     * The map pixel relative to the viewport corresponding to the original browser event.
	     * @type {import("./pixel.js").Pixel}
	     * @api
	     */
	    this.pixel = map.getEventPixel(browserEvent);
	
	    /**
	     * The coordinate in view projection corresponding to the original browser event.
	     * @type {import("./coordinate.js").Coordinate}
	     * @api
	     */
	    this.coordinate = map.getCoordinateFromPixel(this.pixel);
	
	    /**
	     * Indicates if the map is currently being dragged. Only set for
	     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
	     *
	     * @type {boolean}
	     * @api
	     */
	    this.dragging = opt_dragging !== undefined ? opt_dragging : false;
	
	  }
	
	  if ( MapEvent$$1 ) { MapBrowserEvent.__proto__ = MapEvent$$1; }
	  MapBrowserEvent.prototype = Object.create( MapEvent$$1 && MapEvent$$1.prototype );
	  MapBrowserEvent.prototype.constructor = MapBrowserEvent;
	
	  /**
	   * Prevents the default browser action.
	   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
	   * @override
	   * @api
	   */
	  MapBrowserEvent.prototype.preventDefault = function preventDefault () {
	    MapEvent$$1.prototype.preventDefault.call(this);
	    this.originalEvent.preventDefault();
	  };
	
	  /**
	   * Prevents further propagation of the current event.
	   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
	   * @override
	   * @api
	   */
	  MapBrowserEvent.prototype.stopPropagation = function stopPropagation () {
	    MapEvent$$1.prototype.stopPropagation.call(this);
	    this.originalEvent.stopPropagation();
	  };
	
	  return MapBrowserEvent;
	}(MapEvent));
	
	/**
	 * @module ol/MapBrowserEventType
	 */
	
	/**
	 * Constants for event names.
	 * @kind namespace
	 * @name MapBrowserEventType
	 * @api
	 */
	var MapBrowserEventType = {
	
	  /**
	   * A true single click with no dragging and no double click. Note that this
	   * event is delayed by 250 ms to ensure that it is not a double click.
	   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
	   * @api
	   */
	  SINGLECLICK: 'singleclick',
	
	  /**
	   * A click with no dragging. A double click will fire two of this.
	   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
	   * @api
	   */
	  CLICK: EventType.CLICK,
	
	  /**
	   * A true double click, with no dragging.
	   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
	   * @api
	   */
	  DBLCLICK: EventType.DBLCLICK,
	
	  /**
	   * Triggered when a pointer is dragged.
	   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
	   * @api
	   */
	  POINTERDRAG: 'pointerdrag',
	
	  /**
	   * Triggered when a pointer is moved. Note that on touch devices this is
	   * triggered when the map is panned, so is not the same as mousemove.
	   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
	   * @api
	   */
	  POINTERMOVE: 'pointermove',
	
	  POINTERDOWN: 'pointerdown',
	  POINTERUP: 'pointerup',
	  POINTEROVER: 'pointerover',
	  POINTEROUT: 'pointerout',
	  POINTERENTER: 'pointerenter',
	  POINTERLEAVE: 'pointerleave',
	  POINTERCANCEL: 'pointercancel'
	};
	
	/**
	 * @module ol/MapBrowserPointerEvent
	 */
	
	/**
	 * @api
	 */
	var MapBrowserPointerEvent = /*@__PURE__*/(function (MapBrowserEvent$$1) {
	  function MapBrowserPointerEvent(type, map, pointerEvent, opt_dragging, opt_frameState) {
	
	    MapBrowserEvent$$1.call(this, type, map, pointerEvent.originalEvent, opt_dragging, opt_frameState);
	
	    /**
	     * @const
	     * @type {import("./pointer/PointerEvent.js").default}
	     */
	    this.pointerEvent = pointerEvent;
	
	  }
	
	  if ( MapBrowserEvent$$1 ) { MapBrowserPointerEvent.__proto__ = MapBrowserEvent$$1; }
	  MapBrowserPointerEvent.prototype = Object.create( MapBrowserEvent$$1 && MapBrowserEvent$$1.prototype );
	  MapBrowserPointerEvent.prototype.constructor = MapBrowserPointerEvent;
	
	  return MapBrowserPointerEvent;
	}(MapBrowserEvent));
	
	/**
	 * @module ol/pointer/EventType
	 */
	
	/**
	 * Constants for event names.
	 * @enum {string}
	 */
	var PointerEventType = {
	  POINTERMOVE: 'pointermove',
	  POINTERDOWN: 'pointerdown',
	  POINTERUP: 'pointerup',
	  POINTEROVER: 'pointerover',
	  POINTEROUT: 'pointerout',
	  POINTERENTER: 'pointerenter',
	  POINTERLEAVE: 'pointerleave',
	  POINTERCANCEL: 'pointercancel'
	};
	
	/**
	 * @module ol/pointer/EventSource
	 */
	
	var EventSource = function EventSource(dispatcher, mapping) {
	
	  /**
	   * @type {import("./PointerEventHandler.js").default}
	   */
	  this.dispatcher = dispatcher;
	
	  /**
	   * @private
	   * @const
	   * @type {!Object<string, function(Event)>}
	   */
	  this.mapping_ = mapping;
	};
	
	/**
	 * List of events supported by this source.
	 * @return {Array<string>} Event names
	 */
	EventSource.prototype.getEvents = function getEvents () {
	  return Object.keys(this.mapping_);
	};
	
	/**
	 * Returns the handler that should handle a given event type.
	 * @param {string} eventType The event type.
	 * @return {function(Event)} Handler
	 */
	EventSource.prototype.getHandlerForEvent = function getHandlerForEvent (eventType) {
	  return this.mapping_[eventType];
	};
	
	/**
	 * @module ol/pointer/MouseSource
	 */
	
	
	/**
	 * @type {number}
	 */
	var POINTER_ID = 1;
	
	
	/**
	 * @type {string}
	 */
	var POINTER_TYPE = 'mouse';
	
	
	/**
	 * Radius around touchend that swallows mouse events.
	 *
	 * @type {number}
	 */
	var DEDUP_DIST = 25;
	
	/**
	 * Handler for `mousedown`.
	 *
	 * @this {MouseSource}
	 * @param {MouseEvent} inEvent The in event.
	 */
	function mousedown(inEvent) {
	  if (!this.isEventSimulatedFromTouch_(inEvent)) {
	    // TODO(dfreedman) workaround for some elements not sending mouseup
	    // http://crbug/149091
	    if (POINTER_ID.toString() in this.pointerMap) {
	      this.cancel(inEvent);
	    }
	    var e = prepareEvent(inEvent, this.dispatcher);
	    this.pointerMap[POINTER_ID.toString()] = inEvent;
	    this.dispatcher.down(e, inEvent);
	  }
	}
	
	/**
	 * Handler for `mousemove`.
	 *
	 * @this {MouseSource}
	 * @param {MouseEvent} inEvent The in event.
	 */
	function mousemove(inEvent) {
	  if (!this.isEventSimulatedFromTouch_(inEvent)) {
	    var e = prepareEvent(inEvent, this.dispatcher);
	    this.dispatcher.move(e, inEvent);
	  }
	}
	
	/**
	 * Handler for `mouseup`.
	 *
	 * @this {MouseSource}
	 * @param {MouseEvent} inEvent The in event.
	 */
	function mouseup(inEvent) {
	  if (!this.isEventSimulatedFromTouch_(inEvent)) {
	    var p = this.pointerMap[POINTER_ID.toString()];
	
	    if (p && p.button === inEvent.button) {
	      var e = prepareEvent(inEvent, this.dispatcher);
	      this.dispatcher.up(e, inEvent);
	      this.cleanupMouse();
	    }
	  }
	}
	
	/**
	 * Handler for `mouseover`.
	 *
	 * @this {MouseSource}
	 * @param {MouseEvent} inEvent The in event.
	 */
	function mouseover(inEvent) {
	  if (!this.isEventSimulatedFromTouch_(inEvent)) {
	    var e = prepareEvent(inEvent, this.dispatcher);
	    this.dispatcher.enterOver(e, inEvent);
	  }
	}
	
	/**
	 * Handler for `mouseout`.
	 *
	 * @this {MouseSource}
	 * @param {MouseEvent} inEvent The in event.
	 */
	function mouseout(inEvent) {
	  if (!this.isEventSimulatedFromTouch_(inEvent)) {
	    var e = prepareEvent(inEvent, this.dispatcher);
	    this.dispatcher.leaveOut(e, inEvent);
	  }
	}
	
	
	var MouseSource = /*@__PURE__*/(function (EventSource$$1) {
	  function MouseSource(dispatcher) {
	    var mapping = {
	      'mousedown': mousedown,
	      'mousemove': mousemove,
	      'mouseup': mouseup,
	      'mouseover': mouseover,
	      'mouseout': mouseout
	    };
	    EventSource$$1.call(this, dispatcher, mapping);
	
	    /**
	     * @const
	     * @type {!Object<string, Event|Object>}
	     */
	    this.pointerMap = dispatcher.pointerMap;
	
	    /**
	     * @const
	     * @type {Array<import("../pixel.js").Pixel>}
	     */
	    this.lastTouches = [];
	  }
	
	  if ( EventSource$$1 ) { MouseSource.__proto__ = EventSource$$1; }
	  MouseSource.prototype = Object.create( EventSource$$1 && EventSource$$1.prototype );
	  MouseSource.prototype.constructor = MouseSource;
	
	  /**
	   * Detect if a mouse event was simulated from a touch by
	   * checking if previously there was a touch event at the
	   * same position.
	   *
	   * FIXME - Known problem with the native Android browser on
	   * Samsung GT-I9100 (Android 4.1.2):
	   * In case the page is scrolled, this function does not work
	   * correctly when a canvas is used (WebGL or canvas renderer).
	   * Mouse listeners on canvas elements (for this browser), create
	   * two mouse events: One 'good' and one 'bad' one (on other browsers or
	   * when a div is used, there is only one event). For the 'bad' one,
	   * clientX/clientY and also pageX/pageY are wrong when the page
	   * is scrolled. Because of that, this function can not detect if
	   * the events were simulated from a touch event. As result, a
	   * pointer event at a wrong position is dispatched, which confuses
	   * the map interactions.
	   * It is unclear, how one can get the correct position for the event
	   * or detect that the positions are invalid.
	   *
	   * @private
	   * @param {MouseEvent} inEvent The in event.
	   * @return {boolean} True, if the event was generated by a touch.
	   */
	  MouseSource.prototype.isEventSimulatedFromTouch_ = function isEventSimulatedFromTouch_ (inEvent) {
	    var lts = this.lastTouches;
	    var x = inEvent.clientX;
	    var y = inEvent.clientY;
	    for (var i = 0, l = lts.length, t = (void 0); i < l && (t = lts[i]); i++) {
	      // simulated mouse events will be swallowed near a primary touchend
	      var dx = Math.abs(x - t[0]);
	      var dy = Math.abs(y - t[1]);
	      if (dx <= DEDUP_DIST && dy <= DEDUP_DIST) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * Dispatches a `pointercancel` event.
	   *
	   * @param {Event} inEvent The in event.
	   */
	  MouseSource.prototype.cancel = function cancel (inEvent) {
	    var e = prepareEvent(inEvent, this.dispatcher);
	    this.dispatcher.cancel(e, inEvent);
	    this.cleanupMouse();
	  };
	
	  /**
	   * Remove the mouse from the list of active pointers.
	   */
	  MouseSource.prototype.cleanupMouse = function cleanupMouse () {
	    delete this.pointerMap[POINTER_ID.toString()];
	  };
	
	  return MouseSource;
	}(EventSource));
	
	
	/**
	 * Creates a copy of the original event that will be used
	 * for the fake pointer event.
	 *
	 * @param {Event} inEvent The in event.
	 * @param {import("./PointerEventHandler.js").default} dispatcher Event handler.
	 * @return {Object} The copied event.
	 */
	function prepareEvent(inEvent, dispatcher) {
	  var e = dispatcher.cloneEvent(inEvent, inEvent);
	
	  // forward mouse preventDefault
	  var pd = e.preventDefault;
	  e.preventDefault = function() {
	    inEvent.preventDefault();
	    pd();
	  };
	
	  e.pointerId = POINTER_ID;
	  e.isPrimary = true;
	  e.pointerType = POINTER_TYPE;
	
	  return e;
	}
	
	/**
	 * @module ol/pointer/MsSource
	 */
	
	
	/**
	 * @const
	 * @type {Array<string>}
	 */
	var POINTER_TYPES = [
	  '',
	  'unavailable',
	  'touch',
	  'pen',
	  'mouse'
	];
	
	/**
	 * Handler for `msPointerDown`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msPointerDown(inEvent) {
	  this.pointerMap[inEvent.pointerId.toString()] = inEvent;
	  var e = this.prepareEvent_(inEvent);
	  this.dispatcher.down(e, inEvent);
	}
	
	/**
	 * Handler for `msPointerMove`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msPointerMove(inEvent) {
	  var e = this.prepareEvent_(inEvent);
	  this.dispatcher.move(e, inEvent);
	}
	
	/**
	 * Handler for `msPointerUp`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msPointerUp(inEvent) {
	  var e = this.prepareEvent_(inEvent);
	  this.dispatcher.up(e, inEvent);
	  this.cleanup(inEvent.pointerId);
	}
	
	/**
	 * Handler for `msPointerOut`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msPointerOut(inEvent) {
	  var e = this.prepareEvent_(inEvent);
	  this.dispatcher.leaveOut(e, inEvent);
	}
	
	/**
	 * Handler for `msPointerOver`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msPointerOver(inEvent) {
	  var e = this.prepareEvent_(inEvent);
	  this.dispatcher.enterOver(e, inEvent);
	}
	
	/**
	 * Handler for `msPointerCancel`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msPointerCancel(inEvent) {
	  var e = this.prepareEvent_(inEvent);
	  this.dispatcher.cancel(e, inEvent);
	  this.cleanup(inEvent.pointerId);
	}
	
	/**
	 * Handler for `msLostPointerCapture`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msLostPointerCapture(inEvent) {
	  var e = this.dispatcher.makeEvent('lostpointercapture', inEvent, inEvent);
	  this.dispatcher.dispatchEvent(e);
	}
	
	/**
	 * Handler for `msGotPointerCapture`.
	 *
	 * @this {MsSource}
	 * @param {MSPointerEvent} inEvent The in event.
	 */
	function msGotPointerCapture(inEvent) {
	  var e = this.dispatcher.makeEvent('gotpointercapture', inEvent, inEvent);
	  this.dispatcher.dispatchEvent(e);
	}
	
	var MsSource = /*@__PURE__*/(function (EventSource$$1) {
	  function MsSource(dispatcher) {
	    var mapping = {
	      'MSPointerDown': msPointerDown,
	      'MSPointerMove': msPointerMove,
	      'MSPointerUp': msPointerUp,
	      'MSPointerOut': msPointerOut,
	      'MSPointerOver': msPointerOver,
	      'MSPointerCancel': msPointerCancel,
	      'MSGotPointerCapture': msGotPointerCapture,
	      'MSLostPointerCapture': msLostPointerCapture
	    };
	    EventSource$$1.call(this, dispatcher, mapping);
	
	    /**
	     * @const
	     * @type {!Object<string, MSPointerEvent|Object>}
	     */
	    this.pointerMap = dispatcher.pointerMap;
	  }
	
	  if ( EventSource$$1 ) { MsSource.__proto__ = EventSource$$1; }
	  MsSource.prototype = Object.create( EventSource$$1 && EventSource$$1.prototype );
	  MsSource.prototype.constructor = MsSource;
	
	  /**
	   * Creates a copy of the original event that will be used
	   * for the fake pointer event.
	   *
	   * @private
	   * @param {MSPointerEvent} inEvent The in event.
	   * @return {Object} The copied event.
	   */
	  MsSource.prototype.prepareEvent_ = function prepareEvent_ (inEvent) {
	    /** @type {MSPointerEvent|Object} */
	    var e = inEvent;
	    if (typeof inEvent.pointerType === 'number') {
	      e = this.dispatcher.cloneEvent(inEvent, inEvent);
	      e.pointerType = POINTER_TYPES[inEvent.pointerType];
	    }
	
	    return e;
	  };
	
	  /**
	   * Remove this pointer from the list of active pointers.
	   * @param {number} pointerId Pointer identifier.
	   */
	  MsSource.prototype.cleanup = function cleanup (pointerId) {
	    delete this.pointerMap[pointerId.toString()];
	  };
	
	  return MsSource;
	}(EventSource));
	
	/**
	 * @module ol/pointer/NativeSource
	 */
	
	/**
	 * Handler for `pointerdown`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function pointerDown(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `pointermove`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function pointerMove(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `pointerup`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function pointerUp(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `pointerout`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function pointerOut(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `pointerover`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function pointerOver(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `pointercancel`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function pointerCancel(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `lostpointercapture`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function lostPointerCapture(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	/**
	 * Handler for `gotpointercapture`.
	 *
	 * @this {NativeSource}
	 * @param {Event} inEvent The in event.
	 */
	function gotPointerCapture(inEvent) {
	  this.dispatcher.fireNativeEvent(inEvent);
	}
	
	var NativeSource = /*@__PURE__*/(function (EventSource$$1) {
	  function NativeSource(dispatcher) {
	    var mapping = {
	      'pointerdown': pointerDown,
	      'pointermove': pointerMove,
	      'pointerup': pointerUp,
	      'pointerout': pointerOut,
	      'pointerover': pointerOver,
	      'pointercancel': pointerCancel,
	      'gotpointercapture': gotPointerCapture,
	      'lostpointercapture': lostPointerCapture
	    };
	    EventSource$$1.call(this, dispatcher, mapping);
	  }
	
	  if ( EventSource$$1 ) { NativeSource.__proto__ = EventSource$$1; }
	  NativeSource.prototype = Object.create( EventSource$$1 && EventSource$$1.prototype );
	  NativeSource.prototype.constructor = NativeSource;
	
	  return NativeSource;
	}(EventSource));
	
	/**
	 * @module ol/pointer/PointerEvent
	 */
	
	
	/**
	 * Is the `buttons` property supported?
	 * @type {boolean}
	 */
	var HAS_BUTTONS = false;
	
	
	var PointerEvent = /*@__PURE__*/(function (_Event) {
	  function PointerEvent(type, originalEvent, opt_eventDict) {
	    _Event.call(this, type);
	
	    /**
	     * @const
	     * @type {Event}
	     */
	    this.originalEvent = originalEvent;
	
	    var eventDict = opt_eventDict ? opt_eventDict : {};
	
	    /**
	     * @type {number}
	     */
	    this.buttons = getButtons(eventDict);
	
	    /**
	     * @type {number}
	     */
	    this.pressure = getPressure(eventDict, this.buttons);
	
	    // MouseEvent related properties
	
	    /**
	     * @type {boolean}
	     */
	    this.bubbles = 'bubbles' in eventDict ? eventDict['bubbles'] : false;
	
	    /**
	     * @type {boolean}
	     */
	    this.cancelable = 'cancelable' in eventDict ? eventDict['cancelable'] : false;
	
	    /**
	     * @type {Object}
	     */
	    this.view = 'view' in eventDict ? eventDict['view'] : null;
	
	    /**
	     * @type {number}
	     */
	    this.detail = 'detail' in eventDict ? eventDict['detail'] : null;
	
	    /**
	     * @type {number}
	     */
	    this.screenX = 'screenX' in eventDict ? eventDict['screenX'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.screenY = 'screenY' in eventDict ? eventDict['screenY'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.clientX = 'clientX' in eventDict ? eventDict['clientX'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.clientY = 'clientY' in eventDict ? eventDict['clientY'] : 0;
	
	    /**
	     * @type {boolean}
	     */
	    this.ctrlKey = 'ctrlKey' in eventDict ? eventDict['ctrlKey'] : false;
	
	    /**
	     * @type {boolean}
	     */
	    this.altKey = 'altKey' in eventDict ? eventDict['altKey'] : false;
	
	    /**
	     * @type {boolean}
	     */
	    this.shiftKey = 'shiftKey' in eventDict ? eventDict['shiftKey'] : false;
	
	    /**
	     * @type {boolean}
	     */
	    this.metaKey = 'metaKey' in eventDict ? eventDict['metaKey'] : false;
	
	    /**
	     * @type {number}
	     */
	    this.button = 'button' in eventDict ? eventDict['button'] : 0;
	
	    /**
	     * @type {Node}
	     */
	    this.relatedTarget = 'relatedTarget' in eventDict ?
	      eventDict['relatedTarget'] : null;
	
	    // PointerEvent related properties
	
	    /**
	     * @const
	     * @type {number}
	     */
	    this.pointerId = 'pointerId' in eventDict ? eventDict['pointerId'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.width = 'width' in eventDict ? eventDict['width'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.height = 'height' in eventDict ? eventDict['height'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.tiltX = 'tiltX' in eventDict ? eventDict['tiltX'] : 0;
	
	    /**
	     * @type {number}
	     */
	    this.tiltY = 'tiltY' in eventDict ? eventDict['tiltY'] : 0;
	
	    /**
	     * @type {string}
	     */
	    this.pointerType = 'pointerType' in eventDict ? eventDict['pointerType'] : '';
	
	    /**
	     * @type {number}
	     */
	    this.hwTimestamp = 'hwTimestamp' in eventDict ? eventDict['hwTimestamp'] : 0;
	
	    /**
	     * @type {boolean}
	     */
	    this.isPrimary = 'isPrimary' in eventDict ? eventDict['isPrimary'] : false;
	
	    // keep the semantics of preventDefault
	    if (originalEvent.preventDefault) {
	      this.preventDefault = function() {
	        originalEvent.preventDefault();
	      };
	    }
	  }
	
	  if ( _Event ) { PointerEvent.__proto__ = _Event; }
	  PointerEvent.prototype = Object.create( _Event && _Event.prototype );
	  PointerEvent.prototype.constructor = PointerEvent;
	
	  return PointerEvent;
	}(Event));
	
	
	/**
	 * @param {Object<string, ?>} eventDict The event dictionary.
	 * @return {number} Button indicator.
	 */
	function getButtons(eventDict) {
	  // According to the w3c spec,
	  // http://www.w3.org/TR/DOM-Level-3-Events/#events-MouseEvent-button
	  // MouseEvent.button == 0 can mean either no mouse button depressed, or the
	  // left mouse button depressed.
	  //
	  // As of now, the only way to distinguish between the two states of
	  // MouseEvent.button is by using the deprecated MouseEvent.which property, as
	  // this maps mouse buttons to positive integers > 0, and uses 0 to mean that
	  // no mouse button is held.
	  //
	  // MouseEvent.which is derived from MouseEvent.button at MouseEvent creation,
	  // but initMouseEvent does not expose an argument with which to set
	  // MouseEvent.which. Calling initMouseEvent with a buttonArg of 0 will set
	  // MouseEvent.button == 0 and MouseEvent.which == 1, breaking the expectations
	  // of app developers.
	  //
	  // The only way to propagate the correct state of MouseEvent.which and
	  // MouseEvent.button to a new MouseEvent.button == 0 and MouseEvent.which == 0
	  // is to call initMouseEvent with a buttonArg value of -1.
	  //
	  // This is fixed with DOM Level 4's use of buttons
	  var buttons;
	  if (eventDict.buttons || HAS_BUTTONS) {
	    buttons = eventDict.buttons;
	  } else {
	    switch (eventDict.which) {
	      case 1: buttons = 1; break;
	      case 2: buttons = 4; break;
	      case 3: buttons = 2; break;
	      default: buttons = 0;
	    }
	  }
	  return buttons;
	}
	
	
	/**
	 * @param {Object<string, ?>} eventDict The event dictionary.
	 * @param {number} buttons Button indicator.
	 * @return {number} The pressure.
	 */
	function getPressure(eventDict, buttons) {
	  // Spec requires that pointers without pressure specified use 0.5 for down
	  // state and 0 for up state.
	  var pressure = 0;
	  if (eventDict.pressure) {
	    pressure = eventDict.pressure;
	  } else {
	    pressure = buttons ? 0.5 : 0;
	  }
	  return pressure;
	}
	
	
	/**
	 * Checks if the `buttons` property is supported.
	 */
	(function() {
	  try {
	    var ev = new MouseEvent('click', {buttons: 1});
	    HAS_BUTTONS = ev.buttons === 1;
	  } catch (e) {
	    // pass
	  }
	})();
	
	/**
	 * @module ol/pointer/TouchSource
	 */
	
	
	/**
	 * @type {number}
	 */
	var CLICK_COUNT_TIMEOUT = 200;
	
	/**
	 * @type {string}
	 */
	var POINTER_TYPE$1 = 'touch';
	
	/**
	 * Handler for `touchstart`, triggers `pointerover`,
	 * `pointerenter` and `pointerdown` events.
	 *
	 * @this {TouchSource}
	 * @param {TouchEvent} inEvent The in event.
	 */
	function touchstart(inEvent) {
	  this.vacuumTouches_(inEvent);
	  this.setPrimaryTouch_(inEvent.changedTouches[0]);
	  this.dedupSynthMouse_(inEvent);
	  this.clickCount_++;
	  this.processTouches_(inEvent, this.overDown_);
	}
	
	/**
	 * Handler for `touchmove`.
	 *
	 * @this {TouchSource}
	 * @param {TouchEvent} inEvent The in event.
	 */
	function touchmove(inEvent) {
	  this.processTouches_(inEvent, this.moveOverOut_);
	}
	
	/**
	 * Handler for `touchend`, triggers `pointerup`,
	 * `pointerout` and `pointerleave` events.
	 *
	 * @this {TouchSource}
	 * @param {TouchEvent} inEvent The event.
	 */
	function touchend(inEvent) {
	  this.dedupSynthMouse_(inEvent);
	  this.processTouches_(inEvent, this.upOut_);
	}
	
	/**
	 * Handler for `touchcancel`, triggers `pointercancel`,
	 * `pointerout` and `pointerleave` events.
	 *
	 * @this {TouchSource}
	 * @param {TouchEvent} inEvent The in event.
	 */
	function touchcancel(inEvent) {
	  this.processTouches_(inEvent, this.cancelOut_);
	}
	
	
	var TouchSource = /*@__PURE__*/(function (EventSource$$1) {
	  function TouchSource(dispatcher, mouseSource) {
	    var mapping = {
	      'touchstart': touchstart,
	      'touchmove': touchmove,
	      'touchend': touchend,
	      'touchcancel': touchcancel
	    };
	    EventSource$$1.call(this, dispatcher, mapping);
	
	    /**
	     * @const
	     * @type {!Object<string, Event|Object>}
	     */
	    this.pointerMap = dispatcher.pointerMap;
	
	    /**
	     * @const
	     * @type {import("./MouseSource.js").default}
	     */
	    this.mouseSource = mouseSource;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.firstTouchId_ = undefined;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.clickCount_ = 0;
	
	    /**
	     * @private
	     * @type {?}
	     */
	    this.resetId_;
	
	    /**
	     * Mouse event timeout: This should be long enough to
	     * ignore compat mouse events made by touch.
	     * @private
	     * @type {number}
	     */
	    this.dedupTimeout_ = 2500;
	  }
	
	  if ( EventSource$$1 ) { TouchSource.__proto__ = EventSource$$1; }
	  TouchSource.prototype = Object.create( EventSource$$1 && EventSource$$1.prototype );
	  TouchSource.prototype.constructor = TouchSource;
	
	  /**
	   * @private
	   * @param {Touch} inTouch The in touch.
	   * @return {boolean} True, if this is the primary touch.
	   */
	  TouchSource.prototype.isPrimaryTouch_ = function isPrimaryTouch_ (inTouch) {
	    return this.firstTouchId_ === inTouch.identifier;
	  };
	
	  /**
	   * Set primary touch if there are no pointers, or the only pointer is the mouse.
	   * @param {Touch} inTouch The in touch.
	   * @private
	   */
	  TouchSource.prototype.setPrimaryTouch_ = function setPrimaryTouch_ (inTouch) {
	    var count = Object.keys(this.pointerMap).length;
	    if (count === 0 || (count === 1 && POINTER_ID.toString() in this.pointerMap)) {
	      this.firstTouchId_ = inTouch.identifier;
	      this.cancelResetClickCount_();
	    }
	  };
	
	  /**
	   * @private
	   * @param {PointerEvent} inPointer The in pointer object.
	   */
	  TouchSource.prototype.removePrimaryPointer_ = function removePrimaryPointer_ (inPointer) {
	    if (inPointer.isPrimary) {
	      this.firstTouchId_ = undefined;
	      this.resetClickCount_();
	    }
	  };
	
	  /**
	   * @private
	   */
	  TouchSource.prototype.resetClickCount_ = function resetClickCount_ () {
	    this.resetId_ = setTimeout(
	      this.resetClickCountHandler_.bind(this),
	      CLICK_COUNT_TIMEOUT);
	  };
	
	  /**
	   * @private
	   */
	  TouchSource.prototype.resetClickCountHandler_ = function resetClickCountHandler_ () {
	    this.clickCount_ = 0;
	    this.resetId_ = undefined;
	  };
	
	  /**
	   * @private
	   */
	  TouchSource.prototype.cancelResetClickCount_ = function cancelResetClickCount_ () {
	    if (this.resetId_ !== undefined) {
	      clearTimeout(this.resetId_);
	    }
	  };
	
	  /**
	   * @private
	   * @param {TouchEvent} browserEvent Browser event
	   * @param {Touch} inTouch Touch event
	   * @return {PointerEvent} A pointer object.
	   */
	  TouchSource.prototype.touchToPointer_ = function touchToPointer_ (browserEvent, inTouch) {
	    var e = this.dispatcher.cloneEvent(browserEvent, inTouch);
	    // Spec specifies that pointerId 1 is reserved for Mouse.
	    // Touch identifiers can start at 0.
	    // Add 2 to the touch identifier for compatibility.
	    e.pointerId = inTouch.identifier + 2;
	    // TODO: check if this is necessary?
	    //e.target = findTarget(e);
	    e.bubbles = true;
	    e.cancelable = true;
	    e.detail = this.clickCount_;
	    e.button = 0;
	    e.buttons = 1;
	    e.width = inTouch.radiusX || 0;
	    e.height = inTouch.radiusY || 0;
	    e.pressure = inTouch.force || 0.5;
	    e.isPrimary = this.isPrimaryTouch_(inTouch);
	    e.pointerType = POINTER_TYPE$1;
	
	    // make sure that the properties that are different for
	    // each `Touch` object are not copied from the BrowserEvent object
	    e.clientX = inTouch.clientX;
	    e.clientY = inTouch.clientY;
	    e.screenX = inTouch.screenX;
	    e.screenY = inTouch.screenY;
	
	    return e;
	  };
	
	  /**
	   * @private
	   * @param {TouchEvent} inEvent Touch event
	   * @param {function(TouchEvent, PointerEvent)} inFunction In function.
	   */
	  TouchSource.prototype.processTouches_ = function processTouches_ (inEvent, inFunction) {
	    var touches = Array.prototype.slice.call(inEvent.changedTouches);
	    var count = touches.length;
	    function preventDefault() {
	      inEvent.preventDefault();
	    }
	    for (var i = 0; i < count; ++i) {
	      var pointer = this.touchToPointer_(inEvent, touches[i]);
	      // forward touch preventDefaults
	      pointer.preventDefault = preventDefault;
	      inFunction.call(this, inEvent, pointer);
	    }
	  };
	
	  /**
	   * @private
	   * @param {TouchList} touchList The touch list.
	   * @param {number} searchId Search identifier.
	   * @return {boolean} True, if the `Touch` with the given id is in the list.
	   */
	  TouchSource.prototype.findTouch_ = function findTouch_ (touchList, searchId) {
	    var l = touchList.length;
	    for (var i = 0; i < l; i++) {
	      var touch = touchList[i];
	      if (touch.identifier === searchId) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * In some instances, a touchstart can happen without a touchend. This
	   * leaves the pointermap in a broken state.
	   * Therefore, on every touchstart, we remove the touches that did not fire a
	   * touchend event.
	   * To keep state globally consistent, we fire a pointercancel for
	   * this "abandoned" touch
	   *
	   * @private
	   * @param {TouchEvent} inEvent The in event.
	   */
	  TouchSource.prototype.vacuumTouches_ = function vacuumTouches_ (inEvent) {
	    var touchList = inEvent.touches;
	    // pointerMap.getCount() should be < touchList.length here,
	    // as the touchstart has not been processed yet.
	    var keys = Object.keys(this.pointerMap);
	    var count = keys.length;
	    if (count >= touchList.length) {
	      var d = [];
	      for (var i = 0; i < count; ++i) {
	        var key = Number(keys[i]);
	        var value = this.pointerMap[key];
	        // Never remove pointerId == 1, which is mouse.
	        // Touch identifiers are 2 smaller than their pointerId, which is the
	        // index in pointermap.
	        if (key != POINTER_ID && !this.findTouch_(touchList, key - 2)) {
	          d.push(value.out);
	        }
	      }
	      for (var i$1 = 0; i$1 < d.length; ++i$1) {
	        this.cancelOut_(inEvent, d[i$1]);
	      }
	    }
	  };
	
	  /**
	   * @private
	   * @param {TouchEvent} browserEvent The event.
	   * @param {PointerEvent} inPointer The in pointer object.
	   */
	  TouchSource.prototype.overDown_ = function overDown_ (browserEvent, inPointer) {
	    this.pointerMap[inPointer.pointerId] = {
	      target: inPointer.target,
	      out: inPointer,
	      outTarget: inPointer.target
	    };
	    this.dispatcher.over(inPointer, browserEvent);
	    this.dispatcher.enter(inPointer, browserEvent);
	    this.dispatcher.down(inPointer, browserEvent);
	  };
	
	  /**
	   * @private
	   * @param {TouchEvent} browserEvent The event.
	   * @param {PointerEvent} inPointer The in pointer.
	   */
	  TouchSource.prototype.moveOverOut_ = function moveOverOut_ (browserEvent, inPointer) {
	    var event = inPointer;
	    var pointer = this.pointerMap[event.pointerId];
	    // a finger drifted off the screen, ignore it
	    if (!pointer) {
	      return;
	    }
	    var outEvent = pointer.out;
	    var outTarget = pointer.outTarget;
	    this.dispatcher.move(event, browserEvent);
	    if (outEvent && outTarget !== event.target) {
	      outEvent.relatedTarget = event.target;
	      /** @type {Object} */ (event).relatedTarget = outTarget;
	      // recover from retargeting by shadow
	      outEvent.target = outTarget;
	      if (event.target) {
	        this.dispatcher.leaveOut(outEvent, browserEvent);
	        this.dispatcher.enterOver(event, browserEvent);
	      } else {
	        // clean up case when finger leaves the screen
	        /** @type {Object} */ (event).target = outTarget;
	        /** @type {Object} */ (event).relatedTarget = null;
	        this.cancelOut_(browserEvent, event);
	      }
	    }
	    pointer.out = event;
	    pointer.outTarget = event.target;
	  };
	
	  /**
	   * @private
	   * @param {TouchEvent} browserEvent An event.
	   * @param {PointerEvent} inPointer The inPointer object.
	   */
	  TouchSource.prototype.upOut_ = function upOut_ (browserEvent, inPointer) {
	    this.dispatcher.up(inPointer, browserEvent);
	    this.dispatcher.out(inPointer, browserEvent);
	    this.dispatcher.leave(inPointer, browserEvent);
	    this.cleanUpPointer_(inPointer);
	  };
	
	  /**
	   * @private
	   * @param {TouchEvent} browserEvent The event.
	   * @param {PointerEvent} inPointer The in pointer.
	   */
	  TouchSource.prototype.cancelOut_ = function cancelOut_ (browserEvent, inPointer) {
	    this.dispatcher.cancel(inPointer, browserEvent);
	    this.dispatcher.out(inPointer, browserEvent);
	    this.dispatcher.leave(inPointer, browserEvent);
	    this.cleanUpPointer_(inPointer);
	  };
	
	  /**
	   * @private
	   * @param {PointerEvent} inPointer The inPointer object.
	   */
	  TouchSource.prototype.cleanUpPointer_ = function cleanUpPointer_ (inPointer) {
	    delete this.pointerMap[inPointer.pointerId];
	    this.removePrimaryPointer_(inPointer);
	  };
	
	  /**
	   * Prevent synth mouse events from creating pointer events.
	   *
	   * @private
	   * @param {TouchEvent} inEvent The in event.
	   */
	  TouchSource.prototype.dedupSynthMouse_ = function dedupSynthMouse_ (inEvent) {
	    var lts = this.mouseSource.lastTouches;
	    var t = inEvent.changedTouches[0];
	    // only the primary finger will synth mouse events
	    if (this.isPrimaryTouch_(t)) {
	      // remember x/y of last touch
	      var lt = [t.clientX, t.clientY];
	      lts.push(lt);
	
	      setTimeout(function() {
	        // remove touch after timeout
	        remove(lts, lt);
	      }, this.dedupTimeout_);
	    }
	  };
	
	  return TouchSource;
	}(EventSource));
	
	/**
	 * @module ol/pointer/PointerEventHandler
	 */
	
	
	/**
	 * Properties to copy when cloning an event, with default values.
	 * @type {Array<Array>}
	 */
	var CLONE_PROPS = [
	  // MouseEvent
	  ['bubbles', false],
	  ['cancelable', false],
	  ['view', null],
	  ['detail', null],
	  ['screenX', 0],
	  ['screenY', 0],
	  ['clientX', 0],
	  ['clientY', 0],
	  ['ctrlKey', false],
	  ['altKey', false],
	  ['shiftKey', false],
	  ['metaKey', false],
	  ['button', 0],
	  ['relatedTarget', null],
	  // DOM Level 3
	  ['buttons', 0],
	  // PointerEvent
	  ['pointerId', 0],
	  ['width', 0],
	  ['height', 0],
	  ['pressure', 0],
	  ['tiltX', 0],
	  ['tiltY', 0],
	  ['pointerType', ''],
	  ['hwTimestamp', 0],
	  ['isPrimary', false],
	  // event instance
	  ['type', ''],
	  ['target', null],
	  ['currentTarget', null],
	  ['which', 0]
	];
	
	/**
	 * @api
	 */
	var PointerEventHandler = /*@__PURE__*/(function (EventTarget) {
	  function PointerEventHandler(element) {
	    EventTarget.call(this);
	
	    /**
	     * @const
	     * @private
	     * @type {Element|HTMLDocument}
	     */
	    this.element_ = element;
	
	    /**
	     * @const
	     * @type {!Object<string, Event|Object>}
	     */
	    this.pointerMap = {};
	
	    /**
	     * @type {Object<string, function(Event)>}
	     * @private
	     */
	    this.eventMap_ = {};
	
	    /**
	     * @type {Array<import("./EventSource.js").default>}
	     * @private
	     */
	    this.eventSourceList_ = [];
	
	    this.registerSources();
	  }
	
	  if ( EventTarget ) { PointerEventHandler.__proto__ = EventTarget; }
	  PointerEventHandler.prototype = Object.create( EventTarget && EventTarget.prototype );
	  PointerEventHandler.prototype.constructor = PointerEventHandler;
	
	  /**
	   * Set up the event sources (mouse, touch and native pointers)
	   * that generate pointer events.
	   */
	  PointerEventHandler.prototype.registerSources = function registerSources () {
	    if (POINTER) {
	      this.registerSource('native', new NativeSource(this));
	    } else if (MSPOINTER) {
	      this.registerSource('ms', new MsSource(this));
	    } else {
	      var mouseSource = new MouseSource(this);
	      this.registerSource('mouse', mouseSource);
	
	      if (TOUCH) {
	        this.registerSource('touch', new TouchSource(this, mouseSource));
	      }
	    }
	
	    // register events on the viewport element
	    this.register_();
	  };
	
	  /**
	   * Add a new event source that will generate pointer events.
	   *
	   * @param {string} name A name for the event source
	   * @param {import("./EventSource.js").default} source The source event.
	   */
	  PointerEventHandler.prototype.registerSource = function registerSource (name, source) {
	    var s = source;
	    var newEvents = s.getEvents();
	
	    if (newEvents) {
	      newEvents.forEach(function(e) {
	        var handler = s.getHandlerForEvent(e);
	
	        if (handler) {
	          this.eventMap_[e] = handler.bind(s);
	        }
	      }.bind(this));
	      this.eventSourceList_.push(s);
	    }
	  };
	
	  /**
	   * Set up the events for all registered event sources.
	   * @private
	   */
	  PointerEventHandler.prototype.register_ = function register_ () {
	    var l = this.eventSourceList_.length;
	    for (var i = 0; i < l; i++) {
	      var eventSource = this.eventSourceList_[i];
	      this.addEvents_(eventSource.getEvents());
	    }
	  };
	
	  /**
	   * Remove all registered events.
	   * @private
	   */
	  PointerEventHandler.prototype.unregister_ = function unregister_ () {
	    var l = this.eventSourceList_.length;
	    for (var i = 0; i < l; i++) {
	      var eventSource = this.eventSourceList_[i];
	      this.removeEvents_(eventSource.getEvents());
	    }
	  };
	
	  /**
	   * Calls the right handler for a new event.
	   * @private
	   * @param {Event} inEvent Browser event.
	   */
	  PointerEventHandler.prototype.eventHandler_ = function eventHandler_ (inEvent) {
	    var type = inEvent.type;
	    var handler = this.eventMap_[type];
	    if (handler) {
	      handler(inEvent);
	    }
	  };
	
	  /**
	   * Setup listeners for the given events.
	   * @private
	   * @param {Array<string>} events List of events.
	   */
	  PointerEventHandler.prototype.addEvents_ = function addEvents_ (events) {
	    events.forEach(function(eventName) {
	      listen(this.element_, eventName, this.eventHandler_, this);
	    }.bind(this));
	  };
	
	  /**
	   * Unregister listeners for the given events.
	   * @private
	   * @param {Array<string>} events List of events.
	   */
	  PointerEventHandler.prototype.removeEvents_ = function removeEvents_ (events) {
	    events.forEach(function(e) {
	      unlisten(this.element_, e, this.eventHandler_, this);
	    }.bind(this));
	  };
	
	  /**
	   * Returns a snapshot of inEvent, with writable properties.
	   *
	   * @param {Event} event Browser event.
	   * @param {Event|Touch} inEvent An event that contains
	   *    properties to copy.
	   * @return {Object} An object containing shallow copies of
	   *    `inEvent`'s properties.
	   */
	  PointerEventHandler.prototype.cloneEvent = function cloneEvent (event, inEvent) {
	    var eventCopy = {};
	    for (var i = 0, ii = CLONE_PROPS.length; i < ii; i++) {
	      var p = CLONE_PROPS[i][0];
	      eventCopy[p] = event[p] || inEvent[p] || CLONE_PROPS[i][1];
	    }
	
	    return eventCopy;
	  };
	
	  // EVENTS
	
	
	  /**
	   * Triggers a 'pointerdown' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.down = function down (data, event) {
	    this.fireEvent(PointerEventType.POINTERDOWN, data, event);
	  };
	
	  /**
	   * Triggers a 'pointermove' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.move = function move (data, event) {
	    this.fireEvent(PointerEventType.POINTERMOVE, data, event);
	  };
	
	  /**
	   * Triggers a 'pointerup' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.up = function up (data, event) {
	    this.fireEvent(PointerEventType.POINTERUP, data, event);
	  };
	
	  /**
	   * Triggers a 'pointerenter' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.enter = function enter (data, event) {
	    data.bubbles = false;
	    this.fireEvent(PointerEventType.POINTERENTER, data, event);
	  };
	
	  /**
	   * Triggers a 'pointerleave' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.leave = function leave (data, event) {
	    data.bubbles = false;
	    this.fireEvent(PointerEventType.POINTERLEAVE, data, event);
	  };
	
	  /**
	   * Triggers a 'pointerover' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.over = function over (data, event) {
	    data.bubbles = true;
	    this.fireEvent(PointerEventType.POINTEROVER, data, event);
	  };
	
	  /**
	   * Triggers a 'pointerout' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.out = function out (data, event) {
	    data.bubbles = true;
	    this.fireEvent(PointerEventType.POINTEROUT, data, event);
	  };
	
	  /**
	   * Triggers a 'pointercancel' event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.cancel = function cancel (data, event) {
	    this.fireEvent(PointerEventType.POINTERCANCEL, data, event);
	  };
	
	  /**
	   * Triggers a combination of 'pointerout' and 'pointerleave' events.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.leaveOut = function leaveOut (data, event) {
	    this.out(data, event);
	    if (!this.contains_(data.target, data.relatedTarget)) {
	      this.leave(data, event);
	    }
	  };
	
	  /**
	   * Triggers a combination of 'pointerover' and 'pointerevents' events.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.enterOver = function enterOver (data, event) {
	    this.over(data, event);
	    if (!this.contains_(data.target, data.relatedTarget)) {
	      this.enter(data, event);
	    }
	  };
	
	  /**
	   * @private
	   * @param {Element} container The container element.
	   * @param {Element} contained The contained element.
	   * @return {boolean} Returns true if the container element
	   *   contains the other element.
	   */
	  PointerEventHandler.prototype.contains_ = function contains_ (container, contained) {
	    if (!container || !contained) {
	      return false;
	    }
	    return container.contains(contained);
	  };
	
	  // EVENT CREATION AND TRACKING
	  /**
	   * Creates a new Event of type `inType`, based on the information in
	   * `data`.
	   *
	   * @param {string} inType A string representing the type of event to create.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   * @return {PointerEvent} A PointerEvent of type `inType`.
	   */
	  PointerEventHandler.prototype.makeEvent = function makeEvent (inType, data, event) {
	    return new PointerEvent(inType, event, data);
	  };
	
	  /**
	   * Make and dispatch an event in one call.
	   * @param {string} inType A string representing the type of event.
	   * @param {Object} data Pointer event data.
	   * @param {Event} event The event.
	   */
	  PointerEventHandler.prototype.fireEvent = function fireEvent (inType, data, event) {
	    var e = this.makeEvent(inType, data, event);
	    this.dispatchEvent(e);
	  };
	
	  /**
	   * Creates a pointer event from a native pointer event
	   * and dispatches this event.
	   * @param {Event} event A platform event with a target.
	   */
	  PointerEventHandler.prototype.fireNativeEvent = function fireNativeEvent (event) {
	    var e = this.makeEvent(event.type, event, event);
	    this.dispatchEvent(e);
	  };
	
	  /**
	   * Wrap a native mouse event into a pointer event.
	   * This proxy method is required for the legacy IE support.
	   * @param {string} eventType The pointer event type.
	   * @param {Event} event The event.
	   * @return {PointerEvent} The wrapped event.
	   */
	  PointerEventHandler.prototype.wrapMouseEvent = function wrapMouseEvent (eventType, event) {
	    var pointerEvent = this.makeEvent(
	      eventType, prepareEvent(event, this), event);
	    return pointerEvent;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  PointerEventHandler.prototype.disposeInternal = function disposeInternal () {
	    this.unregister_();
	    EventTarget.prototype.disposeInternal.call(this);
	  };
	
	  return PointerEventHandler;
	}(Target));
	
	/**
	 * @module ol/MapBrowserEventHandler
	 */
	
	var MapBrowserEventHandler = /*@__PURE__*/(function (EventTarget) {
	  function MapBrowserEventHandler(map, moveTolerance) {
	
	    EventTarget.call(this);
	
	    /**
	     * This is the element that we will listen to the real events on.
	     * @type {import("./PluggableMap.js").default}
	     * @private
	     */
	    this.map_ = map;
	
	    /**
	     * @type {any}
	     * @private
	     */
	    this.clickTimeoutId_;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.dragging_ = false;
	
	    /**
	     * @type {!Array<import("./events.js").EventsKey>}
	     * @private
	     */
	    this.dragListenerKeys_ = [];
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.moveTolerance_ = moveTolerance ?
	      moveTolerance * DEVICE_PIXEL_RATIO : DEVICE_PIXEL_RATIO;
	
	    /**
	     * The most recent "down" type event (or null if none have occurred).
	     * Set on pointerdown.
	     * @type {import("./pointer/PointerEvent.js").default}
	     * @private
	     */
	    this.down_ = null;
	
	    var element = this.map_.getViewport();
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.activePointers_ = 0;
	
	    /**
	     * @type {!Object<number, boolean>}
	     * @private
	     */
	    this.trackedTouches_ = {};
	
	    /**
	     * Event handler which generates pointer events for
	     * the viewport element.
	     *
	     * @type {PointerEventHandler}
	     * @private
	     */
	    this.pointerEventHandler_ = new PointerEventHandler(element);
	
	    /**
	     * Event handler which generates pointer events for
	     * the document (used when dragging).
	     *
	     * @type {PointerEventHandler}
	     * @private
	     */
	    this.documentPointerEventHandler_ = null;
	
	    /**
	     * @type {?import("./events.js").EventsKey}
	     * @private
	     */
	    this.pointerdownListenerKey_ = listen(this.pointerEventHandler_,
	      PointerEventType.POINTERDOWN,
	      this.handlePointerDown_, this);
	
	    /**
	     * @type {?import("./events.js").EventsKey}
	     * @private
	     */
	    this.relayedListenerKey_ = listen(this.pointerEventHandler_,
	      PointerEventType.POINTERMOVE,
	      this.relayEvent_, this);
	
	  }
	
	  if ( EventTarget ) { MapBrowserEventHandler.__proto__ = EventTarget; }
	  MapBrowserEventHandler.prototype = Object.create( EventTarget && EventTarget.prototype );
	  MapBrowserEventHandler.prototype.constructor = MapBrowserEventHandler;
	
	  /**
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.emulateClick_ = function emulateClick_ (pointerEvent) {
	    var newEvent = new MapBrowserPointerEvent(
	      MapBrowserEventType.CLICK, this.map_, pointerEvent);
	    this.dispatchEvent(newEvent);
	    if (this.clickTimeoutId_ !== undefined) {
	      // double-click
	      clearTimeout(this.clickTimeoutId_);
	      this.clickTimeoutId_ = undefined;
	      newEvent = new MapBrowserPointerEvent(
	        MapBrowserEventType.DBLCLICK, this.map_, pointerEvent);
	      this.dispatchEvent(newEvent);
	    } else {
	      // click
	      this.clickTimeoutId_ = setTimeout(function() {
	        this.clickTimeoutId_ = undefined;
	        var newEvent = new MapBrowserPointerEvent(
	          MapBrowserEventType.SINGLECLICK, this.map_, pointerEvent);
	        this.dispatchEvent(newEvent);
	      }.bind(this), 250);
	    }
	  };
	
	  /**
	   * Keeps track on how many pointers are currently active.
	   *
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.updateActivePointers_ = function updateActivePointers_ (pointerEvent) {
	    var event = pointerEvent;
	
	    if (event.type == MapBrowserEventType.POINTERUP ||
	        event.type == MapBrowserEventType.POINTERCANCEL) {
	      delete this.trackedTouches_[event.pointerId];
	    } else if (event.type == MapBrowserEventType.POINTERDOWN) {
	      this.trackedTouches_[event.pointerId] = true;
	    }
	    this.activePointers_ = Object.keys(this.trackedTouches_).length;
	  };
	
	  /**
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.handlePointerUp_ = function handlePointerUp_ (pointerEvent) {
	    this.updateActivePointers_(pointerEvent);
	    var newEvent = new MapBrowserPointerEvent(
	      MapBrowserEventType.POINTERUP, this.map_, pointerEvent);
	    this.dispatchEvent(newEvent);
	
	    // We emulate click events on left mouse button click, touch contact, and pen
	    // contact. isMouseActionButton returns true in these cases (evt.button is set
	    // to 0).
	    // See http://www.w3.org/TR/pointerevents/#button-states
	    // We only fire click, singleclick, and doubleclick if nobody has called
	    // event.stopPropagation() or event.preventDefault().
	    if (!newEvent.propagationStopped && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) {
	      this.emulateClick_(this.down_);
	    }
	
	    if (this.activePointers_ === 0) {
	      this.dragListenerKeys_.forEach(unlistenByKey);
	      this.dragListenerKeys_.length = 0;
	      this.dragging_ = false;
	      this.down_ = null;
	      this.documentPointerEventHandler_.dispose();
	      this.documentPointerEventHandler_ = null;
	    }
	  };
	
	  /**
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @return {boolean} If the left mouse button was pressed.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.isMouseActionButton_ = function isMouseActionButton_ (pointerEvent) {
	    return pointerEvent.button === 0;
	  };
	
	  /**
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.handlePointerDown_ = function handlePointerDown_ (pointerEvent) {
	    this.updateActivePointers_(pointerEvent);
	    var newEvent = new MapBrowserPointerEvent(
	      MapBrowserEventType.POINTERDOWN, this.map_, pointerEvent);
	    this.dispatchEvent(newEvent);
	
	    this.down_ = pointerEvent;
	
	    if (this.dragListenerKeys_.length === 0) {
	      /* Set up a pointer event handler on the `document`,
	       * which is required when the pointer is moved outside
	       * the viewport when dragging.
	       */
	      this.documentPointerEventHandler_ =
	          new PointerEventHandler(document);
	
	      this.dragListenerKeys_.push(
	        listen(this.documentPointerEventHandler_,
	          MapBrowserEventType.POINTERMOVE,
	          this.handlePointerMove_, this),
	        listen(this.documentPointerEventHandler_,
	          MapBrowserEventType.POINTERUP,
	          this.handlePointerUp_, this),
	        /* Note that the listener for `pointercancel is set up on
	         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
	         * the `pointerup` and `pointermove` listeners.
	         *
	         * The reason for this is the following: `TouchSource.vacuumTouches_()`
	         * issues `pointercancel` events, when there was no `touchend` for a
	         * `touchstart`. Now, let's say a first `touchstart` is registered on
	         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
	         * But `documentPointerEventHandler_` doesn't know about the first
	         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
	         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
	         * only registered there.
	         */
	        listen(this.pointerEventHandler_,
	          MapBrowserEventType.POINTERCANCEL,
	          this.handlePointerUp_, this)
	      );
	    }
	  };
	
	  /**
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.handlePointerMove_ = function handlePointerMove_ (pointerEvent) {
	    // Between pointerdown and pointerup, pointermove events are triggered.
	    // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
	    // moved a significant distance.
	    if (this.isMoving_(pointerEvent)) {
	      this.dragging_ = true;
	      var newEvent = new MapBrowserPointerEvent(
	        MapBrowserEventType.POINTERDRAG, this.map_, pointerEvent,
	        this.dragging_);
	      this.dispatchEvent(newEvent);
	    }
	
	    // Some native android browser triggers mousemove events during small period
	    // of time. See: https://code.google.com/p/android/issues/detail?id=5491 or
	    // https://code.google.com/p/android/issues/detail?id=19827
	    // ex: Galaxy Tab P3110 + Android 4.1.1
	    pointerEvent.preventDefault();
	  };
	
	  /**
	   * Wrap and relay a pointer event.  Note that this requires that the type
	   * string for the MapBrowserPointerEvent matches the PointerEvent type.
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.relayEvent_ = function relayEvent_ (pointerEvent) {
	    var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
	    this.dispatchEvent(new MapBrowserPointerEvent(
	      pointerEvent.type, this.map_, pointerEvent, dragging));
	  };
	
	  /**
	   * @param {import("./pointer/PointerEvent.js").default} pointerEvent Pointer
	   * event.
	   * @return {boolean} Is moving.
	   * @private
	   */
	  MapBrowserEventHandler.prototype.isMoving_ = function isMoving_ (pointerEvent) {
	    return this.dragging_ ||
	        Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ ||
	        Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MapBrowserEventHandler.prototype.disposeInternal = function disposeInternal () {
	    if (this.relayedListenerKey_) {
	      unlistenByKey(this.relayedListenerKey_);
	      this.relayedListenerKey_ = null;
	    }
	    if (this.pointerdownListenerKey_) {
	      unlistenByKey(this.pointerdownListenerKey_);
	      this.pointerdownListenerKey_ = null;
	    }
	
	    this.dragListenerKeys_.forEach(unlistenByKey);
	    this.dragListenerKeys_.length = 0;
	
	    if (this.documentPointerEventHandler_) {
	      this.documentPointerEventHandler_.dispose();
	      this.documentPointerEventHandler_ = null;
	    }
	    if (this.pointerEventHandler_) {
	      this.pointerEventHandler_.dispose();
	      this.pointerEventHandler_ = null;
	    }
	    EventTarget.prototype.disposeInternal.call(this);
	  };
	
	  return MapBrowserEventHandler;
	}(Target));
	
	/**
	 * @module ol/MapEventType
	 */
	
	/**
	 * @enum {string}
	 */
	var MapEventType = {
	
	  /**
	   * Triggered after a map frame is rendered.
	   * @event module:ol/MapEvent~MapEvent#postrender
	   * @api
	   */
	  POSTRENDER: 'postrender',
	
	  /**
	   * Triggered when the map starts moving.
	   * @event module:ol/MapEvent~MapEvent#movestart
	   * @api
	   */
	  MOVESTART: 'movestart',
	
	  /**
	   * Triggered after the map is moved.
	   * @event module:ol/MapEvent~MapEvent#moveend
	   * @api
	   */
	  MOVEEND: 'moveend'
	
	};
	
	/**
	 * @module ol/MapProperty
	 */
	
	/**
	 * @enum {string}
	 */
	var MapProperty = {
	  LAYERGROUP: 'layergroup',
	  SIZE: 'size',
	  TARGET: 'target',
	  VIEW: 'view'
	};
	
	/**
	 * @module ol/TileState
	 */
	
	/**
	 * @enum {number}
	 */
	var TileState = {
	  IDLE: 0,
	  LOADING: 1,
	  LOADED: 2,
	  /**
	   * Indicates that tile loading failed
	   * @type {number}
	   */
	  ERROR: 3,
	  EMPTY: 4,
	  ABORT: 5
	};
	
	/**
	 * @module ol/structs/PriorityQueue
	 */
	
	
	/**
	 * @type {number}
	 */
	var DROP = Infinity;
	
	
	/**
	 * @classdesc
	 * Priority queue.
	 *
	 * The implementation is inspired from the Closure Library's Heap class and
	 * Python's heapq module.
	 *
	 * See http://closure-library.googlecode.com/svn/docs/closure_goog_structs_heap.js.source.html
	 * and http://hg.python.org/cpython/file/2.7/Lib/heapq.py.
	 *
	 * @template T
	 */
	var PriorityQueue = function PriorityQueue(priorityFunction, keyFunction) {
	
	  /**
	   * @type {function(T): number}
	   * @private
	   */
	  this.priorityFunction_ = priorityFunction;
	
	  /**
	   * @type {function(T): string}
	   * @private
	   */
	  this.keyFunction_ = keyFunction;
	
	  /**
	   * @type {Array<T>}
	   * @private
	   */
	  this.elements_ = [];
	
	  /**
	   * @type {Array<number>}
	   * @private
	   */
	  this.priorities_ = [];
	
	  /**
	   * @type {!Object<string, boolean>}
	   * @private
	   */
	  this.queuedElements_ = {};
	
	};
	
	/**
	 * FIXME empty description for jsdoc
	 */
	PriorityQueue.prototype.clear = function clear$1 () {
	  this.elements_.length = 0;
	  this.priorities_.length = 0;
	  clear(this.queuedElements_);
	};
	
	
	/**
	 * Remove and return the highest-priority element. O(log N).
	 * @return {T} Element.
	 */
	PriorityQueue.prototype.dequeue = function dequeue () {
	  var elements = this.elements_;
	  var priorities = this.priorities_;
	  var element = elements[0];
	  if (elements.length == 1) {
	    elements.length = 0;
	    priorities.length = 0;
	  } else {
	    elements[0] = elements.pop();
	    priorities[0] = priorities.pop();
	    this.siftUp_(0);
	  }
	  var elementKey = this.keyFunction_(element);
	  delete this.queuedElements_[elementKey];
	  return element;
	};
	
	
	/**
	 * Enqueue an element. O(log N).
	 * @param {T} element Element.
	 * @return {boolean} The element was added to the queue.
	 */
	PriorityQueue.prototype.enqueue = function enqueue (element) {
	  assert(!(this.keyFunction_(element) in this.queuedElements_),
	    31); // Tried to enqueue an `element` that was already added to the queue
	  var priority = this.priorityFunction_(element);
	  if (priority != DROP) {
	    this.elements_.push(element);
	    this.priorities_.push(priority);
	    this.queuedElements_[this.keyFunction_(element)] = true;
	    this.siftDown_(0, this.elements_.length - 1);
	    return true;
	  }
	  return false;
	};
	
	
	/**
	 * @return {number} Count.
	 */
	PriorityQueue.prototype.getCount = function getCount () {
	  return this.elements_.length;
	};
	
	
	/**
	 * Gets the index of the left child of the node at the given index.
	 * @param {number} index The index of the node to get the left child for.
	 * @return {number} The index of the left child.
	 * @private
	 */
	PriorityQueue.prototype.getLeftChildIndex_ = function getLeftChildIndex_ (index) {
	  return index * 2 + 1;
	};
	
	
	/**
	 * Gets the index of the right child of the node at the given index.
	 * @param {number} index The index of the node to get the right child for.
	 * @return {number} The index of the right child.
	 * @private
	 */
	PriorityQueue.prototype.getRightChildIndex_ = function getRightChildIndex_ (index) {
	  return index * 2 + 2;
	};
	
	
	/**
	 * Gets the index of the parent of the node at the given index.
	 * @param {number} index The index of the node to get the parent for.
	 * @return {number} The index of the parent.
	 * @private
	 */
	PriorityQueue.prototype.getParentIndex_ = function getParentIndex_ (index) {
	  return (index - 1) >> 1;
	};
	
	
	/**
	 * Make this a heap. O(N).
	 * @private
	 */
	PriorityQueue.prototype.heapify_ = function heapify_ () {
	  var i;
	  for (i = (this.elements_.length >> 1) - 1; i >= 0; i--) {
	    this.siftUp_(i);
	  }
	};
	
	
	/**
	 * @return {boolean} Is empty.
	 */
	PriorityQueue.prototype.isEmpty = function isEmpty$$1 () {
	  return this.elements_.length === 0;
	};
	
	
	/**
	 * @param {string} key Key.
	 * @return {boolean} Is key queued.
	 */
	PriorityQueue.prototype.isKeyQueued = function isKeyQueued (key) {
	  return key in this.queuedElements_;
	};
	
	
	/**
	 * @param {T} element Element.
	 * @return {boolean} Is queued.
	 */
	PriorityQueue.prototype.isQueued = function isQueued (element) {
	  return this.isKeyQueued(this.keyFunction_(element));
	};
	
	
	/**
	 * @param {number} index The index of the node to move down.
	 * @private
	 */
	PriorityQueue.prototype.siftUp_ = function siftUp_ (index) {
	  var elements = this.elements_;
	  var priorities = this.priorities_;
	  var count = elements.length;
	  var element = elements[index];
	  var priority = priorities[index];
	  var startIndex = index;
	
	  while (index < (count >> 1)) {
	    var lIndex = this.getLeftChildIndex_(index);
	    var rIndex = this.getRightChildIndex_(index);
	
	    var smallerChildIndex = rIndex < count &&
	        priorities[rIndex] < priorities[lIndex] ?
	      rIndex : lIndex;
	
	    elements[index] = elements[smallerChildIndex];
	    priorities[index] = priorities[smallerChildIndex];
	    index = smallerChildIndex;
	  }
	
	  elements[index] = element;
	  priorities[index] = priority;
	  this.siftDown_(startIndex, index);
	};
	
	
	/**
	 * @param {number} startIndex The index of the root.
	 * @param {number} index The index of the node to move up.
	 * @private
	 */
	PriorityQueue.prototype.siftDown_ = function siftDown_ (startIndex, index) {
	  var elements = this.elements_;
	  var priorities = this.priorities_;
	  var element = elements[index];
	  var priority = priorities[index];
	
	  while (index > startIndex) {
	    var parentIndex = this.getParentIndex_(index);
	    if (priorities[parentIndex] > priority) {
	      elements[index] = elements[parentIndex];
	      priorities[index] = priorities[parentIndex];
	      index = parentIndex;
	    } else {
	      break;
	    }
	  }
	  elements[index] = element;
	  priorities[index] = priority;
	};
	
	
	/**
	 * FIXME empty description for jsdoc
	 */
	PriorityQueue.prototype.reprioritize = function reprioritize () {
	  var priorityFunction = this.priorityFunction_;
	  var elements = this.elements_;
	  var priorities = this.priorities_;
	  var index = 0;
	  var n = elements.length;
	  var element, i, priority;
	  for (i = 0; i < n; ++i) {
	    element = elements[i];
	    priority = priorityFunction(element);
	    if (priority == DROP) {
	      delete this.queuedElements_[this.keyFunction_(element)];
	    } else {
	      priorities[index] = priority;
	      elements[index++] = element;
	    }
	  }
	  elements.length = index;
	  priorities.length = index;
	  this.heapify_();
	};
	
	/**
	 * @module ol/TileQueue
	 */
	
	
	/**
	 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
	 */
	
	
	/**
	 * @api
	 */
	var TileQueue = /*@__PURE__*/(function (PriorityQueue$$1) {
	  function TileQueue(tilePriorityFunction, tileChangeCallback) {
	
	    PriorityQueue$$1.call(
	      /**
	       * @param {Array} element Element.
	       * @return {number} Priority.
	       */
	      this, function(element) {
	        return tilePriorityFunction.apply(null, element);
	      },
	      /**
	       * @param {Array} element Element.
	       * @return {string} Key.
	       */
	      function(element) {
	        return (/** @type {import("./Tile.js").default} */ (element[0]).getKey());
	      });
	
	    /**
	     * @private
	     * @type {function(): ?}
	     */
	    this.tileChangeCallback_ = tileChangeCallback;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.tilesLoading_ = 0;
	
	    /**
	     * @private
	     * @type {!Object<string,boolean>}
	     */
	    this.tilesLoadingKeys_ = {};
	
	  }
	
	  if ( PriorityQueue$$1 ) { TileQueue.__proto__ = PriorityQueue$$1; }
	  TileQueue.prototype = Object.create( PriorityQueue$$1 && PriorityQueue$$1.prototype );
	  TileQueue.prototype.constructor = TileQueue;
	
	  /**
	   * @inheritDoc
	   */
	  TileQueue.prototype.enqueue = function enqueue (element) {
	    var added = PriorityQueue$$1.prototype.enqueue.call(this, element);
	    if (added) {
	      var tile = element[0];
	      listen(tile, EventType.CHANGE, this.handleTileChange, this);
	    }
	    return added;
	  };
	
	  /**
	   * @return {number} Number of tiles loading.
	   */
	  TileQueue.prototype.getTilesLoading = function getTilesLoading () {
	    return this.tilesLoading_;
	  };
	
	  /**
	   * @param {import("./events/Event.js").default} event Event.
	   * @protected
	   */
	  TileQueue.prototype.handleTileChange = function handleTileChange (event) {
	    var tile = /** @type {import("./Tile.js").default} */ (event.target);
	    var state = tile.getState();
	    if (state === TileState.LOADED || state === TileState.ERROR ||
	        state === TileState.EMPTY || state === TileState.ABORT) {
	      unlisten(tile, EventType.CHANGE, this.handleTileChange, this);
	      var tileKey = tile.getKey();
	      if (tileKey in this.tilesLoadingKeys_) {
	        delete this.tilesLoadingKeys_[tileKey];
	        --this.tilesLoading_;
	      }
	      this.tileChangeCallback_();
	    }
	  };
	
	  /**
	   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
	   * @param {number} maxNewLoads Maximum number of new tiles to load.
	   */
	  TileQueue.prototype.loadMoreTiles = function loadMoreTiles (maxTotalLoading, maxNewLoads) {
	    var newLoads = 0;
	    var abortedTiles = false;
	    var state, tile, tileKey;
	    while (this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads &&
	           this.getCount() > 0) {
	      tile = /** @type {import("./Tile.js").default} */ (this.dequeue()[0]);
	      tileKey = tile.getKey();
	      state = tile.getState();
	      if (state === TileState.ABORT) {
	        abortedTiles = true;
	      } else if (state === TileState.IDLE && !(tileKey in this.tilesLoadingKeys_)) {
	        this.tilesLoadingKeys_[tileKey] = true;
	        ++this.tilesLoading_;
	        ++newLoads;
	        tile.load();
	      }
	    }
	    if (newLoads === 0 && abortedTiles) {
	      // Do not stop the render loop when all wanted tiles were aborted due to
	      // a small, saturated tile cache.
	      this.tileChangeCallback_();
	    }
	  };
	
	  return TileQueue;
	}(PriorityQueue));
	
	/**
	 * @module ol/tilegrid/common
	 */
	
	/**
	 * Default maximum zoom for default tile grids.
	 * @type {number}
	 */
	var DEFAULT_MAX_ZOOM = 42;
	
	/**
	 * Default tile size.
	 * @type {number}
	 */
	var DEFAULT_TILE_SIZE = 256;
	
	/**
	 * @module ol/centerconstraint
	 */
	
	
	/**
	 * @typedef {function((import("./coordinate.js").Coordinate|undefined)): (import("./coordinate.js").Coordinate|undefined)} Type
	 */
	
	
	/**
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @return {Type} The constraint.
	 */
	function createExtent(extent) {
	  return (
	    /**
	     * @param {import("./coordinate.js").Coordinate=} center Center.
	     * @return {import("./coordinate.js").Coordinate|undefined} Center.
	     */
	    function(center) {
	      if (center) {
	        return [
	          clamp(center[0], extent[0], extent[2]),
	          clamp(center[1], extent[1], extent[3])
	        ];
	      } else {
	        return undefined;
	      }
	    }
	  );
	}
	
	
	/**
	 * @param {import("./coordinate.js").Coordinate=} center Center.
	 * @return {import("./coordinate.js").Coordinate|undefined} Center.
	 */
	function none(center) {
	  return center;
	}
	
	/**
	 * @module ol/resolutionconstraint
	 */
	
	
	/**
	 * @typedef {function((number|undefined), number, number): (number|undefined)} Type
	 */
	
	
	/**
	 * @param {Array<number>} resolutions Resolutions.
	 * @return {Type} Zoom function.
	 */
	function createSnapToResolutions(resolutions) {
	  return (
	    /**
	     * @param {number|undefined} resolution Resolution.
	     * @param {number} delta Delta.
	     * @param {number} direction Direction.
	     * @return {number|undefined} Resolution.
	     */
	    function(resolution, delta, direction) {
	      if (resolution !== undefined) {
	        var z = linearFindNearest(resolutions, resolution, direction);
	        z = clamp(z + delta, 0, resolutions.length - 1);
	        var index = Math.floor(z);
	        if (z != index && index < resolutions.length - 1) {
	          var power = resolutions[index] / resolutions[index + 1];
	          return resolutions[index] / Math.pow(power, z - index);
	        } else {
	          return resolutions[index];
	        }
	      } else {
	        return undefined;
	      }
	    }
	  );
	}
	
	
	/**
	 * @param {number} power Power.
	 * @param {number} maxResolution Maximum resolution.
	 * @param {number=} opt_maxLevel Maximum level.
	 * @return {Type} Zoom function.
	 */
	function createSnapToPower(power, maxResolution, opt_maxLevel) {
	  return (
	    /**
	     * @param {number|undefined} resolution Resolution.
	     * @param {number} delta Delta.
	     * @param {number} direction Direction.
	     * @return {number|undefined} Resolution.
	     */
	    function(resolution, delta, direction) {
	      if (resolution !== undefined) {
	        var offset = -direction / 2 + 0.5;
	        var oldLevel = Math.floor(
	          Math.log(maxResolution / resolution) / Math.log(power) + offset);
	        var newLevel = Math.max(oldLevel + delta, 0);
	        if (opt_maxLevel !== undefined) {
	          newLevel = Math.min(newLevel, opt_maxLevel);
	        }
	        return maxResolution / Math.pow(power, newLevel);
	      } else {
	        return undefined;
	      }
	    });
	}
	
	/**
	 * @module ol/rotationconstraint
	 */
	
	
	/**
	 * @typedef {function((number|undefined), number): (number|undefined)} Type
	 */
	
	
	/**
	 * @param {number|undefined} rotation Rotation.
	 * @param {number} delta Delta.
	 * @return {number|undefined} Rotation.
	 */
	function disable(rotation, delta) {
	  if (rotation !== undefined) {
	    return 0;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {number|undefined} rotation Rotation.
	 * @param {number} delta Delta.
	 * @return {number|undefined} Rotation.
	 */
	function none$1(rotation, delta) {
	  if (rotation !== undefined) {
	    return rotation + delta;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {number} n N.
	 * @return {Type} Rotation constraint.
	 */
	function createSnapToN(n) {
	  var theta = 2 * Math.PI / n;
	  return (
	    /**
	     * @param {number|undefined} rotation Rotation.
	     * @param {number} delta Delta.
	     * @return {number|undefined} Rotation.
	     */
	    function(rotation, delta) {
	      if (rotation !== undefined) {
	        rotation = Math.floor((rotation + delta) / theta + 0.5) * theta;
	        return rotation;
	      } else {
	        return undefined;
	      }
	    });
	}
	
	
	/**
	 * @param {number=} opt_tolerance Tolerance.
	 * @return {Type} Rotation constraint.
	 */
	function createSnapToZero(opt_tolerance) {
	  var tolerance = opt_tolerance || toRadians(5);
	  return (
	    /**
	     * @param {number|undefined} rotation Rotation.
	     * @param {number} delta Delta.
	     * @return {number|undefined} Rotation.
	     */
	    function(rotation, delta) {
	      if (rotation !== undefined) {
	        if (Math.abs(rotation + delta) <= tolerance) {
	          return 0;
	        } else {
	          return rotation + delta;
	        }
	      } else {
	        return undefined;
	      }
	    });
	}
	
	/**
	 * @module ol/ViewHint
	 */
	
	/**
	 * @api
	 * @kind constant
	 * @name ViewHint
	 */
	var ViewHint = {
	  ANIMATING: 0,
	  INTERACTING: 1
	};
	
	/**
	 * @module ol/ViewProperty
	 */
	
	/**
	 * @enum {string}
	 */
	var ViewProperty = {
	  CENTER: 'center',
	  RESOLUTION: 'resolution',
	  ROTATION: 'rotation'
	};
	
	/**
	 * @module ol/easing
	 */
	
	
	/**
	 * Start slow and speed up.
	 * @param {number} t Input between 0 and 1.
	 * @return {number} Output between 0 and 1.
	 * @api
	 */
	function easeIn(t) {
	  return Math.pow(t, 3);
	}
	
	
	/**
	 * Start fast and slow down.
	 * @param {number} t Input between 0 and 1.
	 * @return {number} Output between 0 and 1.
	 * @api
	 */
	function easeOut(t) {
	  return 1 - easeIn(1 - t);
	}
	
	
	/**
	 * Start slow, speed up, and then slow down again.
	 * @param {number} t Input between 0 and 1.
	 * @return {number} Output between 0 and 1.
	 * @api
	 */
	function inAndOut(t) {
	  return 3 * t * t - 2 * t * t * t;
	}
	
	
	/**
	 * Maintain a constant speed over time.
	 * @param {number} t Input between 0 and 1.
	 * @return {number} Output between 0 and 1.
	 * @api
	 */
	function linear(t) {
	  return t;
	}
	
	
	/**
	 * Start slow, speed up, and at the very end slow down again.  This has the
	 * same general behavior as {@link module:ol/easing~inAndOut}, but the final
	 * slowdown is delayed.
	 * @param {number} t Input between 0 and 1.
	 * @return {number} Output between 0 and 1.
	 * @api
	 */
	function upAndDown(t) {
	  if (t < 0.5) {
	    return inAndOut(2 * t);
	  } else {
	    return 1 - inAndOut(2 * (t - 0.5));
	  }
	}
	
	/**
	 * @module ol/View
	 */
	
	
	/**
	 * An animation configuration
	 *
	 * @typedef {Object} Animation
	 * @property {import("./coordinate.js").Coordinate} [sourceCenter]
	 * @property {import("./coordinate.js").Coordinate} [targetCenter]
	 * @property {number} [sourceResolution]
	 * @property {number} [targetResolution]
	 * @property {number} [sourceRotation]
	 * @property {number} [targetRotation]
	 * @property {import("./coordinate.js").Coordinate} [anchor]
	 * @property {number} start
	 * @property {number} duration
	 * @property {boolean} complete
	 * @property {function(number):number} easing
	 * @property {function(boolean)} callback
	 */
	
	
	/**
	 * @typedef {Object} Constraints
	 * @property {import("./centerconstraint.js").Type} center
	 * @property {import("./resolutionconstraint.js").Type} resolution
	 * @property {import("./rotationconstraint.js").Type} rotation
	 */
	
	
	/**
	 * @typedef {Object} FitOptions
	 * @property {import("./size.js").Size} [size] The size in pixels of the box to fit
	 * the extent into. Default is the current size of the first map in the DOM that
	 * uses this view, or `[100, 100]` if no such map is found.
	 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
	 * cleared inside the view. Values in the array are top, right, bottom and left
	 * padding.
	 * @property {boolean} [constrainResolution=true] Constrain the resolution.
	 * @property {boolean} [nearest=false] If `constrainResolution` is `true`, get
	 * the nearest extent instead of the closest that actually fits the view.
	 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
	 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
	 * `minResolution` is given, this property is ignored.
	 * @property {number} [duration] The duration of the animation in milliseconds.
	 * By default, there is no animation to the target extent.
	 * @property {function(number):number} [easing] The easing function used during
	 * the animation (defaults to {@link module:ol/easing~inAndOut}).
	 * The function will be called for each frame with a number representing a
	 * fraction of the animation's duration.  The function should return a number
	 * between 0 and 1 representing the progress toward the destination state.
	 * @property {function(boolean)} [callback] Function called when the view is in
	 * its final position. The callback will be called with `true` if the animation
	 * series completed on its own or `false` if it was cancelled.
	 */
	
	
	/**
	 * @typedef {Object} ViewOptions
	 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
	 * the view. The coordinate system for the center is specified with the
	 * `projection` option. Layer sources will not be fetched if this is not set,
	 * but the center can be set later with {@link #setCenter}.
	 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
	 * `false` means no constraint. `true` means no constraint, but snap to zero
	 * near zero. A number constrains the rotation to that number of values. For
	 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
	 * @property {boolean} [enableRotation=true] Enable rotation.
	 * If `false`, a rotation constraint that always sets the rotation to zero is
	 * used. The `constrainRotation` option has no effect if `enableRotation` is
	 * `false`.
	 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
	 * center, in other words, center cannot be set outside this extent.
	 * @property {number} [maxResolution] The maximum resolution used to determine
	 * the resolution constraint. It is used together with `minResolution` (or
	 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
	 * that the projection's validity extent fits in a 256x256 px tile. If the
	 * projection is Spherical Mercator (the default) then `maxResolution` defaults
	 * to `40075016.68557849 / 256 = 156543.03392804097`.
	 * @property {number} [minResolution] The minimum resolution used to determine
	 * the resolution constraint.  It is used together with `maxResolution` (or
	 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
	 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
	 * (the default) then `minResolution` defaults to
	 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
	 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
	 * resolution constraint. It is used together with `minZoom` (or
	 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
	 * provided, it is given precedence over `maxZoom`.
	 * @property {number} [minZoom=0] The minimum zoom level used to determine the
	 * resolution constraint. It is used together with `maxZoom` (or
	 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
	 * provided, it is given precedence over `minZoom`.
	 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
	 * projection. The default is Spherical Mercator.
	 * @property {number} [resolution] The initial resolution for the view. The
	 * units are `projection` units per pixel (e.g. meters per pixel). An
	 * alternative to setting this is to set `zoom`. Layer sources will not be
	 * fetched if neither this nor `zoom` are defined, but they can be set later
	 * with {@link #setZoom} or {@link #setResolution}.
	 * @property {Array<number>} [resolutions] Resolutions to determine the
	 * resolution constraint. If set the `maxResolution`, `minResolution`,
	 * `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
	 * @property {number} [rotation=0] The initial rotation for the view in radians
	 * (positive rotation clockwise, 0 means North).
	 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
	 * level used to calculate the initial resolution for the view. The initial
	 * resolution is determined using the {@link #constrainResolution} method.
	 * @property {number} [zoomFactor=2] The zoom factor used to determine the
	 * resolution constraint.
	 */
	
	
	/**
	 * @typedef {Object} AnimationOptions
	 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
	 * the animation.
	 * @property {number} [zoom] The zoom level of the view at the end of the
	 * animation. This takes precedence over `resolution`.
	 * @property {number} [resolution] The resolution of the view at the end
	 * of the animation.  If `zoom` is also provided, this option will be ignored.
	 * @property {number} [rotation] The rotation of the view at the end of
	 * the animation.
	 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remained fixed
	 * during a rotation or resolution animation.
	 * @property {number} [duration=1000] The duration of the animation in milliseconds.
	 * @property {function(number):number} [easing] The easing function used
	 * during the animation (defaults to {@link module:ol/easing~inAndOut}).
	 * The function will be called for each frame with a number representing a
	 * fraction of the animation's duration.  The function should return a number
	 * between 0 and 1 representing the progress toward the destination state.
	 */
	
	
	/**
	 * @typedef {Object} State
	 * @property {import("./coordinate.js").Coordinate} center
	 * @property {import("./proj/Projection.js").default} projection
	 * @property {number} resolution
	 * @property {number} rotation
	 * @property {number} zoom
	 */
	
	
	/**
	 * Default min zoom level for the map view.
	 * @type {number}
	 */
	var DEFAULT_MIN_ZOOM = 0;
	
	
	/**
	 * @classdesc
	 * A View object represents a simple 2D view of the map.
	 *
	 * This is the object to act upon to change the center, resolution,
	 * and rotation of the map.
	 *
	 * ### The view states
	 *
	 * An View is determined by three states: `center`, `resolution`,
	 * and `rotation`. Each state has a corresponding getter and setter, e.g.
	 * `getCenter` and `setCenter` for the `center` state.
	 *
	 * An View has a `projection`. The projection determines the
	 * coordinate system of the center, and its units determine the units of the
	 * resolution (projection units per pixel). The default projection is
	 * Spherical Mercator (EPSG:3857).
	 *
	 * ### The constraints
	 *
	 * `setCenter`, `setResolution` and `setRotation` can be used to change the
	 * states of the view. Any value can be passed to the setters. And the value
	 * that is passed to a setter will effectively be the value set in the view,
	 * and returned by the corresponding getter.
	 *
	 * But a View object also has a *resolution constraint*, a
	 * *rotation constraint* and a *center constraint*.
	 *
	 * As said above, no constraints are applied when the setters are used to set
	 * new states for the view. Applying constraints is done explicitly through
	 * the use of the `constrain*` functions (`constrainResolution` and
	 * `constrainRotation` and `constrainCenter`).
	 *
	 * The main users of the constraints are the interactions and the
	 * controls. For example, double-clicking on the map changes the view to
	 * the "next" resolution. And releasing the fingers after pinch-zooming
	 * snaps to the closest resolution (with an animation).
	 *
	 * The *resolution constraint* snaps to specific resolutions. It is
	 * determined by the following options: `resolutions`, `maxResolution`,
	 * `maxZoom`, and `zoomFactor`. If `resolutions` is set, the other three
	 * options are ignored. See documentation for each option for more
	 * information.
	 *
	 * The *rotation constraint* snaps to specific angles. It is determined
	 * by the following options: `enableRotation` and `constrainRotation`.
	 * By default the rotation value is snapped to zero when approaching the
	 * horizontal.
	 *
	 * The *center constraint* is determined by the `extent` option. By
	 * default the center is not constrained at all.
	 *
	  * @api
	 */
	var View = /*@__PURE__*/(function (BaseObject$$1) {
	  function View(opt_options) {
	    BaseObject$$1.call(this);
	
	    var options = assign({}, opt_options);
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.hints_ = [0, 0];
	
	    /**
	     * @private
	     * @type {Array<Array<Animation>>}
	     */
	    this.animations_ = [];
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.updateAnimationKey_;
	
	    this.updateAnimations_ = this.updateAnimations_.bind(this);
	
	    /**
	     * @private
	     * @const
	     * @type {import("./proj/Projection.js").default}
	     */
	    this.projection_ = createProjection(options.projection, 'EPSG:3857');
	
	    this.applyOptions_(options);
	  }
	
	  if ( BaseObject$$1 ) { View.__proto__ = BaseObject$$1; }
	  View.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  View.prototype.constructor = View;
	
	  /**
	   * Set up the view with the given options.
	   * @param {ViewOptions} options View options.
	   */
	  View.prototype.applyOptions_ = function applyOptions_ (options) {
	
	    /**
	     * @type {Object<string, *>}
	     */
	    var properties = {};
	    properties[ViewProperty.CENTER] = options.center !== undefined ?
	      options.center : null;
	
	    var resolutionConstraintInfo = createResolutionConstraint(options);
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxResolution_ = resolutionConstraintInfo.maxResolution;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.minResolution_ = resolutionConstraintInfo.minResolution;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
	
	    /**
	     * @private
	     * @type {Array<number>|undefined}
	     */
	    this.resolutions_ = options.resolutions;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.minZoom_ = resolutionConstraintInfo.minZoom;
	
	    var centerConstraint = createCenterConstraint(options);
	    var resolutionConstraint = resolutionConstraintInfo.constraint;
	    var rotationConstraint = createRotationConstraint(options);
	
	    /**
	     * @private
	     * @type {Constraints}
	     */
	    this.constraints_ = {
	      center: centerConstraint,
	      resolution: resolutionConstraint,
	      rotation: rotationConstraint
	    };
	
	    if (options.resolution !== undefined) {
	      properties[ViewProperty.RESOLUTION] = options.resolution;
	    } else if (options.zoom !== undefined) {
	      properties[ViewProperty.RESOLUTION] = this.constrainResolution(
	        this.maxResolution_, options.zoom - this.minZoom_);
	
	      if (this.resolutions_) { // in case map zoom is out of min/max zoom range
	        properties[ViewProperty.RESOLUTION] = clamp(
	          Number(this.getResolution() || properties[ViewProperty.RESOLUTION]),
	          this.minResolution_, this.maxResolution_);
	      }
	    }
	    properties[ViewProperty.ROTATION] = options.rotation !== undefined ? options.rotation : 0;
	    this.setProperties(properties);
	
	    /**
	     * @private
	     * @type {ViewOptions}
	     */
	    this.options_ = options;
	
	  };
	
	  /**
	   * Get an updated version of the view options used to construct the view.  The
	   * current resolution (or zoom), center, and rotation are applied to any stored
	   * options.  The provided options can be used to apply new min/max zoom or
	   * resolution limits.
	   * @param {ViewOptions} newOptions New options to be applied.
	   * @return {ViewOptions} New options updated with the current view state.
	   */
	  View.prototype.getUpdatedOptions_ = function getUpdatedOptions_ (newOptions) {
	    var options = assign({}, this.options_);
	
	    // preserve resolution (or zoom)
	    if (options.resolution !== undefined) {
	      options.resolution = this.getResolution();
	    } else {
	      options.zoom = this.getZoom();
	    }
	
	    // preserve center
	    options.center = this.getCenter();
	
	    // preserve rotation
	    options.rotation = this.getRotation();
	
	    return assign({}, options, newOptions);
	  };
	
	  /**
	   * Animate the view.  The view's center, zoom (or resolution), and rotation
	   * can be animated for smooth transitions between view states.  For example,
	   * to animate the view to a new zoom level:
	   *
	   *     view.animate({zoom: view.getZoom() + 1});
	   *
	   * By default, the animation lasts one second and uses in-and-out easing.  You
	   * can customize this behavior by including `duration` (in milliseconds) and
	   * `easing` options (see {@link module:ol/easing}).
	   *
	   * To chain together multiple animations, call the method with multiple
	   * animation objects.  For example, to first zoom and then pan:
	   *
	   *     view.animate({zoom: 10}, {center: [0, 0]});
	   *
	   * If you provide a function as the last argument to the animate method, it
	   * will get called at the end of an animation series.  The callback will be
	   * called with `true` if the animation series completed on its own or `false`
	   * if it was cancelled.
	   *
	   * Animations are cancelled by user interactions (e.g. dragging the map) or by
	   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
	   * (or another method that calls one of these).
	   *
	   * @param {...(AnimationOptions|function(boolean))} var_args Animation
	   *     options.  Multiple animations can be run in series by passing multiple
	   *     options objects.  To run multiple animations in parallel, call the method
	   *     multiple times.  An optional callback can be provided as a final
	   *     argument.  The callback will be called with a boolean indicating whether
	   *     the animation completed without being cancelled.
	   * @api
	   */
	  View.prototype.animate = function animate (var_args) {
	    var arguments$1 = arguments;
	
	    var animationCount = arguments.length;
	    var callback;
	    if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
	      callback = arguments[animationCount - 1];
	      --animationCount;
	    }
	    if (!this.isDef()) {
	      // if view properties are not yet set, shortcut to the final state
	      var state = arguments[animationCount - 1];
	      if (state.center) {
	        this.setCenter(state.center);
	      }
	      if (state.zoom !== undefined) {
	        this.setZoom(state.zoom);
	      }
	      if (state.rotation !== undefined) {
	        this.setRotation(state.rotation);
	      }
	      if (callback) {
	        animationCallback(callback, true);
	      }
	      return;
	    }
	    var start = Date.now();
	    var center = this.getCenter().slice();
	    var resolution = this.getResolution();
	    var rotation = this.getRotation();
	    var series = [];
	    for (var i = 0; i < animationCount; ++i) {
	      var options = /** @type {AnimationOptions} */ (arguments$1[i]);
	
	      var animation = /** @type {Animation} */ ({
	        start: start,
	        complete: false,
	        anchor: options.anchor,
	        duration: options.duration !== undefined ? options.duration : 1000,
	        easing: options.easing || inAndOut
	      });
	
	      if (options.center) {
	        animation.sourceCenter = center;
	        animation.targetCenter = options.center;
	        center = animation.targetCenter;
	      }
	
	      if (options.zoom !== undefined) {
	        animation.sourceResolution = resolution;
	        animation.targetResolution = this.constrainResolution(
	          this.maxResolution_, options.zoom - this.minZoom_, 0);
	        resolution = animation.targetResolution;
	      } else if (options.resolution) {
	        animation.sourceResolution = resolution;
	        animation.targetResolution = options.resolution;
	        resolution = animation.targetResolution;
	      }
	
	      if (options.rotation !== undefined) {
	        animation.sourceRotation = rotation;
	        var delta = modulo(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
	        animation.targetRotation = rotation + delta;
	        rotation = animation.targetRotation;
	      }
	
	      animation.callback = callback;
	
	      // check if animation is a no-op
	      if (isNoopAnimation(animation)) {
	        animation.complete = true;
	        // we still push it onto the series for callback handling
	      } else {
	        start += animation.duration;
	      }
	      series.push(animation);
	    }
	    this.animations_.push(series);
	    this.setHint(ViewHint.ANIMATING, 1);
	    this.updateAnimations_();
	  };
	
	  /**
	   * Determine if the view is being animated.
	   * @return {boolean} The view is being animated.
	   * @api
	   */
	  View.prototype.getAnimating = function getAnimating () {
	    return this.hints_[ViewHint.ANIMATING] > 0;
	  };
	
	  /**
	   * Determine if the user is interacting with the view, such as panning or zooming.
	   * @return {boolean} The view is being interacted with.
	   * @api
	   */
	  View.prototype.getInteracting = function getInteracting () {
	    return this.hints_[ViewHint.INTERACTING] > 0;
	  };
	
	  /**
	   * Cancel any ongoing animations.
	   * @api
	   */
	  View.prototype.cancelAnimations = function cancelAnimations () {
	    this.setHint(ViewHint.ANIMATING, -this.hints_[ViewHint.ANIMATING]);
	    for (var i = 0, ii = this.animations_.length; i < ii; ++i) {
	      var series = this.animations_[i];
	      if (series[0].callback) {
	        animationCallback(series[0].callback, false);
	      }
	    }
	    this.animations_.length = 0;
	  };
	
	  /**
	   * Update all animations.
	   */
	  View.prototype.updateAnimations_ = function updateAnimations_ () {
	    if (this.updateAnimationKey_ !== undefined) {
	      cancelAnimationFrame(this.updateAnimationKey_);
	      this.updateAnimationKey_ = undefined;
	    }
	    if (!this.getAnimating()) {
	      return;
	    }
	    var now = Date.now();
	    var more = false;
	    for (var i = this.animations_.length - 1; i >= 0; --i) {
	      var series = this.animations_[i];
	      var seriesComplete = true;
	      for (var j = 0, jj = series.length; j < jj; ++j) {
	        var animation = series[j];
	        if (animation.complete) {
	          continue;
	        }
	        var elapsed = now - animation.start;
	        var fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
	        if (fraction >= 1) {
	          animation.complete = true;
	          fraction = 1;
	        } else {
	          seriesComplete = false;
	        }
	        var progress = animation.easing(fraction);
	        if (animation.sourceCenter) {
	          var x0 = animation.sourceCenter[0];
	          var y0 = animation.sourceCenter[1];
	          var x1 = animation.targetCenter[0];
	          var y1 = animation.targetCenter[1];
	          var x = x0 + progress * (x1 - x0);
	          var y = y0 + progress * (y1 - y0);
	          this.set(ViewProperty.CENTER, [x, y]);
	        }
	        if (animation.sourceResolution && animation.targetResolution) {
	          var resolution = progress === 1 ?
	            animation.targetResolution :
	            animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
	          if (animation.anchor) {
	            this.set(ViewProperty.CENTER,
	              this.calculateCenterZoom(resolution, animation.anchor));
	          }
	          this.set(ViewProperty.RESOLUTION, resolution);
	        }
	        if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
	          var rotation = progress === 1 ?
	            modulo(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI :
	            animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
	          if (animation.anchor) {
	            this.set(ViewProperty.CENTER,
	              this.calculateCenterRotate(rotation, animation.anchor));
	          }
	          this.set(ViewProperty.ROTATION, rotation);
	        }
	        more = true;
	        if (!animation.complete) {
	          break;
	        }
	      }
	      if (seriesComplete) {
	        this.animations_[i] = null;
	        this.setHint(ViewHint.ANIMATING, -1);
	        var callback = series[0].callback;
	        if (callback) {
	          animationCallback(callback, true);
	        }
	      }
	    }
	    // prune completed series
	    this.animations_ = this.animations_.filter(Boolean);
	    if (more && this.updateAnimationKey_ === undefined) {
	      this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_);
	    }
	  };
	
	  /**
	   * @param {number} rotation Target rotation.
	   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
	   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
	   */
	  View.prototype.calculateCenterRotate = function calculateCenterRotate (rotation, anchor) {
	    var center;
	    var currentCenter = this.getCenter();
	    if (currentCenter !== undefined) {
	      center = [currentCenter[0] - anchor[0], currentCenter[1] - anchor[1]];
	      rotate$2(center, rotation - this.getRotation());
	      add$2(center, anchor);
	    }
	    return center;
	  };
	
	  /**
	   * @param {number} resolution Target resolution.
	   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
	   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
	   */
	  View.prototype.calculateCenterZoom = function calculateCenterZoom (resolution, anchor) {
	    var center;
	    var currentCenter = this.getCenter();
	    var currentResolution = this.getResolution();
	    if (currentCenter !== undefined && currentResolution !== undefined) {
	      var x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
	      var y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
	      center = [x, y];
	    }
	    return center;
	  };
	
	  /**
	   * @private
	   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
	   */
	  View.prototype.getSizeFromViewport_ = function getSizeFromViewport_ () {
	    var size = [100, 100];
	    var selector = '.ol-viewport[data-view="' + getUid(this) + '"]';
	    var element = document.querySelector(selector);
	    if (element) {
	      var metrics = getComputedStyle(element);
	      size[0] = parseInt(metrics.width, 10);
	      size[1] = parseInt(metrics.height, 10);
	    }
	    return size;
	  };
	
	  /**
	   * Get the constrained center of this view.
	   * @param {import("./coordinate.js").Coordinate|undefined} center Center.
	   * @return {import("./coordinate.js").Coordinate|undefined} Constrained center.
	   * @api
	   */
	  View.prototype.constrainCenter = function constrainCenter (center) {
	    return this.constraints_.center(center);
	  };
	
	  /**
	   * Get the constrained resolution of this view.
	   * @param {number|undefined} resolution Resolution.
	   * @param {number=} opt_delta Delta. Default is `0`.
	   * @param {number=} opt_direction Direction. Default is `0`.
	   * @return {number|undefined} Constrained resolution.
	   * @api
	   */
	  View.prototype.constrainResolution = function constrainResolution (resolution, opt_delta, opt_direction) {
	    var delta = opt_delta || 0;
	    var direction = opt_direction || 0;
	    return this.constraints_.resolution(resolution, delta, direction);
	  };
	
	  /**
	   * Get the constrained rotation of this view.
	   * @param {number|undefined} rotation Rotation.
	   * @param {number=} opt_delta Delta. Default is `0`.
	   * @return {number|undefined} Constrained rotation.
	   * @api
	   */
	  View.prototype.constrainRotation = function constrainRotation (rotation, opt_delta) {
	    var delta = opt_delta || 0;
	    return this.constraints_.rotation(rotation, delta);
	  };
	
	  /**
	   * Get the view center.
	   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
	   * @observable
	   * @api
	   */
	  View.prototype.getCenter = function getCenter$$1 () {
	    return (
	      /** @type {import("./coordinate.js").Coordinate|undefined} */ (this.get(ViewProperty.CENTER))
	    );
	  };
	
	  /**
	   * @return {Constraints} Constraints.
	   */
	  View.prototype.getConstraints = function getConstraints () {
	    return this.constraints_;
	  };
	
	  /**
	   * @param {Array<number>=} opt_hints Destination array.
	   * @return {Array<number>} Hint.
	   */
	  View.prototype.getHints = function getHints (opt_hints) {
	    if (opt_hints !== undefined) {
	      opt_hints[0] = this.hints_[0];
	      opt_hints[1] = this.hints_[1];
	      return opt_hints;
	    } else {
	      return this.hints_.slice();
	    }
	  };
	
	  /**
	   * Calculate the extent for the current view state and the passed size.
	   * The size is the pixel dimensions of the box into which the calculated extent
	   * should fit. In most cases you want to get the extent of the entire map,
	   * that is `map.getSize()`.
	   * @param {import("./size.js").Size=} opt_size Box pixel size. If not provided, the size of the
	   * first map that uses this view will be used.
	   * @return {import("./extent.js").Extent} Extent.
	   * @api
	   */
	  View.prototype.calculateExtent = function calculateExtent (opt_size) {
	    var size = opt_size || this.getSizeFromViewport_();
	    var center = /** @type {!import("./coordinate.js").Coordinate} */ (this.getCenter());
	    assert(center, 1); // The view center is not defined
	    var resolution = /** @type {!number} */ (this.getResolution());
	    assert(resolution !== undefined, 2); // The view resolution is not defined
	    var rotation = /** @type {!number} */ (this.getRotation());
	    assert(rotation !== undefined, 3); // The view rotation is not defined
	
	    return getForViewAndSize(center, resolution, rotation, size);
	  };
	
	  /**
	   * Get the maximum resolution of the view.
	   * @return {number} The maximum resolution of the view.
	   * @api
	   */
	  View.prototype.getMaxResolution = function getMaxResolution () {
	    return this.maxResolution_;
	  };
	
	  /**
	   * Get the minimum resolution of the view.
	   * @return {number} The minimum resolution of the view.
	   * @api
	   */
	  View.prototype.getMinResolution = function getMinResolution () {
	    return this.minResolution_;
	  };
	
	  /**
	   * Get the maximum zoom level for the view.
	   * @return {number} The maximum zoom level.
	   * @api
	   */
	  View.prototype.getMaxZoom = function getMaxZoom () {
	    return /** @type {number} */ (this.getZoomForResolution(this.minResolution_));
	  };
	
	  /**
	   * Set a new maximum zoom level for the view.
	   * @param {number} zoom The maximum zoom level.
	   * @api
	   */
	  View.prototype.setMaxZoom = function setMaxZoom (zoom) {
	    this.applyOptions_(this.getUpdatedOptions_({maxZoom: zoom}));
	  };
	
	  /**
	   * Get the minimum zoom level for the view.
	   * @return {number} The minimum zoom level.
	   * @api
	   */
	  View.prototype.getMinZoom = function getMinZoom () {
	    return /** @type {number} */ (this.getZoomForResolution(this.maxResolution_));
	  };
	
	  /**
	   * Set a new minimum zoom level for the view.
	   * @param {number} zoom The minimum zoom level.
	   * @api
	   */
	  View.prototype.setMinZoom = function setMinZoom (zoom) {
	    this.applyOptions_(this.getUpdatedOptions_({minZoom: zoom}));
	  };
	
	  /**
	   * Get the view projection.
	   * @return {import("./proj/Projection.js").default} The projection of the view.
	   * @api
	   */
	  View.prototype.getProjection = function getProjection () {
	    return this.projection_;
	  };
	
	  /**
	   * Get the view resolution.
	   * @return {number|undefined} The resolution of the view.
	   * @observable
	   * @api
	   */
	  View.prototype.getResolution = function getResolution () {
	    return /** @type {number|undefined} */ (this.get(ViewProperty.RESOLUTION));
	  };
	
	  /**
	   * Get the resolutions for the view. This returns the array of resolutions
	   * passed to the constructor of the View, or undefined if none were given.
	   * @return {Array<number>|undefined} The resolutions of the view.
	   * @api
	   */
	  View.prototype.getResolutions = function getResolutions () {
	    return this.resolutions_;
	  };
	
	  /**
	   * Get the resolution for a provided extent (in map units) and size (in pixels).
	   * @param {import("./extent.js").Extent} extent Extent.
	   * @param {import("./size.js").Size=} opt_size Box pixel size.
	   * @return {number} The resolution at which the provided extent will render at
	   *     the given size.
	   * @api
	   */
	  View.prototype.getResolutionForExtent = function getResolutionForExtent (extent, opt_size) {
	    var size = opt_size || this.getSizeFromViewport_();
	    var xResolution = getWidth(extent) / size[0];
	    var yResolution = getHeight(extent) / size[1];
	    return Math.max(xResolution, yResolution);
	  };
	
	  /**
	   * Return a function that returns a value between 0 and 1 for a
	   * resolution. Exponential scaling is assumed.
	   * @param {number=} opt_power Power.
	   * @return {function(number): number} Resolution for value function.
	   */
	  View.prototype.getResolutionForValueFunction = function getResolutionForValueFunction (opt_power) {
	    var power = opt_power || 2;
	    var maxResolution = this.maxResolution_;
	    var minResolution = this.minResolution_;
	    var max = Math.log(maxResolution / minResolution) / Math.log(power);
	    return (
	      /**
	       * @param {number} value Value.
	       * @return {number} Resolution.
	       */
	      function(value) {
	        var resolution = maxResolution / Math.pow(power, value * max);
	        return resolution;
	      });
	  };
	
	  /**
	   * Get the view rotation.
	   * @return {number} The rotation of the view in radians.
	   * @observable
	   * @api
	   */
	  View.prototype.getRotation = function getRotation () {
	    return /** @type {number} */ (this.get(ViewProperty.ROTATION));
	  };
	
	  /**
	   * Return a function that returns a resolution for a value between
	   * 0 and 1. Exponential scaling is assumed.
	   * @param {number=} opt_power Power.
	   * @return {function(number): number} Value for resolution function.
	   */
	  View.prototype.getValueForResolutionFunction = function getValueForResolutionFunction (opt_power) {
	    var power = opt_power || 2;
	    var maxResolution = this.maxResolution_;
	    var minResolution = this.minResolution_;
	    var max = Math.log(maxResolution / minResolution) / Math.log(power);
	    return (
	      /**
	       * @param {number} resolution Resolution.
	       * @return {number} Value.
	       */
	      function(resolution) {
	        var value = (Math.log(maxResolution / resolution) / Math.log(power)) / max;
	        return value;
	      });
	  };
	
	  /**
	   * @param {number} pixelRatio Pixel ratio for center rounding.
	   * @return {State} View state.
	   */
	  View.prototype.getState = function getState (pixelRatio) {
	    var center = /** @type {import("./coordinate.js").Coordinate} */ (this.getCenter());
	    var projection = this.getProjection();
	    var resolution = /** @type {number} */ (this.getResolution());
	    var pixelResolution = resolution / pixelRatio;
	    var rotation = this.getRotation();
	    return (
	      /** @type {State} */ ({
	        center: [
	          Math.round(center[0] / pixelResolution) * pixelResolution,
	          Math.round(center[1] / pixelResolution) * pixelResolution
	        ],
	        projection: projection !== undefined ? projection : null,
	        resolution: resolution,
	        rotation: rotation,
	        zoom: this.getZoom()
	      })
	    );
	  };
	
	  /**
	   * Get the current zoom level.  If you configured your view with a resolutions
	   * array (this is rare), this method may return non-integer zoom levels (so
	   * the zoom level is not safe to use as an index into a resolutions array).
	   * @return {number|undefined} Zoom.
	   * @api
	   */
	  View.prototype.getZoom = function getZoom () {
	    var zoom;
	    var resolution = this.getResolution();
	    if (resolution !== undefined) {
	      zoom = this.getZoomForResolution(resolution);
	    }
	    return zoom;
	  };
	
	  /**
	   * Get the zoom level for a resolution.
	   * @param {number} resolution The resolution.
	   * @return {number|undefined} The zoom level for the provided resolution.
	   * @api
	   */
	  View.prototype.getZoomForResolution = function getZoomForResolution (resolution) {
	    var offset = this.minZoom_ || 0;
	    var max, zoomFactor;
	    if (this.resolutions_) {
	      var nearest = linearFindNearest(this.resolutions_, resolution, 1);
	      offset = nearest;
	      max = this.resolutions_[nearest];
	      if (nearest == this.resolutions_.length - 1) {
	        zoomFactor = 2;
	      } else {
	        zoomFactor = max / this.resolutions_[nearest + 1];
	      }
	    } else {
	      max = this.maxResolution_;
	      zoomFactor = this.zoomFactor_;
	    }
	    return offset + Math.log(max / resolution) / Math.log(zoomFactor);
	  };
	
	  /**
	   * Get the resolution for a zoom level.
	   * @param {number} zoom Zoom level.
	   * @return {number} The view resolution for the provided zoom level.
	   * @api
	   */
	  View.prototype.getResolutionForZoom = function getResolutionForZoom (zoom) {
	    return /** @type {number} */ (this.constrainResolution(
	      this.maxResolution_, zoom - this.minZoom_, 0));
	  };
	
	  /**
	   * Fit the given geometry or extent based on the given map size and border.
	   * The size is pixel dimensions of the box to fit the extent into.
	   * In most cases you will want to use the map size, that is `map.getSize()`.
	   * Takes care of the map angle.
	   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
	   *     extent to fit the view to.
	   * @param {FitOptions=} opt_options Options.
	   * @api
	   */
	  View.prototype.fit = function fit (geometryOrExtent, opt_options) {
	    var options = opt_options || {};
	    var size = options.size;
	    if (!size) {
	      size = this.getSizeFromViewport_();
	    }
	    /** @type {import("./geom/SimpleGeometry.js").default} */
	    var geometry;
	    assert(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ (geometryOrExtent).getSimplifiedGeometry === 'function',
	      24); // Invalid extent or geometry provided as `geometry`
	    if (Array.isArray(geometryOrExtent)) {
	      assert(!isEmpty$1(geometryOrExtent),
	        25); // Cannot fit empty extent provided as `geometry`
	      geometry = fromExtent(geometryOrExtent);
	    } else if (geometryOrExtent.getType() === GeometryType.CIRCLE) {
	      geometryOrExtent = geometryOrExtent.getExtent();
	      geometry = fromExtent(geometryOrExtent);
	      geometry.rotate(this.getRotation(), getCenter(geometryOrExtent));
	    } else {
	      geometry = geometryOrExtent;
	    }
	
	    var padding = options.padding !== undefined ? options.padding : [0, 0, 0, 0];
	    var constrainResolution = options.constrainResolution !== undefined ?
	      options.constrainResolution : true;
	    var nearest = options.nearest !== undefined ? options.nearest : false;
	    var minResolution;
	    if (options.minResolution !== undefined) {
	      minResolution = options.minResolution;
	    } else if (options.maxZoom !== undefined) {
	      minResolution = this.constrainResolution(
	        this.maxResolution_, options.maxZoom - this.minZoom_, 0);
	    } else {
	      minResolution = 0;
	    }
	    var coords = geometry.getFlatCoordinates();
	
	    // calculate rotated extent
	    var rotation = this.getRotation();
	    var cosAngle = Math.cos(-rotation);
	    var sinAngle = Math.sin(-rotation);
	    var minRotX = +Infinity;
	    var minRotY = +Infinity;
	    var maxRotX = -Infinity;
	    var maxRotY = -Infinity;
	    var stride = geometry.getStride();
	    for (var i = 0, ii = coords.length; i < ii; i += stride) {
	      var rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
	      var rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
	      minRotX = Math.min(minRotX, rotX);
	      minRotY = Math.min(minRotY, rotY);
	      maxRotX = Math.max(maxRotX, rotX);
	      maxRotY = Math.max(maxRotY, rotY);
	    }
	
	    // calculate resolution
	    var resolution = this.getResolutionForExtent(
	      [minRotX, minRotY, maxRotX, maxRotY],
	      [size[0] - padding[1] - padding[3], size[1] - padding[0] - padding[2]]);
	    resolution = isNaN(resolution) ? minResolution :
	      Math.max(resolution, minResolution);
	    if (constrainResolution) {
	      var constrainedResolution = this.constrainResolution(resolution, 0, 0);
	      if (!nearest && constrainedResolution < resolution) {
	        constrainedResolution = this.constrainResolution(
	          constrainedResolution, -1, 0);
	      }
	      resolution = constrainedResolution;
	    }
	
	    // calculate center
	    sinAngle = -sinAngle; // go back to original rotation
	    var centerRotX = (minRotX + maxRotX) / 2;
	    var centerRotY = (minRotY + maxRotY) / 2;
	    centerRotX += (padding[1] - padding[3]) / 2 * resolution;
	    centerRotY += (padding[0] - padding[2]) / 2 * resolution;
	    var centerX = centerRotX * cosAngle - centerRotY * sinAngle;
	    var centerY = centerRotY * cosAngle + centerRotX * sinAngle;
	    var center = [centerX, centerY];
	    var callback = options.callback ? options.callback : VOID;
	
	    if (options.duration !== undefined) {
	      this.animate({
	        resolution: resolution,
	        center: center,
	        duration: options.duration,
	        easing: options.easing
	      }, callback);
	    } else {
	      this.setResolution(resolution);
	      this.setCenter(center);
	      animationCallback(callback, true);
	    }
	  };
	
	  /**
	   * Center on coordinate and view position.
	   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("./size.js").Size} size Box pixel size.
	   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
	   * @api
	   */
	  View.prototype.centerOn = function centerOn (coordinate, size, position) {
	    // calculate rotated position
	    var rotation = this.getRotation();
	    var cosAngle = Math.cos(-rotation);
	    var sinAngle = Math.sin(-rotation);
	    var rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
	    var rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
	    var resolution = this.getResolution();
	    rotX += (size[0] / 2 - position[0]) * resolution;
	    rotY += (position[1] - size[1] / 2) * resolution;
	
	    // go back to original angle
	    sinAngle = -sinAngle; // go back to original rotation
	    var centerX = rotX * cosAngle - rotY * sinAngle;
	    var centerY = rotY * cosAngle + rotX * sinAngle;
	
	    this.setCenter([centerX, centerY]);
	  };
	
	  /**
	   * @return {boolean} Is defined.
	   */
	  View.prototype.isDef = function isDef () {
	    return !!this.getCenter() && this.getResolution() !== undefined;
	  };
	
	  /**
	   * Rotate the view around a given coordinate.
	   * @param {number} rotation New rotation value for the view.
	   * @param {import("./coordinate.js").Coordinate=} opt_anchor The rotation center.
	   * @api
	   */
	  View.prototype.rotate = function rotate$$1 (rotation, opt_anchor) {
	    if (opt_anchor !== undefined) {
	      var center = this.calculateCenterRotate(rotation, opt_anchor);
	      this.setCenter(center);
	    }
	    this.setRotation(rotation);
	  };
	
	  /**
	   * Set the center of the current view.
	   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
	   * @observable
	   * @api
	   */
	  View.prototype.setCenter = function setCenter (center) {
	    this.set(ViewProperty.CENTER, center);
	    if (this.getAnimating()) {
	      this.cancelAnimations();
	    }
	  };
	
	  /**
	   * @param {ViewHint} hint Hint.
	   * @param {number} delta Delta.
	   * @return {number} New value.
	   */
	  View.prototype.setHint = function setHint (hint, delta) {
	    this.hints_[hint] += delta;
	    this.changed();
	    return this.hints_[hint];
	  };
	
	  /**
	   * Set the resolution for this view.
	   * @param {number|undefined} resolution The resolution of the view.
	   * @observable
	   * @api
	   */
	  View.prototype.setResolution = function setResolution (resolution) {
	    this.set(ViewProperty.RESOLUTION, resolution);
	    if (this.getAnimating()) {
	      this.cancelAnimations();
	    }
	  };
	
	  /**
	   * Set the rotation for this view.
	   * @param {number} rotation The rotation of the view in radians.
	   * @observable
	   * @api
	   */
	  View.prototype.setRotation = function setRotation (rotation) {
	    this.set(ViewProperty.ROTATION, rotation);
	    if (this.getAnimating()) {
	      this.cancelAnimations();
	    }
	  };
	
	  /**
	   * Zoom to a specific zoom level.
	   * @param {number} zoom Zoom level.
	   * @api
	   */
	  View.prototype.setZoom = function setZoom (zoom) {
	    this.setResolution(this.getResolutionForZoom(zoom));
	  };
	
	  return View;
	}(BaseObject));
	
	
	/**
	 * @param {Function} callback Callback.
	 * @param {*} returnValue Return value.
	 */
	function animationCallback(callback, returnValue) {
	  setTimeout(function() {
	    callback(returnValue);
	  }, 0);
	}
	
	
	/**
	 * @param {ViewOptions} options View options.
	 * @return {import("./centerconstraint.js").Type} The constraint.
	 */
	function createCenterConstraint(options) {
	  if (options.extent !== undefined) {
	    return createExtent(options.extent);
	  } else {
	    return none;
	  }
	}
	
	
	/**
	 * @param {ViewOptions} options View options.
	 * @return {{constraint: import("./resolutionconstraint.js").Type, maxResolution: number,
	 *     minResolution: number, minZoom: number, zoomFactor: number}} The constraint.
	 */
	function createResolutionConstraint(options) {
	  var resolutionConstraint;
	  var maxResolution;
	  var minResolution;
	
	  // TODO: move these to be ol constants
	  // see https://github.com/openlayers/openlayers/issues/2076
	  var defaultMaxZoom = 28;
	  var defaultZoomFactor = 2;
	
	  var minZoom = options.minZoom !== undefined ?
	    options.minZoom : DEFAULT_MIN_ZOOM;
	
	  var maxZoom = options.maxZoom !== undefined ?
	    options.maxZoom : defaultMaxZoom;
	
	  var zoomFactor = options.zoomFactor !== undefined ?
	    options.zoomFactor : defaultZoomFactor;
	
	  if (options.resolutions !== undefined) {
	    var resolutions = options.resolutions;
	    maxResolution = resolutions[minZoom];
	    minResolution = resolutions[maxZoom] !== undefined ?
	      resolutions[maxZoom] : resolutions[resolutions.length - 1];
	    resolutionConstraint = createSnapToResolutions(
	      resolutions);
	  } else {
	    // calculate the default min and max resolution
	    var projection = createProjection(options.projection, 'EPSG:3857');
	    var extent = projection.getExtent();
	    var size = !extent ?
	      // use an extent that can fit the whole world if need be
	      360 * METERS_PER_UNIT[Units.DEGREES] /
	            projection.getMetersPerUnit() :
	      Math.max(getWidth(extent), getHeight(extent));
	
	    var defaultMaxResolution = size / DEFAULT_TILE_SIZE / Math.pow(
	      defaultZoomFactor, DEFAULT_MIN_ZOOM);
	
	    var defaultMinResolution = defaultMaxResolution / Math.pow(
	      defaultZoomFactor, defaultMaxZoom - DEFAULT_MIN_ZOOM);
	
	    // user provided maxResolution takes precedence
	    maxResolution = options.maxResolution;
	    if (maxResolution !== undefined) {
	      minZoom = 0;
	    } else {
	      maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
	    }
	
	    // user provided minResolution takes precedence
	    minResolution = options.minResolution;
	    if (minResolution === undefined) {
	      if (options.maxZoom !== undefined) {
	        if (options.maxResolution !== undefined) {
	          minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
	        } else {
	          minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
	        }
	      } else {
	        minResolution = defaultMinResolution;
	      }
	    }
	
	    // given discrete zoom levels, minResolution may be different than provided
	    maxZoom = minZoom + Math.floor(
	      Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
	    minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
	
	    resolutionConstraint = createSnapToPower(
	      zoomFactor, maxResolution, maxZoom - minZoom);
	  }
	  return {constraint: resolutionConstraint, maxResolution: maxResolution,
	    minResolution: minResolution, minZoom: minZoom, zoomFactor: zoomFactor};
	}
	
	
	/**
	 * @param {ViewOptions} options View options.
	 * @return {import("./rotationconstraint.js").Type} Rotation constraint.
	 */
	function createRotationConstraint(options) {
	  var enableRotation = options.enableRotation !== undefined ?
	    options.enableRotation : true;
	  if (enableRotation) {
	    var constrainRotation = options.constrainRotation;
	    if (constrainRotation === undefined || constrainRotation === true) {
	      return createSnapToZero();
	    } else if (constrainRotation === false) {
	      return none$1;
	    } else if (typeof constrainRotation === 'number') {
	      return createSnapToN(constrainRotation);
	    } else {
	      return none$1;
	    }
	  } else {
	    return disable;
	  }
	}
	
	
	/**
	 * Determine if an animation involves no view change.
	 * @param {Animation} animation The animation.
	 * @return {boolean} The animation involves no view change.
	 */
	function isNoopAnimation(animation) {
	  if (animation.sourceCenter && animation.targetCenter) {
	    if (!equals$2(animation.sourceCenter, animation.targetCenter)) {
	      return false;
	    }
	  }
	  if (animation.sourceResolution !== animation.targetResolution) {
	    return false;
	  }
	  if (animation.sourceRotation !== animation.targetRotation) {
	    return false;
	  }
	  return true;
	}
	
	/**
	 * @module ol/dom
	 */
	
	
	/**
	 * Create an html canvas element and returns its 2d context.
	 * @param {number=} opt_width Canvas width.
	 * @param {number=} opt_height Canvas height.
	 * @return {CanvasRenderingContext2D} The context.
	 */
	function createCanvasContext2D(opt_width, opt_height) {
	  var canvas = /** @type {HTMLCanvasElement} */ (document.createElement('canvas'));
	  if (opt_width) {
	    canvas.width = opt_width;
	  }
	  if (opt_height) {
	    canvas.height = opt_height;
	  }
	  return /** @type {CanvasRenderingContext2D} */ (canvas.getContext('2d'));
	}
	
	
	/**
	 * Get the current computed width for the given element including margin,
	 * padding and border.
	 * Equivalent to jQuery's `$(el).outerWidth(true)`.
	 * @param {!HTMLElement} element Element.
	 * @return {number} The width.
	 */
	function outerWidth(element) {
	  var width = element.offsetWidth;
	  var style = getComputedStyle(element);
	  width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
	
	  return width;
	}
	
	
	/**
	 * Get the current computed height for the given element including margin,
	 * padding and border.
	 * Equivalent to jQuery's `$(el).outerHeight(true)`.
	 * @param {!HTMLElement} element Element.
	 * @return {number} The height.
	 */
	function outerHeight(element) {
	  var height = element.offsetHeight;
	  var style = getComputedStyle(element);
	  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
	
	  return height;
	}
	
	/**
	 * @param {Node} newNode Node to replace old node
	 * @param {Node} oldNode The node to be replaced
	 */
	function replaceNode(newNode, oldNode) {
	  var parent = oldNode.parentNode;
	  if (parent) {
	    parent.replaceChild(newNode, oldNode);
	  }
	}
	
	/**
	 * @param {Node} node The node to remove.
	 * @returns {Node} The node that was removed or null.
	 */
	function removeNode(node) {
	  return node && node.parentNode ? node.parentNode.removeChild(node) : null;
	}
	
	/**
	 * @param {Node} node The node to remove the children from.
	 */
	function removeChildren(node) {
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	}
	
	/**
	 * @module ol/layer/Property
	 */
	
	/**
	 * @enum {string}
	 */
	var LayerProperty = {
	  OPACITY: 'opacity',
	  VISIBLE: 'visible',
	  EXTENT: 'extent',
	  Z_INDEX: 'zIndex',
	  MAX_RESOLUTION: 'maxResolution',
	  MIN_RESOLUTION: 'minResolution',
	  SOURCE: 'source'
	};
	
	/**
	 * @module ol/layer/Base
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Note that with {@link module:ol/layer/Base} and all its subclasses, any property set in
	 * the options is set as a {@link module:ol/Object} property on the layer object, so
	 * is observable, and has get/set accessors.
	 *
	 * @api
	 */
	var BaseLayer = /*@__PURE__*/(function (BaseObject$$1) {
	  function BaseLayer(options) {
	
	    BaseObject$$1.call(this);
	
	    /**
	     * @type {Object<string, *>}
	     */
	    var properties = assign({}, options);
	    properties[LayerProperty.OPACITY] =
	       options.opacity !== undefined ? options.opacity : 1;
	    properties[LayerProperty.VISIBLE] =
	       options.visible !== undefined ? options.visible : true;
	    properties[LayerProperty.Z_INDEX] = options.zIndex;
	    properties[LayerProperty.MAX_RESOLUTION] =
	       options.maxResolution !== undefined ? options.maxResolution : Infinity;
	    properties[LayerProperty.MIN_RESOLUTION] =
	       options.minResolution !== undefined ? options.minResolution : 0;
	
	    this.setProperties(properties);
	
	    /**
	     * @type {import("./Layer.js").State}
	     * @private
	     */
	    this.state_ = null;
	
	    /**
	     * The layer type.
	     * @type {import("../LayerType.js").default}
	     * @protected;
	     */
	    this.type;
	
	  }
	
	  if ( BaseObject$$1 ) { BaseLayer.__proto__ = BaseObject$$1; }
	  BaseLayer.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  BaseLayer.prototype.constructor = BaseLayer;
	
	  /**
	   * Get the layer type (used when creating a layer renderer).
	   * @return {import("../LayerType.js").default} The layer type.
	   */
	  BaseLayer.prototype.getType = function getType () {
	    return this.type;
	  };
	
	  /**
	   * @return {import("./Layer.js").State} Layer state.
	   */
	  BaseLayer.prototype.getLayerState = function getLayerState () {
	    /** @type {import("./Layer.js").State} */
	    var state = this.state_ || /** @type {?} */ ({
	      layer: this,
	      managed: true
	    });
	    state.opacity = clamp(this.getOpacity(), 0, 1);
	    state.sourceState = this.getSourceState();
	    state.visible = this.getVisible();
	    state.extent = this.getExtent();
	    state.zIndex = this.getZIndex() || 0;
	    state.maxResolution = this.getMaxResolution();
	    state.minResolution = Math.max(this.getMinResolution(), 0);
	    this.state_ = state;
	
	    return state;
	  };
	
	  /**
	   * @abstract
	   * @param {Array<import("./Layer.js").default>=} opt_array Array of layers (to be
	   *     modified in place).
	   * @return {Array<import("./Layer.js").default>} Array of layers.
	   */
	  BaseLayer.prototype.getLayersArray = function getLayersArray (opt_array) {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @param {Array<import("./Layer.js").State>=} opt_states Optional list of layer
	   *     states (to be modified in place).
	   * @return {Array<import("./Layer.js").State>} List of layer states.
	   */
	  BaseLayer.prototype.getLayerStatesArray = function getLayerStatesArray (opt_states) {
	    return abstract();
	  };
	
	  /**
	   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
	   * will be visible regardless of extent.
	   * @return {import("../extent.js").Extent|undefined} The layer extent.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.getExtent = function getExtent () {
	    return (
	      /** @type {import("../extent.js").Extent|undefined} */ (this.get(LayerProperty.EXTENT))
	    );
	  };
	
	  /**
	   * Return the maximum resolution of the layer.
	   * @return {number} The maximum resolution of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.getMaxResolution = function getMaxResolution () {
	    return /** @type {number} */ (this.get(LayerProperty.MAX_RESOLUTION));
	  };
	
	  /**
	   * Return the minimum resolution of the layer.
	   * @return {number} The minimum resolution of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.getMinResolution = function getMinResolution () {
	    return /** @type {number} */ (this.get(LayerProperty.MIN_RESOLUTION));
	  };
	
	  /**
	   * Return the opacity of the layer (between 0 and 1).
	   * @return {number} The opacity of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.getOpacity = function getOpacity () {
	    return /** @type {number} */ (this.get(LayerProperty.OPACITY));
	  };
	
	  /**
	   * @abstract
	   * @return {import("../source/State.js").default} Source state.
	   */
	  BaseLayer.prototype.getSourceState = function getSourceState () {
	    return abstract();
	  };
	
	  /**
	   * Return the visibility of the layer (`true` or `false`).
	   * @return {boolean} The visibility of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.getVisible = function getVisible () {
	    return /** @type {boolean} */ (this.get(LayerProperty.VISIBLE));
	  };
	
	  /**
	   * Return the Z-index of the layer, which is used to order layers before
	   * rendering. The default Z-index is 0.
	   * @return {number} The Z-index of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.getZIndex = function getZIndex () {
	    return /** @type {number} */ (this.get(LayerProperty.Z_INDEX));
	  };
	
	  /**
	   * Set the extent at which the layer is visible.  If `undefined`, the layer
	   * will be visible at all extents.
	   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.setExtent = function setExtent (extent) {
	    this.set(LayerProperty.EXTENT, extent);
	  };
	
	  /**
	   * Set the maximum resolution at which the layer is visible.
	   * @param {number} maxResolution The maximum resolution of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.setMaxResolution = function setMaxResolution (maxResolution) {
	    this.set(LayerProperty.MAX_RESOLUTION, maxResolution);
	  };
	
	  /**
	   * Set the minimum resolution at which the layer is visible.
	   * @param {number} minResolution The minimum resolution of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.setMinResolution = function setMinResolution (minResolution) {
	    this.set(LayerProperty.MIN_RESOLUTION, minResolution);
	  };
	
	  /**
	   * Set the opacity of the layer, allowed values range from 0 to 1.
	   * @param {number} opacity The opacity of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.setOpacity = function setOpacity (opacity) {
	    this.set(LayerProperty.OPACITY, opacity);
	  };
	
	  /**
	   * Set the visibility of the layer (`true` or `false`).
	   * @param {boolean} visible The visibility of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.setVisible = function setVisible (visible) {
	    this.set(LayerProperty.VISIBLE, visible);
	  };
	
	  /**
	   * Set Z-index of the layer, which is used to order layers before rendering.
	   * The default Z-index is 0.
	   * @param {number} zindex The z-index of the layer.
	   * @observable
	   * @api
	   */
	  BaseLayer.prototype.setZIndex = function setZIndex (zindex) {
	    this.set(LayerProperty.Z_INDEX, zindex);
	  };
	
	  return BaseLayer;
	}(BaseObject));
	
	/**
	 * @module ol/source/State
	 */
	
	/**
	 * @enum {string}
	 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
	 */
	var SourceState = {
	  UNDEFINED: 'undefined',
	  LOADING: 'loading',
	  READY: 'ready',
	  ERROR: 'error'
	};
	
	/**
	 * @module ol/layer/Group
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {Array<import("./Base.js").default>|import("../Collection.js").default<import("./Base.js").default>} [layers] Child layers.
	 */
	
	
	/**
	 * @enum {string}
	 * @private
	 */
	var Property$2 = {
	  LAYERS: 'layers'
	};
	
	
	/**
	 * @classdesc
	 * A {@link module:ol/Collection~Collection} of layers that are handled together.
	 *
	 * A generic `change` event is triggered when the group/Collection changes.
	 *
	 * @api
	 */
	var LayerGroup = /*@__PURE__*/(function (BaseLayer$$1) {
	  function LayerGroup(opt_options) {
	
	    var options = opt_options || {};
	    var baseOptions = /** @type {Options} */ (assign({}, options));
	    delete baseOptions.layers;
	
	    var layers = options.layers;
	
	    BaseLayer$$1.call(this, baseOptions);
	
	    /**
	     * @private
	     * @type {Array<import("../events.js").EventsKey>}
	     */
	    this.layersListenerKeys_ = [];
	
	    /**
	     * @private
	     * @type {Object<string, Array<import("../events.js").EventsKey>>}
	     */
	    this.listenerKeys_ = {};
	
	    listen(this,
	      getChangeEventType(Property$2.LAYERS),
	      this.handleLayersChanged_, this);
	
	    if (layers) {
	      if (Array.isArray(layers)) {
	        layers = new Collection(layers.slice(), {unique: true});
	      } else {
	        assert(typeof /** @type {?} */ (layers).getArray === 'function',
	          43); // Expected `layers` to be an array or a `Collection`
	      }
	    } else {
	      layers = new Collection(undefined, {unique: true});
	    }
	
	    this.setLayers(layers);
	
	  }
	
	  if ( BaseLayer$$1 ) { LayerGroup.__proto__ = BaseLayer$$1; }
	  LayerGroup.prototype = Object.create( BaseLayer$$1 && BaseLayer$$1.prototype );
	  LayerGroup.prototype.constructor = LayerGroup;
	
	  /**
	   * @private
	   */
	  LayerGroup.prototype.handleLayerChange_ = function handleLayerChange_ () {
	    this.changed();
	  };
	
	  /**
	   * @private
	   */
	  LayerGroup.prototype.handleLayersChanged_ = function handleLayersChanged_ () {
	    this.layersListenerKeys_.forEach(unlistenByKey);
	    this.layersListenerKeys_.length = 0;
	
	    var layers = this.getLayers();
	    this.layersListenerKeys_.push(
	      listen(layers, CollectionEventType.ADD, this.handleLayersAdd_, this),
	      listen(layers, CollectionEventType.REMOVE, this.handleLayersRemove_, this)
	    );
	
	    for (var id in this.listenerKeys_) {
	      this.listenerKeys_[id].forEach(unlistenByKey);
	    }
	    clear(this.listenerKeys_);
	
	    var layersArray = layers.getArray();
	    for (var i = 0, ii = layersArray.length; i < ii; i++) {
	      var layer = layersArray[i];
	      this.listenerKeys_[getUid(layer)] = [
	        listen(layer, ObjectEventType.PROPERTYCHANGE, this.handleLayerChange_, this),
	        listen(layer, EventType.CHANGE, this.handleLayerChange_, this)
	      ];
	    }
	
	    this.changed();
	  };
	
	  /**
	   * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
	   * @private
	   */
	  LayerGroup.prototype.handleLayersAdd_ = function handleLayersAdd_ (collectionEvent) {
	    var layer = /** @type {import("./Base.js").default} */ (collectionEvent.element);
	    this.listenerKeys_[getUid(layer)] = [
	      listen(layer, ObjectEventType.PROPERTYCHANGE, this.handleLayerChange_, this),
	      listen(layer, EventType.CHANGE, this.handleLayerChange_, this)
	    ];
	    this.changed();
	  };
	
	  /**
	   * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
	   * @private
	   */
	  LayerGroup.prototype.handleLayersRemove_ = function handleLayersRemove_ (collectionEvent) {
	    var layer = /** @type {import("./Base.js").default} */ (collectionEvent.element);
	    var key = getUid(layer);
	    this.listenerKeys_[key].forEach(unlistenByKey);
	    delete this.listenerKeys_[key];
	    this.changed();
	  };
	
	  /**
	   * Returns the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
	   * in this group.
	   * @return {!import("../Collection.js").default<import("./Base.js").default>} Collection of
	   *   {@link module:ol/layer/Base layers} that are part of this group.
	   * @observable
	   * @api
	   */
	  LayerGroup.prototype.getLayers = function getLayers () {
	    return (
	      /** @type {!import("../Collection.js").default<import("./Base.js").default>} */ (this.get(Property$2.LAYERS))
	    );
	  };
	
	  /**
	   * Set the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
	   * in this group.
	   * @param {!import("../Collection.js").default<import("./Base.js").default>} layers Collection of
	   *   {@link module:ol/layer/Base layers} that are part of this group.
	   * @observable
	   * @api
	   */
	  LayerGroup.prototype.setLayers = function setLayers (layers) {
	    this.set(Property$2.LAYERS, layers);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LayerGroup.prototype.getLayersArray = function getLayersArray (opt_array) {
	    var array = opt_array !== undefined ? opt_array : [];
	    this.getLayers().forEach(function(layer) {
	      layer.getLayersArray(array);
	    });
	    return array;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LayerGroup.prototype.getLayerStatesArray = function getLayerStatesArray (opt_states) {
	    var states = opt_states !== undefined ? opt_states : [];
	
	    var pos = states.length;
	
	    this.getLayers().forEach(function(layer) {
	      layer.getLayerStatesArray(states);
	    });
	
	    var ownLayerState = this.getLayerState();
	    for (var i = pos, ii = states.length; i < ii; i++) {
	      var layerState = states[i];
	      layerState.opacity *= ownLayerState.opacity;
	      layerState.visible = layerState.visible && ownLayerState.visible;
	      layerState.maxResolution = Math.min(
	        layerState.maxResolution, ownLayerState.maxResolution);
	      layerState.minResolution = Math.max(
	        layerState.minResolution, ownLayerState.minResolution);
	      if (ownLayerState.extent !== undefined) {
	        if (layerState.extent !== undefined) {
	          layerState.extent = getIntersection(layerState.extent, ownLayerState.extent);
	        } else {
	          layerState.extent = ownLayerState.extent;
	        }
	      }
	    }
	
	    return states;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  LayerGroup.prototype.getSourceState = function getSourceState () {
	    return SourceState.READY;
	  };
	
	  return LayerGroup;
	}(BaseLayer));
	
	/**
	 * @module ol/size
	 */
	
	
	/**
	 * An array of numbers representing a size: `[width, height]`.
	 * @typedef {Array<number>} Size
	 * @api
	 */
	
	
	/**
	 * Returns a buffered size.
	 * @param {Size} size Size.
	 * @param {number} num The amount by which to buffer.
	 * @param {Size=} opt_size Optional reusable size array.
	 * @return {Size} The buffered size.
	 */
	function buffer$1(size, num, opt_size) {
	  if (opt_size === undefined) {
	    opt_size = [0, 0];
	  }
	  opt_size[0] = size[0] + 2 * num;
	  opt_size[1] = size[1] + 2 * num;
	  return opt_size;
	}
	
	
	/**
	 * Determines if a size has a positive area.
	 * @param {Size} size The size to test.
	 * @return {boolean} The size has a positive area.
	 */
	function hasArea(size) {
	  return size[0] > 0 && size[1] > 0;
	}
	
	
	/**
	 * Returns a size scaled by a ratio. The result will be an array of integers.
	 * @param {Size} size Size.
	 * @param {number} ratio Ratio.
	 * @param {Size=} opt_size Optional reusable size array.
	 * @return {Size} The scaled size.
	 */
	function scale$3(size, ratio, opt_size) {
	  if (opt_size === undefined) {
	    opt_size = [0, 0];
	  }
	  opt_size[0] = (size[0] * ratio + 0.5) | 0;
	  opt_size[1] = (size[1] * ratio + 0.5) | 0;
	  return opt_size;
	}
	
	
	/**
	 * Returns an `Size` array for the passed in number (meaning: square) or
	 * `Size` array.
	 * (meaning: non-square),
	 * @param {number|Size} size Width and height.
	 * @param {Size=} opt_size Optional reusable size array.
	 * @return {Size} Size.
	 * @api
	 */
	function toSize(size, opt_size) {
	  if (Array.isArray(size)) {
	    return size;
	  } else {
	    if (opt_size === undefined) {
	      opt_size = [size, size];
	    } else {
	      opt_size[0] = opt_size[1] = /** @type {number} */ (size);
	    }
	    return opt_size;
	  }
	}
	
	/**
	 * @module ol/PluggableMap
	 */
	
	
	/**
	 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
	 * be used in applications.
	 * @typedef {Object} FrameState
	 * @property {number} pixelRatio The pixel ratio of the frame.
	 * @property {number} time The time when rendering of the frame was requested.
	 * @property {import("./View.js").State} viewState The state of the current view.
	 * @property {boolean} animate
	 * @property {import("./transform.js").Transform} coordinateToPixelTransform
	 * @property {null|import("./extent.js").Extent} extent
	 * @property {import("./coordinate.js").Coordinate} focus
	 * @property {number} index
	 * @property {Object<string, import("./layer/Layer.js").State>} layerStates
	 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray
	 * @property {import("./transform.js").Transform} pixelToCoordinateTransform
	 * @property {Array<PostRenderFunction>} postRenderFunctions
	 * @property {import("./size.js").Size} size
	 * @property {!Object<string, boolean>} skippedFeatureUids
	 * @property {TileQueue} tileQueue
	 * @property {Object<string, Object<string, import("./TileRange.js").default>>} usedTiles
	 * @property {Array<number>} viewHints
	 * @property {!Object<string, Object<string, boolean>>} wantedTiles
	 */
	
	
	/**
	 * @typedef {function(PluggableMap, ?FrameState): boolean} PostRenderFunction
	 */
	
	
	/**
	 * @typedef {Object} AtPixelOptions
	 * @property {undefined|function(import("./layer/Layer.js").default): boolean} layerFilter Layer filter
	 * function. The filter function will receive one argument, the
	 * {@link module:ol/layer/Layer layer-candidate} and it should return a boolean value.
	 * Only layers which are visible and for which this function returns `true`
	 * will be tested for features. By default, all visible layers will be tested.
	 * @property {number} [hitTolerance=0] Hit-detection tolerance in pixels. Pixels
	 * inside the radius around the given position will be checked for features. This only
	 * works for the canvas renderer and not for WebGL.
	 */
	
	
	/**
	 * @typedef {Object} MapOptionsInternal
	 * @property {Collection<import("./control/Control.js").default>} [controls]
	 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions]
	 * @property {HTMLElement|Document} keyboardEventTarget
	 * @property {Collection<import("./Overlay.js").default>} overlays
	 * @property {Object<string, *>} values
	 */
	
	
	/**
	 * Object literal with config options for the map.
	 * @typedef {Object} MapOptions
	 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
	 * Controls initially added to the map. If not specified,
	 * {@link module:ol/control~defaults} is used.
	 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
	 * physical pixels and device-independent pixels (dips) on the device.
	 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
	 * Interactions that are initially added to the map. If not specified,
	 * {@link module:ol/interaction~defaults} is used.
	 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
	 * listen to keyboard events on. This determines when the `KeyboardPan` and
	 * `KeyboardZoom` interactions trigger. For example, if this option is set to
	 * `document` the keyboard interactions will always trigger. If this option is
	 * not specified, the element the library listens to keyboard events on is the
	 * map target (i.e. the user-provided div for the map). If this is not
	 * `document`, the target element needs to be focused for key events to be
	 * emitted, requiring that the target element has a `tabindex` attribute.
	 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
	 * Layers. If this is not defined, a map with no layers will be rendered. Note
	 * that layers are rendered in the order supplied, so if you want, for example,
	 * a vector layer to appear on top of a tile layer, it must come after the tile
	 * layer.
	 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
	 * simultaneously.
	 * @property {boolean} [loadTilesWhileAnimating=false] When set to `true`, tiles
	 * will be loaded during animations. This may improve the user experience, but
	 * can also make animations stutter on devices with slow memory.
	 * @property {boolean} [loadTilesWhileInteracting=false] When set to `true`,
	 * tiles will be loaded while interacting with the map. This may improve the
	 * user experience, but can also make map panning and zooming choppy on devices
	 * with slow memory.
	 * @property {number} [moveTolerance=1] The minimum distance in pixels the
	 * cursor must move to be detected as a map move event instead of a click.
	 * Increasing this value can make it easier to click on the map.
	 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
	 * Overlays initially added to the map. By default, no overlays are added.
	 * @property {HTMLElement|string} [target] The container for the map, either the
	 * element itself or the `id` of the element. If not specified at construction
	 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
	 * rendered.
	 * @property {View} [view] The map's view.  No layer sources will be
	 * fetched unless this is specified at construction time or through
	 * {@link module:ol/Map~Map#setView}.
	 */
	
	
	/**
	 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
	 * @fires import("./MapEvent.js").MapEvent
	 * @fires module:ol/render/Event~RenderEvent#postcompose
	 * @fires module:ol/render/Event~RenderEvent#precompose
	 * @fires module:ol/render/Event~RenderEvent#rendercomplete
	 * @api
	 */
	var PluggableMap = /*@__PURE__*/(function (BaseObject$$1) {
	  function PluggableMap(options) {
	
	    BaseObject$$1.call(this);
	
	    var optionsInternal = createOptionsInternal(options);
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.loadTilesWhileAnimating_ =
	        options.loadTilesWhileAnimating !== undefined ?
	          options.loadTilesWhileAnimating : false;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.loadTilesWhileInteracting_ =
	        options.loadTilesWhileInteracting !== undefined ?
	          options.loadTilesWhileInteracting : false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.pixelRatio_ = options.pixelRatio !== undefined ?
	      options.pixelRatio : DEVICE_PIXEL_RATIO;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.animationDelayKey_;
	
	    /**
	     * @private
	     */
	    this.animationDelay_ = function() {
	      this.animationDelayKey_ = undefined;
	      this.renderFrame_.call(this, Date.now());
	    }.bind(this);
	
	    /**
	     * @private
	     * @type {import("./transform.js").Transform}
	     */
	    this.coordinateToPixelTransform_ = create();
	
	    /**
	     * @private
	     * @type {import("./transform.js").Transform}
	     */
	    this.pixelToCoordinateTransform_ = create();
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.frameIndex_ = 0;
	
	    /**
	     * @private
	     * @type {?FrameState}
	     */
	    this.frameState_ = null;
	
	    /**
	     * The extent at the previous 'moveend' event.
	     * @private
	     * @type {import("./extent.js").Extent}
	     */
	    this.previousExtent_ = null;
	
	    /**
	     * @private
	     * @type {?import("./events.js").EventsKey}
	     */
	    this.viewPropertyListenerKey_ = null;
	
	    /**
	     * @private
	     * @type {?import("./events.js").EventsKey}
	     */
	    this.viewChangeListenerKey_ = null;
	
	    /**
	     * @private
	     * @type {Array<import("./events.js").EventsKey>}
	     */
	    this.layerGroupPropertyListenerKeys_ = null;
	
	    /**
	     * @private
	     * @type {!HTMLElement}
	     */
	    this.viewport_ = document.createElement('div');
	    this.viewport_.className = 'ol-viewport' + (TOUCH ? ' ol-touch' : '');
	    this.viewport_.style.position = 'relative';
	    this.viewport_.style.overflow = 'hidden';
	    this.viewport_.style.width = '100%';
	    this.viewport_.style.height = '100%';
	    // prevent page zoom on IE >= 10 browsers
	    this.viewport_.style.msTouchAction = 'none';
	    this.viewport_.style.touchAction = 'none';
	
	    /**
	     * @private
	     * @type {!HTMLElement}
	     */
	    this.overlayContainer_ = document.createElement('div');
	    this.overlayContainer_.className = 'ol-overlaycontainer';
	    this.viewport_.appendChild(this.overlayContainer_);
	
	    /**
	     * @private
	     * @type {!HTMLElement}
	     */
	    this.overlayContainerStopEvent_ = document.createElement('div');
	    this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
	    var overlayEvents = [
	      EventType.CLICK,
	      EventType.DBLCLICK,
	      EventType.MOUSEDOWN,
	      EventType.TOUCHSTART,
	      EventType.MSPOINTERDOWN,
	      MapBrowserEventType.POINTERDOWN,
	      EventType.MOUSEWHEEL,
	      EventType.WHEEL
	    ];
	    for (var i = 0, ii = overlayEvents.length; i < ii; ++i) {
	      listen(this.overlayContainerStopEvent_, overlayEvents[i], stopPropagation);
	    }
	    this.viewport_.appendChild(this.overlayContainerStopEvent_);
	
	    /**
	     * @private
	     * @type {MapBrowserEventHandler}
	     */
	    this.mapBrowserEventHandler_ = new MapBrowserEventHandler(this, options.moveTolerance);
	    for (var key in MapBrowserEventType) {
	      listen(this.mapBrowserEventHandler_, MapBrowserEventType[key],
	        this.handleMapBrowserEvent, this);
	    }
	
	    /**
	     * @private
	     * @type {HTMLElement|Document}
	     */
	    this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
	
	    /**
	     * @private
	     * @type {Array<import("./events.js").EventsKey>}
	     */
	    this.keyHandlerKeys_ = null;
	
	    listen(this.viewport_, EventType.CONTEXTMENU, this.handleBrowserEvent, this);
	    listen(this.viewport_, EventType.WHEEL, this.handleBrowserEvent, this);
	    listen(this.viewport_, EventType.MOUSEWHEEL, this.handleBrowserEvent, this);
	
	    /**
	     * @type {Collection<import("./control/Control.js").default>}
	     * @protected
	     */
	    this.controls = optionsInternal.controls || new Collection();
	
	    /**
	     * @type {Collection<import("./interaction/Interaction.js").default>}
	     * @protected
	     */
	    this.interactions = optionsInternal.interactions || new Collection();
	
	    /**
	     * @type {Collection<import("./Overlay.js").default>}
	     * @private
	     */
	    this.overlays_ = optionsInternal.overlays;
	
	    /**
	     * A lookup of overlays by id.
	     * @private
	     * @type {Object<string, import("./Overlay.js").default>}
	     */
	    this.overlayIdIndex_ = {};
	
	    /**
	     * @type {import("./renderer/Map.js").default}
	     * @private
	     */
	    this.renderer_ = this.createRenderer();
	
	    /**
	     * @type {function(Event)|undefined}
	     * @private
	     */
	    this.handleResize_;
	
	    /**
	     * @private
	     * @type {import("./coordinate.js").Coordinate}
	     */
	    this.focus_ = null;
	
	    /**
	     * @private
	     * @type {!Array<PostRenderFunction>}
	     */
	    this.postRenderFunctions_ = [];
	
	    /**
	     * @private
	     * @type {TileQueue}
	     */
	    this.tileQueue_ = new TileQueue(
	      this.getTilePriority.bind(this),
	      this.handleTileChange_.bind(this));
	
	    /**
	     * Uids of features to skip at rendering time.
	     * @type {Object<string, boolean>}
	     * @private
	     */
	    this.skippedFeatureUids_ = {};
	
	    listen(
	      this, getChangeEventType(MapProperty.LAYERGROUP),
	      this.handleLayerGroupChanged_, this);
	    listen(this, getChangeEventType(MapProperty.VIEW),
	      this.handleViewChanged_, this);
	    listen(this, getChangeEventType(MapProperty.SIZE),
	      this.handleSizeChanged_, this);
	    listen(this, getChangeEventType(MapProperty.TARGET),
	      this.handleTargetChanged_, this);
	
	    // setProperties will trigger the rendering of the map if the map
	    // is "defined" already.
	    this.setProperties(optionsInternal.values);
	
	    this.controls.forEach(
	      /**
	       * @param {import("./control/Control.js").default} control Control.
	       * @this {PluggableMap}
	       */
	      (function(control) {
	        control.setMap(this);
	      }).bind(this));
	
	    listen(this.controls, CollectionEventType.ADD,
	      /**
	       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
	       */
	      function(event) {
	        event.element.setMap(this);
	      }, this);
	
	    listen(this.controls, CollectionEventType.REMOVE,
	      /**
	       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
	       */
	      function(event) {
	        event.element.setMap(null);
	      }, this);
	
	    this.interactions.forEach(
	      /**
	       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
	       * @this {PluggableMap}
	       */
	      (function(interaction) {
	        interaction.setMap(this);
	      }).bind(this));
	
	    listen(this.interactions, CollectionEventType.ADD,
	      /**
	       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
	       */
	      function(event) {
	        event.element.setMap(this);
	      }, this);
	
	    listen(this.interactions, CollectionEventType.REMOVE,
	      /**
	       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
	       */
	      function(event) {
	        event.element.setMap(null);
	      }, this);
	
	    this.overlays_.forEach(this.addOverlayInternal_.bind(this));
	
	    listen(this.overlays_, CollectionEventType.ADD,
	      /**
	       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
	       */
	      function(event) {
	        this.addOverlayInternal_(/** @type {import("./Overlay.js").default} */ (event.element));
	      }, this);
	
	    listen(this.overlays_, CollectionEventType.REMOVE,
	      /**
	       * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
	       */
	      function(event) {
	        var overlay = /** @type {import("./Overlay.js").default} */ (event.element);
	        var id = overlay.getId();
	        if (id !== undefined) {
	          delete this.overlayIdIndex_[id.toString()];
	        }
	        event.element.setMap(null);
	      }, this);
	
	  }
	
	  if ( BaseObject$$1 ) { PluggableMap.__proto__ = BaseObject$$1; }
	  PluggableMap.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  PluggableMap.prototype.constructor = PluggableMap;
	
	  /**
	   * @abstract
	   * @return {import("./renderer/Map.js").default} The map renderer
	   */
	  PluggableMap.prototype.createRenderer = function createRenderer () {
	    throw new Error('Use a map type that has a createRenderer method');
	  };
	
	  /**
	   * Add the given control to the map.
	   * @param {import("./control/Control.js").default} control Control.
	   * @api
	   */
	  PluggableMap.prototype.addControl = function addControl (control) {
	    this.getControls().push(control);
	  };
	
	  /**
	   * Add the given interaction to the map.
	   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
	   * @api
	   */
	  PluggableMap.prototype.addInteraction = function addInteraction (interaction) {
	    this.getInteractions().push(interaction);
	  };
	
	  /**
	   * Adds the given layer to the top of this map. If you want to add a layer
	   * elsewhere in the stack, use `getLayers()` and the methods available on
	   * {@link module:ol/Collection~Collection}.
	   * @param {import("./layer/Base.js").default} layer Layer.
	   * @api
	   */
	  PluggableMap.prototype.addLayer = function addLayer (layer) {
	    var layers = this.getLayerGroup().getLayers();
	    layers.push(layer);
	  };
	
	  /**
	   * Add the given overlay to the map.
	   * @param {import("./Overlay.js").default} overlay Overlay.
	   * @api
	   */
	  PluggableMap.prototype.addOverlay = function addOverlay (overlay) {
	    this.getOverlays().push(overlay);
	  };
	
	  /**
	   * This deals with map's overlay collection changes.
	   * @param {import("./Overlay.js").default} overlay Overlay.
	   * @private
	   */
	  PluggableMap.prototype.addOverlayInternal_ = function addOverlayInternal_ (overlay) {
	    var id = overlay.getId();
	    if (id !== undefined) {
	      this.overlayIdIndex_[id.toString()] = overlay;
	    }
	    overlay.setMap(this);
	  };
	
	  /**
	   *
	   * @inheritDoc
	   */
	  PluggableMap.prototype.disposeInternal = function disposeInternal () {
	    this.mapBrowserEventHandler_.dispose();
	    unlisten(this.viewport_, EventType.CONTEXTMENU, this.handleBrowserEvent, this);
	    unlisten(this.viewport_, EventType.WHEEL, this.handleBrowserEvent, this);
	    unlisten(this.viewport_, EventType.MOUSEWHEEL, this.handleBrowserEvent, this);
	    if (this.handleResize_ !== undefined) {
	      removeEventListener(EventType.RESIZE, this.handleResize_, false);
	      this.handleResize_ = undefined;
	    }
	    if (this.animationDelayKey_) {
	      cancelAnimationFrame(this.animationDelayKey_);
	      this.animationDelayKey_ = undefined;
	    }
	    this.setTarget(null);
	    BaseObject$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * Detect features that intersect a pixel on the viewport, and execute a
	   * callback with each intersecting feature. Layers included in the detection can
	   * be configured through the `layerFilter` option in `opt_options`.
	   * @param {import("./pixel.js").Pixel} pixel Pixel.
	   * @param {function(this: S, import("./Feature.js").FeatureLike,
	   *     import("./layer/Layer.js").default): T} callback Feature callback. The callback will be
	   *     called with two arguments. The first argument is one
	   *     {@link module:ol/Feature feature} or
	   *     {@link module:ol/render/Feature render feature} at the pixel, the second is
	   *     the {@link module:ol/layer/Layer layer} of the feature and will be null for
	   *     unmanaged layers. To stop detection, callback functions can return a
	   *     truthy value.
	   * @param {AtPixelOptions=} opt_options Optional options.
	   * @return {T|undefined} Callback result, i.e. the return value of last
	   * callback execution, or the first truthy callback return value.
	   * @template S,T
	   * @api
	   */
	  PluggableMap.prototype.forEachFeatureAtPixel = function forEachFeatureAtPixel (pixel, callback, opt_options) {
	    if (!this.frameState_) {
	      return;
	    }
	    var coordinate = this.getCoordinateFromPixel(pixel);
	    opt_options = opt_options !== undefined ? opt_options :
	      /** @type {AtPixelOptions} */ ({});
	    var hitTolerance = opt_options.hitTolerance !== undefined ?
	      opt_options.hitTolerance * this.frameState_.pixelRatio : 0;
	    var layerFilter = opt_options.layerFilter !== undefined ?
	      opt_options.layerFilter : TRUE;
	    return this.renderer_.forEachFeatureAtCoordinate(
	      coordinate, this.frameState_, hitTolerance, callback, null,
	      layerFilter, null);
	  };
	
	  /**
	   * Get all features that intersect a pixel on the viewport.
	   * @param {import("./pixel.js").Pixel} pixel Pixel.
	   * @param {AtPixelOptions=} opt_options Optional options.
	   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
	   * `null` if none were found.
	   * @api
	   */
	  PluggableMap.prototype.getFeaturesAtPixel = function getFeaturesAtPixel (pixel, opt_options) {
	    var features = null;
	    this.forEachFeatureAtPixel(pixel, function(feature) {
	      if (!features) {
	        features = [];
	      }
	      features.push(feature);
	    }, opt_options);
	    return features;
	  };
	
	  /**
	   * Detect layers that have a color value at a pixel on the viewport, and
	   * execute a callback with each matching layer. Layers included in the
	   * detection can be configured through `opt_layerFilter`.
	   * @param {import("./pixel.js").Pixel} pixel Pixel.
	   * @param {function(this: S, import("./layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback
	   *     Layer callback. This callback will receive two arguments: first is the
	   *     {@link module:ol/layer/Layer layer}, second argument is an array representing
	   *     [R, G, B, A] pixel values (0 - 255) and will be `null` for layer types
	   *     that do not currently support this argument. To stop detection, callback
	   *     functions can return a truthy value.
	   * @param {AtPixelOptions=} opt_options Configuration options.
	   * @return {T|undefined} Callback result, i.e. the return value of last
	   * callback execution, or the first truthy callback return value.
	   * @template S,T
	   * @api
	   */
	  PluggableMap.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, callback, opt_options) {
	    if (!this.frameState_) {
	      return;
	    }
	    var options = opt_options || /** @type {AtPixelOptions} */ ({});
	    var hitTolerance = options.hitTolerance !== undefined ?
	      opt_options.hitTolerance * this.frameState_.pixelRatio : 0;
	    var layerFilter = options.layerFilter || TRUE;
	    return this.renderer_.forEachLayerAtPixel(
	      pixel, this.frameState_, hitTolerance, callback, null, layerFilter, null);
	  };
	
	  /**
	   * Detect if features intersect a pixel on the viewport. Layers included in the
	   * detection can be configured through `opt_layerFilter`.
	   * @param {import("./pixel.js").Pixel} pixel Pixel.
	   * @param {AtPixelOptions=} opt_options Optional options.
	   * @return {boolean} Is there a feature at the given pixel?
	   * @template U
	   * @api
	   */
	  PluggableMap.prototype.hasFeatureAtPixel = function hasFeatureAtPixel (pixel, opt_options) {
	    if (!this.frameState_) {
	      return false;
	    }
	    var coordinate = this.getCoordinateFromPixel(pixel);
	    opt_options = opt_options !== undefined ? opt_options :
	      /** @type {AtPixelOptions} */ ({});
	    var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : TRUE;
	    var hitTolerance = opt_options.hitTolerance !== undefined ?
	      opt_options.hitTolerance * this.frameState_.pixelRatio : 0;
	    return this.renderer_.hasFeatureAtCoordinate(
	      coordinate, this.frameState_, hitTolerance, layerFilter, null);
	  };
	
	  /**
	   * Returns the coordinate in view projection for a browser event.
	   * @param {Event} event Event.
	   * @return {import("./coordinate.js").Coordinate} Coordinate.
	   * @api
	   */
	  PluggableMap.prototype.getEventCoordinate = function getEventCoordinate (event) {
	    return this.getCoordinateFromPixel(this.getEventPixel(event));
	  };
	
	  /**
	   * Returns the map pixel position for a browser event relative to the viewport.
	   * @param {Event|TouchEvent} event Event.
	   * @return {import("./pixel.js").Pixel} Pixel.
	   * @api
	   */
	  PluggableMap.prototype.getEventPixel = function getEventPixel (event) {
	    var viewportPosition = this.viewport_.getBoundingClientRect();
	    var eventPosition = 'changedTouches' in event ?
	      /** @type {TouchEvent} */ (event).changedTouches[0] :
	      /** @type {MouseEvent} */ (event);
	
	    return [
	      eventPosition.clientX - viewportPosition.left,
	      eventPosition.clientY - viewportPosition.top
	    ];
	  };
	
	  /**
	   * Get the target in which this map is rendered.
	   * Note that this returns what is entered as an option or in setTarget:
	   * if that was an element, it returns an element; if a string, it returns that.
	   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
	   *     map is rendered in.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.getTarget = function getTarget () {
	    return /** @type {HTMLElement|string|undefined} */ (this.get(MapProperty.TARGET));
	  };
	
	  /**
	   * Get the DOM element into which this map is rendered. In contrast to
	   * `getTarget` this method always return an `Element`, or `null` if the
	   * map has no target.
	   * @return {HTMLElement} The element that the map is rendered in.
	   * @api
	   */
	  PluggableMap.prototype.getTargetElement = function getTargetElement () {
	    var target = this.getTarget();
	    if (target !== undefined) {
	      return typeof target === 'string' ? document.getElementById(target) : target;
	    } else {
	      return null;
	    }
	  };
	
	  /**
	   * Get the coordinate for a given pixel.  This returns a coordinate in the
	   * map view projection.
	   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
	   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
	   * @api
	   */
	  PluggableMap.prototype.getCoordinateFromPixel = function getCoordinateFromPixel (pixel) {
	    var frameState = this.frameState_;
	    if (!frameState) {
	      return null;
	    } else {
	      return apply(frameState.pixelToCoordinateTransform, pixel.slice());
	    }
	  };
	
	  /**
	   * Get the map controls. Modifying this collection changes the controls
	   * associated with the map.
	   * @return {Collection<import("./control/Control.js").default>} Controls.
	   * @api
	   */
	  PluggableMap.prototype.getControls = function getControls () {
	    return this.controls;
	  };
	
	  /**
	   * Get the map overlays. Modifying this collection changes the overlays
	   * associated with the map.
	   * @return {Collection<import("./Overlay.js").default>} Overlays.
	   * @api
	   */
	  PluggableMap.prototype.getOverlays = function getOverlays () {
	    return this.overlays_;
	  };
	
	  /**
	   * Get an overlay by its identifier (the value returned by overlay.getId()).
	   * Note that the index treats string and numeric identifiers as the same. So
	   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
	   * @param {string|number} id Overlay identifier.
	   * @return {import("./Overlay.js").default} Overlay.
	   * @api
	   */
	  PluggableMap.prototype.getOverlayById = function getOverlayById (id) {
	    var overlay = this.overlayIdIndex_[id.toString()];
	    return overlay !== undefined ? overlay : null;
	  };
	
	  /**
	   * Get the map interactions. Modifying this collection changes the interactions
	   * associated with the map.
	   *
	   * Interactions are used for e.g. pan, zoom and rotate.
	   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
	   * @api
	   */
	  PluggableMap.prototype.getInteractions = function getInteractions () {
	    return this.interactions;
	  };
	
	  /**
	   * Get the layergroup associated with this map.
	   * @return {LayerGroup} A layer group containing the layers in this map.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.getLayerGroup = function getLayerGroup () {
	    return (
	      /** @type {LayerGroup} */ (this.get(MapProperty.LAYERGROUP))
	    );
	  };
	
	  /**
	   * Get the collection of layers associated with this map.
	   * @return {!Collection<import("./layer/Base.js").default>} Layers.
	   * @api
	   */
	  PluggableMap.prototype.getLayers = function getLayers () {
	    var layers = this.getLayerGroup().getLayers();
	    return layers;
	  };
	
	  /**
	   * Get the pixel for a coordinate.  This takes a coordinate in the map view
	   * projection and returns the corresponding pixel.
	   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
	   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
	   * @api
	   */
	  PluggableMap.prototype.getPixelFromCoordinate = function getPixelFromCoordinate (coordinate) {
	    var frameState = this.frameState_;
	    if (!frameState) {
	      return null;
	    } else {
	      return apply(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
	    }
	  };
	
	  /**
	   * Get the map renderer.
	   * @return {import("./renderer/Map.js").default} Renderer
	   */
	  PluggableMap.prototype.getRenderer = function getRenderer () {
	    return this.renderer_;
	  };
	
	  /**
	   * Get the size of this map.
	   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.getSize = function getSize$$1 () {
	    return (
	      /** @type {import("./size.js").Size|undefined} */ (this.get(MapProperty.SIZE))
	    );
	  };
	
	  /**
	   * Get the view associated with this map. A view manages properties such as
	   * center and resolution.
	   * @return {View} The view that controls this map.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.getView = function getView () {
	    return (
	      /** @type {View} */ (this.get(MapProperty.VIEW))
	    );
	  };
	
	  /**
	   * Get the element that serves as the map viewport.
	   * @return {HTMLElement} Viewport.
	   * @api
	   */
	  PluggableMap.prototype.getViewport = function getViewport () {
	    return this.viewport_;
	  };
	
	  /**
	   * Get the element that serves as the container for overlays.  Elements added to
	   * this container will let mousedown and touchstart events through to the map,
	   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
	   * events.
	   * @return {!HTMLElement} The map's overlay container.
	   */
	  PluggableMap.prototype.getOverlayContainer = function getOverlayContainer () {
	    return this.overlayContainer_;
	  };
	
	  /**
	   * Get the element that serves as a container for overlays that don't allow
	   * event propagation. Elements added to this container won't let mousedown and
	   * touchstart events through to the map, so clicks and gestures on an overlay
	   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
	   * @return {!HTMLElement} The map's overlay container that stops events.
	   */
	  PluggableMap.prototype.getOverlayContainerStopEvent = function getOverlayContainerStopEvent () {
	    return this.overlayContainerStopEvent_;
	  };
	
	  /**
	   * @param {import("./Tile.js").default} tile Tile.
	   * @param {string} tileSourceKey Tile source key.
	   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
	   * @param {number} tileResolution Tile resolution.
	   * @return {number} Tile priority.
	   */
	  PluggableMap.prototype.getTilePriority = function getTilePriority (tile, tileSourceKey, tileCenter, tileResolution) {
	    // Filter out tiles at higher zoom levels than the current zoom level, or that
	    // are outside the visible extent.
	    var frameState = this.frameState_;
	    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) {
	      return DROP;
	    }
	    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) {
	      return DROP;
	    }
	    // Prioritize the highest zoom level tiles closest to the focus.
	    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
	    // Within a zoom level, tiles are prioritized by the distance in pixels
	    // between the center of the tile and the focus.  The factor of 65536 means
	    // that the prioritization should behave as desired for tiles up to
	    // 65536 * Math.log(2) = 45426 pixels from the focus.
	    var deltaX = tileCenter[0] - frameState.focus[0];
	    var deltaY = tileCenter[1] - frameState.focus[1];
	    return 65536 * Math.log(tileResolution) +
	        Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
	  };
	
	  /**
	   * @param {Event} browserEvent Browser event.
	   * @param {string=} opt_type Type.
	   */
	  PluggableMap.prototype.handleBrowserEvent = function handleBrowserEvent (browserEvent, opt_type) {
	    var type = opt_type || browserEvent.type;
	    var mapBrowserEvent = new MapBrowserEvent(type, this, browserEvent);
	    this.handleMapBrowserEvent(mapBrowserEvent);
	  };
	
	  /**
	   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
	   */
	  PluggableMap.prototype.handleMapBrowserEvent = function handleMapBrowserEvent (mapBrowserEvent) {
	    if (!this.frameState_) {
	      // With no view defined, we cannot translate pixels into geographical
	      // coordinates so interactions cannot be used.
	      return;
	    }
	    this.focus_ = mapBrowserEvent.coordinate;
	    mapBrowserEvent.frameState = this.frameState_;
	    var interactionsArray = this.getInteractions().getArray();
	    if (this.dispatchEvent(mapBrowserEvent) !== false) {
	      for (var i = interactionsArray.length - 1; i >= 0; i--) {
	        var interaction = interactionsArray[i];
	        if (!interaction.getActive()) {
	          continue;
	        }
	        var cont = interaction.handleEvent(mapBrowserEvent);
	        if (!cont) {
	          break;
	        }
	      }
	    }
	  };
	
	  /**
	   * @protected
	   */
	  PluggableMap.prototype.handlePostRender = function handlePostRender () {
	
	    var frameState = this.frameState_;
	
	    // Manage the tile queue
	    // Image loads are expensive and a limited resource, so try to use them
	    // efficiently:
	    // * When the view is static we allow a large number of parallel tile loads
	    //   to complete the frame as quickly as possible.
	    // * When animating or interacting, image loads can cause janks, so we reduce
	    //   the maximum number of loads per frame and limit the number of parallel
	    //   tile loads to remain reactive to view changes and to reduce the chance of
	    //   loading tiles that will quickly disappear from view.
	    var tileQueue = this.tileQueue_;
	    if (!tileQueue.isEmpty()) {
	      var maxTotalLoading = this.maxTilesLoading_;
	      var maxNewLoads = maxTotalLoading;
	      if (frameState) {
	        var hints = frameState.viewHints;
	        if (hints[ViewHint.ANIMATING]) {
	          maxTotalLoading = this.loadTilesWhileAnimating_ ? 8 : 0;
	          maxNewLoads = 2;
	        }
	        if (hints[ViewHint.INTERACTING]) {
	          maxTotalLoading = this.loadTilesWhileInteracting_ ? 8 : 0;
	          maxNewLoads = 2;
	        }
	      }
	      if (tileQueue.getTilesLoading() < maxTotalLoading) {
	        tileQueue.reprioritize(); // FIXME only call if view has changed
	        tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
	      }
	    }
	    if (frameState && this.hasListener(RenderEventType.RENDERCOMPLETE) && !frameState.animate &&
	        !this.tileQueue_.getTilesLoading() && !getLoading(this.getLayers().getArray())) {
	      this.renderer_.dispatchRenderEvent(RenderEventType.RENDERCOMPLETE, frameState);
	    }
	
	    var postRenderFunctions = this.postRenderFunctions_;
	    for (var i = 0, ii = postRenderFunctions.length; i < ii; ++i) {
	      postRenderFunctions[i](this, frameState);
	    }
	    postRenderFunctions.length = 0;
	  };
	
	  /**
	   * @private
	   */
	  PluggableMap.prototype.handleSizeChanged_ = function handleSizeChanged_ () {
	    this.render();
	  };
	
	  /**
	   * @private
	   */
	  PluggableMap.prototype.handleTargetChanged_ = function handleTargetChanged_ () {
	    // target may be undefined, null, a string or an Element.
	    // If it's a string we convert it to an Element before proceeding.
	    // If it's not now an Element we remove the viewport from the DOM.
	    // If it's an Element we append the viewport element to it.
	
	    var targetElement;
	    if (this.getTarget()) {
	      targetElement = this.getTargetElement();
	    }
	
	    if (this.keyHandlerKeys_) {
	      for (var i = 0, ii = this.keyHandlerKeys_.length; i < ii; ++i) {
	        unlistenByKey(this.keyHandlerKeys_[i]);
	      }
	      this.keyHandlerKeys_ = null;
	    }
	
	    if (!targetElement) {
	      this.renderer_.removeLayerRenderers();
	      removeNode(this.viewport_);
	      if (this.handleResize_ !== undefined) {
	        removeEventListener(EventType.RESIZE, this.handleResize_, false);
	        this.handleResize_ = undefined;
	      }
	    } else {
	      targetElement.appendChild(this.viewport_);
	
	      var keyboardEventTarget = !this.keyboardEventTarget_ ?
	        targetElement : this.keyboardEventTarget_;
	      this.keyHandlerKeys_ = [
	        listen(keyboardEventTarget, EventType.KEYDOWN, this.handleBrowserEvent, this),
	        listen(keyboardEventTarget, EventType.KEYPRESS, this.handleBrowserEvent, this)
	      ];
	
	      if (!this.handleResize_) {
	        this.handleResize_ = this.updateSize.bind(this);
	        addEventListener(EventType.RESIZE, this.handleResize_, false);
	      }
	    }
	
	    this.updateSize();
	    // updateSize calls setSize, so no need to call this.render
	    // ourselves here.
	  };
	
	  /**
	   * @private
	   */
	  PluggableMap.prototype.handleTileChange_ = function handleTileChange_ () {
	    this.render();
	  };
	
	  /**
	   * @private
	   */
	  PluggableMap.prototype.handleViewPropertyChanged_ = function handleViewPropertyChanged_ () {
	    this.render();
	  };
	
	  /**
	   * @private
	   */
	  PluggableMap.prototype.handleViewChanged_ = function handleViewChanged_ () {
	    if (this.viewPropertyListenerKey_) {
	      unlistenByKey(this.viewPropertyListenerKey_);
	      this.viewPropertyListenerKey_ = null;
	    }
	    if (this.viewChangeListenerKey_) {
	      unlistenByKey(this.viewChangeListenerKey_);
	      this.viewChangeListenerKey_ = null;
	    }
	    var view = this.getView();
	    if (view) {
	      this.viewport_.setAttribute('data-view', getUid(view));
	      this.viewPropertyListenerKey_ = listen(
	        view, ObjectEventType.PROPERTYCHANGE,
	        this.handleViewPropertyChanged_, this);
	      this.viewChangeListenerKey_ = listen(
	        view, EventType.CHANGE,
	        this.handleViewPropertyChanged_, this);
	    }
	    this.render();
	  };
	
	  /**
	   * @private
	   */
	  PluggableMap.prototype.handleLayerGroupChanged_ = function handleLayerGroupChanged_ () {
	    if (this.layerGroupPropertyListenerKeys_) {
	      this.layerGroupPropertyListenerKeys_.forEach(unlistenByKey);
	      this.layerGroupPropertyListenerKeys_ = null;
	    }
	    var layerGroup = this.getLayerGroup();
	    if (layerGroup) {
	      this.layerGroupPropertyListenerKeys_ = [
	        listen(
	          layerGroup, ObjectEventType.PROPERTYCHANGE,
	          this.render, this),
	        listen(
	          layerGroup, EventType.CHANGE,
	          this.render, this)
	      ];
	    }
	    this.render();
	  };
	
	  /**
	   * @return {boolean} Is rendered.
	   */
	  PluggableMap.prototype.isRendered = function isRendered () {
	    return !!this.frameState_;
	  };
	
	  /**
	   * Requests an immediate render in a synchronous manner.
	   * @api
	   */
	  PluggableMap.prototype.renderSync = function renderSync () {
	    if (this.animationDelayKey_) {
	      cancelAnimationFrame(this.animationDelayKey_);
	    }
	    this.animationDelay_();
	  };
	
	  /**
	   * Request a map rendering (at the next animation frame).
	   * @api
	   */
	  PluggableMap.prototype.render = function render () {
	    if (this.animationDelayKey_ === undefined) {
	      this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
	    }
	  };
	
	  /**
	   * Remove the given control from the map.
	   * @param {import("./control/Control.js").default} control Control.
	   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
	   *     if the control was not found).
	   * @api
	   */
	  PluggableMap.prototype.removeControl = function removeControl (control) {
	    return this.getControls().remove(control);
	  };
	
	  /**
	   * Remove the given interaction from the map.
	   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
	   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
	   *     undefined if the interaction was not found).
	   * @api
	   */
	  PluggableMap.prototype.removeInteraction = function removeInteraction (interaction) {
	    return this.getInteractions().remove(interaction);
	  };
	
	  /**
	   * Removes the given layer from the map.
	   * @param {import("./layer/Base.js").default} layer Layer.
	   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
	   *     layer was not found).
	   * @api
	   */
	  PluggableMap.prototype.removeLayer = function removeLayer (layer) {
	    var layers = this.getLayerGroup().getLayers();
	    return layers.remove(layer);
	  };
	
	  /**
	   * Remove the given overlay from the map.
	   * @param {import("./Overlay.js").default} overlay Overlay.
	   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
	   *     if the overlay was not found).
	   * @api
	   */
	  PluggableMap.prototype.removeOverlay = function removeOverlay (overlay) {
	    return this.getOverlays().remove(overlay);
	  };
	
	  /**
	   * @param {number} time Time.
	   * @private
	   */
	  PluggableMap.prototype.renderFrame_ = function renderFrame_ (time) {
	    var viewState;
	
	    var size = this.getSize();
	    var view = this.getView();
	    var extent = createEmpty();
	    var previousFrameState = this.frameState_;
	    /** @type {?FrameState} */
	    var frameState = null;
	    if (size !== undefined && hasArea(size) && view && view.isDef()) {
	      var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
	      var layerStatesArray = this.getLayerGroup().getLayerStatesArray();
	      var layerStates = {};
	      for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
	        layerStates[getUid(layerStatesArray[i].layer)] = layerStatesArray[i];
	      }
	      viewState = view.getState(this.pixelRatio_);
	      frameState = /** @type {FrameState} */ ({
	        animate: false,
	        coordinateToPixelTransform: this.coordinateToPixelTransform_,
	        extent: extent,
	        focus: this.focus_ ? this.focus_ : viewState.center,
	        index: this.frameIndex_++,
	        layerStates: layerStates,
	        layerStatesArray: layerStatesArray,
	        pixelRatio: this.pixelRatio_,
	        pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
	        postRenderFunctions: [],
	        size: size,
	        skippedFeatureUids: this.skippedFeatureUids_,
	        tileQueue: this.tileQueue_,
	        time: time,
	        usedTiles: {},
	        viewState: viewState,
	        viewHints: viewHints,
	        wantedTiles: {}
	      });
	    }
	
	    if (frameState) {
	      frameState.extent = getForViewAndSize(viewState.center,
	        viewState.resolution, viewState.rotation, frameState.size, extent);
	    }
	
	    this.frameState_ = frameState;
	    this.renderer_.renderFrame(frameState);
	
	    if (frameState) {
	      if (frameState.animate) {
	        this.render();
	      }
	      Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
	
	      if (previousFrameState) {
	        var moveStart = !this.previousExtent_ ||
	                    (!isEmpty$1(this.previousExtent_) &&
	                    !equals$1(frameState.extent, this.previousExtent_));
	        if (moveStart) {
	          this.dispatchEvent(
	            new MapEvent(MapEventType.MOVESTART, this, previousFrameState));
	          this.previousExtent_ = createOrUpdateEmpty(this.previousExtent_);
	        }
	      }
	
	      var idle = this.previousExtent_ &&
	          !frameState.viewHints[ViewHint.ANIMATING] &&
	          !frameState.viewHints[ViewHint.INTERACTING] &&
	          !equals$1(frameState.extent, this.previousExtent_);
	
	      if (idle) {
	        this.dispatchEvent(new MapEvent(MapEventType.MOVEEND, this, frameState));
	        clone(frameState.extent, this.previousExtent_);
	      }
	    }
	
	    this.dispatchEvent(new MapEvent(MapEventType.POSTRENDER, this, frameState));
	
	    setTimeout(this.handlePostRender.bind(this), 0);
	
	  };
	
	  /**
	   * Sets the layergroup of this map.
	   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.setLayerGroup = function setLayerGroup (layerGroup) {
	    this.set(MapProperty.LAYERGROUP, layerGroup);
	  };
	
	  /**
	   * Set the size of this map.
	   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.setSize = function setSize (size) {
	    this.set(MapProperty.SIZE, size);
	  };
	
	  /**
	   * Set the target element to render this map into.
	   * @param {HTMLElement|string|undefined} target The Element or id of the Element
	   *     that the map is rendered in.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.setTarget = function setTarget (target) {
	    this.set(MapProperty.TARGET, target);
	  };
	
	  /**
	   * Set the view for this map.
	   * @param {View} view The view that controls this map.
	   * @observable
	   * @api
	   */
	  PluggableMap.prototype.setView = function setView (view) {
	    this.set(MapProperty.VIEW, view);
	  };
	
	  /**
	   * @param {import("./Feature.js").default} feature Feature.
	   */
	  PluggableMap.prototype.skipFeature = function skipFeature (feature) {
	    this.skippedFeatureUids_[getUid(feature)] = true;
	    this.render();
	  };
	
	  /**
	   * Force a recalculation of the map viewport size.  This should be called when
	   * third-party code changes the size of the map viewport.
	   * @api
	   */
	  PluggableMap.prototype.updateSize = function updateSize () {
	    var targetElement = this.getTargetElement();
	
	    if (!targetElement) {
	      this.setSize(undefined);
	    } else {
	      var computedStyle = getComputedStyle(targetElement);
	      this.setSize([
	        targetElement.offsetWidth -
	            parseFloat(computedStyle['borderLeftWidth']) -
	            parseFloat(computedStyle['paddingLeft']) -
	            parseFloat(computedStyle['paddingRight']) -
	            parseFloat(computedStyle['borderRightWidth']),
	        targetElement.offsetHeight -
	            parseFloat(computedStyle['borderTopWidth']) -
	            parseFloat(computedStyle['paddingTop']) -
	            parseFloat(computedStyle['paddingBottom']) -
	            parseFloat(computedStyle['borderBottomWidth'])
	      ]);
	    }
	  };
	
	  /**
	   * @param {import("./Feature.js").default} feature Feature.
	   */
	  PluggableMap.prototype.unskipFeature = function unskipFeature (feature) {
	    delete this.skippedFeatureUids_[getUid(feature)];
	    this.render();
	  };
	
	  return PluggableMap;
	}(BaseObject));
	
	
	/**
	 * @param {MapOptions} options Map options.
	 * @return {MapOptionsInternal} Internal map options.
	 */
	function createOptionsInternal(options) {
	
	  /**
	   * @type {HTMLElement|Document}
	   */
	  var keyboardEventTarget = null;
	  if (options.keyboardEventTarget !== undefined) {
	    keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ?
	      document.getElementById(options.keyboardEventTarget) :
	      options.keyboardEventTarget;
	  }
	
	  /**
	   * @type {Object<string, *>}
	   */
	  var values = {};
	
	  var layerGroup = options.layers && typeof /** @type {?} */ (options.layers).getLayers === 'function' ?
	    /** @type {LayerGroup} */ (options.layers) : new LayerGroup({layers: /** @type {Collection} */ (options.layers)});
	  values[MapProperty.LAYERGROUP] = layerGroup;
	
	  values[MapProperty.TARGET] = options.target;
	
	  values[MapProperty.VIEW] = options.view !== undefined ?
	    options.view : new View();
	
	  var controls;
	  if (options.controls !== undefined) {
	    if (Array.isArray(options.controls)) {
	      controls = new Collection(options.controls.slice());
	    } else {
	      assert(typeof /** @type {?} */ (options.controls).getArray === 'function',
	        47); // Expected `controls` to be an array or an `import("./Collection.js").Collection`
	      controls = /** @type {Collection} */ (options.controls);
	    }
	  }
	
	  var interactions;
	  if (options.interactions !== undefined) {
	    if (Array.isArray(options.interactions)) {
	      interactions = new Collection(options.interactions.slice());
	    } else {
	      assert(typeof /** @type {?} */ (options.interactions).getArray === 'function',
	        48); // Expected `interactions` to be an array or an `import("./Collection.js").Collection`
	      interactions = /** @type {Collection} */ (options.interactions);
	    }
	  }
	
	  var overlays;
	  if (options.overlays !== undefined) {
	    if (Array.isArray(options.overlays)) {
	      overlays = new Collection(options.overlays.slice());
	    } else {
	      assert(typeof /** @type {?} */ (options.overlays).getArray === 'function',
	        49); // Expected `overlays` to be an array or an `import("./Collection.js").Collection`
	      overlays = options.overlays;
	    }
	  } else {
	    overlays = new Collection();
	  }
	
	  return {
	    controls: controls,
	    interactions: interactions,
	    keyboardEventTarget: keyboardEventTarget,
	    overlays: overlays,
	    values: values
	  };
	
	}
	
	/**
	 * @param  {Array<import("./layer/Base.js").default>} layers Layers.
	 * @return {boolean} Layers have sources that are still loading.
	 */
	function getLoading(layers) {
	  for (var i = 0, ii = layers.length; i < ii; ++i) {
	    var layer = layers[i];
	    if (typeof /** @type {?} */ (layer).getLayers === 'function') {
	      return getLoading(/** @type {LayerGroup} */ (layer).getLayers().getArray());
	    } else {
	      var source = /** @type {import("./layer/Layer.js").default} */ (
	        layer).getSource();
	      if (source && source.loading) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	/**
	 * @module ol/control/Control
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {HTMLElement} [element] The element is the control's
	 * container element. This only needs to be specified if you're developing
	 * a custom control.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when
	 * the control should be re-rendered. This is called in a `requestAnimationFrame`
	 * callback.
	 * @property {HTMLElement|string} [target] Specify a target if you want
	 * the control to be rendered outside of the map's viewport.
	 */
	
	
	/**
	 * @classdesc
	 * A control is a visible widget with a DOM element in a fixed position on the
	 * screen. They can involve user input (buttons), or be informational only;
	 * the position is determined using CSS. By default these are placed in the
	 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
	 * any outside DOM element.
	 *
	 * This is the base class for controls. You can use it for simple custom
	 * controls by creating the element with listeners, creating an instance:
	 * ```js
	 * var myControl = new Control({element: myElement});
	 * ```
	 * and then adding this to the map.
	 *
	 * The main advantage of having this as a control rather than a simple separate
	 * DOM element is that preventing propagation is handled for you. Controls
	 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
	 *
	 * You can also extend this base for your own control class. See
	 * examples/custom-controls for an example of how to do this.
	 *
	 * @api
	 */
	var Control = /*@__PURE__*/(function (BaseObject$$1) {
	  function Control(options) {
	
	    BaseObject$$1.call(this);
	
	    /**
	     * @protected
	     * @type {HTMLElement}
	     */
	    this.element = options.element ? options.element : null;
	
	    /**
	     * @private
	     * @type {HTMLElement}
	     */
	    this.target_ = null;
	
	    /**
	     * @private
	     * @type {import("../PluggableMap.js").default}
	     */
	    this.map_ = null;
	
	    /**
	     * @protected
	     * @type {!Array<import("../events.js").EventsKey>}
	     */
	    this.listenerKeys = [];
	
	    /**
	     * @type {function(import("../MapEvent.js").default)}
	     */
	    this.render = options.render ? options.render : VOID;
	
	    if (options.target) {
	      this.setTarget(options.target);
	    }
	
	  }
	
	  if ( BaseObject$$1 ) { Control.__proto__ = BaseObject$$1; }
	  Control.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Control.prototype.constructor = Control;
	
	  /**
	   * @inheritDoc
	   */
	  Control.prototype.disposeInternal = function disposeInternal () {
	    removeNode(this.element);
	    BaseObject$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * Get the map associated with this control.
	   * @return {import("../PluggableMap.js").default} Map.
	   * @api
	   */
	  Control.prototype.getMap = function getMap () {
	    return this.map_;
	  };
	
	  /**
	   * Remove the control from its current map and attach it to the new map.
	   * Subclasses may set up event handlers to get notified about changes to
	   * the map here.
	   * @param {import("../PluggableMap.js").default} map Map.
	   * @api
	   */
	  Control.prototype.setMap = function setMap (map) {
	    if (this.map_) {
	      removeNode(this.element);
	    }
	    for (var i = 0, ii = this.listenerKeys.length; i < ii; ++i) {
	      unlistenByKey(this.listenerKeys[i]);
	    }
	    this.listenerKeys.length = 0;
	    this.map_ = map;
	    if (this.map_) {
	      var target = this.target_ ?
	        this.target_ : map.getOverlayContainerStopEvent();
	      target.appendChild(this.element);
	      if (this.render !== VOID) {
	        this.listenerKeys.push(listen(map,
	          MapEventType.POSTRENDER, this.render, this));
	      }
	      map.render();
	    }
	  };
	
	  /**
	   * This function is used to set a target element for the control. It has no
	   * effect if it is called after the control has been added to the map (i.e.
	   * after `setMap` is called on the control). If no `target` is set in the
	   * options passed to the control constructor and if `setTarget` is not called
	   * then the control is added to the map's overlay container.
	   * @param {HTMLElement|string} target Target.
	   * @api
	   */
	  Control.prototype.setTarget = function setTarget (target) {
	    this.target_ = typeof target === 'string' ?
	      document.getElementById(target) :
	      target;
	  };
	
	  return Control;
	}(BaseObject));
	
	/**
	 * @module ol/css
	 */
	
	
	/**
	 * The CSS class for hidden feature.
	 *
	 * @const
	 * @type {string}
	 */
	var CLASS_HIDDEN = 'ol-hidden';
	
	
	/**
	 * The CSS class that we'll give the DOM elements to have them selectable.
	 *
	 * @const
	 * @type {string}
	 */
	var CLASS_SELECTABLE = 'ol-selectable';
	
	
	/**
	 * The CSS class that we'll give the DOM elements to have them unselectable.
	 *
	 * @const
	 * @type {string}
	 */
	var CLASS_UNSELECTABLE = 'ol-unselectable';
	
	
	/**
	 * The CSS class for unsupported feature.
	 *
	 * @const
	 * @type {string}
	 */
	var CLASS_UNSUPPORTED = 'ol-unsupported';
	
	
	/**
	 * The CSS class for controls.
	 *
	 * @const
	 * @type {string}
	 */
	var CLASS_CONTROL = 'ol-control';
	
	
	/**
	 * The CSS class that we'll give the DOM elements that are collapsed, i.e.
	 * to those elements which usually can be expanded.
	 *
	 * @const
	 * @type {string}
	 */
	var CLASS_COLLAPSED = 'ol-collapsed';
	
	
	/**
	 * Get the list of font families from a font spec.  Note that this doesn't work
	 * for font families that have commas in them.
	 * @param {string} The CSS font property.
	 * @return {Object<string>} The font families (or null if the input spec is invalid).
	 */
	var getFontFamilies = (function() {
	  var style;
	  var cache = {};
	  return function(font) {
	    if (!style) {
	      style = document.createElement('div').style;
	    }
	    if (!(font in cache)) {
	      style.font = font;
	      var family = style.fontFamily;
	      style.font = '';
	      if (!family) {
	        return null;
	      }
	      cache[font] = family.split(/,\s?/);
	    }
	    return cache[font];
	  };
	})();
	
	/**
	 * @module ol/layer/Layer
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {import("../source/Source.js").default} [source] Source for this layer.  If not provided to the constructor,
	 * the source can be set by calling {@link module:ol/layer/Layer#setSource layer.setSource(source)} after
	 * construction.
	 * @property {import("../PluggableMap.js").default} [map] Map.
	 */
	
	
	/**
	 * @typedef {Object} State
	 * @property {import("./Base.js").default} layer
	 * @property {number} opacity
	 * @property {SourceState} sourceState
	 * @property {boolean} visible
	 * @property {boolean} managed
	 * @property {import("../extent.js").Extent} [extent]
	 * @property {number} zIndex
	 * @property {number} maxResolution
	 * @property {number} minResolution
	 */
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * A visual representation of raster or vector map data.
	 * Layers group together those properties that pertain to how the data is to be
	 * displayed, irrespective of the source of that data.
	 *
	 * Layers are usually added to a map with {@link module:ol/Map#addLayer}. Components
	 * like {@link module:ol/interaction/Select~Select} use unmanaged layers
	 * internally. These unmanaged layers are associated with the map using
	 * {@link module:ol/layer/Layer~Layer#setMap} instead.
	 *
	 * A generic `change` event is fired when the state of the source changes.
	 *
	 * @fires import("../render/Event.js").RenderEvent
	 */
	var Layer = /*@__PURE__*/(function (BaseLayer$$1) {
	  function Layer(options) {
	
	    var baseOptions = assign({}, options);
	    delete baseOptions.source;
	
	    BaseLayer$$1.call(this, baseOptions);
	
	    /**
	     * @private
	     * @type {?import("../events.js").EventsKey}
	     */
	    this.mapPrecomposeKey_ = null;
	
	    /**
	     * @private
	     * @type {?import("../events.js").EventsKey}
	     */
	    this.mapRenderKey_ = null;
	
	    /**
	     * @private
	     * @type {?import("../events.js").EventsKey}
	     */
	    this.sourceChangeKey_ = null;
	
	    if (options.map) {
	      this.setMap(options.map);
	    }
	
	    listen(this,
	      getChangeEventType(LayerProperty.SOURCE),
	      this.handleSourcePropertyChange_, this);
	
	    var source = options.source ? options.source : null;
	    this.setSource(source);
	  }
	
	  if ( BaseLayer$$1 ) { Layer.__proto__ = BaseLayer$$1; }
	  Layer.prototype = Object.create( BaseLayer$$1 && BaseLayer$$1.prototype );
	  Layer.prototype.constructor = Layer;
	
	  /**
	   * @inheritDoc
	   */
	  Layer.prototype.getLayersArray = function getLayersArray (opt_array) {
	    var array = opt_array ? opt_array : [];
	    array.push(this);
	    return array;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Layer.prototype.getLayerStatesArray = function getLayerStatesArray (opt_states) {
	    var states = opt_states ? opt_states : [];
	    states.push(this.getLayerState());
	    return states;
	  };
	
	  /**
	   * Get the layer source.
	   * @return {import("../source/Source.js").default} The layer source (or `null` if not yet set).
	   * @observable
	   * @api
	   */
	  Layer.prototype.getSource = function getSource () {
	    var source = this.get(LayerProperty.SOURCE);
	    return (
	      /** @type {import("../source/Source.js").default} */ (source) || null
	    );
	  };
	
	  /**
	    * @inheritDoc
	    */
	  Layer.prototype.getSourceState = function getSourceState () {
	    var source = this.getSource();
	    return !source ? SourceState.UNDEFINED : source.getState();
	  };
	
	  /**
	   * @private
	   */
	  Layer.prototype.handleSourceChange_ = function handleSourceChange_ () {
	    this.changed();
	  };
	
	  /**
	   * @private
	   */
	  Layer.prototype.handleSourcePropertyChange_ = function handleSourcePropertyChange_ () {
	    if (this.sourceChangeKey_) {
	      unlistenByKey(this.sourceChangeKey_);
	      this.sourceChangeKey_ = null;
	    }
	    var source = this.getSource();
	    if (source) {
	      this.sourceChangeKey_ = listen(source,
	        EventType.CHANGE, this.handleSourceChange_, this);
	    }
	    this.changed();
	  };
	
	  /**
	   * Sets the layer to be rendered on top of other layers on a map. The map will
	   * not manage this layer in its layers collection, and the callback in
	   * {@link module:ol/Map#forEachLayerAtPixel} will receive `null` as layer. This
	   * is useful for temporary layers. To remove an unmanaged layer from the map,
	   * use `#setMap(null)`.
	   *
	   * To add the layer to a map and have it managed by the map, use
	   * {@link module:ol/Map#addLayer} instead.
	   * @param {import("../PluggableMap.js").default} map Map.
	   * @api
	   */
	  Layer.prototype.setMap = function setMap (map) {
	    if (this.mapPrecomposeKey_) {
	      unlistenByKey(this.mapPrecomposeKey_);
	      this.mapPrecomposeKey_ = null;
	    }
	    if (!map) {
	      this.changed();
	    }
	    if (this.mapRenderKey_) {
	      unlistenByKey(this.mapRenderKey_);
	      this.mapRenderKey_ = null;
	    }
	    if (map) {
	      this.mapPrecomposeKey_ = listen(map, RenderEventType.PRECOMPOSE, function(evt) {
	        var renderEvent = /** @type {import("../render/Event.js").default} */ (evt);
	        var layerState = this.getLayerState();
	        layerState.managed = false;
	        if (this.getZIndex() === undefined) {
	          layerState.zIndex = Infinity;
	        }
	        renderEvent.frameState.layerStatesArray.push(layerState);
	        renderEvent.frameState.layerStates[getUid(this)] = layerState;
	      }, this);
	      this.mapRenderKey_ = listen(this, EventType.CHANGE, map.render, map);
	      this.changed();
	    }
	  };
	
	  /**
	   * Set the layer source.
	   * @param {import("../source/Source.js").default} source The layer source.
	   * @observable
	   * @api
	   */
	  Layer.prototype.setSource = function setSource (source) {
	    this.set(LayerProperty.SOURCE, source);
	  };
	
	  return Layer;
	}(BaseLayer));
	
	
	/**
	 * Return `true` if the layer is visible, and if the passed resolution is
	 * between the layer's minResolution and maxResolution. The comparison is
	 * inclusive for `minResolution` and exclusive for `maxResolution`.
	 * @param {State} layerState Layer state.
	 * @param {number} resolution Resolution.
	 * @return {boolean} The layer is visible at the given resolution.
	 * @api
	 */
	function visibleAtResolution(layerState, resolution) {
	  return layerState.visible && resolution >= layerState.minResolution &&
	      resolution < layerState.maxResolution;
	}
	
	/**
	 * @module ol/control/Attribution
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-attribution'] CSS class name.
	 * @property {HTMLElement|string} [target] Specify a target if you
	 * want the control to be rendered outside of the map's
	 * viewport.
	 * @property {boolean} [collapsible] Specify if attributions can
	 * be collapsed. If not specified, sources control this behavior with their
	 * `attributionsCollapsible` setting.
	 * @property {boolean} [collapsed=true] Specify if attributions should
	 * be collapsed at startup.
	 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
	 * @property {string} [label='i'] Text label to use for the
	 * collapsed attributions button.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string|HTMLElement} [collapseLabel='»'] Text label to use
	 * for the expanded attributions button.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when
	 * the control should be re-rendered. This is called in a `requestAnimationFrame`
	 * callback.
	 */
	
	
	/**
	 * @classdesc
	 * Control to show all the attributions associated with the layer sources
	 * in the map. This control is one of the default controls included in maps.
	 * By default it will show in the bottom right portion of the map, but this can
	 * be changed by using a css selector for `.ol-attribution`.
	 *
	 * @api
	 */
	var Attribution = /*@__PURE__*/(function (Control$$1) {
	  function Attribution(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      render: options.render || render,
	      target: options.target
	    });
	
	    /**
	     * @private
	     * @type {HTMLElement}
	     */
	    this.ulElement_ = document.createElement('ul');
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.overrideCollapsible_ = options.collapsible !== undefined;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.collapsible_ = options.collapsible !== undefined ?
	      options.collapsible : true;
	
	    if (!this.collapsible_) {
	      this.collapsed_ = false;
	    }
	
	    var className = options.className !== undefined ? options.className : 'ol-attribution';
	
	    var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
	
	    var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00BB';
	
	    if (typeof collapseLabel === 'string') {
	      /**
	       * @private
	       * @type {HTMLElement}
	       */
	      this.collapseLabel_ = document.createElement('span');
	      this.collapseLabel_.textContent = collapseLabel;
	    } else {
	      this.collapseLabel_ = collapseLabel;
	    }
	
	    var label = options.label !== undefined ? options.label : 'i';
	
	    if (typeof label === 'string') {
	      /**
	       * @private
	       * @type {HTMLElement}
	       */
	      this.label_ = document.createElement('span');
	      this.label_.textContent = label;
	    } else {
	      this.label_ = label;
	    }
	
	
	    var activeLabel = (this.collapsible_ && !this.collapsed_) ?
	      this.collapseLabel_ : this.label_;
	    var button = document.createElement('button');
	    button.setAttribute('type', 'button');
	    button.title = tipLabel;
	    button.appendChild(activeLabel);
	
	    listen(button, EventType.CLICK, this.handleClick_, this);
	
	    var cssClasses = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL +
	        (this.collapsed_ && this.collapsible_ ? ' ' + CLASS_COLLAPSED : '') +
	        (this.collapsible_ ? '' : ' ol-uncollapsible');
	    var element = this.element;
	    element.className = cssClasses;
	    element.appendChild(this.ulElement_);
	    element.appendChild(button);
	
	    /**
	     * A list of currently rendered resolutions.
	     * @type {Array<string>}
	     * @private
	     */
	    this.renderedAttributions_ = [];
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderedVisible_ = true;
	
	  }
	
	  if ( Control$$1 ) { Attribution.__proto__ = Control$$1; }
	  Attribution.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  Attribution.prototype.constructor = Attribution;
	
	  /**
	   * Collect a list of visible attributions and set the collapsible state.
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @return {Array<string>} Attributions.
	   * @private
	   */
	  Attribution.prototype.collectSourceAttributions_ = function collectSourceAttributions_ (frameState) {
	    /**
	     * Used to determine if an attribution already exists.
	     * @type {!Object<string, boolean>}
	     */
	    var lookup = {};
	
	    /**
	     * A list of visible attributions.
	     * @type {Array<string>}
	     */
	    var visibleAttributions = [];
	
	    var layerStatesArray = frameState.layerStatesArray;
	    var resolution = frameState.viewState.resolution;
	    for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
	      var layerState = layerStatesArray[i];
	      if (!visibleAtResolution(layerState, resolution)) {
	        continue;
	      }
	
	      var source = /** @type {import("../layer/Layer.js").default} */ (layerState.layer).getSource();
	      if (!source) {
	        continue;
	      }
	
	      var attributionGetter = source.getAttributions();
	      if (!attributionGetter) {
	        continue;
	      }
	
	      var attributions = attributionGetter(frameState);
	      if (!attributions) {
	        continue;
	      }
	
	      if (!this.overrideCollapsible_ && source.getAttributionsCollapsible() === false) {
	        this.setCollapsible(false);
	      }
	
	      if (Array.isArray(attributions)) {
	        for (var j = 0, jj = attributions.length; j < jj; ++j) {
	          if (!(attributions[j] in lookup)) {
	            visibleAttributions.push(attributions[j]);
	            lookup[attributions[j]] = true;
	          }
	        }
	      } else {
	        if (!(attributions in lookup)) {
	          visibleAttributions.push(attributions);
	          lookup[attributions] = true;
	        }
	      }
	    }
	    return visibleAttributions;
	  };
	
	  /**
	   * @private
	   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
	   */
	  Attribution.prototype.updateElement_ = function updateElement_ (frameState) {
	    if (!frameState) {
	      if (this.renderedVisible_) {
	        this.element.style.display = 'none';
	        this.renderedVisible_ = false;
	      }
	      return;
	    }
	
	    var attributions = this.collectSourceAttributions_(frameState);
	
	    var visible = attributions.length > 0;
	    if (this.renderedVisible_ != visible) {
	      this.element.style.display = visible ? '' : 'none';
	      this.renderedVisible_ = visible;
	    }
	
	    if (equals(attributions, this.renderedAttributions_)) {
	      return;
	    }
	
	    removeChildren(this.ulElement_);
	
	    // append the attributions
	    for (var i = 0, ii = attributions.length; i < ii; ++i) {
	      var element = document.createElement('li');
	      element.innerHTML = attributions[i];
	      this.ulElement_.appendChild(element);
	    }
	
	    this.renderedAttributions_ = attributions;
	  };
	
	  /**
	   * @param {MouseEvent} event The event to handle
	   * @private
	   */
	  Attribution.prototype.handleClick_ = function handleClick_ (event) {
	    event.preventDefault();
	    this.handleToggle_();
	  };
	
	  /**
	   * @private
	   */
	  Attribution.prototype.handleToggle_ = function handleToggle_ () {
	    this.element.classList.toggle(CLASS_COLLAPSED);
	    if (this.collapsed_) {
	      replaceNode(this.collapseLabel_, this.label_);
	    } else {
	      replaceNode(this.label_, this.collapseLabel_);
	    }
	    this.collapsed_ = !this.collapsed_;
	  };
	
	  /**
	   * Return `true` if the attribution is collapsible, `false` otherwise.
	   * @return {boolean} True if the widget is collapsible.
	   * @api
	   */
	  Attribution.prototype.getCollapsible = function getCollapsible () {
	    return this.collapsible_;
	  };
	
	  /**
	   * Set whether the attribution should be collapsible.
	   * @param {boolean} collapsible True if the widget is collapsible.
	   * @api
	   */
	  Attribution.prototype.setCollapsible = function setCollapsible (collapsible) {
	    if (this.collapsible_ === collapsible) {
	      return;
	    }
	    this.collapsible_ = collapsible;
	    this.element.classList.toggle('ol-uncollapsible');
	    if (!collapsible && this.collapsed_) {
	      this.handleToggle_();
	    }
	  };
	
	  /**
	   * Collapse or expand the attribution according to the passed parameter. Will
	   * not do anything if the attribution isn't collapsible or if the current
	   * collapsed state is already the one requested.
	   * @param {boolean} collapsed True if the widget is collapsed.
	   * @api
	   */
	  Attribution.prototype.setCollapsed = function setCollapsed (collapsed) {
	    if (!this.collapsible_ || this.collapsed_ === collapsed) {
	      return;
	    }
	    this.handleToggle_();
	  };
	
	  /**
	   * Return `true` when the attribution is currently collapsed or `false`
	   * otherwise.
	   * @return {boolean} True if the widget is collapsed.
	   * @api
	   */
	  Attribution.prototype.getCollapsed = function getCollapsed () {
	    return this.collapsed_;
	  };
	
	  return Attribution;
	}(Control));
	
	
	/**
	 * Update the attribution element.
	 * @param {import("../MapEvent.js").default} mapEvent Map event.
	 * @this {Attribution}
	 * @api
	 */
	function render(mapEvent) {
	  this.updateElement_(mapEvent.frameState);
	}
	
	/**
	 * @module ol/control/Rotate
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-rotate'] CSS class name.
	 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
	 * @property {number} [duration=250] Animation duration in milliseconds.
	 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when the control should
	 * be re-rendered. This is called in a `requestAnimationFrame` callback.
	 * @property {function()} [resetNorth] Function called when the control is clicked.
	 * This will override the default `resetNorth`.
	 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
	 * rendered outside of the map's viewport.
	 */
	
	
	/**
	 * @classdesc
	 * A button control to reset rotation to 0.
	 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
	 * selector is added to the button when the rotation is 0.
	 *
	 * @api
	 */
	var Rotate = /*@__PURE__*/(function (Control$$1) {
	  function Rotate(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      render: options.render || render$1,
	      target: options.target
	    });
	
	    var className = options.className !== undefined ? options.className : 'ol-rotate';
	
	    var label = options.label !== undefined ? options.label : '\u21E7';
	
	    /**
	     * @type {HTMLElement}
	     * @private
	     */
	    this.label_ = null;
	
	    if (typeof label === 'string') {
	      this.label_ = document.createElement('span');
	      this.label_.className = 'ol-compass';
	      this.label_.textContent = label;
	    } else {
	      this.label_ = label;
	      this.label_.classList.add('ol-compass');
	    }
	
	    var tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
	
	    var button = document.createElement('button');
	    button.className = className + '-reset';
	    button.setAttribute('type', 'button');
	    button.title = tipLabel;
	    button.appendChild(this.label_);
	
	    listen(button, EventType.CLICK, this.handleClick_, this);
	
	    var cssClasses = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL;
	    var element = this.element;
	    element.className = cssClasses;
	    element.appendChild(button);
	
	    this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 250;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.rotation_ = undefined;
	
	    if (this.autoHide_) {
	      this.element.classList.add(CLASS_HIDDEN);
	    }
	
	  }
	
	  if ( Control$$1 ) { Rotate.__proto__ = Control$$1; }
	  Rotate.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  Rotate.prototype.constructor = Rotate;
	
	  /**
	   * @param {MouseEvent} event The event to handle
	   * @private
	   */
	  Rotate.prototype.handleClick_ = function handleClick_ (event) {
	    event.preventDefault();
	    if (this.callResetNorth_ !== undefined) {
	      this.callResetNorth_();
	    } else {
	      this.resetNorth_();
	    }
	  };
	
	  /**
	   * @private
	   */
	  Rotate.prototype.resetNorth_ = function resetNorth_ () {
	    var map = this.getMap();
	    var view = map.getView();
	    if (!view) {
	      // the map does not have a view, so we can't act
	      // upon it
	      return;
	    }
	    if (view.getRotation() !== undefined) {
	      if (this.duration_ > 0) {
	        view.animate({
	          rotation: 0,
	          duration: this.duration_,
	          easing: easeOut
	        });
	      } else {
	        view.setRotation(0);
	      }
	    }
	  };
	
	  return Rotate;
	}(Control));
	
	
	/**
	 * Update the rotate control element.
	 * @param {import("../MapEvent.js").default} mapEvent Map event.
	 * @this {Rotate}
	 * @api
	 */
	function render$1(mapEvent) {
	  var frameState = mapEvent.frameState;
	  if (!frameState) {
	    return;
	  }
	  var rotation = frameState.viewState.rotation;
	  if (rotation != this.rotation_) {
	    var transform = 'rotate(' + rotation + 'rad)';
	    if (this.autoHide_) {
	      var contains = this.element.classList.contains(CLASS_HIDDEN);
	      if (!contains && rotation === 0) {
	        this.element.classList.add(CLASS_HIDDEN);
	      } else if (contains && rotation !== 0) {
	        this.element.classList.remove(CLASS_HIDDEN);
	      }
	    }
	    this.label_.style.msTransform = transform;
	    this.label_.style.webkitTransform = transform;
	    this.label_.style.transform = transform;
	  }
	  this.rotation_ = rotation;
	}
	
	/**
	 * @module ol/control/Zoom
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [duration=250] Animation duration in milliseconds.
	 * @property {string} [className='ol-zoom'] CSS class name.
	 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
	 * button. Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string|HTMLElement} [zoomOutLabel='-'] Text label to use for the zoom-out button.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
	 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
	 * @property {number} [delta=1] The zoom delta applied on each click.
	 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
	 * rendered outside of the map's viewport.
	 */
	
	
	/**
	 * @classdesc
	 * A control with 2 buttons, one for zoom in and one for zoom out.
	 * This control is one of the default controls of a map. To style this control
	 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
	 *
	 * @api
	 */
	var Zoom = /*@__PURE__*/(function (Control$$1) {
	  function Zoom(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      target: options.target
	    });
	
	    var className = options.className !== undefined ? options.className : 'ol-zoom';
	
	    var delta = options.delta !== undefined ? options.delta : 1;
	
	    var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
	    var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2212';
	
	    var zoomInTipLabel = options.zoomInTipLabel !== undefined ?
	      options.zoomInTipLabel : 'Zoom in';
	    var zoomOutTipLabel = options.zoomOutTipLabel !== undefined ?
	      options.zoomOutTipLabel : 'Zoom out';
	
	    var inElement = document.createElement('button');
	    inElement.className = className + '-in';
	    inElement.setAttribute('type', 'button');
	    inElement.title = zoomInTipLabel;
	    inElement.appendChild(
	      typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel
	    );
	
	    listen(inElement, EventType.CLICK, this.handleClick_.bind(this, delta));
	
	    var outElement = document.createElement('button');
	    outElement.className = className + '-out';
	    outElement.setAttribute('type', 'button');
	    outElement.title = zoomOutTipLabel;
	    outElement.appendChild(
	      typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel
	    );
	
	    listen(outElement, EventType.CLICK, this.handleClick_.bind(this, -delta));
	
	    var cssClasses = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL;
	    var element = this.element;
	    element.className = cssClasses;
	    element.appendChild(inElement);
	    element.appendChild(outElement);
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 250;
	
	  }
	
	  if ( Control$$1 ) { Zoom.__proto__ = Control$$1; }
	  Zoom.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  Zoom.prototype.constructor = Zoom;
	
	  /**
	   * @param {number} delta Zoom delta.
	   * @param {MouseEvent} event The event to handle
	   * @private
	   */
	  Zoom.prototype.handleClick_ = function handleClick_ (delta, event) {
	    event.preventDefault();
	    this.zoomByDelta_(delta);
	  };
	
	  /**
	   * @param {number} delta Zoom delta.
	   * @private
	   */
	  Zoom.prototype.zoomByDelta_ = function zoomByDelta_ (delta) {
	    var map = this.getMap();
	    var view = map.getView();
	    if (!view) {
	      // the map does not have a view, so we can't act
	      // upon it
	      return;
	    }
	    var currentResolution = view.getResolution();
	    if (currentResolution) {
	      var newResolution = view.constrainResolution(currentResolution, delta);
	      if (this.duration_ > 0) {
	        if (view.getAnimating()) {
	          view.cancelAnimations();
	        }
	        view.animate({
	          resolution: newResolution,
	          duration: this.duration_,
	          easing: easeOut
	        });
	      } else {
	        view.setResolution(newResolution);
	      }
	    }
	  };
	
	  return Zoom;
	}(Control));
	
	/**
	 * @module ol/control/util
	 */
	
	
	/**
	 * @typedef {Object} DefaultsOptions
	 * @property {boolean} [attribution=true] Include
	 * {@link module:ol/control/Attribution~Attribution}.
	 * @property {import("./Attribution.js").Options} [attributionOptions]
	 * Options for {@link module:ol/control/Attribution~Attribution}.
	 * @property {boolean} [rotate=true] Include
	 * {@link module:ol/control/Rotate~Rotate}.
	 * @property {import("./Rotate.js").Options} [rotateOptions] Options
	 * for {@link module:ol/control/Rotate~Rotate}.
	 * @property {boolean} [zoom] Include {@link module:ol/control/Zoom~Zoom}.
	 * @property {import("./Zoom.js").Options} [zoomOptions] Options for
	 * {@link module:ol/control/Zoom~Zoom}.
	 * @api
	 */
	
	
	/**
	 * Set of controls included in maps by default. Unless configured otherwise,
	 * this returns a collection containing an instance of each of the following
	 * controls:
	 * * {@link module:ol/control/Zoom~Zoom}
	 * * {@link module:ol/control/Rotate~Rotate}
	 * * {@link module:ol/control/Attribution~Attribution}
	 *
	 * @param {DefaultsOptions=} opt_options
	 * Defaults options.
	 * @return {Collection<import("./Control.js").default>}
	 * Controls.
	 * @function module:ol/control.defaults
	 * @api
	 */
	function defaults(opt_options) {
	
	  var options = opt_options ? opt_options : {};
	
	  var controls = new Collection();
	
	  var zoomControl = options.zoom !== undefined ? options.zoom : true;
	  if (zoomControl) {
	    controls.push(new Zoom(options.zoomOptions));
	  }
	
	  var rotateControl = options.rotate !== undefined ? options.rotate : true;
	  if (rotateControl) {
	    controls.push(new Rotate(options.rotateOptions));
	  }
	
	  var attributionControl = options.attribution !== undefined ?
	    options.attribution : true;
	  if (attributionControl) {
	    controls.push(new Attribution(options.attributionOptions));
	  }
	
	  return controls;
	}
	
	/**
	 * @module ol/interaction/Property
	 */
	
	/**
	 * @enum {string}
	 */
	var InteractionProperty = {
	  ACTIVE: 'active'
	};
	
	/**
	 * @module ol/interaction/Interaction
	 */
	
	
	/**
	 * Object literal with config options for interactions.
	 * @typedef {Object} InteractionOptions
	 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
	 * Method called by the map to notify the interaction that a browser event was
	 * dispatched to the map. If the function returns a falsy value, propagation of
	 * the event to other interactions in the map's interactions chain will be
	 * prevented (this includes functions with no explicit return).
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * User actions that change the state of the map. Some are similar to controls,
	 * but are not associated with a DOM element.
	 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
	 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
	 * by a keyboard event not a button element event.
	 * Although interactions do not have a DOM element, some of them do render
	 * vectors and so are visible on the screen.
	 * @api
	 */
	var Interaction = /*@__PURE__*/(function (BaseObject$$1) {
	  function Interaction(options) {
	    BaseObject$$1.call(this);
	
	    if (options.handleEvent) {
	      this.handleEvent = options.handleEvent;
	    }
	
	    /**
	     * @private
	     * @type {import("../PluggableMap.js").default}
	     */
	    this.map_ = null;
	
	    this.setActive(true);
	  }
	
	  if ( BaseObject$$1 ) { Interaction.__proto__ = BaseObject$$1; }
	  Interaction.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Interaction.prototype.constructor = Interaction;
	
	  /**
	   * Return whether the interaction is currently active.
	   * @return {boolean} `true` if the interaction is active, `false` otherwise.
	   * @observable
	   * @api
	   */
	  Interaction.prototype.getActive = function getActive () {
	    return /** @type {boolean} */ (this.get(InteractionProperty.ACTIVE));
	  };
	
	  /**
	   * Get the map associated with this interaction.
	   * @return {import("../PluggableMap.js").default} Map.
	   * @api
	   */
	  Interaction.prototype.getMap = function getMap () {
	    return this.map_;
	  };
	
	  /**
	   * Handles the {@link module:ol/MapBrowserEvent map browser event}.
	   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	   * @return {boolean} `false` to stop event propagation.
	   * @api
	   */
	  Interaction.prototype.handleEvent = function handleEvent (mapBrowserEvent) {
	    return true;
	  };
	
	  /**
	   * Activate or deactivate the interaction.
	   * @param {boolean} active Active.
	   * @observable
	   * @api
	   */
	  Interaction.prototype.setActive = function setActive (active) {
	    this.set(InteractionProperty.ACTIVE, active);
	  };
	
	  /**
	   * Remove the interaction from its current map and attach it to the new map.
	   * Subclasses may set up event handlers to get notified about changes to
	   * the map here.
	   * @param {import("../PluggableMap.js").default} map Map.
	   */
	  Interaction.prototype.setMap = function setMap (map) {
	    this.map_ = map;
	  };
	
	  return Interaction;
	}(BaseObject));
	
	
	/**
	 * @param {import("../View.js").default} view View.
	 * @param {import("../coordinate.js").Coordinate} delta Delta.
	 * @param {number=} opt_duration Duration.
	 */
	function pan(view, delta, opt_duration) {
	  var currentCenter = view.getCenter();
	  if (currentCenter) {
	    var center = view.constrainCenter(
	      [currentCenter[0] + delta[0], currentCenter[1] + delta[1]]);
	    if (opt_duration) {
	      view.animate({
	        duration: opt_duration,
	        easing: linear,
	        center: center
	      });
	    } else {
	      view.setCenter(center);
	    }
	  }
	}
	
	
	/**
	 * @param {import("../View.js").default} view View.
	 * @param {number|undefined} rotation Rotation.
	 * @param {import("../coordinate.js").Coordinate=} opt_anchor Anchor coordinate.
	 * @param {number=} opt_duration Duration.
	 */
	function rotate$3(view, rotation, opt_anchor, opt_duration) {
	  rotation = view.constrainRotation(rotation, 0);
	  rotateWithoutConstraints(view, rotation, opt_anchor, opt_duration);
	}
	
	
	/**
	 * @param {import("../View.js").default} view View.
	 * @param {number|undefined} rotation Rotation.
	 * @param {import("../coordinate.js").Coordinate=} opt_anchor Anchor coordinate.
	 * @param {number=} opt_duration Duration.
	 */
	function rotateWithoutConstraints(view, rotation, opt_anchor, opt_duration) {
	  if (rotation !== undefined) {
	    var currentRotation = view.getRotation();
	    var currentCenter = view.getCenter();
	    if (currentRotation !== undefined && currentCenter && opt_duration > 0) {
	      view.animate({
	        rotation: rotation,
	        anchor: opt_anchor,
	        duration: opt_duration,
	        easing: easeOut
	      });
	    } else {
	      view.rotate(rotation, opt_anchor);
	    }
	  }
	}
	
	
	/**
	 * @param {import("../View.js").default} view View.
	 * @param {number|undefined} resolution Resolution to go to.
	 * @param {import("../coordinate.js").Coordinate=} opt_anchor Anchor coordinate.
	 * @param {number=} opt_duration Duration.
	 * @param {number=} opt_direction Zooming direction; > 0 indicates
	 *     zooming out, in which case the constraints system will select
	 *     the largest nearest resolution; < 0 indicates zooming in, in
	 *     which case the constraints system will select the smallest
	 *     nearest resolution; == 0 indicates that the zooming direction
	 *     is unknown/not relevant, in which case the constraints system
	 *     will select the nearest resolution. If not defined 0 is
	 *     assumed.
	 */
	function zoom(view, resolution, opt_anchor, opt_duration, opt_direction) {
	  resolution = view.constrainResolution(resolution, 0, opt_direction);
	  zoomWithoutConstraints(view, resolution, opt_anchor, opt_duration);
	}
	
	
	/**
	 * @param {import("../View.js").default} view View.
	 * @param {number} delta Delta from previous zoom level.
	 * @param {import("../coordinate.js").Coordinate=} opt_anchor Anchor coordinate.
	 * @param {number=} opt_duration Duration.
	 * @api
	 */
	function zoomByDelta(view, delta, opt_anchor, opt_duration) {
	  var currentResolution = view.getResolution();
	  var resolution = view.constrainResolution(currentResolution, delta, 0);
	
	  if (resolution !== undefined) {
	    var resolutions = view.getResolutions();
	    resolution = clamp(
	      resolution,
	      view.getMinResolution() || resolutions[resolutions.length - 1],
	      view.getMaxResolution() || resolutions[0]);
	  }
	
	  // If we have a constraint on center, we need to change the anchor so that the
	  // new center is within the extent. We first calculate the new center, apply
	  // the constraint to it, and then calculate back the anchor
	  if (opt_anchor && resolution !== undefined && resolution !== currentResolution) {
	    var currentCenter = view.getCenter();
	    var center = view.calculateCenterZoom(resolution, opt_anchor);
	    center = view.constrainCenter(center);
	
	    opt_anchor = [
	      (resolution * currentCenter[0] - currentResolution * center[0]) /
	          (resolution - currentResolution),
	      (resolution * currentCenter[1] - currentResolution * center[1]) /
	          (resolution - currentResolution)
	    ];
	  }
	
	  zoomWithoutConstraints(view, resolution, opt_anchor, opt_duration);
	}
	
	
	/**
	 * @param {import("../View.js").default} view View.
	 * @param {number|undefined} resolution Resolution to go to.
	 * @param {import("../coordinate.js").Coordinate=} opt_anchor Anchor coordinate.
	 * @param {number=} opt_duration Duration.
	 */
	function zoomWithoutConstraints(view, resolution, opt_anchor, opt_duration) {
	  if (resolution) {
	    var currentResolution = view.getResolution();
	    var currentCenter = view.getCenter();
	    if (currentResolution !== undefined && currentCenter &&
	        resolution !== currentResolution && opt_duration) {
	      view.animate({
	        resolution: resolution,
	        anchor: opt_anchor,
	        duration: opt_duration,
	        easing: easeOut
	      });
	    } else {
	      if (opt_anchor) {
	        var center = view.calculateCenterZoom(resolution, opt_anchor);
	        view.setCenter(center);
	      }
	      view.setResolution(resolution);
	    }
	  }
	}
	
	/**
	 * @module ol/interaction/DoubleClickZoom
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [duration=250] Animation duration in milliseconds.
	 * @property {number} [delta=1] The zoom delta applied on each double click.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to zoom by double-clicking on the map.
	 * @api
	 */
	var DoubleClickZoom = /*@__PURE__*/(function (Interaction$$1) {
	  function DoubleClickZoom(opt_options) {
	    Interaction$$1.call(this, {
	      handleEvent: handleEvent
	    });
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.delta_ = options.delta ? options.delta : 1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 250;
	
	  }
	
	  if ( Interaction$$1 ) { DoubleClickZoom.__proto__ = Interaction$$1; }
	  DoubleClickZoom.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  DoubleClickZoom.prototype.constructor = DoubleClickZoom;
	
	  return DoubleClickZoom;
	}(Interaction));
	
	
	/**
	 * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a
	 * doubleclick) and eventually zooms the map.
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} `false` to stop event propagation.
	 * @this {DoubleClickZoom}
	 */
	function handleEvent(mapBrowserEvent) {
	  var stopEvent = false;
	  if (mapBrowserEvent.type == MapBrowserEventType.DBLCLICK) {
	    var browserEvent = /** @type {MouseEvent} */ (mapBrowserEvent.originalEvent);
	    var map = mapBrowserEvent.map;
	    var anchor = mapBrowserEvent.coordinate;
	    var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
	    var view = map.getView();
	    zoomByDelta(view, delta, anchor, this.duration_);
	    mapBrowserEvent.preventDefault();
	    stopEvent = true;
	  }
	  return !stopEvent;
	}
	
	/**
	 * @module ol/events/condition
	 */
	
	
	/**
	 * A function that takes an {@link module:ol/MapBrowserEvent} and returns a
	 * `{boolean}`. If the condition is met, true should be returned.
	 *
	 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default): boolean} Condition
	 */
	
	
	/**
	 * Return `true` if only the alt-key is pressed, `false` otherwise (e.g. when
	 * additionally the shift-key is pressed).
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if only the alt key is pressed.
	 * @api
	 */
	var altKeyOnly = function(mapBrowserEvent) {
	  var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
	  return (
	    originalEvent.altKey &&
	      !(originalEvent.metaKey || originalEvent.ctrlKey) &&
	      !originalEvent.shiftKey);
	};
	
	
	/**
	 * Return `true` if only the alt-key and shift-key is pressed, `false` otherwise
	 * (e.g. when additionally the platform-modifier-key is pressed).
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if only the alt and shift keys are pressed.
	 * @api
	 */
	var altShiftKeysOnly = function(mapBrowserEvent) {
	  var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
	  return (
	    originalEvent.altKey &&
	      !(originalEvent.metaKey || originalEvent.ctrlKey) &&
	      originalEvent.shiftKey);
	};
	
	
	/**
	 * Return `true` if the map has the focus. This condition requires a map target
	 * element with a `tabindex` attribute, e.g. `<div id="map" tabindex="1">`.
	 *
	 * @param {import("../MapBrowserEvent.js").default} event Map browser event.
	 * @return {boolean} The map has the focus.
	 * @api
	 */
	var focus = function(event) {
	  return event.target.getTargetElement() === document.activeElement;
	};
	
	
	/**
	 * Return always true.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True.
	 * @api
	 */
	var always = TRUE;
	
	
	/**
	 * Return `true` if the event is a `click` event, `false` otherwise.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if the event is a map `click` event.
	 * @api
	 */
	var click = function(mapBrowserEvent) {
	  return mapBrowserEvent.type == MapBrowserEventType.CLICK;
	};
	
	
	/**
	 * Return `true` if the event has an "action"-producing mouse button.
	 *
	 * By definition, this includes left-click on windows/linux, and left-click
	 * without the ctrl key on Macs.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} The result.
	 */
	var mouseActionButton = function(mapBrowserEvent) {
	  var originalEvent = /** @type {MouseEvent} */ (mapBrowserEvent.originalEvent);
	  return originalEvent.button == 0 &&
	      !(WEBKIT && MAC && originalEvent.ctrlKey);
	};
	
	
	/**
	 * Return always false.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} False.
	 * @api
	 */
	var never = FALSE;
	
	
	/**
	 * Return `true` if the browser event is a `pointermove` event, `false`
	 * otherwise.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if the browser event is a `pointermove` event.
	 * @api
	 */
	var pointerMove$1 = function(mapBrowserEvent) {
	  return mapBrowserEvent.type == 'pointermove';
	};
	
	
	/**
	 * Return `true` if the event is a map `singleclick` event, `false` otherwise.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if the event is a map `singleclick` event.
	 * @api
	 */
	var singleClick = function(mapBrowserEvent) {
	  return mapBrowserEvent.type == MapBrowserEventType.SINGLECLICK;
	};
	
	
	/**
	 * Return `true` if the event is a map `dblclick` event, `false` otherwise.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if the event is a map `dblclick` event.
	 * @api
	 */
	var doubleClick = function(mapBrowserEvent) {
	  return mapBrowserEvent.type == MapBrowserEventType.DBLCLICK;
	};
	
	
	/**
	 * Return `true` if no modifier key (alt-, shift- or platform-modifier-key) is
	 * pressed.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True only if there no modifier keys are pressed.
	 * @api
	 */
	var noModifierKeys = function(mapBrowserEvent) {
	  var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
	  return (
	    !originalEvent.altKey &&
	      !(originalEvent.metaKey || originalEvent.ctrlKey) &&
	      !originalEvent.shiftKey);
	};
	
	
	/**
	 * Return `true` if only the platform-modifier-key (the meta-key on Mac,
	 * ctrl-key otherwise) is pressed, `false` otherwise (e.g. when additionally
	 * the shift-key is pressed).
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if only the platform modifier key is pressed.
	 * @api
	 */
	var platformModifierKeyOnly = function(mapBrowserEvent) {
	  var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
	  return !originalEvent.altKey &&
	    (MAC ? originalEvent.metaKey : originalEvent.ctrlKey) &&
	    !originalEvent.shiftKey;
	};
	
	
	/**
	 * Return `true` if only the shift-key is pressed, `false` otherwise (e.g. when
	 * additionally the alt-key is pressed).
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if only the shift key is pressed.
	 * @api
	 */
	var shiftKeyOnly = function(mapBrowserEvent) {
	  var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
	  return (
	    !originalEvent.altKey &&
	      !(originalEvent.metaKey || originalEvent.ctrlKey) &&
	      originalEvent.shiftKey);
	};
	
	
	/**
	 * Return `true` if the target element is not editable, i.e. not a `<input>`-,
	 * `<select>`- or `<textarea>`-element, `false` otherwise.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True only if the target element is not editable.
	 * @api
	 */
	var targetNotEditable = function(mapBrowserEvent) {
	  var target = mapBrowserEvent.originalEvent.target;
	  var tagName = /** @type {Element} */ (target).tagName;
	  return (
	    tagName !== 'INPUT' &&
	      tagName !== 'SELECT' &&
	      tagName !== 'TEXTAREA');
	};
	
	
	/**
	 * Return `true` if the event originates from a mouse device.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if the event originates from a mouse device.
	 * @api
	 */
	var mouseOnly = function(mapBrowserEvent) {
	  var pointerEvent = /** @type {import("../MapBrowserPointerEvent").default} */ (mapBrowserEvent).pointerEvent;
	  assert(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
	  // see http://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
	  return pointerEvent.pointerType == 'mouse';
	};
	
	
	/**
	 * Return `true` if the event originates from a primary pointer in
	 * contact with the surface or if the left mouse button is pressed.
	 * See http://www.w3.org/TR/pointerevents/#button-states.
	 *
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} True if the event originates from a primary pointer.
	 * @api
	 */
	var primaryAction = function(mapBrowserEvent) {
	  var pointerEvent = /** @type {import("../MapBrowserPointerEvent").default} */ (mapBrowserEvent).pointerEvent;
	  assert(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
	  return pointerEvent.isPrimary && pointerEvent.button === 0;
	};
	
	/**
	 * @module ol/interaction/Pointer
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {function(import("../MapBrowserPointerEvent.js").default):boolean} [handleDownEvent]
	 * Function handling "down" events. If the function returns `true` then a drag
	 * sequence is started.
	 * @property {function(import("../MapBrowserPointerEvent.js").default)} [handleDragEvent]
	 * Function handling "drag" events. This function is called on "move" events
	 * during a drag sequence.
	 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
	 * Method called by the map to notify the interaction that a browser event was
	 * dispatched to the map. The function may return `false` to prevent the
	 * propagation of the event to other interactions in the map's interactions
	 * chain.
	 * @property {function(import("../MapBrowserPointerEvent.js").default)} [handleMoveEvent]
	 * Function handling "move" events. This function is called on "move" events,
	 * also during a drag sequence (so during a drag sequence both the
	 * `handleDragEvent` function and this function are called).
	 * @property {function(import("../MapBrowserPointerEvent.js").default):boolean} [handleUpEvent]
	 *  Function handling "up" events. If the function returns `false` then the
	 * current drag sequence is stopped.
	 * @property {function(boolean):boolean} [stopDown]
	 * Should the down event be propagated to other interactions, or should be
	 * stopped?
	 */
	
	
	/**
	 * @classdesc
	 * Base class that calls user-defined functions on `down`, `move` and `up`
	 * events. This class also manages "drag sequences".
	 *
	 * When the `handleDownEvent` user function returns `true` a drag sequence is
	 * started. During a drag sequence the `handleDragEvent` user function is
	 * called on `move` events. The drag sequence ends when the `handleUpEvent`
	 * user function is called and returns `false`.
	 * @api
	 */
	var PointerInteraction = /*@__PURE__*/(function (Interaction$$1) {
	  function PointerInteraction(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Interaction$$1.call(/** @type {import("./Interaction.js").InteractionOptions} */ this, (options));
	
	    if (options.handleDownEvent) {
	      this.handleDownEvent = options.handleDownEvent;
	    }
	
	    if (options.handleDragEvent) {
	      this.handleDragEvent = options.handleDragEvent;
	    }
	
	    if (options.handleMoveEvent) {
	      this.handleMoveEvent = options.handleMoveEvent;
	    }
	
	    if (options.handleUpEvent) {
	      this.handleUpEvent = options.handleUpEvent;
	    }
	
	    if (options.stopDown) {
	      this.stopDown = options.stopDown;
	    }
	
	    /**
	     * @type {boolean}
	     * @protected
	     */
	    this.handlingDownUpSequence = false;
	
	    /**
	     * @type {!Object<string, import("../pointer/PointerEvent.js").default>}
	     * @private
	     */
	    this.trackedPointers_ = {};
	
	    /**
	     * @type {Array<import("../pointer/PointerEvent.js").default>}
	     * @protected
	     */
	    this.targetPointers = [];
	
	  }
	
	  if ( Interaction$$1 ) { PointerInteraction.__proto__ = Interaction$$1; }
	  PointerInteraction.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  PointerInteraction.prototype.constructor = PointerInteraction;
	
	  /**
	   * Handle pointer down events.
	   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
	   * @return {boolean} If the event was consumed.
	   * @protected
	   */
	  PointerInteraction.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    return false;
	  };
	
	  /**
	   * Handle pointer drag events.
	   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
	   * @protected
	   */
	  PointerInteraction.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {};
	
	  /**
	   * Handles the {@link module:ol/MapBrowserEvent map browser event} and may call into
	   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
	   * detected.
	   * @override
	   * @api
	   */
	  PointerInteraction.prototype.handleEvent = function handleEvent (mapBrowserEvent) {
	    if (!(/** @type {import("../MapBrowserPointerEvent.js").default} */ (mapBrowserEvent).pointerEvent)) {
	      return true;
	    }
	
	    var stopEvent = false;
	    this.updateTrackedPointers_(mapBrowserEvent);
	    if (this.handlingDownUpSequence) {
	      if (mapBrowserEvent.type == MapBrowserEventType.POINTERDRAG) {
	        this.handleDragEvent(mapBrowserEvent);
	      } else if (mapBrowserEvent.type == MapBrowserEventType.POINTERUP) {
	        var handledUp = this.handleUpEvent(mapBrowserEvent);
	        this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
	      }
	    } else {
	      if (mapBrowserEvent.type == MapBrowserEventType.POINTERDOWN) {
	        var handled = this.handleDownEvent(mapBrowserEvent);
	        if (handled) {
	          mapBrowserEvent.preventDefault();
	        }
	        this.handlingDownUpSequence = handled;
	        stopEvent = this.stopDown(handled);
	      } else if (mapBrowserEvent.type == MapBrowserEventType.POINTERMOVE) {
	        this.handleMoveEvent(mapBrowserEvent);
	      }
	    }
	    return !stopEvent;
	  };
	
	  /**
	   * Handle pointer move events.
	   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
	   * @protected
	   */
	  PointerInteraction.prototype.handleMoveEvent = function handleMoveEvent (mapBrowserEvent) {};
	
	  /**
	   * Handle pointer up events.
	   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
	   * @return {boolean} If the event was consumed.
	   * @protected
	   */
	  PointerInteraction.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    return false;
	  };
	
	  /**
	   * This function is used to determine if "down" events should be propagated
	   * to other interactions or should be stopped.
	   * @param {boolean} handled Was the event handled by the interaction?
	   * @return {boolean} Should the `down` event be stopped?
	   */
	  PointerInteraction.prototype.stopDown = function stopDown (handled) {
	    return handled;
	  };
	
	  /**
	   * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
	   * @private
	   */
	  PointerInteraction.prototype.updateTrackedPointers_ = function updateTrackedPointers_ (mapBrowserEvent) {
	    if (isPointerDraggingEvent(mapBrowserEvent)) {
	      var event = mapBrowserEvent.pointerEvent;
	
	      var id = event.pointerId.toString();
	      if (mapBrowserEvent.type == MapBrowserEventType.POINTERUP) {
	        delete this.trackedPointers_[id];
	      } else if (mapBrowserEvent.type ==
	          MapBrowserEventType.POINTERDOWN) {
	        this.trackedPointers_[id] = event;
	      } else if (id in this.trackedPointers_) {
	        // update only when there was a pointerdown event for this pointer
	        this.trackedPointers_[id] = event;
	      }
	      this.targetPointers = getValues(this.trackedPointers_);
	    }
	  };
	
	  return PointerInteraction;
	}(Interaction));
	
	
	/**
	 * @param {Array<import("../pointer/PointerEvent.js").default>} pointerEvents List of events.
	 * @return {import("../pixel.js").Pixel} Centroid pixel.
	 */
	function centroid(pointerEvents) {
	  var length = pointerEvents.length;
	  var clientX = 0;
	  var clientY = 0;
	  for (var i = 0; i < length; i++) {
	    clientX += pointerEvents[i].clientX;
	    clientY += pointerEvents[i].clientY;
	  }
	  return [clientX / length, clientY / length];
	}
	
	
	/**
	 * @param {import("../MapBrowserPointerEvent.js").default} mapBrowserEvent Event.
	 * @return {boolean} Whether the event is a pointerdown, pointerdrag
	 *     or pointerup event.
	 */
	function isPointerDraggingEvent(mapBrowserEvent) {
	  var type = mapBrowserEvent.type;
	  return type === MapBrowserEventType.POINTERDOWN ||
	    type === MapBrowserEventType.POINTERDRAG ||
	    type === MapBrowserEventType.POINTERUP;
	}
	
	/**
	 * @module ol/interaction/DragPan
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
	 * to indicate whether that event should be handled.
	 * Default is {@link module:ol/events/condition~noModifierKeys}.
	 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to pan the map by dragging the map.
	 * @api
	 */
	var DragPan = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function DragPan(opt_options) {
	
	    PointerInteraction$$1.call(this, {
	      stopDown: FALSE
	    });
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {import("../Kinetic.js").default|undefined}
	     */
	    this.kinetic_ = options.kinetic;
	
	    /**
	     * @type {import("../pixel.js").Pixel}
	     */
	    this.lastCentroid = null;
	
	    /**
	     * @type {number}
	     */
	    this.lastPointersCount_;
	
	    /**
	     * @type {boolean}
	     */
	    this.panning_ = false;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : noModifierKeys;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.noKinetic_ = false;
	
	  }
	
	  if ( PointerInteraction$$1 ) { DragPan.__proto__ = PointerInteraction$$1; }
	  DragPan.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  DragPan.prototype.constructor = DragPan;
	
	  /**
	   * @inheritDoc
	   */
	  DragPan.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    if (!this.panning_) {
	      this.panning_ = true;
	      this.getMap().getView().setHint(ViewHint.INTERACTING, 1);
	    }
	    var targetPointers = this.targetPointers;
	    var centroid$$1 = centroid(targetPointers);
	    if (targetPointers.length == this.lastPointersCount_) {
	      if (this.kinetic_) {
	        this.kinetic_.update(centroid$$1[0], centroid$$1[1]);
	      }
	      if (this.lastCentroid) {
	        var deltaX = this.lastCentroid[0] - centroid$$1[0];
	        var deltaY = centroid$$1[1] - this.lastCentroid[1];
	        var map = mapBrowserEvent.map;
	        var view = map.getView();
	        var center = [deltaX, deltaY];
	        scale$2(center, view.getResolution());
	        rotate$2(center, view.getRotation());
	        add$2(center, view.getCenter());
	        center = view.constrainCenter(center);
	        view.setCenter(center);
	      }
	    } else if (this.kinetic_) {
	      // reset so we don't overestimate the kinetic energy after
	      // after one finger down, tiny drag, second finger down
	      this.kinetic_.begin();
	    }
	    this.lastCentroid = centroid$$1;
	    this.lastPointersCount_ = targetPointers.length;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragPan.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    var map = mapBrowserEvent.map;
	    var view = map.getView();
	    if (this.targetPointers.length === 0) {
	      if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
	        var distance$$1 = this.kinetic_.getDistance();
	        var angle = this.kinetic_.getAngle();
	        var center = /** @type {!import("../coordinate.js").Coordinate} */ (view.getCenter());
	        var centerpx = map.getPixelFromCoordinate(center);
	        var dest = map.getCoordinateFromPixel([
	          centerpx[0] - distance$$1 * Math.cos(angle),
	          centerpx[1] - distance$$1 * Math.sin(angle)
	        ]);
	        view.animate({
	          center: view.constrainCenter(dest),
	          duration: 500,
	          easing: easeOut
	        });
	      }
	      if (this.panning_) {
	        this.panning_ = false;
	        view.setHint(ViewHint.INTERACTING, -1);
	      }
	      return false;
	    } else {
	      if (this.kinetic_) {
	        // reset so we don't overestimate the kinetic energy after
	        // after one finger up, tiny drag, second finger up
	        this.kinetic_.begin();
	      }
	      this.lastCentroid = null;
	      return true;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragPan.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
	      var map = mapBrowserEvent.map;
	      var view = map.getView();
	      this.lastCentroid = null;
	      // stop any current animation
	      if (view.getAnimating()) {
	        view.setCenter(mapBrowserEvent.frameState.viewState.center);
	      }
	      if (this.kinetic_) {
	        this.kinetic_.begin();
	      }
	      // No kinetic as soon as more than one pointer on the screen is
	      // detected. This is to prevent nasty pans after pinch.
	      this.noKinetic_ = this.targetPointers.length > 1;
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  return DragPan;
	}(PointerInteraction));
	
	/**
	 * @module ol/interaction/DragRotate
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
	 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
	 * to indicate whether that event should be handled.
	 * Default is {@link module:ol/events/condition~altShiftKeysOnly}.
	 * @property {number} [duration=250] Animation duration in milliseconds.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to rotate the map by clicking and dragging on the map,
	 * normally combined with an {@link module:ol/events/condition} that limits
	 * it to when the alt and shift keys are held down.
	 *
	 * This interaction is only supported for mouse devices.
	 * @api
	 */
	var DragRotate = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function DragRotate(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    PointerInteraction$$1.call(this, {
	      stopDown: FALSE
	    });
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : altShiftKeysOnly;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.lastAngle_ = undefined;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 250;
	
	  }
	
	  if ( PointerInteraction$$1 ) { DragRotate.__proto__ = PointerInteraction$$1; }
	  DragRotate.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  DragRotate.prototype.constructor = DragRotate;
	
	  /**
	   * @inheritDoc
	   */
	  DragRotate.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return;
	    }
	
	    var map = mapBrowserEvent.map;
	    var view = map.getView();
	    if (view.getConstraints().rotation === disable) {
	      return;
	    }
	    var size = map.getSize();
	    var offset = mapBrowserEvent.pixel;
	    var theta =
	        Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
	    if (this.lastAngle_ !== undefined) {
	      var delta = theta - this.lastAngle_;
	      var rotation = view.getRotation();
	      rotateWithoutConstraints(view, rotation - delta);
	    }
	    this.lastAngle_ = theta;
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  DragRotate.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return true;
	    }
	
	    var map = mapBrowserEvent.map;
	    var view = map.getView();
	    view.setHint(ViewHint.INTERACTING, -1);
	    var rotation = view.getRotation();
	    rotate$3(view, rotation, undefined, this.duration_);
	    return false;
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  DragRotate.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return false;
	    }
	
	    if (mouseActionButton(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
	      var map = mapBrowserEvent.map;
	      map.getView().setHint(ViewHint.INTERACTING, 1);
	      this.lastAngle_ = undefined;
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  return DragRotate;
	}(PointerInteraction));
	
	/**
	 * @module ol/render/Box
	 */
	
	var RenderBox = /*@__PURE__*/(function (Disposable$$1) {
	  function RenderBox(className) {
	    Disposable$$1.call(this);
	
	    /**
	     * @type {import("../geom/Polygon.js").default}
	     * @private
	     */
	    this.geometry_ = null;
	
	    /**
	     * @type {HTMLDivElement}
	     * @private
	     */
	    this.element_ = /** @type {HTMLDivElement} */ (document.createElement('div'));
	    this.element_.style.position = 'absolute';
	    this.element_.className = 'ol-box ' + className;
	
	    /**
	     * @private
	     * @type {import("../PluggableMap.js").default}
	     */
	    this.map_ = null;
	
	    /**
	     * @private
	     * @type {import("../pixel.js").Pixel}
	     */
	    this.startPixel_ = null;
	
	    /**
	     * @private
	     * @type {import("../pixel.js").Pixel}
	     */
	    this.endPixel_ = null;
	
	  }
	
	  if ( Disposable$$1 ) { RenderBox.__proto__ = Disposable$$1; }
	  RenderBox.prototype = Object.create( Disposable$$1 && Disposable$$1.prototype );
	  RenderBox.prototype.constructor = RenderBox;
	
	  /**
	   * @inheritDoc
	   */
	  RenderBox.prototype.disposeInternal = function disposeInternal () {
	    this.setMap(null);
	  };
	
	  /**
	   * @private
	   */
	  RenderBox.prototype.render_ = function render_ () {
	    var startPixel = this.startPixel_;
	    var endPixel = this.endPixel_;
	    var px = 'px';
	    var style = this.element_.style;
	    style.left = Math.min(startPixel[0], endPixel[0]) + px;
	    style.top = Math.min(startPixel[1], endPixel[1]) + px;
	    style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
	    style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
	  };
	
	  /**
	   * @param {import("../PluggableMap.js").default} map Map.
	   */
	  RenderBox.prototype.setMap = function setMap (map) {
	    if (this.map_) {
	      this.map_.getOverlayContainer().removeChild(this.element_);
	      var style = this.element_.style;
	      style.left = style.top = style.width = style.height = 'inherit';
	    }
	    this.map_ = map;
	    if (this.map_) {
	      this.map_.getOverlayContainer().appendChild(this.element_);
	    }
	  };
	
	  /**
	   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
	   * @param {import("../pixel.js").Pixel} endPixel End pixel.
	   */
	  RenderBox.prototype.setPixels = function setPixels (startPixel, endPixel) {
	    this.startPixel_ = startPixel;
	    this.endPixel_ = endPixel;
	    this.createOrUpdateGeometry();
	    this.render_();
	  };
	
	  /**
	   * Creates or updates the cached geometry.
	   */
	  RenderBox.prototype.createOrUpdateGeometry = function createOrUpdateGeometry () {
	    var startPixel = this.startPixel_;
	    var endPixel = this.endPixel_;
	    var pixels = [
	      startPixel,
	      [startPixel[0], endPixel[1]],
	      endPixel,
	      [endPixel[0], startPixel[1]]
	    ];
	    var coordinates = pixels.map(this.map_.getCoordinateFromPixel, this.map_);
	    // close the polygon
	    coordinates[4] = coordinates[0].slice();
	    if (!this.geometry_) {
	      this.geometry_ = new Polygon([coordinates]);
	    } else {
	      this.geometry_.setCoordinates([coordinates]);
	    }
	  };
	
	  /**
	   * @return {import("../geom/Polygon.js").default} Geometry.
	   */
	  RenderBox.prototype.getGeometry = function getGeometry () {
	    return this.geometry_;
	  };
	
	  return RenderBox;
	}(Disposable));
	
	/**
	 * @module ol/interaction/DragBox
	 */
	
	
	/**
	 * A function that takes a {@link module:ol/MapBrowserEvent} and two
	 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
	 * true should be returned.
	 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
	 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
	 * to indicate whether that event should be handled.
	 * Default is {@link ol/events/condition~always}.
	 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
	 * `boxEndCondition` function.
	 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
	 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
	 * Default is `true` if the area of the box is bigger than the `minArea` option.
	 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default)} onBoxEnd Code to execute just
	 * before `boxend` is fired.
	 */
	
	
	/**
	 * @enum {string}
	 */
	var DragBoxEventType = {
	  /**
	   * Triggered upon drag box start.
	   * @event DragBoxEvent#boxstart
	   * @api
	   */
	  BOXSTART: 'boxstart',
	
	  /**
	   * Triggered on drag when box is active.
	   * @event DragBoxEvent#boxdrag
	   * @api
	   */
	  BOXDRAG: 'boxdrag',
	
	  /**
	   * Triggered upon drag box end.
	   * @event DragBoxEvent#boxend
	   * @api
	   */
	  BOXEND: 'boxend'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
	 * this type.
	 */
	var DragBoxEvent = /*@__PURE__*/(function (Event$$1) {
	  function DragBoxEvent(type, coordinate, mapBrowserEvent) {
	    Event$$1.call(this, type);
	
	    /**
	     * The coordinate of the drag event.
	     * @const
	     * @type {import("../coordinate.js").Coordinate}
	     * @api
	     */
	    this.coordinate = coordinate;
	
	    /**
	     * @const
	     * @type {import("../MapBrowserEvent.js").default}
	     * @api
	     */
	    this.mapBrowserEvent = mapBrowserEvent;
	
	  }
	
	  if ( Event$$1 ) { DragBoxEvent.__proto__ = Event$$1; }
	  DragBoxEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  DragBoxEvent.prototype.constructor = DragBoxEvent;
	
	  return DragBoxEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Allows the user to draw a vector box by clicking and dragging on the map,
	 * normally combined with an {@link module:ol/events/condition} that limits
	 * it to when the shift or other key is held down. This is used, for example,
	 * for zooming to a specific area of the map
	 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
	 * {@link module:ol/interaction/DragRotateAndZoom}).
	 *
	 * This interaction is only supported for mouse devices.
	 *
	 * @fires DragBoxEvent
	 * @api
	 */
	var DragBox = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function DragBox(opt_options) {
	
	    PointerInteraction$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	    * @type {import("../render/Box.js").default}
	    * @private
	    */
	    this.box_ = new RenderBox(options.className || 'ol-dragbox');
	
	    /**
	    * @type {number}
	    * @private
	    */
	    this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
	
	    /**
	     * Function to execute just before `onboxend` is fired
	     * @type {function(this:DragBox, import("../MapBrowserEvent.js").default)}
	     * @private
	     */
	    this.onBoxEnd_ = options.onBoxEnd ? options.onBoxEnd : VOID;
	
	    /**
	    * @type {import("../pixel.js").Pixel}
	    * @private
	    */
	    this.startPixel_ = null;
	
	    /**
	    * @private
	    * @type {import("../events/condition.js").Condition}
	    */
	    this.condition_ = options.condition ? options.condition : always;
	
	    /**
	    * @private
	    * @type {EndCondition}
	    */
	    this.boxEndCondition_ = options.boxEndCondition ?
	      options.boxEndCondition : this.defaultBoxEndCondition;
	  }
	
	  if ( PointerInteraction$$1 ) { DragBox.__proto__ = PointerInteraction$$1; }
	  DragBox.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  DragBox.prototype.constructor = DragBox;
	
	  /**
	   * The default condition for determining whether the boxend event
	   * should fire.
	   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
	   *     leading to the box end.
	   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
	   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
	   * @return {boolean} Whether or not the boxend condition should be fired.
	   */
	  DragBox.prototype.defaultBoxEndCondition = function defaultBoxEndCondition (mapBrowserEvent, startPixel, endPixel) {
	    var width = endPixel[0] - startPixel[0];
	    var height = endPixel[1] - startPixel[1];
	    return width * width + height * height >= this.minArea_;
	  };
	
	  /**
	  * Returns geometry of last drawn box.
	  * @return {import("../geom/Polygon.js").default} Geometry.
	  * @api
	  */
	  DragBox.prototype.getGeometry = function getGeometry () {
	    return this.box_.getGeometry();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragBox.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return;
	    }
	
	    this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
	
	    this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXDRAG,
	      mapBrowserEvent.coordinate, mapBrowserEvent));
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragBox.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return true;
	    }
	
	    this.box_.setMap(null);
	
	    if (this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel)) {
	      this.onBoxEnd_(mapBrowserEvent);
	      this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXEND,
	        mapBrowserEvent.coordinate, mapBrowserEvent));
	    }
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragBox.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return false;
	    }
	
	    if (mouseActionButton(mapBrowserEvent) &&
	        this.condition_(mapBrowserEvent)) {
	      this.startPixel_ = mapBrowserEvent.pixel;
	      this.box_.setMap(mapBrowserEvent.map);
	      this.box_.setPixels(this.startPixel_, this.startPixel_);
	      this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXSTART,
	        mapBrowserEvent.coordinate, mapBrowserEvent));
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  return DragBox;
	}(PointerInteraction));
	
	/**
	 * @module ol/interaction/DragZoom
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
	 * box.
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled.
	 * Default is {@link module:ol/events/condition~shiftKeyOnly}.
	 * @property {number} [duration=200] Animation duration in milliseconds.
	 * @property {boolean} [out=false] Use interaction for zooming out.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to zoom the map by clicking and dragging on the map,
	 * normally combined with an {@link module:ol/events/condition} that limits
	 * it to when a key, shift by default, is held down.
	 *
	 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
	 * your custom one configured with `className`.
	 * @api
	 */
	var DragZoom = /*@__PURE__*/(function (DragBox$$1) {
	  function DragZoom(opt_options) {
	    var options = opt_options ? opt_options : {};
	
	    var condition = options.condition ? options.condition : shiftKeyOnly;
	
	    DragBox$$1.call(this, {
	      condition: condition,
	      className: options.className || 'ol-dragzoom',
	      onBoxEnd: onBoxEnd
	    });
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 200;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.out_ = options.out !== undefined ? options.out : false;
	  }
	
	  if ( DragBox$$1 ) { DragZoom.__proto__ = DragBox$$1; }
	  DragZoom.prototype = Object.create( DragBox$$1 && DragBox$$1.prototype );
	  DragZoom.prototype.constructor = DragZoom;
	
	  return DragZoom;
	}(DragBox));
	
	
	/**
	 * @this {DragZoom}
	 */
	function onBoxEnd() {
	  var map = this.getMap();
	  var view = /** @type {!import("../View.js").default} */ (map.getView());
	  var size = /** @type {!import("../size.js").Size} */ (map.getSize());
	  var extent = this.getGeometry().getExtent();
	
	  if (this.out_) {
	    var mapExtent = view.calculateExtent(size);
	    var boxPixelExtent = createOrUpdateFromCoordinates([
	      map.getPixelFromCoordinate(getBottomLeft(extent)),
	      map.getPixelFromCoordinate(getTopRight(extent))]);
	    var factor = view.getResolutionForExtent(boxPixelExtent, size);
	
	    scaleFromCenter(mapExtent, 1 / factor);
	    extent = mapExtent;
	  }
	
	  var resolution = view.constrainResolution(
	    view.getResolutionForExtent(extent, size));
	
	  var center = getCenter(extent);
	  center = view.constrainCenter(center);
	
	  view.animate({
	    resolution: resolution,
	    center: center,
	    duration: this.duration_,
	    easing: easeOut
	  });
	}
	
	/**
	 * @module ol/events/KeyCode
	 */
	
	/**
	 * @enum {number}
	 * @const
	 */
	var KeyCode = {
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40
	};
	
	/**
	 * @module ol/interaction/KeyboardPan
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled. Default is
	 * {@link module:ol/events/condition~noModifierKeys} and
	 * {@link module:ol/events/condition~targetNotEditable}.
	 * @property {number} [duration=100] Animation duration in milliseconds.
	 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
	 * press.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to pan the map using keyboard arrows.
	 * Note that, although this interaction is by default included in maps,
	 * the keys can only be used when browser focus is on the element to which
	 * the keyboard events are attached. By default, this is the map div,
	 * though you can change this with the `keyboardEventTarget` in
	 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
	 * element, focus will have to be on, and returned to, this element if the keys
	 * are to function.
	 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
	 * @api
	 */
	var KeyboardPan = /*@__PURE__*/(function (Interaction$$1) {
	  function KeyboardPan(opt_options) {
	
	    Interaction$$1.call(this, {
	      handleEvent: handleEvent$1
	    });
	
	    var options = opt_options || {};
	
	    /**
	     * @private
	     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
	     * @return {boolean} Combined condition result.
	     */
	    this.defaultCondition_ = function(mapBrowserEvent) {
	      return noModifierKeys(mapBrowserEvent) &&
	        targetNotEditable(mapBrowserEvent);
	    };
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition !== undefined ?
	      options.condition : this.defaultCondition_;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 100;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.pixelDelta_ = options.pixelDelta !== undefined ?
	      options.pixelDelta : 128;
	
	  }
	
	  if ( Interaction$$1 ) { KeyboardPan.__proto__ = Interaction$$1; }
	  KeyboardPan.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  KeyboardPan.prototype.constructor = KeyboardPan;
	
	  return KeyboardPan;
	}(Interaction));
	
	
	/**
	 * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
	 * `KeyEvent`, and decides the direction to pan to (if an arrow key was
	 * pressed).
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} `false` to stop event propagation.
	 * @this {KeyboardPan}
	 */
	function handleEvent$1(mapBrowserEvent) {
	  var stopEvent = false;
	  if (mapBrowserEvent.type == EventType.KEYDOWN) {
	    var keyEvent = /** @type {KeyboardEvent} */ (mapBrowserEvent.originalEvent);
	    var keyCode = keyEvent.keyCode;
	    if (this.condition_(mapBrowserEvent) &&
	        (keyCode == KeyCode.DOWN ||
	        keyCode == KeyCode.LEFT ||
	        keyCode == KeyCode.RIGHT ||
	        keyCode == KeyCode.UP)) {
	      var map = mapBrowserEvent.map;
	      var view = map.getView();
	      var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
	      var deltaX = 0, deltaY = 0;
	      if (keyCode == KeyCode.DOWN) {
	        deltaY = -mapUnitsDelta;
	      } else if (keyCode == KeyCode.LEFT) {
	        deltaX = -mapUnitsDelta;
	      } else if (keyCode == KeyCode.RIGHT) {
	        deltaX = mapUnitsDelta;
	      } else {
	        deltaY = mapUnitsDelta;
	      }
	      var delta = [deltaX, deltaY];
	      rotate$2(delta, view.getRotation());
	      pan(view, delta, this.duration_);
	      mapBrowserEvent.preventDefault();
	      stopEvent = true;
	    }
	  }
	  return !stopEvent;
	}
	
	/**
	 * @module ol/interaction/KeyboardZoom
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [duration=100] Animation duration in milliseconds.
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled. Default is
	 * {@link module:ol/events/condition~targetNotEditable}.
	 * @property {number} [delta=1] The zoom level delta on each key press.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to zoom the map using keyboard + and -.
	 * Note that, although this interaction is by default included in maps,
	 * the keys can only be used when browser focus is on the element to which
	 * the keyboard events are attached. By default, this is the map div,
	 * though you can change this with the `keyboardEventTarget` in
	 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
	 * element, focus will have to be on, and returned to, this element if the keys
	 * are to function.
	 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
	 * @api
	 */
	var KeyboardZoom = /*@__PURE__*/(function (Interaction$$1) {
	  function KeyboardZoom(opt_options) {
	
	    Interaction$$1.call(this, {
	      handleEvent: handleEvent$2
	    });
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : targetNotEditable;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.delta_ = options.delta ? options.delta : 1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 100;
	
	  }
	
	  if ( Interaction$$1 ) { KeyboardZoom.__proto__ = Interaction$$1; }
	  KeyboardZoom.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  KeyboardZoom.prototype.constructor = KeyboardZoom;
	
	  return KeyboardZoom;
	}(Interaction));
	
	
	/**
	 * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
	 * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
	 * key pressed was '+' or '-').
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} `false` to stop event propagation.
	 * @this {KeyboardZoom}
	 */
	function handleEvent$2(mapBrowserEvent) {
	  var stopEvent = false;
	  if (mapBrowserEvent.type == EventType.KEYDOWN ||
	      mapBrowserEvent.type == EventType.KEYPRESS) {
	    var keyEvent = /** @type {KeyboardEvent} */ (mapBrowserEvent.originalEvent);
	    var charCode = keyEvent.charCode;
	    if (this.condition_(mapBrowserEvent) &&
	        (charCode == '+'.charCodeAt(0) || charCode == '-'.charCodeAt(0))) {
	      var map = mapBrowserEvent.map;
	      var delta = (charCode == '+'.charCodeAt(0)) ? this.delta_ : -this.delta_;
	      var view = map.getView();
	      zoomByDelta(view, delta, undefined, this.duration_);
	      mapBrowserEvent.preventDefault();
	      stopEvent = true;
	    }
	  }
	  return !stopEvent;
	}
	
	/**
	 * @module ol/interaction/MouseWheelZoom
	 */
	
	
	/**
	 * Maximum mouse wheel delta.
	 * @type {number}
	 */
	var MAX_DELTA = 1;
	
	
	/**
	 * @enum {string}
	 */
	var Mode = {
	  TRACKPAD: 'trackpad',
	  WHEEL: 'wheel'
	};
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled. Default is
	 * {@link module:ol/events/condition~always}.
	 * @property {number} [duration=250] Animation duration in milliseconds.
	 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
	 * @property {boolean} [constrainResolution=false] When using a trackpad or
	 * magic mouse, zoom to the closest integer zoom level after the scroll gesture
	 * ends.
	 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
	 * location as the anchor. When set to `false`, zooming in and out will zoom to
	 * the center of the screen instead of zooming on the mouse's location.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to zoom the map by scrolling the mouse wheel.
	 * @api
	 */
	var MouseWheelZoom = /*@__PURE__*/(function (Interaction$$1) {
	  function MouseWheelZoom(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Interaction$$1.call(/** @type {import("./Interaction.js").InteractionOptions} */ this, (options));
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.delta_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 250;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.constrainResolution_ = options.constrainResolution || false;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : always;
	
	    /**
	     * @private
	     * @type {?import("../coordinate.js").Coordinate}
	     */
	    this.lastAnchor_ = null;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.startTime_ = undefined;
	
	    /**
	     * @private
	     * @type {?}
	     */
	    this.timeoutId_;
	
	    /**
	     * @private
	     * @type {Mode|undefined}
	     */
	    this.mode_ = undefined;
	
	    /**
	     * Trackpad events separated by this delay will be considered separate
	     * interactions.
	     * @type {number}
	     */
	    this.trackpadEventGap_ = 400;
	
	    /**
	     * @type {?}
	     */
	    this.trackpadTimeoutId_;
	
	    /**
	     * The number of delta values per zoom level
	     * @private
	     * @type {number}
	     */
	    this.trackpadDeltaPerZoom_ = 300;
	
	    /**
	     * The zoom factor by which scroll zooming is allowed to exceed the limits.
	     * @private
	     * @type {number}
	     */
	    this.trackpadZoomBuffer_ = 1.5;
	
	  }
	
	  if ( Interaction$$1 ) { MouseWheelZoom.__proto__ = Interaction$$1; }
	  MouseWheelZoom.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  MouseWheelZoom.prototype.constructor = MouseWheelZoom;
	
	  /**
	   * @private
	   */
	  MouseWheelZoom.prototype.decrementInteractingHint_ = function decrementInteractingHint_ () {
	    this.trackpadTimeoutId_ = undefined;
	    var view = this.getMap().getView();
	    view.setHint(ViewHint.INTERACTING, -1);
	  };
	
	  /**
	   * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
	   * zooms the map.
	   * @override
	   */
	  MouseWheelZoom.prototype.handleEvent = function handleEvent (mapBrowserEvent) {
	    if (!this.condition_(mapBrowserEvent)) {
	      return true;
	    }
	    var type = mapBrowserEvent.type;
	    if (type !== EventType.WHEEL && type !== EventType.MOUSEWHEEL) {
	      return true;
	    }
	
	    mapBrowserEvent.preventDefault();
	
	    var map = mapBrowserEvent.map;
	    var wheelEvent = /** @type {WheelEvent} */ (mapBrowserEvent.originalEvent);
	
	    if (this.useAnchor_) {
	      this.lastAnchor_ = mapBrowserEvent.coordinate;
	    }
	
	    // Delta normalisation inspired by
	    // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
	    var delta;
	    if (mapBrowserEvent.type == EventType.WHEEL) {
	      delta = wheelEvent.deltaY;
	      if (FIREFOX &&
	          wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
	        delta /= DEVICE_PIXEL_RATIO;
	      }
	      if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) {
	        delta *= 40;
	      }
	    } else if (mapBrowserEvent.type == EventType.MOUSEWHEEL) {
	      delta = -wheelEvent.wheelDeltaY;
	      if (SAFARI) {
	        delta /= 3;
	      }
	    }
	
	    if (delta === 0) {
	      return false;
	    }
	
	    var now = Date.now();
	
	    if (this.startTime_ === undefined) {
	      this.startTime_ = now;
	    }
	
	    if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) {
	      this.mode_ = Math.abs(delta) < 4 ?
	        Mode.TRACKPAD :
	        Mode.WHEEL;
	    }
	
	    if (this.mode_ === Mode.TRACKPAD) {
	      var view = map.getView();
	      if (this.trackpadTimeoutId_) {
	        clearTimeout(this.trackpadTimeoutId_);
	      } else {
	        view.setHint(ViewHint.INTERACTING, 1);
	      }
	      this.trackpadTimeoutId_ = setTimeout(this.decrementInteractingHint_.bind(this), this.trackpadEventGap_);
	      var resolution = view.getResolution() * Math.pow(2, delta / this.trackpadDeltaPerZoom_);
	      var minResolution = view.getMinResolution();
	      var maxResolution = view.getMaxResolution();
	      var rebound = 0;
	      if (resolution < minResolution) {
	        resolution = Math.max(resolution, minResolution / this.trackpadZoomBuffer_);
	        rebound = 1;
	      } else if (resolution > maxResolution) {
	        resolution = Math.min(resolution, maxResolution * this.trackpadZoomBuffer_);
	        rebound = -1;
	      }
	      if (this.lastAnchor_) {
	        var center = view.calculateCenterZoom(resolution, this.lastAnchor_);
	        view.setCenter(view.constrainCenter(center));
	      }
	      view.setResolution(resolution);
	
	      if (rebound === 0 && this.constrainResolution_) {
	        view.animate({
	          resolution: view.constrainResolution(resolution, delta > 0 ? -1 : 1),
	          easing: easeOut,
	          anchor: this.lastAnchor_,
	          duration: this.duration_
	        });
	      }
	
	      if (rebound > 0) {
	        view.animate({
	          resolution: minResolution,
	          easing: easeOut,
	          anchor: this.lastAnchor_,
	          duration: 500
	        });
	      } else if (rebound < 0) {
	        view.animate({
	          resolution: maxResolution,
	          easing: easeOut,
	          anchor: this.lastAnchor_,
	          duration: 500
	        });
	      }
	      this.startTime_ = now;
	      return false;
	    }
	
	    this.delta_ += delta;
	
	    var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
	
	    clearTimeout(this.timeoutId_);
	    this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
	
	    return false;
	  };
	
	  /**
	   * @private
	   * @param {import("../PluggableMap.js").default} map Map.
	   */
	  MouseWheelZoom.prototype.handleWheelZoom_ = function handleWheelZoom_ (map) {
	    var view = map.getView();
	    if (view.getAnimating()) {
	      view.cancelAnimations();
	    }
	    var maxDelta = MAX_DELTA;
	    var delta = clamp(this.delta_, -maxDelta, maxDelta);
	    zoomByDelta(view, -delta, this.lastAnchor_, this.duration_);
	    this.mode_ = undefined;
	    this.delta_ = 0;
	    this.lastAnchor_ = null;
	    this.startTime_ = undefined;
	    this.timeoutId_ = undefined;
	  };
	
	  /**
	   * Enable or disable using the mouse's location as an anchor when zooming
	   * @param {boolean} useAnchor true to zoom to the mouse's location, false
	   * to zoom to the center of the map
	   * @api
	   */
	  MouseWheelZoom.prototype.setMouseAnchor = function setMouseAnchor (useAnchor) {
	    this.useAnchor_ = useAnchor;
	    if (!useAnchor) {
	      this.lastAnchor_ = null;
	    }
	  };
	
	  return MouseWheelZoom;
	}(Interaction));
	
	/**
	 * @module ol/interaction/PinchRotate
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [duration=250] The duration of the animation in
	 * milliseconds.
	 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to rotate the map by twisting with two fingers
	 * on a touch screen.
	 * @api
	 */
	var PinchRotate = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function PinchRotate(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
	
	    if (!pointerOptions.stopDown) {
	      pointerOptions.stopDown = FALSE;
	    }
	
	    PointerInteraction$$1.call(this, pointerOptions);
	
	    /**
	     * @private
	     * @type {import("../coordinate.js").Coordinate}
	     */
	    this.anchor_ = null;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.lastAngle_ = undefined;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.rotating_ = false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.rotationDelta_ = 0.0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 250;
	
	  }
	
	  if ( PointerInteraction$$1 ) { PinchRotate.__proto__ = PointerInteraction$$1; }
	  PinchRotate.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  PinchRotate.prototype.constructor = PinchRotate;
	
	  /**
	   * @inheritDoc
	   */
	  PinchRotate.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    var rotationDelta = 0.0;
	
	    var touch0 = this.targetPointers[0];
	    var touch1 = this.targetPointers[1];
	
	    // angle between touches
	    var angle = Math.atan2(
	      touch1.clientY - touch0.clientY,
	      touch1.clientX - touch0.clientX);
	
	    if (this.lastAngle_ !== undefined) {
	      var delta = angle - this.lastAngle_;
	      this.rotationDelta_ += delta;
	      if (!this.rotating_ &&
	          Math.abs(this.rotationDelta_) > this.threshold_) {
	        this.rotating_ = true;
	      }
	      rotationDelta = delta;
	    }
	    this.lastAngle_ = angle;
	
	    var map = mapBrowserEvent.map;
	    var view = map.getView();
	    if (view.getConstraints().rotation === disable) {
	      return;
	    }
	
	    // rotate anchor point.
	    // FIXME: should be the intersection point between the lines:
	    //     touch0,touch1 and previousTouch0,previousTouch1
	    var viewportPosition = map.getViewport().getBoundingClientRect();
	    var centroid$$1 = centroid(this.targetPointers);
	    centroid$$1[0] -= viewportPosition.left;
	    centroid$$1[1] -= viewportPosition.top;
	    this.anchor_ = map.getCoordinateFromPixel(centroid$$1);
	
	    // rotate
	    if (this.rotating_) {
	      var rotation = view.getRotation();
	      map.render();
	      rotateWithoutConstraints(view, rotation + rotationDelta, this.anchor_);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  PinchRotate.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    if (this.targetPointers.length < 2) {
	      var map = mapBrowserEvent.map;
	      var view = map.getView();
	      view.setHint(ViewHint.INTERACTING, -1);
	      if (this.rotating_) {
	        var rotation = view.getRotation();
	        rotate$3(view, rotation, this.anchor_, this.duration_);
	      }
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  PinchRotate.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    if (this.targetPointers.length >= 2) {
	      var map = mapBrowserEvent.map;
	      this.anchor_ = null;
	      this.lastAngle_ = undefined;
	      this.rotating_ = false;
	      this.rotationDelta_ = 0.0;
	      if (!this.handlingDownUpSequence) {
	        map.getView().setHint(ViewHint.INTERACTING, 1);
	      }
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  return PinchRotate;
	}(PointerInteraction));
	
	/**
	 * @module ol/interaction/PinchZoom
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [duration=400] Animation duration in milliseconds.
	 * @property {boolean} [constrainResolution=false] Zoom to the closest integer
	 * zoom level after the pinch gesture ends.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to zoom the map by pinching with two fingers
	 * on a touch screen.
	 * @api
	 */
	var PinchZoom = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function PinchZoom(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
	
	    if (!pointerOptions.stopDown) {
	      pointerOptions.stopDown = FALSE;
	    }
	
	    PointerInteraction$$1.call(this, pointerOptions);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.constrainResolution_ = options.constrainResolution || false;
	
	    /**
	     * @private
	     * @type {import("../coordinate.js").Coordinate}
	     */
	    this.anchor_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 400;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.lastDistance_ = undefined;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.lastScaleDelta_ = 1;
	
	  }
	
	  if ( PointerInteraction$$1 ) { PinchZoom.__proto__ = PointerInteraction$$1; }
	  PinchZoom.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  PinchZoom.prototype.constructor = PinchZoom;
	
	  /**
	   * @inheritDoc
	   */
	  PinchZoom.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    var scaleDelta = 1.0;
	
	    var touch0 = this.targetPointers[0];
	    var touch1 = this.targetPointers[1];
	    var dx = touch0.clientX - touch1.clientX;
	    var dy = touch0.clientY - touch1.clientY;
	
	    // distance between touches
	    var distance = Math.sqrt(dx * dx + dy * dy);
	
	    if (this.lastDistance_ !== undefined) {
	      scaleDelta = this.lastDistance_ / distance;
	    }
	    this.lastDistance_ = distance;
	
	
	    var map = mapBrowserEvent.map;
	    var view = map.getView();
	    var resolution = view.getResolution();
	    var maxResolution = view.getMaxResolution();
	    var minResolution = view.getMinResolution();
	    var newResolution = resolution * scaleDelta;
	    if (newResolution > maxResolution) {
	      scaleDelta = maxResolution / resolution;
	      newResolution = maxResolution;
	    } else if (newResolution < minResolution) {
	      scaleDelta = minResolution / resolution;
	      newResolution = minResolution;
	    }
	
	    if (scaleDelta != 1.0) {
	      this.lastScaleDelta_ = scaleDelta;
	    }
	
	    // scale anchor point.
	    var viewportPosition = map.getViewport().getBoundingClientRect();
	    var centroid$$1 = centroid(this.targetPointers);
	    centroid$$1[0] -= viewportPosition.left;
	    centroid$$1[1] -= viewportPosition.top;
	    this.anchor_ = map.getCoordinateFromPixel(centroid$$1);
	
	    // scale, bypass the resolution constraint
	    map.render();
	    zoomWithoutConstraints(view, newResolution, this.anchor_);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  PinchZoom.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    if (this.targetPointers.length < 2) {
	      var map = mapBrowserEvent.map;
	      var view = map.getView();
	      view.setHint(ViewHint.INTERACTING, -1);
	      var resolution = view.getResolution();
	      if (this.constrainResolution_ ||
	          resolution < view.getMinResolution() ||
	          resolution > view.getMaxResolution()) {
	        // Zoom to final resolution, with an animation, and provide a
	        // direction not to zoom out/in if user was pinching in/out.
	        // Direction is > 0 if pinching out, and < 0 if pinching in.
	        var direction = this.lastScaleDelta_ - 1;
	        zoom(view, resolution, this.anchor_, this.duration_, direction);
	      }
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  PinchZoom.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    if (this.targetPointers.length >= 2) {
	      var map = mapBrowserEvent.map;
	      this.anchor_ = null;
	      this.lastDistance_ = undefined;
	      this.lastScaleDelta_ = 1;
	      if (!this.handlingDownUpSequence) {
	        map.getView().setHint(ViewHint.INTERACTING, 1);
	      }
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  return PinchZoom;
	}(PointerInteraction));
	
	/**
	 * @module ol/interaction/DragAndDrop
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {Array<typeof import("../format/Feature.js").default>} [formatConstructors] Format constructors.
	 * @property {import("../source/Vector.js").default} [source] Optional vector source where features will be added.  If a source is provided
	 * all existing features will be removed and new features will be added when
	 * they are dropped on the target.  If you want to add features to a vector
	 * source without removing the existing features (append only), instead of
	 * providing the source option listen for the "addfeatures" event.
	 * @property {import("../proj.js").ProjectionLike} [projection] Target projection. By default, the map's view's projection is used.
	 * @property {HTMLElement} [target] The element that is used as the drop target, default is the viewport element.
	 */
	
	
	/**
	 * @enum {string}
	 */
	var DragAndDropEventType = {
	  /**
	   * Triggered when features are added
	   * @event DragAndDropEvent#addfeatures
	   * @api
	   */
	  ADD_FEATURES: 'addfeatures'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/DragAndDrop~DragAndDrop} instances are instances
	 * of this type.
	 */
	var DragAndDropEvent = /*@__PURE__*/(function (Event$$1) {
	  function DragAndDropEvent(type, file, opt_features, opt_projection) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The features parsed from dropped data.
	     * @type {Array<import("../Feature.js").FeatureLike>|undefined}
	     * @api
	     */
	    this.features = opt_features;
	
	    /**
	     * The dropped file.
	     * @type {File}
	     * @api
	     */
	    this.file = file;
	
	    /**
	     * The feature projection.
	     * @type {import("../proj/Projection.js").default|undefined}
	     * @api
	     */
	    this.projection = opt_projection;
	
	  }
	
	  if ( Event$$1 ) { DragAndDropEvent.__proto__ = Event$$1; }
	  DragAndDropEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  DragAndDropEvent.prototype.constructor = DragAndDropEvent;
	
	  return DragAndDropEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Handles input of vector data by drag and drop.
	 * @api
	 *
	 * @fires DragAndDropEvent
	 */
	var DragAndDrop = /*@__PURE__*/(function (Interaction$$1) {
	  function DragAndDrop(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Interaction$$1.call(this, {
	      handleEvent: TRUE
	    });
	
	    /**
	     * @private
	     * @type {Array<typeof import("../format/Feature.js").default>}
	     */
	    this.formatConstructors_ = options.formatConstructors ?
	      options.formatConstructors : [];
	
	    /**
	     * @private
	     * @type {import("../proj/Projection.js").default}
	     */
	    this.projection_ = options.projection ?
	      get$2(options.projection) : null;
	
	    /**
	     * @private
	     * @type {Array<import("../events.js").EventsKey>}
	     */
	    this.dropListenKeys_ = null;
	
	    /**
	     * @private
	     * @type {import("../source/Vector.js").default}
	     */
	    this.source_ = options.source || null;
	
	    /**
	     * @private
	     * @type {HTMLElement}
	     */
	    this.target = options.target ? options.target : null;
	
	  }
	
	  if ( Interaction$$1 ) { DragAndDrop.__proto__ = Interaction$$1; }
	  DragAndDrop.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  DragAndDrop.prototype.constructor = DragAndDrop;
	
	  /**
	   * @param {File} file File.
	   * @param {Event} event Load event.
	   * @private
	   */
	  DragAndDrop.prototype.handleResult_ = function handleResult_ (file, event) {
	    var result = event.target.result;
	    var map = this.getMap();
	    var projection = this.projection_;
	    if (!projection) {
	      var view = map.getView();
	      projection = view.getProjection();
	    }
	
	    var formatConstructors = this.formatConstructors_;
	    var features = [];
	    for (var i = 0, ii = formatConstructors.length; i < ii; ++i) {
	      var format = new formatConstructors[i]();
	      features = this.tryReadFeatures_(format, result, {
	        featureProjection: projection
	      });
	      if (features && features.length > 0) {
	        break;
	      }
	    }
	    if (this.source_) {
	      this.source_.clear();
	      this.source_.addFeatures(features);
	    }
	    this.dispatchEvent(
	      new DragAndDropEvent(
	        DragAndDropEventType.ADD_FEATURES, file,
	        features, projection));
	  };
	
	  /**
	   * @private
	   */
	  DragAndDrop.prototype.registerListeners_ = function registerListeners_ () {
	    var map = this.getMap();
	    if (map) {
	      var dropArea = this.target ? this.target : map.getViewport();
	      this.dropListenKeys_ = [
	        listen(dropArea, EventType.DROP, handleDrop, this),
	        listen(dropArea, EventType.DRAGENTER, handleStop, this),
	        listen(dropArea, EventType.DRAGOVER, handleStop, this),
	        listen(dropArea, EventType.DROP, handleStop, this)
	      ];
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragAndDrop.prototype.setActive = function setActive (active) {
	    Interaction$$1.prototype.setActive.call(this, active);
	    if (active) {
	      this.registerListeners_();
	    } else {
	      this.unregisterListeners_();
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragAndDrop.prototype.setMap = function setMap (map) {
	    this.unregisterListeners_();
	    Interaction$$1.prototype.setMap.call(this, map);
	    if (this.getActive()) {
	      this.registerListeners_();
	    }
	  };
	
	  /**
	   * @param {import("../format/Feature.js").default} format Format.
	   * @param {string} text Text.
	   * @param {import("../format/Feature.js").ReadOptions} options Read options.
	   * @private
	   * @return {Array<import("../Feature.js").FeatureLike>} Features.
	   */
	  DragAndDrop.prototype.tryReadFeatures_ = function tryReadFeatures_ (format, text, options) {
	    try {
	      return format.readFeatures(text, options);
	    } catch (e) {
	      return null;
	    }
	  };
	
	  /**
	   * @private
	   */
	  DragAndDrop.prototype.unregisterListeners_ = function unregisterListeners_ () {
	    if (this.dropListenKeys_) {
	      this.dropListenKeys_.forEach(unlistenByKey);
	      this.dropListenKeys_ = null;
	    }
	  };
	
	  return DragAndDrop;
	}(Interaction));
	
	
	/**
	 * @param {DragEvent} event Event.
	 * @this {DragAndDrop}
	 */
	function handleDrop(event) {
	  var files = event.dataTransfer.files;
	  for (var i = 0, ii = files.length; i < ii; ++i) {
	    var file = files.item(i);
	    var reader = new FileReader();
	    reader.addEventListener(EventType.LOAD, this.handleResult_.bind(this, file));
	    reader.readAsText(file);
	  }
	}
	
	
	/**
	 * @param {DragEvent} event Event.
	 */
	function handleStop(event) {
	  event.stopPropagation();
	  event.preventDefault();
	  event.dataTransfer.dropEffect = 'copy';
	}
	
	/**
	 * @module ol/interaction/DragRotateAndZoom
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled.
	 * Default is {@link module:ol/events/condition~shiftKeyOnly}.
	 * @property {number} [duration=400] Animation duration in milliseconds.
	 */
	
	
	/**
	 * @classdesc
	 * Allows the user to zoom and rotate the map by clicking and dragging
	 * on the map.  By default, this interaction is limited to when the shift
	 * key is held down.
	 *
	 * This interaction is only supported for mouse devices.
	 *
	 * And this interaction is not included in the default interactions.
	 * @api
	 */
	var DragRotateAndZoom = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function DragRotateAndZoom(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    PointerInteraction$$1.call(/** @type {import("./Pointer.js").Options} */ this, (options));
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : shiftKeyOnly;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.lastAngle_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.lastMagnitude_ = undefined;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.lastScaleDelta_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 400;
	
	  }
	
	  if ( PointerInteraction$$1 ) { DragRotateAndZoom.__proto__ = PointerInteraction$$1; }
	  DragRotateAndZoom.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  DragRotateAndZoom.prototype.constructor = DragRotateAndZoom;
	
	  /**
	   * @inheritDoc
	   */
	  DragRotateAndZoom.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return;
	    }
	
	    var map = mapBrowserEvent.map;
	    var size = map.getSize();
	    var offset = mapBrowserEvent.pixel;
	    var deltaX = offset[0] - size[0] / 2;
	    var deltaY = size[1] / 2 - offset[1];
	    var theta = Math.atan2(deltaY, deltaX);
	    var magnitude = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
	    var view = map.getView();
	    if (view.getConstraints().rotation !== disable && this.lastAngle_ !== undefined) {
	      var angleDelta = theta - this.lastAngle_;
	      rotateWithoutConstraints(view, view.getRotation() - angleDelta);
	    }
	    this.lastAngle_ = theta;
	    if (this.lastMagnitude_ !== undefined) {
	      var resolution = this.lastMagnitude_ * (view.getResolution() / magnitude);
	      zoomWithoutConstraints(view, resolution);
	    }
	    if (this.lastMagnitude_ !== undefined) {
	      this.lastScaleDelta_ = this.lastMagnitude_ / magnitude;
	    }
	    this.lastMagnitude_ = magnitude;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragRotateAndZoom.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return true;
	    }
	
	    var map = mapBrowserEvent.map;
	    var view = map.getView();
	    view.setHint(ViewHint.INTERACTING, -1);
	    var direction = this.lastScaleDelta_ - 1;
	    rotate$3(view, view.getRotation());
	    zoom(view, view.getResolution(), undefined, this.duration_, direction);
	    this.lastScaleDelta_ = 0;
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  DragRotateAndZoom.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    if (!mouseOnly(mapBrowserEvent)) {
	      return false;
	    }
	
	    if (this.condition_(mapBrowserEvent)) {
	      mapBrowserEvent.map.getView().setHint(ViewHint.INTERACTING, 1);
	      this.lastAngle_ = undefined;
	      this.lastMagnitude_ = undefined;
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  return DragRotateAndZoom;
	}(PointerInteraction));
	
	/**
	 * @module ol/geom/Circle
	 */
	
	/**
	 * @classdesc
	 * Circle geometry.
	 *
	 * @api
	 */
	var Circle = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function Circle(center, opt_radius, opt_layout) {
	    SimpleGeometry$$1.call(this);
	    if (opt_layout !== undefined && opt_radius === undefined) {
	      this.setFlatCoordinates(opt_layout, center);
	    } else {
	      var radius = opt_radius ? opt_radius : 0;
	      this.setCenterAndRadius(center, radius, opt_layout);
	    }
	  }
	
	  if ( SimpleGeometry$$1 ) { Circle.__proto__ = SimpleGeometry$$1; }
	  Circle.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  Circle.prototype.constructor = Circle;
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!Circle} Clone.
	   * @override
	   * @api
	   */
	  Circle.prototype.clone = function clone$$1 () {
	    return new Circle(this.flatCoordinates.slice(), undefined, this.layout);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Circle.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    var flatCoordinates = this.flatCoordinates;
	    var dx = x - flatCoordinates[0];
	    var dy = y - flatCoordinates[1];
	    var squaredDistance = dx * dx + dy * dy;
	    if (squaredDistance < minSquaredDistance) {
	      if (squaredDistance === 0) {
	        for (var i = 0; i < this.stride; ++i) {
	          closestPoint[i] = flatCoordinates[i];
	        }
	      } else {
	        var delta = this.getRadius() / Math.sqrt(squaredDistance);
	        closestPoint[0] = flatCoordinates[0] + delta * dx;
	        closestPoint[1] = flatCoordinates[1] + delta * dy;
	        for (var i$1 = 2; i$1 < this.stride; ++i$1) {
	          closestPoint[i$1] = flatCoordinates[i$1];
	        }
	      }
	      closestPoint.length = this.stride;
	      return squaredDistance;
	    } else {
	      return minSquaredDistance;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Circle.prototype.containsXY = function containsXY$$1 (x, y) {
	    var flatCoordinates = this.flatCoordinates;
	    var dx = x - flatCoordinates[0];
	    var dy = y - flatCoordinates[1];
	    return dx * dx + dy * dy <= this.getRadiusSquared_();
	  };
	
	  /**
	   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
	   * @return {import("../coordinate.js").Coordinate} Center.
	   * @api
	   */
	  Circle.prototype.getCenter = function getCenter$$1 () {
	    return this.flatCoordinates.slice(0, this.stride);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Circle.prototype.computeExtent = function computeExtent (extent) {
	    var flatCoordinates = this.flatCoordinates;
	    var radius = flatCoordinates[this.stride] - flatCoordinates[0];
	    return createOrUpdate(
	      flatCoordinates[0] - radius, flatCoordinates[1] - radius,
	      flatCoordinates[0] + radius, flatCoordinates[1] + radius,
	      extent);
	  };
	
	  /**
	   * Return the radius of the circle.
	   * @return {number} Radius.
	   * @api
	   */
	  Circle.prototype.getRadius = function getRadius () {
	    return Math.sqrt(this.getRadiusSquared_());
	  };
	
	  /**
	   * @private
	   * @return {number} Radius squared.
	   */
	  Circle.prototype.getRadiusSquared_ = function getRadiusSquared_ () {
	    var dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
	    var dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
	    return dx * dx + dy * dy;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Circle.prototype.getType = function getType () {
	    return GeometryType.CIRCLE;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Circle.prototype.intersectsExtent = function intersectsExtent (extent) {
	    var circleExtent = this.getExtent();
	    if (intersects(extent, circleExtent)) {
	      var center = this.getCenter();
	
	      if (extent[0] <= center[0] && extent[2] >= center[0]) {
	        return true;
	      }
	      if (extent[1] <= center[1] && extent[3] >= center[1]) {
	        return true;
	      }
	
	      return forEachCorner(extent, this.intersectsCoordinate, this);
	    }
	    return false;
	
	  };
	
	  /**
	   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
	   * @param {import("../coordinate.js").Coordinate} center Center.
	   * @api
	   */
	  Circle.prototype.setCenter = function setCenter (center) {
	    var stride = this.stride;
	    var radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
	    var flatCoordinates = center.slice();
	    flatCoordinates[stride] = flatCoordinates[0] + radius;
	    for (var i = 1; i < stride; ++i) {
	      flatCoordinates[stride + i] = center[i];
	    }
	    this.setFlatCoordinates(this.layout, flatCoordinates);
	    this.changed();
	  };
	
	  /**
	   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
	   * number) of the circle.
	   * @param {!import("../coordinate.js").Coordinate} center Center.
	   * @param {number} radius Radius.
	   * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
	   * @api
	   */
	  Circle.prototype.setCenterAndRadius = function setCenterAndRadius (center, radius, opt_layout) {
	    this.setLayout(opt_layout, center, 0);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    /** @type {Array<number>} */
	    var flatCoordinates = this.flatCoordinates;
	    var offset = deflateCoordinate(
	      flatCoordinates, 0, center, this.stride);
	    flatCoordinates[offset++] = flatCoordinates[0] + radius;
	    for (var i = 1, ii = this.stride; i < ii; ++i) {
	      flatCoordinates[offset++] = flatCoordinates[i];
	    }
	    flatCoordinates.length = offset;
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Circle.prototype.getCoordinates = function getCoordinates () {
	    return null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Circle.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {};
	
	  /**
	   * Set the radius of the circle. The radius is in the units of the projection.
	   * @param {number} radius Radius.
	   * @api
	   */
	  Circle.prototype.setRadius = function setRadius (radius) {
	    this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
	    this.changed();
	  };
	
	  return Circle;
	}(SimpleGeometry));
	
	
	/**
	 * Transform each coordinate of the circle from one coordinate reference system
	 * to another. The geometry is modified in place.
	 * If you do not want the geometry modified in place, first clone() it and
	 * then use this function on the clone.
	 *
	 * Internally a circle is currently represented by two points: the center of
	 * the circle `[cx, cy]`, and the point to the right of the circle
	 * `[cx + r, cy]`. This `transform` function just transforms these two points.
	 * So the resulting geometry is also a circle, and that circle does not
	 * correspond to the shape that would be obtained by transforming every point
	 * of the original circle.
	 *
	 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
	 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
	 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
	 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
	 * @return {Circle} This geometry.  Note that original geometry is
	 *     modified in place.
	 * @function
	 * @api
	 */
	Circle.prototype.transform;
	
	/**
	 * @module ol/geom/MultiLineString
	 */
	
	/**
	 * @classdesc
	 * Multi-linestring geometry.
	 *
	 * @api
	 */
	var MultiLineString = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function MultiLineString(coordinates, opt_layout, opt_ends) {
	
	    SimpleGeometry$$1.call(this);
	
	    /**
	     * @type {Array<number>}
	     * @private
	     */
	    this.ends_ = [];
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDelta_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDeltaRevision_ = -1;
	
	    if (Array.isArray(coordinates[0])) {
	      this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ (coordinates), opt_layout);
	    } else if (opt_layout !== undefined && opt_ends) {
	      this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ (coordinates));
	      this.ends_ = opt_ends;
	    } else {
	      var layout = this.getLayout();
	      var lineStrings = /** @type {Array<LineString>} */ (coordinates);
	      var flatCoordinates = [];
	      var ends = [];
	      for (var i = 0, ii = lineStrings.length; i < ii; ++i) {
	        var lineString = lineStrings[i];
	        if (i === 0) {
	          layout = lineString.getLayout();
	        }
	        extend(flatCoordinates, lineString.getFlatCoordinates());
	        ends.push(flatCoordinates.length);
	      }
	      this.setFlatCoordinates(layout, flatCoordinates);
	      this.ends_ = ends;
	    }
	
	  }
	
	  if ( SimpleGeometry$$1 ) { MultiLineString.__proto__ = SimpleGeometry$$1; }
	  MultiLineString.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  MultiLineString.prototype.constructor = MultiLineString;
	
	  /**
	   * Append the passed linestring to the multilinestring.
	   * @param {LineString} lineString LineString.
	   * @api
	   */
	  MultiLineString.prototype.appendLineString = function appendLineString (lineString) {
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = lineString.getFlatCoordinates().slice();
	    } else {
	      extend(this.flatCoordinates, lineString.getFlatCoordinates().slice());
	    }
	    this.ends_.push(this.flatCoordinates.length);
	    this.changed();
	  };
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!MultiLineString} Clone.
	   * @override
	   * @api
	   */
	  MultiLineString.prototype.clone = function clone$$1 () {
	    return new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MultiLineString.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    if (this.maxDeltaRevision_ != this.getRevision()) {
	      this.maxDelta_ = Math.sqrt(arrayMaxSquaredDelta(
	        this.flatCoordinates, 0, this.ends_, this.stride, 0));
	      this.maxDeltaRevision_ = this.getRevision();
	    }
	    return assignClosestArrayPoint(
	      this.flatCoordinates, 0, this.ends_, this.stride,
	      this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
	  };
	
	  /**
	   * Returns the coordinate at `m` using linear interpolation, or `null` if no
	   * such coordinate exists.
	   *
	   * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
	   * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
	   * M will return the first coordinate and Ms greater than the last M will
	   * return the last coordinate.
	   *
	   * `opt_interpolate` controls interpolation between consecutive LineStrings
	   * within the MultiLineString. If `opt_interpolate` is `true` the coordinates
	   * will be linearly interpolated between the last coordinate of one LineString
	   * and the first coordinate of the next LineString.  If `opt_interpolate` is
	   * `false` then the function will return `null` for Ms falling between
	   * LineStrings.
	   *
	   * @param {number} m M.
	   * @param {boolean=} opt_extrapolate Extrapolate. Default is `false`.
	   * @param {boolean=} opt_interpolate Interpolate. Default is `false`.
	   * @return {import("../coordinate.js").Coordinate} Coordinate.
	   * @api
	   */
	  MultiLineString.prototype.getCoordinateAtM = function getCoordinateAtM (m, opt_extrapolate, opt_interpolate) {
	    if ((this.layout != GeometryLayout.XYM &&
	         this.layout != GeometryLayout.XYZM) ||
	        this.flatCoordinates.length === 0) {
	      return null;
	    }
	    var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
	    var interpolate = opt_interpolate !== undefined ? opt_interpolate : false;
	    return lineStringsCoordinateAtM(this.flatCoordinates, 0,
	      this.ends_, this.stride, m, extrapolate, interpolate);
	  };
	
	  /**
	   * Return the coordinates of the multilinestring.
	   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
	   * @override
	   * @api
	   */
	  MultiLineString.prototype.getCoordinates = function getCoordinates () {
	    return inflateCoordinatesArray(
	      this.flatCoordinates, 0, this.ends_, this.stride);
	  };
	
	  /**
	   * @return {Array<number>} Ends.
	   */
	  MultiLineString.prototype.getEnds = function getEnds () {
	    return this.ends_;
	  };
	
	  /**
	   * Return the linestring at the specified index.
	   * @param {number} index Index.
	   * @return {LineString} LineString.
	   * @api
	   */
	  MultiLineString.prototype.getLineString = function getLineString (index) {
	    if (index < 0 || this.ends_.length <= index) {
	      return null;
	    }
	    return new LineString(this.flatCoordinates.slice(
	      index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
	  };
	
	  /**
	   * Return the linestrings of this multilinestring.
	   * @return {Array<LineString>} LineStrings.
	   * @api
	   */
	  MultiLineString.prototype.getLineStrings = function getLineStrings () {
	    var flatCoordinates = this.flatCoordinates;
	    var ends = this.ends_;
	    var layout = this.layout;
	    /** @type {Array<LineString>} */
	    var lineStrings = [];
	    var offset = 0;
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      var end = ends[i];
	      var lineString = new LineString(flatCoordinates.slice(offset, end), layout);
	      lineStrings.push(lineString);
	      offset = end;
	    }
	    return lineStrings;
	  };
	
	  /**
	   * @return {Array<number>} Flat midpoints.
	   */
	  MultiLineString.prototype.getFlatMidpoints = function getFlatMidpoints () {
	    var midpoints = [];
	    var flatCoordinates = this.flatCoordinates;
	    var offset = 0;
	    var ends = this.ends_;
	    var stride = this.stride;
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      var end = ends[i];
	      var midpoint = interpolatePoint(
	        flatCoordinates, offset, end, stride, 0.5);
	      extend(midpoints, midpoint);
	      offset = end;
	    }
	    return midpoints;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MultiLineString.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal (squaredTolerance) {
	    var simplifiedFlatCoordinates = [];
	    var simplifiedEnds = [];
	    simplifiedFlatCoordinates.length = douglasPeuckerArray(
	      this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance,
	      simplifiedFlatCoordinates, 0, simplifiedEnds);
	    return new MultiLineString(simplifiedFlatCoordinates, GeometryLayout.XY, simplifiedEnds);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MultiLineString.prototype.getType = function getType () {
	    return GeometryType.MULTI_LINE_STRING;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MultiLineString.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return intersectsLineStringArray(
	      this.flatCoordinates, 0, this.ends_, this.stride, extent);
	  };
	
	  /**
	   * Set the coordinates of the multilinestring.
	   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
	   * @param {GeometryLayout=} opt_layout Layout.
	   * @override
	   * @api
	   */
	  MultiLineString.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 2);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    var ends = deflateCoordinatesArray(
	      this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
	    this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
	    this.changed();
	  };
	
	  return MultiLineString;
	}(SimpleGeometry));
	
	/**
	 * @module ol/geom/MultiPoint
	 */
	
	/**
	 * @classdesc
	 * Multi-point geometry.
	 *
	 * @api
	 */
	var MultiPoint = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function MultiPoint(coordinates, opt_layout) {
	    SimpleGeometry$$1.call(this);
	    if (opt_layout && !Array.isArray(coordinates[0])) {
	      this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ (coordinates));
	    } else {
	      this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ (coordinates), opt_layout);
	    }
	  }
	
	  if ( SimpleGeometry$$1 ) { MultiPoint.__proto__ = SimpleGeometry$$1; }
	  MultiPoint.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  MultiPoint.prototype.constructor = MultiPoint;
	
	  /**
	   * Append the passed point to this multipoint.
	   * @param {Point} point Point.
	   * @api
	   */
	  MultiPoint.prototype.appendPoint = function appendPoint (point) {
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = point.getFlatCoordinates().slice();
	    } else {
	      extend(this.flatCoordinates, point.getFlatCoordinates());
	    }
	    this.changed();
	  };
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!MultiPoint} Clone.
	   * @override
	   * @api
	   */
	  MultiPoint.prototype.clone = function clone$$1 () {
	    var multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
	    return multiPoint;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MultiPoint.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    var flatCoordinates = this.flatCoordinates;
	    var stride = this.stride;
	    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
	      var squaredDistance$$1 = squaredDistance(
	        x, y, flatCoordinates[i], flatCoordinates[i + 1]);
	      if (squaredDistance$$1 < minSquaredDistance) {
	        minSquaredDistance = squaredDistance$$1;
	        for (var j = 0; j < stride; ++j) {
	          closestPoint[j] = flatCoordinates[i + j];
	        }
	        closestPoint.length = stride;
	      }
	    }
	    return minSquaredDistance;
	  };
	
	  /**
	   * Return the coordinates of the multipoint.
	   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
	   * @override
	   * @api
	   */
	  MultiPoint.prototype.getCoordinates = function getCoordinates () {
	    return inflateCoordinates(
	      this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
	  };
	
	  /**
	   * Return the point at the specified index.
	   * @param {number} index Index.
	   * @return {Point} Point.
	   * @api
	   */
	  MultiPoint.prototype.getPoint = function getPoint (index) {
	    var n = !this.flatCoordinates ? 0 : this.flatCoordinates.length / this.stride;
	    if (index < 0 || n <= index) {
	      return null;
	    }
	    return new Point(this.flatCoordinates.slice(
	      index * this.stride, (index + 1) * this.stride), this.layout);
	  };
	
	  /**
	   * Return the points of this multipoint.
	   * @return {Array<Point>} Points.
	   * @api
	   */
	  MultiPoint.prototype.getPoints = function getPoints () {
	    var flatCoordinates = this.flatCoordinates;
	    var layout = this.layout;
	    var stride = this.stride;
	    /** @type {Array<Point>} */
	    var points = [];
	    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
	      var point = new Point(flatCoordinates.slice(i, i + stride), layout);
	      points.push(point);
	    }
	    return points;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MultiPoint.prototype.getType = function getType () {
	    return GeometryType.MULTI_POINT;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MultiPoint.prototype.intersectsExtent = function intersectsExtent (extent) {
	    var flatCoordinates = this.flatCoordinates;
	    var stride = this.stride;
	    for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
	      var x = flatCoordinates[i];
	      var y = flatCoordinates[i + 1];
	      if (containsXY(extent, x, y)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * Set the coordinates of the multipoint.
	   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
	   * @param {import("./GeometryLayout.js").default=} opt_layout Layout.
	   * @override
	   * @api
	   */
	  MultiPoint.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 1);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    this.flatCoordinates.length = deflateCoordinates(
	      this.flatCoordinates, 0, coordinates, this.stride);
	    this.changed();
	  };
	
	  return MultiPoint;
	}(SimpleGeometry));
	
	/**
	 * @module ol/geom/flat/center
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {Array<Array<number>>} endss Endss.
	 * @param {number} stride Stride.
	 * @return {Array<number>} Flat centers.
	 */
	function linearRingss$1(flatCoordinates, offset, endss, stride) {
	  var flatCenters = [];
	  var extent = createEmpty();
	  for (var i = 0, ii = endss.length; i < ii; ++i) {
	    var ends = endss[i];
	    extent = createOrUpdateFromFlatCoordinates(flatCoordinates, offset, ends[0], stride);
	    flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
	    offset = ends[ends.length - 1];
	  }
	  return flatCenters;
	}
	
	/**
	 * @module ol/geom/MultiPolygon
	 */
	
	/**
	 * @classdesc
	 * Multi-polygon geometry.
	 *
	 * @api
	 */
	var MultiPolygon = /*@__PURE__*/(function (SimpleGeometry$$1) {
	  function MultiPolygon(coordinates, opt_layout, opt_endss) {
	
	    SimpleGeometry$$1.call(this);
	
	    /**
	     * @type {Array<Array<number>>}
	     * @private
	     */
	    this.endss_ = [];
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.flatInteriorPointsRevision_ = -1;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.flatInteriorPoints_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDelta_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxDeltaRevision_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.orientedRevision_ = -1;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.orientedFlatCoordinates_ = null;
	
	    if (!opt_endss && !Array.isArray(coordinates[0])) {
	      var layout = this.getLayout();
	      var polygons = /** @type {Array<Polygon>} */ (coordinates);
	      var flatCoordinates = [];
	      var endss = [];
	      for (var i = 0, ii = polygons.length; i < ii; ++i) {
	        var polygon = polygons[i];
	        if (i === 0) {
	          layout = polygon.getLayout();
	        }
	        var offset = flatCoordinates.length;
	        var ends = polygon.getEnds();
	        for (var j = 0, jj = ends.length; j < jj; ++j) {
	          ends[j] += offset;
	        }
	        extend(flatCoordinates, polygon.getFlatCoordinates());
	        endss.push(ends);
	      }
	      opt_layout = layout;
	      coordinates = flatCoordinates;
	      opt_endss = endss;
	    }
	    if (opt_layout !== undefined && opt_endss) {
	      this.setFlatCoordinates(opt_layout, /** @type {Array<number>} */ (coordinates));
	      this.endss_ = opt_endss;
	    } else {
	      this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ (coordinates),
	        opt_layout);
	    }
	
	  }
	
	  if ( SimpleGeometry$$1 ) { MultiPolygon.__proto__ = SimpleGeometry$$1; }
	  MultiPolygon.prototype = Object.create( SimpleGeometry$$1 && SimpleGeometry$$1.prototype );
	  MultiPolygon.prototype.constructor = MultiPolygon;
	
	  /**
	   * Append the passed polygon to this multipolygon.
	   * @param {Polygon} polygon Polygon.
	   * @api
	   */
	  MultiPolygon.prototype.appendPolygon = function appendPolygon (polygon) {
	    /** @type {Array<number>} */
	    var ends;
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = polygon.getFlatCoordinates().slice();
	      ends = polygon.getEnds().slice();
	      this.endss_.push();
	    } else {
	      var offset = this.flatCoordinates.length;
	      extend(this.flatCoordinates, polygon.getFlatCoordinates());
	      ends = polygon.getEnds().slice();
	      for (var i = 0, ii = ends.length; i < ii; ++i) {
	        ends[i] += offset;
	      }
	    }
	    this.endss_.push(ends);
	    this.changed();
	  };
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!MultiPolygon} Clone.
	   * @override
	   * @api
	   */
	  MultiPolygon.prototype.clone = function clone$$1 () {
	    var len = this.endss_.length;
	    var newEndss = new Array(len);
	    for (var i = 0; i < len; ++i) {
	      newEndss[i] = this.endss_[i].slice();
	    }
	
	    return new MultiPolygon(
	      this.flatCoordinates.slice(), this.layout, newEndss);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MultiPolygon.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    if (this.maxDeltaRevision_ != this.getRevision()) {
	      this.maxDelta_ = Math.sqrt(multiArrayMaxSquaredDelta(
	        this.flatCoordinates, 0, this.endss_, this.stride, 0));
	      this.maxDeltaRevision_ = this.getRevision();
	    }
	    return assignClosestMultiArrayPoint(
	      this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride,
	      this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MultiPolygon.prototype.containsXY = function containsXY$$1 (x, y) {
	    return linearRingssContainsXY(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
	  };
	
	  /**
	   * Return the area of the multipolygon on projected plane.
	   * @return {number} Area (on projected plane).
	   * @api
	   */
	  MultiPolygon.prototype.getArea = function getArea$$1 () {
	    return linearRingss(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
	  };
	
	  /**
	   * Get the coordinate array for this geometry.  This array has the structure
	   * of a GeoJSON coordinate array for multi-polygons.
	   *
	   * @param {boolean=} opt_right Orient coordinates according to the right-hand
	   *     rule (counter-clockwise for exterior and clockwise for interior rings).
	   *     If `false`, coordinates will be oriented according to the left-hand rule
	   *     (clockwise for exterior and counter-clockwise for interior rings).
	   *     By default, coordinate orientation will depend on how the geometry was
	   *     constructed.
	   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
	   * @override
	   * @api
	   */
	  MultiPolygon.prototype.getCoordinates = function getCoordinates (opt_right) {
	    var flatCoordinates;
	    if (opt_right !== undefined) {
	      flatCoordinates = this.getOrientedFlatCoordinates().slice();
	      orientLinearRingsArray(
	        flatCoordinates, 0, this.endss_, this.stride, opt_right);
	    } else {
	      flatCoordinates = this.flatCoordinates;
	    }
	
	    return inflateMultiCoordinatesArray(
	      flatCoordinates, 0, this.endss_, this.stride);
	  };
	
	  /**
	   * @return {Array<Array<number>>} Endss.
	   */
	  MultiPolygon.prototype.getEndss = function getEndss () {
	    return this.endss_;
	  };
	
	  /**
	   * @return {Array<number>} Flat interior points.
	   */
	  MultiPolygon.prototype.getFlatInteriorPoints = function getFlatInteriorPoints () {
	    if (this.flatInteriorPointsRevision_ != this.getRevision()) {
	      var flatCenters = linearRingss$1(
	        this.flatCoordinates, 0, this.endss_, this.stride);
	      this.flatInteriorPoints_ = getInteriorPointsOfMultiArray(
	        this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride,
	        flatCenters);
	      this.flatInteriorPointsRevision_ = this.getRevision();
	    }
	    return this.flatInteriorPoints_;
	  };
	
	  /**
	   * Return the interior points as {@link module:ol/geom/MultiPoint multipoint}.
	   * @return {MultiPoint} Interior points as XYM coordinates, where M is
	   * the length of the horizontal intersection that the point belongs to.
	   * @api
	   */
	  MultiPolygon.prototype.getInteriorPoints = function getInteriorPoints () {
	    return new MultiPoint(this.getFlatInteriorPoints().slice(), GeometryLayout.XYM);
	  };
	
	  /**
	   * @return {Array<number>} Oriented flat coordinates.
	   */
	  MultiPolygon.prototype.getOrientedFlatCoordinates = function getOrientedFlatCoordinates () {
	    if (this.orientedRevision_ != this.getRevision()) {
	      var flatCoordinates = this.flatCoordinates;
	      if (linearRingsAreOriented(
	        flatCoordinates, 0, this.endss_, this.stride)) {
	        this.orientedFlatCoordinates_ = flatCoordinates;
	      } else {
	        this.orientedFlatCoordinates_ = flatCoordinates.slice();
	        this.orientedFlatCoordinates_.length =
	            orientLinearRingsArray(
	              this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
	      }
	      this.orientedRevision_ = this.getRevision();
	    }
	    return this.orientedFlatCoordinates_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MultiPolygon.prototype.getSimplifiedGeometryInternal = function getSimplifiedGeometryInternal (squaredTolerance) {
	    var simplifiedFlatCoordinates = [];
	    var simplifiedEndss = [];
	    simplifiedFlatCoordinates.length = quantizeMultiArray(
	      this.flatCoordinates, 0, this.endss_, this.stride,
	      Math.sqrt(squaredTolerance),
	      simplifiedFlatCoordinates, 0, simplifiedEndss);
	    return new MultiPolygon(simplifiedFlatCoordinates, GeometryLayout.XY, simplifiedEndss);
	  };
	
	  /**
	   * Return the polygon at the specified index.
	   * @param {number} index Index.
	   * @return {Polygon} Polygon.
	   * @api
	   */
	  MultiPolygon.prototype.getPolygon = function getPolygon (index) {
	    if (index < 0 || this.endss_.length <= index) {
	      return null;
	    }
	    var offset;
	    if (index === 0) {
	      offset = 0;
	    } else {
	      var prevEnds = this.endss_[index - 1];
	      offset = prevEnds[prevEnds.length - 1];
	    }
	    var ends = this.endss_[index].slice();
	    var end = ends[ends.length - 1];
	    if (offset !== 0) {
	      for (var i = 0, ii = ends.length; i < ii; ++i) {
	        ends[i] -= offset;
	      }
	    }
	    return new Polygon(this.flatCoordinates.slice(offset, end), this.layout, ends);
	  };
	
	  /**
	   * Return the polygons of this multipolygon.
	   * @return {Array<Polygon>} Polygons.
	   * @api
	   */
	  MultiPolygon.prototype.getPolygons = function getPolygons () {
	    var layout = this.layout;
	    var flatCoordinates = this.flatCoordinates;
	    var endss = this.endss_;
	    var polygons = [];
	    var offset = 0;
	    for (var i = 0, ii = endss.length; i < ii; ++i) {
	      var ends = endss[i].slice();
	      var end = ends[ends.length - 1];
	      if (offset !== 0) {
	        for (var j = 0, jj = ends.length; j < jj; ++j) {
	          ends[j] -= offset;
	        }
	      }
	      var polygon = new Polygon(flatCoordinates.slice(offset, end), layout, ends);
	      polygons.push(polygon);
	      offset = end;
	    }
	    return polygons;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MultiPolygon.prototype.getType = function getType () {
	    return GeometryType.MULTI_POLYGON;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MultiPolygon.prototype.intersectsExtent = function intersectsExtent (extent) {
	    return intersectsLinearRingMultiArray(
	      this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
	  };
	
	  /**
	   * Set the coordinates of the multipolygon.
	   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
	   * @param {GeometryLayout=} opt_layout Layout.
	   * @override
	   * @api
	   */
	  MultiPolygon.prototype.setCoordinates = function setCoordinates (coordinates, opt_layout) {
	    this.setLayout(opt_layout, coordinates, 3);
	    if (!this.flatCoordinates) {
	      this.flatCoordinates = [];
	    }
	    var endss = deflateMultiCoordinatesArray(
	      this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
	    if (endss.length === 0) {
	      this.flatCoordinates.length = 0;
	    } else {
	      var lastEnds = endss[endss.length - 1];
	      this.flatCoordinates.length = lastEnds.length === 0 ?
	        0 : lastEnds[lastEnds.length - 1];
	    }
	    this.changed();
	  };
	
	  return MultiPolygon;
	}(SimpleGeometry));
	
	/**
	 * @module ol/LayerType
	 */
	
	/**
	 * A layer type used when creating layer renderers.
	 * @enum {string}
	 */
	var LayerType = {
	  IMAGE: 'IMAGE',
	  TILE: 'TILE',
	  VECTOR_TILE: 'VECTOR_TILE',
	  VECTOR: 'VECTOR'
	};
	
	/**
	 * @module ol/layer/VectorRenderType
	 */
	
	/**
	 * @enum {string}
	 * Render mode for vector layers:
	 *  * `'image'`: Vector layers are rendered as images. Great performance, but
	 *    point symbols and texts are always rotated with the view and pixels are
	 *    scaled during zoom animations.
	 *  * `'vector'`: Vector layers are rendered as vectors. Most accurate rendering
	 *    even during animations, but slower performance.
	 * @api
	 */
	var VectorRenderType = {
	  IMAGE: 'image',
	  VECTOR: 'vector'
	};
	
	/**
	 * @module ol/colorlike
	 */
	
	
	/**
	 * A type accepted by CanvasRenderingContext2D.fillStyle
	 * or CanvasRenderingContext2D.strokeStyle.
	 * Represents a color, pattern, or gradient. The origin for patterns and
	 * gradients as fill style is an increment of 512 css pixels from map coordinate
	 * `[0, 0]`. For seamless repeat patterns, width and height of the pattern image
	 * must be a factor of two (2, 4, 8, ..., 512).
	 *
	 * @typedef {string|CanvasPattern|CanvasGradient} ColorLike
	 * @api
	 */
	
	
	/**
	 * @param {import("./color.js").Color|ColorLike} color Color.
	 * @return {ColorLike} The color as an {@link ol/colorlike~ColorLike}.
	 * @api
	 */
	function asColorLike(color) {
	  if (Array.isArray(color)) {
	    return toString(color);
	  } else {
	    return color;
	  }
	}
	
	/**
	 * @module ol/ImageState
	 */
	
	/**
	 * @enum {number}
	 */
	var ImageState = {
	  IDLE: 0,
	  LOADING: 1,
	  LOADED: 2,
	  ERROR: 3
	};
	
	/**
	 * @module ol/structs/LRUCache
	 */
	
	
	/**
	 * @typedef {Object} Entry
	 * @property {string} key_
	 * @property {Object} newer
	 * @property {Object} older
	 * @property {*} value_
	 */
	
	
	/**
	 * @classdesc
	 * Implements a Least-Recently-Used cache where the keys do not conflict with
	 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
	 * items from the cache is the responsibility of the user.
	 *
	 * @fires import("../events/Event.js").Event
	 * @template T
	 */
	var LRUCache = /*@__PURE__*/(function (EventTarget) {
	  function LRUCache(opt_highWaterMark) {
	
	    EventTarget.call(this);
	
	    /**
	     * @type {number}
	     */
	    this.highWaterMark = opt_highWaterMark !== undefined ? opt_highWaterMark : 2048;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.count_ = 0;
	
	    /**
	     * @private
	     * @type {!Object<string, Entry>}
	     */
	    this.entries_ = {};
	
	    /**
	     * @private
	     * @type {?Entry}
	     */
	    this.oldest_ = null;
	
	    /**
	     * @private
	     * @type {?Entry}
	     */
	    this.newest_ = null;
	
	  }
	
	  if ( EventTarget ) { LRUCache.__proto__ = EventTarget; }
	  LRUCache.prototype = Object.create( EventTarget && EventTarget.prototype );
	  LRUCache.prototype.constructor = LRUCache;
	
	
	  /**
	   * @return {boolean} Can expire cache.
	   */
	  LRUCache.prototype.canExpireCache = function canExpireCache () {
	    return this.getCount() > this.highWaterMark;
	  };
	
	
	  /**
	   * FIXME empty description for jsdoc
	   */
	  LRUCache.prototype.clear = function clear () {
	    this.count_ = 0;
	    this.entries_ = {};
	    this.oldest_ = null;
	    this.newest_ = null;
	    this.dispatchEvent(EventType.CLEAR);
	  };
	
	
	  /**
	   * @param {string} key Key.
	   * @return {boolean} Contains key.
	   */
	  LRUCache.prototype.containsKey = function containsKey (key) {
	    return this.entries_.hasOwnProperty(key);
	  };
	
	
	  /**
	   * @param {function(this: S, T, string, LRUCache): ?} f The function
	   *     to call for every entry from the oldest to the newer. This function takes
	   *     3 arguments (the entry value, the entry key and the LRUCache object).
	   *     The return value is ignored.
	   * @param {S=} opt_this The object to use as `this` in `f`.
	   * @template S
	   */
	  LRUCache.prototype.forEach = function forEach (f, opt_this) {
	    var entry = this.oldest_;
	    while (entry) {
	      f.call(opt_this, entry.value_, entry.key_, this);
	      entry = entry.newer;
	    }
	  };
	
	
	  /**
	   * @param {string} key Key.
	   * @return {T} Value.
	   */
	  LRUCache.prototype.get = function get (key) {
	    var entry = this.entries_[key];
	    assert(entry !== undefined,
	      15); // Tried to get a value for a key that does not exist in the cache
	    if (entry === this.newest_) {
	      return entry.value_;
	    } else if (entry === this.oldest_) {
	      this.oldest_ = /** @type {Entry} */ (this.oldest_.newer);
	      this.oldest_.older = null;
	    } else {
	      entry.newer.older = entry.older;
	      entry.older.newer = entry.newer;
	    }
	    entry.newer = null;
	    entry.older = this.newest_;
	    this.newest_.newer = entry;
	    this.newest_ = entry;
	    return entry.value_;
	  };
	
	
	  /**
	   * Remove an entry from the cache.
	   * @param {string} key The entry key.
	   * @return {T} The removed entry.
	   */
	  LRUCache.prototype.remove = function remove (key) {
	    var entry = this.entries_[key];
	    assert(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
	    if (entry === this.newest_) {
	      this.newest_ = /** @type {Entry} */ (entry.older);
	      if (this.newest_) {
	        this.newest_.newer = null;
	      }
	    } else if (entry === this.oldest_) {
	      this.oldest_ = /** @type {Entry} */ (entry.newer);
	      if (this.oldest_) {
	        this.oldest_.older = null;
	      }
	    } else {
	      entry.newer.older = entry.older;
	      entry.older.newer = entry.newer;
	    }
	    delete this.entries_[key];
	    --this.count_;
	    return entry.value_;
	  };
	
	
	  /**
	   * @return {number} Count.
	   */
	  LRUCache.prototype.getCount = function getCount () {
	    return this.count_;
	  };
	
	
	  /**
	   * @return {Array<string>} Keys.
	   */
	  LRUCache.prototype.getKeys = function getKeys () {
	    var keys = new Array(this.count_);
	    var i = 0;
	    var entry;
	    for (entry = this.newest_; entry; entry = entry.older) {
	      keys[i++] = entry.key_;
	    }
	    return keys;
	  };
	
	
	  /**
	   * @return {Array<T>} Values.
	   */
	  LRUCache.prototype.getValues = function getValues () {
	    var values = new Array(this.count_);
	    var i = 0;
	    var entry;
	    for (entry = this.newest_; entry; entry = entry.older) {
	      values[i++] = entry.value_;
	    }
	    return values;
	  };
	
	
	  /**
	   * @return {T} Last value.
	   */
	  LRUCache.prototype.peekLast = function peekLast () {
	    return this.oldest_.value_;
	  };
	
	
	  /**
	   * @return {string} Last key.
	   */
	  LRUCache.prototype.peekLastKey = function peekLastKey () {
	    return this.oldest_.key_;
	  };
	
	
	  /**
	   * Get the key of the newest item in the cache.  Throws if the cache is empty.
	   * @return {string} The newest key.
	   */
	  LRUCache.prototype.peekFirstKey = function peekFirstKey () {
	    return this.newest_.key_;
	  };
	
	
	  /**
	   * @return {T} value Value.
	   */
	  LRUCache.prototype.pop = function pop () {
	    var entry = this.oldest_;
	    delete this.entries_[entry.key_];
	    if (entry.newer) {
	      entry.newer.older = null;
	    }
	    this.oldest_ = /** @type {Entry} */ (entry.newer);
	    if (!this.oldest_) {
	      this.newest_ = null;
	    }
	    --this.count_;
	    return entry.value_;
	  };
	
	
	  /**
	   * @param {string} key Key.
	   * @param {T} value Value.
	   */
	  LRUCache.prototype.replace = function replace (key, value) {
	    this.get(key); // update `newest_`
	    this.entries_[key].value_ = value;
	  };
	
	
	  /**
	   * @param {string} key Key.
	   * @param {T} value Value.
	   */
	  LRUCache.prototype.set = function set (key, value) {
	    assert(!(key in this.entries_),
	      16); // Tried to set a value for a key that is used already
	    var entry = /** @type {Entry} */ ({
	      key_: key,
	      newer: null,
	      older: this.newest_,
	      value_: value
	    });
	    if (!this.newest_) {
	      this.oldest_ = entry;
	    } else {
	      this.newest_.newer = entry;
	    }
	    this.newest_ = entry;
	    this.entries_[key] = entry;
	    ++this.count_;
	  };
	
	
	  /**
	   * Set a maximum number of entries for the cache.
	   * @param {number} size Cache size.
	   * @api
	   */
	  LRUCache.prototype.setSize = function setSize (size) {
	    this.highWaterMark = size;
	  };
	
	
	  /**
	   * Prune the cache.
	   */
	  LRUCache.prototype.prune = function prune () {
	    while (this.canExpireCache()) {
	      this.pop();
	    }
	  };
	
	  return LRUCache;
	}(Target));
	
	/**
	 * @module ol/render/canvas/Instruction
	 */
	
	/**
	 * @enum {number}
	 */
	var Instruction = {
	  BEGIN_GEOMETRY: 0,
	  BEGIN_PATH: 1,
	  CIRCLE: 2,
	  CLOSE_PATH: 3,
	  CUSTOM: 4,
	  DRAW_CHARS: 5,
	  DRAW_IMAGE: 6,
	  END_GEOMETRY: 7,
	  FILL: 8,
	  MOVE_TO_LINE_TO: 9,
	  SET_FILL_STYLE: 10,
	  SET_STROKE_STYLE: 11,
	  STROKE: 12
	};
	
	
	/**
	 * @type {Array<Instruction>}
	 */
	var fillInstruction = [Instruction.FILL];
	
	
	/**
	 * @type {Array<Instruction>}
	 */
	var strokeInstruction = [Instruction.STROKE];
	
	
	/**
	 * @type {Array<Instruction>}
	 */
	var beginPathInstruction = [Instruction.BEGIN_PATH];
	
	
	/**
	 * @type {Array<Instruction>}
	 */
	var closePathInstruction = [Instruction.CLOSE_PATH];
	
	/**
	 * @module ol/render/canvas
	 */
	
	
	/**
	 * @typedef {Object} FillState
	 * @property {import("../colorlike.js").ColorLike} fillStyle
	 */
	
	
	/**
	 * @typedef {Object} FillStrokeState
	 * @property {import("../colorlike.js").ColorLike} [currentFillStyle]
	 * @property {import("../colorlike.js").ColorLike} [currentStrokeStyle]
	 * @property {string} [currentLineCap]
	 * @property {Array<number>} currentLineDash
	 * @property {number} [currentLineDashOffset]
	 * @property {string} [currentLineJoin]
	 * @property {number} [currentLineWidth]
	 * @property {number} [currentMiterLimit]
	 * @property {number} [lastStroke]
	 * @property {import("../colorlike.js").ColorLike} [fillStyle]
	 * @property {import("../colorlike.js").ColorLike} [strokeStyle]
	 * @property {string} [lineCap]
	 * @property {Array<number>} lineDash
	 * @property {number} [lineDashOffset]
	 * @property {string} [lineJoin]
	 * @property {number} [lineWidth]
	 * @property {number} [miterLimit]
	 */
	
	
	/**
	 * @typedef {Object} StrokeState
	 * @property {string} lineCap
	 * @property {Array<number>} lineDash
	 * @property {number} lineDashOffset
	 * @property {string} lineJoin
	 * @property {number} lineWidth
	 * @property {number} miterLimit
	 * @property {import("../colorlike.js").ColorLike} strokeStyle
	 */
	
	
	/**
	 * @typedef {Object} TextState
	 * @property {string} font
	 * @property {string} [textAlign]
	 * @property {string} textBaseline
	 * @property {string} [placement]
	 * @property {number} [maxAngle]
	 * @property {boolean} [overflow]
	 * @property {import("../style/Fill.js").default} [backgroundFill]
	 * @property {import("../style/Stroke.js").default} [backgroundStroke]
	 * @property {number} [scale]
	 * @property {Array<number>} [padding]
	 */
	
	
	/**
	 * Container for decluttered replay instructions that need to be rendered or
	 * omitted together, i.e. when styles render both an image and text, or for the
	 * characters that form text along lines. The basic elements of this array are
	 * `[minX, minY, maxX, maxY, count]`, where the first four entries are the
	 * rendered extent of the group in pixel space. `count` is the number of styles
	 * in the group, i.e. 2 when an image and a text are grouped, or 1 otherwise.
	 * In addition to these four elements, declutter instruction arrays (i.e. the
	 * arguments to {@link module:ol/render/canvas~drawImage} are appended to the array.
	 * @typedef {Array<*>} DeclutterGroup
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 * @api
	 */
	var defaultFont = '10px sans-serif';
	
	
	/**
	 * @const
	 * @type {import("../color.js").Color}
	 * @api
	 */
	var defaultFillStyle = [0, 0, 0, 1];
	
	
	/**
	 * @const
	 * @type {string}
	 * @api
	 */
	var defaultLineCap = 'round';
	
	
	/**
	 * @const
	 * @type {Array<number>}
	 * @api
	 */
	var defaultLineDash = [];
	
	
	/**
	 * @const
	 * @type {number}
	 * @api
	 */
	var defaultLineDashOffset = 0;
	
	
	/**
	 * @const
	 * @type {string}
	 * @api
	 */
	var defaultLineJoin = 'round';
	
	
	/**
	 * @const
	 * @type {number}
	 * @api
	 */
	var defaultMiterLimit = 10;
	
	
	/**
	 * @const
	 * @type {import("../color.js").Color}
	 * @api
	 */
	var defaultStrokeStyle = [0, 0, 0, 1];
	
	
	/**
	 * @const
	 * @type {string}
	 * @api
	 */
	var defaultTextAlign = 'center';
	
	
	/**
	 * @const
	 * @type {string}
	 * @api
	 */
	var defaultTextBaseline = 'middle';
	
	
	/**
	 * @const
	 * @type {Array<number>}
	 * @api
	 */
	var defaultPadding = [0, 0, 0, 0];
	
	
	/**
	 * @const
	 * @type {number}
	 * @api
	 */
	var defaultLineWidth = 1;
	
	
	/**
	 * The label cache for text rendering. To change the default cache size of 2048
	 * entries, use {@link module:ol/structs/LRUCache#setSize}.
	 * @type {LRUCache<HTMLCanvasElement>}
	 * @api
	 */
	var labelCache = new LRUCache();
	
	
	/**
	 * @type {!Object<string, number>}
	 */
	var checkedFonts = {};
	
	
	/**
	 * @type {CanvasRenderingContext2D}
	 */
	var measureContext = null;
	
	
	/**
	 * @type {!Object<string, number>}
	 */
	var textHeights = {};
	
	
	/**
	 * Clears the label cache when a font becomes available.
	 * @param {string} fontSpec CSS font spec.
	 * @api
	 */
	var checkFont = (function() {
	  var retries = 60;
	  var checked = checkedFonts;
	  var size = '32px ';
	  var referenceFonts = ['monospace', 'serif'];
	  var len = referenceFonts.length;
	  var text = 'wmytzilWMYTZIL@#/&?$%10\uF013';
	  var interval, referenceWidth;
	
	  function isAvailable(font) {
	    var context = getMeasureContext();
	    // Check weight ranges according to
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Fallback_weights
	    for (var weight = 100; weight <= 700; weight += 300) {
	      var fontWeight = weight + ' ';
	      var available = true;
	      for (var i = 0; i < len; ++i) {
	        var referenceFont = referenceFonts[i];
	        context.font = fontWeight + size + referenceFont;
	        referenceWidth = context.measureText(text).width;
	        if (font != referenceFont) {
	          context.font = fontWeight + size + font + ',' + referenceFont;
	          var width = context.measureText(text).width;
	          // If width and referenceWidth are the same, then the fallback was used
	          // instead of the font we wanted, so the font is not available.
	          available = available && width != referenceWidth;
	        }
	      }
	      if (available) {
	        // Consider font available when it is available in one weight range.
	        //FIXME With this we miss rare corner cases, so we should consider
	        //FIXME checking availability for each requested weight range.
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function check() {
	    var done = true;
	    for (var font in checked) {
	      if (checked[font] < retries) {
	        if (isAvailable(font)) {
	          checked[font] = retries;
	          clear(textHeights);
	          // Make sure that loaded fonts are picked up by Safari
	          measureContext = null;
	          labelCache.clear();
	        } else {
	          ++checked[font];
	          done = false;
	        }
	      }
	    }
	    if (done) {
	      clearInterval(interval);
	      interval = undefined;
	    }
	  }
	
	  return function(fontSpec) {
	    var fontFamilies = getFontFamilies(fontSpec);
	    if (!fontFamilies) {
	      return;
	    }
	    for (var i = 0, ii = fontFamilies.length; i < ii; ++i) {
	      var fontFamily = fontFamilies[i];
	      if (!(fontFamily in checked)) {
	        checked[fontFamily] = retries;
	        if (!isAvailable(fontFamily)) {
	          checked[fontFamily] = 0;
	          if (interval === undefined) {
	            interval = setInterval(check, 32);
	          }
	        }
	      }
	    }
	  };
	})();
	
	
	/**
	 * @return {CanvasRenderingContext2D} Measure context.
	 */
	function getMeasureContext() {
	  if (!measureContext) {
	    measureContext = createCanvasContext2D(1, 1);
	  }
	  return measureContext;
	}
	
	
	/**
	 * @param {string} font Font to use for measuring.
	 * @return {import("../size.js").Size} Measurement.
	 */
	var measureTextHeight = (function() {
	  var span;
	  var heights = textHeights;
	  return function(font) {
	    var height = heights[font];
	    if (height == undefined) {
	      if (!span) {
	        span = document.createElement('span');
	        span.textContent = 'M';
	        span.style.margin = span.style.padding = '0 !important';
	        span.style.position = 'absolute !important';
	        span.style.left = '-99999px !important';
	      }
	      span.style.font = font;
	      document.body.appendChild(span);
	      height = heights[font] = span.offsetHeight;
	      document.body.removeChild(span);
	    }
	    return height;
	  };
	})();
	
	
	/**
	 * @param {string} font Font.
	 * @param {string} text Text.
	 * @return {number} Width.
	 */
	function measureTextWidth(font, text) {
	  var measureContext = getMeasureContext();
	  if (font != measureContext.font) {
	    measureContext.font = font;
	  }
	  return measureContext.measureText(text).width;
	}
	
	
	/**
	 * @param {CanvasRenderingContext2D} context Context.
	 * @param {number} rotation Rotation.
	 * @param {number} offsetX X offset.
	 * @param {number} offsetY Y offset.
	 * @api
	 */
	function rotateAtOffset(context, rotation, offsetX, offsetY) {
	  if (rotation !== 0) {
	    context.translate(offsetX, offsetY);
	    context.rotate(rotation);
	    context.translate(-offsetX, -offsetY);
	  }
	}
	
	
	var resetTransform = create();
	
	
	/**
	 * @param {CanvasRenderingContext2D} context Context.
	 * @param {import("../transform.js").Transform|null} transform Transform.
	 * @param {number} opacity Opacity.
	 * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} image Image.
	 * @param {number} originX Origin X.
	 * @param {number} originY Origin Y.
	 * @param {number} w Width.
	 * @param {number} h Height.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {number} scale Scale.
	 */
	function drawImage(context,
	  transform, opacity, image, originX, originY, w, h, x, y, scale) {
	  var alpha;
	  if (opacity != 1) {
	    alpha = context.globalAlpha;
	    context.globalAlpha = alpha * opacity;
	  }
	  if (transform) {
	    context.setTransform.apply(context, transform);
	  }
	
	  context.drawImage(image, originX, originY, w, h, x, y, w * scale, h * scale);
	
	  if (alpha) {
	    context.globalAlpha = alpha;
	  }
	  if (transform) {
	    context.setTransform.apply(context, resetTransform);
	  }
	}
	
	/**
	 * @api
	 */
	var Instruction$1 = Instruction;
	
	/**
	 * @module ol/style/Image
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} opacity
	 * @property {boolean} rotateWithView
	 * @property {number} rotation
	 * @property {number} scale
	 */
	
	
	/**
	 * @classdesc
	 * A base class used for creating subclasses and not instantiated in
	 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
	 * {@link module:ol/style/RegularShape~RegularShape}.
	 * @abstract
	 * @api
	 */
	var ImageStyle = function ImageStyle(options) {
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.opacity_ = options.opacity;
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  this.rotateWithView_ = options.rotateWithView;
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.rotation_ = options.rotation;
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.scale_ = options.scale;
	
	};
	
	/**
	 * Clones the style.
	 * @return {ImageStyle} The cloned style.
	 * @api
	 */
	ImageStyle.prototype.clone = function clone () {
	  return new ImageStyle({
	    opacity: this.getOpacity(),
	    scale: this.getScale(),
	    rotation: this.getRotation(),
	    rotateWithView: this.getRotateWithView()
	  });
	};
	
	/**
	 * Get the symbolizer opacity.
	 * @return {number} Opacity.
	 * @api
	 */
	ImageStyle.prototype.getOpacity = function getOpacity () {
	  return this.opacity_;
	};
	
	/**
	 * Determine whether the symbolizer rotates with the map.
	 * @return {boolean} Rotate with map.
	 * @api
	 */
	ImageStyle.prototype.getRotateWithView = function getRotateWithView () {
	  return this.rotateWithView_;
	};
	
	/**
	 * Get the symoblizer rotation.
	 * @return {number} Rotation.
	 * @api
	 */
	ImageStyle.prototype.getRotation = function getRotation () {
	  return this.rotation_;
	};
	
	/**
	 * Get the symbolizer scale.
	 * @return {number} Scale.
	 * @api
	 */
	ImageStyle.prototype.getScale = function getScale () {
	  return this.scale_;
	};
	
	/**
	 * This method is deprecated and always returns false.
	 * @return {boolean} false.
	 * @deprecated
	 * @api
	 */
	ImageStyle.prototype.getSnapToPixel = function getSnapToPixel () {
	  return false;
	};
	
	/**
	 * Get the anchor point in pixels. The anchor determines the center point for the
	 * symbolizer.
	 * @abstract
	 * @return {Array<number>} Anchor.
	 */
	ImageStyle.prototype.getAnchor = function getAnchor () {
	  return abstract();
	};
	
	/**
	 * Get the image element for the symbolizer.
	 * @abstract
	 * @param {number} pixelRatio Pixel ratio.
	 * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
	 */
	ImageStyle.prototype.getImage = function getImage (pixelRatio) {
	  return abstract();
	};
	
	/**
	 * @abstract
	 * @param {number} pixelRatio Pixel ratio.
	 * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
	 */
	ImageStyle.prototype.getHitDetectionImage = function getHitDetectionImage (pixelRatio) {
	  return abstract();
	};
	
	/**
	 * @abstract
	 * @return {import("../ImageState.js").default} Image state.
	 */
	ImageStyle.prototype.getImageState = function getImageState () {
	  return abstract();
	};
	
	/**
	 * @abstract
	 * @return {import("../size.js").Size} Image size.
	 */
	ImageStyle.prototype.getImageSize = function getImageSize () {
	  return abstract();
	};
	
	/**
	 * @abstract
	 * @return {import("../size.js").Size} Size of the hit-detection image.
	 */
	ImageStyle.prototype.getHitDetectionImageSize = function getHitDetectionImageSize () {
	  return abstract();
	};
	
	/**
	 * Get the origin of the symbolizer.
	 * @abstract
	 * @return {Array<number>} Origin.
	 */
	ImageStyle.prototype.getOrigin = function getOrigin () {
	  return abstract();
	};
	
	/**
	 * Get the size of the symbolizer (in pixels).
	 * @abstract
	 * @return {import("../size.js").Size} Size.
	 */
	ImageStyle.prototype.getSize = function getSize () {
	  return abstract();
	};
	
	/**
	 * Set the opacity.
	 *
	 * @param {number} opacity Opacity.
	 * @api
	 */
	ImageStyle.prototype.setOpacity = function setOpacity (opacity) {
	  this.opacity_ = opacity;
	};
	
	/**
	 * Set whether to rotate the style with the view.
	 *
	 * @param {boolean} rotateWithView Rotate with map.
	 * @api
	 */
	ImageStyle.prototype.setRotateWithView = function setRotateWithView (rotateWithView) {
	  this.rotateWithView_ = rotateWithView;
	};
	
	/**
	 * Set the rotation.
	 *
	 * @param {number} rotation Rotation.
	 * @api
	 */
	ImageStyle.prototype.setRotation = function setRotation (rotation) {
	  this.rotation_ = rotation;
	};
	/**
	 * Set the scale.
	 *
	 * @param {number} scale Scale.
	 * @api
	 */
	ImageStyle.prototype.setScale = function setScale (scale) {
	  this.scale_ = scale;
	};
	
	/**
	 * This method is deprecated and does nothing.
	 * @param {boolean} snapToPixel Snap to pixel?
	 * @deprecated
	 * @api
	 */
	ImageStyle.prototype.setSnapToPixel = function setSnapToPixel (snapToPixel) {};
	
	/**
	 * @abstract
	 * @param {function(this: T, import("../events/Event.js").default)} listener Listener function.
	 * @param {T} thisArg Value to use as `this` when executing `listener`.
	 * @return {import("../events.js").EventsKey|undefined} Listener key.
	 * @template T
	 */
	ImageStyle.prototype.listenImageChange = function listenImageChange (listener, thisArg) {
	  return abstract();
	};
	
	/**
	 * Load not yet loaded URI.
	 * @abstract
	 */
	ImageStyle.prototype.load = function load () {
	  abstract();
	};
	
	/**
	 * @abstract
	 * @param {function(this: T, import("../events/Event.js").default)} listener Listener function.
	 * @param {T} thisArg Value to use as `this` when executing `listener`.
	 * @template T
	 */
	ImageStyle.prototype.unlistenImageChange = function unlistenImageChange (listener, thisArg) {
	  abstract();
	};
	
	/**
	 * @module ol/style/RegularShape
	 */
	
	
	/**
	 * Specify radius for regular polygons, or radius1 and radius2 for stars.
	 * @typedef {Object} Options
	 * @property {import("./Fill.js").default} [fill] Fill style.
	 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
	 * is the number of sides.
	 * @property {number} [radius] Radius of a regular polygon.
	 * @property {number} [radius1] Outer radius of a star.
	 * @property {number} [radius2] Inner radius of a star.
	 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's point facing up.
	 * @property {import("./Stroke.js").default} [stroke] Stroke style.
	 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
	 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
	 * @property {import("./AtlasManager.js").default} [atlasManager] The atlas manager to use for this symbol. When
	 * using WebGL it is recommended to use an atlas manager to avoid texture switching. If an atlas manager is given, the
	 * symbol is added to an atlas. By default no atlas manager is used.
	 */
	
	
	/**
	 * @typedef {Object} RenderOptions
	 * @property {import("../colorlike.js").ColorLike} [strokeStyle]
	 * @property {number} strokeWidth
	 * @property {number} size
	 * @property {string} lineCap
	 * @property {Array<number>} lineDash
	 * @property {number} lineDashOffset
	 * @property {string} lineJoin
	 * @property {number} miterLimit
	 */
	
	
	/**
	 * @classdesc
	 * Set regular shape style for vector features. The resulting shape will be
	 * a regular polygon when `radius` is provided, or a star when `radius1` and
	 * `radius2` are provided.
	 * @api
	 */
	var RegularShape = /*@__PURE__*/(function (ImageStyle$$1) {
	  function RegularShape(options) {
	    /**
	     * @type {boolean}
	     */
	    var rotateWithView = options.rotateWithView !== undefined ?
	      options.rotateWithView : false;
	
	    ImageStyle$$1.call(this, {
	      opacity: 1,
	      rotateWithView: rotateWithView,
	      rotation: options.rotation !== undefined ? options.rotation : 0,
	      scale: 1
	    });
	
	    /**
	     * @private
	     * @type {Array<string|number>}
	     */
	    this.checksums_ = null;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = null;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.hitDetectionCanvas_ = null;
	
	    /**
	     * @private
	     * @type {import("./Fill.js").default}
	     */
	    this.fill_ = options.fill !== undefined ? options.fill : null;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.origin_ = [0, 0];
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.points_ = options.points;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.radius_ = /** @type {number} */ (options.radius !== undefined ?
	      options.radius : options.radius1);
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.radius2_ = options.radius2;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.angle_ = options.angle !== undefined ? options.angle : 0;
	
	    /**
	     * @private
	     * @type {import("./Stroke.js").default}
	     */
	    this.stroke_ = options.stroke !== undefined ? options.stroke : null;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.anchor_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.size_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.imageSize_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.hitDetectionImageSize_ = null;
	
	    /**
	     * @protected
	     * @type {import("./AtlasManager.js").default|undefined}
	     */
	    this.atlasManager_ = options.atlasManager;
	
	    this.render_(this.atlasManager_);
	
	  }
	
	  if ( ImageStyle$$1 ) { RegularShape.__proto__ = ImageStyle$$1; }
	  RegularShape.prototype = Object.create( ImageStyle$$1 && ImageStyle$$1.prototype );
	  RegularShape.prototype.constructor = RegularShape;
	
	  /**
	   * Clones the style. If an atlasmanager was provided to the original style it will be used in the cloned style, too.
	   * @return {RegularShape} The cloned style.
	   * @api
	   */
	  RegularShape.prototype.clone = function clone () {
	    var style = new RegularShape({
	      fill: this.getFill() ? this.getFill().clone() : undefined,
	      points: this.getPoints(),
	      radius: this.getRadius(),
	      radius2: this.getRadius2(),
	      angle: this.getAngle(),
	      stroke: this.getStroke() ? this.getStroke().clone() : undefined,
	      rotation: this.getRotation(),
	      rotateWithView: this.getRotateWithView(),
	      atlasManager: this.atlasManager_
	    });
	    style.setOpacity(this.getOpacity());
	    style.setScale(this.getScale());
	    return style;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  RegularShape.prototype.getAnchor = function getAnchor () {
	    return this.anchor_;
	  };
	
	  /**
	   * Get the angle used in generating the shape.
	   * @return {number} Shape's rotation in radians.
	   * @api
	   */
	  RegularShape.prototype.getAngle = function getAngle () {
	    return this.angle_;
	  };
	
	  /**
	   * Get the fill style for the shape.
	   * @return {import("./Fill.js").default} Fill style.
	   * @api
	   */
	  RegularShape.prototype.getFill = function getFill () {
	    return this.fill_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.getHitDetectionImage = function getHitDetectionImage (pixelRatio) {
	    return this.hitDetectionCanvas_;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  RegularShape.prototype.getImage = function getImage (pixelRatio) {
	    return this.canvas_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.getImageSize = function getImageSize () {
	    return this.imageSize_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.getHitDetectionImageSize = function getHitDetectionImageSize () {
	    return this.hitDetectionImageSize_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.getImageState = function getImageState () {
	    return ImageState.LOADED;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  RegularShape.prototype.getOrigin = function getOrigin () {
	    return this.origin_;
	  };
	
	  /**
	   * Get the number of points for generating the shape.
	   * @return {number} Number of points for stars and regular polygons.
	   * @api
	   */
	  RegularShape.prototype.getPoints = function getPoints () {
	    return this.points_;
	  };
	
	  /**
	   * Get the (primary) radius for the shape.
	   * @return {number} Radius.
	   * @api
	   */
	  RegularShape.prototype.getRadius = function getRadius () {
	    return this.radius_;
	  };
	
	  /**
	   * Get the secondary radius for the shape.
	   * @return {number|undefined} Radius2.
	   * @api
	   */
	  RegularShape.prototype.getRadius2 = function getRadius2 () {
	    return this.radius2_;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  RegularShape.prototype.getSize = function getSize () {
	    return this.size_;
	  };
	
	  /**
	   * Get the stroke style for the shape.
	   * @return {import("./Stroke.js").default} Stroke style.
	   * @api
	   */
	  RegularShape.prototype.getStroke = function getStroke () {
	    return this.stroke_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.listenImageChange = function listenImageChange (listener, thisArg) {
	    return undefined;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.load = function load () {};
	
	  /**
	   * @inheritDoc
	   */
	  RegularShape.prototype.unlistenImageChange = function unlistenImageChange (listener, thisArg) {};
	
	  /**
	   * @protected
	   * @param {import("./AtlasManager.js").default|undefined} atlasManager An atlas manager.
	   */
	  RegularShape.prototype.render_ = function render_ (atlasManager) {
	    var imageSize;
	    var lineCap = '';
	    var lineJoin = '';
	    var miterLimit = 0;
	    var lineDash = null;
	    var lineDashOffset = 0;
	    var strokeStyle;
	    var strokeWidth = 0;
	
	    if (this.stroke_) {
	      strokeStyle = this.stroke_.getColor();
	      if (strokeStyle === null) {
	        strokeStyle = defaultStrokeStyle;
	      }
	      strokeStyle = asColorLike(strokeStyle);
	      strokeWidth = this.stroke_.getWidth();
	      if (strokeWidth === undefined) {
	        strokeWidth = defaultLineWidth;
	      }
	      lineDash = this.stroke_.getLineDash();
	      lineDashOffset = this.stroke_.getLineDashOffset();
	      if (!CANVAS_LINE_DASH) {
	        lineDash = null;
	        lineDashOffset = 0;
	      }
	      lineJoin = this.stroke_.getLineJoin();
	      if (lineJoin === undefined) {
	        lineJoin = defaultLineJoin;
	      }
	      lineCap = this.stroke_.getLineCap();
	      if (lineCap === undefined) {
	        lineCap = defaultLineCap;
	      }
	      miterLimit = this.stroke_.getMiterLimit();
	      if (miterLimit === undefined) {
	        miterLimit = defaultMiterLimit;
	      }
	    }
	
	    var size = 2 * (this.radius_ + strokeWidth) + 1;
	
	    /** @type {RenderOptions} */
	    var renderOptions = {
	      strokeStyle: strokeStyle,
	      strokeWidth: strokeWidth,
	      size: size,
	      lineCap: lineCap,
	      lineDash: lineDash,
	      lineDashOffset: lineDashOffset,
	      lineJoin: lineJoin,
	      miterLimit: miterLimit
	    };
	
	    if (atlasManager === undefined) {
	      // no atlas manager is used, create a new canvas
	      var context = createCanvasContext2D(size, size);
	      this.canvas_ = context.canvas;
	
	      // canvas.width and height are rounded to the closest integer
	      size = this.canvas_.width;
	      imageSize = size;
	
	      this.draw_(renderOptions, context, 0, 0);
	
	      this.createHitDetectionCanvas_(renderOptions);
	    } else {
	      // an atlas manager is used, add the symbol to an atlas
	      size = Math.round(size);
	
	      var hasCustomHitDetectionImage = !this.fill_;
	      var renderHitDetectionCallback;
	      if (hasCustomHitDetectionImage) {
	        // render the hit-detection image into a separate atlas image
	        renderHitDetectionCallback =
	            this.drawHitDetectionCanvas_.bind(this, renderOptions);
	      }
	
	      var id = this.getChecksum();
	      var info = atlasManager.add(
	        id, size, size, this.draw_.bind(this, renderOptions),
	        renderHitDetectionCallback);
	
	      this.canvas_ = info.image;
	      this.origin_ = [info.offsetX, info.offsetY];
	      imageSize = info.image.width;
	
	      if (hasCustomHitDetectionImage) {
	        this.hitDetectionCanvas_ = info.hitImage;
	        this.hitDetectionImageSize_ =
	            [info.hitImage.width, info.hitImage.height];
	      } else {
	        this.hitDetectionCanvas_ = this.canvas_;
	        this.hitDetectionImageSize_ = [imageSize, imageSize];
	      }
	    }
	
	    this.anchor_ = [size / 2, size / 2];
	    this.size_ = [size, size];
	    this.imageSize_ = [imageSize, imageSize];
	  };
	
	  /**
	   * @private
	   * @param {RenderOptions} renderOptions Render options.
	   * @param {CanvasRenderingContext2D} context The rendering context.
	   * @param {number} x The origin for the symbol (x).
	   * @param {number} y The origin for the symbol (y).
	   */
	  RegularShape.prototype.draw_ = function draw_ (renderOptions, context, x, y) {
	    var i, angle0, radiusC;
	    // reset transform
	    context.setTransform(1, 0, 0, 1, 0, 0);
	
	    // then move to (x, y)
	    context.translate(x, y);
	
	    context.beginPath();
	
	    var points = this.points_;
	    if (points === Infinity) {
	      context.arc(
	        renderOptions.size / 2, renderOptions.size / 2,
	        this.radius_, 0, 2 * Math.PI, true);
	    } else {
	      var radius2 = (this.radius2_ !== undefined) ? this.radius2_
	        : this.radius_;
	      if (radius2 !== this.radius_) {
	        points = 2 * points;
	      }
	      for (i = 0; i <= points; i++) {
	        angle0 = i * 2 * Math.PI / points - Math.PI / 2 + this.angle_;
	        radiusC = i % 2 === 0 ? this.radius_ : radius2;
	        context.lineTo(renderOptions.size / 2 + radiusC * Math.cos(angle0),
	          renderOptions.size / 2 + radiusC * Math.sin(angle0));
	      }
	    }
	
	
	    if (this.fill_) {
	      var color = this.fill_.getColor();
	      if (color === null) {
	        color = defaultFillStyle;
	      }
	      context.fillStyle = asColorLike(color);
	      context.fill();
	    }
	    if (this.stroke_) {
	      context.strokeStyle = renderOptions.strokeStyle;
	      context.lineWidth = renderOptions.strokeWidth;
	      if (renderOptions.lineDash) {
	        context.setLineDash(renderOptions.lineDash);
	        context.lineDashOffset = renderOptions.lineDashOffset;
	      }
	      context.lineCap = /** @type {CanvasLineCap} */ (renderOptions.lineCap);
	      context.lineJoin = /** @type {CanvasLineJoin} */ (renderOptions.lineJoin);
	      context.miterLimit = renderOptions.miterLimit;
	      context.stroke();
	    }
	    context.closePath();
	  };
	
	  /**
	   * @private
	   * @param {RenderOptions} renderOptions Render options.
	   */
	  RegularShape.prototype.createHitDetectionCanvas_ = function createHitDetectionCanvas_ (renderOptions) {
	    this.hitDetectionImageSize_ = [renderOptions.size, renderOptions.size];
	    if (this.fill_) {
	      this.hitDetectionCanvas_ = this.canvas_;
	      return;
	    }
	
	    // if no fill style is set, create an extra hit-detection image with a
	    // default fill style
	    var context = createCanvasContext2D(renderOptions.size, renderOptions.size);
	    this.hitDetectionCanvas_ = context.canvas;
	
	    this.drawHitDetectionCanvas_(renderOptions, context, 0, 0);
	  };
	
	  /**
	   * @private
	   * @param {RenderOptions} renderOptions Render options.
	   * @param {CanvasRenderingContext2D} context The context.
	   * @param {number} x The origin for the symbol (x).
	   * @param {number} y The origin for the symbol (y).
	   */
	  RegularShape.prototype.drawHitDetectionCanvas_ = function drawHitDetectionCanvas_ (renderOptions, context, x, y) {
	    // reset transform
	    context.setTransform(1, 0, 0, 1, 0, 0);
	
	    // then move to (x, y)
	    context.translate(x, y);
	
	    context.beginPath();
	
	    var points = this.points_;
	    if (points === Infinity) {
	      context.arc(
	        renderOptions.size / 2, renderOptions.size / 2,
	        this.radius_, 0, 2 * Math.PI, true);
	    } else {
	      var radius2 = (this.radius2_ !== undefined) ? this.radius2_
	        : this.radius_;
	      if (radius2 !== this.radius_) {
	        points = 2 * points;
	      }
	      var i, radiusC, angle0;
	      for (i = 0; i <= points; i++) {
	        angle0 = i * 2 * Math.PI / points - Math.PI / 2 + this.angle_;
	        radiusC = i % 2 === 0 ? this.radius_ : radius2;
	        context.lineTo(renderOptions.size / 2 + radiusC * Math.cos(angle0),
	          renderOptions.size / 2 + radiusC * Math.sin(angle0));
	      }
	    }
	
	    context.fillStyle = asString(defaultFillStyle);
	    context.fill();
	    if (this.stroke_) {
	      context.strokeStyle = renderOptions.strokeStyle;
	      context.lineWidth = renderOptions.strokeWidth;
	      if (renderOptions.lineDash) {
	        context.setLineDash(renderOptions.lineDash);
	        context.lineDashOffset = renderOptions.lineDashOffset;
	      }
	      context.stroke();
	    }
	    context.closePath();
	  };
	
	  /**
	   * @return {string} The checksum.
	   */
	  RegularShape.prototype.getChecksum = function getChecksum () {
	    var strokeChecksum = this.stroke_ ?
	      this.stroke_.getChecksum() : '-';
	    var fillChecksum = this.fill_ ?
	      this.fill_.getChecksum() : '-';
	
	    var recalculate = !this.checksums_ ||
	        (strokeChecksum != this.checksums_[1] ||
	        fillChecksum != this.checksums_[2] ||
	        this.radius_ != this.checksums_[3] ||
	        this.radius2_ != this.checksums_[4] ||
	        this.angle_ != this.checksums_[5] ||
	        this.points_ != this.checksums_[6]);
	
	    if (recalculate) {
	      var checksum = 'r' + strokeChecksum + fillChecksum +
	          (this.radius_ !== undefined ? this.radius_.toString() : '-') +
	          (this.radius2_ !== undefined ? this.radius2_.toString() : '-') +
	          (this.angle_ !== undefined ? this.angle_.toString() : '-') +
	          (this.points_ !== undefined ? this.points_.toString() : '-');
	      this.checksums_ = [checksum, strokeChecksum, fillChecksum,
	        this.radius_, this.radius2_, this.angle_, this.points_];
	    }
	
	    return /** @type {string} */ (this.checksums_[0]);
	  };
	
	  return RegularShape;
	}(ImageStyle));
	
	/**
	 * @module ol/style/Circle
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Fill.js").default} [fill] Fill style.
	 * @property {number} radius Circle radius.
	 * @property {import("./Stroke.js").default} [stroke] Stroke style.
	 * @property {import("./AtlasManager.js").default} [atlasManager] The atlas manager to use for this circle.
	 * When using WebGL it is recommended to use an atlas manager to avoid texture switching. If an atlas manager is given,
	 * the circle is added to an atlas. By default no atlas manager is used.
	 */
	
	
	/**
	 * @classdesc
	 * Set circle style for vector features.
	 * @api
	 */
	var CircleStyle = /*@__PURE__*/(function (RegularShape$$1) {
	  function CircleStyle(opt_options) {
	
	    var options = opt_options || /** @type {Options} */ ({});
	
	    RegularShape$$1.call(this, {
	      points: Infinity,
	      fill: options.fill,
	      radius: options.radius,
	      stroke: options.stroke,
	      atlasManager: options.atlasManager
	    });
	
	  }
	
	  if ( RegularShape$$1 ) { CircleStyle.__proto__ = RegularShape$$1; }
	  CircleStyle.prototype = Object.create( RegularShape$$1 && RegularShape$$1.prototype );
	  CircleStyle.prototype.constructor = CircleStyle;
	
	  /**
	  * Clones the style.  If an atlasmanager was provided to the original style it will be used in the cloned style, too.
	  * @return {CircleStyle} The cloned style.
	  * @override
	  * @api
	  */
	  CircleStyle.prototype.clone = function clone () {
	    var style = new CircleStyle({
	      fill: this.getFill() ? this.getFill().clone() : undefined,
	      stroke: this.getStroke() ? this.getStroke().clone() : undefined,
	      radius: this.getRadius(),
	      atlasManager: this.atlasManager_
	    });
	    style.setOpacity(this.getOpacity());
	    style.setScale(this.getScale());
	    return style;
	  };
	
	  /**
	  * Set the circle radius.
	  *
	  * @param {number} radius Circle radius.
	  * @api
	  */
	  CircleStyle.prototype.setRadius = function setRadius (radius) {
	    this.radius_ = radius;
	    this.render_(this.atlasManager_);
	  };
	
	  return CircleStyle;
	}(RegularShape));
	
	/**
	 * @module ol/style/Style
	 */
	
	
	/**
	 * A function that takes an {@link module:ol/Feature} and a `{number}`
	 * representing the view's resolution. The function should return a
	 * {@link module:ol/style/Style} or an array of them. This way e.g. a
	 * vector layer can be styled.
	 *
	 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>)} StyleFunction
	 */
	
	/**
	 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
	 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
	 */
	
	/**
	 * A function that takes an {@link module:ol/Feature} as argument and returns an
	 * {@link module:ol/geom/Geometry} that will be rendered and styled for the feature.
	 *
	 * @typedef {function(import("../Feature.js").FeatureLike):
	 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
	 */
	
	
	/**
	 * Custom renderer function. Takes two arguments:
	 *
	 * 1. The pixel coordinates of the geometry in GeoJSON notation.
	 * 2. The {@link module:ol/render~State} of the layer renderer.
	 *
	 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>),import("../render.js").State)}
	 * RenderFunction
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
	 * or function returning a geometry to render for this style.
	 * @property {import("./Fill.js").default} [fill] Fill style.
	 * @property {import("./Image.js").default} [image] Image style.
	 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
	 * ignored, and the provided function will be called with each render frame for each geometry.
	 * @property {import("./Stroke.js").default} [stroke] Stroke style.
	 * @property {import("./Text.js").default} [text] Text style.
	 * @property {number} [zIndex] Z index.
	 */
	
	/**
	 * @classdesc
	 * Container for vector feature rendering styles. Any changes made to the style
	 * or its children through `set*()` methods will not take effect until the
	 * feature or layer that uses the style is re-rendered.
	 * @api
	 */
	var Style = function Style(opt_options) {
	
	  var options = opt_options || {};
	
	  /**
	   * @private
	   * @type {string|import("../geom/Geometry.js").default|GeometryFunction}
	   */
	  this.geometry_ = null;
	
	  /**
	   * @private
	   * @type {!GeometryFunction}
	   */
	  this.geometryFunction_ = defaultGeometryFunction;
	
	  if (options.geometry !== undefined) {
	    this.setGeometry(options.geometry);
	  }
	
	  /**
	   * @private
	   * @type {import("./Fill.js").default}
	   */
	  this.fill_ = options.fill !== undefined ? options.fill : null;
	
	  /**
	     * @private
	     * @type {import("./Image.js").default}
	     */
	  this.image_ = options.image !== undefined ? options.image : null;
	
	  /**
	   * @private
	   * @type {RenderFunction|null}
	   */
	  this.renderer_ = options.renderer !== undefined ? options.renderer : null;
	
	  /**
	   * @private
	   * @type {import("./Stroke.js").default}
	   */
	  this.stroke_ = options.stroke !== undefined ? options.stroke : null;
	
	  /**
	   * @private
	   * @type {import("./Text.js").default}
	   */
	  this.text_ = options.text !== undefined ? options.text : null;
	
	  /**
	   * @private
	   * @type {number|undefined}
	   */
	  this.zIndex_ = options.zIndex;
	
	};
	
	/**
	 * Clones the style.
	 * @return {Style} The cloned style.
	 * @api
	 */
	Style.prototype.clone = function clone () {
	  var geometry = this.getGeometry();
	  if (geometry && typeof geometry === 'object') {
	    geometry = /** @type {import("../geom/Geometry.js").default} */ (geometry).clone();
	  }
	  return new Style({
	    geometry: geometry,
	    fill: this.getFill() ? this.getFill().clone() : undefined,
	    image: this.getImage() ? this.getImage().clone() : undefined,
	    stroke: this.getStroke() ? this.getStroke().clone() : undefined,
	    text: this.getText() ? this.getText().clone() : undefined,
	    zIndex: this.getZIndex()
	  });
	};
	
	/**
	 * Get the custom renderer function that was configured with
	 * {@link #setRenderer} or the `renderer` constructor option.
	 * @return {RenderFunction|null} Custom renderer function.
	 * @api
	 */
	Style.prototype.getRenderer = function getRenderer () {
	  return this.renderer_;
	};
	
	/**
	 * Sets a custom renderer function for this style. When set, `fill`, `stroke`
	 * and `image` options of the style will be ignored.
	 * @param {RenderFunction|null} renderer Custom renderer function.
	 * @api
	 */
	Style.prototype.setRenderer = function setRenderer (renderer) {
	  this.renderer_ = renderer;
	};
	
	/**
	 * Get the geometry to be rendered.
	 * @return {string|import("../geom/Geometry.js").default|GeometryFunction}
	 * Feature property or geometry or function that returns the geometry that will
	 * be rendered with this style.
	 * @api
	 */
	Style.prototype.getGeometry = function getGeometry () {
	  return this.geometry_;
	};
	
	/**
	 * Get the function used to generate a geometry for rendering.
	 * @return {!GeometryFunction} Function that is called with a feature
	 * and returns the geometry to render instead of the feature's geometry.
	 * @api
	 */
	Style.prototype.getGeometryFunction = function getGeometryFunction () {
	  return this.geometryFunction_;
	};
	
	/**
	 * Get the fill style.
	 * @return {import("./Fill.js").default} Fill style.
	 * @api
	 */
	Style.prototype.getFill = function getFill () {
	  return this.fill_;
	};
	
	/**
	 * Set the fill style.
	 * @param {import("./Fill.js").default} fill Fill style.
	 * @api
	 */
	Style.prototype.setFill = function setFill (fill) {
	  this.fill_ = fill;
	};
	
	/**
	 * Get the image style.
	 * @return {import("./Image.js").default} Image style.
	 * @api
	 */
	Style.prototype.getImage = function getImage () {
	  return this.image_;
	};
	
	/**
	 * Set the image style.
	 * @param {import("./Image.js").default} image Image style.
	 * @api
	 */
	Style.prototype.setImage = function setImage (image) {
	  this.image_ = image;
	};
	
	/**
	 * Get the stroke style.
	 * @return {import("./Stroke.js").default} Stroke style.
	 * @api
	 */
	Style.prototype.getStroke = function getStroke () {
	  return this.stroke_;
	};
	
	/**
	 * Set the stroke style.
	 * @param {import("./Stroke.js").default} stroke Stroke style.
	 * @api
	 */
	Style.prototype.setStroke = function setStroke (stroke) {
	  this.stroke_ = stroke;
	};
	
	/**
	 * Get the text style.
	 * @return {import("./Text.js").default} Text style.
	 * @api
	 */
	Style.prototype.getText = function getText () {
	  return this.text_;
	};
	
	/**
	 * Set the text style.
	 * @param {import("./Text.js").default} text Text style.
	 * @api
	 */
	Style.prototype.setText = function setText (text) {
	  this.text_ = text;
	};
	
	/**
	 * Get the z-index for the style.
	 * @return {number|undefined} ZIndex.
	 * @api
	 */
	Style.prototype.getZIndex = function getZIndex () {
	  return this.zIndex_;
	};
	
	/**
	 * Set a geometry that is rendered instead of the feature's geometry.
	 *
	 * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
	 *   Feature property or geometry or function returning a geometry to render
	 *   for this style.
	 * @api
	 */
	Style.prototype.setGeometry = function setGeometry (geometry) {
	  if (typeof geometry === 'function') {
	    this.geometryFunction_ = geometry;
	  } else if (typeof geometry === 'string') {
	    this.geometryFunction_ = function(feature) {
	      return (
	        /** @type {import("../geom/Geometry.js").default} */ (feature.get(geometry))
	      );
	    };
	  } else if (!geometry) {
	    this.geometryFunction_ = defaultGeometryFunction;
	  } else if (geometry !== undefined) {
	    this.geometryFunction_ = function() {
	      return (
	        /** @type {import("../geom/Geometry.js").default} */ (geometry)
	      );
	    };
	  }
	  this.geometry_ = geometry;
	};
	
	/**
	 * Set the z-index.
	 *
	 * @param {number|undefined} zIndex ZIndex.
	 * @api
	 */
	Style.prototype.setZIndex = function setZIndex (zIndex) {
	  this.zIndex_ = zIndex;
	};
	
	
	/**
	 * Convert the provided object into a style function.  Functions passed through
	 * unchanged.  Arrays of Style or single style objects wrapped in a
	 * new style function.
	 * @param {StyleFunction|Array<Style>|Style} obj
	 *     A style function, a single style, or an array of styles.
	 * @return {StyleFunction} A style function.
	 */
	function toFunction(obj) {
	  var styleFunction;
	
	  if (typeof obj === 'function') {
	    styleFunction = obj;
	  } else {
	    /**
	     * @type {Array<Style>}
	     */
	    var styles;
	    if (Array.isArray(obj)) {
	      styles = obj;
	    } else {
	      assert(typeof /** @type {?} */ (obj).getZIndex === 'function',
	        41); // Expected an `Style` or an array of `Style`
	      var style = /** @type {Style} */ (obj);
	      styles = [style];
	    }
	    styleFunction = function() {
	      return styles;
	    };
	  }
	  return styleFunction;
	}
	
	
	/**
	 * @type {Array<Style>}
	 */
	var defaultStyles = null;
	
	
	/**
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 * @param {number} resolution Resolution.
	 * @return {Array<Style>} Style.
	 */
	function createDefaultStyle(feature, resolution) {
	  // We don't use an immediately-invoked function
	  // and a closure so we don't get an error at script evaluation time in
	  // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
	  // canvas.getContext('2d') at construction time, which will cause an.error
	  // in such browsers.)
	  if (!defaultStyles) {
	    var fill = new Fill({
	      color: 'rgba(255,255,255,0.4)'
	    });
	    var stroke = new Stroke({
	      color: '#3399CC',
	      width: 1.25
	    });
	    defaultStyles = [
	      new Style({
	        image: new CircleStyle({
	          fill: fill,
	          stroke: stroke,
	          radius: 5
	        }),
	        fill: fill,
	        stroke: stroke
	      })
	    ];
	  }
	  return defaultStyles;
	}
	
	
	/**
	 * Default styles for editing features.
	 * @return {Object<import("../geom/GeometryType.js").default, Array<Style>>} Styles
	 */
	function createEditingStyle() {
	  /** @type {Object<import("../geom/GeometryType.js").default, Array<Style>>} */
	  var styles = {};
	  var white = [255, 255, 255, 1];
	  var blue = [0, 153, 255, 1];
	  var width = 3;
	  styles[GeometryType.POLYGON] = [
	    new Style({
	      fill: new Fill({
	        color: [255, 255, 255, 0.5]
	      })
	    })
	  ];
	  styles[GeometryType.MULTI_POLYGON] =
	      styles[GeometryType.POLYGON];
	
	  styles[GeometryType.LINE_STRING] = [
	    new Style({
	      stroke: new Stroke({
	        color: white,
	        width: width + 2
	      })
	    }),
	    new Style({
	      stroke: new Stroke({
	        color: blue,
	        width: width
	      })
	    })
	  ];
	  styles[GeometryType.MULTI_LINE_STRING] =
	      styles[GeometryType.LINE_STRING];
	
	  styles[GeometryType.CIRCLE] =
	      styles[GeometryType.POLYGON].concat(
	        styles[GeometryType.LINE_STRING]
	      );
	
	
	  styles[GeometryType.POINT] = [
	    new Style({
	      image: new CircleStyle({
	        radius: width * 2,
	        fill: new Fill({
	          color: blue
	        }),
	        stroke: new Stroke({
	          color: white,
	          width: width / 2
	        })
	      }),
	      zIndex: Infinity
	    })
	  ];
	  styles[GeometryType.MULTI_POINT] =
	      styles[GeometryType.POINT];
	
	  styles[GeometryType.GEOMETRY_COLLECTION] =
	      styles[GeometryType.POLYGON].concat(
	        styles[GeometryType.LINE_STRING],
	        styles[GeometryType.POINT]
	      );
	
	  return styles;
	}
	
	
	/**
	 * Function that is called with a feature and returns its default geometry.
	 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
	 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
	 */
	function defaultGeometryFunction(feature) {
	  return feature.getGeometry();
	}
	
	/**
	 * @module ol/layer/Vector
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
	 * features before rendering. By default features are drawn in the order that they are created. Use
	 * `null` to avoid the sort, but get an undefined draw order.
	 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
	 * renderer when getting features from the vector source for the rendering or hit-detection.
	 * Recommended value: the size of the largest symbol, line width or label.
	 * @property {import("./VectorRenderType.js").default|string} [renderMode='vector'] Render mode for vector layers:
	 *  * `'image'`: Vector layers are rendered as images. Great performance, but point symbols and
	 *    texts are always rotated with the view and pixels are scaled during zoom animations.
	 *  * `'vector'`: Vector layers are rendered as vectors. Most accurate rendering even during
	 *    animations, but slower performance.
	 * @property {import("../source/Vector.js").default} [source] Source.
	 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
	 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
	 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
	 * use {@link module:ol/Map#addLayer}.
	 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
	 * image and text styles, and the priority is defined by the z-index of the style. Lower z-index
	 * means higher priority.
	 * @property {import("../style/Style.js").StyleLike} [style] Layer style. See
	 * {@link module:ol/style} for default style which will be used if this is not defined.
	 * @property {boolean} [updateWhileAnimating=false] When set to `true` and `renderMode`
	 * is `vector`, feature batches will be recreated during animations. This means that no
	 * vectors will be shown clipped, but the setting will have a performance impact for large
	 * amounts of vector data. When set to `false`, batches will be recreated when no animation
	 * is active.
	 * @property {boolean} [updateWhileInteracting=false] When set to `true` and `renderMode`
	 * is `vector`, feature batches will be recreated during interactions. See also
	 * `updateWhileAnimating`.
	 */
	
	
	/**
	 * @enum {string}
	 * @private
	 */
	var Property$3 = {
	  RENDER_ORDER: 'renderOrder'
	};
	
	
	/**
	 * @classdesc
	 * Vector data that is rendered client-side.
	 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
	 * property on the layer object; for example, setting `title: 'My Title'` in the
	 * options means that `title` is observable, and has get/set accessors.
	 *
	 * @api
	 */
	var VectorLayer = /*@__PURE__*/(function (Layer$$1) {
	  function VectorLayer(opt_options) {
	    var options = opt_options ?
	      opt_options : /** @type {Options} */ ({});
	
	    var baseOptions = assign({}, options);
	
	    delete baseOptions.style;
	    delete baseOptions.renderBuffer;
	    delete baseOptions.updateWhileAnimating;
	    delete baseOptions.updateWhileInteracting;
	    Layer$$1.call(this, baseOptions);
	
	    /**
	    * @private
	    * @type {boolean}
	    */
	    this.declutter_ = options.declutter !== undefined ? options.declutter : false;
	
	    /**
	    * @type {number}
	    * @private
	    */
	    this.renderBuffer_ = options.renderBuffer !== undefined ?
	      options.renderBuffer : 100;
	
	    /**
	    * User provided style.
	    * @type {import("../style/Style.js").StyleLike}
	    * @private
	    */
	    this.style_ = null;
	
	    /**
	    * Style function for use within the library.
	    * @type {import("../style/Style.js").StyleFunction|undefined}
	    * @private
	    */
	    this.styleFunction_ = undefined;
	
	    this.setStyle(options.style);
	
	    /**
	    * @type {boolean}
	    * @private
	    */
	    this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ?
	      options.updateWhileAnimating : false;
	
	    /**
	    * @type {boolean}
	    * @private
	    */
	    this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ?
	      options.updateWhileInteracting : false;
	
	    /**
	    * @private
	    * @type {import("./VectorTileRenderType.js").default|string}
	    */
	    this.renderMode_ = options.renderMode || VectorRenderType.VECTOR;
	
	    /**
	    * The layer type.
	    * @protected
	    * @type {import("../LayerType.js").default}
	    */
	    this.type = LayerType.VECTOR;
	
	  }
	
	  if ( Layer$$1 ) { VectorLayer.__proto__ = Layer$$1; }
	  VectorLayer.prototype = Object.create( Layer$$1 && Layer$$1.prototype );
	  VectorLayer.prototype.constructor = VectorLayer;
	
	  /**
	  * @return {boolean} Declutter.
	  */
	  VectorLayer.prototype.getDeclutter = function getDeclutter () {
	    return this.declutter_;
	  };
	
	  /**
	  * @param {boolean} declutter Declutter.
	  */
	  VectorLayer.prototype.setDeclutter = function setDeclutter (declutter) {
	    this.declutter_ = declutter;
	  };
	
	  /**
	  * @return {number|undefined} Render buffer.
	  */
	  VectorLayer.prototype.getRenderBuffer = function getRenderBuffer () {
	    return this.renderBuffer_;
	  };
	
	  /**
	  * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
	  *     order.
	  */
	  VectorLayer.prototype.getRenderOrder = function getRenderOrder () {
	    return (
	    /** @type {import("../render.js").OrderFunction|null|undefined} */ (this.get(Property$3.RENDER_ORDER))
	    );
	  };
	
	  /**
	  * Get the style for features.  This returns whatever was passed to the `style`
	  * option at construction or to the `setStyle` method.
	  * @return {import("../style/Style.js").StyleLike}
	  *     Layer style.
	  * @api
	  */
	  VectorLayer.prototype.getStyle = function getStyle () {
	    return this.style_;
	  };
	
	  /**
	  * Get the style function.
	  * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
	  * @api
	  */
	  VectorLayer.prototype.getStyleFunction = function getStyleFunction () {
	    return this.styleFunction_;
	  };
	
	  /**
	  * @return {boolean} Whether the rendered layer should be updated while
	  *     animating.
	  */
	  VectorLayer.prototype.getUpdateWhileAnimating = function getUpdateWhileAnimating () {
	    return this.updateWhileAnimating_;
	  };
	
	  /**
	  * @return {boolean} Whether the rendered layer should be updated while
	  *     interacting.
	  */
	  VectorLayer.prototype.getUpdateWhileInteracting = function getUpdateWhileInteracting () {
	    return this.updateWhileInteracting_;
	  };
	
	  /**
	  * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
	  *     Render order.
	  */
	  VectorLayer.prototype.setRenderOrder = function setRenderOrder (renderOrder) {
	    this.set(Property$3.RENDER_ORDER, renderOrder);
	  };
	
	  /**
	  * Set the style for features.  This can be a single style object, an array
	  * of styles, or a function that takes a feature and resolution and returns
	  * an array of styles. If it is `undefined` the default style is used. If
	  * it is `null` the layer has no style (a `null` style), so only features
	  * that have their own styles will be rendered in the layer. See
	  * {@link module:ol/style} for information on the default style.
	  * @param {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null|undefined} style Layer style.
	  * @api
	  */
	  VectorLayer.prototype.setStyle = function setStyle (style) {
	    this.style_ = style !== undefined ? style : createDefaultStyle;
	    this.styleFunction_ = style === null ?
	      undefined : toFunction(this.style_);
	    this.changed();
	  };
	
	  /**
	  * @return {import("./VectorRenderType.js").default|string} The render mode.
	  */
	  VectorLayer.prototype.getRenderMode = function getRenderMode () {
	    return this.renderMode_;
	  };
	
	  return VectorLayer;
	}(Layer));
	
	
	/**
	 * Return the associated {@link module:ol/source/Vector vectorsource} of the layer.
	 * @function
	 * @return {import("../source/Vector.js").default} Source.
	 * @api
	 */
	VectorLayer.prototype.getSource;
	
	/**
	 * @module ol/format/FormatType
	 */
	
	/**
	 * @enum {string}
	 */
	var FormatType = {
	  ARRAY_BUFFER: 'arraybuffer',
	  JSON: 'json',
	  TEXT: 'text',
	  XML: 'xml'
	};
	
	/**
	 * @module ol/featureloader
	 */
	
	/**
	 * {@link module:ol/source/Vector} sources use a function of this type to
	 * load features.
	 *
	 * This function takes an {@link module:ol/extent~Extent} representing the area to be loaded,
	 * a `{number}` representing the resolution (map units per pixel) and an
	 * {@link module:ol/proj/Projection} for the projection  as
	 * arguments. `this` within the function is bound to the
	 * {@link module:ol/source/Vector} it's called from.
	 *
	 * The function is responsible for loading the features and adding them to the
	 * source.
	 * @typedef {function(this:(import("./source/Vector").default|import("./VectorTile.js").default), import("./extent.js").Extent, number,
	 *                    import("./proj/Projection.js").default)} FeatureLoader
	 * @api
	 */
	
	
	/**
	 * {@link module:ol/source/Vector} sources use a function of this type to
	 * get the url to load features from.
	 *
	 * This function takes an {@link module:ol/extent~Extent} representing the area
	 * to be loaded, a `{number}` representing the resolution (map units per pixel)
	 * and an {@link module:ol/proj/Projection} for the projection  as
	 * arguments and returns a `{string}` representing the URL.
	 * @typedef {function(import("./extent.js").Extent, number, import("./proj/Projection.js").default): string} FeatureUrlFunction
	 * @api
	 */
	
	
	/**
	 * @param {string|FeatureUrlFunction} url Feature URL service.
	 * @param {import("./format/Feature.js").default} format Feature format.
	 * @param {function(this:import("./VectorTile.js").default, Array<import("./Feature.js").default>, import("./proj/Projection.js").default, import("./extent.js").Extent)|function(this:import("./source/Vector").default, Array<import("./Feature.js").default>)} success
	 *     Function called with the loaded features and optionally with the data
	 *     projection. Called with the vector tile or source as `this`.
	 * @param {function(this:import("./VectorTile.js").default)|function(this:import("./source/Vector").default)} failure
	 *     Function called when loading failed. Called with the vector tile or
	 *     source as `this`.
	 * @return {FeatureLoader} The feature loader.
	 */
	function loadFeaturesXhr(url, format, success, failure) {
	  return (
	    /**
	     * @param {import("./extent.js").Extent} extent Extent.
	     * @param {number} resolution Resolution.
	     * @param {import("./proj/Projection.js").default} projection Projection.
	     * @this {import("./source/Vector").default|import("./VectorTile.js").default}
	     */
	    function(extent, resolution, projection) {
	      var xhr = new XMLHttpRequest();
	      xhr.open('GET',
	        typeof url === 'function' ? url(extent, resolution, projection) : url,
	        true);
	      if (format.getType() == FormatType.ARRAY_BUFFER) {
	        xhr.responseType = 'arraybuffer';
	      }
	      /**
	       * @param {Event} event Event.
	       * @private
	       */
	      xhr.onload = function(event) {
	        // status will be 0 for file:// urls
	        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
	          var type = format.getType();
	          /** @type {Document|Node|Object|string|undefined} */
	          var source;
	          if (type == FormatType.JSON || type == FormatType.TEXT) {
	            source = xhr.responseText;
	          } else if (type == FormatType.XML) {
	            source = xhr.responseXML;
	            if (!source) {
	              source = new DOMParser().parseFromString(xhr.responseText, 'application/xml');
	            }
	          } else if (type == FormatType.ARRAY_BUFFER) {
	            source = /** @type {ArrayBuffer} */ (xhr.response);
	          }
	          if (source) {
	            success.call(this, format.readFeatures(source,
	              {featureProjection: projection}),
	            format.readProjection(source), format.getLastExtent());
	          } else {
	            failure.call(this);
	          }
	        } else {
	          failure.call(this);
	        }
	      }.bind(this);
	      /**
	       * @private
	       */
	      xhr.onerror = function() {
	        failure.call(this);
	      }.bind(this);
	      xhr.send();
	    }
	  );
	}
	
	
	/**
	 * Create an XHR feature loader for a `url` and `format`. The feature loader
	 * loads features (with XHR), parses the features, and adds them to the
	 * vector source.
	 * @param {string|FeatureUrlFunction} url Feature URL service.
	 * @param {import("./format/Feature.js").default} format Feature format.
	 * @return {FeatureLoader} The feature loader.
	 * @api
	 */
	function xhr(url, format) {
	  return loadFeaturesXhr(url, format,
	    /**
	     * @param {Array<import("./Feature.js").default>} features The loaded features.
	     * @param {import("./proj/Projection.js").default} dataProjection Data
	     * projection.
	     * @this {import("./source/Vector").default|import("./VectorTile.js").default}
	     */
	    function(features, dataProjection) {
	      var sourceOrTile = /** @type {?} */ (this);
	      if (typeof sourceOrTile.addFeatures === 'function') {
	        /** @type {import("./source/Vector").default} */ (sourceOrTile).addFeatures(features);
	      }
	    }, /* FIXME handle error */ VOID);
	}
	
	/**
	 * @module ol/loadingstrategy
	 */
	
	
	/**
	 * Strategy function for loading all features with a single request.
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number} resolution Resolution.
	 * @return {Array<import("./extent.js").Extent>} Extents.
	 * @api
	 */
	function all(extent, resolution) {
	  return [[-Infinity, -Infinity, Infinity, Infinity]];
	}
	
	
	/**
	 * Strategy function for loading features based on the view's extent and
	 * resolution.
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number} resolution Resolution.
	 * @return {Array<import("./extent.js").Extent>} Extents.
	 * @api
	 */
	function bbox(extent, resolution) {
	  return [extent];
	}
	
	
	/**
	 * Creates a strategy function for loading features based on a tile grid.
	 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
	 * @return {function(import("./extent.js").Extent, number): Array<import("./extent.js").Extent>} Loading strategy.
	 * @api
	 */
	function tile(tileGrid) {
	  return (
	    /**
	     * @param {import("./extent.js").Extent} extent Extent.
	     * @param {number} resolution Resolution.
	     * @return {Array<import("./extent.js").Extent>} Extents.
	     */
	    function(extent, resolution) {
	      var z = tileGrid.getZForResolution(resolution);
	      var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
	      /** @type {Array<import("./extent.js").Extent>} */
	      var extents = [];
	      /** @type {import("./tilecoord.js").TileCoord} */
	      var tileCoord = [z, 0, 0];
	      for (tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1]) {
	        for (tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2]) {
	          extents.push(tileGrid.getTileCoordExtent(tileCoord));
	        }
	      }
	      return extents;
	    }
	  );
	}
	
	/**
	 * @module ol/source/Source
	 */
	
	
	/**
	 * A function that returns a string or an array of strings representing source
	 * attributions.
	 *
	 * @typedef {function(import("../PluggableMap.js").FrameState): (string|Array<string>)} Attribution
	 */
	
	
	/**
	 * A type that can be used to provide attribution information for data sources.
	 *
	 * It represents either
	 * * a simple string (e.g. `'© Acme Inc.'`)
	 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
	 * * a function that returns a string or array of strings (`{@link module:ol/source/Source~Attribution}`)
	 *
	 * @typedef {string|Array<string>|Attribution} AttributionLike
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {AttributionLike} [attributions]
	 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
	 * @property {import("../proj.js").ProjectionLike} projection
	 * @property {SourceState} [state='ready']
	 * @property {boolean} [wrapX=false]
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for {@link module:ol/layer/Layer~Layer} sources.
	 *
	 * A generic `change` event is triggered when the state of the source changes.
	 * @abstract
	 * @api
	 */
	var Source = /*@__PURE__*/(function (BaseObject$$1) {
	  function Source(options) {
	
	    BaseObject$$1.call(this);
	
	    /**
	     * @private
	     * @type {import("../proj/Projection.js").default}
	     */
	    this.projection_ = get$2(options.projection);
	
	    /**
	     * @private
	     * @type {?Attribution}
	     */
	    this.attributions_ = adaptAttributions(options.attributions);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.attributionsCollapsible_ = options.attributionsCollapsible !== undefined ?
	      options.attributionsCollapsible : true;
	
	    /**
	     * This source is currently loading data. Sources that defer loading to the
	     * map's tile queue never set this to `true`.
	     * @type {boolean}
	     */
	    this.loading = false;
	
	    /**
	     * @private
	     * @type {SourceState}
	     */
	    this.state_ = options.state !== undefined ?
	      options.state : SourceState.READY;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
	
	  }
	
	  if ( BaseObject$$1 ) { Source.__proto__ = BaseObject$$1; }
	  Source.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Source.prototype.constructor = Source;
	
	  /**
	   * Get the attribution function for the source.
	   * @return {?Attribution} Attribution function.
	   */
	  Source.prototype.getAttributions = function getAttributions () {
	    return this.attributions_;
	  };
	
	  /**
	   * @return {boolean} Aattributions are collapsible.
	   */
	  Source.prototype.getAttributionsCollapsible = function getAttributionsCollapsible () {
	    return this.attributionsCollapsible_;
	  };
	
	  /**
	   * Get the projection of the source.
	   * @return {import("../proj/Projection.js").default} Projection.
	   * @api
	   */
	  Source.prototype.getProjection = function getProjection () {
	    return this.projection_;
	  };
	
	  /**
	   * @abstract
	   * @return {Array<number>|undefined} Resolutions.
	   */
	  Source.prototype.getResolutions = function getResolutions () {
	    return abstract();
	  };
	
	  /**
	   * Get the state of the source, see {@link module:ol/source/State~State} for possible states.
	   * @return {SourceState} State.
	   * @api
	   */
	  Source.prototype.getState = function getState () {
	    return this.state_;
	  };
	
	  /**
	   * @return {boolean|undefined} Wrap X.
	   */
	  Source.prototype.getWrapX = function getWrapX () {
	    return this.wrapX_;
	  };
	
	  /**
	   * Refreshes the source and finally dispatches a 'change' event.
	   * @api
	   */
	  Source.prototype.refresh = function refresh () {
	    this.changed();
	  };
	
	  /**
	   * Set the attributions of the source.
	   * @param {AttributionLike|undefined} attributions Attributions.
	   *     Can be passed as `string`, `Array<string>`, `{@link module:ol/source/Source~Attribution}`,
	   *     or `undefined`.
	   * @api
	   */
	  Source.prototype.setAttributions = function setAttributions (attributions) {
	    this.attributions_ = adaptAttributions(attributions);
	    this.changed();
	  };
	
	  /**
	   * Set the state of the source.
	   * @param {SourceState} state State.
	   * @protected
	   */
	  Source.prototype.setState = function setState (state) {
	    this.state_ = state;
	    this.changed();
	  };
	
	  return Source;
	}(BaseObject));
	
	
	/**
	 * Turns the attributions option into an attributions function.
	 * @param {AttributionLike|undefined} attributionLike The attribution option.
	 * @return {?Attribution} An attribution function (or null).
	 */
	function adaptAttributions(attributionLike) {
	  if (!attributionLike) {
	    return null;
	  }
	  if (Array.isArray(attributionLike)) {
	    return function(frameState) {
	      return attributionLike;
	    };
	  }
	
	  if (typeof attributionLike === 'function') {
	    return attributionLike;
	  }
	
	  return function(frameState) {
	    return [attributionLike];
	  };
	}
	
	/**
	 * @module ol/source/VectorEventType
	 */
	
	/**
	 * @enum {string}
	 */
	var VectorEventType = {
	  /**
	   * Triggered when a feature is added to the source.
	   * @event ol/source/Vector.VectorSourceEvent#addfeature
	   * @api
	   */
	  ADDFEATURE: 'addfeature',
	
	  /**
	   * Triggered when a feature is updated.
	   * @event ol/source/Vector.VectorSourceEvent#changefeature
	   * @api
	   */
	  CHANGEFEATURE: 'changefeature',
	
	  /**
	   * Triggered when the clear method is called on the source.
	   * @event ol/source/Vector.VectorSourceEvent#clear
	   * @api
	   */
	  CLEAR: 'clear',
	
	  /**
	   * Triggered when a feature is removed from the source.
	   * See {@link module:ol/source/Vector#clear source.clear()} for exceptions.
	   * @event ol/source/Vector.VectorSourceEvent#removefeature
	   * @api
	   */
	  REMOVEFEATURE: 'removefeature'
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var quickselect = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		module.exports = factory();
	}(commonjsGlobal, (function () {
	function quickselect(arr, k, left, right, compare) {
	    quickselectStep(arr, k, left || 0, right || (arr.length - 1), compare || defaultCompare);
	}
	
	function quickselectStep(arr, k, left, right, compare) {
	
	    while (right > left) {
	        if (right - left > 600) {
	            var n = right - left + 1;
	            var m = k - left + 1;
	            var z = Math.log(n);
	            var s = 0.5 * Math.exp(2 * z / 3);
	            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	            quickselectStep(arr, k, newLeft, newRight, compare);
	        }
	
	        var t = arr[k];
	        var i = left;
	        var j = right;
	
	        swap(arr, left, k);
	        if (compare(arr[right], t) > 0) { swap(arr, left, right); }
	
	        while (i < j) {
	            swap(arr, i, j);
	            i++;
	            j--;
	            while (compare(arr[i], t) < 0) { i++; }
	            while (compare(arr[j], t) > 0) { j--; }
	        }
	
	        if (compare(arr[left], t) === 0) { swap(arr, left, j); }
	        else {
	            j++;
	            swap(arr, j, right);
	        }
	
	        if (j <= k) { left = j + 1; }
	        if (k <= j) { right = j - 1; }
	    }
	}
	
	function swap(arr, i, j) {
	    var tmp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = tmp;
	}
	
	function defaultCompare(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	}
	
	return quickselect;
	
	})));
	});
	
	var rbush_1 = rbush;
	var default_1 = rbush;
	
	
	
	function rbush(maxEntries, format) {
	    if (!(this instanceof rbush)) { return new rbush(maxEntries, format); }
	
	    // max entries in a node is 9 by default; min node fill is 40% for best performance
	    this._maxEntries = Math.max(4, maxEntries || 9);
	    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
	
	    if (format) {
	        this._initFormat(format);
	    }
	
	    this.clear();
	}
	
	rbush.prototype = {
	
	    all: function () {
	        return this._all(this.data, []);
	    },
	
	    search: function (bbox) {
	
	        var node = this.data,
	            result = [],
	            toBBox = this.toBBox;
	
	        if (!intersects$1(bbox, node)) { return result; }
	
	        var nodesToSearch = [],
	            i, len, child, childBBox;
	
	        while (node) {
	            for (i = 0, len = node.children.length; i < len; i++) {
	
	                child = node.children[i];
	                childBBox = node.leaf ? toBBox(child) : child;
	
	                if (intersects$1(bbox, childBBox)) {
	                    if (node.leaf) { result.push(child); }
	                    else if (contains(bbox, childBBox)) { this._all(child, result); }
	                    else { nodesToSearch.push(child); }
	                }
	            }
	            node = nodesToSearch.pop();
	        }
	
	        return result;
	    },
	
	    collides: function (bbox) {
	
	        var node = this.data,
	            toBBox = this.toBBox;
	
	        if (!intersects$1(bbox, node)) { return false; }
	
	        var nodesToSearch = [],
	            i, len, child, childBBox;
	
	        while (node) {
	            for (i = 0, len = node.children.length; i < len; i++) {
	
	                child = node.children[i];
	                childBBox = node.leaf ? toBBox(child) : child;
	
	                if (intersects$1(bbox, childBBox)) {
	                    if (node.leaf || contains(bbox, childBBox)) { return true; }
	                    nodesToSearch.push(child);
	                }
	            }
	            node = nodesToSearch.pop();
	        }
	
	        return false;
	    },
	
	    load: function (data) {
	        if (!(data && data.length)) { return this; }
	
	        if (data.length < this._minEntries) {
	            for (var i = 0, len = data.length; i < len; i++) {
	                this.insert(data[i]);
	            }
	            return this;
	        }
	
	        // recursively build the tree with the given data from scratch using OMT algorithm
	        var node = this._build(data.slice(), 0, data.length - 1, 0);
	
	        if (!this.data.children.length) {
	            // save as is if tree is empty
	            this.data = node;
	
	        } else if (this.data.height === node.height) {
	            // split root if trees have the same height
	            this._splitRoot(this.data, node);
	
	        } else {
	            if (this.data.height < node.height) {
	                // swap trees if inserted one is bigger
	                var tmpNode = this.data;
	                this.data = node;
	                node = tmpNode;
	            }
	
	            // insert the small tree into the large tree at appropriate level
	            this._insert(node, this.data.height - node.height - 1, true);
	        }
	
	        return this;
	    },
	
	    insert: function (item) {
	        if (item) { this._insert(item, this.data.height - 1); }
	        return this;
	    },
	
	    clear: function () {
	        this.data = createNode([]);
	        return this;
	    },
	
	    remove: function (item, equalsFn) {
	        if (!item) { return this; }
	
	        var node = this.data,
	            bbox = this.toBBox(item),
	            path = [],
	            indexes = [],
	            i, parent, index, goingUp;
	
	        // depth-first iterative tree traversal
	        while (node || path.length) {
	
	            if (!node) { // go up
	                node = path.pop();
	                parent = path[path.length - 1];
	                i = indexes.pop();
	                goingUp = true;
	            }
	
	            if (node.leaf) { // check current node
	                index = findItem(item, node.children, equalsFn);
	
	                if (index !== -1) {
	                    // item found, remove the item and condense tree upwards
	                    node.children.splice(index, 1);
	                    path.push(node);
	                    this._condense(path);
	                    return this;
	                }
	            }
	
	            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down
	                path.push(node);
	                indexes.push(i);
	                i = 0;
	                parent = node;
	                node = node.children[0];
	
	            } else if (parent) { // go right
	                i++;
	                node = parent.children[i];
	                goingUp = false;
	
	            } else { node = null; } // nothing found
	        }
	
	        return this;
	    },
	
	    toBBox: function (item) { return item; },
	
	    compareMinX: compareNodeMinX,
	    compareMinY: compareNodeMinY,
	
	    toJSON: function () { return this.data; },
	
	    fromJSON: function (data) {
	        this.data = data;
	        return this;
	    },
	
	    _all: function (node, result) {
	        var nodesToSearch = [];
	        while (node) {
	            if (node.leaf) { result.push.apply(result, node.children); }
	            else { nodesToSearch.push.apply(nodesToSearch, node.children); }
	
	            node = nodesToSearch.pop();
	        }
	        return result;
	    },
	
	    _build: function (items, left, right, height) {
	
	        var N = right - left + 1,
	            M = this._maxEntries,
	            node;
	
	        if (N <= M) {
	            // reached leaf level; return leaf
	            node = createNode(items.slice(left, right + 1));
	            calcBBox(node, this.toBBox);
	            return node;
	        }
	
	        if (!height) {
	            // target height of the bulk-loaded tree
	            height = Math.ceil(Math.log(N) / Math.log(M));
	
	            // target number of root entries to maximize storage utilization
	            M = Math.ceil(N / Math.pow(M, height - 1));
	        }
	
	        node = createNode([]);
	        node.leaf = false;
	        node.height = height;
	
	        // split the items into M mostly square tiles
	
	        var N2 = Math.ceil(N / M),
	            N1 = N2 * Math.ceil(Math.sqrt(M)),
	            i, j, right2, right3;
	
	        multiSelect(items, left, right, N1, this.compareMinX);
	
	        for (i = left; i <= right; i += N1) {
	
	            right2 = Math.min(i + N1 - 1, right);
	
	            multiSelect(items, i, right2, N2, this.compareMinY);
	
	            for (j = i; j <= right2; j += N2) {
	
	                right3 = Math.min(j + N2 - 1, right2);
	
	                // pack each entry recursively
	                node.children.push(this._build(items, j, right3, height - 1));
	            }
	        }
	
	        calcBBox(node, this.toBBox);
	
	        return node;
	    },
	
	    _chooseSubtree: function (bbox, node, level, path) {
	
	        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
	
	        while (true) {
	            path.push(node);
	
	            if (node.leaf || path.length - 1 === level) { break; }
	
	            minArea = minEnlargement = Infinity;
	
	            for (i = 0, len = node.children.length; i < len; i++) {
	                child = node.children[i];
	                area = bboxArea(child);
	                enlargement = enlargedArea(bbox, child) - area;
	
	                // choose entry with the least area enlargement
	                if (enlargement < minEnlargement) {
	                    minEnlargement = enlargement;
	                    minArea = area < minArea ? area : minArea;
	                    targetNode = child;
	
	                } else if (enlargement === minEnlargement) {
	                    // otherwise choose one with the smallest area
	                    if (area < minArea) {
	                        minArea = area;
	                        targetNode = child;
	                    }
	                }
	            }
	
	            node = targetNode || node.children[0];
	        }
	
	        return node;
	    },
	
	    _insert: function (item, level, isNode) {
	
	        var toBBox = this.toBBox,
	            bbox = isNode ? item : toBBox(item),
	            insertPath = [];
	
	        // find the best node for accommodating the item, saving all nodes along the path too
	        var node = this._chooseSubtree(bbox, this.data, level, insertPath);
	
	        // put the item into the node
	        node.children.push(item);
	        extend$2(node, bbox);
	
	        // split on node overflow; propagate upwards if necessary
	        while (level >= 0) {
	            if (insertPath[level].children.length > this._maxEntries) {
	                this._split(insertPath, level);
	                level--;
	            } else { break; }
	        }
	
	        // adjust bboxes along the insertion path
	        this._adjustParentBBoxes(bbox, insertPath, level);
	    },
	
	    // split overflowed node into two
	    _split: function (insertPath, level) {
	
	        var node = insertPath[level],
	            M = node.children.length,
	            m = this._minEntries;
	
	        this._chooseSplitAxis(node, m, M);
	
	        var splitIndex = this._chooseSplitIndex(node, m, M);
	
	        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
	        newNode.height = node.height;
	        newNode.leaf = node.leaf;
	
	        calcBBox(node, this.toBBox);
	        calcBBox(newNode, this.toBBox);
	
	        if (level) { insertPath[level - 1].children.push(newNode); }
	        else { this._splitRoot(node, newNode); }
	    },
	
	    _splitRoot: function (node, newNode) {
	        // split root node
	        this.data = createNode([node, newNode]);
	        this.data.height = node.height + 1;
	        this.data.leaf = false;
	        calcBBox(this.data, this.toBBox);
	    },
	
	    _chooseSplitIndex: function (node, m, M) {
	
	        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
	
	        minOverlap = minArea = Infinity;
	
	        for (i = m; i <= M - m; i++) {
	            bbox1 = distBBox(node, 0, i, this.toBBox);
	            bbox2 = distBBox(node, i, M, this.toBBox);
	
	            overlap = intersectionArea(bbox1, bbox2);
	            area = bboxArea(bbox1) + bboxArea(bbox2);
	
	            // choose distribution with minimum overlap
	            if (overlap < minOverlap) {
	                minOverlap = overlap;
	                index = i;
	
	                minArea = area < minArea ? area : minArea;
	
	            } else if (overlap === minOverlap) {
	                // otherwise choose distribution with minimum area
	                if (area < minArea) {
	                    minArea = area;
	                    index = i;
	                }
	            }
	        }
	
	        return index;
	    },
	
	    // sorts node children by the best axis for split
	    _chooseSplitAxis: function (node, m, M) {
	
	        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,
	            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,
	            xMargin = this._allDistMargin(node, m, M, compareMinX),
	            yMargin = this._allDistMargin(node, m, M, compareMinY);
	
	        // if total distributions margin value is minimal for x, sort by minX,
	        // otherwise it's already sorted by minY
	        if (xMargin < yMargin) { node.children.sort(compareMinX); }
	    },
	
	    // total margin of all possible split distributions where each node is at least m full
	    _allDistMargin: function (node, m, M, compare) {
	
	        node.children.sort(compare);
	
	        var toBBox = this.toBBox,
	            leftBBox = distBBox(node, 0, m, toBBox),
	            rightBBox = distBBox(node, M - m, M, toBBox),
	            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),
	            i, child;
	
	        for (i = m; i < M - m; i++) {
	            child = node.children[i];
	            extend$2(leftBBox, node.leaf ? toBBox(child) : child);
	            margin += bboxMargin(leftBBox);
	        }
	
	        for (i = M - m - 1; i >= m; i--) {
	            child = node.children[i];
	            extend$2(rightBBox, node.leaf ? toBBox(child) : child);
	            margin += bboxMargin(rightBBox);
	        }
	
	        return margin;
	    },
	
	    _adjustParentBBoxes: function (bbox, path, level) {
	        // adjust bboxes along the given tree path
	        for (var i = level; i >= 0; i--) {
	            extend$2(path[i], bbox);
	        }
	    },
	
	    _condense: function (path) {
	        // go through the path, removing empty nodes and updating bboxes
	        for (var i = path.length - 1, siblings; i >= 0; i--) {
	            if (path[i].children.length === 0) {
	                if (i > 0) {
	                    siblings = path[i - 1].children;
	                    siblings.splice(siblings.indexOf(path[i]), 1);
	
	                } else { this.clear(); }
	
	            } else { calcBBox(path[i], this.toBBox); }
	        }
	    },
	
	    _initFormat: function (format) {
	        // data format (minX, minY, maxX, maxY accessors)
	
	        // uses eval-type function compilation instead of just accepting a toBBox function
	        // because the algorithms are very sensitive to sorting functions performance,
	        // so they should be dead simple and without inner calls
	
	        var compareArr = ['return a', ' - b', ';'];
	
	        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));
	        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));
	
	        this.toBBox = new Function('a',
	            'return {minX: a' + format[0] +
	            ', minY: a' + format[1] +
	            ', maxX: a' + format[2] +
	            ', maxY: a' + format[3] + '};');
	    }
	};
	
	function findItem(item, items, equalsFn) {
	    if (!equalsFn) { return items.indexOf(item); }
	
	    for (var i = 0; i < items.length; i++) {
	        if (equalsFn(item, items[i])) { return i; }
	    }
	    return -1;
	}
	
	// calculate node's bbox from bboxes of its children
	function calcBBox(node, toBBox) {
	    distBBox(node, 0, node.children.length, toBBox, node);
	}
	
	// min bounding rectangle of node children from k to p-1
	function distBBox(node, k, p, toBBox, destNode) {
	    if (!destNode) { destNode = createNode(null); }
	    destNode.minX = Infinity;
	    destNode.minY = Infinity;
	    destNode.maxX = -Infinity;
	    destNode.maxY = -Infinity;
	
	    for (var i = k, child; i < p; i++) {
	        child = node.children[i];
	        extend$2(destNode, node.leaf ? toBBox(child) : child);
	    }
	
	    return destNode;
	}
	
	function extend$2(a, b) {
	    a.minX = Math.min(a.minX, b.minX);
	    a.minY = Math.min(a.minY, b.minY);
	    a.maxX = Math.max(a.maxX, b.maxX);
	    a.maxY = Math.max(a.maxY, b.maxY);
	    return a;
	}
	
	function compareNodeMinX(a, b) { return a.minX - b.minX; }
	function compareNodeMinY(a, b) { return a.minY - b.minY; }
	
	function bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }
	function bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }
	
	function enlargedArea(a, b) {
	    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *
	           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
	}
	
	function intersectionArea(a, b) {
	    var minX = Math.max(a.minX, b.minX),
	        minY = Math.max(a.minY, b.minY),
	        maxX = Math.min(a.maxX, b.maxX),
	        maxY = Math.min(a.maxY, b.maxY);
	
	    return Math.max(0, maxX - minX) *
	           Math.max(0, maxY - minY);
	}
	
	function contains(a, b) {
	    return a.minX <= b.minX &&
	           a.minY <= b.minY &&
	           b.maxX <= a.maxX &&
	           b.maxY <= a.maxY;
	}
	
	function intersects$1(a, b) {
	    return b.minX <= a.maxX &&
	           b.minY <= a.maxY &&
	           b.maxX >= a.minX &&
	           b.maxY >= a.minY;
	}
	
	function createNode(children) {
	    return {
	        children: children,
	        height: 1,
	        leaf: true,
	        minX: Infinity,
	        minY: Infinity,
	        maxX: -Infinity,
	        maxY: -Infinity
	    };
	}
	
	// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
	// combines selection algorithm with binary divide & conquer approach
	
	function multiSelect(arr, left, right, n, compare) {
	    var stack = [left, right],
	        mid;
	
	    while (stack.length) {
	        right = stack.pop();
	        left = stack.pop();
	
	        if (right - left <= n) { continue; }
	
	        mid = left + Math.ceil((right - left) / n / 2) * n;
	        quickselect(arr, mid, left, right, compare);
	
	        stack.push(left, mid, mid, right);
	    }
	}
	rbush_1.default = default_1;
	
	/**
	 * @module ol/structs/RBush
	 */
	
	/**
	 * @typedef {Object} Entry
	 * @property {number} minX
	 * @property {number} minY
	 * @property {number} maxX
	 * @property {number} maxY
	 * @property {Object} [value]
	 */
	
	/**
	 * @classdesc
	 * Wrapper around the RBush by Vladimir Agafonkin.
	 * See https://github.com/mourner/rbush.
	 *
	 * @template T
	 * @api
	 */
	var RBush = function RBush(opt_maxEntries) {
	
	  /**
	   * @private
	   */
	  this.rbush_ = rbush_1(opt_maxEntries, undefined);
	
	  /**
	   * A mapping between the objects added to this rbush wrapper
	   * and the objects that are actually added to the internal rbush.
	   * @private
	   * @type {Object<string, Entry>}
	   */
	  this.items_ = {};
	
	};
	
	/**
	 * Insert a value into the RBush.
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @param {T} value Value.
	 */
	RBush.prototype.insert = function insert (extent, value) {
	  /** @type {Entry} */
	  var item = {
	    minX: extent[0],
	    minY: extent[1],
	    maxX: extent[2],
	    maxY: extent[3],
	    value: value
	  };
	
	  this.rbush_.insert(item);
	  this.items_[getUid(value)] = item;
	};
	
	
	/**
	 * Bulk-insert values into the RBush.
	 * @param {Array<import("../extent.js").Extent>} extents Extents.
	 * @param {Array<T>} values Values.
	 */
	RBush.prototype.load = function load (extents, values) {
	  var items = new Array(values.length);
	  for (var i = 0, l = values.length; i < l; i++) {
	    var extent = extents[i];
	    var value = values[i];
	
	    /** @type {Entry} */
	    var item = {
	      minX: extent[0],
	      minY: extent[1],
	      maxX: extent[2],
	      maxY: extent[3],
	      value: value
	    };
	    items[i] = item;
	    this.items_[getUid(value)] = item;
	  }
	  this.rbush_.load(items);
	};
	
	
	/**
	 * Remove a value from the RBush.
	 * @param {T} value Value.
	 * @return {boolean} Removed.
	 */
	RBush.prototype.remove = function remove (value) {
	  var uid = getUid(value);
	
	  // get the object in which the value was wrapped when adding to the
	  // internal rbush. then use that object to do the removal.
	  var item = this.items_[uid];
	  delete this.items_[uid];
	  return this.rbush_.remove(item) !== null;
	};
	
	
	/**
	 * Update the extent of a value in the RBush.
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @param {T} value Value.
	 */
	RBush.prototype.update = function update (extent, value) {
	  var item = this.items_[getUid(value)];
	  var bbox = [item.minX, item.minY, item.maxX, item.maxY];
	  if (!equals$1(bbox, extent)) {
	    this.remove(value);
	    this.insert(extent, value);
	  }
	};
	
	
	/**
	 * Return all values in the RBush.
	 * @return {Array<T>} All.
	 */
	RBush.prototype.getAll = function getAll () {
	  var items = this.rbush_.all();
	  return items.map(function(item) {
	    return item.value;
	  });
	};
	
	
	/**
	 * Return all values in the given extent.
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @return {Array<T>} All in extent.
	 */
	RBush.prototype.getInExtent = function getInExtent (extent) {
	  /** @type {Entry} */
	  var bbox = {
	    minX: extent[0],
	    minY: extent[1],
	    maxX: extent[2],
	    maxY: extent[3]
	  };
	  var items = this.rbush_.search(bbox);
	  return items.map(function(item) {
	    return item.value;
	  });
	};
	
	
	/**
	 * Calls a callback function with each value in the tree.
	 * If the callback returns a truthy value, this value is returned without
	 * checking the rest of the tree.
	 * @param {function(this: S, T): *} callback Callback.
	 * @param {S=} opt_this The object to use as `this` in `callback`.
	 * @return {*} Callback return value.
	 * @template S
	 */
	RBush.prototype.forEach = function forEach (callback, opt_this) {
	  return this.forEach_(this.getAll(), callback, opt_this);
	};
	
	
	/**
	 * Calls a callback function with each value in the provided extent.
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @param {function(this: S, T): *} callback Callback.
	 * @param {S=} opt_this The object to use as `this` in `callback`.
	 * @return {*} Callback return value.
	 * @template S
	 */
	RBush.prototype.forEachInExtent = function forEachInExtent (extent, callback, opt_this) {
	  return this.forEach_(this.getInExtent(extent), callback, opt_this);
	};
	
	
	/**
	 * @param {Array<T>} values Values.
	 * @param {function(this: S, T): *} callback Callback.
	 * @param {S=} opt_this The object to use as `this` in `callback`.
	 * @private
	 * @return {*} Callback return value.
	 * @template S
	 */
	RBush.prototype.forEach_ = function forEach_ (values, callback, opt_this) {
	  var result;
	  for (var i = 0, l = values.length; i < l; i++) {
	    result = callback.call(opt_this, values[i]);
	    if (result) {
	      return result;
	    }
	  }
	  return result;
	};
	
	
	/**
	 * @return {boolean} Is empty.
	 */
	RBush.prototype.isEmpty = function isEmpty$1$$1 () {
	  return isEmpty(this.items_);
	};
	
	
	/**
	 * Remove all values from the RBush.
	 */
	RBush.prototype.clear = function clear$$1 () {
	  this.rbush_.clear();
	  this.items_ = {};
	};
	
	
	/**
	 * @param {import("../extent.js").Extent=} opt_extent Extent.
	 * @return {import("../extent.js").Extent} Extent.
	 */
	RBush.prototype.getExtent = function getExtent (opt_extent) {
	  var data = this.rbush_.toJSON();
	  return createOrUpdate(data.minX, data.minY, data.maxX, data.maxY, opt_extent);
	};
	
	
	/**
	 * @param {RBush} rbush R-Tree.
	 */
	RBush.prototype.concat = function concat (rbush) {
	  this.rbush_.load(rbush.rbush_.all());
	  for (var i in rbush.items_) {
	    this.items_[i] = rbush.items_[i];
	  }
	};
	
	/**
	 * @module ol/source/Vector
	 */
	
	/**
	 * A function that takes an {@link module:ol/extent~Extent} and a resolution as arguments, and
	 * returns an array of {@link module:ol/extent~Extent} with the extents to load. Usually this
	 * is one of the standard {@link module:ol/loadingstrategy} strategies.
	 *
	 * @typedef {function(import("../extent.js").Extent, number): Array<import("../extent.js").Extent>} LoadingStrategy
	 * @api
	 */
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/source/Vector} instances are instances of this
	 * type.
	 */
	var VectorSourceEvent = /*@__PURE__*/(function (Event$$1) {
	  function VectorSourceEvent(type, opt_feature) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The feature being added or removed.
	     * @type {import("../Feature.js").default|undefined}
	     * @api
	     */
	    this.feature = opt_feature;
	
	  }
	
	  if ( Event$$1 ) { VectorSourceEvent.__proto__ = Event$$1; }
	  VectorSourceEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  VectorSourceEvent.prototype.constructor = VectorSourceEvent;
	
	  return VectorSourceEvent;
	}(Event));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {Array<import("../Feature.js").default>|Collection<import("../Feature.js").default>} [features]
	 * Features. If provided as {@link module:ol/Collection}, the features in the source
	 * and the collection will stay in sync.
	 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
	 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
	 * @property {import("../featureloader.js").FeatureLoader} [loader]
	 * The loader function used to load features, from a remote source for example.
	 * If this is not set and `url` is set, the source will create and use an XHR
	 * feature loader.
	 *
	 * Example:
	 *
	 * ```js
	 * import {Vector} from 'ol/source';
	 * import {GeoJSON} from 'ol/format';
	 * import {bbox} from 'ol/loadingstrategy';
	 *
	 * var vectorSource = new Vector({
	 *   format: new GeoJSON(),
	 *   loader: function(extent, resolution, projection) {
	 *      var proj = projection.getCode();
	 *      var url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
	 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
	 *          'outputFormat=application/json&srsname=' + proj + '&' +
	 *          'bbox=' + extent.join(',') + ',' + proj;
	 *      var xhr = new XMLHttpRequest();
	 *      xhr.open('GET', url);
	 *      var onError = function() {
	 *        vectorSource.removeLoadedExtent(extent);
	 *      }
	 *      xhr.onerror = onError;
	 *      xhr.onload = function() {
	 *        if (xhr.status == 200) {
	 *          vectorSource.addFeatures(
	 *              vectorSource.getFormat().readFeatures(xhr.responseText));
	 *        } else {
	 *          onError();
	 *        }
	 *      }
	 *      xhr.send();
	 *    },
	 *    strategy: bbox
	 *  });
	 * ```
	 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
	 * Setting this to `false` (e.g. for sources with polygons that represent administrative
	 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
	 * stroke operations.
	 * @property {LoadingStrategy} [strategy] The loading strategy to use.
	 * By default an {@link module:ol/loadingstrategy~all}
	 * strategy is used, a one-off strategy which loads all features at once.
	 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
	 * Setting this option instructs the source to load features using an XHR loader
	 * (see {@link module:ol/featureloader~xhr}). Use a `string` and an
	 * {@link module:ol/loadingstrategy~all} for a one-off download of all features from
	 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
	 * other loading strategies.
	 * Requires `format` to be set as well.
	 * When default XHR feature loader is provided, the features will
	 * be transformed from the data projection to the view projection
	 * during parsing. If your remote data source does not advertise its projection
	 * properly, this transformation will be incorrect. For some formats, the
	 * default projection (usually EPSG:4326) can be overridden by setting the
	 * dataProjection constructor option on the format.
	 * Note that if a source contains non-feature data, such as a GeoJSON geometry
	 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
	 * @property {boolean} [useSpatialIndex=true]
	 * By default, an RTree is used as spatial index. When features are removed and
	 * added frequently, and the total number of features is low, setting this to
	 * `false` may improve performance.
	 *
	 * Note that
	 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
	 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
	 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
	 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
	 * through all features.
	 *
	 * When set to `false`, the features will be maintained in an
	 * {@link module:ol/Collection}, which can be retrieved through
	 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
	 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
	 * -180° and 180° meridians to work properly, this should be set to `false`. The
	 * resulting geometry coordinates will then exceed the world bounds.
	 */
	
	
	/**
	 * @classdesc
	 * Provides a source of features for vector layers. Vector features provided
	 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
	 * vector data that is optimized for rendering.
	 *
	 * @fires ol/source/Vector.VectorSourceEvent
	 * @api
	 */
	var VectorSource = /*@__PURE__*/(function (Source$$1) {
	  function VectorSource(opt_options) {
	
	    var options = opt_options || {};
	
	    Source$$1.call(this, {
	      attributions: options.attributions,
	      projection: undefined,
	      state: SourceState.READY,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true
	    });
	
	    /**
	     * @private
	     * @type {import("../featureloader.js").FeatureLoader}
	     */
	    this.loader_ = VOID;
	
	    /**
	     * @private
	     * @type {import("../format/Feature.js").default|undefined}
	     */
	    this.format_ = options.format;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.overlaps_ = options.overlaps == undefined ? true : options.overlaps;
	
	    /**
	     * @private
	     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
	     */
	    this.url_ = options.url;
	
	    if (options.loader !== undefined) {
	      this.loader_ = options.loader;
	    } else if (this.url_ !== undefined) {
	      assert(this.format_, 7); // `format` must be set when `url` is set
	      // create a XHR feature loader for "url" and "format"
	      this.loader_ = xhr(this.url_, /** @type {import("../format/Feature.js").default} */ (this.format_));
	    }
	
	    /**
	     * @private
	     * @type {LoadingStrategy}
	     */
	    this.strategy_ = options.strategy !== undefined ? options.strategy : all;
	
	    var useSpatialIndex =
	        options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
	
	    /**
	     * @private
	     * @type {RBush<import("../Feature.js").default>}
	     */
	    this.featuresRtree_ = useSpatialIndex ? new RBush() : null;
	
	    /**
	     * @private
	     * @type {RBush<{extent: import("../extent.js").Extent}>}
	     */
	    this.loadedExtentsRtree_ = new RBush();
	
	    /**
	     * @private
	     * @type {!Object<string, import("../Feature.js").default>}
	     */
	    this.nullGeometryFeatures_ = {};
	
	    /**
	     * A lookup of features by id (the return from feature.getId()).
	     * @private
	     * @type {!Object<string, import("../Feature.js").default>}
	     */
	    this.idIndex_ = {};
	
	    /**
	     * A lookup of features without id (keyed by getUid(feature)).
	     * @private
	     * @type {!Object<string, import("../Feature.js").default>}
	     */
	    this.undefIdIndex_ = {};
	
	    /**
	     * @private
	     * @type {Object<string, Array<import("../events.js").EventsKey>>}
	     */
	    this.featureChangeKeys_ = {};
	
	    /**
	     * @private
	     * @type {Collection<import("../Feature.js").default>}
	     */
	    this.featuresCollection_ = null;
	
	    var collection, features;
	    if (Array.isArray(options.features)) {
	      features = options.features;
	    } else if (options.features) {
	      collection = options.features;
	      features = collection.getArray();
	    }
	    if (!useSpatialIndex && collection === undefined) {
	      collection = new Collection(features);
	    }
	    if (features !== undefined) {
	      this.addFeaturesInternal(features);
	    }
	    if (collection !== undefined) {
	      this.bindFeaturesCollection_(collection);
	    }
	
	  }
	
	  if ( Source$$1 ) { VectorSource.__proto__ = Source$$1; }
	  VectorSource.prototype = Object.create( Source$$1 && Source$$1.prototype );
	  VectorSource.prototype.constructor = VectorSource;
	
	  /**
	   * Add a single feature to the source.  If you want to add a batch of features
	   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
	   * instead. A feature will not be added to the source if feature with
	   * the same id is already there. The reason for this behavior is to avoid
	   * feature duplication when using bbox or tile loading strategies.
	   * @param {import("../Feature.js").default} feature Feature to add.
	   * @api
	   */
	  VectorSource.prototype.addFeature = function addFeature (feature) {
	    this.addFeatureInternal(feature);
	    this.changed();
	  };
	
	
	  /**
	   * Add a feature without firing a `change` event.
	   * @param {import("../Feature.js").default} feature Feature.
	   * @protected
	   */
	  VectorSource.prototype.addFeatureInternal = function addFeatureInternal (feature) {
	    var featureKey = getUid(feature);
	
	    if (!this.addToIndex_(featureKey, feature)) {
	      return;
	    }
	
	    this.setupChangeEvents_(featureKey, feature);
	
	    var geometry = feature.getGeometry();
	    if (geometry) {
	      var extent = geometry.getExtent();
	      if (this.featuresRtree_) {
	        this.featuresRtree_.insert(extent, feature);
	      }
	    } else {
	      this.nullGeometryFeatures_[featureKey] = feature;
	    }
	
	    this.dispatchEvent(
	      new VectorSourceEvent(VectorEventType.ADDFEATURE, feature));
	  };
	
	
	  /**
	   * @param {string} featureKey Unique identifier for the feature.
	   * @param {import("../Feature.js").default} feature The feature.
	   * @private
	   */
	  VectorSource.prototype.setupChangeEvents_ = function setupChangeEvents_ (featureKey, feature) {
	    this.featureChangeKeys_[featureKey] = [
	      listen(feature, EventType.CHANGE,
	        this.handleFeatureChange_, this),
	      listen(feature, ObjectEventType.PROPERTYCHANGE,
	        this.handleFeatureChange_, this)
	    ];
	  };
	
	
	  /**
	   * @param {string} featureKey Unique identifier for the feature.
	   * @param {import("../Feature.js").default} feature The feature.
	   * @return {boolean} The feature is "valid", in the sense that it is also a
	   *     candidate for insertion into the Rtree.
	   * @private
	   */
	  VectorSource.prototype.addToIndex_ = function addToIndex_ (featureKey, feature) {
	    var valid = true;
	    var id = feature.getId();
	    if (id !== undefined) {
	      if (!(id.toString() in this.idIndex_)) {
	        this.idIndex_[id.toString()] = feature;
	      } else {
	        valid = false;
	      }
	    } else {
	      assert(!(featureKey in this.undefIdIndex_),
	        30); // The passed `feature` was already added to the source
	      this.undefIdIndex_[featureKey] = feature;
	    }
	    return valid;
	  };
	
	
	  /**
	   * Add a batch of features to the source.
	   * @param {Array<import("../Feature.js").default>} features Features to add.
	   * @api
	   */
	  VectorSource.prototype.addFeatures = function addFeatures (features) {
	    this.addFeaturesInternal(features);
	    this.changed();
	  };
	
	
	  /**
	   * Add features without firing a `change` event.
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @protected
	   */
	  VectorSource.prototype.addFeaturesInternal = function addFeaturesInternal (features) {
	    var extents = [];
	    var newFeatures = [];
	    var geometryFeatures = [];
	
	    for (var i = 0, length = features.length; i < length; i++) {
	      var feature = features[i];
	      var featureKey = getUid(feature);
	      if (this.addToIndex_(featureKey, feature)) {
	        newFeatures.push(feature);
	      }
	    }
	
	    for (var i$1 = 0, length$1 = newFeatures.length; i$1 < length$1; i$1++) {
	      var feature$1 = newFeatures[i$1];
	      var featureKey$1 = getUid(feature$1);
	      this.setupChangeEvents_(featureKey$1, feature$1);
	
	      var geometry = feature$1.getGeometry();
	      if (geometry) {
	        var extent = geometry.getExtent();
	        extents.push(extent);
	        geometryFeatures.push(feature$1);
	      } else {
	        this.nullGeometryFeatures_[featureKey$1] = feature$1;
	      }
	    }
	    if (this.featuresRtree_) {
	      this.featuresRtree_.load(extents, geometryFeatures);
	    }
	
	    for (var i$2 = 0, length$2 = newFeatures.length; i$2 < length$2; i$2++) {
	      this.dispatchEvent(new VectorSourceEvent(VectorEventType.ADDFEATURE, newFeatures[i$2]));
	    }
	  };
	
	
	  /**
	   * @param {!Collection<import("../Feature.js").default>} collection Collection.
	   * @private
	   */
	  VectorSource.prototype.bindFeaturesCollection_ = function bindFeaturesCollection_ (collection) {
	    var modifyingCollection = false;
	    listen(this, VectorEventType.ADDFEATURE,
	      /**
	       * @param {VectorSourceEvent} evt The vector source event
	       */
	      function(evt) {
	        if (!modifyingCollection) {
	          modifyingCollection = true;
	          collection.push(evt.feature);
	          modifyingCollection = false;
	        }
	      });
	    listen(this, VectorEventType.REMOVEFEATURE,
	      /**
	       * @param {VectorSourceEvent} evt The vector source event
	       */
	      function(evt) {
	        if (!modifyingCollection) {
	          modifyingCollection = true;
	          collection.remove(evt.feature);
	          modifyingCollection = false;
	        }
	      });
	    listen(collection, CollectionEventType.ADD,
	      /**
	       * @param {import("../Collection.js").CollectionEvent} evt The collection event
	       */
	      function(evt) {
	        if (!modifyingCollection) {
	          modifyingCollection = true;
	          this.addFeature(/** @type {import("../Feature.js").default} */ (evt.element));
	          modifyingCollection = false;
	        }
	      }, this);
	    listen(collection, CollectionEventType.REMOVE,
	      /**
	       * @param {import("../Collection.js").CollectionEvent} evt The collection event
	       */
	      function(evt) {
	        if (!modifyingCollection) {
	          modifyingCollection = true;
	          this.removeFeature(/** @type {import("../Feature.js").default} */ (evt.element));
	          modifyingCollection = false;
	        }
	      }, this);
	    this.featuresCollection_ = collection;
	  };
	
	
	  /**
	   * Remove all features from the source.
	   * @param {boolean=} opt_fast Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#removefeature} events.
	   * @api
	   */
	  VectorSource.prototype.clear = function clear$$1 (opt_fast) {
	    if (opt_fast) {
	      for (var featureId in this.featureChangeKeys_) {
	        var keys = this.featureChangeKeys_[featureId];
	        keys.forEach(unlistenByKey);
	      }
	      if (!this.featuresCollection_) {
	        this.featureChangeKeys_ = {};
	        this.idIndex_ = {};
	        this.undefIdIndex_ = {};
	      }
	    } else {
	      if (this.featuresRtree_) {
	        this.featuresRtree_.forEach(this.removeFeatureInternal, this);
	        for (var id in this.nullGeometryFeatures_) {
	          this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
	        }
	      }
	    }
	    if (this.featuresCollection_) {
	      this.featuresCollection_.clear();
	    }
	
	    if (this.featuresRtree_) {
	      this.featuresRtree_.clear();
	    }
	    this.loadedExtentsRtree_.clear();
	    this.nullGeometryFeatures_ = {};
	
	    var clearEvent = new VectorSourceEvent(VectorEventType.CLEAR);
	    this.dispatchEvent(clearEvent);
	    this.changed();
	  };
	
	
	  /**
	   * Iterate through all features on the source, calling the provided callback
	   * with each one.  If the callback returns any "truthy" value, iteration will
	   * stop and the function will return the same value.
	   * Note: this function only iterate through the feature that have a defined geometry.
	   *
	   * @param {function(import("../Feature.js").default): T} callback Called with each feature
	   *     on the source.  Return a truthy value to stop iteration.
	   * @return {T|undefined} The return value from the last call to the callback.
	   * @template T
	   * @api
	   */
	  VectorSource.prototype.forEachFeature = function forEachFeature (callback) {
	    if (this.featuresRtree_) {
	      return this.featuresRtree_.forEach(callback);
	    } else if (this.featuresCollection_) {
	      this.featuresCollection_.forEach(callback);
	    }
	  };
	
	
	  /**
	   * Iterate through all features whose geometries contain the provided
	   * coordinate, calling the callback with each feature.  If the callback returns
	   * a "truthy" value, iteration will stop and the function will return the same
	   * value.
	   *
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {function(import("../Feature.js").default): T} callback Called with each feature
	   *     whose goemetry contains the provided coordinate.
	   * @return {T|undefined} The return value from the last call to the callback.
	   * @template T
	   */
	  VectorSource.prototype.forEachFeatureAtCoordinateDirect = function forEachFeatureAtCoordinateDirect (coordinate, callback) {
	    var extent = [coordinate[0], coordinate[1], coordinate[0], coordinate[1]];
	    return this.forEachFeatureInExtent(extent, function(feature) {
	      var geometry = feature.getGeometry();
	      if (geometry.intersectsCoordinate(coordinate)) {
	        return callback(feature);
	      } else {
	        return undefined;
	      }
	    });
	  };
	
	
	  /**
	   * Iterate through all features whose bounding box intersects the provided
	   * extent (note that the feature's geometry may not intersect the extent),
	   * calling the callback with each feature.  If the callback returns a "truthy"
	   * value, iteration will stop and the function will return the same value.
	   *
	   * If you are interested in features whose geometry intersects an extent, call
	   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
	   *
	   * When `useSpatialIndex` is set to false, this method will loop through all
	   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
	   *
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {function(import("../Feature.js").default): T} callback Called with each feature
	   *     whose bounding box intersects the provided extent.
	   * @return {T|undefined} The return value from the last call to the callback.
	   * @template T
	   * @api
	   */
	  VectorSource.prototype.forEachFeatureInExtent = function forEachFeatureInExtent (extent, callback) {
	    if (this.featuresRtree_) {
	      return this.featuresRtree_.forEachInExtent(extent, callback);
	    } else if (this.featuresCollection_) {
	      this.featuresCollection_.forEach(callback);
	    }
	  };
	
	
	  /**
	   * Iterate through all features whose geometry intersects the provided extent,
	   * calling the callback with each feature.  If the callback returns a "truthy"
	   * value, iteration will stop and the function will return the same value.
	   *
	   * If you only want to test for bounding box intersection, call the
	   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
	   *
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {function(import("../Feature.js").default): T} callback Called with each feature
	   *     whose geometry intersects the provided extent.
	   * @return {T|undefined} The return value from the last call to the callback.
	   * @template T
	   * @api
	   */
	  VectorSource.prototype.forEachFeatureIntersectingExtent = function forEachFeatureIntersectingExtent (extent, callback) {
	    return this.forEachFeatureInExtent(extent,
	      /**
	       * @param {import("../Feature.js").default} feature Feature.
	       * @return {T|undefined} The return value from the last call to the callback.
	       */
	      function(feature) {
	        var geometry = feature.getGeometry();
	        if (geometry.intersectsExtent(extent)) {
	          var result = callback(feature);
	          if (result) {
	            return result;
	          }
	        }
	      });
	  };
	
	
	  /**
	   * Get the features collection associated with this source. Will be `null`
	   * unless the source was configured with `useSpatialIndex` set to `false`, or
	   * with an {@link module:ol/Collection} as `features`.
	   * @return {Collection<import("../Feature.js").default>} The collection of features.
	   * @api
	   */
	  VectorSource.prototype.getFeaturesCollection = function getFeaturesCollection () {
	    return this.featuresCollection_;
	  };
	
	
	  /**
	   * Get all features on the source in random order.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @api
	   */
	  VectorSource.prototype.getFeatures = function getFeatures () {
	    var features;
	    if (this.featuresCollection_) {
	      features = this.featuresCollection_.getArray();
	    } else if (this.featuresRtree_) {
	      features = this.featuresRtree_.getAll();
	      if (!isEmpty(this.nullGeometryFeatures_)) {
	        extend(features, getValues(this.nullGeometryFeatures_));
	      }
	    }
	    return (
	      /** @type {Array<import("../Feature.js").default>} */ (features)
	    );
	  };
	
	
	  /**
	   * Get all features whose geometry intersects the provided coordinate.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @api
	   */
	  VectorSource.prototype.getFeaturesAtCoordinate = function getFeaturesAtCoordinate (coordinate) {
	    var features = [];
	    this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
	      features.push(feature);
	    });
	    return features;
	  };
	
	
	  /**
	   * Get all features in the provided extent.  Note that this returns an array of
	   * all features intersecting the given extent in random order (so it may include
	   * features whose geometries do not intersect the extent).
	   *
	   * This method is not available when the source is configured with
	   * `useSpatialIndex` set to `false`.
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @api
	   */
	  VectorSource.prototype.getFeaturesInExtent = function getFeaturesInExtent (extent) {
	    return this.featuresRtree_.getInExtent(extent);
	  };
	
	
	  /**
	   * Get the closest feature to the provided coordinate.
	   *
	   * This method is not available when the source is configured with
	   * `useSpatialIndex` set to `false`.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {function(import("../Feature.js").default):boolean=} opt_filter Feature filter function.
	   *     The filter function will receive one argument, the {@link module:ol/Feature feature}
	   *     and it should return a boolean value. By default, no filtering is made.
	   * @return {import("../Feature.js").default} Closest feature.
	   * @api
	   */
	  VectorSource.prototype.getClosestFeatureToCoordinate = function getClosestFeatureToCoordinate (coordinate, opt_filter) {
	    // Find the closest feature using branch and bound.  We start searching an
	    // infinite extent, and find the distance from the first feature found.  This
	    // becomes the closest feature.  We then compute a smaller extent which any
	    // closer feature must intersect.  We continue searching with this smaller
	    // extent, trying to find a closer feature.  Every time we find a closer
	    // feature, we update the extent being searched so that any even closer
	    // feature must intersect it.  We continue until we run out of features.
	    var x = coordinate[0];
	    var y = coordinate[1];
	    var closestFeature = null;
	    var closestPoint = [NaN, NaN];
	    var minSquaredDistance = Infinity;
	    var extent = [-Infinity, -Infinity, Infinity, Infinity];
	    var filter = opt_filter ? opt_filter : TRUE;
	    this.featuresRtree_.forEachInExtent(extent,
	      /**
	       * @param {import("../Feature.js").default} feature Feature.
	       */
	      function(feature) {
	        if (filter(feature)) {
	          var geometry = feature.getGeometry();
	          var previousMinSquaredDistance = minSquaredDistance;
	          minSquaredDistance = geometry.closestPointXY(
	            x, y, closestPoint, minSquaredDistance);
	          if (minSquaredDistance < previousMinSquaredDistance) {
	            closestFeature = feature;
	            // This is sneaky.  Reduce the extent that it is currently being
	            // searched while the R-Tree traversal using this same extent object
	            // is still in progress.  This is safe because the new extent is
	            // strictly contained by the old extent.
	            var minDistance = Math.sqrt(minSquaredDistance);
	            extent[0] = x - minDistance;
	            extent[1] = y - minDistance;
	            extent[2] = x + minDistance;
	            extent[3] = y + minDistance;
	          }
	        }
	      });
	    return closestFeature;
	  };
	
	
	  /**
	   * Get the extent of the features currently in the source.
	   *
	   * This method is not available when the source is configured with
	   * `useSpatialIndex` set to `false`.
	   * @param {import("../extent.js").Extent=} opt_extent Destination extent. If provided, no new extent
	   *     will be created. Instead, that extent's coordinates will be overwritten.
	   * @return {import("../extent.js").Extent} Extent.
	   * @api
	   */
	  VectorSource.prototype.getExtent = function getExtent (opt_extent) {
	    return this.featuresRtree_.getExtent(opt_extent);
	  };
	
	
	  /**
	   * Get a feature by its identifier (the value returned by feature.getId()).
	   * Note that the index treats string and numeric identifiers as the same.  So
	   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
	   *
	   * @param {string|number} id Feature identifier.
	   * @return {import("../Feature.js").default} The feature (or `null` if not found).
	   * @api
	   */
	  VectorSource.prototype.getFeatureById = function getFeatureById (id) {
	    var feature = this.idIndex_[id.toString()];
	    return feature !== undefined ? feature : null;
	  };
	
	
	  /**
	   * Get the format associated with this source.
	   *
	   * @return {import("../format/Feature.js").default|undefined} The feature format.
	   * @api
	   */
	  VectorSource.prototype.getFormat = function getFormat () {
	    return this.format_;
	  };
	
	
	  /**
	   * @return {boolean} The source can have overlapping geometries.
	   */
	  VectorSource.prototype.getOverlaps = function getOverlaps () {
	    return this.overlaps_;
	  };
	
	
	  /**
	   * Get the url associated with this source.
	   *
	   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
	   * @api
	   */
	  VectorSource.prototype.getUrl = function getUrl () {
	    return this.url_;
	  };
	
	
	  /**
	   * @param {Event} event Event.
	   * @private
	   */
	  VectorSource.prototype.handleFeatureChange_ = function handleFeatureChange_ (event) {
	    var feature = /** @type {import("../Feature.js").default} */ (event.target);
	    var featureKey = getUid(feature);
	    var geometry = feature.getGeometry();
	    if (!geometry) {
	      if (!(featureKey in this.nullGeometryFeatures_)) {
	        if (this.featuresRtree_) {
	          this.featuresRtree_.remove(feature);
	        }
	        this.nullGeometryFeatures_[featureKey] = feature;
	      }
	    } else {
	      var extent = geometry.getExtent();
	      if (featureKey in this.nullGeometryFeatures_) {
	        delete this.nullGeometryFeatures_[featureKey];
	        if (this.featuresRtree_) {
	          this.featuresRtree_.insert(extent, feature);
	        }
	      } else {
	        if (this.featuresRtree_) {
	          this.featuresRtree_.update(extent, feature);
	        }
	      }
	    }
	    var id = feature.getId();
	    if (id !== undefined) {
	      var sid = id.toString();
	      if (featureKey in this.undefIdIndex_) {
	        delete this.undefIdIndex_[featureKey];
	        this.idIndex_[sid] = feature;
	      } else {
	        if (this.idIndex_[sid] !== feature) {
	          this.removeFromIdIndex_(feature);
	          this.idIndex_[sid] = feature;
	        }
	      }
	    } else {
	      if (!(featureKey in this.undefIdIndex_)) {
	        this.removeFromIdIndex_(feature);
	        this.undefIdIndex_[featureKey] = feature;
	      }
	    }
	    this.changed();
	    this.dispatchEvent(new VectorSourceEvent(
	      VectorEventType.CHANGEFEATURE, feature));
	  };
	
	  /**
	   * Returns true if the feature is contained within the source.
	   * @param {import("../Feature.js").default} feature Feature.
	   * @return {boolean} Has feature.
	   * @api
	   */
	  VectorSource.prototype.hasFeature = function hasFeature (feature) {
	    var id = feature.getId();
	    if (id !== undefined) {
	      return id in this.idIndex_;
	    } else {
	      return getUid(feature) in this.undefIdIndex_;
	    }
	  };
	
	  /**
	   * @return {boolean} Is empty.
	   */
	  VectorSource.prototype.isEmpty = function isEmpty$1$$1 () {
	    return this.featuresRtree_.isEmpty() && isEmpty(this.nullGeometryFeatures_);
	  };
	
	
	  /**
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {number} resolution Resolution.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   */
	  VectorSource.prototype.loadFeatures = function loadFeatures (extent, resolution, projection) {
	    var this$1 = this;
	
	    var loadedExtentsRtree = this.loadedExtentsRtree_;
	    var extentsToLoad = this.strategy_(extent, resolution);
	    this.loading = false;
	    var loop = function ( i, ii ) {
	      var extentToLoad = extentsToLoad[i];
	      var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad,
	        /**
	         * @param {{extent: import("../extent.js").Extent}} object Object.
	         * @return {boolean} Contains.
	         */
	        function(object) {
	          return containsExtent(object.extent, extentToLoad);
	        });
	      if (!alreadyLoaded) {
	        this$1.loader_.call(this$1, extentToLoad, resolution, projection);
	        loadedExtentsRtree.insert(extentToLoad, {extent: extentToLoad.slice()});
	        this$1.loading = this$1.loader_ !== VOID;
	      }
	    };
	
	    for (var i = 0, ii = extentsToLoad.length; i < ii; ++i) { loop( i, ii ); }
	  };
	
	
	  /**
	   * Remove an extent from the list of loaded extents.
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @api
	   */
	  VectorSource.prototype.removeLoadedExtent = function removeLoadedExtent (extent) {
	    var loadedExtentsRtree = this.loadedExtentsRtree_;
	    var obj;
	    loadedExtentsRtree.forEachInExtent(extent, function(object) {
	      if (equals$1(object.extent, extent)) {
	        obj = object;
	        return true;
	      }
	    });
	    if (obj) {
	      loadedExtentsRtree.remove(obj);
	    }
	  };
	
	
	  /**
	   * Remove a single feature from the source.  If you want to remove all features
	   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
	   * instead.
	   * @param {import("../Feature.js").default} feature Feature to remove.
	   * @api
	   */
	  VectorSource.prototype.removeFeature = function removeFeature (feature) {
	    var featureKey = getUid(feature);
	    if (featureKey in this.nullGeometryFeatures_) {
	      delete this.nullGeometryFeatures_[featureKey];
	    } else {
	      if (this.featuresRtree_) {
	        this.featuresRtree_.remove(feature);
	      }
	    }
	    this.removeFeatureInternal(feature);
	    this.changed();
	  };
	
	
	  /**
	   * Remove feature without firing a `change` event.
	   * @param {import("../Feature.js").default} feature Feature.
	   * @protected
	   */
	  VectorSource.prototype.removeFeatureInternal = function removeFeatureInternal (feature) {
	    var featureKey = getUid(feature);
	    this.featureChangeKeys_[featureKey].forEach(unlistenByKey);
	    delete this.featureChangeKeys_[featureKey];
	    var id = feature.getId();
	    if (id !== undefined) {
	      delete this.idIndex_[id.toString()];
	    } else {
	      delete this.undefIdIndex_[featureKey];
	    }
	    this.dispatchEvent(new VectorSourceEvent(
	      VectorEventType.REMOVEFEATURE, feature));
	  };
	
	
	  /**
	   * Remove a feature from the id index.  Called internally when the feature id
	   * may have changed.
	   * @param {import("../Feature.js").default} feature The feature.
	   * @return {boolean} Removed the feature from the index.
	   * @private
	   */
	  VectorSource.prototype.removeFromIdIndex_ = function removeFromIdIndex_ (feature) {
	    var removed = false;
	    for (var id in this.idIndex_) {
	      if (this.idIndex_[id] === feature) {
	        delete this.idIndex_[id];
	        removed = true;
	        break;
	      }
	    }
	    return removed;
	  };
	
	
	  /**
	   * Set the new loader of the source. The next loadFeatures call will use the
	   * new loader.
	   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
	   * @api
	   */
	  VectorSource.prototype.setLoader = function setLoader (loader) {
	    this.loader_ = loader;
	  };
	
	  return VectorSource;
	}(Source));
	
	/**
	 * @module ol/interaction/Draw
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {GeometryType} type Geometry type of
	 * the geometries being drawn with this instance.
	 * @property {number} [clickTolerance=6] The maximum distance in pixels between
	 * "down" and "up" for a "up" event to be considered a "click" event and
	 * actually add a point/vertex to the geometry being drawn.  The default of `6`
	 * was chosen for the draw interaction to behave correctly on mouse as well as
	 * on touch devices.
	 * @property {import("../Collection.js").default<Feature>} [features]
	 * Destination collection for the drawn features.
	 * @property {VectorSource} [source] Destination source for
	 * the drawn features.
	 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
	 * before the current vertex can be dragged to its exact position.
	 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
	 * drawing finish.
	 * @property {boolean} [stopClick=false] Stop click, singleclick, and
	 * doubleclick events from firing during drawing.
	 * @property {number} [maxPoints] The number of points that can be drawn before
	 * a polygon ring or line string is finished. By default there is no
	 * restriction.
	 * @property {number} [minPoints] The number of points that must be drawn
	 * before a polygon ring or line string can be finished. Default is `3` for
	 * polygon rings and `2` for line strings.
	 * @property {import("../events/condition.js").Condition} [finishCondition] A function
	 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether the drawing can be finished.
	 * @property {import("../style/Style.js").StyleLike} [style]
	 * Style for sketch features.
	 * @property {GeometryFunction} [geometryFunction]
	 * Function that is called when a geometry's coordinates are updated.
	 * @property {string} [geometryName] Geometry name to use for features created
	 * by the draw interaction.
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled.
	 * By default {@link module:ol/events/condition~noModifierKeys}, i.e. a click,
	 * adds a vertex or deactivates freehand drawing.
	 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
	 * polygons, and circles.  This makes the interaction always operate in freehand
	 * mode and takes precedence over any `freehandCondition` option.
	 * @property {import("../events/condition.js").Condition} [freehandCondition]
	 * Condition that activates freehand drawing for lines and polygons. This
	 * function takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
	 * returns a boolean to indicate whether that event should be handled. The
	 * default is {@link module:ol/events/condition~shiftKeyOnly}, meaning that the
	 * Shift key activates freehand drawing.
	 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
	 * overlay.
	 */
	
	
	/**
	 * Coordinate type when drawing points.
	 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
	 */
	
	
	/**
	 * Coordinate type when drawing lines.
	 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
	 */
	
	
	/**
	 * Coordinate type when drawing polygons.
	 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
	 */
	
	
	/**
	 * Types used for drawing coordinates.
	 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
	 */
	
	
	/**
	 * Function that takes an array of coordinates and an optional existing geometry as
	 * arguments, and returns a geometry. The optional existing geometry is the
	 * geometry that is returned when the function is called without a second
	 * argument.
	 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default=):
	 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
	 */
	
	
	/**
	 * Draw mode.  This collapses multi-part geometry types with their single-part
	 * cousins.
	 * @enum {string}
	 */
	var Mode$1 = {
	  POINT: 'Point',
	  LINE_STRING: 'LineString',
	  POLYGON: 'Polygon',
	  CIRCLE: 'Circle'
	};
	
	
	/**
	 * @enum {string}
	 */
	var DrawEventType = {
	  /**
	   * Triggered upon feature draw start
	   * @event DrawEvent#drawstart
	   * @api
	   */
	  DRAWSTART: 'drawstart',
	  /**
	   * Triggered upon feature draw end
	   * @event DrawEvent#drawend
	   * @api
	   */
	  DRAWEND: 'drawend'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/Draw~Draw} instances are
	 * instances of this type.
	 */
	var DrawEvent = /*@__PURE__*/(function (Event$$1) {
	  function DrawEvent(type, feature) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The feature being drawn.
	     * @type {Feature}
	     * @api
	     */
	    this.feature = feature;
	
	  }
	
	  if ( Event$$1 ) { DrawEvent.__proto__ = Event$$1; }
	  DrawEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  DrawEvent.prototype.constructor = DrawEvent;
	
	  return DrawEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Interaction for drawing feature geometries.
	 *
	 * @fires DrawEvent
	 * @api
	 */
	var Draw = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function Draw(options) {
	
	    var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
	    if (!pointerOptions.stopDown) {
	      pointerOptions.stopDown = FALSE;
	    }
	
	    PointerInteraction$$1.call(this, pointerOptions);
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.shouldHandle_ = false;
	
	    /**
	     * @type {import("../pixel.js").Pixel}
	     * @private
	     */
	    this.downPx_ = null;
	
	    /**
	     * @type {?}
	     * @private
	     */
	    this.downTimeout_;
	
	    /**
	     * @type {number|undefined}
	     * @private
	     */
	    this.lastDragTime_;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.freehand_ = false;
	
	    /**
	     * Target source for drawn features.
	     * @type {VectorSource}
	     * @private
	     */
	    this.source_ = options.source ? options.source : null;
	
	    /**
	     * Target collection for drawn features.
	     * @type {import("../Collection.js").default<Feature>}
	     * @private
	     */
	    this.features_ = options.features ? options.features : null;
	
	    /**
	     * Pixel distance for snapping.
	     * @type {number}
	     * @private
	     */
	    this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
	
	    /**
	     * Geometry type.
	     * @type {GeometryType}
	     * @private
	     */
	    this.type_ = /** @type {GeometryType} */ (options.type);
	
	    /**
	     * Drawing mode (derived from geometry type.
	     * @type {Mode}
	     * @private
	     */
	    this.mode_ = getMode(this.type_);
	
	    /**
	     * Stop click, singleclick, and doubleclick events from firing during drawing.
	     * Default is `false`.
	     * @type {boolean}
	     * @private
	     */
	    this.stopClick_ = !!options.stopClick;
	
	    /**
	     * The number of points that must be drawn before a polygon ring or line
	     * string can be finished.  The default is 3 for polygon rings and 2 for
	     * line strings.
	     * @type {number}
	     * @private
	     */
	    this.minPoints_ = options.minPoints ?
	      options.minPoints :
	      (this.mode_ === Mode$1.POLYGON ? 3 : 2);
	
	    /**
	     * The number of points that can be drawn before a polygon ring or line string
	     * is finished. The default is no restriction.
	     * @type {number}
	     * @private
	     */
	    this.maxPoints_ = options.maxPoints ? options.maxPoints : Infinity;
	
	    /**
	     * A function to decide if a potential finish coordinate is permissible
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.finishCondition_ = options.finishCondition ? options.finishCondition : TRUE;
	
	    var geometryFunction = options.geometryFunction;
	    if (!geometryFunction) {
	      if (this.type_ === GeometryType.CIRCLE) {
	        /**
	         * @param {!LineCoordType} coordinates The coordinates.
	         * @param {import("../geom/SimpleGeometry.js").default=} opt_geometry Optional geometry.
	         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
	         */
	        geometryFunction = function(coordinates, opt_geometry) {
	          var circle = opt_geometry ? /** @type {Circle} */ (opt_geometry) :
	            new Circle([NaN, NaN]);
	          var squaredLength = squaredDistance$1(
	            coordinates[0], coordinates[1]);
	          circle.setCenterAndRadius(coordinates[0], Math.sqrt(squaredLength));
	          return circle;
	        };
	      } else {
	        var Constructor;
	        var mode = this.mode_;
	        if (mode === Mode$1.POINT) {
	          Constructor = Point;
	        } else if (mode === Mode$1.LINE_STRING) {
	          Constructor = LineString;
	        } else if (mode === Mode$1.POLYGON) {
	          Constructor = Polygon;
	        }
	        /**
	         * @param {!LineCoordType} coordinates The coordinates.
	         * @param {import("../geom/SimpleGeometry.js").default=} opt_geometry Optional geometry.
	         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
	         */
	        geometryFunction = function(coordinates, opt_geometry) {
	          var geometry = opt_geometry;
	          if (geometry) {
	            if (mode === Mode$1.POLYGON) {
	              if (coordinates[0].length) {
	                // Add a closing coordinate to match the first
	                geometry.setCoordinates([coordinates[0].concat([coordinates[0][0]])]);
	              } else {
	                geometry.setCoordinates([]);
	              }
	            } else {
	              geometry.setCoordinates(coordinates);
	            }
	          } else {
	            geometry = new Constructor(coordinates);
	          }
	          return geometry;
	        };
	      }
	    }
	
	    /**
	     * @type {GeometryFunction}
	     * @private
	     */
	    this.geometryFunction_ = geometryFunction;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
	
	    /**
	     * Finish coordinate for the feature (first point for polygons, last point for
	     * linestrings).
	     * @type {import("../coordinate.js").Coordinate}
	     * @private
	     */
	    this.finishCoordinate_ = null;
	
	    /**
	     * Sketch feature.
	     * @type {Feature}
	     * @private
	     */
	    this.sketchFeature_ = null;
	
	    /**
	     * Sketch point.
	     * @type {Feature}
	     * @private
	     */
	    this.sketchPoint_ = null;
	
	    /**
	     * Sketch coordinates. Used when drawing a line or polygon.
	     * @type {SketchCoordType}
	     * @private
	     */
	    this.sketchCoords_ = null;
	
	    /**
	     * Sketch line. Used when drawing polygon.
	     * @type {Feature}
	     * @private
	     */
	    this.sketchLine_ = null;
	
	    /**
	     * Sketch line coordinates. Used when drawing a polygon or circle.
	     * @type {LineCoordType}
	     * @private
	     */
	    this.sketchLineCoords_ = null;
	
	    /**
	     * Squared tolerance for handling up events.  If the squared distance
	     * between a down and up event is greater than this tolerance, up events
	     * will not be handled.
	     * @type {number}
	     * @private
	     */
	    this.squaredClickTolerance_ = options.clickTolerance ?
	      options.clickTolerance * options.clickTolerance : 36;
	
	    /**
	     * Draw overlay where our sketch features are drawn.
	     * @type {VectorLayer}
	     * @private
	     */
	    this.overlay_ = new VectorLayer({
	      source: new VectorSource({
	        useSpatialIndex: false,
	        wrapX: options.wrapX ? options.wrapX : false
	      }),
	      style: options.style ? options.style :
	        getDefaultStyleFunction(),
	      updateWhileInteracting: true
	    });
	
	    /**
	     * Name of the geometry attribute for newly created features.
	     * @type {string|undefined}
	     * @private
	     */
	    this.geometryName_ = options.geometryName;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : noModifierKeys;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.freehandCondition_;
	    if (options.freehand) {
	      this.freehandCondition_ = always;
	    } else {
	      this.freehandCondition_ = options.freehandCondition ?
	        options.freehandCondition : shiftKeyOnly;
	    }
	
	    listen(this,
	      getChangeEventType(InteractionProperty.ACTIVE),
	      this.updateState_, this);
	
	  }
	
	  if ( PointerInteraction$$1 ) { Draw.__proto__ = PointerInteraction$$1; }
	  Draw.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  Draw.prototype.constructor = Draw;
	
	  /**
	   * @inheritDoc
	   */
	  Draw.prototype.setMap = function setMap (map) {
	    PointerInteraction$$1.prototype.setMap.call(this, map);
	    this.updateState_();
	  };
	
	  /**
	   * Get the overlay layer that this interaction renders sketch features to.
	   * @return {VectorLayer} Overlay layer.
	   * @api
	   */
	  Draw.prototype.getOverlay = function getOverlay () {
	    return this.overlay_;
	  };
	
	  /**
	   * Handles the {@link module:ol/MapBrowserEvent map browser event} and may actually draw or finish the drawing.
	   * @override
	   * @api
	   */
	  Draw.prototype.handleEvent = function handleEvent (event) {
	    if (event.originalEvent.type === EventType.CONTEXTMENU) {
	      // Avoid context menu for long taps when drawing on mobile
	      event.preventDefault();
	    }
	    this.freehand_ = this.mode_ !== Mode$1.POINT && this.freehandCondition_(event);
	    var move = event.type === MapBrowserEventType.POINTERMOVE;
	    var pass = true;
	    if (!this.freehand_ && this.lastDragTime_ && event.type === MapBrowserEventType.POINTERDRAG) {
	      var now = Date.now();
	      if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
	        this.downPx_ = event.pixel;
	        this.shouldHandle_ = !this.freehand_;
	        move = true;
	      } else {
	        this.lastDragTime_ = undefined;
	      }
	      if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
	        clearTimeout(this.downTimeout_);
	        this.downTimeout_ = undefined;
	      }
	    }
	    if (this.freehand_ &&
	        event.type === MapBrowserEventType.POINTERDRAG &&
	        this.sketchFeature_ !== null) {
	      this.addToDrawing_(event);
	      pass = false;
	    } else if (this.freehand_ &&
	        event.type === MapBrowserEventType.POINTERDOWN) {
	      pass = false;
	    } else if (move) {
	      pass = event.type === MapBrowserEventType.POINTERMOVE;
	      if (pass && this.freehand_) {
	        pass = this.handlePointerMove_(event);
	      } else if (/** @type {MapBrowserPointerEvent} */ (event).pointerEvent.pointerType == POINTER_TYPE ||
	          (event.type === MapBrowserEventType.POINTERDRAG && this.downTimeout_ === undefined)) {
	        this.handlePointerMove_(event);
	      }
	    } else if (event.type === MapBrowserEventType.DBLCLICK) {
	      pass = false;
	    }
	
	    return PointerInteraction$$1.prototype.handleEvent.call(this, event) && pass;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Draw.prototype.handleDownEvent = function handleDownEvent (event) {
	    this.shouldHandle_ = !this.freehand_;
	
	    if (this.freehand_) {
	      this.downPx_ = event.pixel;
	      if (!this.finishCoordinate_) {
	        this.startDrawing_(event);
	      }
	      return true;
	    } else if (this.condition_(event)) {
	      this.lastDragTime_ = Date.now();
	      this.downTimeout_ = setTimeout(function() {
	        this.handlePointerMove_(new MapBrowserPointerEvent(
	          MapBrowserEventType.POINTERMOVE, event.map, event.pointerEvent, false, event.frameState));
	      }.bind(this), this.dragVertexDelay_);
	      this.downPx_ = event.pixel;
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  Draw.prototype.handleUpEvent = function handleUpEvent (event) {
	    var pass = true;
	
	    if (this.downTimeout_) {
	      clearTimeout(this.downTimeout_);
	      this.downTimeout_ = undefined;
	    }
	
	    this.handlePointerMove_(event);
	
	    var circleMode = this.mode_ === Mode$1.CIRCLE;
	
	    if (this.shouldHandle_) {
	      if (!this.finishCoordinate_) {
	        this.startDrawing_(event);
	        if (this.mode_ === Mode$1.POINT) {
	          this.finishDrawing();
	        }
	      } else if (this.freehand_ || circleMode) {
	        this.finishDrawing();
	      } else if (this.atFinish_(event)) {
	        if (this.finishCondition_(event)) {
	          this.finishDrawing();
	        }
	      } else {
	        this.addToDrawing_(event);
	      }
	      pass = false;
	    } else if (this.freehand_) {
	      this.finishCoordinate_ = null;
	      this.abortDrawing_();
	    }
	    if (!pass && this.stopClick_) {
	      event.stopPropagation();
	    }
	    return pass;
	  };
	
	  /**
	   * Handle move events.
	   * @param {import("../MapBrowserEvent.js").default} event A move event.
	   * @return {boolean} Pass the event to other interactions.
	   * @private
	   */
	  Draw.prototype.handlePointerMove_ = function handlePointerMove_ (event) {
	    if (this.downPx_ &&
	        ((!this.freehand_ && this.shouldHandle_) ||
	        (this.freehand_ && !this.shouldHandle_))) {
	      var downPx = this.downPx_;
	      var clickPx = event.pixel;
	      var dx = downPx[0] - clickPx[0];
	      var dy = downPx[1] - clickPx[1];
	      var squaredDistance$$1 = dx * dx + dy * dy;
	      this.shouldHandle_ = this.freehand_ ?
	        squaredDistance$$1 > this.squaredClickTolerance_ :
	        squaredDistance$$1 <= this.squaredClickTolerance_;
	      if (!this.shouldHandle_) {
	        return true;
	      }
	    }
	
	    if (this.finishCoordinate_) {
	      this.modifyDrawing_(event);
	    } else {
	      this.createOrUpdateSketchPoint_(event);
	    }
	    return true;
	  };
	
	  /**
	   * Determine if an event is within the snapping tolerance of the start coord.
	   * @param {import("../MapBrowserEvent.js").default} event Event.
	   * @return {boolean} The event is within the snapping tolerance of the start.
	   * @private
	   */
	  Draw.prototype.atFinish_ = function atFinish_ (event) {
	    var at = false;
	    if (this.sketchFeature_) {
	      var potentiallyDone = false;
	      var potentiallyFinishCoordinates = [this.finishCoordinate_];
	      if (this.mode_ === Mode$1.LINE_STRING) {
	        potentiallyDone = this.sketchCoords_.length > this.minPoints_;
	      } else if (this.mode_ === Mode$1.POLYGON) {
	        var sketchCoords = /** @type {PolyCoordType} */ (this.sketchCoords_);
	        potentiallyDone = sketchCoords[0].length > this.minPoints_;
	        potentiallyFinishCoordinates = [sketchCoords[0][0], sketchCoords[0][sketchCoords[0].length - 2]];
	      }
	      if (potentiallyDone) {
	        var map = event.map;
	        for (var i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++) {
	          var finishCoordinate = potentiallyFinishCoordinates[i];
	          var finishPixel = map.getPixelFromCoordinate(finishCoordinate);
	          var pixel = event.pixel;
	          var dx = pixel[0] - finishPixel[0];
	          var dy = pixel[1] - finishPixel[1];
	          var snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
	          at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
	          if (at) {
	            this.finishCoordinate_ = finishCoordinate;
	            break;
	          }
	        }
	      }
	    }
	    return at;
	  };
	
	  /**
	   * @param {import("../MapBrowserEvent.js").default} event Event.
	   * @private
	   */
	  Draw.prototype.createOrUpdateSketchPoint_ = function createOrUpdateSketchPoint_ (event) {
	    var coordinates = event.coordinate.slice();
	    if (!this.sketchPoint_) {
	      this.sketchPoint_ = new Feature(new Point(coordinates));
	      this.updateSketchFeatures_();
	    } else {
	      var sketchPointGeom = /** @type {Point} */ (this.sketchPoint_.getGeometry());
	      sketchPointGeom.setCoordinates(coordinates);
	    }
	  };
	
	  /**
	   * Start the drawing.
	   * @param {import("../MapBrowserEvent.js").default} event Event.
	   * @private
	   */
	  Draw.prototype.startDrawing_ = function startDrawing_ (event) {
	    var start = event.coordinate;
	    this.finishCoordinate_ = start;
	    if (this.mode_ === Mode$1.POINT) {
	      this.sketchCoords_ = start.slice();
	    } else if (this.mode_ === Mode$1.POLYGON) {
	      this.sketchCoords_ = [[start.slice(), start.slice()]];
	      this.sketchLineCoords_ = this.sketchCoords_[0];
	    } else {
	      this.sketchCoords_ = [start.slice(), start.slice()];
	    }
	    if (this.sketchLineCoords_) {
	      this.sketchLine_ = new Feature(
	        new LineString(this.sketchLineCoords_));
	    }
	    var geometry = this.geometryFunction_(this.sketchCoords_);
	    this.sketchFeature_ = new Feature();
	    if (this.geometryName_) {
	      this.sketchFeature_.setGeometryName(this.geometryName_);
	    }
	    this.sketchFeature_.setGeometry(geometry);
	    this.updateSketchFeatures_();
	    this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
	  };
	
	  /**
	   * Modify the drawing.
	   * @param {import("../MapBrowserEvent.js").default} event Event.
	   * @private
	   */
	  Draw.prototype.modifyDrawing_ = function modifyDrawing_ (event) {
	    var coordinate = event.coordinate;
	    var geometry = /** @type {import("../geom/SimpleGeometry.js").default} */ (this.sketchFeature_.getGeometry());
	    var coordinates, last;
	    if (this.mode_ === Mode$1.POINT) {
	      last = this.sketchCoords_;
	    } else if (this.mode_ === Mode$1.POLYGON) {
	      coordinates = /** @type {PolyCoordType} */ (this.sketchCoords_)[0];
	      last = coordinates[coordinates.length - 1];
	      if (this.atFinish_(event)) {
	        // snap to finish
	        coordinate = this.finishCoordinate_.slice();
	      }
	    } else {
	      coordinates = this.sketchCoords_;
	      last = coordinates[coordinates.length - 1];
	    }
	    last[0] = coordinate[0];
	    last[1] = coordinate[1];
	    this.geometryFunction_(/** @type {!LineCoordType} */ (this.sketchCoords_), geometry);
	    if (this.sketchPoint_) {
	      var sketchPointGeom = /** @type {Point} */ (this.sketchPoint_.getGeometry());
	      sketchPointGeom.setCoordinates(coordinate);
	    }
	    /** @type {LineString} */
	    var sketchLineGeom;
	    if (geometry.getType() == GeometryType.POLYGON &&
	        this.mode_ !== Mode$1.POLYGON) {
	      if (!this.sketchLine_) {
	        this.sketchLine_ = new Feature();
	      }
	      var ring = /** @type {Polygon} */ (geometry).getLinearRing(0);
	      sketchLineGeom = /** @type {LineString} */ (this.sketchLine_.getGeometry());
	      if (!sketchLineGeom) {
	        sketchLineGeom = new LineString(ring.getFlatCoordinates(), ring.getLayout());
	        this.sketchLine_.setGeometry(sketchLineGeom);
	      } else {
	        sketchLineGeom.setFlatCoordinates(
	          ring.getLayout(), ring.getFlatCoordinates());
	        sketchLineGeom.changed();
	      }
	    } else if (this.sketchLineCoords_) {
	      sketchLineGeom = /** @type {LineString} */ (this.sketchLine_.getGeometry());
	      sketchLineGeom.setCoordinates(this.sketchLineCoords_);
	    }
	    this.updateSketchFeatures_();
	  };
	
	  /**
	   * Add a new coordinate to the drawing.
	   * @param {import("../MapBrowserEvent.js").default} event Event.
	   * @private
	   */
	  Draw.prototype.addToDrawing_ = function addToDrawing_ (event) {
	    var coordinate = event.coordinate;
	    var geometry = /** @type {import("../geom/SimpleGeometry.js").default} */ (this.sketchFeature_.getGeometry());
	    var done;
	    var coordinates;
	    if (this.mode_ === Mode$1.LINE_STRING) {
	      this.finishCoordinate_ = coordinate.slice();
	      coordinates = /** @type {LineCoordType} */ (this.sketchCoords_);
	      if (coordinates.length >= this.maxPoints_) {
	        if (this.freehand_) {
	          coordinates.pop();
	        } else {
	          done = true;
	        }
	      }
	      coordinates.push(coordinate.slice());
	      this.geometryFunction_(coordinates, geometry);
	    } else if (this.mode_ === Mode$1.POLYGON) {
	      coordinates = /** @type {PolyCoordType} */ (this.sketchCoords_)[0];
	      if (coordinates.length >= this.maxPoints_) {
	        if (this.freehand_) {
	          coordinates.pop();
	        } else {
	          done = true;
	        }
	      }
	      coordinates.push(coordinate.slice());
	      if (done) {
	        this.finishCoordinate_ = coordinates[0];
	      }
	      this.geometryFunction_(this.sketchCoords_, geometry);
	    }
	    this.updateSketchFeatures_();
	    if (done) {
	      this.finishDrawing();
	    }
	  };
	
	  /**
	   * Remove last point of the feature currently being drawn.
	   * @api
	   */
	  Draw.prototype.removeLastPoint = function removeLastPoint () {
	    if (!this.sketchFeature_) {
	      return;
	    }
	    var geometry = /** @type {import("../geom/SimpleGeometry.js").default} */ (this.sketchFeature_.getGeometry());
	    var coordinates;
	    /** @type {LineString} */
	    var sketchLineGeom;
	    if (this.mode_ === Mode$1.LINE_STRING) {
	      coordinates = /** @type {LineCoordType} */ (this.sketchCoords_);
	      coordinates.splice(-2, 1);
	      this.geometryFunction_(coordinates, geometry);
	      if (coordinates.length >= 2) {
	        this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
	      }
	    } else if (this.mode_ === Mode$1.POLYGON) {
	      coordinates = /** @type {PolyCoordType} */ (this.sketchCoords_)[0];
	      coordinates.splice(-2, 1);
	      sketchLineGeom = /** @type {LineString} */ (this.sketchLine_.getGeometry());
	      sketchLineGeom.setCoordinates(coordinates);
	      this.geometryFunction_(this.sketchCoords_, geometry);
	    }
	
	    if (coordinates.length === 0) {
	      this.finishCoordinate_ = null;
	    }
	
	    this.updateSketchFeatures_();
	  };
	
	  /**
	   * Stop drawing and add the sketch feature to the target layer.
	   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
	   * dispatched before inserting the feature.
	   * @api
	   */
	  Draw.prototype.finishDrawing = function finishDrawing () {
	    var sketchFeature = this.abortDrawing_();
	    if (!sketchFeature) {
	      return;
	    }
	    var coordinates = this.sketchCoords_;
	    var geometry = /** @type {import("../geom/SimpleGeometry.js").default} */ (sketchFeature.getGeometry());
	    if (this.mode_ === Mode$1.LINE_STRING) {
	      // remove the redundant last point
	      coordinates.pop();
	      this.geometryFunction_(coordinates, geometry);
	    } else if (this.mode_ === Mode$1.POLYGON) {
	      // remove the redundant last point in ring
	      /** @type {PolyCoordType} */ (coordinates)[0].pop();
	      this.geometryFunction_(coordinates, geometry);
	      coordinates = geometry.getCoordinates();
	    }
	
	    // cast multi-part geometries
	    if (this.type_ === GeometryType.MULTI_POINT) {
	      sketchFeature.setGeometry(new MultiPoint([/** @type {PointCoordType} */(coordinates)]));
	    } else if (this.type_ === GeometryType.MULTI_LINE_STRING) {
	      sketchFeature.setGeometry(new MultiLineString([/** @type {LineCoordType} */(coordinates)]));
	    } else if (this.type_ === GeometryType.MULTI_POLYGON) {
	      sketchFeature.setGeometry(new MultiPolygon([/** @type {PolyCoordType} */(coordinates)]));
	    }
	
	    // First dispatch event to allow full set up of feature
	    this.dispatchEvent(new DrawEvent(DrawEventType.DRAWEND, sketchFeature));
	
	    // Then insert feature
	    if (this.features_) {
	      this.features_.push(sketchFeature);
	    }
	    if (this.source_) {
	      this.source_.addFeature(sketchFeature);
	    }
	  };
	
	  /**
	   * Stop drawing without adding the sketch feature to the target layer.
	   * @return {Feature} The sketch feature (or null if none).
	   * @private
	   */
	  Draw.prototype.abortDrawing_ = function abortDrawing_ () {
	    this.finishCoordinate_ = null;
	    var sketchFeature = this.sketchFeature_;
	    if (sketchFeature) {
	      this.sketchFeature_ = null;
	      this.sketchPoint_ = null;
	      this.sketchLine_ = null;
	      /** @type {VectorSource} */ (this.overlay_.getSource()).clear(true);
	    }
	    return sketchFeature;
	  };
	
	  /**
	   * Extend an existing geometry by adding additional points. This only works
	   * on features with `LineString` geometries, where the interaction will
	   * extend lines by adding points to the end of the coordinates array.
	   * @param {!Feature} feature Feature to be extended.
	   * @api
	   */
	  Draw.prototype.extend = function extend (feature) {
	    var geometry = feature.getGeometry();
	    var lineString = /** @type {LineString} */ (geometry);
	    this.sketchFeature_ = feature;
	    this.sketchCoords_ = lineString.getCoordinates();
	    var last = this.sketchCoords_[this.sketchCoords_.length - 1];
	    this.finishCoordinate_ = last.slice();
	    this.sketchCoords_.push(last.slice());
	    this.updateSketchFeatures_();
	    this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
	  };
	
	  /**
	   * Redraw the sketch features.
	   * @private
	   */
	  Draw.prototype.updateSketchFeatures_ = function updateSketchFeatures_ () {
	    var sketchFeatures = [];
	    if (this.sketchFeature_) {
	      sketchFeatures.push(this.sketchFeature_);
	    }
	    if (this.sketchLine_) {
	      sketchFeatures.push(this.sketchLine_);
	    }
	    if (this.sketchPoint_) {
	      sketchFeatures.push(this.sketchPoint_);
	    }
	    var overlaySource = /** @type {VectorSource} */ (this.overlay_.getSource());
	    overlaySource.clear(true);
	    overlaySource.addFeatures(sketchFeatures);
	  };
	
	  /**
	   * @private
	   */
	  Draw.prototype.updateState_ = function updateState_ () {
	    var map = this.getMap();
	    var active = this.getActive();
	    if (!map || !active) {
	      this.abortDrawing_();
	    }
	    this.overlay_.setMap(active ? map : null);
	  };
	
	  return Draw;
	}(PointerInteraction));
	
	
	/**
	 * @return {import("../style/Style.js").StyleFunction} Styles.
	 */
	function getDefaultStyleFunction() {
	  var styles = createEditingStyle();
	  return function(feature, resolution) {
	    return styles[feature.getGeometry().getType()];
	  };
	}
	
	
	/**
	 * Create a `geometryFunction` for `type: 'Circle'` that will create a regular
	 * polygon with a user specified number of sides and start angle instead of an
	 * `import("../geom/Circle.js").Circle` geometry.
	 * @param {number=} opt_sides Number of sides of the regular polygon. Default is
	 *     32.
	 * @param {number=} opt_angle Angle of the first point in radians. 0 means East.
	 *     Default is the angle defined by the heading from the center of the
	 *     regular polygon to the current pointer position.
	 * @return {GeometryFunction} Function that draws a
	 *     polygon.
	 * @api
	 */
	function createRegularPolygon(opt_sides, opt_angle) {
	  return function(coordinates, opt_geometry) {
	    var center = /** @type {LineCoordType} */ (coordinates)[0];
	    var end = /** @type {LineCoordType} */ (coordinates)[1];
	    var radius = Math.sqrt(
	      squaredDistance$1(center, end));
	    var geometry = opt_geometry ? /** @type {Polygon} */ (opt_geometry) :
	      fromCircle(new Circle(center), opt_sides);
	    var angle = opt_angle;
	    if (!opt_angle) {
	      var x = end[0] - center[0];
	      var y = end[1] - center[1];
	      angle = Math.atan(y / x) - (x < 0 ? Math.PI : 0);
	    }
	    makeRegular(geometry, center, radius, angle);
	    return geometry;
	  };
	}
	
	
	/**
	 * Create a `geometryFunction` that will create a box-shaped polygon (aligned
	 * with the coordinate system axes).  Use this with the draw interaction and
	 * `type: 'Circle'` to return a box instead of a circle geometry.
	 * @return {GeometryFunction} Function that draws a box-shaped polygon.
	 * @api
	 */
	function createBox() {
	  return (
	    function(coordinates, opt_geometry) {
	      var extent = boundingExtent(/** @type {LineCoordType} */ (coordinates));
	      var boxCoordinates = [[
	        getBottomLeft(extent),
	        getBottomRight(extent),
	        getTopRight(extent),
	        getTopLeft(extent),
	        getBottomLeft(extent)
	      ]];
	      var geometry = opt_geometry;
	      if (geometry) {
	        geometry.setCoordinates(boxCoordinates);
	      } else {
	        geometry = new Polygon(boxCoordinates);
	      }
	      return geometry;
	    }
	  );
	}
	
	
	/**
	 * Get the drawing mode.  The mode for mult-part geometries is the same as for
	 * their single-part cousins.
	 * @param {GeometryType} type Geometry type.
	 * @return {Mode} Drawing mode.
	 */
	function getMode(type) {
	  var mode;
	  if (type === GeometryType.POINT ||
	      type === GeometryType.MULTI_POINT) {
	    mode = Mode$1.POINT;
	  } else if (type === GeometryType.LINE_STRING ||
	      type === GeometryType.MULTI_LINE_STRING) {
	    mode = Mode$1.LINE_STRING;
	  } else if (type === GeometryType.POLYGON ||
	      type === GeometryType.MULTI_POLYGON) {
	    mode = Mode$1.POLYGON;
	  } else if (type === GeometryType.CIRCLE) {
	    mode = Mode$1.CIRCLE;
	  }
	  return (
	    /** @type {!Mode} */ (mode)
	  );
	}
	
	/**
	 * @module ol/interaction/Extent
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../extent.js").Extent} [extent] Initial extent. Defaults to no
	 * initial extent.
	 * @property {import("../style/Style.js").StyleLike} [boxStyle]
	 * Style for the drawn extent box. Defaults to
	 * {@link module:ol/style/Style~createEditing()['Polygon']}
	 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
	 * pointer close enough to a segment or vertex for editing.
	 * @property {import("../style/Style.js").StyleLike} [pointerStyle]
	 * Style for the cursor used to draw the extent. Defaults to
	 * {@link module:ol/style/Style~createEditing()['Point']}
	 * @property {boolean} [wrapX=false] Wrap the drawn extent across multiple maps
	 * in the X direction? Only affects visuals, not functionality.
	 */
	
	
	/**
	 * @enum {string}
	 */
	var ExtentEventType = {
	  /**
	   * Triggered after the extent is changed
	   * @event ExtentEventType#extentchanged
	   * @api
	   */
	  EXTENTCHANGED: 'extentchanged'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/Extent~ExtentInteraction} instances are
	 * instances of this type.
	 */
	var ExtentInteractionEvent = /*@__PURE__*/(function (Event$$1) {
	  function ExtentInteractionEvent(extent) {
	    Event$$1.call(this, ExtentEventType.EXTENTCHANGED);
	
	    /**
	     * The current extent.
	     * @type {import("../extent.js").Extent}
	     * @api
	     */
	    this.extent = extent;
	  }
	
	  if ( Event$$1 ) { ExtentInteractionEvent.__proto__ = Event$$1; }
	  ExtentInteractionEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  ExtentInteractionEvent.prototype.constructor = ExtentInteractionEvent;
	
	  return ExtentInteractionEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Allows the user to draw a vector box by clicking and dragging on the map.
	 * Once drawn, the vector box can be modified by dragging its vertices or edges.
	 * This interaction is only supported for mouse devices.
	 *
	 * @fires Event
	 * @api
	 */
	var ExtentInteraction = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function ExtentInteraction(opt_options) {
	
	    var options = opt_options || {};
	
	    PointerInteraction$$1.call(/** @type {import("./Pointer.js").Options} */ this, (options));
	
	    /**
	     * Extent of the drawn box
	     * @type {import("../extent.js").Extent}
	     * @private
	     */
	    this.extent_ = null;
	
	    /**
	     * Handler for pointer move events
	     * @type {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent|null}
	     * @private
	     */
	    this.pointerHandler_ = null;
	
	    /**
	     * Pixel threshold to snap to extent
	     * @type {number}
	     * @private
	     */
	    this.pixelTolerance_ = options.pixelTolerance !== undefined ?
	      options.pixelTolerance : 10;
	
	    /**
	     * Is the pointer snapped to an extent vertex
	     * @type {boolean}
	     * @private
	     */
	    this.snappedToVertex_ = false;
	
	    /**
	     * Feature for displaying the visible extent
	     * @type {Feature}
	     * @private
	     */
	    this.extentFeature_ = null;
	
	    /**
	     * Feature for displaying the visible pointer
	     * @type {Feature}
	     * @private
	     */
	    this.vertexFeature_ = null;
	
	    if (!opt_options) {
	      opt_options = {};
	    }
	
	    /**
	     * Layer for the extentFeature
	     * @type {VectorLayer}
	     * @private
	     */
	    this.extentOverlay_ = new VectorLayer({
	      source: new VectorSource({
	        useSpatialIndex: false,
	        wrapX: !!opt_options.wrapX
	      }),
	      style: opt_options.boxStyle ? opt_options.boxStyle : getDefaultExtentStyleFunction(),
	      updateWhileAnimating: true,
	      updateWhileInteracting: true
	    });
	
	    /**
	     * Layer for the vertexFeature
	     * @type {VectorLayer}
	     * @private
	     */
	    this.vertexOverlay_ = new VectorLayer({
	      source: new VectorSource({
	        useSpatialIndex: false,
	        wrapX: !!opt_options.wrapX
	      }),
	      style: opt_options.pointerStyle ? opt_options.pointerStyle : getDefaultPointerStyleFunction(),
	      updateWhileAnimating: true,
	      updateWhileInteracting: true
	    });
	
	    if (opt_options.extent) {
	      this.setExtent(opt_options.extent);
	    }
	  }
	
	  if ( PointerInteraction$$1 ) { ExtentInteraction.__proto__ = PointerInteraction$$1; }
	  ExtentInteraction.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  ExtentInteraction.prototype.constructor = ExtentInteraction;
	
	  /**
	   * @param {import("../pixel.js").Pixel} pixel cursor location
	   * @param {import("../PluggableMap.js").default} map map
	   * @returns {import("../coordinate.js").Coordinate|null} snapped vertex on extent
	   * @private
	   */
	  ExtentInteraction.prototype.snapToVertex_ = function snapToVertex_ (pixel, map) {
	    var pixelCoordinate = map.getCoordinateFromPixel(pixel);
	    var sortByDistance = function(a, b) {
	      return squaredDistanceToSegment(pixelCoordinate, a) -
	          squaredDistanceToSegment(pixelCoordinate, b);
	    };
	    var extent = this.getExtent();
	    if (extent) {
	      //convert extents to line segments and find the segment closest to pixelCoordinate
	      var segments = getSegments(extent);
	      segments.sort(sortByDistance);
	      var closestSegment = segments[0];
	
	      var vertex = (closestOnSegment(pixelCoordinate,
	        closestSegment));
	      var vertexPixel = map.getPixelFromCoordinate(vertex);
	
	      //if the distance is within tolerance, snap to the segment
	      if (distance(pixel, vertexPixel) <= this.pixelTolerance_) {
	        //test if we should further snap to a vertex
	        var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
	        var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
	        var squaredDist1 = squaredDistance$1(vertexPixel, pixel1);
	        var squaredDist2 = squaredDistance$1(vertexPixel, pixel2);
	        var dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
	        this.snappedToVertex_ = dist <= this.pixelTolerance_;
	        if (this.snappedToVertex_) {
	          vertex = squaredDist1 > squaredDist2 ?
	            closestSegment[1] : closestSegment[0];
	        }
	        return vertex;
	      }
	    }
	    return null;
	  };
	
	  /**
	   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent pointer move event
	   * @private
	   */
	  ExtentInteraction.prototype.handlePointerMove_ = function handlePointerMove_ (mapBrowserEvent) {
	    var pixel = mapBrowserEvent.pixel;
	    var map = mapBrowserEvent.map;
	
	    var vertex = this.snapToVertex_(pixel, map);
	    if (!vertex) {
	      vertex = map.getCoordinateFromPixel(pixel);
	    }
	    this.createOrUpdatePointerFeature_(vertex);
	  };
	
	  /**
	   * @param {import("../extent.js").Extent} extent extent
	   * @returns {Feature} extent as featrue
	   * @private
	   */
	  ExtentInteraction.prototype.createOrUpdateExtentFeature_ = function createOrUpdateExtentFeature_ (extent) {
	    var extentFeature = this.extentFeature_;
	
	    if (!extentFeature) {
	      if (!extent) {
	        extentFeature = new Feature({});
	      } else {
	        extentFeature = new Feature(fromExtent(extent));
	      }
	      this.extentFeature_ = extentFeature;
	      /** @type {VectorSource} */ (this.extentOverlay_.getSource()).addFeature(extentFeature);
	    } else {
	      if (!extent) {
	        extentFeature.setGeometry(undefined);
	      } else {
	        extentFeature.setGeometry(fromExtent(extent));
	      }
	    }
	    return extentFeature;
	  };
	
	  /**
	   * @param {import("../coordinate.js").Coordinate} vertex location of feature
	   * @returns {Feature} vertex as feature
	   * @private
	   */
	  ExtentInteraction.prototype.createOrUpdatePointerFeature_ = function createOrUpdatePointerFeature_ (vertex) {
	    var vertexFeature = this.vertexFeature_;
	    if (!vertexFeature) {
	      vertexFeature = new Feature(new Point(vertex));
	      this.vertexFeature_ = vertexFeature;
	      /** @type {VectorSource} */ (this.vertexOverlay_.getSource()).addFeature(vertexFeature);
	    } else {
	      var geometry = /** @type {Point} */ (vertexFeature.getGeometry());
	      geometry.setCoordinates(vertex);
	    }
	    return vertexFeature;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ExtentInteraction.prototype.handleEvent = function handleEvent (mapBrowserEvent) {
	    if (!(/** @type {import("../MapBrowserPointerEvent.js").default} */ (mapBrowserEvent).pointerEvent)) {
	      return true;
	    }
	    //display pointer (if not dragging)
	    if (mapBrowserEvent.type == MapBrowserEventType.POINTERMOVE && !this.handlingDownUpSequence) {
	      this.handlePointerMove_(mapBrowserEvent);
	    }
	    //call pointer to determine up/down/drag
	    PointerInteraction$$1.prototype.handleEvent.call(this, mapBrowserEvent);
	    //return false to stop propagation
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ExtentInteraction.prototype.handleDownEvent = function handleDownEvent (mapBrowserEvent) {
	    var pixel = mapBrowserEvent.pixel;
	    var map = mapBrowserEvent.map;
	
	    var extent = this.getExtent();
	    var vertex = this.snapToVertex_(pixel, map);
	
	    //find the extent corner opposite the passed corner
	    var getOpposingPoint = function(point) {
	      var x_ = null;
	      var y_ = null;
	      if (point[0] == extent[0]) {
	        x_ = extent[2];
	      } else if (point[0] == extent[2]) {
	        x_ = extent[0];
	      }
	      if (point[1] == extent[1]) {
	        y_ = extent[3];
	      } else if (point[1] == extent[3]) {
	        y_ = extent[1];
	      }
	      if (x_ !== null && y_ !== null) {
	        return [x_, y_];
	      }
	      return null;
	    };
	    if (vertex && extent) {
	      var x = (vertex[0] == extent[0] || vertex[0] == extent[2]) ? vertex[0] : null;
	      var y = (vertex[1] == extent[1] || vertex[1] == extent[3]) ? vertex[1] : null;
	
	      //snap to point
	      if (x !== null && y !== null) {
	        this.pointerHandler_ = getPointHandler(getOpposingPoint(vertex));
	      //snap to edge
	      } else if (x !== null) {
	        this.pointerHandler_ = getEdgeHandler(
	          getOpposingPoint([x, extent[1]]),
	          getOpposingPoint([x, extent[3]])
	        );
	      } else if (y !== null) {
	        this.pointerHandler_ = getEdgeHandler(
	          getOpposingPoint([extent[0], y]),
	          getOpposingPoint([extent[2], y])
	        );
	      }
	    //no snap - new bbox
	    } else {
	      vertex = map.getCoordinateFromPixel(pixel);
	      this.setExtent([vertex[0], vertex[1], vertex[0], vertex[1]]);
	      this.pointerHandler_ = getPointHandler(vertex);
	    }
	    return true; //event handled; start downup sequence
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ExtentInteraction.prototype.handleDragEvent = function handleDragEvent (mapBrowserEvent) {
	    if (this.pointerHandler_) {
	      var pixelCoordinate = mapBrowserEvent.coordinate;
	      this.setExtent(this.pointerHandler_(pixelCoordinate));
	      this.createOrUpdatePointerFeature_(pixelCoordinate);
	    }
	    return true;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ExtentInteraction.prototype.handleUpEvent = function handleUpEvent (mapBrowserEvent) {
	    this.pointerHandler_ = null;
	    //If bbox is zero area, set to null;
	    var extent = this.getExtent();
	    if (!extent || getArea(extent) === 0) {
	      this.setExtent(null);
	    }
	    return false; //Stop handling downup sequence
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ExtentInteraction.prototype.setMap = function setMap (map) {
	    this.extentOverlay_.setMap(map);
	    this.vertexOverlay_.setMap(map);
	    PointerInteraction$$1.prototype.setMap.call(this, map);
	  };
	
	  /**
	   * Returns the current drawn extent in the view projection
	   *
	   * @return {import("../extent.js").Extent} Drawn extent in the view projection.
	   * @api
	   */
	  ExtentInteraction.prototype.getExtent = function getExtent () {
	    return this.extent_;
	  };
	
	  /**
	   * Manually sets the drawn extent, using the view projection.
	   *
	   * @param {import("../extent.js").Extent} extent Extent
	   * @api
	   */
	  ExtentInteraction.prototype.setExtent = function setExtent (extent) {
	    //Null extent means no bbox
	    this.extent_ = extent ? extent : null;
	    this.createOrUpdateExtentFeature_(extent);
	    this.dispatchEvent(new ExtentInteractionEvent(this.extent_));
	  };
	
	  return ExtentInteraction;
	}(PointerInteraction));
	
	/**
	 * Returns the default style for the drawn bbox
	 *
	 * @return {import("../style/Style.js").StyleFunction} Default Extent style
	 */
	function getDefaultExtentStyleFunction() {
	  var style = createEditingStyle();
	  return function(feature, resolution) {
	    return style[GeometryType.POLYGON];
	  };
	}
	
	/**
	 * Returns the default style for the pointer
	 *
	 * @return {import("../style/Style.js").StyleFunction} Default pointer style
	 */
	function getDefaultPointerStyleFunction() {
	  var style = createEditingStyle();
	  return function(feature, resolution) {
	    return style[GeometryType.POINT];
	  };
	}
	
	/**
	 * @param {import("../coordinate.js").Coordinate} fixedPoint corner that will be unchanged in the new extent
	 * @returns {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent} event handler
	 */
	function getPointHandler(fixedPoint) {
	  return function(point) {
	    return boundingExtent([fixedPoint, point]);
	  };
	}
	
	/**
	 * @param {import("../coordinate.js").Coordinate} fixedP1 first corner that will be unchanged in the new extent
	 * @param {import("../coordinate.js").Coordinate} fixedP2 second corner that will be unchanged in the new extent
	 * @returns {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent|null} event handler
	 */
	function getEdgeHandler(fixedP1, fixedP2) {
	  if (fixedP1[0] == fixedP2[0]) {
	    return function(point) {
	      return boundingExtent([fixedP1, [point[0], fixedP2[1]]]);
	    };
	  } else if (fixedP1[1] == fixedP2[1]) {
	    return function(point) {
	      return boundingExtent([fixedP1, [fixedP2[0], point[1]]]);
	    };
	  } else {
	    return null;
	  }
	}
	
	/**
	 * @param {import("../extent.js").Extent} extent extent
	 * @returns {Array<Array<import("../coordinate.js").Coordinate>>} extent line segments
	 */
	function getSegments(extent) {
	  return [
	    [[extent[0], extent[1]], [extent[0], extent[3]]],
	    [[extent[0], extent[3]], [extent[2], extent[3]]],
	    [[extent[2], extent[3]], [extent[2], extent[1]]],
	    [[extent[2], extent[1]], [extent[0], extent[1]]]
	  ];
	}
	
	/**
	 * @module ol/interaction/Modify
	 */
	
	
	/**
	 * The segment index assigned to a circle's center when
	 * breaking up a circle into ModifySegmentDataType segments.
	 * @type {number}
	 */
	var CIRCLE_CENTER_INDEX = 0;
	
	/**
	 * The segment index assigned to a circle's circumference when
	 * breaking up a circle into ModifySegmentDataType segments.
	 * @type {number}
	 */
	var CIRCLE_CIRCUMFERENCE_INDEX = 1;
	
	
	/**
	 * @enum {string}
	 */
	var ModifyEventType = {
	  /**
	   * Triggered upon feature modification start
	   * @event ModifyEvent#modifystart
	   * @api
	   */
	  MODIFYSTART: 'modifystart',
	  /**
	   * Triggered upon feature modification end
	   * @event ModifyEvent#modifyend
	   * @api
	   */
	  MODIFYEND: 'modifyend'
	};
	
	
	/**
	 * @typedef {Object} SegmentData
	 * @property {Array<number>} [depth]
	 * @property {Feature} feature
	 * @property {import("../geom/SimpleGeometry.js").default} geometry
	 * @property {number} [index]
	 * @property {Array<import("../extent.js").Extent>} segment
	 * @property {Array<SegmentData>} [featureSegments]
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event will be considered to add or move a
	 * vertex to the sketch. Default is
	 * {@link module:ol/events/condition~primaryAction}.
	 * @property {import("../events/condition.js").Condition} [deleteCondition] A function
	 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled. By default,
	 * {@link module:ol/events/condition~singleClick} with
	 * {@link module:ol/events/condition~altKeyOnly} results in a vertex deletion.
	 * @property {import("../events/condition.js").Condition} [insertVertexCondition] A
	 * function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
	 * returns a boolean to indicate whether a new vertex can be added to the sketch
	 * features. Default is {@link module:ol/events/condition~always}.
	 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
	 * pointer close enough to a segment or vertex for editing.
	 * @property {import("../style/Style.js").StyleLike} [style]
	 * Style used for the features being modified. By default the default edit
	 * style is used (see {@link module:ol/style}).
	 * @property {VectorSource} [source] The vector source with
	 * features to modify.  If a vector source is not provided, a feature collection
	 * must be provided with the features option.
	 * @property {Collection<Feature>} [features]
	 * The features the interaction works on.  If a feature collection is not
	 * provided, a vector source must be provided with the source option.
	 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
	 * overlay.
	 */
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/Modify~Modify} instances are
	 * instances of this type.
	 */
	var ModifyEvent = /*@__PURE__*/(function (Event$$1) {
	  function ModifyEvent(type, features, mapBrowserPointerEvent) {
	    Event$$1.call(this, type);
	
	    /**
	     * The features being modified.
	     * @type {Collection<Feature>}
	     * @api
	     */
	    this.features = features;
	
	    /**
	     * Associated {@link module:ol/MapBrowserEvent}.
	     * @type {import("../MapBrowserEvent.js").default}
	     * @api
	     */
	    this.mapBrowserEvent = mapBrowserPointerEvent;
	
	  }
	
	  if ( Event$$1 ) { ModifyEvent.__proto__ = Event$$1; }
	  ModifyEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  ModifyEvent.prototype.constructor = ModifyEvent;
	
	  return ModifyEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Interaction for modifying feature geometries.  To modify features that have
	 * been added to an existing source, construct the modify interaction with the
	 * `source` option.  If you want to modify features in a collection (for example,
	 * the collection used by a select interaction), construct the interaction with
	 * the `features` option.  The interaction must be constructed with either a
	 * `source` or `features` option.
	 *
	 * By default, the interaction will allow deletion of vertices when the `alt`
	 * key is pressed.  To configure the interaction with a different condition
	 * for deletion, use the `deleteCondition` option.
	 * @fires ModifyEvent
	 * @api
	 */
	var Modify = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function Modify(options) {
	
	    PointerInteraction$$1.call(/** @type {import("./Pointer.js").Options} */ this, (options));
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : primaryAction;
	
	    /**
	     * @private
	     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
	     * @return {boolean} Combined condition result.
	     */
	    this.defaultDeleteCondition_ = function(mapBrowserEvent) {
	      return altKeyOnly(mapBrowserEvent) && singleClick(mapBrowserEvent);
	    };
	
	    /**
	     * @type {import("../events/condition.js").Condition}
	     * @private
	     */
	    this.deleteCondition_ = options.deleteCondition ?
	      options.deleteCondition : this.defaultDeleteCondition_;
	
	    /**
	     * @type {import("../events/condition.js").Condition}
	     * @private
	     */
	    this.insertVertexCondition_ = options.insertVertexCondition ?
	      options.insertVertexCondition : always;
	
	    /**
	     * Editing vertex.
	     * @type {Feature}
	     * @private
	     */
	    this.vertexFeature_ = null;
	
	    /**
	     * Segments intersecting {@link this.vertexFeature_} by segment uid.
	     * @type {Object<string, boolean>}
	     * @private
	     */
	    this.vertexSegments_ = null;
	
	    /**
	     * @type {import("../pixel.js").Pixel}
	     * @private
	     */
	    this.lastPixel_ = [0, 0];
	
	    /**
	     * Tracks if the next `singleclick` event should be ignored to prevent
	     * accidental deletion right after vertex creation.
	     * @type {boolean}
	     * @private
	     */
	    this.ignoreNextSingleClick_ = false;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.modified_ = false;
	
	    /**
	     * Segment RTree for each layer
	     * @type {RBush<SegmentData>}
	     * @private
	     */
	    this.rBush_ = new RBush();
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.pixelTolerance_ = options.pixelTolerance !== undefined ?
	      options.pixelTolerance : 10;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.snappedToVertex_ = false;
	
	    /**
	     * Indicate whether the interaction is currently changing a feature's
	     * coordinates.
	     * @type {boolean}
	     * @private
	     */
	    this.changingFeature_ = false;
	
	    /**
	     * @type {Array}
	     * @private
	     */
	    this.dragSegments_ = [];
	
	    /**
	     * Draw overlay where sketch features are drawn.
	     * @type {VectorLayer}
	     * @private
	     */
	    this.overlay_ = new VectorLayer({
	      source: new VectorSource({
	        useSpatialIndex: false,
	        wrapX: !!options.wrapX
	      }),
	      style: options.style ? options.style :
	        getDefaultStyleFunction$1(),
	      updateWhileAnimating: true,
	      updateWhileInteracting: true
	    });
	
	    /**
	     * @const
	     * @private
	     * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default)>}
	     */
	    this.SEGMENT_WRITERS_ = {
	      'Point': this.writePointGeometry_,
	      'LineString': this.writeLineStringGeometry_,
	      'LinearRing': this.writeLineStringGeometry_,
	      'Polygon': this.writePolygonGeometry_,
	      'MultiPoint': this.writeMultiPointGeometry_,
	      'MultiLineString': this.writeMultiLineStringGeometry_,
	      'MultiPolygon': this.writeMultiPolygonGeometry_,
	      'Circle': this.writeCircleGeometry_,
	      'GeometryCollection': this.writeGeometryCollectionGeometry_
	    };
	
	
	    /**
	     * @type {VectorSource}
	     * @private
	     */
	    this.source_ = null;
	
	    var features;
	    if (options.source) {
	      this.source_ = options.source;
	      features = new Collection(this.source_.getFeatures());
	      listen(this.source_, VectorEventType.ADDFEATURE,
	        this.handleSourceAdd_, this);
	      listen(this.source_, VectorEventType.REMOVEFEATURE,
	        this.handleSourceRemove_, this);
	    } else {
	      features = options.features;
	    }
	    if (!features) {
	      throw new Error('The modify interaction requires features or a source');
	    }
	
	    /**
	     * @type {Collection<Feature>}
	     * @private
	     */
	    this.features_ = features;
	
	    this.features_.forEach(this.addFeature_.bind(this));
	    listen(this.features_, CollectionEventType.ADD,
	      this.handleFeatureAdd_, this);
	    listen(this.features_, CollectionEventType.REMOVE,
	      this.handleFeatureRemove_, this);
	
	    /**
	     * @type {import("../MapBrowserPointerEvent.js").default}
	     * @private
	     */
	    this.lastPointerEvent_ = null;
	
	  }
	
	  if ( PointerInteraction$$1 ) { Modify.__proto__ = PointerInteraction$$1; }
	  Modify.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  Modify.prototype.constructor = Modify;
	
	  var staticAccessors = { closestOnSegmentData: { configurable: true },pointDistanceToSegmentDataSquared: { configurable: true },getDefaultStyleFunction: { configurable: true },Event: { configurable: true } };
	
	  /**
	   * @param {Feature} feature Feature.
	   * @private
	   */
	  staticAccessors.closestOnSegmentData.get = function () {
	    return closestOnSegmentData;
	  };
	
	  /* Экспорт для OMJS */
	  staticAccessors.pointDistanceToSegmentDataSquared.get = function () {
	    return pointDistanceToSegmentDataSquared;
	  };
	
	  /* Экспорт для OMJS */
	  staticAccessors.getDefaultStyleFunction.get = function () {
	    return getDefaultStyleFunction$1;
	  };
	
	  /* Экспорт для OMJS */
	  staticAccessors.Event.get = function () {
	    return ModifyEvent;
	  };
	
	  Modify.prototype.addFeature_ = function addFeature_ (feature) {
	    var geometry = feature.getGeometry();
	    if (geometry && geometry.getType() in this.SEGMENT_WRITERS_) {
	      this.SEGMENT_WRITERS_[geometry.getType()].call(this, feature, geometry);
	    }
	    var map = this.getMap();
	    if (map && map.isRendered() && this.getActive()) {
	      this.handlePointerAtPixel_(this.lastPixel_, map);
	    }
	    listen(feature, EventType.CHANGE,
	      this.handleFeatureChange_, this);
	  };
	
	  /**
	   * @param {import("../MapBrowserPointerEvent.js").default} evt Map browser event
	   * @private
	   */
	  Modify.prototype.willModifyFeatures_ = function willModifyFeatures_ (evt) {
	    if (!this.modified_) {
	      this.modified_ = true;
	      this.dispatchEvent(new ModifyEvent(
	        ModifyEventType.MODIFYSTART, this.features_, evt));
	    }
	  };
	
	  /**
	   * @param {Feature} feature Feature.
	   * @private
	   */
	  Modify.prototype.removeFeature_ = function removeFeature_ (feature) {
	    this.removeFeatureSegmentData_(feature);
	    // Remove the vertex feature if the collection of canditate features
	    // is empty.
	    if (this.vertexFeature_ && this.features_.getLength() === 0) {
	      /** @type {VectorSource} */ (this.overlay_.getSource()).removeFeature(this.vertexFeature_);
	      this.vertexFeature_ = null;
	    }
	    unlisten(feature, EventType.CHANGE,
	      this.handleFeatureChange_, this);
	  };
	
	  /**
	   * @param {Feature} feature Feature.
	   * @private
	   */
	  Modify.prototype.removeFeatureSegmentData_ = function removeFeatureSegmentData_ (feature) {
	    var rBush = this.rBush_;
	    var /** @type {Array<SegmentData>} */ nodesToRemove = [];
	    rBush.forEach(
	      /**
	       * @param {SegmentData} node RTree node.
	       */
	      function(node) {
	        if (feature === node.feature) {
	          nodesToRemove.push(node);
	        }
	      });
	    for (var i = nodesToRemove.length - 1; i >= 0; --i) {
	      rBush.remove(nodesToRemove[i]);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Modify.prototype.setActive = function setActive (active) {
	    if (this.vertexFeature_ && !active) {
	      /** @type {VectorSource} */ (this.overlay_.getSource()).removeFeature(this.vertexFeature_);
	      this.vertexFeature_ = null;
	    }
	    PointerInteraction$$1.prototype.setActive.call(this, active);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Modify.prototype.setMap = function setMap (map) {
	    this.overlay_.setMap(map);
	    PointerInteraction$$1.prototype.setMap.call(this, map);
	  };
	
	  /**
	   * Get the overlay layer that this interaction renders sketch features to.
	   * @return {VectorLayer} Overlay layer.
	   * @api
	   */
	  Modify.prototype.getOverlay = function getOverlay () {
	    return this.overlay_;
	  };
	
	  /**
	   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
	   * @private
	   */
	  Modify.prototype.handleSourceAdd_ = function handleSourceAdd_ (event) {
	    if (event.feature) {
	      this.features_.push(event.feature);
	    }
	  };
	
	  /**
	   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
	   * @private
	   */
	  Modify.prototype.handleSourceRemove_ = function handleSourceRemove_ (event) {
	    if (event.feature) {
	      this.features_.remove(event.feature);
	    }
	  };
	
	  /**
	   * @param {import("../Collection.js").CollectionEvent} evt Event.
	   * @private
	   */
	  Modify.prototype.handleFeatureAdd_ = function handleFeatureAdd_ (evt) {
	    this.addFeature_(/** @type {Feature} */ (evt.element));
	  };
	
	  /**
	   * @param {import("../events/Event.js").default} evt Event.
	   * @private
	   */
	  Modify.prototype.handleFeatureChange_ = function handleFeatureChange_ (evt) {
	    if (!this.changingFeature_) {
	      var feature = /** @type {Feature} */ (evt.target);
	      this.removeFeature_(feature);
	      this.addFeature_(feature);
	    }
	  };
	
	  /**
	   * @param {import("../Collection.js").CollectionEvent} evt Event.
	   * @private
	   */
	  Modify.prototype.handleFeatureRemove_ = function handleFeatureRemove_ (evt) {
	    var feature = /** @type {Feature} */ (evt.element);
	    this.removeFeature_(feature);
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {Point} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writePointGeometry_ = function writePointGeometry_ (feature, geometry) {
	    var coordinates = geometry.getCoordinates();
	    var segmentData = /** @type {SegmentData} */ ({
	      feature: feature,
	      geometry: geometry,
	      segment: [coordinates, coordinates]
	    });
	    this.rBush_.insert(geometry.getExtent(), segmentData);
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writeMultiPointGeometry_ = function writeMultiPointGeometry_ (feature, geometry) {
	    var points = geometry.getCoordinates();
	    for (var i = 0, ii = points.length; i < ii; ++i) {
	      var coordinates = points[i];
	      var segmentData = /** @type {SegmentData} */ ({
	        feature: feature,
	        geometry: geometry,
	        depth: [i],
	        index: i,
	        segment: [coordinates, coordinates]
	      });
	      this.rBush_.insert(geometry.getExtent(), segmentData);
	    }
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {import("../geom/LineString.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writeLineStringGeometry_ = function writeLineStringGeometry_ (feature, geometry) {
	    var coordinates = geometry.getCoordinates();
	    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	      var segment = coordinates.slice(i, i + 2);
	      var segmentData = /** @type {SegmentData} */ ({
	        feature: feature,
	        geometry: geometry,
	        index: i,
	        segment: segment
	      });
	      this.rBush_.insert(boundingExtent(segment), segmentData);
	    }
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writeMultiLineStringGeometry_ = function writeMultiLineStringGeometry_ (feature, geometry) {
	    var lines = geometry.getCoordinates();
	    for (var j = 0, jj = lines.length; j < jj; ++j) {
	      var coordinates = lines[j];
	      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	        var segment = coordinates.slice(i, i + 2);
	        var segmentData = /** @type {SegmentData} */ ({
	          feature: feature,
	          geometry: geometry,
	          depth: [j],
	          index: i,
	          segment: segment
	        });
	        this.rBush_.insert(boundingExtent(segment), segmentData);
	      }
	    }
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {import("../geom/Polygon.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writePolygonGeometry_ = function writePolygonGeometry_ (feature, geometry) {
	    var rings = geometry.getCoordinates();
	    for (var j = 0, jj = rings.length; j < jj; ++j) {
	      var coordinates = rings[j];
	      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	        var segment = coordinates.slice(i, i + 2);
	        var segmentData = /** @type {SegmentData} */ ({
	          feature: feature,
	          geometry: geometry,
	          depth: [j],
	          index: i,
	          segment: segment
	        });
	        this.rBush_.insert(boundingExtent(segment), segmentData);
	      }
	    }
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writeMultiPolygonGeometry_ = function writeMultiPolygonGeometry_ (feature, geometry) {
	    var polygons = geometry.getCoordinates();
	    for (var k = 0, kk = polygons.length; k < kk; ++k) {
	      var rings = polygons[k];
	      for (var j = 0, jj = rings.length; j < jj; ++j) {
	        var coordinates = rings[j];
	        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	          var segment = coordinates.slice(i, i + 2);
	          var segmentData = /** @type {SegmentData} */ ({
	            feature: feature,
	            geometry: geometry,
	            depth: [j, k],
	            index: i,
	            segment: segment
	          });
	          this.rBush_.insert(boundingExtent(segment), segmentData);
	        }
	      }
	    }
	  };
	
	  /**
	   * We convert a circle into two segments.  The segment at index
	   * {@link CIRCLE_CENTER_INDEX} is the
	   * circle's center (a point).  The segment at index
	   * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
	   * the circumference, and is not a line segment.
	   *
	   * @param {Feature} feature Feature.
	   * @param {import("../geom/Circle.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writeCircleGeometry_ = function writeCircleGeometry_ (feature, geometry) {
	    var coordinates = geometry.getCenter();
	    var centerSegmentData = /** @type {SegmentData} */ ({
	      feature: feature,
	      geometry: geometry,
	      index: CIRCLE_CENTER_INDEX,
	      segment: [coordinates, coordinates]
	    });
	    var circumferenceSegmentData = /** @type {SegmentData} */ ({
	      feature: feature,
	      geometry: geometry,
	      index: CIRCLE_CIRCUMFERENCE_INDEX,
	      segment: [coordinates, coordinates]
	    });
	    var featureSegments = [centerSegmentData, circumferenceSegmentData];
	    centerSegmentData.featureSegments = circumferenceSegmentData.featureSegments = featureSegments;
	    this.rBush_.insert(createOrUpdateFromCoordinate(coordinates), centerSegmentData);
	    this.rBush_.insert(geometry.getExtent(), circumferenceSegmentData);
	  };
	
	  /**
	   * @param {Feature} feature Feature
	   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
	   * @private
	   */
	  Modify.prototype.writeGeometryCollectionGeometry_ = function writeGeometryCollectionGeometry_ (feature, geometry) {
	    var geometries = geometry.getGeometriesArray();
	    for (var i = 0; i < geometries.length; ++i) {
	      this.SEGMENT_WRITERS_[geometries[i].getType()].call(this, feature, geometries[i]);
	    }
	  };
	
	  /**
	   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
	   * @return {Feature} Vertex feature.
	   * @private
	   */
	  Modify.prototype.createOrUpdateVertexFeature_ = function createOrUpdateVertexFeature_ (coordinates) {
	    var vertexFeature = this.vertexFeature_;
	    if (!vertexFeature) {
	      vertexFeature = new Feature(new Point(coordinates));
	      this.vertexFeature_ = vertexFeature;
	      /** @type {VectorSource} */ (this.overlay_.getSource()).addFeature(vertexFeature);
	    } else {
	      var geometry = /** @type {Point} */ (vertexFeature.getGeometry());
	      geometry.setCoordinates(coordinates);
	    }
	    return vertexFeature;
	  };
	
	  /**
	   * Handles the {@link module:ol/MapBrowserEvent map browser event} and may modify the geometry.
	   * @override
	   */
	  Modify.prototype.handleEvent = function handleEvent (mapBrowserEvent) {
	    if (!(/** @type {import("../MapBrowserPointerEvent.js").default} */ (mapBrowserEvent).pointerEvent)) {
	      return true;
	    }
	    this.lastPointerEvent_ = mapBrowserEvent;
	
	    var handled;
	    if (!mapBrowserEvent.map.getView().getInteracting() &&
	        mapBrowserEvent.type == MapBrowserEventType.POINTERMOVE &&
	        !this.handlingDownUpSequence) {
	      this.handlePointerMove_(mapBrowserEvent);
	    }
	    if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
	      if (mapBrowserEvent.type != MapBrowserEventType.SINGLECLICK || !this.ignoreNextSingleClick_) {
	        handled = this.removePoint();
	      } else {
	        handled = true;
	      }
	    }
	
	    if (mapBrowserEvent.type == MapBrowserEventType.SINGLECLICK) {
	      this.ignoreNextSingleClick_ = false;
	    }
	
	    return PointerInteraction$$1.prototype.handleEvent.call(this, mapBrowserEvent) && !handled;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Modify.prototype.handleDragEvent = function handleDragEvent (evt) {
	    this.ignoreNextSingleClick_ = false;
	    this.willModifyFeatures_(evt);
	
	    var vertex = evt.coordinate;
	    for (var i = 0, ii = this.dragSegments_.length; i < ii; ++i) {
	      var dragSegment = this.dragSegments_[i];
	      var segmentData = dragSegment[0];
	      var depth = segmentData.depth;
	      var geometry = segmentData.geometry;
	      var coordinates = (void 0);
	      var segment = segmentData.segment;
	      var index = dragSegment[1];
	
	      while (vertex.length < geometry.getStride()) {
	        vertex.push(segment[index][vertex.length]);
	      }
	
	      switch (geometry.getType()) {
	        case GeometryType.POINT:
	          coordinates = vertex;
	          segment[0] = segment[1] = vertex;
	          break;
	        case GeometryType.MULTI_POINT:
	          coordinates = geometry.getCoordinates();
	          coordinates[segmentData.index] = vertex;
	          segment[0] = segment[1] = vertex;
	          break;
	        case GeometryType.LINE_STRING:
	          coordinates = geometry.getCoordinates();
	          coordinates[segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case GeometryType.MULTI_LINE_STRING:
	          coordinates = geometry.getCoordinates();
	          coordinates[depth[0]][segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case GeometryType.POLYGON:
	          coordinates = geometry.getCoordinates();
	          coordinates[depth[0]][segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case GeometryType.MULTI_POLYGON:
	          coordinates = geometry.getCoordinates();
	          coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case GeometryType.CIRCLE:
	          segment[0] = segment[1] = vertex;
	          if (segmentData.index === CIRCLE_CENTER_INDEX) {
	            this.changingFeature_ = true;
	            geometry.setCenter(vertex);
	            this.changingFeature_ = false;
	          } else { // We're dragging the circle's circumference:
	            this.changingFeature_ = true;
	            geometry.setRadius(distance(geometry.getCenter(), vertex));
	            this.changingFeature_ = false;
	          }
	          break;
	        default:
	          // pass
	      }
	
	      if (coordinates) {
	        this.setGeometryCoordinates_(geometry, coordinates);
	      }
	    }
	    this.createOrUpdateVertexFeature_(vertex);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Modify.prototype.handleDownEvent = function handleDownEvent (evt) {
	    if (!this.condition_(evt)) {
	      return false;
	    }
	    this.handlePointerAtPixel_(evt.pixel, evt.map);
	    var pixelCoordinate = evt.map.getCoordinateFromPixel(evt.pixel);
	    this.dragSegments_.length = 0;
	    this.modified_ = false;
	    var vertexFeature = this.vertexFeature_;
	    if (vertexFeature) {
	      var insertVertices = [];
	      var geometry = /** @type {Point} */ (vertexFeature.getGeometry());
	      var vertex = geometry.getCoordinates();
	      var vertexExtent = boundingExtent([vertex]);
	      var segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
	      var componentSegments = {};
	      segmentDataMatches.sort(compareIndexes);
	      for (var i = 0, ii = segmentDataMatches.length; i < ii; ++i) {
	        var segmentDataMatch = segmentDataMatches[i];
	        var segment = segmentDataMatch.segment;
	        var uid = getUid(segmentDataMatch.feature);
	        var depth = segmentDataMatch.depth;
	        if (depth) {
	          uid += '-' + depth.join('-'); // separate feature components
	        }
	        if (!componentSegments[uid]) {
	          componentSegments[uid] = new Array(2);
	        }
	        if (segmentDataMatch.geometry.getType() === GeometryType.CIRCLE &&
	        segmentDataMatch.index === CIRCLE_CIRCUMFERENCE_INDEX) {
	
	          var closestVertex = closestOnSegmentData(pixelCoordinate, segmentDataMatch);
	          if (equals$2(closestVertex, vertex) && !componentSegments[uid][0]) {
	            this.dragSegments_.push([segmentDataMatch, 0]);
	            componentSegments[uid][0] = segmentDataMatch;
	          }
	        } else if (equals$2(segment[0], vertex) &&
	            !componentSegments[uid][0]) {
	          this.dragSegments_.push([segmentDataMatch, 0]);
	          componentSegments[uid][0] = segmentDataMatch;
	        } else if (equals$2(segment[1], vertex) &&
	            !componentSegments[uid][1]) {
	
	          // prevent dragging closed linestrings by the connecting node
	          if ((segmentDataMatch.geometry.getType() ===
	              GeometryType.LINE_STRING ||
	              segmentDataMatch.geometry.getType() ===
	              GeometryType.MULTI_LINE_STRING) &&
	              componentSegments[uid][0] &&
	              componentSegments[uid][0].index === 0) {
	            continue;
	          }
	
	          this.dragSegments_.push([segmentDataMatch, 1]);
	          componentSegments[uid][1] = segmentDataMatch;
	        } else if (this.insertVertexCondition_(evt) && getUid(segment) in this.vertexSegments_ &&
	            (!componentSegments[uid][0] && !componentSegments[uid][1])) {
	          insertVertices.push([segmentDataMatch, vertex]);
	        }
	      }
	      if (insertVertices.length) {
	        this.willModifyFeatures_(evt);
	      }
	      for (var j = insertVertices.length - 1; j >= 0; --j) {
	        this.insertVertex_.apply(this, insertVertices[j]);
	      }
	    }
	    return !!this.vertexFeature_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Modify.prototype.handleUpEvent = function handleUpEvent (evt) {
	    for (var i = this.dragSegments_.length - 1; i >= 0; --i) {
	      var segmentData = this.dragSegments_[i][0];
	      var geometry = segmentData.geometry;
	      if (geometry.getType() === GeometryType.CIRCLE) {
	        // Update a circle object in the R* bush:
	        var coordinates = geometry.getCenter();
	        var centerSegmentData = segmentData.featureSegments[0];
	        var circumferenceSegmentData = segmentData.featureSegments[1];
	        centerSegmentData.segment[0] = centerSegmentData.segment[1] = coordinates;
	        circumferenceSegmentData.segment[0] = circumferenceSegmentData.segment[1] = coordinates;
	        this.rBush_.update(createOrUpdateFromCoordinate(coordinates), centerSegmentData);
	        this.rBush_.update(geometry.getExtent(), circumferenceSegmentData);
	      } else {
	        this.rBush_.update(boundingExtent(segmentData.segment), segmentData);
	      }
	    }
	    if (this.modified_) {
	      this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYEND, this.features_, evt));
	      this.modified_ = false;
	    }
	    return false;
	  };
	
	  /**
	   * @param {import("../MapBrowserEvent.js").default} evt Event.
	   * @private
	   */
	  Modify.prototype.handlePointerMove_ = function handlePointerMove_ (evt) {
	    this.lastPixel_ = evt.pixel;
	    this.handlePointerAtPixel_(evt.pixel, evt.map);
	  };
	
	  /**
	   * @param {import("../pixel.js").Pixel} pixel Pixel
	   * @param {import("../PluggableMap.js").default} map Map.
	   * @private
	   */
	  Modify.prototype.handlePointerAtPixel_ = function handlePointerAtPixel_ (pixel, map) {
	    var pixelCoordinate = map.getCoordinateFromPixel(pixel);
	    var sortByDistance = function(a, b) {
	      return pointDistanceToSegmentDataSquared(pixelCoordinate, a) -
	          pointDistanceToSegmentDataSquared(pixelCoordinate, b);
	    };
	
	    var box = buffer(createOrUpdateFromCoordinate(pixelCoordinate),
	      map.getView().getResolution() * this.pixelTolerance_);
	
	    var rBush = this.rBush_;
	    var nodes = rBush.getInExtent(box);
	    if (nodes.length > 0) {
	      nodes.sort(sortByDistance);
	      var node = nodes[0];
	      var closestSegment = node.segment;
	      var vertex = closestOnSegmentData(pixelCoordinate, node);
	      var vertexPixel = map.getPixelFromCoordinate(vertex);
	      var dist = distance(pixel, vertexPixel);
	      if (dist <= this.pixelTolerance_) {
	        /** @type {Object<string, boolean>} */
	        var vertexSegments = {};
	
	        if (node.geometry.getType() === GeometryType.CIRCLE &&
	        node.index === CIRCLE_CIRCUMFERENCE_INDEX) {
	
	          this.snappedToVertex_ = true;
	          this.createOrUpdateVertexFeature_(vertex);
	        } else {
	          var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
	          var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
	          var squaredDist1 = squaredDistance$1(vertexPixel, pixel1);
	          var squaredDist2 = squaredDistance$1(vertexPixel, pixel2);
	          dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
	          this.snappedToVertex_ = dist <= this.pixelTolerance_;
	          if (this.snappedToVertex_) {
	            vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
	          }
	          this.createOrUpdateVertexFeature_(vertex);
	          for (var i = 1, ii = nodes.length; i < ii; ++i) {
	            var segment = nodes[i].segment;
	            if ((equals$2(closestSegment[0], segment[0]) &&
	                equals$2(closestSegment[1], segment[1]) ||
	                (equals$2(closestSegment[0], segment[1]) &&
	                equals$2(closestSegment[1], segment[0])))) {
	              vertexSegments[getUid(segment)] = true;
	            } else {
	              break;
	            }
	          }
	        }
	
	        vertexSegments[getUid(closestSegment)] = true;
	        this.vertexSegments_ = vertexSegments;
	        return;
	      }
	    }
	    if (this.vertexFeature_) {
	      /** @type {VectorSource} */ (this.overlay_.getSource()).removeFeature(this.vertexFeature_);
	      this.vertexFeature_ = null;
	    }
	  };
	
	  /**
	   * @param {SegmentData} segmentData Segment data.
	   * @param {import("../coordinate.js").Coordinate} vertex Vertex.
	   * @private
	   */
	  Modify.prototype.insertVertex_ = function insertVertex_ (segmentData, vertex) {
	    var segment = segmentData.segment;
	    var feature = segmentData.feature;
	    var geometry = segmentData.geometry;
	    var depth = segmentData.depth;
	    var index = /** @type {number} */ (segmentData.index);
	    var coordinates;
	
	    while (vertex.length < geometry.getStride()) {
	      vertex.push(0);
	    }
	
	    switch (geometry.getType()) {
	      case GeometryType.MULTI_LINE_STRING:
	        coordinates = geometry.getCoordinates();
	        coordinates[depth[0]].splice(index + 1, 0, vertex);
	        break;
	      case GeometryType.POLYGON:
	        coordinates = geometry.getCoordinates();
	        coordinates[depth[0]].splice(index + 1, 0, vertex);
	        break;
	      case GeometryType.MULTI_POLYGON:
	        coordinates = geometry.getCoordinates();
	        coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
	        break;
	      case GeometryType.LINE_STRING:
	        coordinates = geometry.getCoordinates();
	        coordinates.splice(index + 1, 0, vertex);
	        break;
	      default:
	        return;
	    }
	
	    this.setGeometryCoordinates_(geometry, coordinates);
	    var rTree = this.rBush_;
	    rTree.remove(segmentData);
	    this.updateSegmentIndices_(geometry, index, depth, 1);
	    var newSegmentData = /** @type {SegmentData} */ ({
	      segment: [segment[0], vertex],
	      feature: feature,
	      geometry: geometry,
	      depth: depth,
	      index: index
	    });
	    rTree.insert(boundingExtent(newSegmentData.segment),
	      newSegmentData);
	    this.dragSegments_.push([newSegmentData, 1]);
	
	    var newSegmentData2 = /** @type {SegmentData} */ ({
	      segment: [vertex, segment[1]],
	      feature: feature,
	      geometry: geometry,
	      depth: depth,
	      index: index + 1
	    });
	    rTree.insert(boundingExtent(newSegmentData2.segment), newSegmentData2);
	    this.dragSegments_.push([newSegmentData2, 0]);
	    this.ignoreNextSingleClick_ = true;
	  };
	
	  /**
	   * Removes the vertex currently being pointed.
	   * @return {boolean} True when a vertex was removed.
	   * @api
	   */
	  Modify.prototype.removePoint = function removePoint () {
	    if (this.lastPointerEvent_ && this.lastPointerEvent_.type != MapBrowserEventType.POINTERDRAG) {
	      var evt = this.lastPointerEvent_;
	      this.willModifyFeatures_(evt);
	      this.removeVertex_();
	      this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYEND, this.features_, evt));
	      this.modified_ = false;
	      return true;
	    }
	    return false;
	  };
	
	  /**
	   * Removes a vertex from all matching features.
	   * @return {boolean} True when a vertex was removed.
	   * @private
	   */
	  Modify.prototype.removeVertex_ = function removeVertex_ () {
	    var dragSegments = this.dragSegments_;
	    var segmentsByFeature = {};
	    var deleted = false;
	    var component, coordinates, dragSegment, geometry, i, index, left;
	    var newIndex, right, segmentData, uid;
	    for (i = dragSegments.length - 1; i >= 0; --i) {
	      dragSegment = dragSegments[i];
	      segmentData = dragSegment[0];
	      uid = getUid(segmentData.feature);
	      if (segmentData.depth) {
	        // separate feature components
	        uid += '-' + segmentData.depth.join('-');
	      }
	      if (!(uid in segmentsByFeature)) {
	        segmentsByFeature[uid] = {};
	      }
	      if (dragSegment[1] === 0) {
	        segmentsByFeature[uid].right = segmentData;
	        segmentsByFeature[uid].index = segmentData.index;
	      } else if (dragSegment[1] == 1) {
	        segmentsByFeature[uid].left = segmentData;
	        segmentsByFeature[uid].index = segmentData.index + 1;
	      }
	
	    }
	    for (uid in segmentsByFeature) {
	      right = segmentsByFeature[uid].right;
	      left = segmentsByFeature[uid].left;
	      index = segmentsByFeature[uid].index;
	      newIndex = index - 1;
	      if (left !== undefined) {
	        segmentData = left;
	      } else {
	        segmentData = right;
	      }
	      if (newIndex < 0) {
	        newIndex = 0;
	      }
	      geometry = segmentData.geometry;
	      coordinates = geometry.getCoordinates();
	      component = coordinates;
	      deleted = false;
	      switch (geometry.getType()) {
	        case GeometryType.MULTI_LINE_STRING:
	          if (coordinates[segmentData.depth[0]].length > 2) {
	            coordinates[segmentData.depth[0]].splice(index, 1);
	            deleted = true;
	          }
	          break;
	        case GeometryType.LINE_STRING:
	          if (coordinates.length > 2) {
	            coordinates.splice(index, 1);
	            deleted = true;
	          }
	          break;
	        case GeometryType.MULTI_POLYGON:
	          component = component[segmentData.depth[1]];
	          /* falls through */
	        case GeometryType.POLYGON:
	          component = component[segmentData.depth[0]];
	          if (component.length > 4) {
	            if (index == component.length - 1) {
	              index = 0;
	            }
	            component.splice(index, 1);
	            deleted = true;
	            if (index === 0) {
	              // close the ring again
	              component.pop();
	              component.push(component[0]);
	              newIndex = component.length - 1;
	            }
	          }
	          break;
	        default:
	          // pass
	      }
	
	      if (deleted) {
	        this.setGeometryCoordinates_(geometry, coordinates);
	        var segments = [];
	        if (left !== undefined) {
	          this.rBush_.remove(left);
	          segments.push(left.segment[0]);
	        }
	        if (right !== undefined) {
	          this.rBush_.remove(right);
	          segments.push(right.segment[1]);
	        }
	        if (left !== undefined && right !== undefined) {
	          var newSegmentData = /** @type {SegmentData} */ ({
	            depth: segmentData.depth,
	            feature: segmentData.feature,
	            geometry: segmentData.geometry,
	            index: newIndex,
	            segment: segments
	          });
	          this.rBush_.insert(boundingExtent(newSegmentData.segment),
	            newSegmentData);
	        }
	        this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);
	        if (this.vertexFeature_) {
	          /** @type {VectorSource} */ (this.overlay_.getSource()).removeFeature(this.vertexFeature_);
	          this.vertexFeature_ = null;
	        }
	        dragSegments.length = 0;
	      }
	
	    }
	    return deleted;
	  };
	
	  /**
	   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
	   * @param {Array} coordinates Coordinates.
	   * @private
	   */
	  Modify.prototype.setGeometryCoordinates_ = function setGeometryCoordinates_ (geometry, coordinates) {
	    this.changingFeature_ = true;
	    geometry.setCoordinates(coordinates);
	    this.changingFeature_ = false;
	  };
	
	  /**
	   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
	   * @param {number} index Index.
	   * @param {Array<number>|undefined} depth Depth.
	   * @param {number} delta Delta (1 or -1).
	   * @private
	   */
	  Modify.prototype.updateSegmentIndices_ = function updateSegmentIndices_ (geometry, index, depth, delta) {
	    this.rBush_.forEachInExtent(geometry.getExtent(), function(segmentDataMatch) {
	      if (segmentDataMatch.geometry === geometry &&
	          (depth === undefined || segmentDataMatch.depth === undefined ||
	          equals(segmentDataMatch.depth, depth)) &&
	          segmentDataMatch.index > index) {
	        segmentDataMatch.index += delta;
	      }
	    });
	  };
	
	  Object.defineProperties( Modify, staticAccessors );
	
	  return Modify;
	}(PointerInteraction));
	
	
	/**
	 * @param {SegmentData} a The first segment data.
	 * @param {SegmentData} b The second segment data.
	 * @return {number} The difference in indexes.
	 */
	function compareIndexes(a, b) {
	  return a.index - b.index;
	}
	
	
	/**
	 * Returns the distance from a point to a line segment.
	 *
	 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
	 *        which to calculate the distance.
	 * @param {SegmentData} segmentData The object describing the line
	 *        segment we are calculating the distance to.
	 * @return {number} The square of the distance between a point and a line segment.
	 */
	function pointDistanceToSegmentDataSquared(pointCoordinates, segmentData) {
	  var geometry = segmentData.geometry;
	
	  if (geometry.getType() === GeometryType.CIRCLE) {
	    var circleGeometry = /** @type {import("../geom/Circle.js").default} */ (geometry);
	
	    if (segmentData.index === CIRCLE_CIRCUMFERENCE_INDEX) {
	      var distanceToCenterSquared =
	            squaredDistance$1(circleGeometry.getCenter(), pointCoordinates);
	      var distanceToCircumference =
	            Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
	      return distanceToCircumference * distanceToCircumference;
	    }
	  }
	  return squaredDistanceToSegment(pointCoordinates, segmentData.segment);
	}
	
	/**
	 * Returns the point closest to a given line segment.
	 *
	 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
	 *        should be found.
	 * @param {SegmentData} segmentData The object describing the line
	 *        segment which should contain the closest point.
	 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
	 */
	function closestOnSegmentData(pointCoordinates, segmentData) {
	  var geometry = segmentData.geometry;
	
	  if (geometry.getType() === GeometryType.CIRCLE &&
	  segmentData.index === CIRCLE_CIRCUMFERENCE_INDEX) {
	    return geometry.getClosestPoint(pointCoordinates);
	  }
	  return closestOnSegment(pointCoordinates, segmentData.segment);
	}
	
	
	/**
	 * @return {import("../style/Style.js").StyleFunction} Styles.
	 */
	function getDefaultStyleFunction$1() {
	  var style = createEditingStyle();
	  return function(feature, resolution) {
	    return style[GeometryType.POINT];
	  };
	}
	
	/**
	 * @module ol/interaction/Select
	 */
	
	
	/**
	 * @enum {string}
	 */
	var SelectEventType = {
	  /**
	   * Triggered when feature(s) has been (de)selected.
	   * @event SelectEvent#select
	   * @api
	   */
	  SELECT: 'select'
	};
	
	
	/**
	 * A function that takes an {@link module:ol/Feature} or
	 * {@link module:ol/render/Feature} and an
	 * {@link module:ol/layer/Layer} and returns `true` if the feature may be
	 * selected or `false` otherwise.
	 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default):boolean} FilterFunction
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../events/condition.js").Condition} [addCondition] A function
	 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled.
	 * By default, this is {@link module:ol/events/condition~never}. Use this if you
	 * want to use different events for add and remove instead of `toggle`.
	 * @property {import("../events/condition.js").Condition} [condition] A function that
	 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled. This is the event
	 * for the selected features as a whole. By default, this is
	 * {@link module:ol/events/condition~singleClick}. Clicking on a feature selects that
	 * feature and removes any that were in the selection. Clicking outside any
	 * feature removes all from the selection.
	 * See `toggle`, `add`, `remove` options for adding/removing extra features to/
	 * from the selection.
	 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default): boolean} [layers]
	 * A list of layers from which features should be selected. Alternatively, a
	 * filter function can be provided. The function will be called for each layer
	 * in the map and should return `true` for layers that you want to be
	 * selectable. If the option is absent, all visible layers will be considered
	 * selectable.
	 * @property {import("../style/Style.js").StyleLike} [style]
	 * Style for the selected features. By default the default edit style is used
	 * (see {@link module:ol/style}).
	 * @property {import("../events/condition.js").Condition} [removeCondition] A function
	 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled.
	 * By default, this is {@link module:ol/events/condition~never}. Use this if you
	 * want to use different events for add and remove instead of `toggle`.
	 * @property {import("../events/condition.js").Condition} [toggleCondition] A function
	 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
	 * boolean to indicate whether that event should be handled. This is in addition
	 * to the `condition` event. By default,
	 * {@link module:ol/events/condition~shiftKeyOnly}, i.e. pressing `shift` as
	 * well as the `condition` event, adds that feature to the current selection if
	 * it is not currently selected, and removes it if it is. See `add` and `remove`
	 * if you want to use different events instead of a toggle.
	 * @property {boolean} [multi=false] A boolean that determines if the default
	 * behaviour should select only single features or all (overlapping) features at
	 * the clicked map position. The default of `false` means single select.
	 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features]
	 * Collection where the interaction will place selected features. Optional. If
	 * not set the interaction will create a collection. In any case the collection
	 * used by the interaction is returned by
	 * {@link module:ol/interaction/Select~Select#getFeatures}.
	 * @property {FilterFunction} [filter] A function
	 * that takes an {@link module:ol/Feature} and an
	 * {@link module:ol/layer/Layer} and returns `true` if the feature may be
	 * selected or `false` otherwise.
	 * @property {boolean} [wrapX=true] Wrap the world horizontally on the selection
	 * overlay.
	 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside
	 * the radius around the given position will be checked for features. This only
	 * works for the canvas renderer and not for WebGL.
	 */
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/Select~Select} instances are instances of
	 * this type.
	 */
	var SelectEvent = /*@__PURE__*/(function (Event$$1) {
	  function SelectEvent(type, selected, deselected, mapBrowserEvent) {
	    Event$$1.call(this, type);
	
	    /**
	     * Selected features array.
	     * @type {Array<import("../Feature.js").default>}
	     * @api
	     */
	    this.selected = selected;
	
	    /**
	     * Deselected features array.
	     * @type {Array<import("../Feature.js").default>}
	     * @api
	     */
	    this.deselected = deselected;
	
	    /**
	     * Associated {@link module:ol/MapBrowserEvent}.
	     * @type {import("../MapBrowserEvent.js").default}
	     * @api
	     */
	    this.mapBrowserEvent = mapBrowserEvent;
	
	  }
	
	  if ( Event$$1 ) { SelectEvent.__proto__ = Event$$1; }
	  SelectEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  SelectEvent.prototype.constructor = SelectEvent;
	
	  return SelectEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Interaction for selecting vector features. By default, selected features are
	 * styled differently, so this interaction can be used for visual highlighting,
	 * as well as selecting features for other actions, such as modification or
	 * output. There are three ways of controlling which features are selected:
	 * using the browser event as defined by the `condition` and optionally the
	 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
	 * further feature filter using the `filter` option.
	 *
	 * Selected features are added to an internal unmanaged layer.
	 *
	 * @fires SelectEvent
	 * @api
	 */
	var Select = /*@__PURE__*/(function (Interaction$$1) {
	  function Select(opt_options) {
	
	    Interaction$$1.call(this, {
	      handleEvent: handleEvent$3
	    });
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.condition_ = options.condition ? options.condition : singleClick;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.addCondition_ = options.addCondition ? options.addCondition : never;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.removeCondition_ = options.removeCondition ? options.removeCondition : never;
	
	    /**
	     * @private
	     * @type {import("../events/condition.js").Condition}
	     */
	    this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : shiftKeyOnly;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.multi_ = options.multi ? options.multi : false;
	
	    /**
	     * @private
	     * @type {FilterFunction}
	     */
	    this.filter_ = options.filter ? options.filter : TRUE;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
	
	    var featureOverlay = new VectorLayer({
	      source: new VectorSource({
	        useSpatialIndex: false,
	        features: options.features,
	        wrapX: options.wrapX
	      }),
	      style: options.style ? options.style :
	        getDefaultStyleFunction$2(),
	      updateWhileAnimating: true,
	      updateWhileInteracting: true
	    });
	
	    /**
	     * @private
	     * @type {VectorLayer}
	     */
	    this.featureOverlay_ = featureOverlay;
	
	    /** @type {function(import("../layer/Layer.js").default): boolean} */
	    var layerFilter;
	    if (options.layers) {
	      if (typeof options.layers === 'function') {
	        layerFilter = options.layers;
	      } else {
	        var layers = options.layers;
	        layerFilter = function(layer) {
	          return includes(layers, layer);
	        };
	      }
	    } else {
	      layerFilter = TRUE;
	    }
	
	    /**
	     * @private
	     * @type {function(import("../layer/Layer.js").default): boolean}
	     */
	    this.layerFilter_ = layerFilter;
	
	    /**
	     * An association between selected feature (key)
	     * and layer (value)
	     * @private
	     * @type {Object<string, import("../layer/Layer.js").default>}
	     */
	    this.featureLayerAssociation_ = {};
	
	    var features = this.getFeatures();
	    listen(features, CollectionEventType.ADD,
	      this.addFeature_, this);
	    listen(features, CollectionEventType.REMOVE,
	      this.removeFeature_, this);
	  }
	
	  if ( Interaction$$1 ) { Select.__proto__ = Interaction$$1; }
	  Select.prototype = Object.create( Interaction$$1 && Interaction$$1.prototype );
	  Select.prototype.constructor = Select;
	
	  /**
	   * @param {import("../Feature.js").FeatureLike} feature Feature.
	   * @param {import("../layer/Layer.js").default} layer Layer.
	   * @private
	   */
	  Select.prototype.addFeatureLayerAssociation_ = function addFeatureLayerAssociation_ (feature, layer) {
	    this.featureLayerAssociation_[getUid(feature)] = layer;
	  };
	
	  /**
	   * Get the selected features.
	   * @return {import("../Collection.js").default<import("../Feature.js").default>} Features collection.
	   * @api
	   */
	  Select.prototype.getFeatures = function getFeatures () {
	    return /** @type {VectorSource} */ (this.featureOverlay_.getSource()).getFeaturesCollection();
	  };
	
	  /**
	   * Returns the Hit-detection tolerance.
	   * @returns {number} Hit tolerance in pixels.
	   * @api
	   */
	  Select.prototype.getHitTolerance = function getHitTolerance () {
	    return this.hitTolerance_;
	  };
	
	  /**
	   * Returns the associated {@link module:ol/layer/Vector~Vector vectorlayer} of
	   * the (last) selected feature. Note that this will not work with any
	   * programmatic method like pushing features to
	   * {@link module:ol/interaction/Select~Select#getFeatures collection}.
	   * @param {import("../Feature.js").FeatureLike} feature Feature
	   * @return {VectorLayer} Layer.
	   * @api
	   */
	  Select.prototype.getLayer = function getLayer (feature) {
	    return (
	      /** @type {VectorLayer} */ (this.featureLayerAssociation_[getUid(feature)])
	    );
	  };
	
	  /**
	   * Get the overlay layer that this interaction renders selected features to.
	   * @return {VectorLayer} Overlay layer.
	   * @api
	   */
	  Select.prototype.getOverlay = function getOverlay () {
	    return this.featureOverlay_;
	  };
	
	  /**
	   * Hit-detection tolerance. Pixels inside the radius around the given position
	   * will be checked for features. This only works for the canvas renderer and
	   * not for WebGL.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @api
	   */
	  Select.prototype.setHitTolerance = function setHitTolerance (hitTolerance) {
	    this.hitTolerance_ = hitTolerance;
	  };
	
	  /**
	   * Remove the interaction from its current map, if any,  and attach it to a new
	   * map, if any. Pass `null` to just remove the interaction from the current map.
	   * @param {import("../PluggableMap.js").default} map Map.
	   * @override
	   * @api
	   */
	  Select.prototype.setMap = function setMap (map) {
	    var currentMap = this.getMap();
	    var selectedFeatures = this.getFeatures();
	    if (currentMap) {
	      selectedFeatures.forEach(currentMap.unskipFeature.bind(currentMap));
	    }
	    Interaction$$1.prototype.setMap.call(this, map);
	    this.featureOverlay_.setMap(map);
	    if (map) {
	      selectedFeatures.forEach(map.skipFeature.bind(map));
	    }
	  };
	
	  /**
	   * @param {import("../Collection.js").CollectionEvent} evt Event.
	   * @private
	   */
	  Select.prototype.addFeature_ = function addFeature_ (evt) {
	    var map = this.getMap();
	    if (map) {
	      map.skipFeature(/** @type {import("../Feature.js").default} */ (evt.element));
	    }
	  };
	
	  /**
	   * @param {import("../Collection.js").CollectionEvent} evt Event.
	   * @private
	   */
	  Select.prototype.removeFeature_ = function removeFeature_ (evt) {
	    var map = this.getMap();
	    if (map) {
	      map.unskipFeature(/** @type {import("../Feature.js").default} */ (evt.element));
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").FeatureLike} feature Feature.
	   * @private
	   */
	  Select.prototype.removeFeatureLayerAssociation_ = function removeFeatureLayerAssociation_ (feature) {
	    delete this.featureLayerAssociation_[getUid(feature)];
	  };
	
	  return Select;
	}(Interaction));
	
	
	/**
	 * Handles the {@link module:ol/MapBrowserEvent map browser event} and may change the
	 * selected state of features.
	 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
	 * @return {boolean} `false` to stop event propagation.
	 * @this {Select}
	 */
	function handleEvent$3(mapBrowserEvent) {
	  if (!this.condition_(mapBrowserEvent)) {
	    return true;
	  }
	  var add = this.addCondition_(mapBrowserEvent);
	  var remove$$1 = this.removeCondition_(mapBrowserEvent);
	  var toggle = this.toggleCondition_(mapBrowserEvent);
	  var set = !add && !remove$$1 && !toggle;
	  var map = mapBrowserEvent.map;
	  var features = this.getFeatures();
	  var deselected = [];
	  var selected = [];
	  if (set) {
	    // Replace the currently selected feature(s) with the feature(s) at the
	    // pixel, or clear the selected feature(s) if there is no feature at
	    // the pixel.
	    clear(this.featureLayerAssociation_);
	    map.forEachFeatureAtPixel(mapBrowserEvent.pixel,
	      (
	        /**
	         * @param {import("../Feature.js").FeatureLike} feature Feature.
	         * @param {import("../layer/Layer.js").default} layer Layer.
	         * @return {boolean|undefined} Continue to iterate over the features.
	         */
	        function(feature, layer) {
	          if (this.filter_(feature, layer)) {
	            selected.push(feature);
	            this.addFeatureLayerAssociation_(feature, layer);
	            return !this.multi_;
	          }
	        }).bind(this), {
	        layerFilter: this.layerFilter_,
	        hitTolerance: this.hitTolerance_
	      });
	    for (var i = features.getLength() - 1; i >= 0; --i) {
	      var feature = features.item(i);
	      var index = selected.indexOf(feature);
	      if (index > -1) {
	        // feature is already selected
	        selected.splice(index, 1);
	      } else {
	        features.remove(feature);
	        deselected.push(feature);
	      }
	    }
	    if (selected.length !== 0) {
	      features.extend(selected);
	    }
	  } else {
	    // Modify the currently selected feature(s).
	    map.forEachFeatureAtPixel(mapBrowserEvent.pixel,
	      (
	        /**
	         * @param {import("../Feature.js").FeatureLike} feature Feature.
	         * @param {import("../layer/Layer.js").default} layer Layer.
	         * @return {boolean|undefined} Continue to iterate over the features.
	         */
	        function(feature, layer) {
	          if (this.filter_(feature, layer)) {
	            if ((add || toggle) && !includes(features.getArray(), feature)) {
	              selected.push(feature);
	              this.addFeatureLayerAssociation_(feature, layer);
	            } else if ((remove$$1 || toggle) && includes(features.getArray(), feature)) {
	              deselected.push(feature);
	              this.removeFeatureLayerAssociation_(feature);
	            }
	            return !this.multi_;
	          }
	        }).bind(this), {
	        layerFilter: this.layerFilter_,
	        hitTolerance: this.hitTolerance_
	      });
	    for (var j = deselected.length - 1; j >= 0; --j) {
	      features.remove(deselected[j]);
	    }
	    features.extend(selected);
	  }
	  if (selected.length > 0 || deselected.length > 0) {
	    this.dispatchEvent(
	      new SelectEvent(SelectEventType.SELECT,
	        selected, deselected, mapBrowserEvent));
	  }
	  return pointerMove$1(mapBrowserEvent);
	}
	
	
	/**
	 * @return {import("../style/Style.js").StyleFunction} Styles.
	 */
	function getDefaultStyleFunction$2() {
	  var styles = createEditingStyle();
	  extend(styles[GeometryType.POLYGON], styles[GeometryType.LINE_STRING]);
	  extend(styles[GeometryType.GEOMETRY_COLLECTION], styles[GeometryType.LINE_STRING]);
	
	  return function(feature, resolution) {
	    if (!feature.getGeometry()) {
	      return null;
	    }
	    return styles[feature.getGeometry().getType()];
	  };
	}
	
	/**
	 * @module ol/interaction/Snap
	 */
	
	
	/**
	 * @typedef {Object} Result
	 * @property {boolean} snapped
	 * @property {import("../coordinate.js").Coordinate|null} vertex
	 * @property {import("../pixel.js").Pixel|null} vertexPixel
	 */
	
	
	/**
	 * @typedef {Object} SegmentData
	 * @property {import("../Feature.js").default} feature
	 * @property {Array<import("../coordinate.js").Coordinate>} segment
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features] Snap to these features. Either this option or source should be provided.
	 * @property {boolean} [edge=true] Snap to edges.
	 * @property {boolean} [vertex=true] Snap to vertices.
	 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the pointer close enough to a segment or
	 * vertex for snapping.
	 * @property {import("../source/Vector.js").default} [source] Snap to features from this source. Either this option or features should be provided
	 */
	
	
	/**
	 * @param  {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
	 * @return {import("../Feature.js").default} Feature.
	 */
	function getFeatureFromEvent(evt) {
	  if (/** @type {import("../source/Vector.js").VectorSourceEvent} */ (evt).feature) {
	    return /** @type {import("../source/Vector.js").VectorSourceEvent} */ (evt).feature;
	  } else if (/** @type {import("../Collection.js").CollectionEvent} */ (evt).element) {
	    return /** @type {import("../Feature.js").default} */ (/** @type {import("../Collection.js").CollectionEvent} */ (evt).element);
	  }
	
	}
	
	/**
	 * @classdesc
	 * Handles snapping of vector features while modifying or drawing them.  The
	 * features can come from a {@link module:ol/source/Vector} or {@link module:ol/Collection~Collection}
	 * Any interaction object that allows the user to interact
	 * with the features using the mouse can benefit from the snapping, as long
	 * as it is added before.
	 *
	 * The snap interaction modifies map browser event `coordinate` and `pixel`
	 * properties to force the snap to occur to any interaction that them.
	 *
	 * Example:
	 *
	 *     import Snap from 'ol/interaction/Snap';
	 *
	 *     var snap = new Snap({
	 *       source: source
	 *     });
	 *
	 * @api
	 */
	var Snap = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function Snap(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
	
	    if (!pointerOptions.handleDownEvent) {
	      pointerOptions.handleDownEvent = TRUE;
	    }
	
	    if (!pointerOptions.stopDown) {
	      pointerOptions.stopDown = FALSE;
	    }
	
	    PointerInteraction$$1.call(this, pointerOptions);
	
	    /**
	     * @type {import("../source/Vector.js").default}
	     * @private
	     */
	    this.source_ = options.source ? options.source : null;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.vertex_ = options.vertex !== undefined ? options.vertex : true;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.edge_ = options.edge !== undefined ? options.edge : true;
	
	    /**
	     * @type {import("../Collection.js").default<import("../Feature.js").default>}
	     * @private
	     */
	    this.features_ = options.features ? options.features : null;
	
	    /**
	     * @type {Array<import("../events.js").EventsKey>}
	     * @private
	     */
	    this.featuresListenerKeys_ = [];
	
	    /**
	     * @type {Object<string, import("../events.js").EventsKey>}
	     * @private
	     */
	    this.featureChangeListenerKeys_ = {};
	
	    /**
	     * Extents are preserved so indexed segment can be quickly removed
	     * when its feature geometry changes
	     * @type {Object<string, import("../extent.js").Extent>}
	     * @private
	     */
	    this.indexedFeaturesExtents_ = {};
	
	    /**
	     * If a feature geometry changes while a pointer drag|move event occurs, the
	     * feature doesn't get updated right away.  It will be at the next 'pointerup'
	     * event fired.
	     * @type {!Object<string, import("../Feature.js").default>}
	     * @private
	     */
	    this.pendingFeatures_ = {};
	
	    /**
	     * Used for distance sorting in sortByDistance_
	     * @type {import("../coordinate.js").Coordinate}
	     * @private
	     */
	    this.pixelCoordinate_ = null;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.pixelTolerance_ = options.pixelTolerance !== undefined ?
	      options.pixelTolerance : 10;
	
	    /**
	     * @type {function(SegmentData, SegmentData): number}
	     * @private
	     */
	    this.sortByDistance_ = sortByDistance.bind(this);
	
	
	    /**
	    * Segment RTree for each layer
	    * @type {import("../structs/RBush.js").default<SegmentData>}
	    * @private
	    */
	    this.rBush_ = new RBush();
	
	
	    /**
	    * @const
	    * @private
	    * @type {Object<string, function(import("../Feature.js").default, import("../geom/Geometry.js").default)>}
	    */
	    this.SEGMENT_WRITERS_ = {
	      'Point': this.writePointGeometry_,
	      'LineString': this.writeLineStringGeometry_,
	      'LinearRing': this.writeLineStringGeometry_,
	      'Polygon': this.writePolygonGeometry_,
	      'MultiPoint': this.writeMultiPointGeometry_,
	      'MultiLineString': this.writeMultiLineStringGeometry_,
	      'MultiPolygon': this.writeMultiPolygonGeometry_,
	      'GeometryCollection': this.writeGeometryCollectionGeometry_,
	      'Circle': this.writeCircleGeometry_
	    };
	  }
	
	  if ( PointerInteraction$$1 ) { Snap.__proto__ = PointerInteraction$$1; }
	  Snap.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  Snap.prototype.constructor = Snap;
	
	  /**
	   * Add a feature to the collection of features that we may snap to.
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {boolean=} opt_listen Whether to listen to the feature change or not
	   *     Defaults to `true`.
	   * @api
	   */
	  Snap.prototype.addFeature = function addFeature (feature, opt_listen) {
	    var register = opt_listen !== undefined ? opt_listen : true;
	    var feature_uid = getUid(feature);
	    var geometry = feature.getGeometry();
	    if (geometry) {
	      var segmentWriter = this.SEGMENT_WRITERS_[geometry.getType()];
	      if (segmentWriter) {
	        this.indexedFeaturesExtents_[feature_uid] = geometry.getExtent(createEmpty());
	        segmentWriter.call(this, feature, geometry);
	      }
	    }
	
	    if (register) {
	      this.featureChangeListenerKeys_[feature_uid] = listen(
	        feature,
	        EventType.CHANGE,
	        this.handleFeatureChange_, this);
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature.
	   * @private
	   */
	  Snap.prototype.forEachFeatureAdd_ = function forEachFeatureAdd_ (feature) {
	    this.addFeature(feature);
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature.
	   * @private
	   */
	  Snap.prototype.forEachFeatureRemove_ = function forEachFeatureRemove_ (feature) {
	    this.removeFeature(feature);
	  };
	
	  /**
	   * @return {import("../Collection.js").default<import("../Feature.js").default>|Array<import("../Feature.js").default>} Features.
	   * @private
	   */
	  Snap.prototype.getFeatures_ = function getFeatures_ () {
	    var features;
	    if (this.features_) {
	      features = this.features_;
	    } else if (this.source_) {
	      features = this.source_.getFeatures();
	    }
	    return features;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Snap.prototype.handleEvent = function handleEvent (evt) {
	    var result = this.snapTo(evt.pixel, evt.coordinate, evt.map);
	    if (result.snapped) {
	      evt.coordinate = result.vertex.slice(0, 2);
	      evt.pixel = result.vertexPixel;
	    }
	    return PointerInteraction$$1.prototype.handleEvent.call(this, evt);
	  };
	
	  /**
	   * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
	   * @private
	   */
	  Snap.prototype.handleFeatureAdd_ = function handleFeatureAdd_ (evt) {
	    var feature = getFeatureFromEvent(evt);
	    this.addFeature(feature);
	  };
	
	  /**
	   * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
	   * @private
	   */
	  Snap.prototype.handleFeatureRemove_ = function handleFeatureRemove_ (evt) {
	    var feature = getFeatureFromEvent(evt);
	    this.removeFeature(feature);
	  };
	
	  /**
	   * @param {import("../events/Event.js").default} evt Event.
	   * @private
	   */
	  Snap.prototype.handleFeatureChange_ = function handleFeatureChange_ (evt) {
	    var feature = /** @type {import("../Feature.js").default} */ (evt.target);
	    if (this.handlingDownUpSequence) {
	      var uid = getUid(feature);
	      if (!(uid in this.pendingFeatures_)) {
	        this.pendingFeatures_[uid] = feature;
	      }
	    } else {
	      this.updateFeature_(feature);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Snap.prototype.handleUpEvent = function handleUpEvent (evt) {
	    var featuresToUpdate = getValues(this.pendingFeatures_);
	    if (featuresToUpdate.length) {
	      featuresToUpdate.forEach(this.updateFeature_.bind(this));
	      this.pendingFeatures_ = {};
	    }
	    return false;
	  };
	
	  /**
	   * Remove a feature from the collection of features that we may snap to.
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {boolean=} opt_unlisten Whether to unlisten to the feature change
	   *     or not. Defaults to `true`.
	   * @api
	   */
	  Snap.prototype.removeFeature = function removeFeature (feature, opt_unlisten) {
	    var unregister = opt_unlisten !== undefined ? opt_unlisten : true;
	    var feature_uid = getUid(feature);
	    var extent = this.indexedFeaturesExtents_[feature_uid];
	    if (extent) {
	      var rBush = this.rBush_;
	      var nodesToRemove = [];
	      rBush.forEachInExtent(extent, function(node) {
	        if (feature === node.feature) {
	          nodesToRemove.push(node);
	        }
	      });
	      for (var i = nodesToRemove.length - 1; i >= 0; --i) {
	        rBush.remove(nodesToRemove[i]);
	      }
	    }
	
	    if (unregister) {
	      unlistenByKey(this.featureChangeListenerKeys_[feature_uid]);
	      delete this.featureChangeListenerKeys_[feature_uid];
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Snap.prototype.setMap = function setMap (map) {
	    var currentMap = this.getMap();
	    var keys = this.featuresListenerKeys_;
	    var features = /** @type {Array<import("../Feature.js").default>} */ (this.getFeatures_());
	
	    if (currentMap) {
	      keys.forEach(unlistenByKey);
	      keys.length = 0;
	      features.forEach(this.forEachFeatureRemove_.bind(this));
	    }
	    PointerInteraction$$1.prototype.setMap.call(this, map);
	
	    if (map) {
	      if (this.features_) {
	        keys.push(
	          listen(this.features_, CollectionEventType.ADD,
	            this.handleFeatureAdd_, this),
	          listen(this.features_, CollectionEventType.REMOVE,
	            this.handleFeatureRemove_, this)
	        );
	      } else if (this.source_) {
	        keys.push(
	          listen(this.source_, VectorEventType.ADDFEATURE,
	            this.handleFeatureAdd_, this),
	          listen(this.source_, VectorEventType.REMOVEFEATURE,
	            this.handleFeatureRemove_, this)
	        );
	      }
	      features.forEach(this.forEachFeatureAdd_.bind(this));
	    }
	  };
	
	  /**
	   * @param {import("../pixel.js").Pixel} pixel Pixel
	   * @param {import("../coordinate.js").Coordinate} pixelCoordinate Coordinate
	   * @param {import("../PluggableMap.js").default} map Map.
	   * @return {Result} Snap result
	   */
	  Snap.prototype.snapTo = function snapTo (pixel, pixelCoordinate, map) {
	
	    var lowerLeft = map.getCoordinateFromPixel(
	      [pixel[0] - this.pixelTolerance_, pixel[1] + this.pixelTolerance_]);
	    var upperRight = map.getCoordinateFromPixel(
	      [pixel[0] + this.pixelTolerance_, pixel[1] - this.pixelTolerance_]);
	    var box = boundingExtent([lowerLeft, upperRight]);
	
	    var segments = this.rBush_.getInExtent(box);
	
	    // If snapping on vertices only, don't consider circles
	    if (this.vertex_ && !this.edge_) {
	      segments = segments.filter(function(segment) {
	        return segment.feature.getGeometry().getType() !==
	            GeometryType.CIRCLE;
	      });
	    }
	
	    var snappedToVertex = false;
	    var snapped = false;
	    var vertex = null;
	    var vertexPixel = null;
	    var dist, pixel1, pixel2, squaredDist1, squaredDist2;
	    if (segments.length > 0) {
	      this.pixelCoordinate_ = pixelCoordinate;
	      segments.sort(this.sortByDistance_);
	      var closestSegment = segments[0].segment;
	      var isCircle = segments[0].feature.getGeometry().getType() ===
	          GeometryType.CIRCLE;
	      if (this.vertex_ && !this.edge_) {
	        pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
	        pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
	        squaredDist1 = squaredDistance$1(pixel, pixel1);
	        squaredDist2 = squaredDistance$1(pixel, pixel2);
	        dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
	        snappedToVertex = dist <= this.pixelTolerance_;
	        if (snappedToVertex) {
	          snapped = true;
	          vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
	          vertexPixel = map.getPixelFromCoordinate(vertex);
	        }
	      } else if (this.edge_) {
	        if (isCircle) {
	          vertex = closestOnCircle(pixelCoordinate,
	            /** @type {import("../geom/Circle.js").default} */ (segments[0].feature.getGeometry()));
	        } else {
	          vertex = closestOnSegment(pixelCoordinate, closestSegment);
	        }
	        vertexPixel = map.getPixelFromCoordinate(vertex);
	        if (distance(pixel, vertexPixel) <= this.pixelTolerance_) {
	          snapped = true;
	          if (this.vertex_ && !isCircle) {
	            pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
	            pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
	            squaredDist1 = squaredDistance$1(vertexPixel, pixel1);
	            squaredDist2 = squaredDistance$1(vertexPixel, pixel2);
	            dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
	            snappedToVertex = dist <= this.pixelTolerance_;
	            if (snappedToVertex) {
	              vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
	              vertexPixel = map.getPixelFromCoordinate(vertex);
	            }
	          }
	        }
	      }
	      if (snapped) {
	        vertexPixel = [Math.round(vertexPixel[0]), Math.round(vertexPixel[1])];
	      }
	    }
	    return (
	      /** @type {Result} */ ({
	        snapped: snapped,
	        vertex: vertex,
	        vertexPixel: vertexPixel
	      })
	    );
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @private
	   */
	  Snap.prototype.updateFeature_ = function updateFeature_ (feature) {
	    this.removeFeature(feature, false);
	    this.addFeature(feature, false);
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/Circle.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writeCircleGeometry_ = function writeCircleGeometry_ (feature, geometry) {
	    var polygon = fromCircle(geometry);
	    var coordinates = polygon.getCoordinates()[0];
	    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	      var segment = coordinates.slice(i, i + 2);
	      var segmentData = /** @type {SegmentData} */ ({
	        feature: feature,
	        segment: segment
	      });
	      this.rBush_.insert(boundingExtent(segment), segmentData);
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writeGeometryCollectionGeometry_ = function writeGeometryCollectionGeometry_ (feature, geometry) {
	    var geometries = geometry.getGeometriesArray();
	    for (var i = 0; i < geometries.length; ++i) {
	      var segmentWriter = this.SEGMENT_WRITERS_[geometries[i].getType()];
	      if (segmentWriter) {
	        segmentWriter.call(this, feature, geometries[i]);
	      }
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/LineString.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writeLineStringGeometry_ = function writeLineStringGeometry_ (feature, geometry) {
	    var coordinates = geometry.getCoordinates();
	    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	      var segment = coordinates.slice(i, i + 2);
	      var segmentData = /** @type {SegmentData} */ ({
	        feature: feature,
	        segment: segment
	      });
	      this.rBush_.insert(boundingExtent(segment), segmentData);
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writeMultiLineStringGeometry_ = function writeMultiLineStringGeometry_ (feature, geometry) {
	    var lines = geometry.getCoordinates();
	    for (var j = 0, jj = lines.length; j < jj; ++j) {
	      var coordinates = lines[j];
	      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	        var segment = coordinates.slice(i, i + 2);
	        var segmentData = /** @type {SegmentData} */ ({
	          feature: feature,
	          segment: segment
	        });
	        this.rBush_.insert(boundingExtent(segment), segmentData);
	      }
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writeMultiPointGeometry_ = function writeMultiPointGeometry_ (feature, geometry) {
	    var points = geometry.getCoordinates();
	    for (var i = 0, ii = points.length; i < ii; ++i) {
	      var coordinates = points[i];
	      var segmentData = /** @type {SegmentData} */ ({
	        feature: feature,
	        segment: [coordinates, coordinates]
	      });
	      this.rBush_.insert(geometry.getExtent(), segmentData);
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writeMultiPolygonGeometry_ = function writeMultiPolygonGeometry_ (feature, geometry) {
	    var polygons = geometry.getCoordinates();
	    for (var k = 0, kk = polygons.length; k < kk; ++k) {
	      var rings = polygons[k];
	      for (var j = 0, jj = rings.length; j < jj; ++j) {
	        var coordinates = rings[j];
	        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	          var segment = coordinates.slice(i, i + 2);
	          var segmentData = /** @type {SegmentData} */ ({
	            feature: feature,
	            segment: segment
	          });
	          this.rBush_.insert(boundingExtent(segment), segmentData);
	        }
	      }
	    }
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/Point.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writePointGeometry_ = function writePointGeometry_ (feature, geometry) {
	    var coordinates = geometry.getCoordinates();
	    var segmentData = /** @type {SegmentData} */ ({
	      feature: feature,
	      segment: [coordinates, coordinates]
	    });
	    this.rBush_.insert(geometry.getExtent(), segmentData);
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature
	   * @param {import("../geom/Polygon.js").default} geometry Geometry.
	   * @private
	   */
	  Snap.prototype.writePolygonGeometry_ = function writePolygonGeometry_ (feature, geometry) {
	    var rings = geometry.getCoordinates();
	    for (var j = 0, jj = rings.length; j < jj; ++j) {
	      var coordinates = rings[j];
	      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
	        var segment = coordinates.slice(i, i + 2);
	        var segmentData = /** @type {SegmentData} */ ({
	          feature: feature,
	          segment: segment
	        });
	        this.rBush_.insert(boundingExtent(segment), segmentData);
	      }
	    }
	  };
	
	  return Snap;
	}(PointerInteraction));
	
	
	/**
	 * Sort segments by distance, helper function
	 * @param {SegmentData} a The first segment data.
	 * @param {SegmentData} b The second segment data.
	 * @return {number} The difference in distance.
	 * @this {Snap}
	 */
	function sortByDistance(a, b) {
	  var deltaA = squaredDistanceToSegment(this.pixelCoordinate_, a.segment);
	  var deltaB = squaredDistanceToSegment(this.pixelCoordinate_, b.segment);
	  return deltaA - deltaB;
	}
	
	/**
	 * @module ol/interaction/Translate
	 */
	
	
	/**
	 * @enum {string}
	 */
	var TranslateEventType = {
	  /**
	   * Triggered upon feature translation start.
	   * @event TranslateEvent#translatestart
	   * @api
	   */
	  TRANSLATESTART: 'translatestart',
	  /**
	   * Triggered upon feature translation.
	   * @event TranslateEvent#translating
	   * @api
	   */
	  TRANSLATING: 'translating',
	  /**
	   * Triggered upon feature translation end.
	   * @event TranslateEvent#translateend
	   * @api
	   */
	  TRANSLATEEND: 'translateend'
	};
	
	
	/**
	 * @typedef {Object} Options
	 * @property {Collection<import("../Feature.js").default>} [features] Only features contained in this collection will be able to be translated. If
	 * not specified, all features on the map will be able to be translated.
	 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default): boolean} [layers] A list of layers from which features should be
	 * translated. Alternatively, a filter function can be provided. The
	 * function will be called for each layer in the map and should return
	 * `true` for layers that you want to be translatable. If the option is
	 * absent, all visible layers will be considered translatable.
	 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside the radius around the given position
	 * will be checked for features. This only works for the canvas renderer and
	 * not for WebGL.
	 */
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/interaction/Translate~Translate} instances
	 * are instances of this type.
	 */
	var TranslateEvent = /*@__PURE__*/(function (Event$$1) {
	  function TranslateEvent(type, features, coordinate) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The features being translated.
	     * @type {Collection<import("../Feature.js").default>}
	     * @api
	     */
	    this.features = features;
	
	    /**
	     * The coordinate of the drag event.
	     * @const
	     * @type {import("../coordinate.js").Coordinate}
	     * @api
	     */
	    this.coordinate = coordinate;
	
	  }
	
	  if ( Event$$1 ) { TranslateEvent.__proto__ = Event$$1; }
	  TranslateEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  TranslateEvent.prototype.constructor = TranslateEvent;
	
	  return TranslateEvent;
	}(Event));
	
	
	/**
	 * @classdesc
	 * Interaction for translating (moving) features.
	 *
	 * @fires TranslateEvent
	 * @api
	 */
	var Translate = /*@__PURE__*/(function (PointerInteraction$$1) {
	  function Translate(opt_options) {
	    var options = opt_options ? opt_options : {};
	
	    PointerInteraction$$1.call(/** @type {import("./Pointer.js").Options} */ this, (options));
	
	    /**
	     * The last position we translated to.
	     * @type {import("../coordinate.js").Coordinate}
	     * @private
	     */
	    this.lastCoordinate_ = null;
	
	
	    /**
	     * @type {Collection<import("../Feature.js").default>}
	     * @private
	     */
	    this.features_ = options.features !== undefined ? options.features : null;
	
	    /** @type {function(import("../layer/Layer.js").default): boolean} */
	    var layerFilter;
	    if (options.layers) {
	      if (typeof options.layers === 'function') {
	        layerFilter = options.layers;
	      } else {
	        var layers = options.layers;
	        layerFilter = function(layer) {
	          return includes(layers, layer);
	        };
	      }
	    } else {
	      layerFilter = TRUE;
	    }
	
	    /**
	     * @private
	     * @type {function(import("../layer/Layer.js").default): boolean}
	     */
	    this.layerFilter_ = layerFilter;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
	
	    /**
	     * @type {import("../Feature.js").default}
	     * @private
	     */
	    this.lastFeature_ = null;
	
	    listen(this,
	      getChangeEventType(InteractionProperty.ACTIVE),
	      this.handleActiveChanged_, this);
	
	  }
	
	  if ( PointerInteraction$$1 ) { Translate.__proto__ = PointerInteraction$$1; }
	  Translate.prototype = Object.create( PointerInteraction$$1 && PointerInteraction$$1.prototype );
	  Translate.prototype.constructor = Translate;
	
	  /**
	   * @inheritDoc
	   */
	  Translate.prototype.handleDownEvent = function handleDownEvent (event) {
	    this.lastFeature_ = this.featuresAtPixel_(event.pixel, event.map);
	    if (!this.lastCoordinate_ && this.lastFeature_) {
	      this.lastCoordinate_ = event.coordinate;
	      this.handleMoveEvent(event);
	
	      var features = this.features_ || new Collection([this.lastFeature_]);
	
	      this.dispatchEvent(
	        new TranslateEvent(
	          TranslateEventType.TRANSLATESTART, features,
	          event.coordinate));
	      return true;
	    }
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Translate.prototype.handleUpEvent = function handleUpEvent (event) {
	    if (this.lastCoordinate_) {
	      this.lastCoordinate_ = null;
	      this.handleMoveEvent(event);
	
	      var features = this.features_ || new Collection([this.lastFeature_]);
	
	      this.dispatchEvent(
	        new TranslateEvent(
	          TranslateEventType.TRANSLATEEND, features,
	          event.coordinate));
	      return true;
	    }
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Translate.prototype.handleDragEvent = function handleDragEvent (event) {
	    if (this.lastCoordinate_) {
	      var newCoordinate = event.coordinate;
	      var deltaX = newCoordinate[0] - this.lastCoordinate_[0];
	      var deltaY = newCoordinate[1] - this.lastCoordinate_[1];
	
	      var features = this.features_ || new Collection([this.lastFeature_]);
	
	      features.forEach(function(feature) {
	        var geom = feature.getGeometry();
	        geom.translate(deltaX, deltaY);
	        feature.setGeometry(geom);
	      });
	
	      this.lastCoordinate_ = newCoordinate;
	      this.dispatchEvent(
	        new TranslateEvent(
	          TranslateEventType.TRANSLATING, features,
	          newCoordinate));
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Translate.prototype.handleMoveEvent = function handleMoveEvent (event) {
	    var elem = event.map.getViewport();
	
	    // Change the cursor to grab/grabbing if hovering any of the features managed
	    // by the interaction
	    if (this.featuresAtPixel_(event.pixel, event.map)) {
	      elem.classList.remove(this.lastCoordinate_ ? 'ol-grab' : 'ol-grabbing');
	      elem.classList.add(this.lastCoordinate_ ? 'ol-grabbing' : 'ol-grab');
	    } else {
	      elem.classList.remove('ol-grab', 'ol-grabbing');
	    }
	  };
	
	  /**
	   * Tests to see if the given coordinates intersects any of our selected
	   * features.
	   * @param {import("../pixel.js").Pixel} pixel Pixel coordinate to test for intersection.
	   * @param {import("../PluggableMap.js").default} map Map to test the intersection on.
	   * @return {import("../Feature.js").default} Returns the feature found at the specified pixel
	   * coordinates.
	   * @private
	   */
	  Translate.prototype.featuresAtPixel_ = function featuresAtPixel_ (pixel, map) {
	    return map.forEachFeatureAtPixel(pixel,
	      function(feature) {
	        if (!this.features_ || includes(this.features_.getArray(), feature)) {
	          return feature;
	        }
	      }.bind(this), {
	        layerFilter: this.layerFilter_,
	        hitTolerance: this.hitTolerance_
	      });
	  };
	
	  /**
	   * Returns the Hit-detection tolerance.
	   * @returns {number} Hit tolerance in pixels.
	   * @api
	   */
	  Translate.prototype.getHitTolerance = function getHitTolerance () {
	    return this.hitTolerance_;
	  };
	
	  /**
	   * Hit-detection tolerance. Pixels inside the radius around the given position
	   * will be checked for features. This only works for the canvas renderer and
	   * not for WebGL.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @api
	   */
	  Translate.prototype.setHitTolerance = function setHitTolerance (hitTolerance) {
	    this.hitTolerance_ = hitTolerance;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Translate.prototype.setMap = function setMap (map) {
	    var oldMap = this.getMap();
	    PointerInteraction$$1.prototype.setMap.call(this, map);
	    this.updateState_(oldMap);
	  };
	
	  /**
	   * @private
	   */
	  Translate.prototype.handleActiveChanged_ = function handleActiveChanged_ () {
	    this.updateState_(null);
	  };
	
	  /**
	   * @param {import("../PluggableMap.js").default} oldMap Old map.
	   * @private
	   */
	  Translate.prototype.updateState_ = function updateState_ (oldMap) {
	    var map = this.getMap();
	    var active = this.getActive();
	    if (!map || !active) {
	      map = map || oldMap;
	      if (map) {
	        var elem = map.getViewport();
	        elem.classList.remove('ol-grab', 'ol-grabbing');
	      }
	    }
	  };
	
	  return Translate;
	}(PointerInteraction));
	
	/**
	 * @module ol/interaction
	 */
	
	
	/**
	 * @typedef {Object} DefaultsOptions
	 * @property {boolean} [altShiftDragRotate=true] Whether Alt-Shift-drag rotate is
	 * desired.
	 * @property {boolean} [onFocusOnly=false] Interact only when the map has the
	 * focus. This affects the `MouseWheelZoom` and `DragPan` interactions and is
	 * useful when page scroll is desired for maps that do not have the browser's
	 * focus.
	 * @property {boolean} [constrainResolution=false] Zoom to the closest integer
	 * zoom level after the wheel/trackpad or pinch gesture ends.
	 * @property {boolean} [doubleClickZoom=true] Whether double click zoom is
	 * desired.
	 * @property {boolean} [keyboard=true] Whether keyboard interaction is desired.
	 * @property {boolean} [mouseWheelZoom=true] Whether mousewheel zoom is desired.
	 * @property {boolean} [shiftDragZoom=true] Whether Shift-drag zoom is desired.
	 * @property {boolean} [dragPan=true] Whether drag pan is desired.
	 * @property {boolean} [pinchRotate=true] Whether pinch rotate is desired.
	 * @property {boolean} [pinchZoom=true] Whether pinch zoom is desired.
	 * @property {number} [zoomDelta] Zoom level delta when using keyboard or
	 * mousewheel zoom.
	 * @property {number} [zoomDuration] Duration of the zoom animation in
	 * milliseconds.
	 */
	
	
	/**
	 * Set of interactions included in maps by default. Specific interactions can be
	 * excluded by setting the appropriate option to false in the constructor
	 * options, but the order of the interactions is fixed.  If you want to specify
	 * a different order for interactions, you will need to create your own
	 * {@link module:ol/interaction/Interaction} instances and insert
	 * them into a {@link module:ol/Collection} in the order you want
	 * before creating your {@link module:ol/Map~Map} instance. The default set of
	 * interactions, in sequence, is:
	 * * {@link module:ol/interaction/DragRotate~DragRotate}
	 * * {@link module:ol/interaction/DoubleClickZoom~DoubleClickZoom}
	 * * {@link module:ol/interaction/DragPan~DragPan}
	 * * {@link module:ol/interaction/PinchRotate~PinchRotate}
	 * * {@link module:ol/interaction/PinchZoom~PinchZoom}
	 * * {@link module:ol/interaction/KeyboardPan~KeyboardPan}
	 * * {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}
	 * * {@link module:ol/interaction/MouseWheelZoom~MouseWheelZoom}
	 * * {@link module:ol/interaction/DragZoom~DragZoom}
	 *
	 * @param {DefaultsOptions=} opt_options Defaults options.
	 * @return {import("./Collection.js").default<import("./interaction/Interaction.js").default>}
	 * A collection of interactions to be used with the {@link module:ol/Map~Map}
	 * constructor's `interactions` option.
	 * @api
	 */
	function defaults$1(opt_options) {
	
	  var options = opt_options ? opt_options : {};
	
	  var interactions = new Collection();
	
	  var kinetic = new Kinetic(-0.005, 0.05, 100);
	
	  var altShiftDragRotate = options.altShiftDragRotate !== undefined ?
	    options.altShiftDragRotate : true;
	  if (altShiftDragRotate) {
	    interactions.push(new DragRotate());
	  }
	
	  var doubleClickZoom = options.doubleClickZoom !== undefined ?
	    options.doubleClickZoom : true;
	  if (doubleClickZoom) {
	    interactions.push(new DoubleClickZoom({
	      delta: options.zoomDelta,
	      duration: options.zoomDuration
	    }));
	  }
	
	  var dragPan = options.dragPan !== undefined ? options.dragPan : true;
	  if (dragPan) {
	    interactions.push(new DragPan({
	      condition: options.onFocusOnly ? focus : undefined,
	      kinetic: kinetic
	    }));
	  }
	
	  var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate :
	    true;
	  if (pinchRotate) {
	    interactions.push(new PinchRotate());
	  }
	
	  var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
	  if (pinchZoom) {
	    interactions.push(new PinchZoom({
	      constrainResolution: options.constrainResolution,
	      duration: options.zoomDuration
	    }));
	  }
	
	  var keyboard = options.keyboard !== undefined ? options.keyboard : true;
	  if (keyboard) {
	    interactions.push(new KeyboardPan());
	    interactions.push(new KeyboardZoom({
	      delta: options.zoomDelta,
	      duration: options.zoomDuration
	    }));
	  }
	
	  var mouseWheelZoom = options.mouseWheelZoom !== undefined ?
	    options.mouseWheelZoom : true;
	  if (mouseWheelZoom) {
	    interactions.push(new MouseWheelZoom({
	      condition: options.onFocusOnly ? focus : undefined,
	      constrainResolution: options.constrainResolution,
	      duration: options.zoomDuration
	    }));
	  }
	
	  var shiftDragZoom = options.shiftDragZoom !== undefined ?
	    options.shiftDragZoom : true;
	  if (shiftDragZoom) {
	    interactions.push(new DragZoom({
	      duration: options.zoomDuration
	    }));
	  }
	
	  return interactions;
	
	}
	
	/**
	 * @module ol/reproj/common
	 */
	
	/**
	 * Default maximum allowed threshold  (in pixels) for reprojection
	 * triangulation.
	 * @type {number}
	 */
	var ERROR_THRESHOLD = 0.5;
	
	/**
	 * @module ol/ImageBase
	 */
	
	/**
	 * @abstract
	 */
	var ImageBase = /*@__PURE__*/(function (EventTarget) {
	  function ImageBase(extent, resolution, pixelRatio, state) {
	
	    EventTarget.call(this);
	
	    /**
	     * @protected
	     * @type {import("./extent.js").Extent}
	     */
	    this.extent = extent;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.pixelRatio_ = pixelRatio;
	
	    /**
	     * @protected
	     * @type {number|undefined}
	     */
	    this.resolution = resolution;
	
	    /**
	     * @protected
	     * @type {import("./ImageState.js").default}
	     */
	    this.state = state;
	
	  }
	
	  if ( EventTarget ) { ImageBase.__proto__ = EventTarget; }
	  ImageBase.prototype = Object.create( EventTarget && EventTarget.prototype );
	  ImageBase.prototype.constructor = ImageBase;
	
	  /**
	   * @protected
	   */
	  ImageBase.prototype.changed = function changed () {
	    this.dispatchEvent(EventType.CHANGE);
	  };
	
	  /**
	   * @return {import("./extent.js").Extent} Extent.
	   */
	  ImageBase.prototype.getExtent = function getExtent () {
	    return this.extent;
	  };
	
	  /**
	   * @abstract
	   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
	   */
	  ImageBase.prototype.getImage = function getImage () {
	    return abstract();
	  };
	
	  /**
	   * @return {number} PixelRatio.
	   */
	  ImageBase.prototype.getPixelRatio = function getPixelRatio () {
	    return this.pixelRatio_;
	  };
	
	  /**
	   * @return {number} Resolution.
	   */
	  ImageBase.prototype.getResolution = function getResolution () {
	    return /** @type {number} */ (this.resolution);
	  };
	
	  /**
	   * @return {import("./ImageState.js").default} State.
	   */
	  ImageBase.prototype.getState = function getState () {
	    return this.state;
	  };
	
	  /**
	   * Load not yet loaded URI.
	   * @abstract
	   */
	  ImageBase.prototype.load = function load () {
	    abstract();
	  };
	
	  return ImageBase;
	}(Target));
	
	/**
	 * @module ol/ImageCanvas
	 */
	
	
	/**
	 * A function that is called to trigger asynchronous canvas drawing.  It is
	 * called with a "done" callback that should be called when drawing is done.
	 * If any error occurs during drawing, the "done" callback should be called with
	 * that error.
	 *
	 * @typedef {function(function(Error=))} Loader
	 */
	
	
	var ImageCanvas = /*@__PURE__*/(function (ImageBase$$1) {
	  function ImageCanvas(extent, resolution, pixelRatio, canvas, opt_loader) {
	
	    var state = opt_loader !== undefined ? ImageState.IDLE : ImageState.LOADED;
	
	    ImageBase$$1.call(this, extent, resolution, pixelRatio, state);
	
	    /**
	     * Optional canvas loader function.
	     * @type {?Loader}
	     * @private
	     */
	    this.loader_ = opt_loader !== undefined ? opt_loader : null;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = canvas;
	
	    /**
	     * @private
	     * @type {Error}
	     */
	    this.error_ = null;
	
	  }
	
	  if ( ImageBase$$1 ) { ImageCanvas.__proto__ = ImageBase$$1; }
	  ImageCanvas.prototype = Object.create( ImageBase$$1 && ImageBase$$1.prototype );
	  ImageCanvas.prototype.constructor = ImageCanvas;
	
	  /**
	   * Get any error associated with asynchronous rendering.
	   * @return {Error} Any error that occurred during rendering.
	   */
	  ImageCanvas.prototype.getError = function getError () {
	    return this.error_;
	  };
	
	  /**
	   * Handle async drawing complete.
	   * @param {Error=} err Any error during drawing.
	   * @private
	   */
	  ImageCanvas.prototype.handleLoad_ = function handleLoad_ (err) {
	    if (err) {
	      this.error_ = err;
	      this.state = ImageState.ERROR;
	    } else {
	      this.state = ImageState.LOADED;
	    }
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ImageCanvas.prototype.load = function load () {
	    if (this.state == ImageState.IDLE) {
	      this.state = ImageState.LOADING;
	      this.changed();
	      this.loader_(this.handleLoad_.bind(this));
	    }
	  };
	
	  /**
	   * @return {HTMLCanvasElement} Canvas element.
	   */
	  ImageCanvas.prototype.getImage = function getImage () {
	    return this.canvas_;
	  };
	
	  return ImageCanvas;
	}(ImageBase));
	
	/**
	 * @module ol/render/Event
	 */
	
	var RenderEvent = /*@__PURE__*/(function (Event$$1) {
	  function RenderEvent(type, opt_vectorContext, opt_frameState, opt_context, opt_glContext) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * For canvas, this is an instance of {@link module:ol/render/canvas/Immediate}.
	     * @type {import("./VectorContext.js").default|undefined}
	     * @api
	     */
	    this.vectorContext = opt_vectorContext;
	
	    /**
	     * An object representing the current render frame state.
	     * @type {import("../PluggableMap.js").FrameState|undefined}
	     * @api
	     */
	    this.frameState = opt_frameState;
	
	    /**
	     * Canvas context. Only available when a Canvas renderer is used, null
	     * otherwise.
	     * @type {CanvasRenderingContext2D|null|undefined}
	     * @api
	     */
	    this.context = opt_context;
	
	    /**
	     * WebGL context. Only available when a WebGL renderer is used, null
	     * otherwise.
	     * @type {import("../webgl/Context.js").default|null|undefined}
	     * @api
	     */
	    this.glContext = opt_glContext;
	
	  }
	
	  if ( Event$$1 ) { RenderEvent.__proto__ = Event$$1; }
	  RenderEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  RenderEvent.prototype.constructor = RenderEvent;
	
	  return RenderEvent;
	}(Event));
	
	/**
	 * @module ol/render/VectorContext
	 */
	
	/**
	 * @classdesc
	 * Context for drawing geometries.  A vector context is available on render
	 * events and does not need to be constructed directly.
	 * @api
	 */
	var VectorContext = function VectorContext () {};
	
	VectorContext.prototype.drawCustom = function drawCustom (geometry, feature, renderer) {};
	
	/**
	 * Render a geometry.
	 *
	 * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
	 */
	VectorContext.prototype.drawGeometry = function drawGeometry (geometry) {};
	
	/**
	 * Set the rendering style.
	 *
	 * @param {import("../style/Style.js").default} style The rendering style.
	 */
	VectorContext.prototype.setStyle = function setStyle (style) {};
	
	/**
	 * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
	 * @param {import("../Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawCircle = function drawCircle (circleGeometry, feature) {};
	
	/**
	 * @param {import("../Feature.js").default} feature Feature.
	 * @param {import("../style/Style.js").default} style Style.
	 */
	VectorContext.prototype.drawFeature = function drawFeature (feature, style) {};
	
	/**
	 * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
	 * @param {import("../Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawGeometryCollection = function drawGeometryCollection (geometryCollectionGeometry, feature) {};
	
	/**
	 * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawLineString = function drawLineString (lineStringGeometry, feature) {};
	
	/**
	 * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawMultiLineString = function drawMultiLineString (multiLineStringGeometry, feature) {};
	
	/**
	 * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawMultiPoint = function drawMultiPoint (multiPointGeometry, feature) {};
	
	/**
	 * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawMultiPolygon = function drawMultiPolygon (multiPolygonGeometry, feature) {};
	
	/**
	 * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawPoint = function drawPoint (pointGeometry, feature) {};
	
	/**
	 * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawPolygon = function drawPolygon (polygonGeometry, feature) {};
	
	/**
	 * @param {import("../geom/Geometry.js").default|import("./Feature.js").default} geometry Geometry.
	 * @param {import("../Feature.js").default|import("./Feature.js").default} feature Feature.
	 */
	VectorContext.prototype.drawText = function drawText (geometry, feature) {};
	
	/**
	 * @param {import("../style/Fill.js").default} fillStyle Fill style.
	 * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
	 */
	VectorContext.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {};
	
	/**
	 * @param {import("../style/Image.js").default} imageStyle Image style.
	 * @param {import("./canvas.js").DeclutterGroup=} opt_declutterGroup Declutter.
	 */
	VectorContext.prototype.setImageStyle = function setImageStyle (imageStyle, opt_declutterGroup) {};
	
	/**
	 * @param {import("../style/Text.js").default} textStyle Text style.
	 * @param {import("./canvas.js").DeclutterGroup=} opt_declutterGroup Declutter.
	 */
	VectorContext.prototype.setTextStyle = function setTextStyle (textStyle, opt_declutterGroup) {};
	
	/**
	 * @module ol/render/canvas/Immediate
	 */
	
	/**
	 * @classdesc
	 * A concrete subclass of {@link module:ol/render/VectorContext} that implements
	 * direct rendering of features and geometries to an HTML5 Canvas context.
	 * Instances of this class are created internally by the library and
	 * provided to application code as vectorContext member of the
	 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
	 * render events emitted by layers and maps.
	 * @api
	 */
	var CanvasImmediateRenderer = /*@__PURE__*/(function (VectorContext$$1) {
	  function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation) {
	    VectorContext$$1.call(this);
	
	    /**
	     * @private
	     * @type {CanvasRenderingContext2D}
	     */
	    this.context_ = context;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.pixelRatio_ = pixelRatio;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.extent_ = extent;
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.transform_ = transform;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.viewRotation_ = viewRotation;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").FillState}
	     */
	    this.contextFillState_ = null;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").StrokeState}
	     */
	    this.contextStrokeState_ = null;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").TextState}
	     */
	    this.contextTextState_ = null;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").FillState}
	     */
	    this.fillState_ = null;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").StrokeState}
	     */
	    this.strokeState_ = null;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageAnchorX_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageAnchorY_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageHeight_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageOpacity_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageOriginX_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageOriginY_ = 0;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.imageRotateWithView_ = false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageRotation_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageScale_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.imageWidth_ = 0;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.text_ = '';
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textOffsetX_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textOffsetY_ = 0;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.textRotateWithView_ = false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textRotation_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textScale_ = 0;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").FillState}
	     */
	    this.textFillState_ = null;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").StrokeState}
	     */
	    this.textStrokeState_ = null;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").TextState}
	     */
	    this.textState_ = null;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.pixelCoordinates_ = [];
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.tmpLocalTransform_ = create();
	
	  }
	
	  if ( VectorContext$$1 ) { CanvasImmediateRenderer.__proto__ = VectorContext$$1; }
	  CanvasImmediateRenderer.prototype = Object.create( VectorContext$$1 && VectorContext$$1.prototype );
	  CanvasImmediateRenderer.prototype.constructor = CanvasImmediateRenderer;
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @private
	   */
	  CanvasImmediateRenderer.prototype.drawImages_ = function drawImages_ (flatCoordinates, offset, end, stride) {
	    if (!this.image_) {
	      return;
	    }
	    var pixelCoordinates = transform2D(
	      flatCoordinates, offset, end, 2, this.transform_,
	      this.pixelCoordinates_);
	    var context = this.context_;
	    var localTransform = this.tmpLocalTransform_;
	    var alpha = context.globalAlpha;
	    if (this.imageOpacity_ != 1) {
	      context.globalAlpha = alpha * this.imageOpacity_;
	    }
	    var rotation = this.imageRotation_;
	    if (this.imageRotateWithView_) {
	      rotation += this.viewRotation_;
	    }
	    for (var i = 0, ii = pixelCoordinates.length; i < ii; i += 2) {
	      var x = pixelCoordinates[i] - this.imageAnchorX_;
	      var y = pixelCoordinates[i + 1] - this.imageAnchorY_;
	      if (rotation !== 0 || this.imageScale_ != 1) {
	        var centerX = x + this.imageAnchorX_;
	        var centerY = y + this.imageAnchorY_;
	        compose(localTransform,
	          centerX, centerY,
	          this.imageScale_, this.imageScale_,
	          rotation,
	          -centerX, -centerY);
	        context.setTransform.apply(context, localTransform);
	      }
	      context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_,
	        this.imageWidth_, this.imageHeight_, x, y,
	        this.imageWidth_, this.imageHeight_);
	    }
	    if (rotation !== 0 || this.imageScale_ != 1) {
	      context.setTransform(1, 0, 0, 1, 0, 0);
	    }
	    if (this.imageOpacity_ != 1) {
	      context.globalAlpha = alpha;
	    }
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @private
	   */
	  CanvasImmediateRenderer.prototype.drawText_ = function drawText_ (flatCoordinates, offset, end, stride) {
	    if (!this.textState_ || this.text_ === '') {
	      return;
	    }
	    if (this.textFillState_) {
	      this.setContextFillState_(this.textFillState_);
	    }
	    if (this.textStrokeState_) {
	      this.setContextStrokeState_(this.textStrokeState_);
	    }
	    this.setContextTextState_(this.textState_);
	    var pixelCoordinates = transform2D(
	      flatCoordinates, offset, end, stride, this.transform_,
	      this.pixelCoordinates_);
	    var context = this.context_;
	    var rotation = this.textRotation_;
	    if (this.textRotateWithView_) {
	      rotation += this.viewRotation_;
	    }
	    for (; offset < end; offset += stride) {
	      var x = pixelCoordinates[offset] + this.textOffsetX_;
	      var y = pixelCoordinates[offset + 1] + this.textOffsetY_;
	      if (rotation !== 0 || this.textScale_ != 1) {
	        var localTransform = compose(this.tmpLocalTransform_,
	          x, y,
	          this.textScale_, this.textScale_,
	          rotation,
	          -x, -y);
	        context.setTransform.apply(context, localTransform);
	      }
	      if (this.textStrokeState_) {
	        context.strokeText(this.text_, x, y);
	      }
	      if (this.textFillState_) {
	        context.fillText(this.text_, x, y);
	      }
	    }
	    if (rotation !== 0 || this.textScale_ != 1) {
	      context.setTransform(1, 0, 0, 1, 0, 0);
	    }
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @param {boolean} close Close.
	   * @private
	   * @return {number} end End.
	   */
	  CanvasImmediateRenderer.prototype.moveToLineTo_ = function moveToLineTo_ (flatCoordinates, offset, end, stride, close) {
	    var context = this.context_;
	    var pixelCoordinates = transform2D(
	      flatCoordinates, offset, end, stride, this.transform_,
	      this.pixelCoordinates_);
	    context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
	    var length = pixelCoordinates.length;
	    if (close) {
	      length -= 2;
	    }
	    for (var i = 2; i < length; i += 2) {
	      context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
	    }
	    if (close) {
	      context.closePath();
	    }
	    return end;
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {Array<number>} ends Ends.
	   * @param {number} stride Stride.
	   * @private
	   * @return {number} End.
	   */
	  CanvasImmediateRenderer.prototype.drawRings_ = function drawRings_ (flatCoordinates, offset, ends, stride) {
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
	    }
	    return offset;
	  };
	
	  /**
	   * Render a circle geometry into the canvas.  Rendering is immediate and uses
	   * the current fill and stroke styles.
	   *
	   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
	   * @override
	   * @api
	   */
	  CanvasImmediateRenderer.prototype.drawCircle = function drawCircle (geometry) {
	    if (!intersects(this.extent_, geometry.getExtent())) {
	      return;
	    }
	    if (this.fillState_ || this.strokeState_) {
	      if (this.fillState_) {
	        this.setContextFillState_(this.fillState_);
	      }
	      if (this.strokeState_) {
	        this.setContextStrokeState_(this.strokeState_);
	      }
	      var pixelCoordinates = transformGeom2D(
	        geometry, this.transform_, this.pixelCoordinates_);
	      var dx = pixelCoordinates[2] - pixelCoordinates[0];
	      var dy = pixelCoordinates[3] - pixelCoordinates[1];
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      var context = this.context_;
	      context.beginPath();
	      context.arc(
	        pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
	      if (this.fillState_) {
	        context.fill();
	      }
	      if (this.strokeState_) {
	        context.stroke();
	      }
	    }
	    if (this.text_ !== '') {
	      this.drawText_(geometry.getCenter(), 0, 2, 2);
	    }
	  };
	
	  /**
	   * Set the rendering style.  Note that since this is an immediate rendering API,
	   * any `zIndex` on the provided style will be ignored.
	   *
	   * @param {import("../../style/Style.js").default} style The rendering style.
	   * @override
	   * @api
	   */
	  CanvasImmediateRenderer.prototype.setStyle = function setStyle (style) {
	    this.setFillStrokeStyle(style.getFill(), style.getStroke());
	    this.setImageStyle(style.getImage());
	    this.setTextStyle(style.getText());
	  };
	
	  /**
	   * Render a geometry into the canvas.  Call
	   * {@link module:ol/render/canvas/Immediate#setStyle} first to set the rendering style.
	   *
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
	   * @override
	   * @api
	   */
	  CanvasImmediateRenderer.prototype.drawGeometry = function drawGeometry (geometry) {
	    var type = geometry.getType();
	    switch (type) {
	      case GeometryType.POINT:
	        this.drawPoint(/** @type {import("../../geom/Point.js").default} */ (geometry));
	        break;
	      case GeometryType.LINE_STRING:
	        this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ (geometry));
	        break;
	      case GeometryType.POLYGON:
	        this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ (geometry));
	        break;
	      case GeometryType.MULTI_POINT:
	        this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ (geometry));
	        break;
	      case GeometryType.MULTI_LINE_STRING:
	        this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ (geometry));
	        break;
	      case GeometryType.MULTI_POLYGON:
	        this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ (geometry));
	        break;
	      case GeometryType.GEOMETRY_COLLECTION:
	        this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ (geometry));
	        break;
	      case GeometryType.CIRCLE:
	        this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ (geometry));
	        break;
	      default:
	    }
	  };
	
	  /**
	   * Render a feature into the canvas.  Note that any `zIndex` on the provided
	   * style will be ignored - features are rendered immediately in the order that
	   * this method is called.  If you need `zIndex` support, you should be using an
	   * {@link module:ol/layer/Vector~VectorLayer} instead.
	   *
	   * @param {import("../../Feature.js").default} feature Feature.
	   * @param {import("../../style/Style.js").default} style Style.
	   * @override
	   * @api
	   */
	  CanvasImmediateRenderer.prototype.drawFeature = function drawFeature (feature, style) {
	    var geometry = style.getGeometryFunction()(feature);
	    if (!geometry || !intersects(this.extent_, geometry.getExtent())) {
	      return;
	    }
	    this.setStyle(style);
	    this.drawGeometry(geometry);
	  };
	
	  /**
	   * Render a GeometryCollection to the canvas.  Rendering is immediate and
	   * uses the current styles appropriate for each geometry in the collection.
	   *
	   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawGeometryCollection = function drawGeometryCollection (geometry) {
	    var geometries = geometry.getGeometriesArray();
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      this.drawGeometry(geometries[i]);
	    }
	  };
	
	  /**
	   * Render a Point geometry into the canvas.  Rendering is immediate and uses
	   * the current style.
	   *
	   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawPoint = function drawPoint (geometry) {
	    var flatCoordinates = geometry.getFlatCoordinates();
	    var stride = geometry.getStride();
	    if (this.image_) {
	      this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
	    }
	    if (this.text_ !== '') {
	      this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
	    }
	  };
	
	  /**
	   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
	   * uses the current style.
	   *
	   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawMultiPoint = function drawMultiPoint (geometry) {
	    var flatCoordinates = geometry.getFlatCoordinates();
	    var stride = geometry.getStride();
	    if (this.image_) {
	      this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
	    }
	    if (this.text_ !== '') {
	      this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
	    }
	  };
	
	  /**
	   * Render a LineString into the canvas.  Rendering is immediate and uses
	   * the current style.
	   *
	   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawLineString = function drawLineString (geometry) {
	    if (!intersects(this.extent_, geometry.getExtent())) {
	      return;
	    }
	    if (this.strokeState_) {
	      this.setContextStrokeState_(this.strokeState_);
	      var context = this.context_;
	      var flatCoordinates = geometry.getFlatCoordinates();
	      context.beginPath();
	      this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length,
	        geometry.getStride(), false);
	      context.stroke();
	    }
	    if (this.text_ !== '') {
	      var flatMidpoint = geometry.getFlatMidpoint();
	      this.drawText_(flatMidpoint, 0, 2, 2);
	    }
	  };
	
	  /**
	   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
	   * and uses the current style.
	   *
	   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawMultiLineString = function drawMultiLineString (geometry) {
	    var geometryExtent = geometry.getExtent();
	    if (!intersects(this.extent_, geometryExtent)) {
	      return;
	    }
	    if (this.strokeState_) {
	      this.setContextStrokeState_(this.strokeState_);
	      var context = this.context_;
	      var flatCoordinates = geometry.getFlatCoordinates();
	      var offset = 0;
	      var ends = /** @type {Array<number>} */ (geometry.getEnds());
	      var stride = geometry.getStride();
	      context.beginPath();
	      for (var i = 0, ii = ends.length; i < ii; ++i) {
	        offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
	      }
	      context.stroke();
	    }
	    if (this.text_ !== '') {
	      var flatMidpoints = geometry.getFlatMidpoints();
	      this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
	    }
	  };
	
	  /**
	   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
	   * the current style.
	   *
	   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawPolygon = function drawPolygon (geometry) {
	    if (!intersects(this.extent_, geometry.getExtent())) {
	      return;
	    }
	    if (this.strokeState_ || this.fillState_) {
	      if (this.fillState_) {
	        this.setContextFillState_(this.fillState_);
	      }
	      if (this.strokeState_) {
	        this.setContextStrokeState_(this.strokeState_);
	      }
	      var context = this.context_;
	      context.beginPath();
	      this.drawRings_(geometry.getOrientedFlatCoordinates(),
	        0, /** @type {Array<number>} */ (geometry.getEnds()), geometry.getStride());
	      if (this.fillState_) {
	        context.fill();
	      }
	      if (this.strokeState_) {
	        context.stroke();
	      }
	    }
	    if (this.text_ !== '') {
	      var flatInteriorPoint = geometry.getFlatInteriorPoint();
	      this.drawText_(flatInteriorPoint, 0, 2, 2);
	    }
	  };
	
	  /**
	   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
	   * uses the current style.
	   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.drawMultiPolygon = function drawMultiPolygon (geometry) {
	    if (!intersects(this.extent_, geometry.getExtent())) {
	      return;
	    }
	    if (this.strokeState_ || this.fillState_) {
	      if (this.fillState_) {
	        this.setContextFillState_(this.fillState_);
	      }
	      if (this.strokeState_) {
	        this.setContextStrokeState_(this.strokeState_);
	      }
	      var context = this.context_;
	      var flatCoordinates = geometry.getOrientedFlatCoordinates();
	      var offset = 0;
	      var endss = geometry.getEndss();
	      var stride = geometry.getStride();
	      context.beginPath();
	      for (var i = 0, ii = endss.length; i < ii; ++i) {
	        var ends = endss[i];
	        offset = this.drawRings_(flatCoordinates, offset, ends, stride);
	      }
	      if (this.fillState_) {
	        context.fill();
	      }
	      if (this.strokeState_) {
	        context.stroke();
	      }
	    }
	    if (this.text_ !== '') {
	      var flatInteriorPoints = geometry.getFlatInteriorPoints();
	      this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
	    }
	  };
	
	  /**
	   * @param {import("../canvas.js").FillState} fillState Fill state.
	   * @private
	   */
	  CanvasImmediateRenderer.prototype.setContextFillState_ = function setContextFillState_ (fillState) {
	    var context = this.context_;
	    var contextFillState = this.contextFillState_;
	    if (!contextFillState) {
	      context.fillStyle = fillState.fillStyle;
	      this.contextFillState_ = {
	        fillStyle: fillState.fillStyle
	      };
	    } else {
	      if (contextFillState.fillStyle != fillState.fillStyle) {
	        contextFillState.fillStyle = context.fillStyle = fillState.fillStyle;
	      }
	    }
	  };
	
	  /**
	   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
	   * @private
	   */
	  CanvasImmediateRenderer.prototype.setContextStrokeState_ = function setContextStrokeState_ (strokeState) {
	    var context = this.context_;
	    var contextStrokeState = this.contextStrokeState_;
	    if (!contextStrokeState) {
	      context.lineCap = /** @type {CanvasLineCap} */ (strokeState.lineCap);
	      if (CANVAS_LINE_DASH) {
	        context.setLineDash(strokeState.lineDash);
	        context.lineDashOffset = strokeState.lineDashOffset;
	      }
	      context.lineJoin = /** @type {CanvasLineJoin} */ (strokeState.lineJoin);
	      context.lineWidth = strokeState.lineWidth;
	      context.miterLimit = strokeState.miterLimit;
	      context.strokeStyle = strokeState.strokeStyle;
	      this.contextStrokeState_ = {
	        lineCap: strokeState.lineCap,
	        lineDash: strokeState.lineDash,
	        lineDashOffset: strokeState.lineDashOffset,
	        lineJoin: strokeState.lineJoin,
	        lineWidth: strokeState.lineWidth,
	        miterLimit: strokeState.miterLimit,
	        strokeStyle: strokeState.strokeStyle
	      };
	    } else {
	      if (contextStrokeState.lineCap != strokeState.lineCap) {
	        contextStrokeState.lineCap = context.lineCap = /** @type {CanvasLineCap} */ (strokeState.lineCap);
	      }
	      if (CANVAS_LINE_DASH) {
	        if (!equals(contextStrokeState.lineDash, strokeState.lineDash)) {
	          context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
	        }
	        if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
	          contextStrokeState.lineDashOffset = context.lineDashOffset =
	              strokeState.lineDashOffset;
	        }
	      }
	      if (contextStrokeState.lineJoin != strokeState.lineJoin) {
	        contextStrokeState.lineJoin = context.lineJoin = /** @type {CanvasLineJoin} */ (strokeState.lineJoin);
	      }
	      if (contextStrokeState.lineWidth != strokeState.lineWidth) {
	        contextStrokeState.lineWidth = context.lineWidth = strokeState.lineWidth;
	      }
	      if (contextStrokeState.miterLimit != strokeState.miterLimit) {
	        contextStrokeState.miterLimit = context.miterLimit =
	            strokeState.miterLimit;
	      }
	      if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
	        contextStrokeState.strokeStyle = context.strokeStyle =
	            strokeState.strokeStyle;
	      }
	    }
	  };
	
	  /**
	   * @param {import("../canvas.js").TextState} textState Text state.
	   * @private
	   */
	  CanvasImmediateRenderer.prototype.setContextTextState_ = function setContextTextState_ (textState) {
	    var context = this.context_;
	    var contextTextState = this.contextTextState_;
	    var textAlign = textState.textAlign ?
	      textState.textAlign : defaultTextAlign;
	    if (!contextTextState) {
	      context.font = textState.font;
	      context.textAlign = /** @type {CanvasTextAlign} */ (textAlign);
	      context.textBaseline = /** @type {CanvasTextBaseline} */ (textState.textBaseline);
	      this.contextTextState_ = {
	        font: textState.font,
	        textAlign: textAlign,
	        textBaseline: textState.textBaseline
	      };
	    } else {
	      if (contextTextState.font != textState.font) {
	        contextTextState.font = context.font = textState.font;
	      }
	      if (contextTextState.textAlign != textAlign) {
	        contextTextState.textAlign = context.textAlign = /** @type {CanvasTextAlign} */ (textAlign);
	      }
	      if (contextTextState.textBaseline != textState.textBaseline) {
	        contextTextState.textBaseline = context.textBaseline =
	          /** @type {CanvasTextBaseline} */ (textState.textBaseline);
	      }
	    }
	  };
	
	  /**
	   * Set the fill and stroke style for subsequent draw operations.  To clear
	   * either fill or stroke styles, pass null for the appropriate parameter.
	   *
	   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
	   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {
	    if (!fillStyle) {
	      this.fillState_ = null;
	    } else {
	      var fillStyleColor = fillStyle.getColor();
	      this.fillState_ = {
	        fillStyle: asColorLike(fillStyleColor ?
	          fillStyleColor : defaultFillStyle)
	      };
	    }
	    if (!strokeStyle) {
	      this.strokeState_ = null;
	    } else {
	      var strokeStyleColor = strokeStyle.getColor();
	      var strokeStyleLineCap = strokeStyle.getLineCap();
	      var strokeStyleLineDash = strokeStyle.getLineDash();
	      var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
	      var strokeStyleLineJoin = strokeStyle.getLineJoin();
	      var strokeStyleWidth = strokeStyle.getWidth();
	      var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
	      this.strokeState_ = {
	        lineCap: strokeStyleLineCap !== undefined ?
	          strokeStyleLineCap : defaultLineCap,
	        lineDash: strokeStyleLineDash ?
	          strokeStyleLineDash : defaultLineDash,
	        lineDashOffset: strokeStyleLineDashOffset ?
	          strokeStyleLineDashOffset : defaultLineDashOffset,
	        lineJoin: strokeStyleLineJoin !== undefined ?
	          strokeStyleLineJoin : defaultLineJoin,
	        lineWidth: this.pixelRatio_ * (strokeStyleWidth !== undefined ?
	          strokeStyleWidth : defaultLineWidth),
	        miterLimit: strokeStyleMiterLimit !== undefined ?
	          strokeStyleMiterLimit : defaultMiterLimit,
	        strokeStyle: asColorLike(strokeStyleColor ?
	          strokeStyleColor : defaultStrokeStyle)
	      };
	    }
	  };
	
	  /**
	   * Set the image style for subsequent draw operations.  Pass null to remove
	   * the image style.
	   *
	   * @param {import("../../style/Image.js").default} imageStyle Image style.
	   * @override
	   */
	  CanvasImmediateRenderer.prototype.setImageStyle = function setImageStyle (imageStyle) {
	    if (!imageStyle) {
	      this.image_ = null;
	    } else {
	      var imageAnchor = imageStyle.getAnchor();
	      // FIXME pixel ratio
	      var imageImage = imageStyle.getImage(1);
	      var imageOrigin = imageStyle.getOrigin();
	      var imageSize = imageStyle.getSize();
	      this.imageAnchorX_ = imageAnchor[0];
	      this.imageAnchorY_ = imageAnchor[1];
	      this.imageHeight_ = imageSize[1];
	      this.image_ = imageImage;
	      this.imageOpacity_ = imageStyle.getOpacity();
	      this.imageOriginX_ = imageOrigin[0];
	      this.imageOriginY_ = imageOrigin[1];
	      this.imageRotateWithView_ = imageStyle.getRotateWithView();
	      this.imageRotation_ = imageStyle.getRotation();
	      this.imageScale_ = imageStyle.getScale() * this.pixelRatio_;
	      this.imageWidth_ = imageSize[0];
	    }
	  };
	
	  /**
	   * Set the text style for subsequent draw operations.  Pass null to
	   * remove the text style.
	   *
	   * @param {import("../../style/Text.js").default} textStyle Text style.
	   * @override
	   * @api
	   */
	  CanvasImmediateRenderer.prototype.setTextStyle = function setTextStyle (textStyle) {
	    if (!textStyle) {
	      this.text_ = '';
	    } else {
	      var textFillStyle = textStyle.getFill();
	      if (!textFillStyle) {
	        this.textFillState_ = null;
	      } else {
	        var textFillStyleColor = textFillStyle.getColor();
	        this.textFillState_ = {
	          fillStyle: asColorLike(textFillStyleColor ?
	            textFillStyleColor : defaultFillStyle)
	        };
	      }
	      var textStrokeStyle = textStyle.getStroke();
	      if (!textStrokeStyle) {
	        this.textStrokeState_ = null;
	      } else {
	        var textStrokeStyleColor = textStrokeStyle.getColor();
	        var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
	        var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
	        var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
	        var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
	        var textStrokeStyleWidth = textStrokeStyle.getWidth();
	        var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
	        this.textStrokeState_ = {
	          lineCap: textStrokeStyleLineCap !== undefined ?
	            textStrokeStyleLineCap : defaultLineCap,
	          lineDash: textStrokeStyleLineDash ?
	            textStrokeStyleLineDash : defaultLineDash,
	          lineDashOffset: textStrokeStyleLineDashOffset ?
	            textStrokeStyleLineDashOffset : defaultLineDashOffset,
	          lineJoin: textStrokeStyleLineJoin !== undefined ?
	            textStrokeStyleLineJoin : defaultLineJoin,
	          lineWidth: textStrokeStyleWidth !== undefined ?
	            textStrokeStyleWidth : defaultLineWidth,
	          miterLimit: textStrokeStyleMiterLimit !== undefined ?
	            textStrokeStyleMiterLimit : defaultMiterLimit,
	          strokeStyle: asColorLike(textStrokeStyleColor ?
	            textStrokeStyleColor : defaultStrokeStyle)
	        };
	      }
	      var textFont = textStyle.getFont();
	      var textOffsetX = textStyle.getOffsetX();
	      var textOffsetY = textStyle.getOffsetY();
	      var textRotateWithView = textStyle.getRotateWithView();
	      var textRotation = textStyle.getRotation();
	      var textScale = textStyle.getScale();
	      var textText = textStyle.getText();
	      var textTextAlign = textStyle.getTextAlign();
	      var textTextBaseline = textStyle.getTextBaseline();
	      this.textState_ = {
	        font: textFont !== undefined ?
	          textFont : defaultFont,
	        textAlign: textTextAlign !== undefined ?
	          textTextAlign : defaultTextAlign,
	        textBaseline: textTextBaseline !== undefined ?
	          textTextBaseline : defaultTextBaseline
	      };
	      this.text_ = textText !== undefined ? textText : '';
	      this.textOffsetX_ =
	          textOffsetX !== undefined ? (this.pixelRatio_ * textOffsetX) : 0;
	      this.textOffsetY_ =
	          textOffsetY !== undefined ? (this.pixelRatio_ * textOffsetY) : 0;
	      this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
	      this.textRotation_ = textRotation !== undefined ? textRotation : 0;
	      this.textScale_ = this.pixelRatio_ * (textScale !== undefined ?
	        textScale : 1);
	    }
	  };
	
	  return CanvasImmediateRenderer;
	}(VectorContext));
	
	/**
	 * @module ol/style/IconImageCache
	 */
	
	/**
	 * @classdesc
	 * Singleton class. Available through {@link module:ol/style/IconImageCache~shared}.
	 */
	var IconImageCache = function IconImageCache() {
	
	  /**
	  * @type {!Object<string, import("./IconImage.js").default>}
	  * @private
	  */
	  this.cache_ = {};
	
	  /**
	  * @type {number}
	  * @private
	  */
	  this.cacheSize_ = 0;
	
	  /**
	  * @type {number}
	  * @private
	  */
	  this.maxCacheSize_ = 32;
	};
	
	/**
	* FIXME empty description for jsdoc
	*/
	IconImageCache.prototype.clear = function clear () {
	  this.cache_ = {};
	  this.cacheSize_ = 0;
	};
	
	/**
	* FIXME empty description for jsdoc
	*/
	IconImageCache.prototype.expire = function expire () {
	  if (this.cacheSize_ > this.maxCacheSize_) {
	    var i = 0;
	    for (var key in this.cache_) {
	      var iconImage = this.cache_[key];
	      if ((i++ & 3) === 0 && !iconImage.hasListener()) {
	        delete this.cache_[key];
	        --this.cacheSize_;
	      }
	    }
	  }
	};
	
	/**
	* @param {string} src Src.
	* @param {?string} crossOrigin Cross origin.
	* @param {import("../color.js").Color} color Color.
	* @return {import("./IconImage.js").default} Icon image.
	*/
	IconImageCache.prototype.get = function get (src, crossOrigin, color) {
	  var key = getKey(src, crossOrigin, color);
	  return key in this.cache_ ? this.cache_[key] : null;
	};
	
	/**
	* @param {string} src Src.
	* @param {?string} crossOrigin Cross origin.
	* @param {import("../color.js").Color} color Color.
	* @param {import("./IconImage.js").default} iconImage Icon image.
	*/
	IconImageCache.prototype.set = function set (src, crossOrigin, color, iconImage) {
	  var key = getKey(src, crossOrigin, color);
	  this.cache_[key] = iconImage;
	  ++this.cacheSize_;
	};
	
	/**
	* Set the cache size of the icon cache. Default is `32`. Change this value when
	* your map uses more than 32 different icon images and you are not caching icon
	* styles on the application level.
	* @param {number} maxCacheSize Cache max size.
	* @api
	*/
	IconImageCache.prototype.setSize = function setSize (maxCacheSize) {
	  this.maxCacheSize_ = maxCacheSize;
	  this.expire();
	};
	
	
	/**
	 * @param {string} src Src.
	 * @param {?string} crossOrigin Cross origin.
	 * @param {import("../color.js").Color} color Color.
	 * @return {string} Cache key.
	 */
	function getKey(src, crossOrigin, color) {
	  var colorString = color ? asString(color) : 'null';
	  return crossOrigin + ':' + src + ':' + colorString;
	}
	
	
	/**
	 * The {@link module:ol/style/IconImageCache~IconImageCache} for
	 * {@link module:ol/style/Icon~Icon} images.
	 * @api
	 */
	var shared = new IconImageCache();
	
	/**
	 * @module ol/renderer/Map
	 */
	
	/**
	 * @abstract
	 * @api
	 */
	var MapRenderer = /*@__PURE__*/(function (Disposable$$1) {
	  function MapRenderer(map) {
	    Disposable$$1.call(this);
	
	    /**
	     * @private
	     * @type {import("../PluggableMap.js").default}
	     */
	    this.map_ = map;
	
	    /**
	     * @private
	     * @type {!Object<string, import("./Layer.js").default>}
	     */
	    this.layerRenderers_ = {};
	
	    /**
	     * @private
	     * @type {Object<string, import("../events.js").EventsKey>}
	     */
	    this.layerRendererListeners_ = {};
	
	    /**
	     * @private
	     * @type {Array<typeof import("./Layer.js").default>}
	     */
	    this.layerRendererConstructors_ = [];
	
	  }
	
	  if ( Disposable$$1 ) { MapRenderer.__proto__ = Disposable$$1; }
	  MapRenderer.prototype = Object.create( Disposable$$1 && Disposable$$1.prototype );
	  MapRenderer.prototype.constructor = MapRenderer;
	
	  /**
	   * @abstract
	   * @param {import("../render/EventType.js").default} type Event type.
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   */
	  MapRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent (type, frameState) {
	    abstract();
	  };
	
	  /**
	   * Register layer renderer constructors.
	   * @param {Array<typeof import("./Layer.js").default>} constructors Layer renderers.
	   */
	  MapRenderer.prototype.registerLayerRenderers = function registerLayerRenderers (constructors) {
	    this.layerRendererConstructors_.push.apply(this.layerRendererConstructors_, constructors);
	  };
	
	  /**
	   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
	   * @protected
	   */
	  MapRenderer.prototype.calculateMatrices2D = function calculateMatrices2D (frameState) {
	    var viewState = frameState.viewState;
	    var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
	    var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
	
	    compose(coordinateToPixelTransform,
	      frameState.size[0] / 2, frameState.size[1] / 2,
	      1 / viewState.resolution, -1 / viewState.resolution,
	      -viewState.rotation,
	      -viewState.center[0], -viewState.center[1]);
	
	    invert(
	      setFromArray(pixelToCoordinateTransform, coordinateToPixelTransform));
	  };
	
	  /**
	   * Removes all layer renderers.
	   */
	  MapRenderer.prototype.removeLayerRenderers = function removeLayerRenderers () {
	    for (var key in this.layerRenderers_) {
	      this.removeLayerRendererByKey_(key).dispose();
	    }
	  };
	
	  /**
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @param {function(this: S, import("../Feature.js").FeatureLike,
	   *     import("../layer/Layer.js").default): T} callback Feature callback.
	   * @param {S} thisArg Value to use as `this` when executing `callback`.
	   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
	   *     function, only layers which are visible and for which this function
	   *     returns `true` will be tested for features.  By default, all visible
	   *     layers will be tested.
	   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
	   * @return {T|undefined} Callback result.
	   * @template S,T,U
	   */
	  MapRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (
	    coordinate,
	    frameState,
	    hitTolerance,
	    callback,
	    thisArg,
	    layerFilter,
	    thisArg2
	  ) {
	    var result;
	    var viewState = frameState.viewState;
	    var viewResolution = viewState.resolution;
	
	    /**
	     * @param {import("../Feature.js").FeatureLike} feature Feature.
	     * @param {import("../layer/Layer.js").default} layer Layer.
	     * @return {?} Callback result.
	     */
	    function forEachFeatureAtCoordinate(feature, layer) {
	      var managed = frameState.layerStates[getUid(layer)].managed;
	      if (!(getUid(feature) in frameState.skippedFeatureUids && !managed)) {
	        return callback.call(thisArg, feature, managed ? layer : null);
	      }
	    }
	
	    var projection = viewState.projection;
	
	    var translatedCoordinate = coordinate;
	    if (projection.canWrapX()) {
	      var projectionExtent = projection.getExtent();
	      var worldWidth = getWidth(projectionExtent);
	      var x = coordinate[0];
	      if (x < projectionExtent[0] || x > projectionExtent[2]) {
	        var worldsAway = Math.ceil((projectionExtent[0] - x) / worldWidth);
	        translatedCoordinate = [x + worldWidth * worldsAway, coordinate[1]];
	      }
	    }
	
	    var layerStates = frameState.layerStatesArray;
	    var numLayers = layerStates.length;
	    var i;
	    for (i = numLayers - 1; i >= 0; --i) {
	      var layerState = layerStates[i];
	      var layer = layerState.layer;
	      if (visibleAtResolution(layerState, viewResolution) && layerFilter.call(thisArg2, layer)) {
	        var layerRenderer = this.getLayerRenderer(layer);
	        var source = /** @type {import("../layer/Layer.js").default} */ (layer).getSource();
	        if (source) {
	          result = layerRenderer.forEachFeatureAtCoordinate(
	            source.getWrapX() ? translatedCoordinate : coordinate,
	            frameState, hitTolerance, forEachFeatureAtCoordinate);
	        }
	        if (result) {
	          return result;
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @abstract
	   * @param {import("../pixel.js").Pixel} pixel Pixel.
	   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @param {function(this: S, import("../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
	   *     callback.
	   * @param {S} thisArg Value to use as `this` when executing `callback`.
	   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
	   *     function, only layers which are visible and for which this function
	   *     returns `true` will be tested for features.  By default, all visible
	   *     layers will be tested.
	   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
	   * @return {T|undefined} Callback result.
	   * @template S,T,U
	   */
	  MapRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, hitTolerance, callback, thisArg, layerFilter, thisArg2) {
	    return abstract();
	  };
	
	  /**
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
	   *     function, only layers which are visible and for which this function
	   *     returns `true` will be tested for features.  By default, all visible
	   *     layers will be tested.
	   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
	   * @return {boolean} Is there a feature at the given coordinate?
	   * @template U
	   */
	  MapRenderer.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate (coordinate, frameState, hitTolerance, layerFilter, thisArg) {
	    var hasFeature = this.forEachFeatureAtCoordinate(
	      coordinate, frameState, hitTolerance, TRUE, this, layerFilter, thisArg);
	
	    return hasFeature !== undefined;
	  };
	
	  /**
	   * @param {import("../layer/Base.js").default} layer Layer.
	   * @protected
	   * @return {import("./Layer.js").default} Layer renderer.
	   */
	  MapRenderer.prototype.getLayerRenderer = function getLayerRenderer (layer) {
	    var layerKey = getUid(layer);
	    if (layerKey in this.layerRenderers_) {
	      return this.layerRenderers_[layerKey];
	    } else {
	      var renderer;
	      for (var i = 0, ii = this.layerRendererConstructors_.length; i < ii; ++i) {
	        var candidate = this.layerRendererConstructors_[i];
	        if (candidate['handles'](layer)) {
	          renderer = candidate['create'](this, layer);
	          break;
	        }
	      }
	      if (renderer) {
	        this.layerRenderers_[layerKey] = renderer;
	        this.layerRendererListeners_[layerKey] = listen(renderer,
	          EventType.CHANGE, this.handleLayerRendererChange_, this);
	      } else {
	        throw new Error('Unable to create renderer for layer: ' + layer.getType());
	      }
	      return renderer;
	    }
	  };
	
	  /**
	   * @param {string} layerKey Layer key.
	   * @protected
	   * @return {import("./Layer.js").default} Layer renderer.
	   */
	  MapRenderer.prototype.getLayerRendererByKey = function getLayerRendererByKey (layerKey) {
	    return this.layerRenderers_[layerKey];
	  };
	
	  /**
	   * @protected
	   * @return {Object<string, import("./Layer.js").default>} Layer renderers.
	   */
	  MapRenderer.prototype.getLayerRenderers = function getLayerRenderers () {
	    return this.layerRenderers_;
	  };
	
	  /**
	   * @return {import("../PluggableMap.js").default} Map.
	   */
	  MapRenderer.prototype.getMap = function getMap () {
	    return this.map_;
	  };
	
	  /**
	   * Handle changes in a layer renderer.
	   * @private
	   */
	  MapRenderer.prototype.handleLayerRendererChange_ = function handleLayerRendererChange_ () {
	    this.map_.render();
	  };
	
	  /**
	   * @param {string} layerKey Layer key.
	   * @return {import("./Layer.js").default} Layer renderer.
	   * @private
	   */
	  MapRenderer.prototype.removeLayerRendererByKey_ = function removeLayerRendererByKey_ (layerKey) {
	    var layerRenderer = this.layerRenderers_[layerKey];
	    delete this.layerRenderers_[layerKey];
	
	    unlistenByKey(this.layerRendererListeners_[layerKey]);
	    delete this.layerRendererListeners_[layerKey];
	
	    return layerRenderer;
	  };
	
	  /**
	   * @param {import("../PluggableMap.js").default} map Map.
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @private
	   */
	  MapRenderer.prototype.removeUnusedLayerRenderers_ = function removeUnusedLayerRenderers_ (map, frameState) {
	    for (var layerKey in this.layerRenderers_) {
	      if (!frameState || !(layerKey in frameState.layerStates)) {
	        this.removeLayerRendererByKey_(layerKey).dispose();
	      }
	    }
	  };
	
	  /**
	   * Render.
	   * @abstract
	   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
	   */
	  MapRenderer.prototype.renderFrame = function renderFrame (frameState) {
	    abstract();
	  };
	
	  /**
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @protected
	   */
	  MapRenderer.prototype.scheduleExpireIconCache = function scheduleExpireIconCache (frameState) {
	    frameState.postRenderFunctions.push(/** @type {import("../PluggableMap.js").PostRenderFunction} */ (expireIconCache));
	  };
	
	  /**
	   * @param {!import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @protected
	   */
	  MapRenderer.prototype.scheduleRemoveUnusedLayerRenderers = function scheduleRemoveUnusedLayerRenderers (frameState) {
	    for (var layerKey in this.layerRenderers_) {
	      if (!(layerKey in frameState.layerStates)) {
	        frameState.postRenderFunctions.push(
	          /** @type {import("../PluggableMap.js").PostRenderFunction} */ (this.removeUnusedLayerRenderers_.bind(this))
	        );
	        return;
	      }
	    }
	  };
	
	  return MapRenderer;
	}(Disposable));
	
	
	/**
	 * @param {import("../PluggableMap.js").default} map Map.
	 * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	 */
	function expireIconCache(map, frameState) {
	  shared.expire();
	}
	
	
	/**
	 * @param {import("../layer/Layer.js").State} state1 First layer state.
	 * @param {import("../layer/Layer.js").State} state2 Second layer state.
	 * @return {number} The zIndex difference.
	 */
	function sortByZIndex(state1, state2) {
	  return state1.zIndex - state2.zIndex;
	}
	
	/**
	 * @module ol/renderer/canvas/Map
	 */
	
	
	/**
	 * @type {Array<typeof import("../Layer.js").default>}
	 */
	var layerRendererConstructors = [];
	
	/**
	 * @classdesc
	 * Canvas map renderer.
	 * @api
	 */
	var CanvasMapRenderer = /*@__PURE__*/(function (MapRenderer$$1) {
	  function CanvasMapRenderer(map) {
	    MapRenderer$$1.call(this, map);
	
	    var container = map.getViewport();
	
	    /**
	     * @private
	     * @type {CanvasRenderingContext2D}
	     */
	    this.context_ = createCanvasContext2D();
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = this.context_.canvas;
	
	    this.canvas_.style.width = '100%';
	    this.canvas_.style.height = '100%';
	    this.canvas_.style.display = 'block';
	    this.canvas_.className = CLASS_UNSELECTABLE;
	    container.insertBefore(this.canvas_, container.childNodes[0] || null);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderedVisible_ = true;
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.transform_ = create();
	
	  }
	
	  if ( MapRenderer$$1 ) { CanvasMapRenderer.__proto__ = MapRenderer$$1; }
	  CanvasMapRenderer.prototype = Object.create( MapRenderer$$1 && MapRenderer$$1.prototype );
	  CanvasMapRenderer.prototype.constructor = CanvasMapRenderer;
	
	  /**
	   * @param {import("../../render/EventType.js").default} type Event type.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   */
	  CanvasMapRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent (type, frameState) {
	    var map = this.getMap();
	    var context = this.context_;
	    if (map.hasListener(type)) {
	      var extent = frameState.extent;
	      var pixelRatio = frameState.pixelRatio;
	      var viewState = frameState.viewState;
	      var rotation = viewState.rotation;
	
	      var transform = this.getTransform(frameState);
	
	      var vectorContext = new CanvasImmediateRenderer(context, pixelRatio,
	        extent, transform, rotation);
	      var composeEvent = new RenderEvent(type, vectorContext,
	        frameState, context, null);
	      map.dispatchEvent(composeEvent);
	    }
	  };
	
	  /**
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @protected
	   * @return {!import("../../transform.js").Transform} Transform.
	   */
	  CanvasMapRenderer.prototype.getTransform = function getTransform (frameState) {
	    var viewState = frameState.viewState;
	    var dx1 = this.canvas_.width / 2;
	    var dy1 = this.canvas_.height / 2;
	    var sx = frameState.pixelRatio / viewState.resolution;
	    var sy = -sx;
	    var angle = -viewState.rotation;
	    var dx2 = -viewState.center[0];
	    var dy2 = -viewState.center[1];
	    return compose(this.transform_, dx1, dy1, sx, sy, angle, dx2, dy2);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasMapRenderer.prototype.renderFrame = function renderFrame (frameState) {
	
	    if (!frameState) {
	      if (this.renderedVisible_) {
	        this.canvas_.style.display = 'none';
	        this.renderedVisible_ = false;
	      }
	      return;
	    }
	
	    var context = this.context_;
	    var pixelRatio = frameState.pixelRatio;
	    var width = Math.round(frameState.size[0] * pixelRatio);
	    var height = Math.round(frameState.size[1] * pixelRatio);
	    if (this.canvas_.width != width || this.canvas_.height != height) {
	      this.canvas_.width = width;
	      this.canvas_.height = height;
	    } else {
	      context.clearRect(0, 0, width, height);
	    }
	
	    var rotation = frameState.viewState.rotation;
	
	    this.calculateMatrices2D(frameState);
	
	    this.dispatchRenderEvent(RenderEventType.PRECOMPOSE, frameState);
	
	    var layerStatesArray = frameState.layerStatesArray;
	    stableSort(layerStatesArray, sortByZIndex);
	
	    if (rotation) {
	      context.save();
	      rotateAtOffset(context, rotation, width / 2, height / 2);
	    }
	
	    var viewResolution = frameState.viewState.resolution;
	    var i, ii;
	    for (i = 0, ii = layerStatesArray.length; i < ii; ++i) {
	      var layerState = layerStatesArray[i];
	      var layer = layerState.layer;
	      var layerRenderer = /** @type {import("./Layer.js").default} */ (this.getLayerRenderer(layer));
	      if (!visibleAtResolution(layerState, viewResolution) ||
	          layerState.sourceState != SourceState.READY) {
	        continue;
	      }
	      if (layerRenderer.prepareFrame(frameState, layerState)) {
	        layerRenderer.composeFrame(frameState, layerState, context);
	      }
	    }
	
	    if (rotation) {
	      context.restore();
	    }
	
	    this.dispatchRenderEvent(RenderEventType.POSTCOMPOSE, frameState);
	
	    if (!this.renderedVisible_) {
	      this.canvas_.style.display = '';
	      this.renderedVisible_ = true;
	    }
	
	    this.scheduleRemoveUnusedLayerRenderers(frameState);
	    this.scheduleExpireIconCache(frameState);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasMapRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, hitTolerance, callback, thisArg, layerFilter, thisArg2) {
	    var result;
	    var viewState = frameState.viewState;
	    var viewResolution = viewState.resolution;
	
	    var layerStates = frameState.layerStatesArray;
	    var numLayers = layerStates.length;
	
	    var coordinate = apply(
	      frameState.pixelToCoordinateTransform, pixel.slice());
	
	    var i;
	    for (i = numLayers - 1; i >= 0; --i) {
	      var layerState = layerStates[i];
	      var layer = layerState.layer;
	      if (visibleAtResolution(layerState, viewResolution) && layerFilter.call(thisArg2, layer)) {
	        var layerRenderer = /** @type {import("./Layer.js").default} */ (this.getLayerRenderer(layer));
	        result = layerRenderer.forEachLayerAtCoordinate(
	          coordinate, frameState, hitTolerance, callback, thisArg);
	        if (result) {
	          return result;
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasMapRenderer.prototype.registerLayerRenderers = function registerLayerRenderers (constructors) {
	    MapRenderer$$1.prototype.registerLayerRenderers.call(this, constructors);
	    for (var i = 0, ii = constructors.length; i < ii; ++i) {
	      var ctor = constructors[i];
	      if (!includes(layerRendererConstructors, ctor)) {
	        layerRendererConstructors.push(ctor);
	      }
	    }
	  };
	
	  return CanvasMapRenderer;
	}(MapRenderer));
	
	/**
	 * @module ol/renderer/Layer
	 */
	
	var LayerRenderer = /*@__PURE__*/(function (Observable$$1) {
	  function LayerRenderer(layer) {
	
	    Observable$$1.call(this);
	
	    /**
	     * @private
	     * @type {import("../layer/Layer.js").default}
	     */
	    this.layer_ = layer;
	
	  }
	
	  if ( Observable$$1 ) { LayerRenderer.__proto__ = Observable$$1; }
	  LayerRenderer.prototype = Object.create( Observable$$1 && Observable$$1.prototype );
	  LayerRenderer.prototype.constructor = LayerRenderer;
	
	  /**
	   * Create a function that adds loaded tiles to the tile lookup.
	   * @param {import("../source/Tile.js").default} source Tile source.
	   * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
	   * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
	   * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
	   *     called with a zoom level and a tile range to add loaded tiles to the lookup.
	   * @protected
	   */
	  LayerRenderer.prototype.createLoadedTileFinder = function createLoadedTileFinder (source, projection, tiles) {
	    return (
	      /**
	       * @param {number} zoom Zoom level.
	       * @param {import("../TileRange.js").default} tileRange Tile range.
	       * @return {boolean} The tile range is fully loaded.
	       */
	      function(zoom, tileRange) {
	        /**
	         * @param {import("../Tile.js").default} tile Tile.
	         */
	        function callback(tile) {
	          if (!tiles[zoom]) {
	            tiles[zoom] = {};
	          }
	          tiles[zoom][tile.tileCoord.toString()] = tile;
	        }
	        return source.forEachLoadedTile(projection, zoom, tileRange, callback);
	      }
	    );
	  };
	
	  /**
	   * @abstract
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @param {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default): T} callback Feature callback.
	   * @return {T|void} Callback result.
	   * @template T
	   */
	  LayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback) {};
	
	  /**
	   * @return {import("../layer/Layer.js").default} Layer.
	   */
	  LayerRenderer.prototype.getLayer = function getLayer () {
	    return this.layer_;
	  };
	
	  /**
	   * Handle changes in image state.
	   * @param {import("../events/Event.js").default} event Image change event.
	   * @private
	   */
	  LayerRenderer.prototype.handleImageChange_ = function handleImageChange_ (event) {
	    var image = /** @type {import("../Image.js").default} */ (event.target);
	    if (image.getState() === ImageState.LOADED) {
	      this.renderIfReadyAndVisible();
	    }
	  };
	
	  /**
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @return {boolean} Is there a feature at the given coordinate?
	   */
	  LayerRenderer.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate (coordinate, frameState) {
	    return false;
	  };
	
	  /**
	   * Load the image if not already loaded, and register the image change
	   * listener if needed.
	   * @param {import("../ImageBase.js").default} image Image.
	   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
	   * @protected
	   */
	  LayerRenderer.prototype.loadImage = function loadImage (image) {
	    var imageState = image.getState();
	    if (imageState != ImageState.LOADED && imageState != ImageState.ERROR) {
	      listen(image, EventType.CHANGE, this.handleImageChange_, this);
	    }
	    if (imageState == ImageState.IDLE) {
	      image.load();
	      imageState = image.getState();
	    }
	    return imageState == ImageState.LOADED;
	  };
	
	  /**
	   * @protected
	   */
	  LayerRenderer.prototype.renderIfReadyAndVisible = function renderIfReadyAndVisible () {
	    var layer = this.getLayer();
	    if (layer.getVisible() && layer.getSourceState() == SourceState.READY) {
	      this.changed();
	    }
	  };
	
	  /**
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../source/Tile.js").default} tileSource Tile source.
	   * @protected
	   */
	  LayerRenderer.prototype.scheduleExpireCache = function scheduleExpireCache (frameState, tileSource) {
	    if (tileSource.canExpireCache()) {
	      /**
	       * @param {import("../source/Tile.js").default} tileSource Tile source.
	       * @param {import("../PluggableMap.js").default} map Map.
	       * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	       */
	      var postRenderFunction = function(tileSource, map, frameState) {
	        var tileSourceKey = getUid(tileSource);
	        if (tileSourceKey in frameState.usedTiles) {
	          tileSource.expireCache(frameState.viewState.projection,
	            frameState.usedTiles[tileSourceKey]);
	        }
	      }.bind(null, tileSource);
	
	      frameState.postRenderFunctions.push(
	        /** @type {import("../PluggableMap.js").PostRenderFunction} */ (postRenderFunction)
	      );
	    }
	  };
	
	  /**
	   * @param {!Object<string, !Object<string, import("../TileRange.js").default>>} usedTiles Used tiles.
	   * @param {import("../source/Tile.js").default} tileSource Tile source.
	   * @param {number} z Z.
	   * @param {import("../TileRange.js").default} tileRange Tile range.
	   * @protected
	   */
	  LayerRenderer.prototype.updateUsedTiles = function updateUsedTiles (usedTiles, tileSource, z, tileRange) {
	    // FIXME should we use tilesToDrawByZ instead?
	    var tileSourceKey = getUid(tileSource);
	    var zKey = z.toString();
	    if (tileSourceKey in usedTiles) {
	      if (zKey in usedTiles[tileSourceKey]) {
	        usedTiles[tileSourceKey][zKey].extend(tileRange);
	      } else {
	        usedTiles[tileSourceKey][zKey] = tileRange;
	      }
	    } else {
	      usedTiles[tileSourceKey] = {};
	      usedTiles[tileSourceKey][zKey] = tileRange;
	    }
	  };
	
	  /**
	   * Manage tile pyramid.
	   * This function performs a number of functions related to the tiles at the
	   * current zoom and lower zoom levels:
	   * - registers idle tiles in frameState.wantedTiles so that they are not
	   *   discarded by the tile queue
	   * - enqueues missing tiles
	   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../source/Tile.js").default} tileSource Tile source.
	   * @param {import("../tilegrid/TileGrid.js").default} tileGrid Tile grid.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {number} currentZ Current Z.
	   * @param {number} preload Load low resolution tiles up to 'preload' levels.
	   * @param {function(this: T, import("../Tile.js").default)=} opt_tileCallback Tile callback.
	   * @param {T=} opt_this Object to use as `this` in `opt_tileCallback`.
	   * @protected
	   * @template T
	   */
	  LayerRenderer.prototype.manageTilePyramid = function manageTilePyramid (
	    frameState,
	    tileSource,
	    tileGrid,
	    pixelRatio,
	    projection,
	    extent,
	    currentZ,
	    preload,
	    opt_tileCallback,
	    opt_this
	  ) {
	    var tileSourceKey = getUid(tileSource);
	    if (!(tileSourceKey in frameState.wantedTiles)) {
	      frameState.wantedTiles[tileSourceKey] = {};
	    }
	    var wantedTiles = frameState.wantedTiles[tileSourceKey];
	    var tileQueue = frameState.tileQueue;
	    var minZoom = tileGrid.getMinZoom();
	    var tile, tileRange, tileResolution, x, y, z;
	    for (z = minZoom; z <= currentZ; ++z) {
	      tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
	      tileResolution = tileGrid.getResolution(z);
	      for (x = tileRange.minX; x <= tileRange.maxX; ++x) {
	        for (y = tileRange.minY; y <= tileRange.maxY; ++y) {
	          if (currentZ - z <= preload) {
	            tile = tileSource.getTile(z, x, y, pixelRatio, projection);
	            if (tile.getState() == TileState.IDLE) {
	              wantedTiles[tile.getKey()] = true;
	              if (!tileQueue.isKeyQueued(tile.getKey())) {
	                tileQueue.enqueue([tile, tileSourceKey,
	                  tileGrid.getTileCoordCenter(tile.tileCoord), tileResolution]);
	              }
	            }
	            if (opt_tileCallback !== undefined) {
	              opt_tileCallback.call(opt_this, tile);
	            }
	          } else {
	            tileSource.useTile(z, x, y, projection);
	          }
	        }
	      }
	    }
	  };
	
	  return LayerRenderer;
	}(Observable));
	
	/**
	 * @module ol/renderer/canvas/Layer
	 */
	
	/**
	 * @abstract
	 */
	var CanvasLayerRenderer = /*@__PURE__*/(function (LayerRenderer$$1) {
	  function CanvasLayerRenderer(layer) {
	
	    LayerRenderer$$1.call(this, layer);
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.renderedResolution;
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.transform_ = create();
	
	  }
	
	  if ( LayerRenderer$$1 ) { CanvasLayerRenderer.__proto__ = LayerRenderer$$1; }
	  CanvasLayerRenderer.prototype = Object.create( LayerRenderer$$1 && LayerRenderer$$1.prototype );
	  CanvasLayerRenderer.prototype.constructor = CanvasLayerRenderer;
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../extent.js").Extent} extent Clip extent.
	   * @protected
	   */
	  CanvasLayerRenderer.prototype.clip = function clip (context, frameState, extent) {
	    var pixelRatio = frameState.pixelRatio;
	    var width = frameState.size[0] * pixelRatio;
	    var height = frameState.size[1] * pixelRatio;
	    var rotation = frameState.viewState.rotation;
	    var topLeft = getTopLeft(extent);
	    var topRight = getTopRight(extent);
	    var bottomRight = getBottomRight(extent);
	    var bottomLeft = getBottomLeft(extent);
	
	    apply(frameState.coordinateToPixelTransform, topLeft);
	    apply(frameState.coordinateToPixelTransform, topRight);
	    apply(frameState.coordinateToPixelTransform, bottomRight);
	    apply(frameState.coordinateToPixelTransform, bottomLeft);
	
	    context.save();
	    rotateAtOffset(context, -rotation, width / 2, height / 2);
	    context.beginPath();
	    context.moveTo(topLeft[0] * pixelRatio, topLeft[1] * pixelRatio);
	    context.lineTo(topRight[0] * pixelRatio, topRight[1] * pixelRatio);
	    context.lineTo(bottomRight[0] * pixelRatio, bottomRight[1] * pixelRatio);
	    context.lineTo(bottomLeft[0] * pixelRatio, bottomLeft[1] * pixelRatio);
	    context.clip();
	    rotateAtOffset(context, rotation, width / 2, height / 2);
	  };
	
	  /**
	   * @param {import("../../render/EventType.js").default} type Event type.
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../transform.js").Transform=} opt_transform Transform.
	   * @private
	   */
	  CanvasLayerRenderer.prototype.dispatchComposeEvent_ = function dispatchComposeEvent_ (type, context, frameState, opt_transform) {
	    var layer = this.getLayer();
	    if (layer.hasListener(type)) {
	      var width = frameState.size[0] * frameState.pixelRatio;
	      var height = frameState.size[1] * frameState.pixelRatio;
	      var rotation = frameState.viewState.rotation;
	      rotateAtOffset(context, -rotation, width / 2, height / 2);
	      var transform = opt_transform !== undefined ?
	        opt_transform : this.getTransform(frameState, 0);
	      var render = new CanvasImmediateRenderer(
	        context, frameState.pixelRatio, frameState.extent, transform,
	        frameState.viewState.rotation);
	      var composeEvent = new RenderEvent(type, render, frameState,
	        context, null);
	      layer.dispatchEvent(composeEvent);
	      rotateAtOffset(context, rotation, width / 2, height / 2);
	    }
	  };
	
	  /**
	   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @param {function(this: S, import("../../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
	   *     callback.
	   * @param {S} thisArg Value to use as `this` when executing `callback`.
	   * @return {T|undefined} Callback result.
	   * @template S,T,U
	   */
	  CanvasLayerRenderer.prototype.forEachLayerAtCoordinate = function forEachLayerAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
	    var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, TRUE);
	
	    if (hasFeature) {
	      return callback.call(thisArg, this.getLayer(), null);
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   * @param {import("../../transform.js").Transform=} opt_transform Transform.
	   * @protected
	   */
	  CanvasLayerRenderer.prototype.postCompose = function postCompose (context, frameState, layerState, opt_transform) {
	    this.dispatchComposeEvent_(RenderEventType.POSTCOMPOSE, context, frameState, opt_transform);
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../transform.js").Transform=} opt_transform Transform.
	   * @protected
	   */
	  CanvasLayerRenderer.prototype.preCompose = function preCompose (context, frameState, opt_transform) {
	    this.dispatchComposeEvent_(RenderEventType.PRECOMPOSE, context, frameState, opt_transform);
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../transform.js").Transform=} opt_transform Transform.
	   * @protected
	   */
	  CanvasLayerRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent (context, frameState, opt_transform) {
	    this.dispatchComposeEvent_(RenderEventType.RENDER, context, frameState, opt_transform);
	  };
	
	  /**
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {number} offsetX Offset on the x-axis in view coordinates.
	   * @protected
	   * @return {!import("../../transform.js").Transform} Transform.
	   */
	  CanvasLayerRenderer.prototype.getTransform = function getTransform (frameState, offsetX) {
	    var viewState = frameState.viewState;
	    var pixelRatio = frameState.pixelRatio;
	    var dx1 = pixelRatio * frameState.size[0] / 2;
	    var dy1 = pixelRatio * frameState.size[1] / 2;
	    var sx = pixelRatio / viewState.resolution;
	    var sy = -sx;
	    var angle = -viewState.rotation;
	    var dx2 = -viewState.center[0] + offsetX;
	    var dy2 = -viewState.center[1];
	    return compose(this.transform_, dx1, dy1, sx, sy, angle, dx2, dy2);
	  };
	
	  /**
	   * @abstract
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   * @param {CanvasRenderingContext2D} context Context.
	   */
	  CanvasLayerRenderer.prototype.composeFrame = function composeFrame (frameState, layerState, context) {
	    abstract();
	  };
	
	  /**
	   * @abstract
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   * @return {boolean} whether composeFrame should be called.
	   */
	  CanvasLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState) {
	    return abstract();
	  };
	
	  return CanvasLayerRenderer;
	}(LayerRenderer));
	
	/**
	 * @module ol/renderer/canvas/IntermediateCanvas
	 */
	
	/**
	 * @abstract
	 * @api
	 */
	var IntermediateCanvasRenderer = /*@__PURE__*/(function (CanvasLayerRenderer$$1) {
	  function IntermediateCanvasRenderer(layer) {
	
	    CanvasLayerRenderer$$1.call(this, layer);
	
	    /**
	     * @protected
	     * @type {import("../../transform.js").Transform}
	     */
	    this.coordinateToCanvasPixelTransform = create();
	
	    /**
	     * @private
	     * @type {CanvasRenderingContext2D}
	     */
	    this.hitCanvasContext_ = null;
	
	  }
	
	  if ( CanvasLayerRenderer$$1 ) { IntermediateCanvasRenderer.__proto__ = CanvasLayerRenderer$$1; }
	  IntermediateCanvasRenderer.prototype = Object.create( CanvasLayerRenderer$$1 && CanvasLayerRenderer$$1.prototype );
	  IntermediateCanvasRenderer.prototype.constructor = IntermediateCanvasRenderer;
	
	  /**
	   * @inheritDoc
	   */
	  IntermediateCanvasRenderer.prototype.composeFrame = function composeFrame (frameState, layerState, context) {
	
	    this.preCompose(context, frameState);
	
	    var image = this.getImage();
	    if (image) {
	
	      // clipped rendering if layer extent is set
	      var extent = layerState.extent;
	      var clipped = extent !== undefined &&
	          !containsExtent(extent, frameState.extent) &&
	          intersects(extent, frameState.extent);
	      if (clipped) {
	        this.clip(context, frameState, /** @type {import("../../extent.js").Extent} */ (extent));
	      }
	
	      var imageTransform = this.getImageTransform();
	      // for performance reasons, context.save / context.restore is not used
	      // to save and restore the transformation matrix and the opacity.
	      // see http://jsperf.com/context-save-restore-versus-variable
	      var alpha = context.globalAlpha;
	      context.globalAlpha = layerState.opacity;
	
	      // for performance reasons, context.setTransform is only used
	      // when the view is rotated. see http://jsperf.com/canvas-transform
	      var dx = imageTransform[4];
	      var dy = imageTransform[5];
	      var dw = image.width * imageTransform[0];
	      var dh = image.height * imageTransform[3];
	      if (dw >= 0.5 && dh >= 0.5) {
	        context.drawImage(image, 0, 0, +image.width, +image.height,
	          Math.round(dx), Math.round(dy), Math.round(dw), Math.round(dh));
	      }
	      context.globalAlpha = alpha;
	
	      if (clipped) {
	        context.restore();
	      }
	    }
	
	    this.postCompose(context, frameState, layerState);
	  };
	
	  /**
	   * @abstract
	   * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Canvas.
	   */
	  IntermediateCanvasRenderer.prototype.getImage = function getImage () {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @return {!import("../../transform.js").Transform} Image transform.
	   */
	  IntermediateCanvasRenderer.prototype.getImageTransform = function getImageTransform () {
	    return abstract();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  IntermediateCanvasRenderer.prototype.forEachLayerAtCoordinate = function forEachLayerAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
	    if (!this.getImage()) {
	      return undefined;
	    }
	
	    var pixel = apply(this.coordinateToCanvasPixelTransform, coordinate.slice());
	    scale$2(pixel, frameState.viewState.resolution / this.renderedResolution);
	
	    if (!this.hitCanvasContext_) {
	      this.hitCanvasContext_ = createCanvasContext2D(1, 1);
	    }
	
	    this.hitCanvasContext_.clearRect(0, 0, 1, 1);
	    this.hitCanvasContext_.drawImage(this.getImage(), pixel[0], pixel[1], 1, 1, 0, 0, 1, 1);
	
	    var imageData = this.hitCanvasContext_.getImageData(0, 0, 1, 1).data;
	    if (imageData[3] > 0) {
	      return callback.call(thisArg, this.getLayer(), imageData);
	    } else {
	      return undefined;
	    }
	  };
	
	  return IntermediateCanvasRenderer;
	}(CanvasLayerRenderer));
	
	/**
	 * @module ol/renderer/canvas/ImageLayer
	 */
	
	/**
	 * @classdesc
	 * Canvas renderer for image layers.
	 * @api
	 */
	var CanvasImageLayerRenderer = /*@__PURE__*/(function (IntermediateCanvasRenderer$$1) {
	  function CanvasImageLayerRenderer(imageLayer) {
	
	    IntermediateCanvasRenderer$$1.call(this, imageLayer);
	
	    /**
	     * @private
	     * @type {?import("../../ImageBase.js").default}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.imageTransform_ = create();
	
	    /**
	     * @type {!Array<string>}
	     */
	    this.skippedFeatures_ = [];
	
	    /**
	     * @private
	     * @type {import("./VectorLayer.js").default}
	     */
	    this.vectorRenderer_ = null;
	
	    if (imageLayer.getType() === LayerType.VECTOR) {
	      for (var i = 0, ii = layerRendererConstructors.length; i < ii; ++i) {
	        var ctor = layerRendererConstructors[i];
	        if (ctor !== CanvasImageLayerRenderer && ctor['handles'](imageLayer)) {
	          this.vectorRenderer_ = /** @type {import("./VectorLayer.js").default} */ (new ctor(imageLayer));
	          break;
	        }
	      }
	    }
	
	  }
	
	  if ( IntermediateCanvasRenderer$$1 ) { CanvasImageLayerRenderer.__proto__ = IntermediateCanvasRenderer$$1; }
	  CanvasImageLayerRenderer.prototype = Object.create( IntermediateCanvasRenderer$$1 && IntermediateCanvasRenderer$$1.prototype );
	  CanvasImageLayerRenderer.prototype.constructor = CanvasImageLayerRenderer;
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageLayerRenderer.prototype.disposeInternal = function disposeInternal () {
	    if (this.vectorRenderer_) {
	      this.vectorRenderer_.dispose();
	    }
	    IntermediateCanvasRenderer$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageLayerRenderer.prototype.getImage = function getImage () {
	    return !this.image_ ? null : this.image_.getImage();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageLayerRenderer.prototype.getImageTransform = function getImageTransform () {
	    return this.imageTransform_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState) {
	
	    var pixelRatio = frameState.pixelRatio;
	    var size = frameState.size;
	    var viewState = frameState.viewState;
	    var viewCenter = viewState.center;
	    var viewResolution = viewState.resolution;
	
	    var image;
	    var imageLayer = /** @type {import("../../layer/Image.js").default} */ (this.getLayer());
	    var imageSource = /** @type {import("../../source/Image.js").default} */ (imageLayer.getSource());
	
	    var hints = frameState.viewHints;
	
	    var vectorRenderer = this.vectorRenderer_;
	    var renderedExtent = frameState.extent;
	    if (!vectorRenderer && layerState.extent !== undefined) {
	      renderedExtent = getIntersection(renderedExtent, layerState.extent);
	    }
	
	    if (!hints[ViewHint.ANIMATING] && !hints[ViewHint.INTERACTING] &&
	        !isEmpty$1(renderedExtent)) {
	      var projection = viewState.projection;
	      var skippedFeatures = this.skippedFeatures_;
	      if (vectorRenderer) {
	        var context = vectorRenderer.context;
	        var imageFrameState = /** @type {import("../../PluggableMap.js").FrameState} */ (assign({}, frameState, {
	          size: [
	            getWidth(renderedExtent) / viewResolution,
	            getHeight(renderedExtent) / viewResolution
	          ],
	          viewState: /** @type {import("../../View.js").State} */ (assign({}, frameState.viewState, {
	            rotation: 0
	          }))
	        }));
	        var newSkippedFeatures = Object.keys(imageFrameState.skippedFeatureUids).sort();
	        image = new ImageCanvas(renderedExtent, viewResolution, pixelRatio, context.canvas, function(callback) {
	          if (vectorRenderer.prepareFrame(imageFrameState, layerState) &&
	              (vectorRenderer.replayGroupChanged ||
	              !equals(skippedFeatures, newSkippedFeatures))) {
	            context.canvas.width = imageFrameState.size[0] * pixelRatio;
	            context.canvas.height = imageFrameState.size[1] * pixelRatio;
	            vectorRenderer.compose(context, imageFrameState, layerState);
	            skippedFeatures = newSkippedFeatures;
	            callback();
	          }
	        });
	      } else {
	        image = imageSource.getImage(
	          renderedExtent, viewResolution, pixelRatio, projection);
	      }
	      if (image && this.loadImage(image)) {
	        this.image_ = image;
	        this.skippedFeatures_ = skippedFeatures;
	      }
	    }
	
	    if (this.image_) {
	      image = this.image_;
	      var imageExtent = image.getExtent();
	      var imageResolution = image.getResolution();
	      var imagePixelRatio = image.getPixelRatio();
	      var scale = pixelRatio * imageResolution /
	          (viewResolution * imagePixelRatio);
	      var transform = compose(this.imageTransform_,
	        pixelRatio * size[0] / 2, pixelRatio * size[1] / 2,
	        scale, scale,
	        0,
	        imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolution,
	        imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolution);
	      compose(this.coordinateToCanvasPixelTransform,
	        pixelRatio * size[0] / 2 - transform[4], pixelRatio * size[1] / 2 - transform[5],
	        pixelRatio / viewResolution, -pixelRatio / viewResolution,
	        0,
	        -viewCenter[0], -viewCenter[1]);
	
	      this.renderedResolution = imageResolution * pixelRatio / imagePixelRatio;
	    }
	
	    return !!this.image_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback) {
	    if (this.vectorRenderer_) {
	      return this.vectorRenderer_.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback);
	    } else {
	      return IntermediateCanvasRenderer$$1.prototype.forEachFeatureAtCoordinate.call(this, coordinate, frameState, hitTolerance, callback);
	    }
	  };
	
	  return CanvasImageLayerRenderer;
	}(IntermediateCanvasRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	CanvasImageLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.IMAGE ||
	    layer.getType() === LayerType.VECTOR &&
	    /** @type {import("../../layer/Vector.js").default} */ (layer).getRenderMode() === VectorRenderType.IMAGE;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {CanvasImageLayerRenderer} The layer renderer.
	 */
	CanvasImageLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new CanvasImageLayerRenderer(/** @type {import("../../layer/Image.js").default} */ (layer));
	};
	
	/**
	 * @module ol/TileRange
	 */
	
	/**
	 * A representation of a contiguous block of tiles.  A tile range is specified
	 * by its min/max tile coordinates and is inclusive of coordinates.
	 */
	var TileRange = function TileRange(minX, maxX, minY, maxY) {
	
	  /**
	   * @type {number}
	   */
	  this.minX = minX;
	
	  /**
	   * @type {number}
	   */
	  this.maxX = maxX;
	
	  /**
	   * @type {number}
	   */
	  this.minY = minY;
	
	  /**
	   * @type {number}
	   */
	  this.maxY = maxY;
	
	};
	
	/**
	 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @return {boolean} Contains tile coordinate.
	 */
	TileRange.prototype.contains = function contains (tileCoord) {
	  return this.containsXY(tileCoord[1], tileCoord[2]);
	};
	
	/**
	 * @param {TileRange} tileRange Tile range.
	 * @return {boolean} Contains.
	 */
	TileRange.prototype.containsTileRange = function containsTileRange (tileRange) {
	  return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX &&
	     this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
	};
	
	/**
	 * @param {number} x Tile coordinate x.
	 * @param {number} y Tile coordinate y.
	 * @return {boolean} Contains coordinate.
	 */
	TileRange.prototype.containsXY = function containsXY (x, y) {
	  return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
	};
	
	/**
	 * @param {TileRange} tileRange Tile range.
	 * @return {boolean} Equals.
	 */
	TileRange.prototype.equals = function equals (tileRange) {
	  return this.minX == tileRange.minX && this.minY == tileRange.minY &&
	     this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
	};
	
	/**
	 * @param {TileRange} tileRange Tile range.
	 */
	TileRange.prototype.extend = function extend (tileRange) {
	  if (tileRange.minX < this.minX) {
	    this.minX = tileRange.minX;
	  }
	  if (tileRange.maxX > this.maxX) {
	    this.maxX = tileRange.maxX;
	  }
	  if (tileRange.minY < this.minY) {
	    this.minY = tileRange.minY;
	  }
	  if (tileRange.maxY > this.maxY) {
	    this.maxY = tileRange.maxY;
	  }
	};
	
	/**
	 * @return {number} Height.
	 */
	TileRange.prototype.getHeight = function getHeight () {
	  return this.maxY - this.minY + 1;
	};
	
	/**
	 * @return {import("./size.js").Size} Size.
	 */
	TileRange.prototype.getSize = function getSize () {
	  return [this.getWidth(), this.getHeight()];
	};
	
	/**
	 * @return {number} Width.
	 */
	TileRange.prototype.getWidth = function getWidth () {
	  return this.maxX - this.minX + 1;
	};
	
	/**
	 * @param {TileRange} tileRange Tile range.
	 * @return {boolean} Intersects.
	 */
	TileRange.prototype.intersects = function intersects (tileRange) {
	  return this.minX <= tileRange.maxX &&
	     this.maxX >= tileRange.minX &&
	     this.minY <= tileRange.maxY &&
	     this.maxY >= tileRange.minY;
	};
	
	
	/**
	 * @param {number} minX Minimum X.
	 * @param {number} maxX Maximum X.
	 * @param {number} minY Minimum Y.
	 * @param {number} maxY Maximum Y.
	 * @param {TileRange=} tileRange TileRange.
	 * @return {TileRange} Tile range.
	 */
	function createOrUpdate$1(minX, maxX, minY, maxY, tileRange) {
	  if (tileRange !== undefined) {
	    tileRange.minX = minX;
	    tileRange.maxX = maxX;
	    tileRange.minY = minY;
	    tileRange.maxY = maxY;
	    return tileRange;
	  } else {
	    return new TileRange(minX, maxX, minY, maxY);
	  }
	}
	
	/**
	 * @module ol/renderer/canvas/TileLayer
	 */
	
	/**
	 * @classdesc
	 * Canvas renderer for tile layers.
	 * @api
	 */
	var CanvasTileLayerRenderer = /*@__PURE__*/(function (IntermediateCanvasRenderer$$1) {
	  function CanvasTileLayerRenderer(tileLayer, opt_noContext) {
	
	    IntermediateCanvasRenderer$$1.call(this, tileLayer);
	
	    /**
	     * @protected
	     * @type {CanvasRenderingContext2D}
	     */
	    this.context = opt_noContext ? null : createCanvasContext2D();
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.oversampling_;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.renderedExtent_ = null;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.renderedRevision;
	
	    /**
	     * @protected
	     * @type {!Array<import("../../Tile.js").default>}
	     */
	    this.renderedTiles = [];
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.newTiles_ = false;
	
	    /**
	     * @protected
	     * @type {import("../../extent.js").Extent}
	     */
	    this.tmpExtent = createEmpty();
	
	    /**
	     * @private
	     * @type {import("../../TileRange.js").default}
	     */
	    this.tmpTileRange_ = new TileRange(0, 0, 0, 0);
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.imageTransform_ = create();
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.zDirection = 0;
	
	  }
	
	  if ( IntermediateCanvasRenderer$$1 ) { CanvasTileLayerRenderer.__proto__ = IntermediateCanvasRenderer$$1; }
	  CanvasTileLayerRenderer.prototype = Object.create( IntermediateCanvasRenderer$$1 && IntermediateCanvasRenderer$$1.prototype );
	  CanvasTileLayerRenderer.prototype.constructor = CanvasTileLayerRenderer;
	
	  /**
	   * @private
	   * @param {import("../../Tile.js").default} tile Tile.
	   * @return {boolean} Tile is drawable.
	   */
	  CanvasTileLayerRenderer.prototype.isDrawableTile_ = function isDrawableTile_ (tile) {
	    var tileLayer = /** @type {import("../../layer/Tile.js").default} */ (this.getLayer());
	    var tileState = tile.getState();
	    var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
	    return tileState == TileState.LOADED ||
	        tileState == TileState.EMPTY ||
	        tileState == TileState.ERROR && !useInterimTilesOnError;
	  };
	
	  /**
	   * @param {number} z Tile coordinate z.
	   * @param {number} x Tile coordinate x.
	   * @param {number} y Tile coordinate y.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../../proj/Projection.js").default} projection Projection.
	   * @return {!import("../../Tile.js").default} Tile.
	   */
	  CanvasTileLayerRenderer.prototype.getTile = function getTile (z, x, y, pixelRatio, projection) {
	    var tileLayer = /** @type {import("../../layer/Tile.js").default} */ (this.getLayer());
	    var tileSource = /** @type {import("../../source/Tile.js").default} */ (tileLayer.getSource());
	    var tile = tileSource.getTile(z, x, y, pixelRatio, projection);
	    if (tile.getState() == TileState.ERROR) {
	      if (!tileLayer.getUseInterimTilesOnError()) {
	        // When useInterimTilesOnError is false, we consider the error tile as loaded.
	        tile.setState(TileState.LOADED);
	      } else if (tileLayer.getPreload() > 0) {
	        // Preloaded tiles for lower resolutions might have finished loading.
	        this.newTiles_ = true;
	      }
	    }
	    if (!this.isDrawableTile_(tile)) {
	      tile = tile.getInterimTile();
	    }
	    return tile;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasTileLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState) {
	
	    var pixelRatio = frameState.pixelRatio;
	    var size = frameState.size;
	    var viewState = frameState.viewState;
	    var projection = viewState.projection;
	    var viewResolution = viewState.resolution;
	    var viewCenter = viewState.center;
	
	    var tileLayer = /** @type {import("../../layer/Tile.js").default} */ (this.getLayer());
	    var tileSource = /** @type {import("../../source/Tile.js").default} */ (tileLayer.getSource());
	    var sourceRevision = tileSource.getRevision();
	    var tileGrid = tileSource.getTileGridForProjection(projection);
	    var z = tileGrid.getZForResolution(viewResolution, this.zDirection);
	    var tileResolution = tileGrid.getResolution(z);
	    var oversampling = Math.round(viewResolution / tileResolution) || 1;
	    var extent = frameState.extent;
	
	    if (layerState.extent !== undefined) {
	      extent = getIntersection(extent, layerState.extent);
	    }
	    if (isEmpty$1(extent)) {
	      // Return false to prevent the rendering of the layer.
	      return false;
	    }
	
	    var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
	    var imageExtent = tileGrid.getTileRangeExtent(z, tileRange);
	
	    var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
	
	    /**
	     * @type {Object<number, Object<string, import("../../Tile.js").default>>}
	     */
	    var tilesToDrawByZ = {};
	    tilesToDrawByZ[z] = {};
	
	    var findLoadedTiles = this.createLoadedTileFinder(
	      tileSource, projection, tilesToDrawByZ);
	
	    var hints = frameState.viewHints;
	    var animatingOrInteracting = hints[ViewHint.ANIMATING] || hints[ViewHint.INTERACTING];
	
	    var tmpExtent = this.tmpExtent;
	    var tmpTileRange = this.tmpTileRange_;
	    this.newTiles_ = false;
	    var tile, x, y;
	    for (x = tileRange.minX; x <= tileRange.maxX; ++x) {
	      for (y = tileRange.minY; y <= tileRange.maxY; ++y) {
	        if (Date.now() - frameState.time > 16 && animatingOrInteracting) {
	          continue;
	        }
	        tile = this.getTile(z, x, y, pixelRatio, projection);
	        if (this.isDrawableTile_(tile)) {
	          var uid = getUid(this);
	          if (tile.getState() == TileState.LOADED) {
	            tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
	            var inTransition = tile.inTransition(uid);
	            if (!this.newTiles_ && (inTransition || this.renderedTiles.indexOf(tile) === -1)) {
	              this.newTiles_ = true;
	            }
	          }
	          if (tile.getAlpha(uid, frameState.time) === 1) {
	            // don't look for alt tiles if alpha is 1
	            continue;
	          }
	        }
	
	        var childTileRange = tileGrid.getTileCoordChildTileRange(
	          tile.tileCoord, tmpTileRange, tmpExtent);
	        var covered = false;
	        if (childTileRange) {
	          covered = findLoadedTiles(z + 1, childTileRange);
	        }
	        if (!covered) {
	          tileGrid.forEachTileCoordParentTileRange(
	            tile.tileCoord, findLoadedTiles, null, tmpTileRange, tmpExtent);
	        }
	
	      }
	    }
	
	    var renderedResolution = tileResolution * pixelRatio / tilePixelRatio * oversampling;
	    if (!(this.renderedResolution && Date.now() - frameState.time > 16 && animatingOrInteracting) && (
	      this.newTiles_ ||
	          !(this.renderedExtent_ && containsExtent(this.renderedExtent_, extent)) ||
	          this.renderedRevision != sourceRevision ||
	          oversampling != this.oversampling_ ||
	          !animatingOrInteracting && renderedResolution != this.renderedResolution
	    )) {
	
	      var context = this.context;
	      if (context) {
	        var tilePixelSize = tileSource.getTilePixelSize(z, pixelRatio, projection);
	        var width = Math.round(tileRange.getWidth() * tilePixelSize[0] / oversampling);
	        var height = Math.round(tileRange.getHeight() * tilePixelSize[1] / oversampling);
	        var canvas = context.canvas;
	        if (canvas.width != width || canvas.height != height) {
	          this.oversampling_ = oversampling;
	          canvas.width = width;
	          canvas.height = height;
	        } else {
	          if (this.renderedExtent_ && !equals$1(imageExtent, this.renderedExtent_)) {
	            context.clearRect(0, 0, width, height);
	          }
	          oversampling = this.oversampling_;
	        }
	      }
	
	      this.renderedTiles.length = 0;
	      /** @type {Array<number>} */
	      var zs = Object.keys(tilesToDrawByZ).map(Number);
	      zs.sort(function(a, b) {
	        if (a === z) {
	          return 1;
	        } else if (b === z) {
	          return -1;
	        } else {
	          return a > b ? 1 : a < b ? -1 : 0;
	        }
	      });
	      var currentResolution, currentScale, currentTilePixelSize, currentZ, i, ii;
	      var tileExtent, tileGutter, tilesToDraw, w, h;
	      for (i = 0, ii = zs.length; i < ii; ++i) {
	        currentZ = zs[i];
	        currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
	        currentResolution = tileGrid.getResolution(currentZ);
	        currentScale = currentResolution / tileResolution;
	        tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
	        tilesToDraw = tilesToDrawByZ[currentZ];
	        for (var tileCoordKey in tilesToDraw) {
	          tile = tilesToDraw[tileCoordKey];
	          tileExtent = tileGrid.getTileCoordExtent(tile.getTileCoord(), tmpExtent);
	          x = (tileExtent[0] - imageExtent[0]) / tileResolution * tilePixelRatio / oversampling;
	          y = (imageExtent[3] - tileExtent[3]) / tileResolution * tilePixelRatio / oversampling;
	          w = currentTilePixelSize[0] * currentScale / oversampling;
	          h = currentTilePixelSize[1] * currentScale / oversampling;
	          this.drawTileImage(tile, frameState, layerState, x, y, w, h, tileGutter, z === currentZ);
	          this.renderedTiles.push(tile);
	        }
	      }
	
	      this.renderedRevision = sourceRevision;
	      this.renderedResolution = tileResolution * pixelRatio / tilePixelRatio * oversampling;
	      this.renderedExtent_ = imageExtent;
	    }
	
	    var scale = this.renderedResolution / viewResolution;
	    var transform = compose(this.imageTransform_,
	      pixelRatio * size[0] / 2, pixelRatio * size[1] / 2,
	      scale, scale,
	      0,
	      (this.renderedExtent_[0] - viewCenter[0]) / this.renderedResolution * pixelRatio,
	      (viewCenter[1] - this.renderedExtent_[3]) / this.renderedResolution * pixelRatio);
	    compose(this.coordinateToCanvasPixelTransform,
	      pixelRatio * size[0] / 2 - transform[4], pixelRatio * size[1] / 2 - transform[5],
	      pixelRatio / viewResolution, -pixelRatio / viewResolution,
	      0,
	      -viewCenter[0], -viewCenter[1]);
	
	
	    this.updateUsedTiles(frameState.usedTiles, tileSource, z, tileRange);
	    this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio,
	      projection, extent, z, tileLayer.getPreload());
	    this.scheduleExpireCache(frameState, tileSource);
	
	    return this.renderedTiles.length > 0;
	  };
	
	  /**
	   * @param {import("../../Tile.js").default} tile Tile.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   * @param {number} x Left of the tile.
	   * @param {number} y Top of the tile.
	   * @param {number} w Width of the tile.
	   * @param {number} h Height of the tile.
	   * @param {number} gutter Tile gutter.
	   * @param {boolean} transition Apply an alpha transition.
	   */
	  CanvasTileLayerRenderer.prototype.drawTileImage = function drawTileImage (tile, frameState, layerState, x, y, w, h, gutter, transition) {
	    var image = this.getTileImage(tile);
	    if (!image) {
	      return;
	    }
	    var uid = getUid(this);
	    var alpha = transition ? tile.getAlpha(uid, frameState.time) : 1;
	    var tileLayer = /** @type {import("../../layer/Tile.js").default} */ (this.getLayer());
	    var tileSource = /** @type {import("../../source/Tile.js").default} */ (tileLayer.getSource());
	    if (alpha === 1 && !tileSource.getOpaque(frameState.viewState.projection)) {
	      this.context.clearRect(x, y, w, h);
	    }
	    var alphaChanged = alpha !== this.context.globalAlpha;
	    if (alphaChanged) {
	      this.context.save();
	      this.context.globalAlpha = alpha;
	    }
	    this.context.drawImage(image, gutter, gutter,
	      image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
	
	    if (alphaChanged) {
	      this.context.restore();
	    }
	    if (alpha !== 1) {
	      frameState.animate = true;
	    } else if (transition) {
	      tile.endTransition(uid);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasTileLayerRenderer.prototype.getImage = function getImage () {
	    var context = this.context;
	    return context ? context.canvas : null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasTileLayerRenderer.prototype.getImageTransform = function getImageTransform () {
	    return this.imageTransform_;
	  };
	
	  /**
	   * Get the image from a tile.
	   * @param {import("../../Tile.js").default} tile Tile.
	   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
	   * @protected
	   */
	  CanvasTileLayerRenderer.prototype.getTileImage = function getTileImage (tile) {
	    return /** @type {import("../../ImageTile.js").default} */ (tile).getImage();
	  };
	
	  return CanvasTileLayerRenderer;
	}(IntermediateCanvasRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	CanvasTileLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.TILE;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {CanvasTileLayerRenderer} The layer renderer.
	 */
	CanvasTileLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new CanvasTileLayerRenderer(/** @type {import("../../layer/Tile.js").default} */ (layer));
	};
	
	
	/**
	 * @function
	 * @return {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default}
	 */
	CanvasTileLayerRenderer.prototype.getLayer;
	
	/**
	 * @module ol/render/ReplayGroup
	 */
	
	/**
	 * Base class for replay groups.
	 */
	var ReplayGroup = function ReplayGroup () {};
	
	ReplayGroup.prototype.getReplay = function getReplay (zIndex, replayType) {
	  return abstract();
	};
	
	/**
	 * @abstract
	 * @return {boolean} Is empty.
	 */
	ReplayGroup.prototype.isEmpty = function isEmpty () {
	  return abstract();
	};
	
	/**
	 * @abstract
	 * @param {boolean} group Group with previous replay
	 * @return {Array<*>} The resulting instruction group
	 */
	ReplayGroup.prototype.addDeclutter = function addDeclutter (group) {
	  return abstract();
	};
	
	/**
	 * @module ol/render/ReplayType
	 */
	
	/**
	 * @enum {string}
	 */
	var ReplayType = {
	  CIRCLE: 'Circle',
	  DEFAULT: 'Default',
	  IMAGE: 'Image',
	  LINE_STRING: 'LineString',
	  POLYGON: 'Polygon',
	  TEXT: 'Text'
	};
	
	/**
	 * @module ol/geom/flat/textpath
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Path to put text on.
	 * @param {number} offset Start offset of the `flatCoordinates`.
	 * @param {number} end End offset of the `flatCoordinates`.
	 * @param {number} stride Stride.
	 * @param {string} text Text to place on the path.
	 * @param {function(string):number} measure Measure function returning the
	 * width of the character passed as 1st argument.
	 * @param {number} startM m along the path where the text starts.
	 * @param {number} maxAngle Max angle between adjacent chars in radians.
	 * @return {Array<Array<*>>} The result array of null if `maxAngle` was
	 * exceeded. Entries of the array are x, y, anchorX, angle, chunk.
	 * @api
	 */
	function drawTextOnPath(
	  flatCoordinates, offset, end, stride, text, measure, startM, maxAngle) {
	  var result = [];
	
	  // Keep text upright
	  var reverse = flatCoordinates[offset] > flatCoordinates[end - stride];
	
	  var numChars = text.length;
	
	  var x1 = flatCoordinates[offset];
	  var y1 = flatCoordinates[offset + 1];
	  offset += stride;
	  var x2 = flatCoordinates[offset];
	  var y2 = flatCoordinates[offset + 1];
	  var segmentM = 0;
	  var segmentLength = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	
	  var chunk = '';
	  var chunkLength = 0;
	  var data, index, previousAngle;
	  for (var i = 0; i < numChars; ++i) {
	    index = reverse ? numChars - i - 1 : i;
	    var char = text.charAt(index);
	    chunk = reverse ? char + chunk : chunk + char;
	    var charLength = measure(chunk) - chunkLength;
	    chunkLength += charLength;
	    var charM = startM + charLength / 2;
	    while (offset < end - stride && segmentM + segmentLength < charM) {
	      x1 = x2;
	      y1 = y2;
	      offset += stride;
	      x2 = flatCoordinates[offset];
	      y2 = flatCoordinates[offset + 1];
	      segmentM += segmentLength;
	      segmentLength = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	    }
	    var segmentPos = charM - segmentM;
	    var angle = Math.atan2(y2 - y1, x2 - x1);
	    if (reverse) {
	      angle += angle > 0 ? -Math.PI : Math.PI;
	    }
	    if (previousAngle !== undefined) {
	      var delta = angle - previousAngle;
	      delta += (delta > Math.PI) ? -2 * Math.PI : (delta < -Math.PI) ? 2 * Math.PI : 0;
	      if (Math.abs(delta) > maxAngle) {
	        return null;
	      }
	    }
	    var interpolate = segmentPos / segmentLength;
	    var x = lerp(x1, x2, interpolate);
	    var y = lerp(y1, y2, interpolate);
	    if (previousAngle == angle) {
	      if (reverse) {
	        data[0] = x;
	        data[1] = y;
	        data[2] = charLength / 2;
	      }
	      data[4] = chunk;
	    } else {
	      chunk = char;
	      chunkLength = charLength;
	      data = [x, y, charLength / 2, angle, chunk];
	      if (reverse) {
	        result.unshift(data);
	      } else {
	        result.push(data);
	      }
	      previousAngle = angle;
	    }
	    startM += charLength;
	  }
	  return result;
	}
	
	/**
	 * @module ol/render/replay
	 */
	
	
	/**
	 * @const
	 * @type {Array<ReplayType>}
	 */
	var ORDER = [
	  ReplayType.POLYGON,
	  ReplayType.CIRCLE,
	  ReplayType.LINE_STRING,
	  ReplayType.IMAGE,
	  ReplayType.TEXT,
	  ReplayType.DEFAULT
	];
	
	/**
	 * @const
	 * @enum {number}
	 */
	var TEXT_ALIGN = {};
	TEXT_ALIGN['left'] = 0;
	TEXT_ALIGN['end'] = 0;
	TEXT_ALIGN['center'] = 0.5;
	TEXT_ALIGN['right'] = 1;
	TEXT_ALIGN['start'] = 1;
	TEXT_ALIGN['top'] = 0;
	TEXT_ALIGN['middle'] = 0.5;
	TEXT_ALIGN['hanging'] = 0.2;
	TEXT_ALIGN['alphabetic'] = 0.8;
	TEXT_ALIGN['ideographic'] = 0.8;
	TEXT_ALIGN['bottom'] = 1;
	
	/**
	 * @module ol/render/canvas/Replay
	 */
	
	
	/**
	 * @type {import("../../extent.js").Extent}
	 */
	var tmpExtent = createEmpty();
	
	
	/**
	 * @type {!import("../../transform.js").Transform}
	 */
	var tmpTransform$1 = create();
	
	
	/**
	 * @api
	 */
	var CanvasReplay = /*@__PURE__*/(function (VectorContext$$1) {
	  function CanvasReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
	    VectorContext$$1.call(this);
	
	    /**
	     * @type {?}
	     */
	    this.declutterTree = declutterTree;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.tolerance = tolerance;
	
	    /**
	     * @protected
	     * @const
	     * @type {import("../../extent.js").Extent}
	     */
	    this.maxExtent = maxExtent;
	
	    /**
	     * @protected
	     * @type {boolean}
	     */
	    this.overlaps = overlaps;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.pixelRatio = pixelRatio;
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.maxLineWidth = 0;
	
	    /**
	     * @protected
	     * @const
	     * @type {number}
	     */
	    this.resolution = resolution;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.alignFill_;
	
	    /**
	     * @private
	     * @type {Array<*>}
	     */
	    this.beginGeometryInstruction1_ = null;
	
	    /**
	     * @private
	     * @type {Array<*>}
	     */
	    this.beginGeometryInstruction2_ = null;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.bufferedMaxExtent_ = null;
	
	    /**
	     * @protected
	     * @type {Array<*>}
	     */
	    this.instructions = [];
	
	    /**
	     * @protected
	     * @type {Array<number>}
	     */
	    this.coordinates = [];
	
	    /**
	     * @private
	     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
	     */
	    this.coordinateCache_ = {};
	
	    /**
	     * @private
	     * @type {!import("../../transform.js").Transform}
	     */
	    this.renderedTransform_ = create();
	
	    /**
	     * @protected
	     * @type {Array<*>}
	     */
	    this.hitDetectionInstructions = [];
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.pixelCoordinates_ = null;
	
	    /**
	     * @protected
	     * @type {import("../canvas.js").FillStrokeState}
	     */
	    this.state = /** @type {import("../canvas.js").FillStrokeState} */ ({});
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.viewRotation_ = 0;
	
	  }
	
	  if ( VectorContext$$1 ) { CanvasReplay.__proto__ = VectorContext$$1; }
	  CanvasReplay.prototype = Object.create( VectorContext$$1 && VectorContext$$1.prototype );
	  CanvasReplay.prototype.constructor = CanvasReplay;
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
	   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
	   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
	   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
	   * @param {Array<*>} fillInstruction Fill instruction.
	   * @param {Array<*>} strokeInstruction Stroke instruction.
	   */
	  CanvasReplay.prototype.replayTextBackground_ = function replayTextBackground_ (context, p1, p2, p3, p4, fillInstruction$$1, strokeInstruction$$1) {
	    context.beginPath();
	    context.moveTo.apply(context, p1);
	    context.lineTo.apply(context, p2);
	    context.lineTo.apply(context, p3);
	    context.lineTo.apply(context, p4);
	    context.lineTo.apply(context, p1);
	    if (fillInstruction$$1) {
	      this.alignFill_ = /** @type {boolean} */ (fillInstruction$$1[2]);
	      this.fill_(context);
	    }
	    if (strokeInstruction$$1) {
	      this.setStrokeStyle_(context, /** @type {Array<*>} */ (strokeInstruction$$1));
	      context.stroke();
	    }
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {number} x X.
	   * @param {number} y Y.
	   * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} image Image.
	   * @param {number} anchorX Anchor X.
	   * @param {number} anchorY Anchor Y.
	   * @param {import("../canvas.js").DeclutterGroup} declutterGroup Declutter group.
	   * @param {number} height Height.
	   * @param {number} opacity Opacity.
	   * @param {number} originX Origin X.
	   * @param {number} originY Origin Y.
	   * @param {number} rotation Rotation.
	   * @param {number} scale Scale.
	   * @param {boolean} snapToPixel Snap to pixel.
	   * @param {number} width Width.
	   * @param {Array<number>} padding Padding.
	   * @param {Array<*>} fillInstruction Fill instruction.
	   * @param {Array<*>} strokeInstruction Stroke instruction.
	   */
	  CanvasReplay.prototype.replayImage_ = function replayImage_ (
	    context,
	    x,
	    y,
	    image,
	    anchorX,
	    anchorY,
	    declutterGroup,
	    height,
	    opacity,
	    originX,
	    originY,
	    rotation,
	    scale$$1,
	    snapToPixel,
	    width,
	    padding,
	    fillInstruction$$1,
	    strokeInstruction$$1
	  ) {
	    var fillStroke = fillInstruction$$1 || strokeInstruction$$1;
	    anchorX *= scale$$1;
	    anchorY *= scale$$1;
	    x -= anchorX;
	    y -= anchorY;
	
	    var w = (width + originX > image.width) ? image.width - originX : width;
	    var h = (height + originY > image.height) ? image.height - originY : height;
	    var boxW = padding[3] + w * scale$$1 + padding[1];
	    var boxH = padding[0] + h * scale$$1 + padding[2];
	    var boxX = x - padding[3];
	    var boxY = y - padding[0];
	
	    /** @type {import("../../coordinate.js").Coordinate} */
	    var p1;
	    /** @type {import("../../coordinate.js").Coordinate} */
	    var p2;
	    /** @type {import("../../coordinate.js").Coordinate} */
	    var p3;
	    /** @type {import("../../coordinate.js").Coordinate} */
	    var p4;
	    if (fillStroke || rotation !== 0) {
	      p1 = [boxX, boxY];
	      p2 = [boxX + boxW, boxY];
	      p3 = [boxX + boxW, boxY + boxH];
	      p4 = [boxX, boxY + boxH];
	    }
	
	    var transform = null;
	    if (rotation !== 0) {
	      var centerX = x + anchorX;
	      var centerY = y + anchorY;
	      transform = compose(tmpTransform$1, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
	
	      createOrUpdateEmpty(tmpExtent);
	      extendCoordinate(tmpExtent, apply(tmpTransform$1, p1));
	      extendCoordinate(tmpExtent, apply(tmpTransform$1, p2));
	      extendCoordinate(tmpExtent, apply(tmpTransform$1, p3));
	      extendCoordinate(tmpExtent, apply(tmpTransform$1, p4));
	    } else {
	      createOrUpdate(boxX, boxY, boxX + boxW, boxY + boxH, tmpExtent);
	    }
	    var canvas = context.canvas;
	    var strokePadding = strokeInstruction$$1 ? (strokeInstruction$$1[2] * scale$$1 / 2) : 0;
	    var intersects$$1 =
	        tmpExtent[0] - strokePadding <= canvas.width && tmpExtent[2] + strokePadding >= 0 &&
	        tmpExtent[1] - strokePadding <= canvas.height && tmpExtent[3] + strokePadding >= 0;
	
	    if (snapToPixel) {
	      x = Math.round(x);
	      y = Math.round(y);
	    }
	
	    if (declutterGroup) {
	      if (!intersects$$1 && declutterGroup[4] == 1) {
	        return;
	      }
	      extend$1(declutterGroup, tmpExtent);
	      var declutterArgs = intersects$$1 ?
	        [context, transform ? transform.slice(0) : null, opacity, image, originX, originY, w, h, x, y, scale$$1] :
	        null;
	      if (declutterArgs && fillStroke) {
	        declutterArgs.push(fillInstruction$$1, strokeInstruction$$1, p1, p2, p3, p4);
	      }
	      declutterGroup.push(declutterArgs);
	    } else if (intersects$$1) {
	      if (fillStroke) {
	        this.replayTextBackground_(context, p1, p2, p3, p4,
	          /** @type {Array<*>} */ (fillInstruction$$1),
	          /** @type {Array<*>} */ (strokeInstruction$$1));
	      }
	      drawImage(context, transform, opacity, image, originX, originY, w, h, x, y, scale$$1);
	    }
	  };
	
	  /**
	   * @protected
	   * @param {Array<number>} dashArray Dash array.
	   * @return {Array<number>} Dash array with pixel ratio applied
	   */
	  CanvasReplay.prototype.applyPixelRatio = function applyPixelRatio (dashArray) {
	    var pixelRatio = this.pixelRatio;
	    return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
	      return dash * pixelRatio;
	    });
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @param {boolean} closed Last input coordinate equals first.
	   * @param {boolean} skipFirst Skip first coordinate.
	   * @protected
	   * @return {number} My end.
	   */
	  CanvasReplay.prototype.appendFlatCoordinates = function appendFlatCoordinates (flatCoordinates, offset, end, stride, closed, skipFirst) {
	
	    var myEnd = this.coordinates.length;
	    var extent = this.getBufferedMaxExtent();
	    if (skipFirst) {
	      offset += stride;
	    }
	    var lastCoord = [flatCoordinates[offset], flatCoordinates[offset + 1]];
	    var nextCoord = [NaN, NaN];
	    var skipped = true;
	
	    var i, lastRel, nextRel;
	    for (i = offset + stride; i < end; i += stride) {
	      nextCoord[0] = flatCoordinates[i];
	      nextCoord[1] = flatCoordinates[i + 1];
	      nextRel = coordinateRelationship(extent, nextCoord);
	      if (nextRel !== lastRel) {
	        if (skipped) {
	          this.coordinates[myEnd++] = lastCoord[0];
	          this.coordinates[myEnd++] = lastCoord[1];
	        }
	        this.coordinates[myEnd++] = nextCoord[0];
	        this.coordinates[myEnd++] = nextCoord[1];
	        skipped = false;
	      } else if (nextRel === Relationship.INTERSECTING) {
	        this.coordinates[myEnd++] = nextCoord[0];
	        this.coordinates[myEnd++] = nextCoord[1];
	        skipped = false;
	      } else {
	        skipped = true;
	      }
	      lastCoord[0] = nextCoord[0];
	      lastCoord[1] = nextCoord[1];
	      lastRel = nextRel;
	    }
	
	    // Last coordinate equals first or only one point to append:
	    if ((closed && skipped) || i === offset + stride) {
	      this.coordinates[myEnd++] = lastCoord[0];
	      this.coordinates[myEnd++] = lastCoord[1];
	    }
	    return myEnd;
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {Array<number>} ends Ends.
	   * @param {number} stride Stride.
	   * @param {Array<number>} replayEnds Replay ends.
	   * @return {number} Offset.
	   */
	  CanvasReplay.prototype.drawCustomCoordinates_ = function drawCustomCoordinates_ (flatCoordinates, offset, ends, stride, replayEnds) {
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      var end = ends[i];
	      var replayEnd = this.appendFlatCoordinates(flatCoordinates, offset, end, stride, false, false);
	      replayEnds.push(replayEnd);
	      offset = end;
	    }
	    return offset;
	  };
	
	  /**
	   * @inheritDoc.
	   */
	  CanvasReplay.prototype.drawCustom = function drawCustom (geometry, feature, renderer) {
	    this.beginGeometry(geometry, feature);
	    var type = geometry.getType();
	    var stride = geometry.getStride();
	    var replayBegin = this.coordinates.length;
	    var flatCoordinates, replayEnd, replayEnds, replayEndss;
	    var offset;
	    if (type == GeometryType.MULTI_POLYGON) {
	      geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry);
	      flatCoordinates = geometry.getOrientedFlatCoordinates();
	      replayEndss = [];
	      var endss = geometry.getEndss();
	      offset = 0;
	      for (var i = 0, ii = endss.length; i < ii; ++i) {
	        var myEnds = [];
	        offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
	        replayEndss.push(myEnds);
	      }
	      this.instructions.push([Instruction.CUSTOM,
	        replayBegin, replayEndss, geometry, renderer, inflateMultiCoordinatesArray]);
	    } else if (type == GeometryType.POLYGON || type == GeometryType.MULTI_LINE_STRING) {
	      replayEnds = [];
	      flatCoordinates = (type == GeometryType.POLYGON) ?
	        /** @type {import("../../geom/Polygon.js").default} */ (geometry).getOrientedFlatCoordinates() :
	        geometry.getFlatCoordinates();
	      offset = this.drawCustomCoordinates_(flatCoordinates, 0,
	        /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ (geometry).getEnds(),
	        stride, replayEnds);
	      this.instructions.push([Instruction.CUSTOM,
	        replayBegin, replayEnds, geometry, renderer, inflateCoordinatesArray]);
	    } else if (type == GeometryType.LINE_STRING || type == GeometryType.MULTI_POINT) {
	      flatCoordinates = geometry.getFlatCoordinates();
	      replayEnd = this.appendFlatCoordinates(
	        flatCoordinates, 0, flatCoordinates.length, stride, false, false);
	      this.instructions.push([Instruction.CUSTOM,
	        replayBegin, replayEnd, geometry, renderer, inflateCoordinates]);
	    } else if (type == GeometryType.POINT) {
	      flatCoordinates = geometry.getFlatCoordinates();
	      this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
	      replayEnd = this.coordinates.length;
	      this.instructions.push([Instruction.CUSTOM,
	        replayBegin, replayEnd, geometry, renderer]);
	    }
	    this.endGeometry(geometry, feature);
	  };
	
	  /**
	   * @protected
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
	   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	   */
	  CanvasReplay.prototype.beginGeometry = function beginGeometry (geometry, feature) {
	    this.beginGeometryInstruction1_ = [Instruction.BEGIN_GEOMETRY, feature, 0];
	    this.instructions.push(this.beginGeometryInstruction1_);
	    this.beginGeometryInstruction2_ = [Instruction.BEGIN_GEOMETRY, feature, 0];
	    this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
	  };
	
	  /**
	   * FIXME empty description for jsdoc
	   */
	  CanvasReplay.prototype.finish = function finish () {};
	
	  /**
	   * @private
	   * @param {CanvasRenderingContext2D} context Context.
	   */
	  CanvasReplay.prototype.fill_ = function fill_ (context) {
	    if (this.alignFill_) {
	      var origin = apply(this.renderedTransform_, [0, 0]);
	      var repeatSize = 512 * this.pixelRatio;
	      context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
	      context.rotate(this.viewRotation_);
	    }
	    context.fill();
	    if (this.alignFill_) {
	      context.setTransform.apply(context, resetTransform);
	    }
	  };
	
	  /**
	   * @private
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {Array<*>} instruction Instruction.
	   */
	  CanvasReplay.prototype.setStrokeStyle_ = function setStrokeStyle_ (context, instruction) {
	    context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
	    context.lineWidth = /** @type {number} */ (instruction[2]);
	    context.lineCap = /** @type {CanvasLineCap} */ (instruction[3]);
	    context.lineJoin = /** @type {CanvasLineJoin} */ (instruction[4]);
	    context.miterLimit = /** @type {number} */ (instruction[5]);
	    if (CANVAS_LINE_DASH) {
	      context.lineDashOffset = /** @type {number} */ (instruction[7]);
	      context.setLineDash(/** @type {Array<number>} */ (instruction[6]));
	    }
	  };
	
	  /**
	   * @param {import("../canvas.js").DeclutterGroup} declutterGroup Declutter group.
	   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	   */
	  CanvasReplay.prototype.renderDeclutter_ = function renderDeclutter_ (declutterGroup, feature) {
	    if (declutterGroup && declutterGroup.length > 5) {
	      var groupCount = declutterGroup[4];
	      if (groupCount == 1 || groupCount == declutterGroup.length - 5) {
	        /** @type {import("../../structs/RBush.js").Entry} */
	        var box = {
	          minX: /** @type {number} */ (declutterGroup[0]),
	          minY: /** @type {number} */ (declutterGroup[1]),
	          maxX: /** @type {number} */ (declutterGroup[2]),
	          maxY: /** @type {number} */ (declutterGroup[3]),
	          value: feature
	        };
	        if (!this.declutterTree.collides(box)) {
	          this.declutterTree.insert(box);
	          for (var j = 5, jj = declutterGroup.length; j < jj; ++j) {
	            var declutterData = /** @type {Array} */ (declutterGroup[j]);
	            if (declutterData) {
	              if (declutterData.length > 11) {
	                this.replayTextBackground_(declutterData[0],
	                  declutterData[13], declutterData[14], declutterData[15], declutterData[16],
	                  declutterData[11], declutterData[12]);
	              }
	              drawImage.apply(undefined, declutterData);
	            }
	          }
	        }
	        declutterGroup.length = 5;
	        createOrUpdateEmpty(declutterGroup);
	      }
	    }
	  };
	
	  /**
	   * @private
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../transform.js").Transform} transform Transform.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
	   *     to skip.
	   * @param {Array<*>} instructions Instructions array.
	   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
	   * @param {import("../../extent.js").Extent=} opt_hitExtent Only check features that intersect this
	   *     extent.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  CanvasReplay.prototype.replay_ = function replay_ (
	    context,
	    transform,
	    skippedFeaturesHash,
	    instructions,
	    snapToPixel,
	    featureCallback,
	    opt_hitExtent
	  ) {
	    /** @type {Array<number>} */
	    var pixelCoordinates;
	    if (this.pixelCoordinates_ && equals(transform, this.renderedTransform_)) {
	      pixelCoordinates = this.pixelCoordinates_;
	    } else {
	      if (!this.pixelCoordinates_) {
	        this.pixelCoordinates_ = [];
	      }
	      pixelCoordinates = transform2D(
	        this.coordinates, 0, this.coordinates.length, 2,
	        transform, this.pixelCoordinates_);
	      setFromArray(this.renderedTransform_, transform);
	    }
	    var skipFeatures = !isEmpty(skippedFeaturesHash);
	    var i = 0; // instruction index
	    var ii = instructions.length; // end of instructions
	    var d = 0; // data index
	    var dd; // end of per-instruction data
	    var anchorX, anchorY, prevX, prevY, roundX, roundY, declutterGroup, image;
	    var pendingFill = 0;
	    var pendingStroke = 0;
	    var lastFillInstruction = null;
	    var lastStrokeInstruction = null;
	    var coordinateCache = this.coordinateCache_;
	    var viewRotation = this.viewRotation_;
	
	    var state = /** @type {import("../../render.js").State} */ ({
	      context: context,
	      pixelRatio: this.pixelRatio,
	      resolution: this.resolution,
	      rotation: viewRotation
	    });
	
	    // When the batch size gets too big, performance decreases. 200 is a good
	    // balance between batch size and number of fill/stroke instructions.
	    var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
	    var /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ feature;
	    var x, y;
	    while (i < ii) {
	      var instruction = instructions[i];
	      var type = /** @type {CanvasInstruction} */ (instruction[0]);
	      switch (type) {
	        case Instruction.BEGIN_GEOMETRY:
	          feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
	          if ((skipFeatures && skippedFeaturesHash[getUid(feature)]) || !feature.getGeometry()) {
	            i = /** @type {number} */ (instruction[2]);
	          } else if (opt_hitExtent !== undefined && !intersects(
	            opt_hitExtent, feature.getGeometry().getExtent())) {
	            i = /** @type {number} */ (instruction[2]) + 1;
	          } else {
	            ++i;
	          }
	          break;
	        case Instruction.BEGIN_PATH:
	          if (pendingFill > batchSize) {
	            this.fill_(context);
	            pendingFill = 0;
	          }
	          if (pendingStroke > batchSize) {
	            context.stroke();
	            pendingStroke = 0;
	          }
	          if (!pendingFill && !pendingStroke) {
	            context.beginPath();
	            prevX = prevY = NaN;
	          }
	          ++i;
	          break;
	        case Instruction.CIRCLE:
	          d = /** @type {number} */ (instruction[1]);
	          var x1 = pixelCoordinates[d];
	          var y1 = pixelCoordinates[d + 1];
	          var x2 = pixelCoordinates[d + 2];
	          var y2 = pixelCoordinates[d + 3];
	          var dx = x2 - x1;
	          var dy = y2 - y1;
	          var r = Math.sqrt(dx * dx + dy * dy);
	          context.moveTo(x1 + r, y1);
	          context.arc(x1, y1, r, 0, 2 * Math.PI, true);
	          ++i;
	          break;
	        case Instruction.CLOSE_PATH:
	          context.closePath();
	          ++i;
	          break;
	        case Instruction.CUSTOM:
	          d = /** @type {number} */ (instruction[1]);
	          dd = instruction[2];
	          var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ (instruction[3]);
	          var renderer = instruction[4];
	          var fn = instruction.length == 6 ? instruction[5] : undefined;
	          state.geometry = geometry;
	          state.feature = feature;
	          if (!(i in coordinateCache)) {
	            coordinateCache[i] = [];
	          }
	          var coords = coordinateCache[i];
	          if (fn) {
	            fn(pixelCoordinates, d, dd, 2, coords);
	          } else {
	            coords[0] = pixelCoordinates[d];
	            coords[1] = pixelCoordinates[d + 1];
	            coords.length = 2;
	          }
	          renderer(coords, state);
	          ++i;
	          break;
	        case Instruction.DRAW_IMAGE:
	          d = /** @type {number} */ (instruction[1]);
	          dd = /** @type {number} */ (instruction[2]);
	          image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
	              (instruction[3]);
	          // Remaining arguments in DRAW_IMAGE are in alphabetical order
	          anchorX = /** @type {number} */ (instruction[4]);
	          anchorY = /** @type {number} */ (instruction[5]);
	          declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[6]);
	          var height = /** @type {number} */ (instruction[7]);
	          var opacity = /** @type {number} */ (instruction[8]);
	          var originX = /** @type {number} */ (instruction[9]);
	          var originY = /** @type {number} */ (instruction[10]);
	          var rotateWithView = /** @type {boolean} */ (instruction[11]);
	          var rotation = /** @type {number} */ (instruction[12]);
	          var scale$$1 = /** @type {number} */ (instruction[13]);
	          var width = /** @type {number} */ (instruction[14]);
	
	          var padding = (void 0), backgroundFill = (void 0), backgroundStroke = (void 0);
	          if (instruction.length > 16) {
	            padding = /** @type {Array<number>} */ (instruction[15]);
	            backgroundFill = /** @type {boolean} */ (instruction[16]);
	            backgroundStroke = /** @type {boolean} */ (instruction[17]);
	          } else {
	            padding = defaultPadding;
	            backgroundFill = backgroundStroke = false;
	          }
	
	          if (rotateWithView) {
	            rotation += viewRotation;
	          }
	          for (; d < dd; d += 2) {
	            this.replayImage_(context,
	              pixelCoordinates[d], pixelCoordinates[d + 1], image, anchorX, anchorY,
	              declutterGroup, height, opacity, originX, originY, rotation, scale$$1,
	              snapToPixel, width, padding,
	              backgroundFill ? /** @type {Array<*>} */ (lastFillInstruction) : null,
	              backgroundStroke ? /** @type {Array<*>} */ (lastStrokeInstruction) : null);
	          }
	          this.renderDeclutter_(declutterGroup, feature);
	          ++i;
	          break;
	        case Instruction.DRAW_CHARS:
	          var begin = /** @type {number} */ (instruction[1]);
	          var end = /** @type {number} */ (instruction[2]);
	          var baseline = /** @type {number} */ (instruction[3]);
	          declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[4]);
	          var overflow = /** @type {number} */ (instruction[5]);
	          var fillKey = /** @type {string} */ (instruction[6]);
	          var maxAngle = /** @type {number} */ (instruction[7]);
	          var measure = /** @type {function(string):number} */ (instruction[8]);
	          var offsetY = /** @type {number} */ (instruction[9]);
	          var strokeKey = /** @type {string} */ (instruction[10]);
	          var strokeWidth = /** @type {number} */ (instruction[11]);
	          var text = /** @type {string} */ (instruction[12]);
	          var textKey = /** @type {string} */ (instruction[13]);
	          var textScale = /** @type {number} */ (instruction[14]);
	
	          var pathLength = lineStringLength(pixelCoordinates, begin, end, 2);
	          var textLength = measure(text);
	          if (overflow || textLength <= pathLength) {
	            /** @type {import("./TextReplay.js").default} */
	            var textReplay = /** @type {?} */ (this);
	            var textAlign = textReplay.textStates[textKey].textAlign;
	            var startM = (pathLength - textLength) * TEXT_ALIGN[textAlign];
	            var parts = drawTextOnPath(
	              pixelCoordinates, begin, end, 2, text, measure, startM, maxAngle);
	            if (parts) {
	              var c = (void 0), cc = (void 0), chars = (void 0), label = (void 0), part = (void 0);
	              if (strokeKey) {
	                for (c = 0, cc = parts.length; c < cc; ++c) {
	                  part = parts[c]; // x, y, anchorX, rotation, chunk
	                  chars = /** @type {string} */ (part[4]);
	                  label = textReplay.getImage(chars, textKey, '', strokeKey);
	                  anchorX = /** @type {number} */ (part[2]) + strokeWidth;
	                  anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth - offsetY;
	                  this.replayImage_(context,
	                    /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
	                    anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
	                    /** @type {number} */ (part[3]), textScale, false, label.width,
	                    defaultPadding, null, null);
	                }
	              }
	              if (fillKey) {
	                for (c = 0, cc = parts.length; c < cc; ++c) {
	                  part = parts[c]; // x, y, anchorX, rotation, chunk
	                  chars = /** @type {string} */ (part[4]);
	                  label = textReplay.getImage(chars, textKey, fillKey, '');
	                  anchorX = /** @type {number} */ (part[2]);
	                  anchorY = baseline * label.height - offsetY;
	                  this.replayImage_(context,
	                    /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
	                    anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
	                    /** @type {number} */ (part[3]), textScale, false, label.width,
	                    defaultPadding, null, null);
	                }
	              }
	            }
	          }
	          this.renderDeclutter_(declutterGroup, feature);
	          ++i;
	          break;
	        case Instruction.END_GEOMETRY:
	          if (featureCallback !== undefined) {
	            feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
	            var result = featureCallback(feature);
	            if (result) {
	              return result;
	            }
	          }
	          ++i;
	          break;
	        case Instruction.FILL:
	          if (batchSize) {
	            pendingFill++;
	          } else {
	            this.fill_(context);
	          }
	          ++i;
	          break;
	        case Instruction.MOVE_TO_LINE_TO:
	          d = /** @type {number} */ (instruction[1]);
	          dd = /** @type {number} */ (instruction[2]);
	          x = pixelCoordinates[d];
	          y = pixelCoordinates[d + 1];
	          roundX = (x + 0.5) | 0;
	          roundY = (y + 0.5) | 0;
	          if (roundX !== prevX || roundY !== prevY) {
	            context.moveTo(x, y);
	            prevX = roundX;
	            prevY = roundY;
	          }
	          for (d += 2; d < dd; d += 2) {
	            x = pixelCoordinates[d];
	            y = pixelCoordinates[d + 1];
	            roundX = (x + 0.5) | 0;
	            roundY = (y + 0.5) | 0;
	            if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
	              context.lineTo(x, y);
	              prevX = roundX;
	              prevY = roundY;
	            }
	          }
	          ++i;
	          break;
	        case Instruction.SET_FILL_STYLE:
	          lastFillInstruction = instruction;
	          this.alignFill_ = instruction[2];
	
	          if (pendingFill) {
	            this.fill_(context);
	            pendingFill = 0;
	            if (pendingStroke) {
	              context.stroke();
	              pendingStroke = 0;
	            }
	          }
	
	          context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
	          ++i;
	          break;
	        case Instruction.SET_STROKE_STYLE:
	          lastStrokeInstruction = instruction;
	          if (pendingStroke) {
	            context.stroke();
	            pendingStroke = 0;
	          }
	          this.setStrokeStyle_(context, /** @type {Array<*>} */ (instruction));
	          ++i;
	          break;
	        case Instruction.STROKE:
	          if (batchSize) {
	            pendingStroke++;
	          } else {
	            context.stroke();
	          }
	          ++i;
	          break;
	        default:
	          ++i; // consume the instruction anyway, to avoid an infinite loop
	          break;
	      }
	    }
	    if (pendingFill) {
	      this.fill_(context);
	    }
	    if (pendingStroke) {
	      context.stroke();
	    }
	    return undefined;
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../transform.js").Transform} transform Transform.
	   * @param {number} viewRotation View rotation.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
	   *     to skip.
	   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
	   */
	  CanvasReplay.prototype.replay = function replay (context, transform, viewRotation, skippedFeaturesHash, snapToPixel) {
	    this.viewRotation_ = viewRotation;
	    this.replay_(context, transform,
	      skippedFeaturesHash, this.instructions, snapToPixel, undefined, undefined);
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../transform.js").Transform} transform Transform.
	   * @param {number} viewRotation View rotation.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
	   *     to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T=} opt_featureCallback
	   *     Feature callback.
	   * @param {import("../../extent.js").Extent=} opt_hitExtent Only check features that intersect this
	   *     extent.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  CanvasReplay.prototype.replayHitDetection = function replayHitDetection (
	    context,
	    transform,
	    viewRotation,
	    skippedFeaturesHash,
	    opt_featureCallback,
	    opt_hitExtent
	  ) {
	    this.viewRotation_ = viewRotation;
	    return this.replay_(context, transform, skippedFeaturesHash,
	      this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent);
	  };
	
	  /**
	   * Reverse the hit detection instructions.
	   */
	  CanvasReplay.prototype.reverseHitDetectionInstructions = function reverseHitDetectionInstructions () {
	    var hitDetectionInstructions = this.hitDetectionInstructions;
	    // step 1 - reverse array
	    hitDetectionInstructions.reverse();
	    // step 2 - reverse instructions within geometry blocks
	    var i;
	    var n = hitDetectionInstructions.length;
	    var instruction;
	    var type;
	    var begin = -1;
	    for (i = 0; i < n; ++i) {
	      instruction = hitDetectionInstructions[i];
	      type = /** @type {CanvasInstruction} */ (instruction[0]);
	      if (type == Instruction.END_GEOMETRY) {
	        begin = i;
	      } else if (type == Instruction.BEGIN_GEOMETRY) {
	        instruction[2] = i;
	        reverseSubArray(this.hitDetectionInstructions, begin, i);
	        begin = -1;
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasReplay.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {
	    var state = this.state;
	    if (fillStyle) {
	      var fillStyleColor = fillStyle.getColor();
	      state.fillStyle = asColorLike(fillStyleColor ?
	        fillStyleColor : defaultFillStyle);
	    } else {
	      state.fillStyle = undefined;
	    }
	    if (strokeStyle) {
	      var strokeStyleColor = strokeStyle.getColor();
	      state.strokeStyle = asColorLike(strokeStyleColor ?
	        strokeStyleColor : defaultStrokeStyle);
	      var strokeStyleLineCap = strokeStyle.getLineCap();
	      state.lineCap = strokeStyleLineCap !== undefined ?
	        strokeStyleLineCap : defaultLineCap;
	      var strokeStyleLineDash = strokeStyle.getLineDash();
	      state.lineDash = strokeStyleLineDash ?
	        strokeStyleLineDash.slice() : defaultLineDash;
	      var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
	      state.lineDashOffset = strokeStyleLineDashOffset ?
	        strokeStyleLineDashOffset : defaultLineDashOffset;
	      var strokeStyleLineJoin = strokeStyle.getLineJoin();
	      state.lineJoin = strokeStyleLineJoin !== undefined ?
	        strokeStyleLineJoin : defaultLineJoin;
	      var strokeStyleWidth = strokeStyle.getWidth();
	      state.lineWidth = strokeStyleWidth !== undefined ?
	        strokeStyleWidth : defaultLineWidth;
	      var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
	      state.miterLimit = strokeStyleMiterLimit !== undefined ?
	        strokeStyleMiterLimit : defaultMiterLimit;
	
	      if (state.lineWidth > this.maxLineWidth) {
	        this.maxLineWidth = state.lineWidth;
	        // invalidate the buffered max extent cache
	        this.bufferedMaxExtent_ = null;
	      }
	    } else {
	      state.strokeStyle = undefined;
	      state.lineCap = undefined;
	      state.lineDash = null;
	      state.lineDashOffset = undefined;
	      state.lineJoin = undefined;
	      state.lineWidth = undefined;
	      state.miterLimit = undefined;
	    }
	  };
	
	  /**
	   * @param {import("../canvas.js").FillStrokeState} state State.
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
	   * @return {Array<*>} Fill instruction.
	   */
	  CanvasReplay.prototype.createFill = function createFill (state, geometry) {
	    var fillStyle = state.fillStyle;
	    /** @type {Array<*>} */
	    var fillInstruction$$1 = [Instruction.SET_FILL_STYLE, fillStyle];
	    if (typeof fillStyle !== 'string') {
	      // Fill is a pattern or gradient - align it!
	      fillInstruction$$1.push(true);
	    }
	    return fillInstruction$$1;
	  };
	
	  /**
	   * @param {import("../canvas.js").FillStrokeState} state State.
	   */
	  CanvasReplay.prototype.applyStroke = function applyStroke (state) {
	    this.instructions.push(this.createStroke(state));
	  };
	
	  /**
	   * @param {import("../canvas.js").FillStrokeState} state State.
	   * @return {Array<*>} Stroke instruction.
	   */
	  CanvasReplay.prototype.createStroke = function createStroke (state) {
	    return [
	      Instruction.SET_STROKE_STYLE,
	      state.strokeStyle, state.lineWidth * this.pixelRatio, state.lineCap,
	      state.lineJoin, state.miterLimit,
	      this.applyPixelRatio(state.lineDash), state.lineDashOffset * this.pixelRatio
	    ];
	  };
	
	  /**
	   * @param {import("../canvas.js").FillStrokeState} state State.
	   * @param {function(this:CanvasReplay, import("../canvas.js").FillStrokeState, (import("../../geom/Geometry.js").default|import("../Feature.js").default)):Array<*>} createFill Create fill.
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
	   */
	  CanvasReplay.prototype.updateFillStyle = function updateFillStyle (state, createFill, geometry) {
	    var fillStyle = state.fillStyle;
	    if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
	      if (fillStyle !== undefined) {
	        this.instructions.push(createFill.call(this, state, geometry));
	      }
	      state.currentFillStyle = fillStyle;
	    }
	  };
	
	  /**
	   * @param {import("../canvas.js").FillStrokeState} state State.
	   * @param {function(this:CanvasReplay, import("../canvas.js").FillStrokeState)} applyStroke Apply stroke.
	   */
	  CanvasReplay.prototype.updateStrokeStyle = function updateStrokeStyle (state, applyStroke) {
	    var strokeStyle = state.strokeStyle;
	    var lineCap = state.lineCap;
	    var lineDash = state.lineDash;
	    var lineDashOffset = state.lineDashOffset;
	    var lineJoin = state.lineJoin;
	    var lineWidth = state.lineWidth;
	    var miterLimit = state.miterLimit;
	    if (state.currentStrokeStyle != strokeStyle ||
	        state.currentLineCap != lineCap ||
	        (lineDash != state.currentLineDash && !equals(state.currentLineDash, lineDash)) ||
	        state.currentLineDashOffset != lineDashOffset ||
	        state.currentLineJoin != lineJoin ||
	        state.currentLineWidth != lineWidth ||
	        state.currentMiterLimit != miterLimit) {
	      if (strokeStyle !== undefined) {
	        applyStroke.call(this, state);
	      }
	      state.currentStrokeStyle = strokeStyle;
	      state.currentLineCap = lineCap;
	      state.currentLineDash = lineDash;
	      state.currentLineDashOffset = lineDashOffset;
	      state.currentLineJoin = lineJoin;
	      state.currentLineWidth = lineWidth;
	      state.currentMiterLimit = miterLimit;
	    }
	  };
	
	  /**
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
	   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	   */
	  CanvasReplay.prototype.endGeometry = function endGeometry (geometry, feature) {
	    this.beginGeometryInstruction1_[2] = this.instructions.length;
	    this.beginGeometryInstruction1_ = null;
	    this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
	    this.beginGeometryInstruction2_ = null;
	    var endGeometryInstruction = [Instruction.END_GEOMETRY, feature];
	    this.instructions.push(endGeometryInstruction);
	    this.hitDetectionInstructions.push(endGeometryInstruction);
	  };
	
	  /**
	   * Get the buffered rendering extent.  Rendering will be clipped to the extent
	   * provided to the constructor.  To account for symbolizers that may intersect
	   * this extent, we calculate a buffered extent (e.g. based on stroke width).
	   * @return {import("../../extent.js").Extent} The buffered rendering extent.
	   * @protected
	   */
	  CanvasReplay.prototype.getBufferedMaxExtent = function getBufferedMaxExtent () {
	    if (!this.bufferedMaxExtent_) {
	      this.bufferedMaxExtent_ = clone(this.maxExtent);
	      if (this.maxLineWidth > 0) {
	        var width = this.resolution * (this.maxLineWidth + 1) / 2;
	        buffer(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
	      }
	    }
	    return this.bufferedMaxExtent_;
	  };
	
	  return CanvasReplay;
	}(VectorContext));
	
	/**
	 * @module ol/render/canvas/ImageReplay
	 */
	
	var CanvasImageReplay = /*@__PURE__*/(function (CanvasReplay$$1) {
	  function CanvasImageReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
	    CanvasReplay$$1.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
	
	    /**
	     * @private
	     * @type {import("../canvas.js").DeclutterGroup}
	     */
	    this.declutterGroup_ = null;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
	     */
	    this.hitDetectionImage_ = null;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.anchorX_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.anchorY_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.height_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.opacity_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.originX_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.originY_ = undefined;
	
	    /**
	     * @private
	     * @type {boolean|undefined}
	     */
	    this.rotateWithView_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.rotation_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.scale_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.width_ = undefined;
	
	  }
	
	  if ( CanvasReplay$$1 ) { CanvasImageReplay.__proto__ = CanvasReplay$$1; }
	  CanvasImageReplay.prototype = Object.create( CanvasReplay$$1 && CanvasReplay$$1.prototype );
	  CanvasImageReplay.prototype.constructor = CanvasImageReplay;
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @private
	   * @return {number} My end.
	   */
	  CanvasImageReplay.prototype.drawCoordinates_ = function drawCoordinates_ (flatCoordinates, offset, end, stride) {
	    return this.appendFlatCoordinates(flatCoordinates, offset, end, stride, false, false);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageReplay.prototype.drawPoint = function drawPoint (pointGeometry, feature) {
	    if (!this.image_) {
	      return;
	    }
	    this.beginGeometry(pointGeometry, feature);
	    var flatCoordinates = pointGeometry.getFlatCoordinates();
	    var stride = pointGeometry.getStride();
	    var myBegin = this.coordinates.length;
	    var myEnd = this.drawCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
	    this.instructions.push([
	      Instruction.DRAW_IMAGE, myBegin, myEnd, this.image_,
	      // Remaining arguments to DRAW_IMAGE are in alphabetical order
	      this.anchorX_, this.anchorY_, this.declutterGroup_, this.height_, this.opacity_,
	      this.originX_, this.originY_, this.rotateWithView_, this.rotation_,
	      this.scale_ * this.pixelRatio, this.width_
	    ]);
	    this.hitDetectionInstructions.push([
	      Instruction.DRAW_IMAGE, myBegin, myEnd, this.hitDetectionImage_,
	      // Remaining arguments to DRAW_IMAGE are in alphabetical order
	      this.anchorX_, this.anchorY_, this.declutterGroup_, this.height_, this.opacity_,
	      this.originX_, this.originY_, this.rotateWithView_, this.rotation_,
	      this.scale_, this.width_
	    ]);
	    this.endGeometry(pointGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageReplay.prototype.drawMultiPoint = function drawMultiPoint (multiPointGeometry, feature) {
	    if (!this.image_) {
	      return;
	    }
	    this.beginGeometry(multiPointGeometry, feature);
	    var flatCoordinates = multiPointGeometry.getFlatCoordinates();
	    var stride = multiPointGeometry.getStride();
	    var myBegin = this.coordinates.length;
	    var myEnd = this.drawCoordinates_(
	      flatCoordinates, 0, flatCoordinates.length, stride);
	    this.instructions.push([
	      Instruction.DRAW_IMAGE, myBegin, myEnd, this.image_,
	      // Remaining arguments to DRAW_IMAGE are in alphabetical order
	      this.anchorX_, this.anchorY_, this.declutterGroup_, this.height_, this.opacity_,
	      this.originX_, this.originY_, this.rotateWithView_, this.rotation_,
	      this.scale_ * this.pixelRatio, this.width_
	    ]);
	    this.hitDetectionInstructions.push([
	      Instruction.DRAW_IMAGE, myBegin, myEnd, this.hitDetectionImage_,
	      // Remaining arguments to DRAW_IMAGE are in alphabetical order
	      this.anchorX_, this.anchorY_, this.declutterGroup_, this.height_, this.opacity_,
	      this.originX_, this.originY_, this.rotateWithView_, this.rotation_,
	      this.scale_, this.width_
	    ]);
	    this.endGeometry(multiPointGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageReplay.prototype.finish = function finish () {
	    this.reverseHitDetectionInstructions();
	    // FIXME this doesn't really protect us against further calls to draw*Geometry
	    this.anchorX_ = undefined;
	    this.anchorY_ = undefined;
	    this.hitDetectionImage_ = null;
	    this.image_ = null;
	    this.height_ = undefined;
	    this.scale_ = undefined;
	    this.opacity_ = undefined;
	    this.originX_ = undefined;
	    this.originY_ = undefined;
	    this.rotateWithView_ = undefined;
	    this.rotation_ = undefined;
	    this.width_ = undefined;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasImageReplay.prototype.setImageStyle = function setImageStyle (imageStyle, declutterGroup) {
	    var anchor = imageStyle.getAnchor();
	    var size = imageStyle.getSize();
	    var hitDetectionImage = imageStyle.getHitDetectionImage(1);
	    var image = imageStyle.getImage(1);
	    var origin = imageStyle.getOrigin();
	    this.anchorX_ = anchor[0];
	    this.anchorY_ = anchor[1];
	    this.declutterGroup_ = /** @type {import("../canvas.js").DeclutterGroup} */ (declutterGroup);
	    this.hitDetectionImage_ = hitDetectionImage;
	    this.image_ = image;
	    this.height_ = size[1];
	    this.opacity_ = imageStyle.getOpacity();
	    this.originX_ = origin[0];
	    this.originY_ = origin[1];
	    this.rotateWithView_ = imageStyle.getRotateWithView();
	    this.rotation_ = imageStyle.getRotation();
	    this.scale_ = imageStyle.getScale();
	    this.width_ = size[0];
	  };
	
	  return CanvasImageReplay;
	}(CanvasReplay));
	
	/**
	 * @module ol/render/canvas/LineStringReplay
	 */
	
	var CanvasLineStringReplay = /*@__PURE__*/(function (CanvasReplay$$1) {
	  function CanvasLineStringReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
	    CanvasReplay$$1.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
	  }
	
	  if ( CanvasReplay$$1 ) { CanvasLineStringReplay.__proto__ = CanvasReplay$$1; }
	  CanvasLineStringReplay.prototype = Object.create( CanvasReplay$$1 && CanvasReplay$$1.prototype );
	  CanvasLineStringReplay.prototype.constructor = CanvasLineStringReplay;
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @private
	   * @return {number} end.
	   */
	  CanvasLineStringReplay.prototype.drawFlatCoordinates_ = function drawFlatCoordinates_ (flatCoordinates, offset, end, stride) {
	    var myBegin = this.coordinates.length;
	    var myEnd = this.appendFlatCoordinates(
	      flatCoordinates, offset, end, stride, false, false);
	    var moveToLineToInstruction = [Instruction.MOVE_TO_LINE_TO, myBegin, myEnd];
	    this.instructions.push(moveToLineToInstruction);
	    this.hitDetectionInstructions.push(moveToLineToInstruction);
	    return end;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasLineStringReplay.prototype.drawLineString = function drawLineString (lineStringGeometry, feature) {
	    var state = this.state;
	    var strokeStyle = state.strokeStyle;
	    var lineWidth = state.lineWidth;
	    if (strokeStyle === undefined || lineWidth === undefined) {
	      return;
	    }
	    this.updateStrokeStyle(state, this.applyStroke);
	    this.beginGeometry(lineStringGeometry, feature);
	    this.hitDetectionInstructions.push([
	      Instruction.SET_STROKE_STYLE,
	      state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin,
	      state.miterLimit, state.lineDash, state.lineDashOffset
	    ], beginPathInstruction);
	    var flatCoordinates = lineStringGeometry.getFlatCoordinates();
	    var stride = lineStringGeometry.getStride();
	    this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
	    this.hitDetectionInstructions.push(strokeInstruction);
	    this.endGeometry(lineStringGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasLineStringReplay.prototype.drawMultiLineString = function drawMultiLineString (multiLineStringGeometry, feature) {
	    var state = this.state;
	    var strokeStyle = state.strokeStyle;
	    var lineWidth = state.lineWidth;
	    if (strokeStyle === undefined || lineWidth === undefined) {
	      return;
	    }
	    this.updateStrokeStyle(state, this.applyStroke);
	    this.beginGeometry(multiLineStringGeometry, feature);
	    this.hitDetectionInstructions.push([
	      Instruction.SET_STROKE_STYLE,
	      state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin,
	      state.miterLimit, state.lineDash, state.lineDashOffset
	    ], beginPathInstruction);
	    var ends = multiLineStringGeometry.getEnds();
	    var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
	    var stride = multiLineStringGeometry.getStride();
	    var offset = 0;
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      offset = this.drawFlatCoordinates_(flatCoordinates, offset, ends[i], stride);
	    }
	    this.hitDetectionInstructions.push(strokeInstruction);
	    this.endGeometry(multiLineStringGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasLineStringReplay.prototype.finish = function finish () {
	    var state = this.state;
	    if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
	      this.instructions.push(strokeInstruction);
	    }
	    this.reverseHitDetectionInstructions();
	    this.state = null;
	  };
	
	  /**
	   * @inheritDoc.
	   */
	  CanvasLineStringReplay.prototype.applyStroke = function applyStroke (state) {
	    if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
	      this.instructions.push(strokeInstruction);
	      state.lastStroke = this.coordinates.length;
	    }
	    state.lastStroke = 0;
	    CanvasReplay$$1.prototype.applyStroke.call(this, state);
	    this.instructions.push(beginPathInstruction);
	  };
	
	  return CanvasLineStringReplay;
	}(CanvasReplay));
	
	/**
	 * @module ol/render/canvas/PolygonReplay
	 */
	
	
	var CanvasPolygonReplay = /*@__PURE__*/(function (CanvasReplay$$1) {
	  function CanvasPolygonReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
	    CanvasReplay$$1.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
	  }
	
	  if ( CanvasReplay$$1 ) { CanvasPolygonReplay.__proto__ = CanvasReplay$$1; }
	  CanvasPolygonReplay.prototype = Object.create( CanvasReplay$$1 && CanvasReplay$$1.prototype );
	  CanvasPolygonReplay.prototype.constructor = CanvasPolygonReplay;
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {Array<number>} ends Ends.
	   * @param {number} stride Stride.
	   * @private
	   * @return {number} End.
	   */
	  CanvasPolygonReplay.prototype.drawFlatCoordinatess_ = function drawFlatCoordinatess_ (flatCoordinates, offset, ends, stride) {
	    var state = this.state;
	    var fill = state.fillStyle !== undefined;
	    var stroke = state.strokeStyle != undefined;
	    var numEnds = ends.length;
	    this.instructions.push(beginPathInstruction);
	    this.hitDetectionInstructions.push(beginPathInstruction);
	    for (var i = 0; i < numEnds; ++i) {
	      var end = ends[i];
	      var myBegin = this.coordinates.length;
	      var myEnd = this.appendFlatCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
	      var moveToLineToInstruction = [Instruction.MOVE_TO_LINE_TO, myBegin, myEnd];
	      this.instructions.push(moveToLineToInstruction);
	      this.hitDetectionInstructions.push(moveToLineToInstruction);
	      if (stroke) {
	        // Performance optimization: only call closePath() when we have a stroke.
	        // Otherwise the ring is closed already (see appendFlatCoordinates above).
	        this.instructions.push(closePathInstruction);
	        this.hitDetectionInstructions.push(closePathInstruction);
	      }
	      offset = end;
	    }
	    if (fill) {
	      this.instructions.push(fillInstruction);
	      this.hitDetectionInstructions.push(fillInstruction);
	    }
	    if (stroke) {
	      this.instructions.push(strokeInstruction);
	      this.hitDetectionInstructions.push(strokeInstruction);
	    }
	    return offset;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasPolygonReplay.prototype.drawCircle = function drawCircle (circleGeometry, feature) {
	    var state = this.state;
	    var fillStyle = state.fillStyle;
	    var strokeStyle = state.strokeStyle;
	    if (fillStyle === undefined && strokeStyle === undefined) {
	      return;
	    }
	    this.setFillStrokeStyles_(circleGeometry);
	    this.beginGeometry(circleGeometry, feature);
	    if (state.fillStyle !== undefined) {
	      this.hitDetectionInstructions.push([
	        Instruction.SET_FILL_STYLE,
	        asString(defaultFillStyle)
	      ]);
	    }
	    if (state.strokeStyle !== undefined) {
	      this.hitDetectionInstructions.push([
	        Instruction.SET_STROKE_STYLE,
	        state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin,
	        state.miterLimit, state.lineDash, state.lineDashOffset
	      ]);
	    }
	    var flatCoordinates = circleGeometry.getFlatCoordinates();
	    var stride = circleGeometry.getStride();
	    var myBegin = this.coordinates.length;
	    this.appendFlatCoordinates(
	      flatCoordinates, 0, flatCoordinates.length, stride, false, false);
	    var circleInstruction = [Instruction.CIRCLE, myBegin];
	    this.instructions.push(beginPathInstruction, circleInstruction);
	    this.hitDetectionInstructions.push(beginPathInstruction, circleInstruction);
	    this.hitDetectionInstructions.push(fillInstruction);
	    if (state.fillStyle !== undefined) {
	      this.instructions.push(fillInstruction);
	    }
	    if (state.strokeStyle !== undefined) {
	      this.instructions.push(strokeInstruction);
	      this.hitDetectionInstructions.push(strokeInstruction);
	    }
	    this.endGeometry(circleGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasPolygonReplay.prototype.drawPolygon = function drawPolygon (polygonGeometry, feature) {
	    var state = this.state;
	    var fillStyle = state.fillStyle;
	    var strokeStyle = state.strokeStyle;
	    if (fillStyle === undefined && strokeStyle === undefined) {
	      return;
	    }
	    this.setFillStrokeStyles_(polygonGeometry);
	    this.beginGeometry(polygonGeometry, feature);
	    if (state.fillStyle !== undefined) {
	      this.hitDetectionInstructions.push([
	        Instruction.SET_FILL_STYLE,
	        asString(defaultFillStyle)
	      ]);
	    }
	    if (state.strokeStyle !== undefined) {
	      this.hitDetectionInstructions.push([
	        Instruction.SET_STROKE_STYLE,
	        state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin,
	        state.miterLimit, state.lineDash, state.lineDashOffset
	      ]);
	    }
	    var ends = polygonGeometry.getEnds();
	    var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
	    var stride = polygonGeometry.getStride();
	    this.drawFlatCoordinatess_(flatCoordinates, 0, ends, stride);
	    this.endGeometry(polygonGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasPolygonReplay.prototype.drawMultiPolygon = function drawMultiPolygon (multiPolygonGeometry, feature) {
	    var state = this.state;
	    var fillStyle = state.fillStyle;
	    var strokeStyle = state.strokeStyle;
	    if (fillStyle === undefined && strokeStyle === undefined) {
	      return;
	    }
	    this.setFillStrokeStyles_(multiPolygonGeometry);
	    this.beginGeometry(multiPolygonGeometry, feature);
	    if (state.fillStyle !== undefined) {
	      this.hitDetectionInstructions.push([
	        Instruction.SET_FILL_STYLE,
	        asString(defaultFillStyle)
	      ]);
	    }
	    if (state.strokeStyle !== undefined) {
	      this.hitDetectionInstructions.push([
	        Instruction.SET_STROKE_STYLE,
	        state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin,
	        state.miterLimit, state.lineDash, state.lineDashOffset
	      ]);
	    }
	    var endss = multiPolygonGeometry.getEndss();
	    var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
	    var stride = multiPolygonGeometry.getStride();
	    var offset = 0;
	    for (var i = 0, ii = endss.length; i < ii; ++i) {
	      offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
	    }
	    this.endGeometry(multiPolygonGeometry, feature);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasPolygonReplay.prototype.finish = function finish () {
	    this.reverseHitDetectionInstructions();
	    this.state = null;
	    // We want to preserve topology when drawing polygons.  Polygons are
	    // simplified using quantization and point elimination. However, we might
	    // have received a mix of quantized and non-quantized geometries, so ensure
	    // that all are quantized by quantizing all coordinates in the batch.
	    var tolerance = this.tolerance;
	    if (tolerance !== 0) {
	      var coordinates = this.coordinates;
	      for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	        coordinates[i] = snap(coordinates[i], tolerance);
	      }
	    }
	  };
	
	  /**
	   * @private
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
	   */
	  CanvasPolygonReplay.prototype.setFillStrokeStyles_ = function setFillStrokeStyles_ (geometry) {
	    var state = this.state;
	    var fillStyle = state.fillStyle;
	    if (fillStyle !== undefined) {
	      this.updateFillStyle(state, this.createFill, geometry);
	    }
	    if (state.strokeStyle !== undefined) {
	      this.updateStrokeStyle(state, this.applyStroke);
	    }
	  };
	
	  return CanvasPolygonReplay;
	}(CanvasReplay));
	
	/**
	 * @module ol/geom/flat/straightchunk
	 */
	
	
	/**
	 * @param {number} maxAngle Maximum acceptable angle delta between segments.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @return {Array<number>} Start and end of the first suitable chunk of the
	 * given `flatCoordinates`.
	 */
	function matchingChunk(maxAngle, flatCoordinates, offset, end, stride) {
	  var chunkStart = offset;
	  var chunkEnd = offset;
	  var chunkM = 0;
	  var m = 0;
	  var start = offset;
	  var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
	  for (i = offset; i < end; i += stride) {
	    var x2 = flatCoordinates[i];
	    var y2 = flatCoordinates[i + 1];
	    if (x1 !== undefined) {
	      x23 = x2 - x1;
	      y23 = y2 - y1;
	      m23 = Math.sqrt(x23 * x23 + y23 * y23);
	      if (x12 !== undefined) {
	        m += m12;
	        acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
	        if (acos > maxAngle) {
	          if (m > chunkM) {
	            chunkM = m;
	            chunkStart = start;
	            chunkEnd = i;
	          }
	          m = 0;
	          start = i - stride;
	        }
	      }
	      m12 = m23;
	      x12 = x23;
	      y12 = y23;
	    }
	    x1 = x2;
	    y1 = y2;
	  }
	  m += m23;
	  return m > chunkM ? [start, i] : [chunkStart, chunkEnd];
	}
	
	/**
	 * @module ol/render/canvas/TextReplay
	 */
	
	/**
	 * @api
	 */
	var CanvasTextReplay = /*@__PURE__*/(function (CanvasReplay$$1) {
	  function CanvasTextReplay(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
	    CanvasReplay$$1.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
	
	    /**
	     * @private
	     * @type {import("../canvas.js").DeclutterGroup}
	     */
	    this.declutterGroup_;
	
	    /**
	     * @private
	     * @type {Array<HTMLCanvasElement>}
	     */
	    this.labels_ = null;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.text_ = '';
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textOffsetX_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textOffsetY_ = 0;
	
	    /**
	     * @private
	     * @type {boolean|undefined}
	     */
	    this.textRotateWithView_ = undefined;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textRotation_ = 0;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").FillState}
	     */
	    this.textFillState_ = null;
	
	    /**
	     * @type {!Object<string, import("../canvas.js").FillState>}
	     */
	    this.fillStates = {};
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").StrokeState}
	     */
	    this.textStrokeState_ = null;
	
	    /**
	     * @type {!Object<string, import("../canvas.js").StrokeState>}
	     */
	    this.strokeStates = {};
	
	    /**
	     * @private
	     * @type {import("../canvas.js").TextState}
	     */
	    this.textState_ = /** @type {import("../canvas.js").TextState} */ ({});
	
	    /**
	     * @type {!Object<string, import("../canvas.js").TextState>}
	     */
	    this.textStates = {};
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.textKey_ = '';
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.fillKey_ = '';
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.strokeKey_ = '';
	
	    /**
	     * @private
	     * @type {Object<string, Object<string, number>>}
	     */
	    this.widths_ = {};
	
	    labelCache.prune();
	
	  }
	
	  if ( CanvasReplay$$1 ) { CanvasTextReplay.__proto__ = CanvasReplay$$1; }
	  CanvasTextReplay.prototype = Object.create( CanvasReplay$$1 && CanvasReplay$$1.prototype );
	  CanvasTextReplay.prototype.constructor = CanvasTextReplay;
	
	  /**
	   * @inheritDoc
	   */
	  CanvasTextReplay.prototype.drawText = function drawText (geometry, feature) {
	    var fillState = this.textFillState_;
	    var strokeState = this.textStrokeState_;
	    var textState = this.textState_;
	    if (this.text_ === '' || !textState || (!fillState && !strokeState)) {
	      return;
	    }
	
	    var begin = this.coordinates.length;
	
	    var geometryType = geometry.getType();
	    var flatCoordinates = null;
	    var end = 2;
	    var stride = 2;
	    var i, ii;
	
	    if (textState.placement === TextPlacement.LINE) {
	      if (!intersects(this.getBufferedMaxExtent(), geometry.getExtent())) {
	        return;
	      }
	      var ends;
	      flatCoordinates = geometry.getFlatCoordinates();
	      stride = geometry.getStride();
	      if (geometryType == GeometryType.LINE_STRING) {
	        ends = [flatCoordinates.length];
	      } else if (geometryType == GeometryType.MULTI_LINE_STRING) {
	        ends = geometry.getEnds();
	      } else if (geometryType == GeometryType.POLYGON) {
	        ends = geometry.getEnds().slice(0, 1);
	      } else if (geometryType == GeometryType.MULTI_POLYGON) {
	        var endss = geometry.getEndss();
	        ends = [];
	        for (i = 0, ii = endss.length; i < ii; ++i) {
	          ends.push(endss[i][0]);
	        }
	      }
	      this.beginGeometry(geometry, feature);
	      var textAlign = textState.textAlign;
	      var flatOffset = 0;
	      var flatEnd;
	      for (var o = 0, oo = ends.length; o < oo; ++o) {
	        if (textAlign == undefined) {
	          var range = matchingChunk(textState.maxAngle, flatCoordinates, flatOffset, ends[o], stride);
	          flatOffset = range[0];
	          flatEnd = range[1];
	        } else {
	          flatEnd = ends[o];
	        }
	        for (i = flatOffset; i < flatEnd; i += stride) {
	          this.coordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
	        }
	        end = this.coordinates.length;
	        flatOffset = ends[o];
	        this.drawChars_(begin, end, this.declutterGroup_);
	        begin = end;
	      }
	      this.endGeometry(geometry, feature);
	
	    } else {
	      var label = this.getImage(this.text_, this.textKey_, this.fillKey_, this.strokeKey_);
	      var width = label.width / this.pixelRatio;
	      switch (geometryType) {
	        case GeometryType.POINT:
	        case GeometryType.MULTI_POINT:
	          flatCoordinates = geometry.getFlatCoordinates();
	          end = flatCoordinates.length;
	          break;
	        case GeometryType.LINE_STRING:
	          flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ (geometry).getFlatMidpoint();
	          break;
	        case GeometryType.CIRCLE:
	          flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ (geometry).getCenter();
	          break;
	        case GeometryType.MULTI_LINE_STRING:
	          flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ (geometry).getFlatMidpoints();
	          end = flatCoordinates.length;
	          break;
	        case GeometryType.POLYGON:
	          flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ (geometry).getFlatInteriorPoint();
	          if (!textState.overflow && flatCoordinates[2] / this.resolution < width) {
	            return;
	          }
	          stride = 3;
	          break;
	        case GeometryType.MULTI_POLYGON:
	          var interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry).getFlatInteriorPoints();
	          flatCoordinates = [];
	          for (i = 0, ii = interiorPoints.length; i < ii; i += 3) {
	            if (textState.overflow || interiorPoints[i + 2] / this.resolution >= width) {
	              flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
	            }
	          }
	          end = flatCoordinates.length;
	          if (end == 0) {
	            return;
	          }
	          break;
	        default:
	      }
	      end = this.appendFlatCoordinates(flatCoordinates, 0, end, stride, false, false);
	      if (textState.backgroundFill || textState.backgroundStroke) {
	        this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
	        if (textState.backgroundFill) {
	          this.updateFillStyle(this.state, this.createFill, geometry);
	          this.hitDetectionInstructions.push(this.createFill(this.state, geometry));
	        }
	        if (textState.backgroundStroke) {
	          this.updateStrokeStyle(this.state, this.applyStroke);
	          this.hitDetectionInstructions.push(this.createStroke(this.state));
	        }
	      }
	      this.beginGeometry(geometry, feature);
	      this.drawTextImage_(label, begin, end);
	      this.endGeometry(geometry, feature);
	    }
	  };
	
	  /**
	   * @param {string} text Text.
	   * @param {string} textKey Text style key.
	   * @param {string} fillKey Fill style key.
	   * @param {string} strokeKey Stroke style key.
	   * @return {HTMLCanvasElement} Image.
	   */
	  CanvasTextReplay.prototype.getImage = function getImage (text, textKey, fillKey, strokeKey) {
	    var label;
	    var key = strokeKey + textKey + text + fillKey + this.pixelRatio;
	
	    if (!labelCache.containsKey(key)) {
	      var strokeState = strokeKey ? this.strokeStates[strokeKey] || this.textStrokeState_ : null;
	      var fillState = fillKey ? this.fillStates[fillKey] || this.textFillState_ : null;
	      var textState = this.textStates[textKey] || this.textState_;
	      var pixelRatio = this.pixelRatio;
	      var scale = textState.scale * pixelRatio;
	      var align = TEXT_ALIGN[textState.textAlign || defaultTextAlign];
	      var strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
	
	      var lines = text.split('\n');
	      var numLines = lines.length;
	      var widths = [];
	      var width = measureTextWidths(textState.font, lines, widths);
	      var lineHeight = measureTextHeight(textState.font);
	      var height = lineHeight * numLines;
	      var renderWidth = (width + strokeWidth);
	      var context = createCanvasContext2D(
	        Math.ceil(renderWidth * scale),
	        Math.ceil((height + strokeWidth) * scale));
	      label = context.canvas;
	      labelCache.set(key, label);
	      if (scale != 1) {
	        context.scale(scale, scale);
	      }
	      context.font = textState.font;
	      if (strokeKey) {
	        context.strokeStyle = strokeState.strokeStyle;
	        context.lineWidth = strokeWidth;
	        context.lineCap = /** @type {CanvasLineCap} */ (strokeState.lineCap);
	        context.lineJoin = /** @type {CanvasLineJoin} */ (strokeState.lineJoin);
	        context.miterLimit = strokeState.miterLimit;
	        if (CANVAS_LINE_DASH && strokeState.lineDash.length) {
	          context.setLineDash(strokeState.lineDash);
	          context.lineDashOffset = strokeState.lineDashOffset;
	        }
	      }
	      if (fillKey) {
	        context.fillStyle = fillState.fillStyle;
	      }
	      context.textBaseline = 'middle';
	      context.textAlign = 'center';
	      var leftRight = (0.5 - align);
	      var x = align * label.width / scale + leftRight * strokeWidth;
	      var i;
	      if (strokeKey) {
	        for (i = 0; i < numLines; ++i) {
	          context.strokeText(lines[i], x + leftRight * widths[i], 0.5 * (strokeWidth + lineHeight) + i * lineHeight);
	        }
	      }
	      if (fillKey) {
	        for (i = 0; i < numLines; ++i) {
	          context.fillText(lines[i], x + leftRight * widths[i], 0.5 * (strokeWidth + lineHeight) + i * lineHeight);
	        }
	      }
	    }
	    return labelCache.get(key);
	  };
	
	  /**
	   * @private
	   * @param {HTMLCanvasElement} label Label.
	   * @param {number} begin Begin.
	   * @param {number} end End.
	   */
	  CanvasTextReplay.prototype.drawTextImage_ = function drawTextImage_ (label, begin, end) {
	    var textState = this.textState_;
	    var strokeState = this.textStrokeState_;
	    var pixelRatio = this.pixelRatio;
	    var align = TEXT_ALIGN[textState.textAlign || defaultTextAlign];
	    var baseline = TEXT_ALIGN[textState.textBaseline];
	    var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
	
	    var anchorX = align * label.width / pixelRatio + 2 * (0.5 - align) * strokeWidth;
	    var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
	    this.instructions.push([Instruction.DRAW_IMAGE, begin, end,
	      label, (anchorX - this.textOffsetX_) * pixelRatio, (anchorY - this.textOffsetY_) * pixelRatio,
	      this.declutterGroup_, label.height, 1, 0, 0, this.textRotateWithView_, this.textRotation_,
	      1, label.width,
	      textState.padding == defaultPadding ?
	        defaultPadding : textState.padding.map(function(p) {
	          return p * pixelRatio;
	        }),
	      !!textState.backgroundFill, !!textState.backgroundStroke
	    ]);
	    this.hitDetectionInstructions.push([Instruction.DRAW_IMAGE, begin, end,
	      label, (anchorX - this.textOffsetX_) * pixelRatio, (anchorY - this.textOffsetY_) * pixelRatio,
	      this.declutterGroup_, label.height, 1, 0, 0, this.textRotateWithView_, this.textRotation_,
	      1 / pixelRatio, label.width, textState.padding,
	      !!textState.backgroundFill, !!textState.backgroundStroke
	    ]);
	  };
	
	  /**
	   * @private
	   * @param {number} begin Begin.
	   * @param {number} end End.
	   * @param {import("../canvas.js").DeclutterGroup} declutterGroup Declutter group.
	   */
	  CanvasTextReplay.prototype.drawChars_ = function drawChars_ (begin, end, declutterGroup) {
	    var strokeState = this.textStrokeState_;
	    var textState = this.textState_;
	    var fillState = this.textFillState_;
	
	    var strokeKey = this.strokeKey_;
	    if (strokeState) {
	      if (!(strokeKey in this.strokeStates)) {
	        this.strokeStates[strokeKey] = /** @type {import("../canvas.js").StrokeState} */ ({
	          strokeStyle: strokeState.strokeStyle,
	          lineCap: strokeState.lineCap,
	          lineDashOffset: strokeState.lineDashOffset,
	          lineWidth: strokeState.lineWidth,
	          lineJoin: strokeState.lineJoin,
	          miterLimit: strokeState.miterLimit,
	          lineDash: strokeState.lineDash
	        });
	      }
	    }
	    var textKey = this.textKey_;
	    if (!(this.textKey_ in this.textStates)) {
	      this.textStates[this.textKey_] = /** @type {import("../canvas.js").TextState} */ ({
	        font: textState.font,
	        textAlign: textState.textAlign || defaultTextAlign,
	        scale: textState.scale
	      });
	    }
	    var fillKey = this.fillKey_;
	    if (fillState) {
	      if (!(fillKey in this.fillStates)) {
	        this.fillStates[fillKey] = /** @type {import("../canvas.js").FillState} */ ({
	          fillStyle: fillState.fillStyle
	        });
	      }
	    }
	
	    var pixelRatio = this.pixelRatio;
	    var baseline = TEXT_ALIGN[textState.textBaseline];
	
	    var offsetY = this.textOffsetY_ * pixelRatio;
	    var text = this.text_;
	    var font = textState.font;
	    var textScale = textState.scale;
	    var strokeWidth = strokeState ? strokeState.lineWidth * textScale / 2 : 0;
	    var widths = this.widths_[font];
	    if (!widths) {
	      this.widths_[font] = widths = {};
	    }
	    this.instructions.push([Instruction.DRAW_CHARS,
	      begin, end, baseline, declutterGroup,
	      textState.overflow, fillKey, textState.maxAngle,
	      function(text) {
	        var width = widths[text];
	        if (!width) {
	          width = widths[text] = measureTextWidth(font, text);
	        }
	        return width * textScale * pixelRatio;
	      },
	      offsetY, strokeKey, strokeWidth * pixelRatio, text, textKey, 1
	    ]);
	    this.hitDetectionInstructions.push([Instruction.DRAW_CHARS,
	      begin, end, baseline, declutterGroup,
	      textState.overflow, fillKey, textState.maxAngle,
	      function(text) {
	        var width = widths[text];
	        if (!width) {
	          width = widths[text] = measureTextWidth(font, text);
	        }
	        return width * textScale;
	      },
	      offsetY, strokeKey, strokeWidth, text, textKey, 1 / pixelRatio
	    ]);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasTextReplay.prototype.setTextStyle = function setTextStyle (textStyle, declutterGroup) {
	    var textState, fillState, strokeState;
	    if (!textStyle) {
	      this.text_ = '';
	    } else {
	      this.declutterGroup_ = /** @type {import("../canvas.js").DeclutterGroup} */ (declutterGroup);
	
	      var textFillStyle = textStyle.getFill();
	      if (!textFillStyle) {
	        fillState = this.textFillState_ = null;
	      } else {
	        fillState = this.textFillState_;
	        if (!fillState) {
	          fillState = this.textFillState_ = /** @type {import("../canvas.js").FillState} */ ({});
	        }
	        fillState.fillStyle = asColorLike(
	          textFillStyle.getColor() || defaultFillStyle);
	      }
	
	      var textStrokeStyle = textStyle.getStroke();
	      if (!textStrokeStyle) {
	        strokeState = this.textStrokeState_ = null;
	      } else {
	        strokeState = this.textStrokeState_;
	        if (!strokeState) {
	          strokeState = this.textStrokeState_ = /** @type {import("../canvas.js").StrokeState} */ ({});
	        }
	        var lineDash = textStrokeStyle.getLineDash();
	        var lineDashOffset = textStrokeStyle.getLineDashOffset();
	        var lineWidth = textStrokeStyle.getWidth();
	        var miterLimit = textStrokeStyle.getMiterLimit();
	        strokeState.lineCap = textStrokeStyle.getLineCap() || defaultLineCap;
	        strokeState.lineDash = lineDash ? lineDash.slice() : defaultLineDash;
	        strokeState.lineDashOffset =
	            lineDashOffset === undefined ? defaultLineDashOffset : lineDashOffset;
	        strokeState.lineJoin = textStrokeStyle.getLineJoin() || defaultLineJoin;
	        strokeState.lineWidth =
	            lineWidth === undefined ? defaultLineWidth : lineWidth;
	        strokeState.miterLimit =
	            miterLimit === undefined ? defaultMiterLimit : miterLimit;
	        strokeState.strokeStyle = asColorLike(
	          textStrokeStyle.getColor() || defaultStrokeStyle);
	      }
	
	      textState = this.textState_;
	      var font = textStyle.getFont() || defaultFont;
	      checkFont(font);
	      var textScale = textStyle.getScale();
	      textState.overflow = textStyle.getOverflow();
	      textState.font = font;
	      textState.maxAngle = textStyle.getMaxAngle();
	      textState.placement = textStyle.getPlacement();
	      textState.textAlign = textStyle.getTextAlign();
	      textState.textBaseline = textStyle.getTextBaseline() || defaultTextBaseline;
	      textState.backgroundFill = textStyle.getBackgroundFill();
	      textState.backgroundStroke = textStyle.getBackgroundStroke();
	      textState.padding = textStyle.getPadding() || defaultPadding;
	      textState.scale = textScale === undefined ? 1 : textScale;
	
	      var textOffsetX = textStyle.getOffsetX();
	      var textOffsetY = textStyle.getOffsetY();
	      var textRotateWithView = textStyle.getRotateWithView();
	      var textRotation = textStyle.getRotation();
	      this.text_ = textStyle.getText() || '';
	      this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
	      this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
	      this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
	      this.textRotation_ = textRotation === undefined ? 0 : textRotation;
	
	      this.strokeKey_ = strokeState ?
	        (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : getUid(strokeState.strokeStyle)) +
	        strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth +
	        strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' :
	        '';
	      this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?');
	      this.fillKey_ = fillState ?
	        (typeof fillState.fillStyle == 'string' ? fillState.fillStyle : ('|' + getUid(fillState.fillStyle))) :
	        '';
	    }
	  };
	
	  return CanvasTextReplay;
	}(CanvasReplay));
	
	
	/**
	 * @param {string} font Font to use for measuring.
	 * @param {Array<string>} lines Lines to measure.
	 * @param {Array<number>} widths Array will be populated with the widths of
	 * each line.
	 * @return {number} Width of the whole text.
	 */
	function measureTextWidths(font, lines, widths) {
	  var numLines = lines.length;
	  var width = 0;
	  for (var i = 0; i < numLines; ++i) {
	    var currentWidth = measureTextWidth(font, lines[i]);
	    width = Math.max(width, currentWidth);
	    widths.push(currentWidth);
	  }
	  return width;
	}
	
	/**
	 * @module ol/render/canvas/ReplayGroup
	 */
	
	
	/**
	 * @type {Object<ReplayType, typeof CanvasReplay>}
	 */
	var BATCH_CONSTRUCTORS = {
	  'Circle': CanvasPolygonReplay,
	  'Default': CanvasReplay,
	  'Image': CanvasImageReplay,
	  'LineString': CanvasLineStringReplay,
	  'Polygon': CanvasPolygonReplay,
	  'Text': CanvasTextReplay
	};
	
	/**
	 * @api
	 */
	var CanvasReplayGroup = /*@__PURE__*/(function (ReplayGroup$$1) {
	  function CanvasReplayGroup(
	    tolerance,
	    maxExtent,
	    resolution,
	    pixelRatio,
	    overlaps,
	    declutterTree,
	    opt_renderBuffer
	  ) {
	    ReplayGroup$$1.call(this);
	
	    /**
	     * Declutter tree.
	     * @private
	     */
	    this.declutterTree_ = declutterTree;
	
	    /**
	     * @type {import("../canvas.js").DeclutterGroup}
	     * @private
	     */
	    this.declutterGroup_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.tolerance_ = tolerance;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.maxExtent_ = maxExtent;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.overlaps_ = overlaps;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.pixelRatio_ = pixelRatio;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.resolution_ = resolution;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.renderBuffer_ = opt_renderBuffer;
	
	    /**
	     * @private
	     * @type {!Object<string, !Object<ReplayType, CanvasReplay>>}
	     */
	    this.replaysByZIndex_ = {};
	
	    /**
	     * @private
	     * @type {CanvasRenderingContext2D}
	     */
	    this.hitDetectionContext_ = createCanvasContext2D(1, 1);
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.hitDetectionTransform_ = create();
	  }
	
	  if ( ReplayGroup$$1 ) { CanvasReplayGroup.__proto__ = ReplayGroup$$1; }
	  CanvasReplayGroup.prototype = Object.create( ReplayGroup$$1 && ReplayGroup$$1.prototype );
	  CanvasReplayGroup.prototype.constructor = CanvasReplayGroup;
	
	  /**
	   * @inheritDoc
	   */
	  CanvasReplayGroup.prototype.addDeclutter = function addDeclutter (group) {
	    var declutter = null;
	    if (this.declutterTree_) {
	      if (group) {
	        declutter = this.declutterGroup_;
	        /** @type {number} */ (declutter[4])++;
	      } else {
	        declutter = this.declutterGroup_ = createEmpty();
	        declutter.push(1);
	      }
	    }
	    return declutter;
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../transform.js").Transform} transform Transform.
	   */
	  CanvasReplayGroup.prototype.clip = function clip (context, transform) {
	    var flatClipCoords = this.getClipCoords(transform);
	    context.beginPath();
	    context.moveTo(flatClipCoords[0], flatClipCoords[1]);
	    context.lineTo(flatClipCoords[2], flatClipCoords[3]);
	    context.lineTo(flatClipCoords[4], flatClipCoords[5]);
	    context.lineTo(flatClipCoords[6], flatClipCoords[7]);
	    context.clip();
	  };
	
	  /**
	   * @param {Array<ReplayType>} replays Replays.
	   * @return {boolean} Has replays of the provided types.
	   */
	  CanvasReplayGroup.prototype.hasReplays = function hasReplays (replays) {
	    for (var zIndex in this.replaysByZIndex_) {
	      var candidates = this.replaysByZIndex_[zIndex];
	      for (var i = 0, ii = replays.length; i < ii; ++i) {
	        if (replays[i] in candidates) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  /**
	   * FIXME empty description for jsdoc
	   */
	  CanvasReplayGroup.prototype.finish = function finish () {
	    for (var zKey in this.replaysByZIndex_) {
	      var replays = this.replaysByZIndex_[zKey];
	      for (var replayKey in replays) {
	        replays[replayKey].finish();
	      }
	    }
	  };
	
	  /**
	   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {number} resolution Resolution.
	   * @param {number} rotation Rotation.
	   * @param {number} hitTolerance Hit tolerance in pixels.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T} callback Feature callback.
	   * @param {Object<string, import("../canvas.js").DeclutterGroup>} declutterReplays Declutter replays.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  CanvasReplayGroup.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (
	    coordinate,
	    resolution,
	    rotation,
	    hitTolerance,
	    skippedFeaturesHash,
	    callback,
	    declutterReplays
	  ) {
	
	    hitTolerance = Math.round(hitTolerance);
	    var contextSize = hitTolerance * 2 + 1;
	    var transform = compose(this.hitDetectionTransform_,
	      hitTolerance + 0.5, hitTolerance + 0.5,
	      1 / resolution, -1 / resolution,
	      -rotation,
	      -coordinate[0], -coordinate[1]);
	    var context = this.hitDetectionContext_;
	
	    if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
	      context.canvas.width = contextSize;
	      context.canvas.height = contextSize;
	    } else {
	      context.clearRect(0, 0, contextSize, contextSize);
	    }
	
	    /**
	     * @type {import("../../extent.js").Extent}
	     */
	    var hitExtent;
	    if (this.renderBuffer_ !== undefined) {
	      hitExtent = createEmpty();
	      extendCoordinate(hitExtent, coordinate);
	      buffer(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
	    }
	
	    var mask = getCircleArray(hitTolerance);
	    var declutteredFeatures;
	    if (this.declutterTree_) {
	      declutteredFeatures = this.declutterTree_.all().map(function(entry) {
	        return entry.value;
	      });
	    }
	
	    var replayType;
	
	    /**
	     * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	     * @return {?} Callback result.
	     */
	    function featureCallback(feature) {
	      var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
	      for (var i = 0; i < contextSize; i++) {
	        for (var j = 0; j < contextSize; j++) {
	          if (mask[i][j]) {
	            if (imageData[(j * contextSize + i) * 4 + 3] > 0) {
	              var result = (void 0);
	              if (!(declutteredFeatures && (replayType == ReplayType.IMAGE || replayType == ReplayType.TEXT)) ||
	                  declutteredFeatures.indexOf(feature) !== -1) {
	                result = callback(feature);
	              }
	              if (result) {
	                return result;
	              } else {
	                context.clearRect(0, 0, contextSize, contextSize);
	                return undefined;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    /** @type {Array<number>} */
	    var zs = Object.keys(this.replaysByZIndex_).map(Number);
	    zs.sort(numberSafeCompareFunction);
	
	    var i, j, replays, replay, result;
	    for (i = zs.length - 1; i >= 0; --i) {
	      var zIndexKey = zs[i].toString();
	      replays = this.replaysByZIndex_[zIndexKey];
	      for (j = ORDER.length - 1; j >= 0; --j) {
	        replayType = ORDER[j];
	        replay = replays[replayType];
	        if (replay !== undefined) {
	          if (declutterReplays &&
	              (replayType == ReplayType.IMAGE || replayType == ReplayType.TEXT)) {
	            var declutter = declutterReplays[zIndexKey];
	            if (!declutter) {
	              declutterReplays[zIndexKey] = [replay, transform.slice(0)];
	            } else {
	              declutter.push(replay, transform.slice(0));
	            }
	          } else {
	            result = replay.replayHitDetection(context, transform, rotation,
	              skippedFeaturesHash, featureCallback, hitExtent);
	            if (result) {
	              return result;
	            }
	          }
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @param {import("../../transform.js").Transform} transform Transform.
	   * @return {Array<number>} Clip coordinates.
	   */
	  CanvasReplayGroup.prototype.getClipCoords = function getClipCoords (transform) {
	    var maxExtent = this.maxExtent_;
	    var minX = maxExtent[0];
	    var minY = maxExtent[1];
	    var maxX = maxExtent[2];
	    var maxY = maxExtent[3];
	    var flatClipCoords = [minX, minY, minX, maxY, maxX, maxY, maxX, minY];
	    transform2D(
	      flatClipCoords, 0, 8, 2, transform, flatClipCoords);
	    return flatClipCoords;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasReplayGroup.prototype.getReplay = function getReplay (zIndex, replayType) {
	    var zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
	    var replays = this.replaysByZIndex_[zIndexKey];
	    if (replays === undefined) {
	      replays = {};
	      this.replaysByZIndex_[zIndexKey] = replays;
	    }
	    var replay = replays[replayType];
	    if (replay === undefined) {
	      var Constructor = BATCH_CONSTRUCTORS[replayType];
	      replay = new Constructor(this.tolerance_, this.maxExtent_,
	        this.resolution_, this.pixelRatio_, this.overlaps_, this.declutterTree_);
	      replays[replayType] = replay;
	    }
	    return replay;
	  };
	
	  /**
	   * @return {Object<string, Object<ReplayType, CanvasReplay>>} Replays.
	   */
	  CanvasReplayGroup.prototype.getReplays = function getReplays () {
	    return this.replaysByZIndex_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasReplayGroup.prototype.isEmpty = function isEmpty$1$$1 () {
	    return isEmpty(this.replaysByZIndex_);
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../transform.js").Transform} transform Transform.
	   * @param {number} viewRotation View rotation.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
	   * @param {Array<ReplayType>=} opt_replayTypes Ordered replay types to replay.
	   *     Default is {@link module:ol/render/replay~ORDER}
	   * @param {Object<string, import("../canvas.js").DeclutterGroup>=} opt_declutterReplays Declutter replays.
	   */
	  CanvasReplayGroup.prototype.replay = function replay (
	    context,
	    transform,
	    viewRotation,
	    skippedFeaturesHash,
	    snapToPixel,
	    opt_replayTypes,
	    opt_declutterReplays
	  ) {
	
	    /** @type {Array<number>} */
	    var zs = Object.keys(this.replaysByZIndex_).map(Number);
	    zs.sort(numberSafeCompareFunction);
	
	    // setup clipping so that the parts of over-simplified geometries are not
	    // visible outside the current extent when panning
	    context.save();
	    this.clip(context, transform);
	
	    var replayTypes = opt_replayTypes ? opt_replayTypes : ORDER;
	    var i, ii, j, jj, replays, replay;
	    for (i = 0, ii = zs.length; i < ii; ++i) {
	      var zIndexKey = zs[i].toString();
	      replays = this.replaysByZIndex_[zIndexKey];
	      for (j = 0, jj = replayTypes.length; j < jj; ++j) {
	        var replayType = replayTypes[j];
	        replay = replays[replayType];
	        if (replay !== undefined) {
	          if (opt_declutterReplays &&
	              (replayType == ReplayType.IMAGE || replayType == ReplayType.TEXT)) {
	            var declutter = opt_declutterReplays[zIndexKey];
	            if (!declutter) {
	              opt_declutterReplays[zIndexKey] = [replay, transform.slice(0)];
	            } else {
	              declutter.push(replay, transform.slice(0));
	            }
	          } else {
	            replay.replay(context, transform, viewRotation, skippedFeaturesHash, snapToPixel);
	          }
	        }
	      }
	    }
	
	    context.restore();
	  };
	
	  return CanvasReplayGroup;
	}(ReplayGroup));
	
	
	/**
	 * This cache is used for storing calculated pixel circles for increasing performance.
	 * It is a static property to allow each Replaygroup to access it.
	 * @type {Object<number, Array<Array<(boolean|undefined)>>>}
	 */
	var circleArrayCache = {
	  0: [[true]]
	};
	
	
	/**
	 * This method fills a row in the array from the given coordinate to the
	 * middle with `true`.
	 * @param {Array<Array<(boolean|undefined)>>} array The array that will be altered.
	 * @param {number} x X coordinate.
	 * @param {number} y Y coordinate.
	 */
	function fillCircleArrayRowToMiddle(array, x, y) {
	  var i;
	  var radius = Math.floor(array.length / 2);
	  if (x >= radius) {
	    for (i = radius; i < x; i++) {
	      array[i][y] = true;
	    }
	  } else if (x < radius) {
	    for (i = x + 1; i < radius; i++) {
	      array[i][y] = true;
	    }
	  }
	}
	
	
	/**
	 * This methods creates a circle inside a fitting array. Points inside the
	 * circle are marked by true, points on the outside are undefined.
	 * It uses the midpoint circle algorithm.
	 * A cache is used to increase performance.
	 * @param {number} radius Radius.
	 * @returns {Array<Array<(boolean|undefined)>>} An array with marked circle points.
	 * @api
	 */
	function getCircleArray(radius) {
	  if (circleArrayCache[radius] !== undefined) {
	    return circleArrayCache[radius];
	  }
	
	  var arraySize = radius * 2 + 1;
	  var arr = new Array(arraySize);
	  for (var i = 0; i < arraySize; i++) {
	    arr[i] = new Array(arraySize);
	  }
	
	  var x = radius;
	  var y = 0;
	  var error = 0;
	
	  while (x >= y) {
	    fillCircleArrayRowToMiddle(arr, radius + x, radius + y);
	    fillCircleArrayRowToMiddle(arr, radius + y, radius + x);
	    fillCircleArrayRowToMiddle(arr, radius - y, radius + x);
	    fillCircleArrayRowToMiddle(arr, radius - x, radius + y);
	    fillCircleArrayRowToMiddle(arr, radius - x, radius - y);
	    fillCircleArrayRowToMiddle(arr, radius - y, radius - x);
	    fillCircleArrayRowToMiddle(arr, radius + y, radius - x);
	    fillCircleArrayRowToMiddle(arr, radius + x, radius - y);
	
	    y++;
	    error += 1 + 2 * y;
	    if (2 * (error - x) + 1 > 0) {
	      x -= 1;
	      error += 1 - 2 * x;
	    }
	  }
	
	  circleArrayCache[radius] = arr;
	  return arr;
	}
	
	
	/**
	 * @param {!Object<string, Array<*>>} declutterReplays Declutter replays.
	 * @param {CanvasRenderingContext2D} context Context.
	 * @param {number} rotation Rotation.
	 * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
	 */
	function replayDeclutter(declutterReplays, context, rotation, snapToPixel) {
	  var zs = Object.keys(declutterReplays).map(Number).sort(numberSafeCompareFunction);
	  var skippedFeatureUids = {};
	  for (var z = 0, zz = zs.length; z < zz; ++z) {
	    var replayData = declutterReplays[zs[z].toString()];
	    for (var i = 0, ii = replayData.length; i < ii;) {
	      var replay = replayData[i++];
	      var transform = replayData[i++];
	      replay.replay(context, transform, rotation, skippedFeatureUids, snapToPixel);
	    }
	  }
	}
	
	/**
	 * @module ol/renderer/vector
	 */
	
	
	/**
	 * Tolerance for geometry simplification in device pixels.
	 * @type {number}
	 */
	var SIMPLIFY_TOLERANCE = 0.5;
	
	
	/**
	 * @const
	 * @type {Object<import("../geom/GeometryType.js").default,
	 *                function(import("../render/ReplayGroup.js").default, import("../geom/Geometry.js").default,
	 *                         import("../style/Style.js").default, Object)>}
	 */
	var GEOMETRY_RENDERERS = {
	  'Point': renderPointGeometry,
	  'LineString': renderLineStringGeometry,
	  'Polygon': renderPolygonGeometry,
	  'MultiPoint': renderMultiPointGeometry,
	  'MultiLineString': renderMultiLineStringGeometry,
	  'MultiPolygon': renderMultiPolygonGeometry,
	  'GeometryCollection': renderGeometryCollectionGeometry,
	  'Circle': renderCircleGeometry
	};
	
	
	/**
	 * @param {import("../Feature.js").FeatureLike} feature1 Feature 1.
	 * @param {import("../Feature.js").FeatureLike} feature2 Feature 2.
	 * @return {number} Order.
	 */
	function defaultOrder(feature1, feature2) {
	  return parseInt(getUid(feature1), 10) - parseInt(getUid(feature2), 10);
	}
	
	
	/**
	 * @param {number} resolution Resolution.
	 * @param {number} pixelRatio Pixel ratio.
	 * @return {number} Squared pixel tolerance.
	 */
	function getSquaredTolerance(resolution, pixelRatio) {
	  var tolerance = getTolerance(resolution, pixelRatio);
	  return tolerance * tolerance;
	}
	
	
	/**
	 * @param {number} resolution Resolution.
	 * @param {number} pixelRatio Pixel ratio.
	 * @return {number} Pixel tolerance.
	 */
	function getTolerance(resolution, pixelRatio) {
	  return SIMPLIFY_TOLERANCE * resolution / pixelRatio;
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/Circle.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").default} feature Feature.
	 */
	function renderCircleGeometry(replayGroup, geometry, style, feature) {
	  var fillStyle = style.getFill();
	  var strokeStyle = style.getStroke();
	  if (fillStyle || strokeStyle) {
	    var circleReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.CIRCLE);
	    circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
	    circleReplay.drawCircle(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {number} squaredTolerance Squared tolerance.
	 * @param {function(this: T, import("../events/Event.js").default)} listener Listener function.
	 * @param {T} thisArg Value to use as `this` when executing `listener`.
	 * @return {boolean} `true` if style is loading.
	 * @template T
	 */
	function renderFeature(replayGroup, feature, style, squaredTolerance, listener, thisArg) {
	  var loading = false;
	  var imageStyle = style.getImage();
	  if (imageStyle) {
	    var imageState = imageStyle.getImageState();
	    if (imageState == ImageState.LOADED || imageState == ImageState.ERROR) {
	      imageStyle.unlistenImageChange(listener, thisArg);
	    } else {
	      if (imageState == ImageState.IDLE) {
	        imageStyle.load();
	      }
	      imageState = imageStyle.getImageState();
	      imageStyle.listenImageChange(listener, thisArg);
	      loading = true;
	    }
	  }
	  renderFeatureInternal(replayGroup, feature, style, squaredTolerance);
	
	  return loading;
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {number} squaredTolerance Squared tolerance.
	 */
	function renderFeatureInternal(replayGroup, feature, style, squaredTolerance) {
	  var geometry = style.getGeometryFunction()(feature);
	  if (!geometry) {
	    return;
	  }
	  var simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
	  var renderer = style.getRenderer();
	  if (renderer) {
	    renderGeometry(replayGroup, simplifiedGeometry, style, feature);
	  } else {
	    var geometryRenderer = GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
	    geometryRenderer(replayGroup, simplifiedGeometry, style, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 */
	function renderGeometry(replayGroup, geometry, style, feature) {
	  if (geometry.getType() == GeometryType.GEOMETRY_COLLECTION) {
	    var geometries = /** @type {import("../geom/GeometryCollection.js").default} */ (geometry).getGeometries();
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      renderGeometry(replayGroup, geometries[i], style, feature);
	    }
	    return;
	  }
	  var replay = replayGroup.getReplay(style.getZIndex(), ReplayType.DEFAULT);
	  replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ (geometry), feature, style.getRenderer());
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").default} feature Feature.
	 */
	function renderGeometryCollectionGeometry(replayGroup, geometry, style, feature) {
	  var geometries = geometry.getGeometriesArray();
	  var i, ii;
	  for (i = 0, ii = geometries.length; i < ii; ++i) {
	    var geometryRenderer =
	        GEOMETRY_RENDERERS[geometries[i].getType()];
	    geometryRenderer(replayGroup, geometries[i], style, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 */
	function renderLineStringGeometry(replayGroup, geometry, style, feature) {
	  var strokeStyle = style.getStroke();
	  if (strokeStyle) {
	    var lineStringReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.LINE_STRING);
	    lineStringReplay.setFillStrokeStyle(null, strokeStyle);
	    lineStringReplay.drawLineString(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 */
	function renderMultiLineStringGeometry(replayGroup, geometry, style, feature) {
	  var strokeStyle = style.getStroke();
	  if (strokeStyle) {
	    var lineStringReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.LINE_STRING);
	    lineStringReplay.setFillStrokeStyle(null, strokeStyle);
	    lineStringReplay.drawMultiLineString(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").default} feature Feature.
	 */
	function renderMultiPolygonGeometry(replayGroup, geometry, style, feature) {
	  var fillStyle = style.getFill();
	  var strokeStyle = style.getStroke();
	  if (strokeStyle || fillStyle) {
	    var polygonReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.POLYGON);
	    polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
	    polygonReplay.drawMultiPolygon(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 */
	function renderPointGeometry(replayGroup, geometry, style, feature) {
	  var imageStyle = style.getImage();
	  if (imageStyle) {
	    if (imageStyle.getImageState() != ImageState.LOADED) {
	      return;
	    }
	    var imageReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.IMAGE);
	    imageReplay.setImageStyle(imageStyle, replayGroup.addDeclutter(false));
	    imageReplay.drawPoint(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(!!imageStyle));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 */
	function renderMultiPointGeometry(replayGroup, geometry, style, feature) {
	  var imageStyle = style.getImage();
	  if (imageStyle) {
	    if (imageStyle.getImageState() != ImageState.LOADED) {
	      return;
	    }
	    var imageReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.IMAGE);
	    imageReplay.setImageStyle(imageStyle, replayGroup.addDeclutter(false));
	    imageReplay.drawMultiPoint(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(!!imageStyle));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	
	/**
	 * @param {import("../render/ReplayGroup.js").default} replayGroup Replay group.
	 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
	 * @param {import("../style/Style.js").default} style Style.
	 * @param {import("../Feature.js").FeatureLike} feature Feature.
	 */
	function renderPolygonGeometry(replayGroup, geometry, style, feature) {
	  var fillStyle = style.getFill();
	  var strokeStyle = style.getStroke();
	  if (fillStyle || strokeStyle) {
	    var polygonReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.POLYGON);
	    polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
	    polygonReplay.drawPolygon(geometry, feature);
	  }
	  var textStyle = style.getText();
	  if (textStyle) {
	    var textReplay = replayGroup.getReplay(style.getZIndex(), ReplayType.TEXT);
	    textReplay.setTextStyle(textStyle, replayGroup.addDeclutter(false));
	    textReplay.drawText(geometry, feature);
	  }
	}
	
	/**
	 * @module ol/renderer/canvas/VectorLayer
	 */
	
	/**
	 * @classdesc
	 * Canvas renderer for vector layers.
	 * @api
	 */
	var CanvasVectorLayerRenderer = /*@__PURE__*/(function (CanvasLayerRenderer$$1) {
	  function CanvasVectorLayerRenderer(vectorLayer) {
	
	    CanvasLayerRenderer$$1.call(this, vectorLayer);
	
	    /**
	     * Declutter tree.
	     * @private
	     */
	    this.declutterTree_ = vectorLayer.getDeclutter() ? rbush_1(9, undefined) : null;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.dirty_ = false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedRevision_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedResolution_ = NaN;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.renderedExtent_ = createEmpty();
	
	    /**
	     * @private
	     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
	     */
	    this.renderedRenderOrder_ = null;
	
	    /**
	     * @private
	     * @type {import("../../render/canvas/ReplayGroup.js").default}
	     */
	    this.replayGroup_ = null;
	
	    /**
	     * A new replay group had to be created by `prepareFrame()`
	     * @type {boolean}
	     */
	    this.replayGroupChanged = true;
	
	    /**
	     * @type {CanvasRenderingContext2D}
	     */
	    this.context = createCanvasContext2D();
	
	    listen(labelCache, EventType.CLEAR, this.handleFontsChanged_, this);
	
	  }
	
	  if ( CanvasLayerRenderer$$1 ) { CanvasVectorLayerRenderer.__proto__ = CanvasLayerRenderer$$1; }
	  CanvasVectorLayerRenderer.prototype = Object.create( CanvasLayerRenderer$$1 && CanvasLayerRenderer$$1.prototype );
	  CanvasVectorLayerRenderer.prototype.constructor = CanvasVectorLayerRenderer;
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorLayerRenderer.prototype.disposeInternal = function disposeInternal () {
	    unlisten(labelCache, EventType.CLEAR, this.handleFontsChanged_, this);
	    CanvasLayerRenderer$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @param {CanvasRenderingContext2D} context Context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   */
	  CanvasVectorLayerRenderer.prototype.compose = function compose (context, frameState, layerState) {
	    var extent = frameState.extent;
	    var pixelRatio = frameState.pixelRatio;
	    var skippedFeatureUids = layerState.managed ?
	      frameState.skippedFeatureUids : {};
	    var viewState = frameState.viewState;
	    var projection = viewState.projection;
	    var rotation = viewState.rotation;
	    var projectionExtent = projection.getExtent();
	    var vectorSource = /** @type {import("../../source/Vector.js").default} */ (this.getLayer().getSource());
	
	    var transform = this.getTransform(frameState, 0);
	
	    // clipped rendering if layer extent is set
	    var clipExtent = layerState.extent;
	    var clipped = clipExtent !== undefined;
	    if (clipped) {
	      this.clip(context, frameState, /** @type {import("../../extent.js").Extent} */ (clipExtent));
	    }
	    var replayGroup = this.replayGroup_;
	    if (replayGroup && !replayGroup.isEmpty()) {
	      if (this.declutterTree_) {
	        this.declutterTree_.clear();
	      }
	      var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	      var drawOffsetX = 0;
	      var drawOffsetY = 0;
	      var replayContext;
	      var transparentLayer = layerState.opacity !== 1;
	      var hasRenderListeners = layer.hasListener(RenderEventType.RENDER);
	      if (transparentLayer || hasRenderListeners) {
	        var drawWidth = context.canvas.width;
	        var drawHeight = context.canvas.height;
	        if (rotation) {
	          var drawSize = Math.round(Math.sqrt(drawWidth * drawWidth + drawHeight * drawHeight));
	          drawOffsetX = (drawSize - drawWidth) / 2;
	          drawOffsetY = (drawSize - drawHeight) / 2;
	          drawWidth = drawHeight = drawSize;
	        }
	        // resize and clear
	        this.context.canvas.width = drawWidth;
	        this.context.canvas.height = drawHeight;
	        replayContext = this.context;
	      } else {
	        replayContext = context;
	      }
	
	      var alpha = replayContext.globalAlpha;
	      if (!transparentLayer) {
	        // for performance reasons, context.save / context.restore is not used
	        // to save and restore the transformation matrix and the opacity.
	        // see http://jsperf.com/context-save-restore-versus-variable
	        replayContext.globalAlpha = layerState.opacity;
	      }
	
	      if (replayContext != context) {
	        replayContext.translate(drawOffsetX, drawOffsetY);
	      }
	
	      var viewHints = frameState.viewHints;
	      var snapToPixel = !(viewHints[ViewHint.ANIMATING] || viewHints[ViewHint.INTERACTING]);
	      var width = frameState.size[0] * pixelRatio;
	      var height = frameState.size[1] * pixelRatio;
	      rotateAtOffset(replayContext, -rotation,
	        width / 2, height / 2);
	      replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel);
	      if (vectorSource.getWrapX() && projection.canWrapX() &&
	          !containsExtent(projectionExtent, extent)) {
	        var startX = extent[0];
	        var worldWidth = getWidth(projectionExtent);
	        var world = 0;
	        var offsetX;
	        while (startX < projectionExtent[0]) {
	          --world;
	          offsetX = worldWidth * world;
	          transform = this.getTransform(frameState, offsetX);
	          replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel);
	          startX += worldWidth;
	        }
	        world = 0;
	        startX = extent[2];
	        while (startX > projectionExtent[2]) {
	          ++world;
	          offsetX = worldWidth * world;
	          transform = this.getTransform(frameState, offsetX);
	          replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel);
	          startX -= worldWidth;
	        }
	      }
	      rotateAtOffset(replayContext, rotation,
	        width / 2, height / 2);
	
	      if (hasRenderListeners) {
	        this.dispatchRenderEvent(replayContext, frameState, transform);
	      }
	      if (replayContext != context) {
	        if (transparentLayer) {
	          var mainContextAlpha = context.globalAlpha;
	          context.globalAlpha = layerState.opacity;
	          context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
	          context.globalAlpha = mainContextAlpha;
	        } else {
	          context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
	        }
	        replayContext.translate(-drawOffsetX, -drawOffsetY);
	      }
	
	      if (!transparentLayer) {
	        replayContext.globalAlpha = alpha;
	      }
	    }
	
	    if (clipped) {
	      context.restore();
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorLayerRenderer.prototype.composeFrame = function composeFrame (frameState, layerState, context) {
	    var transform = this.getTransform(frameState, 0);
	    this.preCompose(context, frameState, transform);
	    this.compose(context, frameState, layerState);
	    this.postCompose(context, frameState, layerState, transform);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
	    if (!this.replayGroup_) {
	      return undefined;
	    } else {
	      var resolution = frameState.viewState.resolution;
	      var rotation = frameState.viewState.rotation;
	      var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	      /** @type {!Object<string, boolean>} */
	      var features = {};
	      var result = this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, {},
	        /**
	         * @param {import("../../Feature.js").FeatureLike} feature Feature.
	         * @return {?} Callback result.
	         */
	        function(feature) {
	          var key = getUid(feature);
	          if (!(key in features)) {
	            features[key] = true;
	            return callback.call(thisArg, feature, layer);
	          }
	        }, null);
	      return result;
	    }
	  };
	
	  /**
	   * @param {import("../../events/Event.js").default} event Event.
	   */
	  CanvasVectorLayerRenderer.prototype.handleFontsChanged_ = function handleFontsChanged_ (event) {
	    var layer = this.getLayer();
	    if (layer.getVisible() && this.replayGroup_) {
	      layer.changed();
	    }
	  };
	
	  /**
	   * Handle changes in image style state.
	   * @param {import("../../events/Event.js").default} event Image style change event.
	   * @private
	   */
	  CanvasVectorLayerRenderer.prototype.handleStyleImageChange_ = function handleStyleImageChange_ (event) {
	    this.renderIfReadyAndVisible();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState) {
	    var vectorLayer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	    var vectorSource = /** @type {import("../../source/Vector.js").default} */ (vectorLayer.getSource());
	
	    var animating = frameState.viewHints[ViewHint.ANIMATING];
	    var interacting = frameState.viewHints[ViewHint.INTERACTING];
	    var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
	    var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
	
	    if (!this.dirty_ && (!updateWhileAnimating && animating) ||
	        (!updateWhileInteracting && interacting)) {
	      return true;
	    }
	
	    var frameStateExtent = frameState.extent;
	    var viewState = frameState.viewState;
	    var projection = viewState.projection;
	    var resolution = viewState.resolution;
	    var pixelRatio = frameState.pixelRatio;
	    var vectorLayerRevision = vectorLayer.getRevision();
	    var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
	    var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
	
	    if (vectorLayerRenderOrder === undefined) {
	      vectorLayerRenderOrder = defaultOrder;
	    }
	
	    var extent = buffer(frameStateExtent,
	      vectorLayerRenderBuffer * resolution);
	    var projectionExtent = viewState.projection.getExtent();
	
	    if (vectorSource.getWrapX() && viewState.projection.canWrapX() &&
	        !containsExtent(projectionExtent, frameState.extent)) {
	      // For the replay group, we need an extent that intersects the real world
	      // (-180° to +180°). To support geometries in a coordinate range from -540°
	      // to +540°, we add at least 1 world width on each side of the projection
	      // extent. If the viewport is wider than the world, we need to add half of
	      // the viewport width to make sure we cover the whole viewport.
	      var worldWidth = getWidth(projectionExtent);
	      var gutter = Math.max(getWidth(extent) / 2, worldWidth);
	      extent[0] = projectionExtent[0] - gutter;
	      extent[2] = projectionExtent[2] + gutter;
	    }
	
	    if (!this.dirty_ &&
	        this.renderedResolution_ == resolution &&
	        this.renderedRevision_ == vectorLayerRevision &&
	        this.renderedRenderOrder_ == vectorLayerRenderOrder &&
	        containsExtent(this.renderedExtent_, extent)) {
	      this.replayGroupChanged = false;
	      return true;
	    }
	
	    this.replayGroup_ = null;
	
	    this.dirty_ = false;
	
	    var replayGroup = new CanvasReplayGroup(
	      getTolerance(resolution, pixelRatio), extent, resolution,
	      pixelRatio, vectorSource.getOverlaps(), this.declutterTree_, vectorLayer.getRenderBuffer());
	    vectorSource.loadFeatures(extent, resolution, projection);
	    /**
	     * @param {import("../../Feature.js").default} feature Feature.
	     * @this {CanvasVectorLayerRenderer}
	     */
	    var render = function(feature) {
	      var styles;
	      var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
	      if (styleFunction) {
	        styles = styleFunction(feature, resolution);
	      }
	      if (styles) {
	        var dirty = this.renderFeature(
	          feature, resolution, pixelRatio, styles, replayGroup);
	        this.dirty_ = this.dirty_ || dirty;
	      }
	    }.bind(this);
	    if (vectorLayerRenderOrder) {
	      /** @type {Array<import("../../Feature.js").default>} */
	      var features = [];
	      vectorSource.forEachFeatureInExtent(extent,
	        /**
	         * @param {import("../../Feature.js").default} feature Feature.
	         */
	        function(feature) {
	          features.push(feature);
	        });
	      features.sort(vectorLayerRenderOrder);
	      for (var i = 0, ii = features.length; i < ii; ++i) {
	        render(features[i]);
	      }
	    } else {
	      vectorSource.forEachFeatureInExtent(extent, render);
	    }
	    replayGroup.finish();
	
	    this.renderedResolution_ = resolution;
	    this.renderedRevision_ = vectorLayerRevision;
	    this.renderedRenderOrder_ = vectorLayerRenderOrder;
	    this.renderedExtent_ = extent;
	    this.replayGroup_ = replayGroup;
	
	    this.replayGroupChanged = true;
	    return true;
	  };
	
	  /**
	   * @param {import("../../Feature.js").default} feature Feature.
	   * @param {number} resolution Resolution.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
	   * @param {import("../../render/canvas/ReplayGroup.js").default} replayGroup Replay group.
	   * @return {boolean} `true` if an image is loading.
	   */
	  CanvasVectorLayerRenderer.prototype.renderFeature = function renderFeature$1 (feature, resolution, pixelRatio, styles, replayGroup) {
	    if (!styles) {
	      return false;
	    }
	    var loading = false;
	    if (Array.isArray(styles)) {
	      for (var i = 0, ii = styles.length; i < ii; ++i) {
	        loading = renderFeature(
	          replayGroup, feature, styles[i],
	          getSquaredTolerance(resolution, pixelRatio),
	          this.handleStyleImageChange_, this) || loading;
	      }
	    } else {
	      loading = renderFeature(
	        replayGroup, feature, styles,
	        getSquaredTolerance(resolution, pixelRatio),
	        this.handleStyleImageChange_, this);
	    }
	    return loading;
	  };
	
	  return CanvasVectorLayerRenderer;
	}(CanvasLayerRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	CanvasVectorLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.VECTOR;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {CanvasVectorLayerRenderer} The layer renderer.
	 */
	CanvasVectorLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new CanvasVectorLayerRenderer(/** @type {import("../../layer/Vector.js").default} */ (layer));
	};
	
	/**
	 * @module ol/layer/VectorTileRenderType
	 */
	
	/**
	 * @enum {string}
	 * Render mode for vector tiles:
	 *  * `'image'`: Vector tiles are rendered as images. Great performance, but
	 *    point symbols and texts are always rotated with the view and pixels are
	 *    scaled during zoom animations.
	 *  * `'hybrid'`: Polygon and line elements are rendered as images, so pixels
	 *    are scaled during zoom animations. Point symbols and texts are accurately
	 *    rendered as vectors and can stay upright on rotated views.
	 *  * `'vector'`: Vector tiles are rendered as vectors. Most accurate rendering
	 *    even during animations, but slower performance than the other options.
	 * @api
	 */
	var VectorTileRenderType = {
	  IMAGE: 'image',
	  HYBRID: 'hybrid',
	  VECTOR: 'vector'
	};
	
	/**
	 * @module ol/renderer/canvas/VectorTileLayer
	 */
	
	
	/**
	 * @type {!Object<string, Array<import("../../render/ReplayType.js").default>>}
	 */
	var IMAGE_REPLAYS = {
	  'image': [ReplayType.POLYGON, ReplayType.CIRCLE,
	    ReplayType.LINE_STRING, ReplayType.IMAGE, ReplayType.TEXT],
	  'hybrid': [ReplayType.POLYGON, ReplayType.LINE_STRING]
	};
	
	
	/**
	 * @type {!Object<string, Array<import("../../render/ReplayType.js").default>>}
	 */
	var VECTOR_REPLAYS = {
	  'image': [ReplayType.DEFAULT],
	  'hybrid': [ReplayType.IMAGE, ReplayType.TEXT, ReplayType.DEFAULT],
	  'vector': ORDER
	};
	
	
	/**
	 * @classdesc
	 * Canvas renderer for vector tile layers.
	 * @api
	 */
	var CanvasVectorTileLayerRenderer = /*@__PURE__*/(function (CanvasTileLayerRenderer$$1) {
	  function CanvasVectorTileLayerRenderer(layer) {
	
	    CanvasTileLayerRenderer$$1.call(this, layer, true);
	
	    /**
	     * Declutter tree.
	     * @private
	     */
	    this.declutterTree_ = layer.getDeclutter() ? rbush_1(9, undefined) : null;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.dirty_ = false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedLayerRevision_;
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.tmpTransform_ = create();
	
	    var renderMode = layer.getRenderMode();
	
	    // Use lower resolution for pure vector rendering. Closest resolution otherwise.
	    this.zDirection = renderMode === VectorTileRenderType.VECTOR ? 1 : 0;
	
	    if (renderMode !== VectorTileRenderType.VECTOR) {
	      this.context = createCanvasContext2D();
	    }
	
	
	    listen(labelCache, EventType.CLEAR, this.handleFontsChanged_, this);
	
	  }
	
	  if ( CanvasTileLayerRenderer$$1 ) { CanvasVectorTileLayerRenderer.__proto__ = CanvasTileLayerRenderer$$1; }
	  CanvasVectorTileLayerRenderer.prototype = Object.create( CanvasTileLayerRenderer$$1 && CanvasTileLayerRenderer$$1.prototype );
	  CanvasVectorTileLayerRenderer.prototype.constructor = CanvasVectorTileLayerRenderer;
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorTileLayerRenderer.prototype.disposeInternal = function disposeInternal () {
	    unlisten(labelCache, EventType.CLEAR, this.handleFontsChanged_, this);
	    CanvasTileLayerRenderer$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorTileLayerRenderer.prototype.getTile = function getTile (z, x, y, pixelRatio, projection) {
	    var tile = CanvasTileLayerRenderer$$1.prototype.getTile.call(this, z, x, y, pixelRatio, projection);
	    if (tile.getState() === TileState.LOADED) {
	      this.createReplayGroup_(/** @type {import("../../VectorImageTile.js").default} */ (tile), pixelRatio, projection);
	      if (this.context) {
	        this.renderTileImage_(/** @type {import("../../VectorImageTile.js").default} */ (tile), pixelRatio, projection);
	      }
	    }
	    return tile;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorTileLayerRenderer.prototype.getTileImage = function getTileImage (tile) {
	    var tileLayer = /** @type {import("../../layer/Tile.js").default} */ (this.getLayer());
	    return /** @type {import("../../VectorImageTile.js").default} */ (tile).getImage(tileLayer);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorTileLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState) {
	    var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	    var layerRevision = layer.getRevision();
	    if (this.renderedLayerRevision_ != layerRevision) {
	      this.renderedTiles.length = 0;
	    }
	    this.renderedLayerRevision_ = layerRevision;
	    return CanvasTileLayerRenderer$$1.prototype.prepareFrame.call(this, frameState, layerState);
	  };
	
	  /**
	   * @param {import("../../VectorImageTile.js").default} tile Tile.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../../proj/Projection.js").default} projection Projection.
	   * @private
	   */
	  CanvasVectorTileLayerRenderer.prototype.createReplayGroup_ = function createReplayGroup_ (tile, pixelRatio, projection) {
	    var this$1 = this;
	
	    var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	    var revision = layer.getRevision();
	    var renderOrder = /** @type {import("../../render.js").OrderFunction} */ (layer.getRenderOrder()) || null;
	
	    var replayState = tile.getReplayState(layer);
	    if (!replayState.dirty && replayState.renderedRevision == revision &&
	        replayState.renderedRenderOrder == renderOrder) {
	      return;
	    }
	
	    var source = /** @type {import("../../source/VectorTile.js").default} */ (layer.getSource());
	    var sourceTileGrid = source.getTileGrid();
	    var tileGrid = source.getTileGridForProjection(projection);
	    var resolution = tileGrid.getResolution(tile.tileCoord[0]);
	    var tileExtent = tile.extent;
	
	    var loop = function ( t, tt ) {
	      var sourceTile = tile.getTile(tile.tileKeys[t]);
	      if (sourceTile.getState() != TileState.LOADED) {
	        return;
	      }
	
	      var sourceTileCoord = sourceTile.tileCoord;
	      var sourceTileExtent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
	      var sharedExtent = getIntersection(tileExtent, sourceTileExtent);
	      var bufferedExtent = equals$1(sourceTileExtent, sharedExtent) ? null :
	        buffer(sharedExtent, layer.getRenderBuffer() * resolution, this$1.tmpExtent);
	      var tileProjection = sourceTile.getProjection();
	      var reproject = false;
	      if (!equivalent(projection, tileProjection)) {
	        reproject = true;
	        sourceTile.setProjection(projection);
	      }
	      replayState.dirty = false;
	      var replayGroup = new CanvasReplayGroup(0, sharedExtent, resolution,
	        pixelRatio, source.getOverlaps(), this$1.declutterTree_, layer.getRenderBuffer());
	      var squaredTolerance = getSquaredTolerance(resolution, pixelRatio);
	
	      /**
	       * @param {import("../../Feature.js").FeatureLike} feature Feature.
	       * @this {CanvasVectorTileLayerRenderer}
	       */
	      var render = function(feature) {
	        var styles;
	        var styleFunction = feature.getStyleFunction() || layer.getStyleFunction();
	        if (styleFunction) {
	          styles = styleFunction(feature, resolution);
	        }
	        if (styles) {
	          var dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup);
	          this.dirty_ = this.dirty_ || dirty;
	          replayState.dirty = replayState.dirty || dirty;
	        }
	      };
	
	      var features = sourceTile.getFeatures();
	      if (renderOrder && renderOrder !== replayState.renderedRenderOrder) {
	        features.sort(renderOrder);
	      }
	      for (var i = 0, ii = features.length; i < ii; ++i) {
	        var feature = features[i];
	        if (reproject) {
	          if (tileProjection.getUnits() == Units.TILE_PIXELS) {
	            // projected tile extent
	            tileProjection.setWorldExtent(sourceTileExtent);
	            // tile extent in tile pixel space
	            tileProjection.setExtent(sourceTile.getExtent());
	          }
	          feature.getGeometry().transform(tileProjection, projection);
	        }
	        if (!bufferedExtent || intersects(bufferedExtent, feature.getGeometry().getExtent())) {
	          render.call(this$1, feature);
	        }
	      }
	      replayGroup.finish();
	      sourceTile.setReplayGroup(layer, tile.tileCoord.toString(), replayGroup);
	    };
	
	    for (var t = 0, tt = tile.tileKeys.length; t < tt; ++t) { loop( t, tt ); }
	    replayState.renderedRevision = revision;
	    replayState.renderedRenderOrder = renderOrder;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorTileLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
	    var resolution = frameState.viewState.resolution;
	    var rotation = frameState.viewState.rotation;
	    hitTolerance = hitTolerance == undefined ? 0 : hitTolerance;
	    var layer = this.getLayer();
	    /** @type {!Object<string, boolean>} */
	    var features = {};
	
	    var renderedTiles = /** @type {Array<import("../../VectorImageTile.js").default>} */ (this.renderedTiles);
	
	    var bufferedExtent, found;
	    var i, ii;
	    for (i = 0, ii = renderedTiles.length; i < ii; ++i) {
	      var tile = renderedTiles[i];
	      bufferedExtent = buffer(tile.extent, hitTolerance * resolution, bufferedExtent);
	      if (!containsCoordinate(bufferedExtent, coordinate)) {
	        continue;
	      }
	      for (var t = 0, tt = tile.tileKeys.length; t < tt; ++t) {
	        var sourceTile = tile.getTile(tile.tileKeys[t]);
	        if (sourceTile.getState() != TileState.LOADED) {
	          continue;
	        }
	        var replayGroup = /** @type {CanvasReplayGroup} */ (sourceTile.getReplayGroup(layer,
	          tile.tileCoord.toString()));
	        found = found || replayGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, {},
	          /**
	           * @param {import("../../Feature.js").FeatureLike} feature Feature.
	           * @return {?} Callback result.
	           */
	          function(feature) {
	            var key = getUid(feature);
	            if (!(key in features)) {
	              features[key] = true;
	              return callback.call(thisArg, feature, layer);
	            }
	          }, null);
	      }
	    }
	    return found;
	  };
	
	  /**
	   * @param {import("../../VectorTile.js").default} tile Tile.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @return {import("../../transform.js").Transform} transform Transform.
	   * @private
	   */
	  CanvasVectorTileLayerRenderer.prototype.getReplayTransform_ = function getReplayTransform_ (tile, frameState) {
	    var layer = this.getLayer();
	    var source = /** @type {import("../../source/VectorTile.js").default} */ (layer.getSource());
	    var tileGrid = source.getTileGrid();
	    var tileCoord = tile.tileCoord;
	    var tileResolution = tileGrid.getResolution(tileCoord[0]);
	    var viewState = frameState.viewState;
	    var pixelRatio = frameState.pixelRatio;
	    var renderResolution = viewState.resolution / pixelRatio;
	    var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent);
	    var center = viewState.center;
	    var origin = getTopLeft(tileExtent);
	    var size = frameState.size;
	    var offsetX = Math.round(pixelRatio * size[0] / 2);
	    var offsetY = Math.round(pixelRatio * size[1] / 2);
	    return compose(this.tmpTransform_,
	      offsetX, offsetY,
	      tileResolution / renderResolution, tileResolution / renderResolution,
	      viewState.rotation,
	      (origin[0] - center[0]) / tileResolution,
	      (center[1] - origin[1]) / tileResolution);
	  };
	
	  /**
	   * @param {import("../../events/Event.js").default} event Event.
	   */
	  CanvasVectorTileLayerRenderer.prototype.handleFontsChanged_ = function handleFontsChanged_ (event) {
	    var layer = this.getLayer();
	    if (layer.getVisible() && this.renderedLayerRevision_ !== undefined) {
	      layer.changed();
	    }
	  };
	
	  /**
	   * Handle changes in image style state.
	   * @param {import("../../events/Event.js").default} event Image style change event.
	   * @private
	   */
	  CanvasVectorTileLayerRenderer.prototype.handleStyleImageChange_ = function handleStyleImageChange_ (event) {
	    this.renderIfReadyAndVisible();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  CanvasVectorTileLayerRenderer.prototype.postCompose = function postCompose (context, frameState, layerState) {
	    var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	    var renderMode = layer.getRenderMode();
	    if (renderMode != VectorTileRenderType.IMAGE) {
	      var declutterReplays = layer.getDeclutter() ? {} : null;
	      var source = /** @type {import("../../source/VectorTile.js").default} */ (layer.getSource());
	      var replayTypes = VECTOR_REPLAYS[renderMode];
	      var pixelRatio = frameState.pixelRatio;
	      var rotation = frameState.viewState.rotation;
	      var size = frameState.size;
	      var offsetX, offsetY;
	      if (rotation) {
	        offsetX = Math.round(pixelRatio * size[0] / 2);
	        offsetY = Math.round(pixelRatio * size[1] / 2);
	        rotateAtOffset(context, -rotation, offsetX, offsetY);
	      }
	      if (declutterReplays) {
	        this.declutterTree_.clear();
	      }
	      var viewHints = frameState.viewHints;
	      var snapToPixel = !(viewHints[ViewHint.ANIMATING] || viewHints[ViewHint.INTERACTING]);
	      var tiles = this.renderedTiles;
	      var tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
	      var clips = [];
	      var zs = [];
	      for (var i = tiles.length - 1; i >= 0; --i) {
	        var tile = /** @type {import("../../VectorImageTile.js").default} */ (tiles[i]);
	        if (tile.getState() == TileState.ABORT) {
	          continue;
	        }
	        var tileCoord = tile.tileCoord;
	        var worldOffset = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent)[0] - tile.extent[0];
	        var transform$$1 = undefined;
	        for (var t = 0, tt = tile.tileKeys.length; t < tt; ++t) {
	          var sourceTile = tile.getTile(tile.tileKeys[t]);
	          if (sourceTile.getState() != TileState.LOADED) {
	            continue;
	          }
	          var replayGroup = /** @type {CanvasReplayGroup} */ (sourceTile.getReplayGroup(layer, tileCoord.toString()));
	          if (!replayGroup || !replayGroup.hasReplays(replayTypes)) {
	            // sourceTile was not yet loaded when this.createReplayGroup_() was
	            // called, or it has no replays of the types we want to render
	            continue;
	          }
	          if (!transform$$1) {
	            transform$$1 = this.getTransform(frameState, worldOffset);
	          }
	          var currentZ = sourceTile.tileCoord[0];
	          var currentClip = replayGroup.getClipCoords(transform$$1);
	          context.save();
	          context.globalAlpha = layerState.opacity;
	          // Create a clip mask for regions in this low resolution tile that are
	          // already filled by a higher resolution tile
	          for (var j = 0, jj = clips.length; j < jj; ++j) {
	            var clip = clips[j];
	            if (currentZ < zs[j]) {
	              context.beginPath();
	              // counter-clockwise (outer ring) for current tile
	              context.moveTo(currentClip[0], currentClip[1]);
	              context.lineTo(currentClip[2], currentClip[3]);
	              context.lineTo(currentClip[4], currentClip[5]);
	              context.lineTo(currentClip[6], currentClip[7]);
	              // clockwise (inner ring) for higher resolution tile
	              context.moveTo(clip[6], clip[7]);
	              context.lineTo(clip[4], clip[5]);
	              context.lineTo(clip[2], clip[3]);
	              context.lineTo(clip[0], clip[1]);
	              context.clip();
	            }
	          }
	          replayGroup.replay(context, transform$$1, rotation, {}, snapToPixel, replayTypes, declutterReplays);
	          context.restore();
	          clips.push(currentClip);
	          zs.push(currentZ);
	        }
	      }
	      if (declutterReplays) {
	        replayDeclutter(declutterReplays, context, rotation, snapToPixel);
	      }
	      if (rotation) {
	        rotateAtOffset(context, rotation,
	          /** @type {number} */ (offsetX), /** @type {number} */ (offsetY));
	      }
	    }
	    CanvasTileLayerRenderer$$1.prototype.postCompose.call(this, context, frameState, layerState);
	  };
	
	  /**
	   * @param {import("../../Feature.js").FeatureLike} feature Feature.
	   * @param {number} squaredTolerance Squared tolerance.
	   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
	   * @param {import("../../render/canvas/ReplayGroup.js").default} replayGroup Replay group.
	   * @return {boolean} `true` if an image is loading.
	   */
	  CanvasVectorTileLayerRenderer.prototype.renderFeature = function renderFeature$1 (feature, squaredTolerance, styles, replayGroup) {
	    if (!styles) {
	      return false;
	    }
	    var loading = false;
	    if (Array.isArray(styles)) {
	      for (var i = 0, ii = styles.length; i < ii; ++i) {
	        loading = renderFeature(
	          replayGroup, feature, styles[i], squaredTolerance,
	          this.handleStyleImageChange_, this) || loading;
	      }
	    } else {
	      loading = renderFeature(
	        replayGroup, feature, styles, squaredTolerance,
	        this.handleStyleImageChange_, this);
	    }
	    return loading;
	  };
	
	  /**
	   * @param {import("../../VectorImageTile.js").default} tile Tile.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../../proj/Projection.js").default} projection Projection.
	   * @private
	   */
	  CanvasVectorTileLayerRenderer.prototype.renderTileImage_ = function renderTileImage_ (tile, pixelRatio, projection) {
	    var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	    var replayState = tile.getReplayState(layer);
	    var revision = layer.getRevision();
	    var replays = IMAGE_REPLAYS[layer.getRenderMode()];
	    if (replays && replayState.renderedTileRevision !== revision) {
	      replayState.renderedTileRevision = revision;
	      var tileCoord = tile.wrappedTileCoord;
	      var z = tileCoord[0];
	      var source = /** @type {import("../../source/VectorTile.js").default} */ (layer.getSource());
	      var tileGrid = source.getTileGridForProjection(projection);
	      var resolution = tileGrid.getResolution(z);
	      var context = tile.getContext(layer);
	      var size = source.getTilePixelSize(z, pixelRatio, projection);
	      context.canvas.width = size[0];
	      context.canvas.height = size[1];
	      var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent);
	      for (var i = 0, ii = tile.tileKeys.length; i < ii; ++i) {
	        var sourceTile = tile.getTile(tile.tileKeys[i]);
	        if (sourceTile.getState() != TileState.LOADED) {
	          continue;
	        }
	        var pixelScale = pixelRatio / resolution;
	        var transform$$1 = reset(this.tmpTransform_);
	        scale$1(transform$$1, pixelScale, -pixelScale);
	        translate$1(transform$$1, -tileExtent[0], -tileExtent[3]);
	        var replayGroup = /** @type {CanvasReplayGroup} */ (sourceTile.getReplayGroup(layer,
	          tile.tileCoord.toString()));
	        replayGroup.replay(context, transform$$1, 0, {}, true, replays);
	      }
	    }
	  };
	
	  return CanvasVectorTileLayerRenderer;
	}(CanvasTileLayerRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	CanvasVectorTileLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.VECTOR_TILE;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {CanvasVectorTileLayerRenderer} The layer renderer.
	 */
	CanvasVectorTileLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new CanvasVectorTileLayerRenderer(/** @type {import("../../layer/VectorTile.js").default} */ (layer));
	};
	
	/**
	 * @module ol/Map
	 */
	
	/**
	 * @classdesc
	 * The map is the core component of OpenLayers. For a map to render, a view,
	 * one or more layers, and a target container are needed:
	 *
	 *     import Map from 'ol/Map';
	 *     import View from 'ol/View';
	 *     import TileLayer from 'ol/layer/Tile';
	 *     import OSM from 'ol/source/OSM';
	 *
	 *     var map = new Map({
	 *       view: new View({
	 *         center: [0, 0],
	 *         zoom: 1
	 *       }),
	 *       layers: [
	 *         new TileLayer({
	 *           source: new OSM()
	 *         })
	 *       ],
	 *       target: 'map'
	 *     });
	 *
	 * The above snippet creates a map using a {@link module:ol/layer/Tile} to
	 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
	 * element with the id `map`.
	 *
	 * The constructor places a viewport container (with CSS class name
	 * `ol-viewport`) in the target element (see `getViewport()`), and then two
	 * further elements within the viewport: one with CSS class name
	 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
	 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
	 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
	 * itself is placed in a further element within the viewport.
	 *
	 * Layers are stored as a {@link module:ol/Collection~Collection} in
	 * layerGroups. A top-level group is provided by the library. This is what is
	 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
	 * options are added to this group, and `addLayer` and `removeLayer` change the
	 * layer collection in the group. `getLayers` is a convenience function for
	 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~Group}
	 * is a subclass of {@link module:ol/layer/Base}, so layers entered in the
	 * options or added with `addLayer` can be groups, which can contain further
	 * groups, and so on.
	 *
	 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
	 * @fires import("./MapEvent.js").MapEvent
	 * @fires module:ol/render/Event~RenderEvent#postcompose
	 * @fires module:ol/render/Event~RenderEvent#precompose
	 * @api
	 */
	var Map = /*@__PURE__*/(function (PluggableMap$$1) {
	  function Map(options) {
	    options = assign({}, options);
	    if (!options.controls) {
	      options.controls = defaults();
	    }
	    if (!options.interactions) {
	      options.interactions = defaults$1();
	    }
	
	    PluggableMap$$1.call(this, options);
	  }
	
	  if ( PluggableMap$$1 ) { Map.__proto__ = PluggableMap$$1; }
	  Map.prototype = Object.create( PluggableMap$$1 && PluggableMap$$1.prototype );
	  Map.prototype.constructor = Map;
	
	  Map.prototype.createRenderer = function createRenderer () {
	    var renderer = new CanvasMapRenderer(this);
	    renderer.registerLayerRenderers([
	      CanvasImageLayerRenderer,
	      CanvasTileLayerRenderer,
	      CanvasVectorLayerRenderer,
	      CanvasVectorTileLayerRenderer
	    ]);
	    return renderer;
	  };
	
	  return Map;
	}(PluggableMap));
	
	/**
	 * @module ol/OverlayPositioning
	 */
	
	/**
	 * Overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
	 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
	 * `'top-center'`, `'top-right'`
	 * @enum {string}
	 */
	var OverlayPositioning = {
	  BOTTOM_LEFT: 'bottom-left',
	  BOTTOM_CENTER: 'bottom-center',
	  BOTTOM_RIGHT: 'bottom-right',
	  CENTER_LEFT: 'center-left',
	  CENTER_CENTER: 'center-center',
	  CENTER_RIGHT: 'center-right',
	  TOP_LEFT: 'top-left',
	  TOP_CENTER: 'top-center',
	  TOP_RIGHT: 'top-right'
	};
	
	/**
	 * @module ol/Overlay
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number|string} [id] Set the overlay id. The overlay id can be used
	 * with the {@link module:ol/Map~Map#getOverlayById} method.
	 * @property {HTMLElement} [element] The overlay element.
	 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
	 * the overlay. The first element in the
	 * array is the horizontal offset. A positive value shifts the overlay right.
	 * The second element in the array is the vertical offset. A positive value
	 * shifts the overlay down.
	 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
	 * in map projection.
	 * @property {OverlayPositioning} [positioning='top-left'] Defines how
	 * the overlay is actually positioned with respect to its `position` property.
	 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
	 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
	 * `'top-center'`, and `'top-right'`.
	 * @property {boolean} [stopEvent=true] Whether event propagation to the map
	 * viewport should be stopped. If `true` the overlay is placed in the same
	 * container as that of the controls (CSS class name
	 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
	 * with CSS class name specified by the `className` property.
	 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
	 * in the overlay container, or appended. If the overlay is placed in the same
	 * container as that of the controls (see the `stopEvent` option) you will
	 * probably set `insertFirst` to `true` so the overlay is displayed below the
	 * controls.
	 * @property {boolean} [autoPan=false] If set to `true` the map is panned when
	 * calling `setPosition`, so that the overlay is entirely visible in the current
	 * viewport.
	 * @property {PanOptions} [autoPanAnimation] The
	 * animation options used to pan the overlay into view. This animation is only
	 * used when `autoPan` is enabled. A `duration` and `easing` may be provided to
	 * customize the animation.
	 * @property {number} [autoPanMargin=20] The margin (in pixels) between the
	 * overlay and the borders of the map when autopanning.
	 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
	 * name.
	 */
	
	
	/**
	 * @typedef {Object} PanOptions
	 * @property {number} [duration=1000] The duration of the animation in
	 * milliseconds.
	 * @property {function(number):number} [easing] The easing function to use. Can
	 * be one from {@link module:ol/easing} or a custom function.
	 * Default is {@link module:ol/easing~inAndOut}.
	 */
	
	
	/**
	 * @enum {string}
	 * @protected
	 */
	var Property$4 = {
	  ELEMENT: 'element',
	  MAP: 'map',
	  OFFSET: 'offset',
	  POSITION: 'position',
	  POSITIONING: 'positioning'
	};
	
	
	/**
	 * @classdesc
	 * An element to be displayed over the map and attached to a single map
	 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
	 * visible widgets. Unlike Controls, they are not in a fixed position on the
	 * screen, but are tied to a geographical coordinate, so panning the map will
	 * move an Overlay but not a Control.
	 *
	 * Example:
	 *
	 *     import Overlay from 'ol/Overlay';
	 *
	 *     var popup = new Overlay({
	 *       element: document.getElementById('popup')
	 *     });
	 *     popup.setPosition(coordinate);
	 *     map.addOverlay(popup);
	 *
	 * @api
	 */
	var Overlay = /*@__PURE__*/(function (BaseObject$$1) {
	  function Overlay(options) {
	
	    BaseObject$$1.call(this);
	
	    /**
	     * @protected
	     * @type {Options}
	     */
	    this.options = options;
	
	    /**
	     * @protected
	     * @type {number|string|undefined}
	     */
	    this.id = options.id;
	
	    /**
	     * @protected
	     * @type {boolean}
	     */
	    this.insertFirst = options.insertFirst !== undefined ?
	      options.insertFirst : true;
	
	    /**
	     * @protected
	     * @type {boolean}
	     */
	    this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
	
	    /**
	     * @protected
	     * @type {HTMLElement}
	     */
	    this.element = document.createElement('div');
	    this.element.className = options.className !== undefined ?
	      options.className : 'ol-overlay-container ' + CLASS_SELECTABLE;
	    this.element.style.position = 'absolute';
	
	    /**
	     * @protected
	     * @type {boolean}
	     */
	    this.autoPan = options.autoPan !== undefined ? options.autoPan : false;
	
	    /**
	     * @protected
	     * @type {PanOptions}
	     */
	    this.autoPanAnimation = options.autoPanAnimation || /** @type {PanOptions} */ ({});
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.autoPanMargin = options.autoPanMargin !== undefined ?
	      options.autoPanMargin : 20;
	
	    /**
	     * @protected
	     * @type {{bottom_: string,
	     *         left_: string,
	     *         right_: string,
	     *         top_: string,
	     *         visible: boolean}}
	     */
	    this.rendered = {
	      bottom_: '',
	      left_: '',
	      right_: '',
	      top_: '',
	      visible: true
	    };
	
	    /**
	     * @protected
	     * @type {?import("./events.js").EventsKey}
	     */
	    this.mapPostrenderListenerKey = null;
	
	    listen(
	      this, getChangeEventType(Property$4.ELEMENT),
	      this.handleElementChanged, this);
	
	    listen(
	      this, getChangeEventType(Property$4.MAP),
	      this.handleMapChanged, this);
	
	    listen(
	      this, getChangeEventType(Property$4.OFFSET),
	      this.handleOffsetChanged, this);
	
	    listen(
	      this, getChangeEventType(Property$4.POSITION),
	      this.handlePositionChanged, this);
	
	    listen(
	      this, getChangeEventType(Property$4.POSITIONING),
	      this.handlePositioningChanged, this);
	
	    if (options.element !== undefined) {
	      this.setElement(options.element);
	    }
	
	    this.setOffset(options.offset !== undefined ? options.offset : [0, 0]);
	
	    this.setPositioning(options.positioning !== undefined ?
	      /** @type {OverlayPositioning} */ (options.positioning) :
	      OverlayPositioning.TOP_LEFT);
	
	    if (options.position !== undefined) {
	      this.setPosition(options.position);
	    }
	
	  }
	
	  if ( BaseObject$$1 ) { Overlay.__proto__ = BaseObject$$1; }
	  Overlay.prototype = Object.create( BaseObject$$1 && BaseObject$$1.prototype );
	  Overlay.prototype.constructor = Overlay;
	
	  /**
	   * Get the DOM element of this overlay.
	   * @return {HTMLElement|undefined} The Element containing the overlay.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.getElement = function getElement () {
	    return /** @type {HTMLElement|undefined} */ (this.get(Property$4.ELEMENT));
	  };
	
	  /**
	   * Get the overlay identifier which is set on constructor.
	   * @return {number|string|undefined} Id.
	   * @api
	   */
	  Overlay.prototype.getId = function getId () {
	    return this.id;
	  };
	
	  /**
	   * Get the map associated with this overlay.
	   * @return {import("./PluggableMap.js").default|undefined} The map that the
	   * overlay is part of.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.getMap = function getMap () {
	    return (
	      /** @type {import("./PluggableMap.js").default|undefined} */ (this.get(Property$4.MAP))
	    );
	  };
	
	  /**
	   * Get the offset of this overlay.
	   * @return {Array<number>} The offset.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.getOffset = function getOffset () {
	    return /** @type {Array<number>} */ (this.get(Property$4.OFFSET));
	  };
	
	  /**
	   * Get the current position of this overlay.
	   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
	   *     anchored at.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.getPosition = function getPosition () {
	    return (
	      /** @type {import("./coordinate.js").Coordinate|undefined} */ (this.get(Property$4.POSITION))
	    );
	  };
	
	  /**
	   * Get the current positioning of this overlay.
	   * @return {OverlayPositioning} How the overlay is positioned
	   *     relative to its point on the map.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.getPositioning = function getPositioning () {
	    return (
	      /** @type {OverlayPositioning} */ (this.get(Property$4.POSITIONING))
	    );
	  };
	
	  /**
	   * @protected
	   */
	  Overlay.prototype.handleElementChanged = function handleElementChanged () {
	    removeChildren(this.element);
	    var element = this.getElement();
	    if (element) {
	      this.element.appendChild(element);
	    }
	  };
	
	  /**
	   * @protected
	   */
	  Overlay.prototype.handleMapChanged = function handleMapChanged () {
	    if (this.mapPostrenderListenerKey) {
	      removeNode(this.element);
	      unlistenByKey(this.mapPostrenderListenerKey);
	      this.mapPostrenderListenerKey = null;
	    }
	    var map = this.getMap();
	    if (map) {
	      this.mapPostrenderListenerKey = listen(map,
	        MapEventType.POSTRENDER, this.render, this);
	      this.updatePixelPosition();
	      var container = this.stopEvent ?
	        map.getOverlayContainerStopEvent() : map.getOverlayContainer();
	      if (this.insertFirst) {
	        container.insertBefore(this.element, container.childNodes[0] || null);
	      } else {
	        container.appendChild(this.element);
	      }
	    }
	  };
	
	  /**
	   * @protected
	   */
	  Overlay.prototype.render = function render () {
	    this.updatePixelPosition();
	  };
	
	  /**
	   * @protected
	   */
	  Overlay.prototype.handleOffsetChanged = function handleOffsetChanged () {
	    this.updatePixelPosition();
	  };
	
	  /**
	   * @protected
	   */
	  Overlay.prototype.handlePositionChanged = function handlePositionChanged () {
	    this.updatePixelPosition();
	    if (this.get(Property$4.POSITION) && this.autoPan) {
	      this.panIntoView();
	    }
	  };
	
	  /**
	   * @protected
	   */
	  Overlay.prototype.handlePositioningChanged = function handlePositioningChanged () {
	    this.updatePixelPosition();
	  };
	
	  /**
	   * Set the DOM element to be associated with this overlay.
	   * @param {HTMLElement|undefined} element The Element containing the overlay.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.setElement = function setElement (element) {
	    this.set(Property$4.ELEMENT, element);
	  };
	
	  /**
	   * Set the map to be associated with this overlay.
	   * @param {import("./PluggableMap.js").default|undefined} map The map that the
	   * overlay is part of.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.setMap = function setMap (map) {
	    this.set(Property$4.MAP, map);
	  };
	
	  /**
	   * Set the offset for this overlay.
	   * @param {Array<number>} offset Offset.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.setOffset = function setOffset (offset) {
	    this.set(Property$4.OFFSET, offset);
	  };
	
	  /**
	   * Set the position for this overlay. If the position is `undefined` the
	   * overlay is hidden.
	   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
	   *     is anchored at.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.setPosition = function setPosition (position) {
	    this.set(Property$4.POSITION, position);
	  };
	
	  /**
	   * Pan the map so that the overlay is entirely visible in the current viewport
	   * (if necessary).
	   * @protected
	   */
	  Overlay.prototype.panIntoView = function panIntoView () {
	    var map = this.getMap();
	
	    if (!map || !map.getTargetElement()) {
	      return;
	    }
	
	    var mapRect = this.getRect(map.getTargetElement(), map.getSize());
	    var element = this.getElement();
	    var overlayRect = this.getRect(element, [outerWidth(element), outerHeight(element)]);
	
	    var margin = this.autoPanMargin;
	    if (!containsExtent(mapRect, overlayRect)) {
	      // the overlay is not completely inside the viewport, so pan the map
	      var offsetLeft = overlayRect[0] - mapRect[0];
	      var offsetRight = mapRect[2] - overlayRect[2];
	      var offsetTop = overlayRect[1] - mapRect[1];
	      var offsetBottom = mapRect[3] - overlayRect[3];
	
	      var delta = [0, 0];
	      if (offsetLeft < 0) {
	        // move map to the left
	        delta[0] = offsetLeft - margin;
	      } else if (offsetRight < 0) {
	        // move map to the right
	        delta[0] = Math.abs(offsetRight) + margin;
	      }
	      if (offsetTop < 0) {
	        // move map up
	        delta[1] = offsetTop - margin;
	      } else if (offsetBottom < 0) {
	        // move map down
	        delta[1] = Math.abs(offsetBottom) + margin;
	      }
	
	      if (delta[0] !== 0 || delta[1] !== 0) {
	        var center = /** @type {import("./coordinate.js").Coordinate} */ (map.getView().getCenter());
	        var centerPx = map.getPixelFromCoordinate(center);
	        var newCenterPx = [
	          centerPx[0] + delta[0],
	          centerPx[1] + delta[1]
	        ];
	
	        map.getView().animate({
	          center: map.getCoordinateFromPixel(newCenterPx),
	          duration: this.autoPanAnimation.duration,
	          easing: this.autoPanAnimation.easing
	        });
	      }
	    }
	  };
	
	  /**
	   * Get the extent of an element relative to the document
	   * @param {HTMLElement|undefined} element The element.
	   * @param {import("./size.js").Size|undefined} size The size of the element.
	   * @return {import("./extent.js").Extent} The extent.
	   * @protected
	   */
	  Overlay.prototype.getRect = function getRect (element, size) {
	    var box = element.getBoundingClientRect();
	    var offsetX = box.left + window.pageXOffset;
	    var offsetY = box.top + window.pageYOffset;
	    return [
	      offsetX,
	      offsetY,
	      offsetX + size[0],
	      offsetY + size[1]
	    ];
	  };
	
	  /**
	   * Set the positioning for this overlay.
	   * @param {OverlayPositioning} positioning how the overlay is
	   *     positioned relative to its point on the map.
	   * @observable
	   * @api
	   */
	  Overlay.prototype.setPositioning = function setPositioning (positioning) {
	    this.set(Property$4.POSITIONING, positioning);
	  };
	
	  /**
	   * Modify the visibility of the element.
	   * @param {boolean} visible Element visibility.
	   * @protected
	   */
	  Overlay.prototype.setVisible = function setVisible (visible) {
	    if (this.rendered.visible !== visible) {
	      this.element.style.display = visible ? '' : 'none';
	      this.rendered.visible = visible;
	    }
	  };
	
	  /**
	   * Update pixel position.
	   * @protected
	   */
	  Overlay.prototype.updatePixelPosition = function updatePixelPosition () {
	    var map = this.getMap();
	    var position = this.getPosition();
	    if (!map || !map.isRendered() || !position) {
	      this.setVisible(false);
	      return;
	    }
	
	    var pixel = map.getPixelFromCoordinate(position);
	    var mapSize = map.getSize();
	    this.updateRenderedPosition(pixel, mapSize);
	  };
	
	  /**
	   * @param {import("./pixel.js").Pixel} pixel The pixel location.
	   * @param {import("./size.js").Size|undefined} mapSize The map size.
	   * @protected
	   */
	  Overlay.prototype.updateRenderedPosition = function updateRenderedPosition (pixel, mapSize) {
	    var style = this.element.style;
	    var offset = this.getOffset();
	
	    var positioning = this.getPositioning();
	
	    this.setVisible(true);
	
	    var offsetX = offset[0];
	    var offsetY = offset[1];
	    if (positioning == OverlayPositioning.BOTTOM_RIGHT ||
	        positioning == OverlayPositioning.CENTER_RIGHT ||
	        positioning == OverlayPositioning.TOP_RIGHT) {
	      if (this.rendered.left_ !== '') {
	        this.rendered.left_ = style.left = '';
	      }
	      var right = Math.round(mapSize[0] - pixel[0] - offsetX) + 'px';
	      if (this.rendered.right_ != right) {
	        this.rendered.right_ = style.right = right;
	      }
	    } else {
	      if (this.rendered.right_ !== '') {
	        this.rendered.right_ = style.right = '';
	      }
	      if (positioning == OverlayPositioning.BOTTOM_CENTER ||
	          positioning == OverlayPositioning.CENTER_CENTER ||
	          positioning == OverlayPositioning.TOP_CENTER) {
	        offsetX -= this.element.offsetWidth / 2;
	      }
	      var left = Math.round(pixel[0] + offsetX) + 'px';
	      if (this.rendered.left_ != left) {
	        this.rendered.left_ = style.left = left;
	      }
	    }
	    if (positioning == OverlayPositioning.BOTTOM_LEFT ||
	        positioning == OverlayPositioning.BOTTOM_CENTER ||
	        positioning == OverlayPositioning.BOTTOM_RIGHT) {
	      if (this.rendered.top_ !== '') {
	        this.rendered.top_ = style.top = '';
	      }
	      var bottom = Math.round(mapSize[1] - pixel[1] - offsetY) + 'px';
	      if (this.rendered.bottom_ != bottom) {
	        this.rendered.bottom_ = style.bottom = bottom;
	      }
	    } else {
	      if (this.rendered.bottom_ !== '') {
	        this.rendered.bottom_ = style.bottom = '';
	      }
	      if (positioning == OverlayPositioning.CENTER_LEFT ||
	          positioning == OverlayPositioning.CENTER_CENTER ||
	          positioning == OverlayPositioning.CENTER_RIGHT) {
	        offsetY -= this.element.offsetHeight / 2;
	      }
	      var top = Math.round(pixel[1] + offsetY) + 'px';
	      if (this.rendered.top_ != top) {
	        this.rendered.top_ = style.top = top;
	      }
	    }
	  };
	
	  /**
	   * returns the options this Overlay has been created with
	   * @return {Options} overlay options
	   */
	  Overlay.prototype.getOptions = function getOptions () {
	    return this.options;
	  };
	
	  return Overlay;
	}(BaseObject));
	
	/**
	 * @module ol/control/FullScreen
	 */
	
	
	/**
	 * @return {string} Change type.
	 */
	var getChangeType = (function() {
	  var changeType;
	  return function() {
	    if (!changeType) {
	      var body = document.body;
	      if (body.webkitRequestFullscreen) {
	        changeType = 'webkitfullscreenchange';
	      } else if (body.mozRequestFullScreen) {
	        changeType = 'mozfullscreenchange';
	      } else if (body.msRequestFullscreen) {
	        changeType = 'MSFullscreenChange';
	      } else if (body.requestFullscreen) {
	        changeType = 'fullscreenchange';
	      }
	    }
	    return changeType;
	  };
	})();
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-full-screen'] CSS class name.
	 * @property {string|Text} [label='\u2922'] Text label to use for the button.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string|Text} [labelActive='\u00d7'] Text label to use for the
	 * button when full-screen is active.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
	 * @property {boolean} [keys=false] Full keyboard access.
	 * @property {HTMLElement|string} [target] Specify a target if you want the
	 * control to be rendered outside of the map's viewport.
	 * @property {HTMLElement|string} [source] The element to be displayed
	 * fullscreen. When not provided, the element containing the map viewport will
	 * be displayed fullscreen.
	 */
	
	
	/**
	 * @classdesc
	 * Provides a button that when clicked fills up the full screen with the map.
	 * The full screen source element is by default the element containing the map viewport unless
	 * overridden by providing the `source` option. In which case, the dom
	 * element introduced using this parameter will be displayed in full screen.
	 *
	 * When in full screen mode, a close button is shown to exit full screen mode.
	 * The [Fullscreen API](http://www.w3.org/TR/fullscreen/) is used to
	 * toggle the map in full screen mode.
	 *
	 * @api
	 */
	var FullScreen = /*@__PURE__*/(function (Control$$1) {
	  function FullScreen(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      target: options.target
	    });
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.cssClassName_ = options.className !== undefined ? options.className :
	      'ol-full-screen';
	
	    var label = options.label !== undefined ? options.label : '\u2922';
	
	    /**
	     * @private
	     * @type {Text}
	     */
	    this.labelNode_ = typeof label === 'string' ?
	      document.createTextNode(label) : label;
	
	    var labelActive = options.labelActive !== undefined ? options.labelActive : '\u00d7';
	
	    /**
	     * @private
	     * @type {Text}
	     */
	    this.labelActiveNode_ = typeof labelActive === 'string' ?
	      document.createTextNode(labelActive) : labelActive;
	
	    /**
	     * @private
	     * @type {HTMLElement}
	     */
	    this.button_ = document.createElement('button');
	
	    var tipLabel = options.tipLabel ? options.tipLabel : 'Toggle full-screen';
	    this.setClassName_(this.button_, isFullScreen());
	    this.button_.setAttribute('type', 'button');
	    this.button_.title = tipLabel;
	    this.button_.appendChild(this.labelNode_);
	
	    listen(this.button_, EventType.CLICK,
	      this.handleClick_, this);
	
	    var cssClasses = this.cssClassName_ + ' ' + CLASS_UNSELECTABLE +
	        ' ' + CLASS_CONTROL + ' ' +
	        (!isFullScreenSupported() ? CLASS_UNSUPPORTED : '');
	    var element = this.element;
	    element.className = cssClasses;
	    element.appendChild(this.button_);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.keys_ = options.keys !== undefined ? options.keys : false;
	
	    /**
	     * @private
	     * @type {HTMLElement|string|undefined}
	     */
	    this.source_ = options.source;
	
	  }
	
	  if ( Control$$1 ) { FullScreen.__proto__ = Control$$1; }
	  FullScreen.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  FullScreen.prototype.constructor = FullScreen;
	
	  /**
	   * @param {MouseEvent} event The event to handle
	   * @private
	   */
	  FullScreen.prototype.handleClick_ = function handleClick_ (event) {
	    event.preventDefault();
	    this.handleFullScreen_();
	  };
	
	  /**
	   * @private
	   */
	  FullScreen.prototype.handleFullScreen_ = function handleFullScreen_ () {
	    if (!isFullScreenSupported()) {
	      return;
	    }
	    var map = this.getMap();
	    if (!map) {
	      return;
	    }
	    if (isFullScreen()) {
	      exitFullScreen();
	    } else {
	      var element;
	      if (this.source_) {
	        element = typeof this.source_ === 'string' ?
	          document.getElementById(this.source_) :
	          this.source_;
	      } else {
	        element = map.getTargetElement();
	      }
	      if (this.keys_) {
	        requestFullScreenWithKeys(element);
	
	      } else {
	        requestFullScreen(element);
	      }
	    }
	  };
	
	  /**
	   * @private
	   */
	  FullScreen.prototype.handleFullScreenChange_ = function handleFullScreenChange_ () {
	    var map = this.getMap();
	    if (isFullScreen()) {
	      this.setClassName_(this.button_, true);
	      replaceNode(this.labelActiveNode_, this.labelNode_);
	    } else {
	      this.setClassName_(this.button_, false);
	      replaceNode(this.labelNode_, this.labelActiveNode_);
	    }
	    if (map) {
	      map.updateSize();
	    }
	  };
	
	  /**
	   * @param {HTMLElement} element Target element
	   * @param {boolean} fullscreen True if fullscreen class name should be active
	   * @private
	   */
	  FullScreen.prototype.setClassName_ = function setClassName_ (element, fullscreen) {
	    var activeClassName = this.cssClassName_ + '-true';
	    var inactiveClassName = this.cssClassName_ + '-false';
	    var nextClassName = fullscreen ? activeClassName : inactiveClassName;
	    element.classList.remove(activeClassName);
	    element.classList.remove(inactiveClassName);
	    element.classList.add(nextClassName);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  FullScreen.prototype.setMap = function setMap (map) {
	    Control$$1.prototype.setMap.call(this, map);
	    if (map) {
	      this.listenerKeys.push(listen(document,
	        getChangeType(),
	        this.handleFullScreenChange_, this)
	      );
	    }
	  };
	
	  return FullScreen;
	}(Control));
	
	
	/**
	 * @return {boolean} Fullscreen is supported by the current platform.
	 */
	function isFullScreenSupported() {
	  var body = document.body;
	  return !!(
	    body.webkitRequestFullscreen ||
	    (body.mozRequestFullScreen && document.mozFullScreenEnabled) ||
	    (body.msRequestFullscreen && document.msFullscreenEnabled) ||
	    (body.requestFullscreen && document.fullscreenEnabled)
	  );
	}
	
	/**
	 * @return {boolean} Element is currently in fullscreen.
	 */
	function isFullScreen() {
	  return !!(
	    document.webkitIsFullScreen || document.mozFullScreen ||
	    document.msFullscreenElement || document.fullscreenElement
	  );
	}
	
	/**
	 * Request to fullscreen an element.
	 * @param {HTMLElement} element Element to request fullscreen
	 */
	function requestFullScreen(element) {
	  if (element.requestFullscreen) {
	    element.requestFullscreen();
	  } else if (element.msRequestFullscreen) {
	    element.msRequestFullscreen();
	  } else if (element.mozRequestFullScreen) {
	    element.mozRequestFullScreen();
	  } else if (element.webkitRequestFullscreen) {
	    element.webkitRequestFullscreen();
	  }
	}
	
	/**
	 * Request to fullscreen an element with keyboard input.
	 * @param {HTMLElement} element Element to request fullscreen
	 */
	function requestFullScreenWithKeys(element) {
	  if (element.mozRequestFullScreenWithKeys) {
	    element.mozRequestFullScreenWithKeys();
	  } else if (element.webkitRequestFullscreen) {
	    element.webkitRequestFullscreen();
	  } else {
	    requestFullScreen(element);
	  }
	}
	
	/**
	 * Exit fullscreen.
	 */
	function exitFullScreen() {
	  if (document.exitFullscreen) {
	    document.exitFullscreen();
	  } else if (document.msExitFullscreen) {
	    document.msExitFullscreen();
	  } else if (document.mozCancelFullScreen) {
	    document.mozCancelFullScreen();
	  } else if (document.webkitExitFullscreen) {
	    document.webkitExitFullscreen();
	  }
	}
	
	/**
	 * @module ol/control/MousePosition
	 */
	
	
	/**
	 * @type {string}
	 */
	var PROJECTION = 'projection';
	
	/**
	 * @type {string}
	 */
	var COORDINATE_FORMAT = 'coordinateFormat';
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-mouse-position'] CSS class name.
	 * @property {import("../coordinate.js").CoordinateFormat} [coordinateFormat] Coordinate format.
	 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when the
	 * control should be re-rendered. This is called in a `requestAnimationFrame`
	 * callback.
	 * @property {HTMLElement|string} [target] Specify a target if you want the
	 * control to be rendered outside of the map's viewport.
	 * @property {string} [undefinedHTML='&#160;'] Markup to show when coordinates are not
	 * available (e.g. when the pointer leaves the map viewport).  By default, the last position
	 * will be replaced with `'&#160;'` (`&nbsp;`) when the pointer leaves the viewport.  To
	 * retain the last rendered position, set this option to something falsey (like an empty
	 * string `''`).
	 */
	
	
	/**
	 * @classdesc
	 * A control to show the 2D coordinates of the mouse cursor. By default, these
	 * are in the view projection, but can be in any supported projection.
	 * By default the control is shown in the top right corner of the map, but this
	 * can be changed by using the css selector `.ol-mouse-position`.
	 *
	 * On touch devices, which usually do not have a mouse cursor, the coordinates
	 * of the currently touched position are shown.
	 *
	 * @api
	 */
	var MousePosition = /*@__PURE__*/(function (Control$$1) {
	  function MousePosition(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    var element = document.createElement('div');
	    element.className = options.className !== undefined ? options.className : 'ol-mouse-position';
	
	    Control$$1.call(this, {
	      element: element,
	      render: options.render || render$2,
	      target: options.target
	    });
	
	    listen(this,
	      getChangeEventType(PROJECTION),
	      this.handleProjectionChanged_, this);
	
	    if (options.coordinateFormat) {
	      this.setCoordinateFormat(options.coordinateFormat);
	    }
	    if (options.projection) {
	      this.setProjection(options.projection);
	    }
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.undefinedHTML_ = options.undefinedHTML !== undefined ? options.undefinedHTML : '&#160;';
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderOnMouseOut_ = !!this.undefinedHTML_;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.renderedHTML_ = element.innerHTML;
	
	    /**
	     * @private
	     * @type {import("../proj/Projection.js").default}
	     */
	    this.mapProjection_ = null;
	
	    /**
	     * @private
	     * @type {?import("../proj.js").TransformFunction}
	     */
	    this.transform_ = null;
	
	    /**
	     * @private
	     * @type {import("../pixel.js").Pixel}
	     */
	    this.lastMouseMovePixel_ = null;
	
	  }
	
	  if ( Control$$1 ) { MousePosition.__proto__ = Control$$1; }
	  MousePosition.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  MousePosition.prototype.constructor = MousePosition;
	
	  /**
	   * @private
	   */
	  MousePosition.prototype.handleProjectionChanged_ = function handleProjectionChanged_ () {
	    this.transform_ = null;
	  };
	
	  /**
	   * Return the coordinate format type used to render the current position or
	   * undefined.
	   * @return {import("../coordinate.js").CoordinateFormat|undefined} The format to render the current
	   *     position in.
	   * @observable
	   * @api
	   */
	  MousePosition.prototype.getCoordinateFormat = function getCoordinateFormat () {
	    return (
	      /** @type {import("../coordinate.js").CoordinateFormat|undefined} */ (this.get(COORDINATE_FORMAT))
	    );
	  };
	
	  /**
	   * Return the projection that is used to report the mouse position.
	   * @return {import("../proj/Projection.js").default|undefined} The projection to report mouse
	   *     position in.
	   * @observable
	   * @api
	   */
	  MousePosition.prototype.getProjection = function getProjection () {
	    return (
	      /** @type {import("../proj/Projection.js").default|undefined} */ (this.get(PROJECTION))
	    );
	  };
	
	  /**
	   * @param {Event} event Browser event.
	   * @protected
	   */
	  MousePosition.prototype.handleMouseMove = function handleMouseMove (event) {
	    var map = this.getMap();
	    this.lastMouseMovePixel_ = map.getEventPixel(event);
	    this.updateHTML_(this.lastMouseMovePixel_);
	  };
	
	  /**
	   * @param {Event} event Browser event.
	   * @protected
	   */
	  MousePosition.prototype.handleMouseOut = function handleMouseOut (event) {
	    this.updateHTML_(null);
	    this.lastMouseMovePixel_ = null;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MousePosition.prototype.setMap = function setMap (map) {
	    Control$$1.prototype.setMap.call(this, map);
	    if (map) {
	      var viewport = map.getViewport();
	      this.listenerKeys.push(
	        listen(viewport, EventType.MOUSEMOVE, this.handleMouseMove, this),
	        listen(viewport, EventType.TOUCHSTART, this.handleMouseMove, this)
	      );
	      if (this.renderOnMouseOut_) {
	        this.listenerKeys.push(
	          listen(viewport, EventType.MOUSEOUT, this.handleMouseOut, this),
	          listen(viewport, EventType.TOUCHEND, this.handleMouseOut, this)
	        );
	      }
	    }
	  };
	
	  /**
	   * Set the coordinate format type used to render the current position.
	   * @param {import("../coordinate.js").CoordinateFormat} format The format to render the current
	   *     position in.
	   * @observable
	   * @api
	   */
	  MousePosition.prototype.setCoordinateFormat = function setCoordinateFormat (format) {
	    this.set(COORDINATE_FORMAT, format);
	  };
	
	  /**
	   * Set the projection that is used to report the mouse position.
	   * @param {import("../proj.js").ProjectionLike} projection The projection to report mouse
	   *     position in.
	   * @observable
	   * @api
	   */
	  MousePosition.prototype.setProjection = function setProjection (projection) {
	    this.set(PROJECTION, get$2(projection));
	  };
	
	  /**
	   * @param {?import("../pixel.js").Pixel} pixel Pixel.
	   * @private
	   */
	  MousePosition.prototype.updateHTML_ = function updateHTML_ (pixel) {
	    var html = this.undefinedHTML_;
	    if (pixel && this.mapProjection_) {
	      if (!this.transform_) {
	        var projection = this.getProjection();
	        if (projection) {
	          this.transform_ = getTransformFromProjections(
	            this.mapProjection_, projection);
	        } else {
	          this.transform_ = identityTransform;
	        }
	      }
	      var map = this.getMap();
	      var coordinate = map.getCoordinateFromPixel(pixel);
	      if (coordinate) {
	        this.transform_(coordinate, coordinate);
	        var coordinateFormat = this.getCoordinateFormat();
	        if (coordinateFormat) {
	          html = coordinateFormat(coordinate);
	        } else {
	          html = coordinate.toString();
	        }
	      }
	    }
	    if (!this.renderedHTML_ || html !== this.renderedHTML_) {
	      this.element.innerHTML = html;
	      this.renderedHTML_ = html;
	    }
	  };
	
	  return MousePosition;
	}(Control));
	
	
	/**
	 * Update the projection. Rendering of the coordinates is done in
	 * `handleMouseMove` and `handleMouseUp`.
	 * @param {import("../MapEvent.js").default} mapEvent Map event.
	 * @this {MousePosition}
	 * @api
	 */
	function render$2(mapEvent) {
	  var frameState = mapEvent.frameState;
	  if (!frameState) {
	    this.mapProjection_ = null;
	  } else {
	    if (this.mapProjection_ != frameState.viewState.projection) {
	      this.mapProjection_ = frameState.viewState.projection;
	      this.transform_ = null;
	    }
	  }
	}
	
	/**
	 * @module ol/control/OverviewMap
	 */
	
	
	/**
	 * Maximum width and/or height extent ratio that determines when the overview
	 * map should be zoomed out.
	 * @type {number}
	 */
	var MAX_RATIO = 0.75;
	
	
	/**
	 * Minimum width and/or height extent ratio that determines when the overview
	 * map should be zoomed in.
	 * @type {number}
	 */
	var MIN_RATIO = 0.1;
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-overviewmap'] CSS class name.
	 * @property {boolean} [collapsed=true] Whether the control should start collapsed or not (expanded).
	 * @property {string|HTMLElement} [collapseLabel='«'] Text label to use for the
	 * expanded overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {boolean} [collapsible=true] Whether the control can be collapsed or not.
	 * @property {string|HTMLElement} [label='»'] Text label to use for the collapsed
	 * overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {Array<import("../layer/Layer.js").default>|import("../Collection.js").default<import("../layer/Layer.js").default>} [layers]
	 * Layers for the overview map. If not set, then all main map layers are used
	 * instead.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when the control
	 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
	 * @property {HTMLElement|string} [target] Specify a target if you want the control
	 * to be rendered outside of the map's viewport.
	 * @property {string} [tipLabel='Overview map'] Text label to use for the button tip.
	 * @property {import("../View.js").default} [view] Custom view for the overview map. If not provided,
	 * a default view with an EPSG:3857 projection will be used.
	 */
	
	
	/**
	 * Create a new control with a map acting as an overview map for an other
	 * defined map.
	 *
	 * @api
	 */
	var OverviewMap = /*@__PURE__*/(function (Control$$1) {
	  function OverviewMap(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      render: options.render || render$3,
	      target: options.target
	    });
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.collapsible_ = options.collapsible !== undefined ?
	      options.collapsible : true;
	
	    if (!this.collapsible_) {
	      this.collapsed_ = false;
	    }
	
	    var className = options.className !== undefined ? options.className : 'ol-overviewmap';
	
	    var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Overview map';
	
	    var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00AB';
	
	    if (typeof collapseLabel === 'string') {
	      /**
	       * @private
	       * @type {HTMLElement}
	       */
	      this.collapseLabel_ = document.createElement('span');
	      this.collapseLabel_.textContent = collapseLabel;
	    } else {
	      this.collapseLabel_ = collapseLabel;
	    }
	
	    var label = options.label !== undefined ? options.label : '\u00BB';
	
	
	    if (typeof label === 'string') {
	      /**
	       * @private
	       * @type {HTMLElement}
	       */
	      this.label_ = document.createElement('span');
	      this.label_.textContent = label;
	    } else {
	      this.label_ = label;
	    }
	
	    var activeLabel = (this.collapsible_ && !this.collapsed_) ?
	      this.collapseLabel_ : this.label_;
	    var button = document.createElement('button');
	    button.setAttribute('type', 'button');
	    button.title = tipLabel;
	    button.appendChild(activeLabel);
	
	    listen(button, EventType.CLICK,
	      this.handleClick_, this);
	
	    /**
	     * @type {HTMLElement}
	     * @private
	     */
	    this.ovmapDiv_ = document.createElement('div');
	    this.ovmapDiv_.className = 'ol-overviewmap-map';
	
	    /**
	     * @type {import("../Map.js").default}
	     * @private
	     */
	    this.ovmap_ = new Map({
	      controls: new Collection(),
	      interactions: new Collection(),
	      view: options.view
	    });
	    var ovmap = this.ovmap_;
	
	    if (options.layers) {
	      /** @type {Array<import("../layer/Layer.js").default>} */ (options.layers).forEach(
	        /**
	         * @param {import("../layer/Layer.js").default} layer Layer.
	         */
	        (function(layer) {
	          ovmap.addLayer(layer);
	        }).bind(this));
	    }
	
	    var box = document.createElement('div');
	    box.className = 'ol-overviewmap-box';
	    box.style.boxSizing = 'border-box';
	
	    /**
	     * @type {import("../Overlay.js").default}
	     * @private
	     */
	    this.boxOverlay_ = new Overlay({
	      position: [0, 0],
	      positioning: OverlayPositioning.BOTTOM_LEFT,
	      element: box
	    });
	    this.ovmap_.addOverlay(this.boxOverlay_);
	
	    var cssClasses = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL +
	        (this.collapsed_ && this.collapsible_ ? ' ' + CLASS_COLLAPSED : '') +
	        (this.collapsible_ ? '' : ' ol-uncollapsible');
	    var element = this.element;
	    element.className = cssClasses;
	    element.appendChild(this.ovmapDiv_);
	    element.appendChild(button);
	
	    /* Interactive map */
	
	    var scope = this;
	
	    var overlay = this.boxOverlay_;
	    var overlayBox = this.boxOverlay_.getElement();
	
	    /* Functions definition */
	
	    var computeDesiredMousePosition = function(mousePosition) {
	      return {
	        clientX: mousePosition.clientX - (overlayBox.offsetWidth / 2),
	        clientY: mousePosition.clientY + (overlayBox.offsetHeight / 2)
	      };
	    };
	
	    var move = function(event) {
	      var position = /** @type {?} */ (computeDesiredMousePosition(event));
	      var coordinates = ovmap.getEventCoordinate(/** @type {Event} */ (position));
	
	      overlay.setPosition(coordinates);
	    };
	
	    var endMoving = function(event) {
	      var coordinates = ovmap.getEventCoordinate(event);
	
	      scope.getMap().getView().setCenter(coordinates);
	
	      window.removeEventListener('mousemove', move);
	      window.removeEventListener('mouseup', endMoving);
	    };
	
	    /* Binding */
	
	    overlayBox.addEventListener('mousedown', function() {
	      window.addEventListener('mousemove', move);
	      window.addEventListener('mouseup', endMoving);
	    });
	  }
	
	  if ( Control$$1 ) { OverviewMap.__proto__ = Control$$1; }
	  OverviewMap.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  OverviewMap.prototype.constructor = OverviewMap;
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  OverviewMap.prototype.setMap = function setMap (map) {
	    var oldMap = this.getMap();
	    if (map === oldMap) {
	      return;
	    }
	    if (oldMap) {
	      var oldView = oldMap.getView();
	      if (oldView) {
	        this.unbindView_(oldView);
	      }
	      this.ovmap_.setTarget(null);
	    }
	    Control$$1.prototype.setMap.call(this, map);
	
	    if (map) {
	      this.ovmap_.setTarget(this.ovmapDiv_);
	      this.listenerKeys.push(listen(
	        map, ObjectEventType.PROPERTYCHANGE,
	        this.handleMapPropertyChange_, this));
	
	      // TODO: to really support map switching, this would need to be reworked
	      if (this.ovmap_.getLayers().getLength() === 0) {
	        this.ovmap_.setLayerGroup(map.getLayerGroup());
	      }
	
	      var view = map.getView();
	      if (view) {
	        this.bindView_(view);
	        if (view.isDef()) {
	          this.ovmap_.updateSize();
	          this.resetExtent_();
	        }
	      }
	    }
	  };
	
	  /**
	   * Handle map property changes.  This only deals with changes to the map's view.
	   * @param {import("../Object.js").ObjectEvent} event The propertychange event.
	   * @private
	   */
	  OverviewMap.prototype.handleMapPropertyChange_ = function handleMapPropertyChange_ (event) {
	    if (event.key === MapProperty.VIEW) {
	      var oldView = /** @type {import("../View.js").default} */ (event.oldValue);
	      if (oldView) {
	        this.unbindView_(oldView);
	      }
	      var newView = this.getMap().getView();
	      this.bindView_(newView);
	    }
	  };
	
	  /**
	   * Register listeners for view property changes.
	   * @param {import("../View.js").default} view The view.
	   * @private
	   */
	  OverviewMap.prototype.bindView_ = function bindView_ (view) {
	    listen(view,
	      getChangeEventType(ViewProperty.ROTATION),
	      this.handleRotationChanged_, this);
	  };
	
	  /**
	   * Unregister listeners for view property changes.
	   * @param {import("../View.js").default} view The view.
	   * @private
	   */
	  OverviewMap.prototype.unbindView_ = function unbindView_ (view) {
	    unlisten(view,
	      getChangeEventType(ViewProperty.ROTATION),
	      this.handleRotationChanged_, this);
	  };
	
	  /**
	   * Handle rotation changes to the main map.
	   * TODO: This should rotate the extent rectrangle instead of the
	   * overview map's view.
	   * @private
	   */
	  OverviewMap.prototype.handleRotationChanged_ = function handleRotationChanged_ () {
	    this.ovmap_.getView().setRotation(this.getMap().getView().getRotation());
	  };
	
	  /**
	   * Reset the overview map extent if the box size (width or
	   * height) is less than the size of the overview map size times minRatio
	   * or is greater than the size of the overview size times maxRatio.
	   *
	   * If the map extent was not reset, the box size can fits in the defined
	   * ratio sizes. This method then checks if is contained inside the overview
	   * map current extent. If not, recenter the overview map to the current
	   * main map center location.
	   * @private
	   */
	  OverviewMap.prototype.validateExtent_ = function validateExtent_ () {
	    var map = this.getMap();
	    var ovmap = this.ovmap_;
	
	    if (!map.isRendered() || !ovmap.isRendered()) {
	      return;
	    }
	
	    var mapSize = /** @type {import("../size.js").Size} */ (map.getSize());
	
	    var view = map.getView();
	    var extent = view.calculateExtent(mapSize);
	
	    var ovmapSize = /** @type {import("../size.js").Size} */ (ovmap.getSize());
	
	    var ovview = ovmap.getView();
	    var ovextent = ovview.calculateExtent(ovmapSize);
	
	    var topLeftPixel =
	        ovmap.getPixelFromCoordinate(getTopLeft(extent));
	    var bottomRightPixel =
	        ovmap.getPixelFromCoordinate(getBottomRight(extent));
	
	    var boxWidth = Math.abs(topLeftPixel[0] - bottomRightPixel[0]);
	    var boxHeight = Math.abs(topLeftPixel[1] - bottomRightPixel[1]);
	
	    var ovmapWidth = ovmapSize[0];
	    var ovmapHeight = ovmapSize[1];
	
	    if (boxWidth < ovmapWidth * MIN_RATIO ||
	        boxHeight < ovmapHeight * MIN_RATIO ||
	        boxWidth > ovmapWidth * MAX_RATIO ||
	        boxHeight > ovmapHeight * MAX_RATIO) {
	      this.resetExtent_();
	    } else if (!containsExtent(ovextent, extent)) {
	      this.recenter_();
	    }
	  };
	
	  /**
	   * Reset the overview map extent to half calculated min and max ratio times
	   * the extent of the main map.
	   * @private
	   */
	  OverviewMap.prototype.resetExtent_ = function resetExtent_ () {
	
	    var map = this.getMap();
	    var ovmap = this.ovmap_;
	
	    var mapSize = /** @type {import("../size.js").Size} */ (map.getSize());
	
	    var view = map.getView();
	    var extent = view.calculateExtent(mapSize);
	
	    var ovview = ovmap.getView();
	
	    // get how many times the current map overview could hold different
	    // box sizes using the min and max ratio, pick the step in the middle used
	    // to calculate the extent from the main map to set it to the overview map,
	    var steps = Math.log(
	      MAX_RATIO / MIN_RATIO) / Math.LN2;
	    var ratio = 1 / (Math.pow(2, steps / 2) * MIN_RATIO);
	    scaleFromCenter(extent, ratio);
	    ovview.fit(extent);
	  };
	
	  /**
	   * Set the center of the overview map to the map center without changing its
	   * resolution.
	   * @private
	   */
	  OverviewMap.prototype.recenter_ = function recenter_ () {
	    var map = this.getMap();
	    var ovmap = this.ovmap_;
	
	    var view = map.getView();
	
	    var ovview = ovmap.getView();
	
	    ovview.setCenter(view.getCenter());
	  };
	
	  /**
	   * Update the box using the main map extent
	   * @private
	   */
	  OverviewMap.prototype.updateBox_ = function updateBox_ () {
	    var map = this.getMap();
	    var ovmap = this.ovmap_;
	
	    if (!map.isRendered() || !ovmap.isRendered()) {
	      return;
	    }
	
	    var mapSize = /** @type {import("../size.js").Size} */ (map.getSize());
	
	    var view = map.getView();
	
	    var ovview = ovmap.getView();
	
	    var rotation = view.getRotation();
	
	    var overlay = this.boxOverlay_;
	    var box = this.boxOverlay_.getElement();
	    var extent = view.calculateExtent(mapSize);
	    var ovresolution = ovview.getResolution();
	    var bottomLeft = getBottomLeft(extent);
	    var topRight = getTopRight(extent);
	
	    // set position using bottom left coordinates
	    var rotateBottomLeft = this.calculateCoordinateRotate_(rotation, bottomLeft);
	    overlay.setPosition(rotateBottomLeft);
	
	    // set box size calculated from map extent size and overview map resolution
	    if (box) {
	      box.style.width = Math.abs((bottomLeft[0] - topRight[0]) / ovresolution) + 'px';
	      box.style.height = Math.abs((topRight[1] - bottomLeft[1]) / ovresolution) + 'px';
	    }
	  };
	
	  /**
	   * @param {number} rotation Target rotation.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @return {import("../coordinate.js").Coordinate|undefined} Coordinate for rotation and center anchor.
	   * @private
	   */
	  OverviewMap.prototype.calculateCoordinateRotate_ = function calculateCoordinateRotate_ (rotation, coordinate) {
	    var coordinateRotate;
	
	    var map = this.getMap();
	    var view = map.getView();
	
	    var currentCenter = view.getCenter();
	
	    if (currentCenter) {
	      coordinateRotate = [
	        coordinate[0] - currentCenter[0],
	        coordinate[1] - currentCenter[1]
	      ];
	      rotate$2(coordinateRotate, rotation);
	      add$2(coordinateRotate, currentCenter);
	    }
	    return coordinateRotate;
	  };
	
	  /**
	   * @param {MouseEvent} event The event to handle
	   * @private
	   */
	  OverviewMap.prototype.handleClick_ = function handleClick_ (event) {
	    event.preventDefault();
	    this.handleToggle_();
	  };
	
	  /**
	   * @private
	   */
	  OverviewMap.prototype.handleToggle_ = function handleToggle_ () {
	    this.element.classList.toggle(CLASS_COLLAPSED);
	    if (this.collapsed_) {
	      replaceNode(this.collapseLabel_, this.label_);
	    } else {
	      replaceNode(this.label_, this.collapseLabel_);
	    }
	    this.collapsed_ = !this.collapsed_;
	
	    // manage overview map if it had not been rendered before and control
	    // is expanded
	    var ovmap = this.ovmap_;
	    if (!this.collapsed_ && !ovmap.isRendered()) {
	      ovmap.updateSize();
	      this.resetExtent_();
	      listenOnce(ovmap, MapEventType.POSTRENDER,
	        function(event) {
	          this.updateBox_();
	        },
	        this);
	    }
	  };
	
	  /**
	   * Return `true` if the overview map is collapsible, `false` otherwise.
	   * @return {boolean} True if the widget is collapsible.
	   * @api
	   */
	  OverviewMap.prototype.getCollapsible = function getCollapsible () {
	    return this.collapsible_;
	  };
	
	  /**
	   * Set whether the overview map should be collapsible.
	   * @param {boolean} collapsible True if the widget is collapsible.
	   * @api
	   */
	  OverviewMap.prototype.setCollapsible = function setCollapsible (collapsible) {
	    if (this.collapsible_ === collapsible) {
	      return;
	    }
	    this.collapsible_ = collapsible;
	    this.element.classList.toggle('ol-uncollapsible');
	    if (!collapsible && this.collapsed_) {
	      this.handleToggle_();
	    }
	  };
	
	  /**
	   * Collapse or expand the overview map according to the passed parameter. Will
	   * not do anything if the overview map isn't collapsible or if the current
	   * collapsed state is already the one requested.
	   * @param {boolean} collapsed True if the widget is collapsed.
	   * @api
	   */
	  OverviewMap.prototype.setCollapsed = function setCollapsed (collapsed) {
	    if (!this.collapsible_ || this.collapsed_ === collapsed) {
	      return;
	    }
	    this.handleToggle_();
	  };
	
	  /**
	   * Determine if the overview map is collapsed.
	   * @return {boolean} The overview map is collapsed.
	   * @api
	   */
	  OverviewMap.prototype.getCollapsed = function getCollapsed () {
	    return this.collapsed_;
	  };
	
	  /**
	   * Return the overview map.
	   * @return {import("../PluggableMap.js").default} Overview map.
	   * @api
	   */
	  OverviewMap.prototype.getOverviewMap = function getOverviewMap () {
	    return this.ovmap_;
	  };
	
	  return OverviewMap;
	}(Control));
	
	
	/**
	 * Update the overview map element.
	 * @param {import("../MapEvent.js").default} mapEvent Map event.
	 * @this {OverviewMap}
	 * @api
	 */
	function render$3(mapEvent) {
	  this.validateExtent_();
	  this.updateBox_();
	}
	
	/**
	 * @module ol/control/ScaleLine
	 */
	
	
	/**
	 * @type {string}
	 */
	var UNITS_PROP = 'units';
	
	/**
	 * Units for the scale line. Supported values are `'degrees'`, `'imperial'`,
	 * `'nautical'`, `'metric'`, `'us'`.
	 * @enum {string}
	 */
	var Units$1 = {
	  DEGREES: 'degrees',
	  IMPERIAL: 'imperial',
	  NAUTICAL: 'nautical',
	  METRIC: 'metric',
	  US: 'us'
	};
	
	
	/**
	 * @const
	 * @type {Array<number>}
	 */
	var LEADING_DIGITS = [1, 2, 5];
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-scale-line'] CSS Class name.
	 * @property {number} [minWidth=64] Minimum width in pixels.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when the control
	 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
	 * @property {HTMLElement|string} [target] Specify a target if you want the control
	 * to be rendered outside of the map's viewport.
	 * @property {Units|string} [units='metric'] Units.
	 */
	
	
	/**
	 * @classdesc
	 * A control displaying rough y-axis distances, calculated for the center of the
	 * viewport. For conformal projections (e.g. EPSG:3857, the default view
	 * projection in OpenLayers), the scale is valid for all directions.
	 * No scale line will be shown when the y-axis distance of a pixel at the
	 * viewport center cannot be calculated in the view projection.
	 * By default the scale line will show in the bottom left portion of the map,
	 * but this can be changed by using the css selector `.ol-scale-line`.
	 *
	 * @api
	 */
	var ScaleLine = /*@__PURE__*/(function (Control$$1) {
	  function ScaleLine(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    var className = options.className !== undefined ? options.className : 'ol-scale-line';
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      render: options.render || render$4,
	      target: options.target
	    });
	
	    /**
	     * @private
	     * @type {HTMLElement}
	     */
	    this.innerElement_ = document.createElement('div');
	    this.innerElement_.className = className + '-inner';
	
	    this.element.className = className + ' ' + CLASS_UNSELECTABLE;
	    this.element.appendChild(this.innerElement_);
	
	    /**
	     * @private
	     * @type {?import("../View.js").State}
	     */
	    this.viewState_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.minWidth_ = options.minWidth !== undefined ? options.minWidth : 64;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderedVisible_ = false;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.renderedWidth_ = undefined;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.renderedHTML_ = '';
	
	    listen(
	      this, getChangeEventType(UNITS_PROP),
	      this.handleUnitsChanged_, this);
	
	    this.setUnits(/** @type {Units} */ (options.units) || Units$1.METRIC);
	
	  }
	
	  if ( Control$$1 ) { ScaleLine.__proto__ = Control$$1; }
	  ScaleLine.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  ScaleLine.prototype.constructor = ScaleLine;
	
	  /**
	   * Return the units to use in the scale line.
	   * @return {Units} The units
	   * to use in the scale line.
	   * @observable
	   * @api
	   */
	  ScaleLine.prototype.getUnits = function getUnits () {
	    return this.get(UNITS_PROP);
	  };
	
	  /**
	   * @private
	   */
	  ScaleLine.prototype.handleUnitsChanged_ = function handleUnitsChanged_ () {
	    this.updateElement_();
	  };
	
	  /**
	   * Set the units to use in the scale line.
	   * @param {Units} units The units to use in the scale line.
	   * @observable
	   * @api
	   */
	  ScaleLine.prototype.setUnits = function setUnits (units) {
	    this.set(UNITS_PROP, units);
	  };
	
	  /**
	   * @private
	   */
	  ScaleLine.prototype.updateElement_ = function updateElement_ () {
	    var viewState = this.viewState_;
	
	    if (!viewState) {
	      if (this.renderedVisible_) {
	        this.element.style.display = 'none';
	        this.renderedVisible_ = false;
	      }
	      return;
	    }
	
	    var center = viewState.center;
	    var projection = viewState.projection;
	    var units = this.getUnits();
	    var pointResolutionUnits = units == Units$1.DEGREES ?
	      Units.DEGREES :
	      Units.METERS;
	    var pointResolution =
	        getPointResolution(projection, viewState.resolution, center, pointResolutionUnits);
	    if (projection.getUnits() != Units.DEGREES && projection.getMetersPerUnit()
	      && pointResolutionUnits == Units.METERS) {
	      pointResolution *= projection.getMetersPerUnit();
	    }
	
	    var nominalCount = this.minWidth_ * pointResolution;
	    var suffix = '';
	    if (units == Units$1.DEGREES) {
	      var metersPerDegree = METERS_PER_UNIT[Units.DEGREES];
	      if (projection.getUnits() == Units.DEGREES) {
	        nominalCount *= metersPerDegree;
	      } else {
	        pointResolution /= metersPerDegree;
	      }
	      if (nominalCount < metersPerDegree / 60) {
	        suffix = '\u2033'; // seconds
	        pointResolution *= 3600;
	      } else if (nominalCount < metersPerDegree) {
	        suffix = '\u2032'; // minutes
	        pointResolution *= 60;
	      } else {
	        suffix = '\u00b0'; // degrees
	      }
	    } else if (units == Units$1.IMPERIAL) {
	      if (nominalCount < 0.9144) {
	        suffix = 'in';
	        pointResolution /= 0.0254;
	      } else if (nominalCount < 1609.344) {
	        suffix = 'ft';
	        pointResolution /= 0.3048;
	      } else {
	        suffix = 'mi';
	        pointResolution /= 1609.344;
	      }
	    } else if (units == Units$1.NAUTICAL) {
	      pointResolution /= 1852;
	      suffix = 'nm';
	    } else if (units == Units$1.METRIC) {
	      if (nominalCount < 0.001) {
	        suffix = 'μm';
	        pointResolution *= 1000000;
	      } else if (nominalCount < 1) {
	        suffix = 'mm';
	        pointResolution *= 1000;
	      } else if (nominalCount < 1000) {
	        suffix = 'm';
	      } else {
	        suffix = 'km';
	        pointResolution /= 1000;
	      }
	    } else if (units == Units$1.US) {
	      if (nominalCount < 0.9144) {
	        suffix = 'in';
	        pointResolution *= 39.37;
	      } else if (nominalCount < 1609.344) {
	        suffix = 'ft';
	        pointResolution /= 0.30480061;
	      } else {
	        suffix = 'mi';
	        pointResolution /= 1609.3472;
	      }
	    } else {
	      assert(false, 33); // Invalid units
	    }
	
	    var i = 3 * Math.floor(
	      Math.log(this.minWidth_ * pointResolution) / Math.log(10));
	    var count, width;
	    while (true) {
	      count = LEADING_DIGITS[((i % 3) + 3) % 3] *
	          Math.pow(10, Math.floor(i / 3));
	      width = Math.round(count / pointResolution);
	      if (isNaN(width)) {
	        this.element.style.display = 'none';
	        this.renderedVisible_ = false;
	        return;
	      } else if (width >= this.minWidth_) {
	        break;
	      }
	      ++i;
	    }
	
	    var html = count + ' ' + suffix;
	    if (this.renderedHTML_ != html) {
	      this.innerElement_.innerHTML = html;
	      this.renderedHTML_ = html;
	    }
	
	    if (this.renderedWidth_ != width) {
	      this.innerElement_.style.width = width + 'px';
	      this.renderedWidth_ = width;
	    }
	
	    if (!this.renderedVisible_) {
	      this.element.style.display = '';
	      this.renderedVisible_ = true;
	    }
	
	  };
	
	  return ScaleLine;
	}(Control));
	
	
	/**
	 * Update the scale line element.
	 * @param {import("../MapEvent.js").default} mapEvent Map event.
	 * @this {ScaleLine}
	 * @api
	 */
	function render$4(mapEvent) {
	  var frameState = mapEvent.frameState;
	  if (!frameState) {
	    this.viewState_ = null;
	  } else {
	    this.viewState_ = frameState.viewState;
	  }
	  this.updateElement_();
	}
	
	/**
	 * @module ol/control/ZoomSlider
	 */
	
	
	/**
	 * The enum for available directions.
	 *
	 * @enum {number}
	 */
	var Direction = {
	  VERTICAL: 0,
	  HORIZONTAL: 1
	};
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-zoomslider'] CSS class name.
	 * @property {number} [duration=200] Animation duration in milliseconds.
	 * @property {function(import("../MapEvent.js").default)} [render] Function called when the control
	 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
	 */
	
	
	/**
	 * @classdesc
	 * A slider type of control for zooming.
	 *
	 * Example:
	 *
	 *     map.addControl(new ZoomSlider());
	 *
	 * @api
	 */
	var ZoomSlider = /*@__PURE__*/(function (Control$$1) {
	  function ZoomSlider(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      render: options.render || render$5
	    });
	
	    /**
	      * @type {!Array.<import("../events.js").EventsKey>}
	      * @private
	      */
	    this.dragListenerKeys_ = [];
	
	    /**
	     * Will hold the current resolution of the view.
	     *
	     * @type {number|undefined}
	     * @private
	     */
	    this.currentResolution_ = undefined;
	
	    /**
	     * The direction of the slider. Will be determined from actual display of the
	     * container and defaults to Direction.VERTICAL.
	     *
	     * @type {Direction}
	     * @private
	     */
	    this.direction_ = Direction.VERTICAL;
	
	    /**
	     * @type {boolean}
	     * @private
	     */
	    this.dragging_;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.heightLimit_ = 0;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.widthLimit_ = 0;
	
	    /**
	     * @type {number|undefined}
	     * @private
	     */
	    this.previousX_;
	
	    /**
	     * @type {number|undefined}
	     * @private
	     */
	    this.previousY_;
	
	    /**
	     * The calculated thumb size (border box plus margins).  Set when initSlider_
	     * is called.
	     * @type {import("../size.js").Size}
	     * @private
	     */
	    this.thumbSize_ = null;
	
	    /**
	     * Whether the slider is initialized.
	     * @type {boolean}
	     * @private
	     */
	    this.sliderInitialized_ = false;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.duration_ = options.duration !== undefined ? options.duration : 200;
	
	    var className = options.className !== undefined ? options.className : 'ol-zoomslider';
	    var thumbElement = document.createElement('button');
	    thumbElement.setAttribute('type', 'button');
	    thumbElement.className = className + '-thumb ' + CLASS_UNSELECTABLE;
	    var containerElement = this.element;
	    containerElement.className = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL;
	    containerElement.appendChild(thumbElement);
	    /**
	     * @type {PointerEventHandler}
	     * @private
	     */
	    this.dragger_ = new PointerEventHandler(containerElement);
	
	    listen(this.dragger_, PointerEventType.POINTERDOWN,
	      this.handleDraggerStart_, this);
	    listen(this.dragger_, PointerEventType.POINTERMOVE,
	      this.handleDraggerDrag_, this);
	    listen(this.dragger_, PointerEventType.POINTERUP,
	      this.handleDraggerEnd_, this);
	
	    listen(containerElement, EventType.CLICK, this.handleContainerClick_, this);
	    listen(thumbElement, EventType.CLICK, stopPropagation);
	  }
	
	  if ( Control$$1 ) { ZoomSlider.__proto__ = Control$$1; }
	  ZoomSlider.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  ZoomSlider.prototype.constructor = ZoomSlider;
	
	  /**
	   * @inheritDoc
	   */
	  ZoomSlider.prototype.disposeInternal = function disposeInternal () {
	    this.dragger_.dispose();
	    Control$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ZoomSlider.prototype.setMap = function setMap (map) {
	    Control$$1.prototype.setMap.call(this, map);
	    if (map) {
	      map.render();
	    }
	  };
	
	  /**
	   * Initializes the slider element. This will determine and set this controls
	   * direction_ and also constrain the dragging of the thumb to always be within
	   * the bounds of the container.
	   *
	   * @private
	   */
	  ZoomSlider.prototype.initSlider_ = function initSlider_ () {
	    var container = this.element;
	    var containerSize = {
	      width: container.offsetWidth, height: container.offsetHeight
	    };
	
	    var thumb = /** @type {HTMLElement} */ (container.firstElementChild);
	    var computedStyle = getComputedStyle(thumb);
	    var thumbWidth = thumb.offsetWidth +
	        parseFloat(computedStyle['marginRight']) +
	        parseFloat(computedStyle['marginLeft']);
	    var thumbHeight = thumb.offsetHeight +
	        parseFloat(computedStyle['marginTop']) +
	        parseFloat(computedStyle['marginBottom']);
	    this.thumbSize_ = [thumbWidth, thumbHeight];
	
	    if (containerSize.width > containerSize.height) {
	      this.direction_ = Direction.HORIZONTAL;
	      this.widthLimit_ = containerSize.width - thumbWidth;
	    } else {
	      this.direction_ = Direction.VERTICAL;
	      this.heightLimit_ = containerSize.height - thumbHeight;
	    }
	    this.sliderInitialized_ = true;
	  };
	
	  /**
	   * @param {MouseEvent} event The browser event to handle.
	   * @private
	   */
	  ZoomSlider.prototype.handleContainerClick_ = function handleContainerClick_ (event) {
	    var view = this.getMap().getView();
	
	    var relativePosition = this.getRelativePosition_(
	      event.offsetX - this.thumbSize_[0] / 2,
	      event.offsetY - this.thumbSize_[1] / 2);
	
	    var resolution = this.getResolutionForPosition_(relativePosition);
	
	    view.animate({
	      resolution: view.constrainResolution(resolution),
	      duration: this.duration_,
	      easing: easeOut
	    });
	  };
	
	  /**
	   * Handle dragger start events.
	   * @param {import("../pointer/PointerEvent.js").default} event The drag event.
	   * @private
	   */
	  ZoomSlider.prototype.handleDraggerStart_ = function handleDraggerStart_ (event) {
	    if (!this.dragging_ && event.originalEvent.target === this.element.firstElementChild) {
	      this.getMap().getView().setHint(ViewHint.INTERACTING, 1);
	      this.previousX_ = event.clientX;
	      this.previousY_ = event.clientY;
	      this.dragging_ = true;
	
	      if (this.dragListenerKeys_.length === 0) {
	        var drag = this.handleDraggerDrag_;
	        var end = this.handleDraggerEnd_;
	        this.dragListenerKeys_.push(
	          listen(document, EventType.MOUSEMOVE, drag, this),
	          listen(document, PointerEventType.POINTERMOVE, drag, this),
	          listen(document, EventType.MOUSEUP, end, this),
	          listen(document, PointerEventType.POINTERUP, end, this)
	        );
	      }
	    }
	  };
	
	  /**
	   * Handle dragger drag events.
	   *
	   * @param {import("../pointer/PointerEvent.js").default} event The drag event.
	   * @private
	   */
	  ZoomSlider.prototype.handleDraggerDrag_ = function handleDraggerDrag_ (event) {
	    if (this.dragging_) {
	      var element = /** @type {HTMLElement} */ (this.element.firstElementChild);
	      var deltaX = event.clientX - this.previousX_ + parseFloat(element.style.left);
	      var deltaY = event.clientY - this.previousY_ + parseFloat(element.style.top);
	      var relativePosition = this.getRelativePosition_(deltaX, deltaY);
	      this.currentResolution_ = this.getResolutionForPosition_(relativePosition);
	      this.getMap().getView().setResolution(this.currentResolution_);
	      this.setThumbPosition_(this.currentResolution_);
	      this.previousX_ = event.clientX;
	      this.previousY_ = event.clientY;
	    }
	  };
	
	  /**
	   * Handle dragger end events.
	   * @param {import("../pointer/PointerEvent.js").default} event The drag event.
	   * @private
	   */
	  ZoomSlider.prototype.handleDraggerEnd_ = function handleDraggerEnd_ (event) {
	    if (this.dragging_) {
	      var view = this.getMap().getView();
	      view.setHint(ViewHint.INTERACTING, -1);
	
	      view.animate({
	        resolution: view.constrainResolution(this.currentResolution_),
	        duration: this.duration_,
	        easing: easeOut
	      });
	
	      this.dragging_ = false;
	      this.previousX_ = undefined;
	      this.previousY_ = undefined;
	      this.dragListenerKeys_.forEach(unlistenByKey);
	      this.dragListenerKeys_.length = 0;
	    }
	  };
	
	  /**
	   * Positions the thumb inside its container according to the given resolution.
	   *
	   * @param {number} res The res.
	   * @private
	   */
	  ZoomSlider.prototype.setThumbPosition_ = function setThumbPosition_ (res) {
	    var position = this.getPositionForResolution_(res);
	    var thumb = /** @type {HTMLElement} */ (this.element.firstElementChild);
	
	    if (this.direction_ == Direction.HORIZONTAL) {
	      thumb.style.left = this.widthLimit_ * position + 'px';
	    } else {
	      thumb.style.top = this.heightLimit_ * position + 'px';
	    }
	  };
	
	  /**
	   * Calculates the relative position of the thumb given x and y offsets.  The
	   * relative position scales from 0 to 1.  The x and y offsets are assumed to be
	   * in pixel units within the dragger limits.
	   *
	   * @param {number} x Pixel position relative to the left of the slider.
	   * @param {number} y Pixel position relative to the top of the slider.
	   * @return {number} The relative position of the thumb.
	   * @private
	   */
	  ZoomSlider.prototype.getRelativePosition_ = function getRelativePosition_ (x, y) {
	    var amount;
	    if (this.direction_ === Direction.HORIZONTAL) {
	      amount = x / this.widthLimit_;
	    } else {
	      amount = y / this.heightLimit_;
	    }
	    return clamp(amount, 0, 1);
	  };
	
	  /**
	   * Calculates the corresponding resolution of the thumb given its relative
	   * position (where 0 is the minimum and 1 is the maximum).
	   *
	   * @param {number} position The relative position of the thumb.
	   * @return {number} The corresponding resolution.
	   * @private
	   */
	  ZoomSlider.prototype.getResolutionForPosition_ = function getResolutionForPosition_ (position) {
	    var fn = this.getMap().getView().getResolutionForValueFunction();
	    return fn(1 - position);
	  };
	
	  /**
	   * Determines the relative position of the slider for the given resolution.  A
	   * relative position of 0 corresponds to the minimum view resolution.  A
	   * relative position of 1 corresponds to the maximum view resolution.
	   *
	   * @param {number} res The resolution.
	   * @return {number} The relative position value (between 0 and 1).
	   * @private
	   */
	  ZoomSlider.prototype.getPositionForResolution_ = function getPositionForResolution_ (res) {
	    var fn = this.getMap().getView().getValueForResolutionFunction();
	    return 1 - fn(res);
	  };
	
	  return ZoomSlider;
	}(Control));
	
	
	/**
	 * Update the zoomslider element.
	 * @param {import("../MapEvent.js").default} mapEvent Map event.
	 * @this {ZoomSlider}
	 * @api
	 */
	function render$5(mapEvent) {
	  if (!mapEvent.frameState) {
	    return;
	  }
	  if (!this.sliderInitialized_) {
	    this.initSlider_();
	  }
	  var res = mapEvent.frameState.viewState.resolution;
	  if (res !== this.currentResolution_) {
	    this.currentResolution_ = res;
	    this.setThumbPosition_(res);
	  }
	}
	
	/**
	 * @module ol/control/ZoomToExtent
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [className='ol-zoom-extent'] Class name.
	 * @property {HTMLElement|string} [target] Specify a target if you want the control
	 * to be rendered outside of the map's viewport.
	 * @property {string|HTMLElement} [label='E'] Text label to use for the button.
	 * Instead of text, also an element (e.g. a `span` element) can be used.
	 * @property {string} [tipLabel='Fit to extent'] Text label to use for the button tip.
	 * @property {import("../extent.js").Extent} [extent] The extent to zoom to. If undefined the validity
	 * extent of the view projection is used.
	 */
	
	
	/**
	 * @classdesc
	 * A button control which, when pressed, changes the map view to a specific
	 * extent. To style this control use the css selector `.ol-zoom-extent`.
	 *
	 * @api
	 */
	var ZoomToExtent = /*@__PURE__*/(function (Control$$1) {
	  function ZoomToExtent(opt_options) {
	    var options = opt_options ? opt_options : {};
	
	    Control$$1.call(this, {
	      element: document.createElement('div'),
	      target: options.target
	    });
	
	    /**
	     * @type {import("../extent.js").Extent}
	     * @protected
	     */
	    this.extent = options.extent ? options.extent : null;
	
	    var className = options.className !== undefined ? options.className : 'ol-zoom-extent';
	
	    var label = options.label !== undefined ? options.label : 'E';
	    var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Fit to extent';
	    var button = document.createElement('button');
	    button.setAttribute('type', 'button');
	    button.title = tipLabel;
	    button.appendChild(
	      typeof label === 'string' ? document.createTextNode(label) : label
	    );
	
	    listen(button, EventType.CLICK, this.handleClick_, this);
	
	    var cssClasses = className + ' ' + CLASS_UNSELECTABLE + ' ' + CLASS_CONTROL;
	    var element = this.element;
	    element.className = cssClasses;
	    element.appendChild(button);
	  }
	
	  if ( Control$$1 ) { ZoomToExtent.__proto__ = Control$$1; }
	  ZoomToExtent.prototype = Object.create( Control$$1 && Control$$1.prototype );
	  ZoomToExtent.prototype.constructor = ZoomToExtent;
	
	  /**
	   * @param {MouseEvent} event The event to handle
	   * @private
	   */
	  ZoomToExtent.prototype.handleClick_ = function handleClick_ (event) {
	    event.preventDefault();
	    this.handleZoomToExtent();
	  };
	
	  /**
	   * @protected
	   */
	  ZoomToExtent.prototype.handleZoomToExtent = function handleZoomToExtent () {
	    var map = this.getMap();
	    var view = map.getView();
	    var extent = !this.extent ? view.getProjection().getExtent() : this.extent;
	    view.fit(extent);
	  };
	
	  return ZoomToExtent;
	}(Control));
	
	/**
	 * @module ol/control
	 */
	
	/**
	 * @module ol/webgl/Shader
	 */
	
	/**
	 * @abstract
	 */
	var WebGLShader = function WebGLShader(source) {
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this.source_ = source;
	
	};
	
	/**
	 * @return {boolean} Is animated?
	 */
	WebGLShader.prototype.isAnimated = function isAnimated () {
	  return false;
	};
	
	/**
	 * @abstract
	 * @return {number} Type.
	 */
	WebGLShader.prototype.getType = function getType () {
	  return abstract();
	};
	
	/**
	 * @return {string} Source.
	 */
	WebGLShader.prototype.getSource = function getSource () {
	  return this.source_;
	};
	
	/**
	 * @module ol/webgl/Fragment
	 */
	
	var WebGLFragment = /*@__PURE__*/(function (WebGLShader$$1) {
	  function WebGLFragment(source) {
	    WebGLShader$$1.call(this, source);
	  }
	
	  if ( WebGLShader$$1 ) { WebGLFragment.__proto__ = WebGLShader$$1; }
	  WebGLFragment.prototype = Object.create( WebGLShader$$1 && WebGLShader$$1.prototype );
	  WebGLFragment.prototype.constructor = WebGLFragment;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLFragment.prototype.getType = function getType () {
	    return FRAGMENT_SHADER;
	  };
	
	  return WebGLFragment;
	}(WebGLShader));
	
	/**
	 * @module ol/webgl/Vertex
	 */
	
	var WebGLVertex = /*@__PURE__*/(function (WebGLShader$$1) {
	  function WebGLVertex(source) {
	    WebGLShader$$1.call(this, source);
	  }
	
	  if ( WebGLShader$$1 ) { WebGLVertex.__proto__ = WebGLShader$$1; }
	  WebGLVertex.prototype = Object.create( WebGLShader$$1 && WebGLShader$$1.prototype );
	  WebGLVertex.prototype.constructor = WebGLVertex;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVertex.prototype.getType = function getType () {
	    return VERTEX_SHADER;
	  };
	
	  return WebGLVertex;
	}(WebGLShader));
	
	/**
	 * @module ol/render/webgl/circlereplay/defaultshader
	 */
	
	var fragment = new WebGLFragment('precision mediump float;\nvarying vec2 v_center;\nvarying vec2 v_offset;\nvarying float v_halfWidth;\nvarying float v_pixelRatio;\n\n\n\nuniform float u_opacity;\nuniform vec4 u_fillColor;\nuniform vec4 u_strokeColor;\nuniform vec2 u_size;\n\nvoid main(void) {\n  vec2 windowCenter = vec2((v_center.x + 1.0) / 2.0 * u_size.x * v_pixelRatio,\n      (v_center.y + 1.0) / 2.0 * u_size.y * v_pixelRatio);\n  vec2 windowOffset = vec2((v_offset.x + 1.0) / 2.0 * u_size.x * v_pixelRatio,\n      (v_offset.y + 1.0) / 2.0 * u_size.y * v_pixelRatio);\n  float radius = length(windowCenter - windowOffset);\n  float dist = length(windowCenter - gl_FragCoord.xy);\n  if (dist > radius + v_halfWidth) {\n    if (u_strokeColor.a == 0.0) {\n      gl_FragColor = u_fillColor;\n    } else {\n      gl_FragColor = u_strokeColor;\n    }\n    gl_FragColor.a = gl_FragColor.a - (dist - (radius + v_halfWidth));\n  } else if (u_fillColor.a == 0.0) {\n    // Hooray, no fill, just stroke. We can use real antialiasing.\n    gl_FragColor = u_strokeColor;\n    if (dist < radius - v_halfWidth) {\n      gl_FragColor.a = gl_FragColor.a - (radius - v_halfWidth - dist);\n    }\n  } else {\n    gl_FragColor = u_fillColor;\n    float strokeDist = radius - v_halfWidth;\n    float antialias = 2.0 * v_pixelRatio;\n    if (dist > strokeDist) {\n      gl_FragColor = u_strokeColor;\n    } else if (dist >= strokeDist - antialias) {\n      float step = smoothstep(strokeDist - antialias, strokeDist, dist);\n      gl_FragColor = mix(u_fillColor, u_strokeColor, step);\n    }\n  }\n  gl_FragColor.a = gl_FragColor.a * u_opacity;\n  if (gl_FragColor.a <= 0.0) {\n    discard;\n  }\n}\n');
	
	var vertex = new WebGLVertex('varying vec2 v_center;\nvarying vec2 v_offset;\nvarying float v_halfWidth;\nvarying float v_pixelRatio;\n\n\nattribute vec2 a_position;\nattribute float a_instruction;\nattribute float a_radius;\n\nuniform mat4 u_projectionMatrix;\nuniform mat4 u_offsetScaleMatrix;\nuniform mat4 u_offsetRotateMatrix;\nuniform float u_lineWidth;\nuniform float u_pixelRatio;\n\nvoid main(void) {\n  mat4 offsetMatrix = u_offsetScaleMatrix * u_offsetRotateMatrix;\n  v_center = vec4(u_projectionMatrix * vec4(a_position, 0.0, 1.0)).xy;\n  v_pixelRatio = u_pixelRatio;\n  float lineWidth = u_lineWidth * u_pixelRatio;\n  v_halfWidth = lineWidth / 2.0;\n  if (lineWidth == 0.0) {\n    lineWidth = 2.0 * u_pixelRatio;\n  }\n  vec2 offset;\n  // Radius with anitaliasing (roughly).\n  float radius = a_radius + 3.0 * u_pixelRatio;\n  // Until we get gl_VertexID in WebGL, we store an instruction.\n  if (a_instruction == 0.0) {\n    // Offsetting the edges of the triangle by lineWidth / 2 is necessary, however\n    // we should also leave some space for the antialiasing, thus we offset by lineWidth.\n    offset = vec2(-1.0, 1.0);\n  } else if (a_instruction == 1.0) {\n    offset = vec2(-1.0, -1.0);\n  } else if (a_instruction == 2.0) {\n    offset = vec2(1.0, -1.0);\n  } else {\n    offset = vec2(1.0, 1.0);\n  }\n\n  gl_Position = u_projectionMatrix * vec4(a_position + offset * radius, 0.0, 1.0) +\n      offsetMatrix * vec4(offset * lineWidth, 0.0, 0.0);\n  v_offset = vec4(u_projectionMatrix * vec4(a_position.x + a_radius, a_position.y,\n      0.0, 1.0)).xy;\n\n  if (distance(v_center, v_offset) > 20000.0) {\n    gl_Position = vec4(v_center, 0.0, 1.0);\n  }\n}\n\n\n');
	
	/**
	 * @module ol/render/webgl/circlereplay/defaultshader/Locations
	 */
	
	var Locations = function Locations(gl, program) {
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_projectionMatrix = gl.getUniformLocation(
	    program, 'u_projectionMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetScaleMatrix = gl.getUniformLocation(
	    program, 'u_offsetScaleMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetRotateMatrix = gl.getUniformLocation(
	    program, 'u_offsetRotateMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_lineWidth = gl.getUniformLocation(
	    program, 'u_lineWidth');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_pixelRatio = gl.getUniformLocation(
	    program, 'u_pixelRatio');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_opacity = gl.getUniformLocation(
	    program, 'u_opacity');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_fillColor = gl.getUniformLocation(
	    program, 'u_fillColor');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_strokeColor = gl.getUniformLocation(
	    program, 'u_strokeColor');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_size = gl.getUniformLocation(
	    program, 'u_size');
	
	  /**
	   * @type {number}
	   */
	  this.a_position = gl.getAttribLocation(
	    program, 'a_position');
	
	  /**
	   * @type {number}
	   */
	  this.a_instruction = gl.getAttribLocation(
	    program, 'a_instruction');
	
	  /**
	   * @type {number}
	   */
	  this.a_radius = gl.getAttribLocation(
	    program, 'a_radius');
	
	};
	
	/**
	 * @module ol/vec/mat4
	 */
	
	
	/**
	 * @return {Array<number>} 4x4 matrix representing a 3D identity transform.
	 */
	function create$1() {
	  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	}
	
	
	/**
	 * @param {Array<number>} mat4 Flattened 4x4 matrix receiving the result.
	 * @param {import("../transform.js").Transform} transform Transformation matrix.
	 * @return {Array<number>} 2D transformation matrix as flattened 4x4 matrix.
	 */
	function fromTransform(mat4, transform) {
	  mat4[0] = transform[0];
	  mat4[1] = transform[1];
	  mat4[4] = transform[2];
	  mat4[5] = transform[3];
	  mat4[12] = transform[4];
	  mat4[13] = transform[5];
	  return mat4;
	}
	
	/**
	 * @module ol/render/webgl/Replay
	 */
	
	var WebGLReplay = /*@__PURE__*/(function (VectorContext$$1) {
	  function WebGLReplay(tolerance, maxExtent) {
	    VectorContext$$1.call(this);
	
	    /**
	     * @protected
	     * @type {number}
	     */
	    this.tolerance = tolerance;
	
	    /**
	     * @protected
	     * @const
	     * @type {import("../../extent.js").Extent}
	     */
	    this.maxExtent = maxExtent;
	
	    /**
	     * The origin of the coordinate system for the point coordinates sent to
	     * the GPU. To eliminate jitter caused by precision problems in the GPU
	     * we use the "Rendering Relative to Eye" technique described in the "3D
	     * Engine Design for Virtual Globes" book.
	     * @protected
	     * @type {import("../../coordinate.js").Coordinate}
	     */
	    this.origin = getCenter(maxExtent);
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.projectionMatrix_ = create();
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.offsetRotateMatrix_ = create();
	
	    /**
	     * @private
	     * @type {import("../../transform.js").Transform}
	     */
	    this.offsetScaleMatrix_ = create();
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.tmpMat4_ = create$1();
	
	    /**
	     * @protected
	     * @type {Array<number>}
	     */
	    this.indices = [];
	
	    /**
	     * @protected
	     * @type {?import("../../webgl/Buffer.js").default}
	     */
	    this.indicesBuffer = null;
	
	    /**
	     * Start index per feature (the index).
	     * @protected
	     * @type {Array<number>}
	     */
	    this.startIndices = [];
	
	    /**
	     * Start index per feature (the feature).
	     * @protected
	     * @type {Array<import("../../Feature.js").default|import("../Feature.js").default>}
	     */
	    this.startIndicesFeature = [];
	
	    /**
	     * @protected
	     * @type {Array<number>}
	     */
	    this.vertices = [];
	
	    /**
	     * @protected
	     * @type {?import("../../webgl/Buffer.js").default}
	     */
	    this.verticesBuffer = null;
	
	    /**
	     * Optional parameter for PolygonReplay instances.
	     * @protected
	     * @type {import("./LineStringReplay.js").default|undefined}
	     */
	    this.lineStringReplay = undefined;
	
	  }
	
	  if ( VectorContext$$1 ) { WebGLReplay.__proto__ = VectorContext$$1; }
	  WebGLReplay.prototype = Object.create( VectorContext$$1 && VectorContext$$1.prototype );
	  WebGLReplay.prototype.constructor = WebGLReplay;
	
	  /**
	   * @abstract
	   * @param {import("../../webgl/Context.js").default} context WebGL context.
	   * @return {function()} Delete resources function.
	   */
	  WebGLReplay.prototype.getDeleteResourcesFunction = function getDeleteResourcesFunction (context) {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @param {import("../../webgl/Context.js").default} context Context.
	   */
	  WebGLReplay.prototype.finish = function finish (context) {
	    abstract();
	  };
	
	  /**
	   * @abstract
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {import("../../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @return {import("./circlereplay/defaultshader/Locations.js").default|
	     import("./linestringreplay/defaultshader/Locations.js").default|
	     import("./polygonreplay/defaultshader/Locations.js").default|
	     import("./texturereplay/defaultshader/Locations.js").default} Locations.
	   */
	  WebGLReplay.prototype.setUpProgram = function setUpProgram (gl, context, size, pixelRatio) {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("./circlereplay/defaultshader/Locations.js").default|
	     import("./linestringreplay/defaultshader/Locations.js").default|
	     import("./polygonreplay/defaultshader/Locations.js").default|
	     import("./texturereplay/defaultshader/Locations.js").default} locations Locations.
	   */
	  WebGLReplay.prototype.shutDownProgram = function shutDownProgram (gl, locations) {
	    abstract();
	  };
	
	  /**
	   * @abstract
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {boolean} hitDetection Hit detection mode.
	   */
	  WebGLReplay.prototype.drawReplay = function drawReplay (gl, context, skippedFeaturesHash, hitDetection) {
	    abstract();
	  };
	
	  /**
	   * @abstract
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
	   * @param {import("../../extent.js").Extent=} opt_hitExtent Hit extent: Only features intersecting this extent are checked.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  WebGLReplay.prototype.drawHitDetectionReplayOneByOne = function drawHitDetectionReplayOneByOne (gl, context, skippedFeaturesHash, featureCallback, opt_hitExtent) {
	    return abstract();
	  };
	
	  /**
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
	   * @param {boolean} oneByOne Draw features one-by-one for the hit-detecion.
	   * @param {import("../../extent.js").Extent=} opt_hitExtent Hit extent: Only features intersecting this extent are checked.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  WebGLReplay.prototype.drawHitDetectionReplay = function drawHitDetectionReplay (gl, context, skippedFeaturesHash, featureCallback, oneByOne, opt_hitExtent) {
	    if (!oneByOne) {
	      // draw all hit-detection features in "once" (by texture group)
	      return this.drawHitDetectionReplayAll(gl, context,
	        skippedFeaturesHash, featureCallback);
	    } else {
	      // draw hit-detection features one by one
	      return this.drawHitDetectionReplayOneByOne(gl, context,
	        skippedFeaturesHash, featureCallback, opt_hitExtent);
	    }
	  };
	
	  /**
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  WebGLReplay.prototype.drawHitDetectionReplayAll = function drawHitDetectionReplayAll (gl, context, skippedFeaturesHash, featureCallback) {
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	    this.drawReplay(gl, context, skippedFeaturesHash, true);
	
	    var result = featureCallback(null);
	    if (result) {
	      return result;
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {import("../../coordinate.js").Coordinate} center Center.
	   * @param {number} resolution Resolution.
	   * @param {number} rotation Rotation.
	   * @param {import("../../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {number} opacity Global opacity.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
	   * @param {boolean} oneByOne Draw features one-by-one for the hit-detecion.
	   * @param {import("../../extent.js").Extent=} opt_hitExtent Hit extent: Only features intersecting this extent are checked.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  WebGLReplay.prototype.replay = function replay (
	    context,
	    center,
	    resolution,
	    rotation,
	    size,
	    pixelRatio,
	    opacity,
	    skippedFeaturesHash,
	    featureCallback,
	    oneByOne,
	    opt_hitExtent
	  ) {
	    var gl = context.getGL();
	    var tmpStencil, tmpStencilFunc, tmpStencilMaskVal, tmpStencilRef, tmpStencilMask,
	        tmpStencilOpFail, tmpStencilOpPass, tmpStencilOpZFail;
	
	    if (this.lineStringReplay) {
	      tmpStencil = gl.isEnabled(gl.STENCIL_TEST);
	      tmpStencilFunc = gl.getParameter(gl.STENCIL_FUNC);
	      tmpStencilMaskVal = gl.getParameter(gl.STENCIL_VALUE_MASK);
	      tmpStencilRef = gl.getParameter(gl.STENCIL_REF);
	      tmpStencilMask = gl.getParameter(gl.STENCIL_WRITEMASK);
	      tmpStencilOpFail = gl.getParameter(gl.STENCIL_FAIL);
	      tmpStencilOpPass = gl.getParameter(gl.STENCIL_PASS_DEPTH_PASS);
	      tmpStencilOpZFail = gl.getParameter(gl.STENCIL_PASS_DEPTH_FAIL);
	
	      gl.enable(gl.STENCIL_TEST);
	      gl.clear(gl.STENCIL_BUFFER_BIT);
	      gl.stencilMask(255);
	      gl.stencilFunc(gl.ALWAYS, 1, 255);
	      gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
	
	      this.lineStringReplay.replay(context,
	        center, resolution, rotation, size, pixelRatio,
	        opacity, skippedFeaturesHash,
	        featureCallback, oneByOne, opt_hitExtent);
	
	      gl.stencilMask(0);
	      gl.stencilFunc(gl.NOTEQUAL, 1, 255);
	    }
	
	    context.bindBuffer(ARRAY_BUFFER, this.verticesBuffer);
	
	    context.bindBuffer(ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
	
	    var locations = this.setUpProgram(gl, context, size, pixelRatio);
	
	    // set the "uniform" values
	    var projectionMatrix = reset(this.projectionMatrix_);
	    scale$1(projectionMatrix, 2 / (resolution * size[0]), 2 / (resolution * size[1]));
	    rotate$1(projectionMatrix, -rotation);
	    translate$1(projectionMatrix, -(center[0] - this.origin[0]), -(center[1] - this.origin[1]));
	
	    var offsetScaleMatrix = reset(this.offsetScaleMatrix_);
	    scale$1(offsetScaleMatrix, 2 / size[0], 2 / size[1]);
	
	    var offsetRotateMatrix = reset(this.offsetRotateMatrix_);
	    if (rotation !== 0) {
	      rotate$1(offsetRotateMatrix, -rotation);
	    }
	
	    gl.uniformMatrix4fv(locations.u_projectionMatrix, false,
	      fromTransform(this.tmpMat4_, projectionMatrix));
	    gl.uniformMatrix4fv(locations.u_offsetScaleMatrix, false,
	      fromTransform(this.tmpMat4_, offsetScaleMatrix));
	    gl.uniformMatrix4fv(locations.u_offsetRotateMatrix, false,
	      fromTransform(this.tmpMat4_, offsetRotateMatrix));
	    gl.uniform1f(locations.u_opacity, opacity);
	
	    // draw!
	    var result;
	    if (featureCallback === undefined) {
	      this.drawReplay(gl, context, skippedFeaturesHash, false);
	    } else {
	      // draw feature by feature for the hit-detection
	      result = this.drawHitDetectionReplay(gl, context, skippedFeaturesHash,
	        featureCallback, oneByOne, opt_hitExtent);
	    }
	
	    // disable the vertex attrib arrays
	    this.shutDownProgram(gl, locations);
	
	    if (this.lineStringReplay) {
	      if (!tmpStencil) {
	        gl.disable(gl.STENCIL_TEST);
	      }
	      gl.clear(gl.STENCIL_BUFFER_BIT);
	      gl.stencilFunc(/** @type {number} */ (tmpStencilFunc),
	        /** @type {number} */ (tmpStencilRef), /** @type {number} */ (tmpStencilMaskVal));
	      gl.stencilMask(/** @type {number} */ (tmpStencilMask));
	      gl.stencilOp(/** @type {number} */ (tmpStencilOpFail),
	        /** @type {number} */ (tmpStencilOpZFail), /** @type {number} */ (tmpStencilOpPass));
	    }
	
	    return result;
	  };
	
	  /**
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {number} start Start index.
	   * @param {number} end End index.
	   */
	  WebGLReplay.prototype.drawElements = function drawElements (gl, context, start, end) {
	    var elementType = context.hasOESElementIndexUint ?
	      UNSIGNED_INT : UNSIGNED_SHORT;
	    var elementSize = context.hasOESElementIndexUint ? 4 : 2;
	
	    var numItems = end - start;
	    var offsetInBytes = start * elementSize;
	    gl.drawElements(TRIANGLES, numItems, elementType, offsetInBytes);
	  };
	
	  return WebGLReplay;
	}(VectorContext));
	
	/**
	 * @module ol/render/webgl
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var DEFAULT_FONT = '10px sans-serif';
	
	
	/**
	 * @const
	 * @type {import("../color.js").Color}
	 */
	var DEFAULT_FILLSTYLE = [0.0, 0.0, 0.0, 1.0];
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var DEFAULT_LINECAP = 'round';
	
	
	/**
	 * @const
	 * @type {Array<number>}
	 */
	var DEFAULT_LINEDASH = [];
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DEFAULT_LINEDASHOFFSET = 0;
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var DEFAULT_LINEJOIN = 'round';
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DEFAULT_MITERLIMIT = 10;
	
	/**
	 * @const
	 * @type {import("../color.js").Color}
	 */
	var DEFAULT_STROKESTYLE = [0.0, 0.0, 0.0, 1.0];
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DEFAULT_TEXTALIGN = 0.5;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DEFAULT_TEXTBASELINE = 0.5;
	
	
	/**
	 * @const
	 * @type {number}
	 */
	var DEFAULT_LINEWIDTH = 1;
	
	/**
	 * @const
	 * @type {number}
	 */
	var EPSILON = Number.EPSILON || 2.220446049250313e-16;
	
	/**
	 * Calculates the orientation of a triangle based on the determinant method.
	 * @param {number} x1 First X coordinate.
	 * @param {number} y1 First Y coordinate.
	 * @param {number} x2 Second X coordinate.
	 * @param {number} y2 Second Y coordinate.
	 * @param {number} x3 Third X coordinate.
	 * @param {number} y3 Third Y coordinate.
	 * @return {boolean|undefined} Triangle is clockwise.
	 */
	var triangleIsCounterClockwise = function(x1, y1, x2, y2, x3, y3) {
	  var area = (x2 - x1) * (y3 - y1) - (x3 - x1) * (y2 - y1);
	  return (area <= EPSILON && area >= -EPSILON) ?
	    undefined : area > 0;
	};
	
	/**
	 * @module ol/webgl/Buffer
	 */
	
	/**
	 * @enum {number}
	 */
	var BufferUsage = {
	  STATIC_DRAW: STATIC_DRAW,
	  STREAM_DRAW: STREAM_DRAW,
	  DYNAMIC_DRAW: DYNAMIC_DRAW
	};
	
	
	var WebGLBuffer = function WebGLBuffer(opt_arr, opt_usage) {
	
	  /**
	   * @private
	   * @type {Array<number>}
	   */
	  this.arr_ = opt_arr !== undefined ? opt_arr : [];
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.usage_ = opt_usage !== undefined ? opt_usage : BufferUsage.STATIC_DRAW;
	
	};
	
	/**
	 * @return {Array<number>} Array.
	 */
	WebGLBuffer.prototype.getArray = function getArray () {
	  return this.arr_;
	};
	
	/**
	 * @return {number} Usage.
	 */
	WebGLBuffer.prototype.getUsage = function getUsage () {
	  return this.usage_;
	};
	
	/**
	 * @module ol/render/webgl/CircleReplay
	 */
	
	var WebGLCircleReplay = /*@__PURE__*/(function (WebGLReplay$$1) {
	  function WebGLCircleReplay(tolerance, maxExtent) {
	    WebGLReplay$$1.call(this, tolerance, maxExtent);
	
	    /**
	     * @private
	     * @type {import("./circlereplay/defaultshader/Locations.js").default}
	     */
	    this.defaultLocations_ = null;
	
	    /**
	     * @private
	     * @type {Array<Array<Array<number>|number>>}
	     */
	    this.styles_ = [];
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.styleIndices_ = [];
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.radius_ = 0;
	
	    /**
	     * @private
	     * @type {{fillColor: (Array<number>|null),
	     *         strokeColor: (Array<number>|null),
	     *         lineDash: Array<number>,
	     *         lineDashOffset: (number|undefined),
	     *         lineWidth: (number|undefined),
	     *         changed: boolean}|null}
	     */
	    this.state_ = {
	      fillColor: null,
	      strokeColor: null,
	      lineDash: null,
	      lineDashOffset: undefined,
	      lineWidth: undefined,
	      changed: false
	    };
	
	  }
	
	  if ( WebGLReplay$$1 ) { WebGLCircleReplay.__proto__ = WebGLReplay$$1; }
	  WebGLCircleReplay.prototype = Object.create( WebGLReplay$$1 && WebGLReplay$$1.prototype );
	  WebGLCircleReplay.prototype.constructor = WebGLCircleReplay;
	
	  /**
	   * @private
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   */
	  WebGLCircleReplay.prototype.drawCoordinates_ = function drawCoordinates_ (flatCoordinates, offset, end, stride) {
	    var numVertices = this.vertices.length;
	    var numIndices = this.indices.length;
	    var n = numVertices / 4;
	    var i, ii;
	    for (i = offset, ii = end; i < ii; i += stride) {
	      this.vertices[numVertices++] = flatCoordinates[i];
	      this.vertices[numVertices++] = flatCoordinates[i + 1];
	      this.vertices[numVertices++] = 0;
	      this.vertices[numVertices++] = this.radius_;
	
	      this.vertices[numVertices++] = flatCoordinates[i];
	      this.vertices[numVertices++] = flatCoordinates[i + 1];
	      this.vertices[numVertices++] = 1;
	      this.vertices[numVertices++] = this.radius_;
	
	      this.vertices[numVertices++] = flatCoordinates[i];
	      this.vertices[numVertices++] = flatCoordinates[i + 1];
	      this.vertices[numVertices++] = 2;
	      this.vertices[numVertices++] = this.radius_;
	
	      this.vertices[numVertices++] = flatCoordinates[i];
	      this.vertices[numVertices++] = flatCoordinates[i + 1];
	      this.vertices[numVertices++] = 3;
	      this.vertices[numVertices++] = this.radius_;
	
	      this.indices[numIndices++] = n;
	      this.indices[numIndices++] = n + 1;
	      this.indices[numIndices++] = n + 2;
	
	      this.indices[numIndices++] = n + 2;
	      this.indices[numIndices++] = n + 3;
	      this.indices[numIndices++] = n;
	
	      n += 4;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.drawCircle = function drawCircle (circleGeometry, feature) {
	    var radius = circleGeometry.getRadius();
	    var stride = circleGeometry.getStride();
	    if (radius) {
	      this.startIndices.push(this.indices.length);
	      this.startIndicesFeature.push(feature);
	      if (this.state_.changed) {
	        this.styleIndices_.push(this.indices.length);
	        this.state_.changed = false;
	      }
	
	      this.radius_ = radius;
	      var flatCoordinates = circleGeometry.getFlatCoordinates();
	      flatCoordinates = translate(flatCoordinates, 0, 2,
	        stride, -this.origin[0], -this.origin[1]);
	      this.drawCoordinates_(flatCoordinates, 0, 2, stride);
	    } else {
	      if (this.state_.changed) {
	        this.styles_.pop();
	        if (this.styles_.length) {
	          var lastState = this.styles_[this.styles_.length - 1];
	          this.state_.fillColor = /** @type {Array<number>} */ (lastState[0]);
	          this.state_.strokeColor = /** @type {Array<number>} */ (lastState[1]);
	          this.state_.lineWidth = /** @type {number} */ (lastState[2]);
	          this.state_.changed = false;
	        }
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   **/
	  WebGLCircleReplay.prototype.finish = function finish (context) {
	    // create, bind, and populate the vertices buffer
	    this.verticesBuffer = new WebGLBuffer(this.vertices);
	
	    // create, bind, and populate the indices buffer
	    this.indicesBuffer = new WebGLBuffer(this.indices);
	
	    this.startIndices.push(this.indices.length);
	
	    //Clean up, if there is nothing to draw
	    if (this.styleIndices_.length === 0 && this.styles_.length > 0) {
	      this.styles_ = [];
	    }
	
	    this.vertices = null;
	    this.indices = null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.getDeleteResourcesFunction = function getDeleteResourcesFunction (context) {
	    // We only delete our stuff here. The shaders and the program may
	    // be used by other CircleReplay instances (for other layers). And
	    // they will be deleted when disposing of the import("../../webgl/Context.js").WebGLContext
	    // object.
	    var verticesBuffer = this.verticesBuffer;
	    var indicesBuffer = this.indicesBuffer;
	    return function() {
	      context.deleteBuffer(verticesBuffer);
	      context.deleteBuffer(indicesBuffer);
	    };
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.setUpProgram = function setUpProgram (gl, context, size, pixelRatio) {
	    // get the program
	    var program = context.getProgram(fragment, vertex);
	
	    // get the locations
	    var locations;
	    if (!this.defaultLocations_) {
	      locations = new Locations(gl, program);
	      this.defaultLocations_ = locations;
	    } else {
	      locations = this.defaultLocations_;
	    }
	
	    context.useProgram(program);
	
	    // enable the vertex attrib arrays
	    gl.enableVertexAttribArray(locations.a_position);
	    gl.vertexAttribPointer(locations.a_position, 2, FLOAT,
	      false, 16, 0);
	
	    gl.enableVertexAttribArray(locations.a_instruction);
	    gl.vertexAttribPointer(locations.a_instruction, 1, FLOAT,
	      false, 16, 8);
	
	    gl.enableVertexAttribArray(locations.a_radius);
	    gl.vertexAttribPointer(locations.a_radius, 1, FLOAT,
	      false, 16, 12);
	
	    // Enable renderer specific uniforms.
	    gl.uniform2fv(locations.u_size, size);
	    gl.uniform1f(locations.u_pixelRatio, pixelRatio);
	
	    return locations;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.shutDownProgram = function shutDownProgram (gl, locations) {
	    gl.disableVertexAttribArray(locations.a_position);
	    gl.disableVertexAttribArray(locations.a_instruction);
	    gl.disableVertexAttribArray(locations.a_radius);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.drawReplay = function drawReplay (gl, context, skippedFeaturesHash, hitDetection) {
	    if (!isEmpty(skippedFeaturesHash)) {
	      this.drawReplaySkipping_(gl, context, skippedFeaturesHash);
	    } else {
	      //Draw by style groups to minimize drawElements() calls.
	      var i, start, end, nextStyle;
	      end = this.startIndices[this.startIndices.length - 1];
	      for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	        start = this.styleIndices_[i];
	        nextStyle = this.styles_[i];
	        this.setFillStyle_(gl, /** @type {Array<number>} */ (nextStyle[0]));
	        this.setStrokeStyle_(gl, /** @type {Array<number>} */ (nextStyle[1]),
	          /** @type {number} */ (nextStyle[2]));
	        this.drawElements(gl, context, start, end);
	        end = start;
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.drawHitDetectionReplayOneByOne = function drawHitDetectionReplayOneByOne (gl, context, skippedFeaturesHash, featureCallback, opt_hitExtent) {
	    var i, start, end, nextStyle, groupStart, feature, featureIndex;
	    featureIndex = this.startIndices.length - 2;
	    end = this.startIndices[featureIndex + 1];
	    for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	      nextStyle = this.styles_[i];
	      this.setFillStyle_(gl, /** @type {Array<number>} */ (nextStyle[0]));
	      this.setStrokeStyle_(gl, /** @type {Array<number>} */ (nextStyle[1]),
	        /** @type {number} */ (nextStyle[2]));
	      groupStart = this.styleIndices_[i];
	
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        start = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)] === undefined &&
	            feature.getGeometry() &&
	            (opt_hitExtent === undefined || intersects(
	              /** @type {Array<number>} */ (opt_hitExtent),
	              feature.getGeometry().getExtent()))) {
	          gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	          this.drawElements(gl, context, start, end);
	
	          var result = featureCallback(feature);
	
	          if (result) {
	            return result;
	          }
	
	        }
	        featureIndex--;
	        end = start;
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object} skippedFeaturesHash Ids of features to skip.
	   */
	  WebGLCircleReplay.prototype.drawReplaySkipping_ = function drawReplaySkipping_ (gl, context, skippedFeaturesHash) {
	    var i, start, end, nextStyle, groupStart, feature, featureIndex, featureStart;
	    featureIndex = this.startIndices.length - 2;
	    end = start = this.startIndices[featureIndex + 1];
	    for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	      nextStyle = this.styles_[i];
	      this.setFillStyle_(gl, /** @type {Array<number>} */ (nextStyle[0]));
	      this.setStrokeStyle_(gl, /** @type {Array<number>} */ (nextStyle[1]),
	        /** @type {number} */ (nextStyle[2]));
	      groupStart = this.styleIndices_[i];
	
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        featureStart = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)]) {
	          if (start !== end) {
	            this.drawElements(gl, context, start, end);
	          }
	          end = featureStart;
	        }
	        featureIndex--;
	        start = featureStart;
	      }
	      if (start !== end) {
	        this.drawElements(gl, context, start, end);
	      }
	      start = end = groupStart;
	    }
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {Array<number>} color Color.
	   */
	  WebGLCircleReplay.prototype.setFillStyle_ = function setFillStyle_ (gl, color) {
	    gl.uniform4fv(this.defaultLocations_.u_fillColor, color);
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {Array<number>} color Color.
	   * @param {number} lineWidth Line width.
	   */
	  WebGLCircleReplay.prototype.setStrokeStyle_ = function setStrokeStyle_ (gl, color, lineWidth) {
	    gl.uniform4fv(this.defaultLocations_.u_strokeColor, color);
	    gl.uniform1f(this.defaultLocations_.u_lineWidth, lineWidth);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLCircleReplay.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {
	    var strokeStyleColor, strokeStyleWidth;
	    if (strokeStyle) {
	      var strokeStyleLineDash = strokeStyle.getLineDash();
	      this.state_.lineDash = strokeStyleLineDash ?
	        strokeStyleLineDash : DEFAULT_LINEDASH;
	      var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
	      this.state_.lineDashOffset = strokeStyleLineDashOffset ?
	        strokeStyleLineDashOffset : DEFAULT_LINEDASHOFFSET;
	      strokeStyleColor = strokeStyle.getColor();
	      if (!(strokeStyleColor instanceof CanvasGradient) &&
	          !(strokeStyleColor instanceof CanvasPattern)) {
	        strokeStyleColor = asArray(strokeStyleColor).map(function(c, i) {
	          return i != 3 ? c / 255 : c;
	        }) || DEFAULT_STROKESTYLE;
	      } else {
	        strokeStyleColor = DEFAULT_STROKESTYLE;
	      }
	      strokeStyleWidth = strokeStyle.getWidth();
	      strokeStyleWidth = strokeStyleWidth !== undefined ?
	        strokeStyleWidth : DEFAULT_LINEWIDTH;
	    } else {
	      strokeStyleColor = [0, 0, 0, 0];
	      strokeStyleWidth = 0;
	    }
	    var fillStyleColor = fillStyle ? fillStyle.getColor() : [0, 0, 0, 0];
	    if (!(fillStyleColor instanceof CanvasGradient) &&
	        !(fillStyleColor instanceof CanvasPattern)) {
	      fillStyleColor = asArray(fillStyleColor).map(function(c, i) {
	        return i != 3 ? c / 255 : c;
	      }) || DEFAULT_FILLSTYLE;
	    } else {
	      fillStyleColor = DEFAULT_FILLSTYLE;
	    }
	    if (!this.state_.strokeColor || !equals(this.state_.strokeColor, strokeStyleColor) ||
	        !this.state_.fillColor || !equals(this.state_.fillColor, fillStyleColor) ||
	        this.state_.lineWidth !== strokeStyleWidth) {
	      this.state_.changed = true;
	      this.state_.fillColor = fillStyleColor;
	      this.state_.strokeColor = strokeStyleColor;
	      this.state_.lineWidth = strokeStyleWidth;
	      this.styles_.push([fillStyleColor, strokeStyleColor, strokeStyleWidth]);
	    }
	  };
	
	  return WebGLCircleReplay;
	}(WebGLReplay));
	
	/**
	 * @module ol/render/webgl/texturereplay/defaultshader
	 */
	
	var fragment$1 = new WebGLFragment('precision mediump float;\nvarying vec2 v_texCoord;\nvarying float v_opacity;\n\nuniform float u_opacity;\nuniform sampler2D u_image;\n\nvoid main(void) {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor.rgb = texColor.rgb;\n  float alpha = texColor.a * v_opacity * u_opacity;\n  if (alpha == 0.0) {\n    discard;\n  }\n  gl_FragColor.a = alpha;\n}\n');
	
	var vertex$1 = new WebGLVertex('varying vec2 v_texCoord;\nvarying float v_opacity;\n\nattribute vec2 a_position;\nattribute vec2 a_texCoord;\nattribute vec2 a_offsets;\nattribute float a_opacity;\nattribute float a_rotateWithView;\n\nuniform mat4 u_projectionMatrix;\nuniform mat4 u_offsetScaleMatrix;\nuniform mat4 u_offsetRotateMatrix;\n\nvoid main(void) {\n  mat4 offsetMatrix = u_offsetScaleMatrix;\n  if (a_rotateWithView == 1.0) {\n    offsetMatrix = u_offsetScaleMatrix * u_offsetRotateMatrix;\n  }\n  vec4 offsets = offsetMatrix * vec4(a_offsets, 0.0, 0.0);\n  gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0) + offsets;\n  v_texCoord = a_texCoord;\n  v_opacity = a_opacity;\n}\n\n\n');
	
	/**
	 * @module ol/render/webgl/texturereplay/defaultshader/Locations
	 */
	
	var Locations$1 = function Locations(gl, program) {
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_projectionMatrix = gl.getUniformLocation(
	    program, 'u_projectionMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetScaleMatrix = gl.getUniformLocation(
	    program, 'u_offsetScaleMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetRotateMatrix = gl.getUniformLocation(
	    program, 'u_offsetRotateMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_opacity = gl.getUniformLocation(
	    program, 'u_opacity');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_image = gl.getUniformLocation(
	    program, 'u_image');
	
	  /**
	   * @type {number}
	   */
	  this.a_position = gl.getAttribLocation(
	    program, 'a_position');
	
	  /**
	   * @type {number}
	   */
	  this.a_texCoord = gl.getAttribLocation(
	    program, 'a_texCoord');
	
	  /**
	   * @type {number}
	   */
	  this.a_offsets = gl.getAttribLocation(
	    program, 'a_offsets');
	
	  /**
	   * @type {number}
	   */
	  this.a_opacity = gl.getAttribLocation(
	    program, 'a_opacity');
	
	  /**
	   * @type {number}
	   */
	  this.a_rotateWithView = gl.getAttribLocation(
	    program, 'a_rotateWithView');
	
	};
	
	/**
	 * @module ol/webgl/ContextEventType
	 */
	
	/**
	 * @enum {string}
	 */
	var ContextEventType = {
	  LOST: 'webglcontextlost',
	  RESTORED: 'webglcontextrestored'
	};
	
	/**
	 * @module ol/webgl/Context
	 */
	
	
	/**
	 * @typedef {Object} BufferCacheEntry
	 * @property {import("./Buffer.js").default} buf
	 * @property {WebGLBuffer} buffer
	 */
	
	
	/**
	 * @classdesc
	 * A WebGL context for accessing low-level WebGL capabilities.
	 */
	var WebGLContext = /*@__PURE__*/(function (Disposable$$1) {
	  function WebGLContext(canvas, gl) {
	    Disposable$$1.call(this);
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = canvas;
	
	    /**
	     * @private
	     * @type {WebGLRenderingContext}
	     */
	    this.gl_ = gl;
	
	    /**
	     * @private
	     * @type {!Object<string, BufferCacheEntry>}
	     */
	    this.bufferCache_ = {};
	
	    /**
	     * @private
	     * @type {!Object<string, WebGLShader>}
	     */
	    this.shaderCache_ = {};
	
	    /**
	     * @private
	     * @type {!Object<string, WebGLProgram>}
	     */
	    this.programCache_ = {};
	
	    /**
	     * @private
	     * @type {WebGLProgram}
	     */
	    this.currentProgram_ = null;
	
	    /**
	     * @private
	     * @type {WebGLFramebuffer}
	     */
	    this.hitDetectionFramebuffer_ = null;
	
	    /**
	     * @private
	     * @type {WebGLTexture}
	     */
	    this.hitDetectionTexture_ = null;
	
	    /**
	     * @private
	     * @type {WebGLRenderbuffer}
	     */
	    this.hitDetectionRenderbuffer_ = null;
	
	    /**
	     * @type {boolean}
	     */
	    this.hasOESElementIndexUint = includes(EXTENSIONS, 'OES_element_index_uint');
	
	    // use the OES_element_index_uint extension if available
	    if (this.hasOESElementIndexUint) {
	      gl.getExtension('OES_element_index_uint');
	    }
	
	    listen(this.canvas_, ContextEventType.LOST,
	      this.handleWebGLContextLost, this);
	    listen(this.canvas_, ContextEventType.RESTORED,
	      this.handleWebGLContextRestored, this);
	
	  }
	
	  if ( Disposable$$1 ) { WebGLContext.__proto__ = Disposable$$1; }
	  WebGLContext.prototype = Object.create( Disposable$$1 && Disposable$$1.prototype );
	  WebGLContext.prototype.constructor = WebGLContext;
	
	  /**
	   * Just bind the buffer if it's in the cache. Otherwise create
	   * the WebGL buffer, bind it, populate it, and add an entry to
	   * the cache.
	   * @param {number} target Target.
	   * @param {import("./Buffer.js").default} buf Buffer.
	   */
	  WebGLContext.prototype.bindBuffer = function bindBuffer (target, buf) {
	    var gl = this.getGL();
	    var arr = buf.getArray();
	    var bufferKey = getUid(buf);
	    if (bufferKey in this.bufferCache_) {
	      var bufferCacheEntry = this.bufferCache_[bufferKey];
	      gl.bindBuffer(target, bufferCacheEntry.buffer);
	    } else {
	      var buffer = gl.createBuffer();
	      gl.bindBuffer(target, buffer);
	      var /** @type {ArrayBufferView} */ arrayBuffer;
	      if (target == ARRAY_BUFFER) {
	        arrayBuffer = new Float32Array(arr);
	      } else if (target == ELEMENT_ARRAY_BUFFER) {
	        arrayBuffer = this.hasOESElementIndexUint ?
	          new Uint32Array(arr) : new Uint16Array(arr);
	      }
	      gl.bufferData(target, arrayBuffer, buf.getUsage());
	      this.bufferCache_[bufferKey] = {
	        buf: buf,
	        buffer: buffer
	      };
	    }
	  };
	
	  /**
	   * @param {import("./Buffer.js").default} buf Buffer.
	   */
	  WebGLContext.prototype.deleteBuffer = function deleteBuffer (buf) {
	    var gl = this.getGL();
	    var bufferKey = getUid(buf);
	    var bufferCacheEntry = this.bufferCache_[bufferKey];
	    if (!gl.isContextLost()) {
	      gl.deleteBuffer(bufferCacheEntry.buffer);
	    }
	    delete this.bufferCache_[bufferKey];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLContext.prototype.disposeInternal = function disposeInternal () {
	    unlistenAll(this.canvas_);
	    var gl = this.getGL();
	    if (!gl.isContextLost()) {
	      for (var key in this.bufferCache_) {
	        gl.deleteBuffer(this.bufferCache_[key].buffer);
	      }
	      for (var key$1 in this.programCache_) {
	        gl.deleteProgram(this.programCache_[key$1]);
	      }
	      for (var key$2 in this.shaderCache_) {
	        gl.deleteShader(this.shaderCache_[key$2]);
	      }
	      // delete objects for hit-detection
	      gl.deleteFramebuffer(this.hitDetectionFramebuffer_);
	      gl.deleteRenderbuffer(this.hitDetectionRenderbuffer_);
	      gl.deleteTexture(this.hitDetectionTexture_);
	    }
	  };
	
	  /**
	   * @return {HTMLCanvasElement} Canvas.
	   */
	  WebGLContext.prototype.getCanvas = function getCanvas () {
	    return this.canvas_;
	  };
	
	  /**
	   * Get the WebGL rendering context
	   * @return {WebGLRenderingContext} The rendering context.
	   * @api
	   */
	  WebGLContext.prototype.getGL = function getGL () {
	    return this.gl_;
	  };
	
	  /**
	   * Get the frame buffer for hit detection.
	   * @return {WebGLFramebuffer} The hit detection frame buffer.
	   */
	  WebGLContext.prototype.getHitDetectionFramebuffer = function getHitDetectionFramebuffer () {
	    if (!this.hitDetectionFramebuffer_) {
	      this.initHitDetectionFramebuffer_();
	    }
	    return this.hitDetectionFramebuffer_;
	  };
	
	  /**
	   * Get shader from the cache if it's in the cache. Otherwise, create
	   * the WebGL shader, compile it, and add entry to cache.
	   * @param {import("./Shader.js").default} shaderObject Shader object.
	   * @return {WebGLShader} Shader.
	   */
	  WebGLContext.prototype.getShader = function getShader (shaderObject) {
	    var shaderKey = getUid(shaderObject);
	    if (shaderKey in this.shaderCache_) {
	      return this.shaderCache_[shaderKey];
	    } else {
	      var gl = this.getGL();
	      var shader = gl.createShader(shaderObject.getType());
	      gl.shaderSource(shader, shaderObject.getSource());
	      gl.compileShader(shader);
	      this.shaderCache_[shaderKey] = shader;
	      return shader;
	    }
	  };
	
	  /**
	   * Get the program from the cache if it's in the cache. Otherwise create
	   * the WebGL program, attach the shaders to it, and add an entry to the
	   * cache.
	   * @param {import("./Fragment.js").default} fragmentShaderObject Fragment shader.
	   * @param {import("./Vertex.js").default} vertexShaderObject Vertex shader.
	   * @return {WebGLProgram} Program.
	   */
	  WebGLContext.prototype.getProgram = function getProgram (fragmentShaderObject, vertexShaderObject) {
	    var programKey = getUid(fragmentShaderObject) + '/' + getUid(vertexShaderObject);
	    if (programKey in this.programCache_) {
	      return this.programCache_[programKey];
	    } else {
	      var gl = this.getGL();
	      var program = gl.createProgram();
	      gl.attachShader(program, this.getShader(fragmentShaderObject));
	      gl.attachShader(program, this.getShader(vertexShaderObject));
	      gl.linkProgram(program);
	      this.programCache_[programKey] = program;
	      return program;
	    }
	  };
	
	  /**
	   * FIXME empty description for jsdoc
	   */
	  WebGLContext.prototype.handleWebGLContextLost = function handleWebGLContextLost () {
	    clear(this.bufferCache_);
	    clear(this.shaderCache_);
	    clear(this.programCache_);
	    this.currentProgram_ = null;
	    this.hitDetectionFramebuffer_ = null;
	    this.hitDetectionTexture_ = null;
	    this.hitDetectionRenderbuffer_ = null;
	  };
	
	  /**
	   * FIXME empty description for jsdoc
	   */
	  WebGLContext.prototype.handleWebGLContextRestored = function handleWebGLContextRestored () {
	  };
	
	  /**
	   * Creates a 1x1 pixel framebuffer for the hit-detection.
	   * @private
	   */
	  WebGLContext.prototype.initHitDetectionFramebuffer_ = function initHitDetectionFramebuffer_ () {
	    var gl = this.gl_;
	    var framebuffer = gl.createFramebuffer();
	    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
	
	    var texture = createEmptyTexture(gl, 1, 1);
	    var renderbuffer = gl.createRenderbuffer();
	    gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
	    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, 1, 1);
	    gl.framebufferTexture2D(
	      gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
	    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT,
	      gl.RENDERBUFFER, renderbuffer);
	
	    gl.bindTexture(gl.TEXTURE_2D, null);
	    gl.bindRenderbuffer(gl.RENDERBUFFER, null);
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	    this.hitDetectionFramebuffer_ = framebuffer;
	    this.hitDetectionTexture_ = texture;
	    this.hitDetectionRenderbuffer_ = renderbuffer;
	  };
	
	  /**
	   * Use a program.  If the program is already in use, this will return `false`.
	   * @param {WebGLProgram} program Program.
	   * @return {boolean} Changed.
	   * @api
	   */
	  WebGLContext.prototype.useProgram = function useProgram (program) {
	    if (program == this.currentProgram_) {
	      return false;
	    } else {
	      var gl = this.getGL();
	      gl.useProgram(program);
	      this.currentProgram_ = program;
	      return true;
	    }
	  };
	
	  return WebGLContext;
	}(Disposable));
	
	
	/**
	 * @param {WebGLRenderingContext} gl WebGL rendering context.
	 * @param {number=} opt_wrapS wrapS.
	 * @param {number=} opt_wrapT wrapT.
	 * @return {WebGLTexture} The texture.
	 */
	function createTextureInternal(gl, opt_wrapS, opt_wrapT) {
	  var texture = gl.createTexture();
	  gl.bindTexture(gl.TEXTURE_2D, texture);
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
	  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
	
	  if (opt_wrapS !== undefined) {
	    gl.texParameteri(
	      TEXTURE_2D, TEXTURE_WRAP_S, opt_wrapS);
	  }
	  if (opt_wrapT !== undefined) {
	    gl.texParameteri(
	      TEXTURE_2D, TEXTURE_WRAP_T, opt_wrapT);
	  }
	
	  return texture;
	}
	
	
	/**
	 * @param {WebGLRenderingContext} gl WebGL rendering context.
	 * @param {number} width Width.
	 * @param {number} height Height.
	 * @param {number=} opt_wrapS wrapS.
	 * @param {number=} opt_wrapT wrapT.
	 * @return {WebGLTexture} The texture.
	 */
	function createEmptyTexture(gl, width, height, opt_wrapS, opt_wrapT) {
	  var texture = createTextureInternal(gl, opt_wrapS, opt_wrapT);
	  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	  return texture;
	}
	
	
	/**
	 * @param {WebGLRenderingContext} gl WebGL rendering context.
	 * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
	 * @param {number=} opt_wrapS wrapS.
	 * @param {number=} opt_wrapT wrapT.
	 * @return {WebGLTexture} The texture.
	 */
	function createTexture(gl, image, opt_wrapS, opt_wrapT) {
	  var texture = createTextureInternal(gl, opt_wrapS, opt_wrapT);
	  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	  return texture;
	}
	
	/**
	 * @module ol/render/webgl/TextureReplay
	 */
	
	var WebGLTextureReplay = /*@__PURE__*/(function (WebGLReplay$$1) {
	  function WebGLTextureReplay(tolerance, maxExtent) {
	    WebGLReplay$$1.call(this, tolerance, maxExtent);
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.anchorX = undefined;
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.anchorY = undefined;
	
	    /**
	     * @type {Array<number>}
	     * @protected
	     */
	    this.groupIndices = [];
	
	    /**
	     * @type {Array<number>}
	     * @protected
	     */
	    this.hitDetectionGroupIndices = [];
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.height = undefined;
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.imageHeight = undefined;
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.imageWidth = undefined;
	
	    /**
	     * @protected
	     * @type {import("./texturereplay/defaultshader/Locations.js").default}
	     */
	    this.defaultLocations = null;
	
	    /**
	     * @protected
	     * @type {number|undefined}
	     */
	    this.opacity = undefined;
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.originX = undefined;
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.originY = undefined;
	
	    /**
	     * @protected
	     * @type {boolean|undefined}
	     */
	    this.rotateWithView = undefined;
	
	    /**
	     * @protected
	     * @type {number|undefined}
	     */
	    this.rotation = undefined;
	
	    /**
	     * @protected
	     * @type {number|undefined}
	     */
	    this.scale = undefined;
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.width = undefined;
	  }
	
	  if ( WebGLReplay$$1 ) { WebGLTextureReplay.__proto__ = WebGLReplay$$1; }
	  WebGLTextureReplay.prototype = Object.create( WebGLReplay$$1 && WebGLReplay$$1.prototype );
	  WebGLTextureReplay.prototype.constructor = WebGLTextureReplay;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextureReplay.prototype.getDeleteResourcesFunction = function getDeleteResourcesFunction (context) {
	    var verticesBuffer = this.verticesBuffer;
	    var indicesBuffer = this.indicesBuffer;
	    var textures = this.getTextures(true);
	    var gl = context.getGL();
	    return function() {
	      if (!gl.isContextLost()) {
	        var i, ii;
	        for (i = 0, ii = textures.length; i < ii; ++i) {
	          gl.deleteTexture(textures[i]);
	        }
	      }
	      context.deleteBuffer(verticesBuffer);
	      context.deleteBuffer(indicesBuffer);
	    };
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @return {number} My end.
	   * @protected
	   */
	  WebGLTextureReplay.prototype.drawCoordinates = function drawCoordinates (flatCoordinates, offset, end, stride) {
	    var anchorX = /** @type {number} */ (this.anchorX);
	    var anchorY = /** @type {number} */ (this.anchorY);
	    var height = /** @type {number} */ (this.height);
	    var imageHeight = /** @type {number} */ (this.imageHeight);
	    var imageWidth = /** @type {number} */ (this.imageWidth);
	    var opacity = /** @type {number} */ (this.opacity);
	    var originX = /** @type {number} */ (this.originX);
	    var originY = /** @type {number} */ (this.originY);
	    var rotateWithView = this.rotateWithView ? 1.0 : 0.0;
	    // this.rotation_ is anti-clockwise, but rotation is clockwise
	    var rotation = /** @type {number} */ (-this.rotation);
	    var scale = /** @type {number} */ (this.scale);
	    var width = /** @type {number} */ (this.width);
	    var cos = Math.cos(rotation);
	    var sin = Math.sin(rotation);
	    var numIndices = this.indices.length;
	    var numVertices = this.vertices.length;
	    var i, n, offsetX, offsetY, x, y;
	    for (i = offset; i < end; i += stride) {
	      x = flatCoordinates[i] - this.origin[0];
	      y = flatCoordinates[i + 1] - this.origin[1];
	
	      // There are 4 vertices per [x, y] point, one for each corner of the
	      // rectangle we're going to draw. We'd use 1 vertex per [x, y] point if
	      // WebGL supported Geometry Shaders (which can emit new vertices), but that
	      // is not currently the case.
	      //
	      // And each vertex includes 8 values: the x and y coordinates, the x and
	      // y offsets used to calculate the position of the corner, the u and
	      // v texture coordinates for the corner, the opacity, and whether the
	      // the image should be rotated with the view (rotateWithView).
	
	      n = numVertices / 8;
	
	      // bottom-left corner
	      offsetX = -scale * anchorX;
	      offsetY = -scale * (height - anchorY);
	      this.vertices[numVertices++] = x;
	      this.vertices[numVertices++] = y;
	      this.vertices[numVertices++] = offsetX * cos - offsetY * sin;
	      this.vertices[numVertices++] = offsetX * sin + offsetY * cos;
	      this.vertices[numVertices++] = originX / imageWidth;
	      this.vertices[numVertices++] = (originY + height) / imageHeight;
	      this.vertices[numVertices++] = opacity;
	      this.vertices[numVertices++] = rotateWithView;
	
	      // bottom-right corner
	      offsetX = scale * (width - anchorX);
	      offsetY = -scale * (height - anchorY);
	      this.vertices[numVertices++] = x;
	      this.vertices[numVertices++] = y;
	      this.vertices[numVertices++] = offsetX * cos - offsetY * sin;
	      this.vertices[numVertices++] = offsetX * sin + offsetY * cos;
	      this.vertices[numVertices++] = (originX + width) / imageWidth;
	      this.vertices[numVertices++] = (originY + height) / imageHeight;
	      this.vertices[numVertices++] = opacity;
	      this.vertices[numVertices++] = rotateWithView;
	
	      // top-right corner
	      offsetX = scale * (width - anchorX);
	      offsetY = scale * anchorY;
	      this.vertices[numVertices++] = x;
	      this.vertices[numVertices++] = y;
	      this.vertices[numVertices++] = offsetX * cos - offsetY * sin;
	      this.vertices[numVertices++] = offsetX * sin + offsetY * cos;
	      this.vertices[numVertices++] = (originX + width) / imageWidth;
	      this.vertices[numVertices++] = originY / imageHeight;
	      this.vertices[numVertices++] = opacity;
	      this.vertices[numVertices++] = rotateWithView;
	
	      // top-left corner
	      offsetX = -scale * anchorX;
	      offsetY = scale * anchorY;
	      this.vertices[numVertices++] = x;
	      this.vertices[numVertices++] = y;
	      this.vertices[numVertices++] = offsetX * cos - offsetY * sin;
	      this.vertices[numVertices++] = offsetX * sin + offsetY * cos;
	      this.vertices[numVertices++] = originX / imageWidth;
	      this.vertices[numVertices++] = originY / imageHeight;
	      this.vertices[numVertices++] = opacity;
	      this.vertices[numVertices++] = rotateWithView;
	
	      this.indices[numIndices++] = n;
	      this.indices[numIndices++] = n + 1;
	      this.indices[numIndices++] = n + 2;
	      this.indices[numIndices++] = n;
	      this.indices[numIndices++] = n + 2;
	      this.indices[numIndices++] = n + 3;
	    }
	
	    return numVertices;
	  };
	
	  /**
	   * @protected
	   * @param {Array<WebGLTexture>} textures Textures.
	   * @param {Array<HTMLCanvasElement|HTMLImageElement|HTMLVideoElement>} images Images.
	   * @param {!Object<string, WebGLTexture>} texturePerImage Texture cache.
	   * @param {WebGLRenderingContext} gl Gl.
	   */
	  WebGLTextureReplay.prototype.createTextures = function createTextures (textures, images, texturePerImage, gl) {
	    var texture, image, uid, i;
	    var ii = images.length;
	    for (i = 0; i < ii; ++i) {
	      image = images[i];
	
	      uid = getUid(image);
	      if (uid in texturePerImage) {
	        texture = texturePerImage[uid];
	      } else {
	        texture = createTexture(
	          gl, image, CLAMP_TO_EDGE, CLAMP_TO_EDGE);
	        texturePerImage[uid] = texture;
	      }
	      textures[i] = texture;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextureReplay.prototype.setUpProgram = function setUpProgram (gl, context, size, pixelRatio) {
	    // get the program
	    var program = context.getProgram(fragment$1, vertex$1);
	
	    // get the locations
	    var locations;
	    if (!this.defaultLocations) {
	      locations = new Locations$1(gl, program);
	      this.defaultLocations = locations;
	    } else {
	      locations = this.defaultLocations;
	    }
	
	    // use the program (FIXME: use the return value)
	    context.useProgram(program);
	
	    // enable the vertex attrib arrays
	    gl.enableVertexAttribArray(locations.a_position);
	    gl.vertexAttribPointer(locations.a_position, 2, FLOAT,
	      false, 32, 0);
	
	    gl.enableVertexAttribArray(locations.a_offsets);
	    gl.vertexAttribPointer(locations.a_offsets, 2, FLOAT,
	      false, 32, 8);
	
	    gl.enableVertexAttribArray(locations.a_texCoord);
	    gl.vertexAttribPointer(locations.a_texCoord, 2, FLOAT,
	      false, 32, 16);
	
	    gl.enableVertexAttribArray(locations.a_opacity);
	    gl.vertexAttribPointer(locations.a_opacity, 1, FLOAT,
	      false, 32, 24);
	
	    gl.enableVertexAttribArray(locations.a_rotateWithView);
	    gl.vertexAttribPointer(locations.a_rotateWithView, 1, FLOAT,
	      false, 32, 28);
	
	    return locations;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextureReplay.prototype.shutDownProgram = function shutDownProgram (gl, locations) {
	    gl.disableVertexAttribArray(locations.a_position);
	    gl.disableVertexAttribArray(locations.a_offsets);
	    gl.disableVertexAttribArray(locations.a_texCoord);
	    gl.disableVertexAttribArray(locations.a_opacity);
	    gl.disableVertexAttribArray(locations.a_rotateWithView);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextureReplay.prototype.drawReplay = function drawReplay (gl, context, skippedFeaturesHash, hitDetection) {
	    var textures = hitDetection ? this.getHitDetectionTextures() : this.getTextures();
	    var groupIndices = hitDetection ? this.hitDetectionGroupIndices : this.groupIndices;
	
	    if (!isEmpty(skippedFeaturesHash)) {
	      this.drawReplaySkipping(gl, context, skippedFeaturesHash, textures, groupIndices);
	    } else {
	      var i, ii, start;
	      for (i = 0, ii = textures.length, start = 0; i < ii; ++i) {
	        gl.bindTexture(TEXTURE_2D, textures[i]);
	        var end = groupIndices[i];
	        this.drawElements(gl, context, start, end);
	        start = end;
	      }
	    }
	  };
	
	  /**
	   * Draw the replay while paying attention to skipped features.
	   *
	   * This functions creates groups of features that can be drawn to together,
	   * so that the number of `drawElements` calls is minimized.
	   *
	   * For example given the following texture groups:
	   *
	   *    Group 1: A B C
	   *    Group 2: D [E] F G
	   *
	   * If feature E should be skipped, the following `drawElements` calls will be
	   * made:
	   *
	   *    drawElements with feature A, B and C
	   *    drawElements with feature D
	   *    drawElements with feature F and G
	   *
	   * @protected
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features
	   *  to skip.
	   * @param {Array<WebGLTexture>} textures Textures.
	   * @param {Array<number>} groupIndices Texture group indices.
	   */
	  WebGLTextureReplay.prototype.drawReplaySkipping = function drawReplaySkipping (gl, context, skippedFeaturesHash, textures, groupIndices) {
	    var featureIndex = 0;
	
	    var i, ii;
	    for (i = 0, ii = textures.length; i < ii; ++i) {
	      gl.bindTexture(TEXTURE_2D, textures[i]);
	      var groupStart = (i > 0) ? groupIndices[i - 1] : 0;
	      var groupEnd = groupIndices[i];
	
	      var start = groupStart;
	      var end = groupStart;
	      while (featureIndex < this.startIndices.length &&
	          this.startIndices[featureIndex] <= groupEnd) {
	        var feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)] !== undefined) {
	          // feature should be skipped
	          if (start !== end) {
	            // draw the features so far
	            this.drawElements(gl, context, start, end);
	          }
	          // continue with the next feature
	          start = (featureIndex === this.startIndices.length - 1) ?
	            groupEnd : this.startIndices[featureIndex + 1];
	          end = start;
	        } else {
	          // the feature is not skipped, augment the end index
	          end = (featureIndex === this.startIndices.length - 1) ?
	            groupEnd : this.startIndices[featureIndex + 1];
	        }
	        featureIndex++;
	      }
	
	      if (start !== end) {
	        // draw the remaining features (in case there was no skipped feature
	        // in this texture group, all features of a group are drawn together)
	        this.drawElements(gl, context, start, end);
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextureReplay.prototype.drawHitDetectionReplayOneByOne = function drawHitDetectionReplayOneByOne (gl, context, skippedFeaturesHash, featureCallback, opt_hitExtent) {
	    var i, groupStart, start, end, feature;
	    var featureIndex = this.startIndices.length - 1;
	    var hitDetectionTextures = this.getHitDetectionTextures();
	    for (i = hitDetectionTextures.length - 1; i >= 0; --i) {
	      gl.bindTexture(TEXTURE_2D, hitDetectionTextures[i]);
	      groupStart = (i > 0) ? this.hitDetectionGroupIndices[i - 1] : 0;
	      end = this.hitDetectionGroupIndices[i];
	
	      // draw all features for this texture group
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        start = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)] === undefined &&
	            feature.getGeometry() &&
	            (opt_hitExtent === undefined || intersects(
	              /** @type {Array<number>} */ (opt_hitExtent),
	              feature.getGeometry().getExtent()))) {
	          gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	          this.drawElements(gl, context, start, end);
	
	          var result = featureCallback(feature);
	          if (result) {
	            return result;
	          }
	        }
	
	        end = start;
	        featureIndex--;
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextureReplay.prototype.finish = function finish (context) {
	    this.anchorX = undefined;
	    this.anchorY = undefined;
	    this.height = undefined;
	    this.imageHeight = undefined;
	    this.imageWidth = undefined;
	    this.indices = null;
	    this.opacity = undefined;
	    this.originX = undefined;
	    this.originY = undefined;
	    this.rotateWithView = undefined;
	    this.rotation = undefined;
	    this.scale = undefined;
	    this.vertices = null;
	    this.width = undefined;
	  };
	
	  /**
	   * @abstract
	   * @protected
	   * @param {boolean=} opt_all Return hit detection textures with regular ones.
	   * @return {Array<WebGLTexture>} Textures.
	   */
	  WebGLTextureReplay.prototype.getTextures = function getTextures (opt_all) {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @protected
	   * @return {Array<WebGLTexture>} Textures.
	   */
	  WebGLTextureReplay.prototype.getHitDetectionTextures = function getHitDetectionTextures () {
	    return abstract();
	  };
	
	  return WebGLTextureReplay;
	}(WebGLReplay));
	
	/**
	 * @module ol/render/webgl/ImageReplay
	 */
	
	var WebGLImageReplay = /*@__PURE__*/(function (WebGLTextureReplay$$1) {
	  function WebGLImageReplay(tolerance, maxExtent) {
	    WebGLTextureReplay$$1.call(this, tolerance, maxExtent);
	
	    /**
	     * @type {Array<HTMLCanvasElement|HTMLImageElement|HTMLVideoElement>}
	     * @protected
	     */
	    this.images_ = [];
	
	    /**
	     * @type {Array<HTMLCanvasElement|HTMLImageElement|HTMLVideoElement>}
	     * @protected
	     */
	    this.hitDetectionImages_ = [];
	
	    /**
	     * @type {Array<WebGLTexture>}
	     * @private
	     */
	    this.textures_ = [];
	
	    /**
	     * @type {Array<WebGLTexture>}
	     * @private
	     */
	    this.hitDetectionTextures_ = [];
	
	  }
	
	  if ( WebGLTextureReplay$$1 ) { WebGLImageReplay.__proto__ = WebGLTextureReplay$$1; }
	  WebGLImageReplay.prototype = Object.create( WebGLTextureReplay$$1 && WebGLTextureReplay$$1.prototype );
	  WebGLImageReplay.prototype.constructor = WebGLImageReplay;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageReplay.prototype.drawMultiPoint = function drawMultiPoint (multiPointGeometry, feature) {
	    this.startIndices.push(this.indices.length);
	    this.startIndicesFeature.push(feature);
	    var flatCoordinates = multiPointGeometry.getFlatCoordinates();
	    var stride = multiPointGeometry.getStride();
	    this.drawCoordinates(
	      flatCoordinates, 0, flatCoordinates.length, stride);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageReplay.prototype.drawPoint = function drawPoint (pointGeometry, feature) {
	    this.startIndices.push(this.indices.length);
	    this.startIndicesFeature.push(feature);
	    var flatCoordinates = pointGeometry.getFlatCoordinates();
	    var stride = pointGeometry.getStride();
	    this.drawCoordinates(
	      flatCoordinates, 0, flatCoordinates.length, stride);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageReplay.prototype.finish = function finish (context) {
	    var gl = context.getGL();
	
	    this.groupIndices.push(this.indices.length);
	    this.hitDetectionGroupIndices.push(this.indices.length);
	
	    // create, bind, and populate the vertices buffer
	    this.verticesBuffer = new WebGLBuffer(this.vertices);
	
	    var indices = this.indices;
	
	    // create, bind, and populate the indices buffer
	    this.indicesBuffer = new WebGLBuffer(indices);
	
	    // create textures
	    /** @type {Object<string, WebGLTexture>} */
	    var texturePerImage = {};
	
	    this.createTextures(this.textures_, this.images_, texturePerImage, gl);
	
	    this.createTextures(this.hitDetectionTextures_, this.hitDetectionImages_,
	      texturePerImage, gl);
	
	    this.images_ = null;
	    this.hitDetectionImages_ = null;
	    WebGLTextureReplay$$1.prototype.finish.call(this, context);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageReplay.prototype.setImageStyle = function setImageStyle (imageStyle) {
	    var anchor = imageStyle.getAnchor();
	    var image = imageStyle.getImage(1);
	    var imageSize = imageStyle.getImageSize();
	    var hitDetectionImage = imageStyle.getHitDetectionImage(1);
	    var opacity = imageStyle.getOpacity();
	    var origin = imageStyle.getOrigin();
	    var rotateWithView = imageStyle.getRotateWithView();
	    var rotation = imageStyle.getRotation();
	    var size = imageStyle.getSize();
	    var scale = imageStyle.getScale();
	
	    var currentImage;
	    if (this.images_.length === 0) {
	      this.images_.push(image);
	    } else {
	      currentImage = this.images_[this.images_.length - 1];
	      if (getUid(currentImage) != getUid(image)) {
	        this.groupIndices.push(this.indices.length);
	        this.images_.push(image);
	      }
	    }
	
	    if (this.hitDetectionImages_.length === 0) {
	      this.hitDetectionImages_.push(hitDetectionImage);
	    } else {
	      currentImage =
	          this.hitDetectionImages_[this.hitDetectionImages_.length - 1];
	      if (getUid(currentImage) != getUid(hitDetectionImage)) {
	        this.hitDetectionGroupIndices.push(this.indices.length);
	        this.hitDetectionImages_.push(hitDetectionImage);
	      }
	    }
	
	    this.anchorX = anchor[0];
	    this.anchorY = anchor[1];
	    this.height = size[1];
	    this.imageHeight = imageSize[1];
	    this.imageWidth = imageSize[0];
	    this.opacity = opacity;
	    this.originX = origin[0];
	    this.originY = origin[1];
	    this.rotation = rotation;
	    this.rotateWithView = rotateWithView;
	    this.scale = scale;
	    this.width = size[0];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageReplay.prototype.getTextures = function getTextures (opt_all) {
	    return opt_all ? this.textures_.concat(this.hitDetectionTextures_) : this.textures_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageReplay.prototype.getHitDetectionTextures = function getHitDetectionTextures () {
	    return this.hitDetectionTextures_;
	  };
	
	  return WebGLImageReplay;
	}(WebGLTextureReplay));
	
	/**
	 * @module ol/geom/flat/topology
	 */
	
	/**
	 * Check if the linestring is a boundary.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @return {boolean} The linestring is a boundary.
	 */
	function lineStringIsClosed(flatCoordinates, offset, end, stride) {
	  var lastCoord = end - stride;
	  if (flatCoordinates[offset] === flatCoordinates[lastCoord] &&
	      flatCoordinates[offset + 1] === flatCoordinates[lastCoord + 1] && (end - offset) / stride > 3) {
	    return !!linearRing(flatCoordinates, offset, end, stride);
	  }
	  return false;
	}
	
	/**
	 * @module ol/render/webgl/linestringreplay/defaultshader
	 */
	
	var fragment$2 = new WebGLFragment('precision mediump float;\nvarying float v_round;\nvarying vec2 v_roundVertex;\nvarying float v_halfWidth;\n\n\n\nuniform float u_opacity;\nuniform vec4 u_color;\nuniform vec2 u_size;\nuniform float u_pixelRatio;\n\nvoid main(void) {\n  if (v_round > 0.0) {\n    vec2 windowCoords = vec2((v_roundVertex.x + 1.0) / 2.0 * u_size.x * u_pixelRatio,\n        (v_roundVertex.y + 1.0) / 2.0 * u_size.y * u_pixelRatio);\n    if (length(windowCoords - gl_FragCoord.xy) > v_halfWidth * u_pixelRatio) {\n      discard;\n    }\n  }\n  gl_FragColor = u_color;\n  float alpha = u_color.a * u_opacity;\n  if (alpha == 0.0) {\n    discard;\n  }\n  gl_FragColor.a = alpha;\n}\n');
	
	var vertex$2 = new WebGLVertex('varying float v_round;\nvarying vec2 v_roundVertex;\nvarying float v_halfWidth;\n\n\nattribute vec2 a_lastPos;\nattribute vec2 a_position;\nattribute vec2 a_nextPos;\nattribute float a_direction;\n\nuniform mat4 u_projectionMatrix;\nuniform mat4 u_offsetScaleMatrix;\nuniform mat4 u_offsetRotateMatrix;\nuniform float u_lineWidth;\nuniform float u_miterLimit;\n\nbool nearlyEquals(in float value, in float ref) {\n  float epsilon = 0.000000000001;\n  return value >= ref - epsilon && value <= ref + epsilon;\n}\n\nvoid alongNormal(out vec2 offset, in vec2 nextP, in float turnDir, in float direction) {\n  vec2 dirVect = nextP - a_position;\n  vec2 normal = normalize(vec2(-turnDir * dirVect.y, turnDir * dirVect.x));\n  offset = u_lineWidth / 2.0 * normal * direction;\n}\n\nvoid miterUp(out vec2 offset, out float round, in bool isRound, in float direction) {\n  float halfWidth = u_lineWidth / 2.0;\n  vec2 tangent = normalize(normalize(a_nextPos - a_position) + normalize(a_position - a_lastPos));\n  vec2 normal = vec2(-tangent.y, tangent.x);\n  vec2 dirVect = a_nextPos - a_position;\n  vec2 tmpNormal = normalize(vec2(-dirVect.y, dirVect.x));\n  float miterLength = abs(halfWidth / dot(normal, tmpNormal));\n  offset = normal * direction * miterLength;\n  round = 0.0;\n  if (isRound) {\n    round = 1.0;\n  } else if (miterLength > u_miterLimit + u_lineWidth) {\n    offset = halfWidth * tmpNormal * direction;\n  }\n}\n\nbool miterDown(out vec2 offset, in vec4 projPos, in mat4 offsetMatrix, in float direction) {\n  bool degenerate = false;\n  vec2 tangent = normalize(normalize(a_nextPos - a_position) + normalize(a_position - a_lastPos));\n  vec2 normal = vec2(-tangent.y, tangent.x);\n  vec2 dirVect = a_lastPos - a_position;\n  vec2 tmpNormal = normalize(vec2(-dirVect.y, dirVect.x));\n  vec2 longOffset, shortOffset, longVertex;\n  vec4 shortProjVertex;\n  float halfWidth = u_lineWidth / 2.0;\n  if (length(a_nextPos - a_position) > length(a_lastPos - a_position)) {\n    longOffset = tmpNormal * direction * halfWidth;\n    shortOffset = normalize(vec2(dirVect.y, -dirVect.x)) * direction * halfWidth;\n    longVertex = a_nextPos;\n    shortProjVertex = u_projectionMatrix * vec4(a_lastPos, 0.0, 1.0);\n  } else {\n    shortOffset = tmpNormal * direction * halfWidth;\n    longOffset = normalize(vec2(dirVect.y, -dirVect.x)) * direction * halfWidth;\n    longVertex = a_lastPos;\n    shortProjVertex = u_projectionMatrix * vec4(a_nextPos, 0.0, 1.0);\n  }\n  //Intersection algorithm based on theory by Paul Bourke (http://paulbourke.net/geometry/pointlineplane/).\n  vec4 p1 = u_projectionMatrix * vec4(longVertex, 0.0, 1.0) + offsetMatrix * vec4(longOffset, 0.0, 0.0);\n  vec4 p2 = projPos + offsetMatrix * vec4(longOffset, 0.0, 0.0);\n  vec4 p3 = shortProjVertex + offsetMatrix * vec4(-shortOffset, 0.0, 0.0);\n  vec4 p4 = shortProjVertex + offsetMatrix * vec4(shortOffset, 0.0, 0.0);\n  float denom = (p4.y - p3.y) * (p2.x - p1.x) - (p4.x - p3.x) * (p2.y - p1.y);\n  float firstU = ((p4.x - p3.x) * (p1.y - p3.y) - (p4.y - p3.y) * (p1.x - p3.x)) / denom;\n  float secondU = ((p2.x - p1.x) * (p1.y - p3.y) - (p2.y - p1.y) * (p1.x - p3.x)) / denom;\n  float epsilon = 0.000000000001;\n  if (firstU > epsilon && firstU < 1.0 - epsilon && secondU > epsilon && secondU < 1.0 - epsilon) {\n    shortProjVertex.x = p1.x + firstU * (p2.x - p1.x);\n    shortProjVertex.y = p1.y + firstU * (p2.y - p1.y);\n    offset = shortProjVertex.xy;\n    degenerate = true;\n  } else {\n    float miterLength = abs(halfWidth / dot(normal, tmpNormal));\n    offset = normal * direction * miterLength;\n  }\n  return degenerate;\n}\n\nvoid squareCap(out vec2 offset, out float round, in bool isRound, in vec2 nextP,\n    in float turnDir, in float direction) {\n  round = 0.0;\n  vec2 dirVect = a_position - nextP;\n  vec2 firstNormal = normalize(dirVect);\n  vec2 secondNormal = vec2(turnDir * firstNormal.y * direction, -turnDir * firstNormal.x * direction);\n  vec2 hypotenuse = normalize(firstNormal - secondNormal);\n  vec2 normal = vec2(turnDir * hypotenuse.y * direction, -turnDir * hypotenuse.x * direction);\n  float length = sqrt(v_halfWidth * v_halfWidth * 2.0);\n  offset = normal * length;\n  if (isRound) {\n    round = 1.0;\n  }\n}\n\nvoid main(void) {\n  bool degenerate = false;\n  float direction = float(sign(a_direction));\n  mat4 offsetMatrix = u_offsetScaleMatrix * u_offsetRotateMatrix;\n  vec2 offset;\n  vec4 projPos = u_projectionMatrix * vec4(a_position, 0.0, 1.0);\n  bool round = nearlyEquals(mod(a_direction, 2.0), 0.0);\n\n  v_round = 0.0;\n  v_halfWidth = u_lineWidth / 2.0;\n  v_roundVertex = projPos.xy;\n\n  if (nearlyEquals(mod(a_direction, 3.0), 0.0) || nearlyEquals(mod(a_direction, 17.0), 0.0)) {\n    alongNormal(offset, a_nextPos, 1.0, direction);\n  } else if (nearlyEquals(mod(a_direction, 5.0), 0.0) || nearlyEquals(mod(a_direction, 13.0), 0.0)) {\n    alongNormal(offset, a_lastPos, -1.0, direction);\n  } else if (nearlyEquals(mod(a_direction, 23.0), 0.0)) {\n    miterUp(offset, v_round, round, direction);\n  } else if (nearlyEquals(mod(a_direction, 19.0), 0.0)) {\n    degenerate = miterDown(offset, projPos, offsetMatrix, direction);\n  } else if (nearlyEquals(mod(a_direction, 7.0), 0.0)) {\n    squareCap(offset, v_round, round, a_nextPos, 1.0, direction);\n  } else if (nearlyEquals(mod(a_direction, 11.0), 0.0)) {\n    squareCap(offset, v_round, round, a_lastPos, -1.0, direction);\n  }\n  if (!degenerate) {\n    vec4 offsets = offsetMatrix * vec4(offset, 0.0, 0.0);\n    gl_Position = projPos + offsets;\n  } else {\n    gl_Position = vec4(offset, 0.0, 1.0);\n  }\n}\n\n\n');
	
	/**
	 * @module ol/render/webgl/linestringreplay/defaultshader/Locations
	 */
	
	var Locations$2 = function Locations(gl, program) {
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_projectionMatrix = gl.getUniformLocation(
	    program, 'u_projectionMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetScaleMatrix = gl.getUniformLocation(
	    program, 'u_offsetScaleMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetRotateMatrix = gl.getUniformLocation(
	    program, 'u_offsetRotateMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_lineWidth = gl.getUniformLocation(
	    program, 'u_lineWidth');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_miterLimit = gl.getUniformLocation(
	    program, 'u_miterLimit');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_opacity = gl.getUniformLocation(
	    program, 'u_opacity');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_color = gl.getUniformLocation(
	    program, 'u_color');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_size = gl.getUniformLocation(
	    program, 'u_size');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_pixelRatio = gl.getUniformLocation(
	    program, 'u_pixelRatio');
	
	  /**
	   * @type {number}
	   */
	  this.a_lastPos = gl.getAttribLocation(
	    program, 'a_lastPos');
	
	  /**
	   * @type {number}
	   */
	  this.a_position = gl.getAttribLocation(
	    program, 'a_position');
	
	  /**
	   * @type {number}
	   */
	  this.a_nextPos = gl.getAttribLocation(
	    program, 'a_nextPos');
	
	  /**
	   * @type {number}
	   */
	  this.a_direction = gl.getAttribLocation(
	    program, 'a_direction');
	
	};
	
	/**
	 * @module ol/render/webgl/LineStringReplay
	 */
	
	
	/**
	 * @enum {number}
	 */
	var Instruction$2 = {
	  ROUND: 2,
	  BEGIN_LINE: 3,
	  END_LINE: 5,
	  BEGIN_LINE_CAP: 7,
	  END_LINE_CAP: 11,
	  BEVEL_FIRST: 13,
	  BEVEL_SECOND: 17,
	  MITER_BOTTOM: 19,
	  MITER_TOP: 23
	};
	
	
	var WebGLLineStringReplay = /*@__PURE__*/(function (WebGLReplay$$1) {
	  function WebGLLineStringReplay(tolerance, maxExtent) {
	    WebGLReplay$$1.call(this, tolerance, maxExtent);
	
	    /**
	     * @private
	     * @type {import("./linestringreplay/defaultshader/Locations.js").default}
	     */
	    this.defaultLocations_ = null;
	
	    /**
	     * @private
	     * @type {Array<Array<?>>}
	     */
	    this.styles_ = [];
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.styleIndices_ = [];
	
	    /**
	     * @private
	     * @type {{strokeColor: (Array<number>|null),
	     *         lineCap: (string|undefined),
	     *         lineDash: Array<number>,
	     *         lineDashOffset: (number|undefined),
	     *         lineJoin: (string|undefined),
	     *         lineWidth: (number|undefined),
	     *         miterLimit: (number|undefined),
	     *         changed: boolean}|null}
	     */
	    this.state_ = {
	      strokeColor: null,
	      lineCap: undefined,
	      lineDash: null,
	      lineDashOffset: undefined,
	      lineJoin: undefined,
	      lineWidth: undefined,
	      miterLimit: undefined,
	      changed: false
	    };
	
	  }
	
	  if ( WebGLReplay$$1 ) { WebGLLineStringReplay.__proto__ = WebGLReplay$$1; }
	  WebGLLineStringReplay.prototype = Object.create( WebGLReplay$$1 && WebGLReplay$$1.prototype );
	  WebGLLineStringReplay.prototype.constructor = WebGLLineStringReplay;
	
	  /**
	   * Draw one segment.
	   * @private
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   */
	  WebGLLineStringReplay.prototype.drawCoordinates_ = function drawCoordinates_ (flatCoordinates, offset, end, stride) {
	
	    var i, ii;
	    var numVertices = this.vertices.length;
	    var numIndices = this.indices.length;
	    //To save a vertex, the direction of a point is a product of the sign (1 or -1), a prime from
	    //Instruction, and a rounding factor (1 or 2). If the product is even,
	    //we round it. If it is odd, we don't.
	    var lineJoin = this.state_.lineJoin === 'bevel' ? 0 :
	      this.state_.lineJoin === 'miter' ? 1 : 2;
	    var lineCap = this.state_.lineCap === 'butt' ? 0 :
	      this.state_.lineCap === 'square' ? 1 : 2;
	    var closed = lineStringIsClosed(flatCoordinates, offset, end, stride);
	    var startCoords, sign, n;
	    var lastIndex = numIndices;
	    var lastSign = 1;
	    //We need the adjacent vertices to define normals in joins. p0 = last, p1 = current, p2 = next.
	    var p0, p1, p2;
	
	    for (i = offset, ii = end; i < ii; i += stride) {
	
	      n = numVertices / 7;
	
	      p0 = p1;
	      p1 = p2 || [flatCoordinates[i], flatCoordinates[i + 1]];
	      //First vertex.
	      if (i === offset) {
	        p2 = [flatCoordinates[i + stride], flatCoordinates[i + stride + 1]];
	        if (end - offset === stride * 2 && equals(p1, p2)) {
	          break;
	        }
	        if (closed) {
	          //A closed line! Complete the circle.
	          p0 = [flatCoordinates[end - stride * 2],
	            flatCoordinates[end - stride * 2 + 1]];
	
	          startCoords = p2;
	        } else {
	          //Add the first two/four vertices.
	
	          if (lineCap) {
	            numVertices = this.addVertices_([0, 0], p1, p2,
	              lastSign * Instruction$2.BEGIN_LINE_CAP * lineCap, numVertices);
	
	            numVertices = this.addVertices_([0, 0], p1, p2,
	              -lastSign * Instruction$2.BEGIN_LINE_CAP * lineCap, numVertices);
	
	            this.indices[numIndices++] = n + 2;
	            this.indices[numIndices++] = n;
	            this.indices[numIndices++] = n + 1;
	
	            this.indices[numIndices++] = n + 1;
	            this.indices[numIndices++] = n + 3;
	            this.indices[numIndices++] = n + 2;
	
	          }
	
	          numVertices = this.addVertices_([0, 0], p1, p2,
	            lastSign * Instruction$2.BEGIN_LINE * (lineCap || 1), numVertices);
	
	          numVertices = this.addVertices_([0, 0], p1, p2,
	            -lastSign * Instruction$2.BEGIN_LINE * (lineCap || 1), numVertices);
	
	          lastIndex = numVertices / 7 - 1;
	
	          continue;
	        }
	      } else if (i === end - stride) {
	        //Last vertex.
	        if (closed) {
	          //Same as the first vertex.
	          p2 = startCoords;
	          break;
	        } else {
	          p0 = p0 || [0, 0];
	
	          numVertices = this.addVertices_(p0, p1, [0, 0],
	            lastSign * Instruction$2.END_LINE * (lineCap || 1), numVertices);
	
	          numVertices = this.addVertices_(p0, p1, [0, 0],
	            -lastSign * Instruction$2.END_LINE * (lineCap || 1), numVertices);
	
	          this.indices[numIndices++] = n;
	          this.indices[numIndices++] = lastIndex - 1;
	          this.indices[numIndices++] = lastIndex;
	
	          this.indices[numIndices++] = lastIndex;
	          this.indices[numIndices++] = n + 1;
	          this.indices[numIndices++] = n;
	
	          if (lineCap) {
	            numVertices = this.addVertices_(p0, p1, [0, 0],
	              lastSign * Instruction$2.END_LINE_CAP * lineCap, numVertices);
	
	            numVertices = this.addVertices_(p0, p1, [0, 0],
	              -lastSign * Instruction$2.END_LINE_CAP * lineCap, numVertices);
	
	            this.indices[numIndices++] = n + 2;
	            this.indices[numIndices++] = n;
	            this.indices[numIndices++] = n + 1;
	
	            this.indices[numIndices++] = n + 1;
	            this.indices[numIndices++] = n + 3;
	            this.indices[numIndices++] = n + 2;
	
	          }
	
	          break;
	        }
	      } else {
	        p2 = [flatCoordinates[i + stride], flatCoordinates[i + stride + 1]];
	      }
	
	      // We group CW and straight lines, thus the not so inituitive CCW checking function.
	      sign = triangleIsCounterClockwise(p0[0], p0[1], p1[0], p1[1], p2[0], p2[1])
	        ? -1 : 1;
	
	      numVertices = this.addVertices_(p0, p1, p2,
	        sign * Instruction$2.BEVEL_FIRST * (lineJoin || 1), numVertices);
	
	      numVertices = this.addVertices_(p0, p1, p2,
	        sign * Instruction$2.BEVEL_SECOND * (lineJoin || 1), numVertices);
	
	      numVertices = this.addVertices_(p0, p1, p2,
	        -sign * Instruction$2.MITER_BOTTOM * (lineJoin || 1), numVertices);
	
	      if (i > offset) {
	        this.indices[numIndices++] = n;
	        this.indices[numIndices++] = lastIndex - 1;
	        this.indices[numIndices++] = lastIndex;
	
	        this.indices[numIndices++] = n + 2;
	        this.indices[numIndices++] = n;
	        this.indices[numIndices++] = lastSign * sign > 0 ? lastIndex : lastIndex - 1;
	      }
	
	      this.indices[numIndices++] = n;
	      this.indices[numIndices++] = n + 2;
	      this.indices[numIndices++] = n + 1;
	
	      lastIndex = n + 2;
	      lastSign = sign;
	
	      //Add miter
	      if (lineJoin) {
	        numVertices = this.addVertices_(p0, p1, p2,
	          sign * Instruction$2.MITER_TOP * lineJoin, numVertices);
	
	        this.indices[numIndices++] = n + 1;
	        this.indices[numIndices++] = n + 3;
	        this.indices[numIndices++] = n;
	      }
	    }
	
	    if (closed) {
	      n = n || numVertices / 7;
	      sign = linearRingIsClockwise([p0[0], p0[1], p1[0], p1[1], p2[0], p2[1]], 0, 6, 2)
	        ? 1 : -1;
	
	      numVertices = this.addVertices_(p0, p1, p2,
	        sign * Instruction$2.BEVEL_FIRST * (lineJoin || 1), numVertices);
	
	      numVertices = this.addVertices_(p0, p1, p2,
	        -sign * Instruction$2.MITER_BOTTOM * (lineJoin || 1), numVertices);
	
	      this.indices[numIndices++] = n;
	      this.indices[numIndices++] = lastIndex - 1;
	      this.indices[numIndices++] = lastIndex;
	
	      this.indices[numIndices++] = n + 1;
	      this.indices[numIndices++] = n;
	      this.indices[numIndices++] = lastSign * sign > 0 ? lastIndex : lastIndex - 1;
	    }
	  };
	
	  /**
	   * @param {Array<number>} p0 Last coordinates.
	   * @param {Array<number>} p1 Current coordinates.
	   * @param {Array<number>} p2 Next coordinates.
	   * @param {number} product Sign, instruction, and rounding product.
	   * @param {number} numVertices Vertex counter.
	   * @return {number} Vertex counter.
	   * @private
	   */
	  WebGLLineStringReplay.prototype.addVertices_ = function addVertices_ (p0, p1, p2, product, numVertices) {
	    this.vertices[numVertices++] = p0[0];
	    this.vertices[numVertices++] = p0[1];
	    this.vertices[numVertices++] = p1[0];
	    this.vertices[numVertices++] = p1[1];
	    this.vertices[numVertices++] = p2[0];
	    this.vertices[numVertices++] = p2[1];
	    this.vertices[numVertices++] = product;
	
	    return numVertices;
	  };
	
	  /**
	   * Check if the linestring can be drawn (i. e. valid).
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   * @return {boolean} The linestring can be drawn.
	   * @private
	   */
	  WebGLLineStringReplay.prototype.isValid_ = function isValid_ (flatCoordinates, offset, end, stride) {
	    var range = end - offset;
	    if (range < stride * 2) {
	      return false;
	    } else if (range === stride * 2) {
	      var firstP = [flatCoordinates[offset], flatCoordinates[offset + 1]];
	      var lastP = [flatCoordinates[offset + stride], flatCoordinates[offset + stride + 1]];
	      return !equals(firstP, lastP);
	    }
	
	    return true;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.drawLineString = function drawLineString (lineStringGeometry, feature) {
	    var flatCoordinates = lineStringGeometry.getFlatCoordinates();
	    var stride = lineStringGeometry.getStride();
	    if (this.isValid_(flatCoordinates, 0, flatCoordinates.length, stride)) {
	      flatCoordinates = translate(flatCoordinates, 0, flatCoordinates.length,
	        stride, -this.origin[0], -this.origin[1]);
	      if (this.state_.changed) {
	        this.styleIndices_.push(this.indices.length);
	        this.state_.changed = false;
	      }
	      this.startIndices.push(this.indices.length);
	      this.startIndicesFeature.push(feature);
	      this.drawCoordinates_(
	        flatCoordinates, 0, flatCoordinates.length, stride);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.drawMultiLineString = function drawMultiLineString (multiLineStringGeometry, feature) {
	    var indexCount = this.indices.length;
	    var ends = multiLineStringGeometry.getEnds();
	    ends.unshift(0);
	    var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
	    var stride = multiLineStringGeometry.getStride();
	    var i, ii;
	    if (ends.length > 1) {
	      for (i = 1, ii = ends.length; i < ii; ++i) {
	        if (this.isValid_(flatCoordinates, ends[i - 1], ends[i], stride)) {
	          var lineString = translate(flatCoordinates, ends[i - 1], ends[i],
	            stride, -this.origin[0], -this.origin[1]);
	          this.drawCoordinates_(
	            lineString, 0, lineString.length, stride);
	        }
	      }
	    }
	    if (this.indices.length > indexCount) {
	      this.startIndices.push(indexCount);
	      this.startIndicesFeature.push(feature);
	      if (this.state_.changed) {
	        this.styleIndices_.push(indexCount);
	        this.state_.changed = false;
	      }
	    }
	  };
	
	  /**
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {Array<Array<number>>} holeFlatCoordinates Hole flat coordinates.
	   * @param {number} stride Stride.
	   */
	  WebGLLineStringReplay.prototype.drawPolygonCoordinates = function drawPolygonCoordinates (flatCoordinates, holeFlatCoordinates, stride) {
	    if (!lineStringIsClosed(flatCoordinates, 0, flatCoordinates.length, stride)) {
	      flatCoordinates.push(flatCoordinates[0]);
	      flatCoordinates.push(flatCoordinates[1]);
	    }
	    this.drawCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
	    if (holeFlatCoordinates.length) {
	      var i, ii;
	      for (i = 0, ii = holeFlatCoordinates.length; i < ii; ++i) {
	        if (!lineStringIsClosed(holeFlatCoordinates[i], 0, holeFlatCoordinates[i].length, stride)) {
	          holeFlatCoordinates[i].push(holeFlatCoordinates[i][0]);
	          holeFlatCoordinates[i].push(holeFlatCoordinates[i][1]);
	        }
	        this.drawCoordinates_(holeFlatCoordinates[i], 0,
	          holeFlatCoordinates[i].length, stride);
	      }
	    }
	  };
	
	  /**
	   * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	   * @param {number=} opt_index Index count.
	   */
	  WebGLLineStringReplay.prototype.setPolygonStyle = function setPolygonStyle (feature, opt_index) {
	    var index = opt_index === undefined ? this.indices.length : opt_index;
	    this.startIndices.push(index);
	    this.startIndicesFeature.push(feature);
	    if (this.state_.changed) {
	      this.styleIndices_.push(index);
	      this.state_.changed = false;
	    }
	  };
	
	  /**
	   * @return {number} Current index.
	   */
	  WebGLLineStringReplay.prototype.getCurrentIndex = function getCurrentIndex () {
	    return this.indices.length;
	  };
	
	  /**
	   * @inheritDoc
	   **/
	  WebGLLineStringReplay.prototype.finish = function finish (context) {
	    // create, bind, and populate the vertices buffer
	    this.verticesBuffer = new WebGLBuffer(this.vertices);
	
	    // create, bind, and populate the indices buffer
	    this.indicesBuffer = new WebGLBuffer(this.indices);
	
	    this.startIndices.push(this.indices.length);
	
	    //Clean up, if there is nothing to draw
	    if (this.styleIndices_.length === 0 && this.styles_.length > 0) {
	      this.styles_ = [];
	    }
	
	    this.vertices = null;
	    this.indices = null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.getDeleteResourcesFunction = function getDeleteResourcesFunction (context) {
	    var verticesBuffer = this.verticesBuffer;
	    var indicesBuffer = this.indicesBuffer;
	    return function() {
	      context.deleteBuffer(verticesBuffer);
	      context.deleteBuffer(indicesBuffer);
	    };
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.setUpProgram = function setUpProgram (gl, context, size, pixelRatio) {
	    // get the program
	    var program = context.getProgram(fragment$2, vertex$2);
	
	    // get the locations
	    var locations;
	    if (!this.defaultLocations_) {
	      locations = new Locations$2(gl, program);
	      this.defaultLocations_ = locations;
	    } else {
	      locations = this.defaultLocations_;
	    }
	
	    context.useProgram(program);
	
	    // enable the vertex attrib arrays
	    gl.enableVertexAttribArray(locations.a_lastPos);
	    gl.vertexAttribPointer(locations.a_lastPos, 2, FLOAT,
	      false, 28, 0);
	
	    gl.enableVertexAttribArray(locations.a_position);
	    gl.vertexAttribPointer(locations.a_position, 2, FLOAT,
	      false, 28, 8);
	
	    gl.enableVertexAttribArray(locations.a_nextPos);
	    gl.vertexAttribPointer(locations.a_nextPos, 2, FLOAT,
	      false, 28, 16);
	
	    gl.enableVertexAttribArray(locations.a_direction);
	    gl.vertexAttribPointer(locations.a_direction, 1, FLOAT,
	      false, 28, 24);
	
	    // Enable renderer specific uniforms.
	    gl.uniform2fv(locations.u_size, size);
	    gl.uniform1f(locations.u_pixelRatio, pixelRatio);
	
	    return locations;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.shutDownProgram = function shutDownProgram (gl, locations) {
	    gl.disableVertexAttribArray(locations.a_lastPos);
	    gl.disableVertexAttribArray(locations.a_position);
	    gl.disableVertexAttribArray(locations.a_nextPos);
	    gl.disableVertexAttribArray(locations.a_direction);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.drawReplay = function drawReplay (gl, context, skippedFeaturesHash, hitDetection) {
	    //Save GL parameters.
	    var tmpDepthFunc = /** @type {number} */ (gl.getParameter(gl.DEPTH_FUNC));
	    var tmpDepthMask = /** @type {boolean} */ (gl.getParameter(gl.DEPTH_WRITEMASK));
	
	    if (!hitDetection) {
	      gl.enable(gl.DEPTH_TEST);
	      gl.depthMask(true);
	      gl.depthFunc(gl.NOTEQUAL);
	    }
	
	    if (!isEmpty(skippedFeaturesHash)) {
	      this.drawReplaySkipping_(gl, context, skippedFeaturesHash);
	    } else {
	      //Draw by style groups to minimize drawElements() calls.
	      var i, start, end, nextStyle;
	      end = this.startIndices[this.startIndices.length - 1];
	      for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	        start = this.styleIndices_[i];
	        nextStyle = this.styles_[i];
	        this.setStrokeStyle_(gl, nextStyle[0], nextStyle[1], nextStyle[2]);
	        this.drawElements(gl, context, start, end);
	        gl.clear(gl.DEPTH_BUFFER_BIT);
	        end = start;
	      }
	    }
	    if (!hitDetection) {
	      gl.disable(gl.DEPTH_TEST);
	      gl.clear(gl.DEPTH_BUFFER_BIT);
	      //Restore GL parameters.
	      gl.depthMask(tmpDepthMask);
	      gl.depthFunc(tmpDepthFunc);
	    }
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object} skippedFeaturesHash Ids of features to skip.
	   */
	  WebGLLineStringReplay.prototype.drawReplaySkipping_ = function drawReplaySkipping_ (gl, context, skippedFeaturesHash) {
	    var i, start, end, nextStyle, groupStart, feature, featureIndex, featureStart;
	    featureIndex = this.startIndices.length - 2;
	    end = start = this.startIndices[featureIndex + 1];
	    for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	      nextStyle = this.styles_[i];
	      this.setStrokeStyle_(gl, nextStyle[0], nextStyle[1], nextStyle[2]);
	      groupStart = this.styleIndices_[i];
	
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        featureStart = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)]) {
	          if (start !== end) {
	            this.drawElements(gl, context, start, end);
	            gl.clear(gl.DEPTH_BUFFER_BIT);
	          }
	          end = featureStart;
	        }
	        featureIndex--;
	        start = featureStart;
	      }
	      if (start !== end) {
	        this.drawElements(gl, context, start, end);
	        gl.clear(gl.DEPTH_BUFFER_BIT);
	      }
	      start = end = groupStart;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.drawHitDetectionReplayOneByOne = function drawHitDetectionReplayOneByOne (gl, context, skippedFeaturesHash, featureCallback, opt_hitExtent) {
	    var i, start, end, nextStyle, groupStart, feature, featureIndex;
	    featureIndex = this.startIndices.length - 2;
	    end = this.startIndices[featureIndex + 1];
	    for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	      nextStyle = this.styles_[i];
	      this.setStrokeStyle_(gl, nextStyle[0], nextStyle[1], nextStyle[2]);
	      groupStart = this.styleIndices_[i];
	
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        start = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)] === undefined &&
	            feature.getGeometry() &&
	            (opt_hitExtent === undefined || intersects(
	              /** @type {Array<number>} */ (opt_hitExtent),
	              feature.getGeometry().getExtent()))) {
	          gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	          this.drawElements(gl, context, start, end);
	
	          var result = featureCallback(feature);
	
	          if (result) {
	            return result;
	          }
	
	        }
	        featureIndex--;
	        end = start;
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {Array<number>} color Color.
	   * @param {number} lineWidth Line width.
	   * @param {number} miterLimit Miter limit.
	   */
	  WebGLLineStringReplay.prototype.setStrokeStyle_ = function setStrokeStyle_ (gl, color, lineWidth, miterLimit) {
	    gl.uniform4fv(this.defaultLocations_.u_color, color);
	    gl.uniform1f(this.defaultLocations_.u_lineWidth, lineWidth);
	    gl.uniform1f(this.defaultLocations_.u_miterLimit, miterLimit);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLLineStringReplay.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {
	    var strokeStyleLineCap = strokeStyle.getLineCap();
	    this.state_.lineCap = strokeStyleLineCap !== undefined ?
	      strokeStyleLineCap : DEFAULT_LINECAP;
	    var strokeStyleLineDash = strokeStyle.getLineDash();
	    this.state_.lineDash = strokeStyleLineDash ?
	      strokeStyleLineDash : DEFAULT_LINEDASH;
	    var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
	    this.state_.lineDashOffset = strokeStyleLineDashOffset ?
	      strokeStyleLineDashOffset : DEFAULT_LINEDASHOFFSET;
	    var strokeStyleLineJoin = strokeStyle.getLineJoin();
	    this.state_.lineJoin = strokeStyleLineJoin !== undefined ?
	      strokeStyleLineJoin : DEFAULT_LINEJOIN;
	    var strokeStyleColor = strokeStyle.getColor();
	    if (!(strokeStyleColor instanceof CanvasGradient) &&
	        !(strokeStyleColor instanceof CanvasPattern)) {
	      strokeStyleColor = asArray(strokeStyleColor).map(function(c, i) {
	        return i != 3 ? c / 255 : c;
	      }) || DEFAULT_STROKESTYLE;
	    } else {
	      strokeStyleColor = DEFAULT_STROKESTYLE;
	    }
	    var strokeStyleWidth = strokeStyle.getWidth();
	    strokeStyleWidth = strokeStyleWidth !== undefined ?
	      strokeStyleWidth : DEFAULT_LINEWIDTH;
	    var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
	    strokeStyleMiterLimit = strokeStyleMiterLimit !== undefined ?
	      strokeStyleMiterLimit : DEFAULT_MITERLIMIT;
	    if (!this.state_.strokeColor || !equals(this.state_.strokeColor, strokeStyleColor) ||
	        this.state_.lineWidth !== strokeStyleWidth || this.state_.miterLimit !== strokeStyleMiterLimit) {
	      this.state_.changed = true;
	      this.state_.strokeColor = strokeStyleColor;
	      this.state_.lineWidth = strokeStyleWidth;
	      this.state_.miterLimit = strokeStyleMiterLimit;
	      this.styles_.push([strokeStyleColor, strokeStyleWidth, strokeStyleMiterLimit]);
	    }
	  };
	
	  return WebGLLineStringReplay;
	}(WebGLReplay));
	
	/**
	 * @module ol/render/webgl/polygonreplay/defaultshader
	 */
	
	var fragment$3 = new WebGLFragment('precision mediump float;\n\n\n\nuniform vec4 u_color;\nuniform float u_opacity;\n\nvoid main(void) {\n  gl_FragColor = u_color;\n  float alpha = u_color.a * u_opacity;\n  if (alpha == 0.0) {\n    discard;\n  }\n  gl_FragColor.a = alpha;\n}\n');
	
	var vertex$3 = new WebGLVertex('\n\nattribute vec2 a_position;\n\nuniform mat4 u_projectionMatrix;\nuniform mat4 u_offsetScaleMatrix;\nuniform mat4 u_offsetRotateMatrix;\n\nvoid main(void) {\n  gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0);\n}\n\n\n');
	
	/**
	 * @module ol/render/webgl/polygonreplay/defaultshader/Locations
	 */
	
	var Locations$3 = function Locations(gl, program) {
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_projectionMatrix = gl.getUniformLocation(
	    program, 'u_projectionMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetScaleMatrix = gl.getUniformLocation(
	    program, 'u_offsetScaleMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_offsetRotateMatrix = gl.getUniformLocation(
	    program, 'u_offsetRotateMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_color = gl.getUniformLocation(
	    program, 'u_color');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_opacity = gl.getUniformLocation(
	    program, 'u_opacity');
	
	  /**
	   * @type {number}
	   */
	  this.a_position = gl.getAttribLocation(
	    program, 'a_position');
	
	};
	
	/**
	 * @module ol/structs/LinkedList
	 */
	
	
	/**
	 * @typedef {Object} Item
	 * @property {Item} [prev]
	 * @property {Item} [next]
	 * @property {?} data
	 */
	
	/**
	 * @classdesc
	 * Creates an empty linked list structure.
	 */
	var LinkedList = function LinkedList(opt_circular) {
	
	  /**
	   * @private
	   * @type {Item|undefined}
	   */
	  this.first_;
	
	  /**
	   * @private
	   * @type {Item|undefined}
	   */
	  this.last_;
	
	  /**
	   * @private
	   * @type {Item|undefined}
	   */
	  this.head_;
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  this.circular_ = opt_circular === undefined ? true : opt_circular;
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.length_ = 0;
	
	};
	
	/**
	 * Inserts an item into the linked list right after the current one.
	 *
	 * @param {?} data Item data.
	 */
	LinkedList.prototype.insertItem = function insertItem (data) {
	
	  /** @type {Item} */
	  var item = {
	    prev: undefined,
	    next: undefined,
	    data: data
	  };
	
	  var head = this.head_;
	
	  //Initialize the list.
	  if (!head) {
	    this.first_ = item;
	    this.last_ = item;
	    if (this.circular_) {
	      item.next = item;
	      item.prev = item;
	    }
	  } else {
	    //Link the new item to the adjacent ones.
	    var next = head.next;
	    item.prev = head;
	    item.next = next;
	    head.next = item;
	    if (next) {
	      next.prev = item;
	    }
	
	    if (head === this.last_) {
	      this.last_ = item;
	    }
	  }
	  this.head_ = item;
	  this.length_++;
	};
	
	/**
	 * Removes the current item from the list. Sets the cursor to the next item,
	 * if possible.
	 */
	LinkedList.prototype.removeItem = function removeItem () {
	  var head = this.head_;
	  if (head) {
	    var next = head.next;
	    var prev = head.prev;
	    if (next) {
	      next.prev = prev;
	    }
	    if (prev) {
	      prev.next = next;
	    }
	    this.head_ = next || prev;
	
	    if (this.first_ === this.last_) {
	      this.head_ = undefined;
	      this.first_ = undefined;
	      this.last_ = undefined;
	    } else if (this.first_ === head) {
	      this.first_ = this.head_;
	    } else if (this.last_ === head) {
	      this.last_ = prev ? this.head_.prev : this.head_;
	    }
	    this.length_--;
	  }
	};
	
	/**
	 * Sets the cursor to the first item, and returns the associated data.
	 *
	 * @return {?} Item data.
	 */
	LinkedList.prototype.firstItem = function firstItem () {
	  this.head_ = this.first_;
	  if (this.head_) {
	    return this.head_.data;
	  }
	  return undefined;
	};
	
	/**
	* Sets the cursor to the last item, and returns the associated data.
	*
	* @return {?} Item data.
	*/
	LinkedList.prototype.lastItem = function lastItem () {
	  this.head_ = this.last_;
	  if (this.head_) {
	    return this.head_.data;
	  }
	  return undefined;
	};
	
	/**
	 * Sets the cursor to the next item, and returns the associated data.
	 *
	 * @return {?} Item data.
	 */
	LinkedList.prototype.nextItem = function nextItem () {
	  if (this.head_ && this.head_.next) {
	    this.head_ = this.head_.next;
	    return this.head_.data;
	  }
	  return undefined;
	};
	
	/**
	 * Returns the next item's data without moving the cursor.
	 *
	 * @return {?} Item data.
	 */
	LinkedList.prototype.getNextItem = function getNextItem () {
	  if (this.head_ && this.head_.next) {
	    return this.head_.next.data;
	  }
	  return undefined;
	};
	
	/**
	 * Sets the cursor to the previous item, and returns the associated data.
	 *
	 * @return {?} Item data.
	 */
	LinkedList.prototype.prevItem = function prevItem () {
	  if (this.head_ && this.head_.prev) {
	    this.head_ = this.head_.prev;
	    return this.head_.data;
	  }
	  return undefined;
	};
	
	/**
	 * Returns the previous item's data without moving the cursor.
	 *
	 * @return {?} Item data.
	 */
	LinkedList.prototype.getPrevItem = function getPrevItem () {
	  if (this.head_ && this.head_.prev) {
	    return this.head_.prev.data;
	  }
	  return undefined;
	};
	
	/**
	 * Returns the current item's data.
	 *
	 * @return {?} Item data.
	 */
	LinkedList.prototype.getCurrItem = function getCurrItem () {
	  if (this.head_) {
	    return this.head_.data;
	  }
	  return undefined;
	};
	
	/**
	 * Sets the first item of the list. This only works for circular lists, and sets
	 * the last item accordingly.
	 */
	LinkedList.prototype.setFirstItem = function setFirstItem () {
	  if (this.circular_ && this.head_) {
	    this.first_ = this.head_;
	    this.last_ = this.head_.prev;
	  }
	};
	
	/**
	 * Concatenates two lists.
	 * @param {LinkedList} list List to merge into the current list.
	 */
	LinkedList.prototype.concat = function concat (list) {
	  if (list.head_) {
	    if (this.head_) {
	      var end = this.head_.next;
	      this.head_.next = list.first_;
	      list.first_.prev = this.head_;
	      end.prev = list.last_;
	      list.last_.next = end;
	      this.length_ += list.length_;
	    } else {
	      this.head_ = list.head_;
	      this.first_ = list.first_;
	      this.last_ = list.last_;
	      this.length_ = list.length_;
	    }
	    list.head_ = undefined;
	    list.first_ = undefined;
	    list.last_ = undefined;
	    list.length_ = 0;
	  }
	};
	
	/**
	 * Returns the current length of the list.
	 *
	 * @return {number} Length.
	 */
	LinkedList.prototype.getLength = function getLength () {
	  return this.length_;
	};
	
	/**
	 * @module ol/render/webgl/PolygonReplay
	 */
	
	
	/**
	 * @typedef {Object} PolygonVertex
	 * @property {number} x
	 * @property {number} y
	 * @property {number} i
	 * @property {boolean} [reflex]
	 */
	
	/**
	 * @typedef {Object} PolygonSegment
	 * @property {PolygonVertex} p0
	 * @property {PolygonVertex} p1
	 */
	
	
	var WebGLPolygonReplay = /*@__PURE__*/(function (WebGLReplay$$1) {
	  function WebGLPolygonReplay(tolerance, maxExtent) {
	    WebGLReplay$$1.call(this, tolerance, maxExtent);
	
	    this.lineStringReplay = new WebGLLineStringReplay(
	      tolerance, maxExtent);
	
	    /**
	     * @private
	     * @type {import("./polygonreplay/defaultshader/Locations.js").default}
	     */
	    this.defaultLocations_ = null;
	
	    /**
	     * @private
	     * @type {Array<Array<number>>}
	     */
	    this.styles_ = [];
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.styleIndices_ = [];
	
	    /**
	     * @private
	     * @type {{fillColor: (Array<number>|null),
	     *         changed: boolean}|null}
	     */
	    this.state_ = {
	      fillColor: null,
	      changed: false
	    };
	
	  }
	
	  if ( WebGLReplay$$1 ) { WebGLPolygonReplay.__proto__ = WebGLReplay$$1; }
	  WebGLPolygonReplay.prototype = Object.create( WebGLReplay$$1 && WebGLReplay$$1.prototype );
	  WebGLPolygonReplay.prototype.constructor = WebGLPolygonReplay;
	
	  /**
	   * Draw one polygon.
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {Array<Array<number>>} holeFlatCoordinates Hole flat coordinates.
	   * @param {number} stride Stride.
	   * @private
	   */
	  WebGLPolygonReplay.prototype.drawCoordinates_ = function drawCoordinates_ (flatCoordinates, holeFlatCoordinates, stride) {
	    // Triangulate the polygon
	    var outerRing = new LinkedList();
	    var rtree = new RBush();
	    // Initialize the outer ring
	    this.processFlatCoordinates_(flatCoordinates, stride, outerRing, rtree, true);
	    var maxCoords = this.getMaxCoords_(outerRing);
	
	    // Eliminate holes, if there are any
	    if (holeFlatCoordinates.length) {
	      var i, ii;
	      var holeLists = [];
	      for (i = 0, ii = holeFlatCoordinates.length; i < ii; ++i) {
	        var holeList = {
	          list: new LinkedList(),
	          maxCoords: undefined,
	          rtree: new RBush()
	        };
	        holeLists.push(holeList);
	        this.processFlatCoordinates_(holeFlatCoordinates[i],
	          stride, holeList.list, holeList.rtree, false);
	        this.classifyPoints_(holeList.list, holeList.rtree, true);
	        holeList.maxCoords = this.getMaxCoords_(holeList.list);
	      }
	      holeLists.sort(function(a, b) {
	        return b.maxCoords[0] === a.maxCoords[0] ?
	          a.maxCoords[1] - b.maxCoords[1] : b.maxCoords[0] - a.maxCoords[0];
	      });
	      for (i = 0; i < holeLists.length; ++i) {
	        var currList = holeLists[i].list;
	        var start = currList.firstItem();
	        var currItem = start;
	        var intersection = (void 0);
	        do {
	          //TODO: Triangulate holes when they intersect the outer ring.
	          if (this.getIntersections_(currItem, rtree).length) {
	            intersection = true;
	            break;
	          }
	          currItem = currList.nextItem();
	        } while (start !== currItem);
	        if (!intersection) {
	          if (this.bridgeHole_(currList, holeLists[i].maxCoords[0], outerRing, maxCoords[0], rtree)) {
	            rtree.concat(holeLists[i].rtree);
	            this.classifyPoints_(outerRing, rtree, false);
	          }
	        }
	      }
	    } else {
	      this.classifyPoints_(outerRing, rtree, false);
	    }
	    this.triangulate_(outerRing, rtree);
	  };
	
	  /**
	   * Inserts flat coordinates in a linked list and adds them to the vertex buffer.
	   * @private
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} stride Stride.
	   * @param {import("../../structs/LinkedList.js").default} list Linked list.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @param {boolean} clockwise Coordinate order should be clockwise.
	   */
	  WebGLPolygonReplay.prototype.processFlatCoordinates_ = function processFlatCoordinates_ (flatCoordinates, stride, list, rtree, clockwise) {
	    var isClockwise = linearRingIsClockwise(flatCoordinates,
	      0, flatCoordinates.length, stride);
	    var i, ii;
	    var n = this.vertices.length / 2;
	    /** @type {PolygonVertex} */
	    var start;
	    /** @type {PolygonVertex} */
	    var p0;
	    /** @type {PolygonVertex} */
	    var p1;
	    var extents = [];
	    var segments = [];
	    if (clockwise === isClockwise) {
	      start = this.createPoint_(flatCoordinates[0], flatCoordinates[1], n++);
	      p0 = start;
	      for (i = stride, ii = flatCoordinates.length; i < ii; i += stride) {
	        p1 = this.createPoint_(flatCoordinates[i], flatCoordinates[i + 1], n++);
	        segments.push(this.insertItem_(p0, p1, list));
	        extents.push([Math.min(p0.x, p1.x), Math.min(p0.y, p1.y), Math.max(p0.x, p1.x),
	          Math.max(p0.y, p1.y)]);
	        p0 = p1;
	      }
	      segments.push(this.insertItem_(p1, start, list));
	      extents.push([Math.min(p0.x, p1.x), Math.min(p0.y, p1.y), Math.max(p0.x, p1.x),
	        Math.max(p0.y, p1.y)]);
	    } else {
	      var end = flatCoordinates.length - stride;
	      start = this.createPoint_(flatCoordinates[end], flatCoordinates[end + 1], n++);
	      p0 = start;
	      for (i = end - stride, ii = 0; i >= ii; i -= stride) {
	        p1 = this.createPoint_(flatCoordinates[i], flatCoordinates[i + 1], n++);
	        segments.push(this.insertItem_(p0, p1, list));
	        extents.push([Math.min(p0.x, p1.x), Math.min(p0.y, p1.y), Math.max(p0.x, p1.x),
	          Math.max(p0.y, p1.y)]);
	        p0 = p1;
	      }
	      segments.push(this.insertItem_(p1, start, list));
	      extents.push([Math.min(p0.x, p1.x), Math.min(p0.y, p1.y), Math.max(p0.x, p1.x),
	        Math.max(p0.y, p1.y)]);
	    }
	    rtree.load(extents, segments);
	  };
	
	  /**
	   * Returns the rightmost coordinates of a polygon on the X axis.
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Polygons ring.
	   * @return {Array<number>} Max X coordinates.
	   */
	  WebGLPolygonReplay.prototype.getMaxCoords_ = function getMaxCoords_ (list) {
	    var start = list.firstItem();
	    var seg = start;
	    var maxCoords = [seg.p0.x, seg.p0.y];
	
	    do {
	      seg = list.nextItem();
	      if (seg.p0.x > maxCoords[0]) {
	        maxCoords = [seg.p0.x, seg.p0.y];
	      }
	    } while (seg !== start);
	
	    return maxCoords;
	  };
	
	  /**
	   * Classifies the points of a polygon list as convex, reflex. Removes collinear vertices.
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Polygon ring.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @param {boolean} ccw The orientation of the polygon is counter-clockwise.
	   * @return {boolean} There were reclassified points.
	   */
	  WebGLPolygonReplay.prototype.classifyPoints_ = function classifyPoints_ (list, rtree, ccw) {
	    var start = list.firstItem();
	    var s0 = start;
	    var s1 = list.nextItem();
	    var pointsReclassified = false;
	    do {
	      var reflex = ccw ? triangleIsCounterClockwise(s1.p1.x,
	        s1.p1.y, s0.p1.x, s0.p1.y, s0.p0.x, s0.p0.y) :
	        triangleIsCounterClockwise(s0.p0.x, s0.p0.y, s0.p1.x,
	          s0.p1.y, s1.p1.x, s1.p1.y);
	      if (reflex === undefined) {
	        this.removeItem_(s0, s1, list, rtree);
	        pointsReclassified = true;
	        if (s1 === start) {
	          start = list.getNextItem();
	        }
	        s1 = s0;
	        list.prevItem();
	      } else if (s0.p1.reflex !== reflex) {
	        s0.p1.reflex = reflex;
	        pointsReclassified = true;
	      }
	      s0 = s1;
	      s1 = list.nextItem();
	    } while (s0 !== start);
	    return pointsReclassified;
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} hole Linked list of the hole.
	   * @param {number} holeMaxX Maximum X value of the hole.
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @param {number} listMaxX Maximum X value of the polygon.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @return {boolean} Bridging was successful.
	   */
	  WebGLPolygonReplay.prototype.bridgeHole_ = function bridgeHole_ (hole, holeMaxX, list, listMaxX, rtree) {
	    var seg = hole.firstItem();
	    while (seg.p1.x !== holeMaxX) {
	      seg = hole.nextItem();
	    }
	
	    var p1 = seg.p1;
	    /** @type {PolygonVertex} */
	    var p2 = {x: listMaxX, y: p1.y, i: -1};
	    var minDist = Infinity;
	    var i, ii, bestPoint;
	    /** @type {PolygonVertex} */
	    var p5;
	
	    var intersectingSegments = this.getIntersections_({p0: p1, p1: p2}, rtree, true);
	    for (i = 0, ii = intersectingSegments.length; i < ii; ++i) {
	      var currSeg = intersectingSegments[i];
	      var intersection = this.calculateIntersection_(p1, p2, currSeg.p0,
	        currSeg.p1, true);
	      var dist = Math.abs(p1.x - intersection[0]);
	      if (dist < minDist && triangleIsCounterClockwise(p1.x, p1.y,
	        currSeg.p0.x, currSeg.p0.y, currSeg.p1.x, currSeg.p1.y) !== undefined) {
	        minDist = dist;
	        p5 = {x: intersection[0], y: intersection[1], i: -1};
	        seg = currSeg;
	      }
	    }
	    if (minDist === Infinity) {
	      return false;
	    }
	    bestPoint = seg.p1;
	
	    if (minDist > 0) {
	      var pointsInTriangle = this.getPointsInTriangle_(p1, p5, seg.p1, rtree);
	      if (pointsInTriangle.length) {
	        var theta = Infinity;
	        for (i = 0, ii = pointsInTriangle.length; i < ii; ++i) {
	          var currPoint = pointsInTriangle[i];
	          var currTheta = Math.atan2(p1.y - currPoint.y, p2.x - currPoint.x);
	          if (currTheta < theta || (currTheta === theta && currPoint.x < bestPoint.x)) {
	            theta = currTheta;
	            bestPoint = currPoint;
	          }
	        }
	      }
	    }
	
	    seg = list.firstItem();
	    while (seg.p1.x !== bestPoint.x || seg.p1.y !== bestPoint.y) {
	      seg = list.nextItem();
	    }
	
	    //We clone the bridge points as they can have different convexity.
	    var p0Bridge = {x: p1.x, y: p1.y, i: p1.i, reflex: undefined};
	    var p1Bridge = {x: seg.p1.x, y: seg.p1.y, i: seg.p1.i, reflex: undefined};
	
	    hole.getNextItem().p0 = p0Bridge;
	    this.insertItem_(p1, seg.p1, hole, rtree);
	    this.insertItem_(p1Bridge, p0Bridge, hole, rtree);
	    seg.p1 = p1Bridge;
	    hole.setFirstItem();
	    list.concat(hole);
	
	    return true;
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   */
	  WebGLPolygonReplay.prototype.triangulate_ = function triangulate_ (list, rtree) {
	    var ccw = false;
	    var simple = this.isSimple_(list, rtree);
	
	    // Start clipping ears
	    while (list.getLength() > 3) {
	      if (simple) {
	        if (!this.clipEars_(list, rtree, simple, ccw)) {
	          if (!this.classifyPoints_(list, rtree, ccw)) {
	            // Due to the behavior of OL's PIP algorithm, the ear clipping cannot
	            // introduce touching segments. However, the original data may have some.
	            if (!this.resolveSelfIntersections_(list, rtree, true)) {
	              break;
	            }
	          }
	        }
	      } else {
	        if (!this.clipEars_(list, rtree, simple, ccw)) {
	          // We ran out of ears, try to reclassify.
	          if (!this.classifyPoints_(list, rtree, ccw)) {
	            // We have a bad polygon, try to resolve local self-intersections.
	            if (!this.resolveSelfIntersections_(list, rtree)) {
	              simple = this.isSimple_(list, rtree);
	              if (!simple) {
	                // We have a really bad polygon, try more time consuming methods.
	                this.splitPolygon_(list, rtree);
	                break;
	              } else {
	                ccw = !this.isClockwise_(list);
	                this.classifyPoints_(list, rtree, ccw);
	              }
	            }
	          }
	        }
	      }
	    }
	    if (list.getLength() === 3) {
	      var numIndices = this.indices.length;
	      this.indices[numIndices++] = list.getPrevItem().p0.i;
	      this.indices[numIndices++] = list.getCurrItem().p0.i;
	      this.indices[numIndices++] = list.getNextItem().p0.i;
	    }
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @param {boolean} simple The polygon is simple.
	   * @param {boolean} ccw Orientation of the polygon is counter-clockwise.
	   * @return {boolean} There were processed ears.
	   */
	  WebGLPolygonReplay.prototype.clipEars_ = function clipEars_ (list, rtree, simple, ccw) {
	    var numIndices = this.indices.length;
	    var start = list.firstItem();
	    var s0 = list.getPrevItem();
	    var s1 = start;
	    var s2 = list.nextItem();
	    var s3 = list.getNextItem();
	    var p0, p1, p2;
	    var processedEars = false;
	    do {
	      p0 = s1.p0;
	      p1 = s1.p1;
	      p2 = s2.p1;
	      if (p1.reflex === false) {
	        // We might have a valid ear
	        var variableCriterion = (void 0);
	        if (simple) {
	          variableCriterion = this.getPointsInTriangle_(p0, p1, p2, rtree, true).length === 0;
	        } else {
	          variableCriterion = ccw ? this.diagonalIsInside_(s3.p1, p2, p1, p0,
	            s0.p0) : this.diagonalIsInside_(s0.p0, p0, p1, p2, s3.p1);
	        }
	        if ((simple || this.getIntersections_({p0: p0, p1: p2}, rtree).length === 0) &&
	            variableCriterion) {
	          //The diagonal is completely inside the polygon
	          if (simple || p0.reflex === false || p2.reflex === false ||
	              linearRingIsClockwise([s0.p0.x, s0.p0.y, p0.x,
	                p0.y, p1.x, p1.y, p2.x, p2.y, s3.p1.x, s3.p1.y], 0, 10, 2) === !ccw) {
	            //The diagonal is persumably valid, we have an ear
	            this.indices[numIndices++] = p0.i;
	            this.indices[numIndices++] = p1.i;
	            this.indices[numIndices++] = p2.i;
	            this.removeItem_(s1, s2, list, rtree);
	            if (s2 === start) {
	              start = s3;
	            }
	            processedEars = true;
	          }
	        }
	      }
	      // Else we have a reflex point.
	      s0 = list.getPrevItem();
	      s1 = list.getCurrItem();
	      s2 = list.nextItem();
	      s3 = list.getNextItem();
	    } while (s1 !== start && list.getLength() > 3);
	
	    return processedEars;
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @param {boolean=} opt_touch Resolve touching segments.
	   * @return {boolean} There were resolved intersections.
	  */
	  WebGLPolygonReplay.prototype.resolveSelfIntersections_ = function resolveSelfIntersections_ (list, rtree, opt_touch) {
	    var start = list.firstItem();
	    list.nextItem();
	    var s0 = start;
	    var s1 = list.nextItem();
	    var resolvedIntersections = false;
	
	    do {
	      var intersection = this.calculateIntersection_(s0.p0, s0.p1, s1.p0, s1.p1,
	        opt_touch);
	      if (intersection) {
	        var breakCond = false;
	        var numVertices = this.vertices.length;
	        var numIndices = this.indices.length;
	        var n = numVertices / 2;
	        var seg = list.prevItem();
	        list.removeItem();
	        rtree.remove(seg);
	        breakCond = (seg === start);
	        var p = (void 0);
	        if (opt_touch) {
	          if (intersection[0] === s0.p0.x && intersection[1] === s0.p0.y) {
	            list.prevItem();
	            p = s0.p0;
	            s1.p0 = p;
	            rtree.remove(s0);
	            breakCond = breakCond || (s0 === start);
	          } else {
	            p = s1.p1;
	            s0.p1 = p;
	            rtree.remove(s1);
	            breakCond = breakCond || (s1 === start);
	          }
	          list.removeItem();
	        } else {
	          p = this.createPoint_(intersection[0], intersection[1], n);
	          s0.p1 = p;
	          s1.p0 = p;
	          rtree.update([Math.min(s0.p0.x, s0.p1.x), Math.min(s0.p0.y, s0.p1.y),
	            Math.max(s0.p0.x, s0.p1.x), Math.max(s0.p0.y, s0.p1.y)], s0);
	          rtree.update([Math.min(s1.p0.x, s1.p1.x), Math.min(s1.p0.y, s1.p1.y),
	            Math.max(s1.p0.x, s1.p1.x), Math.max(s1.p0.y, s1.p1.y)], s1);
	        }
	
	        this.indices[numIndices++] = seg.p0.i;
	        this.indices[numIndices++] = seg.p1.i;
	        this.indices[numIndices++] = p.i;
	
	        resolvedIntersections = true;
	        if (breakCond) {
	          break;
	        }
	      }
	
	      s0 = list.getPrevItem();
	      s1 = list.nextItem();
	    } while (s0 !== start);
	    return resolvedIntersections;
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @return {boolean} The polygon is simple.
	   */
	  WebGLPolygonReplay.prototype.isSimple_ = function isSimple_ (list, rtree) {
	    var start = list.firstItem();
	    var seg = start;
	    do {
	      if (this.getIntersections_(seg, rtree).length) {
	        return false;
	      }
	      seg = list.nextItem();
	    } while (seg !== start);
	    return true;
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @return {boolean} Orientation is clockwise.
	   */
	  WebGLPolygonReplay.prototype.isClockwise_ = function isClockwise_ (list) {
	    var length = list.getLength() * 2;
	    var flatCoordinates = new Array(length);
	    var start = list.firstItem();
	    var seg = start;
	    var i = 0;
	    do {
	      flatCoordinates[i++] = seg.p0.x;
	      flatCoordinates[i++] = seg.p0.y;
	      seg = list.nextItem();
	    } while (seg !== start);
	    return linearRingIsClockwise(flatCoordinates, 0, length, 2);
	  };
	
	  /**
	   * @private
	   * @param {import("../../structs/LinkedList.js").default} list Linked list of the polygon.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   */
	  WebGLPolygonReplay.prototype.splitPolygon_ = function splitPolygon_ (list, rtree) {
	    var start = list.firstItem();
	    var s0 = start;
	    do {
	      var intersections = this.getIntersections_(s0, rtree);
	      if (intersections.length) {
	        var s1 = intersections[0];
	        var n = this.vertices.length / 2;
	        var intersection = this.calculateIntersection_(s0.p0,
	          s0.p1, s1.p0, s1.p1);
	        var p = this.createPoint_(intersection[0], intersection[1], n);
	        var newPolygon = new LinkedList();
	        var newRtree = new RBush();
	        this.insertItem_(p, s0.p1, newPolygon, newRtree);
	        s0.p1 = p;
	        rtree.update([Math.min(s0.p0.x, p.x), Math.min(s0.p0.y, p.y),
	          Math.max(s0.p0.x, p.x), Math.max(s0.p0.y, p.y)], s0);
	        var currItem = list.nextItem();
	        while (currItem !== s1) {
	          this.insertItem_(currItem.p0, currItem.p1, newPolygon, newRtree);
	          rtree.remove(currItem);
	          list.removeItem();
	          currItem = list.getCurrItem();
	        }
	        this.insertItem_(s1.p0, p, newPolygon, newRtree);
	        s1.p0 = p;
	        rtree.update([Math.min(s1.p1.x, p.x), Math.min(s1.p1.y, p.y),
	          Math.max(s1.p1.x, p.x), Math.max(s1.p1.y, p.y)], s1);
	        this.classifyPoints_(list, rtree, false);
	        this.triangulate_(list, rtree);
	        this.classifyPoints_(newPolygon, newRtree, false);
	        this.triangulate_(newPolygon, newRtree);
	        break;
	      }
	      s0 = list.nextItem();
	    } while (s0 !== start);
	  };
	
	  /**
	   * @private
	   * @param {number} x X coordinate.
	   * @param {number} y Y coordinate.
	   * @param {number} i Index.
	   * @return {PolygonVertex} List item.
	   */
	  WebGLPolygonReplay.prototype.createPoint_ = function createPoint_ (x, y, i) {
	    var numVertices = this.vertices.length;
	    this.vertices[numVertices++] = x;
	    this.vertices[numVertices++] = y;
	    /** @type {PolygonVertex} */
	    var p = {
	      x: x,
	      y: y,
	      i: i,
	      reflex: undefined
	    };
	    return p;
	  };
	
	  /**
	   * @private
	   * @param {PolygonVertex} p0 First point of segment.
	   * @param {PolygonVertex} p1 Second point of segment.
	   * @param {import("../../structs/LinkedList.js").default} list Polygon ring.
	   * @param {import("../../structs/RBush.js").default=} opt_rtree Insert the segment into the R-Tree.
	   * @return {PolygonSegment} segment.
	   */
	  WebGLPolygonReplay.prototype.insertItem_ = function insertItem_ (p0, p1, list, opt_rtree) {
	    var seg = {
	      p0: p0,
	      p1: p1
	    };
	    list.insertItem(seg);
	    if (opt_rtree) {
	      opt_rtree.insert([Math.min(p0.x, p1.x), Math.min(p0.y, p1.y),
	        Math.max(p0.x, p1.x), Math.max(p0.y, p1.y)], seg);
	    }
	    return seg;
	  };
	
	  /**
	    * @private
	    * @param {PolygonSegment} s0 Segment before the remove candidate.
	    * @param {PolygonSegment} s1 Remove candidate segment.
	    * @param {import("../../structs/LinkedList.js").default} list Polygon ring.
	    * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	    */
	  WebGLPolygonReplay.prototype.removeItem_ = function removeItem_ (s0, s1, list, rtree) {
	    if (list.getCurrItem() === s1) {
	      list.removeItem();
	      s0.p1 = s1.p1;
	      rtree.remove(s1);
	      rtree.update([Math.min(s0.p0.x, s0.p1.x), Math.min(s0.p0.y, s0.p1.y),
	        Math.max(s0.p0.x, s0.p1.x), Math.max(s0.p0.y, s0.p1.y)], s0);
	    }
	  };
	
	  /**
	   * @private
	   * @param {PolygonVertex} p0 First point.
	   * @param {PolygonVertex} p1 Second point.
	   * @param {PolygonVertex} p2 Third point.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @param {boolean=} opt_reflex Only include reflex points.
	   * @return {Array<PolygonVertex>} Points in the triangle.
	   */
	  WebGLPolygonReplay.prototype.getPointsInTriangle_ = function getPointsInTriangle_ (p0, p1, p2, rtree, opt_reflex) {
	    var result = [];
	    var segmentsInExtent = rtree.getInExtent([Math.min(p0.x, p1.x, p2.x),
	      Math.min(p0.y, p1.y, p2.y), Math.max(p0.x, p1.x, p2.x), Math.max(p0.y,
	        p1.y, p2.y)]);
	    for (var i = 0, ii = segmentsInExtent.length; i < ii; ++i) {
	      for (var j in segmentsInExtent[i]) {
	        var p = segmentsInExtent[i][j];
	        if (typeof p === 'object' && (!opt_reflex || p.reflex)) {
	          if ((p.x !== p0.x || p.y !== p0.y) && (p.x !== p1.x || p.y !== p1.y) &&
	              (p.x !== p2.x || p.y !== p2.y) && result.indexOf(p) === -1 &&
	              linearRingContainsXY([p0.x, p0.y, p1.x, p1.y, p2.x, p2.y], 0, 6, 2, p.x, p.y)) {
	            result.push(p);
	          }
	        }
	      }
	    }
	    return result;
	  };
	
	  /**
	   * @private
	   * @param {PolygonSegment} segment Segment.
	   * @param {import("../../structs/RBush.js").default} rtree R-Tree of the polygon.
	   * @param {boolean=} opt_touch Touching segments should be considered an intersection.
	   * @return {Array<PolygonSegment>} Intersecting segments.
	   */
	  WebGLPolygonReplay.prototype.getIntersections_ = function getIntersections_ (segment, rtree, opt_touch) {
	    var p0 = segment.p0;
	    var p1 = segment.p1;
	    var segmentsInExtent = rtree.getInExtent([Math.min(p0.x, p1.x),
	      Math.min(p0.y, p1.y), Math.max(p0.x, p1.x), Math.max(p0.y, p1.y)]);
	    var result = [];
	    for (var i = 0, ii = segmentsInExtent.length; i < ii; ++i) {
	      var currSeg = segmentsInExtent[i];
	      if (segment !== currSeg && (opt_touch || currSeg.p0 !== p1 || currSeg.p1 !== p0) &&
	          this.calculateIntersection_(p0, p1, currSeg.p0, currSeg.p1, opt_touch)) {
	        result.push(currSeg);
	      }
	    }
	    return result;
	  };
	
	  /**
	   * Line intersection algorithm by Paul Bourke.
	   * See http://paulbourke.net/geometry/pointlineplane/.
	   *
	   * @private
	   * @param {PolygonVertex} p0 First point.
	   * @param {PolygonVertex} p1 Second point.
	   * @param {PolygonVertex} p2 Third point.
	   * @param {PolygonVertex} p3 Fourth point.
	   * @param {boolean=} opt_touch Touching segments should be considered an intersection.
	   * @return {Array<number>|undefined} Intersection coordinates.
	   */
	  WebGLPolygonReplay.prototype.calculateIntersection_ = function calculateIntersection_ (p0, p1, p2, p3, opt_touch) {
	    var denom = (p3.y - p2.y) * (p1.x - p0.x) - (p3.x - p2.x) * (p1.y - p0.y);
	    if (denom !== 0) {
	      var ua = ((p3.x - p2.x) * (p0.y - p2.y) - (p3.y - p2.y) * (p0.x - p2.x)) / denom;
	      var ub = ((p1.x - p0.x) * (p0.y - p2.y) - (p1.y - p0.y) * (p0.x - p2.x)) / denom;
	      if ((!opt_touch && ua > EPSILON && ua < 1 - EPSILON &&
	          ub > EPSILON && ub < 1 - EPSILON) || (opt_touch &&
	          ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1)) {
	        return [p0.x + ua * (p1.x - p0.x), p0.y + ua * (p1.y - p0.y)];
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @private
	   * @param {PolygonVertex} p0 Point before the start of the diagonal.
	   * @param {PolygonVertex} p1 Start point of the diagonal.
	   * @param {PolygonVertex} p2 Ear candidate.
	   * @param {PolygonVertex} p3 End point of the diagonal.
	   * @param {PolygonVertex} p4 Point after the end of the diagonal.
	   * @return {boolean} Diagonal is inside the polygon.
	   */
	  WebGLPolygonReplay.prototype.diagonalIsInside_ = function diagonalIsInside_ (p0, p1, p2, p3, p4) {
	    if (p1.reflex === undefined || p3.reflex === undefined) {
	      return false;
	    }
	    var p1IsLeftOf = (p2.x - p3.x) * (p1.y - p3.y) > (p2.y - p3.y) * (p1.x - p3.x);
	    var p1IsRightOf = (p4.x - p3.x) * (p1.y - p3.y) < (p4.y - p3.y) * (p1.x - p3.x);
	    var p3IsLeftOf = (p0.x - p1.x) * (p3.y - p1.y) > (p0.y - p1.y) * (p3.x - p1.x);
	    var p3IsRightOf = (p2.x - p1.x) * (p3.y - p1.y) < (p2.y - p1.y) * (p3.x - p1.x);
	    var p1InCone = p3.reflex ? p1IsRightOf || p1IsLeftOf : p1IsRightOf && p1IsLeftOf;
	    var p3InCone = p1.reflex ? p3IsRightOf || p3IsLeftOf : p3IsRightOf && p3IsLeftOf;
	    return p1InCone && p3InCone;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.drawMultiPolygon = function drawMultiPolygon (multiPolygonGeometry, feature) {
	    var endss = multiPolygonGeometry.getEndss();
	    var stride = multiPolygonGeometry.getStride();
	    var currIndex = this.indices.length;
	    var currLineIndex = this.lineStringReplay.getCurrentIndex();
	    var flatCoordinates = multiPolygonGeometry.getFlatCoordinates();
	    var i, ii, j, jj;
	    var start = 0;
	    for (i = 0, ii = endss.length; i < ii; ++i) {
	      var ends = endss[i];
	      if (ends.length > 0) {
	        var outerRing = translate(flatCoordinates, start, ends[0],
	          stride, -this.origin[0], -this.origin[1]);
	        if (outerRing.length) {
	          var holes = [];
	          var holeFlatCoords = (void 0);
	          for (j = 1, jj = ends.length; j < jj; ++j) {
	            if (ends[j] !== ends[j - 1]) {
	              holeFlatCoords = translate(flatCoordinates, ends[j - 1],
	                ends[j], stride, -this.origin[0], -this.origin[1]);
	              holes.push(holeFlatCoords);
	            }
	          }
	          this.lineStringReplay.drawPolygonCoordinates(outerRing, holes, stride);
	          this.drawCoordinates_(outerRing, holes, stride);
	        }
	      }
	      start = ends[ends.length - 1];
	    }
	    if (this.indices.length > currIndex) {
	      this.startIndices.push(currIndex);
	      this.startIndicesFeature.push(feature);
	      if (this.state_.changed) {
	        this.styleIndices_.push(currIndex);
	        this.state_.changed = false;
	      }
	    }
	    if (this.lineStringReplay.getCurrentIndex() > currLineIndex) {
	      this.lineStringReplay.setPolygonStyle(feature, currLineIndex);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.drawPolygon = function drawPolygon (polygonGeometry, feature) {
	    var ends = polygonGeometry.getEnds();
	    var stride = polygonGeometry.getStride();
	    if (ends.length > 0) {
	      var flatCoordinates = polygonGeometry.getFlatCoordinates().map(Number);
	      var outerRing = translate(flatCoordinates, 0, ends[0],
	        stride, -this.origin[0], -this.origin[1]);
	      if (outerRing.length) {
	        var holes = [];
	        var i, ii, holeFlatCoords;
	        for (i = 1, ii = ends.length; i < ii; ++i) {
	          if (ends[i] !== ends[i - 1]) {
	            holeFlatCoords = translate(flatCoordinates, ends[i - 1],
	              ends[i], stride, -this.origin[0], -this.origin[1]);
	            holes.push(holeFlatCoords);
	          }
	        }
	
	        this.startIndices.push(this.indices.length);
	        this.startIndicesFeature.push(feature);
	        if (this.state_.changed) {
	          this.styleIndices_.push(this.indices.length);
	          this.state_.changed = false;
	        }
	        this.lineStringReplay.setPolygonStyle(feature);
	
	        this.lineStringReplay.drawPolygonCoordinates(outerRing, holes, stride);
	        this.drawCoordinates_(outerRing, holes, stride);
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   **/
	  WebGLPolygonReplay.prototype.finish = function finish (context) {
	    // create, bind, and populate the vertices buffer
	    this.verticesBuffer = new WebGLBuffer(this.vertices);
	
	    // create, bind, and populate the indices buffer
	    this.indicesBuffer = new WebGLBuffer(this.indices);
	
	    this.startIndices.push(this.indices.length);
	
	    this.lineStringReplay.finish(context);
	
	    //Clean up, if there is nothing to draw
	    if (this.styleIndices_.length === 0 && this.styles_.length > 0) {
	      this.styles_ = [];
	    }
	
	    this.vertices = null;
	    this.indices = null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.getDeleteResourcesFunction = function getDeleteResourcesFunction (context) {
	    var verticesBuffer = this.verticesBuffer;
	    var indicesBuffer = this.indicesBuffer;
	    var lineDeleter = this.lineStringReplay.getDeleteResourcesFunction(context);
	    return function() {
	      context.deleteBuffer(verticesBuffer);
	      context.deleteBuffer(indicesBuffer);
	      lineDeleter();
	    };
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.setUpProgram = function setUpProgram (gl, context, size, pixelRatio) {
	    // get the program
	    var program = context.getProgram(fragment$3, vertex$3);
	
	    // get the locations
	    var locations;
	    if (!this.defaultLocations_) {
	      locations = new Locations$3(gl, program);
	      this.defaultLocations_ = locations;
	    } else {
	      locations = this.defaultLocations_;
	    }
	
	    context.useProgram(program);
	
	    // enable the vertex attrib arrays
	    gl.enableVertexAttribArray(locations.a_position);
	    gl.vertexAttribPointer(locations.a_position, 2, FLOAT,
	      false, 8, 0);
	
	    return locations;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.shutDownProgram = function shutDownProgram (gl, locations) {
	    gl.disableVertexAttribArray(locations.a_position);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.drawReplay = function drawReplay (gl, context, skippedFeaturesHash, hitDetection) {
	    //Save GL parameters.
	    var tmpDepthFunc = /** @type {number} */ (gl.getParameter(gl.DEPTH_FUNC));
	    var tmpDepthMask = /** @type {boolean} */ (gl.getParameter(gl.DEPTH_WRITEMASK));
	
	    if (!hitDetection) {
	      gl.enable(gl.DEPTH_TEST);
	      gl.depthMask(true);
	      gl.depthFunc(gl.NOTEQUAL);
	    }
	
	    if (!isEmpty(skippedFeaturesHash)) {
	      this.drawReplaySkipping_(gl, context, skippedFeaturesHash);
	    } else {
	      //Draw by style groups to minimize drawElements() calls.
	      var i, start, end, nextStyle;
	      end = this.startIndices[this.startIndices.length - 1];
	      for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	        start = this.styleIndices_[i];
	        nextStyle = this.styles_[i];
	        this.setFillStyle_(gl, nextStyle);
	        this.drawElements(gl, context, start, end);
	        end = start;
	      }
	    }
	    if (!hitDetection) {
	      gl.disable(gl.DEPTH_TEST);
	      gl.clear(gl.DEPTH_BUFFER_BIT);
	      //Restore GL parameters.
	      gl.depthMask(tmpDepthMask);
	      gl.depthFunc(tmpDepthFunc);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.drawHitDetectionReplayOneByOne = function drawHitDetectionReplayOneByOne (gl, context, skippedFeaturesHash, featureCallback, opt_hitExtent) {
	    var i, start, end, nextStyle, groupStart, feature, featureIndex;
	    featureIndex = this.startIndices.length - 2;
	    end = this.startIndices[featureIndex + 1];
	    for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	      nextStyle = this.styles_[i];
	      this.setFillStyle_(gl, nextStyle);
	      groupStart = this.styleIndices_[i];
	
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        start = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)] === undefined &&
	            feature.getGeometry() &&
	            (opt_hitExtent === undefined || intersects(
	              /** @type {Array<number>} */ (opt_hitExtent),
	              feature.getGeometry().getExtent()))) {
	          gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	          this.drawElements(gl, context, start, end);
	
	          var result = featureCallback(feature);
	
	          if (result) {
	            return result;
	          }
	
	        }
	        featureIndex--;
	        end = start;
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {Object} skippedFeaturesHash Ids of features to skip.
	   */
	  WebGLPolygonReplay.prototype.drawReplaySkipping_ = function drawReplaySkipping_ (gl, context, skippedFeaturesHash) {
	    var i, start, end, nextStyle, groupStart, feature, featureIndex, featureStart;
	    featureIndex = this.startIndices.length - 2;
	    end = start = this.startIndices[featureIndex + 1];
	    for (i = this.styleIndices_.length - 1; i >= 0; --i) {
	      nextStyle = this.styles_[i];
	      this.setFillStyle_(gl, nextStyle);
	      groupStart = this.styleIndices_[i];
	
	      while (featureIndex >= 0 &&
	          this.startIndices[featureIndex] >= groupStart) {
	        featureStart = this.startIndices[featureIndex];
	        feature = this.startIndicesFeature[featureIndex];
	
	        if (skippedFeaturesHash[getUid(feature)]) {
	          if (start !== end) {
	            this.drawElements(gl, context, start, end);
	            gl.clear(gl.DEPTH_BUFFER_BIT);
	          }
	          end = featureStart;
	        }
	        featureIndex--;
	        start = featureStart;
	      }
	      if (start !== end) {
	        this.drawElements(gl, context, start, end);
	        gl.clear(gl.DEPTH_BUFFER_BIT);
	      }
	      start = end = groupStart;
	    }
	  };
	
	  /**
	   * @private
	   * @param {WebGLRenderingContext} gl gl.
	   * @param {Array<number>} color Color.
	   */
	  WebGLPolygonReplay.prototype.setFillStyle_ = function setFillStyle_ (gl, color) {
	    gl.uniform4fv(this.defaultLocations_.u_color, color);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLPolygonReplay.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {
	    var fillStyleColor = fillStyle ? fillStyle.getColor() : [0, 0, 0, 0];
	    if (!(fillStyleColor instanceof CanvasGradient) &&
	        !(fillStyleColor instanceof CanvasPattern)) {
	      fillStyleColor = asArray(fillStyleColor).map(function(c, i) {
	        return i != 3 ? c / 255 : c;
	      }) || DEFAULT_FILLSTYLE;
	    } else {
	      fillStyleColor = DEFAULT_FILLSTYLE;
	    }
	    if (!this.state_.fillColor || !equals(fillStyleColor, this.state_.fillColor)) {
	      this.state_.fillColor = fillStyleColor;
	      this.state_.changed = true;
	      this.styles_.push(fillStyleColor);
	    }
	    //Provide a null stroke style, if no strokeStyle is provided. Required for the draw interaction to work.
	    if (strokeStyle) {
	      this.lineStringReplay.setFillStrokeStyle(null, strokeStyle);
	    } else {
	      var nullStrokeStyle = new Stroke({
	        color: [0, 0, 0, 0],
	        width: 0
	      });
	      this.lineStringReplay.setFillStrokeStyle(null, nullStrokeStyle);
	    }
	  };
	
	  return WebGLPolygonReplay;
	}(WebGLReplay));
	
	/**
	 * @module ol/style/Atlas
	 */
	
	
	/**
	 * @typedef {Object} AtlasBlock
	 * @property {number} x
	 * @property {number} y
	 * @property {number} width
	 * @property {number} height
	 */
	
	/**
	 * Provides information for an image inside an atlas.
	 * `offsetX` and `offsetY` are the position of the image inside the atlas image `image`.
	 * @typedef {Object} AtlasInfo
	 * @property {number} offsetX
	 * @property {number} offsetY
	 * @property {HTMLCanvasElement} image
	 */
	
	
	/**
	 * @classesc
	 * This class facilitates the creation of image atlases.
	 *
	 * Images added to an atlas will be rendered onto a single
	 * atlas canvas. The distribution of images on the canvas is
	 * managed with the bin packing algorithm described in:
	 * http://www.blackpawn.com/texts/lightmaps/
	 *
	 * @param {number} size The size in pixels of the sprite image.
	 * @param {number} space The space in pixels between images.
	 *    Because texture coordinates are float values, the edges of
	 *    images might not be completely correct (in a way that the
	 *    edges overlap when being rendered). To avoid this we add a
	 *    padding around each image.
	 */
	var Atlas = function Atlas(size, space) {
	
	  /**
	   * @private
	   * @type {number}
	   */
	  this.space_ = space;
	
	  /**
	   * @private
	   * @type {Array<AtlasBlock>}
	   */
	  this.emptyBlocks_ = [{x: 0, y: 0, width: size, height: size}];
	
	  /**
	   * @private
	   * @type {Object<string, AtlasInfo>}
	   */
	  this.entries_ = {};
	
	  /**
	   * @private
	   * @type {CanvasRenderingContext2D}
	   */
	  this.context_ = createCanvasContext2D(size, size);
	
	  /**
	   * @private
	   * @type {HTMLCanvasElement}
	   */
	  this.canvas_ = this.context_.canvas;
	};
	
	/**
	 * @param {string} id The identifier of the entry to check.
	 * @return {?AtlasInfo} The atlas info.
	 */
	Atlas.prototype.get = function get (id) {
	  return this.entries_[id] || null;
	};
	
	/**
	 * @param {string} id The identifier of the entry to add.
	 * @param {number} width The width.
	 * @param {number} height The height.
	 * @param {function(CanvasRenderingContext2D, number, number)} renderCallback
	 *  Called to render the new image onto an atlas image.
	 * @param {Object=} opt_this Value to use as `this` when executing
	 *  `renderCallback`.
	 * @return {?AtlasInfo} The position and atlas image for the entry.
	 */
	Atlas.prototype.add = function add (id, width, height, renderCallback, opt_this) {
	  for (var i = 0, ii = this.emptyBlocks_.length; i < ii; ++i) {
	    var block = this.emptyBlocks_[i];
	    if (block.width >= width + this.space_ &&
	        block.height >= height + this.space_) {
	      // we found a block that is big enough for our entry
	      var entry = {
	        offsetX: block.x + this.space_,
	        offsetY: block.y + this.space_,
	        image: this.canvas_
	      };
	      this.entries_[id] = entry;
	
	      // render the image on the atlas image
	      renderCallback.call(opt_this, this.context_,
	        block.x + this.space_, block.y + this.space_);
	
	      // split the block after the insertion, either horizontally or vertically
	      this.split_(i, block, width + this.space_, height + this.space_);
	
	      return entry;
	    }
	  }
	
	  // there is no space for the new entry in this atlas
	  return null;
	};
	
	/**
	 * @private
	 * @param {number} index The index of the block.
	 * @param {AtlasBlock} block The block to split.
	 * @param {number} width The width of the entry to insert.
	 * @param {number} height The height of the entry to insert.
	 */
	Atlas.prototype.split_ = function split_ (index, block, width, height) {
	  var deltaWidth = block.width - width;
	  var deltaHeight = block.height - height;
	
	  /** @type {AtlasBlock} */
	  var newBlock1;
	  /** @type {AtlasBlock} */
	  var newBlock2;
	
	  if (deltaWidth > deltaHeight) {
	    // split vertically
	    // block right of the inserted entry
	    newBlock1 = {
	      x: block.x + width,
	      y: block.y,
	      width: block.width - width,
	      height: block.height
	    };
	
	    // block below the inserted entry
	    newBlock2 = {
	      x: block.x,
	      y: block.y + height,
	      width: width,
	      height: block.height - height
	    };
	    this.updateBlocks_(index, newBlock1, newBlock2);
	  } else {
	    // split horizontally
	    // block right of the inserted entry
	    newBlock1 = {
	      x: block.x + width,
	      y: block.y,
	      width: block.width - width,
	      height: height
	    };
	
	    // block below the inserted entry
	    newBlock2 = {
	      x: block.x,
	      y: block.y + height,
	      width: block.width,
	      height: block.height - height
	    };
	    this.updateBlocks_(index, newBlock1, newBlock2);
	  }
	};
	
	/**
	 * Remove the old block and insert new blocks at the same array position.
	 * The new blocks are inserted at the same position, so that splitted
	 * blocks (that are potentially smaller) are filled first.
	 * @private
	 * @param {number} index The index of the block to remove.
	 * @param {AtlasBlock} newBlock1 The 1st block to add.
	 * @param {AtlasBlock} newBlock2 The 2nd block to add.
	 */
	Atlas.prototype.updateBlocks_ = function updateBlocks_ (index, newBlock1, newBlock2) {
	  var args = /** @type {Array<*>} */ ([index, 1]);
	  if (newBlock1.width > 0 && newBlock1.height > 0) {
	    args.push(newBlock1);
	  }
	  if (newBlock2.width > 0 && newBlock2.height > 0) {
	    args.push(newBlock2);
	  }
	  this.emptyBlocks_.splice.apply(this.emptyBlocks_, args);
	};
	
	/**
	 * @module ol/style/AtlasManager
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [initialSize=256] The size in pixels of the first atlas image.
	 * @property {number} [maxSize] The maximum size in pixels of atlas images. Default is
	 * `webgl/MAX_TEXTURE_SIZE` or 2048 if WebGL is not supported.
	 * @property {number} [space=1] The space in pixels between images.
	 */
	
	
	/**
	 * Provides information for an image inside an atlas manager.
	 * `offsetX` and `offsetY` is the position of the image inside
	 * the atlas image `image` and the position of the hit-detection image
	 * inside the hit-detection atlas image `hitImage`.
	 * @typedef {Object} AtlasManagerInfo
	 * @property {number} offsetX
	 * @property {number} offsetY
	 * @property {HTMLCanvasElement} image
	 * @property {HTMLCanvasElement} hitImage
	 */
	
	
	/**
	 * The size in pixels of the first atlas image.
	 * @type {number}
	 */
	var INITIAL_ATLAS_SIZE = 256;
	
	
	/**
	 * @classdesc
	 * Manages the creation of image atlases.
	 *
	 * Images added to this manager will be inserted into an atlas, which
	 * will be used for rendering.
	 * The `size` given in the constructor is the size for the first
	 * atlas. After that, when new atlases are created, they will have
	 * twice the size as the latest atlas (until `maxSize` is reached).
	 *
	 * If an application uses many images or very large images, it is recommended
	 * to set a higher `size` value to avoid the creation of too many atlases.
	 * @api
	 */
	var AtlasManager = function AtlasManager(opt_options) {
	
	  var options = opt_options || {};
	
	  /**
	   * The size in pixels of the latest atlas image.
	   * @private
	   * @type {number}
	   */
	  this.currentSize_ = options.initialSize !== undefined ?
	    options.initialSize : INITIAL_ATLAS_SIZE;
	
	  /**
	   * The maximum size in pixels of atlas images.
	   * @private
	   * @type {number}
	   */
	  this.maxSize_ = options.maxSize !== undefined ?
	    options.maxSize : MAX_TEXTURE_SIZE !== undefined ?
	        MAX_TEXTURE_SIZE : 2048;
	
	  /**
	   * The size in pixels between images.
	   * @private
	   * @type {number}
	   */
	  this.space_ = options.space !== undefined ? options.space : 1;
	
	  /**
	   * @private
	   * @type {Array<import("./Atlas.js").default>}
	   */
	  this.atlases_ = [new Atlas(this.currentSize_, this.space_)];
	
	  /**
	   * The size in pixels of the latest atlas image for hit-detection images.
	   * @private
	   * @type {number}
	   */
	  this.currentHitSize_ = this.currentSize_;
	
	  /**
	   * @private
	   * @type {Array<import("./Atlas.js").default>}
	   */
	  this.hitAtlases_ = [new Atlas(this.currentHitSize_, this.space_)];
	};
	
	/**
	 * @param {string} id The identifier of the entry to check.
	 * @return {?AtlasManagerInfo} The position and atlas image for the
	 *  entry, or `null` if the entry is not part of the atlas manager.
	 */
	AtlasManager.prototype.getInfo = function getInfo (id) {
	  /** @type {?import("./Atlas.js").AtlasInfo} */
	  var info = this.getInfo_(this.atlases_, id);
	
	  if (!info) {
	    return null;
	  }
	  var hitInfo = /** @type {import("./Atlas.js").AtlasInfo} */ (this.getInfo_(this.hitAtlases_, id));
	
	  return this.mergeInfos_(info, hitInfo);
	};
	
	/**
	 * @private
	 * @param {Array<import("./Atlas.js").default>} atlases The atlases to search.
	 * @param {string} id The identifier of the entry to check.
	 * @return {?import("./Atlas.js").AtlasInfo} The position and atlas image for the entry,
	 *  or `null` if the entry is not part of the atlases.
	 */
	AtlasManager.prototype.getInfo_ = function getInfo_ (atlases, id) {
	  for (var i = 0, ii = atlases.length; i < ii; ++i) {
	    var atlas = atlases[i];
	    var info = atlas.get(id);
	    if (info) {
	      return info;
	    }
	  }
	  return null;
	};
	
	/**
	 * @private
	 * @param {import("./Atlas.js").AtlasInfo} info The info for the real image.
	 * @param {import("./Atlas.js").AtlasInfo} hitInfo The info for the hit-detection
	 *  image.
	 * @return {?AtlasManagerInfo} The position and atlas image for the
	 *  entry, or `null` if the entry is not part of the atlases.
	 */
	AtlasManager.prototype.mergeInfos_ = function mergeInfos_ (info, hitInfo) {
	  return (
	    /** @type {AtlasManagerInfo} */ ({
	      offsetX: info.offsetX,
	      offsetY: info.offsetY,
	      image: info.image,
	      hitImage: hitInfo.image
	    })
	  );
	};
	
	/**
	 * Add an image to the atlas manager.
	 *
	 * If an entry for the given id already exists, the entry will
	 * be overridden (but the space on the atlas graphic will not be freed).
	 *
	 * If `renderHitCallback` is provided, the image (or the hit-detection version
	 * of the image) will be rendered into a separate hit-detection atlas image.
	 *
	 * @param {string} id The identifier of the entry to add.
	 * @param {number} width The width.
	 * @param {number} height The height.
	 * @param {function(CanvasRenderingContext2D, number, number)} renderCallback
	 *  Called to render the new image onto an atlas image.
	 * @param {function(CanvasRenderingContext2D, number, number)=} opt_renderHitCallback Called to render a hit-detection image onto a hit
	 *  detection atlas image.
	 * @param {Object=} opt_this Value to use as `this` when executing
	 *  `renderCallback` and `renderHitCallback`.
	 * @return {?AtlasManagerInfo}The position and atlas image for the
	 *  entry, or `null` if the image is too big.
	 */
	AtlasManager.prototype.add = function add (id, width, height, renderCallback, opt_renderHitCallback, opt_this) {
	  if (width + this.space_ > this.maxSize_ ||
	      height + this.space_ > this.maxSize_) {
	    return null;
	  }
	
	  /** @type {?import("./Atlas.js").AtlasInfo} */
	  var info = this.add_(false, id, width, height, renderCallback, opt_this);
	  if (!info) {
	    return null;
	  }
	
	  // even if no hit-detection entry is requested, we insert a fake entry into
	  // the hit-detection atlas, to make sure that the offset is the same for
	  // the original image and the hit-detection image.
	  var renderHitCallback = opt_renderHitCallback !== undefined ?
	    opt_renderHitCallback : VOID;
	
	  var hitInfo = /** @type {import("./Atlas.js").AtlasInfo} */ (this.add_(true,
	    id, width, height, renderHitCallback, opt_this));
	
	  return this.mergeInfos_(info, hitInfo);
	};
	
	/**
	 * @private
	 * @param {boolean} isHitAtlas If the hit-detection atlases are used.
	 * @param {string} id The identifier of the entry to add.
	 * @param {number} width The width.
	 * @param {number} height The height.
	 * @param {function(CanvasRenderingContext2D, number, number)} renderCallback
	 *  Called to render the new image onto an atlas image.
	 * @param {Object=} opt_this Value to use as `this` when executing
	 *  `renderCallback` and `renderHitCallback`.
	 * @return {?import("./Atlas.js").AtlasInfo}The position and atlas image for the entry,
	 *  or `null` if the image is too big.
	 */
	AtlasManager.prototype.add_ = function add_ (isHitAtlas, id, width, height, renderCallback, opt_this) {
	  var atlases = (isHitAtlas) ? this.hitAtlases_ : this.atlases_;
	  var atlas, info, i, ii;
	  for (i = 0, ii = atlases.length; i < ii; ++i) {
	    atlas = atlases[i];
	    info = atlas.add(id, width, height, renderCallback, opt_this);
	    if (info) {
	      return info;
	    } else if (!info && i === ii - 1) {
	      // the entry could not be added to one of the existing atlases,
	      // create a new atlas that is twice as big and try to add to this one.
	      var size = (void 0);
	      if (isHitAtlas) {
	        size = Math.min(this.currentHitSize_ * 2, this.maxSize_);
	        this.currentHitSize_ = size;
	      } else {
	        size = Math.min(this.currentSize_ * 2, this.maxSize_);
	        this.currentSize_ = size;
	      }
	      atlas = new Atlas(size, this.space_);
	      atlases.push(atlas);
	      // run the loop another time
	      ++ii;
	    }
	  }
	  return null;
	};
	
	/**
	 * @module ol/render/webgl/TextReplay
	 */
	
	/**
	 * @typedef {Object} GlyphAtlas
	 * @property {import("../../style/AtlasManager.js").default} atlas
	 * @property {Object<string, number>} width
	 * @property {number} height
	 */
	
	
	var WebGLTextReplay = /*@__PURE__*/(function (WebGLTextureReplay$$1) {
	  function WebGLTextReplay(tolerance, maxExtent) {
	    WebGLTextureReplay$$1.call(this, tolerance, maxExtent);
	
	    /**
	     * @private
	     * @type {Array<HTMLCanvasElement>}
	     */
	    this.images_ = [];
	
	    /**
	     * @private
	     * @type {Array<WebGLTexture>}
	     */
	    this.textures_ = [];
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.measureCanvas_ = createCanvasContext2D(0, 0).canvas;
	
	    /**
	     * @private
	     * @type {{strokeColor: (import("../../colorlike.js").ColorLike|null),
	     *         lineCap: (string|undefined),
	     *         lineDash: Array<number>,
	     *         lineDashOffset: (number|undefined),
	     *         lineJoin: (string|undefined),
	     *         lineWidth: number,
	     *         miterLimit: (number|undefined),
	     *         fillColor: (import("../../colorlike.js").ColorLike|null),
	     *         font: (string|undefined),
	     *         scale: (number|undefined)}}
	     */
	    this.state_ = {
	      strokeColor: null,
	      lineCap: undefined,
	      lineDash: null,
	      lineDashOffset: undefined,
	      lineJoin: undefined,
	      lineWidth: 0,
	      miterLimit: undefined,
	      fillColor: null,
	      font: undefined,
	      scale: undefined
	    };
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.text_ = '';
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.textAlign_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.textBaseline_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.offsetX_ = undefined;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.offsetY_ = undefined;
	
	    /**
	     * @private
	     * @type {Object<string, GlyphAtlas>}
	     */
	    this.atlases_ = {};
	
	    /**
	     * @private
	     * @type {GlyphAtlas|undefined}
	     */
	    this.currAtlas_ = undefined;
	
	    this.scale = 1;
	
	    this.opacity = 1;
	
	  }
	
	  if ( WebGLTextureReplay$$1 ) { WebGLTextReplay.__proto__ = WebGLTextureReplay$$1; }
	  WebGLTextReplay.prototype = Object.create( WebGLTextureReplay$$1 && WebGLTextureReplay$$1.prototype );
	  WebGLTextReplay.prototype.constructor = WebGLTextReplay;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextReplay.prototype.drawText = function drawText (geometry, feature) {
	    if (this.text_) {
	      var flatCoordinates = null;
	      var offset = 0;
	      var end = 2;
	      var stride = 2;
	      switch (geometry.getType()) {
	        case GeometryType.POINT:
	        case GeometryType.MULTI_POINT:
	          flatCoordinates = geometry.getFlatCoordinates();
	          end = flatCoordinates.length;
	          stride = geometry.getStride();
	          break;
	        case GeometryType.CIRCLE:
	          flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ (geometry).getCenter();
	          break;
	        case GeometryType.LINE_STRING:
	          flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ (geometry).getFlatMidpoint();
	          break;
	        case GeometryType.MULTI_LINE_STRING:
	          flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ (geometry).getFlatMidpoints();
	          end = flatCoordinates.length;
	          break;
	        case GeometryType.POLYGON:
	          flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ (geometry).getFlatInteriorPoint();
	          break;
	        case GeometryType.MULTI_POLYGON:
	          flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry).getFlatInteriorPoints();
	          end = flatCoordinates.length;
	          break;
	        default:
	      }
	      this.startIndices.push(this.indices.length);
	      this.startIndicesFeature.push(feature);
	
	      var glyphAtlas = this.currAtlas_;
	      var lines = this.text_.split('\n');
	      var textSize = this.getTextSize_(lines);
	      var i, ii, j, jj, currX, currY, charArr, charInfo;
	      var anchorX = Math.round(textSize[0] * this.textAlign_ - this.offsetX_);
	      var anchorY = Math.round(textSize[1] * this.textBaseline_ - this.offsetY_);
	      var lineWidth = (this.state_.lineWidth / 2) * this.state_.scale;
	
	      for (i = 0, ii = lines.length; i < ii; ++i) {
	        currX = 0;
	        currY = glyphAtlas.height * i;
	        charArr = lines[i].split('');
	
	        for (j = 0, jj = charArr.length; j < jj; ++j) {
	          charInfo = glyphAtlas.atlas.getInfo(charArr[j]);
	
	          if (charInfo) {
	            var image = charInfo.image;
	
	            this.anchorX = anchorX - currX;
	            this.anchorY = anchorY - currY;
	            this.originX = j === 0 ? charInfo.offsetX - lineWidth : charInfo.offsetX;
	            this.originY = charInfo.offsetY;
	            this.height = glyphAtlas.height;
	            this.width = j === 0 || j === charArr.length - 1 ?
	              glyphAtlas.width[charArr[j]] + lineWidth : glyphAtlas.width[charArr[j]];
	            this.imageHeight = image.height;
	            this.imageWidth = image.width;
	
	            if (this.images_.length === 0) {
	              this.images_.push(image);
	            } else {
	              var currentImage = this.images_[this.images_.length - 1];
	              if (getUid(currentImage) != getUid(image)) {
	                this.groupIndices.push(this.indices.length);
	                this.images_.push(image);
	              }
	            }
	
	            this.drawText_(flatCoordinates, offset, end, stride);
	          }
	          currX += this.width;
	        }
	      }
	    }
	  };
	
	  /**
	   * @private
	   * @param {Array<string>} lines Label to draw split to lines.
	   * @return {Array<number>} Size of the label in pixels.
	   */
	  WebGLTextReplay.prototype.getTextSize_ = function getTextSize_ (lines) {
	    var self = this;
	    var glyphAtlas = this.currAtlas_;
	    var textHeight = lines.length * glyphAtlas.height;
	    //Split every line to an array of chars, sum up their width, and select the longest.
	    var textWidth = lines.map(function(str) {
	      var sum = 0;
	      for (var i = 0, ii = str.length; i < ii; ++i) {
	        var curr = str[i];
	        if (!glyphAtlas.width[curr]) {
	          self.addCharToAtlas_(curr);
	        }
	        sum += glyphAtlas.width[curr] ? glyphAtlas.width[curr] : 0;
	      }
	      return sum;
	    }).reduce(function(max, curr) {
	      return Math.max(max, curr);
	    });
	
	    return [textWidth, textHeight];
	  };
	
	  /**
	   * @private
	   * @param {Array<number>} flatCoordinates Flat coordinates.
	   * @param {number} offset Offset.
	   * @param {number} end End.
	   * @param {number} stride Stride.
	   */
	  WebGLTextReplay.prototype.drawText_ = function drawText_ (flatCoordinates, offset, end, stride) {
	    for (var i = offset, ii = end; i < ii; i += stride) {
	      this.drawCoordinates(flatCoordinates, offset, end, stride);
	    }
	  };
	
	  /**
	   * @private
	   * @param {string} char Character.
	   */
	  WebGLTextReplay.prototype.addCharToAtlas_ = function addCharToAtlas_ (char) {
	    if (char.length === 1) {
	      var glyphAtlas = this.currAtlas_;
	      var state = this.state_;
	      var mCtx = this.measureCanvas_.getContext('2d');
	      mCtx.font = state.font;
	      var width = Math.ceil(mCtx.measureText(char).width * state.scale);
	
	      var info = glyphAtlas.atlas.add(char, width, glyphAtlas.height,
	        function(ctx, x, y) {
	          //Parameterize the canvas
	          ctx.font = /** @type {string} */ (state.font);
	          ctx.fillStyle = state.fillColor;
	          ctx.strokeStyle = state.strokeColor;
	          ctx.lineWidth = state.lineWidth;
	          ctx.lineCap = /** @type {CanvasLineCap} */ (state.lineCap);
	          ctx.lineJoin = /** @type {CanvasLineJoin} */ (state.lineJoin);
	          ctx.miterLimit = /** @type {number} */ (state.miterLimit);
	          ctx.textAlign = 'left';
	          ctx.textBaseline = 'top';
	          if (CANVAS_LINE_DASH && state.lineDash) {
	            //FIXME: use pixelRatio
	            ctx.setLineDash(state.lineDash);
	            ctx.lineDashOffset = /** @type {number} */ (state.lineDashOffset);
	          }
	          if (state.scale !== 1) {
	            //FIXME: use pixelRatio
	            ctx.setTransform(/** @type {number} */ (state.scale), 0, 0,
	              /** @type {number} */ (state.scale), 0, 0);
	          }
	
	          //Draw the character on the canvas
	          if (state.strokeColor) {
	            ctx.strokeText(char, x, y);
	          }
	          if (state.fillColor) {
	            ctx.fillText(char, x, y);
	          }
	        });
	
	      if (info) {
	        glyphAtlas.width[char] = width;
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextReplay.prototype.finish = function finish (context) {
	    var gl = context.getGL();
	
	    this.groupIndices.push(this.indices.length);
	    this.hitDetectionGroupIndices = this.groupIndices;
	
	    // create, bind, and populate the vertices buffer
	    this.verticesBuffer = new WebGLBuffer(this.vertices);
	
	    // create, bind, and populate the indices buffer
	    this.indicesBuffer = new WebGLBuffer(this.indices);
	
	    // create textures
	    /** @type {Object<string, WebGLTexture>} */
	    var texturePerImage = {};
	
	    this.createTextures(this.textures_, this.images_, texturePerImage, gl);
	
	    this.state_ = {
	      strokeColor: null,
	      lineCap: undefined,
	      lineDash: null,
	      lineDashOffset: undefined,
	      lineJoin: undefined,
	      lineWidth: 0,
	      miterLimit: undefined,
	      fillColor: null,
	      font: undefined,
	      scale: undefined
	    };
	    this.text_ = '';
	    this.textAlign_ = undefined;
	    this.textBaseline_ = undefined;
	    this.offsetX_ = undefined;
	    this.offsetY_ = undefined;
	    this.images_ = null;
	    this.atlases_ = {};
	    this.currAtlas_ = undefined;
	    WebGLTextureReplay$$1.prototype.finish.call(this, context);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextReplay.prototype.setTextStyle = function setTextStyle (textStyle) {
	    var state = this.state_;
	    var textFillStyle = textStyle.getFill();
	    var textStrokeStyle = textStyle.getStroke();
	    if (!textStyle || !textStyle.getText() || (!textFillStyle && !textStrokeStyle)) {
	      this.text_ = '';
	    } else {
	      if (!textFillStyle) {
	        state.fillColor = null;
	      } else {
	        var textFillStyleColor = textFillStyle.getColor();
	        state.fillColor = asColorLike(textFillStyleColor ?
	          textFillStyleColor : DEFAULT_FILLSTYLE);
	      }
	      if (!textStrokeStyle) {
	        state.strokeColor = null;
	        state.lineWidth = 0;
	      } else {
	        var textStrokeStyleColor = textStrokeStyle.getColor();
	        state.strokeColor = asColorLike(textStrokeStyleColor ?
	          textStrokeStyleColor : DEFAULT_STROKESTYLE);
	        state.lineWidth = textStrokeStyle.getWidth() || DEFAULT_LINEWIDTH;
	        state.lineCap = textStrokeStyle.getLineCap() || DEFAULT_LINECAP;
	        state.lineDashOffset = textStrokeStyle.getLineDashOffset() || DEFAULT_LINEDASHOFFSET;
	        state.lineJoin = textStrokeStyle.getLineJoin() || DEFAULT_LINEJOIN;
	        state.miterLimit = textStrokeStyle.getMiterLimit() || DEFAULT_MITERLIMIT;
	        var lineDash = textStrokeStyle.getLineDash();
	        state.lineDash = lineDash ? lineDash.slice() : DEFAULT_LINEDASH;
	      }
	      state.font = textStyle.getFont() || DEFAULT_FONT;
	      state.scale = textStyle.getScale() || 1;
	      this.text_ = /** @type {string} */ (textStyle.getText());
	      var textAlign = TEXT_ALIGN[textStyle.getTextAlign()];
	      var textBaseline = TEXT_ALIGN[textStyle.getTextBaseline()];
	      this.textAlign_ = textAlign === undefined ?
	        DEFAULT_TEXTALIGN : textAlign;
	      this.textBaseline_ = textBaseline === undefined ?
	        DEFAULT_TEXTBASELINE : textBaseline;
	      this.offsetX_ = textStyle.getOffsetX() || 0;
	      this.offsetY_ = textStyle.getOffsetY() || 0;
	      this.rotateWithView = !!textStyle.getRotateWithView();
	      this.rotation = textStyle.getRotation() || 0;
	
	      this.currAtlas_ = this.getAtlas_(state);
	    }
	  };
	
	  /**
	   * @private
	   * @param {Object} state Font attributes.
	   * @return {GlyphAtlas} Glyph atlas.
	   */
	  WebGLTextReplay.prototype.getAtlas_ = function getAtlas_ (state) {
	    var params = [];
	    for (var i in state) {
	      if (state[i] || state[i] === 0) {
	        if (Array.isArray(state[i])) {
	          params = params.concat(state[i]);
	        } else {
	          params.push(state[i]);
	        }
	      }
	    }
	    var hash = this.calculateHash_(params);
	    if (!this.atlases_[hash]) {
	      var mCtx = this.measureCanvas_.getContext('2d');
	      mCtx.font = state.font;
	      var height = Math.ceil((mCtx.measureText('M').width * 1.5 +
	          state.lineWidth / 2) * state.scale);
	
	      this.atlases_[hash] = {
	        atlas: new AtlasManager({
	          space: state.lineWidth + 1
	        }),
	        width: {},
	        height: height
	      };
	    }
	    return this.atlases_[hash];
	  };
	
	  /**
	   * @private
	   * @param {Array<string|number>} params Array of parameters.
	   * @return {string} Hash string.
	   */
	  WebGLTextReplay.prototype.calculateHash_ = function calculateHash_ (params) {
	    //TODO: Create a more performant, reliable, general hash function.
	    var hash = '';
	    for (var i = 0, ii = params.length; i < ii; ++i) {
	      hash += params[i];
	    }
	    return hash;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextReplay.prototype.getTextures = function getTextures (opt_all) {
	    return this.textures_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTextReplay.prototype.getHitDetectionTextures = function getHitDetectionTextures () {
	    return this.textures_;
	  };
	
	  return WebGLTextReplay;
	}(WebGLTextureReplay));
	
	/**
	 * @module ol/render/webgl/ReplayGroup
	 */
	
	/**
	 * @type {Array<number>}
	 */
	var HIT_DETECTION_SIZE = [1, 1];
	
	/**
	 * @type {Object<import("../ReplayType.js").default, typeof import("./Replay.js").default>}
	 */
	var BATCH_CONSTRUCTORS$1 = {
	  'Circle': WebGLCircleReplay,
	  'Image': WebGLImageReplay,
	  'LineString': WebGLLineStringReplay,
	  'Polygon': WebGLPolygonReplay,
	  'Text': WebGLTextReplay
	};
	
	
	var WebGLReplayGroup = /*@__PURE__*/(function (ReplayGroup$$1) {
	  function WebGLReplayGroup(tolerance, maxExtent, opt_renderBuffer) {
	    ReplayGroup$$1.call(this);
	
	    /**
	     * @type {import("../../extent.js").Extent}
	     * @private
	     */
	    this.maxExtent_ = maxExtent;
	
	    /**
	     * @type {number}
	     * @private
	     */
	    this.tolerance_ = tolerance;
	
	    /**
	     * @type {number|undefined}
	     * @private
	     */
	    this.renderBuffer_ = opt_renderBuffer;
	
	    /**
	     * @private
	     * @type {!Object<string,
	     *        Object<import("../ReplayType.js").default, import("./Replay.js").default>>}
	     */
	    this.replaysByZIndex_ = {};
	
	  }
	
	  if ( ReplayGroup$$1 ) { WebGLReplayGroup.__proto__ = ReplayGroup$$1; }
	  WebGLReplayGroup.prototype = Object.create( ReplayGroup$$1 && ReplayGroup$$1.prototype );
	  WebGLReplayGroup.prototype.constructor = WebGLReplayGroup;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLReplayGroup.prototype.addDeclutter = function addDeclutter (group) {
	    return [];
	  };
	
	  /**
	   * @param {import("../../webgl/Context.js").default} context WebGL context.
	   * @return {function()} Delete resources function.
	   */
	  WebGLReplayGroup.prototype.getDeleteResourcesFunction = function getDeleteResourcesFunction (context) {
	    var functions = [];
	    var zKey;
	    for (zKey in this.replaysByZIndex_) {
	      var replays = this.replaysByZIndex_[zKey];
	      for (var replayKey in replays) {
	        functions.push(
	          replays[replayKey].getDeleteResourcesFunction(context));
	      }
	    }
	    return function() {
	      var arguments$1 = arguments;
	
	      var length = functions.length;
	      var result;
	      for (var i = 0; i < length; i++) {
	        result = functions[i].apply(this, arguments$1);
	      }
	      return result;
	    };
	  };
	
	  /**
	   * @param {import("../../webgl/Context.js").default} context Context.
	   */
	  WebGLReplayGroup.prototype.finish = function finish (context) {
	    var zKey;
	    for (zKey in this.replaysByZIndex_) {
	      var replays = this.replaysByZIndex_[zKey];
	      for (var replayKey in replays) {
	        replays[replayKey].finish(context);
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLReplayGroup.prototype.getReplay = function getReplay (zIndex, replayType) {
	    var zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
	    var replays = this.replaysByZIndex_[zIndexKey];
	    if (replays === undefined) {
	      replays = {};
	      this.replaysByZIndex_[zIndexKey] = replays;
	    }
	    var replay = replays[replayType];
	    if (replay === undefined) {
	      var Constructor = BATCH_CONSTRUCTORS$1[replayType];
	      replay = new Constructor(this.tolerance_, this.maxExtent_);
	      replays[replayType] = replay;
	    }
	    return replay;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLReplayGroup.prototype.isEmpty = function isEmpty$1$$1 () {
	    return isEmpty(this.replaysByZIndex_);
	  };
	
	  /**
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {import("../../coordinate.js").Coordinate} center Center.
	   * @param {number} resolution Resolution.
	   * @param {number} rotation Rotation.
	   * @param {import("../../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {number} opacity Global opacity.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   */
	  WebGLReplayGroup.prototype.replay = function replay (
	    context,
	    center,
	    resolution,
	    rotation,
	    size,
	    pixelRatio,
	    opacity,
	    skippedFeaturesHash
	  ) {
	    /** @type {Array<number>} */
	    var zs = Object.keys(this.replaysByZIndex_).map(Number);
	    zs.sort(numberSafeCompareFunction);
	
	    var i, ii, j, jj, replays, replay;
	    for (i = 0, ii = zs.length; i < ii; ++i) {
	      replays = this.replaysByZIndex_[zs[i].toString()];
	      for (j = 0, jj = ORDER.length; j < jj; ++j) {
	        replay = replays[ORDER[j]];
	        if (replay !== undefined) {
	          replay.replay(context,
	            center, resolution, rotation, size, pixelRatio,
	            opacity, skippedFeaturesHash,
	            undefined, false);
	        }
	      }
	    }
	  };
	
	  /**
	   * @private
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {import("../../coordinate.js").Coordinate} center Center.
	   * @param {number} resolution Resolution.
	   * @param {number} rotation Rotation.
	   * @param {import("../../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {number} opacity Global opacity.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} featureCallback Feature callback.
	   * @param {boolean} oneByOne Draw features one-by-one for the hit-detecion.
	   * @param {import("../../extent.js").Extent=} opt_hitExtent Hit extent: Only features intersecting
	   *  this extent are checked.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  WebGLReplayGroup.prototype.replayHitDetection_ = function replayHitDetection_ (
	    context,
	    center,
	    resolution,
	    rotation,
	    size,
	    pixelRatio,
	    opacity,
	    skippedFeaturesHash,
	    featureCallback,
	    oneByOne,
	    opt_hitExtent
	  ) {
	    /** @type {Array<number>} */
	    var zs = Object.keys(this.replaysByZIndex_).map(Number);
	    zs.sort(function(a, b) {
	      return b - a;
	    });
	
	    var i, ii, j, replays, replay, result;
	    for (i = 0, ii = zs.length; i < ii; ++i) {
	      replays = this.replaysByZIndex_[zs[i].toString()];
	      for (j = ORDER.length - 1; j >= 0; --j) {
	        replay = replays[ORDER[j]];
	        if (replay !== undefined) {
	          result = replay.replay(context,
	            center, resolution, rotation, size, pixelRatio, opacity,
	            skippedFeaturesHash, featureCallback, oneByOne, opt_hitExtent);
	          if (result) {
	            return result;
	          }
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {import("../../coordinate.js").Coordinate} center Center.
	   * @param {number} resolution Resolution.
	   * @param {number} rotation Rotation.
	   * @param {import("../../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {number} opacity Global opacity.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @param {function((import("../../Feature.js").default|import("../Feature.js").default)): T|undefined} callback Feature callback.
	   * @return {T|undefined} Callback result.
	   * @template T
	   */
	  WebGLReplayGroup.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (
	    coordinate,
	    context,
	    center,
	    resolution,
	    rotation,
	    size,
	    pixelRatio,
	    opacity,
	    skippedFeaturesHash,
	    callback
	  ) {
	    var gl = context.getGL();
	    gl.bindFramebuffer(
	      gl.FRAMEBUFFER, context.getHitDetectionFramebuffer());
	
	
	    /**
	     * @type {import("../../extent.js").Extent}
	     */
	    var hitExtent;
	    if (this.renderBuffer_ !== undefined) {
	      // build an extent around the coordinate, so that only features that
	      // intersect this extent are checked
	      hitExtent = buffer(createOrUpdateFromCoordinate(coordinate), resolution * this.renderBuffer_);
	    }
	
	    return this.replayHitDetection_(context,
	      coordinate, resolution, rotation, HIT_DETECTION_SIZE,
	      pixelRatio, opacity, skippedFeaturesHash,
	      /**
	       * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	       * @return {?} Callback result.
	       */
	      function(feature) {
	        var imageData = new Uint8Array(4);
	        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, imageData);
	
	        if (imageData[3] > 0) {
	          var result = callback(feature);
	          if (result) {
	            return result;
	          }
	        }
	      }, true, hitExtent);
	  };
	
	  /**
	   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @param {import("../../coordinate.js").Coordinate} center Center.
	   * @param {number} resolution Resolution.
	   * @param {number} rotation Rotation.
	   * @param {import("../../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {number} opacity Global opacity.
	   * @param {Object<string, boolean>} skippedFeaturesHash Ids of features to skip.
	   * @return {boolean} Is there a feature at the given coordinate?
	   */
	  WebGLReplayGroup.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate (
	    coordinate,
	    context,
	    center,
	    resolution,
	    rotation,
	    size,
	    pixelRatio,
	    opacity,
	    skippedFeaturesHash
	  ) {
	    var gl = context.getGL();
	    gl.bindFramebuffer(
	      gl.FRAMEBUFFER, context.getHitDetectionFramebuffer());
	
	    var hasFeature = this.replayHitDetection_(context,
	      coordinate, resolution, rotation, HIT_DETECTION_SIZE,
	      pixelRatio, opacity, skippedFeaturesHash,
	      /**
	       * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	       * @return {boolean} Is there a feature?
	       */
	      function(feature) {
	        var imageData = new Uint8Array(4);
	        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, imageData);
	        return imageData[3] > 0;
	      }, false);
	
	    return hasFeature !== undefined;
	  };
	
	  return WebGLReplayGroup;
	}(ReplayGroup));
	
	/**
	 * @module ol/render/webgl/Immediate
	 */
	
	var WebGLImmediateRenderer = /*@__PURE__*/(function (VectorContext$$1) {
	  function WebGLImmediateRenderer(context, center, resolution, rotation, size, extent, pixelRatio) {
	    VectorContext$$1.call(this);
	
	    /**
	     * @private
	     */
	    this.context_ = context;
	
	    /**
	     * @private
	     */
	    this.center_ = center;
	
	    /**
	     * @private
	     */
	    this.extent_ = extent;
	
	    /**
	     * @private
	     */
	    this.pixelRatio_ = pixelRatio;
	
	    /**
	     * @private
	     */
	    this.size_ = size;
	
	    /**
	     * @private
	     */
	    this.rotation_ = rotation;
	
	    /**
	     * @private
	     */
	    this.resolution_ = resolution;
	
	    /**
	     * @private
	     * @type {import("../../style/Image.js").default}
	     */
	    this.imageStyle_ = null;
	
	    /**
	     * @private
	     * @type {import("../../style/Fill.js").default}
	     */
	    this.fillStyle_ = null;
	
	    /**
	     * @private
	     * @type {import("../../style/Stroke.js").default}
	     */
	    this.strokeStyle_ = null;
	
	    /**
	     * @private
	     * @type {import("../../style/Text.js").default}
	     */
	    this.textStyle_ = null;
	
	  }
	
	  if ( VectorContext$$1 ) { WebGLImmediateRenderer.__proto__ = VectorContext$$1; }
	  WebGLImmediateRenderer.prototype = Object.create( VectorContext$$1 && VectorContext$$1.prototype );
	  WebGLImmediateRenderer.prototype.constructor = WebGLImmediateRenderer;
	
	  /**
	   * @param {import("./ReplayGroup.js").default} replayGroup Replay group.
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry Geometry.
	   * @private
	   */
	  WebGLImmediateRenderer.prototype.drawText_ = function drawText_ (replayGroup, geometry) {
	    var context = this.context_;
	    var replay = /** @type {import("./TextReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.TEXT));
	    replay.setTextStyle(this.textStyle_);
	    replay.drawText(geometry, null);
	    replay.finish(context);
	    // default colors
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	  };
	
	  /**
	   * Set the rendering style.  Note that since this is an immediate rendering API,
	   * any `zIndex` on the provided style will be ignored.
	   *
	   * @param {import("../../style/Style.js").default} style The rendering style.
	   * @override
	   * @api
	   */
	  WebGLImmediateRenderer.prototype.setStyle = function setStyle (style) {
	    this.setFillStrokeStyle(style.getFill(), style.getStroke());
	    this.setImageStyle(style.getImage());
	    this.setTextStyle(style.getText());
	  };
	
	  /**
	   * Render a geometry into the canvas.  Call
	   * {@link ol/render/webgl/Immediate#setStyle} first to set the rendering style.
	   *
	   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
	   * @override
	   * @api
	   */
	  WebGLImmediateRenderer.prototype.drawGeometry = function drawGeometry (geometry) {
	    var type = geometry.getType();
	    switch (type) {
	      case GeometryType.POINT:
	        this.drawPoint(/** @type {import("../../geom/Point.js").default} */ (geometry), null);
	        break;
	      case GeometryType.LINE_STRING:
	        this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ (geometry), null);
	        break;
	      case GeometryType.POLYGON:
	        this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ (geometry), null);
	        break;
	      case GeometryType.MULTI_POINT:
	        this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ (geometry), null);
	        break;
	      case GeometryType.MULTI_LINE_STRING:
	        this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ (geometry), null);
	        break;
	      case GeometryType.MULTI_POLYGON:
	        this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ (geometry), null);
	        break;
	      case GeometryType.GEOMETRY_COLLECTION:
	        this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ (geometry), null);
	        break;
	      case GeometryType.CIRCLE:
	        this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ (geometry), null);
	        break;
	      default:
	        // pass
	    }
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  WebGLImmediateRenderer.prototype.drawFeature = function drawFeature (feature, style) {
	    var geometry = style.getGeometryFunction()(feature);
	    if (!geometry || !intersects(this.extent_, geometry.getExtent())) {
	      return;
	    }
	    this.setStyle(style);
	    this.drawGeometry(geometry);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawGeometryCollection = function drawGeometryCollection (geometry, data) {
	    var geometries = geometry.getGeometriesArray();
	    var i, ii;
	    for (i = 0, ii = geometries.length; i < ii; ++i) {
	      this.drawGeometry(geometries[i]);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawPoint = function drawPoint (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./ImageReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.IMAGE));
	    replay.setImageStyle(this.imageStyle_);
	    replay.drawPoint(geometry, data);
	    replay.finish(context);
	    // default colors
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawMultiPoint = function drawMultiPoint (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./ImageReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.IMAGE));
	    replay.setImageStyle(this.imageStyle_);
	    replay.drawMultiPoint(geometry, data);
	    replay.finish(context);
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawLineString = function drawLineString (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./LineStringReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.LINE_STRING));
	    replay.setFillStrokeStyle(null, this.strokeStyle_);
	    replay.drawLineString(geometry, data);
	    replay.finish(context);
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawMultiLineString = function drawMultiLineString (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./LineStringReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.LINE_STRING));
	    replay.setFillStrokeStyle(null, this.strokeStyle_);
	    replay.drawMultiLineString(geometry, data);
	    replay.finish(context);
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawPolygon = function drawPolygon (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./PolygonReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.POLYGON));
	    replay.setFillStrokeStyle(this.fillStyle_, this.strokeStyle_);
	    replay.drawPolygon(geometry, data);
	    replay.finish(context);
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawMultiPolygon = function drawMultiPolygon (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./PolygonReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.POLYGON));
	    replay.setFillStrokeStyle(this.fillStyle_, this.strokeStyle_);
	    replay.drawMultiPolygon(geometry, data);
	    replay.finish(context);
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.drawCircle = function drawCircle (geometry, data) {
	    var context = this.context_;
	    var replayGroup = new WebGLReplayGroup(1, this.extent_);
	    var replay = /** @type {import("./CircleReplay.js").default} */ (
	      replayGroup.getReplay(0, ReplayType.CIRCLE));
	    replay.setFillStrokeStyle(this.fillStyle_, this.strokeStyle_);
	    replay.drawCircle(geometry, data);
	    replay.finish(context);
	    var opacity = 1;
	    /** @type {Object<string, boolean>} */
	    var skippedFeatures = {};
	    var featureCallback;
	    var oneByOne = false;
	    replay.replay(this.context_, this.center_, this.resolution_, this.rotation_,
	      this.size_, this.pixelRatio_, opacity, skippedFeatures, featureCallback,
	      oneByOne);
	    replay.getDeleteResourcesFunction(context)();
	
	    if (this.textStyle_) {
	      this.drawText_(replayGroup, geometry);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.setImageStyle = function setImageStyle (imageStyle) {
	    this.imageStyle_ = imageStyle;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.setFillStrokeStyle = function setFillStrokeStyle (fillStyle, strokeStyle) {
	    this.fillStyle_ = fillStyle;
	    this.strokeStyle_ = strokeStyle;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImmediateRenderer.prototype.setTextStyle = function setTextStyle (textStyle) {
	    this.textStyle_ = textStyle;
	  };
	
	  return WebGLImmediateRenderer;
	}(VectorContext));
	
	/**
	 * @module ol/renderer/webgl/defaultmapshader
	 */
	
	var fragment$4 = new WebGLFragment('precision mediump float;\nvarying vec2 v_texCoord;\n\n\nuniform float u_opacity;\nuniform sampler2D u_texture;\n\nvoid main(void) {\n  vec4 texColor = texture2D(u_texture, v_texCoord);\n  gl_FragColor.rgb = texColor.rgb;\n  gl_FragColor.a = texColor.a * u_opacity;\n}\n');
	
	var vertex$4 = new WebGLVertex('varying vec2 v_texCoord;\n\n\nattribute vec2 a_position;\nattribute vec2 a_texCoord;\n\nuniform mat4 u_texCoordMatrix;\nuniform mat4 u_projectionMatrix;\n\nvoid main(void) {\n  gl_Position = u_projectionMatrix * vec4(a_position, 0., 1.);\n  v_texCoord = (u_texCoordMatrix * vec4(a_texCoord, 0., 1.)).st;\n}\n\n\n');
	
	/**
	 * @module ol/renderer/webgl/defaultmapshader/Locations
	 */
	
	var Locations$4 = function Locations(gl, program) {
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_texCoordMatrix = gl.getUniformLocation(
	    program, 'u_texCoordMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_projectionMatrix = gl.getUniformLocation(
	    program, 'u_projectionMatrix');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_opacity = gl.getUniformLocation(
	    program, 'u_opacity');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_texture = gl.getUniformLocation(
	    program, 'u_texture');
	
	  /**
	   * @type {number}
	   */
	  this.a_position = gl.getAttribLocation(
	    program, 'a_position');
	
	  /**
	   * @type {number}
	   */
	  this.a_texCoord = gl.getAttribLocation(
	    program, 'a_texCoord');
	
	};
	
	/**
	 * @module ol/renderer/webgl/Layer
	 */
	
	/**
	 * @abstract
	 */
	var WebGLLayerRenderer = /*@__PURE__*/(function (LayerRenderer$$1) {
	  function WebGLLayerRenderer(mapRenderer, layer) {
	
	    LayerRenderer$$1.call(this, layer);
	
	    /**
	     * @protected
	     * @type {import("./Map.js").default}
	     */
	    this.mapRenderer = mapRenderer;
	
	    /**
	     * @private
	     * @type {import("../../webgl/Buffer.js").default}
	     */
	    this.arrayBuffer_ = new WebGLBuffer([
	      -1, -1, 0, 0,
	      1, -1, 1, 0,
	      -1, 1, 0, 1,
	      1, 1, 1, 1
	    ]);
	
	    /**
	     * @protected
	     * @type {WebGLTexture}
	     */
	    this.texture = null;
	
	    /**
	     * @protected
	     * @type {WebGLFramebuffer}
	     */
	    this.framebuffer = null;
	
	    /**
	     * @protected
	     * @type {number|undefined}
	     */
	    this.framebufferDimension = undefined;
	
	    /**
	     * @protected
	     * @type {import("../../transform.js").Transform}
	     */
	    this.texCoordMatrix = create();
	
	    /**
	     * @protected
	     * @type {import("../../transform.js").Transform}
	     */
	    this.projectionMatrix = create();
	
	    /**
	     * @type {Array<number>}
	     * @private
	     */
	    this.tmpMat4_ = create$1();
	
	    /**
	     * @private
	     * @type {import("./defaultmapshader/Locations.js").default}
	     */
	    this.defaultLocations_ = null;
	
	  }
	
	  if ( LayerRenderer$$1 ) { WebGLLayerRenderer.__proto__ = LayerRenderer$$1; }
	  WebGLLayerRenderer.prototype = Object.create( LayerRenderer$$1 && LayerRenderer$$1.prototype );
	  WebGLLayerRenderer.prototype.constructor = WebGLLayerRenderer;
	
	  /**
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {number} framebufferDimension Framebuffer dimension.
	   * @protected
	   */
	  WebGLLayerRenderer.prototype.bindFramebuffer = function bindFramebuffer (frameState, framebufferDimension) {
	
	    var gl = this.mapRenderer.getGL();
	
	    if (this.framebufferDimension === undefined ||
	        this.framebufferDimension != framebufferDimension) {
	      /**
	       * @param {WebGLRenderingContext} gl GL.
	       * @param {WebGLFramebuffer} framebuffer Framebuffer.
	       * @param {WebGLTexture} texture Texture.
	       */
	      var postRenderFunction = function(gl, framebuffer, texture) {
	        if (!gl.isContextLost()) {
	          gl.deleteFramebuffer(framebuffer);
	          gl.deleteTexture(texture);
	        }
	      }.bind(null, gl, this.framebuffer, this.texture);
	
	      frameState.postRenderFunctions.push(
	        /** @type {import("../../PluggableMap.js").PostRenderFunction} */ (postRenderFunction)
	      );
	
	      var texture = createEmptyTexture(
	        gl, framebufferDimension, framebufferDimension);
	
	      var framebuffer = gl.createFramebuffer();
	      gl.bindFramebuffer(FRAMEBUFFER, framebuffer);
	      gl.framebufferTexture2D(FRAMEBUFFER,
	        COLOR_ATTACHMENT0, TEXTURE_2D, texture, 0);
	
	      this.texture = texture;
	      this.framebuffer = framebuffer;
	      this.framebufferDimension = framebufferDimension;
	
	    } else {
	      gl.bindFramebuffer(FRAMEBUFFER, this.framebuffer);
	    }
	
	  };
	
	  /**
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   */
	  WebGLLayerRenderer.prototype.composeFrame = function composeFrame (frameState, layerState, context) {
	
	    this.dispatchComposeEvent_(RenderEventType.PRECOMPOSE, context, frameState);
	
	    context.bindBuffer(ARRAY_BUFFER, this.arrayBuffer_);
	
	    var gl = context.getGL();
	
	    var program = context.getProgram(fragment$4, vertex$4);
	
	    var locations;
	    if (!this.defaultLocations_) {
	      locations = new Locations$4(gl, program);
	      this.defaultLocations_ = locations;
	    } else {
	      locations = this.defaultLocations_;
	    }
	
	    if (context.useProgram(program)) {
	      gl.enableVertexAttribArray(locations.a_position);
	      gl.vertexAttribPointer(
	        locations.a_position, 2, FLOAT, false, 16, 0);
	      gl.enableVertexAttribArray(locations.a_texCoord);
	      gl.vertexAttribPointer(
	        locations.a_texCoord, 2, FLOAT, false, 16, 8);
	      gl.uniform1i(locations.u_texture, 0);
	    }
	
	    gl.uniformMatrix4fv(locations.u_texCoordMatrix, false,
	      fromTransform(this.tmpMat4_, this.getTexCoordMatrix()));
	    gl.uniformMatrix4fv(locations.u_projectionMatrix, false,
	      fromTransform(this.tmpMat4_, this.getProjectionMatrix()));
	    gl.uniform1f(locations.u_opacity, layerState.opacity);
	    gl.bindTexture(TEXTURE_2D, this.getTexture());
	    gl.drawArrays(TRIANGLE_STRIP, 0, 4);
	
	    this.dispatchComposeEvent_(RenderEventType.POSTCOMPOSE, context, frameState);
	  };
	
	  /**
	   * @param {import("../../render/EventType.js").default} type Event type.
	   * @param {import("../../webgl/Context.js").default} context WebGL context.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @private
	   */
	  WebGLLayerRenderer.prototype.dispatchComposeEvent_ = function dispatchComposeEvent_ (type, context, frameState) {
	    var layer = this.getLayer();
	    if (layer.hasListener(type)) {
	      var viewState = frameState.viewState;
	      var resolution = viewState.resolution;
	      var pixelRatio = frameState.pixelRatio;
	      var extent = frameState.extent;
	      var center = viewState.center;
	      var rotation = viewState.rotation;
	      var size = frameState.size;
	
	      var render = new WebGLImmediateRenderer(
	        context, center, resolution, rotation, size, extent, pixelRatio);
	      var composeEvent = new RenderEvent(
	        type, render, frameState, null, context);
	      layer.dispatchEvent(composeEvent);
	    }
	  };
	
	  /**
	   * @return {!import("../../transform.js").Transform} Matrix.
	   */
	  WebGLLayerRenderer.prototype.getTexCoordMatrix = function getTexCoordMatrix () {
	    return this.texCoordMatrix;
	  };
	
	  /**
	   * @return {WebGLTexture} Texture.
	   */
	  WebGLLayerRenderer.prototype.getTexture = function getTexture () {
	    return this.texture;
	  };
	
	  /**
	   * @return {!import("../../transform.js").Transform} Matrix.
	   */
	  WebGLLayerRenderer.prototype.getProjectionMatrix = function getProjectionMatrix () {
	    return this.projectionMatrix;
	  };
	
	  /**
	   * Handle webglcontextlost.
	   */
	  WebGLLayerRenderer.prototype.handleWebGLContextLost = function handleWebGLContextLost () {
	    this.texture = null;
	    this.framebuffer = null;
	    this.framebufferDimension = undefined;
	  };
	
	  /**
	   * @abstract
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @param {import("../../layer/Layer.js").State} layerState Layer state.
	   * @param {import("../../webgl/Context.js").default} context Context.
	   * @return {boolean} whether composeFrame should be called.
	   */
	  WebGLLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState, context) {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @param {import("../../pixel.js").Pixel} pixel Pixel.
	   * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
	   * @param {function(this: S, import("../../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
	   *     callback.
	   * @param {S} thisArg Value to use as `this` when executing `callback`.
	   * @return {T|undefined} Callback result.
	   * @template S,T,U
	   */
	  WebGLLayerRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, callback, thisArg) {
	    return abstract();
	  };
	
	  return WebGLLayerRenderer;
	}(LayerRenderer));
	
	/**
	 * @module ol/renderer/webgl/ImageLayer
	 */
	
	/**
	 * @classdesc
	 * WebGL renderer for image layers.
	 * @api
	 */
	var WebGLImageLayerRenderer = /*@__PURE__*/(function (WebGLLayerRenderer$$1) {
	  function WebGLImageLayerRenderer(mapRenderer, imageLayer) {
	
	    WebGLLayerRenderer$$1.call(this, mapRenderer, imageLayer);
	
	    /**
	     * The last rendered image.
	     * @private
	     * @type {?import("../../ImageBase.js").default}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {CanvasRenderingContext2D}
	     */
	    this.hitCanvasContext_ = null;
	
	    /**
	     * @private
	     * @type {?import("../../transform.js").Transform}
	     */
	    this.hitTransformationMatrix_ = null;
	
	  }
	
	  if ( WebGLLayerRenderer$$1 ) { WebGLImageLayerRenderer.__proto__ = WebGLLayerRenderer$$1; }
	  WebGLImageLayerRenderer.prototype = Object.create( WebGLLayerRenderer$$1 && WebGLLayerRenderer$$1.prototype );
	  WebGLImageLayerRenderer.prototype.constructor = WebGLImageLayerRenderer;
	
	  /**
	   * @param {import("../../ImageBase.js").default} image Image.
	   * @private
	   * @return {WebGLTexture} Texture.
	   */
	  WebGLImageLayerRenderer.prototype.createTexture_ = function createTexture_ (image) {
	
	    // We meet the conditions to work with non-power of two textures.
	    // http://www.khronos.org/webgl/wiki/WebGL_and_OpenGL_Differences#Non-Power_of_Two_Texture_Support
	    // http://learningwebgl.com/blog/?p=2101
	
	    var imageElement = image.getImage();
	    var gl = this.mapRenderer.getGL();
	
	    return createTexture(
	      gl, imageElement, CLAMP_TO_EDGE, CLAMP_TO_EDGE);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState, context) {
	
	    var gl = this.mapRenderer.getGL();
	
	    var pixelRatio = frameState.pixelRatio;
	    var viewState = frameState.viewState;
	    var viewCenter = viewState.center;
	    var viewResolution = viewState.resolution;
	    var viewRotation = viewState.rotation;
	
	    var image = this.image_;
	    var texture = this.texture;
	    var imageLayer = /** @type {import("../../layer/Image.js").default} */ (this.getLayer());
	    var imageSource = /** @type {import("../../source/Image.js").default} */ (imageLayer.getSource());
	
	    var hints = frameState.viewHints;
	
	    var renderedExtent = frameState.extent;
	    if (layerState.extent !== undefined) {
	      renderedExtent = getIntersection(renderedExtent, layerState.extent);
	    }
	    if (!hints[ViewHint.ANIMATING] && !hints[ViewHint.INTERACTING] &&
	        !isEmpty$1(renderedExtent)) {
	      var projection = viewState.projection;
	      var image_ = imageSource.getImage(renderedExtent, viewResolution,
	        pixelRatio, projection);
	      if (image_) {
	        var loaded = this.loadImage(image_);
	        if (loaded) {
	          image = image_;
	          texture = this.createTexture_(image_);
	          if (this.texture) {
	            /**
	             * @param {WebGLRenderingContext} gl GL.
	             * @param {WebGLTexture} texture Texture.
	             */
	            var postRenderFunction = function(gl, texture) {
	              if (!gl.isContextLost()) {
	                gl.deleteTexture(texture);
	              }
	            }.bind(null, gl, this.texture);
	            frameState.postRenderFunctions.push(
	              /** @type {import("../../PluggableMap.js").PostRenderFunction} */ (postRenderFunction)
	            );
	          }
	        }
	      }
	    }
	
	    if (image) {
	      var canvas = this.mapRenderer.getContext().getCanvas();
	
	      this.updateProjectionMatrix_(canvas.width, canvas.height,
	        pixelRatio, viewCenter, viewResolution, viewRotation,
	        image.getExtent());
	      this.hitTransformationMatrix_ = null;
	
	      // Translate and scale to flip the Y coord.
	      var texCoordMatrix = this.texCoordMatrix;
	      reset(texCoordMatrix);
	      scale$1(texCoordMatrix, 1, -1);
	      translate$1(texCoordMatrix, 0, -1);
	
	      this.image_ = image;
	      this.texture = texture;
	    }
	
	    return !!image;
	  };
	
	  /**
	   * @param {number} canvasWidth Canvas width.
	   * @param {number} canvasHeight Canvas height.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../../coordinate.js").Coordinate} viewCenter View center.
	   * @param {number} viewResolution View resolution.
	   * @param {number} viewRotation View rotation.
	   * @param {import("../../extent.js").Extent} imageExtent Image extent.
	   * @private
	   */
	  WebGLImageLayerRenderer.prototype.updateProjectionMatrix_ = function updateProjectionMatrix_ (
	    canvasWidth,
	    canvasHeight,
	    pixelRatio,
	    viewCenter,
	    viewResolution,
	    viewRotation,
	    imageExtent
	  ) {
	
	    var canvasExtentWidth = canvasWidth * viewResolution;
	    var canvasExtentHeight = canvasHeight * viewResolution;
	
	    var projectionMatrix = this.projectionMatrix;
	    reset(projectionMatrix);
	    scale$1(projectionMatrix,
	      pixelRatio * 2 / canvasExtentWidth,
	      pixelRatio * 2 / canvasExtentHeight);
	    rotate$1(projectionMatrix, -viewRotation);
	    translate$1(projectionMatrix,
	      imageExtent[0] - viewCenter[0],
	      imageExtent[1] - viewCenter[1]);
	    scale$1(projectionMatrix,
	      (imageExtent[2] - imageExtent[0]) / 2,
	      (imageExtent[3] - imageExtent[1]) / 2);
	    translate$1(projectionMatrix, 1, 1);
	
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLImageLayerRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, callback, thisArg) {
	    if (!this.image_ || !this.image_.getImage()) {
	      return undefined;
	    }
	
	    var imageSize =
	        [this.image_.getImage().width, this.image_.getImage().height];
	
	    if (!this.hitTransformationMatrix_) {
	      this.hitTransformationMatrix_ = this.getHitTransformationMatrix_(
	        frameState.size, imageSize);
	    }
	
	    var pixelOnFrameBuffer = apply(
	      this.hitTransformationMatrix_, pixel.slice());
	
	    if (pixelOnFrameBuffer[0] < 0 || pixelOnFrameBuffer[0] > imageSize[0] ||
	        pixelOnFrameBuffer[1] < 0 || pixelOnFrameBuffer[1] > imageSize[1]) {
	      // outside the image, no need to check
	      return undefined;
	    }
	
	    if (!this.hitCanvasContext_) {
	      this.hitCanvasContext_ = createCanvasContext2D(1, 1);
	    }
	
	    this.hitCanvasContext_.clearRect(0, 0, 1, 1);
	    this.hitCanvasContext_.drawImage(this.image_.getImage(),
	      pixelOnFrameBuffer[0], pixelOnFrameBuffer[1], 1, 1, 0, 0, 1, 1);
	
	    var imageData = this.hitCanvasContext_.getImageData(0, 0, 1, 1).data;
	    if (imageData[3] > 0) {
	      return callback.call(thisArg, this.getLayer(), imageData);
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * The transformation matrix to get the pixel on the image for a
	   * pixel on the map.
	   * @param {import("../../size.js").Size} mapSize The map size.
	   * @param {import("../../size.js").Size} imageSize The image size.
	   * @return {import("../../transform.js").Transform} The transformation matrix.
	   * @private
	   */
	  WebGLImageLayerRenderer.prototype.getHitTransformationMatrix_ = function getHitTransformationMatrix_ (mapSize, imageSize) {
	    // the first matrix takes a map pixel, flips the y-axis and scales to
	    // a range between -1 ... 1
	    var mapCoordTransform = create();
	    translate$1(mapCoordTransform, -1, -1);
	    scale$1(mapCoordTransform, 2 / mapSize[0], 2 / mapSize[1]);
	    translate$1(mapCoordTransform, 0, mapSize[1]);
	    scale$1(mapCoordTransform, 1, -1);
	
	    // the second matrix is the inverse of the projection matrix used in the
	    // shader for drawing
	    var projectionMatrixInv = invert(this.projectionMatrix.slice());
	
	    // the third matrix scales to the image dimensions and flips the y-axis again
	    var transform = create();
	    translate$1(transform, 0, imageSize[1]);
	    scale$1(transform, 1, -1);
	    scale$1(transform, imageSize[0] / 2, imageSize[1] / 2);
	    translate$1(transform, 1, 1);
	
	    multiply(transform, projectionMatrixInv);
	    multiply(transform, mapCoordTransform);
	
	    return transform;
	  };
	
	  return WebGLImageLayerRenderer;
	}(WebGLLayerRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	WebGLImageLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.IMAGE;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {WebGLImageLayerRenderer} The layer renderer.
	 */
	WebGLImageLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new WebGLImageLayerRenderer(
	    /** @type {import("./Map.js").default} */ (mapRenderer),
	    /** @type {import("../../layer/Image.js").default} */ (layer)
	  );
	};
	
	/**
	 * @module ol/renderer/webgl/Map
	 */
	
	
	/**
	 * @typedef {Object} TextureCacheEntry
	 * @property {number} magFilter
	 * @property {number} minFilter
	 * @property {WebGLTexture} texture
	 */
	
	
	/**
	 * Texture cache high water mark.
	 * @type {number}
	 */
	var WEBGL_TEXTURE_CACHE_HIGH_WATER_MARK = 1024;
	
	
	/**
	 * @classdesc
	 * WebGL map renderer.
	 * @api
	 */
	var WebGLMapRenderer = /*@__PURE__*/(function (MapRenderer$$1) {
	  function WebGLMapRenderer(map) {
	    MapRenderer$$1.call(this, map);
	
	    var container = map.getViewport();
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = /** @type {HTMLCanvasElement} */
	      (document.createElement('canvas'));
	    this.canvas_.style.width = '100%';
	    this.canvas_.style.height = '100%';
	    this.canvas_.style.display = 'block';
	    this.canvas_.className = CLASS_UNSELECTABLE;
	    container.insertBefore(this.canvas_, container.childNodes[0] || null);
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.clipTileCanvasWidth_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.clipTileCanvasHeight_ = 0;
	
	    /**
	     * @private
	     * @type {CanvasRenderingContext2D}
	     */
	    this.clipTileContext_ = createCanvasContext2D();
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderedVisible_ = true;
	
	    /**
	     * @private
	     * @type {WebGLRenderingContext}
	     */
	    this.gl_ = getContext(this.canvas_, {
	      antialias: true,
	      depth: true,
	      failIfMajorPerformanceCaveat: true,
	      preserveDrawingBuffer: false,
	      stencil: true
	    });
	
	    /**
	     * @private
	     * @type {import("../../webgl/Context.js").default}
	     */
	    this.context_ = new WebGLContext(this.canvas_, this.gl_);
	
	    listen(this.canvas_, ContextEventType.LOST,
	      this.handleWebGLContextLost, this);
	    listen(this.canvas_, ContextEventType.RESTORED,
	      this.handleWebGLContextRestored, this);
	
	    /**
	     * @private
	     * @type {import("../../structs/LRUCache.js").default<TextureCacheEntry|null>}
	     */
	    this.textureCache_ = new LRUCache();
	
	    /**
	     * @private
	     * @type {import("../../coordinate.js").Coordinate}
	     */
	    this.focus_ = null;
	
	    /**
	     * @private
	     * @type {import("../../structs/PriorityQueue.js").default<Array>}
	     */
	    this.tileTextureQueue_ = new PriorityQueue(
	      /**
	       * @param {Array<*>} element Element.
	       * @return {number} Priority.
	       * @this {WebGLMapRenderer}
	       */
	      (function(element) {
	        var tileCenter = /** @type {import("../../coordinate.js").Coordinate} */ (element[1]);
	        var tileResolution = /** @type {number} */ (element[2]);
	        var deltaX = tileCenter[0] - this.focus_[0];
	        var deltaY = tileCenter[1] - this.focus_[1];
	        return 65536 * Math.log(tileResolution) +
	              Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
	      }).bind(this),
	      /**
	       * @param {Array<*>} element Element.
	       * @return {string} Key.
	       */
	      function(element) {
	        return (
	          /** @type {import("../../Tile.js").default} */ (element[0]).getKey()
	        );
	      });
	
	
	    /**
	     * @param {import("../../PluggableMap.js").default} map Map.
	     * @param {?import("../../PluggableMap.js").FrameState} frameState Frame state.
	     * @return {boolean} false.
	     * @this {WebGLMapRenderer}
	     */
	    this.loadNextTileTexture_ =
	        function(map, frameState) {
	          if (!this.tileTextureQueue_.isEmpty()) {
	            this.tileTextureQueue_.reprioritize();
	            var element = this.tileTextureQueue_.dequeue();
	            var tile = /** @type {import("../../Tile.js").default} */ (element[0]);
	            var tileSize = /** @type {import("../../size.js").Size} */ (element[3]);
	            var tileGutter = /** @type {number} */ (element[4]);
	            this.bindTileTexture(
	              tile, tileSize, tileGutter, LINEAR, LINEAR);
	          }
	          return false;
	        }.bind(this);
	
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textureCacheFrameMarkerCount_ = 0;
	
	    this.initializeGL_();
	  }
	
	  if ( MapRenderer$$1 ) { WebGLMapRenderer.__proto__ = MapRenderer$$1; }
	  WebGLMapRenderer.prototype = Object.create( MapRenderer$$1 && MapRenderer$$1.prototype );
	  WebGLMapRenderer.prototype.constructor = WebGLMapRenderer;
	
	  /**
	   * @param {import("../../Tile.js").default} tile Tile.
	   * @param {import("../../size.js").Size} tileSize Tile size.
	   * @param {number} tileGutter Tile gutter.
	   * @param {number} magFilter Mag filter.
	   * @param {number} minFilter Min filter.
	   */
	  WebGLMapRenderer.prototype.bindTileTexture = function bindTileTexture (tile, tileSize, tileGutter, magFilter, minFilter) {
	    var gl = this.getGL();
	    var tileKey = tile.getKey();
	    if (this.textureCache_.containsKey(tileKey)) {
	      var textureCacheEntry = this.textureCache_.get(tileKey);
	      gl.bindTexture(TEXTURE_2D, textureCacheEntry.texture);
	      if (textureCacheEntry.magFilter != magFilter) {
	        gl.texParameteri(
	          TEXTURE_2D, TEXTURE_MAG_FILTER, magFilter);
	        textureCacheEntry.magFilter = magFilter;
	      }
	      if (textureCacheEntry.minFilter != minFilter) {
	        gl.texParameteri(
	          TEXTURE_2D, TEXTURE_MIN_FILTER, minFilter);
	        textureCacheEntry.minFilter = minFilter;
	      }
	    } else {
	      var texture = gl.createTexture();
	      var imageTile = /** @type {import("../../ImageTile.js").default} */ (tile);
	      gl.bindTexture(TEXTURE_2D, texture);
	      if (tileGutter > 0) {
	        var clipTileCanvas = this.clipTileContext_.canvas;
	        var clipTileContext = this.clipTileContext_;
	        if (this.clipTileCanvasWidth_ !== tileSize[0] ||
	            this.clipTileCanvasHeight_ !== tileSize[1]) {
	          clipTileCanvas.width = tileSize[0];
	          clipTileCanvas.height = tileSize[1];
	          this.clipTileCanvasWidth_ = tileSize[0];
	          this.clipTileCanvasHeight_ = tileSize[1];
	        } else {
	          clipTileContext.clearRect(0, 0, tileSize[0], tileSize[1]);
	        }
	        clipTileContext.drawImage(imageTile.getImage(), tileGutter, tileGutter,
	          tileSize[0], tileSize[1], 0, 0, tileSize[0], tileSize[1]);
	        gl.texImage2D(TEXTURE_2D, 0,
	          RGBA, RGBA,
	          UNSIGNED_BYTE, clipTileCanvas);
	      } else {
	        gl.texImage2D(TEXTURE_2D, 0,
	          RGBA, RGBA,
	          UNSIGNED_BYTE, imageTile.getImage());
	      }
	      gl.texParameteri(
	        TEXTURE_2D, TEXTURE_MAG_FILTER, magFilter);
	      gl.texParameteri(
	        TEXTURE_2D, TEXTURE_MIN_FILTER, minFilter);
	      gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_S,
	        CLAMP_TO_EDGE);
	      gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_T,
	        CLAMP_TO_EDGE);
	      this.textureCache_.set(tileKey, {
	        texture: texture,
	        magFilter: magFilter,
	        minFilter: minFilter
	      });
	    }
	  };
	
	  /**
	   * @param {import("../../render/EventType.js").default} type Event type.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   */
	  WebGLMapRenderer.prototype.dispatchRenderEvent = function dispatchRenderEvent (type, frameState) {
	    var map = this.getMap();
	    if (map.hasListener(type)) {
	      var context = this.context_;
	
	      var extent = frameState.extent;
	      var size = frameState.size;
	      var viewState = frameState.viewState;
	      var pixelRatio = frameState.pixelRatio;
	
	      var resolution = viewState.resolution;
	      var center = viewState.center;
	      var rotation = viewState.rotation;
	
	      var vectorContext = new WebGLImmediateRenderer(context,
	        center, resolution, rotation, size, extent, pixelRatio);
	      var composeEvent = new RenderEvent(type, vectorContext,
	        frameState, null, context);
	      map.dispatchEvent(composeEvent);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLMapRenderer.prototype.disposeInternal = function disposeInternal () {
	    var gl = this.getGL();
	    if (!gl.isContextLost()) {
	      this.textureCache_.forEach(
	        /**
	         * @param {?TextureCacheEntry} textureCacheEntry
	         *     Texture cache entry.
	         */
	        function(textureCacheEntry) {
	          if (textureCacheEntry) {
	            gl.deleteTexture(textureCacheEntry.texture);
	          }
	        });
	    }
	    this.context_.dispose();
	    MapRenderer$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @param {import("../../PluggableMap.js").default} map Map.
	   * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
	   * @private
	   */
	  WebGLMapRenderer.prototype.expireCache_ = function expireCache_ (map, frameState) {
	    var gl = this.getGL();
	    var textureCacheEntry;
	    while (this.textureCache_.getCount() - this.textureCacheFrameMarkerCount_ >
	        WEBGL_TEXTURE_CACHE_HIGH_WATER_MARK) {
	      textureCacheEntry = this.textureCache_.peekLast();
	      if (!textureCacheEntry) {
	        if (+this.textureCache_.peekLastKey() == frameState.index) {
	          break;
	        } else {
	          --this.textureCacheFrameMarkerCount_;
	        }
	      } else {
	        gl.deleteTexture(textureCacheEntry.texture);
	      }
	      this.textureCache_.pop();
	    }
	  };
	
	  /**
	   * @return {import("../../webgl/Context.js").default} The context.
	   */
	  WebGLMapRenderer.prototype.getContext = function getContext$$1 () {
	    return this.context_;
	  };
	
	  /**
	   * @return {WebGLRenderingContext} GL.
	   */
	  WebGLMapRenderer.prototype.getGL = function getGL () {
	    return this.gl_;
	  };
	
	  /**
	   * @return {import("../../structs/PriorityQueue.js").default<Array>} Tile texture queue.
	   */
	  WebGLMapRenderer.prototype.getTileTextureQueue = function getTileTextureQueue () {
	    return this.tileTextureQueue_;
	  };
	
	  /**
	   * @param {import("../../events/Event.js").default} event Event.
	   * @protected
	   */
	  WebGLMapRenderer.prototype.handleWebGLContextLost = function handleWebGLContextLost (event) {
	    event.preventDefault();
	    this.textureCache_.clear();
	    this.textureCacheFrameMarkerCount_ = 0;
	
	    var renderers = this.getLayerRenderers();
	    for (var id in renderers) {
	      var renderer = /** @type {import("./Layer.js").default} */ (renderers[id]);
	      renderer.handleWebGLContextLost();
	    }
	  };
	
	  /**
	   * @protected
	   */
	  WebGLMapRenderer.prototype.handleWebGLContextRestored = function handleWebGLContextRestored () {
	    this.initializeGL_();
	    this.getMap().render();
	  };
	
	  /**
	   * @private
	   */
	  WebGLMapRenderer.prototype.initializeGL_ = function initializeGL_ () {
	    var gl = this.gl_;
	    gl.activeTexture(TEXTURE0);
	    gl.blendFuncSeparate(
	      SRC_ALPHA, ONE_MINUS_SRC_ALPHA,
	      ONE, ONE_MINUS_SRC_ALPHA);
	    gl.disable(CULL_FACE);
	    gl.disable(DEPTH_TEST);
	    gl.disable(SCISSOR_TEST);
	    gl.disable(STENCIL_TEST);
	  };
	
	  /**
	   * @param {import("../../Tile.js").default} tile Tile.
	   * @return {boolean} Is tile texture loaded.
	   */
	  WebGLMapRenderer.prototype.isTileTextureLoaded = function isTileTextureLoaded (tile) {
	    return this.textureCache_.containsKey(tile.getKey());
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLMapRenderer.prototype.renderFrame = function renderFrame (frameState) {
	
	    var context = this.getContext();
	    var gl = this.getGL();
	
	    if (gl.isContextLost()) {
	      return false;
	    }
	
	    if (!frameState) {
	      if (this.renderedVisible_) {
	        this.canvas_.style.display = 'none';
	        this.renderedVisible_ = false;
	      }
	      return false;
	    }
	
	    this.focus_ = frameState.focus;
	
	    this.textureCache_.set((-frameState.index).toString(), null);
	    ++this.textureCacheFrameMarkerCount_;
	
	    this.dispatchRenderEvent(RenderEventType.PRECOMPOSE, frameState);
	
	    /** @type {Array<import("../../layer/Layer.js").State>} */
	    var layerStatesToDraw = [];
	    var layerStatesArray = frameState.layerStatesArray;
	    stableSort(layerStatesArray, sortByZIndex);
	
	    var viewResolution = frameState.viewState.resolution;
	    var i, ii;
	    for (i = 0, ii = layerStatesArray.length; i < ii; ++i) {
	      var layerState = layerStatesArray[i];
	      if (visibleAtResolution(layerState, viewResolution) &&
	          layerState.sourceState == SourceState.READY) {
	        var layerRenderer = /** @type {import("./Layer.js").default} */ (this.getLayerRenderer(layerState.layer));
	        if (layerRenderer.prepareFrame(frameState, layerState, context)) {
	          layerStatesToDraw.push(layerState);
	        }
	      }
	    }
	
	    var width = frameState.size[0] * frameState.pixelRatio;
	    var height = frameState.size[1] * frameState.pixelRatio;
	    if (this.canvas_.width != width || this.canvas_.height != height) {
	      this.canvas_.width = width;
	      this.canvas_.height = height;
	    }
	
	    gl.bindFramebuffer(FRAMEBUFFER, null);
	
	    gl.clearColor(0, 0, 0, 0);
	    gl.clear(COLOR_BUFFER_BIT);
	    gl.enable(BLEND);
	    gl.viewport(0, 0, this.canvas_.width, this.canvas_.height);
	
	    for (i = 0, ii = layerStatesToDraw.length; i < ii; ++i) {
	      var layerState$1 = layerStatesToDraw[i];
	      var layerRenderer$1 = /** @type {import("./Layer.js").default} */ (this.getLayerRenderer(layerState$1.layer));
	      layerRenderer$1.composeFrame(frameState, layerState$1, context);
	    }
	
	    if (!this.renderedVisible_) {
	      this.canvas_.style.display = '';
	      this.renderedVisible_ = true;
	    }
	
	    this.calculateMatrices2D(frameState);
	
	    if (this.textureCache_.getCount() - this.textureCacheFrameMarkerCount_ >
	        WEBGL_TEXTURE_CACHE_HIGH_WATER_MARK) {
	      frameState.postRenderFunctions.push(
	        /** @type {import("../../PluggableMap.js").PostRenderFunction} */ (this.expireCache_.bind(this))
	      );
	    }
	
	    if (!this.tileTextureQueue_.isEmpty()) {
	      frameState.postRenderFunctions.push(this.loadNextTileTexture_);
	      frameState.animate = true;
	    }
	
	    this.dispatchRenderEvent(RenderEventType.POSTCOMPOSE, frameState);
	
	    this.scheduleRemoveUnusedLayerRenderers(frameState);
	    this.scheduleExpireIconCache(frameState);
	
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLMapRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (
	    coordinate,
	    frameState,
	    hitTolerance,
	    callback,
	    thisArg,
	    layerFilter,
	    thisArg2
	  ) {
	    var result;
	
	    if (this.getGL().isContextLost()) {
	      return false;
	    }
	
	    var viewState = frameState.viewState;
	
	    var layerStates = frameState.layerStatesArray;
	    var numLayers = layerStates.length;
	    var i;
	    for (i = numLayers - 1; i >= 0; --i) {
	      var layerState = layerStates[i];
	      var layer = layerState.layer;
	      if (visibleAtResolution(layerState, viewState.resolution) &&
	          layerFilter.call(thisArg2, layer)) {
	        var layerRenderer = this.getLayerRenderer(layer);
	        result = layerRenderer.forEachFeatureAtCoordinate(
	          coordinate, frameState, hitTolerance, callback);
	        if (result) {
	          return result;
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLMapRenderer.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate (coordinate, frameState, hitTolerance, layerFilter, thisArg) {
	    var hasFeature = false;
	
	    if (this.getGL().isContextLost()) {
	      return false;
	    }
	
	    var viewState = frameState.viewState;
	
	    var layerStates = frameState.layerStatesArray;
	    var numLayers = layerStates.length;
	    var i;
	    for (i = numLayers - 1; i >= 0; --i) {
	      var layerState = layerStates[i];
	      var layer = layerState.layer;
	      if (visibleAtResolution(layerState, viewState.resolution) &&
	          layerFilter.call(thisArg, layer)) {
	        var layerRenderer = this.getLayerRenderer(layer);
	        hasFeature =
	            layerRenderer.hasFeatureAtCoordinate(coordinate, frameState);
	        if (hasFeature) {
	          return true;
	        }
	      }
	    }
	    return hasFeature;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLMapRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, hitTolerance, callback, thisArg, layerFilter, thisArg2) {
	    if (this.getGL().isContextLost()) {
	      return false;
	    }
	
	    var viewState = frameState.viewState;
	    var result;
	
	    var layerStates = frameState.layerStatesArray;
	    var numLayers = layerStates.length;
	    var i;
	    for (i = numLayers - 1; i >= 0; --i) {
	      var layerState = layerStates[i];
	      var layer = layerState.layer;
	      if (visibleAtResolution(layerState, viewState.resolution) &&
	          layerFilter.call(thisArg, layer)) {
	        var layerRenderer = /** @type {import("./Layer.js").default} */ (this.getLayerRenderer(layer));
	        result = layerRenderer.forEachLayerAtPixel(
	          pixel, frameState, callback, thisArg);
	        if (result) {
	          return result;
	        }
	      }
	    }
	    return undefined;
	  };
	
	  return WebGLMapRenderer;
	}(MapRenderer));
	
	/**
	 * @module ol/Tile
	 */
	
	
	/**
	 * A function that takes an {@link module:ol/Tile} for the tile and a
	 * `{string}` for the url as arguments. The default is
	 * ```js
	 * source.setTileLoadFunction(function(tile, src) {
	 *   tile.getImage().src = src;
	 * });
	 * ```
	 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
	 * error handling:
	 *
	 * ```js
	 * import TileState from 'ol/TileState';
	 *
	 * source.setTileLoadFunction(function(tile, src) {
	 *   var xhr = new XMLHttpRequest();
	 *   xhr.responseType = 'blob';
	 *   xhr.addEventListener('loadend', function (evt) {
	 *     var data = this.response;
	 *     if (data !== undefined) {
	 *       tile.getImage().src = URL.createObjectURL(data);
	 *     } else {
	 *       tile.setState(TileState.ERROR);
	 *     }
	 *   });
	 *   xhr.addEventListener('error', function () {
	 *     tile.setState(TileState.ERROR);
	 *   });
	 *   xhr.open('GET', src);
	 *   xhr.send();
	 * });
	 * ```
	 *
	 * @typedef {function(Tile, string)} LoadFunction
	 * @api
	 */
	
	/**
	 * {@link module:ol/source/Tile~Tile} sources use a function of this type to get
	 * the url that provides a tile for a given tile coordinate.
	 *
	 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
	 * coordinate, a `{number}` representing the pixel ratio and a
	 * {@link module:ol/proj/Projection} for the projection  as arguments
	 * and returns a `{string}` representing the tile URL, or undefined if no tile
	 * should be requested for the passed tile coordinate.
	 *
	 * @typedef {function(import("./tilecoord.js").TileCoord, number,
	 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
	 * @api
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [transition=250] A duration for tile opacity
	 * transitions in milliseconds. A duration of 0 disables the opacity transition.
	 * @api
	 */
	
	
	/**
	 * @classdesc
	 * Base class for tiles.
	 *
	 * @abstract
	 */
	var Tile = /*@__PURE__*/(function (EventTarget) {
	  function Tile(tileCoord, state, opt_options) {
	    EventTarget.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @type {import("./tilecoord.js").TileCoord}
	     */
	    this.tileCoord = tileCoord;
	
	    /**
	     * @protected
	     * @type {TileState}
	     */
	    this.state = state;
	
	    /**
	     * An "interim" tile for this tile. The interim tile may be used while this
	     * one is loading, for "smooth" transitions when changing params/dimensions
	     * on the source.
	     * @type {Tile}
	     */
	    this.interimTile = null;
	
	    /**
	     * A key assigned to the tile. This is used by the tile source to determine
	     * if this tile can effectively be used, or if a new tile should be created
	     * and this one be used as an interim tile for this new tile.
	     * @type {string}
	     */
	    this.key = '';
	
	    /**
	     * The duration for the opacity transition.
	     * @type {number}
	     */
	    this.transition_ = options.transition === undefined ? 250 : options.transition;
	
	    /**
	     * Lookup of start times for rendering transitions.  If the start time is
	     * equal to -1, the transition is complete.
	     * @type {Object<string, number>}
	     */
	    this.transitionStarts_ = {};
	
	  }
	
	  if ( EventTarget ) { Tile.__proto__ = EventTarget; }
	  Tile.prototype = Object.create( EventTarget && EventTarget.prototype );
	  Tile.prototype.constructor = Tile;
	
	  /**
	   * @protected
	   */
	  Tile.prototype.changed = function changed () {
	    this.dispatchEvent(EventType.CHANGE);
	  };
	
	  /**
	   * @return {string} Key.
	   */
	  Tile.prototype.getKey = function getKey () {
	    return this.key + '/' + this.tileCoord;
	  };
	
	  /**
	   * Get the interim tile most suitable for rendering using the chain of interim
	   * tiles. This corresponds to the  most recent tile that has been loaded, if no
	   * such tile exists, the original tile is returned.
	   * @return {!Tile} Best tile for rendering.
	   */
	  Tile.prototype.getInterimTile = function getInterimTile () {
	    if (!this.interimTile) {
	      //empty chain
	      return this;
	    }
	    var tile = this.interimTile;
	
	    // find the first loaded tile and return it. Since the chain is sorted in
	    // decreasing order of creation time, there is no need to search the remainder
	    // of the list (all those tiles correspond to older requests and will be
	    // cleaned up by refreshInterimChain)
	    do {
	      if (tile.getState() == TileState.LOADED) {
	        return tile;
	      }
	      tile = tile.interimTile;
	    } while (tile);
	
	    // we can not find a better tile
	    return this;
	  };
	
	  /**
	   * Goes through the chain of interim tiles and discards sections of the chain
	   * that are no longer relevant.
	   */
	  Tile.prototype.refreshInterimChain = function refreshInterimChain () {
	    if (!this.interimTile) {
	      return;
	    }
	
	    var tile = this.interimTile;
	    var prev = /** @type {Tile} */ (this);
	
	    do {
	      if (tile.getState() == TileState.LOADED) {
	        //we have a loaded tile, we can discard the rest of the list
	        //we would could abort any LOADING tile request
	        //older than this tile (i.e. any LOADING tile following this entry in the chain)
	        tile.interimTile = null;
	        break;
	      } else if (tile.getState() == TileState.LOADING) {
	        //keep this LOADING tile any loaded tiles later in the chain are
	        //older than this tile, so we're still interested in the request
	        prev = tile;
	      } else if (tile.getState() == TileState.IDLE) {
	        //the head of the list is the most current tile, we don't need
	        //to start any other requests for this chain
	        prev.interimTile = tile.interimTile;
	      } else {
	        prev = tile;
	      }
	      tile = prev.interimTile;
	    } while (tile);
	  };
	
	  /**
	   * Get the tile coordinate for this tile.
	   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
	   * @api
	   */
	  Tile.prototype.getTileCoord = function getTileCoord () {
	    return this.tileCoord;
	  };
	
	  /**
	   * @return {TileState} State.
	   */
	  Tile.prototype.getState = function getState () {
	    return this.state;
	  };
	
	  /**
	   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
	   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
	   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
	   * the tile queue and will block other requests.
	   * @param {TileState} state State.
	   * @api
	   */
	  Tile.prototype.setState = function setState (state) {
	    this.state = state;
	    this.changed();
	  };
	
	  /**
	   * Load the image or retry if loading previously failed.
	   * Loading is taken care of by the tile queue, and calling this method is
	   * only needed for preloading or for reloading in case of an error.
	   * @abstract
	   * @api
	   */
	  Tile.prototype.load = function load () {};
	
	  /**
	   * Get the alpha value for rendering.
	   * @param {string} id An id for the renderer.
	   * @param {number} time The render frame time.
	   * @return {number} A number between 0 and 1.
	   */
	  Tile.prototype.getAlpha = function getAlpha (id, time) {
	    if (!this.transition_) {
	      return 1;
	    }
	
	    var start = this.transitionStarts_[id];
	    if (!start) {
	      start = time;
	      this.transitionStarts_[id] = start;
	    } else if (start === -1) {
	      return 1;
	    }
	
	    var delta = time - start + (1000 / 60); // avoid rendering at 0
	    if (delta >= this.transition_) {
	      return 1;
	    }
	    return easeIn(delta / this.transition_);
	  };
	
	  /**
	   * Determine if a tile is in an alpha transition.  A tile is considered in
	   * transition if tile.getAlpha() has not yet been called or has been called
	   * and returned 1.
	   * @param {string} id An id for the renderer.
	   * @return {boolean} The tile is in transition.
	   */
	  Tile.prototype.inTransition = function inTransition (id) {
	    if (!this.transition_) {
	      return false;
	    }
	    return this.transitionStarts_[id] !== -1;
	  };
	
	  /**
	   * Mark a transition as complete.
	   * @param {string} id An id for the renderer.
	   */
	  Tile.prototype.endTransition = function endTransition (id) {
	    if (this.transition_) {
	      this.transitionStarts_[id] = -1;
	    }
	  };
	
	  return Tile;
	}(Target));
	
	/**
	 * @module ol/ImageTile
	 */
	
	
	var ImageTile = /*@__PURE__*/(function (Tile$$1) {
	  function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
	
	    Tile$$1.call(this, tileCoord, state, opt_options);
	
	    /**
	     * @private
	     * @type {?string}
	     */
	    this.crossOrigin_ = crossOrigin;
	
	    /**
	     * Image URI
	     *
	     * @private
	     * @type {string}
	     */
	    this.src_ = src;
	
	    /**
	     * @private
	     * @type {HTMLImageElement|HTMLCanvasElement}
	     */
	    this.image_ = new Image();
	    if (crossOrigin !== null) {
	      this.image_.crossOrigin = crossOrigin;
	    }
	
	    /**
	     * @private
	     * @type {Array<import("./events.js").EventsKey>}
	     */
	    this.imageListenerKeys_ = null;
	
	    /**
	     * @private
	     * @type {import("./Tile.js").LoadFunction}
	     */
	    this.tileLoadFunction_ = tileLoadFunction;
	
	  }
	
	  if ( Tile$$1 ) { ImageTile.__proto__ = Tile$$1; }
	  ImageTile.prototype = Object.create( Tile$$1 && Tile$$1.prototype );
	  ImageTile.prototype.constructor = ImageTile;
	
	  /**
	   * @inheritDoc
	   */
	  ImageTile.prototype.disposeInternal = function disposeInternal () {
	    if (this.state == TileState.LOADING) {
	      this.unlistenImage_();
	      this.image_ = getBlankImage();
	    }
	    if (this.interimTile) {
	      this.interimTile.dispose();
	    }
	    this.state = TileState.ABORT;
	    this.changed();
	    Tile$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
	   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
	   * @api
	   */
	  ImageTile.prototype.getImage = function getImage () {
	    return this.image_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ImageTile.prototype.getKey = function getKey () {
	    return this.src_;
	  };
	
	  /**
	   * Tracks loading or read errors.
	   *
	   * @private
	   */
	  ImageTile.prototype.handleImageError_ = function handleImageError_ () {
	    this.state = TileState.ERROR;
	    this.unlistenImage_();
	    this.image_ = getBlankImage();
	    this.changed();
	  };
	
	  /**
	   * Tracks successful image load.
	   *
	   * @private
	   */
	  ImageTile.prototype.handleImageLoad_ = function handleImageLoad_ () {
	    var image = /** @type {HTMLImageElement} */ (this.image_);
	    if (image.naturalWidth && image.naturalHeight) {
	      this.state = TileState.LOADED;
	    } else {
	      this.state = TileState.EMPTY;
	    }
	    this.unlistenImage_();
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  ImageTile.prototype.load = function load () {
	    if (this.state == TileState.ERROR) {
	      this.state = TileState.IDLE;
	      this.image_ = new Image();
	      if (this.crossOrigin_ !== null) {
	        this.image_.crossOrigin = this.crossOrigin_;
	      }
	    }
	    if (this.state == TileState.IDLE) {
	      this.state = TileState.LOADING;
	      this.changed();
	      this.imageListenerKeys_ = [
	        listenOnce(this.image_, EventType.ERROR,
	          this.handleImageError_, this),
	        listenOnce(this.image_, EventType.LOAD,
	          this.handleImageLoad_, this)
	      ];
	      this.tileLoadFunction_(this, this.src_);
	    }
	  };
	
	  /**
	   * Discards event handlers which listen for load completion or errors.
	   *
	   * @private
	   */
	  ImageTile.prototype.unlistenImage_ = function unlistenImage_ () {
	    this.imageListenerKeys_.forEach(unlistenByKey);
	    this.imageListenerKeys_ = null;
	  };
	
	  return ImageTile;
	}(Tile));
	
	
	/**
	 * Get a 1-pixel blank image.
	 * @return {HTMLCanvasElement} Blank image.
	 */
	function getBlankImage() {
	  var ctx = createCanvasContext2D(1, 1);
	  ctx.fillStyle = 'rgba(0,0,0,0)';
	  ctx.fillRect(0, 0, 1, 1);
	  return ctx.canvas;
	}
	
	/**
	 * @module ol/tilecoord
	 */
	
	
	/**
	 * An array of three numbers representing the location of a tile in a tile
	 * grid. The order is `z`, `x`, and `y`. `z` is the zoom level.
	 * @typedef {Array<number>} TileCoord
	 * @api
	 */
	
	
	/**
	 * @param {number} z Z.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {TileCoord=} opt_tileCoord Tile coordinate.
	 * @return {TileCoord} Tile coordinate.
	 * @api
	 */
	function createOrUpdate$2(z, x, y, opt_tileCoord) {
	  if (opt_tileCoord !== undefined) {
	    opt_tileCoord[0] = z;
	    opt_tileCoord[1] = x;
	    opt_tileCoord[2] = y;
	    return opt_tileCoord;
	  } else {
	    return [z, x, y];
	  }
	}
	
	
	/**
	 * @param {number} z Z.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @return {string} Key.
	 * @api
	 */
	function getKeyZXY(z, x, y) {
	  return z + '/' + x + '/' + y;
	}
	
	
	/**
	 * Get the key for a tile coord.
	 * @param {TileCoord} tileCoord The tile coord.
	 * @return {string} Key.
	 * @api
	 */
	function getKey$1(tileCoord) {
	  return getKeyZXY(tileCoord[0], tileCoord[1], tileCoord[2]);
	}
	
	
	/**
	 * Get a tile coord given a key.
	 * @param {string} key The tile coord key.
	 * @return {TileCoord} The tile coord.
	 * @api
	 */
	function fromKey(key) {
	  return key.split('/').map(Number);
	}
	
	
	/**
	 * @param {TileCoord} tileCoord Tile coord.
	 * @return {number} Hash.
	 * @api
	 */
	function hash(tileCoord) {
	  return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
	}
	
	
	/**
	 * @param {TileCoord} tileCoord Tile coord.
	 * @return {string} Quad key.
	 * @api
	 */
	function quadKey(tileCoord) {
	  var z = tileCoord[0];
	  var digits = new Array(z);
	  var mask = 1 << (z - 1);
	  var i, charCode;
	  for (i = 0; i < z; ++i) {
	    // 48 is charCode for 0 - '0'.charCodeAt(0)
	    charCode = 48;
	    if (tileCoord[1] & mask) {
	      charCode += 1;
	    }
	    if (tileCoord[2] & mask) {
	      charCode += 2;
	    }
	    digits[i] = String.fromCharCode(charCode);
	    mask >>= 1;
	  }
	  return digits.join('');
	}
	
	
	/**
	 * @param {TileCoord} tileCoord Tile coordinate.
	 * @param {!import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
	 * @return {boolean} Tile coordinate is within extent and zoom level range.
	 * @api
	 */
	function withinExtentAndZ(tileCoord, tileGrid) {
	  var z = tileCoord[0];
	  var x = tileCoord[1];
	  var y = tileCoord[2];
	
	  if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) {
	    return false;
	  }
	  var extent = tileGrid.getExtent();
	  var tileRange;
	  if (!extent) {
	    tileRange = tileGrid.getFullTileRange(z);
	  } else {
	    tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
	  }
	  if (!tileRange) {
	    return true;
	  } else {
	    return tileRange.containsXY(x, y);
	  }
	}
	
	/**
	 * @module ol/TileCache
	 */
	
	var TileCache = /*@__PURE__*/(function (LRUCache$$1) {
	  function TileCache(opt_highWaterMark) {
	
	    LRUCache$$1.call(this, opt_highWaterMark);
	
	  }
	
	  if ( LRUCache$$1 ) { TileCache.__proto__ = LRUCache$$1; }
	  TileCache.prototype = Object.create( LRUCache$$1 && LRUCache$$1.prototype );
	  TileCache.prototype.constructor = TileCache;
	
	  /**
	   * @param {!Object<string, import("./TileRange.js").default>} usedTiles Used tiles.
	   */
	  TileCache.prototype.expireCache = function expireCache (usedTiles) {
	    while (this.canExpireCache()) {
	      var tile = this.peekLast();
	      var zKey = tile.tileCoord[0].toString();
	      if (zKey in usedTiles && usedTiles[zKey].contains(tile.tileCoord)) {
	        break;
	      } else {
	        this.pop().dispose();
	      }
	    }
	  };
	
	  /**
	   * Prune all tiles from the cache that don't have the same z as the newest tile.
	   */
	  TileCache.prototype.pruneExceptNewestZ = function pruneExceptNewestZ () {
	    if (this.getCount() === 0) {
	      return;
	    }
	    var key = this.peekFirstKey();
	    var tileCoord = fromKey(key);
	    var z = tileCoord[0];
	    this.forEach(function(tile) {
	      if (tile.tileCoord[0] !== z) {
	        this.remove(getKey$1(tile.tileCoord));
	        tile.dispose();
	      }
	    }, this);
	  };
	
	  return TileCache;
	}(LRUCache));
	
	/**
	 * @module ol/tilegrid/TileGrid
	 */
	
	
	/**
	 * @private
	 * @type {import("../tilecoord.js").TileCoord}
	 */
	var tmpTileCoord = [0, 0, 0];
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
	 * extent will be requested by {@link module:ol/source/Tile} sources. When no `origin` or
	 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
	 * @property {number} [minZoom=0] Minimum zoom.
	 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
	 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and upwards. If not
	 * specified, `extent` or `origins` must be provided.
	 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
	 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
	 * should match the length of the `resolutions` array, i.e. each resolution can have a different
	 * origin. Tile coordinates increase left to right and upwards. If not specified, `extent` or
	 * `origin` must be provided.
	 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
	 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
	 * array will have a length of `maxZoom + 1`.
	 * @property {Array<import("../size.js").Size>} [sizes] Sizes.
	 * @property {number|import("../size.js").Size} [tileSize] Tile size.
	 * Default is `[256, 256]`.
	 * @property {Array<import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
	 * should match the length of the `resolutions` array, i.e. each resolution can have a different
	 * tile size.
	 */
	
	
	/**
	 * @classdesc
	 * Base class for setting the grid pattern for sources accessing tiled-image
	 * servers.
	 * @api
	 */
	var TileGrid = function TileGrid(options) {
	
	  /**
	   * @protected
	   * @type {number}
	   */
	  this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
	
	  /**
	   * @private
	   * @type {!Array<number>}
	   */
	  this.resolutions_ = options.resolutions;
	  assert(isSorted(this.resolutions_, function(a, b) {
	    return b - a;
	  }, true), 17); // `resolutions` must be sorted in descending order
	
	
	  // check if we've got a consistent zoom factor and origin
	  var zoomFactor;
	  if (!options.origins) {
	    for (var i = 0, ii = this.resolutions_.length - 1; i < ii; ++i) {
	      if (!zoomFactor) {
	        zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
	      } else {
	        if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
	          zoomFactor = undefined;
	          break;
	        }
	      }
	    }
	  }
	
	
	  /**
	   * @private
	   * @type {number|undefined}
	   */
	  this.zoomFactor_ = zoomFactor;
	
	
	  /**
	   * @protected
	   * @type {number}
	   */
	  this.maxZoom = this.resolutions_.length - 1;
	
	  /**
	   * @private
	   * @type {import("../coordinate.js").Coordinate}
	   */
	  this.origin_ = options.origin !== undefined ? options.origin : null;
	
	  /**
	   * @private
	   * @type {Array<import("../coordinate.js").Coordinate>}
	   */
	  this.origins_ = null;
	  if (options.origins !== undefined) {
	    this.origins_ = options.origins;
	    assert(this.origins_.length == this.resolutions_.length,
	      20); // Number of `origins` and `resolutions` must be equal
	  }
	
	  var extent = options.extent;
	
	  if (extent !== undefined &&
	      !this.origin_ && !this.origins_) {
	    this.origin_ = getTopLeft(extent);
	  }
	
	  assert(
	    (!this.origin_ && this.origins_) || (this.origin_ && !this.origins_),
	    18); // Either `origin` or `origins` must be configured, never both
	
	  /**
	   * @private
	   * @type {Array<number|import("../size.js").Size>}
	   */
	  this.tileSizes_ = null;
	  if (options.tileSizes !== undefined) {
	    this.tileSizes_ = options.tileSizes;
	    assert(this.tileSizes_.length == this.resolutions_.length,
	      19); // Number of `tileSizes` and `resolutions` must be equal
	  }
	
	  /**
	   * @private
	   * @type {number|import("../size.js").Size}
	   */
	  this.tileSize_ = options.tileSize !== undefined ?
	    options.tileSize :
	    !this.tileSizes_ ? DEFAULT_TILE_SIZE : null;
	  assert(
	    (!this.tileSize_ && this.tileSizes_) ||
	      (this.tileSize_ && !this.tileSizes_),
	    22); // Either `tileSize` or `tileSizes` must be configured, never both
	
	  /**
	   * @private
	   * @type {import("../extent.js").Extent}
	   */
	  this.extent_ = extent !== undefined ? extent : null;
	
	
	  /**
	   * @private
	   * @type {Array<import("../TileRange.js").default>}
	   */
	  this.fullTileRanges_ = null;
	
	  /**
	   * @private
	   * @type {import("../size.js").Size}
	   */
	  this.tmpSize_ = [0, 0];
	
	  if (options.sizes !== undefined) {
	    this.fullTileRanges_ = options.sizes.map(function(size, z) {
	      var tileRange = new TileRange(
	        Math.min(0, size[0]), Math.max(size[0] - 1, -1),
	        Math.min(0, size[1]), Math.max(size[1] - 1, -1));
	      return tileRange;
	    }, this);
	  } else if (extent) {
	    this.calculateTileRanges_(extent);
	  }
	
	};
	
	/**
	 * Call a function with each tile coordinate for a given extent and zoom level.
	 *
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @param {number} zoom Integer zoom level.
	 * @param {function(import("../tilecoord.js").TileCoord)} callback Function called with each tile coordinate.
	 * @api
	 */
	TileGrid.prototype.forEachTileCoord = function forEachTileCoord (extent, zoom, callback) {
	  var tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
	  for (var i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i) {
	    for (var j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j) {
	      callback([zoom, i, j]);
	    }
	  }
	};
	
	/**
	 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @param {function(this: T, number, import("../TileRange.js").default): boolean} callback Callback.
	 * @param {T=} opt_this The object to use as `this` in `callback`.
	 * @param {import("../TileRange.js").default=} opt_tileRange Temporary import("../TileRange.js").default object.
	 * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
	 * @return {boolean} Callback succeeded.
	 * @template T
	 */
	TileGrid.prototype.forEachTileCoordParentTileRange = function forEachTileCoordParentTileRange (tileCoord, callback, opt_this, opt_tileRange, opt_extent) {
	  var tileRange, x, y;
	  var tileCoordExtent = null;
	  var z = tileCoord[0] - 1;
	  if (this.zoomFactor_ === 2) {
	    x = tileCoord[1];
	    y = tileCoord[2];
	  } else {
	    tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
	  }
	  while (z >= this.minZoom) {
	    if (this.zoomFactor_ === 2) {
	      x = Math.floor(x / 2);
	      y = Math.floor(y / 2);
	      tileRange = createOrUpdate$1(x, x, y, y, opt_tileRange);
	    } else {
	      tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
	    }
	    if (callback.call(opt_this, z, tileRange)) {
	      return true;
	    }
	    --z;
	  }
	  return false;
	};
	
	/**
	 * Get the extent for this tile grid, if it was configured.
	 * @return {import("../extent.js").Extent} Extent.
	 */
	TileGrid.prototype.getExtent = function getExtent () {
	  return this.extent_;
	};
	
	/**
	 * Get the maximum zoom level for the grid.
	 * @return {number} Max zoom.
	 * @api
	 */
	TileGrid.prototype.getMaxZoom = function getMaxZoom () {
	  return this.maxZoom;
	};
	
	/**
	 * Get the minimum zoom level for the grid.
	 * @return {number} Min zoom.
	 * @api
	 */
	TileGrid.prototype.getMinZoom = function getMinZoom () {
	  return this.minZoom;
	};
	
	/**
	 * Get the origin for the grid at the given zoom level.
	 * @param {number} z Integer zoom level.
	 * @return {import("../coordinate.js").Coordinate} Origin.
	 * @api
	 */
	TileGrid.prototype.getOrigin = function getOrigin (z) {
	  if (this.origin_) {
	    return this.origin_;
	  } else {
	    return this.origins_[z];
	  }
	};
	
	/**
	 * Get the resolution for the given zoom level.
	 * @param {number} z Integer zoom level.
	 * @return {number} Resolution.
	 * @api
	 */
	TileGrid.prototype.getResolution = function getResolution (z) {
	  return this.resolutions_[z];
	};
	
	/**
	 * Get the list of resolutions for the tile grid.
	 * @return {Array<number>} Resolutions.
	 * @api
	 */
	TileGrid.prototype.getResolutions = function getResolutions () {
	  return this.resolutions_;
	};
	
	/**
	 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @param {import("../TileRange.js").default=} opt_tileRange Temporary import("../TileRange.js").default object.
	 * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
	 * @return {import("../TileRange.js").default} Tile range.
	 */
	TileGrid.prototype.getTileCoordChildTileRange = function getTileCoordChildTileRange (tileCoord, opt_tileRange, opt_extent) {
	  if (tileCoord[0] < this.maxZoom) {
	    if (this.zoomFactor_ === 2) {
	      var minX = tileCoord[1] * 2;
	      var minY = tileCoord[2] * 2;
	      return createOrUpdate$1(minX, minX + 1, minY, minY + 1, opt_tileRange);
	    }
	    var tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
	    return this.getTileRangeForExtentAndZ(
	      tileCoordExtent, tileCoord[0] + 1, opt_tileRange);
	  }
	  return null;
	};
	
	/**
	 * Get the extent for a tile range.
	 * @param {number} z Integer zoom level.
	 * @param {import("../TileRange.js").default} tileRange Tile range.
	 * @param {import("../extent.js").Extent=} opt_extent Temporary import("../extent.js").Extent object.
	 * @return {import("../extent.js").Extent} Extent.
	 */
	TileGrid.prototype.getTileRangeExtent = function getTileRangeExtent (z, tileRange, opt_extent) {
	  var origin = this.getOrigin(z);
	  var resolution = this.getResolution(z);
	  var tileSize = toSize(this.getTileSize(z), this.tmpSize_);
	  var minX = origin[0] + tileRange.minX * tileSize[0] * resolution;
	  var maxX = origin[0] + (tileRange.maxX + 1) * tileSize[0] * resolution;
	  var minY = origin[1] + tileRange.minY * tileSize[1] * resolution;
	  var maxY = origin[1] + (tileRange.maxY + 1) * tileSize[1] * resolution;
	  return createOrUpdate(minX, minY, maxX, maxY, opt_extent);
	};
	
	/**
	 * Get a tile range for the given extent and integer zoom level.
	 * @param {import("../extent.js").Extent} extent Extent.
	 * @param {number} z Integer zoom level.
	 * @param {import("../TileRange.js").default=} opt_tileRange Temporary tile range object.
	 * @return {import("../TileRange.js").default} Tile range.
	 */
	TileGrid.prototype.getTileRangeForExtentAndZ = function getTileRangeForExtentAndZ (extent, z, opt_tileRange) {
	  var tileCoord = tmpTileCoord;
	  this.getTileCoordForXYAndZ_(extent[0], extent[1], z, false, tileCoord);
	  var minX = tileCoord[1];
	  var minY = tileCoord[2];
	  this.getTileCoordForXYAndZ_(extent[2], extent[3], z, true, tileCoord);
	  return createOrUpdate$1(minX, tileCoord[1], minY, tileCoord[2], opt_tileRange);
	};
	
	/**
	 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @return {import("../coordinate.js").Coordinate} Tile center.
	 */
	TileGrid.prototype.getTileCoordCenter = function getTileCoordCenter (tileCoord) {
	  var origin = this.getOrigin(tileCoord[0]);
	  var resolution = this.getResolution(tileCoord[0]);
	  var tileSize = toSize(this.getTileSize(tileCoord[0]), this.tmpSize_);
	  return [
	    origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
	    origin[1] + (tileCoord[2] + 0.5) * tileSize[1] * resolution
	  ];
	};
	
	/**
	 * Get the extent of a tile coordinate.
	 *
	 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @param {import("../extent.js").Extent=} opt_extent Temporary extent object.
	 * @return {import("../extent.js").Extent} Extent.
	 * @api
	 */
	TileGrid.prototype.getTileCoordExtent = function getTileCoordExtent (tileCoord, opt_extent) {
	  var origin = this.getOrigin(tileCoord[0]);
	  var resolution = this.getResolution(tileCoord[0]);
	  var tileSize = toSize(this.getTileSize(tileCoord[0]), this.tmpSize_);
	  var minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
	  var minY = origin[1] + tileCoord[2] * tileSize[1] * resolution;
	  var maxX = minX + tileSize[0] * resolution;
	  var maxY = minY + tileSize[1] * resolution;
	  return createOrUpdate(minX, minY, maxX, maxY, opt_extent);
	};
	
	/**
	 * Get the tile coordinate for the given map coordinate and resolution.This
	 * method considers that coordinates that intersect tile boundaries should be
	 * assigned the higher tile coordinate.
	 *
	 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	 * @param {number} resolution Resolution.
	 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Destination import("../tilecoord.js").TileCoord object.
	 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
	 * @api
	 */
	TileGrid.prototype.getTileCoordForCoordAndResolution = function getTileCoordForCoordAndResolution (coordinate, resolution, opt_tileCoord) {
	  return this.getTileCoordForXYAndResolution_(
	    coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
	};
	
	/**
	 * Note that this method should not be called for resolutions that correspond
	 * to an integer zoom level.Instead call the `getTileCoordForXYAndZ_` method.
	 * @param {number} x X.
	 * @param {number} y Y.
	 * @param {number} resolution Resolution (for a non-integer zoom level).
	 * @param {boolean} reverseIntersectionPolicy Instead of letting edge
	 *   intersections go to the higher tile coordinate, let edge intersections
	 *   go to the lower tile coordinate.
	 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Temporary import("../tilecoord.js").TileCoord object.
	 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
	 * @private
	 */
	TileGrid.prototype.getTileCoordForXYAndResolution_ = function getTileCoordForXYAndResolution_ (x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
	  var z = this.getZForResolution(resolution);
	  var scale = resolution / this.getResolution(z);
	  var origin = this.getOrigin(z);
	  var tileSize = toSize(this.getTileSize(z), this.tmpSize_);
	
	  var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
	  var adjustY = reverseIntersectionPolicy ? 0 : 0.5;
	  var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
	  var yFromOrigin = Math.floor((y - origin[1]) / resolution + adjustY);
	  var tileCoordX = scale * xFromOrigin / tileSize[0];
	  var tileCoordY = scale * yFromOrigin / tileSize[1];
	
	  if (reverseIntersectionPolicy) {
	    tileCoordX = Math.ceil(tileCoordX) - 1;
	    tileCoordY = Math.ceil(tileCoordY) - 1;
	  } else {
	    tileCoordX = Math.floor(tileCoordX);
	    tileCoordY = Math.floor(tileCoordY);
	  }
	
	  return createOrUpdate$2(z, tileCoordX, tileCoordY, opt_tileCoord);
	};
	
	/**
	 * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
	 * they should have separate implementations.This method is for integer zoom
	 * levels.The other method should only be called for resolutions corresponding
	 * to non-integer zoom levels.
	 * @param {number} x Map x coordinate.
	 * @param {number} y Map y coordinate.
	 * @param {number} z Integer zoom level.
	 * @param {boolean} reverseIntersectionPolicy Instead of letting edge
	 *   intersections go to the higher tile coordinate, let edge intersections
	 *   go to the lower tile coordinate.
	 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Temporary import("../tilecoord.js").TileCoord object.
	 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
	 * @private
	 */
	TileGrid.prototype.getTileCoordForXYAndZ_ = function getTileCoordForXYAndZ_ (x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
	  var origin = this.getOrigin(z);
	  var resolution = this.getResolution(z);
	  var tileSize = toSize(this.getTileSize(z), this.tmpSize_);
	
	  var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
	  var adjustY = reverseIntersectionPolicy ? 0 : 0.5;
	  var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
	  var yFromOrigin = Math.floor((y - origin[1]) / resolution + adjustY);
	  var tileCoordX = xFromOrigin / tileSize[0];
	  var tileCoordY = yFromOrigin / tileSize[1];
	
	  if (reverseIntersectionPolicy) {
	    tileCoordX = Math.ceil(tileCoordX) - 1;
	    tileCoordY = Math.ceil(tileCoordY) - 1;
	  } else {
	    tileCoordX = Math.floor(tileCoordX);
	    tileCoordY = Math.floor(tileCoordY);
	  }
	
	  return createOrUpdate$2(z, tileCoordX, tileCoordY, opt_tileCoord);
	};
	
	/**
	 * Get a tile coordinate given a map coordinate and zoom level.
	 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	 * @param {number} z Zoom level.
	 * @param {import("../tilecoord.js").TileCoord=} opt_tileCoord Destination import("../tilecoord.js").TileCoord object.
	 * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
	 * @api
	 */
	TileGrid.prototype.getTileCoordForCoordAndZ = function getTileCoordForCoordAndZ (coordinate, z, opt_tileCoord) {
	  return this.getTileCoordForXYAndZ_(
	    coordinate[0], coordinate[1], z, false, opt_tileCoord);
	};
	
	/**
	 * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @return {number} Tile resolution.
	 */
	TileGrid.prototype.getTileCoordResolution = function getTileCoordResolution (tileCoord) {
	  return this.resolutions_[tileCoord[0]];
	};
	
	/**
	 * Get the tile size for a zoom level. The type of the return value matches the
	 * `tileSize` or `tileSizes` that the tile grid was configured with. To always
	 * get an `import("../size.js").Size`, run the result through `import("../size.js").Size.toSize()`.
	 * @param {number} z Z.
	 * @return {number|import("../size.js").Size} Tile size.
	 * @api
	 */
	TileGrid.prototype.getTileSize = function getTileSize (z) {
	  if (this.tileSize_) {
	    return this.tileSize_;
	  } else {
	    return this.tileSizes_[z];
	  }
	};
	
	/**
	 * @param {number} z Zoom level.
	 * @return {import("../TileRange.js").default} Extent tile range for the specified zoom level.
	 */
	TileGrid.prototype.getFullTileRange = function getFullTileRange (z) {
	  if (!this.fullTileRanges_) {
	    return null;
	  } else {
	    return this.fullTileRanges_[z];
	  }
	};
	
	/**
	 * @param {number} resolution Resolution.
	 * @param {number=} opt_direction If 0, the nearest resolution will be used.
	 *   If 1, the nearest lower resolution will be used. If -1, the nearest
	 *   higher resolution will be used. Default is 0.
	 * @return {number} Z.
	 * @api
	 */
	TileGrid.prototype.getZForResolution = function getZForResolution (resolution, opt_direction) {
	  var z = linearFindNearest(this.resolutions_, resolution, opt_direction || 0);
	  return clamp(z, this.minZoom, this.maxZoom);
	};
	
	/**
	 * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
	 * @private
	 */
	TileGrid.prototype.calculateTileRanges_ = function calculateTileRanges_ (extent) {
	  var length = this.resolutions_.length;
	  var fullTileRanges = new Array(length);
	  for (var z = this.minZoom; z < length; ++z) {
	    fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
	  }
	  this.fullTileRanges_ = fullTileRanges;
	};
	
	/**
	 * @module ol/tilegrid
	 */
	
	
	/**
	 * @param {import("./proj/Projection.js").default} projection Projection.
	 * @return {!TileGrid} Default tile grid for the
	 * passed projection.
	 * @api
	 */
	function getForProjection(projection) {
	  var tileGrid = projection.getDefaultTileGrid();
	  if (!tileGrid) {
	    tileGrid = createForProjection(projection);
	    projection.setDefaultTileGrid(tileGrid);
	  }
	  return tileGrid;
	}
	
	
	/**
	 * @param {TileGrid} tileGrid Tile grid.
	 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @param {import("./proj/Projection.js").default} projection Projection.
	 * @return {import("./tilecoord.js").TileCoord} Tile coordinate.
	 */
	function wrapX(tileGrid, tileCoord, projection) {
	  var z = tileCoord[0];
	  var center = tileGrid.getTileCoordCenter(tileCoord);
	  var projectionExtent = extentFromProjection(projection);
	  if (!containsCoordinate(projectionExtent, center)) {
	    var worldWidth = getWidth(projectionExtent);
	    var worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
	    center[0] += worldWidth * worldsAway;
	    return tileGrid.getTileCoordForCoordAndZ(center, z);
	  } else {
	    return tileCoord;
	  }
	}
	
	
	/**
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number=} opt_maxZoom Maximum zoom level (default is
	 *     DEFAULT_MAX_ZOOM).
	 * @param {number|import("./size.js").Size=} opt_tileSize Tile size (default uses
	 *     DEFAULT_TILE_SIZE).
	 * @param {Corner=} opt_corner Extent corner (default is `'top-left'`).
	 * @return {!TileGrid} TileGrid instance.
	 */
	function createForExtent(extent, opt_maxZoom, opt_tileSize, opt_corner) {
	  var corner = opt_corner !== undefined ? opt_corner : Corner.TOP_LEFT;
	
	  var resolutions = resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize);
	
	  return new TileGrid({
	    extent: extent,
	    origin: getCorner(extent, corner),
	    resolutions: resolutions,
	    tileSize: opt_tileSize
	  });
	}
	
	
	/**
	 * @typedef {Object} XYZOptions
	 * @property {import("./extent.js").Extent} [extent] Extent for the tile grid. The origin for an XYZ tile grid is the
	 * top-left corner of the extent. The zero level of the grid is defined by the resolution at which one tile fits in the
	 * provided extent. If not provided, the extent of the EPSG:3857 projection is used.
	 * @property {number} [maxZoom] Maximum zoom. The default is `42`. This determines the number of levels
	 * in the grid set. For example, a `maxZoom` of 21 means there are 22 levels in the grid set.
	 * @property {number} [minZoom=0] Minimum zoom.
	 * @property {number|import("./size.js").Size} [tileSize=[256, 256]] Tile size in pixels.
	 */
	
	
	/**
	 * Creates a tile grid with a standard XYZ tiling scheme.
	 * @param {XYZOptions=} opt_options Tile grid options.
	 * @return {!TileGrid} Tile grid instance.
	 * @api
	 */
	function createXYZ(opt_options) {
	  /** @type {XYZOptions} */
	  var xyzOptions = opt_options || {};
	
	  var extent = xyzOptions.extent || get$2('EPSG:3857').getExtent();
	
	  /** @type {import("./tilegrid/TileGrid.js").Options} */
	  var gridOptions = {
	    extent: extent,
	    minZoom: xyzOptions.minZoom,
	    tileSize: xyzOptions.tileSize,
	    resolutions: resolutionsFromExtent(
	      extent,
	      xyzOptions.maxZoom,
	      xyzOptions.tileSize
	    )
	  };
	  return new TileGrid(gridOptions);
	}
	
	
	/**
	 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
	 * @param {import("./extent.js").Extent} extent Extent.
	 * @param {number=} opt_maxZoom Maximum zoom level (default is
	 *     DEFAULT_MAX_ZOOM).
	 * @param {number|import("./size.js").Size=} opt_tileSize Tile size (default uses
	 *     DEFAULT_TILE_SIZE).
	 * @return {!Array<number>} Resolutions array.
	 */
	function resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize) {
	  var maxZoom = opt_maxZoom !== undefined ?
	    opt_maxZoom : DEFAULT_MAX_ZOOM;
	
	  var height = getHeight(extent);
	  var width = getWidth(extent);
	
	  var tileSize = toSize(opt_tileSize !== undefined ?
	    opt_tileSize : DEFAULT_TILE_SIZE);
	  var maxResolution = Math.max(
	    width / tileSize[0], height / tileSize[1]);
	
	  var length = maxZoom + 1;
	  var resolutions = new Array(length);
	  for (var z = 0; z < length; ++z) {
	    resolutions[z] = maxResolution / Math.pow(2, z);
	  }
	  return resolutions;
	}
	
	
	/**
	 * @param {import("./proj.js").ProjectionLike} projection Projection.
	 * @param {number=} opt_maxZoom Maximum zoom level (default is
	 *     DEFAULT_MAX_ZOOM).
	 * @param {number|import("./size.js").Size=} opt_tileSize Tile size (default uses
	 *     DEFAULT_TILE_SIZE).
	 * @param {Corner=} opt_corner Extent corner (default is `'top-left'`).
	 * @return {!TileGrid} TileGrid instance.
	 */
	function createForProjection(projection, opt_maxZoom, opt_tileSize, opt_corner) {
	  var extent = extentFromProjection(projection);
	  return createForExtent(extent, opt_maxZoom, opt_tileSize, opt_corner);
	}
	
	
	/**
	 * Generate a tile grid extent from a projection.  If the projection has an
	 * extent, it is used.  If not, a global extent is assumed.
	 * @param {import("./proj.js").ProjectionLike} projection Projection.
	 * @return {import("./extent.js").Extent} Extent.
	 */
	function extentFromProjection(projection) {
	  projection = get$2(projection);
	  var extent = projection.getExtent();
	  if (!extent) {
	    var half = 180 * METERS_PER_UNIT[Units.DEGREES] / projection.getMetersPerUnit();
	    extent = createOrUpdate(-half, -half, half, half);
	  }
	  return extent;
	}
	
	/**
	 * @module ol/source/Tile
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions]
	 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
	 * @property {number} [cacheSize]
	 * @property {boolean} [opaque]
	 * @property {number} [tilePixelRatio]
	 * @property {import("../proj.js").ProjectionLike} [projection]
	 * @property {import("./State.js").default} [state]
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid]
	 * @property {boolean} [wrapX=true]
	 * @property {number} [transition]
	 * @property {string} [key]
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for sources providing images divided into a tile grid.
	 * @abstract
	 * @api
	 */
	var TileSource = /*@__PURE__*/(function (Source$$1) {
	  function TileSource(options) {
	
	    Source$$1.call(this, {
	      attributions: options.attributions,
	      attributionsCollapsible: options.attributionsCollapsible,
	      projection: options.projection,
	      state: options.state,
	      wrapX: options.wrapX
	    });
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.opaque_ = options.opaque !== undefined ? options.opaque : false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.tilePixelRatio_ = options.tilePixelRatio !== undefined ?
	      options.tilePixelRatio : 1;
	
	    /**
	     * @protected
	     * @type {import("../tilegrid/TileGrid.js").default}
	     */
	    this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
	
	    /**
	     * @protected
	     * @type {import("../TileCache.js").default}
	     */
	    this.tileCache = new TileCache(options.cacheSize);
	
	    /**
	     * @protected
	     * @type {import("../size.js").Size}
	     */
	    this.tmpSize = [0, 0];
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.key_ = options.key || '';
	
	    /**
	     * @protected
	     * @type {import("../Tile.js").Options}
	     */
	    this.tileOptions = {transition: options.transition};
	
	  }
	
	  if ( Source$$1 ) { TileSource.__proto__ = Source$$1; }
	  TileSource.prototype = Object.create( Source$$1 && Source$$1.prototype );
	  TileSource.prototype.constructor = TileSource;
	
	  /**
	   * @return {boolean} Can expire cache.
	   */
	  TileSource.prototype.canExpireCache = function canExpireCache () {
	    return this.tileCache.canExpireCache();
	  };
	
	  /**
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {!Object<string, import("../TileRange.js").default>} usedTiles Used tiles.
	   */
	  TileSource.prototype.expireCache = function expireCache (projection, usedTiles) {
	    var tileCache = this.getTileCacheForProjection(projection);
	    if (tileCache) {
	      tileCache.expireCache(usedTiles);
	    }
	  };
	
	  /**
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {number} z Zoom level.
	   * @param {import("../TileRange.js").default} tileRange Tile range.
	   * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
	   *     loaded tile.  If the callback returns `false`, the tile will not be
	   *     considered loaded.
	   * @return {boolean} The tile range is fully covered with loaded tiles.
	   */
	  TileSource.prototype.forEachLoadedTile = function forEachLoadedTile (projection, z, tileRange, callback) {
	    var tileCache = this.getTileCacheForProjection(projection);
	    if (!tileCache) {
	      return false;
	    }
	
	    var covered = true;
	    var tile, tileCoordKey, loaded;
	    for (var x = tileRange.minX; x <= tileRange.maxX; ++x) {
	      for (var y = tileRange.minY; y <= tileRange.maxY; ++y) {
	        tileCoordKey = getKeyZXY(z, x, y);
	        loaded = false;
	        if (tileCache.containsKey(tileCoordKey)) {
	          tile = /** @type {!import("../Tile.js").default} */ (tileCache.get(tileCoordKey));
	          loaded = tile.getState() === TileState.LOADED;
	          if (loaded) {
	            loaded = (callback(tile) !== false);
	          }
	        }
	        if (!loaded) {
	          covered = false;
	        }
	      }
	    }
	    return covered;
	  };
	
	  /**
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {number} Gutter.
	   */
	  TileSource.prototype.getGutterForProjection = function getGutterForProjection (projection) {
	    return 0;
	  };
	
	  /**
	   * Return the key to be used for all tiles in the source.
	   * @return {string} The key for all tiles.
	   * @protected
	   */
	  TileSource.prototype.getKey = function getKey () {
	    return this.key_;
	  };
	
	  /**
	   * Set the value to be used as the key for all tiles in the source.
	   * @param {string} key The key for tiles.
	   * @protected
	   */
	  TileSource.prototype.setKey = function setKey (key) {
	    if (this.key_ !== key) {
	      this.key_ = key;
	      this.changed();
	    }
	  };
	
	  /**
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {boolean} Opaque.
	   */
	  TileSource.prototype.getOpaque = function getOpaque (projection) {
	    return this.opaque_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileSource.prototype.getResolutions = function getResolutions () {
	    return this.tileGrid.getResolutions();
	  };
	
	  /**
	   * @abstract
	   * @param {number} z Tile coordinate z.
	   * @param {number} x Tile coordinate x.
	   * @param {number} y Tile coordinate y.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {!import("../Tile.js").default} Tile.
	   */
	  TileSource.prototype.getTile = function getTile (z, x, y, pixelRatio, projection) {
	    return abstract();
	  };
	
	  /**
	   * Return the tile grid of the tile source.
	   * @return {import("../tilegrid/TileGrid.js").default} Tile grid.
	   * @api
	   */
	  TileSource.prototype.getTileGrid = function getTileGrid () {
	    return this.tileGrid;
	  };
	
	  /**
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
	   */
	  TileSource.prototype.getTileGridForProjection = function getTileGridForProjection$1 (projection) {
	    if (!this.tileGrid) {
	      return getForProjection(projection);
	    } else {
	      return this.tileGrid;
	    }
	  };
	
	  /**
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {import("../TileCache.js").default} Tile cache.
	   * @protected
	   */
	  TileSource.prototype.getTileCacheForProjection = function getTileCacheForProjection (projection) {
	    var thisProj = this.getProjection();
	    if (thisProj && !equivalent(thisProj, projection)) {
	      return null;
	    } else {
	      return this.tileCache;
	    }
	  };
	
	  /**
	   * Get the tile pixel ratio for this source. Subclasses may override this
	   * method, which is meant to return a supported pixel ratio that matches the
	   * provided `pixelRatio` as close as possible.
	   * @param {number} pixelRatio Pixel ratio.
	   * @return {number} Tile pixel ratio.
	   */
	  TileSource.prototype.getTilePixelRatio = function getTilePixelRatio (pixelRatio) {
	    return this.tilePixelRatio_;
	  };
	
	  /**
	   * @param {number} z Z.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {import("../size.js").Size} Tile size.
	   */
	  TileSource.prototype.getTilePixelSize = function getTilePixelSize (z, pixelRatio, projection) {
	    var tileGrid = this.getTileGridForProjection(projection);
	    var tilePixelRatio = this.getTilePixelRatio(pixelRatio);
	    var tileSize = toSize(tileGrid.getTileSize(z), this.tmpSize);
	    if (tilePixelRatio == 1) {
	      return tileSize;
	    } else {
	      return scale$3(tileSize, tilePixelRatio, this.tmpSize);
	    }
	  };
	
	  /**
	   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
	   * is outside the resolution and extent range of the tile grid, `null` will be
	   * returned.
	   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	   * @param {import("../proj/Projection.js").default=} opt_projection Projection.
	   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
	   *     null if no tile URL should be created for the passed `tileCoord`.
	   */
	  TileSource.prototype.getTileCoordForTileUrlFunction = function getTileCoordForTileUrlFunction (tileCoord, opt_projection) {
	    var projection = opt_projection !== undefined ?
	      opt_projection : this.getProjection();
	    var tileGrid = this.getTileGridForProjection(projection);
	    if (this.getWrapX() && projection.isGlobal()) {
	      tileCoord = wrapX(tileGrid, tileCoord, projection);
	    }
	    return withinExtentAndZ(tileCoord, tileGrid) ? tileCoord : null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileSource.prototype.refresh = function refresh () {
	    this.tileCache.clear();
	    this.changed();
	  };
	
	  /**
	   * Marks a tile coord as being used, without triggering a load.
	   * @abstract
	   * @param {number} z Tile coordinate z.
	   * @param {number} x Tile coordinate x.
	   * @param {number} y Tile coordinate y.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   */
	  TileSource.prototype.useTile = function useTile (z, x, y, projection) {};
	
	  return TileSource;
	}(Source));
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/source/Tile~TileSource} instances are instances of this
	 * type.
	 */
	var TileSourceEvent = /*@__PURE__*/(function (Event$$1) {
	  function TileSourceEvent(type, tile) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The tile related to the event.
	     * @type {import("../Tile.js").default}
	     * @api
	     */
	    this.tile = tile;
	
	  }
	
	  if ( Event$$1 ) { TileSourceEvent.__proto__ = Event$$1; }
	  TileSourceEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  TileSourceEvent.prototype.constructor = TileSourceEvent;
	
	  return TileSourceEvent;
	}(Event));
	
	/**
	 * @module ol/renderer/webgl/tilelayershader
	 */
	
	var fragment$5 = new WebGLFragment('precision mediump float;\nvarying vec2 v_texCoord;\n\n\nuniform sampler2D u_texture;\n\nvoid main(void) {\n  gl_FragColor = texture2D(u_texture, v_texCoord);\n}\n');
	
	var vertex$5 = new WebGLVertex('varying vec2 v_texCoord;\n\n\nattribute vec2 a_position;\nattribute vec2 a_texCoord;\nuniform vec4 u_tileOffset;\n\nvoid main(void) {\n  gl_Position = vec4(a_position * u_tileOffset.xy + u_tileOffset.zw, 0., 1.);\n  v_texCoord = a_texCoord;\n}\n\n\n');
	
	/**
	 * @module ol/renderer/webgl/tilelayershader/Locations
	 */
	
	var Locations$5 = function Locations(gl, program) {
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_tileOffset = gl.getUniformLocation(
	    program, 'u_tileOffset');
	
	  /**
	   * @type {WebGLUniformLocation}
	   */
	  this.u_texture = gl.getUniformLocation(
	    program, 'u_texture');
	
	  /**
	   * @type {number}
	   */
	  this.a_position = gl.getAttribLocation(
	    program, 'a_position');
	
	  /**
	   * @type {number}
	   */
	  this.a_texCoord = gl.getAttribLocation(
	    program, 'a_texCoord');
	
	};
	
	/**
	 * @module ol/renderer/webgl/TileLayer
	 */
	
	/**
	 * @classdesc
	 * WebGL renderer for tile layers.
	 * @api
	 */
	var WebGLTileLayerRenderer = /*@__PURE__*/(function (WebGLLayerRenderer$$1) {
	  function WebGLTileLayerRenderer(mapRenderer, tileLayer) {
	
	    WebGLLayerRenderer$$1.call(this, mapRenderer, tileLayer);
	
	    /**
	     * @private
	     * @type {import("../../webgl/Fragment.js").default}
	     */
	    this.fragmentShader_ = fragment$5;
	
	    /**
	     * @private
	     * @type {import("../../webgl/Vertex.js").default}
	     */
	    this.vertexShader_ = vertex$5;
	
	    /**
	     * @private
	     * @type {import("./tilelayershader/Locations.js").default}
	     */
	    this.locations_ = null;
	
	    /**
	     * @private
	     * @type {import("../../webgl/Buffer.js").default}
	     */
	    this.renderArrayBuffer_ = new WebGLBuffer([
	      0, 0, 0, 1,
	      1, 0, 1, 1,
	      0, 1, 0, 0,
	      1, 1, 1, 0
	    ]);
	
	    /**
	     * @private
	     * @type {import("../../TileRange.js").default}
	     */
	    this.renderedTileRange_ = null;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.renderedFramebufferExtent_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedRevision_ = -1;
	
	    /**
	     * @private
	     * @type {import("../../size.js").Size}
	     */
	    this.tmpSize_ = [0, 0];
	
	  }
	
	  if ( WebGLLayerRenderer$$1 ) { WebGLTileLayerRenderer.__proto__ = WebGLLayerRenderer$$1; }
	  WebGLTileLayerRenderer.prototype = Object.create( WebGLLayerRenderer$$1 && WebGLLayerRenderer$$1.prototype );
	  WebGLTileLayerRenderer.prototype.constructor = WebGLTileLayerRenderer;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTileLayerRenderer.prototype.disposeInternal = function disposeInternal () {
	    var context = this.mapRenderer.getContext();
	    context.deleteBuffer(this.renderArrayBuffer_);
	    WebGLLayerRenderer$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTileLayerRenderer.prototype.createLoadedTileFinder = function createLoadedTileFinder (source, projection, tiles) {
	    var mapRenderer = this.mapRenderer;
	
	    return (
	      /**
	       * @param {number} zoom Zoom level.
	       * @param {import("../../TileRange.js").default} tileRange Tile range.
	       * @return {boolean} The tile range is fully loaded.
	       */
	      function(zoom, tileRange) {
	        function callback(tile) {
	          var loaded = mapRenderer.isTileTextureLoaded(tile);
	          if (loaded) {
	            if (!tiles[zoom]) {
	              tiles[zoom] = {};
	            }
	            tiles[zoom][tile.tileCoord.toString()] = tile;
	          }
	          return loaded;
	        }
	        return source.forEachLoadedTile(projection, zoom, tileRange, callback);
	      }
	    );
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTileLayerRenderer.prototype.handleWebGLContextLost = function handleWebGLContextLost () {
	    WebGLLayerRenderer$$1.prototype.handleWebGLContextLost.call(this);
	    this.locations_ = null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTileLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState, context) {
	
	    var mapRenderer = this.mapRenderer;
	    var gl = context.getGL();
	
	    var viewState = frameState.viewState;
	    var projection = viewState.projection;
	
	    var tileLayer = /** @type {import("../../layer/Tile.js").default} */ (this.getLayer());
	    var tileSource = tileLayer.getSource();
	    if (!(tileSource instanceof TileSource)) {
	      return true;
	    }
	
	    var tileGrid = tileSource.getTileGridForProjection(projection);
	    var z = tileGrid.getZForResolution(viewState.resolution);
	    var tileResolution = tileGrid.getResolution(z);
	
	    var tilePixelSize =
	        tileSource.getTilePixelSize(z, frameState.pixelRatio, projection);
	    var pixelRatio = tilePixelSize[0] /
	        toSize(tileGrid.getTileSize(z), this.tmpSize_)[0];
	    var tilePixelResolution = tileResolution / pixelRatio;
	    var tileGutter = tileSource.getTilePixelRatio(pixelRatio) * tileSource.getGutterForProjection(projection);
	
	    var center = viewState.center;
	    var extent = frameState.extent;
	    var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
	
	    var framebufferExtent;
	    if (this.renderedTileRange_ &&
	        this.renderedTileRange_.equals(tileRange) &&
	        this.renderedRevision_ == tileSource.getRevision()) {
	      framebufferExtent = this.renderedFramebufferExtent_;
	    } else {
	
	      var tileRangeSize = tileRange.getSize();
	
	      var maxDimension = Math.max(
	        tileRangeSize[0] * tilePixelSize[0],
	        tileRangeSize[1] * tilePixelSize[1]);
	      var framebufferDimension = roundUpToPowerOfTwo(maxDimension);
	      var framebufferExtentDimension = tilePixelResolution * framebufferDimension;
	      var origin = tileGrid.getOrigin(z);
	      var minX = origin[0] +
	          tileRange.minX * tilePixelSize[0] * tilePixelResolution;
	      var minY = origin[1] +
	          tileRange.minY * tilePixelSize[1] * tilePixelResolution;
	      framebufferExtent = [
	        minX, minY,
	        minX + framebufferExtentDimension, minY + framebufferExtentDimension
	      ];
	
	      this.bindFramebuffer(frameState, framebufferDimension);
	      gl.viewport(0, 0, framebufferDimension, framebufferDimension);
	
	      gl.clearColor(0, 0, 0, 0);
	      gl.clear(COLOR_BUFFER_BIT);
	      gl.disable(BLEND);
	
	      var program = context.getProgram(this.fragmentShader_, this.vertexShader_);
	      context.useProgram(program);
	      if (!this.locations_) {
	        this.locations_ = new Locations$5(gl, program);
	      }
	
	      context.bindBuffer(ARRAY_BUFFER, this.renderArrayBuffer_);
	      gl.enableVertexAttribArray(this.locations_.a_position);
	      gl.vertexAttribPointer(
	        this.locations_.a_position, 2, FLOAT, false, 16, 0);
	      gl.enableVertexAttribArray(this.locations_.a_texCoord);
	      gl.vertexAttribPointer(
	        this.locations_.a_texCoord, 2, FLOAT, false, 16, 8);
	      gl.uniform1i(this.locations_.u_texture, 0);
	
	      /**
	       * @type {Object<number, Object<string, import("../../Tile.js").default>>}
	       */
	      var tilesToDrawByZ = {};
	      tilesToDrawByZ[z] = {};
	
	      var findLoadedTiles = this.createLoadedTileFinder(
	        tileSource, projection, tilesToDrawByZ);
	
	      var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
	      var allTilesLoaded = true;
	      var tmpExtent = createEmpty();
	      var tmpTileRange = new TileRange(0, 0, 0, 0);
	      var childTileRange, drawable, fullyLoaded, tile, tileState;
	      var x, y, tileExtent;
	      for (x = tileRange.minX; x <= tileRange.maxX; ++x) {
	        for (y = tileRange.minY; y <= tileRange.maxY; ++y) {
	
	          tile = tileSource.getTile(z, x, y, pixelRatio, projection);
	          if (layerState.extent !== undefined) {
	            // ignore tiles outside layer extent
	            tileExtent = tileGrid.getTileCoordExtent(tile.tileCoord, tmpExtent);
	            if (!intersects(tileExtent, layerState.extent)) {
	              continue;
	            }
	          }
	          tileState = tile.getState();
	          drawable = tileState == TileState.LOADED ||
	              tileState == TileState.EMPTY ||
	              tileState == TileState.ERROR && !useInterimTilesOnError;
	          if (!drawable) {
	            tile = tile.getInterimTile();
	          }
	          tileState = tile.getState();
	          if (tileState == TileState.LOADED) {
	            if (mapRenderer.isTileTextureLoaded(tile)) {
	              tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
	              continue;
	            }
	          } else if (tileState == TileState.EMPTY ||
	                     (tileState == TileState.ERROR &&
	                      !useInterimTilesOnError)) {
	            continue;
	          }
	
	          allTilesLoaded = false;
	          fullyLoaded = tileGrid.forEachTileCoordParentTileRange(
	            tile.tileCoord, findLoadedTiles, null, tmpTileRange, tmpExtent);
	          if (!fullyLoaded) {
	            childTileRange = tileGrid.getTileCoordChildTileRange(
	              tile.tileCoord, tmpTileRange, tmpExtent);
	            if (childTileRange) {
	              findLoadedTiles(z + 1, childTileRange);
	            }
	          }
	
	        }
	
	      }
	
	      /** @type {Array<number>} */
	      var zs = Object.keys(tilesToDrawByZ).map(Number);
	      zs.sort(numberSafeCompareFunction);
	      var u_tileOffset = new Float32Array(4);
	      for (var i = 0, ii = zs.length; i < ii; ++i) {
	        var tilesToDraw = tilesToDrawByZ[zs[i]];
	        for (var tileKey in tilesToDraw) {
	          tile = tilesToDraw[tileKey];
	
	          if (!(tile instanceof ImageTile)) {
	            continue;
	          }
	
	          tileExtent = tileGrid.getTileCoordExtent(tile.tileCoord, tmpExtent);
	          u_tileOffset[0] = 2 * (tileExtent[2] - tileExtent[0]) /
	              framebufferExtentDimension;
	          u_tileOffset[1] = 2 * (tileExtent[3] - tileExtent[1]) /
	              framebufferExtentDimension;
	          u_tileOffset[2] = 2 * (tileExtent[0] - framebufferExtent[0]) /
	              framebufferExtentDimension - 1;
	          u_tileOffset[3] = 2 * (tileExtent[1] - framebufferExtent[1]) /
	              framebufferExtentDimension - 1;
	          gl.uniform4fv(this.locations_.u_tileOffset, u_tileOffset);
	          mapRenderer.bindTileTexture(tile, tilePixelSize,
	            tileGutter * pixelRatio, LINEAR, LINEAR);
	          gl.drawArrays(TRIANGLE_STRIP, 0, 4);
	        }
	      }
	
	      if (allTilesLoaded) {
	        this.renderedTileRange_ = tileRange;
	        this.renderedFramebufferExtent_ = framebufferExtent;
	        this.renderedRevision_ = tileSource.getRevision();
	      } else {
	        this.renderedTileRange_ = null;
	        this.renderedFramebufferExtent_ = null;
	        this.renderedRevision_ = -1;
	        frameState.animate = true;
	      }
	
	    }
	
	    this.updateUsedTiles(frameState.usedTiles, tileSource, z, tileRange);
	    var tileTextureQueue = mapRenderer.getTileTextureQueue();
	    this.manageTilePyramid(
	      frameState, tileSource, tileGrid, pixelRatio, projection, extent, z,
	      tileLayer.getPreload(),
	      /**
	       * @param {import("../../Tile.js").default} tile Tile.
	       */
	      function(tile) {
	        if (tile.getState() == TileState.LOADED &&
	              !mapRenderer.isTileTextureLoaded(tile) &&
	              !tileTextureQueue.isKeyQueued(tile.getKey())) {
	          tileTextureQueue.enqueue([
	            tile,
	            tileGrid.getTileCoordCenter(tile.tileCoord),
	            tileGrid.getResolution(tile.tileCoord[0]),
	            tilePixelSize, tileGutter * pixelRatio
	          ]);
	        }
	      }, this);
	    this.scheduleExpireCache(frameState, tileSource);
	
	    var texCoordMatrix = this.texCoordMatrix;
	    reset(texCoordMatrix);
	    translate$1(texCoordMatrix,
	      (Math.round(center[0] / tileResolution) * tileResolution - framebufferExtent[0]) /
	            (framebufferExtent[2] - framebufferExtent[0]),
	      (Math.round(center[1] / tileResolution) * tileResolution - framebufferExtent[1]) /
	            (framebufferExtent[3] - framebufferExtent[1]));
	    if (viewState.rotation !== 0) {
	      rotate$1(texCoordMatrix, viewState.rotation);
	    }
	    scale$1(texCoordMatrix,
	      frameState.size[0] * viewState.resolution /
	            (framebufferExtent[2] - framebufferExtent[0]),
	      frameState.size[1] * viewState.resolution /
	            (framebufferExtent[3] - framebufferExtent[1]));
	    translate$1(texCoordMatrix, -0.5, -0.5);
	
	    return true;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLTileLayerRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, callback, thisArg) {
	    if (!this.framebuffer) {
	      return undefined;
	    }
	
	    var pixelOnMapScaled = [
	      pixel[0] / frameState.size[0],
	      (frameState.size[1] - pixel[1]) / frameState.size[1]];
	
	    var pixelOnFrameBufferScaled = apply(
	      this.texCoordMatrix, pixelOnMapScaled.slice());
	    var pixelOnFrameBuffer = [
	      pixelOnFrameBufferScaled[0] * this.framebufferDimension,
	      pixelOnFrameBufferScaled[1] * this.framebufferDimension];
	
	    var gl = this.mapRenderer.getContext().getGL();
	    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
	    var imageData = new Uint8Array(4);
	    gl.readPixels(pixelOnFrameBuffer[0], pixelOnFrameBuffer[1], 1, 1,
	      gl.RGBA, gl.UNSIGNED_BYTE, imageData);
	
	    if (imageData[3] > 0) {
	      return callback.call(thisArg, this.getLayer(), imageData);
	    } else {
	      return undefined;
	    }
	  };
	
	  return WebGLTileLayerRenderer;
	}(WebGLLayerRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	WebGLTileLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.TILE;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {WebGLTileLayerRenderer} The layer renderer.
	 */
	WebGLTileLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new WebGLTileLayerRenderer(
	    /** @type {import("./Map.js").default} */ (mapRenderer),
	    /** @type {import("../../layer/Tile.js").default} */ (layer)
	  );
	};
	
	/**
	 * @module ol/renderer/webgl/VectorLayer
	 */
	
	
	/**
	 * @classdesc
	 * WebGL renderer for vector layers.
	 * @api
	 */
	var WebGLVectorLayerRenderer = /*@__PURE__*/(function (WebGLLayerRenderer$$1) {
	  function WebGLVectorLayerRenderer(mapRenderer, vectorLayer) {
	
	    WebGLLayerRenderer$$1.call(this, mapRenderer, vectorLayer);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.dirty_ = false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedRevision_ = -1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedResolution_ = NaN;
	
	    /**
	     * @private
	     * @type {import("../../extent.js").Extent}
	     */
	    this.renderedExtent_ = createEmpty();
	
	    /**
	     * @private
	     * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
	     */
	    this.renderedRenderOrder_ = null;
	
	    /**
	     * @private
	     * @type {import("../../render/webgl/ReplayGroup.js").default}
	     */
	    this.replayGroup_ = null;
	
	    /**
	     * The last layer state.
	     * @private
	     * @type {?import("../../layer/Layer.js").State}
	     */
	    this.layerState_ = null;
	
	  }
	
	  if ( WebGLLayerRenderer$$1 ) { WebGLVectorLayerRenderer.__proto__ = WebGLLayerRenderer$$1; }
	  WebGLVectorLayerRenderer.prototype = Object.create( WebGLLayerRenderer$$1 && WebGLLayerRenderer$$1.prototype );
	  WebGLVectorLayerRenderer.prototype.constructor = WebGLVectorLayerRenderer;
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVectorLayerRenderer.prototype.composeFrame = function composeFrame (frameState, layerState, context) {
	    this.layerState_ = layerState;
	    var viewState = frameState.viewState;
	    var replayGroup = this.replayGroup_;
	    var size = frameState.size;
	    var pixelRatio = frameState.pixelRatio;
	    var gl = this.mapRenderer.getGL();
	    if (replayGroup && !replayGroup.isEmpty()) {
	      gl.enable(gl.SCISSOR_TEST);
	      gl.scissor(0, 0, size[0] * pixelRatio, size[1] * pixelRatio);
	      replayGroup.replay(context,
	        viewState.center, viewState.resolution, viewState.rotation,
	        size, pixelRatio, layerState.opacity,
	        layerState.managed ? frameState.skippedFeatureUids : {});
	      gl.disable(gl.SCISSOR_TEST);
	    }
	
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVectorLayerRenderer.prototype.disposeInternal = function disposeInternal () {
	    var replayGroup = this.replayGroup_;
	    if (replayGroup) {
	      var context = this.mapRenderer.getContext();
	      replayGroup.getDeleteResourcesFunction(context)();
	      this.replayGroup_ = null;
	    }
	    WebGLLayerRenderer$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
	    if (!this.replayGroup_ || !this.layerState_) {
	      return undefined;
	    } else {
	      var context = this.mapRenderer.getContext();
	      var viewState = frameState.viewState;
	      var layer = this.getLayer();
	      var layerState = this.layerState_;
	      /** @type {!Object<string, boolean>} */
	      var features = {};
	      return this.replayGroup_.forEachFeatureAtCoordinate(coordinate,
	        context, viewState.center, viewState.resolution, viewState.rotation,
	        frameState.size, frameState.pixelRatio, layerState.opacity,
	        {},
	        /**
	         * @param {import("../../Feature.js").FeatureLike} feature Feature.
	         * @return {?} Callback result.
	         */
	        function(feature) {
	          var key = getUid(feature);
	          if (!(key in features)) {
	            features[key] = true;
	            return callback.call(thisArg, feature, layer);
	          }
	        });
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVectorLayerRenderer.prototype.hasFeatureAtCoordinate = function hasFeatureAtCoordinate (coordinate, frameState) {
	    if (!this.replayGroup_ || !this.layerState_) {
	      return false;
	    } else {
	      var context = this.mapRenderer.getContext();
	      var viewState = frameState.viewState;
	      var layerState = this.layerState_;
	      return this.replayGroup_.hasFeatureAtCoordinate(coordinate,
	        context, viewState.center, viewState.resolution, viewState.rotation,
	        frameState.size, frameState.pixelRatio, layerState.opacity,
	        frameState.skippedFeatureUids);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVectorLayerRenderer.prototype.forEachLayerAtPixel = function forEachLayerAtPixel (pixel, frameState, callback, thisArg) {
	    var coordinate = apply(
	      frameState.pixelToCoordinateTransform, pixel.slice());
	    var hasFeature = this.hasFeatureAtCoordinate(coordinate, frameState);
	
	    if (hasFeature) {
	      return callback.call(thisArg, this.getLayer(), null);
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * Handle changes in image style state.
	   * @param {import("../../events/Event.js").default} event Image style change event.
	   * @private
	   */
	  WebGLVectorLayerRenderer.prototype.handleStyleImageChange_ = function handleStyleImageChange_ (event) {
	    this.renderIfReadyAndVisible();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WebGLVectorLayerRenderer.prototype.prepareFrame = function prepareFrame (frameState, layerState, context) {
	    var vectorLayer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	    var vectorSource = /** @type {import("../../source/Vector.js").default} */ (vectorLayer.getSource());
	
	    var animating = frameState.viewHints[ViewHint.ANIMATING];
	    var interacting = frameState.viewHints[ViewHint.INTERACTING];
	    var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
	    var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
	
	    if (!this.dirty_ && (!updateWhileAnimating && animating) ||
	        (!updateWhileInteracting && interacting)) {
	      return true;
	    }
	
	    var frameStateExtent = frameState.extent;
	    var viewState = frameState.viewState;
	    var projection = viewState.projection;
	    var resolution = viewState.resolution;
	    var pixelRatio = frameState.pixelRatio;
	    var vectorLayerRevision = vectorLayer.getRevision();
	    var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
	    var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
	
	    if (vectorLayerRenderOrder === undefined) {
	      vectorLayerRenderOrder = defaultOrder;
	    }
	
	    var extent = buffer(frameStateExtent,
	      vectorLayerRenderBuffer * resolution);
	
	    if (!this.dirty_ &&
	        this.renderedResolution_ == resolution &&
	        this.renderedRevision_ == vectorLayerRevision &&
	        this.renderedRenderOrder_ == vectorLayerRenderOrder &&
	        containsExtent(this.renderedExtent_, extent)) {
	      return true;
	    }
	
	    if (this.replayGroup_) {
	      frameState.postRenderFunctions.push(
	        this.replayGroup_.getDeleteResourcesFunction(context));
	    }
	
	    this.dirty_ = false;
	
	    var replayGroup = new WebGLReplayGroup(
	      getTolerance(resolution, pixelRatio),
	      extent, vectorLayer.getRenderBuffer());
	    vectorSource.loadFeatures(extent, resolution, projection);
	    /**
	     * @param {import("../../Feature.js").default} feature Feature.
	     * @this {WebGLVectorLayerRenderer}
	     */
	    var render = function(feature) {
	      var styles;
	      var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
	      if (styleFunction) {
	        styles = styleFunction(feature, resolution);
	      }
	      if (styles) {
	        var dirty = this.renderFeature(
	          feature, resolution, pixelRatio, styles, replayGroup);
	        this.dirty_ = this.dirty_ || dirty;
	      }
	    }.bind(this);
	    if (vectorLayerRenderOrder) {
	      /** @type {Array<import("../../Feature.js").default>} */
	      var features = [];
	      vectorSource.forEachFeatureInExtent(extent,
	        /**
	         * @param {import("../../Feature.js").default} feature Feature.
	         */
	        function(feature) {
	          features.push(feature);
	        });
	      features.sort(vectorLayerRenderOrder);
	      features.forEach(render.bind(this));
	    } else {
	      vectorSource.forEachFeatureInExtent(extent, render);
	    }
	    replayGroup.finish(context);
	
	    this.renderedResolution_ = resolution;
	    this.renderedRevision_ = vectorLayerRevision;
	    this.renderedRenderOrder_ = vectorLayerRenderOrder;
	    this.renderedExtent_ = extent;
	    this.replayGroup_ = replayGroup;
	
	    return true;
	  };
	
	  /**
	   * @param {import("../../Feature.js").default} feature Feature.
	   * @param {number} resolution Resolution.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of
	   *     styles.
	   * @param {import("../../render/webgl/ReplayGroup.js").default} replayGroup Replay group.
	   * @return {boolean} `true` if an image is loading.
	   */
	  WebGLVectorLayerRenderer.prototype.renderFeature = function renderFeature$1 (feature, resolution, pixelRatio, styles, replayGroup) {
	    if (!styles) {
	      return false;
	    }
	    var loading = false;
	    if (Array.isArray(styles)) {
	      for (var i = styles.length - 1, ii = 0; i >= ii; --i) {
	        loading = renderFeature(
	          replayGroup, feature, styles[i],
	          getSquaredTolerance(resolution, pixelRatio),
	          this.handleStyleImageChange_, this) || loading;
	      }
	    } else {
	      loading = renderFeature(
	        replayGroup, feature, styles,
	        getSquaredTolerance(resolution, pixelRatio),
	        this.handleStyleImageChange_, this) || loading;
	    }
	    return loading;
	  };
	
	  return WebGLVectorLayerRenderer;
	}(WebGLLayerRenderer));
	
	
	/**
	 * Determine if this renderer handles the provided layer.
	 * @param {import("../../layer/Layer.js").default} layer The candidate layer.
	 * @return {boolean} The renderer can render the layer.
	 */
	WebGLVectorLayerRenderer['handles'] = function(layer) {
	  return layer.getType() === LayerType.VECTOR;
	};
	
	
	/**
	 * Create a layer renderer.
	 * @param {import("../Map.js").default} mapRenderer The map renderer.
	 * @param {import("../../layer/Layer.js").default} layer The layer to be rendererd.
	 * @return {WebGLVectorLayerRenderer} The layer renderer.
	 */
	WebGLVectorLayerRenderer['create'] = function(mapRenderer, layer) {
	  return new WebGLVectorLayerRenderer(
	    /** @type {import("./Map.js").default} */ (mapRenderer),
	    /** @type {import("../../layer/Vector.js").default} */ (layer)
	  );
	};
	
	/**
	 * @module ol/WebGLMap
	 */
	
	
	/**
	 * @classdesc
	 * The WebGLMap uses WebGL for rendering map layers.  This renderer has limited
	 * support for vector data and no support for vector tiles.
	 *
	 *     import WebGLMap from 'ol/WebGLMap';
	 *     import TileLayer from 'ol/layer/Tile';
	 *     import OSM from 'ol/source/OSM';
	 *     import View from 'ol/View';
	 *
	 *     var map = new WebGLMap({
	 *       view: new View({
	 *         center: [0, 0],
	 *         zoom: 1
	 *       }),
	 *       layers: [
	 *         new TileLayer({
	 *           source: new OSM()
	 *         })
	 *       ],
	 *       target: 'map'
	 *     });
	 *
	 * The above snippet creates a map using a {@link module:ol/layer/Tile~Tile} to
	 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
	 * element with the id `map`.
	 *
	 * The constructor places a viewport container (with CSS class name
	 * `ol-viewport`) in the target element (see `getViewport()`), and then two
	 * further elements within the viewport: one with CSS class name
	 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
	 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
	 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
	 * itself is placed in a further element within the viewport.
	 *
	 * Layers are stored as a {@link module:ol/Collection~Collection} in
	 * layerGroups. A top-level group is provided by the library. This is what is
	 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
	 * options are added to this group, and `addLayer` and `removeLayer` change the
	 * layer collection in the group. `getLayers` is a convenience function for
	 * `getLayerGroup().getLayers()`.
	 * Note that {@link module:ol/layer/Group~Group} is a subclass of
	 * {@link module:ol/layer/Base}, so layers entered in the options or added
	 * with `addLayer` can be groups, which can contain further groups, and so on.
	 *
	 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
	 * @fires import("./MapEvent.js").MapEvent
	 * @fires module:ol/render/Event~RenderEvent#postcompose
	 * @fires module:ol/render/Event~RenderEvent#precompose
	 * @api
	 */
	var WebGLMap = /*@__PURE__*/(function (PluggableMap$$1) {
	  function WebGLMap(options) {
	    options = assign({}, options);
	    if (!options.controls) {
	      options.controls = defaults();
	    }
	    if (!options.interactions) {
	      options.interactions = defaults$1();
	    }
	
	    PluggableMap$$1.call(this, options);
	  }
	
	  if ( PluggableMap$$1 ) { WebGLMap.__proto__ = PluggableMap$$1; }
	  WebGLMap.prototype = Object.create( PluggableMap$$1 && PluggableMap$$1.prototype );
	  WebGLMap.prototype.constructor = WebGLMap;
	
	  WebGLMap.prototype.createRenderer = function createRenderer () {
	    var renderer = new WebGLMapRenderer(this);
	    renderer.registerLayerRenderers([
	      WebGLImageLayerRenderer,
	      WebGLTileLayerRenderer,
	      WebGLVectorLayerRenderer
	    ]);
	    return renderer;
	  };
	
	  return WebGLMap;
	}(PluggableMap));
	
	/**
	 * @module ol/geom
	 */
	
	/**
	 * @api
	 */
	var GeometryType$1 = GeometryType;
	
	/**
	 * @module ol/Image
	 */
	
	
	/**
	 * A function that takes an {@link module:ol/Image~Image} for the image and a
	 * `{string}` for the src as arguments. It is supposed to make it so the
	 * underlying image {@link module:ol/Image~Image#getImage} is assigned the
	 * content specified by the src. If not specified, the default is
	 *
	 *     function(image, src) {
	 *       image.getImage().src = src;
	 *     }
	 *
	 * Providing a custom `imageLoadFunction` can be useful to load images with
	 * post requests or - in general - through XHR requests, where the src of the
	 * image element would be set to a data URI when the content is loaded.
	 *
	 * @typedef {function(ImageWrapper, string)} LoadFunction
	 * @api
	 */
	
	
	var ImageWrapper = /*@__PURE__*/(function (ImageBase$$1) {
	  function ImageWrapper(extent, resolution, pixelRatio, src, crossOrigin, imageLoadFunction) {
	
	    ImageBase$$1.call(this, extent, resolution, pixelRatio, ImageState.IDLE);
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.src_ = src;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
	     */
	    this.image_ = new Image();
	    if (crossOrigin !== null) {
	      this.image_.crossOrigin = crossOrigin;
	    }
	
	    /**
	     * @private
	     * @type {Array<import("./events.js").EventsKey>}
	     */
	    this.imageListenerKeys_ = null;
	
	    /**
	     * @protected
	     * @type {ImageState}
	     */
	    this.state = ImageState.IDLE;
	
	    /**
	     * @private
	     * @type {LoadFunction}
	     */
	    this.imageLoadFunction_ = imageLoadFunction;
	
	  }
	
	  if ( ImageBase$$1 ) { ImageWrapper.__proto__ = ImageBase$$1; }
	  ImageWrapper.prototype = Object.create( ImageBase$$1 && ImageBase$$1.prototype );
	  ImageWrapper.prototype.constructor = ImageWrapper;
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  ImageWrapper.prototype.getImage = function getImage () {
	    return this.image_;
	  };
	
	  /**
	   * Tracks loading or read errors.
	   *
	   * @private
	   */
	  ImageWrapper.prototype.handleImageError_ = function handleImageError_ () {
	    this.state = ImageState.ERROR;
	    this.unlistenImage_();
	    this.changed();
	  };
	
	  /**
	   * Tracks successful image load.
	   *
	   * @private
	   */
	  ImageWrapper.prototype.handleImageLoad_ = function handleImageLoad_ () {
	    if (this.resolution === undefined) {
	      this.resolution = getHeight(this.extent) / this.image_.height;
	    }
	    this.state = ImageState.LOADED;
	    this.unlistenImage_();
	    this.changed();
	  };
	
	  /**
	   * Load the image or retry if loading previously failed.
	   * Loading is taken care of by the tile queue, and calling this method is
	   * only needed for preloading or for reloading in case of an error.
	   * @override
	   * @api
	   */
	  ImageWrapper.prototype.load = function load () {
	    if (this.state == ImageState.IDLE || this.state == ImageState.ERROR) {
	      this.state = ImageState.LOADING;
	      this.changed();
	      this.imageListenerKeys_ = [
	        listenOnce(this.image_, EventType.ERROR,
	          this.handleImageError_, this),
	        listenOnce(this.image_, EventType.LOAD,
	          this.handleImageLoad_, this)
	      ];
	      this.imageLoadFunction_(this, this.src_);
	    }
	  };
	
	  /**
	   * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
	   */
	  ImageWrapper.prototype.setImage = function setImage (image) {
	    this.image_ = image;
	  };
	
	  /**
	   * Discards event handlers which listen for load completion or errors.
	   *
	   * @private
	   */
	  ImageWrapper.prototype.unlistenImage_ = function unlistenImage_ () {
	    this.imageListenerKeys_.forEach(unlistenByKey);
	    this.imageListenerKeys_ = null;
	  };
	
	  return ImageWrapper;
	}(ImageBase));
	
	/**
	 * @module ol/VectorImageTile
	 */
	
	
	/**
	 * @typedef {Object} ReplayState
	 * @property {boolean} dirty
	 * @property {null|import("./render.js").OrderFunction} renderedRenderOrder
	 * @property {number} renderedTileRevision
	 * @property {number} renderedRevision
	 */
	
	
	var VectorImageTile = /*@__PURE__*/(function (Tile$$1) {
	  function VectorImageTile(tileCoord, state, sourceRevision, format, tileLoadFunction,
	    urlTileCoord, tileUrlFunction, sourceTileGrid, tileGrid, sourceTiles,
	    pixelRatio, projection, tileClass, handleTileChange, zoom) {
	
	    Tile$$1.call(this, tileCoord, state, {transition: 0});
	
	    /**
	     * @private
	     * @type {!Object<string, CanvasRenderingContext2D>}
	     */
	    this.context_ = {};
	
	    /**
	     * @private
	     * @type {import("./featureloader.js").FeatureLoader}
	     */
	    this.loader_;
	
	    /**
	     * @private
	     * @type {!Object<string, ReplayState>}
	     */
	    this.replayState_ = {};
	
	    /**
	     * @private
	     * @type {Object<string, import("./VectorTile.js").default>}
	     */
	    this.sourceTiles_ = sourceTiles;
	
	    /**
	     * Keys of source tiles used by this tile. Use with {@link #getTile}.
	     * @type {Array<string>}
	     */
	    this.tileKeys = [];
	
	    /**
	     * @type {import("./extent.js").Extent}
	     */
	    this.extent = null;
	
	    /**
	     * @type {number}
	     */
	    this.sourceRevision_ = sourceRevision;
	
	    /**
	     * @type {import("./tilecoord.js").TileCoord}
	     */
	    this.wrappedTileCoord = urlTileCoord;
	
	    /**
	     * @type {Array<import("./events.js").EventsKey>}
	     */
	    this.loadListenerKeys_ = [];
	
	    /**
	     * @type {Array<import("./events.js").EventsKey>}
	     */
	    this.sourceTileListenerKeys_ = [];
	
	    if (urlTileCoord) {
	      var extent = this.extent = tileGrid.getTileCoordExtent(urlTileCoord);
	      var resolution = tileGrid.getResolution(zoom);
	      var sourceZ = sourceTileGrid.getZForResolution(resolution);
	      var useLoadedOnly = zoom != tileCoord[0];
	      var loadCount = 0;
	      sourceTileGrid.forEachTileCoord(extent, sourceZ, function(sourceTileCoord) {
	        var sharedExtent = getIntersection(extent,
	          sourceTileGrid.getTileCoordExtent(sourceTileCoord));
	        var sourceExtent = sourceTileGrid.getExtent();
	        if (sourceExtent) {
	          sharedExtent = getIntersection(sharedExtent, sourceExtent, sharedExtent);
	        }
	        if (getWidth(sharedExtent) / resolution >= 0.5 &&
	            getHeight(sharedExtent) / resolution >= 0.5) {
	          // only include source tile if overlap is at least 1 pixel
	          ++loadCount;
	          var sourceTileKey = sourceTileCoord.toString();
	          var sourceTile = sourceTiles[sourceTileKey];
	          if (!sourceTile && !useLoadedOnly) {
	            var tileUrl = tileUrlFunction(sourceTileCoord, pixelRatio, projection);
	            sourceTile = sourceTiles[sourceTileKey] = new tileClass(sourceTileCoord,
	              tileUrl == undefined ? TileState.EMPTY : TileState.IDLE,
	              tileUrl == undefined ? '' : tileUrl,
	              format, tileLoadFunction);
	            this.sourceTileListenerKeys_.push(
	              listen(sourceTile, EventType.CHANGE, handleTileChange));
	          }
	          if (sourceTile && (!useLoadedOnly || sourceTile.getState() == TileState.LOADED)) {
	            sourceTile.consumers++;
	            this.tileKeys.push(sourceTileKey);
	          }
	        }
	      }.bind(this));
	
	      if (useLoadedOnly && loadCount == this.tileKeys.length) {
	        this.finishLoading_();
	      }
	
	      if (zoom <= tileCoord[0] && this.state != TileState.LOADED) {
	        while (zoom > tileGrid.getMinZoom()) {
	          var tile = new VectorImageTile(tileCoord, state, sourceRevision,
	            format, tileLoadFunction, urlTileCoord, tileUrlFunction,
	            sourceTileGrid, tileGrid, sourceTiles, pixelRatio, projection,
	            tileClass, VOID, --zoom);
	          if (tile.state == TileState.LOADED) {
	            this.interimTile = tile;
	            break;
	          }
	        }
	      }
	    }
	
	  }
	
	  if ( Tile$$1 ) { VectorImageTile.__proto__ = Tile$$1; }
	  VectorImageTile.prototype = Object.create( Tile$$1 && Tile$$1.prototype );
	  VectorImageTile.prototype.constructor = VectorImageTile;
	
	  /**
	   * @inheritDoc
	   */
	  VectorImageTile.prototype.disposeInternal = function disposeInternal () {
	    this.state = TileState.ABORT;
	    this.changed();
	    if (this.interimTile) {
	      this.interimTile.dispose();
	    }
	
	    for (var i = 0, ii = this.tileKeys.length; i < ii; ++i) {
	      var sourceTileKey = this.tileKeys[i];
	      var sourceTile = this.getTile(sourceTileKey);
	      sourceTile.consumers--;
	      if (sourceTile.consumers == 0) {
	        delete this.sourceTiles_[sourceTileKey];
	        sourceTile.dispose();
	      }
	    }
	    this.tileKeys.length = 0;
	    this.sourceTiles_ = null;
	    this.loadListenerKeys_.forEach(unlistenByKey);
	    this.loadListenerKeys_.length = 0;
	    this.sourceTileListenerKeys_.forEach(unlistenByKey);
	    this.sourceTileListenerKeys_.length = 0;
	    Tile$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @param {import("./layer/Layer.js").default} layer Layer.
	   * @return {CanvasRenderingContext2D} The rendering context.
	   */
	  VectorImageTile.prototype.getContext = function getContext (layer) {
	    var key = getUid(layer);
	    if (!(key in this.context_)) {
	      this.context_[key] = createCanvasContext2D();
	    }
	    return this.context_[key];
	  };
	
	  /**
	   * Get the Canvas for this tile.
	   * @param {import("./layer/Layer.js").default} layer Layer.
	   * @return {HTMLCanvasElement} Canvas.
	   */
	  VectorImageTile.prototype.getImage = function getImage (layer) {
	    return this.getReplayState(layer).renderedTileRevision == -1 ?
	      null : this.getContext(layer).canvas;
	  };
	
	  /**
	   * @param {import("./layer/Layer.js").default} layer Layer.
	   * @return {ReplayState} The replay state.
	   */
	  VectorImageTile.prototype.getReplayState = function getReplayState (layer) {
	    var key = getUid(layer);
	    if (!(key in this.replayState_)) {
	      this.replayState_[key] = {
	        dirty: false,
	        renderedRenderOrder: null,
	        renderedRevision: -1,
	        renderedTileRevision: -1
	      };
	    }
	    return this.replayState_[key];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  VectorImageTile.prototype.getKey = function getKey () {
	    return this.tileKeys.join('/') + '-' + this.sourceRevision_;
	  };
	
	  /**
	   * @param {string} tileKey Key (tileCoord) of the source tile.
	   * @return {import("./VectorTile.js").default} Source tile.
	   */
	  VectorImageTile.prototype.getTile = function getTile (tileKey) {
	    return this.sourceTiles_[tileKey];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  VectorImageTile.prototype.load = function load () {
	    // Source tiles with LOADED state - we just count them because once they are
	    // loaded, we're no longer listening to state changes.
	    var leftToLoad = 0;
	    // Source tiles with ERROR state - we track them because they can still have
	    // an ERROR state after another load attempt.
	    var errorSourceTiles = {};
	
	    if (this.state == TileState.IDLE) {
	      this.setState(TileState.LOADING);
	    }
	    if (this.state == TileState.LOADING) {
	      this.tileKeys.forEach(function(sourceTileKey) {
	        var sourceTile = this.getTile(sourceTileKey);
	        if (sourceTile.state == TileState.IDLE) {
	          sourceTile.setLoader(this.loader_);
	          sourceTile.load();
	        }
	        if (sourceTile.state == TileState.LOADING) {
	          var key = listen(sourceTile, EventType.CHANGE, function(e) {
	            var state = sourceTile.getState();
	            if (state == TileState.LOADED ||
	                state == TileState.ERROR) {
	              var uid = getUid(sourceTile);
	              if (state == TileState.ERROR) {
	                errorSourceTiles[uid] = true;
	              } else {
	                --leftToLoad;
	                delete errorSourceTiles[uid];
	              }
	              if (leftToLoad - Object.keys(errorSourceTiles).length == 0) {
	                this.finishLoading_();
	              }
	            }
	          }.bind(this));
	          this.loadListenerKeys_.push(key);
	          ++leftToLoad;
	        }
	      }.bind(this));
	    }
	    if (leftToLoad - Object.keys(errorSourceTiles).length == 0) {
	      setTimeout(this.finishLoading_.bind(this), 0);
	    }
	  };
	
	  /**
	   * @private
	   */
	  VectorImageTile.prototype.finishLoading_ = function finishLoading_ () {
	    var loaded = this.tileKeys.length;
	    var empty = 0;
	    for (var i = loaded - 1; i >= 0; --i) {
	      var state = this.getTile(this.tileKeys[i]).getState();
	      if (state != TileState.LOADED) {
	        --loaded;
	      }
	      if (state == TileState.EMPTY) {
	        ++empty;
	      }
	    }
	    if (loaded == this.tileKeys.length) {
	      this.loadListenerKeys_.forEach(unlistenByKey);
	      this.loadListenerKeys_.length = 0;
	      this.setState(TileState.LOADED);
	    } else {
	      this.setState(empty == this.tileKeys.length ? TileState.EMPTY : TileState.ERROR);
	    }
	  };
	
	  return VectorImageTile;
	}(Tile));
	
	/**
	 * Sets the loader for a tile.
	 * @param {import("./VectorTile.js").default} tile Vector tile.
	 * @param {string} url URL.
	 */
	function defaultLoadFunction(tile, url) {
	  var loader = loadFeaturesXhr(url, tile.getFormat(), tile.onLoad.bind(tile), tile.onError.bind(tile));
	  tile.setLoader(loader);
	}
	
	/**
	 * @module ol/VectorTile
	 */
	
	/**
	 * @const
	 * @type {import("./extent.js").Extent}
	 */
	var DEFAULT_EXTENT = [0, 0, 4096, 4096];
	
	
	var VectorTile = /*@__PURE__*/(function (Tile$$1) {
	  function VectorTile(tileCoord, state, src, format, tileLoadFunction, opt_options) {
	
	    Tile$$1.call(this, tileCoord, state, opt_options);
	
	    /**
	     * @type {number}
	     */
	    this.consumers = 0;
	
	    /**
	     * @private
	     * @type {import("./extent.js").Extent}
	     */
	    this.extent_ = null;
	
	    /**
	     * @private
	     * @type {import("./format/Feature.js").default}
	     */
	    this.format_ = format;
	
	    /**
	     * @private
	     * @type {Array<import("./Feature.js").default>}
	     */
	    this.features_ = null;
	
	    /**
	     * @private
	     * @type {import("./featureloader.js").FeatureLoader}
	     */
	    this.loader_;
	
	    /**
	     * Data projection
	     * @private
	     * @type {import("./proj/Projection.js").default}
	     */
	    this.projection_ = null;
	
	    /**
	     * @private
	     * @type {Object<string, import("./render/ReplayGroup.js").default>}
	     */
	    this.replayGroups_ = {};
	
	    /**
	     * @private
	     * @type {import("./Tile.js").LoadFunction}
	     */
	    this.tileLoadFunction_ = tileLoadFunction;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.url_ = src;
	
	  }
	
	  if ( Tile$$1 ) { VectorTile.__proto__ = Tile$$1; }
	  VectorTile.prototype = Object.create( Tile$$1 && Tile$$1.prototype );
	  VectorTile.prototype.constructor = VectorTile;
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile.prototype.disposeInternal = function disposeInternal () {
	    this.features_ = null;
	    this.replayGroups_ = {};
	    this.state = TileState.ABORT;
	    this.changed();
	    Tile$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * Gets the extent of the vector tile.
	   * @return {import("./extent.js").Extent} The extent.
	   * @api
	   */
	  VectorTile.prototype.getExtent = function getExtent () {
	    return this.extent_ || DEFAULT_EXTENT;
	  };
	
	  /**
	   * Get the feature format assigned for reading this tile's features.
	   * @return {import("./format/Feature.js").default} Feature format.
	   * @api
	   */
	  VectorTile.prototype.getFormat = function getFormat () {
	    return this.format_;
	  };
	
	  /**
	   * Get the features for this tile. Geometries will be in the projection returned
	   * by {@link module:ol/VectorTile~VectorTile#getProjection}.
	   * @return {Array<import("./Feature.js").FeatureLike>} Features.
	   * @api
	   */
	  VectorTile.prototype.getFeatures = function getFeatures () {
	    return this.features_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile.prototype.getKey = function getKey () {
	    return this.url_;
	  };
	
	  /**
	   * Get the feature projection of features returned by
	   * {@link module:ol/VectorTile~VectorTile#getFeatures}.
	   * @return {import("./proj/Projection.js").default} Feature projection.
	   * @api
	   */
	  VectorTile.prototype.getProjection = function getProjection () {
	    return this.projection_;
	  };
	
	  /**
	   * @param {import("./layer/Layer.js").default} layer Layer.
	   * @param {string} key Key.
	   * @return {import("./render/ReplayGroup.js").default} Replay group.
	   */
	  VectorTile.prototype.getReplayGroup = function getReplayGroup (layer, key) {
	    return this.replayGroups_[getUid(layer) + ',' + key];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile.prototype.load = function load () {
	    if (this.state == TileState.IDLE) {
	      this.setState(TileState.LOADING);
	      this.tileLoadFunction_(this, this.url_);
	      this.loader_(null, NaN, null);
	    }
	  };
	
	  /**
	   * Handler for successful tile load.
	   * @param {Array<import("./Feature.js").default>} features The loaded features.
	   * @param {import("./proj/Projection.js").default} dataProjection Data projection.
	   * @param {import("./extent.js").Extent} extent Extent.
	   */
	  VectorTile.prototype.onLoad = function onLoad (features, dataProjection, extent) {
	    this.setProjection(dataProjection);
	    this.setFeatures(features);
	    this.setExtent(extent);
	  };
	
	  /**
	   * Handler for tile load errors.
	   */
	  VectorTile.prototype.onError = function onError () {
	    this.setState(TileState.ERROR);
	  };
	
	  /**
	   * Function for use in an {@link module:ol/source/VectorTile~VectorTile}'s
	   * `tileLoadFunction`. Sets the extent of the vector tile. This is only required
	   * for tiles in projections with `tile-pixels` as units. The extent should be
	   * set to `[0, 0, tilePixelSize, tilePixelSize]`, where `tilePixelSize` is
	   * calculated by multiplying the tile size with the tile pixel ratio. For
	   * sources using {@link module:ol/format/MVT~MVT} as feature format, the
	   * {@link module:ol/format/MVT~MVT#getLastExtent} method will return the correct
	   * extent. The default is `[0, 0, 4096, 4096]`.
	   * @param {import("./extent.js").Extent} extent The extent.
	   * @api
	   */
	  VectorTile.prototype.setExtent = function setExtent (extent) {
	    this.extent_ = extent;
	  };
	
	  /**
	   * Function for use in an {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
	   * Sets the features for the tile.
	   * @param {Array<import("./Feature.js").default>} features Features.
	   * @api
	   */
	  VectorTile.prototype.setFeatures = function setFeatures (features) {
	    this.features_ = features;
	    this.setState(TileState.LOADED);
	  };
	
	  /**
	   * Function for use in an {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
	   * Sets the projection of the features that were added with
	   * {@link module:ol/VectorTile~VectorTile#setFeatures}.
	   * @param {import("./proj/Projection.js").default} projection Feature projection.
	   * @api
	   */
	  VectorTile.prototype.setProjection = function setProjection (projection) {
	    this.projection_ = projection;
	  };
	
	  /**
	   * @param {import("./layer/Layer.js").default} layer Layer.
	   * @param {string} key Key.
	   * @param {import("./render/ReplayGroup.js").default} replayGroup Replay group.
	   */
	  VectorTile.prototype.setReplayGroup = function setReplayGroup (layer, key, replayGroup) {
	    this.replayGroups_[getUid(layer) + ',' + key] = replayGroup;
	  };
	
	  /**
	   * Set the feature loader for reading this tile's features.
	   * @param {import("./featureloader.js").FeatureLoader} loader Feature loader.
	   * @api
	   */
	  VectorTile.prototype.setLoader = function setLoader (loader) {
	    this.loader_ = loader;
	  };
	
	  return VectorTile;
	}(Tile));
	
	/**
	 * @module ol
	 */
	
	/**
	 * @api
	 */
	var TileState$1 = TileState;
	/**
	 * @api
	 */
	var ViewHint$1 = ViewHint;
	/**
	 * @api
	 */
	var rbush$1 = rbush_1;
	
	/**
	 * @module ol/render
	 */
	
	
	/**
	 * @typedef {Object} State
	 * @property {CanvasRenderingContext2D} context Canvas context that the layer is being rendered to.
	 * @property {import("./Feature.js").FeatureLike} feature
	 * @property {import("./geom/SimpleGeometry.js").default} geometry
	 * @property {number} pixelRatio Pixel ratio used by the layer renderer.
	 * @property {number} resolution Resolution that the render batch was created and optimized for.
	 * This is not the view's resolution that is being rendered.
	 * @property {number} rotation Rotation of the rendered layer in radians.
	 */
	
	
	/**
	 * A function to be used when sorting features before rendering.
	 * It takes two instances of {@link module:ol/Feature} or
	 * {@link module:ol/render/Feature} and returns a `{number}`.
	 *
	 * @typedef {function(import("./Feature.js").FeatureLike, import("./Feature.js").FeatureLike):number} OrderFunction
	 */
	
	
	/**
	 * @typedef {Object} ToContextOptions
	 * @property {import("./size.js").Size} [size] Desired size of the canvas in css
	 * pixels. When provided, both canvas and css size will be set according to the
	 * `pixelRatio`. If not provided, the current canvas and css sizes will not be
	 * altered.
	 * @property {number} [pixelRatio=window.devicePixelRatio] Pixel ratio (canvas
	 * pixel to css pixel ratio) for the canvas.
	 */
	
	
	/**
	 * Binds a Canvas Immediate API to a canvas context, to allow drawing geometries
	 * to the context's canvas.
	 *
	 * The units for geometry coordinates are css pixels relative to the top left
	 * corner of the canvas element.
	 * ```js
	 * import {toContext} from 'ol/render';
	 * import Fill from 'ol/style/Fill';
	 * import Polygon from 'ol/geom/Polygon';
	 *
	 * var canvas = document.createElement('canvas');
	 * var render = toContext(canvas.getContext('2d'),
	 *     { size: [100, 100] });
	 * render.setFillStrokeStyle(new Fill({ color: blue }));
	 * render.drawPolygon(
	 *     new Polygon([[[0, 0], [100, 100], [100, 0], [0, 0]]]));
	 * ```
	 *
	 * @param {CanvasRenderingContext2D} context Canvas context.
	 * @param {ToContextOptions=} opt_options Options.
	 * @return {CanvasImmediateRenderer} Canvas Immediate.
	 * @api
	 */
	function toContext(context, opt_options) {
	  var canvas = context.canvas;
	  var options = opt_options ? opt_options : {};
	  var pixelRatio = options.pixelRatio || DEVICE_PIXEL_RATIO;
	  var size = options.size;
	  if (size) {
	    canvas.width = size[0] * pixelRatio;
	    canvas.height = size[1] * pixelRatio;
	    canvas.style.width = size[0] + 'px';
	    canvas.style.height = size[1] + 'px';
	  }
	  var extent = [0, 0, canvas.width, canvas.height];
	  var transform = scale$1(create(), pixelRatio, pixelRatio);
	  return new CanvasImmediateRenderer(context, pixelRatio, extent, transform, 0);
	}
	
	/**
	 * @api
	 */
	var ORDER$1 = ORDER;
	
	/**
	 * @api
	 */
	var TEXT_ALIGN$1 = TEXT_ALIGN;
	
	/**
	 * @api
	 */
	var EventType$2 = RenderEventType;
	
	/**
	 * @api
	 */
	var ReplayType$1 = ReplayType;
	
	/**
	 * @module ol/style/IconAnchorUnits
	 */
	
	/**
	 * Icon anchor units. One of 'fraction', 'pixels'.
	 * @enum {string}
	 */
	var IconAnchorUnits = {
	  FRACTION: 'fraction',
	  PIXELS: 'pixels'
	};
	
	/**
	 * @module ol/style/IconImage
	 */
	
	var IconImage = /*@__PURE__*/(function (EventTarget) {
	  function IconImage(image, src, size, crossOrigin, imageState, color) {
	
	    EventTarget.call(this);
	
	    /**
	     * @private
	     * @type {HTMLImageElement|HTMLCanvasElement}
	     */
	    this.hitDetectionImage_ = null;
	
	    /**
	     * @private
	     * @type {HTMLImageElement|HTMLCanvasElement}
	     */
	    this.image_ = !image ? new Image() : image;
	
	    if (crossOrigin !== null) {
	      /** @type {HTMLImageElement} */ (this.image_).crossOrigin = crossOrigin;
	    }
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = color ?
	      /** @type {HTMLCanvasElement} */ (document.createElement('canvas')) :
	      null;
	
	    /**
	     * @private
	     * @type {import("../color.js").Color}
	     */
	    this.color_ = color;
	
	    /**
	     * @private
	     * @type {Array<import("../events.js").EventsKey>}
	     */
	    this.imageListenerKeys_ = null;
	
	    /**
	     * @private
	     * @type {import("../ImageState.js").default}
	     */
	    this.imageState_ = imageState;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.size_ = size;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.src_ = src;
	
	    /**
	     * @private
	     * @type {boolean|undefined}
	     */
	    this.tainted_;
	
	  }
	
	  if ( EventTarget ) { IconImage.__proto__ = EventTarget; }
	  IconImage.prototype = Object.create( EventTarget && EventTarget.prototype );
	  IconImage.prototype.constructor = IconImage;
	
	  /**
	   * @private
	   * @return {boolean} The image canvas is tainted.
	   */
	  IconImage.prototype.isTainted_ = function isTainted_ () {
	    if (this.tainted_ === undefined && this.imageState_ === ImageState.LOADED) {
	      this.tainted_ = false;
	      var context = createCanvasContext2D(1, 1);
	      try {
	        context.drawImage(this.image_, 0, 0);
	        context.getImageData(0, 0, 1, 1);
	      } catch (e) {
	        this.tainted_ = true;
	      }
	    }
	    return this.tainted_ === true;
	  };
	
	  /**
	   * @private
	   */
	  IconImage.prototype.dispatchChangeEvent_ = function dispatchChangeEvent_ () {
	    this.dispatchEvent(EventType.CHANGE);
	  };
	
	  /**
	   * @private
	   */
	  IconImage.prototype.handleImageError_ = function handleImageError_ () {
	    this.imageState_ = ImageState.ERROR;
	    this.unlistenImage_();
	    this.dispatchChangeEvent_();
	  };
	
	  /**
	   * @private
	   */
	  IconImage.prototype.handleImageLoad_ = function handleImageLoad_ () {
	    this.imageState_ = ImageState.LOADED;
	    if (this.size_) {
	      this.image_.width = this.size_[0];
	      this.image_.height = this.size_[1];
	    }
	    this.size_ = [this.image_.width, this.image_.height];
	    this.unlistenImage_();
	    this.replaceColor_();
	    this.dispatchChangeEvent_();
	  };
	
	  /**
	   * @param {number} pixelRatio Pixel ratio.
	   * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
	   */
	  IconImage.prototype.getImage = function getImage (pixelRatio) {
	    return this.canvas_ ? this.canvas_ : this.image_;
	  };
	
	  /**
	   * @return {import("../ImageState.js").default} Image state.
	   */
	  IconImage.prototype.getImageState = function getImageState () {
	    return this.imageState_;
	  };
	
	  /**
	   * @param {number} pixelRatio Pixel ratio.
	   * @return {HTMLImageElement|HTMLCanvasElement} Image element.
	   */
	  IconImage.prototype.getHitDetectionImage = function getHitDetectionImage (pixelRatio) {
	    if (!this.hitDetectionImage_) {
	      if (this.isTainted_()) {
	        var width = this.size_[0];
	        var height = this.size_[1];
	        var context = createCanvasContext2D(width, height);
	        context.fillRect(0, 0, width, height);
	        this.hitDetectionImage_ = context.canvas;
	      } else {
	        this.hitDetectionImage_ = this.image_;
	      }
	    }
	    return this.hitDetectionImage_;
	  };
	
	  /**
	   * @return {import("../size.js").Size} Image size.
	   */
	  IconImage.prototype.getSize = function getSize () {
	    return this.size_;
	  };
	
	  /**
	   * @return {string|undefined} Image src.
	   */
	  IconImage.prototype.getSrc = function getSrc () {
	    return this.src_;
	  };
	
	  /**
	   * Load not yet loaded URI.
	   */
	  IconImage.prototype.load = function load () {
	    if (this.imageState_ == ImageState.IDLE) {
	      this.imageState_ = ImageState.LOADING;
	      this.imageListenerKeys_ = [
	        listenOnce(this.image_, EventType.ERROR,
	          this.handleImageError_, this),
	        listenOnce(this.image_, EventType.LOAD,
	          this.handleImageLoad_, this)
	      ];
	      try {
	        /** @type {HTMLImageElement} */ (this.image_).src = this.src_;
	      } catch (e) {
	        this.handleImageError_();
	      }
	    }
	  };
	
	  /**
	   * @private
	   */
	  IconImage.prototype.replaceColor_ = function replaceColor_ () {
	    if (!this.color_ || this.isTainted_()) {
	      return;
	    }
	
	    this.canvas_.width = this.image_.width;
	    this.canvas_.height = this.image_.height;
	
	    var ctx = this.canvas_.getContext('2d');
	    ctx.drawImage(this.image_, 0, 0);
	
	    var imgData = ctx.getImageData(0, 0, this.image_.width, this.image_.height);
	    var data = imgData.data;
	    var r = this.color_[0] / 255.0;
	    var g = this.color_[1] / 255.0;
	    var b = this.color_[2] / 255.0;
	
	    for (var i = 0, ii = data.length; i < ii; i += 4) {
	      data[i] *= r;
	      data[i + 1] *= g;
	      data[i + 2] *= b;
	    }
	    ctx.putImageData(imgData, 0, 0);
	  };
	
	  /**
	   * Discards event handlers which listen for load completion or errors.
	   *
	   * @private
	   */
	  IconImage.prototype.unlistenImage_ = function unlistenImage_ () {
	    this.imageListenerKeys_.forEach(unlistenByKey);
	    this.imageListenerKeys_ = null;
	  };
	
	  return IconImage;
	}(Target));
	
	
	/**
	 * @param {HTMLImageElement|HTMLCanvasElement} image Image.
	 * @param {string} src Src.
	 * @param {import("../size.js").Size} size Size.
	 * @param {?string} crossOrigin Cross origin.
	 * @param {import("../ImageState.js").default} imageState Image state.
	 * @param {import("../color.js").Color} color Color.
	 * @return {IconImage} Icon image.
	 */
	function get$3(image, src, size, crossOrigin, imageState, color) {
	  var iconImage = shared.get(src, crossOrigin, color);
	  if (!iconImage) {
	    iconImage = new IconImage(image, src, size, crossOrigin, imageState, color);
	    shared.set(src, crossOrigin, color, iconImage);
	  }
	  return iconImage;
	}
	
	/**
	 * @module ol/style/IconOrigin
	 */
	
	/**
	 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
	 * @enum {string}
	 */
	var IconOrigin = {
	  BOTTOM_LEFT: 'bottom-left',
	  BOTTOM_RIGHT: 'bottom-right',
	  TOP_LEFT: 'top-left',
	  TOP_RIGHT: 'top-right'
	};
	
	/**
	 * @module ol/style/Icon
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
	 * @property {import("./IconOrigin.js").default} [anchorOrigin] Origin of the anchor: `bottom-left`, `bottom-right`,
	 * `top-left` or `top-right`. Default is `top-left`.
	 * @property {import("./IconAnchorUnits.js").default} [anchorXUnits] Units in which the anchor x value is
	 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
	 * the x value in pixels. Default is `'fraction'`.
	 * @property {import("./IconAnchorUnits.js").default} [anchorYUnits] Units in which the anchor y value is
	 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
	 * the y value in pixels. Default is `'fraction'`.
	 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
	 * the icon will be left as is.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
	 * `crossOrigin` value if you are using the WebGL renderer or if you want to access pixel data with the Canvas renderer.
	 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {HTMLImageElement|HTMLCanvasElement} [img] Image object for the icon. If the `src` option is not provided then the
	 * provided image must already be loaded. And in that case, it is required
	 * to provide the size of the image, with the `imgSize` option.
	 * @property {Array<number>} [offset=[0, 0]] Offset, which, together with the size and the offset origin, define the
	 * sub-rectangle to use from the original icon image.
	 * @property {import("./IconOrigin.js").default} [offsetOrigin] Origin of the offset: `bottom-left`, `bottom-right`,
	 * `top-left` or `top-right`. Default is `top-left`.
	 * @property {number} [opacity=1] Opacity of the icon.
	 * @property {number} [scale=1] Scale.
	 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
	 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
	 * @property {import("../size.js").Size} [size] Icon size in pixel. Can be used together with `offset` to define the
	 * sub-rectangle to use from the origin (sprite) icon image.
	 * @property {import("../size.js").Size} [imgSize] Image size in pixels. Only required if `img` is set and `src` is not, and
	 * for SVG images in Internet Explorer 11. The provided `imgSize` needs to match the actual size of the image.
	 * @property {string} [src] Image source URI.
	 */
	
	
	/**
	 * @classdesc
	 * Set icon style for vector features.
	 * @api
	 */
	var Icon = /*@__PURE__*/(function (ImageStyle$$1) {
	  function Icon(opt_options) {
	    var options = opt_options || {};
	
	    /**
	     * @type {number}
	     */
	    var opacity = options.opacity !== undefined ? options.opacity : 1;
	
	    /**
	     * @type {number}
	     */
	    var rotation = options.rotation !== undefined ? options.rotation : 0;
	
	    /**
	     * @type {number}
	     */
	    var scale = options.scale !== undefined ? options.scale : 1;
	
	    /**
	     * @type {boolean}
	     */
	    var rotateWithView = options.rotateWithView !== undefined ?
	      options.rotateWithView : false;
	
	    ImageStyle$$1.call(this, {
	      opacity: opacity,
	      rotation: rotation,
	      scale: scale,
	      rotateWithView: rotateWithView
	    });
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.anchor_ = options.anchor !== undefined ? options.anchor : [0.5, 0.5];
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.normalizedAnchor_ = null;
	
	    /**
	     * @private
	     * @type {import("./IconOrigin.js").default}
	     */
	    this.anchorOrigin_ = options.anchorOrigin !== undefined ?
	      options.anchorOrigin : IconOrigin.TOP_LEFT;
	
	    /**
	     * @private
	     * @type {import("./IconAnchorUnits.js").default}
	     */
	    this.anchorXUnits_ = options.anchorXUnits !== undefined ?
	      options.anchorXUnits : IconAnchorUnits.FRACTION;
	
	    /**
	     * @private
	     * @type {import("./IconAnchorUnits.js").default}
	     */
	    this.anchorYUnits_ = options.anchorYUnits !== undefined ?
	      options.anchorYUnits : IconAnchorUnits.FRACTION;
	
	    /**
	     * @private
	     * @type {?string}
	     */
	    this.crossOrigin_ =
	        options.crossOrigin !== undefined ? options.crossOrigin : null;
	
	    /**
	     * @type {HTMLImageElement|HTMLCanvasElement}
	     */
	    var image = options.img !== undefined ? options.img : null;
	
	    /**
	     * @type {import("../size.js").Size}
	     */
	    var imgSize = options.imgSize !== undefined ? options.imgSize : null;
	
	    /**
	     * @type {string|undefined}
	     */
	    var src = options.src;
	
	    assert(!(src !== undefined && image),
	      4); // `image` and `src` cannot be provided at the same time
	    assert(!image || (image && imgSize),
	      5); // `imgSize` must be set when `image` is provided
	
	    if ((src === undefined || src.length === 0) && image) {
	      src = /** @type {HTMLImageElement} */ (image).src || getUid(image);
	    }
	    assert(src !== undefined && src.length > 0,
	      6); // A defined and non-empty `src` or `image` must be provided
	
	    /**
	     * @type {import("../ImageState.js").default}
	     */
	    var imageState = options.src !== undefined ?
	      ImageState.IDLE : ImageState.LOADED;
	
	    /**
	     * @private
	     * @type {import("../color.js").Color}
	     */
	    this.color_ = options.color !== undefined ? asArray(options.color) : null;
	
	    /**
	     * @private
	     * @type {import("./IconImage.js").default}
	     */
	    this.iconImage_ = get$3(
	      image, /** @type {string} */ (src), imgSize, this.crossOrigin_, imageState, this.color_);
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.offset_ = options.offset !== undefined ? options.offset : [0, 0];
	
	    /**
	     * @private
	     * @type {import("./IconOrigin.js").default}
	     */
	    this.offsetOrigin_ = options.offsetOrigin !== undefined ?
	      options.offsetOrigin : IconOrigin.TOP_LEFT;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.origin_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.size_ = options.size !== undefined ? options.size : null;
	
	  }
	
	  if ( ImageStyle$$1 ) { Icon.__proto__ = ImageStyle$$1; }
	  Icon.prototype = Object.create( ImageStyle$$1 && ImageStyle$$1.prototype );
	  Icon.prototype.constructor = Icon;
	
	  /**
	   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
	   * @return {Icon} The cloned style.
	   * @api
	   */
	  Icon.prototype.clone = function clone () {
	    return new Icon({
	      anchor: this.anchor_.slice(),
	      anchorOrigin: this.anchorOrigin_,
	      anchorXUnits: this.anchorXUnits_,
	      anchorYUnits: this.anchorYUnits_,
	      crossOrigin: this.crossOrigin_,
	      color: (this.color_ && this.color_.slice) ? this.color_.slice() : this.color_ || undefined,
	      src: this.getSrc(),
	      offset: this.offset_.slice(),
	      offsetOrigin: this.offsetOrigin_,
	      size: this.size_ !== null ? this.size_.slice() : undefined,
	      opacity: this.getOpacity(),
	      scale: this.getScale(),
	      rotation: this.getRotation(),
	      rotateWithView: this.getRotateWithView()
	    });
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Icon.prototype.getAnchor = function getAnchor () {
	    if (this.normalizedAnchor_) {
	      return this.normalizedAnchor_;
	    }
	    var anchor = this.anchor_;
	    var size = this.getSize();
	    if (this.anchorXUnits_ == IconAnchorUnits.FRACTION ||
	        this.anchorYUnits_ == IconAnchorUnits.FRACTION) {
	      if (!size) {
	        return null;
	      }
	      anchor = this.anchor_.slice();
	      if (this.anchorXUnits_ == IconAnchorUnits.FRACTION) {
	        anchor[0] *= size[0];
	      }
	      if (this.anchorYUnits_ == IconAnchorUnits.FRACTION) {
	        anchor[1] *= size[1];
	      }
	    }
	
	    if (this.anchorOrigin_ != IconOrigin.TOP_LEFT) {
	      if (!size) {
	        return null;
	      }
	      if (anchor === this.anchor_) {
	        anchor = this.anchor_.slice();
	      }
	      if (this.anchorOrigin_ == IconOrigin.TOP_RIGHT ||
	          this.anchorOrigin_ == IconOrigin.BOTTOM_RIGHT) {
	        anchor[0] = -anchor[0] + size[0];
	      }
	      if (this.anchorOrigin_ == IconOrigin.BOTTOM_LEFT ||
	          this.anchorOrigin_ == IconOrigin.BOTTOM_RIGHT) {
	        anchor[1] = -anchor[1] + size[1];
	      }
	    }
	    this.normalizedAnchor_ = anchor;
	    return this.normalizedAnchor_;
	  };
	
	  /**
	   * Set the anchor point. The anchor determines the center point for the
	   * symbolizer.
	   *
	   * @param {Array<number>} anchor Anchor.
	   * @api
	   */
	  Icon.prototype.setAnchor = function setAnchor (anchor) {
	    this.anchor_ = anchor;
	    this.normalizedAnchor_ = null;
	  };
	
	  /**
	   * Get the icon color.
	   * @return {import("../color.js").Color} Color.
	   * @api
	   */
	  Icon.prototype.getColor = function getColor () {
	    return this.color_;
	  };
	
	  /**
	   * Get the image icon.
	   * @param {number} pixelRatio Pixel ratio.
	   * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
	   * @override
	   * @api
	   */
	  Icon.prototype.getImage = function getImage (pixelRatio) {
	    return this.iconImage_.getImage(pixelRatio);
	  };
	
	  /**
	   * @override
	   */
	  Icon.prototype.getImageSize = function getImageSize () {
	    return this.iconImage_.getSize();
	  };
	
	  /**
	   * @override
	   */
	  Icon.prototype.getHitDetectionImageSize = function getHitDetectionImageSize () {
	    return this.getImageSize();
	  };
	
	  /**
	   * @override
	   */
	  Icon.prototype.getImageState = function getImageState () {
	    return this.iconImage_.getImageState();
	  };
	
	  /**
	   * @override
	   */
	  Icon.prototype.getHitDetectionImage = function getHitDetectionImage (pixelRatio) {
	    return this.iconImage_.getHitDetectionImage(pixelRatio);
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Icon.prototype.getOrigin = function getOrigin () {
	    if (this.origin_) {
	      return this.origin_;
	    }
	    var offset = this.offset_;
	
	    if (this.offsetOrigin_ != IconOrigin.TOP_LEFT) {
	      var size = this.getSize();
	      var iconImageSize = this.iconImage_.getSize();
	      if (!size || !iconImageSize) {
	        return null;
	      }
	      offset = offset.slice();
	      if (this.offsetOrigin_ == IconOrigin.TOP_RIGHT ||
	          this.offsetOrigin_ == IconOrigin.BOTTOM_RIGHT) {
	        offset[0] = iconImageSize[0] - size[0] - offset[0];
	      }
	      if (this.offsetOrigin_ == IconOrigin.BOTTOM_LEFT ||
	          this.offsetOrigin_ == IconOrigin.BOTTOM_RIGHT) {
	        offset[1] = iconImageSize[1] - size[1] - offset[1];
	      }
	    }
	    this.origin_ = offset;
	    return this.origin_;
	  };
	
	  /**
	   * Get the image URL.
	   * @return {string|undefined} Image src.
	   * @api
	   */
	  Icon.prototype.getSrc = function getSrc () {
	    return this.iconImage_.getSrc();
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  Icon.prototype.getSize = function getSize () {
	    return !this.size_ ? this.iconImage_.getSize() : this.size_;
	  };
	
	  /**
	   * @override
	   */
	  Icon.prototype.listenImageChange = function listenImageChange (listener, thisArg) {
	    return listen(this.iconImage_, EventType.CHANGE,
	      listener, thisArg);
	  };
	
	  /**
	   * Load not yet loaded URI.
	   * When rendering a feature with an icon style, the vector renderer will
	   * automatically call this method. However, you might want to call this
	   * method yourself for preloading or other purposes.
	   * @override
	   * @api
	   */
	  Icon.prototype.load = function load () {
	    this.iconImage_.load();
	  };
	
	  /**
	   * @override
	   */
	  Icon.prototype.unlistenImageChange = function unlistenImageChange (listener, thisArg) {
	    unlisten(this.iconImage_, EventType.CHANGE,
	      listener, thisArg);
	  };
	
	  return Icon;
	}(ImageStyle));
	
	/**
	 * @module ol/style
	 */
	/**
	 * @api
	 */
	var TextPlacement$1 = TextPlacement;
	
	/**
	 * @module ol/uri
	 */
	
	
	/**
	 * Appends query parameters to a URI.
	 *
	 * @param {string} uri The original URI, which may already have query data.
	 * @param {!Object} params An object where keys are URI-encoded parameter keys,
	 *     and the values are arbitrary types or arrays.
	 * @api
	 * @return {string} The new URI.
	 */
	function appendParams(uri, params) {
	  var keyParams = [];
	  // Skip any null or undefined parameter values
	  Object.keys(params).forEach(function(k) {
	    if (params[k] !== null && params[k] !== undefined) {
	      keyParams.push(k + '=' + encodeURIComponent(params[k]));
	    }
	  });
	  var qs = keyParams.join('&');
	  // remove any trailing ? or &
	  uri = uri.replace(/[?&]$/, '');
	  // append ? or & depending on whether uri has existing parameters
	  uri = uri.indexOf('?') === -1 ? uri + '?' : uri + '&';
	  return uri + qs;
	}
	
	/**
	 * @module ol/xml
	 */
	
	
	/**
	 * When using {@link module:ol/xml~makeChildAppender} or
	 * {@link module:ol/xml~makeSimpleNodeFactory}, the top `objectStack` item needs
	 * to have this structure.
	 * @typedef {Object} NodeStackItem
	 * @property {Node} node
	 */
	
	
	/**
	 * @typedef {function(Element, Array<*>)} Parser
	 */
	
	
	/**
	 * @typedef {function(Element, *, Array<*>)} Serializer
	 */
	
	
	/**
	 * This document should be used when creating nodes for XML serializations. This
	 * document is also used by {@link module:ol/xml~createElementNS}
	 * @const
	 * @type {Document}
	 */
	var DOCUMENT = document.implementation.createDocument('', '', null);
	
	
	/**
	 * @type {string}
	 */
	var XML_SCHEMA_INSTANCE_URI = 'http://www.w3.org/2001/XMLSchema-instance';
	
	
	/**
	 * @param {string} namespaceURI Namespace URI.
	 * @param {string} qualifiedName Qualified name.
	 * @return {Element} Node.
	 */
	function createElementNS(namespaceURI, qualifiedName) {
	  return DOCUMENT.createElementNS(namespaceURI, qualifiedName);
	}
	
	
	/**
	 * Recursively grab all text content of child nodes into a single string.
	 * @param {Node} node Node.
	 * @param {boolean} normalizeWhitespace Normalize whitespace: remove all line
	 * breaks.
	 * @return {string} All text content.
	 * @api
	 */
	function getAllTextContent(node, normalizeWhitespace) {
	  return getAllTextContent_(node, normalizeWhitespace, []).join('');
	}
	
	
	/**
	 * Recursively grab all text content of child nodes into a single string.
	 * @param {Node} node Node.
	 * @param {boolean} normalizeWhitespace Normalize whitespace: remove all line
	 * breaks.
	 * @param {Array<string>} accumulator Accumulator.
	 * @private
	 * @return {Array<string>} Accumulator.
	 */
	function getAllTextContent_(node, normalizeWhitespace, accumulator) {
	  if (node.nodeType == Node.CDATA_SECTION_NODE ||
	      node.nodeType == Node.TEXT_NODE) {
	    if (normalizeWhitespace) {
	      accumulator.push(String(node.nodeValue).replace(/(\r\n|\r|\n)/g, ''));
	    } else {
	      accumulator.push(node.nodeValue);
	    }
	  } else {
	    var n;
	    for (n = node.firstChild; n; n = n.nextSibling) {
	      getAllTextContent_(n, normalizeWhitespace, accumulator);
	    }
	  }
	  return accumulator;
	}
	
	
	/**
	 * @param {Object} object Object.
	 * @return {boolean} Is a document.
	 */
	function isDocument(object) {
	  return 'documentElement' in object;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {?string} namespaceURI Namespace URI.
	 * @param {string} name Attribute name.
	 * @return {string} Value
	 */
	function getAttributeNS(node, namespaceURI, name) {
	  return node.getAttributeNS(namespaceURI, name) || '';
	}
	
	
	/**
	 * Parse an XML string to an XML Document.
	 * @param {string} xml XML.
	 * @return {Document} Document.
	 * @api
	 */
	function parse(xml) {
	  return new DOMParser().parseFromString(xml, 'application/xml');
	}
	
	
	/**
	 * Make an array extender function for extending the array at the top of the
	 * object stack.
	 * @param {function(this: T, Node, Array<*>): (Array<*>|undefined)} valueReader Value reader.
	 * @param {T=} opt_this The object to use as `this` in `valueReader`.
	 * @return {Parser} Parser.
	 * @template T
	 */
	function makeArrayExtender(valueReader, opt_this) {
	  return (
	    /**
	     * @param {Node} node Node.
	     * @param {Array<*>} objectStack Object stack.
	     */
	    function(node, objectStack) {
	      var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
	      if (value !== undefined) {
	        var array = /** @type {Array<*>} */ (objectStack[objectStack.length - 1]);
	        extend(array, value);
	      }
	    }
	  );
	}
	
	
	/**
	 * Make an array pusher function for pushing to the array at the top of the
	 * object stack.
	 * @param {function(this: T, Element, Array<*>): *} valueReader Value reader.
	 * @param {T=} opt_this The object to use as `this` in `valueReader`.
	 * @return {Parser} Parser.
	 * @template T
	 */
	function makeArrayPusher(valueReader, opt_this) {
	  return (
	    /**
	     * @param {Element} node Node.
	     * @param {Array<*>} objectStack Object stack.
	     */
	    function(node, objectStack) {
	      var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
	      if (value !== undefined) {
	        var array = /** @type {Array<*>} */ (objectStack[objectStack.length - 1]);
	        array.push(value);
	      }
	    });
	}
	
	
	/**
	 * Make an object stack replacer function for replacing the object at the
	 * top of the stack.
	 * @param {function(this: T, Node, Array<*>): *} valueReader Value reader.
	 * @param {T=} opt_this The object to use as `this` in `valueReader`.
	 * @return {Parser} Parser.
	 * @template T
	 */
	function makeReplacer(valueReader, opt_this) {
	  return (
	    /**
	     * @param {Node} node Node.
	     * @param {Array<*>} objectStack Object stack.
	     */
	    function(node, objectStack) {
	      var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
	      if (value !== undefined) {
	        objectStack[objectStack.length - 1] = value;
	      }
	    });
	}
	
	
	/**
	 * Make an object property pusher function for adding a property to the
	 * object at the top of the stack.
	 * @param {function(this: T, Element, Array<*>): *} valueReader Value reader.
	 * @param {string=} opt_property Property.
	 * @param {T=} opt_this The object to use as `this` in `valueReader`.
	 * @return {Parser} Parser.
	 * @template T
	 */
	function makeObjectPropertyPusher(valueReader, opt_property, opt_this) {
	  return (
	    /**
	     * @param {Element} node Node.
	     * @param {Array<*>} objectStack Object stack.
	     */
	    function(node, objectStack) {
	      var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
	      if (value !== undefined) {
	        var object = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
	        var property = opt_property !== undefined ? opt_property : node.localName;
	        var array;
	        if (property in object) {
	          array = object[property];
	        } else {
	          array = object[property] = [];
	        }
	        array.push(value);
	      }
	    });
	}
	
	
	/**
	 * Make an object property setter function.
	 * @param {function(this: T, Element, Array<*>): *} valueReader Value reader.
	 * @param {string=} opt_property Property.
	 * @param {T=} opt_this The object to use as `this` in `valueReader`.
	 * @return {Parser} Parser.
	 * @template T
	 */
	function makeObjectPropertySetter(valueReader, opt_property, opt_this) {
	  return (
	    /**
	     * @param {Element} node Node.
	     * @param {Array<*>} objectStack Object stack.
	     */
	    function(node, objectStack) {
	      var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
	      if (value !== undefined) {
	        var object = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
	        var property = opt_property !== undefined ? opt_property : node.localName;
	        object[property] = value;
	      }
	    });
	}
	
	
	/**
	 * Create a serializer that appends nodes written by its `nodeWriter` to its
	 * designated parent. The parent is the `node` of the
	 * {@link module:ol/xml~NodeStackItem} at the top of the `objectStack`.
	 * @param {function(this: T, Node, V, Array<*>)} nodeWriter Node writer.
	 * @param {T=} opt_this The object to use as `this` in `nodeWriter`.
	 * @return {Serializer} Serializer.
	 * @template T, V
	 */
	function makeChildAppender(nodeWriter, opt_this) {
	  return function(node, value, objectStack) {
	    nodeWriter.call(opt_this !== undefined ? opt_this : this, node, value, objectStack);
	    var parent = /** @type {NodeStackItem} */ (objectStack[objectStack.length - 1]);
	    var parentNode = parent.node;
	    parentNode.appendChild(node);
	  };
	}
	
	
	/**
	 * Create a serializer that calls the provided `nodeWriter` from
	 * {@link module:ol/xml~serialize}. This can be used by the parent writer to have the
	 * 'nodeWriter' called with an array of values when the `nodeWriter` was
	 * designed to serialize a single item. An example would be a LineString
	 * geometry writer, which could be reused for writing MultiLineString
	 * geometries.
	 * @param {function(this: T, Element, V, Array<*>)} nodeWriter Node writer.
	 * @param {T=} opt_this The object to use as `this` in `nodeWriter`.
	 * @return {Serializer} Serializer.
	 * @template T, V
	 */
	function makeArraySerializer(nodeWriter, opt_this) {
	  var serializersNS, nodeFactory;
	  return function(node, value, objectStack) {
	    if (serializersNS === undefined) {
	      serializersNS = {};
	      var serializers = {};
	      serializers[node.localName] = nodeWriter;
	      serializersNS[node.namespaceURI] = serializers;
	      nodeFactory = makeSimpleNodeFactory(node.localName);
	    }
	    serialize(serializersNS, nodeFactory, value, objectStack);
	  };
	}
	
	
	/**
	 * Create a node factory which can use the `opt_keys` passed to
	 * {@link module:ol/xml~serialize} or {@link module:ol/xml~pushSerializeAndPop} as node names,
	 * or a fixed node name. The namespace of the created nodes can either be fixed,
	 * or the parent namespace will be used.
	 * @param {string=} opt_nodeName Fixed node name which will be used for all
	 *     created nodes. If not provided, the 3rd argument to the resulting node
	 *     factory needs to be provided and will be the nodeName.
	 * @param {string=} opt_namespaceURI Fixed namespace URI which will be used for
	 *     all created nodes. If not provided, the namespace of the parent node will
	 *     be used.
	 * @return {function(*, Array<*>, string=): (Node|undefined)} Node factory.
	 */
	function makeSimpleNodeFactory(opt_nodeName, opt_namespaceURI) {
	  var fixedNodeName = opt_nodeName;
	  return (
	    /**
	     * @param {*} value Value.
	     * @param {Array<*>} objectStack Object stack.
	     * @param {string=} opt_nodeName Node name.
	     * @return {Node} Node.
	     */
	    function(value, objectStack, opt_nodeName) {
	      var context = /** @type {NodeStackItem} */ (objectStack[objectStack.length - 1]);
	      var node = context.node;
	      var nodeName = fixedNodeName;
	      if (nodeName === undefined) {
	        nodeName = opt_nodeName;
	      }
	
	      var namespaceURI = opt_namespaceURI !== undefined ? opt_namespaceURI : node.namespaceURI;
	      return createElementNS(namespaceURI, /** @type {string} */ (nodeName));
	    }
	  );
	}
	
	
	/**
	 * A node factory that creates a node using the parent's `namespaceURI` and the
	 * `nodeName` passed by {@link module:ol/xml~serialize} or
	 * {@link module:ol/xml~pushSerializeAndPop} to the node factory.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var OBJECT_PROPERTY_NODE_FACTORY = makeSimpleNodeFactory();
	
	
	/**
	 * Create an array of `values` to be used with {@link module:ol/xml~serialize} or
	 * {@link module:ol/xml~pushSerializeAndPop}, where `orderedKeys` has to be provided as
	 * `opt_key` argument.
	 * @param {Object<string, V>} object Key-value pairs for the sequence. Keys can
	 *     be a subset of the `orderedKeys`.
	 * @param {Array<string>} orderedKeys Keys in the order of the sequence.
	 * @return {Array<V>} Values in the order of the sequence. The resulting array
	 *     has the same length as the `orderedKeys` array. Values that are not
	 *     present in `object` will be `undefined` in the resulting array.
	 * @template V
	 */
	function makeSequence(object, orderedKeys) {
	  var length = orderedKeys.length;
	  var sequence = new Array(length);
	  for (var i = 0; i < length; ++i) {
	    sequence[i] = object[orderedKeys[i]];
	  }
	  return sequence;
	}
	
	
	/**
	 * Create a namespaced structure, using the same values for each namespace.
	 * This can be used as a starting point for versioned parsers, when only a few
	 * values are version specific.
	 * @param {Array<string>} namespaceURIs Namespace URIs.
	 * @param {T} structure Structure.
	 * @param {Object<string, T>=} opt_structureNS Namespaced structure to add to.
	 * @return {Object<string, T>} Namespaced structure.
	 * @template T
	 */
	function makeStructureNS(namespaceURIs, structure, opt_structureNS) {
	  /**
	   * @type {Object<string, T>}
	   */
	  var structureNS = opt_structureNS !== undefined ? opt_structureNS : {};
	  var i, ii;
	  for (i = 0, ii = namespaceURIs.length; i < ii; ++i) {
	    structureNS[namespaceURIs[i]] = structure;
	  }
	  return structureNS;
	}
	
	
	/**
	 * Parse a node using the parsers and object stack.
	 * @param {Object<string, Object<string, Parser>>} parsersNS
	 *     Parsers by namespace.
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @param {*=} opt_this The object to use as `this`.
	 */
	function parseNode(parsersNS, node, objectStack, opt_this) {
	  var n;
	  for (n = node.firstElementChild; n; n = n.nextElementSibling) {
	    var parsers = parsersNS[n.namespaceURI];
	    if (parsers !== undefined) {
	      var parser = parsers[n.localName];
	      if (parser !== undefined) {
	        parser.call(opt_this, n, objectStack);
	      }
	    }
	  }
	}
	
	
	/**
	 * Push an object on top of the stack, parse and return the popped object.
	 * @param {T} object Object.
	 * @param {Object<string, Object<string, Parser>>} parsersNS
	 *     Parsers by namespace.
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @param {*=} opt_this The object to use as `this`.
	 * @return {T} Object.
	 * @template T
	 */
	function pushParseAndPop(object, parsersNS, node, objectStack, opt_this) {
	  objectStack.push(object);
	  parseNode(parsersNS, node, objectStack, opt_this);
	  return /** @type {T} */ (objectStack.pop());
	}
	
	
	/**
	 * Walk through an array of `values` and call a serializer for each value.
	 * @param {Object<string, Object<string, Serializer>>} serializersNS
	 *     Namespaced serializers.
	 * @param {function(this: T, *, Array<*>, (string|undefined)): (Node|undefined)} nodeFactory
	 *     Node factory. The `nodeFactory` creates the node whose namespace and name
	 *     will be used to choose a node writer from `serializersNS`. This
	 *     separation allows us to decide what kind of node to create, depending on
	 *     the value we want to serialize. An example for this would be different
	 *     geometry writers based on the geometry type.
	 * @param {Array<*>} values Values to serialize. An example would be an array
	 *     of {@link module:ol/Feature~Feature} instances.
	 * @param {Array<*>} objectStack Node stack.
	 * @param {Array<string>=} opt_keys Keys of the `values`. Will be passed to the
	 *     `nodeFactory`. This is used for serializing object literals where the
	 *     node name relates to the property key. The array length of `opt_keys` has
	 *     to match the length of `values`. For serializing a sequence, `opt_keys`
	 *     determines the order of the sequence.
	 * @param {T=} opt_this The object to use as `this` for the node factory and
	 *     serializers.
	 * @template T
	 */
	function serialize(
	  serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this) {
	  var length = (opt_keys !== undefined ? opt_keys : values).length;
	  var value, node;
	  for (var i = 0; i < length; ++i) {
	    value = values[i];
	    if (value !== undefined) {
	      node = nodeFactory.call(opt_this !== undefined ? opt_this : this, value, objectStack,
	        opt_keys !== undefined ? opt_keys[i] : undefined);
	      if (node !== undefined) {
	        serializersNS[node.namespaceURI][node.localName]
	          .call(opt_this, node, value, objectStack);
	      }
	    }
	  }
	}
	
	
	/**
	 * @param {O} object Object.
	 * @param {Object<string, Object<string, Serializer>>} serializersNS
	 *     Namespaced serializers.
	 * @param {function(this: T, *, Array<*>, (string|undefined)): (Node|undefined)} nodeFactory
	 *     Node factory. The `nodeFactory` creates the node whose namespace and name
	 *     will be used to choose a node writer from `serializersNS`. This
	 *     separation allows us to decide what kind of node to create, depending on
	 *     the value we want to serialize. An example for this would be different
	 *     geometry writers based on the geometry type.
	 * @param {Array<*>} values Values to serialize. An example would be an array
	 *     of {@link module:ol/Feature~Feature} instances.
	 * @param {Array<*>} objectStack Node stack.
	 * @param {Array<string>=} opt_keys Keys of the `values`. Will be passed to the
	 *     `nodeFactory`. This is used for serializing object literals where the
	 *     node name relates to the property key. The array length of `opt_keys` has
	 *     to match the length of `values`. For serializing a sequence, `opt_keys`
	 *     determines the order of the sequence.
	 * @param {T=} opt_this The object to use as `this` for the node factory and
	 *     serializers.
	 * @return {O|undefined} Object.
	 * @template O, T
	 */
	function pushSerializeAndPop(object, serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this) {
	  objectStack.push(object);
	  serialize(serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this);
	  return /** @type {O|undefined} */ (objectStack.pop());
	}
	
	/**
	 * @module ol/tilegrid/WMTS
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles
	 * outside this extent will be requested by {@link module:ol/source/Tile} sources.
	 * When no `origin` or `origins` are configured, the `origin` will be set to the
	 * top-left corner of the extent.
	 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e.
	 * where the `x` and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left
	 * to right and upwards. If not specified, `extent` or `origins` must be provided.
	 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins,
	 * i.e. where the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If
	 * given, the array length should match the length of the `resolutions` array, i.e.
	 * each resolution can have a different origin. Tile coordinates increase left to
	 * right and upwards. If not specified, `extent` or `origin` must be provided.
	 * @property {!Array<number>} resolutions Resolutions. The array index of each
	 * resolution needs to match the zoom level. This means that even if a `minZoom`
	 * is configured, the resolutions array will have a length of `maxZoom + 1`
	 * @property {!Array<string>} matrixIds matrix IDs. The length of this array needs
	 * to match the length of the `resolutions` array.
	 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
	 * of the grid for each zoom level. The values here are the `TileMatrixWidth` and
	 * `TileMatrixHeight` advertised in the GetCapabilities response of the WMTS, and
	 * define the grid's extent together with the `origin`.
	 * An `extent` can be configured in addition, and will further limit the extent for
	 * which tile requests are made by sources. Note that when the top-left corner of
	 * the `extent` is used as `origin` or `origins`, then the `y` value must be
	 * negative because OpenLayers tile coordinates increase upwards.
	 * @property {number|import("../size.js").Size} [tileSize] Tile size.
	 * @property {Array<import("../size.js").Size>} [tileSizes] Tile sizes. The length of
	 * this array needs to match the length of the `resolutions` array.
	 * @property {Array<number>} [widths] Number of tile columns that cover the grid's
	 * extent for each zoom level. Only required when used with a source that has `wrapX`
	 * set to `true`, and only when the grid's origin differs from the one of the
	 * projection's extent. The array length has to match the length of the `resolutions`
	 * array, i.e. each resolution will have a matching entry here.
	 */
	
	
	/**
	 * @classdesc
	 * Set the grid pattern for sources accessing WMTS tiled-image servers.
	 * @api
	 */
	var WMTSTileGrid = /*@__PURE__*/(function (TileGrid$$1) {
	  function WMTSTileGrid(options) {
	    TileGrid$$1.call(this, {
	      extent: options.extent,
	      origin: options.origin,
	      origins: options.origins,
	      resolutions: options.resolutions,
	      tileSize: options.tileSize,
	      tileSizes: options.tileSizes,
	      sizes: options.sizes
	    });
	
	    /**
	     * @private
	     * @type {!Array<string>}
	     */
	    this.matrixIds_ = options.matrixIds;
	  }
	
	  if ( TileGrid$$1 ) { WMTSTileGrid.__proto__ = TileGrid$$1; }
	  WMTSTileGrid.prototype = Object.create( TileGrid$$1 && TileGrid$$1.prototype );
	  WMTSTileGrid.prototype.constructor = WMTSTileGrid;
	
	  /**
	   * @param {number} z Z.
	   * @return {string} MatrixId..
	   */
	  WMTSTileGrid.prototype.getMatrixId = function getMatrixId (z) {
	    return this.matrixIds_[z];
	  };
	
	  /**
	   * Get the list of matrix identifiers.
	   * @return {Array<string>} MatrixIds.
	   * @api
	   */
	  WMTSTileGrid.prototype.getMatrixIds = function getMatrixIds () {
	    return this.matrixIds_;
	  };
	
	  return WMTSTileGrid;
	}(TileGrid));
	
	/**
	 * Create a tile grid from a WMTS capabilities matrix set and an
	 * optional TileMatrixSetLimits.
	 * @param {Object} matrixSet An object representing a matrixSet in the
	 *     capabilities document.
	 * @param {import("../extent.js").Extent=} opt_extent An optional extent to restrict the tile
	 *     ranges the server provides.
	 * @param {Array<Object>=} opt_matrixLimits An optional object representing
	 *     the available matrices for tileGrid.
	 * @return {WMTSTileGrid} WMTS tileGrid instance.
	 * @api
	 */
	function createFromCapabilitiesMatrixSet(matrixSet, opt_extent, opt_matrixLimits) {
	
	  /** @type {!Array<number>} */
	  var resolutions = [];
	  /** @type {!Array<string>} */
	  var matrixIds = [];
	  /** @type {!Array<import("../coordinate.js").Coordinate>} */
	  var origins = [];
	  /** @type {!Array<import("../size.js").Size>} */
	  var tileSizes = [];
	  /** @type {!Array<import("../size.js").Size>} */
	  var sizes = [];
	
	  var matrixLimits = opt_matrixLimits !== undefined ? opt_matrixLimits : [];
	
	  var supportedCRSPropName = 'SupportedCRS';
	  var matrixIdsPropName = 'TileMatrix';
	  var identifierPropName = 'Identifier';
	  var scaleDenominatorPropName = 'ScaleDenominator';
	  var topLeftCornerPropName = 'TopLeftCorner';
	  var tileWidthPropName = 'TileWidth';
	  var tileHeightPropName = 'TileHeight';
	
	  var code = matrixSet[supportedCRSPropName];
	  var projection = get$2(code.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/, '$1:$3')) ||
	      get$2(code);
	  var metersPerUnit = projection.getMetersPerUnit();
	  // swap origin x and y coordinates if axis orientation is lat/long
	  var switchOriginXY = projection.getAxisOrientation().substr(0, 2) == 'ne';
	
	  matrixSet[matrixIdsPropName].sort(function(a, b) {
	    return b[scaleDenominatorPropName] - a[scaleDenominatorPropName];
	  });
	
	  matrixSet[matrixIdsPropName].forEach(function(elt) {
	
	    var matrixAvailable;
	    // use of matrixLimits to filter TileMatrices from GetCapabilities
	    // TileMatrixSet from unavailable matrix levels.
	    if (matrixLimits.length > 0) {
	      matrixAvailable = find(matrixLimits, function(elt_ml) {
	        if (elt[identifierPropName] == elt_ml[matrixIdsPropName]) {
	          return true;
	        }
	        // Fallback for tileMatrix identifiers that don't get prefixed
	        // by their tileMatrixSet identifiers.
	        if (elt[identifierPropName].indexOf(':') === -1) {
	          return matrixSet[identifierPropName] + ':' + elt[identifierPropName] === elt_ml[matrixIdsPropName];
	        }
	        return false;
	      });
	    } else {
	      matrixAvailable = true;
	    }
	
	    if (matrixAvailable) {
	      matrixIds.push(elt[identifierPropName]);
	      var resolution = elt[scaleDenominatorPropName] * 0.28E-3 / metersPerUnit;
	      var tileWidth = elt[tileWidthPropName];
	      var tileHeight = elt[tileHeightPropName];
	      if (switchOriginXY) {
	        origins.push([elt[topLeftCornerPropName][1],
	          elt[topLeftCornerPropName][0]]);
	      } else {
	        origins.push(elt[topLeftCornerPropName]);
	      }
	      resolutions.push(resolution);
	      tileSizes.push(tileWidth == tileHeight ?
	        tileWidth : [tileWidth, tileHeight]);
	      // top-left origin, so height is negative
	      sizes.push([elt['MatrixWidth'], -elt['MatrixHeight']]);
	    }
	  });
	
	  return new WMTSTileGrid({
	    extent: opt_extent,
	    origins: origins,
	    resolutions: resolutions,
	    matrixIds: matrixIds,
	    tileSizes: tileSizes,
	    sizes: sizes
	  });
	}
	
	/**
	 * @module ol/tileurlfunction
	 */
	
	
	/**
	 * @param {string} template Template.
	 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
	 * @return {import("./Tile.js").UrlFunction} Tile URL function.
	 */
	function createFromTemplate(template, tileGrid) {
	  var zRegEx = /\{z\}/g;
	  var xRegEx = /\{x\}/g;
	  var yRegEx = /\{y\}/g;
	  var dashYRegEx = /\{-y\}/g;
	  return (
	    /**
	     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
	     * @param {number} pixelRatio Pixel ratio.
	     * @param {import("./proj/Projection.js").default} projection Projection.
	     * @return {string|undefined} Tile URL.
	     */
	    function(tileCoord, pixelRatio, projection) {
	      if (!tileCoord) {
	        return undefined;
	      } else {
	        return template.replace(zRegEx, tileCoord[0].toString())
	          .replace(xRegEx, tileCoord[1].toString())
	          .replace(yRegEx, function() {
	            var y = -tileCoord[2] - 1;
	            return y.toString();
	          })
	          .replace(dashYRegEx, function() {
	            var z = tileCoord[0];
	            var range = tileGrid.getFullTileRange(z);
	            assert(range, 55); // The {-y} placeholder requires a tile grid with extent
	            var y = range.getHeight() + tileCoord[2];
	            return y.toString();
	          });
	      }
	    }
	  );
	}
	
	
	/**
	 * @param {Array<string>} templates Templates.
	 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
	 * @return {import("./Tile.js").UrlFunction} Tile URL function.
	 */
	function createFromTemplates(templates, tileGrid) {
	  var len = templates.length;
	  var tileUrlFunctions = new Array(len);
	  for (var i = 0; i < len; ++i) {
	    tileUrlFunctions[i] = createFromTemplate(templates[i], tileGrid);
	  }
	  return createFromTileUrlFunctions(tileUrlFunctions);
	}
	
	
	/**
	 * @param {Array<import("./Tile.js").UrlFunction>} tileUrlFunctions Tile URL Functions.
	 * @return {import("./Tile.js").UrlFunction} Tile URL function.
	 */
	function createFromTileUrlFunctions(tileUrlFunctions) {
	  if (tileUrlFunctions.length === 1) {
	    return tileUrlFunctions[0];
	  }
	  return (
	    /**
	     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
	     * @param {number} pixelRatio Pixel ratio.
	     * @param {import("./proj/Projection.js").default} projection Projection.
	     * @return {string|undefined} Tile URL.
	     */
	    function(tileCoord, pixelRatio, projection) {
	      if (!tileCoord) {
	        return undefined;
	      } else {
	        var h = hash(tileCoord);
	        var index = modulo(h, tileUrlFunctions.length);
	        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
	      }
	    }
	  );
	}
	
	
	/**
	 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
	 * @param {number} pixelRatio Pixel ratio.
	 * @param {import("./proj/Projection.js").default} projection Projection.
	 * @return {string|undefined} Tile URL.
	 */
	function nullTileUrlFunction(tileCoord, pixelRatio, projection) {
	  return undefined;
	}
	
	
	/**
	 * @param {string} url URL.
	 * @return {Array<string>} Array of urls.
	 */
	function expandUrl(url) {
	  var urls = [];
	  var match = /\{([a-z])-([a-z])\}/.exec(url);
	  if (match) {
	    // char range
	    var startCharCode = match[1].charCodeAt(0);
	    var stopCharCode = match[2].charCodeAt(0);
	    var charCode;
	    for (charCode = startCharCode; charCode <= stopCharCode; ++charCode) {
	      urls.push(url.replace(match[0], String.fromCharCode(charCode)));
	    }
	    return urls;
	  }
	  match = match = /\{(\d+)-(\d+)\}/.exec(url);
	  if (match) {
	    // number range
	    var stop = parseInt(match[2], 10);
	    for (var i = parseInt(match[1], 10); i <= stop; i++) {
	      urls.push(url.replace(match[0], i.toString()));
	    }
	    return urls;
	  }
	  urls.push(url);
	  return urls;
	}
	
	/**
	 * @module ol/net
	 */
	
	
	/**
	 * Simple JSONP helper. Supports error callbacks and a custom callback param.
	 * The error callback will be called when no JSONP is executed after 10 seconds.
	 *
	 * @param {string} url Request url. A 'callback' query parameter will be
	 *     appended.
	 * @param {Function} callback Callback on success.
	 * @param {function()=} opt_errback Callback on error.
	 * @param {string=} opt_callbackParam Custom query parameter for the JSONP
	 *     callback. Default is 'callback'.
	 */
	function jsonp(url, callback, opt_errback, opt_callbackParam) {
	  var script = document.createElement('script');
	  var key = 'olc_' + getUid(callback);
	  function cleanup() {
	    delete window[key];
	    script.parentNode.removeChild(script);
	  }
	  script.async = true;
	  script.src = url + (url.indexOf('?') == -1 ? '?' : '&') +
	      (opt_callbackParam || 'callback') + '=' + key;
	  var timer = setTimeout(function() {
	    cleanup();
	    if (opt_errback) {
	      opt_errback();
	    }
	  }, 10000);
	  window[key] = function(data) {
	    clearTimeout(timer);
	    cleanup();
	    callback(data);
	  };
	  document.getElementsByTagName('head')[0].appendChild(script);
	}
	
	/**
	 * @module ol/reproj
	 */
	
	
	/**
	 * Calculates ideal resolution to use from the source in order to achieve
	 * pixel mapping as close as possible to 1:1 during reprojection.
	 * The resolution is calculated regardless of what resolutions
	 * are actually available in the dataset (TileGrid, Image, ...).
	 *
	 * @param {import("./proj/Projection.js").default} sourceProj Source projection.
	 * @param {import("./proj/Projection.js").default} targetProj Target projection.
	 * @param {import("./coordinate.js").Coordinate} targetCenter Target center.
	 * @param {number} targetResolution Target resolution.
	 * @return {number} The best resolution to use. Can be +-Infinity, NaN or 0.
	 */
	function calculateSourceResolution(sourceProj, targetProj,
	  targetCenter, targetResolution) {
	
	  var sourceCenter = transform(targetCenter, targetProj, sourceProj);
	
	  // calculate the ideal resolution of the source data
	  var sourceResolution = getPointResolution(targetProj, targetResolution, targetCenter);
	
	  var targetMetersPerUnit = targetProj.getMetersPerUnit();
	  if (targetMetersPerUnit !== undefined) {
	    sourceResolution *= targetMetersPerUnit;
	  }
	  var sourceMetersPerUnit = sourceProj.getMetersPerUnit();
	  if (sourceMetersPerUnit !== undefined) {
	    sourceResolution /= sourceMetersPerUnit;
	  }
	
	  // Based on the projection properties, the point resolution at the specified
	  // coordinates may be slightly different. We need to reverse-compensate this
	  // in order to achieve optimal results.
	
	  var sourceExtent = sourceProj.getExtent();
	  if (!sourceExtent || containsCoordinate(sourceExtent, sourceCenter)) {
	    var compensationFactor = getPointResolution(sourceProj, sourceResolution, sourceCenter) /
	        sourceResolution;
	    if (isFinite(compensationFactor) && compensationFactor > 0) {
	      sourceResolution /= compensationFactor;
	    }
	  }
	
	  return sourceResolution;
	}
	
	
	/**
	 * Enlarge the clipping triangle point by 1 pixel to ensure the edges overlap
	 * in order to mask gaps caused by antialiasing.
	 *
	 * @param {number} centroidX Centroid of the triangle (x coordinate in pixels).
	 * @param {number} centroidY Centroid of the triangle (y coordinate in pixels).
	 * @param {number} x X coordinate of the point (in pixels).
	 * @param {number} y Y coordinate of the point (in pixels).
	 * @return {import("./coordinate.js").Coordinate} New point 1 px farther from the centroid.
	 */
	function enlargeClipPoint(centroidX, centroidY, x, y) {
	  var dX = x - centroidX;
	  var dY = y - centroidY;
	  var distance = Math.sqrt(dX * dX + dY * dY);
	  return [Math.round(x + dX / distance), Math.round(y + dY / distance)];
	}
	
	
	/**
	 * Renders the source data into new canvas based on the triangulation.
	 *
	 * @param {number} width Width of the canvas.
	 * @param {number} height Height of the canvas.
	 * @param {number} pixelRatio Pixel ratio.
	 * @param {number} sourceResolution Source resolution.
	 * @param {import("./extent.js").Extent} sourceExtent Extent of the data source.
	 * @param {number} targetResolution Target resolution.
	 * @param {import("./extent.js").Extent} targetExtent Target extent.
	 * @param {import("./reproj/Triangulation.js").default} triangulation
	 * Calculated triangulation.
	 * @param {Array<{extent: import("./extent.js").Extent,
	 *                 image: (HTMLCanvasElement|HTMLImageElement|HTMLVideoElement)}>} sources
	 * Array of sources.
	 * @param {number} gutter Gutter of the sources.
	 * @param {boolean=} opt_renderEdges Render reprojection edges.
	 * @return {HTMLCanvasElement} Canvas with reprojected data.
	 */
	function render$6(width, height, pixelRatio,
	  sourceResolution, sourceExtent, targetResolution, targetExtent,
	  triangulation, sources, gutter, opt_renderEdges) {
	
	  var context = createCanvasContext2D(Math.round(pixelRatio * width),
	    Math.round(pixelRatio * height));
	
	  if (sources.length === 0) {
	    return context.canvas;
	  }
	
	  context.scale(pixelRatio, pixelRatio);
	
	  var sourceDataExtent = createEmpty();
	  sources.forEach(function(src, i, arr) {
	    extend$1(sourceDataExtent, src.extent);
	  });
	
	  var canvasWidthInUnits = getWidth(sourceDataExtent);
	  var canvasHeightInUnits = getHeight(sourceDataExtent);
	  var stitchContext = createCanvasContext2D(
	    Math.round(pixelRatio * canvasWidthInUnits / sourceResolution),
	    Math.round(pixelRatio * canvasHeightInUnits / sourceResolution));
	
	  var stitchScale = pixelRatio / sourceResolution;
	
	  sources.forEach(function(src, i, arr) {
	    var xPos = src.extent[0] - sourceDataExtent[0];
	    var yPos = -(src.extent[3] - sourceDataExtent[3]);
	    var srcWidth = getWidth(src.extent);
	    var srcHeight = getHeight(src.extent);
	
	    stitchContext.drawImage(
	      src.image,
	      gutter, gutter,
	      src.image.width - 2 * gutter, src.image.height - 2 * gutter,
	      xPos * stitchScale, yPos * stitchScale,
	      srcWidth * stitchScale, srcHeight * stitchScale);
	  });
	
	  var targetTopLeft = getTopLeft(targetExtent);
	
	  triangulation.getTriangles().forEach(function(triangle, i, arr) {
	    /* Calculate affine transform (src -> dst)
	     * Resulting matrix can be used to transform coordinate
	     * from `sourceProjection` to destination pixels.
	     *
	     * To optimize number of context calls and increase numerical stability,
	     * we also do the following operations:
	     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
	     * here before solving the linear system so [ui, vi] are pixel coordinates.
	     *
	     * Src points: xi, yi
	     * Dst points: ui, vi
	     * Affine coefficients: aij
	     *
	     * | x0 y0 1  0  0 0 |   |a00|   |u0|
	     * | x1 y1 1  0  0 0 |   |a01|   |u1|
	     * | x2 y2 1  0  0 0 | x |a02| = |u2|
	     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
	     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
	     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
	     */
	    var source = triangle.source;
	    var target = triangle.target;
	    var x0 = source[0][0], y0 = source[0][1];
	    var x1 = source[1][0], y1 = source[1][1];
	    var x2 = source[2][0], y2 = source[2][1];
	    var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
	    var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
	    var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
	    var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
	    var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
	    var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
	
	    // Shift all the source points to improve numerical stability
	    // of all the subsequent calculations. The [x0, y0] is used here.
	    // This is also used to simplify the linear system.
	    var sourceNumericalShiftX = x0;
	    var sourceNumericalShiftY = y0;
	    x0 = 0;
	    y0 = 0;
	    x1 -= sourceNumericalShiftX;
	    y1 -= sourceNumericalShiftY;
	    x2 -= sourceNumericalShiftX;
	    y2 -= sourceNumericalShiftY;
	
	    var augmentedMatrix = [
	      [x1, y1, 0, 0, u1 - u0],
	      [x2, y2, 0, 0, u2 - u0],
	      [0, 0, x1, y1, v1 - v0],
	      [0, 0, x2, y2, v2 - v0]
	    ];
	    var affineCoefs = solveLinearSystem(augmentedMatrix);
	    if (!affineCoefs) {
	      return;
	    }
	
	    context.save();
	    context.beginPath();
	    var centroidX = (u0 + u1 + u2) / 3;
	    var centroidY = (v0 + v1 + v2) / 3;
	    var p0 = enlargeClipPoint(centroidX, centroidY, u0, v0);
	    var p1 = enlargeClipPoint(centroidX, centroidY, u1, v1);
	    var p2 = enlargeClipPoint(centroidX, centroidY, u2, v2);
	
	    context.moveTo(p1[0], p1[1]);
	    context.lineTo(p0[0], p0[1]);
	    context.lineTo(p2[0], p2[1]);
	    context.clip();
	
	    context.transform(
	      affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
	
	    context.translate(sourceDataExtent[0] - sourceNumericalShiftX,
	      sourceDataExtent[3] - sourceNumericalShiftY);
	
	    context.scale(sourceResolution / pixelRatio,
	      -sourceResolution / pixelRatio);
	
	    context.drawImage(stitchContext.canvas, 0, 0);
	    context.restore();
	  });
	
	  if (opt_renderEdges) {
	    context.save();
	
	    context.strokeStyle = 'black';
	    context.lineWidth = 1;
	
	    triangulation.getTriangles().forEach(function(triangle, i, arr) {
	      var target = triangle.target;
	      var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
	      var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
	      var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
	      var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
	      var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
	      var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
	
	      context.beginPath();
	      context.moveTo(u1, v1);
	      context.lineTo(u0, v0);
	      context.lineTo(u2, v2);
	      context.closePath();
	      context.stroke();
	    });
	
	    context.restore();
	  }
	  return context.canvas;
	}
	
	/**
	 * @module ol/reproj/Triangulation
	 */
	
	
	/**
	 * Single triangle; consists of 3 source points and 3 target points.
	 * @typedef {Object} Triangle
	 * @property {Array<import("../coordinate.js").Coordinate>} source
	 * @property {Array<import("../coordinate.js").Coordinate>} target
	 */
	
	
	/**
	 * Maximum number of subdivision steps during raster reprojection triangulation.
	 * Prevents high memory usage and large number of proj4 calls (for certain
	 * transformations and areas). At most `2*(2^this)` triangles are created for
	 * each triangulated extent (tile/image).
	 * @type {number}
	 */
	var MAX_SUBDIVISION = 10;
	
	
	/**
	 * Maximum allowed size of triangle relative to world width. When transforming
	 * corners of world extent between certain projections, the resulting
	 * triangulation seems to have zero error and no subdivision is performed. If
	 * the triangle width is more than this (relative to world width; 0-1),
	 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
	 * @type {number}
	 */
	var MAX_TRIANGLE_WIDTH = 0.25;
	
	
	/**
	 * @classdesc
	 * Class containing triangulation of the given target extent.
	 * Used for determining source data and the reprojection itself.
	 */
	var Triangulation = function Triangulation(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold) {
	
	  /**
	   * @type {import("../proj/Projection.js").default}
	   * @private
	   */
	  this.sourceProj_ = sourceProj;
	
	  /**
	   * @type {import("../proj/Projection.js").default}
	   * @private
	   */
	  this.targetProj_ = targetProj;
	
	  /** @type {!Object<string, import("../coordinate.js").Coordinate>} */
	  var transformInvCache = {};
	  var transformInv = getTransform(this.targetProj_, this.sourceProj_);
	
	  /**
	   * @param {import("../coordinate.js").Coordinate} c A coordinate.
	   * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
	   * @private
	   */
	  this.transformInv_ = function(c) {
	    var key = c[0] + '/' + c[1];
	    if (!transformInvCache[key]) {
	      transformInvCache[key] = transformInv(c);
	    }
	    return transformInvCache[key];
	  };
	
	  /**
	   * @type {import("../extent.js").Extent}
	   * @private
	   */
	  this.maxSourceExtent_ = maxSourceExtent;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.errorThresholdSquared_ = errorThreshold * errorThreshold;
	
	  /**
	   * @type {Array<Triangle>}
	   * @private
	   */
	  this.triangles_ = [];
	
	  /**
	   * Indicates that the triangulation crosses edge of the source projection.
	   * @type {boolean}
	   * @private
	   */
	  this.wrapsXInSource_ = false;
	
	  /**
	   * @type {boolean}
	   * @private
	   */
	  this.canWrapXInSource_ = this.sourceProj_.canWrapX() &&
	      !!maxSourceExtent &&
	      !!this.sourceProj_.getExtent() &&
	      (getWidth(maxSourceExtent) == getWidth(this.sourceProj_.getExtent()));
	
	  /**
	   * @type {?number}
	   * @private
	   */
	  this.sourceWorldWidth_ = this.sourceProj_.getExtent() ?
	    getWidth(this.sourceProj_.getExtent()) : null;
	
	  /**
	   * @type {?number}
	   * @private
	   */
	  this.targetWorldWidth_ = this.targetProj_.getExtent() ?
	    getWidth(this.targetProj_.getExtent()) : null;
	
	  var destinationTopLeft = getTopLeft(targetExtent);
	  var destinationTopRight = getTopRight(targetExtent);
	  var destinationBottomRight = getBottomRight(targetExtent);
	  var destinationBottomLeft = getBottomLeft(targetExtent);
	  var sourceTopLeft = this.transformInv_(destinationTopLeft);
	  var sourceTopRight = this.transformInv_(destinationTopRight);
	  var sourceBottomRight = this.transformInv_(destinationBottomRight);
	  var sourceBottomLeft = this.transformInv_(destinationBottomLeft);
	
	  this.addQuad_(
	    destinationTopLeft, destinationTopRight,
	    destinationBottomRight, destinationBottomLeft,
	    sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft,
	    MAX_SUBDIVISION);
	
	  if (this.wrapsXInSource_) {
	    var leftBound = Infinity;
	    this.triangles_.forEach(function(triangle, i, arr) {
	      leftBound = Math.min(leftBound,
	        triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
	    });
	
	    // Shift triangles to be as close to `leftBound` as possible
	    // (if the distance is more than `worldWidth / 2` it can be closer.
	    this.triangles_.forEach(function(triangle) {
	      if (Math.max(triangle.source[0][0], triangle.source[1][0],
	        triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
	        var newTriangle = [[triangle.source[0][0], triangle.source[0][1]],
	          [triangle.source[1][0], triangle.source[1][1]],
	          [triangle.source[2][0], triangle.source[2][1]]];
	        if ((newTriangle[0][0] - leftBound) > this.sourceWorldWidth_ / 2) {
	          newTriangle[0][0] -= this.sourceWorldWidth_;
	        }
	        if ((newTriangle[1][0] - leftBound) > this.sourceWorldWidth_ / 2) {
	          newTriangle[1][0] -= this.sourceWorldWidth_;
	        }
	        if ((newTriangle[2][0] - leftBound) > this.sourceWorldWidth_ / 2) {
	          newTriangle[2][0] -= this.sourceWorldWidth_;
	        }
	
	        // Rarely (if the extent contains both the dateline and prime meridian)
	        // the shift can in turn break some triangles.
	        // Detect this here and don't shift in such cases.
	        var minX = Math.min(
	          newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
	        var maxX = Math.max(
	          newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
	        if ((maxX - minX) < this.sourceWorldWidth_ / 2) {
	          triangle.source = newTriangle;
	        }
	      }
	    }.bind(this));
	  }
	
	  transformInvCache = {};
	};
	
	/**
	 * Adds triangle to the triangulation.
	 * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
	 * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
	 * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
	 * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
	 * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
	 * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
	 * @private
	 */
	Triangulation.prototype.addTriangle_ = function addTriangle_ (a, b, c, aSrc, bSrc, cSrc) {
	  this.triangles_.push({
	    source: [aSrc, bSrc, cSrc],
	    target: [a, b, c]
	  });
	};
	
	/**
	 * Adds quad (points in clock-wise order) to the triangulation
	 * (and reprojects the vertices) if valid.
	 * Performs quad subdivision if needed to increase precision.
	 *
	 * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
	 * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
	 * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
	 * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
	 * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
	 * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
	 * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
	 * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
	 * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
	 * @private
	 */
	Triangulation.prototype.addQuad_ = function addQuad_ (a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
	
	  var sourceQuadExtent = boundingExtent([aSrc, bSrc, cSrc, dSrc]);
	  var sourceCoverageX = this.sourceWorldWidth_ ?
	    getWidth(sourceQuadExtent) / this.sourceWorldWidth_ : null;
	  var sourceWorldWidth = /** @type {number} */ (this.sourceWorldWidth_);
	
	  // when the quad is wrapped in the source projection
	  // it covers most of the projection extent, but not fully
	  var wrapsX = this.sourceProj_.canWrapX() &&
	               sourceCoverageX > 0.5 && sourceCoverageX < 1;
	
	  var needsSubdivision = false;
	
	  if (maxSubdivision > 0) {
	    if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
	      var targetQuadExtent = boundingExtent([a, b, c, d]);
	      var targetCoverageX = getWidth(targetQuadExtent) / this.targetWorldWidth_;
	      needsSubdivision = targetCoverageX > MAX_TRIANGLE_WIDTH ||
	        needsSubdivision;
	    }
	    if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) {
	      needsSubdivision = sourceCoverageX > MAX_TRIANGLE_WIDTH ||
	          needsSubdivision;
	    }
	  }
	
	  if (!needsSubdivision && this.maxSourceExtent_) {
	    if (!intersects(sourceQuadExtent, this.maxSourceExtent_)) {
	      // whole quad outside source projection extent -> ignore
	      return;
	    }
	  }
	
	  if (!needsSubdivision) {
	    if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ||
	        !isFinite(bSrc[0]) || !isFinite(bSrc[1]) ||
	        !isFinite(cSrc[0]) || !isFinite(cSrc[1]) ||
	        !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
	      if (maxSubdivision > 0) {
	        needsSubdivision = true;
	      } else {
	        return;
	      }
	    }
	  }
	
	  if (maxSubdivision > 0) {
	    if (!needsSubdivision) {
	      var center = [(a[0] + c[0]) / 2, (a[1] + c[1]) / 2];
	      var centerSrc = this.transformInv_(center);
	
	      var dx;
	      if (wrapsX) {
	        var centerSrcEstimX =
	            (modulo(aSrc[0], sourceWorldWidth) +
	             modulo(cSrc[0], sourceWorldWidth)) / 2;
	        dx = centerSrcEstimX -
	            modulo(centerSrc[0], sourceWorldWidth);
	      } else {
	        dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
	      }
	      var dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
	      var centerSrcErrorSquared = dx * dx + dy * dy;
	      needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
	    }
	    if (needsSubdivision) {
	      if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
	        // split horizontally (top & bottom)
	        var bc = [(b[0] + c[0]) / 2, (b[1] + c[1]) / 2];
	        var bcSrc = this.transformInv_(bc);
	        var da = [(d[0] + a[0]) / 2, (d[1] + a[1]) / 2];
	        var daSrc = this.transformInv_(da);
	
	        this.addQuad_(
	          a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
	        this.addQuad_(
	          da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
	      } else {
	        // split vertically (left & right)
	        var ab = [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
	        var abSrc = this.transformInv_(ab);
	        var cd = [(c[0] + d[0]) / 2, (c[1] + d[1]) / 2];
	        var cdSrc = this.transformInv_(cd);
	
	        this.addQuad_(
	          a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
	        this.addQuad_(
	          ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
	      }
	      return;
	    }
	  }
	
	  if (wrapsX) {
	    if (!this.canWrapXInSource_) {
	      return;
	    }
	    this.wrapsXInSource_ = true;
	  }
	
	  this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
	  this.addTriangle_(a, b, c, aSrc, bSrc, cSrc);
	};
	
	/**
	 * Calculates extent of the 'source' coordinates from all the triangles.
	 *
	 * @return {import("../extent.js").Extent} Calculated extent.
	 */
	Triangulation.prototype.calculateSourceExtent = function calculateSourceExtent () {
	  var extent = createEmpty();
	
	  this.triangles_.forEach(function(triangle, i, arr) {
	    var src = triangle.source;
	    extendCoordinate(extent, src[0]);
	    extendCoordinate(extent, src[1]);
	    extendCoordinate(extent, src[2]);
	  });
	
	  return extent;
	};
	
	/**
	 * @return {Array<Triangle>} Array of the calculated triangles.
	 */
	Triangulation.prototype.getTriangles = function getTriangles () {
	  return this.triangles_;
	};
	
	/**
	 * @module ol/reproj/Tile
	 */
	
	
	/**
	 * @typedef {function(number, number, number, number) : import("../Tile.js").default} FunctionType
	 */
	
	
	/**
	 * @classdesc
	 * Class encapsulating single reprojected tile.
	 * See {@link module:ol/source/TileImage~TileImage}.
	 *
	 */
	var ReprojTile = /*@__PURE__*/(function (Tile$$1) {
	  function ReprojTile(
	    sourceProj,
	    sourceTileGrid,
	    targetProj,
	    targetTileGrid,
	    tileCoord,
	    wrappedTileCoord,
	    pixelRatio,
	    gutter,
	    getTileFunction,
	    opt_errorThreshold,
	    opt_renderEdges
	  ) {
	    Tile$$1.call(this, tileCoord, TileState.IDLE);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderEdges_ = opt_renderEdges !== undefined ? opt_renderEdges : false;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.pixelRatio_ = pixelRatio;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.gutter_ = gutter;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = null;
	
	    /**
	     * @private
	     * @type {import("../tilegrid/TileGrid.js").default}
	     */
	    this.sourceTileGrid_ = sourceTileGrid;
	
	    /**
	     * @private
	     * @type {import("../tilegrid/TileGrid.js").default}
	     */
	    this.targetTileGrid_ = targetTileGrid;
	
	    /**
	     * @private
	     * @type {import("../tilecoord.js").TileCoord}
	     */
	    this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
	
	    /**
	     * @private
	     * @type {!Array<import("../Tile.js").default>}
	     */
	    this.sourceTiles_ = [];
	
	    /**
	     * @private
	     * @type {Array<import("../events.js").EventsKey>}
	     */
	    this.sourcesListenerKeys_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.sourceZ_ = 0;
	
	    var targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
	    var maxTargetExtent = this.targetTileGrid_.getExtent();
	    var maxSourceExtent = this.sourceTileGrid_.getExtent();
	
	    var limitedTargetExtent = maxTargetExtent ?
	      getIntersection(targetExtent, maxTargetExtent) : targetExtent;
	
	    if (getArea(limitedTargetExtent) === 0) {
	      // Tile is completely outside range -> EMPTY
	      // TODO: is it actually correct that the source even creates the tile ?
	      this.state = TileState.EMPTY;
	      return;
	    }
	
	    var sourceProjExtent = sourceProj.getExtent();
	    if (sourceProjExtent) {
	      if (!maxSourceExtent) {
	        maxSourceExtent = sourceProjExtent;
	      } else {
	        maxSourceExtent = getIntersection(maxSourceExtent, sourceProjExtent);
	      }
	    }
	
	    var targetResolution = targetTileGrid.getResolution(
	      this.wrappedTileCoord_[0]);
	
	    var targetCenter = getCenter(limitedTargetExtent);
	    var sourceResolution = calculateSourceResolution(
	      sourceProj, targetProj, targetCenter, targetResolution);
	
	    if (!isFinite(sourceResolution) || sourceResolution <= 0) {
	      // invalid sourceResolution -> EMPTY
	      // probably edges of the projections when no extent is defined
	      this.state = TileState.EMPTY;
	      return;
	    }
	
	    var errorThresholdInPixels = opt_errorThreshold !== undefined ?
	      opt_errorThreshold : ERROR_THRESHOLD;
	
	    /**
	     * @private
	     * @type {!import("./Triangulation.js").default}
	     */
	    this.triangulation_ = new Triangulation(
	      sourceProj, targetProj, limitedTargetExtent, maxSourceExtent,
	      sourceResolution * errorThresholdInPixels);
	
	    if (this.triangulation_.getTriangles().length === 0) {
	      // no valid triangles -> EMPTY
	      this.state = TileState.EMPTY;
	      return;
	    }
	
	    this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
	    var sourceExtent = this.triangulation_.calculateSourceExtent();
	
	    if (maxSourceExtent) {
	      if (sourceProj.canWrapX()) {
	        sourceExtent[1] = clamp(
	          sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
	        sourceExtent[3] = clamp(
	          sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
	      } else {
	        sourceExtent = getIntersection(sourceExtent, maxSourceExtent);
	      }
	    }
	
	    if (!getArea(sourceExtent)) {
	      this.state = TileState.EMPTY;
	    } else {
	      var sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(
	        sourceExtent, this.sourceZ_);
	
	      for (var srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++) {
	        for (var srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++) {
	          var tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
	          if (tile) {
	            this.sourceTiles_.push(tile);
	          }
	        }
	      }
	
	      if (this.sourceTiles_.length === 0) {
	        this.state = TileState.EMPTY;
	      }
	    }
	  }
	
	  if ( Tile$$1 ) { ReprojTile.__proto__ = Tile$$1; }
	  ReprojTile.prototype = Object.create( Tile$$1 && Tile$$1.prototype );
	  ReprojTile.prototype.constructor = ReprojTile;
	
	  /**
	   * @inheritDoc
	   */
	  ReprojTile.prototype.disposeInternal = function disposeInternal () {
	    if (this.state == TileState.LOADING) {
	      this.unlistenSources_();
	    }
	    Tile$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * Get the HTML Canvas element for this tile.
	   * @return {HTMLCanvasElement} Canvas.
	   */
	  ReprojTile.prototype.getImage = function getImage () {
	    return this.canvas_;
	  };
	
	  /**
	   * @private
	   */
	  ReprojTile.prototype.reproject_ = function reproject_ () {
	    var sources = [];
	    this.sourceTiles_.forEach(function(tile, i, arr) {
	      if (tile && tile.getState() == TileState.LOADED) {
	        sources.push({
	          extent: this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord),
	          image: tile.getImage()
	        });
	      }
	    }.bind(this));
	    this.sourceTiles_.length = 0;
	
	    if (sources.length === 0) {
	      this.state = TileState.ERROR;
	    } else {
	      var z = this.wrappedTileCoord_[0];
	      var size = this.targetTileGrid_.getTileSize(z);
	      var width = typeof size === 'number' ? size : size[0];
	      var height = typeof size === 'number' ? size : size[1];
	      var targetResolution = this.targetTileGrid_.getResolution(z);
	      var sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
	
	      var targetExtent = this.targetTileGrid_.getTileCoordExtent(
	        this.wrappedTileCoord_);
	      this.canvas_ = render$6(width, height, this.pixelRatio_,
	        sourceResolution, this.sourceTileGrid_.getExtent(),
	        targetResolution, targetExtent, this.triangulation_, sources,
	        this.gutter_, this.renderEdges_);
	
	      this.state = TileState.LOADED;
	    }
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ReprojTile.prototype.load = function load () {
	    if (this.state == TileState.IDLE) {
	      this.state = TileState.LOADING;
	      this.changed();
	
	      var leftToLoad = 0;
	
	      this.sourcesListenerKeys_ = [];
	      this.sourceTiles_.forEach(function(tile, i, arr) {
	        var state = tile.getState();
	        if (state == TileState.IDLE || state == TileState.LOADING) {
	          leftToLoad++;
	
	          var sourceListenKey = listen(tile, EventType.CHANGE,
	            function(e) {
	              var state = tile.getState();
	              if (state == TileState.LOADED ||
	                    state == TileState.ERROR ||
	                    state == TileState.EMPTY) {
	                unlistenByKey(sourceListenKey);
	                leftToLoad--;
	                if (leftToLoad === 0) {
	                  this.unlistenSources_();
	                  this.reproject_();
	                }
	              }
	            }, this);
	          this.sourcesListenerKeys_.push(sourceListenKey);
	        }
	      }.bind(this));
	
	      this.sourceTiles_.forEach(function(tile, i, arr) {
	        var state = tile.getState();
	        if (state == TileState.IDLE) {
	          tile.load();
	        }
	      });
	
	      if (leftToLoad === 0) {
	        setTimeout(this.reproject_.bind(this), 0);
	      }
	    }
	  };
	
	  /**
	   * @private
	   */
	  ReprojTile.prototype.unlistenSources_ = function unlistenSources_ () {
	    this.sourcesListenerKeys_.forEach(unlistenByKey);
	    this.sourcesListenerKeys_ = null;
	  };
	
	  return ReprojTile;
	}(Tile));
	
	/**
	 * @module ol/source/TileEventType
	 */
	
	/**
	 * @enum {string}
	 */
	var TileEventType = {
	
	  /**
	   * Triggered when a tile starts loading.
	   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
	   * @api
	   */
	  TILELOADSTART: 'tileloadstart',
	
	  /**
	   * Triggered when a tile finishes loading, either when its data is loaded,
	   * or when loading was aborted because the tile is no longer needed.
	   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
	   * @api
	   */
	  TILELOADEND: 'tileloadend',
	
	  /**
	   * Triggered if tile loading results in an error.
	   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
	   * @api
	   */
	  TILELOADERROR: 'tileloaderror'
	
	};
	
	/**
	 * @module ol/source/UrlTile
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions]
	 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
	 * @property {number} [cacheSize]
	 * @property {boolean} [opaque]
	 * @property {import("../proj.js").ProjectionLike} [projection]
	 * @property {import("./State.js").default} [state]
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid]
	 * @property {import("../Tile.js").LoadFunction} tileLoadFunction
	 * @property {number} [tilePixelRatio]
	 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction]
	 * @property {string} [url]
	 * @property {Array<string>} [urls]
	 * @property {boolean} [wrapX=true]
	 * @property {number} [transition]
	 * @property {string} [key]
	 */
	
	
	/**
	 * @classdesc
	 * Base class for sources providing tiles divided into a tile grid over http.
	 *
	 * @fires import("./Tile.js").TileSourceEvent
	 */
	var UrlTile = /*@__PURE__*/(function (TileSource$$1) {
	  function UrlTile(options) {
	
	    TileSource$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      opaque: options.opaque,
	      projection: options.projection,
	      state: options.state,
	      tileGrid: options.tileGrid,
	      tilePixelRatio: options.tilePixelRatio,
	      wrapX: options.wrapX,
	      transition: options.transition,
	      key: options.key,
	      attributionsCollapsible: options.attributionsCollapsible
	    });
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.generateTileUrlFunction_ = !options.tileUrlFunction;
	
	    /**
	     * @protected
	     * @type {import("../Tile.js").LoadFunction}
	     */
	    this.tileLoadFunction = options.tileLoadFunction;
	
	    /**
	     * @protected
	     * @type {import("../Tile.js").UrlFunction}
	     */
	    this.tileUrlFunction = options.tileUrlFunction ? options.tileUrlFunction.bind(this) : nullTileUrlFunction;
	
	    /**
	     * @protected
	     * @type {!Array<string>|null}
	     */
	    this.urls = null;
	
	    if (options.urls) {
	      this.setUrls(options.urls);
	    } else if (options.url) {
	      this.setUrl(options.url);
	    }
	
	    if (options.tileUrlFunction) {
	      this.setTileUrlFunction(options.tileUrlFunction, this.key_);
	    }
	
	    /**
	     * @private
	     * @type {!Object<string, boolean>}
	     */
	    this.tileLoadingKeys_ = {};
	
	  }
	
	  if ( TileSource$$1 ) { UrlTile.__proto__ = TileSource$$1; }
	  UrlTile.prototype = Object.create( TileSource$$1 && TileSource$$1.prototype );
	  UrlTile.prototype.constructor = UrlTile;
	
	  /**
	   * Return the tile load function of the source.
	   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
	   * @api
	   */
	  UrlTile.prototype.getTileLoadFunction = function getTileLoadFunction () {
	    return this.tileLoadFunction;
	  };
	
	  /**
	   * Return the tile URL function of the source.
	   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
	   * @api
	   */
	  UrlTile.prototype.getTileUrlFunction = function getTileUrlFunction () {
	    return this.tileUrlFunction;
	  };
	
	  /**
	   * Return the URLs used for this source.
	   * When a tileUrlFunction is used instead of url or urls,
	   * null will be returned.
	   * @return {!Array<string>|null} URLs.
	   * @api
	   */
	  UrlTile.prototype.getUrls = function getUrls () {
	    return this.urls;
	  };
	
	  /**
	   * Handle tile change events.
	   * @param {import("../events/Event.js").default} event Event.
	   * @protected
	   */
	  UrlTile.prototype.handleTileChange = function handleTileChange (event) {
	    var tile = /** @type {import("../Tile.js").default} */ (event.target);
	    var uid = getUid(tile);
	    var tileState = tile.getState();
	    var type;
	    if (tileState == TileState.LOADING) {
	      this.tileLoadingKeys_[uid] = true;
	      type = TileEventType.TILELOADSTART;
	    } else if (uid in this.tileLoadingKeys_) {
	      delete this.tileLoadingKeys_[uid];
	      type = tileState == TileState.ERROR ? TileEventType.TILELOADERROR :
	        (tileState == TileState.LOADED || tileState == TileState.ABORT) ?
	          TileEventType.TILELOADEND : undefined;
	    }
	    if (type != undefined) {
	      this.dispatchEvent(new TileSourceEvent(type, tile));
	    }
	  };
	
	  /**
	   * Set the tile load function of the source.
	   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
	   * @api
	   */
	  UrlTile.prototype.setTileLoadFunction = function setTileLoadFunction (tileLoadFunction) {
	    this.tileCache.clear();
	    this.tileLoadFunction = tileLoadFunction;
	    this.changed();
	  };
	
	  /**
	   * Set the tile URL function of the source.
	   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
	   * @param {string=} key Optional new tile key for the source.
	   * @api
	   */
	  UrlTile.prototype.setTileUrlFunction = function setTileUrlFunction (tileUrlFunction, key) {
	    this.tileUrlFunction = tileUrlFunction;
	    this.tileCache.pruneExceptNewestZ();
	    if (typeof key !== 'undefined') {
	      this.setKey(key);
	    } else {
	      this.changed();
	    }
	  };
	
	  /**
	   * Set the URL to use for requests.
	   * @param {string} url URL.
	   * @api
	   */
	  UrlTile.prototype.setUrl = function setUrl (url) {
	    var urls = this.urls = expandUrl(url);
	    this.setUrls(urls);
	  };
	
	  /**
	   * Set the URLs to use for requests.
	   * @param {Array<string>} urls URLs.
	   * @api
	   */
	  UrlTile.prototype.setUrls = function setUrls (urls) {
	    this.urls = urls;
	    var key = urls.join('\n');
	    if (this.generateTileUrlFunction_) {
	      this.setTileUrlFunction(createFromTemplates(urls, this.tileGrid), key);
	    } else {
	      this.setKey(key);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  UrlTile.prototype.useTile = function useTile (z, x, y) {
	    var tileCoordKey = getKeyZXY(z, x, y);
	    if (this.tileCache.containsKey(tileCoordKey)) {
	      this.tileCache.get(tileCoordKey);
	    }
	  };
	
	  return UrlTile;
	}(TileSource));
	
	/**
	 * @module ol/source/TileImage
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {boolean} [opaque=true] Whether the layer is opaque.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {import("./State.js").default} [state] Source state.
	 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
	 * Default is {@link module:ol/ImageTile~ImageTile}.
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
	 * service advertizes 256px by 256px tiles but actually sends 512px
	 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
	 * should be set to `2`.
	 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
	 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
	 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
	 * used instead of defining each one separately in the `urls` option.
	 * @property {Array<string>} [urls] An array of URL templates.
	 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
	 * request out-of-bounds tiles from the server. When set to `false`, only one
	 * world will be rendered. When set to `true`, tiles will be requested for one
	 * world only, but they will be wrapped horizontally to render multiple worlds.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 * @property {string} [key] Optional tile key for proper cache fetching
	 */
	
	
	/**
	 * @classdesc
	 * Base class for sources providing images divided into a tile grid.
	 *
	 * @fires import("./Tile.js").TileSourceEvent
	 * @api
	 */
	var TileImage = /*@__PURE__*/(function (UrlTile$$1) {
	  function TileImage(options) {
	
	    UrlTile$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      opaque: options.opaque,
	      projection: options.projection,
	      state: options.state,
	      tileGrid: options.tileGrid,
	      tileLoadFunction: options.tileLoadFunction ?
	        options.tileLoadFunction : defaultTileLoadFunction,
	      tilePixelRatio: options.tilePixelRatio,
	      tileUrlFunction: options.tileUrlFunction,
	      url: options.url,
	      urls: options.urls,
	      wrapX: options.wrapX,
	      transition: options.transition,
	      key: options.key,
	      attributionsCollapsible: options.attributionsCollapsible
	    });
	
	    /**
	     * @protected
	     * @type {?string}
	     */
	    this.crossOrigin =
	        options.crossOrigin !== undefined ? options.crossOrigin : null;
	
	    /**
	     * @protected
	     * @type {typeof ImageTile}
	     */
	    this.tileClass = options.tileClass !== undefined ?
	      options.tileClass : ImageTile;
	
	    /**
	     * @protected
	     * @type {!Object<string, TileCache>}
	     */
	    this.tileCacheForProjection = {};
	
	    /**
	     * @protected
	     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
	     */
	    this.tileGridForProjection = {};
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.renderReprojectionEdges_ = false;
	  }
	
	  if ( UrlTile$$1 ) { TileImage.__proto__ = UrlTile$$1; }
	  TileImage.prototype = Object.create( UrlTile$$1 && UrlTile$$1.prototype );
	  TileImage.prototype.constructor = TileImage;
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.canExpireCache = function canExpireCache () {
	    if (this.tileCache.canExpireCache()) {
	      return true;
	    } else {
	      for (var key in this.tileCacheForProjection) {
	        if (this.tileCacheForProjection[key].canExpireCache()) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.expireCache = function expireCache (projection, usedTiles) {
	    var usedTileCache = this.getTileCacheForProjection(projection);
	
	    this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
	    for (var id in this.tileCacheForProjection) {
	      var tileCache = this.tileCacheForProjection[id];
	      tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.getGutterForProjection = function getGutterForProjection (projection) {
	    if (this.getProjection() && projection && !equivalent(this.getProjection(), projection)) {
	      return 0;
	    } else {
	      return this.getGutter();
	    }
	  };
	
	  /**
	   * @return {number} Gutter.
	   */
	  TileImage.prototype.getGutter = function getGutter () {
	    return 0;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.getOpaque = function getOpaque (projection) {
	    if (this.getProjection() && projection && !equivalent(this.getProjection(), projection)) {
	      return false;
	    } else {
	      return UrlTile$$1.prototype.getOpaque.call(this, projection);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.getTileGridForProjection = function getTileGridForProjection$1 (projection) {
	    var thisProj = this.getProjection();
	    if (this.tileGrid && (!thisProj || equivalent(thisProj, projection))) {
	      return this.tileGrid;
	    } else {
	      var projKey = getUid(projection);
	      if (!(projKey in this.tileGridForProjection)) {
	        this.tileGridForProjection[projKey] = getForProjection(projection);
	      }
	      return (
	        /** @type {!import("../tilegrid/TileGrid.js").default} */ (this.tileGridForProjection[projKey])
	      );
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.getTileCacheForProjection = function getTileCacheForProjection (projection) {
	    var thisProj = this.getProjection(); if (!thisProj || equivalent(thisProj, projection)) {
	      return this.tileCache;
	    } else {
	      var projKey = getUid(projection);
	      if (!(projKey in this.tileCacheForProjection)) {
	        this.tileCacheForProjection[projKey] = new TileCache(this.tileCache.highWaterMark);
	      }
	      return this.tileCacheForProjection[projKey];
	    }
	  };
	
	  /**
	   * @param {number} z Tile coordinate z.
	   * @param {number} x Tile coordinate x.
	   * @param {number} y Tile coordinate y.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {string} key The key set on the tile.
	   * @return {!import("../Tile.js").default} Tile.
	   * @private
	   */
	  TileImage.prototype.createTile_ = function createTile_ (z, x, y, pixelRatio, projection, key) {
	    var tileCoord = [z, x, y];
	    var urlTileCoord = this.getTileCoordForTileUrlFunction(
	      tileCoord, projection);
	    var tileUrl = urlTileCoord ?
	      this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
	    var tile = new this.tileClass(
	      tileCoord,
	      tileUrl !== undefined ? TileState.IDLE : TileState.EMPTY,
	      tileUrl !== undefined ? tileUrl : '',
	      this.crossOrigin,
	      this.tileLoadFunction,
	      this.tileOptions);
	    tile.key = key;
	    listen(tile, EventType.CHANGE,
	      this.handleTileChange, this);
	    return tile;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileImage.prototype.getTile = function getTile (z, x, y, pixelRatio, projection) {
	    var sourceProjection = /** @type {!import("../proj/Projection.js").default} */ (this.getProjection());
	    if (!sourceProjection || !projection || equivalent(sourceProjection, projection)) {
	      return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
	    } else {
	      var cache = this.getTileCacheForProjection(projection);
	      var tileCoord = [z, x, y];
	      var tile;
	      var tileCoordKey = getKey$1(tileCoord);
	      if (cache.containsKey(tileCoordKey)) {
	        tile = /** @type {!import("../Tile.js").default} */ (cache.get(tileCoordKey));
	      }
	      var key = this.getKey();
	      if (tile && tile.key == key) {
	        return tile;
	      } else {
	        var sourceTileGrid = this.getTileGridForProjection(sourceProjection);
	        var targetTileGrid = this.getTileGridForProjection(projection);
	        var wrappedTileCoord =
	            this.getTileCoordForTileUrlFunction(tileCoord, projection);
	        var newTile = new ReprojTile(
	          sourceProjection, sourceTileGrid,
	          projection, targetTileGrid,
	          tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio),
	          this.getGutter(),
	          function(z, x, y, pixelRatio) {
	            return this.getTileInternal(z, x, y, pixelRatio, sourceProjection);
	          }.bind(this), this.reprojectionErrorThreshold_,
	          this.renderReprojectionEdges_);
	        newTile.key = key;
	
	        if (tile) {
	          newTile.interimTile = tile;
	          newTile.refreshInterimChain();
	          cache.replace(tileCoordKey, newTile);
	        } else {
	          cache.set(tileCoordKey, newTile);
	        }
	        return newTile;
	      }
	    }
	  };
	
	  /**
	   * @param {number} z Tile coordinate z.
	   * @param {number} x Tile coordinate x.
	   * @param {number} y Tile coordinate y.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {!import("../proj/Projection.js").default} projection Projection.
	   * @return {!import("../Tile.js").default} Tile.
	   * @protected
	   */
	  TileImage.prototype.getTileInternal = function getTileInternal (z, x, y, pixelRatio, projection) {
	    var tile = null;
	    var tileCoordKey = getKeyZXY(z, x, y);
	    var key = this.getKey();
	    if (!this.tileCache.containsKey(tileCoordKey)) {
	      tile = this.createTile_(z, x, y, pixelRatio, projection, key);
	      this.tileCache.set(tileCoordKey, tile);
	    } else {
	      tile = this.tileCache.get(tileCoordKey);
	      if (tile.key != key) {
	        // The source's params changed. If the tile has an interim tile and if we
	        // can use it then we use it. Otherwise we create a new tile.  In both
	        // cases we attempt to assign an interim tile to the new tile.
	        var interimTile = tile;
	        tile = this.createTile_(z, x, y, pixelRatio, projection, key);
	
	        //make the new tile the head of the list,
	        if (interimTile.getState() == TileState.IDLE) {
	          //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
	          tile.interimTile = interimTile.interimTile;
	        } else {
	          tile.interimTile = interimTile;
	        }
	        tile.refreshInterimChain();
	        this.tileCache.replace(tileCoordKey, tile);
	      }
	    }
	    return tile;
	  };
	
	  /**
	   * Sets whether to render reprojection edges or not (usually for debugging).
	   * @param {boolean} render Render the edges.
	   * @api
	   */
	  TileImage.prototype.setRenderReprojectionEdges = function setRenderReprojectionEdges (render) {
	    if (this.renderReprojectionEdges_ == render) {
	      return;
	    }
	    this.renderReprojectionEdges_ = render;
	    for (var id in this.tileCacheForProjection) {
	      this.tileCacheForProjection[id].clear();
	    }
	    this.changed();
	  };
	
	  /**
	   * Sets the tile grid to use when reprojecting the tiles to the given
	   * projection instead of the default tile grid for the projection.
	   *
	   * This can be useful when the default tile grid cannot be created
	   * (e.g. projection has no extent defined) or
	   * for optimization reasons (custom tile size, resolutions, ...).
	   *
	   * @param {import("../proj.js").ProjectionLike} projection Projection.
	   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
	   * @api
	   */
	  TileImage.prototype.setTileGridForProjection = function setTileGridForProjection (projection, tilegrid) {
	    {
	      var proj = get$2(projection);
	      if (proj) {
	        var projKey = getUid(proj);
	        if (!(projKey in this.tileGridForProjection)) {
	          this.tileGridForProjection[projKey] = tilegrid;
	        }
	      }
	    }
	  };
	
	  return TileImage;
	}(UrlTile));
	
	
	/**
	 * @param {ImageTile} imageTile Image tile.
	 * @param {string} src Source.
	 */
	function defaultTileLoadFunction(imageTile, src) {
	  /** @type {HTMLImageElement|HTMLVideoElement} */ (imageTile.getImage()).src = src;
	}
	
	/**
	 * @module ol/source/BingMaps
	 */
	
	
	/**
	 * The attribution containing a link to the Microsoft® Bing™ Maps Platform APIs’
	 * Terms Of Use.
	 * @const
	 * @type {string}
	 */
	var TOS_ATTRIBUTION = '<a class="ol-attribution-bing-tos" ' +
	      'href="https://www.microsoft.com/maps/product/terms.html">' +
	      'Terms of Use</a>';
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {boolean} [hidpi=false] If `true` hidpi tiles will be requested.
	 * @property {string} [culture='en-us'] Culture code.
	 * @property {string} key Bing Maps API key. Get yours at http://www.bingmapsportal.com/.
	 * @property {string} imagerySet Type of imagery.
	 * @property {number} [maxZoom=21] Max zoom. Default is what's advertized by the BingMaps service.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 */
	
	
	/**
	 * @typedef {Object} BingMapsImageryMetadataResponse
	 * @property {number} statusCode The response status code
	 * @property {string} statusDescription The response status description
	 * @property {string} authenticationResultCode The authentication result code
	 * @property {Array<ResourceSet>} resourceSets The array of resource sets
	 */
	
	
	/**
	 * @typedef {Object} ResourceSet
	 * @property {Array<Resource>} resources
	 */
	
	
	/**
	 * @typedef {Object} Resource
	 * @property {number} imageHeight The image height
	 * @property {number} imageWidth The image width
	 * @property {number} zoomMin The minimum zoom level
	 * @property {number} zoomMax The maximum zoom level
	 * @property {string} imageUrl The image URL
	 * @property {Array<string>} imageUrlSubdomains The image URL subdomains for rotation
	 * @property {Array<ImageryProvider>} [imageryProviders] The array of ImageryProviders
	 */
	
	
	/**
	 * @typedef {Object} ImageryProvider
	 * @property {Array<CoverageArea>} coverageAreas The coverage areas
	 * @property {string} [attribution] The attribution
	 */
	
	
	/**
	 * @typedef {Object} CoverageArea
	 * @property {number} zoomMin The minimum zoom
	 * @property {number} zoomMax The maximum zoom
	 * @property {Array<number>} bbox The coverage bounding box
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for Bing Maps tile data.
	 * @api
	 */
	var BingMaps = /*@__PURE__*/(function (TileImage$$1) {
	  function BingMaps(options) {
	
	    var hidpi = options.hidpi !== undefined ? options.hidpi : false;
	
	    TileImage$$1.call(this, {
	      cacheSize: options.cacheSize,
	      crossOrigin: 'anonymous',
	      opaque: true,
	      projection: get$2('EPSG:3857'),
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      state: SourceState.LOADING,
	      tileLoadFunction: options.tileLoadFunction,
	      tilePixelRatio: hidpi ? 2 : 1,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true,
	      transition: options.transition
	    });
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.hidpi_ = hidpi;
	
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.culture_ = options.culture !== undefined ? options.culture : 'en-us';
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxZoom_ = options.maxZoom !== undefined ? options.maxZoom : -1;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.apiKey_ = options.key;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.imagerySet_ = options.imagerySet;
	
	    var url = 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/' +
	        this.imagerySet_ +
	        '?uriScheme=https&include=ImageryProviders&key=' + this.apiKey_ +
	        '&c=' + this.culture_;
	
	    jsonp(url, this.handleImageryMetadataResponse.bind(this), undefined,
	      'jsonp');
	
	  }
	
	  if ( TileImage$$1 ) { BingMaps.__proto__ = TileImage$$1; }
	  BingMaps.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  BingMaps.prototype.constructor = BingMaps;
	
	  /**
	   * Get the api key used for this source.
	   *
	   * @return {string} The api key.
	   * @api
	   */
	  BingMaps.prototype.getApiKey = function getApiKey () {
	    return this.apiKey_;
	  };
	
	  /**
	   * Get the imagery set associated with this source.
	   *
	   * @return {string} The imagery set.
	   * @api
	   */
	  BingMaps.prototype.getImagerySet = function getImagerySet () {
	    return this.imagerySet_;
	  };
	
	  /**
	   * @param {BingMapsImageryMetadataResponse} response Response.
	   */
	  BingMaps.prototype.handleImageryMetadataResponse = function handleImageryMetadataResponse (response) {
	    if (response.statusCode != 200 ||
	        response.statusDescription != 'OK' ||
	        response.authenticationResultCode != 'ValidCredentials' ||
	        response.resourceSets.length != 1 ||
	        response.resourceSets[0].resources.length != 1) {
	      this.setState(SourceState.ERROR);
	      return;
	    }
	
	    var resource = response.resourceSets[0].resources[0];
	    var maxZoom = this.maxZoom_ == -1 ? resource.zoomMax : this.maxZoom_;
	
	    var sourceProjection = this.getProjection();
	    var extent = extentFromProjection(sourceProjection);
	    var scale = this.hidpi_ ? 2 : 1;
	    var tileSize = resource.imageWidth == resource.imageHeight ?
	      resource.imageWidth / scale :
	      [resource.imageWidth / scale, resource.imageHeight / scale];
	
	    var tileGrid = createXYZ({
	      extent: extent,
	      minZoom: resource.zoomMin,
	      maxZoom: maxZoom,
	      tileSize: tileSize
	    });
	    this.tileGrid = tileGrid;
	
	    var culture = this.culture_;
	    var hidpi = this.hidpi_;
	    this.tileUrlFunction = createFromTileUrlFunctions(
	      resource.imageUrlSubdomains.map(function(subdomain) {
	        var quadKeyTileCoord = [0, 0, 0];
	        var imageUrl = resource.imageUrl
	          .replace('{subdomain}', subdomain)
	          .replace('{culture}', culture);
	        return (
	          /**
	           * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	           * @param {number} pixelRatio Pixel ratio.
	           * @param {import("../proj/Projection.js").default} projection Projection.
	           * @return {string|undefined} Tile URL.
	           */
	          function(tileCoord, pixelRatio, projection) {
	            if (!tileCoord) {
	              return undefined;
	            } else {
	              createOrUpdate$2(tileCoord[0], tileCoord[1], -tileCoord[2] - 1, quadKeyTileCoord);
	              var url = imageUrl;
	              if (hidpi) {
	                url += '&dpi=d1&device=mobile';
	              }
	              return url.replace('{quadkey}', quadKey(quadKeyTileCoord));
	            }
	          }
	        );
	      }));
	
	    if (resource.imageryProviders) {
	      var transform$$1 = getTransformFromProjections(
	        get$2('EPSG:4326'), this.getProjection());
	
	      this.setAttributions(function(frameState) {
	        var attributions = [];
	        var viewState = frameState.viewState;
	        var tileGrid = this.getTileGrid();
	        var tileCoord = tileGrid.getTileCoordForCoordAndResolution(viewState.center, viewState.resolution);
	        var zoom = tileCoord[0];
	        resource.imageryProviders.map(function(imageryProvider) {
	          var intersecting = false;
	          var coverageAreas = imageryProvider.coverageAreas;
	          for (var i = 0, ii = coverageAreas.length; i < ii; ++i) {
	            var coverageArea = coverageAreas[i];
	            if (zoom >= coverageArea.zoomMin && zoom <= coverageArea.zoomMax) {
	              var bbox = coverageArea.bbox;
	              var epsg4326Extent = [bbox[1], bbox[0], bbox[3], bbox[2]];
	              var extent = applyTransform(epsg4326Extent, transform$$1);
	              if (intersects(extent, frameState.extent)) {
	                intersecting = true;
	                break;
	              }
	            }
	          }
	          if (intersecting) {
	            attributions.push(imageryProvider.attribution);
	          }
	        });
	
	        attributions.push(TOS_ATTRIBUTION);
	        return attributions;
	      }.bind(this));
	    }
	
	    this.setState(SourceState.READY);
	  };
	
	  return BingMaps;
	}(TileImage));
	
	/**
	 * @module ol/source/XYZ
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {boolean} [opaque=true] Whether the layer is opaque.
	 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {number} [maxZoom=18] Optional max zoom level.
	 * @property {number} [minZoom=0] Optional min zoom level.
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
	 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
	 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
	 * should be set to `2`.
	 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
	 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
	 * tile URL given a tile coordinate and the projection.
	 * Required if url or urls are not provided.
	 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
	 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
	 * may be used instead of defining each one separately in the `urls` option.
	 * @property {Array<string>} [urls] An array of URL templates.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for tile data with URLs in a set XYZ format that are
	 * defined in a URL template. By default, this follows the widely-used
	 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
	 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
	 * using the `{-y}` placeholder in the URL template, so long as the
	 * source does not have a custom tile grid. In this case,
	 * {@link module:ol/source/TileImage} can be used with a `tileUrlFunction`
	 * such as:
	 *
	 *  tileUrlFunction: function(coordinate) {
	 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
	 *        coordinate[1] + '/' + coordinate[2] + '.png';
	 *    }
	 *
	 * @api
	 */
	var XYZ = /*@__PURE__*/(function (TileImage$$1) {
	  function XYZ(opt_options) {
	    var options = opt_options || {};
	    var projection = options.projection !== undefined ?
	      options.projection : 'EPSG:3857';
	
	    var tileGrid = options.tileGrid !== undefined ? options.tileGrid :
	      createXYZ({
	        extent: extentFromProjection(projection),
	        maxZoom: options.maxZoom,
	        minZoom: options.minZoom,
	        tileSize: options.tileSize
	      });
	
	    TileImage$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      opaque: options.opaque,
	      projection: projection,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileGrid: tileGrid,
	      tileLoadFunction: options.tileLoadFunction,
	      tilePixelRatio: options.tilePixelRatio,
	      tileUrlFunction: options.tileUrlFunction,
	      url: options.url,
	      urls: options.urls,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true,
	      transition: options.transition,
	      attributionsCollapsible: options.attributionsCollapsible
	    });
	
	  }
	
	  if ( TileImage$$1 ) { XYZ.__proto__ = TileImage$$1; }
	  XYZ.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  XYZ.prototype.constructor = XYZ;
	
	  return XYZ;
	}(TileImage));
	
	/**
	 * @module ol/source/CartoDB
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
	 * @property {number} [maxZoom=18] Max zoom.
	 * @property {number} [minZoom] Minimum zoom.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * @property {Object} [config] If using anonymous maps, the CartoDB config to use. See
	 * http://docs.cartodb.com/cartodb-platform/maps-api/anonymous-maps/
	 * for more detail.
	 * If using named maps, a key-value lookup with the template parameters.
	 * See http://docs.cartodb.com/cartodb-platform/maps-api/named-maps/
	 * for more detail.
	 * @property {string} [map] If using named maps, this will be the name of the template to load.
	 * See http://docs.cartodb.com/cartodb-platform/maps-api/named-maps/
	 * for more detail.
	 * @property {string} account If using named maps, this will be the name of the template to load.
	 */
	
	
	/**
	 * @typedef {Object} CartoDBLayerInfo
	 * @property {string} layergroupid The layer group ID
	 * @property {{https: string}} cdn_url The CDN URL
	 */
	
	/**
	 * @classdesc
	 * Layer source for the CartoDB Maps API.
	 * @api
	 */
	var CartoDB = /*@__PURE__*/(function (XYZ$$1) {
	  function CartoDB(options) {
	    XYZ$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      maxZoom: options.maxZoom !== undefined ? options.maxZoom : 18,
	      minZoom: options.minZoom,
	      projection: options.projection,
	      wrapX: options.wrapX
	    });
	
	    /**
	     * @type {string}
	     * @private
	     */
	    this.account_ = options.account;
	
	    /**
	     * @type {string}
	     * @private
	     */
	    this.mapId_ = options.map || '';
	
	    /**
	     * @type {!Object}
	     * @private
	     */
	    this.config_ = options.config || {};
	
	    /**
	     * @type {!Object<string, CartoDBLayerInfo>}
	     * @private
	     */
	    this.templateCache_ = {};
	
	    this.initializeMap_();
	  }
	
	  if ( XYZ$$1 ) { CartoDB.__proto__ = XYZ$$1; }
	  CartoDB.prototype = Object.create( XYZ$$1 && XYZ$$1.prototype );
	  CartoDB.prototype.constructor = CartoDB;
	
	  /**
	   * Returns the current config.
	   * @return {!Object} The current configuration.
	   * @api
	   */
	  CartoDB.prototype.getConfig = function getConfig () {
	    return this.config_;
	  };
	
	  /**
	   * Updates the carto db config.
	   * @param {Object} config a key-value lookup. Values will replace current values
	   *     in the config.
	   * @api
	   */
	  CartoDB.prototype.updateConfig = function updateConfig (config) {
	    assign(this.config_, config);
	    this.initializeMap_();
	  };
	
	  /**
	   * Sets the CartoDB config
	   * @param {Object} config In the case of anonymous maps, a CartoDB configuration
	   *     object.
	   * If using named maps, a key-value lookup with the template parameters.
	   * @api
	   */
	  CartoDB.prototype.setConfig = function setConfig (config) {
	    this.config_ = config || {};
	    this.initializeMap_();
	  };
	
	  /**
	   * Issue a request to initialize the CartoDB map.
	   * @private
	   */
	  CartoDB.prototype.initializeMap_ = function initializeMap_ () {
	    var paramHash = JSON.stringify(this.config_);
	    if (this.templateCache_[paramHash]) {
	      this.applyTemplate_(this.templateCache_[paramHash]);
	      return;
	    }
	    var mapUrl = 'https://' + this.account_ + '.carto.com/api/v1/map';
	
	    if (this.mapId_) {
	      mapUrl += '/named/' + this.mapId_;
	    }
	
	    var client = new XMLHttpRequest();
	    client.addEventListener('load', this.handleInitResponse_.bind(this, paramHash));
	    client.addEventListener('error', this.handleInitError_.bind(this));
	    client.open('POST', mapUrl);
	    client.setRequestHeader('Content-type', 'application/json');
	    client.send(JSON.stringify(this.config_));
	  };
	
	  /**
	   * Handle map initialization response.
	   * @param {string} paramHash a hash representing the parameter set that was used
	   *     for the request
	   * @param {Event} event Event.
	   * @private
	   */
	  CartoDB.prototype.handleInitResponse_ = function handleInitResponse_ (paramHash, event) {
	    var client = /** @type {XMLHttpRequest} */ (event.target);
	    // status will be 0 for file:// urls
	    if (!client.status || client.status >= 200 && client.status < 300) {
	      var response;
	      try {
	        response = /** @type {CartoDBLayerInfo} */(JSON.parse(client.responseText));
	      } catch (err) {
	        this.setState(SourceState.ERROR);
	        return;
	      }
	      this.applyTemplate_(response);
	      this.templateCache_[paramHash] = response;
	      this.setState(SourceState.READY);
	    } else {
	      this.setState(SourceState.ERROR);
	    }
	  };
	
	  /**
	   * @private
	   * @param {Event} event Event.
	   */
	  CartoDB.prototype.handleInitError_ = function handleInitError_ (event) {
	    this.setState(SourceState.ERROR);
	  };
	
	  /**
	   * Apply the new tile urls returned by carto db
	   * @param {CartoDBLayerInfo} data Result of carto db call.
	   * @private
	   */
	  CartoDB.prototype.applyTemplate_ = function applyTemplate_ (data) {
	    var tilesUrl = 'https://' + data.cdn_url.https + '/' + this.account_ +
	        '/api/v1/map/' + data.layergroupid + '/{z}/{x}/{y}.png';
	    this.setUrl(tilesUrl);
	  };
	
	  return CartoDB;
	}(XYZ));
	
	/**
	 * @module ol/source/Cluster
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [distance=20] Minimum distance in pixels between clusters.
	 * @property {function(Feature):Point} [geometryFunction]
	 * Function that takes an {@link module:ol/Feature} as argument and returns an
	 * {@link module:ol/geom/Point} as cluster calculation point for the feature. When a
	 * feature should not be considered for clustering, the function should return
	 * `null`. The default, which works when the underyling source contains point
	 * features only, is
	 * ```js
	 * function(feature) {
	 *   return feature.getGeometry();
	 * }
	 * ```
	 * See {@link module:ol/geom/Polygon~Polygon#getInteriorPoint} for a way to get a cluster
	 * calculation point for polygons.
	 * @property {VectorSource} source Source.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source to cluster vector data. Works out of the box with point
	 * geometries. For other geometry types, or if not all geometries should be
	 * considered for clustering, a custom `geometryFunction` can be defined.
	 * @api
	 */
	var Cluster = /*@__PURE__*/(function (VectorSource$$1) {
	  function Cluster(options) {
	    VectorSource$$1.call(this, {
	      attributions: options.attributions,
	      wrapX: options.wrapX
	    });
	
	    /**
	     * @type {number|undefined}
	     * @protected
	     */
	    this.resolution = undefined;
	
	    /**
	     * @type {number}
	     * @protected
	     */
	    this.distance = options.distance !== undefined ? options.distance : 20;
	
	    /**
	     * @type {Array<Feature>}
	     * @protected
	     */
	    this.features = [];
	
	    /**
	     * @param {Feature} feature Feature.
	     * @return {Point} Cluster calculation point.
	     * @protected
	     */
	    this.geometryFunction = options.geometryFunction || function(feature) {
	      var geometry = /** @type {Point} */ (feature.getGeometry());
	      assert(geometry.getType() == GeometryType.POINT,
	        10); // The default `geometryFunction` can only handle `Point` geometries
	      return geometry;
	    };
	
	    /**
	     * @type {VectorSource}
	     * @protected
	     */
	    this.source = options.source;
	
	    listen(this.source, EventType.CHANGE, this.refresh, this);
	  }
	
	  if ( VectorSource$$1 ) { Cluster.__proto__ = VectorSource$$1; }
	  Cluster.prototype = Object.create( VectorSource$$1 && VectorSource$$1.prototype );
	  Cluster.prototype.constructor = Cluster;
	
	  /**
	   * Get the distance in pixels between clusters.
	   * @return {number} Distance.
	   * @api
	   */
	  Cluster.prototype.getDistance = function getDistance () {
	    return this.distance;
	  };
	
	  /**
	   * Get a reference to the wrapped source.
	   * @return {VectorSource} Source.
	   * @api
	   */
	  Cluster.prototype.getSource = function getSource () {
	    return this.source;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Cluster.prototype.loadFeatures = function loadFeatures (extent, resolution, projection) {
	    this.source.loadFeatures(extent, resolution, projection);
	    if (resolution !== this.resolution) {
	      this.clear();
	      this.resolution = resolution;
	      this.cluster();
	      this.addFeatures(this.features);
	    }
	  };
	
	  /**
	   * Set the distance in pixels between clusters.
	   * @param {number} distance The distance in pixels.
	   * @api
	   */
	  Cluster.prototype.setDistance = function setDistance (distance$$1) {
	    this.distance = distance$$1;
	    this.refresh();
	  };
	
	  /**
	   * handle the source changing
	   * @override
	   */
	  Cluster.prototype.refresh = function refresh () {
	    this.clear();
	    this.cluster();
	    this.addFeatures(this.features);
	    VectorSource$$1.prototype.refresh.call(this);
	  };
	
	  /**
	   * @protected
	   */
	  Cluster.prototype.cluster = function cluster () {
	    if (this.resolution === undefined) {
	      return;
	    }
	    this.features.length = 0;
	    var extent = createEmpty();
	    var mapDistance = this.distance * this.resolution;
	    var features = this.source.getFeatures();
	
	    /**
	     * @type {!Object<string, boolean>}
	     */
	    var clustered = {};
	
	    for (var i = 0, ii = features.length; i < ii; i++) {
	      var feature = features[i];
	      if (!(getUid(feature) in clustered)) {
	        var geometry = this.geometryFunction(feature);
	        if (geometry) {
	          var coordinates = geometry.getCoordinates();
	          createOrUpdateFromCoordinate(coordinates, extent);
	          buffer(extent, mapDistance, extent);
	
	          var neighbors = this.source.getFeaturesInExtent(extent);
	          neighbors = neighbors.filter(function(neighbor) {
	            var uid = getUid(neighbor);
	            if (!(uid in clustered)) {
	              clustered[uid] = true;
	              return true;
	            } else {
	              return false;
	            }
	          });
	          this.features.push(this.createCluster(neighbors));
	        }
	      }
	    }
	  };
	
	  /**
	   * @param {Array<Feature>} features Features
	   * @return {Feature} The cluster feature.
	   * @protected
	   */
	  Cluster.prototype.createCluster = function createCluster (features) {
	    var centroid = [0, 0];
	    for (var i = features.length - 1; i >= 0; --i) {
	      var geometry = this.geometryFunction(features[i]);
	      if (geometry) {
	        add$2(centroid, geometry.getCoordinates());
	      } else {
	        features.splice(i, 1);
	      }
	    }
	    scale$2(centroid, 1 / features.length);
	
	    var cluster = new Feature(new Point(centroid));
	    cluster.set('features', features);
	    return cluster;
	  };
	
	  return Cluster;
	}(VectorSource));
	
	/**
	 * @module ol/reproj/Image
	 */
	
	
	/**
	 * @typedef {function(import("../extent.js").Extent, number, number) : import("../ImageBase.js").default} FunctionType
	 */
	
	
	/**
	 * @classdesc
	 * Class encapsulating single reprojected image.
	 * See {@link module:ol/source/Image~ImageSource}.
	 */
	var ReprojImage = /*@__PURE__*/(function (ImageBase$$1) {
	  function ReprojImage(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction) {
	    var maxSourceExtent = sourceProj.getExtent();
	    var maxTargetExtent = targetProj.getExtent();
	
	    var limitedTargetExtent = maxTargetExtent ?
	      getIntersection(targetExtent, maxTargetExtent) : targetExtent;
	
	    var targetCenter = getCenter(limitedTargetExtent);
	    var sourceResolution = calculateSourceResolution(
	      sourceProj, targetProj, targetCenter, targetResolution);
	
	    var errorThresholdInPixels = ERROR_THRESHOLD;
	
	    var triangulation = new Triangulation(
	      sourceProj, targetProj, limitedTargetExtent, maxSourceExtent,
	      sourceResolution * errorThresholdInPixels);
	
	    var sourceExtent = triangulation.calculateSourceExtent();
	    var sourceImage = getImageFunction(sourceExtent, sourceResolution, pixelRatio);
	    var state = ImageState.LOADED;
	    if (sourceImage) {
	      state = ImageState.IDLE;
	    }
	    var sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
	
	    ImageBase$$1.call(this, targetExtent, targetResolution, sourcePixelRatio, state);
	
	    /**
	     * @private
	     * @type {import("../proj/Projection.js").default}
	     */
	    this.targetProj_ = targetProj;
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.maxSourceExtent_ = maxSourceExtent;
	
	    /**
	     * @private
	     * @type {!import("./Triangulation.js").default}
	     */
	    this.triangulation_ = triangulation;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.targetResolution_ = targetResolution;
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.targetExtent_ = targetExtent;
	
	    /**
	     * @private
	     * @type {import("../ImageBase.js").default}
	     */
	    this.sourceImage_ = sourceImage;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.sourcePixelRatio_ = sourcePixelRatio;
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement}
	     */
	    this.canvas_ = null;
	
	    /**
	     * @private
	     * @type {?import("../events.js").EventsKey}
	     */
	    this.sourceListenerKey_ = null;
	  }
	
	  if ( ImageBase$$1 ) { ReprojImage.__proto__ = ImageBase$$1; }
	  ReprojImage.prototype = Object.create( ImageBase$$1 && ImageBase$$1.prototype );
	  ReprojImage.prototype.constructor = ReprojImage;
	
	  /**
	   * @inheritDoc
	   */
	  ReprojImage.prototype.disposeInternal = function disposeInternal () {
	    if (this.state == ImageState.LOADING) {
	      this.unlistenSource_();
	    }
	    ImageBase$$1.prototype.disposeInternal.call(this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ReprojImage.prototype.getImage = function getImage () {
	    return this.canvas_;
	  };
	
	  /**
	   * @return {import("../proj/Projection.js").default} Projection.
	   */
	  ReprojImage.prototype.getProjection = function getProjection () {
	    return this.targetProj_;
	  };
	
	  /**
	   * @private
	   */
	  ReprojImage.prototype.reproject_ = function reproject_ () {
	    var sourceState = this.sourceImage_.getState();
	    if (sourceState == ImageState.LOADED) {
	      var width = getWidth(this.targetExtent_) / this.targetResolution_;
	      var height = getHeight(this.targetExtent_) / this.targetResolution_;
	
	      this.canvas_ = render$6(width, height, this.sourcePixelRatio_,
	        this.sourceImage_.getResolution(), this.maxSourceExtent_,
	        this.targetResolution_, this.targetExtent_, this.triangulation_, [{
	          extent: this.sourceImage_.getExtent(),
	          image: this.sourceImage_.getImage()
	        }], 0);
	    }
	    this.state = sourceState;
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ReprojImage.prototype.load = function load () {
	    if (this.state == ImageState.IDLE) {
	      this.state = ImageState.LOADING;
	      this.changed();
	
	      var sourceState = this.sourceImage_.getState();
	      if (sourceState == ImageState.LOADED || sourceState == ImageState.ERROR) {
	        this.reproject_();
	      } else {
	        this.sourceListenerKey_ = listen(this.sourceImage_,
	          EventType.CHANGE, function(e) {
	            var sourceState = this.sourceImage_.getState();
	            if (sourceState == ImageState.LOADED || sourceState == ImageState.ERROR) {
	              this.unlistenSource_();
	              this.reproject_();
	            }
	          }, this);
	        this.sourceImage_.load();
	      }
	    }
	  };
	
	  /**
	   * @private
	   */
	  ReprojImage.prototype.unlistenSource_ = function unlistenSource_ () {
	    unlistenByKey(/** @type {!import("../events.js").EventsKey} */ (this.sourceListenerKey_));
	    this.sourceListenerKey_ = null;
	  };
	
	  return ReprojImage;
	}(ImageBase));
	
	/**
	 * @module ol/source/Image
	 */
	
	
	/**
	 * @enum {string}
	 */
	var ImageSourceEventType = {
	
	  /**
	   * Triggered when an image starts loading.
	   * @event ol/source/Image~ImageSourceEvent#imageloadstart
	   * @api
	   */
	  IMAGELOADSTART: 'imageloadstart',
	
	  /**
	   * Triggered when an image finishes loading.
	   * @event ol/source/Image~ImageSourceEvent#imageloadend
	   * @api
	   */
	  IMAGELOADEND: 'imageloadend',
	
	  /**
	   * Triggered if image loading results in an error.
	   * @event ol/source/Image~ImageSourceEvent#imageloaderror
	   * @api
	   */
	  IMAGELOADERROR: 'imageloaderror'
	
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/source/Image~ImageSource} instances are instances of this
	 * type.
	 */
	var ImageSourceEvent = /*@__PURE__*/(function (Event$$1) {
	  function ImageSourceEvent(type, image) {
	
	    Event$$1.call(this, type);
	
	    /**
	     * The image related to the event.
	     * @type {import("../Image.js").default}
	     * @api
	     */
	    this.image = image;
	
	  }
	
	  if ( Event$$1 ) { ImageSourceEvent.__proto__ = Event$$1; }
	  ImageSourceEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  ImageSourceEvent.prototype.constructor = ImageSourceEvent;
	
	  return ImageSourceEvent;
	}(Event));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions]
	 * @property {import("../proj.js").ProjectionLike} projection
	 * @property {Array<number>} [resolutions]
	 * @property {import("./State.js").default} [state]
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for sources providing a single image.
	 * @abstract
	 * @api
	 */
	var ImageSource = /*@__PURE__*/(function (Source$$1) {
	  function ImageSource(options) {
	    Source$$1.call(this, {
	      attributions: options.attributions,
	      projection: options.projection,
	      state: options.state
	    });
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.resolutions_ = options.resolutions !== undefined ?
	      options.resolutions : null;
	
	
	    /**
	     * @private
	     * @type {import("../reproj/Image.js").default}
	     */
	    this.reprojectedImage_ = null;
	
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.reprojectedRevision_ = 0;
	  }
	
	  if ( Source$$1 ) { ImageSource.__proto__ = Source$$1; }
	  ImageSource.prototype = Object.create( Source$$1 && Source$$1.prototype );
	  ImageSource.prototype.constructor = ImageSource;
	
	  /**
	   * @return {Array<number>} Resolutions.
	   * @override
	   */
	  ImageSource.prototype.getResolutions = function getResolutions () {
	    return this.resolutions_;
	  };
	
	  /**
	   * @protected
	   * @param {number} resolution Resolution.
	   * @return {number} Resolution.
	   */
	  ImageSource.prototype.findNearestResolution = function findNearestResolution (resolution) {
	    if (this.resolutions_) {
	      var idx = linearFindNearest(this.resolutions_, resolution, 0);
	      resolution = this.resolutions_[idx];
	    }
	    return resolution;
	  };
	
	  /**
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {number} resolution Resolution.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {import("../ImageBase.js").default} Single image.
	   */
	  ImageSource.prototype.getImage = function getImage (extent, resolution, pixelRatio, projection) {
	    var sourceProjection = this.getProjection();
	    if (!sourceProjection ||
	        !projection ||
	        equivalent(sourceProjection, projection)) {
	      if (sourceProjection) {
	        projection = sourceProjection;
	      }
	      return this.getImageInternal(extent, resolution, pixelRatio, projection);
	    } else {
	      if (this.reprojectedImage_) {
	        if (this.reprojectedRevision_ == this.getRevision() &&
	            equivalent(
	              this.reprojectedImage_.getProjection(), projection) &&
	            this.reprojectedImage_.getResolution() == resolution &&
	            equals$1(this.reprojectedImage_.getExtent(), extent)) {
	          return this.reprojectedImage_;
	        }
	        this.reprojectedImage_.dispose();
	        this.reprojectedImage_ = null;
	      }
	
	      this.reprojectedImage_ = new ReprojImage(
	        sourceProjection, projection, extent, resolution, pixelRatio,
	        function(extent, resolution, pixelRatio) {
	          return this.getImageInternal(extent, resolution,
	            pixelRatio, sourceProjection);
	        }.bind(this));
	      this.reprojectedRevision_ = this.getRevision();
	
	      return this.reprojectedImage_;
	    }
	  };
	
	  /**
	   * @abstract
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {number} resolution Resolution.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {import("../ImageBase.js").default} Single image.
	   * @protected
	   */
	  ImageSource.prototype.getImageInternal = function getImageInternal (extent, resolution, pixelRatio, projection) {
	    return abstract();
	  };
	
	  /**
	   * Handle image change events.
	   * @param {import("../events/Event.js").default} event Event.
	   * @protected
	   */
	  ImageSource.prototype.handleImageChange = function handleImageChange (event) {
	    var image = /** @type {import("../Image.js").default} */ (event.target);
	    switch (image.getState()) {
	      case ImageState.LOADING:
	        this.loading = true;
	        this.dispatchEvent(
	          new ImageSourceEvent(ImageSourceEventType.IMAGELOADSTART,
	            image));
	        break;
	      case ImageState.LOADED:
	        this.loading = false;
	        this.dispatchEvent(
	          new ImageSourceEvent(ImageSourceEventType.IMAGELOADEND,
	            image));
	        break;
	      case ImageState.ERROR:
	        this.loading = false;
	        this.dispatchEvent(
	          new ImageSourceEvent(ImageSourceEventType.IMAGELOADERROR,
	            image));
	        break;
	      default:
	        // pass
	    }
	  };
	
	  return ImageSource;
	}(Source));
	
	
	/**
	 * Default image load function for image sources that use import("../Image.js").Image image
	 * instances.
	 * @param {import("../Image.js").default} image Image.
	 * @param {string} src Source.
	 */
	function defaultImageLoadFunction(image, src) {
	  /** @type {HTMLImageElement|HTMLVideoElement} */ (image.getImage()).src = src;
	}
	
	/**
	 * @module ol/source/ImageArcGISRest
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * {@link https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image} for more detail.
	 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting the image from
	 * the remote server.
	 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given
	 * a URL.
	 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service
	 * defaults will be used for any fields not specified. `FORMAT` is `PNG32` by default. `F` is
	 * `IMAGE` by default. `TRANSPARENT` is `true` by default.  `BBOX`, `SIZE`, `BBOXSR`, and `IMAGESR`
	 * will be set dynamically. Set `LAYERS` to override the default service layer visibility. See
	 * {@link http://resources.arcgis.com/en/help/arcgis-rest-api/index.html#/Export_Map/02r3000000v7000000/}
	 * for further reference.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport,
	 * `2` means twice the size of the map viewport, and so on.
	 * @property {Array<number>} [resolutions] Resolutions. If specified, requests will be made for
	 * these resolutions only.
	 * @property {string} [url] ArcGIS Rest service URL for a Map Service or Image Service. The url
	 * should include /MapServer or /ImageServer.
	 */
	
	
	/**
	 * @classdesc
	 * Source for data from ArcGIS Rest services providing single, untiled images.
	 * Useful when underlying map service has labels.
	 *
	 * If underlying map service is not using labels,
	 * take advantage of ol image caching and use
	 * {@link module:ol/source/TileArcGISRest} data source.
	 *
	 * @fires ol/source/Image~ImageSourceEvent
	 * @api
	 */
	var ImageArcGISRest = /*@__PURE__*/(function (ImageSource$$1) {
	  function ImageArcGISRest(opt_options) {
	
	    var options = opt_options || /** @type {Options} */ ({});
	
	    ImageSource$$1.call(this, {
	      attributions: options.attributions,
	      projection: options.projection,
	      resolutions: options.resolutions
	    });
	
	    /**
	     * @private
	     * @type {?string}
	     */
	    this.crossOrigin_ =
	        options.crossOrigin !== undefined ? options.crossOrigin : null;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.url_ = options.url;
	
	    /**
	     * @private
	     * @type {import("../Image.js").LoadFunction}
	     */
	    this.imageLoadFunction_ = options.imageLoadFunction !== undefined ?
	      options.imageLoadFunction : defaultImageLoadFunction;
	
	
	    /**
	     * @private
	     * @type {!Object}
	     */
	    this.params_ = options.params || {};
	
	    /**
	     * @private
	     * @type {import("../Image.js").default}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.imageSize_ = [0, 0];
	
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedRevision_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
	
	  }
	
	  if ( ImageSource$$1 ) { ImageArcGISRest.__proto__ = ImageSource$$1; }
	  ImageArcGISRest.prototype = Object.create( ImageSource$$1 && ImageSource$$1.prototype );
	  ImageArcGISRest.prototype.constructor = ImageArcGISRest;
	
	  /**
	   * Get the user-provided params, i.e. those passed to the constructor through
	   * the "params" option, and possibly updated using the updateParams method.
	   * @return {Object} Params.
	   * @api
	   */
	  ImageArcGISRest.prototype.getParams = function getParams () {
	    return this.params_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ImageArcGISRest.prototype.getImageInternal = function getImageInternal (extent, resolution, pixelRatio, projection) {
	
	    if (this.url_ === undefined) {
	      return null;
	    }
	
	    resolution = this.findNearestResolution(resolution);
	    pixelRatio = this.hidpi_ ? pixelRatio : 1;
	
	    var image = this.image_;
	    if (image &&
	        this.renderedRevision_ == this.getRevision() &&
	        image.getResolution() == resolution &&
	        image.getPixelRatio() == pixelRatio &&
	        containsExtent(image.getExtent(), extent)) {
	      return image;
	    }
	
	    var params = {
	      'F': 'image',
	      'FORMAT': 'PNG32',
	      'TRANSPARENT': true
	    };
	    assign(params, this.params_);
	
	    extent = extent.slice();
	    var centerX = (extent[0] + extent[2]) / 2;
	    var centerY = (extent[1] + extent[3]) / 2;
	    if (this.ratio_ != 1) {
	      var halfWidth = this.ratio_ * getWidth(extent) / 2;
	      var halfHeight = this.ratio_ * getHeight(extent) / 2;
	      extent[0] = centerX - halfWidth;
	      extent[1] = centerY - halfHeight;
	      extent[2] = centerX + halfWidth;
	      extent[3] = centerY + halfHeight;
	    }
	
	    var imageResolution = resolution / pixelRatio;
	
	    // Compute an integer width and height.
	    var width = Math.ceil(getWidth(extent) / imageResolution);
	    var height = Math.ceil(getHeight(extent) / imageResolution);
	
	    // Modify the extent to match the integer width and height.
	    extent[0] = centerX - imageResolution * width / 2;
	    extent[2] = centerX + imageResolution * width / 2;
	    extent[1] = centerY - imageResolution * height / 2;
	    extent[3] = centerY + imageResolution * height / 2;
	
	    this.imageSize_[0] = width;
	    this.imageSize_[1] = height;
	
	    var url = this.getRequestUrl_(extent, this.imageSize_, pixelRatio,
	      projection, params);
	
	    this.image_ = new ImageWrapper(extent, resolution, pixelRatio,
	      url, this.crossOrigin_, this.imageLoadFunction_);
	
	    this.renderedRevision_ = this.getRevision();
	
	    listen(this.image_, EventType.CHANGE,
	      this.handleImageChange, this);
	
	    return this.image_;
	
	  };
	
	  /**
	   * Return the image load function of the source.
	   * @return {import("../Image.js").LoadFunction} The image load function.
	   * @api
	   */
	  ImageArcGISRest.prototype.getImageLoadFunction = function getImageLoadFunction () {
	    return this.imageLoadFunction_;
	  };
	
	  /**
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {import("../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {Object} params Params.
	   * @return {string} Request URL.
	   * @private
	   */
	  ImageArcGISRest.prototype.getRequestUrl_ = function getRequestUrl_ (extent, size, pixelRatio, projection, params) {
	    // ArcGIS Server only wants the numeric portion of the projection ID.
	    var srid = projection.getCode().split(':').pop();
	
	    params['SIZE'] = size[0] + ',' + size[1];
	    params['BBOX'] = extent.join(',');
	    params['BBOXSR'] = srid;
	    params['IMAGESR'] = srid;
	    params['DPI'] = Math.round(90 * pixelRatio);
	
	    var url = this.url_;
	
	    var modifiedUrl = url
	      .replace(/MapServer\/?$/, 'MapServer/export')
	      .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
	    if (modifiedUrl == url) {
	      assert(false, 50); // `options.featureTypes` should be an Array
	    }
	    return appendParams(modifiedUrl, params);
	  };
	
	  /**
	   * Return the URL used for this ArcGIS source.
	   * @return {string|undefined} URL.
	   * @api
	   */
	  ImageArcGISRest.prototype.getUrl = function getUrl () {
	    return this.url_;
	  };
	
	  /**
	   * Set the image load function of the source.
	   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
	   * @api
	   */
	  ImageArcGISRest.prototype.setImageLoadFunction = function setImageLoadFunction (imageLoadFunction) {
	    this.image_ = null;
	    this.imageLoadFunction_ = imageLoadFunction;
	    this.changed();
	  };
	
	  /**
	   * Set the URL to use for requests.
	   * @param {string|undefined} url URL.
	   * @api
	   */
	  ImageArcGISRest.prototype.setUrl = function setUrl (url) {
	    if (url != this.url_) {
	      this.url_ = url;
	      this.image_ = null;
	      this.changed();
	    }
	  };
	
	  /**
	   * Update the user-provided params.
	   * @param {Object} params Params.
	   * @api
	   */
	  ImageArcGISRest.prototype.updateParams = function updateParams (params) {
	    assign(this.params_, params);
	    this.image_ = null;
	    this.changed();
	  };
	
	  return ImageArcGISRest;
	}(ImageSource));
	
	/**
	 * @module ol/source/ImageCanvas
	 */
	
	
	/**
	 * A function returning the canvas element (`{HTMLCanvasElement}`)
	 * used by the source as an image. The arguments passed to the function are:
	 * {@link module:ol/extent~Extent} the image extent, `{number}` the image resolution,
	 * `{number}` the device pixel ratio, {@link module:ol/size~Size} the image size, and
	 * {@link module:ol/proj/Projection} the image projection. The canvas returned by
	 * this function is cached by the source. The this keyword inside the function
	 * references the {@link module:ol/source/ImageCanvas}.
	 *
	 * @typedef {function(this:import("../ImageCanvas.js").default, import("../extent.js").Extent, number,
	 *     number, import("../size.js").Size, import("../proj/Projection.js").default): HTMLCanvasElement} FunctionType
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {FunctionType} [canvasFunction] Canvas function.
	 * The function returning the canvas element used by the source
	 * as an image. The arguments passed to the function are: `{import("../extent.js").Extent}` the
	 * image extent, `{number}` the image resolution, `{number}` the device pixel
	 * ratio, `{import("../size.js").Size}` the image size, and `{import("../proj/Projection.js").Projection}` the image
	 * projection. The canvas returned by this function is cached by the source. If
	 * the value returned by the function is later changed then
	 * `changed` should be called on the source for the source to
	 * invalidate the current cached image. See: {@link module:ol/Observable~Observable#changed}
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [ratio=1.5] Ratio. 1 means canvases are the size of the map viewport, 2 means twice the
	 * width and height of the map viewport, and so on. Must be `1` or higher.
	 * @property {Array<number>} [resolutions] Resolutions.
	 * If specified, new canvases will be created for these resolutions
	 * @property {import("./State.js").default} [state] Source state.
	 */
	
	
	/**
	 * @classdesc
	 * Base class for image sources where a canvas element is the image.
	 * @api
	 */
	var ImageCanvasSource = /*@__PURE__*/(function (ImageSource$$1) {
	  function ImageCanvasSource(opt_options) {
	
	    var options = opt_options || /** @type {Options} */ ({});
	
	    ImageSource$$1.call(this, {
	      attributions: options.attributions,
	      projection: options.projection,
	      resolutions: options.resolutions,
	      state: options.state
	    });
	
	    /**
	    * @private
	    * @type {FunctionType}
	    */
	    this.canvasFunction_ = options.canvasFunction;
	
	    /**
	    * @private
	    * @type {import("../ImageCanvas.js").default}
	    */
	    this.canvas_ = null;
	
	    /**
	    * @private
	    * @type {number}
	    */
	    this.renderedRevision_ = 0;
	
	    /**
	    * @private
	    * @type {number}
	    */
	    this.ratio_ = options.ratio !== undefined ?
	      options.ratio : 1.5;
	
	  }
	
	  if ( ImageSource$$1 ) { ImageCanvasSource.__proto__ = ImageSource$$1; }
	  ImageCanvasSource.prototype = Object.create( ImageSource$$1 && ImageSource$$1.prototype );
	  ImageCanvasSource.prototype.constructor = ImageCanvasSource;
	
	  /**
	  * @inheritDoc
	  */
	  ImageCanvasSource.prototype.getImageInternal = function getImageInternal (extent, resolution, pixelRatio, projection) {
	    resolution = this.findNearestResolution(resolution);
	
	    var canvas = this.canvas_;
	    if (canvas &&
	       this.renderedRevision_ == this.getRevision() &&
	       canvas.getResolution() == resolution &&
	       canvas.getPixelRatio() == pixelRatio &&
	       containsExtent(canvas.getExtent(), extent)) {
	      return canvas;
	    }
	
	    extent = extent.slice();
	    scaleFromCenter(extent, this.ratio_);
	    var width = getWidth(extent) / resolution;
	    var height = getHeight(extent) / resolution;
	    var size = [width * pixelRatio, height * pixelRatio];
	
	    var canvasElement = this.canvasFunction_.call(
	      this, extent, resolution, pixelRatio, size, projection);
	    if (canvasElement) {
	      canvas = new ImageCanvas(extent, resolution, pixelRatio, canvasElement);
	    }
	    this.canvas_ = canvas;
	    this.renderedRevision_ = this.getRevision();
	
	    return canvas;
	  };
	
	  return ImageCanvasSource;
	}(ImageSource));
	
	/**
	 * @module ol/source/ImageMapGuide
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [url] The mapagent url.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {number} [displayDpi=96] The display resolution.
	 * @property {number} [metersPerUnit=1] The meters-per-unit value.
	 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
	 * the image from the remote server.
	 * @property {boolean} [useOverlay] If `true`, will use `GETDYNAMICMAPOVERLAYIMAGE`.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [ratio=1] Ratio. `1` means image requests are the size of the map viewport, `2` means
	 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
	 * @property {Array<number>} [resolutions] Resolutions.
	 * If specified, requests will be made for these resolutions only.
	 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
	 * @property {Object} [params] Additional parameters.
	 */
	
	
	/**
	 * @classdesc
	 * Source for images from Mapguide servers
	 *
	 * @fires ol/source/Image~ImageSourceEvent
	 * @api
	 */
	var ImageMapGuide = /*@__PURE__*/(function (ImageSource$$1) {
	  function ImageMapGuide(options) {
	
	    ImageSource$$1.call(this, {
	      projection: options.projection,
	      resolutions: options.resolutions
	    });
	
	    /**
	     * @private
	     * @type {?string}
	     */
	    this.crossOrigin_ =
	        options.crossOrigin !== undefined ? options.crossOrigin : null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.displayDpi_ = options.displayDpi !== undefined ?
	      options.displayDpi : 96;
	
	    /**
	     * @private
	     * @type {!Object}
	     */
	    this.params_ = options.params || {};
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.url_ = options.url;
	
	    /**
	     * @private
	     * @type {import("../Image.js").LoadFunction}
	     */
	    this.imageLoadFunction_ = options.imageLoadFunction !== undefined ?
	      options.imageLoadFunction : defaultImageLoadFunction;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.metersPerUnit_ = options.metersPerUnit !== undefined ?
	      options.metersPerUnit : 1;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.ratio_ = options.ratio !== undefined ? options.ratio : 1;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.useOverlay_ = options.useOverlay !== undefined ?
	      options.useOverlay : false;
	
	    /**
	     * @private
	     * @type {import("../Image.js").default}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedRevision_ = 0;
	
	  }
	
	  if ( ImageSource$$1 ) { ImageMapGuide.__proto__ = ImageSource$$1; }
	  ImageMapGuide.prototype = Object.create( ImageSource$$1 && ImageSource$$1.prototype );
	  ImageMapGuide.prototype.constructor = ImageMapGuide;
	
	  /**
	   * Get the user-provided params, i.e. those passed to the constructor through
	   * the "params" option, and possibly updated using the updateParams method.
	   * @return {Object} Params.
	   * @api
	   */
	  ImageMapGuide.prototype.getParams = function getParams () {
	    return this.params_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ImageMapGuide.prototype.getImageInternal = function getImageInternal (extent, resolution, pixelRatio, projection) {
	    resolution = this.findNearestResolution(resolution);
	    pixelRatio = this.hidpi_ ? pixelRatio : 1;
	
	    var image = this.image_;
	    if (image &&
	        this.renderedRevision_ == this.getRevision() &&
	        image.getResolution() == resolution &&
	        image.getPixelRatio() == pixelRatio &&
	        containsExtent(image.getExtent(), extent)) {
	      return image;
	    }
	
	    if (this.ratio_ != 1) {
	      extent = extent.slice();
	      scaleFromCenter(extent, this.ratio_);
	    }
	    var width = getWidth(extent) / resolution;
	    var height = getHeight(extent) / resolution;
	    var size = [width * pixelRatio, height * pixelRatio];
	
	    if (this.url_ !== undefined) {
	      var imageUrl = this.getUrl(this.url_, this.params_, extent, size,
	        projection);
	      image = new ImageWrapper(extent, resolution, pixelRatio,
	        imageUrl, this.crossOrigin_,
	        this.imageLoadFunction_);
	      listen(image, EventType.CHANGE,
	        this.handleImageChange, this);
	    } else {
	      image = null;
	    }
	    this.image_ = image;
	    this.renderedRevision_ = this.getRevision();
	
	    return image;
	  };
	
	  /**
	   * Return the image load function of the source.
	   * @return {import("../Image.js").LoadFunction} The image load function.
	   * @api
	   */
	  ImageMapGuide.prototype.getImageLoadFunction = function getImageLoadFunction () {
	    return this.imageLoadFunction_;
	  };
	
	  /**
	   * Update the user-provided params.
	   * @param {Object} params Params.
	   * @api
	   */
	  ImageMapGuide.prototype.updateParams = function updateParams (params) {
	    assign(this.params_, params);
	    this.changed();
	  };
	
	  /**
	   * @param {string} baseUrl The mapagent url.
	   * @param {Object<string, string|number>} params Request parameters.
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {import("../size.js").Size} size Size.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @return {string} The mapagent map image request URL.
	   */
	  ImageMapGuide.prototype.getUrl = function getUrl (baseUrl, params, extent, size, projection) {
	    var scale = getScale(extent, size,
	      this.metersPerUnit_, this.displayDpi_);
	    var center = getCenter(extent);
	    var baseParams = {
	      'OPERATION': this.useOverlay_ ? 'GETDYNAMICMAPOVERLAYIMAGE' : 'GETMAPIMAGE',
	      'VERSION': '2.0.0',
	      'LOCALE': 'en',
	      'CLIENTAGENT': 'ol/source/ImageMapGuide source',
	      'CLIP': '1',
	      'SETDISPLAYDPI': this.displayDpi_,
	      'SETDISPLAYWIDTH': Math.round(size[0]),
	      'SETDISPLAYHEIGHT': Math.round(size[1]),
	      'SETVIEWSCALE': scale,
	      'SETVIEWCENTERX': center[0],
	      'SETVIEWCENTERY': center[1]
	    };
	    assign(baseParams, params);
	    return appendParams(baseUrl, baseParams);
	  };
	
	  /**
	   * Set the image load function of the MapGuide source.
	   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
	   * @api
	   */
	  ImageMapGuide.prototype.setImageLoadFunction = function setImageLoadFunction (imageLoadFunction) {
	    this.image_ = null;
	    this.imageLoadFunction_ = imageLoadFunction;
	    this.changed();
	  };
	
	  return ImageMapGuide;
	}(ImageSource));
	
	
	/**
	 * @param {import("../extent.js").Extent} extent The map extents.
	 * @param {import("../size.js").Size} size The viewport size.
	 * @param {number} metersPerUnit The meters-per-unit value.
	 * @param {number} dpi The display resolution.
	 * @return {number} The computed map scale.
	 */
	function getScale(extent, size, metersPerUnit, dpi) {
	  var mcsW = getWidth(extent);
	  var mcsH = getHeight(extent);
	  var devW = size[0];
	  var devH = size[1];
	  var mpp = 0.0254 / dpi;
	  if (devH * mcsW > devW * mcsH) {
	    return mcsW * metersPerUnit / (devW * mpp); // width limited
	  } else {
	    return mcsH * metersPerUnit / (devH * mpp); // height limited
	  }
	}
	
	/**
	 * @module ol/source/ImageStatic
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {import("../extent.js").Extent} [imageExtent] Extent of the image in map coordinates.
	 * This is the [left, bottom, right, top] map coordinates of your image.
	 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {import("../size.js").Size} [imageSize] Size of the image in pixels. Usually the image size is auto-detected, so this
	 * only needs to be set if auto-detection fails for some reason.
	 * @property {string} url Image URL.
	 */
	
	
	/**
	 * @classdesc
	 * A layer source for displaying a single, static image.
	 * @api
	 */
	var Static = /*@__PURE__*/(function (ImageSource$$1) {
	  function Static(options) {
	    var crossOrigin = options.crossOrigin !== undefined ?
	      options.crossOrigin : null;
	
	    var /** @type {import("../Image.js").LoadFunction} */ imageLoadFunction =
	        options.imageLoadFunction !== undefined ?
	          options.imageLoadFunction : defaultImageLoadFunction;
	
	    ImageSource$$1.call(this, {
	      attributions: options.attributions,
	      projection: get$2(options.projection)
	    });
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.url_ = options.url;
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.imageExtent_ = options.imageExtent;
	
	    /**
	     * @private
	     * @type {import("../Image.js").default}
	     */
	    this.image_ = new ImageWrapper(this.imageExtent_, undefined, 1, this.url_, crossOrigin, imageLoadFunction);
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.imageSize_ = options.imageSize ? options.imageSize : null;
	
	    listen(this.image_, EventType.CHANGE,
	      this.handleImageChange, this);
	
	  }
	
	  if ( ImageSource$$1 ) { Static.__proto__ = ImageSource$$1; }
	  Static.prototype = Object.create( ImageSource$$1 && ImageSource$$1.prototype );
	  Static.prototype.constructor = Static;
	
	  /**
	   * Returns the image extent
	   * @return {import("../extent.js").Extent} image extent.
	   * @api
	   */
	  Static.prototype.getImageExtent = function getImageExtent () {
	    return this.imageExtent_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Static.prototype.getImageInternal = function getImageInternal (extent, resolution, pixelRatio, projection) {
	    if (intersects(extent, this.image_.getExtent())) {
	      return this.image_;
	    }
	    return null;
	  };
	
	  /**
	   * Return the URL used for this image source.
	   * @return {string} URL.
	   * @api
	   */
	  Static.prototype.getUrl = function getUrl () {
	    return this.url_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Static.prototype.handleImageChange = function handleImageChange (evt) {
	    if (this.image_.getState() == ImageState.LOADED) {
	      var imageExtent = this.image_.getExtent();
	      var image = this.image_.getImage();
	      var imageWidth, imageHeight;
	      if (this.imageSize_) {
	        imageWidth = this.imageSize_[0];
	        imageHeight = this.imageSize_[1];
	      } else {
	        imageWidth = image.width;
	        imageHeight = image.height;
	      }
	      var resolution = getHeight(imageExtent) / imageHeight;
	      var targetWidth = Math.ceil(getWidth(imageExtent) / resolution);
	      if (targetWidth != imageWidth) {
	        var context = createCanvasContext2D(targetWidth, imageHeight);
	        var canvas = context.canvas;
	        context.drawImage(image, 0, 0, imageWidth, imageHeight,
	          0, 0, canvas.width, canvas.height);
	        this.image_.setImage(canvas);
	      }
	    }
	    ImageSource$$1.prototype.handleImageChange.call(this, evt);
	  };
	
	  return Static;
	}(ImageSource));
	
	/**
	 * @module ol/source/common
	 */
	
	/**
	 * Default WMS version.
	 * @type {string}
	 */
	var DEFAULT_WMS_VERSION = '1.3.0';
	
	/**
	 * @module ol/source/WMSServerType
	 */
	
	/**
	 * Available server types: `'carmentaserver'`, `'geoserver'`, `'mapserver'`,
	 *     `'qgis'`. These are servers that have vendor parameters beyond the WMS
	 *     specification that OpenLayers can make use of.
	 * @enum {string}
	 */
	var WMSServerType = {
	  CARMENTA_SERVER: 'carmentaserver',
	  GEOSERVER: 'geoserver',
	  MAPSERVER: 'mapserver',
	  QGIS: 'qgis'
	};
	
	/**
	 * @module ol/source/ImageWMS
	 */
	
	
	/**
	 * @const
	 * @type {import("../size.js").Size}
	 */
	var GETFEATUREINFO_IMAGE_SIZE = [101, 101];
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
	 * the image from the remote server.
	 * @property {import("./WMSServerType.js").default|string} [serverType] The type of
	 * the remote WMS server: `mapserver`, `geoserver` or `qgis`. Only needed if `hidpi` is `true`.
	 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
	 * @property {Object<string,*>} params WMS request parameters.
	 * At least a `LAYERS` param is required. `STYLES` is
	 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
	 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
	 * twice the width and height of the map viewport, and so on. Must be `1` or
	 * higher.
	 * @property {Array<number>} [resolutions] Resolutions.
	 * If specified, requests will be made for these resolutions only.
	 * @property {string} url WMS service URL.
	 */
	
	
	/**
	 * @classdesc
	 * Source for WMS servers providing single, untiled images.
	 *
	 * @fires ol/source/Image~ImageSourceEvent
	 * @api
	 */
	var ImageWMS = /*@__PURE__*/(function (ImageSource$$1) {
	  function ImageWMS(opt_options) {
	
	    var options = opt_options || /** @type {Options} */ ({});
	
	    ImageSource$$1.call(this, {
	      attributions: options.attributions,
	      projection: options.projection,
	      resolutions: options.resolutions
	    });
	
	    /**
	     * @private
	     * @type {?string}
	     */
	    this.crossOrigin_ =
	        options.crossOrigin !== undefined ? options.crossOrigin : null;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.url_ = options.url;
	
	    /**
	     * @private
	     * @type {import("../Image.js").LoadFunction}
	     */
	    this.imageLoadFunction_ = options.imageLoadFunction !== undefined ?
	      options.imageLoadFunction : defaultImageLoadFunction;
	
	    /**
	     * @private
	     * @type {!Object}
	     */
	    this.params_ = options.params || {};
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.v13_ = true;
	    this.updateV13_();
	
	    /**
	     * @private
	     * @type {import("./WMSServerType.js").default|undefined}
	     */
	    this.serverType_ = /** @type {import("./WMSServerType.js").default|undefined} */ (options.serverType);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
	
	    /**
	     * @private
	     * @type {import("../Image.js").default}
	     */
	    this.image_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.imageSize_ = [0, 0];
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.renderedRevision_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
	
	  }
	
	  if ( ImageSource$$1 ) { ImageWMS.__proto__ = ImageSource$$1; }
	  ImageWMS.prototype = Object.create( ImageSource$$1 && ImageSource$$1.prototype );
	  ImageWMS.prototype.constructor = ImageWMS;
	
	  /**
	   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
	   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
	   * constructed.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {number} resolution Resolution.
	   * @param {import("../proj.js").ProjectionLike} projection Projection.
	   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
	   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
	   *     in the `LAYERS` parameter will be used. `VERSION` should not be
	   *     specified here.
	   * @return {string|undefined} GetFeatureInfo URL.
	   * @api
	   */
	  ImageWMS.prototype.getGetFeatureInfoUrl = function getGetFeatureInfoUrl (coordinate, resolution, projection, params) {
	    if (this.url_ === undefined) {
	      return undefined;
	    }
	    var projectionObj = get$2(projection);
	    var sourceProjectionObj = this.getProjection();
	
	    if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
	      resolution = calculateSourceResolution(sourceProjectionObj, projectionObj, coordinate, resolution);
	      coordinate = transform(coordinate, projectionObj, sourceProjectionObj);
	    }
	
	    var extent = getForViewAndSize(coordinate, resolution, 0,
	      GETFEATUREINFO_IMAGE_SIZE);
	
	    var baseParams = {
	      'SERVICE': 'WMS',
	      'VERSION': DEFAULT_WMS_VERSION,
	      'REQUEST': 'GetFeatureInfo',
	      'FORMAT': 'image/png',
	      'TRANSPARENT': true,
	      'QUERY_LAYERS': this.params_['LAYERS']
	    };
	    assign(baseParams, this.params_, params);
	
	    var x = Math.floor((coordinate[0] - extent[0]) / resolution);
	    var y = Math.floor((extent[3] - coordinate[1]) / resolution);
	    baseParams[this.v13_ ? 'I' : 'X'] = x;
	    baseParams[this.v13_ ? 'J' : 'Y'] = y;
	
	    return this.getRequestUrl_(
	      extent, GETFEATUREINFO_IMAGE_SIZE,
	      1, sourceProjectionObj || projectionObj, baseParams);
	  };
	
	  /**
	   * Get the user-provided params, i.e. those passed to the constructor through
	   * the "params" option, and possibly updated using the updateParams method.
	   * @return {Object} Params.
	   * @api
	   */
	  ImageWMS.prototype.getParams = function getParams () {
	    return this.params_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  ImageWMS.prototype.getImageInternal = function getImageInternal (extent, resolution, pixelRatio, projection) {
	
	    if (this.url_ === undefined) {
	      return null;
	    }
	
	    resolution = this.findNearestResolution(resolution);
	
	    if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) {
	      pixelRatio = 1;
	    }
	
	    var imageResolution = resolution / pixelRatio;
	
	    var center = getCenter(extent);
	    var viewWidth = Math.ceil(getWidth(extent) / imageResolution);
	    var viewHeight = Math.ceil(getHeight(extent) / imageResolution);
	    var viewExtent = getForViewAndSize(center, imageResolution, 0,
	      [viewWidth, viewHeight]);
	    var requestWidth = Math.ceil(this.ratio_ * getWidth(extent) / imageResolution);
	    var requestHeight = Math.ceil(this.ratio_ * getHeight(extent) / imageResolution);
	    var requestExtent = getForViewAndSize(center, imageResolution, 0,
	      [requestWidth, requestHeight]);
	
	    var image = this.image_;
	    if (image &&
	        this.renderedRevision_ == this.getRevision() &&
	        image.getResolution() == resolution &&
	        image.getPixelRatio() == pixelRatio &&
	        containsExtent(image.getExtent(), viewExtent)) {
	      return image;
	    }
	
	    var params = {
	      'SERVICE': 'WMS',
	      'VERSION': DEFAULT_WMS_VERSION,
	      'REQUEST': 'GetMap',
	      'FORMAT': 'image/png',
	      'TRANSPARENT': true
	    };
	    assign(params, this.params_);
	
	    this.imageSize_[0] = Math.round(getWidth(requestExtent) / imageResolution);
	    this.imageSize_[1] = Math.round(getHeight(requestExtent) / imageResolution);
	
	    var url = this.getRequestUrl_(requestExtent, this.imageSize_, pixelRatio,
	      projection, params);
	
	    this.image_ = new ImageWrapper(requestExtent, resolution, pixelRatio,
	      url, this.crossOrigin_, this.imageLoadFunction_);
	
	    this.renderedRevision_ = this.getRevision();
	
	    listen(this.image_, EventType.CHANGE,
	      this.handleImageChange, this);
	
	    return this.image_;
	
	  };
	
	  /**
	   * Return the image load function of the source.
	   * @return {import("../Image.js").LoadFunction} The image load function.
	   * @api
	   */
	  ImageWMS.prototype.getImageLoadFunction = function getImageLoadFunction () {
	    return this.imageLoadFunction_;
	  };
	
	  /**
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {import("../size.js").Size} size Size.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {Object} params Params.
	   * @return {string} Request URL.
	   * @private
	   */
	  ImageWMS.prototype.getRequestUrl_ = function getRequestUrl_ (extent, size, pixelRatio, projection, params) {
	
	    assert(this.url_ !== undefined, 9); // `url` must be configured or set using `#setUrl()`
	
	    params[this.v13_ ? 'CRS' : 'SRS'] = projection.getCode();
	
	    if (!('STYLES' in this.params_)) {
	      params['STYLES'] = '';
	    }
	
	    if (pixelRatio != 1) {
	      switch (this.serverType_) {
	        case WMSServerType.GEOSERVER:
	          var dpi = (90 * pixelRatio + 0.5) | 0;
	          if ('FORMAT_OPTIONS' in params) {
	            params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
	          } else {
	            params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
	          }
	          break;
	        case WMSServerType.MAPSERVER:
	          params['MAP_RESOLUTION'] = 90 * pixelRatio;
	          break;
	        case WMSServerType.CARMENTA_SERVER:
	        case WMSServerType.QGIS:
	          params['DPI'] = 90 * pixelRatio;
	          break;
	        default:
	          assert(false, 8); // Unknown `serverType` configured
	          break;
	      }
	    }
	
	    params['WIDTH'] = size[0];
	    params['HEIGHT'] = size[1];
	
	    var axisOrientation = projection.getAxisOrientation();
	    var bbox;
	    if (this.v13_ && axisOrientation.substr(0, 2) == 'ne') {
	      bbox = [extent[1], extent[0], extent[3], extent[2]];
	    } else {
	      bbox = extent;
	    }
	    params['BBOX'] = bbox.join(',');
	
	    return appendParams(/** @type {string} */ (this.url_), params);
	  };
	
	  /**
	   * Return the URL used for this WMS source.
	   * @return {string|undefined} URL.
	   * @api
	   */
	  ImageWMS.prototype.getUrl = function getUrl () {
	    return this.url_;
	  };
	
	  /**
	   * Set the image load function of the source.
	   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
	   * @api
	   */
	  ImageWMS.prototype.setImageLoadFunction = function setImageLoadFunction (imageLoadFunction) {
	    this.image_ = null;
	    this.imageLoadFunction_ = imageLoadFunction;
	    this.changed();
	  };
	
	  /**
	   * Set the URL to use for requests.
	   * @param {string|undefined} url URL.
	   * @api
	   */
	  ImageWMS.prototype.setUrl = function setUrl (url) {
	    if (url != this.url_) {
	      this.url_ = url;
	      this.image_ = null;
	      this.changed();
	    }
	  };
	
	  /**
	   * Update the user-provided params.
	   * @param {Object} params Params.
	   * @api
	   */
	  ImageWMS.prototype.updateParams = function updateParams (params) {
	    assign(this.params_, params);
	    this.updateV13_();
	    this.image_ = null;
	    this.changed();
	  };
	
	  /**
	   * @private
	   */
	  ImageWMS.prototype.updateV13_ = function updateV13_ () {
	    var version = this.params_['VERSION'] || DEFAULT_WMS_VERSION;
	    this.v13_ = compareVersions(version, '1.3') >= 0;
	  };
	
	  return ImageWMS;
	}(ImageSource));
	
	/**
	 * @module ol/source/OSM
	 */
	
	
	/**
	 * The attribution containing a link to the OpenStreetMap Copyright and License
	 * page.
	 * @const
	 * @type {string}
	 * @api
	 */
	var ATTRIBUTION = '&#169; ' +
	      '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> ' +
	      'contributors.';
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {number} [maxZoom=19] Max zoom.
	 * @property {boolean} [opaque=true] Whether the layer is opaque.
	 * @property {number} [reprojectionErrorThreshold=1.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {string} [url='https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
	 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for the OpenStreetMap tile server.
	 * @api
	 */
	var OSM = /*@__PURE__*/(function (XYZ$$1) {
	  function OSM(opt_options) {
	
	    var options = opt_options || {};
	
	    var attributions;
	    if (options.attributions !== undefined) {
	      attributions = options.attributions;
	    } else {
	      attributions = [ATTRIBUTION];
	    }
	
	    var crossOrigin = options.crossOrigin !== undefined ?
	      options.crossOrigin : 'anonymous';
	
	    var url = options.url !== undefined ?
	      options.url : 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	
	    XYZ$$1.call(this, {
	      attributions: attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: crossOrigin,
	      opaque: options.opaque !== undefined ? options.opaque : true,
	      maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileLoadFunction: options.tileLoadFunction,
	      url: url,
	      wrapX: options.wrapX,
	      attributionsCollapsible: false
	    });
	
	  }
	
	  if ( XYZ$$1 ) { OSM.__proto__ = XYZ$$1; }
	  OSM.prototype = Object.create( XYZ$$1 && XYZ$$1.prototype );
	  OSM.prototype.constructor = OSM;
	
	  return OSM;
	}(XYZ));
	
	var hasImageData = true;
	try {
	  new ImageData(10, 10);
	} catch (_) {
	  hasImageData = false;
	}
	
	var context = document.createElement('canvas').getContext('2d');
	
	function newImageData(data, width, height) {
	  if (hasImageData) {
	    return new ImageData(data, width, height);
	  } else {
	    var imageData = context.createImageData(width, height);
	    imageData.data.set(data);
	    return imageData;
	  }
	}
	
	var newImageData_1 = newImageData;
	
	var util = {
		newImageData: newImageData_1
	};
	
	var newImageData$1 = util.newImageData;
	
	/**
	 * Create a function for running operations.  This function is serialized for
	 * use in a worker.
	 * @param {function(Array, Object):*} operation The operation.
	 * @return {function(Object):ArrayBuffer} A function that takes an object with
	 * buffers, meta, imageOps, width, and height properties and returns an array
	 * buffer.
	 */
	function createMinion(operation) {
	  var workerHasImageData = true;
	  try {
	    new ImageData(10, 10);
	  } catch (_) {
	    workerHasImageData = false;
	  }
	
	  function newWorkerImageData(data, width, height) {
	    if (workerHasImageData) {
	      return new ImageData(data, width, height);
	    } else {
	      return {data: data, width: width, height: height};
	    }
	  }
	
	  return function(data) {
	    // bracket notation for minification support
	    var buffers = data['buffers'];
	    var meta = data['meta'];
	    var imageOps = data['imageOps'];
	    var width = data['width'];
	    var height = data['height'];
	
	    var numBuffers = buffers.length;
	    var numBytes = buffers[0].byteLength;
	    var output, b;
	
	    if (imageOps) {
	      var images = new Array(numBuffers);
	      for (b = 0; b < numBuffers; ++b) {
	        images[b] = newWorkerImageData(
	            new Uint8ClampedArray(buffers[b]), width, height);
	      }
	      output = operation(images, meta).data;
	    } else {
	      output = new Uint8ClampedArray(numBytes);
	      var arrays = new Array(numBuffers);
	      var pixels = new Array(numBuffers);
	      for (b = 0; b < numBuffers; ++b) {
	        arrays[b] = new Uint8ClampedArray(buffers[b]);
	        pixels[b] = [0, 0, 0, 0];
	      }
	      for (var i = 0; i < numBytes; i += 4) {
	        for (var j = 0; j < numBuffers; ++j) {
	          var array = arrays[j];
	          pixels[j][0] = array[i];
	          pixels[j][1] = array[i + 1];
	          pixels[j][2] = array[i + 2];
	          pixels[j][3] = array[i + 3];
	        }
	        var pixel = operation(pixels, meta);
	        output[i] = pixel[0];
	        output[i + 1] = pixel[1];
	        output[i + 2] = pixel[2];
	        output[i + 3] = pixel[3];
	      }
	    }
	    return output.buffer;
	  };
	}
	
	/**
	 * Create a worker for running operations.
	 * @param {Object} config Configuration.
	 * @param {function(MessageEvent)} onMessage Called with a message event.
	 * @return {Worker} The worker.
	 */
	function createWorker(config, onMessage) {
	  var lib = Object.keys(config.lib || {}).map(function(name) {
	    return 'var ' + name + ' = ' + config.lib[name].toString() + ';';
	  });
	
	  var lines = lib.concat([
	    'var __minion__ = (' + createMinion.toString() + ')(', config.operation.toString(), ');',
	    'self.addEventListener("message", function(event) {',
	    '  var buffer = __minion__(event.data);',
	    '  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);',
	    '});'
	  ]);
	
	  var blob = new Blob(lines, {type: 'text/javascript'});
	  var source = URL.createObjectURL(blob);
	  var worker = new Worker(source);
	  worker.addEventListener('message', onMessage);
	  return worker;
	}
	
	/**
	 * Create a faux worker for running operations.
	 * @param {Object} config Configuration.
	 * @param {function(MessageEvent)} onMessage Called with a message event.
	 * @return {Object} The faux worker.
	 */
	function createFauxWorker(config, onMessage) {
	  var minion = createMinion(config.operation);
	  return {
	    postMessage: function(data) {
	      setTimeout(function() {
	        onMessage({'data': {'buffer': minion(data), 'meta': data['meta']}});
	      }, 0);
	    }
	  };
	}
	
	/**
	 * A processor runs pixel or image operations in workers.
	 * @param {Object} config Configuration.
	 */
	function Processor(config) {
	  this._imageOps = !!config.imageOps;
	  var threads;
	  if (config.threads === 0) {
	    threads = 0;
	  } else if (this._imageOps) {
	    threads = 1;
	  } else {
	    threads = config.threads || 1;
	  }
	  var workers = [];
	  if (threads) {
	    for (var i = 0; i < threads; ++i) {
	      workers[i] = createWorker(config, this._onWorkerMessage.bind(this, i));
	    }
	  } else {
	    workers[0] = createFauxWorker(config, this._onWorkerMessage.bind(this, 0));
	  }
	  this._workers = workers;
	  this._queue = [];
	  this._maxQueueLength = config.queue || Infinity;
	  this._running = 0;
	  this._dataLookup = {};
	  this._job = null;
	}
	
	/**
	 * Run operation on input data.
	 * @param {Array.<Array|ImageData>} inputs Array of pixels or image data
	 *     (depending on the operation type).
	 * @param {Object} meta A user data object.  This is passed to all operations
	 *     and must be serializable.
	 * @param {function(Error, ImageData, Object)} callback Called when work
	 *     completes.  The first argument is any error.  The second is the ImageData
	 *     generated by operations.  The third is the user data object.
	 */
	Processor.prototype.process = function(inputs, meta, callback) {
	  this._enqueue({
	    inputs: inputs,
	    meta: meta,
	    callback: callback
	  });
	  this._dispatch();
	};
	
	/**
	 * Stop responding to any completed work and destroy the processor.
	 */
	Processor.prototype.destroy = function() {
	  for (var key in this) {
	    this[key] = null;
	  }
	  this._destroyed = true;
	};
	
	/**
	 * Add a job to the queue.
	 * @param {Object} job The job.
	 */
	Processor.prototype._enqueue = function(job) {
	  this._queue.push(job);
	  while (this._queue.length > this._maxQueueLength) {
	    this._queue.shift().callback(null, null);
	  }
	};
	
	/**
	 * Dispatch a job.
	 */
	Processor.prototype._dispatch = function() {
	  if (this._running === 0 && this._queue.length > 0) {
	    var job = this._job = this._queue.shift();
	    var width = job.inputs[0].width;
	    var height = job.inputs[0].height;
	    var buffers = job.inputs.map(function(input) {
	      return input.data.buffer;
	    });
	    var threads = this._workers.length;
	    this._running = threads;
	    if (threads === 1) {
	      this._workers[0].postMessage({
	        'buffers': buffers,
	        'meta': job.meta,
	        'imageOps': this._imageOps,
	        'width': width,
	        'height': height
	      }, buffers);
	    } else {
	      var length = job.inputs[0].data.length;
	      var segmentLength = 4 * Math.ceil(length / 4 / threads);
	      for (var i = 0; i < threads; ++i) {
	        var offset = i * segmentLength;
	        var slices = [];
	        for (var j = 0, jj = buffers.length; j < jj; ++j) {
	          slices.push(buffers[i].slice(offset, offset + segmentLength));
	        }
	        this._workers[i].postMessage({
	          'buffers': slices,
	          'meta': job.meta,
	          'imageOps': this._imageOps,
	          'width': width,
	          'height': height
	        }, slices);
	      }
	    }
	  }
	};
	
	/**
	 * Handle messages from the worker.
	 * @param {number} index The worker index.
	 * @param {MessageEvent} event The message event.
	 */
	Processor.prototype._onWorkerMessage = function(index, event) {
	  if (this._destroyed) {
	    return;
	  }
	  this._dataLookup[index] = event.data;
	  --this._running;
	  if (this._running === 0) {
	    this._resolveJob();
	  }
	};
	
	/**
	 * Resolve a job.  If there are no more worker threads, the processor callback
	 * will be called.
	 */
	Processor.prototype._resolveJob = function() {
	  var job = this._job;
	  var threads = this._workers.length;
	  var data, meta;
	  if (threads === 1) {
	    data = new Uint8ClampedArray(this._dataLookup[0]['buffer']);
	    meta = this._dataLookup[0]['meta'];
	  } else {
	    var length = job.inputs[0].data.length;
	    data = new Uint8ClampedArray(length);
	    meta = new Array(length);
	    var segmentLength = 4 * Math.ceil(length / 4 / threads);
	    for (var i = 0; i < threads; ++i) {
	      var buffer = this._dataLookup[i]['buffer'];
	      var offset = i * segmentLength;
	      data.set(new Uint8ClampedArray(buffer), offset);
	      meta[i] = this._dataLookup[i]['meta'];
	    }
	  }
	  this._job = null;
	  this._dataLookup = {};
	  job.callback(null,
	      newImageData$1(data, job.inputs[0].width, job.inputs[0].height), meta);
	  this._dispatch();
	};
	
	var processor = Processor;
	
	var Processor_1 = processor;
	
	/**
	 * @module ol/layer/Image
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
	 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
	 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
	 * use {@link module:ol/Map#addLayer}.
	 * @property {import("../source/Image.js").default} [source] Source for this layer.
	 */
	
	
	/**
	 * @classdesc
	 * Server-rendered images that are available for arbitrary extents and
	 * resolutions.
	 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
	 * property on the layer object; for example, setting `title: 'My Title'` in the
	 * options means that `title` is observable, and has get/set accessors.
	 *
	 * @fires import("../render/Event.js").RenderEvent
	 * @api
	 */
	var ImageLayer = /*@__PURE__*/(function (Layer$$1) {
	  function ImageLayer(opt_options) {
	    var options = opt_options ? opt_options : {};
	    Layer$$1.call(this, options);
	
	    /**
	     * The layer type.
	     * @protected
	     * @type {import("../LayerType.js").default}
	     */
	    this.type = LayerType.IMAGE;
	
	  }
	
	  if ( Layer$$1 ) { ImageLayer.__proto__ = Layer$$1; }
	  ImageLayer.prototype = Object.create( Layer$$1 && Layer$$1.prototype );
	  ImageLayer.prototype.constructor = ImageLayer;
	
	  return ImageLayer;
	}(Layer));
	
	
	/**
	 * Return the associated {@link module:ol/source/Image source} of the image layer.
	 * @function
	 * @return {import("../source/Image.js").default} Source.
	 * @api
	 */
	ImageLayer.prototype.getSource;
	
	/**
	 * @module ol/layer/TileProperty
	 */
	
	/**
	 * @enum {string}
	 */
	var TileProperty = {
	  PRELOAD: 'preload',
	  USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
	};
	
	/**
	 * @module ol/layer/Tile
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
	 * means no preloading.
	 * @property {import("../source/Tile.js").default} [source] Source for this layer.
	 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
	 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
	 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
	 * use {@link module:ol/Map#addLayer}.
	 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
	 */
	
	/**
	 * @classdesc
	 * For layer sources that provide pre-rendered, tiled images in grids that are
	 * organized by zoom levels for specific resolutions.
	 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
	 * property on the layer object; for example, setting `title: 'My Title'` in the
	 * options means that `title` is observable, and has get/set accessors.
	 *
	 * @api
	 */
	var TileLayer = /*@__PURE__*/(function (Layer$$1) {
	  function TileLayer(opt_options) {
	    var options = opt_options ? opt_options : {};
	
	    var baseOptions = assign({}, options);
	
	    delete baseOptions.preload;
	    delete baseOptions.useInterimTilesOnError;
	    Layer$$1.call(this, baseOptions);
	
	    this.setPreload(options.preload !== undefined ? options.preload : 0);
	    this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ?
	      options.useInterimTilesOnError : true);
	
	    /**
	    * The layer type.
	    * @protected
	    * @type {import("../LayerType.js").default}
	    */
	    this.type = LayerType.TILE;
	
	  }
	
	  if ( Layer$$1 ) { TileLayer.__proto__ = Layer$$1; }
	  TileLayer.prototype = Object.create( Layer$$1 && Layer$$1.prototype );
	  TileLayer.prototype.constructor = TileLayer;
	
	  /**
	  * Return the level as number to which we will preload tiles up to.
	  * @return {number} The level to preload tiles up to.
	  * @observable
	  * @api
	  */
	  TileLayer.prototype.getPreload = function getPreload () {
	    return /** @type {number} */ (this.get(TileProperty.PRELOAD));
	  };
	
	  /**
	  * Set the level as number to which we will preload tiles up to.
	  * @param {number} preload The level to preload tiles up to.
	  * @observable
	  * @api
	  */
	  TileLayer.prototype.setPreload = function setPreload (preload) {
	    this.set(TileProperty.PRELOAD, preload);
	  };
	
	  /**
	  * Whether we use interim tiles on error.
	  * @return {boolean} Use interim tiles on error.
	  * @observable
	  * @api
	  */
	  TileLayer.prototype.getUseInterimTilesOnError = function getUseInterimTilesOnError () {
	    return /** @type {boolean} */ (this.get(TileProperty.USE_INTERIM_TILES_ON_ERROR));
	  };
	
	  /**
	  * Set whether we use interim tiles on error.
	  * @param {boolean} useInterimTilesOnError Use interim tiles on error.
	  * @observable
	  * @api
	  */
	  TileLayer.prototype.setUseInterimTilesOnError = function setUseInterimTilesOnError (useInterimTilesOnError) {
	    this.set(TileProperty.USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
	  };
	
	  return TileLayer;
	}(Layer));
	
	
	/**
	 * Return the associated {@link module:ol/source/Tile tilesource} of the layer.
	 * @function
	 * @return {import("../source/Tile.js").default} Source.
	 * @api
	 */
	TileLayer.prototype.getSource;
	
	/**
	 * @module ol/source/Raster
	 */
	
	
	/**
	 * A function that takes an array of input data, performs some operation, and
	 * returns an array of output data.
	 * For `pixel` type operations, the function will be called with an array of
	 * pixels, where each pixel is an array of four numbers (`[r, g, b, a]`) in the
	 * range of 0 - 255. It should return a single pixel array.
	 * For `'image'` type operations, functions will be called with an array of
	 * {@link ImageData https://developer.mozilla.org/en-US/docs/Web/API/ImageData}
	 * and should return a single {@link ImageData
	 * https://developer.mozilla.org/en-US/docs/Web/API/ImageData}.  The operations
	 * are called with a second "data" argument, which can be used for storage.  The
	 * data object is accessible from raster events, where it can be initialized in
	 * "beforeoperations" and accessed again in "afteroperations".
	 *
	 * @typedef {function((Array<Array<number>>|Array<ImageData>), Object):
	 *     (Array<number>|ImageData)} Operation
	 */
	
	
	/**
	 * @enum {string}
	 */
	var RasterEventType = {
	  /**
	   * Triggered before operations are run.
	   * @event ol/source/Raster~RasterSourceEvent#beforeoperations
	   * @api
	   */
	  BEFOREOPERATIONS: 'beforeoperations',
	
	  /**
	   * Triggered after operations are run.
	   * @event ol/source/Raster~RasterSourceEvent#afteroperations
	   * @api
	   */
	  AFTEROPERATIONS: 'afteroperations'
	};
	
	
	/**
	 * Raster operation type. Supported values are `'pixel'` and `'image'`.
	 * @enum {string}
	 */
	var RasterOperationType = {
	  PIXEL: 'pixel',
	  IMAGE: 'image'
	};
	
	
	/**
	 * @classdesc
	 * Events emitted by {@link module:ol/source/Raster} instances are instances of this
	 * type.
	 */
	var RasterSourceEvent = /*@__PURE__*/(function (Event$$1) {
	  function RasterSourceEvent(type, frameState, data) {
	    Event$$1.call(this, type);
	
	    /**
	     * The raster extent.
	     * @type {import("../extent.js").Extent}
	     * @api
	     */
	    this.extent = frameState.extent;
	
	    /**
	     * The pixel resolution (map units per pixel).
	     * @type {number}
	     * @api
	     */
	    this.resolution = frameState.viewState.resolution / frameState.pixelRatio;
	
	    /**
	     * An object made available to all operations.  This can be used by operations
	     * as a storage object (e.g. for calculating statistics).
	     * @type {Object}
	     * @api
	     */
	    this.data = data;
	
	  }
	
	  if ( Event$$1 ) { RasterSourceEvent.__proto__ = Event$$1; }
	  RasterSourceEvent.prototype = Object.create( Event$$1 && Event$$1.prototype );
	  RasterSourceEvent.prototype.constructor = RasterSourceEvent;
	
	  return RasterSourceEvent;
	}(Event));
	
	/**
	 * @typedef {Object} Options
	 * @property {Array<import("./Source.js").default|import("../layer/Layer.js").default>} sources Input
	 * sources or layers. Vector layers must be configured with `renderMode: 'image'`.
	 * @property {Operation} [operation] Raster operation.
	 * The operation will be called with data from input sources
	 * and the output will be assigned to the raster source.
	 * @property {Object} [lib] Functions that will be made available to operations run in a worker.
	 * @property {number} [threads] By default, operations will be run in a single worker thread.
	 * To avoid using workers altogether, set `threads: 0`.  For pixel operations, operations can
	 * be run in multiple worker threads.  Note that there is additional overhead in
	 * transferring data to multiple workers, and that depending on the user's
	 * system, it may not be possible to parallelize the work.
	 * @property {RasterOperationType} [operationType='pixel'] Operation type.
	 * Supported values are `'pixel'` and `'image'`.  By default,
	 * `'pixel'` operations are assumed, and operations will be called with an
	 * array of pixels from input sources.  If set to `'image'`, operations will
	 * be called with an array of ImageData objects from input sources.
	 */
	
	
	/**
	 * @classdesc
	 * A source that transforms data from any number of input sources using an
	 * {@link module:ol/source/Raster~Operation} function to transform input pixel values into
	 * output pixel values.
	 *
	 * @fires ol/source/Raster~RasterSourceEvent
	 * @api
	 */
	var RasterSource = /*@__PURE__*/(function (ImageSource$$1) {
	  function RasterSource(options) {
	    ImageSource$$1.call(this, {
	      projection: null
	    });
	
	    /**
	     * @private
	     * @type {*}
	     */
	    this.worker_ = null;
	
	    /**
	     * @private
	     * @type {RasterOperationType}
	     */
	    this.operationType_ = options.operationType !== undefined ?
	      options.operationType : RasterOperationType.PIXEL;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.threads_ = options.threads !== undefined ? options.threads : 1;
	
	    /**
	     * @private
	     * @type {Array<import("../renderer/canvas/Layer.js").default>}
	     */
	    this.renderers_ = createRenderers(options.sources);
	
	    for (var r = 0, rr = this.renderers_.length; r < rr; ++r) {
	      listen(this.renderers_[r], EventType.CHANGE,
	        this.changed, this);
	    }
	
	    /**
	     * @private
	     * @type {import("../TileQueue.js").default}
	     */
	    this.tileQueue_ = new TileQueue(
	      function() {
	        return 1;
	      },
	      this.changed.bind(this));
	
	    var layerStatesArray = getLayerStatesArray(this.renderers_);
	
	    /**
	     * @type {Object<string, import("../layer/Layer.js").State>}
	     */
	    var layerStates = {};
	    for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
	      layerStates[getUid(layerStatesArray[i].layer)] = layerStatesArray[i];
	    }
	
	    /**
	     * The most recently requested frame state.
	     * @type {import("../PluggableMap.js").FrameState}
	     * @private
	     */
	    this.requestedFrameState_;
	
	    /**
	     * The most recently rendered image canvas.
	     * @type {import("../ImageCanvas.js").default}
	     * @private
	     */
	    this.renderedImageCanvas_ = null;
	
	    /**
	     * The most recently rendered revision.
	     * @type {number}
	     */
	    this.renderedRevision_;
	
	    /**
	     * @private
	     * @type {import("../PluggableMap.js").FrameState}
	     */
	    this.frameState_ = {
	      animate: false,
	      coordinateToPixelTransform: create(),
	      extent: null,
	      focus: null,
	      index: 0,
	      layerStates: layerStates,
	      layerStatesArray: layerStatesArray,
	      pixelRatio: 1,
	      pixelToCoordinateTransform: create(),
	      postRenderFunctions: [],
	      size: [0, 0],
	      skippedFeatureUids: {},
	      tileQueue: this.tileQueue_,
	      time: Date.now(),
	      usedTiles: {},
	      viewState: /** @type {import("../View.js").State} */ ({
	        rotation: 0
	      }),
	      viewHints: [],
	      wantedTiles: {}
	    };
	
	    if (options.operation !== undefined) {
	      this.setOperation(options.operation, options.lib);
	    }
	
	  }
	
	  if ( ImageSource$$1 ) { RasterSource.__proto__ = ImageSource$$1; }
	  RasterSource.prototype = Object.create( ImageSource$$1 && ImageSource$$1.prototype );
	  RasterSource.prototype.constructor = RasterSource;
	
	  /**
	   * Set the operation.
	   * @param {Operation} operation New operation.
	   * @param {Object=} opt_lib Functions that will be available to operations run
	   *     in a worker.
	   * @api
	   */
	  RasterSource.prototype.setOperation = function setOperation (operation, opt_lib) {
	    this.worker_ = new Processor_1({
	      operation: operation,
	      imageOps: this.operationType_ === RasterOperationType.IMAGE,
	      queue: 1,
	      lib: opt_lib,
	      threads: this.threads_
	    });
	    this.changed();
	  };
	
	  /**
	   * Update the stored frame state.
	   * @param {import("../extent.js").Extent} extent The view extent (in map units).
	   * @param {number} resolution The view resolution.
	   * @param {import("../proj/Projection.js").default} projection The view projection.
	   * @return {import("../PluggableMap.js").FrameState} The updated frame state.
	   * @private
	   */
	  RasterSource.prototype.updateFrameState_ = function updateFrameState_ (extent, resolution, projection) {
	
	    var frameState = /** @type {import("../PluggableMap.js").FrameState} */ (assign({}, this.frameState_));
	
	    frameState.viewState = /** @type {import("../View.js").State} */ (assign({}, frameState.viewState));
	
	    var center = getCenter(extent);
	
	    frameState.extent = extent.slice();
	    frameState.focus = center;
	    frameState.size[0] = Math.round(getWidth(extent) / resolution);
	    frameState.size[1] = Math.round(getHeight(extent) / resolution);
	    frameState.time = Date.now();
	    frameState.animate = false;
	
	    var viewState = frameState.viewState;
	    viewState.center = center;
	    viewState.projection = projection;
	    viewState.resolution = resolution;
	    return frameState;
	  };
	
	  /**
	   * Determine if all sources are ready.
	   * @return {boolean} All sources are ready.
	   * @private
	   */
	  RasterSource.prototype.allSourcesReady_ = function allSourcesReady_ () {
	    var ready = true;
	    var source;
	    for (var i = 0, ii = this.renderers_.length; i < ii; ++i) {
	      source = this.renderers_[i].getLayer().getSource();
	      if (source.getState() !== SourceState.READY) {
	        ready = false;
	        break;
	      }
	    }
	    return ready;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  RasterSource.prototype.getImage = function getImage (extent, resolution, pixelRatio, projection) {
	    if (!this.allSourcesReady_()) {
	      return null;
	    }
	
	    var frameState = this.updateFrameState_(extent, resolution, projection);
	    this.requestedFrameState_ = frameState;
	
	    // check if we can't reuse the existing ol/ImageCanvas
	    if (this.renderedImageCanvas_) {
	      var renderedResolution = this.renderedImageCanvas_.getResolution();
	      var renderedExtent = this.renderedImageCanvas_.getExtent();
	      if (resolution !== renderedResolution || !equals$1(extent, renderedExtent)) {
	        this.renderedImageCanvas_ = null;
	      }
	    }
	
	    if (!this.renderedImageCanvas_ || this.getRevision() !== this.renderedRevision_) {
	      this.processSources_();
	    }
	
	    frameState.tileQueue.loadMoreTiles(16, 16);
	
	    if (frameState.animate) {
	      requestAnimationFrame(this.changed.bind(this));
	    }
	
	    return this.renderedImageCanvas_;
	  };
	
	  /**
	   * Start processing source data.
	   * @private
	   */
	  RasterSource.prototype.processSources_ = function processSources_ () {
	    var frameState = this.requestedFrameState_;
	    var len = this.renderers_.length;
	    var imageDatas = new Array(len);
	    for (var i = 0; i < len; ++i) {
	      var imageData = getImageData(
	        this.renderers_[i], frameState, frameState.layerStatesArray[i]);
	      if (imageData) {
	        imageDatas[i] = imageData;
	      } else {
	        return;
	      }
	    }
	
	    var data = {};
	    this.dispatchEvent(new RasterSourceEvent(RasterEventType.BEFOREOPERATIONS, frameState, data));
	    this.worker_.process(imageDatas, data, this.onWorkerComplete_.bind(this, frameState));
	  };
	
	  /**
	   * Called when pixel processing is complete.
	   * @param {import("../PluggableMap.js").FrameState} frameState The frame state.
	   * @param {Error} err Any error during processing.
	   * @param {ImageData} output The output image data.
	   * @param {Object} data The user data.
	   * @private
	   */
	  RasterSource.prototype.onWorkerComplete_ = function onWorkerComplete_ (frameState, err, output, data) {
	    if (err || !output) {
	      return;
	    }
	
	    // do nothing if extent or resolution changed
	    var extent = frameState.extent;
	    var resolution = frameState.viewState.resolution;
	    if (resolution !== this.requestedFrameState_.viewState.resolution ||
	        !equals$1(extent, this.requestedFrameState_.extent)) {
	      return;
	    }
	
	    var context;
	    if (this.renderedImageCanvas_) {
	      context = this.renderedImageCanvas_.getImage().getContext('2d');
	    } else {
	      var width = Math.round(getWidth(extent) / resolution);
	      var height = Math.round(getHeight(extent) / resolution);
	      context = createCanvasContext2D(width, height);
	      this.renderedImageCanvas_ = new ImageCanvas(extent, resolution, 1, context.canvas);
	    }
	    context.putImageData(output, 0, 0);
	
	    this.changed();
	    this.renderedRevision_ = this.getRevision();
	
	    this.dispatchEvent(new RasterSourceEvent(RasterEventType.AFTEROPERATIONS, frameState, data));
	  };
	
	  /**
	   * @override
	   */
	  RasterSource.prototype.getImageInternal = function getImageInternal () {
	    return null; // not implemented
	  };
	
	  return RasterSource;
	}(ImageSource));
	
	
	/**
	 * A reusable canvas context.
	 * @type {CanvasRenderingContext2D}
	 * @private
	 */
	var sharedContext = null;
	
	
	/**
	 * Get image data from a renderer.
	 * @param {import("../renderer/canvas/Layer.js").default} renderer Layer renderer.
	 * @param {import("../PluggableMap.js").FrameState} frameState The frame state.
	 * @param {import("../layer/Layer.js").State} layerState The layer state.
	 * @return {ImageData} The image data.
	 */
	function getImageData(renderer, frameState, layerState) {
	  if (!renderer.prepareFrame(frameState, layerState)) {
	    return null;
	  }
	  var width = frameState.size[0];
	  var height = frameState.size[1];
	  if (!sharedContext) {
	    sharedContext = createCanvasContext2D(width, height);
	  } else {
	    var canvas = sharedContext.canvas;
	    if (canvas.width !== width || canvas.height !== height) {
	      sharedContext = createCanvasContext2D(width, height);
	    } else {
	      sharedContext.clearRect(0, 0, width, height);
	    }
	  }
	  renderer.composeFrame(frameState, layerState, sharedContext);
	  return sharedContext.getImageData(0, 0, width, height);
	}
	
	
	/**
	 * Get a list of layer states from a list of renderers.
	 * @param {Array<import("../renderer/canvas/Layer.js").default>} renderers Layer renderers.
	 * @return {Array<import("../layer/Layer.js").State>} The layer states.
	 */
	function getLayerStatesArray(renderers) {
	  return renderers.map(function(renderer) {
	    return renderer.getLayer().getLayerState();
	  });
	}
	
	
	/**
	 * Create renderers for all sources.
	 * @param {Array<import("./Source.js").default|import("../layer/Layer.js").default>} sources The sources.
	 * @return {Array<import("../renderer/canvas/Layer.js").default>} Array of layer renderers.
	 */
	function createRenderers(sources) {
	  var len = sources.length;
	  var renderers = new Array(len);
	  for (var i = 0; i < len; ++i) {
	    renderers[i] = createRenderer(sources[i]);
	  }
	  return renderers;
	}
	
	
	/**
	 * Create a renderer for the provided source.
	 * @param {import("./Source.js").default|import("../layer/Layer.js").default} layerOrSource The layer or source.
	 * @return {import("../renderer/canvas/Layer.js").default} The renderer.
	 */
	function createRenderer(layerOrSource) {
	  var tileSource = /** @type {import("./Tile.js").default} */ (layerOrSource);
	  var imageSource = /** @type {import("./Image.js").default} */ (layerOrSource);
	  var layer = /** @type {import("../layer/Layer.js").default} */ (layerOrSource);
	  var renderer = null;
	  if (typeof tileSource.getTile === 'function') {
	    renderer = createTileRenderer(tileSource);
	  } else if (typeof imageSource.getImage === 'function') {
	    renderer = createImageRenderer(imageSource);
	  } else if (layer.getType() === LayerType.TILE) {
	    renderer = new CanvasTileLayerRenderer(/** @type {import("../layer/Tile.js").default} */ (layer));
	  } else if (layer.getType() == LayerType.IMAGE || layer.getType() == LayerType.VECTOR) {
	    renderer = new CanvasImageLayerRenderer(/** @type {import("../layer/Image.js").default} */ (layer));
	  }
	  return renderer;
	}
	
	
	/**
	 * Create an image renderer for the provided source.
	 * @param {import("./Image.js").default} source The source.
	 * @return {import("../renderer/canvas/Layer.js").default} The renderer.
	 */
	function createImageRenderer(source) {
	  var layer = new ImageLayer({source: source});
	  return new CanvasImageLayerRenderer(layer);
	}
	
	
	/**
	 * Create a tile renderer for the provided source.
	 * @param {import("./Tile.js").default} source The source.
	 * @return {import("../renderer/canvas/Layer.js").default} The renderer.
	 */
	function createTileRenderer(source) {
	  var layer = new TileLayer({source: source});
	  return new CanvasTileLayerRenderer(layer);
	}
	
	/**
	 * @module ol/source/Stamen
	 */
	
	
	/**
	 * @const
	 * @type {Array<string>}
	 */
	var ATTRIBUTIONS = [
	  'Map tiles by <a href="https://stamen.com/">Stamen Design</a>, ' +
	        'under <a href="https://creativecommons.org/licenses/by/3.0/">CC BY' +
	        ' 3.0</a>.',
	  ATTRIBUTION
	];
	
	
	/**
	 * @type {Object<string, {extension: string, opaque: boolean}>}
	 */
	var LayerConfig = {
	  'terrain': {
	    extension: 'jpg',
	    opaque: true
	  },
	  'terrain-background': {
	    extension: 'jpg',
	    opaque: true
	  },
	  'terrain-labels': {
	    extension: 'png',
	    opaque: false
	  },
	  'terrain-lines': {
	    extension: 'png',
	    opaque: false
	  },
	  'toner-background': {
	    extension: 'png',
	    opaque: true
	  },
	  'toner': {
	    extension: 'png',
	    opaque: true
	  },
	  'toner-hybrid': {
	    extension: 'png',
	    opaque: false
	  },
	  'toner-labels': {
	    extension: 'png',
	    opaque: false
	  },
	  'toner-lines': {
	    extension: 'png',
	    opaque: false
	  },
	  'toner-lite': {
	    extension: 'png',
	    opaque: true
	  },
	  'watercolor': {
	    extension: 'jpg',
	    opaque: true
	  }
	};
	
	
	/**
	 * @type {Object<string, {minZoom: number, maxZoom: number}>}
	 */
	var ProviderConfig = {
	  'terrain': {
	    minZoom: 4,
	    maxZoom: 18
	  },
	  'toner': {
	    minZoom: 0,
	    maxZoom: 20
	  },
	  'watercolor': {
	    minZoom: 1,
	    maxZoom: 16
	  }
	};
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {string} layer Layer name.
	 * @property {number} [minZoom] Minimum zoom.
	 * @property {number} [maxZoom] Maximum zoom.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction]
	 * Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for the Stamen tile server.
	 * @api
	 */
	var Stamen = /*@__PURE__*/(function (XYZ$$1) {
	  function Stamen(options) {
	    var i = options.layer.indexOf('-');
	    var provider = i == -1 ? options.layer : options.layer.slice(0, i);
	    var providerConfig = ProviderConfig[provider];
	
	    var layerConfig = LayerConfig[options.layer];
	
	    var url = options.url !== undefined ? options.url :
	      'https://stamen-tiles-{a-d}.a.ssl.fastly.net/' + options.layer +
	        '/{z}/{x}/{y}.' + layerConfig.extension;
	
	    XYZ$$1.call(this, {
	      attributions: ATTRIBUTIONS,
	      cacheSize: options.cacheSize,
	      crossOrigin: 'anonymous',
	      maxZoom: options.maxZoom != undefined ? options.maxZoom : providerConfig.maxZoom,
	      minZoom: options.minZoom != undefined ? options.minZoom : providerConfig.minZoom,
	      opaque: layerConfig.opaque,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileLoadFunction: options.tileLoadFunction,
	      url: url,
	      wrapX: options.wrapX
	    });
	
	  }
	
	  if ( XYZ$$1 ) { Stamen.__proto__ = XYZ$$1; }
	  Stamen.prototype = Object.create( XYZ$$1 && XYZ$$1.prototype );
	  Stamen.prototype.constructor = Stamen;
	
	  return Stamen;
	}(XYZ));
	
	/**
	 * @module ol/source/TileArcGISRest
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.
	 * Note that you must provide a `crossOrigin` value if you are using the WebGL renderer
	 * or if you want to access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
	 * for more detail.
	 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service defaults will be
	 * used for any fields not specified. `FORMAT` is `PNG32` by default. `F` is `IMAGE` by
	 * default. `TRANSPARENT` is `true` by default.  `BBOX`, `SIZE`, `BBOXSR`,
	 * and `IMAGESR` will be set dynamically. Set `LAYERS` to
	 * override the default service layer visibility. See
	 * http://resources.arcgis.com/en/help/arcgis-rest-api/index.html#/Export_Map/02r3000000v7000000/
	 * for further reference.
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
	 * tilesize and extent supported by the server.
	 * If this is not defined, a default grid will be used: if there is a projection
	 * extent, the grid will be based on that; if not, a grid based on a global
	 * extent with origin at 0,0 will be used.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL.
	 * The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {string} [url] ArcGIS Rest service URL for a Map Service or Image Service. The
	 * url should include /MapServer or /ImageServer.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * @property {number} [transition] Duration of the opacity transition for rendering.  To disable the opacity
	 * transition, pass `transition: 0`.
	 * @property {Array<string>} urls ArcGIS Rest service urls. Use this instead of `url` when the ArcGIS
	 * Service supports multiple urls for export requests.
	 * @property {(arg0: number[], arg1: number, arg2: import("../proj/Projection.js").default) => string} tileUrlFunction
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for tile data from ArcGIS Rest services. Map and Image
	 * Services are supported.
	 *
	 * For cached ArcGIS services, better performance is available using the
	 * {@link module:ol/source/XYZ~XYZ} data source.
	 * @api
	 */
	var TileArcGISRest = /*@__PURE__*/(function (TileImage$$1) {
	  function TileArcGISRest(opt_options) {
	
	    var options = opt_options || /** @type {Options} */ ({});
	
	    TileImage$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      projection: options.projection,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileGrid: options.tileGrid,
	      tileLoadFunction: options.tileLoadFunction,
	      // Правки для OMJS. Эта функция перезаписывается в PKK5ArcGISSource.
	      // А тут ее руками записывали в опции без возможности перезаписи этой функции.
	      // Без переопределения этой функции или без костылей тайлы не будут попадать в кэш росреестра
	      tileUrlFunction: options.tileUrlFunction || tileUrlFunction,
	      url: options.url,
	      urls: options.urls,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true,
	      transition: options.transition
	    });
	
	    /**
	     * @private
	     * @type {!Object}
	     */
	    this.params_ = options.params || {};
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.tmpExtent_ = createEmpty();
	
	    this.setKey(this.getKeyForParams_());
	  }
	
	  if ( TileImage$$1 ) { TileArcGISRest.__proto__ = TileImage$$1; }
	  TileArcGISRest.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  TileArcGISRest.prototype.constructor = TileArcGISRest;
	
	  /**
	   * @private
	   * @return {string} The key for the current params.
	   */
	  TileArcGISRest.prototype.getKeyForParams_ = function getKeyForParams_ () {
	    var i = 0;
	    var res = [];
	    for (var key in this.params_) {
	      res[i++] = key + '-' + this.params_[key];
	    }
	    return res.join('/');
	  };
	
	  /**
	   * Get the user-provided params, i.e. those passed to the constructor through
	   * the "params" option, and possibly updated using the updateParams method.
	   * @return {Object} Params.
	   * @api
	   */
	  TileArcGISRest.prototype.getParams = function getParams () {
	    return this.params_;
	  };
	
	  /**
	   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	   * @param {import("../size.js").Size} tileSize Tile size.
	   * @param {import("../extent.js").Extent} tileExtent Tile extent.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {Object} params Params.
	   * @return {string|undefined} Request URL.
	   * @private
	   */
	  TileArcGISRest.prototype.getRequestUrl_ = function getRequestUrl_ (tileCoord, tileSize, tileExtent, pixelRatio, projection, params) {
	
	    var urls = this.urls;
	    if (!urls) {
	      return undefined;
	    }
	
	    // ArcGIS Server only wants the numeric portion of the projection ID.
	    var srid = projection.getCode().split(':').pop();
	
	    params['SIZE'] = tileSize[0] + ',' + tileSize[1];
	    params['BBOX'] = tileExtent.join(',');
	    params['BBOXSR'] = srid;
	    params['IMAGESR'] = srid;
	    params['DPI'] = Math.round(
	      params['DPI'] ? params['DPI'] * pixelRatio : 90 * pixelRatio
	    );
	
	    var url;
	    if (urls.length == 1) {
	      url = urls[0];
	    } else {
	      var index = modulo(hash(tileCoord), urls.length);
	      url = urls[index];
	    }
	
	    var modifiedUrl = url
	      .replace(/MapServer\/?$/, 'MapServer/export')
	      .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
	    return appendParams(modifiedUrl, params);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileArcGISRest.prototype.getTilePixelRatio = function getTilePixelRatio (pixelRatio) {
	    return /** @type {number} */ (pixelRatio);
	  };
	
	  /**
	   * Update the user-provided params.
	   * @param {Object} params Params.
	   * @api
	   */
	  TileArcGISRest.prototype.updateParams = function updateParams (params) {
	    assign(this.params_, params);
	    this.setKey(this.getKeyForParams_());
	  };
	
	  return TileArcGISRest;
	}(TileImage));
	
	/**
	 * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
	 * @param {number} pixelRatio The pixel ratio
	 * @param {import("../proj/Projection.js").default} projection The projection
	 * @return {string|undefined} The tile URL
	 * @this {TileArcGISRest}
	 */
	function tileUrlFunction(tileCoord, pixelRatio, projection) {
	
	  var tileGrid = this.getTileGrid();
	  if (!tileGrid) {
	    tileGrid = this.getTileGridForProjection(projection);
	  }
	
	  if (tileGrid.getResolutions().length <= tileCoord[0]) {
	    return undefined;
	  }
	
	  var tileExtent = tileGrid.getTileCoordExtent(
	    tileCoord, this.tmpExtent_);
	  var tileSize = toSize(
	    tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
	
	  if (pixelRatio != 1) {
	    tileSize = scale$3(tileSize, pixelRatio, this.tmpSize);
	  }
	
	  // Apply default params and override with user specified values.
	  var baseParams = {
	    'F': 'image',
	    'FORMAT': 'PNG32',
	    'TRANSPARENT': true
	  };
	  assign(baseParams, this.params_);
	
	  return this.getRequestUrl_(tileCoord, tileSize, tileExtent,
	    pixelRatio, projection, baseParams);
	}
	
	/**
	 * @module ol/source/TileDebug
	 */
	
	
	var LabeledTile = /*@__PURE__*/(function (Tile$$1) {
	  function LabeledTile(tileCoord, tileSize, text) {
	
	    Tile$$1.call(this, tileCoord, TileState.LOADED);
	
	    /**
	    * @private
	    * @type {import("../size.js").Size}
	    */
	    this.tileSize_ = tileSize;
	
	    /**
	    * @private
	    * @type {string}
	    */
	    this.text_ = text;
	
	    /**
	    * @private
	    * @type {HTMLCanvasElement}
	    */
	    this.canvas_ = null;
	
	  }
	
	  if ( Tile$$1 ) { LabeledTile.__proto__ = Tile$$1; }
	  LabeledTile.prototype = Object.create( Tile$$1 && Tile$$1.prototype );
	  LabeledTile.prototype.constructor = LabeledTile;
	
	  /**
	  * Get the image element for this tile.
	  * @return {HTMLCanvasElement} Image.
	  */
	  LabeledTile.prototype.getImage = function getImage () {
	    if (this.canvas_) {
	      return this.canvas_;
	    } else {
	      var tileSize = this.tileSize_;
	      var context = createCanvasContext2D(tileSize[0], tileSize[1]);
	
	      context.strokeStyle = 'black';
	      context.strokeRect(0.5, 0.5, tileSize[0] + 0.5, tileSize[1] + 0.5);
	
	      context.fillStyle = 'black';
	      context.textAlign = 'center';
	      context.textBaseline = 'middle';
	      context.font = '24px sans-serif';
	      context.fillText(this.text_, tileSize[0] / 2, tileSize[1] / 2);
	
	      this.canvas_ = context.canvas;
	      return context.canvas;
	    }
	  };
	
	  /**
	  * @override
	  */
	  LabeledTile.prototype.load = function load () {};
	
	  return LabeledTile;
	}(Tile));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 */
	
	
	/**
	 * @classdesc
	 * A pseudo tile source, which does not fetch tiles from a server, but renders
	 * a grid outline for the tile grid/projection along with the coordinates for
	 * each tile. See examples/canvas-tiles for an example.
	 *
	 * Uses Canvas context2d, so requires Canvas support.
	 * @api
	 */
	var TileDebug = /*@__PURE__*/(function (TileSource$$1) {
	  function TileDebug(options) {
	
	    TileSource$$1.call(this, {
	      opaque: false,
	      projection: options.projection,
	      tileGrid: options.tileGrid,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true
	    });
	
	  }
	
	  if ( TileSource$$1 ) { TileDebug.__proto__ = TileSource$$1; }
	  TileDebug.prototype = Object.create( TileSource$$1 && TileSource$$1.prototype );
	  TileDebug.prototype.constructor = TileDebug;
	
	  /**
	  * @inheritDoc
	  */
	  TileDebug.prototype.getTile = function getTile (z, x, y) {
	    var tileCoordKey = getKeyZXY(z, x, y);
	    if (this.tileCache.containsKey(tileCoordKey)) {
	      return /** @type {!LabeledTile} */ (this.tileCache.get(tileCoordKey));
	    } else {
	      var tileSize = toSize(this.tileGrid.getTileSize(z));
	      var tileCoord = [z, x, y];
	      var textTileCoord = this.getTileCoordForTileUrlFunction(tileCoord);
	      var text = !textTileCoord ? '' :
	        this.getTileCoordForTileUrlFunction(textTileCoord).toString();
	      var tile = new LabeledTile(tileCoord, tileSize, text);
	      this.tileCache.set(tileCoordKey, tile);
	      return tile;
	    }
	  };
	
	  return TileDebug;
	}(TileSource));
	
	/**
	 * @module ol/source/TileJSON
	 */
	
	
	/**
	 * @typedef {Object} Config
	 * @property {string} [name] The name.
	 * @property {string} [description] The description.
	 * @property {string} [version] The version.
	 * @property {string} [attribution] The attribution.
	 * @property {string} [template] The template.
	 * @property {string} [legend] The legend.
	 * @property {string} [scheme] The scheme.
	 * @property {Array<string>} tiles The tile URL templates.
	 * @property {Array<string>} [grids] Optional grids.
	 * @property {number} [minzoom] Minimum zoom level.
	 * @property {number} [maxzoom] Maximum zoom level.
	 * @property {Array<number>} [bounds] Optional bounds.
	 * @property {Array<number>} [center] Optional center.
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {boolean} [jsonp=false] Use JSONP with callback to load the TileJSON.
	 * Useful when the server does not support CORS..
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {Config} [tileJSON] TileJSON configuration for this source.
	 * If not provided, `url` must be configured.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {string} [url] URL to the TileJSON file. If not provided, `tileJSON` must be configured.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for tile data in TileJSON format.
	 * @api
	 */
	var TileJSON = /*@__PURE__*/(function (TileImage$$1) {
	  function TileJSON(options) {
	    TileImage$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      projection: get$2('EPSG:3857'),
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      state: SourceState.LOADING,
	      tileLoadFunction: options.tileLoadFunction,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true,
	      transition: options.transition
	    });
	
	    /**
	     * @type {Config}
	     * @private
	     */
	    this.tileJSON_ = null;
	
	
	    if (options.url) {
	      if (options.jsonp) {
	        jsonp(options.url, this.handleTileJSONResponse.bind(this),
	          this.handleTileJSONError.bind(this));
	      } else {
	        var client = new XMLHttpRequest();
	        client.addEventListener('load', this.onXHRLoad_.bind(this));
	        client.addEventListener('error', this.onXHRError_.bind(this));
	        client.open('GET', options.url);
	        client.send();
	      }
	    } else if (options.tileJSON) {
	      this.handleTileJSONResponse(options.tileJSON);
	    } else {
	      assert(false, 51); // Either `url` or `tileJSON` options must be provided
	    }
	
	  }
	
	  if ( TileImage$$1 ) { TileJSON.__proto__ = TileImage$$1; }
	  TileJSON.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  TileJSON.prototype.constructor = TileJSON;
	
	  /**
	   * @private
	   * @param {Event} event The load event.
	   */
	  TileJSON.prototype.onXHRLoad_ = function onXHRLoad_ (event) {
	    var client = /** @type {XMLHttpRequest} */ (event.target);
	    // status will be 0 for file:// urls
	    if (!client.status || client.status >= 200 && client.status < 300) {
	      var response;
	      try {
	        response = /** @type {TileJSON} */(JSON.parse(client.responseText));
	      } catch (err) {
	        this.handleTileJSONError();
	        return;
	      }
	      this.handleTileJSONResponse(response);
	    } else {
	      this.handleTileJSONError();
	    }
	  };
	
	  /**
	   * @private
	   * @param {Event} event The error event.
	   */
	  TileJSON.prototype.onXHRError_ = function onXHRError_ (event) {
	    this.handleTileJSONError();
	  };
	
	  /**
	   * @return {Config} The tilejson object.
	   * @api
	   */
	  TileJSON.prototype.getTileJSON = function getTileJSON () {
	    return this.tileJSON_;
	  };
	
	  /**
	   * @protected
	   * @param {Config} tileJSON Tile JSON.
	   */
	  TileJSON.prototype.handleTileJSONResponse = function handleTileJSONResponse (tileJSON) {
	
	    var epsg4326Projection = get$2('EPSG:4326');
	
	    var sourceProjection = this.getProjection();
	    var extent;
	    if (tileJSON['bounds'] !== undefined) {
	      var transform$$1 = getTransformFromProjections(
	        epsg4326Projection, sourceProjection);
	      extent = applyTransform(tileJSON['bounds'], transform$$1);
	    }
	
	    var minZoom = tileJSON['minzoom'] || 0;
	    var maxZoom = tileJSON['maxzoom'] || 22;
	    var tileGrid = createXYZ({
	      extent: extentFromProjection(sourceProjection),
	      maxZoom: maxZoom,
	      minZoom: minZoom
	    });
	    this.tileGrid = tileGrid;
	
	    this.tileUrlFunction = createFromTemplates(tileJSON['tiles'], tileGrid);
	
	    if (tileJSON['attribution'] !== undefined && !this.getAttributions()) {
	      var attributionExtent = extent !== undefined ?
	        extent : epsg4326Projection.getExtent();
	
	      this.setAttributions(function(frameState) {
	        if (intersects(attributionExtent, frameState.extent)) {
	          return [tileJSON['attribution']];
	        }
	        return null;
	      });
	
	    }
	    this.tileJSON_ = tileJSON;
	    this.setState(SourceState.READY);
	
	  };
	
	  /**
	   * @protected
	   */
	  TileJSON.prototype.handleTileJSONError = function handleTileJSONError () {
	    this.setState(SourceState.ERROR);
	  };
	
	  return TileJSON;
	}(TileImage));
	
	/**
	 * @module ol/source/TileWMS
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {Object<string,*>} params WMS request parameters.
	 * At least a `LAYERS` param is required. `STYLES` is
	 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
	 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
	 * @property {number} [gutter=0]
	 * The size in pixels of the gutter around image tiles to ignore. By setting
	 * this property to a non-zero value, images will be requested that are wider
	 * and taller than the tile size by a value of `2 x gutter`.
	 * Using a non-zero value allows artifacts of rendering at tile edges to be
	 * ignored. If you control the WMS service it is recommended to address
	 * "artifacts at tile edges" issues by properly configuring the WMS service. For
	 * example, MapServer has a `tile_map_edge_buffer` configuration parameter for
	 * this. See http://mapserver.org/output/tile_mode.html.
	 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
	 * the image from the remote server.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
	 * Default is {@link module:ol/ImageTile~ImageTile}.
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
	 * tilesize and extent supported by the server.
	 * If this is not defined, a default grid will be used: if there is a projection
	 * extent, the grid will be based on that; if not, a grid based on a global
	 * extent with origin at 0,0 will be used..
	 * @property {import("./WMSServerType.js").default|string} [serverType]
	 * The type of the remote WMS server. Currently only used when `hidpi` is
	 * `true`.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {string} [url] WMS service URL.
	 * @property {Array<string>} [urls] WMS service urls.
	 * Use this instead of `url` when the WMS supports multiple urls for GetMap requests.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * When set to `false`, only one world
	 * will be rendered. When `true`, tiles will be requested for one world only,
	 * but they will be wrapped horizontally to render multiple worlds.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for tile data from WMS servers.
	 * @api
	 */
	var TileWMS = /*@__PURE__*/(function (TileImage$$1) {
	  function TileWMS(opt_options) {
	
	    var options = opt_options || /** @type {Options} */ ({});
	
	    var params = options.params || {};
	
	    var transparent = 'TRANSPARENT' in params ? params['TRANSPARENT'] : true;
	
	    TileImage$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      opaque: !transparent,
	      projection: options.projection,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileClass: options.tileClass,
	      tileGrid: options.tileGrid,
	      tileLoadFunction: options.tileLoadFunction,
	      tileUrlFunction: tileUrlFunction$1,
	      url: options.url,
	      urls: options.urls,
	      wrapX: options.wrapX !== undefined ? options.wrapX : true,
	      transition: options.transition
	    });
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
	
	    /**
	     * @private
	     * @type {!Object}
	     */
	    this.params_ = params;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.v13_ = true;
	
	    /**
	     * @private
	     * @type {import("./WMSServerType.js").default|undefined}
	     */
	    this.serverType_ = /** @type {import("./WMSServerType.js").default|undefined} */ (options.serverType);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.tmpExtent_ = createEmpty();
	
	    this.updateV13_();
	    this.setKey(this.getKeyForParams_());
	
	  }
	
	  if ( TileImage$$1 ) { TileWMS.__proto__ = TileImage$$1; }
	  TileWMS.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  TileWMS.prototype.constructor = TileWMS;
	
	  /**
	   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
	   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
	   * constructed.
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {number} resolution Resolution.
	   * @param {import("../proj.js").ProjectionLike} projection Projection.
	   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
	   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
	   *     in the `LAYERS` parameter will be used. `VERSION` should not be
	   *     specified here.
	   * @return {string|undefined} GetFeatureInfo URL.
	   * @api
	   */
	  TileWMS.prototype.getGetFeatureInfoUrl = function getGetFeatureInfoUrl (coordinate, resolution, projection, params) {
	    var projectionObj = get$2(projection);
	    var sourceProjectionObj = this.getProjection();
	
	    var tileGrid = this.getTileGrid();
	    if (!tileGrid) {
	      tileGrid = this.getTileGridForProjection(projectionObj);
	    }
	
	    var tileCoord = tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution);
	
	    if (tileGrid.getResolutions().length <= tileCoord[0]) {
	      return undefined;
	    }
	
	    var tileResolution = tileGrid.getResolution(tileCoord[0]);
	    var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
	    var tileSize = toSize(tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
	
	
	    var gutter = this.gutter_;
	    if (gutter !== 0) {
	      tileSize = buffer$1(tileSize, gutter, this.tmpSize);
	      tileExtent = buffer(tileExtent, tileResolution * gutter, tileExtent);
	    }
	
	    if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
	      tileResolution = calculateSourceResolution(sourceProjectionObj, projectionObj, coordinate, tileResolution);
	      tileExtent = transformExtent(tileExtent, projectionObj, sourceProjectionObj);
	      coordinate = transform(coordinate, projectionObj, sourceProjectionObj);
	    }
	
	    var baseParams = {
	      'SERVICE': 'WMS',
	      'VERSION': DEFAULT_WMS_VERSION,
	      'REQUEST': 'GetFeatureInfo',
	      'FORMAT': 'image/png',
	      'TRANSPARENT': true,
	      'QUERY_LAYERS': this.params_['LAYERS']
	    };
	    assign(baseParams, this.params_, params);
	
	    var x = Math.floor((coordinate[0] - tileExtent[0]) / tileResolution);
	    var y = Math.floor((tileExtent[3] - coordinate[1]) / tileResolution);
	
	    baseParams[this.v13_ ? 'I' : 'X'] = x;
	    baseParams[this.v13_ ? 'J' : 'Y'] = y;
	
	    return this.getRequestUrl_(tileCoord, tileSize, tileExtent,
	      1, sourceProjectionObj || projectionObj, baseParams);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileWMS.prototype.getGutter = function getGutter () {
	    return this.gutter_;
	  };
	
	  /**
	   * Get the user-provided params, i.e. those passed to the constructor through
	   * the "params" option, and possibly updated using the updateParams method.
	   * @return {Object} Params.
	   * @api
	   */
	  TileWMS.prototype.getParams = function getParams () {
	    return this.params_;
	  };
	
	  /**
	   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	   * @param {import("../size.js").Size} tileSize Tile size.
	   * @param {import("../extent.js").Extent} tileExtent Tile extent.
	   * @param {number} pixelRatio Pixel ratio.
	   * @param {import("../proj/Projection.js").default} projection Projection.
	   * @param {Object} params Params.
	   * @return {string|undefined} Request URL.
	   * @private
	   */
	  TileWMS.prototype.getRequestUrl_ = function getRequestUrl_ (tileCoord, tileSize, tileExtent, pixelRatio, projection, params) {
	
	    var urls = this.urls;
	    if (!urls) {
	      return undefined;
	    }
	
	    params['WIDTH'] = tileSize[0];
	    params['HEIGHT'] = tileSize[1];
	
	    params[this.v13_ ? 'CRS' : 'SRS'] = projection.getCode();
	
	    if (!('STYLES' in this.params_)) {
	      params['STYLES'] = '';
	    }
	
	    if (pixelRatio != 1) {
	      switch (this.serverType_) {
	        case WMSServerType.GEOSERVER:
	          var dpi = (90 * pixelRatio + 0.5) | 0;
	          if ('FORMAT_OPTIONS' in params) {
	            params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
	          } else {
	            params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
	          }
	          break;
	        case WMSServerType.MAPSERVER:
	          params['MAP_RESOLUTION'] = 90 * pixelRatio;
	          break;
	        case WMSServerType.CARMENTA_SERVER:
	        case WMSServerType.QGIS:
	          params['DPI'] = 90 * pixelRatio;
	          break;
	        default:
	          assert(false, 52); // Unknown `serverType` configured
	          break;
	      }
	    }
	
	    var axisOrientation = projection.getAxisOrientation();
	    var bbox = tileExtent;
	    if (this.v13_ && axisOrientation.substr(0, 2) == 'ne') {
	      var tmp;
	      tmp = tileExtent[0];
	      bbox[0] = tileExtent[1];
	      bbox[1] = tmp;
	      tmp = tileExtent[2];
	      bbox[2] = tileExtent[3];
	      bbox[3] = tmp;
	    }
	    params['BBOX'] = bbox.join(',');
	
	    var url;
	    if (urls.length == 1) {
	      url = urls[0];
	    } else {
	      var index = modulo(hash(tileCoord), urls.length);
	      url = urls[index];
	    }
	    return appendParams(url, params);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TileWMS.prototype.getTilePixelRatio = function getTilePixelRatio (pixelRatio) {
	    return (!this.hidpi_ || this.serverType_ === undefined) ? 1 :
	    /** @type {number} */ (pixelRatio);
	  };
	
	  /**
	   * @private
	   * @return {string} The key for the current params.
	   */
	  TileWMS.prototype.getKeyForParams_ = function getKeyForParams_ () {
	    var i = 0;
	    var res = [];
	    for (var key in this.params_) {
	      res[i++] = key + '-' + this.params_[key];
	    }
	    return res.join('/');
	  };
	
	  /**
	   * Update the user-provided params.
	   * @param {Object} params Params.
	   * @api
	   */
	  TileWMS.prototype.updateParams = function updateParams (params) {
	    assign(this.params_, params);
	    this.updateV13_();
	    this.setKey(this.getKeyForParams_());
	  };
	
	  /**
	   * @private
	   */
	  TileWMS.prototype.updateV13_ = function updateV13_ () {
	    var version = this.params_['VERSION'] || DEFAULT_WMS_VERSION;
	    this.v13_ = compareVersions(version, '1.3') >= 0;
	  };
	
	  return TileWMS;
	}(TileImage));
	
	/**
	 * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
	 * @param {number} pixelRatio The pixel ratio
	 * @param {import("../proj/Projection.js").default} projection The projection
	 * @return {string|undefined} The tile URL
	 * @this {TileWMS}
	 */
	function tileUrlFunction$1(tileCoord, pixelRatio, projection) {
	
	  var tileGrid = this.getTileGrid();
	  if (!tileGrid) {
	    tileGrid = this.getTileGridForProjection(projection);
	  }
	
	  if (tileGrid.getResolutions().length <= tileCoord[0]) {
	    return undefined;
	  }
	
	  if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) {
	    pixelRatio = 1;
	  }
	
	  var tileResolution = tileGrid.getResolution(tileCoord[0]);
	  var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
	  var tileSize = toSize(
	    tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
	
	  var gutter = this.gutter_;
	  if (gutter !== 0) {
	    tileSize = buffer$1(tileSize, gutter, this.tmpSize);
	    tileExtent = buffer(tileExtent, tileResolution * gutter, tileExtent);
	  }
	
	  if (pixelRatio != 1) {
	    tileSize = scale$3(tileSize, pixelRatio, this.tmpSize);
	  }
	
	  var baseParams = {
	    'SERVICE': 'WMS',
	    'VERSION': DEFAULT_WMS_VERSION,
	    'REQUEST': 'GetMap',
	    'FORMAT': 'image/png',
	    'TRANSPARENT': true
	  };
	  assign(baseParams, this.params_);
	
	  return this.getRequestUrl_(tileCoord, tileSize, tileExtent,
	    pixelRatio, projection, baseParams);
	}
	
	/**
	 * @module ol/source/UTFGrid
	 */
	
	/**
	 * @typedef {Object} UTFGridJSON
	 * @property {Array<string>} grid The grid.
	 * @property {Array<string>} keys The keys.
	 * @property {Object<string, Object>} [data] Optional data.
	 */
	
	
	var CustomTile = /*@__PURE__*/(function (Tile$$1) {
	  function CustomTile(tileCoord, state, src, extent, preemptive, jsonp$$1) {
	
	    Tile$$1.call(this, tileCoord, state);
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.src_ = src;
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.extent_ = extent;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.preemptive_ = preemptive;
	
	    /**
	     * @private
	     * @type {Array<string>}
	     */
	    this.grid_ = null;
	
	    /**
	     * @private
	     * @type {Array<string>}
	     */
	    this.keys_ = null;
	
	    /**
	     * @private
	     * @type {Object<string, Object>|undefined}
	     */
	    this.data_ = null;
	
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.jsonp_ = jsonp$$1;
	
	  }
	
	  if ( Tile$$1 ) { CustomTile.__proto__ = Tile$$1; }
	  CustomTile.prototype = Object.create( Tile$$1 && Tile$$1.prototype );
	  CustomTile.prototype.constructor = CustomTile;
	
	  /**
	   * Get the image element for this tile.
	   * @return {HTMLImageElement} Image.
	   */
	  CustomTile.prototype.getImage = function getImage () {
	    return null;
	  };
	
	
	  /**
	   * Synchronously returns data at given coordinate (if available).
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @return {*} The data.
	   */
	  CustomTile.prototype.getData = function getData (coordinate) {
	    if (!this.grid_ || !this.keys_) {
	      return null;
	    }
	    var xRelative = (coordinate[0] - this.extent_[0]) /
	        (this.extent_[2] - this.extent_[0]);
	    var yRelative = (coordinate[1] - this.extent_[1]) /
	        (this.extent_[3] - this.extent_[1]);
	
	    var row = this.grid_[Math.floor((1 - yRelative) * this.grid_.length)];
	
	    if (typeof row !== 'string') {
	      return null;
	    }
	
	    var code = row.charCodeAt(Math.floor(xRelative * row.length));
	    if (code >= 93) {
	      code--;
	    }
	    if (code >= 35) {
	      code--;
	    }
	    code -= 32;
	
	    var data = null;
	    if (code in this.keys_) {
	      var id = this.keys_[code];
	      if (this.data_ && id in this.data_) {
	        data = this.data_[id];
	      } else {
	        data = id;
	      }
	    }
	    return data;
	  };
	
	
	  /**
	   * Calls the callback (synchronously by default) with the available data
	   * for given coordinate (or `null` if not yet loaded).
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {function(this: T, *)} callback Callback.
	   * @param {T=} opt_this The object to use as `this` in the callback.
	   * @param {boolean=} opt_request If `true` the callback is always async.
	   *                               The tile data is requested if not yet loaded.
	   * @template T
	   */
	  CustomTile.prototype.forDataAtCoordinate = function forDataAtCoordinate (coordinate, callback, opt_this, opt_request) {
	    if (this.state == TileState.IDLE && opt_request === true) {
	      listenOnce(this, EventType.CHANGE, function(e) {
	        callback.call(opt_this, this.getData(coordinate));
	      }, this);
	      this.loadInternal_();
	    } else {
	      if (opt_request === true) {
	        setTimeout(function() {
	          callback.call(opt_this, this.getData(coordinate));
	        }.bind(this), 0);
	      } else {
	        callback.call(opt_this, this.getData(coordinate));
	      }
	    }
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  CustomTile.prototype.getKey = function getKey () {
	    return this.src_;
	  };
	
	
	  /**
	   * @private
	   */
	  CustomTile.prototype.handleError_ = function handleError_ () {
	    this.state = TileState.ERROR;
	    this.changed();
	  };
	
	
	  /**
	   * @param {!UTFGridJSON} json UTFGrid data.
	   * @private
	   */
	  CustomTile.prototype.handleLoad_ = function handleLoad_ (json) {
	    this.grid_ = json['grid'];
	    this.keys_ = json['keys'];
	    this.data_ = json['data'];
	
	    this.state = TileState.EMPTY;
	    this.changed();
	  };
	
	
	  /**
	   * @private
	   */
	  CustomTile.prototype.loadInternal_ = function loadInternal_ () {
	    if (this.state == TileState.IDLE) {
	      this.state = TileState.LOADING;
	      if (this.jsonp_) {
	        jsonp(this.src_, this.handleLoad_.bind(this),
	          this.handleError_.bind(this));
	      } else {
	        var client = new XMLHttpRequest();
	        client.addEventListener('load', this.onXHRLoad_.bind(this));
	        client.addEventListener('error', this.onXHRError_.bind(this));
	        client.open('GET', this.src_);
	        client.send();
	      }
	    }
	  };
	
	
	  /**
	   * @private
	   * @param {Event} event The load event.
	   */
	  CustomTile.prototype.onXHRLoad_ = function onXHRLoad_ (event) {
	    var client = /** @type {XMLHttpRequest} */ (event.target);
	    // status will be 0 for file:// urls
	    if (!client.status || client.status >= 200 && client.status < 300) {
	      var response;
	      try {
	        response = /** @type {!UTFGridJSON} */(JSON.parse(client.responseText));
	      } catch (err) {
	        this.handleError_();
	        return;
	      }
	      this.handleLoad_(response);
	    } else {
	      this.handleError_();
	    }
	  };
	
	
	  /**
	   * @private
	   * @param {Event} event The error event.
	   */
	  CustomTile.prototype.onXHRError_ = function onXHRError_ (event) {
	    this.handleError_();
	  };
	
	
	  /**
	   * @override
	   */
	  CustomTile.prototype.load = function load () {
	    if (this.preemptive_) {
	      this.loadInternal_();
	    }
	  };
	
	  return CustomTile;
	}(Tile));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {boolean} [preemptive=true]
	 * If `true` the UTFGrid source loads the tiles based on their "visibility".
	 * This improves the speed of response, but increases traffic.
	 * Note that if set to `false`, you need to pass `true` as `opt_request`
	 * to the `forDataAtCoordinateAndResolution` method otherwise no data
	 * will ever be loaded.
	 * @property {boolean} [jsonp=false] Use JSONP with callback to load the TileJSON.
	 * Useful when the server does not support CORS..
	 * @property {import("./TileJSON.js").Config} [tileJSON] TileJSON configuration for this source.
	 * If not provided, `url` must be configured.
	 * @property {string} [url] TileJSON endpoint that provides the configuration for this source.
	 * Request will be made through JSONP. If not provided, `tileJSON` must be configured.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for UTFGrid interaction data loaded from TileJSON format.
	 * @api
	 */
	var UTFGrid = /*@__PURE__*/(function (TileSource$$1) {
	  function UTFGrid(options) {
	    TileSource$$1.call(this, {
	      projection: get$2('EPSG:3857'),
	      state: SourceState.LOADING
	    });
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.preemptive_ = options.preemptive !== undefined ?
	      options.preemptive : true;
	
	    /**
	     * @private
	     * @type {!import("../Tile.js").UrlFunction}
	     */
	    this.tileUrlFunction_ = nullTileUrlFunction;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.template_ = undefined;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.jsonp_ = options.jsonp || false;
	
	    if (options.url) {
	      if (this.jsonp_) {
	        jsonp(options.url, this.handleTileJSONResponse.bind(this),
	          this.handleTileJSONError.bind(this));
	      } else {
	        var client = new XMLHttpRequest();
	        client.addEventListener('load', this.onXHRLoad_.bind(this));
	        client.addEventListener('error', this.onXHRError_.bind(this));
	        client.open('GET', options.url);
	        client.send();
	      }
	    } else if (options.tileJSON) {
	      this.handleTileJSONResponse(options.tileJSON);
	    } else {
	      assert(false, 51); // Either `url` or `tileJSON` options must be provided
	    }
	
	  }
	
	  if ( TileSource$$1 ) { UTFGrid.__proto__ = TileSource$$1; }
	  UTFGrid.prototype = Object.create( TileSource$$1 && TileSource$$1.prototype );
	  UTFGrid.prototype.constructor = UTFGrid;
	
	
	  /**
	   * @private
	   * @param {Event} event The load event.
	   */
	  UTFGrid.prototype.onXHRLoad_ = function onXHRLoad_ (event) {
	    var client = /** @type {XMLHttpRequest} */ (event.target);
	    // status will be 0 for file:// urls
	    if (!client.status || client.status >= 200 && client.status < 300) {
	      var response;
	      try {
	        response = /** @type {import("./TileJSON.js").Config} */(JSON.parse(client.responseText));
	      } catch (err) {
	        this.handleTileJSONError();
	        return;
	      }
	      this.handleTileJSONResponse(response);
	    } else {
	      this.handleTileJSONError();
	    }
	  };
	
	
	  /**
	   * @private
	   * @param {Event} event The error event.
	   */
	  UTFGrid.prototype.onXHRError_ = function onXHRError_ (event) {
	    this.handleTileJSONError();
	  };
	
	
	  /**
	   * Return the template from TileJSON.
	   * @return {string|undefined} The template from TileJSON.
	   * @api
	   */
	  UTFGrid.prototype.getTemplate = function getTemplate () {
	    return this.template_;
	  };
	
	
	  /**
	   * Calls the callback (synchronously by default) with the available data
	   * for given coordinate and resolution (or `null` if not yet loaded or
	   * in case of an error).
	   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	   * @param {number} resolution Resolution.
	   * @param {function(*)} callback Callback.
	   * @param {boolean=} opt_request If `true` the callback is always async.
	   *                               The tile data is requested if not yet loaded.
	   * @api
	   */
	  UTFGrid.prototype.forDataAtCoordinateAndResolution = function forDataAtCoordinateAndResolution (
	    coordinate, resolution, callback, opt_request) {
	    if (this.tileGrid) {
	      var tileCoord = this.tileGrid.getTileCoordForCoordAndResolution(
	        coordinate, resolution);
	      var tile = /** @type {!CustomTile} */(this.getTile(
	        tileCoord[0], tileCoord[1], tileCoord[2], 1, this.getProjection()));
	      tile.forDataAtCoordinate(coordinate, callback, null, opt_request);
	    } else {
	      if (opt_request === true) {
	        setTimeout(function() {
	          callback(null);
	        }, 0);
	      } else {
	        callback(null);
	      }
	    }
	  };
	
	
	  /**
	   * @protected
	   */
	  UTFGrid.prototype.handleTileJSONError = function handleTileJSONError () {
	    this.setState(SourceState.ERROR);
	  };
	
	
	  /**
	   * TODO: very similar to ol/source/TileJSON#handleTileJSONResponse
	   * @protected
	   * @param {import("./TileJSON.js").Config} tileJSON Tile JSON.
	   */
	  UTFGrid.prototype.handleTileJSONResponse = function handleTileJSONResponse (tileJSON) {
	
	    var epsg4326Projection = get$2('EPSG:4326');
	
	    var sourceProjection = this.getProjection();
	    var extent;
	    if (tileJSON['bounds'] !== undefined) {
	      var transform$$1 = getTransformFromProjections(
	        epsg4326Projection, sourceProjection);
	      extent = applyTransform(tileJSON['bounds'], transform$$1);
	    }
	
	    var minZoom = tileJSON['minzoom'] || 0;
	    var maxZoom = tileJSON['maxzoom'] || 22;
	    var tileGrid = createXYZ({
	      extent: extentFromProjection(sourceProjection),
	      maxZoom: maxZoom,
	      minZoom: minZoom
	    });
	    this.tileGrid = tileGrid;
	
	    this.template_ = tileJSON['template'];
	
	    var grids = tileJSON['grids'];
	    if (!grids) {
	      this.setState(SourceState.ERROR);
	      return;
	    }
	
	    this.tileUrlFunction_ = createFromTemplates(grids, tileGrid);
	
	    if (tileJSON['attribution'] !== undefined) {
	      var attributionExtent = extent !== undefined ?
	        extent : epsg4326Projection.getExtent();
	
	      this.setAttributions(function(frameState) {
	        if (intersects(attributionExtent, frameState.extent)) {
	          return [tileJSON['attribution']];
	        }
	        return null;
	      });
	    }
	
	    this.setState(SourceState.READY);
	
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  UTFGrid.prototype.getTile = function getTile (z, x, y, pixelRatio, projection) {
	    var tileCoordKey = getKeyZXY(z, x, y);
	    if (this.tileCache.containsKey(tileCoordKey)) {
	      return (
	        /** @type {!import("../Tile.js").default} */ (this.tileCache.get(tileCoordKey))
	      );
	    } else {
	      var tileCoord = [z, x, y];
	      var urlTileCoord =
	          this.getTileCoordForTileUrlFunction(tileCoord, projection);
	      var tileUrl = this.tileUrlFunction_(urlTileCoord, pixelRatio, projection);
	      var tile = new CustomTile(
	        tileCoord,
	        tileUrl !== undefined ? TileState.IDLE : TileState.EMPTY,
	        tileUrl !== undefined ? tileUrl : '',
	        this.tileGrid.getTileCoordExtent(tileCoord),
	        this.preemptive_,
	        this.jsonp_);
	      this.tileCache.set(tileCoordKey, tile);
	      return tile;
	    }
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  UTFGrid.prototype.useTile = function useTile (z, x, y) {
	    var tileCoordKey = getKeyZXY(z, x, y);
	    if (this.tileCache.containsKey(tileCoordKey)) {
	      this.tileCache.get(tileCoordKey);
	    }
	  };
	
	  return UTFGrid;
	}(TileSource));
	
	/**
	 * @module ol/source/VectorTile
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=128] Cache size.
	 * @property {import("../extent.js").Extent} [extent]
	 * @property {import("../format/Feature.js").default} [format] Feature format for tiles. Used and required by the default.
	 * @property {boolean} [overlaps=true] This source may have overlapping geometries. Setting this
	 * to `false` (e.g. for sources with polygons that represent administrative
	 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
	 * stroke operations.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {import("./State.js").default} [state] Source state.
	 * @property {typeof import("../VectorTile.js").default} [tileClass] Class used to instantiate image tiles.
	 * Default is {@link module:ol/VectorTile}.
	 * @property {number} [maxZoom=22] Optional max zoom level.
	 * @property {number} [minZoom] Optional min zoom level.
	 * @property {number|import("../size.js").Size} [tileSize=512] Optional tile size.
	 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction]
	 * Optional function to load a tile given a URL. Could look like this:
	 * ```js
	 * function(tile, url) {
	 *   tile.setLoader(function() {
	 *     var data = // ... fetch data
	 *     var format = tile.getFormat();
	 *     tile.setProjection(format.readProjection(data));
	 *     tile.setFeatures(format.readFeatures(data, {
	 *       // featureProjection is not required for ol/format/MVT
	 *       featureProjection: map.getView().getProjection()
	 *     }));
	 *     // the line below is only required for ol/format/MVT
	 *     tile.setExtent(format.getLastExtent());
	 *   }
	 * });
	 * ```
	 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
	 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
	 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
	 * used instead of defining each one separately in the `urls` option.
	 * @property {number} [transition] A duration for tile opacity
	 * transitions in milliseconds. A duration of 0 disables the opacity transition.
	 * @property {Array<string>} [urls] An array of URL templates.
	 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
	 * When set to `false`, only one world
	 * will be rendered. When set to `true`, tiles will be wrapped horizontally to
	 * render multiple worlds.
	 */
	
	
	/**
	 * @classdesc
	 * Class for layer sources providing vector data divided into a tile grid, to be
	 * used with {@link module:ol/layer/VectorTile~VectorTile}. Although this source receives tiles
	 * with vector features from the server, it is not meant for feature editing.
	 * Features are optimized for rendering, their geometries are clipped at or near
	 * tile boundaries and simplified for a view resolution. See
	 * {@link module:ol/source/Vector} for vector sources that are suitable for feature
	 * editing.
	 *
	 * @fires import("./Tile.js").TileSourceEvent
	 * @api
	 */
	var VectorTile$1 = /*@__PURE__*/(function (UrlTile$$1) {
	  function VectorTile$$1(options) {
	    var projection = options.projection || 'EPSG:3857';
	
	    var extent = options.extent || extentFromProjection(projection);
	
	    var tileGrid = options.tileGrid || createXYZ({
	      extent: extent,
	      maxZoom: options.maxZoom || 22,
	      minZoom: options.minZoom,
	      tileSize: options.tileSize || 512
	    });
	
	    UrlTile$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize !== undefined ? options.cacheSize : 128,
	      opaque: false,
	      projection: projection,
	      state: options.state,
	      tileGrid: tileGrid,
	      tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : defaultLoadFunction,
	      tileUrlFunction: options.tileUrlFunction,
	      url: options.url,
	      urls: options.urls,
	      wrapX: options.wrapX === undefined ? true : options.wrapX,
	      transition: options.transition
	    });
	
	    /**
	     * @private
	     * @type {import("../format/Feature.js").default}
	     */
	    this.format_ = options.format ? options.format : null;
	
	    /**
	       * @private
	       * @type {Object<string, Tile>}
	       */
	    this.sourceTiles_ = {};
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.overlaps_ = options.overlaps == undefined ? true : options.overlaps;
	
	    /**
	     * @protected
	     * @type {typeof import("../VectorTile.js").default}
	     */
	    this.tileClass = options.tileClass ? options.tileClass : VectorTile;
	
	    /**
	     * @private
	     * @type {Object<string, import("../tilegrid/TileGrid.js").default>}
	     */
	    this.tileGrids_ = {};
	
	  }
	
	  if ( UrlTile$$1 ) { VectorTile$$1.__proto__ = UrlTile$$1; }
	  VectorTile$$1.prototype = Object.create( UrlTile$$1 && UrlTile$$1.prototype );
	  VectorTile$$1.prototype.constructor = VectorTile$$1;
	
	  /**
	   * @return {boolean} The source can have overlapping geometries.
	   */
	  VectorTile$$1.prototype.getOverlaps = function getOverlaps () {
	    return this.overlaps_;
	  };
	
	  /**
	   * clear {@link module:ol/TileCache~TileCache} and delete all source tiles
	   * @api
	   */
	  VectorTile$$1.prototype.clear = function clear () {
	    this.tileCache.clear();
	    this.sourceTiles_ = {};
	  };
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile$$1.prototype.getTile = function getTile (z, x, y, pixelRatio, projection) {
	    var tileCoordKey = getKeyZXY(z, x, y);
	    if (this.tileCache.containsKey(tileCoordKey)) {
	      return (
	        /** @type {!import("../Tile.js").default} */ (this.tileCache.get(tileCoordKey))
	      );
	    } else {
	      var tileCoord = [z, x, y];
	      var urlTileCoord = this.getTileCoordForTileUrlFunction(
	        tileCoord, projection);
	      var tile = new VectorImageTile(
	        tileCoord,
	        urlTileCoord !== null ? TileState.IDLE : TileState.EMPTY,
	        this.getRevision(),
	        this.format_, this.tileLoadFunction, urlTileCoord, this.tileUrlFunction,
	        this.tileGrid, this.getTileGridForProjection(projection),
	        this.sourceTiles_, pixelRatio, projection, this.tileClass,
	        this.handleTileChange.bind(this), tileCoord[0]);
	
	      this.tileCache.set(tileCoordKey, tile);
	      return tile;
	    }
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile$$1.prototype.getTileGridForProjection = function getTileGridForProjection (projection) {
	    var code = projection.getCode();
	    var tileGrid = this.tileGrids_[code];
	    if (!tileGrid) {
	      // A tile grid that matches the tile size of the source tile grid is more
	      // likely to have 1:1 relationships between source tiles and rendered tiles.
	      var sourceTileGrid = this.tileGrid;
	      tileGrid = this.tileGrids_[code] = createForProjection(projection, undefined,
	        sourceTileGrid ? sourceTileGrid.getTileSize(sourceTileGrid.getMinZoom()) : undefined);
	    }
	    return tileGrid;
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile$$1.prototype.getTilePixelRatio = function getTilePixelRatio (pixelRatio) {
	    return pixelRatio;
	  };
	
	
	  /**
	   * @inheritDoc
	   */
	  VectorTile$$1.prototype.getTilePixelSize = function getTilePixelSize (z, pixelRatio, projection) {
	    var tileGrid = this.getTileGridForProjection(projection);
	    var tileSize = toSize(tileGrid.getTileSize(z), this.tmpSize);
	    return [Math.round(tileSize[0] * pixelRatio), Math.round(tileSize[1] * pixelRatio)];
	  };
	
	  return VectorTile$$1;
	}(UrlTile));
	
	/**
	 * @module ol/source/WMTSRequestEncoding
	 */
	
	/**
	 * Request encoding. One of 'KVP', 'REST'.
	 * @enum {string}
	 */
	var WMTSRequestEncoding = {
	  KVP: 'KVP', // see spec §8
	  REST: 'REST' // see spec §10
	};
	
	/**
	 * @module ol/source/WMTS
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {import("../tilegrid/WMTS.js").default} tileGrid Tile grid.
	 * @property {import("../proj.js").ProjectionLike} projection Projection.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {import("./WMTSRequestEncoding.js").default|string} [requestEncoding='KVP'] Request encoding.
	 * @property {string} layer Layer name as advertised in the WMTS capabilities.
	 * @property {string} style Style name as advertised in the WMTS capabilities.
	 * @property {typeof import("../ImageTile.js").default} [tileClass]  Class used to instantiate image tiles. Default is {@link module:ol/ImageTile~ImageTile}.
	 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
	 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
	 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
	 * should be set to `2`.
	 * @property {string} [format='image/jpeg'] Image format. Only used when `requestEncoding` is `'KVP'`.
	 * @property {string} [version='1.0.0'] WMTS version.
	 * @property {string} matrixSet Matrix set.
	 * @property {!Object} [dimensions] Additional "dimensions" for tile requests.
	 * This is an object with properties named like the advertised WMTS dimensions.
	 * @property {string} [url]  A URL for the service.
	 * For the RESTful request encoding, this is a URL
	 * template.  For KVP encoding, it is normal URL. A `{?-?}` template pattern,
	 * for example `subdomain{a-f}.domain.com`, may be used instead of defining
	 * each one separately in the `urls` option.
	 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
	 * ```js
	 * function(imageTile, src) {
	 *   imageTile.getImage().src = src;
	 * };
	 * ```
	 * @property {Array<string>} [urls] An array of URLs.
	 * Requests will be distributed among the URLs in this array.
	 * @property {boolean} [wrapX=false] Whether to wrap the world horizontally.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for tile data from WMTS servers.
	 * @api
	 */
	var WMTS = /*@__PURE__*/(function (TileImage$$1) {
	  function WMTS(options) {
	
	    // TODO: add support for TileMatrixLimits
	
	    var requestEncoding = options.requestEncoding !== undefined ?
	      /** @type {import("./WMTSRequestEncoding.js").default} */ (options.requestEncoding) :
	      WMTSRequestEncoding.KVP;
	
	    // FIXME: should we create a default tileGrid?
	    // we could issue a getCapabilities xhr to retrieve missing configuration
	    var tileGrid = options.tileGrid;
	
	    var urls = options.urls;
	    if (urls === undefined && options.url !== undefined) {
	      urls = expandUrl(options.url);
	    }
	
	    TileImage$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      projection: options.projection,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileClass: options.tileClass,
	      tileGrid: tileGrid,
	      tileLoadFunction: options.tileLoadFunction,
	      tilePixelRatio: options.tilePixelRatio,
	      tileUrlFunction: nullTileUrlFunction,
	      urls: urls,
	      wrapX: options.wrapX !== undefined ? options.wrapX : false,
	      transition: options.transition
	    });
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.version_ = options.version !== undefined ? options.version : '1.0.0';
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.format_ = options.format !== undefined ? options.format : 'image/jpeg';
	
	    /**
	     * @private
	     * @type {!Object}
	     */
	    this.dimensions_ = options.dimensions !== undefined ? options.dimensions : {};
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.layer_ = options.layer;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.matrixSet_ = options.matrixSet;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.style_ = options.style;
	
	    // FIXME: should we guess this requestEncoding from options.url(s)
	    //        structure? that would mean KVP only if a template is not provided.
	
	    /**
	     * @private
	     * @type {import("./WMTSRequestEncoding.js").default}
	     */
	    this.requestEncoding_ = requestEncoding;
	
	    this.setKey(this.getKeyForDimensions_());
	
	    if (urls && urls.length > 0) {
	      this.tileUrlFunction = createFromTileUrlFunctions(urls.map(createFromWMTSTemplate.bind(this)));
	    }
	
	  }
	
	  if ( TileImage$$1 ) { WMTS.__proto__ = TileImage$$1; }
	  WMTS.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  WMTS.prototype.constructor = WMTS;
	
	  /**
	   * Set the URLs to use for requests.
	   * URLs may contain OCG conform URL Template Variables: {TileMatrix}, {TileRow}, {TileCol}.
	   * @override
	   */
	  WMTS.prototype.setUrls = function setUrls (urls) {
	    this.urls = urls;
	    var key = urls.join('\n');
	    this.setTileUrlFunction(createFromTileUrlFunctions(urls.map(createFromWMTSTemplate.bind(this))), key);
	  };
	
	  /**
	   * Get the dimensions, i.e. those passed to the constructor through the
	   * "dimensions" option, and possibly updated using the updateDimensions
	   * method.
	   * @return {!Object} Dimensions.
	   * @api
	   */
	  WMTS.prototype.getDimensions = function getDimensions () {
	    return this.dimensions_;
	  };
	
	
	  /**
	   * Return the image format of the WMTS source.
	   * @return {string} Format.
	   * @api
	   */
	  WMTS.prototype.getFormat = function getFormat () {
	    return this.format_;
	  };
	
	
	  /**
	   * Return the layer of the WMTS source.
	   * @return {string} Layer.
	   * @api
	   */
	  WMTS.prototype.getLayer = function getLayer () {
	    return this.layer_;
	  };
	
	
	  /**
	   * Return the matrix set of the WMTS source.
	   * @return {string} MatrixSet.
	   * @api
	   */
	  WMTS.prototype.getMatrixSet = function getMatrixSet () {
	    return this.matrixSet_;
	  };
	
	
	  /**
	   * Return the request encoding, either "KVP" or "REST".
	   * @return {import("./WMTSRequestEncoding.js").default} Request encoding.
	   * @api
	   */
	  WMTS.prototype.getRequestEncoding = function getRequestEncoding () {
	    return this.requestEncoding_;
	  };
	
	
	  /**
	   * Return the style of the WMTS source.
	   * @return {string} Style.
	   * @api
	   */
	  WMTS.prototype.getStyle = function getStyle () {
	    return this.style_;
	  };
	
	
	  /**
	   * Return the version of the WMTS source.
	   * @return {string} Version.
	   * @api
	   */
	  WMTS.prototype.getVersion = function getVersion () {
	    return this.version_;
	  };
	
	
	  /**
	   * @private
	   * @return {string} The key for the current dimensions.
	   */
	  WMTS.prototype.getKeyForDimensions_ = function getKeyForDimensions_ () {
	    var i = 0;
	    var res = [];
	    for (var key in this.dimensions_) {
	      res[i++] = key + '-' + this.dimensions_[key];
	    }
	    return res.join('/');
	  };
	
	
	  /**
	   * Update the dimensions.
	   * @param {Object} dimensions Dimensions.
	   * @api
	   */
	  WMTS.prototype.updateDimensions = function updateDimensions (dimensions) {
	    assign(this.dimensions_, dimensions);
	    this.setKey(this.getKeyForDimensions_());
	  };
	
	  return WMTS;
	}(TileImage));
	
	/**
	 * Generate source options from a capabilities object.
	 * @param {Object} wmtsCap An object representing the capabilities document.
	 * @param {!Object} config Configuration properties for the layer.  Defaults for
	 *                  the layer will apply if not provided.
	 *
	 * Required config properties:
	 *  - layer - {string} The layer identifier.
	 *
	 * Optional config properties:
	 *  - matrixSet - {string} The matrix set identifier, required if there is
	 *       more than one matrix set in the layer capabilities.
	 *  - projection - {string} The desired CRS when no matrixSet is specified.
	 *       eg: "EPSG:3857". If the desired projection is not available,
	 *       an error is thrown.
	 *  - requestEncoding - {string} url encoding format for the layer. Default is
	 *       the first tile url format found in the GetCapabilities response.
	 *  - style - {string} The name of the style
	 *  - format - {string} Image format for the layer. Default is the first
	 *       format returned in the GetCapabilities response.
	 *  - crossOrigin - {string|null|undefined} Cross origin. Default is `undefined`.
	 * @return {?Options} WMTS source options object or `null` if the layer was not found.
	 * @api
	 */
	function optionsFromCapabilities(wmtsCap, config) {
	  var layers = wmtsCap['Contents']['Layer'];
	  var l = find(layers, function(elt, index, array) {
	    return elt['Identifier'] == config['layer'];
	  });
	  if (l === null) {
	    return null;
	  }
	  var tileMatrixSets = wmtsCap['Contents']['TileMatrixSet'];
	  var idx;
	  if (l['TileMatrixSetLink'].length > 1) {
	    if ('projection' in config) {
	      idx = findIndex(l['TileMatrixSetLink'],
	        function(elt, index, array) {
	          var tileMatrixSet = find(tileMatrixSets, function(el) {
	            return el['Identifier'] == elt['TileMatrixSet'];
	          });
	          var supportedCRS = tileMatrixSet['SupportedCRS'];
	          var proj1 = get$2(supportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/, '$1:$3')) ||
	                get$2(supportedCRS);
	          var proj2 = get$2(config['projection']);
	          if (proj1 && proj2) {
	            return equivalent(proj1, proj2);
	          } else {
	            return supportedCRS == config['projection'];
	          }
	        });
	    } else {
	      idx = findIndex(l['TileMatrixSetLink'],
	        function(elt, index, array) {
	          return elt['TileMatrixSet'] == config['matrixSet'];
	        });
	    }
	  } else {
	    idx = 0;
	  }
	  if (idx < 0) {
	    idx = 0;
	  }
	  var matrixSet = /** @type {string} */
	    (l['TileMatrixSetLink'][idx]['TileMatrixSet']);
	  var matrixLimits = /** @type {Array<Object>} */
	    (l['TileMatrixSetLink'][idx]['TileMatrixSetLimits']);
	
	  var format = /** @type {string} */ (l['Format'][0]);
	  if ('format' in config) {
	    format = config['format'];
	  }
	  idx = findIndex(l['Style'], function(elt, index, array) {
	    if ('style' in config) {
	      return elt['Title'] == config['style'];
	    } else {
	      return elt['isDefault'];
	    }
	  });
	  if (idx < 0) {
	    idx = 0;
	  }
	  var style = /** @type {string} */ (l['Style'][idx]['Identifier']);
	
	  var dimensions = {};
	  if ('Dimension' in l) {
	    l['Dimension'].forEach(function(elt, index, array) {
	      var key = elt['Identifier'];
	      var value = elt['Default'];
	      if (value === undefined) {
	        value = elt['Value'][0];
	      }
	      dimensions[key] = value;
	    });
	  }
	
	  var matrixSets = wmtsCap['Contents']['TileMatrixSet'];
	  var matrixSetObj = find(matrixSets, function(elt, index, array) {
	    return elt['Identifier'] == matrixSet;
	  });
	
	  var projection;
	  var code = matrixSetObj['SupportedCRS'];
	  if (code) {
	    projection = get$2(code.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/, '$1:$3')) ||
	        get$2(code);
	  }
	  if ('projection' in config) {
	    var projConfig = get$2(config['projection']);
	    if (projConfig) {
	      if (!projection || equivalent(projConfig, projection)) {
	        projection = projConfig;
	      }
	    }
	  }
	
	  var wgs84BoundingBox = l['WGS84BoundingBox'];
	  var extent, wrapX;
	  if (wgs84BoundingBox !== undefined) {
	    var wgs84ProjectionExtent = get$2('EPSG:4326').getExtent();
	    wrapX = (wgs84BoundingBox[0] == wgs84ProjectionExtent[0] &&
	        wgs84BoundingBox[2] == wgs84ProjectionExtent[2]);
	    extent = transformExtent(
	      wgs84BoundingBox, 'EPSG:4326', projection);
	    var projectionExtent = projection.getExtent();
	    if (projectionExtent) {
	      // If possible, do a sanity check on the extent - it should never be
	      // bigger than the validity extent of the projection of a matrix set.
	      if (!containsExtent(projectionExtent, extent)) {
	        extent = undefined;
	      }
	    }
	  }
	
	  var tileGrid = createFromCapabilitiesMatrixSet(matrixSetObj, extent, matrixLimits);
	
	  /** @type {!Array<string>} */
	  var urls = [];
	  var requestEncoding = config['requestEncoding'];
	  requestEncoding = requestEncoding !== undefined ? requestEncoding : '';
	
	  if ('OperationsMetadata' in wmtsCap && 'GetTile' in wmtsCap['OperationsMetadata']) {
	    var gets = wmtsCap['OperationsMetadata']['GetTile']['DCP']['HTTP']['Get'];
	
	    for (var i = 0, ii = gets.length; i < ii; ++i) {
	      if (gets[i]['Constraint']) {
	        var constraint = find(gets[i]['Constraint'], function(element) {
	          return element['name'] == 'GetEncoding';
	        });
	        var encodings = constraint['AllowedValues']['Value'];
	
	        if (requestEncoding === '') {
	          // requestEncoding not provided, use the first encoding from the list
	          requestEncoding = encodings[0];
	        }
	        if (requestEncoding === WMTSRequestEncoding.KVP) {
	          if (includes(encodings, WMTSRequestEncoding.KVP)) {
	            urls.push(/** @type {string} */ (gets[i]['href']));
	          }
	        } else {
	          break;
	        }
	      } else if (gets[i]['href']) {
	        requestEncoding = WMTSRequestEncoding.KVP;
	        urls.push(/** @type {string} */ (gets[i]['href']));
	      }
	    }
	  }
	  if (urls.length === 0) {
	    requestEncoding = WMTSRequestEncoding.REST;
	    l['ResourceURL'].forEach(function(element) {
	      if (element['resourceType'] === 'tile') {
	        format = element['format'];
	        urls.push(/** @type {string} */ (element['template']));
	      }
	    });
	  }
	
	  return {
	    urls: urls,
	    layer: config['layer'],
	    matrixSet: matrixSet,
	    format: format,
	    projection: projection,
	    requestEncoding: requestEncoding,
	    tileGrid: tileGrid,
	    style: style,
	    dimensions: dimensions,
	    wrapX: wrapX,
	    crossOrigin: config['crossOrigin']
	  };
	}
	
	/**
	 * @param {string} template Template.
	 * @return {import("../Tile.js").UrlFunction} Tile URL function.
	 * @this {WMTS}
	 */
	function createFromWMTSTemplate(template) {
	  var requestEncoding = this.requestEncoding_;
	
	  // context property names are lower case to allow for a case insensitive
	  // replacement as some services use different naming conventions
	  var context = {
	    'layer': this.layer_,
	    'style': this.style_,
	    'tilematrixset': this.matrixSet_
	  };
	
	  if (requestEncoding == WMTSRequestEncoding.KVP) {
	    assign(context, {
	      'Service': 'WMTS',
	      'Request': 'GetTile',
	      'Version': this.version_,
	      'Format': this.format_
	    });
	  }
	
	  // TODO: we may want to create our own appendParams function so that params
	  // order conforms to wmts spec guidance, and so that we can avoid to escape
	  // special template params
	
	  template = (requestEncoding == WMTSRequestEncoding.KVP) ?
	    appendParams(template, context) :
	    template.replace(/\{(\w+?)\}/g, function(m, p) {
	      return (p.toLowerCase() in context) ? context[p.toLowerCase()] : m;
	    });
	
	  var tileGrid = /** @type {import("../tilegrid/WMTS.js").default} */ (
	    this.tileGrid);
	  var dimensions = this.dimensions_;
	
	  return (
	    /**
	     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
	     * @param {number} pixelRatio Pixel ratio.
	     * @param {import("../proj/Projection.js").default} projection Projection.
	     * @return {string|undefined} Tile URL.
	     */
	    function(tileCoord, pixelRatio, projection) {
	      if (!tileCoord) {
	        return undefined;
	      } else {
	        var localContext = {
	          'TileMatrix': tileGrid.getMatrixId(tileCoord[0]),
	          'TileCol': tileCoord[1],
	          'TileRow': -tileCoord[2] - 1
	        };
	        assign(localContext, dimensions);
	        var url = template;
	        if (requestEncoding == WMTSRequestEncoding.KVP) {
	          url = appendParams(url, localContext);
	        } else {
	          url = url.replace(/\{(\w+?)\}/g, function(m, p) {
	            return localContext[p];
	          });
	        }
	        return url;
	      }
	    }
	  );
	}
	
	/**
	 * @module ol/source/Zoomify
	 */
	
	
	/**
	 * @enum {string}
	 */
	var TierSizeCalculation = {
	  DEFAULT: 'default',
	  TRUNCATED: 'truncated'
	};
	
	
	var CustomTile$1 = /*@__PURE__*/(function (ImageTile$$1) {
	  function CustomTile(tileGrid, tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
	
	    ImageTile$$1.call(this, tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options);
	
	    /**
	     * @private
	     * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
	     */
	    this.zoomifyImage_ = null;
	
	    /**
	     * @private
	     * @type {import("../size.js").Size}
	     */
	    this.tileSize_ = toSize(tileGrid.getTileSize(tileCoord[0]));
	
	  }
	
	  if ( ImageTile$$1 ) { CustomTile.__proto__ = ImageTile$$1; }
	  CustomTile.prototype = Object.create( ImageTile$$1 && ImageTile$$1.prototype );
	  CustomTile.prototype.constructor = CustomTile;
	
	  /**
	   * @inheritDoc
	   */
	  CustomTile.prototype.getImage = function getImage () {
	    if (this.zoomifyImage_) {
	      return this.zoomifyImage_;
	    }
	    var image = ImageTile$$1.prototype.getImage.call(this);
	    if (this.state == TileState.LOADED) {
	      var tileSize = this.tileSize_;
	      if (image.width == tileSize[0] && image.height == tileSize[1]) {
	        this.zoomifyImage_ = image;
	        return image;
	      } else {
	        var context = createCanvasContext2D(tileSize[0], tileSize[1]);
	        context.drawImage(image, 0, 0);
	        this.zoomifyImage_ = context.canvas;
	        return context.canvas;
	      }
	    } else {
	      return image;
	    }
	  };
	
	  return CustomTile;
	}(ImageTile));
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
	 * @property {number} [cacheSize=2048] Cache size.
	 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
	 * you must provide a `crossOrigin` value if you are using the WebGL renderer or if you want to
	 * access pixel data with the Canvas renderer.  See
	 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
	 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
	 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
	 * Higher values can increase reprojection performance, but decrease precision.
	 * @property {string} [url] URL template or base URL of the Zoomify service.
	 * A base URL is the fixed part
	 * of the URL, excluding the tile group, z, x, and y folder structure, e.g.
	 * `http://my.zoomify.info/IMAGE.TIF/`. A URL template must include
	 * `{TileGroup}`, `{x}`, `{y}`, and `{z}` placeholders, e.g.
	 * `http://my.zoomify.info/IMAGE.TIF/{TileGroup}/{z}-{x}-{y}.jpg`.
	 * Internet Imaging Protocol (IIP) with JTL extension can be also used with
	 * `{tileIndex}` and `{z}` placeholders, e.g.
	 * `http://my.zoomify.info?FIF=IMAGE.TIF&JTL={z},{tileIndex}`.
	 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
	 * used instead of defining each one separately in the `urls` option.
	 * @property {string} [tierSizeCalculation] Tier size calculation method: `default` or `truncated`.
	 * @property {import("../size.js").Size} [size] Size of the image.
	 * @property {import("../extent.js").Extent} [extent] Extent for the TileGrid that is created.
	 * Default sets the TileGrid in the
	 * fourth quadrant, meaning extent is `[0, -height, width, 0]`. To change the
	 * extent to the first quadrant (the default for OpenLayers 2) set the extent
	 * as `[0, 0, width, height]`.
	 * @property {number} [transition] Duration of the opacity transition for rendering.
	 * To disable the opacity transition, pass `transition: 0`.
	 * @property {number} [tileSize=256] Tile size. Same tile size is used for all zoom levels.
	 */
	
	
	/**
	 * @classdesc
	 * Layer source for tile data in Zoomify format (both Zoomify and Internet
	 * Imaging Protocol are supported).
	 * @api
	 */
	var Zoomify = /*@__PURE__*/(function (TileImage$$1) {
	  function Zoomify(opt_options) {
	
	    var options = opt_options || {};
	
	    var size = options.size;
	    var tierSizeCalculation = options.tierSizeCalculation !== undefined ?
	      options.tierSizeCalculation :
	      TierSizeCalculation.DEFAULT;
	
	    var imageWidth = size[0];
	    var imageHeight = size[1];
	    var extent = options.extent || [0, -size[1], size[0], 0];
	    var tierSizeInTiles = [];
	    var tileSize = options.tileSize || DEFAULT_TILE_SIZE;
	    var tileSizeForTierSizeCalculation = tileSize;
	
	    switch (tierSizeCalculation) {
	      case TierSizeCalculation.DEFAULT:
	        while (imageWidth > tileSizeForTierSizeCalculation || imageHeight > tileSizeForTierSizeCalculation) {
	          tierSizeInTiles.push([
	            Math.ceil(imageWidth / tileSizeForTierSizeCalculation),
	            Math.ceil(imageHeight / tileSizeForTierSizeCalculation)
	          ]);
	          tileSizeForTierSizeCalculation += tileSizeForTierSizeCalculation;
	        }
	        break;
	      case TierSizeCalculation.TRUNCATED:
	        var width = imageWidth;
	        var height = imageHeight;
	        while (width > tileSizeForTierSizeCalculation || height > tileSizeForTierSizeCalculation) {
	          tierSizeInTiles.push([
	            Math.ceil(width / tileSizeForTierSizeCalculation),
	            Math.ceil(height / tileSizeForTierSizeCalculation)
	          ]);
	          width >>= 1;
	          height >>= 1;
	        }
	        break;
	      default:
	        assert(false, 53); // Unknown `tierSizeCalculation` configured
	        break;
	    }
	
	    tierSizeInTiles.push([1, 1]);
	    tierSizeInTiles.reverse();
	
	    var resolutions = [1];
	    var tileCountUpToTier = [0];
	    for (var i = 1, ii = tierSizeInTiles.length; i < ii; i++) {
	      resolutions.push(1 << i);
	      tileCountUpToTier.push(
	        tierSizeInTiles[i - 1][0] * tierSizeInTiles[i - 1][1] +
	          tileCountUpToTier[i - 1]
	      );
	    }
	    resolutions.reverse();
	
	    var tileGrid = new TileGrid({
	      tileSize: tileSize,
	      extent: extent,
	      origin: getTopLeft(extent),
	      resolutions: resolutions
	    });
	
	    var url = options.url;
	    if (url && url.indexOf('{TileGroup}') == -1 && url.indexOf('{tileIndex}') == -1) {
	      url += '{TileGroup}/{z}-{x}-{y}.jpg';
	    }
	    var urls = expandUrl(url);
	
	    /**
	     * @param {string} template Template.
	     * @return {import("../Tile.js").UrlFunction} Tile URL function.
	     */
	    function createFromTemplate$$1(template) {
	
	      return (
	        /**
	         * @param {import("../tilecoord.js").TileCoord} tileCoord Tile Coordinate.
	         * @param {number} pixelRatio Pixel ratio.
	         * @param {import("../proj/Projection.js").default} projection Projection.
	         * @return {string|undefined} Tile URL.
	         */
	        function(tileCoord, pixelRatio, projection) {
	          if (!tileCoord) {
	            return undefined;
	          } else {
	            var tileCoordZ = tileCoord[0];
	            var tileCoordX = tileCoord[1];
	            var tileCoordY = -tileCoord[2] - 1;
	            var tileIndex =
	                tileCoordX +
	                tileCoordY * tierSizeInTiles[tileCoordZ][0];
	            var tileSize = tileGrid.getTileSize(tileCoordZ);
	            var tileWidth = Array.isArray(tileSize) ? tileSize[0] : tileSize;
	            var tileGroup = ((tileIndex + tileCountUpToTier[tileCoordZ]) / tileWidth) | 0;
	            var localContext = {
	              'z': tileCoordZ,
	              'x': tileCoordX,
	              'y': tileCoordY,
	              'tileIndex': tileIndex,
	              'TileGroup': 'TileGroup' + tileGroup
	            };
	            return template.replace(/\{(\w+?)\}/g, function(m, p) {
	              return localContext[p];
	            });
	          }
	        }
	      );
	    }
	
	    var tileUrlFunction = createFromTileUrlFunctions(urls.map(createFromTemplate$$1));
	
	    var ZoomifyTileClass = CustomTile$1.bind(null, tileGrid);
	
	    TileImage$$1.call(this, {
	      attributions: options.attributions,
	      cacheSize: options.cacheSize,
	      crossOrigin: options.crossOrigin,
	      projection: options.projection,
	      reprojectionErrorThreshold: options.reprojectionErrorThreshold,
	      tileClass: ZoomifyTileClass,
	      tileGrid: tileGrid,
	      tileUrlFunction: tileUrlFunction,
	      transition: options.transition
	    });
	
	  }
	
	  if ( TileImage$$1 ) { Zoomify.__proto__ = TileImage$$1; }
	  Zoomify.prototype = Object.create( TileImage$$1 && TileImage$$1.prototype );
	  Zoomify.prototype.constructor = Zoomify;
	
	  return Zoomify;
	}(TileImage));
	
	/**
	 * @module ol/proj/proj4
	 */
	
	/**
	 * Make projections defined in proj4 (with `proj4.defs()`) available in
	 * OpenLayers.
	 *
	 * This function should be called whenever changes are made to the proj4
	 * registry, e.g. after calling `proj4.defs()`. Existing transforms will not be
	 * modified by this function.
	 *
	 * @param {?} proj4 Proj4.
	 * @api
	 */
	function register(proj4) {
	  var projCodes = Object.keys(proj4.defs);
	  var len = projCodes.length;
	  var i, j;
	  for (i = 0; i < len; ++i) {
	    var code = projCodes[i];
	    if (!get$2(code)) {
	      var def = proj4.defs(code);
	      addProjection(new Projection({
	        code: code,
	        axisOrientation: def.axis,
	        metersPerUnit: def.to_meter,
	        units: def.units
	      }));
	    }
	  }
	  for (i = 0; i < len; ++i) {
	    var code1 = projCodes[i];
	    var proj1 = get$2(code1);
	    for (j = 0; j < len; ++j) {
	      var code2 = projCodes[j];
	      var proj2 = get$2(code2);
	      if (!get$1(code1, code2)) {
	        if (proj4.defs[code1] === proj4.defs[code2]) {
	          addEquivalentProjections([proj1, proj2]);
	        } else {
	          var transform$$1 = proj4(code1, code2);
	          addCoordinateTransforms(proj1, proj2, transform$$1.forward, transform$$1.inverse);
	        }
	      }
	    }
	  }
	}
	
	/**
	 * @module ol/layer/Heatmap
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {Array<string>} [gradient=['#00f', '#0ff', '#0f0', '#ff0', '#f00']] The color gradient
	 * of the heatmap, specified as an array of CSS color strings.
	 * @property {number} [radius=8] Radius size in pixels.
	 * @property {number} [blur=15] Blur size in pixels.
	 * @property {number} [shadow=250] Shadow size in pixels.
	 * @property {string|function(import("../Feature.js").default):number} [weight='weight'] The feature
	 * attribute to use for the weight or a function that returns a weight from a feature. Weight values
	 * should range from 0 to 1 (and values outside will be clamped to that range).
	 * @property {import("./VectorRenderType.js").default|string} [renderMode='vector'] Render mode for vector layers:
	 *  * `'image'`: Vector layers are rendered as images. Great performance, but point symbols and
	 *    texts are always rotated with the view and pixels are scaled during zoom animations.
	 *  * `'vector'`: Vector layers are rendered as vectors. Most accurate rendering even during
	 *    animations, but slower performance.
	 * @property {import("../source/Vector.js").default} [source] Source.
	 */
	
	
	/**
	 * @enum {string}
	 * @private
	 */
	var Property$5 = {
	  BLUR: 'blur',
	  GRADIENT: 'gradient',
	  RADIUS: 'radius'
	};
	
	
	/**
	 * @const
	 * @type {Array<string>}
	 */
	var DEFAULT_GRADIENT = ['#00f', '#0ff', '#0f0', '#ff0', '#f00'];
	
	
	/**
	 * @classdesc
	 * Layer for rendering vector data as a heatmap.
	 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
	 * property on the layer object; for example, setting `title: 'My Title'` in the
	 * options means that `title` is observable, and has get/set accessors.
	 *
	 * @fires import("../render/Event.js").RenderEvent
	 * @api
	 */
	var Heatmap = /*@__PURE__*/(function (VectorLayer$$1) {
	  function Heatmap(opt_options) {
	    var options = opt_options ? opt_options : {};
	
	    var baseOptions = assign({}, options);
	
	    delete baseOptions.gradient;
	    delete baseOptions.radius;
	    delete baseOptions.blur;
	    delete baseOptions.shadow;
	    delete baseOptions.weight;
	    VectorLayer$$1.call(this, baseOptions);
	
	    /**
	     * @private
	     * @type {Uint8ClampedArray}
	     */
	    this.gradient_ = null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.shadow_ = options.shadow !== undefined ? options.shadow : 250;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.circleImage_ = undefined;
	
	    /**
	     * @private
	     * @type {Array<Array<import("../style/Style.js").default>>}
	     */
	    this.styleCache_ = null;
	
	    listen(this,
	      getChangeEventType(Property$5.GRADIENT),
	      this.handleGradientChanged_, this);
	
	    this.setGradient(options.gradient ? options.gradient : DEFAULT_GRADIENT);
	
	    this.setBlur(options.blur !== undefined ? options.blur : 15);
	
	    this.setRadius(options.radius !== undefined ? options.radius : 8);
	
	    listen(this,
	      getChangeEventType(Property$5.BLUR),
	      this.handleStyleChanged_, this);
	    listen(this,
	      getChangeEventType(Property$5.RADIUS),
	      this.handleStyleChanged_, this);
	
	    this.handleStyleChanged_();
	
	    var weight = options.weight ? options.weight : 'weight';
	    var weightFunction;
	    if (typeof weight === 'string') {
	      weightFunction = function(feature) {
	        return feature.get(weight);
	      };
	    } else {
	      weightFunction = weight;
	    }
	
	    this.setStyle(function(feature, resolution) {
	      var weight = weightFunction(feature);
	      var opacity = weight !== undefined ? clamp(weight, 0, 1) : 1;
	      // cast to 8 bits
	      var index = (255 * opacity) | 0;
	      var style = this.styleCache_[index];
	      if (!style) {
	        style = [
	          new Style({
	            image: new Icon({
	              opacity: opacity,
	              src: this.circleImage_
	            })
	          })
	        ];
	        this.styleCache_[index] = style;
	      }
	      return style;
	    }.bind(this));
	
	    // For performance reasons, don't sort the features before rendering.
	    // The render order is not relevant for a heatmap representation.
	    this.setRenderOrder(null);
	
	    listen(this, RenderEventType.RENDER, this.handleRender_, this);
	  }
	
	  if ( VectorLayer$$1 ) { Heatmap.__proto__ = VectorLayer$$1; }
	  Heatmap.prototype = Object.create( VectorLayer$$1 && VectorLayer$$1.prototype );
	  Heatmap.prototype.constructor = Heatmap;
	
	  /**
	   * @return {string} Data URL for a circle.
	   * @private
	   */
	  Heatmap.prototype.createCircle_ = function createCircle_ () {
	    var radius = this.getRadius();
	    var blur = this.getBlur();
	    var halfSize = radius + blur + 1;
	    var size = 2 * halfSize;
	    var context = createCanvasContext2D(size, size);
	    context.shadowOffsetX = context.shadowOffsetY = this.shadow_;
	    context.shadowBlur = blur;
	    context.shadowColor = '#000';
	    context.beginPath();
	    var center = halfSize - this.shadow_;
	    context.arc(center, center, radius, 0, Math.PI * 2, true);
	    context.fill();
	    return context.canvas.toDataURL();
	  };
	
	  /**
	   * Return the blur size in pixels.
	   * @return {number} Blur size in pixels.
	   * @api
	   * @observable
	   */
	  Heatmap.prototype.getBlur = function getBlur () {
	    return /** @type {number} */ (this.get(Property$5.BLUR));
	  };
	
	  /**
	   * Return the gradient colors as array of strings.
	   * @return {Array<string>} Colors.
	   * @api
	   * @observable
	   */
	  Heatmap.prototype.getGradient = function getGradient () {
	    return /** @type {Array<string>} */ (this.get(Property$5.GRADIENT));
	  };
	
	  /**
	   * Return the size of the radius in pixels.
	   * @return {number} Radius size in pixel.
	   * @api
	   * @observable
	   */
	  Heatmap.prototype.getRadius = function getRadius () {
	    return /** @type {number} */ (this.get(Property$5.RADIUS));
	  };
	
	  /**
	   * @private
	   */
	  Heatmap.prototype.handleGradientChanged_ = function handleGradientChanged_ () {
	    this.gradient_ = createGradient(this.getGradient());
	  };
	
	  /**
	   * @private
	   */
	  Heatmap.prototype.handleStyleChanged_ = function handleStyleChanged_ () {
	    this.circleImage_ = this.createCircle_();
	    this.styleCache_ = new Array(256);
	    this.changed();
	  };
	
	  /**
	   * @param {import("../render/Event.js").default} event Post compose event
	   * @private
	   */
	  Heatmap.prototype.handleRender_ = function handleRender_ (event) {
	    var context = event.context;
	    var canvas = context.canvas;
	    var image = context.getImageData(0, 0, canvas.width, canvas.height);
	    var view8 = image.data;
	    for (var i = 0, ii = view8.length; i < ii; i += 4) {
	      var alpha = view8[i + 3] * 4;
	      if (alpha) {
	        view8[i] = this.gradient_[alpha];
	        view8[i + 1] = this.gradient_[alpha + 1];
	        view8[i + 2] = this.gradient_[alpha + 2];
	      }
	    }
	    context.putImageData(image, 0, 0);
	  };
	
	  /**
	   * Set the blur size in pixels.
	   * @param {number} blur Blur size in pixels.
	   * @api
	   * @observable
	   */
	  Heatmap.prototype.setBlur = function setBlur (blur) {
	    this.set(Property$5.BLUR, blur);
	  };
	
	  /**
	   * Set the gradient colors as array of strings.
	   * @param {Array<string>} colors Gradient.
	   * @api
	   * @observable
	   */
	  Heatmap.prototype.setGradient = function setGradient (colors) {
	    this.set(Property$5.GRADIENT, colors);
	  };
	
	  /**
	   * Set the size of the radius in pixels.
	   * @param {number} radius Radius size in pixel.
	   * @api
	   * @observable
	   */
	  Heatmap.prototype.setRadius = function setRadius (radius) {
	    this.set(Property$5.RADIUS, radius);
	  };
	
	  return Heatmap;
	}(VectorLayer));
	
	
	/**
	 * @param {Array<string>} colors A list of colored.
	 * @return {Uint8ClampedArray} An array.
	 */
	function createGradient(colors) {
	  var width = 1;
	  var height = 256;
	  var context = createCanvasContext2D(width, height);
	
	  var gradient = context.createLinearGradient(0, 0, width, height);
	  var step = 1 / (colors.length - 1);
	  for (var i = 0, ii = colors.length; i < ii; ++i) {
	    gradient.addColorStop(i * step, colors[i]);
	  }
	
	  context.fillStyle = gradient;
	  context.fillRect(0, 0, width, height);
	
	  return context.getImageData(0, 0, width, height).data;
	}
	
	/**
	 * @module ol/layer/VectorTile
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [opacity=1] Opacity (0, 1).
	 * @property {boolean} [visible=true] Visibility.
	 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
	 * rendered outside of this extent.
	 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
	 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
	 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
	 * method was used.
	 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
	 * visible.
	 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
	 * be visible.
	 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
	 * features before rendering. By default features are drawn in the order that they are created. Use
	 * `null` to avoid the sort, but get an undefined draw order.
	 * @property {number} [renderBuffer=100] The buffer in pixels around the tile extent used by the
	 * renderer when getting features from the vector tile for the rendering or hit-detection.
	 * Recommended value: Vector tiles are usually generated with a buffer, so this value should match
	 * the largest possible buffer of the used tiles. It should be at least the size of the largest
	 * point symbol or line width.
	 * @property {import("./VectorTileRenderType.js").default|string} [renderMode='hybrid'] Render mode for vector tiles:
	 *  * `'image'`: Vector tiles are rendered as images. Great performance, but point symbols and texts
	 *    are always rotated with the view and pixels are scaled during zoom animations.
	 *  * `'hybrid'`: Polygon and line elements are rendered as images, so pixels are scaled during zoom
	 *    animations. Point symbols and texts are accurately rendered as vectors and can stay upright on
	 *    rotated views.
	 *  * `'vector'`: Vector tiles are rendered as vectors. Most accurate rendering even during
	 *    animations, but slower performance than the other options.
	 *
	 * When `declutter` is set to `true`, `'hybrid'` will be used instead of `'image'`.
	 * @property {import("../source/VectorTile.js").default} [source] Source.
	 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
	 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
	 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
	 * use {@link module:ol/Map#addLayer}.
	 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
	 * image and text styles, and the priority is defined by the z-index of the style. Lower z-index
	 * means higher priority. When set to `true`, a `renderMode` of `'image'` will be overridden with
	 * `'hybrid'`.
	 * @property {import("../style/Style.js").StyleLike} [style] Layer style. See
	 * {@link module:ol/style} for default style which will be used if this is not defined.
	 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will be
	 * recreated during animations. This means that no vectors will be shown clipped, but the setting
	 * will have a performance impact for large amounts of vector data. When set to `false`, batches
	 * will be recreated when no animation is active.
	 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will be
	 * recreated during interactions. See also `updateWhileAnimating`.
	 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
	 * means no preloading.
	 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
	 * features before rendering. By default features are drawn in the order that they are created.
	 * @property {import("../style/Style.js").StyleLike} [style] Layer style. See
	 * {@link module:ol/style} for default style which will be used if this is not defined.
	 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
	 */
	
	
	/**
	 * @classdesc
	 * Layer for vector tile data that is rendered client-side.
	 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
	 * property on the layer object; for example, setting `title: 'My Title'` in the
	 * options means that `title` is observable, and has get/set accessors.
	 *
	 * @param {Options=} opt_options Options.
	 * @api
	 */
	var VectorTileLayer = /*@__PURE__*/(function (VectorLayer$$1) {
	  function VectorTileLayer(opt_options) {
	    var options = opt_options ? opt_options : {};
	
	    var renderMode = options.renderMode || VectorTileRenderType.HYBRID;
	    assert(renderMode == undefined ||
	       renderMode == VectorTileRenderType.IMAGE ||
	       renderMode == VectorTileRenderType.HYBRID ||
	       renderMode == VectorTileRenderType.VECTOR,
	    28); // `renderMode` must be `'image'`, `'hybrid'` or `'vector'`
	    if (options.declutter && renderMode == VectorTileRenderType.IMAGE) {
	      renderMode = VectorTileRenderType.HYBRID;
	    }
	    options.renderMode = renderMode;
	
	    var baseOptions = /** @type {Object} */ (assign({}, options));
	    delete baseOptions.preload;
	    delete baseOptions.useInterimTilesOnError;
	
	    VectorLayer$$1.call(/** @type {import("./Vector.js").Options} */ this, (baseOptions));
	
	    this.setPreload(options.preload ? options.preload : 0);
	    this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ?
	      options.useInterimTilesOnError : true);
	
	    /**
	    * The layer type.
	    * @protected
	    * @type {import("../LayerType.js").default}
	    */
	    this.type = LayerType.VECTOR_TILE;
	
	  }
	
	  if ( VectorLayer$$1 ) { VectorTileLayer.__proto__ = VectorLayer$$1; }
	  VectorTileLayer.prototype = Object.create( VectorLayer$$1 && VectorLayer$$1.prototype );
	  VectorTileLayer.prototype.constructor = VectorTileLayer;
	
	  /**
	  * Return the level as number to which we will preload tiles up to.
	  * @return {number} The level to preload tiles up to.
	  * @observable
	  * @api
	  */
	  VectorTileLayer.prototype.getPreload = function getPreload () {
	    return /** @type {number} */ (this.get(TileProperty.PRELOAD));
	  };
	
	  /**
	  * Whether we use interim tiles on error.
	  * @return {boolean} Use interim tiles on error.
	  * @observable
	  * @api
	  */
	  VectorTileLayer.prototype.getUseInterimTilesOnError = function getUseInterimTilesOnError () {
	    return /** @type {boolean} */ (this.get(TileProperty.USE_INTERIM_TILES_ON_ERROR));
	  };
	
	  /**
	  * Set the level as number to which we will preload tiles up to.
	  * @param {number} preload The level to preload tiles up to.
	  * @observable
	  * @api
	  */
	  VectorTileLayer.prototype.setPreload = function setPreload (preload) {
	    this.set(TileProperty.PRELOAD, preload);
	  };
	
	  /**
	  * Set whether we use interim tiles on error.
	  * @param {boolean} useInterimTilesOnError Use interim tiles on error.
	  * @observable
	  * @api
	  */
	  VectorTileLayer.prototype.setUseInterimTilesOnError = function setUseInterimTilesOnError (useInterimTilesOnError) {
	    this.set(TileProperty.USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
	  };
	
	  return VectorTileLayer;
	}(VectorLayer));
	
	
	/**
	 * Return the associated {@link module:ol/source/VectorTile vectortilesource} of the layer.
	 * @function
	 * @return {import("../source/VectorTile.js").default} Source.
	 * @api
	 */
	VectorTileLayer.prototype.getSource;
	
	/**
	 * @module ol/geom/GeometryCollection
	 */
	
	/**
	 * @classdesc
	 * An array of {@link module:ol/geom/Geometry} objects.
	 *
	 * @api
	 */
	var GeometryCollection = /*@__PURE__*/(function (Geometry$$1) {
	  function GeometryCollection(opt_geometries) {
	
	    Geometry$$1.call(this);
	
	    /**
	     * @private
	     * @type {Array<Geometry>}
	     */
	    this.geometries_ = opt_geometries ? opt_geometries : null;
	
	    this.listenGeometriesChange_();
	  }
	
	  if ( Geometry$$1 ) { GeometryCollection.__proto__ = Geometry$$1; }
	  GeometryCollection.prototype = Object.create( Geometry$$1 && Geometry$$1.prototype );
	  GeometryCollection.prototype.constructor = GeometryCollection;
	
	  /**
	   * @private
	   */
	  GeometryCollection.prototype.unlistenGeometriesChange_ = function unlistenGeometriesChange_ () {
	    if (!this.geometries_) {
	      return;
	    }
	    for (var i = 0, ii = this.geometries_.length; i < ii; ++i) {
	      unlisten(
	        this.geometries_[i], EventType.CHANGE,
	        this.changed, this);
	    }
	  };
	
	  /**
	   * @private
	   */
	  GeometryCollection.prototype.listenGeometriesChange_ = function listenGeometriesChange_ () {
	    if (!this.geometries_) {
	      return;
	    }
	    for (var i = 0, ii = this.geometries_.length; i < ii; ++i) {
	      listen(
	        this.geometries_[i], EventType.CHANGE,
	        this.changed, this);
	    }
	  };
	
	  /**
	   * Make a complete copy of the geometry.
	   * @return {!GeometryCollection} Clone.
	   * @override
	   * @api
	   */
	  GeometryCollection.prototype.clone = function clone$$1 () {
	    var geometryCollection = new GeometryCollection(null);
	    geometryCollection.setGeometries(this.geometries_);
	    return geometryCollection;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeometryCollection.prototype.closestPointXY = function closestPointXY (x, y, closestPoint, minSquaredDistance) {
	    if (minSquaredDistance < closestSquaredDistanceXY(this.getExtent(), x, y)) {
	      return minSquaredDistance;
	    }
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      minSquaredDistance = geometries[i].closestPointXY(
	        x, y, closestPoint, minSquaredDistance);
	    }
	    return minSquaredDistance;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeometryCollection.prototype.containsXY = function containsXY$$1 (x, y) {
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      if (geometries[i].containsXY(x, y)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeometryCollection.prototype.computeExtent = function computeExtent (extent) {
	    createOrUpdateEmpty(extent);
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      extend$1(extent, geometries[i].getExtent());
	    }
	    return extent;
	  };
	
	  /**
	   * Return the geometries that make up this geometry collection.
	   * @return {Array<Geometry>} Geometries.
	   * @api
	   */
	  GeometryCollection.prototype.getGeometries = function getGeometries () {
	    return cloneGeometries(this.geometries_);
	  };
	
	  /**
	   * @return {Array<Geometry>} Geometries.
	   */
	  GeometryCollection.prototype.getGeometriesArray = function getGeometriesArray () {
	    return this.geometries_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeometryCollection.prototype.getSimplifiedGeometry = function getSimplifiedGeometry (squaredTolerance) {
	    if (this.simplifiedGeometryRevision != this.getRevision()) {
	      clear(this.simplifiedGeometryCache);
	      this.simplifiedGeometryMaxMinSquaredTolerance = 0;
	      this.simplifiedGeometryRevision = this.getRevision();
	    }
	    if (squaredTolerance < 0 ||
	        (this.simplifiedGeometryMaxMinSquaredTolerance !== 0 &&
	         squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance)) {
	      return this;
	    }
	    var key = squaredTolerance.toString();
	    if (this.simplifiedGeometryCache.hasOwnProperty(key)) {
	      return this.simplifiedGeometryCache[key];
	    } else {
	      var simplifiedGeometries = [];
	      var geometries = this.geometries_;
	      var simplified = false;
	      for (var i = 0, ii = geometries.length; i < ii; ++i) {
	        var geometry = geometries[i];
	        var simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
	        simplifiedGeometries.push(simplifiedGeometry);
	        if (simplifiedGeometry !== geometry) {
	          simplified = true;
	        }
	      }
	      if (simplified) {
	        var simplifiedGeometryCollection = new GeometryCollection(null);
	        simplifiedGeometryCollection.setGeometriesArray(simplifiedGeometries);
	        this.simplifiedGeometryCache[key] = simplifiedGeometryCollection;
	        return simplifiedGeometryCollection;
	      } else {
	        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
	        return this;
	      }
	    }
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  GeometryCollection.prototype.getType = function getType () {
	    return GeometryType.GEOMETRY_COLLECTION;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  GeometryCollection.prototype.intersectsExtent = function intersectsExtent (extent) {
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      if (geometries[i].intersectsExtent(extent)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * @return {boolean} Is empty.
	   */
	  GeometryCollection.prototype.isEmpty = function isEmpty$$1 () {
	    return this.geometries_.length === 0;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  GeometryCollection.prototype.rotate = function rotate (angle, anchor) {
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      geometries[i].rotate(angle, anchor);
	    }
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  GeometryCollection.prototype.scale = function scale (sx, opt_sy, opt_anchor) {
	    var anchor = opt_anchor;
	    if (!anchor) {
	      anchor = getCenter(this.getExtent());
	    }
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      geometries[i].scale(sx, opt_sy, anchor);
	    }
	    this.changed();
	  };
	
	  /**
	   * Set the geometries that make up this geometry collection.
	   * @param {Array<Geometry>} geometries Geometries.
	   * @api
	   */
	  GeometryCollection.prototype.setGeometries = function setGeometries (geometries) {
	    this.setGeometriesArray(cloneGeometries(geometries));
	  };
	
	  /**
	   * @param {Array<Geometry>} geometries Geometries.
	   */
	  GeometryCollection.prototype.setGeometriesArray = function setGeometriesArray (geometries) {
	    this.unlistenGeometriesChange_();
	    this.geometries_ = geometries;
	    this.listenGeometriesChange_();
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  GeometryCollection.prototype.applyTransform = function applyTransform$$1 (transformFn) {
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      geometries[i].applyTransform(transformFn);
	    }
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  GeometryCollection.prototype.translate = function translate (deltaX, deltaY) {
	    var geometries = this.geometries_;
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      geometries[i].translate(deltaX, deltaY);
	    }
	    this.changed();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeometryCollection.prototype.disposeInternal = function disposeInternal () {
	    this.unlistenGeometriesChange_();
	    Geometry$$1.prototype.disposeInternal.call(this);
	  };
	
	  return GeometryCollection;
	}(Geometry));
	
	
	/**
	 * @param {Array<Geometry>} geometries Geometries.
	 * @return {Array<Geometry>} Cloned geometries.
	 */
	function cloneGeometries(geometries) {
	  var clonedGeometries = [];
	  for (var i = 0, ii = geometries.length; i < ii; ++i) {
	    clonedGeometries.push(geometries[i].clone());
	  }
	  return clonedGeometries;
	}
	
	/**
	 * @module ol/format/Feature
	 */
	
	
	/**
	 * @typedef {Object} ReadOptions
	 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
	 * If not provided, the projection will be derived from the data (where possible) or
	 * the `dataProjection` of the format is assigned (where set). If the projection
	 * can not be derived from the data and if no `dataProjection` is set for a format,
	 * the features will not be reprojected.
	 * @property {import("../extent.js").Extent} [extent] Tile extent of the tile being read. This is only used and
	 * required for {@link module:ol/format/MVT}.
	 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
	 * created by the format reader. If not provided, features will be returned in the
	 * `dataProjection`.
	 */
	
	
	/**
	 * @typedef {Object} WriteOptions
	 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
	 * If not provided, the `dataProjection` of the format is assigned (where set).
	 * If no `dataProjection` is set for a format, the features will be returned
	 * in the `featureProjection`.
	 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
	 * that will be serialized by the format writer. If not provided, geometries are assumed
	 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
	 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
	 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
	 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
	 * as they are provided at construction.  If `true`, the right-hand rule will
	 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
	 * exterior and counter-clockwise for interior rings).  Note that not all
	 * formats support this.  The GeoJSON format does use this property when writing
	 * geometries.
	 * @property {number} [decimals] Maximum number of decimal places for coordinates.
	 * Coordinates are stored internally as floats, but floating-point arithmetic can create
	 * coordinates with a large number of decimal places, not generally wanted on output.
	 * Set a number here to round coordinates. Can also be used to ensure that
	 * coordinates read in can be written back out with the same number of decimals.
	 * Default is no rounding.
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for feature formats.
	 * {FeatureFormat} subclasses provide the ability to decode and encode
	 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
	 * file formats.  See the documentation for each format for more details.
	 *
	 * @abstract
	 * @api
	 */
	var FeatureFormat = function FeatureFormat() {
	
	  /**
	   * @protected
	   * @type {import("../proj/Projection.js").default}
	   */
	  this.dataProjection = null;
	
	  /**
	   * @protected
	   * @type {import("../proj/Projection.js").default}
	   */
	  this.defaultFeatureProjection = null;
	
	};
	
	/**
	 * Adds the data projection to the read options.
	 * @param {Document|Node|Object|string} source Source.
	 * @param {ReadOptions=} opt_options Options.
	 * @return {ReadOptions|undefined} Options.
	 * @protected
	 */
	FeatureFormat.prototype.getReadOptions = function getReadOptions (source, opt_options) {
	  var options;
	  if (opt_options) {
	    options = {
	      dataProjection: opt_options.dataProjection ?
	        opt_options.dataProjection : this.readProjection(source),
	      featureProjection: opt_options.featureProjection
	    };
	  }
	  return this.adaptOptions(options);
	};
	
	/**
	 * Sets the `dataProjection` on the options, if no `dataProjection`
	 * is set.
	 * @param {WriteOptions|ReadOptions|undefined} options
	 *   Options.
	 * @protected
	 * @return {WriteOptions|ReadOptions|undefined}
	 *   Updated options.
	 */
	FeatureFormat.prototype.adaptOptions = function adaptOptions (options) {
	  return assign({
	    dataProjection: this.dataProjection,
	    featureProjection: this.defaultFeatureProjection
	  }, options);
	};
	
	/**
	 * Get the extent from the source of the last {@link readFeatures} call.
	 * @return {import("../extent.js").Extent} Tile extent.
	 */
	FeatureFormat.prototype.getLastExtent = function getLastExtent () {
	  return null;
	};
	
	/**
	 * @abstract
	 * @return {import("./FormatType.js").default} Format.
	 */
	FeatureFormat.prototype.getType = function getType () {
	  return abstract();
	};
	
	/**
	 * Read a single feature from a source.
	 *
	 * @abstract
	 * @param {Document|Node|Object|string} source Source.
	 * @param {ReadOptions=} opt_options Read options.
	 * @return {import("../Feature.js").FeatureLike} Feature.
	 */
	FeatureFormat.prototype.readFeature = function readFeature (source, opt_options) {
	  return abstract();
	};
	
	/**
	 * Read all features from a source.
	 *
	 * @abstract
	 * @param {Document|Node|ArrayBuffer|Object|string} source Source.
	 * @param {ReadOptions=} opt_options Read options.
	 * @return {Array<import("../Feature.js").FeatureLike>} Features.
	 */
	FeatureFormat.prototype.readFeatures = function readFeatures (source, opt_options) {
	  return abstract();
	};
	
	/**
	 * Read a single geometry from a source.
	 *
	 * @abstract
	 * @param {Document|Node|Object|string} source Source.
	 * @param {ReadOptions=} opt_options Read options.
	 * @return {import("../geom/Geometry.js").default} Geometry.
	 */
	FeatureFormat.prototype.readGeometry = function readGeometry (source, opt_options) {
	  return abstract();
	};
	
	/**
	 * Read the projection from a source.
	 *
	 * @abstract
	 * @param {Document|Node|Object|string} source Source.
	 * @return {import("../proj/Projection.js").default} Projection.
	 */
	FeatureFormat.prototype.readProjection = function readProjection (source) {
	  return abstract();
	};
	
	/**
	 * Encode a feature in this format.
	 *
	 * @abstract
	 * @param {import("../Feature.js").default} feature Feature.
	 * @param {WriteOptions=} opt_options Write options.
	 * @return {string} Result.
	 */
	FeatureFormat.prototype.writeFeature = function writeFeature (feature, opt_options) {
	  return abstract();
	};
	
	/**
	 * Encode an array of features in this format.
	 *
	 * @abstract
	 * @param {Array<import("../Feature.js").default>} features Features.
	 * @param {WriteOptions=} opt_options Write options.
	 * @return {string} Result.
	 */
	FeatureFormat.prototype.writeFeatures = function writeFeatures (features, opt_options) {
	  return abstract();
	};
	
	/**
	 * Write a single geometry in this format.
	 *
	 * @abstract
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {WriteOptions=} opt_options Write options.
	 * @return {string} Result.
	 */
	FeatureFormat.prototype.writeGeometry = function writeGeometry (geometry, opt_options) {
	  return abstract();
	};
	
	/**
	 * @param {import("../geom/Geometry.js").default|import("../extent.js").Extent} geometry Geometry.
	 * @param {boolean} write Set to true for writing, false for reading.
	 * @param {(WriteOptions|ReadOptions)=} opt_options Options.
	 * @return {import("../geom/Geometry.js").default|import("../extent.js").Extent} Transformed geometry.
	 */
	function transformWithOptions(geometry, write, opt_options) {
	  var featureProjection = opt_options ?
	    get$2(opt_options.featureProjection) : null;
	  var dataProjection = opt_options ?
	    get$2(opt_options.dataProjection) : null;
	  /**
	   * @type {import("../geom/Geometry.js").default|import("../extent.js").Extent}
	   */
	  var transformed;
	  if (featureProjection && dataProjection &&
	      !equivalent(featureProjection, dataProjection)) {
	    if (Array.isArray(geometry)) {
	      // FIXME this is necessary because GML treats extents
	      // as geometries
	      transformed = transformExtent(
	        geometry,
	        dataProjection,
	        featureProjection);
	    } else {
	      transformed = (write ? /** @type {import("../geom/Geometry").default} */ (geometry).clone() : geometry).transform(
	        write ? featureProjection : dataProjection,
	        write ? dataProjection : featureProjection);
	    }
	  } else {
	    transformed = geometry;
	  }
	  if (write && opt_options && /** @type {WriteOptions} */ (opt_options).decimals !== undefined &&
	    !Array.isArray(transformed)) {
	    var power = Math.pow(10, /** @type {WriteOptions} */ (opt_options).decimals);
	    // if decimals option on write, round each coordinate appropriately
	    /**
	     * @param {Array<number>} coordinates Coordinates.
	     * @return {Array<number>} Transformed coordinates.
	     */
	    var transform$$1 = function(coordinates) {
	      for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	        coordinates[i] = Math.round(coordinates[i] * power) / power;
	      }
	      return coordinates;
	    };
	    if (transformed === geometry) {
	      transformed = /** @type {import("../geom/Geometry").default} */ (geometry).clone();
	    }
	    transformed.applyTransform(transform$$1);
	  }
	  return transformed;
	}
	
	/**
	 * @module ol/format/JSONFeature
	 */
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for JSON feature formats.
	 *
	 * @abstract
	 */
	var JSONFeature = /*@__PURE__*/(function (FeatureFormat$$1) {
	  function JSONFeature() {
	    FeatureFormat$$1.call(this);
	  }
	
	  if ( FeatureFormat$$1 ) { JSONFeature.__proto__ = FeatureFormat$$1; }
	  JSONFeature.prototype = Object.create( FeatureFormat$$1 && FeatureFormat$$1.prototype );
	  JSONFeature.prototype.constructor = JSONFeature;
	
	  /**
	   * @inheritDoc
	   */
	  JSONFeature.prototype.getType = function getType () {
	    return FormatType.JSON;
	  };
	
	  /**
	   * Read a feature.  Only works for a single feature. Use `readFeatures` to
	   * read a feature collection.
	   *
	   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {import("../Feature.js").default} Feature.
	   * @api
	   */
	  JSONFeature.prototype.readFeature = function readFeature (source, opt_options) {
	    return this.readFeatureFromObject(
	      getObject(source), this.getReadOptions(source, opt_options));
	  };
	
	  /**
	   * Read all features.  Works with both a single feature and a feature
	   * collection.
	   *
	   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @api
	   */
	  JSONFeature.prototype.readFeatures = function readFeatures (source, opt_options) {
	    return this.readFeaturesFromObject(
	      getObject(source), this.getReadOptions(source, opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {Object} object Object.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @protected
	   * @return {import("../Feature.js").default} Feature.
	   */
	  JSONFeature.prototype.readFeatureFromObject = function readFeatureFromObject (object, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * @abstract
	   * @param {Object} object Object.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @protected
	   * @return {Array<import("../Feature.js").default>} Features.
	   */
	  JSONFeature.prototype.readFeaturesFromObject = function readFeaturesFromObject (object, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Read a geometry.
	   *
	   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {import("../geom/Geometry.js").default} Geometry.
	   * @api
	   */
	  JSONFeature.prototype.readGeometry = function readGeometry (source, opt_options) {
	    return this.readGeometryFromObject(
	      getObject(source), this.getReadOptions(source, opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {Object} object Object.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @protected
	   * @return {import("../geom/Geometry.js").default} Geometry.
	   */
	  JSONFeature.prototype.readGeometryFromObject = function readGeometryFromObject (object, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Read the projection.
	   *
	   * @param {ArrayBuffer|Document|Node|Object|string} source Source.
	   * @return {import("../proj/Projection.js").default} Projection.
	   * @api
	   */
	  JSONFeature.prototype.readProjection = function readProjection (source) {
	    return this.readProjectionFromObject(getObject(source));
	  };
	
	  /**
	   * @abstract
	   * @param {Object} object Object.
	   * @protected
	   * @return {import("../proj/Projection.js").default} Projection.
	   */
	  JSONFeature.prototype.readProjectionFromObject = function readProjectionFromObject (object) {
	    return abstract();
	  };
	
	  /**
	   * Encode a feature as string.
	   *
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Encoded feature.
	   * @api
	   */
	  JSONFeature.prototype.writeFeature = function writeFeature (feature, opt_options) {
	    return JSON.stringify(this.writeFeatureObject(feature, opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {Object} Object.
	   */
	  JSONFeature.prototype.writeFeatureObject = function writeFeatureObject (feature, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Encode an array of features as string.
	   *
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Encoded features.
	   * @api
	   */
	  JSONFeature.prototype.writeFeatures = function writeFeatures (features, opt_options) {
	    return JSON.stringify(this.writeFeaturesObject(features, opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {Object} Object.
	   */
	  JSONFeature.prototype.writeFeaturesObject = function writeFeaturesObject (features, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Encode a geometry as string.
	   *
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Encoded geometry.
	   * @api
	   */
	  JSONFeature.prototype.writeGeometry = function writeGeometry (geometry, opt_options) {
	    return JSON.stringify(this.writeGeometryObject(geometry, opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {Object} Object.
	   */
	  JSONFeature.prototype.writeGeometryObject = function writeGeometryObject (geometry, opt_options) {
	    return abstract();
	  };
	
	  return JSONFeature;
	}(FeatureFormat));
	
	
	/**
	 * @param {Document|Node|Object|string} source Source.
	 * @return {Object} Object.
	 */
	function getObject(source) {
	  if (typeof source === 'string') {
	    var object = JSON.parse(source);
	    return object ? /** @type {Object} */ (object) : null;
	  } else if (source !== null) {
	    return source;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * @module ol/format/EsriJSON
	 */
	
	/**
	 * @typedef {import("arcgis-rest-api").Feature} EsriJSONFeature
	 * @typedef {import("arcgis-rest-api").FeatureSet} EsriJSONFeatureSet
	 * @typedef {import("arcgis-rest-api").Geometry} EsriJSONGeometry
	 * @typedef {import("arcgis-rest-api").Point} EsriJSONPoint
	 * @typedef {import("arcgis-rest-api").Polyline} EsriJSONPolyline
	 * @typedef {import("arcgis-rest-api").Polygon} EsriJSONPolygon
	 * @typedef {import("arcgis-rest-api").Multipoint} EsriJSONMultipoint
	 * @typedef {import("arcgis-rest-api").HasZM} EsriJSONHasZM
	 * @typedef {import("arcgis-rest-api").Position} EsriJSONPosition
	 * @typedef {import("arcgis-rest-api").SpatialReferenceWkid} EsriJSONSpatialReferenceWkid
	 */
	
	
	/**
	 * @typedef {Object} EsriJSONMultiPolygon
	 * @property {Array<Array<Array<Array<number>>>>} rings Rings for the MultiPolygon.
	 * @property {boolean} [hasM] If the polygon coordinates have an M value.
	 * @property {boolean} [hasZ] If the polygon coordinates have a Z value.
	 * @property {EsriJSONSpatialReferenceWkid} [spatialReference] The coordinate reference system.
	 */
	
	
	/**
	 * @const
	 * @type {Object<import("../geom/GeometryType.js").default, function(EsriJSONGeometry): import("../geom/Geometry.js").default>}
	 */
	var GEOMETRY_READERS = {};
	GEOMETRY_READERS[GeometryType.POINT] = readPointGeometry;
	GEOMETRY_READERS[GeometryType.LINE_STRING] = readLineStringGeometry;
	GEOMETRY_READERS[GeometryType.POLYGON] = readPolygonGeometry;
	GEOMETRY_READERS[GeometryType.MULTI_POINT] = readMultiPointGeometry;
	GEOMETRY_READERS[GeometryType.MULTI_LINE_STRING] = readMultiLineStringGeometry;
	GEOMETRY_READERS[GeometryType.MULTI_POLYGON] = readMultiPolygonGeometry;
	
	
	/**
	 * @const
	 * @type {Object<string, function(import("../geom/Geometry.js").default, import("./Feature.js").WriteOptions=): (EsriJSONGeometry)>}
	 */
	var GEOMETRY_WRITERS = {};
	GEOMETRY_WRITERS[GeometryType.POINT] = writePointGeometry;
	GEOMETRY_WRITERS[GeometryType.LINE_STRING] = writeLineStringGeometry;
	GEOMETRY_WRITERS[GeometryType.POLYGON] = writePolygonGeometry;
	GEOMETRY_WRITERS[GeometryType.MULTI_POINT] = writeMultiPointGeometry;
	GEOMETRY_WRITERS[GeometryType.MULTI_LINE_STRING] = writeMultiLineStringGeometry;
	GEOMETRY_WRITERS[GeometryType.MULTI_POLYGON] = writeMultiPolygonGeometry;
	
	
	/**
	 * @typedef {Object} Options
	 * @property {string} [geometryName] Geometry name to use when creating features.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the EsriJSON format.
	 *
	 * @api
	 */
	var EsriJSON = /*@__PURE__*/(function (JSONFeature$$1) {
	  function EsriJSON(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    JSONFeature$$1.call(this);
	
	    /**
	     * Name of the geometry attribute for features.
	     * @type {string|undefined}
	     * @private
	     */
	    this.geometryName_ = options.geometryName;
	
	  }
	
	  if ( JSONFeature$$1 ) { EsriJSON.__proto__ = JSONFeature$$1; }
	  EsriJSON.prototype = Object.create( JSONFeature$$1 && JSONFeature$$1.prototype );
	  EsriJSON.prototype.constructor = EsriJSON;
	
	  /**
	   * @inheritDoc
	   */
	  EsriJSON.prototype.readFeatureFromObject = function readFeatureFromObject (object, opt_options) {
	    var esriJSONFeature = /** @type {EsriJSONFeature} */ (object);
	    var geometry = readGeometry(esriJSONFeature.geometry, opt_options);
	    var feature = new Feature();
	    if (this.geometryName_) {
	      feature.setGeometryName(this.geometryName_);
	    }
	    feature.setGeometry(geometry);
	    if (opt_options && opt_options.idField &&
	      esriJSONFeature.attributes[opt_options.idField]) {
	      feature.setId(/** @type {number} */(esriJSONFeature.attributes[opt_options.idField]));
	    }
	    if (esriJSONFeature.attributes) {
	      feature.setProperties(esriJSONFeature.attributes);
	    }
	    return feature;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  EsriJSON.prototype.readFeaturesFromObject = function readFeaturesFromObject (object, opt_options) {
	    var options = opt_options ? opt_options : {};
	    if (object['features']) {
	      var esriJSONFeatureSet = /** @type {EsriJSONFeatureSet} */ (object);
	      /** @type {Array<import("../Feature.js").default>} */
	      var features = [];
	      var esriJSONFeatures = esriJSONFeatureSet.features;
	      options.idField = object.objectIdFieldName;
	      for (var i = 0, ii = esriJSONFeatures.length; i < ii; ++i) {
	        features.push(this.readFeatureFromObject(esriJSONFeatures[i], options));
	      }
	      return features;
	    } else {
	      return [this.readFeatureFromObject(object, options)];
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  EsriJSON.prototype.readGeometryFromObject = function readGeometryFromObject (object, opt_options) {
	    return readGeometry(/** @type {EsriJSONGeometry} */(object), opt_options);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  EsriJSON.prototype.readProjectionFromObject = function readProjectionFromObject (object) {
	    if (object['spatialReference'] && object['spatialReference']['wkid'] !== undefined) {
	      var spatialReference = /** @type {EsriJSONSpatialReferenceWkid} */ (object['spatialReference']);
	      var crs = spatialReference.wkid;
	      return get$2('EPSG:' + crs);
	    } else {
	      return null;
	    }
	  };
	
	  /**
	   * Encode a geometry as a EsriJSON object.
	   *
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {EsriJSONGeometry} Object.
	   * @override
	   * @api
	   */
	  EsriJSON.prototype.writeGeometryObject = function writeGeometryObject (geometry, opt_options) {
	    return writeGeometry(geometry, this.adaptOptions(opt_options));
	  };
	
	  /**
	   * Encode a feature as a esriJSON Feature object.
	   *
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {Object} Object.
	   * @override
	   * @api
	   */
	  EsriJSON.prototype.writeFeatureObject = function writeFeatureObject (feature, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    var object = {};
	    var geometry = feature.getGeometry();
	    if (geometry) {
	      object['geometry'] = writeGeometry(geometry, opt_options);
	      if (opt_options && opt_options.featureProjection) {
	        object['geometry']['spatialReference'] = /** @type {EsriJSONSpatialReferenceWkid} */({
	          wkid: Number(get$2(opt_options.featureProjection).getCode().split(':').pop())
	        });
	      }
	    }
	    var properties = feature.getProperties();
	    delete properties[feature.getGeometryName()];
	    if (!isEmpty(properties)) {
	      object['attributes'] = properties;
	    } else {
	      object['attributes'] = {};
	    }
	    return object;
	  };
	
	  /**
	   * Encode an array of features as a EsriJSON object.
	   *
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {Object} EsriJSON Object.
	   * @override
	   * @api
	   */
	  EsriJSON.prototype.writeFeaturesObject = function writeFeaturesObject (features, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    var objects = [];
	    for (var i = 0, ii = features.length; i < ii; ++i) {
	      objects.push(this.writeFeatureObject(features[i], opt_options));
	    }
	    return /** @type {EsriJSONFeatureSet} */ ({
	      'features': objects
	    });
	  };
	
	  return EsriJSON;
	}(JSONFeature));
	
	
	/**
	 * @param {EsriJSONGeometry} object Object.
	 * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	 * @return {import("../geom/Geometry.js").default} Geometry.
	 */
	function readGeometry(object, opt_options) {
	  if (!object) {
	    return null;
	  }
	  /** @type {import("../geom/GeometryType.js").default} */
	  var type;
	  if (typeof object['x'] === 'number' && typeof object['y'] === 'number') {
	    type = GeometryType.POINT;
	  } else if (object['points']) {
	    type = GeometryType.MULTI_POINT;
	  } else if (object['paths']) {
	    var esriJSONPolyline = /** @type {EsriJSONPolyline} */ (object);
	    if (esriJSONPolyline.paths.length === 1) {
	      type = GeometryType.LINE_STRING;
	    } else {
	      type = GeometryType.MULTI_LINE_STRING;
	    }
	  } else if (object['rings']) {
	    var esriJSONPolygon = /** @type {EsriJSONPolygon} */ (object);
	    var layout = getGeometryLayout(esriJSONPolygon);
	    var rings = convertRings(esriJSONPolygon.rings, layout);
	    if (rings.length === 1) {
	      type = GeometryType.POLYGON;
	      object['rings'] = rings[0];
	    } else {
	      type = GeometryType.MULTI_POLYGON;
	      object['rings'] = rings;
	    }
	  }
	  var geometryReader = GEOMETRY_READERS[type];
	  return (
	    /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geometryReader(object), false, opt_options))
	  );
	}
	
	
	/**
	 * Determines inner and outer rings.
	 * Checks if any polygons in this array contain any other polygons in this
	 * array. It is used for checking for holes.
	 * Logic inspired by: https://github.com/Esri/terraformer-arcgis-parser
	 * @param {Array<!Array<!Array<number>>>} rings Rings.
	 * @param {import("../geom/GeometryLayout.js").default} layout Geometry layout.
	 * @return {Array<!Array<!Array<!Array<number>>>>} Transformed rings.
	 */
	function convertRings(rings, layout) {
	  var flatRing = [];
	  var outerRings = [];
	  var holes = [];
	  var i, ii;
	  for (i = 0, ii = rings.length; i < ii; ++i) {
	    flatRing.length = 0;
	    deflateCoordinates(flatRing, 0, rings[i], layout.length);
	    // is this ring an outer ring? is it clockwise?
	    var clockwise = linearRingIsClockwise(flatRing, 0,
	      flatRing.length, layout.length);
	    if (clockwise) {
	      outerRings.push([rings[i]]);
	    } else {
	      holes.push(rings[i]);
	    }
	  }
	  while (holes.length) {
	    var hole = holes.shift();
	    var matched = false;
	    // loop over all outer rings and see if they contain our hole.
	    for (i = outerRings.length - 1; i >= 0; i--) {
	      var outerRing = outerRings[i][0];
	      var containsHole = containsExtent(
	        new LinearRing(outerRing).getExtent(),
	        new LinearRing(hole).getExtent()
	      );
	      if (containsHole) {
	        // the hole is contained push it into our polygon
	        outerRings[i].push(hole);
	        matched = true;
	        break;
	      }
	    }
	    if (!matched) {
	      // no outer rings contain this hole turn it into and outer
	      // ring (reverse it)
	      outerRings.push([hole.reverse()]);
	    }
	  }
	  return outerRings;
	}
	
	
	/**
	 * @param {EsriJSONPoint} object Object.
	 * @return {import("../geom/Geometry.js").default} Point.
	 */
	function readPointGeometry(object) {
	  var point;
	  if (object.m !== undefined && object.z !== undefined) {
	    point = new Point([object.x, object.y, object.z, object.m],
	      GeometryLayout.XYZM);
	  } else if (object.z !== undefined) {
	    point = new Point([object.x, object.y, object.z],
	      GeometryLayout.XYZ);
	  } else if (object.m !== undefined) {
	    point = new Point([object.x, object.y, object.m],
	      GeometryLayout.XYM);
	  } else {
	    point = new Point([object.x, object.y]);
	  }
	  return point;
	}
	
	
	/**
	 * @param {EsriJSONPolyline} object Object.
	 * @return {import("../geom/Geometry.js").default} LineString.
	 */
	function readLineStringGeometry(object) {
	  var layout = getGeometryLayout(object);
	  return new LineString(object.paths[0], layout);
	}
	
	
	/**
	 * @param {EsriJSONPolyline} object Object.
	 * @return {import("../geom/Geometry.js").default} MultiLineString.
	 */
	function readMultiLineStringGeometry(object) {
	  var layout = getGeometryLayout(object);
	  return new MultiLineString(object.paths, layout);
	}
	
	
	/**
	 * @param {EsriJSONHasZM} object Object.
	 * @return {import("../geom/GeometryLayout.js").default} The geometry layout to use.
	 */
	function getGeometryLayout(object) {
	  var layout = GeometryLayout.XY;
	  if (object.hasZ === true && object.hasM === true) {
	    layout = GeometryLayout.XYZM;
	  } else if (object.hasZ === true) {
	    layout = GeometryLayout.XYZ;
	  } else if (object.hasM === true) {
	    layout = GeometryLayout.XYM;
	  }
	  return layout;
	}
	
	
	/**
	 * @param {EsriJSONMultipoint} object Object.
	 * @return {import("../geom/Geometry.js").default} MultiPoint.
	 */
	function readMultiPointGeometry(object) {
	  var layout = getGeometryLayout(object);
	  return new MultiPoint(object.points, layout);
	}
	
	
	/**
	 * @param {EsriJSONMultiPolygon} object Object.
	 * @return {import("../geom/Geometry.js").default} MultiPolygon.
	 */
	function readMultiPolygonGeometry(object) {
	  var layout = getGeometryLayout(object);
	  return new MultiPolygon(object.rings, layout);
	}
	
	
	/**
	 * @param {EsriJSONPolygon} object Object.
	 * @return {import("../geom/Geometry.js").default} Polygon.
	 */
	function readPolygonGeometry(object) {
	  var layout = getGeometryLayout(object);
	  return new Polygon(object.rings, layout);
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONGeometry} EsriJSON geometry.
	 */
	function writePointGeometry(geometry, opt_options) {
	  var coordinates = /** @type {import("../geom/Point.js").default} */ (geometry).getCoordinates();
	  var esriJSON;
	  var layout = /** @type {import("../geom/Point.js").default} */ (geometry).getLayout();
	  if (layout === GeometryLayout.XYZ) {
	    esriJSON = /** @type {EsriJSONPoint} */ ({
	      x: coordinates[0],
	      y: coordinates[1],
	      z: coordinates[2]
	    });
	  } else if (layout === GeometryLayout.XYM) {
	    esriJSON = /** @type {EsriJSONPoint} */ ({
	      x: coordinates[0],
	      y: coordinates[1],
	      m: coordinates[2]
	    });
	  } else if (layout === GeometryLayout.XYZM) {
	    esriJSON = /** @type {EsriJSONPoint} */ ({
	      x: coordinates[0],
	      y: coordinates[1],
	      z: coordinates[2],
	      m: coordinates[3]
	    });
	  } else if (layout === GeometryLayout.XY) {
	    esriJSON = /** @type {EsriJSONPoint} */ ({
	      x: coordinates[0],
	      y: coordinates[1]
	    });
	  } else {
	    assert(false, 34); // Invalid geometry layout
	  }
	  return /** @type {EsriJSONGeometry} */ (esriJSON);
	}
	
	
	/**
	 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
	 * @return {Object} Object with boolean hasZ and hasM keys.
	 */
	function getHasZM(geometry) {
	  var layout = geometry.getLayout();
	  return {
	    hasZ: (layout === GeometryLayout.XYZ ||
	      layout === GeometryLayout.XYZM),
	    hasM: (layout === GeometryLayout.XYM ||
	      layout === GeometryLayout.XYZM)
	  };
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONPolyline} EsriJSON geometry.
	 */
	function writeLineStringGeometry(geometry, opt_options) {
	  var lineString = /** @type {import("../geom/LineString.js").default} */ (geometry);
	  var hasZM = getHasZM(lineString);
	  return (
	    /** @type {EsriJSONPolyline} */ {
	      hasZ: hasZM.hasZ,
	      hasM: hasZM.hasM,
	      paths: [
	        /** @type {Array<EsriJSONPosition>} */ (lineString.getCoordinates())
	      ]
	    }
	  );
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONPolygon} EsriJSON geometry.
	 */
	function writePolygonGeometry(geometry, opt_options) {
	  var polygon = /** @type {import("../geom/Polygon.js").default} */ (geometry);
	  // Esri geometries use the left-hand rule
	  var hasZM = getHasZM(polygon);
	  return (
	    /** @type {EsriJSONPolygon} */ {
	      hasZ: hasZM.hasZ,
	      hasM: hasZM.hasM,
	      rings: /** @type {Array<Array<EsriJSONPosition>>} */ (polygon.getCoordinates(false))
	    }
	  );
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONPolyline} EsriJSON geometry.
	 */
	function writeMultiLineStringGeometry(geometry, opt_options) {
	  var multiLineString = /** @type {import("../geom/MultiLineString.js").default} */ (geometry);
	  var hasZM = getHasZM(multiLineString);
	  return (
	    /** @type {EsriJSONPolyline} */ {
	      hasZ: hasZM.hasZ,
	      hasM: hasZM.hasM,
	      paths: /** @type {Array<Array<EsriJSONPosition>>} */ (multiLineString.getCoordinates())
	    }
	  );
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONMultipoint} EsriJSON geometry.
	 */
	function writeMultiPointGeometry(geometry, opt_options) {
	  var multiPoint = /** @type {import("../geom/MultiPoint.js").default} */ (geometry);
	  var hasZM = getHasZM(multiPoint);
	  return (
	    /** @type {EsriJSONMultipoint} */ {
	      hasZ: hasZM.hasZ,
	      hasM: hasZM.hasM,
	      points: /** @type {Array<EsriJSONPosition>} */ (multiPoint.getCoordinates())
	    }
	  );
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONPolygon} EsriJSON geometry.
	 */
	function writeMultiPolygonGeometry(geometry, opt_options) {
	  var hasZM = getHasZM(/** @type {import("../geom/MultiPolygon.js").default} */(geometry));
	  var coordinates = /** @type {import("../geom/MultiPolygon.js").default} */ (geometry).getCoordinates(false);
	  var output = [];
	  for (var i = 0; i < coordinates.length; i++) {
	    for (var x = coordinates[i].length - 1; x >= 0; x--) {
	      output.push(coordinates[i][x]);
	    }
	  }
	  return /** @type {EsriJSONPolygon} */ ({
	    hasZ: hasZM.hasZ,
	    hasM: hasZM.hasM,
	    rings: output
	  });
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {EsriJSONGeometry} EsriJSON geometry.
	 */
	function writeGeometry(geometry, opt_options) {
	  var geometryWriter = GEOMETRY_WRITERS[geometry.getType()];
	  return geometryWriter(/** @type {import("../geom/Geometry.js").default} */(
	    transformWithOptions(geometry, true, opt_options)), opt_options);
	}
	
	/**
	 * @module ol/format/XMLFeature
	 */
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for XML feature formats.
	 *
	 * @abstract
	 */
	var XMLFeature = /*@__PURE__*/(function (FeatureFormat$$1) {
	  function XMLFeature() {
	    FeatureFormat$$1.call(this);
	
	    /**
	     * @type {XMLSerializer}
	     * @private
	     */
	    this.xmlSerializer_ = new XMLSerializer();
	  }
	
	  if ( FeatureFormat$$1 ) { XMLFeature.__proto__ = FeatureFormat$$1; }
	  XMLFeature.prototype = Object.create( FeatureFormat$$1 && FeatureFormat$$1.prototype );
	  XMLFeature.prototype.constructor = XMLFeature;
	
	  /**
	   * @inheritDoc
	   */
	  XMLFeature.prototype.getType = function getType () {
	    return FormatType.XML;
	  };
	
	  /**
	   * Read a single feature.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {import("../Feature.js").default} Feature.
	   * @api
	   */
	  XMLFeature.prototype.readFeature = function readFeature (source, opt_options) {
	    if (!source) {
	      return null;
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readFeatureFromDocument(doc, opt_options);
	    } else if (isDocument(source)) {
	      return this.readFeatureFromDocument(/** @type {Document} */ (source), opt_options);
	    } else {
	      return this.readFeatureFromNode(/** @type {Node} */ (source), opt_options);
	    }
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @return {import("../Feature.js").default} Feature.
	   */
	  XMLFeature.prototype.readFeatureFromDocument = function readFeatureFromDocument (doc, opt_options) {
	    var features = this.readFeaturesFromDocument(doc, opt_options);
	    if (features.length > 0) {
	      return features[0];
	    } else {
	      return null;
	    }
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @return {import("../Feature.js").default} Feature.
	   */
	  XMLFeature.prototype.readFeatureFromNode = function readFeatureFromNode (node, opt_options) {
	    return null; // not implemented
	  };
	
	  /**
	   * Read all features from a feature collection.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @api
	   */
	  XMLFeature.prototype.readFeatures = function readFeatures (source, opt_options) {
	    if (!source) {
	      return [];
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readFeaturesFromDocument(doc, opt_options);
	    } else if (isDocument(source)) {
	      return this.readFeaturesFromDocument(
	        /** @type {Document} */ (source), opt_options);
	    } else {
	      return this.readFeaturesFromNode(/** @type {Node} */ (source), opt_options);
	    }
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @protected
	   * @return {Array<import("../Feature.js").default>} Features.
	   */
	  XMLFeature.prototype.readFeaturesFromDocument = function readFeaturesFromDocument (doc, opt_options) {
	    /** @type {Array<import("../Feature.js").default>} */
	    var features = [];
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        extend(features, this.readFeaturesFromNode(n, opt_options));
	      }
	    }
	    return features;
	  };
	
	  /**
	   * @abstract
	   * @param {Node} node Node.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @protected
	   * @return {Array<import("../Feature.js").default>} Features.
	   */
	  XMLFeature.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  XMLFeature.prototype.readGeometry = function readGeometry (source, opt_options) {
	    if (!source) {
	      return null;
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readGeometryFromDocument(doc, opt_options);
	    } else if (isDocument(source)) {
	      return this.readGeometryFromDocument(
	        /** @type {Document} */ (source), opt_options);
	    } else {
	      return this.readGeometryFromNode(/** @type {Node} */ (source), opt_options);
	    }
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @protected
	   * @return {import("../geom/Geometry.js").default} Geometry.
	   */
	  XMLFeature.prototype.readGeometryFromDocument = function readGeometryFromDocument (doc, opt_options) {
	    return null; // not implemented
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Options.
	   * @protected
	   * @return {import("../geom/Geometry.js").default} Geometry.
	   */
	  XMLFeature.prototype.readGeometryFromNode = function readGeometryFromNode (node, opt_options) {
	    return null; // not implemented
	  };
	
	  /**
	   * Read the projection from the source.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @return {import("../proj/Projection.js").default} Projection.
	   * @api
	   */
	  XMLFeature.prototype.readProjection = function readProjection (source) {
	    if (!source) {
	      return null;
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readProjectionFromDocument(doc);
	    } else if (isDocument(source)) {
	      return this.readProjectionFromDocument(/** @type {Document} */ (source));
	    } else {
	      return this.readProjectionFromNode(/** @type {Node} */ (source));
	    }
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @protected
	   * @return {import("../proj/Projection.js").default} Projection.
	   */
	  XMLFeature.prototype.readProjectionFromDocument = function readProjectionFromDocument (doc) {
	    return this.dataProjection;
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @protected
	   * @return {import("../proj/Projection.js").default} Projection.
	   */
	  XMLFeature.prototype.readProjectionFromNode = function readProjectionFromNode (node) {
	    return this.dataProjection;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  XMLFeature.prototype.writeFeature = function writeFeature (feature, opt_options) {
	    var node = this.writeFeatureNode(feature, opt_options);
	    return this.xmlSerializer_.serializeToString(node);
	  };
	
	  /**
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @protected
	   * @return {Node} Node.
	   */
	  XMLFeature.prototype.writeFeatureNode = function writeFeatureNode (feature, opt_options) {
	    return null; // not implemented
	  };
	
	  /**
	   * Encode an array of features as string.
	   *
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Result.
	   * @api
	   */
	  XMLFeature.prototype.writeFeatures = function writeFeatures (features, opt_options) {
	    var node = this.writeFeaturesNode(features, opt_options);
	    return this.xmlSerializer_.serializeToString(node);
	  };
	
	  /**
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @return {Node} Node.
	   */
	  XMLFeature.prototype.writeFeaturesNode = function writeFeaturesNode (features, opt_options) {
	    return null; // not implemented
	  };
	
	  /**
	   * @inheritDoc
	   */
	  XMLFeature.prototype.writeGeometry = function writeGeometry (geometry, opt_options) {
	    var node = this.writeGeometryNode(geometry, opt_options);
	    return this.xmlSerializer_.serializeToString(node);
	  };
	
	  /**
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @return {Node} Node.
	   */
	  XMLFeature.prototype.writeGeometryNode = function writeGeometryNode (geometry, opt_options) {
	    return null; // not implemented
	  };
	
	  return XMLFeature;
	}(FeatureFormat));
	
	/**
	 * @module ol/format/GMLBase
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var GMLNS = 'http://www.opengis.net/gml';
	
	
	/**
	 * A regular expression that matches if a string only contains whitespace
	 * characters. It will e.g. match `''`, `' '`, `'\n'` etc. The non-breaking
	 * space (0xa0) is explicitly included as IE doesn't include it in its
	 * definition of `\s`.
	 *
	 * Information from `goog.string.isEmptyOrWhitespace`: https://github.com/google/closure-library/blob/e877b1e/closure/goog/string/string.js#L156-L160
	 *
	 * @const
	 * @type {RegExp}
	 */
	var ONLY_WHITESPACE_RE = /^[\s\xa0]*$/;
	
	
	/**
	 * @typedef {Object} Options
	 * @property {Object<string, string>|string} [featureNS] Feature
	 * namespace. If not defined will be derived from GML. If multiple
	 * feature types have been configured which come from different feature
	 * namespaces, this will be an object with the keys being the prefixes used
	 * in the entries of featureType array. The values of the object will be the
	 * feature namespaces themselves. So for instance there might be a featureType
	 * item `topp:states` in the `featureType` array and then there will be a key
	 * `topp` in the featureNS object with value `http://www.openplans.org/topp`.
	 * @property {Array<string>|string} [featureType] Feature type(s) to parse.
	 * If multiple feature types need to be configured
	 * which come from different feature namespaces, `featureNS` will be an object
	 * with the keys being the prefixes used in the entries of featureType array.
	 * The values of the object will be the feature namespaces themselves.
	 * So for instance there might be a featureType item `topp:states` and then
	 * there will be a key named `topp` in the featureNS object with value
	 * `http://www.openplans.org/topp`.
	 * @property {string} srsName srsName to use when writing geometries.
	 * @property {boolean} [surface=false] Write gml:Surface instead of gml:Polygon
	 * elements. This also affects the elements in multi-part geometries.
	 * @property {boolean} [curve=false] Write gml:Curve instead of gml:LineString
	 * elements. This also affects the elements in multi-part geometries.
	 * @property {boolean} [multiCurve=true] Write gml:MultiCurve instead of gml:MultiLineString.
	 * Since the latter is deprecated in GML 3.
	 * @property {boolean} [multiSurface=true] Write gml:multiSurface instead of
	 * gml:MultiPolygon. Since the latter is deprecated in GML 3.
	 * @property {string} [schemaLocation] Optional schemaLocation to use when
	 * writing out the GML, this will override the default provided.
	 * @property {boolean} [hasZ=false] If coordinates have a Z value.
	 */
	
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Feature base format for reading and writing data in the GML format.
	 * This class cannot be instantiated, it contains only base content that
	 * is shared with versioned format classes GML2 and GML3.
	 *
	 * @abstract
	 */
	var GMLBase = /*@__PURE__*/(function (XMLFeature$$1) {
	  function GMLBase(opt_options) {
	    XMLFeature$$1.call(this);
	
	    var options = /** @type {Options} */ (opt_options ? opt_options : {});
	
	    /**
	     * @protected
	     * @type {Array<string>|string|undefined}
	     */
	    this.featureType = options.featureType;
	
	    /**
	     * @protected
	     * @type {Object<string, string>|string|undefined}
	     */
	    this.featureNS = options.featureNS;
	
	    /**
	     * @protected
	     * @type {string}
	     */
	    this.srsName = options.srsName;
	
	    /**
	     * @protected
	     * @type {string}
	     */
	    this.schemaLocation = '';
	
	    /**
	     * @type {Object<string, Object<string, Object>>}
	     */
	    this.FEATURE_COLLECTION_PARSERS = {};
	    this.FEATURE_COLLECTION_PARSERS[this.namespace] = {
	      'featureMember': makeArrayPusher(this.readFeaturesInternal),
	      'featureMembers': makeReplacer(this.readFeaturesInternal)
	    };
	  }
	
	  if ( XMLFeature$$1 ) { GMLBase.__proto__ = XMLFeature$$1; }
	  GMLBase.prototype = Object.create( XMLFeature$$1 && XMLFeature$$1.prototype );
	  GMLBase.prototype.constructor = GMLBase;
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {Array<Feature> | undefined} Features.
	   */
	  GMLBase.prototype.readFeaturesInternal = function readFeaturesInternal (node, objectStack) {
	    var localName = node.localName;
	    var features = null;
	    if (localName == 'FeatureCollection') {
	      features = pushParseAndPop([],
	        this.FEATURE_COLLECTION_PARSERS, node,
	        objectStack, this);
	    } else if (localName == 'featureMembers' || localName == 'featureMember') {
	      var context = objectStack[0];
	      var featureType = context['featureType'];
	      var featureNS = context['featureNS'];
	      var prefix = 'p';
	      var defaultPrefix = 'p0';
	      if (!featureType && node.childNodes) {
	        featureType = [], featureNS = {};
	        for (var i = 0, ii = node.childNodes.length; i < ii; ++i) {
	          var child = node.childNodes[i];
	          if (child.nodeType === 1) {
	            var ft = child.nodeName.split(':').pop();
	            if (featureType.indexOf(ft) === -1) {
	              var key = '';
	              var count = 0;
	              var uri = child.namespaceURI;
	              for (var candidate in featureNS) {
	                if (featureNS[candidate] === uri) {
	                  key = candidate;
	                  break;
	                }
	                ++count;
	              }
	              if (!key) {
	                key = prefix + count;
	                featureNS[key] = uri;
	              }
	              featureType.push(key + ':' + ft);
	            }
	          }
	        }
	        if (localName != 'featureMember') {
	          // recheck featureType for each featureMember
	          context['featureType'] = featureType;
	          context['featureNS'] = featureNS;
	        }
	      }
	      if (typeof featureNS === 'string') {
	        var ns = featureNS;
	        featureNS = {};
	        featureNS[defaultPrefix] = ns;
	      }
	      /** @type {Object<string, Object<string, import("../xml.js").Parser>>} */
	      var parsersNS = {};
	      var featureTypes = Array.isArray(featureType) ? featureType : [featureType];
	      for (var p in featureNS) {
	        /** @type {Object<string, import("../xml.js").Parser>} */
	        var parsers = {};
	        for (var i$1 = 0, ii$1 = featureTypes.length; i$1 < ii$1; ++i$1) {
	          var featurePrefix = featureTypes[i$1].indexOf(':') === -1 ?
	            defaultPrefix : featureTypes[i$1].split(':')[0];
	          if (featurePrefix === p) {
	            parsers[featureTypes[i$1].split(':').pop()] =
	                (localName == 'featureMembers') ?
	                  makeArrayPusher(this.readFeatureElement, this) :
	                  makeReplacer(this.readFeatureElement, this);
	          }
	        }
	        parsersNS[featureNS[p]] = parsers;
	      }
	      if (localName == 'featureMember') {
	        features = pushParseAndPop(undefined, parsersNS, node, objectStack);
	      } else {
	        features = pushParseAndPop([], parsersNS, node, objectStack);
	      }
	    }
	    if (features === null) {
	      features = [];
	    }
	    return features;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {import("../geom/Geometry.js").default|undefined} Geometry.
	   */
	  GMLBase.prototype.readGeometryElement = function readGeometryElement (node, objectStack) {
	    var context = /** @type {Object} */ (objectStack[0]);
	    context['srsName'] = node.firstElementChild.getAttribute('srsName');
	    context['srsDimension'] = node.firstElementChild.getAttribute('srsDimension');
	    /** @type {import("../geom/Geometry.js").default} */
	    var geometry = pushParseAndPop(null, this.GEOMETRY_PARSERS, node, objectStack, this);
	    if (geometry) {
	      return (
	        /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geometry, false, context))
	      );
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {boolean} asFeature whether result should be wrapped as a feature.
	   * @return {Feature|Object} Feature
	   */
	  GMLBase.prototype.readFeatureElementInternal = function readFeatureElementInternal (node, objectStack, asFeature) {
	    var geometryName;
	    var values = {};
	    for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
	      var value = (void 0);
	      var localName = n.localName;
	      // first, check if it is simple attribute
	      if (n.childNodes.length === 0
	              || (n.childNodes.length === 1 && (n.firstChild.nodeType === 3 || n.firstChild.nodeType === 4))) {
	        value = getAllTextContent(n, false);
	        if (ONLY_WHITESPACE_RE.test(value)) {
	          value = undefined;
	        }
	      } else {
	        if (asFeature) {
	          //if feature, try it as a geometry
	          value = this.readGeometryElement(n, objectStack);
	        }
	        if (!value) { //if not a geometry or not a feature, treat it as a complex attribute
	          value = this.readFeatureElementInternal(n, objectStack, false);
	        } else if (localName !== 'boundedBy') {
	          // boundedBy is an extent and must not be considered as a geometry
	          geometryName = localName;
	        }
	      }
	
	      if (values[localName]) {
	        if (!(values[localName] instanceof Array)) {
	          values[localName] = [values[localName]];
	        }
	        values[localName].push(value);
	      } else {
	        values[localName] = value;
	      }
	
	      var len = n.attributes.length;
	      if (len > 0) {
	        values[localName] = {_content_: values[localName]};
	        for (var i = 0; i < len; i++) {
	          var attName = n.attributes[i].name;
	          values[localName][attName] = n.attributes[i].value;
	        }
	      }
	    }
	    if (!asFeature) {
	      return values;
	    } else {
	      var feature = new Feature(values);
	      if (geometryName) {
	        feature.setGeometryName(geometryName);
	      }
	      var fid = node.getAttribute('fid') ||
	           getAttributeNS(node, this.namespace, 'id');
	      if (fid) {
	        feature.setId(fid);
	      }
	      return feature;
	    }
	  };
	
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {Feature} Feature.
	   */
	  GMLBase.prototype.readFeatureElement = function readFeatureElement (node, objectStack) {
	    return this.readFeatureElementInternal(node, objectStack, true);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {Point|undefined} Point.
	   */
	  GMLBase.prototype.readPoint = function readPoint (node, objectStack) {
	    var flatCoordinates = this.readFlatCoordinatesFromNode_(node, objectStack);
	    if (flatCoordinates) {
	      return new Point(flatCoordinates, GeometryLayout.XYZ);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {MultiPoint|undefined} MultiPoint.
	   */
	  GMLBase.prototype.readMultiPoint = function readMultiPoint (node, objectStack) {
	    /** @type {Array<Array<number>>} */
	    var coordinates = pushParseAndPop([],
	      this.MULTIPOINT_PARSERS_, node, objectStack, this);
	    if (coordinates) {
	      return new MultiPoint(coordinates);
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {MultiLineString|undefined} MultiLineString.
	   */
	  GMLBase.prototype.readMultiLineString = function readMultiLineString (node, objectStack) {
	    /** @type {Array<LineString>} */
	    var lineStrings = pushParseAndPop([],
	      this.MULTILINESTRING_PARSERS_, node, objectStack, this);
	    if (lineStrings) {
	      return new MultiLineString(lineStrings);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {MultiPolygon|undefined} MultiPolygon.
	   */
	  GMLBase.prototype.readMultiPolygon = function readMultiPolygon (node, objectStack) {
	    /** @type {Array<Polygon>} */
	    var polygons = pushParseAndPop([], this.MULTIPOLYGON_PARSERS_, node, objectStack, this);
	    if (polygons) {
	      return new MultiPolygon(polygons);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GMLBase.prototype.pointMemberParser_ = function pointMemberParser_ (node, objectStack) {
	    parseNode(this.POINTMEMBER_PARSERS_, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GMLBase.prototype.lineStringMemberParser_ = function lineStringMemberParser_ (node, objectStack) {
	    parseNode(this.LINESTRINGMEMBER_PARSERS_, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GMLBase.prototype.polygonMemberParser_ = function polygonMemberParser_ (node, objectStack) {
	    parseNode(this.POLYGONMEMBER_PARSERS_, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {LineString|undefined} LineString.
	   */
	  GMLBase.prototype.readLineString = function readLineString (node, objectStack) {
	    var flatCoordinates = this.readFlatCoordinatesFromNode_(node, objectStack);
	    if (flatCoordinates) {
	      var lineString = new LineString(flatCoordinates, GeometryLayout.XYZ);
	      return lineString;
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>|undefined} LinearRing flat coordinates.
	   */
	  GMLBase.prototype.readFlatLinearRing_ = function readFlatLinearRing_ (node, objectStack) {
	    var ring = pushParseAndPop(null,
	      this.GEOMETRY_FLAT_COORDINATES_PARSERS, node,
	      objectStack, this);
	    if (ring) {
	      return ring;
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {LinearRing|undefined} LinearRing.
	   */
	  GMLBase.prototype.readLinearRing = function readLinearRing (node, objectStack) {
	    var flatCoordinates = this.readFlatCoordinatesFromNode_(node, objectStack);
	    if (flatCoordinates) {
	      return new LinearRing(flatCoordinates, GeometryLayout.XYZ);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {Polygon|undefined} Polygon.
	   */
	  GMLBase.prototype.readPolygon = function readPolygon (node, objectStack) {
	    /** @type {Array<Array<number>>} */
	    var flatLinearRings = pushParseAndPop([null],
	      this.FLAT_LINEAR_RINGS_PARSERS, node, objectStack, this);
	    if (flatLinearRings && flatLinearRings[0]) {
	      var flatCoordinates = flatLinearRings[0];
	      var ends = [flatCoordinates.length];
	      var i, ii;
	      for (i = 1, ii = flatLinearRings.length; i < ii; ++i) {
	        extend(flatCoordinates, flatLinearRings[i]);
	        ends.push(flatCoordinates.length);
	      }
	      return new Polygon(flatCoordinates, GeometryLayout.XYZ, ends);
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>} Flat coordinates.
	   */
	  GMLBase.prototype.readFlatCoordinatesFromNode_ = function readFlatCoordinatesFromNode_ (node, objectStack) {
	    return pushParseAndPop(null, this.GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack, this);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GMLBase.prototype.readGeometryFromNode = function readGeometryFromNode (node, opt_options) {
	    var geometry = this.readGeometryElement(node,
	      [this.getReadOptions(node, opt_options ? opt_options : {})]);
	    return geometry ? geometry : null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GMLBase.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    var options = {
	      featureType: this.featureType,
	      featureNS: this.featureNS
	    };
	    if (opt_options) {
	      assign(options, this.getReadOptions(node, opt_options));
	    }
	    var features = this.readFeaturesInternal(node, [options]);
	    return features || [];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GMLBase.prototype.readProjectionFromNode = function readProjectionFromNode (node) {
	    return get$2(this.srsName ? this.srsName : node.firstElementChild.getAttribute('srsName'));
	  };
	
	  return GMLBase;
	}(XMLFeature));
	
	
	GMLBase.prototype.namespace = GMLNS;
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GMLBase.prototype.FLAT_LINEAR_RINGS_PARSERS = {
	  'http://www.opengis.net/gml': {}
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GMLBase.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
	  'http://www.opengis.net/gml': {}
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GMLBase.prototype.GEOMETRY_PARSERS = {
	  'http://www.opengis.net/gml': {}
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GMLBase.prototype.MULTIPOINT_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'pointMember': makeArrayPusher(GMLBase.prototype.pointMemberParser_),
	    'pointMembers': makeArrayPusher(GMLBase.prototype.pointMemberParser_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GMLBase.prototype.MULTILINESTRING_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'lineStringMember': makeArrayPusher(GMLBase.prototype.lineStringMemberParser_),
	    'lineStringMembers': makeArrayPusher(GMLBase.prototype.lineStringMemberParser_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GMLBase.prototype.MULTIPOLYGON_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'polygonMember': makeArrayPusher(GMLBase.prototype.polygonMemberParser_),
	    'polygonMembers': makeArrayPusher(GMLBase.prototype.polygonMemberParser_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GMLBase.prototype.POINTMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'Point': makeArrayPusher(GMLBase.prototype.readFlatCoordinatesFromNode_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GMLBase.prototype.LINESTRINGMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'LineString': makeArrayPusher(GMLBase.prototype.readLineString)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GMLBase.prototype.POLYGONMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'Polygon': makeArrayPusher(GMLBase.prototype.readPolygon)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GMLBase.prototype.RING_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'LinearRing': makeReplacer(GMLBase.prototype.readFlatLinearRing_)
	  }
	};
	
	/**
	 * @module ol/format/xsd
	 */
	
	
	/**
	 * @param {Node} node Node.
	 * @return {boolean|undefined} Boolean.
	 */
	function readBoolean(node) {
	  var s = getAllTextContent(node, false);
	  return readBooleanString(s);
	}
	
	
	/**
	 * @param {string} string String.
	 * @return {boolean|undefined} Boolean.
	 */
	function readBooleanString(string) {
	  var m = /^\s*(true|1)|(false|0)\s*$/.exec(string);
	  if (m) {
	    return m[1] !== undefined || false;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {number|undefined} DateTime in seconds.
	 */
	function readDateTime(node) {
	  var s = getAllTextContent(node, false);
	  var dateTime = Date.parse(s);
	  return isNaN(dateTime) ? undefined : dateTime / 1000;
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {number|undefined} Decimal.
	 */
	function readDecimal(node) {
	  var s = getAllTextContent(node, false);
	  return readDecimalString(s);
	}
	
	
	/**
	 * @param {string} string String.
	 * @return {number|undefined} Decimal.
	 */
	function readDecimalString(string) {
	  // FIXME check spec
	  var m = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(string);
	  if (m) {
	    return parseFloat(m[1]);
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {number|undefined} Non negative integer.
	 */
	function readNonNegativeInteger(node) {
	  var s = getAllTextContent(node, false);
	  return readNonNegativeIntegerString(s);
	}
	
	
	/**
	 * @param {string} string String.
	 * @return {number|undefined} Non negative integer.
	 */
	function readNonNegativeIntegerString(string) {
	  var m = /^\s*(\d+)\s*$/.exec(string);
	  if (m) {
	    return parseInt(m[1], 10);
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {string|undefined} String.
	 */
	function readString(node) {
	  return getAllTextContent(node, false).trim();
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the boolean to.
	 * @param {boolean} bool Boolean.
	 */
	function writeBooleanTextNode(node, bool) {
	  writeStringTextNode(node, (bool) ? '1' : '0');
	}
	
	
	/**
	 * @param {Node} node Node to append a CDATA Section with the string to.
	 * @param {string} string String.
	 */
	function writeCDATASection(node, string) {
	  node.appendChild(DOCUMENT.createCDATASection(string));
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the dateTime to.
	 * @param {number} dateTime DateTime in seconds.
	 */
	function writeDateTimeTextNode(node, dateTime) {
	  var date = new Date(dateTime * 1000);
	  var string = date.getUTCFullYear() + '-' +
	      padNumber(date.getUTCMonth() + 1, 2) + '-' +
	      padNumber(date.getUTCDate(), 2) + 'T' +
	      padNumber(date.getUTCHours(), 2) + ':' +
	      padNumber(date.getUTCMinutes(), 2) + ':' +
	      padNumber(date.getUTCSeconds(), 2) + 'Z';
	  node.appendChild(DOCUMENT.createTextNode(string));
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the decimal to.
	 * @param {number} decimal Decimal.
	 */
	function writeDecimalTextNode(node, decimal) {
	  var string = decimal.toPrecision();
	  node.appendChild(DOCUMENT.createTextNode(string));
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the decimal to.
	 * @param {number} nonNegativeInteger Non negative integer.
	 */
	function writeNonNegativeIntegerTextNode(node, nonNegativeInteger) {
	  var string = nonNegativeInteger.toString();
	  node.appendChild(DOCUMENT.createTextNode(string));
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the string to.
	 * @param {string} string String.
	 */
	function writeStringTextNode(node, string) {
	  node.appendChild(DOCUMENT.createTextNode(string));
	}
	
	/**
	 * @module ol/format/GML3
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 * @private
	 */
	var schemaLocation = GMLNS +
	    ' http://schemas.opengis.net/gml/3.1.1/profiles/gmlsfProfile/' +
	    '1.0.0/gmlsf.xsd';
	
	
	/**
	 * @const
	 * @type {Object<string, string>}
	 */
	var MULTIGEOMETRY_TO_MEMBER_NODENAME = {
	  'MultiLineString': 'lineStringMember',
	  'MultiCurve': 'curveMember',
	  'MultiPolygon': 'polygonMember',
	  'MultiSurface': 'surfaceMember'
	};
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the GML format
	 * version 3.1.1.
	 * Currently only supports GML 3.1.1 Simple Features profile.
	 *
	 * @api
	 */
	var GML3 = /*@__PURE__*/(function (GMLBase$$1) {
	  function GML3(opt_options) {
	    var options = /** @type {import("./GMLBase.js").Options} */
	        (opt_options ? opt_options : {});
	
	    GMLBase$$1.call(this, options);
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.surface_ = options.surface !== undefined ? options.surface : false;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.curve_ = options.curve !== undefined ? options.curve : false;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.multiCurve_ = options.multiCurve !== undefined ?
	      options.multiCurve : true;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.multiSurface_ = options.multiSurface !== undefined ?
	      options.multiSurface : true;
	
	    /**
	     * @inheritDoc
	     */
	    this.schemaLocation = options.schemaLocation ?
	      options.schemaLocation : schemaLocation;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.hasZ = options.hasZ !== undefined ?
	      options.hasZ : false;
	
	  }
	
	  if ( GMLBase$$1 ) { GML3.__proto__ = GMLBase$$1; }
	  GML3.prototype = Object.create( GMLBase$$1 && GMLBase$$1.prototype );
	  GML3.prototype.constructor = GML3;
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {MultiLineString|undefined} MultiLineString.
	   */
	  GML3.prototype.readMultiCurve_ = function readMultiCurve_ (node, objectStack) {
	    /** @type {Array<LineString>} */
	    var lineStrings = pushParseAndPop([],
	      this.MULTICURVE_PARSERS_, node, objectStack, this);
	    if (lineStrings) {
	      var multiLineString = new MultiLineString(lineStrings);
	      return multiLineString;
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {MultiPolygon|undefined} MultiPolygon.
	   */
	  GML3.prototype.readMultiSurface_ = function readMultiSurface_ (node, objectStack) {
	    /** @type {Array<Polygon>} */
	    var polygons = pushParseAndPop([],
	      this.MULTISURFACE_PARSERS_, node, objectStack, this);
	    if (polygons) {
	      return new MultiPolygon(polygons);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GML3.prototype.curveMemberParser_ = function curveMemberParser_ (node, objectStack) {
	    parseNode(this.CURVEMEMBER_PARSERS_, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GML3.prototype.surfaceMemberParser_ = function surfaceMemberParser_ (node, objectStack) {
	    parseNode(this.SURFACEMEMBER_PARSERS_,
	      node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<(Array<number>)>|undefined} flat coordinates.
	   */
	  GML3.prototype.readPatch_ = function readPatch_ (node, objectStack) {
	    return pushParseAndPop([null],
	      this.PATCHES_PARSERS_, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>|undefined} flat coordinates.
	   */
	  GML3.prototype.readSegment_ = function readSegment_ (node, objectStack) {
	    return pushParseAndPop([null],
	      this.SEGMENTS_PARSERS_, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<(Array<number>)>|undefined} flat coordinates.
	   */
	  GML3.prototype.readPolygonPatch_ = function readPolygonPatch_ (node, objectStack) {
	    return pushParseAndPop([null],
	      this.FLAT_LINEAR_RINGS_PARSERS, node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>|undefined} flat coordinates.
	   */
	  GML3.prototype.readLineStringSegment_ = function readLineStringSegment_ (node, objectStack) {
	    return pushParseAndPop([null],
	      this.GEOMETRY_FLAT_COORDINATES_PARSERS,
	      node, objectStack, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GML3.prototype.interiorParser_ = function interiorParser_ (node, objectStack) {
	    /** @type {Array<number>|undefined} */
	    var flatLinearRing = pushParseAndPop(undefined,
	      this.RING_PARSERS, node, objectStack, this);
	    if (flatLinearRing) {
	      var flatLinearRings = /** @type {Array<Array<number>>} */
	          (objectStack[objectStack.length - 1]);
	      flatLinearRings.push(flatLinearRing);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GML3.prototype.exteriorParser_ = function exteriorParser_ (node, objectStack) {
	    /** @type {Array<number>|undefined} */
	    var flatLinearRing = pushParseAndPop(undefined,
	      this.RING_PARSERS, node, objectStack, this);
	    if (flatLinearRing) {
	      var flatLinearRings = /** @type {Array<Array<number>>} */
	          (objectStack[objectStack.length - 1]);
	      flatLinearRings[0] = flatLinearRing;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Polygon|undefined} Polygon.
	   */
	  GML3.prototype.readSurface_ = function readSurface_ (node, objectStack) {
	    /** @type {Array<Array<number>>} */
	    var flatLinearRings = pushParseAndPop([null],
	      this.SURFACE_PARSERS_, node, objectStack, this);
	    if (flatLinearRings && flatLinearRings[0]) {
	      var flatCoordinates = flatLinearRings[0];
	      var ends = [flatCoordinates.length];
	      var i, ii;
	      for (i = 1, ii = flatLinearRings.length; i < ii; ++i) {
	        extend(flatCoordinates, flatLinearRings[i]);
	        ends.push(flatCoordinates.length);
	      }
	      return new Polygon(flatCoordinates, GeometryLayout.XYZ, ends);
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {LineString|undefined} LineString.
	   */
	  GML3.prototype.readCurve_ = function readCurve_ (node, objectStack) {
	    /** @type {Array<number>} */
	    var flatCoordinates = pushParseAndPop([null],
	      this.CURVE_PARSERS_, node, objectStack, this);
	    if (flatCoordinates) {
	      var lineString = new LineString(flatCoordinates, GeometryLayout.XYZ);
	      return lineString;
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {import("../extent.js").Extent|undefined} Envelope.
	   */
	  GML3.prototype.readEnvelope_ = function readEnvelope_ (node, objectStack) {
	    /** @type {Array<number>} */
	    var flatCoordinates = pushParseAndPop([null],
	      this.ENVELOPE_PARSERS_, node, objectStack, this);
	    return createOrUpdate(flatCoordinates[1][0],
	      flatCoordinates[1][1], flatCoordinates[2][0],
	      flatCoordinates[2][1]);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>|undefined} Flat coordinates.
	   */
	  GML3.prototype.readFlatPos_ = function readFlatPos_ (node, objectStack) {
	    var s = getAllTextContent(node, false);
	    var re = /^\s*([+\-]?\d*\.?\d+(?:[eE][+\-]?\d+)?)\s*/;
	    /** @type {Array<number>} */
	    var flatCoordinates = [];
	    var m;
	    while ((m = re.exec(s))) {
	      flatCoordinates.push(parseFloat(m[1]));
	      s = s.substr(m[0].length);
	    }
	    if (s !== '') {
	      return undefined;
	    }
	    var context = objectStack[0];
	    var containerSrs = context['srsName'];
	    var axisOrientation = 'enu';
	    if (containerSrs) {
	      var proj = get$2(containerSrs);
	      axisOrientation = proj.getAxisOrientation();
	    }
	    if (axisOrientation === 'neu') {
	      var i, ii;
	      for (i = 0, ii = flatCoordinates.length; i < ii; i += 3) {
	        var y = flatCoordinates[i];
	        var x = flatCoordinates[i + 1];
	        flatCoordinates[i] = x;
	        flatCoordinates[i + 1] = y;
	      }
	    }
	    var len = flatCoordinates.length;
	    if (len == 2) {
	      flatCoordinates.push(0);
	    }
	    if (len === 0) {
	      return undefined;
	    }
	    return flatCoordinates;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>|undefined} Flat coordinates.
	   */
	  GML3.prototype.readFlatPosList_ = function readFlatPosList_ (node, objectStack) {
	    var s = getAllTextContent(node, false).replace(/^\s*|\s*$/g, '');
	    var context = objectStack[0];
	    var containerSrs = context['srsName'];
	    var contextDimension = context['srsDimension'];
	    var axisOrientation = 'enu';
	    if (containerSrs) {
	      var proj = get$2(containerSrs);
	      axisOrientation = proj.getAxisOrientation();
	    }
	    var coords = s.split(/\s+/);
	    // The "dimension" attribute is from the GML 3.0.1 spec.
	    var dim = 2;
	    if (node.getAttribute('srsDimension')) {
	      dim = readNonNegativeIntegerString(
	        node.getAttribute('srsDimension'));
	    } else if (node.getAttribute('dimension')) {
	      dim = readNonNegativeIntegerString(
	        node.getAttribute('dimension'));
	    } else if (/** @type {Element} */ (node.parentNode).getAttribute('srsDimension')) {
	      dim = readNonNegativeIntegerString(
	        /** @type {Element} */ (node.parentNode).getAttribute('srsDimension'));
	    } else if (contextDimension) {
	      dim = readNonNegativeIntegerString(contextDimension);
	    }
	    var x, y, z;
	    var flatCoordinates = [];
	    for (var i = 0, ii = coords.length; i < ii; i += dim) {
	      x = parseFloat(coords[i]);
	      y = parseFloat(coords[i + 1]);
	      z = (dim === 3) ? parseFloat(coords[i + 2]) : 0;
	      if (axisOrientation.substr(0, 2) === 'en') {
	        flatCoordinates.push(x, y, z);
	      } else {
	        flatCoordinates.push(y, x, z);
	      }
	    }
	    return flatCoordinates;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/Point.js").default} value Point geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writePos_ = function writePos_ (node, value, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsDimension = hasZ ? '3' : '2';
	    node.setAttribute('srsDimension', srsDimension);
	    var srsName = context['srsName'];
	    var axisOrientation = 'enu';
	    if (srsName) {
	      axisOrientation = get$2(srsName).getAxisOrientation();
	    }
	    var point = value.getCoordinates();
	    var coords;
	    // only 2d for simple features profile
	    if (axisOrientation.substr(0, 2) === 'en') {
	      coords = (point[0] + ' ' + point[1]);
	    } else {
	      coords = (point[1] + ' ' + point[0]);
	    }
	    if (hasZ) {
	      // For newly created points, Z can be undefined.
	      var z = point[2] || 0;
	      coords += ' ' + z;
	    }
	    writeStringTextNode(node, coords);
	  };
	
	  /**
	   * @param {Array<number>} point Point geometry.
	   * @param {string=} opt_srsName Optional srsName
	   * @param {boolean=} opt_hasZ whether the geometry has a Z coordinate (is 3D) or not.
	   * @return {string} The coords string.
	   * @private
	   */
	  GML3.prototype.getCoords_ = function getCoords_ (point, opt_srsName, opt_hasZ) {
	    var axisOrientation = 'enu';
	    if (opt_srsName) {
	      axisOrientation = get$2(opt_srsName).getAxisOrientation();
	    }
	    var coords = ((axisOrientation.substr(0, 2) === 'en') ?
	      point[0] + ' ' + point[1] :
	      point[1] + ' ' + point[0]);
	    if (opt_hasZ) {
	      // For newly created points, Z can be undefined.
	      var z = point[2] || 0;
	      coords += ' ' + z;
	    }
	
	    return coords;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {LineString|import("../geom/LinearRing.js").default} value Geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writePosList_ = function writePosList_ (node, value, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsDimension = hasZ ? '3' : '2';
	    node.setAttribute('srsDimension', srsDimension);
	    var srsName = context['srsName'];
	    // only 2d for simple features profile
	    var points = value.getCoordinates();
	    var len = points.length;
	    var parts = new Array(len);
	    var point;
	    for (var i = 0; i < len; ++i) {
	      point = points[i];
	      parts[i] = this.getCoords_(point, srsName, hasZ);
	    }
	    writeStringTextNode(node, parts.join(' '));
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/Point.js").default} geometry Point geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writePoint_ = function writePoint_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var pos = createElementNS(node.namespaceURI, 'pos');
	    node.appendChild(pos);
	    this.writePos_(pos, geometry, objectStack);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {Array<*>} objectStack Node stack.
	   */
	  GML3.prototype.writeEnvelope = function writeEnvelope (node, extent, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var keys = ['lowerCorner', 'upperCorner'];
	    var values = [extent[0] + ' ' + extent[1], extent[2] + ' ' + extent[3]];
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      ({node: node}), this.ENVELOPE_SERIALIZERS_,
	      OBJECT_PROPERTY_NODE_FACTORY,
	      values,
	      objectStack, keys, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/LinearRing.js").default} geometry LinearRing geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeLinearRing_ = function writeLinearRing_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var posList = createElementNS(node.namespaceURI, 'posList');
	    node.appendChild(posList);
	    this.writePosList_(posList, geometry, objectStack);
	  };
	
	  /**
	   * @param {*} value Value.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {string=} opt_nodeName Node name.
	   * @return {Node} Node.
	   * @private
	   */
	  GML3.prototype.RING_NODE_FACTORY_ = function RING_NODE_FACTORY_ (value, objectStack, opt_nodeName) {
	    var context = objectStack[objectStack.length - 1];
	    var parentNode = context.node;
	    var exteriorWritten = context['exteriorWritten'];
	    if (exteriorWritten === undefined) {
	      context['exteriorWritten'] = true;
	    }
	    return createElementNS(parentNode.namespaceURI,
	      exteriorWritten !== undefined ? 'interior' : 'exterior');
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Polygon} geometry Polygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeSurfaceOrPolygon_ = function writeSurfaceOrPolygon_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    if (node.nodeName !== 'PolygonPatch' && srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    if (node.nodeName === 'Polygon' || node.nodeName === 'PolygonPatch') {
	      var rings = geometry.getLinearRings();
	      pushSerializeAndPop(
	        {node: node, hasZ: hasZ, srsName: srsName},
	        this.RING_SERIALIZERS_,
	        this.RING_NODE_FACTORY_,
	        rings, objectStack, undefined, this);
	    } else if (node.nodeName === 'Surface') {
	      var patches = createElementNS(node.namespaceURI, 'patches');
	      node.appendChild(patches);
	      this.writeSurfacePatches_(
	        patches, geometry, objectStack);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {LineString} geometry LineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeCurveOrLineString_ = function writeCurveOrLineString_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (node.nodeName !== 'LineStringSegment' && srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    if (node.nodeName === 'LineString' ||
	        node.nodeName === 'LineStringSegment') {
	      var posList = createElementNS(node.namespaceURI, 'posList');
	      node.appendChild(posList);
	      this.writePosList_(posList, geometry, objectStack);
	    } else if (node.nodeName === 'Curve') {
	      var segments = createElementNS(node.namespaceURI, 'segments');
	      node.appendChild(segments);
	      this.writeCurveSegments_(segments,
	        geometry, objectStack);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {MultiPolygon} geometry MultiPolygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeMultiSurfaceOrPolygon_ = function writeMultiSurfaceOrPolygon_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    var surface = context['surface'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var polygons = geometry.getPolygons();
	    pushSerializeAndPop({node: node, hasZ: hasZ, srsName: srsName, surface: surface},
	      this.SURFACEORPOLYGONMEMBER_SERIALIZERS_,
	      this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, polygons,
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/MultiPoint.js").default} geometry MultiPoint geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeMultiPoint_ = function writeMultiPoint_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    var hasZ = context['hasZ'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var points = geometry.getPoints();
	    pushSerializeAndPop({node: node, hasZ: hasZ, srsName: srsName},
	      this.POINTMEMBER_SERIALIZERS_,
	      makeSimpleNodeFactory('pointMember'), points,
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {MultiLineString} geometry MultiLineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeMultiCurveOrLineString_ = function writeMultiCurveOrLineString_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    var curve = context['curve'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var lines = geometry.getLineStrings();
	    pushSerializeAndPop({node: node, hasZ: hasZ, srsName: srsName, curve: curve},
	      this.LINESTRINGORCURVEMEMBER_SERIALIZERS_,
	      this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, lines,
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/LinearRing.js").default} ring LinearRing geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeRing_ = function writeRing_ (node, ring, objectStack) {
	    var linearRing = createElementNS(node.namespaceURI, 'LinearRing');
	    node.appendChild(linearRing);
	    this.writeLinearRing_(linearRing, ring, objectStack);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {Polygon} polygon Polygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeSurfaceOrPolygonMember_ = function writeSurfaceOrPolygonMember_ (node, polygon, objectStack) {
	    var child = this.GEOMETRY_NODE_FACTORY_(
	      polygon, objectStack);
	    if (child) {
	      node.appendChild(child);
	      this.writeSurfaceOrPolygon_(child, polygon, objectStack);
	    }
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/Point.js").default} point Point geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writePointMember_ = function writePointMember_ (node, point, objectStack) {
	    var child = createElementNS(node.namespaceURI, 'Point');
	    node.appendChild(child);
	    this.writePoint_(child, point, objectStack);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {LineString} line LineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeLineStringOrCurveMember_ = function writeLineStringOrCurveMember_ (node, line, objectStack) {
	    var child = this.GEOMETRY_NODE_FACTORY_(line, objectStack);
	    if (child) {
	      node.appendChild(child);
	      this.writeCurveOrLineString_(child, line, objectStack);
	    }
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {Polygon} polygon Polygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeSurfacePatches_ = function writeSurfacePatches_ (node, polygon, objectStack) {
	    var child = createElementNS(node.namespaceURI, 'PolygonPatch');
	    node.appendChild(child);
	    this.writeSurfaceOrPolygon_(child, polygon, objectStack);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {LineString} line LineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeCurveSegments_ = function writeCurveSegments_ (node, line, objectStack) {
	    var child = createElementNS(node.namespaceURI,
	      'LineStringSegment');
	    node.appendChild(child);
	    this.writeCurveOrLineString_(child, line, objectStack);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/Geometry.js").default|import("../extent.js").Extent} geometry Geometry.
	   * @param {Array<*>} objectStack Node stack.
	   */
	  GML3.prototype.writeGeometryElement = function writeGeometryElement (node, geometry, objectStack) {
	    var context = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[objectStack.length - 1]);
	    var item = assign({}, context);
	    item['node'] = node;
	    var value;
	    if (Array.isArray(geometry)) {
	      if (context.dataProjection) {
	        value = transformExtent(
	          geometry, context.featureProjection, context.dataProjection);
	      } else {
	        value = geometry;
	      }
	    } else {
	      value = transformWithOptions(/** @type {import("../geom/Geometry.js").default} */ (geometry), true, context);
	    }
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      (item), this.GEOMETRY_SERIALIZERS_,
	      this.GEOMETRY_NODE_FACTORY_, [value],
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {Array<*>} objectStack Node stack.
	   */
	  GML3.prototype.writeFeatureElement = function writeFeatureElement (node, feature, objectStack) {
	    var fid = feature.getId();
	    if (fid) {
	      node.setAttribute('fid', /** @type {string} */ (fid));
	    }
	    var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	    var featureNS = context['featureNS'];
	    var geometryName = feature.getGeometryName();
	    if (!context.serializers) {
	      context.serializers = {};
	      context.serializers[featureNS] = {};
	    }
	    var properties = feature.getProperties();
	    var keys = [];
	    var values = [];
	    for (var key in properties) {
	      var value = properties[key];
	      if (value !== null) {
	        keys.push(key);
	        values.push(value);
	        if (key == geometryName || typeof /** @type {?} */ (value).getSimplifiedGeometry === 'function') {
	          if (!(key in context.serializers[featureNS])) {
	            context.serializers[featureNS][key] = makeChildAppender(
	              this.writeGeometryElement, this);
	          }
	        } else {
	          if (!(key in context.serializers[featureNS])) {
	            context.serializers[featureNS][key] = makeChildAppender(writeStringTextNode);
	          }
	        }
	      }
	    }
	    var item = assign({}, context);
	    item.node = node;
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      (item), context.serializers,
	      makeSimpleNodeFactory(undefined, featureNS),
	      values,
	      objectStack, keys);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML3.prototype.writeFeatureMembers_ = function writeFeatureMembers_ (node, features, objectStack) {
	    var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	    var featureType = context['featureType'];
	    var featureNS = context['featureNS'];
	    /** @type {Object<string, Object<string, import("../xml.js").Serializer>>} */
	    var serializers = {};
	    serializers[featureNS] = {};
	    serializers[featureNS][featureType] = makeChildAppender(
	      this.writeFeatureElement, this);
	    var item = assign({}, context);
	    item.node = node;
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      (item),
	      serializers,
	      makeSimpleNodeFactory(featureType, featureNS), features,
	      objectStack);
	  };
	
	  /**
	   * @const
	   * @param {*} value Value.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {string=} opt_nodeName Node name.
	   * @return {Node|undefined} Node.
	   * @private
	   */
	  GML3.prototype.MULTIGEOMETRY_MEMBER_NODE_FACTORY_ = function MULTIGEOMETRY_MEMBER_NODE_FACTORY_ (value, objectStack, opt_nodeName) {
	    var parentNode = objectStack[objectStack.length - 1].node;
	    return createElementNS(this.namespace,
	      MULTIGEOMETRY_TO_MEMBER_NODENAME[parentNode.nodeName]);
	  };
	
	  /**
	   * @const
	   * @param {*} value Value.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {string=} opt_nodeName Node name.
	   * @return {Element|undefined} Node.
	   * @private
	   */
	  GML3.prototype.GEOMETRY_NODE_FACTORY_ = function GEOMETRY_NODE_FACTORY_ (value, objectStack, opt_nodeName) {
	    var context = objectStack[objectStack.length - 1];
	    var multiSurface = context['multiSurface'];
	    var surface = context['surface'];
	    var curve = context['curve'];
	    var multiCurve = context['multiCurve'];
	    var nodeName;
	    if (!Array.isArray(value)) {
	      nodeName = /** @type {import("../geom/Geometry.js").default} */ (value).getType();
	      if (nodeName === 'MultiPolygon' && multiSurface === true) {
	        nodeName = 'MultiSurface';
	      } else if (nodeName === 'Polygon' && surface === true) {
	        nodeName = 'Surface';
	      } else if (nodeName === 'LineString' && curve === true) {
	        nodeName = 'Curve';
	      } else if (nodeName === 'MultiLineString' && multiCurve === true) {
	        nodeName = 'MultiCurve';
	      }
	    } else {
	      nodeName = 'Envelope';
	    }
	    return createElementNS(this.namespace,
	      nodeName);
	  };
	
	  /**
	   * Encode a geometry in GML 3.1.1 Simple Features.
	   *
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @return {Node} Node.
	   * @override
	   * @api
	   */
	  GML3.prototype.writeGeometryNode = function writeGeometryNode (geometry, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    var geom = createElementNS(this.namespace, 'geom');
	    var context = {node: geom, hasZ: this.hasZ, srsName: this.srsName,
	      curve: this.curve_, surface: this.surface_,
	      multiSurface: this.multiSurface_, multiCurve: this.multiCurve_};
	    if (opt_options) {
	      assign(context, opt_options);
	    }
	    this.writeGeometryElement(geom, geometry, [context]);
	    return geom;
	  };
	
	  /**
	   * Encode an array of features in the GML 3.1.1 format as an XML node.
	   *
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @return {Element} Node.
	   * @override
	   * @api
	   */
	  GML3.prototype.writeFeaturesNode = function writeFeaturesNode (features, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    var node = createElementNS(this.namespace, 'featureMembers');
	    node.setAttributeNS(XML_SCHEMA_INSTANCE_URI, 'xsi:schemaLocation', this.schemaLocation);
	    var context = {
	      srsName: this.srsName,
	      hasZ: this.hasZ,
	      curve: this.curve_,
	      surface: this.surface_,
	      multiSurface: this.multiSurface_,
	      multiCurve: this.multiCurve_,
	      featureNS: this.featureNS,
	      featureType: this.featureType
	    };
	    if (opt_options) {
	      assign(context, opt_options);
	    }
	    this.writeFeatureMembers_(node, features, [context]);
	    return node;
	  };
	
	  return GML3;
	}(GMLBase));
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML3.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'pos': makeReplacer(GML3.prototype.readFlatPos_),
	    'posList': makeReplacer(GML3.prototype.readFlatPosList_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML3.prototype.FLAT_LINEAR_RINGS_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'interior': GML3.prototype.interiorParser_,
	    'exterior': GML3.prototype.exteriorParser_
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML3.prototype.GEOMETRY_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'Point': makeReplacer(GMLBase.prototype.readPoint),
	    'MultiPoint': makeReplacer(
	      GMLBase.prototype.readMultiPoint),
	    'LineString': makeReplacer(
	      GMLBase.prototype.readLineString),
	    'MultiLineString': makeReplacer(
	      GMLBase.prototype.readMultiLineString),
	    'LinearRing': makeReplacer(
	      GMLBase.prototype.readLinearRing),
	    'Polygon': makeReplacer(GMLBase.prototype.readPolygon),
	    'MultiPolygon': makeReplacer(
	      GMLBase.prototype.readMultiPolygon),
	    'Surface': makeReplacer(GML3.prototype.readSurface_),
	    'MultiSurface': makeReplacer(
	      GML3.prototype.readMultiSurface_),
	    'Curve': makeReplacer(GML3.prototype.readCurve_),
	    'MultiCurve': makeReplacer(
	      GML3.prototype.readMultiCurve_),
	    'Envelope': makeReplacer(GML3.prototype.readEnvelope_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.MULTICURVE_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'curveMember': makeArrayPusher(
	      GML3.prototype.curveMemberParser_),
	    'curveMembers': makeArrayPusher(
	      GML3.prototype.curveMemberParser_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.MULTISURFACE_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'surfaceMember': makeArrayPusher(
	      GML3.prototype.surfaceMemberParser_),
	    'surfaceMembers': makeArrayPusher(
	      GML3.prototype.surfaceMemberParser_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.CURVEMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'LineString': makeArrayPusher(
	      GMLBase.prototype.readLineString),
	    'Curve': makeArrayPusher(GML3.prototype.readCurve_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.SURFACEMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'Polygon': makeArrayPusher(GMLBase.prototype.readPolygon),
	    'Surface': makeArrayPusher(GML3.prototype.readSurface_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.SURFACE_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'patches': makeReplacer(GML3.prototype.readPatch_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.CURVE_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'segments': makeReplacer(GML3.prototype.readSegment_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.ENVELOPE_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'lowerCorner': makeArrayPusher(
	      GML3.prototype.readFlatPosList_),
	    'upperCorner': makeArrayPusher(
	      GML3.prototype.readFlatPosList_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.PATCHES_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'PolygonPatch': makeReplacer(
	      GML3.prototype.readPolygonPatch_)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML3.prototype.SEGMENTS_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'LineStringSegment': makeReplacer(
	      GML3.prototype.readLineStringSegment_)
	  }
	};
	
	
	/**
	 * Encode an array of features in GML 3.1.1 Simple Features.
	 *
	 * @function
	 * @param {Array<import("../Feature.js").default>} features Features.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	 * @return {string} Result.
	 * @api
	 */
	GML3.prototype.writeFeatures;
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML3.prototype.RING_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'exterior': makeChildAppender(GML3.prototype.writeRing_),
	    'interior': makeChildAppender(GML3.prototype.writeRing_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML3.prototype.ENVELOPE_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'lowerCorner': makeChildAppender(writeStringTextNode),
	    'upperCorner': makeChildAppender(writeStringTextNode)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML3.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'surfaceMember': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygonMember_),
	    'polygonMember': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygonMember_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML3.prototype.POINTMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'pointMember': makeChildAppender(
	      GML3.prototype.writePointMember_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML3.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'lineStringMember': makeChildAppender(
	      GML3.prototype.writeLineStringOrCurveMember_),
	    'curveMember': makeChildAppender(
	      GML3.prototype.writeLineStringOrCurveMember_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML3.prototype.GEOMETRY_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'Curve': makeChildAppender(
	      GML3.prototype.writeCurveOrLineString_),
	    'MultiCurve': makeChildAppender(
	      GML3.prototype.writeMultiCurveOrLineString_),
	    'Point': makeChildAppender(GML3.prototype.writePoint_),
	    'MultiPoint': makeChildAppender(
	      GML3.prototype.writeMultiPoint_),
	    'LineString': makeChildAppender(
	      GML3.prototype.writeCurveOrLineString_),
	    'MultiLineString': makeChildAppender(
	      GML3.prototype.writeMultiCurveOrLineString_),
	    'LinearRing': makeChildAppender(
	      GML3.prototype.writeLinearRing_),
	    'Polygon': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygon_),
	    'MultiPolygon': makeChildAppender(
	      GML3.prototype.writeMultiSurfaceOrPolygon_),
	    'Surface': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygon_),
	    'MultiSurface': makeChildAppender(
	      GML3.prototype.writeMultiSurfaceOrPolygon_),
	    'Envelope': makeChildAppender(
	      GML3.prototype.writeEnvelope)
	  }
	};
	
	/**
	 * @module ol/format/GML
	 */
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the GML format
	 * version 3.1.1.
	 * Currently only supports GML 3.1.1 Simple Features profile.
	 *
	 * @param {import("./GMLBase.js").Options=} opt_options
	 *     Optional configuration object.
	 * @api
	 */
	var GML = GML3;
	
	
	/**
	 * Encode an array of features in GML 3.1.1 Simple Features.
	 *
	 * @function
	 * @param {Array<import("../Feature.js").default>} features Features.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	 * @return {string} Result.
	 * @api
	 */
	GML.prototype.writeFeatures;
	
	
	/**
	 * Encode an array of features in the GML 3.1.1 format as an XML node.
	 *
	 * @function
	 * @param {Array<import("../Feature.js").default>} features Features.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	 * @return {Node} Node.
	 * @api
	 */
	GML.prototype.writeFeaturesNode;
	
	/**
	 * @module ol/format/GML2
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var schemaLocation$1 = GMLNS + ' http://schemas.opengis.net/gml/2.1.2/feature.xsd';
	
	
	/**
	 * @const
	 * @type {Object<string, string>}
	 */
	var MULTIGEOMETRY_TO_MEMBER_NODENAME$1 = {
	  'MultiLineString': 'lineStringMember',
	  'MultiCurve': 'curveMember',
	  'MultiPolygon': 'polygonMember',
	  'MultiSurface': 'surfaceMember'
	};
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the GML format,
	 * version 2.1.2.
	 *
	 * @api
	 */
	var GML2 = /*@__PURE__*/(function (GMLBase$$1) {
	  function GML2(opt_options) {
	    var options = /** @type {import("./GMLBase.js").Options} */
	        (opt_options ? opt_options : {});
	
	    GMLBase$$1.call(this, options);
	
	    this.FEATURE_COLLECTION_PARSERS[GMLNS][
	      'featureMember'] =
	        makeArrayPusher(this.readFeaturesInternal);
	
	    /**
	     * @inheritDoc
	     */
	    this.schemaLocation = options.schemaLocation ?
	      options.schemaLocation : schemaLocation$1;
	
	  }
	
	  if ( GMLBase$$1 ) { GML2.__proto__ = GMLBase$$1; }
	  GML2.prototype = Object.create( GMLBase$$1 && GMLBase$$1.prototype );
	  GML2.prototype.constructor = GML2;
	
	  /**
	   * @param {Node} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<number>|undefined} Flat coordinates.
	   */
	  GML2.prototype.readFlatCoordinates_ = function readFlatCoordinates_ (node, objectStack) {
	    var s = getAllTextContent(node, false).replace(/^\s*|\s*$/g, '');
	    var context = /** @type {import("../xml.js").NodeStackItem} */ (objectStack[0]);
	    var containerSrs = context['srsName'];
	    var axisOrientation = 'enu';
	    if (containerSrs) {
	      var proj = get$2(containerSrs);
	      if (proj) {
	        axisOrientation = proj.getAxisOrientation();
	      }
	    }
	    var coordsGroups = s.trim().split(/\s+/);
	    var flatCoordinates = [];
	    for (var i = 0, ii = coordsGroups.length; i < ii; i++) {
	      var coords = coordsGroups[i].split(/,+/);
	      var x = parseFloat(coords[0]);
	      var y = parseFloat(coords[1]);
	      var z = (coords.length === 3) ? parseFloat(coords[2]) : 0;
	      if (axisOrientation.substr(0, 2) === 'en') {
	        flatCoordinates.push(x, y, z);
	      } else {
	        flatCoordinates.push(y, x, z);
	      }
	    }
	    return flatCoordinates;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {import("../extent.js").Extent|undefined} Envelope.
	   */
	  GML2.prototype.readBox_ = function readBox_ (node, objectStack) {
	    /** @type {Array<number>} */
	    var flatCoordinates = pushParseAndPop([null],
	      this.BOX_PARSERS_, node, objectStack, this);
	    return createOrUpdate(flatCoordinates[1][0],
	      flatCoordinates[1][1], flatCoordinates[1][3],
	      flatCoordinates[1][4]);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GML2.prototype.innerBoundaryIsParser_ = function innerBoundaryIsParser_ (node, objectStack) {
	    /** @type {Array<number>|undefined} */
	    var flatLinearRing = pushParseAndPop(undefined,
	      this.RING_PARSERS, node, objectStack, this);
	    if (flatLinearRing) {
	      var flatLinearRings = /** @type {Array<Array<number>>} */
	          (objectStack[objectStack.length - 1]);
	      flatLinearRings.push(flatLinearRing);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  GML2.prototype.outerBoundaryIsParser_ = function outerBoundaryIsParser_ (node, objectStack) {
	    /** @type {Array<number>|undefined} */
	    var flatLinearRing = pushParseAndPop(undefined,
	      this.RING_PARSERS, node, objectStack, this);
	    if (flatLinearRing) {
	      var flatLinearRings = /** @type {Array<Array<number>>} */
	          (objectStack[objectStack.length - 1]);
	      flatLinearRings[0] = flatLinearRing;
	    }
	  };
	
	  /**
	   * @const
	   * @param {*} value Value.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {string=} opt_nodeName Node name.
	   * @return {Element|undefined} Node.
	   * @private
	   */
	  GML2.prototype.GEOMETRY_NODE_FACTORY_ = function GEOMETRY_NODE_FACTORY_ (value, objectStack, opt_nodeName) {
	    var context = objectStack[objectStack.length - 1];
	    var multiSurface = context['multiSurface'];
	    var surface = context['surface'];
	    var multiCurve = context['multiCurve'];
	    var nodeName;
	    if (!Array.isArray(value)) {
	      nodeName = /** @type {import("../geom/Geometry.js").default} */ (value).getType();
	      if (nodeName === 'MultiPolygon' && multiSurface === true) {
	        nodeName = 'MultiSurface';
	      } else if (nodeName === 'Polygon' && surface === true) {
	        nodeName = 'Surface';
	      } else if (nodeName === 'MultiLineString' && multiCurve === true) {
	        nodeName = 'MultiCurve';
	      }
	    } else {
	      nodeName = 'Envelope';
	    }
	    return createElementNS('http://www.opengis.net/gml',
	      nodeName);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {Array<*>} objectStack Node stack.
	   */
	  GML2.prototype.writeFeatureElement = function writeFeatureElement (node, feature, objectStack) {
	    var fid = feature.getId();
	    if (fid) {
	      node.setAttribute('fid', /** @type {string} */ (fid));
	    }
	    var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	    var featureNS = context['featureNS'];
	    var geometryName = feature.getGeometryName();
	    if (!context.serializers) {
	      context.serializers = {};
	      context.serializers[featureNS] = {};
	    }
	    var properties = feature.getProperties();
	    var keys = [];
	    var values = [];
	    for (var key in properties) {
	      var value = properties[key];
	      if (value !== null) {
	        keys.push(key);
	        values.push(value);
	        if (key == geometryName || typeof /** @type {?} */ (value).getSimplifiedGeometry === 'function') {
	          if (!(key in context.serializers[featureNS])) {
	            context.serializers[featureNS][key] = makeChildAppender(
	              this.writeGeometryElement, this);
	          }
	        } else {
	          if (!(key in context.serializers[featureNS])) {
	            context.serializers[featureNS][key] = makeChildAppender(writeStringTextNode);
	          }
	        }
	      }
	    }
	    var item = assign({}, context);
	    item.node = node;
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      (item), context.serializers,
	      makeSimpleNodeFactory(undefined, featureNS),
	      values,
	      objectStack, keys);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/LineString.js").default} geometry LineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeCurveOrLineString_ = function writeCurveOrLineString_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (node.nodeName !== 'LineStringSegment' && srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    if (node.nodeName === 'LineString' ||
	        node.nodeName === 'LineStringSegment') {
	      var coordinates = this.createCoordinatesNode_(node.namespaceURI);
	      node.appendChild(coordinates);
	      this.writeCoordinates_(coordinates, geometry, objectStack);
	    } else if (node.nodeName === 'Curve') {
	      var segments = createElementNS(node.namespaceURI, 'segments');
	      node.appendChild(segments);
	      this.writeCurveSegments_(segments,
	        geometry, objectStack);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/LineString.js").default} line LineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeLineStringOrCurveMember_ = function writeLineStringOrCurveMember_ (node, line, objectStack) {
	    var child = this.GEOMETRY_NODE_FACTORY_(line, objectStack);
	    if (child) {
	      node.appendChild(child);
	      this.writeCurveOrLineString_(child, line, objectStack);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/MultiLineString.js").default} geometry MultiLineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeMultiCurveOrLineString_ = function writeMultiCurveOrLineString_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    var curve = context['curve'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var lines = geometry.getLineStrings();
	    pushSerializeAndPop({node: node, hasZ: hasZ, srsName: srsName, curve: curve},
	      this.LINESTRINGORCURVEMEMBER_SERIALIZERS_,
	      this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, lines,
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/Geometry.js").default|import("../extent.js").Extent} geometry Geometry.
	   * @param {Array<*>} objectStack Node stack.
	   */
	  GML2.prototype.writeGeometryElement = function writeGeometryElement (node, geometry, objectStack) {
	    var context = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[objectStack.length - 1]);
	    var item = assign({}, context);
	    item['node'] = node;
	    var value;
	    if (Array.isArray(geometry)) {
	      if (context.dataProjection) {
	        value = transformExtent(
	          geometry, context.featureProjection, context.dataProjection);
	      } else {
	        value = geometry;
	      }
	    } else {
	      value = transformWithOptions(/** @type {import("../geom/Geometry.js").default} */ (geometry), true, context);
	    }
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      (item), this.GEOMETRY_SERIALIZERS_,
	      this.GEOMETRY_NODE_FACTORY_, [value],
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {string} namespaceURI XML namespace.
	   * @returns {Element} coordinates node.
	   * @private
	   */
	  GML2.prototype.createCoordinatesNode_ = function createCoordinatesNode_ (namespaceURI) {
	    var coordinates = createElementNS(namespaceURI, 'coordinates');
	    coordinates.setAttribute('decimal', '.');
	    coordinates.setAttribute('cs', ',');
	    coordinates.setAttribute('ts', ' ');
	
	    return coordinates;
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/LineString.js").default|import("../geom/LinearRing.js").default} value Geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeCoordinates_ = function writeCoordinates_ (node, value, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    // only 2d for simple features profile
	    var points = value.getCoordinates();
	    var len = points.length;
	    var parts = new Array(len);
	    for (var i = 0; i < len; ++i) {
	      var point = points[i];
	      parts[i] = this.getCoords_(point, srsName, hasZ);
	    }
	    writeStringTextNode(node, parts.join(' '));
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/LineString.js").default} line LineString geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeCurveSegments_ = function writeCurveSegments_ (node, line, objectStack) {
	    var child = createElementNS(node.namespaceURI, 'LineStringSegment');
	    node.appendChild(child);
	    this.writeCurveOrLineString_(child, line, objectStack);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeSurfaceOrPolygon_ = function writeSurfaceOrPolygon_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    if (node.nodeName !== 'PolygonPatch' && srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    if (node.nodeName === 'Polygon' || node.nodeName === 'PolygonPatch') {
	      var rings = geometry.getLinearRings();
	      pushSerializeAndPop(
	        {node: node, hasZ: hasZ, srsName: srsName},
	        this.RING_SERIALIZERS_,
	        this.RING_NODE_FACTORY_,
	        rings, objectStack, undefined, this);
	    } else if (node.nodeName === 'Surface') {
	      var patches = createElementNS(node.namespaceURI, 'patches');
	      node.appendChild(patches);
	      this.writeSurfacePatches_(
	        patches, geometry, objectStack);
	    }
	  };
	
	  /**
	   * @param {*} value Value.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {string=} opt_nodeName Node name.
	   * @return {Node} Node.
	   * @private
	   */
	  GML2.prototype.RING_NODE_FACTORY_ = function RING_NODE_FACTORY_ (value, objectStack, opt_nodeName) {
	    var context = objectStack[objectStack.length - 1];
	    var parentNode = context.node;
	    var exteriorWritten = context['exteriorWritten'];
	    if (exteriorWritten === undefined) {
	      context['exteriorWritten'] = true;
	    }
	    return createElementNS(parentNode.namespaceURI,
	      exteriorWritten !== undefined ? 'innerBoundaryIs' : 'outerBoundaryIs');
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/Polygon.js").default} polygon Polygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeSurfacePatches_ = function writeSurfacePatches_ (node, polygon, objectStack) {
	    var child = createElementNS(node.namespaceURI, 'PolygonPatch');
	    node.appendChild(child);
	    this.writeSurfaceOrPolygon_(child, polygon, objectStack);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/LinearRing.js").default} ring LinearRing geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeRing_ = function writeRing_ (node, ring, objectStack) {
	    var linearRing = createElementNS(node.namespaceURI, 'LinearRing');
	    node.appendChild(linearRing);
	    this.writeLinearRing_(linearRing, ring, objectStack);
	  };
	
	  /**
	   * @param {Array<number>} point Point geometry.
	   * @param {string=} opt_srsName Optional srsName
	   * @param {boolean=} opt_hasZ whether the geometry has a Z coordinate (is 3D) or not.
	   * @return {string} The coords string.
	   * @private
	   */
	  GML2.prototype.getCoords_ = function getCoords_ (point, opt_srsName, opt_hasZ) {
	    var axisOrientation = 'enu';
	    if (opt_srsName) {
	      axisOrientation = get$2(opt_srsName).getAxisOrientation();
	    }
	    var coords = ((axisOrientation.substr(0, 2) === 'en') ?
	      point[0] + ',' + point[1] :
	      point[1] + ',' + point[0]);
	    if (opt_hasZ) {
	      // For newly created points, Z can be undefined.
	      var z = point[2] || 0;
	      coords += ',' + z;
	    }
	
	    return coords;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/Point.js").default} geometry Point geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writePoint_ = function writePoint_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var coordinates = this.createCoordinatesNode_(node.namespaceURI);
	    node.appendChild(coordinates);
	    var point = geometry.getCoordinates();
	    var coord = this.getCoords_(point, srsName, hasZ);
	    writeStringTextNode(coordinates, coord);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/MultiPoint.js").default} geometry MultiPoint geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeMultiPoint_ = function writeMultiPoint_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var points = geometry.getPoints();
	    pushSerializeAndPop({node: node, hasZ: hasZ, srsName: srsName},
	      this.POINTMEMBER_SERIALIZERS_,
	      makeSimpleNodeFactory('pointMember'), points,
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/Point.js").default} point Point geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writePointMember_ = function writePointMember_ (node, point, objectStack) {
	    var child = createElementNS(node.namespaceURI, 'Point');
	    node.appendChild(child);
	    this.writePoint_(child, point, objectStack);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/LinearRing.js").default} geometry LinearRing geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeLinearRing_ = function writeLinearRing_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var coordinates = this.createCoordinatesNode_(node.namespaceURI);
	    node.appendChild(coordinates);
	    this.writeCoordinates_(coordinates, geometry, objectStack);
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeMultiSurfaceOrPolygon_ = function writeMultiSurfaceOrPolygon_ (node, geometry, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var hasZ = context['hasZ'];
	    var srsName = context['srsName'];
	    var surface = context['surface'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var polygons = geometry.getPolygons();
	    pushSerializeAndPop({node: node, hasZ: hasZ, srsName: srsName, surface: surface},
	      this.SURFACEORPOLYGONMEMBER_SERIALIZERS_,
	      this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, polygons,
	      objectStack, undefined, this);
	  };
	
	  /**
	   * @param {Node} node Node.
	   * @param {import("../geom/Polygon.js").default} polygon Polygon geometry.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeSurfaceOrPolygonMember_ = function writeSurfaceOrPolygonMember_ (node, polygon, objectStack) {
	    var child = this.GEOMETRY_NODE_FACTORY_(
	      polygon, objectStack);
	    if (child) {
	      node.appendChild(child);
	      this.writeSurfaceOrPolygon_(child, polygon, objectStack);
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {import("../extent.js").Extent} extent Extent.
	   * @param {Array<*>} objectStack Node stack.
	   * @private
	   */
	  GML2.prototype.writeEnvelope = function writeEnvelope (node, extent, objectStack) {
	    var context = objectStack[objectStack.length - 1];
	    var srsName = context['srsName'];
	    if (srsName) {
	      node.setAttribute('srsName', srsName);
	    }
	    var keys = ['lowerCorner', 'upperCorner'];
	    var values = [extent[0] + ' ' + extent[1], extent[2] + ' ' + extent[3]];
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      ({node: node}), this.ENVELOPE_SERIALIZERS_,
	      OBJECT_PROPERTY_NODE_FACTORY,
	      values,
	      objectStack, keys, this);
	  };
	
	  /**
	   * @const
	   * @param {*} value Value.
	   * @param {Array<*>} objectStack Object stack.
	   * @param {string=} opt_nodeName Node name.
	   * @return {Node|undefined} Node.
	   * @private
	   */
	  GML2.prototype.MULTIGEOMETRY_MEMBER_NODE_FACTORY_ = function MULTIGEOMETRY_MEMBER_NODE_FACTORY_ (value, objectStack, opt_nodeName) {
	    var parentNode = objectStack[objectStack.length - 1].node;
	    return createElementNS('http://www.opengis.net/gml',
	      MULTIGEOMETRY_TO_MEMBER_NODENAME$1[parentNode.nodeName]);
	  };
	
	  return GML2;
	}(GMLBase));
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML2.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'coordinates': makeReplacer(GML2.prototype.readFlatCoordinates_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML2.prototype.FLAT_LINEAR_RINGS_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'innerBoundaryIs': GML2.prototype.innerBoundaryIsParser_,
	    'outerBoundaryIs': GML2.prototype.outerBoundaryIsParser_
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML2.prototype.BOX_PARSERS_ = {
	  'http://www.opengis.net/gml': {
	    'coordinates': makeArrayPusher(
	      GML2.prototype.readFlatCoordinates_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML2.prototype.GEOMETRY_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'Point': makeReplacer(GMLBase.prototype.readPoint),
	    'MultiPoint': makeReplacer(
	      GMLBase.prototype.readMultiPoint),
	    'LineString': makeReplacer(
	      GMLBase.prototype.readLineString),
	    'MultiLineString': makeReplacer(
	      GMLBase.prototype.readMultiLineString),
	    'LinearRing': makeReplacer(
	      GMLBase.prototype.readLinearRing),
	    'Polygon': makeReplacer(GMLBase.prototype.readPolygon),
	    'MultiPolygon': makeReplacer(
	      GMLBase.prototype.readMultiPolygon),
	    'Box': makeReplacer(GML2.prototype.readBox_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML2.prototype.GEOMETRY_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'Curve': makeChildAppender(
	      GML2.prototype.writeCurveOrLineString_),
	    'MultiCurve': makeChildAppender(
	      GML2.prototype.writeMultiCurveOrLineString_),
	    'Point': makeChildAppender(GML2.prototype.writePoint_),
	    'MultiPoint': makeChildAppender(
	      GML2.prototype.writeMultiPoint_),
	    'LineString': makeChildAppender(
	      GML2.prototype.writeCurveOrLineString_),
	    'MultiLineString': makeChildAppender(
	      GML2.prototype.writeMultiCurveOrLineString_),
	    'LinearRing': makeChildAppender(
	      GML2.prototype.writeLinearRing_),
	    'Polygon': makeChildAppender(
	      GML2.prototype.writeSurfaceOrPolygon_),
	    'MultiPolygon': makeChildAppender(
	      GML2.prototype.writeMultiSurfaceOrPolygon_),
	    'Surface': makeChildAppender(
	      GML2.prototype.writeSurfaceOrPolygon_),
	    'MultiSurface': makeChildAppender(
	      GML2.prototype.writeMultiSurfaceOrPolygon_),
	    'Envelope': makeChildAppender(
	      GML2.prototype.writeEnvelope)
	  }
	};
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML2.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'lineStringMember': makeChildAppender(
	      GML2.prototype.writeLineStringOrCurveMember_),
	    'curveMember': makeChildAppender(
	      GML2.prototype.writeLineStringOrCurveMember_)
	  }
	};
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML2.prototype.RING_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'outerBoundaryIs': makeChildAppender(GML2.prototype.writeRing_),
	    'innerBoundaryIs': makeChildAppender(GML2.prototype.writeRing_)
	  }
	};
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML2.prototype.POINTMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'pointMember': makeChildAppender(
	      GML2.prototype.writePointMember_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML2.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'surfaceMember': makeChildAppender(
	      GML2.prototype.writeSurfaceOrPolygonMember_),
	    'polygonMember': makeChildAppender(
	      GML2.prototype.writeSurfaceOrPolygonMember_)
	  }
	};
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML2.prototype.ENVELOPE_SERIALIZERS_ = {
	  'http://www.opengis.net/gml': {
	    'lowerCorner': makeChildAppender(writeStringTextNode),
	    'upperCorner': makeChildAppender(writeStringTextNode)
	  }
	};
	
	/**
	 * @module ol/format/GML32
	 */
	
	/**
	 * @classdesc Feature format for reading and writing data in the GML format
	 *            version 3.2.1.
	 * @api
	 */
	var GML32 = /*@__PURE__*/(function (GML3$$1) {
	  function GML32(opt_options) {
	    var options = /** @type {import("./GMLBase.js").Options} */ (opt_options ? opt_options : {});
	
	    GML3$$1.call(this, options);
	
	    /**
	     * @inheritDoc
	     */
	    this.schemaLocation = options.schemaLocation ?
	      options.schemaLocation : this.namespace + ' http://schemas.opengis.net/gml/3.2.1/gml.xsd';
	
	  }
	
	  if ( GML3$$1 ) { GML32.__proto__ = GML3$$1; }
	  GML32.prototype = Object.create( GML3$$1 && GML3$$1.prototype );
	  GML32.prototype.constructor = GML32;
	
	  return GML32;
	}(GML3));
	
	GML32.prototype.namespace = 'http://www.opengis.net/gml/3.2';
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML32.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
	  'http://www.opengis.net/gml/3.2': {
	    'pos': makeReplacer(GML3.prototype.readFlatPos_),
	    'posList': makeReplacer(GML3.prototype.readFlatPosList_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML32.prototype.FLAT_LINEAR_RINGS_PARSERS = {
	  'http://www.opengis.net/gml/3.2': {
	    'interior': GML3.prototype.interiorParser_,
	    'exterior': GML3.prototype.exteriorParser_
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML32.prototype.GEOMETRY_PARSERS = {
	  'http://www.opengis.net/gml/3.2': {
	    'Point': makeReplacer(GMLBase.prototype.readPoint),
	    'MultiPoint': makeReplacer(
	      GMLBase.prototype.readMultiPoint),
	    'LineString': makeReplacer(
	      GMLBase.prototype.readLineString),
	    'MultiLineString': makeReplacer(
	      GMLBase.prototype.readMultiLineString),
	    'LinearRing': makeReplacer(
	      GMLBase.prototype.readLinearRing),
	    'Polygon': makeReplacer(GMLBase.prototype.readPolygon),
	    'MultiPolygon': makeReplacer(
	      GMLBase.prototype.readMultiPolygon),
	    'Surface': makeReplacer(GML32.prototype.readSurface_),
	    'MultiSurface': makeReplacer(
	      GML3.prototype.readMultiSurface_),
	    'Curve': makeReplacer(GML32.prototype.readCurve_),
	    'MultiCurve': makeReplacer(
	      GML3.prototype.readMultiCurve_),
	    'Envelope': makeReplacer(GML32.prototype.readEnvelope_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.MULTICURVE_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'curveMember': makeArrayPusher(
	      GML3.prototype.curveMemberParser_),
	    'curveMembers': makeArrayPusher(
	      GML3.prototype.curveMemberParser_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.MULTISURFACE_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'surfaceMember': makeArrayPusher(
	      GML3.prototype.surfaceMemberParser_),
	    'surfaceMembers': makeArrayPusher(
	      GML3.prototype.surfaceMemberParser_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.CURVEMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'LineString': makeArrayPusher(
	      GMLBase.prototype.readLineString),
	    'Curve': makeArrayPusher(GML3.prototype.readCurve_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.SURFACEMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'Polygon': makeArrayPusher(GMLBase.prototype.readPolygon),
	    'Surface': makeArrayPusher(GML3.prototype.readSurface_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.SURFACE_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'patches': makeReplacer(GML3.prototype.readPatch_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.CURVE_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'segments': makeReplacer(GML3.prototype.readSegment_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.ENVELOPE_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'lowerCorner': makeArrayPusher(
	      GML3.prototype.readFlatPosList_),
	    'upperCorner': makeArrayPusher(
	      GML3.prototype.readFlatPosList_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.PATCHES_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'PolygonPatch': makeReplacer(
	      GML3.prototype.readPolygonPatch_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.SEGMENTS_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'LineStringSegment': makeReplacer(
	      GML3.prototype.readLineStringSegment_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.MULTIPOINT_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'pointMember': makeArrayPusher(
	      GMLBase.prototype.pointMemberParser_),
	    'pointMembers': makeArrayPusher(
	      GMLBase.prototype.pointMemberParser_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.MULTILINESTRING_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'lineStringMember': makeArrayPusher(
	      GMLBase.prototype.lineStringMemberParser_),
	    'lineStringMembers': makeArrayPusher(
	      GMLBase.prototype.lineStringMemberParser_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.MULTIPOLYGON_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'polygonMember': makeArrayPusher(
	      GMLBase.prototype.polygonMemberParser_),
	    'polygonMembers': makeArrayPusher(
	      GMLBase.prototype.polygonMemberParser_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.POINTMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'Point': makeArrayPusher(
	      GMLBase.prototype.readFlatCoordinatesFromNode_)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.LINESTRINGMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'LineString': makeArrayPusher(
	      GMLBase.prototype.readLineString)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @private
	 */
	GML32.prototype.POLYGONMEMBER_PARSERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'Polygon': makeArrayPusher(
	      GMLBase.prototype.readPolygon)
	  }
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 * @protected
	 */
	GML32.prototype.RING_PARSERS = {
	  'http://www.opengis.net/gml/3.2': {
	    'LinearRing': makeReplacer(
	      GMLBase.prototype.readFlatLinearRing_)
	  }
	};
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML32.prototype.RING_SERIALIZERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'exterior': makeChildAppender(GML3.prototype.writeRing_),
	    'interior': makeChildAppender(GML3.prototype.writeRing_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML32.prototype.ENVELOPE_SERIALIZERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'lowerCorner': makeChildAppender(writeStringTextNode),
	    'upperCorner': makeChildAppender(writeStringTextNode)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML32.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'surfaceMember': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygonMember_),
	    'polygonMember': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygonMember_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML32.prototype.POINTMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'pointMember': makeChildAppender(
	      GML3.prototype.writePointMember_)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML32.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'lineStringMember': makeChildAppender(
	      GML3.prototype.writeLineStringOrCurveMember_),
	    'curveMember': makeChildAppender(
	      GML3.prototype.writeLineStringOrCurveMember_)
	  }
	};
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 * @private
	 */
	GML32.prototype.GEOMETRY_SERIALIZERS_ = {
	  'http://www.opengis.net/gml/3.2': {
	    'Curve': makeChildAppender(
	      GML3.prototype.writeCurveOrLineString_),
	    'MultiCurve': makeChildAppender(
	      GML3.prototype.writeMultiCurveOrLineString_),
	    'Point': makeChildAppender(GML32.prototype.writePoint_),
	    'MultiPoint': makeChildAppender(
	      GML3.prototype.writeMultiPoint_),
	    'LineString': makeChildAppender(
	      GML3.prototype.writeCurveOrLineString_),
	    'MultiLineString': makeChildAppender(
	      GML3.prototype.writeMultiCurveOrLineString_),
	    'LinearRing': makeChildAppender(
	      GML3.prototype.writeLinearRing_),
	    'Polygon': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygon_),
	    'MultiPolygon': makeChildAppender(
	      GML3.prototype.writeMultiSurfaceOrPolygon_),
	    'Surface': makeChildAppender(
	      GML3.prototype.writeSurfaceOrPolygon_),
	    'MultiSurface': makeChildAppender(
	      GML3.prototype.writeMultiSurfaceOrPolygon_),
	    'Envelope': makeChildAppender(
	      GML3.prototype.writeEnvelope)
	  }
	};
	
	/**
	 * @module ol/format/GPX
	 */
	
	
	/**
	 * @const
	 * @type {Array<null|string>}
	 */
	var NAMESPACE_URIS = [
	  null,
	  'http://www.topografix.com/GPX/1/0',
	  'http://www.topografix.com/GPX/1/1'
	];
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var SCHEMA_LOCATION = 'http://www.topografix.com/GPX/1/1 ' +
	    'http://www.topografix.com/GPX/1/1/gpx.xsd';
	
	
	/**
	 * @const
	 * @type {Object<string, function(Node, Array<*>): (Feature|undefined)>}
	 */
	var FEATURE_READER = {
	  'rte': readRte,
	  'trk': readTrk,
	  'wpt': readWpt
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var GPX_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'rte': makeArrayPusher(readRte),
	    'trk': makeArrayPusher(readTrk),
	    'wpt': makeArrayPusher(readWpt)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LINK_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'text': makeObjectPropertySetter(readString, 'linkText'),
	    'type': makeObjectPropertySetter(readString, 'linkType')
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var GPX_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'rte': makeChildAppender(writeRte),
	    'trk': makeChildAppender(writeTrk),
	    'wpt': makeChildAppender(writeWpt)
	  });
	
	
	/**
	 * @typedef {Object} Options
	 * @property {function(Feature, Node)} [readExtensions] Callback function
	 * to process `extensions` nodes. To prevent memory leaks, this callback function must
	 * not store any references to the node. Note that the `extensions`
	 * node is not allowed in GPX 1.0. Moreover, only `extensions`
	 * nodes from `wpt`, `rte` and `trk` can be processed, as those are
	 * directly mapped to a feature.
	 */
	
	/**
	 * @typedef {Object} LayoutOptions
	 * @property {boolean} [hasZ]
	 * @property {boolean} [hasM]
	 */
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the GPX format.
	 *
	 * Note that {@link module:ol/format/GPX~GPX#readFeature} only reads the first
	 * feature of the source.
	 *
	 * When reading, routes (`<rte>`) are converted into LineString geometries, and
	 * tracks (`<trk>`) into MultiLineString. Any properties on route and track
	 * waypoints are ignored.
	 *
	 * When writing, LineString geometries are output as routes (`<rte>`), and
	 * MultiLineString as tracks (`<trk>`).
	 *
	 * @api
	 */
	var GPX = /*@__PURE__*/(function (XMLFeature$$1) {
	  function GPX(opt_options) {
	    XMLFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2('EPSG:4326');
	
	    /**
	     * @type {function(Feature, Node)|undefined}
	     * @private
	     */
	    this.readExtensions_ = options.readExtensions;
	  }
	
	  if ( XMLFeature$$1 ) { GPX.__proto__ = XMLFeature$$1; }
	  GPX.prototype = Object.create( XMLFeature$$1 && XMLFeature$$1.prototype );
	  GPX.prototype.constructor = GPX;
	
	  /**
	   * @param {Array<Feature>} features List of features.
	   * @private
	   */
	  GPX.prototype.handleReadExtensions_ = function handleReadExtensions_ (features) {
	    if (!features) {
	      features = [];
	    }
	    for (var i = 0, ii = features.length; i < ii; ++i) {
	      var feature = features[i];
	      if (this.readExtensions_) {
	        var extensionsNode = feature.get('extensionsNode_') || null;
	        this.readExtensions_(feature, extensionsNode);
	      }
	      feature.set('extensionsNode_', undefined);
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GPX.prototype.readFeatureFromNode = function readFeatureFromNode (node, opt_options) {
	    if (!includes(NAMESPACE_URIS, node.namespaceURI)) {
	      return null;
	    }
	    var featureReader = FEATURE_READER[node.localName];
	    if (!featureReader) {
	      return null;
	    }
	    var feature = featureReader(node, [this.getReadOptions(node, opt_options)]);
	    if (!feature) {
	      return null;
	    }
	    this.handleReadExtensions_([feature]);
	    return feature;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GPX.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    if (!includes(NAMESPACE_URIS, node.namespaceURI)) {
	      return [];
	    }
	    if (node.localName == 'gpx') {
	      /** @type {Array<Feature>} */
	      var features = pushParseAndPop([], GPX_PARSERS,
	        node, [this.getReadOptions(node, opt_options)]);
	      if (features) {
	        this.handleReadExtensions_(features);
	        return features;
	      } else {
	        return [];
	      }
	    }
	    return [];
	  };
	
	  /**
	   * Encode an array of features in the GPX format as an XML node.
	   * LineString geometries are output as routes (`<rte>`), and MultiLineString
	   * as tracks (`<trk>`).
	   *
	   * @param {Array<Feature>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @return {Node} Node.
	   * @override
	   * @api
	   */
	  GPX.prototype.writeFeaturesNode = function writeFeaturesNode (features, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    //FIXME Serialize metadata
	    var gpx = createElementNS('http://www.topografix.com/GPX/1/1', 'gpx');
	    var xmlnsUri = 'http://www.w3.org/2000/xmlns/';
	    gpx.setAttributeNS(xmlnsUri, 'xmlns:xsi', XML_SCHEMA_INSTANCE_URI);
	    gpx.setAttributeNS(XML_SCHEMA_INSTANCE_URI, 'xsi:schemaLocation', SCHEMA_LOCATION);
	    gpx.setAttribute('version', '1.1');
	    gpx.setAttribute('creator', 'OpenLayers');
	
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	      ({node: gpx}), GPX_SERIALIZERS, GPX_NODE_FACTORY, features, [opt_options]);
	    return gpx;
	  };
	
	  return GPX;
	}(XMLFeature));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var RTE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'name': makeObjectPropertySetter(readString),
	    'cmt': makeObjectPropertySetter(readString),
	    'desc': makeObjectPropertySetter(readString),
	    'src': makeObjectPropertySetter(readString),
	    'link': parseLink,
	    'number': makeObjectPropertySetter(readNonNegativeInteger),
	    'extensions': parseExtensions,
	    'type': makeObjectPropertySetter(readString),
	    'rtept': parseRtePt
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var RTEPT_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'ele': makeObjectPropertySetter(readDecimal),
	    'time': makeObjectPropertySetter(readDateTime)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TRK_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'name': makeObjectPropertySetter(readString),
	    'cmt': makeObjectPropertySetter(readString),
	    'desc': makeObjectPropertySetter(readString),
	    'src': makeObjectPropertySetter(readString),
	    'link': parseLink,
	    'number': makeObjectPropertySetter(readNonNegativeInteger),
	    'type': makeObjectPropertySetter(readString),
	    'extensions': parseExtensions,
	    'trkseg': parseTrkSeg
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TRKSEG_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'trkpt': parseTrkPt
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TRKPT_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'ele': makeObjectPropertySetter(readDecimal),
	    'time': makeObjectPropertySetter(readDateTime)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var WPT_PARSERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'ele': makeObjectPropertySetter(readDecimal),
	    'time': makeObjectPropertySetter(readDateTime),
	    'magvar': makeObjectPropertySetter(readDecimal),
	    'geoidheight': makeObjectPropertySetter(readDecimal),
	    'name': makeObjectPropertySetter(readString),
	    'cmt': makeObjectPropertySetter(readString),
	    'desc': makeObjectPropertySetter(readString),
	    'src': makeObjectPropertySetter(readString),
	    'link': parseLink,
	    'sym': makeObjectPropertySetter(readString),
	    'type': makeObjectPropertySetter(readString),
	    'fix': makeObjectPropertySetter(readString),
	    'sat': makeObjectPropertySetter(readNonNegativeInteger),
	    'hdop': makeObjectPropertySetter(readDecimal),
	    'vdop': makeObjectPropertySetter(readDecimal),
	    'pdop': makeObjectPropertySetter(readDecimal),
	    'ageofdgpsdata': makeObjectPropertySetter(readDecimal),
	    'dgpsid': makeObjectPropertySetter(readNonNegativeInteger),
	    'extensions': parseExtensions
	  });
	
	
	/**
	 * @const
	 * @type {Array<string>}
	 */
	var LINK_SEQUENCE = ['text', 'type'];
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var LINK_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'text': makeChildAppender(writeStringTextNode),
	    'type': makeChildAppender(writeStringTextNode)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var RTE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS, [
	    'name', 'cmt', 'desc', 'src', 'link', 'number', 'type', 'rtept'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var RTE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'name': makeChildAppender(writeStringTextNode),
	    'cmt': makeChildAppender(writeStringTextNode),
	    'desc': makeChildAppender(writeStringTextNode),
	    'src': makeChildAppender(writeStringTextNode),
	    'link': makeChildAppender(writeLink),
	    'number': makeChildAppender(writeNonNegativeIntegerTextNode),
	    'type': makeChildAppender(writeStringTextNode),
	    'rtept': makeArraySerializer(makeChildAppender(writeWptType))
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var RTEPT_TYPE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS, [
	    'ele', 'time'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var TRK_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS, [
	    'name', 'cmt', 'desc', 'src', 'link', 'number', 'type', 'trkseg'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var TRK_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'name': makeChildAppender(writeStringTextNode),
	    'cmt': makeChildAppender(writeStringTextNode),
	    'desc': makeChildAppender(writeStringTextNode),
	    'src': makeChildAppender(writeStringTextNode),
	    'link': makeChildAppender(writeLink),
	    'number': makeChildAppender(writeNonNegativeIntegerTextNode),
	    'type': makeChildAppender(writeStringTextNode),
	    'trkseg': makeArraySerializer(makeChildAppender(writeTrkSeg))
	  });
	
	
	/**
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var TRKSEG_NODE_FACTORY = makeSimpleNodeFactory('trkpt');
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var TRKSEG_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'trkpt': makeChildAppender(writeWptType)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var WPT_TYPE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS, [
	    'ele', 'time', 'magvar', 'geoidheight', 'name', 'cmt', 'desc', 'src',
	    'link', 'sym', 'type', 'fix', 'sat', 'hdop', 'vdop', 'pdop',
	    'ageofdgpsdata', 'dgpsid'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var WPT_TYPE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS, {
	    'ele': makeChildAppender(writeDecimalTextNode),
	    'time': makeChildAppender(writeDateTimeTextNode),
	    'magvar': makeChildAppender(writeDecimalTextNode),
	    'geoidheight': makeChildAppender(writeDecimalTextNode),
	    'name': makeChildAppender(writeStringTextNode),
	    'cmt': makeChildAppender(writeStringTextNode),
	    'desc': makeChildAppender(writeStringTextNode),
	    'src': makeChildAppender(writeStringTextNode),
	    'link': makeChildAppender(writeLink),
	    'sym': makeChildAppender(writeStringTextNode),
	    'type': makeChildAppender(writeStringTextNode),
	    'fix': makeChildAppender(writeStringTextNode),
	    'sat': makeChildAppender(writeNonNegativeIntegerTextNode),
	    'hdop': makeChildAppender(writeDecimalTextNode),
	    'vdop': makeChildAppender(writeDecimalTextNode),
	    'pdop': makeChildAppender(writeDecimalTextNode),
	    'ageofdgpsdata': makeChildAppender(writeDecimalTextNode),
	    'dgpsid': makeChildAppender(writeNonNegativeIntegerTextNode)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, string>}
	 */
	var GEOMETRY_TYPE_TO_NODENAME = {
	  'Point': 'wpt',
	  'LineString': 'rte',
	  'MultiLineString': 'trk'
	};
	
	
	/**
	 * @param {*} value Value.
	 * @param {Array<*>} objectStack Object stack.
	 * @param {string=} opt_nodeName Node name.
	 * @return {Node|undefined} Node.
	 */
	function GPX_NODE_FACTORY(value, objectStack, opt_nodeName) {
	  var geometry = /** @type {Feature} */ (value).getGeometry();
	  if (geometry) {
	    var nodeName = GEOMETRY_TYPE_TO_NODENAME[geometry.getType()];
	    if (nodeName) {
	      var parentNode = objectStack[objectStack.length - 1].node;
	      return createElementNS(parentNode.namespaceURI, nodeName);
	    }
	  }
	}
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {LayoutOptions} layoutOptions Layout options.
	 * @param {Element} node Node.
	 * @param {!Object} values Values.
	 * @return {Array<number>} Flat coordinates.
	 */
	function appendCoordinate(flatCoordinates, layoutOptions, node, values) {
	  flatCoordinates.push(
	    parseFloat(node.getAttribute('lon')),
	    parseFloat(node.getAttribute('lat')));
	  if ('ele' in values) {
	    flatCoordinates.push(/** @type {number} */ (values['ele']));
	    delete values['ele'];
	    layoutOptions.hasZ = true;
	  } else {
	    flatCoordinates.push(0);
	  }
	  if ('time' in values) {
	    flatCoordinates.push(/** @type {number} */ (values['time']));
	    delete values['time'];
	    layoutOptions.hasM = true;
	  } else {
	    flatCoordinates.push(0);
	  }
	  return flatCoordinates;
	}
	
	
	/**
	 * Choose GeometryLayout based on flags in layoutOptions and adjust flatCoordinates
	 * and ends arrays by shrinking them accordingly (removing unused zero entries).
	 *
	 * @param {LayoutOptions} layoutOptions Layout options.
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {Array<number>=} ends Ends.
	 * @return {GeometryLayout} Layout.
	 */
	function applyLayoutOptions(layoutOptions, flatCoordinates, ends) {
	  var layout = GeometryLayout.XY;
	  var stride = 2;
	  if (layoutOptions.hasZ && layoutOptions.hasM) {
	    layout = GeometryLayout.XYZM;
	    stride = 4;
	  } else if (layoutOptions.hasZ) {
	    layout = GeometryLayout.XYZ;
	    stride = 3;
	  } else if (layoutOptions.hasM) {
	    layout = GeometryLayout.XYM;
	    stride = 3;
	  }
	  if (stride !== 4) {
	    for (var i = 0, ii = flatCoordinates.length / 4; i < ii; i++) {
	      flatCoordinates[i * stride] = flatCoordinates[i * 4];
	      flatCoordinates[i * stride + 1] = flatCoordinates[i * 4 + 1];
	      if (layoutOptions.hasZ) {
	        flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 2];
	      }
	      if (layoutOptions.hasM) {
	        flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 3];
	      }
	    }
	    flatCoordinates.length = flatCoordinates.length / 4 * stride;
	    if (ends) {
	      for (var i$1 = 0, ii$1 = ends.length; i$1 < ii$1; i$1++) {
	        ends[i$1] = ends[i$1] / 4 * stride;
	      }
	    }
	  }
	  return layout;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function parseLink(node, objectStack) {
	  var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  var href = node.getAttribute('href');
	  if (href !== null) {
	    values['link'] = href;
	  }
	  parseNode(LINK_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function parseExtensions(node, objectStack) {
	  var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  values['extensionsNode_'] = node;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function parseRtePt(node, objectStack) {
	  var values = pushParseAndPop({}, RTEPT_PARSERS, node, objectStack);
	  if (values) {
	    var rteValues = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
	    var flatCoordinates = /** @type {Array<number>} */ (rteValues['flatCoordinates']);
	    var layoutOptions = /** @type {LayoutOptions} */ (rteValues['layoutOptions']);
	    appendCoordinate(flatCoordinates, layoutOptions, node, values);
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function parseTrkPt(node, objectStack) {
	  var values = pushParseAndPop({}, TRKPT_PARSERS, node, objectStack);
	  if (values) {
	    var trkValues = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
	    var flatCoordinates = /** @type {Array<number>} */ (trkValues['flatCoordinates']);
	    var layoutOptions = /** @type {LayoutOptions} */ (trkValues['layoutOptions']);
	    appendCoordinate(flatCoordinates, layoutOptions, node, values);
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function parseTrkSeg(node, objectStack) {
	  var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  parseNode(TRKSEG_PARSERS, node, objectStack);
	  var flatCoordinates = /** @type {Array<number>} */
	      (values['flatCoordinates']);
	  var ends = /** @type {Array<number>} */ (values['ends']);
	  ends.push(flatCoordinates.length);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Feature|undefined} Track.
	 */
	function readRte(node, objectStack) {
	  var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
	  var values = pushParseAndPop({
	    'flatCoordinates': [],
	    'layoutOptions': {}
	  }, RTE_PARSERS, node, objectStack);
	  if (!values) {
	    return undefined;
	  }
	  var flatCoordinates = /** @type {Array<number>} */
	      (values['flatCoordinates']);
	  delete values['flatCoordinates'];
	  var layoutOptions = /** @type {LayoutOptions} */ (values['layoutOptions']);
	  delete values['layoutOptions'];
	  var layout = applyLayoutOptions(layoutOptions, flatCoordinates);
	  var geometry = new LineString(flatCoordinates, layout);
	  transformWithOptions(geometry, false, options);
	  var feature = new Feature(geometry);
	  feature.setProperties(values);
	  return feature;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Feature|undefined} Track.
	 */
	function readTrk(node, objectStack) {
	  var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
	  var values = pushParseAndPop({
	    'flatCoordinates': [],
	    'ends': [],
	    'layoutOptions': {}
	  }, TRK_PARSERS, node, objectStack);
	  if (!values) {
	    return undefined;
	  }
	  var flatCoordinates = /** @type {Array<number>} */
	      (values['flatCoordinates']);
	  delete values['flatCoordinates'];
	  var ends = /** @type {Array<number>} */ (values['ends']);
	  delete values['ends'];
	  var layoutOptions = /** @type {LayoutOptions} */ (values['layoutOptions']);
	  delete values['layoutOptions'];
	  var layout = applyLayoutOptions(layoutOptions, flatCoordinates, ends);
	  var geometry = new MultiLineString(flatCoordinates, layout, ends);
	  transformWithOptions(geometry, false, options);
	  var feature = new Feature(geometry);
	  feature.setProperties(values);
	  return feature;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Feature|undefined} Waypoint.
	 */
	function readWpt(node, objectStack) {
	  var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
	  var values = pushParseAndPop({}, WPT_PARSERS, node, objectStack);
	  if (!values) {
	    return undefined;
	  }
	  var layoutOptions = /** @type {LayoutOptions} */ ({});
	  var coordinates = appendCoordinate([], layoutOptions, node, values);
	  var layout = applyLayoutOptions(layoutOptions, coordinates);
	  var geometry = new Point(coordinates, layout);
	  transformWithOptions(geometry, false, options);
	  var feature = new Feature(geometry);
	  feature.setProperties(values);
	  return feature;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {string} value Value for the link's `href` attribute.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeLink(node, value, objectStack) {
	  node.setAttribute('href', value);
	  var context = objectStack[objectStack.length - 1];
	  var properties = context['properties'];
	  var link = [
	    properties['linkText'],
	    properties['linkType']
	  ];
	  pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */ ({node: node}),
	    LINK_SERIALIZERS, OBJECT_PROPERTY_NODE_FACTORY,
	    link, objectStack, LINK_SEQUENCE);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeWptType(node, coordinate, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  var parentNode = context.node;
	  var namespaceURI = parentNode.namespaceURI;
	  var properties = context['properties'];
	  //FIXME Projection handling
	  node.setAttributeNS(null, 'lat', String(coordinate[1]));
	  node.setAttributeNS(null, 'lon', String(coordinate[0]));
	  var geometryLayout = context['geometryLayout'];
	  switch (geometryLayout) {
	    case GeometryLayout.XYZM:
	      if (coordinate[3] !== 0) {
	        properties['time'] = coordinate[3];
	      }
	      // fall through
	    case GeometryLayout.XYZ:
	      if (coordinate[2] !== 0) {
	        properties['ele'] = coordinate[2];
	      }
	      break;
	    case GeometryLayout.XYM:
	      if (coordinate[2] !== 0) {
	        properties['time'] = coordinate[2];
	      }
	      break;
	    default:
	      // pass
	  }
	  var orderedKeys = (node.nodeName == 'rtept') ?
	    RTEPT_TYPE_SEQUENCE[namespaceURI] :
	    WPT_TYPE_SEQUENCE[namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */
	    ({node: node, 'properties': properties}),
	    WPT_TYPE_SERIALIZERS, OBJECT_PROPERTY_NODE_FACTORY,
	    values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Feature} feature Feature.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeRte(node, feature, objectStack) {
	  var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
	  var properties = feature.getProperties();
	  var context = {node: node};
	  context['properties'] = properties;
	  var geometry = feature.getGeometry();
	  if (geometry.getType() == GeometryType.LINE_STRING) {
	    var lineString = /** @type {LineString} */ (transformWithOptions(geometry, true, options));
	    context['geometryLayout'] = lineString.getLayout();
	    properties['rtept'] = lineString.getCoordinates();
	  }
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = RTE_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context,
	    RTE_SERIALIZERS, OBJECT_PROPERTY_NODE_FACTORY,
	    values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Feature} feature Feature.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeTrk(node, feature, objectStack) {
	  var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
	  var properties = feature.getProperties();
	  /** @type {import("../xml.js").NodeStackItem} */
	  var context = {node: node};
	  context['properties'] = properties;
	  var geometry = feature.getGeometry();
	  if (geometry.getType() == GeometryType.MULTI_LINE_STRING) {
	    var multiLineString = /** @type {MultiLineString} */ (transformWithOptions(geometry, true, options));
	    properties['trkseg'] = multiLineString.getLineStrings();
	  }
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = TRK_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context,
	    TRK_SERIALIZERS, OBJECT_PROPERTY_NODE_FACTORY,
	    values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {LineString} lineString LineString.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeTrkSeg(node, lineString, objectStack) {
	  /** @type {import("../xml.js").NodeStackItem} */
	  var context = {node: node};
	  context['geometryLayout'] = lineString.getLayout();
	  context['properties'] = {};
	  pushSerializeAndPop(context,
	    TRKSEG_SERIALIZERS, TRKSEG_NODE_FACTORY,
	    lineString.getCoordinates(), objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Feature} feature Feature.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeWpt(node, feature, objectStack) {
	  var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
	  var context = objectStack[objectStack.length - 1];
	  context['properties'] = feature.getProperties();
	  var geometry = feature.getGeometry();
	  if (geometry.getType() == GeometryType.POINT) {
	    var point = /** @type {Point} */ (transformWithOptions(geometry, true, options));
	    context['geometryLayout'] = point.getLayout();
	    writeWptType(node, point.getCoordinates(), objectStack);
	  }
	}
	
	/**
	 * @module ol/format/GeoJSON
	 */
	
	/**
	 * @typedef {import("geojson").GeoJSON} GeoJSONObject
	 * @typedef {import("geojson").Feature} GeoJSONFeature
	 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
	 * @typedef {import("geojson").Geometry} GeoJSONGeometry
	 * @typedef {import("geojson").Point} GeoJSONPoint
	 * @typedef {import("geojson").LineString} GeoJSONLineString
	 * @typedef {import("geojson").Polygon} GeoJSONPolygon
	 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
	 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
	 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
	 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
	 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
	 * written by the format.  Options passed to read or write methods will take precedence.
	 * @property {string} [geometryName] Geometry name to use when creating features.
	 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
	 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
	 * will look for that field to set the geometry name. If both this field is set to `true`
	 * and a `geometryName` is provided, the `geometryName` will take precedence.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the GeoJSON format.
	 *
	  * @api
	 */
	var GeoJSON = /*@__PURE__*/(function (JSONFeature$$1) {
	  function GeoJSON(opt_options) {
	
	    var options = opt_options ? opt_options : {};
	
	    JSONFeature$$1.call(this);
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2(
	      options.dataProjection ?
	        options.dataProjection : 'EPSG:4326');
	
	    if (options.featureProjection) {
	      this.defaultFeatureProjection = get$2(options.featureProjection);
	    }
	
	    /**
	     * Name of the geometry attribute for features.
	     * @type {string|undefined}
	     * @private
	     */
	    this.geometryName_ = options.geometryName;
	
	    /**
	     * Look for the geometry name in the feature GeoJSON
	     * @type {boolean|undefined}
	     * @private
	     */
	    this.extractGeometryName_ = options.extractGeometryName;
	
	  }
	
	  if ( JSONFeature$$1 ) { GeoJSON.__proto__ = JSONFeature$$1; }
	  GeoJSON.prototype = Object.create( JSONFeature$$1 && JSONFeature$$1.prototype );
	  GeoJSON.prototype.constructor = GeoJSON;
	
	  /**
	   * @inheritDoc
	   */
	  GeoJSON.prototype.readFeatureFromObject = function readFeatureFromObject (object, opt_options) {
	    /**
	     * @type {GeoJSONFeature}
	     */
	    var geoJSONFeature = null;
	    if (object['type'] === 'Feature') {
	      geoJSONFeature = /** @type {GeoJSONFeature} */ (object);
	    } else {
	      geoJSONFeature = {
	        'type': 'Feature',
	        'geometry': /** @type {GeoJSONGeometry} */ (object),
	        'properties': null
	      };
	    }
	
	    var geometry = readGeometry$1(geoJSONFeature['geometry'], opt_options);
	    var feature = new Feature();
	    if (this.geometryName_) {
	      feature.setGeometryName(this.geometryName_);
	    } else if (this.extractGeometryName_ && 'geometry_name' in geoJSONFeature !== undefined) {
	      feature.setGeometryName(geoJSONFeature['geometry_name']);
	    }
	    feature.setGeometry(geometry);
	
	    if ('id' in geoJSONFeature) {
	      feature.setId(geoJSONFeature['id']);
	    }
	
	    if (geoJSONFeature['properties']) {
	      feature.setProperties(geoJSONFeature['properties']);
	    }
	    return feature;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeoJSON.prototype.readFeaturesFromObject = function readFeaturesFromObject (object, opt_options) {
	    var geoJSONObject = /** @type {GeoJSONObject} */ (object);
	    /** @type {Array<import("../Feature.js").default>} */
	    var features = null;
	    if (geoJSONObject['type'] === 'FeatureCollection') {
	      var geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ (object);
	      features = [];
	      var geoJSONFeatures = geoJSONFeatureCollection['features'];
	      for (var i = 0, ii = geoJSONFeatures.length; i < ii; ++i) {
	        features.push(this.readFeatureFromObject(geoJSONFeatures[i], opt_options));
	      }
	    } else {
	      features = [this.readFeatureFromObject(object, opt_options)];
	    }
	    return features;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeoJSON.prototype.readGeometryFromObject = function readGeometryFromObject (object, opt_options) {
	    return readGeometry$1(/** @type {GeoJSONGeometry} */ (object), opt_options);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  GeoJSON.prototype.readProjectionFromObject = function readProjectionFromObject (object) {
	    var crs = object['crs'];
	    var projection;
	    if (crs) {
	      if (crs['type'] == 'name') {
	        projection = get$2(crs['properties']['name']);
	      } else {
	        assert(false, 36); // Unknown SRS type
	      }
	    } else {
	      projection = this.dataProjection;
	    }
	    return (
	      /** @type {import("../proj/Projection.js").default} */ (projection)
	    );
	  };
	
	  /**
	   * Encode a feature as a GeoJSON Feature object.
	   *
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {GeoJSONFeature} Object.
	   * @override
	   * @api
	   */
	  GeoJSON.prototype.writeFeatureObject = function writeFeatureObject (feature, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	
	    /** @type {GeoJSONFeature} */
	    var object = {
	      'type': 'Feature',
	      geometry: null,
	      properties: null
	    };
	
	    var id = feature.getId();
	    if (id !== undefined) {
	      object.id = id;
	    }
	
	    var geometry = feature.getGeometry();
	    if (geometry) {
	      object.geometry = writeGeometry$1(geometry, opt_options);
	    }
	
	    var properties = feature.getProperties();
	    delete properties[feature.getGeometryName()];
	    if (!isEmpty(properties)) {
	      object.properties = properties;
	    }
	    return object;
	  };
	
	  /**
	   * Encode an array of features as a GeoJSON object.
	   *
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {GeoJSONFeatureCollection} GeoJSON Object.
	   * @override
	   * @api
	   */
	  GeoJSON.prototype.writeFeaturesObject = function writeFeaturesObject (features, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    var objects = [];
	    for (var i = 0, ii = features.length; i < ii; ++i) {
	      objects.push(this.writeFeatureObject(features[i], opt_options));
	    }
	    return {
	      type: 'FeatureCollection',
	      features: objects
	    };
	  };
	
	  /**
	   * Encode a geometry as a GeoJSON object.
	   *
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
	   * @override
	   * @api
	   */
	  GeoJSON.prototype.writeGeometryObject = function writeGeometryObject (geometry, opt_options) {
	    return writeGeometry$1(geometry, this.adaptOptions(opt_options));
	  };
	
	  return GeoJSON;
	}(JSONFeature));
	
	
	/**
	 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
	 * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	 * @return {import("../geom/Geometry.js").default} Geometry.
	 */
	function readGeometry$1(object, opt_options) {
	  if (!object) {
	    return null;
	  }
	
	  /**
	   * @type {import("../geom/Geometry.js").default}
	   */
	  var geometry;
	  switch (object['type']) {
	    case GeometryType.POINT: {
	      geometry = readPointGeometry$1(/** @type {GeoJSONPoint} */ (object));
	      break;
	    }
	    case GeometryType.LINE_STRING: {
	      geometry = readLineStringGeometry$1(/** @type {GeoJSONLineString} */ (object));
	      break;
	    }
	    case GeometryType.POLYGON: {
	      geometry = readPolygonGeometry$1(/** @type {GeoJSONPolygon} */ (object));
	      break;
	    }
	    case GeometryType.MULTI_POINT: {
	      geometry = readMultiPointGeometry$1(/** @type {GeoJSONMultiPoint} */ (object));
	      break;
	    }
	    case GeometryType.MULTI_LINE_STRING: {
	      geometry = readMultiLineStringGeometry$1(/** @type {GeoJSONMultiLineString} */ (object));
	      break;
	    }
	    case GeometryType.MULTI_POLYGON: {
	      geometry = readMultiPolygonGeometry$1(/** @type {GeoJSONMultiPolygon} */ (object));
	      break;
	    }
	    case GeometryType.GEOMETRY_COLLECTION: {
	      geometry = readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ (object));
	      break;
	    }
	    default: {
	      throw new Error('Unsupported GeoJSON type: ' + object.type);
	    }
	  }
	  return /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geometry, false, opt_options));
	}
	
	
	/**
	 * @param {GeoJSONGeometryCollection} object Object.
	 * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	 * @return {GeometryCollection} Geometry collection.
	 */
	function readGeometryCollectionGeometry(object, opt_options) {
	  var geometries = object['geometries'].map(
	    /**
	     * @param {GeoJSONGeometry} geometry Geometry.
	     * @return {import("../geom/Geometry.js").default} geometry Geometry.
	     */
	    function(geometry) {
	      return readGeometry$1(geometry, opt_options);
	    });
	  return new GeometryCollection(geometries);
	}
	
	
	/**
	 * @param {GeoJSONPoint} object Object.
	 * @return {Point} Point.
	 */
	function readPointGeometry$1(object) {
	  return new Point(object['coordinates']);
	}
	
	
	/**
	 * @param {GeoJSONLineString} object Object.
	 * @return {LineString} LineString.
	 */
	function readLineStringGeometry$1(object) {
	  return new LineString(object['coordinates']);
	}
	
	
	/**
	 * @param {GeoJSONMultiLineString} object Object.
	 * @return {MultiLineString} MultiLineString.
	 */
	function readMultiLineStringGeometry$1(object) {
	  return new MultiLineString(object['coordinates']);
	}
	
	
	/**
	 * @param {GeoJSONMultiPoint} object Object.
	 * @return {MultiPoint} MultiPoint.
	 */
	function readMultiPointGeometry$1(object) {
	  return new MultiPoint(object['coordinates']);
	}
	
	
	/**
	 * @param {GeoJSONMultiPolygon} object Object.
	 * @return {MultiPolygon} MultiPolygon.
	 */
	function readMultiPolygonGeometry$1(object) {
	  return new MultiPolygon(object['coordinates']);
	}
	
	
	/**
	 * @param {GeoJSONPolygon} object Object.
	 * @return {Polygon} Polygon.
	 */
	function readPolygonGeometry$1(object) {
	  return new Polygon(object['coordinates']);
	}
	
	
	/**
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writeGeometry$1(geometry, opt_options) {
	  geometry = /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geometry, true, opt_options));
	  var type = geometry.getType();
	
	  /** @type {GeoJSONGeometry} */
	  var geoJSON;
	  switch (type) {
	    case GeometryType.POINT: {
	      geoJSON = writePointGeometry$1(/** @type {Point} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.LINE_STRING: {
	      geoJSON = writeLineStringGeometry$1(/** @type {LineString} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.POLYGON: {
	      geoJSON = writePolygonGeometry$1(/** @type {Polygon} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.MULTI_POINT: {
	      geoJSON = writeMultiPointGeometry$1(/** @type {MultiPoint} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.MULTI_LINE_STRING: {
	      geoJSON = writeMultiLineStringGeometry$1(/** @type {MultiLineString} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.MULTI_POLYGON: {
	      geoJSON = writeMultiPolygonGeometry$1(/** @type {MultiPolygon} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.GEOMETRY_COLLECTION: {
	      geoJSON = writeGeometryCollectionGeometry(/** @type {GeometryCollection} */ (geometry), opt_options);
	      break;
	    }
	    case GeometryType.CIRCLE: {
	      geoJSON = {
	        type: 'GeometryCollection',
	        geometries: []
	      };
	      break;
	    }
	    default: {
	      throw new Error('Unsupported geometry type: ' + type);
	    }
	  }
	  return geoJSON;
	}
	
	
	/**
	 * @param {GeometryCollection} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
	 */
	function writeGeometryCollectionGeometry(geometry, opt_options) {
	  var geometries = geometry.getGeometriesArray().map(function(geometry) {
	    var options = assign({}, opt_options);
	    delete options.featureProjection;
	    return writeGeometry$1(geometry, options);
	  });
	  return {
	    type: 'GeometryCollection',
	    geometries: geometries
	  };
	}
	
	
	/**
	 * @param {LineString} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writeLineStringGeometry$1(geometry, opt_options) {
	  return {
	    type: 'LineString',
	    coordinates: geometry.getCoordinates()
	  };
	}
	
	
	/**
	 * @param {MultiLineString} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writeMultiLineStringGeometry$1(geometry, opt_options) {
	  return {
	    type: 'MultiLineString',
	    coordinates: geometry.getCoordinates()
	  };
	}
	
	
	/**
	 * @param {MultiPoint} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writeMultiPointGeometry$1(geometry, opt_options) {
	  return {
	    type: 'MultiPoint',
	    coordinates: geometry.getCoordinates()
	  };
	}
	
	
	/**
	 * @param {MultiPolygon} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writeMultiPolygonGeometry$1(geometry, opt_options) {
	  var right;
	  if (opt_options) {
	    right = opt_options.rightHanded;
	  }
	  return {
	    type: 'MultiPolygon',
	    coordinates: geometry.getCoordinates(right)
	  };
	}
	
	
	/**
	 * @param {Point} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writePointGeometry$1(geometry, opt_options) {
	  return {
	    type: 'Point',
	    coordinates: geometry.getCoordinates()
	  };
	}
	
	
	/**
	 * @param {Polygon} geometry Geometry.
	 * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	 * @return {GeoJSONGeometry} GeoJSON geometry.
	 */
	function writePolygonGeometry$1(geometry, opt_options) {
	  var right;
	  if (opt_options) {
	    right = opt_options.rightHanded;
	  }
	  return {
	    type: 'Polygon',
	    coordinates: geometry.getCoordinates(right)
	  };
	}
	
	/**
	 * @module ol/format/TextFeature
	 */
	
	/**
	 * @classdesc
	 * Abstract base class; normally only used for creating subclasses and not
	 * instantiated in apps.
	 * Base class for text feature formats.
	 *
	 * @abstract
	 */
	var TextFeature = /*@__PURE__*/(function (FeatureFormat$$1) {
	  function TextFeature() {
	    FeatureFormat$$1.call(this);
	  }
	
	  if ( FeatureFormat$$1 ) { TextFeature.__proto__ = FeatureFormat$$1; }
	  TextFeature.prototype = Object.create( FeatureFormat$$1 && FeatureFormat$$1.prototype );
	  TextFeature.prototype.constructor = TextFeature;
	
	  /**
	   * @inheritDoc
	   */
	  TextFeature.prototype.getType = function getType () {
	    return FormatType.TEXT;
	  };
	
	  /**
	   * Read the feature from the source.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {import("../Feature.js").default} Feature.
	   * @api
	   */
	  TextFeature.prototype.readFeature = function readFeature (source, opt_options) {
	    return this.readFeatureFromText(getText(source), this.adaptOptions(opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {string} text Text.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @protected
	   * @return {import("../Feature.js").default} Feature.
	   */
	  TextFeature.prototype.readFeatureFromText = function readFeatureFromText (text, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Read the features from the source.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @api
	   */
	  TextFeature.prototype.readFeatures = function readFeatures (source, opt_options) {
	    return this.readFeaturesFromText(getText(source), this.adaptOptions(opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {string} text Text.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @protected
	   * @return {Array<import("../Feature.js").default>} Features.
	   */
	  TextFeature.prototype.readFeaturesFromText = function readFeaturesFromText (text, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Read the geometry from the source.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {import("../geom/Geometry.js").default} Geometry.
	   * @api
	   */
	  TextFeature.prototype.readGeometry = function readGeometry (source, opt_options) {
	    return this.readGeometryFromText(getText(source), this.adaptOptions(opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {string} text Text.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @protected
	   * @return {import("../geom/Geometry.js").default} Geometry.
	   */
	  TextFeature.prototype.readGeometryFromText = function readGeometryFromText (text, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Read the projection from the source.
	   *
	   * @param {Document|Node|Object|string} source Source.
	   * @return {import("../proj/Projection.js").default} Projection.
	   * @api
	   */
	  TextFeature.prototype.readProjection = function readProjection (source) {
	    return this.readProjectionFromText(getText(source));
	  };
	
	  /**
	   * @param {string} text Text.
	   * @protected
	   * @return {import("../proj/Projection.js").default} Projection.
	   */
	  TextFeature.prototype.readProjectionFromText = function readProjectionFromText (text) {
	    return this.dataProjection;
	  };
	
	  /**
	   * Encode a feature as a string.
	   *
	   * @param {import("../Feature.js").default} feature Feature.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Encoded feature.
	   * @api
	   */
	  TextFeature.prototype.writeFeature = function writeFeature (feature, opt_options) {
	    return this.writeFeatureText(feature, this.adaptOptions(opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {import("../Feature.js").default} feature Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @protected
	   * @return {string} Text.
	   */
	  TextFeature.prototype.writeFeatureText = function writeFeatureText (feature, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Encode an array of features as string.
	   *
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Encoded features.
	   * @api
	   */
	  TextFeature.prototype.writeFeatures = function writeFeatures (features, opt_options) {
	    return this.writeFeaturesText(features, this.adaptOptions(opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {Array<import("../Feature.js").default>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @protected
	   * @return {string} Text.
	   */
	  TextFeature.prototype.writeFeaturesText = function writeFeaturesText (features, opt_options) {
	    return abstract();
	  };
	
	  /**
	   * Write a single geometry.
	   *
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @return {string} Geometry.
	   * @api
	   */
	  TextFeature.prototype.writeGeometry = function writeGeometry (geometry, opt_options) {
	    return this.writeGeometryText(geometry, this.adaptOptions(opt_options));
	  };
	
	  /**
	   * @abstract
	   * @param {import("../geom/Geometry.js").default} geometry Geometry.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Write options.
	   * @protected
	   * @return {string} Text.
	   */
	  TextFeature.prototype.writeGeometryText = function writeGeometryText (geometry, opt_options) {
	    return abstract();
	  };
	
	  return TextFeature;
	}(FeatureFormat));
	
	
	/**
	 * @param {Document|Node|Object|string} source Source.
	 * @return {string} Text.
	 */
	function getText(source) {
	  if (typeof source === 'string') {
	    return source;
	  } else {
	    return '';
	  }
	}
	
	/**
	 * @module ol/format/IGC
	 */
	
	/**
	 * IGC altitude/z. One of 'barometric', 'gps', 'none'.
	 * @enum {string}
	 */
	var IGCZ = {
	  BAROMETRIC: 'barometric',
	  GPS: 'gps',
	  NONE: 'none'
	};
	
	/**
	 * @const
	 * @type {RegExp}
	 */
	var B_RECORD_RE =
	    /^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/;
	
	
	/**
	 * @const
	 * @type {RegExp}
	 */
	var H_RECORD_RE = /^H.([A-Z]{3}).*?:(.*)/;
	
	
	/**
	 * @const
	 * @type {RegExp}
	 */
	var HFDTE_RECORD_RE = /^HFDTE(\d{2})(\d{2})(\d{2})/;
	
	
	/**
	 * A regular expression matching the newline characters `\r\n`, `\r` and `\n`.
	 *
	 * @const
	 * @type {RegExp}
	 */
	var NEWLINE_RE = /\r\n|\r|\n/;
	
	
	/**
	 * @typedef {Object} Options
	 * @property {IGCZ|string} [altitudeMode='none'] Altitude mode. Possible
	 * values are `'barometric'`, `'gps'`, and `'none'`.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for `*.igc` flight recording files.
	 *
	 * As IGC sources contain a single feature,
	 * {@link module:ol/format/IGC~IGC#readFeatures} will return the feature in an
	 * array
	 *
	 * @api
	 */
	var IGC = /*@__PURE__*/(function (TextFeature$$1) {
	  function IGC(opt_options) {
	    TextFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2('EPSG:4326');
	
	    /**
	     * @private
	     * @type {IGCZ}
	     */
	    this.altitudeMode_ = options.altitudeMode ? options.altitudeMode : IGCZ.NONE;
	  }
	
	  if ( TextFeature$$1 ) { IGC.__proto__ = TextFeature$$1; }
	  IGC.prototype = Object.create( TextFeature$$1 && TextFeature$$1.prototype );
	  IGC.prototype.constructor = IGC;
	
	  /**
	   * @inheritDoc
	   */
	  IGC.prototype.readFeatureFromText = function readFeatureFromText (text, opt_options) {
	    var altitudeMode = this.altitudeMode_;
	    var lines = text.split(NEWLINE_RE);
	    /** @type {Object<string, string>} */
	    var properties = {};
	    var flatCoordinates = [];
	    var year = 2000;
	    var month = 0;
	    var day = 1;
	    var lastDateTime = -1;
	    var i, ii;
	    for (i = 0, ii = lines.length; i < ii; ++i) {
	      var line = lines[i];
	      var m = (void 0);
	      if (line.charAt(0) == 'B') {
	        m = B_RECORD_RE.exec(line);
	        if (m) {
	          var hour = parseInt(m[1], 10);
	          var minute = parseInt(m[2], 10);
	          var second = parseInt(m[3], 10);
	          var y = parseInt(m[4], 10) + parseInt(m[5], 10) / 60000;
	          if (m[6] == 'S') {
	            y = -y;
	          }
	          var x = parseInt(m[7], 10) + parseInt(m[8], 10) / 60000;
	          if (m[9] == 'W') {
	            x = -x;
	          }
	          flatCoordinates.push(x, y);
	          if (altitudeMode != IGCZ.NONE) {
	            var z = (void 0);
	            if (altitudeMode == IGCZ.GPS) {
	              z = parseInt(m[11], 10);
	            } else if (altitudeMode == IGCZ.BAROMETRIC) {
	              z = parseInt(m[12], 10);
	            } else {
	              z = 0;
	            }
	            flatCoordinates.push(z);
	          }
	          var dateTime = Date.UTC(year, month, day, hour, minute, second);
	          // Detect UTC midnight wrap around.
	          if (dateTime < lastDateTime) {
	            dateTime = Date.UTC(year, month, day + 1, hour, minute, second);
	          }
	          flatCoordinates.push(dateTime / 1000);
	          lastDateTime = dateTime;
	        }
	      } else if (line.charAt(0) == 'H') {
	        m = HFDTE_RECORD_RE.exec(line);
	        if (m) {
	          day = parseInt(m[1], 10);
	          month = parseInt(m[2], 10) - 1;
	          year = 2000 + parseInt(m[3], 10);
	        } else {
	          m = H_RECORD_RE.exec(line);
	          if (m) {
	            properties[m[1]] = m[2].trim();
	          }
	        }
	      }
	    }
	    if (flatCoordinates.length === 0) {
	      return null;
	    }
	    var layout = altitudeMode == IGCZ.NONE ? GeometryLayout.XYM : GeometryLayout.XYZM;
	    var lineString = new LineString(flatCoordinates, layout);
	    var feature = new Feature(transformWithOptions(lineString, false, opt_options));
	    feature.setProperties(properties);
	    return feature;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  IGC.prototype.readFeaturesFromText = function readFeaturesFromText (text, opt_options) {
	    var feature = this.readFeatureFromText(text, opt_options);
	    if (feature) {
	      return [feature];
	    } else {
	      return [];
	    }
	  };
	
	  return IGC;
	}(TextFeature));
	
	/**
	 * @module ol/format/KML
	 */
	
	/**
	 * @typedef {Object} Vec2
	 * @property {number} x
	 * @property {IconAnchorUnits} xunits
	 * @property {number} y
	 * @property {IconAnchorUnits} yunits
	 * @property {IconOrigin} origin
	 */
	
	/**
	 * @typedef {Object} GxTrackObject
	 * @property {Array<number>} flatCoordinates
	 * @property {Array<number>} whens
	 */
	
	
	/**
	 * @const
	 * @type {Array<string>}
	 */
	var GX_NAMESPACE_URIS = [
	  'http://www.google.com/kml/ext/2.2'
	];
	
	
	/**
	 * @const
	 * @type {Array<null|string>}
	 */
	var NAMESPACE_URIS$1 = [
	  null,
	  'http://earth.google.com/kml/2.0',
	  'http://earth.google.com/kml/2.1',
	  'http://earth.google.com/kml/2.2',
	  'http://www.opengis.net/kml/2.2'
	];
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var SCHEMA_LOCATION$1 = 'http://www.opengis.net/kml/2.2 ' +
	    'https://developers.google.com/kml/schema/kml22gx.xsd';
	
	
	/**
	 * @type {Object<string, IconAnchorUnits>}
	 */
	var ICON_ANCHOR_UNITS_MAP = {
	  'fraction': IconAnchorUnits.FRACTION,
	  'pixels': IconAnchorUnits.PIXELS,
	  'insetPixels': IconAnchorUnits.PIXELS
	};
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PLACEMARK_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'ExtendedData': extendedDataParser,
	    'Region': regionParser,
	    'MultiGeometry': makeObjectPropertySetter(
	      readMultiGeometry, 'geometry'),
	    'LineString': makeObjectPropertySetter(
	      readLineString, 'geometry'),
	    'LinearRing': makeObjectPropertySetter(
	      readLinearRing, 'geometry'),
	    'Point': makeObjectPropertySetter(
	      readPoint, 'geometry'),
	    'Polygon': makeObjectPropertySetter(
	      readPolygon, 'geometry'),
	    'Style': makeObjectPropertySetter(readStyle),
	    'StyleMap': placemarkStyleMapParser,
	    'address': makeObjectPropertySetter(readString),
	    'description': makeObjectPropertySetter(readString),
	    'name': makeObjectPropertySetter(readString),
	    'open': makeObjectPropertySetter(readBoolean),
	    'phoneNumber': makeObjectPropertySetter(readString),
	    'styleUrl': makeObjectPropertySetter(readURI),
	    'visibility': makeObjectPropertySetter(readBoolean)
	  }, makeStructureNS(
	    GX_NAMESPACE_URIS, {
	      'MultiTrack': makeObjectPropertySetter(
	        readGxMultiTrack, 'geometry'),
	      'Track': makeObjectPropertySetter(
	        readGxTrack, 'geometry')
	    }
	  ));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var NETWORK_LINK_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'ExtendedData': extendedDataParser,
	    'Region': regionParser,
	    'Link': linkParser,
	    'address': makeObjectPropertySetter(readString),
	    'description': makeObjectPropertySetter(readString),
	    'name': makeObjectPropertySetter(readString),
	    'open': makeObjectPropertySetter(readBoolean),
	    'phoneNumber': makeObjectPropertySetter(readString),
	    'visibility': makeObjectPropertySetter(readBoolean)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LINK_PARSERS$1 = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'href': makeObjectPropertySetter(readURI)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var REGION_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'LatLonAltBox': latLonAltBoxParser,
	    'Lod': lodParser
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var KML_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'Document', 'Placemark'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var KML_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Document': makeChildAppender(writeDocument),
	    'Placemark': makeChildAppender(writePlacemark)
	  });
	
	
	/**
	 * @type {import("../color.js").Color}
	 */
	var DEFAULT_COLOR;
	
	/**
	 * @type {Fill}
	 */
	var DEFAULT_FILL_STYLE = null;
	
	/**
	 * @type {import("../size.js").Size}
	 */
	var DEFAULT_IMAGE_STYLE_ANCHOR;
	
	/**
	 * @type {IconAnchorUnits}
	 */
	var DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
	
	/**
	 * @type {IconAnchorUnits}
	 */
	var DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
	
	/**
	 * @type {import("../size.js").Size}
	 */
	var DEFAULT_IMAGE_STYLE_SIZE;
	
	/**
	 * @type {string}
	 */
	var DEFAULT_IMAGE_STYLE_SRC;
	
	/**
	 * @type {number}
	 */
	var DEFAULT_IMAGE_SCALE_MULTIPLIER;
	
	/**
	 * @type {import("../style/Image.js").default}
	 */
	var DEFAULT_IMAGE_STYLE = null;
	
	/**
	 * @type {string}
	 */
	var DEFAULT_NO_IMAGE_STYLE;
	
	/**
	 * @type {Stroke}
	 */
	var DEFAULT_STROKE_STYLE$1 = null;
	
	/**
	 * @type {Stroke}
	 */
	var DEFAULT_TEXT_STROKE_STYLE;
	
	/**
	 * @type {Text}
	 */
	var DEFAULT_TEXT_STYLE = null;
	
	/**
	 * @type {Style}
	 */
	var DEFAULT_STYLE = null;
	
	/**
	 * @type {Array<Style>}
	 */
	var DEFAULT_STYLE_ARRAY = null;
	
	
	function createStyleDefaults() {
	
	  DEFAULT_COLOR = [255, 255, 255, 1];
	
	  DEFAULT_FILL_STYLE = new Fill({
	    color: DEFAULT_COLOR
	  });
	
	  DEFAULT_IMAGE_STYLE_ANCHOR = [20, 2]; // FIXME maybe [8, 32] ?
	
	  DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS = IconAnchorUnits.PIXELS;
	
	  DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS = IconAnchorUnits.PIXELS;
	
	  DEFAULT_IMAGE_STYLE_SIZE = [64, 64];
	
	  DEFAULT_IMAGE_STYLE_SRC =
	      'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png';
	
	  DEFAULT_IMAGE_SCALE_MULTIPLIER = 0.5;
	
	  DEFAULT_IMAGE_STYLE = new Icon({
	    anchor: DEFAULT_IMAGE_STYLE_ANCHOR,
	    anchorOrigin: IconOrigin.BOTTOM_LEFT,
	    anchorXUnits: DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS,
	    anchorYUnits: DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS,
	    crossOrigin: 'anonymous',
	    rotation: 0,
	    scale: DEFAULT_IMAGE_SCALE_MULTIPLIER,
	    size: DEFAULT_IMAGE_STYLE_SIZE,
	    src: DEFAULT_IMAGE_STYLE_SRC
	  });
	
	  DEFAULT_NO_IMAGE_STYLE = 'NO_IMAGE';
	
	  DEFAULT_STROKE_STYLE$1 = new Stroke({
	    color: DEFAULT_COLOR,
	    width: 1
	  });
	
	  DEFAULT_TEXT_STROKE_STYLE = new Stroke({
	    color: [51, 51, 51, 1],
	    width: 2
	  });
	
	  DEFAULT_TEXT_STYLE = new Text({
	    font: 'bold 16px Helvetica',
	    fill: DEFAULT_FILL_STYLE,
	    stroke: DEFAULT_TEXT_STROKE_STYLE,
	    scale: 0.8
	  });
	
	  DEFAULT_STYLE = new Style({
	    fill: DEFAULT_FILL_STYLE,
	    image: DEFAULT_IMAGE_STYLE,
	    text: DEFAULT_TEXT_STYLE,
	    stroke: DEFAULT_STROKE_STYLE$1,
	    zIndex: 0
	  });
	
	  DEFAULT_STYLE_ARRAY = [DEFAULT_STYLE];
	
	}
	
	
	/**
	 * @typedef {Object} Options
	 * @property {boolean} [extractStyles=true] Extract styles from the KML.
	 * @property {boolean} [showPointNames=true] Show names as labels for placemarks which contain points.
	 * @property {Array<Style>} [defaultStyle] Default style. The
	 * default default style is the same as Google Earth.
	 * @property {boolean} [writeStyles=true] Write styles into KML.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the KML format.
	 *
	 * {@link module:ol/format/KML~KML#readFeature} will read the first feature from
	 * a KML source.
	 *
	 * MultiGeometries are converted into GeometryCollections if they are a mix of
	 * geometry types, and into MultiPoint/MultiLineString/MultiPolygon if they are
	 * all of the same type.
	 *
	 * Note that the KML format uses the URL() constructor. Older browsers such as IE
	 * which do not support this will need a URL polyfill to be loaded before use.
	 *
	 * @api
	 */
	var KML = /*@__PURE__*/(function (XMLFeature$$1) {
	  function KML(opt_options) {
	    XMLFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    if (!DEFAULT_STYLE_ARRAY) {
	      createStyleDefaults();
	    }
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2('EPSG:4326');
	
	    /**
	     * @private
	     * @type {Array<Style>}
	     */
	    this.defaultStyle_ = options.defaultStyle ?
	      options.defaultStyle : DEFAULT_STYLE_ARRAY;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.extractStyles_ = options.extractStyles !== undefined ?
	      options.extractStyles : true;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.writeStyles_ = options.writeStyles !== undefined ?
	      options.writeStyles : true;
	
	    /**
	     * @private
	     * @type {!Object<string, (Array<Style>|string)>}
	     */
	    this.sharedStyles_ = {};
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.showPointNames_ = options.showPointNames !== undefined ?
	      options.showPointNames : true;
	
	  }
	
	  if ( XMLFeature$$1 ) { KML.__proto__ = XMLFeature$$1; }
	  KML.prototype = Object.create( XMLFeature$$1 && XMLFeature$$1.prototype );
	  KML.prototype.constructor = KML;
	
	  /**
	   * @param {Node} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Array<Feature>|undefined} Features.
	   */
	  KML.prototype.readDocumentOrFolder_ = function readDocumentOrFolder_ (node, objectStack) {
	    // FIXME use scope somehow
	    var parsersNS = makeStructureNS(
	      NAMESPACE_URIS$1, {
	        'Document': makeArrayExtender(this.readDocumentOrFolder_, this),
	        'Folder': makeArrayExtender(this.readDocumentOrFolder_, this),
	        'Placemark': makeArrayPusher(this.readPlacemark_, this),
	        'Style': this.readSharedStyle_.bind(this),
	        'StyleMap': this.readSharedStyleMap_.bind(this)
	      });
	    /** @type {Array<Feature>} */
	    var features = pushParseAndPop([], parsersNS, node, objectStack, this);
	    if (features) {
	      return features;
	    } else {
	      return undefined;
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   * @return {Feature|undefined} Feature.
	   */
	  KML.prototype.readPlacemark_ = function readPlacemark_ (node, objectStack) {
	    var object = pushParseAndPop({'geometry': null},
	      PLACEMARK_PARSERS, node, objectStack);
	    if (!object) {
	      return undefined;
	    }
	    var feature = new Feature();
	    var id = node.getAttribute('id');
	    if (id !== null) {
	      feature.setId(id);
	    }
	    var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
	
	    var geometry = object['geometry'];
	    if (geometry) {
	      transformWithOptions(geometry, false, options);
	    }
	    feature.setGeometry(geometry);
	    delete object['geometry'];
	
	    if (this.extractStyles_) {
	      var style = object['Style'];
	      var styleUrl = object['styleUrl'];
	      var styleFunction = createFeatureStyleFunction(
	        style, styleUrl, this.defaultStyle_, this.sharedStyles_,
	        this.showPointNames_);
	      feature.setStyle(styleFunction);
	    }
	    delete object['Style'];
	    // we do not remove the styleUrl property from the object, so it
	    // gets stored on feature when setProperties is called
	
	    feature.setProperties(object);
	
	    return feature;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  KML.prototype.readSharedStyle_ = function readSharedStyle_ (node, objectStack) {
	    var id = node.getAttribute('id');
	    if (id !== null) {
	      var style = readStyle(node, objectStack);
	      if (style) {
	        var styleUri;
	        var baseURI = node.baseURI;
	        if (!baseURI || baseURI == 'about:blank') {
	          baseURI = window.location.href;
	        }
	        if (baseURI) {
	          var url = new URL('#' + id, baseURI);
	          styleUri = url.href;
	        } else {
	          styleUri = '#' + id;
	        }
	        this.sharedStyles_[styleUri] = style;
	      }
	    }
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @private
	   */
	  KML.prototype.readSharedStyleMap_ = function readSharedStyleMap_ (node, objectStack) {
	    var id = node.getAttribute('id');
	    if (id === null) {
	      return;
	    }
	    var styleMapValue = readStyleMapValue(node, objectStack);
	    if (!styleMapValue) {
	      return;
	    }
	    var styleUri;
	    var baseURI = node.baseURI;
	    if (!baseURI || baseURI == 'about:blank') {
	      baseURI = window.location.href;
	    }
	    if (baseURI) {
	      var url = new URL('#' + id, baseURI);
	      styleUri = url.href;
	    } else {
	      styleUri = '#' + id;
	    }
	    this.sharedStyles_[styleUri] = styleMapValue;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  KML.prototype.readFeatureFromNode = function readFeatureFromNode (node, opt_options) {
	    if (!includes(NAMESPACE_URIS$1, node.namespaceURI)) {
	      return null;
	    }
	    var feature = this.readPlacemark_(
	      node, [this.getReadOptions(node, opt_options)]);
	    if (feature) {
	      return feature;
	    } else {
	      return null;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  KML.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    if (!includes(NAMESPACE_URIS$1, node.namespaceURI)) {
	      return [];
	    }
	    var features;
	    var localName = node.localName;
	    if (localName == 'Document' || localName == 'Folder') {
	      features = this.readDocumentOrFolder_(
	        node, [this.getReadOptions(node, opt_options)]);
	      if (features) {
	        return features;
	      } else {
	        return [];
	      }
	    } else if (localName == 'Placemark') {
	      var feature = this.readPlacemark_(
	        node, [this.getReadOptions(node, opt_options)]);
	      if (feature) {
	        return [feature];
	      } else {
	        return [];
	      }
	    } else if (localName == 'kml') {
	      features = [];
	      for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
	        var fs = this.readFeaturesFromNode(n, opt_options);
	        if (fs) {
	          extend(features, fs);
	        }
	      }
	      return features;
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Read the name of the KML.
	   *
	   * @param {Document|Element|string} source Source.
	   * @return {string|undefined} Name.
	   * @api
	   */
	  KML.prototype.readName = function readName (source) {
	    if (!source) {
	      return undefined;
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readNameFromDocument(doc);
	    } else if (isDocument(source)) {
	      return this.readNameFromDocument(/** @type {Document} */ (source));
	    } else {
	      return this.readNameFromNode(/** @type {Element} */ (source));
	    }
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @return {string|undefined} Name.
	   */
	  KML.prototype.readNameFromDocument = function readNameFromDocument (doc) {
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        var name = this.readNameFromNode(/** @type {Element} */ (n));
	        if (name) {
	          return name;
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @return {string|undefined} Name.
	   */
	  KML.prototype.readNameFromNode = function readNameFromNode (node) {
	    for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
	      if (includes(NAMESPACE_URIS$1, n.namespaceURI) &&
	          n.localName == 'name') {
	        return readString(n);
	      }
	    }
	    for (var n$1 = node.firstElementChild; n$1; n$1 = n$1.nextElementSibling) {
	      var localName = n$1.localName;
	      if (includes(NAMESPACE_URIS$1, n$1.namespaceURI) &&
	          (localName == 'Document' ||
	           localName == 'Folder' ||
	           localName == 'Placemark' ||
	           localName == 'kml')) {
	        var name = this.readNameFromNode(n$1);
	        if (name) {
	          return name;
	        }
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * Read the network links of the KML.
	   *
	   * @param {Document|Element|string} source Source.
	   * @return {Array<Object>} Network links.
	   * @api
	   */
	  KML.prototype.readNetworkLinks = function readNetworkLinks (source) {
	    var networkLinks = [];
	    if (typeof source === 'string') {
	      var doc = parse(source);
	      extend(networkLinks, this.readNetworkLinksFromDocument(doc));
	    } else if (isDocument(source)) {
	      extend(networkLinks, this.readNetworkLinksFromDocument(
	        /** @type {Document} */ (source)));
	    } else {
	      extend(networkLinks, this.readNetworkLinksFromNode(
	        /** @type {Element} */ (source)));
	    }
	    return networkLinks;
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @return {Array<Object>} Network links.
	   */
	  KML.prototype.readNetworkLinksFromDocument = function readNetworkLinksFromDocument (doc) {
	    var networkLinks = [];
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        extend(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ (n)));
	      }
	    }
	    return networkLinks;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @return {Array<Object>} Network links.
	   */
	  KML.prototype.readNetworkLinksFromNode = function readNetworkLinksFromNode (node) {
	    var networkLinks = [];
	    for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
	      if (includes(NAMESPACE_URIS$1, n.namespaceURI) &&
	          n.localName == 'NetworkLink') {
	        var obj = pushParseAndPop({}, NETWORK_LINK_PARSERS,
	          n, []);
	        networkLinks.push(obj);
	      }
	    }
	    for (var n$1 = node.firstElementChild; n$1; n$1 = n$1.nextElementSibling) {
	      var localName = n$1.localName;
	      if (includes(NAMESPACE_URIS$1, n$1.namespaceURI) &&
	          (localName == 'Document' ||
	           localName == 'Folder' ||
	           localName == 'kml')) {
	        extend(networkLinks, this.readNetworkLinksFromNode(n$1));
	      }
	    }
	    return networkLinks;
	  };
	
	  /**
	   * Read the regions of the KML.
	   *
	   * @param {Document|Element|string} source Source.
	   * @return {Array<Object>} Regions.
	   * @api
	   */
	  KML.prototype.readRegion = function readRegion (source) {
	    var regions = [];
	    if (typeof source === 'string') {
	      var doc = parse(source);
	      extend(regions, this.readRegionFromDocument(doc));
	    } else if (isDocument(source)) {
	      extend(regions, this.readRegionFromDocument(
	        /** @type {Document} */ (source)));
	    } else {
	      extend(regions, this.readRegionFromNode(
	        /** @type {Element} */ (source)));
	    }
	    return regions;
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @return {Array<Object>} Region.
	   */
	  KML.prototype.readRegionFromDocument = function readRegionFromDocument (doc) {
	    var regions = [];
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        extend(regions, this.readRegionFromNode(/** @type {Element} */ (n)));
	      }
	    }
	    return regions;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @return {Array<Object>} Region.
	   * @api
	   */
	  KML.prototype.readRegionFromNode = function readRegionFromNode (node) {
	    var regions = [];
	    for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
	      if (includes(NAMESPACE_URIS$1, n.namespaceURI) &&
	          n.localName == 'Region') {
	        var obj = pushParseAndPop({}, REGION_PARSERS,
	          n, []);
	        regions.push(obj);
	      }
	    }
	    for (var n$1 = node.firstElementChild; n$1; n$1 = n$1.nextElementSibling) {
	      var localName = n$1.localName;
	      if (includes(NAMESPACE_URIS$1, n$1.namespaceURI) &&
	          (localName == 'Document' ||
	           localName == 'Folder' ||
	           localName == 'kml')) {
	        extend(regions, this.readRegionFromNode(n$1));
	      }
	    }
	    return regions;
	  };
	
	  /**
	   * Encode an array of features in the KML format as an XML node. GeometryCollections,
	   * MultiPoints, MultiLineStrings, and MultiPolygons are output as MultiGeometries.
	   *
	   * @param {Array<Feature>} features Features.
	   * @param {import("./Feature.js").WriteOptions=} opt_options Options.
	   * @return {Node} Node.
	   * @override
	   * @api
	   */
	  KML.prototype.writeFeaturesNode = function writeFeaturesNode (features, opt_options) {
	    opt_options = this.adaptOptions(opt_options);
	    var kml = createElementNS(NAMESPACE_URIS$1[4], 'kml');
	    var xmlnsUri = 'http://www.w3.org/2000/xmlns/';
	    kml.setAttributeNS(xmlnsUri, 'xmlns:gx', GX_NAMESPACE_URIS[0]);
	    kml.setAttributeNS(xmlnsUri, 'xmlns:xsi', XML_SCHEMA_INSTANCE_URI);
	    kml.setAttributeNS(XML_SCHEMA_INSTANCE_URI, 'xsi:schemaLocation', SCHEMA_LOCATION$1);
	
	    var /** @type {import("../xml.js").NodeStackItem} */ context = {node: kml};
	    /** @type {!Object<string, (Array<Feature>|Feature|undefined)>} */
	    var properties = {};
	    if (features.length > 1) {
	      properties['Document'] = features;
	    } else if (features.length == 1) {
	      properties['Placemark'] = features[0];
	    }
	    var orderedKeys = KML_SEQUENCE[kml.namespaceURI];
	    var values = makeSequence(properties, orderedKeys);
	    pushSerializeAndPop(context, KML_SERIALIZERS,
	      OBJECT_PROPERTY_NODE_FACTORY, values, [opt_options], orderedKeys,
	      this);
	    return kml;
	  };
	
	  return KML;
	}(XMLFeature));
	
	
	/**
	 * @param {Style|undefined} foundStyle Style.
	 * @param {string} name Name.
	 * @return {Style} style Style.
	 */
	function createNameStyleFunction(foundStyle, name) {
	  var textStyle = null;
	  var textOffset = [0, 0];
	  var textAlign = 'start';
	  if (foundStyle.getImage()) {
	    var imageSize = foundStyle.getImage().getImageSize();
	    if (imageSize === null) {
	      imageSize = DEFAULT_IMAGE_STYLE_SIZE;
	    }
	    if (imageSize.length == 2) {
	      var imageScale = foundStyle.getImage().getScale();
	      // Offset the label to be centered to the right of the icon, if there is
	      // one.
	      textOffset[0] = imageScale * imageSize[0] / 2;
	      textOffset[1] = -imageScale * imageSize[1] / 2;
	      textAlign = 'left';
	    }
	  }
	  if (foundStyle.getText() !== null) {
	    // clone the text style, customizing it with name, alignments and offset.
	    // Note that kml does not support many text options that OpenLayers does (rotation, textBaseline).
	    var foundText = foundStyle.getText();
	    textStyle = foundText.clone();
	    textStyle.setFont(foundText.getFont() || DEFAULT_TEXT_STYLE.getFont());
	    textStyle.setScale(foundText.getScale() || DEFAULT_TEXT_STYLE.getScale());
	    textStyle.setFill(foundText.getFill() || DEFAULT_TEXT_STYLE.getFill());
	    textStyle.setStroke(foundText.getStroke() || DEFAULT_TEXT_STROKE_STYLE);
	  } else {
	    textStyle = DEFAULT_TEXT_STYLE.clone();
	  }
	  textStyle.setText(name);
	  textStyle.setOffsetX(textOffset[0]);
	  textStyle.setOffsetY(textOffset[1]);
	  textStyle.setTextAlign(textAlign);
	
	  var nameStyle = new Style({
	    text: textStyle
	  });
	  return nameStyle;
	}
	
	
	/**
	 * @param {Array<Style>|undefined} style Style.
	 * @param {string} styleUrl Style URL.
	 * @param {Array<Style>} defaultStyle Default style.
	 * @param {!Object<string, (Array<Style>|string)>} sharedStyles Shared styles.
	 * @param {boolean|undefined} showPointNames true to show names for point placemarks.
	 * @return {import("../style/Style.js").StyleFunction} Feature style function.
	 */
	function createFeatureStyleFunction(style, styleUrl, defaultStyle, sharedStyles, showPointNames) {
	
	  return (
	    /**
	     * @param {Feature} feature feature.
	     * @param {number} resolution Resolution.
	     * @return {Array<Style>} Style.
	     */
	    function(feature, resolution) {
	      var drawName = showPointNames;
	      /** @type {Style|undefined} */
	      var nameStyle;
	      var name = '';
	      if (drawName) {
	        var geometry = feature.getGeometry();
	        if (geometry) {
	          drawName = geometry.getType() === GeometryType.POINT;
	        }
	      }
	
	      if (drawName) {
	        name = /** @type {string} */ (feature.get('name'));
	        drawName = drawName && !!name;
	      }
	
	      if (style) {
	        if (drawName) {
	          nameStyle = createNameStyleFunction(style[0], name);
	          return style.concat(nameStyle);
	        }
	        return style;
	      }
	      if (styleUrl) {
	        var foundStyle = findStyle(styleUrl, defaultStyle, sharedStyles);
	        if (drawName) {
	          nameStyle = createNameStyleFunction(foundStyle[0], name);
	          return foundStyle.concat(nameStyle);
	        }
	        return foundStyle;
	      }
	      if (drawName) {
	        nameStyle = createNameStyleFunction(defaultStyle[0], name);
	        return defaultStyle.concat(nameStyle);
	      }
	      return defaultStyle;
	    }
	  );
	}
	
	
	/**
	 * @param {Array<Style>|string|undefined} styleValue Style value.
	 * @param {Array<Style>} defaultStyle Default style.
	 * @param {!Object<string, (Array<Style>|string)>} sharedStyles
	 * Shared styles.
	 * @return {Array<Style>} Style.
	 */
	function findStyle(styleValue, defaultStyle, sharedStyles) {
	  if (Array.isArray(styleValue)) {
	    return styleValue;
	  } else if (typeof styleValue === 'string') {
	    // KML files in the wild occasionally forget the leading `#` on styleUrls
	    // defined in the same document.  Add a leading `#` if it enables to find
	    // a style.
	    if (!(styleValue in sharedStyles) && ('#' + styleValue in sharedStyles)) {
	      styleValue = '#' + styleValue;
	    }
	    return findStyle(sharedStyles[styleValue], defaultStyle, sharedStyles);
	  } else {
	    return defaultStyle;
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {import("../color.js").Color|undefined} Color.
	 */
	function readColor(node) {
	  var s = getAllTextContent(node, false);
	  // The KML specification states that colors should not include a leading `#`
	  // but we tolerate them.
	  var m = /^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(s);
	  if (m) {
	    var hexColor = m[1];
	    return [
	      parseInt(hexColor.substr(6, 2), 16),
	      parseInt(hexColor.substr(4, 2), 16),
	      parseInt(hexColor.substr(2, 2), 16),
	      parseInt(hexColor.substr(0, 2), 16) / 255
	    ];
	
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {Array<number>|undefined} Flat coordinates.
	 */
	function readFlatCoordinates(node) {
	  var s = getAllTextContent(node, false);
	  var flatCoordinates = [];
	  // The KML specification states that coordinate tuples should not include
	  // spaces, but we tolerate them.
	  var re =
	      /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?))?\s*/i;
	  var m;
	  while ((m = re.exec(s))) {
	    var x = parseFloat(m[1]);
	    var y = parseFloat(m[2]);
	    var z = m[3] ? parseFloat(m[3]) : 0;
	    flatCoordinates.push(x, y, z);
	    s = s.substr(m[0].length);
	  }
	  if (s !== '') {
	    return undefined;
	  }
	  return flatCoordinates;
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {string} URI.
	 */
	function readURI(node) {
	  var s = getAllTextContent(node, false).trim();
	  var baseURI = node.baseURI;
	  if (!baseURI || baseURI == 'about:blank') {
	    baseURI = window.location.href;
	  }
	  if (baseURI) {
	    var url = new URL(s, baseURI);
	    return url.href;
	  } else {
	    return s;
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @return {Vec2} Vec2.
	 */
	function readVec2(node) {
	  var xunits = node.getAttribute('xunits');
	  var yunits = node.getAttribute('yunits');
	  var origin;
	  if (xunits !== 'insetPixels') {
	    if (yunits !== 'insetPixels') {
	      origin = IconOrigin.BOTTOM_LEFT;
	    } else {
	      origin = IconOrigin.TOP_LEFT;
	    }
	  } else {
	    if (yunits !== 'insetPixels') {
	      origin = IconOrigin.BOTTOM_RIGHT;
	    } else {
	      origin = IconOrigin.TOP_RIGHT;
	    }
	  }
	  return {
	    x: parseFloat(node.getAttribute('x')),
	    xunits: ICON_ANCHOR_UNITS_MAP[xunits],
	    y: parseFloat(node.getAttribute('y')),
	    yunits: ICON_ANCHOR_UNITS_MAP[yunits],
	    origin: origin
	  };
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @return {number|undefined} Scale.
	 */
	function readScale(node) {
	  return readDecimal(node);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var STYLE_MAP_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Pair': pairDataParser
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<Style>|string|undefined} StyleMap.
	 */
	function readStyleMapValue(node, objectStack) {
	  return pushParseAndPop(undefined,
	    STYLE_MAP_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var ICON_STYLE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Icon': makeObjectPropertySetter(readIcon),
	    'heading': makeObjectPropertySetter(readDecimal),
	    'hotSpot': makeObjectPropertySetter(readVec2),
	    'scale': makeObjectPropertySetter(readScale)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function iconStyleParser(node, objectStack) {
	  // FIXME refreshMode
	  // FIXME refreshInterval
	  // FIXME viewRefreshTime
	  // FIXME viewBoundScale
	  // FIXME viewFormat
	  // FIXME httpQuery
	  var object = pushParseAndPop(
	    {}, ICON_STYLE_PARSERS, node, objectStack);
	  if (!object) {
	    return;
	  }
	  var styleObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  var IconObject = 'Icon' in object ? object['Icon'] : {};
	  var drawIcon = (!('Icon' in object) || Object.keys(IconObject).length > 0);
	  var src;
	  var href = /** @type {string|undefined} */
	      (IconObject['href']);
	  if (href) {
	    src = href;
	  } else if (drawIcon) {
	    src = DEFAULT_IMAGE_STYLE_SRC;
	  }
	  var anchor, anchorXUnits, anchorYUnits;
	  var anchorOrigin = IconOrigin.BOTTOM_LEFT;
	  var hotSpot = /** @type {Vec2|undefined} */
	      (object['hotSpot']);
	  if (hotSpot) {
	    anchor = [hotSpot.x, hotSpot.y];
	    anchorXUnits = hotSpot.xunits;
	    anchorYUnits = hotSpot.yunits;
	    anchorOrigin = hotSpot.origin;
	  } else if (src === DEFAULT_IMAGE_STYLE_SRC) {
	    anchor = DEFAULT_IMAGE_STYLE_ANCHOR;
	    anchorXUnits = DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
	    anchorYUnits = DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
	  } else if (/^http:\/\/maps\.(?:google|gstatic)\.com\//.test(src)) {
	    anchor = [0.5, 0];
	    anchorXUnits = IconAnchorUnits.FRACTION;
	    anchorYUnits = IconAnchorUnits.FRACTION;
	  }
	
	  var offset;
	  var x = /** @type {number|undefined} */
	      (IconObject['x']);
	  var y = /** @type {number|undefined} */
	      (IconObject['y']);
	  if (x !== undefined && y !== undefined) {
	    offset = [x, y];
	  }
	
	  var size;
	  var w = /** @type {number|undefined} */
	      (IconObject['w']);
	  var h = /** @type {number|undefined} */
	      (IconObject['h']);
	  if (w !== undefined && h !== undefined) {
	    size = [w, h];
	  }
	
	  var rotation;
	  var heading = /** @type {number} */
	      (object['heading']);
	  if (heading !== undefined) {
	    rotation = toRadians(heading);
	  }
	
	  var scale = /** @type {number|undefined} */
	      (object['scale']);
	
	  if (drawIcon) {
	    if (src == DEFAULT_IMAGE_STYLE_SRC) {
	      size = DEFAULT_IMAGE_STYLE_SIZE;
	      if (scale === undefined) {
	        scale = DEFAULT_IMAGE_SCALE_MULTIPLIER;
	      }
	    }
	
	    var imageStyle = new Icon({
	      anchor: anchor,
	      anchorOrigin: anchorOrigin,
	      anchorXUnits: anchorXUnits,
	      anchorYUnits: anchorYUnits,
	      crossOrigin: 'anonymous', // FIXME should this be configurable?
	      offset: offset,
	      offsetOrigin: IconOrigin.BOTTOM_LEFT,
	      rotation: rotation,
	      scale: scale,
	      size: size,
	      src: src
	    });
	    styleObject['imageStyle'] = imageStyle;
	  } else {
	    // handle the case when we explicitly want to draw no icon.
	    styleObject['imageStyle'] = DEFAULT_NO_IMAGE_STYLE;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LABEL_STYLE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'color': makeObjectPropertySetter(readColor),
	    'scale': makeObjectPropertySetter(readScale)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function labelStyleParser(node, objectStack) {
	  // FIXME colorMode
	  var object = pushParseAndPop(
	    {}, LABEL_STYLE_PARSERS, node, objectStack);
	  if (!object) {
	    return;
	  }
	  var styleObject = objectStack[objectStack.length - 1];
	  var textStyle = new Text({
	    fill: new Fill({
	      color: /** @type {import("../color.js").Color} */
	          ('color' in object ? object['color'] : DEFAULT_COLOR)
	    }),
	    scale: /** @type {number|undefined} */
	        (object['scale'])
	  });
	  styleObject['textStyle'] = textStyle;
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LINE_STYLE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'color': makeObjectPropertySetter(readColor),
	    'width': makeObjectPropertySetter(readDecimal)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function lineStyleParser(node, objectStack) {
	  // FIXME colorMode
	  // FIXME gx:outerColor
	  // FIXME gx:outerWidth
	  // FIXME gx:physicalWidth
	  // FIXME gx:labelVisibility
	  var object = pushParseAndPop(
	    {}, LINE_STYLE_PARSERS, node, objectStack);
	  if (!object) {
	    return;
	  }
	  var styleObject = objectStack[objectStack.length - 1];
	  var strokeStyle = new Stroke({
	    color: /** @type {import("../color.js").Color} */
	        ('color' in object ? object['color'] : DEFAULT_COLOR),
	    width: /** @type {number} */ ('width' in object ? object['width'] : 1)
	  });
	  styleObject['strokeStyle'] = strokeStyle;
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var POLY_STYLE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'color': makeObjectPropertySetter(readColor),
	    'fill': makeObjectPropertySetter(readBoolean),
	    'outline': makeObjectPropertySetter(readBoolean)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function polyStyleParser(node, objectStack) {
	  // FIXME colorMode
	  var object = pushParseAndPop(
	    {}, POLY_STYLE_PARSERS, node, objectStack);
	  if (!object) {
	    return;
	  }
	  var styleObject = objectStack[objectStack.length - 1];
	  var fillStyle = new Fill({
	    color: /** @type {import("../color.js").Color} */
	        ('color' in object ? object['color'] : DEFAULT_COLOR)
	  });
	  styleObject['fillStyle'] = fillStyle;
	  var fill = /** @type {boolean|undefined} */ (object['fill']);
	  if (fill !== undefined) {
	    styleObject['fill'] = fill;
	  }
	  var outline = /** @type {boolean|undefined} */ (object['outline']);
	  if (outline !== undefined) {
	    styleObject['outline'] = outline;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var FLAT_LINEAR_RING_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'coordinates': makeReplacer(readFlatCoordinates)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<number>} LinearRing flat coordinates.
	 */
	function readFlatLinearRing(node, objectStack) {
	  return pushParseAndPop(null,
	    FLAT_LINEAR_RING_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function gxCoordParser(node, objectStack) {
	  var gxTrackObject = /** @type {GxTrackObject} */
	      (objectStack[objectStack.length - 1]);
	  var flatCoordinates = gxTrackObject.flatCoordinates;
	  var s = getAllTextContent(node, false);
	  var re =
	      /^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i;
	  var m = re.exec(s);
	  if (m) {
	    var x = parseFloat(m[1]);
	    var y = parseFloat(m[2]);
	    var z = parseFloat(m[3]);
	    flatCoordinates.push(x, y, z, 0);
	  } else {
	    flatCoordinates.push(0, 0, 0, 0);
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var GX_MULTITRACK_GEOMETRY_PARSERS = makeStructureNS(
	  GX_NAMESPACE_URIS, {
	    'Track': makeArrayPusher(readGxTrack)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {MultiLineString|undefined} MultiLineString.
	 */
	function readGxMultiTrack(node, objectStack) {
	  var lineStrings = pushParseAndPop([],
	    GX_MULTITRACK_GEOMETRY_PARSERS, node, objectStack);
	  if (!lineStrings) {
	    return undefined;
	  }
	  return new MultiLineString(lineStrings);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var GX_TRACK_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'when': whenParser
	  }, makeStructureNS(
	    GX_NAMESPACE_URIS, {
	      'coord': gxCoordParser
	    }));
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {LineString|undefined} LineString.
	 */
	function readGxTrack(node, objectStack) {
	  var gxTrackObject = pushParseAndPop(
	    /** @type {GxTrackObject} */ ({
	      flatCoordinates: [],
	      whens: []
	    }), GX_TRACK_PARSERS, node, objectStack);
	  if (!gxTrackObject) {
	    return undefined;
	  }
	  var flatCoordinates = gxTrackObject.flatCoordinates;
	  var whens = gxTrackObject.whens;
	  for (var i = 0, ii = Math.min(flatCoordinates.length, whens.length); i < ii; ++i) {
	    flatCoordinates[4 * i + 3] = whens[i];
	  }
	  return new LineString(flatCoordinates, GeometryLayout.XYZM);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var ICON_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'href': makeObjectPropertySetter(readURI)
	  }, makeStructureNS(
	    GX_NAMESPACE_URIS, {
	      'x': makeObjectPropertySetter(readDecimal),
	      'y': makeObjectPropertySetter(readDecimal),
	      'w': makeObjectPropertySetter(readDecimal),
	      'h': makeObjectPropertySetter(readDecimal)
	    }));
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object} Icon object.
	 */
	function readIcon(node, objectStack) {
	  var iconObject = pushParseAndPop(
	    {}, ICON_PARSERS, node, objectStack);
	  if (iconObject) {
	    return iconObject;
	  } else {
	    return null;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var GEOMETRY_FLAT_COORDINATES_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'coordinates': makeReplacer(readFlatCoordinates)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<number>} Flat coordinates.
	 */
	function readFlatCoordinatesFromNode(node, objectStack) {
	  return pushParseAndPop(null,
	    GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var EXTRUDE_AND_ALTITUDE_MODE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'extrude': makeObjectPropertySetter(readBoolean),
	    'tessellate': makeObjectPropertySetter(readBoolean),
	    'altitudeMode': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {LineString|undefined} LineString.
	 */
	function readLineString(node, objectStack) {
	  var properties = pushParseAndPop({},
	    EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node,
	    objectStack);
	  var flatCoordinates =
	      readFlatCoordinatesFromNode(node, objectStack);
	  if (flatCoordinates) {
	    var lineString = new LineString(flatCoordinates, GeometryLayout.XYZ);
	    lineString.setProperties(properties);
	    return lineString;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Polygon|undefined} Polygon.
	 */
	function readLinearRing(node, objectStack) {
	  var properties = pushParseAndPop({},
	    EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node,
	    objectStack);
	  var flatCoordinates =
	      readFlatCoordinatesFromNode(node, objectStack);
	  if (flatCoordinates) {
	    var polygon = new Polygon(flatCoordinates, GeometryLayout.XYZ, [flatCoordinates.length]);
	    polygon.setProperties(properties);
	    return polygon;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var MULTI_GEOMETRY_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'LineString': makeArrayPusher(readLineString),
	    'LinearRing': makeArrayPusher(readLinearRing),
	    'MultiGeometry': makeArrayPusher(readMultiGeometry),
	    'Point': makeArrayPusher(readPoint),
	    'Polygon': makeArrayPusher(readPolygon)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {import("../geom/Geometry.js").default} Geometry.
	 */
	function readMultiGeometry(node, objectStack) {
	  var geometries = pushParseAndPop([],
	    MULTI_GEOMETRY_PARSERS, node, objectStack);
	  if (!geometries) {
	    return null;
	  }
	  if (geometries.length === 0) {
	    return new GeometryCollection(geometries);
	  }
	  var multiGeometry;
	  var homogeneous = true;
	  var type = geometries[0].getType();
	  var geometry;
	  for (var i = 1, ii = geometries.length; i < ii; ++i) {
	    geometry = geometries[i];
	    if (geometry.getType() != type) {
	      homogeneous = false;
	      break;
	    }
	  }
	  if (homogeneous) {
	    var layout;
	    var flatCoordinates;
	    if (type == GeometryType.POINT) {
	      var point = geometries[0];
	      layout = point.getLayout();
	      flatCoordinates = point.getFlatCoordinates();
	      for (var i$1 = 1, ii$1 = geometries.length; i$1 < ii$1; ++i$1) {
	        geometry = geometries[i$1];
	        extend(flatCoordinates, geometry.getFlatCoordinates());
	      }
	      multiGeometry = new MultiPoint(flatCoordinates, layout);
	      setCommonGeometryProperties(multiGeometry, geometries);
	    } else if (type == GeometryType.LINE_STRING) {
	      multiGeometry = new MultiLineString(geometries);
	      setCommonGeometryProperties(multiGeometry, geometries);
	    } else if (type == GeometryType.POLYGON) {
	      multiGeometry = new MultiPolygon(geometries);
	      setCommonGeometryProperties(multiGeometry, geometries);
	    } else if (type == GeometryType.GEOMETRY_COLLECTION) {
	      multiGeometry = new GeometryCollection(geometries);
	    } else {
	      assert(false, 37); // Unknown geometry type found
	    }
	  } else {
	    multiGeometry = new GeometryCollection(geometries);
	  }
	  return (
	    /** @type {import("../geom/Geometry.js").default} */ (multiGeometry)
	  );
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Point|undefined} Point.
	 */
	function readPoint(node, objectStack) {
	  var properties = pushParseAndPop({},
	    EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node,
	    objectStack);
	  var flatCoordinates =
	      readFlatCoordinatesFromNode(node, objectStack);
	  if (flatCoordinates) {
	    var point = new Point(flatCoordinates, GeometryLayout.XYZ);
	    point.setProperties(properties);
	    return point;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var FLAT_LINEAR_RINGS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'innerBoundaryIs': innerBoundaryIsParser,
	    'outerBoundaryIs': outerBoundaryIsParser
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Polygon|undefined} Polygon.
	 */
	function readPolygon(node, objectStack) {
	  var properties = pushParseAndPop(/** @type {Object<string,*>} */ ({}),
	    EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node,
	    objectStack);
	  var flatLinearRings = pushParseAndPop([null],
	    FLAT_LINEAR_RINGS_PARSERS, node, objectStack);
	  if (flatLinearRings && flatLinearRings[0]) {
	    var flatCoordinates = flatLinearRings[0];
	    var ends = [flatCoordinates.length];
	    for (var i = 1, ii = flatLinearRings.length; i < ii; ++i) {
	      extend(flatCoordinates, flatLinearRings[i]);
	      ends.push(flatCoordinates.length);
	    }
	    var polygon = new Polygon(flatCoordinates, GeometryLayout.XYZ, ends);
	    polygon.setProperties(properties);
	    return polygon;
	  } else {
	    return undefined;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var STYLE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'IconStyle': iconStyleParser,
	    'LabelStyle': labelStyleParser,
	    'LineStyle': lineStyleParser,
	    'PolyStyle': polyStyleParser
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<Style>} Style.
	 */
	function readStyle(node, objectStack) {
	  var styleObject = pushParseAndPop(
	    {}, STYLE_PARSERS, node, objectStack);
	  if (!styleObject) {
	    return null;
	  }
	  var fillStyle = /** @type {Fill} */
	      ('fillStyle' in styleObject ?
	        styleObject['fillStyle'] : DEFAULT_FILL_STYLE);
	  var fill = /** @type {boolean|undefined} */ (styleObject['fill']);
	  if (fill !== undefined && !fill) {
	    fillStyle = null;
	  }
	  var imageStyle;
	  if ('imageStyle' in styleObject) {
	    if (styleObject['imageStyle'] != DEFAULT_NO_IMAGE_STYLE) {
	      imageStyle = styleObject['imageStyle'];
	    }
	  } else {
	    imageStyle = DEFAULT_IMAGE_STYLE;
	  }
	  var textStyle = /** @type {Text} */
	      ('textStyle' in styleObject ?
	        styleObject['textStyle'] : DEFAULT_TEXT_STYLE);
	  var strokeStyle = /** @type {Stroke} */
	      ('strokeStyle' in styleObject ?
	        styleObject['strokeStyle'] : DEFAULT_STROKE_STYLE$1);
	  var outline = /** @type {boolean|undefined} */
	      (styleObject['outline']);
	  if (outline !== undefined && !outline) {
	    strokeStyle = null;
	  }
	  return [new Style({
	    fill: fillStyle,
	    image: imageStyle,
	    stroke: strokeStyle,
	    text: textStyle,
	    zIndex: undefined // FIXME
	  })];
	}
	
	
	/**
	 * Reads an array of geometries and creates arrays for common geometry
	 * properties. Then sets them to the multi geometry.
	 * @param {MultiPoint|MultiLineString|MultiPolygon} multiGeometry A multi-geometry.
	 * @param {Array<import("../geom/Geometry.js").default>} geometries List of geometries.
	 */
	function setCommonGeometryProperties(multiGeometry, geometries) {
	  var ii = geometries.length;
	  var extrudes = new Array(geometries.length);
	  var tessellates = new Array(geometries.length);
	  var altitudeModes = new Array(geometries.length);
	  var hasExtrude, hasTessellate, hasAltitudeMode;
	  hasExtrude = hasTessellate = hasAltitudeMode = false;
	  for (var i = 0; i < ii; ++i) {
	    var geometry = geometries[i];
	    extrudes[i] = geometry.get('extrude');
	    tessellates[i] = geometry.get('tessellate');
	    altitudeModes[i] = geometry.get('altitudeMode');
	    hasExtrude = hasExtrude || extrudes[i] !== undefined;
	    hasTessellate = hasTessellate || tessellates[i] !== undefined;
	    hasAltitudeMode = hasAltitudeMode || altitudeModes[i];
	  }
	  if (hasExtrude) {
	    multiGeometry.set('extrude', extrudes);
	  }
	  if (hasTessellate) {
	    multiGeometry.set('tessellate', tessellates);
	  }
	  if (hasAltitudeMode) {
	    multiGeometry.set('altitudeMode', altitudeModes);
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var DATA_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'displayName': makeObjectPropertySetter(readString),
	    'value': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function dataParser(node, objectStack) {
	  var name = node.getAttribute('name');
	  parseNode(DATA_PARSERS, node, objectStack);
	  var featureObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  if (name !== null) {
	    featureObject[name] = featureObject.value;
	  } else if (featureObject.displayName !== null) {
	    featureObject[featureObject.displayName] = featureObject.value;
	  }
	  delete featureObject['value'];
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var EXTENDED_DATA_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Data': dataParser,
	    'SchemaData': schemaDataParser
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function extendedDataParser(node, objectStack) {
	  parseNode(EXTENDED_DATA_PARSERS, node, objectStack);
	}
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function regionParser(node, objectStack) {
	  parseNode(REGION_PARSERS, node, objectStack);
	}
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PAIR_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Style': makeObjectPropertySetter(readStyle),
	    'key': makeObjectPropertySetter(readString),
	    'styleUrl': makeObjectPropertySetter(readURI)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function pairDataParser(node, objectStack) {
	  var pairObject = pushParseAndPop(
	    {}, PAIR_PARSERS, node, objectStack);
	  if (!pairObject) {
	    return;
	  }
	  var key = /** @type {string|undefined} */
	      (pairObject['key']);
	  if (key && key == 'normal') {
	    var styleUrl = /** @type {string|undefined} */
	        (pairObject['styleUrl']);
	    if (styleUrl) {
	      objectStack[objectStack.length - 1] = styleUrl;
	    }
	    var style = /** @type {Style} */
	        (pairObject['Style']);
	    if (style) {
	      objectStack[objectStack.length - 1] = style;
	    }
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function placemarkStyleMapParser(node, objectStack) {
	  var styleMapValue = readStyleMapValue(node, objectStack);
	  if (!styleMapValue) {
	    return;
	  }
	  var placemarkObject = objectStack[objectStack.length - 1];
	  if (Array.isArray(styleMapValue)) {
	    placemarkObject['Style'] = styleMapValue;
	  } else if (typeof styleMapValue === 'string') {
	    placemarkObject['styleUrl'] = styleMapValue;
	  } else {
	    assert(false, 38); // `styleMapValue` has an unknown type
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var SCHEMA_DATA_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'SimpleData': simpleDataParser
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function schemaDataParser(node, objectStack) {
	  parseNode(SCHEMA_DATA_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function simpleDataParser(node, objectStack) {
	  var name = node.getAttribute('name');
	  if (name !== null) {
	    var data = readString(node);
	    var featureObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	    featureObject[name] = data;
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LAT_LON_ALT_BOX_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'altitudeMode': makeObjectPropertySetter(readString),
	    'minAltitude': makeObjectPropertySetter(readDecimal),
	    'maxAltitude': makeObjectPropertySetter(readDecimal),
	    'north': makeObjectPropertySetter(readDecimal),
	    'south': makeObjectPropertySetter(readDecimal),
	    'east': makeObjectPropertySetter(readDecimal),
	    'west': makeObjectPropertySetter(readDecimal)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function latLonAltBoxParser(node, objectStack) {
	  var object = pushParseAndPop({}, LAT_LON_ALT_BOX_PARSERS, node, objectStack);
	  if (!object) {
	    return;
	  }
	  var regionObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  var extent = [
	    parseFloat(object['west']),
	    parseFloat(object['south']),
	    parseFloat(object['east']),
	    parseFloat(object['north'])
	  ];
	  regionObject['extent'] = extent;
	  regionObject['altitudeMode'] = object['altitudeMode'];
	  regionObject['minAltitude'] = parseFloat(object['minAltitude']);
	  regionObject['maxAltitude'] = parseFloat(object['maxAltitude']);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LOD_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'minLodPixels': makeObjectPropertySetter(readDecimal),
	    'maxLodPixels': makeObjectPropertySetter(readDecimal),
	    'minFadeExtent': makeObjectPropertySetter(readDecimal),
	    'maxFadeExtent': makeObjectPropertySetter(readDecimal)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function lodParser(node, objectStack) {
	  var object = pushParseAndPop({}, LOD_PARSERS, node, objectStack);
	  if (!object) {
	    return;
	  }
	  var lodObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  lodObject['minLodPixels'] = parseFloat(object['minLodPixels']);
	  lodObject['maxLodPixels'] = parseFloat(object['maxLodPixels']);
	  lodObject['minFadeExtent'] = parseFloat(object['minFadeExtent']);
	  lodObject['maxFadeExtent'] = parseFloat(object['maxFadeExtent']);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var INNER_BOUNDARY_IS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'LinearRing': makeReplacer(readFlatLinearRing)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function innerBoundaryIsParser(node, objectStack) {
	  /** @type {Array<number>|undefined} */
	  var flatLinearRing = pushParseAndPop(undefined,
	    INNER_BOUNDARY_IS_PARSERS, node, objectStack);
	  if (flatLinearRing) {
	    var flatLinearRings = /** @type {Array<Array<number>>} */
	        (objectStack[objectStack.length - 1]);
	    flatLinearRings.push(flatLinearRing);
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var OUTER_BOUNDARY_IS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'LinearRing': makeReplacer(readFlatLinearRing)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function outerBoundaryIsParser(node, objectStack) {
	  /** @type {Array<number>|undefined} */
	  var flatLinearRing = pushParseAndPop(undefined,
	    OUTER_BOUNDARY_IS_PARSERS, node, objectStack);
	  if (flatLinearRing) {
	    var flatLinearRings = /** @type {Array<Array<number>>} */
	        (objectStack[objectStack.length - 1]);
	    flatLinearRings[0] = flatLinearRing;
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function linkParser(node, objectStack) {
	  parseNode(LINK_PARSERS$1, node, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function whenParser(node, objectStack) {
	  var gxTrackObject = /** @type {GxTrackObject} */
	      (objectStack[objectStack.length - 1]);
	  var whens = gxTrackObject.whens;
	  var s = getAllTextContent(node, false);
	  var when = Date.parse(s);
	  whens.push(isNaN(when) ? 0 : when);
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the color to.
	 * @param {import("../color.js").Color|string} color Color.
	 */
	function writeColorTextNode(node, color) {
	  var rgba = asArray(color);
	  var opacity = (rgba.length == 4) ? rgba[3] : 1;
	  /** @type {Array<string|number>} */
	  var abgr = [opacity * 255, rgba[2], rgba[1], rgba[0]];
	  for (var i = 0; i < 4; ++i) {
	    var hex = Math.floor(/** @type {number} */ (abgr[i])).toString(16);
	    abgr[i] = (hex.length == 1) ? '0' + hex : hex;
	  }
	  writeStringTextNode(node, abgr.join(''));
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the coordinates to.
	 * @param {Array<number>} coordinates Coordinates.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeCoordinatesTextNode(node, coordinates, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	
	  var layout = context['layout'];
	  var stride = context['stride'];
	
	  var dimension;
	  if (layout == GeometryLayout.XY ||
	      layout == GeometryLayout.XYM) {
	    dimension = 2;
	  } else if (layout == GeometryLayout.XYZ ||
	      layout == GeometryLayout.XYZM) {
	    dimension = 3;
	  } else {
	    assert(false, 34); // Invalid geometry layout
	  }
	
	  var ii = coordinates.length;
	  var text = '';
	  if (ii > 0) {
	    text += coordinates[0];
	    for (var d = 1; d < dimension; ++d) {
	      text += ',' + coordinates[d];
	    }
	    for (var i = stride; i < ii; i += stride) {
	      text += ' ' + coordinates[i];
	      for (var d$1 = 1; d$1 < dimension; ++d$1) {
	        text += ',' + coordinates[i + d$1];
	      }
	    }
	  }
	  writeStringTextNode(node, text);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var EXTENDEDDATA_NODE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Data': makeChildAppender(writeDataNode),
	    'value': makeChildAppender(writeDataNodeValue),
	    'displayName': makeChildAppender(writeDataNodeName)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {{name: *, value: *}} pair Name value pair.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeDataNode(node, pair, objectStack) {
	  node.setAttribute('name', pair.name);
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var value = pair.value;
	
	  if (typeof value == 'object') {
	    if (value !== null && value.displayName) {
	      pushSerializeAndPop(context, EXTENDEDDATA_NODE_SERIALIZERS,
	        OBJECT_PROPERTY_NODE_FACTORY, [value.displayName], objectStack, ['displayName']);
	    }
	
	    if (value !== null && value.value) {
	      pushSerializeAndPop(context, EXTENDEDDATA_NODE_SERIALIZERS,
	        OBJECT_PROPERTY_NODE_FACTORY, [value.value], objectStack, ['value']);
	    }
	  } else {
	    pushSerializeAndPop(context, EXTENDEDDATA_NODE_SERIALIZERS,
	      OBJECT_PROPERTY_NODE_FACTORY, [value], objectStack, ['value']);
	  }
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the name to.
	 * @param {string} name DisplayName.
	 */
	function writeDataNodeName(node, name) {
	  writeCDATASection(node, name);
	}
	
	
	/**
	 * @param {Node} node Node to append a CDATA Section with the value to.
	 * @param {string} value Value.
	 */
	function writeDataNodeValue(node, value) {
	  writeStringTextNode(node, value);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var DOCUMENT_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Placemark': makeChildAppender(writePlacemark)
	  });
	
	
	/**
	 * @const
	 * @param {*} value Value.
	 * @param {Array<*>} objectStack Object stack.
	 * @param {string=} opt_nodeName Node name.
	 * @return {Node|undefined} Node.
	 */
	var DOCUMENT_NODE_FACTORY = function(value, objectStack, opt_nodeName) {
	  var parentNode = objectStack[objectStack.length - 1].node;
	  return createElementNS(parentNode.namespaceURI, 'Placemark');
	};
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<Feature>} features Features.
	 * @param {Array<*>} objectStack Object stack.
	 * @this {KML}
	 */
	function writeDocument(node, features, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  pushSerializeAndPop(context, DOCUMENT_SERIALIZERS,
	    DOCUMENT_NODE_FACTORY, features, objectStack, undefined,
	    this);
	}
	
	
	/**
	 * A factory for creating Data nodes.
	 * @const
	 * @type {function(*, Array<*>): (Node|undefined)}
	 */
	var DATA_NODE_FACTORY = makeSimpleNodeFactory('Data');
	
	
	/**
	 * @param {Node} node Node.
	 * @param {{names: Array<string>, values: (Array<*>)}} namesAndValues Names and values.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeExtendedData(node, namesAndValues, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var names = namesAndValues.names;
	  var values = namesAndValues.values;
	  var length = names.length;
	
	  for (var i = 0; i < length; i++) {
	    pushSerializeAndPop(context, EXTENDEDDATA_NODE_SERIALIZERS,
	      DATA_NODE_FACTORY, [{name: names[i], value: values[i]}], objectStack);
	  }
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var ICON_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'href'
	  ],
	  makeStructureNS(GX_NAMESPACE_URIS, [
	    'x', 'y', 'w', 'h'
	  ]));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var ICON_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'href': makeChildAppender(writeStringTextNode)
	  }, makeStructureNS(
	    GX_NAMESPACE_URIS, {
	      'x': makeChildAppender(writeDecimalTextNode),
	      'y': makeChildAppender(writeDecimalTextNode),
	      'w': makeChildAppender(writeDecimalTextNode),
	      'h': makeChildAppender(writeDecimalTextNode)
	    }));
	
	
	/**
	 * @const
	 * @param {*} value Value.
	 * @param {Array<*>} objectStack Object stack.
	 * @param {string=} opt_nodeName Node name.
	 * @return {Node|undefined} Node.
	 */
	var GX_NODE_FACTORY = function(value, objectStack, opt_nodeName) {
	  return createElementNS(GX_NAMESPACE_URIS[0],
	    'gx:' + opt_nodeName);
	};
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Object} icon Icon object.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeIcon(node, icon, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = ICON_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(icon, orderedKeys);
	  pushSerializeAndPop(context,
	    ICON_SERIALIZERS, OBJECT_PROPERTY_NODE_FACTORY,
	    values, objectStack, orderedKeys);
	  orderedKeys =
	      ICON_SEQUENCE[GX_NAMESPACE_URIS[0]];
	  values = makeSequence(icon, orderedKeys);
	  pushSerializeAndPop(context, ICON_SERIALIZERS,
	    GX_NODE_FACTORY, values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var ICON_STYLE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'scale', 'heading', 'Icon', 'hotSpot'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var ICON_STYLE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'Icon': makeChildAppender(writeIcon),
	    'heading': makeChildAppender(writeDecimalTextNode),
	    'hotSpot': makeChildAppender(writeVec2),
	    'scale': makeChildAppender(writeScaleTextNode)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("../style/Icon.js").default} style Icon style.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeIconStyle(node, style, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var properties = {};
	  var src = style.getSrc();
	  var size = style.getSize();
	  var iconImageSize = style.getImageSize();
	  var iconProperties = {
	    'href': src
	  };
	
	  if (size) {
	    iconProperties['w'] = size[0];
	    iconProperties['h'] = size[1];
	    var anchor = style.getAnchor(); // top-left
	    var origin = style.getOrigin(); // top-left
	
	    if (origin && iconImageSize && origin[0] !== 0 && origin[1] !== size[1]) {
	      iconProperties['x'] = origin[0];
	      iconProperties['y'] = iconImageSize[1] - (origin[1] + size[1]);
	    }
	
	    if (anchor && (anchor[0] !== size[0] / 2 || anchor[1] !== size[1] / 2)) {
	      var /** @type {Vec2} */ hotSpot = {
	        x: anchor[0],
	        xunits: IconAnchorUnits.PIXELS,
	        y: size[1] - anchor[1],
	        yunits: IconAnchorUnits.PIXELS
	      };
	      properties['hotSpot'] = hotSpot;
	    }
	  }
	
	  properties['Icon'] = iconProperties;
	
	  var scale = style.getScale();
	  if (scale !== 1) {
	    properties['scale'] = scale;
	  }
	
	  var rotation = style.getRotation();
	  if (rotation !== 0) {
	    properties['heading'] = rotation; // 0-360
	  }
	
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = ICON_STYLE_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context, ICON_STYLE_SERIALIZERS,
	    OBJECT_PROPERTY_NODE_FACTORY, values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var LABEL_STYLE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'color', 'scale'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var LABEL_STYLE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'color': makeChildAppender(writeColorTextNode),
	    'scale': makeChildAppender(writeScaleTextNode)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Text} style style.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeLabelStyle(node, style, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var properties = {};
	  var fill = style.getFill();
	  if (fill) {
	    properties['color'] = fill.getColor();
	  }
	  var scale = style.getScale();
	  if (scale && scale !== 1) {
	    properties['scale'] = scale;
	  }
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys =
	      LABEL_STYLE_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context, LABEL_STYLE_SERIALIZERS,
	    OBJECT_PROPERTY_NODE_FACTORY, values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var LINE_STYLE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'color', 'width'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var LINE_STYLE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'color': makeChildAppender(writeColorTextNode),
	    'width': makeChildAppender(writeDecimalTextNode)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Stroke} style style.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeLineStyle(node, style, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var properties = {
	    'color': style.getColor(),
	    'width': style.getWidth()
	  };
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = LINE_STYLE_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context, LINE_STYLE_SERIALIZERS,
	    OBJECT_PROPERTY_NODE_FACTORY, values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, string>}
	 */
	var GEOMETRY_TYPE_TO_NODENAME$1 = {
	  'Point': 'Point',
	  'LineString': 'LineString',
	  'LinearRing': 'LinearRing',
	  'Polygon': 'Polygon',
	  'MultiPoint': 'MultiGeometry',
	  'MultiLineString': 'MultiGeometry',
	  'MultiPolygon': 'MultiGeometry',
	  'GeometryCollection': 'MultiGeometry'
	};
	
	
	/**
	 * @const
	 * @param {*} value Value.
	 * @param {Array<*>} objectStack Object stack.
	 * @param {string=} opt_nodeName Node name.
	 * @return {Node|undefined} Node.
	 */
	var GEOMETRY_NODE_FACTORY = function(value, objectStack, opt_nodeName) {
	  if (value) {
	    var parentNode = objectStack[objectStack.length - 1].node;
	    return createElementNS(parentNode.namespaceURI,
	      GEOMETRY_TYPE_TO_NODENAME$1[/** @type {import("../geom/Geometry.js").default} */ (value).getType()]);
	  }
	};
	
	
	/**
	 * A factory for creating Point nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var POINT_NODE_FACTORY = makeSimpleNodeFactory('Point');
	
	
	/**
	 * A factory for creating LineString nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var LINE_STRING_NODE_FACTORY = makeSimpleNodeFactory('LineString');
	
	
	/**
	 * A factory for creating LinearRing nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var LINEAR_RING_NODE_FACTORY = makeSimpleNodeFactory('LinearRing');
	
	
	/**
	 * A factory for creating Polygon nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var POLYGON_NODE_FACTORY = makeSimpleNodeFactory('Polygon');
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var MULTI_GEOMETRY_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'LineString': makeChildAppender(
	      writePrimitiveGeometry),
	    'Point': makeChildAppender(
	      writePrimitiveGeometry),
	    'Polygon': makeChildAppender(writePolygon),
	    'GeometryCollection': makeChildAppender(
	      writeMultiGeometry)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeMultiGeometry(node, geometry, objectStack) {
	  /** @type {import("../xml.js").NodeStackItem} */
	  var context = {node: node};
	  var type = geometry.getType();
	  /** @type {Array<import("../geom/Geometry.js").default>} */
	  var geometries;
	  /** @type {function(*, Array<*>, string=): (Node|undefined)} */
	  var factory;
	  if (type == GeometryType.GEOMETRY_COLLECTION) {
	    geometries = /** @type {GeometryCollection} */ (geometry).getGeometries();
	    factory = GEOMETRY_NODE_FACTORY;
	  } else if (type == GeometryType.MULTI_POINT) {
	    geometries = /** @type {MultiPoint} */ (geometry).getPoints();
	    factory = POINT_NODE_FACTORY;
	  } else if (type == GeometryType.MULTI_LINE_STRING) {
	    geometries =
	        (/** @type {MultiLineString} */ (geometry)).getLineStrings();
	    factory = LINE_STRING_NODE_FACTORY;
	  } else if (type == GeometryType.MULTI_POLYGON) {
	    geometries =
	        (/** @type {MultiPolygon} */ (geometry)).getPolygons();
	    factory = POLYGON_NODE_FACTORY;
	  } else {
	    assert(false, 39); // Unknown geometry type
	  }
	  pushSerializeAndPop(context,
	    MULTI_GEOMETRY_SERIALIZERS, factory,
	    geometries, objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var BOUNDARY_IS_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'LinearRing': makeChildAppender(
	      writePrimitiveGeometry)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("../geom/LinearRing.js").default} linearRing Linear ring.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeBoundaryIs(node, linearRing, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  pushSerializeAndPop(context,
	    BOUNDARY_IS_SERIALIZERS,
	    LINEAR_RING_NODE_FACTORY, [linearRing], objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var PLACEMARK_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'ExtendedData': makeChildAppender(writeExtendedData),
	    'MultiGeometry': makeChildAppender(writeMultiGeometry),
	    'LineString': makeChildAppender(writePrimitiveGeometry),
	    'LinearRing': makeChildAppender(writePrimitiveGeometry),
	    'Point': makeChildAppender(writePrimitiveGeometry),
	    'Polygon': makeChildAppender(writePolygon),
	    'Style': makeChildAppender(writeStyle),
	    'address': makeChildAppender(writeStringTextNode),
	    'description': makeChildAppender(writeStringTextNode),
	    'name': makeChildAppender(writeStringTextNode),
	    'open': makeChildAppender(writeBooleanTextNode),
	    'phoneNumber': makeChildAppender(writeStringTextNode),
	    'styleUrl': makeChildAppender(writeStringTextNode),
	    'visibility': makeChildAppender(writeBooleanTextNode)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var PLACEMARK_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'name', 'open', 'visibility', 'address', 'phoneNumber', 'description',
	    'styleUrl', 'Style'
	  ]);
	
	
	/**
	 * A factory for creating ExtendedData nodes.
	 * @const
	 * @type {function(*, Array<*>): (Node|undefined)}
	 */
	var EXTENDEDDATA_NODE_FACTORY = makeSimpleNodeFactory('ExtendedData');
	
	
	/**
	 * FIXME currently we do serialize arbitrary/custom feature properties
	 * (ExtendedData).
	 * @param {Element} node Node.
	 * @param {Feature} feature Feature.
	 * @param {Array<*>} objectStack Object stack.
	 * @this {KML}
	 */
	function writePlacemark(node, feature, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	
	  // set id
	  if (feature.getId()) {
	    node.setAttribute('id', /** @type {string} */ (feature.getId()));
	  }
	
	  // serialize properties (properties unknown to KML are not serialized)
	  var properties = feature.getProperties();
	
	  // don't export these to ExtendedData
	  var filter = {'address': 1, 'description': 1, 'name': 1, 'open': 1,
	    'phoneNumber': 1, 'styleUrl': 1, 'visibility': 1};
	  filter[feature.getGeometryName()] = 1;
	  var keys = Object.keys(properties || {}).sort().filter(function(v) {
	    return !filter[v];
	  });
	
	  if (keys.length > 0) {
	    var sequence = makeSequence(properties, keys);
	    var namesAndValues = {names: keys, values: sequence};
	    pushSerializeAndPop(context, PLACEMARK_SERIALIZERS,
	      EXTENDEDDATA_NODE_FACTORY, [namesAndValues], objectStack);
	  }
	
	  var styleFunction = feature.getStyleFunction();
	  if (styleFunction) {
	    // FIXME the styles returned by the style function are supposed to be
	    // resolution-independent here
	    var styles = styleFunction(feature, 0);
	    if (styles) {
	      var style = Array.isArray(styles) ? styles[0] : styles;
	      if (this.writeStyles_) {
	        properties['Style'] = style;
	      }
	      var textStyle = style.getText();
	      if (textStyle) {
	        properties['name'] = textStyle.getText();
	      }
	    }
	  }
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = PLACEMARK_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context, PLACEMARK_SERIALIZERS,
	    OBJECT_PROPERTY_NODE_FACTORY, values, objectStack, orderedKeys);
	
	  // serialize geometry
	  var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
	  var geometry = feature.getGeometry();
	  if (geometry) {
	    geometry = /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geometry, true, options));
	  }
	  pushSerializeAndPop(context, PLACEMARK_SERIALIZERS,
	    GEOMETRY_NODE_FACTORY, [geometry], objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var PRIMITIVE_GEOMETRY_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'extrude', 'tessellate', 'altitudeMode', 'coordinates'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var PRIMITIVE_GEOMETRY_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'extrude': makeChildAppender(writeBooleanTextNode),
	    'tessellate': makeChildAppender(writeBooleanTextNode),
	    'altitudeMode': makeChildAppender(writeStringTextNode),
	    'coordinates': makeChildAppender(writeCoordinatesTextNode)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writePrimitiveGeometry(node, geometry, objectStack) {
	  var flatCoordinates = geometry.getFlatCoordinates();
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  context['layout'] = geometry.getLayout();
	  context['stride'] = geometry.getStride();
	
	  // serialize properties (properties unknown to KML are not serialized)
	  var properties = geometry.getProperties();
	  properties.coordinates = flatCoordinates;
	
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = PRIMITIVE_GEOMETRY_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context, PRIMITIVE_GEOMETRY_SERIALIZERS,
	    OBJECT_PROPERTY_NODE_FACTORY, values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var POLYGON_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'outerBoundaryIs': makeChildAppender(
	      writeBoundaryIs),
	    'innerBoundaryIs': makeChildAppender(
	      writeBoundaryIs)
	  });
	
	
	/**
	 * A factory for creating innerBoundaryIs nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var INNER_BOUNDARY_NODE_FACTORY = makeSimpleNodeFactory('innerBoundaryIs');
	
	
	/**
	 * A factory for creating outerBoundaryIs nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var OUTER_BOUNDARY_NODE_FACTORY = makeSimpleNodeFactory('outerBoundaryIs');
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Polygon} polygon Polygon.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writePolygon(node, polygon, objectStack) {
	  var linearRings = polygon.getLinearRings();
	  var outerRing = linearRings.shift();
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  // inner rings
	  pushSerializeAndPop(context,
	    POLYGON_SERIALIZERS,
	    INNER_BOUNDARY_NODE_FACTORY,
	    linearRings, objectStack);
	  // outer ring
	  pushSerializeAndPop(context,
	    POLYGON_SERIALIZERS,
	    OUTER_BOUNDARY_NODE_FACTORY,
	    [outerRing], objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var POLY_STYLE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'color': makeChildAppender(writeColorTextNode)
	  });
	
	
	/**
	 * A factory for creating coordinates nodes.
	 * @const
	 * @type {function(*, Array<*>, string=): (Node|undefined)}
	 */
	var COLOR_NODE_FACTORY = makeSimpleNodeFactory('color');
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Fill} style Style.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writePolyStyle(node, style, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  pushSerializeAndPop(context, POLY_STYLE_SERIALIZERS,
	    COLOR_NODE_FACTORY, [style.getColor()], objectStack);
	}
	
	
	/**
	 * @param {Node} node Node to append a TextNode with the scale to.
	 * @param {number|undefined} scale Scale.
	 */
	function writeScaleTextNode(node, scale) {
	  // the Math is to remove any excess decimals created by float arithmetic
	  writeDecimalTextNode(node,
	    Math.round(scale * 1e6) / 1e6);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Array<string>>}
	 */
	var STYLE_SEQUENCE = makeStructureNS(
	  NAMESPACE_URIS$1, [
	    'IconStyle', 'LabelStyle', 'LineStyle', 'PolyStyle'
	  ]);
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var STYLE_SERIALIZERS = makeStructureNS(
	  NAMESPACE_URIS$1, {
	    'IconStyle': makeChildAppender(writeIconStyle),
	    'LabelStyle': makeChildAppender(writeLabelStyle),
	    'LineStyle': makeChildAppender(writeLineStyle),
	    'PolyStyle': makeChildAppender(writePolyStyle)
	  });
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Style} style Style.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function writeStyle(node, style, objectStack) {
	  var /** @type {import("../xml.js").NodeStackItem} */ context = {node: node};
	  var properties = {};
	  var fillStyle = style.getFill();
	  var strokeStyle = style.getStroke();
	  var imageStyle = style.getImage();
	  var textStyle = style.getText();
	  if (imageStyle && typeof /** @type {?} */ (imageStyle).getSrc === 'function') {
	    properties['IconStyle'] = imageStyle;
	  }
	  if (textStyle) {
	    properties['LabelStyle'] = textStyle;
	  }
	  if (strokeStyle) {
	    properties['LineStyle'] = strokeStyle;
	  }
	  if (fillStyle) {
	    properties['PolyStyle'] = fillStyle;
	  }
	  var parentNode = objectStack[objectStack.length - 1].node;
	  var orderedKeys = STYLE_SEQUENCE[parentNode.namespaceURI];
	  var values = makeSequence(properties, orderedKeys);
	  pushSerializeAndPop(context, STYLE_SERIALIZERS,
	    OBJECT_PROPERTY_NODE_FACTORY, values, objectStack, orderedKeys);
	}
	
	
	/**
	 * @param {Element} node Node to append a TextNode with the Vec2 to.
	 * @param {Vec2} vec2 Vec2.
	 */
	function writeVec2(node, vec2) {
	  node.setAttribute('x', String(vec2.x));
	  node.setAttribute('y', String(vec2.y));
	  node.setAttribute('xunits', vec2.xunits);
	  node.setAttribute('yunits', vec2.yunits);
	}
	
	var read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? (nBytes - 1) : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & ((1 << (-nBits)) - 1);
	  s >>= (-nBits);
	  nBits += eLen;
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1);
	  e >>= (-nBits);
	  nBits += mLen;
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	};
	
	var write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	  var i = isLE ? 0 : (nBytes - 1);
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};
	
	var ieee754 = {
		read: read,
		write: write
	};
	
	var pbf = Pbf;
	
	
	
	function Pbf(buf) {
	    this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
	    this.pos = 0;
	    this.type = 0;
	    this.length = this.buf.length;
	}
	
	Pbf.Varint  = 0; // varint: int32, int64, uint32, uint64, sint32, sint64, bool, enum
	Pbf.Fixed64 = 1; // 64-bit: double, fixed64, sfixed64
	Pbf.Bytes   = 2; // length-delimited: string, bytes, embedded messages, packed repeated fields
	Pbf.Fixed32 = 5; // 32-bit: float, fixed32, sfixed32
	
	var SHIFT_LEFT_32 = (1 << 16) * (1 << 16),
	    SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;
	
	Pbf.prototype = {
	
	    destroy: function() {
	        this.buf = null;
	    },
	
	    // === READING =================================================================
	
	    readFields: function(readField, result, end) {
	        end = end || this.length;
	
	        while (this.pos < end) {
	            var val = this.readVarint(),
	                tag = val >> 3,
	                startPos = this.pos;
	
	            this.type = val & 0x7;
	            readField(tag, result, this);
	
	            if (this.pos === startPos) { this.skip(val); }
	        }
	        return result;
	    },
	
	    readMessage: function(readField, result) {
	        return this.readFields(readField, result, this.readVarint() + this.pos);
	    },
	
	    readFixed32: function() {
	        var val = readUInt32(this.buf, this.pos);
	        this.pos += 4;
	        return val;
	    },
	
	    readSFixed32: function() {
	        var val = readInt32(this.buf, this.pos);
	        this.pos += 4;
	        return val;
	    },
	
	    // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
	
	    readFixed64: function() {
	        var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
	        this.pos += 8;
	        return val;
	    },
	
	    readSFixed64: function() {
	        var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
	        this.pos += 8;
	        return val;
	    },
	
	    readFloat: function() {
	        var val = ieee754.read(this.buf, this.pos, true, 23, 4);
	        this.pos += 4;
	        return val;
	    },
	
	    readDouble: function() {
	        var val = ieee754.read(this.buf, this.pos, true, 52, 8);
	        this.pos += 8;
	        return val;
	    },
	
	    readVarint: function(isSigned) {
	        var buf = this.buf,
	            val, b;
	
	        b = buf[this.pos++]; val  =  b & 0x7f;        if (b < 0x80) { return val; }
	        b = buf[this.pos++]; val |= (b & 0x7f) << 7;  if (b < 0x80) { return val; }
	        b = buf[this.pos++]; val |= (b & 0x7f) << 14; if (b < 0x80) { return val; }
	        b = buf[this.pos++]; val |= (b & 0x7f) << 21; if (b < 0x80) { return val; }
	        b = buf[this.pos];   val |= (b & 0x0f) << 28;
	
	        return readVarintRemainder(val, isSigned, this);
	    },
	
	    readVarint64: function() { // for compatibility with v2.0.1
	        return this.readVarint(true);
	    },
	
	    readSVarint: function() {
	        var num = this.readVarint();
	        return num % 2 === 1 ? (num + 1) / -2 : num / 2; // zigzag encoding
	    },
	
	    readBoolean: function() {
	        return Boolean(this.readVarint());
	    },
	
	    readString: function() {
	        var end = this.readVarint() + this.pos,
	            str = readUtf8(this.buf, this.pos, end);
	        this.pos = end;
	        return str;
	    },
	
	    readBytes: function() {
	        var end = this.readVarint() + this.pos,
	            buffer = this.buf.subarray(this.pos, end);
	        this.pos = end;
	        return buffer;
	    },
	
	    // verbose for performance reasons; doesn't affect gzipped size
	
	    readPackedVarint: function(arr, isSigned) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readVarint(isSigned)); }
	        return arr;
	    },
	    readPackedSVarint: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readSVarint()); }
	        return arr;
	    },
	    readPackedBoolean: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readBoolean()); }
	        return arr;
	    },
	    readPackedFloat: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readFloat()); }
	        return arr;
	    },
	    readPackedDouble: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readDouble()); }
	        return arr;
	    },
	    readPackedFixed32: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readFixed32()); }
	        return arr;
	    },
	    readPackedSFixed32: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readSFixed32()); }
	        return arr;
	    },
	    readPackedFixed64: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readFixed64()); }
	        return arr;
	    },
	    readPackedSFixed64: function(arr) {
	        var end = readPackedEnd(this);
	        arr = arr || [];
	        while (this.pos < end) { arr.push(this.readSFixed64()); }
	        return arr;
	    },
	
	    skip: function(val) {
	        var type = val & 0x7;
	        if (type === Pbf.Varint) { while (this.buf[this.pos++] > 0x7f) {} }
	        else if (type === Pbf.Bytes) { this.pos = this.readVarint() + this.pos; }
	        else if (type === Pbf.Fixed32) { this.pos += 4; }
	        else if (type === Pbf.Fixed64) { this.pos += 8; }
	        else { throw new Error('Unimplemented type: ' + type); }
	    },
	
	    // === WRITING =================================================================
	
	    writeTag: function(tag, type) {
	        this.writeVarint((tag << 3) | type);
	    },
	
	    realloc: function(min) {
	        var length = this.length || 16;
	
	        while (length < this.pos + min) { length *= 2; }
	
	        if (length !== this.length) {
	            var buf = new Uint8Array(length);
	            buf.set(this.buf);
	            this.buf = buf;
	            this.length = length;
	        }
	    },
	
	    finish: function() {
	        this.length = this.pos;
	        this.pos = 0;
	        return this.buf.subarray(0, this.length);
	    },
	
	    writeFixed32: function(val) {
	        this.realloc(4);
	        writeInt32(this.buf, val, this.pos);
	        this.pos += 4;
	    },
	
	    writeSFixed32: function(val) {
	        this.realloc(4);
	        writeInt32(this.buf, val, this.pos);
	        this.pos += 4;
	    },
	
	    writeFixed64: function(val) {
	        this.realloc(8);
	        writeInt32(this.buf, val & -1, this.pos);
	        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
	        this.pos += 8;
	    },
	
	    writeSFixed64: function(val) {
	        this.realloc(8);
	        writeInt32(this.buf, val & -1, this.pos);
	        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
	        this.pos += 8;
	    },
	
	    writeVarint: function(val) {
	        val = +val || 0;
	
	        if (val > 0xfffffff || val < 0) {
	            writeBigVarint(val, this);
	            return;
	        }
	
	        this.realloc(4);
	
	        this.buf[this.pos++] =           val & 0x7f  | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) { return; }
	        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) { return; }
	        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) { return; }
	        this.buf[this.pos++] =   (val >>> 7) & 0x7f;
	    },
	
	    writeSVarint: function(val) {
	        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
	    },
	
	    writeBoolean: function(val) {
	        this.writeVarint(Boolean(val));
	    },
	
	    writeString: function(str) {
	        str = String(str);
	        this.realloc(str.length * 4);
	
	        this.pos++; // reserve 1 byte for short string length
	
	        var startPos = this.pos;
	        // write the string directly to the buffer and see how much was written
	        this.pos = writeUtf8(this.buf, str, this.pos);
	        var len = this.pos - startPos;
	
	        if (len >= 0x80) { makeRoomForExtraLength(startPos, len, this); }
	
	        // finally, write the message length in the reserved place and restore the position
	        this.pos = startPos - 1;
	        this.writeVarint(len);
	        this.pos += len;
	    },
	
	    writeFloat: function(val) {
	        this.realloc(4);
	        ieee754.write(this.buf, val, this.pos, true, 23, 4);
	        this.pos += 4;
	    },
	
	    writeDouble: function(val) {
	        this.realloc(8);
	        ieee754.write(this.buf, val, this.pos, true, 52, 8);
	        this.pos += 8;
	    },
	
	    writeBytes: function(buffer) {
	        var len = buffer.length;
	        this.writeVarint(len);
	        this.realloc(len);
	        for (var i = 0; i < len; i++) { this.buf[this.pos++] = buffer[i]; }
	    },
	
	    writeRawMessage: function(fn, obj) {
	        this.pos++; // reserve 1 byte for short message length
	
	        // write the message directly to the buffer and see how much was written
	        var startPos = this.pos;
	        fn(obj, this);
	        var len = this.pos - startPos;
	
	        if (len >= 0x80) { makeRoomForExtraLength(startPos, len, this); }
	
	        // finally, write the message length in the reserved place and restore the position
	        this.pos = startPos - 1;
	        this.writeVarint(len);
	        this.pos += len;
	    },
	
	    writeMessage: function(tag, fn, obj) {
	        this.writeTag(tag, Pbf.Bytes);
	        this.writeRawMessage(fn, obj);
	    },
	
	    writePackedVarint:   function(tag, arr) { this.writeMessage(tag, writePackedVarint, arr);   },
	    writePackedSVarint:  function(tag, arr) { this.writeMessage(tag, writePackedSVarint, arr);  },
	    writePackedBoolean:  function(tag, arr) { this.writeMessage(tag, writePackedBoolean, arr);  },
	    writePackedFloat:    function(tag, arr) { this.writeMessage(tag, writePackedFloat, arr);    },
	    writePackedDouble:   function(tag, arr) { this.writeMessage(tag, writePackedDouble, arr);   },
	    writePackedFixed32:  function(tag, arr) { this.writeMessage(tag, writePackedFixed32, arr);  },
	    writePackedSFixed32: function(tag, arr) { this.writeMessage(tag, writePackedSFixed32, arr); },
	    writePackedFixed64:  function(tag, arr) { this.writeMessage(tag, writePackedFixed64, arr);  },
	    writePackedSFixed64: function(tag, arr) { this.writeMessage(tag, writePackedSFixed64, arr); },
	
	    writeBytesField: function(tag, buffer) {
	        this.writeTag(tag, Pbf.Bytes);
	        this.writeBytes(buffer);
	    },
	    writeFixed32Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed32);
	        this.writeFixed32(val);
	    },
	    writeSFixed32Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed32);
	        this.writeSFixed32(val);
	    },
	    writeFixed64Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed64);
	        this.writeFixed64(val);
	    },
	    writeSFixed64Field: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed64);
	        this.writeSFixed64(val);
	    },
	    writeVarintField: function(tag, val) {
	        this.writeTag(tag, Pbf.Varint);
	        this.writeVarint(val);
	    },
	    writeSVarintField: function(tag, val) {
	        this.writeTag(tag, Pbf.Varint);
	        this.writeSVarint(val);
	    },
	    writeStringField: function(tag, str) {
	        this.writeTag(tag, Pbf.Bytes);
	        this.writeString(str);
	    },
	    writeFloatField: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed32);
	        this.writeFloat(val);
	    },
	    writeDoubleField: function(tag, val) {
	        this.writeTag(tag, Pbf.Fixed64);
	        this.writeDouble(val);
	    },
	    writeBooleanField: function(tag, val) {
	        this.writeVarintField(tag, Boolean(val));
	    }
	};
	
	function readVarintRemainder(l, s, p) {
	    var buf = p.buf,
	        h, b;
	
	    b = buf[p.pos++]; h  = (b & 0x70) >> 4;  if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 3;  if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 10; if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 17; if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x7f) << 24; if (b < 0x80) { return toNum(l, h, s); }
	    b = buf[p.pos++]; h |= (b & 0x01) << 31; if (b < 0x80) { return toNum(l, h, s); }
	
	    throw new Error('Expected varint not more than 10 bytes');
	}
	
	function readPackedEnd(pbf) {
	    return pbf.type === Pbf.Bytes ?
	        pbf.readVarint() + pbf.pos : pbf.pos + 1;
	}
	
	function toNum(low, high, isSigned) {
	    if (isSigned) {
	        return high * 0x100000000 + (low >>> 0);
	    }
	
	    return ((high >>> 0) * 0x100000000) + (low >>> 0);
	}
	
	function writeBigVarint(val, pbf) {
	    var low, high;
	
	    if (val >= 0) {
	        low  = (val % 0x100000000) | 0;
	        high = (val / 0x100000000) | 0;
	    } else {
	        low  = ~(-val % 0x100000000);
	        high = ~(-val / 0x100000000);
	
	        if (low ^ 0xffffffff) {
	            low = (low + 1) | 0;
	        } else {
	            low = 0;
	            high = (high + 1) | 0;
	        }
	    }
	
	    if (val >= 0x10000000000000000 || val < -0x10000000000000000) {
	        throw new Error('Given varint doesn\'t fit into 10 bytes');
	    }
	
	    pbf.realloc(10);
	
	    writeBigVarintLow(low, high, pbf);
	    writeBigVarintHigh(high, pbf);
	}
	
	function writeBigVarintLow(low, high, pbf) {
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
	    pbf.buf[pbf.pos]   = low & 0x7f;
	}
	
	function writeBigVarintHigh(high, pbf) {
	    var lsb = (high & 0x07) << 4;
	
	    pbf.buf[pbf.pos++] |= lsb         | ((high >>>= 3) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) { return; }
	    pbf.buf[pbf.pos++]  = high & 0x7f;
	}
	
	function makeRoomForExtraLength(startPos, len, pbf) {
	    var extraLen =
	        len <= 0x3fff ? 1 :
	        len <= 0x1fffff ? 2 :
	        len <= 0xfffffff ? 3 : Math.ceil(Math.log(len) / (Math.LN2 * 7));
	
	    // if 1 byte isn't enough for encoding message length, shift the data to the right
	    pbf.realloc(extraLen);
	    for (var i = pbf.pos - 1; i >= startPos; i--) { pbf.buf[i + extraLen] = pbf.buf[i]; }
	}
	
	function writePackedVarint(arr, pbf)   { for (var i = 0; i < arr.length; i++) { pbf.writeVarint(arr[i]); }   }
	function writePackedSVarint(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeSVarint(arr[i]); }  }
	function writePackedFloat(arr, pbf)    { for (var i = 0; i < arr.length; i++) { pbf.writeFloat(arr[i]); }    }
	function writePackedDouble(arr, pbf)   { for (var i = 0; i < arr.length; i++) { pbf.writeDouble(arr[i]); }   }
	function writePackedBoolean(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeBoolean(arr[i]); }  }
	function writePackedFixed32(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeFixed32(arr[i]); }  }
	function writePackedSFixed32(arr, pbf) { for (var i = 0; i < arr.length; i++) { pbf.writeSFixed32(arr[i]); } }
	function writePackedFixed64(arr, pbf)  { for (var i = 0; i < arr.length; i++) { pbf.writeFixed64(arr[i]); }  }
	function writePackedSFixed64(arr, pbf) { for (var i = 0; i < arr.length; i++) { pbf.writeSFixed64(arr[i]); } }
	
	// Buffer code below from https://github.com/feross/buffer, MIT-licensed
	
	function readUInt32(buf, pos) {
	    return ((buf[pos]) |
	        (buf[pos + 1] << 8) |
	        (buf[pos + 2] << 16)) +
	        (buf[pos + 3] * 0x1000000);
	}
	
	function writeInt32(buf, val, pos) {
	    buf[pos] = val;
	    buf[pos + 1] = (val >>> 8);
	    buf[pos + 2] = (val >>> 16);
	    buf[pos + 3] = (val >>> 24);
	}
	
	function readInt32(buf, pos) {
	    return ((buf[pos]) |
	        (buf[pos + 1] << 8) |
	        (buf[pos + 2] << 16)) +
	        (buf[pos + 3] << 24);
	}
	
	function readUtf8(buf, pos, end) {
	    var str = '';
	    var i = pos;
	
	    while (i < end) {
	        var b0 = buf[i];
	        var c = null; // codepoint
	        var bytesPerSequence =
	            b0 > 0xEF ? 4 :
	            b0 > 0xDF ? 3 :
	            b0 > 0xBF ? 2 : 1;
	
	        if (i + bytesPerSequence > end) { break; }
	
	        var b1, b2, b3;
	
	        if (bytesPerSequence === 1) {
	            if (b0 < 0x80) {
	                c = b0;
	            }
	        } else if (bytesPerSequence === 2) {
	            b1 = buf[i + 1];
	            if ((b1 & 0xC0) === 0x80) {
	                c = (b0 & 0x1F) << 0x6 | (b1 & 0x3F);
	                if (c <= 0x7F) {
	                    c = null;
	                }
	            }
	        } else if (bytesPerSequence === 3) {
	            b1 = buf[i + 1];
	            b2 = buf[i + 2];
	            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80) {
	                c = (b0 & 0xF) << 0xC | (b1 & 0x3F) << 0x6 | (b2 & 0x3F);
	                if (c <= 0x7FF || (c >= 0xD800 && c <= 0xDFFF)) {
	                    c = null;
	                }
	            }
	        } else if (bytesPerSequence === 4) {
	            b1 = buf[i + 1];
	            b2 = buf[i + 2];
	            b3 = buf[i + 3];
	            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
	                c = (b0 & 0xF) << 0x12 | (b1 & 0x3F) << 0xC | (b2 & 0x3F) << 0x6 | (b3 & 0x3F);
	                if (c <= 0xFFFF || c >= 0x110000) {
	                    c = null;
	                }
	            }
	        }
	
	        if (c === null) {
	            c = 0xFFFD;
	            bytesPerSequence = 1;
	
	        } else if (c > 0xFFFF) {
	            c -= 0x10000;
	            str += String.fromCharCode(c >>> 10 & 0x3FF | 0xD800);
	            c = 0xDC00 | c & 0x3FF;
	        }
	
	        str += String.fromCharCode(c);
	        i += bytesPerSequence;
	    }
	
	    return str;
	}
	
	function writeUtf8(buf, str, pos) {
	    for (var i = 0, c, lead; i < str.length; i++) {
	        c = str.charCodeAt(i); // code point
	
	        if (c > 0xD7FF && c < 0xE000) {
	            if (lead) {
	                if (c < 0xDC00) {
	                    buf[pos++] = 0xEF;
	                    buf[pos++] = 0xBF;
	                    buf[pos++] = 0xBD;
	                    lead = c;
	                    continue;
	                } else {
	                    c = lead - 0xD800 << 10 | c - 0xDC00 | 0x10000;
	                    lead = null;
	                }
	            } else {
	                if (c > 0xDBFF || (i + 1 === str.length)) {
	                    buf[pos++] = 0xEF;
	                    buf[pos++] = 0xBF;
	                    buf[pos++] = 0xBD;
	                } else {
	                    lead = c;
	                }
	                continue;
	            }
	        } else if (lead) {
	            buf[pos++] = 0xEF;
	            buf[pos++] = 0xBF;
	            buf[pos++] = 0xBD;
	            lead = null;
	        }
	
	        if (c < 0x80) {
	            buf[pos++] = c;
	        } else {
	            if (c < 0x800) {
	                buf[pos++] = c >> 0x6 | 0xC0;
	            } else {
	                if (c < 0x10000) {
	                    buf[pos++] = c >> 0xC | 0xE0;
	                } else {
	                    buf[pos++] = c >> 0x12 | 0xF0;
	                    buf[pos++] = c >> 0xC & 0x3F | 0x80;
	                }
	                buf[pos++] = c >> 0x6 & 0x3F | 0x80;
	            }
	            buf[pos++] = c & 0x3F | 0x80;
	        }
	    }
	    return pos;
	}
	
	/**
	 * @module ol/render/Feature
	 */
	
	
	/**
	 * @type {import("../transform.js").Transform}
	 */
	var tmpTransform$2 = create();
	
	
	/**
	 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
	 * structure, optimized for vector tile rendering and styling. Geometry access
	 * through the API is limited to getting the type and extent of the geometry.
	 *
	 * @param {GeometryType} type Geometry type.
	 * @param {Array<number>} flatCoordinates Flat coordinates. These always need
	 *     to be right-handed for polygons.
	 * @param {Array<number>|Array<Array<number>>} ends Ends or Endss.
	 * @param {Object<string, *>} properties Properties.
	 * @param {number|string|undefined} id Feature id.
	 */
	var RenderFeature = function RenderFeature(type, flatCoordinates, ends, properties, id) {
	  /**
	  * @private
	  * @type {import("../extent.js").Extent|undefined}
	  */
	  this.extent_;
	
	  /**
	  * @private
	  * @type {number|string|undefined}
	  */
	  this.id_ = id;
	
	  /**
	  * @private
	  * @type {GeometryType}
	  */
	  this.type_ = type;
	
	  /**
	  * @private
	  * @type {Array<number>}
	  */
	  this.flatCoordinates_ = flatCoordinates;
	
	  /**
	  * @private
	  * @type {Array<number>}
	  */
	  this.flatInteriorPoints_ = null;
	
	  /**
	  * @private
	  * @type {Array<number>}
	  */
	  this.flatMidpoints_ = null;
	
	  /**
	  * @private
	  * @type {Array<number>|Array<Array<number>>}
	  */
	  this.ends_ = ends;
	
	  /**
	  * @private
	  * @type {Object<string, *>}
	  */
	  this.properties_ = properties;
	
	};
	
	/**
	* Get a feature property by its key.
	* @param {string} key Key
	* @return {*} Value for the requested key.
	* @api
	*/
	RenderFeature.prototype.get = function get$$1 (key) {
	  return this.properties_[key];
	};
	
	/**
	* Get the extent of this feature's geometry.
	* @return {import("../extent.js").Extent} Extent.
	* @api
	*/
	RenderFeature.prototype.getExtent = function getExtent () {
	  if (!this.extent_) {
	    this.extent_ = this.type_ === GeometryType.POINT ?
	      createOrUpdateFromCoordinate(this.flatCoordinates_) :
	      createOrUpdateFromFlatCoordinates(
	        this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
	
	  }
	  return this.extent_;
	};
	
	/**
	* @return {Array<number>} Flat interior points.
	*/
	RenderFeature.prototype.getFlatInteriorPoint = function getFlatInteriorPoint () {
	  if (!this.flatInteriorPoints_) {
	    var flatCenter = getCenter(this.getExtent());
	    this.flatInteriorPoints_ = getInteriorPointOfArray(
	      this.flatCoordinates_, 0, /** @type {Array<number>} */ (this.ends_), 2, flatCenter, 0);
	  }
	  return this.flatInteriorPoints_;
	};
	
	/**
	* @return {Array<number>} Flat interior points.
	*/
	RenderFeature.prototype.getFlatInteriorPoints = function getFlatInteriorPoints () {
	  if (!this.flatInteriorPoints_) {
	    var flatCenters = linearRingss$1(
	      this.flatCoordinates_, 0, /** @type {Array<Array<number>>} */ (this.ends_), 2);
	    this.flatInteriorPoints_ = getInteriorPointsOfMultiArray(
	      this.flatCoordinates_, 0, /** @type {Array<Array<number>>} */ (this.ends_), 2, flatCenters);
	  }
	  return this.flatInteriorPoints_;
	};
	
	/**
	* @return {Array<number>} Flat midpoint.
	*/
	RenderFeature.prototype.getFlatMidpoint = function getFlatMidpoint () {
	  if (!this.flatMidpoints_) {
	    this.flatMidpoints_ = interpolatePoint(
	      this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
	  }
	  return this.flatMidpoints_;
	};
	
	/**
	* @return {Array<number>} Flat midpoints.
	*/
	RenderFeature.prototype.getFlatMidpoints = function getFlatMidpoints () {
	  if (!this.flatMidpoints_) {
	    this.flatMidpoints_ = [];
	    var flatCoordinates = this.flatCoordinates_;
	    var offset = 0;
	    var ends = /** @type {Array<number>} */ (this.ends_);
	    for (var i = 0, ii = ends.length; i < ii; ++i) {
	      var end = ends[i];
	      var midpoint = interpolatePoint(
	        flatCoordinates, offset, end, 2, 0.5);
	      extend(this.flatMidpoints_, midpoint);
	      offset = end;
	    }
	  }
	  return this.flatMidpoints_;
	};
	
	/**
	* Get the feature identifier.This is a stable identifier for the feature and
	* is set when reading data from a remote source.
	* @return {number|string|undefined} Id.
	* @api
	*/
	RenderFeature.prototype.getId = function getId () {
	  return this.id_;
	};
	
	/**
	* @return {Array<number>} Flat coordinates.
	*/
	RenderFeature.prototype.getOrientedFlatCoordinates = function getOrientedFlatCoordinates () {
	  return this.flatCoordinates_;
	};
	
	/**
	* For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
	* determining the geometry type in style function (see {@link #getType}).
	* @return {RenderFeature} Feature.
	* @api
	*/
	RenderFeature.prototype.getGeometry = function getGeometry () {
	  return this;
	};
	
	/**
	 * @param {number} squaredTolerance Squared tolerance.
	 * @return {RenderFeature} Simplified geometry.
	 */
	RenderFeature.prototype.getSimplifiedGeometry = function getSimplifiedGeometry (squaredTolerance) {
	  return this;
	};
	
	/**
	* Get the feature properties.
	* @return {Object<string, *>} Feature properties.
	* @api
	*/
	RenderFeature.prototype.getProperties = function getProperties () {
	  return this.properties_;
	};
	
	/**
	* @return {number} Stride.
	*/
	RenderFeature.prototype.getStride = function getStride () {
	  return 2;
	};
	
	/**
	 * @return {undefined}
	 */
	RenderFeature.prototype.getStyleFunction = function getStyleFunction () {
	  return undefined;
	};
	
	/**
	* Get the type of this feature's geometry.
	* @return {GeometryType} Geometry type.
	* @api
	*/
	RenderFeature.prototype.getType = function getType () {
	  return this.type_;
	};
	
	/**
	* Transform geometry coordinates from tile pixel space to projected.
	* The SRS of the source and destination are expected to be the same.
	*
	* @param {import("../proj.js").ProjectionLike} source The current projection
	* @param {import("../proj.js").ProjectionLike} destination The desired projection.
	*/
	RenderFeature.prototype.transform = function transform$$1 (source, destination) {
	  source = get$2(source);
	  var pixelExtent = source.getExtent();
	  var projectedExtent = source.getWorldExtent();
	  var scale$$1 = getHeight(projectedExtent) / getHeight(pixelExtent);
	  compose(tmpTransform$2,
	    projectedExtent[0], projectedExtent[3],
	    scale$$1, -scale$$1, 0,
	    0, 0);
	  transform2D(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2,
	    tmpTransform$2, this.flatCoordinates_);
	};
	
	
	/**
	 * @return {Array<number>|Array<Array<number>>} Ends or endss.
	 */
	RenderFeature.prototype.getEnds =
	RenderFeature.prototype.getEndss = function() {
	  return this.ends_;
	};
	
	
	/**
	 * @return {Array<number>} Flat coordinates.
	 */
	RenderFeature.prototype.getFlatCoordinates =
	    RenderFeature.prototype.getOrientedFlatCoordinates;
	
	/**
	 * @module ol/format/MVT
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../Feature.js").FeatureClass} [featureClass] Class for features returned by
	 * {@link module:ol/format/MVT#readFeatures}. Set to {@link module:ol/Feature~Feature} to get full editing and geometry
	 * support at the cost of decreased rendering performance. The default is
	 * {@link module:ol/render/Feature~RenderFeature}, which is optimized for rendering and hit detection.
	 * @property {string} [geometryName='geometry'] Geometry name to use when creating features.
	 * @property {string} [layerName='layer'] Name of the feature attribute that holds the layer name.
	 * @property {Array<string>} [layers] Layers to read features from. If not provided, features will be read from all
	 * layers.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for reading data in the Mapbox MVT format.
	 *
	 * @param {Options=} opt_options Options.
	 * @api
	 */
	var MVT = /*@__PURE__*/(function (FeatureFormat$$1) {
	  function MVT(opt_options) {
	    FeatureFormat$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @type {Projection}
	     */
	    this.dataProjection = new Projection({
	      code: '',
	      units: Units.TILE_PIXELS
	    });
	
	    /**
	     * @private
	     * @type {import("../Feature.js").FeatureClass}
	     */
	    this.featureClass_ = options.featureClass ? options.featureClass : RenderFeature;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.geometryName_ = options.geometryName;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.layerName_ = options.layerName ? options.layerName : 'layer';
	
	    /**
	     * @private
	     * @type {Array<string>}
	     */
	    this.layers_ = options.layers ? options.layers : null;
	
	    /**
	     * @private
	     * @type {import("../extent.js").Extent}
	     */
	    this.extent_ = null;
	
	  }
	
	  if ( FeatureFormat$$1 ) { MVT.__proto__ = FeatureFormat$$1; }
	  MVT.prototype = Object.create( FeatureFormat$$1 && FeatureFormat$$1.prototype );
	  MVT.prototype.constructor = MVT;
	
	  /**
	   * Read the raw geometry from the pbf offset stored in a raw feature's geometry
	   * property.
	   * @suppress {missingProperties}
	   * @param {Object} pbf PBF.
	   * @param {Object} feature Raw feature.
	   * @param {Array<number>} flatCoordinates Array to store flat coordinates in.
	   * @param {Array<number>} ends Array to store ends in.
	   * @private
	   */
	  MVT.prototype.readRawGeometry_ = function readRawGeometry_ (pbf$$1, feature, flatCoordinates, ends) {
	    pbf$$1.pos = feature.geometry;
	
	    var end = pbf$$1.readVarint() + pbf$$1.pos;
	    var cmd = 1;
	    var length = 0;
	    var x = 0;
	    var y = 0;
	    var coordsLen = 0;
	    var currentEnd = 0;
	
	    while (pbf$$1.pos < end) {
	      if (!length) {
	        var cmdLen = pbf$$1.readVarint();
	        cmd = cmdLen & 0x7;
	        length = cmdLen >> 3;
	      }
	
	      length--;
	
	      if (cmd === 1 || cmd === 2) {
	        x += pbf$$1.readSVarint();
	        y += pbf$$1.readSVarint();
	
	        if (cmd === 1) { // moveTo
	          if (coordsLen > currentEnd) {
	            ends.push(coordsLen);
	            currentEnd = coordsLen;
	          }
	        }
	
	        flatCoordinates.push(x, y);
	        coordsLen += 2;
	
	      } else if (cmd === 7) {
	
	        if (coordsLen > currentEnd) {
	          // close polygon
	          flatCoordinates.push(
	            flatCoordinates[currentEnd], flatCoordinates[currentEnd + 1]);
	          coordsLen += 2;
	        }
	
	      } else {
	        assert(false, 59); // Invalid command found in the PBF
	      }
	    }
	
	    if (coordsLen > currentEnd) {
	      ends.push(coordsLen);
	      currentEnd = coordsLen;
	    }
	
	  };
	
	  /**
	   * @private
	   * @param {Object} pbf PBF
	   * @param {Object} rawFeature Raw Mapbox feature.
	   * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	   * @return {import("../Feature.js").FeatureLike} Feature.
	   */
	  MVT.prototype.createFeature_ = function createFeature_ (pbf$$1, rawFeature, opt_options) {
	    var type = rawFeature.type;
	    if (type === 0) {
	      return null;
	    }
	
	    var feature;
	    var id = rawFeature.id;
	    var values = rawFeature.properties;
	    values[this.layerName_] = rawFeature.layer.name;
	
	    var flatCoordinates = [];
	    var ends = [];
	    this.readRawGeometry_(pbf$$1, rawFeature, flatCoordinates, ends);
	
	    var geometryType = getGeometryType(type, ends.length);
	
	    if (this.featureClass_ === RenderFeature) {
	      feature = new this.featureClass_(geometryType, flatCoordinates, ends, values, id);
	    } else {
	      var geom;
	      if (geometryType == GeometryType.POLYGON) {
	        var endss = [];
	        var offset = 0;
	        var prevEndIndex = 0;
	        for (var i = 0, ii = ends.length; i < ii; ++i) {
	          var end = ends[i];
	          if (!linearRingIsClockwise(flatCoordinates, offset, end, 2)) {
	            endss.push(ends.slice(prevEndIndex, i));
	            prevEndIndex = i;
	          }
	          offset = end;
	        }
	        if (endss.length > 1) {
	          geom = new MultiPolygon(flatCoordinates, GeometryLayout.XY, endss);
	        } else {
	          geom = new Polygon(flatCoordinates, GeometryLayout.XY, ends);
	        }
	      } else {
	        geom = geometryType === GeometryType.POINT ? new Point(flatCoordinates, GeometryLayout.XY) :
	          geometryType === GeometryType.LINE_STRING ? new LineString(flatCoordinates, GeometryLayout.XY) :
	            geometryType === GeometryType.POLYGON ? new Polygon(flatCoordinates, GeometryLayout.XY, ends) :
	              geometryType === GeometryType.MULTI_POINT ? new MultiPoint(flatCoordinates, GeometryLayout.XY) :
	                geometryType === GeometryType.MULTI_LINE_STRING ? new MultiLineString(flatCoordinates, GeometryLayout.XY, ends) :
	                  null;
	      }
	      var ctor = /** @type {typeof import("../Feature.js").default} */ (this.featureClass_);
	      feature = new ctor();
	      if (this.geometryName_) {
	        feature.setGeometryName(this.geometryName_);
	      }
	      var geometry = /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geom, false,
	        this.adaptOptions(opt_options)));
	      feature.setGeometry(geometry);
	      feature.setId(id);
	      feature.setProperties(values);
	    }
	
	    return feature;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MVT.prototype.getLastExtent = function getLastExtent () {
	    return this.extent_;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  MVT.prototype.getType = function getType () {
	    return FormatType.ARRAY_BUFFER;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MVT.prototype.readFeatures = function readFeatures (source, opt_options) {
	    var layers = this.layers_;
	
	    var pbf$$1 = new pbf(/** @type {ArrayBuffer} */ (source));
	    var pbfLayers = pbf$$1.readFields(layersPBFReader, {});
	    /** @type {Array<import("../Feature.js").FeatureLike>} */
	    var features = [];
	    for (var name in pbfLayers) {
	      if (layers && layers.indexOf(name) == -1) {
	        continue;
	      }
	      var pbfLayer = pbfLayers[name];
	
	      for (var i = 0, ii = pbfLayer.length; i < ii; ++i) {
	        var rawFeature = readRawFeature(pbf$$1, pbfLayer, i);
	        features.push(this.createFeature_(pbf$$1, rawFeature));
	      }
	      this.extent_ = pbfLayer ? [0, 0, pbfLayer.extent, pbfLayer.extent] : null;
	    }
	
	    return features;
	  };
	
	  /**
	   * @inheritDoc
	   * @api
	   */
	  MVT.prototype.readProjection = function readProjection (source) {
	    return this.dataProjection;
	  };
	
	  /**
	   * Sets the layers that features will be read from.
	   * @param {Array<string>} layers Layers.
	   * @api
	   */
	  MVT.prototype.setLayers = function setLayers (layers) {
	    this.layers_ = layers;
	  };
	
	  return MVT;
	}(FeatureFormat));
	
	
	/**
	 * Reader callback for parsing layers.
	 * @param {number} tag The tag.
	 * @param {Object} layers The layers object.
	 * @param {Object} pbf The PBF.
	 */
	function layersPBFReader(tag, layers, pbf$$1) {
	  if (tag === 3) {
	    var layer = {
	      keys: [],
	      values: [],
	      features: []
	    };
	    var end = pbf$$1.readVarint() + pbf$$1.pos;
	    pbf$$1.readFields(layerPBFReader, layer, end);
	    layer.length = layer.features.length;
	    if (layer.length) {
	      layers[layer.name] = layer;
	    }
	  }
	}
	
	/**
	 * Reader callback for parsing layer.
	 * @param {number} tag The tag.
	 * @param {Object} layer The layer object.
	 * @param {Object} pbf The PBF.
	 */
	function layerPBFReader(tag, layer, pbf$$1) {
	  if (tag === 15) {
	    layer.version = pbf$$1.readVarint();
	  } else if (tag === 1) {
	    layer.name = pbf$$1.readString();
	  } else if (tag === 5) {
	    layer.extent = pbf$$1.readVarint();
	  } else if (tag === 2) {
	    layer.features.push(pbf$$1.pos);
	  } else if (tag === 3) {
	    layer.keys.push(pbf$$1.readString());
	  } else if (tag === 4) {
	    var value = null;
	    var end = pbf$$1.readVarint() + pbf$$1.pos;
	    while (pbf$$1.pos < end) {
	      tag = pbf$$1.readVarint() >> 3;
	      value = tag === 1 ? pbf$$1.readString() :
	        tag === 2 ? pbf$$1.readFloat() :
	          tag === 3 ? pbf$$1.readDouble() :
	            tag === 4 ? pbf$$1.readVarint64() :
	              tag === 5 ? pbf$$1.readVarint() :
	                tag === 6 ? pbf$$1.readSVarint() :
	                  tag === 7 ? pbf$$1.readBoolean() : null;
	    }
	    layer.values.push(value);
	  }
	}
	
	/**
	 * Reader callback for parsing feature.
	 * @param {number} tag The tag.
	 * @param {Object} feature The feature object.
	 * @param {Object} pbf The PBF.
	 */
	function featurePBFReader(tag, feature, pbf$$1) {
	  if (tag == 1) {
	    feature.id = pbf$$1.readVarint();
	  } else if (tag == 2) {
	    var end = pbf$$1.readVarint() + pbf$$1.pos;
	    while (pbf$$1.pos < end) {
	      var key = feature.layer.keys[pbf$$1.readVarint()];
	      var value = feature.layer.values[pbf$$1.readVarint()];
	      feature.properties[key] = value;
	    }
	  } else if (tag == 3) {
	    feature.type = pbf$$1.readVarint();
	  } else if (tag == 4) {
	    feature.geometry = pbf$$1.pos;
	  }
	}
	
	
	/**
	 * Read a raw feature from the pbf offset stored at index `i` in the raw layer.
	 * @suppress {missingProperties}
	 * @param {Object} pbf PBF.
	 * @param {Object} layer Raw layer.
	 * @param {number} i Index of the feature in the raw layer's `features` array.
	 * @return {Object} Raw feature.
	 */
	function readRawFeature(pbf$$1, layer, i) {
	  pbf$$1.pos = layer.features[i];
	  var end = pbf$$1.readVarint() + pbf$$1.pos;
	
	  var feature = {
	    layer: layer,
	    type: 0,
	    properties: {}
	  };
	  pbf$$1.readFields(featurePBFReader, feature, end);
	  return feature;
	}
	
	
	/**
	 * @suppress {missingProperties}
	 * @param {number} type The raw feature's geometry type
	 * @param {number} numEnds Number of ends of the flat coordinates of the
	 * geometry.
	 * @return {GeometryType} The geometry type.
	 */
	function getGeometryType(type, numEnds) {
	  /** @type {GeometryType} */
	  var geometryType;
	  if (type === 1) {
	    geometryType = numEnds === 1 ?
	      GeometryType.POINT : GeometryType.MULTI_POINT;
	  } else if (type === 2) {
	    geometryType = numEnds === 1 ?
	      GeometryType.LINE_STRING :
	      GeometryType.MULTI_LINE_STRING;
	  } else if (type === 3) {
	    geometryType = GeometryType.POLYGON;
	    // MultiPolygon not relevant for rendering - winding order determines
	    // outer rings of polygons.
	  }
	  return geometryType;
	}
	
	/**
	 * @module ol/format/OSMXML
	 */
	
	
	/**
	 * @const
	 * @type {Array<null>}
	 */
	var NAMESPACE_URIS$2 = [null];
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var WAY_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$2, {
	    'nd': readNd,
	    'tag': readTag
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PARSERS = makeStructureNS(
	  NAMESPACE_URIS$2, {
	    'node': readNode,
	    'way': readWay
	  });
	
	
	/**
	 * @classdesc
	 * Feature format for reading data in the
	 * [OSMXML format](http://wiki.openstreetmap.org/wiki/OSM_XML).
	 *
	 * @api
	 */
	var OSMXML = /*@__PURE__*/(function (XMLFeature$$1) {
	  function OSMXML() {
	    XMLFeature$$1.call(this);
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2('EPSG:4326');
	  }
	
	  if ( XMLFeature$$1 ) { OSMXML.__proto__ = XMLFeature$$1; }
	  OSMXML.prototype = Object.create( XMLFeature$$1 && XMLFeature$$1.prototype );
	  OSMXML.prototype.constructor = OSMXML;
	
	  /**
	   * @inheritDoc
	   */
	  OSMXML.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    var options = this.getReadOptions(node, opt_options);
	    if (node.localName == 'osm') {
	      var state = pushParseAndPop({
	        nodes: {},
	        ways: [],
	        features: []
	      }, PARSERS, node, [options]);
	      // parse nodes in ways
	      for (var j = 0; j < state.ways.length; j++) {
	        var values = /** @type {Object} */ (state.ways[j]);
	        /** @type {Array<number>} */
	        var flatCoordinates = [];
	        for (var i = 0, ii = values.ndrefs.length; i < ii; i++) {
	          var point = state.nodes[values.ndrefs[i]];
	          extend(flatCoordinates, point);
	        }
	        var geometry = (void 0);
	        if (values.ndrefs[0] == values.ndrefs[values.ndrefs.length - 1]) {
	          // closed way
	          geometry = new Polygon(flatCoordinates, GeometryLayout.XY, [flatCoordinates.length]);
	        } else {
	          geometry = new LineString(flatCoordinates, GeometryLayout.XY);
	        }
	        transformWithOptions(geometry, false, options);
	        var feature = new Feature(geometry);
	        feature.setId(values.id);
	        feature.setProperties(values.tags);
	        state.features.push(feature);
	      }
	      if (state.features) {
	        return state.features;
	      }
	    }
	    return [];
	  };
	
	  return OSMXML;
	}(XMLFeature));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var NODE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$2, {
	    'tag': readTag
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function readNode(node, objectStack) {
	  var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
	  var state = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  var id = node.getAttribute('id');
	  /** @type {import("../coordinate.js").Coordinate} */
	  var coordinates = [
	    parseFloat(node.getAttribute('lon')),
	    parseFloat(node.getAttribute('lat'))
	  ];
	  state.nodes[id] = coordinates;
	
	  var values = pushParseAndPop({
	    tags: {}
	  }, NODE_PARSERS, node, objectStack);
	  if (!isEmpty(values.tags)) {
	    var geometry = new Point(coordinates);
	    transformWithOptions(geometry, false, options);
	    var feature = new Feature(geometry);
	    feature.setId(id);
	    feature.setProperties(values.tags);
	    state.features.push(feature);
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function readWay(node, objectStack) {
	  var id = node.getAttribute('id');
	  var values = pushParseAndPop({
	    id: id,
	    ndrefs: [],
	    tags: {}
	  }, WAY_PARSERS, node, objectStack);
	  var state = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  state.ways.push(values);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function readNd(node, objectStack) {
	  var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  values.ndrefs.push(node.getAttribute('ref'));
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function readTag(node, objectStack) {
	  var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  values.tags[node.getAttribute('k')] = node.getAttribute('v');
	}
	
	/**
	 * @module ol/geom/flat/flip
	 */
	
	
	/**
	 * @param {Array<number>} flatCoordinates Flat coordinates.
	 * @param {number} offset Offset.
	 * @param {number} end End.
	 * @param {number} stride Stride.
	 * @param {Array<number>=} opt_dest Destination.
	 * @param {number=} opt_destOffset Destination offset.
	 * @return {Array<number>} Flat coordinates.
	 */
	function flipXY(flatCoordinates, offset, end, stride, opt_dest, opt_destOffset) {
	  var dest, destOffset;
	  if (opt_dest !== undefined) {
	    dest = opt_dest;
	    destOffset = opt_destOffset !== undefined ? opt_destOffset : 0;
	  } else {
	    dest = [];
	    destOffset = 0;
	  }
	  var j = offset;
	  while (j < end) {
	    var x = flatCoordinates[j++];
	    dest[destOffset++] = flatCoordinates[j++];
	    dest[destOffset++] = x;
	    for (var k = 2; k < stride; ++k) {
	      dest[destOffset++] = flatCoordinates[j++];
	    }
	  }
	  dest.length = destOffset;
	  return dest;
	}
	
	/**
	 * @module ol/format/Polyline
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {number} [factor=1e5] The factor by which the coordinates values will be scaled.
	 * @property {GeometryLayout} [geometryLayout='XY'] Layout of the
	 * feature geometries created by the format reader.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the Encoded
	 * Polyline Algorithm Format.
	 *
	 * When reading features, the coordinates are assumed to be in two dimensions
	 * and in [latitude, longitude] order.
	 *
	 * As Polyline sources contain a single feature,
	 * {@link module:ol/format/Polyline~Polyline#readFeatures} will return the
	 * feature in an array.
	 *
	 * @api
	 */
	var Polyline = /*@__PURE__*/(function (TextFeature$$1) {
	  function Polyline(opt_options) {
	    TextFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2('EPSG:4326');
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.factor_ = options.factor ? options.factor : 1e5;
	
	    /**
	     * @private
	     * @type {GeometryLayout}
	     */
	    this.geometryLayout_ = options.geometryLayout ?
	      options.geometryLayout : GeometryLayout.XY;
	  }
	
	  if ( TextFeature$$1 ) { Polyline.__proto__ = TextFeature$$1; }
	  Polyline.prototype = Object.create( TextFeature$$1 && TextFeature$$1.prototype );
	  Polyline.prototype.constructor = Polyline;
	
	  /**
	   * @inheritDoc
	   */
	  Polyline.prototype.readFeatureFromText = function readFeatureFromText (text, opt_options) {
	    var geometry = this.readGeometryFromText(text, opt_options);
	    return new Feature(geometry);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polyline.prototype.readFeaturesFromText = function readFeaturesFromText (text, opt_options) {
	    var feature = this.readFeatureFromText(text, opt_options);
	    return [feature];
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polyline.prototype.readGeometryFromText = function readGeometryFromText (text, opt_options) {
	    var stride = getStrideForLayout(this.geometryLayout_);
	    var flatCoordinates = decodeDeltas(text, stride, this.factor_);
	    flipXY(flatCoordinates, 0, flatCoordinates.length, stride, flatCoordinates);
	    var coordinates = inflateCoordinates(flatCoordinates, 0, flatCoordinates.length, stride);
	
	    return (
	      /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(
	        new LineString(coordinates, this.geometryLayout_),
	        false,
	        this.adaptOptions(opt_options)
	      ))
	    );
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polyline.prototype.writeFeatureText = function writeFeatureText (feature, opt_options) {
	    var geometry = feature.getGeometry();
	    if (geometry) {
	      return this.writeGeometryText(geometry, opt_options);
	    } else {
	      assert(false, 40); // Expected `feature` to have a geometry
	      return '';
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polyline.prototype.writeFeaturesText = function writeFeaturesText (features, opt_options) {
	    return this.writeFeatureText(features[0], opt_options);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  Polyline.prototype.writeGeometryText = function writeGeometryText (geometry, opt_options) {
	    geometry = /** @type {LineString} */
	      (transformWithOptions(geometry, true, this.adaptOptions(opt_options)));
	    var flatCoordinates = geometry.getFlatCoordinates();
	    var stride = geometry.getStride();
	    flipXY(flatCoordinates, 0, flatCoordinates.length, stride, flatCoordinates);
	    return encodeDeltas(flatCoordinates, stride, this.factor_);
	  };
	
	  return Polyline;
	}(TextFeature));
	
	
	/**
	 * Encode a list of n-dimensional points and return an encoded string
	 *
	 * Attention: This function will modify the passed array!
	 *
	 * @param {Array<number>} numbers A list of n-dimensional points.
	 * @param {number} stride The number of dimension of the points in the list.
	 * @param {number=} opt_factor The factor by which the numbers will be
	 *     multiplied. The remaining decimal places will get rounded away.
	 *     Default is `1e5`.
	 * @return {string} The encoded string.
	 * @api
	 */
	function encodeDeltas(numbers, stride, opt_factor) {
	  var factor = opt_factor ? opt_factor : 1e5;
	  var d;
	
	  var lastNumbers = new Array(stride);
	  for (d = 0; d < stride; ++d) {
	    lastNumbers[d] = 0;
	  }
	
	  for (var i = 0, ii = numbers.length; i < ii;) {
	    for (d = 0; d < stride; ++d, ++i) {
	      var num = numbers[i];
	      var delta = num - lastNumbers[d];
	      lastNumbers[d] = num;
	
	      numbers[i] = delta;
	    }
	  }
	
	  return encodeFloats(numbers, factor);
	}
	
	
	/**
	 * Decode a list of n-dimensional points from an encoded string
	 *
	 * @param {string} encoded An encoded string.
	 * @param {number} stride The number of dimension of the points in the
	 *     encoded string.
	 * @param {number=} opt_factor The factor by which the resulting numbers will
	 *     be divided. Default is `1e5`.
	 * @return {Array<number>} A list of n-dimensional points.
	 * @api
	 */
	function decodeDeltas(encoded, stride, opt_factor) {
	  var factor = opt_factor ? opt_factor : 1e5;
	  var d;
	
	  /** @type {Array<number>} */
	  var lastNumbers = new Array(stride);
	  for (d = 0; d < stride; ++d) {
	    lastNumbers[d] = 0;
	  }
	
	  var numbers = decodeFloats(encoded, factor);
	
	  for (var i = 0, ii = numbers.length; i < ii;) {
	    for (d = 0; d < stride; ++d, ++i) {
	      lastNumbers[d] += numbers[i];
	
	      numbers[i] = lastNumbers[d];
	    }
	  }
	
	  return numbers;
	}
	
	
	/**
	 * Encode a list of floating point numbers and return an encoded string
	 *
	 * Attention: This function will modify the passed array!
	 *
	 * @param {Array<number>} numbers A list of floating point numbers.
	 * @param {number=} opt_factor The factor by which the numbers will be
	 *     multiplied. The remaining decimal places will get rounded away.
	 *     Default is `1e5`.
	 * @return {string} The encoded string.
	 * @api
	 */
	function encodeFloats(numbers, opt_factor) {
	  var factor = opt_factor ? opt_factor : 1e5;
	  for (var i = 0, ii = numbers.length; i < ii; ++i) {
	    numbers[i] = Math.round(numbers[i] * factor);
	  }
	
	  return encodeSignedIntegers(numbers);
	}
	
	
	/**
	 * Decode a list of floating point numbers from an encoded string
	 *
	 * @param {string} encoded An encoded string.
	 * @param {number=} opt_factor The factor by which the result will be divided.
	 *     Default is `1e5`.
	 * @return {Array<number>} A list of floating point numbers.
	 * @api
	 */
	function decodeFloats(encoded, opt_factor) {
	  var factor = opt_factor ? opt_factor : 1e5;
	  var numbers = decodeSignedIntegers(encoded);
	  for (var i = 0, ii = numbers.length; i < ii; ++i) {
	    numbers[i] /= factor;
	  }
	  return numbers;
	}
	
	
	/**
	 * Encode a list of signed integers and return an encoded string
	 *
	 * Attention: This function will modify the passed array!
	 *
	 * @param {Array<number>} numbers A list of signed integers.
	 * @return {string} The encoded string.
	 */
	function encodeSignedIntegers(numbers) {
	  for (var i = 0, ii = numbers.length; i < ii; ++i) {
	    var num = numbers[i];
	    numbers[i] = (num < 0) ? ~(num << 1) : (num << 1);
	  }
	  return encodeUnsignedIntegers(numbers);
	}
	
	
	/**
	 * Decode a list of signed integers from an encoded string
	 *
	 * @param {string} encoded An encoded string.
	 * @return {Array<number>} A list of signed integers.
	 */
	function decodeSignedIntegers(encoded) {
	  var numbers = decodeUnsignedIntegers(encoded);
	  for (var i = 0, ii = numbers.length; i < ii; ++i) {
	    var num = numbers[i];
	    numbers[i] = (num & 1) ? ~(num >> 1) : (num >> 1);
	  }
	  return numbers;
	}
	
	
	/**
	 * Encode a list of unsigned integers and return an encoded string
	 *
	 * @param {Array<number>} numbers A list of unsigned integers.
	 * @return {string} The encoded string.
	 */
	function encodeUnsignedIntegers(numbers) {
	  var encoded = '';
	  for (var i = 0, ii = numbers.length; i < ii; ++i) {
	    encoded += encodeUnsignedInteger(numbers[i]);
	  }
	  return encoded;
	}
	
	
	/**
	 * Decode a list of unsigned integers from an encoded string
	 *
	 * @param {string} encoded An encoded string.
	 * @return {Array<number>} A list of unsigned integers.
	 */
	function decodeUnsignedIntegers(encoded) {
	  var numbers = [];
	  var current = 0;
	  var shift = 0;
	  for (var i = 0, ii = encoded.length; i < ii; ++i) {
	    var b = encoded.charCodeAt(i) - 63;
	    current |= (b & 0x1f) << shift;
	    if (b < 0x20) {
	      numbers.push(current);
	      current = 0;
	      shift = 0;
	    } else {
	      shift += 5;
	    }
	  }
	  return numbers;
	}
	
	
	/**
	 * Encode one single unsigned integer and return an encoded string
	 *
	 * @param {number} num Unsigned integer that should be encoded.
	 * @return {string} The encoded string.
	 */
	function encodeUnsignedInteger(num) {
	  var value, encoded = '';
	  while (num >= 0x20) {
	    value = (0x20 | (num & 0x1f)) + 63;
	    encoded += String.fromCharCode(value);
	    num >>= 5;
	  }
	  value = num + 63;
	  encoded += String.fromCharCode(value);
	  return encoded;
	}
	
	/**
	 * @module ol/format/TopoJSON
	 */
	
	/**
	 * @typedef {import("topojson-specification").Topology} TopoJSONTopology
	 * @typedef {import("topojson-specification").GeometryCollection} TopoJSONGeometryCollection
	 * @typedef {import("topojson-specification").GeometryObject} TopoJSONGeometry
	 * @typedef {import("topojson-specification").Point} TopoJSONPoint
	 * @typedef {import("topojson-specification").MultiPoint} TopoJSONMultiPoint
	 * @typedef {import("topojson-specification").LineString} TopoJSONLineString
	 * @typedef {import("topojson-specification").MultiLineString} TopoJSONMultiLineString
	 * @typedef {import("topojson-specification").Polygon} TopoJSONPolygon
	 * @typedef {import("topojson-specification").MultiPolygon} TopoJSONMultiPolygon
	 */
	
	/**
	 * @typedef {Object} Options
	 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
	 * @property {string} [layerName] Set the name of the TopoJSON topology
	 * `objects`'s children as feature property with the specified name. This means
	 * that when set to `'layer'`, a topology like
	 * ```
	 * {
	 *   "type": "Topology",
	 *   "objects": {
	 *     "example": {
	 *       "type": "GeometryCollection",
	 *       "geometries": []
	 *     }
	 *   }
	 * }
	 * ```
	 * will result in features that have a property `'layer'` set to `'example'`.
	 * When not set, no property will be added to features.
	 * @property {Array<string>} [layers] Names of the TopoJSON topology's
	 * `objects`'s children to read features from.  If not provided, features will
	 * be read from all children.
	 */
	
	
	/**
	 * @classdesc
	 * Feature format for reading data in the TopoJSON format.
	 *
	 * @api
	 */
	var TopoJSON = /*@__PURE__*/(function (JSONFeature$$1) {
	  function TopoJSON(opt_options) {
	    JSONFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.layerName_ = options.layerName;
	
	    /**
	     * @private
	     * @type {Array<string>}
	     */
	    this.layers_ = options.layers ? options.layers : null;
	
	    /**
	     * @inheritDoc
	     */
	    this.dataProjection = get$2(
	      options.dataProjection ?
	        options.dataProjection : 'EPSG:4326');
	
	  }
	
	  if ( JSONFeature$$1 ) { TopoJSON.__proto__ = JSONFeature$$1; }
	  TopoJSON.prototype = Object.create( JSONFeature$$1 && JSONFeature$$1.prototype );
	  TopoJSON.prototype.constructor = TopoJSON;
	
	  /**
	   * @inheritDoc
	   */
	  TopoJSON.prototype.readFeaturesFromObject = function readFeaturesFromObject (object, opt_options) {
	    if (object.type == 'Topology') {
	      var topoJSONTopology = /** @type {TopoJSONTopology} */ (object);
	      var transform$$1, scale = null, translate = null;
	      if (topoJSONTopology['transform']) {
	        transform$$1 = topoJSONTopology['transform'];
	        scale = transform$$1['scale'];
	        translate = transform$$1['translate'];
	      }
	      var arcs = topoJSONTopology['arcs'];
	      if (transform$$1) {
	        transformArcs(arcs, scale, translate);
	      }
	      /** @type {Array<Feature>} */
	      var features = [];
	      var topoJSONFeatures = topoJSONTopology['objects'];
	      var property = this.layerName_;
	      var feature;
	      for (var objectName in topoJSONFeatures) {
	        if (this.layers_ && this.layers_.indexOf(objectName) == -1) {
	          continue;
	        }
	        if (topoJSONFeatures[objectName].type === 'GeometryCollection') {
	          feature = /** @type {TopoJSONGeometryCollection} */ (topoJSONFeatures[objectName]);
	          features.push.apply(features, readFeaturesFromGeometryCollection(
	            feature, arcs, scale, translate, property, objectName, opt_options));
	        } else {
	          feature = /** @type {TopoJSONGeometry} */ (topoJSONFeatures[objectName]);
	          features.push(readFeatureFromGeometry(
	            feature, arcs, scale, translate, property, objectName, opt_options));
	        }
	      }
	      return features;
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  TopoJSON.prototype.readProjectionFromObject = function readProjectionFromObject (object) {
	    return this.dataProjection;
	  };
	
	  return TopoJSON;
	}(JSONFeature));
	
	
	/**
	 * @const
	 * @type {Object<string, function(TopoJSONGeometry, Array, ...Array=): import("../geom/Geometry.js").default>}
	 */
	var GEOMETRY_READERS$1 = {
	  'Point': readPointGeometry$2,
	  'LineString': readLineStringGeometry$2,
	  'Polygon': readPolygonGeometry$2,
	  'MultiPoint': readMultiPointGeometry$2,
	  'MultiLineString': readMultiLineStringGeometry$2,
	  'MultiPolygon': readMultiPolygonGeometry$2
	};
	
	
	/**
	 * Concatenate arcs into a coordinate array.
	 * @param {Array<number>} indices Indices of arcs to concatenate.  Negative
	 *     values indicate arcs need to be reversed.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs (already
	 *     transformed).
	 * @return {Array<import("../coordinate.js").Coordinate>} Coordinates array.
	 */
	function concatenateArcs(indices, arcs) {
	  /** @type {Array<import("../coordinate.js").Coordinate>} */
	  var coordinates = [];
	  var index, arc;
	  for (var i = 0, ii = indices.length; i < ii; ++i) {
	    index = indices[i];
	    if (i > 0) {
	      // splicing together arcs, discard last point
	      coordinates.pop();
	    }
	    if (index >= 0) {
	      // forward arc
	      arc = arcs[index];
	    } else {
	      // reverse arc
	      arc = arcs[~index].slice().reverse();
	    }
	    coordinates.push.apply(coordinates, arc);
	  }
	  // provide fresh copies of coordinate arrays
	  for (var j = 0, jj = coordinates.length; j < jj; ++j) {
	    coordinates[j] = coordinates[j].slice();
	  }
	  return coordinates;
	}
	
	
	/**
	 * Create a point from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONPoint} object TopoJSON object.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 * @return {Point} Geometry.
	 */
	function readPointGeometry$2(object, scale, translate) {
	  var coordinates = object['coordinates'];
	  if (scale && translate) {
	    transformVertex(coordinates, scale, translate);
	  }
	  return new Point(coordinates);
	}
	
	
	/**
	 * Create a multi-point from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONMultiPoint} object TopoJSON object.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 * @return {MultiPoint} Geometry.
	 */
	function readMultiPointGeometry$2(object, scale, translate) {
	  var coordinates = object['coordinates'];
	  if (scale && translate) {
	    for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	      transformVertex(coordinates[i], scale, translate);
	    }
	  }
	  return new MultiPoint(coordinates);
	}
	
	
	/**
	 * Create a linestring from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONLineString} object TopoJSON object.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @return {LineString} Geometry.
	 */
	function readLineStringGeometry$2(object, arcs) {
	  var coordinates = concatenateArcs(object['arcs'], arcs);
	  return new LineString(coordinates);
	}
	
	
	/**
	 * Create a multi-linestring from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONMultiLineString} object TopoJSON object.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @return {MultiLineString} Geometry.
	 */
	function readMultiLineStringGeometry$2(object, arcs) {
	  var coordinates = [];
	  for (var i = 0, ii = object['arcs'].length; i < ii; ++i) {
	    coordinates[i] = concatenateArcs(object['arcs'][i], arcs);
	  }
	  return new MultiLineString(coordinates);
	}
	
	
	/**
	 * Create a polygon from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONPolygon} object TopoJSON object.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @return {Polygon} Geometry.
	 */
	function readPolygonGeometry$2(object, arcs) {
	  var coordinates = [];
	  for (var i = 0, ii = object['arcs'].length; i < ii; ++i) {
	    coordinates[i] = concatenateArcs(object['arcs'][i], arcs);
	  }
	  return new Polygon(coordinates);
	}
	
	
	/**
	 * Create a multi-polygon from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONMultiPolygon} object TopoJSON object.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @return {MultiPolygon} Geometry.
	 */
	function readMultiPolygonGeometry$2(object, arcs) {
	  var coordinates = [];
	  for (var i = 0, ii = object['arcs'].length; i < ii; ++i) {
	    // for each polygon
	    var polyArray = object['arcs'][i];
	    var ringCoords = [];
	    for (var j = 0, jj = polyArray.length; j < jj; ++j) {
	      // for each ring
	      ringCoords[j] = concatenateArcs(polyArray[j], arcs);
	    }
	    coordinates[i] = ringCoords;
	  }
	  return new MultiPolygon(coordinates);
	}
	
	
	/**
	 * Create features from a TopoJSON GeometryCollection object.
	 *
	 * @param {TopoJSONGeometryCollection} collection TopoJSON Geometry
	 *     object.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 * @param {string|undefined} property Property to set the `GeometryCollection`'s parent
	 *     object to.
	 * @param {string} name Name of the `Topology`'s child object.
	 * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	 * @return {Array<Feature>} Array of features.
	 */
	function readFeaturesFromGeometryCollection(collection, arcs, scale, translate, property, name, opt_options) {
	  var geometries = collection['geometries'];
	  var features = [];
	  for (var i = 0, ii = geometries.length; i < ii; ++i) {
	    features[i] = readFeatureFromGeometry(
	      geometries[i], arcs, scale, translate, property, name, opt_options);
	  }
	  return features;
	}
	
	
	/**
	 * Create a feature from a TopoJSON geometry object.
	 *
	 * @param {TopoJSONGeometry} object TopoJSON geometry object.
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 * @param {string|undefined} property Property to set the `GeometryCollection`'s parent
	 *     object to.
	 * @param {string} name Name of the `Topology`'s child object.
	 * @param {import("./Feature.js").ReadOptions=} opt_options Read options.
	 * @return {Feature} Feature.
	 */
	function readFeatureFromGeometry(object, arcs, scale, translate, property, name, opt_options) {
	  var geometry;
	  var type = object.type;
	  var geometryReader = GEOMETRY_READERS$1[type];
	  if ((type === 'Point') || (type === 'MultiPoint')) {
	    geometry = geometryReader(object, scale, translate);
	  } else {
	    geometry = geometryReader(object, arcs);
	  }
	  var feature = new Feature();
	  feature.setGeometry(/** @type {import("../geom/Geometry.js").default} */ (
	    transformWithOptions(geometry, false, opt_options)));
	  if (object.id !== undefined) {
	    feature.setId(object.id);
	  }
	  var properties = object.properties;
	  if (property) {
	    if (!properties) {
	      properties = {};
	    }
	    properties[property] = name;
	  }
	  if (properties) {
	    feature.setProperties(properties);
	  }
	  return feature;
	}
	
	
	/**
	 * Apply a linear transform to array of arcs.  The provided array of arcs is
	 * modified in place.
	 *
	 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 */
	function transformArcs(arcs, scale, translate) {
	  for (var i = 0, ii = arcs.length; i < ii; ++i) {
	    transformArc(arcs[i], scale, translate);
	  }
	}
	
	
	/**
	 * Apply a linear transform to an arc.  The provided arc is modified in place.
	 *
	 * @param {Array<import("../coordinate.js").Coordinate>} arc Arc.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 */
	function transformArc(arc, scale, translate) {
	  var x = 0;
	  var y = 0;
	  for (var i = 0, ii = arc.length; i < ii; ++i) {
	    var vertex = arc[i];
	    x += vertex[0];
	    y += vertex[1];
	    vertex[0] = x;
	    vertex[1] = y;
	    transformVertex(vertex, scale, translate);
	  }
	}
	
	
	/**
	 * Apply a linear transform to a vertex.  The provided vertex is modified in
	 * place.
	 *
	 * @param {import("../coordinate.js").Coordinate} vertex Vertex.
	 * @param {Array<number>} scale Scale for each dimension.
	 * @param {Array<number>} translate Translation for each dimension.
	 */
	function transformVertex(vertex, scale, translate) {
	  vertex[0] = vertex[0] * scale[0] + translate[0];
	  vertex[1] = vertex[1] * scale[1] + translate[1];
	}
	
	/**
	 * @module ol/format/filter/Filter
	 */
	
	
	/**
	 * @classdesc
	 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
	 * Base class for WFS GetFeature filters.
	 *
	 * @abstract
	 */
	var Filter = function Filter(tagName) {
	
	  /**
	   * @private
	   * @type {!string}
	   */
	  this.tagName_ = tagName;
	};
	
	/**
	 * The XML tag name for a filter.
	 * @returns {!string} Name.
	 */
	Filter.prototype.getTagName = function getTagName () {
	  return this.tagName_;
	};
	
	/**
	 * @module ol/format/filter/LogicalNary
	 */
	
	/**
	 * @classdesc
	 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
	 * Base class for WFS GetFeature n-ary logical filters.
	 *
	 * @abstract
	 */
	var LogicalNary = /*@__PURE__*/(function (Filter$$1) {
	  function LogicalNary(tagName, conditions) {
	
	    Filter$$1.call(this, tagName);
	
	    /**
	     * @type {Array<import("./Filter.js").default>}
	     */
	    this.conditions = conditions;
	    assert(this.conditions.length >= 2, 57); // At least 2 conditions are required.
	  }
	
	  if ( Filter$$1 ) { LogicalNary.__proto__ = Filter$$1; }
	  LogicalNary.prototype = Object.create( Filter$$1 && Filter$$1.prototype );
	  LogicalNary.prototype.constructor = LogicalNary;
	
	  return LogicalNary;
	}(Filter));
	
	/**
	 * @module ol/format/filter/And
	 */
	
	/**
	 * @classdesc
	 * Represents a logical `<And>` operator between two or more filter conditions.
	 *
	 * @abstract
	 */
	var And = /*@__PURE__*/(function (LogicalNary$$1) {
	  function And(conditions) {
	    LogicalNary$$1.call(this, 'And', Array.prototype.slice.call(arguments));
	  }
	
	  if ( LogicalNary$$1 ) { And.__proto__ = LogicalNary$$1; }
	  And.prototype = Object.create( LogicalNary$$1 && LogicalNary$$1.prototype );
	  And.prototype.constructor = And;
	
	  return And;
	}(LogicalNary));
	
	/**
	 * @module ol/format/filter/Bbox
	 */
	
	/**
	 * @classdesc
	 * Represents a `<BBOX>` operator to test whether a geometry-valued property
	 * intersects a fixed bounding box
	 *
	 * @api
	 */
	var Bbox = /*@__PURE__*/(function (Filter$$1) {
	  function Bbox(geometryName, extent, opt_srsName) {
	
	    Filter$$1.call(this, 'BBOX');
	
	    /**
	     * @type {!string}
	     */
	    this.geometryName = geometryName;
	
	    /**
	     * @type {import("../../extent.js").Extent}
	     */
	    this.extent = extent;
	
	    /**
	     * @type {string|undefined}
	     */
	    this.srsName = opt_srsName;
	  }
	
	  if ( Filter$$1 ) { Bbox.__proto__ = Filter$$1; }
	  Bbox.prototype = Object.create( Filter$$1 && Filter$$1.prototype );
	  Bbox.prototype.constructor = Bbox;
	
	  return Bbox;
	}(Filter));
	
	/**
	 * @module ol/format/filter/Spatial
	 */
	
	/**
	 * @classdesc
	 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
	 * Represents a spatial operator to test whether a geometry-valued property
	 * relates to a given geometry.
	 *
	 * @abstract
	 */
	var Spatial = /*@__PURE__*/(function (Filter$$1) {
	  function Spatial(tagName, geometryName, geometry, opt_srsName) {
	
	    Filter$$1.call(this, tagName);
	
	    /**
	     * @type {!string}
	     */
	    this.geometryName = geometryName || 'the_geom';
	
	    /**
	     * @type {import("../../geom/Geometry.js").default}
	     */
	    this.geometry = geometry;
	
	    /**
	     * @type {string|undefined}
	     */
	    this.srsName = opt_srsName;
	  }
	
	  if ( Filter$$1 ) { Spatial.__proto__ = Filter$$1; }
	  Spatial.prototype = Object.create( Filter$$1 && Filter$$1.prototype );
	  Spatial.prototype.constructor = Spatial;
	
	  return Spatial;
	}(Filter));
	
	/**
	 * @module ol/format/filter/Contains
	 */
	
	/**
	 * @classdesc
	 * Represents a `<Contains>` operator to test whether a geometry-valued property
	 * contains a given geometry.
	 * @api
	 */
	var Contains = /*@__PURE__*/(function (Spatial$$1) {
	  function Contains(geometryName, geometry, opt_srsName) {
	
	    Spatial$$1.call(this, 'Contains', geometryName, geometry, opt_srsName);
	
	  }
	
	  if ( Spatial$$1 ) { Contains.__proto__ = Spatial$$1; }
	  Contains.prototype = Object.create( Spatial$$1 && Spatial$$1.prototype );
	  Contains.prototype.constructor = Contains;
	
	  return Contains;
	}(Spatial));
	
	/**
	 * @module ol/format/filter/Comparison
	 */
	
	/**
	 * @classdesc
	 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
	 * Base class for WFS GetFeature property comparison filters.
	 *
	 * @abstract
	 */
	var Comparison = /*@__PURE__*/(function (Filter$$1) {
	  function Comparison(tagName, propertyName) {
	
	    Filter$$1.call(this, tagName);
	
	    /**
	     * @type {!string}
	     */
	    this.propertyName = propertyName;
	  }
	
	  if ( Filter$$1 ) { Comparison.__proto__ = Filter$$1; }
	  Comparison.prototype = Object.create( Filter$$1 && Filter$$1.prototype );
	  Comparison.prototype.constructor = Comparison;
	
	  return Comparison;
	}(Filter));
	
	/**
	 * @module ol/format/filter/During
	 */
	
	/**
	 * @classdesc
	 * Represents a `<During>` comparison operator.
	 * @api
	 */
	var During = /*@__PURE__*/(function (Comparison$$1) {
	  function During(propertyName, begin, end) {
	    Comparison$$1.call(this, 'During', propertyName);
	
	    /**
	     * @type {!string}
	     */
	    this.begin = begin;
	
	    /**
	     * @type {!string}
	     */
	    this.end = end;
	  }
	
	  if ( Comparison$$1 ) { During.__proto__ = Comparison$$1; }
	  During.prototype = Object.create( Comparison$$1 && Comparison$$1.prototype );
	  During.prototype.constructor = During;
	
	  return During;
	}(Comparison));
	
	/**
	 * @module ol/format/filter/ComparisonBinary
	 */
	
	/**
	 * @classdesc
	 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
	 * Base class for WFS GetFeature property binary comparison filters.
	 *
	 * @abstract
	 */
	var ComparisonBinary = /*@__PURE__*/(function (Comparison$$1) {
	  function ComparisonBinary(tagName, propertyName, expression, opt_matchCase) {
	
	    Comparison$$1.call(this, tagName, propertyName);
	
	    /**
	     * @type {!(string|number)}
	     */
	    this.expression = expression;
	
	    /**
	     * @type {boolean|undefined}
	     */
	    this.matchCase = opt_matchCase;
	  }
	
	  if ( Comparison$$1 ) { ComparisonBinary.__proto__ = Comparison$$1; }
	  ComparisonBinary.prototype = Object.create( Comparison$$1 && Comparison$$1.prototype );
	  ComparisonBinary.prototype.constructor = ComparisonBinary;
	
	  return ComparisonBinary;
	}(Comparison));
	
	/**
	 * @module ol/format/filter/EqualTo
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsEqualTo>` comparison operator.
	 * @api
	 */
	var EqualTo = /*@__PURE__*/(function (ComparisonBinary$$1) {
	  function EqualTo(propertyName, expression, opt_matchCase) {
	    ComparisonBinary$$1.call(this, 'PropertyIsEqualTo', propertyName, expression, opt_matchCase);
	  }
	
	  if ( ComparisonBinary$$1 ) { EqualTo.__proto__ = ComparisonBinary$$1; }
	  EqualTo.prototype = Object.create( ComparisonBinary$$1 && ComparisonBinary$$1.prototype );
	  EqualTo.prototype.constructor = EqualTo;
	
	  return EqualTo;
	}(ComparisonBinary));
	
	/**
	 * @module ol/format/filter/GreaterThan
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsGreaterThan>` comparison operator.
	 * @api
	 */
	var GreaterThan = /*@__PURE__*/(function (ComparisonBinary$$1) {
	  function GreaterThan(propertyName, expression) {
	    ComparisonBinary$$1.call(this, 'PropertyIsGreaterThan', propertyName, expression);
	  }
	
	  if ( ComparisonBinary$$1 ) { GreaterThan.__proto__ = ComparisonBinary$$1; }
	  GreaterThan.prototype = Object.create( ComparisonBinary$$1 && ComparisonBinary$$1.prototype );
	  GreaterThan.prototype.constructor = GreaterThan;
	
	  return GreaterThan;
	}(ComparisonBinary));
	
	/**
	 * @module ol/format/filter/GreaterThanOrEqualTo
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsGreaterThanOrEqualTo>` comparison operator.
	 * @api
	 */
	var GreaterThanOrEqualTo = /*@__PURE__*/(function (ComparisonBinary$$1) {
	  function GreaterThanOrEqualTo(propertyName, expression) {
	    ComparisonBinary$$1.call(this, 'PropertyIsGreaterThanOrEqualTo', propertyName, expression);
	  }
	
	  if ( ComparisonBinary$$1 ) { GreaterThanOrEqualTo.__proto__ = ComparisonBinary$$1; }
	  GreaterThanOrEqualTo.prototype = Object.create( ComparisonBinary$$1 && ComparisonBinary$$1.prototype );
	  GreaterThanOrEqualTo.prototype.constructor = GreaterThanOrEqualTo;
	
	  return GreaterThanOrEqualTo;
	}(ComparisonBinary));
	
	/**
	 * @module ol/format/filter/Intersects
	 */
	
	/**
	 * @classdesc
	 * Represents a `<Intersects>` operator to test whether a geometry-valued property
	 * intersects a given geometry.
	 * @api
	 */
	var Intersects = /*@__PURE__*/(function (Spatial$$1) {
	  function Intersects(geometryName, geometry, opt_srsName) {
	    Spatial$$1.call(this, 'Intersects', geometryName, geometry, opt_srsName);
	  }
	
	  if ( Spatial$$1 ) { Intersects.__proto__ = Spatial$$1; }
	  Intersects.prototype = Object.create( Spatial$$1 && Spatial$$1.prototype );
	  Intersects.prototype.constructor = Intersects;
	
	  return Intersects;
	}(Spatial));
	
	/**
	 * @module ol/format/filter/IsBetween
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsBetween>` comparison operator.
	 * @api
	 */
	var IsBetween = /*@__PURE__*/(function (Comparison$$1) {
	  function IsBetween(propertyName, lowerBoundary, upperBoundary) {
	    Comparison$$1.call(this, 'PropertyIsBetween', propertyName);
	
	    /**
	     * @type {!number}
	     */
	    this.lowerBoundary = lowerBoundary;
	
	    /**
	     * @type {!number}
	     */
	    this.upperBoundary = upperBoundary;
	
	  }
	
	  if ( Comparison$$1 ) { IsBetween.__proto__ = Comparison$$1; }
	  IsBetween.prototype = Object.create( Comparison$$1 && Comparison$$1.prototype );
	  IsBetween.prototype.constructor = IsBetween;
	
	  return IsBetween;
	}(Comparison));
	
	/**
	 * @module ol/format/filter/IsLike
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsLike>` comparison operator.
	 * @api
	 */
	var IsLike = /*@__PURE__*/(function (Comparison$$1) {
	  function IsLike(propertyName, pattern, opt_wildCard, opt_singleChar, opt_escapeChar, opt_matchCase) {
	    Comparison$$1.call(this, 'PropertyIsLike', propertyName);
	
	    /**
	     * @type {!string}
	     */
	    this.pattern = pattern;
	
	    /**
	     * @type {!string}
	     */
	    this.wildCard = (opt_wildCard !== undefined) ? opt_wildCard : '*';
	
	    /**
	     * @type {!string}
	     */
	    this.singleChar = (opt_singleChar !== undefined) ? opt_singleChar : '.';
	
	    /**
	     * @type {!string}
	     */
	    this.escapeChar = (opt_escapeChar !== undefined) ? opt_escapeChar : '!';
	
	    /**
	     * @type {boolean|undefined}
	     */
	    this.matchCase = opt_matchCase;
	
	  }
	
	  if ( Comparison$$1 ) { IsLike.__proto__ = Comparison$$1; }
	  IsLike.prototype = Object.create( Comparison$$1 && Comparison$$1.prototype );
	  IsLike.prototype.constructor = IsLike;
	
	  return IsLike;
	}(Comparison));
	
	/**
	 * @module ol/format/filter/IsNull
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsNull>` comparison operator.
	 * @api
	 */
	var IsNull = /*@__PURE__*/(function (Comparison$$1) {
	  function IsNull(propertyName) {
	    Comparison$$1.call(this, 'PropertyIsNull', propertyName);
	  }
	
	  if ( Comparison$$1 ) { IsNull.__proto__ = Comparison$$1; }
	  IsNull.prototype = Object.create( Comparison$$1 && Comparison$$1.prototype );
	  IsNull.prototype.constructor = IsNull;
	
	  return IsNull;
	}(Comparison));
	
	/**
	 * @module ol/format/filter/LessThan
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsLessThan>` comparison operator.
	 * @api
	 */
	var LessThan = /*@__PURE__*/(function (ComparisonBinary$$1) {
	  function LessThan(propertyName, expression) {
	    ComparisonBinary$$1.call(this, 'PropertyIsLessThan', propertyName, expression);
	  }
	
	  if ( ComparisonBinary$$1 ) { LessThan.__proto__ = ComparisonBinary$$1; }
	  LessThan.prototype = Object.create( ComparisonBinary$$1 && ComparisonBinary$$1.prototype );
	  LessThan.prototype.constructor = LessThan;
	
	  return LessThan;
	}(ComparisonBinary));
	
	/**
	 * @module ol/format/filter/LessThanOrEqualTo
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsLessThanOrEqualTo>` comparison operator.
	 * @api
	 */
	var LessThanOrEqualTo = /*@__PURE__*/(function (ComparisonBinary$$1) {
	  function LessThanOrEqualTo(propertyName, expression) {
	    ComparisonBinary$$1.call(this, 'PropertyIsLessThanOrEqualTo', propertyName, expression);
	  }
	
	  if ( ComparisonBinary$$1 ) { LessThanOrEqualTo.__proto__ = ComparisonBinary$$1; }
	  LessThanOrEqualTo.prototype = Object.create( ComparisonBinary$$1 && ComparisonBinary$$1.prototype );
	  LessThanOrEqualTo.prototype.constructor = LessThanOrEqualTo;
	
	  return LessThanOrEqualTo;
	}(ComparisonBinary));
	
	/**
	 * @module ol/format/filter/Not
	 */
	
	/**
	 * @classdesc
	 * Represents a logical `<Not>` operator for a filter condition.
	 * @api
	 */
	var Not = /*@__PURE__*/(function (Filter$$1) {
	  function Not(condition) {
	
	    Filter$$1.call(this, 'Not');
	
	    /**
	     * @type {!import("./Filter.js").default}
	     */
	    this.condition = condition;
	
	  }
	
	  if ( Filter$$1 ) { Not.__proto__ = Filter$$1; }
	  Not.prototype = Object.create( Filter$$1 && Filter$$1.prototype );
	  Not.prototype.constructor = Not;
	
	  return Not;
	}(Filter));
	
	/**
	 * @module ol/format/filter/NotEqualTo
	 */
	
	/**
	 * @classdesc
	 * Represents a `<PropertyIsNotEqualTo>` comparison operator.
	 * @api
	 */
	var NotEqualTo = /*@__PURE__*/(function (ComparisonBinary$$1) {
	  function NotEqualTo(propertyName, expression, opt_matchCase) {
	    ComparisonBinary$$1.call(this, 'PropertyIsNotEqualTo', propertyName, expression, opt_matchCase);
	  }
	
	  if ( ComparisonBinary$$1 ) { NotEqualTo.__proto__ = ComparisonBinary$$1; }
	  NotEqualTo.prototype = Object.create( ComparisonBinary$$1 && ComparisonBinary$$1.prototype );
	  NotEqualTo.prototype.constructor = NotEqualTo;
	
	  return NotEqualTo;
	}(ComparisonBinary));
	
	/**
	 * @module ol/format/filter/Or
	 */
	
	/**
	 * @classdesc
	 * Represents a logical `<Or>` operator between two ore more filter conditions.
	 * @api
	 */
	var Or = /*@__PURE__*/(function (LogicalNary$$1) {
	  function Or(conditions) {
	    LogicalNary$$1.call(this, 'Or', Array.prototype.slice.call(arguments));
	  }
	
	  if ( LogicalNary$$1 ) { Or.__proto__ = LogicalNary$$1; }
	  Or.prototype = Object.create( LogicalNary$$1 && LogicalNary$$1.prototype );
	  Or.prototype.constructor = Or;
	
	  return Or;
	}(LogicalNary));
	
	/**
	 * @module ol/format/filter/Within
	 */
	
	/**
	 * @classdesc
	 * Represents a `<Within>` operator to test whether a geometry-valued property
	 * is within a given geometry.
	 * @api
	 */
	var Within = /*@__PURE__*/(function (Spatial$$1) {
	  function Within(geometryName, geometry, opt_srsName) {
	    Spatial$$1.call(this, 'Within', geometryName, geometry, opt_srsName);
	  }
	
	  if ( Spatial$$1 ) { Within.__proto__ = Spatial$$1; }
	  Within.prototype = Object.create( Spatial$$1 && Spatial$$1.prototype );
	  Within.prototype.constructor = Within;
	
	  return Within;
	}(Spatial));
	
	/**
	 * @module ol/format/filter
	 */
	
	
	/**
	 * Create a logical `<And>` operator between two or more filter conditions.
	 *
	 * @param {...import("./filter/Filter.js").default} conditions Filter conditions.
	 * @returns {!And} `<And>` operator.
	 * @api
	 */
	function and(conditions) {
	  var params = [null].concat(Array.prototype.slice.call(arguments));
	  return new (Function.prototype.bind.apply(And, params));
	}
	
	
	/**
	 * Create a logical `<Or>` operator between two or more filter conditions.
	 *
	 * @param {...import("./filter/Filter.js").default} conditions Filter conditions.
	 * @returns {!Or} `<Or>` operator.
	 * @api
	 */
	function or(conditions) {
	  var params = [null].concat(Array.prototype.slice.call(arguments));
	  return new (Function.prototype.bind.apply(Or, params));
	}
	
	
	/**
	 * Represents a logical `<Not>` operator for a filter condition.
	 *
	 * @param {!import("./filter/Filter.js").default} condition Filter condition.
	 * @returns {!Not} `<Not>` operator.
	 * @api
	 */
	function not(condition) {
	  return new Not(condition);
	}
	
	
	/**
	 * Create a `<BBOX>` operator to test whether a geometry-valued property
	 * intersects a fixed bounding box
	 *
	 * @param {!string} geometryName Geometry name to use.
	 * @param {!import("../extent.js").Extent} extent Extent.
	 * @param {string=} opt_srsName SRS name. No srsName attribute will be
	 *    set on geometries when this is not provided.
	 * @returns {!Bbox} `<BBOX>` operator.
	 * @api
	 */
	function bbox$1(geometryName, extent, opt_srsName) {
	  return new Bbox(geometryName, extent, opt_srsName);
	}
	
	/**
	 * Create a `<Contains>` operator to test whether a geometry-valued property
	 * contains a given geometry.
	 *
	 * @param {!string} geometryName Geometry name to use.
	 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {string=} opt_srsName SRS name. No srsName attribute will be
	 *    set on geometries when this is not provided.
	 * @returns {!Contains} `<Contains>` operator.
	 * @api
	 */
	function contains$1(geometryName, geometry, opt_srsName) {
	  return new Contains(geometryName, geometry, opt_srsName);
	}
	
	/**
	 * Create a `<Intersects>` operator to test whether a geometry-valued property
	 * intersects a given geometry.
	 *
	 * @param {!string} geometryName Geometry name to use.
	 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {string=} opt_srsName SRS name. No srsName attribute will be
	 *    set on geometries when this is not provided.
	 * @returns {!Intersects} `<Intersects>` operator.
	 * @api
	 */
	function intersects$2(geometryName, geometry, opt_srsName) {
	  return new Intersects(geometryName, geometry, opt_srsName);
	}
	
	/**
	 * Create a `<Within>` operator to test whether a geometry-valued property
	 * is within a given geometry.
	 *
	 * @param {!string} geometryName Geometry name to use.
	 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
	 * @param {string=} opt_srsName SRS name. No srsName attribute will be
	 *    set on geometries when this is not provided.
	 * @returns {!Within} `<Within>` operator.
	 * @api
	 */
	function within(geometryName, geometry, opt_srsName) {
	  return new Within(geometryName, geometry, opt_srsName);
	}
	
	
	/**
	 * Creates a `<PropertyIsEqualTo>` comparison operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!(string|number)} expression The value to compare.
	 * @param {boolean=} opt_matchCase Case-sensitive?
	 * @returns {!EqualTo} `<PropertyIsEqualTo>` operator.
	 * @api
	 */
	function equalTo(propertyName, expression, opt_matchCase) {
	  return new EqualTo(propertyName, expression, opt_matchCase);
	}
	
	
	/**
	 * Creates a `<PropertyIsNotEqualTo>` comparison operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!(string|number)} expression The value to compare.
	 * @param {boolean=} opt_matchCase Case-sensitive?
	 * @returns {!NotEqualTo} `<PropertyIsNotEqualTo>` operator.
	 * @api
	 */
	function notEqualTo(propertyName, expression, opt_matchCase) {
	  return new NotEqualTo(propertyName, expression, opt_matchCase);
	}
	
	
	/**
	 * Creates a `<PropertyIsLessThan>` comparison operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!number} expression The value to compare.
	 * @returns {!LessThan} `<PropertyIsLessThan>` operator.
	 * @api
	 */
	function lessThan(propertyName, expression) {
	  return new LessThan(propertyName, expression);
	}
	
	
	/**
	 * Creates a `<PropertyIsLessThanOrEqualTo>` comparison operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!number} expression The value to compare.
	 * @returns {!LessThanOrEqualTo} `<PropertyIsLessThanOrEqualTo>` operator.
	 * @api
	 */
	function lessThanOrEqualTo(propertyName, expression) {
	  return new LessThanOrEqualTo(propertyName, expression);
	}
	
	
	/**
	 * Creates a `<PropertyIsGreaterThan>` comparison operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!number} expression The value to compare.
	 * @returns {!GreaterThan} `<PropertyIsGreaterThan>` operator.
	 * @api
	 */
	function greaterThan(propertyName, expression) {
	  return new GreaterThan(propertyName, expression);
	}
	
	
	/**
	 * Creates a `<PropertyIsGreaterThanOrEqualTo>` comparison operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!number} expression The value to compare.
	 * @returns {!GreaterThanOrEqualTo} `<PropertyIsGreaterThanOrEqualTo>` operator.
	 * @api
	 */
	function greaterThanOrEqualTo(propertyName, expression) {
	  return new GreaterThanOrEqualTo(propertyName, expression);
	}
	
	
	/**
	 * Creates a `<PropertyIsNull>` comparison operator to test whether a property value
	 * is null.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @returns {!IsNull} `<PropertyIsNull>` operator.
	 * @api
	 */
	function isNull(propertyName) {
	  return new IsNull(propertyName);
	}
	
	
	/**
	 * Creates a `<PropertyIsBetween>` comparison operator to test whether an expression
	 * value lies within a range given by a lower and upper bound (inclusive).
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!number} lowerBoundary The lower bound of the range.
	 * @param {!number} upperBoundary The upper bound of the range.
	 * @returns {!IsBetween} `<PropertyIsBetween>` operator.
	 * @api
	 */
	function between(propertyName, lowerBoundary, upperBoundary) {
	  return new IsBetween(propertyName, lowerBoundary, upperBoundary);
	}
	
	
	/**
	 * Represents a `<PropertyIsLike>` comparison operator that matches a string property
	 * value against a text pattern.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!string} pattern Text pattern.
	 * @param {string=} opt_wildCard Pattern character which matches any sequence of
	 *    zero or more string characters. Default is '*'.
	 * @param {string=} opt_singleChar pattern character which matches any single
	 *    string character. Default is '.'.
	 * @param {string=} opt_escapeChar Escape character which can be used to escape
	 *    the pattern characters. Default is '!'.
	 * @param {boolean=} opt_matchCase Case-sensitive?
	 * @returns {!IsLike} `<PropertyIsLike>` operator.
	 * @api
	 */
	function like(propertyName, pattern,
	  opt_wildCard, opt_singleChar, opt_escapeChar, opt_matchCase) {
	  return new IsLike(propertyName, pattern,
	    opt_wildCard, opt_singleChar, opt_escapeChar, opt_matchCase);
	}
	
	
	/**
	 * Create a `<During>` temporal operator.
	 *
	 * @param {!string} propertyName Name of the context property to compare.
	 * @param {!string} begin The begin date in ISO-8601 format.
	 * @param {!string} end The end date in ISO-8601 format.
	 * @returns {!During} `<During>` operator.
	 * @api
	 */
	function during(propertyName, begin, end) {
	  return new During(propertyName, begin, end);
	}
	
	/**
	 * @module ol/format/WFS
	 */
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var FEATURE_COLLECTION_PARSERS = {
	  'http://www.opengis.net/gml': {
	    'boundedBy': makeObjectPropertySetter(
	      GMLBase.prototype.readGeometryElement, 'bounds')
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TRANSACTION_SUMMARY_PARSERS = {
	  'http://www.opengis.net/wfs': {
	    'totalInserted': makeObjectPropertySetter(readNonNegativeInteger),
	    'totalUpdated': makeObjectPropertySetter(readNonNegativeInteger),
	    'totalDeleted': makeObjectPropertySetter(readNonNegativeInteger)
	  }
	};
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TRANSACTION_RESPONSE_PARSERS = {
	  'http://www.opengis.net/wfs': {
	    'TransactionSummary': makeObjectPropertySetter(
	      readTransactionSummary, 'transactionSummary'),
	    'InsertResults': makeObjectPropertySetter(
	      readInsertResults, 'insertIds')
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var QUERY_SERIALIZERS = {
	  'http://www.opengis.net/wfs': {
	    'PropertyName': makeChildAppender(writeStringTextNode)
	  }
	};
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var TRANSACTION_SERIALIZERS = {
	  'http://www.opengis.net/wfs': {
	    'Insert': makeChildAppender(writeFeature),
	    'Update': makeChildAppender(writeUpdate),
	    'Delete': makeChildAppender(writeDelete),
	    'Property': makeChildAppender(writeProperty),
	    'Native': makeChildAppender(writeNative)
	  }
	};
	
	
	/**
	 * @typedef {Object} Options
	 * @property {Object<string, string>|string} [featureNS] The namespace URI used for features.
	 * @property {Array<string>|string} [featureType] The feature type to parse. Only used for read operations.
	 * @property {GMLBase} [gmlFormat] The GML format to use to parse the response. Default is `ol/format/GML3`.
	 * @property {string} [schemaLocation] Optional schemaLocation to use for serialization, this will override the default.
	 */
	
	
	/**
	 * @typedef {Object} WriteGetFeatureOptions
	 * @property {string} featureNS The namespace URI used for features.
	 * @property {string} featurePrefix The prefix for the feature namespace.
	 * @property {Array<string>} featureTypes The feature type names.
	 * @property {string} [srsName] SRS name. No srsName attribute will be set on
	 * geometries when this is not provided.
	 * @property {string} [handle] Handle.
	 * @property {string} [outputFormat] Output format.
	 * @property {number} [maxFeatures] Maximum number of features to fetch.
	 * @property {string} [geometryName] Geometry name to use in a BBOX filter.
	 * @property {Array<string>} [propertyNames] Optional list of property names to serialize.
	 * @property {string} [viewParams] viewParams GeoServer vendor parameter.
	 * @property {number} [startIndex] Start index to use for WFS paging. This is a
	 * WFS 2.0 feature backported to WFS 1.1.0 by some Web Feature Services.
	 * @property {number} [count] Number of features to retrieve when paging. This is a
	 * WFS 2.0 feature backported to WFS 1.1.0 by some Web Feature Services. Please note that some
	 * Web Feature Services have repurposed `maxfeatures` instead.
	 * @property {import("../extent.js").Extent} [bbox] Extent to use for the BBOX filter.
	 * @property {import("./filter/Filter.js").default} [filter] Filter condition. See
	 * {@link module:ol/format/Filter} for more information.
	 * @property {string} [resultType] Indicates what response should be returned,
	 * E.g. `hits` only includes the `numberOfFeatures` attribute in the response and no features.
	 */
	
	
	/**
	 * @typedef {Object} WriteTransactionOptions
	 * @property {string} featureNS The namespace URI used for features.
	 * @property {string} featurePrefix The prefix for the feature namespace.
	 * @property {string} featureType The feature type name.
	 * @property {string} [srsName] SRS name. No srsName attribute will be set on
	 * geometries when this is not provided.
	 * @property {string} [handle] Handle.
	 * @property {boolean} [hasZ] Must be set to true if the transaction is for
	 * a 3D layer. This will allow the Z coordinate to be included in the transaction.
	 * @property {Array<Object>} nativeElements Native elements. Currently not supported.
	 * @property {import("./GMLBase.js").Options} [gmlOptions] GML options for the WFS transaction writer.
	 * @property {string} [version='1.1.0'] WFS version to use for the transaction. Can be either `1.0.0` or `1.1.0`.
	 */
	
	
	/**
	 * Number of features; bounds/extent.
	 * @typedef {Object} FeatureCollectionMetadata
	 * @property {number} numberOfFeatures
	 * @property {import("../extent.js").Extent} bounds
	 */
	
	
	/**
	 * Total deleted; total inserted; total updated; array of insert ids.
	 * @typedef {Object} TransactionResponse
	 * @property {number} totalDeleted
	 * @property {number} totalInserted
	 * @property {number} totalUpdated
	 * @property {Array<string>} insertIds
	 */
	
	
	/**
	 * @type {string}
	 */
	var FEATURE_PREFIX = 'feature';
	
	
	/**
	 * @type {string}
	 */
	var XMLNS = 'http://www.w3.org/2000/xmlns/';
	
	
	/**
	 * @type {string}
	 */
	var OGCNS = 'http://www.opengis.net/ogc';
	
	
	/**
	 * @type {string}
	 */
	var WFSNS = 'http://www.opengis.net/wfs';
	
	
	/**
	 * @type {string}
	 */
	var FESNS = 'http://www.opengis.net/fes';
	
	
	/**
	 * @type {Object<string, string>}
	 */
	var SCHEMA_LOCATIONS = {
	  '1.1.0': 'http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd',
	  '1.0.0': 'http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.0.0/wfs.xsd'
	};
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var DEFAULT_VERSION = '1.1.0';
	
	
	/**
	 * @classdesc
	 * Feature format for reading and writing data in the WFS format.
	 * By default, supports WFS version 1.1.0. You can pass a GML format
	 * as option if you want to read a WFS that contains GML2 (WFS 1.0.0).
	 * Also see {@link module:ol/format/GMLBase~GMLBase} which is used by this format.
	 *
	 * @api
	 */
	var WFS = /*@__PURE__*/(function (XMLFeature$$1) {
	  function WFS(opt_options) {
	    XMLFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {Array<string>|string|undefined}
	     */
	    this.featureType_ = options.featureType;
	
	    /**
	     * @private
	     * @type {Object<string, string>|string|undefined}
	     */
	    this.featureNS_ = options.featureNS;
	
	    /**
	     * @private
	     * @type {GMLBase}
	     */
	    this.gmlFormat_ = options.gmlFormat ?
	      options.gmlFormat : new GML3();
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.schemaLocation_ = options.schemaLocation ?
	      options.schemaLocation : SCHEMA_LOCATIONS[DEFAULT_VERSION];
	  }
	
	  if ( XMLFeature$$1 ) { WFS.__proto__ = XMLFeature$$1; }
	  WFS.prototype = Object.create( XMLFeature$$1 && XMLFeature$$1.prototype );
	  WFS.prototype.constructor = WFS;
	
	  /**
	   * @return {Array<string>|string|undefined} featureType
	   */
	  WFS.prototype.getFeatureType = function getFeatureType () {
	    return this.featureType_;
	  };
	
	  /**
	   * @param {Array<string>|string|undefined} featureType Feature type(s) to parse.
	   */
	  WFS.prototype.setFeatureType = function setFeatureType (featureType) {
	    this.featureType_ = featureType;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WFS.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    /** @type {import("../xml.js").NodeStackItem} */
	    var context = {
	      node: node
	    };
	    assign(context, {
	      'featureType': this.featureType_,
	      'featureNS': this.featureNS_
	    });
	
	    assign(context, this.getReadOptions(node, opt_options ? opt_options : {}));
	    var objectStack = [context];
	    this.gmlFormat_.FEATURE_COLLECTION_PARSERS[GMLNS][
	      'featureMember'] =
	        makeArrayPusher(GMLBase.prototype.readFeaturesInternal);
	    var features = pushParseAndPop([],
	      this.gmlFormat_.FEATURE_COLLECTION_PARSERS, node,
	      objectStack, this.gmlFormat_);
	    if (!features) {
	      features = [];
	    }
	    return features;
	  };
	
	  /**
	   * Read transaction response of the source.
	   *
	   * @param {Document|Element|Object|string} source Source.
	   * @return {TransactionResponse|undefined} Transaction response.
	   * @api
	   */
	  WFS.prototype.readTransactionResponse = function readTransactionResponse (source) {
	    if (!source) {
	      return undefined;
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readTransactionResponseFromDocument(doc);
	    } else if (isDocument(source)) {
	      return this.readTransactionResponseFromDocument(
	        /** @type {Document} */ (source));
	    } else {
	      return this.readTransactionResponseFromNode(/** @type {Element} */ (source));
	    }
	  };
	
	  /**
	   * Read feature collection metadata of the source.
	   *
	   * @param {Document|Element|Object|string} source Source.
	   * @return {FeatureCollectionMetadata|undefined}
	   *     FeatureCollection metadata.
	   * @api
	   */
	  WFS.prototype.readFeatureCollectionMetadata = function readFeatureCollectionMetadata (source) {
	    if (!source) {
	      return undefined;
	    } else if (typeof source === 'string') {
	      var doc = parse(source);
	      return this.readFeatureCollectionMetadataFromDocument(doc);
	    } else if (isDocument(source)) {
	      return this.readFeatureCollectionMetadataFromDocument(
	        /** @type {Document} */ (source));
	    } else {
	      return this.readFeatureCollectionMetadataFromNode(
	        /** @type {Element} */ (source));
	    }
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @return {FeatureCollectionMetadata|undefined}
	   *     FeatureCollection metadata.
	   */
	  WFS.prototype.readFeatureCollectionMetadataFromDocument = function readFeatureCollectionMetadataFromDocument (doc) {
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        return this.readFeatureCollectionMetadataFromNode(/** @type {Element} */ (n));
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @return {FeatureCollectionMetadata|undefined}
	   *     FeatureCollection metadata.
	   */
	  WFS.prototype.readFeatureCollectionMetadataFromNode = function readFeatureCollectionMetadataFromNode (node) {
	    var result = {};
	    var value = readNonNegativeIntegerString(
	      node.getAttribute('numberOfFeatures'));
	    result['numberOfFeatures'] = value;
	    return pushParseAndPop(
	      /** @type {FeatureCollectionMetadata} */ (result),
	      FEATURE_COLLECTION_PARSERS, node, [], this.gmlFormat_);
	  };
	
	  /**
	   * @param {Document} doc Document.
	   * @return {TransactionResponse|undefined} Transaction response.
	   */
	  WFS.prototype.readTransactionResponseFromDocument = function readTransactionResponseFromDocument (doc) {
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        return this.readTransactionResponseFromNode(/** @type {Element} */ (n));
	      }
	    }
	    return undefined;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @return {TransactionResponse|undefined} Transaction response.
	   */
	  WFS.prototype.readTransactionResponseFromNode = function readTransactionResponseFromNode (node) {
	    return pushParseAndPop(
	      /** @type {TransactionResponse} */({}),
	      TRANSACTION_RESPONSE_PARSERS, node, []);
	  };
	
	  /**
	   * Encode format as WFS `GetFeature` and return the Node.
	   *
	   * @param {WriteGetFeatureOptions} options Options.
	   * @return {Node} Result.
	   * @api
	   */
	  WFS.prototype.writeGetFeature = function writeGetFeature$1 (options) {
	    var node = createElementNS(WFSNS, 'GetFeature');
	    node.setAttribute('service', 'WFS');
	    node.setAttribute('version', '1.1.0');
	    var filter;
	    if (options) {
	      if (options.handle) {
	        node.setAttribute('handle', options.handle);
	      }
	      if (options.outputFormat) {
	        node.setAttribute('outputFormat', options.outputFormat);
	      }
	      if (options.maxFeatures !== undefined) {
	        node.setAttribute('maxFeatures', String(options.maxFeatures));
	      }
	      if (options.resultType) {
	        node.setAttribute('resultType', options.resultType);
	      }
	      if (options.startIndex !== undefined) {
	        node.setAttribute('startIndex', String(options.startIndex));
	      }
	      if (options.count !== undefined) {
	        node.setAttribute('count', String(options.count));
	      }
	      if (options.viewParams !== undefined) {
	        node.setAttribute('viewParams ', options.viewParams);
	      }
	      filter = options.filter;
	      if (options.bbox) {
	        assert(options.geometryName,
	          12); // `options.geometryName` must also be provided when `options.bbox` is set
	        var bbox$$1 = bbox$1(
	          /** @type {string} */ (options.geometryName), options.bbox, options.srsName);
	        if (filter) {
	          // if bbox and filter are both set, combine the two into a single filter
	          filter = and(filter, bbox$$1);
	        } else {
	          filter = bbox$$1;
	        }
	      }
	    }
	    node.setAttributeNS(XML_SCHEMA_INSTANCE_URI, 'xsi:schemaLocation', this.schemaLocation_);
	    /** @type {import("../xml.js").NodeStackItem} */
	    var context = {
	      node: node
	    };
	    assign(context, {
	      'srsName': options.srsName,
	      'featureNS': options.featureNS ? options.featureNS : this.featureNS_,
	      'featurePrefix': options.featurePrefix,
	      'geometryName': options.geometryName,
	      'filter': filter,
	      'propertyNames': options.propertyNames ? options.propertyNames : []
	    });
	
	    assert(Array.isArray(options.featureTypes),
	      11); // `options.featureTypes` should be an Array
	    writeGetFeature(node, /** @type {!Array<string>} */ (options.featureTypes), [context]);
	    return node;
	  };
	
	  /**
	   * Encode format as WFS `Transaction` and return the Node.
	   *
	   * @param {Array<import("../Feature.js").default>} inserts The features to insert.
	   * @param {Array<import("../Feature.js").default>} updates The features to update.
	   * @param {Array<import("../Feature.js").default>} deletes The features to delete.
	   * @param {WriteTransactionOptions} options Write options.
	   * @return {Node} Result.
	   * @api
	   */
	  WFS.prototype.writeTransaction = function writeTransaction (inserts, updates, deletes, options) {
	    var objectStack = [];
	    var node = createElementNS(WFSNS, 'Transaction');
	    var version = options.version ? options.version : DEFAULT_VERSION;
	    var gmlVersion = version === '1.0.0' ? 2 : 3;
	    node.setAttribute('service', 'WFS');
	    node.setAttribute('version', version);
	    var baseObj;
	    /** @type {import("../xml.js").NodeStackItem} */
	    var obj;
	    if (options) {
	      baseObj = options.gmlOptions ? options.gmlOptions : {};
	      if (options.handle) {
	        node.setAttribute('handle', options.handle);
	      }
	    }
	    var schemaLocation = SCHEMA_LOCATIONS[version];
	    node.setAttributeNS(XML_SCHEMA_INSTANCE_URI, 'xsi:schemaLocation', schemaLocation);
	    var featurePrefix = options.featurePrefix ? options.featurePrefix : FEATURE_PREFIX;
	    if (inserts) {
	      obj = assign({node: node}, {'featureNS': options.featureNS,
	        'featureType': options.featureType, 'featurePrefix': featurePrefix,
	        'gmlVersion': gmlVersion, 'hasZ': options.hasZ, 'srsName': options.srsName});
	      assign(obj, baseObj);
	      pushSerializeAndPop(obj,
	        TRANSACTION_SERIALIZERS,
	        makeSimpleNodeFactory('Insert'), inserts,
	        objectStack);
	    }
	    if (updates) {
	      obj = assign({node: node}, {'featureNS': options.featureNS,
	        'featureType': options.featureType, 'featurePrefix': featurePrefix,
	        'gmlVersion': gmlVersion, 'hasZ': options.hasZ, 'srsName': options.srsName});
	      assign(obj, baseObj);
	      pushSerializeAndPop(obj,
	        TRANSACTION_SERIALIZERS,
	        makeSimpleNodeFactory('Update'), updates,
	        objectStack);
	    }
	    if (deletes) {
	      pushSerializeAndPop({node: node, 'featureNS': options.featureNS,
	        'featureType': options.featureType, 'featurePrefix': featurePrefix,
	        'gmlVersion': gmlVersion, 'srsName': options.srsName},
	      TRANSACTION_SERIALIZERS,
	      makeSimpleNodeFactory('Delete'), deletes,
	      objectStack);
	    }
	    if (options.nativeElements) {
	      pushSerializeAndPop({node: node, 'featureNS': options.featureNS,
	        'featureType': options.featureType, 'featurePrefix': featurePrefix,
	        'gmlVersion': gmlVersion, 'srsName': options.srsName},
	      TRANSACTION_SERIALIZERS,
	      makeSimpleNodeFactory('Native'), options.nativeElements,
	      objectStack);
	    }
	    return node;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WFS.prototype.readProjectionFromDocument = function readProjectionFromDocument (doc) {
	    for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        return this.readProjectionFromNode(n);
	      }
	    }
	    return null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WFS.prototype.readProjectionFromNode = function readProjectionFromNode (node) {
	    if (node.firstElementChild &&
	        node.firstElementChild.firstElementChild) {
	      node = node.firstElementChild.firstElementChild;
	      for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
	        if (!(n.childNodes.length === 0 ||
	            (n.childNodes.length === 1 &&
	            n.firstChild.nodeType === 3))) {
	          var objectStack = [{}];
	          this.gmlFormat_.readGeometryElement(n, objectStack);
	          return get$2(objectStack.pop().srsName);
	        }
	      }
	    }
	
	    return null;
	  };
	
	  return WFS;
	}(XMLFeature));
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Transaction Summary.
	 */
	function readTransactionSummary(node, objectStack) {
	  return pushParseAndPop(
	    {}, TRANSACTION_SUMMARY_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var OGC_FID_PARSERS = {
	  'http://www.opengis.net/ogc': {
	    'FeatureId': makeArrayPusher(function(node, objectStack) {
	      return node.getAttribute('fid');
	    })
	  }
	};
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 */
	function fidParser(node, objectStack) {
	  parseNode(OGC_FID_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var INSERT_RESULTS_PARSERS = {
	  'http://www.opengis.net/wfs': {
	    'Feature': fidParser
	  }
	};
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<string>|undefined} Insert results.
	 */
	function readInsertResults(node, objectStack) {
	  return pushParseAndPop(
	    [], INSERT_RESULTS_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {import("../Feature.js").default} feature Feature.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeFeature(node, feature, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  var featureType = context['featureType'];
	  var featureNS = context['featureNS'];
	  var gmlVersion = context['gmlVersion'];
	  var child = createElementNS(featureNS, featureType);
	  node.appendChild(child);
	  if (gmlVersion === 2) {
	    GML2.prototype.writeFeatureElement(child, feature, objectStack);
	  } else {
	    GML3.prototype.writeFeatureElement(child, feature, objectStack);
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {number|string} fid Feature identifier.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeOgcFidFilter(node, fid, objectStack) {
	  var filter = createElementNS(OGCNS, 'Filter');
	  var child = createElementNS(OGCNS, 'FeatureId');
	  filter.appendChild(child);
	  child.setAttribute('fid', /** @type {string} */ (fid));
	  node.appendChild(filter);
	}
	
	
	/**
	 * @param {string|undefined} featurePrefix The prefix of the feature.
	 * @param {string} featureType The type of the feature.
	 * @returns {string} The value of the typeName property.
	 */
	function getTypeName(featurePrefix, featureType) {
	  featurePrefix = featurePrefix ? featurePrefix : FEATURE_PREFIX;
	  var prefix = featurePrefix + ':';
	  // The featureType already contains the prefix.
	  if (featureType.indexOf(prefix) === 0) {
	    return featureType;
	  } else {
	    return prefix + featureType;
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {import("../Feature.js").default} feature Feature.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeDelete(node, feature, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  assert(feature.getId() !== undefined, 26); // Features must have an id set
	  var featureType = context['featureType'];
	  var featurePrefix = context['featurePrefix'];
	  var featureNS = context['featureNS'];
	  var typeName = getTypeName(featurePrefix, featureType);
	  node.setAttribute('typeName', typeName);
	  node.setAttributeNS(XMLNS, 'xmlns:' + featurePrefix, featureNS);
	  var fid = feature.getId();
	  if (fid !== undefined) {
	    writeOgcFidFilter(node, fid, objectStack);
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {import("../Feature.js").default} feature Feature.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeUpdate(node, feature, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  assert(feature.getId() !== undefined, 27); // Features must have an id set
	  var featureType = context['featureType'];
	  var featurePrefix = context['featurePrefix'];
	  var featureNS = context['featureNS'];
	  var typeName = getTypeName(featurePrefix, featureType);
	  var geometryName = feature.getGeometryName();
	  node.setAttribute('typeName', typeName);
	  node.setAttributeNS(XMLNS, 'xmlns:' + featurePrefix, featureNS);
	  var fid = feature.getId();
	  if (fid !== undefined) {
	    var keys = feature.getKeys();
	    var values = [];
	    for (var i = 0, ii = keys.length; i < ii; i++) {
	      var value = feature.get(keys[i]);
	      if (value !== undefined) {
	        var name = keys[i];
	        if (value && typeof /** @type {?} */ (value).getSimplifiedGeometry === 'function') {
	          name = geometryName;
	        }
	        values.push({name: name, value: value});
	      }
	    }
	    pushSerializeAndPop(/** @type {import("../xml.js").NodeStackItem} */ (
	      {'gmlVersion': context['gmlVersion'], node: node,
	        'hasZ': context['hasZ'], 'srsName': context['srsName']}),
	    TRANSACTION_SERIALIZERS,
	    makeSimpleNodeFactory('Property'), values,
	    objectStack);
	    writeOgcFidFilter(node, fid, objectStack);
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Object} pair Property name and value.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeProperty(node, pair, objectStack) {
	  var name = createElementNS(WFSNS, 'Name');
	  var context = objectStack[objectStack.length - 1];
	  var gmlVersion = context['gmlVersion'];
	  node.appendChild(name);
	  writeStringTextNode(name, pair.name);
	  if (pair.value !== undefined && pair.value !== null) {
	    var value = createElementNS(WFSNS, 'Value');
	    node.appendChild(value);
	    if (pair.value && typeof /** @type {?} */ (pair.value).getSimplifiedGeometry === 'function') {
	      if (gmlVersion === 2) {
	        GML2.prototype.writeGeometryElement(value,
	          pair.value, objectStack);
	      } else {
	        GML3.prototype.writeGeometryElement(value,
	          pair.value, objectStack);
	      }
	    } else {
	      writeStringTextNode(value, pair.value);
	    }
	  }
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {{vendorId: string, safeToIgnore: boolean, value: string}} nativeElement The native element.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeNative(node, nativeElement, objectStack) {
	  if (nativeElement.vendorId) {
	    node.setAttribute('vendorId', nativeElement.vendorId);
	  }
	  if (nativeElement.safeToIgnore !== undefined) {
	    node.setAttribute('safeToIgnore', String(nativeElement.safeToIgnore));
	  }
	  if (nativeElement.value !== undefined) {
	    writeStringTextNode(node, nativeElement.value);
	  }
	}
	
	
	/**
	 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
	 */
	var GETFEATURE_SERIALIZERS = {
	  'http://www.opengis.net/wfs': {
	    'Query': makeChildAppender(writeQuery)
	  },
	  'http://www.opengis.net/ogc': {
	    'During': makeChildAppender(writeDuringFilter),
	    'And': makeChildAppender(writeLogicalFilter),
	    'Or': makeChildAppender(writeLogicalFilter),
	    'Not': makeChildAppender(writeNotFilter),
	    'BBOX': makeChildAppender(writeBboxFilter),
	    'Contains': makeChildAppender(writeContainsFilter),
	    'Intersects': makeChildAppender(writeIntersectsFilter),
	    'Within': makeChildAppender(writeWithinFilter),
	    'PropertyIsEqualTo': makeChildAppender(writeComparisonFilter),
	    'PropertyIsNotEqualTo': makeChildAppender(writeComparisonFilter),
	    'PropertyIsLessThan': makeChildAppender(writeComparisonFilter),
	    'PropertyIsLessThanOrEqualTo': makeChildAppender(writeComparisonFilter),
	    'PropertyIsGreaterThan': makeChildAppender(writeComparisonFilter),
	    'PropertyIsGreaterThanOrEqualTo': makeChildAppender(writeComparisonFilter),
	    'PropertyIsNull': makeChildAppender(writeIsNullFilter),
	    'PropertyIsBetween': makeChildAppender(writeIsBetweenFilter),
	    'PropertyIsLike': makeChildAppender(writeIsLikeFilter)
	  }
	};
	
	
	/**
	 * @param {Element} node Node.
	 * @param {string} featureType Feature type.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeQuery(node, featureType, objectStack) {
	  var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  var featurePrefix = context['featurePrefix'];
	  var featureNS = context['featureNS'];
	  var propertyNames = context['propertyNames'];
	  var srsName = context['srsName'];
	  var typeName;
	  // If feature prefix is not defined, we must not use the default prefix.
	  if (featurePrefix) {
	    typeName = getTypeName(featurePrefix, featureType);
	  } else {
	    typeName = featureType;
	  }
	  node.setAttribute('typeName', typeName);
	  if (srsName) {
	    node.setAttribute('srsName', srsName);
	  }
	  if (featureNS) {
	    node.setAttributeNS(XMLNS, 'xmlns:' + featurePrefix, featureNS);
	  }
	  var item = /** @type {import("../xml.js").NodeStackItem} */ (assign({}, context));
	  item.node = node;
	  pushSerializeAndPop(item,
	    QUERY_SERIALIZERS,
	    makeSimpleNodeFactory('PropertyName'), propertyNames,
	    objectStack);
	  var filter = context['filter'];
	  if (filter) {
	    var child = createElementNS(OGCNS, 'Filter');
	    node.appendChild(child);
	    writeFilterCondition(child, filter, objectStack);
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/Filter.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeFilterCondition(node, filter, objectStack) {
	  /** @type {import("../xml.js").NodeStackItem} */
	  var item = {node: node};
	  pushSerializeAndPop(item,
	    GETFEATURE_SERIALIZERS,
	    makeSimpleNodeFactory(filter.getTagName()),
	    [filter], objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/Bbox.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeBboxFilter(node, filter, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  context['srsName'] = filter.srsName;
	
	  writeOgcPropertyName(node, filter.geometryName);
	  GML3.prototype.writeGeometryElement(node, filter.extent, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/Contains.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeContainsFilter(node, filter, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  context['srsName'] = filter.srsName;
	
	  writeOgcPropertyName(node, filter.geometryName);
	  GML3.prototype.writeGeometryElement(node, filter.geometry, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/Intersects.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeIntersectsFilter(node, filter, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  context['srsName'] = filter.srsName;
	
	  writeOgcPropertyName(node, filter.geometryName);
	  GML3.prototype.writeGeometryElement(node, filter.geometry, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/Within.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeWithinFilter(node, filter, objectStack) {
	  var context = objectStack[objectStack.length - 1];
	  context['srsName'] = filter.srsName;
	
	  writeOgcPropertyName(node, filter.geometryName);
	  GML3.prototype.writeGeometryElement(node, filter.geometry, objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/During.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeDuringFilter(node, filter, objectStack) {
	
	  var valueReference = createElementNS(FESNS, 'ValueReference');
	  writeStringTextNode(valueReference, filter.propertyName);
	  node.appendChild(valueReference);
	
	  var timePeriod = createElementNS(GMLNS, 'TimePeriod');
	
	  node.appendChild(timePeriod);
	
	  var begin = createElementNS(GMLNS, 'begin');
	  timePeriod.appendChild(begin);
	  writeTimeInstant(begin, filter.begin);
	
	  var end = createElementNS(GMLNS, 'end');
	  timePeriod.appendChild(end);
	  writeTimeInstant(end, filter.end);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/LogicalNary.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeLogicalFilter(node, filter, objectStack) {
	  /** @type {import("../xml.js").NodeStackItem} */
	  var item = {node: node};
	  var conditions = filter.conditions;
	  for (var i = 0, ii = conditions.length; i < ii; ++i) {
	    var condition = conditions[i];
	    pushSerializeAndPop(item,
	      GETFEATURE_SERIALIZERS,
	      makeSimpleNodeFactory(condition.getTagName()),
	      [condition], objectStack);
	  }
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/Not.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeNotFilter(node, filter, objectStack) {
	  /** @type {import("../xml.js").NodeStackItem} */
	  var item = {node: node};
	  var condition = filter.condition;
	  pushSerializeAndPop(item,
	    GETFEATURE_SERIALIZERS,
	    makeSimpleNodeFactory(condition.getTagName()),
	    [condition], objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {import("./filter/ComparisonBinary.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeComparisonFilter(node, filter, objectStack) {
	  if (filter.matchCase !== undefined) {
	    node.setAttribute('matchCase', filter.matchCase.toString());
	  }
	  writeOgcPropertyName(node, filter.propertyName);
	  writeOgcLiteral(node, '' + filter.expression);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/IsNull.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeIsNullFilter(node, filter, objectStack) {
	  writeOgcPropertyName(node, filter.propertyName);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {import("./filter/IsBetween.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeIsBetweenFilter(node, filter, objectStack) {
	  writeOgcPropertyName(node, filter.propertyName);
	
	  var lowerBoundary = createElementNS(OGCNS, 'LowerBoundary');
	  node.appendChild(lowerBoundary);
	  writeOgcLiteral(lowerBoundary, '' + filter.lowerBoundary);
	
	  var upperBoundary = createElementNS(OGCNS, 'UpperBoundary');
	  node.appendChild(upperBoundary);
	  writeOgcLiteral(upperBoundary, '' + filter.upperBoundary);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {import("./filter/IsLike.js").default} filter Filter.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeIsLikeFilter(node, filter, objectStack) {
	  node.setAttribute('wildCard', filter.wildCard);
	  node.setAttribute('singleChar', filter.singleChar);
	  node.setAttribute('escapeChar', filter.escapeChar);
	  if (filter.matchCase !== undefined) {
	    node.setAttribute('matchCase', filter.matchCase.toString());
	  }
	  writeOgcPropertyName(node, filter.propertyName);
	  writeOgcLiteral(node, '' + filter.pattern);
	}
	
	
	/**
	 * @param {string} tagName Tag name.
	 * @param {Node} node Node.
	 * @param {string} value Value.
	 */
	function writeOgcExpression(tagName, node, value) {
	  var property = createElementNS(OGCNS, tagName);
	  writeStringTextNode(property, value);
	  node.appendChild(property);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {string} value PropertyName value.
	 */
	function writeOgcPropertyName(node, value) {
	  writeOgcExpression('PropertyName', node, value);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {string} value PropertyName value.
	 */
	function writeOgcLiteral(node, value) {
	  writeOgcExpression('Literal', node, value);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {string} time PropertyName value.
	 */
	function writeTimeInstant(node, time) {
	  var timeInstant = createElementNS(GMLNS, 'TimeInstant');
	  node.appendChild(timeInstant);
	
	  var timePosition = createElementNS(GMLNS, 'timePosition');
	  timeInstant.appendChild(timePosition);
	  writeStringTextNode(timePosition, time);
	}
	
	
	/**
	 * Encode filter as WFS `Filter` and return the Node.
	 *
	 * @param {import("./filter/Filter.js").default} filter Filter.
	 * @return {Node} Result.
	 * @api
	 */
	function writeFilter(filter) {
	  var child = createElementNS(OGCNS, 'Filter');
	  writeFilterCondition(child, filter, []);
	  return child;
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<string>} featureTypes Feature types.
	 * @param {Array<*>} objectStack Node stack.
	 */
	function writeGetFeature(node, featureTypes, objectStack) {
	  var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
	  var item = /** @type {import("../xml.js").NodeStackItem} */ (assign({}, context));
	  item.node = node;
	  pushSerializeAndPop(item,
	    GETFEATURE_SERIALIZERS,
	    makeSimpleNodeFactory('Query'), featureTypes,
	    objectStack);
	}
	
	/**
	 * @module ol/format/WKT
	 */
	
	
	/**
	 * Geometry constructors
	 * @enum {function (new:import("../geom/Geometry.js").default, Array, GeometryLayout)}
	 */
	var GeometryConstructor = {
	  'POINT': Point,
	  'LINESTRING': LineString,
	  'POLYGON': Polygon,
	  'MULTIPOINT': MultiPoint,
	  'MULTILINESTRING': MultiLineString,
	  'MULTIPOLYGON': MultiPolygon
	};
	
	
	/**
	 * @typedef {Object} Options
	 * @property {boolean} [splitCollection=false] Whether to split GeometryCollections into
	 * multiple features on reading.
	 */
	
	/**
	 * @typedef {Object} Token
	 * @property {number} type
	 * @property {number|string} [value]
	 * @property {number} position
	 */
	
	/**
	 * @const
	 * @type {string}
	 */
	var EMPTY = 'EMPTY';
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var Z = 'Z';
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var M = 'M';
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var ZM = 'ZM';
	
	
	/**
	 * @const
	 * @enum {number}
	 */
	var TokenType = {
	  TEXT: 1,
	  LEFT_PAREN: 2,
	  RIGHT_PAREN: 3,
	  NUMBER: 4,
	  COMMA: 5,
	  EOF: 6
	};
	
	/**
	 * @const
	 * @type {Object<string, string>}
	 */
	var WKTGeometryType = {};
	for (var type in GeometryType) {
	  WKTGeometryType[type] = GeometryType[type].toUpperCase();
	}
	
	
	/**
	 * Class to tokenize a WKT string.
	 */
	var Lexer = function Lexer(wkt) {
	
	  /**
	   * @type {string}
	   */
	  this.wkt = wkt;
	
	  /**
	   * @type {number}
	   * @private
	   */
	  this.index_ = -1;
	};
	
	/**
	 * @param {string} c Character.
	 * @return {boolean} Whether the character is alphabetic.
	 * @private
	 */
	Lexer.prototype.isAlpha_ = function isAlpha_ (c) {
	  return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z';
	};
	
	/**
	 * @param {string} c Character.
	 * @param {boolean=} opt_decimal Whether the string number
	 *   contains a dot, i.e. is a decimal number.
	 * @return {boolean} Whether the character is numeric.
	 * @private
	 */
	Lexer.prototype.isNumeric_ = function isNumeric_ (c, opt_decimal) {
	  var decimal = opt_decimal !== undefined ? opt_decimal : false;
	  return c >= '0' && c <= '9' || c == '.' && !decimal;
	};
	
	/**
	 * @param {string} c Character.
	 * @return {boolean} Whether the character is whitespace.
	 * @private
	 */
	Lexer.prototype.isWhiteSpace_ = function isWhiteSpace_ (c) {
	  return c == ' ' || c == '\t' || c == '\r' || c == '\n';
	};
	
	/**
	 * @return {string} Next string character.
	 * @private
	 */
	Lexer.prototype.nextChar_ = function nextChar_ () {
	  return this.wkt.charAt(++this.index_);
	};
	
	/**
	 * Fetch and return the next token.
	 * @return {!Token} Next string token.
	 */
	Lexer.prototype.nextToken = function nextToken () {
	  var c = this.nextChar_();
	  var position = this.index_;
	  /** @type {number|string} */
	  var value = c;
	  var type;
	
	  if (c == '(') {
	    type = TokenType.LEFT_PAREN;
	  } else if (c == ',') {
	    type = TokenType.COMMA;
	  } else if (c == ')') {
	    type = TokenType.RIGHT_PAREN;
	  } else if (this.isNumeric_(c) || c == '-') {
	    type = TokenType.NUMBER;
	    value = this.readNumber_();
	  } else if (this.isAlpha_(c)) {
	    type = TokenType.TEXT;
	    value = this.readText_();
	  } else if (this.isWhiteSpace_(c)) {
	    return this.nextToken();
	  } else if (c === '') {
	    type = TokenType.EOF;
	  } else {
	    throw new Error('Unexpected character: ' + c);
	  }
	
	  return {position: position, value: value, type: type};
	};
	
	/**
	 * @return {number} Numeric token value.
	 * @private
	 */
	Lexer.prototype.readNumber_ = function readNumber_ () {
	  var c;
	  var index = this.index_;
	  var decimal = false;
	  var scientificNotation = false;
	  do {
	    if (c == '.') {
	      decimal = true;
	    } else if (c == 'e' || c == 'E') {
	      scientificNotation = true;
	    }
	    c = this.nextChar_();
	  } while (
	    this.isNumeric_(c, decimal) ||
	      // if we haven't detected a scientific number before, 'e' or 'E'
	      // hint that we should continue to read
	      !scientificNotation && (c == 'e' || c == 'E') ||
	      // once we know that we have a scientific number, both '-' and '+'
	      // are allowed
	      scientificNotation && (c == '-' || c == '+')
	  );
	  return parseFloat(this.wkt.substring(index, this.index_--));
	};
	
	/**
	 * @return {string} String token value.
	 * @private
	 */
	Lexer.prototype.readText_ = function readText_ () {
	  var c;
	  var index = this.index_;
	  do {
	    c = this.nextChar_();
	  } while (this.isAlpha_(c));
	  return this.wkt.substring(index, this.index_--).toUpperCase();
	};
	
	/**
	 * Class to parse the tokens from the WKT string.
	 */
	var Parser = function Parser(lexer) {
	
	  /**
	   * @type {Lexer}
	   * @private
	   */
	  this.lexer_ = lexer;
	
	  /**
	   * @type {Token}
	   * @private
	   */
	  this.token_;
	
	  /**
	   * @type {GeometryLayout}
	   * @private
	   */
	  this.layout_ = GeometryLayout.XY;
	};
	
	/**
	 * Fetch the next token form the lexer and replace the active token.
	 * @private
	 */
	Parser.prototype.consume_ = function consume_ () {
	  this.token_ = this.lexer_.nextToken();
	};
	
	/**
	 * Tests if the given type matches the type of the current token.
	 * @param {TokenType} type Token type.
	 * @return {boolean} Whether the token matches the given type.
	 */
	Parser.prototype.isTokenType = function isTokenType (type) {
	  var isMatch = this.token_.type == type;
	  return isMatch;
	};
	
	/**
	 * If the given type matches the current token, consume it.
	 * @param {TokenType} type Token type.
	 * @return {boolean} Whether the token matches the given type.
	 */
	Parser.prototype.match = function match (type) {
	  var isMatch = this.isTokenType(type);
	  if (isMatch) {
	    this.consume_();
	  }
	  return isMatch;
	};
	
	/**
	 * Try to parse the tokens provided by the lexer.
	 * @return {import("../geom/Geometry.js").default} The geometry.
	 */
	Parser.prototype.parse = function parse () {
	  this.consume_();
	  var geometry = this.parseGeometry_();
	  return geometry;
	};
	
	/**
	 * Try to parse the dimensional info.
	 * @return {GeometryLayout} The layout.
	 * @private
	 */
	Parser.prototype.parseGeometryLayout_ = function parseGeometryLayout_ () {
	  var layout = GeometryLayout.XY;
	  var dimToken = this.token_;
	  if (this.isTokenType(TokenType.TEXT)) {
	    var dimInfo = dimToken.value;
	    if (dimInfo === Z) {
	      layout = GeometryLayout.XYZ;
	    } else if (dimInfo === M) {
	      layout = GeometryLayout.XYM;
	    } else if (dimInfo === ZM) {
	      layout = GeometryLayout.XYZM;
	    }
	    if (layout !== GeometryLayout.XY) {
	      this.consume_();
	    }
	  }
	  return layout;
	};
	
	/**
	 * @return {!Array<import("../geom/Geometry.js").default>} A collection of geometries.
	 * @private
	 */
	Parser.prototype.parseGeometryCollectionText_ = function parseGeometryCollectionText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var geometries = [];
	    do {
	      geometries.push(this.parseGeometry_());
	    } while (this.match(TokenType.COMMA));
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return geometries;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return [];
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {Array<number>} All values in a point.
	 * @private
	 */
	Parser.prototype.parsePointText_ = function parsePointText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var coordinates = this.parsePoint_();
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return coordinates;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return null;
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<!Array<number>>} All points in a linestring.
	 * @private
	 */
	Parser.prototype.parseLineStringText_ = function parseLineStringText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var coordinates = this.parsePointList_();
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return coordinates;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return [];
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<!Array<!Array<number>>>} All points in a polygon.
	 * @private
	 */
	Parser.prototype.parsePolygonText_ = function parsePolygonText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var coordinates = this.parseLineStringTextList_();
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return coordinates;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return [];
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<!Array<number>>} All points in a multipoint.
	 * @private
	 */
	Parser.prototype.parseMultiPointText_ = function parseMultiPointText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var coordinates;
	    if (this.token_.type == TokenType.LEFT_PAREN) {
	      coordinates = this.parsePointTextList_();
	    } else {
	      coordinates = this.parsePointList_();
	    }
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return coordinates;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return [];
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<!Array<!Array<number>>>} All linestring points
	 *                                        in a multilinestring.
	 * @private
	 */
	Parser.prototype.parseMultiLineStringText_ = function parseMultiLineStringText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var coordinates = this.parseLineStringTextList_();
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return coordinates;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return [];
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<!Array<!Array<!Array<number>>>>} All polygon points in a multipolygon.
	 * @private
	 */
	Parser.prototype.parseMultiPolygonText_ = function parseMultiPolygonText_ () {
	  if (this.match(TokenType.LEFT_PAREN)) {
	    var coordinates = this.parsePolygonTextList_();
	    if (this.match(TokenType.RIGHT_PAREN)) {
	      return coordinates;
	    }
	  } else if (this.isEmptyGeometry_()) {
	    return [];
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<number>} A point.
	 * @private
	 */
	Parser.prototype.parsePoint_ = function parsePoint_ () {
	  var coordinates = [];
	  var dimensions = this.layout_.length;
	  for (var i = 0; i < dimensions; ++i) {
	    var token = this.token_;
	    if (this.match(TokenType.NUMBER)) {
	      coordinates.push(/** @type {number} */ (token.value));
	    } else {
	      break;
	    }
	  }
	  if (coordinates.length == dimensions) {
	    return coordinates;
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	/**
	 * @return {!Array<!Array<number>>} An array of points.
	 * @private
	 */
	Parser.prototype.parsePointList_ = function parsePointList_ () {
	  var coordinates = [this.parsePoint_()];
	  while (this.match(TokenType.COMMA)) {
	    coordinates.push(this.parsePoint_());
	  }
	  return coordinates;
	};
	
	/**
	 * @return {!Array<!Array<number>>} An array of points.
	 * @private
	 */
	Parser.prototype.parsePointTextList_ = function parsePointTextList_ () {
	  var coordinates = [this.parsePointText_()];
	  while (this.match(TokenType.COMMA)) {
	    coordinates.push(this.parsePointText_());
	  }
	  return coordinates;
	};
	
	/**
	 * @return {!Array<!Array<!Array<number>>>} An array of points.
	 * @private
	 */
	Parser.prototype.parseLineStringTextList_ = function parseLineStringTextList_ () {
	  var coordinates = [this.parseLineStringText_()];
	  while (this.match(TokenType.COMMA)) {
	    coordinates.push(this.parseLineStringText_());
	  }
	  return coordinates;
	};
	
	/**
	 * @return {!Array<!Array<!Array<!Array<number>>>>} An array of points.
	 * @private
	 */
	Parser.prototype.parsePolygonTextList_ = function parsePolygonTextList_ () {
	  var coordinates = [this.parsePolygonText_()];
	  while (this.match(TokenType.COMMA)) {
	    coordinates.push(this.parsePolygonText_());
	  }
	  return coordinates;
	};
	
	/**
	 * @return {boolean} Whether the token implies an empty geometry.
	 * @private
	 */
	Parser.prototype.isEmptyGeometry_ = function isEmptyGeometry_ () {
	  var isEmpty = this.isTokenType(TokenType.TEXT) &&
	      this.token_.value == EMPTY;
	  if (isEmpty) {
	    this.consume_();
	  }
	  return isEmpty;
	};
	
	/**
	 * Create an error message for an unexpected token error.
	 * @return {string} Error message.
	 * @private
	 */
	Parser.prototype.formatErrorMessage_ = function formatErrorMessage_ () {
	  return 'Unexpected `' + this.token_.value + '` at position ' +
	      this.token_.position + ' in `' + this.lexer_.wkt + '`';
	};
	
	/**
	 * @return {!import("../geom/Geometry.js").default} The geometry.
	 * @private
	 */
	Parser.prototype.parseGeometry_ = function parseGeometry_ () {
	  var token = this.token_;
	  if (this.match(TokenType.TEXT)) {
	    var geomType = token.value;
	    this.layout_ = this.parseGeometryLayout_();
	    if (geomType == 'GEOMETRYCOLLECTION') {
	      var geometries = this.parseGeometryCollectionText_();
	      return new GeometryCollection(geometries);
	    } else {
	      var ctor = GeometryConstructor[geomType];
	      if (!ctor) {
	        throw new Error('Invalid geometry type: ' + geomType);
	      }
	
	      var coordinates;
	      switch (geomType) {
	        case 'POINT': {
	          coordinates = this.parsePointText_();
	          break;
	        }
	        case 'LINESTRING': {
	          coordinates = this.parseLineStringText_();
	          break;
	        }
	        case 'POLYGON': {
	          coordinates = this.parsePolygonText_();
	          break;
	        }
	        case 'MULTIPOINT': {
	          coordinates = this.parseMultiPointText_();
	          break;
	        }
	        case 'MULTILINESTRING': {
	          coordinates = this.parseMultiLineStringText_();
	          break;
	        }
	        case 'MULTIPOLYGON': {
	          coordinates = this.parseMultiPolygonText_();
	          break;
	        }
	        default: {
	          throw new Error('Invalid geometry type: ' + geomType);
	        }
	      }
	
	      if (!coordinates) {
	        if (ctor === GeometryConstructor['POINT']) {
	          coordinates = [NaN, NaN];
	        } else {
	          coordinates = [];
	        }
	      }
	      return new ctor(coordinates, this.layout_);
	    }
	  }
	  throw new Error(this.formatErrorMessage_());
	};
	
	
	/**
	 * @classdesc
	 * Geometry format for reading and writing data in the `WellKnownText` (WKT)
	 * format.
	 *
	 * @api
	 */
	var WKT = /*@__PURE__*/(function (TextFeature$$1) {
	  function WKT(opt_options) {
	    TextFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	
	    /**
	     * Split GeometryCollection into multiple features.
	     * @type {boolean}
	     * @private
	     */
	    this.splitCollection_ = options.splitCollection !== undefined ?
	      options.splitCollection : false;
	
	  }
	
	  if ( TextFeature$$1 ) { WKT.__proto__ = TextFeature$$1; }
	  WKT.prototype = Object.create( TextFeature$$1 && TextFeature$$1.prototype );
	  WKT.prototype.constructor = WKT;
	
	  /**
	   * Parse a WKT string.
	   * @param {string} wkt WKT string.
	   * @return {import("../geom/Geometry.js").default|undefined}
	   *     The geometry created.
	   * @private
	   */
	  WKT.prototype.parse_ = function parse_ (wkt) {
	    var lexer = new Lexer(wkt);
	    var parser = new Parser(lexer);
	    return parser.parse();
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WKT.prototype.readFeatureFromText = function readFeatureFromText (text, opt_options) {
	    var geom = this.readGeometryFromText(text, opt_options);
	    if (geom) {
	      var feature = new Feature();
	      feature.setGeometry(geom);
	      return feature;
	    }
	    return null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WKT.prototype.readFeaturesFromText = function readFeaturesFromText (text, opt_options) {
	    var geometries = [];
	    var geometry = this.readGeometryFromText(text, opt_options);
	    if (this.splitCollection_ &&
	        geometry.getType() == GeometryType.GEOMETRY_COLLECTION) {
	      geometries = (/** @type {GeometryCollection} */ (geometry))
	        .getGeometriesArray();
	    } else {
	      geometries = [geometry];
	    }
	    var features = [];
	    for (var i = 0, ii = geometries.length; i < ii; ++i) {
	      var feature = new Feature();
	      feature.setGeometry(geometries[i]);
	      features.push(feature);
	    }
	    return features;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WKT.prototype.readGeometryFromText = function readGeometryFromText (text, opt_options) {
	    var geometry = this.parse_(text);
	    if (geometry) {
	      return (
	        /** @type {import("../geom/Geometry.js").default} */ (transformWithOptions(geometry, false, opt_options))
	      );
	    } else {
	      return null;
	    }
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WKT.prototype.writeFeatureText = function writeFeatureText (feature, opt_options) {
	    var geometry = feature.getGeometry();
	    if (geometry) {
	      return this.writeGeometryText(geometry, opt_options);
	    }
	    return '';
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WKT.prototype.writeFeaturesText = function writeFeaturesText (features, opt_options) {
	    if (features.length == 1) {
	      return this.writeFeatureText(features[0], opt_options);
	    }
	    var geometries = [];
	    for (var i = 0, ii = features.length; i < ii; ++i) {
	      geometries.push(features[i].getGeometry());
	    }
	    var collection = new GeometryCollection(geometries);
	    return this.writeGeometryText(collection, opt_options);
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WKT.prototype.writeGeometryText = function writeGeometryText (geometry, opt_options) {
	    return encode(/** @type {import("../geom/Geometry.js").default} */ (
	      transformWithOptions(geometry, true, opt_options)));
	  };
	
	  return WKT;
	}(TextFeature));
	
	
	/**
	 * @param {Point} geom Point geometry.
	 * @return {string} Coordinates part of Point as WKT.
	 */
	function encodePointGeometry(geom) {
	  var coordinates = geom.getCoordinates();
	  if (coordinates.length === 0) {
	    return '';
	  }
	  return coordinates.join(' ');
	}
	
	
	/**
	 * @param {MultiPoint} geom MultiPoint geometry.
	 * @return {string} Coordinates part of MultiPoint as WKT.
	 */
	function encodeMultiPointGeometry(geom) {
	  var array = [];
	  var components = geom.getPoints();
	  for (var i = 0, ii = components.length; i < ii; ++i) {
	    array.push('(' + encodePointGeometry(components[i]) + ')');
	  }
	  return array.join(',');
	}
	
	
	/**
	 * @param {GeometryCollection} geom GeometryCollection geometry.
	 * @return {string} Coordinates part of GeometryCollection as WKT.
	 */
	function encodeGeometryCollectionGeometry(geom) {
	  var array = [];
	  var geoms = geom.getGeometries();
	  for (var i = 0, ii = geoms.length; i < ii; ++i) {
	    array.push(encode(geoms[i]));
	  }
	  return array.join(',');
	}
	
	
	/**
	 * @param {LineString|import("../geom/LinearRing.js").default} geom LineString geometry.
	 * @return {string} Coordinates part of LineString as WKT.
	 */
	function encodeLineStringGeometry(geom) {
	  var coordinates = geom.getCoordinates();
	  var array = [];
	  for (var i = 0, ii = coordinates.length; i < ii; ++i) {
	    array.push(coordinates[i].join(' '));
	  }
	  return array.join(',');
	}
	
	
	/**
	 * @param {MultiLineString} geom MultiLineString geometry.
	 * @return {string} Coordinates part of MultiLineString as WKT.
	 */
	function encodeMultiLineStringGeometry(geom) {
	  var array = [];
	  var components = geom.getLineStrings();
	  for (var i = 0, ii = components.length; i < ii; ++i) {
	    array.push('(' + encodeLineStringGeometry(components[i]) + ')');
	  }
	  return array.join(',');
	}
	
	
	/**
	 * @param {Polygon} geom Polygon geometry.
	 * @return {string} Coordinates part of Polygon as WKT.
	 */
	function encodePolygonGeometry(geom) {
	  var array = [];
	  var rings = geom.getLinearRings();
	  for (var i = 0, ii = rings.length; i < ii; ++i) {
	    array.push('(' + encodeLineStringGeometry(rings[i]) + ')');
	  }
	  return array.join(',');
	}
	
	
	/**
	 * @param {MultiPolygon} geom MultiPolygon geometry.
	 * @return {string} Coordinates part of MultiPolygon as WKT.
	 */
	function encodeMultiPolygonGeometry(geom) {
	  var array = [];
	  var components = geom.getPolygons();
	  for (var i = 0, ii = components.length; i < ii; ++i) {
	    array.push('(' + encodePolygonGeometry(components[i]) + ')');
	  }
	  return array.join(',');
	}
	
	/**
	 * @param {import("../geom/SimpleGeometry.js").default} geom SimpleGeometry geometry.
	 * @return {string} Potential dimensional information for WKT type.
	 */
	function encodeGeometryLayout(geom) {
	  var layout = geom.getLayout();
	  var dimInfo = '';
	  if (layout === GeometryLayout.XYZ || layout === GeometryLayout.XYZM) {
	    dimInfo += Z;
	  }
	  if (layout === GeometryLayout.XYM || layout === GeometryLayout.XYZM) {
	    dimInfo += M;
	  }
	  return dimInfo;
	}
	
	
	/**
	 * @const
	 * @type {Object<string, function(import("../geom/Geometry.js").default): string>}
	 */
	var GeometryEncoder = {
	  'Point': encodePointGeometry,
	  'LineString': encodeLineStringGeometry,
	  'Polygon': encodePolygonGeometry,
	  'MultiPoint': encodeMultiPointGeometry,
	  'MultiLineString': encodeMultiLineStringGeometry,
	  'MultiPolygon': encodeMultiPolygonGeometry,
	  'GeometryCollection': encodeGeometryCollectionGeometry
	};
	
	
	/**
	 * Encode a geometry as WKT.
	 * @param {!import("../geom/Geometry.js").default} geom The geometry to encode.
	 * @return {string} WKT string for the geometry.
	 */
	function encode(geom) {
	  var type = geom.getType();
	  var geometryEncoder = GeometryEncoder[type];
	  var enc = geometryEncoder(geom);
	  type = type.toUpperCase();
	  if (typeof /** @type {?} */ (geom).getFlatCoordinates === 'function') {
	    var dimInfo = encodeGeometryLayout(/** @type {import("../geom/SimpleGeometry.js").default} */ (geom));
	    if (dimInfo.length > 0) {
	      type += ' ' + dimInfo;
	    }
	  }
	  if (enc.length === 0) {
	    return type + ' ' + EMPTY;
	  }
	  return type + '(' + enc + ')';
	}
	
	/**
	 * @module ol/format/XLink
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var NAMESPACE_URI = 'http://www.w3.org/1999/xlink';
	
	
	/**
	 * @param {Element} node Node.
	 * @return {string|undefined} href.
	 */
	function readHref(node) {
	  return node.getAttributeNS(NAMESPACE_URI, 'href');
	}
	
	/**
	 * @module ol/format/XML
	 */
	
	/**
	 * @classdesc
	 * Generic format for reading non-feature XML data
	 *
	 * @abstract
	 */
	var XML = function XML () {};
	
	XML.prototype.read = function read (source) {
	  if (!source) {
	    return null;
	  } else if (typeof source === 'string') {
	    var doc = parse(source);
	    return this.readFromDocument(doc);
	  } else if (isDocument(source)) {
	    return this.readFromDocument(/** @type {Document} */ (source));
	  } else {
	    return this.readFromNode(/** @type {Element} */ (source));
	  }
	};
	
	/**
	 * @abstract
	 * @param {Document} doc Document.
	 * @return {Object} Object
	 */
	XML.prototype.readFromDocument = function readFromDocument (doc) {};
	
	/**
	 * @abstract
	 * @param {Element} node Node.
	 * @return {Object} Object
	 */
	XML.prototype.readFromNode = function readFromNode (node) {};
	
	/**
	 * @module ol/format/WMSCapabilities
	 */
	
	
	/**
	 * @const
	 * @type {Array<null|string>}
	 */
	var NAMESPACE_URIS$3 = [
	  null,
	  'http://www.opengis.net/wms'
	];
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PARSERS$1 = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Service': makeObjectPropertySetter(readService),
	    'Capability': makeObjectPropertySetter(readCapability)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CAPABILITY_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Request': makeObjectPropertySetter(readRequest),
	    'Exception': makeObjectPropertySetter(readException),
	    'Layer': makeObjectPropertySetter(readCapabilityLayer)
	  });
	
	
	/**
	 * @classdesc
	 * Format for reading WMS capabilities data
	 *
	 * @api
	 */
	var WMSCapabilities = /*@__PURE__*/(function (XML$$1) {
	  function WMSCapabilities() {
	    XML$$1.call(this);
	
	    /**
	     * @type {string|undefined}
	     */
	    this.version = undefined;
	  }
	
	  if ( XML$$1 ) { WMSCapabilities.__proto__ = XML$$1; }
	  WMSCapabilities.prototype = Object.create( XML$$1 && XML$$1.prototype );
	  WMSCapabilities.prototype.constructor = WMSCapabilities;
	
	  /**
	   * @inheritDoc
	   */
	  WMSCapabilities.prototype.readFromDocument = function readFromDocument (doc) {
	    for (var n = doc.firstChild; n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        return this.readFromNode(n);
	      }
	    }
	    return null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WMSCapabilities.prototype.readFromNode = function readFromNode (node) {
	    this.version = node.getAttribute('version').trim();
	    var wmsCapabilityObject = pushParseAndPop({
	      'version': this.version
	    }, PARSERS$1, node, []);
	    return wmsCapabilityObject ? wmsCapabilityObject : null;
	  };
	
	  return WMSCapabilities;
	}(XML));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var SERVICE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Name': makeObjectPropertySetter(readString),
	    'Title': makeObjectPropertySetter(readString),
	    'Abstract': makeObjectPropertySetter(readString),
	    'KeywordList': makeObjectPropertySetter(readKeywordList),
	    'OnlineResource': makeObjectPropertySetter(readHref),
	    'ContactInformation': makeObjectPropertySetter(readContactInformation),
	    'Fees': makeObjectPropertySetter(readString),
	    'AccessConstraints': makeObjectPropertySetter(readString),
	    'LayerLimit': makeObjectPropertySetter(readNonNegativeInteger),
	    'MaxWidth': makeObjectPropertySetter(readNonNegativeInteger),
	    'MaxHeight': makeObjectPropertySetter(readNonNegativeInteger)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CONTACT_INFORMATION_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'ContactPersonPrimary': makeObjectPropertySetter(readContactPersonPrimary),
	    'ContactPosition': makeObjectPropertySetter(readString),
	    'ContactAddress': makeObjectPropertySetter(readContactAddress),
	    'ContactVoiceTelephone': makeObjectPropertySetter(readString),
	    'ContactFacsimileTelephone': makeObjectPropertySetter(readString),
	    'ContactElectronicMailAddress': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CONTACT_PERSON_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'ContactPerson': makeObjectPropertySetter(readString),
	    'ContactOrganization': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CONTACT_ADDRESS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'AddressType': makeObjectPropertySetter(readString),
	    'Address': makeObjectPropertySetter(readString),
	    'City': makeObjectPropertySetter(readString),
	    'StateOrProvince': makeObjectPropertySetter(readString),
	    'PostCode': makeObjectPropertySetter(readString),
	    'Country': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var EXCEPTION_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Format': makeArrayPusher(readString)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LAYER_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Name': makeObjectPropertySetter(readString),
	    'Title': makeObjectPropertySetter(readString),
	    'Abstract': makeObjectPropertySetter(readString),
	    'KeywordList': makeObjectPropertySetter(readKeywordList),
	    'CRS': makeObjectPropertyPusher(readString),
	    'EX_GeographicBoundingBox': makeObjectPropertySetter(readEXGeographicBoundingBox),
	    'BoundingBox': makeObjectPropertyPusher(readBoundingBox),
	    'Dimension': makeObjectPropertyPusher(readDimension),
	    'Attribution': makeObjectPropertySetter(readAttribution),
	    'AuthorityURL': makeObjectPropertyPusher(readAuthorityURL),
	    'Identifier': makeObjectPropertyPusher(readString),
	    'MetadataURL': makeObjectPropertyPusher(readMetadataURL),
	    'DataURL': makeObjectPropertyPusher(readFormatOnlineresource),
	    'FeatureListURL': makeObjectPropertyPusher(readFormatOnlineresource),
	    'Style': makeObjectPropertyPusher(readStyle$1),
	    'MinScaleDenominator': makeObjectPropertySetter(readDecimal),
	    'MaxScaleDenominator': makeObjectPropertySetter(readDecimal),
	    'Layer': makeObjectPropertyPusher(readLayer)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var ATTRIBUTION_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Title': makeObjectPropertySetter(readString),
	    'OnlineResource': makeObjectPropertySetter(readHref),
	    'LogoURL': makeObjectPropertySetter(readSizedFormatOnlineresource)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var EX_GEOGRAPHIC_BOUNDING_BOX_PARSERS =
	    makeStructureNS(NAMESPACE_URIS$3, {
	      'westBoundLongitude': makeObjectPropertySetter(readDecimal),
	      'eastBoundLongitude': makeObjectPropertySetter(readDecimal),
	      'southBoundLatitude': makeObjectPropertySetter(readDecimal),
	      'northBoundLatitude': makeObjectPropertySetter(readDecimal)
	    });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var REQUEST_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'GetCapabilities': makeObjectPropertySetter(readOperationType),
	    'GetMap': makeObjectPropertySetter(readOperationType),
	    'GetFeatureInfo': makeObjectPropertySetter(readOperationType)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var OPERATIONTYPE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Format': makeObjectPropertyPusher(readString),
	    'DCPType': makeObjectPropertyPusher(readDCPType)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var DCPTYPE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'HTTP': makeObjectPropertySetter(readHTTP)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var HTTP_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Get': makeObjectPropertySetter(readFormatOnlineresource),
	    'Post': makeObjectPropertySetter(readFormatOnlineresource)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var STYLE_PARSERS$1 = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Name': makeObjectPropertySetter(readString),
	    'Title': makeObjectPropertySetter(readString),
	    'Abstract': makeObjectPropertySetter(readString),
	    'LegendURL': makeObjectPropertyPusher(readSizedFormatOnlineresource),
	    'StyleSheetURL': makeObjectPropertySetter(readFormatOnlineresource),
	    'StyleURL': makeObjectPropertySetter(readFormatOnlineresource)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var FORMAT_ONLINERESOURCE_PARSERS =
	    makeStructureNS(NAMESPACE_URIS$3, {
	      'Format': makeObjectPropertySetter(readString),
	      'OnlineResource': makeObjectPropertySetter(readHref)
	    });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var KEYWORDLIST_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$3, {
	    'Keyword': makeArrayPusher(readString)
	  });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Attribution object.
	 */
	function readAttribution(node, objectStack) {
	  return pushParseAndPop({}, ATTRIBUTION_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object} Bounding box object.
	 */
	function readBoundingBox(node, objectStack) {
	  var extent = [
	    readDecimalString(node.getAttribute('minx')),
	    readDecimalString(node.getAttribute('miny')),
	    readDecimalString(node.getAttribute('maxx')),
	    readDecimalString(node.getAttribute('maxy'))
	  ];
	
	  var resolutions = [
	    readDecimalString(node.getAttribute('resx')),
	    readDecimalString(node.getAttribute('resy'))
	  ];
	
	  return {
	    'crs': node.getAttribute('CRS'),
	    'extent': extent,
	    'res': resolutions
	  };
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {import("../extent.js").Extent|undefined} Bounding box object.
	 */
	function readEXGeographicBoundingBox(node, objectStack) {
	  var geographicBoundingBox = pushParseAndPop(
	    {},
	    EX_GEOGRAPHIC_BOUNDING_BOX_PARSERS,
	    node, objectStack);
	  if (!geographicBoundingBox) {
	    return undefined;
	  }
	  var westBoundLongitude = /** @type {number|undefined} */
	        (geographicBoundingBox['westBoundLongitude']);
	  var southBoundLatitude = /** @type {number|undefined} */
	        (geographicBoundingBox['southBoundLatitude']);
	  var eastBoundLongitude = /** @type {number|undefined} */
	        (geographicBoundingBox['eastBoundLongitude']);
	  var northBoundLatitude = /** @type {number|undefined} */
	        (geographicBoundingBox['northBoundLatitude']);
	  if (westBoundLongitude === undefined || southBoundLatitude === undefined ||
	        eastBoundLongitude === undefined || northBoundLatitude === undefined) {
	    return undefined;
	  }
	  return [
	    westBoundLongitude, southBoundLatitude,
	    eastBoundLongitude, northBoundLatitude
	  ];
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Capability object.
	 */
	function readCapability(node, objectStack) {
	  return pushParseAndPop({}, CAPABILITY_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Service object.
	 */
	function readService(node, objectStack) {
	  return pushParseAndPop({}, SERVICE_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Contact information object.
	 */
	function readContactInformation(node, objectStack) {
	  return pushParseAndPop({}, CONTACT_INFORMATION_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Contact person object.
	 */
	function readContactPersonPrimary(node, objectStack) {
	  return pushParseAndPop({}, CONTACT_PERSON_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Contact address object.
	 */
	function readContactAddress(node, objectStack) {
	  return pushParseAndPop({}, CONTACT_ADDRESS_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<string>|undefined} Format array.
	 */
	function readException(node, objectStack) {
	  return pushParseAndPop([], EXCEPTION_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Layer object.
	 */
	function readCapabilityLayer(node, objectStack) {
	  return pushParseAndPop({}, LAYER_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Layer object.
	 */
	function readLayer(node, objectStack) {
	  var parentLayerObject = /**  @type {!Object<string,*>} */ (objectStack[objectStack.length - 1]);
	
	  var layerObject = pushParseAndPop({}, LAYER_PARSERS, node, objectStack);
	
	  if (!layerObject) {
	    return undefined;
	  }
	  var queryable = readBooleanString(node.getAttribute('queryable'));
	  if (queryable === undefined) {
	    queryable = parentLayerObject['queryable'];
	  }
	  layerObject['queryable'] = queryable !== undefined ? queryable : false;
	
	  var cascaded = readNonNegativeIntegerString(
	    node.getAttribute('cascaded'));
	  if (cascaded === undefined) {
	    cascaded = parentLayerObject['cascaded'];
	  }
	  layerObject['cascaded'] = cascaded;
	
	  var opaque = readBooleanString(node.getAttribute('opaque'));
	  if (opaque === undefined) {
	    opaque = parentLayerObject['opaque'];
	  }
	  layerObject['opaque'] = opaque !== undefined ? opaque : false;
	
	  var noSubsets = readBooleanString(node.getAttribute('noSubsets'));
	  if (noSubsets === undefined) {
	    noSubsets = parentLayerObject['noSubsets'];
	  }
	  layerObject['noSubsets'] = noSubsets !== undefined ? noSubsets : false;
	
	  var fixedWidth = readDecimalString(node.getAttribute('fixedWidth'));
	  if (!fixedWidth) {
	    fixedWidth = parentLayerObject['fixedWidth'];
	  }
	  layerObject['fixedWidth'] = fixedWidth;
	
	  var fixedHeight = readDecimalString(node.getAttribute('fixedHeight'));
	  if (!fixedHeight) {
	    fixedHeight = parentLayerObject['fixedHeight'];
	  }
	  layerObject['fixedHeight'] = fixedHeight;
	
	  // See 7.2.4.8
	  var addKeys = ['Style', 'CRS', 'AuthorityURL'];
	  addKeys.forEach(function(key) {
	    if (key in parentLayerObject) {
	      var childValue = layerObject[key] || [];
	      layerObject[key] = childValue.concat(parentLayerObject[key]);
	    }
	  });
	
	  var replaceKeys = ['EX_GeographicBoundingBox', 'BoundingBox', 'Dimension',
	    'Attribution', 'MinScaleDenominator', 'MaxScaleDenominator'];
	  replaceKeys.forEach(function(key) {
	    if (!(key in layerObject)) {
	      var parentValue = parentLayerObject[key];
	      layerObject[key] = parentValue;
	    }
	  });
	
	  return layerObject;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object} Dimension object.
	 */
	function readDimension(node, objectStack) {
	  var dimensionObject = {
	    'name': node.getAttribute('name'),
	    'units': node.getAttribute('units'),
	    'unitSymbol': node.getAttribute('unitSymbol'),
	    'default': node.getAttribute('default'),
	    'multipleValues': readBooleanString(node.getAttribute('multipleValues')),
	    'nearestValue': readBooleanString(node.getAttribute('nearestValue')),
	    'current': readBooleanString(node.getAttribute('current')),
	    'values': readString(node)
	  };
	  return dimensionObject;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Online resource object.
	 */
	function readFormatOnlineresource(node, objectStack) {
	  return pushParseAndPop({}, FORMAT_ONLINERESOURCE_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Request object.
	 */
	function readRequest(node, objectStack) {
	  return pushParseAndPop({}, REQUEST_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} DCP type object.
	 */
	function readDCPType(node, objectStack) {
	  return pushParseAndPop({}, DCPTYPE_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} HTTP object.
	 */
	function readHTTP(node, objectStack) {
	  return pushParseAndPop({}, HTTP_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Operation type object.
	 */
	function readOperationType(node, objectStack) {
	  return pushParseAndPop({}, OPERATIONTYPE_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Online resource object.
	 */
	function readSizedFormatOnlineresource(node, objectStack) {
	  var formatOnlineresource = readFormatOnlineresource(node, objectStack);
	  if (formatOnlineresource) {
	    var size = [
	      readNonNegativeIntegerString(node.getAttribute('width')),
	      readNonNegativeIntegerString(node.getAttribute('height'))
	    ];
	    formatOnlineresource['size'] = size;
	    return formatOnlineresource;
	  }
	  return undefined;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Authority URL object.
	 */
	function readAuthorityURL(node, objectStack) {
	  var authorityObject = readFormatOnlineresource(node, objectStack);
	  if (authorityObject) {
	    authorityObject['name'] = node.getAttribute('name');
	    return authorityObject;
	  }
	  return undefined;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Metadata URL object.
	 */
	function readMetadataURL(node, objectStack) {
	  var metadataObject = readFormatOnlineresource(node, objectStack);
	  if (metadataObject) {
	    metadataObject['type'] = node.getAttribute('type');
	    return metadataObject;
	  }
	  return undefined;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Style object.
	 */
	function readStyle$1(node, objectStack) {
	  return pushParseAndPop({}, STYLE_PARSERS$1, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Array<string>|undefined} Keyword list.
	 */
	function readKeywordList(node, objectStack) {
	  return pushParseAndPop([], KEYWORDLIST_PARSERS, node, objectStack);
	}
	
	/**
	 * @module ol/format/WMSGetFeatureInfo
	 */
	
	
	/**
	 * @typedef {Object} Options
	 * @property {Array<string>} [layers] If set, only features of the given layers will be returned by the format when read.
	 */
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var featureIdentifier = '_feature';
	
	
	/**
	 * @const
	 * @type {string}
	 */
	var layerIdentifier = '_layer';
	
	
	/**
	 * @classdesc
	 * Format for reading WMSGetFeatureInfo format. It uses
	 * {@link module:ol/format/GML2~GML2} to read features.
	 *
	 * @api
	 */
	var WMSGetFeatureInfo = /*@__PURE__*/(function (XMLFeature$$1) {
	  function WMSGetFeatureInfo(opt_options) {
	    XMLFeature$$1.call(this);
	
	    var options = opt_options ? opt_options : {};
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.featureNS_ = 'http://mapserver.gis.umn.edu/mapserver';
	
	
	    /**
	     * @private
	     * @type {GML2}
	     */
	    this.gmlFormat_ = new GML2();
	
	
	    /**
	     * @private
	     * @type {Array<string>}
	     */
	    this.layers_ = options.layers ? options.layers : null;
	  }
	
	  if ( XMLFeature$$1 ) { WMSGetFeatureInfo.__proto__ = XMLFeature$$1; }
	  WMSGetFeatureInfo.prototype = Object.create( XMLFeature$$1 && XMLFeature$$1.prototype );
	  WMSGetFeatureInfo.prototype.constructor = WMSGetFeatureInfo;
	
	  /**
	   * @return {Array<string>} layers
	   */
	  WMSGetFeatureInfo.prototype.getLayers = function getLayers () {
	    return this.layers_;
	  };
	
	  /**
	   * @param {Array<string>} layers Layers to parse.
	   */
	  WMSGetFeatureInfo.prototype.setLayers = function setLayers (layers) {
	    this.layers_ = layers;
	  };
	
	  /**
	   * @param {Element} node Node.
	   * @param {Array<*>} objectStack Object stack.
	   * @return {Array<import("../Feature.js").default>} Features.
	   * @private
	   */
	  WMSGetFeatureInfo.prototype.readFeatures_ = function readFeatures_ (node, objectStack) {
	    node.setAttribute('namespaceURI', this.featureNS_);
	    var localName = node.localName;
	    /** @type {Array<import("../Feature.js").default>} */
	    var features = [];
	    if (node.childNodes.length === 0) {
	      return features;
	    }
	    if (localName == 'msGMLOutput') {
	      for (var i = 0, ii = node.childNodes.length; i < ii; i++) {
	        var layer = node.childNodes[i];
	        if (layer.nodeType !== Node.ELEMENT_NODE) {
	          continue;
	        }
	
	        var layerElement = /** @type {Element} */ (layer);
	        var context = objectStack[0];
	
	        var toRemove = layerIdentifier;
	        var layerName = layerElement.localName.replace(toRemove, '');
	
	        if (this.layers_ && !includes(this.layers_, layerName)) {
	          continue;
	        }
	
	        var featureType = layerName +
	            featureIdentifier;
	
	        context['featureType'] = featureType;
	        context['featureNS'] = this.featureNS_;
	
	        /** @type {Object<string, import("../xml.js").Parser>} */
	        var parsers = {};
	        parsers[featureType] = makeArrayPusher(
	          this.gmlFormat_.readFeatureElement, this.gmlFormat_);
	        var parsersNS = makeStructureNS(
	          [context['featureNS'], null], parsers);
	        layerElement.setAttribute('namespaceURI', this.featureNS_);
	        var layerFeatures = pushParseAndPop(
	          [], parsersNS, layerElement, objectStack, this.gmlFormat_);
	        if (layerFeatures) {
	          extend(features, layerFeatures);
	        }
	      }
	    }
	    if (localName == 'FeatureCollection') {
	      var gmlFeatures = pushParseAndPop([],
	        this.gmlFormat_.FEATURE_COLLECTION_PARSERS, node,
	        [{}], this.gmlFormat_);
	      if (gmlFeatures) {
	        features = gmlFeatures;
	      }
	    }
	    return features;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WMSGetFeatureInfo.prototype.readFeaturesFromNode = function readFeaturesFromNode (node, opt_options) {
	    var options = {};
	    if (opt_options) {
	      assign(options, this.getReadOptions(node, opt_options));
	    }
	    return this.readFeatures_(node, [options]);
	  };
	
	  return WMSGetFeatureInfo;
	}(XMLFeature));
	
	/**
	 * @module ol/format/OWS
	 */
	
	
	/**
	 * @const
	 * @type {Array<null|string>}
	 */
	var NAMESPACE_URIS$4 = [null, 'http://www.opengis.net/ows/1.1'];
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PARSERS$2 = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'ServiceIdentification': makeObjectPropertySetter(readServiceIdentification),
	    'ServiceProvider': makeObjectPropertySetter(readServiceProvider),
	    'OperationsMetadata': makeObjectPropertySetter(readOperationsMetadata)
	  });
	
	
	var OWS = /*@__PURE__*/(function (XML$$1) {
	  function OWS() {
	    XML$$1.call(this);
	  }
	
	  if ( XML$$1 ) { OWS.__proto__ = XML$$1; }
	  OWS.prototype = Object.create( XML$$1 && XML$$1.prototype );
	  OWS.prototype.constructor = OWS;
	
	  /**
	   * @inheritDoc
	   */
	  OWS.prototype.readFromDocument = function readFromDocument (doc) {
	    for (var n = doc.firstChild; n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        return this.readFromNode(n);
	      }
	    }
	    return null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  OWS.prototype.readFromNode = function readFromNode (node) {
	    var owsObject = pushParseAndPop({},
	      PARSERS$2, node, []);
	    return owsObject ? owsObject : null;
	  };
	
	  return OWS;
	}(XML));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var ADDRESS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'DeliveryPoint': makeObjectPropertySetter(readString),
	    'City': makeObjectPropertySetter(readString),
	    'AdministrativeArea': makeObjectPropertySetter(readString),
	    'PostalCode': makeObjectPropertySetter(readString),
	    'Country': makeObjectPropertySetter(readString),
	    'ElectronicMailAddress': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var ALLOWED_VALUES_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'Value': makeObjectPropertyPusher(readValue)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CONSTRAINT_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'AllowedValues': makeObjectPropertySetter(readAllowedValues)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CONTACT_INFO_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'Phone': makeObjectPropertySetter(readPhone),
	    'Address': makeObjectPropertySetter(readAddress)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var DCP_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'HTTP': makeObjectPropertySetter(readHttp)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var HTTP_PARSERS$1 = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'Get': makeObjectPropertyPusher(readGet),
	    'Post': undefined // TODO
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var OPERATION_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'DCP': makeObjectPropertySetter(readDcp)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var OPERATIONS_METADATA_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'Operation': readOperation
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PHONE_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'Voice': makeObjectPropertySetter(readString),
	    'Facsimile': makeObjectPropertySetter(readString)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var REQUEST_METHOD_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$4, {
	    'Constraint': makeObjectPropertyPusher(readConstraint)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var SERVICE_CONTACT_PARSERS =
	    makeStructureNS(
	      NAMESPACE_URIS$4, {
	        'IndividualName': makeObjectPropertySetter(readString),
	        'PositionName': makeObjectPropertySetter(readString),
	        'ContactInfo': makeObjectPropertySetter(readContactInfo)
	      });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var SERVICE_IDENTIFICATION_PARSERS =
	    makeStructureNS(
	      NAMESPACE_URIS$4, {
	        'Abstract': makeObjectPropertySetter(readString),
	        'AccessConstraints': makeObjectPropertySetter(readString),
	        'Fees': makeObjectPropertySetter(readString),
	        'Title': makeObjectPropertySetter(readString),
	        'ServiceTypeVersion': makeObjectPropertySetter(readString),
	        'ServiceType': makeObjectPropertySetter(readString)
	      });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var SERVICE_PROVIDER_PARSERS =
	    makeStructureNS(
	      NAMESPACE_URIS$4, {
	        'ProviderName': makeObjectPropertySetter(readString),
	        'ProviderSite': makeObjectPropertySetter(readHref),
	        'ServiceContact': makeObjectPropertySetter(readServiceContact)
	      });
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The address.
	 */
	function readAddress(node, objectStack) {
	  return pushParseAndPop({},
	    ADDRESS_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The values.
	 */
	function readAllowedValues(node, objectStack) {
	  return pushParseAndPop({},
	    ALLOWED_VALUES_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The constraint.
	 */
	function readConstraint(node, objectStack) {
	  var name = node.getAttribute('name');
	  if (!name) {
	    return undefined;
	  }
	  return pushParseAndPop({'name': name},
	    CONSTRAINT_PARSERS, node,
	    objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The contact info.
	 */
	function readContactInfo(node, objectStack) {
	  return pushParseAndPop({},
	    CONTACT_INFO_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The DCP.
	 */
	function readDcp(node, objectStack) {
	  return pushParseAndPop({},
	    DCP_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The GET object.
	 */
	function readGet(node, objectStack) {
	  var href = readHref(node);
	  if (!href) {
	    return undefined;
	  }
	  return pushParseAndPop({'href': href},
	    REQUEST_METHOD_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The HTTP object.
	 */
	function readHttp(node, objectStack) {
	  return pushParseAndPop({}, HTTP_PARSERS$1, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The operation.
	 */
	function readOperation(node, objectStack) {
	  var name = node.getAttribute('name');
	  var value = pushParseAndPop({},
	    OPERATION_PARSERS, node, objectStack);
	  if (!value) {
	    return undefined;
	  }
	  var object = /** @type {Object} */
	      (objectStack[objectStack.length - 1]);
	  object[name] = value;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The operations metadata.
	 */
	function readOperationsMetadata(node, objectStack) {
	  return pushParseAndPop({},
	    OPERATIONS_METADATA_PARSERS, node,
	    objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The phone.
	 */
	function readPhone(node, objectStack) {
	  return pushParseAndPop({},
	    PHONE_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The service identification.
	 */
	function readServiceIdentification(node, objectStack) {
	  return pushParseAndPop(
	    {}, SERVICE_IDENTIFICATION_PARSERS, node,
	    objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The service contact.
	 */
	function readServiceContact(node, objectStack) {
	  return pushParseAndPop(
	    {}, SERVICE_CONTACT_PARSERS, node,
	    objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} The service provider.
	 */
	function readServiceProvider(node, objectStack) {
	  return pushParseAndPop(
	    {}, SERVICE_PROVIDER_PARSERS, node,
	    objectStack);
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {string|undefined} The value.
	 */
	function readValue(node, objectStack) {
	  return readString(node);
	}
	
	/**
	 * @module ol/format/WMTSCapabilities
	 */
	
	
	/**
	 * @const
	 * @type {Array<null|string>}
	 */
	var NAMESPACE_URIS$5 = [
	  null,
	  'http://www.opengis.net/wmts/1.0'
	];
	
	
	/**
	 * @const
	 * @type {Array<null|string>}
	 */
	var OWS_NAMESPACE_URIS = [
	  null,
	  'http://www.opengis.net/ows/1.1'
	];
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var PARSERS$3 = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'Contents': makeObjectPropertySetter(readContents)
	  });
	
	
	/**
	 * @classdesc
	 * Format for reading WMTS capabilities data.
	 *
	 * @api
	 */
	var WMTSCapabilities = /*@__PURE__*/(function (XML$$1) {
	  function WMTSCapabilities() {
	    XML$$1.call(this);
	
	    /**
	     * @type {OWS}
	     * @private
	     */
	    this.owsParser_ = new OWS();
	  }
	
	  if ( XML$$1 ) { WMTSCapabilities.__proto__ = XML$$1; }
	  WMTSCapabilities.prototype = Object.create( XML$$1 && XML$$1.prototype );
	  WMTSCapabilities.prototype.constructor = WMTSCapabilities;
	
	  /**
	   * @inheritDoc
	   */
	  WMTSCapabilities.prototype.readFromDocument = function readFromDocument (doc) {
	    for (var n = doc.firstChild; n; n = n.nextSibling) {
	      if (n.nodeType == Node.ELEMENT_NODE) {
	        return this.readFromNode(n);
	      }
	    }
	    return null;
	  };
	
	  /**
	   * @inheritDoc
	   */
	  WMTSCapabilities.prototype.readFromNode = function readFromNode (node) {
	    var version = node.getAttribute('version').trim();
	    var WMTSCapabilityObject = this.owsParser_.readFromNode(node);
	    if (!WMTSCapabilityObject) {
	      return null;
	    }
	    WMTSCapabilityObject['version'] = version;
	    WMTSCapabilityObject = pushParseAndPop(WMTSCapabilityObject, PARSERS$3, node, []);
	    return WMTSCapabilityObject ? WMTSCapabilityObject : null;
	  };
	
	  return WMTSCapabilities;
	}(XML));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var CONTENTS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'Layer': makeObjectPropertyPusher(readLayer$1),
	    'TileMatrixSet': makeObjectPropertyPusher(readTileMatrixSet)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var LAYER_PARSERS$1 = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'Style': makeObjectPropertyPusher(readStyle$2),
	    'Format': makeObjectPropertyPusher(readString),
	    'TileMatrixSetLink': makeObjectPropertyPusher(readTileMatrixSetLink),
	    'Dimension': makeObjectPropertyPusher(readDimensions),
	    'ResourceURL': makeObjectPropertyPusher(readResourceUrl)
	  }, makeStructureNS(OWS_NAMESPACE_URIS, {
	    'Title': makeObjectPropertySetter(readString),
	    'Abstract': makeObjectPropertySetter(readString),
	    'WGS84BoundingBox': makeObjectPropertySetter(readWgs84BoundingBox),
	    'Identifier': makeObjectPropertySetter(readString)
	  }));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var STYLE_PARSERS$2 = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'LegendURL': makeObjectPropertyPusher(readLegendUrl)
	  }, makeStructureNS(OWS_NAMESPACE_URIS, {
	    'Title': makeObjectPropertySetter(readString),
	    'Identifier': makeObjectPropertySetter(readString)
	  }));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TMS_LINKS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'TileMatrixSet': makeObjectPropertySetter(readString),
	    'TileMatrixSetLimits': makeObjectPropertySetter(readTileMatrixLimitsList)
	  });
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TMS_LIMITS_LIST_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'TileMatrixLimits': makeArrayPusher(readTileMatrixLimits)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TMS_LIMITS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'TileMatrix': makeObjectPropertySetter(readString),
	    'MinTileRow': makeObjectPropertySetter(readNonNegativeInteger),
	    'MaxTileRow': makeObjectPropertySetter(readNonNegativeInteger),
	    'MinTileCol': makeObjectPropertySetter(readNonNegativeInteger),
	    'MaxTileCol': makeObjectPropertySetter(readNonNegativeInteger)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var DIMENSION_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'Default': makeObjectPropertySetter(readString),
	    'Value': makeObjectPropertyPusher(readString)
	  }, makeStructureNS(OWS_NAMESPACE_URIS, {
	    'Identifier': makeObjectPropertySetter(readString)
	  }));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var WGS84_BBOX_READERS = makeStructureNS(
	  OWS_NAMESPACE_URIS, {
	    'LowerCorner': makeArrayPusher(readCoordinates),
	    'UpperCorner': makeArrayPusher(readCoordinates)
	  });
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TMS_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'WellKnownScaleSet': makeObjectPropertySetter(readString),
	    'TileMatrix': makeObjectPropertyPusher(readTileMatrix)
	  }, makeStructureNS(OWS_NAMESPACE_URIS, {
	    'SupportedCRS': makeObjectPropertySetter(readString),
	    'Identifier': makeObjectPropertySetter(readString)
	  }));
	
	
	/**
	 * @const
	 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
	 */
	var TM_PARSERS = makeStructureNS(
	  NAMESPACE_URIS$5, {
	    'TopLeftCorner': makeObjectPropertySetter(readCoordinates),
	    'ScaleDenominator': makeObjectPropertySetter(readDecimal),
	    'TileWidth': makeObjectPropertySetter(readNonNegativeInteger),
	    'TileHeight': makeObjectPropertySetter(readNonNegativeInteger),
	    'MatrixWidth': makeObjectPropertySetter(readNonNegativeInteger),
	    'MatrixHeight': makeObjectPropertySetter(readNonNegativeInteger)
	  }, makeStructureNS(OWS_NAMESPACE_URIS, {
	    'Identifier': makeObjectPropertySetter(readString)
	  }));
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Attribution object.
	 */
	function readContents(node, objectStack) {
	  return pushParseAndPop({}, CONTENTS_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Layers object.
	 */
	function readLayer$1(node, objectStack) {
	  return pushParseAndPop({}, LAYER_PARSERS$1, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Tile Matrix Set object.
	 */
	function readTileMatrixSet(node, objectStack) {
	  return pushParseAndPop({}, TMS_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Style object.
	 */
	function readStyle$2(node, objectStack) {
	  var style = pushParseAndPop({}, STYLE_PARSERS$2, node, objectStack);
	  if (!style) {
	    return undefined;
	  }
	  var isDefault = node.getAttribute('isDefault') === 'true';
	  style['isDefault'] = isDefault;
	  return style;
	
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Tile Matrix Set Link object.
	 */
	function readTileMatrixSetLink(node, objectStack) {
	  return pushParseAndPop({}, TMS_LINKS_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Dimension object.
	 */
	function readDimensions(node, objectStack) {
	  return pushParseAndPop({}, DIMENSION_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Resource URL object.
	 */
	function readResourceUrl(node, objectStack) {
	  var format = node.getAttribute('format');
	  var template = node.getAttribute('template');
	  var resourceType = node.getAttribute('resourceType');
	  var resource = {};
	  if (format) {
	    resource['format'] = format;
	  }
	  if (template) {
	    resource['template'] = template;
	  }
	  if (resourceType) {
	    resource['resourceType'] = resourceType;
	  }
	  return resource;
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} WGS84 BBox object.
	 */
	function readWgs84BoundingBox(node, objectStack) {
	  var coordinates = pushParseAndPop([], WGS84_BBOX_READERS, node, objectStack);
	  if (coordinates.length != 2) {
	    return undefined;
	  }
	  return boundingExtent(coordinates);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Legend object.
	 */
	function readLegendUrl(node, objectStack) {
	  var legend = {};
	  legend['format'] = node.getAttribute('format');
	  legend['href'] = readHref(node);
	  return legend;
	}
	
	
	/**
	 * @param {Node} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} Coordinates object.
	 */
	function readCoordinates(node, objectStack) {
	  var coordinates = readString(node).split(/\s+/);
	  if (!coordinates || coordinates.length != 2) {
	    return undefined;
	  }
	  var x = +coordinates[0];
	  var y = +coordinates[1];
	  if (isNaN(x) || isNaN(y)) {
	    return undefined;
	  }
	  return [x, y];
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} TileMatrix object.
	 */
	function readTileMatrix(node, objectStack) {
	  return pushParseAndPop({}, TM_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} TileMatrixSetLimits Object.
	 */
	function readTileMatrixLimitsList(node, objectStack) {
	  return pushParseAndPop([], TMS_LIMITS_LIST_PARSERS, node, objectStack);
	}
	
	
	/**
	 * @param {Element} node Node.
	 * @param {Array<*>} objectStack Object stack.
	 * @return {Object|undefined} TileMatrixLimits Array.
	 */
	function readTileMatrixLimits(node, objectStack) {
	  return pushParseAndPop({}, TMS_LIMITS_PARSERS, node, objectStack);
	}
	
	var ol = {};
	
	ol.array = {};
	ol.color = {};
	ol.colorlike = {};
	ol.control = {};
	ol.coordinate = {};
	ol.easing = {};
	ol.events = {};
	ol.events.condition = {};
	ol.extent = {};
	ol.featureloader = {};
	ol.format = {};
	ol.format.filter = {};
	ol.geom = {};
	ol.geom.flat = {};
	ol.geom.flat.length = {};
	ol.geom.flat.segments = {};
	ol.geom.flat.textpath = {};
	ol.geom.flat.transform = {};
	ol.has = {};
	ol.interaction = {};
	ol.layer = {};
	ol.layer.Layer = {};
	ol.loadingstrategy = {};
	ol.math = {};
	ol.obj = {};
	ol.pointer = {};
	ol.proj = {};
	ol.proj.Units = {};
	ol.proj.proj4 = {};
	ol.render = {};
	ol.render.canvas = {};
	ol.renderer = {};
	ol.renderer.canvas = {};
	ol.renderer.webgl = {};
	ol.size = {};
	ol.source = {};
	ol.sphere = {};
	ol.structs = {};
	ol.style = {};
	ol.style.IconImageCache = {};
	ol.tilecoord = {};
	ol.tilegrid = {};
	ol.transform = {};
	ol.uri = {};
	ol.xml = {};
	ol.Collection = Collection;
	ol.Feature = Feature;
	ol.Geolocation = Geolocation;
	ol.Graticule = Graticule;
	ol.Kinetic = Kinetic;
	ol.Map = Map;
	ol.MapBrowserEvent = MapBrowserEvent;
	ol.MapBrowserEventType = MapBrowserEventType;
	ol.MapBrowserPointerEvent = MapBrowserPointerEvent;
	ol.Object = BaseObject;
	ol.Observable = Observable;
	ol.Observable.unByKey = unByKey;
	ol.Overlay = Overlay;
	ol.PluggableMap = PluggableMap;
	ol.TileQueue = TileQueue;
	ol.TileState = TileState$1;
	ol.View = View;
	ol.ViewHint = ViewHint;
	ol.ViewHint = ViewHint$1;
	ol.WebGLMap = WebGLMap;
	ol.array.equals = equals;
	ol.array.numberSafeCompareFunction = numberSafeCompareFunction;
	ol.array.stableSort = stableSort;
	ol.color.asArray = asArray;
	ol.color.asString = asString;
	ol.colorlike.asColorLike = asColorLike;
	ol.control.Attribution = Attribution;
	ol.control.Attribution.render = render;
	ol.control.Control = Control;
	ol.control.FullScreen = FullScreen;
	ol.control.MousePosition = MousePosition;
	ol.control.MousePosition.render = render$2;
	ol.control.OverviewMap = OverviewMap;
	ol.control.OverviewMap.render = render$3;
	ol.control.Rotate = Rotate;
	ol.control.Rotate.render = render$1;
	ol.control.ScaleLine = ScaleLine;
	ol.control.ScaleLine.render = render$4;
	ol.control.Zoom = Zoom;
	ol.control.ZoomSlider = ZoomSlider;
	ol.control.ZoomSlider.render = render$5;
	ol.control.ZoomToExtent = ZoomToExtent;
	ol.control.defaults = defaults;
	ol.coordinate.add = add$2;
	ol.coordinate.closestOnCircle = closestOnCircle;
	ol.coordinate.closestOnSegment = closestOnSegment;
	ol.coordinate.createStringXY = createStringXY;
	ol.coordinate.degreesToStringHDMS = degreesToStringHDMS;
	ol.coordinate.distance = distance;
	ol.coordinate.equals = equals$2;
	ol.coordinate.format = format;
	ol.coordinate.rotate = rotate$2;
	ol.coordinate.scale = scale$2;
	ol.coordinate.squaredDistance = squaredDistance$1;
	ol.coordinate.squaredDistanceToSegment = squaredDistanceToSegment;
	ol.coordinate.toStringHDMS = toStringHDMS;
	ol.coordinate.toStringXY = toStringXY;
	ol.easing.easeIn = easeIn;
	ol.easing.easeOut = easeOut;
	ol.easing.inAndOut = inAndOut;
	ol.easing.linear = linear;
	ol.easing.upAndDown = upAndDown;
	ol.events.EventType = EventType$1;
	ol.events.condition.altKeyOnly = altKeyOnly;
	ol.events.condition.altShiftKeysOnly = altShiftKeysOnly;
	ol.events.condition.always = always;
	ol.events.condition.click = click;
	ol.events.condition.doubleClick = doubleClick;
	ol.events.condition.focus = focus;
	ol.events.condition.mouseOnly = mouseOnly;
	ol.events.condition.never = never;
	ol.events.condition.noModifierKeys = noModifierKeys;
	ol.events.condition.platformModifierKeyOnly = platformModifierKeyOnly;
	ol.events.condition.pointerMove = pointerMove$1;
	ol.events.condition.primaryAction = primaryAction;
	ol.events.condition.shiftKeyOnly = shiftKeyOnly;
	ol.events.condition.singleClick = singleClick;
	ol.events.condition.targetNotEditable = targetNotEditable;
	ol.events.listen = listen;
	ol.events.unlisten = unlisten;
	ol.extent.applyTransform = applyTransform;
	ol.extent.boundingExtent = boundingExtent;
	ol.extent.buffer = buffer;
	ol.extent.clone = clone;
	ol.extent.closestSquaredDistanceXY = closestSquaredDistanceXY;
	ol.extent.containsCoordinate = containsCoordinate;
	ol.extent.containsExtent = containsExtent;
	ol.extent.containsXY = containsXY;
	ol.extent.coordinateRelationship = coordinateRelationship;
	ol.extent.createEmpty = createEmpty;
	ol.extent.createOrUpdate = createOrUpdate;
	ol.extent.createOrUpdateEmpty = createOrUpdateEmpty;
	ol.extent.createOrUpdateFromCoordinate = createOrUpdateFromCoordinate;
	ol.extent.createOrUpdateFromCoordinates = createOrUpdateFromCoordinates;
	ol.extent.createOrUpdateFromFlatCoordinates = createOrUpdateFromFlatCoordinates;
	ol.extent.createOrUpdateFromRings = createOrUpdateFromRings;
	ol.extent.equals = equals$1;
	ol.extent.extend = extend$1;
	ol.extent.extendCoordinate = extendCoordinate;
	ol.extent.extendCoordinates = extendCoordinates;
	ol.extent.extendFlatCoordinates = extendFlatCoordinates;
	ol.extent.extendRings = extendRings;
	ol.extent.extendXY = extendXY;
	ol.extent.forEachCorner = forEachCorner;
	ol.extent.getArea = getArea;
	ol.extent.getBottomLeft = getBottomLeft;
	ol.extent.getBottomRight = getBottomRight;
	ol.extent.getCenter = getCenter;
	ol.extent.getCorner = getCorner;
	ol.extent.getEnlargedArea = getEnlargedArea;
	ol.extent.getForViewAndSize = getForViewAndSize;
	ol.extent.getHeight = getHeight;
	ol.extent.getIntersection = getIntersection;
	ol.extent.getIntersectionArea = getIntersectionArea;
	ol.extent.getMargin = getMargin;
	ol.extent.getSize = getSize;
	ol.extent.getTopLeft = getTopLeft;
	ol.extent.getTopRight = getTopRight;
	ol.extent.getWidth = getWidth;
	ol.extent.intersects = intersects;
	ol.extent.intersectsSegment = intersectsSegment;
	ol.extent.isEmpty = isEmpty$1;
	ol.extent.returnOrUpdate = returnOrUpdate;
	ol.extent.scaleFromCenter = scaleFromCenter;
	ol.featureloader.xhr = xhr;
	ol.format.EsriJSON = EsriJSON;
	ol.format.Feature = FeatureFormat;
	ol.format.GML = GML;
	ol.format.GML2 = GML2;
	ol.format.GML3 = GML3;
	ol.format.GML32 = GML32;
	ol.format.GPX = GPX;
	ol.format.GeoJSON = GeoJSON;
	ol.format.IGC = IGC;
	ol.format.KML = KML;
	ol.format.MVT = MVT;
	ol.format.OSMXML = OSMXML;
	ol.format.Polyline = Polyline;
	ol.format.Polyline.decodeDeltas = decodeDeltas;
	ol.format.Polyline.decodeFloats = decodeFloats;
	ol.format.Polyline.encodeDeltas = encodeDeltas;
	ol.format.Polyline.encodeFloats = encodeFloats;
	ol.format.TopoJSON = TopoJSON;
	ol.format.WFS = WFS;
	ol.format.WFS.writeFilter = writeFilter;
	ol.format.WKT = WKT;
	ol.format.WMSCapabilities = WMSCapabilities;
	ol.format.WMSGetFeatureInfo = WMSGetFeatureInfo;
	ol.format.WMTSCapabilities = WMTSCapabilities;
	ol.format.filter.Bbox = Bbox;
	ol.format.filter.Contains = Contains;
	ol.format.filter.During = During;
	ol.format.filter.EqualTo = EqualTo;
	ol.format.filter.GreaterThan = GreaterThan;
	ol.format.filter.GreaterThanOrEqualTo = GreaterThanOrEqualTo;
	ol.format.filter.Intersects = Intersects;
	ol.format.filter.IsBetween = IsBetween;
	ol.format.filter.IsLike = IsLike;
	ol.format.filter.IsNull = IsNull;
	ol.format.filter.LessThan = LessThan;
	ol.format.filter.LessThanOrEqualTo = LessThanOrEqualTo;
	ol.format.filter.Not = Not;
	ol.format.filter.NotEqualTo = NotEqualTo;
	ol.format.filter.Or = Or;
	ol.format.filter.Within = Within;
	ol.format.filter.and = and;
	ol.format.filter.bbox = bbox$1;
	ol.format.filter.between = between;
	ol.format.filter.contains = contains$1;
	ol.format.filter.during = during;
	ol.format.filter.equalTo = equalTo;
	ol.format.filter.greaterThan = greaterThan;
	ol.format.filter.greaterThanOrEqualTo = greaterThanOrEqualTo;
	ol.format.filter.intersects = intersects$2;
	ol.format.filter.isNull = isNull;
	ol.format.filter.lessThan = lessThan;
	ol.format.filter.lessThanOrEqualTo = lessThanOrEqualTo;
	ol.format.filter.like = like;
	ol.format.filter.not = not;
	ol.format.filter.notEqualTo = notEqualTo;
	ol.format.filter.or = or;
	ol.format.filter.within = within;
	ol.geom.Circle = Circle;
	ol.geom.Geometry = Geometry;
	ol.geom.GeometryCollection = GeometryCollection;
	ol.geom.GeometryType = GeometryType$1;
	ol.geom.LineString = LineString;
	ol.geom.LinearRing = LinearRing;
	ol.geom.MultiLineString = MultiLineString;
	ol.geom.MultiPoint = MultiPoint;
	ol.geom.MultiPolygon = MultiPolygon;
	ol.geom.Point = Point;
	ol.geom.Polygon = Polygon;
	ol.geom.Polygon.circular = circular;
	ol.geom.Polygon.fromCircle = fromCircle;
	ol.geom.Polygon.fromExtent = fromExtent;
	ol.geom.SimpleGeometry = SimpleGeometry;
	ol.geom.flat.length.lineStringLength = lineStringLength;
	ol.geom.flat.segments.forEach = forEach;
	ol.geom.flat.textpath.drawTextOnPath = drawTextOnPath;
	ol.geom.flat.transform.transform2D = transform2D;
	ol.getUid = getUid;
	ol.has.DEVICE_PIXEL_RATIO = DEVICE_PIXEL_RATIO;
	ol.has.FIREFOX = FIREFOX;
	ol.has.GEOLOCATION = GEOLOCATION;
	ol.has.MAC = MAC;
	ol.has.SAFARI = SAFARI;
	ol.has.TOUCH = TOUCH;
	ol.has.WEBKIT = WEBKIT;
	ol.inherits = inherits;
	ol.interaction.DoubleClickZoom = DoubleClickZoom;
	ol.interaction.DragAndDrop = DragAndDrop;
	ol.interaction.DragBox = DragBox;
	ol.interaction.DragPan = DragPan;
	ol.interaction.DragRotate = DragRotate;
	ol.interaction.DragRotateAndZoom = DragRotateAndZoom;
	ol.interaction.DragZoom = DragZoom;
	ol.interaction.Draw = Draw;
	ol.interaction.Draw.createBox = createBox;
	ol.interaction.Draw.createRegularPolygon = createRegularPolygon;
	ol.interaction.Extent = ExtentInteraction;
	ol.interaction.Interaction = Interaction;
	ol.interaction.Interaction.zoomByDelta = zoomByDelta;
	ol.interaction.KeyboardPan = KeyboardPan;
	ol.interaction.KeyboardZoom = KeyboardZoom;
	ol.interaction.Modify = Modify;
	ol.interaction.MouseWheelZoom = MouseWheelZoom;
	ol.interaction.PinchRotate = PinchRotate;
	ol.interaction.PinchZoom = PinchZoom;
	ol.interaction.Pointer = PointerInteraction;
	ol.interaction.Select = Select;
	ol.interaction.Snap = Snap;
	ol.interaction.Translate = Translate;
	ol.interaction.defaults = defaults$1;
	ol.layer.Base = BaseLayer;
	ol.layer.Group = LayerGroup;
	ol.layer.Heatmap = Heatmap;
	ol.layer.Image = ImageLayer;
	ol.layer.Layer.visibleAtResolution = visibleAtResolution;
	ol.layer.Tile = TileLayer;
	ol.layer.Vector = VectorLayer;
	ol.layer.VectorTile = VectorTileLayer;
	ol.loadingstrategy.all = all;
	ol.loadingstrategy.bbox = bbox;
	ol.loadingstrategy.tile = tile;
	ol.math.clamp = clamp;
	ol.math.cosh = cosh;
	ol.math.lerp = lerp;
	ol.math.modulo = modulo;
	ol.math.roundUpToPowerOfTwo = roundUpToPowerOfTwo;
	ol.math.solveLinearSystem = solveLinearSystem;
	ol.math.squaredDistance = squaredDistance;
	ol.math.squaredSegmentDistance = squaredSegmentDistance;
	ol.math.toDegrees = toDegrees;
	ol.math.toRadians = toRadians;
	ol.obj.assign = assign;
	ol.obj.isEmpty = isEmpty;
	ol.pointer.PointerEventHandler = PointerEventHandler;
	ol.proj.Projection = Projection;
	ol.proj.Units.METERS_PER_UNIT = METERS_PER_UNIT;
	ol.proj.addCoordinateTransforms = addCoordinateTransforms;
	ol.proj.addEquivalentProjections = addEquivalentProjections;
	ol.proj.addProjection = addProjection;
	ol.proj.equivalent = equivalent;
	ol.proj.fromLonLat = fromLonLat;
	ol.proj.get = get$2;
	ol.proj.getPointResolution = getPointResolution;
	ol.proj.getTransform = getTransform;
	ol.proj.proj4.register = register;
	ol.proj.toLonLat = toLonLat;
	ol.proj.transform = transform;
	ol.proj.transformExtent = transformExtent;
	ol.rbush = rbush$1;
	ol.render.EventType = EventType$2;
	ol.render.ORDER = ORDER$1;
	ol.render.ReplayType = ReplayType$1;
	ol.render.TEXT_ALIGN = TEXT_ALIGN$1;
	ol.render.VectorContext = VectorContext;
	ol.render.canvas.Immediate = CanvasImmediateRenderer;
	ol.render.canvas.Instruction = Instruction$1;
	ol.render.canvas.Replay = CanvasReplay;
	ol.render.canvas.ReplayGroup = CanvasReplayGroup;
	ol.render.canvas.ReplayGroup.getCircleArray = getCircleArray;
	ol.render.canvas.TextReplay = CanvasTextReplay;
	ol.render.canvas.checkFont = checkFont;
	ol.render.canvas.defaultFillStyle = defaultFillStyle;
	ol.render.canvas.defaultFont = defaultFont;
	ol.render.canvas.defaultLineCap = defaultLineCap;
	ol.render.canvas.defaultLineDash = defaultLineDash;
	ol.render.canvas.defaultLineDashOffset = defaultLineDashOffset;
	ol.render.canvas.defaultLineJoin = defaultLineJoin;
	ol.render.canvas.defaultLineWidth = defaultLineWidth;
	ol.render.canvas.defaultMiterLimit = defaultMiterLimit;
	ol.render.canvas.defaultPadding = defaultPadding;
	ol.render.canvas.defaultStrokeStyle = defaultStrokeStyle;
	ol.render.canvas.defaultTextAlign = defaultTextAlign;
	ol.render.canvas.defaultTextBaseline = defaultTextBaseline;
	ol.render.canvas.labelCache = labelCache;
	ol.render.canvas.rotateAtOffset = rotateAtOffset;
	ol.render.toContext = toContext;
	ol.renderer.Map = MapRenderer;
	ol.renderer.canvas.ImageLayer = CanvasImageLayerRenderer;
	ol.renderer.canvas.IntermediateCanvas = IntermediateCanvasRenderer;
	ol.renderer.canvas.Map = CanvasMapRenderer;
	ol.renderer.canvas.TileLayer = CanvasTileLayerRenderer;
	ol.renderer.canvas.VectorLayer = CanvasVectorLayerRenderer;
	ol.renderer.canvas.VectorTileLayer = CanvasVectorTileLayerRenderer;
	ol.renderer.webgl.ImageLayer = WebGLImageLayerRenderer;
	ol.renderer.webgl.Map = WebGLMapRenderer;
	ol.renderer.webgl.TileLayer = WebGLTileLayerRenderer;
	ol.renderer.webgl.VectorLayer = WebGLVectorLayerRenderer;
	ol.size.toSize = toSize;
	ol.source.BingMaps = BingMaps;
	ol.source.CartoDB = CartoDB;
	ol.source.Cluster = Cluster;
	ol.source.Image = ImageSource;
	ol.source.ImageArcGISRest = ImageArcGISRest;
	ol.source.ImageCanvas = ImageCanvasSource;
	ol.source.ImageMapGuide = ImageMapGuide;
	ol.source.ImageStatic = Static;
	ol.source.ImageWMS = ImageWMS;
	ol.source.OSM = OSM;
	ol.source.OSM.ATTRIBUTION = ATTRIBUTION;
	ol.source.Raster = RasterSource;
	ol.source.Source = Source;
	ol.source.Stamen = Stamen;
	ol.source.Tile = TileSource;
	ol.source.TileArcGISRest = TileArcGISRest;
	ol.source.TileDebug = TileDebug;
	ol.source.TileImage = TileImage;
	ol.source.TileJSON = TileJSON;
	ol.source.TileWMS = TileWMS;
	ol.source.UTFGrid = UTFGrid;
	ol.source.Vector = VectorSource;
	ol.source.VectorTile = VectorTile$1;
	ol.source.WMTS = WMTS;
	ol.source.WMTS.optionsFromCapabilities = optionsFromCapabilities;
	ol.source.XYZ = XYZ;
	ol.source.Zoomify = Zoomify;
	ol.sphere.getArea = getArea$1;
	ol.sphere.getDistance = getDistance;
	ol.sphere.getLength = getLength;
	ol.structs.RBush = RBush;
	ol.style.AtlasManager = AtlasManager;
	ol.style.Circle = CircleStyle;
	ol.style.Fill = Fill;
	ol.style.Icon = Icon;
	ol.style.IconImageCache.shared = shared;
	ol.style.Image = ImageStyle;
	ol.style.RegularShape = RegularShape;
	ol.style.Stroke = Stroke;
	ol.style.Style = Style;
	ol.style.Text = Text;
	ol.style.Text.DEFAULT_FILL_COLOR = DEFAULT_FILL_COLOR;
	ol.style.TextPlacement = TextPlacement$1;
	ol.tilecoord.createOrUpdate = createOrUpdate$2;
	ol.tilecoord.fromKey = fromKey;
	ol.tilecoord.getKey = getKey$1;
	ol.tilecoord.getKeyZXY = getKeyZXY;
	ol.tilecoord.hash = hash;
	ol.tilecoord.quadKey = quadKey;
	ol.tilecoord.withinExtentAndZ = withinExtentAndZ;
	ol.tilegrid.TileGrid = TileGrid;
	ol.tilegrid.WMTS = WMTSTileGrid;
	ol.tilegrid.WMTS.createFromCapabilitiesMatrixSet = createFromCapabilitiesMatrixSet;
	ol.tilegrid.createXYZ = createXYZ;
	ol.tilegrid.getForProjection = getForProjection;
	ol.transform.compose = compose;
	ol.transform.invert = invert;
	ol.transform.setFromArray = setFromArray;
	ol.uri.appendParams = appendParams;
	ol.xml.getAllTextContent = getAllTextContent;
	ol.xml.parse = parse;
	
	module.exports = ol;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	
	ol.TileQueue.prototype.handleTileChange = function(event) {
	    var tile = /** @type {import("./Tile.js").default} */ (event.target);
	    var state = tile.getState();
	    if (!this.loadingSlots) {
	        this.loadingSlots = [];
	    }
	    if (state === ol.TileState.LOADED || state === ol.TileState.ERROR ||
	        state === ol.TileState.EMPTY || state === ol.TileState.ABORT) {
	        ol.events.unlisten(tile, ol.events.EventType.CHANGE,
	            this.handleTileChange, this);
	        var tileKey = tile.getKey();
	        if (tileKey in this.tilesLoadingKeys_) {
	            delete this.tilesLoadingKeys_[tileKey];
	            --this.tilesLoading_;
	        }
	
	        var indexOfTileSlot = this.loadingSlots.indexOf(tile);
	        if (~this.loadingSlots.indexOf(tile)) {
	            this.loadingSlots.splice(indexOfTileSlot, 1);
	        }
	
	        this.tileChangeCallback_();
	    }
	};
	
	ol.TileQueue.prototype.loadMoreTiles = function(maxTotalLoading, maxNewLoads) {
	    var newLoads = 0;
	    var abortedTiles = false;
	    var state, tile, tileKey;
	    if (!this.loadingSlots) {
	        this.loadingSlots = [];
	    }
	    while (this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads &&
	    this.getCount() > 0) {
	        tile = /** @type {import("./Tile.js").default} */ (this.dequeue()[0]);
	        tileKey = tile.getKey();
	        state = tile.getState();
	        if (state === ol.TileState.ABORT) {
	            abortedTiles = true;
	        } else if (state === ol.TileState.IDLE && !(tileKey in this.tilesLoadingKeys_)) {
	            this.tilesLoadingKeys_[tileKey] = true;
	            ++this.tilesLoading_;
	            ++newLoads;
	            this.loadingSlots.push(tile);
	            tile.load();
	        }
	    }
	    if (newLoads === 0 && abortedTiles) {
	        // Do not stop the render loop when all wanted tiles were aborted due to
	        // a small, saturated tile cache.
	        this.tileChangeCallback_();
	    }
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	
	ol.renderer.canvas.TileLayer.prototype.manageTilePyramid = function (
	    frameState, tileSource, tileGrid, pixelRatio, projection, extent,
	    currentZ, preload, opt_tileCallback, opt_this) {
	    var tileSourceKey = ol.getUid(tileSource);
	    if (!(tileSourceKey in frameState.wantedTiles)) {
	        frameState.wantedTiles[tileSourceKey] = {};
	    }
	    var wantedTiles = frameState.wantedTiles[tileSourceKey];
	    var tileQueue = frameState.tileQueue;
	    var minZoom = tileGrid.getMinZoom();
	    var tile, tileRange, tileResolution, x, y, z;
	    var loadingTile = [];
	    for (z = minZoom; z <= currentZ; ++z) {
	        tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
	        tileResolution = tileGrid.getResolution(z);
	        for (x = tileRange.minX; x <= tileRange.maxX; ++x) {
	            for (y = tileRange.minY; y <= tileRange.maxY; ++y) {
	                if (currentZ - z <= preload) {
	                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
	                    loadingTile.push(ol.tilecoord.getKeyZXY(z, x, y));
	                    if (tile.getState() == ol.TileState.IDLE) {
	                        wantedTiles[tile.getKey()] = true;
	                        if (!tileQueue.isKeyQueued(tile.getKey())) {
	                            tileQueue.enqueue([tile, tileSourceKey,
	                                tileGrid.getTileCoordCenter(tile.tileCoord), tileResolution]);
	                        }
	                    }
	                    if (opt_tileCallback !== undefined) {
	                        opt_tileCallback.call(opt_this, tile);
	                    }
	                } else {
	                    tileSource.useTile(z, x, y, projection);
	                }
	            }
	        }
	    }
	    tileSource.tileCache.forEach(function (Tile, key, TileCache) {
	        var image_;
	        if ((Tile.state != ol.TileState.LOADING && Tile.state != ol.TileState.IDLE)
	            || ~loadingTile.indexOf(key)) {
	            return;
	        }
	        try {
	            if (Tile.getImage()) {
	                image_ = Tile.getImage();
	                Tile.disposeInternal();
	                image_.src = "";
	                try {
	                    TileCache.remove(key);
	                } catch (e) {
	                    console.warn(e)
	                }
	            }
	        } catch (e) {
	            // ресурс не поддерживает работу с изображениями
	        }
	    });
	}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	/**
	 * Модификация MouseWheelZoom с правкой большой чувствительности зума при использовании тачпада
	 * Повторение правок 77f298667e0b 5cd2599ed528 4cfe9e0a3411
	 * @param opt_options
	 * @constructor
	 */
	ol.interaction.OMJSMouseWheelZoom = function (opt_options) {
	    ol.interaction.MouseWheelZoom.call(this, opt_options);
	    this.finishAnchor_ = null;
	    this.trackpadTimeoutFinish_ = undefined;
	    this._trackpadDeltaBuff = 0;
	}
	ol.inherits(ol.interaction.OMJSMouseWheelZoom, ol.interaction.MouseWheelZoom);
	
	ol.interaction.OMJSMouseWheelZoom.prototype.handleEvent = function handleEvent(mapBrowserEvent) {
	    if (!this.condition_(mapBrowserEvent)) {
	        return true;
	    }
	    var type = mapBrowserEvent.type;
	    if (type !== ol.events.EventType.WHEEL && type !== ol.events.EventType.MOUSEWHEEL) {
	        return true;
	    }
	
	    mapBrowserEvent.preventDefault();
	
	    var map = mapBrowserEvent.map;
	    var wheelEvent = /** @type {WheelEvent} */ (mapBrowserEvent.originalEvent);
	
	    if (this.useAnchor_) {
	        this.lastAnchor_ = mapBrowserEvent.coordinate;
	        this.finishAnchor_ = [mapBrowserEvent.coordinate[0], mapBrowserEvent.coordinate[1]];
	    }
	
	    // Delta normalisation inspired by
	    // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
	    var delta;
	    if (mapBrowserEvent.type == ol.events.EventType.WHEEL) {
	        delta = wheelEvent.deltaY;
	        if (ol.has.FIREFOX &&
	            wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
	            delta /= ol.has.DEVICE_PIXEL_RATIO;
	        }
	        if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) {
	            delta *= 40;
	        }
	    } else if (mapBrowserEvent.type == ol.events.EventType.MOUSEWHEEL) {
	        delta = -wheelEvent.wheelDeltaY;
	        if (ol.has.SAFARI) {
	            delta /= 3;
	        }
	    }
	
	    if (delta === 0) {
	        return false;
	    }
	
	    var now = Date.now();
	
	    if (this.startTime_ === undefined) {
	        this.startTime_ = now;
	    }
	
	    if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) {
	        this.mode_ = Math.abs(delta) < 8 ?
	            ol.interaction.OMJSMouseWheelZoom.Mode_.TRACKPAD :
	            ol.interaction.OMJSMouseWheelZoom.Mode_.WHEEL;
	    }
	
	    if (this.mode_ === ol.interaction.OMJSMouseWheelZoom.Mode_.TRACKPAD) {
	        if ((this._trackpadDeltaBuff < 0 && delta > 0) || (this._trackpadDeltaBuff > 0 && delta < 0)) {
	            this._trackpadDeltaBuff = 0;
	        }
	
	        this._trackpadDeltaBuff += delta;
	
	        if (Math.abs(this._trackpadDeltaBuff) < 53) {
	            return;
	        }
	
	        this._trackpadDeltaBuff = 0;
	
	        if (this.trackpadTimeoutFinish_ === undefined) {
	            var that = this;
	            this.trackpadTimeoutFinish_ = setTimeout(function () {
	                that.trackpadTimeoutFinish_ = undefined;
	            }, this.duration_);
	        } else {
	            return;
	        }
	    }
	
	    this.delta_ += delta;
	
	    var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
	
	    clearTimeout(this.timeoutId_);
	    this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
	
	    return false;
	};
	ol.interaction.OMJSMouseWheelZoom.prototype.handleWheelZoom_ = function handleWheelZoom_(map) {
	    var view = map.getView();
	    if (view.getAnimating()) {
	        view.cancelAnimations();
	    }
	    var maxDelta = ol.interaction.OMJSMouseWheelZoom.MAX_DELTA_;
	    var delta = ol.math.clamp(this.delta_, -maxDelta, maxDelta);
	    ol.interaction.Interaction.zoomByDelta(view, -delta, this.lastAnchor_, this.duration_);
	    view.setHint(ol.ViewHint.INTERACTING, 0);
	    this.mode_ = undefined;
	    this.delta_ = 0;
	    this.lastAnchor_ = null;
	    this.startTime_ = undefined;
	    this.timeoutId_ = undefined;
	};
	ol.interaction.OMJSMouseWheelZoom.Mode_ = {
	    TRACKPAD: 'trackpad',
	    WHEEL: 'wheel'
	};
	ol.interaction.OMJSMouseWheelZoom.MAX_DELTA_ = 1;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	// VFL переопределение конструктора ol.style.Text
	// добавлен атрибут перекрытий
	var olStyleText = function (opt_options) {
	
	    var options = opt_options || {};
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.font_ = options.font;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.rotation_ = options.rotation;
	
	    /**
	     * @private
	     * @type {boolean|undefined}
	     */
	    this.rotateWithView_ = options.rotateWithView;
	
	    /**
	     * @private
	     * @type {number|undefined}
	     */
	    this.scale_ = options.scale;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.text_ = options.text;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.textAlign_ = options.textAlign;
	
	    /**
	     * @private
	     * @type {string|undefined}
	     */
	    this.textBaseline_ = options.textBaseline;
	
	    /**
	     * @private
	     * @type {import("./Fill.js").default}
	     */
	    this.fill_ = options.fill !== undefined ? options.fill :
	        new ol.style.Fill({color: ol.style.Text.DEFAULT_FILL_COLOR});
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
	
	    /**
	     * @private
	     * @type {import("./TextPlacement.js").default|string}
	     */
	    this.placement_ = options.placement !== undefined ? options.placement : ol.style.TextPlacement.POINT;
	
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.overflow_ = !!options.overflow;
	
	    /**
	     * @private
	     * @type {import("./Stroke.js").default}
	     */
	    this.stroke_ = options.stroke !== undefined ? options.stroke : null;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
	
	    /**
	     * @private
	     * @type {import("./Fill.js").default}
	     */
	    this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
	
	    /**
	     * @private
	     * @type {import("./Stroke.js").default}
	     */
	    this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
	
	    /**
	     * @private
	     * @type {Array<number>}
	     */
	    this.padding_ = options.padding === undefined ? null : options.padding;
	
	    // VFL добавлен атрибут перекрытий
	    // по умолчанию true (в отличии от мапника), т.к. в проектах по умолчанию тексты могут перекрываться
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.overlap_ = options.overlap !== undefined ? options.overlap : true;
	};
	
	olStyleText.prototype = {};
	
	ol.inherits(olStyleText, ol.style.Text);
	
	ol.style.Text = olStyleText;
	
	// VFL геттер атрибута перекрытий текта
	ol.style.Text.prototype.getOverlap = function () {
	    return this.overlap_;
	};
	
	// VFL сеттер атрибута перекрытий текстов
	ol.style.Text.prototype.setOverlap = function (overlap) {
	    this.overlap_ = overlap;
	};
	
	// VFL клонирование с учетом перекрытий текстов
	ol.style.Text.prototype.clone = function () {
	    return new Text({
	        font: this.getFont(),
	        placement: this.getPlacement(),
	        maxAngle: this.getMaxAngle(),
	        overflow: this.getOverflow(),
	        rotation: this.getRotation(),
	        rotateWithView: this.getRotateWithView(),
	        scale: this.getScale(),
	        text: this.getText(),
	        textAlign: this.getTextAlign(),
	        textBaseline: this.getTextBaseline(),
	        fill: this.getFill() ? this.getFill().clone() : undefined,
	        stroke: this.getStroke() ? this.getStroke().clone() : undefined,
	        offsetX: this.getOffsetX(),
	        offsetY: this.getOffsetY(),
	        backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
	        backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
	        // VFL клонирование с учетом перекрытий текстов
	        overlap: this.getOverlap()
	    });
	};
	
	
	// VFL
	// добавлен атрибут перекрытий textOverlap
	ol.render.canvas.Immediate.prototype.setTextStyle = function (textStyle) {
	    if (!textStyle) {
	        this.text_ = '';
	    } else {
	        var textFillStyle = textStyle.getFill();
	        if (!textFillStyle) {
	            this.textFillState_ = null;
	        } else {
	            var textFillStyleColor = textFillStyle.getColor();
	            this.textFillState_ = {
	                fillStyle: ol.colorlike.asColorLike(textFillStyleColor ?
	                    textFillStyleColor : ol.render.canvas.defaultFillStyle)
	            };
	        }
	        var textStrokeStyle = textStyle.getStroke();
	        if (!textStrokeStyle) {
	            this.textStrokeState_ = null;
	        } else {
	            var textStrokeStyleColor = textStrokeStyle.getColor();
	            var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
	            var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
	            var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
	            var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
	            var textStrokeStyleWidth = textStrokeStyle.getWidth();
	            var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
	            this.textStrokeState_ = {
	                lineCap: textStrokeStyleLineCap !== undefined ?
	                    textStrokeStyleLineCap : ol.render.canvas.defaultLineCap,
	                lineDash: textStrokeStyleLineDash ?
	                    textStrokeStyleLineDash : ol.render.canvas.defaultLineDash,
	                lineDashOffset: textStrokeStyleLineDashOffset ?
	                    textStrokeStyleLineDashOffset : ol.render.canvas.defaultLineDashOffset,
	                lineJoin: textStrokeStyleLineJoin !== undefined ?
	                    textStrokeStyleLineJoin : ol.render.canvas.defaultLineJoin,
	                lineWidth: textStrokeStyleWidth !== undefined ?
	                    textStrokeStyleWidth : ol.render.canvas.defaultLineWidth,
	                miterLimit: textStrokeStyleMiterLimit !== undefined ?
	                    textStrokeStyleMiterLimit : ol.render.canvas.defaultMiterLimit,
	                strokeStyle: ol.colorlike.asColorLike(textStrokeStyleColor ?
	                    textStrokeStyleColor : ol.render.canvas.defaultStrokeStyle)
	            };
	        }
	        var textFont = textStyle.getFont();
	        var textOffsetX = textStyle.getOffsetX();
	        var textOffsetY = textStyle.getOffsetY();
	        var textRotateWithView = textStyle.getRotateWithView();
	        var textRotation = textStyle.getRotation();
	        var textScale = textStyle.getScale();
	        var textText = textStyle.getText();
	        var textTextAlign = textStyle.getTextAlign();
	        var textTextBaseline = textStyle.getTextBaseline();
	        // VFL свойство перекрытия
	        var textOverlap = textStyle.getOverlap();
	        this.textState_ = {
	            font: textFont !== undefined ?
	                textFont : ol.render.canvas.defaultFont,
	            textAlign: textTextAlign !== undefined ?
	                textTextAlign : ol.render.canvas.defaultTextAlign,
	            textBaseline: textTextBaseline !== undefined ?
	                textTextBaseline : ol.render.canvas.defaultTextBaseline
	        };
	        this.text_ = textText !== undefined ? textText : '';
	        this.textOffsetX_ =
	            textOffsetX !== undefined ? (this.pixelRatio_ * textOffsetX) : 0;
	        this.textOffsetY_ =
	            textOffsetY !== undefined ? (this.pixelRatio_ * textOffsetY) : 0;
	        this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
	        this.textRotation_ = textRotation !== undefined ? textRotation : 0;
	        this.textScale_ = this.pixelRatio_ * (textScale !== undefined ?
	            textScale : 1);
	        // VFL свойсто перекрытия. В мапнике по умолчанию false, тут true, т.к. в проектах по умолчанию объекты перекрываются
	        this.textOverlap_ = textOverlap !== undefined ? textOverlap : true;
	    }
	};
	// VFL запуск рендера детектора фичи по координате (не визуальный рендер, но рабатает по такому же принципу)
	// очистка накопителя пересечений для рендера детектора, прокидывние слоя
	ol.renderer.Map.prototype.forEachFeatureAtCoordinate = function (
	    coordinate,
	    frameState,
	    hitTolerance,
	    callback,
	    thisArg,
	    layerFilter,
	    thisArg2
	) {
	    var result;
	    var viewState = frameState.viewState;
	    var viewResolution = viewState.resolution;
	
	    /**
	     * @param {import("../Feature.js").FeatureLike} feature Feature.
	     * @param {import("../layer/Layer.js").default} layer Layer.
	     * @return {?} Callback result.
	     */
	    function forEachFeatureAtCoordinate(feature, layer) {
	        var managed = frameState.layerStates[ol.getUid(layer)].managed;
	        if (!(ol.getUid(feature) in frameState.skippedFeatureUids && !managed)) {
	            return callback.call(thisArg, feature, managed ? layer : null);
	        }
	    }
	
	    var projection = viewState.projection;
	
	    var translatedCoordinate = coordinate;
	    if (projection.canWrapX()) {
	        var projectionExtent = projection.getExtent();
	        var worldWidth = ol.extent.getWidth(projectionExtent);
	        var x = coordinate[0];
	        if (x < projectionExtent[0] || x > projectionExtent[2]) {
	            var worldsAway = Math.ceil((projectionExtent[0] - x) / worldWidth);
	            translatedCoordinate = [x + worldWidth * worldsAway, coordinate[1]];
	        }
	    }
	
	    var layerStates = frameState.layerStatesArray;
	    var numLayers = layerStates.length;
	    var i;
	    for (i = numLayers - 1; i >= 0; --i) {
	        var layerState = layerStates[i];
	        var layer = layerState.layer;
	        if (layer.get('overlapHitDetector')) {
	            // VFL очистка накопителя пересечений
	            layer.get('overlapHitDetector').clear();
	        }
	        if (ol.layer.Layer.visibleAtResolution(layerState, viewResolution) && layerFilter.call(thisArg2, layer)) {
	            var layerRenderer = this.getLayerRenderer(layer);
	            var source = /** @type {import("../layer/Layer.js").default} */ (layer).getSource();
	            if (source) {
	                result = layerRenderer.forEachFeatureAtCoordinate(
	                    source.getWrapX() ? translatedCoordinate : coordinate,
	                    frameState, hitTolerance, forEachFeatureAtCoordinate, undefined, layer);
	            }
	            if (result) {
	                return result;
	            }
	        }
	    }
	    return undefined;
	};
	
	// VFL ещё прокидывание layer
	ol.renderer.canvas.VectorLayer.prototype.forEachFeatureAtCoordinate = function forEachFeatureAtCoordinate (coordinate, frameState, hitTolerance, callback, thisArg) {
	    if (!this.replayGroup_) {
	        return undefined;
	    } else {
	        var resolution = frameState.viewState.resolution;
	        var rotation = frameState.viewState.rotation;
	        var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	        /** @type {!Object<string, boolean>} */
	        var features = {};
	        var result = this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, {},
	            /**
	             * @param {import("../../Feature.js").FeatureLike} feature Feature.
	             * @return {?} Callback result.
	             */
	            function(feature) {
	                var key = ol.getUid(feature);
	                if (!(key in features)) {
	                    features[key] = true;
	                    return callback.call(thisArg, feature, layer);
	                }
	            }, null, layer);
	        return result;
	    }
	};
	
	// VFL ещё прокидывени layer и очистка геомтерий, честный вектор
	ol.renderer.canvas.VectorLayer.prototype.compose = function (context, frameState, layerState) {
	    var extent = frameState.extent;
	    var pixelRatio = frameState.pixelRatio;
	    var skippedFeatureUids = layerState.managed ?
	        frameState.skippedFeatureUids : {};
	    var viewState = frameState.viewState;
	    var projection = viewState.projection;
	    var rotation = viewState.rotation;
	    var projectionExtent = projection.getExtent();
	    var vectorSource = /** @type {import("../../source/Vector.js").default} */ (this.getLayer().getSource());
	
	    var transform = this.getTransform(frameState, 0);
	
	    // clipped rendering if layer extent is set
	    var clipExtent = layerState.extent;
	    var clipped = clipExtent !== undefined;
	    if (clipped) {
	        this.clip(context, frameState, /** @type {import("../../extent.js").Extent} */ (clipExtent));
	    }
	    var replayGroup = this.replayGroup_;
	    if (replayGroup && !replayGroup.isEmpty()) {
	        if (this.declutterTree_) {
	            this.declutterTree_.clear();
	        }
	        var layer = /** @type {import("../../layer/Vector.js").default} */ (this.getLayer());
	        var drawOffsetX = 0;
	        var drawOffsetY = 0;
	        var replayContext;
	        var transparentLayer = layerState.opacity !== 1;
	        var hasRenderListeners = layer.hasListener(ol.render.EventType.RENDER);
	        if (transparentLayer || hasRenderListeners) {
	            var drawWidth = context.canvas.width;
	            var drawHeight = context.canvas.height;
	            if (rotation) {
	                var drawSize = Math.round(Math.sqrt(drawWidth * drawWidth + drawHeight * drawHeight));
	                drawOffsetX = (drawSize - drawWidth) / 2;
	                drawOffsetY = (drawSize - drawHeight) / 2;
	                drawWidth = drawHeight = drawSize;
	            }
	            // resize and clear
	            this.context.canvas.width = drawWidth;
	            this.context.canvas.height = drawHeight;
	            replayContext = this.context;
	        } else {
	            replayContext = context;
	        }
	
	        var alpha = replayContext.globalAlpha;
	        if (!transparentLayer) {
	            // for performance reasons, context.save / context.restore is not used
	            // to save and restore the transformation matrix and the opacity.
	            // see http://jsperf.com/context-save-restore-versus-variable
	            replayContext.globalAlpha = layerState.opacity;
	        }
	
	        if (replayContext != context) {
	            replayContext.translate(drawOffsetX, drawOffsetY);
	        }
	
	        var viewHints = frameState.viewHints;
	        var snapToPixel = !(viewHints[ol.ViewHint.ANIMATING] || viewHints[ol.ViewHint.INTERACTING]);
	        var width = frameState.size[0] * pixelRatio;
	        var height = frameState.size[1] * pixelRatio;
	        ol.render.canvas.rotateAtOffset(replayContext, -rotation,
	            width / 2, height / 2);
	
	        // VFL для визуального рендера: детектор пересечений и накопители bbox стилей
	        // + разеделение на визуально отображаемые и скрытые
	        // вызывается тут, потому что это место определения, что image слоя необходимо перерисовать
	        if (!layer.get('overlapDetector')) {
	            layer.set('overlapDetector', new ol.rbush(), true);
	        }
	        if (!layer.get('overlapHitDetector')) {
	            layer.set('overlapHitDetector', new ol.rbush(), true);
	        }
	        layer.get('overlapDetector').clear();
	        layer.set('overlapFeatureExtents', {}, true);
	        layer.set('overlapFeatureExtentsShown', {}, true);
	        layer.set('overlapFeatureExtentsHidden', {}, true);
	
	        replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel, undefined, null, layer);
	        if (vectorSource.getWrapX() && projection.canWrapX() &&
	            !ol.extent.containsExtent(projectionExtent, extent)) {
	            var startX = extent[0];
	            var worldWidth = ol.extent.getWidth(projectionExtent);
	            var world = 0;
	            var offsetX;
	            while (startX < projectionExtent[0]) {
	                --world;
	                offsetX = worldWidth * world;
	                transform = this.getTransform(frameState, offsetX);
	                replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel, undefined, null, layer);
	                startX += worldWidth;
	            }
	            world = 0;
	            startX = extent[2];
	            while (startX > projectionExtent[2]) {
	                ++world;
	                offsetX = worldWidth * world;
	                transform = this.getTransform(frameState, offsetX);
	                replayGroup.replay(replayContext, transform, rotation, skippedFeatureUids, snapToPixel, undefined, null, layer);
	                startX -= worldWidth;
	            }
	        }
	        ol.render.canvas.rotateAtOffset(replayContext, rotation,
	            width / 2, height / 2);
	
	        if (hasRenderListeners) {
	            this.dispatchRenderEvent(replayContext, frameState, transform);
	        }
	        if (replayContext != context) {
	            if (transparentLayer) {
	                var mainContextAlpha = context.globalAlpha;
	                context.globalAlpha = layerState.opacity;
	                context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
	                context.globalAlpha = mainContextAlpha;
	            } else {
	                context.drawImage(replayContext.canvas, -drawOffsetX, -drawOffsetY);
	            }
	            replayContext.translate(-drawOffsetX, -drawOffsetY);
	        }
	
	        if (!transparentLayer) {
	            replayContext.globalAlpha = alpha;
	        }
	    }
	
	    if (clipped) {
	        context.restore();
	    }
	};
	
	// VFL прокидывание layer в детектор
	ol.render.canvas.ReplayGroup.prototype.forEachFeatureAtCoordinate = function (
	    coordinate,
	    resolution,
	    rotation,
	    hitTolerance,
	    skippedFeaturesHash,
	    callback,
	    declutterReplays,
	    layer
	) {
	
	    hitTolerance = Math.round(hitTolerance);
	    var contextSize = hitTolerance * 2 + 1;
	    var transform = ol.transform.compose(this.hitDetectionTransform_,
	        hitTolerance + 0.5, hitTolerance + 0.5,
	        1 / resolution, -1 / resolution,
	        -rotation,
	        -coordinate[0], -coordinate[1]);
	    var context = this.hitDetectionContext_;
	
	    if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
	        context.canvas.width = contextSize;
	        context.canvas.height = contextSize;
	    } else {
	        context.clearRect(0, 0, contextSize, contextSize);
	    }
	
	    /**
	     * @type {import("../../extent.js").Extent}
	     */
	    var hitExtent;
	    if (this.renderBuffer_ !== undefined) {
	        hitExtent = ol.extent.createEmpty();
	        ol.extent.extendCoordinate(hitExtent, coordinate);
	        ol.extent.buffer(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
	    }
	
	    var mask = ol.render.canvas.ReplayGroup.getCircleArray(hitTolerance);
	    var declutteredFeatures;
	    if (this.declutterTree_) {
	        declutteredFeatures = this.declutterTree_.all().map(function(entry) {
	            return entry.value;
	        });
	    }
	
	    var replayType;
	
	    /**
	     * @param {import("../../Feature.js").default|import("../Feature.js").default} feature Feature.
	     * @return {?} Callback result.
	     */
	    function featureCallback(feature) {
	        var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
	        for (var i = 0; i < contextSize; i++) {
	            for (var j = 0; j < contextSize; j++) {
	                if (mask[i][j]) {
	                    if (imageData[(j * contextSize + i) * 4 + 3] > 0) {
	                        var result = (void 0);
	                        if (!(declutteredFeatures && (replayType == ol.render.ReplayType.IMAGE || replayType == ol.render.ReplayType.TEXT)) ||
	                            declutteredFeatures.indexOf(feature) !== -1) {
	                            result = callback(feature);
	                        }
	                        if (result) {
	                            return result;
	                        } else {
	                            context.clearRect(0, 0, contextSize, contextSize);
	                            return undefined;
	                        }
	                    }
	                }
	            }
	        }
	    }
	
	    /** @type {Array<number>} */
	    var zs = Object.keys(this.replaysByZIndex_).map(Number);
	    zs.sort(ol.array.numberSafeCompareFunction);
	
	    var i, j, replays, replay, result;
	    for (i = zs.length - 1; i >= 0; --i) {
	        var zIndexKey = zs[i].toString();
	        replays = this.replaysByZIndex_[zIndexKey];
	        for (j = ol.render.ORDER.length - 1; j >= 0; --j) {
	            replayType = ol.render.ORDER[j];
	            replay = replays[replayType];
	            if (replay !== undefined) {
	                if (declutterReplays &&
	                    (replayType == ol.render.ReplayType.IMAGE || replayType == ol.render.ReplayType.TEXT)) {
	                    var declutter = declutterReplays[zIndexKey];
	                    if (!declutter) {
	                        declutterReplays[zIndexKey] = [replay, transform.slice(0)];
	                    } else {
	                        declutter.push(replay, transform.slice(0));
	                    }
	                } else {
	                    result = replay.replayHitDetection(context, transform, rotation,
	                        skippedFeaturesHash, featureCallback, hitExtent, layer);
	                    if (result) {
	                        return result;
	                    }
	                }
	            }
	        }
	    }
	    return undefined;
	};
	
	// VFL прокидывние layer в отприсовку
	ol.render.canvas.ReplayGroup.prototype.replay = function (
	    context,
	    transform,
	    viewRotation,
	    skippedFeaturesHash,
	    snapToPixel,
	    opt_replayTypes,
	    opt_declutterReplays,
	    layer
	) {
	
	    /** @type {Array<number>} */
	    var zs = Object.keys(this.replaysByZIndex_).map(Number);
	    zs.sort(ol.array.numberSafeCompareFunction);
	
	    // setup clipping so that the parts of over-simplified geometries are not
	    // visible outside the current extent when panning
	    context.save();
	    // без обрезки для отображения данных за переделами области отрисовки, важно для векторных тайлов
	    // this.clip(context, transform);
	
	    var replayTypes = opt_replayTypes ? opt_replayTypes : ol.render.ORDER;
	    var i, ii, j, jj, replays, replay;
	    for (i = 0, ii = zs.length; i < ii; ++i) {
	        var zIndexKey = zs[i].toString();
	        replays = this.replaysByZIndex_[zIndexKey];
	        for (j = 0, jj = replayTypes.length; j < jj; ++j) {
	            var replayType = replayTypes[j];
	            replay = replays[replayType];
	            if (replay !== undefined) {
	                if (opt_declutterReplays &&
	                    (replayType == ol.render.ReplayType.IMAGE || replayType == ol.render.ReplayType.TEXT)) {
	                    var declutter = opt_declutterReplays[zIndexKey];
	                    if (!declutter) {
	                        opt_declutterReplays[zIndexKey] = [replay, transform.slice(0)];
	                    } else {
	                        declutter.push(replay, transform.slice(0));
	                    }
	                } else {
	                    replay.replay(context, transform, viewRotation, skippedFeaturesHash, snapToPixel, layer);
	                }
	            }
	        }
	    }
	
	    context.restore();
	};
	
	// VFL прокидывание layer в детектор
	ol.render.canvas.Replay.prototype.replayHitDetection = function (
	    context,
	    transform,
	    viewRotation,
	    skippedFeaturesHash,
	    opt_featureCallback,
	    opt_hitExtent,
	    layer
	) {
	    this.viewRotation_ = viewRotation;
	    return this.replay_(context, transform, skippedFeaturesHash,
	        this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent, layer);
	};
	
	// VFL прокидывние слоя в отрисовку
	ol.render.canvas.Replay.prototype.replay = function (
	    context, transform, viewRotation, skippedFeaturesHash, snapToPixel, layer) {
	    this.viewRotation_ = viewRotation;
	    this.replay_(context, transform,
	        skippedFeaturesHash, this.instructions, snapToPixel, undefined, undefined, layer);
	};
	
	// VFL собстенно рендер в canvas, самая важная часть
	// при визуальном рендере накапливаются геометрии, просчитываются пересечения
	// при рендере детектора проверяются накопленные геометрии, в т.ч. по стилям
	// можно увидеть пересечения при window.showOverlap = true
	// активно используется преобразование координат, т.к. canvas при детекторе приходит размером 1х1 пикс и координаты отличаются
	// от координат при визуальном рендере, а после преобразований - корректный 3857
	// ВАЖНО! сейчас при сохранении геометрии отображенных/скрытых стилей производится округление до целых
	// т.к. при преобразовании координат происходят потери в точности
	// возможно стоит брать большую точность (степень двойки)
	ol.render.canvas.Replay.prototype.replay_ = function (
	    context,
	    transform,
	    skippedFeaturesHash,
	    instructions,
	    snapToPixel,
	    featureCallback,
	    opt_hitExtent,
	    // VFL прокинут слой
	    layer
	) {
	    if (ol.OMS_VECTOR_ALLOW_OVERLAP) {
	        /** @type {Array<number>} */
	        var pixelCoordinates;
	        if (this.pixelCoordinates_ && ol.array.equals(transform, this.renderedTransform_)) {
	            pixelCoordinates = this.pixelCoordinates_;
	        } else {
	            if (!this.pixelCoordinates_) {
	                this.pixelCoordinates_ = [];
	            }
	            pixelCoordinates = ol.geom.flat.transform.transform2D(
	                this.coordinates, 0, this.coordinates.length, 2,
	                transform, this.pixelCoordinates_);
	            ol.transform.setFromArray(this.renderedTransform_, transform);
	        }
	        // VFL матрица обратной трансформации координат
	        // отдельная переменная, т.к. преобразование влияет переданную в метод матрицу
	        var transformInverted = [];
	        for (var _idx = 0; _idx < transform.length; _idx++) {
	            transformInverted.push(transform[_idx]);
	        }
	        transformInverted = ol.transform.invert(transformInverted);
	        var skipFeatures = !ol.obj.isEmpty(skippedFeaturesHash);
	        var i = 0; // instruction index
	        var ii = instructions.length; // end of instructions
	        var d = 0; // data index
	        var dd; // end of per-instruction data
	        var anchorX, anchorY, prevX, prevY, roundX, roundY, declutterGroup, image;
	        var pendingFill = 0;
	        var pendingStroke = 0;
	        var lastFillInstruction = null;
	        var lastStrokeInstruction = null;
	        var coordinateCache = this.coordinateCache_;
	        var viewRotation = this.viewRotation_;
	
	        var state = /** @type {import("../../render.js").State} */ ({
	            context: context,
	            pixelRatio: this.pixelRatio,
	            resolution: this.resolution,
	            rotation: viewRotation
	        });
	
	        // When the batch size gets too big, performance decreases. 200 is a good
	        // balance between batch size and number of fill/stroke instructions.
	        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
	        var /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ feature;
	        var x, y;
	        // VFL текущий накопитель коллизий в зависимости от типа рендера (визуальный/детектор)
	        // возможно накопитель детектора больше не нужен, т.к. для определения отрисовки в детекторе используется геометрия стиля
	        var overlapDetector;
	        if (opt_hitExtent === undefined) {
	            if (layer !== undefined && layer.get('overlapDetector')) {
	                overlapDetector = layer.get('overlapDetector');
	            }
	        } else {
	            if (layer !== undefined && layer.get('overlapHitDetector')) {
	                overlapDetector = layer.get('overlapHitDetector');
	            }
	        }
	        // VFL идентфиикатор текущей фичи
	        // любая инструкция, отвечающая за рисование на canvas имеет пункт BEGIN_GEOMETRY и END_GEOMETRY
	        // причем BEGIN_GEOMETRY всегда ПЕРЕД инструкцие изменения пикселей canvas,
	        // т.е. при BEGIN_GEOMTRY возможно достоверно сзапомнить id фичи, стили которой будет отрисованы в процессе исполнения инструкций
	        var currenFeatureId;
	        // VFL определение попадания фичи в текущий bbox отрисовки (у детектора он не равен bbox видимой области карты)
	        // помимо проверки попадания геометрии фичи, проверяет попадаение геометрии видимых стилей фич
	        var detectStyleIntersects = function (extent, featureExtent, styleExtents) {
	            var i;
	            if (ol.extent.intersects(extent, featureExtent)) {
	                return true;
	            }
	            for (i = 0; i < styleExtents.length; i++) {
	                if (ol.extent.intersects(extent, styleExtents[i])) {
	                    return true;
	                }
	            }
	            return false;
	        };
	        // VFL добавление геометрии видимого стиля
	        // тут используется не полноценный bbox, а ключ по нему, для ускорения
	        var addShownExtent = function (featureId, resolution, extent) {
	            if (layer === undefined || !layer.get('overlapFeatureExtentsShown')) {
	                return;
	            }
	            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
	            var extentKey = extentRound.join(':');
	            var overlapFeatureExtentsShown = layer.get('overlapFeatureExtentsShown');
	            if (!overlapFeatureExtentsShown[featureId]) {
	                overlapFeatureExtentsShown[featureId] = {};
	            }
	            if (!overlapFeatureExtentsShown[featureId][resolution]) {
	                overlapFeatureExtentsShown[featureId][resolution] = {};
	            }
	            overlapFeatureExtentsShown[featureId][resolution][extentKey] = true;
	        };
	        // VFL добпвление геомтерии скрытого стиля
	        // тут используется не полноценный bbox, а ключ по нему, для ускорения
	        var addHiddenExtent = function (featureId, resolution, extent) {
	            if (layer === undefined || !layer.get('overlapFeatureExtentsHidden')) {
	                return;
	            }
	            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
	            var extentKey = extentRound.join(':');
	            var overlapFeatureExtentsHidden = layer.get('overlapFeatureExtentsHidden');
	            if (!overlapFeatureExtentsHidden[featureId]) {
	                overlapFeatureExtentsHidden[featureId] = {};
	            }
	            if (!overlapFeatureExtentsHidden[featureId][resolution]) {
	                overlapFeatureExtentsHidden[featureId][resolution] = {};
	            }
	            overlapFeatureExtentsHidden[featureId][resolution][extentKey] = true;
	        };
	        // VFL проверка на наличие отображенного стиля по его геометрии
	        var isShownExtent = function (featureId, resolution, extent) {
	            if (layer === undefined || !layer.get('overlapFeatureExtentsShown')) {
	                return true;
	            }
	            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
	            var extentKey = extentRound.join(':');
	            var overlapFeatureExtentsShown = layer.get('overlapFeatureExtentsShown');
	            return !!overlapFeatureExtentsShown[featureId] && !!overlapFeatureExtentsShown[featureId][resolution] && !!overlapFeatureExtentsShown[featureId][resolution][extentKey];
	        };
	        // проврека на наличие скрытого стиял по его геометрии
	        var isHiddenExtent = function (featureId, resolution, extent) {
	            if (layer === undefined || !layer.get('overlapFeatureExtentsHidden')) {
	                return false;
	            }
	            var extentRound = [Math.round(extent[0]), Math.round(extent[1]), Math.round(extent[2]), Math.round(extent[3])];
	            var extentKey = extentRound.join(':');
	            var overlapFeatureExtentsHidden = layer.get('overlapFeatureExtentsHidden');
	            return !!overlapFeatureExtentsHidden[featureId] && !!overlapFeatureExtentsHidden[featureId][resolution] && !!overlapFeatureExtentsHidden[featureId][resolution][extentKey];
	        };
	        while (i < ii) {
	            var instruction = instructions[i];
	            var type = /** @type {CanvasInstruction} */ (instruction[0]);
	            // VFL атрибут допустимости перекрытия стиля (пока что текста)
	            var overlap;
	            switch (type) {
	                case ol.render.canvas.Instruction.BEGIN_GEOMETRY:
	                    feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
	                    // VFL запомнить id фичи и проинициализировать накопитель геометри видимых стилей фичи
	                    currenFeatureId = ol.getUid(feature);
	                    if (opt_hitExtent === undefined && layer !== undefined && layer.get('overlapFeatureExtents')) {
	                        if (!layer.get('overlapFeatureExtents')[currenFeatureId]) {
	                            layer.get('overlapFeatureExtents')[currenFeatureId] = {};
	                        }
	                        if (!layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution]) {
	                            layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution] = [];
	                        }
	                    }
	                    if ((skipFeatures && skippedFeaturesHash[ol.getUid(feature)]) || !feature.getGeometry()) {
	                        i = /** @type {number} */ (instruction[2]);
	                        // } else if (opt_hitExtent !== undefined && !ol.extent.intersects(
	                        //     opt_hitExtent, feature.getGeometry().getExtent())) {
	                        //     i = /** @type {number} */ (instruction[2]) + 1;
	                        // VFL вместо проверки пересечения ТОЛЬКО по геометрии теперь проверка и по геометрии стилей
	                    } else if (opt_hitExtent !== undefined && !detectStyleIntersects(opt_hitExtent, feature.getGeometry().getExtent(), layer !== undefined && layer.get('overlapFeatureExtents') ? layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution] : [])) {
	                        i = /** @type {number} */ (instruction[2]) + 1;
	                    } else {
	                        ++i;
	                    }
	                    // VFL можно подебажить объекты найденных фич
	                    if (window.showOverlap && opt_hitExtent !== undefined && detectStyleIntersects(opt_hitExtent, feature.getGeometry().getExtent(), layer !== undefined && layer.get('overlapFeatureExtents') ? layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution] : [])) {
	                        console.log(feature);
	                    }
	                    break;
	                case ol.render.canvas.Instruction.BEGIN_PATH:
	                    if (pendingFill > batchSize) {
	                        this.fill_(context);
	                        pendingFill = 0;
	                    }
	                    if (pendingStroke > batchSize) {
	                        context.stroke();
	                        pendingStroke = 0;
	                    }
	                    if (!pendingFill && !pendingStroke) {
	                        context.beginPath();
	                        prevX = prevY = NaN;
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.CIRCLE:
	                    d = /** @type {number} */ (instruction[1]);
	                    var x1 = pixelCoordinates[d];
	                    var y1 = pixelCoordinates[d + 1];
	                    var x2 = pixelCoordinates[d + 2];
	                    var y2 = pixelCoordinates[d + 3];
	                    var dx = x2 - x1;
	                    var dy = y2 - y1;
	                    var r = Math.sqrt(dx * dx + dy * dy);
	                    context.moveTo(x1 + r, y1);
	                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.CLOSE_PATH:
	                    context.closePath();
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.CUSTOM:
	                    d = /** @type {number} */ (instruction[1]);
	                    dd = instruction[2];
	                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ (instruction[3]);
	                    var renderer = instruction[4];
	                    var fn = instruction.length == 6 ? instruction[5] : undefined;
	                    state.geometry = geometry;
	                    state.feature = feature;
	                    if (!(i in coordinateCache)) {
	                        coordinateCache[i] = [];
	                    }
	                    var coords = coordinateCache[i];
	                    if (fn) {
	                        fn(pixelCoordinates, d, dd, 2, coords);
	                    } else {
	                        coords[0] = pixelCoordinates[d];
	                        coords[1] = pixelCoordinates[d + 1];
	                        coords.length = 2;
	                    }
	                    renderer(coords, state);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.DRAW_IMAGE:
	                    d = /** @type {number} */ (instruction[1]);
	                    dd = /** @type {number} */ (instruction[2]);
	                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
	                        (instruction[3]);
	                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
	                    anchorX = /** @type {number} */ (instruction[4]);
	                    anchorY = /** @type {number} */ (instruction[5]);
	                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[6]);
	                    var height = /** @type {number} */ (instruction[7]);
	                    var opacity = /** @type {number} */ (instruction[8]);
	                    var originX = /** @type {number} */ (instruction[9]);
	                    var originY = /** @type {number} */ (instruction[10]);
	                    var rotateWithView = /** @type {boolean} */ (instruction[11]);
	                    var rotation = /** @type {number} */ (instruction[12]);
	                    var scale$$1 = /** @type {number} */ (instruction[13]);
	                    var width = /** @type {number} */ (instruction[14]);
	
	                    var padding = (void 0), backgroundFill = (void 0), backgroundStroke = (void 0);
	                    // VFL - если это текст, то инструкций у него > 16 (исходя из ImageReply и TextReply)
	                    if (instruction.length > 16) {
	                        padding = /** @type {Array<number>} */ (instruction[15]);
	                        backgroundFill = /** @type {boolean} */ (instruction[16]);
	                        backgroundStroke = /** @type {boolean} */ (instruction[17]);
	                    } else {
	                        padding = ol.render.canvas.defaultPadding;
	                        backgroundFill = backgroundStroke = false;
	                    }
	                    // VFL перекрытие по умолчанию есть. Типа глобальное решение, можно и для остальных типов отрисовки,
	                    // помимо текста, добавлять подобный флаг, только учитывать индекс инструкции
	                    overlap = instruction[18] !== undefined ? instruction[18] : true;
	
	                    if (rotateWithView) {
	                        rotation += viewRotation;
	                    }
	                    for (; d < dd; d += 2) {
	                        // VFL расчет перекрытий и их учет
	                        // итого - нужно ли рисовать объект
	                        var objShown = false;
	                        var collides = false;
	                        // дублирование глубоко спрятанной логики расчета ширины, высоты и позиции
	                        var xo = pixelCoordinates[d] - anchorX * scale$$1,
	                            yo = pixelCoordinates[d + 1] - anchorY * scale$$1,
	                            wo = (width + originX > image.width) ? image.width - originX : width,
	                            ho = (height + originY > image.height) ? image.height - originY : height;
	                        // габариты текущего объекта отрисовки
	                        var r = {
	                            minX: xo, minY: yo,
	                            maxX: xo + wo * scale$$1, maxY: yo + ho * scale$$1
	                        };
	                        // проверка на перекрытие только для объектов, которые могут быть вытолкнуты
	                        if (!overlap) {
	                            collides = overlapDetector ? overlapDetector.collides(r) : false;
	                        }
	                        // для дальнейших расчетов не учитываются вытолкнутые объекты, т.к. они не будут отрисованы
	                        if (!collides && overlapDetector) {
	                            overlapDetector.insert(r);
	                        }
	                        // VFL можно подебажить геометрию в т.ч. для вытолкнутых объектов
	                        if (window.showOverlap) {
	                            var tmp1 = context.strokeStyle;
	                            var tmp2 = context.lineWidth;
	
	                            // context.lineWidth = 1;
	                            context.lineWidth = 1;
	                            context.strokeStyle = collides ? 'red' : 'green';
	
	                            context.strokeRect(xo, yo, wo * scale$$1, ho * scale$$1);
	
	                            context.strokeStyle = tmp1;
	                            context.lineWidth = tmp2
	                        }
	                        // рассовать габариты
	                        // в режиме визуальнго рендера - записать габарит объекта (видимого и невидимого)
	                        if (opt_hitExtent === undefined) {
	                            if (!collides) {
	                                if (layer !== undefined && layer.get('overlapFeatureExtents')) {
	                                    layer.get('overlapFeatureExtents')[currenFeatureId][this.resolution].push(ol.geom.flat.transform.transform2D(
	                                        [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                    ));
	                                }
	                                addShownExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
	                                    [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                ));
	                            } else {
	                                addHiddenExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
	                                    [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                ));
	                            }
	                        }
	                        // TODO упростить
	                        // VFL если пересчения нет, то можно нарисовать объект
	                        // ВАЖНО! в режиме детектора проверяет не просто наличие пересечения (оно посчти всегда некорректное
	                        // из за ограниченного bbox) но и ранее накопленные данные об отображенности/скрытости стилей по геометриям
	                        if (!collides) {
	
	                            // VFL при отсутствии коллизий отображаем объект,
	                            // если он может пересекаться
	                            // или это визуальные рендер
	                            // или это рендер детектор и геометрия есть в отображенных и нет в скрытых
	                            if (overlap || opt_hitExtent === undefined ||
	                                (opt_hitExtent !== undefined &&
	                                    isShownExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
	                                        [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                    )) && !isHiddenExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
	                                        [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                    )))
	                            ) {
	                                objShown = true;
	                            }
	                        } else if (!overlap && opt_hitExtent !== undefined) {
	                            // VFL есть коллизия и объект не может пересекаться и режим детектора
	                            // то необходимо проверить, может в режиме визуального рендера он был отрисован
	                            if (
	                                isShownExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
	                                    [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                )) && !isHiddenExtent(currenFeatureId, this.resolution, ol.geom.flat.transform.transform2D(
	                                [r.minX, r.maxY, r.maxX, r.minY], 0, 4, 2, transformInverted
	                                ))
	                            ) {
	                                objShown = true;
	                            }
	                        }
	                        if (objShown) {
	                            this.replayImage_(context,
	                                pixelCoordinates[d], pixelCoordinates[d + 1], image, anchorX, anchorY,
	                                declutterGroup, height, opacity, originX, originY, rotation, scale$$1,
	                                snapToPixel, width, padding,
	                                backgroundFill ? /** @type {Array<*>} */ (lastFillInstruction) : null,
	                                backgroundStroke ? /** @type {Array<*>} */ (lastStrokeInstruction) : null);
	                        }
	                    }
	                    this.renderDeclutter_(declutterGroup, feature);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.DRAW_CHARS:
	                    var begin = /** @type {number} */ (instruction[1]);
	                    var end = /** @type {number} */ (instruction[2]);
	                    var baseline = /** @type {number} */ (instruction[3]);
	                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[4]);
	                    var overflow = /** @type {number} */ (instruction[5]);
	                    var fillKey = /** @type {string} */ (instruction[6]);
	                    var maxAngle = /** @type {number} */ (instruction[7]);
	                    var measure = /** @type {function(string):number} */ (instruction[8]);
	                    var offsetY = /** @type {number} */ (instruction[9]);
	                    var strokeKey = /** @type {string} */ (instruction[10]);
	                    var strokeWidth = /** @type {number} */ (instruction[11]);
	                    var text = /** @type {string} */ (instruction[12]);
	                    var textKey = /** @type {string} */ (instruction[13]);
	                    var textScale = /** @type {number} */ (instruction[14]);
	
	                    var pathLength = ol.geom.flat.length.lineStringLength(pixelCoordinates, begin, end, 2);
	                    var textLength = measure(text);
	                    if (overflow || textLength <= pathLength) {
	                        /** @type {import("./TextReplay.js").default} */
	                        var textReplay = /** @type {?} */ (this);
	                        var textAlign = textReplay.textStates[textKey].textAlign;
	                        var startM = (pathLength - textLength) * ol.render.TEXT_ALIGN[textAlign];
	                        var parts = ol.geom.flat.textpath.drawTextOnPath(
	                            pixelCoordinates, begin, end, 2, text, measure, startM, maxAngle);
	                        if (parts) {
	                            var c = (void 0), cc = (void 0), chars = (void 0), label = (void 0), part = (void 0);
	                            if (strokeKey) {
	                                for (c = 0, cc = parts.length; c < cc; ++c) {
	                                    part = parts[c]; // x, y, anchorX, rotation, chunk
	                                    chars = /** @type {string} */ (part[4]);
	                                    label = textReplay.getImage(chars, textKey, '', strokeKey);
	                                    anchorX = /** @type {number} */ (part[2]) + strokeWidth;
	                                    anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth - offsetY;
	                                    this.replayImage_(context,
	                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
	                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
	                                        /** @type {number} */ (part[3]), textScale, false, label.width,
	                                        ol.render.canvas.defaultPadding, null, null);
	                                }
	                            }
	                            if (fillKey) {
	                                for (c = 0, cc = parts.length; c < cc; ++c) {
	                                    part = parts[c]; // x, y, anchorX, rotation, chunk
	                                    chars = /** @type {string} */ (part[4]);
	                                    label = textReplay.getImage(chars, textKey, fillKey, '');
	                                    anchorX = /** @type {number} */ (part[2]);
	                                    anchorY = baseline * label.height - offsetY;
	                                    this.replayImage_(context,
	                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
	                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
	                                        /** @type {number} */ (part[3]), textScale, false, label.width,
	                                        ol.render.canvas.defaultPadding, null, null);
	                                }
	                            }
	                        }
	                    }
	                    this.renderDeclutter_(declutterGroup, feature);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.END_GEOMETRY:
	                    if (featureCallback !== undefined) {
	                        feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
	                        var result = featureCallback(feature);
	                        if (result) {
	                            return result;
	                        }
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.FILL:
	                    if (batchSize) {
	                        pendingFill++;
	                    } else {
	                        this.fill_(context);
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.MOVE_TO_LINE_TO:
	                    d = /** @type {number} */ (instruction[1]);
	                    dd = /** @type {number} */ (instruction[2]);
	                    x = pixelCoordinates[d];
	                    y = pixelCoordinates[d + 1];
	                    roundX = (x + 0.5) | 0;
	                    roundY = (y + 0.5) | 0;
	                    if (roundX !== prevX || roundY !== prevY) {
	                        context.moveTo(x, y);
	                        prevX = roundX;
	                        prevY = roundY;
	                    }
	                    for (d += 2; d < dd; d += 2) {
	                        x = pixelCoordinates[d];
	                        y = pixelCoordinates[d + 1];
	                        roundX = (x + 0.5) | 0;
	                        roundY = (y + 0.5) | 0;
	                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
	                            context.lineTo(x, y);
	                            prevX = roundX;
	                            prevY = roundY;
	                        }
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.SET_FILL_STYLE:
	                    lastFillInstruction = instruction;
	                    this.alignFill_ = instruction[2];
	
	                    if (pendingFill) {
	                        this.fill_(context);
	                        pendingFill = 0;
	                        if (pendingStroke) {
	                            context.stroke();
	                            pendingStroke = 0;
	                        }
	                    }
	
	                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.SET_STROKE_STYLE:
	                    lastStrokeInstruction = instruction;
	                    if (pendingStroke) {
	                        context.stroke();
	                        pendingStroke = 0;
	                    }
	                    this.setStrokeStyle_(context, /** @type {Array<*>} */ (instruction));
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.STROKE:
	                    if (batchSize) {
	                        pendingStroke++;
	                    } else {
	                        context.stroke();
	                    }
	                    ++i;
	                    break;
	                default:
	                    ++i; // consume the instruction anyway, to avoid an infinite loop
	                    break;
	            }
	        }
	    } else {
	        /** @type {Array<number>} */
	        var pixelCoordinates;
	        if (this.pixelCoordinates_ && ol.array.equals(transform, this.renderedTransform_)) {
	            pixelCoordinates = this.pixelCoordinates_;
	        } else {
	            if (!this.pixelCoordinates_) {
	                this.pixelCoordinates_ = [];
	            }
	            pixelCoordinates = ol.geom.flat.transform.transform2D(
	                this.coordinates, 0, this.coordinates.length, 2,
	                transform, this.pixelCoordinates_);
	            ol.transform.setFromArray(this.renderedTransform_, transform);
	        }
	        var skipFeatures = !ol.obj.isEmpty(skippedFeaturesHash);
	        var i = 0; // instruction index
	        var ii = instructions.length; // end of instructions
	        var d = 0; // data index
	        var dd; // end of per-instruction data
	        var anchorX, anchorY, prevX, prevY, roundX, roundY, declutterGroup, image;
	        var pendingFill = 0;
	        var pendingStroke = 0;
	        var lastFillInstruction = null;
	        var lastStrokeInstruction = null;
	        var coordinateCache = this.coordinateCache_;
	        var viewRotation = this.viewRotation_;
	
	        var state = /** @type {import("../../render.js").State} */ ({
	            context: context,
	            pixelRatio: this.pixelRatio,
	            resolution: this.resolution,
	            rotation: viewRotation
	        });
	
	        // When the batch size gets too big, performance decreases. 200 is a good
	        // balance between batch size and number of fill/stroke instructions.
	        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
	        var /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ feature;
	        var x, y;
	        while (i < ii) {
	            var instruction = instructions[i];
	            var type = /** @type {CanvasInstruction} */ (instruction[0]);
	            switch (type) {
	                case ol.render.canvas.Instruction.BEGIN_GEOMETRY:
	                    feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
	                    if ((skipFeatures && skippedFeaturesHash[ol.getUid(feature)]) || !feature.getGeometry()) {
	                        i = /** @type {number} */ (instruction[2]);
	                    } else if (opt_hitExtent !== undefined && !ol.extent.intersects(
	                        opt_hitExtent, feature.getGeometry().getExtent())) {
	                        i = /** @type {number} */ (instruction[2]) + 1;
	                    } else {
	                        ++i;
	                    }
	                    break;
	                case ol.render.canvas.Instruction.BEGIN_PATH:
	                    if (pendingFill > batchSize) {
	                        this.fill_(context);
	                        pendingFill = 0;
	                    }
	                    if (pendingStroke > batchSize) {
	                        context.stroke();
	                        pendingStroke = 0;
	                    }
	                    if (!pendingFill && !pendingStroke) {
	                        context.beginPath();
	                        prevX = prevY = NaN;
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.CIRCLE:
	                    d = /** @type {number} */ (instruction[1]);
	                    var x1 = pixelCoordinates[d];
	                    var y1 = pixelCoordinates[d + 1];
	                    var x2 = pixelCoordinates[d + 2];
	                    var y2 = pixelCoordinates[d + 3];
	                    var dx = x2 - x1;
	                    var dy = y2 - y1;
	                    var r = Math.sqrt(dx * dx + dy * dy);
	                    context.moveTo(x1 + r, y1);
	                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.CLOSE_PATH:
	                    context.closePath();
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.CUSTOM:
	                    d = /** @type {number} */ (instruction[1]);
	                    dd = instruction[2];
	                    var geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ (instruction[3]);
	                    var renderer = instruction[4];
	                    var fn = instruction.length == 6 ? instruction[5] : undefined;
	                    state.geometry = geometry;
	                    state.feature = feature;
	                    if (!(i in coordinateCache)) {
	                        coordinateCache[i] = [];
	                    }
	                    var coords = coordinateCache[i];
	                    if (fn) {
	                        fn(pixelCoordinates, d, dd, 2, coords);
	                    } else {
	                        coords[0] = pixelCoordinates[d];
	                        coords[1] = pixelCoordinates[d + 1];
	                        coords.length = 2;
	                    }
	                    renderer(coords, state);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.DRAW_IMAGE:
	                    d = /** @type {number} */ (instruction[1]);
	                    dd = /** @type {number} */ (instruction[2]);
	                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */
	                        (instruction[3]);
	                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
	                    anchorX = /** @type {number} */ (instruction[4]);
	                    anchorY = /** @type {number} */ (instruction[5]);
	                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[6]);
	                    var height = /** @type {number} */ (instruction[7]);
	                    var opacity = /** @type {number} */ (instruction[8]);
	                    var originX = /** @type {number} */ (instruction[9]);
	                    var originY = /** @type {number} */ (instruction[10]);
	                    var rotateWithView = /** @type {boolean} */ (instruction[11]);
	                    var rotation = /** @type {number} */ (instruction[12]);
	                    var scale$$1 = /** @type {number} */ (instruction[13]);
	                    var width = /** @type {number} */ (instruction[14]);
	
	                    var padding = (void 0), backgroundFill = (void 0), backgroundStroke = (void 0);
	                    if (instruction.length > 16) {
	                        padding = /** @type {Array<number>} */ (instruction[15]);
	                        backgroundFill = /** @type {boolean} */ (instruction[16]);
	                        backgroundStroke = /** @type {boolean} */ (instruction[17]);
	                    } else {
	                        padding = ol.render.canvas.defaultPadding;
	                        backgroundFill = backgroundStroke = false;
	                    }
	
	                    if (rotateWithView) {
	                        rotation += viewRotation;
	                    }
	                    for (; d < dd; d += 2) {
	                        this.replayImage_(context,
	                            pixelCoordinates[d], pixelCoordinates[d + 1], image, anchorX, anchorY,
	                            declutterGroup, height, opacity, originX, originY, rotation, scale$$1,
	                            snapToPixel, width, padding,
	                            backgroundFill ? /** @type {Array<*>} */ (lastFillInstruction) : null,
	                            backgroundStroke ? /** @type {Array<*>} */ (lastStrokeInstruction) : null);
	                    }
	                    this.renderDeclutter_(declutterGroup, feature);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.DRAW_CHARS:
	                    var begin = /** @type {number} */ (instruction[1]);
	                    var end = /** @type {number} */ (instruction[2]);
	                    var baseline = /** @type {number} */ (instruction[3]);
	                    declutterGroup = featureCallback ? null : /** @type {import("../canvas.js").DeclutterGroup} */ (instruction[4]);
	                    var overflow = /** @type {number} */ (instruction[5]);
	                    var fillKey = /** @type {string} */ (instruction[6]);
	                    var maxAngle = /** @type {number} */ (instruction[7]);
	                    var measure = /** @type {function(string):number} */ (instruction[8]);
	                    var offsetY = /** @type {number} */ (instruction[9]);
	                    var strokeKey = /** @type {string} */ (instruction[10]);
	                    var strokeWidth = /** @type {number} */ (instruction[11]);
	                    var text = /** @type {string} */ (instruction[12]);
	                    var textKey = /** @type {string} */ (instruction[13]);
	                    var textScale = /** @type {number} */ (instruction[14]);
	
	                    var pathLength = ol.geom.flat.length.lineStringLength(pixelCoordinates, begin, end, 2);
	                    var textLength = measure(text);
	                    if (overflow || textLength <= pathLength) {
	                        /** @type {import("./TextReplay.js").default} */
	                        var textReplay = /** @type {?} */ (this);
	                        var textAlign = textReplay.textStates[textKey].textAlign;
	                        var startM = (pathLength - textLength) * ol.render.TEXT_ALIGN[textAlign];
	                        var parts = ol.geom.flat.textpath.drawTextOnPath(
	                            pixelCoordinates, begin, end, 2, text, measure, startM, maxAngle);
	                        if (parts) {
	                            var c = (void 0), cc = (void 0), chars = (void 0), label = (void 0), part = (void 0);
	                            if (strokeKey) {
	                                for (c = 0, cc = parts.length; c < cc; ++c) {
	                                    part = parts[c]; // x, y, anchorX, rotation, chunk
	                                    chars = /** @type {string} */ (part[4]);
	                                    label = textReplay.getImage(chars, textKey, '', strokeKey);
	                                    anchorX = /** @type {number} */ (part[2]) + strokeWidth;
	                                    anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth - offsetY;
	                                    this.replayImage_(context,
	                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
	                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
	                                        /** @type {number} */ (part[3]), textScale, false, label.width,
	                                        ol.render.canvas.defaultPadding, null, null);
	                                }
	                            }
	                            if (fillKey) {
	                                for (c = 0, cc = parts.length; c < cc; ++c) {
	                                    part = parts[c]; // x, y, anchorX, rotation, chunk
	                                    chars = /** @type {string} */ (part[4]);
	                                    label = textReplay.getImage(chars, textKey, fillKey, '');
	                                    anchorX = /** @type {number} */ (part[2]);
	                                    anchorY = baseline * label.height - offsetY;
	                                    this.replayImage_(context,
	                                        /** @type {number} */ (part[0]), /** @type {number} */ (part[1]), label,
	                                        anchorX, anchorY, declutterGroup, label.height, 1, 0, 0,
	                                        /** @type {number} */ (part[3]), textScale, false, label.width,
	                                        ol.render.canvas.defaultPadding, null, null);
	                                }
	                            }
	                        }
	                    }
	                    this.renderDeclutter_(declutterGroup, feature);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.END_GEOMETRY:
	                    if (featureCallback !== undefined) {
	                        feature = /** @type {import("../../Feature.js").default|import("../Feature.js").default} */ (instruction[1]);
	                        var result = featureCallback(feature);
	                        if (result) {
	                            return result;
	                        }
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.FILL:
	                    if (batchSize) {
	                        pendingFill++;
	                    } else {
	                        this.fill_(context);
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.MOVE_TO_LINE_TO:
	                    d = /** @type {number} */ (instruction[1]);
	                    dd = /** @type {number} */ (instruction[2]);
	                    x = pixelCoordinates[d];
	                    y = pixelCoordinates[d + 1];
	                    roundX = (x + 0.5) | 0;
	                    roundY = (y + 0.5) | 0;
	                    if (roundX !== prevX || roundY !== prevY) {
	                        context.moveTo(x, y);
	                        prevX = roundX;
	                        prevY = roundY;
	                    }
	                    for (d += 2; d < dd; d += 2) {
	                        x = pixelCoordinates[d];
	                        y = pixelCoordinates[d + 1];
	                        roundX = (x + 0.5) | 0;
	                        roundY = (y + 0.5) | 0;
	                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
	                            context.lineTo(x, y);
	                            prevX = roundX;
	                            prevY = roundY;
	                        }
	                    }
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.SET_FILL_STYLE:
	                    lastFillInstruction = instruction;
	                    this.alignFill_ = instruction[2];
	
	                    if (pendingFill) {
	                        this.fill_(context);
	                        pendingFill = 0;
	                        if (pendingStroke) {
	                            context.stroke();
	                            pendingStroke = 0;
	                        }
	                    }
	
	                    context.fillStyle = /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.SET_STROKE_STYLE:
	                    lastStrokeInstruction = instruction;
	                    if (pendingStroke) {
	                        context.stroke();
	                        pendingStroke = 0;
	                    }
	                    this.setStrokeStyle_(context, /** @type {Array<*>} */ (instruction));
	                    ++i;
	                    break;
	                case ol.render.canvas.Instruction.STROKE:
	                    if (batchSize) {
	                        pendingStroke++;
	                    } else {
	                        context.stroke();
	                    }
	                    ++i;
	                    break;
	                default:
	                    ++i; // consume the instruction anyway, to avoid an infinite loop
	                    break;
	            }
	        }
	    }
	    if (pendingFill) {
	        this.fill_(context);
	    }
	    if (pendingStroke) {
	        context.stroke();
	    }
	    return undefined;
	};
	
	// VFL добавлен атрибут перекрытия
	var olRenderCanvasTextReplay = function(tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree) {
	    ol.render.canvas.Replay.call(this, tolerance, maxExtent, resolution, pixelRatio, overlaps, declutterTree);
	
	    /**
	     * @private
	     * @type {import("../canvas.js").DeclutterGroup}
	     */
	    this.declutterGroup_;
	
	    /**
	     * @private
	     * @type {Array<HTMLCanvasElement>}
	     */
	    this.labels_ = null;
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.text_ = '';
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textOffsetX_ = 0;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textOffsetY_ = 0;
	
	    /**
	     * @private
	     * @type {boolean|undefined}
	     */
	    this.textRotateWithView_ = undefined;
	
	    /**
	     * @private
	     * @type {number}
	     */
	    this.textRotation_ = 0;
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").FillState}
	     */
	    this.textFillState_ = null;
	
	    /**
	     * @type {!Object<string, import("../canvas.js").FillState>}
	     */
	    this.fillStates = {};
	
	    /**
	     * @private
	     * @type {?import("../canvas.js").StrokeState}
	     */
	    this.textStrokeState_ = null;
	
	    /**
	     * @type {!Object<string, import("../canvas.js").StrokeState>}
	     */
	    this.strokeStates = {};
	
	    /**
	     * @private
	     * @type {import("../canvas.js").TextState}
	     */
	    this.textState_ = /** @type {import("../canvas.js").TextState} */ ({});
	
	    /**
	     * @type {!Object<string, import("../canvas.js").TextState>}
	     */
	    this.textStates = {};
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.textKey_ = '';
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.fillKey_ = '';
	
	    /**
	     * @private
	     * @type {string}
	     */
	    this.strokeKey_ = '';
	
	    /**
	     * @private
	     * @type {Object<string, Object<string, number>>}
	     */
	    this.widths_ = {};
	
	    // VFL атрибут перекрытия
	    /**
	     * @private
	     * @type {boolean}
	     */
	    this.textOverlap_ = true;
	
	    ol.render.canvas.labelCache.prune();
	
	};
	
	olRenderCanvasTextReplay.prototype = {};
	
	ol.inherits(olRenderCanvasTextReplay, ol.render.canvas.TextReplay);
	
	// VFL добавлен атрибут перекрытия
	ol.render.canvas.TextReplay.prototype.drawTextImage_ = function (label, begin, end) {
	    var textState = this.textState_;
	    var strokeState = this.textStrokeState_;
	    var pixelRatio = this.pixelRatio;
	    var align = ol.render.TEXT_ALIGN[textState.textAlign || ol.render.canvas.defaultTextAlign];
	    var baseline = ol.render.TEXT_ALIGN[textState.textBaseline];
	    var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
	
	    var anchorX = align * label.width / pixelRatio + 2 * (0.5 - align) * strokeWidth;
	    var anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
	    // VFL атрибут перекрытия
	    var overlap = !!this.textOverlap_;
	    // VFL в инструкцию добавлен атрибут перекрытия
	    this.instructions.push([ol.render.canvas.Instruction.DRAW_IMAGE, begin, end,
	        label, (anchorX - this.textOffsetX_) * pixelRatio, (anchorY - this.textOffsetY_) * pixelRatio,
	        this.declutterGroup_, label.height, 1, 0, 0, this.textRotateWithView_, this.textRotation_,
	        1, label.width,
	        textState.padding == ol.render.canvas.defaultPadding ?
	            ol.render.canvas.defaultPadding : textState.padding.map(function (p) {
	                return p * pixelRatio;
	            }),
	        !!textState.backgroundFill, !!textState.backgroundStroke, overlap
	    ]);
	    // VFL в инструкцию добавлен атрибут перекрытия
	    this.hitDetectionInstructions.push([ol.render.canvas.Instruction.DRAW_IMAGE, begin, end,
	        label, (anchorX - this.textOffsetX_) * pixelRatio, (anchorY - this.textOffsetY_) * pixelRatio,
	        this.declutterGroup_, label.height, 1, 0, 0, this.textRotateWithView_, this.textRotation_,
	        1 / pixelRatio, label.width, textState.padding,
	        !!textState.backgroundFill, !!textState.backgroundStroke, overlap
	    ]);
	};
	
	// VFL добавлен атрибут перекрытия
	ol.render.canvas.TextReplay.prototype.setTextStyle = function (textStyle, declutterGroup) {
	    var textState, fillState, strokeState;
	    if (!textStyle) {
	        this.text_ = '';
	    } else {
	        this.declutterGroup_ = /** @type {import("../canvas.js").DeclutterGroup} */ (declutterGroup);
	
	        var textFillStyle = textStyle.getFill();
	        if (!textFillStyle) {
	            fillState = this.textFillState_ = null;
	        } else {
	            fillState = this.textFillState_;
	            if (!fillState) {
	                fillState = this.textFillState_ = /** @type {import("../canvas.js").FillState} */ ({});
	            }
	            fillState.fillStyle = ol.colorlike.asColorLike(
	                textFillStyle.getColor() || ol.render.canvas.defaultFillStyle);
	        }
	
	        var textStrokeStyle = textStyle.getStroke();
	        if (!textStrokeStyle) {
	            strokeState = this.textStrokeState_ = null;
	        } else {
	            strokeState = this.textStrokeState_;
	            if (!strokeState) {
	                strokeState = this.textStrokeState_ = /** @type {import("../canvas.js").StrokeState} */ ({});
	            }
	            var lineDash = textStrokeStyle.getLineDash();
	            var lineDashOffset = textStrokeStyle.getLineDashOffset();
	            var lineWidth = textStrokeStyle.getWidth();
	            var miterLimit = textStrokeStyle.getMiterLimit();
	            strokeState.lineCap = textStrokeStyle.getLineCap() || ol.render.canvas.defaultLineCap;
	            strokeState.lineDash = lineDash ? lineDash.slice() : ol.render.canvas.defaultLineDash;
	            strokeState.lineDashOffset =
	                lineDashOffset === undefined ? ol.render.canvas.defaultLineDashOffset : lineDashOffset;
	            strokeState.lineJoin = textStrokeStyle.getLineJoin() || ol.render.canvas.defaultLineJoin;
	            strokeState.lineWidth =
	                lineWidth === undefined ? ol.render.canvas.defaultLineWidth : lineWidth;
	            strokeState.miterLimit =
	                miterLimit === undefined ? ol.render.canvas.defaultMiterLimit : miterLimit;
	            strokeState.strokeStyle = ol.colorlike.asColorLike(
	                textStrokeStyle.getColor() || ol.render.canvas.defaultStrokeStyle);
	        }
	
	        textState = this.textState_;
	        var font = textStyle.getFont() || ol.render.canvas.defaultFont;
	        ol.render.canvas.checkFont(font);
	        var textScale = textStyle.getScale();
	        textState.overflow = textStyle.getOverflow();
	        textState.font = font;
	        textState.maxAngle = textStyle.getMaxAngle();
	        textState.placement = textStyle.getPlacement();
	        textState.textAlign = textStyle.getTextAlign();
	        textState.textBaseline = textStyle.getTextBaseline() || ol.render.canvas.defaultTextBaseline;
	        textState.backgroundFill = textStyle.getBackgroundFill();
	        textState.backgroundStroke = textStyle.getBackgroundStroke();
	        textState.padding = textStyle.getPadding() || ol.render.canvas.defaultPadding;
	        textState.scale = textScale === undefined ? 1 : textScale;
	
	        var textOffsetX = textStyle.getOffsetX();
	        var textOffsetY = textStyle.getOffsetY();
	        var textRotateWithView = textStyle.getRotateWithView();
	        var textRotation = textStyle.getRotation();
	        // VFL атрибут перекрытия
	        var textOverlap = textStyle.getOverlap();
	        this.text_ = textStyle.getText() || '';
	        this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
	        this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
	        this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
	        this.textRotation_ = textRotation === undefined ? 0 : textRotation;
	        // VFL атрибут перекрытия
	        this.textOverlap_ = textOverlap !== undefined ? textOverlap : true;
	
	        this.strokeKey_ = strokeState ?
	            (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : ol.getUid(strokeState.strokeStyle)) +
	            strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth +
	            strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' :
	            '';
	        this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?');
	        this.fillKey_ = fillState ?
	            (typeof fillState.fillStyle == 'string' ? fillState.fillStyle : ('|' + ol.getUid(fillState.fillStyle))) :
	            '';
	    }
	};
	
	// VFL прокидывание layer
	ol.renderer.canvas.ImageLayer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, layer) {
	    if (this.vectorRenderer_) {
	        return this.vectorRenderer_.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, undefined, layer);
	    } else {
	        return ol.renderer.canvas.IntermediateCanvas.prototype.forEachFeatureAtCoordinate.call(this, coordinate, frameState, hitTolerance, callback, undefined, layer);
	    }
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	ol.interaction.DragPan.prototype.handleDownEvent = function(mapBrowserEvent) {
	    if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
	        var map = mapBrowserEvent.map;
	        var view = map.getView();
	        this.lastCentroid = null;
	
	        if (view.getAnimating()) {
	            if (Math.floor(view.getZoom()) !== view.getZoom()) {
	                return false;
	            }
	        }
	
	        // stop any current animation
	        if (view.getAnimating()) {
	            view.setCenter(mapBrowserEvent.frameState.viewState.center);
	        }
	        if (this.kinetic_) {
	            this.kinetic_.begin();
	        }
	        // No kinetic as soon as more than one pointer on the screen is
	        // detected. This is to prevent nasty pans after pinch.
	        this.noKinetic_ = this.targetPointers.length > 1;
	        return true;
	    } else {
	        return false;
	    }
	}
	


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(23);
	ol.pointer.PointerEventHandler.prototype.eventHandler_ = function(inEvent) {
	    var type = inEvent.type;
	    var handler = this.eventMap_[type];
	    if (type == 'pointerdown') {
	        this.startPoint = {
	            x: inEvent.offsetX,
	            y: inEvent.offsetY
	        };
	    }
	    if (handler) {
	        if (type == 'pointermove') {
	            if (this.startPoint) {
	                if (Math.abs(this.startPoint.x - inEvent.offsetX) + Math.abs(this.startPoint.y - inEvent.offsetY) < 3) {
	                    return;
	                }
	            }
	        }
	        handler(inEvent);
	    }
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget = __webpack_require__(31),
	    $      = __webpack_require__(3);
	
	var ModalMessage = Widget.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function (options) {
	        var that = this;
	
	        ModalMessage.__super__.initialize.call(that, options);
	        that.getContainer().addClass('omjs-widget-modal-alert');
	        that.$message = $('<div>')
	            .addClass('omjs-widget-modal-alert-message')
	            .appendTo(that.getContainer());
	
	        if(options.message){
	            that.setMessage(options.message)
	        }
	
	        that.getContainer().on('click', function () {
	            that.hide();
	        });
	    },
	
	    setMessage: function(message){
	        var that = this;
	        that.message = message;
	        that.$message.html(that.message);
	        return that;
	    },
	
	    getMessage: function(){
	        return this.message;
	    },
	
	    onAdd: function(view){
	        this.view = view;
	    }
	});
	
	module.exports = ModalMessage;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var Class           = __webpack_require__(4),
	    $               = __webpack_require__(3),
	    Events          = __webpack_require__(6);
	
	var Widget = Class.extend({
	
	    includes: Events,
	
	    statics: {
	        CLASSES: {
	            HIDDEN_CLASS: 'hidden'
	        }
	    },
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        that._hidden = false;
	
	        that._container = $('<div></div>');
	        that._container.addClass('omjs-widget');
	
	        if (typeof options.classes == 'string' && options.classes.length > 0) {
	            that._container.addClass(options.classes);
	        }
	
	        if (typeof options.css == 'object') {
	            that._container.css(options.css);
	        }
	
	        if ('name' in options) {
	            that._name = options.name;
	            delete options['name'];
	        }
	
	        if (typeof options.translate == 'function') {
	            that._translate = options.translate;
	            delete options['translate'];
	        } else {
	            that._translate = function (phrase) {
	                return phrase;
	            };
	        }
	
	        that.setOptions(options);
	    },
	
	    /**
	     *
	     * @return {*|jQuery|HTMLElement|Widget._container}
	     */
	    getContainer: function() {
	        return this._container;
	    },
	
	
	    getName: function(){
	        return this._name;
	    },
	
	    /**
	     *
	     */
	    show: function(){
	        var that = this;
	        that.getContainer().removeClass(Widget.CLASSES.HIDDEN_CLASS);
	        that._hidden = false;
	        that.fire('show');
	        return that;
	    },
	
	    /**
	     *
	     */
	    hide: function(){
	        var that = this;
	        that.getContainer().addClass(Widget.CLASSES.HIDDEN_CLASS);
	        that._hidden = true;
	        that.fire('hide');
	        return that;
	    },
	
	    /**
	     *
	     */
	    onAdd: function(view){
	        return void(0);
	    },
	
	    onRemove: function(view){
	        return void(0);
	    },
	
	    isHidden: function(){
	        var that = this;
	        return that._hidden;
	    },
	
	    translate: function (phrase) {
	        var that = this;
	        return that._translate(phrase);
	    }
	});
	
	module.exports = Widget;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(22);
	var PKK5ArcGISTileGrid = __webpack_require__(33);
	
	function tileUrlFunction(tileCoord, pixelRatio, projection) {
	    var tileGrid = this.getTileGrid();
	    if (!tileGrid) {
	        tileGrid = this.getTileGridForProjection(projection);
	    }
	
	    if (tileGrid.getResolutions().length <= tileCoord[0]) {
	        return undefined;
	    }
	
	    var tileExtent = tileGrid.getTileCoordExtent(
	        tileCoord/*, this.tmpExtent_*/);
	    var tileSize = ol.size.toSize(
	        tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
	
	    // if (pixelRatio != 1) {
	    //     tileSize = ol.size.scale(tileSize, pixelRatio, this.tmpSize);
	    // }
	
	    // Apply default params and override with user specified values.
	    // убрал их в getRequestUrl_ для удобства
	    var baseParams = {};
	    ol.obj.assign(baseParams, this.params_);
	
	    return this.getRequestUrl_(tileCoord, tileSize, tileExtent,
	        pixelRatio, projection, baseParams);
	}
	
	ol.source.PKK5ArcGISSource = function(opt_options){
	    var options = opt_options || {};
	    options = ol.obj.assign({}, options, {
	        'tileUrlFunction': tileUrlFunction,
	        'tileGrid': options['tileGrid'] || (
	            new ol.tilegrid.PKK5ArcGISTileGrid()
	        )
	    });
	    ol.source.TileArcGISRest.call(this, options);
	};
	
	ol.inherits(ol.source.PKK5ArcGISSource, ol.source.TileArcGISRest);
	
	ol.source.PKK5ArcGISSource.prototype.calculatePKK5Extent = function(tileCoord, tileSize) {
	    var tileGrid = this.getTileGrid();
	    var s = tileGrid.getOrigin()[0],
	        a = tileGrid.getOrigin()[1];
	
	    var t = tileCoord[0]; // z
	    var i = tileCoord[1]; // x
	    var e = Math.abs(tileCoord[2]) -1; // y
	
	    // t - zoom
	    // e - колонка тайла в DOM
	    // i - ряд тайла в DOM
	    // s и a что-то скорее всего связанное с экстентом на 1 или 0 зуме.
	    //      они всегда равны (s = -20037508.342787, a = 20037508.342787)
	
	    var resolution = tileGrid.getResolution(t);
	    var width = tileSize[0];
	    var height = tileSize[1];
	    var extent = {};
	    extent.xmin = i * width * resolution + s;
	    extent.ymin = a - (e + 1) * height * resolution;
	    extent.ymax = a - e * height * resolution;
	    extent.xmax = (i + 1) * width * resolution + s;
	    // extent.spatialReference = this.spatialReference;
	    return [extent.xmin, extent.ymin, extent.xmax, extent.ymax];
	},
	
	ol.source.PKK5ArcGISSource.prototype.getRequestUrl_ = function(
	    tileCoord, tileSize, tileExtent,
	    pixelRatio, projection, params
	) {
	    var urls = this.urls;
	    var tileGrid = this.getTileGrid();
	
	    if (!urls) {
	        return undefined;
	    }
	
	    var layers = 'show:0,1,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,23,24,29,30,31,32,33,34,35,38,39';
	
	    var srid = projection.getCode().split(':').pop();
	
	    // поменял параметры в lowerCase
	    params['layers'] = layers;
	    params['dpi'] = 96;
	    params['format'] = 'PNG32';
	    // params['bbox'] = tileExtent.join(',');
	    params['bbox'] = this.calculatePKK5Extent(tileCoord, tileSize).join(',');
	    params['bboxSR'] = /*srid*/ '102100';
	    params['imageSR'] = /*srid*/ '102100';
	    params['size'] = tileSize[0] + ',' + tileSize[1];
	    params['transparent'] = true;
	    params['f'] = 'image';
	    // params['dpi'] = Math.round(
	    //         params['dpi'] ? params['dpi'] * pixelRatio : 90 * pixelRatio
	    // );
	
	    var url;
	    if (urls.length == 1) {
	        url = urls[0];
	    } else {
	        var index = ol.math.modulo(ol.tilecoord.hash(tileCoord), urls.length);
	        url = urls[index];
	    }
	
	    var modifiedUrl = url
	            .replace(/MapServer\/?$/, 'MapServer/export')
	            .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
	    return ol.uri.appendParams(modifiedUrl, params);
	};
	
	module.exports = ol.source.PKK5ArcGISSource;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(22);
	
	ol.tilegrid.PKK5ArcGISTileGrid = function(opt_options){
	    var options = opt_options || {};
	
	    var DEFAULT_EXTENT = [
	        -20037508.342787,
	        -20037508.342781093,
	        20037508.342781093,
	        20037508.342787
	    ];
	
	    var DEFAULT_RESOLUTIONS = [
	        156543.03392800014,
	        78271.51696399994,
	        39135.75848200009,
	        19567.87924099992,
	        9783.93962049996,
	        4891.96981024998,
	        2445.98490512499,
	        1222.992452562495,
	        611.4962262813797,
	        305.74811314055756,
	        152.87405657041106,
	        76.43702828507324,
	        38.21851414253662,
	        19.10925707126831,
	        9.554628535634155,
	        4.77731426794937,
	        2.388657133974685,
	        1.1943285668550503,
	        0.5971642835598172,
	        0.29858214164761665,
	        0.14929107082380833,
	        0.07464553541190416,
	        0.03732276770595208,
	        0.01866138385297604,
	        0.00933069192648802,
	        0.00466534596456693,
	        0.0023326729817542973,
	        0.0011663364908771486,
	        0.0005831682454385743,
	        0.00029158412271928716,
	        0.00014579206135964358
	    ];
	
	    var DEFAULT_MIN_ZOOM = 0;
	    var DEFAULT_MAX_ZOOM = 30;
	    var DEFAULT_TILE_SIZE = 1024;
	
	    options['extent'] = options['extent'] || DEFAULT_EXTENT;
	    options['resolutions'] = options['resolutions'] || DEFAULT_RESOLUTIONS;
	    options['minZoom'] = options['minZoom'] || DEFAULT_MIN_ZOOM;
	    options['maxZoom'] = options['maxZoom'] || DEFAULT_MAX_ZOOM;
	    options['tileSize'] = options['tileSize'] || DEFAULT_TILE_SIZE;
	
	    ol.tilegrid.TileGrid.call(this, options);
	};
	ol.inherits(ol.tilegrid.PKK5ArcGISTileGrid, ol.tilegrid.TileGrid);
	
	module.exports = ol.tilegrid.PKK5ArcGISTileGrid;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// http://pkk5.rosreestr.ru/arcgis/rest/services/Cadastre/CadastreSelected/MapServer/export?dpi=96&transparent=true&format=png32&layers=show%3A10&bbox=5539327.669175136%2C8384958.095826377%2C7726038.174356877%2C10006646.087924246&bboxSR=102100&imageSR=102100&size=894%2C663&layerDefs=10%3AID%20%3D%20%2786%27&f=image
	var ol = __webpack_require__(22);
	var this_parent = ol.source.PKK5ArcGISSource;
	ol.source.PKK5ArcGISHighlightSource = function(opt_options) {
	    /**
	     * Строка с id фичи, которую нужно подсветить
	     * @type {string}
	     */
	    this.selected_feature = null;
	
	    this_parent.call(this, opt_options)
	};
	ol.inherits(ol.source.PKK5ArcGISHighlightSource, this_parent);
	
	
	ol.source.PKK5ArcGISHighlightSource.prototype.setSelectedFeature = function(feature_id) {
	    if (feature_id === null) {
	        this.selected_feature = null;
	    } else {
	        this.selected_feature = feature_id + '';
	    }
	
	    this._reloadTiles();
	};
	
	ol.source.PKK5ArcGISHighlightSource.prototype._reloadTiles = function() {
	    this.emptyCache();
	    this.refresh();
	};
	
	ol.source.PKK5ArcGISHighlightSource.prototype.emptyCache = function() {
	    this.tileCache.expireCache({});
	    this.tileCache.clear();
	}
	
	/* 
	    Эта функция такая же как и у парента, кроме того что к запросу добавляется 
	    параметр layerDefs, который содержит id фичи, которую надо выделить
	*/
	ol.source.PKK5ArcGISHighlightSource.prototype.getRequestUrl_ = function(
	    tileCoord, 
	    tileSize, 
	    tileExtent,
	    pixelRatio, 
	    projection, 
	    params
	) {
	
	    var urls = this.urls;
	    var tileGrid = this.getTileGrid();
	    var selected_feature = this.selected_feature;
	
	    if (!urls) {
	        return undefined;
	    }
	
	    var layer_ids = [0, 1 , 2, 3, 4, 5, 6, 7, 8, 9, 10];
	    // var layers = 'show:0,1,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,23,24,29,30,31,32,33,34,35,38,39';
	
	    var srid = projection.getCode().split(':').pop();
	
	    var layerDefs = {};
	    if (selected_feature) {
	        for (var i = 0; i < layer_ids.length; i++) {
	            var layer_id = layer_ids[i];
	            layerDefs[layer_id] = "ID = '" + selected_feature + "'";
	        }
	    }
	
	    // поменял параметры в lowerCase
	    params['layers'] = 'show:' + layer_ids.join(',');
	    params['dpi'] = 96;
	    params['format'] = 'PNG32';
	    // params['bbox'] = tileExtent.join(',');
	    params['bbox'] = this.calculatePKK5Extent(tileCoord, tileSize).join(',');
	    params['bboxSR'] = /*srid*/ '102100';
	    params['imageSR'] = /*srid*/ '102100';
	    params['size'] = tileSize[0] + ',' + tileSize[1];
	    params['transparent'] = true;
	    params['f'] = 'image';
	    if (selected_feature) {
	        params['layerDefs'] = JSON.stringify(layerDefs);
	    }
	    // params['dpi'] = Math.round(
	    //         params['dpi'] ? params['dpi'] * pixelRatio : 90 * pixelRatio
	    // );
	
	    var url;
	    if (urls.length == 1) {
	        url = urls[0];
	    } else {
	        var index = ol.math.modulo(ol.tilecoord.hash(tileCoord), urls.length);
	        url = urls[index];
	    }
	
	    var modifiedUrl = url
	            .replace(/MapServer\/?$/, 'MapServer/export')
	            .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
	    return ol.uri.appendParams(modifiedUrl, params);
	};
	
	
	


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(Buffer, global) {(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.mapboxgl = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
	"use strict";function serializePaintVertexArrays(r,e){var t={};for(var a in r){var n=r[a].paintVertexArray;if(0!==n.length){var i=n.serialize(e),s=n.constructor.serialize();t[a]={array:i,type:s}}}return t}var ProgramConfiguration=require("./program_configuration"),Segment=function(r,e){this.vertexOffset=r,this.primitiveOffset=e,this.vertexLength=0,this.primitiveLength=0},ArrayGroup=function(r,e,t){var a=this;this.globalProperties={zoom:t};var n=r.layoutVertexArrayType;this.layoutVertexArray=new n;var i=r.elementArrayType;i&&(this.elementArray=new i);var s=r.elementArrayType2;s&&(this.elementArray2=new s),this.layerData={};for(var y=0,o=e;y<o.length;y+=1){var l=o[y],h=ProgramConfiguration.createDynamic(r.paintAttributes||[],l,t);a.layerData[l.id]={layer:l,programConfiguration:h,paintVertexArray:new h.PaintVertexArray}}this.segments=[],this.segments2=[]};ArrayGroup.prototype.prepareSegment=function(r){var e=this.segments[this.segments.length-1];return(!e||e.vertexLength+r>ArrayGroup.MAX_VERTEX_ARRAY_LENGTH)&&(e=new Segment(this.layoutVertexArray.length,this.elementArray.length),this.segments.push(e)),e},ArrayGroup.prototype.prepareSegment2=function(r){var e=this.segments2[this.segments2.length-1];return(!e||e.vertexLength+r>ArrayGroup.MAX_VERTEX_ARRAY_LENGTH)&&(e=new Segment(this.layoutVertexArray.length,this.elementArray2.length),this.segments2.push(e)),e},ArrayGroup.prototype.populatePaintArrays=function(r){var e=this;for(var t in this.layerData){var a=e.layerData[t];0!==a.paintVertexArray.bytesPerElement&&a.programConfiguration.populatePaintArray(a.layer,a.paintVertexArray,e.layoutVertexArray.length,e.globalProperties,r)}},ArrayGroup.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},ArrayGroup.prototype.serialize=function(r){return{layoutVertexArray:this.layoutVertexArray.serialize(r),elementArray:this.elementArray&&this.elementArray.serialize(r),elementArray2:this.elementArray2&&this.elementArray2.serialize(r),paintVertexArrays:serializePaintVertexArrays(this.layerData,r),segments:this.segments,segments2:this.segments2}},ArrayGroup.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,module.exports=ArrayGroup;
	},{"./program_configuration":15}],2:[function(require,module,exports){
	"use strict";var ArrayGroup=require("./array_group"),BufferGroup=require("./buffer_group"),util=require("../util/util"),Bucket=function(r,e){this.zoom=r.zoom,this.overscaling=r.overscaling,this.layers=r.layers,this.index=r.index,r.arrays?this.buffers=new BufferGroup(e,r.layers,r.zoom,r.arrays):this.arrays=new ArrayGroup(e,r.layers,r.zoom)};Bucket.prototype.populate=function(r,e){for(var t=this,i=0,u=r;i<u.length;i+=1){var a=u[i];t.layers[0].filter(a)&&(t.addFeature(a),e.featureIndex.insert(a,t.index))}},Bucket.prototype.isEmpty=function(){return this.arrays.isEmpty()},Bucket.prototype.serialize=function(r){return{zoom:this.zoom,layerIds:this.layers.map(function(r){return r.id}),arrays:this.arrays.serialize(r)}},Bucket.prototype.destroy=function(){this.buffers&&(this.buffers.destroy(),this.buffers=null)},module.exports=Bucket,Bucket.deserialize=function(r,e){if(e){for(var t={},i=0,u=r;i<u.length;i+=1){var a=u[i],o=a.layerIds.map(function(r){return e.getLayer(r)}).filter(Boolean);if(0!==o.length)for(var s=o[0].createBucket(util.extend({layers:o},a)),n=0,f=o;n<f.length;n+=1){var l=f[n];t[l.id]=s}}return t}};
	},{"../util/util":127,"./array_group":1,"./buffer_group":9}],3:[function(require,module,exports){
	"use strict";function addCircleVertex(e,r,t,a,p){e.emplaceBack(2*r+(a+1)/2,2*t+(p+1)/2)}var Bucket=require("../bucket"),createVertexArrayType=require("../vertex_array_type"),createElementArrayType=require("../element_array_type"),loadGeometry=require("../load_geometry"),EXTENT=require("../extent"),circleInterface={layoutVertexArrayType:createVertexArrayType([{name:"a_pos",components:2,type:"Int16"}]),elementArrayType:createElementArrayType(),paintAttributes:[{property:"circle-color",type:"Uint8"},{property:"circle-radius",type:"Uint16",multiplier:10},{property:"circle-blur",type:"Uint16",multiplier:10},{property:"circle-opacity",type:"Uint8",multiplier:255},{property:"circle-stroke-color",type:"Uint8"},{property:"circle-stroke-width",type:"Uint16",multiplier:10},{property:"circle-stroke-opacity",type:"Uint8",multiplier:255}]},CircleBucket=function(e){function r(r){e.call(this,r,circleInterface)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.addFeature=function(e){for(var r=this.arrays,t=0,a=loadGeometry(e);t<a.length;t+=1)for(var p=a[t],c=0,i=p;c<i.length;c+=1){var y=i[c],l=y.x,o=y.y;if(!(l<0||l>=EXTENT||o<0||o>=EXTENT)){var n=r.prepareSegment(4),u=n.vertexLength;addCircleVertex(r.layoutVertexArray,l,o,-1,-1),addCircleVertex(r.layoutVertexArray,l,o,1,-1),addCircleVertex(r.layoutVertexArray,l,o,1,1),addCircleVertex(r.layoutVertexArray,l,o,-1,1),r.elementArray.emplaceBack(u,u+1,u+2),r.elementArray.emplaceBack(u,u+3,u+2),n.vertexLength+=4,n.primitiveLength+=2}}r.populatePaintArrays(e.properties)},r}(Bucket);module.exports=CircleBucket;
	},{"../bucket":2,"../element_array_type":10,"../extent":11,"../load_geometry":13,"../vertex_array_type":17}],4:[function(require,module,exports){
	"use strict";var Bucket=require("../bucket"),createVertexArrayType=require("../vertex_array_type"),createElementArrayType=require("../element_array_type"),loadGeometry=require("../load_geometry"),earcut=require("earcut"),classifyRings=require("../../util/classify_rings"),EARCUT_MAX_RINGS=500,fillInterface={layoutVertexArrayType:createVertexArrayType([{name:"a_pos",components:2,type:"Int16"}]),elementArrayType:createElementArrayType(3),elementArrayType2:createElementArrayType(2),paintAttributes:[{property:"fill-color",type:"Uint8"},{property:"fill-outline-color",type:"Uint8"},{property:"fill-opacity",type:"Uint8",multiplier:255}]},FillBucket=function(e){function r(r){e.call(this,r,fillInterface)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.addFeature=function(e){for(var r=this.arrays,t=0,a=classifyRings(loadGeometry(e),EARCUT_MAX_RINGS);t<a.length;t+=1){for(var l=a[t],p=0,n=0,y=l;n<y.length;n+=1){var o=y[n];p+=o.length}for(var i=r.prepareSegment(p),c=i.vertexLength,u=[],h=[],s=0,g=l;s<g.length;s+=1){var m=g[s];if(0!==m.length){m!==l[0]&&h.push(u.length/2);var f=r.prepareSegment2(m.length),A=f.vertexLength;r.layoutVertexArray.emplaceBack(m[0].x,m[0].y),r.elementArray2.emplaceBack(A+m.length-1,A),u.push(m[0].x),u.push(m[0].y);for(var v=1;v<m.length;v++)r.layoutVertexArray.emplaceBack(m[v].x,m[v].y),r.elementArray2.emplaceBack(A+v-1,A+v),u.push(m[v].x),u.push(m[v].y);f.vertexLength+=m.length,f.primitiveLength+=m.length}}for(var x=earcut(u,h),_=0;_<x.length;_+=3)r.elementArray.emplaceBack(c+x[_],c+x[_+1],c+x[_+2]);i.vertexLength+=p,i.primitiveLength+=x.length/3}r.populatePaintArrays(e.properties)},r}(Bucket);module.exports=FillBucket;
	},{"../../util/classify_rings":111,"../bucket":2,"../element_array_type":10,"../load_geometry":13,"../vertex_array_type":17,"earcut":133}],5:[function(require,module,exports){
	"use strict";function addVertex(e,r,t,a,n,y,o,i){e.emplaceBack(r,t,2*Math.floor(a*FACTOR)+o,n*FACTOR*2,y*FACTOR*2,Math.round(i))}function isBoundaryEdge(e,r){return e.x===r.x&&(e.x<0||e.x>EXTENT)||e.y===r.y&&(e.y<0||e.y>EXTENT)}var Bucket=require("../bucket"),createVertexArrayType=require("../vertex_array_type"),createElementArrayType=require("../element_array_type"),loadGeometry=require("../load_geometry"),EXTENT=require("../extent"),earcut=require("earcut"),classifyRings=require("../../util/classify_rings"),EARCUT_MAX_RINGS=500,fillExtrusionInterface={layoutVertexArrayType:createVertexArrayType([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal",components:3,type:"Int16"},{name:"a_edgedistance",components:1,type:"Int16"}]),elementArrayType:createElementArrayType(3),paintAttributes:[{property:"fill-extrusion-base",type:"Uint16"},{property:"fill-extrusion-height",type:"Uint16"},{property:"fill-extrusion-color",type:"Uint8"}]},FACTOR=Math.pow(2,13),FillExtrusionBucket=function(e){function r(r){e.call(this,r,fillExtrusionInterface)}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.addFeature=function(e){for(var r=this.arrays,t=0,a=classifyRings(loadGeometry(e),EARCUT_MAX_RINGS);t<a.length;t+=1){for(var n=a[t],y=0,o=0,i=n;o<i.length;o+=1){var l=i[o];y+=l.length}for(var p=r.prepareSegment(5*y),u=[],c=[],x=[],s=0,d=n;s<d.length;s+=1){var h=d[s];if(0!==h.length){h!==n[0]&&c.push(u.length/2);for(var m=0,f=0;f<h.length;f++){var A=h[f];if(addVertex(r.layoutVertexArray,A.x,A.y,0,0,1,1,0),x.push(p.vertexLength++),f>=1){var g=h[f-1];if(!isBoundaryEdge(A,g)){var _=A.sub(g)._perp()._unit();addVertex(r.layoutVertexArray,A.x,A.y,_.x,_.y,0,0,m),addVertex(r.layoutVertexArray,A.x,A.y,_.x,_.y,0,1,m),m+=g.dist(A),addVertex(r.layoutVertexArray,g.x,g.y,_.x,_.y,0,0,m),addVertex(r.layoutVertexArray,g.x,g.y,_.x,_.y,0,1,m);var v=p.vertexLength;r.elementArray.emplaceBack(v,v+1,v+2),r.elementArray.emplaceBack(v+1,v+2,v+3),p.vertexLength+=4,p.primitiveLength+=2}}u.push(A.x),u.push(A.y)}}}for(var T=earcut(u,c),E=0;E<T.length;E+=3)r.elementArray.emplaceBack(x[T[E]],x[T[E+1]],x[T[E+2]]);p.primitiveLength+=T.length/3}r.populatePaintArrays(e.properties)},r}(Bucket);module.exports=FillExtrusionBucket;
	},{"../../util/classify_rings":111,"../bucket":2,"../element_array_type":10,"../extent":11,"../load_geometry":13,"../vertex_array_type":17,"earcut":133}],6:[function(require,module,exports){
	"use strict";function addLineVertex(e,t,r,i,a,n,d){e.emplaceBack(t.x<<1|i,t.y<<1|a,Math.round(EXTRUDE_SCALE*r.x)+128,Math.round(EXTRUDE_SCALE*r.y)+128,(0===n?0:n<0?-1:1)+1|(d*LINE_DISTANCE_SCALE&63)<<2,d*LINE_DISTANCE_SCALE>>6)}var Bucket=require("../bucket"),createVertexArrayType=require("../vertex_array_type"),createElementArrayType=require("../element_array_type"),loadGeometry=require("../load_geometry"),EXTENT=require("../extent"),EXTRUDE_SCALE=63,COS_HALF_SHARP_CORNER=Math.cos(37.5*(Math.PI/180)),SHARP_CORNER_OFFSET=15,LINE_DISTANCE_BUFFER_BITS=15,LINE_DISTANCE_SCALE=.5,MAX_LINE_DISTANCE=Math.pow(2,LINE_DISTANCE_BUFFER_BITS-1)/LINE_DISTANCE_SCALE,lineInterface={layoutVertexArrayType:createVertexArrayType([{name:"a_pos",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}]),paintAttributes:[{property:"line-color",type:"Uint8"},{property:"line-blur",multiplier:10,type:"Uint8"},{property:"line-opacity",multiplier:10,type:"Uint8"},{property:"line-gap-width",multiplier:10,type:"Uint8",name:"a_gapwidth"},{property:"line-offset",multiplier:1,type:"Int8"}],elementArrayType:createElementArrayType()},LineBucket=function(e){function t(t){e.call(this,t,lineInterface)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.addFeature=function(e){for(var t=this,r=this.layers[0].layout,i=r["line-join"],a=r["line-cap"],n=r["line-miter-limit"],d=r["line-round-limit"],s=0,u=loadGeometry(e,LINE_DISTANCE_BUFFER_BITS);s<u.length;s+=1){var l=u[s];t.addLine(l,e.properties,i,a,n,d)}},t.prototype.addLine=function(e,t,r,i,a,n){for(var d=this,s=e.length;s>2&&e[s-1].equals(e[s-2]);)s--;if(!(e.length<2)){"bevel"===r&&(a=1.05);var u=SHARP_CORNER_OFFSET*(EXTENT/(512*this.overscaling)),l=e[0],p=e[s-1],o=l.equals(p),c=this.arrays,_=c.prepareSegment(10*s);if(2!==s||!o){this.distance=0;var h,y,m,E,x,C,A,f=i,v=o?"butt":i,L=!0;this.e1=this.e2=this.e3=-1,o&&(h=e[s-2],x=l.sub(h)._unit()._perp());for(var S=0;S<s;S++)if(m=o&&S===s-1?e[1]:e[S+1],!m||!e[S].equals(m)){x&&(E=x),h&&(y=h),h=e[S],x=m?m.sub(h)._unit()._perp():E,E=E||x;var V=E.add(x)._unit(),T=V.x*x.x+V.y*x.y,I=1/T,N=T<COS_HALF_SHARP_CORNER&&y&&m;if(N&&S>0){var b=h.dist(y);if(b>2*u){var R=h.sub(h.sub(y)._mult(u/b)._round());d.distance+=R.dist(y),d.addCurrentVertex(R,d.distance,E.mult(1),0,0,!1,_),y=R}}var g=y&&m,B=g?r:m?f:v;if(g&&"round"===B&&(I<n?B="miter":I<=2&&(B="fakeround")),"miter"===B&&I>a&&(B="bevel"),"bevel"===B&&(I>2&&(B="flipbevel"),I<a&&(B="miter")),y&&(d.distance+=h.dist(y)),"miter"===B)V._mult(I),d.addCurrentVertex(h,d.distance,V,0,0,!1,_);else if("flipbevel"===B){if(I>100)V=x.clone();else{var F=E.x*x.y-E.y*x.x>0?-1:1,k=I*E.add(x).mag()/E.sub(x).mag();V._perp()._mult(k*F)}d.addCurrentVertex(h,d.distance,V,0,0,!1,_),d.addCurrentVertex(h,d.distance,V.mult(-1),0,0,!1,_)}else if("bevel"===B||"fakeround"===B){var D=E.x*x.y-E.y*x.x>0,U=-Math.sqrt(I*I-1);if(D?(A=0,C=U):(C=0,A=U),L||d.addCurrentVertex(h,d.distance,E,C,A,!1,_),"fakeround"===B){for(var q,P=Math.floor(8*(.5-(T-.5))),M=0;M<P;M++)q=x.mult((M+1)/(P+1))._add(E)._unit(),d.addPieSliceVertex(h,d.distance,q,D,_);d.addPieSliceVertex(h,d.distance,V,D,_);for(var O=P-1;O>=0;O--)q=E.mult((O+1)/(P+1))._add(x)._unit(),d.addPieSliceVertex(h,d.distance,q,D,_)}m&&d.addCurrentVertex(h,d.distance,x,-C,-A,!1,_)}else"butt"===B?(L||d.addCurrentVertex(h,d.distance,E,0,0,!1,_),m&&d.addCurrentVertex(h,d.distance,x,0,0,!1,_)):"square"===B?(L||(d.addCurrentVertex(h,d.distance,E,1,1,!1,_),d.e1=d.e2=-1),m&&d.addCurrentVertex(h,d.distance,x,-1,-1,!1,_)):"round"===B&&(L||(d.addCurrentVertex(h,d.distance,E,0,0,!1,_),d.addCurrentVertex(h,d.distance,E,1,1,!0,_),d.e1=d.e2=-1),m&&(d.addCurrentVertex(h,d.distance,x,-1,-1,!0,_),d.addCurrentVertex(h,d.distance,x,0,0,!1,_)));if(N&&S<s-1){var X=h.dist(m);if(X>2*u){var H=h.add(m.sub(h)._mult(u/X)._round());d.distance+=H.dist(h),d.addCurrentVertex(H,d.distance,x.mult(1),0,0,!1,_),h=H}}L=!1}c.populatePaintArrays(t)}}},t.prototype.addCurrentVertex=function(e,t,r,i,a,n,d){var s,u=n?1:0,l=this.arrays,p=l.layoutVertexArray,o=l.elementArray;s=r.clone(),i&&s._sub(r.perp()._mult(i)),addLineVertex(p,e,s,u,0,i,t),this.e3=d.vertexLength++,this.e1>=0&&this.e2>=0&&(o.emplaceBack(this.e1,this.e2,this.e3),d.primitiveLength++),this.e1=this.e2,this.e2=this.e3,s=r.mult(-1),a&&s._sub(r.perp()._mult(a)),addLineVertex(p,e,s,u,1,-a,t),this.e3=d.vertexLength++,this.e1>=0&&this.e2>=0&&(o.emplaceBack(this.e1,this.e2,this.e3),d.primitiveLength++),this.e1=this.e2,this.e2=this.e3,t>MAX_LINE_DISTANCE/2&&(this.distance=0,this.addCurrentVertex(e,this.distance,r,i,a,n,d))},t.prototype.addPieSliceVertex=function(e,t,r,i,a){var n=i?1:0;r=r.mult(i?-1:1);var d=this.arrays,s=d.layoutVertexArray,u=d.elementArray;addLineVertex(s,e,r,0,n,0,t),this.e3=a.vertexLength++,this.e1>=0&&this.e2>=0&&(u.emplaceBack(this.e1,this.e2,this.e3),a.primitiveLength++),i?this.e2=this.e3:this.e1=this.e3},t}(Bucket);module.exports=LineBucket;
	},{"../bucket":2,"../element_array_type":10,"../extent":11,"../load_geometry":13,"../vertex_array_type":17}],7:[function(require,module,exports){
	"use strict";function addVertex(e,t,o,a,r,n,i,s,l,y,c){e.emplaceBack(t,o,Math.round(64*a),Math.round(64*r),n/4,i/4,10*(y||0),c,10*(s||0),10*Math.min(l||25,25))}function addCollisionBoxVertex(e,t,o,a,r){return e.emplaceBack(t.x,t.y,Math.round(o.x),Math.round(o.y),10*a,10*r)}var Point=require("point-geometry"),ArrayGroup=require("../array_group"),BufferGroup=require("../buffer_group"),createVertexArrayType=require("../vertex_array_type"),createElementArrayType=require("../element_array_type"),EXTENT=require("../extent"),Anchor=require("../../symbol/anchor"),getAnchors=require("../../symbol/get_anchors"),resolveTokens=require("../../util/token"),Quads=require("../../symbol/quads"),Shaping=require("../../symbol/shaping"),resolveText=require("../../symbol/resolve_text"),mergeLines=require("../../symbol/mergelines"),clipLine=require("../../symbol/clip_line"),util=require("../../util/util"),scriptDetection=require("../../util/script_detection"),loadGeometry=require("../load_geometry"),CollisionFeature=require("../../symbol/collision_feature"),findPoleOfInaccessibility=require("../../util/find_pole_of_inaccessibility"),classifyRings=require("../../util/classify_rings"),VectorTileFeature=require("vector-tile").VectorTileFeature,shapeText=Shaping.shapeText,shapeIcon=Shaping.shapeIcon,WritingMode=Shaping.WritingMode,getGlyphQuads=Quads.getGlyphQuads,getIconQuads=Quads.getIconQuads,elementArrayType=createElementArrayType(),layoutVertexArrayType=createVertexArrayType([{name:"a_pos",components:2,type:"Int16"},{name:"a_offset",components:2,type:"Int16"},{name:"a_texture_pos",components:2,type:"Uint16"},{name:"a_data",components:4,type:"Uint8"}]),symbolInterfaces={glyph:{layoutVertexArrayType:layoutVertexArrayType,elementArrayType:elementArrayType},icon:{layoutVertexArrayType:layoutVertexArrayType,elementArrayType:elementArrayType},collisionBox:{layoutVertexArrayType:createVertexArrayType([{name:"a_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"},{name:"a_data",components:2,type:"Uint8"}]),elementArrayType:createElementArrayType(2)}},SymbolBucket=function(e){var t=this;if(this.collisionBoxArray=e.collisionBoxArray,this.symbolQuadsArray=e.symbolQuadsArray,this.symbolInstancesArray=e.symbolInstancesArray,this.zoom=e.zoom,this.overscaling=e.overscaling,this.layers=e.layers,this.index=e.index,this.sdfIcons=e.sdfIcons,this.iconsNeedLinear=e.iconsNeedLinear,this.adjustedTextSize=e.adjustedTextSize,this.adjustedIconSize=e.adjustedIconSize,this.fontstack=e.fontstack,e.arrays){this.buffers={};for(var o in e.arrays)e.arrays[o]&&(t.buffers[o]=new BufferGroup(symbolInterfaces[o],e.layers,e.zoom,e.arrays[o]))}};SymbolBucket.prototype.populate=function(e,t){var o=this,a=this.layers[0].layout,r=a["text-field"],n=a["text-font"],i=a["icon-image"],s=r&&n,l=i;if(this.features=[],s||l){for(var y=t.iconDependencies,c=t.glyphDependencies,d=c[n]=c[n]||{},h=0;h<e.length;h++){var x=e[h];if(o.layers[0].filter(x)){var u;s&&(u=resolveText(x,a));var m;if(l&&(m=resolveTokens(x.properties,i)),(u||m)&&(o.features.push({text:u,icon:m,index:h,sourceLayerIndex:x.sourceLayerIndex,geometry:loadGeometry(x),properties:x.properties,type:VectorTileFeature.types[x.type]}),m&&(y[m]=!0),u))for(var p=0;p<u.length;p++)d[u.charCodeAt(p)]=!0}}"line"===a["symbol-placement"]&&(this.features=mergeLines(this.features))}},SymbolBucket.prototype.isEmpty=function(){return this.arrays.icon.isEmpty()&&this.arrays.glyph.isEmpty()&&this.arrays.collisionBox.isEmpty()},SymbolBucket.prototype.serialize=function(e){return{zoom:this.zoom,layerIds:this.layers.map(function(e){return e.id}),sdfIcons:this.sdfIcons,iconsNeedLinear:this.iconsNeedLinear,adjustedTextSize:this.adjustedTextSize,adjustedIconSize:this.adjustedIconSize,fontstack:this.fontstack,arrays:util.mapObject(this.arrays,function(t){return t.isEmpty()?null:t.serialize(e)})}},SymbolBucket.prototype.destroy=function(){this.buffers&&(this.buffers.icon&&this.buffers.icon.destroy(),this.buffers.glyph&&this.buffers.glyph.destroy(),this.buffers.collisionBox&&this.buffers.collisionBox.destroy(),this.buffers=null)},SymbolBucket.prototype.createArrays=function(){var e=this;this.arrays=util.mapObject(symbolInterfaces,function(t){return new ArrayGroup(t,e.layers,e.zoom)})},SymbolBucket.prototype.prepare=function(e,t){var o=this;this.createArrays(),this.adjustedTextMaxSize=this.layers[0].getLayoutValue("text-size",{zoom:18}),this.adjustedTextSize=this.layers[0].getLayoutValue("text-size",{zoom:this.zoom+1}),this.adjustedIconMaxSize=this.layers[0].getLayoutValue("icon-size",{zoom:18}),this.adjustedIconSize=this.layers[0].getLayoutValue("icon-size",{zoom:this.zoom+1});var a=512*this.overscaling;this.tilePixelRatio=EXTENT/a,this.compareText={},this.iconsNeedLinear=!1,this.symbolInstancesStartIndex=this.symbolInstancesArray.length;var r=this.layers[0].layout,n=.5,i=.5;switch(r["text-anchor"]){case"right":case"top-right":case"bottom-right":n=1;break;case"left":case"top-left":case"bottom-left":n=0}switch(r["text-anchor"]){case"bottom":case"bottom-right":case"bottom-left":i=1;break;case"top":case"top-right":case"top-left":i=0}for(var s="right"===r["text-justify"]?1:"left"===r["text-justify"]?0:.5,l=24,y=r["text-line-height"]*l,c="line"!==r["symbol-placement"]?r["text-max-width"]*l:0,d=r["text-letter-spacing"]*l,h=[r["text-offset"][0]*l,r["text-offset"][1]*l],x=this.fontstack=r["text-font"].join(","),u="map"===r["text-rotation-alignment"]&&"line"===r["symbol-placement"],m=0,p=this.features;m<p.length;m+=1){var g,f=p[m];if(f.text){var b=scriptDetection.allowsVerticalWritingMode(f.text);g={},g[WritingMode.horizontal]=shapeText(f.text,e[x],c,y,n,i,s,d,h,l,WritingMode.horizontal),g[WritingMode.vertical]=b&&u&&shapeText(f.text,e[x],c,y,n,i,s,d,h,l,WritingMode.vertical)}else g={};var I;if(f.icon){var v=t[f.icon],S=o.layers[0].getLayoutValue("icon-offset",{zoom:o.zoom},f.properties);I=shapeIcon(v,S),v&&(void 0===o.sdfIcons?o.sdfIcons=v.sdf:o.sdfIcons!==v.sdf&&util.warnOnce("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),1!==v.pixelRatio?o.iconsNeedLinear=!0:0===r["icon-rotate"]&&o.layers[0].isLayoutValueFeatureConstant("icon-rotate")||(o.iconsNeedLinear=!0))}(g[WritingMode.horizontal]||I)&&o.addFeature(f,g,I)}this.symbolInstancesEndIndex=this.symbolInstancesArray.length},SymbolBucket.prototype.addFeature=function(e,t,o){var a=this,r=this.layers[0].layout,n=24,i=this.adjustedTextSize/n,s=void 0!==this.adjustedTextMaxSize?this.adjustedTextMaxSize:this.adjustedTextSize,l=this.tilePixelRatio*i,y=this.tilePixelRatio*s/n,c=this.tilePixelRatio*this.adjustedIconSize,d=this.tilePixelRatio*r["symbol-spacing"],h=r["symbol-avoid-edges"],x=r["text-padding"]*this.tilePixelRatio,u=r["icon-padding"]*this.tilePixelRatio,m=r["text-max-angle"]/180*Math.PI,p="map"===r["text-rotation-alignment"]&&"line"===r["symbol-placement"],g="map"===r["icon-rotation-alignment"]&&"line"===r["symbol-placement"],f=r["text-allow-overlap"]||r["icon-allow-overlap"]||r["text-ignore-placement"]||r["icon-ignore-placement"],b=r["symbol-placement"],I=d/2,v=function(r,n){var i=!(n.x<0||n.x>EXTENT||n.y<0||n.y>EXTENT);if(!h||i){var s=i||f;a.addSymbolInstance(n,r,t,o,a.layers[0],s,a.symbolInstancesArray.length,a.collisionBoxArray,e.index,e.sourceLayerIndex,a.index,l,x,p,c,u,g,{zoom:a.zoom},e.properties)}};if("line"===b)for(var S=0,A=clipLine(e.geometry,0,0,EXTENT,EXTENT);S<A.length;S+=1)for(var M=A[S],B=getAnchors(M,d,m,t[WritingMode.vertical]||t[WritingMode.horizontal],o,n,y,a.overscaling,EXTENT),T=0,z=B;T<z.length;T+=1){var E=z[T],k=t[WritingMode.horizontal];k&&a.anchorIsTooClose(k.text,I,E)||v(M,E)}else if("Polygon"===e.type)for(var P=0,L=classifyRings(e.geometry,0);P<L.length;P+=1){var w=L[P],V=findPoleOfInaccessibility(w,16);v(w[0],new Anchor(V.x,V.y,0))}else if("LineString"===e.type)for(var _=0,Q=e.geometry;_<Q.length;_+=1){var j=Q[_];v(j,new Anchor(j[0].x,j[0].y,0))}else if("Point"===e.type)for(var q=0,C=e.geometry;q<C.length;q+=1)for(var F=C[q],N=0,W=F;N<W.length;N+=1){var X=W[N];v([X],new Anchor(X.x,X.y,0))}},SymbolBucket.prototype.anchorIsTooClose=function(e,t,o){var a=this.compareText;if(e in a){for(var r=a[e],n=r.length-1;n>=0;n--)if(o.dist(r[n])<t)return!0}else a[e]=[];return a[e].push(o),!1},SymbolBucket.prototype.place=function(e,t){var o=this;this.createArrays();var a=this.layers[0].layout,r=e.maxScale,n="map"===a["text-rotation-alignment"]&&"line"===a["symbol-placement"],i="map"===a["icon-rotation-alignment"]&&"line"===a["symbol-placement"],s=a["text-allow-overlap"]||a["icon-allow-overlap"]||a["text-ignore-placement"]||a["icon-ignore-placement"];if(s){var l=this.symbolInstancesArray.toArray(this.symbolInstancesStartIndex,this.symbolInstancesEndIndex),y=e.angle,c=Math.sin(y),d=Math.cos(y);this.sortedSymbolInstances=l.sort(function(e,t){var o=c*e.anchorPointX+d*e.anchorPointY|0,a=c*t.anchorPointX+d*t.anchorPointY|0;return o-a||t.index-e.index})}for(var h=this.symbolInstancesStartIndex;h<this.symbolInstancesEndIndex;h++){var x=o.sortedSymbolInstances?o.sortedSymbolInstances[h-o.symbolInstancesStartIndex]:o.symbolInstancesArray.get(h),u={boxStartIndex:x.textBoxStartIndex,boxEndIndex:x.textBoxEndIndex},m={boxStartIndex:x.iconBoxStartIndex,boxEndIndex:x.iconBoxEndIndex},p=!(x.textBoxStartIndex===x.textBoxEndIndex),g=!(x.iconBoxStartIndex===x.iconBoxEndIndex),f=a["text-optional"]||!p,b=a["icon-optional"]||!g,I=p?e.placeCollisionFeature(u,a["text-allow-overlap"],a["symbol-avoid-edges"]):e.minScale,v=g?e.placeCollisionFeature(m,a["icon-allow-overlap"],a["symbol-avoid-edges"]):e.minScale;f||b?!b&&I?I=Math.max(v,I):!f&&v&&(v=Math.max(v,I)):v=I=Math.max(v,I),p&&(e.insertCollisionFeature(u,I,a["text-ignore-placement"]),I<=r&&o.addSymbols(o.arrays.glyph,x.glyphQuadStartIndex,x.glyphQuadEndIndex,I,a["text-keep-upright"],n,e.angle,x.writingModes)),g&&(e.insertCollisionFeature(m,v,a["icon-ignore-placement"]),v<=r&&o.addSymbols(o.arrays.icon,x.iconQuadStartIndex,x.iconQuadEndIndex,v,a["icon-keep-upright"],i,e.angle))}t&&this.addToDebugBuffers(e)},SymbolBucket.prototype.addSymbols=function(e,t,o,a,r,n,i,s){for(var l=this,y=e.elementArray,c=e.layoutVertexArray,d=this.zoom,h=Math.max(Math.log(a)/Math.LN2+d,0),x=t;x<o;x++){var u=l.symbolQuadsArray.get(x).SymbolQuad,m=(u.anchorAngle+i+Math.PI)%(2*Math.PI);if(s&WritingMode.vertical){if(n&&u.writingMode===WritingMode.vertical){if(r&&n&&m<=5*Math.PI/4||m>7*Math.PI/4)continue}else if(r&&n&&m<=3*Math.PI/4||m>5*Math.PI/4)continue}else if(r&&n&&(m<=Math.PI/2||m>3*Math.PI/2))continue;var p=u.tl,g=u.tr,f=u.bl,b=u.br,I=u.tex,v=u.anchorPoint,S=Math.max(d+Math.log(u.minScale)/Math.LN2,h),A=Math.min(d+Math.log(u.maxScale)/Math.LN2,25);if(!(A<=S)){S===h&&(S=0);var M=Math.round(u.glyphAngle/(2*Math.PI)*256),B=e.prepareSegment(4),T=B.vertexLength;addVertex(c,v.x,v.y,p.x,p.y,I.x,I.y,S,A,h,M),addVertex(c,v.x,v.y,g.x,g.y,I.x+I.w,I.y,S,A,h,M),addVertex(c,v.x,v.y,f.x,f.y,I.x,I.y+I.h,S,A,h,M),addVertex(c,v.x,v.y,b.x,b.y,I.x+I.w,I.y+I.h,S,A,h,M),y.emplaceBack(T,T+1,T+2),y.emplaceBack(T+1,T+2,T+3),B.vertexLength+=4,B.primitiveLength+=2}}},SymbolBucket.prototype.addToDebugBuffers=function(e){for(var t=this,o=this.arrays.collisionBox,a=o.layoutVertexArray,r=o.elementArray,n=-e.angle,i=e.yStretch,s=this.symbolInstancesStartIndex;s<this.symbolInstancesEndIndex;s++){var l=t.symbolInstancesArray.get(s);l.textCollisionFeature={boxStartIndex:l.textBoxStartIndex,boxEndIndex:l.textBoxEndIndex},l.iconCollisionFeature={boxStartIndex:l.iconBoxStartIndex,boxEndIndex:l.iconBoxEndIndex};for(var y=0;y<2;y++){var c=l[0===y?"textCollisionFeature":"iconCollisionFeature"];if(c)for(var d=c.boxStartIndex;d<c.boxEndIndex;d++){var h=t.collisionBoxArray.get(d),x=h.anchorPoint,u=new Point(h.x1,h.y1*i)._rotate(n),m=new Point(h.x2,h.y1*i)._rotate(n),p=new Point(h.x1,h.y2*i)._rotate(n),g=new Point(h.x2,h.y2*i)._rotate(n),f=Math.max(0,Math.min(25,t.zoom+Math.log(h.maxScale)/Math.LN2)),b=Math.max(0,Math.min(25,t.zoom+Math.log(h.placementScale)/Math.LN2)),I=o.prepareSegment(4),v=I.vertexLength;addCollisionBoxVertex(a,x,u,f,b),addCollisionBoxVertex(a,x,m,f,b),addCollisionBoxVertex(a,x,g,f,b),addCollisionBoxVertex(a,x,p,f,b),r.emplaceBack(v,v+1),r.emplaceBack(v+1,v+2),r.emplaceBack(v+2,v+3),r.emplaceBack(v+3,v),I.vertexLength+=4,I.primitiveLength+=4}}}},SymbolBucket.prototype.addSymbolInstance=function(e,t,o,a,r,n,i,s,l,y,c,d,h,x,u,m,p,g,f){var b,I,v,S=this,A=[];for(var M in o){var B=parseInt(M,10);o[B]&&(A=A.concat(n?getGlyphQuads(e,o[B],d,t,r,x,B):[]),b=new CollisionFeature(s,t,e,l,y,c,o[B],d,h,x,!1))}var T=this.symbolQuadsArray.length;if(A&&A.length)for(var z=0;z<A.length;z++)S.addSymbolQuad(A[z]);var E=this.symbolQuadsArray.length,k=b?b.boxStartIndex:this.collisionBoxArray.length,P=b?b.boxEndIndex:this.collisionBoxArray.length;a&&(v=n?getIconQuads(e,a,u,t,r,p,o[WritingMode.horizontal],g,f):[],I=new CollisionFeature(s,t,e,l,y,c,a,u,m,p,!0));var L=this.symbolQuadsArray.length;v&&1===v.length&&this.addSymbolQuad(v[0]);var w=this.symbolQuadsArray.length,V=I?I.boxStartIndex:this.collisionBoxArray.length,_=I?I.boxEndIndex:this.collisionBoxArray.length;w>SymbolBucket.MAX_QUADS&&util.warnOnce("Too many symbols being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),E>SymbolBucket.MAX_QUADS&&util.warnOnce("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");var Q=(o[WritingMode.vertical]?WritingMode.vertical:0)|(o[WritingMode.horizontal]?WritingMode.horizontal:0);return this.symbolInstancesArray.emplaceBack(k,P,V,_,T,E,L,w,e.x,e.y,i,Q)},SymbolBucket.prototype.addSymbolQuad=function(e){return this.symbolQuadsArray.emplaceBack(e.anchorPoint.x,e.anchorPoint.y,e.tl.x,e.tl.y,e.tr.x,e.tr.y,e.bl.x,e.bl.y,e.br.x,e.br.y,e.tex.h,e.tex.w,e.tex.x,e.tex.y,e.anchorAngle,e.glyphAngle,e.maxScale,e.minScale,e.writingMode)},SymbolBucket.MAX_QUADS=65535,module.exports=SymbolBucket;
	},{"../../symbol/anchor":73,"../../symbol/clip_line":75,"../../symbol/collision_feature":77,"../../symbol/get_anchors":79,"../../symbol/mergelines":82,"../../symbol/quads":83,"../../symbol/resolve_text":84,"../../symbol/shaping":85,"../../util/classify_rings":111,"../../util/find_pole_of_inaccessibility":117,"../../util/script_detection":124,"../../util/token":126,"../../util/util":127,"../array_group":1,"../buffer_group":9,"../element_array_type":10,"../extent":11,"../load_geometry":13,"../vertex_array_type":17,"point-geometry":194,"vector-tile":204}],8:[function(require,module,exports){
	"use strict";var AttributeType={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT"},Buffer=function(e,t,r){this.arrayBuffer=e.arrayBuffer,this.length=e.length,this.attributes=t.members,this.itemSize=t.bytesPerElement,this.type=r,this.arrayType=t};Buffer.fromStructArray=function(e,t){return new Buffer(e.serialize(),e.constructor.serialize(),t)},Buffer.prototype.bind=function(e){var t=e[this.type];this.buffer?e.bindBuffer(t,this.buffer):(this.gl=e,this.buffer=e.createBuffer(),e.bindBuffer(t,this.buffer),e.bufferData(t,this.arrayBuffer,e.STATIC_DRAW),this.arrayBuffer=null)},Buffer.prototype.setVertexAttribPointers=function(e,t,r){for(var f=this,i=0;i<this.attributes.length;i++){var u=f.attributes[i],s=t[u.name];void 0!==s&&e.vertexAttribPointer(s,u.components,e[AttributeType[u.type]],!1,f.arrayType.bytesPerElement,u.offset+(f.arrayType.bytesPerElement*r||0))}},Buffer.prototype.destroy=function(){this.buffer&&this.gl.deleteBuffer(this.buffer)},Buffer.BufferType={VERTEX:"ARRAY_BUFFER",ELEMENT:"ELEMENT_ARRAY_BUFFER"},module.exports=Buffer;
	},{}],9:[function(require,module,exports){
	"use strict";var util=require("../util/util"),Buffer=require("./buffer"),ProgramConfiguration=require("./program_configuration"),VertexArrayObject=require("../render/vertex_array_object"),BufferGroup=function(e,r,t,a){var f=this;this.layoutVertexBuffer=new Buffer(a.layoutVertexArray,e.layoutVertexArrayType.serialize(),Buffer.BufferType.VERTEX),a.elementArray&&(this.elementBuffer=new Buffer(a.elementArray,e.elementArrayType.serialize(),Buffer.BufferType.ELEMENT)),a.elementArray2&&(this.elementBuffer2=new Buffer(a.elementArray2,e.elementArrayType2.serialize(),Buffer.BufferType.ELEMENT)),this.layerData={};for(var i=0,n=r;i<n.length;i+=1){var u=n[i],s=a.paintVertexArrays&&a.paintVertexArrays[u.id],o=ProgramConfiguration.createDynamic(e.paintAttributes||[],u,t),y=s?new Buffer(s.array,s.type,Buffer.BufferType.VERTEX):null;f.layerData[u.id]={programConfiguration:o,paintVertexBuffer:y}}this.segments=a.segments,this.segments2=a.segments2;for(var l=0,m=[this.segments,this.segments2];l<m.length;l+=1)for(var B=m[l],h=0,p=B||[];h<p.length;h+=1){var g=p[h];g.vaos=util.mapObject(f.layerData,function(){return new VertexArrayObject})}};BufferGroup.prototype.destroy=function(){var e=this;this.layoutVertexBuffer.destroy(),this.elementBuffer&&this.elementBuffer.destroy(),this.elementBuffer2&&this.elementBuffer2.destroy();for(var r in this.layerData){var t=e.layerData[r].paintVertexBuffer;t&&t.destroy()}for(var a=0,f=[this.segments,this.segments2];a<f.length;a+=1)for(var i=f[a],n=0,u=i||[];n<u.length;n+=1){var s=u[n];for(var o in s.vaos)s.vaos[o].destroy()}},module.exports=BufferGroup;
	},{"../render/vertex_array_object":39,"../util/util":127,"./buffer":8,"./program_configuration":15}],10:[function(require,module,exports){
	"use strict";function createElementArrayType(e){return createStructArrayType({members:[{type:"Uint16",name:"vertices",components:e||3}]})}var createStructArrayType=require("../util/struct_array");module.exports=createElementArrayType;
	},{"../util/struct_array":125}],11:[function(require,module,exports){
	"use strict";module.exports=8192;
	},{}],12:[function(require,module,exports){
	"use strict";function translateDistance(e){return Math.sqrt(e[0]*e[0]+e[1]*e[1])}function topDownFeatureComparator(e,t){return t-e}function getLineWidth(e){return e["line-gap-width"]>0?e["line-gap-width"]+2*e["line-width"]:e["line-width"]}function translate(e,t,r,i,n){if(!t[0]&&!t[1])return e;t=Point.convert(t),"viewport"===r&&t._rotate(-i);for(var a=[],o=0;o<e.length;o++){for(var s=e[o],l=[],u=0;u<s.length;u++)l.push(s[u].sub(t._mult(n)));a.push(l)}return a}function offsetLine(e,t){for(var r=[],i=new Point(0,0),n=0;n<e.length;n++){for(var a=e[n],o=[],s=0;s<a.length;s++){var l=a[s-1],u=a[s],c=a[s+1],y=0===s?i:u.sub(l)._unit()._perp(),f=s===a.length-1?i:c.sub(u)._unit()._perp(),d=y._add(f)._unit(),h=d.x*f.x+d.y*f.y;d._mult(1/h),o.push(d._mult(t)._add(u))}r.push(o)}return r}var Point=require("point-geometry"),loadGeometry=require("./load_geometry"),EXTENT=require("./extent"),featureFilter=require("feature-filter"),createStructArrayType=require("../util/struct_array"),Grid=require("grid-index"),DictionaryCoder=require("../util/dictionary_coder"),vt=require("vector-tile"),Protobuf=require("pbf"),GeoJSONFeature=require("../util/vectortile_to_geojson"),arraysIntersect=require("../util/util").arraysIntersect,intersection=require("../util/intersection_tests"),multiPolygonIntersectsBufferedMultiPoint=intersection.multiPolygonIntersectsBufferedMultiPoint,multiPolygonIntersectsMultiPolygon=intersection.multiPolygonIntersectsMultiPolygon,multiPolygonIntersectsBufferedMultiLine=intersection.multiPolygonIntersectsBufferedMultiLine,FeatureIndexArray=createStructArrayType({members:[{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"}]}),FeatureIndex=function(e,t,r){if(e.grid){var i=e,n=t;e=i.coord,t=i.overscaling,this.grid=new Grid(i.grid),this.featureIndexArray=new FeatureIndexArray(i.featureIndexArray),this.rawTileData=n,this.bucketLayerIDs=i.bucketLayerIDs}else this.grid=new Grid(EXTENT,16,0),this.featureIndexArray=new FeatureIndexArray;this.coord=e,this.overscaling=t,this.x=e.x,this.y=e.y,this.z=e.z-Math.log(t)/Math.LN2,this.setCollisionTile(r)};FeatureIndex.prototype.insert=function(e,t){var r=this,i=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(e.index,e.sourceLayerIndex,t);for(var n=loadGeometry(e),a=0;a<n.length;a++){for(var o=n[a],s=[1/0,1/0,-(1/0),-(1/0)],l=0;l<o.length;l++){var u=o[l];s[0]=Math.min(s[0],u.x),s[1]=Math.min(s[1],u.y),s[2]=Math.max(s[2],u.x),s[3]=Math.max(s[3],u.y)}r.grid.insert(i,s[0],s[1],s[2],s[3])}},FeatureIndex.prototype.setCollisionTile=function(e){this.collisionTile=e},FeatureIndex.prototype.serialize=function(e){var t=this.grid.toArrayBuffer();return e&&e.push(t),{coord:this.coord,overscaling:this.overscaling,grid:t,featureIndexArray:this.featureIndexArray.serialize(e),bucketLayerIDs:this.bucketLayerIDs}},FeatureIndex.prototype.query=function(e,t){this.vtLayers||(this.vtLayers=new vt.VectorTile(new Protobuf(this.rawTileData)).layers,this.sourceLayerCoder=new DictionaryCoder(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"]));var r={},i=e.params||{},n=EXTENT/e.tileSize/e.scale,a=featureFilter(i.filter),o=0;for(var s in t){var l=t[s],u=l.paint,c=0;"line"===l.type?c=getLineWidth(u)/2+Math.abs(u["line-offset"])+translateDistance(u["line-translate"]):"fill"===l.type?c=translateDistance(u["fill-translate"]):"fill-extrusion"===l.type?c=translateDistance(u["fill-extrusion-translate"]):"circle"===l.type&&(c=u["circle-radius"]+translateDistance(u["circle-translate"])),o=Math.max(o,c*n)}for(var y=e.queryGeometry.map(function(e){return e.map(function(e){return new Point(e.x,e.y)})}),f=1/0,d=1/0,h=-(1/0),g=-(1/0),p=0;p<y.length;p++)for(var v=y[p],x=0;x<v.length;x++){var I=v[x];f=Math.min(f,I.x),d=Math.min(d,I.y),h=Math.max(h,I.x),g=Math.max(g,I.y)}var m=this.grid.query(f-o,d-o,h+o,g+o);m.sort(topDownFeatureComparator),this.filterMatching(r,m,this.featureIndexArray,y,a,i.layers,t,e.bearing,n);var L=this.collisionTile.queryRenderedSymbols(y,e.scale);return L.sort(),this.filterMatching(r,L,this.collisionTile.collisionBoxArray,y,a,i.layers,t,e.bearing,n),r},FeatureIndex.prototype.filterMatching=function(e,t,r,i,n,a,o,s,l){for(var u,c=this,y=0;y<t.length;y++){var f=t[y];if(f!==u){u=f;var d=r.get(f),h=c.bucketLayerIDs[d.bucketIndex];if(!a||arraysIntersect(a,h)){var g=c.sourceLayerCoder.decode(d.sourceLayerIndex),p=c.vtLayers[g],v=p.feature(d.featureIndex);if(n(v))for(var x=null,I=0;I<h.length;I++){var m=h[I];if(!(a&&a.indexOf(m)<0)){var L=o[m];if(L){var M;if("symbol"!==L.type){x||(x=loadGeometry(v));var P=L.paint;if("line"===L.type){M=translate(i,P["line-translate"],P["line-translate-anchor"],s,l);var b=getLineWidth(P)/2*l;if(P["line-offset"]&&(x=offsetLine(x,P["line-offset"]*l)),!multiPolygonIntersectsBufferedMultiLine(M,x,b))continue}else if("fill"===L.type||"fill-extrusion"===L.type){var w=L.type;if(M=translate(i,P[w+"-translate"],P[w+"-translate-anchor"],s,l),!multiPolygonIntersectsMultiPolygon(M,x))continue}else if("circle"===L.type){M=translate(i,P["circle-translate"],P["circle-translate-anchor"],s,l);var _=P["circle-radius"]*l;if(!multiPolygonIntersectsBufferedMultiPoint(M,x,_))continue}}var q=new GeoJSONFeature(v,c.z,c.x,c.y);q.layer=L.serialize();var T=e[m];void 0===T&&(T=e[m]=[]),T.push(q)}}}}}}},module.exports=FeatureIndex;
	},{"../util/dictionary_coder":113,"../util/intersection_tests":120,"../util/struct_array":125,"../util/util":127,"../util/vectortile_to_geojson":128,"./extent":11,"./load_geometry":13,"feature-filter":135,"grid-index":146,"pbf":193,"point-geometry":194,"vector-tile":204}],13:[function(require,module,exports){
	"use strict";function createBounds(e){return{min:-1*Math.pow(2,e-1),max:Math.pow(2,e-1)-1}}var util=require("../util/util"),EXTENT=require("./extent"),boundsLookup={15:createBounds(15),16:createBounds(16)};module.exports=function(e,t){for(var r=boundsLookup[t||16],o=EXTENT/e.extent,u=e.loadGeometry(),n=0;n<u.length;n++)for(var a=u[n],i=0;i<a.length;i++){var d=a[i];d.x=Math.round(d.x*o),d.y=Math.round(d.y*o),(d.x<r.min||d.x>r.max||d.y<r.min||d.y>r.max)&&util.warnOnce("Geometry exceeds allowed extent, reduce your vector tile buffer size")}return u};
	},{"../util/util":127,"./extent":11}],14:[function(require,module,exports){
	"use strict";var createStructArrayType=require("../util/struct_array"),PosArray=createStructArrayType({members:[{name:"a_pos",type:"Int16",components:2}]});module.exports=PosArray;
	},{"../util/struct_array":125}],15:[function(require,module,exports){
	"use strict";function getPaintAttributeValue(t,e,r,i){if(!t.zoomStops)return e.getPaintValue(t.property,r,i);var a=t.zoomStops.map(function(a){return e.getPaintValue(t.property,util.extend({},r,{zoom:a}),i)});return 1===a.length?a[0]:a}function normalizePaintAttribute(t,e){var r=t.property.replace(e.type+"-","").replace(/-/g,"_"),i="color"===e._paintSpecifications[t.property].type;return util.extend({name:"a_"+r,components:i?4:1,multiplier:i?255:1},t)}var createVertexArrayType=require("./vertex_array_type"),util=require("../util/util"),ProgramConfiguration=function(){this.attributes=[],this.uniforms=[],this.interpolationUniforms=[],this.pragmas={vertex:{},fragment:{}},this.cacheKey=""};ProgramConfiguration.createDynamic=function(t,e,r){for(var i=new ProgramConfiguration,a=0,n=t;a<n.length;a+=1){var o=n[a],p=normalizePaintAttribute(o,e),u=p.name.slice(2);e.isPaintValueFeatureConstant(p.property)?i.addZoomAttribute(u,p):e.isPaintValueZoomConstant(p.property)?i.addPropertyAttribute(u,p):i.addZoomAndPropertyAttribute(u,p,e,r)}return i.PaintVertexArray=createVertexArrayType(i.attributes),i},ProgramConfiguration.createStatic=function(t){for(var e=new ProgramConfiguration,r=0,i=t;r<i.length;r+=1){var a=i[r];e.addUniform(a,"u_"+a)}return e},ProgramConfiguration.prototype.addUniform=function(t,e){var r=this.getPragmas(t);r.define.push("uniform {precision} {type} "+e+";"),r.initialize.push("{precision} {type} "+t+" = "+e+";"),this.cacheKey+="/u_"+t},ProgramConfiguration.prototype.addZoomAttribute=function(t,e){this.uniforms.push(e),this.addUniform(t,e.name)},ProgramConfiguration.prototype.addPropertyAttribute=function(t,e){var r=this.getPragmas(t);this.attributes.push(e),r.define.push("varying {precision} {type} "+t+";"),r.vertex.define.push("attribute {precision} {type} "+e.name+";"),r.vertex.initialize.push(t+" = "+e.name+" / "+e.multiplier+".0;"),this.cacheKey+="/a_"+t},ProgramConfiguration.prototype.addZoomAndPropertyAttribute=function(t,e,r,i){var a=this,n=this.getPragmas(t);n.define.push("varying {precision} {type} "+t+";");for(var o=0,p=r.getPaintValueStopZoomLevels(e.property);o<p.length&&p[o]<i;)o++;var u=Math.max(0,Math.min(p.length-4,o-2)),s="u_"+t+"_t";n.vertex.define.push("uniform lowp float "+s+";"),this.interpolationUniforms.push({name:s,property:e.property,stopOffset:u});for(var m=[],f=0;f<4;f++)m.push(p[Math.min(u+f,p.length-1)]);var g=[];if(1===e.components)this.attributes.push(util.extend({},e,{components:4,zoomStops:m})),n.vertex.define.push("attribute {precision} vec4 "+e.name+";"),g.push(e.name);else for(var h=0;h<4;h++){var l=e.name+h;g.push(l),a.attributes.push(util.extend({},e,{name:l,zoomStops:[m[h]]})),n.vertex.define.push("attribute {precision} {type} "+l+";")}n.vertex.initialize.push(t+" = evaluate_zoom_function_"+e.components+"(            "+g.join(", ")+", "+s+") / "+e.multiplier+".0;"),this.cacheKey+="/z_"+t},ProgramConfiguration.prototype.getPragmas=function(t){return this.pragmas[t]||(this.pragmas[t]={define:[],initialize:[]},this.pragmas[t].fragment={define:[],initialize:[]},this.pragmas[t].vertex={define:[],initialize:[]}),this.pragmas[t]},ProgramConfiguration.prototype.applyPragmas=function(t,e){var r=this;return t.replace(/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,function(t,i,a,n,o){return r.pragmas[o][i].concat(r.pragmas[o][e][i]).join("\n").replace(/{type}/g,n).replace(/{precision}/g,a)})},ProgramConfiguration.prototype.populatePaintArray=function(t,e,r,i,a){var n=e.length;e.resize(r);for(var o=0,p=this.attributes;o<p.length;o+=1)for(var u=p[o],s=getPaintAttributeValue(u,t,i,a),m=n;m<r;m++){var f=e.get(m);if(4===u.components)for(var g=0;g<4;g++)f[u.name+g]=s[g]*u.multiplier;else f[u.name]=s*u.multiplier}},ProgramConfiguration.prototype.setUniforms=function(t,e,r,i){for(var a=0,n=this.uniforms;a<n.length;a+=1){var o=n[a],p=r.getPaintValue(o.property,i);4===o.components?t.uniform4fv(e[o.name],p):t.uniform1f(e[o.name],p)}for(var u=0,s=this.interpolationUniforms;u<s.length;u+=1){var m=s[u],f=r.getPaintInterpolationT(m.property,i);t.uniform1f(e[m.name],Math.max(0,Math.min(4,f-m.stopOffset)))}},module.exports=ProgramConfiguration;
	},{"../util/util":127,"./vertex_array_type":17}],16:[function(require,module,exports){
	"use strict";var createStructArrayType=require("../util/struct_array"),RasterBoundsArray=createStructArrayType({members:[{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]});module.exports=RasterBoundsArray;
	},{"../util/struct_array":125}],17:[function(require,module,exports){
	"use strict";function createVertexArrayType(r){return createStructArrayType({members:r,alignment:4})}var createStructArrayType=require("../util/struct_array");module.exports=createVertexArrayType;
	},{"../util/struct_array":125}],18:[function(require,module,exports){
	"use strict";var Coordinate=function(o,t,n){this.column=o,this.row=t,this.zoom=n};Coordinate.prototype.clone=function(){return new Coordinate(this.column,this.row,this.zoom)},Coordinate.prototype.zoomTo=function(o){return this.clone()._zoomTo(o)},Coordinate.prototype.sub=function(o){return this.clone()._sub(o)},Coordinate.prototype._zoomTo=function(o){var t=Math.pow(2,o-this.zoom);return this.column*=t,this.row*=t,this.zoom=o,this},Coordinate.prototype._sub=function(o){return o=o.zoomTo(this.zoom),this.column-=o.column,this.row-=o.row,this},module.exports=Coordinate;
	},{}],19:[function(require,module,exports){
	"use strict";var wrap=require("../util/util").wrap,LngLat=function(t,n){if(isNaN(t)||isNaN(n))throw new Error("Invalid LngLat object: ("+t+", "+n+")");if(this.lng=+t,this.lat=+n,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};LngLat.prototype.wrap=function(){return new LngLat(wrap(this.lng,-180,180),this.lat)},LngLat.prototype.toArray=function(){return[this.lng,this.lat]},LngLat.prototype.toString=function(){return"LngLat("+this.lng+", "+this.lat+")"},LngLat.convert=function(t){if(t instanceof LngLat)return t;if(t&&t.hasOwnProperty("lng")&&t.hasOwnProperty("lat"))return new LngLat(t.lng,t.lat);if(Array.isArray(t)&&2===t.length)return new LngLat(t[0],t[1]);throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")},module.exports=LngLat;
	},{"../util/util":127}],20:[function(require,module,exports){
	"use strict";var LngLat=require("./lng_lat"),LngLatBounds=function(t,n){t&&(n?this.setSouthWest(t).setNorthEast(n):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]))};LngLatBounds.prototype.setNorthEast=function(t){return this._ne=LngLat.convert(t),this},LngLatBounds.prototype.setSouthWest=function(t){return this._sw=LngLat.convert(t),this},LngLatBounds.prototype.extend=function(t){var n,e,s=this._sw,o=this._ne;if(t instanceof LngLat)n=t,e=t;else{if(!(t instanceof LngLatBounds))return Array.isArray(t)?t.every(Array.isArray)?this.extend(LngLatBounds.convert(t)):this.extend(LngLat.convert(t)):this;if(n=t._sw,e=t._ne,!n||!e)return this}return s||o?(s.lng=Math.min(n.lng,s.lng),s.lat=Math.min(n.lat,s.lat),o.lng=Math.max(e.lng,o.lng),o.lat=Math.max(e.lat,o.lat)):(this._sw=new LngLat(n.lng,n.lat),this._ne=new LngLat(e.lng,e.lat)),this},LngLatBounds.prototype.getCenter=function(){return new LngLat((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},LngLatBounds.prototype.getSouthWest=function(){return this._sw},LngLatBounds.prototype.getNorthEast=function(){return this._ne},LngLatBounds.prototype.getNorthWest=function(){return new LngLat(this.getWest(),this.getNorth())},LngLatBounds.prototype.getSouthEast=function(){return new LngLat(this.getEast(),this.getSouth())},LngLatBounds.prototype.getWest=function(){return this._sw.lng},LngLatBounds.prototype.getSouth=function(){return this._sw.lat},LngLatBounds.prototype.getEast=function(){return this._ne.lng},LngLatBounds.prototype.getNorth=function(){return this._ne.lat},LngLatBounds.prototype.toArray=function(){return[this._sw.toArray(),this._ne.toArray()]},LngLatBounds.prototype.toString=function(){return"LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},LngLatBounds.convert=function(t){return!t||t instanceof LngLatBounds?t:new LngLatBounds(t)},module.exports=LngLatBounds;
	},{"./lng_lat":19}],21:[function(require,module,exports){
	"use strict";var LngLat=require("./lng_lat"),Point=require("point-geometry"),Coordinate=require("./coordinate"),util=require("../util/util"),interp=require("../util/interpolate"),TileCoord=require("../source/tile_coord"),EXTENT=require("../data/extent"),glmatrix=require("@mapbox/gl-matrix"),vec4=glmatrix.vec4,mat4=glmatrix.mat4,mat2=glmatrix.mat2,Transform=function(t,i){this.tileSize=512,this._minZoom=t||0,this._maxZoom=i||22,this.latRange=[-85.05113,85.05113],this.width=0,this.height=0,this._center=new LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0},prototypeAccessors={minZoom:{},maxZoom:{},worldSize:{},centerPoint:{},size:{},bearing:{},pitch:{},fov:{},zoom:{},center:{},unmodified:{},x:{},y:{},point:{}};prototypeAccessors.minZoom.get=function(){return this._minZoom},prototypeAccessors.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t))},prototypeAccessors.maxZoom.get=function(){return this._maxZoom},prototypeAccessors.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t))},prototypeAccessors.worldSize.get=function(){return this.tileSize*this.scale},prototypeAccessors.centerPoint.get=function(){return this.size._div(2)},prototypeAccessors.size.get=function(){return new Point(this.width,this.height)},prototypeAccessors.bearing.get=function(){return-this.angle/Math.PI*180},prototypeAccessors.bearing.set=function(t){var i=-util.wrap(t,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=mat2.create(),mat2.rotate(this.rotationMatrix,this.rotationMatrix,this.angle))},prototypeAccessors.pitch.get=function(){return this._pitch/Math.PI*180},prototypeAccessors.pitch.set=function(t){var i=util.clamp(t,0,60)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices())},prototypeAccessors.fov.get=function(){return this._fov/Math.PI*180},prototypeAccessors.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices())},prototypeAccessors.zoom.get=function(){return this._zoom},prototypeAccessors.zoom.set=function(t){var i=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==i&&(this._unmodified=!1,this._zoom=i,this.scale=this.zoomScale(i),this.tileZoom=Math.floor(i),this.zoomFraction=i-this.tileZoom,this._constrain(),this._calcMatrices())},prototypeAccessors.center.get=function(){return this._center},prototypeAccessors.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices())},Transform.prototype.coveringZoomLevel=function(t){return(t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize))},Transform.prototype.coveringTiles=function(t){var i=this.coveringZoomLevel(t),o=i;if(i<t.minzoom)return[];i>t.maxzoom&&(i=t.maxzoom);var e=this.pointCoordinate(this.centerPoint,i),r=new Point(e.column-.5,e.row-.5),n=[this.pointCoordinate(new Point(0,0),i),this.pointCoordinate(new Point(this.width,0),i),this.pointCoordinate(new Point(this.width,this.height),i),this.pointCoordinate(new Point(0,this.height),i)];return TileCoord.cover(i,n,t.reparseOverscaled?o:i).sort(function(t,i){return r.dist(t)-r.dist(i)})},Transform.prototype.resize=function(t,i){this.width=t,this.height=i,this.pixelsToGLUnits=[2/t,-2/i],this._constrain(),this._calcMatrices()},prototypeAccessors.unmodified.get=function(){return this._unmodified},Transform.prototype.zoomScale=function(t){return Math.pow(2,t)},Transform.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},Transform.prototype.project=function(t){return new Point(this.lngX(t.lng),this.latY(t.lat))},Transform.prototype.unproject=function(t){return new LngLat(this.xLng(t.x),this.yLat(t.y))},prototypeAccessors.x.get=function(){return this.lngX(this.center.lng)},prototypeAccessors.y.get=function(){return this.latY(this.center.lat)},prototypeAccessors.point.get=function(){return new Point(this.x,this.y)},Transform.prototype.lngX=function(t){return(180+t)*this.worldSize/360},Transform.prototype.latY=function(t){var i=180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360));return(180-i)*this.worldSize/360},Transform.prototype.xLng=function(t){return 360*t/this.worldSize-180},Transform.prototype.yLat=function(t){var i=180-360*t/this.worldSize;return 360/Math.PI*Math.atan(Math.exp(i*Math.PI/180))-90},Transform.prototype.setLocationAtPoint=function(t,i){var o=this.pointCoordinate(i)._sub(this.pointCoordinate(this.centerPoint));this.center=this.coordinateLocation(this.locationCoordinate(t)._sub(o))},Transform.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},Transform.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},Transform.prototype.locationCoordinate=function(t){return new Coordinate(this.lngX(t.lng)/this.tileSize,this.latY(t.lat)/this.tileSize,this.zoom).zoomTo(this.tileZoom)},Transform.prototype.coordinateLocation=function(t){var i=t.zoomTo(this.zoom);return new LngLat(this.xLng(i.column*this.tileSize),this.yLat(i.row*this.tileSize))},Transform.prototype.pointCoordinate=function(t,i){void 0===i&&(i=this.tileZoom);var o=0,e=[t.x,t.y,0,1],r=[t.x,t.y,1,1];vec4.transformMat4(e,e,this.pixelMatrixInverse),vec4.transformMat4(r,r,this.pixelMatrixInverse);var n=e[3],s=r[3],a=e[0]/n,h=r[0]/s,c=e[1]/n,m=r[1]/s,p=e[2]/n,l=r[2]/s,u=p===l?0:(o-p)/(l-p);return new Coordinate(interp(a,h,u)/this.tileSize,interp(c,m,u)/this.tileSize,this.zoom)._zoomTo(i)},Transform.prototype.coordinatePoint=function(t){var i=t.zoomTo(this.zoom),o=[i.column*this.tileSize,i.row*this.tileSize,0,1];return vec4.transformMat4(o,o,this.pixelMatrix),new Point(o[0]/o[3],o[1]/o[3])},Transform.prototype.calculatePosMatrix=function(t,i){var o=t.toCoordinate(i),e=this.worldSize/this.zoomScale(o.zoom),r=mat4.identity(new Float64Array(16));return mat4.translate(r,r,[o.column*e,o.row*e,0]),mat4.scale(r,r,[e/EXTENT,e/EXTENT,1]),mat4.multiply(r,this.projMatrix,r),new Float32Array(r)},Transform.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var t,i,o,e,r,n,s,a,h=this.size,c=this._unmodified;this.latRange&&(t=this.latY(this.latRange[1]),i=this.latY(this.latRange[0]),r=i-t<h.y?h.y/(i-t):0),this.lngRange&&(o=this.lngX(this.lngRange[0]),e=this.lngX(this.lngRange[1]),n=e-o<h.x?h.x/(e-o):0);var m=Math.max(n||0,r||0);if(m)return this.center=this.unproject(new Point(n?(e+o)/2:this.x,r?(i+t)/2:this.y)),this.zoom+=this.scaleZoom(m),this._unmodified=c,void(this._constraining=!1);if(this.latRange){var p=this.y,l=h.y/2;p-l<t&&(a=t+l),p+l>i&&(a=i-l)}if(this.lngRange){var u=this.x,f=h.x/2;u-f<o&&(s=o+f),u+f>e&&(s=e-f)}void 0===s&&void 0===a||(this.center=this.unproject(new Point(void 0!==s?s:this.x,void 0!==a?a:this.y))),this._unmodified=c,this._constraining=!1}},Transform.prototype._calcMatrices=function(){if(this.height){this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var t=this._fov/2,i=Math.PI/2+this._pitch,o=Math.sin(t)*this.cameraToCenterDistance/Math.sin(Math.PI-i-t),e=Math.cos(Math.PI/2-this._pitch)*o+this.cameraToCenterDistance,r=1.01*e,n=new Float64Array(16);mat4.perspective(n,this._fov,this.width/this.height,1,r),mat4.scale(n,n,[1,-1,1]),mat4.translate(n,n,[0,0,-this.cameraToCenterDistance]),mat4.rotateX(n,n,this._pitch),mat4.rotateZ(n,n,this.angle),mat4.translate(n,n,[-this.x,-this.y,0]);var s=this.worldSize/(2*Math.PI*6378137*Math.abs(Math.cos(this.center.lat*(Math.PI/180))));if(mat4.scale(n,n,[1,1,s,1]),this.projMatrix=n,n=mat4.create(),mat4.scale(n,n,[this.width/2,-this.height/2,1]),mat4.translate(n,n,[1,-1,0]),this.pixelMatrix=mat4.multiply(new Float64Array(16),n,this.projMatrix),n=mat4.invert(new Float64Array(16),this.pixelMatrix),!n)throw new Error("failed to invert matrix");this.pixelMatrixInverse=n}},Object.defineProperties(Transform.prototype,prototypeAccessors),module.exports=Transform;
	},{"../data/extent":11,"../source/tile_coord":51,"../util/interpolate":119,"../util/util":127,"./coordinate":18,"./lng_lat":19,"@mapbox/gl-matrix":131,"point-geometry":194}],22:[function(require,module,exports){
	"use strict";var WorkerPool=require("./util/worker_pool"),globalWorkerPool;module.exports=function(){return globalWorkerPool||(globalWorkerPool=new WorkerPool),globalWorkerPool};
	},{"./util/worker_pool":130}],23:[function(require,module,exports){
	"use strict";var simplexFont={" ":[16,[]],"!":[10,[5,21,5,7,-1,-1,5,2,4,1,5,0,6,1,5,2]],'"':[16,[4,21,4,14,-1,-1,12,21,12,14]],"#":[21,[11,25,4,-7,-1,-1,17,25,10,-7,-1,-1,4,12,18,12,-1,-1,3,6,17,6]],$:[20,[8,25,8,-4,-1,-1,12,25,12,-4,-1,-1,17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],"%":[24,[21,21,3,0,-1,-1,8,21,10,19,10,17,9,15,7,14,5,14,3,16,3,18,4,20,6,21,8,21,10,20,13,19,16,19,19,20,21,21,-1,-1,17,7,15,6,14,4,14,2,16,0,18,0,20,1,21,3,21,5,19,7,17,7]],"&":[26,[23,12,23,13,22,14,21,14,20,13,19,11,17,6,15,3,13,1,11,0,7,0,5,1,4,2,3,4,3,6,4,8,5,9,12,13,13,14,14,16,14,18,13,20,11,21,9,20,8,18,8,16,9,13,11,10,16,3,18,1,20,0,22,0,23,1,23,2]],"'":[10,[5,19,4,20,5,21,6,20,6,18,5,16,4,15]],"(":[14,[11,25,9,23,7,20,5,16,4,11,4,7,5,2,7,-2,9,-5,11,-7]],")":[14,[3,25,5,23,7,20,9,16,10,11,10,7,9,2,7,-2,5,-5,3,-7]],"*":[16,[8,21,8,9,-1,-1,3,18,13,12,-1,-1,13,18,3,12]],"+":[26,[13,18,13,0,-1,-1,4,9,22,9]],",":[10,[6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"-":[26,[4,9,22,9]],".":[10,[5,2,4,1,5,0,6,1,5,2]],"/":[22,[20,25,2,-7]],0:[20,[9,21,6,20,4,17,3,12,3,9,4,4,6,1,9,0,11,0,14,1,16,4,17,9,17,12,16,17,14,20,11,21,9,21]],1:[20,[6,17,8,18,11,21,11,0]],2:[20,[4,16,4,17,5,19,6,20,8,21,12,21,14,20,15,19,16,17,16,15,15,13,13,10,3,0,17,0]],3:[20,[5,21,16,21,10,13,13,13,15,12,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],4:[20,[13,21,3,7,18,7,-1,-1,13,21,13,0]],5:[20,[15,21,5,21,4,12,5,13,8,14,11,14,14,13,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],6:[20,[16,18,15,20,12,21,10,21,7,20,5,17,4,12,4,7,5,3,7,1,10,0,11,0,14,1,16,3,17,6,17,7,16,10,14,12,11,13,10,13,7,12,5,10,4,7]],7:[20,[17,21,7,0,-1,-1,3,21,17,21]],8:[20,[8,21,5,20,4,18,4,16,5,14,7,13,11,12,14,11,16,9,17,7,17,4,16,2,15,1,12,0,8,0,5,1,4,2,3,4,3,7,4,9,6,11,9,12,13,13,15,14,16,16,16,18,15,20,12,21,8,21]],9:[20,[16,14,15,11,13,9,10,8,9,8,6,9,4,11,3,14,3,15,4,18,6,20,9,21,10,21,13,20,15,18,16,14,16,9,15,4,13,1,10,0,8,0,5,1,4,3]],":":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,5,2,4,1,5,0,6,1,5,2]],";":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"<":[24,[20,18,4,9,20,0]],"=":[26,[4,12,22,12,-1,-1,4,6,22,6]],">":[24,[4,18,20,9,4,0]],"?":[18,[3,16,3,17,4,19,5,20,7,21,11,21,13,20,14,19,15,17,15,15,14,13,13,12,9,10,9,7,-1,-1,9,2,8,1,9,0,10,1,9,2]],"@":[27,[18,13,17,15,15,16,12,16,10,15,9,14,8,11,8,8,9,6,11,5,14,5,16,6,17,8,-1,-1,12,16,10,14,9,11,9,8,10,6,11,5,-1,-1,18,16,17,8,17,6,19,5,21,5,23,7,24,10,24,12,23,15,22,17,20,19,18,20,15,21,12,21,9,20,7,19,5,17,4,15,3,12,3,9,4,6,5,4,7,2,9,1,12,0,15,0,18,1,20,2,21,3,-1,-1,19,16,18,8,18,6,19,5]],A:[18,[9,21,1,0,-1,-1,9,21,17,0,-1,-1,4,7,14,7]],B:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,-1,-1,4,11,13,11,16,10,17,9,18,7,18,4,17,2,16,1,13,0,4,0]],C:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5]],D:[21,[4,21,4,0,-1,-1,4,21,11,21,14,20,16,18,17,16,18,13,18,8,17,5,16,3,14,1,11,0,4,0]],E:[19,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11,-1,-1,4,0,17,0]],F:[18,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11]],G:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,18,8,-1,-1,13,8,18,8]],H:[22,[4,21,4,0,-1,-1,18,21,18,0,-1,-1,4,11,18,11]],I:[8,[4,21,4,0]],J:[16,[12,21,12,5,11,2,10,1,8,0,6,0,4,1,3,2,2,5,2,7]],K:[21,[4,21,4,0,-1,-1,18,21,4,7,-1,-1,9,12,18,0]],L:[17,[4,21,4,0,-1,-1,4,0,16,0]],M:[24,[4,21,4,0,-1,-1,4,21,12,0,-1,-1,20,21,12,0,-1,-1,20,21,20,0]],N:[22,[4,21,4,0,-1,-1,4,21,18,0,-1,-1,18,21,18,0]],O:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21]],P:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,14,17,12,16,11,13,10,4,10]],Q:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21,-1,-1,12,4,18,-2]],R:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,4,11,-1,-1,11,11,18,0]],S:[20,[17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],T:[16,[8,21,8,0,-1,-1,1,21,15,21]],U:[22,[4,21,4,6,5,3,7,1,10,0,12,0,15,1,17,3,18,6,18,21]],V:[18,[1,21,9,0,-1,-1,17,21,9,0]],W:[24,[2,21,7,0,-1,-1,12,21,7,0,-1,-1,12,21,17,0,-1,-1,22,21,17,0]],X:[20,[3,21,17,0,-1,-1,17,21,3,0]],Y:[18,[1,21,9,11,9,0,-1,-1,17,21,9,11]],Z:[20,[17,21,3,0,-1,-1,3,21,17,21,-1,-1,3,0,17,0]],"[":[14,[4,25,4,-7,-1,-1,5,25,5,-7,-1,-1,4,25,11,25,-1,-1,4,-7,11,-7]],"\\":[14,[0,21,14,-3]],"]":[14,[9,25,9,-7,-1,-1,10,25,10,-7,-1,-1,3,25,10,25,-1,-1,3,-7,10,-7]],"^":[16,[6,15,8,18,10,15,-1,-1,3,12,8,17,13,12,-1,-1,8,17,8,0]],_:[16,[0,-2,16,-2]],"`":[10,[6,21,5,20,4,18,4,16,5,15,6,16,5,17]],a:[19,[15,14,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],b:[19,[4,21,4,0,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],c:[18,[15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],d:[19,[15,21,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],e:[18,[3,8,15,8,15,10,14,12,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],f:[12,[10,21,8,21,6,20,5,17,5,0,-1,-1,2,14,9,14]],g:[19,[15,14,15,-2,14,-5,13,-6,11,-7,8,-7,6,-6,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],h:[19,[4,21,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],i:[8,[3,21,4,20,5,21,4,22,3,21,-1,-1,4,14,4,0]],j:[10,[5,21,6,20,7,21,6,22,5,21,-1,-1,6,14,6,-3,5,-6,3,-7,1,-7]],k:[17,[4,21,4,0,-1,-1,14,14,4,4,-1,-1,8,8,15,0]],l:[8,[4,21,4,0]],m:[30,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0,-1,-1,15,10,18,13,20,14,23,14,25,13,26,10,26,0]],n:[19,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],o:[19,[8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3,16,6,16,8,15,11,13,13,11,14,8,14]],p:[19,[4,14,4,-7,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],q:[19,[15,14,15,-7,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],r:[13,[4,14,4,0,-1,-1,4,8,5,11,7,13,9,14,12,14]],s:[17,[14,11,13,13,10,14,7,14,4,13,3,11,4,9,6,8,11,7,13,6,14,4,14,3,13,1,10,0,7,0,4,1,3,3]],t:[12,[5,21,5,4,6,1,8,0,10,0,-1,-1,2,14,9,14]],u:[19,[4,14,4,4,5,1,7,0,10,0,12,1,15,4,-1,-1,15,14,15,0]],v:[16,[2,14,8,0,-1,-1,14,14,8,0]],w:[22,[3,14,7,0,-1,-1,11,14,7,0,-1,-1,11,14,15,0,-1,-1,19,14,15,0]],x:[17,[3,14,14,0,-1,-1,14,14,3,0]],y:[16,[2,14,8,0,-1,-1,14,14,8,0,6,-4,4,-6,2,-7,1,-7]],z:[17,[14,14,3,0,-1,-1,3,14,14,14,-1,-1,3,0,14,0]],"{":[14,[9,25,7,24,6,23,5,21,5,19,6,17,7,16,8,14,8,12,6,10,-1,-1,7,24,6,22,6,20,7,18,8,17,9,15,9,13,8,11,4,9,8,7,9,5,9,3,8,1,7,0,6,-2,6,-4,7,-6,-1,-1,6,8,8,6,8,4,7,2,6,1,5,-1,5,-3,6,-5,7,-6,9,-7]],"|":[8,[4,25,4,-7]],"}":[14,[5,25,7,24,8,23,9,21,9,19,8,17,7,16,6,14,6,12,8,10,-1,-1,7,24,8,22,8,20,7,18,6,17,5,15,5,13,6,11,10,9,6,7,5,5,5,3,6,1,7,0,8,-2,8,-4,7,-6,-1,-1,8,8,6,6,6,4,7,2,8,1,9,-1,9,-3,8,-5,7,-6,5,-7]],"~":[24,[3,6,3,8,4,11,6,12,8,12,10,11,14,8,16,7,18,7,20,8,21,10,-1,-1,3,8,4,10,6,11,8,11,10,10,14,7,16,6,18,6,20,7,21,10,21,12]]};module.exports=function(l,n,t,e){e=e||1;var r,o,u,s,i,x,f,p,h=[];for(r=0,o=l.length;r<o;r++)if(i=simplexFont[l[r]]){for(p=null,u=0,s=i[1].length;u<s;u+=2)i[1][u]===-1&&i[1][u+1]===-1?p=null:(x=n+i[1][u]*e,f=t-i[1][u+1]*e,p&&h.push(p.x,p.y,x,f),p={x:x,y:f});n+=i[0]*e}return h};
	},{}],24:[function(require,module,exports){
	"use strict";var browser=require("./util/browser"),mapboxgl=module.exports={};mapboxgl.version=require("../package.json").version,mapboxgl.workerCount=Math.max(Math.floor(browser.hardwareConcurrency/2),1),mapboxgl.Map=require("./ui/map"),mapboxgl.NavigationControl=require("./ui/control/navigation_control"),mapboxgl.GeolocateControl=require("./ui/control/geolocate_control"),mapboxgl.AttributionControl=require("./ui/control/attribution_control"),mapboxgl.ScaleControl=require("./ui/control/scale_control"),mapboxgl.Popup=require("./ui/popup"),mapboxgl.Marker=require("./ui/marker"),mapboxgl.Style=require("./style/style"),mapboxgl.LngLat=require("./geo/lng_lat"),mapboxgl.LngLatBounds=require("./geo/lng_lat_bounds"),mapboxgl.Point=require("point-geometry"),mapboxgl.Evented=require("./util/evented"),mapboxgl.util=require("./util/util"),mapboxgl.supported=require("./util/browser").supported;var ajax=require("./util/ajax");mapboxgl.util.getJSON=ajax.getJSON,mapboxgl.util.getArrayBuffer=ajax.getArrayBuffer;var config=require("./util/config");mapboxgl.config=config,Object.defineProperty(mapboxgl,"accessToken",{get:function(){return config.ACCESS_TOKEN},set:function(r){config.ACCESS_TOKEN=r}});
	},{"../package.json":214,"./geo/lng_lat":19,"./geo/lng_lat_bounds":20,"./style/style":61,"./ui/control/attribution_control":91,"./ui/control/geolocate_control":92,"./ui/control/navigation_control":93,"./ui/control/scale_control":94,"./ui/map":103,"./ui/marker":104,"./ui/popup":105,"./util/ajax":107,"./util/browser":108,"./util/config":112,"./util/evented":116,"./util/util":127,"point-geometry":194}],25:[function(require,module,exports){
	"use strict";function drawBackground(r,t,e){var a=r.gl,i=r.transform,n=i.tileSize,o=e.paint["background-color"],l=e.paint["background-pattern"],u=e.paint["background-opacity"],f=!l&&1===o[3]&&1===u;if(r.isOpaquePass===f){a.disable(a.STENCIL_TEST),r.setDepthSublayer(0);var s;l?(s=r.useProgram("fillPattern",r.basicFillProgramConfiguration),pattern.prepare(l,r,s),r.tileExtentPatternVAO.bind(a,s,r.tileExtentBuffer)):(s=r.useProgram("fill",r.basicFillProgramConfiguration),a.uniform4fv(s.u_color,o),r.tileExtentVAO.bind(a,s,r.tileExtentBuffer)),a.uniform1f(s.u_opacity,u);for(var c=i.coveringTiles({tileSize:n}),g=0,p=c;g<p.length;g+=1){var d=p[g];l&&pattern.setTile({coord:d,tileSize:n},r,s),a.uniformMatrix4fv(s.u_matrix,!1,r.transform.calculatePosMatrix(d)),a.drawArrays(a.TRIANGLE_STRIP,0,r.tileExtentBuffer.length)}}}var pattern=require("./pattern");module.exports=drawBackground;
	},{"./pattern":37}],26:[function(require,module,exports){
	"use strict";function drawCircles(e,r,t,a){if(!e.isOpaquePass){var i=e.gl;e.setDepthSublayer(0),e.depthMask(!1),i.disable(i.STENCIL_TEST);for(var s=0;s<a.length;s++){var o=a[s],n=r.getTile(o),f=n.getBucket(t);if(f){var l=f.buffers,m=l.layerData[t.id],u=m.programConfiguration,c=e.useProgram("circle",u);u.setUniforms(i,c,t,{zoom:e.transform.zoom}),"map"===t.paint["circle-pitch-scale"]?(i.uniform1i(c.u_scale_with_map,!0),i.uniform2f(c.u_extrude_scale,e.transform.pixelsToGLUnits[0]*e.transform.cameraToCenterDistance,e.transform.pixelsToGLUnits[1]*e.transform.cameraToCenterDistance)):(i.uniform1i(c.u_scale_with_map,!1),i.uniform2fv(c.u_extrude_scale,e.transform.pixelsToGLUnits)),i.uniform1f(c.u_devicepixelratio,browser.devicePixelRatio),i.uniformMatrix4fv(c.u_matrix,!1,e.translatePosMatrix(o.posMatrix,n,t.paint["circle-translate"],t.paint["circle-translate-anchor"]));for(var p=0,v=l.segments;p<v.length;p+=1){var x=v[p];x.vaos[t.id].bind(i,c,l.layoutVertexBuffer,l.elementBuffer,m.paintVertexBuffer,x.vertexOffset),i.drawElements(i.TRIANGLES,3*x.primitiveLength,i.UNSIGNED_SHORT,3*x.primitiveOffset*2)}}}}}var browser=require("../util/browser");module.exports=drawCircles;
	},{"../util/browser":108}],27:[function(require,module,exports){
	"use strict";function drawCollisionDebug(e,o,r,i){var t=e.gl;t.enable(t.STENCIL_TEST);for(var f=e.useProgram("collisionBox"),l=0;l<i.length;l++){var n=i[l],a=o.getTile(n),s=a.getBucket(r);if(s){var u=s.buffers.collisionBox;if(u){t.uniformMatrix4fv(f.u_matrix,!1,n.posMatrix),e.enableTileClippingMask(n),e.lineWidth(1),t.uniform1f(f.u_scale,Math.pow(2,e.transform.zoom-a.coord.z)),t.uniform1f(f.u_zoom,10*e.transform.zoom),t.uniform1f(f.u_maxzoom,10*(a.coord.z+1));for(var m=0,g=u.segments;m<g.length;m+=1){var v=g[m];v.vaos[r.id].bind(t,f,u.layoutVertexBuffer,u.elementBuffer,null,v.vertexOffset),t.drawElements(t.LINES,2*v.primitiveLength,t.UNSIGNED_SHORT,2*v.primitiveOffset*2)}}}}}module.exports=drawCollisionDebug;
	},{}],28:[function(require,module,exports){
	"use strict";function drawDebug(r,e,a){for(var t=0;t<a.length;t++)drawDebugTile(r,e,a[t])}function drawDebugTile(r,e,a){var t=r.gl;t.disable(t.STENCIL_TEST),r.lineWidth(1*browser.devicePixelRatio);var i=a.posMatrix,u=r.useProgram("debug");t.uniformMatrix4fv(u.u_matrix,!1,i),t.uniform4f(u.u_color,1,0,0,1),r.debugVAO.bind(t,u,r.debugBuffer),t.drawArrays(t.LINE_STRIP,0,r.debugBuffer.length);for(var o=textVertices(a.toString(),50,200,5),f=new PosArray,n=0;n<o.length;n+=2)f.emplaceBack(o[n],o[n+1]);var l=Buffer.fromStructArray(f,Buffer.BufferType.VERTEX),b=new VertexArrayObject;b.bind(t,u,l),t.uniform4f(u.u_color,1,1,1,1);for(var d=e.getTile(a).tileSize,g=EXTENT/(Math.pow(2,r.transform.zoom-a.z)*d),m=[[-1,-1],[-1,1],[1,-1],[1,1]],s=0;s<m.length;s++){var x=m[s];t.uniformMatrix4fv(u.u_matrix,!1,mat4.translate([],i,[g*x[0],g*x[1],0])),t.drawArrays(t.LINES,0,l.length)}t.uniform4f(u.u_color,0,0,0,1),t.uniformMatrix4fv(u.u_matrix,!1,i),t.drawArrays(t.LINES,0,l.length)}var textVertices=require("../lib/debugtext"),browser=require("../util/browser"),mat4=require("@mapbox/gl-matrix").mat4,EXTENT=require("../data/extent"),Buffer=require("../data/buffer"),VertexArrayObject=require("./vertex_array_object"),PosArray=require("../data/pos_array");module.exports=drawDebug;
	},{"../data/buffer":8,"../data/extent":11,"../data/pos_array":14,"../lib/debugtext":23,"../util/browser":108,"./vertex_array_object":39,"@mapbox/gl-matrix":131}],29:[function(require,module,exports){
	"use strict";function drawFill(t,e,r,i){var a=t.gl;a.enable(a.STENCIL_TEST);var l=!r.paint["fill-pattern"]&&r.isPaintValueFeatureConstant("fill-color")&&r.isPaintValueFeatureConstant("fill-opacity")&&1===r.paint["fill-color"][3]&&1===r.paint["fill-opacity"];t.isOpaquePass===l&&(t.setDepthSublayer(1),drawFillTiles(t,e,r,i,drawFillTile)),!t.isOpaquePass&&r.paint["fill-antialias"]&&(t.lineWidth(2),t.depthMask(!1),t.setDepthSublayer(r.getPaintProperty("fill-outline-color")?2:0),drawFillTiles(t,e,r,i,drawStrokeTile))}function drawFillTiles(t,e,r,i,a){for(var l=!0,n=0,o=i;n<o.length;n+=1){var f=o[n],s=e.getTile(f),u=s.getBucket(r);u&&(t.enableTileClippingMask(f),a(t,e,r,s,f,u.buffers,l),l=!1)}}function drawFillTile(t,e,r,i,a,l,n){for(var o=t.gl,f=l.layerData[r.id],s=setFillProgram("fill",r.paint["fill-pattern"],t,f,r,i,a,n),u=0,p=l.segments;u<p.length;u+=1){var g=p[u];g.vaos[r.id].bind(o,s,l.layoutVertexBuffer,l.elementBuffer,f.paintVertexBuffer,g.vertexOffset),o.drawElements(o.TRIANGLES,3*g.primitiveLength,o.UNSIGNED_SHORT,3*g.primitiveOffset*2)}}function drawStrokeTile(t,e,r,i,a,l,n){var o=t.gl,f=l.layerData[r.id],s=r.paint["fill-pattern"]&&!r.getPaintProperty("fill-outline-color"),u=setFillProgram("fillOutline",s,t,f,r,i,a,n);o.uniform2f(u.u_world,o.drawingBufferWidth,o.drawingBufferHeight);for(var p=0,g=l.segments2;p<g.length;p+=1){var m=g[p];m.vaos[r.id].bind(o,u,l.layoutVertexBuffer,l.elementBuffer2,f.paintVertexBuffer,m.vertexOffset),o.drawElements(o.LINES,2*m.primitiveLength,o.UNSIGNED_SHORT,2*m.primitiveOffset*2)}}function setFillProgram(t,e,r,i,a,l,n,o){var f,s=r.currentProgram;return e?(f=r.useProgram(t+"Pattern",i.programConfiguration),(o||f!==s)&&(i.programConfiguration.setUniforms(r.gl,f,a,{zoom:r.transform.zoom}),pattern.prepare(a.paint["fill-pattern"],r,f)),pattern.setTile(l,r,f)):(f=r.useProgram(t,i.programConfiguration),(o||f!==s)&&i.programConfiguration.setUniforms(r.gl,f,a,{zoom:r.transform.zoom})),r.gl.uniformMatrix4fv(f.u_matrix,!1,r.translatePosMatrix(n.posMatrix,l,a.paint["fill-translate"],a.paint["fill-translate-anchor"])),f}var pattern=require("./pattern");module.exports=drawFill;
	},{"./pattern":37}],30:[function(require,module,exports){
	"use strict";function draw(t,e,r,i){if(0!==r.paint["fill-extrusion-opacity"]){var a=t.gl;a.disable(a.STENCIL_TEST),a.enable(a.DEPTH_TEST),t.depthMask(!0);var s=new ExtrusionTexture(a,t,r);s.bindFramebuffer(),a.clearColor(0,0,0,0),a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT);for(var u=0;u<i.length;u++)drawExtrusion(t,e,r,i[u]);s.unbindFramebuffer(),s.renderToMap()}}function ExtrusionTexture(t,e,r){this.gl=t,this.width=e.width,this.height=e.height,this.painter=e,this.layer=r,this.texture=null,this.fbo=null,this.fbos=this.painter.preFbos[this.width]&&this.painter.preFbos[this.width][this.height]}function drawExtrusion(t,e,r,i){if(!t.isOpaquePass){var a=e.getTile(i),s=a.getBucket(r);if(s){var u=s.buffers,f=t.gl,h=r.paint["fill-extrusion-pattern"],n=u.layerData[r.id],o=n.programConfiguration,E=t.useProgram(h?"fillExtrusionPattern":"fillExtrusion",o);o.setUniforms(f,E,r,{zoom:t.transform.zoom}),h&&(pattern.prepare(h,t,E),pattern.setTile(a,t,E),f.uniform1f(E.u_height_factor,-Math.pow(2,i.z)/a.tileSize/8)),t.gl.uniformMatrix4fv(E.u_matrix,!1,t.translatePosMatrix(i.posMatrix,a,r.paint["fill-extrusion-translate"],r.paint["fill-extrusion-translate-anchor"])),setLight(E,t);for(var T=0,l=u.segments;T<l.length;T+=1){var R=l[T];R.vaos[r.id].bind(f,E,u.layoutVertexBuffer,u.elementBuffer,n.paintVertexBuffer,R.vertexOffset),f.drawElements(f.TRIANGLES,3*R.primitiveLength,f.UNSIGNED_SHORT,3*R.primitiveOffset*2)}}}}function setLight(t,e){var r=e.gl,i=e.style.light,a=i.calculated.position,s=[a.x,a.y,a.z],u=mat3.create();"viewport"===i.calculated.anchor&&mat3.fromRotation(u,-e.transform.angle),vec3.transformMat3(s,s,u),r.uniform3fv(t.u_lightpos,s),r.uniform1f(t.u_lightintensity,i.calculated.intensity),r.uniform3fv(t.u_lightcolor,i.calculated.color.slice(0,3))}var glMatrix=require("@mapbox/gl-matrix"),Buffer=require("../data/buffer"),VertexArrayObject=require("./vertex_array_object"),PosArray=require("../data/pos_array"),pattern=require("./pattern"),mat3=glMatrix.mat3,mat4=glMatrix.mat4,vec3=glMatrix.vec3;module.exports=draw,ExtrusionTexture.prototype.bindFramebuffer=function(){var t=this.gl;if(this.texture=this.painter.getViewportTexture(this.width,this.height),t.activeTexture(t.TEXTURE1),this.texture?t.bindTexture(t.TEXTURE_2D,this.texture):(this.texture=t.createTexture(),t.bindTexture(t.TEXTURE_2D,this.texture),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,t.LINEAR),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,t.LINEAR),t.texImage2D(t.TEXTURE_2D,0,t.RGBA,this.width,this.height,0,t.RGBA,t.UNSIGNED_BYTE,null),this.texture.width=this.width,this.texture.height=this.height),this.fbos)this.fbo=this.fbos.pop(),t.bindFramebuffer(t.FRAMEBUFFER,this.fbo),t.framebufferTexture2D(t.FRAMEBUFFER,t.COLOR_ATTACHMENT0,t.TEXTURE_2D,this.texture,0);else{this.fbo=t.createFramebuffer();var e=t.createRenderbuffer(),r=t.createRenderbuffer();t.bindRenderbuffer(t.RENDERBUFFER,e),t.bindRenderbuffer(t.RENDERBUFFER,r),t.renderbufferStorage(t.RENDERBUFFER,t.RGBA4,this.width,this.height),t.renderbufferStorage(t.RENDERBUFFER,t.DEPTH_COMPONENT16,this.width,this.height),t.bindFramebuffer(t.FRAMEBUFFER,this.fbo),t.framebufferRenderbuffer(t.FRAMEBUFFER,t.COLOR_ATTACHMENT0,t.RENDERBUFFER,e),t.framebufferRenderbuffer(t.FRAMEBUFFER,t.DEPTH_ATTACHMENT,t.RENDERBUFFER,r),t.framebufferTexture2D(t.FRAMEBUFFER,t.COLOR_ATTACHMENT0,t.TEXTURE_2D,this.texture,0)}},ExtrusionTexture.prototype.unbindFramebuffer=function(){this.painter.bindDefaultFramebuffer(),this.fbos?this.fbos.push(this.fbo):(this.painter.preFbos[this.width]||(this.painter.preFbos[this.width]={}),this.painter.preFbos[this.width][this.height]=[this.fbo]),this.painter.saveViewportTexture(this.texture)},ExtrusionTexture.prototype.renderToMap=function(){var t=this.gl,e=this.painter,r=e.useProgram("extrusionTexture");t.activeTexture(t.TEXTURE0),t.bindTexture(t.TEXTURE_2D,this.texture),t.uniform1f(r.u_opacity,this.layer.paint["fill-extrusion-opacity"]),t.uniform1i(r.u_texture,1),t.uniformMatrix4fv(r.u_matrix,!1,mat4.ortho(mat4.create(),0,e.width,e.height,0,0,1)),t.disable(t.DEPTH_TEST),t.uniform1i(r.u_xdim,e.width),t.uniform1i(r.u_ydim,e.height);var i=new PosArray;i.emplaceBack(0,0),i.emplaceBack(e.width,0),i.emplaceBack(0,e.height),i.emplaceBack(e.width,e.height);var a=Buffer.fromStructArray(i,Buffer.BufferType.VERTEX),s=new VertexArrayObject;s.bind(t,r,a),t.drawArrays(t.TRIANGLE_STRIP,0,4),t.enable(t.DEPTH_TEST)};
	},{"../data/buffer":8,"../data/pos_array":14,"./pattern":37,"./vertex_array_object":39,"@mapbox/gl-matrix":131}],31:[function(require,module,exports){
	"use strict";function drawLineTile(e,i,t,r,a,n,o,f,s){var l,u,m,_,p=i.gl,g=a.paint["line-dasharray"],d=a.paint["line-pattern"];if(f||s){var v=1/pixelsToTileUnits(t,1,i.transform.tileZoom);if(g){l=i.lineAtlas.getDash(g.from,"round"===a.layout["line-cap"]),u=i.lineAtlas.getDash(g.to,"round"===a.layout["line-cap"]);var T=l.width*g.fromScale,h=u.width*g.toScale;p.uniform2f(e.u_patternscale_a,v/T,-l.height/2),p.uniform2f(e.u_patternscale_b,v/h,-u.height/2),p.uniform1f(e.u_sdfgamma,i.lineAtlas.width/(256*Math.min(T,h)*browser.devicePixelRatio)/2)}else if(d){if(m=i.spriteAtlas.getPosition(d.from,!0),_=i.spriteAtlas.getPosition(d.to,!0),!m||!_)return;p.uniform2f(e.u_pattern_size_a,m.size[0]*d.fromScale/v,_.size[1]),p.uniform2f(e.u_pattern_size_b,_.size[0]*d.toScale/v,_.size[1])}p.uniform2f(e.u_gl_units_to_pixels,1/i.transform.pixelsToGLUnits[0],1/i.transform.pixelsToGLUnits[1])}f&&(g?(p.uniform1i(e.u_image,0),p.activeTexture(p.TEXTURE0),i.lineAtlas.bind(p),p.uniform1f(e.u_tex_y_a,l.y),p.uniform1f(e.u_tex_y_b,u.y),p.uniform1f(e.u_mix,g.t)):d&&(p.uniform1i(e.u_image,0),p.activeTexture(p.TEXTURE0),i.spriteAtlas.bind(p,!0),p.uniform2fv(e.u_pattern_tl_a,m.tl),p.uniform2fv(e.u_pattern_br_a,m.br),p.uniform2fv(e.u_pattern_tl_b,_.tl),p.uniform2fv(e.u_pattern_br_b,_.br),p.uniform1f(e.u_fade,d.t)),p.uniform1f(e.u_width,a.paint["line-width"])),i.enableTileClippingMask(n);var x=i.translatePosMatrix(n.posMatrix,t,a.paint["line-translate"],a.paint["line-translate-anchor"]);p.uniformMatrix4fv(e.u_matrix,!1,x),p.uniform1f(e.u_ratio,1/pixelsToTileUnits(t,1,i.transform.zoom));for(var b=0,c=r.segments;b<c.length;b+=1){var w=c[b];w.vaos[a.id].bind(p,e,r.layoutVertexBuffer,r.elementBuffer,o.paintVertexBuffer,w.vertexOffset),p.drawElements(p.TRIANGLES,3*w.primitiveLength,p.UNSIGNED_SHORT,3*w.primitiveOffset*2)}}var browser=require("../util/browser"),pixelsToTileUnits=require("../source/pixels_to_tile_units");module.exports=function(e,i,t,r){if(!e.isOpaquePass){e.setDepthSublayer(0),e.depthMask(!1);var a=e.gl;if(a.enable(a.STENCIL_TEST),!(t.paint["line-width"]<=0))for(var n,o=t.paint["line-dasharray"]?"lineSDF":t.paint["line-pattern"]?"linePattern":"line",f=!0,s=0,l=r;s<l.length;s+=1){var u=l[s],m=i.getTile(u),_=m.getBucket(t);if(_){var p=_.buffers.layerData[t.id],g=e.currentProgram,d=e.useProgram(o,p.programConfiguration),v=f||d!==g,T=n!==m.coord.z;v&&p.programConfiguration.setUniforms(e.gl,d,t,{zoom:e.transform.zoom}),drawLineTile(d,e,m,_.buffers,t,u,p,v,T),n=m.coord.z,f=!1}}}};
	},{"../source/pixels_to_tile_units":45,"../util/browser":108}],32:[function(require,module,exports){
	"use strict";function drawRaster(r,t,a,e){if(!r.isOpaquePass){var i=r.gl;i.enable(i.DEPTH_TEST),r.depthMask(!0),i.depthFunc(i.LESS);for(var o=e.length&&e[0].z,n=0;n<e.length;n++){var u=e[n];r.setDepthSublayer(u.z-o),drawRasterTile(r,t,a,u)}i.depthFunc(i.LEQUAL)}}function drawRasterTile(r,t,a,e){var i=r.gl;i.disable(i.STENCIL_TEST);var o=t.getTile(e),n=r.transform.calculatePosMatrix(e,t.getSource().maxzoom);o.registerFadeDuration(r.style.animationLoop,a.paint["raster-fade-duration"]);var u=r.useProgram("raster");i.uniformMatrix4fv(u.u_matrix,!1,n),i.uniform1f(u.u_brightness_low,a.paint["raster-brightness-min"]),i.uniform1f(u.u_brightness_high,a.paint["raster-brightness-max"]),i.uniform1f(u.u_saturation_factor,saturationFactor(a.paint["raster-saturation"])),i.uniform1f(u.u_contrast_factor,contrastFactor(a.paint["raster-contrast"])),i.uniform3fv(u.u_spin_weights,spinWeights(a.paint["raster-hue-rotate"]));var s,c,f=o.sourceCache&&o.sourceCache.findLoadedParent(e,0,{}),d=getOpacities(o,f,a,r.transform);i.activeTexture(i.TEXTURE0),i.bindTexture(i.TEXTURE_2D,o.texture),i.activeTexture(i.TEXTURE1),f?(i.bindTexture(i.TEXTURE_2D,f.texture),s=Math.pow(2,f.coord.z-o.coord.z),c=[o.coord.x*s%1,o.coord.y*s%1]):i.bindTexture(i.TEXTURE_2D,o.texture),i.uniform2fv(u.u_tl_parent,c||[0,0]),i.uniform1f(u.u_scale_parent,s||1),i.uniform1f(u.u_buffer_scale,1),i.uniform1f(u.u_opacity0,d[0]),i.uniform1f(u.u_opacity1,d[1]),i.uniform1i(u.u_image0,0),i.uniform1i(u.u_image1,1);var m=o.boundsBuffer||r.rasterBoundsBuffer,h=o.boundsVAO||r.rasterBoundsVAO;h.bind(i,u,m),i.drawArrays(i.TRIANGLE_STRIP,0,m.length)}function spinWeights(r){r*=Math.PI/180;var t=Math.sin(r),a=Math.cos(r);return[(2*a+1)/3,(-Math.sqrt(3)*t-a+1)/3,(Math.sqrt(3)*t-a+1)/3]}function contrastFactor(r){return r>0?1/(1-r):1+r}function saturationFactor(r){return r>0?1-1/(1.001-r):-r}function getOpacities(r,t,a,e){var i=[1,0],o=a.paint["raster-fade-duration"];if(r.sourceCache&&o>0){var n=Date.now(),u=(n-r.timeAdded)/o,s=t?(n-t.timeAdded)/o:-1,c=r.sourceCache.getSource(),f=e.coveringZoomLevel({tileSize:c.tileSize,roundZoom:c.roundZoom}),d=!t||Math.abs(t.coord.z-f)>Math.abs(r.coord.z-f);i[0]=util.clamp(d?u:1-s,0,1),i[1]=t?1-i[0]:0}var m=a.paint["raster-opacity"];return i[0]*=m,i[1]*=m,i}var util=require("../util/util");module.exports=drawRaster;
	},{"../util/util":127}],33:[function(require,module,exports){
	"use strict";function drawSymbols(t,e,i,a){if(!t.isOpaquePass){var o=!(i.layout["text-allow-overlap"]||i.layout["icon-allow-overlap"]||i.layout["text-ignore-placement"]||i.layout["icon-ignore-placement"]),r=t.gl;o?r.disable(r.STENCIL_TEST):r.enable(r.STENCIL_TEST),t.setDepthSublayer(0),t.depthMask(!1),drawLayerSymbols(t,e,i,a,!1,i.paint["icon-translate"],i.paint["icon-translate-anchor"],i.layout["icon-rotation-alignment"],i.layout["icon-rotation-alignment"],i.layout["icon-size"],i.paint["icon-halo-width"],i.paint["icon-halo-color"],i.paint["icon-halo-blur"],i.paint["icon-opacity"],i.paint["icon-color"]),drawLayerSymbols(t,e,i,a,!0,i.paint["text-translate"],i.paint["text-translate-anchor"],i.layout["text-rotation-alignment"],i.layout["text-pitch-alignment"],i.layout["text-size"],i.paint["text-halo-width"],i.paint["text-halo-color"],i.paint["text-halo-blur"],i.paint["text-opacity"],i.paint["text-color"]),e.map.showCollisionBoxes&&drawCollisionDebug(t,e,i,a)}}function drawLayerSymbols(t,e,i,a,o,r,n,l,s,u,f,m,p,c,d){if(o||!t.style.sprite||t.style.sprite.loaded()){var h=t.gl,b="map"===l,x="map"===s,g=x;g?h.enable(h.DEPTH_TEST):h.disable(h.DEPTH_TEST);for(var _,y=0,T=a;y<T.length;y+=1){var v=T[y],w=e.getTile(v),S=w.getBucket(i);if(S){var E=o?S.buffers.glyph:S.buffers.icon;if(E&&E.segments.length){var P=o||S.sdfIcons;_||(_=t.useProgram(P?"symbolSDF":"symbolIcon"),setSymbolDrawState(_,t,o,P,b,x,S.fontstack,u,S.iconsNeedLinear,o?S.adjustedTextSize:S.adjustedIconSize,c)),t.enableTileClippingMask(v),h.uniformMatrix4fv(_.u_matrix,!1,t.translatePosMatrix(v.posMatrix,w,r,n)),drawTileSymbols(_,t,i,w,E,o,P,x,u,f,m,p,d)}}}g||h.enable(h.DEPTH_TEST)}}function setSymbolDrawState(t,e,i,a,o,r,n,l,s,u,f){var m=e.gl,p=e.transform;if(m.uniform1i(t.u_rotate_with_map,o),m.uniform1i(t.u_pitch_with_map,r),m.activeTexture(m.TEXTURE0),m.uniform1i(t.u_texture,0),i){var c=n&&e.glyphSource.getGlyphAtlas(n);if(!c)return;c.updateTexture(m),m.uniform2f(t.u_texsize,c.width/4,c.height/4)}else{var d=e.options.rotating||e.options.zooming,h=1!==l||browser.devicePixelRatio!==e.spriteAtlas.pixelRatio||s,b=r||p.pitch;e.spriteAtlas.bind(m,a||d||h||b),m.uniform2f(t.u_texsize,e.spriteAtlas.width/4,e.spriteAtlas.height/4)}m.activeTexture(m.TEXTURE1),e.frameHistory.bind(m),m.uniform1i(t.u_fadetexture,1);var x=Math.log(l/u)/Math.LN2||0;m.uniform1f(t.u_zoom,10*(p.zoom-x)),m.uniform1f(t.u_pitch,p.pitch/360*2*Math.PI),m.uniform1f(t.u_bearing,p.bearing/360*2*Math.PI),m.uniform1f(t.u_aspect_ratio,p.width/p.height),m.uniform1f(t.u_opacity,f)}function drawTileSymbols(t,e,i,a,o,r,n,l,s,u,f,m,p){var c=e.gl,d=e.transform,h=s/(r?24:1);if(l){var b=pixelsToTileUnits(a,h,d.zoom);c.uniform2f(t.u_extrude_scale,b,b)}else{var x=d.cameraToCenterDistance*h;c.uniform2f(t.u_extrude_scale,d.pixelsToGLUnits[0]*x,d.pixelsToGLUnits[1]*x)}if(n){var g=h*(l?Math.cos(d._pitch):1)*d.cameraToCenterDistance;u&&(c.uniform1f(t.u_gamma,(m*blurOffset/sdfPx+gamma)/g),c.uniform4fv(t.u_color,f),c.uniform1f(t.u_buffer,(haloOffset-u/h)/sdfPx),drawSymbolElements(o,i,c,t)),c.uniform1f(t.u_gamma,gamma/g),c.uniform4fv(t.u_color,p),c.uniform1f(t.u_buffer,.75)}drawSymbolElements(o,i,c,t)}function drawSymbolElements(t,e,i,a){for(var o=0,r=t.segments;o<r.length;o+=1){var n=r[o];n.vaos[e.id].bind(i,a,t.layoutVertexBuffer,t.elementBuffer,null,n.vertexOffset),i.drawElements(i.TRIANGLES,3*n.primitiveLength,i.UNSIGNED_SHORT,3*n.primitiveOffset*2)}}var browser=require("../util/browser"),drawCollisionDebug=require("./draw_collision_debug"),pixelsToTileUnits=require("../source/pixels_to_tile_units");module.exports=drawSymbols;var sdfPx=8,blurOffset=1.19,haloOffset=6,gamma=.105/browser.devicePixelRatio;
	},{"../source/pixels_to_tile_units":45,"../util/browser":108,"./draw_collision_debug":27}],34:[function(require,module,exports){
	"use strict";var FrameHistory=function(){this.changeTimes=new Float64Array(256),this.changeOpacities=new Uint8Array(256),this.opacities=new Uint8ClampedArray(256),this.array=new Uint8Array(this.opacities.buffer),this.previousZoom=0,this.firstFrame=!0};FrameHistory.prototype.record=function(e,t,i){var r=this;this.firstFrame&&(e=0,this.firstFrame=!1),t=Math.floor(10*t);var a;if(t<this.previousZoom)for(a=t+1;a<=this.previousZoom;a++)r.changeTimes[a]=e,r.changeOpacities[a]=r.opacities[a];else for(a=t;a>this.previousZoom;a--)r.changeTimes[a]=e,r.changeOpacities[a]=r.opacities[a];for(a=0;a<256;a++){var s=e-r.changeTimes[a],o=255*(i?s/i:1);a<=t?r.opacities[a]=r.changeOpacities[a]+o:r.opacities[a]=r.changeOpacities[a]-o}this.changed=!0,this.previousZoom=t},FrameHistory.prototype.bind=function(e){this.texture?(e.bindTexture(e.TEXTURE_2D,this.texture),this.changed&&(e.texSubImage2D(e.TEXTURE_2D,0,0,0,256,1,e.ALPHA,e.UNSIGNED_BYTE,this.array),this.changed=!1)):(this.texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this.texture),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.NEAREST),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.NEAREST),e.texImage2D(e.TEXTURE_2D,0,e.ALPHA,256,1,0,e.ALPHA,e.UNSIGNED_BYTE,this.array))},module.exports=FrameHistory;
	},{}],35:[function(require,module,exports){
	"use strict";var util=require("../util/util"),LineAtlas=function(t,i){this.width=t,this.height=i,this.nextRow=0,this.bytes=4,this.data=new Uint8Array(this.width*this.height*this.bytes),this.positions={}};LineAtlas.prototype.setSprite=function(t){this.sprite=t},LineAtlas.prototype.getDash=function(t,i){var e=t.join(",")+i;return this.positions[e]||(this.positions[e]=this.addDash(t,i)),this.positions[e]},LineAtlas.prototype.addDash=function(t,i){var e=this,h=i?7:0,s=2*h+1,a=128;if(this.nextRow+s>this.height)return util.warnOnce("LineAtlas out of space"),null;for(var r=0,n=0;n<t.length;n++)r+=t[n];for(var E=this.width/r,o=E/2,T=t.length%2===1,R=-h;R<=h;R++)for(var u=e.nextRow+h+R,d=e.width*u,l=T?-t[t.length-1]:0,x=t[0],A=1,_=0;_<this.width;_++){for(;x<_/E;)l=x,x+=t[A],T&&A===t.length-1&&(x+=t[0]),A++;var p,g=Math.abs(_-l*E),w=Math.abs(_-x*E),D=Math.min(g,w),U=A%2===1;if(i){var f=h?R/h*(o+1):0;if(U){var X=o-Math.abs(f);p=Math.sqrt(D*D+X*X)}else p=o-Math.sqrt(D*D+f*f)}else p=(U?1:-1)*D;e.data[3+4*(d+_)]=Math.max(0,Math.min(255,p+a))}var y={y:(this.nextRow+h+.5)/this.height,height:2*h/this.height,width:r};return this.nextRow+=s,this.dirty=!0,y},LineAtlas.prototype.bind=function(t){this.texture?(t.bindTexture(t.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,t.texSubImage2D(t.TEXTURE_2D,0,0,0,this.width,this.height,t.RGBA,t.UNSIGNED_BYTE,this.data))):(this.texture=t.createTexture(),t.bindTexture(t.TEXTURE_2D,this.texture),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.REPEAT),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.REPEAT),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,t.LINEAR),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,t.LINEAR),t.texImage2D(t.TEXTURE_2D,0,t.RGBA,this.width,this.height,0,t.RGBA,t.UNSIGNED_BYTE,this.data))},module.exports=LineAtlas;
	},{"../util/util":127}],36:[function(require,module,exports){
	"use strict";var browser=require("../util/browser"),mat4=require("@mapbox/gl-matrix").mat4,FrameHistory=require("./frame_history"),SourceCache=require("../source/source_cache"),EXTENT=require("../data/extent"),pixelsToTileUnits=require("../source/pixels_to_tile_units"),util=require("../util/util"),Buffer=require("../data/buffer"),VertexArrayObject=require("./vertex_array_object"),RasterBoundsArray=require("../data/raster_bounds_array"),PosArray=require("../data/pos_array"),ProgramConfiguration=require("../data/program_configuration"),shaders=require("./shaders"),draw={symbol:require("./draw_symbol"),circle:require("./draw_circle"),line:require("./draw_line"),fill:require("./draw_fill"),"fill-extrusion":require("./draw_fill_extrusion"),raster:require("./draw_raster"),background:require("./draw_background"),debug:require("./draw_debug")},Painter=function(e,r){this.gl=e,this.transform=r,this.reusableTextures={},this.preFbos={},this.frameHistory=new FrameHistory,this.setup(),this.numSublayers=SourceCache.maxUnderzooming+SourceCache.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.lineWidthRange=e.getParameter(e.ALIASED_LINE_WIDTH_RANGE),this.basicFillProgramConfiguration=ProgramConfiguration.createStatic(["color","opacity"]),this.emptyProgramConfiguration=new ProgramConfiguration};Painter.prototype.resize=function(e,r){var t=this.gl;this.width=e*browser.devicePixelRatio,this.height=r*browser.devicePixelRatio,t.viewport(0,0,this.width,this.height)},Painter.prototype.setup=function(){var e=this.gl;e.verbose=!0,e.enable(e.BLEND),e.blendFunc(e.ONE,e.ONE_MINUS_SRC_ALPHA),e.enable(e.STENCIL_TEST),e.enable(e.DEPTH_TEST),e.depthFunc(e.LEQUAL),this._depthMask=!1,e.depthMask(!1);var r=new PosArray;r.emplaceBack(0,0),r.emplaceBack(EXTENT,0),r.emplaceBack(0,EXTENT),r.emplaceBack(EXTENT,EXTENT),this.tileExtentBuffer=Buffer.fromStructArray(r,Buffer.BufferType.VERTEX),this.tileExtentVAO=new VertexArrayObject,this.tileExtentPatternVAO=new VertexArrayObject;var t=new PosArray;t.emplaceBack(0,0),t.emplaceBack(EXTENT,0),t.emplaceBack(EXTENT,EXTENT),t.emplaceBack(0,EXTENT),t.emplaceBack(0,0),this.debugBuffer=Buffer.fromStructArray(t,Buffer.BufferType.VERTEX),this.debugVAO=new VertexArrayObject;var a=new RasterBoundsArray;a.emplaceBack(0,0,0,0),a.emplaceBack(EXTENT,0,32767,0),a.emplaceBack(0,EXTENT,0,32767),a.emplaceBack(EXTENT,EXTENT,32767,32767),this.rasterBoundsBuffer=Buffer.fromStructArray(a,Buffer.BufferType.VERTEX),this.rasterBoundsVAO=new VertexArrayObject},Painter.prototype.clearColor=function(){var e=this.gl;e.clearColor(0,0,0,0),e.clear(e.COLOR_BUFFER_BIT)},Painter.prototype.clearStencil=function(){var e=this.gl;e.clearStencil(0),e.stencilMask(255),e.clear(e.STENCIL_BUFFER_BIT)},Painter.prototype.clearDepth=function(){var e=this.gl;e.clearDepth(1),this.depthMask(!0),e.clear(e.DEPTH_BUFFER_BIT)},Painter.prototype._renderTileClippingMasks=function(e){var r=this,t=this.gl;t.colorMask(!1,!1,!1,!1),this.depthMask(!1),t.disable(t.DEPTH_TEST),t.enable(t.STENCIL_TEST),t.stencilMask(248),t.stencilOp(t.KEEP,t.KEEP,t.REPLACE);var a=1;this._tileClippingMaskIDs={};for(var i=0,s=e;i<s.length;i+=1){var o=s[i],n=r._tileClippingMaskIDs[o.id]=a++<<3;t.stencilFunc(t.ALWAYS,n,248);var l=r.useProgram("fill",r.basicFillProgramConfiguration);t.uniformMatrix4fv(l.u_matrix,!1,o.posMatrix),r.tileExtentVAO.bind(t,l,r.tileExtentBuffer),t.drawArrays(t.TRIANGLE_STRIP,0,r.tileExtentBuffer.length)}t.stencilMask(0),t.colorMask(!0,!0,!0,!0),this.depthMask(!0),t.enable(t.DEPTH_TEST)},Painter.prototype.enableTileClippingMask=function(e){var r=this.gl;r.stencilFunc(r.EQUAL,this._tileClippingMaskIDs[e.id],248)},Painter.prototype.prepareBuffers=function(){},Painter.prototype.bindDefaultFramebuffer=function(){var e=this.gl;e.bindFramebuffer(e.FRAMEBUFFER,null)},Painter.prototype.render=function(e,r){if(this.style=e,this.options=r,this.lineAtlas=e.lineAtlas,this.spriteAtlas=e.spriteAtlas,this.spriteAtlas.setSprite(e.sprite),this.glyphSource=e.glyphSource,this.frameHistory.record(Date.now(),this.transform.zoom,e.getTransition().duration),this.prepareBuffers(),this.clearColor(),this.clearDepth(),this.showOverdrawInspector(r.showOverdrawInspector),this.depthRange=(e._order.length+2)*this.numSublayers*this.depthEpsilon,this.isOpaquePass=!0,this.renderPass(),this.isOpaquePass=!1,this.renderPass(),this.options.showTileBoundaries){var t=this.style.sourceCaches[Object.keys(this.style.sourceCaches)[0]];draw.debug(this,t,t.getVisibleCoordinates())}},Painter.prototype.renderPass=function(){var e,r,t=this,a=this.style._order;this.currentLayer=this.isOpaquePass?a.length-1:0;for(var i=0;i<a.length;i++){var s=t.style._layers[a[t.currentLayer]];s.source!==(e&&e.id)&&(e=t.style.sourceCaches[s.source],r=[],e&&(e.prepare&&e.prepare(),t.clearStencil(),r=e.getVisibleCoordinates(),e.getSource().isTileClipped&&t._renderTileClippingMasks(r)),t.isOpaquePass?t._showOverdrawInspector||t.gl.disable(t.gl.BLEND):(t.gl.enable(t.gl.BLEND),r.reverse())),t.renderLayer(t,e,s,r),t.currentLayer+=t.isOpaquePass?-1:1}},Painter.prototype.depthMask=function(e){e!==this._depthMask&&(this._depthMask=e,this.gl.depthMask(e))},Painter.prototype.renderLayer=function(e,r,t,a){t.isHidden(this.transform.zoom)||("background"===t.type||a.length)&&(this.id=t.id,draw[t.type](e,r,t,a))},Painter.prototype.setDepthSublayer=function(e){var r=1-((1+this.currentLayer)*this.numSublayers+e)*this.depthEpsilon,t=r-1+this.depthRange;this.gl.depthRange(t,r)},Painter.prototype.translatePosMatrix=function(e,r,t,a){if(!t[0]&&!t[1])return e;if("viewport"===a){var i=Math.sin(-this.transform.angle),s=Math.cos(-this.transform.angle);t=[t[0]*s-t[1]*i,t[0]*i+t[1]*s]}var o=[pixelsToTileUnits(r,t[0],this.transform.zoom),pixelsToTileUnits(r,t[1],this.transform.zoom),0],n=new Float32Array(16);return mat4.translate(n,e,o),n},Painter.prototype.saveTileTexture=function(e){var r=this.reusableTextures[e.size];r?r.push(e):this.reusableTextures[e.size]=[e]},Painter.prototype.saveViewportTexture=function(e){this.reusableTextures.viewport||(this.reusableTextures.viewport={}),this.reusableTextures.viewport.texture=e},Painter.prototype.getTileTexture=function(e,r){var t=this.reusableTextures[e];if(t){var a=t[r||e];return a&&a.length>0?a.pop():null}},Painter.prototype.getViewportTexture=function(e,r){if(this.reusableTextures.viewport){var t=this.reusableTextures.viewport.texture;return t.width===e&&t.height===r?t:(this.gl.deleteTexture(t),void(this.reusableTextures.viewport.texture=null))}},Painter.prototype.lineWidth=function(e){this.gl.lineWidth(util.clamp(e,this.lineWidthRange[0],this.lineWidthRange[1]))},Painter.prototype.showOverdrawInspector=function(e){if(e||this._showOverdrawInspector){this._showOverdrawInspector=e;var r=this.gl;if(e){r.blendFunc(r.CONSTANT_COLOR,r.ONE);var t=8,a=1/t;r.blendColor(a,a,a,0),r.clearColor(0,0,0,1),r.clear(r.COLOR_BUFFER_BIT)}else r.blendFunc(r.ONE,r.ONE_MINUS_SRC_ALPHA)}},Painter.prototype.createProgram=function(e,r){var t=this.gl,a=t.createProgram(),i=shaders[e],s="#define MAPBOX_GL_JS\n#define DEVICE_PIXEL_RATIO "+browser.devicePixelRatio.toFixed(1)+"\n";this._showOverdrawInspector&&(s+="#define OVERDRAW_INSPECTOR;\n");var o=t.createShader(t.FRAGMENT_SHADER);t.shaderSource(o,r.applyPragmas(s+shaders.prelude.fragmentSource+i.fragmentSource,"fragment")),t.compileShader(o),t.attachShader(a,o);var n=t.createShader(t.VERTEX_SHADER);t.shaderSource(n,r.applyPragmas(s+shaders.prelude.vertexSource+i.vertexSource,"vertex")),t.compileShader(n),t.attachShader(a,n),t.linkProgram(a);for(var l=t.getProgramParameter(a,t.ACTIVE_ATTRIBUTES),u={program:a,numAttributes:l},h=0;h<l;h++){var c=t.getActiveAttrib(a,h);u[c.name]=t.getAttribLocation(a,c.name)}for(var p=t.getProgramParameter(a,t.ACTIVE_UNIFORMS),d=0;d<p;d++){var f=t.getActiveUniform(a,d);u[f.name]=t.getUniformLocation(a,f.name)}return u},Painter.prototype._createProgramCached=function(e,r){this.cache=this.cache||{};var t=""+e+(r.cacheKey||"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[t]||(this.cache[t]=this.createProgram(e,r)),this.cache[t]},Painter.prototype.useProgram=function(e,r){var t=this.gl,a=this._createProgramCached(e,r||this.emptyProgramConfiguration);return this.currentProgram!==a&&(t.useProgram(a.program),this.currentProgram=a),a},module.exports=Painter;
	},{"../data/buffer":8,"../data/extent":11,"../data/pos_array":14,"../data/program_configuration":15,"../data/raster_bounds_array":16,"../source/pixels_to_tile_units":45,"../source/source_cache":49,"../util/browser":108,"../util/util":127,"./draw_background":25,"./draw_circle":26,"./draw_debug":28,"./draw_fill":29,"./draw_fill_extrusion":30,"./draw_line":31,"./draw_raster":32,"./draw_symbol":33,"./frame_history":34,"./shaders":38,"./vertex_array_object":39,"@mapbox/gl-matrix":131}],37:[function(require,module,exports){
	"use strict";var pixelsToTileUnits=require("../source/pixels_to_tile_units");exports.prepare=function(r,t,i){var o=t.gl,e=t.spriteAtlas.getPosition(r.from,!0),_=t.spriteAtlas.getPosition(r.to,!0);e&&_&&(o.uniform1i(i.u_image,0),o.uniform2fv(i.u_pattern_tl_a,e.tl),o.uniform2fv(i.u_pattern_br_a,e.br),o.uniform2fv(i.u_pattern_tl_b,_.tl),o.uniform2fv(i.u_pattern_br_b,_.br),o.uniform1f(i.u_mix,r.t),o.uniform2fv(i.u_pattern_size_a,e.size),o.uniform2fv(i.u_pattern_size_b,_.size),o.uniform1f(i.u_scale_a,r.fromScale),o.uniform1f(i.u_scale_b,r.toScale),o.activeTexture(o.TEXTURE0),t.spriteAtlas.bind(o,!0))},exports.setTile=function(r,t,i){var o=t.gl;o.uniform1f(i.u_tile_units_to_pixels,1/pixelsToTileUnits(r,1,t.transform.tileZoom));var e=Math.pow(2,r.coord.z),_=r.tileSize*Math.pow(2,t.transform.tileZoom)/e,u=_*(r.coord.x+r.coord.w*e),n=_*r.coord.y;o.uniform2f(i.u_pixel_coord_upper,u>>16,n>>16),o.uniform2f(i.u_pixel_coord_lower,65535&u,65535&n)};
	},{"../source/pixels_to_tile_units":45}],38:[function(require,module,exports){
	"use strict";var path=require("path");module.exports={prelude:{fragmentSource:"#ifdef GL_ES\nprecision mediump float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif\n",vertexSource:"#ifdef GL_ES\nprecision highp float;\n#else\n\n#if !defined(lowp)\n#define lowp\n#endif\n\n#if !defined(mediump)\n#define mediump\n#endif\n\n#if !defined(highp)\n#define highp\n#endif\n\n#endif\n\nfloat evaluate_zoom_function_1(const vec4 values, const float t) {\n    if (t < 1.0) {\n        return mix(values[0], values[1], t);\n    } else if (t < 2.0) {\n        return mix(values[1], values[2], t - 1.0);\n    } else {\n        return mix(values[2], values[3], t - 2.0);\n    }\n}\nvec4 evaluate_zoom_function_4(const vec4 value0, const vec4 value1, const vec4 value2, const vec4 value3, const float t) {\n    if (t < 1.0) {\n        return mix(value0, value1, t);\n    } else if (t < 2.0) {\n        return mix(value1, value2, t - 1.0);\n    } else {\n        return mix(value2, value3, t - 2.0);\n    }\n}\n\n// The offset depends on how many pixels are between the world origin and the edge of the tile:\n// vec2 offset = mod(pixel_coord, size)\n//\n// At high zoom levels there are a ton of pixels between the world origin and the edge of the tile.\n// The glsl spec only guarantees 16 bits of precision for highp floats. We need more than that.\n//\n// The pixel_coord is passed in as two 16 bit values:\n// pixel_coord_upper = floor(pixel_coord / 2^16)\n// pixel_coord_lower = mod(pixel_coord, 2^16)\n//\n// The offset is calculated in a series of steps that should preserve this precision:\nvec2 get_pattern_pos(const vec2 pixel_coord_upper, const vec2 pixel_coord_lower,\n    const vec2 pattern_size, const float tile_units_to_pixels, const vec2 pos) {\n\n    vec2 offset = mod(mod(mod(pixel_coord_upper, pattern_size) * 256.0, pattern_size) * 256.0 + pixel_coord_lower, pattern_size);\n    return (tile_units_to_pixels * pos + offset) / pattern_size;\n}\n"},circle:{fragmentSource:"#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\n\nvarying vec2 v_extrude;\nvarying lowp float v_antialiasblur;\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize mediump float radius\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp vec4 stroke_color\n    #pragma mapbox: initialize mediump float stroke_width\n    #pragma mapbox: initialize lowp float stroke_opacity\n\n    float extrude_length = length(v_extrude);\n    float antialiased_blur = -max(blur, v_antialiasblur);\n\n    float opacity_t = smoothstep(0.0, antialiased_blur, extrude_length - 1.0);\n\n    float color_t = stroke_width < 0.01 ? 0.0 : smoothstep(\n        antialiased_blur,\n        0.0,\n        extrude_length - radius / (radius + stroke_width)\n    );\n\n    gl_FragColor = opacity_t * mix(color * opacity, stroke_color * stroke_opacity, color_t);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform bool u_scale_with_map;\nuniform vec2 u_extrude_scale;\n\nattribute vec2 a_pos;\n\n#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\n\nvarying vec2 v_extrude;\nvarying lowp float v_antialiasblur;\n\nvoid main(void) {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize mediump float radius\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp vec4 stroke_color\n    #pragma mapbox: initialize mediump float stroke_width\n    #pragma mapbox: initialize lowp float stroke_opacity\n\n    // unencode the extrusion vector that we snuck into the a_pos vector\n    v_extrude = vec2(mod(a_pos, 2.0) * 2.0 - 1.0);\n\n    vec2 extrude = v_extrude * (radius + stroke_width) * u_extrude_scale;\n    // multiply a_pos by 0.5, since we had it * 2 in order to sneak\n    // in extrusion data\n    gl_Position = u_matrix * vec4(floor(a_pos * 0.5), 0, 1);\n\n    if (u_scale_with_map) {\n        gl_Position.xy += extrude;\n    } else {\n        gl_Position.xy += extrude * gl_Position.w;\n    }\n\n    // This is a minimum blur distance that serves as a faux-antialiasing for\n    // the circle. since blur is a ratio of the circle's size and the intent is\n    // to keep the blur at roughly 1px, the two are inversely related.\n    v_antialiasblur = 1.0 / DEVICE_PIXEL_RATIO / (radius + stroke_width);\n}\n"},collisionBox:{fragmentSource:"uniform float u_zoom;\nuniform float u_maxzoom;\n\nvarying float v_max_zoom;\nvarying float v_placement_zoom;\n\nvoid main() {\n\n    float alpha = 0.5;\n\n    gl_FragColor = vec4(0.0, 1.0, 0.0, 1.0) * alpha;\n\n    if (v_placement_zoom > u_zoom) {\n        gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0) * alpha;\n    }\n\n    if (u_zoom >= v_max_zoom) {\n        gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0) * alpha * 0.25;\n    }\n\n    if (v_placement_zoom >= u_maxzoom) {\n        gl_FragColor = vec4(0.0, 0.0, 1.0, 1.0) * alpha * 0.2;\n    }\n}\n",vertexSource:"attribute vec2 a_pos;\nattribute vec2 a_extrude;\nattribute vec2 a_data;\n\nuniform mat4 u_matrix;\nuniform float u_scale;\n\nvarying float v_max_zoom;\nvarying float v_placement_zoom;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos + a_extrude / u_scale, 0.0, 1.0);\n\n    v_max_zoom = a_data.x;\n    v_placement_zoom = a_data.y;\n}\n"},debug:{fragmentSource:"uniform lowp vec4 u_color;\n\nvoid main() {\n    gl_FragColor = u_color;\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, step(32767.0, a_pos.x), 1);\n}\n"},fill:{fragmentSource:"#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_FragColor = color * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\n\n#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n}\n"},fillOutline:{fragmentSource:"#pragma mapbox: define lowp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_pos;\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 outline_color\n    #pragma mapbox: initialize lowp float opacity\n\n    float dist = length(v_pos - gl_FragCoord.xy);\n    float alpha = smoothstep(1.0, 0.0, dist);\n    gl_FragColor = outline_color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\n\nuniform mat4 u_matrix;\nuniform vec2 u_world;\n\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 outline_color\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos = (gl_Position.xy / gl_Position.w + 1.0) / 2.0 * u_world;\n}\n"},fillOutlinePattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a, u_pattern_br_a, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b, u_pattern_br_b, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    // find distance to outline for alpha interpolation\n\n    float dist = length(v_pos - gl_FragCoord.xy);\n    float alpha = smoothstep(1.0, 0.0, dist);\n\n\n    gl_FragColor = mix(color1, color2, u_mix) * alpha * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_world;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec2 v_pos;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n\n    v_pos = (gl_Position.xy / gl_Position.w + 1.0) / 2.0 * u_world;\n}\n"},fillPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a, u_pattern_br_a, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b, u_pattern_br_b, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    gl_FragColor = mix(color1, color2, u_mix) * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\n\nattribute vec2 a_pos;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\n\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float opacity\n\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, a_pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, a_pos);\n}\n"},fillExtrusion:{fragmentSource:"varying vec4 v_color;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 color\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n    #pragma mapbox: initialize lowp vec4 color\n\n    gl_FragColor = v_color;\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec3 u_lightcolor;\nuniform lowp vec3 u_lightpos;\nuniform lowp float u_lightintensity;\nuniform lowp vec4 u_outline_color;\n\nattribute vec2 a_pos;\nattribute vec3 a_normal;\nattribute float a_edgedistance;\n\nvarying vec4 v_color;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\n#pragma mapbox: define lowp vec4 color\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n    #pragma mapbox: initialize lowp vec4 color\n\n    float ed = a_edgedistance; // use each attrib in order to not trip a VAO assert\n    float t = mod(a_normal.x, 2.0);\n\n    gl_Position = u_matrix * vec4(a_pos, t > 0.0 ? height : base, 1);\n\n#ifdef OUTLINE\n    color = u_outline_color;\n#endif\n\n    // Relative luminance (how dark/bright is the surface color?)\n    float colorvalue = color.r * 0.2126 + color.g * 0.7152 + color.b * 0.0722;\n\n    v_color = vec4(0.0, 0.0, 0.0, 1.0);\n\n    // Add slight ambient lighting so no extrusions are totally black\n    vec4 ambientlight = vec4(0.03, 0.03, 0.03, 1.0);\n    color += ambientlight;\n\n    // Calculate cos(theta), where theta is the angle between surface normal and diffuse light ray\n    float directional = clamp(dot(a_normal / 16384.0, u_lightpos), 0.0, 1.0);\n\n    // Adjust directional so that\n    // the range of values for highlight/shading is narrower\n    // with lower light intensity\n    // and with lighter/brighter surface colors\n    directional = mix((1.0 - u_lightintensity), max((1.0 - colorvalue + u_lightintensity), 1.0), directional);\n\n    // Add gradient along z axis of side surfaces\n    if (a_normal.y != 0.0) {\n        directional *= clamp((t + base) * pow(height / 150.0, 0.5), mix(0.7, 0.98, 1.0 - u_lightintensity), 1.0);\n    }\n\n    // Assign final color based on surface + ambient light color, diffuse light directional, and light color\n    // with lower bounds adjusted to hue of light\n    // so that shading is tinted with the complementary (opposite) color to the light color\n    v_color.r += clamp(color.r * directional * u_lightcolor.r, mix(0.0, 0.3, 1.0 - u_lightcolor.r), 1.0);\n    v_color.g += clamp(color.g * directional * u_lightcolor.g, mix(0.0, 0.3, 1.0 - u_lightcolor.g), 1.0);\n    v_color.b += clamp(color.b * directional * u_lightcolor.b, mix(0.0, 0.3, 1.0 - u_lightcolor.b), 1.0);\n}\n"},fillExtrusionPattern:{fragmentSource:"uniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform float u_mix;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec4 v_lighting;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n\n    vec2 imagecoord = mod(v_pos_a, 1.0);\n    vec2 pos = mix(u_pattern_tl_a, u_pattern_br_a, imagecoord);\n    vec4 color1 = texture2D(u_image, pos);\n\n    vec2 imagecoord_b = mod(v_pos_b, 1.0);\n    vec2 pos2 = mix(u_pattern_tl_b, u_pattern_br_b, imagecoord_b);\n    vec4 color2 = texture2D(u_image, pos2);\n\n    vec4 mixedColor = mix(color1, color2, u_mix);\n\n    gl_FragColor = mixedColor * v_lighting;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pixel_coord_upper;\nuniform vec2 u_pixel_coord_lower;\nuniform float u_scale_a;\nuniform float u_scale_b;\nuniform float u_tile_units_to_pixels;\nuniform float u_height_factor;\n\nuniform vec3 u_lightcolor;\nuniform lowp vec3 u_lightpos;\nuniform lowp float u_lightintensity;\n\nattribute vec2 a_pos;\nattribute vec3 a_normal;\nattribute float a_edgedistance;\n\nvarying vec2 v_pos_a;\nvarying vec2 v_pos_b;\nvarying vec4 v_lighting;\nvarying float v_directional;\n\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n\nvoid main() {\n    #pragma mapbox: initialize lowp float base\n    #pragma mapbox: initialize lowp float height\n\n    float t = mod(a_normal.x, 2.0);\n    float z = t > 0.0 ? height : base;\n\n    gl_Position = u_matrix * vec4(a_pos, z, 1);\n\n    vec2 pos = a_normal.x == 1.0 && a_normal.y == 0.0 && a_normal.z == 16384.0\n        ? a_pos // extrusion top\n        : vec2(a_edgedistance, z * u_height_factor); // extrusion side\n\n    v_pos_a = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_a * u_pattern_size_a, u_tile_units_to_pixels, pos);\n    v_pos_b = get_pattern_pos(u_pixel_coord_upper, u_pixel_coord_lower, u_scale_b * u_pattern_size_b, u_tile_units_to_pixels, pos);\n\n    v_lighting = vec4(0.0, 0.0, 0.0, 1.0);\n    float directional = clamp(dot(a_normal / 16383.0, u_lightpos), 0.0, 1.0);\n    directional = mix((1.0 - u_lightintensity), max((0.5 + u_lightintensity), 1.0), directional);\n\n    if (a_normal.y != 0.0) {\n        directional *= clamp((t + base) * pow(height / 150.0, 0.5), mix(0.7, 0.98, 1.0 - u_lightintensity), 1.0);\n    }\n\n    v_lighting.rgb += clamp(directional * u_lightcolor, mix(vec3(0.0), vec3(0.3), 1.0 - u_lightcolor), vec3(1.0));\n}\n"},extrusionTexture:{fragmentSource:"uniform sampler2D u_texture;\nuniform float u_opacity;\n\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_FragColor = texture2D(u_texture, v_pos) * u_opacity;\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform int u_xdim;\nuniform int u_ydim;\nattribute vec2 a_pos;\nvarying vec2 v_pos;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n\n    v_pos.x = a_pos.x / float(u_xdim);\n    v_pos.y = 1.0 - a_pos.y / float(u_ydim);\n}\n"},line:{fragmentSource:"#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvarying vec2 v_width2;\nvarying vec2 v_normal;\nvarying float v_gamma_scale;\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\n// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\nattribute vec2 a_pos;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform mediump float u_width;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n\n    // We store the texture normals in the most insignificant bit\n    // transform y so that 0 => -1 and 1 => 1\n    // In the texture normal, x is 0 if the normal points straight up/down and 1 if it's a round cap\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = mod(a_pos, 2.0);\n    normal.y = sign(normal.y - 0.5);\n    v_normal = normal;\n\n\n    // these transformations used to be applied in the JS and native code bases. \n    // moved them into the shader for clarity and simplicity. \n    gapwidth = gapwidth / 2.0;\n    float width = u_width / 2.0;\n    offset = -1.0 * offset; \n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + width * (gapwidth > 0.0 ? 2.0 : 1.0) + ANTIALIASING;\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    // Remove the texture normal bit to get the position\n    vec2 pos = floor(a_pos * 0.5);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_width2 = vec2(outset, inset);\n}\n"},linePattern:{fragmentSource:"uniform vec2 u_pattern_size_a;\nuniform vec2 u_pattern_size_b;\nuniform vec2 u_pattern_tl_a;\nuniform vec2 u_pattern_br_a;\nuniform vec2 u_pattern_tl_b;\nuniform vec2 u_pattern_br_b;\nuniform float u_fade;\n\nuniform sampler2D u_image;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_linesofar;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    float x_a = mod(v_linesofar / u_pattern_size_a.x, 1.0);\n    float x_b = mod(v_linesofar / u_pattern_size_b.x, 1.0);\n    float y_a = 0.5 + (v_normal.y * v_width2.s / u_pattern_size_a.y);\n    float y_b = 0.5 + (v_normal.y * v_width2.s / u_pattern_size_b.y);\n    vec2 pos_a = mix(u_pattern_tl_a, u_pattern_br_a, vec2(x_a, y_a));\n    vec2 pos_b = mix(u_pattern_tl_b, u_pattern_br_b, vec2(x_b, y_b));\n\n    vec4 color = mix(texture2D(u_image, pos_a), texture2D(u_image, pos_b), u_fade);\n\n    gl_FragColor = color * alpha * opacity;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\n// We scale the distance before adding it to the buffers so that we can store\n// long distances for long segments. Use this value to unscale the distance.\n#define LINE_DISTANCE_SCALE 2.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\nattribute vec2 a_pos;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform mediump float u_width;\nuniform vec2 u_gl_units_to_pixels;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying float v_linesofar;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n\nvoid main() {\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize lowp float offset\n    #pragma mapbox: initialize mediump float gapwidth\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n    float a_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * LINE_DISTANCE_SCALE;\n\n    // We store the texture normals in the most insignificant bit\n    // transform y so that 0 => -1 and 1 => 1\n    // In the texture normal, x is 0 if the normal points straight up/down and 1 if it's a round cap\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = mod(a_pos, 2.0);\n    normal.y = sign(normal.y - 0.5);\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases. \n    // moved them into the shader for clarity and simplicity. \n    gapwidth = gapwidth / 2.0;\n    float width = u_width / 2.0;\n    offset = -1.0 * offset; \n\n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + width * (gapwidth > 0.0 ? 2.0 : 1.0) + ANTIALIASING;\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist = outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    // Remove the texture normal bit to get the position\n    vec2 pos = floor(a_pos * 0.5);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_linesofar = a_linesofar;\n    v_width2 = vec2(outset, inset);\n}\n"},lineSDF:{fragmentSource:"\nuniform sampler2D u_image;\nuniform float u_sdfgamma;\nuniform float u_mix;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying vec2 v_tex_a;\nvarying vec2 v_tex_b;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n\n    // Calculate the distance of the pixel from the line in pixels.\n    float dist = length(v_normal) * v_width2.s;\n\n    // Calculate the antialiasing fade factor. This is either when fading in\n    // the line in case of an offset line (v_width2.t) or when fading out\n    // (v_width2.s)\n    float blur2 = (blur + 1.0 / DEVICE_PIXEL_RATIO) * v_gamma_scale;\n    float alpha = clamp(min(dist - (v_width2.t - blur2), v_width2.s - dist) / blur2, 0.0, 1.0);\n\n    float sdfdist_a = texture2D(u_image, v_tex_a).a;\n    float sdfdist_b = texture2D(u_image, v_tex_b).a;\n    float sdfdist = mix(sdfdist_a, sdfdist_b, u_mix);\n    alpha *= smoothstep(0.5 - u_sdfgamma, 0.5 + u_sdfgamma, sdfdist);\n\n    gl_FragColor = color * (alpha * opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"// floor(127 / 2) == 63.0\n// the maximum allowed miter limit is 2.0 at the moment. the extrude normal is\n// stored in a byte (-128..127). we scale regular normals up to length 63, but\n// there are also \"special\" normals that have a bigger length (of up to 126 in\n// this case).\n// #define scale 63.0\n#define scale 0.015873016\n\n// We scale the distance before adding it to the buffers so that we can store\n// long distances for long segments. Use this value to unscale the distance.\n#define LINE_DISTANCE_SCALE 2.0\n\n// the distance over which the line edge fades out.\n// Retina devices need a smaller distance to avoid aliasing.\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n\nattribute vec2 a_pos;\nattribute vec4 a_data;\n\nuniform mat4 u_matrix;\nuniform mediump float u_ratio;\nuniform vec2 u_patternscale_a;\nuniform float u_tex_y_a;\nuniform vec2 u_patternscale_b;\nuniform float u_tex_y_b;\nuniform vec2 u_gl_units_to_pixels;\nuniform mediump float u_width;\n\nvarying vec2 v_normal;\nvarying vec2 v_width2;\nvarying vec2 v_tex_a;\nvarying vec2 v_tex_b;\nvarying float v_gamma_scale;\n\n#pragma mapbox: define lowp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n\nvoid main() {\n    #pragma mapbox: initialize lowp vec4 color\n    #pragma mapbox: initialize lowp float blur\n    #pragma mapbox: initialize lowp float opacity\n    #pragma mapbox: initialize mediump float gapwidth\n    #pragma mapbox: initialize lowp float offset\n\n    vec2 a_extrude = a_data.xy - 128.0;\n    float a_direction = mod(a_data.z, 4.0) - 1.0;\n    float a_linesofar = (floor(a_data.z / 4.0) + a_data.w * 64.0) * LINE_DISTANCE_SCALE;\n\n    // We store the texture normals in the most insignificant bit\n    // transform y so that 0 => -1 and 1 => 1\n    // In the texture normal, x is 0 if the normal points straight up/down and 1 if it's a round cap\n    // y is 1 if the normal points up, and -1 if it points down\n    mediump vec2 normal = mod(a_pos, 2.0);\n    normal.y = sign(normal.y - 0.5);\n    v_normal = normal;\n\n    // these transformations used to be applied in the JS and native code bases. \n    // moved them into the shader for clarity and simplicity. \n    gapwidth = gapwidth / 2.0;\n    float width = u_width / 2.0;\n    offset = -1.0 * offset;\n \n    float inset = gapwidth + (gapwidth > 0.0 ? ANTIALIASING : 0.0);\n    float outset = gapwidth + width * (gapwidth > 0.0 ? 2.0 : 1.0) + ANTIALIASING;\n\n    // Scale the extrusion vector down to a normal and then up by the line width\n    // of this vertex.\n    mediump vec2 dist =outset * a_extrude * scale;\n\n    // Calculate the offset when drawing a line that is to the side of the actual line.\n    // We do this by creating a vector that points towards the extrude, but rotate\n    // it when we're drawing round end points (a_direction = -1 or 1) since their\n    // extrude vector points in another direction.\n    mediump float u = 0.5 * a_direction;\n    mediump float t = 1.0 - abs(u);\n    mediump vec2 offset2 = offset * a_extrude * scale * normal.y * mat2(t, -u, u, t);\n\n    // Remove the texture normal bit to get the position\n    vec2 pos = floor(a_pos * 0.5);\n\n    vec4 projected_extrude = u_matrix * vec4(dist / u_ratio, 0.0, 0.0);\n    gl_Position = u_matrix * vec4(pos + offset2 / u_ratio, 0.0, 1.0) + projected_extrude;\n\n    // calculate how much the perspective view squishes or stretches the extrude\n    float extrude_length_without_perspective = length(dist);\n    float extrude_length_with_perspective = length(projected_extrude.xy / gl_Position.w * u_gl_units_to_pixels);\n    v_gamma_scale = extrude_length_without_perspective / extrude_length_with_perspective;\n\n    v_tex_a = vec2(a_linesofar * u_patternscale_a.x, normal.y * u_patternscale_a.y + u_tex_y_a);\n    v_tex_b = vec2(a_linesofar * u_patternscale_b.x, normal.y * u_patternscale_b.y + u_tex_y_b);\n\n    v_width2 = vec2(outset, inset);\n}\n"
	},raster:{fragmentSource:"uniform float u_opacity0;\nuniform float u_opacity1;\nuniform sampler2D u_image0;\nuniform sampler2D u_image1;\nvarying vec2 v_pos0;\nvarying vec2 v_pos1;\n\nuniform float u_brightness_low;\nuniform float u_brightness_high;\n\nuniform float u_saturation_factor;\nuniform float u_contrast_factor;\nuniform vec3 u_spin_weights;\n\nvoid main() {\n\n    // read and cross-fade colors from the main and parent tiles\n    vec4 color0 = texture2D(u_image0, v_pos0);\n    vec4 color1 = texture2D(u_image1, v_pos1);\n    vec4 color = color0 * u_opacity0 + color1 * u_opacity1;\n    vec3 rgb = color.rgb;\n\n    // spin\n    rgb = vec3(\n        dot(rgb, u_spin_weights.xyz),\n        dot(rgb, u_spin_weights.zxy),\n        dot(rgb, u_spin_weights.yzx));\n\n    // saturation\n    float average = (color.r + color.g + color.b) / 3.0;\n    rgb += (average - rgb) * u_saturation_factor;\n\n    // contrast\n    rgb = (rgb - 0.5) * u_contrast_factor + 0.5;\n\n    // brightness\n    vec3 u_high_vec = vec3(u_brightness_low, u_brightness_low, u_brightness_low);\n    vec3 u_low_vec = vec3(u_brightness_high, u_brightness_high, u_brightness_high);\n\n    gl_FragColor = vec4(mix(u_high_vec, u_low_vec, rgb), color.a);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"uniform mat4 u_matrix;\nuniform vec2 u_tl_parent;\nuniform float u_scale_parent;\nuniform float u_buffer_scale;\n\nattribute vec2 a_pos;\nattribute vec2 a_texture_pos;\n\nvarying vec2 v_pos0;\nvarying vec2 v_pos1;\n\nvoid main() {\n    gl_Position = u_matrix * vec4(a_pos, 0, 1);\n    v_pos0 = (((a_texture_pos / 32767.0) - 0.5) / u_buffer_scale ) + 0.5;\n    v_pos1 = (v_pos0 * u_scale_parent) + u_tl_parent;\n}\n"},symbolIcon:{fragmentSource:"uniform sampler2D u_texture;\nuniform sampler2D u_fadetexture;\nuniform lowp float u_opacity;\n\nvarying vec2 v_tex;\nvarying vec2 v_fade_tex;\n\nvoid main() {\n    lowp float alpha = texture2D(u_fadetexture, v_fade_tex).a * u_opacity;\n    gl_FragColor = texture2D(u_texture, v_tex) * alpha;\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"attribute vec2 a_pos;\nattribute vec2 a_offset;\nattribute vec2 a_texture_pos;\nattribute vec4 a_data;\n\n\n// matrix is for the vertex position.\nuniform mat4 u_matrix;\n\nuniform mediump float u_zoom;\nuniform bool u_rotate_with_map;\nuniform vec2 u_extrude_scale;\n\nuniform vec2 u_texsize;\n\nvarying vec2 v_tex;\nvarying vec2 v_fade_tex;\n\nvoid main() {\n    vec2 a_tex = a_texture_pos.xy;\n    mediump float a_labelminzoom = a_data[0];\n    mediump vec2 a_zoom = a_data.pq;\n    mediump float a_minzoom = a_zoom[0];\n    mediump float a_maxzoom = a_zoom[1];\n\n    // u_zoom is the current zoom level adjusted for the change in font size\n    mediump float z = 2.0 - step(a_minzoom, u_zoom) - (1.0 - step(a_maxzoom, u_zoom));\n\n    vec2 extrude = u_extrude_scale * (a_offset / 64.0);\n    if (u_rotate_with_map) {\n        gl_Position = u_matrix * vec4(a_pos + extrude, 0, 1);\n        gl_Position.z += z * gl_Position.w;\n    } else {\n        gl_Position = u_matrix * vec4(a_pos, 0, 1) + vec4(extrude, 0, 0);\n    }\n\n    v_tex = a_tex / u_texsize;\n    v_fade_tex = vec2(a_labelminzoom / 255.0, 0.0);\n}\n"},symbolSDF:{fragmentSource:"uniform sampler2D u_texture;\nuniform sampler2D u_fadetexture;\nuniform lowp vec4 u_color;\nuniform lowp float u_opacity;\nuniform lowp float u_buffer;\nuniform lowp float u_gamma;\n\nvarying vec2 v_tex;\nvarying vec2 v_fade_tex;\nvarying float v_gamma_scale;\n\nvoid main() {\n    lowp float dist = texture2D(u_texture, v_tex).a;\n    lowp float fade_alpha = texture2D(u_fadetexture, v_fade_tex).a;\n    lowp float gamma = u_gamma * v_gamma_scale;\n    lowp float alpha = smoothstep(u_buffer - gamma, u_buffer + gamma, dist) * fade_alpha;\n\n    gl_FragColor = u_color * (alpha * u_opacity);\n\n#ifdef OVERDRAW_INSPECTOR\n    gl_FragColor = vec4(1.0);\n#endif\n}\n",vertexSource:"const float PI = 3.141592653589793;\n\nattribute vec2 a_pos;\nattribute vec2 a_offset;\nattribute vec2 a_texture_pos;\nattribute vec4 a_data;\n\n\n// matrix is for the vertex position.\nuniform mat4 u_matrix;\n\nuniform mediump float u_zoom;\nuniform bool u_rotate_with_map;\nuniform bool u_pitch_with_map;\nuniform mediump float u_pitch;\nuniform mediump float u_bearing;\nuniform mediump float u_aspect_ratio;\nuniform vec2 u_extrude_scale;\n\nuniform vec2 u_texsize;\n\nvarying vec2 v_tex;\nvarying vec2 v_fade_tex;\nvarying float v_gamma_scale;\n\nvoid main() {\n    vec2 a_tex = a_texture_pos.xy;\n    mediump float a_labelminzoom = a_data[0];\n    mediump vec2 a_zoom = a_data.pq;\n    mediump float a_minzoom = a_zoom[0];\n    mediump float a_maxzoom = a_zoom[1];\n\n    // u_zoom is the current zoom level adjusted for the change in font size\n    mediump float z = 2.0 - step(a_minzoom, u_zoom) - (1.0 - step(a_maxzoom, u_zoom));\n\n    // pitch-alignment: map\n    // rotation-alignment: map | viewport\n    if (u_pitch_with_map) {\n        lowp float angle = u_rotate_with_map ? (a_data[1] / 256.0 * 2.0 * PI) : u_bearing;\n        lowp float asin = sin(angle);\n        lowp float acos = cos(angle);\n        mat2 RotationMatrix = mat2(acos, asin, -1.0 * asin, acos);\n        vec2 offset = RotationMatrix * a_offset;\n        vec2 extrude = u_extrude_scale * (offset / 64.0);\n        gl_Position = u_matrix * vec4(a_pos + extrude, 0, 1);\n        gl_Position.z += z * gl_Position.w;\n    // pitch-alignment: viewport\n    // rotation-alignment: map\n    } else if (u_rotate_with_map) {\n        // foreshortening factor to apply on pitched maps\n        // as a label goes from horizontal <=> vertical in angle\n        // it goes from 0% foreshortening to up to around 70% foreshortening\n        lowp float pitchfactor = 1.0 - cos(u_pitch * sin(u_pitch * 0.75));\n\n        lowp float lineangle = a_data[1] / 256.0 * 2.0 * PI;\n\n        // use the lineangle to position points a,b along the line\n        // project the points and calculate the label angle in projected space\n        // this calculation allows labels to be rendered unskewed on pitched maps\n        vec4 a = u_matrix * vec4(a_pos, 0, 1);\n        vec4 b = u_matrix * vec4(a_pos + vec2(cos(lineangle),sin(lineangle)), 0, 1);\n        lowp float angle = atan((b[1]/b[3] - a[1]/a[3])/u_aspect_ratio, b[0]/b[3] - a[0]/a[3]);\n        lowp float asin = sin(angle);\n        lowp float acos = cos(angle);\n        mat2 RotationMatrix = mat2(acos, -1.0 * asin, asin, acos);\n\n        vec2 offset = RotationMatrix * (vec2((1.0-pitchfactor)+(pitchfactor*cos(angle*2.0)), 1.0) * a_offset);\n        vec2 extrude = u_extrude_scale * (offset / 64.0);\n        gl_Position = u_matrix * vec4(a_pos, 0, 1) + vec4(extrude, 0, 0);\n        gl_Position.z += z * gl_Position.w;\n    // pitch-alignment: viewport\n    // rotation-alignment: viewport\n    } else {\n        vec2 extrude = u_extrude_scale * (a_offset / 64.0);\n        gl_Position = u_matrix * vec4(a_pos, 0, 1) + vec4(extrude, 0, 0);\n    }\n\n    v_gamma_scale = gl_Position.w;\n\n    v_tex = a_tex / u_texsize;\n    v_fade_tex = vec2(a_labelminzoom / 255.0, 0.0);\n}\n"}};
	},{"path":191}],39:[function(require,module,exports){
	"use strict";var VertexArrayObject=function(){this.boundProgram=null,this.boundVertexBuffer=null,this.boundVertexBuffer2=null,this.boundElementBuffer=null,this.boundVertexOffset=null,this.vao=null};VertexArrayObject.prototype.bind=function(e,t,r,i,n,o){void 0===e.extVertexArrayObject&&(e.extVertexArrayObject=e.getExtension("OES_vertex_array_object"));var s=!this.vao||this.boundProgram!==t||this.boundVertexBuffer!==r||this.boundVertexBuffer2!==n||this.boundElementBuffer!==i||this.boundVertexOffset!==o;!e.extVertexArrayObject||s?(this.freshBind(e,t,r,i,n,o),this.gl=e):e.extVertexArrayObject.bindVertexArrayOES(this.vao)},VertexArrayObject.prototype.freshBind=function(e,t,r,i,n,o){var s,u=t.numAttributes;if(e.extVertexArrayObject)this.vao&&this.destroy(),this.vao=e.extVertexArrayObject.createVertexArrayOES(),e.extVertexArrayObject.bindVertexArrayOES(this.vao),s=0,this.boundProgram=t,this.boundVertexBuffer=r,this.boundVertexBuffer2=n,this.boundElementBuffer=i,this.boundVertexOffset=o;else{s=e.currentNumAttributes||0;for(var b=u;b<s;b++)e.disableVertexAttribArray(b)}for(var a=s;a<u;a++)e.enableVertexAttribArray(a);r.bind(e),r.setVertexAttribPointers(e,t,o),n&&(n.bind(e),n.setVertexAttribPointers(e,t,o)),i&&i.bind(e),e.currentNumAttributes=u},VertexArrayObject.prototype.destroy=function(){this.vao&&(this.gl.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null)},module.exports=VertexArrayObject;
	},{}],40:[function(require,module,exports){
	"use strict";function resolveURL(t){var e=window.document.createElement("a");return e.href=t,e.href}var Evented=require("../util/evented"),util=require("../util/util"),window=require("../util/window"),EXTENT=require("../data/extent"),GeoJSONSource=function(t){function e(e,o,i,r){var a=this;t.call(this),o=o||{},this.id=e,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this.dispatcher=i,this._data=o.data,void 0!==o.maxzoom&&(this.maxzoom=o.maxzoom),o.type&&(this.type=o.type);var s=EXTENT/this.tileSize;this.workerOptions=util.extend({source:this.id,cluster:o.cluster||!1,geojsonVtOptions:{buffer:(void 0!==o.buffer?o.buffer:128)*s,tolerance:(void 0!==o.tolerance?o.tolerance:.375)*s,extent:EXTENT,maxZoom:this.maxzoom},superclusterOptions:{maxZoom:Math.min(o.clusterMaxZoom,this.maxzoom-1)||this.maxzoom-1,extent:EXTENT,radius:(o.clusterRadius||50)*s,log:!1}},o.workerOptions),this.setEventedParent(r),this.fire("dataloading",{dataType:"source"}),this._updateWorkerData(function(t){return t?void a.fire("error",{error:t}):(a.fire("data",{dataType:"source"}),void a.fire("source.load"))})}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.onAdd=function(t){this.map=t},e.prototype.setData=function(t){var e=this;return this._data=t,this.fire("dataloading",{dataType:"source"}),this._updateWorkerData(function(t){return t?e.fire("error",{error:t}):void e.fire("data",{dataType:"source"})}),this},e.prototype._updateWorkerData=function(t){var e=this,o=util.extend({},this.workerOptions),i=this._data;"string"==typeof i?o.url=resolveURL(i):o.data=JSON.stringify(i),this.workerID=this.dispatcher.send(this.type+".loadData",o,function(o){e._loaded=!0,t(o)})},e.prototype.loadTile=function(t,e){var o=this,i=t.coord.z>this.maxzoom?Math.pow(2,t.coord.z-this.maxzoom):1,r={type:this.type,uid:t.uid,coord:t.coord,zoom:t.coord.z,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,overscaling:i,angle:this.map.transform.angle,pitch:this.map.transform.pitch,showCollisionBoxes:this.map.showCollisionBoxes};t.workerID=this.dispatcher.send("loadTile",r,function(i,r){if(t.unloadVectorData(),!t.aborted)return i?e(i):(t.loadVectorData(r,o.map.painter),t.redoWhenDone&&(t.redoWhenDone=!1,t.redoPlacement(o)),e(null))},this.workerID)},e.prototype.abortTile=function(t){t.aborted=!0},e.prototype.unloadTile=function(t){t.unloadVectorData(),this.dispatcher.send("removeTile",{uid:t.uid,type:this.type,source:this.id},function(){},t.workerID)},e.prototype.onRemove=function(){this.dispatcher.broadcast("removeSource",{type:this.type,source:this.id},function(){})},e.prototype.serialize=function(){return{type:this.type,data:this._data}},e}(Evented);module.exports=GeoJSONSource;
	},{"../data/extent":11,"../util/evented":116,"../util/util":127,"../util/window":110}],41:[function(require,module,exports){
	"use strict";var ajax=require("../util/ajax"),rewind=require("geojson-rewind"),GeoJSONWrapper=require("./geojson_wrapper"),vtpbf=require("vt-pbf"),supercluster=require("supercluster"),geojsonvt=require("geojson-vt"),VectorTileWorkerSource=require("./vector_tile_worker_source"),GeoJSONWorkerSource=function(e){function r(r,t,o){e.call(this,r,t),o&&(this.loadGeoJSON=o),this._geoJSONIndexes={}}return e&&(r.__proto__=e),r.prototype=Object.create(e&&e.prototype),r.prototype.constructor=r,r.prototype.loadVectorData=function(e,r){var t=e.source,o=e.coord;if(!this._geoJSONIndexes[t])return r(null,null);var n=this._geoJSONIndexes[t].getTile(Math.min(o.z,e.maxZoom),o.x,o.y);if(!n)return r(null,null);var u=new GeoJSONWrapper(n.features);u.name="_geojsonTileLayer";var a=vtpbf({layers:{_geojsonTileLayer:u}});0===a.byteOffset&&a.byteLength===a.buffer.byteLength||(a=new Uint8Array(a)),u.rawData=a.buffer,r(null,u)},r.prototype.loadData=function(e,r){var t=function(t,o){var n=this;return t?r(t):"object"!=typeof o?r(new Error("Input data is not a valid GeoJSON object.")):(rewind(o,!0),void this._indexData(o,e,function(t,o){return t?r(t):(n._geoJSONIndexes[e.source]=o,void r(null))}))}.bind(this);this.loadGeoJSON(e,t)},r.prototype.loadGeoJSON=function(e,r){if(e.url)ajax.getJSON(e.url,r);else{if("string"!=typeof e.data)return r(new Error("Input data is not a valid GeoJSON object."));try{return r(null,JSON.parse(e.data))}catch(e){return r(new Error("Input data is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e){this._geoJSONIndexes[e.source]&&delete this._geoJSONIndexes[e.source]},r.prototype._indexData=function(e,r,t){try{r.cluster?t(null,supercluster(r.superclusterOptions).load(e.features)):t(null,geojsonvt(e,r.geojsonVtOptions))}catch(e){return t(e)}},r}(VectorTileWorkerSource);module.exports=GeoJSONWorkerSource;
	},{"../util/ajax":107,"./geojson_wrapper":42,"./vector_tile_worker_source":53,"geojson-rewind":137,"geojson-vt":141,"supercluster":198,"vt-pbf":208}],42:[function(require,module,exports){
	"use strict";var Point=require("point-geometry"),VectorTileFeature=require("vector-tile").VectorTileFeature,EXTENT=require("../data/extent"),FeatureWrapper=function(e){var t=this;if(this.type=e.type,1===e.type){this.rawGeometry=[];for(var r=0;r<e.geometry.length;r++)t.rawGeometry.push([e.geometry[r]])}else this.rawGeometry=e.geometry;this.properties=e.tags,this.extent=EXTENT};FeatureWrapper.prototype.loadGeometry=function(){var e=this,t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var o=t[r],a=[],i=0;i<o.length;i++)a.push(new Point(o[i][0],o[i][1]));e.geometry.push(a)}return this.geometry},FeatureWrapper.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-(1/0),o=1/0,a=-(1/0),i=0;i<e.length;i++)for(var p=e[i],h=0;h<p.length;h++){var n=p[h];t=Math.min(t,n.x),r=Math.max(r,n.x),o=Math.min(o,n.y),a=Math.max(a,n.y)}return[t,o,r,a]},FeatureWrapper.prototype.toGeoJSON=function(){VectorTileFeature.prototype.toGeoJSON.call(this)};var GeoJSONWrapper=function(e){this.features=e,this.length=e.length,this.extent=EXTENT};GeoJSONWrapper.prototype.feature=function(e){return new FeatureWrapper(this.features[e])},module.exports=GeoJSONWrapper;
	},{"../data/extent":11,"point-geometry":194,"vector-tile":204}],43:[function(require,module,exports){
	"use strict";var util=require("../util/util"),window=require("../util/window"),TileCoord=require("./tile_coord"),LngLat=require("../geo/lng_lat"),Point=require("point-geometry"),Evented=require("../util/evented"),ajax=require("../util/ajax"),EXTENT=require("../data/extent"),RasterBoundsArray=require("../data/raster_bounds_array"),Buffer=require("../data/buffer"),VertexArrayObject=require("../render/vertex_array_object"),ImageSource=function(t){function e(e,r,o,i){t.call(this),this.id=e,this.dispatcher=o,this.coordinates=r.coordinates,this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.setEventedParent(i),this.fire("dataloading",{dataType:"source"}),this._load(r)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._load=function(t){var e=this;this.url=t.url,ajax.getImage(t.url,function(t,r){return t?e.fire("error",{error:t}):(e.image=r,void e._finishLoading())})},e.prototype._finishLoading=function(){this.fire("source.load"),this.map&&this.setCoordinates(this.coordinates)},e.prototype.onAdd=function(t){this.map=t,this.image&&this.setCoordinates(this.coordinates)},e.prototype.setCoordinates=function(t){this.coordinates=t;var e=this.map,r=t.map(function(t){return e.transform.locationCoordinate(LngLat.convert(t)).zoomTo(0)}),o=this.centerCoord=util.getCoordinatesCenter(r);return o.column=Math.round(o.column),o.row=Math.round(o.row),this.minzoom=this.maxzoom=o.zoom,this.coord=new TileCoord(o.zoom,o.column,o.row),this._tileCoords=r.map(function(t){var e=t.zoomTo(o.zoom);return new Point(Math.round((e.column-o.column)*EXTENT),Math.round((e.row-o.row)*EXTENT))}),this.fire("data",{dataType:"source"}),this},e.prototype._setTile=function(t){this.tile=t;var e=32767,r=new RasterBoundsArray;r.emplaceBack(this._tileCoords[0].x,this._tileCoords[0].y,0,0),r.emplaceBack(this._tileCoords[1].x,this._tileCoords[1].y,e,0),r.emplaceBack(this._tileCoords[3].x,this._tileCoords[3].y,0,e),r.emplaceBack(this._tileCoords[2].x,this._tileCoords[2].y,e,e),this.tile.buckets={},this.tile.boundsBuffer=Buffer.fromStructArray(r,Buffer.BufferType.VERTEX),this.tile.boundsVAO=new VertexArrayObject},e.prototype.prepare=function(){this.tile&&this.image&&this._prepareImage(this.map.painter.gl,this.image)},e.prototype._prepareImage=function(t,e){"loaded"!==this.tile.state?(this.tile.state="loaded",this.tile.texture=t.createTexture(),t.bindTexture(t.TEXTURE_2D,this.tile.texture),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,t.LINEAR),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,t.LINEAR),t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,e)):e instanceof window.HTMLVideoElement&&(t.bindTexture(t.TEXTURE_2D,this.tile.texture),t.texSubImage2D(t.TEXTURE_2D,0,0,0,t.RGBA,t.UNSIGNED_BYTE,e))},e.prototype.loadTile=function(t,e){this.coord&&this.coord.toString()===t.coord.toString()?(this._setTile(t),e(null)):(t.state="errored",e(null))},e.prototype.serialize=function(){return{type:"image",urls:this.url,coordinates:this.coordinates}},e}(Evented);module.exports=ImageSource;
	},{"../data/buffer":8,"../data/extent":11,"../data/raster_bounds_array":16,"../geo/lng_lat":19,"../render/vertex_array_object":39,"../util/ajax":107,"../util/evented":116,"../util/util":127,"../util/window":110,"./tile_coord":51,"point-geometry":194}],44:[function(require,module,exports){
	"use strict";var util=require("../util/util"),ajax=require("../util/ajax"),browser=require("../util/browser"),normalizeURL=require("../util/mapbox").normalizeSourceURL;module.exports=function(r,e){var i=function(r,i){if(r)return e(r);var t=util.pick(i,["tiles","minzoom","maxzoom","attribution"]);i.vector_layers&&(t.vectorLayers=i.vector_layers,t.vectorLayerIds=t.vectorLayers.map(function(r){return r.id})),e(null,t)};r.url?ajax.getJSON(normalizeURL(r.url),i):browser.frame(i.bind(null,null,r))};
	},{"../util/ajax":107,"../util/browser":108,"../util/mapbox":123,"../util/util":127}],45:[function(require,module,exports){
	"use strict";var EXTENT=require("../data/extent");module.exports=function(e,t,r){return t*(EXTENT/(e.tileSize*Math.pow(2,r-e.coord.z)))};
	},{"../data/extent":11}],46:[function(require,module,exports){
	"use strict";function sortTilesIn(e,r){var o=e.coord,t=r.coord;return o.z-t.z||o.y-t.y||o.w-t.w||o.x-t.x}function mergeRenderedFeatureLayers(e){for(var r=e[0]||{},o=1;o<e.length;o++){var t=e[o];for(var n in t){var a=t[n],i=r[n];if(void 0===i)i=r[n]=a;else for(var u=0;u<a.length;u++)i.push(a[u])}}return r}var TileCoord=require("./tile_coord");exports.rendered=function(e,r,o,t,n,a){var i=e.tilesIn(o);i.sort(sortTilesIn);for(var u=[],s=0;s<i.length;s++){var d=i[s];d.tile.featureIndex&&u.push(d.tile.featureIndex.query({queryGeometry:d.queryGeometry,scale:d.scale,tileSize:d.tile.tileSize,bearing:a,params:t},r))}return mergeRenderedFeatureLayers(u)},exports.source=function(e,r){for(var o=e.getRenderableIds().map(function(r){return e.getTileByID(r)}),t=[],n={},a=0;a<o.length;a++){var i=o[a],u=new TileCoord(Math.min(i.sourceMaxZoom,i.coord.z),i.coord.x,i.coord.y,0).id;n[u]||(n[u]=!0,i.querySourceFeatures(t,r))}return t};
	},{"./tile_coord":51}],47:[function(require,module,exports){
	"use strict";var util=require("../util/util"),ajax=require("../util/ajax"),Evented=require("../util/evented"),loadTileJSON=require("./load_tilejson"),normalizeURL=require("../util/mapbox").normalizeTileURL,RasterTileSource=function(e){function t(t,i,r,a){var o=this;e.call(this),this.id=t,this.dispatcher=r,this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,util.extend(this,util.pick(i,["url","scheme","tileSize"])),this.setEventedParent(a),this.fire("dataloading",{dataType:"source"}),loadTileJSON(i,function(e,t){return e?o.fire("error",e):(util.extend(o,t),o.fire("data",{dataType:"source"}),void o.fire("source.load"))})}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.onAdd=function(e){this.map=e},t.prototype.serialize=function(){return{type:"raster",url:this.url,tileSize:this.tileSize,tiles:this.tiles}},t.prototype.loadTile=function(e,t){function i(i,r){if(delete e.request,e.aborted)return this.state="unloaded",t(null);if(i)return this.state="errored",t(i);var a=this.map.painter.gl;e.texture=this.map.painter.getTileTexture(r.width),e.texture?(a.bindTexture(a.TEXTURE_2D,e.texture),a.texSubImage2D(a.TEXTURE_2D,0,0,0,a.RGBA,a.UNSIGNED_BYTE,r)):(e.texture=a.createTexture(),a.bindTexture(a.TEXTURE_2D,e.texture),a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MIN_FILTER,a.LINEAR_MIPMAP_NEAREST),a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MAG_FILTER,a.LINEAR),a.texParameteri(a.TEXTURE_2D,a.TEXTURE_WRAP_S,a.CLAMP_TO_EDGE),a.texParameteri(a.TEXTURE_2D,a.TEXTURE_WRAP_T,a.CLAMP_TO_EDGE),a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL,!0),a.texImage2D(a.TEXTURE_2D,0,a.RGBA,a.RGBA,a.UNSIGNED_BYTE,r),e.texture.size=r.width),a.generateMipmap(a.TEXTURE_2D),e.state="loaded",t(null)}var r=normalizeURL(e.coord.url(this.tiles,null,this.scheme),this.url,this.tileSize);e.request=ajax.getImage(r,i.bind(this))},t.prototype.abortTile=function(e){e.request&&(e.request.abort(),delete e.request)},t.prototype.unloadTile=function(e){e.texture&&this.map.painter.saveTileTexture(e.texture)},t}(Evented);module.exports=RasterTileSource;
	},{"../util/ajax":107,"../util/evented":116,"../util/mapbox":123,"../util/util":127,"./load_tilejson":44}],48:[function(require,module,exports){
	"use strict";var util=require("../util/util"),sourceTypes={vector:require("../source/vector_tile_source"),raster:require("../source/raster_tile_source"),geojson:require("../source/geojson_source"),video:require("../source/video_source"),image:require("../source/image_source")};exports.create=function(e,r,o,t){if(r=new sourceTypes[r.type](e,r,o,t),r.setEventedParent(t),r.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+r.id);return util.bindAll(["load","abort","unload","serialize","prepare"],r),r},exports.getType=function(e){return sourceTypes[e]},exports.setType=function(e,r){sourceTypes[e]=r};
	},{"../source/geojson_source":40,"../source/image_source":43,"../source/raster_tile_source":47,"../source/vector_tile_source":52,"../source/video_source":54,"../util/util":127}],49:[function(require,module,exports){
	"use strict";function coordinateToTilePoint(e,o,t){var r=t.zoomTo(Math.min(e.z,o));return{x:(r.column-(e.x+e.w*Math.pow(2,e.z)))*EXTENT,y:(r.row-e.y)*EXTENT}}function compareKeyZoom(e,o){return e%32-o%32}var Source=require("./source"),Tile=require("./tile"),Evented=require("../util/evented"),TileCoord=require("./tile_coord"),Cache=require("../util/lru_cache"),Coordinate=require("../geo/coordinate"),util=require("../util/util"),EXTENT=require("../data/extent"),SourceCache=function(e){function o(o,t,r){e.call(this),this.id=o,this.dispatcher=r,this._source=Source.create(o,t,r,this),this.on("source.load",function(){this.map&&this._source.onAdd&&this._source.onAdd(this.map),this._sourceLoaded=!0}),this.on("error",function(){this._sourceErrored=!0}),this.on("data",function(e){this._sourceLoaded&&"source"===e.dataType&&(this.reload(),this.transform&&this.update(this.transform))}),this._tiles={},this._cache=new Cache(0,this.unloadTile.bind(this)),this._isIdRenderable=this._isIdRenderable.bind(this)}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.onAdd=function(e){this.map=e,this._source&&this._source.onAdd&&this._source.onAdd(e)},o.prototype.onRemove=function(e){this._source&&this._source.onRemove&&this._source.onRemove(e)},o.prototype.loaded=function(){var e=this;if(this._sourceErrored)return!0;if(!this._sourceLoaded)return!1;for(var o in this._tiles){var t=e._tiles[o];if("loaded"!==t.state&&"errored"!==t.state)return!1}return!0},o.prototype.getSource=function(){return this._source},o.prototype.loadTile=function(e,o){return this._source.loadTile(e,o)},o.prototype.unloadTile=function(e){if(this._source.unloadTile)return this._source.unloadTile(e)},o.prototype.abortTile=function(e){if(this._source.abortTile)return this._source.abortTile(e)},o.prototype.serialize=function(){return this._source.serialize()},o.prototype.prepare=function(){if(this._sourceLoaded&&this._source.prepare)return this._source.prepare()},o.prototype.getIds=function(){return Object.keys(this._tiles).map(Number).sort(compareKeyZoom)},o.prototype.getRenderableIds=function(){return this.getIds().filter(this._isIdRenderable)},o.prototype._isIdRenderable=function(e){return this._tiles[e].hasData()&&!this._coveredTiles[e]},o.prototype.reload=function(){var e=this;this._cache.reset();for(var o in this._tiles){var t=e._tiles[o];"loading"!==t.state&&(t.state="reloading"),e.loadTile(e._tiles[o],e._tileLoaded.bind(e,e._tiles[o]))}},o.prototype._tileLoaded=function(e,o){return o?(e.state="errored",void this._source.fire("error",{tile:e,error:o})):(e.sourceCache=this,e.timeAdded=(new Date).getTime(),this._source.fire("data",{tile:e,coord:e.coord,dataType:"tile"}),void(this.map&&(this.map.painter.tileExtentVAO.vao=null)))},o.prototype.getTile=function(e){return this.getTileByID(e.id)},o.prototype.getTileByID=function(e){return this._tiles[e]},o.prototype.getZoom=function(e){return e.zoom+e.scaleZoom(e.tileSize/this._source.tileSize)},o.prototype.findLoadedChildren=function(e,o,t){var r=this,i=!1;for(var s in this._tiles){var a=r._tiles[s];if(!(t[s]||!a.hasData()||a.coord.z<=e.z||a.coord.z>o)){var n=Math.pow(2,Math.min(a.coord.z,r._source.maxzoom)-Math.min(e.z,r._source.maxzoom));if(Math.floor(a.coord.x/n)===e.x&&Math.floor(a.coord.y/n)===e.y)for(t[s]=!0,i=!0;a&&a.coord.z-1>e.z;){var d=a.coord.parent(r._source.maxzoom).id;a=r._tiles[d],a&&a.hasData()&&(delete t[s],t[d]=!0)}}}return i},o.prototype.findLoadedParent=function(e,o,t){for(var r=this,i=e.z-1;i>=o;i--){e=e.parent(r._source.maxzoom);var s=r._tiles[e.id];if(s&&s.hasData())return t[e.id]=!0,s;if(r._cache.has(e.id))return r.addTile(e),t[e.id]=!0,r._tiles[e.id]}},o.prototype.updateCacheSize=function(e){var o=Math.ceil(e.width/e.tileSize)+1,t=Math.ceil(e.height/e.tileSize)+1,r=o*t,i=5;this._cache.setMaxSize(Math.floor(r*i))},o.prototype.update=function(e){var t=this;if(this._sourceLoaded){var r,i,s;this.updateCacheSize(e);var a=(this._source.roundZoom?Math.round:Math.floor)(this.getZoom(e)),n=Math.max(a-o.maxOverzooming,this._source.minzoom),d=Math.max(a+o.maxUnderzooming,this._source.minzoom),c={};this._coveredTiles={};var h;for(h=this.used?this._source.coord?[this._source.coord]:e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}):[],r=0;r<h.length;r++)i=h[r],s=t.addTile(i),c[i.id]=!0,s.hasData()||t.findLoadedChildren(i,d,c)||t.findLoadedParent(i,n,c);for(var u={},l=Object.keys(c),p=0;p<l.length;p++){var _=l[p];i=TileCoord.fromID(_),s=t._tiles[_],s&&s.fadeEndTime>=Date.now()&&(t.findLoadedChildren(i,d,c)&&(c[_]=!0),t.findLoadedParent(i,n,u))}var m;for(m in u)c[m]||(t._coveredTiles[m]=!0);for(m in u)c[m]=!0;var f=util.keysDifference(this._tiles,c);for(r=0;r<f.length;r++)t.removeTile(+f[r]);this.transform=e}},o.prototype.addTile=function(e){var o=this._tiles[e.id];if(o)return o;var t=e.wrapped();if(o=this._tiles[t.id],o||(o=this._cache.get(t.id),o&&o.redoPlacement(this._source)),!o){var r=e.z,i=r>this._source.maxzoom?Math.pow(2,r-this._source.maxzoom):1;o=new Tile(t,this._source.tileSize*i,this._source.maxzoom),this.loadTile(o,this._tileLoaded.bind(this,o))}return o.uses++,this._tiles[e.id]=o,this._source.fire("dataloading",{tile:o,coord:o.coord,dataType:"tile"}),o},o.prototype.removeTile=function(e){var o=this._tiles[e];o&&(o.uses--,delete this._tiles[e],this._source.fire("data",{tile:o,coord:o.coord,dataType:"tile"}),o.uses>0||(o.hasData()?this._cache.add(o.coord.wrapped().id,o):(o.aborted=!0,this.abortTile(o),this.unloadTile(o))))},o.prototype.clearTiles=function(){var e=this;for(var o in this._tiles)e.removeTile(o);this._cache.reset()},o.prototype.tilesIn=function(e){for(var o=this,t={},r=this.getIds(),i=1/0,s=1/0,a=-(1/0),n=-(1/0),d=e[0].zoom,c=0;c<e.length;c++){var h=e[c];i=Math.min(i,h.column),s=Math.min(s,h.row),a=Math.max(a,h.column),n=Math.max(n,h.row)}for(var u=0;u<r.length;u++){var l=o._tiles[r[u]],p=TileCoord.fromID(r[u]),_=[coordinateToTilePoint(p,l.sourceMaxZoom,new Coordinate(i,s,d)),coordinateToTilePoint(p,l.sourceMaxZoom,new Coordinate(a,n,d))];if(_[0].x<EXTENT&&_[0].y<EXTENT&&_[1].x>=0&&_[1].y>=0){for(var m=[],f=0;f<e.length;f++)m.push(coordinateToTilePoint(p,l.sourceMaxZoom,e[f]));var v=t[l.coord.id];void 0===v&&(v=t[l.coord.id]={tile:l,coord:p,queryGeometry:[],scale:Math.pow(2,o.transform.zoom-l.coord.z)}),v.queryGeometry.push(m)}}var T=[];for(var y in t)T.push(t[y]);return T},o.prototype.redoPlacement=function(){for(var e=this,o=this.getIds(),t=0;t<o.length;t++){var r=e.getTileByID(o[t]);r.redoPlacement(e._source)}},o.prototype.getVisibleCoordinates=function(){for(var e=this,o=this.getRenderableIds().map(TileCoord.fromID),t=0,r=o;t<r.length;t+=1){var i=r[t];i.posMatrix=e.transform.calculatePosMatrix(i,e._source.maxzoom)}return o},o}(Evented);SourceCache.maxOverzooming=10,SourceCache.maxUnderzooming=3,module.exports=SourceCache;
	},{"../data/extent":11,"../geo/coordinate":18,"../util/evented":116,"../util/lru_cache":122,"../util/util":127,"./source":48,"./tile":50,"./tile_coord":51}],50:[function(require,module,exports){
	"use strict";var util=require("../util/util"),Bucket=require("../data/bucket"),FeatureIndex=require("../data/feature_index"),vt=require("vector-tile"),Protobuf=require("pbf"),GeoJSONFeature=require("../util/vectortile_to_geojson"),featureFilter=require("feature-filter"),CollisionTile=require("../symbol/collision_tile"),CollisionBoxArray=require("../symbol/collision_box"),SymbolInstancesArray=require("../symbol/symbol_instances"),SymbolQuadsArray=require("../symbol/symbol_quads"),Tile=function(e,t,i){this.coord=e,this.uid=util.uniqueId(),this.uses=0,this.tileSize=t,this.sourceMaxZoom=i,this.buckets={},this.state="loading"};Tile.prototype.registerFadeDuration=function(e,t){var i=t+this.timeAdded;i<Date.now()||this.fadeEndTime&&i<this.fadeEndTime||(this.fadeEndTime=i,e.set(this.fadeEndTime-Date.now()))},Tile.prototype.loadVectorData=function(e,t){this.hasData()&&this.unloadVectorData(t),this.state="loaded",e&&(e.rawTileData&&(this.rawTileData=e.rawTileData),this.collisionBoxArray=new CollisionBoxArray(e.collisionBoxArray),this.collisionTile=new CollisionTile(e.collisionTile,this.collisionBoxArray),this.symbolInstancesArray=new SymbolInstancesArray(e.symbolInstancesArray),this.symbolQuadsArray=new SymbolQuadsArray(e.symbolQuadsArray),this.featureIndex=new FeatureIndex(e.featureIndex,this.rawTileData,this.collisionTile),this.buckets=Bucket.deserialize(e.buckets,t.style))},Tile.prototype.reloadSymbolData=function(e,t){var i=this;if("unloaded"!==this.state){this.collisionTile=new CollisionTile(e.collisionTile,this.collisionBoxArray),this.featureIndex.setCollisionTile(this.collisionTile);for(var o in this.buckets){var s=i.buckets[o];"symbol"===s.type&&(s.destroy(),delete i.buckets[o])}util.extend(this.buckets,Bucket.deserialize(e.buckets,t))}},Tile.prototype.unloadVectorData=function(){var e=this;for(var t in this.buckets)e.buckets[t].destroy();this.buckets={},this.collisionBoxArray=null,this.symbolQuadsArray=null,this.symbolInstancesArray=null,this.collisionTile=null,this.featureIndex=null,this.state="unloaded"},Tile.prototype.redoPlacement=function(e){function t(t,i){this.reloadSymbolData(i,e.map.style),e.fire("data",{tile:this,coord:this.coord,dataType:"tile"}),e.map&&(e.map.painter.tileExtentVAO.vao=null),this.state="loaded",this.redoWhenDone&&(this.redoPlacement(e),this.redoWhenDone=!1)}if("vector"===e.type||"geojson"===e.type){if("loaded"!==this.state||"reloading"===this.state)return void(this.redoWhenDone=!0);this.state="reloading",e.dispatcher.send("redoPlacement",{type:e.type,uid:this.uid,source:e.id,angle:e.map.transform.angle,pitch:e.map.transform.pitch,showCollisionBoxes:e.map.showCollisionBoxes},t.bind(this),this.workerID)}},Tile.prototype.getBucket=function(e){return this.buckets[e.id]},Tile.prototype.querySourceFeatures=function(e,t){var i=this;if(this.rawTileData){this.vtLayers||(this.vtLayers=new vt.VectorTile(new Protobuf(this.rawTileData)).layers);var o=this.vtLayers._geojsonTileLayer||this.vtLayers[t.sourceLayer];if(o)for(var s=featureFilter(t&&t.filter),r={z:this.coord.z,x:this.coord.x,y:this.coord.y},a=0;a<o.length;a++){var l=o.feature(a);if(s(l)){var n=new GeoJSONFeature(l,i.coord.z,i.coord.x,i.coord.y);n.tile=r,e.push(n)}}}},Tile.prototype.hasData=function(){return"loaded"===this.state||"reloading"===this.state},module.exports=Tile;
	},{"../data/bucket":2,"../data/feature_index":12,"../symbol/collision_box":76,"../symbol/collision_tile":78,"../symbol/symbol_instances":87,"../symbol/symbol_quads":88,"../util/util":127,"../util/vectortile_to_geojson":128,"feature-filter":135,"pbf":193,"vector-tile":204}],51:[function(require,module,exports){
	"use strict";function edge(t,i){if(t.row>i.row){var o=t;t=i,i=o}return{x0:t.column,y0:t.row,x1:i.column,y1:i.row,dx:i.column-t.column,dy:i.row-t.row}}function scanSpans(t,i,o,r,e){var n=Math.max(o,Math.floor(i.y0)),h=Math.min(r,Math.ceil(i.y1));if(t.x0===i.x0&&t.y0===i.y0?t.x0+i.dy/t.dy*t.dx<i.x1:t.x1-i.dy/t.dy*t.dx<i.x0){var s=t;t=i,i=s}for(var a=t.dx/t.dy,d=i.dx/i.dy,y=t.dx>0,l=i.dx<0,u=n;u<h;u++){var x=a*Math.max(0,Math.min(t.dy,u+y-t.y0))+t.x0,c=d*Math.max(0,Math.min(i.dy,u+l-i.y0))+i.x0;e(Math.floor(c),Math.ceil(x),u)}}function scanTriangle(t,i,o,r,e,n){var h,s=edge(t,i),a=edge(i,o),d=edge(o,t);s.dy>a.dy&&(h=s,s=a,a=h),s.dy>d.dy&&(h=s,s=d,d=h),a.dy>d.dy&&(h=a,a=d,d=h),s.dy&&scanSpans(d,s,r,e,n),a.dy&&scanSpans(d,a,r,e,n)}function getQuadkey(t,i,o){for(var r,e="",n=t;n>0;n--)r=1<<n-1,e+=(i&r?1:0)+(o&r?2:0);return e}var WhooTS=require("whoots-js"),Coordinate=require("../geo/coordinate"),TileCoord=function(t,i,o,r){isNaN(r)&&(r=0),this.z=+t,this.x=+i,this.y=+o,this.w=+r,r*=2,r<0&&(r=r*-1-1);var e=1<<this.z;this.id=32*(e*e*r+e*this.y+this.x)+this.z,this.posMatrix=null};TileCoord.prototype.toString=function(){return this.z+"/"+this.x+"/"+this.y},TileCoord.prototype.toCoordinate=function(t){var i=Math.min(this.z,void 0===t?this.z:t),o=Math.pow(2,i),r=this.y,e=this.x+o*this.w;return new Coordinate(e,r,i)},TileCoord.prototype.url=function(t,i,o){var r=WhooTS.getTileBBox(this.x,this.y,this.z),e=getQuadkey(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",Math.min(this.z,i||this.z)).replace("{x}",this.x).replace("{y}","tms"===o?Math.pow(2,this.z)-this.y-1:this.y).replace("{quadkey}",e).replace("{bbox-epsg-3857}",r)},TileCoord.prototype.parent=function(t){return 0===this.z?null:this.z>t?new TileCoord(this.z-1,this.x,this.y,this.w):new TileCoord(this.z-1,Math.floor(this.x/2),Math.floor(this.y/2),this.w)},TileCoord.prototype.wrapped=function(){return new TileCoord(this.z,this.x,this.y,0)},TileCoord.prototype.children=function(t){if(this.z>=t)return[new TileCoord(this.z+1,this.x,this.y,this.w)];var i=this.z+1,o=2*this.x,r=2*this.y;return[new TileCoord(i,o,r,this.w),new TileCoord(i,o+1,r,this.w),new TileCoord(i,o,r+1,this.w),new TileCoord(i,o+1,r+1,this.w)]},TileCoord.cover=function(t,i,o){function r(t,i,r){var h,s,a;if(r>=0&&r<=e)for(h=t;h<i;h++)s=(h%e+e)%e,a=new TileCoord(o,s,r,Math.floor(h/e)),n[a.id]=a}var e=1<<t,n={};return scanTriangle(i[0],i[1],i[2],0,e,r),scanTriangle(i[2],i[3],i[0],0,e,r),Object.keys(n).map(function(t){return n[t]})},TileCoord.fromID=function(t){var i=t%32,o=1<<i,r=(t-i)/32,e=r%o,n=(r-e)/o%o,h=Math.floor(r/(o*o));return h%2!==0&&(h=h*-1-1),h/=2,new TileCoord(i,e,n,h)},module.exports=TileCoord;
	},{"../geo/coordinate":18,"whoots-js":213}],52:[function(require,module,exports){
	"use strict";var Evented=require("../util/evented"),util=require("../util/util"),loadTileJSON=require("./load_tilejson"),normalizeURL=require("../util/mapbox").normalizeTileURL,VectorTileSource=function(e){function t(t,i,o,r){var l=this;if(e.call(this),this.id=t,this.dispatcher=o,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,util.extend(this,util.pick(i,["url","scheme","tileSize"])),this._options=util.extend({type:"vector"},i),512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(r),this.fire("dataloading",{dataType:"source"}),loadTileJSON(i,function(e,t){return e?void l.fire("error",e):(util.extend(l,t),l.fire("data",{dataType:"source"}),void l.fire("source.load"))})}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.onAdd=function(e){this.map=e},t.prototype.serialize=function(){return util.extend({},this._options)},t.prototype.loadTile=function(e,t){function i(i,o){if(!e.aborted){if(i)return t(i);e.loadVectorData(o,this.map.painter),e.redoWhenDone&&(e.redoWhenDone=!1,e.redoPlacement(this)),t(null),e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)}}var o=e.coord.z>this.maxzoom?Math.pow(2,e.coord.z-this.maxzoom):1,r={url:normalizeURL(e.coord.url(this.tiles,this.maxzoom,this.scheme),this.url),uid:e.uid,coord:e.coord,zoom:e.coord.z,tileSize:this.tileSize*o,type:this.type,source:this.id,overscaling:o,angle:this.map.transform.angle,pitch:this.map.transform.pitch,showCollisionBoxes:this.map.showCollisionBoxes};e.workerID?"loading"===e.state?e.reloadCallback=t:this.dispatcher.send("reloadTile",r,i.bind(this),e.workerID):e.workerID=this.dispatcher.send("loadTile",r,i.bind(this))},t.prototype.abortTile=function(e){this.dispatcher.send("abortTile",{uid:e.uid,type:this.type,source:this.id},null,e.workerID)},t.prototype.unloadTile=function(e){e.unloadVectorData(),this.dispatcher.send("removeTile",{uid:e.uid,type:this.type,source:this.id},null,e.workerID)},t}(Evented);module.exports=VectorTileSource;
	},{"../util/evented":116,"../util/mapbox":123,"../util/util":127,"./load_tilejson":44}],53:[function(require,module,exports){
	"use strict";var ajax=require("../util/ajax"),vt=require("vector-tile"),Protobuf=require("pbf"),WorkerTile=require("./worker_tile"),util=require("../util/util"),VectorTileWorkerSource=function(e,r,t){this.actor=e,this.layerIndex=r,t&&(this.loadVectorData=t),this.loading={},this.loaded={}};VectorTileWorkerSource.prototype.loadTile=function(e,r){function t(e,t){return delete this.loading[o][i],e?r(e):t?(a.vectorTile=t,a.parse(t,this.layerIndex,this.actor,function(e,o,i){return e?r(e):void r(null,util.extend({rawTileData:t.rawData},o),i)}),this.loaded[o]=this.loaded[o]||{},void(this.loaded[o][i]=a)):r(null,null)}var o=e.source,i=e.uid;this.loading[o]||(this.loading[o]={});var a=this.loading[o][i]=new WorkerTile(e);a.abort=this.loadVectorData(e,t.bind(this))},VectorTileWorkerSource.prototype.reloadTile=function(e,r){function t(e,t){if(this.reloadCallback){var o=this.reloadCallback;delete this.reloadCallback,this.parse(this.vectorTile,a.layerIndex,a.actor,o)}r(e,t)}var o=this.loaded[e.source],i=e.uid,a=this;if(o&&o[i]){var l=o[i];"parsing"===l.status?l.reloadCallback=r:"done"===l.status&&l.parse(l.vectorTile,this.layerIndex,this.actor,t.bind(l))}},VectorTileWorkerSource.prototype.abortTile=function(e){var r=this.loading[e.source],t=e.uid;r&&r[t]&&r[t].abort&&(r[t].abort(),delete r[t])},VectorTileWorkerSource.prototype.removeTile=function(e){var r=this.loaded[e.source],t=e.uid;r&&r[t]&&delete r[t]},VectorTileWorkerSource.prototype.loadVectorData=function(e,r){function t(e,t){if(e)return r(e);var o=new vt.VectorTile(new Protobuf(t));o.rawData=t,r(e,o)}var o=ajax.getArrayBuffer(e.url,t.bind(this));return function(){o.abort()}},VectorTileWorkerSource.prototype.redoPlacement=function(e,r){var t=this.loaded[e.source],o=this.loading[e.source],i=e.uid;if(t&&t[i]){var a=t[i],l=a.redoPlacement(e.angle,e.pitch,e.showCollisionBoxes);l.result&&r(null,l.result,l.transferables)}else o&&o[i]&&(o[i].angle=e.angle)},module.exports=VectorTileWorkerSource;
	},{"../util/ajax":107,"../util/util":127,"./worker_tile":56,"pbf":193,"vector-tile":204}],54:[function(require,module,exports){
	"use strict";var ajax=require("../util/ajax"),ImageSource=require("./image_source"),VideoSource=function(e){function t(t,o,i,r){e.call(this,t,o,i,r),this.roundZoom=!0}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype._load=function(e){var t=this;this.urls=e.urls,ajax.getVideo(e.urls,function(e,o){if(e)return t.fire("error",{error:e});t.video=o,t.video.loop=!0;var i;t.video.addEventListener("playing",function(){i=t.map.style.animationLoop.set(1/0),t.map._rerender()}),t.video.addEventListener("pause",function(){t.map.style.animationLoop.cancel(i)}),t.map&&t.video.play(),t._finishLoading()})},t.prototype.getVideo=function(){return this.video},t.prototype.onAdd=function(e){this.map||(this.map=e,this.video&&(this.video.play(),this.setCoordinates(this.coordinates)))},t.prototype.prepare=function(){!this.tile||this.video.readyState<2||this._prepareImage(this.map.painter.gl,this.video)},t.prototype.serialize=function(){return{type:"video",urls:this.urls,coordinates:this.coordinates}},t}(ImageSource);module.exports=VideoSource;
	},{"../util/ajax":107,"./image_source":43}],55:[function(require,module,exports){
	"use strict";var Actor=require("../util/actor"),StyleLayerIndex=require("../style/style_layer_index"),VectorTileWorkerSource=require("./vector_tile_worker_source"),GeoJSONWorkerSource=require("./geojson_worker_source"),Worker=function(e){var r=this;this.self=e,this.actor=new Actor(e,this),this.layerIndexes={},this.workerSourceTypes={vector:VectorTileWorkerSource,geojson:GeoJSONWorkerSource},this.workerSources={},this.self.registerWorkerSource=function(e,o){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=o}};Worker.prototype.setLayers=function(e,r){this.getLayerIndex(e).replace(r)},Worker.prototype.updateLayers=function(e,r){this.getLayerIndex(e).update(r.layers,r.removedIds,r.symbolOrder)},Worker.prototype.loadTile=function(e,r,o){this.getWorkerSource(e,r.type).loadTile(r,o)},Worker.prototype.reloadTile=function(e,r,o){this.getWorkerSource(e,r.type).reloadTile(r,o)},Worker.prototype.abortTile=function(e,r){this.getWorkerSource(e,r.type).abortTile(r)},Worker.prototype.removeTile=function(e,r){this.getWorkerSource(e,r.type).removeTile(r)},Worker.prototype.removeSource=function(e,r){var o=this.getWorkerSource(e,r.type);void 0!==o.removeSource&&o.removeSource(r)},Worker.prototype.redoPlacement=function(e,r,o){this.getWorkerSource(e,r.type).redoPlacement(r,o)},Worker.prototype.loadWorkerSource=function(e,r,o){try{this.self.importScripts(r.url),o()}catch(e){o(e)}},Worker.prototype.getLayerIndex=function(e){var r=this.layerIndexes[e];return r||(r=this.layerIndexes[e]=new StyleLayerIndex),r},Worker.prototype.getWorkerSource=function(e,r){var o=this;if(this.workerSources[e]||(this.workerSources[e]={}),!this.workerSources[e][r]){var t={send:function(r,t,i,s){o.actor.send(r,t,i,s,e)}};this.workerSources[e][r]=new this.workerSourceTypes[r](t,this.getLayerIndex(e))}return this.workerSources[e][r]},module.exports=function(e){return new Worker(e)};
	},{"../style/style_layer_index":69,"../util/actor":106,"./geojson_worker_source":41,"./vector_tile_worker_source":53}],56:[function(require,module,exports){
	"use strict";function recalculateLayers(e,r){for(var i=0,s=e.layers;i<s.length;i+=1){var o=s[i];o.recalculate(r)}}function serializeBuckets(e,r){return e.filter(function(e){return!e.isEmpty()}).map(function(e){return e.serialize(r)})}var FeatureIndex=require("../data/feature_index"),CollisionTile=require("../symbol/collision_tile"),CollisionBoxArray=require("../symbol/collision_box"),DictionaryCoder=require("../util/dictionary_coder"),util=require("../util/util"),SymbolInstancesArray=require("../symbol/symbol_instances"),SymbolQuadsArray=require("../symbol/symbol_quads"),WorkerTile=function(e){this.coord=e.coord,this.uid=e.uid,this.zoom=e.zoom,this.tileSize=e.tileSize,this.source=e.source,this.overscaling=e.overscaling,this.angle=e.angle,this.pitch=e.pitch,this.showCollisionBoxes=e.showCollisionBoxes};WorkerTile.prototype.parse=function(e,r,i,s){var o=this;e.layers||(e={layers:{_geojsonTileLayer:e}}),this.status="parsing",this.data=e,this.collisionBoxArray=new CollisionBoxArray,this.symbolInstancesArray=new SymbolInstancesArray,this.symbolQuadsArray=new SymbolQuadsArray;var l=new DictionaryCoder(Object.keys(e.layers).sort()),t=new FeatureIndex(this.coord,this.overscaling);t.bucketLayerIDs={};var a={},n=0,c={featureIndex:t,iconDependencies:{},glyphDependencies:{}},u=r.familiesBySource[this.source];for(var y in u){var h=e.layers[y];if(h){1===h.version&&util.warnOnce('Vector tile source "'+o.source+'" layer "'+y+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var m=l.encode(y),d=[],b=0;b<h.length;b++){var v=h.feature(b);v.index=b,v.sourceLayerIndex=m,d.push(v)}for(var f=0,p=u[y];f<p.length;f+=1){var g=p[f],x=g[0];if(!(x.minzoom&&o.zoom<x.minzoom||x.maxzoom&&o.zoom>=x.maxzoom||x.layout&&"none"===x.layout.visibility)){for(var z=0,A=g;z<A.length;z+=1){var B=A[z];B.recalculate(o.zoom)}var k=a[x.id]=x.createBucket({index:n,layers:g,zoom:o.zoom,overscaling:o.overscaling,collisionBoxArray:o.collisionBoxArray,symbolQuadsArray:o.symbolQuadsArray,symbolInstancesArray:o.symbolInstancesArray});k.populate(d,c),t.bucketLayerIDs[n]=g.map(function(e){return e.id}),n++}}}}var I=function(e){o.status="done";var r=[];s(null,{buckets:serializeBuckets(util.values(a),r),featureIndex:t.serialize(r),collisionTile:e.serialize(r),collisionBoxArray:o.collisionBoxArray.serialize(),symbolInstancesArray:o.symbolInstancesArray.serialize(),symbolQuadsArray:o.symbolQuadsArray.serialize()},r)};this.symbolBuckets=[];for(var w=r.symbolOrder.length-1;w>=0;w--){var C=a[r.symbolOrder[w]];C&&o.symbolBuckets.push(C)}if(0===this.symbolBuckets.length)return I(new CollisionTile(this.angle,this.pitch,this.collisionBoxArray));var T=0,q=Object.keys(c.iconDependencies),D=util.mapObject(c.glyphDependencies,function(e){return Object.keys(e).map(Number)}),O=function(e){if(e)return s(e);if(T++,2===T){for(var r=new CollisionTile(o.angle,o.pitch,o.collisionBoxArray),i=0,l=o.symbolBuckets;i<l.length;i+=1){var t=l[i];recalculateLayers(t,o.zoom),t.prepare(D,q),t.place(r,o.showCollisionBoxes)}I(r)}};Object.keys(D).length?i.send("getGlyphs",{uid:this.uid,stacks:D},function(e,r){D=r,O(e)}):O(),q.length?i.send("getIcons",{icons:q},function(e,r){q=r,O(e)}):O()},WorkerTile.prototype.redoPlacement=function(e,r,i){var s=this;if(this.angle=e,this.pitch=r,"done"!==this.status)return{};for(var o=new CollisionTile(this.angle,this.pitch,this.collisionBoxArray),l=0,t=this.symbolBuckets;l<t.length;l+=1){var a=t[l];recalculateLayers(a,s.zoom),a.place(o,i)}var n=[];return{result:{buckets:serializeBuckets(this.symbolBuckets,n),collisionTile:o.serialize(n)},transferables:n}},module.exports=WorkerTile;
	},{"../data/feature_index":12,"../symbol/collision_box":76,"../symbol/collision_tile":78,"../symbol/symbol_instances":87,"../symbol/symbol_quads":88,"../util/dictionary_coder":113,"../util/util":127}],57:[function(require,module,exports){
	"use strict";var AnimationLoop=function(){this.n=0,this.times=[]};AnimationLoop.prototype.stopped=function(){return this.times=this.times.filter(function(t){return t.time>=(new Date).getTime()}),!this.times.length},AnimationLoop.prototype.set=function(t){return this.times.push({id:this.n,time:t+(new Date).getTime()}),this.n++},AnimationLoop.prototype.cancel=function(t){this.times=this.times.filter(function(i){return i.id!==t})},module.exports=AnimationLoop;
	},{}],58:[function(require,module,exports){
	"use strict";var Evented=require("../util/evented"),ajax=require("../util/ajax"),browser=require("../util/browser"),normalizeURL=require("../util/mapbox").normalizeSpriteURL,SpritePosition=function(){this.x=0,this.y=0,this.width=0,this.height=0,this.pixelRatio=1,this.sdf=!1},ImageSprite=function(t){function i(i){var e=this;t.call(this),this.base=i,this.retina=browser.devicePixelRatio>1;var a=this.retina?"@2x":"";ajax.getJSON(normalizeURL(i,a,".json"),function(t,i){return t?void e.fire("error",{error:t}):(e.data=i,void(e.imgData&&e.fire("data",{dataType:"style"})))}),ajax.getImage(normalizeURL(i,a,".png"),function(t,i){if(t)return void e.fire("error",{error:t});e.imgData=browser.getImageData(i);for(var a=0;a<e.imgData.length;a+=4){var r=e.imgData[a+3]/255;e.imgData[a+0]*=r,e.imgData[a+1]*=r,e.imgData[a+2]*=r}e.width=i.width,e.data&&e.fire("data",{dataType:"style"})})}return t&&(i.__proto__=t),i.prototype=Object.create(t&&t.prototype),i.prototype.constructor=i,i.prototype.toJSON=function(){return this.base},i.prototype.loaded=function(){return!(!this.data||!this.imgData)},i.prototype.resize=function(){var t=this;if(browser.devicePixelRatio>1!==this.retina){var e=new i(this.base);e.on("data",function(){t.data=e.data,t.imgData=e.imgData,t.width=e.width,t.retina=e.retina})}},i.prototype.getSpritePosition=function(t){if(!this.loaded())return new SpritePosition;var i=this.data&&this.data[t];return i&&this.imgData?i:new SpritePosition},i}(Evented);module.exports=ImageSprite;
	},{"../util/ajax":107,"../util/browser":108,"../util/evented":116,"../util/mapbox":123}],59:[function(require,module,exports){
	"use strict";var styleSpec=require("./style_spec"),util=require("../util/util"),Evented=require("../util/evented"),validateStyle=require("./validate_style"),StyleDeclaration=require("./style_declaration"),StyleTransition=require("./style_transition"),TRANSITION_SUFFIX="-transition",Light=function(t){function i(i){t.call(this),this.properties=["anchor","color","position","intensity"],this._specifications=styleSpec.light,this.set(i)}return t&&(i.__proto__=t),i.prototype=Object.create(t&&t.prototype),i.prototype.constructor=i,i.prototype.set=function(t){var i=this;if(!this._validate(validateStyle.light,t)){this._declarations={},this._transitions={},this._transitionOptions={},this.calculated={},t=util.extend({anchor:this._specifications.anchor.default,color:this._specifications.color.default,position:this._specifications.position.default,intensity:this._specifications.intensity.default},t);for(var e=0,o=this.properties;e<o.length;e+=1){var n=o[e];i._declarations[n]=new StyleDeclaration(i._specifications[n],t[n])}return this}},i.prototype.getLight=function(){return{anchor:this.getLightProperty("anchor"),color:this.getLightProperty("color"),position:this.getLightProperty("position"),intensity:this.getLightProperty("intensity")}},i.prototype.getLightProperty=function(t){return util.endsWith(t,TRANSITION_SUFFIX)?this._transitionOptions[t]:this._declarations[t]&&this._declarations[t].value},i.prototype.getLightValue=function(t,i){if("position"===t){var e=this._transitions[t].calculate(i),o=util.sphericalToCartesian(e);return{x:o[0],y:o[1],z:o[2]}}return this._transitions[t].calculate(i)},i.prototype.setLight=function(t){var i=this;if(!this._validate(validateStyle.light,t))for(var e in t){var o=t[e];util.endsWith(e,TRANSITION_SUFFIX)?i._transitionOptions[e]=o:null===o||void 0===o?delete i._declarations[e]:i._declarations[e]=new StyleDeclaration(i._specifications[e],o)}},i.prototype.recalculate=function(t){var i=this;for(var e in this._declarations)i.calculated[e]=i.getLightValue(e,{zoom:t})},i.prototype._applyLightDeclaration=function(t,i,e,o,n){var r=e.transition?this._transitions[t]:void 0,a=this._specifications[t];if(null!==i&&void 0!==i||(i=new StyleDeclaration(a,a.default)),!r||r.declaration.json!==i.json){var s=util.extend({duration:300,delay:0},o,this.getLightProperty(t+TRANSITION_SUFFIX)),l=this._transitions[t]=new StyleTransition(a,i,r,s);l.instant()||(l.loopID=n.set(l.endTime-Date.now())),r&&n.cancel(r.loopID)}},i.prototype.updateLightTransitions=function(t,i,e){var o,n=this;for(o in this._declarations)n._applyLightDeclaration(o,n._declarations[o],t,i,e)},i.prototype._validate=function(t,i){return validateStyle.emitErrors(this,t.call(validateStyle,util.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:styleSpec})))},i}(Evented);module.exports=Light;
	},{"../util/evented":116,"../util/util":127,"./style_declaration":62,"./style_spec":70,"./style_transition":71,"./validate_style":72}],60:[function(require,module,exports){
	"use strict";var parseColorString=require("csscolorparser").parseCSSColor,util=require("../util/util"),MapboxGLFunction=require("mapbox-gl-function"),cache={};module.exports=function r(o){if(o&&MapboxGLFunction.isFunctionDefinition(o))return o.stops?util.extend({},o,{stops:o.stops.map(function(o){return[o[0],r(o[1])]})}):o;if("string"==typeof o){if(!cache[o]){var i=parseColorString(o);if(!i)throw new Error("Invalid color "+o);cache[o]=[i[0]/255*i[3],i[1]/255*i[3],i[2]/255*i[3],i[3]]}return cache[o]}if(Array.isArray(o))return o;throw new Error("Invalid color "+o)};
	},{"../util/util":127,"csscolorparser":132,"mapbox-gl-function":161}],61:[function(require,module,exports){
	"use strict";var Evented=require("../util/evented"),StyleLayer=require("./style_layer"),ImageSprite=require("./image_sprite"),Light=require("./light"),GlyphSource=require("../symbol/glyph_source"),SpriteAtlas=require("../symbol/sprite_atlas"),LineAtlas=require("../render/line_atlas"),util=require("../util/util"),ajax=require("../util/ajax"),mapbox=require("../util/mapbox"),browser=require("../util/browser"),Dispatcher=require("../util/dispatcher"),AnimationLoop=require("./animation_loop"),validateStyle=require("./validate_style"),Source=require("../source/source"),QueryFeatures=require("../source/query_features"),SourceCache=require("../source/source_cache"),styleSpec=require("./style_spec"),MapboxGLFunction=require("mapbox-gl-function"),getWorkerPool=require("../global_worker_pool"),deref=require("mapbox-gl-style-spec/lib/deref"),diff=require("mapbox-gl-style-spec/lib/diff"),supportedDiffOperations=util.pick(diff.operations,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition"]),ignoredDiffOperations=util.pick(diff.operations,["setCenter","setZoom","setBearing","setPitch"]),Style=function(e){function t(t,r,i){var s=this;e.call(this),this.map=r,this.animationLoop=r&&r.animationLoop||new AnimationLoop,this.dispatcher=new Dispatcher(getWorkerPool(),this),this.spriteAtlas=new SpriteAtlas(1024,1024),this.lineAtlas=new LineAtlas(256,512),this._layers={},this._order=[],this.sourceCaches={},this.zoomHistory={},this._loaded=!1,util.bindAll(["_redoPlacement"],this),this._resetUpdates(),i=util.extend({validate:"string"!=typeof t||!mapbox.isMapboxURL(t)},i),this.setEventedParent(r),this.fire("dataloading",{dataType:"style"});var o=function(e,t){if(e)return void s.fire("error",{error:e});if(!i.validate||!validateStyle.emitErrors(s,validateStyle(t))){s._loaded=!0,s.stylesheet=t,s.updateClasses();for(var r in t.sources)s.addSource(r,t.sources[r],i);t.sprite&&(s.sprite=new ImageSprite(t.sprite),s.sprite.setEventedParent(s)),s.glyphSource=new GlyphSource(t.glyphs),s._resolve(),s.fire("data",{dataType:"style"}),s.fire("style.load")}};"string"==typeof t?ajax.getJSON(mapbox.normalizeStyleURL(t),o):browser.frame(o.bind(this,null,t)),this.on("source.load",function(e){var t=s.sourceCaches[e.sourceId].getSource();if(t&&t.vectorLayerIds)for(var r in s._layers){var i=s._layers[r];i.source===t.id&&s._validateLayer(i)}})}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype._validateLayer=function(e){var t=this.sourceCaches[e.source];if(e.sourceLayer&&t){var r=t.getSource();r.vectorLayerIds&&r.vectorLayerIds.indexOf(e.sourceLayer)===-1&&this.fire("error",{error:new Error('Source layer "'+e.sourceLayer+'" does not exist on source "'+r.id+'" as specified by style layer "'+e.id+'"')})}},t.prototype.loaded=function(){var e=this;if(!this._loaded)return!1;if(Object.keys(this._updatedSources).length)return!1;for(var t in this.sourceCaches)if(!e.sourceCaches[t].loaded())return!1;return!(this.sprite&&!this.sprite.loaded())},t.prototype._resolve=function(){var e=this,t=deref(this.stylesheet.layers);this._order=t.map(function(e){return e.id}),this._layers={};for(var r=0,i=t;r<i.length;r+=1){var s=i[r];s=StyleLayer.create(s),s.setEventedParent(e,{layer:{id:s.id}}),e._layers[s.id]=s}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new Light(this.stylesheet.light)},t.prototype._serializeLayers=function(e){var t=this;return e.map(function(e){return t._layers[e].serialize()})},t.prototype._applyClasses=function(e,t){var r=this;if(this._loaded){e=e||[],t=t||{transition:!0};var i=this.stylesheet.transition||{},s=this._updatedAllPaintProps?this._layers:this._updatedPaintProps;for(var o in s){var a=r._layers[o],n=r._updatedPaintProps[o];if(r._updatedAllPaintProps||n.all)a.updatePaintTransitions(e,t,i,r.animationLoop,r.zoomHistory);else for(var l in n)r._layers[o].updatePaintTransition(l,e,t,i,r.animationLoop,r.zoomHistory)}this.light.updateLightTransitions(t,i,this.animationLoop)}},t.prototype._recalculate=function(e){var t=this;if(this._loaded){for(var r in this.sourceCaches)t.sourceCaches[r].used=!1;this._updateZoomHistory(e);for(var i=0,s=this._order;i<s.length;i+=1){var o=s[i],a=t._layers[o];a.recalculate(e),!a.isHidden(e)&&a.source&&(t.sourceCaches[a.source].used=!0)}this.light.recalculate(e);var n=300;Math.floor(this.z)!==Math.floor(e)&&this.animationLoop.set(n),this.z=e}},t.prototype._updateZoomHistory=function(e){var t=this.zoomHistory;void 0===t.lastIntegerZoom&&(t.lastIntegerZoom=Math.floor(e),t.lastIntegerZoomTime=0,t.lastZoom=e),Math.floor(t.lastZoom)<Math.floor(e)?(t.lastIntegerZoom=Math.floor(e),t.lastIntegerZoomTime=Date.now()):Math.floor(t.lastZoom)>Math.floor(e)&&(t.lastIntegerZoom=Math.floor(e+1),t.lastIntegerZoomTime=Date.now()),t.lastZoom=e},t.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},t.prototype.update=function(e,t){var r=this;if(this._changed){var i=Object.keys(this._updatedLayers),s=Object.keys(this._removedLayers);(i.length||s.length||this._updatedSymbolOrder)&&this._updateWorkerLayers(i,s);for(var o in this._updatedSources){var a=r._updatedSources[o];"reload"===a?r._reloadSource(o):"clear"===a&&r._clearSource(o)}this._applyClasses(e,t),this._resetUpdates(),this.fire("data",{dataType:"style"})}},t.prototype._updateWorkerLayers=function(e,t){var r=this,i=this._updatedSymbolOrder?this._order.filter(function(e){return"symbol"===r._layers[e].type}):null;this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(e),removedIds:t,symbolOrder:i})},t.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSymbolOrder=!1,this._updatedSources={},this._updatedPaintProps={},this._updatedAllPaintProps=!1},t.prototype.setState=function(e){var t=this;if(this._checkLoaded(),validateStyle.emitErrors(this,validateStyle(e)))return!1;e=util.extend({},e),e.layers=deref(e.layers);var r=diff(this.serialize(),e).filter(function(e){return!(e.command in ignoredDiffOperations)});if(0===r.length)return!1;var i=r.filter(function(e){return!(e.command in supportedDiffOperations)});if(i.length>0)throw new Error("Unimplemented: "+i.map(function(e){return e.command}).join(", ")+".");return r.forEach(function(e){"setTransition"!==e.command&&t[e.command].apply(t,e.args)}),this.stylesheet=e,!0},t.prototype.addSource=function(e,t,r){if(this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!t.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(t)+".");var i=["vector","raster","geojson","video","image"],s=i.indexOf(t.type)>=0;if(!s||!this._validate(validateStyle.source,"sources."+e,t,null,r)){var o=this.sourceCaches[e]=new SourceCache(e,t,this.dispatcher);o.style=this,o.setEventedParent(this,function(){return{isSourceLoaded:o.loaded(),source:o.serialize(),sourceId:e}}),o.onAdd(this.map),this._changed=!0}},t.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");var t=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],t.setEventedParent(null),t.clearTiles(),t.onRemove&&t.onRemove(this.map),this._changed=!0},t.prototype.getSource=function(e){return this.sourceCaches[e]&&this.sourceCaches[e].getSource()},t.prototype.addLayer=function(e,t,r){this._checkLoaded();var i=e.id;if(!this._validate(validateStyle.layer,"layers."+i,e,{arrayIndex:-1},r)){var s=StyleLayer.create(e);this._validateLayer(s),s.setEventedParent(this,{layer:{id:i}});var o=t?this._order.indexOf(t):this._order.length;this._order.splice(o,0,i),this._layers[i]=s,this._removedLayers[i]&&(delete this._removedLayers[i],this._updatedSources[s.source]="clear"),this._updateLayer(s),"symbol"===s.type&&(this._updatedSymbolOrder=!0),this.updateClasses(i)}},t.prototype.moveLayer=function(e,t){this._checkLoaded(),this._changed=!0;var r=this._layers[e];if(!r)throw new Error("Layer not found: "+e);var i=this._order.indexOf(e);this._order.splice(i,1);var s=t?this._order.indexOf(t):this._order.length;this._order.splice(s,0,e),"symbol"===r.type&&(this._updatedSymbolOrder=!0,r.source&&!this._updatedSources[r.source]&&(this._updatedSources[r.source]="reload"))},t.prototype.removeLayer=function(e){this._checkLoaded();var t=this._layers[e];if(!t)throw new Error("Layer not found: "+e);t.setEventedParent(null);var r=this._order.indexOf(e);this._order.splice(r,1),"symbol"===t.type&&(this._updatedSymbolOrder=!0),this._changed=!0,this._removedLayers[e]=!0,delete this._layers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e]},t.prototype.getLayer=function(e){return this._layers[e]},t.prototype.setLayerZoomRange=function(e,t,r){this._checkLoaded();var i=this.getLayer(e);i.minzoom===t&&i.maxzoom===r||(null!=t&&(i.minzoom=t),null!=r&&(i.maxzoom=r),this._updateLayer(i))},t.prototype.setFilter=function(e,t){this._checkLoaded();var r=this.getLayer(e);null!==t&&void 0!==t&&this._validate(validateStyle.filter,"layers."+r.id+".filter",t)||util.deepEqual(r.filter,t)||(r.filter=util.clone(t),this._updateLayer(r))},t.prototype.getFilter=function(e){return util.clone(this.getLayer(e).filter)},t.prototype.setLayoutProperty=function(e,t,r){this._checkLoaded();var i=this.getLayer(e);util.deepEqual(i.getLayoutProperty(t),r)||(i.setLayoutProperty(t,r),this._updateLayer(i))},t.prototype.getLayoutProperty=function(e,t){return this.getLayer(e).getLayoutProperty(t)},t.prototype.setPaintProperty=function(e,t,r,i){this._checkLoaded();var s=this.getLayer(e);if(!util.deepEqual(s.getPaintProperty(t,i),r)){var o=s.isPaintValueFeatureConstant(t);s.setPaintProperty(t,r,i);var a=!(r&&MapboxGLFunction.isFunctionDefinition(r)&&"$zoom"!==r.property&&void 0!==r.property);a&&o||this._updateLayer(s),this.updateClasses(e,t)}},t.prototype.getPaintProperty=function(e,t,r){return this.getLayer(e).getPaintProperty(t,r)},t.prototype.getTransition=function(){return util.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},t.prototype.updateClasses=function(e,t){if(this._changed=!0,e){var r=this._updatedPaintProps;r[e]||(r[e]={}),r[e][t||"all"]=!0}else this._updatedAllPaintProps=!0},t.prototype.serialize=function(){var e=this;return util.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:util.mapObject(this.sourceCaches,function(e){return e.serialize()}),layers:this._order.map(function(t){return e._layers[t].serialize()})},function(e){return void 0!==e})},t.prototype._updateLayer=function(e){this._updatedLayers[e.id]=!0,e.source&&!this._updatedSources[e.source]&&(this._updatedSources[e.source]="reload"),this._changed=!0},t.prototype._flattenRenderedFeatures=function(e){for(var t=this,r=[],i=this._order.length-1;i>=0;i--)for(var s=t._order[i],o=0,a=e;o<a.length;o+=1){var n=a[o],l=n[s];if(l)for(var h=0,u=l;h<u.length;h+=1){var d=u[h];r.push(d)}}return r},t.prototype.queryRenderedFeatures=function(e,t,r,i){var s=this;t&&t.filter&&this._validate(validateStyle.filter,"queryRenderedFeatures.filter",t.filter);var o={};if(t&&t.layers)for(var a=0,n=t.layers;a<n.length;a+=1){var l=n[a],h=s._layers[l];if(!h)return void s.fire("error",{error:"The layer '"+l+"' does not exist in the map's style and cannot be queried for features."});o[h.source]=!0}var u=[];for(var d in this.sourceCaches)if(!t.layers||o[d]){var c=QueryFeatures.rendered(s.sourceCaches[d],s._layers,e,t,r,i);u.push(c)}return this._flattenRenderedFeatures(u)},t.prototype.querySourceFeatures=function(e,t){t&&t.filter&&this._validate(validateStyle.filter,"querySourceFeatures.filter",t.filter);var r=this.sourceCaches[e];return r?QueryFeatures.source(r,t):[]},t.prototype.addSourceType=function(e,t,r){return Source.getType(e)?r(new Error('A source type called "'+e+'" already exists.')):(Source.setType(e,t),t.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:e,url:t.workerSourceURL},r):r(null,null))},t.prototype.getLight=function(){return this.light.getLight()},t.prototype.setLight=function(e,t){this._checkLoaded();var r=this.light.getLight(),i=!1;for(var s in e)if(!util.deepEqual(e[s],r[s])){i=!0;break}if(i){var o=this.stylesheet.transition||{};this.light.setLight(e),this.light.updateLightTransitions(t||{transition:!0},o,this.animationLoop)}},t.prototype._validate=function(e,t,r,i,s){return(!s||s.validate!==!1)&&validateStyle.emitErrors(this,e.call(validateStyle,util.extend({key:t,style:this.serialize(),value:r,styleSpec:styleSpec},i)))},t.prototype._remove=function(){var e=this;for(var t in this.sourceCaches)e.sourceCaches[t].clearTiles();this.dispatcher.remove()},t.prototype._clearSource=function(e){this.sourceCaches[e].clearTiles()},t.prototype._reloadSource=function(e){this.sourceCaches[e].reload()},t.prototype._updateSources=function(e){var t=this;for(var r in this.sourceCaches)t.sourceCaches[r].update(e)},t.prototype._redoPlacement=function(){var e=this;for(var t in this.sourceCaches)e.sourceCaches[t].redoPlacement()},t.prototype.getIcons=function(e,t,r){var i=this,s=function(){i.spriteAtlas.setSprite(i.sprite),i.spriteAtlas.addIcons(t.icons,r)};this.sprite.loaded()?s():this.sprite.on("data",s)},t.prototype.getGlyphs=function(e,t,r){function i(e,t,i){e&&console.error(e),n[i]=t,a--,0===a&&r(null,n)}var s=this,o=t.stacks,a=Object.keys(o).length,n={};for(var l in o)s.glyphSource.getSimpleGlyphs(l,o[l],t.uid,i)},t}(Evented);module.exports=Style;
	},{"../global_worker_pool":22,"../render/line_atlas":35,"../source/query_features":46,"../source/source":48,"../source/source_cache":49,"../symbol/glyph_source":81,"../symbol/sprite_atlas":86,"../util/ajax":107,"../util/browser":108,"../util/dispatcher":114,"../util/evented":116,"../util/mapbox":123,"../util/util":127,"./animation_loop":57,"./image_sprite":58,"./light":59,"./style_layer":63,"./style_spec":70,"./validate_style":72,"mapbox-gl-function":161,"mapbox-gl-style-spec/lib/deref":162,"mapbox-gl-style-spec/lib/diff":163}],62:[function(require,module,exports){
	"use strict";var MapboxGLFunction=require("mapbox-gl-function"),parseColor=require("./parse_color"),util=require("../util/util"),StyleDeclaration=function(t,o){var i=this;this.value=util.clone(o),this.isFunction=MapboxGLFunction.isFunctionDefinition(o),this.json=JSON.stringify(this.value),this.minimum=t.minimum,this.isColor="color"===t.type;var n=this.isColor&&this.value?parseColor(this.value):o,s=t.default;if(s&&"color"===t.type&&(s=parseColor(s)),this.function=MapboxGLFunction[t.function||"piecewise-constant"](n,s),this.isFeatureConstant=this.function.isFeatureConstant,this.isZoomConstant=this.function.isZoomConstant,!this.isFeatureConstant&&!this.isZoomConstant){this.stopZoomLevels=[];for(var e=[],a=0,r=this.value.stops;a<r.length;a+=1){var l=r[a],u=l[0].zoom;i.stopZoomLevels.indexOf(u)<0&&(i.stopZoomLevels.push(u),e.push([u,e.length]))}this.functionInterpolationT=MapboxGLFunction.interpolated({stops:e,base:o.base,colorSpace:o.colorSpace})}};StyleDeclaration.prototype.calculate=function(t,o){var i=this.function(t&&t.zoom,o||{});return this.isColor&&i?parseColor(i):void 0!==this.minimum&&i<this.minimum?this.minimum:i},StyleDeclaration.prototype.calculateInterpolationT=function(t,o){return this.functionInterpolationT(t&&t.zoom,o||{})},module.exports=StyleDeclaration;
	},{"../util/util":127,"./parse_color":60,"mapbox-gl-function":161}],63:[function(require,module,exports){
	"use strict";function getDeclarationValue(t){return t.value}var util=require("../util/util"),StyleTransition=require("./style_transition"),StyleDeclaration=require("./style_declaration"),styleSpec=require("./style_spec"),validateStyle=require("./validate_style"),parseColor=require("./parse_color"),Evented=require("../util/evented"),TRANSITION_SUFFIX="-transition",StyleLayer=function(t){function i(i){var a=this;t.call(this),this.id=i.id,this.metadata=i.metadata,this.type=i.type,this.source=i.source,this.sourceLayer=i["source-layer"],this.minzoom=i.minzoom,this.maxzoom=i.maxzoom,this.filter=i.filter,this.paint={},this.layout={},this._paintSpecifications=styleSpec["paint_"+this.type],this._layoutSpecifications=styleSpec["layout_"+this.type],this._paintTransitions={},this._paintTransitionOptions={},this._paintDeclarations={},this._layoutDeclarations={},this._layoutFunctions={};var e,n,o={validate:!1};for(var r in i){var s=r.match(/^paint(?:\.(.*))?$/);if(s){var l=s[1]||"";for(e in i[r])a.setPaintProperty(e,i[r][e],l,o)}}for(n in i.layout)a.setLayoutProperty(n,i.layout[n],o);for(e in this._paintSpecifications)a.paint[e]=a.getPaintValue(e);for(n in this._layoutSpecifications)a._updateLayoutValue(n)}return t&&(i.__proto__=t),i.prototype=Object.create(t&&t.prototype),i.prototype.constructor=i,i.prototype.setLayoutProperty=function(t,i,a){if(null==i)delete this._layoutDeclarations[t];else{var e="layers."+this.id+".layout."+t;if(this._validate(validateStyle.layoutProperty,e,t,i,a))return;this._layoutDeclarations[t]=new StyleDeclaration(this._layoutSpecifications[t],i)}this._updateLayoutValue(t)},i.prototype.getLayoutProperty=function(t){return this._layoutDeclarations[t]&&this._layoutDeclarations[t].value},i.prototype.getLayoutValue=function(t,i,a){var e=this._layoutSpecifications[t],n=this._layoutDeclarations[t];return n?n.calculate(i,a):e.default},i.prototype.setPaintProperty=function(t,i,a,e){var n="layers."+this.id+(a?'["paint.'+a+'"].':".paint.")+t;if(util.endsWith(t,TRANSITION_SUFFIX))if(this._paintTransitionOptions[a||""]||(this._paintTransitionOptions[a||""]={}),null===i||void 0===i)delete this._paintTransitionOptions[a||""][t];else{if(this._validate(validateStyle.paintProperty,n,t,i,e))return;this._paintTransitionOptions[a||""][t]=i}else if(this._paintDeclarations[a||""]||(this._paintDeclarations[a||""]={}),null===i||void 0===i)delete this._paintDeclarations[a||""][t];else{if(this._validate(validateStyle.paintProperty,n,t,i,e))return;this._paintDeclarations[a||""][t]=new StyleDeclaration(this._paintSpecifications[t],i)}},i.prototype.getPaintProperty=function(t,i){return i=i||"",util.endsWith(t,TRANSITION_SUFFIX)?this._paintTransitionOptions[i]&&this._paintTransitionOptions[i][t]:this._paintDeclarations[i]&&this._paintDeclarations[i][t]&&this._paintDeclarations[i][t].value},i.prototype.getPaintValue=function(t,i,a){var e=this._paintSpecifications[t],n=this._paintTransitions[t];return n?n.calculate(i,a):"color"===e.type&&e.default?parseColor(e.default):e.default},i.prototype.getPaintValueStopZoomLevels=function(t){var i=this._paintTransitions[t];return i?i.declaration.stopZoomLevels:[]},i.prototype.getPaintInterpolationT=function(t,i){var a=this._paintTransitions[t];return a.declaration.calculateInterpolationT(i)},i.prototype.isPaintValueFeatureConstant=function(t){var i=this._paintTransitions[t];return!i||i.declaration.isFeatureConstant},i.prototype.isLayoutValueFeatureConstant=function(t){var i=this._layoutDeclarations[t];return!i||i.isFeatureConstant},i.prototype.isPaintValueZoomConstant=function(t){var i=this._paintTransitions[t];return!i||i.declaration.isZoomConstant},i.prototype.isHidden=function(t){return!!(this.minzoom&&t<this.minzoom)||(!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.layout.visibility)},i.prototype.updatePaintTransitions=function(t,i,a,e,n){for(var o=this,r=util.extend({},this._paintDeclarations[""]),s=0;s<t.length;s++)util.extend(r,o._paintDeclarations[t[s]]);var l;for(l in r)o._applyPaintDeclaration(l,r[l],i,a,e,n);for(l in this._paintTransitions)l in r||o._applyPaintDeclaration(l,null,i,a,e,n)},i.prototype.updatePaintTransition=function(t,i,a,e,n,o){for(var r=this,s=this._paintDeclarations[""][t],l=0;l<i.length;l++){var u=r._paintDeclarations[i[l]];u&&u[t]&&(s=u[t])}this._applyPaintDeclaration(t,s,a,e,n,o)},i.prototype.recalculate=function(t){var i=this;for(var a in this._paintTransitions)i.paint[a]=i.getPaintValue(a,{zoom:t});for(var e in this._layoutFunctions)i.layout[e]=i.getLayoutValue(e,{zoom:t})},i.prototype.serialize=function(){var t=this,i={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:util.mapObject(this._layoutDeclarations,getDeclarationValue)};for(var a in this._paintDeclarations){var e=""===a?"paint":"paint."+a;i[e]=util.mapObject(t._paintDeclarations[a],getDeclarationValue)}return util.filterObject(i,function(t,i){return void 0!==t&&!("layout"===i&&!Object.keys(t).length)})},i.prototype._applyPaintDeclaration=function(t,i,a,e,n,o){var r=a.transition?this._paintTransitions[t]:void 0,s=this._paintSpecifications[t];if(null!==i&&void 0!==i||(i=new StyleDeclaration(s,s.default)),!r||r.declaration.json!==i.json){var l=util.extend({duration:300,delay:0},e,this.getPaintProperty(t+TRANSITION_SUFFIX)),u=this._paintTransitions[t]=new StyleTransition(s,i,r,l,o);u.instant()||(u.loopID=n.set(u.endTime-Date.now())),r&&n.cancel(r.loopID)}},i.prototype._updateLayoutValue=function(t){var i=this._layoutDeclarations[t];i&&i.isFunction?this._layoutFunctions[t]=!0:(delete this._layoutFunctions[t],this.layout[t]=this.getLayoutValue(t))},i.prototype._validate=function(t,i,a,e,n){return(!n||n.validate!==!1)&&validateStyle.emitErrors(this,t.call(validateStyle,{key:i,layerType:this.type,objectKey:a,value:e,styleSpec:styleSpec,style:{glyphs:!0,sprite:!0}}))},i}(Evented);module.exports=StyleLayer;var subclasses={circle:require("./style_layer/circle_style_layer"),fill:require("./style_layer/fill_style_layer"),"fill-extrusion":require("./style_layer/fill_extrusion_style_layer"),line:require("./style_layer/line_style_layer"),symbol:require("./style_layer/symbol_style_layer")};StyleLayer.create=function(t){var i=subclasses[t.type]||StyleLayer;return new i(t)};
	},{"../util/evented":116,"../util/util":127,"./parse_color":60,"./style_declaration":62,"./style_layer/circle_style_layer":64,"./style_layer/fill_extrusion_style_layer":65,"./style_layer/fill_style_layer":66,"./style_layer/line_style_layer":67,"./style_layer/symbol_style_layer":68,"./style_spec":70,"./style_transition":71,"./validate_style":72}],64:[function(require,module,exports){
	"use strict";var StyleLayer=require("../style_layer"),CircleBucket=require("../../data/bucket/circle_bucket"),CircleStyleLayer=function(e){function t(){e.apply(this,arguments)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.createBucket=function(e){return new CircleBucket(e)},t}(StyleLayer);module.exports=CircleStyleLayer;
	},{"../../data/bucket/circle_bucket":3,"../style_layer":63}],65:[function(require,module,exports){
	"use strict";var StyleLayer=require("../style_layer"),FillExtrusionBucket=require("../../data/bucket/fill_extrusion_bucket"),FillExtrusionStyleLayer=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getPaintValue=function(e,r,o){var l=t.prototype.getPaintValue.call(this,e,r,o);return"fill-extrusion-color"===e&&l&&(l[3]=1),l},e.prototype.createBucket=function(t){return new FillExtrusionBucket(t)},e}(StyleLayer);module.exports=FillExtrusionStyleLayer;
	},{"../../data/bucket/fill_extrusion_bucket":5,"../style_layer":63}],66:[function(require,module,exports){
	"use strict";var StyleLayer=require("../style_layer"),FillBucket=require("../../data/bucket/fill_bucket"),FillStyleLayer=function(t){function o(){t.apply(this,arguments)}return t&&(o.__proto__=t),o.prototype=Object.create(t&&t.prototype),o.prototype.constructor=o,o.prototype.getPaintValue=function(o,l,e){return"fill-outline-color"===o&&void 0===this.getPaintProperty("fill-outline-color")?t.prototype.getPaintValue.call(this,"fill-color",l,e):t.prototype.getPaintValue.call(this,o,l,e)},o.prototype.getPaintValueStopZoomLevels=function(o){return"fill-outline-color"===o&&void 0===this.getPaintProperty("fill-outline-color")?t.prototype.getPaintValueStopZoomLevels.call(this,"fill-color"):t.prototype.getPaintValueStopZoomLevels.call(this,o)},o.prototype.getPaintInterpolationT=function(o,l){return"fill-outline-color"===o&&void 0===this.getPaintProperty("fill-outline-color")?t.prototype.getPaintInterpolationT.call(this,"fill-color",l):t.prototype.getPaintInterpolationT.call(this,o,l)},o.prototype.isPaintValueFeatureConstant=function(o){return"fill-outline-color"===o&&void 0===this.getPaintProperty("fill-outline-color")?t.prototype.isPaintValueFeatureConstant.call(this,"fill-color"):t.prototype.isPaintValueFeatureConstant.call(this,o)},o.prototype.isPaintValueZoomConstant=function(o){return"fill-outline-color"===o&&void 0===this.getPaintProperty("fill-outline-color")?t.prototype.isPaintValueZoomConstant.call(this,"fill-color"):t.prototype.isPaintValueZoomConstant.call(this,o)},o.prototype.createBucket=function(t){return new FillBucket(t)},o}(StyleLayer);module.exports=FillStyleLayer;
	},{"../../data/bucket/fill_bucket":4,"../style_layer":63}],67:[function(require,module,exports){
	"use strict";var StyleLayer=require("../style_layer"),LineBucket=require("../../data/bucket/line_bucket"),util=require("../../util/util"),LineStyleLayer=function(e){function t(){e.apply(this,arguments)}return e&&(t.__proto__=e),t.prototype=Object.create(e&&e.prototype),t.prototype.constructor=t,t.prototype.getPaintValue=function(t,r,o){var i=e.prototype.getPaintValue.call(this,t,r,o);if(i&&"line-dasharray"===t){var a=this.getPaintValue("line-width",util.extend({},r,{zoom:Math.floor(r.zoom)}),o);i.fromScale*=a,i.toScale*=a}return i},t.prototype.createBucket=function(e){return new LineBucket(e)},t}(StyleLayer);module.exports=LineStyleLayer;
	},{"../../data/bucket/line_bucket":6,"../../util/util":127,"../style_layer":63}],68:[function(require,module,exports){
	"use strict";var StyleLayer=require("../style_layer"),SymbolBucket=require("../../data/bucket/symbol_bucket"),SymbolStyleLayer=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getLayoutValue=function(e,o,r){var a=t.prototype.getLayoutValue.call(this,e,o,r);if("auto"!==a)return a;switch(e){case"text-rotation-alignment":case"icon-rotation-alignment":return"line"===this.getLayoutValue("symbol-placement",o,r)?"map":"viewport";case"text-pitch-alignment":return this.getLayoutValue("text-rotation-alignment",o,r);default:return a}},e.prototype.createBucket=function(t){return new SymbolBucket(t)},e}(StyleLayer);module.exports=SymbolStyleLayer;
	},{"../../data/bucket/symbol_bucket":7,"../style_layer":63}],69:[function(require,module,exports){
	"use strict";var StyleLayer=require("./style_layer"),util=require("../util/util"),featureFilter=require("feature-filter"),groupByLayout=require("mapbox-gl-style-spec/lib/group_by_layout"),StyleLayerIndex=function(e){e&&this.replace(e)};StyleLayerIndex.prototype.replace=function(e){var r=this;this.symbolOrder=[];for(var t=0,a=e;t<a.length;t+=1){var i=a[t];"symbol"===i.type&&r.symbolOrder.push(i.id)}this._layers={},this.update(e,[])},StyleLayerIndex.prototype.update=function(e,r,t){for(var a=this,i=0,l=e;i<l.length;i+=1){var y=l[i];a._layers[y.id]=y}for(var o=0,u=r;o<u.length;o+=1){var s=u[o];delete a._layers[s]}t&&(this.symbolOrder=t),this.familiesBySource={};for(var n=groupByLayout(util.values(this._layers)),p=0,f=n;p<f.length;p+=1){var h=f[p];h=h.map(function(e){return e=StyleLayer.create(e),e.updatePaintTransitions({},{transition:!1}),e.filter=featureFilter(e.filter),e});var v=h[0];if(!v.layout||"none"!==v.layout.visibility){var c=v.source||"",d=a.familiesBySource[c];d||(d=a.familiesBySource[c]={});var m=v.sourceLayer||"_geojsonTileLayer",L=d[m];L||(L=d[m]=[]),L.push(h)}}},module.exports=StyleLayerIndex;
	},{"../util/util":127,"./style_layer":63,"feature-filter":135,"mapbox-gl-style-spec/lib/group_by_layout":165}],70:[function(require,module,exports){
	"use strict";module.exports=require("mapbox-gl-style-spec/reference/latest.min");
	},{"mapbox-gl-style-spec/reference/latest.min":188}],71:[function(require,module,exports){
	"use strict";function interpZoomTransitioned(t,i,o){if(void 0!==t&&void 0!==i)return{from:t.to,fromScale:t.toScale,to:i.to,toScale:i.toScale,t:o}}var util=require("../util/util"),interpolate=require("../util/interpolate"),fakeZoomHistory={lastIntegerZoom:0,lastIntegerZoomTime:0,lastZoom:0},StyleTransition=function(t,i,o,e,a){this.declaration=i,this.startTime=this.endTime=(new Date).getTime(),this.oldTransition=o,this.duration=e.duration||0,this.delay=e.delay||0,this.zoomTransitioned="piecewise-constant"===t.function&&t.transition,this.interp=this.zoomTransitioned?interpZoomTransitioned:interpolate[t.type],this.zoomHistory=a||fakeZoomHistory,this.instant()||(this.endTime=this.startTime+this.duration+this.delay),o&&o.endTime<=this.startTime&&delete o.oldTransition};StyleTransition.prototype.instant=function(){return!this.oldTransition||!this.interp||0===this.duration&&0===this.delay},StyleTransition.prototype.calculate=function(t,i,o){var e=this._calculateTargetValue(t,i);if(this.instant())return e;if(o=o||Date.now(),o>=this.endTime)return e;var a=this.oldTransition.calculate(t,i,this.startTime),n=util.easeCubicInOut((o-this.startTime-this.delay)/this.duration);return this.interp(a,e,n)},StyleTransition.prototype._calculateTargetValue=function(t,i){if(!this.zoomTransitioned)return this.declaration.calculate(t,i);var o=t.zoom,e=this.zoomHistory.lastIntegerZoom,a=o>e?2:.5,n=this.declaration.calculate({zoom:o>e?o-1:o+1},i),r=this.declaration.calculate({zoom:o},i),s=Math.min((Date.now()-this.zoomHistory.lastIntegerZoomTime)/this.duration,1),l=Math.abs(o-e),u=interpolate(s,1,l);return void 0!==n&&void 0!==r?{from:n,fromScale:a,to:r,toScale:1,t:u}:void 0},module.exports=StyleTransition;
	},{"../util/interpolate":119,"../util/util":127}],72:[function(require,module,exports){
	"use strict";module.exports=require("mapbox-gl-style-spec/lib/validate_style.min"),module.exports.emitErrors=function(r,e){if(e&&e.length){for(var t=0;t<e.length;t++)r.fire("error",{error:new Error(e[t].message)});return!0}return!1};
	},{"mapbox-gl-style-spec/lib/validate_style.min":187}],73:[function(require,module,exports){
	"use strict";var Point=require("point-geometry"),Anchor=function(t){function o(o,e,n,r){t.call(this,o,e),this.angle=n,void 0!==r&&(this.segment=r)}return t&&(o.__proto__=t),o.prototype=Object.create(t&&t.prototype),o.prototype.constructor=o,o.prototype.clone=function(){return new o(this.x,this.y,this.angle,this.segment)},o}(Point);module.exports=Anchor;
	},{"point-geometry":194}],74:[function(require,module,exports){
	"use strict";function checkMaxAngle(e,t,a,r,n){if(void 0===t.segment)return!0;for(var i=t,s=t.segment+1,f=0;f>-a/2;){if(s--,s<0)return!1;f-=e[s].dist(i),i=e[s]}f+=e[s].dist(e[s+1]),s++;for(var l=[],o=0;f<a/2;){var u=e[s-1],c=e[s],g=e[s+1];if(!g)return!1;var h=u.angleTo(c)-c.angleTo(g);for(h=Math.abs((h+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:f,angleDelta:h}),o+=h;f-l[0].distance>r;)o-=l.shift().angleDelta;if(o>n)return!1;s++,f+=c.dist(g)}return!0}module.exports=checkMaxAngle;
	},{}],75:[function(require,module,exports){
	"use strict";function clipLine(n,x,y,o,e){for(var r=[],t=0;t<n.length;t++)for(var i,u=n[t],d=0;d<u.length-1;d++){var P=u[d],w=u[d+1];P.x<x&&w.x<x||(P.x<x?P=new Point(x,P.y+(w.y-P.y)*((x-P.x)/(w.x-P.x)))._round():w.x<x&&(w=new Point(x,P.y+(w.y-P.y)*((x-P.x)/(w.x-P.x)))._round()),P.y<y&&w.y<y||(P.y<y?P=new Point(P.x+(w.x-P.x)*((y-P.y)/(w.y-P.y)),y)._round():w.y<y&&(w=new Point(P.x+(w.x-P.x)*((y-P.y)/(w.y-P.y)),y)._round()),P.x>=o&&w.x>=o||(P.x>=o?P=new Point(o,P.y+(w.y-P.y)*((o-P.x)/(w.x-P.x)))._round():w.x>=o&&(w=new Point(o,P.y+(w.y-P.y)*((o-P.x)/(w.x-P.x)))._round()),P.y>=e&&w.y>=e||(P.y>=e?P=new Point(P.x+(w.x-P.x)*((e-P.y)/(w.y-P.y)),e)._round():w.y>=e&&(w=new Point(P.x+(w.x-P.x)*((e-P.y)/(w.y-P.y)),e)._round()),i&&P.equals(i[i.length-1])||(i=[P],r.push(i)),i.push(w)))))}return r}var Point=require("point-geometry");module.exports=clipLine;
	},{"point-geometry":194}],76:[function(require,module,exports){
	"use strict";var createStructArrayType=require("../util/struct_array"),Point=require("point-geometry"),CollisionBoxArray=createStructArrayType({members:[{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Float32",name:"maxScale"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"},{type:"Int16",name:"bbox0"},{type:"Int16",name:"bbox1"},{type:"Int16",name:"bbox2"},{type:"Int16",name:"bbox3"},{type:"Float32",name:"placementScale"}]});Object.defineProperty(CollisionBoxArray.prototype.StructType.prototype,"anchorPoint",{get:function(){return new Point(this.anchorPointX,this.anchorPointY)}}),module.exports=CollisionBoxArray;
	},{"../util/struct_array":125,"point-geometry":194}],77:[function(require,module,exports){
	"use strict";var CollisionFeature=function(t,e,i,o,s,a,n,r,l,d,u){var h=n.top*r-l,x=n.bottom*r+l,f=n.left*r-l,m=n.right*r+l;if(this.boxStartIndex=t.length,d){var _=x-h,b=m-f;if(_>0)if(_=Math.max(10*r,_),u){var v=e[i.segment+1].sub(e[i.segment])._unit()._mult(b),c=[i.sub(v),i.add(v)];this._addLineCollisionBoxes(t,c,i,0,b,_,o,s,a)}else this._addLineCollisionBoxes(t,e,i,i.segment,b,_,o,s,a)}else t.emplaceBack(i.x,i.y,f,h,m,x,1/0,o,s,a,0,0,0,0,0);this.boxEndIndex=t.length};CollisionFeature.prototype._addLineCollisionBoxes=function(t,e,i,o,s,a,n,r,l){var d=a/2,u=Math.floor(s/d),h=-a/2,x=this.boxes,f=i,m=o+1,_=h;do{if(m--,m<0)return x;_-=e[m].dist(f),f=e[m]}while(_>-s/2);for(var b=e[m].dist(e[m+1]),v=0;v<u;v++){for(var c=-s/2+v*d;_+b<c;){if(_+=b,m++,m+1>=e.length)return x;b=e[m].dist(e[m+1])}var g=c-_,p=e[m],C=e[m+1],B=C.sub(p)._unit()._mult(g)._add(p)._round(),M=Math.max(Math.abs(c-h)-d/2,0),y=s/2/M;t.emplaceBack(B.x,B.y,-a/2,-a/2,a/2,a/2,y,n,r,l,0,0,0,0,0)}return x},module.exports=CollisionFeature;
	},{}],78:[function(require,module,exports){
	"use strict";var Point=require("point-geometry"),EXTENT=require("../data/extent"),Grid=require("grid-index"),intersectionTests=require("../util/intersection_tests"),CollisionTile=function(t,e,i){if("object"==typeof t){var r=t;i=e,t=r.angle,e=r.pitch,this.grid=new Grid(r.grid),this.ignoredGrid=new Grid(r.ignoredGrid)}else this.grid=new Grid(EXTENT,12,6),this.ignoredGrid=new Grid(EXTENT,12,0);this.minScale=.5,this.maxScale=2,this.angle=t,this.pitch=e;var a=Math.sin(t),o=Math.cos(t);if(this.rotationMatrix=[o,-a,a,o],this.reverseRotationMatrix=[o,a,-a,o],this.yStretch=1/Math.cos(e/180*Math.PI),this.yStretch=Math.pow(this.yStretch,1.3),this.collisionBoxArray=i,0===i.length){i.emplaceBack();var n=32767;i.emplaceBack(0,0,0,-n,0,n,n,0,0,0,0,0,0,0,0,0),i.emplaceBack(EXTENT,0,0,-n,0,n,n,0,0,0,0,0,0,0,0,0),i.emplaceBack(0,0,-n,0,n,0,n,0,0,0,0,0,0,0,0,0),i.emplaceBack(0,EXTENT,-n,0,n,0,n,0,0,0,0,0,0,0,0,0)}this.tempCollisionBox=i.get(0),this.edges=[i.get(1),i.get(2),i.get(3),i.get(4)]};CollisionTile.prototype.serialize=function(t){var e=this.grid.toArrayBuffer(),i=this.ignoredGrid.toArrayBuffer();return t&&(t.push(e),t.push(i)),{angle:this.angle,pitch:this.pitch,grid:e,ignoredGrid:i}},CollisionTile.prototype.placeCollisionFeature=function(t,e,i){for(var r=this,a=this.collisionBoxArray,o=this.minScale,n=this.rotationMatrix,l=this.yStretch,h=t.boxStartIndex;h<t.boxEndIndex;h++){var s=a.get(h),x=s.anchorPoint._matMult(n),c=x.x,g=x.y,y=c+s.x1,d=g+s.y1*l,m=c+s.x2,u=g+s.y2*l;if(s.bbox0=y,s.bbox1=d,s.bbox2=m,s.bbox3=u,!e)for(var p=r.grid.query(y,d,m,u),M=0;M<p.length;M++){var f=a.get(p[M]),v=f.anchorPoint._matMult(n);if(o=r.getPlacementScale(o,x,s,v,f),o>=r.maxScale)return o}if(i){var S;if(r.angle){var P=r.reverseRotationMatrix,b=new Point(s.x1,s.y1).matMult(P),T=new Point(s.x2,s.y1).matMult(P),w=new Point(s.x1,s.y2).matMult(P),N=new Point(s.x2,s.y2).matMult(P);S=r.tempCollisionBox,S.anchorPointX=s.anchorPoint.x,S.anchorPointY=s.anchorPoint.y,S.x1=Math.min(b.x,T.x,w.x,N.x),S.y1=Math.min(b.y,T.x,w.x,N.x),S.x2=Math.max(b.x,T.x,w.x,N.x),S.y2=Math.max(b.y,T.x,w.x,N.x),S.maxScale=s.maxScale}else S=s;for(var B=0;B<this.edges.length;B++){var G=r.edges[B];if(o=r.getPlacementScale(o,s.anchorPoint,S,G.anchorPoint,G),o>=r.maxScale)return o}}}return o},CollisionTile.prototype.queryRenderedSymbols=function(t,e){var i={},r=[];if(0===t.length||0===this.grid.length&&0===this.ignoredGrid.length)return r;for(var a=this.collisionBoxArray,o=this.rotationMatrix,n=this.yStretch,l=[],h=1/0,s=1/0,x=-(1/0),c=-(1/0),g=0;g<t.length;g++)for(var y=t[g],d=0;d<y.length;d++){var m=y[d].matMult(o);h=Math.min(h,m.x),s=Math.min(s,m.y),x=Math.max(x,m.x),c=Math.max(c,m.y),l.push(m)}for(var u=this.grid.query(h,s,x,c),p=this.ignoredGrid.query(h,s,x,c),M=0;M<p.length;M++)u.push(p[M]);for(var f=Math.pow(2,Math.ceil(Math.log(e)/Math.LN2*10)/10),v=0;v<u.length;v++){var S=a.get(u[v]),P=S.sourceLayerIndex,b=S.featureIndex;if(void 0===i[P]&&(i[P]={}),!i[P][b]&&!(f<S.placementScale||f>S.maxScale)){var T=S.anchorPoint.matMult(o),w=T.x+S.x1/e,N=T.y+S.y1/e*n,B=T.x+S.x2/e,G=T.y+S.y2/e*n,E=[new Point(w,N),new Point(B,N),new Point(B,G),new Point(w,G)];intersectionTests.polygonIntersectsPolygon(l,E)&&(i[P][b]=!0,r.push(u[v]))}}return r},CollisionTile.prototype.getPlacementScale=function(t,e,i,r,a){var o=e.x-r.x,n=e.y-r.y,l=(a.x1-i.x2)/o,h=(a.x2-i.x1)/o,s=(a.y1-i.y2)*this.yStretch/n,x=(a.y2-i.y1)*this.yStretch/n;(isNaN(l)||isNaN(h))&&(l=h=1),(isNaN(s)||isNaN(x))&&(s=x=1);var c=Math.min(Math.max(l,h),Math.max(s,x)),g=a.maxScale,y=i.maxScale;return c>g&&(c=g),c>y&&(c=y),c>t&&c>=a.placementScale&&(t=c),t},CollisionTile.prototype.insertCollisionFeature=function(t,e,i){for(var r=this,a=i?this.ignoredGrid:this.grid,o=this.collisionBoxArray,n=t.boxStartIndex;n<t.boxEndIndex;n++){var l=o.get(n);l.placementScale=e,e<r.maxScale&&a.insert(n,l.bbox0,l.bbox1,l.bbox2,l.bbox3)}},module.exports=CollisionTile;
	},{"../data/extent":11,"../util/intersection_tests":120,"grid-index":146,"point-geometry":194}],79:[function(require,module,exports){
	"use strict";function getAnchors(e,r,t,n,a,l,o,i,h){var c=n?.6*l*o:0,s=Math.max(n?n.right-n.left:0,a?a.right-a.left:0),u=0===e[0].x||e[0].x===h||0===e[0].y||e[0].y===h;r-s*o<r/4&&(r=s*o+r/4);var g=2*l,p=u?r/2*i%r:(s/2+g)*o*i%r;return resample(e,p,r,c,t,s*o,u,!1,h)}function resample(e,r,t,n,a,l,o,i,h){for(var c=l/2,s=0,u=0;u<e.length-1;u++)s+=e[u].dist(e[u+1]);for(var g=0,p=r-t,x=[],f=0;f<e.length-1;f++){for(var v=e[f],m=e[f+1],A=v.dist(m),y=m.angleTo(v);p+t<g+A;){p+=t;var d=(p-g)/A,k=interpolate(v.x,m.x,d),q=interpolate(v.y,m.y,d);if(k>=0&&k<h&&q>=0&&q<h&&p-c>=0&&p+c<=s){var M=new Anchor(k,q,y,f)._round();n&&!checkMaxAngle(e,M,l,n,a)||x.push(M)}}g+=A}return i||x.length||o||(x=resample(e,g/2,t,n,a,l,o,!0,h)),x}var interpolate=require("../util/interpolate"),Anchor=require("../symbol/anchor"),checkMaxAngle=require("./check_max_angle");module.exports=getAnchors;
	},{"../symbol/anchor":73,"../util/interpolate":119,"./check_max_angle":74}],80:[function(require,module,exports){
	"use strict";var ShelfPack=require("shelf-pack"),util=require("../util/util"),SIZE_GROWTH_RATE=4,DEFAULT_SIZE=128,MAX_SIZE=2048,GlyphAtlas=function(){this.width=DEFAULT_SIZE,this.height=DEFAULT_SIZE,this.bin=new ShelfPack(this.width,this.height),this.index={},this.ids={},this.data=new Uint8Array(this.width*this.height)};GlyphAtlas.prototype.getGlyphs=function(){var t,i,e,h={};for(var r in this.ids)t=r.split("#"),i=t[0],e=t[1],h[i]||(h[i]=[]),h[i].push(e);return h},GlyphAtlas.prototype.getRects=function(){var t,i,e,h=this,r={};for(var s in this.ids)t=s.split("#"),i=t[0],e=t[1],r[i]||(r[i]={}),r[i][e]=h.index[s];return r},GlyphAtlas.prototype.addGlyph=function(t,i,e,h){var r=this;if(!e)return null;var s=i+"#"+e.id;if(this.index[s])return this.ids[s].indexOf(t)<0&&this.ids[s].push(t),this.index[s];if(!e.bitmap)return null;var a=e.width+2*h,n=e.height+2*h,E=1,T=a+2*E,u=n+2*E;T+=4-T%4,u+=4-u%4;var l=this.bin.packOne(T,u);if(l||(this.resize(),l=this.bin.packOne(T,u)),!l)return util.warnOnce("glyph bitmap overflow"),null;this.index[s]=l,this.ids[s]=[t];for(var d=this.data,A=e.bitmap,_=0;_<n;_++)for(var p=r.width*(l.y+_+E)+l.x+E,o=a*_,R=0;R<a;R++)d[p+R]=A[o+R];return this.dirty=!0,l},GlyphAtlas.prototype.resize=function(){var t=this,i=this.width,e=this.height;if(!(i>=MAX_SIZE||e>=MAX_SIZE)){this.texture&&(this.gl&&this.gl.deleteTexture(this.texture),this.texture=null),this.width*=SIZE_GROWTH_RATE,this.height*=SIZE_GROWTH_RATE,this.bin.resize(this.width,this.height);for(var h=new ArrayBuffer(this.width*this.height),r=0;r<e;r++){var s=new Uint8Array(t.data.buffer,e*r,i),a=new Uint8Array(h,e*r*SIZE_GROWTH_RATE,i);a.set(s)}this.data=new Uint8Array(h)}},GlyphAtlas.prototype.bind=function(t){this.gl=t,this.texture?t.bindTexture(t.TEXTURE_2D,this.texture):(this.texture=t.createTexture(),t.bindTexture(t.TEXTURE_2D,this.texture),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,t.LINEAR),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,t.LINEAR),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE),t.texImage2D(t.TEXTURE_2D,0,t.ALPHA,this.width,this.height,0,t.ALPHA,t.UNSIGNED_BYTE,null))},GlyphAtlas.prototype.updateTexture=function(t){this.bind(t),this.dirty&&(t.texSubImage2D(t.TEXTURE_2D,0,0,0,this.width,this.height,t.ALPHA,t.UNSIGNED_BYTE,this.data),this.dirty=!1)},module.exports=GlyphAtlas;
	},{"../util/util":127,"shelf-pack":197}],81:[function(require,module,exports){
	"use strict";function glyphUrl(t,e,a,l){return l=l||"abc",a.replace("{s}",l[t.length%l.length]).replace("{fontstack}",t).replace("{range}",e)}var normalizeURL=require("../util/mapbox").normalizeGlyphsURL,ajax=require("../util/ajax"),verticalizePunctuation=require("../util/verticalize_punctuation"),Glyphs=require("../util/glyphs"),GlyphAtlas=require("../symbol/glyph_atlas"),Protobuf=require("pbf"),SimpleGlyph=function(t,e,a){var l=1;this.advance=t.advance,this.left=t.left-a-l,this.top=t.top+a+l,this.rect=e},GlyphSource=function(t){this.url=t&&normalizeURL(t),this.atlases={},this.stacks={},this.loading={}};GlyphSource.prototype.getSimpleGlyphs=function(t,e,a,l){var i=this;void 0===this.stacks[t]&&(this.stacks[t]={}),void 0===this.atlases[t]&&(this.atlases[t]=new GlyphAtlas);for(var r={},o=this.stacks[t],s=this.atlases[t],n=3,h={},p=0,u=function(e){var l=Math.floor(e/256);if(o[l]){var i=o[l].glyphs[e],u=s.addGlyph(a,t,i,n);i&&(r[e]=new SimpleGlyph(i,u,n))}else void 0===h[l]&&(h[l]=[],p++),h[l].push(e)},c=0;c<e.length;c++){var y=e[c],f=String.fromCharCode(y);u(y),verticalizePunctuation.lookup[f]&&u(verticalizePunctuation.lookup[f].charCodeAt(0))}p||l(void 0,r,t);var v=function(e,o,u){if(!e)for(var c=i.stacks[t][o]=u.stacks[0],y=0;y<h[o].length;y++){var f=h[o][y],v=c.glyphs[f],d=s.addGlyph(a,t,v,n);v&&(r[f]=new SimpleGlyph(v,d,n))}p--,p||l(void 0,r,t)};for(var d in h)i.loadRange(t,d,v)},GlyphSource.prototype.loadRange=function(t,e,a){if(256*e>65535)return a("glyphs > 65535 not supported");void 0===this.loading[t]&&(this.loading[t]={});var l=this.loading[t];if(l[e])l[e].push(a);else{l[e]=[a];var i=256*e+"-"+(256*e+255),r=glyphUrl(t,i,this.url);ajax.getArrayBuffer(r,function(t,a){for(var i=!t&&new Glyphs(new Protobuf(a)),r=0;r<l[e].length;r++)l[e][r](t,e,i);delete l[e]})}},GlyphSource.prototype.getGlyphAtlas=function(t){return this.atlases[t]},module.exports=GlyphSource;
	},{"../symbol/glyph_atlas":80,"../util/ajax":107,"../util/glyphs":118,"../util/mapbox":123,"../util/verticalize_punctuation":129,"pbf":193}],82:[function(require,module,exports){
	"use strict";module.exports=function(e){function t(t){g.push(e[t]),l++}function r(e,t,r){var n=u[e];return delete u[e],u[t]=n,g[n].geometry[0].pop(),g[n].geometry[0]=g[n].geometry[0].concat(r[0]),n}function n(e,t,r){var n=i[t];return delete i[t],i[e]=n,g[n].geometry[0].shift(),g[n].geometry[0]=r[0].concat(g[n].geometry[0]),n}function o(e,t,r){var n=r?t[0][t[0].length-1]:t[0][0];return e+":"+n.x+":"+n.y}for(var i={},u={},g=[],l=0,m=0;m<e.length;m++){var y=e[m],c=y.geometry,f=y.text;if(f){var a=o(f,c),s=o(f,c,!0);if(a in u&&s in i&&u[a]!==i[s]){var v=n(a,s,c),d=r(a,s,g[v].geometry);delete i[a],delete u[s],u[o(f,g[d].geometry,!0)]=d,g[v].geometry=null}else a in u?r(a,s,c):s in i?n(a,s,c):(t(m),i[a]=l-1,u[s]=l-1)}else t(m)}return g.filter(function(e){return e.geometry})};
	},{}],83:[function(require,module,exports){
	"use strict";function SymbolQuad(t,e,a,n,i,o,l,h,r,s,g){this.anchorPoint=t,this.tl=e,this.tr=a,this.bl=n,this.br=i,this.tex=o,this.anchorAngle=l,this.glyphAngle=h,this.minScale=r,this.maxScale=s,this.writingMode=g}function getIconQuads(t,e,a,n,i,o,l,h,r){var s,g,u,c,m=e.image.rect,f=i.layout,x=1,d=e.left-x,P=d+m.w/e.image.pixelRatio,y=e.top-x,M=y+m.h/e.image.pixelRatio;if("none"!==f["icon-text-fit"]&&l){var p=P-d,v=M-y,w=f["text-size"]/24,S=l.left*w,b=l.right*w,I=l.top*w,_=l.bottom*w,Q=b-S,G=_-I,k=f["icon-text-fit-padding"][0],q=f["icon-text-fit-padding"][1],A=f["icon-text-fit-padding"][2],R=f["icon-text-fit-padding"][3],z="width"===f["icon-text-fit"]?.5*(G-v):0,L="height"===f["icon-text-fit"]?.5*(Q-p):0,V="width"===f["icon-text-fit"]||"both"===f["icon-text-fit"]?Q:p,j="height"===f["icon-text-fit"]||"both"===f["icon-text-fit"]?G:v;s=new Point(S+L-R,I+z-k),g=new Point(S+L+q+V,I+z-k),u=new Point(S+L+q+V,I+z+A+j),c=new Point(S+L-R,I+z+A+j)}else s=new Point(d,y),g=new Point(P,y),u=new Point(P,M),c=new Point(d,M);var B=i.getLayoutValue("icon-rotate",h,r)*Math.PI/180;if(o){var C=n[t.segment];if(t.y===C.y&&t.x===C.x&&t.segment+1<n.length){var D=n[t.segment+1];B+=Math.atan2(t.y-D.y,t.x-D.x)+Math.PI}else B+=Math.atan2(t.y-C.y,t.x-C.x)}if(B){var E=Math.sin(B),F=Math.cos(B),H=[F,-E,E,F];s=s.matMult(H),g=g.matMult(H),c=c.matMult(H),u=u.matMult(H)}return[new SymbolQuad(new Point(t.x,t.y),s,g,c,u,e.image.rect,0,0,minScale,1/0)]}function getGlyphQuads(t,e,a,n,i,o){for(var l=i.layout["text-rotate"]*Math.PI/180,h=i.layout["text-keep-upright"],r=e.positionedGlyphs,s=[],g=0;g<r.length;g++){var u=r[g],c=u.glyph;if(c){var m=c.rect;if(m){var f,x=(u.x+c.advance/2)*a,d=minScale;o?(f=[],d=getSegmentGlyphs(f,t,x,n,t.segment,!0),h&&(d=Math.min(d,getSegmentGlyphs(f,t,x,n,t.segment,!1)))):f=[{anchorPoint:new Point(t.x,t.y),offset:0,angle:0,maxScale:1/0,minScale:minScale}];var P=u.x+c.left,y=u.y-c.top,M=P+m.w,p=y+m.h,v=new Point(u.x,c.advance/2),w=new Point(P,y),S=new Point(M,y),b=new Point(P,p),I=new Point(M,p);0!==u.angle&&(w._sub(v)._rotate(u.angle)._add(v),S._sub(v)._rotate(u.angle)._add(v),b._sub(v)._rotate(u.angle)._add(v),I._sub(v)._rotate(u.angle)._add(v));for(var _=0;_<f.length;_++){var Q=f[_],G=w,k=S,q=b,A=I;if(l){var R=Math.sin(l),z=Math.cos(l),L=[z,-R,R,z];G=G.matMult(L),k=k.matMult(L),q=q.matMult(L),A=A.matMult(L)}var V=Math.max(Q.minScale,d),j=(t.angle+Q.offset+2*Math.PI)%(2*Math.PI),B=(Q.angle+Q.offset+2*Math.PI)%(2*Math.PI);s.push(new SymbolQuad(Q.anchorPoint,G,k,q,A,m,j,B,V,Q.maxScale,e.writingMode))}}}}return s}function getSegmentGlyphs(t,e,a,n,i,o){var l=!o;a<0&&(o=!o),o&&i++;var h=new Point(e.x,e.y),r=n[i],s=1/0;a=Math.abs(a);for(var g=minScale;;){var u=h.dist(r),c=a/u,m=Math.atan2(r.y-h.y,r.x-h.x);if(o||(m+=Math.PI),t.push({anchorPoint:h,offset:l?Math.PI:0,minScale:c,maxScale:s,angle:(m+2*Math.PI)%(2*Math.PI)}),c<=g)break;for(h=r;h.equals(r);)if(i+=o?1:-1,r=n[i],!r)return c;var f=r.sub(h)._unit();h=h.sub(f._mult(u)),s=c}return g}var Point=require("point-geometry");module.exports={getIconQuads:getIconQuads,getGlyphQuads:getGlyphQuads,SymbolQuad:SymbolQuad};var minScale=.5;
	},{"point-geometry":194}],84:[function(require,module,exports){
	"use strict";var resolveTokens=require("../util/token");module.exports=function(e,r){var o=resolveTokens(e.properties,r["text-field"]);if(o){o=o.toString();var t=r["text-transform"];return"uppercase"===t?o=o.toLocaleUpperCase():"lowercase"===t&&(o=o.toLocaleLowerCase()),o}};
	},{"../util/token":126}],85:[function(require,module,exports){
	"use strict";function PositionedGlyph(e,t,i,n,a){this.codePoint=e,this.x=t,this.y=i,this.glyph=n||null,this.angle=a}function Shaping(e,t,i,n,a,r,o){this.positionedGlyphs=e,this.text=t,this.top=i,this.bottom=n,this.left=a,this.right=r,this.writingMode=o}function breakLines(e,t){for(var i=[],n=0,a=0,r=t;a<r.length;a+=1){var o=r[a];i.push(e.substring(n,o)),n=o}return n<e.length&&i.push(e.substring(n,e.length)),i}function shapeText(e,t,i,n,a,r,o,s,h,l,c){e=e.trim(),c===WritingMode.vertical&&(e=verticalizePunctuation(e));var u=[],d=new Shaping(u,e,h[1],h[1],h[0],h[0],c),p=c===WritingMode.horizontal&&i?breakLines(e,determineLineBreaks(e,s,i,t)):[e];return shapeLines(d,t,p,n,a,r,o,h,c,s,l),!!u.length&&d}function determineAverageLineWidth(e,t,i,n){var a=0;for(var r in e){var o=n[e.charCodeAt(r)];o&&(a+=o.advance+t)}var s=Math.max(1,Math.ceil(a/i));return a/s}function calculateBadness(e,t,i,n){var a=Math.pow(e-t,2);return n&&e<t?Math.max(0,a-150):a+Math.abs(i)*i}function calculatePenalty(e,t){var i=0;return 10===e&&(i-=1e4),!t||40!==t&&65288!==t||(i+=50),41!==e&&65289!==e||(i+=50),i}function evaluateBreak(e,t,i,n,a,r){for(var o=[],s=0,h=n;s<h.length;s+=1){var l=h[s],c=t-l.x;o.push({priorBreak:l,badness:calculateBadness(c,i,a,r)+l.badness})}return o.push({priorBreak:null,badness:calculateBadness(t,i,a,r)}),o.sort(function(e,t){return e.badness-t.badness}),{index:e,x:t,priorBreak:o[0].priorBreak,badness:o[0].badness}}function leastBadBreaks(e){return e?leastBadBreaks(e.priorBreak).concat(e.index):[]}function determineLineBreaks(e,t,i,n){if(!i)return[];if(!e)return[];for(var a=[],r=determineAverageLineWidth(e,t,i,n),o=0,s=0;s<e.length;s++){var h=e.charCodeAt(s),l=n[h];if(l||h===newLine){if(breakable[h]||scriptDetection.charAllowsIdeographicBreaking(h)){var c=e.charCodeAt(s-1);a.unshift(evaluateBreak(s,o,r,a,calculatePenalty(h,c),!1))}l&&(o+=l.advance+t)}}return a.unshift(evaluateBreak(e.length,o,r,a,0,!0)),leastBadBreaks(a.shift())}function shapeLines(e,t,i,n,a,r,o,s,h,l,c){var u=-17,d=0,p=u,f=0,g=e.positionedGlyphs;for(var v in i){var b=i[v].trim();if(b.length){for(var B=g.length,k=0;k<b.length;k++){var x=b.charCodeAt(k),m=t[x];m&&(scriptDetection.charHasUprightVerticalOrientation(x)&&h!==WritingMode.horizontal?(g.push(new PositionedGlyph(x,d,0,m,-Math.PI/2)),d+=c+l):(g.push(new PositionedGlyph(x,d,p,m,0)),d+=m.advance+l))}if(g.length!==B){var M=d-l;f=Math.max(M,f),justifyLine(g,t,B,g.length-1,o)}d=0,p+=n}else p+=n}align(g,o,a,r,f,n,i.length,s);var L=i.length*n;e.top+=-r*L,e.bottom=e.top+L,e.left+=-a*f,e.right=e.left+f}function justifyLine(e,t,i,n,a){if(a)for(var r=t[e[n].codePoint].advance,o=(e[n].x+r)*a,s=i;s<=n;s++)e[s].x-=o}function align(e,t,i,n,a,r,o,s){for(var h=(t-i)*a+s[0],l=(-n*o+.5)*r+s[1],c=0;c<e.length;c++)e[c].x+=h,e[c].y+=l}function shapeIcon(e,t){if(!e||!e.rect)return null;var i=t[0],n=t[1],a=i-e.width/2,r=a+e.width,o=n-e.height/2,s=o+e.height;return new PositionedIcon(e,o,s,a,r)}function PositionedIcon(e,t,i,n,a){this.image=e,this.top=t,this.bottom=i,this.left=n,this.right=a}var scriptDetection=require("../util/script_detection"),verticalizePunctuation=require("../util/verticalize_punctuation"),WritingMode={horizontal:1,vertical:2};module.exports={shapeText:shapeText,shapeIcon:shapeIcon,WritingMode:WritingMode};var newLine=10,breakable={32:!0,38:!0,40:!0,41:!0,43:!0,45:!0,47:!0,173:!0,183:!0,8203:!0,8208:!0,8211:!0,8231:!0};breakable[newLine]=!0;
	},{"../util/script_detection":124,"../util/verticalize_punctuation":129}],86:[function(require,module,exports){
	"use strict";function copyBitmap(t,i,e,h,a,s,r,o,l,p,n){var u,R,f=h*i+e,x=o*s+r;if(n)for(x-=s,R=-1;R<=p;R++,f=((R+p)%p+h)*i+e,x+=s)for(u=-1;u<=l;u++)a[x+u]=t[f+(u+l)%l];else for(R=0;R<p;R++,f+=i,x+=s)for(u=0;u<l;u++)a[x+u]=t[f+u]}var ShelfPack=require("shelf-pack"),browser=require("../util/browser"),util=require("../util/util"),AtlasImage=function(t,i,e,h,a){this.rect=t,this.width=i,this.height=e,this.sdf=h,this.pixelRatio=a},SpriteAtlas=function(t,i){this.width=t,this.height=i,this.bin=new ShelfPack(t,i),this.images={},this.data=!1,this.texture=0,this.filter=0,this.pixelRatio=1,this.dirty=!0};SpriteAtlas.prototype.allocateImage=function(t,i){t/=this.pixelRatio,i/=this.pixelRatio;var e=2,h=t+e+(4-(t+e)%4),a=i+e+(4-(i+e)%4),s=this.bin.packOne(h,a);return s?s:(util.warnOnce("SpriteAtlas out of space."),null)},SpriteAtlas.prototype.getImage=function(t,i){if(this.images[t])return this.images[t];if(!this.sprite)return null;var e=this.sprite.getSpritePosition(t);if(!e.width||!e.height)return null;var h=this.allocateImage(e.width,e.height);if(!h)return null;var a=new AtlasImage(h,e.width/e.pixelRatio,e.height/e.pixelRatio,e.sdf,e.pixelRatio/this.pixelRatio);return this.images[t]=a,this.copy(h,e,i),a},SpriteAtlas.prototype.getPosition=function(t,i){var e=this.getImage(t,i),h=e&&e.rect;if(!h)return null;var a=e.width*e.pixelRatio,s=e.height*e.pixelRatio,r=1;return{size:[e.width,e.height],tl:[(h.x+r)/this.width,(h.y+r)/this.height],br:[(h.x+r+a)/this.width,(h.y+r+s)/this.height]}},SpriteAtlas.prototype.allocate=function(){var t=this;if(!this.data){var i=Math.floor(this.width*this.pixelRatio),e=Math.floor(this.height*this.pixelRatio);this.data=new Uint32Array(i*e);for(var h=0;h<this.data.length;h++)t.data[h]=0}},SpriteAtlas.prototype.copy=function(t,i,e){if(this.sprite.imgData){var h=new Uint32Array(this.sprite.imgData.buffer);this.allocate();var a=this.data,s=1;copyBitmap(h,this.sprite.width,i.x,i.y,a,this.width*this.pixelRatio,(t.x+s)*this.pixelRatio,(t.y+s)*this.pixelRatio,i.width,i.height,e),this.dirty=!0}},SpriteAtlas.prototype.setSprite=function(t){t&&(this.pixelRatio=browser.devicePixelRatio>1?2:1,this.canvas&&(this.canvas.width=this.width*this.pixelRatio,this.canvas.height=this.height*this.pixelRatio)),this.sprite=t},SpriteAtlas.prototype.addIcons=function(t,i){for(var e=this,h=0;h<t.length;h++)e.getImage(t[h]);i(null,this.images)},SpriteAtlas.prototype.bind=function(t,i){var e=!1;this.texture?t.bindTexture(t.TEXTURE_2D,this.texture):(this.texture=t.createTexture(),t.bindTexture(t.TEXTURE_2D,this.texture),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE),e=!0);var h=i?t.LINEAR:t.NEAREST;h!==this.filter&&(t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,h),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,h),this.filter=h),this.dirty&&(this.allocate(),e?t.texImage2D(t.TEXTURE_2D,0,t.RGBA,this.width*this.pixelRatio,this.height*this.pixelRatio,0,t.RGBA,t.UNSIGNED_BYTE,new Uint8Array(this.data.buffer)):t.texSubImage2D(t.TEXTURE_2D,0,0,0,this.width*this.pixelRatio,this.height*this.pixelRatio,t.RGBA,t.UNSIGNED_BYTE,new Uint8Array(this.data.buffer)),this.dirty=!1)},module.exports=SpriteAtlas;
	},{"../util/browser":108,"../util/util":127,"shelf-pack":197}],87:[function(require,module,exports){
	"use strict";var createStructArrayType=require("../util/struct_array"),Point=require("point-geometry"),SymbolInstancesArray=createStructArrayType({members:[{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"glyphQuadStartIndex"},{type:"Uint16",name:"glyphQuadEndIndex"},{type:"Uint16",name:"iconQuadStartIndex"},{type:"Uint16",name:"iconQuadEndIndex"},{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int8",name:"index"},{type:"Uint8",name:"writingModes"}]});Object.defineProperty(SymbolInstancesArray.prototype.StructType.prototype,"anchorPoint",{get:function(){return new Point(this.anchorPointX,this.anchorPointY)}}),module.exports=SymbolInstancesArray;
	},{"../util/struct_array":125,"point-geometry":194}],88:[function(require,module,exports){
	"use strict";var createStructArrayType=require("../util/struct_array"),Point=require("point-geometry"),SymbolQuad=require("./quads").SymbolQuad,SymbolQuadsArray=createStructArrayType({members:[{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Float32",name:"tlX"},{type:"Float32",name:"tlY"},{type:"Float32",name:"trX"},{type:"Float32",name:"trY"},{type:"Float32",name:"blX"},{type:"Float32",name:"blY"},{type:"Float32",name:"brX"},{type:"Float32",name:"brY"},{type:"Int16",name:"texH"},{type:"Int16",name:"texW"},{type:"Int16",name:"texX"},{type:"Int16",name:"texY"},{type:"Float32",name:"anchorAngle"},{type:"Float32",name:"glyphAngle"},{type:"Float32",name:"maxScale"},{type:"Float32",name:"minScale"},{type:"Uint8",name:"writingMode"}]});Object.defineProperty(SymbolQuadsArray.prototype.StructType.prototype,"anchorPoint",{get:function(){return new Point(this.anchorPointX,this.anchorPointY)}}),Object.defineProperty(SymbolQuadsArray.prototype.StructType.prototype,"SymbolQuad",{get:function(){return new SymbolQuad(this.anchorPoint,new Point(this.tlX,this.tlY),new Point(this.trX,this.trY),new Point(this.blX,this.blY),new Point(this.brX,this.brY),{x:this.texX,y:this.texY,h:this.texH,w:this.texW,height:this.texH,width:this.texW},this.anchorAngle,this.glyphAngle,this.minScale,this.maxScale,this.writingMode)}}),module.exports=SymbolQuadsArray;
	},{"../util/struct_array":125,"./quads":83,"point-geometry":194}],89:[function(require,module,exports){
	"use strict";var DOM=require("../util/dom"),Point=require("point-geometry"),handlers={scrollZoom:require("./handler/scroll_zoom"),boxZoom:require("./handler/box_zoom"),dragRotate:require("./handler/drag_rotate"),dragPan:require("./handler/drag_pan"),keyboard:require("./handler/keyboard"),doubleClickZoom:require("./handler/dblclick_zoom"),touchZoomRotate:require("./handler/touch_zoom_rotate")};module.exports=function(e,t){function n(e){h("mouseout",e)}function o(t){e.stop(),L=DOM.mousePos(g,t),h("mousedown",t),E=!0}function r(t){var n=e.dragRotate&&e.dragRotate.isActive();p&&!n&&h("contextmenu",p),p=null,E=!1,h("mouseup",t)}function a(t){if(!(e.dragPan&&e.dragPan.isActive()||e.dragRotate&&e.dragRotate.isActive())){for(var n=t.toElement||t.target;n&&n!==g;)n=n.parentNode;n===g&&h("mousemove",t)}}function u(t){e.stop(),f("touchstart",t),!t.touches||t.touches.length>1||(b?(clearTimeout(b),b=null,h("dblclick",t)):b=setTimeout(l,300))}function i(e){f("touchmove",e)}function c(e){f("touchend",e)}function d(e){f("touchcancel",e)}function l(){b=null}function s(e){var t=DOM.mousePos(g,e);t.equals(L)&&h("click",e)}function v(e){h("dblclick",e),e.preventDefault()}function m(t){var n=e.dragRotate&&e.dragRotate.isActive();E||n?E&&(p=t):h("contextmenu",t),t.preventDefault()}function h(t,n){var o=DOM.mousePos(g,n);return e.fire(t,{lngLat:e.unproject(o),point:o,originalEvent:n})}function f(t,n){var o=DOM.touchPos(g,n),r=o.reduce(function(e,t,n,o){return e.add(t.div(o.length))},new Point(0,0));return e.fire(t,{lngLat:e.unproject(r),point:r,lngLats:o.map(function(t){return e.unproject(t)},this),points:o,originalEvent:n})}var g=e.getCanvasContainer(),p=null,E=!1,L=null,b=null;for(var q in handlers)e[q]=new handlers[q](e,t),t.interactive&&t[q]&&e[q].enable();g.addEventListener("mouseout",n,!1),g.addEventListener("mousedown",o,!1),g.addEventListener("mouseup",r,!1),g.addEventListener("mousemove",a,!1),g.addEventListener("touchstart",u,!1),g.addEventListener("touchend",c,!1),g.addEventListener("touchmove",i,!1),g.addEventListener("touchcancel",d,!1),g.addEventListener("click",s,!1),g.addEventListener("dblclick",v,!1),g.addEventListener("contextmenu",m,!1)};
	},{"../util/dom":115,"./handler/box_zoom":95,"./handler/dblclick_zoom":96,"./handler/drag_pan":97,"./handler/drag_rotate":98,"./handler/keyboard":99,"./handler/scroll_zoom":100,"./handler/touch_zoom_rotate":101,"point-geometry":194}],90:[function(require,module,exports){
	"use strict";var util=require("../util/util"),interpolate=require("../util/interpolate"),browser=require("../util/browser"),LngLat=require("../geo/lng_lat"),LngLatBounds=require("../geo/lng_lat_bounds"),Point=require("point-geometry"),Evented=require("../util/evented"),Camera=function(t){function i(i,e){t.call(this),this.transform=i,this._bearingSnap=e.bearingSnap}return t&&(i.__proto__=t),i.prototype=Object.create(t&&t.prototype),i.prototype.constructor=i,i.prototype.getCenter=function(){return this.transform.center},i.prototype.setCenter=function(t,i){return this.jumpTo({center:t},i),this},i.prototype.panBy=function(t,i,e){return this.panTo(this.transform.center,util.extend({offset:Point.convert(t).mult(-1)},i),e),this},i.prototype.panTo=function(t,i,e){return this.easeTo(util.extend({center:t},i),e)},i.prototype.getZoom=function(){return this.transform.zoom},i.prototype.setZoom=function(t,i){return this.jumpTo({zoom:t},i),this},i.prototype.zoomTo=function(t,i,e){return this.easeTo(util.extend({zoom:t},i),e)},i.prototype.zoomIn=function(t,i){return this.zoomTo(this.getZoom()+1,t,i),this},i.prototype.zoomOut=function(t,i){return this.zoomTo(this.getZoom()-1,t,i),this},i.prototype.getBearing=function(){return this.transform.bearing},i.prototype.setBearing=function(t,i){return this.jumpTo({bearing:t},i),this},i.prototype.rotateTo=function(t,i,e){return this.easeTo(util.extend({bearing:t},i),e)},i.prototype.resetNorth=function(t,i){return this.rotateTo(0,util.extend({duration:1e3},t),i),this},i.prototype.snapToNorth=function(t,i){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,i):this},i.prototype.getPitch=function(){return this.transform.pitch},i.prototype.setPitch=function(t,i){return this.jumpTo({pitch:t},i),this},i.prototype.fitBounds=function(t,i,e){i=util.extend({padding:0,offset:[0,0],maxZoom:this.getMaxZoom()},i),t=LngLatBounds.convert(t);var o=Point.convert(i.offset),n=this.transform,r=n.project(t.getNorthWest()),s=n.project(t.getSouthEast()),a=s.sub(r),h=(n.width-2*i.padding-2*Math.abs(o.x))/a.x,u=(n.height-2*i.padding-2*Math.abs(o.y))/a.y;return i.center=n.unproject(r.add(s).div(2)),i.zoom=Math.min(n.scaleZoom(n.scale*Math.min(h,u)),i.maxZoom),i.bearing=0,i.linear?this.easeTo(i,e):this.flyTo(i,e)},i.prototype.jumpTo=function(t,i){this.stop();var e=this.transform,o=!1,n=!1,r=!1;return"zoom"in t&&e.zoom!==+t.zoom&&(o=!0,e.zoom=+t.zoom),"center"in t&&(e.center=LngLat.convert(t.center)),"bearing"in t&&e.bearing!==+t.bearing&&(n=!0,e.bearing=+t.bearing),"pitch"in t&&e.pitch!==+t.pitch&&(r=!0,e.pitch=+t.pitch),this.fire("movestart",i).fire("move",i),o&&this.fire("zoomstart",i).fire("zoom",i).fire("zoomend",i),n&&this.fire("rotate",i),r&&this.fire("pitch",i),this.fire("moveend",i)},i.prototype.easeTo=function(t,i){var e=this;this.stop(),t=util.extend({offset:[0,0],duration:500,easing:util.ease},t);var o,n,r=this.transform,s=Point.convert(t.offset),a=this.getZoom(),h=this.getBearing(),u=this.getPitch(),p="zoom"in t?+t.zoom:a,c="bearing"in t?this._normalizeBearing(t.bearing,h):h,m="pitch"in t?+t.pitch:u;"center"in t?(o=LngLat.convert(t.center),n=r.centerPoint.add(s)):"around"in t?(o=LngLat.convert(t.around),n=r.locationPoint(o)):(n=r.centerPoint.add(s),o=r.pointLocation(n));var g=r.locationPoint(o);return t.animate===!1&&(t.duration=0),this.zooming=p!==a,this.rotating=h!==c,this.pitching=m!==u,t.smoothEasing&&0!==t.duration&&(t.easing=this._smoothOutEasing(t.duration)),t.noMoveStart||this.fire("movestart",i),this.zooming&&this.fire("zoomstart",i),clearTimeout(this._onEaseEnd),this._ease(function(t){this.zooming&&(r.zoom=interpolate(a,p,t)),this.rotating&&(r.bearing=interpolate(h,c,t)),this.pitching&&(r.pitch=interpolate(u,m,t)),r.setLocationAtPoint(o,g.add(n.sub(g)._mult(t))),this.fire("move",i),this.zooming&&this.fire("zoom",i),this.rotating&&this.fire("rotate",i),this.pitching&&this.fire("pitch",i)},function(){t.delayEndEvents?e._onEaseEnd=setTimeout(e._easeToEnd.bind(e,i),t.delayEndEvents):e._easeToEnd(i)},t),this},i.prototype._easeToEnd=function(t){var i=this.zooming;this.zooming=!1,this.rotating=!1,this.pitching=!1,i&&this.fire("zoomend",t),this.fire("moveend",t)},i.prototype.flyTo=function(t,i){function e(t){var i=(y*y-z*z+(t?-1:1)*E*E*_*_)/(2*(t?y:z)*E*_);return Math.log(Math.sqrt(i*i+1)-i)}function o(t){return(Math.exp(t)-Math.exp(-t))/2}function n(t){return(Math.exp(t)+Math.exp(-t))/2}function r(t){return o(t)/n(t)}this.stop(),t=util.extend({offset:[0,0],speed:1.2,curve:1.42,easing:util.ease},t);var s=this.transform,a=Point.convert(t.offset),h=this.getZoom(),u=this.getBearing(),p=this.getPitch(),c="center"in t?LngLat.convert(t.center):this.getCenter(),m="zoom"in t?+t.zoom:h,g="bearing"in t?this._normalizeBearing(t.bearing,u):u,f="pitch"in t?+t.pitch:p;Math.abs(s.center.lng)+Math.abs(c.lng)>180&&(s.center.lng>0&&c.lng<0?c.lng+=360:s.center.lng<0&&c.lng>0&&(c.lng-=360));var d=s.zoomScale(m-h),l=s.point,v="center"in t?s.project(c).sub(a.div(d)):l,b=t.curve,z=Math.max(s.width,s.height),y=z/d,_=v.sub(l).mag();if("minZoom"in t){var M=util.clamp(Math.min(t.minZoom,h,m),s.minZoom,s.maxZoom),T=z/s.zoomScale(M-h);b=Math.sqrt(T/_*2)}var E=b*b,x=e(0),L=function(t){return n(x)/n(x+b*t)},Z=function(t){return z*((n(x)*r(x+b*t)-o(x))/E)/_},P=(e(1)-x)/b;if(Math.abs(_)<1e-6){if(Math.abs(z-y)<1e-6)return this.easeTo(t);var B=y<z?-1:1;P=Math.abs(Math.log(y/z))/b,Z=function(){return 0},L=function(t){return Math.exp(B*b*t)}}if("duration"in t)t.duration=+t.duration;else{var j="screenSpeed"in t?+t.screenSpeed/b:+t.speed;t.duration=1e3*P/j}return this.zooming=!0,u!==g&&(this.rotating=!0),p!==f&&(this.pitching=!0),this.fire("movestart",i),this.fire("zoomstart",i),this._ease(function(t){var e=t*P,o=Z(e),n=1/L(e);s.zoom=h+s.scaleZoom(n),s.center=s.unproject(l.add(v.sub(l).mult(o)).mult(n)),this.rotating&&(s.bearing=interpolate(u,g,t)),this.pitching&&(s.pitch=interpolate(p,f,t)),this.fire("move",i),this.fire("zoom",i),this.rotating&&this.fire("rotate",i),this.pitching&&this.fire("pitch",i)},function(){this.zooming=!1,this.rotating=!1,this.pitching=!1,this.fire("zoomend",i),this.fire("moveend",i)},t),this},i.prototype.isEasing=function(){return!!this._abortFn},i.prototype.stop=function(){return this._abortFn&&(this._abortFn(),this._finishEase()),this},i.prototype._ease=function(t,i,e){this._finishFn=i,this._abortFn=browser.timed(function(i){t.call(this,e.easing(i)),1===i&&this._finishEase()},e.animate===!1?0:e.duration,this)},i.prototype._finishEase=function(){delete this._abortFn;var t=this._finishFn;delete this._finishFn,t.call(this)},i.prototype._normalizeBearing=function(t,i){t=util.wrap(t,-180,180);var e=Math.abs(t-i);return Math.abs(t-360-i)<e&&(t-=360),Math.abs(t+360-i)<e&&(t+=360),t},i.prototype._smoothOutEasing=function(t){var i=util.ease;if(this._prevEase){var e=this._prevEase,o=(Date.now()-e.start)/e.duration,n=e.easing(o+.01)-e.easing(o),r=.27/Math.sqrt(n*n+1e-4)*.01,s=Math.sqrt(.0729-r*r);i=util.bezier(r,s,.25,1)}return this._prevEase={start:(new Date).getTime(),duration:t,easing:i},i},i}(Evented);module.exports=Camera;
	},{"../geo/lng_lat":19,"../geo/lng_lat_bounds":20,"../util/browser":108,"../util/evented":116,"../util/interpolate":119,"../util/util":127,"point-geometry":194}],91:[function(require,module,exports){
	"use strict";var DOM=require("../../util/dom"),util=require("../../util/util"),AttributionControl=function(t){this.options=t,util.bindAll(["_updateEditLink","_updateData","_updateCompact"],this)};AttributionControl.prototype.getDefaultPosition=function(){return"bottom-right"},AttributionControl.prototype.onAdd=function(t){var i=this.options&&this.options.compact;return this._map=t,this._container=DOM.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),i&&this._container.classList.add("compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("data",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===i&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},AttributionControl.prototype.onRemove=function(){this._container.parentNode.removeChild(this._container),this._map.off("data",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0},AttributionControl.prototype._updateEditLink=function(){if(this._editLink||(this._editLink=this._container.querySelector(".mapbox-improve-map")),this._editLink){var t=this._map.getCenter();this._editLink.href="https://www.mapbox.com/map-feedback/#/"+t.lng+"/"+t.lat+"/"+Math.round(this._map.getZoom()+1)}},AttributionControl.prototype._updateData=function(t){"source"===t.dataType&&(this._updateAttributions(),this._updateEditLink())},AttributionControl.prototype._updateAttributions=function(){if(this._map.style){var t=[],i=this._map.style.sourceCaches;for(var o in i){var n=i[o].getSource();n.attribution&&t.indexOf(n.attribution)<0&&t.push(n.attribution)}t.sort(function(t,i){return t.length-i.length}),t=t.filter(function(i,o){for(var n=o+1;n<t.length;n++)if(t[n].indexOf(i)>=0)return!1;return!0}),this._container.innerHTML=t.join(" | "),this._editLink=null}},AttributionControl.prototype._updateCompact=function(){var t=this._map.getCanvasContainer().offsetWidth<=640;this._container.classList[t?"add":"remove"]("compact")},module.exports=AttributionControl;
	},{"../../util/dom":115,"../../util/util":127}],92:[function(require,module,exports){
	"use strict";function checkGeolocationSupport(t){void 0!==supportsGeolocation?t(supportsGeolocation):void 0!==window.navigator.permissions?window.navigator.permissions.query({name:"geolocation"}).then(function(o){supportsGeolocation="denied"!==o.state,t(supportsGeolocation)}):(supportsGeolocation=!!window.navigator.geolocation,t(supportsGeolocation))}var Evented=require("../../util/evented"),DOM=require("../../util/dom"),window=require("../../util/window"),util=require("../../util/util"),defaultGeoPositionOptions={enableHighAccuracy:!1,timeout:6e3},className="mapboxgl-ctrl",supportsGeolocation,GeolocateControl=function(t){function o(o){t.call(this),this.options=o,util.bindAll(["_onSuccess","_onError","_finish","_setupUI"],this)}return t&&(o.__proto__=t),o.prototype=Object.create(t&&t.prototype),o.prototype.constructor=o,o.prototype.onAdd=function(t){return this._map=t,this._container=DOM.create("div",className+" "+className+"-group"),checkGeolocationSupport(this._setupUI),this._container},o.prototype.onRemove=function(){this._container.parentNode.removeChild(this._container),this._map=void 0},o.prototype._onSuccess=function(t){this._map.jumpTo({center:[t.coords.longitude,t.coords.latitude],zoom:17,bearing:0,pitch:0}),this.fire("geolocate",t),this._finish()},o.prototype._onError=function(t){this.fire("error",t),this._finish()},o.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0},o.prototype._setupUI=function(t){t!==!1&&(this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this._geolocateButton=DOM.create("button",className+"-icon "+className+"-geolocate",this._container),this._geolocateButton.type="button",this._geolocateButton.setAttribute("aria-label","Geolocate"),this.options.watchPosition&&this._geolocateButton.setAttribute("aria-pressed",!1),this._geolocateButton.addEventListener("click",this._onClickGeolocate.bind(this)))},o.prototype._onClickGeolocate=function(){var t=util.extend(defaultGeoPositionOptions,this.options&&this.options.positionOptions||{});this.options.watchPosition?void 0!==this._geolocationWatchID?(this._geolocateButton.classList.remove("watching"),this._geolocateButton.setAttribute("aria-pressed",!1),window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0):(this._geolocateButton.classList.add("watching"),this._geolocateButton.setAttribute("aria-pressed",!0),this._geolocationWatchID=window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,t)):(window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,t),this._timeoutId=setTimeout(this._finish,1e4))},o}(Evented);module.exports=GeolocateControl;
	},{"../../util/dom":115,"../../util/evented":116,"../../util/util":127,"../../util/window":110}],93:[function(require,module,exports){
	"use strict";function copyMouseEvent(t){return new window.MouseEvent(t.type,{button:2,buttons:2,bubbles:!0,cancelable:!0,detail:t.detail,view:t.view,screenX:t.screenX,screenY:t.screenY,clientX:t.clientX,clientY:t.clientY,movementX:t.movementX,movementY:t.movementY,ctrlKey:t.ctrlKey,shiftKey:t.shiftKey,altKey:t.altKey,metaKey:t.metaKey})}var DOM=require("../../util/dom"),window=require("../../util/window"),util=require("../../util/util"),className="mapboxgl-ctrl",NavigationControl=function(){util.bindAll(["_rotateCompassArrow"],this)};NavigationControl.prototype._rotateCompassArrow=function(){var t="rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassArrow.style.transform=t},NavigationControl.prototype.onAdd=function(t){return this._map=t,this._container=DOM.create("div",className+" "+className+"-group",t.getContainer()),this._container.addEventListener("contextmenu",this._onContextMenu.bind(this)),this._zoomInButton=this._createButton(className+"-icon "+className+"-zoom-in","Zoom In",t.zoomIn.bind(t)),this._zoomOutButton=this._createButton(className+"-icon "+className+"-zoom-out","Zoom Out",t.zoomOut.bind(t)),this._compass=this._createButton(className+"-icon "+className+"-compass","Reset North",t.resetNorth.bind(t)),this._compassArrow=DOM.create("span","arrow",this._compass),this._compass.addEventListener("mousedown",this._onCompassDown.bind(this)),this._onCompassMove=this._onCompassMove.bind(this),this._onCompassUp=this._onCompassUp.bind(this),this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._container},NavigationControl.prototype.onRemove=function(){this._container.parentNode.removeChild(this._container),this._map.off("rotate",this._rotateCompassArrow),this._map=void 0},NavigationControl.prototype._onContextMenu=function(t){t.preventDefault()},NavigationControl.prototype._onCompassDown=function(t){0===t.button&&(DOM.disableDrag(),window.document.addEventListener("mousemove",this._onCompassMove),window.document.addEventListener("mouseup",this._onCompassUp),this._map.getCanvasContainer().dispatchEvent(copyMouseEvent(t)),t.stopPropagation())},NavigationControl.prototype._onCompassMove=function(t){0===t.button&&(this._map.getCanvasContainer().dispatchEvent(copyMouseEvent(t)),t.stopPropagation())},NavigationControl.prototype._onCompassUp=function(t){0===t.button&&(window.document.removeEventListener("mousemove",this._onCompassMove),window.document.removeEventListener("mouseup",this._onCompassUp),DOM.enableDrag(),this._map.getCanvasContainer().dispatchEvent(copyMouseEvent(t)),t.stopPropagation())},NavigationControl.prototype._createButton=function(t,o,e){var n=DOM.create("button",t,this._container);return n.type="button",n.setAttribute("aria-label",o),n.addEventListener("click",function(){e()}),n},module.exports=NavigationControl;
	},{"../../util/dom":115,"../../util/util":127,"../../util/window":110}],94:[function(require,module,exports){
	"use strict";function updateScale(t,e,o){var n=o&&o.maxWidth||100,i=t._container.clientHeight/2,a=getDistance(t.unproject([0,i]),t.unproject([n,i]));if(o&&"imperial"===o.unit){var r=3.2808*a;if(r>5280){var l=r/5280;setScale(e,n,l,"mi")}else setScale(e,n,r,"ft")}else setScale(e,n,a,"m")}function setScale(t,e,o,n){var i=getRoundNum(o),a=i/o;"m"===n&&i>=1e3&&(i/=1e3,n="km"),t.style.width=e*a+"px",t.innerHTML=i+n}function getDistance(t,e){var o=6371e3,n=Math.PI/180,i=t.lat*n,a=e.lat*n,r=Math.sin(i)*Math.sin(a)+Math.cos(i)*Math.cos(a)*Math.cos((e.lng-t.lng)*n),l=o*Math.acos(Math.min(r,1));return l}function getRoundNum(t){var e=Math.pow(10,(""+Math.floor(t)).length-1),o=t/e;return o=o>=10?10:o>=5?5:o>=3?3:o>=2?2:1,e*o}var DOM=require("../../util/dom"),util=require("../../util/util"),ScaleControl=function(t){this.options=t,util.bindAll(["_onMove"],this)};ScaleControl.prototype.getDefaultPosition=function(){return"bottom-left"},ScaleControl.prototype._onMove=function(){updateScale(this._map,this._container,this.options)},ScaleControl.prototype.onAdd=function(t){return this._map=t,this._container=DOM.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},ScaleControl.prototype.onRemove=function(){this._container.parentNode.removeChild(this._container),this._map.off("move",this._onMove),this._map=void 0},module.exports=ScaleControl;
	},{"../../util/dom":115,"../../util/util":127}],95:[function(require,module,exports){
	"use strict";var DOM=require("../../util/dom"),LngLatBounds=require("../../geo/lng_lat_bounds"),util=require("../../util/util"),window=require("../../util/window"),BoxZoomHandler=function(o){this._map=o,this._el=o.getCanvasContainer(),this._container=o.getContainer(),util.bindAll(["_onMouseDown","_onMouseMove","_onMouseUp","_onKeyDown"],this)};BoxZoomHandler.prototype.isEnabled=function(){return!!this._enabled},BoxZoomHandler.prototype.isActive=function(){return!!this._active},BoxZoomHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("mousedown",this._onMouseDown,!1),this._enabled=!0)},BoxZoomHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("mousedown",this._onMouseDown),this._enabled=!1)},BoxZoomHandler.prototype._onMouseDown=function(o){o.shiftKey&&0===o.button&&(window.document.addEventListener("mousemove",this._onMouseMove,!1),window.document.addEventListener("keydown",this._onKeyDown,!1),window.document.addEventListener("mouseup",this._onMouseUp,!1),DOM.disableDrag(),this._startPos=DOM.mousePos(this._el,o),this._active=!0)},BoxZoomHandler.prototype._onMouseMove=function(o){var e=this._startPos,t=DOM.mousePos(this._el,o);this._box||(this._box=DOM.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",o));var n=Math.min(e.x,t.x),i=Math.max(e.x,t.x),s=Math.min(e.y,t.y),r=Math.max(e.y,t.y);DOM.setTransform(this._box,"translate("+n+"px,"+s+"px)"),this._box.style.width=i-n+"px",this._box.style.height=r-s+"px"},BoxZoomHandler.prototype._onMouseUp=function(o){if(0===o.button){var e=this._startPos,t=DOM.mousePos(this._el,o),n=(new LngLatBounds).extend(this._map.unproject(e)).extend(this._map.unproject(t));this._finish(),e.x===t.x&&e.y===t.y?this._fireEvent("boxzoomcancel",o):this._map.fitBounds(n,{linear:!0}).fire("boxzoomend",{originalEvent:o,boxZoomBounds:n})}},BoxZoomHandler.prototype._onKeyDown=function(o){27===o.keyCode&&(this._finish(),this._fireEvent("boxzoomcancel",o))},BoxZoomHandler.prototype._finish=function(){this._active=!1,window.document.removeEventListener("mousemove",this._onMouseMove,!1),window.document.removeEventListener("keydown",this._onKeyDown,!1),window.document.removeEventListener("mouseup",this._onMouseUp,!1),this._container.classList.remove("mapboxgl-crosshair"),this._box&&(this._box.parentNode.removeChild(this._box),this._box=null),DOM.enableDrag()},BoxZoomHandler.prototype._fireEvent=function(o,e){return this._map.fire(o,{originalEvent:e})},module.exports=BoxZoomHandler;
	},{"../../geo/lng_lat_bounds":20,"../../util/dom":115,"../../util/util":127,"../../util/window":110}],96:[function(require,module,exports){
	"use strict";var DoubleClickZoomHandler=function(o){this._map=o,this._onDblClick=this._onDblClick.bind(this)};DoubleClickZoomHandler.prototype.isEnabled=function(){return!!this._enabled},DoubleClickZoomHandler.prototype.enable=function(){this.isEnabled()||(this._map.on("dblclick",this._onDblClick),this._enabled=!0)},DoubleClickZoomHandler.prototype.disable=function(){this.isEnabled()&&(this._map.off("dblclick",this._onDblClick),this._enabled=!1)},DoubleClickZoomHandler.prototype._onDblClick=function(o){this._map.zoomTo(this._map.getZoom()+(o.originalEvent.shiftKey?-1:1),{around:o.lngLat},o)},module.exports=DoubleClickZoomHandler;
	},{}],97:[function(require,module,exports){
	"use strict";var DOM=require("../../util/dom"),util=require("../../util/util"),window=require("../../util/window"),inertiaLinearity=.3,inertiaEasing=util.bezier(0,0,inertiaLinearity,1),inertiaMaxSpeed=1400,inertiaDeceleration=2500,DragPanHandler=function(t){this._map=t,this._el=t.getCanvasContainer(),util.bindAll(["_onDown","_onMove","_onUp","_onTouchEnd","_onMouseUp"],this)};DragPanHandler.prototype.isEnabled=function(){return!!this._enabled},DragPanHandler.prototype.isActive=function(){return!!this._active},DragPanHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("mousedown",this._onDown),this._el.addEventListener("touchstart",this._onDown),this._enabled=!0)},DragPanHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("mousedown",this._onDown),this._el.removeEventListener("touchstart",this._onDown),this._enabled=!1)},DragPanHandler.prototype._onDown=function(t){this._ignoreEvent(t)||this.isActive()||(t.touches?(window.document.addEventListener("touchmove",this._onMove),window.document.addEventListener("touchend",this._onTouchEnd)):(window.document.addEventListener("mousemove",this._onMove),window.document.addEventListener("mouseup",this._onMouseUp)),this._active=!1,this._startPos=this._pos=DOM.mousePos(this._el,t),this._inertia=[[Date.now(),this._pos]])},DragPanHandler.prototype._onMove=function(t){if(!this._ignoreEvent(t)){this.isActive()||(this._active=!0,this._fireEvent("dragstart",t),this._fireEvent("movestart",t));var e=DOM.mousePos(this._el,t),n=this._map;n.stop(),this._drainInertiaBuffer(),this._inertia.push([Date.now(),e]),n.transform.setLocationAtPoint(n.transform.pointLocation(this._pos),e),this._fireEvent("drag",t),this._fireEvent("move",t),this._pos=e,t.preventDefault()}},DragPanHandler.prototype._onUp=function(t){var e=this;if(this.isActive()){this._active=!1,this._fireEvent("dragend",t),this._drainInertiaBuffer();var n=function(){return e._fireEvent("moveend",t)},i=this._inertia;if(i.length<2)return void n();var o=i[i.length-1],r=i[0],a=o[1].sub(r[1]),s=(o[0]-r[0])/1e3;if(0===s||o[1].equals(r[1]))return void n();var u=a.mult(inertiaLinearity/s),h=u.mag();h>inertiaMaxSpeed&&(h=inertiaMaxSpeed,u._unit()._mult(h));var d=h/(inertiaDeceleration*inertiaLinearity),v=u.mult(-d/2);this._map.panBy(v,{duration:1e3*d,easing:inertiaEasing,noMoveStart:!0},{originalEvent:t})}},DragPanHandler.prototype._onMouseUp=function(t){this._ignoreEvent(t)||(this._onUp(t),window.document.removeEventListener("mousemove",this._onMove),window.document.removeEventListener("mouseup",this._onMouseUp))},DragPanHandler.prototype._onTouchEnd=function(t){this._ignoreEvent(t)||(this._onUp(t),window.document.removeEventListener("touchmove",this._onMove),window.document.removeEventListener("touchend",this._onTouchEnd))},DragPanHandler.prototype._fireEvent=function(t,e){return this._map.fire(t,{originalEvent:e})},DragPanHandler.prototype._ignoreEvent=function(t){var e=this._map;if(e.boxZoom&&e.boxZoom.isActive())return!0;if(e.dragRotate&&e.dragRotate.isActive())return!0;if(t.touches)return t.touches.length>1;if(t.ctrlKey)return!0;var n=1,i=0;return"mousemove"===t.type?t.buttons&0===n:t.button!==i},DragPanHandler.prototype._drainInertiaBuffer=function(){for(var t=this._inertia,e=Date.now(),n=160;t.length>0&&e-t[0][0]>n;)t.shift()},module.exports=DragPanHandler;
	},{"../../util/dom":115,"../../util/util":127,"../../util/window":110}],98:[function(require,module,exports){
	"use strict";var DOM=require("../../util/dom"),util=require("../../util/util"),window=require("../../util/window"),inertiaLinearity=.25,inertiaEasing=util.bezier(0,0,inertiaLinearity,1),inertiaMaxSpeed=180,inertiaDeceleration=720,DragRotateHandler=function(t,e){this._map=t,this._el=t.getCanvasContainer(),this._bearingSnap=e.bearingSnap,this._pitchWithRotate=e.pitchWithRotate!==!1,util.bindAll(["_onDown","_onMove","_onUp"],this)};DragRotateHandler.prototype.isEnabled=function(){return!!this._enabled},DragRotateHandler.prototype.isActive=function(){return!!this._active},DragRotateHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("mousedown",this._onDown),this._enabled=!0)},DragRotateHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("mousedown",this._onDown),this._enabled=!1)},DragRotateHandler.prototype._onDown=function(t){this._ignoreEvent(t)||this.isActive()||(window.document.addEventListener("mousemove",this._onMove),window.document.addEventListener("mouseup",this._onUp),this._active=!1,this._inertia=[[Date.now(),this._map.getBearing()]],this._startPos=this._pos=DOM.mousePos(this._el,t),this._center=this._map.transform.centerPoint,t.preventDefault())},DragRotateHandler.prototype._onMove=function(t){if(!this._ignoreEvent(t)){this.isActive()||(this._active=!0,this._fireEvent("rotatestart",t),this._fireEvent("movestart",t));var e=this._map;e.stop();var i=this._pos,n=DOM.mousePos(this._el,t),r=.8*(i.x-n.x),a=(i.y-n.y)*-.5,o=e.getBearing()-r,s=e.getPitch()-a,h=this._inertia,_=h[h.length-1];this._drainInertiaBuffer(),h.push([Date.now(),e._normalizeBearing(o,_[1])]),e.transform.bearing=o,this._pitchWithRotate&&(e.transform.pitch=s),this._fireEvent("rotate",t),this._fireEvent("move",t),this._pos=n}},DragRotateHandler.prototype._onUp=function(t){var e=this;if(!this._ignoreEvent(t)&&(window.document.removeEventListener("mousemove",this._onMove),window.document.removeEventListener("mouseup",this._onUp),this.isActive())){this._active=!1,this._fireEvent("rotateend",t),this._drainInertiaBuffer();var i=this._map,n=i.getBearing(),r=this._inertia,a=function(){Math.abs(n)<e._bearingSnap?i.resetNorth({noMoveStart:!0},{originalEvent:t}):e._fireEvent("moveend",t)};if(r.length<2)return void a();var o=r[0],s=r[r.length-1],h=r[r.length-2],_=i._normalizeBearing(n,h[1]),v=s[1]-o[1],u=v<0?-1:1,d=(s[0]-o[0])/1e3;if(0===v||0===d)return void a();var l=Math.abs(v*(inertiaLinearity/d));l>inertiaMaxSpeed&&(l=inertiaMaxSpeed);var p=l/(inertiaDeceleration*inertiaLinearity),g=u*l*(p/2);_+=g,Math.abs(i._normalizeBearing(_,0))<this._bearingSnap&&(_=i._normalizeBearing(0,_)),i.rotateTo(_,{duration:1e3*p,easing:inertiaEasing,noMoveStart:!0},{originalEvent:t})}},DragRotateHandler.prototype._fireEvent=function(t,e){return this._map.fire(t,{originalEvent:e})},DragRotateHandler.prototype._ignoreEvent=function(t){var e=this._map;if(e.boxZoom&&e.boxZoom.isActive())return!0;if(e.dragPan&&e.dragPan.isActive())return!0;if(t.touches)return t.touches.length>1;var i=t.ctrlKey?1:2,n=t.ctrlKey?0:2,r=t.button;return"undefined"!=typeof InstallTrigger&&2===t.button&&t.ctrlKey&&window.navigator.platform.toUpperCase().indexOf("MAC")>=0&&(r=0),"mousemove"===t.type?t.buttons&0===i:r!==n},DragRotateHandler.prototype._drainInertiaBuffer=function(){for(var t=this._inertia,e=Date.now(),i=160;t.length>0&&e-t[0][0]>i;)t.shift()},module.exports=DragRotateHandler;
	},{"../../util/dom":115,"../../util/util":127,"../../util/window":110}],99:[function(require,module,exports){
	"use strict";function easeOut(e){return e*(2-e)}var panStep=100,bearingStep=15,pitchStep=10,KeyboardHandler=function(e){this._map=e,this._el=e.getCanvasContainer(),this._onKeyDown=this._onKeyDown.bind(this)};KeyboardHandler.prototype.isEnabled=function(){return!!this._enabled},KeyboardHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("keydown",this._onKeyDown,!1),this._enabled=!0)},KeyboardHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("keydown",this._onKeyDown),this._enabled=!1)},KeyboardHandler.prototype._onKeyDown=function(e){if(!(e.altKey||e.ctrlKey||e.metaKey)){var t=0,n=0,a=0,i=0,r=0;switch(e.keyCode){case 61:case 107:case 171:case 187:t=1;break;case 189:case 109:case 173:t=-1;break;case 37:e.shiftKey?n=-1:(e.preventDefault(),i=-1);break;case 39:e.shiftKey?n=1:(e.preventDefault(),i=1);break;case 38:e.shiftKey?a=1:(e.preventDefault(),r=-1);break;case 40:e.shiftKey?a=-1:(r=1,e.preventDefault())}var s=this._map,o=s.getZoom(),d={duration:300,delayEndEvents:500,easing:easeOut,zoom:t?Math.round(o)+t*(e.shiftKey?2:1):o,bearing:s.getBearing()+n*bearingStep,pitch:s.getPitch()+a*pitchStep,offset:[-i*panStep,-r*panStep],center:s.getCenter()};s.easeTo(d,{originalEvent:e})}},module.exports=KeyboardHandler;
	},{}],100:[function(require,module,exports){
	"use strict";var DOM=require("../../util/dom"),util=require("../../util/util"),browser=require("../../util/browser"),window=require("../../util/window"),ua=window.navigator.userAgent.toLowerCase(),firefox=ua.indexOf("firefox")!==-1,safari=ua.indexOf("safari")!==-1&&ua.indexOf("chrom")===-1,ScrollZoomHandler=function(e){this._map=e,this._el=e.getCanvasContainer(),util.bindAll(["_onWheel","_onTimeout"],this)};ScrollZoomHandler.prototype.isEnabled=function(){return!!this._enabled},ScrollZoomHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("wheel",this._onWheel,!1),this._el.addEventListener("mousewheel",this._onWheel,!1),this._enabled=!0)},ScrollZoomHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("wheel",this._onWheel),this._el.removeEventListener("mousewheel",this._onWheel),this._enabled=!1)},ScrollZoomHandler.prototype._onWheel=function(e){var t;"wheel"===e.type?(t=e.deltaY,firefox&&e.deltaMode===window.WheelEvent.DOM_DELTA_PIXEL&&(t/=browser.devicePixelRatio),e.deltaMode===window.WheelEvent.DOM_DELTA_LINE&&(t*=40)):"mousewheel"===e.type&&(t=-e.wheelDeltaY,safari&&(t/=3));var o=browser.now(),i=o-(this._time||0);this._pos=DOM.mousePos(this._el,e),this._time=o,0!==t&&t%4.000244140625===0?this._type="wheel":0!==t&&Math.abs(t)<4?this._type="trackpad":i>400?(this._type=null,this._lastValue=t,this._timeout=setTimeout(this._onTimeout,40)):this._type||(this._type=Math.abs(i*t)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,t+=this._lastValue)),e.shiftKey&&t&&(t/=4),this._type&&this._zoom(-t,e),e.preventDefault()},ScrollZoomHandler.prototype._onTimeout=function(){this._type="wheel",this._zoom(-this._lastValue)},ScrollZoomHandler.prototype._zoom=function(e,t){if(0!==e){var o=this._map,i=2/(1+Math.exp(-Math.abs(e/100)));e<0&&0!==i&&(i=1/i);var l=o.ease?o.ease.to:o.transform.scale,s=o.transform.scaleZoom(l*i);o.zoomTo(s,{duration:"wheel"===this._type?200:0,around:o.unproject(this._pos),delayEndEvents:200,smoothEasing:!0},{originalEvent:t})}},module.exports=ScrollZoomHandler;
	},{"../../util/browser":108,"../../util/dom":115,"../../util/util":127,"../../util/window":110}],101:[function(require,module,exports){
	"use strict";var DOM=require("../../util/dom"),util=require("../../util/util"),window=require("../../util/window"),inertiaLinearity=.15,inertiaEasing=util.bezier(0,0,inertiaLinearity,1),inertiaDeceleration=12,inertiaMaxSpeed=2.5,significantScaleThreshold=.15,significantRotateThreshold=4,TouchZoomRotateHandler=function(t){this._map=t,this._el=t.getCanvasContainer(),util.bindAll(["_onStart","_onMove","_onEnd"],this)};TouchZoomRotateHandler.prototype.isEnabled=function(){return!!this._enabled},TouchZoomRotateHandler.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("touchstart",this._onStart,!1),this._enabled=!0)},TouchZoomRotateHandler.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("touchstart",this._onStart),this._enabled=!1)},TouchZoomRotateHandler.prototype.disableRotation=function(){this._rotationDisabled=!0},TouchZoomRotateHandler.prototype.enableRotation=function(){this._rotationDisabled=!1},TouchZoomRotateHandler.prototype._onStart=function(t){if(2===t.touches.length){var e=DOM.mousePos(this._el,t.touches[0]),i=DOM.mousePos(this._el,t.touches[1]);this._startVec=e.sub(i),this._startScale=this._map.transform.scale,this._startBearing=this._map.transform.bearing,this._gestureIntent=void 0,this._inertia=[],window.document.addEventListener("touchmove",this._onMove,!1),window.document.addEventListener("touchend",this._onEnd,!1)}},TouchZoomRotateHandler.prototype._onMove=function(t){if(2===t.touches.length){var e=DOM.mousePos(this._el,t.touches[0]),i=DOM.mousePos(this._el,t.touches[1]),o=e.add(i).div(2),n=e.sub(i),a=n.mag()/this._startVec.mag(),r=this._rotationDisabled?0:180*n.angleWith(this._startVec)/Math.PI,s=this._map;if(this._gestureIntent){var h={duration:0,around:s.unproject(o)};"rotate"===this._gestureIntent&&(h.bearing=this._startBearing+r),"zoom"!==this._gestureIntent&&"rotate"!==this._gestureIntent||(h.zoom=s.transform.scaleZoom(this._startScale*a)),s.stop(),this._drainInertiaBuffer(),this._inertia.push([Date.now(),a,o]),s.easeTo(h,{originalEvent:t})}else{var u=Math.abs(1-a)>significantScaleThreshold,l=Math.abs(r)>significantRotateThreshold;l?this._gestureIntent="rotate":u&&(this._gestureIntent="zoom"),this._gestureIntent&&(this._startVec=n,this._startScale=s.transform.scale,this._startBearing=s.transform.bearing)}t.preventDefault()}},TouchZoomRotateHandler.prototype._onEnd=function(t){window.document.removeEventListener("touchmove",this._onMove),window.document.removeEventListener("touchend",this._onEnd),this._drainInertiaBuffer();var e=this._inertia,i=this._map;if(e.length<2)return void i.snapToNorth({},{originalEvent:t});var o=e[e.length-1],n=e[0],a=i.transform.scaleZoom(this._startScale*o[1]),r=i.transform.scaleZoom(this._startScale*n[1]),s=a-r,h=(o[0]-n[0])/1e3,u=o[2];if(0===h||a===r)return void i.snapToNorth({},{originalEvent:t});var l=s*inertiaLinearity/h;Math.abs(l)>inertiaMaxSpeed&&(l=l>0?inertiaMaxSpeed:-inertiaMaxSpeed);var d=1e3*Math.abs(l/(inertiaDeceleration*inertiaLinearity)),c=a+l*d/2e3;c<0&&(c=0),i.easeTo({zoom:c,duration:d,easing:inertiaEasing,around:i.unproject(u)},{originalEvent:t})},TouchZoomRotateHandler.prototype._drainInertiaBuffer=function(){for(var t=this._inertia,e=Date.now(),i=160;t.length>2&&e-t[0][0]>i;)t.shift()},module.exports=TouchZoomRotateHandler;
	},{"../../util/dom":115,"../../util/util":127,"../../util/window":110}],102:[function(require,module,exports){
	"use strict";var util=require("../util/util"),window=require("../util/window"),Hash=function(){util.bindAll(["_onHashChange","_updateHash"],this)};Hash.prototype.addTo=function(t){return this._map=t,window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},Hash.prototype.remove=function(){return window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),delete this._map,this},Hash.prototype._onHashChange=function(){var t=window.location.hash.replace("#","").split("/");return t.length>=3&&(this._map.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:+(t[3]||0),pitch:+(t[4]||0)}),!0)},Hash.prototype._updateHash=function(){var t=this._map.getCenter(),e=this._map.getZoom(),a=this._map.getBearing(),h=this._map.getPitch(),i=Math.max(0,Math.ceil(Math.log(e)/Math.LN2)),n="#"+Math.round(100*e)/100+"/"+t.lat.toFixed(i)+"/"+t.lng.toFixed(i);(a||h)&&(n+="/"+Math.round(10*a)/10),h&&(n+="/"+Math.round(h)),window.history.replaceState("","",n)},module.exports=Hash;
	},{"../util/util":127,"../util/window":110}],103:[function(require,module,exports){
	"use strict";function removeNode(t){t.parentNode&&t.parentNode.removeChild(t)}var util=require("../util/util"),browser=require("../util/browser"),window=require("../util/window"),DOM=require("../util/dom"),Style=require("../style/style"),AnimationLoop=require("../style/animation_loop"),Painter=require("../render/painter"),Transform=require("../geo/transform"),Hash=require("./hash"),bindHandlers=require("./bind_handlers"),Camera=require("./camera"),LngLat=require("../geo/lng_lat"),LngLatBounds=require("../geo/lng_lat_bounds"),Point=require("point-geometry"),AttributionControl=require("./control/attribution_control"),isSupported=require("mapbox-gl-supported"),defaultMinZoom=0,defaultMaxZoom=20,defaultOptions={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:defaultMinZoom,maxZoom:defaultMaxZoom,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,bearingSnap:7,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0},Map=function(t){function e(e){var i=this;e=util.extend({},defaultOptions,e);var o=new Transform(e.minZoom,e.maxZoom);if(t.call(this,o,e),this._interactive=e.interactive,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,"string"==typeof e.container){if(this._container=window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else this._container=e.container;this.animationLoop=new AnimationLoop,e.maxBounds&&this.setMaxBounds(e.maxBounds),util.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored","_update","_render","_onData","_onDataLoading"],this),this._setupContainer(),this._setupPainter(),this.on("move",this._update.bind(this,!1)),this.on("zoom",this._update.bind(this,!0)),this.on("moveend",function(){i.animationLoop.set(300),i._rerender()}),"undefined"!=typeof window&&(window.addEventListener("online",this._onWindowOnline,!1),window.addEventListener("resize",this._onWindowResize,!1)),bindHandlers(this,e),this._hash=e.hash&&(new Hash).addTo(this),this._hash&&this._hash._onHashChange()||this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),this._classes=[],this.resize(),e.classes&&this.setClasses(e.classes),e.style&&this.setStyle(e.style),e.attributionControl&&this.addControl(new AttributionControl),this.on("style.load",function(){this.transform.unmodified&&this.jumpTo(this.style.stylesheet),this.style.update(this._classes,{transition:!1})}),this.on("data",this._onData),this.on("dataloading",this._onDataLoading)}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var i={showTileBoundaries:{},showCollisionBoxes:{},showOverdrawInspector:{},repaint:{},vertices:{}};return e.prototype.addControl=function(t,e){void 0===e&&t.getDefaultPosition&&(e=t.getDefaultPosition()),void 0===e&&(e="top-right");var i=t.onAdd(this),o=this._controlPositions[e];return e.indexOf("bottom")!==-1?o.insertBefore(i,o.firstChild):o.appendChild(i),this},e.prototype.removeControl=function(t){return t.onRemove(this),this},e.prototype.addClass=function(t,e){return this._classes.indexOf(t)>=0||""===t?this:(this._classes.push(t),this._classOptions=e,this.style&&this.style.updateClasses(),this._update(!0))},e.prototype.removeClass=function(t,e){var i=this._classes.indexOf(t);return i<0||""===t?this:(this._classes.splice(i,1),this._classOptions=e,this.style&&this.style.updateClasses(),this._update(!0))},e.prototype.setClasses=function(t,e){for(var i={},o=0;o<t.length;o++)""!==t[o]&&(i[t[o]]=!0);return this._classes=Object.keys(i),this._classOptions=e,this.style&&this.style.updateClasses(),this._update(!0)},e.prototype.hasClass=function(t){return this._classes.indexOf(t)>=0},e.prototype.getClasses=function(){return this._classes},e.prototype.resize=function(){var t=this._containerDimensions(),e=t[0],i=t[1];return this._resizeCanvas(e,i),this.transform.resize(e,i),this.painter.resize(e,i),this.fire("movestart").fire("move").fire("resize").fire("moveend")},e.prototype.getBounds=function(){var t=new LngLatBounds(this.transform.pointLocation(new Point(0,this.transform.height)),this.transform.pointLocation(new Point(this.transform.width,0)));return(this.transform.angle||this.transform.pitch)&&(t.extend(this.transform.pointLocation(new Point(this.transform.size.x,0))),t.extend(this.transform.pointLocation(new Point(0,this.transform.size.y)))),t},e.prototype.setMaxBounds=function(t){if(t){var e=LngLatBounds.convert(t);this.transform.lngRange=[e.getWest(),e.getEast()],this.transform.latRange=[e.getSouth(),e.getNorth()],this.transform._constrain(),this._update()}else null!==t&&void 0!==t||(this.transform.lngRange=[],this.transform.latRange=[],this._update());return this},e.prototype.setMinZoom=function(t){if(t=null===t||void 0===t?defaultMinZoom:t,t>=defaultMinZoom&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between "+defaultMinZoom+" and the current maxZoom, inclusive")},e.prototype.getMinZoom=function(){return this.transform.minZoom},e.prototype.setMaxZoom=function(t){if(t=null===t||void 0===t?defaultMaxZoom:t,t>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},e.prototype.getMaxZoom=function(){return this.transform.maxZoom},e.prototype.project=function(t){return this.transform.locationPoint(LngLat.convert(t))},e.prototype.unproject=function(t){return this.transform.pointLocation(Point.convert(t))},e.prototype.queryRenderedFeatures=function(){function t(t){return t instanceof Point||Array.isArray(t)}var e,i={};return 2===arguments.length?(e=arguments[0],i=arguments[1]):1===arguments.length&&t(arguments[0])?e=arguments[0]:1===arguments.length&&(i=arguments[0]),this.style.queryRenderedFeatures(this._makeQueryGeometry(e),i,this.transform.zoom,this.transform.angle)},e.prototype._makeQueryGeometry=function(t){var e=this;void 0===t&&(t=[Point.convert([0,0]),Point.convert([this.transform.width,this.transform.height])]);var i,o=t instanceof Point||"number"==typeof t[0];if(o){var s=Point.convert(t);i=[s]}else{var r=[Point.convert(t[0]),Point.convert(t[1])];i=[r[0],new Point(r[1].x,r[0].y),r[1],new Point(r[0].x,r[1].y),r[0]]}return i=i.map(function(t){return e.transform.pointCoordinate(t)})},e.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},e.prototype.setStyle=function(t,e){var i=(!e||e.diff!==!1)&&this.style&&t&&!(t instanceof Style)&&"string"!=typeof t;if(i)try{return this.style.setState(t)&&this._update(!0),this}catch(t){util.warnOnce("Unable to perform style diff: "+(t.message||t.error||t)+".  Rebuilding the style from scratch.")}return this.style&&(this.style.setEventedParent(null),this.style._remove(),this.off("rotate",this.style._redoPlacement),this.off("pitch",this.style._redoPlacement)),t?(t instanceof Style?this.style=t:this.style=new Style(t,this),this.style.setEventedParent(this,{style:this.style}),this.on("rotate",this.style._redoPlacement),this.on("pitch",this.style._redoPlacement),this):(this.style=null,this)},e.prototype.getStyle=function(){if(this.style)return this.style.serialize()},e.prototype.addSource=function(t,e){return this.style.addSource(t,e),this._update(!0),this},e.prototype.addSourceType=function(t,e,i){return this.style.addSourceType(t,e,i)},e.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0),this},e.prototype.getSource=function(t){return this.style.getSource(t)},e.prototype.addLayer=function(t,e){return this.style.addLayer(t,e),this._update(!0),this},e.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0),this},e.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0),this},e.prototype.getLayer=function(t){return this.style.getLayer(t)},e.prototype.setFilter=function(t,e){return this.style.setFilter(t,e),this._update(!0),this},e.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0),this},e.prototype.getFilter=function(t){return this.style.getFilter(t)},e.prototype.setPaintProperty=function(t,e,i,o){return this.style.setPaintProperty(t,e,i,o),this._update(!0),this},e.prototype.getPaintProperty=function(t,e,i){return this.style.getPaintProperty(t,e,i)},e.prototype.setLayoutProperty=function(t,e,i){return this.style.setLayoutProperty(t,e,i),this._update(!0),this},e.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},e.prototype.setLight=function(t){return this.style.setLight(t),this._update(!0),this},e.prototype.getLight=function(){return this.style.getLight()},e.prototype.getContainer=function(){return this._container},e.prototype.getCanvasContainer=function(){return this._canvasContainer},e.prototype.getCanvas=function(){return this._canvas},e.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.offsetWidth||400,e=this._container.offsetHeight||300),[t,e]},e.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map");var e=this._canvasContainer=DOM.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=DOM.create("canvas","mapboxgl-canvas",e),this._canvas.style.position="absolute",this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex",0),this._canvas.setAttribute("aria-label","Map");var i=this._containerDimensions();this._resizeCanvas(i[0],i[1]);var o=this._controlContainer=DOM.create("div","mapboxgl-control-container",t),s=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach(function(t){s[t]=DOM.create("div","mapboxgl-ctrl-"+t,o)})},e.prototype._resizeCanvas=function(t,e){var i=window.devicePixelRatio||1;this._canvas.width=i*t,this._canvas.height=i*e,this._canvas.style.width=t+"px",this._canvas.style.height=e+"px"},e.prototype._setupPainter=function(){var t=util.extend({failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer},isSupported.webGLContextAttributes),e=this._canvas.getContext("webgl",t)||this._canvas.getContext("experimental-webgl",t);return e?void(this.painter=new Painter(e,this.transform)):void this.fire("error",{error:new Error("Failed to initialize WebGL")})},e.prototype._contextLost=function(t){t.preventDefault(),this._frameId&&browser.cancelFrame(this._frameId),this.fire("webglcontextlost",{originalEvent:t})},e.prototype._contextRestored=function(t){this._setupPainter(),this.resize(),this._update(),this.fire("webglcontextrestored",{originalEvent:t})},e.prototype.loaded=function(){return!this._styleDirty&&!this._sourcesDirty&&!(!this.style||!this.style.loaded())},e.prototype._update=function(t){return this.style?(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this._rerender(),this):this},e.prototype._render=function(){return this.style&&this._styleDirty&&(this._styleDirty=!1,this.style.update(this._classes,this._classOptions),this._classOptions=null,this.style._recalculate(this.transform.zoom)),this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.rotating,zooming:this.zooming}),this.fire("render"),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire("load")),this._frameId=null,this.animationLoop.stopped()||(this._styleDirty=!0),(this._sourcesDirty||this._repaint||this._styleDirty)&&this._rerender(),this},e.prototype.remove=function(){this._hash&&this._hash.remove(),browser.cancelFrame(this._frameId),this.setStyle(null),"undefined"!=typeof window&&window.removeEventListener("resize",this._onWindowResize,!1);var t=this.painter.gl.getExtension("WEBGL_lose_context");t&&t.loseContext(),removeNode(this._canvasContainer),removeNode(this._controlContainer),this._container.classList.remove("mapboxgl-map"),this.fire("remove")},e.prototype._rerender=function(){this.style&&!this._frameId&&(this._frameId=browser.frame(this._render))},e.prototype._onWindowOnline=function(){this._update()},e.prototype._onWindowResize=function(){this._trackResize&&this.stop().resize()._update()},i.showTileBoundaries.get=function(){return!!this._showTileBoundaries},i.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update())},i.showCollisionBoxes.get=function(){return!!this._showCollisionBoxes},i.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,this.style._redoPlacement())},i.showOverdrawInspector.get=function(){return!!this._showOverdrawInspector},i.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update())},i.repaint.get=function(){return!!this._repaint},i.repaint.set=function(t){this._repaint=t,this._update()},i.vertices.get=function(){return!!this._vertices},i.vertices.set=function(t){this._vertices=t,this._update()},e.prototype._onData=function(t){this._update("style"===t.dataType),this.fire(t.dataType+"data",t)},e.prototype._onDataLoading=function(t){this.fire(t.dataType+"dataloading",t)},Object.defineProperties(e.prototype,i),e}(Camera);module.exports=Map;
	},{"../geo/lng_lat":19,"../geo/lng_lat_bounds":20,"../geo/transform":21,"../render/painter":36,"../style/animation_loop":57,"../style/style":61,"../util/browser":108,"../util/dom":115,"../util/util":127,"../util/window":110,"./bind_handlers":89,"./camera":90,"./control/attribution_control":91,"./hash":102,"mapbox-gl-supported":190,"point-geometry":194}],104:[function(require,module,exports){
	"use strict";var DOM=require("../util/dom"),LngLat=require("../geo/lng_lat"),Point=require("point-geometry"),Marker=function(t,e){this._offset=Point.convert(e&&e.offset||[0,0]),this._update=this._update.bind(this),this._onMapClick=this._onMapClick.bind(this),t||(t=DOM.create("div")),t.classList.add("mapboxgl-marker"),this._element=t,this._popup=null};Marker.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this._update(),this._map.on("click",this._onMapClick),this},Marker.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map=null),DOM.remove(this._element),this._popup&&this._popup.remove(),this},Marker.prototype.getLngLat=function(){return this._lngLat},Marker.prototype.setLngLat=function(t){return this._lngLat=LngLat.convert(t),this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},Marker.prototype.getElement=function(){return this._element},Marker.prototype.setPopup=function(t){return this._popup&&(this._popup.remove(),this._popup=null),t&&(this._popup=t,this._popup.setLngLat(this._lngLat)),this},Marker.prototype._onMapClick=function(t){var e=t.originalEvent.target,p=this._element;this._popup&&(e===p||p.contains(e))&&this.togglePopup()},Marker.prototype.getPopup=function(){return this._popup},Marker.prototype.togglePopup=function(){var t=this._popup;t&&(t.isOpen()?t.remove():t.addTo(this._map))},Marker.prototype._update=function(t){if(this._map){var e=this._map.project(this._lngLat)._add(this._offset);t&&"moveend"!==t.type||(e=e.round()),DOM.setTransform(this._element,"translate("+e.x+"px, "+e.y+"px)")}},module.exports=Marker;
	},{"../geo/lng_lat":19,"../util/dom":115,"point-geometry":194}],105:[function(require,module,exports){
	"use strict";function normalizeOffset(t){if(t){if("number"==typeof t){var o=Math.round(Math.sqrt(.5*Math.pow(t,2)));return{top:new Point(0,t),"top-left":new Point(o,o),"top-right":new Point(-o,o),bottom:new Point(0,-t),"bottom-left":new Point(o,-o),"bottom-right":new Point(-o,-o),left:new Point(t,0),right:new Point(-t,0)}}if(isPointLike(t)){var e=Point.convert(t);return{top:e,"top-left":e,"top-right":e,bottom:e,"bottom-left":e,"bottom-right":e,left:e,right:e}}return{top:Point.convert(t.top||[0,0]),"top-left":Point.convert(t["top-left"]||[0,0]),"top-right":Point.convert(t["top-right"]||[0,0]),bottom:Point.convert(t.bottom||[0,0]),"bottom-left":Point.convert(t["bottom-left"]||[0,0]),"bottom-right":Point.convert(t["bottom-right"]||[0,0]),left:Point.convert(t.left||[0,0]),right:Point.convert(t.right||[0,0])}}return normalizeOffset(new Point(0,0))}function isPointLike(t){return t instanceof Point||Array.isArray(t)}var util=require("../util/util"),Evented=require("../util/evented"),DOM=require("../util/dom"),LngLat=require("../geo/lng_lat"),Point=require("point-geometry"),window=require("../util/window"),defaultOptions={closeButton:!0,closeOnClick:!0},Popup=function(t){function o(o){t.call(this),this.options=util.extend(Object.create(defaultOptions),o),util.bindAll(["_update","_onClickClose"],this)}return t&&(o.__proto__=t),o.prototype=Object.create(t&&t.prototype),o.prototype.constructor=o,o.prototype.addTo=function(t){return this._map=t,this._map.on("move",this._update),this.options.closeOnClick&&this._map.on("click",this._onClickClose),this._update(),this},o.prototype.isOpen=function(){return!!this._map},o.prototype.remove=function(){return this._content&&this._content.parentNode&&this._content.parentNode.removeChild(this._content),this._container&&(this._container.parentNode.removeChild(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("click",this._onClickClose),delete this._map),this.fire("close"),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(t){return this._lngLat=LngLat.convert(t),this._update(),this},o.prototype.setText=function(t){return this.setDOMContent(window.document.createTextNode(t))},o.prototype.setHTML=function(t){var o,e=window.document.createDocumentFragment(),n=window.document.createElement("body");for(n.innerHTML=t;;){if(o=n.firstChild,!o)break;e.appendChild(o)}return this.setDOMContent(e)},o.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},o.prototype._createContent=function(){this._content&&this._content.parentNode&&this._content.parentNode.removeChild(this._content),this._content=DOM.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=DOM.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClickClose))},o.prototype._update=function(){if(this._map&&this._lngLat&&this._content){this._container||(this._container=DOM.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=DOM.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content));var t=this.options.anchor,o=normalizeOffset(this.options.offset),e=this._map.project(this._lngLat).round();if(!t){var n=this._container.offsetWidth,i=this._container.offsetHeight;t=e.y+o.bottom.y<i?["top"]:e.y>this._map.transform.height-i?["bottom"]:[],e.x<n/2?t.push("left"):e.x>this._map.transform.width-n/2&&t.push("right"),t=0===t.length?"bottom":t.join("-")}var r=e.add(o[t]),s={top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"},p=this._container.classList;for(var a in s)p.remove("mapboxgl-popup-anchor-"+a);p.add("mapboxgl-popup-anchor-"+t),DOM.setTransform(this._container,s[t]+" translate("+r.x+"px,"+r.y+"px)")}},o.prototype._onClickClose=function(){this.remove()},o}(Evented);module.exports=Popup;
	},{"../geo/lng_lat":19,"../util/dom":115,"../util/evented":116,"../util/util":127,"../util/window":110,"point-geometry":194}],106:[function(require,module,exports){
	"use strict";var Actor=function(t,e,a){this.target=t,this.parent=e,this.mapId=a,this.callbacks={},this.callbackID=0,this.receive=this.receive.bind(this),this.target.addEventListener("message",this.receive,!1)};Actor.prototype.send=function(t,e,a,r,s){var i=a?this.mapId+":"+this.callbackID++:null;a&&(this.callbacks[i]=a),this.target.postMessage({targetMapId:s,sourceMapId:this.mapId,type:t,id:String(i),data:e},r)},Actor.prototype.receive=function(t){var e,a=this,r=t.data,s=r.id;if(!r.targetMapId||this.mapId===r.targetMapId){var i=function(t,e,r){a.target.postMessage({sourceMapId:a.mapId,type:"<response>",id:String(s),error:t?String(t):null,data:e},r)};if("<response>"===r.type)e=this.callbacks[r.id],delete this.callbacks[r.id],e&&e(r.error||null,r.data);else if("undefined"!=typeof r.id&&this.parent[r.type])this.parent[r.type](r.sourceMapId,r.data,i);else if("undefined"!=typeof r.id&&this.parent.getWorkerSource){var p=r.type.split("."),d=this.parent.getWorkerSource(r.sourceMapId,p[0]);d[p[1]](r.data,i)}else this.parent[r.type](r.data)}},Actor.prototype.remove=function(){this.target.removeEventListener("message",this.receive,!1)},module.exports=Actor;
	},{}],107:[function(require,module,exports){
	"use strict";function sameOrigin(e){var n=window.document.createElement("a");return n.href=e,n.protocol===window.document.location.protocol&&n.host===window.document.location.host}var window=require("./window");exports.getJSON=function(e,n){var t=new window.XMLHttpRequest;return t.open("GET",e,!0),t.setRequestHeader("Accept","application/json"),t.onerror=function(e){n(e)},t.onload=function(){if(t.status>=200&&t.status<300&&t.response){var e;try{e=JSON.parse(t.response)}catch(e){return n(e)}n(null,e)}else n(new Error(t.statusText))},t.send(),t},exports.getArrayBuffer=function(e,n){var t=new window.XMLHttpRequest;return t.open("GET",e,!0),t.responseType="arraybuffer",t.onerror=function(e){n(e)},t.onload=function(){return 0===t.response.byteLength&&200===t.status?n(new Error("http status 200 returned without content.")):void(t.status>=200&&t.status<300&&t.response?n(null,t.response):n(new Error(t.statusText)))},t.send(),t};var transparentPngUrl="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";exports.getImage=function(e,n){return exports.getArrayBuffer(e,function(e,t){if(e)return n(e);var r=new window.Image,o=window.URL||window.webkitURL;r.onload=function(){n(null,r),o.revokeObjectURL(r.src)};var s=new window.Blob([new Uint8Array(t)],{type:"image/png"});r.src=t.byteLength?o.createObjectURL(s):transparentPngUrl})},exports.getVideo=function(e,n){var t=window.document.createElement("video");t.onloadstart=function(){n(null,t)};for(var r=0;r<e.length;r++){var o=window.document.createElement("source");sameOrigin(e[r])||(t.crossOrigin="Anonymous"),o.src=e[r],t.appendChild(o)}return t};
	},{"./window":110}],108:[function(require,module,exports){
	"use strict";var window=require("./window");module.exports.now=function(){return window.performance&&window.performance.now?window.performance.now.bind(window.performance):Date.now.bind(Date)}();var frame=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame;exports.frame=function(e){return frame(e)};var cancel=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.msCancelAnimationFrame;exports.cancelFrame=function(e){cancel(e)},exports.timed=function(e,n,t){function o(i){r||(i=module.exports.now(),i>=a+n?e.call(t,1):(e.call(t,(i-a)/n),exports.frame(o)))}if(!n)return e.call(t,1),null;var r=!1,a=module.exports.now();return exports.frame(o),function(){r=!0}},exports.getImageData=function(e){var n=window.document.createElement("canvas"),t=n.getContext("2d");return n.width=e.width,n.height=e.height,t.drawImage(e,0,0),t.getImageData(0,0,e.width,e.height).data},exports.supported=require("mapbox-gl-supported"),exports.hardwareConcurrency=window.navigator.hardwareConcurrency||4,Object.defineProperty(exports,"devicePixelRatio",{get:function(){return window.devicePixelRatio}}),exports.supportsWebp=!1;var webpImgTest=window.document.createElement("img");webpImgTest.onload=function(){exports.supportsWebp=!0},webpImgTest.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=";
	},{"./window":110,"mapbox-gl-supported":190}],109:[function(require,module,exports){
	"use strict";var WebWorkify=require("webworkify"),window=require("../window"),workerURL=window.URL.createObjectURL(new WebWorkify(require("../../source/worker"),{bare:!0}));module.exports=function(){return new window.Worker(workerURL)};
	},{"../../source/worker":55,"../window":110,"webworkify":211}],110:[function(require,module,exports){
	"use strict";module.exports=self;
	},{}],111:[function(require,module,exports){
	"use strict";function compareAreas(e,r){return r.area-e.area}var quickselect=require("quickselect"),calculateSignedArea=require("./util").calculateSignedArea;module.exports=function(e,r){var a=e.length;if(a<=1)return[e];for(var t,u,c=[],i=0;i<a;i++){var l=calculateSignedArea(e[i]);0!==l&&(e[i].area=Math.abs(l),void 0===u&&(u=l<0),u===l<0?(t&&c.push(t),t=[e[i]]):t.push(e[i]))}if(t&&c.push(t),r>1)for(var n=0;n<c.length;n++)c[n].length<=r||(quickselect(c[n],r,1,c[n].length-1,compareAreas),c[n]=c[n].slice(0,r));return c};
	},{"./util":127,"quickselect":196}],112:[function(require,module,exports){
	"use strict";var config={API_URL:"https://api.mapbox.com",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null};module.exports=config;
	},{}],113:[function(require,module,exports){
	"use strict";var DictionaryCoder=function(r){var t=this;this._stringToNumber={},this._numberToString=[];for(var o=0;o<r.length;o++){var i=r[o];t._stringToNumber[i]=o,t._numberToString[o]=i}};DictionaryCoder.prototype.encode=function(r){return this._stringToNumber[r]},DictionaryCoder.prototype.decode=function(r){return this._numberToString[r]},module.exports=DictionaryCoder;
	},{}],114:[function(require,module,exports){
	"use strict";var util=require("./util"),Actor=require("./actor"),Dispatcher=function(t,r){var o=this;this.workerPool=t,this.actors=[],this.currentActor=0,this.id=util.uniqueId();for(var i=this.workerPool.acquire(this.id),e=0;e<i.length;e++){var s=i[e],c=new Actor(s,r,o.id);c.name="Worker "+e,o.actors.push(c)}};Dispatcher.prototype.broadcast=function(t,r,o){o=o||function(){},util.asyncAll(this.actors,function(o,i){o.send(t,r,i)},o)},Dispatcher.prototype.send=function(t,r,o,i,e){return("number"!=typeof i||isNaN(i))&&(i=this.currentActor=(this.currentActor+1)%this.actors.length),this.actors[i].send(t,r,o,e),i},Dispatcher.prototype.remove=function(){this.actors.forEach(function(t){t.remove()}),this.actors=[],this.workerPool.release(this.id)},module.exports=Dispatcher;
	},{"./actor":106,"./util":127}],115:[function(require,module,exports){
	"use strict";function testProp(e){for(var t=0;t<e.length;t++)if(e[t]in docStyle)return e[t];return e[0]}function suppressClick(e){e.preventDefault(),e.stopPropagation(),window.removeEventListener("click",suppressClick,!0)}var Point=require("point-geometry"),window=require("./window");exports.create=function(e,t,o){var n=window.document.createElement(e);return t&&(n.className=t),o&&o.appendChild(n),n};var docStyle=window.document.documentElement.style,selectProp=testProp(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]),userSelect;exports.disableDrag=function(){selectProp&&(userSelect=docStyle[selectProp],docStyle[selectProp]="none")},exports.enableDrag=function(){selectProp&&(docStyle[selectProp]=userSelect)};var transformProp=testProp(["transform","WebkitTransform"]);exports.setTransform=function(e,t){e.style[transformProp]=t},exports.suppressClick=function(){window.addEventListener("click",suppressClick,!0),window.setTimeout(function(){window.removeEventListener("click",suppressClick,!0)},0)},exports.mousePos=function(e,t){var o=e.getBoundingClientRect();return t=t.touches?t.touches[0]:t,new Point(t.clientX-o.left-e.clientLeft,t.clientY-o.top-e.clientTop)},exports.touchPos=function(e,t){for(var o=e.getBoundingClientRect(),n=[],r="touchend"===t.type?t.changedTouches:t.touches,s=0;s<r.length;s++)n.push(new Point(r[s].clientX-o.left-e.clientLeft,r[s].clientY-o.top-e.clientTop));return n},exports.remove=function(e){e.parentNode&&e.parentNode.removeChild(e)};
	},{"./window":110,"point-geometry":194}],116:[function(require,module,exports){
	"use strict";var util=require("./util"),Evented=function(){};Evented.prototype.on=function(e,t){return this._listeners=this._listeners||{},this._listeners[e]=this._listeners[e]||[],this._listeners[e].push(t),this},Evented.prototype.off=function(e,t){if(this._listeners&&this._listeners[e]){var n=this._listeners[e].indexOf(t);n!==-1&&this._listeners[e].splice(n,1)}return this},Evented.prototype.once=function(e,t){var n=this,s=function(i){n.off(e,s),t.call(n,i)};return this.on(e,s),this},Evented.prototype.fire=function(e,t){var n=this;if(this.listens(e)){t=util.extend({},t,{type:e,target:this});for(var s=this._listeners&&this._listeners[e]?this._listeners[e].slice():[],i=0;i<s.length;i++)s[i].call(n,t);this._eventedParent&&this._eventedParent.fire(e,util.extend({},t,this._eventedParentData))}else util.endsWith(e,"error")&&console.error(t&&t.error||t||"Empty error event");return this},Evented.prototype.listens=function(e){return this._listeners&&this._listeners[e]||this._eventedParent&&this._eventedParent.listens(e)},Evented.prototype.setEventedParent=function(e,t){return this._eventedParent=e,this._eventedParentData="function"==typeof t?t():t,this},module.exports=Evented;
	},{"./util":127}],117:[function(require,module,exports){
	"use strict";function compareMax(e,t){return t.max-e.max}function Cell(e,t,n,r){this.p=new Point(e,t),this.h=n,this.d=pointToPolygonDist(this.p,r),this.max=this.d+this.h*Math.SQRT2}function pointToPolygonDist(e,t){for(var n=!1,r=1/0,o=0;o<t.length;o++)for(var l=t[o],i=0,s=l.length,u=s-1;i<s;u=i++){var a=l[i],h=l[u];a.y>e.y!=h.y>e.y&&e.x<(h.x-a.x)*(e.y-a.y)/(h.y-a.y)+a.x&&(n=!n),r=Math.min(r,distToSegmentSquared(e,a,h))}return(n?1:-1)*Math.sqrt(r)}function getCentroidCell(e){for(var t=0,n=0,r=0,o=e[0],l=0,i=o.length,s=i-1;l<i;s=l++){var u=o[l],a=o[s],h=u.x*a.y-a.x*u.y;n+=(u.x+a.x)*h,r+=(u.y+a.y)*h,t+=3*h}return new Cell(n/t,r/t,0,e)}var Queue=require("tinyqueue"),Point=require("point-geometry"),distToSegmentSquared=require("./intersection_tests").distToSegmentSquared;module.exports=function(e,t,n){t=t||1;for(var r,o,l,i,s=e[0],u=0;u<s.length;u++){var a=s[u];(!u||a.x<r)&&(r=a.x),(!u||a.y<o)&&(o=a.y),(!u||a.x>l)&&(l=a.x),(!u||a.y>i)&&(i=a.y)}for(var h=l-r,p=i-o,y=Math.min(h,p),x=y/2,d=new Queue(null,compareMax),g=r;g<l;g+=y)for(var f=o;f<i;f+=y)d.push(new Cell(g+x,f+x,x,e));for(var m=getCentroidCell(e),c=d.length;d.length;){var v=d.pop();v.d>m.d&&(m=v,n&&console.log("found best %d after %d probes",Math.round(1e4*v.d)/1e4,c)),v.max-m.d<=t||(x=v.h/2,d.push(new Cell(v.p.x-x,v.p.y-x,x,e)),d.push(new Cell(v.p.x+x,v.p.y-x,x,e)),d.push(new Cell(v.p.x-x,v.p.y+x,x,e)),d.push(new Cell(v.p.x+x,v.p.y+x,x,e)),c+=4)}return n&&(console.log("num probes: "+c),console.log("best distance: "+m.d)),m.p};
	},{"./intersection_tests":120,"point-geometry":194,"tinyqueue":199}],118:[function(require,module,exports){
	"use strict";function Glyphs(a,e){this.stacks=a.readFields(readFontstacks,[],e)}function readFontstacks(a,e,r){if(1===a){var t=r.readMessage(readFontstack,{glyphs:{}});e.push(t)}}function readFontstack(a,e,r){if(1===a)e.name=r.readString();else if(2===a)e.range=r.readString();else if(3===a){var t=r.readMessage(readGlyph,{});e.glyphs[t.id]=t}}function readGlyph(a,e,r){1===a?e.id=r.readVarint():2===a?e.bitmap=r.readBytes():3===a?e.width=r.readVarint():4===a?e.height=r.readVarint():5===a?e.left=r.readSVarint():6===a?e.top=r.readSVarint():7===a&&(e.advance=r.readVarint())}module.exports=Glyphs;
	},{}],119:[function(require,module,exports){
	"use strict";function interpolate(t,e,n){return t*(1-n)+e*n}module.exports=interpolate,interpolate.number=interpolate,interpolate.vec2=function(t,e,n){return[interpolate(t[0],e[0],n),interpolate(t[1],e[1],n)]},interpolate.color=function(t,e,n){return[interpolate(t[0],e[0],n),interpolate(t[1],e[1],n),interpolate(t[2],e[2],n),interpolate(t[3],e[3],n)]},interpolate.array=function(t,e,n){return t.map(function(t,r){return interpolate(t,e[r],n)})};
	},{}],120:[function(require,module,exports){
	"use strict";function polygonIntersectsPolygon(n,t){for(var e=0;e<n.length;e++)if(polygonContainsPoint(t,n[e]))return!0;for(var r=0;r<t.length;r++)if(polygonContainsPoint(n,t[r]))return!0;return!!lineIntersectsLine(n,t)}function multiPolygonIntersectsBufferedMultiPoint(n,t,e){for(var r=0;r<n.length;r++)for(var o=n[r],i=0;i<t.length;i++)for(var l=t[i],u=0;u<l.length;u++){var s=l[u];if(polygonContainsPoint(o,s))return!0;if(pointIntersectsBufferedLine(s,o,e))return!0}return!1}function multiPolygonIntersectsMultiPolygon(n,t){if(1===n.length&&1===n[0].length)return multiPolygonContainsPoint(t,n[0][0]);for(var e=0;e<t.length;e++)for(var r=t[e],o=0;o<r.length;o++)if(multiPolygonContainsPoint(n,r[o]))return!0;for(var i=0;i<n.length;i++){for(var l=n[i],u=0;u<l.length;u++)if(multiPolygonContainsPoint(t,l[u]))return!0;for(var s=0;s<t.length;s++)if(lineIntersectsLine(l,t[s]))return!0}return!1}function multiPolygonIntersectsBufferedMultiLine(n,t,e){for(var r=0;r<t.length;r++)for(var o=t[r],i=0;i<n.length;i++){var l=n[i];if(l.length>=3)for(var u=0;u<o.length;u++)if(polygonContainsPoint(l,o[u]))return!0;if(lineIntersectsBufferedLine(l,o,e))return!0}return!1}function lineIntersectsBufferedLine(n,t,e){if(n.length>1){if(lineIntersectsLine(n,t))return!0;for(var r=0;r<t.length;r++)if(pointIntersectsBufferedLine(t[r],n,e))return!0}for(var o=0;o<n.length;o++)if(pointIntersectsBufferedLine(n[o],t,e))return!0;return!1}function lineIntersectsLine(n,t){if(0===n.length||0===t.length)return!1;for(var e=0;e<n.length-1;e++)for(var r=n[e],o=n[e+1],i=0;i<t.length-1;i++){var l=t[i],u=t[i+1];if(lineSegmentIntersectsLineSegment(r,o,l,u))return!0}return!1}function lineSegmentIntersectsLineSegment(n,t,e,r){return isCounterClockwise(n,e,r)!==isCounterClockwise(t,e,r)&&isCounterClockwise(n,t,e)!==isCounterClockwise(n,t,r)}function pointIntersectsBufferedLine(n,t,e){var r=e*e;if(1===t.length)return n.distSqr(t[0])<r;for(var o=1;o<t.length;o++){var i=t[o-1],l=t[o];if(distToSegmentSquared(n,i,l)<r)return!0}return!1}function distToSegmentSquared(n,t,e){var r=t.distSqr(e);if(0===r)return n.distSqr(t);var o=((n.x-t.x)*(e.x-t.x)+(n.y-t.y)*(e.y-t.y))/r;return o<0?n.distSqr(t):o>1?n.distSqr(e):n.distSqr(e.sub(t)._mult(o)._add(t))}function multiPolygonContainsPoint(n,t){for(var e,r,o,i=!1,l=0;l<n.length;l++){e=n[l];for(var u=0,s=e.length-1;u<e.length;s=u++)r=e[u],o=e[s],r.y>t.y!=o.y>t.y&&t.x<(o.x-r.x)*(t.y-r.y)/(o.y-r.y)+r.x&&(i=!i)}return i}function polygonContainsPoint(n,t){for(var e=!1,r=0,o=n.length-1;r<n.length;o=r++){var i=n[r],l=n[o];i.y>t.y!=l.y>t.y&&t.x<(l.x-i.x)*(t.y-i.y)/(l.y-i.y)+i.x&&(e=!e)}return e}var isCounterClockwise=require("./util").isCounterClockwise;module.exports={multiPolygonIntersectsBufferedMultiPoint:multiPolygonIntersectsBufferedMultiPoint,multiPolygonIntersectsMultiPolygon:multiPolygonIntersectsMultiPolygon,multiPolygonIntersectsBufferedMultiLine:multiPolygonIntersectsBufferedMultiLine,polygonIntersectsPolygon:polygonIntersectsPolygon,distToSegmentSquared:distToSegmentSquared};
	},{"./util":127}],121:[function(require,module,exports){
	"use strict";var unicodeBlockLookup={"Latin-1 Supplement":function(n){return n>=128&&n<=255},"Hangul Jamo":function(n){return n>=4352&&n<=4607},"Unified Canadian Aboriginal Syllabics":function(n){return n>=5120&&n<=5759},"Unified Canadian Aboriginal Syllabics Extended":function(n){return n>=6320&&n<=6399},"General Punctuation":function(n){return n>=8192&&n<=8303},"Letterlike Symbols":function(n){return n>=8448&&n<=8527},"Number Forms":function(n){return n>=8528&&n<=8591},"Miscellaneous Technical":function(n){return n>=8960&&n<=9215},"Control Pictures":function(n){return n>=9216&&n<=9279},"Optical Character Recognition":function(n){return n>=9280&&n<=9311},"Enclosed Alphanumerics":function(n){return n>=9312&&n<=9471},"Geometric Shapes":function(n){return n>=9632&&n<=9727},"Miscellaneous Symbols":function(n){return n>=9728&&n<=9983},"Miscellaneous Symbols and Arrows":function(n){return n>=11008&&n<=11263},"CJK Radicals Supplement":function(n){return n>=11904&&n<=12031},"Kangxi Radicals":function(n){return n>=12032&&n<=12255},"Ideographic Description Characters":function(n){return n>=12272&&n<=12287},"CJK Symbols and Punctuation":function(n){return n>=12288&&n<=12351},Hiragana:function(n){return n>=12352&&n<=12447},Katakana:function(n){return n>=12448&&n<=12543},Bopomofo:function(n){return n>=12544&&n<=12591},"Hangul Compatibility Jamo":function(n){return n>=12592&&n<=12687},Kanbun:function(n){return n>=12688&&n<=12703},"Bopomofo Extended":function(n){return n>=12704&&n<=12735},"CJK Strokes":function(n){return n>=12736&&n<=12783},"Katakana Phonetic Extensions":function(n){return n>=12784&&n<=12799},"Enclosed CJK Letters and Months":function(n){return n>=12800&&n<=13055},"CJK Compatibility":function(n){return n>=13056&&n<=13311},"CJK Unified Ideographs Extension A":function(n){return n>=13312&&n<=19903},"Yijing Hexagram Symbols":function(n){return n>=19904&&n<=19967},"CJK Unified Ideographs":function(n){return n>=19968&&n<=40959},"Yi Syllables":function(n){return n>=40960&&n<=42127},"Yi Radicals":function(n){return n>=42128&&n<=42191},"Hangul Jamo Extended-A":function(n){return n>=43360&&n<=43391},"Hangul Syllables":function(n){return n>=44032&&n<=55215},"Hangul Jamo Extended-B":function(n){return n>=55216&&n<=55295},"Private Use Area":function(n){return n>=57344&&n<=63743},"CJK Compatibility Ideographs":function(n){return n>=63744&&n<=64255},"Vertical Forms":function(n){return n>=65040&&n<=65055},"CJK Compatibility Forms":function(n){return n>=65072&&n<=65103},"Small Form Variants":function(n){return n>=65104&&n<=65135},"Halfwidth and Fullwidth Forms":function(n){return n>=65280&&n<=65519}};module.exports=unicodeBlockLookup;
	},{}],122:[function(require,module,exports){
	"use strict";var LRUCache=function(t,e){this.max=t,this.onRemove=e,this.reset()};LRUCache.prototype.reset=function(){var t=this;for(var e in this.data)t.onRemove(t.data[e]);return this.data={},this.order=[],this},LRUCache.prototype.add=function(t,e){if(this.has(t))this.order.splice(this.order.indexOf(t),1),this.data[t]=e,this.order.push(t);else if(this.data[t]=e,this.order.push(t),this.order.length>this.max){var r=this.get(this.order[0]);r&&this.onRemove(r)}return this},LRUCache.prototype.has=function(t){return t in this.data},LRUCache.prototype.keys=function(){return this.order},LRUCache.prototype.get=function(t){if(!this.has(t))return null;var e=this.data[t];return delete this.data[t],this.order.splice(this.order.indexOf(t),1),e},LRUCache.prototype.setMaxSize=function(t){var e=this;for(this.max=t;this.order.length>this.max;){var r=e.get(e.order[0]);r&&e.onRemove(r)}return this},module.exports=LRUCache;
	},{}],123:[function(require,module,exports){
	"use strict";function makeAPIURL(r,e){var t=parseUrl(config.API_URL);if(r.protocol=t.protocol,r.authority=t.authority,!config.REQUIRE_ACCESS_TOKEN)return formatUrl(r);if(e=e||config.ACCESS_TOKEN,!e)throw new Error("An API access token is required to use Mapbox GL. "+help);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+help);return r.params.push("access_token="+e),formatUrl(r)}function isMapboxURL(r){return 0===r.indexOf("mapbox:")}function replaceTempAccessToken(r){for(var e=0;e<r.length;e++)0===r[e].indexOf("access_token=tk.")&&(r[e]="access_token="+(config.ACCESS_TOKEN||""))}function parseUrl(r){var e=r.match(urlRe);if(!e)throw new Error("Unable to parse URL object");return{protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function formatUrl(r){var e=r.params.length?"?"+r.params.join("&"):"";return r.protocol+"://"+r.authority+r.path+e}var config=require("./config"),browser=require("./browser"),help="See https://www.mapbox.com/developers/api/#access-tokens";exports.isMapboxURL=isMapboxURL,exports.normalizeStyleURL=function(r,e){if(!isMapboxURL(r))return r;var t=parseUrl(r);return t.path="/styles/v1"+t.path,makeAPIURL(t,e)},exports.normalizeGlyphsURL=function(r,e){if(!isMapboxURL(r))return r;var t=parseUrl(r);return t.path="/fonts/v1"+t.path,makeAPIURL(t,e)},exports.normalizeSourceURL=function(r,e){if(!isMapboxURL(r))return r;var t=parseUrl(r);return t.path="/v4/"+t.authority+".json",t.params.push("secure"),makeAPIURL(t,e)},exports.normalizeSpriteURL=function(r,e,t,o){var a=parseUrl(r);return isMapboxURL(r)?(a.path="/styles/v1"+a.path+"/sprite"+e+t,makeAPIURL(a,o)):(a.path+=""+e+t,formatUrl(a))};var imageExtensionRe=/(\.(png|jpg)\d*)(?=$)/;exports.normalizeTileURL=function(r,e,t){if(!e||!isMapboxURL(e))return r;var o=parseUrl(r),a=browser.devicePixelRatio>=2||512===t?"@2x":"",s=browser.supportsWebp?".webp":"$1";return o.path=o.path.replace(imageExtensionRe,""+a+s),replaceTempAccessToken(o.params),formatUrl(o)};var urlRe=/^(\w+):\/\/([^\/?]+)(\/[^?]+)?\??(.+)?/;
	},{"./browser":108,"./config":112}],124:[function(require,module,exports){
	"use strict";var isChar=require("./is_char_in_unicode_block");module.exports.allowsIdeographicBreaking=function(a){for(var i=0,r=a;i<r.length;i+=1){var s=r[i];if(!exports.charAllowsIdeographicBreaking(s.charCodeAt(0)))return!1}return!0},module.exports.allowsVerticalWritingMode=function(a){for(var i=0,r=a;i<r.length;i+=1){var s=r[i];if(exports.charHasUprightVerticalOrientation(s.charCodeAt(0)))return!0}return!1},module.exports.charAllowsIdeographicBreaking=function(a){return!(a<11904)&&(!!isChar["Bopomofo Extended"](a)||(!!isChar.Bopomofo(a)||(!!isChar["CJK Compatibility Forms"](a)||(!!isChar["CJK Compatibility Ideographs"](a)||(!!isChar["CJK Compatibility"](a)||(!!isChar["CJK Radicals Supplement"](a)||(!!isChar["CJK Strokes"](a)||(!!isChar["CJK Symbols and Punctuation"](a)||(!!isChar["CJK Unified Ideographs Extension A"](a)||(!!isChar["CJK Unified Ideographs"](a)||(!!isChar["Enclosed CJK Letters and Months"](a)||(!!isChar["Halfwidth and Fullwidth Forms"](a)||(!!isChar.Hiragana(a)||(!!isChar["Ideographic Description Characters"](a)||(!!isChar["Kangxi Radicals"](a)||(!!isChar["Katakana Phonetic Extensions"](a)||(!!isChar.Katakana(a)||(!!isChar["Vertical Forms"](a)||(!!isChar["Yi Radicals"](a)||!!isChar["Yi Syllables"](a))))))))))))))))))))},exports.charHasUprightVerticalOrientation=function(a){return 746===a||747===a||!(a<4352)&&(!!isChar["Bopomofo Extended"](a)||(!!isChar.Bopomofo(a)||(!(!isChar["CJK Compatibility Forms"](a)||a>=65097&&a<=65103)||(!!isChar["CJK Compatibility Ideographs"](a)||(!!isChar["CJK Compatibility"](a)||(!!isChar["CJK Radicals Supplement"](a)||(!!isChar["CJK Strokes"](a)||(!(!isChar["CJK Symbols and Punctuation"](a)||a>=12296&&a<=12305||a>=12308&&a<=12319||12336===a)||(!!isChar["CJK Unified Ideographs Extension A"](a)||(!!isChar["CJK Unified Ideographs"](a)||(!!isChar["Enclosed CJK Letters and Months"](a)||(!!isChar["Hangul Compatibility Jamo"](a)||(!!isChar["Hangul Jamo Extended-A"](a)||(!!isChar["Hangul Jamo Extended-B"](a)||(!!isChar["Hangul Jamo"](a)||(!!isChar["Hangul Syllables"](a)||(!!isChar.Hiragana(a)||(!!isChar["Ideographic Description Characters"](a)||(!!isChar.Kanbun(a)||(!!isChar["Kangxi Radicals"](a)||(!!isChar["Katakana Phonetic Extensions"](a)||(!(!isChar.Katakana(a)||12540===a)||(!(!isChar["Halfwidth and Fullwidth Forms"](a)||65288===a||65289===a||65293===a||a>=65306&&a<=65310||65339===a||65341===a||65343===a||a>=65371&&a<=65503||65507===a||a>=65512&&a<=65519)||(!(!isChar["Small Form Variants"](a)||a>=65112&&a<=65118||a>=65123&&a<=65126)||(!!isChar["Unified Canadian Aboriginal Syllabics"](a)||(!!isChar["Unified Canadian Aboriginal Syllabics Extended"](a)||(!!isChar["Vertical Forms"](a)||(!!isChar["Yijing Hexagram Symbols"](a)||(!!isChar["Yi Syllables"](a)||!!isChar["Yi Radicals"](a))))))))))))))))))))))))))))))},exports.charHasNeutralVerticalOrientation=function(a){return!(!isChar["Latin-1 Supplement"](a)||167!==a&&169!==a&&174!==a&&177!==a&&188!==a&&189!==a&&190!==a&&215!==a&&247!==a)||(!(!isChar["General Punctuation"](a)||8214!==a&&8224!==a&&8225!==a&&8240!==a&&8241!==a&&8251!==a&&8252!==a&&8258!==a&&8263!==a&&8264!==a&&8265!==a&&8273!==a)||(!!isChar["Letterlike Symbols"](a)||(!!isChar["Number Forms"](a)||(!(!isChar["Miscellaneous Technical"](a)||!(a>=8960&&a<=8967||a>=8972&&a<=8991||a>=8996&&a<=9e3||9003===a||a>=9085&&a<=9114||a>=9150&&a<=9165||9167===a||a>=9169&&a<=9179||a>=9186&&a<=9215))||(!(!isChar["Control Pictures"](a)||9251===a)||(!!isChar["Optical Character Recognition"](a)||(!!isChar["Enclosed Alphanumerics"](a)||(!!isChar["Geometric Shapes"](a)||(!(!isChar["Miscellaneous Symbols"](a)||a>=9754&&a<=9759)||(!(!isChar["Miscellaneous Symbols and Arrows"](a)||!(a>=11026&&a<=11055||a>=11088&&a<=11097||a>=11192&&a<=11243))||(!!isChar["CJK Symbols and Punctuation"](a)||(!!isChar.Katakana(a)||(!!isChar["Private Use Area"](a)||(!!isChar["CJK Compatibility Forms"](a)||(!!isChar["Small Form Variants"](a)||(!!isChar["Halfwidth and Fullwidth Forms"](a)||(8734===a||8756===a||8757===a||a>=9984&&a<=10087||a>=10102&&a<=10131||65532===a||65533===a)))))))))))))))))},exports.charHasRotatedVerticalOrientation=function(a){return!(exports.charHasUprightVerticalOrientation(a)||exports.charHasNeutralVerticalOrientation(a))};
	},{"./is_char_in_unicode_block":121}],125:[function(require,module,exports){
	"use strict";function createStructArrayType(t){var e=JSON.stringify(t);if(structArrayTypeCache[e])return structArrayTypeCache[e];var r=void 0===t.alignment?1:t.alignment,i=0,n=0,a=["Uint8"],o=t.members.map(function(t){a.indexOf(t.type)<0&&a.push(t.type);var e=sizeOf(t.type),o=i=align(i,Math.max(r,e)),s=t.components||1;return n=Math.max(n,e),i+=e*s,{name:t.name,type:t.type,components:s,offset:o}}),s=align(i,Math.max(n,r)),p=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Struct);p.prototype.alignment=r,p.prototype.size=s;for(var y=0,c=o;y<c.length;y+=1)for(var h=c[y],u=0;u<h.components;u++){var f=h.name+(1===h.components?"":u);Object.defineProperty(p.prototype,f,{get:createGetter(h,u),set:createSetter(h,u)})}var m=function(t){function e(){t.apply(this,arguments)}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(StructArray);return m.prototype.members=o,m.prototype.StructType=p,m.prototype.bytesPerElement=s,m.prototype.emplaceBack=createEmplaceBack(o,s),m.prototype._usedTypes=a,structArrayTypeCache[e]=m,m}function align(t,e){return Math.ceil(t/e)*e}function sizeOf(t){return viewTypes[t].BYTES_PER_ELEMENT}function getArrayViewName(t){return t.toLowerCase()}function createEmplaceBack(t,e){for(var r=[],i=[],n="var i = this.length;\nthis.resize(this.length + 1);\n",a=0,o=t;a<o.length;a+=1){var s=o[a],p=sizeOf(s.type);r.indexOf(p)<0&&(r.push(p),n+="var o"+p.toFixed(0)+" = i * "+(e/p).toFixed(0)+";\n");for(var y=0;y<s.components;y++){var c="v"+i.length,h="o"+p.toFixed(0)+" + "+(s.offset/p+y).toFixed(0);n+="this."+getArrayViewName(s.type)+"["+h+"] = "+c+";\n",i.push(c)}}return n+="return i;",new Function(i.toString(),n)}function createMemberComponentString(t,e){var r="this._pos"+sizeOf(t.type).toFixed(0),i=(t.offset/sizeOf(t.type)+e).toFixed(0),n=r+" + "+i;return"this._structArray."+getArrayViewName(t.type)+"["+n+"]"}function createGetter(t,e){return new Function("return "+createMemberComponentString(t,e)+";")}function createSetter(t,e){return new Function("x",createMemberComponentString(t,e)+" = x;")}module.exports=createStructArrayType;var viewTypes={Int8:Int8Array,Uint8:Uint8Array,Uint8Clamped:Uint8ClampedArray,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array,Float64:Float64Array},Struct=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8},DEFAULT_CAPACITY=128,RESIZE_MULTIPLIER=5,StructArray=function(t){this.isTransferred=!1,void 0!==t?(this.arrayBuffer=t.arrayBuffer,this.length=t.length,this.capacity=this.arrayBuffer.byteLength/this.bytesPerElement,this._refreshViews()):(this.capacity=-1,this.resize(0))};StructArray.serialize=function(){return{members:this.prototype.members,alignment:this.prototype.StructType.prototype.alignment,bytesPerElement:this.prototype.bytesPerElement}},StructArray.prototype.serialize=function(t){return this._trim(),t&&(this.isTransferred=!0,t.push(this.arrayBuffer)),{length:this.length,arrayBuffer:this.arrayBuffer}},StructArray.prototype.get=function(t){return new this.StructType(this,t)},StructArray.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews())},StructArray.prototype.resize=function(t){if(this.length=t,t>this.capacity){this.capacity=Math.max(t,Math.floor(this.capacity*RESIZE_MULTIPLIER),DEFAULT_CAPACITY),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var e=this.uint8;this._refreshViews(),e&&this.uint8.set(e)}},StructArray.prototype._refreshViews=function(){for(var t=this,e=0,r=this._usedTypes;e<r.length;e+=1){var i=r[e];t[getArrayViewName(i)]=new viewTypes[i](t.arrayBuffer)}},StructArray.prototype.toArray=function(t,e){for(var r=this,i=[],n=t;n<e;n++){var a=r.get(n);i.push(a)}return i};var structArrayTypeCache={};
	},{}],126:[function(require,module,exports){
	"use strict";function resolveTokens(e,n){return n.replace(/{([^{}]+)}/g,function(n,r){return r in e?e[r]:""})}module.exports=resolveTokens;
	},{}],127:[function(require,module,exports){
	"use strict";var UnitBezier=require("unitbezier"),Coordinate=require("../geo/coordinate"),Point=require("point-geometry");exports.easeCubicInOut=function(r){if(r<=0)return 0;if(r>=1)return 1;var e=r*r,n=e*r;return 4*(r<.5?n:3*(r-e)+n-.75)},exports.bezier=function(r,e,n,t){var o=new UnitBezier(r,e,n,t);return function(r){return o.solve(r)}},exports.ease=exports.bezier(.25,.1,.25,1),exports.clamp=function(r,e,n){return Math.min(n,Math.max(e,r))},exports.wrap=function(r,e,n){var t=n-e,o=((r-e)%t+t)%t+e;return o===e?n:o},exports.asyncAll=function(r,e,n){if(!r.length)return n(null,[]);var t=r.length,o=new Array(r.length),a=null;r.forEach(function(r,i){e(r,function(r,e){r&&(a=r),o[i]=e,0===--t&&n(a,o)})})},exports.values=function(r){var e=[];for(var n in r)e.push(r[n]);return e},exports.keysDifference=function(r,e){var n=[];for(var t in r)t in e||n.push(t);return n},exports.extend=function(r,e,n,t){for(var o=arguments,a=1;a<arguments.length;a++){var i=o[a];for(var u in i)r[u]=i[u]}return r},exports.pick=function(r,e){for(var n={},t=0;t<e.length;t++){var o=e[t];o in r&&(n[o]=r[o])}return n};var id=1;exports.uniqueId=function(){return id++},exports.bindAll=function(r,e){r.forEach(function(r){e[r]&&(e[r]=e[r].bind(e))})},exports.getCoordinatesCenter=function(r){for(var e=1/0,n=1/0,t=-(1/0),o=-(1/0),a=0;a<r.length;a++)e=Math.min(e,r[a].column),n=Math.min(n,r[a].row),t=Math.max(t,r[a].column),o=Math.max(o,r[a].row);var i=t-e,u=o-n,s=Math.max(i,u);return new Coordinate((e+t)/2,(n+o)/2,0).zoomTo(Math.floor(-Math.log(s)/Math.LN2))},exports.endsWith=function(r,e){return r.indexOf(e,r.length-e.length)!==-1},exports.mapObject=function(r,e,n){var t=this,o={};for(var a in r)o[a]=e.call(n||t,r[a],a,r);return o},exports.filterObject=function(r,e,n){var t=this,o={};for(var a in r)e.call(n||t,r[a],a,r)&&(o[a]=r[a]);return o},exports.deepEqual=function(r,e){if(Array.isArray(r)){if(!Array.isArray(e)||r.length!==e.length)return!1;for(var n=0;n<r.length;n++)if(!exports.deepEqual(r[n],e[n]))return!1;return!0}if("object"==typeof r&&null!==r&&null!==e){if("object"!=typeof e)return!1;var t=Object.keys(r);if(t.length!==Object.keys(e).length)return!1;for(var o in r)if(!exports.deepEqual(r[o],e[o]))return!1;return!0}return r===e},exports.clone=function(r){return Array.isArray(r)?r.map(exports.clone):"object"==typeof r&&r?exports.mapObject(r,exports.clone):r},exports.arraysIntersect=function(r,e){for(var n=0;n<r.length;n++)if(e.indexOf(r[n])>=0)return!0;return!1};var warnOnceHistory={};exports.warnOnce=function(r){warnOnceHistory[r]||("undefined"!=typeof console&&console.warn(r),warnOnceHistory[r]=!0)},exports.isCounterClockwise=function(r,e,n){return(n.y-r.y)*(e.x-r.x)>(e.y-r.y)*(n.x-r.x)},exports.calculateSignedArea=function(r){for(var e,n,t=0,o=0,a=r.length,i=a-1;o<a;i=o++)e=r[o],n=r[i],t+=(n.x-e.x)*(e.y+n.y);return t},exports.isClosedPolygon=function(r){if(r.length<4)return!1;var e=r[0],n=r[r.length-1];return!(Math.abs(e.x-n.x)>0||Math.abs(e.y-n.y)>0)&&Math.abs(exports.calculateSignedArea(r))>.01},exports.sphericalToCartesian=function(r){var e=r[0],n=r[1],t=r[2];return n+=90,n*=Math.PI/180,t*=Math.PI/180,[e*Math.cos(n)*Math.sin(t),e*Math.sin(n)*Math.sin(t),e*Math.cos(t)]};
	},{"../geo/coordinate":18,"point-geometry":194,"unitbezier":200}],128:[function(require,module,exports){
	"use strict";var Feature=function(e,t,r,o){this.type="Feature",this._vectorTileFeature=e,e._z=t,e._x=r,e._y=o,this.properties=e.properties,null!=e.id&&(this.id=e.id)},prototypeAccessors={geometry:{}};prototypeAccessors.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},prototypeAccessors.geometry.set=function(e){this._geometry=e},Feature.prototype.toJSON=function(){var e=this,t={geometry:this.geometry};for(var r in this)"_geometry"!==r&&"_vectorTileFeature"!==r&&(t[r]=e[r]);return t},Object.defineProperties(Feature.prototype,prototypeAccessors),module.exports=Feature;
	},{}],129:[function(require,module,exports){
	"use strict";var scriptDetection=require("./script_detection");module.exports=function(t){for(var o="",e=0;e<t.length;e++){var r=t.charCodeAt(e+1)||null,l=t.charCodeAt(e-1)||null,i=(!r||!scriptDetection.charHasRotatedVerticalOrientation(r)||module.exports.lookup[t[e+1]])&&(!l||!scriptDetection.charHasRotatedVerticalOrientation(l)||module.exports.lookup[t[e-1]]);o+=i&&module.exports.lookup[t[e]]?module.exports.lookup[t[e]]:t[e]}return o},module.exports.lookup={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};
	},{"./script_detection":124}],130:[function(require,module,exports){
	"use strict";var WebWorker=require("./web_worker"),WorkerPool=function(){this.active={}};WorkerPool.prototype.acquire=function(r){var e=this;if(!this.workers){var o=require("../mapbox-gl").workerCount;for(this.workers=[];this.workers.length<o;)e.workers.push(new WebWorker)}return this.active[r]=!0,this.workers.slice()},WorkerPool.prototype.release=function(r){delete this.active[r],0===Object.keys(this.active).length&&(this.workers.forEach(function(r){r.terminate()}),this.workers=null)},module.exports=WorkerPool;
	},{"../mapbox-gl":24,"./web_worker":109}],131:[function(require,module,exports){
	!function(t,r){"object"==typeof exports&&"undefined"!=typeof module?module.exports=r():"function"==typeof define&&define.amd?define(r):t.glMatrix=r()}(this,function(){"use strict";function t(){var t=new Float32Array(3);return t[0]=0,t[1]=0,t[2]=0,t}function r(t,r,n){var e=r[0],a=r[1],o=r[2];return t[0]=e*n[0]+a*n[3]+o*n[6],t[1]=e*n[1]+a*n[4]+o*n[7],t[2]=e*n[2]+a*n[5]+o*n[8],t}function n(){var t=new Float32Array(4);return t[0]=0,t[1]=0,t[2]=0,t[3]=0,t}function e(t,r,n){var e=r[0],a=r[1],o=r[2],u=r[3];return t[0]=n[0]*e+n[4]*a+n[8]*o+n[12]*u,t[1]=n[1]*e+n[5]*a+n[9]*o+n[13]*u,t[2]=n[2]*e+n[6]*a+n[10]*o+n[14]*u,t[3]=n[3]*e+n[7]*a+n[11]*o+n[15]*u,t}function a(){var t=new Float32Array(4);return t[0]=1,t[1]=0,t[2]=0,t[3]=1,t}function o(t,r,n){var e=r[0],a=r[1],o=r[2],u=r[3],i=Math.sin(n),c=Math.cos(n);return t[0]=e*c+o*i,t[1]=a*c+u*i,t[2]=e*-i+o*c,t[3]=a*-i+u*c,t}function u(t,r,n){var e=r[0],a=r[1],o=r[2],u=r[3],i=n[0],c=n[1];return t[0]=e*i,t[1]=a*i,t[2]=o*c,t[3]=u*c,t}function i(){var t=new Float32Array(9);return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=1,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t}function c(t,r){var n=Math.sin(r),e=Math.cos(r);return t[0]=e,t[1]=n,t[2]=0,t[3]=-n,t[4]=e,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t}function f(){var t=new Float32Array(16);return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function v(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function s(t,r){var n=r[0],e=r[1],a=r[2],o=r[3],u=r[4],i=r[5],c=r[6],f=r[7],v=r[8],s=r[9],l=r[10],M=r[11],h=r[12],m=r[13],y=r[14],d=r[15],p=n*i-e*u,w=n*c-a*u,A=n*f-o*u,F=e*c-a*i,x=e*f-o*i,b=a*f-o*c,g=v*m-s*h,j=v*y-l*h,R=v*d-M*h,X=s*y-l*m,Z=s*d-M*m,k=l*d-M*y,q=p*k-w*Z+A*X+F*R-x*j+b*g;return q?(q=1/q,t[0]=(i*k-c*Z+f*X)*q,t[1]=(a*Z-e*k-o*X)*q,t[2]=(m*b-y*x+d*F)*q,t[3]=(l*x-s*b-M*F)*q,t[4]=(c*R-u*k-f*j)*q,t[5]=(n*k-a*R+o*j)*q,t[6]=(y*A-h*b-d*w)*q,t[7]=(v*b-l*A+M*w)*q,t[8]=(u*Z-i*R+f*g)*q,t[9]=(e*R-n*Z-o*g)*q,t[10]=(h*x-m*A+d*p)*q,t[11]=(s*A-v*x-M*p)*q,t[12]=(i*j-u*X-c*g)*q,t[13]=(n*X-e*j+a*g)*q,t[14]=(m*w-h*F-y*p)*q,t[15]=(v*F-s*w+l*p)*q,t):null}function l(t,r,n){var e=r[0],a=r[1],o=r[2],u=r[3],i=r[4],c=r[5],f=r[6],v=r[7],s=r[8],l=r[9],M=r[10],h=r[11],m=r[12],y=r[13],d=r[14],p=r[15],w=n[0],A=n[1],F=n[2],x=n[3];return t[0]=w*e+A*i+F*s+x*m,t[1]=w*a+A*c+F*l+x*y,t[2]=w*o+A*f+F*M+x*d,t[3]=w*u+A*v+F*h+x*p,w=n[4],A=n[5],F=n[6],x=n[7],t[4]=w*e+A*i+F*s+x*m,t[5]=w*a+A*c+F*l+x*y,t[6]=w*o+A*f+F*M+x*d,t[7]=w*u+A*v+F*h+x*p,w=n[8],A=n[9],F=n[10],x=n[11],t[8]=w*e+A*i+F*s+x*m,t[9]=w*a+A*c+F*l+x*y,t[10]=w*o+A*f+F*M+x*d,t[11]=w*u+A*v+F*h+x*p,w=n[12],A=n[13],F=n[14],x=n[15],t[12]=w*e+A*i+F*s+x*m,t[13]=w*a+A*c+F*l+x*y,t[14]=w*o+A*f+F*M+x*d,t[15]=w*u+A*v+F*h+x*p,t}function M(t,r,n){var e,a,o,u,i,c,f,v,s,l,M,h,m=n[0],y=n[1],d=n[2];return r===t?(t[12]=r[0]*m+r[4]*y+r[8]*d+r[12],t[13]=r[1]*m+r[5]*y+r[9]*d+r[13],t[14]=r[2]*m+r[6]*y+r[10]*d+r[14],t[15]=r[3]*m+r[7]*y+r[11]*d+r[15]):(e=r[0],a=r[1],o=r[2],u=r[3],i=r[4],c=r[5],f=r[6],v=r[7],s=r[8],l=r[9],M=r[10],h=r[11],t[0]=e,t[1]=a,t[2]=o,t[3]=u,t[4]=i,t[5]=c,t[6]=f,t[7]=v,t[8]=s,t[9]=l,t[10]=M,t[11]=h,t[12]=e*m+i*y+s*d+r[12],t[13]=a*m+c*y+l*d+r[13],t[14]=o*m+f*y+M*d+r[14],t[15]=u*m+v*y+h*d+r[15]),t}function h(t,r,n){var e=n[0],a=n[1],o=n[2];return t[0]=r[0]*e,t[1]=r[1]*e,t[2]=r[2]*e,t[3]=r[3]*e,t[4]=r[4]*a,t[5]=r[5]*a,t[6]=r[6]*a,t[7]=r[7]*a,t[8]=r[8]*o,t[9]=r[9]*o,t[10]=r[10]*o,t[11]=r[11]*o,t[12]=r[12],t[13]=r[13],t[14]=r[14],t[15]=r[15],t}function m(t,r,n){var e=Math.sin(n),a=Math.cos(n),o=r[4],u=r[5],i=r[6],c=r[7],f=r[8],v=r[9],s=r[10],l=r[11];return r!==t&&(t[0]=r[0],t[1]=r[1],t[2]=r[2],t[3]=r[3],t[12]=r[12],t[13]=r[13],t[14]=r[14],t[15]=r[15]),t[4]=o*a+f*e,t[5]=u*a+v*e,t[6]=i*a+s*e,t[7]=c*a+l*e,t[8]=f*a-o*e,t[9]=v*a-u*e,t[10]=s*a-i*e,t[11]=l*a-c*e,t}function y(t,r,n){var e=Math.sin(n),a=Math.cos(n),o=r[0],u=r[1],i=r[2],c=r[3],f=r[4],v=r[5],s=r[6],l=r[7];return r!==t&&(t[8]=r[8],t[9]=r[9],t[10]=r[10],t[11]=r[11],t[12]=r[12],t[13]=r[13],t[14]=r[14],t[15]=r[15]),t[0]=o*a+f*e,t[1]=u*a+v*e,t[2]=i*a+s*e,t[3]=c*a+l*e,t[4]=f*a-o*e,t[5]=v*a-u*e,t[6]=s*a-i*e,t[7]=l*a-c*e,t}function d(t,r,n,e,a){var o=1/Math.tan(r/2),u=1/(e-a);return t[0]=o/n,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=o,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=(a+e)*u,t[11]=-1,t[12]=0,t[13]=0,t[14]=2*a*e*u,t[15]=0,t}function p(t,r,n,e,a,o,u){var i=1/(r-n),c=1/(e-a),f=1/(o-u);return t[0]=-2*i,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*c,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*f,t[11]=0,t[12]=(r+n)*i,t[13]=(a+e)*c,t[14]=(u+o)*f,t[15]=1,t}var w=(t(),n(),{vec3:{transformMat3:r},vec4:{transformMat4:e},mat2:{create:a,rotate:o,scale:u},mat3:{create:i,fromRotation:c},mat4:{create:f,identity:v,translate:M,scale:h,multiply:l,perspective:d,rotateX:m,rotateZ:y,invert:s,ortho:p}});return w});
	},{}],132:[function(require,module,exports){
	function clamp_css_byte(e){return e=Math.round(e),e<0?0:e>255?255:e}function clamp_css_float(e){return e<0?0:e>1?1:e}function parse_css_int(e){return clamp_css_byte("%"===e[e.length-1]?parseFloat(e)/100*255:parseInt(e))}function parse_css_float(e){return clamp_css_float("%"===e[e.length-1]?parseFloat(e)/100:parseFloat(e))}function css_hue_to_rgb(e,r,l){return l<0?l+=1:l>1&&(l-=1),6*l<1?e+(r-e)*l*6:2*l<1?r:3*l<2?e+(r-e)*(2/3-l)*6:e}function parseCSSColor(e){var r=e.replace(/ /g,"").toLowerCase();if(r in kCSSColorTable)return kCSSColorTable[r].slice();if("#"===r[0]){if(4===r.length){var l=parseInt(r.substr(1),16);return l>=0&&l<=4095?[(3840&l)>>4|(3840&l)>>8,240&l|(240&l)>>4,15&l|(15&l)<<4,1]:null}if(7===r.length){var l=parseInt(r.substr(1),16);return l>=0&&l<=16777215?[(16711680&l)>>16,(65280&l)>>8,255&l,1]:null}return null}var a=r.indexOf("("),t=r.indexOf(")");if(a!==-1&&t+1===r.length){var n=r.substr(0,a),s=r.substr(a+1,t-(a+1)).split(","),o=1;switch(n){case"rgba":if(4!==s.length)return null;o=parse_css_float(s.pop());case"rgb":return 3!==s.length?null:[parse_css_int(s[0]),parse_css_int(s[1]),parse_css_int(s[2]),o];case"hsla":if(4!==s.length)return null;o=parse_css_float(s.pop());case"hsl":if(3!==s.length)return null;var i=(parseFloat(s[0])%360+360)%360/360,u=parse_css_float(s[1]),g=parse_css_float(s[2]),d=g<=.5?g*(u+1):g+u-g*u,c=2*g-d;return[clamp_css_byte(255*css_hue_to_rgb(c,d,i+1/3)),clamp_css_byte(255*css_hue_to_rgb(c,d,i)),clamp_css_byte(255*css_hue_to_rgb(c,d,i-1/3)),o];default:return null}}return null}var kCSSColorTable={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};try{exports.parseCSSColor=parseCSSColor}catch(e){}
	},{}],133:[function(require,module,exports){
	"use strict";function earcut(e,n,r){r=r||2;var t=n&&n.length,i=t?n[0]*r:e.length,x=linkedList(e,0,i,r,!0),a=[];if(!x)return a;var o,l,u,s,v,f,y;if(t&&(x=eliminateHoles(e,n,x,r)),e.length>80*r){o=u=e[0],l=s=e[1];for(var d=r;d<i;d+=r)v=e[d],f=e[d+1],v<o&&(o=v),f<l&&(l=f),v>u&&(u=v),f>s&&(s=f);y=Math.max(u-o,s-l)}return earcutLinked(x,a,r,o,l,y),a}function linkedList(e,n,r,t,i){var x,a;if(i===signedArea(e,n,r,t)>0)for(x=n;x<r;x+=t)a=insertNode(x,e[x],e[x+1],a);else for(x=r-t;x>=n;x-=t)a=insertNode(x,e[x],e[x+1],a);return a&&equals(a,a.next)&&(removeNode(a),a=a.next),a}function filterPoints(e,n){if(!e)return e;n||(n=e);var r,t=e;do if(r=!1,t.steiner||!equals(t,t.next)&&0!==area(t.prev,t,t.next))t=t.next;else{if(removeNode(t),t=n=t.prev,t===t.next)return null;r=!0}while(r||t!==n);return n}function earcutLinked(e,n,r,t,i,x,a){if(e){!a&&x&&indexCurve(e,t,i,x);for(var o,l,u=e;e.prev!==e.next;)if(o=e.prev,l=e.next,x?isEarHashed(e,t,i,x):isEar(e))n.push(o.i/r),n.push(e.i/r),n.push(l.i/r),removeNode(e),e=l.next,u=l.next;else if(e=l,e===u){a?1===a?(e=cureLocalIntersections(e,n,r),earcutLinked(e,n,r,t,i,x,2)):2===a&&splitEarcut(e,n,r,t,i,x):earcutLinked(filterPoints(e),n,r,t,i,x,1);break}}}function isEar(e){var n=e.prev,r=e,t=e.next;if(area(n,r,t)>=0)return!1;for(var i=e.next.next;i!==e.prev;){if(pointInTriangle(n.x,n.y,r.x,r.y,t.x,t.y,i.x,i.y)&&area(i.prev,i,i.next)>=0)return!1;i=i.next}return!0}function isEarHashed(e,n,r,t){var i=e.prev,x=e,a=e.next;if(area(i,x,a)>=0)return!1;for(var o=i.x<x.x?i.x<a.x?i.x:a.x:x.x<a.x?x.x:a.x,l=i.y<x.y?i.y<a.y?i.y:a.y:x.y<a.y?x.y:a.y,u=i.x>x.x?i.x>a.x?i.x:a.x:x.x>a.x?x.x:a.x,s=i.y>x.y?i.y>a.y?i.y:a.y:x.y>a.y?x.y:a.y,v=zOrder(o,l,n,r,t),f=zOrder(u,s,n,r,t),y=e.nextZ;y&&y.z<=f;){if(y!==e.prev&&y!==e.next&&pointInTriangle(i.x,i.y,x.x,x.y,a.x,a.y,y.x,y.y)&&area(y.prev,y,y.next)>=0)return!1;y=y.nextZ}for(y=e.prevZ;y&&y.z>=v;){if(y!==e.prev&&y!==e.next&&pointInTriangle(i.x,i.y,x.x,x.y,a.x,a.y,y.x,y.y)&&area(y.prev,y,y.next)>=0)return!1;y=y.prevZ}return!0}function cureLocalIntersections(e,n,r){var t=e;do{var i=t.prev,x=t.next.next;!equals(i,x)&&intersects(i,t,t.next,x)&&locallyInside(i,x)&&locallyInside(x,i)&&(n.push(i.i/r),n.push(t.i/r),n.push(x.i/r),removeNode(t),removeNode(t.next),t=e=x),t=t.next}while(t!==e);return t}function splitEarcut(e,n,r,t,i,x){var a=e;do{for(var o=a.next.next;o!==a.prev;){if(a.i!==o.i&&isValidDiagonal(a,o)){var l=splitPolygon(a,o);return a=filterPoints(a,a.next),l=filterPoints(l,l.next),earcutLinked(a,n,r,t,i,x),void earcutLinked(l,n,r,t,i,x)}o=o.next}a=a.next}while(a!==e)}function eliminateHoles(e,n,r,t){var i,x,a,o,l,u=[];for(i=0,x=n.length;i<x;i++)a=n[i]*t,o=i<x-1?n[i+1]*t:e.length,l=linkedList(e,a,o,t,!1),l===l.next&&(l.steiner=!0),u.push(getLeftmost(l));for(u.sort(compareX),i=0;i<u.length;i++)eliminateHole(u[i],r),r=filterPoints(r,r.next);return r}function compareX(e,n){return e.x-n.x}function eliminateHole(e,n){if(n=findHoleBridge(e,n)){var r=splitPolygon(n,e);filterPoints(r,r.next)}}function findHoleBridge(e,n){var r,t=n,i=e.x,x=e.y,a=-(1/0);do{if(x<=t.y&&x>=t.next.y){var o=t.x+(x-t.y)*(t.next.x-t.x)/(t.next.y-t.y);if(o<=i&&o>a){if(a=o,o===i){if(x===t.y)return t;if(x===t.next.y)return t.next}r=t.x<t.next.x?t:t.next}}t=t.next}while(t!==n);if(!r)return null;if(i===a)return r.prev;var l,u=r,s=r.x,v=r.y,f=1/0;for(t=r.next;t!==u;)i>=t.x&&t.x>=s&&pointInTriangle(x<v?i:a,x,s,v,x<v?a:i,x,t.x,t.y)&&(l=Math.abs(x-t.y)/(i-t.x),(l<f||l===f&&t.x>r.x)&&locallyInside(t,e)&&(r=t,f=l)),t=t.next;return r}function indexCurve(e,n,r,t){var i=e;do null===i.z&&(i.z=zOrder(i.x,i.y,n,r,t)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;while(i!==e);i.prevZ.nextZ=null,i.prevZ=null,sortLinked(i)}function sortLinked(e){var n,r,t,i,x,a,o,l,u=1;do{for(r=e,e=null,x=null,a=0;r;){for(a++,t=r,o=0,n=0;n<u&&(o++,t=t.nextZ,t);n++);for(l=u;o>0||l>0&&t;)0===o?(i=t,t=t.nextZ,l--):0!==l&&t?r.z<=t.z?(i=r,r=r.nextZ,o--):(i=t,t=t.nextZ,l--):(i=r,r=r.nextZ,o--),x?x.nextZ=i:e=i,i.prevZ=x,x=i;r=t}x.nextZ=null,u*=2}while(a>1);return e}function zOrder(e,n,r,t,i){return e=32767*(e-r)/i,n=32767*(n-t)/i,e=16711935&(e|e<<8),e=252645135&(e|e<<4),e=858993459&(e|e<<2),e=1431655765&(e|e<<1),n=16711935&(n|n<<8),n=252645135&(n|n<<4),n=858993459&(n|n<<2),n=1431655765&(n|n<<1),e|n<<1}function getLeftmost(e){var n=e,r=e;do n.x<r.x&&(r=n),n=n.next;while(n!==e);return r}function pointInTriangle(e,n,r,t,i,x,a,o){return(i-a)*(n-o)-(e-a)*(x-o)>=0&&(e-a)*(t-o)-(r-a)*(n-o)>=0&&(r-a)*(x-o)-(i-a)*(t-o)>=0}function isValidDiagonal(e,n){return e.next.i!==n.i&&e.prev.i!==n.i&&!intersectsPolygon(e,n)&&locallyInside(e,n)&&locallyInside(n,e)&&middleInside(e,n)}function area(e,n,r){return(n.y-e.y)*(r.x-n.x)-(n.x-e.x)*(r.y-n.y)}function equals(e,n){return e.x===n.x&&e.y===n.y}function intersects(e,n,r,t){return!!(equals(e,n)&&equals(r,t)||equals(e,t)&&equals(r,n))||area(e,n,r)>0!=area(e,n,t)>0&&area(r,t,e)>0!=area(r,t,n)>0}function intersectsPolygon(e,n){var r=e;do{if(r.i!==e.i&&r.next.i!==e.i&&r.i!==n.i&&r.next.i!==n.i&&intersects(r,r.next,e,n))return!0;r=r.next}while(r!==e);return!1}function locallyInside(e,n){return area(e.prev,e,e.next)<0?area(e,n,e.next)>=0&&area(e,e.prev,n)>=0:area(e,n,e.prev)<0||area(e,e.next,n)<0}function middleInside(e,n){var r=e,t=!1,i=(e.x+n.x)/2,x=(e.y+n.y)/2;do r.y>x!=r.next.y>x&&i<(r.next.x-r.x)*(x-r.y)/(r.next.y-r.y)+r.x&&(t=!t),r=r.next;while(r!==e);return t}function splitPolygon(e,n){var r=new Node(e.i,e.x,e.y),t=new Node(n.i,n.x,n.y),i=e.next,x=n.prev;return e.next=n,n.prev=e,r.next=i,i.prev=r,t.next=r,r.prev=t,x.next=t,t.prev=x,t}function insertNode(e,n,r,t){var i=new Node(e,n,r);return t?(i.next=t.next,i.prev=t,t.next.prev=i,t.next=i):(i.prev=i,i.next=i),i}function removeNode(e){e.next.prev=e.prev,e.prev.next=e.next,e.prevZ&&(e.prevZ.nextZ=e.nextZ),e.nextZ&&(e.nextZ.prevZ=e.prevZ)}function Node(e,n,r){this.i=e,this.x=n,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1}function signedArea(e,n,r,t){for(var i=0,x=n,a=r-t;x<r;x+=t)i+=(e[a]-e[x])*(e[x+1]+e[a+1]),a=x;return i}module.exports=earcut,earcut.deviation=function(e,n,r,t){var i=n&&n.length,x=i?n[0]*r:e.length,a=Math.abs(signedArea(e,0,x,r));if(i)for(var o=0,l=n.length;o<l;o++){var u=n[o]*r,s=o<l-1?n[o+1]*r:e.length;a-=Math.abs(signedArea(e,u,s,r))}var v=0;for(o=0;o<t.length;o+=3){var f=t[o]*r,y=t[o+1]*r,d=t[o+2]*r;v+=Math.abs((e[f]-e[d])*(e[y+1]-e[f+1])-(e[f]-e[y])*(e[d+1]-e[f+1]))}return 0===a&&0===v?0:Math.abs((v-a)/a)},earcut.flatten=function(e){for(var n=e[0][0].length,r={vertices:[],holes:[],dimensions:n},t=0,i=0;i<e.length;i++){for(var x=0;x<e[i].length;x++)for(var a=0;a<n;a++)r.vertices.push(e[i][x][a]);i>0&&(t+=e[i-1].length,r.holes.push(t))}return r};
	},{}],134:[function(require,module,exports){
	function sss(r){var e,t,s,n,u,a;switch(typeof r){case"object":if(null===r)return null;if(isArray(r)){for(s="[",t=r.length-1,e=0;e<t;e++)s+=sss(r[e])+",";return t>-1&&(s+=sss(r[e])),s+"]"}for(n=objKeys(r).sort(),t=n.length,s="{",u=n[e=0],a=t>0&&void 0!==r[u];e<t;)a?(s+='"'+u.replace(strReg,strReplace)+'":'+sss(r[u]),u=n[++e],a=e<t&&void 0!==r[u],a&&(s+=",")):(u=n[++e],a=e<t&&void 0!==r[u]);return s+"}";case"undefined":return null;case"string":return'"'+r.replace(strReg,strReplace)+'"';default:return r}}var toString={}.toString,isArray=Array.isArray||function(r){return"[object Array]"===toString.call(r)},objKeys=Object.keys||function(r){var e=[];for(var t in r)r.hasOwnProperty(t)&&e.push(t);return e},strReg=/[\u0000-\u001f"\\]/g,strReplace=function(r){var e=r.charCodeAt(0);switch(e){case 34:return'\\"';case 92:return"\\\\";case 12:return"\\f";case 10:return"\\n";case 13:return"\\r";case 9:return"\\t";case 8:return"\\b";default:return e>15?"\\u00"+e.toString(16):"\\u000"+e.toString(16)}};module.exports=function(r){if(void 0!==r)return""+sss(r)},module.exports.stringSearch=strReg,module.exports.stringReplace=strReplace;
	},{}],135:[function(require,module,exports){
	"use strict";function createFilter(e){return new Function("f","var p = (f && f.properties || {}); return "+compile(e))}function compile(e){if(!e)return"true";var i=e[0];if(e.length<=1)return"any"===i?"false":"true";var n="=="===i?compileComparisonOp(e[1],e[2],"===",!1):"!="===i?compileComparisonOp(e[1],e[2],"!==",!1):"<"===i||">"===i||"<="===i||">="===i?compileComparisonOp(e[1],e[2],i,!0):"any"===i?compileLogicalOp(e.slice(1),"||"):"all"===i?compileLogicalOp(e.slice(1),"&&"):"none"===i?compileNegation(compileLogicalOp(e.slice(1),"||")):"in"===i?compileInOp(e[1],e.slice(2)):"!in"===i?compileNegation(compileInOp(e[1],e.slice(2))):"has"===i?compileHasOp(e[1]):"!has"===i?compileNegation(compileHasOp([e[1]])):"true";return"("+n+")"}function compilePropertyReference(e){return"$type"===e?"f.type":"$id"===e?"f.id":"p["+JSON.stringify(e)+"]"}function compileComparisonOp(e,i,n,r){var o=compilePropertyReference(e),t="$type"===e?types.indexOf(i):JSON.stringify(i);return(r?"typeof "+o+"=== typeof "+t+"&&":"")+o+n+t}function compileLogicalOp(e,i){return e.map(compile).join(i)}function compileInOp(e,i){"$type"===e&&(i=i.map(function(e){return types.indexOf(e)}));var n=JSON.stringify(i.sort(compare)),r=compilePropertyReference(e);return i.length<=200?n+".indexOf("+r+") !== -1":"function(v, a, i, j) {while (i <= j) { var m = (i + j) >> 1;    if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;}return false; }("+r+", "+n+",0,"+(i.length-1)+")"}function compileHasOp(e){return JSON.stringify(e)+" in p"}function compileNegation(e){return"!("+e+")"}function compare(e,i){return e<i?-1:e>i?1:0}module.exports=createFilter;var types=["Unknown","Point","LineString","Polygon"];
	},{}],136:[function(require,module,exports){
	function geometry(r){if("Polygon"===r.type)return polygonArea(r.coordinates);if("MultiPolygon"===r.type){for(var e=0,n=0;n<r.coordinates.length;n++)e+=polygonArea(r.coordinates[n]);return e}return null}function polygonArea(r){var e=0;if(r&&r.length>0){e+=Math.abs(ringArea(r[0]));for(var n=1;n<r.length;n++)e-=Math.abs(ringArea(r[n]))}return e}function ringArea(r){var e=0;if(r.length>2){for(var n,t,o=0;o<r.length-1;o++)n=r[o],t=r[o+1],e+=rad(t[0]-n[0])*(2+Math.sin(rad(n[1]))+Math.sin(rad(t[1])));e=e*wgs84.RADIUS*wgs84.RADIUS/2}return e}function rad(r){return r*Math.PI/180}var wgs84=require("wgs84");module.exports.geometry=geometry,module.exports.ring=ringArea;
	},{"wgs84":212}],137:[function(require,module,exports){
	function rewind(r,e){switch(r&&r.type||null){case"FeatureCollection":return r.features=r.features.map(curryOuter(rewind,e)),r;case"Feature":return r.geometry=rewind(r.geometry,e),r;case"Polygon":case"MultiPolygon":return correct(r,e);default:return r}}function curryOuter(r,e){return function(n){return r(n,e)}}function correct(r,e){return"Polygon"===r.type?r.coordinates=correctRings(r.coordinates,e):"MultiPolygon"===r.type&&(r.coordinates=r.coordinates.map(curryOuter(correctRings,e))),r}function correctRings(r,e){e=!!e,r[0]=wind(r[0],!e);for(var n=1;n<r.length;n++)r[n]=wind(r[n],e);return r}function wind(r,e){return cw(r)===e?r:r.reverse()}function cw(r){return geojsonArea.ring(r)>=0}var geojsonArea=require("geojson-area");module.exports=rewind;
	},{"geojson-area":136}],138:[function(require,module,exports){
	"use strict";function clip(e,r,t,n,u,i,l,s){if(t/=r,n/=r,l>=t&&s<=n)return e;if(l>n||s<t)return null;for(var h=[],p=0;p<e.length;p++){var a,c,o=e[p],f=o.geometry,g=o.type;if(a=o.min[u],c=o.max[u],a>=t&&c<=n)h.push(o);else if(!(a>n||c<t)){var v=1===g?clipPoints(f,t,n,u):clipGeometry(f,t,n,u,i,3===g);v.length&&h.push(createFeature(o.tags,g,v,o.id))}}return h.length?h:null}function clipPoints(e,r,t,n){for(var u=[],i=0;i<e.length;i++){var l=e[i],s=l[n];s>=r&&s<=t&&u.push(l)}return u}function clipGeometry(e,r,t,n,u,i){for(var l=[],s=0;s<e.length;s++){var h,p,a,c=0,o=0,f=null,g=e[s],v=g.area,m=g.dist,w=g.outer,S=g.length,d=[];for(p=0;p<S-1;p++)h=f||g[p],f=g[p+1],c=o||h[n],o=f[n],c<r?o>t?(d.push(u(h,f,r),u(h,f,t)),i||(d=newSlice(l,d,v,m,w))):o>=r&&d.push(u(h,f,r)):c>t?o<r?(d.push(u(h,f,t),u(h,f,r)),i||(d=newSlice(l,d,v,m,w))):o<=t&&d.push(u(h,f,t)):(d.push(h),o<r?(d.push(u(h,f,r)),i||(d=newSlice(l,d,v,m,w))):o>t&&(d.push(u(h,f,t)),i||(d=newSlice(l,d,v,m,w))));h=g[S-1],c=h[n],c>=r&&c<=t&&d.push(h),a=d[d.length-1],i&&a&&(d[0][0]!==a[0]||d[0][1]!==a[1])&&d.push(d[0]),newSlice(l,d,v,m,w)}return l}function newSlice(e,r,t,n,u){return r.length&&(r.area=t,r.dist=n,void 0!==u&&(r.outer=u),e.push(r)),[]}module.exports=clip;var createFeature=require("./feature");
	},{"./feature":140}],139:[function(require,module,exports){
	"use strict";function convert(e,t){var r=[];if("FeatureCollection"===e.type)for(var o=0;o<e.features.length;o++)convertFeature(r,e.features[o],t);else"Feature"===e.type?convertFeature(r,e,t):convertFeature(r,{geometry:e},t);return r}function convertFeature(e,t,r){if(null!==t.geometry){var o,a,i,n,u=t.geometry,c=u.type,l=u.coordinates,s=t.properties,p=t.id;if("Point"===c)e.push(createFeature(s,1,[projectPoint(l)],p));else if("MultiPoint"===c)e.push(createFeature(s,1,project(l),p));else if("LineString"===c)e.push(createFeature(s,2,[project(l,r)],p));else if("MultiLineString"===c||"Polygon"===c){for(i=[],o=0;o<l.length;o++)n=project(l[o],r),"Polygon"===c&&(n.outer=0===o),i.push(n);e.push(createFeature(s,"Polygon"===c?3:2,i,p))}else if("MultiPolygon"===c){for(i=[],o=0;o<l.length;o++)for(a=0;a<l[o].length;a++)n=project(l[o][a],r),n.outer=0===a,i.push(n);e.push(createFeature(s,3,i,p))}else{if("GeometryCollection"!==c)throw new Error("Input data is not a valid GeoJSON object.");for(o=0;o<u.geometries.length;o++)convertFeature(e,{geometry:u.geometries[o],properties:s},r)}}}function project(e,t){for(var r=[],o=0;o<e.length;o++)r.push(projectPoint(e[o]));return t&&(simplify(r,t),calcSize(r)),r}function projectPoint(e){var t=Math.sin(e[1]*Math.PI/180),r=e[0]/360+.5,o=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return o=o<0?0:o>1?1:o,[r,o,0]}function calcSize(e){for(var t,r,o=0,a=0,i=0;i<e.length-1;i++)t=r||e[i],r=e[i+1],o+=t[0]*r[1]-r[0]*t[1],a+=Math.abs(r[0]-t[0])+Math.abs(r[1]-t[1]);e.area=Math.abs(o/2),e.dist=a}module.exports=convert;var simplify=require("./simplify"),createFeature=require("./feature");
	},{"./feature":140,"./simplify":142}],140:[function(require,module,exports){
	"use strict";function createFeature(e,t,a,n){var r={id:n||null,type:t,geometry:a,tags:e||null,min:[1/0,1/0],max:[-(1/0),-(1/0)]};return calcBBox(r),r}function calcBBox(e){var t=e.geometry,a=e.min,n=e.max;if(1===e.type)calcRingBBox(a,n,t);else for(var r=0;r<t.length;r++)calcRingBBox(a,n,t[r]);return e}function calcRingBBox(e,t,a){for(var n,r=0;r<a.length;r++)n=a[r],e[0]=Math.min(n[0],e[0]),t[0]=Math.max(n[0],t[0]),e[1]=Math.min(n[1],e[1]),t[1]=Math.max(n[1],t[1])}module.exports=createFeature;
	},{}],141:[function(require,module,exports){
	"use strict";function geojsonvt(e,t){return new GeoJSONVT(e,t)}function GeoJSONVT(e,t){t=this.options=extend(Object.create(this.options),t);var i=t.debug;i&&console.time("preprocess data");var o=1<<t.maxZoom,n=convert(e,t.tolerance/(o*t.extent));this.tiles={},this.tileCoords=[],i&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),n=wrap(n,t.buffer/t.extent,intersectX),n.length&&this.splitTile(n,0,0,0),i&&(n.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)))}function toID(e,t,i){return 32*((1<<e)*i+t)+e}function intersectX(e,t,i){return[i,(i-e[0])*(t[1]-e[1])/(t[0]-e[0])+e[1],1]}function intersectY(e,t,i){return[(i-e[1])*(t[0]-e[0])/(t[1]-e[1])+e[0],i,1]}function extend(e,t){for(var i in t)e[i]=t[i];return e}function isClippedSquare(e,t,i){var o=e.source;if(1!==o.length)return!1;var n=o[0];if(3!==n.type||n.geometry.length>1)return!1;var r=n.geometry[0].length;if(5!==r)return!1;for(var s=0;s<r;s++){var l=transform.point(n.geometry[0][s],t,e.z2,e.x,e.y);if(l[0]!==-i&&l[0]!==t+i||l[1]!==-i&&l[1]!==t+i)return!1}return!0}module.exports=geojsonvt;var convert=require("./convert"),transform=require("./transform"),clip=require("./clip"),wrap=require("./wrap"),createTile=require("./tile");GeoJSONVT.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,solidChildren:!1,tolerance:3,extent:4096,buffer:64,debug:0},GeoJSONVT.prototype.splitTile=function(e,t,i,o,n,r,s){for(var l=[e,t,i,o],a=this.options,u=a.debug,c=null;l.length;){o=l.pop(),i=l.pop(),t=l.pop(),e=l.pop();var p=1<<t,d=toID(t,i,o),m=this.tiles[d],f=t===a.maxZoom?0:a.tolerance/(p*a.extent);if(!m&&(u>1&&console.time("creation"),m=this.tiles[d]=createTile(e,p,i,o,f,t===a.maxZoom),this.tileCoords.push({z:t,x:i,y:o}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,i,o,m.numFeatures,m.numPoints,m.numSimplified),console.timeEnd("creation"));var h="z"+t;this.stats[h]=(this.stats[h]||0)+1,this.total++}if(m.source=e,n){if(t===a.maxZoom||t===n)continue;var x=1<<n-t;if(i!==Math.floor(r/x)||o!==Math.floor(s/x))continue}else if(t===a.indexMaxZoom||m.numPoints<=a.indexMaxPoints)continue;if(a.solidChildren||!isClippedSquare(m,a.extent,a.buffer)){m.source=null,u>1&&console.time("clipping");var g,v,M,T,b,y,S=.5*a.buffer/a.extent,Z=.5-S,q=.5+S,w=1+S;g=v=M=T=null,b=clip(e,p,i-S,i+q,0,intersectX,m.min[0],m.max[0]),y=clip(e,p,i+Z,i+w,0,intersectX,m.min[0],m.max[0]),b&&(g=clip(b,p,o-S,o+q,1,intersectY,m.min[1],m.max[1]),v=clip(b,p,o+Z,o+w,1,intersectY,m.min[1],m.max[1])),y&&(M=clip(y,p,o-S,o+q,1,intersectY,m.min[1],m.max[1]),T=clip(y,p,o+Z,o+w,1,intersectY,m.min[1],m.max[1])),u>1&&console.timeEnd("clipping"),e.length&&(l.push(g||[],t+1,2*i,2*o),l.push(v||[],t+1,2*i,2*o+1),l.push(M||[],t+1,2*i+1,2*o),l.push(T||[],t+1,2*i+1,2*o+1))}else n&&(c=t)}return c},GeoJSONVT.prototype.getTile=function(e,t,i){var o=this.options,n=o.extent,r=o.debug,s=1<<e;t=(t%s+s)%s;var l=toID(e,t,i);if(this.tiles[l])return transform.tile(this.tiles[l],n);r>1&&console.log("drilling down to z%d-%d-%d",e,t,i);for(var a,u=e,c=t,p=i;!a&&u>0;)u--,c=Math.floor(c/2),p=Math.floor(p/2),a=this.tiles[toID(u,c,p)];if(!a||!a.source)return null;if(r>1&&console.log("found parent tile z%d-%d-%d",u,c,p),isClippedSquare(a,n,o.buffer))return transform.tile(a,n);r>1&&console.time("drilling down");var d=this.splitTile(a.source,u,c,p,e,t,i);if(r>1&&console.timeEnd("drilling down"),null!==d){var m=1<<e-d;l=toID(d,Math.floor(t/m),Math.floor(i/m))}return this.tiles[l]?transform.tile(this.tiles[l],n):null};
	},{"./clip":138,"./convert":139,"./tile":143,"./transform":144,"./wrap":145}],142:[function(require,module,exports){
	"use strict";function simplify(t,i){var e,p,r,s,o=i*i,f=t.length,u=0,n=f-1,g=[];for(t[u][2]=1,t[n][2]=1;n;){for(p=0,e=u+1;e<n;e++)r=getSqSegDist(t[e],t[u],t[n]),r>p&&(s=e,p=r);p>o?(t[s][2]=p,g.push(u),g.push(s),u=s):(n=g.pop(),u=g.pop())}}function getSqSegDist(t,i,e){var p=i[0],r=i[1],s=e[0],o=e[1],f=t[0],u=t[1],n=s-p,g=o-r;if(0!==n||0!==g){var l=((f-p)*n+(u-r)*g)/(n*n+g*g);l>1?(p=s,r=o):l>0&&(p+=n*l,r+=g*l)}return n=f-p,g=u-r,n*n+g*g}module.exports=simplify;
	},{}],143:[function(require,module,exports){
	"use strict";function createTile(e,n,r,i,t,u){for(var a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:i,z2:n,transformed:!1,min:[2,1],max:[-1,0]},m=0;m<e.length;m++){a.numFeatures++,addFeature(a,e[m],t,u);var s=e[m].min,l=e[m].max;s[0]<a.min[0]&&(a.min[0]=s[0]),s[1]<a.min[1]&&(a.min[1]=s[1]),l[0]>a.max[0]&&(a.max[0]=l[0]),l[1]>a.max[1]&&(a.max[1]=l[1])}return a}function addFeature(e,n,r,i){var t,u,a,m,s=n.geometry,l=n.type,o=[],f=r*r;if(1===l)for(t=0;t<s.length;t++)o.push(s[t]),e.numPoints++,e.numSimplified++;else for(t=0;t<s.length;t++)if(a=s[t],i||!(2===l&&a.dist<r||3===l&&a.area<f)){var d=[];for(u=0;u<a.length;u++)m=a[u],(i||m[2]>f)&&(d.push(m),e.numSimplified++),e.numPoints++;3===l&&rewind(d,a.outer),o.push(d)}else e.numPoints+=a.length;if(o.length){var g={geometry:o,type:l,tags:n.tags||null};null!==n.id&&(g.id=n.id),e.features.push(g)}}function rewind(e,n){var r=signedArea(e);r<0===n&&e.reverse()}function signedArea(e){for(var n,r,i=0,t=0,u=e.length,a=u-1;t<u;a=t++)n=e[t],r=e[a],i+=(r[0]-n[0])*(n[1]+r[1]);return i}module.exports=createTile;
	},{}],144:[function(require,module,exports){
	"use strict";function transformTile(r,t){if(r.transformed)return r;var n,e,o,f=r.z2,a=r.x,s=r.y;for(n=0;n<r.features.length;n++){var i=r.features[n],u=i.geometry,m=i.type;if(1===m)for(e=0;e<u.length;e++)u[e]=transformPoint(u[e],t,f,a,s);else for(e=0;e<u.length;e++){var l=u[e];for(o=0;o<l.length;o++)l[o]=transformPoint(l[o],t,f,a,s)}}return r.transformed=!0,r}function transformPoint(r,t,n,e,o){var f=Math.round(t*(r[0]*n-e)),a=Math.round(t*(r[1]*n-o));return[f,a]}exports.tile=transformTile,exports.point=transformPoint;
	},{}],145:[function(require,module,exports){
	"use strict";function wrap(r,e,t){var o=r,a=clip(r,1,-1-e,e,0,t,-1,2),s=clip(r,1,1-e,2+e,0,t,-1,2);return(a||s)&&(o=clip(r,1,-e,1+e,0,t,-1,2)||[],a&&(o=shiftFeatureCoords(a,1).concat(o)),s&&(o=o.concat(shiftFeatureCoords(s,-1)))),o}function shiftFeatureCoords(r,e){for(var t=[],o=0;o<r.length;o++){var a,s=r[o],i=s.type;if(1===i)a=shiftCoords(s.geometry,e);else{a=[];for(var u=0;u<s.geometry.length;u++)a.push(shiftCoords(s.geometry[u],e))}t.push(createFeature(s.tags,i,a,s.id))}return t}function shiftCoords(r,e){var t=[];t.area=r.area,t.dist=r.dist;for(var o=0;o<r.length;o++)t.push([r[o][0]+e,r[o][1],r[o][2]]);return t}var clip=require("./clip"),createFeature=require("./feature");module.exports=wrap;
	},{"./clip":138,"./feature":140}],146:[function(require,module,exports){
	"use strict";function GridIndex(t,r,e){var s=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],r=i[1],e=i[2],this.d=r+2*e;for(var h=0;h<this.d*this.d;h++){var n=i[NUM_PARAMS+h],o=i[NUM_PARAMS+h+1];s.push(n===o?null:i.subarray(n,o))}var l=i[NUM_PARAMS+s.length],a=i[NUM_PARAMS+s.length+1];this.keys=i.subarray(l,a),this.bboxes=i.subarray(a),this.insert=this._insertReadonly}else{this.d=r+2*e;for(var d=0;d<this.d*this.d;d++)s.push([]);this.keys=[],this.bboxes=[]}this.n=r,this.extent=t,this.padding=e,this.scale=r/t,this.uid=0;var f=e/r*t;this.min=-f,this.max=t+f}module.exports=GridIndex;var NUM_PARAMS=3;GridIndex.prototype.insert=function(t,r,e,s,i){this._forEachCell(r,e,s,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(r),this.bboxes.push(e),this.bboxes.push(s),this.bboxes.push(i)},GridIndex.prototype._insertReadonly=function(){throw"Cannot insert into a GridIndex created from an ArrayBuffer."},GridIndex.prototype._insertCell=function(t,r,e,s,i,h){this.cells[i].push(h)},GridIndex.prototype.query=function(t,r,e,s){var i=this.min,h=this.max;if(t<=i&&r<=i&&h<=e&&h<=s)return Array.prototype.slice.call(this.keys);var n=[],o={};return this._forEachCell(t,r,e,s,this._queryCell,n,o),n},GridIndex.prototype._queryCell=function(t,r,e,s,i,h,n){var o=this.cells[i];if(null!==o)for(var l=this.keys,a=this.bboxes,d=0;d<o.length;d++){var f=o[d];if(void 0===n[f]){var u=4*f;t<=a[u+2]&&r<=a[u+3]&&e>=a[u+0]&&s>=a[u+1]?(n[f]=!0,h.push(l[f])):n[f]=!1}}},GridIndex.prototype._forEachCell=function(t,r,e,s,i,h,n){for(var o=this._convertToCellCoord(t),l=this._convertToCellCoord(r),a=this._convertToCellCoord(e),d=this._convertToCellCoord(s),f=o;f<=a;f++)for(var u=l;u<=d;u++){var y=this.d*u+f;if(i.call(this,t,r,e,s,y,h,n))return}},GridIndex.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},GridIndex.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,r=NUM_PARAMS+this.cells.length+1+1,e=0,s=0;s<this.cells.length;s++)e+=this.cells[s].length;var i=new Int32Array(r+e+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var h=r,n=0;n<t.length;n++){var o=t[n];i[NUM_PARAMS+n]=h,i.set(o,h),h+=o.length}return i[NUM_PARAMS+t.length]=h,i.set(this.keys,h),h+=this.keys.length,i[NUM_PARAMS+t.length+1]=h,i.set(this.bboxes,h),h+=this.bboxes.length,i.buffer};
	},{}],147:[function(require,module,exports){
	exports.read=function(a,o,t,r,h){var M,p,w=8*h-r-1,f=(1<<w)-1,e=f>>1,i=-7,N=t?h-1:0,n=t?-1:1,s=a[o+N];for(N+=n,M=s&(1<<-i)-1,s>>=-i,i+=w;i>0;M=256*M+a[o+N],N+=n,i-=8);for(p=M&(1<<-i)-1,M>>=-i,i+=r;i>0;p=256*p+a[o+N],N+=n,i-=8);if(0===M)M=1-e;else{if(M===f)return p?NaN:(s?-1:1)*(1/0);p+=Math.pow(2,r),M-=e}return(s?-1:1)*p*Math.pow(2,M-r)},exports.write=function(a,o,t,r,h,M){var p,w,f,e=8*M-h-1,i=(1<<e)-1,N=i>>1,n=23===h?Math.pow(2,-24)-Math.pow(2,-77):0,s=r?0:M-1,u=r?1:-1,l=o<0||0===o&&1/o<0?1:0;for(o=Math.abs(o),isNaN(o)||o===1/0?(w=isNaN(o)?1:0,p=i):(p=Math.floor(Math.log(o)/Math.LN2),o*(f=Math.pow(2,-p))<1&&(p--,f*=2),o+=p+N>=1?n/f:n*Math.pow(2,1-N),o*f>=2&&(p++,f/=2),p+N>=i?(w=0,p=i):p+N>=1?(w=(o*f-1)*Math.pow(2,h),p+=N):(w=o*Math.pow(2,N-1)*Math.pow(2,h),p=0));h>=8;a[t+s]=255&w,s+=u,w/=256,h-=8);for(p=p<<h|w,e+=h;e>0;a[t+s]=255&p,s+=u,p/=256,e-=8);a[t+s-u]|=128*l};
	},{}],148:[function(require,module,exports){
	"use strict";function kdbush(t,i,e,s,n){return new KDBush(t,i,e,s,n)}function KDBush(t,i,e,s,n){i=i||defaultGetX,e=e||defaultGetY,n=n||Array,this.nodeSize=s||64,this.points=t,this.ids=new n(t.length),this.coords=new n(2*t.length);for(var r=0;r<t.length;r++)this.ids[r]=r,this.coords[2*r]=i(t[r]),this.coords[2*r+1]=e(t[r]);sort(this.ids,this.coords,this.nodeSize,0,this.ids.length-1,0)}function defaultGetX(t){return t[0]}function defaultGetY(t){return t[1]}var sort=require("./sort"),range=require("./range"),within=require("./within");module.exports=kdbush,KDBush.prototype={range:function(t,i,e,s){return range(this.ids,this.coords,t,i,e,s,this.nodeSize)},within:function(t,i,e){return within(this.ids,this.coords,t,i,e,this.nodeSize)}};
	},{"./range":149,"./sort":150,"./within":151}],149:[function(require,module,exports){
	"use strict";function range(p,r,s,u,h,e,o){for(var a,t,n=[0,p.length-1,0],f=[];n.length;){var l=n.pop(),v=n.pop(),g=n.pop();if(v-g<=o)for(var i=g;i<=v;i++)a=r[2*i],t=r[2*i+1],a>=s&&a<=h&&t>=u&&t<=e&&f.push(p[i]);else{var c=Math.floor((g+v)/2);a=r[2*c],t=r[2*c+1],a>=s&&a<=h&&t>=u&&t<=e&&f.push(p[c]);var d=(l+1)%2;(0===l?s<=a:u<=t)&&(n.push(g),n.push(c-1),n.push(d)),(0===l?h>=a:e>=t)&&(n.push(c+1),n.push(v),n.push(d))}}return f}module.exports=range;
	},{}],150:[function(require,module,exports){
	"use strict";function sortKD(t,a,o,s,r,e){if(!(r-s<=o)){var f=Math.floor((s+r)/2);select(t,a,f,s,r,e%2),sortKD(t,a,o,s,f-1,e+1),sortKD(t,a,o,f+1,r,e+1)}}function select(t,a,o,s,r,e){for(;r>s;){if(r-s>600){var f=r-s+1,p=o-s+1,w=Math.log(f),m=.5*Math.exp(2*w/3),n=.5*Math.sqrt(w*m*(f-m)/f)*(p-f/2<0?-1:1),c=Math.max(s,Math.floor(o-p*m/f+n)),h=Math.min(r,Math.floor(o+(f-p)*m/f+n));select(t,a,o,c,h,e)}var i=a[2*o+e],l=s,M=r;for(swapItem(t,a,s,o),a[2*r+e]>i&&swapItem(t,a,s,r);l<M;){for(swapItem(t,a,l,M),l++,M--;a[2*l+e]<i;)l++;for(;a[2*M+e]>i;)M--}a[2*s+e]===i?swapItem(t,a,s,M):(M++,swapItem(t,a,M,r)),M<=o&&(s=M+1),o<=M&&(r=M-1)}}function swapItem(t,a,o,s){swap(t,o,s),swap(a,2*o,2*s),swap(a,2*o+1,2*s+1)}function swap(t,a,o){var s=t[a];t[a]=t[o],t[o]=s}module.exports=sortKD;
	},{}],151:[function(require,module,exports){
	"use strict";function within(s,p,r,t,u,h){for(var i=[0,s.length-1,0],o=[],n=u*u;i.length;){var e=i.pop(),a=i.pop(),f=i.pop();if(a-f<=h)for(var v=f;v<=a;v++)sqDist(p[2*v],p[2*v+1],r,t)<=n&&o.push(s[v]);else{var l=Math.floor((f+a)/2),c=p[2*l],q=p[2*l+1];sqDist(c,q,r,t)<=n&&o.push(s[l]);var D=(e+1)%2;(0===e?r-u<=c:t-u<=q)&&(i.push(f),i.push(l-1),i.push(D)),(0===e?r+u>=c:t+u>=q)&&(i.push(l+1),i.push(a),i.push(D))}}return o}function sqDist(s,p,r,t){var u=s-r,h=p-t;return u*u+h*h}module.exports=within;
	},{}],152:[function(require,module,exports){
	function isObjectLike(r){return!!r&&"object"==typeof r}function arraySome(r,e){for(var a=-1,t=r.length;++a<t;)if(e(r[a],a,r))return!0;return!1}function baseIsEqual(r,e,a,t,o,n){return r===e||(null==r||null==e||!isObject(r)&&!isObjectLike(e)?r!==r&&e!==e:baseIsEqualDeep(r,e,baseIsEqual,a,t,o,n))}function baseIsEqualDeep(r,e,a,t,o,n,u){var c=isArray(r),s=isArray(e),i=arrayTag,g=arrayTag;c||(i=objToString.call(r),i==argsTag?i=objectTag:i!=objectTag&&(c=isTypedArray(r))),s||(g=objToString.call(e),g==argsTag?g=objectTag:g!=objectTag&&(s=isTypedArray(e)));var b=i==objectTag,l=g==objectTag,f=i==g;if(f&&!c&&!b)return equalByTag(r,e,i);if(!o){var y=b&&hasOwnProperty.call(r,"__wrapped__"),T=l&&hasOwnProperty.call(e,"__wrapped__");if(y||T)return a(y?r.value():r,T?e.value():e,t,o,n,u)}if(!f)return!1;n||(n=[]),u||(u=[]);for(var j=n.length;j--;)if(n[j]==r)return u[j]==e;n.push(r),u.push(e);var p=(c?equalArrays:equalObjects)(r,e,a,t,o,n,u);return n.pop(),u.pop(),p}function equalArrays(r,e,a,t,o,n,u){var c=-1,s=r.length,i=e.length;if(s!=i&&!(o&&i>s))return!1;for(;++c<s;){var g=r[c],b=e[c],l=t?t(o?b:g,o?g:b,c):void 0;if(void 0!==l){if(l)continue;return!1}if(o){if(!arraySome(e,function(r){return g===r||a(g,r,t,o,n,u)}))return!1}else if(g!==b&&!a(g,b,t,o,n,u))return!1}return!0}function equalByTag(r,e,a){switch(a){case boolTag:case dateTag:return+r==+e;case errorTag:return r.name==e.name&&r.message==e.message;case numberTag:return r!=+r?e!=+e:r==+e;case regexpTag:case stringTag:return r==e+""}return!1}function equalObjects(r,e,a,t,o,n,u){var c=keys(r),s=c.length,i=keys(e),g=i.length;if(s!=g&&!o)return!1;for(var b=s;b--;){var l=c[b];if(!(o?l in e:hasOwnProperty.call(e,l)))return!1}for(var f=o;++b<s;){l=c[b];var y=r[l],T=e[l],j=t?t(o?T:y,o?y:T,l):void 0;if(!(void 0===j?a(y,T,t,o,n,u):j))return!1;f||(f="constructor"==l)}if(!f){var p=r.constructor,v=e.constructor;if(p!=v&&"constructor"in r&&"constructor"in e&&!("function"==typeof p&&p instanceof p&&"function"==typeof v&&v instanceof v))return!1}return!0}function isObject(r){var e=typeof r;return!!r&&("object"==e||"function"==e)}var isArray=require("lodash.isarray"),isTypedArray=require("lodash.istypedarray"),keys=require("lodash.keys"),argsTag="[object Arguments]",arrayTag="[object Array]",boolTag="[object Boolean]",dateTag="[object Date]",errorTag="[object Error]",numberTag="[object Number]",objectTag="[object Object]",regexpTag="[object RegExp]",stringTag="[object String]",objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString;module.exports=baseIsEqual;
	},{"lodash.isarray":156,"lodash.istypedarray":158,"lodash.keys":159}],153:[function(require,module,exports){
	function bindCallback(n,t,r){if("function"!=typeof n)return identity;if(void 0===t)return n;switch(r){case 1:return function(r){return n.call(t,r)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,c){return n.call(t,r,e,u,c)};case 5:return function(r,e,u,c,i){return n.call(t,r,e,u,c,i)}}return function(){return n.apply(t,arguments)}}function identity(n){return n}module.exports=bindCallback;
	},{}],154:[function(require,module,exports){
	function isObjectLike(t){return!!t&&"object"==typeof t}function getNative(t,o){var e=null==t?void 0:t[o];return isNative(e)?e:void 0}function isFunction(t){return isObject(t)&&objToString.call(t)==funcTag}function isObject(t){var o=typeof t;return!!t&&("object"==o||"function"==o)}function isNative(t){return null!=t&&(isFunction(t)?reIsNative.test(fnToString.call(t)):isObjectLike(t)&&reIsHostCtor.test(t))}var funcTag="[object Function]",reIsHostCtor=/^\[object .+?Constructor\]$/,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp("^"+fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");module.exports=getNative;
	},{}],155:[function(require,module,exports){
	function isArguments(t){return isArrayLikeObject(t)&&hasOwnProperty.call(t,"callee")&&(!propertyIsEnumerable.call(t,"callee")||objectToString.call(t)==argsTag)}function isArrayLike(t){return null!=t&&isLength(t.length)&&!isFunction(t)}function isArrayLikeObject(t){return isObjectLike(t)&&isArrayLike(t)}function isFunction(t){var e=isObject(t)?objectToString.call(t):"";return e==funcTag||e==genTag}function isLength(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=MAX_SAFE_INTEGER}function isObject(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function isObjectLike(t){return!!t&&"object"==typeof t}var MAX_SAFE_INTEGER=9007199254740991,argsTag="[object Arguments]",funcTag="[object Function]",genTag="[object GeneratorFunction]",objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,objectToString=objectProto.toString,propertyIsEnumerable=objectProto.propertyIsEnumerable;module.exports=isArguments;
	},{}],156:[function(require,module,exports){
	function isObjectLike(t){return!!t&&"object"==typeof t}function getNative(t,r){var e=null==t?void 0:t[r];return isNative(e)?e:void 0}function isLength(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=MAX_SAFE_INTEGER}function isFunction(t){return isObject(t)&&objToString.call(t)==funcTag}function isObject(t){var r=typeof t;return!!t&&("object"==r||"function"==r)}function isNative(t){return null!=t&&(isFunction(t)?reIsNative.test(fnToString.call(t)):isObjectLike(t)&&reIsHostCtor.test(t))}var arrayTag="[object Array]",funcTag="[object Function]",reIsHostCtor=/^\[object .+?Constructor\]$/,objectProto=Object.prototype,fnToString=Function.prototype.toString,hasOwnProperty=objectProto.hasOwnProperty,objToString=objectProto.toString,reIsNative=RegExp("^"+fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),nativeIsArray=getNative(Array,"isArray"),MAX_SAFE_INTEGER=9007199254740991,isArray=nativeIsArray||function(t){return isObjectLike(t)&&isLength(t.length)&&objToString.call(t)==arrayTag};module.exports=isArray;
	},{}],157:[function(require,module,exports){
	function isEqual(a,l,i,e){i="function"==typeof i?bindCallback(i,e,3):void 0;var s=i?i(a,l):void 0;return void 0===s?baseIsEqual(a,l,i):!!s}var baseIsEqual=require("lodash._baseisequal"),bindCallback=require("lodash._bindcallback");module.exports=isEqual;
	},{"lodash._baseisequal":152,"lodash._bindcallback":153}],158:[function(require,module,exports){
	function isLength(a){return"number"==typeof a&&a>-1&&a%1==0&&a<=MAX_SAFE_INTEGER}function isObjectLike(a){return!!a&&"object"==typeof a}function isTypedArray(a){return isObjectLike(a)&&isLength(a.length)&&!!typedArrayTags[objectToString.call(a)]}var MAX_SAFE_INTEGER=9007199254740991,argsTag="[object Arguments]",arrayTag="[object Array]",boolTag="[object Boolean]",dateTag="[object Date]",errorTag="[object Error]",funcTag="[object Function]",mapTag="[object Map]",numberTag="[object Number]",objectTag="[object Object]",regexpTag="[object RegExp]",setTag="[object Set]",stringTag="[object String]",weakMapTag="[object WeakMap]",arrayBufferTag="[object ArrayBuffer]",dataViewTag="[object DataView]",float32Tag="[object Float32Array]",float64Tag="[object Float64Array]",int8Tag="[object Int8Array]",int16Tag="[object Int16Array]",int32Tag="[object Int32Array]",uint8Tag="[object Uint8Array]",uint8ClampedTag="[object Uint8ClampedArray]",uint16Tag="[object Uint16Array]",uint32Tag="[object Uint32Array]",typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=!0,typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=!1;var objectProto=Object.prototype,objectToString=objectProto.toString;module.exports=isTypedArray;
	},{}],159:[function(require,module,exports){
	function baseProperty(e){return function(t){return null==t?void 0:t[e]}}function isArrayLike(e){return null!=e&&isLength(getLength(e))}function isIndex(e,t){return e="number"==typeof e||reIsUint.test(e)?+e:-1,t=null==t?MAX_SAFE_INTEGER:t,e>-1&&e%1==0&&e<t}function isLength(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=MAX_SAFE_INTEGER}function shimKeys(e){for(var t=keysIn(e),r=t.length,n=r&&e.length,s=!!n&&isLength(n)&&(isArray(e)||isArguments(e)),o=-1,i=[];++o<r;){var u=t[o];(s&&isIndex(u,n)||hasOwnProperty.call(e,u))&&i.push(u)}return i}function isObject(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function keysIn(e){if(null==e)return[];isObject(e)||(e=Object(e));var t=e.length;t=t&&isLength(t)&&(isArray(e)||isArguments(e))&&t||0;for(var r=e.constructor,n=-1,s="function"==typeof r&&r.prototype===e,o=Array(t),i=t>0;++n<t;)o[n]=n+"";for(var u in e)i&&isIndex(u,t)||"constructor"==u&&(s||!hasOwnProperty.call(e,u))||o.push(u);return o}var getNative=require("lodash._getnative"),isArguments=require("lodash.isarguments"),isArray=require("lodash.isarray"),reIsUint=/^\d+$/,objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,nativeKeys=getNative(Object,"keys"),MAX_SAFE_INTEGER=9007199254740991,getLength=baseProperty("length"),keys=nativeKeys?function(e){var t=null==e?void 0:e.constructor;return"function"==typeof t&&t.prototype===e||"function"!=typeof e&&isArrayLike(e)?shimKeys(e):isObject(e)?nativeKeys(e):[]}:shimKeys;module.exports=keys;
	},{"lodash._getnative":154,"lodash.isarguments":155,"lodash.isarray":156}],160:[function(require,module,exports){
	function xyz2lab(r){return r>t3?Math.pow(r,1/3):r/t2+t0}function lab2xyz(r){return r>t1?r*r*r:t2*(r-t0)}function xyz2rgb(r){return 255*(r<=.0031308?12.92*r:1.055*Math.pow(r,1/2.4)-.055)}function rgb2xyz(r){return(r/=255)<=.04045?r/12.92:Math.pow((r+.055)/1.055,2.4)}function rgbToLab(r){var t=rgb2xyz(r[0]),a=rgb2xyz(r[1]),n=rgb2xyz(r[2]),b=xyz2lab((.4124564*t+.3575761*a+.1804375*n)/Xn),o=xyz2lab((.2126729*t+.7151522*a+.072175*n)/Yn),g=xyz2lab((.0193339*t+.119192*a+.9503041*n)/Zn);return[116*o-16,500*(b-o),200*(o-g),r[3]]}function labToRgb(r){var t=(r[0]+16)/116,a=isNaN(r[1])?t:t+r[1]/500,n=isNaN(r[2])?t:t-r[2]/200;return t=Yn*lab2xyz(t),a=Xn*lab2xyz(a),n=Zn*lab2xyz(n),[xyz2rgb(3.2404542*a-1.5371385*t-.4985314*n),xyz2rgb(-.969266*a+1.8760108*t+.041556*n),xyz2rgb(.0556434*a-.2040259*t+1.0572252*n),r[3]]}function rgbToHcl(r){var t=rgbToLab(r),a=t[0],n=t[1],b=t[2],o=Math.atan2(b,n)*rad2deg;return[o<0?o+360:o,Math.sqrt(n*n+b*b),a,r[3]]}function hclToRgb(r){var t=r[0]*deg2rad,a=r[1],n=r[2];return labToRgb([n,Math.cos(t)*a,Math.sin(t)*a,r[3]])}var Kn=18,Xn=.95047,Yn=1,Zn=1.08883,t0=4/29,t1=6/29,t2=3*t1*t1,t3=t1*t1*t1,deg2rad=Math.PI/180,rad2deg=180/Math.PI;module.exports={lab:{forward:rgbToLab,reverse:labToRgb},hcl:{forward:rgbToHcl,reverse:hclToRgb}};
	},{}],161:[function(require,module,exports){
	"use strict";function identityFunction(t){return t}function createFunction(t,o){var e;if(isFunctionDefinition(t)){var n,r=t.stops&&"object"==typeof t.stops[0][0],i=r||void 0!==t.property,s=r||!i,a=t.stops&&typeof(r?t.stops[0][0].property:t.stops[0][0]),p=t.type||o||("string"===a?"categorical":"exponential");if("exponential"===p)n=evaluateExponentialFunction;else if("interval"===p)n=evaluateIntervalFunction;else if("categorical"===p)n=evaluateCategoricalFunction;else{if("identity"!==p)throw new Error('Unknown function type "'+p+'"');n=evaluateIdentityFunction}var u;if(t.colorSpace&&"rgb"!==t.colorSpace){if(!colorSpaces[t.colorSpace])throw new Error("Unknown color space: "+t.colorSpace);var c=colorSpaces[t.colorSpace];t=JSON.parse(JSON.stringify(t));for(var l=0;l<t.stops.length;l++)t.stops[l]=[t.stops[l][0],c.forward(t.stops[l][1])];u=c.reverse}else u=identityFunction;if(n===evaluateCategoricalFunction)for(var f=Object.create(null),v=0;v<t.stops.length;v++)f[t.stops[v][0]]=t.stops[v][1];if(r){var y={},F=[];for(l=0;l<t.stops.length;l++){var d=t.stops[l];void 0===y[d[0].zoom]&&(y[d[0].zoom]={zoom:d[0].zoom,type:t.type,property:t.property,stops:[]}),y[d[0].zoom].stops.push([d[0].value,d[1]])}for(var h in y)F.push([y[h].zoom,createFunction(y[h])]);e=function(o,e){return u(evaluateExponentialFunction({stops:F,base:t.base},o)(o,e))},e.isFeatureConstant=!1,e.isZoomConstant=!1}else s?(e=function(o){return u(n===evaluateCategoricalFunction?n(t,o,f):n(t,o))},e.isFeatureConstant=!0,e.isZoomConstant=!1):(e=function(o,e){return u(n===evaluateCategoricalFunction?n(t,e[t.property],f):n(t,e[t.property]))},e.isFeatureConstant=!1,e.isZoomConstant=!0)}else e=function(){return t},e.isFeatureConstant=!0,e.isZoomConstant=!0;return e}function evaluateCategoricalFunction(t,o,e){var n=e[o];return void 0===n?t.stops[0][1]:n}function evaluateIntervalFunction(t,o){var e=t.stops.length;if(1===e)return t.stops[0][1];if(void 0===o||null===o)return t.stops[e-1][1];if(o<=t.stops[0][0])return t.stops[0][1];if(o>=t.stops[e-1][0])return t.stops[e-1][1];var n=binarySearchForIndex(t.stops,o);return t.stops[n][1]}function evaluateExponentialFunction(t,o){var e=void 0!==t.base?t.base:1,n=t.stops.length;if(1===n)return t.stops[0][1];if(void 0===o||null===o)return t.stops[n-1][1];if(o<=t.stops[0][0])return t.stops[0][1];if(o>=t.stops[n-1][0])return t.stops[n-1][1];var r=binarySearchForIndex(t.stops,o);return interpolate(o,e,t.stops[r][0],t.stops[r+1][0],t.stops[r][1],t.stops[r+1][1])}function evaluateIdentityFunction(t,o){return o}function binarySearchForIndex(t,o){for(var e,n=t.length,r=0,i=n-1,s=0;r<=i;){if(s=Math.floor((r+i)/2),e=t[s][0],e===o){s+=1;break}e<o?r=s+1:e>o&&(i=s-1)}return Math.max(s-1,0)}function interpolate(t,o,e,n,r,i){return"function"==typeof r?function(){var s=r.apply(void 0,arguments),a=i.apply(void 0,arguments);return interpolate(t,o,e,n,s,a)}:r.length?interpolateArray(t,o,e,n,r,i):interpolateNumber(t,o,e,n,r,i)}function interpolateNumber(t,o,e,n,r,i){var s,a=n-e,p=t-e;return s=1===o?p/a:(Math.pow(o,p)-1)/(Math.pow(o,a)-1),r*(1-s)+i*s}function interpolateArray(t,o,e,n,r,i){for(var s=[],a=0;a<r.length;a++)s[a]=interpolateNumber(t,o,e,n,r[a],i[a]);return s}function isFunctionDefinition(t){return"object"==typeof t&&(t.stops||"identity"===t.type)}var colorSpaces=require("./color_spaces");module.exports.isFunctionDefinition=isFunctionDefinition,module.exports.interpolated=function(t){return createFunction(t,"exponential")},module.exports["piecewise-constant"]=function(t){return createFunction(t,"interval")};
	},{"./color_spaces":160}],162:[function(require,module,exports){
	"use strict";function deref(e,r){var f={};for(var t in e)"ref"!==t&&(f[t]=e[t]);return refProperties.forEach(function(e){e in r&&(f[e]=r[e])}),f}function derefLayers(e){e=e.slice();var r,f=Object.create(null);for(r=0;r<e.length;r++)f[e[r].id]=e[r];for(r=0;r<e.length;r++)"ref"in e[r]&&(e[r]=deref(e[r],f[e[r].ref]));return e}var refProperties=require("./util/ref_properties");module.exports=derefLayers;
	},{"./util/ref_properties":168}],163:[function(require,module,exports){
	"use strict";function diffSources(e,r,o,a){e=e||{},r=r||{};var s;for(s in e)e.hasOwnProperty(s)&&(r.hasOwnProperty(s)||(o.push({command:operations.removeSource,args:[s]}),a[s]=!0));for(s in r)r.hasOwnProperty(s)&&(e.hasOwnProperty(s)?isEqual(e[s],r[s])||(o.push({command:operations.removeSource,args:[s]}),o.push({command:operations.addSource,args:[s,r[s]]}),a[s]=!0):o.push({command:operations.addSource,args:[s,r[s]]}))}function diffLayerPropertyChanges(e,r,o,a,s,t){e=e||{},r=r||{};var n;for(n in e)e.hasOwnProperty(n)&&(isEqual(e[n],r[n])||o.push({command:t,args:[a,n,r[n],s]}));for(n in r)r.hasOwnProperty(n)&&!e.hasOwnProperty(n)&&(isEqual(e[n],r[n])||o.push({command:t,args:[a,n,r[n],s]}))}function pluckId(e){return e.id}function indexById(e,r){return e[r.id]=r,e}function diffLayers(e,r,o){e=e||[],r=r||[];var a,s,t,n,i,p,m,u=e.map(pluckId),l=r.map(pluckId),y=e.reduce(indexById,{}),c=r.reduce(indexById,{}),d=u.slice(),h=Object.create(null);for(a=0,s=0;a<u.length;a++)t=u[a],c.hasOwnProperty(t)?s++:(o.push({command:operations.removeLayer,args:[t]}),d.splice(d.indexOf(t,s),1));for(a=0,s=0;a<l.length;a++)t=l[l.length-1-a],d[d.length-1-a]!==t&&(y.hasOwnProperty(t)?(o.push({command:operations.removeLayer,args:[t]}),d.splice(d.lastIndexOf(t,d.length-s),1)):s++,p=d[d.length-a],o.push({command:operations.addLayer,args:[c[t],p]}),d.splice(d.length-a,0,t),h[t]=!0);for(a=0;a<l.length;a++)if(t=l[a],n=y[t],i=c[t],!h[t]&&!isEqual(n,i))if(isEqual(n.source,i.source)&&isEqual(n["source-layer"],i["source-layer"])&&isEqual(n.type,i.type)){diffLayerPropertyChanges(n.layout,i.layout,o,t,null,operations.setLayoutProperty),diffLayerPropertyChanges(n.paint,i.paint,o,t,null,operations.setPaintProperty),isEqual(n.filter,i.filter)||o.push({command:operations.setFilter,args:[t,i.filter]}),isEqual(n.minzoom,i.minzoom)&&isEqual(n.maxzoom,i.maxzoom)||o.push({command:operations.setLayerZoomRange,args:[t,i.minzoom,i.maxzoom]});for(m in n)n.hasOwnProperty(m)&&"layout"!==m&&"paint"!==m&&"filter"!==m&&"metadata"!==m&&"minzoom"!==m&&"maxzoom"!==m&&(0===m.indexOf("paint.")?diffLayerPropertyChanges(n[m],i[m],o,t,m.slice(6),operations.setPaintProperty):isEqual(n[m],i[m])||o.push({command:operations.setLayerProperty,args:[t,m,i[m]]}));for(m in i)i.hasOwnProperty(m)&&!n.hasOwnProperty(m)&&"layout"!==m&&"paint"!==m&&"filter"!==m&&"metadata"!==m&&"minzoom"!==m&&"maxzoom"!==m&&(0===m.indexOf("paint.")?diffLayerPropertyChanges(n[m],i[m],o,t,m.slice(6),operations.setPaintProperty):isEqual(n[m],i[m])||o.push({command:operations.setLayerProperty,args:[t,m,i[m]]}))}else o.push({command:operations.removeLayer,args:[t]}),p=d[d.lastIndexOf(t)+1],o.push({command:operations.addLayer,args:[i,p]})}function diffStyles(e,r){if(!e)return[{command:operations.setStyle,args:[r]}];var o=[];try{if(!isEqual(e.version,r.version))return[{command:operations.setStyle,args:[r]}];isEqual(e.center,r.center)||o.push({command:operations.setCenter,args:[r.center]}),isEqual(e.zoom,r.zoom)||o.push({command:operations.setZoom,args:[r.zoom]}),isEqual(e.bearing,r.bearing)||o.push({command:operations.setBearing,args:[r.bearing]}),isEqual(e.pitch,r.pitch)||o.push({command:operations.setPitch,args:[r.pitch]}),isEqual(e.sprite,r.sprite)||o.push({command:operations.setSprite,args:[r.sprite]}),isEqual(e.glyphs,r.glyphs)||o.push({command:operations.setGlyphs,args:[r.glyphs]}),isEqual(e.transition,r.transition)||o.push({command:operations.setTransition,args:[r.transition]}),isEqual(e.light,r.light)||o.push({command:operations.setLight,args:[r.light]});var a={},s=[];diffSources(e.sources,r.sources,s,a);var t=[];e.layers&&e.layers.forEach(function(e){a[e.source]?o.push({command:operations.removeLayer,args:[e.id]}):t.push(e)}),o=o.concat(s),diffLayers(t,r.layers,o)}catch(e){console.warn("Unable to compute style diff:",e),o=[{command:operations.setStyle,args:[r]}]}return o}var isEqual=require("lodash.isequal"),operations={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};module.exports=diffStyles,module.exports.operations=operations;
	},{"lodash.isequal":157}],164:[function(require,module,exports){
	"use strict";function ValidationError(r,i){this.message=(r?r+": ":"")+format.apply(format,Array.prototype.slice.call(arguments,2)),null!==i&&void 0!==i&&i.__line__&&(this.line=i.__line__)}var format=require("util").format;module.exports=ValidationError;
	},{"util":203}],165:[function(require,module,exports){
	"use strict";function key(r){return stringify(refProperties.map(function(e){return r[e]}))}function groupByLayout(r){var e,t,i={};for(e=0;e<r.length;e++){t=key(r[e]);var u=i[t];u||(u=i[t]=[]),u.push(r[e])}var n=[];for(t in i)n.push(i[t]);return n}var refProperties=require("./util/ref_properties"),stringify=require("fast-stable-stringify");module.exports=groupByLayout;
	},{"./util/ref_properties":168,"fast-stable-stringify":134}],166:[function(require,module,exports){
	"use strict";module.exports=function(r){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var n in e)r[n]=e[n]}return r};
	},{}],167:[function(require,module,exports){
	"use strict";module.exports=function(n){return n instanceof Number?"number":n instanceof String?"string":n instanceof Boolean?"boolean":Array.isArray(n)?"array":null===n?"null":typeof n};
	},{}],168:[function(require,module,exports){
	"use strict";module.exports=["type","source","source-layer","minzoom","maxzoom","filter","layout"];
	},{}],169:[function(require,module,exports){
	"use strict";module.exports=function(n){return n instanceof Number||n instanceof String||n instanceof Boolean?n.valueOf():n};
	},{}],170:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),getType=require("../util/get_type"),extend=require("../util/extend");module.exports=function(e){var r=require("./validate_function"),t=require("./validate_object"),i={"*":function(){return[]},array:require("./validate_array"),boolean:require("./validate_boolean"),number:require("./validate_number"),color:require("./validate_color"),constants:require("./validate_constants"),enum:require("./validate_enum"),filter:require("./validate_filter"),function:require("./validate_function"),layer:require("./validate_layer"),object:require("./validate_object"),source:require("./validate_source"),light:require("./validate_light"),string:require("./validate_string")},a=e.value,n=e.valueSpec,u=e.key,o=e.styleSpec,l=e.style;if("string"===getType(a)&&"@"===a[0]){if(o.$version>7)return[new ValidationError(u,a,"constants have been deprecated as of v8")];if(!(a in l.constants))return[new ValidationError(u,a,'constant "%s" not found',a)];e=extend({},e,{value:l.constants[a]})}return n.function&&"object"===getType(a)?r(e):n.type&&i[n.type]?i[n.type](e):t(extend({},e,{valueSpec:n.type?o[n.type]:n}))};
	},{"../error/validation_error":164,"../util/extend":166,"../util/get_type":167,"./validate_array":171,"./validate_boolean":172,"./validate_color":173,"./validate_constants":174,"./validate_enum":175,"./validate_filter":176,"./validate_function":177,"./validate_layer":179,"./validate_light":181,"./validate_number":182,"./validate_object":183,"./validate_source":185,"./validate_string":186}],171:[function(require,module,exports){
	"use strict";var getType=require("../util/get_type"),validate=require("./validate"),ValidationError=require("../error/validation_error");module.exports=function(e){var r=e.value,t=e.valueSpec,a=e.style,n=e.styleSpec,l=e.key,i=e.arrayElementValidator||validate;if("array"!==getType(r))return[new ValidationError(l,r,"array expected, %s found",getType(r))];if(t.length&&r.length!==t.length)return[new ValidationError(l,r,"array length %d expected, length %d found",t.length,r.length)];if(t["min-length"]&&r.length<t["min-length"])return[new ValidationError(l,r,"array length at least %d expected, length %d found",t["min-length"],r.length)];var o={type:t.value};n.$version<7&&(o.function=t.function),"object"===getType(t.value)&&(o=t.value);for(var u=[],d=0;d<r.length;d++)u=u.concat(i({array:r,arrayIndex:d,value:r[d],valueSpec:o,style:a,styleSpec:n,key:l+"["+d+"]"}));return u};
	},{"../error/validation_error":164,"../util/get_type":167,"./validate":170}],172:[function(require,module,exports){
	"use strict";var getType=require("../util/get_type"),ValidationError=require("../error/validation_error");module.exports=function(e){var r=e.value,o=e.key,t=getType(r);return"boolean"!==t?[new ValidationError(o,r,"boolean expected, %s found",t)]:[]};
	},{"../error/validation_error":164,"../util/get_type":167}],173:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),getType=require("../util/get_type"),parseCSSColor=require("csscolorparser").parseCSSColor;module.exports=function(r){var e=r.key,o=r.value,t=getType(o);return"string"!==t?[new ValidationError(e,o,"color expected, %s found",t)]:null===parseCSSColor(o)?[new ValidationError(e,o,'color expected, "%s" found',o)]:[]};
	},{"../error/validation_error":164,"../util/get_type":167,"csscolorparser":132}],174:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),getType=require("../util/get_type");module.exports=function(r){var e=r.key,t=r.value,a=r.styleSpec;if(a.$version>7)return t?[new ValidationError(e,t,"constants have been deprecated as of v8")]:[];var o=getType(t);if("object"!==o)return[new ValidationError(e,t,"object expected, %s found",o)];var n=[];for(var i in t)"@"!==i[0]&&n.push(new ValidationError(e+"."+i,t[i],'constants must start with "@"'));return n};
	},{"../error/validation_error":164,"../util/get_type":167}],175:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),unbundle=require("../util/unbundle_jsonlint");module.exports=function(e){var r=e.key,n=e.value,u=e.valueSpec,o=[];return Array.isArray(u.values)?u.values.indexOf(unbundle(n))===-1&&o.push(new ValidationError(r,n,"expected one of [%s], %s found",u.values.join(", "),n)):Object.keys(u.values).indexOf(unbundle(n))===-1&&o.push(new ValidationError(r,n,"expected one of [%s], %s found",Object.keys(u.values).join(", "),n)),o};
	},{"../error/validation_error":164,"../util/unbundle_jsonlint":169}],176:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),validateEnum=require("./validate_enum"),getType=require("../util/get_type"),unbundle=require("../util/unbundle_jsonlint");module.exports=function e(t){var r,a=t.value,n=t.key,l=t.styleSpec,s=[];if("array"!==getType(a))return[new ValidationError(n,a,"array expected, %s found",getType(a))];if(a.length<1)return[new ValidationError(n,a,"filter array must have at least 1 element")];switch(s=s.concat(validateEnum({key:n+"[0]",value:a[0],valueSpec:l.filter_operator,style:t.style,styleSpec:t.styleSpec})),unbundle(a[0])){case"<":case"<=":case">":case">=":a.length>=2&&"$type"==a[1]&&s.push(new ValidationError(n,a,'"$type" cannot be use with operator "%s"',a[0]));case"==":case"!=":3!=a.length&&s.push(new ValidationError(n,a,'filter array for operator "%s" must have 3 elements',a[0]));case"in":case"!in":a.length>=2&&(r=getType(a[1]),"string"!==r?s.push(new ValidationError(n+"[1]",a[1],"string expected, %s found",r)):"@"===a[1][0]&&s.push(new ValidationError(n+"[1]",a[1],"filter key cannot be a constant")));for(var o=2;o<a.length;o++)r=getType(a[o]),"$type"==a[1]?s=s.concat(validateEnum({key:n+"["+o+"]",value:a[o],valueSpec:l.geometry_type,style:t.style,styleSpec:t.styleSpec})):"string"===r&&"@"===a[o][0]?s.push(new ValidationError(n+"["+o+"]",a[o],"filter value cannot be a constant")):"string"!==r&&"number"!==r&&"boolean"!==r&&s.push(new ValidationError(n+"["+o+"]",a[o],"string, number, or boolean expected, %s found",r));break;case"any":case"all":case"none":for(o=1;o<a.length;o++)s=s.concat(e({key:n+"["+o+"]",value:a[o],style:t.style,styleSpec:t.styleSpec}));break;case"has":case"!has":r=getType(a[1]),2!==a.length?s.push(new ValidationError(n,a,'filter array for "%s" operator must have 2 elements',a[0])):"string"!==r?s.push(new ValidationError(n+"[1]",a[1],"string expected, %s found",r)):"@"===a[1][0]&&s.push(new ValidationError(n+"[1]",a[1],"filter key cannot be a constant"))}return s};
	},{"../error/validation_error":164,"../util/get_type":167,"../util/unbundle_jsonlint":169,"./validate_enum":175}],177:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),getType=require("../util/get_type"),validate=require("./validate"),validateObject=require("./validate_object"),validateArray=require("./validate_array"),validateNumber=require("./validate_number"),unbundle=require("../util/unbundle_jsonlint");module.exports=function(e){function t(e){if("identity"===l)return[new ValidationError(e.key,e.value,'identity function may not have a "stops" property')];var t=[],a=e.value;return t=t.concat(validateArray({key:e.key,value:a,valueSpec:e.valueSpec,style:e.style,styleSpec:e.styleSpec,arrayElementValidator:r})),"array"===getType(a)&&0===a.length&&t.push(new ValidationError(e.key,a,"array must have at least one stop")),t}function r(e){var t=[],r=e.value,o=e.key;if("array"!==getType(r))return[new ValidationError(o,r,"array expected, %s found",getType(r))];if(2!==r.length)return[new ValidationError(o,r,"array length %d expected, length %d found",2,r.length)];if(s){if("object"!==getType(r[0]))return[new ValidationError(o,r,"object expected, %s found",getType(r[0]))];if(void 0===r[0].zoom)return[new ValidationError(o,r,"object stop key must have zoom")];if(void 0===r[0].value)return[new ValidationError(o,r,"object stop key must have value")];t=t.concat(validateObject({key:o+"[0]",value:r[0],valueSpec:{zoom:{}},style:e.style,styleSpec:e.styleSpec,objectElementValidators:{zoom:validateNumber,value:a}}))}else t=t.concat((i?validateNumber:a)({key:o+"[0]",value:r[0],valueSpec:{},style:e.style,styleSpec:e.styleSpec}));return t=t.concat(validate({key:o+"[1]",value:r[1],valueSpec:n,style:e.style,styleSpec:e.styleSpec})),"number"===getType(r[0])&&("piecewise-constant"===n.function&&r[0]%1!==0&&t.push(new ValidationError(o+"[0]",r[0],"zoom level for piecewise-constant functions must be an integer")),0!==e.arrayIndex&&r[0]<e.array[e.arrayIndex-1][0]&&t.push(new ValidationError(o+"[0]",r[0],"array stops must appear in ascending order"))),t}function a(e){var t=getType(e.value);if(o){if(t!==o)return[new ValidationError(e.key,e.value,"%s stop domain type must match previous stop domain type %s",t,o)]}else o=t,l||"string"!==t||(l="categorical");return"number"!==t&&"string"!==t?[new ValidationError(e.key,e.value,"property value must be a number or string")]:"number"!==t&&"categorical"!==l?[new ValidationError(e.key,e.value,"number expected, %s found",t)]:[]}var o,n=e.valueSpec,l=unbundle(e.value.type),i=void 0===e.value.property,u=void 0!==e.value.property,s="array"===getType(e.value.stops)&&"array"===getType(e.value.stops[0])&&"object"===getType(e.value.stops[0][0]),p=validateObject({key:e.key,value:e.value,valueSpec:e.styleSpec.function,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{stops:t}});return"identity"===l||e.value.stops||p.push(new ValidationError(e.key,e.value,'missing required property "stops"')),e.styleSpec.$version>=8&&(u&&!e.valueSpec["property-function"]?p.push(new ValidationError(e.key,e.value,"property functions not supported")):i&&!e.valueSpec["zoom-function"]&&p.push(new ValidationError(e.key,e.value,"zoom functions not supported"))),p};
	},{"../error/validation_error":164,"../util/get_type":167,"../util/unbundle_jsonlint":169,"./validate":170,"./validate_array":171,"./validate_number":182,"./validate_object":183}],178:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),validateString=require("./validate_string");module.exports=function(r){var e=r.value,t=r.key,a=validateString(r);return a.length?a:(e.indexOf("{fontstack}")===-1&&a.push(new ValidationError(t,e,'"glyphs" url must include a "{fontstack}" token')),e.indexOf("{range}")===-1&&a.push(new ValidationError(t,e,'"glyphs" url must include a "{range}" token')),a)};
	},{"../error/validation_error":164,"./validate_string":186}],179:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),unbundle=require("../util/unbundle_jsonlint"),validateObject=require("./validate_object"),validateFilter=require("./validate_filter"),validatePaintProperty=require("./validate_paint_property"),validateLayoutProperty=require("./validate_layout_property"),extend=require("../util/extend");module.exports=function(e){var r=[],t=e.value,a=e.key,i=e.style,l=e.styleSpec;t.type||t.ref||r.push(new ValidationError(a,t,'either "type" or "ref" is required'));var o=unbundle(t.type),u=unbundle(t.ref);if(t.id)for(var n=0;n<e.arrayIndex;n++){var s=i.layers[n];unbundle(s.id)===unbundle(t.id)&&r.push(new ValidationError(a,t.id,'duplicate layer id "%s", previously used at line %d',t.id,s.id.__line__))}if("ref"in t){["type","source","source-layer","filter","layout"].forEach(function(e){e in t&&r.push(new ValidationError(a,t[e],'"%s" is prohibited for ref layers',e))});var d;i.layers.forEach(function(e){e.id==u&&(d=e)}),d?d.ref?r.push(new ValidationError(a,t.ref,"ref cannot reference another ref layer")):o=unbundle(d.type):r.push(new ValidationError(a,t.ref,'ref layer "%s" not found',u))}else if("background"!==o)if(t.source){var y=i.sources&&i.sources[t.source];y?"vector"==y.type&&"raster"==o?r.push(new ValidationError(a,t.source,'layer "%s" requires a raster source',t.id)):"raster"==y.type&&"raster"!=o?r.push(new ValidationError(a,t.source,'layer "%s" requires a vector source',t.id)):"vector"!=y.type||t["source-layer"]||r.push(new ValidationError(a,t,'layer "%s" must specify a "source-layer"',t.id)):r.push(new ValidationError(a,t.source,'source "%s" not found',t.source))}else r.push(new ValidationError(a,t,'missing required property "source"'));return r=r.concat(validateObject({key:a,value:t,valueSpec:l.layer,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{"*":function(){return[]},filter:validateFilter,layout:function(e){return validateObject({layer:t,key:e.key,value:e.value,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{"*":function(e){return validateLayoutProperty(extend({layerType:o},e))}}})},paint:function(e){return validateObject({layer:t,key:e.key,value:e.value,style:e.style,styleSpec:e.styleSpec,objectElementValidators:{"*":function(e){return validatePaintProperty(extend({layerType:o},e))}}})}}}))};
	},{"../error/validation_error":164,"../util/extend":166,"../util/unbundle_jsonlint":169,"./validate_filter":176,"./validate_layout_property":180,"./validate_object":183,"./validate_paint_property":184}],180:[function(require,module,exports){
	"use strict";var validate=require("./validate"),ValidationError=require("../error/validation_error");module.exports=function(e){var r=e.key,t=e.style,a=e.styleSpec,i=e.value,l=e.objectKey,o=a["layout_"+e.layerType];if(!o)return[];if(e.valueSpec||o[l]){var s=[];return"symbol"===e.layerType&&("icon-image"===l&&t&&!t.sprite?s.push(new ValidationError(r,i,'use of "icon-image" requires a style "sprite" property')):"text-field"===l&&t&&!t.glyphs&&s.push(new ValidationError(r,i,'use of "text-field" requires a style "glyphs" property'))),s.concat(validate({key:e.key,value:i,valueSpec:e.valueSpec||o[l],style:t,styleSpec:a}))}return[new ValidationError(r,i,'unknown property "%s"',l)]};
	},{"../error/validation_error":164,"./validate":170}],181:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),getType=require("../util/get_type"),validate=require("./validate");module.exports=function(e){var t=e.value,r=e.styleSpec,a=r.light,i=e.style,n=[],o=getType(t);if(void 0===t)return n;if("object"!==o)return n=n.concat([new ValidationError("light",t,"object expected, %s found",o)]);for(var l in t){var c=l.match(/^(.*)-transition$/);n=c&&a[c[1]]&&a[c[1]].transition?n.concat(validate({key:l,value:t[l],valueSpec:r.transition,style:i,styleSpec:r})):a[l]?n.concat(validate({key:l,value:t[l],valueSpec:a[l],style:i,styleSpec:r})):n.concat([new ValidationError(l,t[l],'unknown property "%s"',l)])}return n};
	},{"../error/validation_error":164,"../util/get_type":167,"./validate":170}],182:[function(require,module,exports){
	"use strict";var getType=require("../util/get_type"),ValidationError=require("../error/validation_error");module.exports=function(e){var r=e.key,i=e.value,m=e.valueSpec,a=getType(i);return"number"!==a?[new ValidationError(r,i,"number expected, %s found",a)]:"minimum"in m&&i<m.minimum?[new ValidationError(r,i,"%s is less than the minimum value %s",i,m.minimum)]:"maximum"in m&&i>m.maximum?[new ValidationError(r,i,"%s is greater than the maximum value %s",i,m.maximum)]:[]};
	},{"../error/validation_error":164,"../util/get_type":167}],183:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),getType=require("../util/get_type"),validateSpec=require("./validate");module.exports=function(e){var r=e.key,t=e.value,i=e.valueSpec||{},a=e.objectElementValidators||{},o=e.style,l=e.styleSpec,n=[],u=getType(t);if("object"!==u)return[new ValidationError(r,t,"object expected, %s found",u)];for(var p in t){var s,c=p.split(".")[0],d=i[c]||i["*"];if(a[c])s=a[c];else if(i[c])s=validateSpec;else if(a["*"])s=a["*"];else{if(!i["*"]){n.push(new ValidationError(r,t[p],'unknown property "%s"',p));continue}s=validateSpec}n=n.concat(s({key:(r?r+".":r)+p,value:t[p],valueSpec:d,style:o,styleSpec:l,object:t,objectKey:p}))}for(c in i)i[c].required&&void 0===i[c].default&&void 0===t[c]&&n.push(new ValidationError(r,t,'missing required property "%s"',c));return n};
	},{"../error/validation_error":164,"../util/get_type":167,"./validate":170}],184:[function(require,module,exports){
	"use strict";var validate=require("./validate"),ValidationError=require("../error/validation_error");module.exports=function(e){var r=e.key,a=e.style,t=e.styleSpec,i=e.value,l=e.objectKey,n=t["paint_"+e.layerType];if(!n)return[];var o=l.match(/^(.*)-transition$/);return o&&n[o[1]]&&n[o[1]].transition?validate({key:r,value:i,valueSpec:t.transition,style:a,styleSpec:t}):e.valueSpec||n[l]?validate({key:e.key,value:i,valueSpec:e.valueSpec||n[l],style:a,styleSpec:t}):[new ValidationError(r,i,'unknown property "%s"',l)]};
	},{"../error/validation_error":164,"./validate":170}],185:[function(require,module,exports){
	"use strict";var ValidationError=require("../error/validation_error"),unbundle=require("../util/unbundle_jsonlint"),validateObject=require("./validate_object"),validateEnum=require("./validate_enum");module.exports=function(e){var r=e.value,t=e.key,a=e.styleSpec,l=e.style;if(!r.type)return[new ValidationError(t,r,'"type" is required')];var u=unbundle(r.type);switch(u){case"vector":case"raster":var i=[];if(i=i.concat(validateObject({key:t,value:r,valueSpec:a.source_tile,style:e.style,styleSpec:a})),"url"in r)for(var s in r)["type","url","tileSize"].indexOf(s)<0&&i.push(new ValidationError(t+"."+s,r[s],'a source with a "url" property may not include a "%s" property',s));return i;case"geojson":return validateObject({key:t,value:r,valueSpec:a.source_geojson,style:l,styleSpec:a});case"video":return validateObject({key:t,value:r,valueSpec:a.source_video,style:l,styleSpec:a});case"image":return validateObject({key:t,value:r,valueSpec:a.source_image,style:l,styleSpec:a});default:return validateEnum({key:t+".type",value:r.type,valueSpec:{values:["vector","raster","geojson","video","image"]},style:l,styleSpec:a})}};
	},{"../error/validation_error":164,"../util/unbundle_jsonlint":169,"./validate_enum":175,"./validate_object":183}],186:[function(require,module,exports){
	"use strict";var getType=require("../util/get_type"),ValidationError=require("../error/validation_error");module.exports=function(r){var e=r.value,t=r.key,i=getType(e);return"string"!==i?[new ValidationError(t,e,"string expected, %s found",i)]:[]};
	},{"../error/validation_error":164,"../util/get_type":167}],187:[function(require,module,exports){
	"use strict";function validateStyleMin(e,a){a=a||latestStyleSpec;var t=[];return t=t.concat(validate({key:"",value:e,valueSpec:a.$root,styleSpec:a,style:e,objectElementValidators:{glyphs:validateGlyphsURL,"*":function(){return[]}}})),a.$version>7&&e.constants&&(t=t.concat(validateConstants({key:"constants",value:e.constants,style:e,styleSpec:a}))),sortErrors(t)}function sortErrors(e){return[].concat(e).sort(function(e,a){return e.line-a.line})}function wrapCleanErrors(e){return function(){return sortErrors(e.apply(this,arguments))}}var validateConstants=require("./validate/validate_constants"),validate=require("./validate/validate"),latestStyleSpec=require("../reference/latest.min"),validateGlyphsURL=require("./validate/validate_glyphs_url");validateStyleMin.source=wrapCleanErrors(require("./validate/validate_source")),validateStyleMin.light=wrapCleanErrors(require("./validate/validate_light")),validateStyleMin.layer=wrapCleanErrors(require("./validate/validate_layer")),validateStyleMin.filter=wrapCleanErrors(require("./validate/validate_filter")),validateStyleMin.paintProperty=wrapCleanErrors(require("./validate/validate_paint_property")),validateStyleMin.layoutProperty=wrapCleanErrors(require("./validate/validate_layout_property")),module.exports=validateStyleMin;
	},{"../reference/latest.min":188,"./validate/validate":170,"./validate/validate_constants":174,"./validate/validate_filter":176,"./validate/validate_glyphs_url":178,"./validate/validate_layer":179,"./validate/validate_layout_property":180,"./validate/validate_light":181,"./validate/validate_paint_property":184,"./validate/validate_source":185}],188:[function(require,module,exports){
	module.exports=require("./v8.min.json");
	},{"./v8.min.json":189}],189:[function(require,module,exports){
	module.exports={"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360,"units":"degrees"},"pitch":{"type":"number","default":0,"units":"degrees"},"light":{"type":"light"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string"},"transition":{"type":"transition"},"layers":{"required":true,"type":"array","value":"layer"}},"sources":{"*":{"type":"source"}},"source":["source_tile","source_geojson","source_video","source_image"],"source_tile":{"type":{"required":true,"type":"enum","values":{"vector":{},"raster":{}}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512,"units":"pixels"},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":{}}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":{}}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":{}}},"url":{"required":true,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"fill-extrusion":{},"raster":{},"background":{}}},"metadata":{"type":"*"},"ref":{"type":"string"},"source":{"type":"string"},"source-layer":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"},"paint.*":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_fill-extrusion","layout_symbol","layout_raster","layout_background"],"layout_background":{"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"layout_fill":{"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"layout_circle":{"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"layout_fill-extrusion":{"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"layout_line":{"line-cap":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"butt":{},"round":{},"square":{}},"default":"butt"},"line-join":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"bevel":{},"round":{},"miter":{}},"default":"miter"},"line-miter-limit":{"type":"number","default":2,"function":"interpolated","zoom-function":true,"property-function":true,"requires":[{"line-join":"miter"}]},"line-round-limit":{"type":"number","default":1.05,"function":"interpolated","zoom-function":true,"property-function":true,"requires":[{"line-join":"round"}]},"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"layout_symbol":{"symbol-placement":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"point":{},"line":{}},"default":"point"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"function":"interpolated","zoom-function":true,"property-function":true,"units":"pixels","requires":[{"symbol-placement":"line"}]},"symbol-avoid-edges":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false},"icon-allow-overlap":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["icon-image"]},"icon-ignore-placement":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["icon-image"]},"icon-optional":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["icon-image","text-field"]},"icon-rotation-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["icon-image"]},"icon-size":{"type":"number","default":1,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"requires":["icon-image"]},"icon-text-fit":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":false,"values":{"none":{},"width":{},"height":{},"both":{}},"default":"none","requires":["icon-image","text-field"]},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"units":"pixels","function":"interpolated","zoom-function":true,"property-function":true,"requires":["icon-image","text-field",{"icon-text-fit":["both","width","height"]}]},"icon-image":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"tokens":true},"icon-rotate":{"type":"number","default":0,"period":360,"function":"interpolated","zoom-function":true,"property-function":true,"units":"degrees","requires":["icon-image"]},"icon-padding":{"type":"number","default":2,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"units":"pixels","requires":["icon-image"]},"icon-keep-upright":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":"line"}]},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"requires":["icon-image"]},"text-pitch-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"]},"text-rotation-alignment":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{},"auto":{}},"default":"auto","requires":["text-field"]},"text-field":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":"","tokens":true},"text-font":{"type":"array","value":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":["Open Sans Regular","Arial Unicode MS Regular"],"requires":["text-field"]},"text-size":{"type":"number","default":16,"minimum":0,"units":"pixels","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-max-width":{"type":"number","default":10,"minimum":0,"units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-line-height":{"type":"number","default":1.2,"units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-letter-spacing":{"type":"number","default":0,"units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-justify":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"left":{},"center":{},"right":{}},"default":"center","requires":["text-field"]},"text-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"center":{},"left":{},"right":{},"top":{},"bottom":{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},"default":"center","requires":["text-field"]},"text-max-angle":{"type":"number","default":45,"units":"degrees","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field",{"symbol-placement":"line"}]},"text-rotate":{"type":"number","default":0,"period":360,"units":"degrees","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-padding":{"type":"number","default":2,"minimum":0,"units":"pixels","function":"interpolated","zoom-function":true,"property-function":true,"requires":["text-field"]},"text-keep-upright":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":true,"requires":["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":"line"}]},"text-transform":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"none":{},"uppercase":{},"lowercase":{}},"default":"none","requires":["text-field"]},"text-offset":{"type":"array","value":"number","units":"ems","function":"interpolated","zoom-function":true,"property-function":true,"length":2,"default":[0,0],"requires":["text-field"]},"text-allow-overlap":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["text-field"]},"text-ignore-placement":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["text-field"]},"text-optional":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":false,"requires":["text-field","icon-image"]},"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"layout_raster":{"visibility":{"type":"enum","function":"piecewise-constant","zoom-function":true,"values":{"visible":{},"none":{}},"default":"visible"}},"filter":{"type":"array","value":"*"},"filter_operator":{"type":"enum","values":{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},"in":{},"!in":{},"all":{},"any":{},"none":{},"has":{},"!has":{}}},"geometry_type":{"type":"enum","values":{"Point":{},"LineString":{},"Polygon":{}}},"function":{"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":{},"exponential":{},"interval":{},"categorical":{}},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":{},"lab":{},"hcl":{}},"default":"rgb"}},"function_stop":{"type":"array","minimum":0,"maximum":22,"value":["number","color"],"length":2},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":{},"viewport":{}},"transition":false},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"function":"interpolated","zoom-function":true,"property-function":false},"color":{"type":"color","default":"#ffffff","function":"interpolated","zoom-function":true,"property-function":false,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":false,"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_fill-extrusion","paint_symbol","paint_raster","paint_background"],"paint_fill":{"fill-antialias":{"type":"boolean","function":"piecewise-constant","zoom-function":true,"property-function":true,"default":true},"fill-opacity":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":1,"minimum":0,"maximum":1,"transition":true},"fill-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"fill-pattern"}]},"fill-outline-color":{"type":"color","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"fill-pattern"},{"fill-antialias":true}]},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"fill-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["fill-translate"]},"fill-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"transition":true}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","function":"interpolated","zoom-function":true,"property-function":false,"default":1,"minimum":0,"maximum":1,"transition":true},"fill-extrusion-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"fill-pattern"}]},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":false,"transition":true,"units":"pixels"},"fill-extrusion-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":false,"values":{"map":{},"viewport":{}},"default":"map","requires":["fill-extrusion-translate"]},"fill-extrusion-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":false,"transition":true},"fill-extrusion-height":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":0,"minimum":0,"units":"meters","transition":true},"fill-extrusion-base":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":0,"minimum":0,"units":"meters","transition":true,"requires":[{"<=":"fill-extrusion-height"}]}},"paint_line":{"line-opacity":{"type":"number","function":"interpolated","zoom-function":true,"property-function":true,"default":1,"minimum":0,"maximum":1,"transition":true},"line-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":[{"!":"line-pattern"}]},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["line-translate"]},"line-width":{"type":"number","default":1,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-gap-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-offset":{"type":"number","default":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-blur":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"line-dasharray":{"type":"array","value":"number","function":"piecewise-constant","zoom-function":true,"property-function":true,"minimum":0,"transition":true,"units":"line widths","requires":[{"!":"line-pattern"}]},"line-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"property-function":true,"transition":true}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"circle-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-blur":{"type":"number","default":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"circle-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["circle-translate"]},"circle-pitch-scale":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{}},"default":"map"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels"},"circle-stroke-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["icon-image"]},"icon-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["icon-image"]},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["icon-image"]},"icon-halo-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["icon-image"]},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["icon-image"]},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["icon-image"]},"icon-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["icon-image","icon-translate"]},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["text-field"]},"text-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["text-field"]},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"requires":["text-field"]},"text-halo-width":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["text-field"]},"text-halo-blur":{"type":"number","default":0,"minimum":0,"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["text-field"]},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"function":"interpolated","zoom-function":true,"property-function":true,"transition":true,"units":"pixels","requires":["text-field"]},"text-translate-anchor":{"type":"enum","function":"piecewise-constant","zoom-function":true,"property-function":true,"values":{"map":{},"viewport":{}},"default":"map","requires":["text-field","text-translate"]}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"raster-hue-rotate":{"type":"number","default":0,"period":360,"function":"interpolated","zoom-function":true,"transition":true,"units":"degrees"},"raster-brightness-min":{"type":"number","function":"interpolated","zoom-function":true,"default":0,"minimum":0,"maximum":1,"transition":true},"raster-brightness-max":{"type":"number","function":"interpolated","zoom-function":true,"default":1,"minimum":0,"maximum":1,"transition":true},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"function":"interpolated","zoom-function":true,"transition":true,"units":"milliseconds"}},"paint_background":{"background-color":{"type":"color","default":"#000000","function":"interpolated","zoom-function":true,"transition":true,"requires":[{"!":"background-pattern"}]},"background-pattern":{"type":"string","function":"piecewise-constant","zoom-function":true,"transition":true},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"function":"interpolated","zoom-function":true,"transition":true}},"transition":{"duration":{"type":"number","default":300,"minimum":0,"units":"milliseconds"},"delay":{"type":"number","default":0,"minimum":0,"units":"milliseconds"}}}
	},{}],190:[function(require,module,exports){
	"use strict";function isSupported(e){return!!(isBrowser()&&isArraySupported()&&isFunctionSupported()&&isObjectSupported()&&isJSONSupported()&&isWorkerSupported()&&isUint8ClampedArraySupported()&&isWebGLSupportedCached(e&&e.failIfMajorPerformanceCaveat))}function isBrowser(){return"undefined"!=typeof window&&"undefined"!=typeof document}function isArraySupported(){return Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray}function isFunctionSupported(){return Function.prototype&&Function.prototype.bind}function isObjectSupported(){return Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions}function isJSONSupported(){return"JSON"in window&&"parse"in JSON&&"stringify"in JSON}function isWorkerSupported(){return"Worker"in window}function isUint8ClampedArraySupported(){return"Uint8ClampedArray"in window}function isWebGLSupportedCached(e){return void 0===isWebGLSupportedCache[e]&&(isWebGLSupportedCache[e]=isWebGLSupported(e)),isWebGLSupportedCache[e]}function isWebGLSupported(e){var t=document.createElement("canvas"),r=Object.create(isSupported.webGLContextAttributes);return r.failIfMajorPerformanceCaveat=e,t.probablySupportsContext?t.probablySupportsContext("webgl",r)||t.probablySupportsContext("experimental-webgl",r):t.supportsContext?t.supportsContext("webgl",r)||t.supportsContext("experimental-webgl",r):t.getContext("webgl",r)||t.getContext("experimental-webgl",r)}"undefined"!=typeof module&&module.exports?module.exports=isSupported:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=isSupported);var isWebGLSupportedCache={};isSupported.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};
	},{}],191:[function(require,module,exports){
	(function (process){
	function normalizeArray(r,t){for(var e=0,n=r.length-1;n>=0;n--){var s=r[n];"."===s?r.splice(n,1):".."===s?(r.splice(n,1),e++):e&&(r.splice(n,1),e--)}if(t)for(;e--;e)r.unshift("..");return r}function filter(r,t){if(r.filter)return r.filter(t);for(var e=[],n=0;n<r.length;n++)t(r[n],n,r)&&e.push(r[n]);return e}var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,splitPath=function(r){return splitPathRe.exec(r).slice(1)};exports.resolve=function(){for(var r="",t=!1,e=arguments.length-1;e>=-1&&!t;e--){var n=e>=0?arguments[e]:process.cwd();if("string"!=typeof n)throw new TypeError("Arguments to path.resolve must be strings");n&&(r=n+"/"+r,t="/"===n.charAt(0))}return r=normalizeArray(filter(r.split("/"),function(r){return!!r}),!t).join("/"),(t?"/":"")+r||"."},exports.normalize=function(r){var t=exports.isAbsolute(r),e="/"===substr(r,-1);return r=normalizeArray(filter(r.split("/"),function(r){return!!r}),!t).join("/"),r||t||(r="."),r&&e&&(r+="/"),(t?"/":"")+r},exports.isAbsolute=function(r){return"/"===r.charAt(0)},exports.join=function(){var r=Array.prototype.slice.call(arguments,0);return exports.normalize(filter(r,function(r,t){if("string"!=typeof r)throw new TypeError("Arguments to path.join must be strings");return r}).join("/"))},exports.relative=function(r,t){function e(r){for(var t=0;t<r.length&&""===r[t];t++);for(var e=r.length-1;e>=0&&""===r[e];e--);return t>e?[]:r.slice(t,e-t+1)}r=exports.resolve(r).substr(1),t=exports.resolve(t).substr(1);for(var n=e(r.split("/")),s=e(t.split("/")),i=Math.min(n.length,s.length),o=i,u=0;u<i;u++)if(n[u]!==s[u]){o=u;break}for(var l=[],u=o;u<n.length;u++)l.push("..");return l=l.concat(s.slice(o)),l.join("/")},exports.sep="/",exports.delimiter=":",exports.dirname=function(r){var t=splitPath(r),e=t[0],n=t[1];return e||n?(n&&(n=n.substr(0,n.length-1)),e+n):"."},exports.basename=function(r,t){var e=splitPath(r)[2];return t&&e.substr(-1*t.length)===t&&(e=e.substr(0,e.length-t.length)),e},exports.extname=function(r){return splitPath(r)[3]};var substr="b"==="ab".substr(-1)?function(r,t,e){return r.substr(t,e)}:function(r,t,e){return t<0&&(t=r.length+t),r.substr(t,e)};
	}).call(this,require('_process'))
	
	},{"_process":195}],192:[function(require,module,exports){
	"use strict";function Buffer(t){var e;t&&t.length&&(e=t,t=e.length);var r=new Uint8Array(t||0);return e&&r.set(e),r.readUInt32LE=BufferMethods.readUInt32LE,r.writeUInt32LE=BufferMethods.writeUInt32LE,r.readInt32LE=BufferMethods.readInt32LE,r.writeInt32LE=BufferMethods.writeInt32LE,r.readFloatLE=BufferMethods.readFloatLE,r.writeFloatLE=BufferMethods.writeFloatLE,r.readDoubleLE=BufferMethods.readDoubleLE,r.writeDoubleLE=BufferMethods.writeDoubleLE,r.toString=BufferMethods.toString,r.write=BufferMethods.write,r.slice=BufferMethods.slice,r.copy=BufferMethods.copy,r._isBuffer=!0,r}function encodeString(t){for(var e,r,n=t.length,i=[],o=0;o<n;o++){if(e=t.charCodeAt(o),e>55295&&e<57344){if(!r){e>56319||o+1===n?i.push(239,191,189):r=e;continue}if(e<56320){i.push(239,191,189),r=e;continue}e=r-55296<<10|e-56320|65536,r=null}else r&&(i.push(239,191,189),r=null);e<128?i.push(e):e<2048?i.push(e>>6|192,63&e|128):e<65536?i.push(e>>12|224,e>>6&63|128,63&e|128):i.push(e>>18|240,e>>12&63|128,e>>6&63|128,63&e|128)}return i}module.exports=Buffer;var ieee754=require("ieee754"),BufferMethods,lastStr,lastStrEncoded;BufferMethods={readUInt32LE:function(t){return(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},writeUInt32LE:function(t,e){this[e]=t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24},readInt32LE:function(t){return(this[t]|this[t+1]<<8|this[t+2]<<16)+(this[t+3]<<24)},readFloatLE:function(t){return ieee754.read(this,t,!0,23,4)},readDoubleLE:function(t){return ieee754.read(this,t,!0,52,8)},writeFloatLE:function(t,e){return ieee754.write(this,t,e,!0,23,4)},writeDoubleLE:function(t,e){return ieee754.write(this,t,e,!0,52,8)},toString:function(t,e,r){var n="",i="";e=e||0,r=Math.min(this.length,r||this.length);for(var o=e;o<r;o++){var u=this[o];u<=127?(n+=decodeURIComponent(i)+String.fromCharCode(u),i=""):i+="%"+u.toString(16)}return n+=decodeURIComponent(i)},write:function(t,e){for(var r=t===lastStr?lastStrEncoded:encodeString(t),n=0;n<r.length;n++)this[e+n]=r[n]},slice:function(t,e){return this.subarray(t,e)},copy:function(t,e){e=e||0;for(var r=0;r<this.length;r++)t[e+r]=this[r]}},BufferMethods.writeInt32LE=BufferMethods.writeUInt32LE,Buffer.byteLength=function(t){return lastStr=t,lastStrEncoded=encodeString(t),lastStrEncoded.length},Buffer.isBuffer=function(t){return!(!t||!t._isBuffer)};
	},{"ieee754":147}],193:[function(require,module,exports){
	(function (global){
	"use strict";function Pbf(t){this.buf=Buffer.isBuffer(t)?t:new Buffer(t||0),this.pos=0,this.length=this.buf.length}function readVarintRemainder(t,i){var e,r=i.buf;if(e=r[i.pos++],t+=268435456*(127&e),e<128)return t;if(e=r[i.pos++],t+=34359738368*(127&e),e<128)return t;if(e=r[i.pos++],t+=4398046511104*(127&e),e<128)return t;if(e=r[i.pos++],t+=562949953421312*(127&e),e<128)return t;if(e=r[i.pos++],t+=72057594037927940*(127&e),e<128)return t;if(e=r[i.pos++],t+=0x8000000000000000*(127&e),e<128)return t;throw new Error("Expected varint not more than 10 bytes")}function writeBigVarint(t,i){i.realloc(10);for(var e=i.pos+10;t>=1;){if(i.pos>=e)throw new Error("Given varint doesn't fit into 10 bytes");var r=255&t;i.buf[i.pos++]=r|(t>=128?128:0),t/=128}}function reallocForRawMessage(t,i,e){var r=i<=16383?1:i<=2097151?2:i<=268435455?3:Math.ceil(Math.log(i)/(7*Math.LN2));e.realloc(r);for(var s=e.pos-1;s>=t;s--)e.buf[s+r]=e.buf[s]}function writePackedVarint(t,i){for(var e=0;e<t.length;e++)i.writeVarint(t[e])}function writePackedSVarint(t,i){for(var e=0;e<t.length;e++)i.writeSVarint(t[e])}function writePackedFloat(t,i){for(var e=0;e<t.length;e++)i.writeFloat(t[e])}function writePackedDouble(t,i){for(var e=0;e<t.length;e++)i.writeDouble(t[e])}function writePackedBoolean(t,i){for(var e=0;e<t.length;e++)i.writeBoolean(t[e])}function writePackedFixed32(t,i){for(var e=0;e<t.length;e++)i.writeFixed32(t[e])}function writePackedSFixed32(t,i){for(var e=0;e<t.length;e++)i.writeSFixed32(t[e])}function writePackedFixed64(t,i){for(var e=0;e<t.length;e++)i.writeFixed64(t[e])}function writePackedSFixed64(t,i){for(var e=0;e<t.length;e++)i.writeSFixed64(t[e])}module.exports=Pbf;var Buffer=global.Buffer||require("./buffer");Pbf.Varint=0,Pbf.Fixed64=1,Pbf.Bytes=2,Pbf.Fixed32=5;var SHIFT_LEFT_32=4294967296,SHIFT_RIGHT_32=1/SHIFT_LEFT_32,POW_2_63=Math.pow(2,63);Pbf.prototype={destroy:function(){this.buf=null},readFields:function(t,i,e){for(e=e||this.length;this.pos<e;){var r=this.readVarint(),s=r>>3,n=this.pos;t(s,i,this),this.pos===n&&this.skip(r)}return i},readMessage:function(t,i){return this.readFields(t,i,this.readVarint()+this.pos)},readFixed32:function(){var t=this.buf.readUInt32LE(this.pos);return this.pos+=4,t},readSFixed32:function(){var t=this.buf.readInt32LE(this.pos);return this.pos+=4,t},readFixed64:function(){var t=this.buf.readUInt32LE(this.pos)+this.buf.readUInt32LE(this.pos+4)*SHIFT_LEFT_32;return this.pos+=8,t},readSFixed64:function(){var t=this.buf.readUInt32LE(this.pos)+this.buf.readInt32LE(this.pos+4)*SHIFT_LEFT_32;return this.pos+=8,t},readFloat:function(){var t=this.buf.readFloatLE(this.pos);return this.pos+=4,t},readDouble:function(){var t=this.buf.readDoubleLE(this.pos);return this.pos+=8,t},readVarint:function(){var t,i,e=this.buf;return i=e[this.pos++],t=127&i,i<128?t:(i=e[this.pos++],t|=(127&i)<<7,i<128?t:(i=e[this.pos++],t|=(127&i)<<14,i<128?t:(i=e[this.pos++],t|=(127&i)<<21,i<128?t:readVarintRemainder(t,this))))},readVarint64:function(){var t=this.pos,i=this.readVarint();if(i<POW_2_63)return i;for(var e=this.pos-2;255===this.buf[e];)e--;e<t&&(e=t),i=0;for(var r=0;r<e-t+1;r++){var s=127&~this.buf[t+r];i+=r<4?s<<7*r:s*Math.pow(2,7*r)}return-i-1},readSVarint:function(){var t=this.readVarint();return t%2===1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,i=this.buf.toString("utf8",this.pos,t);return this.pos=t,i},readBytes:function(){var t=this.readVarint()+this.pos,i=this.buf.slice(this.pos,t);return this.pos=t,i},readPackedVarint:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readVarint());return i},readPackedSVarint:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readSVarint());return i},readPackedBoolean:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readBoolean());return i},readPackedFloat:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readFloat());return i},readPackedDouble:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readDouble());return i},readPackedFixed32:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readFixed32());return i},readPackedSFixed32:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readSFixed32());return i},readPackedFixed64:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readFixed64());return i},readPackedSFixed64:function(){for(var t=this.readVarint()+this.pos,i=[];this.pos<t;)i.push(this.readSFixed64());return i},skip:function(t){var i=7&t;if(i===Pbf.Varint)for(;this.buf[this.pos++]>127;);else if(i===Pbf.Bytes)this.pos=this.readVarint()+this.pos;else if(i===Pbf.Fixed32)this.pos+=4;else{if(i!==Pbf.Fixed64)throw new Error("Unimplemented type: "+i);this.pos+=8}},writeTag:function(t,i){this.writeVarint(t<<3|i)},realloc:function(t){for(var i=this.length||16;i<this.pos+t;)i*=2;if(i!==this.length){var e=new Buffer(i);this.buf.copy(e),this.buf=e,this.length=i}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.slice(0,this.length)},writeFixed32:function(t){this.realloc(4),this.buf.writeUInt32LE(t,this.pos),this.pos+=4},writeSFixed32:function(t){this.realloc(4),this.buf.writeInt32LE(t,this.pos),this.pos+=4},writeFixed64:function(t){this.realloc(8),this.buf.writeInt32LE(t&-1,this.pos),this.buf.writeUInt32LE(Math.floor(t*SHIFT_RIGHT_32),this.pos+4),this.pos+=8},writeSFixed64:function(t){this.realloc(8),this.buf.writeInt32LE(t&-1,this.pos),this.buf.writeInt32LE(Math.floor(t*SHIFT_RIGHT_32),this.pos+4),this.pos+=8},writeVarint:function(t){return t=+t,t>268435455?void writeBigVarint(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),void(t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127)))))},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t)},writeBoolean:function(t){this.writeVarint(Boolean(t))},writeString:function(t){t=String(t);var i=Buffer.byteLength(t);this.writeVarint(i),this.realloc(i),this.buf.write(t,this.pos),this.pos+=i},writeFloat:function(t){this.realloc(4),this.buf.writeFloatLE(t,this.pos),this.pos+=4},writeDouble:function(t){this.realloc(8),this.buf.writeDoubleLE(t,this.pos),this.pos+=8},writeBytes:function(t){var i=t.length;this.writeVarint(i),this.realloc(i);for(var e=0;e<i;e++)this.buf[this.pos++]=t[e]},writeRawMessage:function(t,i){this.pos++;var e=this.pos;t(i,this);var r=this.pos-e;r>=128&&reallocForRawMessage(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r},writeMessage:function(t,i,e){this.writeTag(t,Pbf.Bytes),this.writeRawMessage(i,e)},writePackedVarint:function(t,i){this.writeMessage(t,writePackedVarint,i)},writePackedSVarint:function(t,i){this.writeMessage(t,writePackedSVarint,i)},writePackedBoolean:function(t,i){this.writeMessage(t,writePackedBoolean,i)},writePackedFloat:function(t,i){this.writeMessage(t,writePackedFloat,i)},writePackedDouble:function(t,i){this.writeMessage(t,writePackedDouble,i)},writePackedFixed32:function(t,i){this.writeMessage(t,writePackedFixed32,i)},writePackedSFixed32:function(t,i){this.writeMessage(t,writePackedSFixed32,i)},writePackedFixed64:function(t,i){this.writeMessage(t,writePackedFixed64,i)},writePackedSFixed64:function(t,i){this.writeMessage(t,writePackedSFixed64,i)},writeBytesField:function(t,i){this.writeTag(t,Pbf.Bytes),this.writeBytes(i)},writeFixed32Field:function(t,i){this.writeTag(t,Pbf.Fixed32),this.writeFixed32(i)},writeSFixed32Field:function(t,i){this.writeTag(t,Pbf.Fixed32),this.writeSFixed32(i)},writeFixed64Field:function(t,i){this.writeTag(t,Pbf.Fixed64),this.writeFixed64(i)},writeSFixed64Field:function(t,i){this.writeTag(t,Pbf.Fixed64),this.writeSFixed64(i)},writeVarintField:function(t,i){this.writeTag(t,Pbf.Varint),this.writeVarint(i)},writeSVarintField:function(t,i){this.writeTag(t,Pbf.Varint),this.writeSVarint(i)},writeStringField:function(t,i){this.writeTag(t,Pbf.Bytes),this.writeString(i)},writeFloatField:function(t,i){this.writeTag(t,Pbf.Fixed32),this.writeFloat(i)},writeDoubleField:function(t,i){this.writeTag(t,Pbf.Fixed64),this.writeDouble(i)},writeBooleanField:function(t,i){this.writeVarintField(t,Boolean(i))}};
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	
	},{"./buffer":192}],194:[function(require,module,exports){
	"use strict";function Point(t,n){this.x=t,this.y=n}module.exports=Point,Point.prototype={clone:function(){return new Point(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var n=t.x-this.x,i=t.y-this.y;return n*n+i*i},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,n){return Math.atan2(this.x*n-this.y*t,this.x*t+this.y*n)},_matMult:function(t){var n=t[0]*this.x+t[1]*this.y,i=t[2]*this.x+t[3]*this.y;return this.x=n,this.y=i,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var n=Math.cos(t),i=Math.sin(t),s=n*this.x-i*this.y,r=i*this.x+n*this.y;return this.x=s,this.y=r,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},Point.convert=function(t){return t instanceof Point?t:Array.isArray(t)?new Point(t[0],t[1]):t};
	},{}],195:[function(require,module,exports){
	function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}function runTimeout(e){if(cachedSetTimeout===setTimeout)return setTimeout(e,0);if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout)return cachedSetTimeout=setTimeout,setTimeout(e,0);try{return cachedSetTimeout(e,0)}catch(t){try{return cachedSetTimeout.call(null,e,0)}catch(t){return cachedSetTimeout.call(this,e,0)}}}function runClearTimeout(e){if(cachedClearTimeout===clearTimeout)return clearTimeout(e);if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout)return cachedClearTimeout=clearTimeout,clearTimeout(e);try{return cachedClearTimeout(e)}catch(t){try{return cachedClearTimeout.call(null,e)}catch(t){return cachedClearTimeout.call(this,e)}}}function cleanUpNextTick(){draining&&currentQueue&&(draining=!1,currentQueue.length?queue=currentQueue.concat(queue):queueIndex=-1,queue.length&&drainQueue())}function drainQueue(){if(!draining){var e=runTimeout(cleanUpNextTick);draining=!0;for(var t=queue.length;t;){for(currentQueue=queue,queue=[];++queueIndex<t;)currentQueue&&currentQueue[queueIndex].run();queueIndex=-1,t=queue.length}currentQueue=null,draining=!1,runClearTimeout(e)}}function Item(e,t){this.fun=e,this.array=t}function noop(){}var process=module.exports={},cachedSetTimeout,cachedClearTimeout;!function(){try{cachedSetTimeout="function"==typeof setTimeout?setTimeout:defaultSetTimout}catch(e){cachedSetTimeout=defaultSetTimout}try{cachedClearTimeout="function"==typeof clearTimeout?clearTimeout:defaultClearTimeout}catch(e){cachedClearTimeout=defaultClearTimeout}}();var queue=[],draining=!1,currentQueue,queueIndex=-1;process.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var u=1;u<arguments.length;u++)t[u-1]=arguments[u];queue.push(new Item(e,t)),1!==queue.length||draining||runTimeout(drainQueue)},Item.prototype.run=function(){this.fun.apply(null,this.array)},process.title="browser",process.browser=!0,process.env={},process.argv=[],process.version="",process.versions={},process.on=noop,process.addListener=noop,process.once=noop,process.off=noop,process.removeListener=noop,process.removeAllListeners=noop,process.emit=noop,process.binding=function(e){throw new Error("process.binding is not supported")},process.cwd=function(){return"/"},process.chdir=function(e){throw new Error("process.chdir is not supported")},process.umask=function(){return 0};
	},{}],196:[function(require,module,exports){
	"use strict";function partialSort(a,t,r,o,p){for(r=r||0,o=o||a.length-1,p=p||defaultCompare;o>r;){if(o-r>600){var f=o-r+1,e=t-r+1,l=Math.log(f),s=.5*Math.exp(2*l/3),i=.5*Math.sqrt(l*s*(f-s)/f)*(e-f/2<0?-1:1),n=Math.max(r,Math.floor(t-e*s/f+i)),h=Math.min(o,Math.floor(t+(f-e)*s/f+i));partialSort(a,t,n,h,p)}var u=a[t],M=r,w=o;for(swap(a,r,t),p(a[o],u)>0&&swap(a,r,o);M<w;){for(swap(a,M,w),M++,w--;p(a[M],u)<0;)M++;for(;p(a[w],u)>0;)w--}0===p(a[r],u)?swap(a,r,w):(w++,swap(a,w,o)),w<=t&&(r=w+1),t<=w&&(o=w-1)}}function swap(a,t,r){var o=a[t];a[t]=a[r],a[r]=o}function defaultCompare(a,t){return a<t?-1:a>t?1:0}module.exports=partialSort;
	},{}],197:[function(require,module,exports){
	!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ShelfPack=e()}(this,function(){function t(t,e,s){s=s||{},this.w=t||64,this.h=e||64,this.autoResize=!!s.autoResize,this.shelves=[],this.stats={},this.count=function(t){this.stats[t]=(0|this.stats[t])+1}}function e(t,e,s){this.x=0,this.y=t,this.w=this.free=e,this.h=s}return t.prototype.pack=function(t,e){t=[].concat(t),e=e||{};for(var s,h,i,n=[],r=0;r<t.length;r++)if(s=t[r].w||t[r].width,h=t[r].h||t[r].height,s&&h){if(i=this.packOne(s,h),!i)continue;e.inPlace&&(t[r].x=i.x,t[r].y=i.y),n.push(i)}if(this.shelves.length>0){for(var o=0,f=0,u=0;u<this.shelves.length;u++){var l=this.shelves[u];f+=l.h,o=Math.max(l.w-l.free,o)}this.resize(o,f)}return n},t.prototype.packOne=function(t,s){for(var h,i,n=0,r={shelf:-1,waste:1/0},o=0;o<this.shelves.length;o++){if(h=this.shelves[o],n+=h.h,s===h.h&&t<=h.free)return this.count(s),h.alloc(t,s);s>h.h||t>h.free||s<h.h&&t<=h.free&&(i=h.h-s,i<r.waste&&(r.waste=i,r.shelf=o))}if(r.shelf!==-1)return h=this.shelves[r.shelf],this.count(s),h.alloc(t,s);if(s<=this.h-n&&t<=this.w)return h=new e(n,this.w,s),this.shelves.push(h),this.count(s),h.alloc(t,s);if(this.autoResize){var f,u,l,a;return f=u=this.h,l=a=this.w,(l<=f||t>l)&&(a=2*Math.max(t,l)),(f<l||s>f)&&(u=2*Math.max(s,f)),this.resize(a,u),this.packOne(t,s)}return null},t.prototype.clear=function(){this.shelves=[],this.stats={}},t.prototype.resize=function(t,e){this.w=t,this.h=e;for(var s=0;s<this.shelves.length;s++)this.shelves[s].resize(t);return!0},e.prototype.alloc=function(t,e){if(t>this.free||e>this.h)return null;var s=this.x;return this.x+=t,this.free-=t,{x:s,y:this.y,w:t,h:e,width:t,height:e}},e.prototype.resize=function(t){return this.free+=t-this.w,this.w=t,!0},t});
	},{}],198:[function(require,module,exports){
	"use strict";function supercluster(t){return new SuperCluster(t)}function SuperCluster(t){this.options=extend(Object.create(this.options),t),this.trees=new Array(this.options.maxZoom+1)}function createCluster(t,e,o,n){return{x:t,y:e,zoom:1/0,id:n,numPoints:o}}function createPointCluster(t,e){var o=t.geometry.coordinates;return createCluster(lngX(o[0]),latY(o[1]),1,e)}function getClusterJSON(t){return{type:"Feature",properties:getClusterProperties(t),geometry:{type:"Point",coordinates:[xLng(t.x),yLat(t.y)]}}}function getClusterProperties(t){var e=t.numPoints,o=e>=1e4?Math.round(e/1e3)+"k":e>=1e3?Math.round(e/100)/10+"k":e;return{cluster:!0,point_count:e,point_count_abbreviated:o}}function lngX(t){return t/360+.5}function latY(t){var e=Math.sin(t*Math.PI/180),o=.5-.25*Math.log((1+e)/(1-e))/Math.PI;return o<0?0:o>1?1:o}function xLng(t){return 360*(t-.5)}function yLat(t){var e=(180-360*t)*Math.PI/180;return 360*Math.atan(Math.exp(e))/Math.PI-90}function extend(t,e){for(var o in e)t[o]=e[o];return t}function getX(t){return t.x}function getY(t){return t.y}var kdbush=require("kdbush");module.exports=supercluster,SuperCluster.prototype={options:{minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1},load:function(t){var e=this.options.log;e&&console.time("total time");var o="prepare "+t.length+" points";e&&console.time(o),this.points=t;var n=t.map(createPointCluster);e&&console.timeEnd(o);for(var r=this.options.maxZoom;r>=this.options.minZoom;r--){var i=+Date.now();this.trees[r+1]=kdbush(n,getX,getY,this.options.nodeSize,Float32Array),n=this._cluster(n,r),e&&console.log("z%d: %d clusters in %dms",r,n.length,+Date.now()-i)}return this.trees[this.options.minZoom]=kdbush(n,getX,getY,this.options.nodeSize,Float32Array),e&&console.timeEnd("total time"),this},getClusters:function(t,e){for(var o=this.trees[this._limitZoom(e)],n=o.range(lngX(t[0]),latY(t[3]),lngX(t[2]),latY(t[1])),r=[],i=0;i<n.length;i++){var s=o.points[n[i]];r.push(s.id!==-1?this.points[s.id]:getClusterJSON(s))}return r},getTile:function(t,e,o){var n=this.trees[this._limitZoom(t)],r=Math.pow(2,t),i=this.options.extent,s=this.options.radius,u=s/i,a=(o-u)/r,h=(o+1+u)/r,l={features:[]};return this._addTileFeatures(n.range((e-u)/r,a,(e+1+u)/r,h),n.points,e,o,r,l),0===e&&this._addTileFeatures(n.range(1-u/r,a,1,h),n.points,r,o,r,l),e===r-1&&this._addTileFeatures(n.range(0,a,u/r,h),n.points,-1,o,r,l),l.features.length?l:null},_addTileFeatures:function(t,e,o,n,r,i){for(var s=0;s<t.length;s++){var u=e[t[s]];i.features.push({type:1,geometry:[[Math.round(this.options.extent*(u.x*r-o)),Math.round(this.options.extent*(u.y*r-n))]],tags:u.id!==-1?this.points[u.id].properties:getClusterProperties(u)})}},_limitZoom:function(t){return Math.max(this.options.minZoom,Math.min(t,this.options.maxZoom+1))},_cluster:function(t,e){for(var o=[],n=this.options.radius/(this.options.extent*Math.pow(2,e)),r=0;r<t.length;r++){var i=t[r];if(!(i.zoom<=e)){i.zoom=e;for(var s=this.trees[e+1],u=s.within(i.x,i.y,n),a=!1,h=i.numPoints,l=i.x*h,p=i.y*h,m=0;m<u.length;m++){var c=s.points[u[m]];e<c.zoom&&(a=!0,c.zoom=e,l+=c.x*c.numPoints,p+=c.y*c.numPoints,h+=c.numPoints)}o.push(a?createCluster(l/h,p/h,h,-1):i)}}return o}};
	},{"kdbush":148}],199:[function(require,module,exports){
	"use strict";function TinyQueue(t,i){if(!(this instanceof TinyQueue))return new TinyQueue(t,i);if(this.data=t||[],this.length=this.data.length,this.compare=i||defaultCompare,t)for(var a=Math.floor(this.length/2);a>=0;a--)this._down(a)}function defaultCompare(t,i){return t<i?-1:t>i?1:0}function swap(t,i,a){var n=t[i];t[i]=t[a],t[a]=n}module.exports=TinyQueue,TinyQueue.prototype={push:function(t){this.data.push(t),this.length++,this._up(this.length-1)},pop:function(){var t=this.data[0];return this.data[0]=this.data[this.length-1],this.length--,this.data.pop(),this._down(0),t},peek:function(){return this.data[0]},_up:function(t){for(var i=this.data,a=this.compare;t>0;){var n=Math.floor((t-1)/2);if(!(a(i[t],i[n])<0))break;swap(i,n,t),t=n}},_down:function(t){for(var i=this.data,a=this.compare,n=this.length;;){var e=2*t+1,h=e+1,s=t;if(e<n&&a(i[e],i[s])<0&&(s=e),h<n&&a(i[h],i[s])<0&&(s=h),s===t)return;swap(i,s,t),t=s}}};
	},{}],200:[function(require,module,exports){
	function UnitBezier(t,i,e,r){this.cx=3*t,this.bx=3*(e-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*i,this.by=3*(r-i)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=r,this.p2x=e,this.p2y=r}module.exports=UnitBezier,UnitBezier.prototype.sampleCurveX=function(t){return((this.ax*t+this.bx)*t+this.cx)*t},UnitBezier.prototype.sampleCurveY=function(t){return((this.ay*t+this.by)*t+this.cy)*t},UnitBezier.prototype.sampleCurveDerivativeX=function(t){return(3*this.ax*t+2*this.bx)*t+this.cx},UnitBezier.prototype.solveCurveX=function(t,i){"undefined"==typeof i&&(i=1e-6);var e,r,s,h,n;for(s=t,n=0;n<8;n++){if(h=this.sampleCurveX(s)-t,Math.abs(h)<i)return s;var u=this.sampleCurveDerivativeX(s);if(Math.abs(u)<1e-6)break;s-=h/u}if(e=0,r=1,s=t,s<e)return e;if(s>r)return r;for(;e<r;){if(h=this.sampleCurveX(s),Math.abs(h-t)<i)return s;t>h?e=s:r=s,s=.5*(r-e)+e}return s},UnitBezier.prototype.solve=function(t,i){return this.sampleCurveY(this.solveCurveX(t,i))};
	},{}],201:[function(require,module,exports){
	"function"==typeof Object.create?module.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:module.exports=function(t,e){t.super_=e;var o=function(){};o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t};
	},{}],202:[function(require,module,exports){
	module.exports=function(o){return o&&"object"==typeof o&&"function"==typeof o.copy&&"function"==typeof o.fill&&"function"==typeof o.readUInt8};
	},{}],203:[function(require,module,exports){
	(function (process,global){
	function inspect(e,r){var t={seen:[],stylize:stylizeNoColor};return arguments.length>=3&&(t.depth=arguments[2]),arguments.length>=4&&(t.colors=arguments[3]),isBoolean(r)?t.showHidden=r:r&&exports._extend(t,r),isUndefined(t.showHidden)&&(t.showHidden=!1),isUndefined(t.depth)&&(t.depth=2),isUndefined(t.colors)&&(t.colors=!1),isUndefined(t.customInspect)&&(t.customInspect=!0),t.colors&&(t.stylize=stylizeWithColor),formatValue(t,e,t.depth)}function stylizeWithColor(e,r){var t=inspect.styles[r];return t?"["+inspect.colors[t][0]+"m"+e+"["+inspect.colors[t][1]+"m":e}function stylizeNoColor(e,r){return e}function arrayToHash(e){var r={};return e.forEach(function(e,t){r[e]=!0}),r}function formatValue(e,r,t){if(e.customInspect&&r&&isFunction(r.inspect)&&r.inspect!==exports.inspect&&(!r.constructor||r.constructor.prototype!==r)){var n=r.inspect(t,e);return isString(n)||(n=formatValue(e,n,t)),n}var i=formatPrimitive(e,r);if(i)return i;var o=Object.keys(r),s=arrayToHash(o);if(e.showHidden&&(o=Object.getOwnPropertyNames(r)),isError(r)&&(o.indexOf("message")>=0||o.indexOf("description")>=0))return formatError(r);if(0===o.length){if(isFunction(r)){var u=r.name?": "+r.name:"";return e.stylize("[Function"+u+"]","special")}if(isRegExp(r))return e.stylize(RegExp.prototype.toString.call(r),"regexp");if(isDate(r))return e.stylize(Date.prototype.toString.call(r),"date");if(isError(r))return formatError(r)}var c="",a=!1,l=["{","}"];if(isArray(r)&&(a=!0,l=["[","]"]),isFunction(r)){var p=r.name?": "+r.name:"";c=" [Function"+p+"]"}if(isRegExp(r)&&(c=" "+RegExp.prototype.toString.call(r)),isDate(r)&&(c=" "+Date.prototype.toUTCString.call(r)),isError(r)&&(c=" "+formatError(r)),0===o.length&&(!a||0==r.length))return l[0]+c+l[1];if(t<0)return isRegExp(r)?e.stylize(RegExp.prototype.toString.call(r),"regexp"):e.stylize("[Object]","special");e.seen.push(r);var f;return f=a?formatArray(e,r,t,s,o):o.map(function(n){return formatProperty(e,r,t,s,n,a)}),e.seen.pop(),reduceToSingleString(f,c,l)}function formatPrimitive(e,r){if(isUndefined(r))return e.stylize("undefined","undefined");if(isString(r)){var t="'"+JSON.stringify(r).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(t,"string")}return isNumber(r)?e.stylize(""+r,"number"):isBoolean(r)?e.stylize(""+r,"boolean"):isNull(r)?e.stylize("null","null"):void 0}function formatError(e){return"["+Error.prototype.toString.call(e)+"]"}function formatArray(e,r,t,n,i){for(var o=[],s=0,u=r.length;s<u;++s)hasOwnProperty(r,String(s))?o.push(formatProperty(e,r,t,n,String(s),!0)):o.push("");return i.forEach(function(i){i.match(/^\d+$/)||o.push(formatProperty(e,r,t,n,i,!0))}),o}function formatProperty(e,r,t,n,i,o){var s,u,c;if(c=Object.getOwnPropertyDescriptor(r,i)||{value:r[i]},c.get?u=c.set?e.stylize("[Getter/Setter]","special"):e.stylize("[Getter]","special"):c.set&&(u=e.stylize("[Setter]","special")),hasOwnProperty(n,i)||(s="["+i+"]"),u||(e.seen.indexOf(c.value)<0?(u=isNull(t)?formatValue(e,c.value,null):formatValue(e,c.value,t-1),u.indexOf("\n")>-1&&(u=o?u.split("\n").map(function(e){return"  "+e}).join("\n").substr(2):"\n"+u.split("\n").map(function(e){return"   "+e}).join("\n"))):u=e.stylize("[Circular]","special")),isUndefined(s)){if(o&&i.match(/^\d+$/))return u;s=JSON.stringify(""+i),s.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(s=s.substr(1,s.length-2),s=e.stylize(s,"name")):(s=s.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),s=e.stylize(s,"string"))}return s+": "+u}function reduceToSingleString(e,r,t){var n=0,i=e.reduce(function(e,r){return n++,r.indexOf("\n")>=0&&n++,e+r.replace(/\u001b\[\d\d?m/g,"").length+1},0);return i>60?t[0]+(""===r?"":r+"\n ")+" "+e.join(",\n  ")+" "+t[1]:t[0]+r+" "+e.join(", ")+" "+t[1]}function isArray(e){return Array.isArray(e)}function isBoolean(e){return"boolean"==typeof e}function isNull(e){return null===e}function isNullOrUndefined(e){return null==e}function isNumber(e){return"number"==typeof e}function isString(e){return"string"==typeof e}function isSymbol(e){return"symbol"==typeof e}function isUndefined(e){return void 0===e}function isRegExp(e){return isObject(e)&&"[object RegExp]"===objectToString(e)}function isObject(e){return"object"==typeof e&&null!==e}function isDate(e){return isObject(e)&&"[object Date]"===objectToString(e)}function isError(e){return isObject(e)&&("[object Error]"===objectToString(e)||e instanceof Error)}function isFunction(e){return"function"==typeof e}function isPrimitive(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||"undefined"==typeof e}function objectToString(e){return Object.prototype.toString.call(e)}function pad(e){return e<10?"0"+e.toString(10):e.toString(10)}function timestamp(){var e=new Date,r=[pad(e.getHours()),pad(e.getMinutes()),pad(e.getSeconds())].join(":");return[e.getDate(),months[e.getMonth()],r].join(" ")}function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}var formatRegExp=/%[sdj%]/g;exports.format=function(e){if(!isString(e)){for(var r=[],t=0;t<arguments.length;t++)r.push(inspect(arguments[t]));return r.join(" ")}for(var t=1,n=arguments,i=n.length,o=String(e).replace(formatRegExp,function(e){if("%%"===e)return"%";if(t>=i)return e;switch(e){case"%s":return String(n[t++]);case"%d":return Number(n[t++]);case"%j":try{return JSON.stringify(n[t++])}catch(e){return"[Circular]"}default:return e}}),s=n[t];t<i;s=n[++t])o+=isNull(s)||!isObject(s)?" "+s:" "+inspect(s);return o},exports.deprecate=function(e,r){function t(){if(!n){if(process.throwDeprecation)throw new Error(r);process.traceDeprecation?console.trace(r):console.error(r),n=!0}return e.apply(this,arguments)}if(isUndefined(global.process))return function(){return exports.deprecate(e,r).apply(this,arguments)};if(process.noDeprecation===!0)return e;var n=!1;return t};var debugs={},debugEnviron;exports.debuglog=function(e){if(isUndefined(debugEnviron)&&(debugEnviron=process.env.NODE_DEBUG||""),e=e.toUpperCase(),!debugs[e])if(new RegExp("\\b"+e+"\\b","i").test(debugEnviron)){var r=process.pid;debugs[e]=function(){var t=exports.format.apply(exports,arguments);console.error("%s %d: %s",e,r,t)}}else debugs[e]=function(){};return debugs[e]},exports.inspect=inspect,inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"},exports.isArray=isArray,exports.isBoolean=isBoolean,exports.isNull=isNull,exports.isNullOrUndefined=isNullOrUndefined,exports.isNumber=isNumber,exports.isString=isString,exports.isSymbol=isSymbol,exports.isUndefined=isUndefined,exports.isRegExp=isRegExp,exports.isObject=isObject,exports.isDate=isDate,exports.isError=isError,exports.isFunction=isFunction,exports.isPrimitive=isPrimitive,exports.isBuffer=require("./support/isBuffer");var months=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];exports.log=function(){console.log("%s - %s",timestamp(),exports.format.apply(exports,arguments))},exports.inherits=require("inherits"),exports._extend=function(e,r){if(!r||!isObject(r))return e;for(var t=Object.keys(r),n=t.length;n--;)e[t[n]]=r[t[n]];return e};
	}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	
	},{"./support/isBuffer":202,"_process":195,"inherits":201}],204:[function(require,module,exports){
	module.exports.VectorTile=require("./lib/vectortile.js"),module.exports.VectorTileFeature=require("./lib/vectortilefeature.js"),module.exports.VectorTileLayer=require("./lib/vectortilelayer.js");
	},{"./lib/vectortile.js":205,"./lib/vectortilefeature.js":206,"./lib/vectortilelayer.js":207}],205:[function(require,module,exports){
	"use strict";function VectorTile(e,r){this.layers=e.readFields(readTile,{},r)}function readTile(e,r,i){if(3===e){var t=new VectorTileLayer(i,i.readVarint()+i.pos);t.length&&(r[t.name]=t)}}var VectorTileLayer=require("./vectortilelayer");module.exports=VectorTile;
	},{"./vectortilelayer":207}],206:[function(require,module,exports){
	"use strict";function VectorTileFeature(e,t,r,i,a){this.properties={},this.extent=r,this.type=0,this._pbf=e,this._geometry=-1,this._keys=i,this._values=a,e.readFields(readFeature,this,t)}function readFeature(e,t,r){1==e?t.id=r.readVarint():2==e?readTag(r,t):3==e?t.type=r.readVarint():4==e&&(t._geometry=r.pos)}function readTag(e,t){for(var r=e.readVarint()+e.pos;e.pos<r;){var i=t._keys[e.readVarint()],a=t._values[e.readVarint()];t.properties[i]=a}}function classifyRings(e){var t=e.length;if(t<=1)return[e];for(var r,i,a=[],o=0;o<t;o++){var n=signedArea(e[o]);0!==n&&(void 0===i&&(i=n<0),i===n<0?(r&&a.push(r),r=[e[o]]):r.push(e[o]))}return r&&a.push(r),a}function signedArea(e){for(var t,r,i=0,a=0,o=e.length,n=o-1;a<o;n=a++)t=e[a],r=e[n],i+=(r.x-t.x)*(t.y+r.y);return i}var Point=require("point-geometry");module.exports=VectorTileFeature,VectorTileFeature.types=["Unknown","Point","LineString","Polygon"],VectorTileFeature.prototype.loadGeometry=function(){var e=this._pbf;e.pos=this._geometry;for(var t,r=e.readVarint()+e.pos,i=1,a=0,o=0,n=0,s=[];e.pos<r;){if(!a){var p=e.readVarint();i=7&p,a=p>>3}if(a--,1===i||2===i)o+=e.readSVarint(),n+=e.readSVarint(),1===i&&(t&&s.push(t),t=[]),t.push(new Point(o,n));else{if(7!==i)throw new Error("unknown command "+i);t&&t.push(t[0].clone())}}return t&&s.push(t),s},VectorTileFeature.prototype.bbox=function(){var e=this._pbf;e.pos=this._geometry;for(var t=e.readVarint()+e.pos,r=1,i=0,a=0,o=0,n=1/0,s=-(1/0),p=1/0,h=-(1/0);e.pos<t;){if(!i){var u=e.readVarint();r=7&u,i=u>>3}if(i--,1===r||2===r)a+=e.readSVarint(),o+=e.readSVarint(),a<n&&(n=a),a>s&&(s=a),o<p&&(p=o),o>h&&(h=o);else if(7!==r)throw new Error("unknown command "+r)}return[n,p,s,h]},VectorTileFeature.prototype.toGeoJSON=function(e,t,r){function i(e){for(var t=0;t<e.length;t++){var r=e[t],i=180-360*(r.y+p)/n;e[t]=[360*(r.x+s)/n-180,360/Math.PI*Math.atan(Math.exp(i*Math.PI/180))-90]}}var a,o,n=this.extent*Math.pow(2,r),s=this.extent*e,p=this.extent*t,h=this.loadGeometry(),u=VectorTileFeature.types[this.type];switch(this.type){case 1:var d=[];for(a=0;a<h.length;a++)d[a]=h[a][0];h=d,i(h);break;case 2:for(a=0;a<h.length;a++)i(h[a]);break;case 3:for(h=classifyRings(h),a=0;a<h.length;a++)for(o=0;o<h[a].length;o++)i(h[a][o])}1===h.length?h=h[0]:u="Multi"+u;var f={type:"Feature",geometry:{type:u,coordinates:h},properties:this.properties};return"id"in this&&(f.id=this.id),f};
	},{"point-geometry":194}],207:[function(require,module,exports){
	"use strict";function VectorTileLayer(e,t){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=e,this._keys=[],this._values=[],this._features=[],e.readFields(readLayer,this,t),this.length=this._features.length}function readLayer(e,t,r){15===e?t.version=r.readVarint():1===e?t.name=r.readString():5===e?t.extent=r.readVarint():2===e?t._features.push(r.pos):3===e?t._keys.push(r.readString()):4===e&&t._values.push(readValueMessage(r))}function readValueMessage(e){for(var t=null,r=e.readVarint()+e.pos;e.pos<r;){var a=e.readVarint()>>3;t=1===a?e.readString():2===a?e.readFloat():3===a?e.readDouble():4===a?e.readVarint64():5===a?e.readVarint():6===a?e.readSVarint():7===a?e.readBoolean():null}return t}var VectorTileFeature=require("./vectortilefeature.js");module.exports=VectorTileLayer,VectorTileLayer.prototype.feature=function(e){if(e<0||e>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[e];var t=this._pbf.readVarint()+this._pbf.pos;return new VectorTileFeature(this._pbf,t,this.extent,this._keys,this._values)};
	},{"./vectortilefeature.js":206}],208:[function(require,module,exports){
	function fromVectorTileJs(e){var r=[];for(var o in e.layers)r.push(prepareLayer(e.layers[o]));var t=new Pbf;return vtpb.tile.write({layers:r},t),t.finish()}function fromGeojsonVt(e){var r={};for(var o in e)r[o]=new GeoJSONWrapper(e[o].features),r[o].name=o;return fromVectorTileJs({layers:r})}function prepareLayer(e){for(var r={name:e.name||"",version:e.version||1,extent:e.extent||4096,keys:[],values:[],features:[]},o={},t={},n=0;n<e.length;n++){var a=e.feature(n);a.geometry=encodeGeometry(a.loadGeometry());var u=[];for(var s in a.properties){var i=o[s];"undefined"==typeof i&&(r.keys.push(s),i=r.keys.length-1,o[s]=i);var p=wrapValue(a.properties[s]),l=t[p.key];"undefined"==typeof l&&(r.values.push(p),l=r.values.length-1,t[p.key]=l),u.push(i),u.push(l)}a.tags=u,r.features.push(a)}return r}function command(e,r){return(r<<3)+(7&e)}function zigzag(e){return e<<1^e>>31}function encodeGeometry(e){for(var r=[],o=0,t=0,n=e.length,a=0;a<n;a++){var u=e[a];r.push(command(1,1));for(var s=0;s<u.length;s++){1===s&&r.push(command(2,u.length-1));var i=u[s].x-o,p=u[s].y-t;r.push(zigzag(i),zigzag(p)),o+=i,t+=p}}return r}function wrapValue(e){var r,o=typeof e;return"string"===o?r={string_value:e}:"boolean"===o?r={bool_value:e}:"number"===o?r=e%1!==0?{double_value:e}:e<0?{sint_value:e}:{uint_value:e}:(e=JSON.stringify(e),r={string_value:e}),r.key=o+":"+e,r}var Pbf=require("pbf"),vtpb=require("./vector-tile-pb"),GeoJSONWrapper=require("./lib/geojson_wrapper");module.exports=fromVectorTileJs,module.exports.fromVectorTileJs=fromVectorTileJs,module.exports.fromGeojsonVt=fromGeojsonVt,module.exports.GeoJSONWrapper=GeoJSONWrapper;
	},{"./lib/geojson_wrapper":209,"./vector-tile-pb":210,"pbf":193}],209:[function(require,module,exports){
	"use strict";function GeoJSONWrapper(e){this.features=e,this.length=e.length}function FeatureWrapper(e){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=4096}var Point=require("point-geometry"),VectorTileFeature=require("vector-tile").VectorTileFeature;module.exports=GeoJSONWrapper,GeoJSONWrapper.prototype.feature=function(e){return new FeatureWrapper(this.features[e])},FeatureWrapper.prototype.loadGeometry=function(){var e=this.rawGeometry;this.geometry=[];for(var t=0;t<e.length;t++){for(var r=e[t],o=[],a=0;a<r.length;a++)o.push(new Point(r[a][0],r[a][1]));this.geometry.push(o)}return this.geometry},FeatureWrapper.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-(1/0),o=1/0,a=-(1/0),i=0;i<e.length;i++)for(var p=e[i],n=0;n<p.length;n++){var h=p[n];t=Math.min(t,h.x),r=Math.max(r,h.x),o=Math.min(o,h.y),a=Math.max(a,h.y)}return[t,o,r,a]},FeatureWrapper.prototype.toGeoJSON=VectorTileFeature.prototype.toGeoJSON;
	},{"point-geometry":194,"vector-tile":204}],210:[function(require,module,exports){
	"use strict";function readTile(e,r){return e.readFields(readTileField,{layers:[]},r)}function readTileField(e,r,i){3===e&&r.layers.push(readLayer(i,i.readVarint()+i.pos))}function writeTile(e,r){var i;if(void 0!==e.layers)for(i=0;i<e.layers.length;i++)r.writeMessage(3,writeLayer,e.layers[i])}function readValue(e,r){return e.readFields(readValueField,{},r)}function readValueField(e,r,i){1===e?r.string_value=i.readString():2===e?r.float_value=i.readFloat():3===e?r.double_value=i.readDouble():4===e?r.int_value=i.readVarint():5===e?r.uint_value=i.readVarint():6===e?r.sint_value=i.readSVarint():7===e&&(r.bool_value=i.readBoolean())}function writeValue(e,r){void 0!==e.string_value&&r.writeStringField(1,e.string_value),void 0!==e.float_value&&r.writeFloatField(2,e.float_value),void 0!==e.double_value&&r.writeDoubleField(3,e.double_value),void 0!==e.int_value&&r.writeVarintField(4,e.int_value),void 0!==e.uint_value&&r.writeVarintField(5,e.uint_value),void 0!==e.sint_value&&r.writeSVarintField(6,e.sint_value),void 0!==e.bool_value&&r.writeBooleanField(7,e.bool_value)}function readFeature(e,r){var i=e.readFields(readFeatureField,{},r);return void 0===i.type&&(i.type="Unknown"),i}function readFeatureField(e,r,i){1===e?r.id=i.readVarint():2===e?r.tags=i.readPackedVarint():3===e?r.type=i.readVarint():4===e&&(r.geometry=i.readPackedVarint())}function writeFeature(e,r){void 0!==e.id&&r.writeVarintField(1,e.id),void 0!==e.tags&&r.writePackedVarint(2,e.tags),void 0!==e.type&&r.writeVarintField(3,e.type),void 0!==e.geometry&&r.writePackedVarint(4,e.geometry)}function readLayer(e,r){return e.readFields(readLayerField,{features:[],keys:[],values:[]},r)}function readLayerField(e,r,i){15===e?r.version=i.readVarint():1===e?r.name=i.readString():2===e?r.features.push(readFeature(i,i.readVarint()+i.pos)):3===e?r.keys.push(i.readString()):4===e?r.values.push(readValue(i,i.readVarint()+i.pos)):5===e&&(r.extent=i.readVarint())}function writeLayer(e,r){void 0!==e.version&&r.writeVarintField(15,e.version),void 0!==e.name&&r.writeStringField(1,e.name);var i;if(void 0!==e.features)for(i=0;i<e.features.length;i++)r.writeMessage(2,writeFeature,e.features[i]);if(void 0!==e.keys)for(i=0;i<e.keys.length;i++)r.writeStringField(3,e.keys[i]);if(void 0!==e.values)for(i=0;i<e.values.length;i++)r.writeMessage(4,writeValue,e.values[i]);void 0!==e.extent&&r.writeVarintField(5,e.extent)}var tile=exports.tile={read:readTile,write:writeTile};tile.GeomType={Unknown:0,Point:1,LineString:2,Polygon:3},tile.value={read:readValue,write:writeValue},tile.feature={read:readFeature,write:writeFeature},tile.layer={read:readLayer,write:writeLayer};
	},{}],211:[function(require,module,exports){
	var bundleFn=arguments[3],sources=arguments[4],cache=arguments[5],stringify=JSON.stringify;module.exports=function(r,e){function t(r){d[r]=!0;for(var e in sources[r][1]){var n=sources[r][1][e];d[n]||t(n)}}for(var n,o=Object.keys(cache),a=0,i=o.length;a<i;a++){var s=o[a],u=cache[s].exports;if(u===r||u&&u.default===r){n=s;break}}if(!n){n=Math.floor(Math.pow(16,8)*Math.random()).toString(16);for(var f={},a=0,i=o.length;a<i;a++){var s=o[a];f[s]=s}sources[n]=[Function(["require","module","exports"],"("+r+")(self)"),f]}var c=Math.floor(Math.pow(16,8)*Math.random()).toString(16),l={};l[n]=n,sources[c]=[Function(["require"],"var f = require("+stringify(n)+");(f.default ? f.default : f)(self);"),l];var d={};t(c);var g="("+bundleFn+")({"+Object.keys(d).map(function(r){return stringify(r)+":["+sources[r][0]+","+stringify(sources[r][1])+"]"}).join(",")+"},{},["+stringify(c)+"])",v=window.URL||window.webkitURL||window.mozURL||window.msURL,w=new Blob([g],{type:"text/javascript"});if(e&&e.bare)return w;var h=v.createObjectURL(w),b=new Worker(h);return b.objectURL=h,b};
	},{}],212:[function(require,module,exports){
	module.exports.RADIUS=6378137,module.exports.FLATTENING=1/298.257223563,module.exports.POLAR_RADIUS=6356752.3142;
	},{}],213:[function(require,module,exports){
	!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.WhooTS=e.WhooTS||{})}(this,function(e){function t(e,t,r,n,i,s){s=s||{};var f=e+"?"+["bbox="+o(r,n,i),"format="+(s.format||"image/png"),"service="+(s.service||"WMS"),"version="+(s.version||"1.1.1"),"request="+(s.request||"GetMap"),"srs="+(s.srs||"EPSG:3857"),"width="+(s.width||256),"height="+(s.height||256),"layers="+t].join("&");return f}function o(e,t,o){t=Math.pow(2,o)-t-1;var n=r(256*e,256*t,o),i=r(256*(e+1),256*(t+1),o);return n[0]+","+n[1]+","+i[0]+","+i[1]}function r(e,t,o){var r=2*Math.PI*6378137/256/Math.pow(2,o),n=e*r-2*Math.PI*6378137/2,i=t*r-2*Math.PI*6378137/2;return[n,i]}e.getURL=t,e.getTileBBox=o,e.getMercCoords=r,Object.defineProperty(e,"__esModule",{value:!0})});
	},{}],214:[function(require,module,exports){
	module.exports={"version":"0.29.0"}
	},{}]},{},[24])(24)
	});
	
	
	//# sourceMappingURL=mapbox-gl.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36).Buffer, (function() { return this; }())))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(37)
	var ieee754 = __webpack_require__(38)
	var isArray = __webpack_require__(39)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var Collection      = __webpack_require__(8),
	    ol              = __webpack_require__(22),
	    $               = __webpack_require__(3);
	
	var LayerCollection = Collection.extend({
	
	    initialize: function(view, objects, options){
	        var that = this;
	
	        if (!view) {
	            throw new Error('Can not initialize LayerCollection without view instance');
	        }
	        that._view = view;
	
	        LayerCollection.__super__.initialize.call(that, objects, options);
	    },
	
	    add: function(layers){
	        var that = this,
	            _layers,
	            i;
	
	        LayerCollection.__super__.add.call(that, layers);
	
	        _layers = $.isArray(layers) ? layers : [layers];
	
	        for(i in _layers) {
	            if (_layers[i] && 'getMapLayer' in _layers[i]) {
	                that._olLayersGroup.getLayers().push(_layers[i].getMapLayer());
	                _layers[i].onAdd(that._view);
	            }
	        }
	    },
	
	    remove: function(layers){
	        var that = this,
	            _layers,
	            i;
	
	        LayerCollection.__super__.remove.call(that, _layers);
	
	        _layers = $.isArray(layers) ? layers : [layers];
	
	        for (i in _layers) {
	            if (_layers[i] && 'getMapLayer' in _layers[i]) {
	                that._olLayersGroup.getLayers().remove(_layers[i].getMapLayer());
	            }
	        }
	    },
	
	    reset: function(objects){
	        var that = this;
	
	        if (that._olLayersGroup instanceof ol.layer.Group) {
	            that._olLayersGroup.getLayers().clear();
	        } else {
	            that._olLayersGroup = new ol.layer.Group({});
	        }
	
	        return LayerCollection.__super__.reset.call(that, objects);
	    },
	
	    /**
	     *
	     */
	    filter: function(predicate){
	        var that = this,
	            result = [],
	            callback;
	
	        callback = $.isFunction(predicate)
	            ? predicate
	            : function() {
	                return true;
	            };
	
	        that._items.forEach(function(obj, i) {
	            if (callback (obj, i)) {
	                result.push(obj);
	            }
	        });
	
	        return new Collection(result);
	    },
	
	    /**
	     *
	     */
	    getByContainerCodes: function(codes){
	        var that = this;
	        var _codes;
	
	        if (typeof codes === 'string') {
	            _codes = codes.trim().split(' ');
	        } else {
	            _codes = codes;
	        }
	
	        return that.filter(function(layer) {
	            var contCodes = layer.getProjectLayers().getArray().map(function(cont){
	                return cont.get('code');
	            });
	
	            return _.intersection(_codes, contCodes).length;
	        });
	    }
	});
	
	module.exports = LayerCollection;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var Model       = __webpack_require__(7),
	    ol          = __webpack_require__(22),
	    Events      = __webpack_require__(6);
	
	var Layer = Model.extend({
	
	    includes: Events,
	
	    /**
	     *
	     */
	    initialize: function(options) {
	        var that = this,
	            attributes;
	
	        options || (options = {});
	        attributes = options.attributes || {};
	        delete options['attributes'];
	
	        Layer.__super__.initialize.call(that, attributes, options);
	
	        that._prjLayers = false;
	        that._olSource = undefined;
	        that._olLayer = undefined;
	
	        if ('projectLayers' in that.options) {
	            that._prjLayers = that.options['projectLayers'];
	            delete that.options['projectLayers'];
	        }
	    },
	
	    /**
	     *
	     */
	    onAdd: function(view){
	        var that = this;
	
	        that._view = view;
	        return void (0);
	    },
	
	    /**
	     *
	     */
	    show: function(){
	        var that = this;
	
	        if (that._olLayer !== undefined) {
	            that['_olLayer'].setVisible(true);
	        }
	    },
	
	    /**
	     *
	     */
	    hide: function(){
	        var that = this;
	
	        if (that._olLayer !== undefined) {
	            that['_olLayer'].setVisible(false);
	        }
	    },
	
	    /**
	     *
	     */
	    isVisible: function(){
	        var that = this;
	        return that._olLayer !== undefined ? that._olLayer.getVisible() : false;
	    },
	
	    /**
	     *
	     */
	    toggle: function(){
	        var that = this;
	
	        that.isVisible() ? that.hide() : that.show();
	    },
	
	    /**
	     *
	     */
	    getMapLayer: function(){
	        return this._olLayer;
	    },
	
	    /**
	     *
	     */
	    getProjectLayers: function(){
	        return this._prjLayers;
	    },
	
	    /**
	     *
	     */
	    setMapLayer: function(layer){
	        var that = this;
	        if (layer instanceof ol.layer.Base) {
	            that._olLayer = layer;
	        }
	    },
	
	    /**
	     *
	     */
	    setSource: function(source){
	        var that = this;
	        if (source instanceof ol.source.Source) {
	            that._olLayer.setSource(source);
	        }
	    },
	
	    getSource: function(){
	        var that = this;
	        return that._olLayer.getSource();
	    }
	});
	
	module.exports = Layer;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var Layer       = __webpack_require__(41),
	    OmsSource   = __webpack_require__(43),
	    ol          = __webpack_require__(22);
	
	
	var TileLayer = Layer.extend({
	
	    initialize: function(options){
	        var that = this;
	        TileLayer.__super__.initialize.call(that, options);
	
	        that._olLayer = new ol.layer.Tile({
	            'visible': options.visible
	        });
	
	        that._setup(options);
	    },
	
	    _setup: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        if ('projectLayers' in options) {
	            that._prjLayers = options.projectLayers;
	        }
	
	        //...
	        if (that._prjLayers && that._prjLayers.getLength() > 0) {
	            that._olSource = new OmsSource({
	                crossOrigin: "anonymous",
	                layers: that._prjLayers.pluck('map_layer_id'),
	                urlTemplate: that.options.urlTemplate,
	                mapCode: that.options.mapCode,
	                tilesQuality: that.options.tilesQuality-1
	            });
	
	            that._olLayer.setSource(that._olSource);
	
	            if (that.options['activeLayers']) {
	                that.setActiveLayers(that.options['activeLayers']);
	            } else {
	                that.fire('activeLayersChange', {
	                    layerIds: that._prjLayers.pluck('map_layer_id')
	                });
	            }
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that = this;
	        that._olSource.update();
	    },
	
	    setActiveLayers: function(codes) {
	        var that = this,
	            layersForActivation,
	            layerIds;
	
	        layersForActivation = that._prjLayers.filter(function(l){
	            return ~codes.indexOf(l.get('code')) != 0;
	        });
	
	        layerIds = layersForActivation.pluck('map_layer_id');
	
	        that.getMapLayer()
	            .getSource()
	            .setActiveLayers(layerIds);
	
	        that.fire('activeLayersChange', {
	            layerIds: layerIds
	        });
	    },
	
	    activateLayers: function(codes) {
	        var that = this,
	            source = that.getMapLayer().getSource(),
	            layersForActivation,
	            layerIds;
	
	        if (source) {
	            layersForActivation = that._prjLayers.filter(function(l){
	                return ~codes.indexOf(l.get('code')) != 0;
	            });
	            layerIds = layersForActivation.pluck('map_layer_id');
	            layerIds = _.union(source.getActiveLayers(),layerIds);
	
	            that.getMapLayer()
	                .getSource()
	                .setActiveLayers(layerIds);
	
	            that.fire('activeLayersChange', {
	                layerIds: layerIds
	            });
	        }
	    },
	
	    deactivateLayers: function(codes) {
	        var that = this,
	            source = that.getMapLayer().getSource(),
	            layersForActivation,
	            layerIds;
	
	        if (source) {
	            layersForActivation = that._prjLayers.filter(function(l){
	                return ~codes.indexOf(l.get('code')) != 0;
	            });
	            layerIds = layersForActivation.pluck('map_layer_id');
	            layerIds = _.difference(source.getActiveLayers(),layerIds);
	
	            source.setActiveLayers(layerIds);
	
	            that.fire('activeLayersChange', {
	                layerIds: layerIds
	            });
	        }
	    },
	
	    getActiveLayerCodes : function() {
	        var that = this,
	            activeIds;
	        activeIds = that._olSource.getActiveLayers();
	
	        return that._prjLayers.filter(function(l){
	            return ~activeIds.indexOf(l.get('map_layer_id')) != 0;
	        }).getArray().map(function(l){
	            return l.get('code');
	        });
	    },
	
	    syncWithProject: function(without) {
	        var that = this;
	        var layersForActivation;
	        var oldActiveLayersHash;
	        var layersForActivationHash;
	        var source = that.getSource();
	
	        if (source) {
	            oldActiveLayersHash = [].concat(source.getActiveLayers()).sort(function(a, b) {
	                return a - b;
	            }).join(' ');
	
	            layersForActivation = that._prjLayers.filter(function(l) {
	                var res = l.get('selected');
	                if (without) {
	                    if (~without.indexOf(l.get('code'))) {
	                        res = ~source.getActiveLayers().indexOf(l.get('id'));
	                    }
	                }
	                return res;
	            }).pluck('id');
	
	            layersForActivationHash = [].concat(layersForActivation).sort(function(a, b) {
	                return a - b;
	            }).join(' ');
	
	            if (oldActiveLayersHash !== layersForActivationHash) {
	                source.setActiveLayers(layersForActivation);
	            }
	
	            return {
	                changes: oldActiveLayersHash !== layersForActivationHash,
	                oldLayers: oldActiveLayersHash !== "" ? oldActiveLayersHash.split(' ') : [],
	                newLayers: layersForActivationHash !== "" ? layersForActivationHash.split(' ') : []
	            };
	        }
	    }
	});
	
	module.exports = TileLayer;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(22);
	var $ = __webpack_require__(3);
	var utils = __webpack_require__(5);
	
	var pixelRatio = Math.round(utils.getDevicePixelRatio());
	
	var OmsSource = function(options){
	    var that = this,
	        _options = {};
	
	    that._urlTemplate = options.urlTemplate
	        ? options.urlTemplate
	        : "";
	
	    if (that._urlTemplate != "") {
	        if (options.tilesQuality){
	            that._urlTemplate += '&q=' + options.tilesQuality;
	        }
	        if (pixelRatio !== 1) {
	            that._urlTemplate += '&retina=' + pixelRatio;
	        }
	    }
	
	    that._layers = options.layers
	        ? options.layers
	        : [];
	
	    that._mapCode = options.mapCode
	        ? options.mapCode
	        : "";
	
	    delete options['urlTemplate'];
	    delete options['layers'];
	    delete options['mapCode'];
	
	    _options.tilePixelRatio = pixelRatio;
	    _options.transition = 0;
	
	    $.extend(true, _options, options);
	    _options.url = that._urlTemplate
	        .replace('{map_code}', that._mapCode)
	        .replace('{layers}', that._layers.join(','));
	
	    ol.source.XYZ.call(this, _options);
	
	    that.loadingTiles = [];
	
	    that.on('tileloadstart', function(e) {
	        that.loadingTiles.push(e.tile);
	    });
	
	    that.on(['tileloadend', 'tileloaderror'], function(e) {
	        var index = that.loadingTiles.indexOf(e.tile);
	        if(~index){
	            that.loadingTiles.splice(index, 1);
	        }
	    });
	
	    that.lastUpdateTimestamp = false;
	};
	
	/**
	 *
	 * @type {{setLayers: Function}}
	 */
	OmsSource.prototype = {};
	
	ol.inherits(OmsSource, ol.source.XYZ);
	
	OmsSource.prototype.setActiveLayers = function(ids){
	    var that = this,
	        url;
	
	    that._layers = ids;
	
	    if (!that._layers.length) {
	        that.setUrl('');
	        return;
	    }
	
	    url = that._urlTemplate
	        .replace('{map_code}', that._mapCode)
	        .replace('{layers}', that._layers.join(','));
	
	    if (that.lastUpdateTimestamp){
	        url += '&_=' + that.lastUpdateTimestamp;
	    }
	
	    that.setUrl(url);
	};
	
	OmsSource.prototype.getActiveLayers = function() {
	    return this._layers;
	};
	
	OmsSource.prototype.update = function() {
	    var that = this,
	        i, tile, notLoadedCount = 0;
	
	    for( i in that.tileCache.entries_){
	        tile = that.tileCache.entries_[i].value_;
	        if (tile.getState() != ol.TileState.LOADED) {
	            notLoadedCount += 1;
	        }
	    }
	    that.tileCache.clear();
	
	    that.dispatchEvent({
	        "type": 'cacheCleared',
	        'notLoaded': notLoadedCount
	    });
	    that.lastUpdateTimestamp = $.now();
	
	    that.changed();
	
	    that.setActiveLayers(that._layers);
	
	    return that;
	};
	
	OmsSource.prototype.cancelLoading = function() {
	    var that = this;
	
	    that.loadingTiles.forEach(function(tile){
	        tile.getImage().src = '';
	        tile.changed();
	    });
	
	    that.loadingTiles.length = 0;
	
	    return that;
	};
	
	module.exports = OmsSource;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var Layer = __webpack_require__(41),
	    $     = __webpack_require__(3),
	    ol    = __webpack_require__(22);
	
	var _ = __webpack_require__(16);
	
	var VectorLayer = Layer.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this;
	        VectorLayer.__super__.initialize.call(that, options);
	
	        that._olLayer = new ol.layer.Vector({
	            'visible': options.visible
	        });
	
	        that._olLayer.set('omjsLayer', that);
	        that._setup(options);
	    },
	
	    /**
	     *
	     * @param options
	     * @private
	     */
	    _setup: function(options){
	        var that     = this,
	            prjLayer,
	            features;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._prjLayers = options.projectLayers;
	        }
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0){
	            //prjLayer = that._prjLayers.at(0);
	
	            //prjLayer.objects.each(function(obj, i){
	            //    var geom = obj.getGeometry();
	//
	            //    if(geom && geom.type in ol.geom){
	            //        obj.feature = new ol.Feature({
	            //            obj     : obj,
	            //            geometry: new ol.geom[geom.type](geom.coordinates)
	            //        });
	            //        obj.feature.setId(obj.id);
	            //        features.push(obj.feature);
	            //    }
	            //});
	
	            that._olSource = new ol.source.Vector({
	                features: that.getFeatures()
	            });
	
	            if(that.options['clustering']){
	                that._olClusterSource = new ol.source.Cluster({
	                    distance: that.options['clustering'],
	                    source  : that._olSource
	                });
	                that._olLayer.setSource(that._olClusterSource);
	            }else{
	                that._olLayer.setSource(that._olSource);
	            }
	        }
	        return that;
	    },
	
	    getFeatures: function() {
	        var that = this,
	            features = [];
	
	        that._prjLayers.at(0).objects.each(function(obj, i){
	            var geom = obj.getGeometry();
	
	            if(geom && geom.type in ol.geom){
	                obj.feature = new ol.Feature({
	                    obj     : obj,
	                    geometry: new ol.geom[geom.type](geom.coordinates)
	                });
	                obj.feature.setId(obj.id);
	                features.push(obj.feature);
	            }
	        });
	
	        return features;
	    },
	
	    updateLayer: function() {
	        var that = this;
	        that._prjLayers.at(0).loadObjects(that.options).then(function () {
	            that._olSource.clear();
	            that._olSource.addFeatures(that.getFeatures());
	        });
	
	    },
	
	    setStyle: function(style){
	        var that = this;
	        that._olLayer.setStyle(style);
	    },
	
	    syncWithProject: function(){
	        var that = this;
	        var projectLayer = that.getProjectLayers();
	
	        if (!projectLayer) {
	            return false;
	        }
	
	        projectLayer = projectLayer.at(0);
	
	        if (projectLayer) {
	            if (projectLayer.get('selected')) {
	                that.show();
	            } else {
	                that.hide();
	            }
	        }
	    }
	});
	
	module.exports = VectorLayer;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var VectorLayer = __webpack_require__(44),
	    ol = __webpack_require__(22),
	    _ = __webpack_require__(16),
	    $ = __webpack_require__(3),
	    utils = __webpack_require__(5);
	
	var devPixelRatio = 1 / utils.getDevicePixelRatio();
	
	var OmsVectorLayer = VectorLayer.extend({
	
	    _setup: function(options){
	        var that = this,
	            vStyle,
	            clusterSizeOptionsOverride;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._prjLayers = options.projectLayers;
	        }
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0){
	            clusterSizeOptionsOverride = that._prjLayers.at(0).options.clusterSize || {};
	            that.cluserSizeOptions = {
	                // желательно иметь небольшой буфер вокруг рисуемых фигур (в данном случае 1px с каждой стороны 20x17 vs 18x15)
	                // т.к. на устройствах с нечётным pixel ratio, например galaxy tab, при масштабировании canvas
	                // теряется часть однопиксельной обводки. При толстой обводке, или при рисовании circle это не так критично
	                width       : 20,
	                height      : 17,
	                // допустимые figures и их опции в Utils.createObjectsCountCnv
	                figures     : [
	                    // по умолчанию
	                    {
	                        width       : 18,
	                        height      : 15,
	                        type        : 'rect',
	                        radius      : 2,
	                        strokeStyle : '#7fa3c6',
	                        fillStyle   : '#fff',
	                        lineWidth   : 1
	                    }
	                ],
	                fontSize    : 20,
	                fontFamily  : 'Arial',
	                textAlign   : 'center',
	                textBaseline: 'middle',
	                textColor   : '#000'
	            };
	            // deep extend не нужен, т.к. figures "по умолчанию" нужно перетереть новыми
	            $.extend(
	                that.cluserSizeOptions, 
	                clusterSizeOptionsOverride, 
	                that.view.options.misc_data.objects_counter_style
	            );
	            vStyle = that._prjLayers.at(0).get('vectorSettings');
	            if (!vStyle) {
	                throw new Error("Not enough parameters to create a vector layer");
	            }
	            if (vStyle['clusteringEnabled']) {
	                that.options['clustering'] = vStyle['clusterSettings'].radius;
	            }
	
	            that.project = that._prjLayers.at(0).options.project;
	
	            OmsVectorLayer.__super__._setup.call(that, options);
	
	            that._setZoomRange();
	            that.switchLayerSource();
	            that.setLayerStyle();
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that = this;
	        OmsVectorLayer.__super__.updateLayer.call(that);
	
	    },
	
	    onAdd: function(view){
	        var that = this;
	        that.view = view;
	        that.map = view.getMap();
	        that.map.getView().on('change:resolution', function(){
	            if (that._prjLayers) {
	                that.switchLayerSource();
	            }
	        });
	    },
	
	    switchLayerSource: function(){
	        var that = this;
	        var zoom;
	        var cStyle = that._prjLayers.at(0).get('vectorSettings').clusterSettings;
	
	        if (!that.map) {
	            return;
	        }
	        zoom = that.map.getView().getZoom();
	
	        if (that._prjLayers.at(0).get('vectorSettings').clusteringEnabled) {
	            if (cStyle['maxZoomEnabled'] && zoom > cStyle.maxZoom) {
	                that._olLayer.setSource(that._olSource);
	            } else {
	                that._olLayer.setSource(that._olClusterSource);
	            }
	        } else {
	            that._olLayer.setSource(that._olSource);
	        }
	    },
	
	
	    _setZoomRange: function(){
	        var that = this,
	            vStyle = that._prjLayers.at(0).get('vectorSettings'),
	            startResolution = 156543.03392804097;
	
	        if (vStyle['zoomsEnabled']) {
	            that._olLayer.setMinResolution(startResolution / Math.pow(2, vStyle.maxZoom));
	            that._olLayer.setMaxResolution(startResolution / Math.pow(2, vStyle.minZoom)+0.5);
	        } else {
	            that._olLayer.setMinResolution(startResolution / Math.pow(2, 22));
	            that._olLayer.setMaxResolution(startResolution+0.5);
	        }
	    },
	
	    _createImgLoader: function(iconUrl) {
	        var that = this;
	
	        that.imgCache[iconUrl] = new Image();
	        that.imgCache[iconUrl].def = $.Deferred();
	        that.imgCache[iconUrl].crossOrigin = 'anonymous';
	        that.imgCache[iconUrl].onload = function(){
	            this.def.resolve(true);
	        };
	        return that.imgCache[iconUrl].def;
	    },
	
	    _reloadLayerIcons: function(){
	        var that = this,
	            master = $.Deferred(),
	            defs = [],
	            i, vStyle,
	            url;
	
	        vStyle = that._prjLayers.at(0).get('vectorSettings');
	
	        that.imgCache = {};
	
	        if (vStyle.stylesPoint.icon) {
	            defs.push(that._createImgLoader(vStyle.stylesPoint.icon));
	        }
	
	
	        if (vStyle.clusteringEnabled && vStyle.clusterSettings.icon  && vStyle.clusterSettings.iconEnabled 
	            && that.imgCache[vStyle.clusterSettings.icon] === undefined) {
	            defs.push(that._createImgLoader(vStyle.clusterSettings.icon));
	        }
	
	        if (_.isEmpty(that.imgCache)) {
	            master.resolve(true);
	            return master;
	        }
	
	        $.when.apply($,defs).then(function(){
	            master.resolve(true);
	        });
	
	        for (i in that.imgCache) {
	            url = that.project.apiUrlLocation.protocol
	                  + '//'
	                  + that.project.apiUrlLocation.hostname
	                  + i + '?r=' + Math.floor(Math.random() * (999999)) + 1;
	            that.imgCache[i].src = url;
	        }
	        return master;
	    },
	
	    setLayerStyle: function(){
	        var that = this,
	            layer = that._olLayer,
	            vStyle = that._prjLayers.at(0).get('vectorSettings'),
	            iconImg;
	
	        // update images, then set layer style function
	        that._reloadLayerIcons().done(function(){
	
	            // Чистим сохраненные стили
	            that.styleCache = {};
	            layer.setStyle(function(feature, resolution){
	                var size = feature.get('features') ? feature.get('features').length : 1,
	                    styles = [],
	                    scale,
	                    offset = vStyle.stylesPoint.iconOffsetEnabled
	                        ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
	                        : [0,0];
	
	                if (resolution+'' in that.styleCache) {
	                    if (that.styleCache[resolution+''][size]) {
	                        return that.styleCache[resolution+''][size];
	                    }
	                } else {
	                    that.styleCache[resolution+''] = [];
	                }
	
	                if (size > 1) {
	
	                    var min = 2, max = 2;
	                    layer.getSource().getFeatures().forEach(function(f){
	                        min = Math.min(min, f.get('features').length);
	                        max = Math.max(max, f.get('features').length);
	                    });
	
	                    var sizeDelta = vStyle.clusterSettings.iconSizeMax - vStyle.clusterSettings.iconSizeMin;
	                    var iconSize = parseInt(vStyle.clusterSettings.iconSizeMin + sizeDelta * (size-min)/(max-min));
	
	                    if (vStyle.clusterSettings.icon != null && vStyle.clusterSettings.iconEnabled) {
	                        iconImg = that.imgCache[vStyle.clusterSettings.icon];
	                        offset = vStyle.clusterSettings.iconOffsetEnabled
	                            ? [-vStyle.clusterSettings.iconDx, -vStyle.clusterSettings.iconDy]
	                            : [0,0];
	                    } else {
	                        iconImg = that.imgCache[vStyle.stylesPoint.icon];
	                        offset = vStyle.stylesPoint.iconOffsetEnabled
	                            ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
	                            : [0,0];
	                    }
	
	                    offset[0] += iconImg.width/2;
	                    offset[1] += iconImg.height/2;
	
	                    scale =  vStyle.clusterSettings.iconSizeEnabled ? iconSize/iconImg.width : 1;
	
	                    styles.push(new ol.style.Style({
	                        image: new ol.style.Icon({
	                            anchor: offset,
	                            anchorXUnits: 'pixels',
	                            anchorYUnits: 'pixels',
	                            opacity: 1,
	                            img: iconImg,
	                            imgSize:[iconImg.width,iconImg.height],
	                            scale: scale
	                        })
	                    }));
	
	                    // count style
	                    if (vStyle.clusterSettings.showObjectsCount) {
	                        try {
	                            scale = 1 / (that.pixelRatio || devPixelRatio);
	                            var countIcon = utils.createObjectsCountCnv(size < 100 ? size.toString() : '*', scale,
	                                that.cluserSizeOptions);
	                                styles.push(new ol.style.Style({
	                                image: new ol.style.Icon({
	                                    anchor: [
	                                        (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
	                                        (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
	                                    ],
	                                    anchorXUnits: 'pixels',
	                                    anchorYUnits: 'pixels',
	                                    opacity: 1,
	                                    imgSize: [countIcon.width, countIcon.height],
	                                    img: countIcon,
	                                    scale: 1 / scale
	                                })
	                            }));
	                        } catch (err) {
	                            console.error(err);
	                        }
	                    }
	                } else {
	                    // one feature style
	                    iconImg = that.imgCache[vStyle.stylesPoint.icon];
	                    offset[0] += iconImg.width/2;
	                    offset[1] += iconImg.height/2;
	
	                    styles.push(new ol.style.Style({
	                        image: new ol.style.Icon({
	                            anchor: offset,
	                            anchorXUnits: 'pixels',
	                            anchorYUnits: 'pixels',
	                            opacity: 1,
	                            img: iconImg,
	                            imgSize:[iconImg.width,iconImg.height]
	                        })
	                    }));
	                }
	
	                that.styleCache[resolution+''][size] = styles;
	                return styles;
	            });
	        });
	    }
	});
	
	module.exports = OmsVectorLayer;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var ImageLayer = __webpack_require__(47),
	    OLVectorLayerStyle = __webpack_require__(48),
	    ol = __webpack_require__(22),
	    $ = __webpack_require__(3);
	
	var OmsVectorFeatureLayer = ImageLayer.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this;
	        OmsVectorFeatureLayer.__super__.initialize.call(that, options);
	    },
	
	    _setup: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._prjLayers = options.projectLayers;
	        }
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0){
	
	            that.project = that._prjLayers.at(0).options.project;
	            // страшный костыль, т.к. нет нормального пути до изображений
	            that.markerImgUrl = that.project.options.apiUrl.replace(/\/api\/[0-9\.]+\//g, '/img/');
	
	            OmsVectorFeatureLayer.__super__._setup.call(that, options);
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that     = this;
	        that.styleCache = {};
	        OmsVectorFeatureLayer.__super__.updateLayer.call(that, that.options);
	    },
	
	    setLayerStyle: function(){
	        var that = this,
	            layer = that._olLayer,
	            mapStyles = {},
	            i,
	            prjLayersCount,
	            code,
	            regExpTooltip = /-tooltip$/;
	
	        // Чистим сохраненные стили
	        // todo т.к. кеш м.б. достаточно громодким, необходимо организовать его очистку по уму
	        that.styleCache = {};
	        that.hiddenStyle = [];
	        that.layerSort = {};
	        prjLayersCount = that._prjLayers.getLength();
	
	        for (i = 0; i < prjLayersCount; i ++) {
	            code = that._prjLayers.getArray()[i].get('code');
	            // не используется sort слоя, потому что он не глобальный
	            that.layerSort[code] = prjLayersCount - i;
	            if (!that._prjLayers.getArray()[i].get('mapnik_style')) {
	                continue;
	            }
	            mapStyles[code] = new OLVectorLayerStyle(that._prjLayers.getArray()[i].get('mapnik_style'), (prjLayersCount - i), that.markerImgUrl);
	            // коды для тултипов
	            mapStyles[code].styles.forEach(function (style) {
	                if (!regExpTooltip.test(style['name'])) {
	                    return;
	                }
	                style.rules.forEach(function (rule) {
	                    if (!rule.symbolizers.TEXT || !rule.symbolizers.TEXT.cdata) {
	                        return;
	                    }
	                    that._prjLayers.getArray()[i].set('popupCode', rule.symbolizers.TEXT.cdata);
	                });
	            });
	        }
	
	        layer.setStyle(function pointStyleFunction(feature, resolution) {
	            if (~that.activeLayersCodes.indexOf(feature.get('layer')) == 0 || !mapStyles[feature.get('layer')]) {
	                return that.hiddenStyle;
	            }
	            var featureHighlighted = !!feature.get('highlighted');
	            var cacheKey = '' + resolution + ':' + feature.get('layer') + ':' + feature.get('orbis_id') + ':' + (featureHighlighted ? '1' : '0');
	            if (cacheKey in that.styleCache) {
	                return that.styleCache[cacheKey];
	            }
	            var curZoom = that._view.getMap().getView().getZoom();
	            var styles = mapStyles[feature.get('layer')].getStyle(feature, curZoom, that.layerSort);
	            var highlightStyle,
	                highlightStyleFill,
	                imageSize,
	                canvas,
	                shadowOffset,
	                canvasContext,
	                rgbaFill,
	                baseZIndex;
	            // подстветка hover
	            if (featureHighlighted) {
	                highlightStyle = styles.filter(function (style) {
	                    return !!style.getImage();
	                });
	                highlightStyleFill = styles.filter(function (style) {
	                    return !!style.getFill();
	                });
	                if (highlightStyle && highlightStyle.length) {
	                    imageSize = highlightStyle[0].getImage().getImageSize();
	                    canvas = $("<canvas></canvas>");
	                    shadowOffset = 2;
	                    canvas
	                        .attr({
	                            width: imageSize[0] + shadowOffset * 2,
	                            height: imageSize[1] + shadowOffset * 2
	                        })
	                        .css({
	                            width: imageSize[0] + shadowOffset * 2,
	                            height: imageSize[1] + shadowOffset * 2
	                        });
	                    canvasContext = canvas[0].getContext("2d");
	
	                    canvasContext.shadowColor = "rgba( 0, 0, 0, 0.3 )";
	                    canvasContext.shadowOffsetX = shadowOffset;
	                    canvasContext.shadowOffsetY = shadowOffset;
	                    canvasContext.shadowBlur = shadowOffset;
	                    canvasContext.drawImage(highlightStyle[0].getImage().getImage(), shadowOffset, shadowOffset);
	
	                    try {
	                        baseZIndex = OLVectorLayerStyle.baseZIndexMultiplier * (
	                            that.layerSort && that.layerSort[feature.get('layer')]
	                                ? that.layerSort[feature.get('layer')]
	                                : 0
	                            );
	                        that._setImageGamma(canvas[0], canvasContext, 1.06);
	                        styles.push(new ol.style.Style({
	                            image: new ol.style.Icon({
	                                src: canvas[0].toDataURL(),
	                                scale: highlightStyle[0].getImage().getScale(),
	                                opacity: 1,
	                                rotation: highlightStyle[0].getImage().getRotation()
	                            }),
	                            // здесь, как и в OLVectorLayerStyle, нужно учитывать грандиозность размеров ZIndex
	                            // из-за использование Y координат для построения сортировок отображения объектов
	                            zIndex: 1000 * OLVectorLayerStyle.baseZIndexMultiplier + baseZIndex
	                        }));
	                    } catch (e) {
	                        highlightStyle[0].getImage().setOpacity(highlightStyle[0].getImage().getOpacity() * 0.6);
	                    }
	                    canvas.detach();
	                }
	                if (highlightStyleFill && highlightStyleFill.length) {
	                    rgbaFill = OLVectorLayerStyle.getRGBish(highlightStyleFill[0].getFill().getColor(), true);
	                    rgbaFill = [rgbaFill[0] * 1.06 * 1.06, rgbaFill[1] * 1.06 * 1.06, rgbaFill[2] * 1.06 * 1.06, rgbaFill[3]];
	                    rgbaFill[0] = rgbaFill[0] > 255 ? 255 : rgbaFill[0];
	                    rgbaFill[1] = rgbaFill[1] > 255 ? 255 : rgbaFill[1];
	                    rgbaFill[2] = rgbaFill[2] > 255 ? 255 : rgbaFill[2];
	                    highlightStyleFill[0].getFill().setColor('rgba('+Math.trunc(rgbaFill[0])+', '+Math.trunc(rgbaFill[1])+', '+Math.trunc(rgbaFill[2])+', '+rgbaFill[3]+')');
	                }
	                styles.forEach(function (style) {
	                    if (style.getText()) {
	                        // текст подсвеченного объекта должен отрисоваться раньше остальных текстов, но не раньше объектов
	                        style.setZIndex(style.getZIndex() - 100 * OLVectorLayerStyle.baseZIndexMultiplier);
	                    }
	                });
	            }
	
	            that.styleCache[cacheKey] = styles;
	
	            return styles;
	        });
	    },
	
	    _setImageGamma: function(canvas, context, gamma) {
	        var pix = context.getImageData(0, 0, canvas.width, canvas.height);
	        var x, y, i, r, g, b, a, ret;
	        //Loop through the pixels
	        for (x = 0; x < canvas.width; x++) {
	            for (y = 0; y < canvas.height; y++) {
	                i = (y * canvas.width + x) * 4;
	                r = pix.data[i];
	                g = pix.data[i + 1];
	                b = pix.data[i + 2];
	                a = pix.data[i + 3];
	                ret = [r * gamma * gamma, g * gamma * gamma, b * gamma * gamma, a];
	                pix.data[i] = ret[0];
	                pix.data[i + 1] = ret[1];
	                pix.data[i + 2] = ret[2];
	                pix.data[i + 3] = ret[3];
	            }
	        }
	
	        //Put the image back to the canvas
	        context.clearRect(0, 0, canvas.width, canvas.height);
	        context.putImageData(pix, 0, 0);
	    }
	});
	
	module.exports = OmsVectorFeatureLayer;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var Layer           = __webpack_require__(41),
	    OLVectorLayerStyle   = __webpack_require__(48),
	    ol              = __webpack_require__(22),
	    $               = __webpack_require__(3),
	    _ =             __webpack_require__(16);
	
	var ImageLayer = Layer.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this;
	        ImageLayer.__super__.initialize.call(that, options);
	
	        that._olLayer = new ol.layer.Vector({
	            visible: options.visible,
	            renderMode: 'image'
	        });
	
	        that._olLayer.set('omjsLayer', that);
	        // для отслеживания актуальности запроса объектов при поступлении новго запроса
	        that.lastRequestTime = 0;
	        // текущий запрос объектов, отменяется при наличии нового
	        that.xhrGeoJSON = false;
	        that._setup(options);
	    },
	
	    /**
	     *
	     * @param options
	     * @private
	     */
	    _setup: function(options){
	        var that     = this;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._prjLayers = options.projectLayers;
	        }
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0) {
	
	            // source всегда один, управление идет через набор фич
	            // т.к. ImageVector не имеет setSource, а при ппересоздании ImageVector карта мигает
	            that._olSource = new ol.source.Vector({
	                features: []
	            });
	
	            // эмуляция отмена загрузки тайлов (для проекта ImageVector прикидывается тайловым слоем)
	            // с полезной функцией отмены загрузки объектов, geojson может быть большого размера
	            that._olSource.cancelLoading = function () {
	                if (that.xhrGeoJSON && typeof that.xhrGeoJSON.abort == 'function') {
	                    that.xhrGeoJSON.abort();
	                }
	            };
	            that._olLayer.setSource(that._olSource);
	
	            that.setLayerStyle();
	            if (that.options['activeLayers']) {
	                that.setActiveLayers(that.options['activeLayers']);
	            } else {
	                that.fire('activeLayersChange', {
	                    layerIds: that._prjLayers.pluck('map_layer_id')
	                });
	            }
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that     = this;
	        that.setActiveLayers(that.getActiveLayerCodes());
	    },
	
	    setActiveLayers: function(codes) {
	        var that = this,
	            layersForActivation,
	            layerIds,
	            objectsFields = [],
	            requestTime,
	            requestData = {};
	
	        layersForActivation = that._prjLayers.filter(function(l){
	            return ~codes.indexOf(l.get('code')) != 0;
	        });
	
	        that.activeLayersCodes = layersForActivation.pluck('code');
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0) {
	
	            layerIds = that._prjLayers.getArray().filter(function (l) {
	                return ~that.activeLayersCodes.indexOf(l.get('code')) != 0;
	            }).map(function (l) {
	                return l.get('id');
	            }).sort();
	
	            if (layerIds.length) {
	
	                // перпезапрос списка объектов при изменении набора активных слоев
	                // с актуализацией запрашиваемых полей по объектам
	                objectsFields = [].concat.apply([], that._prjLayers.getArray().filter(function (l) {
	                    return ~that.activeLayersCodes.indexOf(l.get('code')) != 0;
	                }).map(function (l) {
	                    return l.get('mapnik_style')
	                        ? OLVectorLayerStyle.getObjectsFields(l.get('mapnik_style'))
	                        : [];
	                }));
	
	                objectsFields = _.uniq(objectsFields).sort();
	                that.lastRequestTime = requestTime = (new Date()).getTime();
	                if (objectsFields.length) {
	                    requestData['fields'] = objectsFields.join(',');
	                }
	                if (that.project.lng) {
	                    requestData['lng'] = that.project.lng;
	                }
	                if (that.project.token) {
	                    requestData['token'] = that.project.token;
	                }
	                that.xhrGeoJSON = $.ajax({
	                    // url до geojson зашит, при добавлении новых форматов необходимо выносить в настройки
	                    url: that.options.urlTemplate + that.options.mapCode + '/layers/' + layerIds.join(',') + '.geojson',
	                    crossDomain: true,
	                    method: "GET",
	                    dataType: "json",
	                    requestTime: requestTime,
	                    data: requestData
	                }).done(function (geoJSON) {
	                    if (that.lastRequestTime > this.requestTime) {
	                        return;
	                    }
	                    var features = (new ol.format.GeoJSON()).readFeatures(geoJSON);
	                    that.getMapLayer().getSource().clear();
	                    that.getMapLayer().getSource().addFeatures(features);
	                });
	
	            } else if(that.getMapLayer().getSource()) {
	                that.getMapLayer().getSource().clear();
	            }
	            that.fire('activeLayersChange', {
	                layerIds: layerIds
	            });
	        }
	    },
	
	    activateLayers: function(codes) {
	        var that = this,
	            layersForActivation,
	            layerCodes,
	            layerIds;
	
	        layersForActivation = that._prjLayers.filter(function(l){
	            return ~codes.indexOf(l.get('code')) != 0;
	        });
	        layerCodes = layersForActivation.pluck('code');
	        layerCodes = _.union(that.getActiveLayerCodes(), layerCodes);
	
	        layerIds = layersForActivation.pluck('id');
	        layerIds = _.union(that.getActiveLayerIds(), layerIds);
	
	        that.setActiveLayers(layerCodes);
	
	        that.fire('activeLayersChange', {
	            layerIds: layerIds
	        });
	    },
	
	    deactivateLayers: function(codes) {
	        var that = this,
	            layersForActivation,
	            layerCodes,
	            layerIds;
	
	        layersForActivation = that._prjLayers.filter(function(l){
	            return ~codes.indexOf(l.get('code')) != 0;
	        });
	        layerCodes = layersForActivation.pluck('code');
	        layerCodes = _.difference(that.activeLayersCodes, layerCodes);
	
	        layerIds = layersForActivation.pluck('id');
	        layerIds = _.difference(that.getActiveLayerIds(), layerIds);
	
	        that.setActiveLayers(layerCodes);
	
	        that.fire('activeLayersChange', {
	            layerIds: layerIds
	        });
	    },
	
	    getActiveLayerCodes : function() {
	        var that = this,
	            activeCodes;
	        activeCodes = that.activeLayersCodes;
	
	        return that._prjLayers.filter(function(l) {
	            return ~activeCodes.indexOf(l.get('code')) != 0;
	        }).getArray().map(function(l) {
	            return l.get('code');
	        });
	    },
	
	    getActiveLayerIds : function() {
	        var that = this,
	            activeCodes;
	        activeCodes = that.activeLayersCodes;
	
	        return that._prjLayers.filter(function(l) {
	            return ~activeCodes.indexOf(l.get('code')) != 0;
	        }).getArray().map(function(l) {
	            return l.get('id');
	        });
	    },
	
	    syncWithProject: function(without) {
	        var that = this;
	        var layersForActivation;
	        var oldActiveLayersHash;
	        var layersForActivationHash;
	
	        if (that._prjLayers && that._prjLayers.getLength() > 0) {
	            oldActiveLayersHash = [].concat(this.getActiveLayerIds()).sort(function(a, b) {
	                return a - b;
	            }).join(' ');
	
	            layersForActivation = that._prjLayers.filter(function(l) {
	                var res = l.get('selected');
	                if (without) {
	                    if (~without.indexOf(l.get('code'))) {
	                        res = ~that.activeLayersCodes.indexOf(l.get('code'));
	                    }
	                }
	                return res;
	            });
	
	            var layersForActivationIds = layersForActivation.pluck('id');
	
	            layersForActivationHash = [].concat(layersForActivationIds).sort(function(a, b) {
	                return a - b;
	            }).join(' ');
	
	            if (oldActiveLayersHash !== layersForActivationHash) {
	                this.setActiveLayers(layersForActivation.pluck('code'));
	            }
	
	            return {
	                changes: oldActiveLayersHash !== layersForActivationHash,
	                oldLayers: oldActiveLayersHash !== "" ? oldActiveLayersHash.split(' ') : [],
	                newLayers: layersForActivationHash !== "" ? layersForActivationHash.split(' ') : []
	            };
	        }
	    }
	});
	
	module.exports = ImageLayer;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var Model   = __webpack_require__(7),
	    $       = __webpack_require__(3),
	    ol      = __webpack_require__(22),
	    _       = __webpack_require__(16);
	var OLVectorLayerStyle = Model.extend({
	
	    initialize: function(mapnikStyleXML, zIndex, markerImgUrl){
	
	        var that = this;
	        that.zIndex = zIndex;
	        that.markerImgUrl = markerImgUrl;
	        that.styles = [];
	        that._parseStyle(mapnikStyleXML);
	    },
	
	    _scaleDenominatorToZoomLevel: function (inputDenominator) {
	        var scaleDenominators = [
	            279541132.014, //1
	            139770566.007, //2
	            69885283.0036, //3
	            34942641.5018, //4
	            17471320.7509, //5
	            8735660.37545, //6
	            4367830.18772, //7
	            2183915.09386, //8
	            1091957.54693, //9
	            545978.773466, //10
	            272989.386733, //11
	            136494.693366, //12
	            68247.3466832, //13
	            34123.6733416, //14
	            17061.8366708, //15
	            8530.9183354,  //16
	            4265.4591677,  //17
	            2132.72958385,  //18
	            1066.364791925,  //19
	            533.1823959625,  //20
	            266.59119798125,  //21
	            133.295598990625,  //22
	            66.6477994953125,  //23
	            33.32389974765625,  //24
	            16.661949873828124,  //25
	            8.330974936914062,  //26
	            4.165487468457031,  //27
	            2.0827437342285156,  //28
	            1.0413718671142578,  //29
	            0.5206859335571289  //30
	        ];
	        // Zoom level is 18 if smaller than 2132.729...
	        var zoomLevel         = 30;
	
	        scaleDenominators.forEach(function (denominator, index) {
	            if (inputDenominator >= scaleDenominators[0])
	                zoomLevel = 0;
	            else if (inputDenominator > denominator &&
	                inputDenominator <= scaleDenominators[index - 1])
	            //TODO make test for authencity
	                zoomLevel = index + 1;
	        });
	
	        //zoomLevel-=2;//???
	        if(zoomLevel <=0){
	            zoomLevel = 0;
	        }
	
	        if(zoomLevel >= 20){
	            zoomLevel = 20;
	        }
	
	
	        return zoomLevel;
	    },
	
	    _preprocessMapnikFilter: function (filter) {
	        var _filter;
	        _filter = filter.replace(/(\]\s*)(&lt;=|&gt;=|\!=|=|&gt;|&lt;)(\s*)([^='\s\[\]()]+)/g, '$1$2$3\'$4\'');
	        return _filter;
	    },
	
	    _postProcessJSFilter: function (filter) {
	        var _filter;
	        _filter = filter.replace(/(<=|>=|\!=|==|>|<)(\s*)\'null\'/g, '$1$2null');
	        return _filter;
	    },
	
	    _parseStyle: function(xmlMapnikStyle){
	        var that = this;
	        var ruleParsers = OLVectorLayerStyle.SymbolizerParsers;
	        var style = {
	            rules     : [],
	            filterMode: 'all', // Если first, значит берём первый подходящий стиль для объекта и останавливаемся.
	            name      : '',
	            opacity   : 1 // TODO: Мапник может отдать стиль с прозрачностью. Нужно обработать этот параметр.
	        };
	
	        var rule = {
	            maxScale: null,
	            minScale: null,
	            filter  : null,
	
	            symbolizers: {
	                LINE          : null,
	                LINEPATTERN   : null,
	                POLYGON       : null,
	                POLYGONPATTERN: null,
	                POINT         : null,
	                TEXT          : null,
	                RASTER        : null,
	                SHIELD        : null,
	                BUILDING      : null,
	                MARKERS       : null,
	                GLYPH         : null
	            }
	        };
	
	        var styles = $(xmlMapnikStyle.replace(/<Style/g, '<s').replace(/<\/Style/g, '</s').replace(/<!\[CDATA\[/g, '')).filter('s');
	
	        styles.each(function(){
	            var $this = $(this),
	                s = null,
	                rules = $this.find('rule'),
	                filterMode = $this.attr('filter-mode'),
	                name = $this.attr('name');
	
	            if(!rules.length) return;
	
	            s = $.extend(true, {}, style);
	
	            s.filterMode = (filterMode == 'first')
	                ? 'first'
	                : 'all';
	
	            s.name = name;
	
	            rules.each(function(){
	                var r = $.extend(true, {}, rule);
	
	                $(this).children().each(function(){
	
	                    var props;
	                    var tag = this.tagName.replace('SYMBOLIZER', '');
	
	                    // TODO: Нужно ещё распарсить AlsoFilter и ElseFilter
	
	                    if(!(tag in ruleParsers)) return;
	
	                    switch(tag){
	                        case 'MINSCALEDENOMINATOR':
	                            r['minScale'] = parseInt(this.innerHTML);
	                            break;
	                        case 'MAXSCALEDENOMINATOR':
	                            r['maxScale'] = parseInt(this.innerHTML);
	                            break;
	                        case 'FILTER':
	                            r['filter'] = that._postProcessJSFilter(ruleParsers[tag](that._preprocessMapnikFilter(this.innerHTML)));
	                            break;
	                        default:
	                            props = that._getSymbolizePoperties(this);
	                            if(props){
	                                r.symbolizers[tag] = ruleParsers[tag](props, {'markerImgUrl': that.markerImgUrl});
	                            }
	                            break;
	                    }
	                });
	
	                s.rules.push(r);
	            });
	
	            that.styles.push(s);
	        });
	
	        that.styles = that.styles.reverse();
	    },
	
	    getStyle: function(feature, curZoom, layerSort, invertPriority){
	        var that = this,
	            matchedRules = [],
	            i, ii, rule, s,
	            matchedStyles = [];
	
	        for(i in that.styles){
	            for(ii in that.styles[i].rules){
	                rule = that.styles[i].rules[ii];
	                // Тестим на min scale
	                if(rule.minScale != null && curZoom >= that._scaleDenominatorToZoomLevel(parseInt(rule.minScale))) continue;
	                // Тестим на max scale
	                if(rule.maxScale != null && curZoom < that._scaleDenominatorToZoomLevel(parseInt(rule.maxScale))) continue;
	                // Тестим на фильтр
	                if(!that.matchFilter(feature, rule.filter)) continue;
	                s = $.extend(true, {}, rule.symbolizers);
	                if(s['TEXT'] !== null && s['TEXT']['cdata'] !== null){
	                    s['TEXT']['cdata'] = (feature.get(s['TEXT']['cdata']) !== undefined)
	                        ? feature.get(s['TEXT']['cdata'])
	                        : '';
	                }
	                matchedRules.push(s);
	                if(that.styles[i].filterMode == 'first') break;
	            }
	        }
	        matchedRules.forEach(function (rule) {
	            _.keys(OLVectorLayerStyle.SymbolizerParsers).forEach(function (symbol) {
	                if (rule[symbol] === null) {
	                    return;
	                }
	                // инвертированная сортировка слоя: выше в дереве OMS, больше значение, ибо нужен ZIndex (больше = выше)
	                var baseZIndex = layerSort && layerSort[feature.get('layer')] ? layerSort[feature.get('layer')] : 0;
	                // но так как необходимо работать с большими величинами смещения
	                baseZIndex *= OLVectorLayerStyle.baseZIndexMultiplier;
	                // для точечных объектов (их текстов и иконок) - особая магия
	                // #7826 - требование, чтобы нижние объекты (по Y координате) перекрывали те, что выше, в пределах слоя
	                // А чтобы точки не начали выбиваться относительно остальных слоев
	                // (они при прочих равных и так выше остальных типов геометрии)
	                // остальные слои сделаем чуточку ниже, чем максимтальный Y
	                var pointZIndexDecrement = 21 * 1000 * 1000;
	
	                // TODO для MVT на данный момент используется упрощенный формат фич, у его геометрии нет getCoordinates
	                if (~feature.getGeometry().getType().indexOf('Point') && feature.getGeometry().getCoordinates) {
	                    pointZIndexDecrement = feature.getGeometry().getCoordinates()[1];
	                    // Т.к. Y - инвертированный, то вычитание меньшего Y дасть больший ZIndex
	                    // однако mvt рисует точки в обратном порядке -_- (потому что они вне основного приоритета отрисовки),
	                    // надо инвертировать "декремент"
	                    if (invertPriority) {
	                        pointZIndexDecrement *= -1;
	                    }
	                }
	                baseZIndex -= pointZIndexDecrement;
	
	                switch (symbol) {
	                    case 'TEXT':
	                        matchedStyles.push(new ol.style.Style({
	                            text: new ol.style.Text({
	                                font: 'bold'
	                                + ' ' + rule[symbol]['size'] + 'px '
	                                + rule[symbol]['face-name'],
	                                offsetY: rule[symbol]['dy'],
	                                offsetX: rule[symbol]['dx'],
	                                fill: ol.style.Fill({
	                                    color: rule[symbol]['fill']
	                                }),
	                                stroke: (rule[symbol]['halo-radius']
	                                    ? new ol.style.Stroke({
	                                    color: rule[symbol]['halo-fill'],
	                                    width: rule[symbol]['halo-radius']
	                                })
	                                    : undefined),
	                                text: '' + rule[symbol]['cdata'],
	                                textBaseline: rule[symbol]['base-line'],
	                                textAlign: rule[symbol]['text-align'],
	                                overlap: rule[symbol]['allow-overlap']
	                            }),
	                            // тексты должны быть выше остального и иметь обратный ZIndex,
	                            // чтобы в общем они рисовались позже остальных объектов
	                            // но тексты более приоритетных слоев должны отрисоваться раньше,
	                            // чтобы вытеснить при необходимости менее приоритетные тексты
	                            zIndex: 1000 * OLVectorLayerStyle.baseZIndexMultiplier - baseZIndex
	                        }));
	                        break;
	
	                    case 'POINT':
	                        if (rule[symbol]['file'] !== null) {
	                            matchedStyles.push(new ol.style.Style({
	                                image: new ol.style.Icon({
	                                    src: rule[symbol]['file'],
	                                    scale: rule[symbol]['scale'],
	                                    opacity: rule[symbol]['opacity'],
	                                    rotation: rule[symbol]['rotation'],
	                                    crossOrigin: 'anonymous'
	                                }),
	                                zIndex: baseZIndex
	                            }));
	                        } else {
	                            matchedStyles.push(new ol.style.Style({
	                                image: new ol.style.Circle({
	                                    radius: rule[symbol]['radius'] * rule[symbol]['scale'],
	                                    fill: new ol.style.Fill({
	                                        color: rule[symbol]['fill-color']
	                                    }),
	                                    stroke: new ol.style.Stroke({
	                                        color: rule[symbol]['stroke-color'],
	                                        width: rule[symbol]['stroke-width'] * rule[symbol]['scale']
	                                    }),
	                                    rotation: rule[symbol]['rotation']
	                                }),
	                                zIndex: baseZIndex
	                            }));
	                        }
	                        break;
	                    case 'MARKERS':
	                        if (rule[symbol]['file'] !== null) {
	                            matchedStyles.push(new ol.style.Style({
	                                image: new ol.style.Icon({
	                                    src: rule[symbol]['file'],
	                                    scale: rule[symbol]['scale'],
	                                    opacity: rule[symbol]['opacity'],
	                                    rotation: rule[symbol]['rotation'],
	                                    crossOrigin: 'anonymous'
	                                }),
	                                zIndex: baseZIndex
	                            }));
	                        } else {
	                            matchedStyles.push(new ol.style.Style({
	                                image: new ol.style.Circle({
	                                    radius: rule[symbol]['radius'] * rule[symbol]['scale'],
	                                    fill: new ol.style.Fill({
	                                        color: rule[symbol]['fill-color']
	                                    }),
	                                    stroke: new ol.style.Stroke({
	                                        color: rule[symbol]['stroke-color'],
	                                        width: rule[symbol]['stroke-width'] * rule[symbol]['scale']
	                                    }),
	                                    rotation: rule[symbol]['rotation']
	                                }),
	                                zIndex: baseZIndex
	                            }));
	                        }
	                        break;
	
	                    case 'POLYGON':
	                        matchedStyles.push(new ol.style.Style({
	                            fill: new ol.style.Fill({
	                                color: rule[symbol]['fill-color']
	                            }),
	                            zIndex: baseZIndex
	                        }));
	                        break;
	
	                    case 'LINE':
	                        matchedStyles.push(new ol.style.Style({
	                            stroke: new ol.style.Stroke({
	                                color: rule[symbol]['stroke-color'],
	                                width: rule[symbol]['stroke-width'],
	                                lineDash: rule[symbol]['stroke-dasharray'],
	                                lineJoin: rule[symbol]['stroke-linejoin'],
	                                lineCap: rule[symbol]['stroke-linecap']
	                            }),
	                            zIndex: baseZIndex
	                        }));
	                        break;
	                }
	            });
	        });
	        return matchedStyles;
	    },
	
	    matchFilter: function(feature, filter) {
	        var that = this;
	        if(typeof filter != 'string') return true;
	        try{
	            return Boolean(eval(filter))
	        }catch(e){
	            return false;
	        }
	    },
	
	    /*
	     Стили мапника могут быть в двух разных форматах.
	
	     К примеру этот стиль
	     <PolygonSymbolizer>
	     <CssParameter name="fill">#ededed</CssParameter>
	     </PolygonSymbolizer>
	
	     Можно записать ещё и так
	     <PolygonSymbolizer fill="#ededed" />
	
	     Нужно уметь вытащить все свойства в обоих случаях.
	     Приоритет у 2-го варианта.
	     */
	    _getSymbolizePoperties: function(element){
	        var properties = {};
	        var i, attrs, l,
	            child, childs = $(element).children(), childel, propname, propvalue;
	
	        if(!element.attributes.length && !childs.length){
	            return properties;
	        }
	        if(element.childNodes.length){
	            for(child in element.childNodes){
	                childel = element.childNodes[child];
	                // Нам нужны только CSSPARAMETER
	                if(!childel.tagName || childel.tagName != 'CSSPARAMETER') continue;
	                // У элемента CssParameter обязательно должен быть аттрибут name.
	                propname = childel.getAttribute('name');
	                propvalue = childel.innerHTML;
	                if(!propname || !propvalue) continue;
	
	                properties[propname] = propvalue;
	            }
	        }
	
	        for(i = 0, attrs = element.attributes, l = attrs.length; i < l; i++){
	            properties[attrs[i].name] = attrs[i].value;
	        }
	
	        element.innerHTML = $.trim(element.innerHTML);
	        if(element.innerHTML.length){
	//            properties['cdata'] = element.innerHTML.substr(12, element.innerHTML.length - 18);
	            properties['cdata'] = element.innerHTML.substr(1, element.innerHTML.length - 8);
	        }
	
	        return properties;
	    },
	
	    _geomTypeFromMapnik: function (geomType) {
	        var _geomTypes = {
	            '1': 'Point',
	            '2': 'LineString',
	            '3': 'Polygon',
	            '4': 'GeometryCollection'
	        };
	        return _geomTypes[geomType] ? _geomTypes[geomType] : '';
	    }
	
	});
	
	OLVectorLayerStyle.getRGBish = function(c, verbose){
	    var i = 0, itm,
	        M = c.replace(/ +/g, '').match(/(rgba?)|(\d+(\.\d+)?%?)|(\.\d+)/g);
	    verbose = verbose || false;
	
	    if(M && M.length > 3){
	        while(i < 3){
	            itm = M[++i];
	            if(itm.indexOf('%') != -1){
	                itm = Math.round(parseFloat(itm) * 2.55);
	            }
	            else{
	                itm = parseInt(itm);
	            }
	            if(itm < 0 || itm > 255) return false;
	            M[i] = itm;
	        }
	        if(c.indexOf('rgba') === 0){
	            if(M[4] == undefined || M[4] < 0 || M[4] > 1) return false;
	        }
	        else if(M[4]) return false;
	        return verbose
	            ? M.slice(1)
	            : M[0] + '(' + M.slice(1).join(',') + ')';
	    }
	    return false;
	};
	
	OLVectorLayerStyle.any2RGBA = function(color, verbose){
	    var result = 'rgba({r},{g},{b},{a})';
	    var namedColors = {
	        'aliceblue'           : '#f0f8ff',
	        'antiquewhite'        : '#faebd7',
	        'aqua'                : '#00ffff',
	        'aquamarine'          : '#7fffd4',
	        'azure'               : '#f0ffff',
	        'beige'               : '#f5f5dc',
	        'bisque'              : '#ffe4c4',
	        'black'               : '#000000',
	        'blanchedalmond'      : '#ffebcd',
	        'blue'                : '#0000ff',
	        'blueviolet'          : '#8a2be2',
	        'brown'               : '#a52a2a',
	        'burlywood'           : '#deb887',
	        'cadetblue'           : '#5f9ea0',
	        'chartreuse'          : '#7fff00',
	        'chocolate'           : '#d2691e',
	        'coral'               : '#ff7f50',
	        'cornflowerblue'      : '#6495ed',
	        'cornsilk'            : '#fff8dc',
	        'crimson'             : '#dc143c',
	        'cyan'                : '#00ffff',
	        'darkblue'            : '#00008b',
	        'darkcyan'            : '#008b8b',
	        'darkgoldenrod'       : '#b8860b',
	        'darkgray'            : '#a9a9a9',
	        'darkgreen'           : '#006400',
	        'darkkhaki'           : '#bdb76b',
	        'darkmagenta'         : '#8b008b',
	        'darkolivegreen'      : '#556b2f',
	        'darkorange'          : '#ff8c00',
	        'darkorchid'          : '#9932cc',
	        'darkred'             : '#8b0000',
	        'darksalmon'          : '#e9967a',
	        'darkseagreen'        : '#8fbc8f',
	        'darkslateblue'       : '#483d8b',
	        'darkslategray'       : '#2f4f4f',
	        'darkturquoise'       : '#00ced1',
	        'darkviolet'          : '#9400d3',
	        'deeppink'            : '#ff1493',
	        'deepskyblue'         : '#00bfff',
	        'dimgray'             : '#696969',
	        'dodgerblue'          : '#1e90ff',
	        'firebrick'           : '#b22222',
	        'floralwhite'         : '#fffaf0',
	        'forestgreen'         : '#228b22',
	        'fuchsia'             : '#ff00ff',
	        'gainsboro'           : '#dcdcdc',
	        'ghostwhite'          : '#f8f8ff',
	        'gold'                : '#ffd700',
	        'goldenrod'           : '#daa520',
	        'gray'                : '#808080',
	        'green'               : '#008000',
	        'greenyellow'         : '#adff2f',
	        'honeydew'            : '#f0fff0',
	        'hotpink'             : '#ff69b4',
	        'indianred'           : '#cd5c5c',
	        'indigo'              : '#4b0082',
	        'ivory'               : '#fffff0',
	        'khaki'               : '#f0e68c',
	        'lavender'            : '#e6e6fa',
	        'lavenderblush'       : '#fff0f5',
	        'lawngreen'           : '#7cfc00',
	        'lemonchiffon'        : '#fffacd',
	        'lightblue'           : '#add8e6',
	        'lightcoral'          : '#f08080',
	        'lightcyan'           : '#e0ffff',
	        'lightgoldenrodyellow': '#fafad2',
	        'lightgray'           : '#d3d3d3',
	        'lightgreen'          : '#90ee90',
	        'lightpink'           : '#ffb6c1',
	        'lightsalmon'         : '#ffa07a',
	        'lightseagreen'       : '#20b2aa',
	        'lightskyblue'        : '#87cefa',
	        'lightslategray'      : '#778899',
	        'lightsteelblue'      : '#b0c4de',
	        'lightyellow'         : '#ffffe0',
	        'lime'                : '#00ff00',
	        'limegreen'           : '#32cd32',
	        'linen'               : '#faf0e6',
	        'magenta'             : '#ff00ff',
	        'maroon'              : '#800000',
	        'mediumaquamarine'    : '#66cdaa',
	        'mediumblue'          : '#0000cd',
	        'mediumorchid'        : '#ba55d3',
	        'mediumpurple'        : '#9370db',
	        'mediumseagreen'      : '#3cb371',
	        'mediumslateblue'     : '#7b68ee',
	        'mediumspringgreen'   : '#00fa9a',
	        'mediumturquoise'     : '#48d1cc',
	        'mediumvioletred'     : '#c71585',
	        'midnightblue'        : '#191970',
	        'mintcream'           : '#f5fffa',
	        'mistyrose'           : '#ffe4e1',
	        'moccasin'            : '#ffe4b5',
	        'navajowhite'         : '#ffdead',
	        'navy'                : '#000080',
	        'oldlace'             : '#fdf5e6',
	        'olive'               : '#808000',
	        'olivedrab'           : '#6b8e23',
	        'orange'              : '#ffa500',
	        'orangered'           : '#ff4500',
	        'orchid'              : '#da70d6',
	        'palegoldenrod'       : '#eee8aa',
	        'palegreen'           : '#98fb98',
	        'paleturquoise'       : '#afeeee',
	        'palevioletred'       : '#db7093',
	        'papayawhip'          : '#ffefd5',
	        'peachpuff'           : '#ffdab9',
	        'peru'                : '#cd853f',
	        'pink'                : '#ffc0cb',
	        'plum'                : '#dda0dd',
	        'powderblue'          : '#b0e0e6',
	        'purple'              : '#800080',
	        'red'                 : '#ff0000',
	        'rosybrown'           : '#bc8f8f',
	        'royalblue'           : '#4169e1',
	        'saddlebrown'         : '#8b4513',
	        'salmon'              : '#fa8072',
	        'sandybrown'          : '#f4a460',
	        'seagreen'            : '#2e8b57',
	        'seashell'            : '#fff5ee',
	        'sienna'              : '#a0522d',
	        'silver'              : '#c0c0c0',
	        'skyblue'             : '#87ceeb',
	        'slateblue'           : '#6a5acd',
	        'slategray'           : '#708090',
	        'snow'                : '#fffafa',
	        'springgreen'         : '#00ff7f',
	        'steelblue'           : '#4682b4',
	        'tan'                 : '#d2b48c',
	        'teal'                : '#008080',
	        'thistle'             : '#d8bfd8',
	        'tomato'              : '#ff6347',
	        'turquoise'           : '#40e0d0',
	        'violet'              : '#ee82ee',
	        'wheat'               : '#f5deb3',
	        'white'               : '#ffffff',
	        'whitesmoke'          : '#f5f5f5',
	        'yellow'              : '#ffff00',
	        'yellowgreen'         : '#9acd32'
	    };
	    var rgba = [0, 0, 0, 1];
	    var shorthandRegex, hexColor;
	
	    color = color.toLowerCase() || '';
	    verbose = verbose || false;
	
	    color = (color in namedColors)
	        ? namedColors[color]
	        : color;
	
	    if(~color.indexOf('#')){
	        shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	        hexColor = color.replace(shorthandRegex, function(m, r, g, b){
	            return r + r + g + g + b + b;
	        });
	
	        hexColor = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
	        if(hexColor){
	            rgba[0] = parseInt(hexColor[1].toString(), 16);
	            rgba[1] = parseInt(hexColor[2].toString(), 16);
	            rgba[2] = parseInt(hexColor[3].toString(), 16);
	        }
	    }else{
	        color = OLVectorLayerStyle.getRGBish(color, true);
	        if(color){
	            rgba[0] = parseInt(color[0]);
	            rgba[1] = parseInt(color[1]);
	            rgba[2] = parseInt(color[2]);
	            if(color[3]){
	                rgba[3] = parseFloat(color[3]);
	            }
	        }
	    }
	
	    result = result
	        .replace('{r}', rgba[0].toString())
	        .replace('{g}', rgba[1].toString())
	        .replace('{b}', rgba[2].toString())
	        .replace('{a}', rgba[3].toString());
	
	    return verbose
	        ? {'str': result, 'arr': rgba}
	        : result;
	};
	
	OLVectorLayerStyle.SymbolizerParsers = {
	    'POLYGON'            : function(properties, opt){
	        var result = {
	            'fill-color': null
	        };
	        // Цвет в формате CSS, может быть как HEX, так и RGB/RGBA
	        var fillColor = properties['fill'] || "rgba(128,128,128,1)";
	        // Альтернативный способ задать прозрачность. Если цвет был в RGBA, нужно перемножить
	        var fillOpacity = parseFloat(properties['fill-opacity'] || '1');
	
	        // Проверяем и конвертируем цвет в RGBA
	        var rgbaColor = OLVectorLayerStyle.any2RGBA(fillColor, true);
	
	        // Перемножаем заданный opacity
	        rgbaColor.arr[3] *= fillOpacity;
	
	        result['fill-color'] = 'rgba(' + rgbaColor.arr.join(',') + ')';
	        return result;
	    },
	    'POLYGONPATTERN'     : function(properties, opt){},
	    'LINE'               : function(properties, opt){
	        var result = {
	            'stroke-color'    : null,
	            'stroke-width'    : null,
	            'stroke-linejoin' : null,
	            'stroke-linecap'  : null,
	            'stroke-dasharray': null
	        };
	
	        // Прозрачность контура
	        var strokeOpacity = parseFloat(properties['stroke-opacity'] || '1');
	
	        // Цвет контура
	        result['stroke-color'] = properties['stroke'] || 'rgba(0,0,0,1)';
	        result['stroke-color'] = OLVectorLayerStyle.any2RGBA(result['stroke-color'], true);
	        result['stroke-color'].arr[3] *= strokeOpacity;
	        result['stroke-color'] = 'rgba(' + result['stroke-color'].arr.join(',') + ')';
	
	        // Толщина контура
	        result['stroke-width'] = parseFloat(properties['stroke-width'] || '1');
	
	        // Форма соединения контура на углах
	        result['stroke-linejoin'] = ~$.inArray(properties['stroke-linejoin'], ['miter', 'round', 'bevel'])
	            ? properties['stroke-linejoin']
	            : 'miter';
	
	        // Форма границ контура
	        result['stroke-linecap'] = ~$.inArray(properties['stroke-linecap'], ['butt', 'round', 'square'])
	            ? properties['stroke-linejoin']
	            : 'butt';
	
	        if(properties['stroke-dasharray'] !== undefined && properties['stroke-dasharray'].length){
	            properties['stroke-dasharray'] = properties['stroke-dasharray'].split(',');
	            if(properties['stroke-dasharray'].length > 1){
	                result['stroke-dasharray'] = properties['stroke-dasharray'];
	            }
	        } else {
	            result['stroke-dasharray'] = undefined;
	        }
	
	        return result;
	    },
	    'LINEPATTERN'        : function(properties, opt){},
	    'POINT'              : function(properties, opt){
	        var result = {
	            'file'            : null,
	            'fill-color'      : null,
	            'opacity'         : 1,
	            'transform'       : null, // Трансформация SVG http://www.w3.org/TR/SVG/coords.html#TransformAttribute
	            'stroke-color'    : null,
	            'stroke-width'    : null,
	            'scale'           : 1,
	            'radius'          : 5
	        };
	
	        // Прозрачность контура
	        var strokeOpacity = parseFloat(properties['stroke-opacity'] || '1');
	        // Цвет в формате CSS, может быть как HEX, так и RGB/RGBA
	        var fillColor = properties['fill'] || "rgba(0,0,255,1)";
	        // Альтернативный способ задать прозрачность. Если цвет был в RGBA, нужно перемножить
	        var fillOpacity = parseFloat(properties['fill-opacity'] || '1');
	
	        // transform
	        var markerScale;
	        var markerRotate;
	
	        // Проверяем и конвертируем цвет в RGBA
	        var rgbaColor = OLVectorLayerStyle.any2RGBA(fillColor, true);
	
	        // Перемножаем заданный opacity
	        rgbaColor.arr[3] *= fillOpacity;
	
	        result['fill-color'] = 'rgba(' + rgbaColor.arr.join(',') + ')';
	
	        // Цвет контура
	        result['stroke-color'] = properties['stroke'] || 'rgba(0,0,0,1)';
	        result['stroke-color'] = OLVectorLayerStyle.any2RGBA(result['stroke-color'], true);
	        result['stroke-color'].arr[3] *= strokeOpacity;
	        result['stroke-color'] = 'rgba(' + result['stroke-color'].arr.join(',') + ')';
	
	        // Толщина контура
	        result['stroke-width'] = parseFloat(properties['stroke-width'] || '0.5');
	
	        result['file'] = properties['file'] || null;
	        if(result['file'] && opt.markerImgUrl){
	            if (result['file'].substring(0, 4) === 'img/') {
	                result['file'] = result['file'].replace(/^img\//, opt.markerImgUrl);
	            }
	        }
	        result['opacity'] = parseFloat(properties['opacity'] || 1);
	        result['transform'] = properties['transform'] || null;
	        if (result['transform'] !== null) {
	            markerScale = result['transform'].match( /scale\(\s*([0-9.]+)\s*\)/i );
	            if (markerScale && markerScale[1] !== undefined) {
	                result['scale'] = parseFloat(markerScale[1]);
	            }
	            markerRotate = result['transform'].match( /rotate\(\s*([0-9.]+)\s*\)/i );
	            if (markerRotate && markerRotate[1] !== undefined) {
	                result['rotation'] = parseFloat(markerRotate[1]) * Math.PI / 180;
	            }
	        }
	        result['radius'] = parseFloat(properties['width'] || 10) / 2;
	
	        return result;
	    },
	    'MARKERS'            : function(properties, opt){
	        var result = {
	            'file'            : null,
	            'fill-color'      : null,
	            'opacity'         : 1,
	            'transform'       : null, // Трансформация SVG http://www.w3.org/TR/SVG/coords.html#TransformAttribute
	            'stroke-color'    : null,
	            'stroke-width'    : null,
	            'scale'           : 1,
	            'radius'          : 5
	        };
	
	        // Прозрачность контура
	        var strokeOpacity = parseFloat(properties['stroke-opacity'] || '1');
	        // Цвет в формате CSS, может быть как HEX, так и RGB/RGBA
	        var fillColor = properties['fill'] || "rgba(0,0,255,1)";
	        // Альтернативный способ задать прозрачность. Если цвет был в RGBA, нужно перемножить
	        var fillOpacity = parseFloat(properties['fill-opacity'] || '1');
	
	        // transform
	        var markerScale;
	        var markerRotate;
	
	        // Проверяем и конвертируем цвет в RGBA
	        var rgbaColor = OLVectorLayerStyle.any2RGBA(fillColor, true);
	
	        // Перемножаем заданный opacity
	        rgbaColor.arr[3] *= fillOpacity;
	
	        result['fill-color'] = 'rgba(' + rgbaColor.arr.join(',') + ')';
	
	        // Цвет контура
	        result['stroke-color'] = properties['stroke'] || 'rgba(0,0,0,1)';
	        result['stroke-color'] = OLVectorLayerStyle.any2RGBA(result['stroke-color'], true);
	        result['stroke-color'].arr[3] *= strokeOpacity;
	        result['stroke-color'] = 'rgba(' + result['stroke-color'].arr.join(',') + ')';
	
	        // Толщина контура
	        result['stroke-width'] = parseFloat(properties['stroke-width'] || '0.5');
	
	        result['file'] = properties['file'] || null;
	        if(result['file'] && opt.markerImgUrl){
	            if (result['file'].substring(0, 4) === 'img/') {
	                result['file'] = result['file'].replace(/^img\//, opt.markerImgUrl);
	            }
	        }
	        result['opacity'] = parseFloat(properties['opacity'] || 1);
	        result['transform'] = properties['transform'] || null;
	        if (result['transform'] !== null) {
	            markerScale = result['transform'].match( /scale\(\s*([0-9.]+)\s*\)/i );
	            if (markerScale && markerScale[1] !== undefined) {
	                result['scale'] = parseFloat(markerScale[1]);
	            }
	            markerRotate = result['transform'].match( /rotate\(\s*([0-9.]+)\s*\)/i );
	            if (markerRotate && markerRotate[1] !== undefined) {
	                result['rotation'] = parseFloat(markerRotate[1]) * Math.PI / 180;
	            }
	        }
	        result['radius'] = parseFloat(properties['width'] || 10) / 2;
	
	        return result;
	    },
	    'GLYPH'              : function(properties, opt){},
	    'TEXT'               : function(properties, opt){
	        var result = {
	            'face-name'        : 'Arial, Helvetica, "Nimbus Sans L", "Liberation Sans", FreeSans, Sans-serif',
	            'fill'             : 'rgba(0,0,0,1)',
	            'halo-fill'        : 'rgba(255,255,255,1)',
	            'halo-radius'      : 0,
	            'size'             : 10,
	            'dx'               : 0, // Смещение относительно точки
	            'dy'               : 0, // Смещение относительно точки
	            'base-line'        : 'middle',
	            'text-align'       : null,
	            'allow-overlap'    : true,
	            'cdata'            : null
	
	        };
	
	        result['cdata'] = properties['cdata'] || null;
	        // TODO: Разрулить ещё и font weight и прочие параметры, когда будут нужны
	        // result['face-name'] = properties['face-name'] || result['face-name'];
	        result['base-line'] = properties['vertical-align'] || 'auto';
	
	        result['text-align'] = ~$.inArray(properties['justify-alignment'], ['left', 'right', 'center'])
	            ? properties['justify-alignment']
	            : 'start';
	
	        result['fill'] = properties['fill'] || result['fill'];
	        result['fill'] = OLVectorLayerStyle.any2RGBA(result['fill'], true);
	        result['fill'] = 'rgba(' + result['fill'].arr.join(',') + ')';
	        result['halo-fill'] = properties['halo-fill'] || result['halo-fill'];
	        result['halo-fill'] = OLVectorLayerStyle.any2RGBA(result['halo-fill'], true);
	        result['halo-fill'] = 'rgba(' + result['halo-fill'].arr.join(',') + ')';
	
	        result['halo-radius'] = parseFloat(properties['halo-radius'] || 0);
	        result['size'] = parseFloat(properties['size'] || 10);
	        result['dx'] = parseFloat(properties['dx'] || 0);
	        result['dy'] = parseFloat(properties['dy'] || 0);
	
	        if(result['base-line'] == 'auto'){
	            result['base-line'] =
	                result['dy'] < 0 ? 'bottom' :
	                    result['dy'] == 0 ? 'middle' :
	                        'top';
	        }
	
	        if(result['text-align'] == 'start'){
	            result['text-align'] =
	                result['dx'] < 0 ? 'right' :
	                    result['dx'] == 0 ? 'center' :
	                        'left';
	        }
	
	        result['allow-overlap'] = properties['allow-overlap'] !== undefined
	            ? properties['allow-overlap'] == 'true'
	            : true;
	
	        if (result['base-line'] == 'bottom') {
	            result['dy'] -= result['size'] / 2;
	            result['base-line'] = 'middle';
	        }
	        if (result['base-line'] == 'top') {
	            result['dy'] += result['size'] / 2;
	            result['base-line'] = 'middle';
	        }
	
	        // глобальное разрешение расчтеа перекрытий текстов, только если задано
	        if (properties['allow-overlap'] !== undefined && !result['allow-overlap']) {
	            ol.OMS_VECTOR_ALLOW_OVERLAP = true;
	        }
	
	        return result;
	    },
	    'RASTER'             : function(properties, opt){},
	    'SHIELD'             : function(properties, opt){},
	    'BUILDING'           : function(properties, opt){},
	    'MINSCALEDENOMINATOR': null,
	    'MAXSCALEDENOMINATOR': null,
	    'FILTER'             : function(filter){
	        var i;
	        var logical_operators = {
	            'and': '&&',
	            'or' : '||',
	            'not': '!'
	        };
	
	        var logical_operator = '';
	
	        var comparison_operators = {
	            '='    : '==',
	            '!='   : '!=',
	            '&gt;' : '>',
	            '&lt;' : '<',
	            '&gt;=': '>=',
	            '&lt;=': '<='
	        };
	
	        var comparison_operator = '';
	
	        var arithmetic_operators = '*/+-%';
	        var arithmetic_operator = '';
	
	        var regexp_match = '';
	
	        var buffer = "";
	
	        var bracket_on = false;
	        var varb_on = false;
	        var valb_on = false;
	
	        var ch;
	        var variable = '';
	        var val = '';
	
	        var expecting_comparison_operator = false;
	        var expecting_arithmetic_operator = false;
	        var expecting_value = false;
	        var expecting_regexp = false;
	
	        var escape = false;
	        filter = filter.replace(new RegExp('\\[mapnik::geometry_type\\] = (\\d)'), "[mapnik::geometry_type] = '\$1'");
	        filter += ' ';
	
	        for(i in filter){
	            ch = filter.charAt(i);
	
	            switch(ch){
	                case "(":
	                    if(!varb_on && !valb_on && !expecting_regexp){
	                        buffer += ch + ' ';
	                        bracket_on = true;
	                        continue;
	                    }
	                    break;
	                case ')':
	                    if(!varb_on && !valb_on && bracket_on && !expecting_regexp){
	                        buffer += ch + ' ';
	                        continue;
	                    }
	                    break;
	                case '[':
	                    if(!varb_on && !valb_on && !expecting_regexp){
	                        variable = '';
	                        varb_on = true;
	                        continue;
	                    }
	                    break;
	                case ']':
	                    if(varb_on && !valb_on && !expecting_regexp){
	                        varb_on = false;
	                        variable = "feature.get('" + variable.replace(/::/g, "').get('") + "')";
	                        buffer += variable;
	                        expecting_comparison_operator = true;
	                        expecting_arithmetic_operator = true;
	                        expecting_regexp = true;
	                        continue;
	                    }
	                    break;
	                case "'":
	                    if(expecting_value && !escape){
	                        valb_on = !valb_on;
	                        if(!valb_on){
	                            expecting_value = false;
	                            buffer += (val == 'true' || val == 'false') ? val + ' ' : "'" + val + "' ";
	                            val = "";
	                        }
	                        continue;
	                    }
	                    break;
	            }
	
	            // Пишем название переменной
	            if(varb_on){
	                variable += ch;
	                continue;
	            }
	
	            // если не ожидаем ничего иного, то должен быть логический оператор
	            if(
	                !varb_on && !valb_on && !expecting_value && !expecting_comparison_operator && !expecting_arithmetic_operator &&
	                ch != ' '
	            ){
	                logical_operator = filter.substr(i, 3);
	                if(logical_operator in logical_operators){
	                    buffer += logical_operators[logical_operator];
	                    if(logical_operators[logical_operator] !== '!'){
	                        buffer += ' ';
	                    }
	                    continue;
	                }
	
	                logical_operator = logical_operator.substr(0, 2);
	                if(logical_operator in logical_operators){
	                    buffer += logical_operators[logical_operator] + ' ';
	                    continue;
	                }
	            }
	
	            if(expecting_comparison_operator && expecting_arithmetic_operator && expecting_regexp && ch != ' '){
	                if(~arithmetic_operators.indexOf(ch)){
	                    expecting_comparison_operator = expecting_regexp = false;
	                }else if(ch == '=' || ch == '&' || ch == '!'){
	                    expecting_arithmetic_operator = expecting_regexp = false;
	                }else if(ch == '.'){
	                    expecting_comparison_operator = expecting_arithmetic_operator = false;
	                }
	            }
	
	            // Ожидаем регулярное выражение
	            if(expecting_regexp){
	                if(!regexp_match.length && ch == ' ') continue;
	                regexp_match += ch;
	                if(ch == ')' && filter.charAt(parseInt(i) - 1) == "'" && filter.charAt(parseInt(i) - 2) !== '\\'){
	                    regexp_match = regexp_match.replace("match('", 'match(/');
	                    regexp_match = regexp_match.substr(0, regexp_match.length - 2) + '/)';
	                    buffer += regexp_match + ' ';
	                    expecting_regexp = false;
	                    regexp_match = '';
	                    continue;
	                }
	            }
	
	            // Ожидаем арифметический оператор
	            if(expecting_arithmetic_operator && ch != ' '){
	                arithmetic_operator += ch;
	                if(arithmetic_operator.length > 1 && !(/[\d\.]/.test(ch))){
	                    buffer += arithmetic_operator.substr(0, arithmetic_operator.length - 1) + ' ';
	                    expecting_arithmetic_operator = false;
	                    expecting_comparison_operator = true;
	                    arithmetic_operator = '';
	                }else{
	                    continue;
	                }
	            }
	
	            // Ожидаем оператор сравнения, игнорируем пробелы
	            if(expecting_comparison_operator && ch != ' '){
	                comparison_operator += ch;
	                if(comparison_operator in comparison_operators){
	                    if(comparison_operator.length == 4 && filter.charAt(parseInt(i) + 1) == '='){
	                        comparison_operator += filter.charAt(parseInt(i) + 1);
	                    }
	                    buffer += ' ' + comparison_operators[comparison_operator] + ' ';
	                    comparison_operator = '';
	                    expecting_comparison_operator = false;
	                    expecting_value = true;
	                }
	                continue;
	            }
	
	            // Ожидаем значение
	            if(valb_on){
	                escape = false;
	                val += ch;
	                if(ch == '\\'){
	                    escape = true;
	                }
	            }else if(expecting_value){
	                if(/[\d\.]/.test(ch)){
	                    val += ch;
	                }else if(val.length > 0 && !/[\d\.]/.test(ch)){
	                    buffer += val + ' ';
	                    val = '';
	                    expecting_value = false;
	                }
	            }
	        }
	        buffer = buffer.replace(".get('mapnik')", '.getGeometry()').replace(".get('geometry_type')", '.getType()');
	        buffer = buffer.replace(new RegExp('\\.getGeometry\\(\\)\\.getType\\(\\) == \'(\\d)\''), ".getGeometry().getType().replace('Multi', '') == that._geomTypeFromMapnik('\$1')");
	        return buffer;
	    }
	};
	
	OLVectorLayerStyle.getObjectsFields = function (mapnikStyleXML) {
	    var fields = mapnikStyleXML.match(/\[[a-z0-9_]+\]/g) || [];
	    return fields.map(function (f) {
	        return f.slice(1, -1);
	    });
	}
	
	// 100 млн - множитель (коэффициент) для сортировки слоев.
	// Т.к. точечные объекты внутри слоя будут основывать свой ZIndex
	// на освновании Y координаты (примерно от -20 млн до 20 млн)
	// а ещё нужно учесть дополнительные махинации с текстовыми подписями
	// то все смещения внутри одного слоя не должны вылезать за межслойные пределы сортировки
	OLVectorLayerStyle.baseZIndexMultiplier = 100000000,
	
	module.exports = OLVectorLayerStyle;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var MVTLayer = __webpack_require__(50),
	    OLVectorLayerStyle = __webpack_require__(48),
	    ol = __webpack_require__(22),
	    $ = __webpack_require__(3);
	
	var OmsMVTLayer = MVTLayer.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this;
	        OmsMVTLayer.__super__.initialize.call(that, options);
	    },
	
	    _setup: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._prjLayers = options.projectLayers;
	        }
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0){
	
	            that.project = that._prjLayers.at(0).options.project;
	            // страшный костыль, т.к. нет нормального пути до изображений
	            that.markerImgUrl = that.project.options.apiUrl.replace(/\/api\/[0-9\.]+\//g, '/img/');
	
	            OmsMVTLayer.__super__._setup.call(that, options);
	            // временно. Попутно собрать поля для popup tooltip для дальнейшего отображения
	            that._prjLayers.getArray().filter(function (l) {
	                var popupFields = [];
	                if (l.get('mapnik_style') &&
	                    l.get('mapnik_style')['Map']) {
	
	                    popupFields = OLStyleParser.getStyleFields(l.get('mapnik_style')['Map'], '-tooltip$');
	                    if (popupFields.length) {
	                        l.set('popupCode', popupFields[0]);
	                    }
	                }
	            });
	
	            that.setLayerStyle();
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that = this;
	        that.styleCache = {};
	        OmsMVTLayer.__super__.updateLayer.call(that);
	    },
	
	
	    setLayerStyle: function(){
	        var that = this,
	            layer = that._olLayer,
	            mapStyles = {},
	            i,
	            prjLayersCount,
	            code,
	            regExpTooltip = /-tooltip$/;
	
	        // Чистим сохраненные стили
	        // todo т.к. кеш м.б. достаточно громодким, необходимо организовать его очистку по уму
	        that.styleCache = {};
	        that.hiddenStyle = [];
	        that.layerSort = {};
	        prjLayersCount = that._prjLayers.getLength();
	
	        for (i = 0; i < prjLayersCount; i ++) {
	            code = that._prjLayers.getArray()[i].get('code');
	            // не используется sort слоя, потому что он не глобальный
	            that.layerSort[code] = prjLayersCount - i;
	            if (!that._prjLayers.getArray()[i].get('mapnik_style')) {
	                continue;
	            }
	            mapStyles[code] = new OLVectorLayerStyle(that._prjLayers.getArray()[i].get('mapnik_style'), (prjLayersCount - i), that.markerImgUrl);
	            // коды для тултипов
	            mapStyles[code].styles.forEach(function (style) {
	                if (!regExpTooltip.test(style['name'])) {
	                    return;
	                }
	                style.rules.forEach(function (rule) {
	                    if (!rule.symbolizers.TEXT || !rule.symbolizers.TEXT.cdata) {
	                        return;
	                    }
	                    that._prjLayers.getArray()[i].set('popupCode', rule.symbolizers.TEXT.cdata);
	                });
	            });
	        }
	
	        layer.setStyle(function pointStyleFunction(feature, resolution) {
	            if (~that.getActiveLayerCodes().indexOf(feature.get('layer')) == 0 || !mapStyles[feature.get('layer')]) {
	                return that.hiddenStyle;
	            }
	            var featureHighlighted = that.get('selectedFeature') == feature.get('layer') + ':' + feature.get('orbis_id');
	            var cacheKey = '' + resolution + ':' + feature.get('layer') + ':' + feature.get('orbis_id');
	            if (!featureHighlighted && (cacheKey in that.styleCache)) {
	                return that.styleCache[cacheKey];
	            }
	            var curZoom = that._view.getMap().getView().getZoom();
	            var styles = mapStyles[feature.get('layer')].getStyle(feature, curZoom, that.layerSort, true);
	            var highlightStyle,
	                highlightStyleFill,
	                imageSize,
	                canvas,
	                shadowOffset,
	                canvasContext,
	                rgbaFill,
	                baseZIndex;
	            // подстветка hover
	            if (featureHighlighted) {
	                highlightStyle = styles.filter(function (style) {
	                    return !!style.getImage();
	                });
	                highlightStyleFill = styles.filter(function (style) {
	                    return !!style.getFill();
	                });
	                if (highlightStyle && highlightStyle.length) {
	                    imageSize = highlightStyle[0].getImage().getImageSize();
	                    canvas = $("<canvas></canvas>");
	                    shadowOffset = 2;
	                    canvas
	                        .attr({
	                            width: imageSize[0] + shadowOffset * 2,
	                            height: imageSize[1] + shadowOffset * 2
	                        })
	                        .css({
	                            width: imageSize[0] + shadowOffset * 2,
	                            height: imageSize[1] + shadowOffset * 2
	                        });
	                    canvasContext = canvas[0].getContext("2d");
	
	                    canvasContext.shadowColor = "rgba( 0, 0, 0, 0.3 )";
	                    canvasContext.shadowOffsetX = shadowOffset;
	                    canvasContext.shadowOffsetY = shadowOffset;
	                    canvasContext.shadowBlur = shadowOffset;
	                    canvasContext.drawImage(highlightStyle[0].getImage().getImage(), shadowOffset, shadowOffset);
	
	                    try {
	                        baseZIndex = OLVectorLayerStyle.baseZIndexMultiplier * (
	                                that.layerSort && that.layerSort[feature.get('layer')]
	                                    ? that.layerSort[feature.get('layer')]
	                                    : 0
	                            );
	                        that._setImageGamma(canvas[0], canvasContext, 1.06);
	                        styles.push(new ol.style.Style({
	                            image: new ol.style.Icon({
	                                src: canvas[0].toDataURL(),
	                                scale: highlightStyle[0].getImage().getScale(),
	                                opacity: 1,
	                                rotation: highlightStyle[0].getImage().getRotation()
	                            }),
	                            // здесь, как и в OLVectorLayerStyle, нужно учитывать грандиозность размеров ZIndex
	                            // из-за использование Y координат для построения сортировок отображения объектов
	                            zIndex: 1000 * OLVectorLayerStyle.baseZIndexMultiplier + baseZIndex
	                        }));
	                    } catch (e) {
	                        highlightStyle[0].getImage().setOpacity(highlightStyle[0].getImage().getOpacity() * 0.6);
	                    }
	                    canvas.detach();
	                }
	                if (highlightStyleFill && highlightStyleFill.length) {
	                    rgbaFill = OLVectorLayerStyle.getRGBish(highlightStyleFill[0].getFill().getColor(), true);
	                    rgbaFill = [rgbaFill[0] * 1.06 * 1.06, rgbaFill[1] * 1.06 * 1.06, rgbaFill[2] * 1.06 * 1.06, rgbaFill[3]];
	                    rgbaFill[0] = rgbaFill[0] > 255 ? 255 : rgbaFill[0];
	                    rgbaFill[1] = rgbaFill[1] > 255 ? 255 : rgbaFill[1];
	                    rgbaFill[2] = rgbaFill[2] > 255 ? 255 : rgbaFill[2];
	                    highlightStyleFill[0].getFill().setColor('rgba('+Math.floor(rgbaFill[0])+', '+Math.floor(rgbaFill[1])+', '+Math.floor(rgbaFill[2])+', '+rgbaFill[3]+')');
	                }
	                styles.forEach(function (style) {
	                    if (style.getText()) {
	                        // текст подсвеченного объекта должен отрисоваться раньше остальных текстов, но не раньше объектов
	                        style.setZIndex(style.getZIndex() - 100 * OLVectorLayerStyle.baseZIndexMultiplier);
	                    }
	                });
	            }
	
	            if (!featureHighlighted) {
	                that.styleCache[cacheKey] = styles;
	            }
	
	            return styles;
	        });
	    },
	
	    _setImageGamma: function(canvas, context, gamma) {
	        var pix = context.getImageData(0, 0, canvas.width, canvas.height);
	        var x, y, i, r, g, b, a, ret;
	        //Loop through the pixels
	        for (x = 0; x < canvas.width; x++) {
	            for (y = 0; y < canvas.height; y++) {
	                i = (y * canvas.width + x) * 4;
	                r = pix.data[i];
	                g = pix.data[i + 1];
	                b = pix.data[i + 2];
	                a = pix.data[i + 3];
	                ret = [r * gamma * gamma, g * gamma * gamma, b * gamma * gamma, a];
	                pix.data[i] = ret[0];
	                pix.data[i + 1] = ret[1];
	                pix.data[i + 2] = ret[2];
	                pix.data[i + 3] = ret[3];
	            }
	        }
	
	        //Put the image back to the canvas
	        context.clearRect(0, 0, canvas.width, canvas.height);
	        context.putImageData(pix, 0, 0);
	    }
	});
	
	module.exports = OmsMVTLayer;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var Layer       = __webpack_require__(41),
	    OmsVectorSource   = __webpack_require__(51),
	    ol          = __webpack_require__(22);
	
	
	var MVTLayer = Layer.extend({
	
	    initialize: function(options){
	        var that = this;
	        MVTLayer.__super__.initialize.call(that, options);
	
	        that._olLayer = new ol.layer.VectorTile({
	            'visible': options.visible,
	            renderMode: 'hybrid'
	        });
	
	        that._olLayer.set('omjsLayer', that);
	        that._setup(options);
	    },
	
	    _setup: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        if ('projectLayers' in options) {
	            that._prjLayers = options.projectLayers;
	        }
	
	        //...
	        if (that._prjLayers && that._prjLayers.getLength() > 0) {
	            that._olSource = new OmsVectorSource({
	                crossOrigin: "anonymous",
	                layers: that._prjLayers.pluck('map_layer_id'),
	                urlTemplate: that.options.urlTemplate,
	                mapCode: that.options.mapCode
	            });
	
	            that._olLayer.setSource(that._olSource);
	
	            if (that.options['activeLayers']) {
	                that.setActiveLayers(that.options['activeLayers']);
	            } else {
	                that.fire('activeLayersChange', {
	                    layerIds: that._prjLayers.pluck('map_layer_id')
	                });
	            }
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that = this;
	        that.setActiveLayers(that.getActiveLayerCodes());
	        that.setLayerStyle();
	    },
	
	    setStyle: function(style){
	        var that = this;
	        that._olLayer.setStyle(style);
	    },
	
	    setActiveLayers: function(codes) {
	        var that = this,
	            layersForActivation,
	            layerIds;
	
	        layersForActivation = that._prjLayers.filter(function(l){
	            return ~codes.indexOf(l.get('code')) != 0;
	        });
	
	        layerIds = layersForActivation.pluck('map_layer_id');
	
	        that.getMapLayer()
	            .getSource()
	            .setActiveLayers(layerIds);
	
	        that.fire('activeLayersChange', {
	            layerIds: layerIds
	        });
	    },
	
	    activateLayers: function(codes) {
	        var that = this,
	            source = that.getMapLayer().getSource(),
	            layersForActivation,
	            layerIds;
	
	        if (source) {
	            layersForActivation = that._prjLayers.filter(function(l){
	                return ~codes.indexOf(l.get('code')) != 0;
	            });
	            layerIds = layersForActivation.pluck('map_layer_id');
	            layerIds = _.union(source.getActiveLayers(),layerIds);
	
	            source.setActiveLayers(layerIds);
	
	            that.fire('activeLayersChange', {
	                layerIds: layerIds
	            });
	        }
	    },
	
	    deactivateLayers: function(codes) {
	        var that = this,
	            source = that.getMapLayer().getSource(),
	            layersForActivation,
	            layerIds;
	
	        if (source) {
	            layersForActivation = that._prjLayers.filter(function(l){
	                return ~codes.indexOf(l.get('code')) != 0;
	            });
	            layerIds = layersForActivation.pluck('map_layer_id');
	            layerIds = _.difference(source.getActiveLayers(),layerIds);
	
	            source.setActiveLayers(layerIds);
	
	            that.fire('activeLayersChange', {
	                layerIds: layerIds
	            });
	        }
	    },
	
	    getActiveLayerCodes : function() {
	        var that = this,
	            activeIds;
	        activeIds = that._olSource.getActiveLayers();
	
	        return that._prjLayers.filter(function(l){
	            return ~activeIds.indexOf(l.get('map_layer_id')) != 0;
	        }).getArray().map(function(l){
	            return l.get('code');
	        });
	    },
	
	    syncWithProject: function() {
	        var that = this;
	        var layersForActivation;
	        var oldActiveLayersHash;
	        var layersForActivationHash;
	        var source = that.getSource();
	
	        if (source) {
	            oldActiveLayersHash = [].concat(source.getActiveLayers()).sort(function(a, b) {
	                return a - b;
	            }).join(' ');
	
	            layersForActivation = that._prjLayers.filter(function(l) {
	                return l.get('selected');
	            }).pluck('id');
	
	            layersForActivationHash = [].concat(layersForActivation).sort(function(a, b) {
	                return a - b;
	            }).join(' ');
	
	            if (oldActiveLayersHash !== layersForActivationHash) {
	                source.setActiveLayers(layersForActivation);
	            }
	
	            return {
	                changes: oldActiveLayersHash !== layersForActivationHash,
	                oldLayers: oldActiveLayersHash ? oldActiveLayersHash.split(' ') : [],
	                newLayers: layersForActivationHash ? layersForActivationHash.split(' ') : []
	            };
	        }
	    }
	});
	
	module.exports = MVTLayer;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(22);
	var $ = __webpack_require__(3);
	
	var OmsVectorSource = function(options){
	    var that = this,
	        _options = {};
	
	    that._urlTemplate = options.urlTemplate
	        ? options.urlTemplate + '&vector=1'
	        : "";
	
	    that._layers = options.layers
	        ? options.layers
	        : [];
	
	    that._mapCode = options.mapCode
	        ? options.mapCode
	        : "";
	
	    delete options['urlTemplate'];
	    delete options['layers'];
	    delete options['mapCode'];
	
	    $.extend(true, _options, options);
	
	    _options.format = new ol.format.MVT({
	        // ol.Feature в общем случае не нужен и работает криво в новом OL (часть фич в тайлах теряется)
	        // TODO разобраться, если заработает, то можно переписать интерактивность по аналогии с GeoJSON,
	        // это возможно избавит от моргания слоя при перемещении карты, "зацепившись" за границу фич
	        // featureClass: ol.Feature
	    });
	
	    _options.tileGrid = omjs.ol.tilegrid.createXYZ({maxZoom: 22});
	    _options.tilePixelRatio = 16;
	
	    _options.url = that._urlTemplate
	        .replace('{map_code}', that._mapCode)
	        .replace('{layers}', that._layers.join(','));
	    _options.projection = 'EPSG:3857';
	
	    ol.source.VectorTile.call(this, _options);
	
	    that.loadingTiles = [];
	
	    that.on('tileloadstart', function(e) {
	        that.loadingTiles.push(e.tile);
	    });
	
	    that.on(['tileloadend', 'tileloaderror'], function(e) {
	        var index = that.loadingTiles.indexOf(e.tile);
	        if(~index){
	            that.loadingTiles.splice(index, 1);
	        }
	    });
	};
	
	/**
	 *
	 * @type {{setLayers: Function}}
	 */
	OmsVectorSource.prototype = {};
	
	ol.inherits(OmsVectorSource, ol.source.VectorTile);
	
	OmsVectorSource.prototype.setActiveLayers = function(ids){
	    var that = this,
	        url;
	
	    that._layers = ids;
	
	    if (!that._layers.length) {
	        that.clear();
	        return;
	    }
	
	    url = that._urlTemplate
	        .replace('{map_code}', that._mapCode)
	        .replace('{layers}', that._layers.join(','));
	
	
	    that.clear();
	    that.setUrl(url);
	    that.refresh();
	};
	
	OmsVectorSource.prototype.getActiveLayers = function() {
	    return this._layers;
	};
	
	OmsVectorSource.prototype.cancelLoading = function() {
	    var that = this;
	
	    // that.loadingTiles.forEach(function(tile){
	    //     tile.getImage().src = '';
	    //     tile.changed();
	    // });
	
	    that.loadingTiles.length = 0;
	
	    return that;
	};
	
	module.exports = OmsVectorSource;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var VectorLayer = __webpack_require__(44),
	    ol = __webpack_require__(22),
	    _ = __webpack_require__(16),
	    $ = __webpack_require__(3),
	    utils = __webpack_require__(5),
	    Visualization = __webpack_require__(15);
	
	var devPixelRatio = 1 / utils.getDevicePixelRatio();
	
	var OmsCategoryLayer = VectorLayer.extend({
	
	    initialize: function(options){
	        var that = this;
	
	        // Vector layer can work with only one project layer
	        that._takeOnePrjLayer(options);
	
	        OmsCategoryLayer.__super__.initialize.call(that, options);
	
	        that._olLayer = new ol.layer.Group({
	            visible: options.visible
	        });
	        that._olLayer.set('omjsLayer', that);
	
	        that._setup(options);
	    },
	
	    _takeOnePrjLayer: function(options) {
	        var that = this;
	        if ('projectLayers' in options) {
	            if (_.isArray(options['projectLayers'])) {
	                that._prjLayer = options['projectLayers'][0];
	            } else if ('getArray' in options['projectLayers']) {
	                that._prjLayer = options['projectLayers'].at(0);
	            }
	        }
	    },
	
	    onAdd: function(view){
	        var that = this;
	        that.view = view;
	        that.map = view.getMap();
	        that.map.getView().on('change:resolution', function(){
	            that.switchLayerSources();
	        });
	    },
	
	    _setup: function(options){
	        var that = this,
	            vStyle,
	            startResolution = 156543.03392804097,
	            clusterSizeOptionsOverride;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._takeOnePrjLayer(options);
	            that._prjLayers = options.projectLayers;
	        }
	
	        if (!that._prjLayer) {
	            return that;
	        }
	
	        if (!(that._prjLayer instanceof Visualization) || that._prjLayer.get('render_type') != 1) {
	            throw new Error("Project vector visualization required!!!");
	        }
	
	        clusterSizeOptionsOverride = that._prjLayer.options.clusterSize || {};
	        that.cluserSizeOptions = {
	            // см комментарии по использованию в OmsVectorLayer.js
	            width       : 20,
	            height      : 17,
	            figures     : [
	                {
	                    width       : 18,
	                    height      : 15,
	                    type        : 'rect',
	                    radius      : 2,
	                    strokeStyle : '#7fa3c6',
	                    fillStyle   : '#fff',
	                    lineWidth   : 1
	                }
	            ],
	            fontSize    : 20,
	            fontFamily  : 'Arial',
	            textAlign   : 'center',
	            textBaseline: 'middle',
	            textColor   : '#000'
	        };
	        $.extend(
	            that.cluserSizeOptions,
	            clusterSizeOptionsOverride,
	            that.view.options.misc_data.objects_counter_style
	        );
	
	        that.project = that._prjLayer.options.project;
	
	        if (that._prjLayer.get('vectorSettings')['clusteringEnabled']) {
	            that.options['clustering'] = that._prjLayer.get('vectorSettings')['clusterSettings'].radius;
	        }
	
	        vStyle = that._prjLayer.get('vectorSettings');
	        that._createGroupStruct();
	
	        that.switchLayerSources();
	
	        if (vStyle['zoomsEnabled']) {
	            that._olLayer.setMinResolution(startResolution / Math.pow(2, vStyle.maxZoom));
	            that._olLayer.setMaxResolution(startResolution / Math.pow(2, vStyle.minZoom)+0.5);
	        } else {
	            that._olLayer.setMinResolution(startResolution / Math.pow(2, 22));
	            that._olLayer.setMaxResolution(startResolution+0.5);
	        }
	
	        if (that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
	            that.setGroupStyle();
	        } else {
	            that.setLayerStyle();
	        }
	
	        return that;
	    },
	
	
	    updateLayer: function() {
	        var that = this,
	            sources = {},
	            // для оптимизации аккумулируем фичи и разом добавим в сорсы
	            sourcesFeatures = {},
	            features = [],
	            // фичи без разделения по категориям
	            commonFeatures = [],
	            columnCode = that._prjLayer.get('visualSettings')['columnCode'],
	            featureClass,
	            cValue,
	            options = {};
	
	
	        that._prjLayer.project.loadStructure(that._prjLayer.get('code')).then(function (str) {
	            var fields = [];
	            $.each(str, function(id, el) {
	                fields.push(el.code);
	            });
	            $.extend(options, that.options);
	            options.fields = options.fields.concat(fields);
	            return that._prjLayer.loadObjects(options);
	        }).then(function () {
	
	            that._olLayer.getLayers().forEach(function(sLayer){
	                sources[sLayer.categoryValue] = sLayer.vSource;
	                sourcesFeatures[sLayer.categoryValue] = [];
	                sLayer.vSource.clear();
	            });
	            that._olLayer.vSource.clear();
	
	            that._prjLayer.objects.each(function(obj, i){
	                var geom = obj.getGeometry();
	
	                if(geom && geom.type in ol.geom){
	                    obj.feature = new ol.Feature({
	                        obj     : obj,
	                        geometry: new ol.geom[geom.type](geom.coordinates)
	                    });
	                    obj.feature.setId(obj.id);
	                    features.push(obj.feature);
	
	                    if (columnCode == 'orbis_id') {
	                        cValue = obj.getId();
	                    } else {
	                        cValue = obj.get(columnCode);
	                    }
	
	                    if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
	                        if (cValue in sourcesFeatures) {
	                            sourcesFeatures[cValue].push(obj.feature);
	                        } else if ('default' in sourcesFeatures) {
	                            sourcesFeatures['default'].push(obj.feature);
	                        }
	                    } else {
	                        featureClass = that.getVisClassByValue(cValue);
	                        if (featureClass && featureClass.checked) {
	                            commonFeatures.push(obj.feature)
	                        }
	                    }
	                }
	            });
	            if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
	                for (cValue in sourcesFeatures) {
	                    if (sourcesFeatures.hasOwnProperty(cValue)) {
	                        sources[cValue].addFeatures(sourcesFeatures[cValue]);
	                    }
	                }
	            } else if (commonFeatures.length) {
	                that._olLayer.getLayers().getArray()[0].vSource.addFeatures(commonFeatures);
	            }
	            that._olLayer.vSource.addFeatures(features);
	        });
	    },
	
	    _createGroupStruct: function(){
	        var that = this,
	            classes,
	            columnCode,
	            subLayer,
	            i,
	            sources = {},
	            features = [],
	            cValue,
	            featureClass,
	            cStyle = that._prjLayer.get('vectorSettings').clusterSettings,
	            clusteringEnabled = that._prjLayer.get('vectorSettings').clusteringEnabled;
	
	        classes = that._prjLayer.get('visualSettings')['classesSettings']['classes'];
	        columnCode = that._prjLayer.get('visualSettings')['columnCode'];
	        that.categoryColumnCode = columnCode;
	
	        that._olLayer.getLayers().clear();
	        if (that._olLayer.vSource) {
	            that._olLayer.vSource.clear();
	        } else {
	            that._olLayer.vSource = new ol.source.Vector();
	        }
	        if (cStyle.splitByCategories) {
	            for (i in classes) {
	                subLayer = new ol.layer.Vector();
	                subLayer.set('omjsLayer', that);
	                subLayer.styleCache = {};
	                sources[classes[i].value] = new ol.source.Vector();
	                subLayer.vSource = sources[classes[i].value];
	                if (clusteringEnabled) {
	                    subLayer.vClusterSource = new ol.source.Cluster({
	                        source: subLayer.vSource,
	                        distance: cStyle.radius
	                    });
	                } else {
	                    subLayer.vClusterSource = null;
	                }
	                subLayer.categoryValue = classes[i].value;
	                that._olLayer.getLayers().push(subLayer);
	                subLayer.setVisible(classes[i]['checked']);
	            }
	
	            if (that._prjLayer.get('visualSettings')['classesSettings']['defaultClass']) {
	                subLayer = new ol.layer.Vector();
	                subLayer.set('omjsLayer', that);
	                subLayer.styleCache = {};
	                sources['default'] = new ol.source.Vector();
	                subLayer.vSource = sources['default'];
	                if (clusteringEnabled) {
	                    subLayer.vClusterSource = new ol.source.Cluster({
	                        source: subLayer.vSource,
	                        distance: cStyle.radius
	                    });
	                } else {
	                    subLayer.vClusterSource = null;
	                }
	                subLayer.categoryValue = that._prjLayer.get('visualSettings')['classesSettings']['defaultClass'].value;
	                that._olLayer.getLayers().push(subLayer);
	                subLayer.setVisible(that._prjLayer.get('visualSettings')['classesSettings']['defaultClass'].checked);
	            }
	
	        } else {
	            subLayer = new ol.layer.Vector();
	            subLayer.set('omjsLayer', that);
	            subLayer.styleCache = {};
	            subLayer.vSource = new ol.source.Vector();
	            if (clusteringEnabled) {
	                subLayer.vClusterSource = new ol.source.Cluster({
	                    source: subLayer.vSource,
	                    distance: cStyle.radius
	                });
	            } else {
	                subLayer.vClusterSource = null;
	            }
	            that._olLayer.getLayers().push(subLayer);
	        }
	
	        // делаем кучу фич и распихиваем их в зависимости от структуры
	        that._prjLayer.objects.each(function(obj, i){
	            var geom = obj.getGeometry();
	
	            if(geom && geom.type in ol.geom){
	                obj.feature = new ol.Feature({
	                    obj     : obj,
	                    geometry: new ol.geom[geom.type](geom.coordinates)
	                });
	                obj.feature.setId(obj.id);
	                features.push(obj.feature);
	
	                if (columnCode == 'orbis_id') {
	                    cValue = obj.getId();
	                } else {
	                    cValue = obj.get(columnCode);
	                }
	
	                if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
	                    if (cValue in sources) {
	                        sources[cValue].addFeature(obj.feature);
	                    } else if ('default' in sources) {
	                        sources['default'].addFeature(obj.feature);
	                    }
	                } else {
	                    featureClass = that.getVisClassByValue(cValue);
	                    if (featureClass && featureClass.checked) {
	                        subLayer.vSource.addFeature(obj.feature);
	                    }
	                }
	            }
	        });
	        that._olLayer.vSource.addFeatures(features);
	    },
	
	    fillSources: function(objects){
	        var that = this,
	            sources = {},
	            obj,
	            i,
	            columnCode = that._prjLayer.get('visualSettings')['columnCode'],
	            cValue,
	            featureClass;
	
	        that._olLayer.getLayers().forEach(function(subLayer){
	            sources[subLayer.categoryValue] = subLayer.vSource;
	            subLayer.vSource.clear();
	        });
	
	        for (i in objects) {
	            obj = objects[i];
	
	            if (columnCode == 'orbis_id') {
	                cValue = obj.getId();
	            } else {
	                cValue = obj.get(columnCode);
	            }
	
	            if(that._prjLayer.get('vectorSettings').clusterSettings.splitByCategories) {
	                if (cValue in sources) {
	                    sources[cValue].addFeature(obj.feature);
	                } else if ('default' in sources) {
	                    sources['default'].addFeature(obj.feature);
	                }
	            } else {
	                featureClass = that.getVisClassByValue(cValue);
	                if (featureClass && featureClass.checked) {
	                    subLayer.vSource.addFeature(obj.feature);
	                }
	            }
	        }
	    },
	
	    switchLayerSources: function(){
	        var that = this,
	            zoom,
	            cStyle = that._prjLayer.get('vectorSettings').clusterSettings;
	
	        if (that._olLayer.getLayers().getLength() == 0 || !that.map) {
	            return;
	        }
	
	        zoom = that.map.getView().getZoom();
	
	        if (that._prjLayer.get('vectorSettings').clusteringEnabled) {
	            if (cStyle.maxZoomEnabled && zoom > cStyle.maxZoom) {
	                that._olLayer.getLayers().forEach(function (subLayer) {
	                    subLayer.setSource(subLayer.vSource);
	                });
	            } else {
	                that._olLayer.getLayers().forEach(function (subLayer) {
	                    subLayer.setSource(subLayer.vClusterSource);
	                });
	            }
	        } else {
	            that._olLayer.getLayers().forEach(function (subLayer) {
	                subLayer.setSource(subLayer.vSource);
	            });
	        }
	    },
	
	    _createImgLoader: function(iconUrl) {
	        var that = this;
	
	        that.imgCache[iconUrl] = new Image();
	        that.imgCache[iconUrl].def = $.Deferred();
	        that.imgCache[iconUrl].crossOrigin = 'anonymous';
	        that.imgCache[iconUrl].onload = function(){
	            this.def.resolve(true);
	        };
	        return that.imgCache[iconUrl].def;
	    },
	
	    _reloadLayerIcons: function(){
	        var that = this,
	            master = $.Deferred(),
	            defs = [],
	            vStyle,
	            classes,
	            defClass,
	            i,
	            url;
	
	        that.imgCache = {};
	
	
	        classes = that._prjLayer.get('visualSettings')['classesSettings'].classes;
	        defClass = that._prjLayer.get('visualSettings')['classesSettings'].defaultClass;
	        vStyle = that._prjLayer.get('vectorSettings');
	
	        for (var c in classes) {
	            if (classes[c].icon && classes[c].icon != "" && classes[c].icon != null && that.imgCache[classes[c].icon] === undefined) {
	                defs.push(that._createImgLoader(classes[c].icon));
	            }
	        }
	
	        if (vStyle['clusteringEnabled'] && vStyle['clusterSettings'].icon != null && vStyle.clusterSettings.iconEnabled
	            && that.imgCache[vStyle.clusterSettings.icon] === undefined) {
	            defs.push(that._createImgLoader(vStyle.clusterSettings.icon));
	        }
	
	        if (defClass != null && defClass.icon) {
	            defs.push(that._createImgLoader(defClass.icon));
	        }
	
	        if (_.isEmpty(that.imgCache)) {
	            master.resolve(true);
	            return master;
	        }
	
	        $.when.apply($,defs).then(function(){
	            master.resolve(true);
	        });
	
	        for (i in that.imgCache) {
	            url = that.project.apiUrlLocation.protocol
	                + '//'
	                + that.project.apiUrlLocation.hostname
	                + i + '?r=' + Math.floor(Math.random() * (999999)) + 1;
	
	            that.imgCache[i].src = url;
	        }
	        return master;
	    },
	
	    getVisClassByValue: function(value){
	        var that = this,
	            visualSettings = that._prjLayer.get('visualSettings');
	
	        for(var i in visualSettings.classesSettings.classes){
	            if(visualSettings.classesSettings.classes[i].value == value){
	                return visualSettings.classesSettings.classes[i]
	            }
	        }
	
	        return visualSettings.classesSettings.defaultClass
	    },
	
	    setGroupStyle: function(){
	        var that = this,
	            vStyle = that._prjLayer.get('vectorSettings'),
	            layerGrp = that._olLayer,
	            iconImg;
	
	        that._reloadLayerIcons().done(function(){
	
	            layerGrp.getLayers().forEach(function(subLayer){
	                subLayer.styleCache = {};
	
	                var categoryClass = that.getVisClassByValue(subLayer.categoryValue);
	                subLayer.categoryIcon = categoryClass.icon;
	                subLayer.setStyle(function(feature, resolution){
	                    var size = feature.get('features') ? feature.get('features').length : 1,
	                        styles = [],
	                        scale,
	                        offset = vStyle.stylesPoint.iconOffsetEnabled
	                            ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
	                            : [0,0];
	                    if (resolution+'' in subLayer.styleCache) {
	                        if (subLayer.styleCache[resolution+''][size]) {
	                            return subLayer.styleCache[resolution+''][size];
	                        }
	                    } else {
	                        subLayer.styleCache[resolution+''] = [];
	                    }
	
	                    if (size > 1) {
	
	                        var min = 2, max = 2;
	                        subLayer.getSource().getFeatures().forEach(function(f){
	                            min = Math.min(min, f.get('features').length);
	                            max = Math.max(max, f.get('features').length);
	                        });
	
	                        var sizeDelta = vStyle.clusterSettings.iconSizeMax - vStyle.clusterSettings.iconSizeMin;
	                        var iconSize = parseInt(vStyle.clusterSettings.iconSizeMin + sizeDelta * (size-min)/(max-min));
	
	                        if (vStyle.clusterSettings.icon != null && vStyle.clusterSettings.iconEnabled) {
	                            iconImg = that.imgCache[vStyle.clusterSettings.icon];
	                            offset = vStyle.clusterSettings.iconOffsetEnabled
	                                ? [-vStyle.clusterSettings.iconDx, -vStyle.clusterSettings.iconDy]
	                                : [0,0];
	                        } else {
	                            iconImg = that.imgCache[subLayer.categoryIcon];
	                            offset = vStyle.stylesPoint.iconOffsetEnabled
	                                ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
	                                : [0,0];
	                        }
	
	                        offset[0] += iconImg.width/2;
	                        offset[1] += iconImg.height/2;
	
	                        scale =  vStyle.clusterSettings.iconSizeEnabled ? iconSize/iconImg.width : 1;
	
	                        styles.push(new ol.style.Style({
	                            image: new ol.style.Icon({
	                                anchor: offset,
	                                anchorXUnits: 'pixels',
	                                anchorYUnits: 'pixels',
	                                opacity: 1,
	                                img: iconImg,
	                                imgSize:[iconImg.width,iconImg.height],
	                                scale: scale
	                            })
	                        }));
	
	                        // count style
	                        if (vStyle.clusterSettings.showObjectsCount) {
	                            try {
	                                scale = 1 / (that.pixelRatio || devPixelRatio);
	                                var countIcon = utils.createObjectsCountCnv(size < 100 ? size.toString() : '*', scale,
	                                    that.cluserSizeOptions);
	                                styles.push(new ol.style.Style({
	                                    image: new ol.style.Icon({
	                                        anchor: [
	                                            (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
	                                            (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
	                                        ],
	                                        anchorXUnits: 'pixels',
	                                        anchorYUnits: 'pixels',
	                                        opacity: 1,
	                                        imgSize: [countIcon.width, countIcon.height],
	                                        img: countIcon,
	                                        scale: 1 / scale
	                                    })
	                                }));
	                            } catch (err) {
	                                console.error(err);
	                            }
	                        }
	                    } else {
	                        // one feature style
	                        iconImg = that.imgCache[subLayer.categoryIcon];
	                        offset[0] += iconImg.width/2;
	                        offset[1] += iconImg.height/2;
	
	                        styles.push(new ol.style.Style({
	                            image: new ol.style.Icon({
	                                anchor: offset,
	                                anchorXUnits: 'pixels',
	                                anchorYUnits: 'pixels',
	                                opacity: 1,
	                                img: iconImg,
	                                imgSize:[iconImg.width,iconImg.height]
	                            })
	                        }));
	                    }
	
	                    subLayer.styleCache[resolution+''][size] = styles;
	                    return styles;
	                });
	            });
	        })
	    },
	
	    setLayerStyle: function(){
	        var that = this,
	            iconImg,
	            vStyle = that._prjLayer.get("vectorSettings"),
	            cStyle = vStyle.clusterSettings;
	
	        that._reloadLayerIcons().done(function(){
	            that._olLayer.getLayers().forEach(function(subLayer){
	                subLayer.styleCache = {};
	
	                subLayer.setStyle(function(feature, resolution){
	                    var size = feature.get('features') ? feature.get('features').length : 1,
	                        styles = [],
	                        scale,
	                        category,
	                        offset = vStyle.stylesPoint.iconOffsetEnabled
	                            ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
	                            : [0,0],
	                        cacheKey,
	                        featureObj;
	
	                    featureObj = feature.get('features')
	                        ? feature.get('features')[0].get('obj')
	                        : feature.get('obj');
	                    // Колонка orbis_id в атрибуты объекта не записывается, она является Id объекта
	                    category = that.getVisClassByValue(that.categoryColumnCode == 'orbis_id'
	                        ? featureObj.getId()
	                        : featureObj.get(that.categoryColumnCode)
	                    );
	
	                    if (size > 1) {
	                        cacheKey = resolution+'_cluster';
	                    } else {
	                        cacheKey = resolution + '_' + category.value;
	                    }
	
	                    if (cacheKey in subLayer.styleCache) {
	                        if (subLayer.styleCache[cacheKey][size]) {
	                            return subLayer.styleCache[cacheKey][size];
	                        }
	                    } else {
	                        subLayer.styleCache[cacheKey] = [];
	                    }
	
	                    if (size > 1) {
	                        var min = 2, max = 2;
	                        subLayer.getSource().getFeatures().forEach(function(f){
	                            min = Math.min(min, f.get('features').length);
	                            max = Math.max(max, f.get('features').length);
	                        });
	
	                        var sizeDelta = cStyle.iconSizeMax - cStyle.iconSizeMin;
	                        var iconSize = parseInt(cStyle.iconSizeMin + sizeDelta * (size-min)/(max-min));
	
	                        if (cStyle.icon != null && cStyle.iconEnabled) {
	                            iconImg = that.imgCache[cStyle.icon];
	                            offset = cStyle.iconOffsetEnabled
	                                ? [-cStyle.iconDx, -cStyle.iconDy]
	                                : [0,0];
	                        } else {
	                            iconImg = that.imgCache[category.icon];
	                            offset = vStyle.stylesPoint.iconOffsetEnabled
	                                ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
	                                : [0,0];
	                        }
	
	                        offset[0] += iconImg.width/2;
	                        offset[1] += iconImg.height/2;
	
	                        scale =  cStyle.iconSizeEnabled ? iconSize/iconImg.width : 1;
	
	                        styles.push(new ol.style.Style({
	                            image: new ol.style.Icon({
	                                anchor: offset,
	                                anchorXUnits: 'pixels',
	                                anchorYUnits: 'pixels',
	                                opacity: 1,
	                                img: iconImg,
	                                imgSize:[iconImg.width,iconImg.height],
	                                scale: scale
	                            })
	                        }));
	
	                        // count style
	                        if (cStyle.showObjectsCount) {
	                            try {
	                                scale = 1 / (that.pixelRatio || devPixelRatio);
	                                var countIcon = utils.createObjectsCountCnv(size < 100 ? size.toString() : '*', scale,
	                                    that.cluserSizeOptions);
	                                styles.push(new ol.style.Style({
	                                    image: new ol.style.Icon({
	                                        anchor: [
	                                            (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
	                                            (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
	                                        ],
	                                        anchorXUnits: 'pixels',
	                                        anchorYUnits: 'pixels',
	                                        opacity: 1,
	                                        imgSize: [countIcon.width, countIcon.height],
	                                        img: countIcon,
	                                        scale: 1 / scale
	                                    })
	                                }));
	                            } catch (err) {
	                                console.error(err);
	                            }
	                        }
	                    } else {
	                        // one feature style
	                        iconImg = that.imgCache[category.icon];
	                        offset[0] += iconImg.width/2;
	                        offset[1] += iconImg.height/2;
	
	                        styles.push(new ol.style.Style({
	                            image: new ol.style.Icon({
	                                anchor: offset,
	                                anchorXUnits: 'pixels',
	                                anchorYUnits: 'pixels',
	                                opacity: 1,
	                                img: iconImg,
	                                imgSize:[iconImg.width,iconImg.height]
	                            })
	                        }));
	                    }
	
	                    subLayer.styleCache[cacheKey][size] = styles;
	                    return styles;
	                });
	            });
	        });
	    }
	});
	
	module.exports = OmsCategoryLayer;
	


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var VectorLayer = __webpack_require__(44),
	    ol = __webpack_require__(22),
	    Chart  = __webpack_require__(54),
	    _ = __webpack_require__(16),
	    $ = __webpack_require__(3),
	    utils = __webpack_require__(5);
	
	var devPixelRatio = 1/utils.getDevicePixelRatio();
	
	var OmsChartsLayer = VectorLayer.extend({
	
	    _setup: function(options){
	        var that = this,
	            vStyle;
	
	        options || (options = {});
	
	        if('projectLayers' in options){
	            that._prjLayers = options.projectLayers;
	        }
	
	        if(that._prjLayers && that._prjLayers.getLength() > 0){
	            that._prjLayer = that._prjLayers.at(0);
	
	            vStyle = that._prjLayer.get('visualSettings');
	            if (!vStyle) {
	                throw new Error("Not enough parameters to create a vector layer");
	            }
	
	            that.project = that._prjLayer.options.project;
	
	            OmsChartsLayer.__super__._setup.call(that, options);
	
	            // Chart.defaults.global.responsive = false;
	            // Chart.defaults.global.tooltips.enabled = false;
	            // Chart.defaults.global.legend.display = false;
	            // Chart.defaults.global.animation = false;
	            // Chart.defaults.global.defaultFontSize = 9;
	            // Chart.defaults.global.defaultFontColor = "#333333";
	            // Chart.defaults.global.defaultColor = "#666666";
	            // Chart.defaults.global.elements.arc.borderWidth = 1;
	
	            // колонки, по которым будем строить графики
	            that.columnStyles = [];
	            var a=0;
	            vStyle.classesSettings.columns.forEach(function(column){
	                that.columnStyles.push({
	                    id: column.id,
	                    color: column.color,
	                    sort: a
	                });
	                a++;
	            });
	
	            //колонка, по которой будет считаться размер графиков
	            if (vStyle.classesSettings.sizeType == 3) {
	                that.sizeColumn = vStyle.classesSettings.sizeColumn;
	            }
	
	            that.switchLayerSource();
	            that.setLayerStyle();
	        }
	
	        return that;
	    },
	
	    updateLayer: function() {
	        var that = this,
	            options = {};
	
	        $.extend(options, that.options);
	        that._prjLayer.project.loadStructure(that._prjLayer.get('code')).then(function (str) {
	            var fields = [];
	            $.each(str, function(id, el) {
	                fields.push(el.code);
	            });
	            options.fields = options.fields.concat(fields);
	            return that._prjLayers.at(0).loadObjects(options);
	        }).then(function () {
	            that._olSource.clear();
	            that._olSource.addFeatures(that.getFeatures());
	            that.setLayerStyle();
	        });
	    },
	
	    setChartDefaults: function() {
	        Chart.defaults.global.responsive = false;
	        Chart.defaults.global.tooltips.enabled = false;
	        Chart.defaults.global.legend.display = false;
	        Chart.defaults.global.animation = false;
	        Chart.defaults.global.defaultFontSize = 9;
	        Chart.defaults.global.defaultFontColor = "#333333";
	        Chart.defaults.global.defaultColor = "#666666";
	        Chart.defaults.global.elements.arc.borderWidth = 1;
	    },
	
	    onAdd: function(view){
	        var that = this;
	        that.map = view.getMap();
	        that.map.getView().on('change:resolution', function(){
	            that.switchLayerSource();
	        });
	    },
	
	    switchLayerSource: function(){
	        var that = this;
	
	        if (!that.map) {
	            return;
	        }
	        that._olLayer.setSource(that._olSource);
	    },
	
	    /**
	     *
	     */
	    _createPieChart: function(canvas, feature) {
	        var that = this,
	            data = [],
	            labels = [],
	            colors = [],
	            value;
	
	        var pixelRatio = that.pixelRatio ? that.pixelRatio : devPixelRatio;
	
	        var options = {
	            animation : false,
	            cutoutPercentage:-1
	        };
	
	        that.columnStyles.forEach(function(column) {
	            if(that.newArray[column.sort] == column.id) {
	                value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	            }else {
	                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	            }
	            if (value != null) {
	                data.push(typeof value === 'boolean' ? +value : value);
	                colors.push(column.color);
	                labels.push("");
	            }
	        });
	
	        if (data.length == 0) {
	            canvas.attr('no-data', 1);
	            return;
	        }
	
	        var chartData = {
	            labels: labels,
	            datasets: [
	                {
	                    data: data,
	                    backgroundColor: colors
	                }
	            ]
	        };
	
	        // если график строится только по одной колонке, убираем бордер у сегментов и рисуем один общий бордер
	        if (that.columnStyles.length == 1) {
	            chartData.datasets[0].borderWidth = [0];
	        }
	
	        new Chart(canvas[0].getContext("2d"), {
	            type: 'pie',
	            data: chartData,
	            options: options
	        });
	
	        if (that.columnStyles.length == 1) {
	            var obCanvas = canvas[0].getContext('2d');
	            obCanvas.beginPath();
	            obCanvas.arc(canvas[0].width*pixelRatio/2, canvas[0].width*pixelRatio/2, (canvas[0].width/2-1)*pixelRatio, 0, 2*Math.PI, false);
	            obCanvas.lineWidth = 1.1;
	            obCanvas.strokeStyle = '#fff';
	            obCanvas.stroke();
	        }
	    },
	
	
	    _createLineChart: function(canvas, feature) {
	        var that = this,
	            data = [],
	            value,
	            labels = []; //библиотека требует эту лабуду
	
	        var options = {
	            scales: {
	                xAxes: [{
	                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
	                    gridLines: {
	                        color: "rgba(0,0,0,0)"
	                    }
	                }],
	                yAxes: [{
	                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
	                    gridLines: {
	                        color: "rgba(0,0,0,0)"
	                    },
	                    ticks:{
	                        maxTicksLimit: 6,
	                        padding: 3
	                    }
	                }]
	            }
	        };
	
	        //влияет на размер графика без шкалы
	        if (that._prjLayer.get('visualSettings')['classesSettings'].showScale) {
	            options.scales.yAxes[0].ticks.suggestedMin = that.minMaxScaleValues[0];
	            options.scales.yAxes[0].ticks.suggestedMax = that.minMaxScaleValues[1]
	        } else {
	            options.scales.yAxes[0].ticks.min = that.minMaxScaleValues[0];
	            options.scales.yAxes[0].ticks.max = that.minMaxScaleValues[1]
	        }
	
	        that.columnStyles.forEach(function(column) {
	            if(that.newArray[column.sort] == column.id) {
	                value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	            }else {
	                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	            }
	            if (value != null) {
	                data.push(typeof value === 'boolean' ? +value : value);
	                labels.push("");
	            }
	        });
	
	        if (data.length == 0) {
	            canvas.attr('no-data', 1);
	            return;
	        }
	
	        var chartData = {
	            labels: labels,
	            datasets: [
	                {
	                    fill:false,
	                    lineTension: 0.3,
	                    borderColor: that.columnStyles[0].color,
	                    pointBackgroundColor: that.columnStyles[0].color,
	                    pointRadius: 1,
	                    data: data
	                }
	            ]
	        };
	
	        new Chart(canvas[0].getContext("2d"), {
	            type: 'line',
	            data: chartData,
	            options: options
	        });
	    },
	
	
	    _createBarChart: function(canvas, feature) {
	        var that = this,
	            data = [],
	            value;
	
	        var options = {
	            scales: {
	                xAxes: [{
	                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
	                    categoryPercentage: 0.9
	                }],
	                yAxes: [{
	                    display: that._prjLayer.get('visualSettings')['classesSettings'].showScale,
	                    gridLines: {
	                        color: "rgba(0,0,0,0)"
	                    },
	                    ticks: {
	                        maxTicksLimit: 6,
	                        padding: 3
	                    }
	                }]
	            }
	        };
	
	        //влияет на размер графика без шкалы
	        if (that._prjLayer.get('visualSettings')['classesSettings'].showScale) {
	            options.scales.yAxes[0].ticks.suggestedMin = that.minMaxScaleValues[0];
	            options.scales.yAxes[0].ticks.suggestedMax = that.minMaxScaleValues[1]
	        } else {
	            options.scales.yAxes[0].ticks.min = that.minMaxScaleValues[0];
	            options.scales.yAxes[0].ticks.max = that.minMaxScaleValues[1]
	        }
	
	
	        var visible = false;
	        that.columnStyles.forEach(function(column) {
	            if(that.newArray[column.sort] == column.id) {
	                value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	            }else {
	                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	            }
	            visible = visible || value != null;
	            data.push({
	                backgroundColor: column.color,
	                data: [typeof value === 'boolean' ? +value : value]
	            });
	        });
	
	        if (!visible) {
	            canvas.attr('no-data', 1);
	            return;
	        }
	
	        var chartData = {
	            labels: [""],
	            datasets: data
	        };
	
	        new Chart(canvas[0].getContext("2d"), {
	            type: 'bar',
	            data: chartData,
	            options: options
	        });
	    },
	
	    _reloadLayerIcons: function(){
	        var that = this,
	            master = $.Deferred(),
	            features,
	            chartSize,
	            canvas,
	            visStyle;
	
	        that.newArray = [];
	        that._prjLayer.project.loadStructure(that._prjLayer.get('code')).then(function(arr) {
	            visStyle = that._prjLayer.get('visualSettings');
	
	            that.chartCache = {};
	            that.minMaxValues = false;
	            features = that._prjLayer.objects;
	            // для линейных и столбчатых диаграмм нужно посчитать общую границу шкалы
	            that.allPrjArray = [];
	            $.each(arr, function (id, elem) {
	                that.columnStyles.forEach(function (column) {
	                    if (elem.id == column.id) {
	                        that.newArray[column.sort] = elem.code;
	                    }
	                });
	                that.allPrjArray[id] = elem;
	            });
	            if (visStyle.type == 5 || visStyle.type == 6) {
	                that.minMaxScaleValues = false;
	                that._getMinMaxScaleTicks(features);
	            }
	            features.each(function (feature) {
	                chartSize = that._getChartSize(feature);
	                canvas = $('<canvas width="' + chartSize.w + '" height="' + chartSize.h + '"></canvas>');
	
	                switch (visStyle.type) {
	                    case 4:
	                        that._createPieChart(canvas, feature);
	                        break;
	                    case 5:
	                        that._createBarChart(canvas, feature);
	                        break;
	                    case 6:
	                        that._createLineChart(canvas, feature);
	                        break;
	                }
	
	                that.chartCache[feature.getId()] = canvas[0];
	                canvas.detach();
	            });
	            master.resolve(true);
	        });
	        return master;
	    },
	
	    setLayerStyle: function(){
	        var that = this,
	            chart,
	            vStyle = that._prjLayer.get('visualSettings');
	
	        that.setChartDefaults();
	        // update images, then set layer style function
	        return that._reloadLayerIcons().done(function(){
	
	            // Чистим сохраненные стили
	            that.styleCache = {};
	
	            that._olLayer.setStyle(function(feature){
	                var styles = [],
	                    offset = [0,0],
	                    featureId = feature.getId();
	
	                var pixelRatio = that.pixelRatio ? that.pixelRatio : devPixelRatio;
	
	                if (featureId+'' in that.styleCache) {
	                    return that.styleCache[featureId+''];
	                }
	
	                chart = that.chartCache[featureId];
	
	                if(!chart || !chart.width){
	                    return false;
	                }
	                offset[0] = chart.width/2;
	                offset[1] = chart.height/2;
	                // прозрачный фон для кликанья по линейным и столбчатым графикам
	                if (vStyle.type != 4 && $(chart).attr('no-data') == undefined) {
	                    styles.push(new ol.style.Style({
	                        image: new ol.style.RegularShape({
	                            fill: new ol.style.Fill({color: 'rgba(255,255,255,0.01)'}),
	                            points: 4,
	                            radius: Math.sqrt((chart.width * chart.width) + (chart.height * chart.height)) / 2,
	                            angle: Math.PI / 4,
	                            scale:pixelRatio
	                        })
	                    }));
	                }
	
	                styles.push(new ol.style.Style({
	                    image: new ol.style.Icon({
	                        anchor: offset,
	                        anchorXUnits: 'pixels',
	                        anchorYUnits: 'pixels',
	                        opacity: vStyle.classesSettings.opacity / 100,
	                        img: chart,
	                        imgSize:[chart.width, chart.height],
	                        scale: pixelRatio
	                    })
	                }));
	
	                if (vStyle.showText && $(chart).attr('no-data') == undefined) {
	                    var need;
	                    $.each(that.allPrjArray, function(index, column){
	                        if (column.id == vStyle.textSettings.column){
	                            need = column.code;
	                        }
	                    });
	                    var value = (need == 'orbis_id') ? feature.getId() :  feature.get("obj").get(need);
	                    value = utils.doubleUnescapeHTML(value);
	                    var textSettings = {
	                        font: vStyle.textSettings.fontSize + 'px sans-serif',
	                        width: 2,
	                        text: value == null ? '' : _.unescape(value.toString()),
	                        fill: new ol.style.Fill({
	                            color: that._toRgba(vStyle.textSettings.fontColor, vStyle.textSettings.fontOpacity)
	                        })
	                    };
	
	                    if (vStyle.textSettings.halo) {
	                        textSettings.stroke = new ol.style.Stroke({
	                            color: that._toRgba(vStyle.textSettings.haloColor, vStyle.textSettings.haloOpacity),
	                            width: vStyle.textSettings.haloWidth
	                        })
	                    }
	
	                    if (vStyle.textSettings.offsetEnabled) {
	                        textSettings.offsetY = vStyle.textSettings.textOffset;
	                    }
	
	                    styles.push(new ol.style.Style({
	                        text: new ol.style.Text(textSettings)
	                    }));
	                }
	
	                that.styleCache[featureId+''] = styles;
	                return styles;
	            });
	        });
	    },
	
	    _getMinMaxScaleTicks: function(){
	        var that = this,
	            min = 0,
	            max = 0,
	            value;
	
	        if (that.minMaxScaleValues) {
	            return;
	        }
	
	        that._prjLayer.objects.each(function(feature){
	            that.columnStyles.forEach(function(column){
	                // if(that.newArray[column.sort] == column.id) {
	                //     value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	                // }else {
	                //     value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	                // }
	                value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	                if (value != null) {
	
	                    if (value) {
	                        if (value < min) {
	                            min = value;
	                        }
	                        if (value > max) {
	                            max = value;
	                        }
	                    }
	                }
	            });
	        });
	        that.minMaxScaleValues = [min, max];
	    },
	
	    /**
	     *
	     */
	    _getMinMaxValues: function(type){
	        var that = this,
	            min,
	            max,
	            features,
	            value;
	        
	        if (that.minMaxValues) {
	            return;
	        }
	
	        features = that._prjLayer.objects;
	        if (features.length == 0) {
	            return;
	        }
	
	        switch(type) {
	            // сумма значений
	            case 2:
	                //найдем минимальное и максимальное значение по суммам
	                features.each(function(feature){
	                    value = false;
	                    that.columnStyles.forEach(function(column){
	                        var v;
	                        if(that.newArray[column.sort] == column.id) {
	                            v = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	                        }else {
	                            v = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	                        }
	                        if (v != null) {
	                            value += v;
	                        }
	                    });
	
	                    if (value) {
	                        if (!min || value < min) {
	                            min = value;
	                        }
	                        if (!max || value > max) {
	                            max = value;
	                        }
	                    }
	                });
	                that.minMaxValues = [min, max];
	                break;
	
	            // по колонке
	            case 3:
	                //найдем минимальное и максимальное значение по колонке
	                features.each(function(feature){
	                    that.columnStyles.forEach(function(column){
	                        if(that.newArray[column.sort] == that.sizeColumn) {
	                            value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	                        }else {
	                            value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	                        }
	                        if (value != null) {
	                            if (!min || value < min) {
	                                min = value;
	                            }
	                            if (!max || value > max) {
	                                max = value;
	                            }
	                        }
	                    });
	                });
	                that.minMaxValues = [min, max];
	                break;
	        }
	    },
	
	    _getChartSize: function(feature){
	        var that     = this,
	            visStyle = that._prjLayer.get("visualSettings"),
	            classesSettings = that._prjLayer.get("visualSettings")['classesSettings'],
	            value;
	
	        // для линейных и столбчатых диаграмм нужно посчитать ширину шкалы
	        var scaleWidth = 0;
	
	        if (visStyle.type == 5 || visStyle.type == 6) {
	            // если шкала включена, считаем, сколько она должна занять места
	            if (classesSettings.showScale) {
	                scaleWidth = Math.max(that.minMaxScaleValues[0].toString().length + 1, that.minMaxScaleValues[1].toString().length + 1) * 5;
	            }
	        }
	
	        if (classesSettings.sizeType == 1) {
	            // для фиксированного графика сразу возвращаем размеры
	            return {w: classesSettings.sizeValue + scaleWidth, h: classesSettings.sizeValue};
	        } else {
	            // иначе ищем мин макс значения среди всех фич в зависимости от типа графика
	            that._getMinMaxValues(classesSettings.sizeType);
	            if (that.minMaxValues[1] == that.minMaxValues[0]) {
	                // если не смогли найти мин макс, берем средний арифметический размер графика
	                var size = (classesSettings.sizeTo - classesSettings.sizeFrom) / 2;
	                return {w: size + scaleWidth, h: size};
	            }
	        }
	
	        // считаем значение конкретной фичи, чтобы потом рассчитать пропорцию
	        if (classesSettings.sizeType == 2) {
	            value = 0;
	            that.columnStyles.forEach(function(column){
	                var v;
	                if(that.newArray[column.sort] == column.id) {
	                    v = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
	                }else {
	                    v = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	                }
	                if (v != null) {
	                    value += v;
	                }
	
	            });
	        } else if (classesSettings.sizeType == 3) {
	            that.columnStyles.forEach(function(column) {
	                if (that.newArray[column.sort] == that.sizeColumn) {
	                    value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() : feature.get(that._prjLayer.get('visualSettings').columnCode);
	                } else {
	                    value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
	                }
	            });
	        }
	
	        //считаем размер графика в пропорции
	        var sizeDelta = classesSettings.sizeTo - classesSettings.sizeFrom;
	        var chartSize = parseInt(classesSettings.sizeFrom + sizeDelta * (value - that.minMaxValues[0]) / (that.minMaxValues[1] - that.minMaxValues[0]));
	
	        return {w: chartSize + scaleWidth, h: chartSize};
	    },
	
	    _toRgba: function(hex, opacity){
	        var startPos = 0;
	        if(~hex.indexOf("#")){startPos = 1}
	        var r = parseInt(hex.substr((0 + startPos), 2), 16);
	        var g = parseInt(hex.substr((2 + startPos), 2), 16);
	        var b = parseInt(hex.substr((4 + startPos), 2), 16);
	        return "rgba(" + ((r.toString().length == 1) ? '0' + r : r) + ", " + ((g.toString().length == 1) ? '0' + g
	                : g) + ", " + ((b.toString().length == 1) ? '0' + b : b) + ", " + opacity / 100 + ")";
	    },
	
	    show: function() {
	        var that = this;
	        that._prjLayer.set('selected', true);
	        if (that.loadOptions) {
	            that._prjLayer.loadObjects(that.loadOptions)
	                .then(function () {
	                    that.loadOptions = undefined;
	                    that._setup({
	                        projectLayers: that._prjLayers
	                    });
	                    if (that._prjLayer.get('selected')) {
	                        OmsChartsLayer.__super__.show.call(that);
	                    }
	                });
	        } else {
	            OmsChartsLayer.__super__.show.call(that);
	        }
	    },
	
	    hide: function() {
	        var that = this;
	        that._prjLayer.set('selected', false);
	        OmsChartsLayer.__super__.hide.call(that);
	    }
	});
	
	module.exports = OmsChartsLayer;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var Chart = __webpack_require__(55)();
	
	__webpack_require__(56)(Chart);
	__webpack_require__(62)(Chart);
	__webpack_require__(63)(Chart);
	__webpack_require__(64)(Chart);
	__webpack_require__(65)(Chart);
	__webpack_require__(66)(Chart);
	__webpack_require__(67)(Chart);
	__webpack_require__(68)(Chart);
	__webpack_require__(69)(Chart);
	__webpack_require__(70)(Chart);
	__webpack_require__(71)(Chart);
	__webpack_require__(72)(Chart);
	
	__webpack_require__(73)(Chart);
	__webpack_require__(74)(Chart);
	__webpack_require__(75)(Chart);
	__webpack_require__(76)(Chart);
	__webpack_require__(77)(Chart);
	__webpack_require__(78)(Chart);
	
	__webpack_require__(79)(Chart);
	__webpack_require__(80)(Chart);
	__webpack_require__(81)(Chart);
	__webpack_require__(82)(Chart);
	__webpack_require__(83)(Chart);
	
	__webpack_require__(187)(Chart);
	__webpack_require__(188)(Chart);
	__webpack_require__(189)(Chart);
	__webpack_require__(190)(Chart);
	
	__webpack_require__(191)(Chart);
	__webpack_require__(192)(Chart);
	__webpack_require__(193)(Chart);
	__webpack_require__(194)(Chart);
	__webpack_require__(195)(Chart);
	__webpack_require__(196)(Chart);
	__webpack_require__(197)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function() {
	
		//Occupy the global variable of Chart, and create a simple base class
		var Chart = function(context, config) {
			this.config = config;
	
			// Support a jQuery'd canvas element
			if (context.length && context[0].getContext) {
				context = context[0];
			}
	
			// Support a canvas domnode
			if (context.getContext) {
				context = context.getContext("2d");
			}
	
			this.ctx = context;
			this.canvas = context.canvas;
	
			// Figure out what the size of the chart will be.
			// If the canvas has a specified width and height, we use those else
			// we look to see if the canvas node has a CSS width and height.
			// If there is still no height, fill the parent container
			this.width = context.canvas.width || parseInt(Chart.helpers.getStyle(context.canvas, 'width')) || Chart.helpers.getMaximumWidth(context.canvas);
			this.height = context.canvas.height || parseInt(Chart.helpers.getStyle(context.canvas, 'height')) || Chart.helpers.getMaximumHeight(context.canvas);
	
			this.aspectRatio = this.width / this.height;
	
			if (isNaN(this.aspectRatio) || isFinite(this.aspectRatio) === false) {
				// If the canvas has no size, try and figure out what the aspect ratio will be.
				// Some charts prefer square canvases (pie, radar, etc). If that is specified, use that
				// else use the canvas default ratio of 2
				this.aspectRatio = config.aspectRatio !== undefined ? config.aspectRatio : 2;
			}
	
			// Store the original style of the element so we can set it back
			this.originalCanvasStyleWidth = context.canvas.style.width;
			this.originalCanvasStyleHeight = context.canvas.style.height;
	
			// High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
			Chart.helpers.retinaScale(this);
	
			if (config) {
				this.controller = new Chart.Controller(this);
			}
	
			// Always bind this so that if the responsive state changes we still work
			var _this = this;
			Chart.helpers.addResizeListener(context.canvas.parentNode, function() {
				if (_this.controller && _this.controller.config.options.responsive) {
					_this.controller.resize();
				}
			});
	
			return this.controller ? this.controller : this;
	
		};
	
		//Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
				hover: {
					onHover: null,
					mode: 'single',
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join("");
				}
			}
		};
	
		return Chart;
	
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/*global window: false */
	/*global document: false */
	"use strict";
	
	var color = __webpack_require__(57);
	
	module.exports = function(Chart) {
	
		//Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		//-- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (obj.hasOwnProperty(key)) {
					if (helpers.isArray(value)) {
						objClone[key] = value.slice(0);
					} else if (typeof value === 'object' && value !== null) {
						objClone[key] = helpers.clone(value);
					} else {
						objClone[key] = value;
					}
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var len = arguments.length;
			var additionalArgs = [];
			for (var i = 1; i < len; i++) {
				additionalArgs.push(arguments[i]);
			}
			helpers.each(additionalArgs, function(extensionObject) {
				helpers.each(extensionObject, function(value, key) {
					if (extensionObject.hasOwnProperty(key)) {
						base[key] = value;
					}
				});
			});
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					if (extension.hasOwnProperty(key)) {
						if (key === 'scales') {
							// Scale config merging is complex. Add out own function here for that
							base[key] = helpers.scaleMerge(base.hasOwnProperty(key) ? base[key] : {}, value);
	
						} else if (key === 'scale') {
							// Used in polar area & radar charts since there is only one scale
							base[key] = helpers.configMerge(base.hasOwnProperty(key) ? base[key] : {}, Chart.scaleService.getScaleDefaults(value.type), value);
						} else if (base.hasOwnProperty(key) && helpers.isArray(base[key]) && helpers.isArray(value)) {
							// In this case we have an array of objects replacing another array. Rather than doing a strict replace,
							// merge. This allows easy scale option merging
							var baseArray = base[key];
	
							helpers.each(value, function(valueObj, index) {
	
								if (index < baseArray.length) {
									if (typeof baseArray[index] === 'object' && baseArray[index] !== null && typeof valueObj === 'object' && valueObj !== null) {
										// Two objects are coming together. Do a merge of them.
										baseArray[index] = helpers.configMerge(baseArray[index], valueObj);
									} else {
										// Just overwrite in this case since there is nothing to merge
										baseArray[index] = valueObj;
									}
								} else {
									baseArray.push(valueObj); // nothing to merge
								}
							});
	
						} else if (base.hasOwnProperty(key) && typeof base[key] === "object" && base[key] !== null && typeof value === "object") {
							// If we are overwriting an object with an object, do a merge of the properties.
							base[key] = helpers.configMerge(base[key], value);
	
						} else {
							// can just overwrite the value in this case
							base[key] = value;
						}
					}
				});
			});
	
			return base;
		};
		helpers.extendDeep = function(_base) {
			return _extendDeep.apply(this, arguments);
	
			function _extendDeep(dst) {
				helpers.each(arguments, function(obj) {
					if (obj !== dst) {
						helpers.each(obj, function(value, key) {
							if (dst[key] && dst[key].constructor && dst[key].constructor === Object) {
								_extendDeep(dst[key], value);
							} else {
								dst[key] = value;
							}
						});
					}
				});
				return dst;
			}
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (extension.hasOwnProperty(key)) {
					if (key === 'xAxes' || key === 'yAxes') {
						// These properties are arrays of items
						if (base.hasOwnProperty(key)) {
							helpers.each(value, function(valueObj, index) {
								var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
								var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
								if (index >= base[key].length || !base[key][index].type) {
									base[key].push(helpers.configMerge(axisDefaults, valueObj));
								} else if (valueObj.type && valueObj.type !== base[key][index].type) {
									// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
									base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
								} else {
									// Type is the same
									base[key][index] = helpers.configMerge(base[key][index], valueObj);
								}
							});
						} else {
							base[key] = [];
							helpers.each(value, function(valueObj) {
								var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
								base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
							});
						}
					} else if (base.hasOwnProperty(key) && typeof base[key] === "object" && base[key] !== null && typeof value === "object") {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(base[key], value);
	
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = function(arrayToSearch, item) {
			if (Array.prototype.indexOf) {
				return arrayToSearch.indexOf(item);
			} else {
				for (var i = 0; i < arrayToSearch.length; i++) {
					if (arrayToSearch[i] === item)
						return i;
				}
				return -1;
			}
		};
		helpers.where = function(collection, filterCallback) {
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = function(arrayToSearch, callback, thisArg) {
			var index = -1;
			if (Array.prototype.findIndex) {
				index = arrayToSearch.findIndex(callback, thisArg);
			} else {
				for (var i = 0; i < arrayToSearch.length; ++i) {
					thisArg = thisArg !== undefined ? thisArg : arrayToSearch;
	
					if (callback.call(thisArg, arrayToSearch[i], i, arrayToSearch)) {
						index = i;
						break;
					}
				}
			}
	
			return index;
		};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			//Basic javascript inheritance based on the model created in Backbone.js
			var parent = this;
			var ChartElement = (extensions && extensions.hasOwnProperty("constructor")) ? extensions.constructor : function() {
				return parent.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = parent.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = parent.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		})();
		helpers.warn = function(str) {
			//Method for warning of errors
			if (console && typeof console.warn === "function") {
				console.warn(str);
			}
		};
		//-- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				} else {
					return max;
				}
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				} else {
					return min;
				}
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = function(x) {
			if (Math.sign) {
				return Math.sign(x);
			} else {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			}
		};
		helpers.log10 = function(x) {
			if (Math.log10) {
				return Math.log10(x);
			} else {
				return Math.log(x) / Math.LN10;
			}
		};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			//Props to Rob Spencer at scaled innovation for his post on splining between points
			//http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
	
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else {
				if (fraction <= 1.0) {
					niceFraction = 1;
				} else if (fraction <= 2) {
					niceFraction = 2;
				} else if (fraction <= 5) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		//Easing functions adapted from Robert Penner's easing equations
		//http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				} else {
					return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
				}
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		//Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		})();
		helpers.cancelAnimFrame = (function() {
			return window.cancelAnimationFrame ||
				window.webkitCancelAnimationFrame ||
				window.mozCancelAnimationFrame ||
				window.oCancelAnimationFrame ||
				window.msCancelAnimationFrame ||
				function(callback) {
					return window.clearTimeout(callback, 1000 / 60);
				};
		})();
		//-- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			if (e.touches && e.touches.length > 0) {
				mouseX = e.touches[0].clientX;
				mouseY = e.touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent("on" + eventType, method);
			} else {
				node["on" + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent("on" + eventType, handler);
			} else {
				node["on" + eventType] = helpers.noop;
			}
		};
		helpers.bindEvents = function(chartInstance, arrayOfEvents, handler) {
			// Create the events object if it's not already present
			if (!chartInstance.events)
				chartInstance.events = {};
	
			helpers.each(arrayOfEvents, function(eventName) {
				chartInstance.events[eventName] = function() {
					handler.apply(chartInstance, arguments);
				};
				helpers.addEvent(chartInstance.chart.canvas, eventName, chartInstance.events[eventName]);
			});
		};
		helpers.unbindEvents = function(chartInstance, arrayOfEvents) {
			helpers.each(arrayOfEvents, function(handler, eventName) {
				helpers.removeEvent(chartInstance.chart.canvas, eventName, handler);
			});
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') != -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (max-width / max-height)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var constrainedDimension;
			var constrainedNode = document.defaultView.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = document.defaultView.getComputedStyle(domNode.parentNode)[maxStyle];
			var hasCNode = constrainedNode !== null && constrainedNode !== "none";
			var hasCContainer = constrainedContainer !== null && constrainedContainer !== "none";
	
			if (hasCNode || hasCContainer) {
				constrainedDimension = Math.min((hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : Number.POSITIVE_INFINITY), (hasCContainer ? parseMaxStyle(constrainedContainer, domNode.parentNode, percentageProperty) : Number.POSITIVE_INFINITY));
			}
			return constrainedDimension;
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var padding = parseInt(helpers.getStyle(container, 'padding-left')) + parseInt(helpers.getStyle(container, 'padding-right'));
	
			var w = container.clientWidth - padding;
			var cw = helpers.getConstraintWidth(domNode);
			if (cw !== undefined) {
				w = Math.min(w, cw);
			}
	
			return w;
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var padding = parseInt(helpers.getStyle(container, 'padding-top')) + parseInt(helpers.getStyle(container, 'padding-bottom'));
	
			var h = container.clientHeight - padding;
			var ch = helpers.getConstraintHeight(domNode);
			if (ch !== undefined) {
				h = Math.min(h, ch);
			}
	
			return h;
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var ctx = chart.ctx;
			var width = chart.canvas.width;
			var height = chart.canvas.height;
	        var pixelRatio;
	        if (window.customDevicePixelRatio) {
	            pixelRatio = chart.currentDevicePixelRatio = window.customDevicePixelRatio;
	        } else {
	            pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
	        }
	
			if (pixelRatio !== 1) {
				ctx.canvas.height = height * pixelRatio;
				ctx.canvas.width = width * pixelRatio;
				ctx.scale(pixelRatio, pixelRatio);
	
				// Store the device pixel ratio so that we can go backwards in `destroy`.
				// The devicePixelRatio changes with zoom, so there are no guarantees that it is the same
				// when destroy is called
				chart.originalDevicePixelRatio = chart.originalDevicePixelRatio || pixelRatio;
			}
	
			ctx.canvas.style.width = width + 'px';
			ctx.canvas.style.height = height + 'px';
		};
		//-- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + " " + pixelSize + "px " + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfStrings, cache) {
			cache = cache || {};
			cache.data = cache.data || {};
			cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				cache.data = {};
				cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfStrings, function(string) {
				// Undefined strings should not be measured
				if (string !== undefined && string !== null) {
					var textWidth = cache.data[string];
					if (!textWidth) {
						textWidth = cache.data[string] = ctx.measureText(string).width;
						cache.garbageCollect.push(string);
					}
	
					if (textWidth > longest) {
						longest = textWidth;
					}
				}
			});
	
			var gcLen = cache.garbageCollect.length / 2;
			if (gcLen > arrayOfStrings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete cache.data[cache.garbageCollect[i]];
				}
				cache.garbageCollect.splice(0, gcLen);
			}
	
			return longest;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.log('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.addResizeListener = function(node, callback) {
			// Hide an iframe before the node
			var hiddenIframe = document.createElement('iframe');
			var hiddenIframeClass = 'chartjs-hidden-iframe';
	
			if (hiddenIframe.classlist) {
				// can use classlist
				hiddenIframe.classlist.add(hiddenIframeClass);
			} else {
				hiddenIframe.setAttribute('class', hiddenIframeClass);
			}
	
			// Set the style
			hiddenIframe.style.width = '100%';
			hiddenIframe.style.display = 'block';
			hiddenIframe.style.border = 0;
			hiddenIframe.style.height = 0;
			hiddenIframe.style.margin = 0;
			hiddenIframe.style.position = 'absolute';
			hiddenIframe.style.left = 0;
			hiddenIframe.style.right = 0;
			hiddenIframe.style.top = 0;
			hiddenIframe.style.bottom = 0;
	
			// Insert the iframe so that contentWindow is available
			node.insertBefore(hiddenIframe, node.firstChild);
	
			(hiddenIframe.contentWindow || hiddenIframe).onresize = function() {
				if (callback) {
					callback();
				}
			};
		};
		helpers.removeResizeListener = function(node) {
			var hiddenIframe = node.querySelector('.chartjs-hidden-iframe');
	
			// Remove the resize detect iframe
			if (hiddenIframe) {
				hiddenIframe.parentNode.removeChild(hiddenIframe);
			}
		};
		helpers.isArray = function(obj) {
			if (!Array.isArray) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			}
			return Array.isArray(obj);
		};
		helpers.pushAllIfDefined = function(element, array) {
			if (typeof element === "undefined") {
				return;
			}
	
			if (helpers.isArray(element)) {
				array.push.apply(array, element);
			} else {
				array.push(element);
			}
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(color) {
			/* global CanvasPattern */
			return (color instanceof CanvasPattern) ?
				color :
				helpers.color(color).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	
	var convert = __webpack_require__(58),
	  string = __webpack_require__(60);
	
	var Color = function(obj) {
	  if (obj instanceof Color) return obj;
	  if (!(this instanceof Color)) return new Color(obj);
	
	  this.values = {
	    rgb: [0, 0, 0],
	    hsl: [0, 0, 0],
	    hsv: [0, 0, 0],
	    hwb: [0, 0, 0],
	    cmyk: [0, 0, 0, 0],
	    alpha: 1
	  }
	
	  // parse Color() argument
	  if (typeof obj == "string") {
	    var vals = string.getRgba(obj);
	    if (vals) {
	      this.setValues("rgb", vals);
	    } else if (vals = string.getHsla(obj)) {
	      this.setValues("hsl", vals);
	    } else if (vals = string.getHwb(obj)) {
	      this.setValues("hwb", vals);
	    } else {
	      throw new Error("Unable to parse color from string \"" + obj + "\"");
	    }
	  } else if (typeof obj == "object") {
	    var vals = obj;
	    if (vals["r"] !== undefined || vals["red"] !== undefined) {
	      this.setValues("rgb", vals)
	    } else if (vals["l"] !== undefined || vals["lightness"] !== undefined) {
	      this.setValues("hsl", vals)
	    } else if (vals["v"] !== undefined || vals["value"] !== undefined) {
	      this.setValues("hsv", vals)
	    } else if (vals["w"] !== undefined || vals["whiteness"] !== undefined) {
	      this.setValues("hwb", vals)
	    } else if (vals["c"] !== undefined || vals["cyan"] !== undefined) {
	      this.setValues("cmyk", vals)
	    } else {
	      throw new Error("Unable to parse color from object " + JSON.stringify(obj));
	    }
	  }
	}
	
	Color.prototype = {
	  rgb: function(vals) {
	    return this.setSpace("rgb", arguments);
	  },
	  hsl: function(vals) {
	    return this.setSpace("hsl", arguments);
	  },
	  hsv: function(vals) {
	    return this.setSpace("hsv", arguments);
	  },
	  hwb: function(vals) {
	    return this.setSpace("hwb", arguments);
	  },
	  cmyk: function(vals) {
	    return this.setSpace("cmyk", arguments);
	  },
	
	  rgbArray: function() {
	    return this.values.rgb;
	  },
	  hslArray: function() {
	    return this.values.hsl;
	  },
	  hsvArray: function() {
	    return this.values.hsv;
	  },
	  hwbArray: function() {
	    if (this.values.alpha !== 1) {
	      return this.values.hwb.concat([this.values.alpha])
	    }
	    return this.values.hwb;
	  },
	  cmykArray: function() {
	    return this.values.cmyk;
	  },
	  rgbaArray: function() {
	    var rgb = this.values.rgb;
	    return rgb.concat([this.values.alpha]);
	  },
	  hslaArray: function() {
	    var hsl = this.values.hsl;
	    return hsl.concat([this.values.alpha]);
	  },
	  alpha: function(val) {
	    if (val === undefined) {
	      return this.values.alpha;
	    }
	    this.setValues("alpha", val);
	    return this;
	  },
	
	  red: function(val) {
	    return this.setChannel("rgb", 0, val);
	  },
	  green: function(val) {
	    return this.setChannel("rgb", 1, val);
	  },
	  blue: function(val) {
	    return this.setChannel("rgb", 2, val);
	  },
	  hue: function(val) {
	    return this.setChannel("hsl", 0, val);
	  },
	  saturation: function(val) {
	    return this.setChannel("hsl", 1, val);
	  },
	  lightness: function(val) {
	    return this.setChannel("hsl", 2, val);
	  },
	  saturationv: function(val) {
	    return this.setChannel("hsv", 1, val);
	  },
	  whiteness: function(val) {
	    return this.setChannel("hwb", 1, val);
	  },
	  blackness: function(val) {
	    return this.setChannel("hwb", 2, val);
	  },
	  value: function(val) {
	    return this.setChannel("hsv", 2, val);
	  },
	  cyan: function(val) {
	    return this.setChannel("cmyk", 0, val);
	  },
	  magenta: function(val) {
	    return this.setChannel("cmyk", 1, val);
	  },
	  yellow: function(val) {
	    return this.setChannel("cmyk", 2, val);
	  },
	  black: function(val) {
	    return this.setChannel("cmyk", 3, val);
	  },
	
	  hexString: function() {
	    return string.hexString(this.values.rgb);
	  },
	  rgbString: function() {
	    return string.rgbString(this.values.rgb, this.values.alpha);
	  },
	  rgbaString: function() {
	    return string.rgbaString(this.values.rgb, this.values.alpha);
	  },
	  percentString: function() {
	    return string.percentString(this.values.rgb, this.values.alpha);
	  },
	  hslString: function() {
	    return string.hslString(this.values.hsl, this.values.alpha);
	  },
	  hslaString: function() {
	    return string.hslaString(this.values.hsl, this.values.alpha);
	  },
	  hwbString: function() {
	    return string.hwbString(this.values.hwb, this.values.alpha);
	  },
	  keyword: function() {
	    return string.keyword(this.values.rgb, this.values.alpha);
	  },
	
	  rgbNumber: function() {
	    return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	  },
	
	  luminosity: function() {
	    // http://www.w3.org/TR/WCAG20/#relativeluminancedef
	    var rgb = this.values.rgb;
	    var lum = [];
	    for (var i = 0; i < rgb.length; i++) {
	      var chan = rgb[i] / 255;
	      lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4)
	    }
	    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	  },
	
	  contrast: function(color2) {
	    // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
	    var lum1 = this.luminosity();
	    var lum2 = color2.luminosity();
	    if (lum1 > lum2) {
	      return (lum1 + 0.05) / (lum2 + 0.05)
	    };
	    return (lum2 + 0.05) / (lum1 + 0.05);
	  },
	
	  level: function(color2) {
	    var contrastRatio = this.contrast(color2);
	    return (contrastRatio >= 7.1) ? 'AAA' : (contrastRatio >= 4.5) ? 'AA' : '';
	  },
	
	  dark: function() {
	    // YIQ equation from http://24ways.org/2010/calculating-color-contrast
	    var rgb = this.values.rgb,
	      yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
	    return yiq < 128;
	  },
	
	  light: function() {
	    return !this.dark();
	  },
	
	  negate: function() {
	    var rgb = []
	    for (var i = 0; i < 3; i++) {
	      rgb[i] = 255 - this.values.rgb[i];
	    }
	    this.setValues("rgb", rgb);
	    return this;
	  },
	
	  lighten: function(ratio) {
	    this.values.hsl[2] += this.values.hsl[2] * ratio;
	    this.setValues("hsl", this.values.hsl);
	    return this;
	  },
	
	  darken: function(ratio) {
	    this.values.hsl[2] -= this.values.hsl[2] * ratio;
	    this.setValues("hsl", this.values.hsl);
	    return this;
	  },
	
	  saturate: function(ratio) {
	    this.values.hsl[1] += this.values.hsl[1] * ratio;
	    this.setValues("hsl", this.values.hsl);
	    return this;
	  },
	
	  desaturate: function(ratio) {
	    this.values.hsl[1] -= this.values.hsl[1] * ratio;
	    this.setValues("hsl", this.values.hsl);
	    return this;
	  },
	
	  whiten: function(ratio) {
	    this.values.hwb[1] += this.values.hwb[1] * ratio;
	    this.setValues("hwb", this.values.hwb);
	    return this;
	  },
	
	  blacken: function(ratio) {
	    this.values.hwb[2] += this.values.hwb[2] * ratio;
	    this.setValues("hwb", this.values.hwb);
	    return this;
	  },
	
	  greyscale: function() {
	    var rgb = this.values.rgb;
	    // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
	    var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
	    this.setValues("rgb", [val, val, val]);
	    return this;
	  },
	
	  clearer: function(ratio) {
	    this.setValues("alpha", this.values.alpha - (this.values.alpha * ratio));
	    return this;
	  },
	
	  opaquer: function(ratio) {
	    this.setValues("alpha", this.values.alpha + (this.values.alpha * ratio));
	    return this;
	  },
	
	  rotate: function(degrees) {
	    var hue = this.values.hsl[0];
	    hue = (hue + degrees) % 360;
	    hue = hue < 0 ? 360 + hue : hue;
	    this.values.hsl[0] = hue;
	    this.setValues("hsl", this.values.hsl);
	    return this;
	  },
	
	  mix: function(color2, weight) {
	    weight = 1 - (weight == null ? 0.5 : weight);
	
	    // algorithm from Sass's mix(). Ratio of first color in mix is
	    // determined by the alphas of both colors and the weight
	    var t1 = weight * 2 - 1,
	      d = this.alpha() - color2.alpha();
	
	    var weight1 = (((t1 * d == -1) ? t1 : (t1 + d) / (1 + t1 * d)) + 1) / 2;
	    var weight2 = 1 - weight1;
	
	    var rgb = this.rgbArray();
	    var rgb2 = color2.rgbArray();
	
	    for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = rgb[i] * weight1 + rgb2[i] * weight2;
	    }
	    this.setValues("rgb", rgb);
	
	    var alpha = this.alpha() * weight + color2.alpha() * (1 - weight);
	    this.setValues("alpha", alpha);
	
	    return this;
	  },
	
	  toJSON: function() {
	    return this.rgb();
	  },
	
	  clone: function() {
	    return new Color(this.rgb());
	  }
	}
	
	
	Color.prototype.getValues = function(space) {
	  var vals = {};
	  for (var i = 0; i < space.length; i++) {
	    vals[space.charAt(i)] = this.values[space][i];
	  }
	  if (this.values.alpha != 1) {
	    vals["a"] = this.values.alpha;
	  }
	  // {r: 255, g: 255, b: 255, a: 0.4}
	  return vals;
	}
	
	Color.prototype.setValues = function(space, vals) {
	  var spaces = {
	    "rgb": ["red", "green", "blue"],
	    "hsl": ["hue", "saturation", "lightness"],
	    "hsv": ["hue", "saturation", "value"],
	    "hwb": ["hue", "whiteness", "blackness"],
	    "cmyk": ["cyan", "magenta", "yellow", "black"]
	  };
	
	  var maxes = {
	    "rgb": [255, 255, 255],
	    "hsl": [360, 100, 100],
	    "hsv": [360, 100, 100],
	    "hwb": [360, 100, 100],
	    "cmyk": [100, 100, 100, 100]
	  };
	
	  var alpha = 1;
	  if (space == "alpha") {
	    alpha = vals;
	  } else if (vals.length) {
	    // [10, 10, 10]
	    this.values[space] = vals.slice(0, space.length);
	    alpha = vals[space.length];
	  } else if (vals[space.charAt(0)] !== undefined) {
	    // {r: 10, g: 10, b: 10}
	    for (var i = 0; i < space.length; i++) {
	      this.values[space][i] = vals[space.charAt(i)];
	    }
	    alpha = vals.a;
	  } else if (vals[spaces[space][0]] !== undefined) {
	    // {red: 10, green: 10, blue: 10}
	    var chans = spaces[space];
	    for (var i = 0; i < space.length; i++) {
	      this.values[space][i] = vals[chans[i]];
	    }
	    alpha = vals.alpha;
	  }
	  this.values.alpha = Math.max(0, Math.min(1, (alpha !== undefined ? alpha : this.values.alpha)));
	  if (space == "alpha") {
	    return;
	  }
	
	  // cap values of the space prior converting all values
	  for (var i = 0; i < space.length; i++) {
	    var capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
	    this.values[space][i] = Math.round(capped);
	  }
	
	  // convert to all the other color spaces
	  for (var sname in spaces) {
	    if (sname != space) {
	      this.values[sname] = convert[space][sname](this.values[space])
	    }
	
	    // cap values
	    for (var i = 0; i < sname.length; i++) {
	      var capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
	      this.values[sname][i] = Math.round(capped);
	    }
	  }
	  return true;
	}
	
	Color.prototype.setSpace = function(space, args) {
	  var vals = args[0];
	  if (vals === undefined) {
	    // color.rgb()
	    return this.getValues(space);
	  }
	  // color.rgb(10, 10, 10)
	  if (typeof vals == "number") {
	    vals = Array.prototype.slice.call(args);
	  }
	  this.setValues(space, vals);
	  return this;
	}
	
	Color.prototype.setChannel = function(space, index, val) {
	  if (val === undefined) {
	    // color.red()
	    return this.values[space][index];
	  }
	  // color.red(100)
	  this.values[space][index] = val;
	  this.setValues(space, this.values[space]);
	  return this;
	}
	
	window.Color = module.exports = Color


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(59);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(61);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/,
	       hex =  /^#([a-fA-F0-9]{6})$/,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
	  var helpers = Chart.helpers;
	
	  Chart.elements = {};
	
	  Chart.Element = function(configuration) {
	    helpers.extend(this, configuration);
	    this.initialize.apply(this, arguments);
	  };
	  helpers.extend(Chart.Element.prototype, {
	    initialize: function() {
	      this.hidden = false;
	    },
	    pivot: function() {
	      if (!this._view) {
	        this._view = helpers.clone(this._model);
	      }
	      this._start = helpers.clone(this._view);
	      return this;
	    },
	    transition: function(ease) {
	      if (!this._view) {
	        this._view = helpers.clone(this._model);
	      }
	
	      // No animation -> No Transition
	      if (ease === 1) {
	        this._view = this._model;
	        this._start = null;
	        return this;
	      }
	
	      if (!this._start) {
	        this.pivot();
	      }
	
	      helpers.each(this._model, function(value, key) {
	
	        if (key[0] === '_' || !this._model.hasOwnProperty(key)) {
	          // Only non-underscored properties
	        }
	
	        // Init if doesn't exist
	        else if (!this._view.hasOwnProperty(key)) {
	          if (typeof value === 'number' && !isNaN(this._view[key])) {
	            this._view[key] = value * ease;
	          } else {
	            this._view[key] = value;
	          }
	        }
	
	        // No unnecessary computations
	        else if (value === this._view[key]) {
	          // It's the same! Woohoo!
	        }
	
	        // Color transitions if possible
	        else if (typeof value === 'string') {
	          try {
	            var color = helpers.color(this._start[key]).mix(helpers.color(this._model[key]), ease);
	            this._view[key] = color.rgbString();
	          } catch (err) {
	            this._view[key] = value;
	          }
	        }
	        // Number transitions
	        else if (typeof value === 'number') {
	          var startVal = this._start[key] !== undefined && isNaN(this._start[key]) === false ? this._start[key] : 0;
	          this._view[key] = ((this._model[key] - startVal) * ease) + startVal;
	        }
	        // Everything else
	        else {
	          this._view[key] = value;
	        }
	      }, this);
	
	      return this;
	    },
	    tooltipPosition: function() {
	      return {
	        x: this._model.x,
	        y: this._model.y
	      };
	    },
	    hasValue: function() {
	      return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	    }
	  });
	
	  Chart.Element.extend = helpers.inherits;
	
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/*global window: false */
	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: "easeOutQuart",
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: "", // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < this.animations.length; ++index) {
					if (this.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						this.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				this.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (this.animations.length === 1) {
					this.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (this.dropFrames > 1) {
					framesToDrop = Math.floor(this.dropFrames);
					this.dropFrames = this.dropFrames % 1;
				}
	
				var i = 0;
				while (i < this.animations.length) {
					if (this.animations[i].animationObject.currentStep === null) {
						this.animations[i].animationObject.currentStep = 0;
					}
	
					this.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (this.animations[i].animationObject.currentStep > this.animations[i].animationObject.numSteps) {
						this.animations[i].animationObject.currentStep = this.animations[i].animationObject.numSteps;
					}
	
					this.animations[i].animationObject.render(this.animations[i].chartInstance, this.animations[i].animationObject);
					if (this.animations[i].animationObject.onAnimationProgress && this.animations[i].animationObject.onAnimationProgress.call) {
						this.animations[i].animationObject.onAnimationProgress.call(this.animations[i].chartInstance, this.animations[i]);
					}
	
					if (this.animations[i].animationObject.currentStep === this.animations[i].animationObject.numSteps) {
						if (this.animations[i].animationObject.onAnimationComplete && this.animations[i].animationObject.onAnimationComplete.call) {
							this.animations[i].animationObject.onAnimationComplete.call(this.animations[i].chartInstance, this.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						this.animations[i].chartInstance.animating = false;
	
						this.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / this.frameDuration;
	
				this.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (this.animations.length > 0) {
					this.requestAnimationFrame();
				}
			}
		};
	};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		//Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		//Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		//Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		// The main controller of a chart
		Chart.Controller = function(instance) {
	
			this.chart = instance;
			this.config = instance.config;
			this.options = this.config.options = helpers.configMerge(Chart.defaults.global, Chart.defaults[this.config.type], this.config.options || {});
			this.id = helpers.uid();
	
			Object.defineProperty(this, 'data', {
				get: function() {
					return this.config.data;
				}
			});
	
			//Add the chart instance to the global namespace
			Chart.instances[this.id] = this;
	
			if (this.options.responsive) {
				// Silent resize before chart draws
				this.resize(true);
			}
	
			this.initialize();
	
			return this;
		};
	
		helpers.extend(Chart.Controller.prototype, {
	
			initialize: function initialize() {
				// Before init plugin notification
				Chart.pluginService.notifyPlugins('beforeInit', [this]);
	
				this.bindEvents();
	
				// Make sure controllers are built first so that each dataset is bound to an axis before the scales
				// are built
				this.ensureScalesHaveIDs();
				this.buildOrUpdateControllers();
				this.buildScales();
				this.buildSurroundingItems();
				this.updateLayout();
				this.resetElements();
				this.initToolTip();
				this.update();
	
				// After init plugin notification
				Chart.pluginService.notifyPlugins('afterInit', [this]);
	
				return this;
			},
	
			clear: function clear() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function stop() {
				// Stops any current animation loop occuring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function resize(silent) {
				var canvas = this.chart.canvas;
				var newWidth = helpers.getMaximumWidth(this.chart.canvas);
				var newHeight = (this.options.maintainAspectRatio && isNaN(this.chart.aspectRatio) === false && isFinite(this.chart.aspectRatio) && this.chart.aspectRatio !== 0) ? newWidth / this.chart.aspectRatio : helpers.getMaximumHeight(this.chart.canvas);
	
				var sizeChanged = this.chart.width !== newWidth || this.chart.height !== newHeight;
	
				if (!sizeChanged)
					return this;
	
				canvas.width = this.chart.width = newWidth;
				canvas.height = this.chart.height = newHeight;
	
				helpers.retinaScale(this.chart);
	
				if (!silent) {
					this.stop();
					this.update(this.options.responsiveAnimationDuration);
				}
	
				return this;
			},
			ensureScalesHaveIDs: function ensureScalesHaveIDs() {
				var defaultXAxisID = 'x-axis-';
				var defaultYAxisID = 'y-axis-';
	
				if (this.options.scales) {
					if (this.options.scales.xAxes && this.options.scales.xAxes.length) {
						helpers.each(this.options.scales.xAxes, function(xAxisOptions, index) {
							xAxisOptions.id = xAxisOptions.id || (defaultXAxisID + index);
						});
					}
	
					if (this.options.scales.yAxes && this.options.scales.yAxes.length) {
						// Build the y axes
						helpers.each(this.options.scales.yAxes, function(yAxisOptions, index) {
							yAxisOptions.id = yAxisOptions.id || (defaultYAxisID + index);
						});
					}
				}
			},
			buildScales: function buildScales() {
				// Map of scale ID to scale object so we can lookup later
				this.scales = {};
	
				// Build the x axes
				if (this.options.scales) {
					if (this.options.scales.xAxes && this.options.scales.xAxes.length) {
						helpers.each(this.options.scales.xAxes, function(xAxisOptions, index) {
							var xType = helpers.getValueOrDefault(xAxisOptions.type, 'category');
							var ScaleClass = Chart.scaleService.getScaleConstructor(xType);
							if (ScaleClass) {
								var scale = new ScaleClass({
									ctx: this.chart.ctx,
									options: xAxisOptions,
									chart: this,
									id: xAxisOptions.id
								});
	
								this.scales[scale.id] = scale;
							}
						}, this);
					}
	
					if (this.options.scales.yAxes && this.options.scales.yAxes.length) {
						// Build the y axes
						helpers.each(this.options.scales.yAxes, function(yAxisOptions, index) {
							var yType = helpers.getValueOrDefault(yAxisOptions.type, 'linear');
							var ScaleClass = Chart.scaleService.getScaleConstructor(yType);
							if (ScaleClass) {
								var scale = new ScaleClass({
									ctx: this.chart.ctx,
									options: yAxisOptions,
									chart: this,
									id: yAxisOptions.id
								});
	
								this.scales[scale.id] = scale;
							}
						}, this);
					}
				}
				if (this.options.scale) {
					// Build radial axes
					var ScaleClass = Chart.scaleService.getScaleConstructor(this.options.scale.type);
					if (ScaleClass) {
						var scale = new ScaleClass({
							ctx: this.chart.ctx,
							options: this.options.scale,
							chart: this
						});
	
						this.scale = scale;
	
						this.scales.radialScale = scale;
					}
				}
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildSurroundingItems: function() {
				if (this.options.title) {
					this.titleBlock = new Chart.Title({
						ctx: this.chart.ctx,
						options: this.options.title,
						chart: this
					});
	
					Chart.layoutService.addBox(this, this.titleBlock);
				}
	
				if (this.options.legend) {
					this.legend = new Chart.Legend({
						ctx: this.chart.ctx,
						options: this.options.legend,
						chart: this
					});
	
					Chart.layoutService.addBox(this, this.legend);
				}
			},
	
			updateLayout: function() {
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
			},
	
			buildOrUpdateControllers: function buildOrUpdateControllers() {
				var types = [];
				var newControllers = [];
	
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					var meta = this.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || this.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](this, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, this);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							this.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			resetElements: function resetElements() {
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					this.getDatasetMeta(datasetIndex).controller.reset();
				}, this);
			},
	
			update: function update(animationDuration, lazy) {
				Chart.pluginService.notifyPlugins('beforeUpdate', [this]);
	
				// In case the entire data object changed
				this.tooltip._data = this.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = this.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					this.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, this);
	
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
	
				// Apply changes to the dataets that require the scales to have been calculated i.e BorderColor chages
				Chart.pluginService.notifyPlugins('afterScaleUpdate', [this]);
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				// This will loop through any data and do the appropriate element update for the type
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					this.getDatasetMeta(datasetIndex).controller.update();
				}, this);
	
				// Do this before render so that any plugins that need final scale updates can use it
				Chart.pluginService.notifyPlugins('afterUpdate', [this]);
	
				this.render(animationDuration, lazy);
			},
	
			render: function render(duration, lazy) {
				Chart.pluginService.notifyPlugins('beforeRender', [this]);
	
				if (this.options.animation && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && this.options.animation.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || this.options.animation.duration) / 16.66; //60 fps
					animation.easing = this.options.animation.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = this.options.animation.onProgress;
					animation.onAnimationComplete = this.options.animation.onComplete;
	
					Chart.animationService.addAnimation(this, animation, duration, lazy);
				} else {
					this.draw();
					if (this.options.animation && this.options.animation.onComplete && this.options.animation.onComplete.call) {
						this.options.animation.onComplete.call(this);
					}
				}
				return this;
			},
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				this.clear();
	
				Chart.pluginService.notifyPlugins('beforeDraw', [this, easingDecimal]);
	
				// Draw all the scales
				helpers.each(this.boxes, function(box) {
					box.draw(this.chartArea);
				}, this);
				if (this.scale) {
					this.scale.draw();
				}
	
				// Clip out the chart area so that anything outside does not draw. This is necessary for zoom and pan to function
				this.chart.ctx.save();
				this.chart.ctx.beginPath();
				this.chart.ctx.rect(this.chartArea.left, this.chartArea.top, this.chartArea.right - this.chartArea.left, this.chartArea.bottom - this.chartArea.top);
				this.chart.ctx.clip();
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					if (this.isDatasetVisible(datasetIndex)) {
						this.getDatasetMeta(datasetIndex).controller.draw(ease);
					}
				}, this, true);
	
				// Restore from the clipping operation
				this.chart.ctx.restore();
	
				// Finally draw the tooltip
				this.tooltip.transition(easingDecimal).draw();
	
				Chart.pluginService.notifyPlugins('afterDraw', [this, easingDecimal]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				var eventPosition = helpers.getRelativePosition(e, this.chart);
				var elementsArray = [];
	
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					if (this.isDatasetVisible(datasetIndex)) {
						var meta = this.getDatasetMeta(datasetIndex);
						helpers.each(meta.data, function(element, index) {
							if (element.inRange(eventPosition.x, eventPosition.y)) {
								elementsArray.push(element);
								return elementsArray;
							}
						});
					}
				}, this);
	
				return elementsArray;
			},
	
			getElementsAtEvent: function(e) {
				var eventPosition = helpers.getRelativePosition(e, this.chart);
				var elementsArray = [];
	
				var found = (function() {
					if (this.data.datasets) {
						for (var i = 0; i < this.data.datasets.length; i++) {
							var meta = this.getDatasetMeta(i);
							if (this.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}).call(this);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(this.data.datasets, function(dataset, datasetIndex) {
					if (this.isDatasetVisible(datasetIndex)) {
						var meta = this.getDatasetMeta(datasetIndex);
						elementsArray.push(meta.data[found._index]);
					}
				}, this);
	
				return elementsArray;
			},
	
			getDatasetAtEvent: function(e) {
				var elementsArray = this.getElementAtEvent(e);
	
				if (elementsArray.length > 0) {
					elementsArray = this.getDatasetMeta(elementsArray[0]._datasetIndex).data;
				}
	
				return elementsArray;
			},
	
			getDatasetMeta: function(datasetIndex) {
				var dataset = this.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[this.id];
				if (!meta) {
					meta = dataset._meta[this.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					 if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function generateLegend() {
				return this.options.legendCallback(this);
			},
	
			destroy: function destroy() {
				this.clear();
				helpers.unbindEvents(this, this.events);
				helpers.removeResizeListener(this.chart.canvas.parentNode);
	
				// Reset canvas height/width attributes
				var canvas = this.chart.canvas;
				canvas.width = this.chart.width;
				canvas.height = this.chart.height;
	
				// if we scaled the canvas in response to a devicePixelRatio !== 1, we need to undo that transform here
				if (this.chart.originalDevicePixelRatio !== undefined) {
					this.chart.ctx.scale(1 / this.chart.originalDevicePixelRatio, 1 / this.chart.originalDevicePixelRatio);
				}
	
				// Reset to the old style since it may have been changed by the device pixel ratio changes
				canvas.style.width = this.chart.originalCanvasStyleWidth;
				canvas.style.height = this.chart.originalCanvasStyleHeight;
	
				Chart.pluginService.notifyPlugins('destroy', [this]);
	
				delete Chart.instances[this.id];
			},
	
			toBase64Image: function toBase64Image() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function initToolTip() {
				this.tooltip = new Chart.Tooltip({
					_chart: this.chart,
					_chartInstance: this,
					_data: this.data,
					_options: this.options
				}, this);
			},
	
			bindEvents: function bindEvents() {
				helpers.bindEvents(this, this.options.events, function(evt) {
					this.eventHandler(evt);
				});
			},
			eventHandler: function eventHandler(e) {
				this.lastActive = this.lastActive || [];
				this.lastTooltipActive = this.lastTooltipActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					this.active = [];
					this.tooltipActive = [];
				} else {
	
					var _this = this;
					var getItemsForMode = function(mode) {
						switch (mode) {
							case 'single':
								return _this.getElementAtEvent(e);
							case 'label':
								return _this.getElementsAtEvent(e);
							case 'dataset':
								return _this.getDatasetAtEvent(e);
							default:
								return e;
						}
					};
	
					this.active = getItemsForMode(this.options.hover.mode);
					this.tooltipActive = getItemsForMode(this.options.tooltips.mode);
				}
	
				// On Hover hook
				if (this.options.hover.onHover) {
					this.options.hover.onHover.call(this, this.active);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (this.options.onClick) {
						this.options.onClick.call(this, e, this.active);
					}
	
					if (this.legend && this.legend.handleEvent) {
						this.legend.handleEvent(e);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (this.lastActive.length) {
					switch (this.options.hover.mode) {
						case 'single':
							this.getDatasetMeta(this.lastActive[0]._datasetIndex).controller.removeHoverStyle(this.lastActive[0], this.lastActive[0]._datasetIndex, this.lastActive[0]._index);
							break;
						case 'label':
						case 'dataset':
							for (var i = 0; i < this.lastActive.length; i++) {
								if (this.lastActive[i])
									this.getDatasetMeta(this.lastActive[i]._datasetIndex).controller.removeHoverStyle(this.lastActive[i], this.lastActive[i]._datasetIndex, this.lastActive[i]._index);
							}
							break;
						default:
							// Don't change anything
					}
				}
	
				// Built in hover styling
				if (this.active.length && this.options.hover.mode) {
					switch (this.options.hover.mode) {
						case 'single':
							this.getDatasetMeta(this.active[0]._datasetIndex).controller.setHoverStyle(this.active[0]);
							break;
						case 'label':
						case 'dataset':
							for (var j = 0; j < this.active.length; j++) {
								if (this.active[j])
									this.getDatasetMeta(this.active[j]._datasetIndex).controller.setHoverStyle(this.active[j]);
							}
							break;
						default:
							// Don't change anything
					}
				}
	
	
				// Built in Tooltips
				if (this.options.tooltips.enabled || this.options.tooltips.custom) {
	
					// The usual updates
					this.tooltip.initialize();
					this.tooltip._active = this.tooltipActive;
					this.tooltip.update(true);
				}
	
				// Hover animations
				this.tooltip.pivot();
	
				if (!this.animating) {
					var changed;
	
					helpers.each(this.active, function(element, index) {
						if (element !== this.lastActive[index]) {
							changed = true;
						}
					}, this);
	
					helpers.each(this.tooltipActive, function(element, index) {
						if (element !== this.lastTooltipActive[index]) {
							changed = true;
						}
					}, this);
	
					// If entering, leaving, or changing elements, animate the change via pivot
					if ((this.lastActive.length !== this.active.length) ||
						(this.lastTooltipActive.length !== this.tooltipActive.length) ||
						changed) {
	
						this.stop();
	
						if (this.options.tooltips.enabled || this.options.tooltips.custom) {
							this.tooltip.update(true);
						}
	
						// We only need to render at this point. Updating will cause scales to be recomputed generating flicker & using more
						// memory than necessary.
						this.render(this.options.hover.animationDuration, true);
					}
				}
	
				// Remember Last Actives
				this.lastActive = this.active;
				this.lastTooltipActive = this.tooltipActive;
				return this;
			}
		});
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize.call(this, chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
			initialize: function(chart, datasetIndex) {
				this.chart = chart;
				this.index = datasetIndex;
				this.linkScales();
				this.addElements();
			},
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var meta = this.getMeta();
				var dataset = this.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || this.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || this.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			buildOrUpdateElements: function buildOrUpdateElements() {
				// Handle the number of data points changing
				var meta = this.getMeta(),
					md = meta.data,
					numData = this.getDataset().data.length,
					numMetaData = md.length;
	
				// Make sure that we handle number of datapoints changing
				if (numData < numMetaData) {
					// Remove excess bars for data points that have been removed
					md.splice(numData, numMetaData - numData);
				} else if (numData > numMetaData) {
					// Add new elements
					for (var index = numMetaData; index < numData; ++index) {
						this.addElementAndReset(index);
					}
				}
			},
	
			// Controllers should implement the following
			addElements: noop,
			addElementAndReset: noop,
			draw: noop,
			removeHoverStyle: noop,
			setHoverStyle: noop,
			update: noop
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var xPadding = 0;
				var yPadding = 0;
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === "left";
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === "right";
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === "top";
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === "bottom";
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === "chartArea";
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - (2 * xPadding);
				var chartHeight = height - (2 * yPadding);
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box
					});
				}
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
	
				// Steps 5 & 6
				var totalLeftBoxesWidth = xPadding;
				var totalRightBoxesWidth = xPadding;
				var totalTopBoxesHeight = yPadding;
				var totalBottomBoxesHeight = yPadding;
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBoxSize) {
						return minBoxSize.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: totalLeftBoxesWidth,
								right: totalRightBoxesWidth,
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBoxSize) {
						return minBoxSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = xPadding;
				totalRightBoxesWidth = xPadding;
				totalTopBoxesHeight = yPadding;
				totalBottomBoxesHeight = yPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = xPadding;
				var top = yPadding;
				var right = 0;
				var bottom = 0;
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? xPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - xPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: dataset.backgroundColor,
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				this.beforeUpdate();
	
				// Absorb the master measurements
				this.maxWidth = maxWidth;
				this.maxHeight = maxHeight;
				this.margins = margins;
	
				// Dimensions
				this.beforeSetDimensions();
				this.setDimensions();
				this.afterSetDimensions();
				// Labels
				this.beforeBuildLabels();
				this.buildLabels();
				this.afterBuildLabels();
	
				// Fit
				this.beforeFit();
				this.fit();
				this.afterFit();
				//
				this.afterUpdate();
	
				return this.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				// Set the unconstrained dimension before label rotation
				if (this.isHorizontal()) {
					// Reset position before calculating rotation
					this.width = this.maxWidth;
					this.left = 0;
					this.right = this.width;
				} else {
					this.height = this.maxHeight;
	
					// Reset position before calculating rotation
					this.top = 0;
					this.bottom = this.height;
				}
	
				// Reset padding
				this.paddingLeft = 0;
				this.paddingTop = 0;
				this.paddingRight = 0;
				this.paddingBottom = 0;
	
				// Reset minSize
				this.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				this.legendItems = this.options.labels.generateLabels.call(this, this.chart);
				if(this.options.reverse){
					this.legendItems.reverse();
				}
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var opts = this.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = this.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = this.legendHitBoxes = [];
	
				var minSize = this.minSize;
				var isHorizontal = this.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = this.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = this.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = this.lineWidths = [0];
						var totalHeight = this.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = "left";
						ctx.textBaseline = 'top';
						ctx.font = labelFont;
	
						helpers.each(this.legendItems, function(legendItem, i) {
							var width = labelOpts.boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= this.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = this.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						}, this);
	
						minSize.height += totalHeight;
	
					} else {
						// TODO vertical
					}
				}
	
				this.width = minSize.width;
				this.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === "top" || this.options.position === "bottom";
			},
	
			// Actualy draw the legend on the canvas
			draw: function() {
				var opts = this.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = this.width,
					lineWidths = this.lineWidths;
	
				if (opts.display) {
					var ctx = this.ctx,
						cursor = {
							x: this.left + ((legendWidth - lineWidths[0]) / 2),
							y: this.top + labelOpts.padding,
							line: 0
						},
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Horizontal
					if (this.isHorizontal()) {
						// Labels
						ctx.textAlign = "left";
						ctx.textBaseline = 'top';
						ctx.lineWidth = 0.5;
						ctx.strokeStyle = fontColor; // for strikethrough effect
						ctx.fillStyle = fontColor; // render in correct colour
						ctx.font = labelFont;
	
						var boxWidth = labelOpts.boxWidth,
							hitboxes = this.legendHitBoxes;
	
						helpers.each(this.legendItems, function(legendItem, i) {
							var textWidth = ctx.measureText(legendItem.text).width,
								width = boxWidth + (fontSize / 2) + textWidth,
								x = cursor.x,
								y = cursor.y;
	
							if (x + width >= legendWidth) {
								y = cursor.y += fontSize + (labelOpts.padding);
								cursor.line++;
								x = cursor.x = this.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
	
							// Set the ctx for the box
							ctx.save();
	
							ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
							ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
							ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
							ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
							ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
							ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
	
							if (ctx.setLineDash) {
								// IE 9 and 10 do not support line dash
								ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
							}
	
							// Draw the box
							ctx.strokeRect(x, y, boxWidth, fontSize);
							ctx.fillRect(x, y, boxWidth, fontSize);
	
							ctx.restore();
	
							hitboxes[i].left = x;
							hitboxes[i].top = y;
	
							// Fill the actual label
							ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
							if (legendItem.hidden) {
								// Strikethrough the text if hidden
								ctx.beginPath();
								ctx.lineWidth = 2;
								ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
								ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
								ctx.stroke();
							}
	
							cursor.x += width + (labelOpts.padding);
						}, this);
					} else {
	
					}
				}
			},
	
			// Handle an event
			handleEvent: function(e) {
				var position = helpers.getRelativePosition(e, this.chart.chart),
					x = position.x,
					y = position.y,
					opts = this.options;
	
				if (x >= this.left && x <= this.right && y >= this.top && y <= this.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = this.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (opts.onClick) {
								opts.onClick.call(this, e, this.legendItems[i]);
							}
							break;
						}
					}
				}
			}
		});
	
	};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
		var helpers = Chart.helpers;
	
		// Plugins are stored here
		Chart.plugins = [];
		Chart.pluginService = {
			// Register a new plugin
			register: function(plugin) {
				var p = Chart.plugins;
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			},
	
			// Remove a registered plugin
			remove: function(plugin) {
				var p = Chart.plugins;
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			},
	
			// Iterate over all plugins
			notifyPlugins: function(method, args, scope) {
				helpers.each(Chart.plugins, function(plugin) {
					if (plugin[method] && typeof plugin[method] === 'function') {
						plugin[method].apply(scope, args);
					}
				}, scope);
			}
		};
	
		var noop = helpers.noop;
		Chart.PluginBase = Chart.Element.extend({
			// Plugin methods. All functions are passed the chart instance
	
			// Called at start of chart init
			beforeInit: noop,
	
			// Called at end of chart init
			afterInit: noop,
	
			// Called at start of update
			beforeUpdate: noop,
	
			// Called at end of update
			afterUpdate: noop,
	
			// Called at start of draw
			beforeDraw: noop,
	
			// Called at end of draw
			afterDraw: noop,
	
			// Called during destroy
			destroy: noop,
		});
	};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: "left",
	
			// grid line settings
			gridLines: {
				display: true,
				color: "rgba(0, 0, 0, 0.1)",
				lineWidth: 1,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: "rgba(0,0,0,0.25)",
				offsetGridLines: false
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 10,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				callback: function(value) {
					return '' + value;
				}
			}
		};
	
		Chart.Scale = Chart.Element.extend({
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				this.beforeUpdate();
	
				// Absorb the master measurements
				this.maxWidth = maxWidth;
				this.maxHeight = maxHeight;
				this.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
	
				// Dimensions
				this.beforeSetDimensions();
				this.setDimensions();
				this.afterSetDimensions();
	
				// Data min/max
				this.beforeDataLimits();
				this.determineDataLimits();
				this.afterDataLimits();
	
				// Ticks
				this.beforeBuildTicks();
				this.buildTicks();
				this.afterBuildTicks();
	
				this.beforeTickToLabelConversion();
				this.convertTicksToLabels();
				this.afterTickToLabelConversion();
	
				// Tick Rotation
				this.beforeCalculateTickRotation();
				this.calculateTickRotation();
				this.afterCalculateTickRotation();
				// Fit
				this.beforeFit();
				this.fit();
				this.afterFit();
				//
				this.afterUpdate();
	
				return this.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				// Set the unconstrained dimension before label rotation
				if (this.isHorizontal()) {
					// Reset position before calculating rotation
					this.width = this.maxWidth;
					this.left = 0;
					this.right = this.width;
				} else {
					this.height = this.maxHeight;
	
					// Reset position before calculating rotation
					this.top = 0;
					this.bottom = this.height;
				}
	
				// Reset padding
				this.paddingLeft = 0;
				this.paddingTop = 0;
				this.paddingRight = 0;
				this.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				// Convert ticks to strings
				this.ticks = this.ticks.map(function(numericalTick, index, ticks) {
						if (this.options.ticks.userCallback) {
							return this.options.ticks.userCallback(numericalTick, index, ticks);
						}
						return this.options.ticks.callback(numericalTick, index, ticks);
					},
					this);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				//Get the width of each grid by calculating the difference
				//between x offsets between 0 and 1.
				var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(this.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(this.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				this.ctx.font = tickLabelFont;
	
				var firstWidth = this.ctx.measureText(this.ticks[0]).width;
				var lastWidth = this.ctx.measureText(this.ticks[this.ticks.length - 1]).width;
				var firstRotated;
	
				this.labelRotation = this.options.ticks.minRotation || 0;
				this.paddingRight = 0;
				this.paddingLeft = 0;
	
				if (this.options.display) {
					if (this.isHorizontal()) {
						this.paddingRight = lastWidth / 2 + 3;
						this.paddingLeft = firstWidth / 2 + 3;
	
						if (!this.longestTextCache) {
							this.longestTextCache = {};
						}
						var originalLabelWidth = helpers.longestText(this.ctx, tickLabelFont, this.ticks, this.longestTextCache);
						var labelWidth = originalLabelWidth;
						var cosRotation;
						var sinRotation;
	
						// Allow 3 pixels x2 padding either side for label readability
						// only the index matters for a dataset scale, but we want a consistent interface between scales
						var tickWidth = this.getPixelForTick(1) - this.getPixelForTick(0) - 6;
	
						//Max label rotation can be set or default to 90 - also act as a loop counter
						while (labelWidth > tickWidth && this.labelRotation < this.options.ticks.maxRotation) {
							cosRotation = Math.cos(helpers.toRadians(this.labelRotation));
							sinRotation = Math.sin(helpers.toRadians(this.labelRotation));
	
							firstRotated = cosRotation * firstWidth;
	
							// We're right aligning the text now.
							if (firstRotated + tickFontSize / 2 > this.yLabelWidth) {
								this.paddingLeft = firstRotated + tickFontSize / 2;
							}
	
							this.paddingRight = tickFontSize / 2;
	
							if (sinRotation * originalLabelWidth > this.maxHeight) {
								// go back one step
								this.labelRotation--;
								break;
							}
	
							this.labelRotation++;
							labelWidth = cosRotation * originalLabelWidth;
						}
					}
				}
	
				if (this.margins) {
					this.paddingLeft = Math.max(this.paddingLeft - this.margins.left, 0);
					this.paddingRight = Math.max(this.paddingRight - this.margins.right, 0);
				}
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				// Reset
				var minSize = this.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = this.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var globalOpts = Chart.defaults.global;
				var display = opts.display;
				var isHorizontal = this.isHorizontal();
	
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalOpts.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(tickOpts.fontStyle, globalOpts.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(tickOpts.fontFamily, globalOpts.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabelOpts.fontSize, globalOpts.defaultFontSize);
				var scaleLabelFontStyle = helpers.getValueOrDefault(scaleLabelOpts.fontStyle, globalOpts.defaultFontStyle);
				var scaleLabelFontFamily = helpers.getValueOrDefault(scaleLabelOpts.fontFamily, globalOpts.defaultFontFamily);
				var scaleLabelFont = helpers.fontString(scaleLabelFontSize, scaleLabelFontStyle, scaleLabelFontFamily);
	
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = this.isFullWidth() ? this.maxWidth - this.margins.left - this.margins.right : this.maxWidth;
				} else {
					minSize.width = display ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display ? tickMarkLength : 0;
				} else {
					minSize.height = this.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += (scaleLabelFontSize * 1.5);
					} else {
						minSize.width += (scaleLabelFontSize * 1.5);
					}
				}
	
				if (tickOpts.display && display) {
					// Don't bother fitting the ticks if we are not showing them
					if (!this.longestTextCache) {
						this.longestTextCache = {};
					}
	
					var largestTextWidth = helpers.longestText(this.ctx, tickLabelFont, this.ticks, this.longestTextCache);
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						this.longestLabelWidth = largestTextWidth;
	
						// TODO - improve this calculation
						var labelHeight = (Math.sin(helpers.toRadians(this.labelRotation)) * this.longestLabelWidth) + 1.5 * tickFontSize;
	
						minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight);
						this.ctx.font = tickLabelFont;
	
						var firstLabelWidth = this.ctx.measureText(this.ticks[0]).width;
						var lastLabelWidth = this.ctx.measureText(this.ticks[this.ticks.length - 1]).width;
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						var cosRotation = Math.cos(helpers.toRadians(this.labelRotation));
						var sinRotation = Math.sin(helpers.toRadians(this.labelRotation));
						this.paddingLeft = this.labelRotation !== 0 ? (cosRotation * firstLabelWidth) + 3 : firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						this.paddingRight = this.labelRotation !== 0 ? (sinRotation * (tickFontSize / 2)) + 3 : lastLabelWidth / 2 + 3; // when rotated
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						// убираем ограничение ширины шкалы
						var maxLabelWidth = this.maxWidth * 2 - minSize.width;
	
						// Account for padding
						var mirror = tickOpts.mirror;
						if (!mirror) {
							largestTextWidth += this.options.ticks.padding;
						} else {
							// If mirrored text is on the inside so don't expand
							largestTextWidth = 0;
						}
	
						if (largestTextWidth < maxLabelWidth) {
							// We don't need all the room
							minSize.width += largestTextWidth;
						} else {
							// Expand to max size
							minSize.width = this.maxWidth;
						}
	
						this.paddingTop = tickFontSize / 2;
						this.paddingBottom = tickFontSize / 2;
					}
				}
	
				if (this.margins) {
					this.paddingLeft = Math.max(this.paddingLeft - this.margins.left, 0);
					this.paddingTop = Math.max(this.paddingTop - this.margins.top, 0);
					this.paddingRight = Math.max(this.paddingRight - this.margins.right, 0);
					this.paddingBottom = Math.max(this.paddingBottom - this.margins.bottom, 0);
				}
	
				this.width = minSize.width;
				this.height = minSize.height;
	
			},
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === "top" || this.options.position === "bottom";
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function getRightValue(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number
				if (typeof(rawValue) === 'number' && isNaN(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === "object") {
					if (rawValue instanceof Date) {
						return rawValue;
					} else {
						return getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
					}
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				if (this.isHorizontal()) {
					var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
					var tickWidth = innerWidth / Math.max((this.ticks.length - ((this.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + this.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = this.left + Math.round(pixel);
					finalVal += this.isFullWidth() ? this.margins.left : 0;
					return finalVal;
				} else {
					var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
					return this.top + (index * (innerHeight / (this.ticks.length - 1)));
				}
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /*, includeOffset*/ ) {
				if (this.isHorizontal()) {
					var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
					var valueOffset = (innerWidth * decimal) + this.paddingLeft;
	
					var finalVal = this.left + Math.round(valueOffset);
					finalVal += this.isFullWidth() ? this.margins.left : 0;
					return finalVal;
				} else {
					return this.top + (decimal * this.height);
				}
			},
	
			// Actualy draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				if (this.options.display) {
	
					var setContextLineSettings;
					var isRotated = this.labelRotation !== 0;
					var skipRatio;
					var scaleLabelX;
					var scaleLabelY;
					var useAutoskipper = this.options.ticks.autoSkip;
	
	
					// figure out the maximum number of gridlines to show
					var maxTicks;
	
					if (this.options.ticks.maxTicksLimit) {
						maxTicks = this.options.ticks.maxTicksLimit;
					}
	
					var tickFontColor = helpers.getValueOrDefault(this.options.ticks.fontColor, Chart.defaults.global.defaultFontColor);
					var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
					var tickFontStyle = helpers.getValueOrDefault(this.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
					var tickFontFamily = helpers.getValueOrDefault(this.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
					var tl = this.options.gridLines.tickMarkLength;
	
					var scaleLabelFontColor = helpers.getValueOrDefault(this.options.scaleLabel.fontColor, Chart.defaults.global.defaultFontColor);
					var scaleLabelFontSize = helpers.getValueOrDefault(this.options.scaleLabel.fontSize, Chart.defaults.global.defaultFontSize);
					var scaleLabelFontStyle = helpers.getValueOrDefault(this.options.scaleLabel.fontStyle, Chart.defaults.global.defaultFontStyle);
					var scaleLabelFontFamily = helpers.getValueOrDefault(this.options.scaleLabel.fontFamily, Chart.defaults.global.defaultFontFamily);
					var scaleLabelFont = helpers.fontString(scaleLabelFontSize, scaleLabelFontStyle, scaleLabelFontFamily);
	
					var cosRotation = Math.cos(helpers.toRadians(this.labelRotation));
					var sinRotation = Math.sin(helpers.toRadians(this.labelRotation));
					var longestRotatedLabel = this.longestLabelWidth * cosRotation;
					var rotatedLabelHeight = tickFontSize * sinRotation;
	
					// Make sure we draw text in the correct color and font
					this.ctx.fillStyle = tickFontColor;
	
					if (this.isHorizontal()) {
						setContextLineSettings = true;
						var yTickStart = this.options.position === "bottom" ? this.top : this.bottom - tl;
						var yTickEnd = this.options.position === "bottom" ? this.top + tl : this.bottom;
						skipRatio = false;
	
						if (((longestRotatedLabel / 2) + this.options.ticks.autoSkipPadding) * this.ticks.length > (this.width - (this.paddingLeft + this.paddingRight))) {
							skipRatio = 1 + Math.floor((((longestRotatedLabel / 2) + this.options.ticks.autoSkipPadding) * this.ticks.length) / (this.width - (this.paddingLeft + this.paddingRight)));
						}
	
						// if they defined a max number of ticks,
						// increase skipRatio until that number is met
						if (maxTicks && this.ticks.length > maxTicks) {
							while (!skipRatio || this.ticks.length / (skipRatio || 1) > maxTicks) {
								if (!skipRatio) {
									skipRatio = 1;
								}
								skipRatio += 1;
							}
						}
	
						if (!useAutoskipper) {
							skipRatio = false;
						}
	
						helpers.each(this.ticks, function(label, index) {
							// Blank ticks
							var isLastTick = this.ticks.length === index + 1;
	
							// Since we always show the last tick,we need may need to hide the last shown one before
							var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio > this.ticks.length);
							if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
								return;
							}
							var xLineValue = this.getPixelForTick(index); // xvalues for grid lines
							var xLabelValue = this.getPixelForTick(index, this.options.gridLines.offsetGridLines); // x values for ticks (need to consider offsetLabel option)
	
							if (this.options.gridLines.display) {
								if (index === (typeof this.zeroLineIndex !== 'undefined' ? this.zeroLineIndex : 0)) {
									// Draw the first index specially
									this.ctx.lineWidth = this.options.gridLines.zeroLineWidth;
									this.ctx.strokeStyle = this.options.gridLines.zeroLineColor;
									setContextLineSettings = true; // reset next time
								} else if (setContextLineSettings) {
									this.ctx.lineWidth = this.options.gridLines.lineWidth;
									this.ctx.strokeStyle = this.options.gridLines.color;
									setContextLineSettings = false;
								}
	
								xLineValue += helpers.aliasPixel(this.ctx.lineWidth);
	
								// Draw the label area
								this.ctx.beginPath();
	
								if (this.options.gridLines.drawTicks) {
									this.ctx.moveTo(xLineValue, yTickStart);
									this.ctx.lineTo(xLineValue, yTickEnd);
								}
	
								// Draw the chart area
								if (this.options.gridLines.drawOnChartArea) {
									this.ctx.moveTo(xLineValue, chartArea.top);
									this.ctx.lineTo(xLineValue, chartArea.bottom);
								}
	
								// Need to stroke in the loop because we are potentially changing line widths & colours
								this.ctx.stroke();
							}
	
							if (this.options.ticks.display) {
								this.ctx.save();
								this.ctx.translate(xLabelValue + this.options.ticks.labelOffset, (isRotated) ? this.top + 12 : this.options.position === "top" ? this.bottom - tl : this.top + tl);
								this.ctx.rotate(helpers.toRadians(this.labelRotation) * -1);
								this.ctx.font = tickLabelFont;
								this.ctx.textAlign = (isRotated) ? "right" : "center";
								this.ctx.textBaseline = (isRotated) ? "middle" : this.options.position === "top" ? "bottom" : "top";
								this.ctx.fillText(label, 0, 0);
								this.ctx.restore();
							}
						}, this);
	
						if (this.options.scaleLabel.display) {
							// Draw the scale label
							this.ctx.textAlign = "center";
							this.ctx.textBaseline = 'middle';
							this.ctx.fillStyle = scaleLabelFontColor; // render in correct colour
							this.ctx.font = scaleLabelFont;
	
							scaleLabelX = this.left + ((this.right - this.left) / 2); // midpoint of the width
							scaleLabelY = this.options.position === 'bottom' ? this.bottom - (scaleLabelFontSize / 2) : this.top + (scaleLabelFontSize / 2);
	
							this.ctx.fillText(this.options.scaleLabel.labelString, scaleLabelX, scaleLabelY);
						}
	
					} else {
						setContextLineSettings = true;
						var xTickStart = this.options.position === "right" ? this.left : this.right - 5;
						var xTickEnd = this.options.position === "right" ? this.left + 5 : this.right;
	
						helpers.each(this.ticks, function(label, index) {
							// If the callback returned a null or undefined value, do not draw this line
							if (label === undefined || label === null) {
								return;
							}
	
							var yLineValue = this.getPixelForTick(index); // xvalues for grid lines
	
							if (this.options.gridLines.display) {
								if (index === (typeof this.zeroLineIndex !== 'undefined' ? this.zeroLineIndex : 0)) {
									// Draw the first index specially
									this.ctx.lineWidth = this.options.gridLines.zeroLineWidth;
									this.ctx.strokeStyle = this.options.gridLines.zeroLineColor;
									setContextLineSettings = true; // reset next time
								} else if (setContextLineSettings) {
									this.ctx.lineWidth = this.options.gridLines.lineWidth;
									this.ctx.strokeStyle = this.options.gridLines.color;
									setContextLineSettings = false;
								}
	
								yLineValue += helpers.aliasPixel(this.ctx.lineWidth);
	
								// Draw the label area
								this.ctx.beginPath();
	
								if (this.options.gridLines.drawTicks) {
									this.ctx.moveTo(xTickStart, yLineValue);
									this.ctx.lineTo(xTickEnd, yLineValue);
								}
	
								// Draw the chart area
								if (this.options.gridLines.drawOnChartArea) {
									this.ctx.moveTo(chartArea.left, yLineValue);
									this.ctx.lineTo(chartArea.right, yLineValue);
								}
	
								// Need to stroke in the loop because we are potentially changing line widths & colours
								this.ctx.stroke();
							}
	
							if (this.options.ticks.display) {
								var xLabelValue;
								var yLabelValue = this.getPixelForTick(index, this.options.gridLines.offsetGridLines); // x values for ticks (need to consider offsetLabel option)
	
								this.ctx.save();
	
								if (this.options.position === "left") {
									if (this.options.ticks.mirror) {
										xLabelValue = this.right + this.options.ticks.padding;
										this.ctx.textAlign = "left";
									} else {
										xLabelValue = this.right - this.options.ticks.padding;
										this.ctx.textAlign = "right";
									}
								} else {
									// right side
									if (this.options.ticks.mirror) {
										xLabelValue = this.left - this.options.ticks.padding;
										this.ctx.textAlign = "right";
									} else {
										xLabelValue = this.left + this.options.ticks.padding;
										this.ctx.textAlign = "left";
									}
								}
	
								this.ctx.translate(xLabelValue, yLabelValue + this.options.ticks.labelOffset);
								this.ctx.rotate(helpers.toRadians(this.labelRotation) * -1);
								this.ctx.font = tickLabelFont;
								this.ctx.textBaseline = "middle";
								this.ctx.fillText(label, 0, 0);
								this.ctx.restore();
							}
						}, this);
	
						if (this.options.scaleLabel.display) {
							// Draw the scale label
							scaleLabelX = this.options.position === 'left' ? this.left + (scaleLabelFontSize / 2) : this.right - (scaleLabelFontSize / 2);
							scaleLabelY = this.top + ((this.bottom - this.top) / 2);
							var rotation = this.options.position === 'left' ? -0.5 * Math.PI : 0.5 * Math.PI;
	
							this.ctx.save();
							this.ctx.translate(scaleLabelX, scaleLabelY);
							this.ctx.rotate(rotation);
							this.ctx.textAlign = "center";
							this.ctx.fillStyle =scaleLabelFontColor; // render in correct colour
							this.ctx.font = scaleLabelFont;
							this.ctx.textBaseline = 'middle';
							this.ctx.fillText(this.options.scaleLabel.labelString, 0, 0);
							this.ctx.restore();
						}
					}
	
					// Draw the line at the edge of the axis
					this.ctx.lineWidth = this.options.gridLines.lineWidth;
					this.ctx.strokeStyle = this.options.gridLines.color;
					var x1 = this.left,
						x2 = this.right,
						y1 = this.top,
						y2 = this.bottom;
	
					if (this.isHorizontal()) {
						y1 = y2 = this.options.position === 'top' ? this.bottom : this.top;
						y1 += helpers.aliasPixel(this.ctx.lineWidth);
						y2 += helpers.aliasPixel(this.ctx.lineWidth);
					} else {
						x1 = x2 = this.options.position === 'left' ? this.right : this.left;
						x1 += helpers.aliasPixel(this.ctx.lineWidth);
						x2 += helpers.aliasPixel(this.ctx.lineWidth);
					}
	
					this.ctx.beginPath();
					this.ctx.moveTo(x1, y1);
					this.ctx.lineTo(x2, y2);
					this.ctx.stroke();
				}
			}
		});
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
				this.options = helpers.configMerge(Chart.defaults.global.title, config.options);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				this.beforeUpdate();
	
				// Absorb the master measurements
				this.maxWidth = maxWidth;
				this.maxHeight = maxHeight;
				this.margins = margins;
	
				// Dimensions
				this.beforeSetDimensions();
				this.setDimensions();
				this.afterSetDimensions();
				// Labels
				this.beforeBuildLabels();
				this.buildLabels();
				this.afterBuildLabels();
	
				// Fit
				this.beforeFit();
				this.fit();
				this.afterFit();
				//
				this.afterUpdate();
	
				return this.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				// Set the unconstrained dimension before label rotation
				if (this.isHorizontal()) {
					// Reset position before calculating rotation
					this.width = this.maxWidth;
					this.left = 0;
					this.right = this.width;
				} else {
					this.height = this.maxHeight;
	
					// Reset position before calculating rotation
					this.top = 0;
					this.bottom = this.height;
				}
	
				// Reset padding
				this.paddingLeft = 0;
				this.paddingTop = 0;
				this.paddingRight = 0;
				this.paddingBottom = 0;
	
				// Reset minSize
				this.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
	
				var ctx = this.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = this.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = this.minSize;
	
				if (this.isHorizontal()) {
					minSize.width = this.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = this.maxHeight; // fill all the height
				}
	
				this.width = minSize.width;
				this.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === "top" || pos === "bottom";
			},
	
			// Actualy draw the title block on the canvas
			draw: function() {
				var ctx = this.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = this.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX, 
						titleY;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (this.isHorizontal()) {
						titleX = this.left + ((this.right - this.left) / 2); // midpoint of the width
						titleY = this.top + ((this.bottom - this.top) / 2); // midpoint of the height
					} else {
						titleX = opts.position === 'left' ? this.left + (fontSize / 2) : this.right - (fontSize / 2);
						titleY = this.top + ((this.bottom - this.top) / 2);
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0);
					ctx.restore();
				}
			}
		});
	};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'single',
			backgroundColor: "rgba(0,0,0,0.8)",
			titleFontStyle: "bold",
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleColor: "#fff",
			titleAlign: "left",
			bodySpacing: 2,
			bodyColor: "#fff",
			bodyAlign: "left",
			footerFontStyle: "bold",
			footerSpacing: 2,
			footerMarginTop: 6,
			footerColor: "#fff",
			footerAlign: "left",
			yPadding: 6,
			xPadding: 6,
			yAlign : 'center',
			xAlign : 'center',
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
	
					if (tooltipItems.length > 0) {
						if (tooltipItems[0].xLabel) {
							title = tooltipItems[0].xLabel;
						} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
							title = data.labels[tooltipItems[0].index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					base = base.concat(toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				var options = this._options;
				helpers.extend(this, {
					_model: {
						// Positioning
						xPadding: options.tooltips.xPadding,
						yPadding: options.tooltips.yPadding,
						xAlign : options.tooltips.yAlign,
						yAlign : options.tooltips.xAlign,
	
						// Body
						bodyColor: options.tooltips.bodyColor,
						_bodyFontFamily: helpers.getValueOrDefault(options.tooltips.bodyFontFamily, Chart.defaults.global.defaultFontFamily),
						_bodyFontStyle: helpers.getValueOrDefault(options.tooltips.bodyFontStyle, Chart.defaults.global.defaultFontStyle),
						_bodyAlign: options.tooltips.bodyAlign,
						bodyFontSize: helpers.getValueOrDefault(options.tooltips.bodyFontSize, Chart.defaults.global.defaultFontSize),
						bodySpacing: options.tooltips.bodySpacing,
	
						// Title
						titleColor: options.tooltips.titleColor,
						_titleFontFamily: helpers.getValueOrDefault(options.tooltips.titleFontFamily, Chart.defaults.global.defaultFontFamily),
						_titleFontStyle: helpers.getValueOrDefault(options.tooltips.titleFontStyle, Chart.defaults.global.defaultFontStyle),
						titleFontSize: helpers.getValueOrDefault(options.tooltips.titleFontSize, Chart.defaults.global.defaultFontSize),
						_titleAlign: options.tooltips.titleAlign,
						titleSpacing: options.tooltips.titleSpacing,
						titleMarginBottom: options.tooltips.titleMarginBottom,
	
						// Footer
						footerColor: options.tooltips.footerColor,
						_footerFontFamily: helpers.getValueOrDefault(options.tooltips.footerFontFamily, Chart.defaults.global.defaultFontFamily),
						_footerFontStyle: helpers.getValueOrDefault(options.tooltips.footerFontStyle, Chart.defaults.global.defaultFontStyle),
						footerFontSize: helpers.getValueOrDefault(options.tooltips.footerFontSize, Chart.defaults.global.defaultFontSize),
						_footerAlign: options.tooltips.footerAlign,
						footerSpacing: options.tooltips.footerSpacing,
						footerMarginTop: options.tooltips.footerMarginTop,
	
						// Appearance
						caretSize: options.tooltips.caretSize,
						cornerRadius: options.tooltips.cornerRadius,
						backgroundColor: options.tooltips.backgroundColor,
						opacity: 0,
						legendColorBackground: options.tooltips.multiKeyBackground
					}
				});
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var beforeTitle = this._options.tooltips.callbacks.beforeTitle.apply(this, arguments),
					title = this._options.tooltips.callbacks.title.apply(this, arguments),
					afterTitle = this._options.tooltips.callbacks.afterTitle.apply(this, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.tooltips.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var lines = [];
	
				helpers.each(tooltipItems, function(bodyItem) {
					helpers.pushAllIfDefined(this._options.tooltips.callbacks.beforeLabel.call(this, bodyItem, data), lines);
					helpers.pushAllIfDefined(this._options.tooltips.callbacks.label.call(this, bodyItem, data), lines);
					helpers.pushAllIfDefined(this._options.tooltips.callbacks.afterLabel.call(this, bodyItem, data), lines);
				}, this);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.tooltips.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var beforeFooter = this._options.tooltips.callbacks.beforeFooter.apply(this, arguments);
				var footer = this._options.tooltips.callbacks.footer.apply(this, arguments);
				var afterFooter = this._options.tooltips.callbacks.afterFooter.apply(this, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			getAveragePosition: function(elements) {
	
				if (!elements.length) {
					return false;
				}
	
				var xPositions = [];
				var yPositions = [];
	
				helpers.each(elements, function(el) {
					if (el) {
						var pos = el.tooltipPosition();
						xPositions.push(pos.x);
						yPositions.push(pos.y);
					}
				});
	
				var x = 0,
					y = 0;
				for (var i = 0; i < xPositions.length; i++) {
					x += xPositions[i];
					y += yPositions[i];
				}
	
				return {
					x: Math.round(x / xPositions.length),
					y: Math.round(y / xPositions.length)
				};
	
			},
	
			update: function(changed) {
				if (this._active.length) {
					this._model.opacity = 1;
	
					var element = this._active[0],
						labelColors = [],
						tooltipPosition;
	
					var tooltipItems = [];
	
					if (this._options.tooltips.mode === 'single') {
						var yScale = element._yScale || element._scale; // handle radar || polarArea charts
						tooltipItems.push({
							xLabel: element._xScale ? element._xScale.getLabelForIndex(element._index, element._datasetIndex) : '',
							yLabel: yScale ? yScale.getLabelForIndex(element._index, element._datasetIndex) : '',
							index: element._index,
							datasetIndex: element._datasetIndex
						});
						tooltipPosition = this.getAveragePosition(this._active);
					} else {
						helpers.each(this._data.datasets, function(dataset, datasetIndex) {
							if (!this._chartInstance.isDatasetVisible(datasetIndex)) {
								return;
							}
	
							var meta = this._chartInstance.getDatasetMeta(datasetIndex);
							var currentElement = meta.data[element._index];
							if (currentElement) {
								var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	
								tooltipItems.push({
									xLabel: currentElement._xScale ? currentElement._xScale.getLabelForIndex(currentElement._index, currentElement._datasetIndex) : '',
									yLabel: yScale ? yScale.getLabelForIndex(currentElement._index, currentElement._datasetIndex) : '',
									index: element._index,
									datasetIndex: datasetIndex
								});
							}
						}, this);
	
						helpers.each(this._active, function(active) {
							if (active) {
								labelColors.push({
									borderColor: active._view.borderColor,
									backgroundColor: active._view.backgroundColor
								});
							}
						}, null);
	
						tooltipPosition = this.getAveragePosition(this._active);
					}
	
					// Build the Text Lines
					helpers.extend(this._model, {
						title: this.getTitle(tooltipItems, this._data),
						beforeBody: this.getBeforeBody(tooltipItems, this._data),
						body: this.getBody(tooltipItems, this._data),
						afterBody: this.getAfterBody(tooltipItems, this._data),
						footer: this.getFooter(tooltipItems, this._data)
					});
	
					helpers.extend(this._model, {
						x: Math.round(tooltipPosition.x),
						y: Math.round(tooltipPosition.y),
						caretPadding: helpers.getValueOrDefault(tooltipPosition.padding, 2),
						labelColors: labelColors
					});
	
					// We need to determine alignment of
					var tooltipSize = this.getTooltipSize(this._model);
					this.determineAlignment(tooltipSize); // Smart Tooltip placement to stay on the canvas
	
					helpers.extend(this._model, this.getBackgroundPoint(this._model, tooltipSize));
				} else {
					this._model.opacity = 0;
				}
	
				if (changed && this._options.tooltips.custom) {
					this._options.tooltips.custom.call(this, this._model);
				}
	
				return this;
			},
			getTooltipSize: function getTooltipSize(vm) {
				var ctx = this._chart.ctx;
	
				var size = {
					height: vm.yPadding * 2, // Tooltip Padding
					width: 0
				};
				var combinedBodyLength = vm.body.length + vm.beforeBody.length + vm.afterBody.length;
	
				size.height += vm.title.length * vm.titleFontSize; // Title Lines
				size.height += (vm.title.length - 1) * vm.titleSpacing; // Title Line Spacing
				size.height += vm.title.length ? vm.titleMarginBottom : 0; // Title's bottom Margin
				size.height += combinedBodyLength * vm.bodyFontSize; // Body Lines
				size.height += combinedBodyLength ? (combinedBodyLength - 1) * vm.bodySpacing : 0; // Body Line Spacing
				size.height += vm.footer.length ? vm.footerMarginTop : 0; // Footer Margin
				size.height += vm.footer.length * (vm.footerFontSize); // Footer Lines
				size.height += vm.footer.length ? (vm.footer.length - 1) * vm.footerSpacing : 0; // Footer Line Spacing
	
				// Width
				ctx.font = helpers.fontString(vm.titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
				helpers.each(vm.title, function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width);
				});
	
				ctx.font = helpers.fontString(vm.bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
				helpers.each(vm.beforeBody.concat(vm.afterBody), function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width);
				});
				helpers.each(vm.body, function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width + (this._options.tooltips.mode !== 'single' ? (vm.bodyFontSize + 2) : 0));
				}, this);
	
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
				helpers.each(vm.footer, function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width);
				});
				size.width += 2 * vm.xPadding;
	
				return size;
			},
			determineAlignment: function determineAlignment(size) {
				if (this._model.y < size.height) {
					this._model.yAlign = 'top';
				} else if (this._model.y > (this._chart.height - size.height)) {
					this._model.yAlign = 'bottom';
				}
	
				var lf, rf; // functions to determine left, right alignment
				var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
				var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
				var _this = this;
				var midX = (this._chartInstance.chartArea.left + this._chartInstance.chartArea.right) / 2;
				var midY = (this._chartInstance.chartArea.top + this._chartInstance.chartArea.bottom) / 2;
	
				if (this._model.yAlign === 'center') {
					lf = function(x) {
						return x <= midX;
					};
					rf = function(x) {
						return x > midX;
					};
				} else {
					lf = function(x) {
						return x <= (size.width / 2);
					};
					rf = function(x) {
						return x >= (_this._chart.width - (size.width / 2));
					};
				}
	
				olf = function(x) {
					return x + size.width > _this._chart.width;
				};
				orf = function(x) {
					return x - size.width < 0;
				};
				yf = function(y) {
					return y <= midY ? 'top' : 'bottom';
				};
	
				if (lf(this._model.x)) {
					this._model.xAlign = 'left';
	
					// Is tooltip too wide and goes over the right side of the chart.?
					if (olf(this._model.x)) {
						this._model.xAlign = 'center';
						this._model.yAlign = yf(this._model.y);
					}
				} else if (rf(this._model.x)) {
					this._model.xAlign = 'right';
	
					// Is tooltip too wide and goes outside left edge of canvas?
					if (orf(this._model.x)) {
						this._model.xAlign = 'center';
						this._model.yAlign = yf(this._model.y);
					}
				}
			},
			getBackgroundPoint: function getBackgroundPoint(vm, size) {
				// Background Position
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				if (vm.xAlign === 'right') {
					pt.x -= size.width;
				} else if (vm.xAlign === 'center') {
					pt.x -= (size.width / 2);
				}
	
				if (vm.yAlign === 'top') {
					pt.y += vm.caretPadding + vm.caretSize;
				} else if (vm.yAlign === 'bottom') {
					pt.y -= size.height + vm.caretPadding + vm.caretSize;
				} else {
					pt.y -= (size.height / 2);
				}
	
				if (vm.yAlign === 'center') {
					if (vm.xAlign === 'left') {
						pt.x += vm.caretPadding + vm.caretSize;
					} else if (vm.xAlign === 'right') {
						pt.x -= vm.caretPadding + vm.caretSize;
					}
				} else {
					if (vm.xAlign === 'left') {
						pt.x -= vm.cornerRadius + vm.caretPadding;
					} else if (vm.xAlign === 'right') {
						pt.x += vm.cornerRadius + vm.caretPadding;
					}
				}
	
				return pt;
			},
			drawCaret: function drawCaret(tooltipPoint, size, opacity, caretPadding) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
	
				if (vm.yAlign === 'center') {
					// Left or right side
					if (vm.xAlign === 'left') {
						x1 = tooltipPoint.x;
						x2 = x1 - vm.caretSize;
						x3 = x1;
					} else {
						x1 = tooltipPoint.x + size.width;
						x2 = x1 + vm.caretSize;
						x3 = x1;
					}
	
					y2 = tooltipPoint.y + (size.height / 2);
					y1 = y2 - vm.caretSize;
					y3 = y2 + vm.caretSize;
				} else {
					if (vm.xAlign === 'left') {
						x1 = tooltipPoint.x + vm.cornerRadius;
						x2 = x1 + vm.caretSize;
						x3 = x2 + vm.caretSize;
					} else if (vm.xAlign === 'right') {
						x1 = tooltipPoint.x + size.width - vm.cornerRadius;
						x2 = x1 - vm.caretSize;
						x3 = x2 - vm.caretSize;
					} else {
						x2 = tooltipPoint.x + (size.width / 2);
						x1 = x2 - vm.caretSize;
						x3 = x2 + vm.caretSize;
					}
	
					if (vm.yAlign === 'top') {
						y1 = tooltipPoint.y;
						y2 = y1 - vm.caretSize;
						y3 = y1;
					} else {
						y1 = tooltipPoint.y + size.height;
						y2 = y1 + vm.caretSize;
						y3 = y1;
					}
				}
	
				var bgColor = helpers.color(vm.backgroundColor);
				ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function drawTitle(pt, vm, ctx, opacity) {
				if (vm.title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = "top";
	
					var titleColor = helpers.color(vm.titleColor);
					ctx.fillStyle = titleColor.alpha(opacity * titleColor.alpha()).rgbString();
					ctx.font = helpers.fontString(vm.titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					helpers.each(vm.title, function(title, i) {
						ctx.fillText(title, pt.x, pt.y);
						pt.y += vm.titleFontSize + vm.titleSpacing; // Line Height and spacing
	
						if (i + 1 === vm.title.length) {
							pt.y += vm.titleMarginBottom - vm.titleSpacing; // If Last, add margin, remove spacing
						}
					});
				}
			},
			drawBody: function drawBody(pt, vm, ctx, opacity) {
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = "top";
	
				var bodyColor = helpers.color(vm.bodyColor);
				ctx.fillStyle = bodyColor.alpha(opacity * bodyColor.alpha()).rgbString();
				ctx.font = helpers.fontString(vm.bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				helpers.each(vm.beforeBody, function(beforeBody) {
					ctx.fillText(beforeBody, pt.x, pt.y);
					pt.y += vm.bodyFontSize + vm.bodySpacing;
				});
	
				helpers.each(vm.body, function(body, i) {
					// Draw Legend-like boxes if needed
					if (this._options.tooltips.mode !== 'single') {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = helpers.color(vm.legendColorBackground).alpha(opacity).rgbaString();
						ctx.fillRect(pt.x, pt.y, vm.bodyFontSize, vm.bodyFontSize);
	
						// Border
						ctx.strokeStyle = helpers.color(vm.labelColors[i].borderColor).alpha(opacity).rgbaString();
						ctx.strokeRect(pt.x, pt.y, vm.bodyFontSize, vm.bodyFontSize);
	
						// Inner square
						ctx.fillStyle = helpers.color(vm.labelColors[i].backgroundColor).alpha(opacity).rgbaString();
						ctx.fillRect(pt.x + 1, pt.y + 1, vm.bodyFontSize - 2, vm.bodyFontSize - 2);
	
						ctx.fillStyle = helpers.color(vm.bodyColor).alpha(opacity).rgbaString(); // Return fill style for text
					}
	
					// Body Line
					ctx.fillText(body, pt.x + (this._options.tooltips.mode !== 'single' ? (vm.bodyFontSize + 2) : 0), pt.y);
	
					pt.y += vm.bodyFontSize + vm.bodySpacing;
				}, this);
	
				// After Body
				helpers.each(vm.afterBody, function(afterBody) {
					ctx.fillText(afterBody, pt.x, pt.y);
					pt.y += vm.bodyFontSize;
				});
	
				pt.y -= vm.bodySpacing; // Remove last body spacing
			},
			drawFooter: function drawFooter(pt, vm, ctx, opacity) {
				if (vm.footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = "top";
	
					var footerColor = helpers.color(vm.footerColor);
					ctx.fillStyle = footerColor.alpha(opacity * footerColor.alpha()).rgbString();
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(vm.footer, function(footer) {
						ctx.fillText(footer, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			draw: function draw() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var caretPadding = vm.caretPadding;
				var tooltipSize = this.getTooltipSize(vm);
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.tooltips.enabled) {
					// Draw Background
					var bgColor = helpers.color(vm.backgroundColor);
					ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
					helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
					ctx.fill();
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity, caretPadding);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			}
		});
	};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: "label"
			},
	
			scales: {
				xAxes: [{
					type: "category",
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: "linear"
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				// Use this to indicate that this is a bar dataset.
				this.getMeta().bar = true;
			},
			// Get the number of datasets that display bars. We use this to correctly calculate the bar width
			getBarCount: function getBarCount() {
				var barCount = 0;
				helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
					var meta = this.chart.getDatasetMeta(datasetIndex);
					if (meta.bar && this.chart.isDatasetVisible(datasetIndex)) {
						++barCount;
					}
				}, this);
				return barCount;
			},
	
			addElements: function() {
				var meta = this.getMeta();
				helpers.each(this.getDataset().data, function(value, index) {
					meta.data[index] = meta.data[index] || new Chart.elements.Rectangle({
						_chart: this.chart.chart,
						_datasetIndex: this.index,
						_index: index
					});
				}, this);
			},
	
			addElementAndReset: function(index) {
				var rectangle = new Chart.elements.Rectangle({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index
				});
	
				var numBars = this.getBarCount();
	
				// Add to the points array and reset it
				this.getMeta().data.splice(index, 0, rectangle);
				this.updateElement(rectangle, index, true, numBars);
			},
	
			update: function update(reset) {
				var numBars = this.getBarCount();
	
				helpers.each(this.getMeta().data, function(rectangle, index) {
					this.updateElement(rectangle, index, reset, numBars);
				}, this);
			},
	
			updateElement: function updateElement(rectangle, index, reset, numBars) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				var yScalePoint;
	
				if (yScale.min < 0 && yScale.max < 0) {
					// all less than 0. use the top
					yScalePoint = yScale.getPixelForValue(yScale.max);
				} else if (yScale.min > 0 && yScale.max > 0) {
					yScalePoint = yScale.getPixelForValue(yScale.min);
				} else {
					yScalePoint = yScale.getPixelForValue(0);
				}
	
				helpers.extend(rectangle, {
					// Utility
					_chart: this.chart.chart,
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: this.index,
					_index: index,
	
	
					// Desired view properties
					_model: {
						x: this.calculateBarX(index, this.index),
						y: reset ? yScalePoint : this.calculateBarY(index, this.index),
	
						// Tooltip
						label: this.chart.data.labels[index],
						datasetLabel: this.getDataset().label,
	
						// Appearance
						base: reset ? yScalePoint : this.calculateBarBase(this.index, index),
						width: this.calculateBarWidth(numBars),
						backgroundColor: rectangle.custom && rectangle.custom.backgroundColor ? rectangle.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.rectangle.backgroundColor),
						borderSkipped: rectangle.custom && rectangle.custom.borderSkipped ? rectangle.custom.borderSkipped : this.chart.options.elements.rectangle.borderSkipped,
						borderColor: rectangle.custom && rectangle.custom.borderColor ? rectangle.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.rectangle.borderColor),
						borderWidth: rectangle.custom && rectangle.custom.borderWidth ? rectangle.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.rectangle.borderWidth)
					}
				});
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				var base = 0;
	
				if (yScale.options.stacked) {
	
					var value = this.chart.data.datasets[datasetIndex].data[index];
	
					if (value < 0) {
						for (var i = 0; i < datasetIndex; i++) {
							var negDS = this.chart.data.datasets[i];
							var negDSMeta = this.chart.getDatasetMeta(i);
							if (negDSMeta.bar && negDSMeta.yAxisID === yScale.id && this.chart.isDatasetVisible(i)) {
								base += negDS.data[index] < 0 ? negDS.data[index] : 0;
							}
						}
					} else {
						for (var j = 0; j < datasetIndex; j++) {
							var posDS = this.chart.data.datasets[j];
							var posDSMeta = this.chart.getDatasetMeta(j);
							if (posDSMeta.bar && posDSMeta.yAxisID === yScale.id && this.chart.isDatasetVisible(j)) {
								base += posDS.data[index] > 0 ? posDS.data[index] : 0;
							}
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				base = yScale.getPixelForValue(yScale.min);
	
				if (yScale.beginAtZero || ((yScale.min <= 0 && yScale.max >= 0) || (yScale.min >= 0 && yScale.max <= 0))) {
					base = yScale.getPixelForValue(0, 0);
					//base += yScale.options.gridLines.lineWidth;
				} else if (yScale.min < 0 && yScale.max < 0) {
					// All values are negative. Use the top as the base
					base = yScale.getPixelForValue(yScale.max);
				}
	
				return base;
	
			},
	
			getRuler: function() {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
				var datasetCount = this.getBarCount();
	
				var tickWidth = (function() {
					var min = xScale.getPixelForTick(1) - xScale.getPixelForTick(0);
					for (var i = 2; i < xScale.ticks.length; i++) {
						min = Math.min(xScale.getPixelForTick(i) - xScale.getPixelForTick(i - 1), min);
					}
					return min;
				}).call(this);
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / datasetCount;
	
				if (xScale.ticks.length !== this.chart.data.labels.length) {
				    var perc = xScale.ticks.length / this.chart.data.labels.length;
				    fullBarWidth = fullBarWidth * perc;
				}
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function() {
				var xScale = this.getScaleForId(this.getMeta().xAxisID);
				var ruler = this.getRuler();
				return xScale.options.stacked ? ruler.categoryWidth : ruler.barWidth;
			},
	
			// Get bar index from the given dataset index accounting for the fact that not all bars are visible
			getBarIndex: function(datasetIndex) {
				var barIndex = 0;
				var meta, j;
	
				for (j = 0; j < datasetIndex; ++j) {
					meta = this.chart.getDatasetMeta(j);
					if (meta.bar && this.chart.isDatasetVisible(j)) {
						++barIndex;
					}
				}
	
				return barIndex;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var meta = this.getMeta();
				var yScale = this.getScaleForId(meta.yAxisID);
				var xScale = this.getScaleForId(meta.xAxisID);
				var barIndex = this.getBarIndex(datasetIndex);
	
				var ruler = this.getRuler();
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, this.chart.isCombo);
				leftTick -= this.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				if (xScale.options.stacked) {
					return leftTick + (ruler.categoryWidth / 2) + ruler.categorySpacing;
				}
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				var value = this.getDataset().data[index];
	
				if (yScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = this.chart.data.datasets[i];
						var dsMeta = this.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && this.chart.isDatasetVisible(i)) {
							if (ds.data[index] < 0) {
								sumNeg += ds.data[index] || 0;
							} else {
								sumPos += ds.data[index] || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					} else {
						return yScale.getPixelForValue(sumPos + value);
					}
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				helpers.each(this.getMeta().data, function(rectangle, index) {
					var d = this.getDataset().data[index];
					if (d !== null && d !== undefined && !isNaN(d)) {
						rectangle.transition(easingDecimal).draw();
					}
				}, this);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				rectangle._model.backgroundColor = rectangle.custom && rectangle.custom.hoverBackgroundColor ? rectangle.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(rectangle._model.backgroundColor));
				rectangle._model.borderColor = rectangle.custom && rectangle.custom.hoverBorderColor ? rectangle.custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(rectangle._model.borderColor));
				rectangle._model.borderWidth = rectangle.custom && rectangle.custom.hoverBorderWidth ? rectangle.custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, rectangle._model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				rectangle._model.backgroundColor = rectangle.custom && rectangle.custom.backgroundColor ? rectangle.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.rectangle.backgroundColor);
				rectangle._model.borderColor = rectangle.custom && rectangle.custom.borderColor ? rectangle.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.rectangle.borderColor);
				rectangle._model.borderWidth = rectangle.custom && rectangle.custom.borderWidth ? rectangle.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.rectangle.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: "label"
			},
	
			scales: {
				xAxes: [{
					type: "linear",
					position: "bottom"
				}],
				yAxes: [{
					position: "left",
					type: "category",
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			updateElement: function updateElement(rectangle, index, reset, numBars) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				var xScalePoint;
	
				if (xScale.min < 0 && xScale.max < 0) {
					// all less than 0. use the right
					xScalePoint = xScale.getPixelForValue(xScale.max);
				} else if (xScale.min > 0 && xScale.max > 0) {
					xScalePoint = xScale.getPixelForValue(xScale.min);
				} else {
					xScalePoint = xScale.getPixelForValue(0);
				}
	
				helpers.extend(rectangle, {
					// Utility
					_chart: this.chart.chart,
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: this.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScalePoint : this.calculateBarX(index, this.index),
						y: this.calculateBarY(index, this.index),
	
						// Tooltip
						label: this.chart.data.labels[index],
						datasetLabel: this.getDataset().label,
	
						// Appearance
						base: reset ? xScalePoint : this.calculateBarBase(this.index, index),
						height: this.calculateBarHeight(numBars),
						backgroundColor: rectangle.custom && rectangle.custom.backgroundColor ? rectangle.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.rectangle.backgroundColor),
						borderSkipped: rectangle.custom && rectangle.custom.borderSkipped ? rectangle.custom.borderSkipped : this.chart.options.elements.rectangle.borderSkipped,
						borderColor: rectangle.custom && rectangle.custom.borderColor ? rectangle.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.rectangle.borderColor),
						borderWidth: rectangle.custom && rectangle.custom.borderWidth ? rectangle.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.rectangle.borderWidth)
					},
	
					draw: function () {
	
						var ctx = this._chart.ctx;
						var vm = this._view;
	
						var halfHeight = vm.height / 2,
							topY = vm.y - halfHeight,
							bottomY = vm.y + halfHeight,
							right = vm.base - (vm.base - vm.x),
							halfStroke = vm.borderWidth / 2;
	
						// Canvas doesn't allow us to stroke inside the width so we can
						// adjust the sizes to fit if we're setting a stroke on the line
						if (vm.borderWidth) {
							topY += halfStroke;
							bottomY -= halfStroke;
							right += halfStroke;
						}
	
						ctx.beginPath();
	
						ctx.fillStyle = vm.backgroundColor;
						ctx.strokeStyle = vm.borderColor;
						ctx.lineWidth = vm.borderWidth;
	
						// Corner points, from bottom-left to bottom-right clockwise
						// | 1 2 |
						// | 0 3 |
						var corners = [
							[vm.base, bottomY],
							[vm.base, topY],
							[right, topY],
							[right, bottomY]
						];
	
						// Find first (starting) corner with fallback to 'bottom'
						var borders = ['bottom', 'left', 'top', 'right'];
						var startCorner = borders.indexOf(vm.borderSkipped, 0);
						if (startCorner === -1)
							startCorner = 0;
	
						function cornerAt(index) {
							return corners[(startCorner + index) % 4];
						}
	
						// Draw rectangle from 'startCorner'
						ctx.moveTo.apply(ctx, cornerAt(0));
						for (var i = 1; i < 4; i++)
							ctx.lineTo.apply(ctx, cornerAt(i));
	
						ctx.fill();
						if (vm.borderWidth) {
							ctx.stroke();
						}
					},
	
					inRange: function (mouseX, mouseY) {
						var vm = this._view;
						var inRange = false;
	
						if (vm) {
							if (vm.x < vm.base) {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.x && mouseX <= vm.base);
							} else {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.base && mouseX <= vm.x);
							}
						}
	
						return inRange;
					}
				});
	
				rectangle.pivot();
			},
	
			calculateBarBase: function (datasetIndex, index) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				var base = 0;
	
				if (xScale.options.stacked) {
	
					var value = this.chart.data.datasets[datasetIndex].data[index];
	
					if (value < 0) {
						for (var i = 0; i < datasetIndex; i++) {
							var negDS = this.chart.data.datasets[i];
							var negDSMeta = this.chart.getDatasetMeta(i);
							if (negDSMeta.bar && negDSMeta.xAxisID === xScale.id && this.chart.isDatasetVisible(i)) {
								base += negDS.data[index] < 0 ? negDS.data[index] : 0;
							}
						}
					} else {
						for (var j = 0; j < datasetIndex; j++) {
							var posDS = this.chart.data.datasets[j];
							var posDSMeta = this.chart.getDatasetMeta(j);
							if (posDSMeta.bar && posDSMeta.xAxisID === xScale.id && this.chart.isDatasetVisible(j)) {
								base += posDS.data[index] > 0 ? posDS.data[index] : 0;
							}
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				base = xScale.getPixelForValue(xScale.min);
	
				if (xScale.beginAtZero || ((xScale.min <= 0 && xScale.max >= 0) || (xScale.min >= 0 && xScale.max <= 0))) {
					base = xScale.getPixelForValue(0, 0);
				} else if (xScale.min < 0 && xScale.max < 0) {
					// All values are negative. Use the right as the base
					base = xScale.getPixelForValue(xScale.max);
				}
	
				return base;
			},
	
			getRuler: function () {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
				var datasetCount = this.getBarCount();
	
				var tickHeight = (function () {
					var min = yScale.getPixelForTick(1) - yScale.getPixelForTick(0);
					for (var i = 2; i < this.getDataset().data.length; i++) {
						min = Math.min(yScale.getPixelForTick(i) - yScale.getPixelForTick(i - 1), min);
					}
					return min;
				}).call(this);
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / datasetCount;
	
				if (yScale.ticks.length !== this.chart.data.labels.length) {
					var perc = yScale.ticks.length / this.chart.data.labels.length;
					fullBarHeight = fullBarHeight * perc;
				}
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing,
				};
			},
	
			calculateBarHeight: function () {
				var yScale = this.getScaleForId(this.getMeta().yAxisID);
				var ruler = this.getRuler();
				return yScale.options.stacked ? ruler.categoryHeight : ruler.barHeight;
			},
	
			calculateBarX: function (index, datasetIndex) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				var value = this.getDataset().data[index];
	
				if (xScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = this.chart.data.datasets[i];
						var dsMeta = this.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && this.chart.isDatasetVisible(i)) {
							if (ds.data[index] < 0) {
								sumNeg += ds.data[index] || 0;
							} else {
								sumPos += ds.data[index] || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					} else {
						return xScale.getPixelForValue(sumPos + value);
					}
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function (index, datasetIndex) {
				var meta = this.getMeta();
				var yScale = this.getScaleForId(meta.yAxisID);
				var xScale = this.getScaleForId(meta.xAxisID);
				var barIndex = this.getBarIndex(datasetIndex);
	
				var ruler = this.getRuler();
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, this.chart.isCombo);
				topTick -= this.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				if (yScale.options.stacked) {
					return topTick + (ruler.categoryHeight / 2) + ruler.categorySpacing;
				}
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			}
		});
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: "single"
			},
	
			scales: {
				xAxes: [{
					type: "linear", // bubble should probably use a linear scale by default
					position: "bottom",
					id: "x-axis-0" // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: "linear",
					position: "left",
					id: "y-axis-0"
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + dataPoint.x + ', ' + dataPoint.y + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
			addElements: function() {
				var meta = this.getMeta();
				helpers.each(this.getDataset().data, function(value, index) {
					meta.data[index] = meta.data[index] || new Chart.elements.Point({
						_chart: this.chart.chart,
						_datasetIndex: this.index,
						_index: index
					});
				}, this);
			},
			addElementAndReset: function(index) {
				var point = new Chart.elements.Point({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index
				});
	
				// Add to the points array and reset it
				this.getMeta().data.splice(index, 0, point);
				this.updateElement(point, index, true);
			},
	
			update: function update(reset) {
				var meta = this.getMeta();
				var points = meta.data;
				var yScale = this.getScaleForId(meta.yAxisID);
				var xScale = this.getScaleForId(meta.xAxisID);
				var scaleBase;
	
				if (yScale.min < 0 && yScale.max < 0) {
					scaleBase = yScale.getPixelForValue(yScale.max);
				} else if (yScale.min > 0 && yScale.max > 0) {
					scaleBase = yScale.getPixelForValue(yScale.min);
				} else {
					scaleBase = yScale.getPixelForValue(0);
				}
	
				// Update Points
				helpers.each(points, function(point, index) {
					this.updateElement(point, index, reset);
				}, this);
	
			},
	
			updateElement: function(point, index, reset) {
				var meta = this.getMeta();
				var yScale = this.getScaleForId(meta.yAxisID);
				var xScale = this.getScaleForId(meta.xAxisID);
				var scaleBase;
	
				if (yScale.min < 0 && yScale.max < 0) {
					scaleBase = yScale.getPixelForValue(yScale.max);
				} else if (yScale.min > 0 && yScale.max > 0) {
					scaleBase = yScale.getPixelForValue(yScale.min);
				} else {
					scaleBase = yScale.getPixelForValue(0);
				}
	
				helpers.extend(point, {
					// Utility
					_chart: this.chart.chart,
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: this.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(this.getDataset().data[index], index, this.index, this.chart.isCombo),
						y: reset ? scaleBase : yScale.getPixelForValue(this.getDataset().data[index], index, this.index),
						// Appearance
						radius: reset ? 0 : point.custom && point.custom.radius ? point.custom.radius : this.getRadius(this.getDataset().data[index]),
						backgroundColor: point.custom && point.custom.backgroundColor ? point.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.point.backgroundColor),
						borderColor: point.custom && point.custom.borderColor ? point.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.point.borderColor),
						borderWidth: point.custom && point.custom.borderWidth ? point.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.point.borderWidth),
	
						// Tooltip
						hitRadius: point.custom && point.custom.hitRadius ? point.custom.hitRadius : helpers.getValueAtIndexOrDefault(this.getDataset().hitRadius, index, this.chart.options.elements.point.hitRadius)
					}
				});
	
				point._model.skip = point.custom && point.custom.skip ? point.custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
	
				// Transition and Draw the Points
				helpers.each(this.getMeta().data, function(point, index) {
					point.transition(easingDecimal);
					point.draw();
				});
	
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
	
				point._model.radius = point.custom && point.custom.hoverRadius ? point.custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, this.chart.options.elements.point.hoverRadius)) + this.getRadius(this.getDataset().data[point._index]);
				point._model.backgroundColor = point.custom && point.custom.hoverBackgroundColor ? point.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(point._model.backgroundColor));
				point._model.borderColor = point.custom && point.custom.hoverBorderColor ? point.custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(point._model.borderColor));
				point._model.borderWidth = point.custom && point.custom.hoverBorderWidth ? point.custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, point._model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
	
				point._model.radius = point.custom && point.custom.radius ? point.custom.radius : this.getRadius(this.getDataset().data[point._index]);
				point._model.backgroundColor = point.custom && point.custom.backgroundColor ? point.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.point.backgroundColor);
				point._model.borderColor = point.custom && point.custom.borderColor ? point.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.point.borderColor);
				point._model.borderWidth = point.custom && point.custom.borderWidth ? point.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.point.borderWidth);
			}
		});
	};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.doughnut = {
			animation: {
				//Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				//Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				if (chart.data.datasets.length) {
					for (var i = 0; i < chart.data.datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '"></span>');
						if (chart.data.labels[i]) {
							text.push(chart.data.labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join("");
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var fill = arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(ds.backgroundColor, i, this.chart.options.elements.arc.backgroundColor);
								var stroke = arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(ds.borderColor, i, this.chart.options.elements.arc.borderColor);
								var bw = arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(ds.borderWidth, i, this.chart.options.elements.arc.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							}, this);
						} else {
							return [];
						}
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			//The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			//The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			//The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
					}
				}
			}
		};
	
		Chart.defaults.pie = helpers.clone(Chart.defaults.doughnut);
		helpers.extend(Chart.defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
			linkScales: function() {
				// no scales for doughnut
			},
	
			addElements: function() {
				var meta = this.getMeta();
				helpers.each(this.getDataset().data, function(value, index) {
					meta.data[index] = meta.data[index] || new Chart.elements.Arc({
						_chart: this.chart.chart,
						_datasetIndex: this.index,
						_index: index
					});
				}, this);
			},
	
			addElementAndReset: function(index, colorForNewElement) {
				var arc = new Chart.elements.Arc({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index
				});
	
				if (colorForNewElement && helpers.isArray(this.getDataset().backgroundColor)) {
					this.getDataset().backgroundColor.splice(index, 0, colorForNewElement);
				}
	
				// Add to the points array and reset it
				this.getMeta().data.splice(index, 0, arc);
				this.updateElement(arc, index, true);
			},
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function getRingIndex(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function update(reset) {
				var availableWidth = this.chart.chartArea.right - this.chart.chartArea.left - this.chart.options.elements.arc.borderWidth;
				var availableHeight = this.chart.chartArea.bottom - this.chart.chartArea.top - this.chart.options.elements.arc.borderWidth;
				var minSize = Math.min(availableWidth, availableHeight);
				var offset = {x: 0, y: 0};
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (this.chart.options.circumference < Math.PI * 2.0) {
					var startAngle = this.chart.options.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + this.chart.options.circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = this.chart.options.cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				this.chart.outerRadius = Math.max(minSize / 2, 0);
				this.chart.innerRadius = Math.max(this.chart.options.cutoutPercentage ? (this.chart.outerRadius / 100) * (this.chart.options.cutoutPercentage) : 1, 0);
				this.chart.radiusLength = (this.chart.outerRadius - this.chart.innerRadius) / this.chart.getVisibleDatasetCount();
				this.chart.offsetX = offset.x * this.chart.outerRadius;
				this.chart.offsetY = offset.y * this.chart.outerRadius;
	
				this.getMeta().total = this.calculateTotal();
	
				this.outerRadius = this.chart.outerRadius - (this.chart.radiusLength * this.getRingIndex(this.index));
				this.innerRadius = this.outerRadius - this.chart.radiusLength;
	
				helpers.each(this.getMeta().data, function(arc, index) {
					this.updateElement(arc, index, reset);
				}, this);
			},
	
			updateElement: function(arc, index, reset) {
				var centerX = (this.chart.chartArea.left + this.chart.chartArea.right) / 2;
				var centerY = (this.chart.chartArea.top + this.chart.chartArea.bottom) / 2;
				var startAngle = this.chart.options.rotation; // non reset case handled later
				var endAngle = this.chart.options.rotation; // non reset case handled later
				var circumference = reset && this.chart.options.animation.animateRotate ? 0 : arc.hidden? 0 : this.calculateCircumference(this.getDataset().data[index]) * (this.chart.options.circumference / (2.0 * Math.PI));
				var innerRadius = reset && this.chart.options.animation.animateScale ? 0 : this.innerRadius;
				var outerRadius = reset && this.chart.options.animation.animateScale ? 0 : this.outerRadius;
	
				helpers.extend(arc, {
					// Utility
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + this.chart.offsetX,
						y: centerY + this.chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
	
						backgroundColor: arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.arc.backgroundColor),
						hoverBackgroundColor: arc.custom && arc.custom.hoverBackgroundColor ? arc.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().hoverBackgroundColor, index, this.chart.options.elements.arc.hoverBackgroundColor),
						borderWidth: arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.arc.borderWidth),
						borderColor: arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.arc.borderColor),
	
						label: helpers.getValueAtIndexOrDefault(this.getDataset().label, index, this.chart.data.labels[index])
					}
				});
	
				// Set correct angles if not resetting
				if (!reset || !this.chart.options.animation.animateRotate) {
	
					if (index === 0) {
						arc._model.startAngle = this.chart.options.rotation;
					} else {
						arc._model.startAngle = this.getMeta().data[index - 1]._model.endAngle;
					}
	
					arc._model.endAngle = arc._model.startAngle + arc._model.circumference;
				}
	
				arc.pivot();
			},
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				helpers.each(this.getMeta().data, function(arc, index) {
					arc.transition(easingDecimal).draw();
				});
			},
	
			setHoverStyle: function(arc) {
				var dataset = this.chart.data.datasets[arc._datasetIndex];
				var index = arc._index;
	
				arc._model.backgroundColor = arc.custom && arc.custom.hoverBackgroundColor ? arc.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(arc._model.backgroundColor));
				arc._model.borderColor = arc.custom && arc.custom.hoverBorderColor ? arc.custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(arc._model.borderColor));
				arc._model.borderWidth = arc.custom && arc.custom.hoverBorderWidth ? arc.custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, arc._model.borderWidth);
			},
	
			removeHoverStyle: function(arc) {
				var dataset = this.chart.data.datasets[arc._datasetIndex];
				var index = arc._index;
	
				arc._model.backgroundColor = arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.arc.backgroundColor);
				arc._model.borderColor = arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.arc.borderColor);
				arc._model.borderWidth = arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.arc.borderWidth);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				} else {
					return 0;
				}
			}
		});
	};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
	
			hover: {
				mode: "label"
			},
	
			scales: {
				xAxes: [{
					type: "category",
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: "linear",
					id: 'y-axis-0'
				}]
			}
		};
	
	
		Chart.controllers.line = Chart.DatasetController.extend({
			addElements: function() {
				var meta = this.getMeta();
				meta.dataset = meta.dataset || new Chart.elements.Line({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_points: meta.data
				});
	
				helpers.each(this.getDataset().data, function(value, index) {
					meta.data[index] = meta.data[index] || new Chart.elements.Point({
						_chart: this.chart.chart,
						_datasetIndex: this.index,
						_index: index
					});
				}, this);
			},
	
			addElementAndReset: function(index) {
				var point = new Chart.elements.Point({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index
				});
	
				// Add to the points array and reset it
				this.getMeta().data.splice(index, 0, point);
				this.updateElement(point, index, true);
	
				// Make sure bezier control points are updated
				if (this.chart.options.showLines && this.chart.options.elements.line.tension !== 0)
					this.updateBezierControlPoints();
			},
	
			update: function update(reset) {
				var meta = this.getMeta();
				var line = meta.dataset;
				var points = meta.data;
	
				var yScale = this.getScaleForId(meta.yAxisID);
				var xScale = this.getScaleForId(meta.xAxisID);
				var scaleBase;
	
				if (yScale.min < 0 && yScale.max < 0) {
					scaleBase = yScale.getPixelForValue(yScale.max);
				} else if (yScale.min > 0 && yScale.max > 0) {
					scaleBase = yScale.getPixelForValue(yScale.min);
				} else {
					scaleBase = yScale.getPixelForValue(0);
				}
	
				// Update Line
				if (this.chart.options.showLines) {
					// Utility
					line._scale = yScale;
					line._datasetIndex = this.index;
					// Data
					line._children = points;
					// Model
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((this.getDataset().tension !== undefined) && (this.getDataset().lineTension === undefined))
					{
						this.getDataset().lineTension = this.getDataset().tension;
					}
	
					line._model = {
						// Appearance
						tension: line.custom && line.custom.tension ? line.custom.tension : helpers.getValueOrDefault(this.getDataset().lineTension, this.chart.options.elements.line.tension),
						backgroundColor: line.custom && line.custom.backgroundColor ? line.custom.backgroundColor : (this.getDataset().backgroundColor || this.chart.options.elements.line.backgroundColor),
						borderWidth: line.custom && line.custom.borderWidth ? line.custom.borderWidth : (this.getDataset().borderWidth || this.chart.options.elements.line.borderWidth),
						borderColor: line.custom && line.custom.borderColor ? line.custom.borderColor : (this.getDataset().borderColor || this.chart.options.elements.line.borderColor),
						borderCapStyle: line.custom && line.custom.borderCapStyle ? line.custom.borderCapStyle : (this.getDataset().borderCapStyle || this.chart.options.elements.line.borderCapStyle),
						borderDash: line.custom && line.custom.borderDash ? line.custom.borderDash : (this.getDataset().borderDash || this.chart.options.elements.line.borderDash),
						borderDashOffset: line.custom && line.custom.borderDashOffset ? line.custom.borderDashOffset : (this.getDataset().borderDashOffset || this.chart.options.elements.line.borderDashOffset),
						borderJoinStyle: line.custom && line.custom.borderJoinStyle ? line.custom.borderJoinStyle : (this.getDataset().borderJoinStyle || this.chart.options.elements.line.borderJoinStyle),
						fill: line.custom && line.custom.fill ? line.custom.fill : (this.getDataset().fill !== undefined ? this.getDataset().fill : this.chart.options.elements.line.fill),
						// Scale
						scaleTop: yScale.top,
						scaleBottom: yScale.bottom,
						scaleZero: scaleBase
					};
					line.pivot();
				}
	
				// Update Points
				helpers.each(points, function(point, index) {
					this.updateElement(point, index, reset);
				}, this);
	
				if (this.chart.options.showLines && this.chart.options.elements.line.tension !== 0)
					this.updateBezierControlPoints();
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
	
				if (point.custom && point.custom.backgroundColor) {
					backgroundColor = point.custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
	
				if (point.custom && point.custom.borderColor) {
					borderColor = point.custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(this.getDataset().pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
	
				if (point.custom && point.custom.borderWidth !== undefined) {
					borderWidth = point.custom.borderWidth;
				} else if (dataset.pointBorderWidth !== undefined) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (dataset.borderWidth !== undefined) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var meta = this.getMeta();
				var yScale = this.getScaleForId(meta.yAxisID);
				var xScale = this.getScaleForId(meta.xAxisID);
				var scaleBase;
	
				if (yScale.min < 0 && yScale.max < 0) {
					scaleBase = yScale.getPixelForValue(yScale.max);
				} else if (yScale.min > 0 && yScale.max > 0) {
					scaleBase = yScale.getPixelForValue(yScale.min);
				} else {
					scaleBase = yScale.getPixelForValue(0);
				}
	
				// Utility
				point._chart = this.chart.chart;
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = this.index;
				point._index = index;
	
				// Desired view properties
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((this.getDataset().radius !== undefined) && (this.getDataset().pointRadius === undefined))
				{
					this.getDataset().pointRadius = this.getDataset().radius;
				}
				if ((this.getDataset().hitRadius !== undefined) && (this.getDataset().pointHitRadius === undefined))
				{
					this.getDataset().pointHitRadius = this.getDataset().hitRadius;
				}
	
				point._model = {
					x: xScale.getPixelForValue(this.getDataset().data[index], index, this.index, this.chart.isCombo),
					y: reset ? scaleBase : this.calculatePointY(this.getDataset().data[index], index, this.index, this.chart.isCombo),
					// Appearance
					radius: point.custom && point.custom.radius ? point.custom.radius : helpers.getValueAtIndexOrDefault(this.getDataset().pointRadius, index, this.chart.options.elements.point.radius),
					pointStyle: point.custom && point.custom.pointStyle ? point.custom.pointStyle : helpers.getValueAtIndexOrDefault(this.getDataset().pointStyle, index, this.chart.options.elements.point.pointStyle),
					backgroundColor: this.getPointBackgroundColor(point, index),
					borderColor: this.getPointBorderColor(point, index),
					borderWidth: this.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					// Tooltip
					hitRadius: point.custom && point.custom.hitRadius ? point.custom.hitRadius : helpers.getValueAtIndexOrDefault(this.getDataset().pointHitRadius, index, this.chart.options.elements.point.hitRadius)
				};
	
				point._model.skip = point.custom && point.custom.skip ? point.custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
	
			calculatePointY: function(value, index, datasetIndex, isCombo) {
				var meta = this.getMeta();
				var xScale = this.getScaleForId(meta.xAxisID);
				var yScale = this.getScaleForId(meta.yAxisID);
	
				if (yScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = this.chart.data.datasets[i];
						var dsMeta = this.chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && this.chart.isDatasetVisible(i)) {
							if (ds.data[index] < 0) {
								sumNeg += ds.data[index] || 0;
							} else {
								sumPos += ds.data[index] || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					} else {
						return yScale.getPixelForValue(sumPos + value);
					}
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				// Update bezier control points
				var meta = this.getMeta();
				helpers.each(meta.data, function(point, index) {
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index)._model,
						point._model,
						helpers.nextItem(meta.data, index)._model,
						meta.dataset._model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					point._model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, this.chart.chartArea.right), this.chart.chartArea.left);
					point._model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, this.chart.chartArea.bottom), this.chart.chartArea.top);
	
					point._model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, this.chart.chartArea.right), this.chart.chartArea.left);
					point._model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, this.chart.chartArea.bottom), this.chart.chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				}, this);
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				if (this.chart.options.showLines)
					meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
	
				point._model.radius = point.custom && point.custom.hoverRadius ? point.custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				point._model.backgroundColor = point.custom && point.custom.hoverBackgroundColor ? point.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(point._model.backgroundColor));
				point._model.borderColor = point.custom && point.custom.hoverBorderColor ? point.custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(point._model.borderColor));
				point._model.borderWidth = point.custom && point.custom.hoverBorderWidth ? point.custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, point._model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((this.getDataset().radius !== undefined) && (this.getDataset().pointRadius === undefined))
				{
					this.getDataset().pointRadius = this.getDataset().radius;
				}
	
				point._model.radius = point.custom && point.custom.radius ? point.custom.radius : helpers.getValueAtIndexOrDefault(this.getDataset().pointRadius, index, this.chart.options.elements.point.radius);
				point._model.backgroundColor = this.getPointBackgroundColor(point, index);
				point._model.borderColor = this.getPointBorderColor(point, index);
				point._model.borderWidth = this.getPointBorderWidth(point, index);
			}
		});
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: "radialLinear",
				lineArc: true // so that lines are circular
			},
	
			//Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				if (chart.data.datasets.length) {
					for (var i = 0; i < chart.data.datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '">');
						if (chart.data.labels[i]) {
							text.push(chart.data.labels[i]);
						}
						text.push('</span></li>');
					}
				}
	
				text.push('</ul>');
				return text.join("");
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var fill = arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(ds.backgroundColor, i, this.chart.options.elements.arc.backgroundColor);
								var stroke = arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(ds.borderColor, i, this.chart.options.elements.arc.borderColor);
								var bw = arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(ds.borderWidth, i, this.chart.options.elements.arc.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							}, this);
						} else {
							return [];
						}
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
			linkScales: function() {
				// no scales for doughnut
			},
	
			addElements: function() {
				var meta = this.getMeta();
				helpers.each(this.getDataset().data, function(value, index) {
					meta.data[index] = meta.data[index] || new Chart.elements.Arc({
						_chart: this.chart.chart,
						_datasetIndex: this.index,
						_index: index
					});
				}, this);
			},
	
			addElementAndReset: function(index) {
				var arc = new Chart.elements.Arc({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index
				});
	
				// Add to the points array and reset it
				this.getMeta().data.splice(index, 0, arc);
				this.updateElement(arc, index, true);
			},
	
			update: function update(reset) {
				var meta = this.getMeta();
				var minSize = Math.min(this.chart.chartArea.right - this.chart.chartArea.left, this.chart.chartArea.bottom - this.chart.chartArea.top);
				this.chart.outerRadius = Math.max((minSize - this.chart.options.elements.arc.borderWidth / 2) / 2, 0);
				this.chart.innerRadius = Math.max(this.chart.options.cutoutPercentage ? (this.chart.outerRadius / 100) * (this.chart.options.cutoutPercentage) : 1, 0);
				this.chart.radiusLength = (this.chart.outerRadius - this.chart.innerRadius) / this.chart.getVisibleDatasetCount();
	
				this.outerRadius = this.chart.outerRadius - (this.chart.radiusLength * this.index);
				this.innerRadius = this.outerRadius - this.chart.radiusLength;
	
				meta.count = this.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					this.updateElement(arc, index, reset);
				}, this);
			},
	
			updateElement: function(arc, index, reset) {
				var circumference = this.calculateCircumference(this.getDataset().data[index]);
				var centerX = (this.chart.chartArea.left + this.chart.chartArea.right) / 2;
				var centerY = (this.chart.chartArea.top + this.chart.chartArea.bottom) / 2;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = this.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(this.getDataset().data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				var distance = arc.hidden? 0 : this.chart.scale.getDistanceFromCenterForValue(this.getDataset().data[index]);
				var startAngle = (-0.5 * Math.PI) + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden? 0 : circumference);
	
				var resetModel = {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: this.chart.options.animation.animateScale ? 0 : this.chart.scale.getDistanceFromCenterForValue(this.getDataset().data[index]),
					startAngle: this.chart.options.animation.animateRotate ? Math.PI * -0.5 : startAngle,
					endAngle: this.chart.options.animation.animateRotate ? Math.PI * -0.5 : endAngle,
	
					backgroundColor: arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.arc.backgroundColor),
					borderWidth: arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.arc.borderWidth),
					borderColor: arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.arc.borderColor),
	
					label: helpers.getValueAtIndexOrDefault(this.chart.data.labels, index, this.chart.data.labels[index])
				};
	
				helpers.extend(arc, {
					// Utility
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index,
					_scale: this.chart.scale,
	
					// Desired view properties
					_model: reset ? resetModel : {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: distance,
						startAngle: startAngle,
						endAngle: endAngle,
	
						backgroundColor: arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.arc.backgroundColor),
						borderWidth: arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.arc.borderWidth),
						borderColor: arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.arc.borderColor),
	
						label: helpers.getValueAtIndexOrDefault(this.chart.data.labels, index, this.chart.data.labels[index])
					}
				});
	
				arc.pivot();
			},
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				helpers.each(this.getMeta().data, function(arc, index) {
					arc.transition(easingDecimal).draw();
				});
			},
	
			setHoverStyle: function(arc) {
				var dataset = this.chart.data.datasets[arc._datasetIndex];
				var index = arc._index;
	
				arc._model.backgroundColor = arc.custom && arc.custom.hoverBackgroundColor ? arc.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(arc._model.backgroundColor));
				arc._model.borderColor = arc.custom && arc.custom.hoverBorderColor ? arc.custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(arc._model.borderColor));
				arc._model.borderWidth = arc.custom && arc.custom.hoverBorderWidth ? arc.custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, arc._model.borderWidth);
			},
	
			removeHoverStyle: function(arc) {
				var dataset = this.chart.data.datasets[arc._datasetIndex];
				var index = arc._index;
	
				arc._model.backgroundColor = arc.custom && arc.custom.backgroundColor ? arc.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().backgroundColor, index, this.chart.options.elements.arc.backgroundColor);
				arc._model.borderColor = arc.custom && arc.custom.borderColor ? arc.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().borderColor, index, this.chart.options.elements.arc.borderColor);
				arc._model.borderWidth = arc.custom && arc.custom.borderWidth ? arc.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().borderWidth, index, this.chart.options.elements.arc.borderWidth);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				} else {
					return 0;
				}
			}
		});
	};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
	
		Chart.defaults.radar = {
			scale: {
				type: "radialLinear"
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
			linkScales: function() {
				// No need. Single scale only
			},
	
			addElements: function() {
				var meta = this.getMeta();
	
				meta.dataset = meta.dataset || new Chart.elements.Line({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_points: meta.data,
					_loop: true
				});
	
				helpers.each(this.getDataset().data, function(value, index) {
					meta.data[index] = meta.data[index] || new Chart.elements.Point({
						_chart: this.chart.chart,
						_datasetIndex: this.index,
						_index: index,
						_model: {
							x: 0, //xScale.getPixelForValue(null, index, true),
							y: 0 //this.chartArea.bottom,
						}
					});
				}, this);
			},
			addElementAndReset: function(index) {
				var point = new Chart.elements.Point({
					_chart: this.chart.chart,
					_datasetIndex: this.index,
					_index: index
				});
	
				// Add to the points array and reset it
				this.getMeta().data.splice(index, 0, point);
				this.updateElement(point, index, true);
	
				// Make sure bezier control points are updated
				this.updateBezierControlPoints();
			},
	
			update: function update(reset) {
				var meta = this.getMeta();
				var line = meta.dataset;
				var points = meta.data;
	
				var scale = this.chart.scale;
				var scaleBase;
	
				if (scale.min < 0 && scale.max < 0) {
					scaleBase = scale.getPointPositionForValue(0, scale.max);
				} else if (scale.min > 0 && scale.max > 0) {
					scaleBase = scale.getPointPositionForValue(0, scale.min);
				} else {
					scaleBase = scale.getPointPositionForValue(0, 0);
				}
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((this.getDataset().tension !== undefined) && (this.getDataset().lineTension === undefined))
				{
					this.getDataset().lineTension = this.getDataset().tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: this.index,
					// Data
					_children: points,
					// Model
					_model: {
						// Appearance
						tension: line.custom && line.custom.tension ? line.custom.tension : helpers.getValueOrDefault(this.getDataset().lineTension, this.chart.options.elements.line.tension),
						backgroundColor: line.custom && line.custom.backgroundColor ? line.custom.backgroundColor : (this.getDataset().backgroundColor || this.chart.options.elements.line.backgroundColor),
						borderWidth: line.custom && line.custom.borderWidth ? line.custom.borderWidth : (this.getDataset().borderWidth || this.chart.options.elements.line.borderWidth),
						borderColor: line.custom && line.custom.borderColor ? line.custom.borderColor : (this.getDataset().borderColor || this.chart.options.elements.line.borderColor),
						fill: line.custom && line.custom.fill ? line.custom.fill : (this.getDataset().fill !== undefined ? this.getDataset().fill : this.chart.options.elements.line.fill),
						borderCapStyle: line.custom && line.custom.borderCapStyle ? line.custom.borderCapStyle : (this.getDataset().borderCapStyle || this.chart.options.elements.line.borderCapStyle),
						borderDash: line.custom && line.custom.borderDash ? line.custom.borderDash : (this.getDataset().borderDash || this.chart.options.elements.line.borderDash),
						borderDashOffset: line.custom && line.custom.borderDashOffset ? line.custom.borderDashOffset : (this.getDataset().borderDashOffset || this.chart.options.elements.line.borderDashOffset),
						borderJoinStyle: line.custom && line.custom.borderJoinStyle ? line.custom.borderJoinStyle : (this.getDataset().borderJoinStyle || this.chart.options.elements.line.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scaleBase
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					this.updateElement(point, index, reset);
				}, this);
	
	
				// Update bezier control points
				this.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var pointPosition = this.chart.scale.getPointPositionForValue(index, this.getDataset().data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: this.index,
					_index: index,
					_scale: this.chart.scale,
	
					// Desired view properties
					_model: {
						x: reset ? this.chart.scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? this.chart.scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: point.custom && point.custom.tension ? point.custom.tension : helpers.getValueOrDefault(this.getDataset().tension, this.chart.options.elements.line.tension),
						radius: point.custom && point.custom.radius ? point.custom.radius : helpers.getValueAtIndexOrDefault(this.getDataset().pointRadius, index, this.chart.options.elements.point.radius),
						backgroundColor: point.custom && point.custom.backgroundColor ? point.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().pointBackgroundColor, index, this.chart.options.elements.point.backgroundColor),
						borderColor: point.custom && point.custom.borderColor ? point.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().pointBorderColor, index, this.chart.options.elements.point.borderColor),
						borderWidth: point.custom && point.custom.borderWidth ? point.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().pointBorderWidth, index, this.chart.options.elements.point.borderWidth),
						pointStyle: point.custom && point.custom.pointStyle ? point.custom.pointStyle : helpers.getValueAtIndexOrDefault(this.getDataset().pointStyle, index, this.chart.options.elements.point.pointStyle),
	
						// Tooltip
						hitRadius: point.custom && point.custom.hitRadius ? point.custom.hitRadius : helpers.getValueAtIndexOrDefault(this.getDataset().hitRadius, index, this.chart.options.elements.point.hitRadius)
					}
				});
	
				point._model.skip = point.custom && point.custom.skip ? point.custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var meta = this.getMeta();
				helpers.each(meta.data, function(point, index) {
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						point._model,
						helpers.nextItem(meta.data, index, true)._model,
						point._model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					point._model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, this.chart.chartArea.right), this.chart.chartArea.left);
					point._model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, this.chart.chartArea.bottom), this.chart.chartArea.top);
	
					point._model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, this.chart.chartArea.right), this.chart.chartArea.left);
					point._model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, this.chart.chartArea.bottom), this.chart.chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				}, this);
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point, index) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
	
				point._model.radius = point.custom && point.custom.hoverRadius ? point.custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				point._model.backgroundColor = point.custom && point.custom.hoverBackgroundColor ? point.custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(point._model.backgroundColor));
				point._model.borderColor = point.custom && point.custom.hoverBorderColor ? point.custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(point._model.borderColor));
				point._model.borderWidth = point.custom && point.custom.hoverBorderWidth ? point.custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, point._model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
	
				point._model.radius = point.custom && point.custom.radius ? point.custom.radius : helpers.getValueAtIndexOrDefault(this.getDataset().radius, index, this.chart.options.elements.point.radius);
				point._model.backgroundColor = point.custom && point.custom.backgroundColor ? point.custom.backgroundColor : helpers.getValueAtIndexOrDefault(this.getDataset().pointBackgroundColor, index, this.chart.options.elements.point.backgroundColor);
				point._model.borderColor = point.custom && point.custom.borderColor ? point.custom.borderColor : helpers.getValueAtIndexOrDefault(this.getDataset().pointBorderColor, index, this.chart.options.elements.point.borderColor);
				point._model.borderWidth = point.custom && point.custom.borderWidth ? point.custom.borderWidth : helpers.getValueAtIndexOrDefault(this.getDataset().pointBorderWidth, index, this.chart.options.elements.point.borderWidth);
			}
		});
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: "bottom"
		};
	
		var DatasetScale = Chart.Scale.extend({
			// Implement this so that 
			determineDataLimits: function() {
				this.minIndex = 0;
				this.maxIndex = this.chart.data.labels.length - 1;
				var findIndex;
	
				if (this.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(this.chart.data.labels, this.options.ticks.min);
					this.minIndex = findIndex !== -1 ? findIndex : this.minIndex;
				}
	
				if (this.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(this.chart.data.labels, this.options.ticks.max);
					this.maxIndex = findIndex !== -1 ? findIndex : this.maxIndex;
				}
	
				this.min = this.chart.data.labels[this.minIndex];
				this.max = this.chart.data.labels[this.maxIndex];
			},
	
			buildTicks: function(index) {
				// If we are viewing some subset of labels, slice the original array
				this.ticks = (this.minIndex === 0 && this.maxIndex === this.chart.data.labels.length - 1) ? this.chart.data.labels : this.chart.data.labels.slice(this.minIndex, this.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				return this.ticks[index];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((this.maxIndex + 1 - this.minIndex - ((this.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (this.isHorizontal()) {
					var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
					var valueWidth = innerWidth / offsetAmt;
					var widthOffset = (valueWidth * (index - this.minIndex)) + this.paddingLeft;
	
					if (this.options.gridLines.offsetGridLines && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return this.left + Math.round(widthOffset);
				} else {
					var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
					var valueHeight = innerHeight / offsetAmt;
					var heightOffset = (valueHeight * (index - this.minIndex)) + this.paddingTop;
	
					if (this.options.gridLines.offsetGridLines && includeOffset) {
						heightOffset += (valueHeight / 2);
					}
	
					return this.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var value
	;			var offsetAmt = Math.max((this.ticks.length - ((this.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = this.isHorizontal();
				var innerDimension = horz ? this.width - (this.paddingLeft + this.paddingRight) : this.height - (this.paddingTop + this.paddingBottom);
				var valueDimension = innerDimension / offsetAmt;
	
				if (this.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
				pixel -= horz ? this.paddingLeft : this.paddingTop;
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			}
		});
	
		Chart.scaleService.registerScaleType("category", DatasetScale, defaultConfig);
	
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: "left",
			ticks: {
				callback: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				}
			}
		};
	
		var LinearScale = Chart.Scale.extend({
			determineDataLimits: function() {
				// First Calculate the range
				this.min = null;
				this.max = null;
	
				if (this.options.stacked) {
					var valuesPerType = {};
					var hasPositiveValues = false;
					var hasNegativeValues = false;
	
					helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
						var meta = this.chart.getDatasetMeta(datasetIndex);
						if (valuesPerType[meta.type] === undefined) {
							valuesPerType[meta.type] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerType[meta.type].positiveValues;
						var negativeValues = valuesPerType[meta.type].negativeValues;
	
						if (this.chart.isDatasetVisible(datasetIndex) && (this.isHorizontal() ? meta.xAxisID === this.id : meta.yAxisID === this.id)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +this.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (this.options.relativePoints) {
									positiveValues[index] = 100;
								} else {
									if (value < 0) {
										hasNegativeValues = true;
										negativeValues[index] += value;
									} else {
										hasPositiveValues = true;
										positiveValues[index] += value;
									}
								}
							}, this);
						}
					}, this);
	
					helpers.each(valuesPerType, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						this.min = this.min === null ? minVal : Math.min(this.min, minVal);
						this.max = this.max === null ? maxVal : Math.max(this.max, maxVal);
					}, this);
	
				} else {
					helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
						var meta = this.chart.getDatasetMeta(datasetIndex);
						if (this.chart.isDatasetVisible(datasetIndex) && (this.isHorizontal() ? meta.xAxisID === this.id : meta.yAxisID === this.id)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +this.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (this.min === null) {
									this.min = value;
								} else if (value < this.min) {
									this.min = value;
								}
	
								if (this.max === null) {
									this.max = value;
								} else if (value > this.max) {
									this.max = value;
								}
							}, this);
						}
					}, this);
				}
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (this.options.ticks.beginAtZero) {
					var minSign = helpers.sign(this.min);
					var maxSign = helpers.sign(this.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						this.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the botttom down to 0
						this.min = 0;
					}
				}
	
				if (this.options.ticks.min !== undefined) {
					this.min = this.options.ticks.min;
				} else if (this.options.ticks.suggestedMin !== undefined) {
					this.min = Math.min(this.min, this.options.ticks.suggestedMin);
				}
	
				if (this.options.ticks.max !== undefined) {
					this.max = this.options.ticks.max;
				} else if (this.options.ticks.suggestedMax !== undefined) {
					this.max = Math.max(this.max, this.options.ticks.suggestedMax);
				}
	
				if (this.min === this.max) {
					this.max++;
	
					if (!this.options.ticks.beginAtZero) {
						this.min--;
					}
				}
			},
			buildTicks: function() {
	
				// Then calulate the ticks
				this.ticks = [];
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var maxTicks;
	
				if (this.isHorizontal()) {
					maxTicks = Math.min(this.options.ticks.maxTicksLimit ? this.options.ticks.maxTicksLimit : 11, Math.ceil(this.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(this.options.ticks.maxTicksLimit ? this.options.ticks.maxTicksLimit : 11, Math.ceil(this.height / (2 * tickFontSize)));
				}
	
				// Make sure we always have at least 2 ticks
				maxTicks = Math.max(2, maxTicks);
	
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				var fixedStepSizeSet = (this.options.ticks.fixedStepSize && this.options.ticks.fixedStepSize > 0) || (this.options.ticks.stepSize && this.options.ticks.stepSize > 0);
				if (fixedStepSizeSet) {
					spacing = helpers.getValueOrDefault(this.options.ticks.fixedStepSize, this.options.ticks.stepSize);
				} else {
					var niceRange = helpers.niceNum(this.max - this.min, false);
					spacing = helpers.niceNum(niceRange / (maxTicks - 1), true);
				}
				var niceMin = Math.floor(this.min / spacing) * spacing;
				var niceMax = Math.ceil(this.max / spacing) * spacing;
				var numSpaces = (niceMax - niceMin) / spacing;
	
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				this.ticks.push(this.options.ticks.min !== undefined ? this.options.ticks.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					this.ticks.push(niceMin + (j * spacing));
				}
				this.ticks.push(this.options.ticks.max !== undefined ? this.options.ticks.max : niceMax);
	
				if (this.options.position === "left" || this.options.position === "right") {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				this.max = helpers.max(this.ticks);
				this.min = helpers.min(this.ticks);
	
				if (this.options.ticks.reverse) {
					this.ticks.reverse();
	
					this.start = this.max;
					this.end = this.min;
				} else {
					this.start = this.min;
					this.end = this.max;
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			convertTicksToLabels: function() {
				this.ticksAsNumbers = this.ticks.slice();
				this.zeroLineIndex = this.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Utils
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				// This must be called after fit has been run so that
				//      this.left, this.top, this.right, and this.bottom have been defined
				var rightValue = +this.getRightValue(value);
				var pixel;
				var range = this.end - this.start;
	
				if (this.isHorizontal()) {
					var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
					pixel = this.left + (innerWidth / range * (rightValue - this.start));
					return Math.round(pixel + this.paddingLeft);
				} else {
					var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
					pixel = (this.bottom - this.paddingBottom) - (innerHeight / range * (rightValue - this.start));
					return Math.round(pixel);
				}
			},
			getValueForPixel: function(pixel) {
				var offset;
	
				if (this.isHorizontal()) {
					var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
					offset = (pixel - this.left - this.paddingLeft) / innerWidth;
				} else {
					var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
					offset = (this.bottom - this.paddingBottom - pixel) / innerHeight;
				}
	
				return this.start + ((this.end - this.start) * offset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticksAsNumbers[index], null, null, includeOffset);
			}
		});
		Chart.scaleService.registerScaleType("linear", LinearScale, defaultConfig);
	
	};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: "left",
	
			// label settings
			ticks: {
				callback: function(value, index, arr) {
					var remain = value / (Math.pow(10, Math.floor(Chart.helpers.log10(value))));
	
					if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === arr.length - 1) {
						return value.toExponential();
					} else {
						return '';
					}
				}
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				// Calculate Range
				this.min = null;
				this.max = null;
	
				if (this.options.stacked) {
					var valuesPerType = {};
	
					helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
						var meta = this.chart.getDatasetMeta(datasetIndex);
						if (this.chart.isDatasetVisible(datasetIndex) && (this.isHorizontal() ? meta.xAxisID === this.id : meta.yAxisID === this.id)) {
							if (valuesPerType[meta.type] === undefined) {
								valuesPerType[meta.type] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerType[meta.type];
								var value = +this.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (this.options.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							}, this);
						}
					}, this);
	
					helpers.each(valuesPerType, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						this.min = this.min === null ? minVal : Math.min(this.min, minVal);
						this.max = this.max === null ? maxVal : Math.max(this.max, maxVal);
					}, this);
	
				} else {
					helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
						var meta = this.chart.getDatasetMeta(datasetIndex);
						if (this.chart.isDatasetVisible(datasetIndex) && (this.isHorizontal() ? meta.xAxisID === this.id : meta.yAxisID === this.id)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +this.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (this.min === null) {
									this.min = value;
								} else if (value < this.min) {
									this.min = value;
								}
	
								if (this.max === null) {
									this.max = value;
								} else if (value > this.max) {
									this.max = value;
								}
							}, this);
						}
					}, this);
				}
	
				this.min = this.options.ticks.min !== undefined ? this.options.ticks.min : this.min;
				this.max = this.options.ticks.max !== undefined ? this.options.ticks.max : this.max;
	
				if (this.min === this.max) {
					if (this.min !== 0 && this.min !== null) {
						this.min = Math.pow(10, Math.floor(helpers.log10(this.min)) - 1);
						this.max = Math.pow(10, Math.floor(helpers.log10(this.max)) + 1);
					} else {
						this.min = 1;
						this.max = 10;
					}
				}
			},
			buildTicks: function() {
				// Reset the ticks array. Later on, we will draw a grid line at these positions
				// The array simply contains the numerical value of the spots where ticks will be
				this.ticks = [];
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var tickVal = this.options.ticks.min !== undefined ? this.options.ticks.min : Math.pow(10, Math.floor(helpers.log10(this.min)));
	
				while (tickVal < this.max) {
					this.ticks.push(tickVal);
	
					var exp = Math.floor(helpers.log10(tickVal));
					var significand = Math.floor(tickVal / Math.pow(10, exp)) + 1;
	
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				}
	
				var lastTick = this.options.ticks.max !== undefined ? this.options.ticks.max : tickVal;
				this.ticks.push(lastTick);
	
				if (this.options.position === "left" || this.options.position === "right") {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				this.max = helpers.max(this.ticks);
				this.min = helpers.min(this.ticks);
	
				if (this.options.ticks.reverse) {
					this.ticks.reverse();
	
					this.start = this.max;
					this.end = this.min;
				} else {
					this.start = this.min;
					this.end = this.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.tickValues[index], null, null, includeOffset);
			},
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var pixel;
	
				var newVal = +this.getRightValue(value)
	;			var range = helpers.log10(this.end) - helpers.log10(this.start);
	
				if (this.isHorizontal()) {
	
					if (newVal === 0) {
						pixel = this.left + this.paddingLeft;
					} else {
						var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
						pixel = this.left + (innerWidth / range * (helpers.log10(newVal) - helpers.log10(this.start)));
						pixel += this.paddingLeft;
					}
				} else {
					// Bottom - top since pixels increase downard on a screen
					if (newVal === 0) {
						pixel = this.top + this.paddingTop;
					} else {
						var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
						pixel = (this.bottom - this.paddingBottom) - (innerHeight / range * (helpers.log10(newVal) - helpers.log10(this.start)));
					}
				}
	
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var offset;
				var range = helpers.log10(this.end) - helpers.log10(this.start);
				var value;
	
				if (this.isHorizontal()) {
					var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
					value = this.start * Math.pow(10, (pixel - this.left - this.paddingLeft) * range / innerWidth);
				} else {
					var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
					value = Math.pow(10, (this.bottom - this.paddingBottom - pixel) * range / innerHeight) / this.start;
				}
	
				return value;
			}
	
		});
		Chart.scaleService.registerScaleType("logarithmic", LogarithmicScale, defaultConfig);
	
	};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			display: true,
	
			//Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: "chartArea",
	
			angleLines: {
				display: true,
				color: "rgba(0, 0, 0, 0.1)",
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				//Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				//String - The colour of the label backdrop
				backdropColor: "rgba(255,255,255,0.75)",
	
				//Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				//Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2
			},
	
			pointLabels: {
				//Number - Point label font size in pixels
				fontSize: 10,
	
				//Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		var LinearRadialScale = Chart.Scale.extend({
			getValueCount: function() {
				return this.chart.data.labels.length;
			},
			setDimensions: function() {
				// Set the unconstrained dimension before label rotation
				this.width = this.maxWidth;
				this.height = this.maxHeight;
				this.xCenter = Math.round(this.width / 2);
				this.yCenter = Math.round(this.height / 2);
	
				var minSize = helpers.min([this.height, this.width]);
				var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				this.drawingArea = (this.options.display) ? (minSize / 2) - (tickFontSize / 2 + this.options.ticks.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				this.min = null;
				this.max = null;
	
				helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
					if (this.chart.isDatasetVisible(datasetIndex)) {
						var meta = this.chart.getDatasetMeta(datasetIndex);
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +this.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							if (this.min === null) {
								this.min = value;
							} else if (value < this.min) {
								this.min = value;
							}
	
							if (this.max === null) {
								this.max = value;
							} else if (value > this.max) {
								this.max = value;
							}
						}, this);
					}
				}, this);
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (this.options.ticks.beginAtZero) {
					var minSign = helpers.sign(this.min);
					var maxSign = helpers.sign(this.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						this.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the botttom down to 0
						this.min = 0;
					}
				}
	
				if (this.options.ticks.min !== undefined) {
					this.min = this.options.ticks.min;
				} else if (this.options.ticks.suggestedMin !== undefined) {
					this.min = Math.min(this.min, this.options.ticks.suggestedMin);
				}
	
				if (this.options.ticks.max !== undefined) {
					this.max = this.options.ticks.max;
				} else if (this.options.ticks.suggestedMax !== undefined) {
					this.max = Math.max(this.max, this.options.ticks.suggestedMax);
				}
	
				if (this.min === this.max) {
					this.min--;
					this.max++;
				}
			},
			buildTicks: function() {
	
	
				this.ticks = [];
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
				var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var maxTicks = Math.min(this.options.ticks.maxTicksLimit ? this.options.ticks.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
				maxTicks = Math.max(2, maxTicks); // Make sure we always have at least 2 ticks
	
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var niceRange = helpers.niceNum(this.max - this.min, false);
				var spacing = helpers.niceNum(niceRange / (maxTicks - 1), true);
				var niceMin = Math.floor(this.min / spacing) * spacing;
				var niceMax = Math.ceil(this.max / spacing) * spacing;
	
				var numSpaces = Math.ceil((niceMax - niceMin) / spacing);
	
				// Put the values into the ticks array
				this.ticks.push(this.options.ticks.min !== undefined ? this.options.ticks.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					this.ticks.push(niceMin + (j * spacing));
				}
				this.ticks.push(this.options.ticks.max !== undefined ? this.options.ticks.max : niceMax);
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				this.max = helpers.max(this.ticks);
				this.min = helpers.min(this.ticks);
	
				if (this.options.ticks.reverse) {
					this.ticks.reverse();
	
					this.start = this.max;
					this.end = this.min;
				} else {
					this.start = this.min;
					this.end = this.max;
				}
	
				this.zeroLineIndex = this.ticks.indexOf(0);
			},
			convertTicksToLabels: function() {
				Chart.Scale.prototype.convertTicksToLabels.call(this);
	
				// Point labels
				this.pointLabels = this.chart.data.labels.map(this.options.pointLabels.callback, this);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				/*
				 * Right, this is really confusing and there is a lot of maths going on here
				 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
				 *
				 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
				 *
				 * Solution:
				 *
				 * We assume the radius of the polygon is half the size of the canvas at first
				 * at each index we check if the text overlaps.
				 *
				 * Where it does, we store that angle and that index.
				 *
				 * After finding the largest index and angle we calculate how much we need to remove
				 * from the shape radius to move the point inwards by that x.
				 *
				 * We average the left and right distances to get the maximum shape radius that can fit in the box
				 * along with labels.
				 *
				 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
				 * on each side, removing that from the size, halving it and adding the left x protrusion width.
				 *
				 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
				 * and position it in the most space efficient manner
				 *
				 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
				 */
	
				var pointLabelFontSize = helpers.getValueOrDefault(this.options.pointLabels.fontSize, Chart.defaults.global.defaultFontSize);
				var pointLabeFontStyle = helpers.getValueOrDefault(this.options.pointLabels.fontStyle, Chart.defaults.global.defaultFontStyle);
				var pointLabeFontFamily = helpers.getValueOrDefault(this.options.pointLabels.fontFamily, Chart.defaults.global.defaultFontFamily);
				var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
				// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
				// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
				var largestPossibleRadius = helpers.min([(this.height / 2 - pointLabelFontSize - 5), this.width / 2]),
					pointPosition,
					i,
					textWidth,
					halfTextWidth,
					furthestRight = this.width,
					furthestRightIndex,
					furthestRightAngle,
					furthestLeft = 0,
					furthestLeftIndex,
					furthestLeftAngle,
					xProtrusionLeft,
					xProtrusionRight,
					radiusReductionRight,
					radiusReductionLeft,
					maxWidthRadius;
				this.ctx.font = pointLabeFont;
	
				for (i = 0; i < this.getValueCount(); i++) {
					// 5px to space the text slightly out - similar to what we do in the draw function.
					pointPosition = this.getPointPosition(i, largestPossibleRadius);
					textWidth = this.ctx.measureText(this.pointLabels[i] ? this.pointLabels[i] : '').width + 5;
					if (i === 0 || i === this.getValueCount() / 2) {
						// If we're at index zero, or exactly the middle, we're at exactly the top/bottom
						// of the radar chart, so text will be aligned centrally, so we'll half it and compare
						// w/left and right text sizes
						halfTextWidth = textWidth / 2;
						if (pointPosition.x + halfTextWidth > furthestRight) {
							furthestRight = pointPosition.x + halfTextWidth;
							furthestRightIndex = i;
						}
						if (pointPosition.x - halfTextWidth < furthestLeft) {
							furthestLeft = pointPosition.x - halfTextWidth;
							furthestLeftIndex = i;
						}
					} else if (i < this.getValueCount() / 2) {
						// Less than half the values means we'll left align the text
						if (pointPosition.x + textWidth > furthestRight) {
							furthestRight = pointPosition.x + textWidth;
							furthestRightIndex = i;
						}
					} else if (i > this.getValueCount() / 2) {
						// More than half the values means we'll right align the text
						if (pointPosition.x - textWidth < furthestLeft) {
							furthestLeft = pointPosition.x - textWidth;
							furthestLeftIndex = i;
						}
					}
				}
	
				xProtrusionLeft = furthestLeft;
				xProtrusionRight = Math.ceil(furthestRight - this.width);
	
				furthestRightAngle = this.getIndexAngle(furthestRightIndex);
				furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);
	
				radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI / 2);
				radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI / 2);
	
				// Ensure we actually need to reduce the size of the chart
				radiusReductionRight = (helpers.isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
				radiusReductionLeft = (helpers.isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;
	
				this.drawingArea = Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2);
				this.setCenterPoint(radiusReductionLeft, radiusReductionRight);
			},
			setCenterPoint: function(leftMovement, rightMovement) {
	
				var maxRight = this.width - rightMovement - this.drawingArea,
					maxLeft = leftMovement + this.drawingArea;
	
				this.xCenter = Math.round(((maxLeft + maxRight) / 2) + this.left);
				// Always vertically in the centre as the text height doesn't change
				this.yCenter = Math.round((this.height / 2) + this.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / this.getValueCount();
				// Start from the top instead of right, so remove a quarter of the circle
	
				return index * angleMultiplier - (Math.PI / 2);
			},
			getDistanceFromCenterForValue: function(value) {
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = this.drawingArea / (this.max - this.min);
				if (this.options.reverse) {
					return (this.max - value) * scalingFactor;
				} else {
					return (value - this.min) * scalingFactor;
				}
			},
			getPointPosition: function(index, distanceFromCenter) {
				var thisAngle = this.getIndexAngle(index);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + this.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + this.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
			draw: function() {
				if (this.options.display) {
					var ctx = this.ctx;
					helpers.each(this.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || this.options.reverse) {
							var yCenterOffset = this.getDistanceFromCenterForValue(this.ticks[index]);
							var yHeight = this.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (this.options.gridLines.display) {
								ctx.strokeStyle = this.options.gridLines.color;
								ctx.lineWidth = this.options.gridLines.lineWidth;
	
								if (this.options.lineArc) {
									// Draw circular arcs between the points
									ctx.beginPath();
									ctx.arc(this.xCenter, this.yCenter, yCenterOffset, 0, Math.PI * 2);
									ctx.closePath();
									ctx.stroke();
								} else {
									// Draw straight lines connecting each index
									ctx.beginPath();
									for (var i = 0; i < this.getValueCount(); i++) {
										var pointPosition = this.getPointPosition(i, this.getDistanceFromCenterForValue(this.ticks[index]));
										if (i === 0) {
											ctx.moveTo(pointPosition.x, pointPosition.y);
										} else {
											ctx.lineTo(pointPosition.x, pointPosition.y);
										}
									}
									ctx.closePath();
									ctx.stroke();
								}
							}
	
							if (this.options.ticks.display) {
								var tickFontColor = helpers.getValueOrDefault(this.options.ticks.fontColor, Chart.defaults.global.defaultFontColor);
								var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
								var tickFontStyle = helpers.getValueOrDefault(this.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
								var tickFontFamily = helpers.getValueOrDefault(this.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
								var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
								ctx.font = tickLabelFont;
	
								if (this.options.ticks.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = this.options.ticks.backdropColor;
									ctx.fillRect(
										this.xCenter - labelWidth / 2 - this.options.ticks.backdropPaddingX,
										yHeight - tickFontSize / 2 - this.options.ticks.backdropPaddingY,
										labelWidth + this.options.ticks.backdropPaddingX * 2,
										tickFontSize + this.options.ticks.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = "middle";
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, this.xCenter, yHeight);
							}
						}
					}, this);
	
					if (!this.options.lineArc) {
						ctx.lineWidth = this.options.angleLines.lineWidth;
						ctx.strokeStyle = this.options.angleLines.color;
	
						for (var i = this.getValueCount() - 1; i >= 0; i--) {
							if (this.options.angleLines.display) {
								var outerPosition = this.getPointPosition(i, this.getDistanceFromCenterForValue(this.options.reverse ? this.min : this.max));
								ctx.beginPath();
								ctx.moveTo(this.xCenter, this.yCenter);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.stroke();
								ctx.closePath();
							}
							// Extra 3px out for some label spacing
							var pointLabelPosition = this.getPointPosition(i, this.getDistanceFromCenterForValue(this.options.reverse ? this.min : this.max) + 5);
	
							var pointLabelFontColor = helpers.getValueOrDefault(this.options.pointLabels.fontColor, Chart.defaults.global.defaultFontColor);
							var pointLabelFontSize = helpers.getValueOrDefault(this.options.pointLabels.fontSize, Chart.defaults.global.defaultFontSize);
							var pointLabeFontStyle = helpers.getValueOrDefault(this.options.pointLabels.fontStyle, Chart.defaults.global.defaultFontStyle);
							var pointLabeFontFamily = helpers.getValueOrDefault(this.options.pointLabels.fontFamily, Chart.defaults.global.defaultFontFamily);
							var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
							ctx.font = pointLabeFont;
							ctx.fillStyle = pointLabelFontColor;
	
							var labelsCount = this.pointLabels.length,
								halfLabelsCount = this.pointLabels.length / 2,
								quarterLabelsCount = halfLabelsCount / 2,
								upperHalf = (i < quarterLabelsCount || i > labelsCount - quarterLabelsCount),
								exactQuarter = (i === quarterLabelsCount || i === labelsCount - quarterLabelsCount);
							if (i === 0) {
								ctx.textAlign = 'center';
							} else if (i === halfLabelsCount) {
								ctx.textAlign = 'center';
							} else if (i < halfLabelsCount) {
								ctx.textAlign = 'left';
							} else {
								ctx.textAlign = 'right';
							}
	
							// Set the correct text baseline based on outer positioning
							if (exactQuarter) {
								ctx.textBaseline = 'middle';
							} else if (upperHalf) {
								ctx.textBaseline = 'bottom';
							} else {
								ctx.textBaseline = 'top';
							}
	
							ctx.fillText(this.pointLabels[i] ? this.pointLabels[i] : '', pointLabelPosition.x, pointLabelPosition.y);
						}
					}
				}
			}
		});
		Chart.scaleService.registerScaleType("radialLinear", LinearRadialScale, defaultConfig);
	
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/*global window: false */
	"use strict";
	
	var moment = __webpack_require__(84);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: "bottom",
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					'millisecond': 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					'second': 'h:mm:ss a', // 11:20:01 AM
					'minute': 'h:mm:ss a', // 11:20:01 AM
					'hour': 'MMM D, hA', // Sept 4, 5PM
					'day': 'll', // Sep 4 2015
					'week': 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					'month': 'MMM YYYY', // Sept 2015
					'quarter': '[Q]Q - YYYY', // Q3
					'year': 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				return this.labelMoments[datasetIndex][index];
			},
			getMomentStartOf: function(tick) {
				if (this.options.time.unit === 'week' && this.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(this.options.time.isoWeekday);
				} else {
					return tick.clone().startOf(this.tickUnit);
				}
			},
			determineDataLimits: function() {
				this.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (this.chart.data.labels && this.chart.data.labels.length > 0) {
					helpers.each(this.chart.data.labels, function(label, index) {
						var labelMoment = this.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (this.options.time.round) {
								labelMoment.startOf(this.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, this);
	
					this.firstTick = moment.min.call(this, scaleLabelMoments);
					this.lastTick = moment.max.call(this, scaleLabelMoments);
				} else {
					this.firstTick = null;
					this.lastTick = null;
				}
	
				helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = this.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object') {
						helpers.each(dataset.data, function(value, index) {
							var labelMoment = this.parseTime(this.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (this.options.time.round) {
									labelMoment.startOf(this.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									this.firstTick = this.firstTick !== null ? moment.min(this.firstTick, labelMoment) : labelMoment;
									this.lastTick = this.lastTick !== null ? moment.max(this.lastTick, labelMoment) : labelMoment;
								}
							}
						}, this);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					this.labelMoments.push(momentsForDataset);
				}, this);
	
				// Set these after we've done all the data
				if (this.options.time.min) {
					this.firstTick = this.parseTime(this.options.time.min);
				}
	
				if (this.options.time.max) {
					this.lastTick = this.parseTime(this.options.time.max);
				}
	
				// We will modify these, so clone for later
				this.firstTick = (this.firstTick || moment()).clone();
				this.lastTick = (this.lastTick || moment()).clone();
			},
			buildTicks: function(index) {
	
				this.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(this.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(this.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(this.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				this.ctx.font = tickLabelFont;
	
				this.ticks = [];
				this.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				this.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (this.options.time.unit) {
					this.tickUnit = this.options.time.unit || 'day';
					this.displayFormat = this.options.time.displayFormats[this.tickUnit];
					this.scaleSizeInUnits = this.lastTick.diff(this.firstTick, this.tickUnit, true);
					this.unitScale = helpers.getValueOrDefault(this.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = this.isHorizontal() ? this.width - (this.paddingLeft + this.paddingRight) : this.height - (this.paddingTop + this.paddingBottom);
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = this.tickFormatFunction(this.firstTick, 0, []);
					var tickLabelWidth = this.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(this.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(this.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					this.tickUnit = 'millisecond';
					this.scaleSizeInUnits = this.lastTick.diff(this.firstTick, this.tickUnit, true);
					this.displayFormat = this.options.time.displayFormats[this.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						this.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(this.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the prefedined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(this.scaleSizeInUnits / labelCapacity)) {
									this.unitScale = helpers.getValueOrDefault(this.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(this.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							this.unitScale = helpers.getValueOrDefault(this.options.time.unitStepSize, Math.ceil(this.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							this.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = this.firstTick.diff(this.getMomentStartOf(this.firstTick), this.tickUnit, true);
							var trailingUnitBuffer = this.getMomentStartOf(this.lastTick.clone().add(1, this.tickUnit)).diff(this.lastTick, this.tickUnit, true);
							this.scaleSizeInUnits = this.lastTick.diff(this.firstTick, this.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							this.displayFormat = this.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!this.options.time.min) {
					this.firstTick = this.getMomentStartOf(this.firstTick);
					roundedStart = this.firstTick;
				} else {
					roundedStart = this.getMomentStartOf(this.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!this.options.time.max) {
					var roundedEnd = this.getMomentStartOf(this.lastTick);
					if (roundedEnd.diff(this.lastTick, this.tickUnit, true) !== 0) {
						// Do not use end of because we need this to be in the next time unit
						this.lastTick = this.getMomentStartOf(this.lastTick.add(1, this.tickUnit));
					}
				}
	
				this.smallestLabelSeparation = this.width;
	
				helpers.each(this.chart.data.datasets, function(dataset, datasetIndex) {
					for (var i = 1; i < this.labelMoments[datasetIndex].length; i++) {
						this.smallestLabelSeparation = Math.min(this.smallestLabelSeparation, this.labelMoments[datasetIndex][i].diff(this.labelMoments[datasetIndex][i - 1], this.tickUnit, true));
					}
				}, this);
	
				// Tick displayFormat override
				if (this.options.time.displayFormat) {
					this.displayFormat = this.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				this.ticks.push(this.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = 1; i <= this.scaleSizeInUnits; ++i) {
					var newTick = roundedStart.clone().add(i, this.tickUnit);
	
					// Are we greater than the max time
					if (this.options.time.max && newTick.diff(this.lastTick, this.tickUnit, true) >= 0) {
						break;
					}
	
					if (i % this.unitScale === 0) {
						this.ticks.push(newTick);
					}
				}
	
				// Always show the right tick
				var diff = this.ticks[this.ticks.length - 1].diff(this.lastTick, this.tickUnit);
				if (diff !== 0 || this.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (this.options.time.max) {
						this.ticks.push(this.lastTick.clone());
						this.scaleSizeInUnits = this.lastTick.diff(this.ticks[0], this.tickUnit, true);
					} else {
						this.ticks.push(this.lastTick.clone());
						this.scaleSizeInUnits = this.lastTick.diff(this.firstTick, this.tickUnit, true);
					}
				}
	
				this.ctx.restore();
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var label = this.chart.data.labels && index < this.chart.data.labels.length ? this.chart.data.labels[index] : '';
	
				if (typeof this.chart.data.datasets[datasetIndex].data[0] === 'object') {
					label = this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
				}
	
				// Format nicely
				if (this.options.time.tooltipFormat) {
					label = this.parseTime(label).format(this.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function tickFormatFunction(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				} else {
					return formattedTick;
				}
			},
			convertTicksToLabels: function() {
				this.tickMoments = this.ticks;
				this.ticks = this.ticks.map(this.tickFormatFunction, this);
			},
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var labelMoment = value && value.isValid && value.isValid() ? value : this.getLabelMoment(datasetIndex, index);
	
				if (labelMoment) {
					var offset = labelMoment.diff(this.firstTick, this.tickUnit, true);
	
					var decimal = offset / this.scaleSizeInUnits;
	
					if (this.isHorizontal()) {
						var innerWidth = this.width - (this.paddingLeft + this.paddingRight);
						var valueWidth = innerWidth / Math.max(this.ticks.length - 1, 1);
						var valueOffset = (innerWidth * decimal) + this.paddingLeft;
	
						return this.left + Math.round(valueOffset);
					} else {
						var innerHeight = this.height - (this.paddingTop + this.paddingBottom);
						var valueHeight = innerHeight / Math.max(this.ticks.length - 1, 1);
						var heightOffset = (innerHeight * decimal) + this.paddingTop;
	
						return this.top + Math.round(heightOffset);
					}
				}
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.tickMoments[index], null, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var innerDimension = this.isHorizontal() ? this.width - (this.paddingLeft + this.paddingRight) : this.height - (this.paddingTop + this.paddingBottom);
				var offset = (pixel - (this.isHorizontal() ? this.left + this.paddingLeft : this.top + this.paddingTop)) / innerDimension;
				offset *= this.scaleSizeInUnits;
				return this.firstTick.clone().add(moment.duration(offset, this.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				if (typeof this.options.time.parser === 'string') {
					return moment(label, this.options.time.parser);
				}
				if (typeof this.options.time.parser === 'function') {
					return this.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof this.options.time.format !== 'string' && this.options.time.format.call) {
					console.warn("options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale");
					return this.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, this.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType("time", TimeScale, defaultConfig);
	
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.13.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function isObject(input) {
	        return Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(86)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale');
	                config = mergeConfigs(locales[name]._config, config);
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    config = mergeConfigs(locales[config.parentLocale]._config, config);
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet');
	                }
	            }
	            locales[name] = new Locale(config);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale;
	            if (locales[name] != null) {
	                config = mergeConfigs(locales[name]._config, config);
	            }
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             if (this.isValid() && other.isValid()) {
	                 return other < this ? this : other;
	             } else {
	                 return valid__createInvalid();
	             }
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(this.valueOf()) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = getSet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = getSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto._months           = defaultLocaleMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto._monthsRegex      = defaultMonthsRegex;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto._weekdaysRegex      = defaultWeekdaysRegex;
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto._weekdaysShortRegex = defaultWeekdaysShortRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto._weekdaysMinRegex   = defaultWeekdaysMinRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.13.0';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module)))

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 87,
		"./af.js": 87,
		"./ar": 88,
		"./ar-ma": 89,
		"./ar-ma.js": 89,
		"./ar-sa": 90,
		"./ar-sa.js": 90,
		"./ar-tn": 91,
		"./ar-tn.js": 91,
		"./ar.js": 88,
		"./az": 92,
		"./az.js": 92,
		"./be": 93,
		"./be.js": 93,
		"./bg": 94,
		"./bg.js": 94,
		"./bn": 95,
		"./bn.js": 95,
		"./bo": 96,
		"./bo.js": 96,
		"./br": 97,
		"./br.js": 97,
		"./bs": 98,
		"./bs.js": 98,
		"./ca": 99,
		"./ca.js": 99,
		"./cs": 100,
		"./cs.js": 100,
		"./cv": 101,
		"./cv.js": 101,
		"./cy": 102,
		"./cy.js": 102,
		"./da": 103,
		"./da.js": 103,
		"./de": 104,
		"./de-at": 105,
		"./de-at.js": 105,
		"./de.js": 104,
		"./dv": 106,
		"./dv.js": 106,
		"./el": 107,
		"./el.js": 107,
		"./en-au": 108,
		"./en-au.js": 108,
		"./en-ca": 109,
		"./en-ca.js": 109,
		"./en-gb": 110,
		"./en-gb.js": 110,
		"./en-ie": 111,
		"./en-ie.js": 111,
		"./en-nz": 112,
		"./en-nz.js": 112,
		"./eo": 113,
		"./eo.js": 113,
		"./es": 114,
		"./es.js": 114,
		"./et": 115,
		"./et.js": 115,
		"./eu": 116,
		"./eu.js": 116,
		"./fa": 117,
		"./fa.js": 117,
		"./fi": 118,
		"./fi.js": 118,
		"./fo": 119,
		"./fo.js": 119,
		"./fr": 120,
		"./fr-ca": 121,
		"./fr-ca.js": 121,
		"./fr-ch": 122,
		"./fr-ch.js": 122,
		"./fr.js": 120,
		"./fy": 123,
		"./fy.js": 123,
		"./gd": 124,
		"./gd.js": 124,
		"./gl": 125,
		"./gl.js": 125,
		"./he": 126,
		"./he.js": 126,
		"./hi": 127,
		"./hi.js": 127,
		"./hr": 128,
		"./hr.js": 128,
		"./hu": 129,
		"./hu.js": 129,
		"./hy-am": 130,
		"./hy-am.js": 130,
		"./id": 131,
		"./id.js": 131,
		"./is": 132,
		"./is.js": 132,
		"./it": 133,
		"./it.js": 133,
		"./ja": 134,
		"./ja.js": 134,
		"./jv": 135,
		"./jv.js": 135,
		"./ka": 136,
		"./ka.js": 136,
		"./kk": 137,
		"./kk.js": 137,
		"./km": 138,
		"./km.js": 138,
		"./ko": 139,
		"./ko.js": 139,
		"./ky": 140,
		"./ky.js": 140,
		"./lb": 141,
		"./lb.js": 141,
		"./lo": 142,
		"./lo.js": 142,
		"./lt": 143,
		"./lt.js": 143,
		"./lv": 144,
		"./lv.js": 144,
		"./me": 145,
		"./me.js": 145,
		"./mk": 146,
		"./mk.js": 146,
		"./ml": 147,
		"./ml.js": 147,
		"./mr": 148,
		"./mr.js": 148,
		"./ms": 149,
		"./ms-my": 150,
		"./ms-my.js": 150,
		"./ms.js": 149,
		"./my": 151,
		"./my.js": 151,
		"./nb": 152,
		"./nb.js": 152,
		"./ne": 153,
		"./ne.js": 153,
		"./nl": 154,
		"./nl.js": 154,
		"./nn": 155,
		"./nn.js": 155,
		"./pa-in": 156,
		"./pa-in.js": 156,
		"./pl": 157,
		"./pl.js": 157,
		"./pt": 158,
		"./pt-br": 159,
		"./pt-br.js": 159,
		"./pt.js": 158,
		"./ro": 160,
		"./ro.js": 160,
		"./ru": 161,
		"./ru.js": 161,
		"./se": 162,
		"./se.js": 162,
		"./si": 163,
		"./si.js": 163,
		"./sk": 164,
		"./sk.js": 164,
		"./sl": 165,
		"./sl.js": 165,
		"./sq": 166,
		"./sq.js": 166,
		"./sr": 167,
		"./sr-cyrl": 168,
		"./sr-cyrl.js": 168,
		"./sr.js": 167,
		"./ss": 169,
		"./ss.js": 169,
		"./sv": 170,
		"./sv.js": 170,
		"./sw": 171,
		"./sw.js": 171,
		"./ta": 172,
		"./ta.js": 172,
		"./te": 173,
		"./te.js": 173,
		"./th": 174,
		"./th.js": 174,
		"./tl-ph": 175,
		"./tl-ph.js": 175,
		"./tlh": 176,
		"./tlh.js": 176,
		"./tr": 177,
		"./tr.js": 177,
		"./tzl": 178,
		"./tzl.js": 178,
		"./tzm": 179,
		"./tzm-latn": 180,
		"./tzm-latn.js": 180,
		"./tzm.js": 179,
		"./uk": 181,
		"./uk.js": 181,
		"./uz": 182,
		"./uz.js": 182,
		"./vi": 183,
		"./vi.js": 183,
		"./x-pseudo": 184,
		"./x-pseudo.js": 184,
		"./zh-cn": 185,
		"./zh-cn.js": 185,
		"./zh-tw": 186,
		"./zh-tw.js": 186
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 86;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dhivehi (dv)
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish english (en-ie)
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : New Zealand english (en-nz)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swiss french (fr)
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain scottish gealic (gd)
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kazakh (kk)
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kyrgyz (ky)
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : lao (lo)
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_')
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : punjabi india (pa-in)
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        monthsRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|сент\.|февр\.|нояб\.|июнь|янв.|июль|дек.|авг.|апр.|марта|мар[.т]|окт.|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsShortRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|сент\.|февр\.|нояб\.|июнь|янв.|июль|дек.|авг.|апр.|марта|мар[.т]|окт.|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsStrictRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|марта?|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsShortStrictRegex: /^(нояб\.|февр\.|сент\.|июль|янв\.|июн[яь]|мар[.т]|авг\.|апр\.|окт\.|дек\.|ма[яй])/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami (se)
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati (ss)
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swahili (sw)
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : telugu (te)
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon (tlh)
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'leS' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'waQ' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'nem' :
	    	time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'Hu’' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'wen' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'ben' :
	    	time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	    	ten = Math.floor((number % 100) / 10),
	    	one = number % 10,
	    	word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : pseudo (x-pseudo)
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1分鐘',
	            mm : '%d分鐘',
	            h : '1小時',
	            hh : '%d小時',
	            d : '1天',
	            dd : '%d天',
	            M : '1個月',
	            MM : '%d個月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart, moment) {
	
	  var helpers = Chart.helpers,
	    globalOpts = Chart.defaults.global;
	
	  globalOpts.elements.arc = {
	    backgroundColor: globalOpts.defaultColor,
	    borderColor: "#fff",
	    borderWidth: 2
	  };
	
	  Chart.elements.Arc = Chart.Element.extend({
	    inLabelRange: function(mouseX) {
	      var vm = this._view;
	
	      if (vm) {
	        return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
	      } else {
	        return false;
	      }
	    },
	    inRange: function(chartX, chartY) {
	      var vm = this._view;
	
	      if (vm) {
	        var pointRelativePosition = helpers.getAngleFromPoint(vm, {
	            x: chartX,
	            y: chartY
	          }),
	          angle = pointRelativePosition.angle,
	          distance = pointRelativePosition.distance;
	
	        //Sanitise angle range
	        var startAngle = vm.startAngle;
	        var endAngle = vm.endAngle;
	        while (endAngle < startAngle) {
	          endAngle += 2.0 * Math.PI;
	        }
	        while (angle > endAngle) {
	          angle -= 2.0 * Math.PI;
	        }
	        while (angle < startAngle) {
	          angle += 2.0 * Math.PI;
	        }
	
	        //Check if within the range of the open/close angle
	        var betweenAngles = (angle >= startAngle && angle <= endAngle),
	          withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
	        return (betweenAngles && withinRadius);
	      } else {
	        return false;
	      }
	    },
	    tooltipPosition: function() {
	      var vm = this._view;
	
	      var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
	        rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	      return {
	        x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
	        y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
	      };
	    },
	    draw: function() {
	
	      var ctx = this._chart.ctx,
	        vm = this._view,
	        sA = vm.startAngle,
	        eA = vm.endAngle;
	
	      ctx.beginPath();
	
	      ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
	      ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
	      ctx.closePath();
	      ctx.strokeStyle = vm.borderColor;
	      ctx.lineWidth = vm.borderWidth;
	
	      ctx.fillStyle = vm.backgroundColor;
	
	      ctx.fill();
	      ctx.lineJoin = 'bevel';
	
	      if (vm.borderWidth) {
	        ctx.stroke();
	      }
	    }
	  });
	};


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: Chart.defaults.global.defaultColor,
			borderWidth: 3,
			borderColor: Chart.defaults.global.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			fill: true // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			lineToNextPoint: function(previousPoint, point, nextPoint, skipHandler, previousSkipHandler) {
				var ctx = this._chart.ctx;
	
				if (point._view.skip) {
					skipHandler.call(this, previousPoint, point, nextPoint);
				} else if (previousPoint._view.skip) {
					previousSkipHandler.call(this, previousPoint, point, nextPoint);
				} else if (point._view.tension === 0) {
					ctx.lineTo(point._view.x, point._view.y);
				} else {
					// Line between points
					ctx.bezierCurveTo(
						previousPoint._view.controlPointNextX,
						previousPoint._view.controlPointNextY,
						point._view.controlPointPreviousX,
						point._view.controlPointPreviousY,
						point._view.x,
						point._view.y
					);
				}
			},
	
			draw: function() {
				var _this = this;
	
				var vm = this._view;
				var ctx = this._chart.ctx;
				var first = this._children[0];
				var last = this._children[this._children.length - 1];
	
				function loopBackToStart(drawLineToCenter) {
					if (!first._view.skip && !last._view.skip) {
						// Draw a bezier line from last to first
						ctx.bezierCurveTo(
							last._view.controlPointNextX,
							last._view.controlPointNextY,
							first._view.controlPointPreviousX,
							first._view.controlPointPreviousY,
							first._view.x,
							first._view.y
						);
					} else if (drawLineToCenter) {
						// Go to center
						ctx.lineTo(_this._view.scaleZero.x, _this._view.scaleZero.y);
					}
				}
	
				ctx.save();
	
				// If we had points and want to fill this line, do so.
				if (this._children.length > 0 && vm.fill) {
					// Draw the background first (so the border is always on top)
					ctx.beginPath();
	
					helpers.each(this._children, function(point, index) {
						var previous = helpers.previousItem(this._children, index);
						var next = helpers.nextItem(this._children, index);
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (this._loop) {
								ctx.moveTo(vm.scaleZero.x, vm.scaleZero.y);
							} else {
								ctx.moveTo(point._view.x, vm.scaleZero);
							}
	
							if (point._view.skip) {
								if (!this._loop) {
									ctx.moveTo(next._view.x, this._view.scaleZero);
								}
							} else {
								ctx.lineTo(point._view.x, point._view.y);
							}
						} else {
							this.lineToNextPoint(previous, point, next, function(previousPoint, point, nextPoint) {
								if (this._loop) {
									// Go to center
									ctx.lineTo(this._view.scaleZero.x, this._view.scaleZero.y);
								} else {
									ctx.lineTo(previousPoint._view.x, this._view.scaleZero);
									ctx.moveTo(nextPoint._view.x, this._view.scaleZero);
								}
							}, function(previousPoint, point) {
								// If we skipped the last point, draw a line to ourselves so that the fill is nice
								ctx.lineTo(point._view.x, point._view.y);
							});
						}
					}, this);
	
					// For radial scales, loop back around to the first point
					if (this._loop) {
						loopBackToStart(true);
					} else {
						//Round off the line by going to the base of the chart, back to the start, then fill.
						ctx.lineTo(this._children[this._children.length - 1]._view.x, vm.scaleZero);
						ctx.lineTo(this._children[0]._view.x, vm.scaleZero);
					}
	
					ctx.fillStyle = vm.backgroundColor || Chart.defaults.global.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Now draw the line between all the points with any borders
				ctx.lineCap = vm.borderCapStyle || Chart.defaults.global.elements.line.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || Chart.defaults.global.elements.line.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || Chart.defaults.global.elements.line.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || Chart.defaults.global.elements.line.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || Chart.defaults.global.elements.line.borderWidth;
				ctx.strokeStyle = vm.borderColor || Chart.defaults.global.defaultColor;
				ctx.beginPath();
	
				helpers.each(this._children, function(point, index) {
					var previous = helpers.previousItem(this._children, index);
					var next = helpers.nextItem(this._children, index);
	
					if (index === 0) {
						ctx.moveTo(point._view.x, point._view.y);
					} else {
						this.lineToNextPoint(previous, point, next, function(previousPoint, point, nextPoint) {
							ctx.moveTo(nextPoint._view.x, nextPoint._view.y);
						}, function(previousPoint, point) {
							// If we skipped the last point, move up to our point preventing a line from being drawn
							ctx.moveTo(point._view.x, point._view.y);
						});
					}
				}, this);
	
				if (this._loop && this._children.length > 0) {
					loopBackToStart();
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 1,
			borderColor: globalOpts.defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false; 
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function() {
				var vm = this._view,
					x = vm.x,
					y = vm.y;
				var ctx = this._chart.ctx;
	
				if (vm.skip) {
					return;
				}
	
				var pointStyle = vm.pointStyle;
				if (typeof pointStyle === 'object' && ((pointStyle.toString() === '[object HTMLImageElement]') || (pointStyle.toString() === '[object HTMLCanvasElement]'))) {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
	
				if (!isNaN(vm.radius) && vm.radius > 0) {
	
					ctx.strokeStyle = vm.borderColor || Chart.defaults.global.defaultColor;
					ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, Chart.defaults.global.elements.point.borderWidth);
	
					ctx.fillStyle = vm.backgroundColor || Chart.defaults.global.defaultColor;
	
					var radius = vm.radius;
	
					var xOffset,
						yOffset;
	
					switch (pointStyle) {
						// Default includes circle
						default: 
							ctx.beginPath();
							ctx.arc(x, y, radius, 0, Math.PI * 2);
							ctx.closePath();
							ctx.fill();
							break;
						case 'triangle':
							ctx.beginPath();
							var edgeLength = 3 * radius / Math.sqrt(3);
							var height = edgeLength * Math.sqrt(3) / 2;
							ctx.moveTo(x - edgeLength / 2, y + height / 3);
							ctx.lineTo(x + edgeLength / 2, y + height / 3);
							ctx.lineTo(x, y - 2 * height / 3);
							ctx.closePath();
							ctx.fill();
							break;
						case 'rect':
							ctx.fillRect(x - 1 / Math.SQRT2 * radius, y - 1 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius);
							ctx.strokeRect(x - 1 / Math.SQRT2 * radius, y - 1 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius);
							break;
						case 'rectRot':
							ctx.translate(x, y);
							ctx.rotate(Math.PI / 4);
							ctx.fillRect(-1 / Math.SQRT2 * radius, -1 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius);
							ctx.strokeRect(-1 / Math.SQRT2 * radius, -1 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius, 2 / Math.SQRT2 * radius);
							ctx.setTransform(1, 0, 0, 1, 0, 0);
							break;
						case 'cross':
							ctx.beginPath();
							ctx.moveTo(x, y + radius);
							ctx.lineTo(x, y - radius);
							ctx.moveTo(x - radius, y);
							ctx.lineTo(x + radius, y);
							ctx.closePath();
							break;
						case 'crossRot':
							ctx.beginPath();
							xOffset = Math.cos(Math.PI / 4) * radius;
							yOffset = Math.sin(Math.PI / 4) * radius;
							ctx.moveTo(x - xOffset, y - yOffset);
							ctx.lineTo(x + xOffset, y + yOffset);
							ctx.moveTo(x - xOffset, y + yOffset);
							ctx.lineTo(x + xOffset, y - yOffset);
							ctx.closePath();
							break;
						case 'star':
							ctx.beginPath();
							ctx.moveTo(x, y + radius);
							ctx.lineTo(x, y - radius);
							ctx.moveTo(x - radius, y);
							ctx.lineTo(x + radius, y);
							xOffset = Math.cos(Math.PI / 4) * radius;
							yOffset = Math.sin(Math.PI / 4) * radius;
							ctx.moveTo(x - xOffset, y - yOffset);
							ctx.lineTo(x + xOffset, y + yOffset);
							ctx.moveTo(x - xOffset, y + yOffset);
							ctx.lineTo(x + xOffset, y - yOffset);
							ctx.closePath();
							break;
						case 'line':
							ctx.beginPath();
							ctx.moveTo(x - radius, y);
							ctx.lineTo(x + radius, y);
							ctx.closePath();
							break;
						case 'dash':
							ctx.beginPath();
							ctx.moveTo(x, y);
							ctx.lineTo(x + radius, y);
							ctx.closePath();
							break;
					}
	
					ctx.stroke();
				}
			}
		});
	};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				var halfWidth = vm.width / 2,
					leftX = vm.x - halfWidth,
					rightX = vm.x + halfWidth,
					top = vm.base - (vm.base - vm.y),
					halfStroke = vm.borderWidth / 2;
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (vm.borderWidth) {
					leftX += halfStroke;
					rightX -= halfStroke;
					top += halfStroke;
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[leftX, vm.base],
					[leftX, top],
					[rightX, top],
					[rightX, vm.base]
				];
	
				// Find first (starting) corner with fallback to 'bottom' 
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(vm.borderSkipped, 0);
				if (startCorner === -1)
					startCorner = 0;
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				ctx.moveTo.apply(ctx, cornerAt(0));
				for (var i = 1; i < 4; i++)
					ctx.lineTo.apply(ctx, cornerAt(i));
	
				ctx.fill();
				if (vm.borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? 
						(vm.y < vm.base ? 
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.y && mouseY <= vm.base) :
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.base && mouseY <= vm.y)) :
						false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			aspectRatio: 1
		};
	
		Chart.Radar = function(context, config) {
			config.options = helpers.configMerge(defaultConfig, config.options);
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: "linear", // scatter should not use a category axis
					position: "bottom",
					id: "x-axis-1" // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: "linear",
					position: "left",
					id: "y-axis-1"
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var Collection         = __webpack_require__(8),
	    Widget             = __webpack_require__(31),
	    Button             = __webpack_require__(199),
	    ButtonGroup        = __webpack_require__(200),
	    ZoomControl        = __webpack_require__(202),
	    LayerSwitcher      = __webpack_require__(203),
	    DistanceMeasure    = __webpack_require__(205),
	    Window             = __webpack_require__(207),
	    Panel              = __webpack_require__(209),
	    Legend             = __webpack_require__(210),
	    AreaButton         = __webpack_require__(222),
	    LegendGroup        = __webpack_require__(223),
	    Searchbar          = __webpack_require__(224),
	    ModalMessage       = __webpack_require__(30),
	    DropDown           = __webpack_require__(201),
	    LabelButton        = __webpack_require__(206),
	    MeasureToolChanger = __webpack_require__(227);
	
	var widgetClassList = {
	    'Button'            :Button,
	    'ButtonGroup'       :ButtonGroup,
	    'ZoomControl'       :ZoomControl,
	    'LayerSwitcher'     :LayerSwitcher,
	    'DistanceButton'    :DistanceMeasure,
	    'AreaButton'        :AreaButton,
	    'Window'            :Window,
	    'Panel'             :Panel,
	    'Legend'            :Legend,
	    'LegendGroup'       :LegendGroup,
	    'SearchBar'         :Searchbar,
	    'ModalMessage'      :ModalMessage,
	    'DropDown'          :DropDown,
	    'LabelButton'       :LabelButton,
	    'MeasureToolChanger':MeasureToolChanger
	};
	
	var WidgetManager = Collection.extend({
	
	    /**
	     *
	     */
	    initialize: function(view, widgets, options) {
	        var that = this;
	
	        WidgetManager.__super__.initialize.call(that, widgets, options);
	
	        that._view = view;
	
	        that._mapElements = that._view._elements;
	    },
	
	    /**
	     *
	     * @param widget
	     * @param options
	     * @return {WidgetManager}
	     */
	    addWidget: function(widget, options){
	        var that = this,
	            newWidget;
	
	        options || (options = {});
	
	        options.view = that._view;
	
	        if (typeof widget == 'string' && widget in widgetClassList) {
	            newWidget = new widgetClassList[widget](options);
	        } else if (widget instanceof Widget) {
	            newWidget = widget;
	        } else {
	            throw new TypeError("Widget not supported. It should be instance of Widget or predefined widget code name (string)");
	        }
	
	        that.add(newWidget);
	        that._mapElements['container'].appendChild(newWidget.getContainer()[0]);
	        newWidget.onAdd(that._view);
	
	        return that;
	    },
	    
	    /**
	     * Удаляет виджет из коллекции
	     * @param  {Object.Widget} - Объект виджета, который нужно удалить
	     * @return {Object.WidgetManager} - Коллекция виджетов
	     */
	    removeWidget: function(widget_object){
	        var that = this;
	
	        that._mapElements['container'].removeChild(widget_object.getContainer()[0]);
	        widget_object.onRemove(that._view);
	        that.remove(widget_object);
	        return that;
	    },
	
	    /**
	     *
	     */
	    hideWidgets: function() {
	        var that = this;
	        that.each(function(el){
	            el.hide();
	        });
	    },
	
	    /**
	     *
	     */
	    showWidgets: function() {
	        var that = this;
	        that.each(function(el){
	            el.show();
	        });
	    },
	
	    getByName: function(name, all) {
	        var that = this;
	        var i;
	        var res = [];
	        var item;
	
	        for (i = 0; i < that._items.length; i++) {
	            item = that._items[i];
	            if (item.getName() === name) {
	                if (!all) {
	                    return item;
	                } else {
	                    res.push(item);
	                }
	            }
	        }
	        return res;
	    }
	});
	
	module.exports = WidgetManager;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget          = __webpack_require__(31);
	
	var Button = Widget.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options) {
	        var that = this,
	            eventType;
	
	        options || (options = {});
	
	        Button.__super__.initialize.call(that, options);
	
	        that._container.addClass('omjs-button');
	
	        if (typeof options.events == 'object') {
	            for (eventType in options.events) {
	                that.on(eventType, options.events[eventType]);
	            }
	        }
	    },
	
	    /**
	     *
	     * @param eventType
	     * @param handler
	     * @return {Button}
	     */
	    on: function(eventType, handler){
	        var that = this;
	
	        if (that._container[0].addEventListener) {
	            that._container[0].addEventListener(eventType, handler, false);
	        }
	        else if (that._container[0].attachEvent) {
	            that._container[0].attachEvent("on" + eventType, handler);
	        }
	
	        return that;
	    }
	});
	
	module.exports = Button;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget      = __webpack_require__(31),
	    Button      = __webpack_require__(199),
	    DropDown    = __webpack_require__(201);
	
	
	var ButtonGroup = Widget.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this,
	            _buttons,
	            i;
	
	        options || (options = {});
	        that._view = undefined;
	
	        that._buttons = [];
	
	        options.orientation = options.orientation || 'vertical';
	
	        if ('buttons' in options) {
	            _buttons = options.buttons;
	            delete options['buttons'];
	        }
	
	        ButtonGroup.__super__.initialize.call(that, options);
	
	        that.getContainer().addClass(that.options['orientation'] + ' omjs-button-group');
	
	        if (typeof options.css == 'object') {
	            that._container.css(options.css);
	        }
	
	        for(i in _buttons) {
	            that.add(_buttons[i]);
	        }
	    },
	
	    /**
	     *
	     * @param view
	     */
	    onAdd: function(view){
	        var that = this,
	            i;
	        that._view = view;
	        for (i in that._buttons) {
	            that._buttons[i].onAdd(that._view);
	        }
	    },
	
	    /**
	     *
	     */
	    add: function(button){
	        var that = this;
	
	        if (
	            (button instanceof Button) || 
	            (button instanceof DropDown)
	        ) {
	            that._buttons.push(button);
	            that.getContainer()[0].appendChild(button.getContainer()[0]);
	            if (that._view) {
	                button.onAdd(that._view);
	            }
	        }
	
	        return that;
	    },
	
	    /**
	     *
	     */
	    remove: function(button){
	        var that = this;
	
	        if (~that._buttons.indexOf(button)) {
	            that.getContainer()[0].removeChild(button.getContainer()[0]);
	            if (that._view) {
	                button.onRemove(that._view);
	            }
	            
	            that._buttons.splice(that._buttons.indexOf(button), 1);
	        }
	        return that;
	    }
	});
	
	module.exports = ButtonGroup;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget          = __webpack_require__(31);
	var $               = __webpack_require__(3);
	var Utils			= __webpack_require__(5);
	var _               = __webpack_require__(16);
	
	var defaultOptions = {
	    /* Массив OMJS виджетов */
	    elements: [],
	    /* Иконка для дропдауна (false - дефолтная иконка) */
	    icon: false,
	    /* Обработчик события на клик по елементу выпадающего списка */
	    onItemClick: false,
	    /* Нужно ли закрывать выпадающий список после клика по элементу */
	    shouldClose: false
	};
	
	/* 
		Компонент дропдауна
	*/
	var DropDown = Widget.extend({
	    initialize: function(options){
	        var that = this;
	        options = $.extend({}, defaultOptions, (options || {}));
	        DropDown.__super__.initialize.call(that, options);
	
	        var $container = that.getContainer();
	
	        that.list_hide_timeout	= null;
	        that.view				= false;
	        that.isTouch			= Utils.isTouch();
	        that._opened			= false;
	
	        $container = that.getContainer();
	        $container.addClass('omjs-dropdown');
	
	        that.$actionButton = $(that.generateActionButton());
	
	        if (!that.isTouch) {
	        	/* логика для десктопов */
	        	$container.on('mouseenter', that.showContainer.bind(that));
	        	$container.on('mouseleave', that.hideContainer.bind(that));
	        } else {
	        	/* логика для тач устройств */
	        	that.$actionButton.on('focus', that.showContainer.bind(that));
				that.$actionButton.on('blur', that.hideContainer.bind(that));
	        }
	        
	
	        that.$list = $(that.generateListWrapper());
	        that.$list.append(
	            that.generateListItems(that.options.elements)
	        );
	
	        $container.append(that.$actionButton, that.$list);
	        
	        that.setActionIcon();
	    },
	
	    onAdd: function(view){
	    	var that = this;
	    	that.view = view;
	    	_.each(that.options.elements, function(widget){
	    		widget.onAdd(view);
	    	});
	    },
	
	    generateActionButton: function(){
	    	var outerElement = document.createElement('div');
	    		outerElement.className = 'action-button';
	
	        // if (this.options.icon && _.isString(this.options.icon)) {
	        //     outerElement.style.backgroundImage = 'url('+this.options.icon+')';
	        // }
	
	    	outerElement.setAttribute('tabindex', '0');
	
	    	return outerElement;
	    },
	
	    setActionIcon: function(opt_icon){
	        opt_icon = opt_icon || this.options.icon;
	        if (opt_icon) {
	         this.$actionButton.css({
	             backgroundImage: 'url('+opt_icon+')'
	         });
	        }
	    },
	
	    generateListWrapper: function(){
	    	var outerElement = document.createElement('div');
	    		outerElement.className = 'expandable-list';
	
	    	return outerElement;
	    },
	
	    generateListItems: function(widgets){
	    	var that = this;
	    	var _containers = [];
	    	var listContainers = _.map(widgets, function(widg){
	    		_containers.push(widg.getContainer());
	    		return {
	    			widget: widg,
	    			container: widg.getContainer()
	    		};
	    	});
	
	    	_.each(listContainers, function(cont){
	    		cont.container.on(
	    			'click', 
	    			that.__onItemClick__.bind(that, cont.widget)
	    		);
	    	});
	
	    	return _containers;
	    },
	
	    __onItemClick__: function(clicked_widget, jQueryEvent){
	    	var that = this;
	
	    	if (
	    		that.options.onItemClick 
	    		&& _.isFunction(that.options.onItemClick)
	    	) {
	    		that.options.onItemClick(clicked_widget, jQueryEvent);
	    	}
	
	    	if (that.options.shouldClose) {
	    		that.hideContainer();
	    	}
	    	that.fire('item_click', {
	    		item: clicked_widget,
	    		event: jQueryEvent
	    	});
	    },
	
	    showContainer: function(){
	    	var that = this;
	    	if (that.list_hide_timeout) clearTimeout(that.list_hide_timeout);
			// console.log(that.$list.parents('.dark-tools-control'));
			var left = parseInt(that.$list.parents('.dark-tools-control').offset().left);
			var right;
			if(parseInt($(window).width()) - left < parseInt(that.$list.width())){
				right = 10;
				left = undefined;
			}
			that.$list.css({
				'position': 'fixed',
				'left': left + 'px',
				'right': right + 'px'
			});
			that.$list.show();
	    	that._opened = true;
	    },
	
	    hideContainer: function(){
	    	var that = this;
	    	that.list_hide_timeout = setTimeout(function(){
	    		that.$list.hide();
	    		that.list_hide_timeout = null;
	    		that._opened = false;
	    	}, 70);
	    }
	});
	
	module.exports = DropDown;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var ButtonGroup         = __webpack_require__(200),
	    Button              = __webpack_require__(199),
	    $                   = __webpack_require__(3),
	    ol                  = __webpack_require__(22);
	
	var ZoomControl = ButtonGroup.extend({
	
	    options: {
	        duration: 190
	    },
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this,
	            incButton,
	            disButton,
	            decButton;
	
	        that.map = undefined;
	        that.view = undefined;
	
	        options || (options = {});
	
	        ZoomControl.__super__.initialize.call(that, options);
	
	        that.getContainer().addClass('omjs-zoom-control');
	
	        that.add(new Button({}));
	        that.add(new Button({}));
	        that.add(new Button({}));
	
	        incButton = that._buttons[0];
	        disButton = that._buttons[1];
	        decButton = that._buttons[2];
	
	        disButton.getContainer().addClass('disabled').text("0");
	
	        incButton.on('click', function(){
	            that._setZoom.call(that, 1);
	        });
	
	        decButton.on('click', function(){
	            that._setZoom.call(that, -1);
	        });
	    },
	
	    /**
	     *
	     * @param view
	     */
	    onAdd: function(view) {
	        var that = this;
	        that.view = view;
	        that.map = view.getMap();
	        that._buttons[1].getContainer()[0].innerHTML = that.map.getView().getZoom();
	        that._checkButtonState();
	
	        that.map.getView().on('change:resolution', function(e) {
	            that._checkButtonState();
	        });
	    },
	
	    /**
	     *
	     * @private
	     */
	    _checkButtonState: function() {
	        var that = this,
	        map_view = that.map.getView();
	
	        map_view.getZoom() >= that.view.options.maxZoom
	            ? that._buttons[0].getContainer().addClass('disabled')
	            : that._buttons[0].getContainer().removeClass('disabled');
	
	        map_view.getZoom() <= that.view.options.minZoom
	            ? that._buttons[2].getContainer().addClass('disabled')
	            : that._buttons[2].getContainer().removeClass('disabled');
	
	        if ($.isNumeric(map_view.getZoom())) {
	            that._buttons[1].getContainer()[0].innerHTML = parseInt(map_view.getZoom());
	        }
	    },
	
	    /**
	     *
	     * @param delta
	     */
	    _setZoom: function(delta){
	        var that = this,
	            view,
	            currentResolution;
	
	        if (!that.map) {
	            return;
	        }
	
	        view = that.map.getView();
	
	        if (!view) {
	            return;
	        }
	
	        currentResolution = view.getResolution();
	        if (currentResolution) {
	            var newResolution = view.constrainResolution(currentResolution, delta);
	            view.animate({
	                resolution: newResolution,
	                easing: ol.easing.easeOut,
	                duration: 190
	            });
	
	            that._checkButtonState();
	        }
	    }
	});
	
	module.exports = ZoomControl;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var Button          = __webpack_require__(199),
	    $               = __webpack_require__(3),
	    itemTemplate    = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./item.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	
	var LayerSwitcher = Button.extend({
	
	    options: {
	        showCurrIndicator: true,
	        currIndicatorPosition: 'right'
	    },
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options) {
	        var that = this,
	            indicatorPos = 'pos-right';
	
	        that._layerList = [];
	        that._switcherCont = undefined;
	        that._baseLayer = undefined;
	
	        LayerSwitcher.__super__.initialize.call(that, options);
	
	        that.getContainer().addClass('button-layers layer-switcher');
	
	        that.getContainer().on('change', 'input', function(event){
	            if ($(this).prop('type') == "checkbox") {
	                if (that._baseLayer.cdr_layer) {
	                    if ($(this).prop('checked') == true) {
	                        that._baseLayer.cdr_layer.setVisible(true);
	                    } else {
	                        that._baseLayer.cdr_layer.setVisible(false);
	                        if (that._baseLayer.cdr_highlight_layer) {
	
	                            that._baseLayer.cdr_highlight_layer.getSource().emptyCache();
	                            that._baseLayer.cdr_zouit_highlight_layer.getSource().emptyCache();
	
	                            that._baseLayer.cdr_highlight_layer.setVisible(false);
	                            that._baseLayer.cdr_zouit_highlight_layer.setVisible(false);
	                            
	                        }
	                    }
	                }
	            } else {
	                that.view.switchBaseLayer($(this).data('layer'));
	            }
	        });
	
	        if (that.options.showCurrIndicator) {
	            indicatorPos = that.options.currIndicatorPosition == 'left'
	                ? 'pos-left'
	                : 'pos-right';
	
	            that.currLayerIndicator = $('<div></div>');
	            that.currLayerIndicator.addClass('curr-layer-label '+indicatorPos);
	            that.getContainer().append(that.currLayerIndicator);
	        }
	    },
	
	    /**
	     *
	     * @param view
	     */
	    onAdd: function(view){
	        var that = this;
	
	        that.view = view;
	
	        that._baseLayer = view.getBaseLayer();
	        that._layerList = view.options.publication['base_maps'];
	        
	        if(that._layerList.length == 0) {
	            that.getContainer().hide();
	            return;
	        }
	
	        that._createSwitcher();
	        that._baseLayer.on('layerChanged', function(event){
	            that._switcherCont.find('input[data-layer='+event.layerName+']').prop('checked', true);
	            that.setIndicator(event.layerName);
	        });
	    },
	
	    /**
	     *
	     * @private
	     */
	    _createSwitcher: function(){
	        var that = this,
	            currBase    = false,
	            cadastreOn  = false,
	            layerList   = {},
	            lng,
	            names,
	            name;
	
	        that._layerList.forEach(function(el, i){
	            // возможно название локализовано
	            // [{ru: Название}, {en: Name]
	            lng = that.view.getProject().lng;
	            name = '';
	            if (el.localized_name && lng) {
	                names = el.names.filter(function(n) {
	                    return lng in n;
	                }).map(function (n) {
	                    return n[lng];
	                });
	                if (names.length) {
	                    name = names[0];
	                }
	            }
	            layerList[el.id] = {};
	            layerList[el.id].name = el.localized_name && lng ? name : el.name;
	            layerList[el.id].value = el.value == "cadastre" ? el.value : '';
	            if (el.selected && el.value != "cadastre" && !currBase) {
	                currBase = el.id;
	            }
	            if (el.selected && el.value == "cadastre") {
	                cadastreOn = el.id;
	            }
	        });
	
	        that._switcherCont = $(itemTemplate({
	            layers: layerList
	        }));
	
	        // включаем ПКК, если она активна
	        if (cadastreOn) {
	            that._switcherCont.find('input[data-layer='+cadastreOn+']').prop('checked', true); 
	            that._baseLayer.cdr_layer.setVisible(true);
	        }
	
	        that._switcherCont.find('input[data-layer='+currBase+']').prop('checked', true);
	        that._switcherCont.appendTo(that.getContainer());
	        that.setIndicator(currBase);
	    },
	
	    setIndicator: function(layerName) {
	        var that = this,
	            html;
	
	        if (that.options.showCurrIndicator) {
	            html = that._switcherCont.find('label[for="omjs_lsw_'+layerName+'"]').html();
	            that.currLayerIndicator.html(html);
	        }
	    },
	
	    enableCadastreLayer: function(state) {
	        var that = this;
	        state = state === undefined ? true : state;
	        var $input = that.getContainer().find('input[data-cadastre]');
	        $input.prop('checked', !!state);
	        $input.trigger('change');
	    }
	});
	
	module.exports = LayerSwitcher;

/***/ }),
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var LabelButton     = __webpack_require__(206);
	var $               = __webpack_require__(3);
	
	
	var defaultOptions = $.extend({}, LabelButton.DEFAULT_OPTIONS, {
	    /* Перезапишем label компонента чтоб как-то отличать Button'ы друг от друга */
	    label: 'DistanceButton'
	});
	
	var DistanceButton = LabelButton.extend({
	
	    /**
	     *
	     */
	    initialize: function(options){
	        var that = this;
	        options = options || {};
	        options = $.extend({}, defaultOptions, options);
	
	        that._map = undefined;
	        that._measurement = undefined;
	
	        DistanceButton.__super__.initialize.call(that, options);
	
	        that.getContainer()
	            // .addClass('button-distance')
	            .on('click', function(e){
	                that._measurement.changeInteraction('distance');
	            });
	    },
	
	    /**
	     *
	     */
	    onAdd: function(view){
	        var that = this;
	
	        that._map = view.getMap();
	        that._measurement = view.getMeasurement();
	        that._measurement.on('measureChanged', function(event){
	            if (event.measureType == 'distance') {
	                that.getContainer().addClass('active');
	            } else {
	                that.getContainer().removeClass('active');
	            }
	        })
	    }
	});
	
	module.exports = DistanceButton;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var Button          = __webpack_require__(199);
	var $               = __webpack_require__(3);
	
	var defaultOptions = {
		/* Текст для кнопки */
		label: 'LabelButton',
		/* Иконка для дропдауна (
				false - блок с иконкой не отрендерится
				true (default) - блок с иконкой отрендерится, но src иконке не 
								 заполнится
				string - блок отрендерится и значение переменной подставится в src
						 картинки
			) 
		*/
		icon: false,
		iconActive: false,
		/* Обработчик клика по кнопке (функция) */
		onclick: false,
	    /* Дополнительные стили для кнопки */
	    css: {}
	};
	
	/* 
		Этот компонент не отличается от обычного Button'a за
		исключением того, что в него можно передать иконку и лейбл
		для отображения. Если в компонент не передать ни то ни другое,
		то компонент отрендерится как обычный omjs.Widget.Button
	 */
	var LabelButton = Button.extend({
	
	    statics: {
	        DEFAULT_OPTIONS: defaultOptions
	    },
	
		initialize: function(options){
			var that = this;
			options = options = $.extend({}, defaultOptions, (options || {}));
			LabelButton.__super__.initialize.call(that, options);
	
			var $container = that.getContainer();
	
	        $container.css(that.options.css);
			
			/* Если есть или иконка или текст для кнопки,
			 то добавляем класс лейбла */
			if (that.options.icon || that.options.label) {
				$container.addClass('omjs-label-button');
			}
	
			if (that.options.icon) {
				that.$icon_container = $(that.generateIcon());
				$container.append(that.$icon_container);
			}
	
			if (that.options.label) {
				that.$label_container = $(that.generateLabel());
				$container.append(that.generateLabel());
			}
	
			$container.on('click', function(event){
				if (that.options.onclick && _.isFunction(that.options.onclick)) {
					that.options.onclick();
				}
				that.fire('click', event);
			});
			
		},
	
		generateIcon: function(){
			var that = this;
			var icon_path = that.options.icon;
	
			var outerElement = document.createElement('div');
				outerElement.className = 'icon-wrapper';
	
			if (_.isString(icon_path)) {
				var imageElement = document.createElement('img');
					imageElement.src = icon_path;
	
				outerElement.appendChild(imageElement);
			}
	
			return outerElement;
		},
	
		generateLabel: function(){
			var that = this;
			var label_text = that.options.label;
	
			var outerElement = document.createElement('div');
				outerElement.className = 'label-wrapper';
	
			outerElement.textContent = label_text;
	
			/* Если есть иконка, то блоку с текстом нужно
			 сделать отступ чтоб не сливалось */
			if (that.options.icon) {
				outerElement.style.paddingLeft = '7px';
			}
	
			return outerElement;
		},
	
		getIcon: function(){
			return this.options.icon;
		},
	
		getActiveIcon: function(){
			return this.options.iconActive;
		},
	
		setActiveIcon: function(){
			// if (this.options.activeIcon) {
				var img = this.$icon_container.find('img');
				img.attr('src', this.options.iconActive);
			// } else {
				// console.warn('Не задана иконка iconActive', this.options.activeIcon, $.extend({}, this.options));
			// }
		},
	
		unsetActiveIcon: function(){
			// if (this.options.icon) {
				var img = this.$icon_container.find('img');
				img.attr('src', this.options.icon);
			// } else {
				// console.warn('Не задана иконка icon', this.options.icon, $.extend({}, this.options)); 
			// }
		}
	});
	
	module.exports = LabelButton;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget          = __webpack_require__(31),
	    template        = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./template.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),
	    $               = __webpack_require__(3),
	    Events          = __webpack_require__(6);
	
	var Window = Widget.extend({
	
	    includes: Events,
	
	    options: {
	        showHeader: true,
	        showFooter: true
	    },
	
	    initialize: function(options){
	        var that = this;
	
	        Window.__super__.initialize.call(that, options);
	
	        that._container.addClass('omjs-window');
	
	        $(that._container).append(template({
	            header: options.headerContent ? options.headerContent : '',
	            footer: options.footerContent ? options.footerContent : '',
	            content: options.content ? options.content : ''
	        }));
	
	        delete options['headerContent'];
	        delete options['footerContent'];
	        delete options['content'];
	
	        if (!options.showHeader) {
	            $(that._container).find('.window-header').remove();
	        }
	        if (!options.showFooter) {
	            $(that._container).find('.window-footer').remove();
	        }
	
	        that._body = $(that._container).find('.window-body');
	        that._header = $(that._container).find('.window-header');
	        that._footer = $(that._container).find('.window-footer');
	    },
	
	    onAdd: function(view){
	        var that = this,
	            bodyTop,
	            bodyBottom;
	
	        bodyTop = that._header.outerHeight();
	        bodyBottom = that._footer.outerHeight();
	
	        that._body.css({
	            'top': bodyTop,
	            'bottom': bodyBottom
	        });
	
	        $(that._container).on('click', '.close-button', function(event){
	            var close = true;
	            if (typeof that.options['beforeClose'] == 'function') {
	                close = that.options['beforeClose'].call(that);
	            }
	            if (close === true) {
	                that.hide();
	                that.fire('close');
	            }
	        });
	
	        //if (that.options.showHeader) {
	        //    that._header.on('mousedown', function(event) {
	        //        console.log('asd');
	        //    })
	        //}
	    },
	
	    setContent: function(content) {
	        var that = this;
	
	        that._body.empty().append(content);
	
	        return that;
	    },
	
	    setHeader: function(content){
	        var that = this;
	
	        that._header.empty().append(content);
	
	        return that;
	    },
	
	    setFooter: function(content){
	        var that = this;
	
	        that._footer.empty().append(content);
	
	        return that;
	    }
	});
	
	module.exports = Window;

/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget          = __webpack_require__(31),
	    $               = __webpack_require__(3);
	
	var Panel = Widget.extend({
	
	    options: {
	        content: ""
	    },
	
	    initialize: function(options){
	        var that = this;
	
	        Panel.__super__.initialize.call(that, options);
	
	        that._container.addClass('omjs-panel');
	
	        $(that._container).append($('<div class="panel-container"></div>'));
	
	        if (that.options.content) {
	            if (typeof that.options.content == 'strting') {
	                $(that._container).find('.panel-container').html(that.options.content);
	            } else {
	                $(that._container).find('.panel-container').append(that.options.content);
	            }
	        }
	
	        that._contentContainer = $(that._container).find('.panel-container');
	    },
	
	    getContentContainer: function(){
	        var that = this;
	        return that._contentContainer;
	    }
	});
	
	module.exports = Panel;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var Panel           = __webpack_require__(209),
	    $               = __webpack_require__(3);
	
	var Legend = Panel.extend({
	
	    statics: {
	        create: function(options, translate){
	            var legendClass;
	
	            options || (options = {});
	
	            if(
	                !(options instanceof omjs.Project.Visualization) &&
	                !($.isPlainObject(options))
	            ){
	                throw new TypeError('No `omjs.Project.Visualization` instance or `legend options` given')
	            }
	
	            return $.when()
	                .then(function(){
	                    if(options instanceof omjs.Project.Visualization){
	                        return options.getLegend()
	                    }
	
	                    if($.isPlainObject(options)){
	                        if(!('type' in options)){
	                            options['type'] = 'category'
	                        }
	                        return options;
	                    }
	                })
	                .then(function(legendOptions){
	                    // if(legendOptions['name'] !== null){
	                    //     legendOptions['name'] = options.get('name');
	                    // }
	
	                    if(!legendOptions['showLegend']){
	                        return $.Deferred().reject();
	                    } else if (!legendOptions['showValues'] && legendOptions['name'] == null) {
	                        return $.Deferred().reject();
	                    } else if (legendOptions['type'] == 'category' && options.get('render_type') == 1) {
	                        //так как в категориях вектором нет настроек легенды, то не показываем ее
	                        // return $.Deferred().reject();
	                    }
	
	                    switch(legendOptions['type']){
	                        case 'bubble':
	                            legendClass = __webpack_require__(211);
	                            break;
	                        case 'category':
	                            legendClass = __webpack_require__(213);
	                            break;
	                        case 'thematic':
	                            legendClass = __webpack_require__(215);
	                            break;
	                        case 'heat':
	                            legendClass = __webpack_require__(217);
				                break;
	                        case 'PieChart':
	                        case 'BarChart':
	                        case 'LineChart':
	                            legendClass = __webpack_require__(219);
	                            break;
	                    }
	                    if (typeof translate == 'function') {
	                        legendOptions['translate'] = translate;
	                    }
	
	                    if ($.isArray(legendOptions.classificators)){
	                        legendOptions.classificators = legendOptions.classificators.filter(function(item){
	                            return (item['value'] !== null);
	                        });
	                    }
	                    else {
	                        legendOptions.classificators = [];
	                    }
	
	                    return new legendClass(legendOptions);
	                });
	        }
	    },
	
	    initialize: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        options.classificators = options.classificators ? options.classificators : [];
	
	        Legend.__super__.initialize.call(that, options);
	
	        // Базовый класс Widget грохает опцию name. А она нам очень нужна.
	        if(that._name){
	            that.options.name = that._name;
	        }
	
	        that._container.addClass('omjs-legend');
	
	        that._buildLegend();
	    },
	
	    _getTemplate: function(){
	        return __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./template.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    },
	
	    setClassificators: function(data) {
	        var that = this;
	
	        that.options.classificators = $.isArray(data) ? data : [];
	        that._buildLegend();
	
	        return that;
	    },
	
	    setName: function(name) {
	        var that = this;
	
	        that.options.name = $.type(name) !== "string"
	            ? name
	            : '';
	
	        that._buildLegend();
	
	        return that;
	    },
	
	    _buildLegend: function(){
	        var that = this;
	
	        var htm = that._getTemplate()(that.options);
	        // если name для легенды не задан в шаблоне появляется какая то магическая цифра
	        if (!that.options.name) {
	            that.options.name = '';
	        }
	
	        that.getContentContainer().html(htm);
	    }
	});
	
	module.exports = Legend;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var Legend   = __webpack_require__(210),
	    $        = __webpack_require__(3);
	
	var BubbleLegend = Legend.extend({
	
	    initialize: function (options) {
	        var that = this;
	
	        /*var tt = {
	            'type'      : 3,
	            'name'      : 'легенда пузырьков',
	            'showValues': true,
	            'minValue'  : 100,
	            'maxValue'  : 500,
	            'fill'      : '#ffffff',
	            'isIcon'    : false,
	            'separators': [{
	                'value': '100500',
	                'size' : 50,
	                'idx'  : '1'
	            }]
	        };*/
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "name"      : "",
	            "showValues" : null
	        }, options);
	
	        BubbleLegend.__super__.initialize.apply(that, arguments);
	
	        that._container.addClass('omjs-bubble-legend');
	
	        that._buildLegend();
	    },
	
	    _getTemplate: function(){
	        return __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./bubble.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    },
	
	    setMinValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.minValue = value;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setMaxValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.maxValue = value;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setColor: function (color) {
	        var that = this;
	
	        if ($.type(color) !== "string") {
	            return that;
	        }
	
	        that.options.fill   = color;
	        that.options.isIcon = false;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setIcon: function (icon) {
	        var that = this;
	
	        if ($.type(icon) !== "string") {
	            return that;
	        }
	
	        that.options.fill   = icon;
	        that.options.isIcon = true;
	        that._buildLegend();
	
	        return that;
	    }
	});
	
	module.exports = BubbleLegend;

/***/ }),
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var Legend   = __webpack_require__(210),
	    $        = __webpack_require__(3);
	
	var CategoryLegend = Legend.extend({
	
	    initialize: function (options) {
	        var that = this;
	
	        /*var tt = {
	         'type'      : 3,
	         'name'      : 'легенда пузырьков',
	         'showValues': true,
	         'minValue'  : 100,
	         'maxValue'  : 500,
	         'fill'      : '#ffffff',
	         'isIcon'    : false,
	         'separators': [{
	         'value': '100500',
	         'size' : 50,
	         'idx'  : '1'
	         }]
	         };*/
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "name"      : "",
	            "showValues" : null,
	            "classificators": []
	        }, options);
	
	        CategoryLegend.__super__.initialize.apply(that, arguments);
	
	        that._container.addClass('omjs-category-legend');
	
	        that.setClassificators(options.classificators)
	    },
	
	    _getTemplate: function(){
	        return __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./category.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    },
	
	    setClassificators: function(classificators){
	        var that = this;
	
	        classificators = $.isArray(classificators) ? classificators : [];
	
	        that.options.classificators = classificators.map(function(item){
	            if(item['value'] === null){
	                item['value'] = that.translate('Другие')
	            }
	
	            return item;
	        });
	
	        that._buildLegend();
	    },
	
	    setMinValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.minValue = value;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setMaxValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.maxValue = value;
	        that._buildLegend();
	
	        return that;
	    }
	});
	
	module.exports = CategoryLegend;

/***/ }),
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var Legend   = __webpack_require__(210),
	    $        = __webpack_require__(3);
	
	var ThematicLegend = Legend.extend({
	
	    initialize: function (options) {
	        var that = this;
	
	        /*var tt = {
	         'type'      : 3,
	         'name'      : 'легенда пузырьков',
	         'showValues': true,
	         'minValue'  : 100,
	         'maxValue'  : 500,
	         'fill'      : '#ffffff',
	         'isIcon'    : false,
	         'separators': [{
	         'value': '100500',
	         'size' : 50,
	         'idx'  : '1'
	         }]
	         };*/
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "name"      : "",
	            "showValues" : null,
	            "classificators": []
	        }, options);
	
	        ThematicLegend.__super__.initialize.apply(that, arguments);
	
	        that._container.addClass('omjs-thematic-legend');
	
	        that.setClassificators(options.classificators)
	    },
	
	    _getTemplate: function(){
	        return __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./thematic.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    },
	
	    setClassificators: function(classificators){
	        var that = this,
	            delta,
	            i=1;
	
	        classificators = $.isArray(classificators) ? classificators : [];
	        that.options.classificators = [];
	
	
	        if(classificators.length < 7){
	            that.options.classificators = classificators;
	        }else{
	            delta = classificators.length / 6;
	
	            that.options.classificators[0] = classificators[0];
	
	            while(i < 6){
	                that.options.classificators.push(classificators[parseInt(i*delta)])
	                i++;
	            }
	
	            that.options.classificators.push(classificators[classificators.length-1]);
	        }
	
	        that._buildLegend();
	    },
	
	    setMinValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.minValue = value;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setMaxValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.maxValue = value;
	        that._buildLegend();
	
	        return that;
	    }
	});
	
	module.exports = ThematicLegend;

/***/ }),
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var Legend   = __webpack_require__(210),
	    $        = __webpack_require__(3);
	
	var HeatLegend = Legend.extend({
	
	    initialize: function (options) {
	        var that = this;
	
	        /*var tt = {
	         'type'      : 3,
	         'name'      : 'легенда пузырьков',
	         'showValues': true,
	         'minValue'  : 100,
	         'maxValue'  : 500,
	         'fill'      : '#ffffff',
	         'isIcon'    : false,
	         'separators': [{
	         'value': '100500',
	         'size' : 50,
	         'idx'  : '1'
	         }]
	         };*/
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "name"      : "",
	            "showValues" : null,
	            "classificators": []
	        }, options);
	
	        HeatLegend.__super__.initialize.apply(that, arguments);
	
	        that._container.addClass('omjs-heat-legend');
	
	        that.setClassificators(options.classificators)
	    },
	
	    _getTemplate: function(){
	        return __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./heat.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    },
	
	    setClassificators: function(classificators){
	        var that = this,
	            delta,
	            i=1;
	
	        classificators = $.isArray(classificators) ? classificators : [];
	        that.options.classificators = [];
	
	
	        if(classificators.length < 7){
	            that.options.classificators = classificators;
	        }else{
	            delta = classificators.length / 6;
	
	            that.options.classificators[0] = classificators[0];
	
	            while(i < 6){
	                that.options.classificators.push(classificators[parseInt(i*delta)])
	                i++;
	            }
	
	            that.options.classificators.push(classificators[classificators.length-1]);
	        }
	
	        that._buildLegend();
	    },
	
	    setMinValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.minValue = value;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setMaxValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.maxValue = value;
	        that._buildLegend();
	
	        return that;
	    }
	});
	
	module.exports = HeatLegend;

/***/ }),
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var Legend   = __webpack_require__(210),
	    $        = __webpack_require__(3);
	
	var ChartLegend = Legend.extend({
	
	    initialize: function (options) {
	        var that = this;
	
	        /*var tt = {
	         'type'      : 3,
	         'name'      : 'легенда пузырьков',
	         'showValues': true,
	         'minValue'  : 100,
	         'maxValue'  : 500,
	         'fill'      : '#ffffff',
	         'isIcon'    : false,
	         'separators': [{
	         'value': '100500',
	         'size' : 50,
	         'idx'  : '1'
	         }]
	         };*/
	
	        options || (options = {});
	
	        options = $.extend(true, {
	            "name"      : "",
	            "showValues" : null,
	            "classificators": [],
	            "type": ""
	        }, options);
	
	        ChartLegend.__super__.initialize.apply(that, arguments);
	
	        that._container.addClass('omjs-chart-legend');
	
	        that.setClassificators(options.classificators)
	    },
	
	    _getTemplate: function(){
	        return __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./chart.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    },
	
	    setClassificators: function(classificators){
	        var that = this;
	
	        classificators = $.isArray(classificators) ? classificators : [];
	
	        that.options.classificators = classificators.map(function(item){
	            // не должно быть такого, что колонка будет с null именем
	            // if(item['value'] === null){
	            //     item['value'] = that.translate('Другие')
	            // }
	
	            return item;
	        });
	
	        that._buildLegend();
	    },
	
	    setMinValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.minValue = value;
	        that._buildLegend();
	
	        return that;
	    },
	
	    setMaxValue: function (value) {
	        var that = this;
	
	        if ($.type(value) !== "number") {
	            return that;
	        }
	
	        that.options.maxValue = value;
	        that._buildLegend();
	
	        return that;
	    }
	});
	
	module.exports = ChartLegend;

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var LabelButton     = __webpack_require__(206);
	var $               = __webpack_require__(3);
	
	var defaultOptions = $.extend({}, LabelButton.DEFAULT_OPTIONS, {
	    /* Перезапишем label компонента чтоб как-то отличать Button'ы друг от друга */
	    label: 'AreaButton'
	});
	
	var AreaButton = LabelButton.extend({
	
	    /**
	     *
	     */
	    initialize: function(options){
	        var that = this;
	        options = options || {};
	        options = $.extend({}, defaultOptions, options);
	
	        that._map = undefined;
	        that._measurement = undefined;
	
	
	        AreaButton.__super__.initialize.call(that, options);
	
	        that.getContainer()
	            // .addClass('button-area')
	            .on('click', function(e){
	                that._measurement.changeInteraction('area');
	            });
	    },
	
	    /**
	     *
	     */
	    onAdd: function(view){
	        var that = this;
	
	        that._map = view.getMap();
	        that._measurement = view.getMeasurement();
	        that._measurement.on('measureChanged', function(event){
	            if (event.measureType == 'area') {
	                that.getContainer().addClass('active');
	            } else {
	                that.getContainer().removeClass('active');
	            }
	        });
	    }
	});
	
	module.exports = AreaButton;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var Panel       = __webpack_require__(209),
	    $           = __webpack_require__(3),
	    Legend      = __webpack_require__(210);
	
	var LegendGroup  = Panel.extend({
	
	    options: {
	        watchLegendVisibility: true
	    },
	
	    initialize: function(options){
	        'use strict'
	        var that = this;
	
	        that.collapsed = false;
	
	        that._legends = [];
	
	        LegendGroup.__super__.initialize.call(that, options);
	
	        that._container.addClass('omjs-panel legend-group');
	
	        that.getContentContainer()
	            .append($('<div class="close-button"></div>'))
	            .on('click', function(){
	                if (that.collapsed) {
	                    that.expand();
	                }
	            })
	            .on('click', '.close-button', function(){
	                that.collapse();
	                return false;
	            });
	
	        that.getContentContainer().append('<div class="legends-container"></div>');
	
	        that._contentContainer = that.getContentContainer().find(".legends-container");
	
	        that.hide();
	    },
	
	    onAdd: function(view){
	        'use strict'
	        var that = this;
	        that.view = view;
	    },
	
	    addLegend: function(legend, id){
	        'use strict'
	        var that = this;
	
	        if (!legend || !(legend instanceof Legend) || ~that._legends.indexOf(legend)) {
	            return that;
	        }
	
	        that._legends.push(legend);
	        that.getContentContainer().append(legend._container);
	
	        that._legendVisibilityHandler();
	        legend.on('show', that._legendVisibilityHandler, that);
	        legend.on('hide', that._legendVisibilityHandler, that);
	
	        if (id) {
	            legend._grpId = id;
	        }
	
	        return that;
	    },
	
	    removeLegend: function(legend){
	        'use strict'
	        var that = this;
	
	        if (!legend) {
	            return that;
	        }
	
	        if (!(legend instanceof Legend)) {
	            legend = that.getById(legend);
	        }
	
	        if (legend) {
	            legend.getContainer().detach();
	            that._legends.splice(that._legends.indexOf(legend), 1);
	            that._legendVisibilityHandler();
	            legend.off('show', that._legendVisibilityHandler, that);
	            legend.off('hide', that._legendVisibilityHandler, that);
	        }
	
	        return that;
	    },
	
	    _legendVisibilityHandler: function(){
	        'use strict'
	        var that = this;
	        if(that.options.watchLegendVisibility){
	            that.getVisibleChilds().length > 0 ? that.show() : that.hide();    
	        }
	    },
	
	    getById: function(id){
	        'use strict'
	        var that = this,
	            legend;
	
	        legend = that._legends.filter(function(l){
	            return l._grpId == id;
	        });
	
	        return legend.length > 0 ? legend[0] : false;
	    },
	
	    collapse: function(){
	        'use strict'
	        var that = this;
	        that.getContainer().addClass('collapsed');
	        that.collapsed = true;
	    },
	
	    expand: function(){
	        'use strict'
	        var that = this;
	        that.getContainer().removeClass('collapsed');
	        that.collapsed = false;
	    },
	
	    getVisibleChilds: function(){
	        'use strict'
	        var that = this,
	            legends;
	
	        legends = that._legends.filter(function(l){
	            return !l.isHidden();
	        });
	
	        return legends;
	    }
	});
	
	module.exports = LegendGroup;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var Panel			= __webpack_require__(209);
	var $               = __webpack_require__(3);
	var template 		= __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./bar.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var search_item 	= __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./search_item.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	var SearchBar = Panel.extend({
	
		initialize: function(options){
			var that = this;
			that.searchResults = [];
	
			if (!("layer" in options) && !("url" in options)) {
				throw new Error("Не переданы слой или url");
			} else if (!(options.layer instanceof omjs.ol.layer.Vector)) {
				throw new Error("Слой должен быть векторный");
			}
	
			SearchBar.__super__.initialize.call(that, options);
	
			that.selectedItem = -1;
	
			that.setOptions(options);
			that.layer = that.options.layer;
			that.map = that.options.map;
	
			that.layer.setStyle(new ol.style.Style({
				fill : new ol.style.Fill({
					color: 'rgba(255,0,0,0.4)'
				}),
				image: new ol.style.Circle({
					fill  : new ol.style.Fill({
						color: 'rgba(255,0,0,0.4)'
					}),
					stroke: new ol.style.Stroke({
						color: 'rgba(0,0,0,0.7)',
						width: 2
					}),
					radius: 10
				})
			}));
	
			that.container = that.getContainer();
			that.container.html( $(template({})) );
			that.container.attr("tabindex", "-1");
	
			if (that.options.url === null) {
				that.container.css("cursor", "not-allowed");
				that.container.find("*").prop("disabled", true).css("pointer-events", "none");
			}
	
			that._searchInputWrapper = that.container.find("._search-bar-input-wrapper");
			that._searchInput = that.container.find("input[name=search-bar]");
			that._searchButton = that.container.find("div[role=do_search]");
			that._searchResults = that.container.find("div[role=search_results]");
			that._searchResultsItems = that._searchResults.find("._search_result_item");
	
			that._initHandlers();
	
		},
	
		_initHandlers: function(){
			var that = this;
			var curElem, nextElem, prevElem;
	
			that._searchResults.on("click", "._search_result_item", function(){
				that._displayGeometry($(this).attr("data-id"));
				that.container.removeClass("active");
			});
	
			that._searchResults.on("mouseenter", "._search_result_item", function(){
				that._searchResultsItems.removeClass("active");
				$(this).addClass("active");
			});
	
			that._searchInput.on("keydown", function(event){
				if (event.keyCode == 13 && !that.nowLoading) {
					if (that._searchInput.val() != "" && (that.madeRequestWith == that._searchInput.val())) {
						if (that._searchResults.find(".active").length) {
							that._searchResults.find(".active").trigger("click");
							that._searchInput.blur();
						} else /* if (that.madeRequestWith != that._searchInput.val())*/ {
							that.makeSearchRequest();
						}
					} else {
						that.makeSearchRequest();
					}
					// Т.к. используется form для бага хрома версии 66.0.3359.139, необходимо вернуть false, чтобы страница не перезагрузилась 
					return false
				} else if (event.keyCode == 38) {
					// up
					event.preventDefault();
					curElem = that._searchResults.find(".active");
	
					if (!curElem.length) {
						curElem = that._searchResultsItems.first();
					}
	
					prevElem = curElem.prev();
	
					if (!prevElem.length) {
						prevElem = that._searchResultsItems.last();
					}
	
					curElem.removeClass("active");
					prevElem.addClass("active");
	
					//if (that.selectedItem === 0) {
					//	that.selectedItem = that._searchResultsItems.length-1;
					//} else {
	                //
					//}
				} else if (event.keyCode == 40) {
					// down
					event.preventDefault();
					curElem = that._searchResults.find(".active");
	
					if (!curElem.length) {
						curElem = that._searchResultsItems.last();
					}
	
					nextElem = curElem.next();
	
					if (!nextElem.length) {
						nextElem = that._searchResultsItems.first();
					}
	
					curElem.removeClass("active");
					nextElem.addClass("active");
	
	
					//if (that.selectedItem == that._searchResultsItems.length-1) {
					//	that.selectedItem = 0;
					//}
				}
			});
	
			that._searchInput.on("keyup", function(){
				if ($(this).val().length == 0) {
					//очищаем маркеры и результаты поиска
					that.layer.setSource();
					that._searchResults.empty();
					that.container.removeClass("active");
				}
			});
	
			that._searchInput.focusin(function(){
				that._searchResultsItems.removeClass("active");
				that._searchInputWrapper.addClass("input-focused");
			});
	
			that._searchInput.blur(function(){
				that._searchInputWrapper.removeClass("input-focused");
			});
	
			that._searchButton.on("click", function(){
				if (that._searchInput.val() != "" && !that.nowLoading) {
					that.makeSearchRequest();
					that._searchInput.focus();
				}
			});
	
			that.container.on("click", function(e){
				if ($(e.target).hasClass("clearfix")) {
					that._searchInput.focus();
				}
			});
	
			that.container.focusin(function(){
				if (that._searchInput.val() != "" && !that._searchResults.is(":empty")) {
					that.container.addClass("active");
				}
			});
	
			that.container.focusout(function(){
				that._searchResultsItems.removeClass("active");
				that.container.removeClass("active");
			});
	
		},
	
		makeSearchRequest: function(){
			var that = this;
	
			$.ajax({
				url: that.options.url,
				method: "GET",
				data: {
					query: that._searchInput.val(),
					returnGeom: 1
				},
				beforeSend: function(){
					that.nowLoading = true;
					that._searchButton.addClass("loading");
					that.madeRequestWith = that._searchInput.val();
					that.searchResults.length = 0;
				}
			}).done(function(response){
				that.searchResults = response.results;
				that._renderResults(that.searchResults);
			}).fail(function(response){
				switch (response.status) {
					case 404:
						// сервер ничего не нашел
						that._handleEmptyAnswer();
						that.container.addClass("active");
						break;
					case 500:
						// сервер упал, всегда ваш кэп
						that._handleServerInternalError();
						that.container.addClass("active");
						break;
				}
				that.madeRequestWith = false;
			}).always(function(){
				that.nowLoading = false;
				that._searchButton.removeClass("loading");
			});
		},
	
		returnPathFromApiUrl: function(url){
			return url.replace(/(\/\/[a-zA-Z.]*)/, "");
		},
	
		_renderResults: function(response){
			var that = this;
			var $html;
			if (response.length) {
				$html = $("<ul role='results_container'></ul>");
				for (var i = 0; i < response.length; i++) {
					$html.append($(search_item({
						text: (response[i]["name"]||response[i]["address"]||response[i]["id"]),
						id: i,
						parents: response[i].parents
					})))
				}
				that._searchResults.html($html);
				that._searchResultsItems = $html.find("li[role='search_result_item']");
			} else {
				that._handleEmptyAnswer();
			}
			that.container.addClass("active");
			return $html;
		},
	
		_handleEmptyAnswer: function () {
			this._searchResults.html($("<div class='no-search-results'>По вашему запросу ничего не найдено</div>"));
		},
	
		_handleServerInternalError: function(){
			this._searchResults.html($("<div class='no-search-results'>Произошла ошибка на стороне сервера</div>"));
		},
	
		_displayGeometry: function(elemID){
			var that = this;
			var geom, geomType, geojson;
	
			if (!that.searchResults[elemID]) {
				return;
			} else {
				geomType = that.searchResults[elemID].bbox.type;
	
				geom = new ol.geom.Point(
					ol.proj.transform(that.searchResults[elemID].geom, "EPSG:4326", "EPSG:3857")
				);
			}
	
			that.map.getView().fit(geom, that.map.getSize(), {
				maxZoom: that.searchResults[elemID].zoom || 10
			});
	
			geojson = that._makeGeoJSONFromGeom({
				coordinates: that.searchResults[elemID].geom,
				type: "Point"
			});
	
			that.layer.setSource();
			that.layer.setSource( new ol.source.Vector({features: that._geojsonToFeature(geojson)}) )
		},
	
		_geojsonToFeature: function(geojson){
			var formatGeoJSON = new omjs.ol.format.GeoJSON();
	
			return  formatGeoJSON.readFeatures(geojson, {
				dataProjection: new omjs.ol.proj.Projection({code: "EPSG:3857"})
			});
		},
	
		_makeGeoJSONFromGeom: function(geom){
			var geoJSON = {};
			var geomCoordinates;
			var geomType = (geom.type.indexOf("Multi")!= -1)?
				geom.type.substring(5, geom.type.length):geom.type;
	
			geomCoordinates = omjs.ol.proj.transform(geom.coordinates, "EPSG:4326", "EPSG:3857");
	
			if (geomCoordinates.length > 1 && geom.type.indexOf("Multi")!= -1) {
				geoJSON =  {
					"type": "FeatureCollection",
					"features": []
				};
	
				for (var i = 0; i<geomCoordinates.length; i++) {
					geoJSON.features.push({
						"type": "Feature",
						"geometry": {
							"type": geomType,
							"coordinates": geomCoordinates[i]
						},
						"properties": null
					})
				}
	
			} else {
				geoJSON = {
					"type": "Feature",
					"geometry": {
						type: geom.type,
						coordinates: geomCoordinates
					},
					"properties": {}
				};
			}
	
			return geoJSON;
		}
	
	});
	
	module.exports = SearchBar;


/***/ }),
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var DropDown        = __webpack_require__(201);
	var $               = __webpack_require__(3);
	var _ 				= __webpack_require__(16);
	
	
	var MODE = {
		/* выключено - кнопка с линейкой, не подсвечена */
		OFF: 'off',
		/* рисование - кнопка с иконкой типа геометрии, подсвечена */
		DRAW: 'draw',
		/* ожидание (по концепту. По сути это редактор геометрии)
		 - кнопка с линейкой, подсвечена */
		IDLE: 'idle'
	};
	
	var defaultOptions = {
		activeClass: 'active',
		idleClass: 'idle',
	
		icon: false,
		iconActive: false
	};
	
	var MeasureToolChanger = DropDown.extend({
		initialize: function(options){
			var that = this;
			options = options || {};
			options = $.extend({}, defaultOptions, options);
			MeasureToolChanger.__super__.initialize.call(that, options);
	
			that.MODE = MODE.OFF;
			that.selectedWidget_ = false;
	
			var $container = that.getContainer();
			$container.addClass('omjs-measure-changer');
	
			/* Отписываем кнопку от предыдущих обработчиков 
			клика чтобы не было конфликтов */
			that.$actionButton.off('focus');
			that.$actionButton.on('click', that._onActionClick.bind(that));
		},
	
		onAdd: function(view){
			var that = this;
			MeasureToolChanger.__super__.onAdd.call(that, view);
			that.measurement = that.view.getMeasurement();
	
			that.measurement.on('drawstart', 	that._onDrawStart,		that);
			that.measurement.on('drawend', 		that._onDrawEnd,		that);
			that.measurement.on('modifystart', 	that._onModifyStart,	that);
			that.measurement.on('modifyend', 	that._onModifyEnd,		that);
		},
	
		_onDrawStart:function(){},
		_onDrawEnd:function(event){
			var that = this;
			that.setMode(MODE.IDLE);
			that.$actionButton.addClass(that.options.idleClass);
			that.setActionIcon(that.options.iconActive);
			that.resetActiveForItems();
			that.measurement.activateModifyInteraction(event.feature);
		},
	
		_onModifyStart:function(){},
		_onModifyEnd:function(){},
	
		__onItemClick__: function(widget, $event){
			var that = this;
			if (that.selectedWidget_ == widget && that.getMode() == MODE.DRAW) {
				that.selectedWidget_ = false;
				that.setMode(MODE.IDLE);
				that.resetActiveForItems();
				that.setActionIcon(that.options.iconActive);
				that.measurement.stopDrawInteraction();
			} else {
				that.selectedWidget_ = widget;
				that.setMode(MODE.DRAW);
				that.resetActiveForItems(true);
				that.setActiveForItem(widget);
				that.setActionIcon(widget.getActiveIcon());
				that.$actionButton.addClass(that.options.idleClass);
				that.measurement.deactivateModifyInteraction(true);
			}
			MeasureToolChanger.__super__.__onItemClick__.call(this, widget, $event);
		},
	
		_onActionClick: function(){
			var that = this;
	
			if (that.isTouch) {
				if (!that._opened) {
					that.showContainer();
				} else {
					that._turnOff();
				}
			} else {
				that._turnOff();
			}
		},
	
		resetActiveForItems: function(opt_resetActionIcon){
			var options = this.options;
			_.each(this.options.elements, function(omjsWidget){
				omjsWidget.getContainer().removeClass(options.activeClass);
				omjsWidget.unsetActiveIcon();
			});
			if (opt_resetActionIcon) {
				this.setActionIcon(null);
			}
		},
	
		setActiveForItem: function(omjsWidget){
			var options = this.options;
			var widget = _.filter(this.options.elements, function(_widget){
				return _widget == omjsWidget;
			})[0];
			widget.getContainer().addClass(options.activeClass);
			widget.setActiveIcon();
			if (widget.getIcon) {
				this.setActionIcon(widget.getIcon());
			} else {
				this.setActionIcon(null);
			}
		},
	
		_turnOff: function(){
			var that = this;
			if (that.getMode() !== MODE.OFF) {
				that.measurement.stopInteraction();
				that.selectedWidget_ = false;
				that.resetActiveForItems(true);
				that.$actionButton.removeClass(that.options.idleClass);
				that.setActionIcon(null);
				that.setMode(MODE.OFF);
			}
		},
	
		setMode: function(mode){
			var that = this;
			var available_modes = _.values(MODE);
			if (_.contains(available_modes, mode)) {
				that.MODE = mode;
			} else {
				console.warn('Неизвестный режим ['
					+ mode + ']. Режим должен быть одним из ['
					+ available_modes.join(',') + ']');
			}
		},
	
		getMode: function(){
			return this.MODE;
		}
	
	});
	
	module.exports = MeasureToolChanger;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var Class       = __webpack_require__(4),
	    Events      = __webpack_require__(6),
	    Utils       = __webpack_require__(5),
	    // $           = require("jquery"),
	    ol          = __webpack_require__(22);
	__webpack_require__(229);
	
	// TODO переводить подсказки, если снова будут использоваться
	var Measurement = Class.extend({
	
	    includes: Events,
	
	
	    /**
	     *
	     * @param map
	     * @param view
	     * @param options
	     */
	    initialize: function(map, view, options){
	        var that = this;
	
	        options || (options = {});
	
	        that.setOptions(options);
	
	        that._map = map;
	        that._view = view;
	
	        that.drawing = undefined;
	        that.sketch = undefined;
	
	        that._onDrawStart = that._onDrawStart.bind(this);
	        that._onDrawEnd = that._onDrawEnd.bind(this);
	        that._onModifyStart = that._onModifyStart.bind(this);
	        that._onModifyEnd = that._onModifyEnd.bind(this);
	        that._onModifyRemovePoint = that._onModifyRemovePoint.bind(this);
	        that._onPointGeomChange = that._onPointGeomChange.bind(this);
	        that.pointerMoveHandler = that.pointerMoveHandler.bind(this);
	        that._finishDrawing = that._finishDrawing.bind(this);
	        that.addModifyInteractionForFeature = that.addModifyInteractionForFeature.bind(this);
	
	        /* Простой флаг, который показывает редактируем 
	            мы сейчас геометрию или нет */
	        that.modifying_now = false;
	
	        that.modify_interactions = [];
	        // that.translate_interactions = [];
	
	        /* флаг для Circle геометрии. Нужен для того чтобы отличать КАК мы
	            изменяем геометрию (перетаскиваем или изменяем размеры). Это нужно
	            для того чтобы отличать когда нужно менять позицию тултипу,
	            а когда нет */
	        that.isDraggingCircleCenter = false;
	
	        that._hTooltipEl = undefined;
	        that._hTooltip = undefined;
	
	        that._mTooltipEl = undefined;
	        that._mTooltip = undefined;
	
	        that.featureIdCounter = 0;
	
	        /* Параметр для правильного отображения tooltip.
	            По дефолту ol рисует новые tooltip под старыми.*/
	        that.zTooltipIndex = 1;
	
	        that.coordsFormats = [
	            '4326',
	            '4326d',
	            '4326i'
	        ];
	
	        that.switchCoordsFormat = function(current_format){
	           current_format++;
	           if (current_format > that.coordsFormats.length - 1){
	               current_format = 0;
	           }
	           return current_format;
	        }
	
	        // Укажите начальную точку измерения
	        // Двойной клик для завершения измерения
	
	        that.MESSAGE = {
	            START: {
	                MOBILE: {}
	            },
	            CONTINUE: {
	                MOBILE: {}
	            }
	        };
	
	        that.MESSAGE.CONTINUE[ol.geom.GeometryType.POLYGON] = 
	        that.MESSAGE.CONTINUE[ol.geom.GeometryType.LINE_STRING] = 
	            'Правый клик для завершения измерения';
	
	        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.POLYGON] = 
	        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.LINE_STRING] = 
	            'Двойной тап для завершения измерения';
	
	        that.MESSAGE.CONTINUE[ol.geom.GeometryType.POINT] = 
	        that.MESSAGE.CONTINUE[ol.geom.GeometryType.CIRCLE] = 
	            'Клик для завершения измерения';
	
	        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.POINT] = 
	        that.MESSAGE.CONTINUE.MOBILE[ol.geom.GeometryType.CIRCLE] = 
	            'Тап для завершения измерения';
	
	
	        // that.continuePolygonMsg = 'Двойной клик для завершения измерения';
	        // that.continueLineMsg = 'Двойной клик для завершения измерения';
	        // that.continueCircleMsg = 'Клик для завершения измерения';
	
	        // that.mobile_continuePolygonMsg = 'Двойной тап для завершения измерения';
	        // that.mobile_continueLineMsg = 'Двойной тап для завершения измерения';
	        // that.mobile_continueCircleMsg = 'Тап для завершения измерения';        
	
	        that.toolTips = {};
	
	        that.isTouch = false;
	        try {
	            document.createEvent("TouchEvent");
	            that.isTouch = true;
	        }
	        catch (e) {}
	
	        that.currientInteraction = false;
	
	        that.source = new ol.source.Vector();
	
	        that.vector = new ol.layer.Vector({
	            source: that.source,
	            style : that.getLayerStyle()
	        });
	
	        /* стиль для OMJSModifyInteraction */
	        that.modifyStyle = that.getModifyStyle();
	
	        /* стиль для ol.interacion.Draw */
	        that.drawingStyle = [
	            new ol.style.Style({
	                stroke: new ol.style.Stroke({
	                    color: '#ffffff',
	                    width: 10,
	                }),
	            }),
	            new ol.style.Style({
	                fill: new ol.style.Fill({
	                    color: 'rgba(90, 160, 180, 0.2)'
	                }),
	                stroke: new ol.style.Stroke({
	                    color: /*'#6666ff'*/'#0086b3',
	                    lineDash: [5, 5],
	                    width: 2
	                }),
	                image: new ol.style.Circle({
	                    radius: 5,
	                    stroke: new ol.style.Stroke({
	                        color: 'rgba(0, 0, 0, 0.7)'
	                    }),
	                    fill: new ol.style.Fill({
	                        color: 'rgba(255, 255, 255, 0.6)'
	                    })
	                })
	            })
	        ];
	    },
	
	    getLayerStyle: function(scale) {
	
	        if (scale === undefined) {
	            scale = 1;
	        }
	
	        var circle = new ol.style.Circle({
	            radius: 6 * scale,
	            fill  : new ol.style.Fill({
	                color: /*'#6666ff*/'#0086b3'
	            }),
	            stroke: new ol.style.Stroke({
	              color: [255, 255, 255, 1],
	              width: 3 * scale
	            })
	        });
	
	        if (scale !== 1) {
	            circle.setScale(1 / scale);
	        }
	
	        return [
	            /* стиль для дополнительной обводки */
	            new ol.style.Style({
	                stroke: new ol.style.Stroke({
	                    color: '#ffffff',
	                    width: 10,
	                }),
	            }),
	            /* обычный стиль */
	            new ol.style.Style({
	                fill  : new ol.style.Fill({
	                    color: 'rgba(0, 134, 179, 0.2)'
	                }),
	                stroke: new ol.style.Stroke({
	                    color: '#0086b3',
	                    width: 4
	                }),
	                image : circle
	            })
	        ];
	    },
	
	    getModifyStyle: function(scale) {
	
	        if (scale === undefined) {
	            scale = 1;
	        }
	
	        var image = new ol.style.Circle({
	            radius: 6 * scale,  /* различие между двумя стилями */
	            fill: new ol.style.Fill({
	                color: /*'#6666ff'*/'#0086b3'
	            }),
	            stroke: new ol.style.Stroke({
	                color: [255, 255, 255, 1],
	                width: 3 * scale
	            })
	        });
	
	        if (scale !== 1) { 
	            image.setScale(1 / scale); 
	        }
	
	        return new ol.style.Style({
	            image: image
	        });
	    },
	
	    /**
	     * Функция для клонирования слоев на которых рисуется геометрия
	     * @param  {number} scale  - для стилей
	     * @return {ol.layer.Vector[]}
	     */
	    clone: function(scale) {
	        var that = this;
	        var layers = [];
	
	        scale = scale === undefined ? 1 : scale;
	
	        var main_geometry_layer = Utils.cloneVectorLayer(that.vector);
	            main_geometry_layer.setStyle( that.getLayerStyle(scale) );
	
	        layers.push(main_geometry_layer);
	
	        if (
	            that.modify_interactions 
	            && that.modify_interactions.length
	        ) {
	            for (var i = 0; i < that.modify_interactions.length; i++) {
	                var modification = that.modify_interactions[i];
	                if (modification instanceof ol.interaction.OMJSModify) {
	                    var vertex_layer = Utils.cloneVectorLayer(
	                        modification.custom_vertex_overlay_,
	                        {
	                            useSpatialIndex: false
	                        }
	                    );
	                    var new_style = that.getModifyStyle(scale);
	                    vertex_layer.setStyle(new_style);
	                    layers.push(vertex_layer);
	                }
	            }    
	        }
	        
	        return layers;
	    },
	
	    
	
	    _getContinueMessage: function(mobile, geom_type){
	        var that = this;
	        if (!!mobile) {
	            return that.MESSAGE.CONTINUE.MOBILE[geom_type];
	        } else {
	            return that.MESSAGE.CONTINUE[geom_type];
	        }
	    },
	
	    _getStartMessage: function(mobile, geom_type){
	        var that = this;
	        if (!!mobile) {
	            return that.MESSAGE.START.MOBILE[geom_type];
	        } else {
	            return that.MESSAGE.START[geom_type];
	        }
	    },
	
	    _dblClickZoomActive: function(active){
	        var that = this;
	        var interactions = that._map.getInteractions();
	        for (var i = 0; i < interactions.getLength(); i++) {
	            var interaction = interactions.item(i);                          
	            if (interaction instanceof ol.interaction.DoubleClickZoom) {
	                interaction.setActive(active);
	            }
	        }
	    },
	
	    /**
	     *
	     * @param polygon
	     * @return {*}
	     */
	    getArea: function(polygon){
	        var that = this,
	            area,
	            sourceProj,
	            geom,
	            coordinates,
	            output;
	
	        sourceProj = that._map.getView().getProjection();
	
	        area = Math.abs(ol.sphere.getArea(polygon));
	
	        if(area > 10000){
	            output = 'S = ' + (Math.round(area / 1000000 * 100) / 100) +
	                     ' ' + that._view.Lang.translate('км<sup>2</sup>');
	        }else{
	            output = 'S = ' + (Math.round(area * 100) / 100) +
	                     ' ' + that._view.Lang.translate('м<sup>2</sup>');
	        }
	        return output;
	    },
	
	    /**
	     *
	     * @param line
	     * @return {*}
	     */
	    getLength: function(line){
	
	        var that = this,
	            length,
	            coordinates,
	            sourceProj,
	            i, ii, c1, c2,
	            output;
	
	        coordinates = line.getCoordinates();
	        length = 0;
	        sourceProj = that._map.getView().getProjection();
	
	        for(i = 0, ii = coordinates.length - 1; i < ii; ++i){
	            c1 = ol.proj.transform(coordinates[i], sourceProj, 'EPSG:4326');
	            c2 = ol.proj.transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
	            length += ol.sphere.getDistance(c1, c2);
	        }
	
	        if(length > 100){
	            output = 'L = ' + (Math.round(length / 1000 * 100) / 100) +
	                     ' ' + that._view.Lang.translate('км');
	        }else{
	            output = 'L = ' + (Math.round(length * 100) / 100) +
	                     ' ' + that._view.Lang.translate('м');
	        }
	        return output;
	    },
	
	    getPointCoords: function(geometry, mode){
	        var that = this;
	        var coordinates = geometry.getCoordinates();
	        var sourceProj = that._map.getView().getProjection();
	        var convertedCoords;
	        var output;
	
	        switch(mode){
	            case '4326d':
	                convertedCoords = that._ddToDms(ol.proj.transform(coordinates, sourceProj, 'EPSG:4326').reverse());
	                return convertedCoords.join(", ");
	            case '4326i':
	                convertedCoords = ol.proj.transform(coordinates, sourceProj, 'EPSG:4326');
	                return ol.coordinate.format(convertedCoords, '{y}, {x}', 6);
	                return
	            default:
	                convertedCoords = ol.proj.transform(coordinates, sourceProj, 'EPSG:4326');
	                return ol.coordinate.format(convertedCoords, 'X = {x}<br />Y = {y}', 6);
	        }
	
	        return output;
	    },
	
	    _ddToDms: function (coords) {
	        var that = this;
	        var lat  = coords[0];
	        var lng  = coords[1];
	        var latResult, lngResult, dmsResult;
	
	        lat = parseFloat(lat);
	        lng = parseFloat(lng);
	
	        latResult = (lat >= 0) ? 'N ' : 'S ';
	
	        // Call to getDms(lat) function for the coordinates of Latitude in DMS.
	        // The result is stored in latResult variable.
	        latResult += that._getDms(lat);
	
	        lngResult = (lng >= 0) ? 'E ' : 'W ';
	
	        // Call to getDms(lng) function for the coordinates of Longitude in DMS.
	        // The result is stored in lngResult variable.
	        lngResult += that._getDms(lng);
	
	        // Joining both variables and separate them with a space.
	        dmsResult = latResult + ' ' + lngResult;
	
	        // Return the resultant string
	        return [latResult, lngResult];
	    },
	
	    _getDms: function (val) {
	        var valDeg, valMin, valSec, result;
	
	        val = Math.abs(val);
	
	        valDeg = Math.floor(val);
	        result = valDeg + "º";
	
	        valMin = Math.floor((val - valDeg) * 60);
	        result += valMin + "'";
	
	        valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
	        result += valSec + '"';
	
	        return result;
	    },
	
	    _getCircleRadiusInMeters: function(circle_geom){
	        if (circle_geom.getType() !== ol.geom.GeometryType.CIRCLE) {
	            return false;
	        }
	        var that = this;
	        var center = circle_geom.getCenter();
	        var radius = circle_geom.getRadius();
	        var edgeCoordinate = [center[0] + radius, center[1]];
	        var groundRadius = ol.sphere.getDistance(
	            ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326'), 
	            ol.proj.transform(edgeCoordinate, 'EPSG:3857', 'EPSG:4326')
	        );
	        if(groundRadius > 100){
	            groundRadius = 'R = ' + (Math.round(groundRadius / 1000 * 100) / 100) +
	                ' ' + that._view.Lang.translate('км');
	        }else{
	            groundRadius = 'R = ' + groundRadius.toFixed(6) +
	                ' ' + that._view.Lang.translate('м');
	        }
	        return groundRadius;
	    },
	
	    /**
	     *
	     * @param evt
	     */
	    pointerMoveHandler: function(evt){
	
	        var that    = this,
	            helpMsg = 'Укажите начальную точку измерения',
	            tooltipCoord,
	            output,
	            geom;
	
	        if (evt.geom) {
	            geom = evt.geom;
	        } else if (that.sketch) {
	            geom = (that.sketch.getGeometry());
	        }
	
	        if(
	            (evt.dragging && !that.isTouch && !that.modifying_now)
	            || (geom && geom.getType() == ol.geom.GeometryType.POINT)
	        ){
	            return;
	        }
	
	        // if (that._getActive(that.modify_interactions)) {
	        //     that.highlightDots(evt);
	        // }
	
	        tooltipCoord = evt.coordinate;
	
	        if(that.sketch){
	            switch (geom.getType()) {
	                /* Если геометрия типа POLYGON */
	                case ol.geom.GeometryType.POLYGON:
	                    output = that.getArea(geom);
	
	                    helpMsg = that.isTouch 
	                            ? that._getContinueMessage(true, geom.getType())
	                            : that._getContinueMessage(false, geom.getType());
	
	                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
	                    break;
	
	                /* Если геометрия типа LINE_STRING */
	                case ol.geom.GeometryType.LINE_STRING:
	                    output = that.getLength(geom);
	
	                    helpMsg = that.isTouch 
	                            ? that._getContinueMessage(true, geom.getType())
	                            : that._getContinueMessage(false, geom.getType());
	
	                    tooltipCoord = geom.getLastCoordinate();
	                    break;
	
	                /* Если геометрия типа CIRCLE */
	                case ol.geom.GeometryType.CIRCLE:
	                    output = that._getCircleRadiusInMeters(geom);
	
	                    helpMsg = that.isTouch 
	                            ? that._getContinueMessage(true, geom.getType())
	                            : that._getContinueMessage(false, geom.getType());
	
	                    var circleCenter_ = geom.getCenter();
	
	                    if (!that.isDraggingCircleCenter) {
	                        /* если мы тащим круг не за центр (т.е. не перемещаем,
	                            действительно изменяем геометрию) */
	                        
	
	                        var firstCoordinate = geom.getLastCoordinate();
	                        var angle = Math.atan2(
	                                firstCoordinate[1]-circleCenter_[1], 
	                                firstCoordinate[0]-circleCenter_[0]
	                            ) - Math.atan2(
	                                tooltipCoord[1] - circleCenter_[1], 
	                                tooltipCoord[0] - circleCenter_[0]
	                            );
	                        tooltipCoord = evt.coordinate;
	
	                        geom.set('tooltipAngle', -angle, true);
	                    } else {
	                        /* если мы перемещаем круг (тащим куда-то за центр), то
	                            мы должны высчитать новую координату для тултипа
	                            используя угол, на котором у нас находится тултип */
	
	                        tooltipCoord = [
	                            circleCenter_[0] + (geom.getRadius() * Math.cos(geom.get('tooltipAngle'))),
	                            circleCenter_[1] + (geom.getRadius() * Math.sin(geom.get('tooltipAngle')))
	                        ];
	
	                    }
	
	                    // tooltipCoord = geom.getCenter();
	                    break;
	
	                // /* Если геометрия типа POINT */
	                // case ol.geom.GeometryType.POINT:
	                //     output = that.getPointCoords(geom);
	
	                //     helpMsg = that.isTouch 
	                //             ? that._getContinueMessage(true, geom.getType())
	                //             : that._getContinueMessage(false, geom.getType());
	
	                //     tooltipCoord =  geom.getLastCoordinate();
	                //     break;
	            }
	
	            if (that.sketch) {
	                var tooltip = that.toolTips[that.sketch.getId()];
	                tooltip.getElement().innerHTML = output;
	                tooltip.setPosition(tooltipCoord);
	            }
	        } else {
	            if (that.isTouch)  {
	                // that._hTooltipEl.style.display = 'none';
	                return;
	            }
	        }
	
	         // выставляем позицию только если мы в данный момент рисуем
	         //    и рисуем HE точку 
	        // if (that.drawing.getActive()) {
	            /* не выставляем хелпер тултип если мы на таче и рисуем точку */
	            // if (that.sketch 
	                // && geom.getType() == ol.geom.GeometryType.POINT 
	                // && that.isTouch) {
	                // return;
	            // }
	            // that._hTooltipEl.style.display = '';
	            // that._hTooltipEl.innerHTML = helpMsg;
	            // that._hTooltip.setPosition(evt.coordinate);
	        // } else {
	            // that._hTooltipEl.style.display = 'none';
	        // }
	        
	    },
	
	    /**
	     *
	     */
	    // createHelpTooltip: function(){
	    //     var that = this;
	
	    //     if(that._hTooltipEl){
	    //         that._hTooltipEl.parentNode.removeChild(that._hTooltipEl);
	    //     }
	    //     that._hTooltipEl = document.createElement('div');
	    //     that._hTooltipEl.className = 'omjs-tooltip';
	    //     that._hTooltip = new ol.Overlay({
	    //         element    : that._hTooltipEl,
	    //         offset     : [15, 0],
	    //         positioning: 'center-left'
	    //     });
	    //     that._map.addOverlay(that._hTooltip);
	    // },
	
	    /**
	     *
	     */
	    createMeasureTooltip: function(){
	        var that = this;
	        //that._mTooltipEl
	        //that._mTooltip
	        var tooltip_el = document.createElement('div');
	
	        // omjs-tooltip tooltip-static
	        tooltip_el.className = 'omjs-tooltip tooltip-static measurement-tooltip';
	        // задаем правильный порядок отображения
	        tooltip_el.style.zIndex = that.zTooltipIndex;
	
	        var tooltip = new ol.Overlay({
	            element    : tooltip_el,
	            offset     : [0, -15],
	            positioning: 'bottom-center',
	        });
	        that._map.addOverlay(tooltip);
	        return tooltip;
	    },
	
	    /**
	     *
	     * @param itype
	     */
	    createInteraction: function(itype){
	        var that = this,
	            type;
	
	        that._view.on('finish_drawing', that._finishDrawing);
	
	        switch(itype) {
	            case 'Circle':
	                type = itype = that.draw_type = ol.geom.GeometryType.CIRCLE;
	                break;
	            case 'Point':
	                type = itype = that.draw_type = ol.geom.GeometryType.POINT;
	                break;
	            case 'area':
	                type = itype = that.draw_type = ol.geom.GeometryType.POLYGON;
	                break;
	            case 'distance':
	                type = itype = that.draw_type = ol.geom.GeometryType.LINE_STRING;
	                break;
	            default:
	                type = itype = that.draw_type = ol.geom.GeometryType.POINT;
	                break;
	        }
	
	        that.drawing = that.createDrawInteraction(
	                that.source,
	                that.drawingStyle,
	                type
	            );
	
	        that._map.addInteraction(that.drawing);
	
	        // that.createHelpTooltip();
	
	        that.drawing.on('drawstart', that._onDrawStart);
	        that.drawing.on('drawend', that._onDrawEnd);
	
	        
	    },
	
	    createDrawInteraction: function(source, style, type){
	        var that = this;
	        var drawInteraction;
	        drawInteraction = new ol.interaction.Draw({
	            source: source,
	            style: style,
	            type: type,
	            geometryFunction: function(coords, geom){
	                if (type == ol.geom.GeometryType.CIRCLE) {
	                    var circle = geom ? (geom) : new ol.geom.Circle([NaN, NaN]);
	                    var squaredLength = ol.coordinate.squaredDistance(
	                        coords[0], coords[1]);
	                    circle.setCenterAndRadius(coords[0], Math.sqrt(squaredLength));
	                    return circle;
	                } else {
	                    if (!geom) {
	                        geom = new ol.geom[type](coords);
	                    }
	                    geom.setCoordinates(coords);
	                    if (that.isTouch) {
	                        that.pointerMoveHandler({
	                            coordinate: geom.getLastCoordinate(),
	                            geom: geom
	                        });
	                    }
	                    return geom;
	                }
	            }
	        });
	
	        return drawInteraction;
	    },
	
	    _onDrawStart: function(evt){
	        var that = this;
	        /* На время рисовки отключаем зум по двойному */
	        that._dblClickZoomActive(false);
	        that.sketch = evt.feature;
	        that.sketch.setId(++that.featureIdCounter);
	        var geom = that.sketch.getGeometry();
	
	        var tooltip = that.createMeasureTooltip();
	        var tooltipId = evt.feature.getId();
	        that.toolTips[tooltipId] = tooltip;
	
	        if (geom.getType() == ol.geom.GeometryType.POINT) {
	            tooltip.coordsFormat = 0;
	
	            that._onPointGeomChange({
	                target: geom
	            });
	
	            $(tooltip.getElement()).on('click', '.switch-coords-format', function(){
	                tooltip.coordsFormat = that.switchCoordsFormat(tooltip.coordsFormat);
	
	                that._onPointGeomChange({
	                    target: geom
	                }, tooltipId);
	            });
	
	            // that.pointerMoveHandler({
	            //     geom: geom,
	            //     feature: evt.feature
	            // });
	        }
	        if (
	                that.isTouch
	                /* не выполняем вызов pointerMove второй раз */
	                && geom.getType() != ol.geom.GeometryType.POINT
	            ) {
	            that.pointerMoveHandler({
	                coordinate: geom.getLastCoordinate(),
	                geom: geom,
	                feature: evt.feature
	            });
	        }
	        that.fire('drawstart', evt);
	        // инкрементируем параметр для будущих tooltip
	        that.zTooltipIndex += 1;
	    },
	    _onDrawEnd: function(evt){
	        var that = this;
	        /* Включаем зум по двойному клику после того 
	            как мы закончили рисовать */
	        setTimeout(function(){
	            that._dblClickZoomActive(true);
	        }, 10);
	
	        if (that.isTouch)  {
	            // that._hTooltipEl.style.display = 'none';
	
	            var geom = evt.feature.getGeometry();
	            that.pointerMoveHandler({
	                coordinate: geom.getLastCoordinate(),
	                geom: geom,
	                feature: evt.feature
	            });
	        }
	        // that._mTooltipEl.className = 'omjs-tooltip tooltip-static';
	        // that._mTooltip.setOffset([0, -7]);
	
	        that.sketch = null;
	        that.createMeasureTooltip();
	
	        var feature = evt.feature;
	        var feature_geom = feature.getGeometry();
	
	        if (feature_geom.getType() == ol.geom.GeometryType.POLYGON) {
	            /* """""фикс"""""
	                при редактировании нарисованной геометрии куда-то 
	                пропадает возможность редактирования последнего сегмента
	                геометрии. Тут мы просто добавляем первую координату в 
	                конец геометрии чтобы "замкнуть" полигон.
	             */
	            var polygon_coords = feature_geom.getCoordinates()[0];
	            var first_coord = polygon_coords[0];
	            polygon_coords.push(first_coord);
	            feature.setGeometry(new ol.geom.Polygon([polygon_coords]));
	        }
	        
	
	        that.fire('drawend', evt);
	    },
	
	    _finishDrawing: function(event){
	        var that = this;
	        if (that.drawing && that.drawing.getActive()) {
	            that.drawing.addToDrawing_(event);
	            that.drawing.finishDrawing();
	        }
	    },
	
	    // _convertToPointerUpEvent: function(event) {
	    //     var originalEvent = event.originalEvent;
	    //     event.type = 'pointerup';
	
	    //     return event;
	    // },
	
	    _onPointGeomChange: function(event, tooltip_id){
	        var that = this;
	        var tooltipCoord, 
	            geom = event.target,
	            output,
	            helpMsg;
	        /* Если геометрия типа POINT */
	        tooltip_id = tooltip_id || that.sketch.getId();
	        var tooltip = that.toolTips[tooltip_id];
	
	        output = '<div>' + that.getPointCoords(geom, that.coordsFormats[tooltip.coordsFormat]) + '</div>';
	        output += '<div class="switch-coords-format" title="' +
	            that._view.Lang.translate('Сменить формат координат') + '" />';
	    
	        helpMsg = that.isTouch 
	                ? that._getContinueMessage(true, geom.getType())
	                : that._getContinueMessage(false, geom.getType());
	    
	        tooltipCoord =  geom.getCoordinates();
	
	
	        tooltip.getElement().innerHTML = output;
	        tooltip.setPosition(tooltipCoord);
	    },
	
	    activateModifyInteraction: function(created_feature){
	        var that = this;
	
	        that.drawing.setActive(false);
	
	        if (created_feature) {
	            // мы добавили новую фичу, нужно для нее добавить interaction
	            this.addModifyInteractionForFeature(created_feature);
	            if (created_feature.getGeometry().getType() == ol.geom.GeometryType.POINT) {
	                created_feature.getGeometry().on('change', that._onPointGeomChange);
	            }
	        }
	
	        if (!that.modify_interactions.length) {
	            created_feature = created_feature ? [created_feature] : [];
	
	            var source_features = [].concat(
	                                        that.source.getFeatures(),
	                                        created_feature
	                                    );
	
	            _.each(source_features, function(feature){
	                var feature_geom = feature.getGeometry();
	                if (feature_geom.getType() == ol.geom.GeometryType.POINT) {
	                    feature_geom.on('change', that._onPointGeomChange);
	                }
	            });
	
	            that._regenerateModifyInteractions(source_features);
	
	            /* Генерируем по 1 ol.interaction.Translate на 1 фичу */
	            // TODO: выключено до того как поймем как сделать так чтобы
	            //      interaction'ы не конфликтовали между собой.
	            // _.each(polygon_features, function(polygonFeature){
	            //     var interaction = new ol.interaction.Translate({
	            //         features: new ol.Collection([polygonFeature]),
	            //         hitTolerance: 1
	            //     });
	
	            //     interaction.on('translatestart', that._onTranslateStart, that);
	            //     interaction.on('translateend',   that._onTranslateEnd,   that);
	
	            //     that.translate_interactions.push(interaction);
	            //     that._map.addInteraction(interaction);
	            // });
	        } else {
	            that._setActive(that.modify_interactions, true);
	        }
	    },
	
	    deactivateModifyInteraction: function(without_removing){
	        var that = this;
	        if (without_removing) {
	            if (that.modify_interactions.length) {
	                that._setActive(that.modify_interactions, false);
	            }
	        } else {
	            /* Убираем все interaction для перемещения полигонов */
	            // that._removeInteraction(that.translate_interactions);
	
	            /* Убираем все interaction по модифицированию геометрии */
	            that._removeInteraction(that.modify_interactions);
	            
	            that.modify_interactions = [];
	            // that.translate_interactions = [];
	        }
	        /* Включаем рисование обратно */
	        that.drawing.setActive(true);
	    },
	
	    _regenerateModifyInteractions: function(features){
	        /* Генерируем по 1 ol.interaction.OMJSModify на 1 фичу */
	        _.each(features, this.addModifyInteractionForFeature);
	    },
	
	    addModifyInteractionForFeature: function(feature){
	        var that = this;
	        var feature_geom_type = feature.getGeometry().getType();
	        var interaction;
	        /* Если это линия или полигон, то подставляем модифицированную
	            версию ol.interaction.Modify */
	        if (ol.interaction.OMJSModify.AVAILABLE_GEOMTYPES
	                                    .indexOf(feature_geom_type) != -1) 
	        {
	            interaction = new ol.interaction.OMJSModify({
	                features: new ol.Collection([feature]),
	                style: that.modifyStyle
	            });
	        } else {
	            interaction = new ol.interaction.Modify({
	                features: new ol.Collection([feature]),
	                style: that.modifyStyle
	            });
	        }
	        this.modify_interactions.push(interaction);
	
	        interaction.on('modifystart',   this._onModifyStart);
	        interaction.on('modifyend',     this._onModifyEnd);
	        interaction.on('removepoint',   this._onModifyRemovePoint);
	
	        this._map.addInteraction(interaction);
	    },
	
	    _onModifyStart: function(event){
	        var that = this;
	
	        that.modifying_now = true;
	        that.sketch = event.features.item(0);
	
	        // TODO: вынести в OMJSInteraction (начало)
	        var sketchGeometry = that.sketch.getGeometry(),
	            _interaction = event.target,
	            fromGeomCenterDistance = 0;
	
	        if (
	            sketchGeometry.getType() == ol.geom.GeometryType.CIRCLE
	            && _interaction instanceof ol.interaction.Modify
	        ) {
	            fromGeomCenterDistance = ol.coordinate.distance(
	                that._map.getPixelFromCoordinate(sketchGeometry.getCenter()),
	                event.mapBrowserEvent.pixel
	            );
	
	            if (fromGeomCenterDistance < _interaction.pixelTolerance_) {
	                that.isDraggingCircleCenter = true;
	            } else {
	                that.isDraggingCircleCenter = false;
	            }
	        } else {
	            that.isDraggingCircleCenter = false;
	        }
	        event.isDraggingCircleCenter = that.isDraggingCircleCenter;
	        // TODO: вынести в OMJSInteraction (конец)
	
	        that.fire('modifystart', event);
	
	    },
	
	    _onModifyEnd: function(event){
	        var that = this;
	
	        that.modifying_now = false;
	        that.sketch = false;
	        that.isDraggingCircleCenter = false;
	
	        var feature = event.features.item(0);
	        var feature_geom = feature.getGeometry();
	        that.pointerMoveHandler({
	            coordinate: feature_geom.getLastCoordinate(),
	            geom: feature_geom,
	            feature: feature
	        });
	
	        that.fire('modifyend', event);
	    },
	
	    _onModifyRemovePoint: function(event){
	        var features = event.features;
	        var feature = features.item(0);
	        var feature_geom = feature.getGeometry();
	        var toolTip = this.toolTips[feature.getId()];
	        switch (feature_geom.getType()) {
	            case ol.geom.GeometryType.POLYGON:
	                toolTip.setPosition(feature_geom.getInteriorPoint().getCoordinates());
	                toolTip.getElement().innerHTML = this.getArea(feature_geom);
	                break;
	
	            case ol.geom.GeometryType.LINE_STRING:
	                toolTip.setPosition(feature_geom.getLastCoordinate());
	                toolTip.getElement().innerHTML =this.getLength(feature_geom);
	                break;
	        }
	    },
	
	    _onTranslateStart: function(event) {
	        var that = this;
	
	        that.modifying_now = true;
	        that.sketch = event.features.item(0);
	
	        that.fire('translatestart', event);
	
	    },
	
	    _onTranslateEnd: function(event){
	        var that = this;
	
	        that.modifying_now = false;
	        that.sketch = false;
	
	        that.fire('translateend', event);
	    },
	
	    generateDistanceTooltip: function(geometry){
	        var that = this;
	        var outerElement = document.createElement('div');
	            outerElement.className = 'omjs-tooltip tooltip-static';
	
	        var olOverlay = new ol.Overlay({
	            element    : outerElement,
	            offset     : [0, -7],
	            positioning: 'bottom-center'
	        });
	
	        switch(geometry.getType()) {
	            case ol.geom.GeometryType.CIRCLE:
	                outerElement.textContent = that._getCircleRadiusInMeters(
	                                                    geometry
	                                                );
	
	                olOverlay.setPosition(geometry.getCenter());
	                break;
	            case ol.geom.GeometryType.POINT:
	                outerElement.innerHTML = that.getPointCoords(geometry, '4326');
	                olOverlay.setPosition(geometry.getCoordinates());
	                break;
	            case ol.geom.GeometryType.POLYGON:
	                outerElement.innerHTML = that.getArea(geometry);
	                olOverlay.setPosition(
	                    geometry.getInteriorPoint().getCoordinates()
	                );
	                break;
	            case ol.geom.GeometryType.LINE_STRING:
	                outerElement.textContent = that.getLength(geometry);
	                olOverlay.setPosition(geometry.getLastCoordinate());
	                break;
	            default:
	                return false;
	        }
	
	        return olOverlay;
	    },
	
	    /**
	     *
	     * @param itype
	     */
	    changeInteraction: function(interactionType){
	        var that = this;
	
	        if(that.currientInteraction == interactionType){
	            if (!!that.modify_interactions.length 
	                && !that._getActive(that.modify_interactions)) {
	                that._setActive(that.modify_interactions, true);
	            }
	            // that.stopInteraction();
	        } else {
	            if(that.currientInteraction == false){
	                /* добавляем новый слой и подписываемся на ивенты только если
	                    у нас уже векторный слой не добавлен на карту
	                    это нужно для того чтобы отличать когда у нас есть 
	                    ol.interaction.Draw на карте а когда нет. Нужно чтобы
	                    мы могли отключить режим рисования посреди процесса 
	                    рисования */
	                if (!_.contains(that._map.getLayers().getArray(), that.vector)) {
	                    that._map.addLayer(that.vector);
	                    if (that.isTouch) {
	                        that._map.on('pointerdrag', that.pointerMoveHandler);
	                    } else {
	                        that._map.on('pointermove', that.pointerMoveHandler);
	                    }
	                }
	            }else{
	                that._map.removeInteraction(that.drawing);
	                that.drawing = false;
	            }
	            that.createInteraction(interactionType);
	            that.currientInteraction = interactionType;
	            that.fire('measureChanged', {measureType: interactionType});
	        }
	    },
	
	    /**
	     *
	     */
	    stopInteraction: function(){
	        var that = this;
	
	        that.sketch = null;
	        that.featureIdCounter = 0;
	        that._map.un('pointermove', that.pointerMoveHandler);
	        that._map.un('click', that.pointerMoveHandler);
	        that._view.off('finish_drawing', that._finishDrawing);
	        that._map.removeInteraction(that.drawing);
	        if (!!that.modify_interactions.length) {
	            that._removeInteraction(that.modify_interactions);
	            that.modify_interactions = [];
	        }
	        // that._map.removeOverlay(that._hTooltip);
	
	        //$(that._mTooltip.getElement()).remove();
	        //that._mTooltipEl = void(0);
	        //that._hTooltip = void(0);
	        //that._mTooltip = void(0);
	
	        that._map.removeLayer(that.vector);
	        that.source.clear();
	        that.currientInteraction = false;
	
	        _.each(that.toolTips, function(tooltip){
	            that._map.removeOverlay(tooltip);
	        });
	        that.toolTips = {};
	
	        that.fire('measureChanged', {measureType: false});
	    },
	
	    stopDrawInteraction: function(){
	        var that = this;
	        that._view.off('finish_drawing', that._finishDrawing);
	        if (that.drawing) {
	            that._map.removeInteraction(that.drawing);
	            that.drawing = false;
	            that.currientInteraction = false;
	        }
	        if (that.sketch) {
	            that.sketch = false;
	            var toolTipKeys = _.keys(that.toolTips);
	            that._map.removeOverlay(
	                that.toolTips[toolTipKeys[toolTipKeys.length - 1]]
	            );
	        }
	        // that._map.removeOverlay(that.toolTips.pop());
	    },
	
	    _setActive: function(interactions_array, value){
	        _.each(interactions_array, function(interaction){
	            interaction.setActive(value);
	        });
	    },
	
	    _getActive: function(interactions_array){
	        var _active = true;
	        for (var i = 0; i < interactions_array.length; i++) {
	            _active = _active && interactions_array[i].getActive();
	            if (!_active) break; 
	        }
	        return _active;
	    },
	
	    _removeInteraction: function(interactions_array){
	        var that = this;
	        _.each(interactions_array, function(interaction){
	            that._map.removeInteraction(interaction);
	        });
	        // сбрасываем параметр порядка отображения tooltip
	        that.zTooltipIndex = 1;
	    },
	
	    setVisible: function(value){
	        var that = this;
	        that.vector.setVisible(value);
	        _.each(that.modify_interactions, function(interaction){
	            if (interaction.getCustomVertexOverlay) {
	                var custom_vertex = interaction.getCustomVertexOverlay();
	                custom_vertex.setVisible(value);
	            }
	        });
	    }
	
	});
	
	module.exports = Measurement;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var ol = __webpack_require__(22);
	// var _ = require('underscore');
	var Utils = __webpack_require__(5);
	
	var AVAIL_GEOM = [
	    ol.geom.GeometryType.POLYGON,
	    ol.geom.GeometryType.LINE_STRING
	];
	
	ol.interaction.OMJSModify = function(options) {
		ol.interaction.Modify.call(this, options);
	    this.handleDragEvent   = ol.interaction.OMJSModify.handleDragEvent;
	    this.handleDownEvent   = ol.interaction.OMJSModify.handleDownEvent;
	    this.handleUpEvent     = ol.interaction.OMJSModify.handleUpEvent;
	    this.handleEvent       = ol.interaction.OMJSModify.handleEvent;
	
	    this.defaultDeleteCondition_ = function(mapBrowserEvent) {
	        return mapBrowserEvent.type == ol.MapBrowserEventType.SINGLECLICK;
	    };
	
	    this.deleteCondition_ = options.deleteCondition ?
	      options.deleteCondition : this.defaultDeleteCondition_;
	
	    var that = this;
	
	    /* массив со всеми точками для редактирования */
	    this.vertexFeatures_ = [];
	
	    this.snappedVertex_ = false;
	
	    /* флаг, показывающий создаем ли мы сейчас новую вершину */
	    this.creatingNewVertex_ = false;
	
	    /* флаг, показывающий редактируется ли геометрия в рамках OMJSModify
	        (нужно для того чтобы отличать когда геометрия редактируется из других
	        interaction'ов) */
	    this.modifying_now_ = false;
	
	    /* флаг, меняется при .setActive(active) */
	    this._active_ = true;
	
	    /* проверка на тач */
	    this.isTouch_ = Utils.isTouch();
	
	    var white = [255, 255, 255, 1];
	    var width = this.pixelTolerance_;
	
	    /* Дефолтные стили взяты из ol.style.Style.defaultFunction */
	    this.defaultFeatureStyle = new ol.style.Style({
	      image: new ol.style.Circle({
	        radius: 6,  /* различие между двумя стилями */
	        fill: new ol.style.Fill({
	          color: /*'#6666ff'*/'#0086b3'
	        }),
	        stroke: new ol.style.Stroke({
	          color: white,
	          width: 3
	        })
	      })
	    });
	
	    ol.interaction.OMJSModify.highlightedVertexStyle = 
	    this.highlightedVertexStyle = new ol.style.Style({
	      image: new ol.style.Circle({
	        radius: width,  /* различие между двумя стилями */
	        fill: new ol.style.Fill({
	          color: /*'#6666ff'*/'#0086b3'
	        }),
	        stroke: new ol.style.Stroke({
	          color: white,
	          width: 3
	        })
	      })
	    });
	
	    this.custom_vertex_overlay_ = new ol.layer.Vector({
	        source: new ol.source.Vector({
	          useSpatialIndex: false,
	          wrapX: !!options.wrapX
	        }),
	        style: options.style ? options.style :
	            ol.interaction.Modify.getDefaultStyleFunction(),
	        updateWhileAnimating: true,
	        updateWhileInteracting: true
	    });
	
	    this.features_.forEach(function(_feature){
	        _feature.on('change', function(event){
	            if (event.type == 'change') {
	                if (!that.modifying_now_) {
	                    that.rerenderVertices();
	                }
	            }
	        }); 
	    });
	
	    this.rerenderVertices();
	};
	ol.inherits(ol.interaction.OMJSModify, ol.interaction.Modify);
	
	ol.interaction.OMJSModify.prototype.getCustomVertexOverlay = function(){
	  return this.custom_vertex_overlay_;
	};
	
	ol.interaction.OMJSModify.prototype.createOrUpdateVertexFeature_ = function(coordinates){
	    var vertexFeature;
	    var that = this;
	
	    if (!this.snappedVertex_) {
	        vertexFeature = this.vertexFeature_;
	        if (!vertexFeature) {
	            vertexFeature = new ol.Feature(new ol.geom.Point(coordinates));
	            this.vertexFeature_ = vertexFeature;
	            this.overlay_.getSource().addFeature(vertexFeature);
	        } else {
	            var geometry = /** @type {ol.geom.Point} */ (vertexFeature.getGeometry());
	            geometry.setCoordinates(coordinates);
	        }
	        if (this.creatingNewVertex_) {
	            this.setHighlightStylesForFeature(vertexFeature);
	        } else {
	            vertexFeature.setStyle();
	        }
	    } else {
	        var vertex_feature = this.snappedVertex_ || this.findVertexByCoords(coordinates);
	        if (coordinates && vertex_feature) {
	            that.setHighlightStylesForFeature(vertex_feature);
	            vertex_feature.getGeometry().setCoordinates(coordinates);
	        }
	    }
	};
	
	ol.interaction.OMJSModify.prototype.createVertexFeature_ = function(start, end, segment_index){
	    var feature,
	        start_segment;
	
	    if (segment_index == 0) {
	        start_segment = new ol.Feature(new ol.geom.Point(start));
	        this.custom_vertex_overlay_.getSource().addFeature(start_segment);
	        this.vertexFeatures_.push(start_segment);
	    }
	
	    feature = new ol.Feature(new ol.geom.Point(end));
	    this.custom_vertex_overlay_.getSource().addFeature(feature);
	    this.vertexFeatures_.push(feature);
	
	};
	
	ol.interaction.OMJSModify.prototype.handlePointerAtPixel_ = function(pixel, map){
	    var vertex_feature;
	
	    var pixelCoordinate = map.getCoordinateFromPixel(pixel);
	    var sortByDistance = function(a, b) {
	      return ol.interaction.Modify.pointDistanceToSegmentDataSquared(pixelCoordinate, a) -
	          ol.interaction.Modify.pointDistanceToSegmentDataSquared(pixelCoordinate, b);
	    };
	
	    var box = ol.extent.buffer(
	        ol.extent.createOrUpdateFromCoordinate(pixelCoordinate),
	        map.getView().getResolution() * this.pixelTolerance_);
	
	    var rBush = this.rBush_;
	    var nodes = rBush.getInExtent(box);
	    if (nodes.length > 0) {
	        nodes.sort(sortByDistance);
	        var node = nodes[0];
	        var closestSegment = node.segment;
	        var vertex = ol.interaction.Modify.closestOnSegmentData(pixelCoordinate, node);
	        var vertexPixel = map.getPixelFromCoordinate(vertex);
	        var dist = ol.coordinate.distance(pixel, vertexPixel);
	        if (dist <= this.pixelTolerance_) {
	          var vertexSegments = {};
	
	            if (
	                node.geometry.getType() === ol.geom.GeometryType.CIRCLE 
	                // TODO: MODIFY_SEGMENT_CIRCLE_CIRCUMFERENCE_INDEX больше нет
	                && node.index === ol.interaction.Modify.MODIFY_SEGMENT_CIRCLE_CIRCUMFERENCE_INDEX
	            ) {
	              this.snappedToVertex_ = true;
	              this.createOrUpdateVertexFeature_(vertex);
	            } else {
	                var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
	                var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
	                var squaredDist1 = ol.coordinate.squaredDistance(vertexPixel, pixel1);
	                var squaredDist2 = ol.coordinate.squaredDistance(vertexPixel, pixel2);
	                dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
	                this.snappedToVertex_ = dist <= this.pixelTolerance_;
	
	                if (this.snappedToVertex_) {
	                    vertex = squaredDist1 > squaredDist2 ?
	                        closestSegment[1] : closestSegment[0];
	
	                    vertex_feature = this.snappedVertex_ = this.findVertexByCoords(vertex);
	                    if (vertex_feature) {
	                        this.setHighlightStylesForFeature(vertex_feature);
	                        if (this.vertexFeature_) {
	                            this.overlay_.getSource().removeFeature(this.vertexFeature_);
	                            this.vertexFeature_ = false;
	                        }
	                        // this.vertexFeature_ = vertex_feature;
	                    }
	                } else {
	                    this.snappedVertex_ = false;
	
	                    this.resetHighlightStyles();
	                    this.createOrUpdateVertexFeature_(vertex);
	                }
	
	            var segment;
	            for (var i = 1, ii = nodes.length; i < ii; ++i) {
	              segment = nodes[i].segment;
	              if ((ol.coordinate.equals(closestSegment[0], segment[0]) &&
	                  ol.coordinate.equals(closestSegment[1], segment[1]) ||
	                  (ol.coordinate.equals(closestSegment[0], segment[1]) &&
	                  ol.coordinate.equals(closestSegment[1], segment[0])))) {
	                vertexSegments[ol.getUid(segment)] = true;
	              } else {
	                break;
	              }
	            }
	          }
	
	          vertexSegments[ol.getUid(closestSegment)] = true;
	          this.vertexSegments_ = vertexSegments;
	          return;
	        }
	    }
	
	    if (!vertex_feature) {
	        this.resetHighlightStyles();
	    }
	
	    if (this.vertexFeature_) {
	      this.overlay_.getSource().removeFeature(this.vertexFeature_);
	      this.vertexFeature_ = null;
	    }
	
	    if (this.snappedVertex_) {
	        this.snappedVertex_ = null;
	        this.resetHighlightStyles();
	    }
	};
	
	ol.interaction.OMJSModify.handleDownEvent = function(evt) {
	    if (!this.condition_(evt)) {
	        return false;
	    }
	
	    this.modifying_now_ = true;
	
	    this.dragSegments_.length = 0;
	    this.modified_ = false;
	
	    var newVertexFeature_ = this.vertexFeature_ || this.snappedVertex_;
	
	
	    if (!this.snappedVertex_ && this.vertexFeature_) {
	    /* если мы кликнули не на снэпнутой вершине,
	        то мы создаем новую точку. Нужно об этом дать знать функции  */
	        this.creatingNewVertex_ = true;
	    } else {
	        this.creatingNewVertex_ = false;
	    }
	
	    this.handlePointerAtPixel_(evt.pixel, evt.map);
	
	    /* хак для тачей потому что vertexFeature_ появится на тачах только 
	        полсе выполнения функции handlePointerAtPixel_ */
	    if (this.isTouch_) {
	        newVertexFeature_ = this.vertexFeature_ || this.snappedVertex_;
	
	        if (!this.snappedVertex_ && this.vertexFeature_) {
	        /* если мы кликнули не на снэпнутой вершине,
	            то мы создаем новую точку. Нужно об этом дать знать функции  */
	            this.creatingNewVertex_ = true;
	        } else {
	            this.creatingNewVertex_ = false;
	        }
	    }
	
	
	  // var vertexFeature_backup = this.vertexFeature_;
	  // this.vertexFeature_ = newVertexFeature_;
	
	
	  var vertexFeature = newVertexFeature_;
	  if (vertexFeature) {
	    var insertVertices = [];
	    var geometry = /** @type {ol.geom.Point} */ (vertexFeature.getGeometry());
	    var vertex = geometry.getCoordinates();
	    var vertexExtent = ol.extent.boundingExtent([vertex]);
	    var segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
	    var componentSegments = {};
	    segmentDataMatches.sort(ol.interaction.Modify.compareIndexes_);
	    for (var i = 0, ii = segmentDataMatches.length; i < ii; ++i) {
	      var segmentDataMatch = segmentDataMatches[i];
	      var segment = segmentDataMatch.segment;
	      var uid = ol.getUid(segmentDataMatch.feature);
	      var depth = segmentDataMatch.depth;
	      if (depth) {
	        uid += '-' + depth.join('-'); // separate feature components
	      }
	      if (!componentSegments[uid]) {
	        componentSegments[uid] = new Array(2);
	      }
	      if (segmentDataMatch.geometry.getType() === ol.geom.GeometryType.CIRCLE &&
	      segmentDataMatch.index === ol.interaction.Modify.MODIFY_SEGMENT_CIRCLE_CIRCUMFERENCE_INDEX) {
	
	        var closestVertex = ol.interaction.Modify.closestOnSegmentData(vertex, segmentDataMatch);
	        if (ol.coordinate.equals(closestVertex, vertex) && !componentSegments[uid][0]) {
	          this.dragSegments_.push([segmentDataMatch, 0]); 
	          componentSegments[uid][0] = segmentDataMatch;
	        }
	      } else if (ol.coordinate.equals(segment[0], vertex) &&
	          !componentSegments[uid][0]) {
	        this.dragSegments_.push([segmentDataMatch, 0]);
	        componentSegments[uid][0] = segmentDataMatch;
	      } else if (ol.coordinate.equals(segment[1], vertex) &&
	          !componentSegments[uid][1]) {
	
	        // prevent dragging closed linestrings by the connecting node
	        if ((segmentDataMatch.geometry.getType() ===
	            ol.geom.GeometryType.LINE_STRING ||
	            segmentDataMatch.geometry.getType() ===
	            ol.geom.GeometryType.MULTI_LINE_STRING) &&
	            componentSegments[uid][0] &&
	            componentSegments[uid][0].index === 0) {
	          continue;
	        }
	
	        this.dragSegments_.push([segmentDataMatch, 1]);
	        componentSegments[uid][1] = segmentDataMatch;
	      } else if (ol.getUid(segment) in this.vertexSegments_ &&
	          (!componentSegments[uid][0] && !componentSegments[uid][1])) {
	        insertVertices.push([segmentDataMatch, vertex]);
	      }
	    }
	    if (insertVertices.length) {
	      this.willModifyFeatures_(evt);
	    }
	    for (var j = insertVertices.length - 1; j >= 0; --j) {
	      this.insertVertex_.apply(this, insertVertices[j]);
	    }
	  }
	
	  if (!this.isTouch_ && !newVertexFeature_) {
	    this.modifying_now_ = false;
	  }
	
	    return !!newVertexFeature_;
	
	  // this.vertexFeature_ = vertexFeature_backup;
	};
	
	ol.interaction.OMJSModify.handleDragEvent = function(evt){
	    this.ignoreNextSingleClick_ = false;
	    this.willModifyFeatures_(evt);
	
	    var vertex = evt.coordinate;
	    for (var i = 0, ii = this.dragSegments_.length; i < ii; ++i) {
	      var dragSegment = this.dragSegments_[i];
	      var segmentData = dragSegment[0];
	      var depth = segmentData.depth;
	      var geometry = segmentData.geometry;
	      var coordinates;
	      var segment = segmentData.segment;
	      var index = dragSegment[1];
	
	      while (vertex.length < geometry.getStride()) {
	        vertex.push(segment[index][vertex.length]);
	      }
	
	      switch (geometry.getType()) {
	        case ol.geom.GeometryType.POINT:
	          coordinates = vertex;
	          segment[0] = segment[1] = vertex;
	          break;
	        case ol.geom.GeometryType.MULTI_POINT:
	          coordinates = geometry.getCoordinates();
	          coordinates[segmentData.index] = vertex;
	          segment[0] = segment[1] = vertex;
	          break;
	        case ol.geom.GeometryType.LINE_STRING:
	          coordinates = geometry.getCoordinates();
	          coordinates[segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case ol.geom.GeometryType.MULTI_LINE_STRING:
	          coordinates = geometry.getCoordinates();
	          coordinates[depth[0]][segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case ol.geom.GeometryType.POLYGON:
	          coordinates = geometry.getCoordinates();
	          coordinates[depth[0]][segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case ol.geom.GeometryType.MULTI_POLYGON:
	          coordinates = geometry.getCoordinates();
	          coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
	          segment[index] = vertex;
	          break;
	        case ol.geom.GeometryType.CIRCLE:
	          segment[0] = segment[1] = vertex;
	          if (segmentData.index === ol.interaction.Modify.MODIFY_SEGMENT_CIRCLE_CENTER_INDEX) {
	            this.changingFeature_ = true;
	            geometry.setCenter(vertex);
	            this.changingFeature_ = false;
	          } else { // We're dragging the circle's circumference:
	            this.changingFeature_ = true;
	            geometry.setRadius(ol.coordinate.distance(geometry.getCenter(), vertex));
	            this.changingFeature_ = false;
	          }
	          break;
	        default:
	          // pass
	      }
	
	      if (coordinates) {
	        this.setGeometryCoordinates_(geometry, coordinates);
	      }
	    }
	    this.createOrUpdateVertexFeature_(vertex);
	};
	
	ol.interaction.OMJSModify.handleUpEvent = function(evt){
	
	    this.modifying_now_ = false;
	
	    // TODO: тут все точки перегенерируются. Возможно, есть способ добавить
	    //  нужную вершину в нужное место чтоб не перегенерировать все это?
	    if (this.creatingNewVertex_) {
	        /* если мы создаем новую вершину, то нам нужно удалить this.vertexFeature_
	            и сгенерировать все точки  */    
	        this.rerenderVertices();
	    }
	    this.creatingNewVertex_ = false;
	
	    if (this.isTouch_) {
	        if (this.vertexFeature_) {
	          this.overlay_.getSource().removeFeature(this.vertexFeature_);
	          this.vertexFeature_ = null;
	        }
	
	        if (this.snappedVertex_) {
	            this.snappedVertex_ = null;
	            this.resetHighlightStyles();
	        }
	    }
	
	    return ol.interaction.Modify.prototype.handleUpEvent.call(this, evt);
	};
	
	ol.interaction.OMJSModify.handleEvent = function(mapBrowserEvent){
	    if (this._active_) {
	        if (!(mapBrowserEvent instanceof ol.MapBrowserPointerEvent)) {
	          return true;
	        }
	        this.lastPointerEvent_ = mapBrowserEvent;
	
	        var handled;
	        if (
	            !mapBrowserEvent.map.getView().getHints()[ol.ViewHint.INTERACTING] 
	            && mapBrowserEvent.type == ol.MapBrowserEventType.POINTERMOVE 
	            && !this.handlingDownUpSequence
	        ) {
	          this.handlePointerMove_(mapBrowserEvent);
	        }
	        if (
	            (this.vertexFeature_ || this.snappedVertex_) 
	            && this.deleteCondition_(mapBrowserEvent)
	        ) {
	          if (mapBrowserEvent.type != ol.MapBrowserEventType.SINGLECLICK ||
	              !this.ignoreNextSingleClick_) {
	            handled = this.removePoint();
	          } else {
	            handled = true;
	          }
	        }
	
	        if (mapBrowserEvent.type == ol.MapBrowserEventType.SINGLECLICK) {
	          this.ignoreNextSingleClick_ = false;
	        }
	
	        return ol.interaction.Pointer.prototype.handleEvent.call(this, mapBrowserEvent) &&
	            !handled;
	    }
	
	    return true;
	};
	
	ol.interaction.OMJSModify.prototype.removePoint = function(){
	    var features = this.features_;
	    var _result = ol.interaction.Modify.prototype.removePoint.call(this);
	    this.dispatchEvent(new ol.interaction.Modify.Event(
	    	'removepoint',
	    	features
	    ));
	    return _result;
	};
	
	ol.interaction.OMJSModify.prototype.setStylesForFeaturesAtPixel = function(map, pixel){
	    var that = this;
	    var feature_geom;
	    map.forEachFeatureAtPixel(pixel, function(feature){
	        if (feature && that.vertexFeatures_.indexOf(feature) !== -1) {
	            feature_geom = feature.getGeometry();
	            if (feature_geom.getType() == ol.geom.GeometryType.POINT) {
	                feature.setStyle([that.highlightedVertexStyle]);
	            }
	        } else {
	            that.resetHighlightStyles();
	        }
	    });
	};
	
	ol.interaction.OMJSModify.prototype.setHighlightStylesForFeature = function(feature){
	    feature.setStyle([this.highlightedVertexStyle]);
	};
	
	ol.interaction.OMJSModify.prototype.resetHighlightStyles = function(){
	    this.vertexFeatures_.forEach(function(vertex){
	        vertex.setStyle();
	    });
	};
	
	ol.interaction.OMJSModify.prototype.findVertexByCoords = function(coords) {
	    var filtered_vertex = this.vertexFeatures_.filter(function(vertex){
	        var vertex_geom = vertex.getGeometry();
	        var vertex_coords = vertex_geom.getCoordinates();
	        return (
	            vertex_coords[0] == coords[0] &&
	            vertex_coords[1] == coords[1]
	        );
	    });
	    return filtered_vertex[0];
	};
	
	ol.interaction.OMJSModify.prototype.setActive = function(active){
	    var that = this;
	    that._active_ = !!active;
	    ol.interaction.Pointer.prototype.setActive.call(this, active);
	    // ol.interaction.Modify.prototype.setActive.call(this, active);
	};
	
	ol.interaction.OMJSModify.prototype.setMap = function(map) {
	    var that = this;
	    that.custom_vertex_overlay_.setMap(map);
	    ol.interaction.Modify.prototype.setMap.call(this, map);
	    
	};
	
	ol.interaction.OMJSModify.prototype.forEachSegment = function(geom, callback, opt_this){
	    var geom_type = geom.getType();
	    if (geom_type == ol.geom.GeometryType.LINE_STRING) {
	        return geom.forEachSegment(callback, opt_this);
	    } else if (geom_type == ol.geom.GeometryType.POLYGON) {
	        var flat_coords = geom.getOrientedFlatCoordinates();
	        return ol.geom.flat.segments.forEach(flat_coords.slice(0, flat_coords.length - 1), 0,
	            geom.flatCoordinates.length, geom.stride, callback, opt_this); 
	    } else {
	        // pass
	    }
	};
	
	ol.interaction.OMJSModify.prototype.rerenderVertices = function(){
	    var that = this;
	    this.custom_vertex_overlay_.getSource().clear();
	    that.vertexFeatures_.length = 0;
	    this.features_.forEach(function(_feature){
	        var feature_geom = _feature.getGeometry();
	
	        /* Если редактируем геометрию не линию и не полигон, то
	            ничего с сегментами не делаем */
	        if (AVAIL_GEOM.indexOf(feature_geom.getType()) == -1) return;
	
	        var segment_counter = 0;
	        that.forEachSegment(feature_geom, function(start, end){
	            that.createVertexFeature_(start, end, segment_counter);
	            segment_counter++; 
	        });
	    });
	};
	// ol.interaction.OMJSModify.prototype.rerenderVertices = 
	//     _.throttle(ol.interaction.OMJSModify.prototype.rerenderVertices_, 10); 
	
	ol.interaction.OMJSModify.AVAILABLE_GEOMTYPES = AVAIL_GEOM;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var Class       = __webpack_require__(4),
	    Events      = __webpack_require__(6),
	    Utils       = __webpack_require__(5),
	    // $           = require("jquery"),
	    ol          = __webpack_require__(22),
	
	    lineStyleFunction = __webpack_require__(231),
	    pointStyleFunction = __webpack_require__(232),
	    polygonStyleFunction = __webpack_require__(233),
	    textStyleFunction = __webpack_require__(234);
	
	var PublicMapDraw = Class.extend({
	    includes: [ Events ],
	
	    statics: {
	        MODE: {
	            POINT: 'point',
	            LINE: 'line',
	            FREEHAND_LINE: 'freehandline',
	            POLYGON: 'polygon',
	            FREEHAND_POLYGON: 'freehandpolygon',
	            TEXT: 'text'
	        }, 
	
	        LINE_STYLES: [
	            [], // прямая линия
	            [2, 1.1],
	            [3, 2.2],
	            [4, 5.5],
	            [5, 8.6]
	        ] 
	    },
	
	    initialize: function(map) {
	        var that = this;
	
	        that.map = map;
	
	        that.features = {};
	
	        that._custom_style = {};
	
	        that.pointerMoveHandler = that.pointerMoveHandler.bind(that);
	        that._onDrawStart = that._onDrawStart.bind(that);
	        that._onDrawEnd = that._onDrawEnd.bind(that);
	
	        /**
	         * Названия стиля должно начинаться с типа геометрии, который он описывает
	         * @type {Object}
	         */
	        that._original_style = {
	            point_width: 6,
	            point_color: [0, 134, 179, 1],
	            point_border_color: [255, 255, 255, 1],
	            point_border_width: 3,
	
	            line_width: 4,
	            line_color: [0, 134, 179, 1],
	            line_border_width: 4,
	            line_border_color: [255, 255, 255, 1],
	            line_border_style: PublicMapDraw.LINE_STYLES[0],
	
	            polygon_fill: [0, 134, 179, 1],
	            polygon_border_width: 4,
	            polygon_border_color: [255, 255, 255, 1],
	
	            text_content: '',
	            text_fontsize: 12,
	            text_fontcolor: [0, 0, 0, 1]
	        };
	
	        that.MESSAGE = {
	            START: {},
	            CONTINUE: {}
	        };
	
	        that.MESSAGE.START[PublicMapDraw.MODE.POINT] = 'Клик для завершения рисования';
	        that.MESSAGE.START[PublicMapDraw.MODE.LINE] = 'Клик для начала рисования';
	        that.MESSAGE.START[PublicMapDraw.MODE.FREEHAND_LINE] = 'Клик и удерживайте для рисования';
	        that.MESSAGE.START[PublicMapDraw.MODE.POLYGON] = 'Клик для начала рисования';
	        that.MESSAGE.START[PublicMapDraw.MODE.FREEHAND_POLYGON] = 'Клик и удерживайте для рисования';
	        that.MESSAGE.START[PublicMapDraw.MODE.TEXT] = 'Клик для завершения рисования';
	
	        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.POINT] = '';
	        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.LINE] = 'Клик для продолжения. Двойной клик для завершения';
	        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.FREEHAND_LINE] = 'Отпустите мышь для завершения рисования';
	        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.POLYGON] = 'Клик для продолжения. Двойной клик для завершения';
	        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.FREEHAND_POLYGON] = 'Отпустите мышь для завершения рисования';
	        that.MESSAGE.CONTINUE[PublicMapDraw.MODE.TEXT] = 'Клик для завершения рисования';
	
	        that.now_drawing = false;
	        // Показывает была ли поставлена первая точка в рисовании.
	        // Используется для определения какое сообщение поставить в тултип
	        that.first_point_was_set = false;
	        
	        // для рисования фич с правильным наложением друг на друга
	        that.style_zindex = 0;
	
	        that.interaction = null;
	
	        that.source = new ol.source.Vector();
	
	        that.vector = new ol.layer.Vector({
	            source: that.source
	        });
	
	        // Тултип с подсказкой по рисованию
	        that.tooltip = null;
	
	    },
	
	    /**
	     * Функция-помощник для метода .clone()
	     * Меняет стили для фич с учетом scale
	     * @param {number} scale - devicePixelRatio
	     * @param  {ol.Feature} feature
	     */
	    _clonedFeatureNewStyle: function(scale, feature) {
	        var that = this;
	
	        var styles = feature.get('style_settings');
	        var shape_type = feature.get('shape_type');
	
	        var new_styles = that.generateStyle(shape_type, scale, styles);
	        
	        feature.setStyle(new_styles);
	    },
	
	    /**
	     * Клонирует слой с учетом нового scale
	     * @param  {number} scale - devicePixelRatio
	     * @return {ol.Layer.Vector} - Новый слой 
	     */
	    clone: function(scale) {
	        var that = this;
	        var cloned_layer = Utils.cloneVectorLayer(
	            that.vector,
	            { /*useSpatialIndex: false*/ },
	            that._clonedFeatureNewStyle.bind(that, scale)
	        );
	
	        return cloned_layer;
	
	        // var new_style = that.getModifyStyle(scale);
	        // vertex_layer.setStyle(new_style);
	        
	    },
	
	    show: function() {
	        var that = this;
	        var map_has_layer = !!that.map.getLayers().getArray().filter(function(l) { 
	            return l == that.vector; 
	        })[0];
	        if (!map_has_layer) {
	            that.map.addLayer(that.vector);
	        }
	    },
	
	    hide: function() {
	        var that = this;
	        that.map.removeLayer(that.vector);
	    },
	
	    isVisible: function() {
	        var that = this;
	        var layers = that.map.getLayers();
	        var draw_layer = layers.filter(function(l) { return l === that.vector; });
	        return !!draw_layer.length;
	    },
	
	    clear: function() {
	        var that = this;
	        that.source.clear();
	    },
	
	    updateStyle: function(style_setting, shape_type) {
	        var that = this;
	        if (style_setting && style_setting['text_content'] === null) {
	            style_setting['text_content'] = '';
	        }
	        that._custom_style = _.clone(style_setting);
	        that.stopDrawing();
	        that.startDrawing(that.now_drawing_shape);
	    },
	
	    resetStyle: function() {
	
	    },
	
	    /**
	     * Генерирует стили для переданного типа геометрии shape с учетом DPI sclae
	     * @param  {PublicMapDraw.MODE} shape_opt - тип геометрии
	     * @param  {number} scale_opt - devicePixelRatio
	     * @param  {Object} styles_opt - стимлм
	     * 
	     * @return {ol.style.Style[]} - массив стилей
	     */
	    generateStyle: function(shape_opt, scale_opt, styles_opt) {
	        var that = this;
	
	        shape_opt = _.isString(shape_opt) ? shape_opt : that.now_drawing_shape;
	        scale_opt = _.isNumber(scale_opt) ? scale_opt : 1;
	        styles_opt = _.isObject(styles_opt) ? styles_opt : that.getAllStyles();
	
	        switch (shape_opt) {
	            case PublicMapDraw.MODE.POINT:
	                return pointStyleFunction(
	                    styles_opt, 
	                    that.style_zindex++, 
	                    scale_opt
	                );
	            case PublicMapDraw.MODE.LINE:
	            case PublicMapDraw.MODE.FREEHAND_LINE:
	                return lineStyleFunction(
	                    styles_opt, 
	                    that.style_zindex++, 
	                    scale_opt
	                );
	            case PublicMapDraw.MODE.POLYGON:
	            case PublicMapDraw.MODE.FREEHAND_POLYGON:
	                return polygonStyleFunction(
	                    styles_opt, 
	                    that.style_zindex++, 
	                    scale_opt
	                );
	            case PublicMapDraw.MODE.TEXT:
	                return textStyleFunction(
	                    styles_opt, 
	                    that.style_zindex++, 
	                    scale_opt
	                );
	            default:
	                console.warn('Ошибка при генерации стилей', that.now_drawing_shape);
	                return pointStyleFunction(
	                    styles_opt, 
	                    that.style_zindex++,
	                    scale_opt
	                );
	        }
	    },
	
	    getAllStyles: function() {
	        var that = this;
	        var default_settings = that._original_style;
	        var custom_settings = that._custom_style;
	        return _.extend(default_settings, custom_settings);
	    },
	
	    getDefaultStyles: function() {
	        return this._original_style;
	    },
	
	    // generateStyle: function() {
	    //     var that = this;
	    //     console.log(that._custom_style.icon_color, that._original_style.icon_color);
	    //     var circle = new ol.style.Circle({
	    //         radius: that.getStyleSetting('width'),
	    //         fill  : new ol.style.Fill({
	    //             color: that.getStyleSetting('color')
	    //         }),
	    //         stroke: new ol.style.Stroke({
	    //           color: that.getStyleSetting('border_color'),
	    //           width: that.getStyleSetting('border_size')
	    //         })
	    //     });
	
	    //     return [
	    //         /* стиль для дополнительной обводки */
	    //         new ol.style.Style({
	    //             stroke: new ol.style.Stroke({
	    //                 color: that.getStyleSetting('border_color'), // цвет обводки
	    //                 width: that.getStyleSetting('border_size'), // 
	    //                 lineDash: that.getStyleSetting('border_style')
	    //             }),
	    //         }),
	    //         /* обычный стиль */
	    //         new ol.style.Style({
	    //             fill  : new ol.style.Fill({
	    //                 color: that.getStyleSetting('fill_color')
	    //             }),
	    //             stroke: new ol.style.Stroke({
	    //                 color: that.getStyleSetting('fill_color'), // цвет линии
	    //                 width: that.getStyleSetting('size'), // толщина линии
	    //                 lineDash: that.getStyleSetting('border_style')
	    //             }),
	    //             image : circle
	    //         })
	    //     ];
	    // },
	
	    getStyleSetting: function(setting) {
	        var that = this;
	        var value = that._custom_style[setting] || that._original_style[setting];
	        if (setting === 'border_style') {
	            return PublicMapDraw.LINE_STYLES[parseInt(value)];
	        } else {
	            return value;
	        }
	    },
	
	    getStyleForShapeType: function(shape_type) {
	        var that = this;
	        var filtered_styles = {};
	        var current_styles = that.getAllStyles();
	
	        shape_type = shape_type.replace('freehand', '');
	
	        for (var style in current_styles) {
	            if (
	                current_styles.hasOwnProperty(style)
	                && style.indexOf(shape_type) === 0
	            ) {
	                filtered_styles[style] = _.clone(current_styles[style]);
	            }
	        }
	
	        return filtered_styles;
	    },
	
	    startDrawing: function(shape_type) {
	        var that = this;
	
	        switch (shape_type) {
	            case PublicMapDraw.MODE.POINT:
	            case PublicMapDraw.MODE.LINE:
	            case PublicMapDraw.MODE.FREEHAND_LINE:
	            case PublicMapDraw.MODE.POLYGON:
	            case PublicMapDraw.MODE.FREEHAND_POLYGON:
	                that.show();
	                that.now_drawing = true;
	                that.now_drawing_shape = shape_type;
	                that.interaction = that.addDrawInteraction(shape_type);
	                break;
	            case PublicMapDraw.MODE.TEXT:
	                that.show();
	                that.now_drawing = true;
	                that.now_drawing_shape = shape_type;
	                that.interaction = that.addEditTextInteraction();
	                break;
	            default:
	                console.warn('Неизвестный тип геометрии', shape_type);
	        }
	
	        that.fire('drawingstatechange', {
	            is_drawing: true,
	            shape_type: shape_type
	        });
	    },
	
	    stopDrawing: function(clear) {
	        var that = this;
	        that.now_drawing = false;
	        that.first_point_was_set = false;
	        that.map.removeInteraction(that.interaction);
	        
	        that.map.un('pointermove', that.pointerMoveHandler);
	
	        that.map.removeOverlay(that.tooltip);
	        that.tooltip = null;
	        if (clear) {
	            that.clear();
	            that.hide();
	        }
	        that.interaction = null;
	
	        that.fire('drawingstatechange', {
	            is_drawing: false,
	            shape_type: null
	        });
	        
	    },
	
	    isDrawing: function() {
	        return this.now_drawing;
	    },
	
	    addDrawInteraction: function(type) {
	        var that = this;
	        var interaction = that._createDrawInteraction(type);
	
	        interaction.on('drawstart', that._onDrawStart);
	        interaction.on('drawend', that._onDrawEnd);
	
	        that.map.addInteraction(interaction);
	
	        that.tooltip = that.createHelperTooltip();
	        that.map.addOverlay(that.tooltip);
	
	        return interaction;
	    },
	
	    addEditTextInteraction: function() {
	        return this.addDrawInteraction(PublicMapDraw.MODE.POINT);
	    },
	
	    _getOLTypeForShapeType: function(shape_type) {
	        switch (shape_type) {
	            case PublicMapDraw.MODE.POINT:
	                return ol.geom.GeometryType.POINT;
	            case PublicMapDraw.MODE.LINE:
	            case PublicMapDraw.MODE.FREEHAND_LINE:
	                return ol.geom.GeometryType.LINE_STRING;
	            case PublicMapDraw.MODE.POLYGON:
	            case PublicMapDraw.MODE.FREEHAND_POLYGON:
	                return ol.geom.GeometryType.POLYGON;
	            default:
	                return null;
	        }
	    },
	
	    // _getShapeTypeForOLType: function(ol_geom_type) {
	    //     switch (ol_geom_type) {
	    //         case ol.geom.GeometryType.POINT:
	    //             return PublicMapDraw.MODE.POINT.POINT;
	    //         case ol.geom.GeometryType.LINE_STRING:
	    //             return 
	    //     }
	    // },
	
	    _createDrawInteraction: function(type, style){
	        var that = this;
	        var drawInteraction;
	        var is_freehand = type.indexOf('freehand') === 0;
	        var geom_type = that._getOLTypeForShapeType(type);
	
	        var styles = that.generateStyle(
	            that.now_drawing_shape, 
	            window.devicePixelRatio
	        );
	
	        drawInteraction = new ol.interaction.Draw({
	            source: that.source,
	            style: styles,
	            type: geom_type,
	            freehand: is_freehand,
	            geometryFunction: function(coords, geom){
	                if (!geom) {
	                    geom = new ol.geom[geom_type](coords);
	                }
	                geom.setCoordinates(coords);
	                return geom;
	            }
	        });
	
	        that.map.on('pointermove', that.pointerMoveHandler);
	
	        return drawInteraction;
	    },
	
	    _onDrawStart: function(evt){
	        var that = this;
	        
	        that.first_point_was_set = true;
	        
	        /* На время рисовки отключаем зум по двойному */
	        that._dblClickZoomActive(false);
	        // that.sketch = evt.feature;
	        // that.sketch.setId(++that.featureIdCounter);
	
	
	        that.fire('drawstart', evt);
	        // инкрементируем параметр для будущих tooltip
	        // that.zTooltipIndex += 1;
	    },
	
	    _onDrawEnd: function(evt){
	        var that = this;
	
	        that.first_point_was_set = false;
	        
	        /* Включаем зум по двойному клику после того 
	            как мы закончили рисовать */
	
	        setTimeout(function(){
	            that._dblClickZoomActive(true);
	        }, 10);
	
	        // that.sketch = null;
	
	        var feature = evt.feature;
	        
	        // Запоминаем настройки, с которыми рисовалась эта фича
	        feature.set(
	            'style_settings', 
	            that.getStyleForShapeType(that.now_drawing_shape), 
	            true
	        );
	
	        // Запоминаем тип этой фигуры
	        feature.set('shape_type', that.now_drawing_shape, true);
	
	        var feature_geom = feature.getGeometry();
	        feature.setStyle(that.generateStyle());
	
	        // if (feature_geom.getType() == ol.geom.GeometryType.POLYGON) {
	            /* """""фикс"""""
	                при редактировании нарисованной геометрии куда-то 
	                пропадает возможность редактирования последнего сегмента
	                геометрии. Тут мы просто добавляем первую координату в 
	                конец геометрии чтобы "замкнуть" полигон.
	             */
	            // var polygon_coords = feature_geom.getCoordinates()[0];
	            // var first_coord = polygon_coords[0];
	            // polygon_coords.push(first_coord);
	            // feature.setGeometry(new ol.geom.Polygon([polygon_coords]));
	        // }
	        
	
	        that.fire('drawend', evt);
	    },
	
	    _dblClickZoomActive: function(active){
	        var that = this;
	        var interactions = that.map.getInteractions();
	        for (var i = 0; i < interactions.getLength(); i++) {
	            var interaction = interactions.item(i);                          
	            if (interaction instanceof ol.interaction.DoubleClickZoom) {
	                interaction.setActive(active);
	            }
	        }
	    },
	
	    pointerMoveHandler: function(evt) {
	        var that = this;
	        var coordinates = evt.coordinate;
	        var pixel_coords = evt.pixel;
	
	        var shape = that.now_drawing_shape;
	        var helper_message = that.first_point_was_set 
	                                ? that._getContinueMessage(shape)
	                                : that._getStartMessage(shape);
	
	        that.tooltip.getElement().innerHTML = helper_message;
	        that.tooltip.setPosition(coordinates);
	    },
	
	    createHelperTooltip: function(){
	        var that = this;
	        //that._mTooltipEl
	        //that._mTooltip
	        var tooltip_el = document.createElement('div');
	
	        // omjs-tooltip tooltip-static
	        tooltip_el.className = 'omjs-tooltip tooltip-static measurement-tooltip';
	        // задаем правильный порядок отображения
	        tooltip_el.style.zIndex = that.zTooltipIndex;
	
	        var tooltip = new ol.Overlay({
	            element    : tooltip_el,
	            offset     : [0, -15],
	            positioning: 'bottom-center',
	        });
	        // that._map.addOverlay(tooltip);
	        return tooltip;
	    },
	
	    _getContinueMessage: function(shape_type){
	        var that = this;
	        return that.MESSAGE.CONTINUE[shape_type];
	    },
	
	    _getStartMessage: function(shape_type){
	        var that = this;
	        return that.MESSAGE.START[shape_type];
	    },
	
	
	});
	
	module.exports = PublicMapDraw;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// var ol = omjs.ol;
	
	/* 
	    line_width
	    line_color
	    line_border_width
	    line_border_color
	    line_border_style
	*/
	
	var toRGBAstring = function(array) {
	    return 'rgba('+ array.join(',') +')';
	};
	
	module.exports = function(style, zindex, scale) {
	    // кружок для рисования
	    var circle = new ol.style.Circle({
	        radius: style['line_width'] / 2, // сомнительное решение. Скорее всего нужно будет убирать деление когда будет редактирование геометрии
	        fill  : new ol.style.Fill({
	            color: style['line_color']
	        }),
	        stroke: new ol.style.Stroke({
	            color: style['line_border_color'],
	            width: style['line_border_width'],
	            // lineDash: style['line_border_style']
	        })
	    });
	
	    /* обычный стиль */
	    // стиль пунктира умножается на толщину линии чтобы линия смотрелась 
	    // такой же как и на превью выбора пунктира. Если этого не делать, то
	    // при слишком толстой линии пунктира не будет видно.
	    var multiplied_dash = style['line_border_style'].map(function(v){
	        return v * style['line_width'];
	    });
	    var regular = new ol.style.Style({
	        stroke: new ol.style.Stroke({
	            color: style['line_color'], // цвет линии
	            width: style['line_width'], // толщина линии
	            lineDash: multiplied_dash
	        }),
	        image : circle,
	        zIndex: zindex
	    });
	
	    /* стиль для дополнительной обводки */
	    // обводка умножается на 2 чтобы с каждой стороны линии было 
	    // по style['line_border_width'] пикселей обводки. Толщина линии плюсуется
	    // к толщине обводки потому что никаких обводок у линий нет и рисуются на 
	    // самом деле 2 друг на друге.
	    var stroke_width = style['line_width'] + (style['line_border_width'] * 2);
	    var additional = new ol.style.Style({
	        stroke: new ol.style.Stroke({
	            color: style['line_border_color'],
	            width: stroke_width,
	            lineDash: multiplied_dash
	        }),
	        zIndex: zindex
	    });
	
	    return [additional, regular];
	};


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	/**
	 * point_width
	 * point_color
	 * point_border_color
	 * point_border_width
	 */
	
	module.exports = function(style, zindex, scale) {
	    // кружок для рисования
	    var circle = new ol.style.Circle({
	        radius: style['point_width'] * scale,
	        fill  : new ol.style.Fill({
	            color: style['point_color']
	        }),
	        stroke: new ol.style.Stroke({
	            color: style['point_border_color'],
	            width: style['point_border_width'] * scale,
	            // linedash: style['line_border_style']
	        })
	    });
	
	    if (scale !== 1) { 
	        circle.setScale(1 / scale); 
	    }
	
	    /* обычный стиль */
	    var regular = new ol.style.Style({
	        image : circle,
	        zIndex: zindex
	    });
	
	    return [regular];
	};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// var ol = omjs.ol;
	
	/* 
	    polygon_fill
	    polygon_border_width
	    polygon_border_color
	*/
	
	// var toRGBAstring = function(array) {
	//     return 'rgba('+ array.join(',') +')';
	// };
	
	module.exports = function(style, zindex, scale) {
	
	    // кружок для рисования
	    var circle = new ol.style.Circle({
	        radius: style['polygon_border_width'],
	        fill  : new ol.style.Fill({
	            color: style['polygon_fill']
	        }),
	        stroke: new ol.style.Stroke({
	            color: style['polygon_border_color'],
	            width: style['polygon_border_width'],
	            // linedash: style['line_border_style']
	        })
	    });
	
	    /* стиль для дополнительной обводки */
	    var additional = new ol.style.Style({
	        stroke: new ol.style.Stroke({
	            color: style['polygon_fill'],
	            width: style['polygon_border_width'],
	            // linedash: style['line_border_style']
	        }),
	        zIndex: zindex
	    });
	
	    /* обычный стиль */
	    var regular = new ol.style.Style({
	        fill  : new ol.style.Fill({
	            color: style['polygon_fill']
	        }),
	        stroke: new ol.style.Stroke({
	            color: style['polygon_border_color'], // цвет линии
	            width: style['polygon_border_width'], // толщина линии
	            // linedash: style['line_border_style']
	        }),
	        image : circle,
	        zIndex: zindex
	    });
	
	    return [additional, regular];
	};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// var ol = omjs.ol;
	
	/* 
	    text_content
	    text_fontsize
	    text_fontcolor
	*/
	
	
	module.exports = function(style, zindex, scale) {
	    
	    // кружок для рисования
	    var circle = new ol.style.Circle({
	        radius: 1
	    });
	
	    var text_style = new ol.style.Text({
	        text: style['text_content'],
	        fill: new ol.style.Fill({
	            color: style['text_fontcolor']
	        }),
	        font: style['text_fontsize'] + 'px sans-serif'
	    });
	
	    /* обычный стиль */
	    var regular = new ol.style.Style({
	        image : circle,
	        text: text_style,
	        zIndex: zindex
	    });
	
	    return [regular];
	};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Класс для визуального редактирования геометрии.
	 * Принимает геометрию, пользователь ее как-то редактирует, а потом можно получить
	 * обратно уже отредактированную геометрию.
	 */
	
	function getLayerStyle(scale) {
	
	    if (scale === undefined) {
	        scale = 1;
	    }
	
	    var circle = new ol.style.Circle({
	        radius: 6 * scale,
	        fill  : new ol.style.Fill({
	            color: /*'#6666ff*/'#0086b3'
	        }),
	        stroke: new ol.style.Stroke({
	          color: [255, 255, 255, 1],
	          width: 3 * scale
	        })
	    });
	
	    if (scale !== 1) {
	        circle.setScale(1 / scale);
	    }
	
	    return [
	        /* стиль для дополнительной обводки */
	        new ol.style.Style({
	            stroke: new ol.style.Stroke({
	                color: '#ffffff',
	                width: 10,
	            }),
	        }),
	        /* обычный стиль */
	        new ol.style.Style({
	            fill  : new ol.style.Fill({
	                color: 'rgba(0, 134, 179, 0.2)'
	            }),
	            stroke: new ol.style.Stroke({
	                color: '#0086b3',
	                width: 4
	            }),
	            image : circle
	        })
	    ];
	}
	
	function getModifyStyle(scale) {
	
	    if (scale === undefined) {
	        scale = 1;
	    }
	
	    var image = new ol.style.Circle({
	        radius: 6 * scale,  /* различие между двумя стилями */
	        fill: new ol.style.Fill({
	            color: /*'#6666ff'*/'#00b7f9'
	        }),
	        stroke: new ol.style.Stroke({
	            color: [255, 255, 255, 1],
	            width: 4 * scale
	        })
	    });
	
	    if (scale !== 1) { 
	        image.setScale(1 / scale); 
	    }
	
	    return new ol.style.Style({
	        image: image
	    });
	}
	
	var Class       = __webpack_require__(4),
	    Events      = __webpack_require__(6),
	    Utils       = __webpack_require__(5),
	    ol          = __webpack_require__(22);
	
	var GenericGeometryEditor = Class.extend({
	    includes: [ Events ],
	
	    initialize: function(map) {
	        var that = this;
	
	        that.drawInteractionStyles = [
	            new ol.style.Style({
	                stroke: new ol.style.Stroke({
	                    color: '#ffffff',
	                    width: 10,
	                }),
	            }),
	            new ol.style.Style({
	                fill: new ol.style.Fill({
	                    color: 'rgba(90, 160, 180, 0.2)'
	                }),
	                stroke: new ol.style.Stroke({
	                    color: /*'#6666ff'*/'#0086b3',
	                    lineDash: [5, 5],
	                    width: 2
	                }),
	                image: new ol.style.Circle({
	                    radius: 5,
	                    stroke: new ol.style.Stroke({
	                        color: 'rgba(0, 0, 0, 0.7)'
	                    }),
	                    fill: new ol.style.Fill({
	                        color: 'rgba(255, 255, 255, 0.6)'
	                    })
	                })
	            })
	        ];
	
	        that.map = map;
	        that.source = new ol.source.Vector({
	            features: []
	        });
	        that.layer = new ol.layer.Vector({
	            source: that.source,
	            style: getLayerStyle()
	        });
	        that.drawInteraction = null;
	        that.currentGeomType = 'Unknown';
	    },
	
	    show: function() {
	        var that = this;
	        var map_has_layer = !!that.map.getLayers().getArray().filter(function(l) { 
	            return l == that.layer; 
	        })[0];
	        if (!map_has_layer) {
	            that.map.addLayer(that.layer);
	        }
	    },
	
	    hide: function() {
	        var that = this;
	        that.map.removeLayer(that.layer);
	    },
	
	    isVisible: function() {
	        var that = this;
	        var layers = that.map.getLayers().getArray();
	        var draw_layer = layers.filter(function(l) { return l === that.layer; });
	        return !!draw_layer.length;
	    },
	
	    fireGeomChanged: function() {
	        var that = this;
	        that.fire('geomchange');
	    },
	
	    setFeatures: function(features) {
	        var that = this;
	        that.source.clear();
	        that.map.removeInteraction(that.modifyInteraction);
	        if (features) {
	            that.source.addFeatures(features);
	            that.fireGeomChanged();
	        }
	        var first_feature = features ? features[0] : false;
	        if (first_feature) {
	            that.currentGeomType = first_feature.getGeometry().getType();
	        } else {
	            that.currentGeomType = 'Unknown';
	        }
	    },
	
	    addFeatures: function(features) {
	        var that = this;
	        if (features.length) {
	            that.show();
	            that.source.addFeatures(features);
	            that.initModifyInteraction();
	            that.fireGeomChanged();
	        }
	    },
	
	    makeFeaturesFromGeom: function(geom) {
	        var that = this;
	        return that.parseGeoJSONToFeature(that.makeGeoJSONFromGeom(geom));
	    },
	
	    makeGeoJSONFromGeom: function (geom) {
	        var geoJSON  = {};
	        var geomType = (geom.type.indexOf("Multi") != -1) ?
	            geom.type.substring(5, geom.type.length) : geom.type;
	    
	        if (geom.coordinates.length > 1 && geom.type.indexOf("Multi") != -1) {
	            geoJSON = {
	                "type"    : "FeatureCollection",
	                "features": []
	            };
	    
	            for (var i = 0; i < geom.coordinates.length; i++) {
	                geoJSON.features.push({
	                    "type"      : "Feature",
	                    "geometry"  : {
	                        "type"       : geomType,
	                        "coordinates": geom.coordinates[i]
	                    },
	                    "properties": null
	                })
	            }
	    
	        } else {
	            geoJSON = {
	                "type"      : "Feature",
	                "geometry"  : geom,
	                "properties": {}
	            };
	        }
	    
	        return geoJSON;
	    },
	
	    setDblClickZoomActive: function (value) {
	        var that = this;
	        var map  = that.map;
	    
	        map.getInteractions().forEach(function (interact) {
	            if (interact instanceof ol.interaction.DoubleClickZoom) {
	                interact.setActive(!!value);
	            }
	        });
	    },
	
	    stopEverything: function() {
	        var that = this;
	        that.stopHoleDrawing();
	        that.removeDeleteInteraction();
	        that.removeDrawInteraction();
	        that.map.removeInteraction(that.modifyInteraction);
	    },
	
	    initDrawing: function(geomtype) {
	        var that = this;
	
	        if (!that.isVisible()) {
	            that.show();
	        }
	
	        that.stopEverything();
	
	        that.currentGeomType = geomtype;
	
	        that.drawInteraction = new ol.interaction.Draw({
	            type: geomtype,
	            features: new ol.Collection(that.layer.getSource().getFeatures()),
	            wrapX: true,
	            style: that.drawInteractionStyles
	        });
	
	        that.drawInteraction.on("drawstart", function () {
	        });
	
	        that.drawInteraction.on("drawend", function (evt) {
	            that.layer.getSource().addFeature(evt.feature);
	            that.fireGeomChanged();
	            that.onDrawEnd();
	            that.setDblClickZoomActive(true);
	        })
	
	        that.map.addInteraction(that.drawInteraction);
	
	        that.setDblClickZoomActive(false);
	    },
	
	    removeDrawInteraction: function() {
	        var that = this;
	        that.map.removeInteraction(that.drawInteraction);
	        that.drawInteraction = null;
	    },
	
	    removeAll: function() {
	        var that = this;
	        that.map.removeInteraction(that.drawInteraction);
	        that.drawInteraction = null;
	        that.map.removeInteraction(that.modifyInteraction);
	        that.modifyInteraction = null;
	        that.setFeatures(null);
	        that.hide();
	    },
	
	    onDrawEnd: function() {
	        var that = this;
	        that.initModifyInteraction();
	    },
	
	    initModifyInteraction: function() {
	        var that = this;
	        that.map.removeInteraction(that.modifyInteraction);
	        //that.map.removeInteraction(that.drawInteraction);
	
	        that.modifyInteraction = new ol.interaction.Modify({
	            features       : new ol.Collection(that.layer.getSource().getFeatures()),
	            deleteCondition: function (event) {
	                return ol.events.condition.singleClick(event);
	            },
	            wrapX : true,
	            style: getModifyStyle()
	        });
	
	        that.modifyInteraction.on("modifystart", function () {
	            that.modifyFlag = true;
	        });
	
	        that.modifyInteraction.on('modifyend', function() {
	            that.fireGeomChanged();
	        });
	
	        that.map.addInteraction(that.modifyInteraction);
	    },
	
	    toGeoJSON: function(as_string, convert_to) {
	        var that = this;
	        var layerFeatures = that.layer.getSource().getFeatures();
	        var formatGeoJSON = new ol.format.GeoJSON({dataProjection: "EPSG:3857"});
	
	        var write_features_options = {
	            featureProjection: "EPSG:3857"
	        };
	        if (convert_to && typeof convert_to === "string") {
	            write_features_options['dataProjection'] = convert_to;
	        }
	        
	        var parsedJSON = formatGeoJSON.writeFeatures(
	            layerFeatures, 
	            write_features_options
	        );
	        
	        if (as_string) {
	            return JSON.stringify(JSON.parse(parsedJSON), null, 2);
	        } else {
	            return JSON.parse(parsedJSON);
	        }
	    },
	
	    parseGeoJSONToFeature: function(geojson, convert_from, convert_to) {
	        convert_from = convert_from || "EPSG:3857";
	        convert_to = convert_to || "EPSG:3857";
	
	        var formatGeoJSON = new ol.format.GeoJSON();
	        var feature = formatGeoJSON.readFeatures(geojson, {
	            featureProjection: convert_to,
	            dataProjection: convert_from
	            // dataProjection: new ol.proj.Projection({code: "EPSG:3857"})
	        });
	
	        return feature;
	    },
	
	    isGeoJSONValid: function(geojson_string) {
	        var that = this;
	        var formatGeoJSON = new ol.format.GeoJSON({dataProjection: "EPSG:3857"});
	        var JSONString    = geojson_string;
	        var convertedFeature, parsedJSON;
	
	        try {
	            convertedFeature = formatGeoJSON.readFeatures(JSONString, {
	                featureProjection: "EPSG:3857"
	            });
	            parsedJSON       = formatGeoJSON.writeFeatures(convertedFeature, {
	                dataProjection: "EPSG:3857"
	            });
	        } catch (e) {
	            console.log(e);
	            return false;
	        }
	
	        try {
	            var testLayer = new ol.layer.Vector();
	            var features  = that.parseGeoJSONToFeature(geojson_string);
	    
	            testLayer.setSource(new ol.source.Vector({
	                features: features
	            }));
	        } catch (e) {
	            console.log(e);
	            return false;
	        }
	
	        return true;
	    },
	
	    initHoleDrawing: function(callback) {
	        var that = this;
	
	        that.stopEverything();
	
	        that.selectInt = new ol.interaction.Select({
	            wrapX: true
	        });
	
	        that.setDblClickZoomActive(false);
	
	        that.selectInt.on('select', function(event) {
	            var selFeats = new ol.Collection(event.selected);
	            if (selFeats.getLength() !== 1) {
	                that.map.removeInteraction(that.selectInt);
	                that.fire('error', {
	                    message: 'Отверстия можно рисовать только в одном полигоне'
	                });
	                return;
	            } else {
	                var geomTypeSelected = selFeats.getArray()[0].getGeometry().getType();
	                if (geomTypeSelected !== 'Polygon') {
	                    that.fire('error', {
	                        message: 'Отверстия можно рисовать только в полигонах. Вы выбрали ' + geomTypeSelected
	                    });
	                    that.map.removeInteraction(that.selectInt);
	                    return;
	                }
	
	                //create a polygon draw interaction
	                var vertsCouter      = 0; //this is the number of vertices drawn on the ol.interaction.Draw(used in the geometryFunction)
	                var holeDraw         = new ol.interaction.Draw({
	                    //source: that._layer,
	                    wrapX           : true,
	                    features        : new ol.Collection(that.layer.getSource().getFeatures()),
	                    type            : 'Polygon',
	                    //add the geometry function in order to disable
	                    //hole creation outside selected polygon
	                    geometryFunction: function (coords, geom) {
	                        var retGeom; //define the geometry to return
	                        if (typeof (geom) !== 'undefined') { //if it is defined, set its coordinates
	                            geom.setCoordinates(coords);
	                        } else {
	                            retGeom = new ol.geom.Polygon(coords);
	                        }
	                        if (coords[0].length > vertsCouter) { //this is the case where new vertex has been draw
	                            //check if vertex drawn is within the selected polygon
	                            var isIn = that.isPointInPoly(selFeats.getArray()[0].getGeometry(), coords[0][coords[0].length - 1]);
	                            //if outside get rid of it
	                            if (isIn === false) {
	                                coords[0].pop(); //remove the last coordinate element
	                                retGeom = new ol.geom.Polygon(coords); //recunstract the geometry
	                            }
	                            vertsCouter = coords[0].length; //reset the length of vertex counter
	                        }
	                        return retGeom;
	                    }
	
	                });
	                that.holeInteraction = holeDraw;
	                //disable the select and modify interaction during hole drawing
	                that.selectInt.setActive(false);
	                that.modifyInteraction.setActive(false);
	                //add the draw hole interaction
	                that.map.addInteraction(holeDraw);
	                //add the listener when start drawing
	                holeDraw.on('drawstart', function (e) {
	                    that.modifyFlag = true;
	                    var feature     = e.feature; //grab the draw hole feature
	                    var ringAdded   = false; //init boolen var to clarify whether drawn hole has allready been added or not
	                    //set the change feature listener so get the hole like visual effect
	                    feature.on('change', function (e) {
	                        //get draw hole feature geometry
	                        var drawCoords = feature.getGeometry().getCoordinates(false)[0];
	                        //if hole has more than two cordinate pairs, add the interior ring to feature
	                        if (drawCoords.length > 2) {
	                            //if intirior ring has not been added yet, append it and set it as true
	                            if (ringAdded === false) {
	                                selFeats.getArray()[0].getGeometry().appendLinearRing(
	                                    new ol.geom.LinearRing(feature.getGeometry().getCoordinates(false)[0]));
	                                ringAdded = true;
	                            }
	                            //if interior ring has allready been added so we need to remove it and add back the updated one
	                            else {
	                                //get the elements length of the geometry
	                                var coordElemntLength = selFeats.getArray()[0].getGeometry().getCoordinates().length;
	                                var coordsExt         = selFeats.getArray()[0].getGeometry().getCoordinates()[0]; //exterior ring
	                                var coordsInter       = []; //interior rings
	                                //if we have more than 2 elements
	                                if (coordElemntLength > 2) {
	                                    //create the interior rings array
	                                    //note that we use i=1 to leave outside the first element (exterior ring)
	                                    //and coordElemntLength-1 to leave outside the last element as this is the one we need to update
	                                    for (var i = 1; i < coordElemntLength - 1; i++) {
	                                        coordsInter.push(selFeats.getArray()[0].getGeometry().getCoordinates()[i]);
	                                    }
	                                }
	                                //construct the coordinates to use for the modify geometry feature
	                                var setCoords = [];
	                                //if interior rings allready exist
	                                if (coordsInter.length > 0) {
	                                    //push the exterior ring
	                                    setCoords.push(coordsExt);
	                                    //push all the interior rings
	                                    for (var z = 0; z < coordsInter.length; z++) {
	                                        setCoords.push(coordsInter[z]);
	                                    }
	                                    //and finally push the new drawn hole
	
	                                    setCoords.push(feature.getGeometry().getCoordinates(false)[0]);
	                                } else {
	
	                                    setCoords = [coordsExt, feature.getGeometry().getCoordinates(false)[0]];
	                                }
	                                setCoords[setCoords.length - 1].push(
	                                    [].concat(setCoords[setCoords.length - 1][0])
	                                );
	                                selFeats.getArray()[0].getGeometry().setCoordinates(setCoords);
	                            }
	                        }
	                    });
	                });
	
	                //create a listener when finish drawing and so remove the hole interaction
	                holeDraw.on('drawend', function (evt) {
	                    // that.$hole.removeClass("active");
	                    setTimeout(function(){
	                        that.stopHoleDrawing();
	                        that.setDblClickZoomActive(true);
	                        callback();
	                        that.fireGeomChanged();
	                    }, 0);
	                });
	            }
	        });
	
	        that.map.addInteraction(that.selectInt);
	    },
	
	    stopHoleDrawing: function() {
	        var that = this;
	        that.map.removeInteraction(that.holeInteraction);
	        that.map.removeInteraction(that.selectInt);
	        that.initModifyInteraction();
	    },
	
	    isPointInPoly: function (polygon, pt) {
	        var poly = polygon.getCoordinates()[0]; //only the exterior ring of the supplied polygon
	        for (var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
	            ((poly[i][1] <= pt[1] && pt[1] < poly[j][1]) || (poly[j][1] <= pt[1] && pt[1] < poly[i][1])) && (pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0]) && (c = !c);
	        return c;
	    },
	
	    initDeleteSelect: function (callback) {
	        var that = this;
	        var selFeats;
	        
	        that.stopEverything();
	
	        that.setDblClickZoomActive(false);
	        that.deleteSelect = new ol.interaction.Select({
	            wrapX: true,
	            layers: [that.layer]
	        });
	    
	        that.deleteSelect.on("select", function (event) {
	            that.modifyFlag = true;
	            selFeats        = new ol.Collection(event.selected);
	    
	            if (selFeats.getLength() !== 1) {
	                //
	                return;
	            } else {
	                that.layer.getSource().removeFeature(event.selected[0]);
	                that.fireGeomChanged();
	                that.initModifyInteraction();
	                that.map.removeInteraction(that.deleteSelect);
	                callback();
	                that.setDblClickZoomActive(true);
	            }
	        });
	        that.map.addInteraction(that.deleteSelect);
	    },
	
	    removeDeleteInteraction: function() {
	        var that = this;
	        that.map.removeInteraction(that.deleteSelect);
	    }
	
	
	
	});
	
	module.exports = GenericGeometryEditor;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var VectorLayer     = __webpack_require__(44),
	    $               = __webpack_require__(3);
	
	var defMarkerIcon = 'data:image/png;base64,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';
	
	var MarkerLayer = VectorLayer.extend({
	
	    options: {
	        clustering: 40
	    },
	
	    initialize: function(options) {
	        var that = this,
	            group;
	
	        options || (options = {});
	        if ('group' in options) {
	            group = options.group;
	            delete options['group'];
	        }
	
	        MarkerLayer.__super__.initialize.call(that, options);
	
	        that._defaultClusterStyle = new ol.style.Style({
	            image: new ol.style.Icon({
	                anchor: [0.5, 0.5],
	                anchorXUnits: 'fraction',
	                anchorYUnits: 'fraction',
	                opacity: 1,
	                src: defMarkerIcon
	            })
	        });
	
	        that.set('group', group);
	    },
	
	    _setup: function(){
	        var that = this;
	
	        that._olSource = new ol.source.Vector({
	            features: []
	        });
	
	        that._olClusterSource = new ol.source.Cluster({
	            distance: that.options['clustering'],
	            source  : that._olSource
	        });
	
	        that._olLayer.setSource(that._olClusterSource);
	
	        that._olLayer.setStyle(function(feature, resolution){
	            return that._styler(feature, resolution);
	        });
	    },
	
	    _styler: function(feature, resolution){
	        var that = this,
	            size = feature.get('features').length,
	            styles = [];
	
	        if (size > 1) {
	            if (!that.get('clusterStyle')) {
	                styles.push(that._defaultClusterStyle);
	            } else {
	                styles.push(that.get('clusterStyle'));
	            }
	        } else {
	            styles.push(feature.get('features')[0].getStyle());
	        }
	        return styles;
	    },
	
	    addMarker: function(target, options){
	        var that = this,
	            iconStyle,
	            marker,
	            _options;
	
	        options || (options = {});
	        _options = $.extend(true, {}, options);
	
	        if (target instanceof ol.Feature && target.getGeometry() instanceof ol.geom.Point) {
	            that._olSource.addFeature(target);
	            return;
	        }
	
	        if (!$.isArray(target)) {
	            throw new Error("`coordinates` option is not Array ");
	        }
	
	        if ('style' in options) {
	            iconStyle = options.style;
	        } else {
	            iconStyle = new ol.style.Style({
	                image: new ol.style.Icon({
	                    anchor: [0.5, 0.5],
	                    anchorXUnits: 'fraction',
	                    anchorYUnits: 'fraction',
	                    opacity: 1,
	                    src: options.icon !== undefined ? options.icon : defMarkerIcon
	                })
	            });
	        }
	
	        _options.geometry = new ol.geom.Point(ol.proj.transform(target, 'EPSG:4326', 'EPSG:3857'));
	        
	        marker = new ol.Feature(_options);
	        marker.setStyle(iconStyle);
	
	        that._olSource.addFeature(marker);
	        return marker
	    },
	
	    getMarkers: function(){
	        var that = this;
	        return that._olSource.getFeatures();
	    },
	
	    setClusterStyle: function(style){
	        var that = this,
	            _style = {
	                anchor: [0.5, 0.5],
	                anchorXUnits: 'fraction',
	                anchorYUnits: 'fraction',
	                opacity: 1,
	                src: ''
	            };
	
	        if (style instanceof ol.style.Style) {
	            that.set('clusterStyle', style);
	        } else if ($.isPlainObject(style)) {
	            $.extend(true, _style, style);
	
	            if ('icon' in _style) {
	                _style.src = _style.icon;
	                delete _style['icon'];
	            }
	
	            that.set('clusterStyle', new ol.style.Style({
	                image: new ol.style.Icon(_style)
	            }));
	        }
	
	        that._olLayer.setStyle(function(feature, resolution){
	            return that._styler(feature, resolution);
	        });
	
	        return that;
	    }
	});
	
	module.exports = MarkerLayer;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(4),
	    $     = __webpack_require__(3),
	    ol    = __webpack_require__(22);
	
	var OmsExtTileCounter = Class.extend({
	    initialize: function(view){
	        var that = this;
	        that.view = view;
	        that.lastTilesCount = 0;
	
	        setInterval(function(){
	            var tc = that.countTiles();
	            if(that.lastTilesCount == tc) return void(0);
	            that.lastTilesCount = tc;
	            window.postMessage({
	                tilesCount: that.lastTilesCount
	            }, '*');
	        }, 500);
	    },
	
	    countTiles: function(){
	        var that = this;
	        var canvas = $(that.view._elements.mapContainer).find('canvas');
	        var tileSize = 256; // TODO: ����� ���������� �����������. � ���� ����� ���� ������ ������ ������.
	        var layers = that.view._map
	            .getLayers()
	            .getArray();
	
	        var layersCount = that._getTileLayers(layers).length;
	
	        var tX = Math.ceil(canvas.width() / tileSize);
	        var tY = Math.ceil(canvas.height() / tileSize);
	        var tilesPerLayer = tX * tY;
	        return tilesPerLayer * layersCount
	    },
	
	    _getTileLayers: function(layers){
	        var tileLayers = [];
	        var layersLength = layers.length;
	        var that = this;
	        for(var i = 0; i < layersLength; i++){
	            // ���� ���� ��������� - ��� ������, �� ��� �� ����������.
	            if(!layers[i].getVisible()){
	                continue;
	            }
	            // ���� ��� ������ ���� - ������ � ��������
	            if(layers[i] instanceof ol.layer.Group){
	                tileLayers.push.apply(tileLayers, that._getTileLayers(layers[i].getLayers().getArray()));
	            }else if(layers[i] instanceof ol.layer.Tile){
	                tileLayers.push(layers[i]);
	            }
	        }
	        return tileLayers;
	    }
	});
	
	module.exports = OmsExtTileCounter;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var Class   = __webpack_require__(4),
	    $       = __webpack_require__(3);
	/**
	 * Модуль перевода фраз. Ожидает на своем уровне директорию "i18n" с переводами (ru.js, en.js ...) вида:
	 * module.exports = {
	 *     'Фраза': 'Перевод',
	 *     ...
	 * };
	 * Для "ru" Фраза == Перевод
	 */
	var Lang = Class.extend({
	    initialize: function(options){
	        var that = this;
	
	        that.options = options;
	        that.__debug = [];
	        // TODO подумать над необходимостью ограничивать that.options.lng , т.к. фоллбэк на ru язык есть
	        // а исходное значение может ещё пригодиться. Но валидация хотя бы регуляркой будет нужна
	        that.allowedLanguages = ["ru", "en"];
	        if (that.allowedLanguages.indexOf(that.options.lng) == -1) {
	            console.warn('Language "'+ that.options.lng + '" is not defined. Switching to "ru"');
	            that.options.lng = 'ru';
	        }
	        // that.options.lng пока что проверяется белым списком. Без белого списка необходима валидация
	        try {
	            that.data = __webpack_require__(239)("./" + that.options.lng);
	        } catch (err) {
	            console.warn('Can\'t find lang "'+ that.options.lng + '". Switching to "ru"');
	            that.data = __webpack_require__(241);
	        }
	        // возможность переопределить переводы из приложения карты
	        if (that.options.translations) {
	            try {
	                $.extend(that.data, that.options.translations);
	            } catch (err) {
	                console.error(err);
	            }
	        }
	    },
	    getLang: function () {
	        var that = this;
	        return that.options.lng;
	    },
	    translate: function(phrase){
	        var that = this;
	
	        if (phrase in that.data) {
	            if (that.data[phrase] === undefined) {
	                console.error('Translation error "' + phrase + '"');
	                return phrase;
	            }
	            return that.data[phrase];
	        } else {
	            if (that.__debug.indexOf(phrase) == -1) {
	                console.error('Translation error "' + phrase + '"');
	                that.__debug.push(phrase);
	            }
	        }
	        return phrase;
	    }
	});
	
	module.exports = Lang;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en": 240,
		"./en.js": 240,
		"./ru": 241,
		"./ru.js": 241
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 239;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports = {
	    // SearchBarExt
	    'Объекты': 'Objects',
	    'Адрес': 'Address',
	    'По вашему запросу ничего не найдено': 'No results for this search query',
	    'Произошла ошибка на стороне сервера': 'Server error',
	    'Слой карты': 'Map layer',
	    // Measurement
	    'км<sup>2</sup>': 'km<sup>2</sup>',
	    'м<sup>2</sup>': 'm<sup>2</sup>',
	    'км': 'km',
	    'м': 'm',
	    // ChartLegend
	    'Другие': 'Other',
	    // Balloon
	    'Закрыть': 'Close',
	    // BaseLayer
	    'Участники OpenStreetMap': 'OpenStreetMap contributors',
	    'Спутник': 'Sputnik',
	    'Ростелеком': 'Rostelecom',
	    'Сменить формат координат': 'Change coordinate format'
	};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	module.exports = {
	    // SearchBarExt
	    'Объекты': 'Объекты',
	    'Адрес': 'Адрес',
	    'По вашему запросу ничего не найдено': 'По вашему запросу ничего не найдено',
	    'Произошла ошибка на стороне сервера': 'Произошла ошибка на стороне сервера',
	    'Слой карты': 'Слой карты',
	    // Measurement
	    'км<sup>2</sup>': 'км<sup>2</sup>',
	    'м<sup>2</sup>': 'м<sup>2</sup>',
	    'км': 'км',
	    'м': 'м',
	    // ChartLegend
	    'Другие': 'Другие',
	    // Balloon
	    'Закрыть': 'Закрыть',
	    // BaseLayer
	    'Участники OpenStreetMap': 'Участники OpenStreetMap',
	    'Спутник': 'Спутник',
	    'Ростелеком': 'Ростелеком',
	    'Сменить формат координат': 'Сменить формат координат'
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var balloonTemplate = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./Balloon.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var $ = __webpack_require__(3);
	var ol = __webpack_require__(22);
	
	module.exports = {
	
	    showBalloon: function(options){
	        var that = this,
	            defOptions = {
	                'content': '',
	                'class'  : '',
	                'autoPan': true,
	                'autoPanAnimation': {
	                    duration: 500
	                },
	                'offset'     : [0,-12],
	                'positioning': 'bottom-center',
	                'closeTitle' : that.Lang.translate('Закрыть')
	            },
	            $element,
	            position;
	
	        that.hideBalloon();
	
	        options = $.extend(defOptions, options);
	
	        position = ol.proj.transform(options.position, 'EPSG:4326', 'EPSG:3857');
	        // options['position'] = position;
	
	        $element = $(balloonTemplate(options));
	        $element
	            .addClass(options['class'])
	            .on('click', '.omjs-popup-closer', function(e){
	                e.preventDefault();
	                that.hideBalloon();
	                return false;
	            })
	            .find('.omjs-popup-content')
	            .append(options['content']);
	
	        options['element'] = $element[0];
	
	        that._balloon = new omjs.ol.Overlay(options);
	        that._map.addOverlay(that._balloon);
	        that._balloon.setPosition(position);
	        that.fire('showBalloon', {
	            balloon: that._balloon
	        });
	        return that._balloon;
	    },
	
	    hideBalloon: function(){
	        var that = this;
	        if(that._balloon){
	            that._balloon.setPosition(undefined);
	            that._map.removeOverlay(that._balloon);
	            that._balloon = undefined;
	            that.fire('hideBalloon')
	        }
	    }
	};

/***/ }),
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var Layer  = __webpack_require__(41),
	    Events = __webpack_require__(6),
	    Utils  = __webpack_require__(5),
	    ol     = __webpack_require__(22);
	
	var $ = __webpack_require__(3);
	
	var UTFGrid = Layer.extend({
	    includes: Events,
	
	    options: {
	        subdomains: false,
	
	        minZoom : 0,
	        maxZoom : 30,
	        tileSize: 256,
	
	        resolution: 4,
	
	        events: true,
	
	        url: ''
	    },
	
	    initialize: function (options) {
	        var that = this;
	
	        options || (options = {});
	
	        UTFGrid.__super__.initialize.call(that, options);
	
	        //The thing the mouse is currently on
	        that._mouseOn = null;
	
	        // Timeout to update grid
	        that._updateTimeout = null;
	
	        // Last MouseMove EventArgs
	        that._lastUpdateEventArgs = null;
	
	        that._cache    = {};
	        that._requests = {};
	
	        that._tilesOn = true;
	
	        that._clickDiaposon = false;
	        that._clickTimer = false;
	
	        that.inverseY = false;
	
	        that._click = that._click.bind(this);
	        that._move = that._move.bind(this);
	
	        if (that.options.subdomains) {
	            that.options.subdomains = that.options.subdomains.split('-');
	            that.options.subdomains = letterRange(that.options.subdomains[0], that.options.subdomains[1]);
	        }
	
	        that._olLayer = new ol.layer.Tile({});
	
	        // Избавляемся от rnd в запросах на тайлы
	        // that.set('rnd', Math.floor((Math.random() * 999999) + 1));
	
	        that.setUrl(that._createUrl());
	
	        that.on('propertychange propertyunset', function () {
	            that.setUrl(that._createUrl());
	        });
	    },
	
	
	    onAdd: function (view) {
	        var that = this;
	
	        that._view = view;
	
	        that._map       = that._view.getMap();
	        that._container = that._map.getTargetElement();
	        that._tilegrid  = ol.tilegrid.getForProjection(that._map.getView().getProjection());
	        that.enable();
	    },
	
	    toggleTiles: function (toggle) {
	        this._tilesOn = !!toggle;
	    },
	
	    set: function (attr, value, silent) {
	        var that = this,
	            attrs,
	            i;
	
	        if (typeof attr === "string") {
	            attrs       = {};
	            attrs[attr] = value;
	        } else {
	            attrs  = attr;
	            silent = value;
	        }
	
	        for (i in attrs) {
	            that._attributes[i] = attrs[i];
	            if (!silent) {
	                that.fire('propertychange', {
	                    key  : i,
	                    value: attrs[i]
	                })
	            }
	        }
	    },
	
	    unset: function (key, value, silent) {
	        var that = this;
	        if (key in that._attributes) {
	            delete that._attributes[key]
	        }
	
	        if (!silent) {
	            that.fire('propertyunset', {
	                key: key
	            })
	        }
	    },
	
	    disable: function () {
	        var that = this;
	        that.enabled = false;
	        that._map.un('click', that._click);
	        that._map.un('pointermove', that._move);
	    },
	
	    enable: function () {
	        var that = this;
	        that.enabled = true;
	        that._map.on('click', that._click);
	        that._map.on('pointermove', that._move);
	    },
	
	    setUrl: function (url) {
	        var that = this;
	        that.cancelLoading();
	        that.clearCache();
	        that.inverseY = Boolean(~url.indexOf('{-y}'));
	        that._url     = url.replace('{-y}', '{y}');
	    },
	
	    _createUrl: function () {
	        var that = this,
	            re   = /\{ *([\w_]+) *\}/g,
	            url  = that.options.url,
	            i,
	            param;
	
	        var tmp_params = [];
	
	        // Нужно сначала через template прогнать все переменные, которые у нас есть
	        // Оставшиеся добавляем get параметрами
	        var vars = that.options.url.match(re);
	        for (var i in vars) {
	            vars[i] = vars[i].replace('{', '').replace('}', '');
	
	            tmp_params.push(vars[i]);
	        }
	
	
	        for (i in that._attributes) {
	            if (~tmp_params.indexOf(i)) {
	                continue;
	            }
	            param = Object.prototype.toString.call(that.get(i)) === '[object Array]'
	                ? that.get(i).join(",")
	                : that.get(i) || "";
	
	            url += '&' + i + "=" + param;
	        }
	
	        return url;
	    },
	
	    _move: function (e, instance) {
	        var that = this;
	        if (e === null) return;
	        clearTimeout(that._updateTimeout);
	        if (!that.options.events) return;
	
	        function delayedUpdate() {
	            that._updateByPoint(e, false);
	            that._lastUpdateEventArgs = e;
	        }
	
	        if (instance) {
	            delayedUpdate();
	        } else {
	            that._updateTimeout = setTimeout(delayedUpdate, 100);
	        }
	
	        var on = that._objectForEvent(e);
	
	        if (on.data !== that._mouseOn) {
	            if (that._mouseOn) {
	                that.fire('mouseout',
	                    {
	                        coordinate: e.coordinate,
	                        data      : that._mouseOn
	                    });
	            }
	            if (on.data) {
	                that.fire('mouseover', on);
	            }
	
	            that._mouseOn = on.data;
	        } else if (on.data) {
	            that.fire('mousemove', on);
	
	        }
	    },
	
	    //Load up required json grid files for point
	    _updateByPoint: function (e, hard) {
	        var that = this;
	        hard     = hard || false;
	
	        if (!that._map || e === null) return void(0);
	        var zoom     = that._map.getView().getZoom(),
	            tileSize = that.options.tileSize,
	            coord    = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326'),
	            pixel    = project([coord[0], coord[1]], zoom);
	
	        if (zoom > that.options.maxZoom || zoom < that.options.minZoom) return void(0);
	
	        var TileX = Math.floor(pixel[0] / tileSize);
	        var TileY = Math.floor(pixel[1] / tileSize);
	        var max   = (256 * Math.pow(2, zoom)) / tileSize;
	
	        var xw = (TileX + max) % max;
	        var yw = (TileY + max) % max;
	
	        if (that.inverseY) {
	            yw = (Math.pow(2, zoom) - yw - 1)
	        }
	
	        var key = zoom + '_' + xw + '_' + yw;
	
	        if ((Math.floor(zoom) !== zoom) || (Math.floor(xw) !== xw) || (Math.floor(yw) !== yw)) {
	            return;
	        }
	
	        if (!that._cache.hasOwnProperty(key) || hard) {
	            that._cache[key] = null;
	            that._loadTile(zoom, xw, yw);
	        }
	    },
	
	    _loadTile: function (zoom, x, y) {
	        var that = this;
	
	        var params = $.extend(true, {
	            x: x,
	            y: y,
	            z: zoom
	        }, that._attributes);
	
	        var url = Utils.template(that._url, params);
	
	        var key = zoom + '_' + x + '_' + y;
	
	        if (!that._tilesOn) {
	            return;
	        }
	        that.fire('tileloadstart');
	        that._requests[key] = $.ajax({
	                dataType: "json",
	                cache   : true,
	                url     : url
	            })
	            .done(function (data) {
	                delete that._requests[key];
	                
	                // проверяем данные на пустоту
	                if (JSON.stringify(data) != "{}") {
	                    that._cache[key] = data;
	                    that._move(that._lastUpdateEventArgs);
	                    that.fire('tileloadend');
	                } else {
	                    that.fire('tileloaderror');
	                }
	            })
	            .fail(function () {
	                delete that._requests[key];
	                that.fire('tileloaderror');
	            });
	
	    },
	
	    _objectForEvent: function (e) {
	
	        var that       = this,
	            map        = that._map,
	            zoom       = map.getView().getZoom(),
	            coord      = ol.proj.transform(e.coordinate, 'EPSG:3857', 'EPSG:4326'),
	            point      = project([coord[0], coord[1]], zoom),
	            tileSize   = that.options.tileSize,
	            resolution = that.options.resolution,
	            x          = Math.floor(point[0] / tileSize),
	            y          = Math.floor(point[1] / tileSize),
	            gridX      = Math.floor((point[0] - (x * tileSize)) / resolution),
	            gridY      = Math.floor((point[1] - (y * tileSize)) / resolution),
	            max        = (256 * Math.pow(2, zoom)) / tileSize;
	
	        x = (x + max) % max;
	        y = (y + max) % max;
	
	        if (that.inverseY) {
	            y = (Math.pow(2, zoom) - y - 1)
	        }
	
	        var data = that._cache[zoom + '_' + x + '_' + y];
	
	        if (!data) {
	            return {
	                coordinate: e.coordinate,
	                data      : null
	            };
	        }
	
	        var idx    = that._utfDecode(data.grid[gridY].charCodeAt(gridX)),
	            key    = data.keys[idx],
	            result = data.data[key];
	
	        if (!data.data.hasOwnProperty(key)) {
	            result = null;
	        }
	
	        return {
	            coordinate: e.coordinate,
	            data      : result,
	            zoom      : zoom
	        };
	    },
	
	    _utfDecode: function (c) {
	        if (c >= 93) {
	            c--;
	        }
	        if (c >= 35) {
	            c--;
	        }
	        return c - 32;
	    },
	
	    _click: function (e) {
	        var req;
	        var key;
	        var that = this;
	        var gridLoader = $.Deferred();
	        var objForEvent = {};
	
	        if (that._view._utfIgnoreClick) return;
	        if (!that.options.events) return;
	        if(that._clickDiaposon){
	            clearTimeout(that._clickTimer);
	            that.cancelLoading();
	            that._clickDiaposon = false;
	        }else {
	            that._clickDiaposon = true;
	            that._clickTimer = setTimeout(function(){
	                that._clickDiaposon = false;
	                try {
	                    document.createEvent("TouchEvent");
	                    that._move(e, true);
	                }
	                catch (e) {}
	                // Обратная совместимость со старыми клиентами
	                objForEvent = that._objectForEvent(e);
	                objForEvent.gridLoader  = gridLoader;
	
	                that.fire('click', objForEvent);
	
	                req = [];
	                for (key in that._requests) {
	                    req.push(that._requests[key]);
	                }
	
	                $.when.apply($, req).always(function () {
	                    that._clickDiaposon = false;
	                    if (that._objectForEvent(e).data != null) {
	                        gridLoader.resolve(that._objectForEvent(e));
	                    } else {
	                        gridLoader.reject(e);
	                    }
	                })
	            },200);
	        }
	    },
	
	    cancelLoading: function () {
	        var i;
	        for (i in this._requests) {
	            this._requests[i].abort();
	        }
	    },
	
	    clearCache: function () {
	        this._cache = {};
	
	        // Избавляемся от rnd в запросах на тайлы
	        // this.set('rnd', Math.floor((Math.random() * 999999) + 1), true);
	    }
	});
	
	
	var Transformation = function (a, b, c, d) {
	    this._a = a;
	    this._b = b;
	    this._c = c;
	    this._d = d;
	};
	
	Transformation.prototype = {
	    transform: function (point, scale) { // (Point, Number) -> Point
	        return this._transform(point.clone(), scale);
	    },
	
	    // destructive transform (faster)
	    _transform: function (point, scale) {
	        scale    = scale || 1;
	        point[0] = scale * (this._a * point[0] + this._b);
	        point[1] = scale * (this._c * point[1] + this._d);
	        return point;
	    },
	
	    untransform: function (point, scale) {
	        scale = scale || 1;
	        return [
	            (point[0] / scale - this._b) / this._a,
	            (point[1] / scale - this._d) / this._c
	        ];
	    }
	};
	
	var projection = {
	    MAX_LATITUDE: 85.0511287798,
	
	    project: function (latlng) { // (LatLng) -> Point
	        var d   = Math.PI / 180,
	            max = this.MAX_LATITUDE,
	            lat = Math.max(Math.min(max, latlng[1]), -max),
	            x   = latlng[0] * d,
	            y   = lat * d;
	
	        y = Math.log(Math.tan((Math.PI / 4) + (y / 2)));
	
	        return [x, y];
	    },
	
	    unproject: function (point) { // (Point, Boolean) -> LatLng
	        var d   = 180 / Math.PI,
	            lng = point[0] * d,
	            lat = (2 * Math.atan(Math.exp(point[1])) - (Math.PI / 2)) * d;
	
	        return [lat, lng];
	    }
	};
	
	var CRS = {
	    latLngToPoint: function (latlng, zoom) { // (LatLng, Number) -> Point
	        var projectedPoint = this.projection.project(latlng),
	            scale          = this.scale(zoom);
	
	        return this.transformation._transform(projectedPoint, scale);
	    },
	
	    pointToLatLng: function (point, zoom) { // (Point, Number[, Boolean]) -> LatLng
	        var scale              = this.scale(zoom),
	            untransformedPoint = this.transformation.untransform(point, scale);
	
	        return this.projection.unproject(untransformedPoint);
	    },
	
	    scale: function (zoom) {
	        return 256 * Math.pow(2, zoom);
	    },
	
	    getSize: function (zoom) {
	        var s = this.scale(zoom);
	        return [s, s];
	    },
	
	    code: 'EPSG:3857',
	
	    projection: projection,
	
	    transformation: new Transformation(0.5 / Math.PI, 0.5, -0.5 / Math.PI, 0.5),
	
	    project: function (latlng) { // (LatLng) -> Point
	        var projectedPoint = this.projection.project(latlng),
	            earthRadius    = 6378137;
	        projectedPoint[0] *= earthRadius;
	        projectedPoint[1] *= earthRadius;
	
	        return projectedPoint;
	    }
	};
	
	var project = function (latlng, zoom) { // (LatLng[, Number]) -> Point
	    return CRS.latLngToPoint(latlng, zoom);
	};
	
	var letterRange = function (start, stop) {
	    var result = [];
	    for (var idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
	        result.push(String.fromCharCode(idx));
	    }
	    return result;
	};
	
	module.exports = UTFGrid;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var Utils      = __webpack_require__(5),
	    ol         = __webpack_require__(22),
	    Collection = __webpack_require__(8),
	    VLayer      = __webpack_require__(44),
	    PLayer = __webpack_require__(14);
	
	var Choropleth = VLayer.extend({
	
	    options: {
	        totalColors : 10,
	        minFillColor: '#ffffff',
	        maxFillColor: '#000000',
	        strokeColor : '#ffffff',
	        strokeWidth : 1,
	        radius: 5
	    },
	
	    initialize: function(Layer, options){
	        var that = this;
	        if(!(Layer instanceof PLayer)){
	            throw new Error('`Layer` is not instance of omjs.Project.Layer')
	        }
	
	        if(!Layer.objects.getLength()){
	            throw new Error('`Layer` has no objects')
	        }
	
	        that.setOptions(options);
	
	        that._olSource = new ol.source.Vector();
	        that._olLayer = new ol.layer.Vector();
	        that._olLayer.set('omjsLayer', that);
	
	        that.setSource(that._olSource);
	
	        that._projectLayer = Layer;
	        that._classificators = null;
	
	        that._fillFeatures();
	    },
	
	    setField: function(fieldCode){
	
	        var that = this;
	        that.options.field = fieldCode;
	
	        that.bindData(that._projectLayer.objects, function(data, pobject){
	            return pobject.get(that.options.field)
	        });
	
	        that.classify(that._createClassificators());
	
	        return that;
	    },
	
	    _createClassificators: function(){
	        var that = this,
	            maxVal,
	            minVal,
	            delta,
	            classificators = [],
	            colors;
	
	        var values = that._projectLayer.objects.pluck(that.options.field).map(function(v){
	            return parseFloat(v)
	        });
	
	        if(!values.length){
	            throw new Error('Object field `' + that.options.field + '` value not found')
	        }
	
	        maxVal = Math.max.apply(window, values);
	        minVal = Math.min.apply(window, values);
	        delta = (maxVal-minVal) / that.options.totalColors;
	
	        colors = Utils.generateColors(that.options.minFillColor, that.options.maxFillColor, that.options.totalColors);
	
	        colors.forEach(function(color, index){
	            var classificator = {
	                name: index+'',
	                index: index,
	                _min: 0,
	                _max: 0,
	                style: new ol.style.Style({
	                    image: new ol.style.Circle({
	                        radius: that.options.radius,
	                        stroke: new omjs.ol.style.Stroke({
	                            color: that.options.strokeColor,
	                            width: that.options.strokeWidth
	                        }),
	                        fill: new ol.style.Fill({
	                            color: color
	                        })
	                    })
	                }),
	                legendData:{
	                    name: (delta*index) + " - " + (delta*index + delta),
	                    fillColor: color,
	                    strokeColor: that.options.strokeColor,
	                    strokeWidth: that.options.strokeWidth
	                }
	            };
	
	            classificator.matcher = function(value){
	                var classificator = this,
	                    calculatedIndex;
	
	                calculatedIndex = parseInt((value - minVal) / delta);
	                return calculatedIndex == classificator.index || (classificator.index == that.options.totalColors - 1 && calculatedIndex > classificator.index);
	            };
	
	            classificator.matcher.bind(classificator);
	            classificators.push(classificator);
	        });
	
	        return classificators;
	    },
	
	    _fillFeatures: function(){
	        var that = this;
	        var features = [];
	        that._projectLayer.objects.each(function(obj){
	            var geom = obj.getGeometry();
	
	            if(geom.type in ol.geom){
	                var feature = new ol.Feature({
	                    obj     : obj,
	                    geometry: new ol.geom[geom.type](geom.coordinates)
	                });
	                feature.setId(obj.id);
	                features.push(feature);
	            }else{
	                console.warn('Unknown geometry type', obj, geom.type)
	            }
	        });
	        that._olSource.addFeatures(features);
	    },
	
	    classify: function(classificators){
	        var that = this;
	        if(classificators!= undefined){
	            that._classificators = new Collection(classificators);
	        }
	
	        that._classificators.each(function(classificator){
	            that._olSource.forEachFeature(function(feature){
	                var obj = feature.get('obj');
	                if(classificator.matcher(that._getValue(that._data, obj, feature, that._projectLayer), obj, feature)){
	                    feature.setStyle(classificator.style);
	                }
	            })
	        })
	    },
	
	    /**
	     * @param data любые данные
	     * @param matcher функция, в которую будет передан data и feature. Нужно вернуть значение
	     */
	    bindData: function(data, matcher){
	        var that = this;
	
	        that._data = data;
	        that._getValue = matcher;
	
	        return that;
	    },
	
	    /**
	     *
	     */
	    show: function(){
	        var that = this;
	        that['_olLayer'] !== undefined
	            ? that['_olLayer'].setVisible(true)
	            : $.noop();
	    },
	
	    /**
	     *
	     */
	    hide: function(){
	        var that = this;
	        that['_olLayer'] !== undefined
	            ? that['_olLayer'].setVisible(false)
	            : $.noop();
	    },
	
	    /**
	     *
	     */
	    toggle: function(){
	        var that = this;
	        that._olLayer.getVisible() ? that.hide() : that.show();
	    },
	
	    /**
	     *
	     */
	    isVisible: function(){
	        var that = this;
	        return that['_olLayer'] !== undefined ? that['_olLayer'].getVisible() : false;
	    },
	
	    /**
	     *
	     */
	    getMapLayer: function(){
	        return this._olLayer;
	    },
	
	    getProjectLayers: function(){
	        return this._projectLayer;
	    },
	
	    /**
	     *
	     */
	    setMapLayer: function(layer){
	        var that = this;
	        that._olLayer = layer;
	    },
	
	    /**
	     *
	     */
	    setSource: function(source){
	        var that = this;
	        that._olLayer.setSource(source);
	    },
	
	    setStyle: function(style){
	        var that = this;
	        that._olLayer.setStyle(style);
	    },
	
	    getLegendData: function(){
	        var that = this;
	
	        return that._classificators.getArray().map(function(cls){
	            return cls.legendData;
	        });
	    }
	});
	
	module.exports = Choropleth;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var LabelButton          = __webpack_require__(206);
	
	var RadiusButton = LabelButton.extend({
	
	    /**
	     *
	     */
	    initialize: function(options){
	        var that = this;
	
	        that._map = undefined;
	        that._measurement = undefined;
	
	        RadiusButton.__super__.initialize.call(that, options);
	
	        that.getContainer()
	            // .addClass('radius-area')
	            .on('click', function(e){
	                that._measurement.changeInteraction('Circle');
	            });
	    },
	
	    /**
	     *
	     */
	    onAdd: function(view){
	        var that = this;
	
	        that._map = view.getMap();
	        that._measurement = view.getMeasurement();
	        that._measurement.on('measureChanged', function(event){
	            if (event.measureType == 'Circle') {
	                that.getContainer().addClass('active');
	            } else {
	                that.getContainer().removeClass('active');
	            }
	        });
	    }
	});
	
	module.exports = RadiusButton;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var LabelButton          = __webpack_require__(206);
	
	var PointButton = LabelButton.extend({
	
	    /**
	     *
	     */
	    initialize: function(options){
	        var that = this;
	
	        that._map = undefined;
	        that._measurement = undefined;
	
	        PointButton.__super__.initialize.call(that, options);
	
	        that.getContainer()
	            // .addClass('PointButton')
	            .on('click', function(e){
	                that._measurement.changeInteraction('Point');
	            });
	    },
	
	    /**
	     *
	     */
	    onAdd: function(view){
	        var that = this;
	
	        that._map = view.getMap();
	        that._measurement = view.getMeasurement();
	        that._measurement.on('measureChanged', function(event){
	            if (event.measureType == 'Point') {
	                that.getContainer().addClass('active');
	            } else {
	                that.getContainer().removeClass('active');
	            }
	        });
	    }
	});
	
	module.exports = PointButton;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var Widget          = __webpack_require__(31);
	
	var SidePanel = Widget.extend({
	
	    options: {
	        position: 'left'
	    },
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options) {
	        var that = this;
	
	        SidePanel.__super__.initialize.call(that, options);
	
	        that.getContainer().addClass('side-panel');
	        that.getContainer().addClass(that.options.position);
	    },
	
	    onAdd: function(view) {
	        var that = this,
	            offset,
	            container;
	
	        container = that.getContainer();
	
	        if (that.options.position == 'left') {
	            offset = that.getContainer().outerWidth(true);
	            view.getContainer().find('.omjs-map-container').css({
	                left: offset
	            });
	        }
	        if (that.options.position == 'right') {
	            offset = that.getContainer().outerWidth(true);
	            view.getContainer().find('.omjs-map-container').css({
	                right: offset
	            });
	        }
	        if (that.options.position == 'top') {
	            offset = that.getContainer().outerHeight(true);
	            view.getContainer().find('.omjs-map-container').css({
	                top: offset
	            });
	        }
	        if (that.options.position == 'bottom') {
	            offset = that.getContainer().outerHeight(true);
	            view.getContainer().find('.omjs-map-container').css({
	                bottom: offset
	            });
	        }
	
	        view.getMap().updateSize();
	    }
	});
	
	module.exports = SidePanel;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var SidePanel    = __webpack_require__(248),
	    $            = __webpack_require__(3),
	    itemTemplate = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./item.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	var LayersTree = SidePanel.extend({
	
	    /**
	     *
	     * @param options
	     */
	    initialize: function(options){
	        var that = this;
	
	        options || (options = {});
	
	        that._containers = undefined;
	
	        that._layer = undefined;
	
	        LayersTree.__super__.initialize.call(that, options);
	
	        that.getContainer().addClass('layers-tree');
	    },
	
	    onAdd: function(view){
	        var that = this;
	
	        LayersTree.__super__.onAdd.call(that, view);
	
	        view.getProject().loadContainers({type: 'publish'})
	            .then(function(containers){
	                var layers;
	                that._containers = containers;
	                layers = that._containers.filter(function(cont){
	                    return Boolean(~$.inArray(cont.get('type'), ['layer', 'virtual', 'material', 'raster']));
	                });
	
	                return view.addLayer(layers.pluck('code').join(' '));
	            })
	            .done(function(layer){
	
	                that._layer = layer;
	
	                that._switchLayers();
	
	                that._buildLevel(0);
	
	                that.getContainer().on('click', '.omjs-cont-item', function(event){
	                    that._switchHandler(event, this);
	                })
	            });
	    },
	
	    /**
	     *
	     * @param parent
	     * @private
	     */
	    _buildLevel: function(parent){
	        var that = this,
	            items,
	            itemCont;
	
	        items = that._containers.filter(function(item){
	            return item.get('parent_id') == parent;
	        });
	
	        if(!items.getLength()){
	            return;
	        }
	
	        itemCont = $('<ul></ul>');
	
	        if(parent == 0){
	            that.getContainer().append(itemCont);
	        }else{
	            that.getContainer().find('#omjs_tcont_' + parent).append(itemCont);
	        }
	
	        items.each(function(item){
	            var itemEl;
	
	            var childs = that._containers.filter(function(it){
	                return it.get('parent_id') == item.get('id');
	            });
	
	            itemEl = $(itemTemplate({
	                'c_code'      : item.get('code'),
	                'name'        : item.get('name') || item.get('code'),
	                'c_id'        : item.get('id'),
	                'map_layer_id': item.get('map_layer_id') || "",
	                'active'      : item.get('selected') ? 'active' : "",
	                'cont_type'   : item.get('type'),
	                'id'          : item.get('map_layer_id')
	            }))
	                .attr('title', item.get('name') || item.get('code'));
	
	            if(item.get('icon').length){
	                itemEl.find('.omjs-cont-icon')
	                    .removeClass('layer folder raster virtual')
	                    .append('<img src="' + item.get('icon') + '" />')
	            }
	
	            itemCont.append(itemEl);
	
	            if(childs.getLength()){
	                that._buildLevel(item.get('id'));
	            }
	        });
	    },
	
	    /**
	     *
	     * @param event
	     * @param element
	     * @private
	     */
	    _switchHandler: function(event, element){
	        var that     = this,
	            $element = $(element),
	            container,
	            childs;
	
	        $element.toggleClass('active');
	
	        container = that._containers.filter(function(cont){
	            return cont.get('code') == $element.data('cont');
	        });
	
	        if(!container.getLength()){ return }
	
	        container.at(0).set('selected', $element.hasClass('active'));
	        childs = that._containers.filter(function(it){
	            return it.get('parent_id') == container.at(0).get('id');
	        });
	
	        if(childs.getLength()){
	            childs.each(function(child){
	                $element.hasClass('active')
	                    ? $element.parent().find('.omjs-cont-item').addClass('active')
	                    : $element.parent().find('.omjs-cont-item').removeClass('active');
	
	                child.set('selected', $element.hasClass('active'));
	            });
	        }
	
	        that._switchLayers();
	
	    },
	
	    /**
	     *
	     * @private
	     */
	    _switchLayers: function(){
	        var that = this,
	            activeLayers;
	
	        activeLayers = that._containers.filter(function(cont){
	            return cont.get('selected') == true &
	                Boolean(~$.inArray(cont.get('type'), ['layer', 'virtual', 'material', 'raster']));
	        });
	
	        activeLayers.getLength()
	            ? that._layer.show()
	            : that._layer.hide();
	
	        that._layer.setActiveLayers(activeLayers.pluck('code'));
	    }
	
	});
	
	module.exports = LayersTree;

/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var Panel                   = __webpack_require__(209);
	var $                       = __webpack_require__(3);
	var template                = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./bar.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var search_item             = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./search_item.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var cadastre_search_item    = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./cadastre_search_item.ejs\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	var SearchBarExt = Panel.extend({
	
	    initialize: function(options){
	        var that = this;
	        that.searchResults = [];
	
	        that.marker = new ol.style.Icon({
	            src: 'data:image/svg+xml;base64,PHN2ZyBpZD0ibWFya2VyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4gIDxjaXJjbGUgZmlsbD0iI2YwNWEzYyIgb3BhY2l0eT0iMC4yIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiLz4gIDxjaXJjbGUgZmlsbD0iI2YwNWEzYyIgc3Ryb2tlLXdpZHRoPSIycHgiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZT0iI2ZmZiIgY3g9IjEyIiBjeT0iMTIiIHI9IjUiLz48L3N2Zz4=',
	            anchor: [0.5, 0.5],
	            imgSize: [24, 24] // imgSize необходим для корректной работы в IE
	        });
	
	        if (!("layer" in options) && !("url" in options)) {
	            throw new Error("Не переданы слой или url");
	        } else if (!(options.layer instanceof omjs.ol.layer.Vector)) {
	            throw new Error("Слой должен быть векторный");
	        }
	
	        SearchBarExt.__super__.initialize.call(that, options);
	
	        that.setOptions(options);
	        that.layer = that.options.layer;
	        that.map = that.options.map;
	
	        that.layer.setStyle(new ol.style.Style({
	            fill : new ol.style.Fill({
	                color: 'rgba(255,0,0,0.4)'
	            }),
	            image: new ol.style.Circle({
	                fill  : new ol.style.Fill({
	                    color: 'rgba(255,0,0,0.4)'
	                }),
	                stroke: new ol.style.Stroke({
	                    color: 'rgba(0,0,0,0.7)',
	                    width: 2
	                }),
	                radius: 10
	            })
	        }));
	
	        that.container = that.getContainer();
	        that.container.html( $(template({
	            objectsTab: that.translate('Объекты'),
	            addressTab: that.translate('Адрес'),
	            cadastreTab: that.translate('ПКК')
	        })) );
	        that.container.attr("tabindex", "-1");
	
	        if (
	            !that.options.pkk_settings
	            || !that.options.pkk_settings.pkk_search_enabled
	        ) {
	            var cadastre_tab = that.container.find('li[data-tab="cadastre"]');
	            cadastre_tab.remove();
	        }
	
	        // Получим настройки поиска из публикации
	        that.searchSettings = options.search.values;
	        that._searchInputWrapper = that.container.find("._search-bar-input-wrapper");
	        that._searchInput = that.container.find("input[name=search-bar]");
	        that._searchButton = that.container.find("div[role=do_search]");
	        that._searchLoader = that.container.find('div[role=search_loader]');
	        that._searchResults = that.container.find("div[role=search_results]");
	        that._searchResultsItems = that._searchResults.find("._search_result_item");
	        that._searchTabs = that.container.find('[role="search_ext_tabs"]');
	
	        that._loadingXhr = false;
	
	        that._initHandlers();
	    },
	
	    onAdd: function(view){
	        var that = this;
	        that.view = view;
	
	        that.searchObjectsUrl = view._project.options.apiUrl + view._project.options.mapCode + '/search/';
	
	        that.searchAddressUrl = that.options.url;
	        // Тестовая завязка на геосервис геопортала
	        // that.searchAddressUrl = 'http://admin.geoportal40.ru/geosearch/search/';
	
	        // Вкладка Объекты
	        that._searchObjectsTab = that._searchTabs.find('[role="search_objects_tab"]');
	
	        // Вкладка Адрес - типа есть всегда, но ищет или через наш геосервис, или через Яндекс
	        that._searchAddressTab = that._searchTabs.find('[role="search_address_tab"]');
	        // if (!that.options.geosearch) {
	         //    that._searchAddressTab.remove();
	        // }
	
	        // Если выключен поиск по названиям слоёв или по метаданным - скрываем вкладку
	        if (!that.searchSettings.searchLayersNames && !that.searchSettings.searchMeta){
	            that._searchObjectsTab.remove();
	            that._searchTabs.hide();
	        }
	
	        // if (that.options.hideTabSwitcher) {
	         //    that._searchTabs.hide();
	        // }
	
	        // Первую вкладку делаем активной
	        that._setActiveTab(that._searchTabs.find('li:first'));
	    },
	
	    _setActiveTab: function($tab, forceSearch){
	        var that = this;
	
	        var is_new_tab = $tab.is(':not(.active)');
	
	        if (is_new_tab) {
	            that._searchTabs.find('li.active').removeClass('active');
	            $tab.addClass('active');
	
	            that.activeTab = $tab.data('tab');
	        }
	
	        if (forceSearch) {
	            that._searchInput.select();
	
	            if (is_new_tab) {
	                that._search();
	            }
	        }
	    },
	
	    _expand: function(select){
	        var that = this;
	        that.container.addClass("active");
	        if (select)
	            that._searchInput.select();
	    },
	
	    _initHandlers: function(){
	        var that = this;
	        var curElem, nextElem, prevElem;
	
	        that._searchTabs.on('click', 'li:not(.active)', function(){
	            that._setActiveTab($(this), true);
	        });
	
	        that._searchResults.on("click", "._search_result_item", function(){
	            var $this = $(this);
	            that.container.removeClass("active");
	
	            //
	            that.fire('searchResultItemClick');
	
	            switch ($this.data('type')){
	                case 'address':
	                case 'addressYandex':
	                    that._displayGeometry($this);
	                    break;
	                case 'layer':
	                case 'object':
	                    var id = $this.data('id');
	                    if (!that.searchResults.hasOwnProperty(id))
	                        return;
	
	                    var obj = that.searchResults[id];
	                    that.fire('searchItemClick', { object: obj });
	                    break;
	                case 'public-cadastre':
	                    that.fire('cadastreSearchItemClick', {
	                        id: $this.data('ccid'),
	                        center: $this.data('center'),
	                        extent: $this.data('extent')
	                    });
	                    break;
	                default:
	                    return;
	            }
	        });
	
	        that._searchResults.on("mouseenter", "._search_result_item", function(){
	            that._searchResultsItems.removeClass("active");
	            $(this).addClass("active");
	        });
	
	        that._searchInput.on("keydown", function(event){
	            if (event.keyCode == 13) {
	                if (that._searchInput.val() != "" && (that.madeRequestWith == that._searchInput.val())) {
	                    if (that._searchResults.find(".active").length) {
	                        that._searchResults.find(".active").trigger("click");
	                        that._searchInput.blur();
	                    } else /* if (that.madeRequestWith != that._searchInput.val())*/ {
	                        that._search();
	                    }
	                } else {
	                    that._search();
	                }
	                // Т.к. используется form для бага хрома версии 66.0.3359.139, необходимо вернуть false, чтобы страница не перезагрузилась
	                return false;
	            } else if (event.keyCode == 38) {
	                // up
	                event.preventDefault();
	                curElem = that._searchResults.find(".active");
	
	                if (!curElem.length) {
	                    curElem = that._searchResultsItems.first();
	                }
	
	                prevElem = curElem.prev();
	
	                if (!prevElem.length) {
	                    prevElem = that._searchResultsItems.last();
	                }
	
	                curElem.removeClass("active");
	                prevElem.addClass("active");
	            } else if (event.keyCode == 40) {
	                // down
	                event.preventDefault();
	                curElem = that._searchResults.find(".active");
	
	                if (!curElem.length) {
	                    curElem = that._searchResultsItems.last();
	                }
	
	                nextElem = curElem.next();
	
	                if (!nextElem.length) {
	                    nextElem = that._searchResultsItems.first();
	                }
	
	                curElem.removeClass("active");
	                nextElem.addClass("active");
	            } else {
	                setInterval(function(){
	                    that._searchButton.toggleClass('clear_search', that._searchInput.val() != '');
	                }, 0);
	            }
	        });
	
	        that._searchInput.on("keyup", function(){
	            if ($(this).val().length == 0) {
	                //очищаем маркеры и результаты поиска
	                that.layer.setSource();
	                that._searchResults.empty();
	                // that.container.removeClass("active");
	
	                if (that.activeTab == 'objects'){
	                    that._handleSearchDescription();
	                }
	            }
	        });
	
	        that._searchInput.focusin(function(){
	            $(this).select();
	            // that._searchResultsItems.addClass("active");
	            that._searchInputWrapper.addClass("input-focused");
	
	            if ($(this).val().length == 0) {
	                if (that.activeTab == 'objects'){
	                    that._handleSearchDescription();
	                }
	            }
	        });
	
	        that._searchInput.blur(function(){
	            that._searchInputWrapper.removeClass("input-focused");
	        });
	
	        that._searchButton.on("click", function(){
	            if($(this).hasClass('clear_search')){
	                that._searchInput.val('').focus();
	                that._search();
	
	                //очищаем маркеры и результаты поиска
	                that.layer.setSource();
	                that._searchResults.empty();
	                // that.container.removeClass("active");
	
	                if (that.activeTab == 'objects'){
	                    that._handleSearchDescription();
	                }
	            }
	            else {
	                if (that._searchInput.val() != "") {
	                    that._search();
	                    that._searchInput.focus();
	                }
	            }
	        });
	
	        that.container.on("click", function(e){
	            if ($(e.target).hasClass("clearfix")) {
	                that._searchInput.focus();
	            }
	        });
	
	        that.container.focusin(function(){
	            that._expand();
	            // that.container.addClass("active");
	            // if (that._searchInput.val() != "" && !that._searchResults.is(":empty")) {
	            //     that.container.addClass("active");
	            // }
	        });
	
	        that._searchInputWrapper.on('click', function(){
	            that._searchInput.select();
	        });
	
	        that.container.focusout(function(){
	            that._searchResultsItems.removeClass("active");
	            that.container.removeClass("active");
	        });
	
	    },
	
	    /**
	     * Парсит переданную строку search_string и возвращает координаты в виде
	     * массива или null
	     * @param {string} search_string
	     * @returns {[number, number]|null}
	     */
	    _parseCoordinates: function(search_string) {
	        var reg = /^\s*(-?\d{1,3}[.,]\d+)\s*[,;]?\s*(-?\d{1,3}[.,]\d+)\s*$/;
	        var parse_results = reg.exec(search_string);
	        if (parse_results !== null) {
	            var coord1 = parseFloat(parse_results[1].replace(',', '.'));
	            var coord2 = parseFloat(parse_results[2].replace(',', '.'));
	
	            if (!_.isNaN(coord1) && !_.isNaN(coord2)) {
	                return [coord1, coord2];
	            }
	        } else {
	            return null;
	        }
	    },
	
	    _search: function(){
	        var that = this,
	            query = that._searchInput.val().trim(),
	            position;
	
	        that._searchCancelPrevious();
	        that._searchResults.empty();
	
	        if (query.length == 0) {
	            if (that.activeTab == 'objects'){
	                that._handleSearchDescription();
	            }
	            else {
	                that._searchResults.empty();
	            }
	            return;
	        }
	
	        // Кадастровые номера не дадим проверять парсеру координат
	        var cadastreRe = /^(\s)*(\d{2})(:\d{2})?(:\d{1,7})?(:\d{1,})?(\s)*$/;
	        if (cadastreRe.test(query)){
	            // Не будем проверять на координату
	        }
	        else {
	            if (that.activeTab !== 'cadastre') {
	                // Проверим, а не координата ли это
	                try{
	                    position = that._parseCoordinates(query);
	                    if (position) {
	                        that._displayEnteredPoint(
	                            ol.proj.transform([position[1], position[0]], "EPSG:4326", "EPSG:3857")
	                        );
	                        return;
	                    }
	                } catch(error){
	                }
	            }
	        }
	
	        // Определим режим
	        switch (that.activeTab){
	            case 'objects':
	                // Ищем объекты или слои, в зависимости от настроек
	                that._searchObjects(query);
	                break;
	            case 'address':
	                // Ищем через Яндекс
	                if (that.searchSettings.searchYandexApi) {
	                    that._searchAddressYandex(query);
	                }
	                // Ищем через наш геосервис
	                else {
	                    that._searchAddress(query);
	                }
	                break;
	            case 'cadastre':
	                that._searchCadastre(query);
	                break;
	            default:
	                return;
	        }
	    },
	
	    _searchObjects: function(query){
	        var that = this,
	            data = {
	                'phrase': query,
	                'limit': that.searchSettings.searchLimit ? parseInt(that.searchSettings.searchLimit) : 5
	            };
	
	        if (that.view._project.token){
	            data['token'] = that.view._project.token;
	        }
	        if (that.view._project.lng){
	            // для поискового запроса именно lang, а не lng
	            data['lang'] = that.view._project.lng;
	        }
	
	        that._loadingXhr = $.ajax({
	            url: that.searchObjectsUrl,
	            method: 'GET',
	            data: data,
	            beforeSend: function(){
	                that._searchBeforeSend();
	            }
	        }).done(function(response){
	            that.searchResults = response;
	            if (that.options.strictSearch) {
	                that.searchResults = that.strictFilter(that.searchResults, query);
	            }
	
	            that._renderObjectsResults(that.searchResults, query);
	        }).fail(function(response){
	            // сервер упал
	            that._handleServerInternalError();
	            // that.container.addClass("active");
	            that.madeRequestWith = false;
	        }).always(function(){
	            that._searchAfterSend();
	        });
	    },
	
	    _searchAddress: function(query){
	        var that = this;
	
	        that._loadingXhr = $.ajax({
	            url: that.searchAddressUrl,
	            method: "GET",
	            data: {
	                query: query,
	                returnGeom: 1,
	                limit: that.searchSettings.searchLimit ? parseInt(that.searchSettings.searchLimit) : 5
	            },
	            beforeSend: function(){
	                that._searchBeforeSend();
	            }
	        }).done(function(response){
	            that.searchResults = response.results;
	            that._renderAddressResults(that.searchResults);
	        }).fail(function(response){
	            switch (response.status) {
	                case 404:
	                    // сервер ничего не нашел
	                    that._handleEmptyAnswer();
	                    break;
	                case 500:
	                    // сервер упал
	                    that._handleServerInternalError();
	                    break;
	            }
	            that.madeRequestWith = false;
	        }).always(function(){
	            that._searchAfterSend();
	        });
	    },
	
	    _searchAddressYandex: function(query) {
	        var that = this;
	        var ss = that.searchSettings;
	
	        var yandex_limit = { bbox: "", rspn: 0 };
	
	        if (
	            ss.searchYandexLowerLeftCorner
	            && ss.searchYandexUpperRightCorner
	        ) {
	            yandex_limit.bbox = ss.searchYandexLowerLeftCorner + "~" + ss.searchYandexUpperRightCorner;
	            // yandex_limit.rspn = 1;
	        } else {
	            yandex_limit = {};
	        }
	
	        that._loadingXhr = $.ajax({
	            type: 'GET',
	            url: "https://geocode-maps.yandex.ru/1.x/",
	            data: $.extend({}, {
	                'geocode': query,
	                'format': 'json',
	                'results': that.searchSettings.searchLimit ? parseInt(that.searchSettings.searchLimit) : 5
	            }, yandex_limit),
	            beforeSend: function () {
	                that._searchBeforeSend();
	            }
	        }).done(function (response) {
	            that.searchResults = response['response']['GeoObjectCollection']['featureMember'];
	            that._renderAddressYandexResults(that.searchResults);
	        }).fail(function (response) {
	            switch (response.status) {
	                case 404:
	                    // сервер ничего не нашел
	                    that._handleEmptyAnswer();
	                    break;
	                case 500:
	                    // сервер упал
	                    that._handleServerInternalError();
	                    break;
	            }
	            that.madeRequestWith = false;
	        }).always(function () {
	            that._searchAfterSend();
	        });
	    },
	
	    _searchCadastre: function(query) {
	        var that = this;
	
	        query = query.replace(/:+$/gi, '');
	
	        var layers = [
	            {id: 1, title: 'Участок',   reg: /^\d\d:\d+:\d+:\d+$/},
	            {id: 2, title: 'Квартал',   reg: /^\d\d:\d+:\d+$/},
	            {id: 3, title: 'Район',     reg: /^\d\d:\d+$/},
	            {id: 4, title: 'Округ',     reg: /^\d\d$/},
	            {id: 5, title: 'ОКС',       reg: /^\d\d:\d+:\d+:\d+:\d+$/},
	            // {id: 6, title: 'ОКС',       reg: /.*/},
	        ];
	
	        // var requests = [];
	        for (var i = 0; i < layers.length; i++) {
	            var layer = layers[i];
	            if (query.search(layer.reg) !== -1) {
	                that._loadingXhr = $.ajax({
	                    method: 'GET',
	                    url: 'https://pkk5.rosreestr.ru/api/features/'+
	                            layer.id +'?text='+ query +'&limit=1'
	                });
	                break;
	            }
	        }
	
	        // that._loadingXhr = [].concat(requests);
	
	        if (that._loadingXhr) {
	            that._loadingXhr.then(function(response){
	                // var args = [].slice.call(arguments);
	
	                // var features = [];
	                // if (requests.length === 1) {
	                    // var response = args[0];
	                    // features = features.concat(response.features);
	                // } else {
	                    // for (var i = 0; i < args.length; i++) {
	                        // var response = args[i];
	                        // features = features.concat(response.features);
	                    // }
	                // }
	
	                var $html = that._renderCadastreResults(response.features);
	                that._searchResults.html($html);
	            });
	        } else {
	            var $html = that._renderCadastreResults([]);
	            that._searchResults.html($html);
	        }
	    },
	
	    _renderCadastreResults: function(features) {
	        var that = this;
	        var $html = $("<ul role='results_container'></ul>");
	
	        var $results = $(cadastre_search_item({
	            features: features,
	            empty_message: that.translate('По вашему запросу ничего не найдено')
	        }));
	        $html.html($results);
	
	        return $html;
	    },
	
	    _searchBeforeSend: function(){
	        var that = this;
	
	        that._searchLoader.addClass('loading');
	        that.madeRequestWith = that._searchInput.val();
	        that.searchResults.length = 0;
	    },
	
	    _searchAfterSend: function(){
	        var that = this;
	
	        that._loadingXhr = false;
	        that._searchLoader.removeClass("loading");
	    },
	
	    _searchCancelPrevious: function(){
	        var that = this;
	
	        if (that._loadingXhr){
	            that._loadingXhr.abort();
	            that._loadingXhr = false;
	        }
	    },
	
	    returnPathFromApiUrl: function(url){
	        return url.replace(/(\/\/[a-zA-Z.]*)/, "");
	    },
	
	    strictFilter: function(results, query) {
	        var newRes;
	        var queryArr = query.trim().split(' ');
	        var currValue = '';
	        var match;
	        var i;
	
	        newRes = results.filter(function(res){
	            match = true;
	            currValue = ' ' + res.value.trim().toLowerCase() + ' ';
	            currValue = currValue.replace('(', ' ');
	            for(i in queryArr) {
	                match &= !!~currValue.indexOf(' ' + queryArr[i].toLowerCase() + ' ');
	            }
	
	            return match;
	        });
	
	        return newRes;
	    },
	
	    _renderObjectsResults: function(results, query){
	        var that = this,
	            $html,
	            obj,
	            fake_obj,
	            icon;
	
	        // if (that.options.strictSearch) {
	         //    results = that.strictFilter(results, query);
	        // }
	
	        var baseUrl = that.view.getProject()._getApiLocation().host;
	
	        if (results.length) {
	            $html = $("<ul role='results_container'></ul>");
	            for (var i = 0; i < results.length; i++) {
	                obj = results[i];
	
	                if ((this.options.showIcons == undefined) || this.options.showIcons) {
	                    icon = '//' + baseUrl + obj['layer_icon'];
	                } else {
	                    icon = undefined;
	                }
	
	                switch(obj['type']){
	                    case 'layer':
	                        fake_obj = {
	                            id: i,
	                            type: obj['type'],
	                            name: obj['name'] ? obj['name'] : obj['code'],
	                            desc: that.translate('Слой карты'),
	                            icon: '//' + baseUrl + obj['icon'],
	                            hideParents: false
	                        };
	                        break;
	                    case 'object':
	                        fake_obj = {
	                            id: i,
	                            type: obj['type'],
	                            name: obj['name'],
	                            desc: obj['layer_name'] ? obj['layer_name'] : obj['layer'],
	                            icon: icon,
	                            hideParents: this.options.hideParents || false
	                        };
	                        break;
	                    default:
	                        continue;
	                }
	                $html.append($(search_item(fake_obj)))
	            }
	
	            that._updateResultsMaxHeight();
	
	            that._searchResults.html($html);
	            that._searchResultsItems = $html.find("li[role='search_result_item']");
	        } else {
	            that._handleEmptyAnswer();
	        }
	
	        that._expand();
	    },
	
	    _renderAddressResults: function(results){
	        var that = this,
	            $html,
	            obj;
	
	        if (results.length) {
	            $html = $("<ul role='results_container'></ul>");
	            for (var i = 0; i < results.length; i++) {
	                obj = results[i];
	
	                $html.append($(search_item({
	                    id: i,
	                    type: 'address',
	                    name: (obj["name"]||obj["address"]||obj["id"]),
	                    parents: obj.parents,
	                    hideParents: false
	                })))
	            }
	
	            that._updateResultsMaxHeight();
	
	            that._searchResults.html($html);
	            that._searchResultsItems = $html.find("li[role='search_result_item']");
	        } else {
	            that._handleEmptyAnswer();
	        }
	
	        that._expand();
	    },
	
	    _renderAddressYandexResults: function(results){
	        var that = this,
	            $html,
	            obj;
	
	        if (results.length) {
	            $html = $("<ul role='results_container'></ul>");
	            for (var i = 0; i < results.length; i++) {
	                obj = results[i]['GeoObject'];
	
	                $html.append($(search_item({
	                    id: i,
	                    type: 'addressYandex',
	                    name: obj["name"],
	                    desc: obj["description"],
	                    hideParents: false
	                })))
	            }
	
	            that._updateResultsMaxHeight();
	
	            that._searchResults.html($html);
	            that._searchResultsItems = $html.find("li[role='search_result_item']");
	        } else {
	            that._handleEmptyAnswer();
	        }
	
	        that._expand();
	    },
	
	    _updateResultsMaxHeight: function() {
	        var that = this;
	        that._searchResults.css('max-height', $(window).height() - that._searchResults.offset().top);
	    },
	
	    _handleEmptyAnswer: function () {
	        var that = this;
	        that._searchResults.html($("<div class='info-results'>"
	            + that.translate('По вашему запросу ничего не найдено')
	            + "</div>"));
	        // that._expand(true);
	    },
	
	    _handleServerInternalError: function(){
	        var that = this;
	        that._searchResults.html($("<div class='info-results'>"
	            + that.translate('Произошла ошибка на стороне сервера')
	            + "</div>"));
	        // that._expand(true);
	    },
	
	    _handleSearchDescription: function(){
	        var that = this;
	        if (that.searchSettings.description && that.searchSettings.description != '') {
	            that._searchResults.html($("<div class='info-results'></div>").text(that.searchSettings.description));
	            // that._expand(true);
	        }
	    },
	
	    _displayEnteredPoint: function(point){
	        var that = this,
	            geom,
	            feature;
	
	        geom = new ol.geom.Point(point);
	
	        feature = new ol.Feature({
	            geometry: geom
	        });
	
	        that.map.getView().fit(geom, {
	            maxZoom: 15
	        });
	
	        feature.setStyle(new ol.style.Style({
	            image: that.marker
	        }));
	
	        that.layer.setSource();
	        that.layer.setSource( new ol.source.Vector({features: [feature]}) );
	    },
	
	    _displayGeometry: function($elem){
	        var that = this,
	            elemID = $elem.data('id'),
	            obj, point, geom, feature;
	
	        if (!that.searchResults[elemID])
	            return;
	
	        switch ($elem.data('type')){
	            case 'address':
	                obj = that.searchResults[elemID];
	                point = obj.geom;
	
	                // geomType = that.searchResults[elemID].bbox.type;
	                geom = new ol.geom.Point(
	                    ol.proj.transform(point, "EPSG:4326", "EPSG:3857")
	                );
	
	                that.map.getView().fit(geom, {
	                    maxZoom: obj.zoom || 10
	                });
	
	                break;
	            case 'addressYandex':
	                obj = that.searchResults[elemID]['GeoObject'];
	
	                var pos = obj['Point']['pos'].split(' ');
	                pos = ol.proj.transform([+pos[0], +pos[1]], 'EPSG:4326', 'EPSG:3857');
	
	                var lower = obj['boundedBy']['Envelope']['lowerCorner'].split(' ');
	                lower = ol.proj.transform([+lower[0], +lower[1]], 'EPSG:4326', 'EPSG:3857');
	
	                var upper = obj['boundedBy']['Envelope']['upperCorner'].split(' ');
	                upper = ol.proj.transform([+upper[0], +upper[1]], 'EPSG:4326', 'EPSG:3857');
	
	                var extent = lower.concat(upper);
	
	                var view = that.map.getView();
	                view.setCenter(pos);
	                view.fit(extent);
	
	                geom = new ol.geom.Point(pos);
	                break;
	            default:
	                return;
	        }
	
	        feature = new ol.Feature({
	            geometry: geom
	        });
	
	        feature.setStyle(new ol.style.Style({
	            image: that.marker
	        }));
	
	        that.layer.setSource();
	        that.layer.setSource( new ol.source.Vector({features: [feature]}) );
	    },
	
	    _geojsonToFeature: function(geojson){
	        var formatGeoJSON = new omjs.ol.format.GeoJSON();
	
	        return  formatGeoJSON.readFeatures(geojson, {
	            dataProjection: new omjs.ol.proj.Projection({code: "EPSG:3857"})
	        });
	    },
	
	    _makeGeoJSONFromGeom: function(geom){
	        var geoJSON = {};
	        var geomCoordinates;
	        var geomType = (geom.type.indexOf("Multi")!= -1)?
	            geom.type.substring(5, geom.type.length):geom.type;
	
	        geomCoordinates = omjs.ol.proj.transform(geom.coordinates, "EPSG:4326", "EPSG:3857");
	
	        if (geomCoordinates.length > 1 && geom.type.indexOf("Multi")!= -1) {
	            geoJSON =  {
	                "type": "FeatureCollection",
	                "features": []
	            };
	
	            for (var i = 0; i<geomCoordinates.length; i++) {
	                geoJSON.features.push({
	                    "type": "Feature",
	                    "geometry": {
	                        "type": geomType,
	                        "coordinates": geomCoordinates[i]
	                    },
	                    "properties": null
	                })
	            }
	
	        } else {
	            geoJSON = {
	                "type": "Feature",
	                "geometry": {
	                    type: geom.type,
	                    coordinates: geomCoordinates
	                },
	                "properties": {}
	            };
	        }
	
	        return geoJSON;
	    }
	
	});
	
	module.exports = SearchBarExt;


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// omjs.js